var Brief = (function () {
	'use strict';

	var commonjsGlobal = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

	function commonjsRequire () {
		throw new Error('Dynamic requires are not currently supported by rollup-plugin-commonjs');
	}

	function unwrapExports (x) {
		return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
	}

	function createCommonjsModule(fn, module) {
		return module = { exports: {} }, fn(module, module.exports), module.exports;
	}

	var lodash = createCommonjsModule(function (module, exports) {
	(function() {

	  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
	  var undefined;

	  /** Used as the semantic version number. */
	  var VERSION = '4.17.21';

	  /** Used as the size to enable large array optimizations. */
	  var LARGE_ARRAY_SIZE = 200;

	  /** Error message constants. */
	  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
	      FUNC_ERROR_TEXT = 'Expected a function',
	      INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';

	  /** Used to stand-in for `undefined` hash values. */
	  var HASH_UNDEFINED = '__lodash_hash_undefined__';

	  /** Used as the maximum memoize cache size. */
	  var MAX_MEMOIZE_SIZE = 500;

	  /** Used as the internal argument placeholder. */
	  var PLACEHOLDER = '__lodash_placeholder__';

	  /** Used to compose bitmasks for cloning. */
	  var CLONE_DEEP_FLAG = 1,
	      CLONE_FLAT_FLAG = 2,
	      CLONE_SYMBOLS_FLAG = 4;

	  /** Used to compose bitmasks for value comparisons. */
	  var COMPARE_PARTIAL_FLAG = 1,
	      COMPARE_UNORDERED_FLAG = 2;

	  /** Used to compose bitmasks for function metadata. */
	  var WRAP_BIND_FLAG = 1,
	      WRAP_BIND_KEY_FLAG = 2,
	      WRAP_CURRY_BOUND_FLAG = 4,
	      WRAP_CURRY_FLAG = 8,
	      WRAP_CURRY_RIGHT_FLAG = 16,
	      WRAP_PARTIAL_FLAG = 32,
	      WRAP_PARTIAL_RIGHT_FLAG = 64,
	      WRAP_ARY_FLAG = 128,
	      WRAP_REARG_FLAG = 256,
	      WRAP_FLIP_FLAG = 512;

	  /** Used as default options for `_.truncate`. */
	  var DEFAULT_TRUNC_LENGTH = 30,
	      DEFAULT_TRUNC_OMISSION = '...';

	  /** Used to detect hot functions by number of calls within a span of milliseconds. */
	  var HOT_COUNT = 800,
	      HOT_SPAN = 16;

	  /** Used to indicate the type of lazy iteratees. */
	  var LAZY_FILTER_FLAG = 1,
	      LAZY_MAP_FLAG = 2,
	      LAZY_WHILE_FLAG = 3;

	  /** Used as references for various `Number` constants. */
	  var INFINITY = 1 / 0,
	      MAX_SAFE_INTEGER = 9007199254740991,
	      MAX_INTEGER = 1.7976931348623157e+308,
	      NAN = 0 / 0;

	  /** Used as references for the maximum length and index of an array. */
	  var MAX_ARRAY_LENGTH = 4294967295,
	      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
	      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

	  /** Used to associate wrap methods with their bit flags. */
	  var wrapFlags = [
	    ['ary', WRAP_ARY_FLAG],
	    ['bind', WRAP_BIND_FLAG],
	    ['bindKey', WRAP_BIND_KEY_FLAG],
	    ['curry', WRAP_CURRY_FLAG],
	    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
	    ['flip', WRAP_FLIP_FLAG],
	    ['partial', WRAP_PARTIAL_FLAG],
	    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
	    ['rearg', WRAP_REARG_FLAG]
	  ];

	  /** `Object#toString` result references. */
	  var argsTag = '[object Arguments]',
	      arrayTag = '[object Array]',
	      asyncTag = '[object AsyncFunction]',
	      boolTag = '[object Boolean]',
	      dateTag = '[object Date]',
	      domExcTag = '[object DOMException]',
	      errorTag = '[object Error]',
	      funcTag = '[object Function]',
	      genTag = '[object GeneratorFunction]',
	      mapTag = '[object Map]',
	      numberTag = '[object Number]',
	      nullTag = '[object Null]',
	      objectTag = '[object Object]',
	      promiseTag = '[object Promise]',
	      proxyTag = '[object Proxy]',
	      regexpTag = '[object RegExp]',
	      setTag = '[object Set]',
	      stringTag = '[object String]',
	      symbolTag = '[object Symbol]',
	      undefinedTag = '[object Undefined]',
	      weakMapTag = '[object WeakMap]',
	      weakSetTag = '[object WeakSet]';

	  var arrayBufferTag = '[object ArrayBuffer]',
	      dataViewTag = '[object DataView]',
	      float32Tag = '[object Float32Array]',
	      float64Tag = '[object Float64Array]',
	      int8Tag = '[object Int8Array]',
	      int16Tag = '[object Int16Array]',
	      int32Tag = '[object Int32Array]',
	      uint8Tag = '[object Uint8Array]',
	      uint8ClampedTag = '[object Uint8ClampedArray]',
	      uint16Tag = '[object Uint16Array]',
	      uint32Tag = '[object Uint32Array]';

	  /** Used to match empty string literals in compiled template source. */
	  var reEmptyStringLeading = /\b__p \+= '';/g,
	      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
	      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

	  /** Used to match HTML entities and HTML characters. */
	  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
	      reUnescapedHtml = /[&<>"']/g,
	      reHasEscapedHtml = RegExp(reEscapedHtml.source),
	      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

	  /** Used to match template delimiters. */
	  var reEscape = /<%-([\s\S]+?)%>/g,
	      reEvaluate = /<%([\s\S]+?)%>/g,
	      reInterpolate = /<%=([\s\S]+?)%>/g;

	  /** Used to match property names within property paths. */
	  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	      reIsPlainProp = /^\w*$/,
	      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

	  /**
	   * Used to match `RegExp`
	   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	   */
	  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
	      reHasRegExpChar = RegExp(reRegExpChar.source);

	  /** Used to match leading whitespace. */
	  var reTrimStart = /^\s+/;

	  /** Used to match a single whitespace character. */
	  var reWhitespace = /\s/;

	  /** Used to match wrap detail comments. */
	  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
	      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
	      reSplitDetails = /,? & /;

	  /** Used to match words composed of alphanumeric characters. */
	  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

	  /**
	   * Used to validate the `validate` option in `_.template` variable.
	   *
	   * Forbids characters which could potentially change the meaning of the function argument definition:
	   * - "()," (modification of function parameters)
	   * - "=" (default value)
	   * - "[]{}" (destructuring of function parameters)
	   * - "/" (beginning of a comment)
	   * - whitespace
	   */
	  var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;

	  /** Used to match backslashes in property paths. */
	  var reEscapeChar = /\\(\\)?/g;

	  /**
	   * Used to match
	   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
	   */
	  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

	  /** Used to match `RegExp` flags from their coerced string values. */
	  var reFlags = /\w*$/;

	  /** Used to detect bad signed hexadecimal string values. */
	  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

	  /** Used to detect binary string values. */
	  var reIsBinary = /^0b[01]+$/i;

	  /** Used to detect host constructors (Safari). */
	  var reIsHostCtor = /^\[object .+?Constructor\]$/;

	  /** Used to detect octal string values. */
	  var reIsOctal = /^0o[0-7]+$/i;

	  /** Used to detect unsigned integer values. */
	  var reIsUint = /^(?:0|[1-9]\d*)$/;

	  /** Used to match Latin Unicode letters (excluding mathematical operators). */
	  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

	  /** Used to ensure capturing order of template delimiters. */
	  var reNoMatch = /($^)/;

	  /** Used to match unescaped characters in compiled string literals. */
	  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

	  /** Used to compose unicode character classes. */
	  var rsAstralRange = '\\ud800-\\udfff',
	      rsComboMarksRange = '\\u0300-\\u036f',
	      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	      rsComboSymbolsRange = '\\u20d0-\\u20ff',
	      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	      rsDingbatRange = '\\u2700-\\u27bf',
	      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
	      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
	      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
	      rsPunctuationRange = '\\u2000-\\u206f',
	      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
	      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
	      rsVarRange = '\\ufe0e\\ufe0f',
	      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

	  /** Used to compose unicode capture groups. */
	  var rsApos = "['\u2019]",
	      rsAstral = '[' + rsAstralRange + ']',
	      rsBreak = '[' + rsBreakRange + ']',
	      rsCombo = '[' + rsComboRange + ']',
	      rsDigits = '\\d+',
	      rsDingbat = '[' + rsDingbatRange + ']',
	      rsLower = '[' + rsLowerRange + ']',
	      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
	      rsFitz = '\\ud83c[\\udffb-\\udfff]',
	      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	      rsNonAstral = '[^' + rsAstralRange + ']',
	      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	      rsUpper = '[' + rsUpperRange + ']',
	      rsZWJ = '\\u200d';

	  /** Used to compose unicode regexes. */
	  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
	      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
	      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
	      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
	      reOptMod = rsModifier + '?',
	      rsOptVar = '[' + rsVarRange + ']?',
	      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
	      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
	      rsSeq = rsOptVar + reOptMod + rsOptJoin,
	      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
	      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

	  /** Used to match apostrophes. */
	  var reApos = RegExp(rsApos, 'g');

	  /**
	   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
	   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
	   */
	  var reComboMark = RegExp(rsCombo, 'g');

	  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
	  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

	  /** Used to match complex or compound words. */
	  var reUnicodeWord = RegExp([
	    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
	    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
	    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
	    rsUpper + '+' + rsOptContrUpper,
	    rsOrdUpper,
	    rsOrdLower,
	    rsDigits,
	    rsEmoji
	  ].join('|'), 'g');

	  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
	  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

	  /** Used to detect strings that need a more robust regexp to match words. */
	  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

	  /** Used to assign default `context` object properties. */
	  var contextProps = [
	    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
	    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
	    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
	    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
	    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
	  ];

	  /** Used to make template sourceURLs easier to identify. */
	  var templateCounter = -1;

	  /** Used to identify `toStringTag` values of typed arrays. */
	  var typedArrayTags = {};
	  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	  typedArrayTags[uint32Tag] = true;
	  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	  typedArrayTags[setTag] = typedArrayTags[stringTag] =
	  typedArrayTags[weakMapTag] = false;

	  /** Used to identify `toStringTag` values supported by `_.clone`. */
	  var cloneableTags = {};
	  cloneableTags[argsTag] = cloneableTags[arrayTag] =
	  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	  cloneableTags[boolTag] = cloneableTags[dateTag] =
	  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	  cloneableTags[int32Tag] = cloneableTags[mapTag] =
	  cloneableTags[numberTag] = cloneableTags[objectTag] =
	  cloneableTags[regexpTag] = cloneableTags[setTag] =
	  cloneableTags[stringTag] = cloneableTags[symbolTag] =
	  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	  cloneableTags[errorTag] = cloneableTags[funcTag] =
	  cloneableTags[weakMapTag] = false;

	  /** Used to map Latin Unicode letters to basic Latin letters. */
	  var deburredLetters = {
	    // Latin-1 Supplement block.
	    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
	    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
	    '\xc7': 'C',  '\xe7': 'c',
	    '\xd0': 'D',  '\xf0': 'd',
	    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
	    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
	    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
	    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
	    '\xd1': 'N',  '\xf1': 'n',
	    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
	    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
	    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
	    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
	    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
	    '\xc6': 'Ae', '\xe6': 'ae',
	    '\xde': 'Th', '\xfe': 'th',
	    '\xdf': 'ss',
	    // Latin Extended-A block.
	    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
	    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
	    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
	    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
	    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
	    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
	    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
	    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
	    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
	    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
	    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
	    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
	    '\u0134': 'J',  '\u0135': 'j',
	    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
	    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
	    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
	    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
	    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
	    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
	    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
	    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
	    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
	    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
	    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
	    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
	    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
	    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
	    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
	    '\u0174': 'W',  '\u0175': 'w',
	    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
	    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
	    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
	    '\u0132': 'IJ', '\u0133': 'ij',
	    '\u0152': 'Oe', '\u0153': 'oe',
	    '\u0149': "'n", '\u017f': 's'
	  };

	  /** Used to map characters to HTML entities. */
	  var htmlEscapes = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#39;'
	  };

	  /** Used to map HTML entities to characters. */
	  var htmlUnescapes = {
	    '&amp;': '&',
	    '&lt;': '<',
	    '&gt;': '>',
	    '&quot;': '"',
	    '&#39;': "'"
	  };

	  /** Used to escape characters for inclusion in compiled string literals. */
	  var stringEscapes = {
	    '\\': '\\',
	    "'": "'",
	    '\n': 'n',
	    '\r': 'r',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };

	  /** Built-in method references without a dependency on `root`. */
	  var freeParseFloat = parseFloat,
	      freeParseInt = parseInt;

	  /** Detect free variable `global` from Node.js. */
	  var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

	  /** Detect free variable `self`. */
	  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

	  /** Used as a reference to the global object. */
	  var root = freeGlobal || freeSelf || Function('return this')();

	  /** Detect free variable `exports`. */
	  var freeExports = exports && !exports.nodeType && exports;

	  /** Detect free variable `module`. */
	  var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

	  /** Detect the popular CommonJS extension `module.exports`. */
	  var moduleExports = freeModule && freeModule.exports === freeExports;

	  /** Detect free variable `process` from Node.js. */
	  var freeProcess = moduleExports && freeGlobal.process;

	  /** Used to access faster Node.js helpers. */
	  var nodeUtil = (function() {
	    try {
	      // Use `util.types` for Node.js 10+.
	      var types = freeModule && freeModule.require && freeModule.require('util').types;

	      if (types) {
	        return types;
	      }

	      // Legacy `process.binding('util')` for Node.js < 10.
	      return freeProcess && freeProcess.binding && freeProcess.binding('util');
	    } catch (e) {}
	  }());

	  /* Node.js helper references. */
	  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
	      nodeIsDate = nodeUtil && nodeUtil.isDate,
	      nodeIsMap = nodeUtil && nodeUtil.isMap,
	      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
	      nodeIsSet = nodeUtil && nodeUtil.isSet,
	      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

	  /*--------------------------------------------------------------------------*/

	  /**
	   * A faster alternative to `Function#apply`, this function invokes `func`
	   * with the `this` binding of `thisArg` and the arguments of `args`.
	   *
	   * @private
	   * @param {Function} func The function to invoke.
	   * @param {*} thisArg The `this` binding of `func`.
	   * @param {Array} args The arguments to invoke `func` with.
	   * @returns {*} Returns the result of `func`.
	   */
	  function apply(func, thisArg, args) {
	    switch (args.length) {
	      case 0: return func.call(thisArg);
	      case 1: return func.call(thisArg, args[0]);
	      case 2: return func.call(thisArg, args[0], args[1]);
	      case 3: return func.call(thisArg, args[0], args[1], args[2]);
	    }
	    return func.apply(thisArg, args);
	  }

	  /**
	   * A specialized version of `baseAggregator` for arrays.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} setter The function to set `accumulator` values.
	   * @param {Function} iteratee The iteratee to transform keys.
	   * @param {Object} accumulator The initial aggregated object.
	   * @returns {Function} Returns `accumulator`.
	   */
	  function arrayAggregator(array, setter, iteratee, accumulator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;

	    while (++index < length) {
	      var value = array[index];
	      setter(accumulator, value, iteratee(value), array);
	    }
	    return accumulator;
	  }

	  /**
	   * A specialized version of `_.forEach` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEach(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length;

	    while (++index < length) {
	      if (iteratee(array[index], index, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }

	  /**
	   * A specialized version of `_.forEachRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEachRight(array, iteratee) {
	    var length = array == null ? 0 : array.length;

	    while (length--) {
	      if (iteratee(array[length], length, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }

	  /**
	   * A specialized version of `_.every` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if all elements pass the predicate check,
	   *  else `false`.
	   */
	  function arrayEvery(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;

	    while (++index < length) {
	      if (!predicate(array[index], index, array)) {
	        return false;
	      }
	    }
	    return true;
	  }

	  /**
	   * A specialized version of `_.filter` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {Array} Returns the new filtered array.
	   */
	  function arrayFilter(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        resIndex = 0,
	        result = [];

	    while (++index < length) {
	      var value = array[index];
	      if (predicate(value, index, array)) {
	        result[resIndex++] = value;
	      }
	    }
	    return result;
	  }

	  /**
	   * A specialized version of `_.includes` for arrays without support for
	   * specifying an index to search from.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludes(array, value) {
	    var length = array == null ? 0 : array.length;
	    return !!length && baseIndexOf(array, value, 0) > -1;
	  }

	  /**
	   * This function is like `arrayIncludes` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludesWith(array, value, comparator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;

	    while (++index < length) {
	      if (comparator(value, array[index])) {
	        return true;
	      }
	    }
	    return false;
	  }

	  /**
	   * A specialized version of `_.map` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the new mapped array.
	   */
	  function arrayMap(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        result = Array(length);

	    while (++index < length) {
	      result[index] = iteratee(array[index], index, array);
	    }
	    return result;
	  }

	  /**
	   * Appends the elements of `values` to `array`.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {Array} values The values to append.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayPush(array, values) {
	    var index = -1,
	        length = values.length,
	        offset = array.length;

	    while (++index < length) {
	      array[offset + index] = values[index];
	    }
	    return array;
	  }

	  /**
	   * A specialized version of `_.reduce` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the first element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduce(array, iteratee, accumulator, initAccum) {
	    var index = -1,
	        length = array == null ? 0 : array.length;

	    if (initAccum && length) {
	      accumulator = array[++index];
	    }
	    while (++index < length) {
	      accumulator = iteratee(accumulator, array[index], index, array);
	    }
	    return accumulator;
	  }

	  /**
	   * A specialized version of `_.reduceRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the last element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
	    var length = array == null ? 0 : array.length;
	    if (initAccum && length) {
	      accumulator = array[--length];
	    }
	    while (length--) {
	      accumulator = iteratee(accumulator, array[length], length, array);
	    }
	    return accumulator;
	  }

	  /**
	   * A specialized version of `_.some` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if any element passes the predicate check,
	   *  else `false`.
	   */
	  function arraySome(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;

	    while (++index < length) {
	      if (predicate(array[index], index, array)) {
	        return true;
	      }
	    }
	    return false;
	  }

	  /**
	   * Gets the size of an ASCII `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  var asciiSize = baseProperty('length');

	  /**
	   * Converts an ASCII `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function asciiToArray(string) {
	    return string.split('');
	  }

	  /**
	   * Splits an ASCII `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function asciiWords(string) {
	    return string.match(reAsciiWord) || [];
	  }

	  /**
	   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
	   * without support for iteratee shorthands, which iterates over `collection`
	   * using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the found element or its key, else `undefined`.
	   */
	  function baseFindKey(collection, predicate, eachFunc) {
	    var result;
	    eachFunc(collection, function(value, key, collection) {
	      if (predicate(value, key, collection)) {
	        result = key;
	        return false;
	      }
	    });
	    return result;
	  }

	  /**
	   * The base implementation of `_.findIndex` and `_.findLastIndex` without
	   * support for iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {number} fromIndex The index to search from.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseFindIndex(array, predicate, fromIndex, fromRight) {
	    var length = array.length,
	        index = fromIndex + (fromRight ? 1 : -1);

	    while ((fromRight ? index-- : ++index < length)) {
	      if (predicate(array[index], index, array)) {
	        return index;
	      }
	    }
	    return -1;
	  }

	  /**
	   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOf(array, value, fromIndex) {
	    return value === value
	      ? strictIndexOf(array, value, fromIndex)
	      : baseFindIndex(array, baseIsNaN, fromIndex);
	  }

	  /**
	   * This function is like `baseIndexOf` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOfWith(array, value, fromIndex, comparator) {
	    var index = fromIndex - 1,
	        length = array.length;

	    while (++index < length) {
	      if (comparator(array[index], value)) {
	        return index;
	      }
	    }
	    return -1;
	  }

	  /**
	   * The base implementation of `_.isNaN` without support for number objects.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	   */
	  function baseIsNaN(value) {
	    return value !== value;
	  }

	  /**
	   * The base implementation of `_.mean` and `_.meanBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the mean.
	   */
	  function baseMean(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	    return length ? (baseSum(array, iteratee) / length) : NAN;
	  }

	  /**
	   * The base implementation of `_.property` without support for deep paths.
	   *
	   * @private
	   * @param {string} key The key of the property to get.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function baseProperty(key) {
	    return function(object) {
	      return object == null ? undefined : object[key];
	    };
	  }

	  /**
	   * The base implementation of `_.propertyOf` without support for deep paths.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function basePropertyOf(object) {
	    return function(key) {
	      return object == null ? undefined : object[key];
	    };
	  }

	  /**
	   * The base implementation of `_.reduce` and `_.reduceRight`, without support
	   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} accumulator The initial value.
	   * @param {boolean} initAccum Specify using the first or last element of
	   *  `collection` as the initial value.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the accumulated value.
	   */
	  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
	    eachFunc(collection, function(value, index, collection) {
	      accumulator = initAccum
	        ? (initAccum = false, value)
	        : iteratee(accumulator, value, index, collection);
	    });
	    return accumulator;
	  }

	  /**
	   * The base implementation of `_.sortBy` which uses `comparer` to define the
	   * sort order of `array` and replaces criteria objects with their corresponding
	   * values.
	   *
	   * @private
	   * @param {Array} array The array to sort.
	   * @param {Function} comparer The function to define sort order.
	   * @returns {Array} Returns `array`.
	   */
	  function baseSortBy(array, comparer) {
	    var length = array.length;

	    array.sort(comparer);
	    while (length--) {
	      array[length] = array[length].value;
	    }
	    return array;
	  }

	  /**
	   * The base implementation of `_.sum` and `_.sumBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the sum.
	   */
	  function baseSum(array, iteratee) {
	    var result,
	        index = -1,
	        length = array.length;

	    while (++index < length) {
	      var current = iteratee(array[index]);
	      if (current !== undefined) {
	        result = result === undefined ? current : (result + current);
	      }
	    }
	    return result;
	  }

	  /**
	   * The base implementation of `_.times` without support for iteratee shorthands
	   * or max array length checks.
	   *
	   * @private
	   * @param {number} n The number of times to invoke `iteratee`.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the array of results.
	   */
	  function baseTimes(n, iteratee) {
	    var index = -1,
	        result = Array(n);

	    while (++index < n) {
	      result[index] = iteratee(index);
	    }
	    return result;
	  }

	  /**
	   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
	   * of key-value pairs for `object` corresponding to the property names of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the key-value pairs.
	   */
	  function baseToPairs(object, props) {
	    return arrayMap(props, function(key) {
	      return [key, object[key]];
	    });
	  }

	  /**
	   * The base implementation of `_.trim`.
	   *
	   * @private
	   * @param {string} string The string to trim.
	   * @returns {string} Returns the trimmed string.
	   */
	  function baseTrim(string) {
	    return string
	      ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
	      : string;
	  }

	  /**
	   * The base implementation of `_.unary` without support for storing metadata.
	   *
	   * @private
	   * @param {Function} func The function to cap arguments for.
	   * @returns {Function} Returns the new capped function.
	   */
	  function baseUnary(func) {
	    return function(value) {
	      return func(value);
	    };
	  }

	  /**
	   * The base implementation of `_.values` and `_.valuesIn` which creates an
	   * array of `object` property values corresponding to the property names
	   * of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the array of property values.
	   */
	  function baseValues(object, props) {
	    return arrayMap(props, function(key) {
	      return object[key];
	    });
	  }

	  /**
	   * Checks if a `cache` value for `key` exists.
	   *
	   * @private
	   * @param {Object} cache The cache to query.
	   * @param {string} key The key of the entry to check.
	   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	   */
	  function cacheHas(cache, key) {
	    return cache.has(key);
	  }

	  /**
	   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the first unmatched string symbol.
	   */
	  function charsStartIndex(strSymbols, chrSymbols) {
	    var index = -1,
	        length = strSymbols.length;

	    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }

	  /**
	   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the last unmatched string symbol.
	   */
	  function charsEndIndex(strSymbols, chrSymbols) {
	    var index = strSymbols.length;

	    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }

	  /**
	   * Gets the number of `placeholder` occurrences in `array`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} placeholder The placeholder to search for.
	   * @returns {number} Returns the placeholder count.
	   */
	  function countHolders(array, placeholder) {
	    var length = array.length,
	        result = 0;

	    while (length--) {
	      if (array[length] === placeholder) {
	        ++result;
	      }
	    }
	    return result;
	  }

	  /**
	   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
	   * letters to basic Latin letters.
	   *
	   * @private
	   * @param {string} letter The matched letter to deburr.
	   * @returns {string} Returns the deburred letter.
	   */
	  var deburrLetter = basePropertyOf(deburredLetters);

	  /**
	   * Used by `_.escape` to convert characters to HTML entities.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  var escapeHtmlChar = basePropertyOf(htmlEscapes);

	  /**
	   * Used by `_.template` to escape characters for inclusion in compiled string literals.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeStringChar(chr) {
	    return '\\' + stringEscapes[chr];
	  }

	  /**
	   * Gets the value at `key` of `object`.
	   *
	   * @private
	   * @param {Object} [object] The object to query.
	   * @param {string} key The key of the property to get.
	   * @returns {*} Returns the property value.
	   */
	  function getValue(object, key) {
	    return object == null ? undefined : object[key];
	  }

	  /**
	   * Checks if `string` contains Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
	   */
	  function hasUnicode(string) {
	    return reHasUnicode.test(string);
	  }

	  /**
	   * Checks if `string` contains a word composed of Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a word is found, else `false`.
	   */
	  function hasUnicodeWord(string) {
	    return reHasUnicodeWord.test(string);
	  }

	  /**
	   * Converts `iterator` to an array.
	   *
	   * @private
	   * @param {Object} iterator The iterator to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function iteratorToArray(iterator) {
	    var data,
	        result = [];

	    while (!(data = iterator.next()).done) {
	      result.push(data.value);
	    }
	    return result;
	  }

	  /**
	   * Converts `map` to its key-value pairs.
	   *
	   * @private
	   * @param {Object} map The map to convert.
	   * @returns {Array} Returns the key-value pairs.
	   */
	  function mapToArray(map) {
	    var index = -1,
	        result = Array(map.size);

	    map.forEach(function(value, key) {
	      result[++index] = [key, value];
	    });
	    return result;
	  }

	  /**
	   * Creates a unary function that invokes `func` with its argument transformed.
	   *
	   * @private
	   * @param {Function} func The function to wrap.
	   * @param {Function} transform The argument transform.
	   * @returns {Function} Returns the new function.
	   */
	  function overArg(func, transform) {
	    return function(arg) {
	      return func(transform(arg));
	    };
	  }

	  /**
	   * Replaces all `placeholder` elements in `array` with an internal placeholder
	   * and returns an array of their indexes.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {*} placeholder The placeholder to replace.
	   * @returns {Array} Returns the new array of placeholder indexes.
	   */
	  function replaceHolders(array, placeholder) {
	    var index = -1,
	        length = array.length,
	        resIndex = 0,
	        result = [];

	    while (++index < length) {
	      var value = array[index];
	      if (value === placeholder || value === PLACEHOLDER) {
	        array[index] = PLACEHOLDER;
	        result[resIndex++] = index;
	      }
	    }
	    return result;
	  }

	  /**
	   * Converts `set` to an array of its values.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the values.
	   */
	  function setToArray(set) {
	    var index = -1,
	        result = Array(set.size);

	    set.forEach(function(value) {
	      result[++index] = value;
	    });
	    return result;
	  }

	  /**
	   * Converts `set` to its value-value pairs.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the value-value pairs.
	   */
	  function setToPairs(set) {
	    var index = -1,
	        result = Array(set.size);

	    set.forEach(function(value) {
	      result[++index] = [value, value];
	    });
	    return result;
	  }

	  /**
	   * A specialized version of `_.indexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictIndexOf(array, value, fromIndex) {
	    var index = fromIndex - 1,
	        length = array.length;

	    while (++index < length) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return -1;
	  }

	  /**
	   * A specialized version of `_.lastIndexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictLastIndexOf(array, value, fromIndex) {
	    var index = fromIndex + 1;
	    while (index--) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return index;
	  }

	  /**
	   * Gets the number of symbols in `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the string size.
	   */
	  function stringSize(string) {
	    return hasUnicode(string)
	      ? unicodeSize(string)
	      : asciiSize(string);
	  }

	  /**
	   * Converts `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function stringToArray(string) {
	    return hasUnicode(string)
	      ? unicodeToArray(string)
	      : asciiToArray(string);
	  }

	  /**
	   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
	   * character of `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the index of the last non-whitespace character.
	   */
	  function trimmedEndIndex(string) {
	    var index = string.length;

	    while (index-- && reWhitespace.test(string.charAt(index))) {}
	    return index;
	  }

	  /**
	   * Used by `_.unescape` to convert HTML entities to characters.
	   *
	   * @private
	   * @param {string} chr The matched character to unescape.
	   * @returns {string} Returns the unescaped character.
	   */
	  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

	  /**
	   * Gets the size of a Unicode `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  function unicodeSize(string) {
	    var result = reUnicode.lastIndex = 0;
	    while (reUnicode.test(string)) {
	      ++result;
	    }
	    return result;
	  }

	  /**
	   * Converts a Unicode `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function unicodeToArray(string) {
	    return string.match(reUnicode) || [];
	  }

	  /**
	   * Splits a Unicode `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function unicodeWords(string) {
	    return string.match(reUnicodeWord) || [];
	  }

	  /*--------------------------------------------------------------------------*/

	  /**
	   * Create a new pristine `lodash` function using the `context` object.
	   *
	   * @static
	   * @memberOf _
	   * @since 1.1.0
	   * @category Util
	   * @param {Object} [context=root] The context object.
	   * @returns {Function} Returns a new `lodash` function.
	   * @example
	   *
	   * _.mixin({ 'foo': _.constant('foo') });
	   *
	   * var lodash = _.runInContext();
	   * lodash.mixin({ 'bar': lodash.constant('bar') });
	   *
	   * _.isFunction(_.foo);
	   * // => true
	   * _.isFunction(_.bar);
	   * // => false
	   *
	   * lodash.isFunction(lodash.foo);
	   * // => false
	   * lodash.isFunction(lodash.bar);
	   * // => true
	   *
	   * // Create a suped-up `defer` in Node.js.
	   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
	   */
	  var runInContext = (function runInContext(context) {
	    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

	    /** Built-in constructor references. */
	    var Array = context.Array,
	        Date = context.Date,
	        Error = context.Error,
	        Function = context.Function,
	        Math = context.Math,
	        Object = context.Object,
	        RegExp = context.RegExp,
	        String = context.String,
	        TypeError = context.TypeError;

	    /** Used for built-in method references. */
	    var arrayProto = Array.prototype,
	        funcProto = Function.prototype,
	        objectProto = Object.prototype;

	    /** Used to detect overreaching core-js shims. */
	    var coreJsData = context['__core-js_shared__'];

	    /** Used to resolve the decompiled source of functions. */
	    var funcToString = funcProto.toString;

	    /** Used to check objects for own properties. */
	    var hasOwnProperty = objectProto.hasOwnProperty;

	    /** Used to generate unique IDs. */
	    var idCounter = 0;

	    /** Used to detect methods masquerading as native. */
	    var maskSrcKey = (function() {
	      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	      return uid ? ('Symbol(src)_1.' + uid) : '';
	    }());

	    /**
	     * Used to resolve the
	     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	     * of values.
	     */
	    var nativeObjectToString = objectProto.toString;

	    /** Used to infer the `Object` constructor. */
	    var objectCtorString = funcToString.call(Object);

	    /** Used to restore the original `_` reference in `_.noConflict`. */
	    var oldDash = root._;

	    /** Used to detect if a method is native. */
	    var reIsNative = RegExp('^' +
	      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	    );

	    /** Built-in value references. */
	    var Buffer = moduleExports ? context.Buffer : undefined,
	        Symbol = context.Symbol,
	        Uint8Array = context.Uint8Array,
	        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
	        getPrototype = overArg(Object.getPrototypeOf, Object),
	        objectCreate = Object.create,
	        propertyIsEnumerable = objectProto.propertyIsEnumerable,
	        splice = arrayProto.splice,
	        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
	        symIterator = Symbol ? Symbol.iterator : undefined,
	        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

	    var defineProperty = (function() {
	      try {
	        var func = getNative(Object, 'defineProperty');
	        func({}, '', {});
	        return func;
	      } catch (e) {}
	    }());

	    /** Mocked built-ins. */
	    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
	        ctxNow = Date && Date.now !== root.Date.now && Date.now,
	        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

	    /* Built-in method references for those with the same name as other `lodash` methods. */
	    var nativeCeil = Math.ceil,
	        nativeFloor = Math.floor,
	        nativeGetSymbols = Object.getOwnPropertySymbols,
	        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
	        nativeIsFinite = context.isFinite,
	        nativeJoin = arrayProto.join,
	        nativeKeys = overArg(Object.keys, Object),
	        nativeMax = Math.max,
	        nativeMin = Math.min,
	        nativeNow = Date.now,
	        nativeParseInt = context.parseInt,
	        nativeRandom = Math.random,
	        nativeReverse = arrayProto.reverse;

	    /* Built-in method references that are verified to be native. */
	    var DataView = getNative(context, 'DataView'),
	        Map = getNative(context, 'Map'),
	        Promise = getNative(context, 'Promise'),
	        Set = getNative(context, 'Set'),
	        WeakMap = getNative(context, 'WeakMap'),
	        nativeCreate = getNative(Object, 'create');

	    /** Used to store function metadata. */
	    var metaMap = WeakMap && new WeakMap;

	    /** Used to lookup unminified function names. */
	    var realNames = {};

	    /** Used to detect maps, sets, and weakmaps. */
	    var dataViewCtorString = toSource(DataView),
	        mapCtorString = toSource(Map),
	        promiseCtorString = toSource(Promise),
	        setCtorString = toSource(Set),
	        weakMapCtorString = toSource(WeakMap);

	    /** Used to convert symbols to primitives and strings. */
	    var symbolProto = Symbol ? Symbol.prototype : undefined,
	        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
	        symbolToString = symbolProto ? symbolProto.toString : undefined;

	    /*------------------------------------------------------------------------*/

	    /**
	     * Creates a `lodash` object which wraps `value` to enable implicit method
	     * chain sequences. Methods that operate on and return arrays, collections,
	     * and functions can be chained together. Methods that retrieve a single value
	     * or may return a primitive value will automatically end the chain sequence
	     * and return the unwrapped value. Otherwise, the value must be unwrapped
	     * with `_#value`.
	     *
	     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
	     * enabled using `_.chain`.
	     *
	     * The execution of chained methods is lazy, that is, it's deferred until
	     * `_#value` is implicitly or explicitly called.
	     *
	     * Lazy evaluation allows several methods to support shortcut fusion.
	     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
	     * the creation of intermediate arrays and can greatly reduce the number of
	     * iteratee executions. Sections of a chain sequence qualify for shortcut
	     * fusion if the section is applied to an array and iteratees accept only
	     * one argument. The heuristic for whether a section qualifies for shortcut
	     * fusion is subject to change.
	     *
	     * Chaining is supported in custom builds as long as the `_#value` method is
	     * directly or indirectly included in the build.
	     *
	     * In addition to lodash methods, wrappers have `Array` and `String` methods.
	     *
	     * The wrapper `Array` methods are:
	     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
	     *
	     * The wrapper `String` methods are:
	     * `replace` and `split`
	     *
	     * The wrapper methods that support shortcut fusion are:
	     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
	     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
	     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
	     *
	     * The chainable wrapper methods are:
	     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
	     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
	     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
	     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
	     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
	     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
	     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
	     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
	     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
	     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
	     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
	     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
	     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
	     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
	     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
	     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
	     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
	     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
	     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
	     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
	     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
	     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
	     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
	     * `zipObject`, `zipObjectDeep`, and `zipWith`
	     *
	     * The wrapper methods that are **not** chainable by default are:
	     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
	     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
	     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
	     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
	     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
	     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
	     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
	     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
	     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
	     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
	     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
	     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
	     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
	     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
	     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
	     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
	     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
	     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
	     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
	     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
	     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
	     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
	     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
	     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
	     * `upperFirst`, `value`, and `words`
	     *
	     * @name _
	     * @constructor
	     * @category Seq
	     * @param {*} value The value to wrap in a `lodash` instance.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2, 3]);
	     *
	     * // Returns an unwrapped value.
	     * wrapped.reduce(_.add);
	     * // => 6
	     *
	     * // Returns a wrapped value.
	     * var squares = wrapped.map(square);
	     *
	     * _.isArray(squares);
	     * // => false
	     *
	     * _.isArray(squares.value());
	     * // => true
	     */
	    function lodash(value) {
	      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
	        if (value instanceof LodashWrapper) {
	          return value;
	        }
	        if (hasOwnProperty.call(value, '__wrapped__')) {
	          return wrapperClone(value);
	        }
	      }
	      return new LodashWrapper(value);
	    }

	    /**
	     * The base implementation of `_.create` without support for assigning
	     * properties to the created object.
	     *
	     * @private
	     * @param {Object} proto The object to inherit from.
	     * @returns {Object} Returns the new object.
	     */
	    var baseCreate = (function() {
	      function object() {}
	      return function(proto) {
	        if (!isObject(proto)) {
	          return {};
	        }
	        if (objectCreate) {
	          return objectCreate(proto);
	        }
	        object.prototype = proto;
	        var result = new object;
	        object.prototype = undefined;
	        return result;
	      };
	    }());

	    /**
	     * The function whose prototype chain sequence wrappers inherit from.
	     *
	     * @private
	     */
	    function baseLodash() {
	      // No operation performed.
	    }

	    /**
	     * The base constructor for creating `lodash` wrapper objects.
	     *
	     * @private
	     * @param {*} value The value to wrap.
	     * @param {boolean} [chainAll] Enable explicit method chain sequences.
	     */
	    function LodashWrapper(value, chainAll) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__chain__ = !!chainAll;
	      this.__index__ = 0;
	      this.__values__ = undefined;
	    }

	    /**
	     * By default, the template delimiters used by lodash are like those in
	     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
	     * following template settings to use alternative delimiters.
	     *
	     * @static
	     * @memberOf _
	     * @type {Object}
	     */
	    lodash.templateSettings = {

	      /**
	       * Used to detect `data` property values to be HTML-escaped.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'escape': reEscape,

	      /**
	       * Used to detect code to be evaluated.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'evaluate': reEvaluate,

	      /**
	       * Used to detect `data` property values to inject.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'interpolate': reInterpolate,

	      /**
	       * Used to reference the data object in the template text.
	       *
	       * @memberOf _.templateSettings
	       * @type {string}
	       */
	      'variable': '',

	      /**
	       * Used to import variables into the compiled template.
	       *
	       * @memberOf _.templateSettings
	       * @type {Object}
	       */
	      'imports': {

	        /**
	         * A reference to the `lodash` function.
	         *
	         * @memberOf _.templateSettings.imports
	         * @type {Function}
	         */
	        '_': lodash
	      }
	    };

	    // Ensure wrappers are instances of `baseLodash`.
	    lodash.prototype = baseLodash.prototype;
	    lodash.prototype.constructor = lodash;

	    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
	    LodashWrapper.prototype.constructor = LodashWrapper;

	    /*------------------------------------------------------------------------*/

	    /**
	     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
	     *
	     * @private
	     * @constructor
	     * @param {*} value The value to wrap.
	     */
	    function LazyWrapper(value) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__dir__ = 1;
	      this.__filtered__ = false;
	      this.__iteratees__ = [];
	      this.__takeCount__ = MAX_ARRAY_LENGTH;
	      this.__views__ = [];
	    }

	    /**
	     * Creates a clone of the lazy wrapper object.
	     *
	     * @private
	     * @name clone
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the cloned `LazyWrapper` object.
	     */
	    function lazyClone() {
	      var result = new LazyWrapper(this.__wrapped__);
	      result.__actions__ = copyArray(this.__actions__);
	      result.__dir__ = this.__dir__;
	      result.__filtered__ = this.__filtered__;
	      result.__iteratees__ = copyArray(this.__iteratees__);
	      result.__takeCount__ = this.__takeCount__;
	      result.__views__ = copyArray(this.__views__);
	      return result;
	    }

	    /**
	     * Reverses the direction of lazy iteration.
	     *
	     * @private
	     * @name reverse
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the new reversed `LazyWrapper` object.
	     */
	    function lazyReverse() {
	      if (this.__filtered__) {
	        var result = new LazyWrapper(this);
	        result.__dir__ = -1;
	        result.__filtered__ = true;
	      } else {
	        result = this.clone();
	        result.__dir__ *= -1;
	      }
	      return result;
	    }

	    /**
	     * Extracts the unwrapped value from its lazy wrapper.
	     *
	     * @private
	     * @name value
	     * @memberOf LazyWrapper
	     * @returns {*} Returns the unwrapped value.
	     */
	    function lazyValue() {
	      var array = this.__wrapped__.value(),
	          dir = this.__dir__,
	          isArr = isArray(array),
	          isRight = dir < 0,
	          arrLength = isArr ? array.length : 0,
	          view = getView(0, arrLength, this.__views__),
	          start = view.start,
	          end = view.end,
	          length = end - start,
	          index = isRight ? end : (start - 1),
	          iteratees = this.__iteratees__,
	          iterLength = iteratees.length,
	          resIndex = 0,
	          takeCount = nativeMin(length, this.__takeCount__);

	      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
	        return baseWrapperValue(array, this.__actions__);
	      }
	      var result = [];

	      outer:
	      while (length-- && resIndex < takeCount) {
	        index += dir;

	        var iterIndex = -1,
	            value = array[index];

	        while (++iterIndex < iterLength) {
	          var data = iteratees[iterIndex],
	              iteratee = data.iteratee,
	              type = data.type,
	              computed = iteratee(value);

	          if (type == LAZY_MAP_FLAG) {
	            value = computed;
	          } else if (!computed) {
	            if (type == LAZY_FILTER_FLAG) {
	              continue outer;
	            } else {
	              break outer;
	            }
	          }
	        }
	        result[resIndex++] = value;
	      }
	      return result;
	    }

	    // Ensure `LazyWrapper` is an instance of `baseLodash`.
	    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
	    LazyWrapper.prototype.constructor = LazyWrapper;

	    /*------------------------------------------------------------------------*/

	    /**
	     * Creates a hash object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Hash(entries) {
	      var this$1 = this;

	      var index = -1,
	          length = entries == null ? 0 : entries.length;

	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this$1.set(entry[0], entry[1]);
	      }
	    }

	    /**
	     * Removes all key-value entries from the hash.
	     *
	     * @private
	     * @name clear
	     * @memberOf Hash
	     */
	    function hashClear() {
	      this.__data__ = nativeCreate ? nativeCreate(null) : {};
	      this.size = 0;
	    }

	    /**
	     * Removes `key` and its value from the hash.
	     *
	     * @private
	     * @name delete
	     * @memberOf Hash
	     * @param {Object} hash The hash to modify.
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function hashDelete(key) {
	      var result = this.has(key) && delete this.__data__[key];
	      this.size -= result ? 1 : 0;
	      return result;
	    }

	    /**
	     * Gets the hash value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Hash
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function hashGet(key) {
	      var data = this.__data__;
	      if (nativeCreate) {
	        var result = data[key];
	        return result === HASH_UNDEFINED ? undefined : result;
	      }
	      return hasOwnProperty.call(data, key) ? data[key] : undefined;
	    }

	    /**
	     * Checks if a hash value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Hash
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function hashHas(key) {
	      var data = this.__data__;
	      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	    }

	    /**
	     * Sets the hash `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Hash
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the hash instance.
	     */
	    function hashSet(key, value) {
	      var data = this.__data__;
	      this.size += this.has(key) ? 0 : 1;
	      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	      return this;
	    }

	    // Add methods to `Hash`.
	    Hash.prototype.clear = hashClear;
	    Hash.prototype['delete'] = hashDelete;
	    Hash.prototype.get = hashGet;
	    Hash.prototype.has = hashHas;
	    Hash.prototype.set = hashSet;

	    /*------------------------------------------------------------------------*/

	    /**
	     * Creates an list cache object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function ListCache(entries) {
	      var this$1 = this;

	      var index = -1,
	          length = entries == null ? 0 : entries.length;

	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this$1.set(entry[0], entry[1]);
	      }
	    }

	    /**
	     * Removes all key-value entries from the list cache.
	     *
	     * @private
	     * @name clear
	     * @memberOf ListCache
	     */
	    function listCacheClear() {
	      this.__data__ = [];
	      this.size = 0;
	    }

	    /**
	     * Removes `key` and its value from the list cache.
	     *
	     * @private
	     * @name delete
	     * @memberOf ListCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function listCacheDelete(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);

	      if (index < 0) {
	        return false;
	      }
	      var lastIndex = data.length - 1;
	      if (index == lastIndex) {
	        data.pop();
	      } else {
	        splice.call(data, index, 1);
	      }
	      --this.size;
	      return true;
	    }

	    /**
	     * Gets the list cache value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf ListCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function listCacheGet(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);

	      return index < 0 ? undefined : data[index][1];
	    }

	    /**
	     * Checks if a list cache value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf ListCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function listCacheHas(key) {
	      return assocIndexOf(this.__data__, key) > -1;
	    }

	    /**
	     * Sets the list cache `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf ListCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the list cache instance.
	     */
	    function listCacheSet(key, value) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);

	      if (index < 0) {
	        ++this.size;
	        data.push([key, value]);
	      } else {
	        data[index][1] = value;
	      }
	      return this;
	    }

	    // Add methods to `ListCache`.
	    ListCache.prototype.clear = listCacheClear;
	    ListCache.prototype['delete'] = listCacheDelete;
	    ListCache.prototype.get = listCacheGet;
	    ListCache.prototype.has = listCacheHas;
	    ListCache.prototype.set = listCacheSet;

	    /*------------------------------------------------------------------------*/

	    /**
	     * Creates a map cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function MapCache(entries) {
	      var this$1 = this;

	      var index = -1,
	          length = entries == null ? 0 : entries.length;

	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this$1.set(entry[0], entry[1]);
	      }
	    }

	    /**
	     * Removes all key-value entries from the map.
	     *
	     * @private
	     * @name clear
	     * @memberOf MapCache
	     */
	    function mapCacheClear() {
	      this.size = 0;
	      this.__data__ = {
	        'hash': new Hash,
	        'map': new (Map || ListCache),
	        'string': new Hash
	      };
	    }

	    /**
	     * Removes `key` and its value from the map.
	     *
	     * @private
	     * @name delete
	     * @memberOf MapCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function mapCacheDelete(key) {
	      var result = getMapData(this, key)['delete'](key);
	      this.size -= result ? 1 : 0;
	      return result;
	    }

	    /**
	     * Gets the map value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf MapCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function mapCacheGet(key) {
	      return getMapData(this, key).get(key);
	    }

	    /**
	     * Checks if a map value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf MapCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function mapCacheHas(key) {
	      return getMapData(this, key).has(key);
	    }

	    /**
	     * Sets the map `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf MapCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the map cache instance.
	     */
	    function mapCacheSet(key, value) {
	      var data = getMapData(this, key),
	          size = data.size;

	      data.set(key, value);
	      this.size += data.size == size ? 0 : 1;
	      return this;
	    }

	    // Add methods to `MapCache`.
	    MapCache.prototype.clear = mapCacheClear;
	    MapCache.prototype['delete'] = mapCacheDelete;
	    MapCache.prototype.get = mapCacheGet;
	    MapCache.prototype.has = mapCacheHas;
	    MapCache.prototype.set = mapCacheSet;

	    /*------------------------------------------------------------------------*/

	    /**
	     *
	     * Creates an array cache object to store unique values.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [values] The values to cache.
	     */
	    function SetCache(values) {
	      var this$1 = this;

	      var index = -1,
	          length = values == null ? 0 : values.length;

	      this.__data__ = new MapCache;
	      while (++index < length) {
	        this$1.add(values[index]);
	      }
	    }

	    /**
	     * Adds `value` to the array cache.
	     *
	     * @private
	     * @name add
	     * @memberOf SetCache
	     * @alias push
	     * @param {*} value The value to cache.
	     * @returns {Object} Returns the cache instance.
	     */
	    function setCacheAdd(value) {
	      this.__data__.set(value, HASH_UNDEFINED);
	      return this;
	    }

	    /**
	     * Checks if `value` is in the array cache.
	     *
	     * @private
	     * @name has
	     * @memberOf SetCache
	     * @param {*} value The value to search for.
	     * @returns {number} Returns `true` if `value` is found, else `false`.
	     */
	    function setCacheHas(value) {
	      return this.__data__.has(value);
	    }

	    // Add methods to `SetCache`.
	    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	    SetCache.prototype.has = setCacheHas;

	    /*------------------------------------------------------------------------*/

	    /**
	     * Creates a stack cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Stack(entries) {
	      var data = this.__data__ = new ListCache(entries);
	      this.size = data.size;
	    }

	    /**
	     * Removes all key-value entries from the stack.
	     *
	     * @private
	     * @name clear
	     * @memberOf Stack
	     */
	    function stackClear() {
	      this.__data__ = new ListCache;
	      this.size = 0;
	    }

	    /**
	     * Removes `key` and its value from the stack.
	     *
	     * @private
	     * @name delete
	     * @memberOf Stack
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function stackDelete(key) {
	      var data = this.__data__,
	          result = data['delete'](key);

	      this.size = data.size;
	      return result;
	    }

	    /**
	     * Gets the stack value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Stack
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function stackGet(key) {
	      return this.__data__.get(key);
	    }

	    /**
	     * Checks if a stack value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Stack
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function stackHas(key) {
	      return this.__data__.has(key);
	    }

	    /**
	     * Sets the stack `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Stack
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the stack cache instance.
	     */
	    function stackSet(key, value) {
	      var data = this.__data__;
	      if (data instanceof ListCache) {
	        var pairs = data.__data__;
	        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	          pairs.push([key, value]);
	          this.size = ++data.size;
	          return this;
	        }
	        data = this.__data__ = new MapCache(pairs);
	      }
	      data.set(key, value);
	      this.size = data.size;
	      return this;
	    }

	    // Add methods to `Stack`.
	    Stack.prototype.clear = stackClear;
	    Stack.prototype['delete'] = stackDelete;
	    Stack.prototype.get = stackGet;
	    Stack.prototype.has = stackHas;
	    Stack.prototype.set = stackSet;

	    /*------------------------------------------------------------------------*/

	    /**
	     * Creates an array of the enumerable property names of the array-like `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @param {boolean} inherited Specify returning inherited property names.
	     * @returns {Array} Returns the array of property names.
	     */
	    function arrayLikeKeys(value, inherited) {
	      var isArr = isArray(value),
	          isArg = !isArr && isArguments(value),
	          isBuff = !isArr && !isArg && isBuffer(value),
	          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	          skipIndexes = isArr || isArg || isBuff || isType,
	          result = skipIndexes ? baseTimes(value.length, String) : [],
	          length = result.length;

	      for (var key in value) {
	        if ((inherited || hasOwnProperty.call(value, key)) &&
	            !(skipIndexes && (
	               // Safari 9 has enumerable `arguments.length` in strict mode.
	               key == 'length' ||
	               // Node.js 0.10 has enumerable non-index properties on buffers.
	               (isBuff && (key == 'offset' || key == 'parent')) ||
	               // PhantomJS 2 has enumerable non-index properties on typed arrays.
	               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	               // Skip index properties.
	               isIndex(key, length)
	            ))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }

	    /**
	     * A specialized version of `_.sample` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @returns {*} Returns the random element.
	     */
	    function arraySample(array) {
	      var length = array.length;
	      return length ? array[baseRandom(0, length - 1)] : undefined;
	    }

	    /**
	     * A specialized version of `_.sampleSize` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function arraySampleSize(array, n) {
	      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
	    }

	    /**
	     * A specialized version of `_.shuffle` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function arrayShuffle(array) {
	      return shuffleSelf(copyArray(array));
	    }

	    /**
	     * This function is like `assignValue` except that it doesn't assign
	     * `undefined` values.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignMergeValue(object, key, value) {
	      if ((value !== undefined && !eq(object[key], value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }

	    /**
	     * Assigns `value` to `key` of `object` if the existing value is not equivalent
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignValue(object, key, value) {
	      var objValue = object[key];
	      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }

	    /**
	     * Gets the index at which the `key` is found in `array` of key-value pairs.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {*} key The key to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     */
	    function assocIndexOf(array, key) {
	      var length = array.length;
	      while (length--) {
	        if (eq(array[length][0], key)) {
	          return length;
	        }
	      }
	      return -1;
	    }

	    /**
	     * Aggregates elements of `collection` on `accumulator` with keys transformed
	     * by `iteratee` and values set by `setter`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform keys.
	     * @param {Object} accumulator The initial aggregated object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseAggregator(collection, setter, iteratee, accumulator) {
	      baseEach(collection, function(value, key, collection) {
	        setter(accumulator, value, iteratee(value), collection);
	      });
	      return accumulator;
	    }

	    /**
	     * The base implementation of `_.assign` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssign(object, source) {
	      return object && copyObject(source, keys(source), object);
	    }

	    /**
	     * The base implementation of `_.assignIn` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssignIn(object, source) {
	      return object && copyObject(source, keysIn(source), object);
	    }

	    /**
	     * The base implementation of `assignValue` and `assignMergeValue` without
	     * value checks.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function baseAssignValue(object, key, value) {
	      if (key == '__proto__' && defineProperty) {
	        defineProperty(object, key, {
	          'configurable': true,
	          'enumerable': true,
	          'value': value,
	          'writable': true
	        });
	      } else {
	        object[key] = value;
	      }
	    }

	    /**
	     * The base implementation of `_.at` without support for individual paths.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Array} Returns the picked elements.
	     */
	    function baseAt(object, paths) {
	      var index = -1,
	          length = paths.length,
	          result = Array(length),
	          skip = object == null;

	      while (++index < length) {
	        result[index] = skip ? undefined : get(object, paths[index]);
	      }
	      return result;
	    }

	    /**
	     * The base implementation of `_.clamp` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     */
	    function baseClamp(number, lower, upper) {
	      if (number === number) {
	        if (upper !== undefined) {
	          number = number <= upper ? number : upper;
	        }
	        if (lower !== undefined) {
	          number = number >= lower ? number : lower;
	        }
	      }
	      return number;
	    }

	    /**
	     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	     * traversed objects.
	     *
	     * @private
	     * @param {*} value The value to clone.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Deep clone
	     *  2 - Flatten inherited properties
	     *  4 - Clone symbols
	     * @param {Function} [customizer] The function to customize cloning.
	     * @param {string} [key] The key of `value`.
	     * @param {Object} [object] The parent object of `value`.
	     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	     * @returns {*} Returns the cloned value.
	     */
	    function baseClone(value, bitmask, customizer, key, object, stack) {
	      var result,
	          isDeep = bitmask & CLONE_DEEP_FLAG,
	          isFlat = bitmask & CLONE_FLAT_FLAG,
	          isFull = bitmask & CLONE_SYMBOLS_FLAG;

	      if (customizer) {
	        result = object ? customizer(value, key, object, stack) : customizer(value);
	      }
	      if (result !== undefined) {
	        return result;
	      }
	      if (!isObject(value)) {
	        return value;
	      }
	      var isArr = isArray(value);
	      if (isArr) {
	        result = initCloneArray(value);
	        if (!isDeep) {
	          return copyArray(value, result);
	        }
	      } else {
	        var tag = getTag(value),
	            isFunc = tag == funcTag || tag == genTag;

	        if (isBuffer(value)) {
	          return cloneBuffer(value, isDeep);
	        }
	        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	          result = (isFlat || isFunc) ? {} : initCloneObject(value);
	          if (!isDeep) {
	            return isFlat
	              ? copySymbolsIn(value, baseAssignIn(result, value))
	              : copySymbols(value, baseAssign(result, value));
	          }
	        } else {
	          if (!cloneableTags[tag]) {
	            return object ? value : {};
	          }
	          result = initCloneByTag(value, tag, isDeep);
	        }
	      }
	      // Check for circular references and return its corresponding clone.
	      stack || (stack = new Stack);
	      var stacked = stack.get(value);
	      if (stacked) {
	        return stacked;
	      }
	      stack.set(value, result);

	      if (isSet(value)) {
	        value.forEach(function(subValue) {
	          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
	        });
	      } else if (isMap(value)) {
	        value.forEach(function(subValue, key) {
	          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
	        });
	      }

	      var keysFunc = isFull
	        ? (isFlat ? getAllKeysIn : getAllKeys)
	        : (isFlat ? keysIn : keys);

	      var props = isArr ? undefined : keysFunc(value);
	      arrayEach(props || value, function(subValue, key) {
	        if (props) {
	          key = subValue;
	          subValue = value[key];
	        }
	        // Recursively populate clone (susceptible to call stack limits).
	        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
	      });
	      return result;
	    }

	    /**
	     * The base implementation of `_.conforms` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseConforms(source) {
	      var props = keys(source);
	      return function(object) {
	        return baseConformsTo(object, source, props);
	      };
	    }

	    /**
	     * The base implementation of `_.conformsTo` which accepts `props` to check.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     */
	    function baseConformsTo(object, source, props) {
	      var length = props.length;
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (length--) {
	        var key = props[length],
	            predicate = source[key],
	            value = object[key];

	        if ((value === undefined && !(key in object)) || !predicate(value)) {
	          return false;
	        }
	      }
	      return true;
	    }

	    /**
	     * The base implementation of `_.delay` and `_.defer` which accepts `args`
	     * to provide to `func`.
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {Array} args The arguments to provide to `func`.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    function baseDelay(func, wait, args) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return setTimeout(function() { func.apply(undefined, args); }, wait);
	    }

	    /**
	     * The base implementation of methods like `_.difference` without support
	     * for excluding multiple arrays or iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Array} values The values to exclude.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     */
	    function baseDifference(array, values, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          isCommon = true,
	          length = array.length,
	          result = [],
	          valuesLength = values.length;

	      if (!length) {
	        return result;
	      }
	      if (iteratee) {
	        values = arrayMap(values, baseUnary(iteratee));
	      }
	      if (comparator) {
	        includes = arrayIncludesWith;
	        isCommon = false;
	      }
	      else if (values.length >= LARGE_ARRAY_SIZE) {
	        includes = cacheHas;
	        isCommon = false;
	        values = new SetCache(values);
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee == null ? value : iteratee(value);

	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var valuesIndex = valuesLength;
	          while (valuesIndex--) {
	            if (values[valuesIndex] === computed) {
	              continue outer;
	            }
	          }
	          result.push(value);
	        }
	        else if (!includes(values, computed, comparator)) {
	          result.push(value);
	        }
	      }
	      return result;
	    }

	    /**
	     * The base implementation of `_.forEach` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEach = createBaseEach(baseForOwn);

	    /**
	     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEachRight = createBaseEach(baseForOwnRight, true);

	    /**
	     * The base implementation of `_.every` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`
	     */
	    function baseEvery(collection, predicate) {
	      var result = true;
	      baseEach(collection, function(value, index, collection) {
	        result = !!predicate(value, index, collection);
	        return result;
	      });
	      return result;
	    }

	    /**
	     * The base implementation of methods like `_.max` and `_.min` which accepts a
	     * `comparator` to determine the extremum value.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The iteratee invoked per iteration.
	     * @param {Function} comparator The comparator used to compare values.
	     * @returns {*} Returns the extremum value.
	     */
	    function baseExtremum(array, iteratee, comparator) {
	      var index = -1,
	          length = array.length;

	      while (++index < length) {
	        var value = array[index],
	            current = iteratee(value);

	        if (current != null && (computed === undefined
	              ? (current === current && !isSymbol(current))
	              : comparator(current, computed)
	            )) {
	          var computed = current,
	              result = value;
	        }
	      }
	      return result;
	    }

	    /**
	     * The base implementation of `_.fill` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     */
	    function baseFill(array, value, start, end) {
	      var length = array.length;

	      start = toInteger(start);
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = (end === undefined || end > length) ? length : toInteger(end);
	      if (end < 0) {
	        end += length;
	      }
	      end = start > end ? 0 : toLength(end);
	      while (start < end) {
	        array[start++] = value;
	      }
	      return array;
	    }

	    /**
	     * The base implementation of `_.filter` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     */
	    function baseFilter(collection, predicate) {
	      var result = [];
	      baseEach(collection, function(value, index, collection) {
	        if (predicate(value, index, collection)) {
	          result.push(value);
	        }
	      });
	      return result;
	    }

	    /**
	     * The base implementation of `_.flatten` with support for restricting flattening.
	     *
	     * @private
	     * @param {Array} array The array to flatten.
	     * @param {number} depth The maximum recursion depth.
	     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	     * @param {Array} [result=[]] The initial result value.
	     * @returns {Array} Returns the new flattened array.
	     */
	    function baseFlatten(array, depth, predicate, isStrict, result) {
	      var index = -1,
	          length = array.length;

	      predicate || (predicate = isFlattenable);
	      result || (result = []);

	      while (++index < length) {
	        var value = array[index];
	        if (depth > 0 && predicate(value)) {
	          if (depth > 1) {
	            // Recursively flatten arrays (susceptible to call stack limits).
	            baseFlatten(value, depth - 1, predicate, isStrict, result);
	          } else {
	            arrayPush(result, value);
	          }
	        } else if (!isStrict) {
	          result[result.length] = value;
	        }
	      }
	      return result;
	    }

	    /**
	     * The base implementation of `baseForOwn` which iterates over `object`
	     * properties returned by `keysFunc` and invokes `iteratee` for each property.
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseFor = createBaseFor();

	    /**
	     * This function is like `baseFor` except that it iterates over properties
	     * in the opposite order.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseForRight = createBaseFor(true);

	    /**
	     * The base implementation of `_.forOwn` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwn(object, iteratee) {
	      return object && baseFor(object, iteratee, keys);
	    }

	    /**
	     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwnRight(object, iteratee) {
	      return object && baseForRight(object, iteratee, keys);
	    }

	    /**
	     * The base implementation of `_.functions` which creates an array of
	     * `object` function property names filtered from `props`.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Array} props The property names to filter.
	     * @returns {Array} Returns the function names.
	     */
	    function baseFunctions(object, props) {
	      return arrayFilter(props, function(key) {
	        return isFunction(object[key]);
	      });
	    }

	    /**
	     * The base implementation of `_.get` without support for default values.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseGet(object, path) {
	      path = castPath(path, object);

	      var index = 0,
	          length = path.length;

	      while (object != null && index < length) {
	        object = object[toKey(path[index++])];
	      }
	      return (index && index == length) ? object : undefined;
	    }

	    /**
	     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @param {Function} symbolsFunc The function to get the symbols of `object`.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	      var result = keysFunc(object);
	      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	    }

	    /**
	     * The base implementation of `getTag` without fallbacks for buggy environments.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    function baseGetTag(value) {
	      if (value == null) {
	        return value === undefined ? undefinedTag : nullTag;
	      }
	      return (symToStringTag && symToStringTag in Object(value))
	        ? getRawTag(value)
	        : objectToString(value);
	    }

	    /**
	     * The base implementation of `_.gt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     */
	    function baseGt(value, other) {
	      return value > other;
	    }

	    /**
	     * The base implementation of `_.has` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHas(object, key) {
	      return object != null && hasOwnProperty.call(object, key);
	    }

	    /**
	     * The base implementation of `_.hasIn` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHasIn(object, key) {
	      return object != null && key in Object(object);
	    }

	    /**
	     * The base implementation of `_.inRange` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to check.
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     */
	    function baseInRange(number, start, end) {
	      return number >= nativeMin(start, end) && number < nativeMax(start, end);
	    }

	    /**
	     * The base implementation of methods like `_.intersection`, without support
	     * for iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of shared values.
	     */
	    function baseIntersection(arrays, iteratee, comparator) {
	      var includes = comparator ? arrayIncludesWith : arrayIncludes,
	          length = arrays[0].length,
	          othLength = arrays.length,
	          othIndex = othLength,
	          caches = Array(othLength),
	          maxLength = Infinity,
	          result = [];

	      while (othIndex--) {
	        var array = arrays[othIndex];
	        if (othIndex && iteratee) {
	          array = arrayMap(array, baseUnary(iteratee));
	        }
	        maxLength = nativeMin(array.length, maxLength);
	        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
	          ? new SetCache(othIndex && array)
	          : undefined;
	      }
	      array = arrays[0];

	      var index = -1,
	          seen = caches[0];

	      outer:
	      while (++index < length && result.length < maxLength) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;

	        value = (comparator || value !== 0) ? value : 0;
	        if (!(seen
	              ? cacheHas(seen, computed)
	              : includes(result, computed, comparator)
	            )) {
	          othIndex = othLength;
	          while (--othIndex) {
	            var cache = caches[othIndex];
	            if (!(cache
	                  ? cacheHas(cache, computed)
	                  : includes(arrays[othIndex], computed, comparator))
	                ) {
	              continue outer;
	            }
	          }
	          if (seen) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }

	    /**
	     * The base implementation of `_.invert` and `_.invertBy` which inverts
	     * `object` with values transformed by `iteratee` and set by `setter`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform values.
	     * @param {Object} accumulator The initial inverted object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseInverter(object, setter, iteratee, accumulator) {
	      baseForOwn(object, function(value, key, object) {
	        setter(accumulator, iteratee(value), key, object);
	      });
	      return accumulator;
	    }

	    /**
	     * The base implementation of `_.invoke` without support for individual
	     * method arguments.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {Array} args The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     */
	    function baseInvoke(object, path, args) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      var func = object == null ? object : object[toKey(last(path))];
	      return func == null ? undefined : apply(func, object, args);
	    }

	    /**
	     * The base implementation of `_.isArguments`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     */
	    function baseIsArguments(value) {
	      return isObjectLike(value) && baseGetTag(value) == argsTag;
	    }

	    /**
	     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     */
	    function baseIsArrayBuffer(value) {
	      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
	    }

	    /**
	     * The base implementation of `_.isDate` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     */
	    function baseIsDate(value) {
	      return isObjectLike(value) && baseGetTag(value) == dateTag;
	    }

	    /**
	     * The base implementation of `_.isEqual` which supports partial comparisons
	     * and tracks traversed objects.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Unordered comparison
	     *  2 - Partial comparison
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     */
	    function baseIsEqual(value, other, bitmask, customizer, stack) {
	      if (value === other) {
	        return true;
	      }
	      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	        return value !== value && other !== other;
	      }
	      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	    }

	    /**
	     * A specialized version of `baseIsEqual` for arrays and objects which performs
	     * deep comparisons and tracks traversed objects enabling objects with circular
	     * references to be compared.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	      var objIsArr = isArray(object),
	          othIsArr = isArray(other),
	          objTag = objIsArr ? arrayTag : getTag(object),
	          othTag = othIsArr ? arrayTag : getTag(other);

	      objTag = objTag == argsTag ? objectTag : objTag;
	      othTag = othTag == argsTag ? objectTag : othTag;

	      var objIsObj = objTag == objectTag,
	          othIsObj = othTag == objectTag,
	          isSameTag = objTag == othTag;

	      if (isSameTag && isBuffer(object)) {
	        if (!isBuffer(other)) {
	          return false;
	        }
	        objIsArr = true;
	        objIsObj = false;
	      }
	      if (isSameTag && !objIsObj) {
	        stack || (stack = new Stack);
	        return (objIsArr || isTypedArray(object))
	          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	      }
	      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

	        if (objIsWrapped || othIsWrapped) {
	          var objUnwrapped = objIsWrapped ? object.value() : object,
	              othUnwrapped = othIsWrapped ? other.value() : other;

	          stack || (stack = new Stack);
	          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	        }
	      }
	      if (!isSameTag) {
	        return false;
	      }
	      stack || (stack = new Stack);
	      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	    }

	    /**
	     * The base implementation of `_.isMap` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     */
	    function baseIsMap(value) {
	      return isObjectLike(value) && getTag(value) == mapTag;
	    }

	    /**
	     * The base implementation of `_.isMatch` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Array} matchData The property names, values, and compare flags to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     */
	    function baseIsMatch(object, source, matchData, customizer) {
	      var index = matchData.length,
	          length = index,
	          noCustomizer = !customizer;

	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (index--) {
	        var data = matchData[index];
	        if ((noCustomizer && data[2])
	              ? data[1] !== object[data[0]]
	              : !(data[0] in object)
	            ) {
	          return false;
	        }
	      }
	      while (++index < length) {
	        data = matchData[index];
	        var key = data[0],
	            objValue = object[key],
	            srcValue = data[1];

	        if (noCustomizer && data[2]) {
	          if (objValue === undefined && !(key in object)) {
	            return false;
	          }
	        } else {
	          var stack = new Stack;
	          if (customizer) {
	            var result = customizer(objValue, srcValue, key, object, source, stack);
	          }
	          if (!(result === undefined
	                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	                : result
	              )) {
	            return false;
	          }
	        }
	      }
	      return true;
	    }

	    /**
	     * The base implementation of `_.isNative` without bad shim checks.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     */
	    function baseIsNative(value) {
	      if (!isObject(value) || isMasked(value)) {
	        return false;
	      }
	      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	      return pattern.test(toSource(value));
	    }

	    /**
	     * The base implementation of `_.isRegExp` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     */
	    function baseIsRegExp(value) {
	      return isObjectLike(value) && baseGetTag(value) == regexpTag;
	    }

	    /**
	     * The base implementation of `_.isSet` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     */
	    function baseIsSet(value) {
	      return isObjectLike(value) && getTag(value) == setTag;
	    }

	    /**
	     * The base implementation of `_.isTypedArray` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     */
	    function baseIsTypedArray(value) {
	      return isObjectLike(value) &&
	        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	    }

	    /**
	     * The base implementation of `_.iteratee`.
	     *
	     * @private
	     * @param {*} [value=_.identity] The value to convert to an iteratee.
	     * @returns {Function} Returns the iteratee.
	     */
	    function baseIteratee(value) {
	      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	      if (typeof value == 'function') {
	        return value;
	      }
	      if (value == null) {
	        return identity;
	      }
	      if (typeof value == 'object') {
	        return isArray(value)
	          ? baseMatchesProperty(value[0], value[1])
	          : baseMatches(value);
	      }
	      return property(value);
	    }

	    /**
	     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeys(object) {
	      if (!isPrototype(object)) {
	        return nativeKeys(object);
	      }
	      var result = [];
	      for (var key in Object(object)) {
	        if (hasOwnProperty.call(object, key) && key != 'constructor') {
	          result.push(key);
	        }
	      }
	      return result;
	    }

	    /**
	     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeysIn(object) {
	      if (!isObject(object)) {
	        return nativeKeysIn(object);
	      }
	      var isProto = isPrototype(object),
	          result = [];

	      for (var key in object) {
	        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }

	    /**
	     * The base implementation of `_.lt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     */
	    function baseLt(value, other) {
	      return value < other;
	    }

	    /**
	     * The base implementation of `_.map` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     */
	    function baseMap(collection, iteratee) {
	      var index = -1,
	          result = isArrayLike(collection) ? Array(collection.length) : [];

	      baseEach(collection, function(value, key, collection) {
	        result[++index] = iteratee(value, key, collection);
	      });
	      return result;
	    }

	    /**
	     * The base implementation of `_.matches` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatches(source) {
	      var matchData = getMatchData(source);
	      if (matchData.length == 1 && matchData[0][2]) {
	        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	      }
	      return function(object) {
	        return object === source || baseIsMatch(object, source, matchData);
	      };
	    }

	    /**
	     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	     *
	     * @private
	     * @param {string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatchesProperty(path, srcValue) {
	      if (isKey(path) && isStrictComparable(srcValue)) {
	        return matchesStrictComparable(toKey(path), srcValue);
	      }
	      return function(object) {
	        var objValue = get(object, path);
	        return (objValue === undefined && objValue === srcValue)
	          ? hasIn(object, path)
	          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	      };
	    }

	    /**
	     * The base implementation of `_.merge` without support for multiple sources.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} [customizer] The function to customize merged values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMerge(object, source, srcIndex, customizer, stack) {
	      if (object === source) {
	        return;
	      }
	      baseFor(source, function(srcValue, key) {
	        stack || (stack = new Stack);
	        if (isObject(srcValue)) {
	          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	        }
	        else {
	          var newValue = customizer
	            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
	            : undefined;

	          if (newValue === undefined) {
	            newValue = srcValue;
	          }
	          assignMergeValue(object, key, newValue);
	        }
	      }, keysIn);
	    }

	    /**
	     * A specialized version of `baseMerge` for arrays and objects which performs
	     * deep merges and tracks traversed objects enabling objects with circular
	     * references to be merged.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {string} key The key of the value to merge.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} mergeFunc The function to merge values.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	      var objValue = safeGet(object, key),
	          srcValue = safeGet(source, key),
	          stacked = stack.get(srcValue);

	      if (stacked) {
	        assignMergeValue(object, key, stacked);
	        return;
	      }
	      var newValue = customizer
	        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	        : undefined;

	      var isCommon = newValue === undefined;

	      if (isCommon) {
	        var isArr = isArray(srcValue),
	            isBuff = !isArr && isBuffer(srcValue),
	            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

	        newValue = srcValue;
	        if (isArr || isBuff || isTyped) {
	          if (isArray(objValue)) {
	            newValue = objValue;
	          }
	          else if (isArrayLikeObject(objValue)) {
	            newValue = copyArray(objValue);
	          }
	          else if (isBuff) {
	            isCommon = false;
	            newValue = cloneBuffer(srcValue, true);
	          }
	          else if (isTyped) {
	            isCommon = false;
	            newValue = cloneTypedArray(srcValue, true);
	          }
	          else {
	            newValue = [];
	          }
	        }
	        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	          newValue = objValue;
	          if (isArguments(objValue)) {
	            newValue = toPlainObject(objValue);
	          }
	          else if (!isObject(objValue) || isFunction(objValue)) {
	            newValue = initCloneObject(srcValue);
	          }
	        }
	        else {
	          isCommon = false;
	        }
	      }
	      if (isCommon) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, newValue);
	        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	        stack['delete'](srcValue);
	      }
	      assignMergeValue(object, key, newValue);
	    }

	    /**
	     * The base implementation of `_.nth` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {number} n The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     */
	    function baseNth(array, n) {
	      var length = array.length;
	      if (!length) {
	        return;
	      }
	      n += n < 0 ? length : 0;
	      return isIndex(n, length) ? array[n] : undefined;
	    }

	    /**
	     * The base implementation of `_.orderBy` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	     * @param {string[]} orders The sort orders of `iteratees`.
	     * @returns {Array} Returns the new sorted array.
	     */
	    function baseOrderBy(collection, iteratees, orders) {
	      if (iteratees.length) {
	        iteratees = arrayMap(iteratees, function(iteratee) {
	          if (isArray(iteratee)) {
	            return function(value) {
	              return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
	            }
	          }
	          return iteratee;
	        });
	      } else {
	        iteratees = [identity];
	      }

	      var index = -1;
	      iteratees = arrayMap(iteratees, baseUnary(getIteratee()));

	      var result = baseMap(collection, function(value, key, collection) {
	        var criteria = arrayMap(iteratees, function(iteratee) {
	          return iteratee(value);
	        });
	        return { 'criteria': criteria, 'index': ++index, 'value': value };
	      });

	      return baseSortBy(result, function(object, other) {
	        return compareMultiple(object, other, orders);
	      });
	    }

	    /**
	     * The base implementation of `_.pick` without support for individual
	     * property identifiers.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Object} Returns the new object.
	     */
	    function basePick(object, paths) {
	      return basePickBy(object, paths, function(value, path) {
	        return hasIn(object, path);
	      });
	    }

	    /**
	     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @param {Function} predicate The function invoked per property.
	     * @returns {Object} Returns the new object.
	     */
	    function basePickBy(object, paths, predicate) {
	      var index = -1,
	          length = paths.length,
	          result = {};

	      while (++index < length) {
	        var path = paths[index],
	            value = baseGet(object, path);

	        if (predicate(value, path)) {
	          baseSet(result, castPath(path, object), value);
	        }
	      }
	      return result;
	    }

	    /**
	     * A specialized version of `baseProperty` which supports deep paths.
	     *
	     * @private
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     */
	    function basePropertyDeep(path) {
	      return function(object) {
	        return baseGet(object, path);
	      };
	    }

	    /**
	     * The base implementation of `_.pullAllBy` without support for iteratee
	     * shorthands.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAll(array, values, iteratee, comparator) {
	      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
	          index = -1,
	          length = values.length,
	          seen = array;

	      if (array === values) {
	        values = copyArray(values);
	      }
	      if (iteratee) {
	        seen = arrayMap(array, baseUnary(iteratee));
	      }
	      while (++index < length) {
	        var fromIndex = 0,
	            value = values[index],
	            computed = iteratee ? iteratee(value) : value;

	        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
	          if (seen !== array) {
	            splice.call(seen, fromIndex, 1);
	          }
	          splice.call(array, fromIndex, 1);
	        }
	      }
	      return array;
	    }

	    /**
	     * The base implementation of `_.pullAt` without support for individual
	     * indexes or capturing the removed elements.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {number[]} indexes The indexes of elements to remove.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAt(array, indexes) {
	      var length = array ? indexes.length : 0,
	          lastIndex = length - 1;

	      while (length--) {
	        var index = indexes[length];
	        if (length == lastIndex || index !== previous) {
	          var previous = index;
	          if (isIndex(index)) {
	            splice.call(array, index, 1);
	          } else {
	            baseUnset(array, index);
	          }
	        }
	      }
	      return array;
	    }

	    /**
	     * The base implementation of `_.random` without support for returning
	     * floating-point numbers.
	     *
	     * @private
	     * @param {number} lower The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the random number.
	     */
	    function baseRandom(lower, upper) {
	      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
	    }

	    /**
	     * The base implementation of `_.range` and `_.rangeRight` which doesn't
	     * coerce arguments.
	     *
	     * @private
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} step The value to increment or decrement by.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the range of numbers.
	     */
	    function baseRange(start, end, step, fromRight) {
	      var index = -1,
	          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
	          result = Array(length);

	      while (length--) {
	        result[fromRight ? length : ++index] = start;
	        start += step;
	      }
	      return result;
	    }

	    /**
	     * The base implementation of `_.repeat` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {string} string The string to repeat.
	     * @param {number} n The number of times to repeat the string.
	     * @returns {string} Returns the repeated string.
	     */
	    function baseRepeat(string, n) {
	      var result = '';
	      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
	        return result;
	      }
	      // Leverage the exponentiation by squaring algorithm for a faster repeat.
	      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
	      do {
	        if (n % 2) {
	          result += string;
	        }
	        n = nativeFloor(n / 2);
	        if (n) {
	          string += string;
	        }
	      } while (n);

	      return result;
	    }

	    /**
	     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     */
	    function baseRest(func, start) {
	      return setToString(overRest(func, start, identity), func + '');
	    }

	    /**
	     * The base implementation of `_.sample`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     */
	    function baseSample(collection) {
	      return arraySample(values(collection));
	    }

	    /**
	     * The base implementation of `_.sampleSize` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function baseSampleSize(collection, n) {
	      var array = values(collection);
	      return shuffleSelf(array, baseClamp(n, 0, array.length));
	    }

	    /**
	     * The base implementation of `_.set`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseSet(object, path, value, customizer) {
	      if (!isObject(object)) {
	        return object;
	      }
	      path = castPath(path, object);

	      var index = -1,
	          length = path.length,
	          lastIndex = length - 1,
	          nested = object;

	      while (nested != null && ++index < length) {
	        var key = toKey(path[index]),
	            newValue = value;

	        if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
	          return object;
	        }

	        if (index != lastIndex) {
	          var objValue = nested[key];
	          newValue = customizer ? customizer(objValue, key, nested) : undefined;
	          if (newValue === undefined) {
	            newValue = isObject(objValue)
	              ? objValue
	              : (isIndex(path[index + 1]) ? [] : {});
	          }
	        }
	        assignValue(nested, key, newValue);
	        nested = nested[key];
	      }
	      return object;
	    }

	    /**
	     * The base implementation of `setData` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetData = !metaMap ? identity : function(func, data) {
	      metaMap.set(func, data);
	      return func;
	    };

	    /**
	     * The base implementation of `setToString` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetToString = !defineProperty ? identity : function(func, string) {
	      return defineProperty(func, 'toString', {
	        'configurable': true,
	        'enumerable': false,
	        'value': constant(string),
	        'writable': true
	      });
	    };

	    /**
	     * The base implementation of `_.shuffle`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function baseShuffle(collection) {
	      return shuffleSelf(values(collection));
	    }

	    /**
	     * The base implementation of `_.slice` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseSlice(array, start, end) {
	      var index = -1,
	          length = array.length;

	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = end > length ? length : end;
	      if (end < 0) {
	        end += length;
	      }
	      length = start > end ? 0 : ((end - start) >>> 0);
	      start >>>= 0;

	      var result = Array(length);
	      while (++index < length) {
	        result[index] = array[index + start];
	      }
	      return result;
	    }

	    /**
	     * The base implementation of `_.some` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     */
	    function baseSome(collection, predicate) {
	      var result;

	      baseEach(collection, function(value, index, collection) {
	        result = predicate(value, index, collection);
	        return !result;
	      });
	      return !!result;
	    }

	    /**
	     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
	     * performs a binary search of `array` to determine the index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndex(array, value, retHighest) {
	      var low = 0,
	          high = array == null ? low : array.length;

	      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
	        while (low < high) {
	          var mid = (low + high) >>> 1,
	              computed = array[mid];

	          if (computed !== null && !isSymbol(computed) &&
	              (retHighest ? (computed <= value) : (computed < value))) {
	            low = mid + 1;
	          } else {
	            high = mid;
	          }
	        }
	        return high;
	      }
	      return baseSortedIndexBy(array, value, identity, retHighest);
	    }

	    /**
	     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
	     * which invokes `iteratee` for `value` and each element of `array` to compute
	     * their sort ranking. The iteratee is invoked with one argument; (value).
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} iteratee The iteratee invoked per element.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndexBy(array, value, iteratee, retHighest) {
	      var low = 0,
	          high = array == null ? 0 : array.length;
	      if (high === 0) {
	        return 0;
	      }

	      value = iteratee(value);
	      var valIsNaN = value !== value,
	          valIsNull = value === null,
	          valIsSymbol = isSymbol(value),
	          valIsUndefined = value === undefined;

	      while (low < high) {
	        var mid = nativeFloor((low + high) / 2),
	            computed = iteratee(array[mid]),
	            othIsDefined = computed !== undefined,
	            othIsNull = computed === null,
	            othIsReflexive = computed === computed,
	            othIsSymbol = isSymbol(computed);

	        if (valIsNaN) {
	          var setLow = retHighest || othIsReflexive;
	        } else if (valIsUndefined) {
	          setLow = othIsReflexive && (retHighest || othIsDefined);
	        } else if (valIsNull) {
	          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
	        } else if (valIsSymbol) {
	          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
	        } else if (othIsNull || othIsSymbol) {
	          setLow = false;
	        } else {
	          setLow = retHighest ? (computed <= value) : (computed < value);
	        }
	        if (setLow) {
	          low = mid + 1;
	        } else {
	          high = mid;
	        }
	      }
	      return nativeMin(high, MAX_ARRAY_INDEX);
	    }

	    /**
	     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
	     * support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseSortedUniq(array, iteratee) {
	      var index = -1,
	          length = array.length,
	          resIndex = 0,
	          result = [];

	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;

	        if (!index || !eq(computed, seen)) {
	          var seen = computed;
	          result[resIndex++] = value === 0 ? 0 : value;
	        }
	      }
	      return result;
	    }

	    /**
	     * The base implementation of `_.toNumber` which doesn't ensure correct
	     * conversions of binary, hexadecimal, or octal string values.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     */
	    function baseToNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      return +value;
	    }

	    /**
	     * The base implementation of `_.toString` which doesn't convert nullish
	     * values to empty strings.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {string} Returns the string.
	     */
	    function baseToString(value) {
	      // Exit early for strings to avoid a performance hit in some environments.
	      if (typeof value == 'string') {
	        return value;
	      }
	      if (isArray(value)) {
	        // Recursively convert values (susceptible to call stack limits).
	        return arrayMap(value, baseToString) + '';
	      }
	      if (isSymbol(value)) {
	        return symbolToString ? symbolToString.call(value) : '';
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }

	    /**
	     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseUniq(array, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          length = array.length,
	          isCommon = true,
	          result = [],
	          seen = result;

	      if (comparator) {
	        isCommon = false;
	        includes = arrayIncludesWith;
	      }
	      else if (length >= LARGE_ARRAY_SIZE) {
	        var set = iteratee ? null : createSet(array);
	        if (set) {
	          return setToArray(set);
	        }
	        isCommon = false;
	        includes = cacheHas;
	        seen = new SetCache;
	      }
	      else {
	        seen = iteratee ? [] : result;
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;

	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var seenIndex = seen.length;
	          while (seenIndex--) {
	            if (seen[seenIndex] === computed) {
	              continue outer;
	            }
	          }
	          if (iteratee) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	        else if (!includes(seen, computed, comparator)) {
	          if (seen !== result) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }

	    /**
	     * The base implementation of `_.unset`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The property path to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     */
	    function baseUnset(object, path) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      return object == null || delete object[toKey(last(path))];
	    }

	    /**
	     * The base implementation of `_.update`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to update.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseUpdate(object, path, updater, customizer) {
	      return baseSet(object, path, updater(baseGet(object, path)), customizer);
	    }

	    /**
	     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
	     * without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {Function} predicate The function invoked per iteration.
	     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseWhile(array, predicate, isDrop, fromRight) {
	      var length = array.length,
	          index = fromRight ? length : -1;

	      while ((fromRight ? index-- : ++index < length) &&
	        predicate(array[index], index, array)) {}

	      return isDrop
	        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
	        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
	    }

	    /**
	     * The base implementation of `wrapperValue` which returns the result of
	     * performing a sequence of actions on the unwrapped `value`, where each
	     * successive action is supplied the return value of the previous.
	     *
	     * @private
	     * @param {*} value The unwrapped value.
	     * @param {Array} actions Actions to perform to resolve the unwrapped value.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseWrapperValue(value, actions) {
	      var result = value;
	      if (result instanceof LazyWrapper) {
	        result = result.value();
	      }
	      return arrayReduce(actions, function(result, action) {
	        return action.func.apply(action.thisArg, arrayPush([result], action.args));
	      }, result);
	    }

	    /**
	     * The base implementation of methods like `_.xor`, without support for
	     * iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of values.
	     */
	    function baseXor(arrays, iteratee, comparator) {
	      var length = arrays.length;
	      if (length < 2) {
	        return length ? baseUniq(arrays[0]) : [];
	      }
	      var index = -1,
	          result = Array(length);

	      while (++index < length) {
	        var array = arrays[index],
	            othIndex = -1;

	        while (++othIndex < length) {
	          if (othIndex != index) {
	            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
	          }
	        }
	      }
	      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
	    }

	    /**
	     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
	     *
	     * @private
	     * @param {Array} props The property identifiers.
	     * @param {Array} values The property values.
	     * @param {Function} assignFunc The function to assign values.
	     * @returns {Object} Returns the new object.
	     */
	    function baseZipObject(props, values, assignFunc) {
	      var index = -1,
	          length = props.length,
	          valsLength = values.length,
	          result = {};

	      while (++index < length) {
	        var value = index < valsLength ? values[index] : undefined;
	        assignFunc(result, props[index], value);
	      }
	      return result;
	    }

	    /**
	     * Casts `value` to an empty array if it's not an array like object.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Array|Object} Returns the cast array-like object.
	     */
	    function castArrayLikeObject(value) {
	      return isArrayLikeObject(value) ? value : [];
	    }

	    /**
	     * Casts `value` to `identity` if it's not a function.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Function} Returns cast function.
	     */
	    function castFunction(value) {
	      return typeof value == 'function' ? value : identity;
	    }

	    /**
	     * Casts `value` to a path array if it's not one.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {Array} Returns the cast property path array.
	     */
	    function castPath(value, object) {
	      if (isArray(value)) {
	        return value;
	      }
	      return isKey(value, object) ? [value] : stringToPath(toString(value));
	    }

	    /**
	     * A `baseRest` alias which can be replaced with `identity` by module
	     * replacement plugins.
	     *
	     * @private
	     * @type {Function}
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    var castRest = baseRest;

	    /**
	     * Casts `array` to a slice if it's needed.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {number} start The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the cast slice.
	     */
	    function castSlice(array, start, end) {
	      var length = array.length;
	      end = end === undefined ? length : end;
	      return (!start && end >= length) ? array : baseSlice(array, start, end);
	    }

	    /**
	     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
	     *
	     * @private
	     * @param {number|Object} id The timer id or timeout object of the timer to clear.
	     */
	    var clearTimeout = ctxClearTimeout || function(id) {
	      return root.clearTimeout(id);
	    };

	    /**
	     * Creates a clone of  `buffer`.
	     *
	     * @private
	     * @param {Buffer} buffer The buffer to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Buffer} Returns the cloned buffer.
	     */
	    function cloneBuffer(buffer, isDeep) {
	      if (isDeep) {
	        return buffer.slice();
	      }
	      var length = buffer.length,
	          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

	      buffer.copy(result);
	      return result;
	    }

	    /**
	     * Creates a clone of `arrayBuffer`.
	     *
	     * @private
	     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	     * @returns {ArrayBuffer} Returns the cloned array buffer.
	     */
	    function cloneArrayBuffer(arrayBuffer) {
	      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	      return result;
	    }

	    /**
	     * Creates a clone of `dataView`.
	     *
	     * @private
	     * @param {Object} dataView The data view to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned data view.
	     */
	    function cloneDataView(dataView, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	    }

	    /**
	     * Creates a clone of `regexp`.
	     *
	     * @private
	     * @param {Object} regexp The regexp to clone.
	     * @returns {Object} Returns the cloned regexp.
	     */
	    function cloneRegExp(regexp) {
	      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	      result.lastIndex = regexp.lastIndex;
	      return result;
	    }

	    /**
	     * Creates a clone of the `symbol` object.
	     *
	     * @private
	     * @param {Object} symbol The symbol object to clone.
	     * @returns {Object} Returns the cloned symbol object.
	     */
	    function cloneSymbol(symbol) {
	      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	    }

	    /**
	     * Creates a clone of `typedArray`.
	     *
	     * @private
	     * @param {Object} typedArray The typed array to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned typed array.
	     */
	    function cloneTypedArray(typedArray, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	    }

	    /**
	     * Compares values to sort them in ascending order.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {number} Returns the sort order indicator for `value`.
	     */
	    function compareAscending(value, other) {
	      if (value !== other) {
	        var valIsDefined = value !== undefined,
	            valIsNull = value === null,
	            valIsReflexive = value === value,
	            valIsSymbol = isSymbol(value);

	        var othIsDefined = other !== undefined,
	            othIsNull = other === null,
	            othIsReflexive = other === other,
	            othIsSymbol = isSymbol(other);

	        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
	            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
	            (valIsNull && othIsDefined && othIsReflexive) ||
	            (!valIsDefined && othIsReflexive) ||
	            !valIsReflexive) {
	          return 1;
	        }
	        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
	            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
	            (othIsNull && valIsDefined && valIsReflexive) ||
	            (!othIsDefined && valIsReflexive) ||
	            !othIsReflexive) {
	          return -1;
	        }
	      }
	      return 0;
	    }

	    /**
	     * Used by `_.orderBy` to compare multiple properties of a value to another
	     * and stable sort them.
	     *
	     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
	     * specify an order of "desc" for descending or "asc" for ascending sort order
	     * of corresponding values.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {boolean[]|string[]} orders The order to sort by for each property.
	     * @returns {number} Returns the sort order indicator for `object`.
	     */
	    function compareMultiple(object, other, orders) {
	      var index = -1,
	          objCriteria = object.criteria,
	          othCriteria = other.criteria,
	          length = objCriteria.length,
	          ordersLength = orders.length;

	      while (++index < length) {
	        var result = compareAscending(objCriteria[index], othCriteria[index]);
	        if (result) {
	          if (index >= ordersLength) {
	            return result;
	          }
	          var order = orders[index];
	          return result * (order == 'desc' ? -1 : 1);
	        }
	      }
	      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	      // that causes it, under certain circumstances, to provide the same value for
	      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	      // for more details.
	      //
	      // This also ensures a stable sort in V8 and other engines.
	      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
	      return object.index - other.index;
	    }

	    /**
	     * Creates an array that is the composition of partially applied arguments,
	     * placeholders, and provided arguments into a single array of arguments.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to prepend to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgs(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersLength = holders.length,
	          leftIndex = -1,
	          leftLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(leftLength + rangeLength),
	          isUncurried = !isCurried;

	      while (++leftIndex < leftLength) {
	        result[leftIndex] = partials[leftIndex];
	      }
	      while (++argsIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[holders[argsIndex]] = args[argsIndex];
	        }
	      }
	      while (rangeLength--) {
	        result[leftIndex++] = args[argsIndex++];
	      }
	      return result;
	    }

	    /**
	     * This function is like `composeArgs` except that the arguments composition
	     * is tailored for `_.partialRight`.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to append to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgsRight(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersIndex = -1,
	          holdersLength = holders.length,
	          rightIndex = -1,
	          rightLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(rangeLength + rightLength),
	          isUncurried = !isCurried;

	      while (++argsIndex < rangeLength) {
	        result[argsIndex] = args[argsIndex];
	      }
	      var offset = argsIndex;
	      while (++rightIndex < rightLength) {
	        result[offset + rightIndex] = partials[rightIndex];
	      }
	      while (++holdersIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[offset + holders[holdersIndex]] = args[argsIndex++];
	        }
	      }
	      return result;
	    }

	    /**
	     * Copies the values of `source` to `array`.
	     *
	     * @private
	     * @param {Array} source The array to copy values from.
	     * @param {Array} [array=[]] The array to copy values to.
	     * @returns {Array} Returns `array`.
	     */
	    function copyArray(source, array) {
	      var index = -1,
	          length = source.length;

	      array || (array = Array(length));
	      while (++index < length) {
	        array[index] = source[index];
	      }
	      return array;
	    }

	    /**
	     * Copies properties of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy properties from.
	     * @param {Array} props The property identifiers to copy.
	     * @param {Object} [object={}] The object to copy properties to.
	     * @param {Function} [customizer] The function to customize copied values.
	     * @returns {Object} Returns `object`.
	     */
	    function copyObject(source, props, object, customizer) {
	      var isNew = !object;
	      object || (object = {});

	      var index = -1,
	          length = props.length;

	      while (++index < length) {
	        var key = props[index];

	        var newValue = customizer
	          ? customizer(object[key], source[key], key, object, source)
	          : undefined;

	        if (newValue === undefined) {
	          newValue = source[key];
	        }
	        if (isNew) {
	          baseAssignValue(object, key, newValue);
	        } else {
	          assignValue(object, key, newValue);
	        }
	      }
	      return object;
	    }

	    /**
	     * Copies own symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbols(source, object) {
	      return copyObject(source, getSymbols(source), object);
	    }

	    /**
	     * Copies own and inherited symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbolsIn(source, object) {
	      return copyObject(source, getSymbolsIn(source), object);
	    }

	    /**
	     * Creates a function like `_.groupBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} [initializer] The accumulator object initializer.
	     * @returns {Function} Returns the new aggregator function.
	     */
	    function createAggregator(setter, initializer) {
	      return function(collection, iteratee) {
	        var func = isArray(collection) ? arrayAggregator : baseAggregator,
	            accumulator = initializer ? initializer() : {};

	        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
	      };
	    }

	    /**
	     * Creates a function like `_.assign`.
	     *
	     * @private
	     * @param {Function} assigner The function to assign values.
	     * @returns {Function} Returns the new assigner function.
	     */
	    function createAssigner(assigner) {
	      return baseRest(function(object, sources) {
	        var index = -1,
	            length = sources.length,
	            customizer = length > 1 ? sources[length - 1] : undefined,
	            guard = length > 2 ? sources[2] : undefined;

	        customizer = (assigner.length > 3 && typeof customizer == 'function')
	          ? (length--, customizer)
	          : undefined;

	        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	          customizer = length < 3 ? undefined : customizer;
	          length = 1;
	        }
	        object = Object(object);
	        while (++index < length) {
	          var source = sources[index];
	          if (source) {
	            assigner(object, source, index, customizer);
	          }
	        }
	        return object;
	      });
	    }

	    /**
	     * Creates a `baseEach` or `baseEachRight` function.
	     *
	     * @private
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseEach(eachFunc, fromRight) {
	      return function(collection, iteratee) {
	        if (collection == null) {
	          return collection;
	        }
	        if (!isArrayLike(collection)) {
	          return eachFunc(collection, iteratee);
	        }
	        var length = collection.length,
	            index = fromRight ? length : -1,
	            iterable = Object(collection);

	        while ((fromRight ? index-- : ++index < length)) {
	          if (iteratee(iterable[index], index, iterable) === false) {
	            break;
	          }
	        }
	        return collection;
	      };
	    }

	    /**
	     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseFor(fromRight) {
	      return function(object, iteratee, keysFunc) {
	        var index = -1,
	            iterable = Object(object),
	            props = keysFunc(object),
	            length = props.length;

	        while (length--) {
	          var key = props[fromRight ? length : ++index];
	          if (iteratee(iterable[key], key, iterable) === false) {
	            break;
	          }
	        }
	        return object;
	      };
	    }

	    /**
	     * Creates a function that wraps `func` to invoke it with the optional `this`
	     * binding of `thisArg`.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createBind(func, bitmask, thisArg) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);

	      function wrapper() {
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return fn.apply(isBind ? thisArg : this, arguments);
	      }
	      return wrapper;
	    }

	    /**
	     * Creates a function like `_.lowerFirst`.
	     *
	     * @private
	     * @param {string} methodName The name of the `String` case method to use.
	     * @returns {Function} Returns the new case function.
	     */
	    function createCaseFirst(methodName) {
	      return function(string) {
	        string = toString(string);

	        var strSymbols = hasUnicode(string)
	          ? stringToArray(string)
	          : undefined;

	        var chr = strSymbols
	          ? strSymbols[0]
	          : string.charAt(0);

	        var trailing = strSymbols
	          ? castSlice(strSymbols, 1).join('')
	          : string.slice(1);

	        return chr[methodName]() + trailing;
	      };
	    }

	    /**
	     * Creates a function like `_.camelCase`.
	     *
	     * @private
	     * @param {Function} callback The function to combine each word.
	     * @returns {Function} Returns the new compounder function.
	     */
	    function createCompounder(callback) {
	      return function(string) {
	        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
	      };
	    }

	    /**
	     * Creates a function that produces an instance of `Ctor` regardless of
	     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	     *
	     * @private
	     * @param {Function} Ctor The constructor to wrap.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCtor(Ctor) {
	      return function() {
	        // Use a `switch` statement to work with class constructors. See
	        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
	        // for more details.
	        var args = arguments;
	        switch (args.length) {
	          case 0: return new Ctor;
	          case 1: return new Ctor(args[0]);
	          case 2: return new Ctor(args[0], args[1]);
	          case 3: return new Ctor(args[0], args[1], args[2]);
	          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
	          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
	          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
	          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
	        }
	        var thisBinding = baseCreate(Ctor.prototype),
	            result = Ctor.apply(thisBinding, args);

	        // Mimic the constructor's `return` behavior.
	        // See https://es5.github.io/#x13.2.2 for more details.
	        return isObject(result) ? result : thisBinding;
	      };
	    }

	    /**
	     * Creates a function that wraps `func` to enable currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {number} arity The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCurry(func, bitmask, arity) {
	      var Ctor = createCtor(func);

	      function wrapper() {
	        var arguments$1 = arguments;

	        var length = arguments.length,
	            args = Array(length),
	            index = length,
	            placeholder = getHolder(wrapper);

	        while (index--) {
	          args[index] = arguments$1[index];
	        }
	        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
	          ? []
	          : replaceHolders(args, placeholder);

	        length -= holders.length;
	        if (length < arity) {
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, undefined,
	            args, holders, undefined, undefined, arity - length);
	        }
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return apply(fn, this, args);
	      }
	      return wrapper;
	    }

	    /**
	     * Creates a `_.find` or `_.findLast` function.
	     *
	     * @private
	     * @param {Function} findIndexFunc The function to find the collection index.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFind(findIndexFunc) {
	      return function(collection, predicate, fromIndex) {
	        var iterable = Object(collection);
	        if (!isArrayLike(collection)) {
	          var iteratee = getIteratee(predicate, 3);
	          collection = keys(collection);
	          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
	        }
	        var index = findIndexFunc(collection, predicate, fromIndex);
	        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
	      };
	    }

	    /**
	     * Creates a `_.flow` or `_.flowRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new flow function.
	     */
	    function createFlow(fromRight) {
	      return flatRest(function(funcs) {
	        var length = funcs.length,
	            index = length,
	            prereq = LodashWrapper.prototype.thru;

	        if (fromRight) {
	          funcs.reverse();
	        }
	        while (index--) {
	          var func = funcs[index];
	          if (typeof func != 'function') {
	            throw new TypeError(FUNC_ERROR_TEXT);
	          }
	          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
	            var wrapper = new LodashWrapper([], true);
	          }
	        }
	        index = wrapper ? index : length;
	        while (++index < length) {
	          func = funcs[index];

	          var funcName = getFuncName(func),
	              data = funcName == 'wrapper' ? getData(func) : undefined;

	          if (data && isLaziable(data[0]) &&
	                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
	                !data[4].length && data[9] == 1
	              ) {
	            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
	          } else {
	            wrapper = (func.length == 1 && isLaziable(func))
	              ? wrapper[funcName]()
	              : wrapper.thru(func);
	          }
	        }
	        return function() {
	          var this$1 = this;

	          var args = arguments,
	              value = args[0];

	          if (wrapper && args.length == 1 && isArray(value)) {
	            return wrapper.plant(value).value();
	          }
	          var index = 0,
	              result = length ? funcs[index].apply(this, args) : value;

	          while (++index < length) {
	            result = funcs[index].call(this$1, result);
	          }
	          return result;
	        };
	      });
	    }

	    /**
	     * Creates a function that wraps `func` to invoke it with optional `this`
	     * binding of `thisArg`, partial application, and currying.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [partialsRight] The arguments to append to those provided
	     *  to the new function.
	     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
	      var isAry = bitmask & WRAP_ARY_FLAG,
	          isBind = bitmask & WRAP_BIND_FLAG,
	          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
	          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
	          isFlip = bitmask & WRAP_FLIP_FLAG,
	          Ctor = isBindKey ? undefined : createCtor(func);

	      function wrapper() {
	        var arguments$1 = arguments;

	        var length = arguments.length,
	            args = Array(length),
	            index = length;

	        while (index--) {
	          args[index] = arguments$1[index];
	        }
	        if (isCurried) {
	          var placeholder = getHolder(wrapper),
	              holdersCount = countHolders(args, placeholder);
	        }
	        if (partials) {
	          args = composeArgs(args, partials, holders, isCurried);
	        }
	        if (partialsRight) {
	          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
	        }
	        length -= holdersCount;
	        if (isCurried && length < arity) {
	          var newHolders = replaceHolders(args, placeholder);
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
	            args, newHolders, argPos, ary, arity - length
	          );
	        }
	        var thisBinding = isBind ? thisArg : this,
	            fn = isBindKey ? thisBinding[func] : func;

	        length = args.length;
	        if (argPos) {
	          args = reorder(args, argPos);
	        } else if (isFlip && length > 1) {
	          args.reverse();
	        }
	        if (isAry && ary < length) {
	          args.length = ary;
	        }
	        if (this && this !== root && this instanceof wrapper) {
	          fn = Ctor || createCtor(fn);
	        }
	        return fn.apply(thisBinding, args);
	      }
	      return wrapper;
	    }

	    /**
	     * Creates a function like `_.invertBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} toIteratee The function to resolve iteratees.
	     * @returns {Function} Returns the new inverter function.
	     */
	    function createInverter(setter, toIteratee) {
	      return function(object, iteratee) {
	        return baseInverter(object, setter, toIteratee(iteratee), {});
	      };
	    }

	    /**
	     * Creates a function that performs a mathematical operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @param {number} [defaultValue] The value used for `undefined` arguments.
	     * @returns {Function} Returns the new mathematical operation function.
	     */
	    function createMathOperation(operator, defaultValue) {
	      return function(value, other) {
	        var result;
	        if (value === undefined && other === undefined) {
	          return defaultValue;
	        }
	        if (value !== undefined) {
	          result = value;
	        }
	        if (other !== undefined) {
	          if (result === undefined) {
	            return other;
	          }
	          if (typeof value == 'string' || typeof other == 'string') {
	            value = baseToString(value);
	            other = baseToString(other);
	          } else {
	            value = baseToNumber(value);
	            other = baseToNumber(other);
	          }
	          result = operator(value, other);
	        }
	        return result;
	      };
	    }

	    /**
	     * Creates a function like `_.over`.
	     *
	     * @private
	     * @param {Function} arrayFunc The function to iterate over iteratees.
	     * @returns {Function} Returns the new over function.
	     */
	    function createOver(arrayFunc) {
	      return flatRest(function(iteratees) {
	        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
	        return baseRest(function(args) {
	          var thisArg = this;
	          return arrayFunc(iteratees, function(iteratee) {
	            return apply(iteratee, thisArg, args);
	          });
	        });
	      });
	    }

	    /**
	     * Creates the padding for `string` based on `length`. The `chars` string
	     * is truncated if the number of characters exceeds `length`.
	     *
	     * @private
	     * @param {number} length The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padding for `string`.
	     */
	    function createPadding(length, chars) {
	      chars = chars === undefined ? ' ' : baseToString(chars);

	      var charsLength = chars.length;
	      if (charsLength < 2) {
	        return charsLength ? baseRepeat(chars, length) : chars;
	      }
	      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
	      return hasUnicode(chars)
	        ? castSlice(stringToArray(result), 0, length).join('')
	        : result.slice(0, length);
	    }

	    /**
	     * Creates a function that wraps `func` to invoke it with the `this` binding
	     * of `thisArg` and `partials` prepended to the arguments it receives.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {Array} partials The arguments to prepend to those provided to
	     *  the new function.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createPartial(func, bitmask, thisArg, partials) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);

	      function wrapper() {
	        var arguments$1 = arguments;

	        var argsIndex = -1,
	            argsLength = arguments.length,
	            leftIndex = -1,
	            leftLength = partials.length,
	            args = Array(leftLength + argsLength),
	            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

	        while (++leftIndex < leftLength) {
	          args[leftIndex] = partials[leftIndex];
	        }
	        while (argsLength--) {
	          args[leftIndex++] = arguments$1[++argsIndex];
	        }
	        return apply(fn, isBind ? thisArg : this, args);
	      }
	      return wrapper;
	    }

	    /**
	     * Creates a `_.range` or `_.rangeRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new range function.
	     */
	    function createRange(fromRight) {
	      return function(start, end, step) {
	        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
	          end = step = undefined;
	        }
	        // Ensure the sign of `-0` is preserved.
	        start = toFinite(start);
	        if (end === undefined) {
	          end = start;
	          start = 0;
	        } else {
	          end = toFinite(end);
	        }
	        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
	        return baseRange(start, end, step, fromRight);
	      };
	    }

	    /**
	     * Creates a function that performs a relational operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @returns {Function} Returns the new relational operation function.
	     */
	    function createRelationalOperation(operator) {
	      return function(value, other) {
	        if (!(typeof value == 'string' && typeof other == 'string')) {
	          value = toNumber(value);
	          other = toNumber(other);
	        }
	        return operator(value, other);
	      };
	    }

	    /**
	     * Creates a function that wraps `func` to continue currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {Function} wrapFunc The function to create the `func` wrapper.
	     * @param {*} placeholder The placeholder value.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
	      var isCurry = bitmask & WRAP_CURRY_FLAG,
	          newHolders = isCurry ? holders : undefined,
	          newHoldersRight = isCurry ? undefined : holders,
	          newPartials = isCurry ? partials : undefined,
	          newPartialsRight = isCurry ? undefined : partials;

	      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
	      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

	      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
	        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
	      }
	      var newData = [
	        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
	        newHoldersRight, argPos, ary, arity
	      ];

	      var result = wrapFunc.apply(undefined, newData);
	      if (isLaziable(func)) {
	        setData(result, newData);
	      }
	      result.placeholder = placeholder;
	      return setWrapToString(result, func, bitmask);
	    }

	    /**
	     * Creates a function like `_.round`.
	     *
	     * @private
	     * @param {string} methodName The name of the `Math` method to use when rounding.
	     * @returns {Function} Returns the new round function.
	     */
	    function createRound(methodName) {
	      var func = Math[methodName];
	      return function(number, precision) {
	        number = toNumber(number);
	        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
	        if (precision && nativeIsFinite(number)) {
	          // Shift with exponential notation to avoid floating-point issues.
	          // See [MDN](https://mdn.io/round#Examples) for more details.
	          var pair = (toString(number) + 'e').split('e'),
	              value = func(pair[0] + 'e' + (+pair[1] + precision));

	          pair = (toString(value) + 'e').split('e');
	          return +(pair[0] + 'e' + (+pair[1] - precision));
	        }
	        return func(number);
	      };
	    }

	    /**
	     * Creates a set object of `values`.
	     *
	     * @private
	     * @param {Array} values The values to add to the set.
	     * @returns {Object} Returns the new set.
	     */
	    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
	      return new Set(values);
	    };

	    /**
	     * Creates a `_.toPairs` or `_.toPairsIn` function.
	     *
	     * @private
	     * @param {Function} keysFunc The function to get the keys of a given object.
	     * @returns {Function} Returns the new pairs function.
	     */
	    function createToPairs(keysFunc) {
	      return function(object) {
	        var tag = getTag(object);
	        if (tag == mapTag) {
	          return mapToArray(object);
	        }
	        if (tag == setTag) {
	          return setToPairs(object);
	        }
	        return baseToPairs(object, keysFunc(object));
	      };
	    }

	    /**
	     * Creates a function that either curries or invokes `func` with optional
	     * `this` binding and partially applied arguments.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags.
	     *    1 - `_.bind`
	     *    2 - `_.bindKey`
	     *    4 - `_.curry` or `_.curryRight` of a bound function
	     *    8 - `_.curry`
	     *   16 - `_.curryRight`
	     *   32 - `_.partial`
	     *   64 - `_.partialRight`
	     *  128 - `_.rearg`
	     *  256 - `_.ary`
	     *  512 - `_.flip`
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to be partially applied.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
	      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
	      if (!isBindKey && typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var length = partials ? partials.length : 0;
	      if (!length) {
	        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
	        partials = holders = undefined;
	      }
	      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
	      arity = arity === undefined ? arity : toInteger(arity);
	      length -= holders ? holders.length : 0;

	      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
	        var partialsRight = partials,
	            holdersRight = holders;

	        partials = holders = undefined;
	      }
	      var data = isBindKey ? undefined : getData(func);

	      var newData = [
	        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
	        argPos, ary, arity
	      ];

	      if (data) {
	        mergeData(newData, data);
	      }
	      func = newData[0];
	      bitmask = newData[1];
	      thisArg = newData[2];
	      partials = newData[3];
	      holders = newData[4];
	      arity = newData[9] = newData[9] === undefined
	        ? (isBindKey ? 0 : func.length)
	        : nativeMax(newData[9] - length, 0);

	      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
	        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
	      }
	      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
	        var result = createBind(func, bitmask, thisArg);
	      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
	        result = createCurry(func, bitmask, arity);
	      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
	        result = createPartial(func, bitmask, thisArg, partials);
	      } else {
	        result = createHybrid.apply(undefined, newData);
	      }
	      var setter = data ? baseSetData : setData;
	      return setWrapToString(setter(result, newData), func, bitmask);
	    }

	    /**
	     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
	     * of source objects to the destination object for all destination properties
	     * that resolve to `undefined`.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to assign.
	     * @param {Object} object The parent object of `objValue`.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsAssignIn(objValue, srcValue, key, object) {
	      if (objValue === undefined ||
	          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	        return srcValue;
	      }
	      return objValue;
	    }

	    /**
	     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
	     * objects into destination objects that are passed thru.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to merge.
	     * @param {Object} object The parent object of `objValue`.
	     * @param {Object} source The parent object of `srcValue`.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
	      if (isObject(objValue) && isObject(srcValue)) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, objValue);
	        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
	        stack['delete'](srcValue);
	      }
	      return objValue;
	    }

	    /**
	     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
	     * objects.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {string} key The key of the property to inspect.
	     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
	     */
	    function customOmitClone(value) {
	      return isPlainObject(value) ? undefined : value;
	    }

	    /**
	     * A specialized version of `baseIsEqualDeep` for arrays with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Array} array The array to compare.
	     * @param {Array} other The other array to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `array` and `other` objects.
	     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	     */
	    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          arrLength = array.length,
	          othLength = other.length;

	      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	        return false;
	      }
	      // Check that cyclic values are equal.
	      var arrStacked = stack.get(array);
	      var othStacked = stack.get(other);
	      if (arrStacked && othStacked) {
	        return arrStacked == other && othStacked == array;
	      }
	      var index = -1,
	          result = true,
	          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

	      stack.set(array, other);
	      stack.set(other, array);

	      // Ignore non-index properties.
	      while (++index < arrLength) {
	        var arrValue = array[index],
	            othValue = other[index];

	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, arrValue, index, other, array, stack)
	            : customizer(arrValue, othValue, index, array, other, stack);
	        }
	        if (compared !== undefined) {
	          if (compared) {
	            continue;
	          }
	          result = false;
	          break;
	        }
	        // Recursively compare arrays (susceptible to call stack limits).
	        if (seen) {
	          if (!arraySome(other, function(othValue, othIndex) {
	                if (!cacheHas(seen, othIndex) &&
	                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	                  return seen.push(othIndex);
	                }
	              })) {
	            result = false;
	            break;
	          }
	        } else if (!(
	              arrValue === othValue ||
	                equalFunc(arrValue, othValue, bitmask, customizer, stack)
	            )) {
	          result = false;
	          break;
	        }
	      }
	      stack['delete'](array);
	      stack['delete'](other);
	      return result;
	    }

	    /**
	     * A specialized version of `baseIsEqualDeep` for comparing objects of
	     * the same `toStringTag`.
	     *
	     * **Note:** This function only supports comparing values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {string} tag The `toStringTag` of the objects to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	      switch (tag) {
	        case dataViewTag:
	          if ((object.byteLength != other.byteLength) ||
	              (object.byteOffset != other.byteOffset)) {
	            return false;
	          }
	          object = object.buffer;
	          other = other.buffer;

	        case arrayBufferTag:
	          if ((object.byteLength != other.byteLength) ||
	              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	            return false;
	          }
	          return true;

	        case boolTag:
	        case dateTag:
	        case numberTag:
	          // Coerce booleans to `1` or `0` and dates to milliseconds.
	          // Invalid dates are coerced to `NaN`.
	          return eq(+object, +other);

	        case errorTag:
	          return object.name == other.name && object.message == other.message;

	        case regexpTag:
	        case stringTag:
	          // Coerce regexes to strings and treat strings, primitives and objects,
	          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	          // for more details.
	          return object == (other + '');

	        case mapTag:
	          var convert = mapToArray;

	        case setTag:
	          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	          convert || (convert = setToArray);

	          if (object.size != other.size && !isPartial) {
	            return false;
	          }
	          // Assume cyclic values are equal.
	          var stacked = stack.get(object);
	          if (stacked) {
	            return stacked == other;
	          }
	          bitmask |= COMPARE_UNORDERED_FLAG;

	          // Recursively compare objects (susceptible to call stack limits).
	          stack.set(object, other);
	          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	          stack['delete'](object);
	          return result;

	        case symbolTag:
	          if (symbolValueOf) {
	            return symbolValueOf.call(object) == symbolValueOf.call(other);
	          }
	      }
	      return false;
	    }

	    /**
	     * A specialized version of `baseIsEqualDeep` for objects with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          objProps = getAllKeys(object),
	          objLength = objProps.length,
	          othProps = getAllKeys(other),
	          othLength = othProps.length;

	      if (objLength != othLength && !isPartial) {
	        return false;
	      }
	      var index = objLength;
	      while (index--) {
	        var key = objProps[index];
	        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	          return false;
	        }
	      }
	      // Check that cyclic values are equal.
	      var objStacked = stack.get(object);
	      var othStacked = stack.get(other);
	      if (objStacked && othStacked) {
	        return objStacked == other && othStacked == object;
	      }
	      var result = true;
	      stack.set(object, other);
	      stack.set(other, object);

	      var skipCtor = isPartial;
	      while (++index < objLength) {
	        key = objProps[index];
	        var objValue = object[key],
	            othValue = other[key];

	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, objValue, key, other, object, stack)
	            : customizer(objValue, othValue, key, object, other, stack);
	        }
	        // Recursively compare objects (susceptible to call stack limits).
	        if (!(compared === undefined
	              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	              : compared
	            )) {
	          result = false;
	          break;
	        }
	        skipCtor || (skipCtor = key == 'constructor');
	      }
	      if (result && !skipCtor) {
	        var objCtor = object.constructor,
	            othCtor = other.constructor;

	        // Non `Object` object instances with different constructors are not equal.
	        if (objCtor != othCtor &&
	            ('constructor' in object && 'constructor' in other) &&
	            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	          result = false;
	        }
	      }
	      stack['delete'](object);
	      stack['delete'](other);
	      return result;
	    }

	    /**
	     * A specialized version of `baseRest` which flattens the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    function flatRest(func) {
	      return setToString(overRest(func, undefined, flatten), func + '');
	    }

	    /**
	     * Creates an array of own enumerable property names and symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeys(object) {
	      return baseGetAllKeys(object, keys, getSymbols);
	    }

	    /**
	     * Creates an array of own and inherited enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeysIn(object) {
	      return baseGetAllKeys(object, keysIn, getSymbolsIn);
	    }

	    /**
	     * Gets metadata for `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {*} Returns the metadata for `func`.
	     */
	    var getData = !metaMap ? noop : function(func) {
	      return metaMap.get(func);
	    };

	    /**
	     * Gets the name of `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {string} Returns the function name.
	     */
	    function getFuncName(func) {
	      var result = (func.name + ''),
	          array = realNames[result],
	          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

	      while (length--) {
	        var data = array[length],
	            otherFunc = data.func;
	        if (otherFunc == null || otherFunc == func) {
	          return data.name;
	        }
	      }
	      return result;
	    }

	    /**
	     * Gets the argument placeholder value for `func`.
	     *
	     * @private
	     * @param {Function} func The function to inspect.
	     * @returns {*} Returns the placeholder value.
	     */
	    function getHolder(func) {
	      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
	      return object.placeholder;
	    }

	    /**
	     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
	     * this function returns the custom method, otherwise it returns `baseIteratee`.
	     * If arguments are provided, the chosen function is invoked with them and
	     * its result is returned.
	     *
	     * @private
	     * @param {*} [value] The value to convert to an iteratee.
	     * @param {number} [arity] The arity of the created iteratee.
	     * @returns {Function} Returns the chosen function or its result.
	     */
	    function getIteratee() {
	      var result = lodash.iteratee || iteratee;
	      result = result === iteratee ? baseIteratee : result;
	      return arguments.length ? result(arguments[0], arguments[1]) : result;
	    }

	    /**
	     * Gets the data for `map`.
	     *
	     * @private
	     * @param {Object} map The map to query.
	     * @param {string} key The reference key.
	     * @returns {*} Returns the map data.
	     */
	    function getMapData(map, key) {
	      var data = map.__data__;
	      return isKeyable(key)
	        ? data[typeof key == 'string' ? 'string' : 'hash']
	        : data.map;
	    }

	    /**
	     * Gets the property names, values, and compare flags of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the match data of `object`.
	     */
	    function getMatchData(object) {
	      var result = keys(object),
	          length = result.length;

	      while (length--) {
	        var key = result[length],
	            value = object[key];

	        result[length] = [key, value, isStrictComparable(value)];
	      }
	      return result;
	    }

	    /**
	     * Gets the native function at `key` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the method to get.
	     * @returns {*} Returns the function if it's native, else `undefined`.
	     */
	    function getNative(object, key) {
	      var value = getValue(object, key);
	      return baseIsNative(value) ? value : undefined;
	    }

	    /**
	     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the raw `toStringTag`.
	     */
	    function getRawTag(value) {
	      var isOwn = hasOwnProperty.call(value, symToStringTag),
	          tag = value[symToStringTag];

	      try {
	        value[symToStringTag] = undefined;
	        var unmasked = true;
	      } catch (e) {}

	      var result = nativeObjectToString.call(value);
	      if (unmasked) {
	        if (isOwn) {
	          value[symToStringTag] = tag;
	        } else {
	          delete value[symToStringTag];
	        }
	      }
	      return result;
	    }

	    /**
	     * Creates an array of the own enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	      if (object == null) {
	        return [];
	      }
	      object = Object(object);
	      return arrayFilter(nativeGetSymbols(object), function(symbol) {
	        return propertyIsEnumerable.call(object, symbol);
	      });
	    };

	    /**
	     * Creates an array of the own and inherited enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
	      var result = [];
	      while (object) {
	        arrayPush(result, getSymbols(object));
	        object = getPrototype(object);
	      }
	      return result;
	    };

	    /**
	     * Gets the `toStringTag` of `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    var getTag = baseGetTag;

	    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	        (Map && getTag(new Map) != mapTag) ||
	        (Promise && getTag(Promise.resolve()) != promiseTag) ||
	        (Set && getTag(new Set) != setTag) ||
	        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	      getTag = function(value) {
	        var result = baseGetTag(value),
	            Ctor = result == objectTag ? value.constructor : undefined,
	            ctorString = Ctor ? toSource(Ctor) : '';

	        if (ctorString) {
	          switch (ctorString) {
	            case dataViewCtorString: return dataViewTag;
	            case mapCtorString: return mapTag;
	            case promiseCtorString: return promiseTag;
	            case setCtorString: return setTag;
	            case weakMapCtorString: return weakMapTag;
	          }
	        }
	        return result;
	      };
	    }

	    /**
	     * Gets the view, applying any `transforms` to the `start` and `end` positions.
	     *
	     * @private
	     * @param {number} start The start of the view.
	     * @param {number} end The end of the view.
	     * @param {Array} transforms The transformations to apply to the view.
	     * @returns {Object} Returns an object containing the `start` and `end`
	     *  positions of the view.
	     */
	    function getView(start, end, transforms) {
	      var index = -1,
	          length = transforms.length;

	      while (++index < length) {
	        var data = transforms[index],
	            size = data.size;

	        switch (data.type) {
	          case 'drop':      start += size; break;
	          case 'dropRight': end -= size; break;
	          case 'take':      end = nativeMin(end, start + size); break;
	          case 'takeRight': start = nativeMax(start, end - size); break;
	        }
	      }
	      return { 'start': start, 'end': end };
	    }

	    /**
	     * Extracts wrapper details from the `source` body comment.
	     *
	     * @private
	     * @param {string} source The source to inspect.
	     * @returns {Array} Returns the wrapper details.
	     */
	    function getWrapDetails(source) {
	      var match = source.match(reWrapDetails);
	      return match ? match[1].split(reSplitDetails) : [];
	    }

	    /**
	     * Checks if `path` exists on `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @param {Function} hasFunc The function to check properties.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     */
	    function hasPath(object, path, hasFunc) {
	      path = castPath(path, object);

	      var index = -1,
	          length = path.length,
	          result = false;

	      while (++index < length) {
	        var key = toKey(path[index]);
	        if (!(result = object != null && hasFunc(object, key))) {
	          break;
	        }
	        object = object[key];
	      }
	      if (result || ++index != length) {
	        return result;
	      }
	      length = object == null ? 0 : object.length;
	      return !!length && isLength(length) && isIndex(key, length) &&
	        (isArray(object) || isArguments(object));
	    }

	    /**
	     * Initializes an array clone.
	     *
	     * @private
	     * @param {Array} array The array to clone.
	     * @returns {Array} Returns the initialized clone.
	     */
	    function initCloneArray(array) {
	      var length = array.length,
	          result = new array.constructor(length);

	      // Add properties assigned by `RegExp#exec`.
	      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	        result.index = array.index;
	        result.input = array.input;
	      }
	      return result;
	    }

	    /**
	     * Initializes an object clone.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneObject(object) {
	      return (typeof object.constructor == 'function' && !isPrototype(object))
	        ? baseCreate(getPrototype(object))
	        : {};
	    }

	    /**
	     * Initializes an object clone based on its `toStringTag`.
	     *
	     * **Note:** This function only supports cloning values with tags of
	     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @param {string} tag The `toStringTag` of the object to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneByTag(object, tag, isDeep) {
	      var Ctor = object.constructor;
	      switch (tag) {
	        case arrayBufferTag:
	          return cloneArrayBuffer(object);

	        case boolTag:
	        case dateTag:
	          return new Ctor(+object);

	        case dataViewTag:
	          return cloneDataView(object, isDeep);

	        case float32Tag: case float64Tag:
	        case int8Tag: case int16Tag: case int32Tag:
	        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	          return cloneTypedArray(object, isDeep);

	        case mapTag:
	          return new Ctor;

	        case numberTag:
	        case stringTag:
	          return new Ctor(object);

	        case regexpTag:
	          return cloneRegExp(object);

	        case setTag:
	          return new Ctor;

	        case symbolTag:
	          return cloneSymbol(object);
	      }
	    }

	    /**
	     * Inserts wrapper `details` in a comment at the top of the `source` body.
	     *
	     * @private
	     * @param {string} source The source to modify.
	     * @returns {Array} details The details to insert.
	     * @returns {string} Returns the modified source.
	     */
	    function insertWrapDetails(source, details) {
	      var length = details.length;
	      if (!length) {
	        return source;
	      }
	      var lastIndex = length - 1;
	      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
	      details = details.join(length > 2 ? ', ' : ' ');
	      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
	    }

	    /**
	     * Checks if `value` is a flattenable `arguments` object or array.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	     */
	    function isFlattenable(value) {
	      return isArray(value) || isArguments(value) ||
	        !!(spreadableSymbol && value && value[spreadableSymbol]);
	    }

	    /**
	     * Checks if `value` is a valid array-like index.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	     */
	    function isIndex(value, length) {
	      var type = typeof value;
	      length = length == null ? MAX_SAFE_INTEGER : length;

	      return !!length &&
	        (type == 'number' ||
	          (type != 'symbol' && reIsUint.test(value))) &&
	            (value > -1 && value % 1 == 0 && value < length);
	    }

	    /**
	     * Checks if the given arguments are from an iteratee call.
	     *
	     * @private
	     * @param {*} value The potential iteratee value argument.
	     * @param {*} index The potential iteratee index or key argument.
	     * @param {*} object The potential iteratee object argument.
	     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	     *  else `false`.
	     */
	    function isIterateeCall(value, index, object) {
	      if (!isObject(object)) {
	        return false;
	      }
	      var type = typeof index;
	      if (type == 'number'
	            ? (isArrayLike(object) && isIndex(index, object.length))
	            : (type == 'string' && index in object)
	          ) {
	        return eq(object[index], value);
	      }
	      return false;
	    }

	    /**
	     * Checks if `value` is a property name and not a property path.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	     */
	    function isKey(value, object) {
	      if (isArray(value)) {
	        return false;
	      }
	      var type = typeof value;
	      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	          value == null || isSymbol(value)) {
	        return true;
	      }
	      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	        (object != null && value in Object(object));
	    }

	    /**
	     * Checks if `value` is suitable for use as unique object key.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	     */
	    function isKeyable(value) {
	      var type = typeof value;
	      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	        ? (value !== '__proto__')
	        : (value === null);
	    }

	    /**
	     * Checks if `func` has a lazy counterpart.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
	     *  else `false`.
	     */
	    function isLaziable(func) {
	      var funcName = getFuncName(func),
	          other = lodash[funcName];

	      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
	        return false;
	      }
	      if (func === other) {
	        return true;
	      }
	      var data = getData(other);
	      return !!data && func === data[0];
	    }

	    /**
	     * Checks if `func` has its source masked.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	     */
	    function isMasked(func) {
	      return !!maskSrcKey && (maskSrcKey in func);
	    }

	    /**
	     * Checks if `func` is capable of being masked.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
	     */
	    var isMaskable = coreJsData ? isFunction : stubFalse;

	    /**
	     * Checks if `value` is likely a prototype object.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	     */
	    function isPrototype(value) {
	      var Ctor = value && value.constructor,
	          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

	      return value === proto;
	    }

	    /**
	     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` if suitable for strict
	     *  equality comparisons, else `false`.
	     */
	    function isStrictComparable(value) {
	      return value === value && !isObject(value);
	    }

	    /**
	     * A specialized version of `matchesProperty` for source values suitable
	     * for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {string} key The key of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function matchesStrictComparable(key, srcValue) {
	      return function(object) {
	        if (object == null) {
	          return false;
	        }
	        return object[key] === srcValue &&
	          (srcValue !== undefined || (key in Object(object)));
	      };
	    }

	    /**
	     * A specialized version of `_.memoize` which clears the memoized function's
	     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	     *
	     * @private
	     * @param {Function} func The function to have its output memoized.
	     * @returns {Function} Returns the new memoized function.
	     */
	    function memoizeCapped(func) {
	      var result = memoize(func, function(key) {
	        if (cache.size === MAX_MEMOIZE_SIZE) {
	          cache.clear();
	        }
	        return key;
	      });

	      var cache = result.cache;
	      return result;
	    }

	    /**
	     * Merges the function metadata of `source` into `data`.
	     *
	     * Merging metadata reduces the number of wrappers used to invoke a function.
	     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
	     * may be applied regardless of execution order. Methods like `_.ary` and
	     * `_.rearg` modify function arguments, making the order in which they are
	     * executed important, preventing the merging of metadata. However, we make
	     * an exception for a safe combined case where curried functions have `_.ary`
	     * and or `_.rearg` applied.
	     *
	     * @private
	     * @param {Array} data The destination metadata.
	     * @param {Array} source The source metadata.
	     * @returns {Array} Returns `data`.
	     */
	    function mergeData(data, source) {
	      var bitmask = data[1],
	          srcBitmask = source[1],
	          newBitmask = bitmask | srcBitmask,
	          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

	      var isCombo =
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
	        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

	      // Exit early if metadata can't be merged.
	      if (!(isCommon || isCombo)) {
	        return data;
	      }
	      // Use source `thisArg` if available.
	      if (srcBitmask & WRAP_BIND_FLAG) {
	        data[2] = source[2];
	        // Set when currying a bound function.
	        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
	      }
	      // Compose partial arguments.
	      var value = source[3];
	      if (value) {
	        var partials = data[3];
	        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
	        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
	      }
	      // Compose partial right arguments.
	      value = source[5];
	      if (value) {
	        partials = data[5];
	        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
	        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
	      }
	      // Use source `argPos` if available.
	      value = source[7];
	      if (value) {
	        data[7] = value;
	      }
	      // Use source `ary` if it's smaller.
	      if (srcBitmask & WRAP_ARY_FLAG) {
	        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
	      }
	      // Use source `arity` if one is not provided.
	      if (data[9] == null) {
	        data[9] = source[9];
	      }
	      // Use source `func` and merge bitmasks.
	      data[0] = source[0];
	      data[1] = newBitmask;

	      return data;
	    }

	    /**
	     * This function is like
	     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * except that it includes inherited enumerable properties.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function nativeKeysIn(object) {
	      var result = [];
	      if (object != null) {
	        for (var key in Object(object)) {
	          result.push(key);
	        }
	      }
	      return result;
	    }

	    /**
	     * Converts `value` to a string using `Object.prototype.toString`.
	     *
	     * @private
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     */
	    function objectToString(value) {
	      return nativeObjectToString.call(value);
	    }

	    /**
	     * A specialized version of `baseRest` which transforms the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @param {Function} transform The rest array transform.
	     * @returns {Function} Returns the new function.
	     */
	    function overRest(func, start, transform) {
	      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	      return function() {
	        var args = arguments,
	            index = -1,
	            length = nativeMax(args.length - start, 0),
	            array = Array(length);

	        while (++index < length) {
	          array[index] = args[start + index];
	        }
	        index = -1;
	        var otherArgs = Array(start + 1);
	        while (++index < start) {
	          otherArgs[index] = args[index];
	        }
	        otherArgs[start] = transform(array);
	        return apply(func, this, otherArgs);
	      };
	    }

	    /**
	     * Gets the parent value at `path` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array} path The path to get the parent value of.
	     * @returns {*} Returns the parent value.
	     */
	    function parent(object, path) {
	      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
	    }

	    /**
	     * Reorder `array` according to the specified indexes where the element at
	     * the first index is assigned as the first element, the element at
	     * the second index is assigned as the second element, and so on.
	     *
	     * @private
	     * @param {Array} array The array to reorder.
	     * @param {Array} indexes The arranged array indexes.
	     * @returns {Array} Returns `array`.
	     */
	    function reorder(array, indexes) {
	      var arrLength = array.length,
	          length = nativeMin(indexes.length, arrLength),
	          oldArray = copyArray(array);

	      while (length--) {
	        var index = indexes[length];
	        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
	      }
	      return array;
	    }

	    /**
	     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the property to get.
	     * @returns {*} Returns the property value.
	     */
	    function safeGet(object, key) {
	      if (key === 'constructor' && typeof object[key] === 'function') {
	        return;
	      }

	      if (key == '__proto__') {
	        return;
	      }

	      return object[key];
	    }

	    /**
	     * Sets metadata for `func`.
	     *
	     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
	     * period of time, it will trip its breaker and transition to an identity
	     * function to avoid garbage collection pauses in V8. See
	     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
	     * for more details.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var setData = shortOut(baseSetData);

	    /**
	     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    var setTimeout = ctxSetTimeout || function(func, wait) {
	      return root.setTimeout(func, wait);
	    };

	    /**
	     * Sets the `toString` method of `func` to return `string`.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var setToString = shortOut(baseSetToString);

	    /**
	     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
	     * with wrapper details in a comment at the top of the source body.
	     *
	     * @private
	     * @param {Function} wrapper The function to modify.
	     * @param {Function} reference The reference function.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Function} Returns `wrapper`.
	     */
	    function setWrapToString(wrapper, reference, bitmask) {
	      var source = (reference + '');
	      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
	    }

	    /**
	     * Creates a function that'll short out and invoke `identity` instead
	     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	     * milliseconds.
	     *
	     * @private
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new shortable function.
	     */
	    function shortOut(func) {
	      var count = 0,
	          lastCalled = 0;

	      return function() {
	        var stamp = nativeNow(),
	            remaining = HOT_SPAN - (stamp - lastCalled);

	        lastCalled = stamp;
	        if (remaining > 0) {
	          if (++count >= HOT_COUNT) {
	            return arguments[0];
	          }
	        } else {
	          count = 0;
	        }
	        return func.apply(undefined, arguments);
	      };
	    }

	    /**
	     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @param {number} [size=array.length] The size of `array`.
	     * @returns {Array} Returns `array`.
	     */
	    function shuffleSelf(array, size) {
	      var index = -1,
	          length = array.length,
	          lastIndex = length - 1;

	      size = size === undefined ? length : size;
	      while (++index < size) {
	        var rand = baseRandom(index, lastIndex),
	            value = array[rand];

	        array[rand] = array[index];
	        array[index] = value;
	      }
	      array.length = size;
	      return array;
	    }

	    /**
	     * Converts `string` to a property path array.
	     *
	     * @private
	     * @param {string} string The string to convert.
	     * @returns {Array} Returns the property path array.
	     */
	    var stringToPath = memoizeCapped(function(string) {
	      var result = [];
	      if (string.charCodeAt(0) === 46 /* . */) {
	        result.push('');
	      }
	      string.replace(rePropName, function(match, number, quote, subString) {
	        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
	      });
	      return result;
	    });

	    /**
	     * Converts `value` to a string key if it's not a string or symbol.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {string|symbol} Returns the key.
	     */
	    function toKey(value) {
	      if (typeof value == 'string' || isSymbol(value)) {
	        return value;
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }

	    /**
	     * Converts `func` to its source code.
	     *
	     * @private
	     * @param {Function} func The function to convert.
	     * @returns {string} Returns the source code.
	     */
	    function toSource(func) {
	      if (func != null) {
	        try {
	          return funcToString.call(func);
	        } catch (e) {}
	        try {
	          return (func + '');
	        } catch (e) {}
	      }
	      return '';
	    }

	    /**
	     * Updates wrapper `details` based on `bitmask` flags.
	     *
	     * @private
	     * @returns {Array} details The details to modify.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Array} Returns `details`.
	     */
	    function updateWrapDetails(details, bitmask) {
	      arrayEach(wrapFlags, function(pair) {
	        var value = '_.' + pair[0];
	        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
	          details.push(value);
	        }
	      });
	      return details.sort();
	    }

	    /**
	     * Creates a clone of `wrapper`.
	     *
	     * @private
	     * @param {Object} wrapper The wrapper to clone.
	     * @returns {Object} Returns the cloned wrapper.
	     */
	    function wrapperClone(wrapper) {
	      if (wrapper instanceof LazyWrapper) {
	        return wrapper.clone();
	      }
	      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
	      result.__actions__ = copyArray(wrapper.__actions__);
	      result.__index__  = wrapper.__index__;
	      result.__values__ = wrapper.__values__;
	      return result;
	    }

	    /*------------------------------------------------------------------------*/

	    /**
	     * Creates an array of elements split into groups the length of `size`.
	     * If `array` can't be split evenly, the final chunk will be the remaining
	     * elements.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to process.
	     * @param {number} [size=1] The length of each chunk
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the new array of chunks.
	     * @example
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 2);
	     * // => [['a', 'b'], ['c', 'd']]
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 3);
	     * // => [['a', 'b', 'c'], ['d']]
	     */
	    function chunk(array, size, guard) {
	      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
	        size = 1;
	      } else {
	        size = nativeMax(toInteger(size), 0);
	      }
	      var length = array == null ? 0 : array.length;
	      if (!length || size < 1) {
	        return [];
	      }
	      var index = 0,
	          resIndex = 0,
	          result = Array(nativeCeil(length / size));

	      while (index < length) {
	        result[resIndex++] = baseSlice(array, index, (index += size));
	      }
	      return result;
	    }

	    /**
	     * Creates an array with all falsey values removed. The values `false`, `null`,
	     * `0`, `""`, `undefined`, and `NaN` are falsey.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to compact.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.compact([0, 1, false, 2, '', 3]);
	     * // => [1, 2, 3]
	     */
	    function compact(array) {
	      var index = -1,
	          length = array == null ? 0 : array.length,
	          resIndex = 0,
	          result = [];

	      while (++index < length) {
	        var value = array[index];
	        if (value) {
	          result[resIndex++] = value;
	        }
	      }
	      return result;
	    }

	    /**
	     * Creates a new array concatenating `array` with any additional arrays
	     * and/or values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to concatenate.
	     * @param {...*} [values] The values to concatenate.
	     * @returns {Array} Returns the new concatenated array.
	     * @example
	     *
	     * var array = [1];
	     * var other = _.concat(array, 2, [3], [[4]]);
	     *
	     * console.log(other);
	     * // => [1, 2, 3, [4]]
	     *
	     * console.log(array);
	     * // => [1]
	     */
	    function concat() {
	      var arguments$1 = arguments;

	      var length = arguments.length;
	      if (!length) {
	        return [];
	      }
	      var args = Array(length - 1),
	          array = arguments[0],
	          index = length;

	      while (index--) {
	        args[index - 1] = arguments$1[index];
	      }
	      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
	    }

	    /**
	     * Creates an array of `array` values not included in the other given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * **Note:** Unlike `_.pullAll`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.without, _.xor
	     * @example
	     *
	     * _.difference([2, 1], [2, 3]);
	     * // => [1]
	     */
	    var difference = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
	        : [];
	    });

	    /**
	     * This method is like `_.difference` except that it accepts `iteratee` which
	     * is invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var differenceBy = baseRest(function(array, values) {
	      var iteratee = last(values);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
	        : [];
	    });

	    /**
	     * This method is like `_.difference` except that it accepts `comparator`
	     * which is invoked to compare elements of `array` to `values`. The order and
	     * references of result values are determined by the first array. The comparator
	     * is invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     *
	     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }]
	     */
	    var differenceWith = baseRest(function(array, values) {
	      var comparator = last(values);
	      if (isArrayLikeObject(comparator)) {
	        comparator = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
	        : [];
	    });

	    /**
	     * Creates a slice of `array` with `n` elements dropped from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.drop([1, 2, 3]);
	     * // => [2, 3]
	     *
	     * _.drop([1, 2, 3], 2);
	     * // => [3]
	     *
	     * _.drop([1, 2, 3], 5);
	     * // => []
	     *
	     * _.drop([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function drop(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }

	    /**
	     * Creates a slice of `array` with `n` elements dropped from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropRight([1, 2, 3]);
	     * // => [1, 2]
	     *
	     * _.dropRight([1, 2, 3], 2);
	     * // => [1]
	     *
	     * _.dropRight([1, 2, 3], 5);
	     * // => []
	     *
	     * _.dropRight([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function dropRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }

	    /**
	     * Creates a slice of `array` excluding elements dropped from the end.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.dropRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropRightWhile(users, ['active', false]);
	     * // => objects for ['barney']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropRightWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true, true)
	        : [];
	    }

	    /**
	     * Creates a slice of `array` excluding elements dropped from the beginning.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.dropWhile(users, function(o) { return !o.active; });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropWhile(users, ['active', false]);
	     * // => objects for ['pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true)
	        : [];
	    }

	    /**
	     * Fills elements of `array` with `value` from `start` up to, but not
	     * including, `end`.
	     *
	     * **Note:** This method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Array
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.fill(array, 'a');
	     * console.log(array);
	     * // => ['a', 'a', 'a']
	     *
	     * _.fill(Array(3), 2);
	     * // => [2, 2, 2]
	     *
	     * _.fill([4, 6, 8, 10], '*', 1, 3);
	     * // => [4, '*', '*', 10]
	     */
	    function fill(array, value, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
	        start = 0;
	        end = length;
	      }
	      return baseFill(array, value, start, end);
	    }

	    /**
	     * This method is like `_.find` except that it returns the index of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.findIndex(users, function(o) { return o.user == 'barney'; });
	     * // => 0
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findIndex(users, { 'user': 'fred', 'active': false });
	     * // => 1
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findIndex(users, ['active', false]);
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findIndex(users, 'active');
	     * // => 2
	     */
	    function findIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index);
	    }

	    /**
	     * This method is like `_.findIndex` except that it iterates over elements
	     * of `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
	     * // => 2
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
	     * // => 0
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastIndex(users, ['active', false]);
	     * // => 2
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastIndex(users, 'active');
	     * // => 0
	     */
	    function findLastIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length - 1;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = fromIndex < 0
	          ? nativeMax(length + index, 0)
	          : nativeMin(index, length - 1);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
	    }

	    /**
	     * Flattens `array` a single level deep.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flatten([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, [3, [4]], 5]
	     */
	    function flatten(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, 1) : [];
	    }

	    /**
	     * Recursively flattens `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flattenDeep([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, 3, 4, 5]
	     */
	    function flattenDeep(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, INFINITY) : [];
	    }

	    /**
	     * Recursively flatten `array` up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * var array = [1, [2, [3, [4]], 5]];
	     *
	     * _.flattenDepth(array, 1);
	     * // => [1, 2, [3, [4]], 5]
	     *
	     * _.flattenDepth(array, 2);
	     * // => [1, 2, 3, [4], 5]
	     */
	    function flattenDepth(array, depth) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(array, depth);
	    }

	    /**
	     * The inverse of `_.toPairs`; this method returns an object composed
	     * from key-value `pairs`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} pairs The key-value pairs.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.fromPairs([['a', 1], ['b', 2]]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function fromPairs(pairs) {
	      var index = -1,
	          length = pairs == null ? 0 : pairs.length,
	          result = {};

	      while (++index < length) {
	        var pair = pairs[index];
	        result[pair[0]] = pair[1];
	      }
	      return result;
	    }

	    /**
	     * Gets the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias first
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the first element of `array`.
	     * @example
	     *
	     * _.head([1, 2, 3]);
	     * // => 1
	     *
	     * _.head([]);
	     * // => undefined
	     */
	    function head(array) {
	      return (array && array.length) ? array[0] : undefined;
	    }

	    /**
	     * Gets the index at which the first occurrence of `value` is found in `array`
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. If `fromIndex` is negative, it's used as the
	     * offset from the end of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.indexOf([1, 2, 1, 2], 2);
	     * // => 1
	     *
	     * // Search from the `fromIndex`.
	     * _.indexOf([1, 2, 1, 2], 2, 2);
	     * // => 3
	     */
	    function indexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseIndexOf(array, value, index);
	    }

	    /**
	     * Gets all but the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.initial([1, 2, 3]);
	     * // => [1, 2]
	     */
	    function initial(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 0, -1) : [];
	    }

	    /**
	     * Creates an array of unique values that are included in all given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersection([2, 1], [2, 3]);
	     * // => [2]
	     */
	    var intersection = baseRest(function(arrays) {
	      var mapped = arrayMap(arrays, castArrayLikeObject);
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped)
	        : [];
	    });

	    /**
	     * This method is like `_.intersection` except that it accepts `iteratee`
	     * which is invoked for each element of each `arrays` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [2.1]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }]
	     */
	    var intersectionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);

	      if (iteratee === last(mapped)) {
	        iteratee = undefined;
	      } else {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, getIteratee(iteratee, 2))
	        : [];
	    });

	    /**
	     * This method is like `_.intersection` except that it accepts `comparator`
	     * which is invoked to compare elements of `arrays`. The order and references
	     * of result values are determined by the first array. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.intersectionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }]
	     */
	    var intersectionWith = baseRest(function(arrays) {
	      var comparator = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);

	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      if (comparator) {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, undefined, comparator)
	        : [];
	    });

	    /**
	     * Converts all elements in `array` into a string separated by `separator`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to convert.
	     * @param {string} [separator=','] The element separator.
	     * @returns {string} Returns the joined string.
	     * @example
	     *
	     * _.join(['a', 'b', 'c'], '~');
	     * // => 'a~b~c'
	     */
	    function join(array, separator) {
	      return array == null ? '' : nativeJoin.call(array, separator);
	    }

	    /**
	     * Gets the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the last element of `array`.
	     * @example
	     *
	     * _.last([1, 2, 3]);
	     * // => 3
	     */
	    function last(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? array[length - 1] : undefined;
	    }

	    /**
	     * This method is like `_.indexOf` except that it iterates over elements of
	     * `array` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.lastIndexOf([1, 2, 1, 2], 2);
	     * // => 3
	     *
	     * // Search from the `fromIndex`.
	     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
	     * // => 1
	     */
	    function lastIndexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
	      }
	      return value === value
	        ? strictLastIndexOf(array, value, index)
	        : baseFindIndex(array, baseIsNaN, index, true);
	    }

	    /**
	     * Gets the element at index `n` of `array`. If `n` is negative, the nth
	     * element from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.11.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=0] The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     *
	     * _.nth(array, 1);
	     * // => 'b'
	     *
	     * _.nth(array, -2);
	     * // => 'c';
	     */
	    function nth(array, n) {
	      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
	    }

	    /**
	     * Removes all given values from `array` using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
	     * to remove elements from an array by predicate.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...*} [values] The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pull(array, 'a', 'c');
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    var pull = baseRest(pullAll);

	    /**
	     * This method is like `_.pull` except that it accepts an array of values to remove.
	     *
	     * **Note:** Unlike `_.difference`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pullAll(array, ['a', 'c']);
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    function pullAll(array, values) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values)
	        : array;
	    }

	    /**
	     * This method is like `_.pullAll` except that it accepts `iteratee` which is
	     * invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The iteratee is invoked with one argument: (value).
	     *
	     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
	     *
	     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
	     * console.log(array);
	     * // => [{ 'x': 2 }]
	     */
	    function pullAllBy(array, values, iteratee) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, getIteratee(iteratee, 2))
	        : array;
	    }

	    /**
	     * This method is like `_.pullAll` except that it accepts `comparator` which
	     * is invoked to compare elements of `array` to `values`. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
	     *
	     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
	     * console.log(array);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
	     */
	    function pullAllWith(array, values, comparator) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, undefined, comparator)
	        : array;
	    }

	    /**
	     * Removes elements from `array` corresponding to `indexes` and returns an
	     * array of removed elements.
	     *
	     * **Note:** Unlike `_.at`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     * var pulled = _.pullAt(array, [1, 3]);
	     *
	     * console.log(array);
	     * // => ['a', 'c']
	     *
	     * console.log(pulled);
	     * // => ['b', 'd']
	     */
	    var pullAt = flatRest(function(array, indexes) {
	      var length = array == null ? 0 : array.length,
	          result = baseAt(array, indexes);

	      basePullAt(array, arrayMap(indexes, function(index) {
	        return isIndex(index, length) ? +index : index;
	      }).sort(compareAscending));

	      return result;
	    });

	    /**
	     * Removes all elements from `array` that `predicate` returns truthy for
	     * and returns an array of the removed elements. The predicate is invoked
	     * with three arguments: (value, index, array).
	     *
	     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
	     * to pull elements from an array by value.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = [1, 2, 3, 4];
	     * var evens = _.remove(array, function(n) {
	     *   return n % 2 == 0;
	     * });
	     *
	     * console.log(array);
	     * // => [1, 3]
	     *
	     * console.log(evens);
	     * // => [2, 4]
	     */
	    function remove(array, predicate) {
	      var result = [];
	      if (!(array && array.length)) {
	        return result;
	      }
	      var index = -1,
	          indexes = [],
	          length = array.length;

	      predicate = getIteratee(predicate, 3);
	      while (++index < length) {
	        var value = array[index];
	        if (predicate(value, index, array)) {
	          result.push(value);
	          indexes.push(index);
	        }
	      }
	      basePullAt(array, indexes);
	      return result;
	    }

	    /**
	     * Reverses `array` so that the first element becomes the last, the second
	     * element becomes the second to last, and so on.
	     *
	     * **Note:** This method mutates `array` and is based on
	     * [`Array#reverse`](https://mdn.io/Array/reverse).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.reverse(array);
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function reverse(array) {
	      return array == null ? array : nativeReverse.call(array);
	    }

	    /**
	     * Creates a slice of `array` from `start` up to, but not including, `end`.
	     *
	     * **Note:** This method is used instead of
	     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
	     * returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function slice(array, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
	        start = 0;
	        end = length;
	      }
	      else {
	        start = start == null ? 0 : toInteger(start);
	        end = end === undefined ? length : toInteger(end);
	      }
	      return baseSlice(array, start, end);
	    }

	    /**
	     * Uses a binary search to determine the lowest index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedIndex([30, 50], 40);
	     * // => 1
	     */
	    function sortedIndex(array, value) {
	      return baseSortedIndex(array, value);
	    }

	    /**
	     * This method is like `_.sortedIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 0
	     */
	    function sortedIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
	    }

	    /**
	     * This method is like `_.indexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 1
	     */
	    function sortedIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value);
	        if (index < length && eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }

	    /**
	     * This method is like `_.sortedIndex` except that it returns the highest
	     * index at which `value` should be inserted into `array` in order to
	     * maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
	     * // => 4
	     */
	    function sortedLastIndex(array, value) {
	      return baseSortedIndex(array, value, true);
	    }

	    /**
	     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 1
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 1
	     */
	    function sortedLastIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
	    }

	    /**
	     * This method is like `_.lastIndexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 3
	     */
	    function sortedLastIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value, true) - 1;
	        if (eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }

	    /**
	     * This method is like `_.uniq` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniq([1, 1, 2]);
	     * // => [1, 2]
	     */
	    function sortedUniq(array) {
	      return (array && array.length)
	        ? baseSortedUniq(array)
	        : [];
	    }

	    /**
	     * This method is like `_.uniqBy` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
	     * // => [1.1, 2.3]
	     */
	    function sortedUniqBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSortedUniq(array, getIteratee(iteratee, 2))
	        : [];
	    }

	    /**
	     * Gets all but the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.tail([1, 2, 3]);
	     * // => [2, 3]
	     */
	    function tail(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 1, length) : [];
	    }

	    /**
	     * Creates a slice of `array` with `n` elements taken from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.take([1, 2, 3]);
	     * // => [1]
	     *
	     * _.take([1, 2, 3], 2);
	     * // => [1, 2]
	     *
	     * _.take([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.take([1, 2, 3], 0);
	     * // => []
	     */
	    function take(array, n, guard) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }

	    /**
	     * Creates a slice of `array` with `n` elements taken from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeRight([1, 2, 3]);
	     * // => [3]
	     *
	     * _.takeRight([1, 2, 3], 2);
	     * // => [2, 3]
	     *
	     * _.takeRight([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.takeRight([1, 2, 3], 0);
	     * // => []
	     */
	    function takeRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }

	    /**
	     * Creates a slice of `array` with elements taken from the end. Elements are
	     * taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.takeRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeRightWhile(users, ['active', false]);
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeRightWhile(users, 'active');
	     * // => []
	     */
	    function takeRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), false, true)
	        : [];
	    }

	    /**
	     * Creates a slice of `array` with elements taken from the beginning. Elements
	     * are taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.takeWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeWhile(users, ['active', false]);
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeWhile(users, 'active');
	     * // => []
	     */
	    function takeWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3))
	        : [];
	    }

	    /**
	     * Creates an array of unique values, in order, from all given arrays using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.union([2], [1, 2]);
	     * // => [2, 1]
	     */
	    var union = baseRest(function(arrays) {
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
	    });

	    /**
	     * This method is like `_.union` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which uniqueness is computed. Result values are chosen from the first
	     * array in which the value occurs. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    var unionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
	    });

	    /**
	     * This method is like `_.union` except that it accepts `comparator` which
	     * is invoked to compare elements of `arrays`. Result values are chosen from
	     * the first array in which the value occurs. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.unionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var unionWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
	    });

	    /**
	     * Creates a duplicate-free version of an array, using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons, in which only the first occurrence of each element
	     * is kept. The order of result values is determined by the order they occur
	     * in the array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniq([2, 1, 2]);
	     * // => [2, 1]
	     */
	    function uniq(array) {
	      return (array && array.length) ? baseUniq(array) : [];
	    }

	    /**
	     * This method is like `_.uniq` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * uniqueness is computed. The order of result values is determined by the
	     * order they occur in the array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    function uniqBy(array, iteratee) {
	      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
	    }

	    /**
	     * This method is like `_.uniq` except that it accepts `comparator` which
	     * is invoked to compare elements of `array`. The order of result values is
	     * determined by the order they occur in the array.The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.uniqWith(objects, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
	     */
	    function uniqWith(array, comparator) {
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
	    }

	    /**
	     * This method is like `_.zip` except that it accepts an array of grouped
	     * elements and creates an array regrouping the elements to their pre-zip
	     * configuration.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.2.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     *
	     * _.unzip(zipped);
	     * // => [['a', 'b'], [1, 2], [true, false]]
	     */
	    function unzip(array) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var length = 0;
	      array = arrayFilter(array, function(group) {
	        if (isArrayLikeObject(group)) {
	          length = nativeMax(group.length, length);
	          return true;
	        }
	      });
	      return baseTimes(length, function(index) {
	        return arrayMap(array, baseProperty(index));
	      });
	    }

	    /**
	     * This method is like `_.unzip` except that it accepts `iteratee` to specify
	     * how regrouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  regrouped values.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
	     * // => [[1, 10, 100], [2, 20, 200]]
	     *
	     * _.unzipWith(zipped, _.add);
	     * // => [3, 30, 300]
	     */
	    function unzipWith(array, iteratee) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var result = unzip(array);
	      if (iteratee == null) {
	        return result;
	      }
	      return arrayMap(result, function(group) {
	        return apply(iteratee, undefined, group);
	      });
	    }

	    /**
	     * Creates an array excluding all given values using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.pull`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...*} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.xor
	     * @example
	     *
	     * _.without([2, 1, 2, 3], 1, 2);
	     * // => [3]
	     */
	    var without = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, values)
	        : [];
	    });

	    /**
	     * Creates an array of unique values that is the
	     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
	     * of the given arrays. The order of result values is determined by the order
	     * they occur in the arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.without
	     * @example
	     *
	     * _.xor([2, 1], [2, 3]);
	     * // => [1, 3]
	     */
	    var xor = baseRest(function(arrays) {
	      return baseXor(arrayFilter(arrays, isArrayLikeObject));
	    });

	    /**
	     * This method is like `_.xor` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which by which they're compared. The order of result values is determined
	     * by the order they occur in the arrays. The iteratee is invoked with one
	     * argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2, 3.4]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var xorBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
	    });

	    /**
	     * This method is like `_.xor` except that it accepts `comparator` which is
	     * invoked to compare elements of `arrays`. The order of result values is
	     * determined by the order they occur in the arrays. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.xorWith(objects, others, _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var xorWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
	    });

	    /**
	     * Creates an array of grouped elements, the first of which contains the
	     * first elements of the given arrays, the second of which contains the
	     * second elements of the given arrays, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     */
	    var zip = baseRest(unzip);

	    /**
	     * This method is like `_.fromPairs` except that it accepts two arrays,
	     * one of property identifiers and one of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.4.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObject(['a', 'b'], [1, 2]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function zipObject(props, values) {
	      return baseZipObject(props || [], values || [], assignValue);
	    }

	    /**
	     * This method is like `_.zipObject` except that it supports property paths.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
	     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
	     */
	    function zipObjectDeep(props, values) {
	      return baseZipObject(props || [], values || [], baseSet);
	    }

	    /**
	     * This method is like `_.zip` except that it accepts `iteratee` to specify
	     * how grouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  grouped values.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
	     *   return a + b + c;
	     * });
	     * // => [111, 222]
	     */
	    var zipWith = baseRest(function(arrays) {
	      var length = arrays.length,
	          iteratee = length > 1 ? arrays[length - 1] : undefined;

	      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
	      return unzipWith(arrays, iteratee);
	    });

	    /*------------------------------------------------------------------------*/

	    /**
	     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
	     * chain sequences enabled. The result of such sequences must be unwrapped
	     * with `_#value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Seq
	     * @param {*} value The value to wrap.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36 },
	     *   { 'user': 'fred',    'age': 40 },
	     *   { 'user': 'pebbles', 'age': 1 }
	     * ];
	     *
	     * var youngest = _
	     *   .chain(users)
	     *   .sortBy('age')
	     *   .map(function(o) {
	     *     return o.user + ' is ' + o.age;
	     *   })
	     *   .head()
	     *   .value();
	     * // => 'pebbles is 1'
	     */
	    function chain(value) {
	      var result = lodash(value);
	      result.__chain__ = true;
	      return result;
	    }

	    /**
	     * This method invokes `interceptor` and returns `value`. The interceptor
	     * is invoked with one argument; (value). The purpose of this method is to
	     * "tap into" a method chain sequence in order to modify intermediate results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * _([1, 2, 3])
	     *  .tap(function(array) {
	     *    // Mutate input array.
	     *    array.pop();
	     *  })
	     *  .reverse()
	     *  .value();
	     * // => [2, 1]
	     */
	    function tap(value, interceptor) {
	      interceptor(value);
	      return value;
	    }

	    /**
	     * This method is like `_.tap` except that it returns the result of `interceptor`.
	     * The purpose of this method is to "pass thru" values replacing intermediate
	     * results in a method chain sequence.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns the result of `interceptor`.
	     * @example
	     *
	     * _('  abc  ')
	     *  .chain()
	     *  .trim()
	     *  .thru(function(value) {
	     *    return [value];
	     *  })
	     *  .value();
	     * // => ['abc']
	     */
	    function thru(value, interceptor) {
	      return interceptor(value);
	    }

	    /**
	     * This method is the wrapper version of `_.at`.
	     *
	     * @name at
	     * @memberOf _
	     * @since 1.0.0
	     * @category Seq
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _(object).at(['a[0].b.c', 'a[1]']).value();
	     * // => [3, 4]
	     */
	    var wrapperAt = flatRest(function(paths) {
	      var length = paths.length,
	          start = length ? paths[0] : 0,
	          value = this.__wrapped__,
	          interceptor = function(object) { return baseAt(object, paths); };

	      if (length > 1 || this.__actions__.length ||
	          !(value instanceof LazyWrapper) || !isIndex(start)) {
	        return this.thru(interceptor);
	      }
	      value = value.slice(start, +start + (length ? 1 : 0));
	      value.__actions__.push({
	        'func': thru,
	        'args': [interceptor],
	        'thisArg': undefined
	      });
	      return new LodashWrapper(value, this.__chain__).thru(function(array) {
	        if (length && !array.length) {
	          array.push(undefined);
	        }
	        return array;
	      });
	    });

	    /**
	     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
	     *
	     * @name chain
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * // A sequence without explicit chaining.
	     * _(users).head();
	     * // => { 'user': 'barney', 'age': 36 }
	     *
	     * // A sequence with explicit chaining.
	     * _(users)
	     *   .chain()
	     *   .head()
	     *   .pick('user')
	     *   .value();
	     * // => { 'user': 'barney' }
	     */
	    function wrapperChain() {
	      return chain(this);
	    }

	    /**
	     * Executes the chain sequence and returns the wrapped result.
	     *
	     * @name commit
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2];
	     * var wrapped = _(array).push(3);
	     *
	     * console.log(array);
	     * // => [1, 2]
	     *
	     * wrapped = wrapped.commit();
	     * console.log(array);
	     * // => [1, 2, 3]
	     *
	     * wrapped.last();
	     * // => 3
	     *
	     * console.log(array);
	     * // => [1, 2, 3]
	     */
	    function wrapperCommit() {
	      return new LodashWrapper(this.value(), this.__chain__);
	    }

	    /**
	     * Gets the next value on a wrapped object following the
	     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
	     *
	     * @name next
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the next iterator value.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 1 }
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 2 }
	     *
	     * wrapped.next();
	     * // => { 'done': true, 'value': undefined }
	     */
	    function wrapperNext() {
	      if (this.__values__ === undefined) {
	        this.__values__ = toArray(this.value());
	      }
	      var done = this.__index__ >= this.__values__.length,
	          value = done ? undefined : this.__values__[this.__index__++];

	      return { 'done': done, 'value': value };
	    }

	    /**
	     * Enables the wrapper to be iterable.
	     *
	     * @name Symbol.iterator
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the wrapper object.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped[Symbol.iterator]() === wrapped;
	     * // => true
	     *
	     * Array.from(wrapped);
	     * // => [1, 2]
	     */
	    function wrapperToIterator() {
	      return this;
	    }

	    /**
	     * Creates a clone of the chain sequence planting `value` as the wrapped value.
	     *
	     * @name plant
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @param {*} value The value to plant.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2]).map(square);
	     * var other = wrapped.plant([3, 4]);
	     *
	     * other.value();
	     * // => [9, 16]
	     *
	     * wrapped.value();
	     * // => [1, 4]
	     */
	    function wrapperPlant(value) {
	      var result,
	          parent = this;

	      while (parent instanceof baseLodash) {
	        var clone = wrapperClone(parent);
	        clone.__index__ = 0;
	        clone.__values__ = undefined;
	        if (result) {
	          previous.__wrapped__ = clone;
	        } else {
	          result = clone;
	        }
	        var previous = clone;
	        parent = parent.__wrapped__;
	      }
	      previous.__wrapped__ = value;
	      return result;
	    }

	    /**
	     * This method is the wrapper version of `_.reverse`.
	     *
	     * **Note:** This method mutates the wrapped array.
	     *
	     * @name reverse
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _(array).reverse().value()
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function wrapperReverse() {
	      var value = this.__wrapped__;
	      if (value instanceof LazyWrapper) {
	        var wrapped = value;
	        if (this.__actions__.length) {
	          wrapped = new LazyWrapper(this);
	        }
	        wrapped = wrapped.reverse();
	        wrapped.__actions__.push({
	          'func': thru,
	          'args': [reverse],
	          'thisArg': undefined
	        });
	        return new LodashWrapper(wrapped, this.__chain__);
	      }
	      return this.thru(reverse);
	    }

	    /**
	     * Executes the chain sequence to resolve the unwrapped value.
	     *
	     * @name value
	     * @memberOf _
	     * @since 0.1.0
	     * @alias toJSON, valueOf
	     * @category Seq
	     * @returns {*} Returns the resolved unwrapped value.
	     * @example
	     *
	     * _([1, 2, 3]).value();
	     * // => [1, 2, 3]
	     */
	    function wrapperValue() {
	      return baseWrapperValue(this.__wrapped__, this.__actions__);
	    }

	    /*------------------------------------------------------------------------*/

	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the number of times the key was returned by `iteratee`. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.countBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': 1, '6': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.countBy(['one', 'two', 'three'], 'length');
	     * // => { '3': 2, '5': 1 }
	     */
	    var countBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        ++result[key];
	      } else {
	        baseAssignValue(result, key, 1);
	      }
	    });

	    /**
	     * Checks if `predicate` returns truthy for **all** elements of `collection`.
	     * Iteration is stopped once `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * **Note:** This method returns `true` for
	     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
	     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
	     * elements of empty collections.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.every([true, 1, null, 'yes'], Boolean);
	     * // => false
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.every(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.every(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.every(users, 'active');
	     * // => false
	     */
	    function every(collection, predicate, guard) {
	      var func = isArray(collection) ? arrayEvery : baseEvery;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }

	    /**
	     * Iterates over elements of `collection`, returning an array of all elements
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * **Note:** Unlike `_.remove`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.reject
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.filter(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, { 'age': 36, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.filter(users, 'active');
	     * // => objects for ['barney']
	     *
	     * // Combining several predicates using `_.overEvery` or `_.overSome`.
	     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
	     * // => objects for ['fred', 'barney']
	     */
	    function filter(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, getIteratee(predicate, 3));
	    }

	    /**
	     * Iterates over elements of `collection`, returning the first element
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': true },
	     *   { 'user': 'fred',    'age': 40, 'active': false },
	     *   { 'user': 'pebbles', 'age': 1,  'active': true }
	     * ];
	     *
	     * _.find(users, function(o) { return o.age < 40; });
	     * // => object for 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.find(users, { 'age': 1, 'active': true });
	     * // => object for 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.find(users, ['active', false]);
	     * // => object for 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.find(users, 'active');
	     * // => object for 'barney'
	     */
	    var find = createFind(findIndex);

	    /**
	     * This method is like `_.find` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=collection.length-1] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * _.findLast([1, 2, 3, 4], function(n) {
	     *   return n % 2 == 1;
	     * });
	     * // => 3
	     */
	    var findLast = createFind(findLastIndex);

	    /**
	     * Creates a flattened array of values by running each element in `collection`
	     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
	     * with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [n, n];
	     * }
	     *
	     * _.flatMap([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMap(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), 1);
	    }

	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDeep([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMapDeep(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), INFINITY);
	    }

	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDepth([1, 2], duplicate, 2);
	     * // => [[1, 1], [2, 2]]
	     */
	    function flatMapDepth(collection, iteratee, depth) {
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(map(collection, iteratee), depth);
	    }

	    /**
	     * Iterates over elements of `collection` and invokes `iteratee` for each element.
	     * The iteratee is invoked with three arguments: (value, index|key, collection).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * **Note:** As with other "Collections" methods, objects with a "length"
	     * property are iterated like arrays. To avoid this behavior use `_.forIn`
	     * or `_.forOwn` for object iteration.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias each
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEachRight
	     * @example
	     *
	     * _.forEach([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `1` then `2`.
	     *
	     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forEach(collection, iteratee) {
	      var func = isArray(collection) ? arrayEach : baseEach;
	      return func(collection, getIteratee(iteratee, 3));
	    }

	    /**
	     * This method is like `_.forEach` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @alias eachRight
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEach
	     * @example
	     *
	     * _.forEachRight([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `2` then `1`.
	     */
	    function forEachRight(collection, iteratee) {
	      var func = isArray(collection) ? arrayEachRight : baseEachRight;
	      return func(collection, getIteratee(iteratee, 3));
	    }

	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The order of grouped values
	     * is determined by the order they occur in `collection`. The corresponding
	     * value of each key is an array of elements responsible for generating the
	     * key. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': [4.2], '6': [6.1, 6.3] }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.groupBy(['one', 'two', 'three'], 'length');
	     * // => { '3': ['one', 'two'], '5': ['three'] }
	     */
	    var groupBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        result[key].push(value);
	      } else {
	        baseAssignValue(result, key, [value]);
	      }
	    });

	    /**
	     * Checks if `value` is in `collection`. If `collection` is a string, it's
	     * checked for a substring of `value`, otherwise
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * is used for equality comparisons. If `fromIndex` is negative, it's used as
	     * the offset from the end of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {boolean} Returns `true` if `value` is found, else `false`.
	     * @example
	     *
	     * _.includes([1, 2, 3], 1);
	     * // => true
	     *
	     * _.includes([1, 2, 3], 1, 2);
	     * // => false
	     *
	     * _.includes({ 'a': 1, 'b': 2 }, 1);
	     * // => true
	     *
	     * _.includes('abcd', 'bc');
	     * // => true
	     */
	    function includes(collection, value, fromIndex, guard) {
	      collection = isArrayLike(collection) ? collection : values(collection);
	      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

	      var length = collection.length;
	      if (fromIndex < 0) {
	        fromIndex = nativeMax(length + fromIndex, 0);
	      }
	      return isString(collection)
	        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
	        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
	    }

	    /**
	     * Invokes the method at `path` of each element in `collection`, returning
	     * an array of the results of each invoked method. Any additional arguments
	     * are provided to each invoked method. If `path` is a function, it's invoked
	     * for, and `this` bound to, each element in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|string} path The path of the method to invoke or
	     *  the function invoked per iteration.
	     * @param {...*} [args] The arguments to invoke each method with.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
	     * // => [[1, 5, 7], [1, 2, 3]]
	     *
	     * _.invokeMap([123, 456], String.prototype.split, '');
	     * // => [['1', '2', '3'], ['4', '5', '6']]
	     */
	    var invokeMap = baseRest(function(collection, path, args) {
	      var index = -1,
	          isFunc = typeof path == 'function',
	          result = isArrayLike(collection) ? Array(collection.length) : [];

	      baseEach(collection, function(value) {
	        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
	      });
	      return result;
	    });

	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the last element responsible for generating the key. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * var array = [
	     *   { 'dir': 'left', 'code': 97 },
	     *   { 'dir': 'right', 'code': 100 }
	     * ];
	     *
	     * _.keyBy(array, function(o) {
	     *   return String.fromCharCode(o.code);
	     * });
	     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	     *
	     * _.keyBy(array, 'dir');
	     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
	     */
	    var keyBy = createAggregator(function(result, value, key) {
	      baseAssignValue(result, key, value);
	    });

	    /**
	     * Creates an array of values by running each element in `collection` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	     *
	     * The guarded methods are:
	     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
	     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
	     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
	     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * _.map([4, 8], square);
	     * // => [16, 64]
	     *
	     * _.map({ 'a': 4, 'b': 8 }, square);
	     * // => [16, 64] (iteration order is not guaranteed)
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, 'user');
	     * // => ['barney', 'fred']
	     */
	    function map(collection, iteratee) {
	      var func = isArray(collection) ? arrayMap : baseMap;
	      return func(collection, getIteratee(iteratee, 3));
	    }

	    /**
	     * This method is like `_.sortBy` except that it allows specifying the sort
	     * orders of the iteratees to sort by. If `orders` is unspecified, all values
	     * are sorted in ascending order. Otherwise, specify an order of "desc" for
	     * descending or "asc" for ascending sort order of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @param {string[]} [orders] The sort orders of `iteratees`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 34 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 36 }
	     * ];
	     *
	     * // Sort by `user` in ascending order and by `age` in descending order.
	     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     */
	    function orderBy(collection, iteratees, orders, guard) {
	      if (collection == null) {
	        return [];
	      }
	      if (!isArray(iteratees)) {
	        iteratees = iteratees == null ? [] : [iteratees];
	      }
	      orders = guard ? undefined : orders;
	      if (!isArray(orders)) {
	        orders = orders == null ? [] : [orders];
	      }
	      return baseOrderBy(collection, iteratees, orders);
	    }

	    /**
	     * Creates an array of elements split into two groups, the first of which
	     * contains elements `predicate` returns truthy for, the second of which
	     * contains elements `predicate` returns falsey for. The predicate is
	     * invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of grouped elements.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': false },
	     *   { 'user': 'fred',    'age': 40, 'active': true },
	     *   { 'user': 'pebbles', 'age': 1,  'active': false }
	     * ];
	     *
	     * _.partition(users, function(o) { return o.active; });
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.partition(users, { 'age': 1, 'active': false });
	     * // => objects for [['pebbles'], ['barney', 'fred']]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.partition(users, ['active', false]);
	     * // => objects for [['barney', 'pebbles'], ['fred']]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.partition(users, 'active');
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     */
	    var partition = createAggregator(function(result, value, key) {
	      result[key ? 0 : 1].push(value);
	    }, function() { return [[], []]; });

	    /**
	     * Reduces `collection` to a value which is the accumulated result of running
	     * each element in `collection` thru `iteratee`, where each successive
	     * invocation is supplied the return value of the previous. If `accumulator`
	     * is not given, the first element of `collection` is used as the initial
	     * value. The iteratee is invoked with four arguments:
	     * (accumulator, value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.reduce`, `_.reduceRight`, and `_.transform`.
	     *
	     * The guarded methods are:
	     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
	     * and `sortBy`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduceRight
	     * @example
	     *
	     * _.reduce([1, 2], function(sum, n) {
	     *   return sum + n;
	     * }, 0);
	     * // => 3
	     *
	     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     *   return result;
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
	     */
	    function reduce(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduce : baseReduce,
	          initAccum = arguments.length < 3;

	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
	    }

	    /**
	     * This method is like `_.reduce` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduce
	     * @example
	     *
	     * var array = [[0, 1], [2, 3], [4, 5]];
	     *
	     * _.reduceRight(array, function(flattened, other) {
	     *   return flattened.concat(other);
	     * }, []);
	     * // => [4, 5, 2, 3, 0, 1]
	     */
	    function reduceRight(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduceRight : baseReduce,
	          initAccum = arguments.length < 3;

	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
	    }

	    /**
	     * The opposite of `_.filter`; this method returns the elements of `collection`
	     * that `predicate` does **not** return truthy for.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.filter
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': true }
	     * ];
	     *
	     * _.reject(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.reject(users, { 'age': 40, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.reject(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.reject(users, 'active');
	     * // => objects for ['barney']
	     */
	    function reject(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, negate(getIteratee(predicate, 3)));
	    }

	    /**
	     * Gets a random element from `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     * @example
	     *
	     * _.sample([1, 2, 3, 4]);
	     * // => 2
	     */
	    function sample(collection) {
	      var func = isArray(collection) ? arraySample : baseSample;
	      return func(collection);
	    }

	    /**
	     * Gets `n` random elements at unique keys from `collection` up to the
	     * size of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} [n=1] The number of elements to sample.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the random elements.
	     * @example
	     *
	     * _.sampleSize([1, 2, 3], 2);
	     * // => [3, 1]
	     *
	     * _.sampleSize([1, 2, 3], 4);
	     * // => [2, 3, 1]
	     */
	    function sampleSize(collection, n, guard) {
	      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
	      return func(collection, n);
	    }

	    /**
	     * Creates an array of shuffled values, using a version of the
	     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     * @example
	     *
	     * _.shuffle([1, 2, 3, 4]);
	     * // => [4, 1, 3, 2]
	     */
	    function shuffle(collection) {
	      var func = isArray(collection) ? arrayShuffle : baseShuffle;
	      return func(collection);
	    }

	    /**
	     * Gets the size of `collection` by returning its length for array-like
	     * values or the number of own enumerable string keyed properties for objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @returns {number} Returns the collection size.
	     * @example
	     *
	     * _.size([1, 2, 3]);
	     * // => 3
	     *
	     * _.size({ 'a': 1, 'b': 2 });
	     * // => 2
	     *
	     * _.size('pebbles');
	     * // => 7
	     */
	    function size(collection) {
	      if (collection == null) {
	        return 0;
	      }
	      if (isArrayLike(collection)) {
	        return isString(collection) ? stringSize(collection) : collection.length;
	      }
	      var tag = getTag(collection);
	      if (tag == mapTag || tag == setTag) {
	        return collection.size;
	      }
	      return baseKeys(collection).length;
	    }

	    /**
	     * Checks if `predicate` returns truthy for **any** element of `collection`.
	     * Iteration is stopped once `predicate` returns truthy. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.some([null, 0, 'yes', false], Boolean);
	     * // => true
	     *
	     * var users = [
	     *   { 'user': 'barney', 'active': true },
	     *   { 'user': 'fred',   'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.some(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.some(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.some(users, 'active');
	     * // => true
	     */
	    function some(collection, predicate, guard) {
	      var func = isArray(collection) ? arraySome : baseSome;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }

	    /**
	     * Creates an array of elements, sorted in ascending order by the results of
	     * running each element in a collection thru each iteratee. This method
	     * performs a stable sort, that is, it preserves the original sort order of
	     * equal elements. The iteratees are invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 30 },
	     *   { 'user': 'barney', 'age': 34 }
	     * ];
	     *
	     * _.sortBy(users, [function(o) { return o.user; }]);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
	     *
	     * _.sortBy(users, ['user', 'age']);
	     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
	     */
	    var sortBy = baseRest(function(collection, iteratees) {
	      if (collection == null) {
	        return [];
	      }
	      var length = iteratees.length;
	      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
	        iteratees = [];
	      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
	        iteratees = [iteratees[0]];
	      }
	      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
	    });

	    /*------------------------------------------------------------------------*/

	    /**
	     * Gets the timestamp of the number of milliseconds that have elapsed since
	     * the Unix epoch (1 January 1970 00:00:00 UTC).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Date
	     * @returns {number} Returns the timestamp.
	     * @example
	     *
	     * _.defer(function(stamp) {
	     *   console.log(_.now() - stamp);
	     * }, _.now());
	     * // => Logs the number of milliseconds it took for the deferred invocation.
	     */
	    var now = ctxNow || function() {
	      return root.Date.now();
	    };

	    /*------------------------------------------------------------------------*/

	    /**
	     * The opposite of `_.before`; this method creates a function that invokes
	     * `func` once it's called `n` or more times.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {number} n The number of calls before `func` is invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var saves = ['profile', 'settings'];
	     *
	     * var done = _.after(saves.length, function() {
	     *   console.log('done saving!');
	     * });
	     *
	     * _.forEach(saves, function(type) {
	     *   asyncSave({ 'type': type, 'complete': done });
	     * });
	     * // => Logs 'done saving!' after the two async saves have completed.
	     */
	    function after(n, func) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n < 1) {
	          return func.apply(this, arguments);
	        }
	      };
	    }

	    /**
	     * Creates a function that invokes `func`, with up to `n` arguments,
	     * ignoring any additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @param {number} [n=func.length] The arity cap.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
	     * // => [6, 8, 10]
	     */
	    function ary(func, n, guard) {
	      n = guard ? undefined : n;
	      n = (func && n == null) ? func.length : n;
	      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
	    }

	    /**
	     * Creates a function that invokes `func`, with the `this` binding and arguments
	     * of the created function, while it's called less than `n` times. Subsequent
	     * calls to the created function return the result of the last `func` invocation.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {number} n The number of calls at which `func` is no longer invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * jQuery(element).on('click', _.before(5, addContactToList));
	     * // => Allows adding up to 4 contacts to the list.
	     */
	    function before(n, func) {
	      var result;
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n > 0) {
	          result = func.apply(this, arguments);
	        }
	        if (n <= 1) {
	          func = undefined;
	        }
	        return result;
	      };
	    }

	    /**
	     * Creates a function that invokes `func` with the `this` binding of `thisArg`
	     * and `partials` prepended to the arguments it receives.
	     *
	     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
	     * property of bound functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to bind.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * function greet(greeting, punctuation) {
	     *   return greeting + ' ' + this.user + punctuation;
	     * }
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * var bound = _.bind(greet, object, 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bind(greet, object, _, '!');
	     * bound('hi');
	     * // => 'hi fred!'
	     */
	    var bind = baseRest(function(func, thisArg, partials) {
	      var bitmask = WRAP_BIND_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bind));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(func, bitmask, thisArg, partials, holders);
	    });

	    /**
	     * Creates a function that invokes the method at `object[key]` with `partials`
	     * prepended to the arguments it receives.
	     *
	     * This method differs from `_.bind` by allowing bound functions to reference
	     * methods that may be redefined or don't yet exist. See
	     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
	     * for more details.
	     *
	     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Function
	     * @param {Object} object The object to invoke the method on.
	     * @param {string} key The key of the method.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var object = {
	     *   'user': 'fred',
	     *   'greet': function(greeting, punctuation) {
	     *     return greeting + ' ' + this.user + punctuation;
	     *   }
	     * };
	     *
	     * var bound = _.bindKey(object, 'greet', 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * object.greet = function(greeting, punctuation) {
	     *   return greeting + 'ya ' + this.user + punctuation;
	     * };
	     *
	     * bound('!');
	     * // => 'hiya fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bindKey(object, 'greet', _, '!');
	     * bound('hi');
	     * // => 'hiya fred!'
	     */
	    var bindKey = baseRest(function(object, key, partials) {
	      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bindKey));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(key, bitmask, object, partials, holders);
	    });

	    /**
	     * Creates a function that accepts arguments of `func` and either invokes
	     * `func` returning its result, if at least `arity` number of arguments have
	     * been provided, or returns a function that accepts the remaining `func`
	     * arguments, and so on. The arity of `func` may be specified if `func.length`
	     * is not sufficient.
	     *
	     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curry(abc);
	     *
	     * curried(1)(2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(1)(_, 3)(2);
	     * // => [1, 2, 3]
	     */
	    function curry(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curry.placeholder;
	      return result;
	    }

	    /**
	     * This method is like `_.curry` except that arguments are applied to `func`
	     * in the manner of `_.partialRight` instead of `_.partial`.
	     *
	     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curryRight(abc);
	     *
	     * curried(3)(2)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(2, 3)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(3)(1, _)(2);
	     * // => [1, 2, 3]
	     */
	    function curryRight(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curryRight.placeholder;
	      return result;
	    }

	    /**
	     * Creates a debounced function that delays invoking `func` until after `wait`
	     * milliseconds have elapsed since the last time the debounced function was
	     * invoked. The debounced function comes with a `cancel` method to cancel
	     * delayed `func` invocations and a `flush` method to immediately invoke them.
	     * Provide `options` to indicate whether `func` should be invoked on the
	     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	     * with the last arguments provided to the debounced function. Subsequent
	     * calls to the debounced function return the result of the last `func`
	     * invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the debounced function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.debounce` and `_.throttle`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to debounce.
	     * @param {number} [wait=0] The number of milliseconds to delay.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=false]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {number} [options.maxWait]
	     *  The maximum time `func` is allowed to be delayed before it's invoked.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new debounced function.
	     * @example
	     *
	     * // Avoid costly calculations while the window size is in flux.
	     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	     *
	     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	     * jQuery(element).on('click', _.debounce(sendMail, 300, {
	     *   'leading': true,
	     *   'trailing': false
	     * }));
	     *
	     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	     * var source = new EventSource('/stream');
	     * jQuery(source).on('message', debounced);
	     *
	     * // Cancel the trailing debounced invocation.
	     * jQuery(window).on('popstate', debounced.cancel);
	     */
	    function debounce(func, wait, options) {
	      var lastArgs,
	          lastThis,
	          maxWait,
	          result,
	          timerId,
	          lastCallTime,
	          lastInvokeTime = 0,
	          leading = false,
	          maxing = false,
	          trailing = true;

	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      wait = toNumber(wait) || 0;
	      if (isObject(options)) {
	        leading = !!options.leading;
	        maxing = 'maxWait' in options;
	        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }

	      function invokeFunc(time) {
	        var args = lastArgs,
	            thisArg = lastThis;

	        lastArgs = lastThis = undefined;
	        lastInvokeTime = time;
	        result = func.apply(thisArg, args);
	        return result;
	      }

	      function leadingEdge(time) {
	        // Reset any `maxWait` timer.
	        lastInvokeTime = time;
	        // Start the timer for the trailing edge.
	        timerId = setTimeout(timerExpired, wait);
	        // Invoke the leading edge.
	        return leading ? invokeFunc(time) : result;
	      }

	      function remainingWait(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime,
	            timeWaiting = wait - timeSinceLastCall;

	        return maxing
	          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
	          : timeWaiting;
	      }

	      function shouldInvoke(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime;

	        // Either this is the first call, activity has stopped and we're at the
	        // trailing edge, the system time has gone backwards and we're treating
	        // it as the trailing edge, or we've hit the `maxWait` limit.
	        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	      }

	      function timerExpired() {
	        var time = now();
	        if (shouldInvoke(time)) {
	          return trailingEdge(time);
	        }
	        // Restart the timer.
	        timerId = setTimeout(timerExpired, remainingWait(time));
	      }

	      function trailingEdge(time) {
	        timerId = undefined;

	        // Only invoke if we have `lastArgs` which means `func` has been
	        // debounced at least once.
	        if (trailing && lastArgs) {
	          return invokeFunc(time);
	        }
	        lastArgs = lastThis = undefined;
	        return result;
	      }

	      function cancel() {
	        if (timerId !== undefined) {
	          clearTimeout(timerId);
	        }
	        lastInvokeTime = 0;
	        lastArgs = lastCallTime = lastThis = timerId = undefined;
	      }

	      function flush() {
	        return timerId === undefined ? result : trailingEdge(now());
	      }

	      function debounced() {
	        var time = now(),
	            isInvoking = shouldInvoke(time);

	        lastArgs = arguments;
	        lastThis = this;
	        lastCallTime = time;

	        if (isInvoking) {
	          if (timerId === undefined) {
	            return leadingEdge(lastCallTime);
	          }
	          if (maxing) {
	            // Handle invocations in a tight loop.
	            clearTimeout(timerId);
	            timerId = setTimeout(timerExpired, wait);
	            return invokeFunc(lastCallTime);
	          }
	        }
	        if (timerId === undefined) {
	          timerId = setTimeout(timerExpired, wait);
	        }
	        return result;
	      }
	      debounced.cancel = cancel;
	      debounced.flush = flush;
	      return debounced;
	    }

	    /**
	     * Defers invoking the `func` until the current call stack has cleared. Any
	     * additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to defer.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.defer(function(text) {
	     *   console.log(text);
	     * }, 'deferred');
	     * // => Logs 'deferred' after one millisecond.
	     */
	    var defer = baseRest(function(func, args) {
	      return baseDelay(func, 1, args);
	    });

	    /**
	     * Invokes `func` after `wait` milliseconds. Any additional arguments are
	     * provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.delay(function(text) {
	     *   console.log(text);
	     * }, 1000, 'later');
	     * // => Logs 'later' after one second.
	     */
	    var delay = baseRest(function(func, wait, args) {
	      return baseDelay(func, toNumber(wait) || 0, args);
	    });

	    /**
	     * Creates a function that invokes `func` with arguments reversed.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to flip arguments for.
	     * @returns {Function} Returns the new flipped function.
	     * @example
	     *
	     * var flipped = _.flip(function() {
	     *   return _.toArray(arguments);
	     * });
	     *
	     * flipped('a', 'b', 'c', 'd');
	     * // => ['d', 'c', 'b', 'a']
	     */
	    function flip(func) {
	      return createWrap(func, WRAP_FLIP_FLAG);
	    }

	    /**
	     * Creates a function that memoizes the result of `func`. If `resolver` is
	     * provided, it determines the cache key for storing the result based on the
	     * arguments provided to the memoized function. By default, the first argument
	     * provided to the memoized function is used as the map cache key. The `func`
	     * is invoked with the `this` binding of the memoized function.
	     *
	     * **Note:** The cache is exposed as the `cache` property on the memoized
	     * function. Its creation may be customized by replacing the `_.memoize.Cache`
	     * constructor with one whose instances implement the
	     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to have its output memoized.
	     * @param {Function} [resolver] The function to resolve the cache key.
	     * @returns {Function} Returns the new memoized function.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     * var other = { 'c': 3, 'd': 4 };
	     *
	     * var values = _.memoize(_.values);
	     * values(object);
	     * // => [1, 2]
	     *
	     * values(other);
	     * // => [3, 4]
	     *
	     * object.a = 2;
	     * values(object);
	     * // => [1, 2]
	     *
	     * // Modify the result cache.
	     * values.cache.set(object, ['a', 'b']);
	     * values(object);
	     * // => ['a', 'b']
	     *
	     * // Replace `_.memoize.Cache`.
	     * _.memoize.Cache = WeakMap;
	     */
	    function memoize(func, resolver) {
	      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var memoized = function() {
	        var args = arguments,
	            key = resolver ? resolver.apply(this, args) : args[0],
	            cache = memoized.cache;

	        if (cache.has(key)) {
	          return cache.get(key);
	        }
	        var result = func.apply(this, args);
	        memoized.cache = cache.set(key, result) || cache;
	        return result;
	      };
	      memoized.cache = new (memoize.Cache || MapCache);
	      return memoized;
	    }

	    // Expose `MapCache`.
	    memoize.Cache = MapCache;

	    /**
	     * Creates a function that negates the result of the predicate `func`. The
	     * `func` predicate is invoked with the `this` binding and arguments of the
	     * created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} predicate The predicate to negate.
	     * @returns {Function} Returns the new negated function.
	     * @example
	     *
	     * function isEven(n) {
	     *   return n % 2 == 0;
	     * }
	     *
	     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
	     * // => [1, 3, 5]
	     */
	    function negate(predicate) {
	      if (typeof predicate != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return function() {
	        var args = arguments;
	        switch (args.length) {
	          case 0: return !predicate.call(this);
	          case 1: return !predicate.call(this, args[0]);
	          case 2: return !predicate.call(this, args[0], args[1]);
	          case 3: return !predicate.call(this, args[0], args[1], args[2]);
	        }
	        return !predicate.apply(this, args);
	      };
	    }

	    /**
	     * Creates a function that is restricted to invoking `func` once. Repeat calls
	     * to the function return the value of the first invocation. The `func` is
	     * invoked with the `this` binding and arguments of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var initialize = _.once(createApplication);
	     * initialize();
	     * initialize();
	     * // => `createApplication` is invoked once
	     */
	    function once(func) {
	      return before(2, func);
	    }

	    /**
	     * Creates a function that invokes `func` with its arguments transformed.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to wrap.
	     * @param {...(Function|Function[])} [transforms=[_.identity]]
	     *  The argument transforms.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function doubled(n) {
	     *   return n * 2;
	     * }
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var func = _.overArgs(function(x, y) {
	     *   return [x, y];
	     * }, [square, doubled]);
	     *
	     * func(9, 3);
	     * // => [81, 6]
	     *
	     * func(10, 5);
	     * // => [100, 10]
	     */
	    var overArgs = castRest(function(func, transforms) {
	      transforms = (transforms.length == 1 && isArray(transforms[0]))
	        ? arrayMap(transforms[0], baseUnary(getIteratee()))
	        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

	      var funcsLength = transforms.length;
	      return baseRest(function(args) {
	        var this$1 = this;

	        var index = -1,
	            length = nativeMin(args.length, funcsLength);

	        while (++index < length) {
	          args[index] = transforms[index].call(this$1, args[index]);
	        }
	        return apply(func, this, args);
	      });
	    });

	    /**
	     * Creates a function that invokes `func` with `partials` prepended to the
	     * arguments it receives. This method is like `_.bind` except it does **not**
	     * alter the `this` binding.
	     *
	     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.2.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var sayHelloTo = _.partial(greet, 'hello');
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     *
	     * // Partially applied with placeholders.
	     * var greetFred = _.partial(greet, _, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     */
	    var partial = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partial));
	      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
	    });

	    /**
	     * This method is like `_.partial` except that partially applied arguments
	     * are appended to the arguments it receives.
	     *
	     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var greetFred = _.partialRight(greet, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     *
	     * // Partially applied with placeholders.
	     * var sayHelloTo = _.partialRight(greet, 'hello', _);
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     */
	    var partialRight = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partialRight));
	      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
	    });

	    /**
	     * Creates a function that invokes `func` with arguments arranged according
	     * to the specified `indexes` where the argument value at the first index is
	     * provided as the first argument, the argument value at the second index is
	     * provided as the second argument, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to rearrange arguments for.
	     * @param {...(number|number[])} indexes The arranged argument indexes.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var rearged = _.rearg(function(a, b, c) {
	     *   return [a, b, c];
	     * }, [2, 0, 1]);
	     *
	     * rearged('b', 'c', 'a')
	     * // => ['a', 'b', 'c']
	     */
	    var rearg = flatRest(function(func, indexes) {
	      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
	    });

	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * created function and arguments from `start` and beyond provided as
	     * an array.
	     *
	     * **Note:** This method is based on the
	     * [rest parameter](https://mdn.io/rest_parameters).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.rest(function(what, names) {
	     *   return what + ' ' + _.initial(names).join(', ') +
	     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	     * });
	     *
	     * say('hello', 'fred', 'barney', 'pebbles');
	     * // => 'hello fred, barney, & pebbles'
	     */
	    function rest(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start === undefined ? start : toInteger(start);
	      return baseRest(func, start);
	    }

	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * create function and an array of arguments much like
	     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
	     *
	     * **Note:** This method is based on the
	     * [spread operator](https://mdn.io/spread_operator).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Function
	     * @param {Function} func The function to spread arguments over.
	     * @param {number} [start=0] The start position of the spread.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.spread(function(who, what) {
	     *   return who + ' says ' + what;
	     * });
	     *
	     * say(['fred', 'hello']);
	     * // => 'fred says hello'
	     *
	     * var numbers = Promise.all([
	     *   Promise.resolve(40),
	     *   Promise.resolve(36)
	     * ]);
	     *
	     * numbers.then(_.spread(function(x, y) {
	     *   return x + y;
	     * }));
	     * // => a Promise of 76
	     */
	    function spread(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start == null ? 0 : nativeMax(toInteger(start), 0);
	      return baseRest(function(args) {
	        var array = args[start],
	            otherArgs = castSlice(args, 0, start);

	        if (array) {
	          arrayPush(otherArgs, array);
	        }
	        return apply(func, this, otherArgs);
	      });
	    }

	    /**
	     * Creates a throttled function that only invokes `func` at most once per
	     * every `wait` milliseconds. The throttled function comes with a `cancel`
	     * method to cancel delayed `func` invocations and a `flush` method to
	     * immediately invoke them. Provide `options` to indicate whether `func`
	     * should be invoked on the leading and/or trailing edge of the `wait`
	     * timeout. The `func` is invoked with the last arguments provided to the
	     * throttled function. Subsequent calls to the throttled function return the
	     * result of the last `func` invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the throttled function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.throttle` and `_.debounce`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to throttle.
	     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=true]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new throttled function.
	     * @example
	     *
	     * // Avoid excessively updating the position while scrolling.
	     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	     *
	     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	     * jQuery(element).on('click', throttled);
	     *
	     * // Cancel the trailing throttled invocation.
	     * jQuery(window).on('popstate', throttled.cancel);
	     */
	    function throttle(func, wait, options) {
	      var leading = true,
	          trailing = true;

	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      if (isObject(options)) {
	        leading = 'leading' in options ? !!options.leading : leading;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	      return debounce(func, wait, {
	        'leading': leading,
	        'maxWait': wait,
	        'trailing': trailing
	      });
	    }

	    /**
	     * Creates a function that accepts up to one argument, ignoring any
	     * additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.unary(parseInt));
	     * // => [6, 8, 10]
	     */
	    function unary(func) {
	      return ary(func, 1);
	    }

	    /**
	     * Creates a function that provides `value` to `wrapper` as its first
	     * argument. Any additional arguments provided to the function are appended
	     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
	     * binding of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {*} value The value to wrap.
	     * @param {Function} [wrapper=identity] The wrapper function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var p = _.wrap(_.escape, function(func, text) {
	     *   return '<p>' + func(text) + '</p>';
	     * });
	     *
	     * p('fred, barney, & pebbles');
	     * // => '<p>fred, barney, &amp; pebbles</p>'
	     */
	    function wrap(value, wrapper) {
	      return partial(castFunction(wrapper), value);
	    }

	    /*------------------------------------------------------------------------*/

	    /**
	     * Casts `value` as an array if it's not one.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Lang
	     * @param {*} value The value to inspect.
	     * @returns {Array} Returns the cast array.
	     * @example
	     *
	     * _.castArray(1);
	     * // => [1]
	     *
	     * _.castArray({ 'a': 1 });
	     * // => [{ 'a': 1 }]
	     *
	     * _.castArray('abc');
	     * // => ['abc']
	     *
	     * _.castArray(null);
	     * // => [null]
	     *
	     * _.castArray(undefined);
	     * // => [undefined]
	     *
	     * _.castArray();
	     * // => []
	     *
	     * var array = [1, 2, 3];
	     * console.log(_.castArray(array) === array);
	     * // => true
	     */
	    function castArray() {
	      if (!arguments.length) {
	        return [];
	      }
	      var value = arguments[0];
	      return isArray(value) ? value : [value];
	    }

	    /**
	     * Creates a shallow clone of `value`.
	     *
	     * **Note:** This method is loosely based on the
	     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
	     * and supports cloning arrays, array buffers, booleans, date objects, maps,
	     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
	     * arrays. The own enumerable properties of `arguments` objects are cloned
	     * as plain objects. An empty object is returned for uncloneable values such
	     * as error objects, functions, DOM nodes, and WeakMaps.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeep
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var shallow = _.clone(objects);
	     * console.log(shallow[0] === objects[0]);
	     * // => true
	     */
	    function clone(value) {
	      return baseClone(value, CLONE_SYMBOLS_FLAG);
	    }

	    /**
	     * This method is like `_.clone` except that it accepts `customizer` which
	     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
	     * cloning is handled by the method instead. The `customizer` is invoked with
	     * up to four arguments; (value [, index|key, object, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeepWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(false);
	     *   }
	     * }
	     *
	     * var el = _.cloneWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 0
	     */
	    function cloneWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
	    }

	    /**
	     * This method is like `_.clone` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.clone
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var deep = _.cloneDeep(objects);
	     * console.log(deep[0] === objects[0]);
	     * // => false
	     */
	    function cloneDeep(value) {
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
	    }

	    /**
	     * This method is like `_.cloneWith` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.cloneWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(true);
	     *   }
	     * }
	     *
	     * var el = _.cloneDeepWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 20
	     */
	    function cloneDeepWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
	    }

	    /**
	     * Checks if `object` conforms to `source` by invoking the predicate
	     * properties of `source` with the corresponding property values of `object`.
	     *
	     * **Note:** This method is equivalent to `_.conforms` when `source` is
	     * partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
	     * // => true
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
	     * // => false
	     */
	    function conformsTo(object, source) {
	      return source == null || baseConformsTo(object, source, keys(source));
	    }

	    /**
	     * Performs a
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * comparison between two values to determine if they are equivalent.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.eq(object, object);
	     * // => true
	     *
	     * _.eq(object, other);
	     * // => false
	     *
	     * _.eq('a', 'a');
	     * // => true
	     *
	     * _.eq('a', Object('a'));
	     * // => false
	     *
	     * _.eq(NaN, NaN);
	     * // => true
	     */
	    function eq(value, other) {
	      return value === other || (value !== value && other !== other);
	    }

	    /**
	     * Checks if `value` is greater than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     * @see _.lt
	     * @example
	     *
	     * _.gt(3, 1);
	     * // => true
	     *
	     * _.gt(3, 3);
	     * // => false
	     *
	     * _.gt(1, 3);
	     * // => false
	     */
	    var gt = createRelationalOperation(baseGt);

	    /**
	     * Checks if `value` is greater than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than or equal to
	     *  `other`, else `false`.
	     * @see _.lte
	     * @example
	     *
	     * _.gte(3, 1);
	     * // => true
	     *
	     * _.gte(3, 3);
	     * // => true
	     *
	     * _.gte(1, 3);
	     * // => false
	     */
	    var gte = createRelationalOperation(function(value, other) {
	      return value >= other;
	    });

	    /**
	     * Checks if `value` is likely an `arguments` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArguments(function() { return arguments; }());
	     * // => true
	     *
	     * _.isArguments([1, 2, 3]);
	     * // => false
	     */
	    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	        !propertyIsEnumerable.call(value, 'callee');
	    };

	    /**
	     * Checks if `value` is classified as an `Array` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	     * @example
	     *
	     * _.isArray([1, 2, 3]);
	     * // => true
	     *
	     * _.isArray(document.body.children);
	     * // => false
	     *
	     * _.isArray('abc');
	     * // => false
	     *
	     * _.isArray(_.noop);
	     * // => false
	     */
	    var isArray = Array.isArray;

	    /**
	     * Checks if `value` is classified as an `ArrayBuffer` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     * @example
	     *
	     * _.isArrayBuffer(new ArrayBuffer(2));
	     * // => true
	     *
	     * _.isArrayBuffer(new Array(2));
	     * // => false
	     */
	    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

	    /**
	     * Checks if `value` is array-like. A value is considered array-like if it's
	     * not a function and has a `value.length` that's an integer greater than or
	     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	     * @example
	     *
	     * _.isArrayLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLike(document.body.children);
	     * // => true
	     *
	     * _.isArrayLike('abc');
	     * // => true
	     *
	     * _.isArrayLike(_.noop);
	     * // => false
	     */
	    function isArrayLike(value) {
	      return value != null && isLength(value.length) && !isFunction(value);
	    }

	    /**
	     * This method is like `_.isArrayLike` except that it also checks if `value`
	     * is an object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array-like object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArrayLikeObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLikeObject(document.body.children);
	     * // => true
	     *
	     * _.isArrayLikeObject('abc');
	     * // => false
	     *
	     * _.isArrayLikeObject(_.noop);
	     * // => false
	     */
	    function isArrayLikeObject(value) {
	      return isObjectLike(value) && isArrayLike(value);
	    }

	    /**
	     * Checks if `value` is classified as a boolean primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
	     * @example
	     *
	     * _.isBoolean(false);
	     * // => true
	     *
	     * _.isBoolean(null);
	     * // => false
	     */
	    function isBoolean(value) {
	      return value === true || value === false ||
	        (isObjectLike(value) && baseGetTag(value) == boolTag);
	    }

	    /**
	     * Checks if `value` is a buffer.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	     * @example
	     *
	     * _.isBuffer(new Buffer(2));
	     * // => true
	     *
	     * _.isBuffer(new Uint8Array(2));
	     * // => false
	     */
	    var isBuffer = nativeIsBuffer || stubFalse;

	    /**
	     * Checks if `value` is classified as a `Date` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     * @example
	     *
	     * _.isDate(new Date);
	     * // => true
	     *
	     * _.isDate('Mon April 23 2012');
	     * // => false
	     */
	    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

	    /**
	     * Checks if `value` is likely a DOM element.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
	     * @example
	     *
	     * _.isElement(document.body);
	     * // => true
	     *
	     * _.isElement('<body>');
	     * // => false
	     */
	    function isElement(value) {
	      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
	    }

	    /**
	     * Checks if `value` is an empty object, collection, map, or set.
	     *
	     * Objects are considered empty if they have no own enumerable string keyed
	     * properties.
	     *
	     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
	     * jQuery-like collections are considered empty if they have a `length` of `0`.
	     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	     * @example
	     *
	     * _.isEmpty(null);
	     * // => true
	     *
	     * _.isEmpty(true);
	     * // => true
	     *
	     * _.isEmpty(1);
	     * // => true
	     *
	     * _.isEmpty([1, 2, 3]);
	     * // => false
	     *
	     * _.isEmpty({ 'a': 1 });
	     * // => false
	     */
	    function isEmpty(value) {
	      if (value == null) {
	        return true;
	      }
	      if (isArrayLike(value) &&
	          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
	            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
	        return !value.length;
	      }
	      var tag = getTag(value);
	      if (tag == mapTag || tag == setTag) {
	        return !value.size;
	      }
	      if (isPrototype(value)) {
	        return !baseKeys(value).length;
	      }
	      for (var key in value) {
	        if (hasOwnProperty.call(value, key)) {
	          return false;
	        }
	      }
	      return true;
	    }

	    /**
	     * Performs a deep comparison between two values to determine if they are
	     * equivalent.
	     *
	     * **Note:** This method supports comparing arrays, array buffers, booleans,
	     * date objects, error objects, maps, numbers, `Object` objects, regexes,
	     * sets, strings, symbols, and typed arrays. `Object` objects are compared
	     * by their own, not inherited, enumerable properties. Functions and DOM
	     * nodes are compared by strict equality, i.e. `===`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.isEqual(object, other);
	     * // => true
	     *
	     * object === other;
	     * // => false
	     */
	    function isEqual(value, other) {
	      return baseIsEqual(value, other);
	    }

	    /**
	     * This method is like `_.isEqual` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with up to
	     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, othValue) {
	     *   if (isGreeting(objValue) && isGreeting(othValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var array = ['hello', 'goodbye'];
	     * var other = ['hi', 'goodbye'];
	     *
	     * _.isEqualWith(array, other, customizer);
	     * // => true
	     */
	    function isEqualWith(value, other, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      var result = customizer ? customizer(value, other) : undefined;
	      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
	    }

	    /**
	     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
	     * `SyntaxError`, `TypeError`, or `URIError` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
	     * @example
	     *
	     * _.isError(new Error);
	     * // => true
	     *
	     * _.isError(Error);
	     * // => false
	     */
	    function isError(value) {
	      if (!isObjectLike(value)) {
	        return false;
	      }
	      var tag = baseGetTag(value);
	      return tag == errorTag || tag == domExcTag ||
	        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
	    }

	    /**
	     * Checks if `value` is a finite primitive number.
	     *
	     * **Note:** This method is based on
	     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
	     * @example
	     *
	     * _.isFinite(3);
	     * // => true
	     *
	     * _.isFinite(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isFinite(Infinity);
	     * // => false
	     *
	     * _.isFinite('3');
	     * // => false
	     */
	    function isFinite(value) {
	      return typeof value == 'number' && nativeIsFinite(value);
	    }

	    /**
	     * Checks if `value` is classified as a `Function` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	     * @example
	     *
	     * _.isFunction(_);
	     * // => true
	     *
	     * _.isFunction(/abc/);
	     * // => false
	     */
	    function isFunction(value) {
	      if (!isObject(value)) {
	        return false;
	      }
	      // The use of `Object#toString` avoids issues with the `typeof` operator
	      // in Safari 9 which returns 'object' for typed arrays and other constructors.
	      var tag = baseGetTag(value);
	      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	    }

	    /**
	     * Checks if `value` is an integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
	     * @example
	     *
	     * _.isInteger(3);
	     * // => true
	     *
	     * _.isInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isInteger(Infinity);
	     * // => false
	     *
	     * _.isInteger('3');
	     * // => false
	     */
	    function isInteger(value) {
	      return typeof value == 'number' && value == toInteger(value);
	    }

	    /**
	     * Checks if `value` is a valid array-like length.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	     * @example
	     *
	     * _.isLength(3);
	     * // => true
	     *
	     * _.isLength(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isLength(Infinity);
	     * // => false
	     *
	     * _.isLength('3');
	     * // => false
	     */
	    function isLength(value) {
	      return typeof value == 'number' &&
	        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	    }

	    /**
	     * Checks if `value` is the
	     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	     * @example
	     *
	     * _.isObject({});
	     * // => true
	     *
	     * _.isObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isObject(_.noop);
	     * // => true
	     *
	     * _.isObject(null);
	     * // => false
	     */
	    function isObject(value) {
	      var type = typeof value;
	      return value != null && (type == 'object' || type == 'function');
	    }

	    /**
	     * Checks if `value` is object-like. A value is object-like if it's not `null`
	     * and has a `typeof` result of "object".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	     * @example
	     *
	     * _.isObjectLike({});
	     * // => true
	     *
	     * _.isObjectLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isObjectLike(_.noop);
	     * // => false
	     *
	     * _.isObjectLike(null);
	     * // => false
	     */
	    function isObjectLike(value) {
	      return value != null && typeof value == 'object';
	    }

	    /**
	     * Checks if `value` is classified as a `Map` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     * @example
	     *
	     * _.isMap(new Map);
	     * // => true
	     *
	     * _.isMap(new WeakMap);
	     * // => false
	     */
	    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

	    /**
	     * Performs a partial deep comparison between `object` and `source` to
	     * determine if `object` contains equivalent property values.
	     *
	     * **Note:** This method is equivalent to `_.matches` when `source` is
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.isMatch(object, { 'b': 2 });
	     * // => true
	     *
	     * _.isMatch(object, { 'b': 1 });
	     * // => false
	     */
	    function isMatch(object, source) {
	      return object === source || baseIsMatch(object, source, getMatchData(source));
	    }

	    /**
	     * This method is like `_.isMatch` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with five
	     * arguments: (objValue, srcValue, index|key, object, source).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var object = { 'greeting': 'hello' };
	     * var source = { 'greeting': 'hi' };
	     *
	     * _.isMatchWith(object, source, customizer);
	     * // => true
	     */
	    function isMatchWith(object, source, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseIsMatch(object, source, getMatchData(source), customizer);
	    }

	    /**
	     * Checks if `value` is `NaN`.
	     *
	     * **Note:** This method is based on
	     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
	     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
	     * `undefined` and other non-number values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	     * @example
	     *
	     * _.isNaN(NaN);
	     * // => true
	     *
	     * _.isNaN(new Number(NaN));
	     * // => true
	     *
	     * isNaN(undefined);
	     * // => true
	     *
	     * _.isNaN(undefined);
	     * // => false
	     */
	    function isNaN(value) {
	      // An `NaN` primitive is the only value that is not equal to itself.
	      // Perform the `toStringTag` check first to avoid errors with some
	      // ActiveX objects in IE.
	      return isNumber(value) && value != +value;
	    }

	    /**
	     * Checks if `value` is a pristine native function.
	     *
	     * **Note:** This method can't reliably detect native functions in the presence
	     * of the core-js package because core-js circumvents this kind of detection.
	     * Despite multiple requests, the core-js maintainer has made it clear: any
	     * attempt to fix the detection will be obstructed. As a result, we're left
	     * with little choice but to throw an error. Unfortunately, this also affects
	     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
	     * which rely on core-js.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     * @example
	     *
	     * _.isNative(Array.prototype.push);
	     * // => true
	     *
	     * _.isNative(_);
	     * // => false
	     */
	    function isNative(value) {
	      if (isMaskable(value)) {
	        throw new Error(CORE_ERROR_TEXT);
	      }
	      return baseIsNative(value);
	    }

	    /**
	     * Checks if `value` is `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
	     * @example
	     *
	     * _.isNull(null);
	     * // => true
	     *
	     * _.isNull(void 0);
	     * // => false
	     */
	    function isNull(value) {
	      return value === null;
	    }

	    /**
	     * Checks if `value` is `null` or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
	     * @example
	     *
	     * _.isNil(null);
	     * // => true
	     *
	     * _.isNil(void 0);
	     * // => true
	     *
	     * _.isNil(NaN);
	     * // => false
	     */
	    function isNil(value) {
	      return value == null;
	    }

	    /**
	     * Checks if `value` is classified as a `Number` primitive or object.
	     *
	     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
	     * classified as numbers, use the `_.isFinite` method.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
	     * @example
	     *
	     * _.isNumber(3);
	     * // => true
	     *
	     * _.isNumber(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isNumber(Infinity);
	     * // => true
	     *
	     * _.isNumber('3');
	     * // => false
	     */
	    function isNumber(value) {
	      return typeof value == 'number' ||
	        (isObjectLike(value) && baseGetTag(value) == numberTag);
	    }

	    /**
	     * Checks if `value` is a plain object, that is, an object created by the
	     * `Object` constructor or one with a `[[Prototype]]` of `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.8.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * _.isPlainObject(new Foo);
	     * // => false
	     *
	     * _.isPlainObject([1, 2, 3]);
	     * // => false
	     *
	     * _.isPlainObject({ 'x': 0, 'y': 0 });
	     * // => true
	     *
	     * _.isPlainObject(Object.create(null));
	     * // => true
	     */
	    function isPlainObject(value) {
	      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	        return false;
	      }
	      var proto = getPrototype(value);
	      if (proto === null) {
	        return true;
	      }
	      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	        funcToString.call(Ctor) == objectCtorString;
	    }

	    /**
	     * Checks if `value` is classified as a `RegExp` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     * @example
	     *
	     * _.isRegExp(/abc/);
	     * // => true
	     *
	     * _.isRegExp('/abc/');
	     * // => false
	     */
	    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

	    /**
	     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
	     * double precision number which isn't the result of a rounded unsafe integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
	     * @example
	     *
	     * _.isSafeInteger(3);
	     * // => true
	     *
	     * _.isSafeInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isSafeInteger(Infinity);
	     * // => false
	     *
	     * _.isSafeInteger('3');
	     * // => false
	     */
	    function isSafeInteger(value) {
	      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
	    }

	    /**
	     * Checks if `value` is classified as a `Set` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     * @example
	     *
	     * _.isSet(new Set);
	     * // => true
	     *
	     * _.isSet(new WeakSet);
	     * // => false
	     */
	    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

	    /**
	     * Checks if `value` is classified as a `String` primitive or object.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	     * @example
	     *
	     * _.isString('abc');
	     * // => true
	     *
	     * _.isString(1);
	     * // => false
	     */
	    function isString(value) {
	      return typeof value == 'string' ||
	        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
	    }

	    /**
	     * Checks if `value` is classified as a `Symbol` primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	     * @example
	     *
	     * _.isSymbol(Symbol.iterator);
	     * // => true
	     *
	     * _.isSymbol('abc');
	     * // => false
	     */
	    function isSymbol(value) {
	      return typeof value == 'symbol' ||
	        (isObjectLike(value) && baseGetTag(value) == symbolTag);
	    }

	    /**
	     * Checks if `value` is classified as a typed array.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     * @example
	     *
	     * _.isTypedArray(new Uint8Array);
	     * // => true
	     *
	     * _.isTypedArray([]);
	     * // => false
	     */
	    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

	    /**
	     * Checks if `value` is `undefined`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	     * @example
	     *
	     * _.isUndefined(void 0);
	     * // => true
	     *
	     * _.isUndefined(null);
	     * // => false
	     */
	    function isUndefined(value) {
	      return value === undefined;
	    }

	    /**
	     * Checks if `value` is classified as a `WeakMap` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
	     * @example
	     *
	     * _.isWeakMap(new WeakMap);
	     * // => true
	     *
	     * _.isWeakMap(new Map);
	     * // => false
	     */
	    function isWeakMap(value) {
	      return isObjectLike(value) && getTag(value) == weakMapTag;
	    }

	    /**
	     * Checks if `value` is classified as a `WeakSet` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
	     * @example
	     *
	     * _.isWeakSet(new WeakSet);
	     * // => true
	     *
	     * _.isWeakSet(new Set);
	     * // => false
	     */
	    function isWeakSet(value) {
	      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
	    }

	    /**
	     * Checks if `value` is less than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     * @see _.gt
	     * @example
	     *
	     * _.lt(1, 3);
	     * // => true
	     *
	     * _.lt(3, 3);
	     * // => false
	     *
	     * _.lt(3, 1);
	     * // => false
	     */
	    var lt = createRelationalOperation(baseLt);

	    /**
	     * Checks if `value` is less than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than or equal to
	     *  `other`, else `false`.
	     * @see _.gte
	     * @example
	     *
	     * _.lte(1, 3);
	     * // => true
	     *
	     * _.lte(3, 3);
	     * // => true
	     *
	     * _.lte(3, 1);
	     * // => false
	     */
	    var lte = createRelationalOperation(function(value, other) {
	      return value <= other;
	    });

	    /**
	     * Converts `value` to an array.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the converted array.
	     * @example
	     *
	     * _.toArray({ 'a': 1, 'b': 2 });
	     * // => [1, 2]
	     *
	     * _.toArray('abc');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toArray(1);
	     * // => []
	     *
	     * _.toArray(null);
	     * // => []
	     */
	    function toArray(value) {
	      if (!value) {
	        return [];
	      }
	      if (isArrayLike(value)) {
	        return isString(value) ? stringToArray(value) : copyArray(value);
	      }
	      if (symIterator && value[symIterator]) {
	        return iteratorToArray(value[symIterator]());
	      }
	      var tag = getTag(value),
	          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

	      return func(value);
	    }

	    /**
	     * Converts `value` to a finite number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.12.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted number.
	     * @example
	     *
	     * _.toFinite(3.2);
	     * // => 3.2
	     *
	     * _.toFinite(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toFinite(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toFinite('3.2');
	     * // => 3.2
	     */
	    function toFinite(value) {
	      if (!value) {
	        return value === 0 ? value : 0;
	      }
	      value = toNumber(value);
	      if (value === INFINITY || value === -INFINITY) {
	        var sign = (value < 0 ? -1 : 1);
	        return sign * MAX_INTEGER;
	      }
	      return value === value ? value : 0;
	    }

	    /**
	     * Converts `value` to an integer.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toInteger(3.2);
	     * // => 3
	     *
	     * _.toInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toInteger(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toInteger('3.2');
	     * // => 3
	     */
	    function toInteger(value) {
	      var result = toFinite(value),
	          remainder = result % 1;

	      return result === result ? (remainder ? result - remainder : result) : 0;
	    }

	    /**
	     * Converts `value` to an integer suitable for use as the length of an
	     * array-like object.
	     *
	     * **Note:** This method is based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toLength(3.2);
	     * // => 3
	     *
	     * _.toLength(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toLength(Infinity);
	     * // => 4294967295
	     *
	     * _.toLength('3.2');
	     * // => 3
	     */
	    function toLength(value) {
	      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
	    }

	    /**
	     * Converts `value` to a number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     * @example
	     *
	     * _.toNumber(3.2);
	     * // => 3.2
	     *
	     * _.toNumber(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toNumber(Infinity);
	     * // => Infinity
	     *
	     * _.toNumber('3.2');
	     * // => 3.2
	     */
	    function toNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      if (isObject(value)) {
	        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	        value = isObject(other) ? (other + '') : other;
	      }
	      if (typeof value != 'string') {
	        return value === 0 ? value : +value;
	      }
	      value = baseTrim(value);
	      var isBinary = reIsBinary.test(value);
	      return (isBinary || reIsOctal.test(value))
	        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	        : (reIsBadHex.test(value) ? NAN : +value);
	    }

	    /**
	     * Converts `value` to a plain object flattening inherited enumerable string
	     * keyed properties of `value` to own properties of the plain object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Object} Returns the converted plain object.
	     * @example
	     *
	     * function Foo() {
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.assign({ 'a': 1 }, new Foo);
	     * // => { 'a': 1, 'b': 2 }
	     *
	     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	     * // => { 'a': 1, 'b': 2, 'c': 3 }
	     */
	    function toPlainObject(value) {
	      return copyObject(value, keysIn(value));
	    }

	    /**
	     * Converts `value` to a safe integer. A safe integer can be compared and
	     * represented correctly.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toSafeInteger(3.2);
	     * // => 3
	     *
	     * _.toSafeInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toSafeInteger(Infinity);
	     * // => 9007199254740991
	     *
	     * _.toSafeInteger('3.2');
	     * // => 3
	     */
	    function toSafeInteger(value) {
	      return value
	        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
	        : (value === 0 ? value : 0);
	    }

	    /**
	     * Converts `value` to a string. An empty string is returned for `null`
	     * and `undefined` values. The sign of `-0` is preserved.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.toString(null);
	     * // => ''
	     *
	     * _.toString(-0);
	     * // => '-0'
	     *
	     * _.toString([1, 2, 3]);
	     * // => '1,2,3'
	     */
	    function toString(value) {
	      return value == null ? '' : baseToString(value);
	    }

	    /*------------------------------------------------------------------------*/

	    /**
	     * Assigns own enumerable string keyed properties of source objects to the
	     * destination object. Source objects are applied from left to right.
	     * Subsequent sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object` and is loosely based on
	     * [`Object.assign`](https://mdn.io/Object/assign).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assignIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assign({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var assign = createAssigner(function(object, source) {
	      if (isPrototype(source) || isArrayLike(source)) {
	        copyObject(source, keys(source), object);
	        return;
	      }
	      for (var key in source) {
	        if (hasOwnProperty.call(source, key)) {
	          assignValue(object, key, source[key]);
	        }
	      }
	    });

	    /**
	     * This method is like `_.assign` except that it iterates over own and
	     * inherited source properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extend
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assign
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
	     */
	    var assignIn = createAssigner(function(object, source) {
	      copyObject(source, keysIn(source), object);
	    });

	    /**
	     * This method is like `_.assignIn` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extendWith
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignInWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keysIn(source), object, customizer);
	    });

	    /**
	     * This method is like `_.assign` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignInWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keys(source), object, customizer);
	    });

	    /**
	     * Creates an array of values corresponding to `paths` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Array} Returns the picked values.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _.at(object, ['a[0].b.c', 'a[1]']);
	     * // => [3, 4]
	     */
	    var at = flatRest(baseAt);

	    /**
	     * Creates an object that inherits from the `prototype` object. If a
	     * `properties` object is given, its own enumerable string keyed properties
	     * are assigned to the created object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Object
	     * @param {Object} prototype The object to inherit from.
	     * @param {Object} [properties] The properties to assign to the object.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * function Shape() {
	     *   this.x = 0;
	     *   this.y = 0;
	     * }
	     *
	     * function Circle() {
	     *   Shape.call(this);
	     * }
	     *
	     * Circle.prototype = _.create(Shape.prototype, {
	     *   'constructor': Circle
	     * });
	     *
	     * var circle = new Circle;
	     * circle instanceof Circle;
	     * // => true
	     *
	     * circle instanceof Shape;
	     * // => true
	     */
	    function create(prototype, properties) {
	      var result = baseCreate(prototype);
	      return properties == null ? result : baseAssign(result, properties);
	    }

	    /**
	     * Assigns own and inherited enumerable string keyed properties of source
	     * objects to the destination object for all destination properties that
	     * resolve to `undefined`. Source objects are applied from left to right.
	     * Once a property is set, additional values of the same property are ignored.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaultsDeep
	     * @example
	     *
	     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var defaults = baseRest(function(object, sources) {
	      object = Object(object);

	      var index = -1;
	      var length = sources.length;
	      var guard = length > 2 ? sources[2] : undefined;

	      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	        length = 1;
	      }

	      while (++index < length) {
	        var source = sources[index];
	        var props = keysIn(source);
	        var propsIndex = -1;
	        var propsLength = props.length;

	        while (++propsIndex < propsLength) {
	          var key = props[propsIndex];
	          var value = object[key];

	          if (value === undefined ||
	              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	            object[key] = source[key];
	          }
	        }
	      }

	      return object;
	    });

	    /**
	     * This method is like `_.defaults` except that it recursively assigns
	     * default properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaults
	     * @example
	     *
	     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
	     * // => { 'a': { 'b': 2, 'c': 3 } }
	     */
	    var defaultsDeep = baseRest(function(args) {
	      args.push(undefined, customDefaultsMerge);
	      return apply(mergeWith, undefined, args);
	    });

	    /**
	     * This method is like `_.find` except that it returns the key of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findKey(users, function(o) { return o.age < 40; });
	     * // => 'barney' (iteration order is not guaranteed)
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findKey(users, { 'age': 1, 'active': true });
	     * // => 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findKey(users, 'active');
	     * // => 'barney'
	     */
	    function findKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
	    }

	    /**
	     * This method is like `_.findKey` except that it iterates over elements of
	     * a collection in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findLastKey(users, function(o) { return o.age < 40; });
	     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastKey(users, { 'age': 36, 'active': true });
	     * // => 'barney'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastKey(users, 'active');
	     * // => 'pebbles'
	     */
	    function findLastKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
	    }

	    /**
	     * Iterates over own and inherited enumerable string keyed properties of an
	     * object and invokes `iteratee` for each property. The iteratee is invoked
	     * with three arguments: (value, key, object). Iteratee functions may exit
	     * iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forInRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forIn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
	     */
	    function forIn(object, iteratee) {
	      return object == null
	        ? object
	        : baseFor(object, getIteratee(iteratee, 3), keysIn);
	    }

	    /**
	     * This method is like `_.forIn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forInRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
	     */
	    function forInRight(object, iteratee) {
	      return object == null
	        ? object
	        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
	    }

	    /**
	     * Iterates over own enumerable string keyed properties of an object and
	     * invokes `iteratee` for each property. The iteratee is invoked with three
	     * arguments: (value, key, object). Iteratee functions may exit iteration
	     * early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwnRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forOwn(object, iteratee) {
	      return object && baseForOwn(object, getIteratee(iteratee, 3));
	    }

	    /**
	     * This method is like `_.forOwn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwnRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
	     */
	    function forOwnRight(object, iteratee) {
	      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
	    }

	    /**
	     * Creates an array of function property names from own enumerable properties
	     * of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functionsIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functions(new Foo);
	     * // => ['a', 'b']
	     */
	    function functions(object) {
	      return object == null ? [] : baseFunctions(object, keys(object));
	    }

	    /**
	     * Creates an array of function property names from own and inherited
	     * enumerable properties of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functions
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functionsIn(new Foo);
	     * // => ['a', 'b', 'c']
	     */
	    function functionsIn(object) {
	      return object == null ? [] : baseFunctions(object, keysIn(object));
	    }

	    /**
	     * Gets the value at `path` of `object`. If the resolved value is
	     * `undefined`, the `defaultValue` is returned in its place.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.get(object, 'a[0].b.c');
	     * // => 3
	     *
	     * _.get(object, ['a', '0', 'b', 'c']);
	     * // => 3
	     *
	     * _.get(object, 'a.b.c', 'default');
	     * // => 'default'
	     */
	    function get(object, path, defaultValue) {
	      var result = object == null ? undefined : baseGet(object, path);
	      return result === undefined ? defaultValue : result;
	    }

	    /**
	     * Checks if `path` is a direct property of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = { 'a': { 'b': 2 } };
	     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.has(object, 'a');
	     * // => true
	     *
	     * _.has(object, 'a.b');
	     * // => true
	     *
	     * _.has(object, ['a', 'b']);
	     * // => true
	     *
	     * _.has(other, 'a');
	     * // => false
	     */
	    function has(object, path) {
	      return object != null && hasPath(object, path, baseHas);
	    }

	    /**
	     * Checks if `path` is a direct or inherited property of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.hasIn(object, 'a');
	     * // => true
	     *
	     * _.hasIn(object, 'a.b');
	     * // => true
	     *
	     * _.hasIn(object, ['a', 'b']);
	     * // => true
	     *
	     * _.hasIn(object, 'b');
	     * // => false
	     */
	    function hasIn(object, path) {
	      return object != null && hasPath(object, path, baseHasIn);
	    }

	    /**
	     * Creates an object composed of the inverted keys and values of `object`.
	     * If `object` contains duplicate values, subsequent values overwrite
	     * property assignments of previous values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invert(object);
	     * // => { '1': 'c', '2': 'b' }
	     */
	    var invert = createInverter(function(result, value, key) {
	      if (value != null &&
	          typeof value.toString != 'function') {
	        value = nativeObjectToString.call(value);
	      }

	      result[value] = key;
	    }, constant(identity));

	    /**
	     * This method is like `_.invert` except that the inverted object is generated
	     * from the results of running each element of `object` thru `iteratee`. The
	     * corresponding inverted value of each inverted key is an array of keys
	     * responsible for generating the inverted value. The iteratee is invoked
	     * with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invertBy(object);
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     *
	     * _.invertBy(object, function(value) {
	     *   return 'group' + value;
	     * });
	     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
	     */
	    var invertBy = createInverter(function(result, value, key) {
	      if (value != null &&
	          typeof value.toString != 'function') {
	        value = nativeObjectToString.call(value);
	      }

	      if (hasOwnProperty.call(result, value)) {
	        result[value].push(key);
	      } else {
	        result[value] = [key];
	      }
	    }, getIteratee);

	    /**
	     * Invokes the method at `path` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
	     *
	     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
	     * // => [2, 3]
	     */
	    var invoke = baseRest(baseInvoke);

	    /**
	     * Creates an array of the own enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects. See the
	     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * for more details.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keys(new Foo);
	     * // => ['a', 'b'] (iteration order is not guaranteed)
	     *
	     * _.keys('hi');
	     * // => ['0', '1']
	     */
	    function keys(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	    }

	    /**
	     * Creates an array of the own and inherited enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keysIn(new Foo);
	     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	     */
	    function keysIn(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	    }

	    /**
	     * The opposite of `_.mapValues`; this method creates an object with the
	     * same values as `object` and keys generated by running each own enumerable
	     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
	     * with three arguments: (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapValues
	     * @example
	     *
	     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   return key + value;
	     * });
	     * // => { 'a1': 1, 'b2': 2 }
	     */
	    function mapKeys(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);

	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, iteratee(value, key, object), value);
	      });
	      return result;
	    }

	    /**
	     * Creates an object with the same keys as `object` and values generated
	     * by running each own enumerable string keyed property of `object` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapKeys
	     * @example
	     *
	     * var users = {
	     *   'fred':    { 'user': 'fred',    'age': 40 },
	     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	     * };
	     *
	     * _.mapValues(users, function(o) { return o.age; });
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.mapValues(users, 'age');
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     */
	    function mapValues(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);

	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, key, iteratee(value, key, object));
	      });
	      return result;
	    }

	    /**
	     * This method is like `_.assign` except that it recursively merges own and
	     * inherited enumerable string keyed properties of source objects into the
	     * destination object. Source properties that resolve to `undefined` are
	     * skipped if a destination value exists. Array and plain object properties
	     * are merged recursively. Other objects and value types are overridden by
	     * assignment. Source objects are applied from left to right. Subsequent
	     * sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {
	     *   'a': [{ 'b': 2 }, { 'd': 4 }]
	     * };
	     *
	     * var other = {
	     *   'a': [{ 'c': 3 }, { 'e': 5 }]
	     * };
	     *
	     * _.merge(object, other);
	     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
	     */
	    var merge = createAssigner(function(object, source, srcIndex) {
	      baseMerge(object, source, srcIndex);
	    });

	    /**
	     * This method is like `_.merge` except that it accepts `customizer` which
	     * is invoked to produce the merged values of the destination and source
	     * properties. If `customizer` returns `undefined`, merging is handled by the
	     * method instead. The `customizer` is invoked with six arguments:
	     * (objValue, srcValue, key, object, source, stack).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} customizer The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (_.isArray(objValue)) {
	     *     return objValue.concat(srcValue);
	     *   }
	     * }
	     *
	     * var object = { 'a': [1], 'b': [2] };
	     * var other = { 'a': [3], 'b': [4] };
	     *
	     * _.mergeWith(object, other, customizer);
	     * // => { 'a': [1, 3], 'b': [2, 4] }
	     */
	    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
	      baseMerge(object, source, srcIndex, customizer);
	    });

	    /**
	     * The opposite of `_.pick`; this method creates an object composed of the
	     * own and inherited enumerable property paths of `object` that are not omitted.
	     *
	     * **Note:** This method is considerably slower than `_.pick`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to omit.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omit(object, ['a', 'c']);
	     * // => { 'b': '2' }
	     */
	    var omit = flatRest(function(object, paths) {
	      var result = {};
	      if (object == null) {
	        return result;
	      }
	      var isDeep = false;
	      paths = arrayMap(paths, function(path) {
	        path = castPath(path, object);
	        isDeep || (isDeep = path.length > 1);
	        return path;
	      });
	      copyObject(object, getAllKeysIn(object), result);
	      if (isDeep) {
	        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
	      }
	      var length = paths.length;
	      while (length--) {
	        baseUnset(result, paths[length]);
	      }
	      return result;
	    });

	    /**
	     * The opposite of `_.pickBy`; this method creates an object composed of
	     * the own and inherited enumerable string keyed properties of `object` that
	     * `predicate` doesn't return truthy for. The predicate is invoked with two
	     * arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omitBy(object, _.isNumber);
	     * // => { 'b': '2' }
	     */
	    function omitBy(object, predicate) {
	      return pickBy(object, negate(getIteratee(predicate)));
	    }

	    /**
	     * Creates an object composed of the picked `object` properties.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pick(object, ['a', 'c']);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var pick = flatRest(function(object, paths) {
	      return object == null ? {} : basePick(object, paths);
	    });

	    /**
	     * Creates an object composed of the `object` properties `predicate` returns
	     * truthy for. The predicate is invoked with two arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pickBy(object, _.isNumber);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    function pickBy(object, predicate) {
	      if (object == null) {
	        return {};
	      }
	      var props = arrayMap(getAllKeysIn(object), function(prop) {
	        return [prop];
	      });
	      predicate = getIteratee(predicate);
	      return basePickBy(object, props, function(value, path) {
	        return predicate(value, path[0]);
	      });
	    }

	    /**
	     * This method is like `_.get` except that if the resolved value is a
	     * function it's invoked with the `this` binding of its parent object and
	     * its result is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to resolve.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
	     *
	     * _.result(object, 'a[0].b.c1');
	     * // => 3
	     *
	     * _.result(object, 'a[0].b.c2');
	     * // => 4
	     *
	     * _.result(object, 'a[0].b.c3', 'default');
	     * // => 'default'
	     *
	     * _.result(object, 'a[0].b.c3', _.constant('default'));
	     * // => 'default'
	     */
	    function result(object, path, defaultValue) {
	      path = castPath(path, object);

	      var index = -1,
	          length = path.length;

	      // Ensure the loop is entered when path is empty.
	      if (!length) {
	        length = 1;
	        object = undefined;
	      }
	      while (++index < length) {
	        var value = object == null ? undefined : object[toKey(path[index])];
	        if (value === undefined) {
	          index = length;
	          value = defaultValue;
	        }
	        object = isFunction(value) ? value.call(object) : value;
	      }
	      return object;
	    }

	    /**
	     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
	     * it's created. Arrays are created for missing index properties while objects
	     * are created for all other missing properties. Use `_.setWith` to customize
	     * `path` creation.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.set(object, 'a[0].b.c', 4);
	     * console.log(object.a[0].b.c);
	     * // => 4
	     *
	     * _.set(object, ['x', '0', 'y', 'z'], 5);
	     * console.log(object.x[0].y.z);
	     * // => 5
	     */
	    function set(object, path, value) {
	      return object == null ? object : baseSet(object, path, value);
	    }

	    /**
	     * This method is like `_.set` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.setWith(object, '[0][1]', 'a', Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function setWith(object, path, value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseSet(object, path, value, customizer);
	    }

	    /**
	     * Creates an array of own enumerable string keyed-value pairs for `object`
	     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
	     * entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entries
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairs(new Foo);
	     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
	     */
	    var toPairs = createToPairs(keys);

	    /**
	     * Creates an array of own and inherited enumerable string keyed-value pairs
	     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
	     * or set, its entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entriesIn
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairsIn(new Foo);
	     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
	     */
	    var toPairsIn = createToPairs(keysIn);

	    /**
	     * An alternative to `_.reduce`; this method transforms `object` to a new
	     * `accumulator` object which is the result of running each of its own
	     * enumerable string keyed properties thru `iteratee`, with each invocation
	     * potentially mutating the `accumulator` object. If `accumulator` is not
	     * provided, a new object with the same `[[Prototype]]` will be used. The
	     * iteratee is invoked with four arguments: (accumulator, value, key, object).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The custom accumulator value.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * _.transform([2, 3, 4], function(result, n) {
	     *   result.push(n *= n);
	     *   return n % 2 == 0;
	     * }, []);
	     * // => [4, 9]
	     *
	     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     */
	    function transform(object, iteratee, accumulator) {
	      var isArr = isArray(object),
	          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

	      iteratee = getIteratee(iteratee, 4);
	      if (accumulator == null) {
	        var Ctor = object && object.constructor;
	        if (isArrLike) {
	          accumulator = isArr ? new Ctor : [];
	        }
	        else if (isObject(object)) {
	          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
	        }
	        else {
	          accumulator = {};
	        }
	      }
	      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
	        return iteratee(accumulator, value, index, object);
	      });
	      return accumulator;
	    }

	    /**
	     * Removes the property at `path` of `object`.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
	     * _.unset(object, 'a[0].b.c');
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     *
	     * _.unset(object, ['a', '0', 'b', 'c']);
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     */
	    function unset(object, path) {
	      return object == null ? true : baseUnset(object, path);
	    }

	    /**
	     * This method is like `_.set` except that accepts `updater` to produce the
	     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
	     * is invoked with one argument: (value).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
	     * console.log(object.a[0].b.c);
	     * // => 9
	     *
	     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
	     * console.log(object.x[0].y.z);
	     * // => 0
	     */
	    function update(object, path, updater) {
	      return object == null ? object : baseUpdate(object, path, castFunction(updater));
	    }

	    /**
	     * This method is like `_.update` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function updateWith(object, path, updater, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
	    }

	    /**
	     * Creates an array of the own enumerable string keyed property values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.values(new Foo);
	     * // => [1, 2] (iteration order is not guaranteed)
	     *
	     * _.values('hi');
	     * // => ['h', 'i']
	     */
	    function values(object) {
	      return object == null ? [] : baseValues(object, keys(object));
	    }

	    /**
	     * Creates an array of the own and inherited enumerable string keyed property
	     * values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.valuesIn(new Foo);
	     * // => [1, 2, 3] (iteration order is not guaranteed)
	     */
	    function valuesIn(object) {
	      return object == null ? [] : baseValues(object, keysIn(object));
	    }

	    /*------------------------------------------------------------------------*/

	    /**
	     * Clamps `number` within the inclusive `lower` and `upper` bounds.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Number
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     * @example
	     *
	     * _.clamp(-10, -5, 5);
	     * // => -5
	     *
	     * _.clamp(10, -5, 5);
	     * // => 5
	     */
	    function clamp(number, lower, upper) {
	      if (upper === undefined) {
	        upper = lower;
	        lower = undefined;
	      }
	      if (upper !== undefined) {
	        upper = toNumber(upper);
	        upper = upper === upper ? upper : 0;
	      }
	      if (lower !== undefined) {
	        lower = toNumber(lower);
	        lower = lower === lower ? lower : 0;
	      }
	      return baseClamp(toNumber(number), lower, upper);
	    }

	    /**
	     * Checks if `n` is between `start` and up to, but not including, `end`. If
	     * `end` is not specified, it's set to `start` with `start` then set to `0`.
	     * If `start` is greater than `end` the params are swapped to support
	     * negative ranges.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.3.0
	     * @category Number
	     * @param {number} number The number to check.
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     * @see _.range, _.rangeRight
	     * @example
	     *
	     * _.inRange(3, 2, 4);
	     * // => true
	     *
	     * _.inRange(4, 8);
	     * // => true
	     *
	     * _.inRange(4, 2);
	     * // => false
	     *
	     * _.inRange(2, 2);
	     * // => false
	     *
	     * _.inRange(1.2, 2);
	     * // => true
	     *
	     * _.inRange(5.2, 4);
	     * // => false
	     *
	     * _.inRange(-3, -2, -6);
	     * // => true
	     */
	    function inRange(number, start, end) {
	      start = toFinite(start);
	      if (end === undefined) {
	        end = start;
	        start = 0;
	      } else {
	        end = toFinite(end);
	      }
	      number = toNumber(number);
	      return baseInRange(number, start, end);
	    }

	    /**
	     * Produces a random number between the inclusive `lower` and `upper` bounds.
	     * If only one argument is provided a number between `0` and the given number
	     * is returned. If `floating` is `true`, or either `lower` or `upper` are
	     * floats, a floating-point number is returned instead of an integer.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Number
	     * @param {number} [lower=0] The lower bound.
	     * @param {number} [upper=1] The upper bound.
	     * @param {boolean} [floating] Specify returning a floating-point number.
	     * @returns {number} Returns the random number.
	     * @example
	     *
	     * _.random(0, 5);
	     * // => an integer between 0 and 5
	     *
	     * _.random(5);
	     * // => also an integer between 0 and 5
	     *
	     * _.random(5, true);
	     * // => a floating-point number between 0 and 5
	     *
	     * _.random(1.2, 5.2);
	     * // => a floating-point number between 1.2 and 5.2
	     */
	    function random(lower, upper, floating) {
	      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
	        upper = floating = undefined;
	      }
	      if (floating === undefined) {
	        if (typeof upper == 'boolean') {
	          floating = upper;
	          upper = undefined;
	        }
	        else if (typeof lower == 'boolean') {
	          floating = lower;
	          lower = undefined;
	        }
	      }
	      if (lower === undefined && upper === undefined) {
	        lower = 0;
	        upper = 1;
	      }
	      else {
	        lower = toFinite(lower);
	        if (upper === undefined) {
	          upper = lower;
	          lower = 0;
	        } else {
	          upper = toFinite(upper);
	        }
	      }
	      if (lower > upper) {
	        var temp = lower;
	        lower = upper;
	        upper = temp;
	      }
	      if (floating || lower % 1 || upper % 1) {
	        var rand = nativeRandom();
	        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
	      }
	      return baseRandom(lower, upper);
	    }

	    /*------------------------------------------------------------------------*/

	    /**
	     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the camel cased string.
	     * @example
	     *
	     * _.camelCase('Foo Bar');
	     * // => 'fooBar'
	     *
	     * _.camelCase('--foo-bar--');
	     * // => 'fooBar'
	     *
	     * _.camelCase('__FOO_BAR__');
	     * // => 'fooBar'
	     */
	    var camelCase = createCompounder(function(result, word, index) {
	      word = word.toLowerCase();
	      return result + (index ? capitalize(word) : word);
	    });

	    /**
	     * Converts the first character of `string` to upper case and the remaining
	     * to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to capitalize.
	     * @returns {string} Returns the capitalized string.
	     * @example
	     *
	     * _.capitalize('FRED');
	     * // => 'Fred'
	     */
	    function capitalize(string) {
	      return upperFirst(toString(string).toLowerCase());
	    }

	    /**
	     * Deburrs `string` by converting
	     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
	     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
	     * letters to basic Latin letters and removing
	     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to deburr.
	     * @returns {string} Returns the deburred string.
	     * @example
	     *
	     * _.deburr('déjà vu');
	     * // => 'deja vu'
	     */
	    function deburr(string) {
	      string = toString(string);
	      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
	    }

	    /**
	     * Checks if `string` ends with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=string.length] The position to search up to.
	     * @returns {boolean} Returns `true` if `string` ends with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.endsWith('abc', 'c');
	     * // => true
	     *
	     * _.endsWith('abc', 'b');
	     * // => false
	     *
	     * _.endsWith('abc', 'b', 2);
	     * // => true
	     */
	    function endsWith(string, target, position) {
	      string = toString(string);
	      target = baseToString(target);

	      var length = string.length;
	      position = position === undefined
	        ? length
	        : baseClamp(toInteger(position), 0, length);

	      var end = position;
	      position -= target.length;
	      return position >= 0 && string.slice(position, end) == target;
	    }

	    /**
	     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
	     * corresponding HTML entities.
	     *
	     * **Note:** No other characters are escaped. To escape additional
	     * characters use a third-party library like [_he_](https://mths.be/he).
	     *
	     * Though the ">" character is escaped for symmetry, characters like
	     * ">" and "/" don't need escaping in HTML and have no special meaning
	     * unless they're part of a tag or unquoted attribute value. See
	     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
	     * (under "semi-related fun fact") for more details.
	     *
	     * When working with HTML you should always
	     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
	     * XSS vectors.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escape('fred, barney, & pebbles');
	     * // => 'fred, barney, &amp; pebbles'
	     */
	    function escape(string) {
	      string = toString(string);
	      return (string && reHasUnescapedHtml.test(string))
	        ? string.replace(reUnescapedHtml, escapeHtmlChar)
	        : string;
	    }

	    /**
	     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
	     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escapeRegExp('[lodash](https://lodash.com/)');
	     * // => '\[lodash\]\(https://lodash\.com/\)'
	     */
	    function escapeRegExp(string) {
	      string = toString(string);
	      return (string && reHasRegExpChar.test(string))
	        ? string.replace(reRegExpChar, '\\$&')
	        : string;
	    }

	    /**
	     * Converts `string` to
	     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the kebab cased string.
	     * @example
	     *
	     * _.kebabCase('Foo Bar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('fooBar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('__FOO_BAR__');
	     * // => 'foo-bar'
	     */
	    var kebabCase = createCompounder(function(result, word, index) {
	      return result + (index ? '-' : '') + word.toLowerCase();
	    });

	    /**
	     * Converts `string`, as space separated words, to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.lowerCase('--Foo-Bar--');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('fooBar');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('__FOO_BAR__');
	     * // => 'foo bar'
	     */
	    var lowerCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toLowerCase();
	    });

	    /**
	     * Converts the first character of `string` to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.lowerFirst('Fred');
	     * // => 'fred'
	     *
	     * _.lowerFirst('FRED');
	     * // => 'fRED'
	     */
	    var lowerFirst = createCaseFirst('toLowerCase');

	    /**
	     * Pads `string` on the left and right sides if it's shorter than `length`.
	     * Padding characters are truncated if they can't be evenly divided by `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.pad('abc', 8);
	     * // => '  abc   '
	     *
	     * _.pad('abc', 8, '_-');
	     * // => '_-abc_-_'
	     *
	     * _.pad('abc', 3);
	     * // => 'abc'
	     */
	    function pad(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);

	      var strLength = length ? stringSize(string) : 0;
	      if (!length || strLength >= length) {
	        return string;
	      }
	      var mid = (length - strLength) / 2;
	      return (
	        createPadding(nativeFloor(mid), chars) +
	        string +
	        createPadding(nativeCeil(mid), chars)
	      );
	    }

	    /**
	     * Pads `string` on the right side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padEnd('abc', 6);
	     * // => 'abc   '
	     *
	     * _.padEnd('abc', 6, '_-');
	     * // => 'abc_-_'
	     *
	     * _.padEnd('abc', 3);
	     * // => 'abc'
	     */
	    function padEnd(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);

	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (string + createPadding(length - strLength, chars))
	        : string;
	    }

	    /**
	     * Pads `string` on the left side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padStart('abc', 6);
	     * // => '   abc'
	     *
	     * _.padStart('abc', 6, '_-');
	     * // => '_-_abc'
	     *
	     * _.padStart('abc', 3);
	     * // => 'abc'
	     */
	    function padStart(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);

	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (createPadding(length - strLength, chars) + string)
	        : string;
	    }

	    /**
	     * Converts `string` to an integer of the specified radix. If `radix` is
	     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
	     * hexadecimal, in which case a `radix` of `16` is used.
	     *
	     * **Note:** This method aligns with the
	     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category String
	     * @param {string} string The string to convert.
	     * @param {number} [radix=10] The radix to interpret `value` by.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.parseInt('08');
	     * // => 8
	     *
	     * _.map(['6', '08', '10'], _.parseInt);
	     * // => [6, 8, 10]
	     */
	    function parseInt(string, radix, guard) {
	      if (guard || radix == null) {
	        radix = 0;
	      } else if (radix) {
	        radix = +radix;
	      }
	      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
	    }

	    /**
	     * Repeats the given string `n` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to repeat.
	     * @param {number} [n=1] The number of times to repeat the string.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the repeated string.
	     * @example
	     *
	     * _.repeat('*', 3);
	     * // => '***'
	     *
	     * _.repeat('abc', 2);
	     * // => 'abcabc'
	     *
	     * _.repeat('abc', 0);
	     * // => ''
	     */
	    function repeat(string, n, guard) {
	      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      return baseRepeat(toString(string), n);
	    }

	    /**
	     * Replaces matches for `pattern` in `string` with `replacement`.
	     *
	     * **Note:** This method is based on
	     * [`String#replace`](https://mdn.io/String/replace).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to modify.
	     * @param {RegExp|string} pattern The pattern to replace.
	     * @param {Function|string} replacement The match replacement.
	     * @returns {string} Returns the modified string.
	     * @example
	     *
	     * _.replace('Hi Fred', 'Fred', 'Barney');
	     * // => 'Hi Barney'
	     */
	    function replace() {
	      var args = arguments,
	          string = toString(args[0]);

	      return args.length < 3 ? string : string.replace(args[1], args[2]);
	    }

	    /**
	     * Converts `string` to
	     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the snake cased string.
	     * @example
	     *
	     * _.snakeCase('Foo Bar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('fooBar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('--FOO-BAR--');
	     * // => 'foo_bar'
	     */
	    var snakeCase = createCompounder(function(result, word, index) {
	      return result + (index ? '_' : '') + word.toLowerCase();
	    });

	    /**
	     * Splits `string` by `separator`.
	     *
	     * **Note:** This method is based on
	     * [`String#split`](https://mdn.io/String/split).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to split.
	     * @param {RegExp|string} separator The separator pattern to split by.
	     * @param {number} [limit] The length to truncate results to.
	     * @returns {Array} Returns the string segments.
	     * @example
	     *
	     * _.split('a-b-c', '-', 2);
	     * // => ['a', 'b']
	     */
	    function split(string, separator, limit) {
	      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
	        separator = limit = undefined;
	      }
	      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
	      if (!limit) {
	        return [];
	      }
	      string = toString(string);
	      if (string && (
	            typeof separator == 'string' ||
	            (separator != null && !isRegExp(separator))
	          )) {
	        separator = baseToString(separator);
	        if (!separator && hasUnicode(string)) {
	          return castSlice(stringToArray(string), 0, limit);
	        }
	      }
	      return string.split(separator, limit);
	    }

	    /**
	     * Converts `string` to
	     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.1.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the start cased string.
	     * @example
	     *
	     * _.startCase('--foo-bar--');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('fooBar');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('__FOO_BAR__');
	     * // => 'FOO BAR'
	     */
	    var startCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + upperFirst(word);
	    });

	    /**
	     * Checks if `string` starts with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=0] The position to search from.
	     * @returns {boolean} Returns `true` if `string` starts with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.startsWith('abc', 'a');
	     * // => true
	     *
	     * _.startsWith('abc', 'b');
	     * // => false
	     *
	     * _.startsWith('abc', 'b', 1);
	     * // => true
	     */
	    function startsWith(string, target, position) {
	      string = toString(string);
	      position = position == null
	        ? 0
	        : baseClamp(toInteger(position), 0, string.length);

	      target = baseToString(target);
	      return string.slice(position, position + target.length) == target;
	    }

	    /**
	     * Creates a compiled template function that can interpolate data properties
	     * in "interpolate" delimiters, HTML-escape interpolated data properties in
	     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
	     * properties may be accessed as free variables in the template. If a setting
	     * object is given, it takes precedence over `_.templateSettings` values.
	     *
	     * **Note:** In the development build `_.template` utilizes
	     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
	     * for easier debugging.
	     *
	     * For more information on precompiling templates see
	     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
	     *
	     * For more information on Chrome extension sandboxes see
	     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The template string.
	     * @param {Object} [options={}] The options object.
	     * @param {RegExp} [options.escape=_.templateSettings.escape]
	     *  The HTML "escape" delimiter.
	     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
	     *  The "evaluate" delimiter.
	     * @param {Object} [options.imports=_.templateSettings.imports]
	     *  An object to import into the template as free variables.
	     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
	     *  The "interpolate" delimiter.
	     * @param {string} [options.sourceURL='lodash.templateSources[n]']
	     *  The sourceURL of the compiled template.
	     * @param {string} [options.variable='obj']
	     *  The data object variable name.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the compiled template function.
	     * @example
	     *
	     * // Use the "interpolate" delimiter to create a compiled template.
	     * var compiled = _.template('hello <%= user %>!');
	     * compiled({ 'user': 'fred' });
	     * // => 'hello fred!'
	     *
	     * // Use the HTML "escape" delimiter to escape data property values.
	     * var compiled = _.template('<b><%- value %></b>');
	     * compiled({ 'value': '<script>' });
	     * // => '<b>&lt;script&gt;</b>'
	     *
	     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
	     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the internal `print` function in "evaluate" delimiters.
	     * var compiled = _.template('<% print("hello " + user); %>!');
	     * compiled({ 'user': 'barney' });
	     * // => 'hello barney!'
	     *
	     * // Use the ES template literal delimiter as an "interpolate" delimiter.
	     * // Disable support by replacing the "interpolate" delimiter.
	     * var compiled = _.template('hello ${ user }!');
	     * compiled({ 'user': 'pebbles' });
	     * // => 'hello pebbles!'
	     *
	     * // Use backslashes to treat delimiters as plain text.
	     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
	     * compiled({ 'value': 'ignored' });
	     * // => '<%- value %>'
	     *
	     * // Use the `imports` option to import `jQuery` as `jq`.
	     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
	     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
	     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
	     * compiled(data);
	     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
	     *
	     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
	     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
	     * compiled.source;
	     * // => function(data) {
	     * //   var __t, __p = '';
	     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
	     * //   return __p;
	     * // }
	     *
	     * // Use custom template delimiters.
	     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
	     * var compiled = _.template('hello {{ user }}!');
	     * compiled({ 'user': 'mustache' });
	     * // => 'hello mustache!'
	     *
	     * // Use the `source` property to inline compiled templates for meaningful
	     * // line numbers in error messages and stack traces.
	     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
	     *   var JST = {\
	     *     "main": ' + _.template(mainText).source + '\
	     *   };\
	     * ');
	     */
	    function template(string, options, guard) {
	      // Based on John Resig's `tmpl` implementation
	      // (http://ejohn.org/blog/javascript-micro-templating/)
	      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
	      var settings = lodash.templateSettings;

	      if (guard && isIterateeCall(string, options, guard)) {
	        options = undefined;
	      }
	      string = toString(string);
	      options = assignInWith({}, options, settings, customDefaultsAssignIn);

	      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
	          importsKeys = keys(imports),
	          importsValues = baseValues(imports, importsKeys);

	      var isEscaping,
	          isEvaluating,
	          index = 0,
	          interpolate = options.interpolate || reNoMatch,
	          source = "__p += '";

	      // Compile the regexp to match each delimiter.
	      var reDelimiters = RegExp(
	        (options.escape || reNoMatch).source + '|' +
	        interpolate.source + '|' +
	        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
	        (options.evaluate || reNoMatch).source + '|$'
	      , 'g');

	      // Use a sourceURL for easier debugging.
	      // The sourceURL gets injected into the source that's eval-ed, so be careful
	      // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
	      // and escape the comment, thus injecting code that gets evaled.
	      var sourceURL = '//# sourceURL=' +
	        (hasOwnProperty.call(options, 'sourceURL')
	          ? (options.sourceURL + '').replace(/\s/g, ' ')
	          : ('lodash.templateSources[' + (++templateCounter) + ']')
	        ) + '\n';

	      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
	        interpolateValue || (interpolateValue = esTemplateValue);

	        // Escape characters that can't be included in string literals.
	        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

	        // Replace delimiters with snippets.
	        if (escapeValue) {
	          isEscaping = true;
	          source += "' +\n__e(" + escapeValue + ") +\n'";
	        }
	        if (evaluateValue) {
	          isEvaluating = true;
	          source += "';\n" + evaluateValue + ";\n__p += '";
	        }
	        if (interpolateValue) {
	          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
	        }
	        index = offset + match.length;

	        // The JS engine embedded in Adobe products needs `match` returned in
	        // order to produce the correct `offset` value.
	        return match;
	      });

	      source += "';\n";

	      // If `variable` is not specified wrap a with-statement around the generated
	      // code to add the data object to the top of the scope chain.
	      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
	      if (!variable) {
	        source = 'with (obj) {\n' + source + '\n}\n';
	      }
	      // Throw an error if a forbidden character was found in `variable`, to prevent
	      // potential command injection attacks.
	      else if (reForbiddenIdentifierChars.test(variable)) {
	        throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
	      }

	      // Cleanup code by stripping empty strings.
	      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
	        .replace(reEmptyStringMiddle, '$1')
	        .replace(reEmptyStringTrailing, '$1;');

	      // Frame code as the function body.
	      source = 'function(' + (variable || 'obj') + ') {\n' +
	        (variable
	          ? ''
	          : 'obj || (obj = {});\n'
	        ) +
	        "var __t, __p = ''" +
	        (isEscaping
	           ? ', __e = _.escape'
	           : ''
	        ) +
	        (isEvaluating
	          ? ', __j = Array.prototype.join;\n' +
	            "function print() { __p += __j.call(arguments, '') }\n"
	          : ';\n'
	        ) +
	        source +
	        'return __p\n}';

	      var result = attempt(function() {
	        return Function(importsKeys, sourceURL + 'return ' + source)
	          .apply(undefined, importsValues);
	      });

	      // Provide the compiled function's source by its `toString` method or
	      // the `source` property as a convenience for inlining compiled templates.
	      result.source = source;
	      if (isError(result)) {
	        throw result;
	      }
	      return result;
	    }

	    /**
	     * Converts `string`, as a whole, to lower case just like
	     * [String#toLowerCase](https://mdn.io/toLowerCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.toLower('--Foo-Bar--');
	     * // => '--foo-bar--'
	     *
	     * _.toLower('fooBar');
	     * // => 'foobar'
	     *
	     * _.toLower('__FOO_BAR__');
	     * // => '__foo_bar__'
	     */
	    function toLower(value) {
	      return toString(value).toLowerCase();
	    }

	    /**
	     * Converts `string`, as a whole, to upper case just like
	     * [String#toUpperCase](https://mdn.io/toUpperCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.toUpper('--foo-bar--');
	     * // => '--FOO-BAR--'
	     *
	     * _.toUpper('fooBar');
	     * // => 'FOOBAR'
	     *
	     * _.toUpper('__foo_bar__');
	     * // => '__FOO_BAR__'
	     */
	    function toUpper(value) {
	      return toString(value).toUpperCase();
	    }

	    /**
	     * Removes leading and trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trim('  abc  ');
	     * // => 'abc'
	     *
	     * _.trim('-_-abc-_-', '_-');
	     * // => 'abc'
	     *
	     * _.map(['  foo  ', '  bar  '], _.trim);
	     * // => ['foo', 'bar']
	     */
	    function trim(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return baseTrim(string);
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          chrSymbols = stringToArray(chars),
	          start = charsStartIndex(strSymbols, chrSymbols),
	          end = charsEndIndex(strSymbols, chrSymbols) + 1;

	      return castSlice(strSymbols, start, end).join('');
	    }

	    /**
	     * Removes trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimEnd('  abc  ');
	     * // => '  abc'
	     *
	     * _.trimEnd('-_-abc-_-', '_-');
	     * // => '-_-abc'
	     */
	    function trimEnd(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.slice(0, trimmedEndIndex(string) + 1);
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

	      return castSlice(strSymbols, 0, end).join('');
	    }

	    /**
	     * Removes leading whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimStart('  abc  ');
	     * // => 'abc  '
	     *
	     * _.trimStart('-_-abc-_-', '_-');
	     * // => 'abc-_-'
	     */
	    function trimStart(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrimStart, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          start = charsStartIndex(strSymbols, stringToArray(chars));

	      return castSlice(strSymbols, start).join('');
	    }

	    /**
	     * Truncates `string` if it's longer than the given maximum string length.
	     * The last characters of the truncated string are replaced with the omission
	     * string which defaults to "...".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to truncate.
	     * @param {Object} [options={}] The options object.
	     * @param {number} [options.length=30] The maximum string length.
	     * @param {string} [options.omission='...'] The string to indicate text is omitted.
	     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
	     * @returns {string} Returns the truncated string.
	     * @example
	     *
	     * _.truncate('hi-diddly-ho there, neighborino');
	     * // => 'hi-diddly-ho there, neighbo...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': ' '
	     * });
	     * // => 'hi-diddly-ho there,...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': /,? +/
	     * });
	     * // => 'hi-diddly-ho there...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'omission': ' [...]'
	     * });
	     * // => 'hi-diddly-ho there, neig [...]'
	     */
	    function truncate(string, options) {
	      var length = DEFAULT_TRUNC_LENGTH,
	          omission = DEFAULT_TRUNC_OMISSION;

	      if (isObject(options)) {
	        var separator = 'separator' in options ? options.separator : separator;
	        length = 'length' in options ? toInteger(options.length) : length;
	        omission = 'omission' in options ? baseToString(options.omission) : omission;
	      }
	      string = toString(string);

	      var strLength = string.length;
	      if (hasUnicode(string)) {
	        var strSymbols = stringToArray(string);
	        strLength = strSymbols.length;
	      }
	      if (length >= strLength) {
	        return string;
	      }
	      var end = length - stringSize(omission);
	      if (end < 1) {
	        return omission;
	      }
	      var result = strSymbols
	        ? castSlice(strSymbols, 0, end).join('')
	        : string.slice(0, end);

	      if (separator === undefined) {
	        return result + omission;
	      }
	      if (strSymbols) {
	        end += (result.length - end);
	      }
	      if (isRegExp(separator)) {
	        if (string.slice(end).search(separator)) {
	          var match,
	              substring = result;

	          if (!separator.global) {
	            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
	          }
	          separator.lastIndex = 0;
	          while ((match = separator.exec(substring))) {
	            var newEnd = match.index;
	          }
	          result = result.slice(0, newEnd === undefined ? end : newEnd);
	        }
	      } else if (string.indexOf(baseToString(separator), end) != end) {
	        var index = result.lastIndexOf(separator);
	        if (index > -1) {
	          result = result.slice(0, index);
	        }
	      }
	      return result + omission;
	    }

	    /**
	     * The inverse of `_.escape`; this method converts the HTML entities
	     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
	     * their corresponding characters.
	     *
	     * **Note:** No other HTML entities are unescaped. To unescape additional
	     * HTML entities use a third-party library like [_he_](https://mths.be/he).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.6.0
	     * @category String
	     * @param {string} [string=''] The string to unescape.
	     * @returns {string} Returns the unescaped string.
	     * @example
	     *
	     * _.unescape('fred, barney, &amp; pebbles');
	     * // => 'fred, barney, & pebbles'
	     */
	    function unescape(string) {
	      string = toString(string);
	      return (string && reHasEscapedHtml.test(string))
	        ? string.replace(reEscapedHtml, unescapeHtmlChar)
	        : string;
	    }

	    /**
	     * Converts `string`, as space separated words, to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.upperCase('--foo-bar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('fooBar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('__foo_bar__');
	     * // => 'FOO BAR'
	     */
	    var upperCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toUpperCase();
	    });

	    /**
	     * Converts the first character of `string` to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.upperFirst('fred');
	     * // => 'Fred'
	     *
	     * _.upperFirst('FRED');
	     * // => 'FRED'
	     */
	    var upperFirst = createCaseFirst('toUpperCase');

	    /**
	     * Splits `string` into an array of its words.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {RegExp|string} [pattern] The pattern to match words.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the words of `string`.
	     * @example
	     *
	     * _.words('fred, barney, & pebbles');
	     * // => ['fred', 'barney', 'pebbles']
	     *
	     * _.words('fred, barney, & pebbles', /[^, ]+/g);
	     * // => ['fred', 'barney', '&', 'pebbles']
	     */
	    function words(string, pattern, guard) {
	      string = toString(string);
	      pattern = guard ? undefined : pattern;

	      if (pattern === undefined) {
	        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
	      }
	      return string.match(pattern) || [];
	    }

	    /*------------------------------------------------------------------------*/

	    /**
	     * Attempts to invoke `func`, returning either the result or the caught error
	     * object. Any additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Function} func The function to attempt.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {*} Returns the `func` result or error object.
	     * @example
	     *
	     * // Avoid throwing errors for invalid selectors.
	     * var elements = _.attempt(function(selector) {
	     *   return document.querySelectorAll(selector);
	     * }, '>_>');
	     *
	     * if (_.isError(elements)) {
	     *   elements = [];
	     * }
	     */
	    var attempt = baseRest(function(func, args) {
	      try {
	        return apply(func, undefined, args);
	      } catch (e) {
	        return isError(e) ? e : new Error(e);
	      }
	    });

	    /**
	     * Binds methods of an object to the object itself, overwriting the existing
	     * method.
	     *
	     * **Note:** This method doesn't set the "length" property of bound functions.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Object} object The object to bind and assign the bound methods to.
	     * @param {...(string|string[])} methodNames The object method names to bind.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var view = {
	     *   'label': 'docs',
	     *   'click': function() {
	     *     console.log('clicked ' + this.label);
	     *   }
	     * };
	     *
	     * _.bindAll(view, ['click']);
	     * jQuery(element).on('click', view.click);
	     * // => Logs 'clicked docs' when clicked.
	     */
	    var bindAll = flatRest(function(object, methodNames) {
	      arrayEach(methodNames, function(key) {
	        key = toKey(key);
	        baseAssignValue(object, key, bind(object[key], object));
	      });
	      return object;
	    });

	    /**
	     * Creates a function that iterates over `pairs` and invokes the corresponding
	     * function of the first predicate to return truthy. The predicate-function
	     * pairs are invoked with the `this` binding and arguments of the created
	     * function.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Array} pairs The predicate-function pairs.
	     * @returns {Function} Returns the new composite function.
	     * @example
	     *
	     * var func = _.cond([
	     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
	     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
	     *   [_.stubTrue,                      _.constant('no match')]
	     * ]);
	     *
	     * func({ 'a': 1, 'b': 2 });
	     * // => 'matches A'
	     *
	     * func({ 'a': 0, 'b': 1 });
	     * // => 'matches B'
	     *
	     * func({ 'a': '1', 'b': '2' });
	     * // => 'no match'
	     */
	    function cond(pairs) {
	      var length = pairs == null ? 0 : pairs.length,
	          toIteratee = getIteratee();

	      pairs = !length ? [] : arrayMap(pairs, function(pair) {
	        if (typeof pair[1] != 'function') {
	          throw new TypeError(FUNC_ERROR_TEXT);
	        }
	        return [toIteratee(pair[0]), pair[1]];
	      });

	      return baseRest(function(args) {
	        var this$1 = this;

	        var index = -1;
	        while (++index < length) {
	          var pair = pairs[index];
	          if (apply(pair[0], this$1, args)) {
	            return apply(pair[1], this$1, args);
	          }
	        }
	      });
	    }

	    /**
	     * Creates a function that invokes the predicate properties of `source` with
	     * the corresponding property values of a given object, returning `true` if
	     * all predicates return truthy, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.conformsTo` with
	     * `source` partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 2, 'b': 1 },
	     *   { 'a': 1, 'b': 2 }
	     * ];
	     *
	     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
	     * // => [{ 'a': 1, 'b': 2 }]
	     */
	    function conforms(source) {
	      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
	    }

	    /**
	     * Creates a function that returns `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {*} value The value to return from the new function.
	     * @returns {Function} Returns the new constant function.
	     * @example
	     *
	     * var objects = _.times(2, _.constant({ 'a': 1 }));
	     *
	     * console.log(objects);
	     * // => [{ 'a': 1 }, { 'a': 1 }]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => true
	     */
	    function constant(value) {
	      return function() {
	        return value;
	      };
	    }

	    /**
	     * Checks `value` to determine whether a default value should be returned in
	     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
	     * or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Util
	     * @param {*} value The value to check.
	     * @param {*} defaultValue The default value.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * _.defaultTo(1, 10);
	     * // => 1
	     *
	     * _.defaultTo(undefined, 10);
	     * // => 10
	     */
	    function defaultTo(value, defaultValue) {
	      return (value == null || value !== value) ? defaultValue : value;
	    }

	    /**
	     * Creates a function that returns the result of invoking the given functions
	     * with the `this` binding of the created function, where each successive
	     * invocation is supplied the return value of the previous.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flowRight
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flow([_.add, square]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flow = createFlow();

	    /**
	     * This method is like `_.flow` except that it creates a function that
	     * invokes the given functions from right to left.
	     *
	     * @static
	     * @since 3.0.0
	     * @memberOf _
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flow
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flowRight([square, _.add]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flowRight = createFlow(true);

	    /**
	     * This method returns the first argument it receives.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {*} value Any value.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     *
	     * console.log(_.identity(object) === object);
	     * // => true
	     */
	    function identity(value) {
	      return value;
	    }

	    /**
	     * Creates a function that invokes `func` with the arguments of the created
	     * function. If `func` is a property name, the created function returns the
	     * property value for a given element. If `func` is an array or object, the
	     * created function returns `true` for elements that contain the equivalent
	     * source properties, otherwise it returns `false`.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Util
	     * @param {*} [func=_.identity] The value to convert to a callback.
	     * @returns {Function} Returns the callback.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
	     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, _.iteratee(['user', 'fred']));
	     * // => [{ 'user': 'fred', 'age': 40 }]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, _.iteratee('user'));
	     * // => ['barney', 'fred']
	     *
	     * // Create custom iteratee shorthands.
	     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
	     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
	     *     return func.test(string);
	     *   };
	     * });
	     *
	     * _.filter(['abc', 'def'], /ef/);
	     * // => ['def']
	     */
	    function iteratee(func) {
	      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
	    }

	    /**
	     * Creates a function that performs a partial deep comparison between a given
	     * object and `source`, returning `true` if the given object has equivalent
	     * property values, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.isMatch` with `source`
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * **Note:** Multiple values can be checked by combining several matchers
	     * using `_.overSome`
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
	     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
	     *
	     * // Checking for several possible values
	     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
	     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
	     */
	    function matches(source) {
	      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
	    }

	    /**
	     * Creates a function that performs a partial deep comparison between the
	     * value at `path` of a given object to `srcValue`, returning `true` if the
	     * object value is equivalent, else `false`.
	     *
	     * **Note:** Partial comparisons will match empty array and empty object
	     * `srcValue` values against any array or object value, respectively. See
	     * `_.isEqual` for a list of supported value comparisons.
	     *
	     * **Note:** Multiple values can be checked by combining several matchers
	     * using `_.overSome`
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.find(objects, _.matchesProperty('a', 4));
	     * // => { 'a': 4, 'b': 5, 'c': 6 }
	     *
	     * // Checking for several possible values
	     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
	     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
	     */
	    function matchesProperty(path, srcValue) {
	      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
	    }

	    /**
	     * Creates a function that invokes the method at `path` of a given object.
	     * Any additional arguments are provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': _.constant(2) } },
	     *   { 'a': { 'b': _.constant(1) } }
	     * ];
	     *
	     * _.map(objects, _.method('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(objects, _.method(['a', 'b']));
	     * // => [2, 1]
	     */
	    var method = baseRest(function(path, args) {
	      return function(object) {
	        return baseInvoke(object, path, args);
	      };
	    });

	    /**
	     * The opposite of `_.method`; this method creates a function that invokes
	     * the method at a given path of `object`. Any additional arguments are
	     * provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var array = _.times(3, _.constant),
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
	     * // => [2, 0]
	     */
	    var methodOf = baseRest(function(object, args) {
	      return function(path) {
	        return baseInvoke(object, path, args);
	      };
	    });

	    /**
	     * Adds all own enumerable string keyed function properties of a source
	     * object to the destination object. If `object` is a function, then methods
	     * are added to its prototype as well.
	     *
	     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
	     * avoid conflicts caused by modifying the original.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Function|Object} [object=lodash] The destination object.
	     * @param {Object} source The object of functions to add.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
	     * @returns {Function|Object} Returns `object`.
	     * @example
	     *
	     * function vowels(string) {
	     *   return _.filter(string, function(v) {
	     *     return /[aeiou]/i.test(v);
	     *   });
	     * }
	     *
	     * _.mixin({ 'vowels': vowels });
	     * _.vowels('fred');
	     * // => ['e']
	     *
	     * _('fred').vowels().value();
	     * // => ['e']
	     *
	     * _.mixin({ 'vowels': vowels }, { 'chain': false });
	     * _('fred').vowels();
	     * // => ['e']
	     */
	    function mixin(object, source, options) {
	      var props = keys(source),
	          methodNames = baseFunctions(source, props);

	      if (options == null &&
	          !(isObject(source) && (methodNames.length || !props.length))) {
	        options = source;
	        source = object;
	        object = this;
	        methodNames = baseFunctions(source, keys(source));
	      }
	      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
	          isFunc = isFunction(object);

	      arrayEach(methodNames, function(methodName) {
	        var func = source[methodName];
	        object[methodName] = func;
	        if (isFunc) {
	          object.prototype[methodName] = function() {
	            var chainAll = this.__chain__;
	            if (chain || chainAll) {
	              var result = object(this.__wrapped__),
	                  actions = result.__actions__ = copyArray(this.__actions__);

	              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
	              result.__chain__ = chainAll;
	              return result;
	            }
	            return func.apply(object, arrayPush([this.value()], arguments));
	          };
	        }
	      });

	      return object;
	    }

	    /**
	     * Reverts the `_` variable to its previous value and returns a reference to
	     * the `lodash` function.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @returns {Function} Returns the `lodash` function.
	     * @example
	     *
	     * var lodash = _.noConflict();
	     */
	    function noConflict() {
	      if (root._ === this) {
	        root._ = oldDash;
	      }
	      return this;
	    }

	    /**
	     * This method returns `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Util
	     * @example
	     *
	     * _.times(2, _.noop);
	     * // => [undefined, undefined]
	     */
	    function noop() {
	      // No operation performed.
	    }

	    /**
	     * Creates a function that gets the argument at index `n`. If `n` is negative,
	     * the nth argument from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [n=0] The index of the argument to return.
	     * @returns {Function} Returns the new pass-thru function.
	     * @example
	     *
	     * var func = _.nthArg(1);
	     * func('a', 'b', 'c', 'd');
	     * // => 'b'
	     *
	     * var func = _.nthArg(-2);
	     * func('a', 'b', 'c', 'd');
	     * // => 'c'
	     */
	    function nthArg(n) {
	      n = toInteger(n);
	      return baseRest(function(args) {
	        return baseNth(args, n);
	      });
	    }

	    /**
	     * Creates a function that invokes `iteratees` with the arguments it receives
	     * and returns their results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.over([Math.max, Math.min]);
	     *
	     * func(1, 2, 3, 4);
	     * // => [4, 1]
	     */
	    var over = createOver(arrayMap);

	    /**
	     * Creates a function that checks if **all** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * Following shorthands are possible for providing predicates.
	     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
	     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overEvery([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => false
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overEvery = createOver(arrayEvery);

	    /**
	     * Creates a function that checks if **any** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * Following shorthands are possible for providing predicates.
	     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
	     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overSome([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => true
	     *
	     * func(NaN);
	     * // => false
	     *
	     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
	     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
	     */
	    var overSome = createOver(arraySome);

	    /**
	     * Creates a function that returns the value at `path` of a given object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': 2 } },
	     *   { 'a': { 'b': 1 } }
	     * ];
	     *
	     * _.map(objects, _.property('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	     * // => [1, 2]
	     */
	    function property(path) {
	      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	    }

	    /**
	     * The opposite of `_.property`; this method creates a function that returns
	     * the value at a given path of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var array = [0, 1, 2],
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
	     * // => [2, 0]
	     */
	    function propertyOf(object) {
	      return function(path) {
	        return object == null ? undefined : baseGet(object, path);
	      };
	    }

	    /**
	     * Creates an array of numbers (positive and/or negative) progressing from
	     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
	     * `start` is specified without an `end` or `step`. If `end` is not specified,
	     * it's set to `start` with `start` then set to `0`.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.rangeRight
	     * @example
	     *
	     * _.range(4);
	     * // => [0, 1, 2, 3]
	     *
	     * _.range(-4);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 5);
	     * // => [1, 2, 3, 4]
	     *
	     * _.range(0, 20, 5);
	     * // => [0, 5, 10, 15]
	     *
	     * _.range(0, -4, -1);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.range(0);
	     * // => []
	     */
	    var range = createRange();

	    /**
	     * This method is like `_.range` except that it populates values in
	     * descending order.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.range
	     * @example
	     *
	     * _.rangeRight(4);
	     * // => [3, 2, 1, 0]
	     *
	     * _.rangeRight(-4);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 5);
	     * // => [4, 3, 2, 1]
	     *
	     * _.rangeRight(0, 20, 5);
	     * // => [15, 10, 5, 0]
	     *
	     * _.rangeRight(0, -4, -1);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.rangeRight(0);
	     * // => []
	     */
	    var rangeRight = createRange(true);

	    /**
	     * This method returns a new empty array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Array} Returns the new empty array.
	     * @example
	     *
	     * var arrays = _.times(2, _.stubArray);
	     *
	     * console.log(arrays);
	     * // => [[], []]
	     *
	     * console.log(arrays[0] === arrays[1]);
	     * // => false
	     */
	    function stubArray() {
	      return [];
	    }

	    /**
	     * This method returns `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `false`.
	     * @example
	     *
	     * _.times(2, _.stubFalse);
	     * // => [false, false]
	     */
	    function stubFalse() {
	      return false;
	    }

	    /**
	     * This method returns a new empty object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Object} Returns the new empty object.
	     * @example
	     *
	     * var objects = _.times(2, _.stubObject);
	     *
	     * console.log(objects);
	     * // => [{}, {}]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => false
	     */
	    function stubObject() {
	      return {};
	    }

	    /**
	     * This method returns an empty string.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {string} Returns the empty string.
	     * @example
	     *
	     * _.times(2, _.stubString);
	     * // => ['', '']
	     */
	    function stubString() {
	      return '';
	    }

	    /**
	     * This method returns `true`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `true`.
	     * @example
	     *
	     * _.times(2, _.stubTrue);
	     * // => [true, true]
	     */
	    function stubTrue() {
	      return true;
	    }

	    /**
	     * Invokes the iteratee `n` times, returning an array of the results of
	     * each invocation. The iteratee is invoked with one argument; (index).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} n The number of times to invoke `iteratee`.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.times(3, String);
	     * // => ['0', '1', '2']
	     *
	     *  _.times(4, _.constant(0));
	     * // => [0, 0, 0, 0]
	     */
	    function times(n, iteratee) {
	      n = toInteger(n);
	      if (n < 1 || n > MAX_SAFE_INTEGER) {
	        return [];
	      }
	      var index = MAX_ARRAY_LENGTH,
	          length = nativeMin(n, MAX_ARRAY_LENGTH);

	      iteratee = getIteratee(iteratee);
	      n -= MAX_ARRAY_LENGTH;

	      var result = baseTimes(length, iteratee);
	      while (++index < n) {
	        iteratee(index);
	      }
	      return result;
	    }

	    /**
	     * Converts `value` to a property path array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the new property path array.
	     * @example
	     *
	     * _.toPath('a.b.c');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toPath('a[0].b.c');
	     * // => ['a', '0', 'b', 'c']
	     */
	    function toPath(value) {
	      if (isArray(value)) {
	        return arrayMap(value, toKey);
	      }
	      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
	    }

	    /**
	     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {string} [prefix=''] The value to prefix the ID with.
	     * @returns {string} Returns the unique ID.
	     * @example
	     *
	     * _.uniqueId('contact_');
	     * // => 'contact_104'
	     *
	     * _.uniqueId();
	     * // => '105'
	     */
	    function uniqueId(prefix) {
	      var id = ++idCounter;
	      return toString(prefix) + id;
	    }

	    /*------------------------------------------------------------------------*/

	    /**
	     * Adds two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {number} augend The first number in an addition.
	     * @param {number} addend The second number in an addition.
	     * @returns {number} Returns the total.
	     * @example
	     *
	     * _.add(6, 4);
	     * // => 10
	     */
	    var add = createMathOperation(function(augend, addend) {
	      return augend + addend;
	    }, 0);

	    /**
	     * Computes `number` rounded up to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round up.
	     * @param {number} [precision=0] The precision to round up to.
	     * @returns {number} Returns the rounded up number.
	     * @example
	     *
	     * _.ceil(4.006);
	     * // => 5
	     *
	     * _.ceil(6.004, 2);
	     * // => 6.01
	     *
	     * _.ceil(6040, -2);
	     * // => 6100
	     */
	    var ceil = createRound('ceil');

	    /**
	     * Divide two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} dividend The first number in a division.
	     * @param {number} divisor The second number in a division.
	     * @returns {number} Returns the quotient.
	     * @example
	     *
	     * _.divide(6, 4);
	     * // => 1.5
	     */
	    var divide = createMathOperation(function(dividend, divisor) {
	      return dividend / divisor;
	    }, 1);

	    /**
	     * Computes `number` rounded down to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round down.
	     * @param {number} [precision=0] The precision to round down to.
	     * @returns {number} Returns the rounded down number.
	     * @example
	     *
	     * _.floor(4.006);
	     * // => 4
	     *
	     * _.floor(0.046, 2);
	     * // => 0.04
	     *
	     * _.floor(4060, -2);
	     * // => 4000
	     */
	    var floor = createRound('floor');

	    /**
	     * Computes the maximum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * _.max([4, 2, 8, 6]);
	     * // => 8
	     *
	     * _.max([]);
	     * // => undefined
	     */
	    function max(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseGt)
	        : undefined;
	    }

	    /**
	     * This method is like `_.max` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.maxBy(objects, function(o) { return o.n; });
	     * // => { 'n': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.maxBy(objects, 'n');
	     * // => { 'n': 2 }
	     */
	    function maxBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
	        : undefined;
	    }

	    /**
	     * Computes the mean of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * _.mean([4, 2, 8, 6]);
	     * // => 5
	     */
	    function mean(array) {
	      return baseMean(array, identity);
	    }

	    /**
	     * This method is like `_.mean` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be averaged.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.meanBy(objects, function(o) { return o.n; });
	     * // => 5
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.meanBy(objects, 'n');
	     * // => 5
	     */
	    function meanBy(array, iteratee) {
	      return baseMean(array, getIteratee(iteratee, 2));
	    }

	    /**
	     * Computes the minimum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * _.min([4, 2, 8, 6]);
	     * // => 2
	     *
	     * _.min([]);
	     * // => undefined
	     */
	    function min(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseLt)
	        : undefined;
	    }

	    /**
	     * This method is like `_.min` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.minBy(objects, function(o) { return o.n; });
	     * // => { 'n': 1 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.minBy(objects, 'n');
	     * // => { 'n': 1 }
	     */
	    function minBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
	        : undefined;
	    }

	    /**
	     * Multiply two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} multiplier The first number in a multiplication.
	     * @param {number} multiplicand The second number in a multiplication.
	     * @returns {number} Returns the product.
	     * @example
	     *
	     * _.multiply(6, 4);
	     * // => 24
	     */
	    var multiply = createMathOperation(function(multiplier, multiplicand) {
	      return multiplier * multiplicand;
	    }, 1);

	    /**
	     * Computes `number` rounded to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round.
	     * @param {number} [precision=0] The precision to round to.
	     * @returns {number} Returns the rounded number.
	     * @example
	     *
	     * _.round(4.006);
	     * // => 4
	     *
	     * _.round(4.006, 2);
	     * // => 4.01
	     *
	     * _.round(4060, -2);
	     * // => 4100
	     */
	    var round = createRound('round');

	    /**
	     * Subtract two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {number} minuend The first number in a subtraction.
	     * @param {number} subtrahend The second number in a subtraction.
	     * @returns {number} Returns the difference.
	     * @example
	     *
	     * _.subtract(6, 4);
	     * // => 2
	     */
	    var subtract = createMathOperation(function(minuend, subtrahend) {
	      return minuend - subtrahend;
	    }, 0);

	    /**
	     * Computes the sum of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * _.sum([4, 2, 8, 6]);
	     * // => 20
	     */
	    function sum(array) {
	      return (array && array.length)
	        ? baseSum(array, identity)
	        : 0;
	    }

	    /**
	     * This method is like `_.sum` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be summed.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.sumBy(objects, function(o) { return o.n; });
	     * // => 20
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sumBy(objects, 'n');
	     * // => 20
	     */
	    function sumBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSum(array, getIteratee(iteratee, 2))
	        : 0;
	    }

	    /*------------------------------------------------------------------------*/

	    // Add methods that return wrapped values in chain sequences.
	    lodash.after = after;
	    lodash.ary = ary;
	    lodash.assign = assign;
	    lodash.assignIn = assignIn;
	    lodash.assignInWith = assignInWith;
	    lodash.assignWith = assignWith;
	    lodash.at = at;
	    lodash.before = before;
	    lodash.bind = bind;
	    lodash.bindAll = bindAll;
	    lodash.bindKey = bindKey;
	    lodash.castArray = castArray;
	    lodash.chain = chain;
	    lodash.chunk = chunk;
	    lodash.compact = compact;
	    lodash.concat = concat;
	    lodash.cond = cond;
	    lodash.conforms = conforms;
	    lodash.constant = constant;
	    lodash.countBy = countBy;
	    lodash.create = create;
	    lodash.curry = curry;
	    lodash.curryRight = curryRight;
	    lodash.debounce = debounce;
	    lodash.defaults = defaults;
	    lodash.defaultsDeep = defaultsDeep;
	    lodash.defer = defer;
	    lodash.delay = delay;
	    lodash.difference = difference;
	    lodash.differenceBy = differenceBy;
	    lodash.differenceWith = differenceWith;
	    lodash.drop = drop;
	    lodash.dropRight = dropRight;
	    lodash.dropRightWhile = dropRightWhile;
	    lodash.dropWhile = dropWhile;
	    lodash.fill = fill;
	    lodash.filter = filter;
	    lodash.flatMap = flatMap;
	    lodash.flatMapDeep = flatMapDeep;
	    lodash.flatMapDepth = flatMapDepth;
	    lodash.flatten = flatten;
	    lodash.flattenDeep = flattenDeep;
	    lodash.flattenDepth = flattenDepth;
	    lodash.flip = flip;
	    lodash.flow = flow;
	    lodash.flowRight = flowRight;
	    lodash.fromPairs = fromPairs;
	    lodash.functions = functions;
	    lodash.functionsIn = functionsIn;
	    lodash.groupBy = groupBy;
	    lodash.initial = initial;
	    lodash.intersection = intersection;
	    lodash.intersectionBy = intersectionBy;
	    lodash.intersectionWith = intersectionWith;
	    lodash.invert = invert;
	    lodash.invertBy = invertBy;
	    lodash.invokeMap = invokeMap;
	    lodash.iteratee = iteratee;
	    lodash.keyBy = keyBy;
	    lodash.keys = keys;
	    lodash.keysIn = keysIn;
	    lodash.map = map;
	    lodash.mapKeys = mapKeys;
	    lodash.mapValues = mapValues;
	    lodash.matches = matches;
	    lodash.matchesProperty = matchesProperty;
	    lodash.memoize = memoize;
	    lodash.merge = merge;
	    lodash.mergeWith = mergeWith;
	    lodash.method = method;
	    lodash.methodOf = methodOf;
	    lodash.mixin = mixin;
	    lodash.negate = negate;
	    lodash.nthArg = nthArg;
	    lodash.omit = omit;
	    lodash.omitBy = omitBy;
	    lodash.once = once;
	    lodash.orderBy = orderBy;
	    lodash.over = over;
	    lodash.overArgs = overArgs;
	    lodash.overEvery = overEvery;
	    lodash.overSome = overSome;
	    lodash.partial = partial;
	    lodash.partialRight = partialRight;
	    lodash.partition = partition;
	    lodash.pick = pick;
	    lodash.pickBy = pickBy;
	    lodash.property = property;
	    lodash.propertyOf = propertyOf;
	    lodash.pull = pull;
	    lodash.pullAll = pullAll;
	    lodash.pullAllBy = pullAllBy;
	    lodash.pullAllWith = pullAllWith;
	    lodash.pullAt = pullAt;
	    lodash.range = range;
	    lodash.rangeRight = rangeRight;
	    lodash.rearg = rearg;
	    lodash.reject = reject;
	    lodash.remove = remove;
	    lodash.rest = rest;
	    lodash.reverse = reverse;
	    lodash.sampleSize = sampleSize;
	    lodash.set = set;
	    lodash.setWith = setWith;
	    lodash.shuffle = shuffle;
	    lodash.slice = slice;
	    lodash.sortBy = sortBy;
	    lodash.sortedUniq = sortedUniq;
	    lodash.sortedUniqBy = sortedUniqBy;
	    lodash.split = split;
	    lodash.spread = spread;
	    lodash.tail = tail;
	    lodash.take = take;
	    lodash.takeRight = takeRight;
	    lodash.takeRightWhile = takeRightWhile;
	    lodash.takeWhile = takeWhile;
	    lodash.tap = tap;
	    lodash.throttle = throttle;
	    lodash.thru = thru;
	    lodash.toArray = toArray;
	    lodash.toPairs = toPairs;
	    lodash.toPairsIn = toPairsIn;
	    lodash.toPath = toPath;
	    lodash.toPlainObject = toPlainObject;
	    lodash.transform = transform;
	    lodash.unary = unary;
	    lodash.union = union;
	    lodash.unionBy = unionBy;
	    lodash.unionWith = unionWith;
	    lodash.uniq = uniq;
	    lodash.uniqBy = uniqBy;
	    lodash.uniqWith = uniqWith;
	    lodash.unset = unset;
	    lodash.unzip = unzip;
	    lodash.unzipWith = unzipWith;
	    lodash.update = update;
	    lodash.updateWith = updateWith;
	    lodash.values = values;
	    lodash.valuesIn = valuesIn;
	    lodash.without = without;
	    lodash.words = words;
	    lodash.wrap = wrap;
	    lodash.xor = xor;
	    lodash.xorBy = xorBy;
	    lodash.xorWith = xorWith;
	    lodash.zip = zip;
	    lodash.zipObject = zipObject;
	    lodash.zipObjectDeep = zipObjectDeep;
	    lodash.zipWith = zipWith;

	    // Add aliases.
	    lodash.entries = toPairs;
	    lodash.entriesIn = toPairsIn;
	    lodash.extend = assignIn;
	    lodash.extendWith = assignInWith;

	    // Add methods to `lodash.prototype`.
	    mixin(lodash, lodash);

	    /*------------------------------------------------------------------------*/

	    // Add methods that return unwrapped values in chain sequences.
	    lodash.add = add;
	    lodash.attempt = attempt;
	    lodash.camelCase = camelCase;
	    lodash.capitalize = capitalize;
	    lodash.ceil = ceil;
	    lodash.clamp = clamp;
	    lodash.clone = clone;
	    lodash.cloneDeep = cloneDeep;
	    lodash.cloneDeepWith = cloneDeepWith;
	    lodash.cloneWith = cloneWith;
	    lodash.conformsTo = conformsTo;
	    lodash.deburr = deburr;
	    lodash.defaultTo = defaultTo;
	    lodash.divide = divide;
	    lodash.endsWith = endsWith;
	    lodash.eq = eq;
	    lodash.escape = escape;
	    lodash.escapeRegExp = escapeRegExp;
	    lodash.every = every;
	    lodash.find = find;
	    lodash.findIndex = findIndex;
	    lodash.findKey = findKey;
	    lodash.findLast = findLast;
	    lodash.findLastIndex = findLastIndex;
	    lodash.findLastKey = findLastKey;
	    lodash.floor = floor;
	    lodash.forEach = forEach;
	    lodash.forEachRight = forEachRight;
	    lodash.forIn = forIn;
	    lodash.forInRight = forInRight;
	    lodash.forOwn = forOwn;
	    lodash.forOwnRight = forOwnRight;
	    lodash.get = get;
	    lodash.gt = gt;
	    lodash.gte = gte;
	    lodash.has = has;
	    lodash.hasIn = hasIn;
	    lodash.head = head;
	    lodash.identity = identity;
	    lodash.includes = includes;
	    lodash.indexOf = indexOf;
	    lodash.inRange = inRange;
	    lodash.invoke = invoke;
	    lodash.isArguments = isArguments;
	    lodash.isArray = isArray;
	    lodash.isArrayBuffer = isArrayBuffer;
	    lodash.isArrayLike = isArrayLike;
	    lodash.isArrayLikeObject = isArrayLikeObject;
	    lodash.isBoolean = isBoolean;
	    lodash.isBuffer = isBuffer;
	    lodash.isDate = isDate;
	    lodash.isElement = isElement;
	    lodash.isEmpty = isEmpty;
	    lodash.isEqual = isEqual;
	    lodash.isEqualWith = isEqualWith;
	    lodash.isError = isError;
	    lodash.isFinite = isFinite;
	    lodash.isFunction = isFunction;
	    lodash.isInteger = isInteger;
	    lodash.isLength = isLength;
	    lodash.isMap = isMap;
	    lodash.isMatch = isMatch;
	    lodash.isMatchWith = isMatchWith;
	    lodash.isNaN = isNaN;
	    lodash.isNative = isNative;
	    lodash.isNil = isNil;
	    lodash.isNull = isNull;
	    lodash.isNumber = isNumber;
	    lodash.isObject = isObject;
	    lodash.isObjectLike = isObjectLike;
	    lodash.isPlainObject = isPlainObject;
	    lodash.isRegExp = isRegExp;
	    lodash.isSafeInteger = isSafeInteger;
	    lodash.isSet = isSet;
	    lodash.isString = isString;
	    lodash.isSymbol = isSymbol;
	    lodash.isTypedArray = isTypedArray;
	    lodash.isUndefined = isUndefined;
	    lodash.isWeakMap = isWeakMap;
	    lodash.isWeakSet = isWeakSet;
	    lodash.join = join;
	    lodash.kebabCase = kebabCase;
	    lodash.last = last;
	    lodash.lastIndexOf = lastIndexOf;
	    lodash.lowerCase = lowerCase;
	    lodash.lowerFirst = lowerFirst;
	    lodash.lt = lt;
	    lodash.lte = lte;
	    lodash.max = max;
	    lodash.maxBy = maxBy;
	    lodash.mean = mean;
	    lodash.meanBy = meanBy;
	    lodash.min = min;
	    lodash.minBy = minBy;
	    lodash.stubArray = stubArray;
	    lodash.stubFalse = stubFalse;
	    lodash.stubObject = stubObject;
	    lodash.stubString = stubString;
	    lodash.stubTrue = stubTrue;
	    lodash.multiply = multiply;
	    lodash.nth = nth;
	    lodash.noConflict = noConflict;
	    lodash.noop = noop;
	    lodash.now = now;
	    lodash.pad = pad;
	    lodash.padEnd = padEnd;
	    lodash.padStart = padStart;
	    lodash.parseInt = parseInt;
	    lodash.random = random;
	    lodash.reduce = reduce;
	    lodash.reduceRight = reduceRight;
	    lodash.repeat = repeat;
	    lodash.replace = replace;
	    lodash.result = result;
	    lodash.round = round;
	    lodash.runInContext = runInContext;
	    lodash.sample = sample;
	    lodash.size = size;
	    lodash.snakeCase = snakeCase;
	    lodash.some = some;
	    lodash.sortedIndex = sortedIndex;
	    lodash.sortedIndexBy = sortedIndexBy;
	    lodash.sortedIndexOf = sortedIndexOf;
	    lodash.sortedLastIndex = sortedLastIndex;
	    lodash.sortedLastIndexBy = sortedLastIndexBy;
	    lodash.sortedLastIndexOf = sortedLastIndexOf;
	    lodash.startCase = startCase;
	    lodash.startsWith = startsWith;
	    lodash.subtract = subtract;
	    lodash.sum = sum;
	    lodash.sumBy = sumBy;
	    lodash.template = template;
	    lodash.times = times;
	    lodash.toFinite = toFinite;
	    lodash.toInteger = toInteger;
	    lodash.toLength = toLength;
	    lodash.toLower = toLower;
	    lodash.toNumber = toNumber;
	    lodash.toSafeInteger = toSafeInteger;
	    lodash.toString = toString;
	    lodash.toUpper = toUpper;
	    lodash.trim = trim;
	    lodash.trimEnd = trimEnd;
	    lodash.trimStart = trimStart;
	    lodash.truncate = truncate;
	    lodash.unescape = unescape;
	    lodash.uniqueId = uniqueId;
	    lodash.upperCase = upperCase;
	    lodash.upperFirst = upperFirst;

	    // Add aliases.
	    lodash.each = forEach;
	    lodash.eachRight = forEachRight;
	    lodash.first = head;

	    mixin(lodash, (function() {
	      var source = {};
	      baseForOwn(lodash, function(func, methodName) {
	        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
	          source[methodName] = func;
	        }
	      });
	      return source;
	    }()), { 'chain': false });

	    /*------------------------------------------------------------------------*/

	    /**
	     * The semantic version number.
	     *
	     * @static
	     * @memberOf _
	     * @type {string}
	     */
	    lodash.VERSION = VERSION;

	    // Assign default placeholders.
	    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
	      lodash[methodName].placeholder = lodash;
	    });

	    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
	    arrayEach(['drop', 'take'], function(methodName, index) {
	      LazyWrapper.prototype[methodName] = function(n) {
	        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

	        var result = (this.__filtered__ && !index)
	          ? new LazyWrapper(this)
	          : this.clone();

	        if (result.__filtered__) {
	          result.__takeCount__ = nativeMin(n, result.__takeCount__);
	        } else {
	          result.__views__.push({
	            'size': nativeMin(n, MAX_ARRAY_LENGTH),
	            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
	          });
	        }
	        return result;
	      };

	      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
	        return this.reverse()[methodName](n).reverse();
	      };
	    });

	    // Add `LazyWrapper` methods that accept an `iteratee` value.
	    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
	      var type = index + 1,
	          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

	      LazyWrapper.prototype[methodName] = function(iteratee) {
	        var result = this.clone();
	        result.__iteratees__.push({
	          'iteratee': getIteratee(iteratee, 3),
	          'type': type
	        });
	        result.__filtered__ = result.__filtered__ || isFilter;
	        return result;
	      };
	    });

	    // Add `LazyWrapper` methods for `_.head` and `_.last`.
	    arrayEach(['head', 'last'], function(methodName, index) {
	      var takeName = 'take' + (index ? 'Right' : '');

	      LazyWrapper.prototype[methodName] = function() {
	        return this[takeName](1).value()[0];
	      };
	    });

	    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
	    arrayEach(['initial', 'tail'], function(methodName, index) {
	      var dropName = 'drop' + (index ? '' : 'Right');

	      LazyWrapper.prototype[methodName] = function() {
	        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
	      };
	    });

	    LazyWrapper.prototype.compact = function() {
	      return this.filter(identity);
	    };

	    LazyWrapper.prototype.find = function(predicate) {
	      return this.filter(predicate).head();
	    };

	    LazyWrapper.prototype.findLast = function(predicate) {
	      return this.reverse().find(predicate);
	    };

	    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
	      if (typeof path == 'function') {
	        return new LazyWrapper(this);
	      }
	      return this.map(function(value) {
	        return baseInvoke(value, path, args);
	      });
	    });

	    LazyWrapper.prototype.reject = function(predicate) {
	      return this.filter(negate(getIteratee(predicate)));
	    };

	    LazyWrapper.prototype.slice = function(start, end) {
	      start = toInteger(start);

	      var result = this;
	      if (result.__filtered__ && (start > 0 || end < 0)) {
	        return new LazyWrapper(result);
	      }
	      if (start < 0) {
	        result = result.takeRight(-start);
	      } else if (start) {
	        result = result.drop(start);
	      }
	      if (end !== undefined) {
	        end = toInteger(end);
	        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
	      }
	      return result;
	    };

	    LazyWrapper.prototype.takeRightWhile = function(predicate) {
	      return this.reverse().takeWhile(predicate).reverse();
	    };

	    LazyWrapper.prototype.toArray = function() {
	      return this.take(MAX_ARRAY_LENGTH);
	    };

	    // Add `LazyWrapper` methods to `lodash.prototype`.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
	          isTaker = /^(?:head|last)$/.test(methodName),
	          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
	          retUnwrapped = isTaker || /^find/.test(methodName);

	      if (!lodashFunc) {
	        return;
	      }
	      lodash.prototype[methodName] = function() {
	        var value = this.__wrapped__,
	            args = isTaker ? [1] : arguments,
	            isLazy = value instanceof LazyWrapper,
	            iteratee = args[0],
	            useLazy = isLazy || isArray(value);

	        var interceptor = function(value) {
	          var result = lodashFunc.apply(lodash, arrayPush([value], args));
	          return (isTaker && chainAll) ? result[0] : result;
	        };

	        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
	          // Avoid lazy use if the iteratee has a "length" value other than `1`.
	          isLazy = useLazy = false;
	        }
	        var chainAll = this.__chain__,
	            isHybrid = !!this.__actions__.length,
	            isUnwrapped = retUnwrapped && !chainAll,
	            onlyLazy = isLazy && !isHybrid;

	        if (!retUnwrapped && useLazy) {
	          value = onlyLazy ? value : new LazyWrapper(this);
	          var result = func.apply(value, args);
	          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
	          return new LodashWrapper(result, chainAll);
	        }
	        if (isUnwrapped && onlyLazy) {
	          return func.apply(this, args);
	        }
	        result = this.thru(interceptor);
	        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
	      };
	    });

	    // Add `Array` methods to `lodash.prototype`.
	    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
	      var func = arrayProto[methodName],
	          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
	          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

	      lodash.prototype[methodName] = function() {
	        var args = arguments;
	        if (retUnwrapped && !this.__chain__) {
	          var value = this.value();
	          return func.apply(isArray(value) ? value : [], args);
	        }
	        return this[chainName](function(value) {
	          return func.apply(isArray(value) ? value : [], args);
	        });
	      };
	    });

	    // Map minified method names to their real names.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var lodashFunc = lodash[methodName];
	      if (lodashFunc) {
	        var key = lodashFunc.name + '';
	        if (!hasOwnProperty.call(realNames, key)) {
	          realNames[key] = [];
	        }
	        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
	      }
	    });

	    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
	      'name': 'wrapper',
	      'func': undefined
	    }];

	    // Add methods to `LazyWrapper`.
	    LazyWrapper.prototype.clone = lazyClone;
	    LazyWrapper.prototype.reverse = lazyReverse;
	    LazyWrapper.prototype.value = lazyValue;

	    // Add chain sequence methods to the `lodash` wrapper.
	    lodash.prototype.at = wrapperAt;
	    lodash.prototype.chain = wrapperChain;
	    lodash.prototype.commit = wrapperCommit;
	    lodash.prototype.next = wrapperNext;
	    lodash.prototype.plant = wrapperPlant;
	    lodash.prototype.reverse = wrapperReverse;
	    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

	    // Add lazy aliases.
	    lodash.prototype.first = lodash.prototype.head;

	    if (symIterator) {
	      lodash.prototype[symIterator] = wrapperToIterator;
	    }
	    return lodash;
	  });

	  /*--------------------------------------------------------------------------*/

	  // Export lodash.
	  var _ = runInContext();

	  // Some AMD build optimizers, like r.js, check for condition patterns like:
	  if (freeModule) {
	    // Export for Node.js.
	    (freeModule.exports = _)._ = _;
	    // Export for CommonJS support.
	    freeExports._ = _;
	  }
	  else {
	    // Export to the global object.
	    root._ = _;
	  }
	}.call(commonjsGlobal));
	});

	var lodash$1 = /*#__PURE__*/Object.freeze({
		default: lodash,
		__moduleExports: lodash
	});

	/*!
	 * Vue.js v2.6.13
	 * (c) 2014-2021 Evan You
	 * Released under the MIT License.
	 */
	/*  */

	var emptyObject = Object.freeze({});

	// These helpers produce better VM code in JS engines due to their
	// explicitness and function inlining.
	function isUndef (v) {
	  return v === undefined || v === null
	}

	function isDef (v) {
	  return v !== undefined && v !== null
	}

	function isTrue (v) {
	  return v === true
	}

	function isFalse (v) {
	  return v === false
	}

	/**
	 * Check if value is primitive.
	 */
	function isPrimitive (value) {
	  return (
	    typeof value === 'string' ||
	    typeof value === 'number' ||
	    // $flow-disable-line
	    typeof value === 'symbol' ||
	    typeof value === 'boolean'
	  )
	}

	/**
	 * Quick object check - this is primarily used to tell
	 * Objects from primitive values when we know the value
	 * is a JSON-compliant type.
	 */
	function isObject (obj) {
	  return obj !== null && typeof obj === 'object'
	}

	/**
	 * Get the raw type string of a value, e.g., [object Object].
	 */
	var _toString = Object.prototype.toString;

	function toRawType (value) {
	  return _toString.call(value).slice(8, -1)
	}

	/**
	 * Strict object type check. Only returns true
	 * for plain JavaScript objects.
	 */
	function isPlainObject (obj) {
	  return _toString.call(obj) === '[object Object]'
	}

	function isRegExp (v) {
	  return _toString.call(v) === '[object RegExp]'
	}

	/**
	 * Check if val is a valid array index.
	 */
	function isValidArrayIndex (val) {
	  var n = parseFloat(String(val));
	  return n >= 0 && Math.floor(n) === n && isFinite(val)
	}

	function isPromise (val) {
	  return (
	    isDef(val) &&
	    typeof val.then === 'function' &&
	    typeof val.catch === 'function'
	  )
	}

	/**
	 * Convert a value to a string that is actually rendered.
	 */
	function toString (val) {
	  return val == null
	    ? ''
	    : Array.isArray(val) || (isPlainObject(val) && val.toString === _toString)
	      ? JSON.stringify(val, null, 2)
	      : String(val)
	}

	/**
	 * Convert an input value to a number for persistence.
	 * If the conversion fails, return original string.
	 */
	function toNumber (val) {
	  var n = parseFloat(val);
	  return isNaN(n) ? val : n
	}

	/**
	 * Make a map and return a function for checking if a key
	 * is in that map.
	 */
	function makeMap (
	  str,
	  expectsLowerCase
	) {
	  var map = Object.create(null);
	  var list = str.split(',');
	  for (var i = 0; i < list.length; i++) {
	    map[list[i]] = true;
	  }
	  return expectsLowerCase
	    ? function (val) { return map[val.toLowerCase()]; }
	    : function (val) { return map[val]; }
	}

	/**
	 * Check if a tag is a built-in tag.
	 */
	var isBuiltInTag = makeMap('slot,component', true);

	/**
	 * Check if an attribute is a reserved attribute.
	 */
	var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');

	/**
	 * Remove an item from an array.
	 */
	function remove (arr, item) {
	  if (arr.length) {
	    var index = arr.indexOf(item);
	    if (index > -1) {
	      return arr.splice(index, 1)
	    }
	  }
	}

	/**
	 * Check whether an object has the property.
	 */
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	function hasOwn (obj, key) {
	  return hasOwnProperty.call(obj, key)
	}

	/**
	 * Create a cached version of a pure function.
	 */
	function cached (fn) {
	  var cache = Object.create(null);
	  return (function cachedFn (str) {
	    var hit = cache[str];
	    return hit || (cache[str] = fn(str))
	  })
	}

	/**
	 * Camelize a hyphen-delimited string.
	 */
	var camelizeRE = /-(\w)/g;
	var camelize = cached(function (str) {
	  return str.replace(camelizeRE, function (_, c) { return c ? c.toUpperCase() : ''; })
	});

	/**
	 * Capitalize a string.
	 */
	var capitalize = cached(function (str) {
	  return str.charAt(0).toUpperCase() + str.slice(1)
	});

	/**
	 * Hyphenate a camelCase string.
	 */
	var hyphenateRE = /\B([A-Z])/g;
	var hyphenate = cached(function (str) {
	  return str.replace(hyphenateRE, '-$1').toLowerCase()
	});

	/**
	 * Simple bind polyfill for environments that do not support it,
	 * e.g., PhantomJS 1.x. Technically, we don't need this anymore
	 * since native bind is now performant enough in most browsers.
	 * But removing it would mean breaking code that was able to run in
	 * PhantomJS 1.x, so this must be kept for backward compatibility.
	 */

	/* istanbul ignore next */
	function polyfillBind (fn, ctx) {
	  function boundFn (a) {
	    var l = arguments.length;
	    return l
	      ? l > 1
	        ? fn.apply(ctx, arguments)
	        : fn.call(ctx, a)
	      : fn.call(ctx)
	  }

	  boundFn._length = fn.length;
	  return boundFn
	}

	function nativeBind (fn, ctx) {
	  return fn.bind(ctx)
	}

	var bind = Function.prototype.bind
	  ? nativeBind
	  : polyfillBind;

	/**
	 * Convert an Array-like object to a real Array.
	 */
	function toArray (list, start) {
	  start = start || 0;
	  var i = list.length - start;
	  var ret = new Array(i);
	  while (i--) {
	    ret[i] = list[i + start];
	  }
	  return ret
	}

	/**
	 * Mix properties into target object.
	 */
	function extend (to, _from) {
	  for (var key in _from) {
	    to[key] = _from[key];
	  }
	  return to
	}

	/**
	 * Merge an Array of Objects into a single Object.
	 */
	function toObject (arr) {
	  var res = {};
	  for (var i = 0; i < arr.length; i++) {
	    if (arr[i]) {
	      extend(res, arr[i]);
	    }
	  }
	  return res
	}

	/* eslint-disable no-unused-vars */

	/**
	 * Perform no operation.
	 * Stubbing args to make Flow happy without leaving useless transpiled code
	 * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/).
	 */
	function noop (a, b, c) {}

	/**
	 * Always return false.
	 */
	var no = function (a, b, c) { return false; };

	/* eslint-enable no-unused-vars */

	/**
	 * Return the same value.
	 */
	var identity = function (_) { return _; };

	/**
	 * Check if two values are loosely equal - that is,
	 * if they are plain objects, do they have the same shape?
	 */
	function looseEqual (a, b) {
	  if (a === b) { return true }
	  var isObjectA = isObject(a);
	  var isObjectB = isObject(b);
	  if (isObjectA && isObjectB) {
	    try {
	      var isArrayA = Array.isArray(a);
	      var isArrayB = Array.isArray(b);
	      if (isArrayA && isArrayB) {
	        return a.length === b.length && a.every(function (e, i) {
	          return looseEqual(e, b[i])
	        })
	      } else if (a instanceof Date && b instanceof Date) {
	        return a.getTime() === b.getTime()
	      } else if (!isArrayA && !isArrayB) {
	        var keysA = Object.keys(a);
	        var keysB = Object.keys(b);
	        return keysA.length === keysB.length && keysA.every(function (key) {
	          return looseEqual(a[key], b[key])
	        })
	      } else {
	        /* istanbul ignore next */
	        return false
	      }
	    } catch (e) {
	      /* istanbul ignore next */
	      return false
	    }
	  } else if (!isObjectA && !isObjectB) {
	    return String(a) === String(b)
	  } else {
	    return false
	  }
	}

	/**
	 * Return the first index at which a loosely equal value can be
	 * found in the array (if value is a plain object, the array must
	 * contain an object of the same shape), or -1 if it is not present.
	 */
	function looseIndexOf (arr, val) {
	  for (var i = 0; i < arr.length; i++) {
	    if (looseEqual(arr[i], val)) { return i }
	  }
	  return -1
	}

	/**
	 * Ensure a function is called only once.
	 */
	function once (fn) {
	  var called = false;
	  return function () {
	    if (!called) {
	      called = true;
	      fn.apply(this, arguments);
	    }
	  }
	}

	var SSR_ATTR = 'data-server-rendered';

	var ASSET_TYPES = [
	  'component',
	  'directive',
	  'filter'
	];

	var LIFECYCLE_HOOKS = [
	  'beforeCreate',
	  'created',
	  'beforeMount',
	  'mounted',
	  'beforeUpdate',
	  'updated',
	  'beforeDestroy',
	  'destroyed',
	  'activated',
	  'deactivated',
	  'errorCaptured',
	  'serverPrefetch'
	];

	/*  */



	var config = ({
	  /**
	   * Option merge strategies (used in core/util/options)
	   */
	  // $flow-disable-line
	  optionMergeStrategies: Object.create(null),

	  /**
	   * Whether to suppress warnings.
	   */
	  silent: false,

	  /**
	   * Show production mode tip message on boot?
	   */
	  productionTip: "production" !== 'production',

	  /**
	   * Whether to enable devtools
	   */
	  devtools: "production" !== 'production',

	  /**
	   * Whether to record perf
	   */
	  performance: false,

	  /**
	   * Error handler for watcher errors
	   */
	  errorHandler: null,

	  /**
	   * Warn handler for watcher warns
	   */
	  warnHandler: null,

	  /**
	   * Ignore certain custom elements
	   */
	  ignoredElements: [],

	  /**
	   * Custom user key aliases for v-on
	   */
	  // $flow-disable-line
	  keyCodes: Object.create(null),

	  /**
	   * Check if a tag is reserved so that it cannot be registered as a
	   * component. This is platform-dependent and may be overwritten.
	   */
	  isReservedTag: no,

	  /**
	   * Check if an attribute is reserved so that it cannot be used as a component
	   * prop. This is platform-dependent and may be overwritten.
	   */
	  isReservedAttr: no,

	  /**
	   * Check if a tag is an unknown element.
	   * Platform-dependent.
	   */
	  isUnknownElement: no,

	  /**
	   * Get the namespace of an element
	   */
	  getTagNamespace: noop,

	  /**
	   * Parse the real tag name for the specific platform.
	   */
	  parsePlatformTagName: identity,

	  /**
	   * Check if an attribute must be bound using property, e.g. value
	   * Platform-dependent.
	   */
	  mustUseProp: no,

	  /**
	   * Perform updates asynchronously. Intended to be used by Vue Test Utils
	   * This will significantly reduce performance if set to false.
	   */
	  async: true,

	  /**
	   * Exposed for legacy reasons
	   */
	  _lifecycleHooks: LIFECYCLE_HOOKS
	});

	/*  */

	/**
	 * unicode letters used for parsing html tags, component names and property paths.
	 * using https://www.w3.org/TR/html53/semantics-scripting.html#potentialcustomelementname
	 * skipping \u10000-\uEFFFF due to it freezing up PhantomJS
	 */
	var unicodeRegExp = /a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/;

	/**
	 * Check if a string starts with $ or _
	 */
	function isReserved (str) {
	  var c = (str + '').charCodeAt(0);
	  return c === 0x24 || c === 0x5F
	}

	/**
	 * Define a property.
	 */
	function def (obj, key, val, enumerable) {
	  Object.defineProperty(obj, key, {
	    value: val,
	    enumerable: !!enumerable,
	    writable: true,
	    configurable: true
	  });
	}

	/**
	 * Parse simple path.
	 */
	var bailRE = new RegExp(("[^" + (unicodeRegExp.source) + ".$_\\d]"));
	function parsePath (path) {
	  if (bailRE.test(path)) {
	    return
	  }
	  var segments = path.split('.');
	  return function (obj) {
	    for (var i = 0; i < segments.length; i++) {
	      if (!obj) { return }
	      obj = obj[segments[i]];
	    }
	    return obj
	  }
	}

	/*  */

	// can we use __proto__?
	var hasProto = '__proto__' in {};

	// Browser environment sniffing
	var inBrowser = typeof window !== 'undefined';
	var inWeex = typeof WXEnvironment !== 'undefined' && !!WXEnvironment.platform;
	var weexPlatform = inWeex && WXEnvironment.platform.toLowerCase();
	var UA = inBrowser && window.navigator.userAgent.toLowerCase();
	var isIE = UA && /msie|trident/.test(UA);
	var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
	var isEdge = UA && UA.indexOf('edge/') > 0;
	var isAndroid = (UA && UA.indexOf('android') > 0) || (weexPlatform === 'android');
	var isIOS = (UA && /iphone|ipad|ipod|ios/.test(UA)) || (weexPlatform === 'ios');
	var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;
	var isPhantomJS = UA && /phantomjs/.test(UA);
	var isFF = UA && UA.match(/firefox\/(\d+)/);

	// Firefox has a "watch" function on Object.prototype...
	var nativeWatch = ({}).watch;

	var supportsPassive = false;
	if (inBrowser) {
	  try {
	    var opts = {};
	    Object.defineProperty(opts, 'passive', ({
	      get: function get () {
	        /* istanbul ignore next */
	        supportsPassive = true;
	      }
	    })); // https://github.com/facebook/flow/issues/285
	    window.addEventListener('test-passive', null, opts);
	  } catch (e) {}
	}

	// this needs to be lazy-evaled because vue may be required before
	// vue-server-renderer can set VUE_ENV
	var _isServer;
	var isServerRendering = function () {
	  if (_isServer === undefined) {
	    /* istanbul ignore if */
	    if (!inBrowser && !inWeex && typeof global !== 'undefined') {
	      // detect presence of vue-server-renderer and avoid
	      // Webpack shimming the process
	      _isServer = global['process'] && global['process'].env.VUE_ENV === 'server';
	    } else {
	      _isServer = false;
	    }
	  }
	  return _isServer
	};

	// detect devtools
	var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

	/* istanbul ignore next */
	function isNative (Ctor) {
	  return typeof Ctor === 'function' && /native code/.test(Ctor.toString())
	}

	var hasSymbol =
	  typeof Symbol !== 'undefined' && isNative(Symbol) &&
	  typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);

	var _Set;
	/* istanbul ignore if */ // $flow-disable-line
	if (typeof Set !== 'undefined' && isNative(Set)) {
	  // use native Set when available.
	  _Set = Set;
	} else {
	  // a non-standard Set polyfill that only works with primitive keys.
	  _Set = /*@__PURE__*/(function () {
	    function Set () {
	      this.set = Object.create(null);
	    }
	    Set.prototype.has = function has (key) {
	      return this.set[key] === true
	    };
	    Set.prototype.add = function add (key) {
	      this.set[key] = true;
	    };
	    Set.prototype.clear = function clear () {
	      this.set = Object.create(null);
	    };

	    return Set;
	  }());
	}

	/*  */

	var warn = noop;

	/*  */

	var uid = 0;

	/**
	 * A dep is an observable that can have multiple
	 * directives subscribing to it.
	 */
	var Dep = function Dep () {
	  this.id = uid++;
	  this.subs = [];
	};

	Dep.prototype.addSub = function addSub (sub) {
	  this.subs.push(sub);
	};

	Dep.prototype.removeSub = function removeSub (sub) {
	  remove(this.subs, sub);
	};

	Dep.prototype.depend = function depend () {
	  if (Dep.target) {
	    Dep.target.addDep(this);
	  }
	};

	Dep.prototype.notify = function notify () {
	  // stabilize the subscriber list first
	  var subs = this.subs.slice();
	  for (var i = 0, l = subs.length; i < l; i++) {
	    subs[i].update();
	  }
	};

	// The current target watcher being evaluated.
	// This is globally unique because only one watcher
	// can be evaluated at a time.
	Dep.target = null;
	var targetStack = [];

	function pushTarget (target) {
	  targetStack.push(target);
	  Dep.target = target;
	}

	function popTarget () {
	  targetStack.pop();
	  Dep.target = targetStack[targetStack.length - 1];
	}

	/*  */

	var VNode = function VNode (
	  tag,
	  data,
	  children,
	  text,
	  elm,
	  context,
	  componentOptions,
	  asyncFactory
	) {
	  this.tag = tag;
	  this.data = data;
	  this.children = children;
	  this.text = text;
	  this.elm = elm;
	  this.ns = undefined;
	  this.context = context;
	  this.fnContext = undefined;
	  this.fnOptions = undefined;
	  this.fnScopeId = undefined;
	  this.key = data && data.key;
	  this.componentOptions = componentOptions;
	  this.componentInstance = undefined;
	  this.parent = undefined;
	  this.raw = false;
	  this.isStatic = false;
	  this.isRootInsert = true;
	  this.isComment = false;
	  this.isCloned = false;
	  this.isOnce = false;
	  this.asyncFactory = asyncFactory;
	  this.asyncMeta = undefined;
	  this.isAsyncPlaceholder = false;
	};

	var prototypeAccessors = { child: { configurable: true } };

	// DEPRECATED: alias for componentInstance for backwards compat.
	/* istanbul ignore next */
	prototypeAccessors.child.get = function () {
	  return this.componentInstance
	};

	Object.defineProperties( VNode.prototype, prototypeAccessors );

	var createEmptyVNode = function (text) {
	  if ( text === void 0 ) { text = ''; }

	  var node = new VNode();
	  node.text = text;
	  node.isComment = true;
	  return node
	};

	function createTextVNode (val) {
	  return new VNode(undefined, undefined, undefined, String(val))
	}

	// optimized shallow clone
	// used for static nodes and slot nodes because they may be reused across
	// multiple renders, cloning them avoids errors when DOM manipulations rely
	// on their elm reference.
	function cloneVNode (vnode) {
	  var cloned = new VNode(
	    vnode.tag,
	    vnode.data,
	    // #7975
	    // clone children array to avoid mutating original in case of cloning
	    // a child.
	    vnode.children && vnode.children.slice(),
	    vnode.text,
	    vnode.elm,
	    vnode.context,
	    vnode.componentOptions,
	    vnode.asyncFactory
	  );
	  cloned.ns = vnode.ns;
	  cloned.isStatic = vnode.isStatic;
	  cloned.key = vnode.key;
	  cloned.isComment = vnode.isComment;
	  cloned.fnContext = vnode.fnContext;
	  cloned.fnOptions = vnode.fnOptions;
	  cloned.fnScopeId = vnode.fnScopeId;
	  cloned.asyncMeta = vnode.asyncMeta;
	  cloned.isCloned = true;
	  return cloned
	}

	/*
	 * not type checking this file because flow doesn't play well with
	 * dynamically accessing methods on Array prototype
	 */

	var arrayProto = Array.prototype;
	var arrayMethods = Object.create(arrayProto);

	var methodsToPatch = [
	  'push',
	  'pop',
	  'shift',
	  'unshift',
	  'splice',
	  'sort',
	  'reverse'
	];

	/**
	 * Intercept mutating methods and emit events
	 */
	methodsToPatch.forEach(function (method) {
	  // cache original method
	  var original = arrayProto[method];
	  def(arrayMethods, method, function mutator () {
	    var arguments$1 = arguments;

	    var args = [], len = arguments.length;
	    while ( len-- ) { args[ len ] = arguments$1[ len ]; }

	    var result = original.apply(this, args);
	    var ob = this.__ob__;
	    var inserted;
	    switch (method) {
	      case 'push':
	      case 'unshift':
	        inserted = args;
	        break
	      case 'splice':
	        inserted = args.slice(2);
	        break
	    }
	    if (inserted) { ob.observeArray(inserted); }
	    // notify change
	    ob.dep.notify();
	    return result
	  });
	});

	/*  */

	var arrayKeys = Object.getOwnPropertyNames(arrayMethods);

	/**
	 * In some cases we may want to disable observation inside a component's
	 * update computation.
	 */
	var shouldObserve = true;

	function toggleObserving (value) {
	  shouldObserve = value;
	}

	/**
	 * Observer class that is attached to each observed
	 * object. Once attached, the observer converts the target
	 * object's property keys into getter/setters that
	 * collect dependencies and dispatch updates.
	 */
	var Observer = function Observer (value) {
	  this.value = value;
	  this.dep = new Dep();
	  this.vmCount = 0;
	  def(value, '__ob__', this);
	  if (Array.isArray(value)) {
	    if (hasProto) {
	      protoAugment(value, arrayMethods);
	    } else {
	      copyAugment(value, arrayMethods, arrayKeys);
	    }
	    this.observeArray(value);
	  } else {
	    this.walk(value);
	  }
	};

	/**
	 * Walk through all properties and convert them into
	 * getter/setters. This method should only be called when
	 * value type is Object.
	 */
	Observer.prototype.walk = function walk (obj) {
	  var keys = Object.keys(obj);
	  for (var i = 0; i < keys.length; i++) {
	    defineReactive$$1(obj, keys[i]);
	  }
	};

	/**
	 * Observe a list of Array items.
	 */
	Observer.prototype.observeArray = function observeArray (items) {
	  for (var i = 0, l = items.length; i < l; i++) {
	    observe(items[i]);
	  }
	};

	// helpers

	/**
	 * Augment a target Object or Array by intercepting
	 * the prototype chain using __proto__
	 */
	function protoAugment (target, src) {
	  /* eslint-disable no-proto */
	  target.__proto__ = src;
	  /* eslint-enable no-proto */
	}

	/**
	 * Augment a target Object or Array by defining
	 * hidden properties.
	 */
	/* istanbul ignore next */
	function copyAugment (target, src, keys) {
	  for (var i = 0, l = keys.length; i < l; i++) {
	    var key = keys[i];
	    def(target, key, src[key]);
	  }
	}

	/**
	 * Attempt to create an observer instance for a value,
	 * returns the new observer if successfully observed,
	 * or the existing observer if the value already has one.
	 */
	function observe (value, asRootData) {
	  if (!isObject(value) || value instanceof VNode) {
	    return
	  }
	  var ob;
	  if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
	    ob = value.__ob__;
	  } else if (
	    shouldObserve &&
	    !isServerRendering() &&
	    (Array.isArray(value) || isPlainObject(value)) &&
	    Object.isExtensible(value) &&
	    !value._isVue
	  ) {
	    ob = new Observer(value);
	  }
	  if (asRootData && ob) {
	    ob.vmCount++;
	  }
	  return ob
	}

	/**
	 * Define a reactive property on an Object.
	 */
	function defineReactive$$1 (
	  obj,
	  key,
	  val,
	  customSetter,
	  shallow
	) {
	  var dep = new Dep();

	  var property = Object.getOwnPropertyDescriptor(obj, key);
	  if (property && property.configurable === false) {
	    return
	  }

	  // cater for pre-defined getter/setters
	  var getter = property && property.get;
	  var setter = property && property.set;
	  if ((!getter || setter) && arguments.length === 2) {
	    val = obj[key];
	  }

	  var childOb = !shallow && observe(val);
	  Object.defineProperty(obj, key, {
	    enumerable: true,
	    configurable: true,
	    get: function reactiveGetter () {
	      var value = getter ? getter.call(obj) : val;
	      if (Dep.target) {
	        dep.depend();
	        if (childOb) {
	          childOb.dep.depend();
	          if (Array.isArray(value)) {
	            dependArray(value);
	          }
	        }
	      }
	      return value
	    },
	    set: function reactiveSetter (newVal) {
	      var value = getter ? getter.call(obj) : val;
	      /* eslint-disable no-self-compare */
	      if (newVal === value || (newVal !== newVal && value !== value)) {
	        return
	      }
	      // #7981: for accessor properties without setter
	      if (getter && !setter) { return }
	      if (setter) {
	        setter.call(obj, newVal);
	      } else {
	        val = newVal;
	      }
	      childOb = !shallow && observe(newVal);
	      dep.notify();
	    }
	  });
	}

	/**
	 * Set a property on an object. Adds the new property and
	 * triggers change notification if the property doesn't
	 * already exist.
	 */
	function set (target, key, val) {
	  if (Array.isArray(target) && isValidArrayIndex(key)) {
	    target.length = Math.max(target.length, key);
	    target.splice(key, 1, val);
	    return val
	  }
	  if (key in target && !(key in Object.prototype)) {
	    target[key] = val;
	    return val
	  }
	  var ob = (target).__ob__;
	  if (target._isVue || (ob && ob.vmCount)) {
	    return val
	  }
	  if (!ob) {
	    target[key] = val;
	    return val
	  }
	  defineReactive$$1(ob.value, key, val);
	  ob.dep.notify();
	  return val
	}

	/**
	 * Delete a property and trigger change if necessary.
	 */
	function del (target, key) {
	  if (Array.isArray(target) && isValidArrayIndex(key)) {
	    target.splice(key, 1);
	    return
	  }
	  var ob = (target).__ob__;
	  if (target._isVue || (ob && ob.vmCount)) {
	    return
	  }
	  if (!hasOwn(target, key)) {
	    return
	  }
	  delete target[key];
	  if (!ob) {
	    return
	  }
	  ob.dep.notify();
	}

	/**
	 * Collect dependencies on array elements when the array is touched, since
	 * we cannot intercept array element access like property getters.
	 */
	function dependArray (value) {
	  for (var e = (void 0), i = 0, l = value.length; i < l; i++) {
	    e = value[i];
	    e && e.__ob__ && e.__ob__.dep.depend();
	    if (Array.isArray(e)) {
	      dependArray(e);
	    }
	  }
	}

	/*  */

	/**
	 * Option overwriting strategies are functions that handle
	 * how to merge a parent option value and a child option
	 * value into the final value.
	 */
	var strats = config.optionMergeStrategies;

	/**
	 * Helper that recursively merges two data objects together.
	 */
	function mergeData (to, from) {
	  if (!from) { return to }
	  var key, toVal, fromVal;

	  var keys = hasSymbol
	    ? Reflect.ownKeys(from)
	    : Object.keys(from);

	  for (var i = 0; i < keys.length; i++) {
	    key = keys[i];
	    // in case the object is already observed...
	    if (key === '__ob__') { continue }
	    toVal = to[key];
	    fromVal = from[key];
	    if (!hasOwn(to, key)) {
	      set(to, key, fromVal);
	    } else if (
	      toVal !== fromVal &&
	      isPlainObject(toVal) &&
	      isPlainObject(fromVal)
	    ) {
	      mergeData(toVal, fromVal);
	    }
	  }
	  return to
	}

	/**
	 * Data
	 */
	function mergeDataOrFn (
	  parentVal,
	  childVal,
	  vm
	) {
	  if (!vm) {
	    // in a Vue.extend merge, both should be functions
	    if (!childVal) {
	      return parentVal
	    }
	    if (!parentVal) {
	      return childVal
	    }
	    // when parentVal & childVal are both present,
	    // we need to return a function that returns the
	    // merged result of both functions... no need to
	    // check if parentVal is a function here because
	    // it has to be a function to pass previous merges.
	    return function mergedDataFn () {
	      return mergeData(
	        typeof childVal === 'function' ? childVal.call(this, this) : childVal,
	        typeof parentVal === 'function' ? parentVal.call(this, this) : parentVal
	      )
	    }
	  } else {
	    return function mergedInstanceDataFn () {
	      // instance merge
	      var instanceData = typeof childVal === 'function'
	        ? childVal.call(vm, vm)
	        : childVal;
	      var defaultData = typeof parentVal === 'function'
	        ? parentVal.call(vm, vm)
	        : parentVal;
	      if (instanceData) {
	        return mergeData(instanceData, defaultData)
	      } else {
	        return defaultData
	      }
	    }
	  }
	}

	strats.data = function (
	  parentVal,
	  childVal,
	  vm
	) {
	  if (!vm) {
	    if (childVal && typeof childVal !== 'function') {

	      return parentVal
	    }
	    return mergeDataOrFn(parentVal, childVal)
	  }

	  return mergeDataOrFn(parentVal, childVal, vm)
	};

	/**
	 * Hooks and props are merged as arrays.
	 */
	function mergeHook (
	  parentVal,
	  childVal
	) {
	  var res = childVal
	    ? parentVal
	      ? parentVal.concat(childVal)
	      : Array.isArray(childVal)
	        ? childVal
	        : [childVal]
	    : parentVal;
	  return res
	    ? dedupeHooks(res)
	    : res
	}

	function dedupeHooks (hooks) {
	  var res = [];
	  for (var i = 0; i < hooks.length; i++) {
	    if (res.indexOf(hooks[i]) === -1) {
	      res.push(hooks[i]);
	    }
	  }
	  return res
	}

	LIFECYCLE_HOOKS.forEach(function (hook) {
	  strats[hook] = mergeHook;
	});

	/**
	 * Assets
	 *
	 * When a vm is present (instance creation), we need to do
	 * a three-way merge between constructor options, instance
	 * options and parent options.
	 */
	function mergeAssets (
	  parentVal,
	  childVal,
	  vm,
	  key
	) {
	  var res = Object.create(parentVal || null);
	  if (childVal) {
	    return extend(res, childVal)
	  } else {
	    return res
	  }
	}

	ASSET_TYPES.forEach(function (type) {
	  strats[type + 's'] = mergeAssets;
	});

	/**
	 * Watchers.
	 *
	 * Watchers hashes should not overwrite one
	 * another, so we merge them as arrays.
	 */
	strats.watch = function (
	  parentVal,
	  childVal,
	  vm,
	  key
	) {
	  // work around Firefox's Object.prototype.watch...
	  if (parentVal === nativeWatch) { parentVal = undefined; }
	  if (childVal === nativeWatch) { childVal = undefined; }
	  /* istanbul ignore if */
	  if (!childVal) { return Object.create(parentVal || null) }
	  if (!parentVal) { return childVal }
	  var ret = {};
	  extend(ret, parentVal);
	  for (var key$1 in childVal) {
	    var parent = ret[key$1];
	    var child = childVal[key$1];
	    if (parent && !Array.isArray(parent)) {
	      parent = [parent];
	    }
	    ret[key$1] = parent
	      ? parent.concat(child)
	      : Array.isArray(child) ? child : [child];
	  }
	  return ret
	};

	/**
	 * Other object hashes.
	 */
	strats.props =
	strats.methods =
	strats.inject =
	strats.computed = function (
	  parentVal,
	  childVal,
	  vm,
	  key
	) {
	  if (childVal && "production" !== 'production') {
	    assertObjectType(key, childVal, vm);
	  }
	  if (!parentVal) { return childVal }
	  var ret = Object.create(null);
	  extend(ret, parentVal);
	  if (childVal) { extend(ret, childVal); }
	  return ret
	};
	strats.provide = mergeDataOrFn;

	/**
	 * Default strategy.
	 */
	var defaultStrat = function (parentVal, childVal) {
	  return childVal === undefined
	    ? parentVal
	    : childVal
	};

	/**
	 * Ensure all props option syntax are normalized into the
	 * Object-based format.
	 */
	function normalizeProps (options, vm) {
	  var props = options.props;
	  if (!props) { return }
	  var res = {};
	  var i, val, name;
	  if (Array.isArray(props)) {
	    i = props.length;
	    while (i--) {
	      val = props[i];
	      if (typeof val === 'string') {
	        name = camelize(val);
	        res[name] = { type: null };
	      }
	    }
	  } else if (isPlainObject(props)) {
	    for (var key in props) {
	      val = props[key];
	      name = camelize(key);
	      res[name] = isPlainObject(val)
	        ? val
	        : { type: val };
	    }
	  }
	  options.props = res;
	}

	/**
	 * Normalize all injections into Object-based format
	 */
	function normalizeInject (options, vm) {
	  var inject = options.inject;
	  if (!inject) { return }
	  var normalized = options.inject = {};
	  if (Array.isArray(inject)) {
	    for (var i = 0; i < inject.length; i++) {
	      normalized[inject[i]] = { from: inject[i] };
	    }
	  } else if (isPlainObject(inject)) {
	    for (var key in inject) {
	      var val = inject[key];
	      normalized[key] = isPlainObject(val)
	        ? extend({ from: key }, val)
	        : { from: val };
	    }
	  }
	}

	/**
	 * Normalize raw function directives into object format.
	 */
	function normalizeDirectives (options) {
	  var dirs = options.directives;
	  if (dirs) {
	    for (var key in dirs) {
	      var def$$1 = dirs[key];
	      if (typeof def$$1 === 'function') {
	        dirs[key] = { bind: def$$1, update: def$$1 };
	      }
	    }
	  }
	}

	function assertObjectType (name, value, vm) {
	  if (!isPlainObject(value)) {
	    warn(
	      "Invalid value for option \"" + name + "\": expected an Object, " +
	      "but got " + (toRawType(value)) + ".",
	      vm
	    );
	  }
	}

	/**
	 * Merge two option objects into a new one.
	 * Core utility used in both instantiation and inheritance.
	 */
	function mergeOptions (
	  parent,
	  child,
	  vm
	) {

	  if (typeof child === 'function') {
	    child = child.options;
	  }

	  normalizeProps(child, vm);
	  normalizeInject(child, vm);
	  normalizeDirectives(child);

	  // Apply extends and mixins on the child options,
	  // but only if it is a raw options object that isn't
	  // the result of another mergeOptions call.
	  // Only merged options has the _base property.
	  if (!child._base) {
	    if (child.extends) {
	      parent = mergeOptions(parent, child.extends, vm);
	    }
	    if (child.mixins) {
	      for (var i = 0, l = child.mixins.length; i < l; i++) {
	        parent = mergeOptions(parent, child.mixins[i], vm);
	      }
	    }
	  }

	  var options = {};
	  var key;
	  for (key in parent) {
	    mergeField(key);
	  }
	  for (key in child) {
	    if (!hasOwn(parent, key)) {
	      mergeField(key);
	    }
	  }
	  function mergeField (key) {
	    var strat = strats[key] || defaultStrat;
	    options[key] = strat(parent[key], child[key], vm, key);
	  }
	  return options
	}

	/**
	 * Resolve an asset.
	 * This function is used because child instances need access
	 * to assets defined in its ancestor chain.
	 */
	function resolveAsset (
	  options,
	  type,
	  id,
	  warnMissing
	) {
	  /* istanbul ignore if */
	  if (typeof id !== 'string') {
	    return
	  }
	  var assets = options[type];
	  // check local registration variations first
	  if (hasOwn(assets, id)) { return assets[id] }
	  var camelizedId = camelize(id);
	  if (hasOwn(assets, camelizedId)) { return assets[camelizedId] }
	  var PascalCaseId = capitalize(camelizedId);
	  if (hasOwn(assets, PascalCaseId)) { return assets[PascalCaseId] }
	  // fallback to prototype chain
	  var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
	  return res
	}

	/*  */



	function validateProp (
	  key,
	  propOptions,
	  propsData,
	  vm
	) {
	  var prop = propOptions[key];
	  var absent = !hasOwn(propsData, key);
	  var value = propsData[key];
	  // boolean casting
	  var booleanIndex = getTypeIndex(Boolean, prop.type);
	  if (booleanIndex > -1) {
	    if (absent && !hasOwn(prop, 'default')) {
	      value = false;
	    } else if (value === '' || value === hyphenate(key)) {
	      // only cast empty string / same name to boolean if
	      // boolean has higher priority
	      var stringIndex = getTypeIndex(String, prop.type);
	      if (stringIndex < 0 || booleanIndex < stringIndex) {
	        value = true;
	      }
	    }
	  }
	  // check default value
	  if (value === undefined) {
	    value = getPropDefaultValue(vm, prop, key);
	    // since the default value is a fresh copy,
	    // make sure to observe it.
	    var prevShouldObserve = shouldObserve;
	    toggleObserving(true);
	    observe(value);
	    toggleObserving(prevShouldObserve);
	  }
	  return value
	}

	/**
	 * Get the default value of a prop.
	 */
	function getPropDefaultValue (vm, prop, key) {
	  // no default, return undefined
	  if (!hasOwn(prop, 'default')) {
	    return undefined
	  }
	  var def = prop.default;
	  // the raw prop value was also undefined from previous render,
	  // return previous default value to avoid unnecessary watcher trigger
	  if (vm && vm.$options.propsData &&
	    vm.$options.propsData[key] === undefined &&
	    vm._props[key] !== undefined
	  ) {
	    return vm._props[key]
	  }
	  // call factory function for non-Function types
	  // a value is Function if its prototype is function even across different execution context
	  return typeof def === 'function' && getType(prop.type) !== 'Function'
	    ? def.call(vm)
	    : def
	}

	var functionTypeCheckRE = /^\s*function (\w+)/;

	/**
	 * Use function string name to check built-in types,
	 * because a simple equality check will fail when running
	 * across different vms / iframes.
	 */
	function getType (fn) {
	  var match = fn && fn.toString().match(functionTypeCheckRE);
	  return match ? match[1] : ''
	}

	function isSameType (a, b) {
	  return getType(a) === getType(b)
	}

	function getTypeIndex (type, expectedTypes) {
	  if (!Array.isArray(expectedTypes)) {
	    return isSameType(expectedTypes, type) ? 0 : -1
	  }
	  for (var i = 0, len = expectedTypes.length; i < len; i++) {
	    if (isSameType(expectedTypes[i], type)) {
	      return i
	    }
	  }
	  return -1
	}

	/*  */

	function handleError (err, vm, info) {
	  // Deactivate deps tracking while processing error handler to avoid possible infinite rendering.
	  // See: https://github.com/vuejs/vuex/issues/1505
	  pushTarget();
	  try {
	    if (vm) {
	      var cur = vm;
	      while ((cur = cur.$parent)) {
	        var hooks = cur.$options.errorCaptured;
	        if (hooks) {
	          for (var i = 0; i < hooks.length; i++) {
	            try {
	              var capture = hooks[i].call(cur, err, vm, info) === false;
	              if (capture) { return }
	            } catch (e) {
	              globalHandleError(e, cur, 'errorCaptured hook');
	            }
	          }
	        }
	      }
	    }
	    globalHandleError(err, vm, info);
	  } finally {
	    popTarget();
	  }
	}

	function invokeWithErrorHandling (
	  handler,
	  context,
	  args,
	  vm,
	  info
	) {
	  var res;
	  try {
	    res = args ? handler.apply(context, args) : handler.call(context);
	    if (res && !res._isVue && isPromise(res) && !res._handled) {
	      res.catch(function (e) { return handleError(e, vm, info + " (Promise/async)"); });
	      // issue #9511
	      // avoid catch triggering multiple times when nested calls
	      res._handled = true;
	    }
	  } catch (e) {
	    handleError(e, vm, info);
	  }
	  return res
	}

	function globalHandleError (err, vm, info) {
	  if (config.errorHandler) {
	    try {
	      return config.errorHandler.call(null, err, vm, info)
	    } catch (e) {
	      // if the user intentionally throws the original error in the handler,
	      // do not log it twice
	      if (e !== err) {
	        logError(e, null, 'config.errorHandler');
	      }
	    }
	  }
	  logError(err, vm, info);
	}

	function logError (err, vm, info) {
	  /* istanbul ignore else */
	  if ((inBrowser || inWeex) && typeof console !== 'undefined') {
	    console.error(err);
	  } else {
	    throw err
	  }
	}

	/*  */

	var isUsingMicroTask = false;

	var callbacks = [];
	var pending = false;

	function flushCallbacks () {
	  pending = false;
	  var copies = callbacks.slice(0);
	  callbacks.length = 0;
	  for (var i = 0; i < copies.length; i++) {
	    copies[i]();
	  }
	}

	// Here we have async deferring wrappers using microtasks.
	// In 2.5 we used (macro) tasks (in combination with microtasks).
	// However, it has subtle problems when state is changed right before repaint
	// (e.g. #6813, out-in transitions).
	// Also, using (macro) tasks in event handler would cause some weird behaviors
	// that cannot be circumvented (e.g. #7109, #7153, #7546, #7834, #8109).
	// So we now use microtasks everywhere, again.
	// A major drawback of this tradeoff is that there are some scenarios
	// where microtasks have too high a priority and fire in between supposedly
	// sequential events (e.g. #4521, #6690, which have workarounds)
	// or even between bubbling of the same event (#6566).
	var timerFunc;

	// The nextTick behavior leverages the microtask queue, which can be accessed
	// via either native Promise.then or MutationObserver.
	// MutationObserver has wider support, however it is seriously bugged in
	// UIWebView in iOS >= 9.3.3 when triggered in touch event handlers. It
	// completely stops working after triggering a few times... so, if native
	// Promise is available, we will use it:
	/* istanbul ignore next, $flow-disable-line */
	if (typeof Promise !== 'undefined' && isNative(Promise)) {
	  var p = Promise.resolve();
	  timerFunc = function () {
	    p.then(flushCallbacks);
	    // In problematic UIWebViews, Promise.then doesn't completely break, but
	    // it can get stuck in a weird state where callbacks are pushed into the
	    // microtask queue but the queue isn't being flushed, until the browser
	    // needs to do some other work, e.g. handle a timer. Therefore we can
	    // "force" the microtask queue to be flushed by adding an empty timer.
	    if (isIOS) { setTimeout(noop); }
	  };
	  isUsingMicroTask = true;
	} else if (!isIE && typeof MutationObserver !== 'undefined' && (
	  isNative(MutationObserver) ||
	  // PhantomJS and iOS 7.x
	  MutationObserver.toString() === '[object MutationObserverConstructor]'
	)) {
	  // Use MutationObserver where native Promise is not available,
	  // e.g. PhantomJS, iOS7, Android 4.4
	  // (#6466 MutationObserver is unreliable in IE11)
	  var counter = 1;
	  var observer = new MutationObserver(flushCallbacks);
	  var textNode = document.createTextNode(String(counter));
	  observer.observe(textNode, {
	    characterData: true
	  });
	  timerFunc = function () {
	    counter = (counter + 1) % 2;
	    textNode.data = String(counter);
	  };
	  isUsingMicroTask = true;
	} else if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
	  // Fallback to setImmediate.
	  // Technically it leverages the (macro) task queue,
	  // but it is still a better choice than setTimeout.
	  timerFunc = function () {
	    setImmediate(flushCallbacks);
	  };
	} else {
	  // Fallback to setTimeout.
	  timerFunc = function () {
	    setTimeout(flushCallbacks, 0);
	  };
	}

	function nextTick (cb, ctx) {
	  var _resolve;
	  callbacks.push(function () {
	    if (cb) {
	      try {
	        cb.call(ctx);
	      } catch (e) {
	        handleError(e, ctx, 'nextTick');
	      }
	    } else if (_resolve) {
	      _resolve(ctx);
	    }
	  });
	  if (!pending) {
	    pending = true;
	    timerFunc();
	  }
	  // $flow-disable-line
	  if (!cb && typeof Promise !== 'undefined') {
	    return new Promise(function (resolve) {
	      _resolve = resolve;
	    })
	  }
	}

	/*  */

	var seenObjects = new _Set();

	/**
	 * Recursively traverse an object to evoke all converted
	 * getters, so that every nested property inside the object
	 * is collected as a "deep" dependency.
	 */
	function traverse (val) {
	  _traverse(val, seenObjects);
	  seenObjects.clear();
	}

	function _traverse (val, seen) {
	  var i, keys;
	  var isA = Array.isArray(val);
	  if ((!isA && !isObject(val)) || Object.isFrozen(val) || val instanceof VNode) {
	    return
	  }
	  if (val.__ob__) {
	    var depId = val.__ob__.dep.id;
	    if (seen.has(depId)) {
	      return
	    }
	    seen.add(depId);
	  }
	  if (isA) {
	    i = val.length;
	    while (i--) { _traverse(val[i], seen); }
	  } else {
	    keys = Object.keys(val);
	    i = keys.length;
	    while (i--) { _traverse(val[keys[i]], seen); }
	  }
	}

	/*  */

	var normalizeEvent = cached(function (name) {
	  var passive = name.charAt(0) === '&';
	  name = passive ? name.slice(1) : name;
	  var once$$1 = name.charAt(0) === '~'; // Prefixed last, checked first
	  name = once$$1 ? name.slice(1) : name;
	  var capture = name.charAt(0) === '!';
	  name = capture ? name.slice(1) : name;
	  return {
	    name: name,
	    once: once$$1,
	    capture: capture,
	    passive: passive
	  }
	});

	function createFnInvoker (fns, vm) {
	  function invoker () {
	    var arguments$1 = arguments;

	    var fns = invoker.fns;
	    if (Array.isArray(fns)) {
	      var cloned = fns.slice();
	      for (var i = 0; i < cloned.length; i++) {
	        invokeWithErrorHandling(cloned[i], null, arguments$1, vm, "v-on handler");
	      }
	    } else {
	      // return handler return value for single handlers
	      return invokeWithErrorHandling(fns, null, arguments, vm, "v-on handler")
	    }
	  }
	  invoker.fns = fns;
	  return invoker
	}

	function updateListeners (
	  on,
	  oldOn,
	  add,
	  remove$$1,
	  createOnceHandler,
	  vm
	) {
	  var name, def$$1, cur, old, event;
	  for (name in on) {
	    def$$1 = cur = on[name];
	    old = oldOn[name];
	    event = normalizeEvent(name);
	    if (isUndef(cur)) ; else if (isUndef(old)) {
	      if (isUndef(cur.fns)) {
	        cur = on[name] = createFnInvoker(cur, vm);
	      }
	      if (isTrue(event.once)) {
	        cur = on[name] = createOnceHandler(event.name, cur, event.capture);
	      }
	      add(event.name, cur, event.capture, event.passive, event.params);
	    } else if (cur !== old) {
	      old.fns = cur;
	      on[name] = old;
	    }
	  }
	  for (name in oldOn) {
	    if (isUndef(on[name])) {
	      event = normalizeEvent(name);
	      remove$$1(event.name, oldOn[name], event.capture);
	    }
	  }
	}

	/*  */

	function mergeVNodeHook (def, hookKey, hook) {
	  if (def instanceof VNode) {
	    def = def.data.hook || (def.data.hook = {});
	  }
	  var invoker;
	  var oldHook = def[hookKey];

	  function wrappedHook () {
	    hook.apply(this, arguments);
	    // important: remove merged hook to ensure it's called only once
	    // and prevent memory leak
	    remove(invoker.fns, wrappedHook);
	  }

	  if (isUndef(oldHook)) {
	    // no existing hook
	    invoker = createFnInvoker([wrappedHook]);
	  } else {
	    /* istanbul ignore if */
	    if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
	      // already a merged invoker
	      invoker = oldHook;
	      invoker.fns.push(wrappedHook);
	    } else {
	      // existing plain hook
	      invoker = createFnInvoker([oldHook, wrappedHook]);
	    }
	  }

	  invoker.merged = true;
	  def[hookKey] = invoker;
	}

	/*  */

	function extractPropsFromVNodeData (
	  data,
	  Ctor,
	  tag
	) {
	  // we are only extracting raw values here.
	  // validation and default values are handled in the child
	  // component itself.
	  var propOptions = Ctor.options.props;
	  if (isUndef(propOptions)) {
	    return
	  }
	  var res = {};
	  var attrs = data.attrs;
	  var props = data.props;
	  if (isDef(attrs) || isDef(props)) {
	    for (var key in propOptions) {
	      var altKey = hyphenate(key);
	      checkProp(res, props, key, altKey, true) ||
	      checkProp(res, attrs, key, altKey, false);
	    }
	  }
	  return res
	}

	function checkProp (
	  res,
	  hash,
	  key,
	  altKey,
	  preserve
	) {
	  if (isDef(hash)) {
	    if (hasOwn(hash, key)) {
	      res[key] = hash[key];
	      if (!preserve) {
	        delete hash[key];
	      }
	      return true
	    } else if (hasOwn(hash, altKey)) {
	      res[key] = hash[altKey];
	      if (!preserve) {
	        delete hash[altKey];
	      }
	      return true
	    }
	  }
	  return false
	}

	/*  */

	// The template compiler attempts to minimize the need for normalization by
	// statically analyzing the template at compile time.
	//
	// For plain HTML markup, normalization can be completely skipped because the
	// generated render function is guaranteed to return Array<VNode>. There are
	// two cases where extra normalization is needed:

	// 1. When the children contains components - because a functional component
	// may return an Array instead of a single root. In this case, just a simple
	// normalization is needed - if any child is an Array, we flatten the whole
	// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
	// because functional components already normalize their own children.
	function simpleNormalizeChildren (children) {
	  for (var i = 0; i < children.length; i++) {
	    if (Array.isArray(children[i])) {
	      return Array.prototype.concat.apply([], children)
	    }
	  }
	  return children
	}

	// 2. When the children contains constructs that always generated nested Arrays,
	// e.g. <template>, <slot>, v-for, or when the children is provided by user
	// with hand-written render functions / JSX. In such cases a full normalization
	// is needed to cater to all possible types of children values.
	function normalizeChildren (children) {
	  return isPrimitive(children)
	    ? [createTextVNode(children)]
	    : Array.isArray(children)
	      ? normalizeArrayChildren(children)
	      : undefined
	}

	function isTextNode (node) {
	  return isDef(node) && isDef(node.text) && isFalse(node.isComment)
	}

	function normalizeArrayChildren (children, nestedIndex) {
	  var res = [];
	  var i, c, lastIndex, last;
	  for (i = 0; i < children.length; i++) {
	    c = children[i];
	    if (isUndef(c) || typeof c === 'boolean') { continue }
	    lastIndex = res.length - 1;
	    last = res[lastIndex];
	    //  nested
	    if (Array.isArray(c)) {
	      if (c.length > 0) {
	        c = normalizeArrayChildren(c, ((nestedIndex || '') + "_" + i));
	        // merge adjacent text nodes
	        if (isTextNode(c[0]) && isTextNode(last)) {
	          res[lastIndex] = createTextVNode(last.text + (c[0]).text);
	          c.shift();
	        }
	        res.push.apply(res, c);
	      }
	    } else if (isPrimitive(c)) {
	      if (isTextNode(last)) {
	        // merge adjacent text nodes
	        // this is necessary for SSR hydration because text nodes are
	        // essentially merged when rendered to HTML strings
	        res[lastIndex] = createTextVNode(last.text + c);
	      } else if (c !== '') {
	        // convert primitive to vnode
	        res.push(createTextVNode(c));
	      }
	    } else {
	      if (isTextNode(c) && isTextNode(last)) {
	        // merge adjacent text nodes
	        res[lastIndex] = createTextVNode(last.text + c.text);
	      } else {
	        // default key for nested array children (likely generated by v-for)
	        if (isTrue(children._isVList) &&
	          isDef(c.tag) &&
	          isUndef(c.key) &&
	          isDef(nestedIndex)) {
	          c.key = "__vlist" + nestedIndex + "_" + i + "__";
	        }
	        res.push(c);
	      }
	    }
	  }
	  return res
	}

	/*  */

	function initProvide (vm) {
	  var provide = vm.$options.provide;
	  if (provide) {
	    vm._provided = typeof provide === 'function'
	      ? provide.call(vm)
	      : provide;
	  }
	}

	function initInjections (vm) {
	  var result = resolveInject(vm.$options.inject, vm);
	  if (result) {
	    toggleObserving(false);
	    Object.keys(result).forEach(function (key) {
	      /* istanbul ignore else */
	      {
	        defineReactive$$1(vm, key, result[key]);
	      }
	    });
	    toggleObserving(true);
	  }
	}

	function resolveInject (inject, vm) {
	  if (inject) {
	    // inject is :any because flow is not smart enough to figure out cached
	    var result = Object.create(null);
	    var keys = hasSymbol
	      ? Reflect.ownKeys(inject)
	      : Object.keys(inject);

	    for (var i = 0; i < keys.length; i++) {
	      var key = keys[i];
	      // #6574 in case the inject object is observed...
	      if (key === '__ob__') { continue }
	      var provideKey = inject[key].from;
	      var source = vm;
	      while (source) {
	        if (source._provided && hasOwn(source._provided, provideKey)) {
	          result[key] = source._provided[provideKey];
	          break
	        }
	        source = source.$parent;
	      }
	      if (!source) {
	        if ('default' in inject[key]) {
	          var provideDefault = inject[key].default;
	          result[key] = typeof provideDefault === 'function'
	            ? provideDefault.call(vm)
	            : provideDefault;
	        }
	      }
	    }
	    return result
	  }
	}

	/*  */



	/**
	 * Runtime helper for resolving raw children VNodes into a slot object.
	 */
	function resolveSlots (
	  children,
	  context
	) {
	  if (!children || !children.length) {
	    return {}
	  }
	  var slots = {};
	  for (var i = 0, l = children.length; i < l; i++) {
	    var child = children[i];
	    var data = child.data;
	    // remove slot attribute if the node is resolved as a Vue slot node
	    if (data && data.attrs && data.attrs.slot) {
	      delete data.attrs.slot;
	    }
	    // named slots should only be respected if the vnode was rendered in the
	    // same context.
	    if ((child.context === context || child.fnContext === context) &&
	      data && data.slot != null
	    ) {
	      var name = data.slot;
	      var slot = (slots[name] || (slots[name] = []));
	      if (child.tag === 'template') {
	        slot.push.apply(slot, child.children || []);
	      } else {
	        slot.push(child);
	      }
	    } else {
	      (slots.default || (slots.default = [])).push(child);
	    }
	  }
	  // ignore slots that contains only whitespace
	  for (var name$1 in slots) {
	    if (slots[name$1].every(isWhitespace)) {
	      delete slots[name$1];
	    }
	  }
	  return slots
	}

	function isWhitespace (node) {
	  return (node.isComment && !node.asyncFactory) || node.text === ' '
	}

	/*  */

	function isAsyncPlaceholder (node) {
	  return node.isComment && node.asyncFactory
	}

	/*  */

	function normalizeScopedSlots (
	  slots,
	  normalSlots,
	  prevSlots
	) {
	  var res;
	  var hasNormalSlots = Object.keys(normalSlots).length > 0;
	  var isStable = slots ? !!slots.$stable : !hasNormalSlots;
	  var key = slots && slots.$key;
	  if (!slots) {
	    res = {};
	  } else if (slots._normalized) {
	    // fast path 1: child component re-render only, parent did not change
	    return slots._normalized
	  } else if (
	    isStable &&
	    prevSlots &&
	    prevSlots !== emptyObject &&
	    key === prevSlots.$key &&
	    !hasNormalSlots &&
	    !prevSlots.$hasNormal
	  ) {
	    // fast path 2: stable scoped slots w/ no normal slots to proxy,
	    // only need to normalize once
	    return prevSlots
	  } else {
	    res = {};
	    for (var key$1 in slots) {
	      if (slots[key$1] && key$1[0] !== '$') {
	        res[key$1] = normalizeScopedSlot(normalSlots, key$1, slots[key$1]);
	      }
	    }
	  }
	  // expose normal slots on scopedSlots
	  for (var key$2 in normalSlots) {
	    if (!(key$2 in res)) {
	      res[key$2] = proxyNormalSlot(normalSlots, key$2);
	    }
	  }
	  // avoriaz seems to mock a non-extensible $scopedSlots object
	  // and when that is passed down this would cause an error
	  if (slots && Object.isExtensible(slots)) {
	    (slots)._normalized = res;
	  }
	  def(res, '$stable', isStable);
	  def(res, '$key', key);
	  def(res, '$hasNormal', hasNormalSlots);
	  return res
	}

	function normalizeScopedSlot(normalSlots, key, fn) {
	  var normalized = function () {
	    var res = arguments.length ? fn.apply(null, arguments) : fn({});
	    res = res && typeof res === 'object' && !Array.isArray(res)
	      ? [res] // single vnode
	      : normalizeChildren(res);
	    var vnode = res && res[0];
	    return res && (
	      !vnode ||
	      (vnode.isComment && !isAsyncPlaceholder(vnode)) // #9658, #10391
	    ) ? undefined
	      : res
	  };
	  // this is a slot using the new v-slot syntax without scope. although it is
	  // compiled as a scoped slot, render fn users would expect it to be present
	  // on this.$slots because the usage is semantically a normal slot.
	  if (fn.proxy) {
	    Object.defineProperty(normalSlots, key, {
	      get: normalized,
	      enumerable: true,
	      configurable: true
	    });
	  }
	  return normalized
	}

	function proxyNormalSlot(slots, key) {
	  return function () { return slots[key]; }
	}

	/*  */

	/**
	 * Runtime helper for rendering v-for lists.
	 */
	function renderList (
	  val,
	  render
	) {
	  var ret, i, l, keys, key;
	  if (Array.isArray(val) || typeof val === 'string') {
	    ret = new Array(val.length);
	    for (i = 0, l = val.length; i < l; i++) {
	      ret[i] = render(val[i], i);
	    }
	  } else if (typeof val === 'number') {
	    ret = new Array(val);
	    for (i = 0; i < val; i++) {
	      ret[i] = render(i + 1, i);
	    }
	  } else if (isObject(val)) {
	    if (hasSymbol && val[Symbol.iterator]) {
	      ret = [];
	      var iterator = val[Symbol.iterator]();
	      var result = iterator.next();
	      while (!result.done) {
	        ret.push(render(result.value, ret.length));
	        result = iterator.next();
	      }
	    } else {
	      keys = Object.keys(val);
	      ret = new Array(keys.length);
	      for (i = 0, l = keys.length; i < l; i++) {
	        key = keys[i];
	        ret[i] = render(val[key], key, i);
	      }
	    }
	  }
	  if (!isDef(ret)) {
	    ret = [];
	  }
	  (ret)._isVList = true;
	  return ret
	}

	/*  */

	/**
	 * Runtime helper for rendering <slot>
	 */
	function renderSlot (
	  name,
	  fallbackRender,
	  props,
	  bindObject
	) {
	  var scopedSlotFn = this.$scopedSlots[name];
	  var nodes;
	  if (scopedSlotFn) {
	    // scoped slot
	    props = props || {};
	    if (bindObject) {
	      props = extend(extend({}, bindObject), props);
	    }
	    nodes =
	      scopedSlotFn(props) ||
	      (typeof fallbackRender === 'function' ? fallbackRender() : fallbackRender);
	  } else {
	    nodes =
	      this.$slots[name] ||
	      (typeof fallbackRender === 'function' ? fallbackRender() : fallbackRender);
	  }

	  var target = props && props.slot;
	  if (target) {
	    return this.$createElement('template', { slot: target }, nodes)
	  } else {
	    return nodes
	  }
	}

	/*  */

	/**
	 * Runtime helper for resolving filters
	 */
	function resolveFilter (id) {
	  return resolveAsset(this.$options, 'filters', id, true) || identity
	}

	/*  */

	function isKeyNotMatch (expect, actual) {
	  if (Array.isArray(expect)) {
	    return expect.indexOf(actual) === -1
	  } else {
	    return expect !== actual
	  }
	}

	/**
	 * Runtime helper for checking keyCodes from config.
	 * exposed as Vue.prototype._k
	 * passing in eventKeyName as last argument separately for backwards compat
	 */
	function checkKeyCodes (
	  eventKeyCode,
	  key,
	  builtInKeyCode,
	  eventKeyName,
	  builtInKeyName
	) {
	  var mappedKeyCode = config.keyCodes[key] || builtInKeyCode;
	  if (builtInKeyName && eventKeyName && !config.keyCodes[key]) {
	    return isKeyNotMatch(builtInKeyName, eventKeyName)
	  } else if (mappedKeyCode) {
	    return isKeyNotMatch(mappedKeyCode, eventKeyCode)
	  } else if (eventKeyName) {
	    return hyphenate(eventKeyName) !== key
	  }
	  return eventKeyCode === undefined
	}

	/*  */

	/**
	 * Runtime helper for merging v-bind="object" into a VNode's data.
	 */
	function bindObjectProps (
	  data,
	  tag,
	  value,
	  asProp,
	  isSync
	) {
	  if (value) {
	    if (!isObject(value)) ; else {
	      if (Array.isArray(value)) {
	        value = toObject(value);
	      }
	      var hash;
	      var loop = function ( key ) {
	        if (
	          key === 'class' ||
	          key === 'style' ||
	          isReservedAttribute(key)
	        ) {
	          hash = data;
	        } else {
	          var type = data.attrs && data.attrs.type;
	          hash = asProp || config.mustUseProp(tag, type, key)
	            ? data.domProps || (data.domProps = {})
	            : data.attrs || (data.attrs = {});
	        }
	        var camelizedKey = camelize(key);
	        var hyphenatedKey = hyphenate(key);
	        if (!(camelizedKey in hash) && !(hyphenatedKey in hash)) {
	          hash[key] = value[key];

	          if (isSync) {
	            var on = data.on || (data.on = {});
	            on[("update:" + key)] = function ($event) {
	              value[key] = $event;
	            };
	          }
	        }
	      };

	      for (var key in value) { loop( key ); }
	    }
	  }
	  return data
	}

	/*  */

	/**
	 * Runtime helper for rendering static trees.
	 */
	function renderStatic (
	  index,
	  isInFor
	) {
	  var cached = this._staticTrees || (this._staticTrees = []);
	  var tree = cached[index];
	  // if has already-rendered static tree and not inside v-for,
	  // we can reuse the same tree.
	  if (tree && !isInFor) {
	    return tree
	  }
	  // otherwise, render a fresh tree.
	  tree = cached[index] = this.$options.staticRenderFns[index].call(
	    this._renderProxy,
	    null,
	    this // for render fns generated for functional component templates
	  );
	  markStatic(tree, ("__static__" + index), false);
	  return tree
	}

	/**
	 * Runtime helper for v-once.
	 * Effectively it means marking the node as static with a unique key.
	 */
	function markOnce (
	  tree,
	  index,
	  key
	) {
	  markStatic(tree, ("__once__" + index + (key ? ("_" + key) : "")), true);
	  return tree
	}

	function markStatic (
	  tree,
	  key,
	  isOnce
	) {
	  if (Array.isArray(tree)) {
	    for (var i = 0; i < tree.length; i++) {
	      if (tree[i] && typeof tree[i] !== 'string') {
	        markStaticNode(tree[i], (key + "_" + i), isOnce);
	      }
	    }
	  } else {
	    markStaticNode(tree, key, isOnce);
	  }
	}

	function markStaticNode (node, key, isOnce) {
	  node.isStatic = true;
	  node.key = key;
	  node.isOnce = isOnce;
	}

	/*  */

	function bindObjectListeners (data, value) {
	  if (value) {
	    if (!isPlainObject(value)) ; else {
	      var on = data.on = data.on ? extend({}, data.on) : {};
	      for (var key in value) {
	        var existing = on[key];
	        var ours = value[key];
	        on[key] = existing ? [].concat(existing, ours) : ours;
	      }
	    }
	  }
	  return data
	}

	/*  */

	function resolveScopedSlots (
	  fns, // see flow/vnode
	  res,
	  // the following are added in 2.6
	  hasDynamicKeys,
	  contentHashKey
	) {
	  res = res || { $stable: !hasDynamicKeys };
	  for (var i = 0; i < fns.length; i++) {
	    var slot = fns[i];
	    if (Array.isArray(slot)) {
	      resolveScopedSlots(slot, res, hasDynamicKeys);
	    } else if (slot) {
	      // marker for reverse proxying v-slot without scope on this.$slots
	      if (slot.proxy) {
	        slot.fn.proxy = true;
	      }
	      res[slot.key] = slot.fn;
	    }
	  }
	  if (contentHashKey) {
	    (res).$key = contentHashKey;
	  }
	  return res
	}

	/*  */

	function bindDynamicKeys (baseObj, values) {

	  for (var i = 0; i < values.length; i += 2) {
	    var key = values[i];
	    if (typeof key === 'string' && key) {
	      baseObj[values[i]] = values[i + 1];
	    }
	  }
	  return baseObj
	}

	// helper to dynamically append modifier runtime markers to event names.
	// ensure only append when value is already string, otherwise it will be cast
	// to string and cause the type check to miss.
	function prependModifier (value, symbol) {
	  return typeof value === 'string' ? symbol + value : value
	}

	/*  */

	function installRenderHelpers (target) {
	  target._o = markOnce;
	  target._n = toNumber;
	  target._s = toString;
	  target._l = renderList;
	  target._t = renderSlot;
	  target._q = looseEqual;
	  target._i = looseIndexOf;
	  target._m = renderStatic;
	  target._f = resolveFilter;
	  target._k = checkKeyCodes;
	  target._b = bindObjectProps;
	  target._v = createTextVNode;
	  target._e = createEmptyVNode;
	  target._u = resolveScopedSlots;
	  target._g = bindObjectListeners;
	  target._d = bindDynamicKeys;
	  target._p = prependModifier;
	}

	/*  */

	function FunctionalRenderContext (
	  data,
	  props,
	  children,
	  parent,
	  Ctor
	) {
	  var this$1 = this;

	  var options = Ctor.options;
	  // ensure the createElement function in functional components
	  // gets a unique context - this is necessary for correct named slot check
	  var contextVm;
	  if (hasOwn(parent, '_uid')) {
	    contextVm = Object.create(parent);
	    // $flow-disable-line
	    contextVm._original = parent;
	  } else {
	    // the context vm passed in is a functional context as well.
	    // in this case we want to make sure we are able to get a hold to the
	    // real context instance.
	    contextVm = parent;
	    // $flow-disable-line
	    parent = parent._original;
	  }
	  var isCompiled = isTrue(options._compiled);
	  var needNormalization = !isCompiled;

	  this.data = data;
	  this.props = props;
	  this.children = children;
	  this.parent = parent;
	  this.listeners = data.on || emptyObject;
	  this.injections = resolveInject(options.inject, parent);
	  this.slots = function () {
	    if (!this$1.$slots) {
	      normalizeScopedSlots(
	        data.scopedSlots,
	        this$1.$slots = resolveSlots(children, parent)
	      );
	    }
	    return this$1.$slots
	  };

	  Object.defineProperty(this, 'scopedSlots', ({
	    enumerable: true,
	    get: function get () {
	      return normalizeScopedSlots(data.scopedSlots, this.slots())
	    }
	  }));

	  // support for compiled functional template
	  if (isCompiled) {
	    // exposing $options for renderStatic()
	    this.$options = options;
	    // pre-resolve slots for renderSlot()
	    this.$slots = this.slots();
	    this.$scopedSlots = normalizeScopedSlots(data.scopedSlots, this.$slots);
	  }

	  if (options._scopeId) {
	    this._c = function (a, b, c, d) {
	      var vnode = createElement(contextVm, a, b, c, d, needNormalization);
	      if (vnode && !Array.isArray(vnode)) {
	        vnode.fnScopeId = options._scopeId;
	        vnode.fnContext = parent;
	      }
	      return vnode
	    };
	  } else {
	    this._c = function (a, b, c, d) { return createElement(contextVm, a, b, c, d, needNormalization); };
	  }
	}

	installRenderHelpers(FunctionalRenderContext.prototype);

	function createFunctionalComponent (
	  Ctor,
	  propsData,
	  data,
	  contextVm,
	  children
	) {
	  var options = Ctor.options;
	  var props = {};
	  var propOptions = options.props;
	  if (isDef(propOptions)) {
	    for (var key in propOptions) {
	      props[key] = validateProp(key, propOptions, propsData || emptyObject);
	    }
	  } else {
	    if (isDef(data.attrs)) { mergeProps(props, data.attrs); }
	    if (isDef(data.props)) { mergeProps(props, data.props); }
	  }

	  var renderContext = new FunctionalRenderContext(
	    data,
	    props,
	    children,
	    contextVm,
	    Ctor
	  );

	  var vnode = options.render.call(null, renderContext._c, renderContext);

	  if (vnode instanceof VNode) {
	    return cloneAndMarkFunctionalResult(vnode, data, renderContext.parent, options, renderContext)
	  } else if (Array.isArray(vnode)) {
	    var vnodes = normalizeChildren(vnode) || [];
	    var res = new Array(vnodes.length);
	    for (var i = 0; i < vnodes.length; i++) {
	      res[i] = cloneAndMarkFunctionalResult(vnodes[i], data, renderContext.parent, options, renderContext);
	    }
	    return res
	  }
	}

	function cloneAndMarkFunctionalResult (vnode, data, contextVm, options, renderContext) {
	  // #7817 clone node before setting fnContext, otherwise if the node is reused
	  // (e.g. it was from a cached normal slot) the fnContext causes named slots
	  // that should not be matched to match.
	  var clone = cloneVNode(vnode);
	  clone.fnContext = contextVm;
	  clone.fnOptions = options;
	  if (data.slot) {
	    (clone.data || (clone.data = {})).slot = data.slot;
	  }
	  return clone
	}

	function mergeProps (to, from) {
	  for (var key in from) {
	    to[camelize(key)] = from[key];
	  }
	}

	/*  */

	/*  */

	/*  */

	/*  */

	// inline hooks to be invoked on component VNodes during patch
	var componentVNodeHooks = {
	  init: function init (vnode, hydrating) {
	    if (
	      vnode.componentInstance &&
	      !vnode.componentInstance._isDestroyed &&
	      vnode.data.keepAlive
	    ) {
	      // kept-alive components, treat as a patch
	      var mountedNode = vnode; // work around flow
	      componentVNodeHooks.prepatch(mountedNode, mountedNode);
	    } else {
	      var child = vnode.componentInstance = createComponentInstanceForVnode(
	        vnode,
	        activeInstance
	      );
	      child.$mount(hydrating ? vnode.elm : undefined, hydrating);
	    }
	  },

	  prepatch: function prepatch (oldVnode, vnode) {
	    var options = vnode.componentOptions;
	    var child = vnode.componentInstance = oldVnode.componentInstance;
	    updateChildComponent(
	      child,
	      options.propsData, // updated props
	      options.listeners, // updated listeners
	      vnode, // new parent vnode
	      options.children // new children
	    );
	  },

	  insert: function insert (vnode) {
	    var context = vnode.context;
	    var componentInstance = vnode.componentInstance;
	    if (!componentInstance._isMounted) {
	      componentInstance._isMounted = true;
	      callHook(componentInstance, 'mounted');
	    }
	    if (vnode.data.keepAlive) {
	      if (context._isMounted) {
	        // vue-router#1212
	        // During updates, a kept-alive component's child components may
	        // change, so directly walking the tree here may call activated hooks
	        // on incorrect children. Instead we push them into a queue which will
	        // be processed after the whole patch process ended.
	        queueActivatedComponent(componentInstance);
	      } else {
	        activateChildComponent(componentInstance, true /* direct */);
	      }
	    }
	  },

	  destroy: function destroy (vnode) {
	    var componentInstance = vnode.componentInstance;
	    if (!componentInstance._isDestroyed) {
	      if (!vnode.data.keepAlive) {
	        componentInstance.$destroy();
	      } else {
	        deactivateChildComponent(componentInstance, true /* direct */);
	      }
	    }
	  }
	};

	var hooksToMerge = Object.keys(componentVNodeHooks);

	function createComponent (
	  Ctor,
	  data,
	  context,
	  children,
	  tag
	) {
	  if (isUndef(Ctor)) {
	    return
	  }

	  var baseCtor = context.$options._base;

	  // plain options object: turn it into a constructor
	  if (isObject(Ctor)) {
	    Ctor = baseCtor.extend(Ctor);
	  }

	  // if at this stage it's not a constructor or an async component factory,
	  // reject.
	  if (typeof Ctor !== 'function') {
	    return
	  }

	  // async component
	  var asyncFactory;
	  if (isUndef(Ctor.cid)) {
	    asyncFactory = Ctor;
	    Ctor = resolveAsyncComponent(asyncFactory, baseCtor);
	    if (Ctor === undefined) {
	      // return a placeholder node for async component, which is rendered
	      // as a comment node but preserves all the raw information for the node.
	      // the information will be used for async server-rendering and hydration.
	      return createAsyncPlaceholder(
	        asyncFactory,
	        data,
	        context,
	        children,
	        tag
	      )
	    }
	  }

	  data = data || {};

	  // resolve constructor options in case global mixins are applied after
	  // component constructor creation
	  resolveConstructorOptions(Ctor);

	  // transform component v-model data into props & events
	  if (isDef(data.model)) {
	    transformModel(Ctor.options, data);
	  }

	  // extract props
	  var propsData = extractPropsFromVNodeData(data, Ctor, tag);

	  // functional component
	  if (isTrue(Ctor.options.functional)) {
	    return createFunctionalComponent(Ctor, propsData, data, context, children)
	  }

	  // extract listeners, since these needs to be treated as
	  // child component listeners instead of DOM listeners
	  var listeners = data.on;
	  // replace with listeners with .native modifier
	  // so it gets processed during parent component patch.
	  data.on = data.nativeOn;

	  if (isTrue(Ctor.options.abstract)) {
	    // abstract components do not keep anything
	    // other than props & listeners & slot

	    // work around flow
	    var slot = data.slot;
	    data = {};
	    if (slot) {
	      data.slot = slot;
	    }
	  }

	  // install component management hooks onto the placeholder node
	  installComponentHooks(data);

	  // return a placeholder vnode
	  var name = Ctor.options.name || tag;
	  var vnode = new VNode(
	    ("vue-component-" + (Ctor.cid) + (name ? ("-" + name) : '')),
	    data, undefined, undefined, undefined, context,
	    { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children },
	    asyncFactory
	  );

	  return vnode
	}

	function createComponentInstanceForVnode (
	  // we know it's MountedComponentVNode but flow doesn't
	  vnode,
	  // activeInstance in lifecycle state
	  parent
	) {
	  var options = {
	    _isComponent: true,
	    _parentVnode: vnode,
	    parent: parent
	  };
	  // check inline-template render functions
	  var inlineTemplate = vnode.data.inlineTemplate;
	  if (isDef(inlineTemplate)) {
	    options.render = inlineTemplate.render;
	    options.staticRenderFns = inlineTemplate.staticRenderFns;
	  }
	  return new vnode.componentOptions.Ctor(options)
	}

	function installComponentHooks (data) {
	  var hooks = data.hook || (data.hook = {});
	  for (var i = 0; i < hooksToMerge.length; i++) {
	    var key = hooksToMerge[i];
	    var existing = hooks[key];
	    var toMerge = componentVNodeHooks[key];
	    if (existing !== toMerge && !(existing && existing._merged)) {
	      hooks[key] = existing ? mergeHook$1(toMerge, existing) : toMerge;
	    }
	  }
	}

	function mergeHook$1 (f1, f2) {
	  var merged = function (a, b) {
	    // flow complains about extra args which is why we use any
	    f1(a, b);
	    f2(a, b);
	  };
	  merged._merged = true;
	  return merged
	}

	// transform component v-model info (value and callback) into
	// prop and event handler respectively.
	function transformModel (options, data) {
	  var prop = (options.model && options.model.prop) || 'value';
	  var event = (options.model && options.model.event) || 'input'
	  ;(data.attrs || (data.attrs = {}))[prop] = data.model.value;
	  var on = data.on || (data.on = {});
	  var existing = on[event];
	  var callback = data.model.callback;
	  if (isDef(existing)) {
	    if (
	      Array.isArray(existing)
	        ? existing.indexOf(callback) === -1
	        : existing !== callback
	    ) {
	      on[event] = [callback].concat(existing);
	    }
	  } else {
	    on[event] = callback;
	  }
	}

	/*  */

	var SIMPLE_NORMALIZE = 1;
	var ALWAYS_NORMALIZE = 2;

	// wrapper function for providing a more flexible interface
	// without getting yelled at by flow
	function createElement (
	  context,
	  tag,
	  data,
	  children,
	  normalizationType,
	  alwaysNormalize
	) {
	  if (Array.isArray(data) || isPrimitive(data)) {
	    normalizationType = children;
	    children = data;
	    data = undefined;
	  }
	  if (isTrue(alwaysNormalize)) {
	    normalizationType = ALWAYS_NORMALIZE;
	  }
	  return _createElement(context, tag, data, children, normalizationType)
	}

	function _createElement (
	  context,
	  tag,
	  data,
	  children,
	  normalizationType
	) {
	  if (isDef(data) && isDef((data).__ob__)) {
	    return createEmptyVNode()
	  }
	  // object syntax in v-bind
	  if (isDef(data) && isDef(data.is)) {
	    tag = data.is;
	  }
	  if (!tag) {
	    // in case of component :is set to falsy value
	    return createEmptyVNode()
	  }
	  // support single function children as default scoped slot
	  if (Array.isArray(children) &&
	    typeof children[0] === 'function'
	  ) {
	    data = data || {};
	    data.scopedSlots = { default: children[0] };
	    children.length = 0;
	  }
	  if (normalizationType === ALWAYS_NORMALIZE) {
	    children = normalizeChildren(children);
	  } else if (normalizationType === SIMPLE_NORMALIZE) {
	    children = simpleNormalizeChildren(children);
	  }
	  var vnode, ns;
	  if (typeof tag === 'string') {
	    var Ctor;
	    ns = (context.$vnode && context.$vnode.ns) || config.getTagNamespace(tag);
	    if (config.isReservedTag(tag)) {
	      vnode = new VNode(
	        config.parsePlatformTagName(tag), data, children,
	        undefined, undefined, context
	      );
	    } else if ((!data || !data.pre) && isDef(Ctor = resolveAsset(context.$options, 'components', tag))) {
	      // component
	      vnode = createComponent(Ctor, data, context, children, tag);
	    } else {
	      // unknown or unlisted namespaced elements
	      // check at runtime because it may get assigned a namespace when its
	      // parent normalizes children
	      vnode = new VNode(
	        tag, data, children,
	        undefined, undefined, context
	      );
	    }
	  } else {
	    // direct component options / constructor
	    vnode = createComponent(tag, data, context, children);
	  }
	  if (Array.isArray(vnode)) {
	    return vnode
	  } else if (isDef(vnode)) {
	    if (isDef(ns)) { applyNS(vnode, ns); }
	    if (isDef(data)) { registerDeepBindings(data); }
	    return vnode
	  } else {
	    return createEmptyVNode()
	  }
	}

	function applyNS (vnode, ns, force) {
	  vnode.ns = ns;
	  if (vnode.tag === 'foreignObject') {
	    // use default namespace inside foreignObject
	    ns = undefined;
	    force = true;
	  }
	  if (isDef(vnode.children)) {
	    for (var i = 0, l = vnode.children.length; i < l; i++) {
	      var child = vnode.children[i];
	      if (isDef(child.tag) && (
	        isUndef(child.ns) || (isTrue(force) && child.tag !== 'svg'))) {
	        applyNS(child, ns, force);
	      }
	    }
	  }
	}

	// ref #5318
	// necessary to ensure parent re-render when deep bindings like :style and
	// :class are used on slot nodes
	function registerDeepBindings (data) {
	  if (isObject(data.style)) {
	    traverse(data.style);
	  }
	  if (isObject(data.class)) {
	    traverse(data.class);
	  }
	}

	/*  */

	function initRender (vm) {
	  vm._vnode = null; // the root of the child tree
	  vm._staticTrees = null; // v-once cached trees
	  var options = vm.$options;
	  var parentVnode = vm.$vnode = options._parentVnode; // the placeholder node in parent tree
	  var renderContext = parentVnode && parentVnode.context;
	  vm.$slots = resolveSlots(options._renderChildren, renderContext);
	  vm.$scopedSlots = emptyObject;
	  // bind the createElement fn to this instance
	  // so that we get proper render context inside it.
	  // args order: tag, data, children, normalizationType, alwaysNormalize
	  // internal version is used by render functions compiled from templates
	  vm._c = function (a, b, c, d) { return createElement(vm, a, b, c, d, false); };
	  // normalization is always applied for the public version, used in
	  // user-written render functions.
	  vm.$createElement = function (a, b, c, d) { return createElement(vm, a, b, c, d, true); };

	  // $attrs & $listeners are exposed for easier HOC creation.
	  // they need to be reactive so that HOCs using them are always updated
	  var parentData = parentVnode && parentVnode.data;

	  /* istanbul ignore else */
	  {
	    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, null, true);
	    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, null, true);
	  }
	}

	var currentRenderingInstance = null;

	function renderMixin (Vue) {
	  // install runtime convenience helpers
	  installRenderHelpers(Vue.prototype);

	  Vue.prototype.$nextTick = function (fn) {
	    return nextTick(fn, this)
	  };

	  Vue.prototype._render = function () {
	    var vm = this;
	    var ref = vm.$options;
	    var render = ref.render;
	    var _parentVnode = ref._parentVnode;

	    if (_parentVnode) {
	      vm.$scopedSlots = normalizeScopedSlots(
	        _parentVnode.data.scopedSlots,
	        vm.$slots,
	        vm.$scopedSlots
	      );
	    }

	    // set parent vnode. this allows render functions to have access
	    // to the data on the placeholder node.
	    vm.$vnode = _parentVnode;
	    // render self
	    var vnode;
	    try {
	      // There's no need to maintain a stack because all render fns are called
	      // separately from one another. Nested component's render fns are called
	      // when parent component is patched.
	      currentRenderingInstance = vm;
	      vnode = render.call(vm._renderProxy, vm.$createElement);
	    } catch (e) {
	      handleError(e, vm, "render");
	      // return error render result,
	      // or previous vnode to prevent render error causing blank component
	      /* istanbul ignore else */
	      {
	        vnode = vm._vnode;
	      }
	    } finally {
	      currentRenderingInstance = null;
	    }
	    // if the returned array contains only a single node, allow it
	    if (Array.isArray(vnode) && vnode.length === 1) {
	      vnode = vnode[0];
	    }
	    // return empty vnode in case the render function errored out
	    if (!(vnode instanceof VNode)) {
	      vnode = createEmptyVNode();
	    }
	    // set parent
	    vnode.parent = _parentVnode;
	    return vnode
	  };
	}

	/*  */

	function ensureCtor (comp, base) {
	  if (
	    comp.__esModule ||
	    (hasSymbol && comp[Symbol.toStringTag] === 'Module')
	  ) {
	    comp = comp.default;
	  }
	  return isObject(comp)
	    ? base.extend(comp)
	    : comp
	}

	function createAsyncPlaceholder (
	  factory,
	  data,
	  context,
	  children,
	  tag
	) {
	  var node = createEmptyVNode();
	  node.asyncFactory = factory;
	  node.asyncMeta = { data: data, context: context, children: children, tag: tag };
	  return node
	}

	function resolveAsyncComponent (
	  factory,
	  baseCtor
	) {
	  if (isTrue(factory.error) && isDef(factory.errorComp)) {
	    return factory.errorComp
	  }

	  if (isDef(factory.resolved)) {
	    return factory.resolved
	  }

	  var owner = currentRenderingInstance;
	  if (owner && isDef(factory.owners) && factory.owners.indexOf(owner) === -1) {
	    // already pending
	    factory.owners.push(owner);
	  }

	  if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
	    return factory.loadingComp
	  }

	  if (owner && !isDef(factory.owners)) {
	    var owners = factory.owners = [owner];
	    var sync = true;
	    var timerLoading = null;
	    var timerTimeout = null

	    ;(owner).$on('hook:destroyed', function () { return remove(owners, owner); });

	    var forceRender = function (renderCompleted) {
	      for (var i = 0, l = owners.length; i < l; i++) {
	        (owners[i]).$forceUpdate();
	      }

	      if (renderCompleted) {
	        owners.length = 0;
	        if (timerLoading !== null) {
	          clearTimeout(timerLoading);
	          timerLoading = null;
	        }
	        if (timerTimeout !== null) {
	          clearTimeout(timerTimeout);
	          timerTimeout = null;
	        }
	      }
	    };

	    var resolve = once(function (res) {
	      // cache resolved
	      factory.resolved = ensureCtor(res, baseCtor);
	      // invoke callbacks only if this is not a synchronous resolve
	      // (async resolves are shimmed as synchronous during SSR)
	      if (!sync) {
	        forceRender(true);
	      } else {
	        owners.length = 0;
	      }
	    });

	    var reject = once(function (reason) {
	      if (isDef(factory.errorComp)) {
	        factory.error = true;
	        forceRender(true);
	      }
	    });

	    var res = factory(resolve, reject);

	    if (isObject(res)) {
	      if (isPromise(res)) {
	        // () => Promise
	        if (isUndef(factory.resolved)) {
	          res.then(resolve, reject);
	        }
	      } else if (isPromise(res.component)) {
	        res.component.then(resolve, reject);

	        if (isDef(res.error)) {
	          factory.errorComp = ensureCtor(res.error, baseCtor);
	        }

	        if (isDef(res.loading)) {
	          factory.loadingComp = ensureCtor(res.loading, baseCtor);
	          if (res.delay === 0) {
	            factory.loading = true;
	          } else {
	            timerLoading = setTimeout(function () {
	              timerLoading = null;
	              if (isUndef(factory.resolved) && isUndef(factory.error)) {
	                factory.loading = true;
	                forceRender(false);
	              }
	            }, res.delay || 200);
	          }
	        }

	        if (isDef(res.timeout)) {
	          timerTimeout = setTimeout(function () {
	            timerTimeout = null;
	            if (isUndef(factory.resolved)) {
	              reject(
	                null
	              );
	            }
	          }, res.timeout);
	        }
	      }
	    }

	    sync = false;
	    // return in case resolved synchronously
	    return factory.loading
	      ? factory.loadingComp
	      : factory.resolved
	  }
	}

	/*  */

	function getFirstComponentChild (children) {
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      var c = children[i];
	      if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
	        return c
	      }
	    }
	  }
	}

	/*  */

	/*  */

	function initEvents (vm) {
	  vm._events = Object.create(null);
	  vm._hasHookEvent = false;
	  // init parent attached events
	  var listeners = vm.$options._parentListeners;
	  if (listeners) {
	    updateComponentListeners(vm, listeners);
	  }
	}

	var target;

	function add (event, fn) {
	  target.$on(event, fn);
	}

	function remove$1 (event, fn) {
	  target.$off(event, fn);
	}

	function createOnceHandler (event, fn) {
	  var _target = target;
	  return function onceHandler () {
	    var res = fn.apply(null, arguments);
	    if (res !== null) {
	      _target.$off(event, onceHandler);
	    }
	  }
	}

	function updateComponentListeners (
	  vm,
	  listeners,
	  oldListeners
	) {
	  target = vm;
	  updateListeners(listeners, oldListeners || {}, add, remove$1, createOnceHandler, vm);
	  target = undefined;
	}

	function eventsMixin (Vue) {
	  var hookRE = /^hook:/;
	  Vue.prototype.$on = function (event, fn) {
	    var vm = this;
	    if (Array.isArray(event)) {
	      for (var i = 0, l = event.length; i < l; i++) {
	        vm.$on(event[i], fn);
	      }
	    } else {
	      (vm._events[event] || (vm._events[event] = [])).push(fn);
	      // optimize hook:event cost by using a boolean flag marked at registration
	      // instead of a hash lookup
	      if (hookRE.test(event)) {
	        vm._hasHookEvent = true;
	      }
	    }
	    return vm
	  };

	  Vue.prototype.$once = function (event, fn) {
	    var vm = this;
	    function on () {
	      vm.$off(event, on);
	      fn.apply(vm, arguments);
	    }
	    on.fn = fn;
	    vm.$on(event, on);
	    return vm
	  };

	  Vue.prototype.$off = function (event, fn) {
	    var vm = this;
	    // all
	    if (!arguments.length) {
	      vm._events = Object.create(null);
	      return vm
	    }
	    // array of events
	    if (Array.isArray(event)) {
	      for (var i$1 = 0, l = event.length; i$1 < l; i$1++) {
	        vm.$off(event[i$1], fn);
	      }
	      return vm
	    }
	    // specific event
	    var cbs = vm._events[event];
	    if (!cbs) {
	      return vm
	    }
	    if (!fn) {
	      vm._events[event] = null;
	      return vm
	    }
	    // specific handler
	    var cb;
	    var i = cbs.length;
	    while (i--) {
	      cb = cbs[i];
	      if (cb === fn || cb.fn === fn) {
	        cbs.splice(i, 1);
	        break
	      }
	    }
	    return vm
	  };

	  Vue.prototype.$emit = function (event) {
	    var vm = this;
	    var cbs = vm._events[event];
	    if (cbs) {
	      cbs = cbs.length > 1 ? toArray(cbs) : cbs;
	      var args = toArray(arguments, 1);
	      var info = "event handler for \"" + event + "\"";
	      for (var i = 0, l = cbs.length; i < l; i++) {
	        invokeWithErrorHandling(cbs[i], vm, args, vm, info);
	      }
	    }
	    return vm
	  };
	}

	/*  */

	var activeInstance = null;

	function setActiveInstance(vm) {
	  var prevActiveInstance = activeInstance;
	  activeInstance = vm;
	  return function () {
	    activeInstance = prevActiveInstance;
	  }
	}

	function initLifecycle (vm) {
	  var options = vm.$options;

	  // locate first non-abstract parent
	  var parent = options.parent;
	  if (parent && !options.abstract) {
	    while (parent.$options.abstract && parent.$parent) {
	      parent = parent.$parent;
	    }
	    parent.$children.push(vm);
	  }

	  vm.$parent = parent;
	  vm.$root = parent ? parent.$root : vm;

	  vm.$children = [];
	  vm.$refs = {};

	  vm._watcher = null;
	  vm._inactive = null;
	  vm._directInactive = false;
	  vm._isMounted = false;
	  vm._isDestroyed = false;
	  vm._isBeingDestroyed = false;
	}

	function lifecycleMixin (Vue) {
	  Vue.prototype._update = function (vnode, hydrating) {
	    var vm = this;
	    var prevEl = vm.$el;
	    var prevVnode = vm._vnode;
	    var restoreActiveInstance = setActiveInstance(vm);
	    vm._vnode = vnode;
	    // Vue.prototype.__patch__ is injected in entry points
	    // based on the rendering backend used.
	    if (!prevVnode) {
	      // initial render
	      vm.$el = vm.__patch__(vm.$el, vnode, hydrating, false /* removeOnly */);
	    } else {
	      // updates
	      vm.$el = vm.__patch__(prevVnode, vnode);
	    }
	    restoreActiveInstance();
	    // update __vue__ reference
	    if (prevEl) {
	      prevEl.__vue__ = null;
	    }
	    if (vm.$el) {
	      vm.$el.__vue__ = vm;
	    }
	    // if parent is an HOC, update its $el as well
	    if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
	      vm.$parent.$el = vm.$el;
	    }
	    // updated hook is called by the scheduler to ensure that children are
	    // updated in a parent's updated hook.
	  };

	  Vue.prototype.$forceUpdate = function () {
	    var vm = this;
	    if (vm._watcher) {
	      vm._watcher.update();
	    }
	  };

	  Vue.prototype.$destroy = function () {
	    var vm = this;
	    if (vm._isBeingDestroyed) {
	      return
	    }
	    callHook(vm, 'beforeDestroy');
	    vm._isBeingDestroyed = true;
	    // remove self from parent
	    var parent = vm.$parent;
	    if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
	      remove(parent.$children, vm);
	    }
	    // teardown watchers
	    if (vm._watcher) {
	      vm._watcher.teardown();
	    }
	    var i = vm._watchers.length;
	    while (i--) {
	      vm._watchers[i].teardown();
	    }
	    // remove reference from data ob
	    // frozen object may not have observer.
	    if (vm._data.__ob__) {
	      vm._data.__ob__.vmCount--;
	    }
	    // call the last hook...
	    vm._isDestroyed = true;
	    // invoke destroy hooks on current rendered tree
	    vm.__patch__(vm._vnode, null);
	    // fire destroyed hook
	    callHook(vm, 'destroyed');
	    // turn off all instance listeners.
	    vm.$off();
	    // remove __vue__ reference
	    if (vm.$el) {
	      vm.$el.__vue__ = null;
	    }
	    // release circular reference (#6759)
	    if (vm.$vnode) {
	      vm.$vnode.parent = null;
	    }
	  };
	}

	function mountComponent (
	  vm,
	  el,
	  hydrating
	) {
	  vm.$el = el;
	  if (!vm.$options.render) {
	    vm.$options.render = createEmptyVNode;
	  }
	  callHook(vm, 'beforeMount');

	  var updateComponent;
	  /* istanbul ignore if */
	  {
	    updateComponent = function () {
	      vm._update(vm._render(), hydrating);
	    };
	  }

	  // we set this to vm._watcher inside the watcher's constructor
	  // since the watcher's initial patch may call $forceUpdate (e.g. inside child
	  // component's mounted hook), which relies on vm._watcher being already defined
	  new Watcher(vm, updateComponent, noop, {
	    before: function before () {
	      if (vm._isMounted && !vm._isDestroyed) {
	        callHook(vm, 'beforeUpdate');
	      }
	    }
	  }, true /* isRenderWatcher */);
	  hydrating = false;

	  // manually mounted instance, call mounted on self
	  // mounted is called for render-created child components in its inserted hook
	  if (vm.$vnode == null) {
	    vm._isMounted = true;
	    callHook(vm, 'mounted');
	  }
	  return vm
	}

	function updateChildComponent (
	  vm,
	  propsData,
	  listeners,
	  parentVnode,
	  renderChildren
	) {

	  // determine whether component has slot children
	  // we need to do this before overwriting $options._renderChildren.

	  // check if there are dynamic scopedSlots (hand-written or compiled but with
	  // dynamic slot names). Static scoped slots compiled from template has the
	  // "$stable" marker.
	  var newScopedSlots = parentVnode.data.scopedSlots;
	  var oldScopedSlots = vm.$scopedSlots;
	  var hasDynamicScopedSlot = !!(
	    (newScopedSlots && !newScopedSlots.$stable) ||
	    (oldScopedSlots !== emptyObject && !oldScopedSlots.$stable) ||
	    (newScopedSlots && vm.$scopedSlots.$key !== newScopedSlots.$key) ||
	    (!newScopedSlots && vm.$scopedSlots.$key)
	  );

	  // Any static slot children from the parent may have changed during parent's
	  // update. Dynamic scoped slots may also have changed. In such cases, a forced
	  // update is necessary to ensure correctness.
	  var needsForceUpdate = !!(
	    renderChildren ||               // has new static slots
	    vm.$options._renderChildren ||  // has old static slots
	    hasDynamicScopedSlot
	  );

	  vm.$options._parentVnode = parentVnode;
	  vm.$vnode = parentVnode; // update vm's placeholder node without re-render

	  if (vm._vnode) { // update child tree's parent
	    vm._vnode.parent = parentVnode;
	  }
	  vm.$options._renderChildren = renderChildren;

	  // update $attrs and $listeners hash
	  // these are also reactive so they may trigger child update if the child
	  // used them during render
	  vm.$attrs = parentVnode.data.attrs || emptyObject;
	  vm.$listeners = listeners || emptyObject;

	  // update props
	  if (propsData && vm.$options.props) {
	    toggleObserving(false);
	    var props = vm._props;
	    var propKeys = vm.$options._propKeys || [];
	    for (var i = 0; i < propKeys.length; i++) {
	      var key = propKeys[i];
	      var propOptions = vm.$options.props; // wtf flow?
	      props[key] = validateProp(key, propOptions, propsData, vm);
	    }
	    toggleObserving(true);
	    // keep a copy of raw propsData
	    vm.$options.propsData = propsData;
	  }

	  // update listeners
	  listeners = listeners || emptyObject;
	  var oldListeners = vm.$options._parentListeners;
	  vm.$options._parentListeners = listeners;
	  updateComponentListeners(vm, listeners, oldListeners);

	  // resolve slots + force update if has children
	  if (needsForceUpdate) {
	    vm.$slots = resolveSlots(renderChildren, parentVnode.context);
	    vm.$forceUpdate();
	  }
	}

	function isInInactiveTree (vm) {
	  while (vm && (vm = vm.$parent)) {
	    if (vm._inactive) { return true }
	  }
	  return false
	}

	function activateChildComponent (vm, direct) {
	  if (direct) {
	    vm._directInactive = false;
	    if (isInInactiveTree(vm)) {
	      return
	    }
	  } else if (vm._directInactive) {
	    return
	  }
	  if (vm._inactive || vm._inactive === null) {
	    vm._inactive = false;
	    for (var i = 0; i < vm.$children.length; i++) {
	      activateChildComponent(vm.$children[i]);
	    }
	    callHook(vm, 'activated');
	  }
	}

	function deactivateChildComponent (vm, direct) {
	  if (direct) {
	    vm._directInactive = true;
	    if (isInInactiveTree(vm)) {
	      return
	    }
	  }
	  if (!vm._inactive) {
	    vm._inactive = true;
	    for (var i = 0; i < vm.$children.length; i++) {
	      deactivateChildComponent(vm.$children[i]);
	    }
	    callHook(vm, 'deactivated');
	  }
	}

	function callHook (vm, hook) {
	  // #7573 disable dep collection when invoking lifecycle hooks
	  pushTarget();
	  var handlers = vm.$options[hook];
	  var info = hook + " hook";
	  if (handlers) {
	    for (var i = 0, j = handlers.length; i < j; i++) {
	      invokeWithErrorHandling(handlers[i], vm, null, vm, info);
	    }
	  }
	  if (vm._hasHookEvent) {
	    vm.$emit('hook:' + hook);
	  }
	  popTarget();
	}

	var queue = [];
	var activatedChildren = [];
	var has = {};
	var waiting = false;
	var flushing = false;
	var index = 0;

	/**
	 * Reset the scheduler's state.
	 */
	function resetSchedulerState () {
	  index = queue.length = activatedChildren.length = 0;
	  has = {};
	  waiting = flushing = false;
	}

	// Async edge case #6566 requires saving the timestamp when event listeners are
	// attached. However, calling performance.now() has a perf overhead especially
	// if the page has thousands of event listeners. Instead, we take a timestamp
	// every time the scheduler flushes and use that for all event listeners
	// attached during that flush.
	var currentFlushTimestamp = 0;

	// Async edge case fix requires storing an event listener's attach timestamp.
	var getNow = Date.now;

	// Determine what event timestamp the browser is using. Annoyingly, the
	// timestamp can either be hi-res (relative to page load) or low-res
	// (relative to UNIX epoch), so in order to compare time we have to use the
	// same timestamp type when saving the flush timestamp.
	// All IE versions use low-res event timestamps, and have problematic clock
	// implementations (#9632)
	if (inBrowser && !isIE) {
	  var performance = window.performance;
	  if (
	    performance &&
	    typeof performance.now === 'function' &&
	    getNow() > document.createEvent('Event').timeStamp
	  ) {
	    // if the event timestamp, although evaluated AFTER the Date.now(), is
	    // smaller than it, it means the event is using a hi-res timestamp,
	    // and we need to use the hi-res version for event listener timestamps as
	    // well.
	    getNow = function () { return performance.now(); };
	  }
	}

	/**
	 * Flush both queues and run the watchers.
	 */
	function flushSchedulerQueue () {
	  currentFlushTimestamp = getNow();
	  flushing = true;
	  var watcher, id;

	  // Sort queue before flush.
	  // This ensures that:
	  // 1. Components are updated from parent to child. (because parent is always
	  //    created before the child)
	  // 2. A component's user watchers are run before its render watcher (because
	  //    user watchers are created before the render watcher)
	  // 3. If a component is destroyed during a parent component's watcher run,
	  //    its watchers can be skipped.
	  queue.sort(function (a, b) { return a.id - b.id; });

	  // do not cache length because more watchers might be pushed
	  // as we run existing watchers
	  for (index = 0; index < queue.length; index++) {
	    watcher = queue[index];
	    if (watcher.before) {
	      watcher.before();
	    }
	    id = watcher.id;
	    has[id] = null;
	    watcher.run();
	  }

	  // keep copies of post queues before resetting state
	  var activatedQueue = activatedChildren.slice();
	  var updatedQueue = queue.slice();

	  resetSchedulerState();

	  // call component updated and activated hooks
	  callActivatedHooks(activatedQueue);
	  callUpdatedHooks(updatedQueue);

	  // devtool hook
	  /* istanbul ignore if */
	  if (devtools && config.devtools) {
	    devtools.emit('flush');
	  }
	}

	function callUpdatedHooks (queue) {
	  var i = queue.length;
	  while (i--) {
	    var watcher = queue[i];
	    var vm = watcher.vm;
	    if (vm._watcher === watcher && vm._isMounted && !vm._isDestroyed) {
	      callHook(vm, 'updated');
	    }
	  }
	}

	/**
	 * Queue a kept-alive component that was activated during patch.
	 * The queue will be processed after the entire tree has been patched.
	 */
	function queueActivatedComponent (vm) {
	  // setting _inactive to false here so that a render function can
	  // rely on checking whether it's in an inactive tree (e.g. router-view)
	  vm._inactive = false;
	  activatedChildren.push(vm);
	}

	function callActivatedHooks (queue) {
	  for (var i = 0; i < queue.length; i++) {
	    queue[i]._inactive = true;
	    activateChildComponent(queue[i], true /* true */);
	  }
	}

	/**
	 * Push a watcher into the watcher queue.
	 * Jobs with duplicate IDs will be skipped unless it's
	 * pushed when the queue is being flushed.
	 */
	function queueWatcher (watcher) {
	  var id = watcher.id;
	  if (has[id] == null) {
	    has[id] = true;
	    if (!flushing) {
	      queue.push(watcher);
	    } else {
	      // if already flushing, splice the watcher based on its id
	      // if already past its id, it will be run next immediately.
	      var i = queue.length - 1;
	      while (i > index && queue[i].id > watcher.id) {
	        i--;
	      }
	      queue.splice(i + 1, 0, watcher);
	    }
	    // queue the flush
	    if (!waiting) {
	      waiting = true;
	      nextTick(flushSchedulerQueue);
	    }
	  }
	}

	/*  */



	var uid$2 = 0;

	/**
	 * A watcher parses an expression, collects dependencies,
	 * and fires callback when the expression value changes.
	 * This is used for both the $watch() api and directives.
	 */
	var Watcher = function Watcher (
	  vm,
	  expOrFn,
	  cb,
	  options,
	  isRenderWatcher
	) {
	  this.vm = vm;
	  if (isRenderWatcher) {
	    vm._watcher = this;
	  }
	  vm._watchers.push(this);
	  // options
	  if (options) {
	    this.deep = !!options.deep;
	    this.user = !!options.user;
	    this.lazy = !!options.lazy;
	    this.sync = !!options.sync;
	    this.before = options.before;
	  } else {
	    this.deep = this.user = this.lazy = this.sync = false;
	  }
	  this.cb = cb;
	  this.id = ++uid$2; // uid for batching
	  this.active = true;
	  this.dirty = this.lazy; // for lazy watchers
	  this.deps = [];
	  this.newDeps = [];
	  this.depIds = new _Set();
	  this.newDepIds = new _Set();
	  this.expression = '';
	  // parse expression for getter
	  if (typeof expOrFn === 'function') {
	    this.getter = expOrFn;
	  } else {
	    this.getter = parsePath(expOrFn);
	    if (!this.getter) {
	      this.getter = noop;
	    }
	  }
	  this.value = this.lazy
	    ? undefined
	    : this.get();
	};

	/**
	 * Evaluate the getter, and re-collect dependencies.
	 */
	Watcher.prototype.get = function get () {
	  pushTarget(this);
	  var value;
	  var vm = this.vm;
	  try {
	    value = this.getter.call(vm, vm);
	  } catch (e) {
	    if (this.user) {
	      handleError(e, vm, ("getter for watcher \"" + (this.expression) + "\""));
	    } else {
	      throw e
	    }
	  } finally {
	    // "touch" every property so they are all tracked as
	    // dependencies for deep watching
	    if (this.deep) {
	      traverse(value);
	    }
	    popTarget();
	    this.cleanupDeps();
	  }
	  return value
	};

	/**
	 * Add a dependency to this directive.
	 */
	Watcher.prototype.addDep = function addDep (dep) {
	  var id = dep.id;
	  if (!this.newDepIds.has(id)) {
	    this.newDepIds.add(id);
	    this.newDeps.push(dep);
	    if (!this.depIds.has(id)) {
	      dep.addSub(this);
	    }
	  }
	};

	/**
	 * Clean up for dependency collection.
	 */
	Watcher.prototype.cleanupDeps = function cleanupDeps () {
	  var this$1 = this;

	  var i = this.deps.length;
	  while (i--) {
	    var dep = this$1.deps[i];
	    if (!this$1.newDepIds.has(dep.id)) {
	      dep.removeSub(this$1);
	    }
	  }
	  var tmp = this.depIds;
	  this.depIds = this.newDepIds;
	  this.newDepIds = tmp;
	  this.newDepIds.clear();
	  tmp = this.deps;
	  this.deps = this.newDeps;
	  this.newDeps = tmp;
	  this.newDeps.length = 0;
	};

	/**
	 * Subscriber interface.
	 * Will be called when a dependency changes.
	 */
	Watcher.prototype.update = function update () {
	  /* istanbul ignore else */
	  if (this.lazy) {
	    this.dirty = true;
	  } else if (this.sync) {
	    this.run();
	  } else {
	    queueWatcher(this);
	  }
	};

	/**
	 * Scheduler job interface.
	 * Will be called by the scheduler.
	 */
	Watcher.prototype.run = function run () {
	  if (this.active) {
	    var value = this.get();
	    if (
	      value !== this.value ||
	      // Deep watchers and watchers on Object/Arrays should fire even
	      // when the value is the same, because the value may
	      // have mutated.
	      isObject(value) ||
	      this.deep
	    ) {
	      // set new value
	      var oldValue = this.value;
	      this.value = value;
	      if (this.user) {
	        var info = "callback for watcher \"" + (this.expression) + "\"";
	        invokeWithErrorHandling(this.cb, this.vm, [value, oldValue], this.vm, info);
	      } else {
	        this.cb.call(this.vm, value, oldValue);
	      }
	    }
	  }
	};

	/**
	 * Evaluate the value of the watcher.
	 * This only gets called for lazy watchers.
	 */
	Watcher.prototype.evaluate = function evaluate () {
	  this.value = this.get();
	  this.dirty = false;
	};

	/**
	 * Depend on all deps collected by this watcher.
	 */
	Watcher.prototype.depend = function depend () {
	  var this$1 = this;

	  var i = this.deps.length;
	  while (i--) {
	    this$1.deps[i].depend();
	  }
	};

	/**
	 * Remove self from all dependencies' subscriber list.
	 */
	Watcher.prototype.teardown = function teardown () {
	  var this$1 = this;

	  if (this.active) {
	    // remove self from vm's watcher list
	    // this is a somewhat expensive operation so we skip it
	    // if the vm is being destroyed.
	    if (!this.vm._isBeingDestroyed) {
	      remove(this.vm._watchers, this);
	    }
	    var i = this.deps.length;
	    while (i--) {
	      this$1.deps[i].removeSub(this$1);
	    }
	    this.active = false;
	  }
	};

	/*  */

	var sharedPropertyDefinition = {
	  enumerable: true,
	  configurable: true,
	  get: noop,
	  set: noop
	};

	function proxy (target, sourceKey, key) {
	  sharedPropertyDefinition.get = function proxyGetter () {
	    return this[sourceKey][key]
	  };
	  sharedPropertyDefinition.set = function proxySetter (val) {
	    this[sourceKey][key] = val;
	  };
	  Object.defineProperty(target, key, sharedPropertyDefinition);
	}

	function initState (vm) {
	  vm._watchers = [];
	  var opts = vm.$options;
	  if (opts.props) { initProps(vm, opts.props); }
	  if (opts.methods) { initMethods(vm, opts.methods); }
	  if (opts.data) {
	    initData(vm);
	  } else {
	    observe(vm._data = {}, true /* asRootData */);
	  }
	  if (opts.computed) { initComputed(vm, opts.computed); }
	  if (opts.watch && opts.watch !== nativeWatch) {
	    initWatch(vm, opts.watch);
	  }
	}

	function initProps (vm, propsOptions) {
	  var propsData = vm.$options.propsData || {};
	  var props = vm._props = {};
	  // cache prop keys so that future props updates can iterate using Array
	  // instead of dynamic object key enumeration.
	  var keys = vm.$options._propKeys = [];
	  var isRoot = !vm.$parent;
	  // root instance props should be converted
	  if (!isRoot) {
	    toggleObserving(false);
	  }
	  var loop = function ( key ) {
	    keys.push(key);
	    var value = validateProp(key, propsOptions, propsData, vm);
	    /* istanbul ignore else */
	    {
	      defineReactive$$1(props, key, value);
	    }
	    // static props are already proxied on the component's prototype
	    // during Vue.extend(). We only need to proxy props defined at
	    // instantiation here.
	    if (!(key in vm)) {
	      proxy(vm, "_props", key);
	    }
	  };

	  for (var key in propsOptions) { loop( key ); }
	  toggleObserving(true);
	}

	function initData (vm) {
	  var data = vm.$options.data;
	  data = vm._data = typeof data === 'function'
	    ? getData(data, vm)
	    : data || {};
	  if (!isPlainObject(data)) {
	    data = {};
	  }
	  // proxy data on instance
	  var keys = Object.keys(data);
	  var props = vm.$options.props;
	  var methods = vm.$options.methods;
	  var i = keys.length;
	  while (i--) {
	    var key = keys[i];
	    if (props && hasOwn(props, key)) ; else if (!isReserved(key)) {
	      proxy(vm, "_data", key);
	    }
	  }
	  // observe data
	  observe(data, true /* asRootData */);
	}

	function getData (data, vm) {
	  // #7573 disable dep collection when invoking data getters
	  pushTarget();
	  try {
	    return data.call(vm, vm)
	  } catch (e) {
	    handleError(e, vm, "data()");
	    return {}
	  } finally {
	    popTarget();
	  }
	}

	var computedWatcherOptions = { lazy: true };

	function initComputed (vm, computed) {
	  // $flow-disable-line
	  var watchers = vm._computedWatchers = Object.create(null);
	  // computed properties are just getters during SSR
	  var isSSR = isServerRendering();

	  for (var key in computed) {
	    var userDef = computed[key];
	    var getter = typeof userDef === 'function' ? userDef : userDef.get;

	    if (!isSSR) {
	      // create internal watcher for the computed property.
	      watchers[key] = new Watcher(
	        vm,
	        getter || noop,
	        noop,
	        computedWatcherOptions
	      );
	    }

	    // component-defined computed properties are already defined on the
	    // component prototype. We only need to define computed properties defined
	    // at instantiation here.
	    if (!(key in vm)) {
	      defineComputed(vm, key, userDef);
	    }
	  }
	}

	function defineComputed (
	  target,
	  key,
	  userDef
	) {
	  var shouldCache = !isServerRendering();
	  if (typeof userDef === 'function') {
	    sharedPropertyDefinition.get = shouldCache
	      ? createComputedGetter(key)
	      : createGetterInvoker(userDef);
	    sharedPropertyDefinition.set = noop;
	  } else {
	    sharedPropertyDefinition.get = userDef.get
	      ? shouldCache && userDef.cache !== false
	        ? createComputedGetter(key)
	        : createGetterInvoker(userDef.get)
	      : noop;
	    sharedPropertyDefinition.set = userDef.set || noop;
	  }
	  Object.defineProperty(target, key, sharedPropertyDefinition);
	}

	function createComputedGetter (key) {
	  return function computedGetter () {
	    var watcher = this._computedWatchers && this._computedWatchers[key];
	    if (watcher) {
	      if (watcher.dirty) {
	        watcher.evaluate();
	      }
	      if (Dep.target) {
	        watcher.depend();
	      }
	      return watcher.value
	    }
	  }
	}

	function createGetterInvoker(fn) {
	  return function computedGetter () {
	    return fn.call(this, this)
	  }
	}

	function initMethods (vm, methods) {
	  var props = vm.$options.props;
	  for (var key in methods) {
	    vm[key] = typeof methods[key] !== 'function' ? noop : bind(methods[key], vm);
	  }
	}

	function initWatch (vm, watch) {
	  for (var key in watch) {
	    var handler = watch[key];
	    if (Array.isArray(handler)) {
	      for (var i = 0; i < handler.length; i++) {
	        createWatcher(vm, key, handler[i]);
	      }
	    } else {
	      createWatcher(vm, key, handler);
	    }
	  }
	}

	function createWatcher (
	  vm,
	  expOrFn,
	  handler,
	  options
	) {
	  if (isPlainObject(handler)) {
	    options = handler;
	    handler = handler.handler;
	  }
	  if (typeof handler === 'string') {
	    handler = vm[handler];
	  }
	  return vm.$watch(expOrFn, handler, options)
	}

	function stateMixin (Vue) {
	  // flow somehow has problems with directly declared definition object
	  // when using Object.defineProperty, so we have to procedurally build up
	  // the object here.
	  var dataDef = {};
	  dataDef.get = function () { return this._data };
	  var propsDef = {};
	  propsDef.get = function () { return this._props };
	  Object.defineProperty(Vue.prototype, '$data', dataDef);
	  Object.defineProperty(Vue.prototype, '$props', propsDef);

	  Vue.prototype.$set = set;
	  Vue.prototype.$delete = del;

	  Vue.prototype.$watch = function (
	    expOrFn,
	    cb,
	    options
	  ) {
	    var vm = this;
	    if (isPlainObject(cb)) {
	      return createWatcher(vm, expOrFn, cb, options)
	    }
	    options = options || {};
	    options.user = true;
	    var watcher = new Watcher(vm, expOrFn, cb, options);
	    if (options.immediate) {
	      var info = "callback for immediate watcher \"" + (watcher.expression) + "\"";
	      pushTarget();
	      invokeWithErrorHandling(cb, vm, [watcher.value], vm, info);
	      popTarget();
	    }
	    return function unwatchFn () {
	      watcher.teardown();
	    }
	  };
	}

	/*  */

	var uid$3 = 0;

	function initMixin (Vue) {
	  Vue.prototype._init = function (options) {
	    var vm = this;
	    // a uid
	    vm._uid = uid$3++;

	    // a flag to avoid this being observed
	    vm._isVue = true;
	    // merge options
	    if (options && options._isComponent) {
	      // optimize internal component instantiation
	      // since dynamic options merging is pretty slow, and none of the
	      // internal component options needs special treatment.
	      initInternalComponent(vm, options);
	    } else {
	      vm.$options = mergeOptions(
	        resolveConstructorOptions(vm.constructor),
	        options || {},
	        vm
	      );
	    }
	    /* istanbul ignore else */
	    {
	      vm._renderProxy = vm;
	    }
	    // expose real self
	    vm._self = vm;
	    initLifecycle(vm);
	    initEvents(vm);
	    initRender(vm);
	    callHook(vm, 'beforeCreate');
	    initInjections(vm); // resolve injections before data/props
	    initState(vm);
	    initProvide(vm); // resolve provide after data/props
	    callHook(vm, 'created');

	    if (vm.$options.el) {
	      vm.$mount(vm.$options.el);
	    }
	  };
	}

	function initInternalComponent (vm, options) {
	  var opts = vm.$options = Object.create(vm.constructor.options);
	  // doing this because it's faster than dynamic enumeration.
	  var parentVnode = options._parentVnode;
	  opts.parent = options.parent;
	  opts._parentVnode = parentVnode;

	  var vnodeComponentOptions = parentVnode.componentOptions;
	  opts.propsData = vnodeComponentOptions.propsData;
	  opts._parentListeners = vnodeComponentOptions.listeners;
	  opts._renderChildren = vnodeComponentOptions.children;
	  opts._componentTag = vnodeComponentOptions.tag;

	  if (options.render) {
	    opts.render = options.render;
	    opts.staticRenderFns = options.staticRenderFns;
	  }
	}

	function resolveConstructorOptions (Ctor) {
	  var options = Ctor.options;
	  if (Ctor.super) {
	    var superOptions = resolveConstructorOptions(Ctor.super);
	    var cachedSuperOptions = Ctor.superOptions;
	    if (superOptions !== cachedSuperOptions) {
	      // super option changed,
	      // need to resolve new options.
	      Ctor.superOptions = superOptions;
	      // check if there are any late-modified/attached options (#4976)
	      var modifiedOptions = resolveModifiedOptions(Ctor);
	      // update base extend options
	      if (modifiedOptions) {
	        extend(Ctor.extendOptions, modifiedOptions);
	      }
	      options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
	      if (options.name) {
	        options.components[options.name] = Ctor;
	      }
	    }
	  }
	  return options
	}

	function resolveModifiedOptions (Ctor) {
	  var modified;
	  var latest = Ctor.options;
	  var sealed = Ctor.sealedOptions;
	  for (var key in latest) {
	    if (latest[key] !== sealed[key]) {
	      if (!modified) { modified = {}; }
	      modified[key] = latest[key];
	    }
	  }
	  return modified
	}

	function Vue (options) {
	  this._init(options);
	}

	initMixin(Vue);
	stateMixin(Vue);
	eventsMixin(Vue);
	lifecycleMixin(Vue);
	renderMixin(Vue);

	/*  */

	function initUse (Vue) {
	  Vue.use = function (plugin) {
	    var installedPlugins = (this._installedPlugins || (this._installedPlugins = []));
	    if (installedPlugins.indexOf(plugin) > -1) {
	      return this
	    }

	    // additional parameters
	    var args = toArray(arguments, 1);
	    args.unshift(this);
	    if (typeof plugin.install === 'function') {
	      plugin.install.apply(plugin, args);
	    } else if (typeof plugin === 'function') {
	      plugin.apply(null, args);
	    }
	    installedPlugins.push(plugin);
	    return this
	  };
	}

	/*  */

	function initMixin$1 (Vue) {
	  Vue.mixin = function (mixin) {
	    this.options = mergeOptions(this.options, mixin);
	    return this
	  };
	}

	/*  */

	function initExtend (Vue) {
	  /**
	   * Each instance constructor, including Vue, has a unique
	   * cid. This enables us to create wrapped "child
	   * constructors" for prototypal inheritance and cache them.
	   */
	  Vue.cid = 0;
	  var cid = 1;

	  /**
	   * Class inheritance
	   */
	  Vue.extend = function (extendOptions) {
	    extendOptions = extendOptions || {};
	    var Super = this;
	    var SuperId = Super.cid;
	    var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
	    if (cachedCtors[SuperId]) {
	      return cachedCtors[SuperId]
	    }

	    var name = extendOptions.name || Super.options.name;

	    var Sub = function VueComponent (options) {
	      this._init(options);
	    };
	    Sub.prototype = Object.create(Super.prototype);
	    Sub.prototype.constructor = Sub;
	    Sub.cid = cid++;
	    Sub.options = mergeOptions(
	      Super.options,
	      extendOptions
	    );
	    Sub['super'] = Super;

	    // For props and computed properties, we define the proxy getters on
	    // the Vue instances at extension time, on the extended prototype. This
	    // avoids Object.defineProperty calls for each instance created.
	    if (Sub.options.props) {
	      initProps$1(Sub);
	    }
	    if (Sub.options.computed) {
	      initComputed$1(Sub);
	    }

	    // allow further extension/mixin/plugin usage
	    Sub.extend = Super.extend;
	    Sub.mixin = Super.mixin;
	    Sub.use = Super.use;

	    // create asset registers, so extended classes
	    // can have their private assets too.
	    ASSET_TYPES.forEach(function (type) {
	      Sub[type] = Super[type];
	    });
	    // enable recursive self-lookup
	    if (name) {
	      Sub.options.components[name] = Sub;
	    }

	    // keep a reference to the super options at extension time.
	    // later at instantiation we can check if Super's options have
	    // been updated.
	    Sub.superOptions = Super.options;
	    Sub.extendOptions = extendOptions;
	    Sub.sealedOptions = extend({}, Sub.options);

	    // cache constructor
	    cachedCtors[SuperId] = Sub;
	    return Sub
	  };
	}

	function initProps$1 (Comp) {
	  var props = Comp.options.props;
	  for (var key in props) {
	    proxy(Comp.prototype, "_props", key);
	  }
	}

	function initComputed$1 (Comp) {
	  var computed = Comp.options.computed;
	  for (var key in computed) {
	    defineComputed(Comp.prototype, key, computed[key]);
	  }
	}

	/*  */

	function initAssetRegisters (Vue) {
	  /**
	   * Create asset registration methods.
	   */
	  ASSET_TYPES.forEach(function (type) {
	    Vue[type] = function (
	      id,
	      definition
	    ) {
	      if (!definition) {
	        return this.options[type + 's'][id]
	      } else {
	        if (type === 'component' && isPlainObject(definition)) {
	          definition.name = definition.name || id;
	          definition = this.options._base.extend(definition);
	        }
	        if (type === 'directive' && typeof definition === 'function') {
	          definition = { bind: definition, update: definition };
	        }
	        this.options[type + 's'][id] = definition;
	        return definition
	      }
	    };
	  });
	}

	/*  */





	function getComponentName (opts) {
	  return opts && (opts.Ctor.options.name || opts.tag)
	}

	function matches (pattern, name) {
	  if (Array.isArray(pattern)) {
	    return pattern.indexOf(name) > -1
	  } else if (typeof pattern === 'string') {
	    return pattern.split(',').indexOf(name) > -1
	  } else if (isRegExp(pattern)) {
	    return pattern.test(name)
	  }
	  /* istanbul ignore next */
	  return false
	}

	function pruneCache (keepAliveInstance, filter) {
	  var cache = keepAliveInstance.cache;
	  var keys = keepAliveInstance.keys;
	  var _vnode = keepAliveInstance._vnode;
	  for (var key in cache) {
	    var entry = cache[key];
	    if (entry) {
	      var name = entry.name;
	      if (name && !filter(name)) {
	        pruneCacheEntry(cache, key, keys, _vnode);
	      }
	    }
	  }
	}

	function pruneCacheEntry (
	  cache,
	  key,
	  keys,
	  current
	) {
	  var entry = cache[key];
	  if (entry && (!current || entry.tag !== current.tag)) {
	    entry.componentInstance.$destroy();
	  }
	  cache[key] = null;
	  remove(keys, key);
	}

	var patternTypes = [String, RegExp, Array];

	var KeepAlive = {
	  name: 'keep-alive',
	  abstract: true,

	  props: {
	    include: patternTypes,
	    exclude: patternTypes,
	    max: [String, Number]
	  },

	  methods: {
	    cacheVNode: function cacheVNode() {
	      var ref = this;
	      var cache = ref.cache;
	      var keys = ref.keys;
	      var vnodeToCache = ref.vnodeToCache;
	      var keyToCache = ref.keyToCache;
	      if (vnodeToCache) {
	        var tag = vnodeToCache.tag;
	        var componentInstance = vnodeToCache.componentInstance;
	        var componentOptions = vnodeToCache.componentOptions;
	        cache[keyToCache] = {
	          name: getComponentName(componentOptions),
	          tag: tag,
	          componentInstance: componentInstance,
	        };
	        keys.push(keyToCache);
	        // prune oldest entry
	        if (this.max && keys.length > parseInt(this.max)) {
	          pruneCacheEntry(cache, keys[0], keys, this._vnode);
	        }
	        this.vnodeToCache = null;
	      }
	    }
	  },

	  created: function created () {
	    this.cache = Object.create(null);
	    this.keys = [];
	  },

	  destroyed: function destroyed () {
	    var this$1 = this;

	    for (var key in this$1.cache) {
	      pruneCacheEntry(this$1.cache, key, this$1.keys);
	    }
	  },

	  mounted: function mounted () {
	    var this$1 = this;

	    this.cacheVNode();
	    this.$watch('include', function (val) {
	      pruneCache(this$1, function (name) { return matches(val, name); });
	    });
	    this.$watch('exclude', function (val) {
	      pruneCache(this$1, function (name) { return !matches(val, name); });
	    });
	  },

	  updated: function updated () {
	    this.cacheVNode();
	  },

	  render: function render () {
	    var slot = this.$slots.default;
	    var vnode = getFirstComponentChild(slot);
	    var componentOptions = vnode && vnode.componentOptions;
	    if (componentOptions) {
	      // check pattern
	      var name = getComponentName(componentOptions);
	      var ref = this;
	      var include = ref.include;
	      var exclude = ref.exclude;
	      if (
	        // not included
	        (include && (!name || !matches(include, name))) ||
	        // excluded
	        (exclude && name && matches(exclude, name))
	      ) {
	        return vnode
	      }

	      var ref$1 = this;
	      var cache = ref$1.cache;
	      var keys = ref$1.keys;
	      var key = vnode.key == null
	        // same constructor may get registered as different local components
	        // so cid alone is not enough (#3269)
	        ? componentOptions.Ctor.cid + (componentOptions.tag ? ("::" + (componentOptions.tag)) : '')
	        : vnode.key;
	      if (cache[key]) {
	        vnode.componentInstance = cache[key].componentInstance;
	        // make current key freshest
	        remove(keys, key);
	        keys.push(key);
	      } else {
	        // delay setting the cache until update
	        this.vnodeToCache = vnode;
	        this.keyToCache = key;
	      }

	      vnode.data.keepAlive = true;
	    }
	    return vnode || (slot && slot[0])
	  }
	};

	var builtInComponents = {
	  KeepAlive: KeepAlive
	};

	/*  */

	function initGlobalAPI (Vue) {
	  // config
	  var configDef = {};
	  configDef.get = function () { return config; };
	  Object.defineProperty(Vue, 'config', configDef);

	  // exposed util methods.
	  // NOTE: these are not considered part of the public API - avoid relying on
	  // them unless you are aware of the risk.
	  Vue.util = {
	    warn: warn,
	    extend: extend,
	    mergeOptions: mergeOptions,
	    defineReactive: defineReactive$$1
	  };

	  Vue.set = set;
	  Vue.delete = del;
	  Vue.nextTick = nextTick;

	  // 2.6 explicit observable API
	  Vue.observable = function (obj) {
	    observe(obj);
	    return obj
	  };

	  Vue.options = Object.create(null);
	  ASSET_TYPES.forEach(function (type) {
	    Vue.options[type + 's'] = Object.create(null);
	  });

	  // this is used to identify the "base" constructor to extend all plain-object
	  // components with in Weex's multi-instance scenarios.
	  Vue.options._base = Vue;

	  extend(Vue.options.components, builtInComponents);

	  initUse(Vue);
	  initMixin$1(Vue);
	  initExtend(Vue);
	  initAssetRegisters(Vue);
	}

	initGlobalAPI(Vue);

	Object.defineProperty(Vue.prototype, '$isServer', {
	  get: isServerRendering
	});

	Object.defineProperty(Vue.prototype, '$ssrContext', {
	  get: function get () {
	    /* istanbul ignore next */
	    return this.$vnode && this.$vnode.ssrContext
	  }
	});

	// expose FunctionalRenderContext for ssr runtime helper installation
	Object.defineProperty(Vue, 'FunctionalRenderContext', {
	  value: FunctionalRenderContext
	});

	Vue.version = '2.6.13';

	/*  */

	// these are reserved for web because they are directly compiled away
	// during template compilation
	var isReservedAttr = makeMap('style,class');

	// attributes that should be using props for binding
	var acceptValue = makeMap('input,textarea,option,select,progress');
	var mustUseProp = function (tag, type, attr) {
	  return (
	    (attr === 'value' && acceptValue(tag)) && type !== 'button' ||
	    (attr === 'selected' && tag === 'option') ||
	    (attr === 'checked' && tag === 'input') ||
	    (attr === 'muted' && tag === 'video')
	  )
	};

	var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');

	var isValidContentEditableValue = makeMap('events,caret,typing,plaintext-only');

	var convertEnumeratedValue = function (key, value) {
	  return isFalsyAttrValue(value) || value === 'false'
	    ? 'false'
	    // allow arbitrary string value for contenteditable
	    : key === 'contenteditable' && isValidContentEditableValue(value)
	      ? value
	      : 'true'
	};

	var isBooleanAttr = makeMap(
	  'allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
	  'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
	  'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
	  'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
	  'required,reversed,scoped,seamless,selected,sortable,' +
	  'truespeed,typemustmatch,visible'
	);

	var xlinkNS = 'http://www.w3.org/1999/xlink';

	var isXlink = function (name) {
	  return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink'
	};

	var getXlinkProp = function (name) {
	  return isXlink(name) ? name.slice(6, name.length) : ''
	};

	var isFalsyAttrValue = function (val) {
	  return val == null || val === false
	};

	/*  */

	function genClassForVnode (vnode) {
	  var data = vnode.data;
	  var parentNode = vnode;
	  var childNode = vnode;
	  while (isDef(childNode.componentInstance)) {
	    childNode = childNode.componentInstance._vnode;
	    if (childNode && childNode.data) {
	      data = mergeClassData(childNode.data, data);
	    }
	  }
	  while (isDef(parentNode = parentNode.parent)) {
	    if (parentNode && parentNode.data) {
	      data = mergeClassData(data, parentNode.data);
	    }
	  }
	  return renderClass(data.staticClass, data.class)
	}

	function mergeClassData (child, parent) {
	  return {
	    staticClass: concat(child.staticClass, parent.staticClass),
	    class: isDef(child.class)
	      ? [child.class, parent.class]
	      : parent.class
	  }
	}

	function renderClass (
	  staticClass,
	  dynamicClass
	) {
	  if (isDef(staticClass) || isDef(dynamicClass)) {
	    return concat(staticClass, stringifyClass(dynamicClass))
	  }
	  /* istanbul ignore next */
	  return ''
	}

	function concat (a, b) {
	  return a ? b ? (a + ' ' + b) : a : (b || '')
	}

	function stringifyClass (value) {
	  if (Array.isArray(value)) {
	    return stringifyArray(value)
	  }
	  if (isObject(value)) {
	    return stringifyObject(value)
	  }
	  if (typeof value === 'string') {
	    return value
	  }
	  /* istanbul ignore next */
	  return ''
	}

	function stringifyArray (value) {
	  var res = '';
	  var stringified;
	  for (var i = 0, l = value.length; i < l; i++) {
	    if (isDef(stringified = stringifyClass(value[i])) && stringified !== '') {
	      if (res) { res += ' '; }
	      res += stringified;
	    }
	  }
	  return res
	}

	function stringifyObject (value) {
	  var res = '';
	  for (var key in value) {
	    if (value[key]) {
	      if (res) { res += ' '; }
	      res += key;
	    }
	  }
	  return res
	}

	/*  */

	var namespaceMap = {
	  svg: 'http://www.w3.org/2000/svg',
	  math: 'http://www.w3.org/1998/Math/MathML'
	};

	var isHTMLTag = makeMap(
	  'html,body,base,head,link,meta,style,title,' +
	  'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
	  'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' +
	  'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
	  's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
	  'embed,object,param,source,canvas,script,noscript,del,ins,' +
	  'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
	  'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
	  'output,progress,select,textarea,' +
	  'details,dialog,menu,menuitem,summary,' +
	  'content,element,shadow,template,blockquote,iframe,tfoot'
	);

	// this map is intentionally selective, only covering SVG elements that may
	// contain child elements.
	var isSVG = makeMap(
	  'svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
	  'foreignobject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
	  'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view',
	  true
	);

	var isReservedTag = function (tag) {
	  return isHTMLTag(tag) || isSVG(tag)
	};

	function getTagNamespace (tag) {
	  if (isSVG(tag)) {
	    return 'svg'
	  }
	  // basic support for MathML
	  // note it doesn't support other MathML elements being component roots
	  if (tag === 'math') {
	    return 'math'
	  }
	}

	var unknownElementCache = Object.create(null);
	function isUnknownElement (tag) {
	  /* istanbul ignore if */
	  if (!inBrowser) {
	    return true
	  }
	  if (isReservedTag(tag)) {
	    return false
	  }
	  tag = tag.toLowerCase();
	  /* istanbul ignore if */
	  if (unknownElementCache[tag] != null) {
	    return unknownElementCache[tag]
	  }
	  var el = document.createElement(tag);
	  if (tag.indexOf('-') > -1) {
	    // http://stackoverflow.com/a/28210364/1070244
	    return (unknownElementCache[tag] = (
	      el.constructor === window.HTMLUnknownElement ||
	      el.constructor === window.HTMLElement
	    ))
	  } else {
	    return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()))
	  }
	}

	var isTextInputType = makeMap('text,number,password,search,email,tel,url');

	/*  */

	/**
	 * Query an element selector if it's not an element already.
	 */
	function query (el) {
	  if (typeof el === 'string') {
	    var selected = document.querySelector(el);
	    if (!selected) {
	      return document.createElement('div')
	    }
	    return selected
	  } else {
	    return el
	  }
	}

	/*  */

	function createElement$1 (tagName, vnode) {
	  var elm = document.createElement(tagName);
	  if (tagName !== 'select') {
	    return elm
	  }
	  // false or null will remove the attribute but undefined will not
	  if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) {
	    elm.setAttribute('multiple', 'multiple');
	  }
	  return elm
	}

	function createElementNS (namespace, tagName) {
	  return document.createElementNS(namespaceMap[namespace], tagName)
	}

	function createTextNode (text) {
	  return document.createTextNode(text)
	}

	function createComment (text) {
	  return document.createComment(text)
	}

	function insertBefore (parentNode, newNode, referenceNode) {
	  parentNode.insertBefore(newNode, referenceNode);
	}

	function removeChild (node, child) {
	  node.removeChild(child);
	}

	function appendChild (node, child) {
	  node.appendChild(child);
	}

	function parentNode (node) {
	  return node.parentNode
	}

	function nextSibling (node) {
	  return node.nextSibling
	}

	function tagName (node) {
	  return node.tagName
	}

	function setTextContent (node, text) {
	  node.textContent = text;
	}

	function setStyleScope (node, scopeId) {
	  node.setAttribute(scopeId, '');
	}

	var nodeOps = /*#__PURE__*/Object.freeze({
	  createElement: createElement$1,
	  createElementNS: createElementNS,
	  createTextNode: createTextNode,
	  createComment: createComment,
	  insertBefore: insertBefore,
	  removeChild: removeChild,
	  appendChild: appendChild,
	  parentNode: parentNode,
	  nextSibling: nextSibling,
	  tagName: tagName,
	  setTextContent: setTextContent,
	  setStyleScope: setStyleScope
	});

	/*  */

	var ref = {
	  create: function create (_, vnode) {
	    registerRef(vnode);
	  },
	  update: function update (oldVnode, vnode) {
	    if (oldVnode.data.ref !== vnode.data.ref) {
	      registerRef(oldVnode, true);
	      registerRef(vnode);
	    }
	  },
	  destroy: function destroy (vnode) {
	    registerRef(vnode, true);
	  }
	};

	function registerRef (vnode, isRemoval) {
	  var key = vnode.data.ref;
	  if (!isDef(key)) { return }

	  var vm = vnode.context;
	  var ref = vnode.componentInstance || vnode.elm;
	  var refs = vm.$refs;
	  if (isRemoval) {
	    if (Array.isArray(refs[key])) {
	      remove(refs[key], ref);
	    } else if (refs[key] === ref) {
	      refs[key] = undefined;
	    }
	  } else {
	    if (vnode.data.refInFor) {
	      if (!Array.isArray(refs[key])) {
	        refs[key] = [ref];
	      } else if (refs[key].indexOf(ref) < 0) {
	        // $flow-disable-line
	        refs[key].push(ref);
	      }
	    } else {
	      refs[key] = ref;
	    }
	  }
	}

	/**
	 * Virtual DOM patching algorithm based on Snabbdom by
	 * Simon Friis Vindum (@paldepind)
	 * Licensed under the MIT License
	 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
	 *
	 * modified by Evan You (@yyx990803)
	 *
	 * Not type-checking this because this file is perf-critical and the cost
	 * of making flow understand it is not worth it.
	 */

	var emptyNode = new VNode('', {}, []);

	var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];

	function sameVnode (a, b) {
	  return (
	    a.key === b.key &&
	    a.asyncFactory === b.asyncFactory && (
	      (
	        a.tag === b.tag &&
	        a.isComment === b.isComment &&
	        isDef(a.data) === isDef(b.data) &&
	        sameInputType(a, b)
	      ) || (
	        isTrue(a.isAsyncPlaceholder) &&
	        isUndef(b.asyncFactory.error)
	      )
	    )
	  )
	}

	function sameInputType (a, b) {
	  if (a.tag !== 'input') { return true }
	  var i;
	  var typeA = isDef(i = a.data) && isDef(i = i.attrs) && i.type;
	  var typeB = isDef(i = b.data) && isDef(i = i.attrs) && i.type;
	  return typeA === typeB || isTextInputType(typeA) && isTextInputType(typeB)
	}

	function createKeyToOldIdx (children, beginIdx, endIdx) {
	  var i, key;
	  var map = {};
	  for (i = beginIdx; i <= endIdx; ++i) {
	    key = children[i].key;
	    if (isDef(key)) { map[key] = i; }
	  }
	  return map
	}

	function createPatchFunction (backend) {
	  var i, j;
	  var cbs = {};

	  var modules = backend.modules;
	  var nodeOps = backend.nodeOps;

	  for (i = 0; i < hooks.length; ++i) {
	    cbs[hooks[i]] = [];
	    for (j = 0; j < modules.length; ++j) {
	      if (isDef(modules[j][hooks[i]])) {
	        cbs[hooks[i]].push(modules[j][hooks[i]]);
	      }
	    }
	  }

	  function emptyNodeAt (elm) {
	    return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm)
	  }

	  function createRmCb (childElm, listeners) {
	    function remove$$1 () {
	      if (--remove$$1.listeners === 0) {
	        removeNode(childElm);
	      }
	    }
	    remove$$1.listeners = listeners;
	    return remove$$1
	  }

	  function removeNode (el) {
	    var parent = nodeOps.parentNode(el);
	    // element may have already been removed due to v-html / v-text
	    if (isDef(parent)) {
	      nodeOps.removeChild(parent, el);
	    }
	  }

	  function createElm (
	    vnode,
	    insertedVnodeQueue,
	    parentElm,
	    refElm,
	    nested,
	    ownerArray,
	    index
	  ) {
	    if (isDef(vnode.elm) && isDef(ownerArray)) {
	      // This vnode was used in a previous render!
	      // now it's used as a new node, overwriting its elm would cause
	      // potential patch errors down the road when it's used as an insertion
	      // reference node. Instead, we clone the node on-demand before creating
	      // associated DOM element for it.
	      vnode = ownerArray[index] = cloneVNode(vnode);
	    }

	    vnode.isRootInsert = !nested; // for transition enter check
	    if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
	      return
	    }

	    var data = vnode.data;
	    var children = vnode.children;
	    var tag = vnode.tag;
	    if (isDef(tag)) {

	      vnode.elm = vnode.ns
	        ? nodeOps.createElementNS(vnode.ns, tag)
	        : nodeOps.createElement(tag, vnode);
	      setScope(vnode);

	      /* istanbul ignore if */
	      {
	        createChildren(vnode, children, insertedVnodeQueue);
	        if (isDef(data)) {
	          invokeCreateHooks(vnode, insertedVnodeQueue);
	        }
	        insert(parentElm, vnode.elm, refElm);
	      }
	    } else if (isTrue(vnode.isComment)) {
	      vnode.elm = nodeOps.createComment(vnode.text);
	      insert(parentElm, vnode.elm, refElm);
	    } else {
	      vnode.elm = nodeOps.createTextNode(vnode.text);
	      insert(parentElm, vnode.elm, refElm);
	    }
	  }

	  function createComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
	    var i = vnode.data;
	    if (isDef(i)) {
	      var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
	      if (isDef(i = i.hook) && isDef(i = i.init)) {
	        i(vnode, false /* hydrating */);
	      }
	      // after calling the init hook, if the vnode is a child component
	      // it should've created a child instance and mounted it. the child
	      // component also has set the placeholder vnode's elm.
	      // in that case we can just return the element and be done.
	      if (isDef(vnode.componentInstance)) {
	        initComponent(vnode, insertedVnodeQueue);
	        insert(parentElm, vnode.elm, refElm);
	        if (isTrue(isReactivated)) {
	          reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
	        }
	        return true
	      }
	    }
	  }

	  function initComponent (vnode, insertedVnodeQueue) {
	    if (isDef(vnode.data.pendingInsert)) {
	      insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
	      vnode.data.pendingInsert = null;
	    }
	    vnode.elm = vnode.componentInstance.$el;
	    if (isPatchable(vnode)) {
	      invokeCreateHooks(vnode, insertedVnodeQueue);
	      setScope(vnode);
	    } else {
	      // empty component root.
	      // skip all element-related modules except for ref (#3455)
	      registerRef(vnode);
	      // make sure to invoke the insert hook
	      insertedVnodeQueue.push(vnode);
	    }
	  }

	  function reactivateComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
	    var i;
	    // hack for #4339: a reactivated component with inner transition
	    // does not trigger because the inner node's created hooks are not called
	    // again. It's not ideal to involve module-specific logic in here but
	    // there doesn't seem to be a better way to do it.
	    var innerNode = vnode;
	    while (innerNode.componentInstance) {
	      innerNode = innerNode.componentInstance._vnode;
	      if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
	        for (i = 0; i < cbs.activate.length; ++i) {
	          cbs.activate[i](emptyNode, innerNode);
	        }
	        insertedVnodeQueue.push(innerNode);
	        break
	      }
	    }
	    // unlike a newly created component,
	    // a reactivated keep-alive component doesn't insert itself
	    insert(parentElm, vnode.elm, refElm);
	  }

	  function insert (parent, elm, ref$$1) {
	    if (isDef(parent)) {
	      if (isDef(ref$$1)) {
	        if (nodeOps.parentNode(ref$$1) === parent) {
	          nodeOps.insertBefore(parent, elm, ref$$1);
	        }
	      } else {
	        nodeOps.appendChild(parent, elm);
	      }
	    }
	  }

	  function createChildren (vnode, children, insertedVnodeQueue) {
	    if (Array.isArray(children)) {
	      for (var i = 0; i < children.length; ++i) {
	        createElm(children[i], insertedVnodeQueue, vnode.elm, null, true, children, i);
	      }
	    } else if (isPrimitive(vnode.text)) {
	      nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
	    }
	  }

	  function isPatchable (vnode) {
	    while (vnode.componentInstance) {
	      vnode = vnode.componentInstance._vnode;
	    }
	    return isDef(vnode.tag)
	  }

	  function invokeCreateHooks (vnode, insertedVnodeQueue) {
	    for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
	      cbs.create[i$1](emptyNode, vnode);
	    }
	    i = vnode.data.hook; // Reuse variable
	    if (isDef(i)) {
	      if (isDef(i.create)) { i.create(emptyNode, vnode); }
	      if (isDef(i.insert)) { insertedVnodeQueue.push(vnode); }
	    }
	  }

	  // set scope id attribute for scoped CSS.
	  // this is implemented as a special case to avoid the overhead
	  // of going through the normal attribute patching process.
	  function setScope (vnode) {
	    var i;
	    if (isDef(i = vnode.fnScopeId)) {
	      nodeOps.setStyleScope(vnode.elm, i);
	    } else {
	      var ancestor = vnode;
	      while (ancestor) {
	        if (isDef(i = ancestor.context) && isDef(i = i.$options._scopeId)) {
	          nodeOps.setStyleScope(vnode.elm, i);
	        }
	        ancestor = ancestor.parent;
	      }
	    }
	    // for slot content they should also get the scopeId from the host instance.
	    if (isDef(i = activeInstance) &&
	      i !== vnode.context &&
	      i !== vnode.fnContext &&
	      isDef(i = i.$options._scopeId)
	    ) {
	      nodeOps.setStyleScope(vnode.elm, i);
	    }
	  }

	  function addVnodes (parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
	    for (; startIdx <= endIdx; ++startIdx) {
	      createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm, false, vnodes, startIdx);
	    }
	  }

	  function invokeDestroyHook (vnode) {
	    var i, j;
	    var data = vnode.data;
	    if (isDef(data)) {
	      if (isDef(i = data.hook) && isDef(i = i.destroy)) { i(vnode); }
	      for (i = 0; i < cbs.destroy.length; ++i) { cbs.destroy[i](vnode); }
	    }
	    if (isDef(i = vnode.children)) {
	      for (j = 0; j < vnode.children.length; ++j) {
	        invokeDestroyHook(vnode.children[j]);
	      }
	    }
	  }

	  function removeVnodes (vnodes, startIdx, endIdx) {
	    for (; startIdx <= endIdx; ++startIdx) {
	      var ch = vnodes[startIdx];
	      if (isDef(ch)) {
	        if (isDef(ch.tag)) {
	          removeAndInvokeRemoveHook(ch);
	          invokeDestroyHook(ch);
	        } else { // Text node
	          removeNode(ch.elm);
	        }
	      }
	    }
	  }

	  function removeAndInvokeRemoveHook (vnode, rm) {
	    if (isDef(rm) || isDef(vnode.data)) {
	      var i;
	      var listeners = cbs.remove.length + 1;
	      if (isDef(rm)) {
	        // we have a recursively passed down rm callback
	        // increase the listeners count
	        rm.listeners += listeners;
	      } else {
	        // directly removing
	        rm = createRmCb(vnode.elm, listeners);
	      }
	      // recursively invoke hooks on child component root node
	      if (isDef(i = vnode.componentInstance) && isDef(i = i._vnode) && isDef(i.data)) {
	        removeAndInvokeRemoveHook(i, rm);
	      }
	      for (i = 0; i < cbs.remove.length; ++i) {
	        cbs.remove[i](vnode, rm);
	      }
	      if (isDef(i = vnode.data.hook) && isDef(i = i.remove)) {
	        i(vnode, rm);
	      } else {
	        rm();
	      }
	    } else {
	      removeNode(vnode.elm);
	    }
	  }

	  function updateChildren (parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
	    var oldStartIdx = 0;
	    var newStartIdx = 0;
	    var oldEndIdx = oldCh.length - 1;
	    var oldStartVnode = oldCh[0];
	    var oldEndVnode = oldCh[oldEndIdx];
	    var newEndIdx = newCh.length - 1;
	    var newStartVnode = newCh[0];
	    var newEndVnode = newCh[newEndIdx];
	    var oldKeyToIdx, idxInOld, vnodeToMove, refElm;

	    // removeOnly is a special flag used only by <transition-group>
	    // to ensure removed elements stay in correct relative positions
	    // during leaving transitions
	    var canMove = !removeOnly;

	    while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
	      if (isUndef(oldStartVnode)) {
	        oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
	      } else if (isUndef(oldEndVnode)) {
	        oldEndVnode = oldCh[--oldEndIdx];
	      } else if (sameVnode(oldStartVnode, newStartVnode)) {
	        patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
	        oldStartVnode = oldCh[++oldStartIdx];
	        newStartVnode = newCh[++newStartIdx];
	      } else if (sameVnode(oldEndVnode, newEndVnode)) {
	        patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
	        oldEndVnode = oldCh[--oldEndIdx];
	        newEndVnode = newCh[--newEndIdx];
	      } else if (sameVnode(oldStartVnode, newEndVnode)) { // Vnode moved right
	        patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
	        canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
	        oldStartVnode = oldCh[++oldStartIdx];
	        newEndVnode = newCh[--newEndIdx];
	      } else if (sameVnode(oldEndVnode, newStartVnode)) { // Vnode moved left
	        patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
	        canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
	        oldEndVnode = oldCh[--oldEndIdx];
	        newStartVnode = newCh[++newStartIdx];
	      } else {
	        if (isUndef(oldKeyToIdx)) { oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx); }
	        idxInOld = isDef(newStartVnode.key)
	          ? oldKeyToIdx[newStartVnode.key]
	          : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
	        if (isUndef(idxInOld)) { // New element
	          createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
	        } else {
	          vnodeToMove = oldCh[idxInOld];
	          if (sameVnode(vnodeToMove, newStartVnode)) {
	            patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
	            oldCh[idxInOld] = undefined;
	            canMove && nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
	          } else {
	            // same key but different element. treat as new element
	            createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
	          }
	        }
	        newStartVnode = newCh[++newStartIdx];
	      }
	    }
	    if (oldStartIdx > oldEndIdx) {
	      refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
	      addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
	    } else if (newStartIdx > newEndIdx) {
	      removeVnodes(oldCh, oldStartIdx, oldEndIdx);
	    }
	  }

	  function findIdxInOld (node, oldCh, start, end) {
	    for (var i = start; i < end; i++) {
	      var c = oldCh[i];
	      if (isDef(c) && sameVnode(node, c)) { return i }
	    }
	  }

	  function patchVnode (
	    oldVnode,
	    vnode,
	    insertedVnodeQueue,
	    ownerArray,
	    index,
	    removeOnly
	  ) {
	    if (oldVnode === vnode) {
	      return
	    }

	    if (isDef(vnode.elm) && isDef(ownerArray)) {
	      // clone reused vnode
	      vnode = ownerArray[index] = cloneVNode(vnode);
	    }

	    var elm = vnode.elm = oldVnode.elm;

	    if (isTrue(oldVnode.isAsyncPlaceholder)) {
	      if (isDef(vnode.asyncFactory.resolved)) {
	        hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
	      } else {
	        vnode.isAsyncPlaceholder = true;
	      }
	      return
	    }

	    // reuse element for static trees.
	    // note we only do this if the vnode is cloned -
	    // if the new node is not cloned it means the render functions have been
	    // reset by the hot-reload-api and we need to do a proper re-render.
	    if (isTrue(vnode.isStatic) &&
	      isTrue(oldVnode.isStatic) &&
	      vnode.key === oldVnode.key &&
	      (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))
	    ) {
	      vnode.componentInstance = oldVnode.componentInstance;
	      return
	    }

	    var i;
	    var data = vnode.data;
	    if (isDef(data) && isDef(i = data.hook) && isDef(i = i.prepatch)) {
	      i(oldVnode, vnode);
	    }

	    var oldCh = oldVnode.children;
	    var ch = vnode.children;
	    if (isDef(data) && isPatchable(vnode)) {
	      for (i = 0; i < cbs.update.length; ++i) { cbs.update[i](oldVnode, vnode); }
	      if (isDef(i = data.hook) && isDef(i = i.update)) { i(oldVnode, vnode); }
	    }
	    if (isUndef(vnode.text)) {
	      if (isDef(oldCh) && isDef(ch)) {
	        if (oldCh !== ch) { updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly); }
	      } else if (isDef(ch)) {
	        if (isDef(oldVnode.text)) { nodeOps.setTextContent(elm, ''); }
	        addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
	      } else if (isDef(oldCh)) {
	        removeVnodes(oldCh, 0, oldCh.length - 1);
	      } else if (isDef(oldVnode.text)) {
	        nodeOps.setTextContent(elm, '');
	      }
	    } else if (oldVnode.text !== vnode.text) {
	      nodeOps.setTextContent(elm, vnode.text);
	    }
	    if (isDef(data)) {
	      if (isDef(i = data.hook) && isDef(i = i.postpatch)) { i(oldVnode, vnode); }
	    }
	  }

	  function invokeInsertHook (vnode, queue, initial) {
	    // delay insert hooks for component root nodes, invoke them after the
	    // element is really inserted
	    if (isTrue(initial) && isDef(vnode.parent)) {
	      vnode.parent.data.pendingInsert = queue;
	    } else {
	      for (var i = 0; i < queue.length; ++i) {
	        queue[i].data.hook.insert(queue[i]);
	      }
	    }
	  }
	  // list of modules that can skip create hook during hydration because they
	  // are already rendered on the client or has no need for initialization
	  // Note: style is excluded because it relies on initial clone for future
	  // deep updates (#7063).
	  var isRenderedModule = makeMap('attrs,class,staticClass,staticStyle,key');

	  // Note: this is a browser-only function so we can assume elms are DOM nodes.
	  function hydrate (elm, vnode, insertedVnodeQueue, inVPre) {
	    var i;
	    var tag = vnode.tag;
	    var data = vnode.data;
	    var children = vnode.children;
	    inVPre = inVPre || (data && data.pre);
	    vnode.elm = elm;

	    if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
	      vnode.isAsyncPlaceholder = true;
	      return true
	    }
	    if (isDef(data)) {
	      if (isDef(i = data.hook) && isDef(i = i.init)) { i(vnode, true /* hydrating */); }
	      if (isDef(i = vnode.componentInstance)) {
	        // child component. it should have hydrated its own tree.
	        initComponent(vnode, insertedVnodeQueue);
	        return true
	      }
	    }
	    if (isDef(tag)) {
	      if (isDef(children)) {
	        // empty element, allow client to pick up and populate children
	        if (!elm.hasChildNodes()) {
	          createChildren(vnode, children, insertedVnodeQueue);
	        } else {
	          // v-html and domProps: innerHTML
	          if (isDef(i = data) && isDef(i = i.domProps) && isDef(i = i.innerHTML)) {
	            if (i !== elm.innerHTML) {
	              return false
	            }
	          } else {
	            // iterate and compare children lists
	            var childrenMatch = true;
	            var childNode = elm.firstChild;
	            for (var i$1 = 0; i$1 < children.length; i$1++) {
	              if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue, inVPre)) {
	                childrenMatch = false;
	                break
	              }
	              childNode = childNode.nextSibling;
	            }
	            // if childNode is not null, it means the actual childNodes list is
	            // longer than the virtual children list.
	            if (!childrenMatch || childNode) {
	              return false
	            }
	          }
	        }
	      }
	      if (isDef(data)) {
	        var fullInvoke = false;
	        for (var key in data) {
	          if (!isRenderedModule(key)) {
	            fullInvoke = true;
	            invokeCreateHooks(vnode, insertedVnodeQueue);
	            break
	          }
	        }
	        if (!fullInvoke && data['class']) {
	          // ensure collecting deps for deep class bindings for future updates
	          traverse(data['class']);
	        }
	      }
	    } else if (elm.data !== vnode.text) {
	      elm.data = vnode.text;
	    }
	    return true
	  }

	  return function patch (oldVnode, vnode, hydrating, removeOnly) {
	    if (isUndef(vnode)) {
	      if (isDef(oldVnode)) { invokeDestroyHook(oldVnode); }
	      return
	    }

	    var isInitialPatch = false;
	    var insertedVnodeQueue = [];

	    if (isUndef(oldVnode)) {
	      // empty mount (likely as component), create new root element
	      isInitialPatch = true;
	      createElm(vnode, insertedVnodeQueue);
	    } else {
	      var isRealElement = isDef(oldVnode.nodeType);
	      if (!isRealElement && sameVnode(oldVnode, vnode)) {
	        // patch existing root node
	        patchVnode(oldVnode, vnode, insertedVnodeQueue, null, null, removeOnly);
	      } else {
	        if (isRealElement) {
	          // mounting to a real element
	          // check if this is server-rendered content and if we can perform
	          // a successful hydration.
	          if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
	            oldVnode.removeAttribute(SSR_ATTR);
	            hydrating = true;
	          }
	          if (isTrue(hydrating)) {
	            if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
	              invokeInsertHook(vnode, insertedVnodeQueue, true);
	              return oldVnode
	            }
	          }
	          // either not server-rendered, or hydration failed.
	          // create an empty node and replace it
	          oldVnode = emptyNodeAt(oldVnode);
	        }

	        // replacing existing element
	        var oldElm = oldVnode.elm;
	        var parentElm = nodeOps.parentNode(oldElm);

	        // create new node
	        createElm(
	          vnode,
	          insertedVnodeQueue,
	          // extremely rare edge case: do not insert if old element is in a
	          // leaving transition. Only happens when combining transition +
	          // keep-alive + HOCs. (#4590)
	          oldElm._leaveCb ? null : parentElm,
	          nodeOps.nextSibling(oldElm)
	        );

	        // update parent placeholder node element, recursively
	        if (isDef(vnode.parent)) {
	          var ancestor = vnode.parent;
	          var patchable = isPatchable(vnode);
	          while (ancestor) {
	            for (var i = 0; i < cbs.destroy.length; ++i) {
	              cbs.destroy[i](ancestor);
	            }
	            ancestor.elm = vnode.elm;
	            if (patchable) {
	              for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
	                cbs.create[i$1](emptyNode, ancestor);
	              }
	              // #6513
	              // invoke insert hooks that may have been merged by create hooks.
	              // e.g. for directives that uses the "inserted" hook.
	              var insert = ancestor.data.hook.insert;
	              if (insert.merged) {
	                // start at index 1 to avoid re-invoking component mounted hook
	                for (var i$2 = 1; i$2 < insert.fns.length; i$2++) {
	                  insert.fns[i$2]();
	                }
	              }
	            } else {
	              registerRef(ancestor);
	            }
	            ancestor = ancestor.parent;
	          }
	        }

	        // destroy old node
	        if (isDef(parentElm)) {
	          removeVnodes([oldVnode], 0, 0);
	        } else if (isDef(oldVnode.tag)) {
	          invokeDestroyHook(oldVnode);
	        }
	      }
	    }

	    invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
	    return vnode.elm
	  }
	}

	/*  */

	var directives = {
	  create: updateDirectives,
	  update: updateDirectives,
	  destroy: function unbindDirectives (vnode) {
	    updateDirectives(vnode, emptyNode);
	  }
	};

	function updateDirectives (oldVnode, vnode) {
	  if (oldVnode.data.directives || vnode.data.directives) {
	    _update(oldVnode, vnode);
	  }
	}

	function _update (oldVnode, vnode) {
	  var isCreate = oldVnode === emptyNode;
	  var isDestroy = vnode === emptyNode;
	  var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
	  var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);

	  var dirsWithInsert = [];
	  var dirsWithPostpatch = [];

	  var key, oldDir, dir;
	  for (key in newDirs) {
	    oldDir = oldDirs[key];
	    dir = newDirs[key];
	    if (!oldDir) {
	      // new directive, bind
	      callHook$1(dir, 'bind', vnode, oldVnode);
	      if (dir.def && dir.def.inserted) {
	        dirsWithInsert.push(dir);
	      }
	    } else {
	      // existing directive, update
	      dir.oldValue = oldDir.value;
	      dir.oldArg = oldDir.arg;
	      callHook$1(dir, 'update', vnode, oldVnode);
	      if (dir.def && dir.def.componentUpdated) {
	        dirsWithPostpatch.push(dir);
	      }
	    }
	  }

	  if (dirsWithInsert.length) {
	    var callInsert = function () {
	      for (var i = 0; i < dirsWithInsert.length; i++) {
	        callHook$1(dirsWithInsert[i], 'inserted', vnode, oldVnode);
	      }
	    };
	    if (isCreate) {
	      mergeVNodeHook(vnode, 'insert', callInsert);
	    } else {
	      callInsert();
	    }
	  }

	  if (dirsWithPostpatch.length) {
	    mergeVNodeHook(vnode, 'postpatch', function () {
	      for (var i = 0; i < dirsWithPostpatch.length; i++) {
	        callHook$1(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
	      }
	    });
	  }

	  if (!isCreate) {
	    for (key in oldDirs) {
	      if (!newDirs[key]) {
	        // no longer present, unbind
	        callHook$1(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
	      }
	    }
	  }
	}

	var emptyModifiers = Object.create(null);

	function normalizeDirectives$1 (
	  dirs,
	  vm
	) {
	  var res = Object.create(null);
	  if (!dirs) {
	    // $flow-disable-line
	    return res
	  }
	  var i, dir;
	  for (i = 0; i < dirs.length; i++) {
	    dir = dirs[i];
	    if (!dir.modifiers) {
	      // $flow-disable-line
	      dir.modifiers = emptyModifiers;
	    }
	    res[getRawDirName(dir)] = dir;
	    dir.def = resolveAsset(vm.$options, 'directives', dir.name, true);
	  }
	  // $flow-disable-line
	  return res
	}

	function getRawDirName (dir) {
	  return dir.rawName || ((dir.name) + "." + (Object.keys(dir.modifiers || {}).join('.')))
	}

	function callHook$1 (dir, hook, vnode, oldVnode, isDestroy) {
	  var fn = dir.def && dir.def[hook];
	  if (fn) {
	    try {
	      fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
	    } catch (e) {
	      handleError(e, vnode.context, ("directive " + (dir.name) + " " + hook + " hook"));
	    }
	  }
	}

	var baseModules = [
	  ref,
	  directives
	];

	/*  */

	function updateAttrs (oldVnode, vnode) {
	  var opts = vnode.componentOptions;
	  if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
	    return
	  }
	  if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
	    return
	  }
	  var key, cur, old;
	  var elm = vnode.elm;
	  var oldAttrs = oldVnode.data.attrs || {};
	  var attrs = vnode.data.attrs || {};
	  // clone observed objects, as the user probably wants to mutate it
	  if (isDef(attrs.__ob__)) {
	    attrs = vnode.data.attrs = extend({}, attrs);
	  }

	  for (key in attrs) {
	    cur = attrs[key];
	    old = oldAttrs[key];
	    if (old !== cur) {
	      setAttr(elm, key, cur, vnode.data.pre);
	    }
	  }
	  // #4391: in IE9, setting type can reset value for input[type=radio]
	  // #6666: IE/Edge forces progress value down to 1 before setting a max
	  /* istanbul ignore if */
	  if ((isIE || isEdge) && attrs.value !== oldAttrs.value) {
	    setAttr(elm, 'value', attrs.value);
	  }
	  for (key in oldAttrs) {
	    if (isUndef(attrs[key])) {
	      if (isXlink(key)) {
	        elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
	      } else if (!isEnumeratedAttr(key)) {
	        elm.removeAttribute(key);
	      }
	    }
	  }
	}

	function setAttr (el, key, value, isInPre) {
	  if (isInPre || el.tagName.indexOf('-') > -1) {
	    baseSetAttr(el, key, value);
	  } else if (isBooleanAttr(key)) {
	    // set attribute for blank value
	    // e.g. <option disabled>Select one</option>
	    if (isFalsyAttrValue(value)) {
	      el.removeAttribute(key);
	    } else {
	      // technically allowfullscreen is a boolean attribute for <iframe>,
	      // but Flash expects a value of "true" when used on <embed> tag
	      value = key === 'allowfullscreen' && el.tagName === 'EMBED'
	        ? 'true'
	        : key;
	      el.setAttribute(key, value);
	    }
	  } else if (isEnumeratedAttr(key)) {
	    el.setAttribute(key, convertEnumeratedValue(key, value));
	  } else if (isXlink(key)) {
	    if (isFalsyAttrValue(value)) {
	      el.removeAttributeNS(xlinkNS, getXlinkProp(key));
	    } else {
	      el.setAttributeNS(xlinkNS, key, value);
	    }
	  } else {
	    baseSetAttr(el, key, value);
	  }
	}

	function baseSetAttr (el, key, value) {
	  if (isFalsyAttrValue(value)) {
	    el.removeAttribute(key);
	  } else {
	    // #7138: IE10 & 11 fires input event when setting placeholder on
	    // <textarea>... block the first input event and remove the blocker
	    // immediately.
	    /* istanbul ignore if */
	    if (
	      isIE && !isIE9 &&
	      el.tagName === 'TEXTAREA' &&
	      key === 'placeholder' && value !== '' && !el.__ieph
	    ) {
	      var blocker = function (e) {
	        e.stopImmediatePropagation();
	        el.removeEventListener('input', blocker);
	      };
	      el.addEventListener('input', blocker);
	      // $flow-disable-line
	      el.__ieph = true; /* IE placeholder patched */
	    }
	    el.setAttribute(key, value);
	  }
	}

	var attrs = {
	  create: updateAttrs,
	  update: updateAttrs
	};

	/*  */

	function updateClass (oldVnode, vnode) {
	  var el = vnode.elm;
	  var data = vnode.data;
	  var oldData = oldVnode.data;
	  if (
	    isUndef(data.staticClass) &&
	    isUndef(data.class) && (
	      isUndef(oldData) || (
	        isUndef(oldData.staticClass) &&
	        isUndef(oldData.class)
	      )
	    )
	  ) {
	    return
	  }

	  var cls = genClassForVnode(vnode);

	  // handle transition classes
	  var transitionClass = el._transitionClasses;
	  if (isDef(transitionClass)) {
	    cls = concat(cls, stringifyClass(transitionClass));
	  }

	  // set the class
	  if (cls !== el._prevClass) {
	    el.setAttribute('class', cls);
	    el._prevClass = cls;
	  }
	}

	var klass = {
	  create: updateClass,
	  update: updateClass
	};

	/*  */

	/*  */

	/*  */

	/*  */

	// in some cases, the event used has to be determined at runtime
	// so we used some reserved tokens during compile.
	var RANGE_TOKEN = '__r';
	var CHECKBOX_RADIO_TOKEN = '__c';

	/*  */

	// normalize v-model event tokens that can only be determined at runtime.
	// it's important to place the event as the first in the array because
	// the whole point is ensuring the v-model callback gets called before
	// user-attached handlers.
	function normalizeEvents (on) {
	  /* istanbul ignore if */
	  if (isDef(on[RANGE_TOKEN])) {
	    // IE input[type=range] only supports `change` event
	    var event = isIE ? 'change' : 'input';
	    on[event] = [].concat(on[RANGE_TOKEN], on[event] || []);
	    delete on[RANGE_TOKEN];
	  }
	  // This was originally intended to fix #4521 but no longer necessary
	  // after 2.5. Keeping it for backwards compat with generated code from < 2.4
	  /* istanbul ignore if */
	  if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
	    on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
	    delete on[CHECKBOX_RADIO_TOKEN];
	  }
	}

	var target$1;

	function createOnceHandler$1 (event, handler, capture) {
	  var _target = target$1; // save current target element in closure
	  return function onceHandler () {
	    var res = handler.apply(null, arguments);
	    if (res !== null) {
	      remove$2(event, onceHandler, capture, _target);
	    }
	  }
	}

	// #9446: Firefox <= 53 (in particular, ESR 52) has incorrect Event.timeStamp
	// implementation and does not fire microtasks in between event propagation, so
	// safe to exclude.
	var useMicrotaskFix = isUsingMicroTask && !(isFF && Number(isFF[1]) <= 53);

	function add$1 (
	  name,
	  handler,
	  capture,
	  passive
	) {
	  // async edge case #6566: inner click event triggers patch, event handler
	  // attached to outer element during patch, and triggered again. This
	  // happens because browsers fire microtask ticks between event propagation.
	  // the solution is simple: we save the timestamp when a handler is attached,
	  // and the handler would only fire if the event passed to it was fired
	  // AFTER it was attached.
	  if (useMicrotaskFix) {
	    var attachedTimestamp = currentFlushTimestamp;
	    var original = handler;
	    handler = original._wrapper = function (e) {
	      if (
	        // no bubbling, should always fire.
	        // this is just a safety net in case event.timeStamp is unreliable in
	        // certain weird environments...
	        e.target === e.currentTarget ||
	        // event is fired after handler attachment
	        e.timeStamp >= attachedTimestamp ||
	        // bail for environments that have buggy event.timeStamp implementations
	        // #9462 iOS 9 bug: event.timeStamp is 0 after history.pushState
	        // #9681 QtWebEngine event.timeStamp is negative value
	        e.timeStamp <= 0 ||
	        // #9448 bail if event is fired in another document in a multi-page
	        // electron/nw.js app, since event.timeStamp will be using a different
	        // starting reference
	        e.target.ownerDocument !== document
	      ) {
	        return original.apply(this, arguments)
	      }
	    };
	  }
	  target$1.addEventListener(
	    name,
	    handler,
	    supportsPassive
	      ? { capture: capture, passive: passive }
	      : capture
	  );
	}

	function remove$2 (
	  name,
	  handler,
	  capture,
	  _target
	) {
	  (_target || target$1).removeEventListener(
	    name,
	    handler._wrapper || handler,
	    capture
	  );
	}

	function updateDOMListeners (oldVnode, vnode) {
	  if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
	    return
	  }
	  var on = vnode.data.on || {};
	  var oldOn = oldVnode.data.on || {};
	  target$1 = vnode.elm;
	  normalizeEvents(on);
	  updateListeners(on, oldOn, add$1, remove$2, createOnceHandler$1, vnode.context);
	  target$1 = undefined;
	}

	var events = {
	  create: updateDOMListeners,
	  update: updateDOMListeners
	};

	/*  */

	var svgContainer;

	function updateDOMProps (oldVnode, vnode) {
	  if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
	    return
	  }
	  var key, cur;
	  var elm = vnode.elm;
	  var oldProps = oldVnode.data.domProps || {};
	  var props = vnode.data.domProps || {};
	  // clone observed objects, as the user probably wants to mutate it
	  if (isDef(props.__ob__)) {
	    props = vnode.data.domProps = extend({}, props);
	  }

	  for (key in oldProps) {
	    if (!(key in props)) {
	      elm[key] = '';
	    }
	  }

	  for (key in props) {
	    cur = props[key];
	    // ignore children if the node has textContent or innerHTML,
	    // as these will throw away existing DOM nodes and cause removal errors
	    // on subsequent patches (#3360)
	    if (key === 'textContent' || key === 'innerHTML') {
	      if (vnode.children) { vnode.children.length = 0; }
	      if (cur === oldProps[key]) { continue }
	      // #6601 work around Chrome version <= 55 bug where single textNode
	      // replaced by innerHTML/textContent retains its parentNode property
	      if (elm.childNodes.length === 1) {
	        elm.removeChild(elm.childNodes[0]);
	      }
	    }

	    if (key === 'value' && elm.tagName !== 'PROGRESS') {
	      // store value as _value as well since
	      // non-string values will be stringified
	      elm._value = cur;
	      // avoid resetting cursor position when value is the same
	      var strCur = isUndef(cur) ? '' : String(cur);
	      if (shouldUpdateValue(elm, strCur)) {
	        elm.value = strCur;
	      }
	    } else if (key === 'innerHTML' && isSVG(elm.tagName) && isUndef(elm.innerHTML)) {
	      // IE doesn't support innerHTML for SVG elements
	      svgContainer = svgContainer || document.createElement('div');
	      svgContainer.innerHTML = "<svg>" + cur + "</svg>";
	      var svg = svgContainer.firstChild;
	      while (elm.firstChild) {
	        elm.removeChild(elm.firstChild);
	      }
	      while (svg.firstChild) {
	        elm.appendChild(svg.firstChild);
	      }
	    } else if (
	      // skip the update if old and new VDOM state is the same.
	      // `value` is handled separately because the DOM value may be temporarily
	      // out of sync with VDOM state due to focus, composition and modifiers.
	      // This  #4521 by skipping the unnecessary `checked` update.
	      cur !== oldProps[key]
	    ) {
	      // some property updates can throw
	      // e.g. `value` on <progress> w/ non-finite value
	      try {
	        elm[key] = cur;
	      } catch (e) {}
	    }
	  }
	}

	// check platforms/web/util/attrs.js acceptValue


	function shouldUpdateValue (elm, checkVal) {
	  return (!elm.composing && (
	    elm.tagName === 'OPTION' ||
	    isNotInFocusAndDirty(elm, checkVal) ||
	    isDirtyWithModifiers(elm, checkVal)
	  ))
	}

	function isNotInFocusAndDirty (elm, checkVal) {
	  // return true when textbox (.number and .trim) loses focus and its value is
	  // not equal to the updated value
	  var notInFocus = true;
	  // #6157
	  // work around IE bug when accessing document.activeElement in an iframe
	  try { notInFocus = document.activeElement !== elm; } catch (e) {}
	  return notInFocus && elm.value !== checkVal
	}

	function isDirtyWithModifiers (elm, newVal) {
	  var value = elm.value;
	  var modifiers = elm._vModifiers; // injected by v-model runtime
	  if (isDef(modifiers)) {
	    if (modifiers.number) {
	      return toNumber(value) !== toNumber(newVal)
	    }
	    if (modifiers.trim) {
	      return value.trim() !== newVal.trim()
	    }
	  }
	  return value !== newVal
	}

	var domProps = {
	  create: updateDOMProps,
	  update: updateDOMProps
	};

	/*  */

	var parseStyleText = cached(function (cssText) {
	  var res = {};
	  var listDelimiter = /;(?![^(]*\))/g;
	  var propertyDelimiter = /:(.+)/;
	  cssText.split(listDelimiter).forEach(function (item) {
	    if (item) {
	      var tmp = item.split(propertyDelimiter);
	      tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
	    }
	  });
	  return res
	});

	// merge static and dynamic style data on the same vnode
	function normalizeStyleData (data) {
	  var style = normalizeStyleBinding(data.style);
	  // static style is pre-processed into an object during compilation
	  // and is always a fresh object, so it's safe to merge into it
	  return data.staticStyle
	    ? extend(data.staticStyle, style)
	    : style
	}

	// normalize possible array / string values into Object
	function normalizeStyleBinding (bindingStyle) {
	  if (Array.isArray(bindingStyle)) {
	    return toObject(bindingStyle)
	  }
	  if (typeof bindingStyle === 'string') {
	    return parseStyleText(bindingStyle)
	  }
	  return bindingStyle
	}

	/**
	 * parent component style should be after child's
	 * so that parent component's style could override it
	 */
	function getStyle (vnode, checkChild) {
	  var res = {};
	  var styleData;

	  if (checkChild) {
	    var childNode = vnode;
	    while (childNode.componentInstance) {
	      childNode = childNode.componentInstance._vnode;
	      if (
	        childNode && childNode.data &&
	        (styleData = normalizeStyleData(childNode.data))
	      ) {
	        extend(res, styleData);
	      }
	    }
	  }

	  if ((styleData = normalizeStyleData(vnode.data))) {
	    extend(res, styleData);
	  }

	  var parentNode = vnode;
	  while ((parentNode = parentNode.parent)) {
	    if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
	      extend(res, styleData);
	    }
	  }
	  return res
	}

	/*  */

	var cssVarRE = /^--/;
	var importantRE = /\s*!important$/;
	var setProp = function (el, name, val) {
	  /* istanbul ignore if */
	  if (cssVarRE.test(name)) {
	    el.style.setProperty(name, val);
	  } else if (importantRE.test(val)) {
	    el.style.setProperty(hyphenate(name), val.replace(importantRE, ''), 'important');
	  } else {
	    var normalizedName = normalize(name);
	    if (Array.isArray(val)) {
	      // Support values array created by autoprefixer, e.g.
	      // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
	      // Set them one by one, and the browser will only set those it can recognize
	      for (var i = 0, len = val.length; i < len; i++) {
	        el.style[normalizedName] = val[i];
	      }
	    } else {
	      el.style[normalizedName] = val;
	    }
	  }
	};

	var vendorNames = ['Webkit', 'Moz', 'ms'];

	var emptyStyle;
	var normalize = cached(function (prop) {
	  emptyStyle = emptyStyle || document.createElement('div').style;
	  prop = camelize(prop);
	  if (prop !== 'filter' && (prop in emptyStyle)) {
	    return prop
	  }
	  var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
	  for (var i = 0; i < vendorNames.length; i++) {
	    var name = vendorNames[i] + capName;
	    if (name in emptyStyle) {
	      return name
	    }
	  }
	});

	function updateStyle (oldVnode, vnode) {
	  var data = vnode.data;
	  var oldData = oldVnode.data;

	  if (isUndef(data.staticStyle) && isUndef(data.style) &&
	    isUndef(oldData.staticStyle) && isUndef(oldData.style)
	  ) {
	    return
	  }

	  var cur, name;
	  var el = vnode.elm;
	  var oldStaticStyle = oldData.staticStyle;
	  var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};

	  // if static style exists, stylebinding already merged into it when doing normalizeStyleData
	  var oldStyle = oldStaticStyle || oldStyleBinding;

	  var style = normalizeStyleBinding(vnode.data.style) || {};

	  // store normalized style under a different key for next diff
	  // make sure to clone it if it's reactive, since the user likely wants
	  // to mutate it.
	  vnode.data.normalizedStyle = isDef(style.__ob__)
	    ? extend({}, style)
	    : style;

	  var newStyle = getStyle(vnode, true);

	  for (name in oldStyle) {
	    if (isUndef(newStyle[name])) {
	      setProp(el, name, '');
	    }
	  }
	  for (name in newStyle) {
	    cur = newStyle[name];
	    if (cur !== oldStyle[name]) {
	      // ie9 setting to null has no effect, must use empty string
	      setProp(el, name, cur == null ? '' : cur);
	    }
	  }
	}

	var style = {
	  create: updateStyle,
	  update: updateStyle
	};

	/*  */

	var whitespaceRE = /\s+/;

	/**
	 * Add class with compatibility for SVG since classList is not supported on
	 * SVG elements in IE
	 */
	function addClass (el, cls) {
	  /* istanbul ignore if */
	  if (!cls || !(cls = cls.trim())) {
	    return
	  }

	  /* istanbul ignore else */
	  if (el.classList) {
	    if (cls.indexOf(' ') > -1) {
	      cls.split(whitespaceRE).forEach(function (c) { return el.classList.add(c); });
	    } else {
	      el.classList.add(cls);
	    }
	  } else {
	    var cur = " " + (el.getAttribute('class') || '') + " ";
	    if (cur.indexOf(' ' + cls + ' ') < 0) {
	      el.setAttribute('class', (cur + cls).trim());
	    }
	  }
	}

	/**
	 * Remove class with compatibility for SVG since classList is not supported on
	 * SVG elements in IE
	 */
	function removeClass (el, cls) {
	  /* istanbul ignore if */
	  if (!cls || !(cls = cls.trim())) {
	    return
	  }

	  /* istanbul ignore else */
	  if (el.classList) {
	    if (cls.indexOf(' ') > -1) {
	      cls.split(whitespaceRE).forEach(function (c) { return el.classList.remove(c); });
	    } else {
	      el.classList.remove(cls);
	    }
	    if (!el.classList.length) {
	      el.removeAttribute('class');
	    }
	  } else {
	    var cur = " " + (el.getAttribute('class') || '') + " ";
	    var tar = ' ' + cls + ' ';
	    while (cur.indexOf(tar) >= 0) {
	      cur = cur.replace(tar, ' ');
	    }
	    cur = cur.trim();
	    if (cur) {
	      el.setAttribute('class', cur);
	    } else {
	      el.removeAttribute('class');
	    }
	  }
	}

	/*  */

	function resolveTransition (def$$1) {
	  if (!def$$1) {
	    return
	  }
	  /* istanbul ignore else */
	  if (typeof def$$1 === 'object') {
	    var res = {};
	    if (def$$1.css !== false) {
	      extend(res, autoCssTransition(def$$1.name || 'v'));
	    }
	    extend(res, def$$1);
	    return res
	  } else if (typeof def$$1 === 'string') {
	    return autoCssTransition(def$$1)
	  }
	}

	var autoCssTransition = cached(function (name) {
	  return {
	    enterClass: (name + "-enter"),
	    enterToClass: (name + "-enter-to"),
	    enterActiveClass: (name + "-enter-active"),
	    leaveClass: (name + "-leave"),
	    leaveToClass: (name + "-leave-to"),
	    leaveActiveClass: (name + "-leave-active")
	  }
	});

	var hasTransition = inBrowser && !isIE9;
	var TRANSITION = 'transition';
	var ANIMATION = 'animation';

	// Transition property/event sniffing
	var transitionProp = 'transition';
	var transitionEndEvent = 'transitionend';
	var animationProp = 'animation';
	var animationEndEvent = 'animationend';
	if (hasTransition) {
	  /* istanbul ignore if */
	  if (window.ontransitionend === undefined &&
	    window.onwebkittransitionend !== undefined
	  ) {
	    transitionProp = 'WebkitTransition';
	    transitionEndEvent = 'webkitTransitionEnd';
	  }
	  if (window.onanimationend === undefined &&
	    window.onwebkitanimationend !== undefined
	  ) {
	    animationProp = 'WebkitAnimation';
	    animationEndEvent = 'webkitAnimationEnd';
	  }
	}

	// binding to window is necessary to make hot reload work in IE in strict mode
	var raf = inBrowser
	  ? window.requestAnimationFrame
	    ? window.requestAnimationFrame.bind(window)
	    : setTimeout
	  : /* istanbul ignore next */ function (fn) { return fn(); };

	function nextFrame (fn) {
	  raf(function () {
	    raf(fn);
	  });
	}

	function addTransitionClass (el, cls) {
	  var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
	  if (transitionClasses.indexOf(cls) < 0) {
	    transitionClasses.push(cls);
	    addClass(el, cls);
	  }
	}

	function removeTransitionClass (el, cls) {
	  if (el._transitionClasses) {
	    remove(el._transitionClasses, cls);
	  }
	  removeClass(el, cls);
	}

	function whenTransitionEnds (
	  el,
	  expectedType,
	  cb
	) {
	  var ref = getTransitionInfo(el, expectedType);
	  var type = ref.type;
	  var timeout = ref.timeout;
	  var propCount = ref.propCount;
	  if (!type) { return cb() }
	  var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
	  var ended = 0;
	  var end = function () {
	    el.removeEventListener(event, onEnd);
	    cb();
	  };
	  var onEnd = function (e) {
	    if (e.target === el) {
	      if (++ended >= propCount) {
	        end();
	      }
	    }
	  };
	  setTimeout(function () {
	    if (ended < propCount) {
	      end();
	    }
	  }, timeout + 1);
	  el.addEventListener(event, onEnd);
	}

	var transformRE = /\b(transform|all)(,|$)/;

	function getTransitionInfo (el, expectedType) {
	  var styles = window.getComputedStyle(el);
	  // JSDOM may return undefined for transition properties
	  var transitionDelays = (styles[transitionProp + 'Delay'] || '').split(', ');
	  var transitionDurations = (styles[transitionProp + 'Duration'] || '').split(', ');
	  var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
	  var animationDelays = (styles[animationProp + 'Delay'] || '').split(', ');
	  var animationDurations = (styles[animationProp + 'Duration'] || '').split(', ');
	  var animationTimeout = getTimeout(animationDelays, animationDurations);

	  var type;
	  var timeout = 0;
	  var propCount = 0;
	  /* istanbul ignore if */
	  if (expectedType === TRANSITION) {
	    if (transitionTimeout > 0) {
	      type = TRANSITION;
	      timeout = transitionTimeout;
	      propCount = transitionDurations.length;
	    }
	  } else if (expectedType === ANIMATION) {
	    if (animationTimeout > 0) {
	      type = ANIMATION;
	      timeout = animationTimeout;
	      propCount = animationDurations.length;
	    }
	  } else {
	    timeout = Math.max(transitionTimeout, animationTimeout);
	    type = timeout > 0
	      ? transitionTimeout > animationTimeout
	        ? TRANSITION
	        : ANIMATION
	      : null;
	    propCount = type
	      ? type === TRANSITION
	        ? transitionDurations.length
	        : animationDurations.length
	      : 0;
	  }
	  var hasTransform =
	    type === TRANSITION &&
	    transformRE.test(styles[transitionProp + 'Property']);
	  return {
	    type: type,
	    timeout: timeout,
	    propCount: propCount,
	    hasTransform: hasTransform
	  }
	}

	function getTimeout (delays, durations) {
	  /* istanbul ignore next */
	  while (delays.length < durations.length) {
	    delays = delays.concat(delays);
	  }

	  return Math.max.apply(null, durations.map(function (d, i) {
	    return toMs(d) + toMs(delays[i])
	  }))
	}

	// Old versions of Chromium (below 61.0.3163.100) formats floating pointer numbers
	// in a locale-dependent way, using a comma instead of a dot.
	// If comma is not replaced with a dot, the input will be rounded down (i.e. acting
	// as a floor function) causing unexpected behaviors
	function toMs (s) {
	  return Number(s.slice(0, -1).replace(',', '.')) * 1000
	}

	/*  */

	function enter (vnode, toggleDisplay) {
	  var el = vnode.elm;

	  // call leave callback now
	  if (isDef(el._leaveCb)) {
	    el._leaveCb.cancelled = true;
	    el._leaveCb();
	  }

	  var data = resolveTransition(vnode.data.transition);
	  if (isUndef(data)) {
	    return
	  }

	  /* istanbul ignore if */
	  if (isDef(el._enterCb) || el.nodeType !== 1) {
	    return
	  }

	  var css = data.css;
	  var type = data.type;
	  var enterClass = data.enterClass;
	  var enterToClass = data.enterToClass;
	  var enterActiveClass = data.enterActiveClass;
	  var appearClass = data.appearClass;
	  var appearToClass = data.appearToClass;
	  var appearActiveClass = data.appearActiveClass;
	  var beforeEnter = data.beforeEnter;
	  var enter = data.enter;
	  var afterEnter = data.afterEnter;
	  var enterCancelled = data.enterCancelled;
	  var beforeAppear = data.beforeAppear;
	  var appear = data.appear;
	  var afterAppear = data.afterAppear;
	  var appearCancelled = data.appearCancelled;
	  var duration = data.duration;

	  // activeInstance will always be the <transition> component managing this
	  // transition. One edge case to check is when the <transition> is placed
	  // as the root node of a child component. In that case we need to check
	  // <transition>'s parent for appear check.
	  var context = activeInstance;
	  var transitionNode = activeInstance.$vnode;
	  while (transitionNode && transitionNode.parent) {
	    context = transitionNode.context;
	    transitionNode = transitionNode.parent;
	  }

	  var isAppear = !context._isMounted || !vnode.isRootInsert;

	  if (isAppear && !appear && appear !== '') {
	    return
	  }

	  var startClass = isAppear && appearClass
	    ? appearClass
	    : enterClass;
	  var activeClass = isAppear && appearActiveClass
	    ? appearActiveClass
	    : enterActiveClass;
	  var toClass = isAppear && appearToClass
	    ? appearToClass
	    : enterToClass;

	  var beforeEnterHook = isAppear
	    ? (beforeAppear || beforeEnter)
	    : beforeEnter;
	  var enterHook = isAppear
	    ? (typeof appear === 'function' ? appear : enter)
	    : enter;
	  var afterEnterHook = isAppear
	    ? (afterAppear || afterEnter)
	    : afterEnter;
	  var enterCancelledHook = isAppear
	    ? (appearCancelled || enterCancelled)
	    : enterCancelled;

	  var explicitEnterDuration = toNumber(
	    isObject(duration)
	      ? duration.enter
	      : duration
	  );

	  var expectsCSS = css !== false && !isIE9;
	  var userWantsControl = getHookArgumentsLength(enterHook);

	  var cb = el._enterCb = once(function () {
	    if (expectsCSS) {
	      removeTransitionClass(el, toClass);
	      removeTransitionClass(el, activeClass);
	    }
	    if (cb.cancelled) {
	      if (expectsCSS) {
	        removeTransitionClass(el, startClass);
	      }
	      enterCancelledHook && enterCancelledHook(el);
	    } else {
	      afterEnterHook && afterEnterHook(el);
	    }
	    el._enterCb = null;
	  });

	  if (!vnode.data.show) {
	    // remove pending leave element on enter by injecting an insert hook
	    mergeVNodeHook(vnode, 'insert', function () {
	      var parent = el.parentNode;
	      var pendingNode = parent && parent._pending && parent._pending[vnode.key];
	      if (pendingNode &&
	        pendingNode.tag === vnode.tag &&
	        pendingNode.elm._leaveCb
	      ) {
	        pendingNode.elm._leaveCb();
	      }
	      enterHook && enterHook(el, cb);
	    });
	  }

	  // start enter transition
	  beforeEnterHook && beforeEnterHook(el);
	  if (expectsCSS) {
	    addTransitionClass(el, startClass);
	    addTransitionClass(el, activeClass);
	    nextFrame(function () {
	      removeTransitionClass(el, startClass);
	      if (!cb.cancelled) {
	        addTransitionClass(el, toClass);
	        if (!userWantsControl) {
	          if (isValidDuration(explicitEnterDuration)) {
	            setTimeout(cb, explicitEnterDuration);
	          } else {
	            whenTransitionEnds(el, type, cb);
	          }
	        }
	      }
	    });
	  }

	  if (vnode.data.show) {
	    toggleDisplay && toggleDisplay();
	    enterHook && enterHook(el, cb);
	  }

	  if (!expectsCSS && !userWantsControl) {
	    cb();
	  }
	}

	function leave (vnode, rm) {
	  var el = vnode.elm;

	  // call enter callback now
	  if (isDef(el._enterCb)) {
	    el._enterCb.cancelled = true;
	    el._enterCb();
	  }

	  var data = resolveTransition(vnode.data.transition);
	  if (isUndef(data) || el.nodeType !== 1) {
	    return rm()
	  }

	  /* istanbul ignore if */
	  if (isDef(el._leaveCb)) {
	    return
	  }

	  var css = data.css;
	  var type = data.type;
	  var leaveClass = data.leaveClass;
	  var leaveToClass = data.leaveToClass;
	  var leaveActiveClass = data.leaveActiveClass;
	  var beforeLeave = data.beforeLeave;
	  var leave = data.leave;
	  var afterLeave = data.afterLeave;
	  var leaveCancelled = data.leaveCancelled;
	  var delayLeave = data.delayLeave;
	  var duration = data.duration;

	  var expectsCSS = css !== false && !isIE9;
	  var userWantsControl = getHookArgumentsLength(leave);

	  var explicitLeaveDuration = toNumber(
	    isObject(duration)
	      ? duration.leave
	      : duration
	  );

	  var cb = el._leaveCb = once(function () {
	    if (el.parentNode && el.parentNode._pending) {
	      el.parentNode._pending[vnode.key] = null;
	    }
	    if (expectsCSS) {
	      removeTransitionClass(el, leaveToClass);
	      removeTransitionClass(el, leaveActiveClass);
	    }
	    if (cb.cancelled) {
	      if (expectsCSS) {
	        removeTransitionClass(el, leaveClass);
	      }
	      leaveCancelled && leaveCancelled(el);
	    } else {
	      rm();
	      afterLeave && afterLeave(el);
	    }
	    el._leaveCb = null;
	  });

	  if (delayLeave) {
	    delayLeave(performLeave);
	  } else {
	    performLeave();
	  }

	  function performLeave () {
	    // the delayed leave may have already been cancelled
	    if (cb.cancelled) {
	      return
	    }
	    // record leaving element
	    if (!vnode.data.show && el.parentNode) {
	      (el.parentNode._pending || (el.parentNode._pending = {}))[(vnode.key)] = vnode;
	    }
	    beforeLeave && beforeLeave(el);
	    if (expectsCSS) {
	      addTransitionClass(el, leaveClass);
	      addTransitionClass(el, leaveActiveClass);
	      nextFrame(function () {
	        removeTransitionClass(el, leaveClass);
	        if (!cb.cancelled) {
	          addTransitionClass(el, leaveToClass);
	          if (!userWantsControl) {
	            if (isValidDuration(explicitLeaveDuration)) {
	              setTimeout(cb, explicitLeaveDuration);
	            } else {
	              whenTransitionEnds(el, type, cb);
	            }
	          }
	        }
	      });
	    }
	    leave && leave(el, cb);
	    if (!expectsCSS && !userWantsControl) {
	      cb();
	    }
	  }
	}

	function isValidDuration (val) {
	  return typeof val === 'number' && !isNaN(val)
	}

	/**
	 * Normalize a transition hook's argument length. The hook may be:
	 * - a merged hook (invoker) with the original in .fns
	 * - a wrapped component method (check ._length)
	 * - a plain function (.length)
	 */
	function getHookArgumentsLength (fn) {
	  if (isUndef(fn)) {
	    return false
	  }
	  var invokerFns = fn.fns;
	  if (isDef(invokerFns)) {
	    // invoker
	    return getHookArgumentsLength(
	      Array.isArray(invokerFns)
	        ? invokerFns[0]
	        : invokerFns
	    )
	  } else {
	    return (fn._length || fn.length) > 1
	  }
	}

	function _enter (_, vnode) {
	  if (vnode.data.show !== true) {
	    enter(vnode);
	  }
	}

	var transition = inBrowser ? {
	  create: _enter,
	  activate: _enter,
	  remove: function remove$$1 (vnode, rm) {
	    /* istanbul ignore else */
	    if (vnode.data.show !== true) {
	      leave(vnode, rm);
	    } else {
	      rm();
	    }
	  }
	} : {};

	var platformModules = [
	  attrs,
	  klass,
	  events,
	  domProps,
	  style,
	  transition
	];

	/*  */

	// the directive module should be applied last, after all
	// built-in modules have been applied.
	var modules = platformModules.concat(baseModules);

	var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules });

	/**
	 * Not type checking this file because flow doesn't like attaching
	 * properties to Elements.
	 */

	/* istanbul ignore if */
	if (isIE9) {
	  // http://www.matts411.com/post/internet-explorer-9-oninput/
	  document.addEventListener('selectionchange', function () {
	    var el = document.activeElement;
	    if (el && el.vmodel) {
	      trigger(el, 'input');
	    }
	  });
	}

	var directive = {
	  inserted: function inserted (el, binding, vnode, oldVnode) {
	    if (vnode.tag === 'select') {
	      // #6903
	      if (oldVnode.elm && !oldVnode.elm._vOptions) {
	        mergeVNodeHook(vnode, 'postpatch', function () {
	          directive.componentUpdated(el, binding, vnode);
	        });
	      } else {
	        setSelected(el, binding, vnode.context);
	      }
	      el._vOptions = [].map.call(el.options, getValue);
	    } else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
	      el._vModifiers = binding.modifiers;
	      if (!binding.modifiers.lazy) {
	        el.addEventListener('compositionstart', onCompositionStart);
	        el.addEventListener('compositionend', onCompositionEnd);
	        // Safari < 10.2 & UIWebView doesn't fire compositionend when
	        // switching focus before confirming composition choice
	        // this also fixes the issue where some browsers e.g. iOS Chrome
	        // fires "change" instead of "input" on autocomplete.
	        el.addEventListener('change', onCompositionEnd);
	        /* istanbul ignore if */
	        if (isIE9) {
	          el.vmodel = true;
	        }
	      }
	    }
	  },

	  componentUpdated: function componentUpdated (el, binding, vnode) {
	    if (vnode.tag === 'select') {
	      setSelected(el, binding, vnode.context);
	      // in case the options rendered by v-for have changed,
	      // it's possible that the value is out-of-sync with the rendered options.
	      // detect such cases and filter out values that no longer has a matching
	      // option in the DOM.
	      var prevOptions = el._vOptions;
	      var curOptions = el._vOptions = [].map.call(el.options, getValue);
	      if (curOptions.some(function (o, i) { return !looseEqual(o, prevOptions[i]); })) {
	        // trigger change event if
	        // no matching option found for at least one value
	        var needReset = el.multiple
	          ? binding.value.some(function (v) { return hasNoMatchingOption(v, curOptions); })
	          : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, curOptions);
	        if (needReset) {
	          trigger(el, 'change');
	        }
	      }
	    }
	  }
	};

	function setSelected (el, binding, vm) {
	  actuallySetSelected(el, binding, vm);
	  /* istanbul ignore if */
	  if (isIE || isEdge) {
	    setTimeout(function () {
	      actuallySetSelected(el, binding, vm);
	    }, 0);
	  }
	}

	function actuallySetSelected (el, binding, vm) {
	  var value = binding.value;
	  var isMultiple = el.multiple;
	  if (isMultiple && !Array.isArray(value)) {
	    return
	  }
	  var selected, option;
	  for (var i = 0, l = el.options.length; i < l; i++) {
	    option = el.options[i];
	    if (isMultiple) {
	      selected = looseIndexOf(value, getValue(option)) > -1;
	      if (option.selected !== selected) {
	        option.selected = selected;
	      }
	    } else {
	      if (looseEqual(getValue(option), value)) {
	        if (el.selectedIndex !== i) {
	          el.selectedIndex = i;
	        }
	        return
	      }
	    }
	  }
	  if (!isMultiple) {
	    el.selectedIndex = -1;
	  }
	}

	function hasNoMatchingOption (value, options) {
	  return options.every(function (o) { return !looseEqual(o, value); })
	}

	function getValue (option) {
	  return '_value' in option
	    ? option._value
	    : option.value
	}

	function onCompositionStart (e) {
	  e.target.composing = true;
	}

	function onCompositionEnd (e) {
	  // prevent triggering an input event for no reason
	  if (!e.target.composing) { return }
	  e.target.composing = false;
	  trigger(e.target, 'input');
	}

	function trigger (el, type) {
	  var e = document.createEvent('HTMLEvents');
	  e.initEvent(type, true, true);
	  el.dispatchEvent(e);
	}

	/*  */

	// recursively search for possible transition defined inside the component root
	function locateNode (vnode) {
	  return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
	    ? locateNode(vnode.componentInstance._vnode)
	    : vnode
	}

	var show = {
	  bind: function bind (el, ref, vnode) {
	    var value = ref.value;

	    vnode = locateNode(vnode);
	    var transition$$1 = vnode.data && vnode.data.transition;
	    var originalDisplay = el.__vOriginalDisplay =
	      el.style.display === 'none' ? '' : el.style.display;
	    if (value && transition$$1) {
	      vnode.data.show = true;
	      enter(vnode, function () {
	        el.style.display = originalDisplay;
	      });
	    } else {
	      el.style.display = value ? originalDisplay : 'none';
	    }
	  },

	  update: function update (el, ref, vnode) {
	    var value = ref.value;
	    var oldValue = ref.oldValue;

	    /* istanbul ignore if */
	    if (!value === !oldValue) { return }
	    vnode = locateNode(vnode);
	    var transition$$1 = vnode.data && vnode.data.transition;
	    if (transition$$1) {
	      vnode.data.show = true;
	      if (value) {
	        enter(vnode, function () {
	          el.style.display = el.__vOriginalDisplay;
	        });
	      } else {
	        leave(vnode, function () {
	          el.style.display = 'none';
	        });
	      }
	    } else {
	      el.style.display = value ? el.__vOriginalDisplay : 'none';
	    }
	  },

	  unbind: function unbind (
	    el,
	    binding,
	    vnode,
	    oldVnode,
	    isDestroy
	  ) {
	    if (!isDestroy) {
	      el.style.display = el.__vOriginalDisplay;
	    }
	  }
	};

	var platformDirectives = {
	  model: directive,
	  show: show
	};

	/*  */

	var transitionProps = {
	  name: String,
	  appear: Boolean,
	  css: Boolean,
	  mode: String,
	  type: String,
	  enterClass: String,
	  leaveClass: String,
	  enterToClass: String,
	  leaveToClass: String,
	  enterActiveClass: String,
	  leaveActiveClass: String,
	  appearClass: String,
	  appearActiveClass: String,
	  appearToClass: String,
	  duration: [Number, String, Object]
	};

	// in case the child is also an abstract component, e.g. <keep-alive>
	// we want to recursively retrieve the real component to be rendered
	function getRealChild (vnode) {
	  var compOptions = vnode && vnode.componentOptions;
	  if (compOptions && compOptions.Ctor.options.abstract) {
	    return getRealChild(getFirstComponentChild(compOptions.children))
	  } else {
	    return vnode
	  }
	}

	function extractTransitionData (comp) {
	  var data = {};
	  var options = comp.$options;
	  // props
	  for (var key in options.propsData) {
	    data[key] = comp[key];
	  }
	  // events.
	  // extract listeners and pass them directly to the transition methods
	  var listeners = options._parentListeners;
	  for (var key$1 in listeners) {
	    data[camelize(key$1)] = listeners[key$1];
	  }
	  return data
	}

	function placeholder (h, rawChild) {
	  if (/\d-keep-alive$/.test(rawChild.tag)) {
	    return h('keep-alive', {
	      props: rawChild.componentOptions.propsData
	    })
	  }
	}

	function hasParentTransition (vnode) {
	  while ((vnode = vnode.parent)) {
	    if (vnode.data.transition) {
	      return true
	    }
	  }
	}

	function isSameChild (child, oldChild) {
	  return oldChild.key === child.key && oldChild.tag === child.tag
	}

	var isNotTextNode = function (c) { return c.tag || isAsyncPlaceholder(c); };

	var isVShowDirective = function (d) { return d.name === 'show'; };

	var Transition = {
	  name: 'transition',
	  props: transitionProps,
	  abstract: true,

	  render: function render (h) {
	    var this$1 = this;

	    var children = this.$slots.default;
	    if (!children) {
	      return
	    }

	    // filter out text nodes (possible whitespaces)
	    children = children.filter(isNotTextNode);
	    /* istanbul ignore if */
	    if (!children.length) {
	      return
	    }

	    var mode = this.mode;

	    var rawChild = children[0];

	    // if this is a component root node and the component's
	    // parent container node also has transition, skip.
	    if (hasParentTransition(this.$vnode)) {
	      return rawChild
	    }

	    // apply transition data to child
	    // use getRealChild() to ignore abstract components e.g. keep-alive
	    var child = getRealChild(rawChild);
	    /* istanbul ignore if */
	    if (!child) {
	      return rawChild
	    }

	    if (this._leaving) {
	      return placeholder(h, rawChild)
	    }

	    // ensure a key that is unique to the vnode type and to this transition
	    // component instance. This key will be used to remove pending leaving nodes
	    // during entering.
	    var id = "__transition-" + (this._uid) + "-";
	    child.key = child.key == null
	      ? child.isComment
	        ? id + 'comment'
	        : id + child.tag
	      : isPrimitive(child.key)
	        ? (String(child.key).indexOf(id) === 0 ? child.key : id + child.key)
	        : child.key;

	    var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
	    var oldRawChild = this._vnode;
	    var oldChild = getRealChild(oldRawChild);

	    // mark v-show
	    // so that the transition module can hand over the control to the directive
	    if (child.data.directives && child.data.directives.some(isVShowDirective)) {
	      child.data.show = true;
	    }

	    if (
	      oldChild &&
	      oldChild.data &&
	      !isSameChild(child, oldChild) &&
	      !isAsyncPlaceholder(oldChild) &&
	      // #6687 component root is a comment node
	      !(oldChild.componentInstance && oldChild.componentInstance._vnode.isComment)
	    ) {
	      // replace old child transition data with fresh one
	      // important for dynamic transitions!
	      var oldData = oldChild.data.transition = extend({}, data);
	      // handle transition mode
	      if (mode === 'out-in') {
	        // return placeholder node and queue update when leave finishes
	        this._leaving = true;
	        mergeVNodeHook(oldData, 'afterLeave', function () {
	          this$1._leaving = false;
	          this$1.$forceUpdate();
	        });
	        return placeholder(h, rawChild)
	      } else if (mode === 'in-out') {
	        if (isAsyncPlaceholder(child)) {
	          return oldRawChild
	        }
	        var delayedLeave;
	        var performLeave = function () { delayedLeave(); };
	        mergeVNodeHook(data, 'afterEnter', performLeave);
	        mergeVNodeHook(data, 'enterCancelled', performLeave);
	        mergeVNodeHook(oldData, 'delayLeave', function (leave) { delayedLeave = leave; });
	      }
	    }

	    return rawChild
	  }
	};

	/*  */

	var props = extend({
	  tag: String,
	  moveClass: String
	}, transitionProps);

	delete props.mode;

	var TransitionGroup = {
	  props: props,

	  beforeMount: function beforeMount () {
	    var this$1 = this;

	    var update = this._update;
	    this._update = function (vnode, hydrating) {
	      var restoreActiveInstance = setActiveInstance(this$1);
	      // force removing pass
	      this$1.__patch__(
	        this$1._vnode,
	        this$1.kept,
	        false, // hydrating
	        true // removeOnly (!important, avoids unnecessary moves)
	      );
	      this$1._vnode = this$1.kept;
	      restoreActiveInstance();
	      update.call(this$1, vnode, hydrating);
	    };
	  },

	  render: function render (h) {
	    var tag = this.tag || this.$vnode.data.tag || 'span';
	    var map = Object.create(null);
	    var prevChildren = this.prevChildren = this.children;
	    var rawChildren = this.$slots.default || [];
	    var children = this.children = [];
	    var transitionData = extractTransitionData(this);

	    for (var i = 0; i < rawChildren.length; i++) {
	      var c = rawChildren[i];
	      if (c.tag) {
	        if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
	          children.push(c);
	          map[c.key] = c
	          ;(c.data || (c.data = {})).transition = transitionData;
	        }
	      }
	    }

	    if (prevChildren) {
	      var kept = [];
	      var removed = [];
	      for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
	        var c$1 = prevChildren[i$1];
	        c$1.data.transition = transitionData;
	        c$1.data.pos = c$1.elm.getBoundingClientRect();
	        if (map[c$1.key]) {
	          kept.push(c$1);
	        } else {
	          removed.push(c$1);
	        }
	      }
	      this.kept = h(tag, null, kept);
	      this.removed = removed;
	    }

	    return h(tag, null, children)
	  },

	  updated: function updated () {
	    var children = this.prevChildren;
	    var moveClass = this.moveClass || ((this.name || 'v') + '-move');
	    if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
	      return
	    }

	    // we divide the work into three loops to avoid mixing DOM reads and writes
	    // in each iteration - which helps prevent layout thrashing.
	    children.forEach(callPendingCbs);
	    children.forEach(recordPosition);
	    children.forEach(applyTranslation);

	    // force reflow to put everything in position
	    // assign to this to avoid being removed in tree-shaking
	    // $flow-disable-line
	    this._reflow = document.body.offsetHeight;

	    children.forEach(function (c) {
	      if (c.data.moved) {
	        var el = c.elm;
	        var s = el.style;
	        addTransitionClass(el, moveClass);
	        s.transform = s.WebkitTransform = s.transitionDuration = '';
	        el.addEventListener(transitionEndEvent, el._moveCb = function cb (e) {
	          if (e && e.target !== el) {
	            return
	          }
	          if (!e || /transform$/.test(e.propertyName)) {
	            el.removeEventListener(transitionEndEvent, cb);
	            el._moveCb = null;
	            removeTransitionClass(el, moveClass);
	          }
	        });
	      }
	    });
	  },

	  methods: {
	    hasMove: function hasMove (el, moveClass) {
	      /* istanbul ignore if */
	      if (!hasTransition) {
	        return false
	      }
	      /* istanbul ignore if */
	      if (this._hasMove) {
	        return this._hasMove
	      }
	      // Detect whether an element with the move class applied has
	      // CSS transitions. Since the element may be inside an entering
	      // transition at this very moment, we make a clone of it and remove
	      // all other transition classes applied to ensure only the move class
	      // is applied.
	      var clone = el.cloneNode();
	      if (el._transitionClasses) {
	        el._transitionClasses.forEach(function (cls) { removeClass(clone, cls); });
	      }
	      addClass(clone, moveClass);
	      clone.style.display = 'none';
	      this.$el.appendChild(clone);
	      var info = getTransitionInfo(clone);
	      this.$el.removeChild(clone);
	      return (this._hasMove = info.hasTransform)
	    }
	  }
	};

	function callPendingCbs (c) {
	  /* istanbul ignore if */
	  if (c.elm._moveCb) {
	    c.elm._moveCb();
	  }
	  /* istanbul ignore if */
	  if (c.elm._enterCb) {
	    c.elm._enterCb();
	  }
	}

	function recordPosition (c) {
	  c.data.newPos = c.elm.getBoundingClientRect();
	}

	function applyTranslation (c) {
	  var oldPos = c.data.pos;
	  var newPos = c.data.newPos;
	  var dx = oldPos.left - newPos.left;
	  var dy = oldPos.top - newPos.top;
	  if (dx || dy) {
	    c.data.moved = true;
	    var s = c.elm.style;
	    s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
	    s.transitionDuration = '0s';
	  }
	}

	var platformComponents = {
	  Transition: Transition,
	  TransitionGroup: TransitionGroup
	};

	/*  */

	// install platform specific utils
	Vue.config.mustUseProp = mustUseProp;
	Vue.config.isReservedTag = isReservedTag;
	Vue.config.isReservedAttr = isReservedAttr;
	Vue.config.getTagNamespace = getTagNamespace;
	Vue.config.isUnknownElement = isUnknownElement;

	// install platform runtime directives & components
	extend(Vue.options.directives, platformDirectives);
	extend(Vue.options.components, platformComponents);

	// install platform patch function
	Vue.prototype.__patch__ = inBrowser ? patch : noop;

	// public mount method
	Vue.prototype.$mount = function (
	  el,
	  hydrating
	) {
	  el = el && inBrowser ? query(el) : undefined;
	  return mountComponent(this, el, hydrating)
	};

	// devtools global hook
	/* istanbul ignore next */
	if (inBrowser) {
	  setTimeout(function () {
	    if (config.devtools) {
	      if (devtools) {
	        devtools.emit('init', Vue);
	      }
	    }
	  }, 0);
	}

	/**
	 * SSR Window 1.0.1
	 * Better handling for window object in SSR environment
	 * https://github.com/nolimits4web/ssr-window
	 *
	 * Copyright 2018, Vladimir Kharlampidi
	 *
	 * Licensed under MIT
	 *
	 * Released on: July 18, 2018
	 */
	var doc = (typeof document === 'undefined') ? {
	  body: {},
	  addEventListener: function addEventListener() {},
	  removeEventListener: function removeEventListener() {},
	  activeElement: {
	    blur: function blur() {},
	    nodeName: '',
	  },
	  querySelector: function querySelector() {
	    return null;
	  },
	  querySelectorAll: function querySelectorAll() {
	    return [];
	  },
	  getElementById: function getElementById() {
	    return null;
	  },
	  createEvent: function createEvent() {
	    return {
	      initEvent: function initEvent() {},
	    };
	  },
	  createElement: function createElement() {
	    return {
	      children: [],
	      childNodes: [],
	      style: {},
	      setAttribute: function setAttribute() {},
	      getElementsByTagName: function getElementsByTagName() {
	        return [];
	      },
	    };
	  },
	  location: { hash: '' },
	} : document; // eslint-disable-line

	var win = (typeof window === 'undefined') ? {
	  document: doc,
	  navigator: {
	    userAgent: '',
	  },
	  location: {},
	  history: {},
	  CustomEvent: function CustomEvent() {
	    return this;
	  },
	  addEventListener: function addEventListener() {},
	  removeEventListener: function removeEventListener() {},
	  getComputedStyle: function getComputedStyle() {
	    return {
	      getPropertyValue: function getPropertyValue() {
	        return '';
	      },
	    };
	  },
	  Image: function Image() {},
	  Date: function Date() {},
	  screen: {},
	  setTimeout: function setTimeout() {},
	  clearTimeout: function clearTimeout() {},
	} : window; // eslint-disable-line

	/**
	 * Dom7 2.0.6
	 * Minimalistic JavaScript library for DOM manipulation, with a jQuery-compatible API
	 * http://framework7.io/docs/dom.html
	 *
	 * Copyright 2018, Vladimir Kharlampidi
	 * The iDangero.us
	 * http://www.idangero.us/
	 *
	 * Licensed under MIT
	 *
	 * Released on: May 27, 2018
	 */

	var Dom7 = function Dom7(arr) {
	  var self = this;
	  // Create array-like object
	  for (var i = 0; i < arr.length; i += 1) {
	    self[i] = arr[i];
	  }
	  self.length = arr.length;
	  // Return collection with methods
	  return this;
	};

	function $$1(selector, context) {
	  var arr = [];
	  var i = 0;
	  if (selector && !context) {
	    if (selector instanceof Dom7) {
	      return selector;
	    }
	  }
	  if (selector) {
	      // String
	    if (typeof selector === 'string') {
	      var els;
	      var tempParent;
	      var html = selector.trim();
	      if (html.indexOf('<') >= 0 && html.indexOf('>') >= 0) {
	        var toCreate = 'div';
	        if (html.indexOf('<li') === 0) { toCreate = 'ul'; }
	        if (html.indexOf('<tr') === 0) { toCreate = 'tbody'; }
	        if (html.indexOf('<td') === 0 || html.indexOf('<th') === 0) { toCreate = 'tr'; }
	        if (html.indexOf('<tbody') === 0) { toCreate = 'table'; }
	        if (html.indexOf('<option') === 0) { toCreate = 'select'; }
	        tempParent = doc.createElement(toCreate);
	        tempParent.innerHTML = html;
	        for (i = 0; i < tempParent.childNodes.length; i += 1) {
	          arr.push(tempParent.childNodes[i]);
	        }
	      } else {
	        if (!context && selector[0] === '#' && !selector.match(/[ .<>:~]/)) {
	          // Pure ID selector
	          els = [doc.getElementById(selector.trim().split('#')[1])];
	        } else {
	          // Other selectors
	          els = (context || doc).querySelectorAll(selector.trim());
	        }
	        for (i = 0; i < els.length; i += 1) {
	          if (els[i]) { arr.push(els[i]); }
	        }
	      }
	    } else if (selector.nodeType || selector === win || selector === doc) {
	      // Node/element
	      arr.push(selector);
	    } else if (selector.length > 0 && selector[0].nodeType) {
	      // Array of elements or instance of Dom
	      for (i = 0; i < selector.length; i += 1) {
	        arr.push(selector[i]);
	      }
	    }
	  }
	  return new Dom7(arr);
	}

	$$1.fn = Dom7.prototype;
	$$1.Class = Dom7;
	$$1.Dom7 = Dom7;

	function unique(arr) {
	  var uniqueArray = [];
	  for (var i = 0; i < arr.length; i += 1) {
	    if (uniqueArray.indexOf(arr[i]) === -1) { uniqueArray.push(arr[i]); }
	  }
	  return uniqueArray;
	}
	function toCamelCase(string) {
	  return string.toLowerCase().replace(/-(.)/g, function (match, group1) { return group1.toUpperCase(); });
	}

	function requestAnimationFrame(callback) {
	  if (win.requestAnimationFrame) { return win.requestAnimationFrame(callback); }
	  else if (win.webkitRequestAnimationFrame) { return win.webkitRequestAnimationFrame(callback); }
	  return win.setTimeout(callback, 1000 / 60);
	}
	function cancelAnimationFrame(id) {
	  if (win.cancelAnimationFrame) { return win.cancelAnimationFrame(id); }
	  else if (win.webkitCancelAnimationFrame) { return win.webkitCancelAnimationFrame(id); }
	  return win.clearTimeout(id);
	}

	// Classes and attributes
	function addClass$1(className) {
	  var this$1 = this;

	  if (typeof className === 'undefined') {
	    return this;
	  }
	  var classes = className.split(' ');
	  for (var i = 0; i < classes.length; i += 1) {
	    for (var j = 0; j < this.length; j += 1) {
	      if (typeof this$1[j].classList !== 'undefined') { this$1[j].classList.add(classes[i]); }
	    }
	  }
	  return this;
	}
	function removeClass$1(className) {
	  var this$1 = this;

	  var classes = className.split(' ');
	  for (var i = 0; i < classes.length; i += 1) {
	    for (var j = 0; j < this.length; j += 1) {
	      if (typeof this$1[j].classList !== 'undefined') { this$1[j].classList.remove(classes[i]); }
	    }
	  }
	  return this;
	}
	function hasClass(className) {
	  if (!this[0]) { return false; }
	  return this[0].classList.contains(className);
	}
	function toggleClass(className) {
	  var this$1 = this;

	  var classes = className.split(' ');
	  for (var i = 0; i < classes.length; i += 1) {
	    for (var j = 0; j < this.length; j += 1) {
	      if (typeof this$1[j].classList !== 'undefined') { this$1[j].classList.toggle(classes[i]); }
	    }
	  }
	  return this;
	}
	function attr(attrs, value) {
	  var arguments$1 = arguments;
	  var this$1 = this;

	  if (arguments.length === 1 && typeof attrs === 'string') {
	    // Get attr
	    if (this[0]) { return this[0].getAttribute(attrs); }
	    return undefined;
	  }

	  // Set attrs
	  for (var i = 0; i < this.length; i += 1) {
	    if (arguments$1.length === 2) {
	      // String
	      this$1[i].setAttribute(attrs, value);
	    } else {
	      // Object
	      // eslint-disable-next-line
	      for (var attrName in attrs) {
	        this$1[i][attrName] = attrs[attrName];
	        this$1[i].setAttribute(attrName, attrs[attrName]);
	      }
	    }
	  }
	  return this;
	}
	// eslint-disable-next-line
	function removeAttr(attr) {
	  var this$1 = this;

	  for (var i = 0; i < this.length; i += 1) {
	    this$1[i].removeAttribute(attr);
	  }
	  return this;
	}
	// eslint-disable-next-line
	function prop(props, value) {
	  var arguments$1 = arguments;
	  var this$1 = this;

	  if (arguments.length === 1 && typeof props === 'string') {
	    // Get prop
	    if (this[0]) { return this[0][props]; }
	  } else {
	    // Set props
	    for (var i = 0; i < this.length; i += 1) {
	      if (arguments$1.length === 2) {
	        // String
	        this$1[i][props] = value;
	      } else {
	        // Object
	        // eslint-disable-next-line
	        for (var propName in props) {
	          this$1[i][propName] = props[propName];
	        }
	      }
	    }
	    return this;
	  }
	}
	function data(key, value) {
	  var this$1 = this;

	  var el;
	  if (typeof value === 'undefined') {
	    el = this[0];
	    // Get value
	    if (el) {
	      if (el.dom7ElementDataStorage && (key in el.dom7ElementDataStorage)) {
	        return el.dom7ElementDataStorage[key];
	      }

	      var dataKey = el.getAttribute(("data-" + key));
	      if (dataKey) {
	        return dataKey;
	      }
	      return undefined;
	    }
	    return undefined;
	  }

	  // Set value
	  for (var i = 0; i < this.length; i += 1) {
	    el = this$1[i];
	    if (!el.dom7ElementDataStorage) { el.dom7ElementDataStorage = {}; }
	    el.dom7ElementDataStorage[key] = value;
	  }
	  return this;
	}
	function removeData(key) {
	  var this$1 = this;

	  for (var i = 0; i < this.length; i += 1) {
	    var el = this$1[i];
	    if (el.dom7ElementDataStorage && el.dom7ElementDataStorage[key]) {
	      el.dom7ElementDataStorage[key] = null;
	      delete el.dom7ElementDataStorage[key];
	    }
	  }
	}
	function dataset() {
	  var el = this[0];
	  if (!el) { return undefined; }
	  var dataset = {}; // eslint-disable-line
	  if (el.dataset) {
	    // eslint-disable-next-line
	    for (var dataKey in el.dataset) {
	      dataset[dataKey] = el.dataset[dataKey];
	    }
	  } else {
	    for (var i = 0; i < el.attributes.length; i += 1) {
	      // eslint-disable-next-line
	      var attr = el.attributes[i];
	      if (attr.name.indexOf('data-') >= 0) {
	        dataset[toCamelCase(attr.name.split('data-')[1])] = attr.value;
	      }
	    }
	  }
	  // eslint-disable-next-line
	  for (var key in dataset) {
	    if (dataset[key] === 'false') { dataset[key] = false; }
	    else if (dataset[key] === 'true') { dataset[key] = true; }
	    else if (parseFloat(dataset[key]) === dataset[key] * 1) { dataset[key] *= 1; }
	  }
	  return dataset;
	}
	function val(value) {
	  var dom = this;
	  if (typeof value === 'undefined') {
	    if (dom[0]) {
	      if (dom[0].multiple && dom[0].nodeName.toLowerCase() === 'select') {
	        var values = [];
	        for (var i = 0; i < dom[0].selectedOptions.length; i += 1) {
	          values.push(dom[0].selectedOptions[i].value);
	        }
	        return values;
	      }
	      return dom[0].value;
	    }
	    return undefined;
	  }

	  for (var i$1 = 0; i$1 < dom.length; i$1 += 1) {
	    var el = dom[i$1];
	    if (Array.isArray(value) && el.multiple && el.nodeName.toLowerCase() === 'select') {
	      for (var j = 0; j < el.options.length; j += 1) {
	        el.options[j].selected = value.indexOf(el.options[j].value) >= 0;
	      }
	    } else {
	      el.value = value;
	    }
	  }
	  return dom;
	}
	// Transforms
	// eslint-disable-next-line
	function transform(transform) {
	  var this$1 = this;

	  for (var i = 0; i < this.length; i += 1) {
	    var elStyle = this$1[i].style;
	    elStyle.webkitTransform = transform;
	    elStyle.transform = transform;
	  }
	  return this;
	}
	function transition$1(duration) {
	  var this$1 = this;

	  if (typeof duration !== 'string') {
	    duration = duration + "ms"; // eslint-disable-line
	  }
	  for (var i = 0; i < this.length; i += 1) {
	    var elStyle = this$1[i].style;
	    elStyle.webkitTransitionDuration = duration;
	    elStyle.transitionDuration = duration;
	  }
	  return this;
	}
	// Events
	function on() {
	  var this$1 = this;
	  var args = [], len = arguments.length;
	  while ( len-- ) args[ len ] = arguments[ len ];

	  var eventType = args[0];
	  var targetSelector = args[1];
	  var listener = args[2];
	  var capture = args[3];
	  if (typeof args[1] === 'function') {
	    var assign;
	    (assign = args, eventType = assign[0], listener = assign[1], capture = assign[2]);
	    targetSelector = undefined;
	  }
	  if (!capture) { capture = false; }

	  function handleLiveEvent(e) {
	    var target = e.target;
	    if (!target) { return; }
	    var eventData = e.target.dom7EventData || [];
	    if (eventData.indexOf(e) < 0) {
	      eventData.unshift(e);
	    }
	    if ($$1(target).is(targetSelector)) { listener.apply(target, eventData); }
	    else {
	      var parents = $$1(target).parents(); // eslint-disable-line
	      for (var k = 0; k < parents.length; k += 1) {
	        if ($$1(parents[k]).is(targetSelector)) { listener.apply(parents[k], eventData); }
	      }
	    }
	  }
	  function handleEvent(e) {
	    var eventData = e && e.target ? e.target.dom7EventData || [] : [];
	    if (eventData.indexOf(e) < 0) {
	      eventData.unshift(e);
	    }
	    listener.apply(this, eventData);
	  }
	  var events = eventType.split(' ');
	  var j;
	  for (var i = 0; i < this.length; i += 1) {
	    var el = this$1[i];
	    if (!targetSelector) {
	      for (j = 0; j < events.length; j += 1) {
	        var event = events[j];
	        if (!el.dom7Listeners) { el.dom7Listeners = {}; }
	        if (!el.dom7Listeners[event]) { el.dom7Listeners[event] = []; }
	        el.dom7Listeners[event].push({
	          listener: listener,
	          proxyListener: handleEvent,
	        });
	        el.addEventListener(event, handleEvent, capture);
	      }
	    } else {
	      // Live events
	      for (j = 0; j < events.length; j += 1) {
	        var event$1 = events[j];
	        if (!el.dom7LiveListeners) { el.dom7LiveListeners = {}; }
	        if (!el.dom7LiveListeners[event$1]) { el.dom7LiveListeners[event$1] = []; }
	        el.dom7LiveListeners[event$1].push({
	          listener: listener,
	          proxyListener: handleLiveEvent,
	        });
	        el.addEventListener(event$1, handleLiveEvent, capture);
	      }
	    }
	  }
	  return this;
	}
	function off() {
	  var this$1 = this;
	  var args = [], len = arguments.length;
	  while ( len-- ) args[ len ] = arguments[ len ];

	  var eventType = args[0];
	  var targetSelector = args[1];
	  var listener = args[2];
	  var capture = args[3];
	  if (typeof args[1] === 'function') {
	    var assign;
	    (assign = args, eventType = assign[0], listener = assign[1], capture = assign[2]);
	    targetSelector = undefined;
	  }
	  if (!capture) { capture = false; }

	  var events = eventType.split(' ');
	  for (var i = 0; i < events.length; i += 1) {
	    var event = events[i];
	    for (var j = 0; j < this.length; j += 1) {
	      var el = this$1[j];
	      var handlers = (void 0);
	      if (!targetSelector && el.dom7Listeners) {
	        handlers = el.dom7Listeners[event];
	      } else if (targetSelector && el.dom7LiveListeners) {
	        handlers = el.dom7LiveListeners[event];
	      }
	      if (handlers && handlers.length) {
	        for (var k = handlers.length - 1; k >= 0; k -= 1) {
	          var handler = handlers[k];
	          if (listener && handler.listener === listener) {
	            el.removeEventListener(event, handler.proxyListener, capture);
	            handlers.splice(k, 1);
	          } else if (!listener) {
	            el.removeEventListener(event, handler.proxyListener, capture);
	            handlers.splice(k, 1);
	          }
	        }
	      }
	    }
	  }
	  return this;
	}
	function once$1() {
	  var args = [], len = arguments.length;
	  while ( len-- ) args[ len ] = arguments[ len ];

	  var dom = this;
	  var eventName = args[0];
	  var targetSelector = args[1];
	  var listener = args[2];
	  var capture = args[3];
	  if (typeof args[1] === 'function') {
	    var assign;
	    (assign = args, eventName = assign[0], listener = assign[1], capture = assign[2]);
	    targetSelector = undefined;
	  }
	  function proxy() {
	    var eventArgs = [], len = arguments.length;
	    while ( len-- ) eventArgs[ len ] = arguments[ len ];

	    listener.apply(this, eventArgs);
	    dom.off(eventName, targetSelector, proxy, capture);
	  }
	  return dom.on(eventName, targetSelector, proxy, capture);
	}
	function trigger$1() {
	  var this$1 = this;
	  var args = [], len = arguments.length;
	  while ( len-- ) args[ len ] = arguments[ len ];

	  var events = args[0].split(' ');
	  var eventData = args[1];
	  for (var i = 0; i < events.length; i += 1) {
	    var event = events[i];
	    for (var j = 0; j < this.length; j += 1) {
	      var el = this$1[j];
	      var evt = (void 0);
	      try {
	        evt = new win.CustomEvent(event, {
	          detail: eventData,
	          bubbles: true,
	          cancelable: true,
	        });
	      } catch (e) {
	        evt = doc.createEvent('Event');
	        evt.initEvent(event, true, true);
	        evt.detail = eventData;
	      }
	      // eslint-disable-next-line
	      el.dom7EventData = args.filter(function (data, dataIndex) { return dataIndex > 0; });
	      el.dispatchEvent(evt);
	      el.dom7EventData = [];
	      delete el.dom7EventData;
	    }
	  }
	  return this;
	}
	function transitionEnd(callback) {
	  var events = ['webkitTransitionEnd', 'transitionend'];
	  var dom = this;
	  var i;
	  function fireCallBack(e) {
	    /* jshint validthis:true */
	    if (e.target !== this) { return; }
	    callback.call(this, e);
	    for (i = 0; i < events.length; i += 1) {
	      dom.off(events[i], fireCallBack);
	    }
	  }
	  if (callback) {
	    for (i = 0; i < events.length; i += 1) {
	      dom.on(events[i], fireCallBack);
	    }
	  }
	  return this;
	}
	function animationEnd(callback) {
	  var events = ['webkitAnimationEnd', 'animationend'];
	  var dom = this;
	  var i;
	  function fireCallBack(e) {
	    if (e.target !== this) { return; }
	    callback.call(this, e);
	    for (i = 0; i < events.length; i += 1) {
	      dom.off(events[i], fireCallBack);
	    }
	  }
	  if (callback) {
	    for (i = 0; i < events.length; i += 1) {
	      dom.on(events[i], fireCallBack);
	    }
	  }
	  return this;
	}
	// Sizing/Styles
	function width() {
	  if (this[0] === win) {
	    return win.innerWidth;
	  }

	  if (this.length > 0) {
	    return parseFloat(this.css('width'));
	  }

	  return null;
	}
	function outerWidth(includeMargins) {
	  if (this.length > 0) {
	    if (includeMargins) {
	      // eslint-disable-next-line
	      var styles = this.styles();
	      return this[0].offsetWidth + parseFloat(styles.getPropertyValue('margin-right')) + parseFloat(styles.getPropertyValue('margin-left'));
	    }
	    return this[0].offsetWidth;
	  }
	  return null;
	}
	function height() {
	  if (this[0] === win) {
	    return win.innerHeight;
	  }

	  if (this.length > 0) {
	    return parseFloat(this.css('height'));
	  }

	  return null;
	}
	function outerHeight(includeMargins) {
	  if (this.length > 0) {
	    if (includeMargins) {
	      // eslint-disable-next-line
	      var styles = this.styles();
	      return this[0].offsetHeight + parseFloat(styles.getPropertyValue('margin-top')) + parseFloat(styles.getPropertyValue('margin-bottom'));
	    }
	    return this[0].offsetHeight;
	  }
	  return null;
	}
	function offset() {
	  if (this.length > 0) {
	    var el = this[0];
	    var box = el.getBoundingClientRect();
	    var body = doc.body;
	    var clientTop = el.clientTop || body.clientTop || 0;
	    var clientLeft = el.clientLeft || body.clientLeft || 0;
	    var scrollTop = el === win ? win.scrollY : el.scrollTop;
	    var scrollLeft = el === win ? win.scrollX : el.scrollLeft;
	    return {
	      top: (box.top + scrollTop) - clientTop,
	      left: (box.left + scrollLeft) - clientLeft,
	    };
	  }

	  return null;
	}
	function hide() {
	  var this$1 = this;

	  for (var i = 0; i < this.length; i += 1) {
	    this$1[i].style.display = 'none';
	  }
	  return this;
	}
	function show$1() {
	  var this$1 = this;

	  for (var i = 0; i < this.length; i += 1) {
	    var el = this$1[i];
	    if (el.style.display === 'none') {
	      el.style.display = '';
	    }
	    if (win.getComputedStyle(el, null).getPropertyValue('display') === 'none') {
	      // Still not visible
	      el.style.display = 'block';
	    }
	  }
	  return this;
	}
	function styles() {
	  if (this[0]) { return win.getComputedStyle(this[0], null); }
	  return {};
	}
	function css(props, value) {
	  var this$1 = this;

	  var i;
	  if (arguments.length === 1) {
	    if (typeof props === 'string') {
	      if (this[0]) { return win.getComputedStyle(this[0], null).getPropertyValue(props); }
	    } else {
	      for (i = 0; i < this.length; i += 1) {
	        // eslint-disable-next-line
	        for (var prop in props) {
	          this$1[i].style[prop] = props[prop];
	        }
	      }
	      return this;
	    }
	  }
	  if (arguments.length === 2 && typeof props === 'string') {
	    for (i = 0; i < this.length; i += 1) {
	      this$1[i].style[props] = value;
	    }
	    return this;
	  }
	  return this;
	}

	// Dom manipulation
	function toArray$1() {
	  var this$1 = this;

	  var arr = [];
	  for (var i = 0; i < this.length; i += 1) {
	    arr.push(this$1[i]);
	  }
	  return arr;
	}
	// Iterate over the collection passing elements to `callback`
	function each(callback) {
	  var this$1 = this;

	  // Don't bother continuing without a callback
	  if (!callback) { return this; }
	  // Iterate over the current collection
	  for (var i = 0; i < this.length; i += 1) {
	    // If the callback returns false
	    if (callback.call(this$1[i], i, this$1[i]) === false) {
	      // End the loop early
	      return this$1;
	    }
	  }
	  // Return `this` to allow chained DOM operations
	  return this;
	}
	function forEach(callback) {
	  var this$1 = this;

	  // Don't bother continuing without a callback
	  if (!callback) { return this; }
	  // Iterate over the current collection
	  for (var i = 0; i < this.length; i += 1) {
	    // If the callback returns false
	    if (callback.call(this$1[i], this$1[i], i) === false) {
	      // End the loop early
	      return this$1;
	    }
	  }
	  // Return `this` to allow chained DOM operations
	  return this;
	}
	function filter(callback) {
	  var matchedItems = [];
	  var dom = this;
	  for (var i = 0; i < dom.length; i += 1) {
	    if (callback.call(dom[i], i, dom[i])) { matchedItems.push(dom[i]); }
	  }
	  return new Dom7(matchedItems);
	}
	function map(callback) {
	  var modifiedItems = [];
	  var dom = this;
	  for (var i = 0; i < dom.length; i += 1) {
	    modifiedItems.push(callback.call(dom[i], i, dom[i]));
	  }
	  return new Dom7(modifiedItems);
	}
	// eslint-disable-next-line
	function html(html) {
	  var this$1 = this;

	  if (typeof html === 'undefined') {
	    return this[0] ? this[0].innerHTML : undefined;
	  }

	  for (var i = 0; i < this.length; i += 1) {
	    this$1[i].innerHTML = html;
	  }
	  return this;
	}
	// eslint-disable-next-line
	function text(text) {
	  var this$1 = this;

	  if (typeof text === 'undefined') {
	    if (this[0]) {
	      return this[0].textContent.trim();
	    }
	    return null;
	  }

	  for (var i = 0; i < this.length; i += 1) {
	    this$1[i].textContent = text;
	  }
	  return this;
	}
	function is(selector) {
	  var el = this[0];
	  var compareWith;
	  var i;
	  if (!el || typeof selector === 'undefined') { return false; }
	  if (typeof selector === 'string') {
	    if (el.matches) { return el.matches(selector); }
	    else if (el.webkitMatchesSelector) { return el.webkitMatchesSelector(selector); }
	    else if (el.msMatchesSelector) { return el.msMatchesSelector(selector); }

	    compareWith = $$1(selector);
	    for (i = 0; i < compareWith.length; i += 1) {
	      if (compareWith[i] === el) { return true; }
	    }
	    return false;
	  } else if (selector === doc) { return el === doc; }
	  else if (selector === win) { return el === win; }

	  if (selector.nodeType || selector instanceof Dom7) {
	    compareWith = selector.nodeType ? [selector] : selector;
	    for (i = 0; i < compareWith.length; i += 1) {
	      if (compareWith[i] === el) { return true; }
	    }
	    return false;
	  }
	  return false;
	}
	function indexOf(el) {
	  var this$1 = this;

	  for (var i = 0; i < this.length; i += 1) {
	    if (this$1[i] === el) { return i; }
	  }
	  return -1;
	}
	function index$1() {
	  var child = this[0];
	  var i;
	  if (child) {
	    i = 0;
	    // eslint-disable-next-line
	    while ((child = child.previousSibling) !== null) {
	      if (child.nodeType === 1) { i += 1; }
	    }
	    return i;
	  }
	  return undefined;
	}
	// eslint-disable-next-line
	function eq(index) {
	  if (typeof index === 'undefined') { return this; }
	  var length = this.length;
	  var returnIndex;
	  if (index > length - 1) {
	    return new Dom7([]);
	  }
	  if (index < 0) {
	    returnIndex = length + index;
	    if (returnIndex < 0) { return new Dom7([]); }
	    return new Dom7([this[returnIndex]]);
	  }
	  return new Dom7([this[index]]);
	}
	function append() {
	  var this$1 = this;
	  var args = [], len = arguments.length;
	  while ( len-- ) args[ len ] = arguments[ len ];

	  var newChild;

	  for (var k = 0; k < args.length; k += 1) {
	    newChild = args[k];
	    for (var i = 0; i < this.length; i += 1) {
	      if (typeof newChild === 'string') {
	        var tempDiv = doc.createElement('div');
	        tempDiv.innerHTML = newChild;
	        while (tempDiv.firstChild) {
	          this$1[i].appendChild(tempDiv.firstChild);
	        }
	      } else if (newChild instanceof Dom7) {
	        for (var j = 0; j < newChild.length; j += 1) {
	          this$1[i].appendChild(newChild[j]);
	        }
	      } else {
	        this$1[i].appendChild(newChild);
	      }
	    }
	  }

	  return this;
	}
	 // eslint-disable-next-line
	function appendTo(parent) {
	  $$1(parent).append(this);
	  return this;
	}
	function prepend(newChild) {
	  var this$1 = this;

	  var i;
	  var j;
	  for (i = 0; i < this.length; i += 1) {
	    if (typeof newChild === 'string') {
	      var tempDiv = doc.createElement('div');
	      tempDiv.innerHTML = newChild;
	      for (j = tempDiv.childNodes.length - 1; j >= 0; j -= 1) {
	        this$1[i].insertBefore(tempDiv.childNodes[j], this$1[i].childNodes[0]);
	      }
	    } else if (newChild instanceof Dom7) {
	      for (j = 0; j < newChild.length; j += 1) {
	        this$1[i].insertBefore(newChild[j], this$1[i].childNodes[0]);
	      }
	    } else {
	      this$1[i].insertBefore(newChild, this$1[i].childNodes[0]);
	    }
	  }
	  return this;
	}
	 // eslint-disable-next-line
	function prependTo(parent) {
	  $$1(parent).prepend(this);
	  return this;
	}
	function insertBefore$1(selector) {
	  var this$1 = this;

	  var before = $$1(selector);
	  for (var i = 0; i < this.length; i += 1) {
	    if (before.length === 1) {
	      before[0].parentNode.insertBefore(this$1[i], before[0]);
	    } else if (before.length > 1) {
	      for (var j = 0; j < before.length; j += 1) {
	        before[j].parentNode.insertBefore(this$1[i].cloneNode(true), before[j]);
	      }
	    }
	  }
	}
	function insertAfter(selector) {
	  var this$1 = this;

	  var after = $$1(selector);
	  for (var i = 0; i < this.length; i += 1) {
	    if (after.length === 1) {
	      after[0].parentNode.insertBefore(this$1[i], after[0].nextSibling);
	    } else if (after.length > 1) {
	      for (var j = 0; j < after.length; j += 1) {
	        after[j].parentNode.insertBefore(this$1[i].cloneNode(true), after[j].nextSibling);
	      }
	    }
	  }
	}
	function next(selector) {
	  if (this.length > 0) {
	    if (selector) {
	      if (this[0].nextElementSibling && $$1(this[0].nextElementSibling).is(selector)) {
	        return new Dom7([this[0].nextElementSibling]);
	      }
	      return new Dom7([]);
	    }

	    if (this[0].nextElementSibling) { return new Dom7([this[0].nextElementSibling]); }
	    return new Dom7([]);
	  }
	  return new Dom7([]);
	}
	function nextAll(selector) {
	  var nextEls = [];
	  var el = this[0];
	  if (!el) { return new Dom7([]); }
	  while (el.nextElementSibling) {
	    var next = el.nextElementSibling; // eslint-disable-line
	    if (selector) {
	      if ($$1(next).is(selector)) { nextEls.push(next); }
	    } else { nextEls.push(next); }
	    el = next;
	  }
	  return new Dom7(nextEls);
	}
	function prev(selector) {
	  if (this.length > 0) {
	    var el = this[0];
	    if (selector) {
	      if (el.previousElementSibling && $$1(el.previousElementSibling).is(selector)) {
	        return new Dom7([el.previousElementSibling]);
	      }
	      return new Dom7([]);
	    }

	    if (el.previousElementSibling) { return new Dom7([el.previousElementSibling]); }
	    return new Dom7([]);
	  }
	  return new Dom7([]);
	}
	function prevAll(selector) {
	  var prevEls = [];
	  var el = this[0];
	  if (!el) { return new Dom7([]); }
	  while (el.previousElementSibling) {
	    var prev = el.previousElementSibling; // eslint-disable-line
	    if (selector) {
	      if ($$1(prev).is(selector)) { prevEls.push(prev); }
	    } else { prevEls.push(prev); }
	    el = prev;
	  }
	  return new Dom7(prevEls);
	}
	function siblings(selector) {
	  return this.nextAll(selector).add(this.prevAll(selector));
	}
	function parent(selector) {
	  var this$1 = this;

	  var parents = []; // eslint-disable-line
	  for (var i = 0; i < this.length; i += 1) {
	    if (this$1[i].parentNode !== null) {
	      if (selector) {
	        if ($$1(this$1[i].parentNode).is(selector)) { parents.push(this$1[i].parentNode); }
	      } else {
	        parents.push(this$1[i].parentNode);
	      }
	    }
	  }
	  return $$1(unique(parents));
	}
	function parents(selector) {
	  var this$1 = this;

	  var parents = []; // eslint-disable-line
	  for (var i = 0; i < this.length; i += 1) {
	    var parent = this$1[i].parentNode; // eslint-disable-line
	    while (parent) {
	      if (selector) {
	        if ($$1(parent).is(selector)) { parents.push(parent); }
	      } else {
	        parents.push(parent);
	      }
	      parent = parent.parentNode;
	    }
	  }
	  return $$1(unique(parents));
	}
	function closest(selector) {
	  var closest = this; // eslint-disable-line
	  if (typeof selector === 'undefined') {
	    return new Dom7([]);
	  }
	  if (!closest.is(selector)) {
	    closest = closest.parents(selector).eq(0);
	  }
	  return closest;
	}
	function find(selector) {
	  var this$1 = this;

	  var foundElements = [];
	  for (var i = 0; i < this.length; i += 1) {
	    var found = this$1[i].querySelectorAll(selector);
	    for (var j = 0; j < found.length; j += 1) {
	      foundElements.push(found[j]);
	    }
	  }
	  return new Dom7(foundElements);
	}
	function children(selector) {
	  var this$1 = this;

	  var children = []; // eslint-disable-line
	  for (var i = 0; i < this.length; i += 1) {
	    var childNodes = this$1[i].childNodes;

	    for (var j = 0; j < childNodes.length; j += 1) {
	      if (!selector) {
	        if (childNodes[j].nodeType === 1) { children.push(childNodes[j]); }
	      } else if (childNodes[j].nodeType === 1 && $$1(childNodes[j]).is(selector)) {
	        children.push(childNodes[j]);
	      }
	    }
	  }
	  return new Dom7(unique(children));
	}
	function remove$3() {
	  var this$1 = this;

	  for (var i = 0; i < this.length; i += 1) {
	    if (this$1[i].parentNode) { this$1[i].parentNode.removeChild(this$1[i]); }
	  }
	  return this;
	}
	function detach() {
	  return this.remove();
	}
	function add$2() {
	  var args = [], len = arguments.length;
	  while ( len-- ) args[ len ] = arguments[ len ];

	  var dom = this;
	  var i;
	  var j;
	  for (i = 0; i < args.length; i += 1) {
	    var toAdd = $$1(args[i]);
	    for (j = 0; j < toAdd.length; j += 1) {
	      dom[dom.length] = toAdd[j];
	      dom.length += 1;
	    }
	  }
	  return dom;
	}
	function empty() {
	  var this$1 = this;

	  for (var i = 0; i < this.length; i += 1) {
	    var el = this$1[i];
	    if (el.nodeType === 1) {
	      for (var j = 0; j < el.childNodes.length; j += 1) {
	        if (el.childNodes[j].parentNode) {
	          el.childNodes[j].parentNode.removeChild(el.childNodes[j]);
	        }
	      }
	      el.textContent = '';
	    }
	  }
	  return this;
	}




	var Methods = Object.freeze({
		addClass: addClass$1,
		removeClass: removeClass$1,
		hasClass: hasClass,
		toggleClass: toggleClass,
		attr: attr,
		removeAttr: removeAttr,
		prop: prop,
		data: data,
		removeData: removeData,
		dataset: dataset,
		val: val,
		transform: transform,
		transition: transition$1,
		on: on,
		off: off,
		once: once$1,
		trigger: trigger$1,
		transitionEnd: transitionEnd,
		animationEnd: animationEnd,
		width: width,
		outerWidth: outerWidth,
		height: height,
		outerHeight: outerHeight,
		offset: offset,
		hide: hide,
		show: show$1,
		styles: styles,
		css: css,
		toArray: toArray$1,
		each: each,
		forEach: forEach,
		filter: filter,
		map: map,
		html: html,
		text: text,
		is: is,
		indexOf: indexOf,
		index: index$1,
		eq: eq,
		append: append,
		appendTo: appendTo,
		prepend: prepend,
		prependTo: prependTo,
		insertBefore: insertBefore$1,
		insertAfter: insertAfter,
		next: next,
		nextAll: nextAll,
		prev: prev,
		prevAll: prevAll,
		siblings: siblings,
		parent: parent,
		parents: parents,
		closest: closest,
		find: find,
		children: children,
		remove: remove$3,
		detach: detach,
		add: add$2,
		empty: empty
	});

	function scrollTo() {
	  var args = [], len = arguments.length;
	  while ( len-- ) args[ len ] = arguments[ len ];

	  var left = args[0];
	  var top = args[1];
	  var duration = args[2];
	  var easing = args[3];
	  var callback = args[4];
	  if (args.length === 4 && typeof easing === 'function') {
	    callback = easing;
	    var assign;
	    (assign = args, left = assign[0], top = assign[1], duration = assign[2], callback = assign[3], easing = assign[4]);
	  }
	  if (typeof easing === 'undefined') { easing = 'swing'; }

	  return this.each(function animate() {
	    var el = this;
	    var currentTop;
	    var currentLeft;
	    var maxTop;
	    var maxLeft;
	    var newTop;
	    var newLeft;
	    var scrollTop; // eslint-disable-line
	    var scrollLeft; // eslint-disable-line
	    var animateTop = top > 0 || top === 0;
	    var animateLeft = left > 0 || left === 0;
	    if (typeof easing === 'undefined') {
	      easing = 'swing';
	    }
	    if (animateTop) {
	      currentTop = el.scrollTop;
	      if (!duration) {
	        el.scrollTop = top;
	      }
	    }
	    if (animateLeft) {
	      currentLeft = el.scrollLeft;
	      if (!duration) {
	        el.scrollLeft = left;
	      }
	    }
	    if (!duration) { return; }
	    if (animateTop) {
	      maxTop = el.scrollHeight - el.offsetHeight;
	      newTop = Math.max(Math.min(top, maxTop), 0);
	    }
	    if (animateLeft) {
	      maxLeft = el.scrollWidth - el.offsetWidth;
	      newLeft = Math.max(Math.min(left, maxLeft), 0);
	    }
	    var startTime = null;
	    if (animateTop && newTop === currentTop) { animateTop = false; }
	    if (animateLeft && newLeft === currentLeft) { animateLeft = false; }
	    function render(time) {
	      if ( time === void 0 ) time = new Date().getTime();

	      if (startTime === null) {
	        startTime = time;
	      }
	      var progress = Math.max(Math.min((time - startTime) / duration, 1), 0);
	      var easeProgress = easing === 'linear' ? progress : (0.5 - (Math.cos(progress * Math.PI) / 2));
	      var done;
	      if (animateTop) { scrollTop = currentTop + (easeProgress * (newTop - currentTop)); }
	      if (animateLeft) { scrollLeft = currentLeft + (easeProgress * (newLeft - currentLeft)); }
	      if (animateTop && newTop > currentTop && scrollTop >= newTop) {
	        el.scrollTop = newTop;
	        done = true;
	      }
	      if (animateTop && newTop < currentTop && scrollTop <= newTop) {
	        el.scrollTop = newTop;
	        done = true;
	      }
	      if (animateLeft && newLeft > currentLeft && scrollLeft >= newLeft) {
	        el.scrollLeft = newLeft;
	        done = true;
	      }
	      if (animateLeft && newLeft < currentLeft && scrollLeft <= newLeft) {
	        el.scrollLeft = newLeft;
	        done = true;
	      }

	      if (done) {
	        if (callback) { callback(); }
	        return;
	      }
	      if (animateTop) { el.scrollTop = scrollTop; }
	      if (animateLeft) { el.scrollLeft = scrollLeft; }
	      requestAnimationFrame(render);
	    }
	    requestAnimationFrame(render);
	  });
	}
	// scrollTop(top, duration, easing, callback) {
	function scrollTop() {
	  var args = [], len = arguments.length;
	  while ( len-- ) args[ len ] = arguments[ len ];

	  var top = args[0];
	  var duration = args[1];
	  var easing = args[2];
	  var callback = args[3];
	  if (args.length === 3 && typeof easing === 'function') {
	    var assign;
	    (assign = args, top = assign[0], duration = assign[1], callback = assign[2], easing = assign[3]);
	  }
	  var dom = this;
	  if (typeof top === 'undefined') {
	    if (dom.length > 0) { return dom[0].scrollTop; }
	    return null;
	  }
	  return dom.scrollTo(undefined, top, duration, easing, callback);
	}
	function scrollLeft() {
	  var args = [], len = arguments.length;
	  while ( len-- ) args[ len ] = arguments[ len ];

	  var left = args[0];
	  var duration = args[1];
	  var easing = args[2];
	  var callback = args[3];
	  if (args.length === 3 && typeof easing === 'function') {
	    var assign;
	    (assign = args, left = assign[0], duration = assign[1], callback = assign[2], easing = assign[3]);
	  }
	  var dom = this;
	  if (typeof left === 'undefined') {
	    if (dom.length > 0) { return dom[0].scrollLeft; }
	    return null;
	  }
	  return dom.scrollTo(left, undefined, duration, easing, callback);
	}




	var Scroll = Object.freeze({
		scrollTo: scrollTo,
		scrollTop: scrollTop,
		scrollLeft: scrollLeft
	});

	function animate(initialProps, initialParams) {
	  var els = this;
	  var a = {
	    props: Object.assign({}, initialProps),
	    params: Object.assign({
	      duration: 300,
	      easing: 'swing', // or 'linear'
	      /* Callbacks
	      begin(elements)
	      complete(elements)
	      progress(elements, complete, remaining, start, tweenValue)
	      */
	    }, initialParams),

	    elements: els,
	    animating: false,
	    que: [],

	    easingProgress: function easingProgress(easing, progress) {
	      if (easing === 'swing') {
	        return 0.5 - (Math.cos(progress * Math.PI) / 2);
	      }
	      if (typeof easing === 'function') {
	        return easing(progress);
	      }
	      return progress;
	    },
	    stop: function stop() {
	      if (a.frameId) {
	        cancelAnimationFrame(a.frameId);
	      }
	      a.animating = false;
	      a.elements.each(function (index, el) {
	        var element = el;
	        delete element.dom7AnimateInstance;
	      });
	      a.que = [];
	    },
	    done: function done(complete) {
	      a.animating = false;
	      a.elements.each(function (index, el) {
	        var element = el;
	        delete element.dom7AnimateInstance;
	      });
	      if (complete) { complete(els); }
	      if (a.que.length > 0) {
	        var que = a.que.shift();
	        a.animate(que[0], que[1]);
	      }
	    },
	    animate: function animate(props, params) {
	      if (a.animating) {
	        a.que.push([props, params]);
	        return a;
	      }
	      var elements = [];

	      // Define & Cache Initials & Units
	      a.elements.each(function (index, el) {
	        var initialFullValue;
	        var initialValue;
	        var unit;
	        var finalValue;
	        var finalFullValue;

	        if (!el.dom7AnimateInstance) { a.elements[index].dom7AnimateInstance = a; }

	        elements[index] = {
	          container: el,
	        };
	        Object.keys(props).forEach(function (prop) {
	          initialFullValue = win.getComputedStyle(el, null).getPropertyValue(prop).replace(',', '.');
	          initialValue = parseFloat(initialFullValue);
	          unit = initialFullValue.replace(initialValue, '');
	          finalValue = parseFloat(props[prop]);
	          finalFullValue = props[prop] + unit;
	          elements[index][prop] = {
	            initialFullValue: initialFullValue,
	            initialValue: initialValue,
	            unit: unit,
	            finalValue: finalValue,
	            finalFullValue: finalFullValue,
	            currentValue: initialValue,
	          };
	        });
	      });

	      var startTime = null;
	      var time;
	      var elementsDone = 0;
	      var propsDone = 0;
	      var done;
	      var began = false;

	      a.animating = true;

	      function render() {
	        time = new Date().getTime();
	        var progress;
	        var easeProgress;
	        // let el;
	        if (!began) {
	          began = true;
	          if (params.begin) { params.begin(els); }
	        }
	        if (startTime === null) {
	          startTime = time;
	        }
	        if (params.progress) {
	          // eslint-disable-next-line
	          params.progress(els, Math.max(Math.min((time - startTime) / params.duration, 1), 0), ((startTime + params.duration) - time < 0 ? 0 : (startTime + params.duration) - time), startTime);
	        }

	        elements.forEach(function (element) {
	          var el = element;
	          if (done || el.done) { return; }
	          Object.keys(props).forEach(function (prop) {
	            if (done || el.done) { return; }
	            progress = Math.max(Math.min((time - startTime) / params.duration, 1), 0);
	            easeProgress = a.easingProgress(params.easing, progress);
	            var ref = el[prop];
	            var initialValue = ref.initialValue;
	            var finalValue = ref.finalValue;
	            var unit = ref.unit;
	            el[prop].currentValue = initialValue + (easeProgress * (finalValue - initialValue));
	            var currentValue = el[prop].currentValue;

	            if (
	              (finalValue > initialValue && currentValue >= finalValue) ||
	              (finalValue < initialValue && currentValue <= finalValue)) {
	              el.container.style[prop] = finalValue + unit;
	              propsDone += 1;
	              if (propsDone === Object.keys(props).length) {
	                el.done = true;
	                elementsDone += 1;
	              }
	              if (elementsDone === elements.length) {
	                done = true;
	              }
	            }
	            if (done) {
	              a.done(params.complete);
	              return;
	            }
	            el.container.style[prop] = currentValue + unit;
	          });
	        });
	        if (done) { return; }
	        // Then call
	        a.frameId = requestAnimationFrame(render);
	      }
	      a.frameId = requestAnimationFrame(render);
	      return a;
	    },
	  };

	  if (a.elements.length === 0) {
	    return els;
	  }

	  var animateInstance;
	  for (var i = 0; i < a.elements.length; i += 1) {
	    if (a.elements[i].dom7AnimateInstance) {
	      animateInstance = a.elements[i].dom7AnimateInstance;
	    } else { a.elements[i].dom7AnimateInstance = a; }
	  }
	  if (!animateInstance) {
	    animateInstance = a;
	  }

	  if (initialProps === 'stop') {
	    animateInstance.stop();
	  } else {
	    animateInstance.animate(a.props, a.params);
	  }

	  return els;
	}

	function stop() {
	  var els = this;
	  for (var i = 0; i < els.length; i += 1) {
	    if (els[i].dom7AnimateInstance) {
	      els[i].dom7AnimateInstance.stop();
	    }
	  }
	}




	var Animate = Object.freeze({
		animate: animate,
		stop: stop
	});

	var noTrigger = ('resize scroll').split(' ');
	function eventShortcut(name) {
	  var this$1 = this;
	  var args = [], len = arguments.length - 1;
	  while ( len-- > 0 ) args[ len ] = arguments[ len + 1 ];

	  if (typeof args[0] === 'undefined') {
	    for (var i = 0; i < this.length; i += 1) {
	      if (noTrigger.indexOf(name) < 0) {
	        if (name in this$1[i]) { this$1[i][name](); }
	        else {
	          $$1(this$1[i]).trigger(name);
	        }
	      }
	    }
	    return this;
	  }
	  return (ref = this).on.apply(ref, [ name ].concat( args ));
	  var ref;
	}

	function click() {
	  var args = [], len = arguments.length;
	  while ( len-- ) args[ len ] = arguments[ len ];

	  return eventShortcut.bind(this).apply(void 0, [ 'click' ].concat( args ));
	}
	function blur() {
	  var args = [], len = arguments.length;
	  while ( len-- ) args[ len ] = arguments[ len ];

	  return eventShortcut.bind(this).apply(void 0, [ 'blur' ].concat( args ));
	}
	function focus() {
	  var args = [], len = arguments.length;
	  while ( len-- ) args[ len ] = arguments[ len ];

	  return eventShortcut.bind(this).apply(void 0, [ 'focus' ].concat( args ));
	}
	function focusin() {
	  var args = [], len = arguments.length;
	  while ( len-- ) args[ len ] = arguments[ len ];

	  return eventShortcut.bind(this).apply(void 0, [ 'focusin' ].concat( args ));
	}
	function focusout() {
	  var args = [], len = arguments.length;
	  while ( len-- ) args[ len ] = arguments[ len ];

	  return eventShortcut.bind(this).apply(void 0, [ 'focusout' ].concat( args ));
	}
	function keyup() {
	  var args = [], len = arguments.length;
	  while ( len-- ) args[ len ] = arguments[ len ];

	  return eventShortcut.bind(this).apply(void 0, [ 'keyup' ].concat( args ));
	}
	function keydown() {
	  var args = [], len = arguments.length;
	  while ( len-- ) args[ len ] = arguments[ len ];

	  return eventShortcut.bind(this).apply(void 0, [ 'keydown' ].concat( args ));
	}
	function keypress() {
	  var args = [], len = arguments.length;
	  while ( len-- ) args[ len ] = arguments[ len ];

	  return eventShortcut.bind(this).apply(void 0, [ 'keypress' ].concat( args ));
	}
	function submit() {
	  var args = [], len = arguments.length;
	  while ( len-- ) args[ len ] = arguments[ len ];

	  return eventShortcut.bind(this).apply(void 0, [ 'submit' ].concat( args ));
	}
	function change() {
	  var args = [], len = arguments.length;
	  while ( len-- ) args[ len ] = arguments[ len ];

	  return eventShortcut.bind(this).apply(void 0, [ 'change' ].concat( args ));
	}
	function mousedown() {
	  var args = [], len = arguments.length;
	  while ( len-- ) args[ len ] = arguments[ len ];

	  return eventShortcut.bind(this).apply(void 0, [ 'mousedown' ].concat( args ));
	}
	function mousemove() {
	  var args = [], len = arguments.length;
	  while ( len-- ) args[ len ] = arguments[ len ];

	  return eventShortcut.bind(this).apply(void 0, [ 'mousemove' ].concat( args ));
	}
	function mouseup() {
	  var args = [], len = arguments.length;
	  while ( len-- ) args[ len ] = arguments[ len ];

	  return eventShortcut.bind(this).apply(void 0, [ 'mouseup' ].concat( args ));
	}
	function mouseenter() {
	  var args = [], len = arguments.length;
	  while ( len-- ) args[ len ] = arguments[ len ];

	  return eventShortcut.bind(this).apply(void 0, [ 'mouseenter' ].concat( args ));
	}
	function mouseleave() {
	  var args = [], len = arguments.length;
	  while ( len-- ) args[ len ] = arguments[ len ];

	  return eventShortcut.bind(this).apply(void 0, [ 'mouseleave' ].concat( args ));
	}
	function mouseout() {
	  var args = [], len = arguments.length;
	  while ( len-- ) args[ len ] = arguments[ len ];

	  return eventShortcut.bind(this).apply(void 0, [ 'mouseout' ].concat( args ));
	}
	function mouseover() {
	  var args = [], len = arguments.length;
	  while ( len-- ) args[ len ] = arguments[ len ];

	  return eventShortcut.bind(this).apply(void 0, [ 'mouseover' ].concat( args ));
	}
	function touchstart() {
	  var args = [], len = arguments.length;
	  while ( len-- ) args[ len ] = arguments[ len ];

	  return eventShortcut.bind(this).apply(void 0, [ 'touchstart' ].concat( args ));
	}
	function touchend() {
	  var args = [], len = arguments.length;
	  while ( len-- ) args[ len ] = arguments[ len ];

	  return eventShortcut.bind(this).apply(void 0, [ 'touchend' ].concat( args ));
	}
	function touchmove() {
	  var args = [], len = arguments.length;
	  while ( len-- ) args[ len ] = arguments[ len ];

	  return eventShortcut.bind(this).apply(void 0, [ 'touchmove' ].concat( args ));
	}
	function resize() {
	  var args = [], len = arguments.length;
	  while ( len-- ) args[ len ] = arguments[ len ];

	  return eventShortcut.bind(this).apply(void 0, [ 'resize' ].concat( args ));
	}
	function scroll() {
	  var args = [], len = arguments.length;
	  while ( len-- ) args[ len ] = arguments[ len ];

	  return eventShortcut.bind(this).apply(void 0, [ 'scroll' ].concat( args ));
	}




	var eventShortcuts = Object.freeze({
		click: click,
		blur: blur,
		focus: focus,
		focusin: focusin,
		focusout: focusout,
		keyup: keyup,
		keydown: keydown,
		keypress: keypress,
		submit: submit,
		change: change,
		mousedown: mousedown,
		mousemove: mousemove,
		mouseup: mouseup,
		mouseenter: mouseenter,
		mouseleave: mouseleave,
		mouseout: mouseout,
		mouseover: mouseover,
		touchstart: touchstart,
		touchend: touchend,
		touchmove: touchmove,
		resize: resize,
		scroll: scroll
	});

	[Methods, Scroll, Animate, eventShortcuts].forEach(function (group) {
	  Object.keys(group).forEach(function (methodName) {
	    $$1.fn[methodName] = group[methodName];
	  });
	});

	var imageProvider = 'brief-api';
	var fileImageBaseUrl = 'https://app.letsbrief.com/api/v1/files';
	var avatarUrl = 'https://app.letsbrief.com/api/v1/media/avatar.png';
	var imgixImageBaseUrl = 'https://brief.imgix.net';

	function appendQuery(url, query) {
	  if (!query) { return url; }
	  var normalizedQuery = query[0] === '?' || query[0] === '&' ? query.substring(1) : query;
	  return ("" + url + (url.indexOf('?') === -1 ? '?' : '&') + normalizedQuery);
	}

	function isAbsoluteUrl(url) {
	  return url && (url.indexOf('http') === 0 || url.indexOf('/') === 0 || url.indexOf('data:') === 0);
	}

	function encodePathPart(value) {
	  return String(value).split('/').map(encodeURIComponent).join('/');
	}

	function imageUrl(fileOrName, query) {
	  if ( query === void 0 ) query = '';

	  var value = typeof fileOrName === 'object' && fileOrName
	    ? (fileOrName.avatarUrl || fileOrName.url || fileOrName.filename || fileOrName.fileId || fileOrName.id)
	    : fileOrName;

	  if (!value || value === 'avatar.png' || value === 'team_avatar.png')
	    { return appendQuery(avatarUrl, query); }
	  if (isAbsoluteUrl(value))
	    { return appendQuery(value, query); }

	  return appendQuery((fileImageBaseUrl + "/" + (encodePathPart(value)) + "/image"), query);
	}

	function documentUrl(fileOrName) {
	  var value = typeof fileOrName === 'object' && fileOrName
	    ? (fileOrName.url || fileOrName.filename || fileOrName.fileId || fileOrName.id)
	    : fileOrName;
	  if (!value) { return ''; }
	  if (isAbsoluteUrl(value)) { return value; }
	  return (fileImageBaseUrl + "/" + (encodePathPart(value)) + "/image");
	}

	function documentIconUrl(icon) {
	  if ( icon === void 0 ) icon = 'document';

	  var icons = {
	    document: 'data:image/svg+xml,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 viewBox=%220 0 96 120%22%3E%3Cpath fill=%22%23e9e9ee%22 d=%22M18 2h42l28 28v88H18z%22/%3E%3Cpath fill=%22%23c9c9d2%22 d=%22M60 2v28h28z%22/%3E%3Cpath fill=%22%237113ff%22 d=%22M28 70h40v8H28zm0 16h40v8H28z%22/%3E%3C/svg%3E',
	    play: 'data:image/svg+xml,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 viewBox=%220 0 96 96%22%3E%3Ccircle cx=%2248%22 cy=%2248%22 r=%2244%22 fill=%22%237113ff%22/%3E%3Cpath d=%22M39 29v38l31-19z%22 fill=%22white%22/%3E%3C/svg%3E',
	  };
	  return icons[icon] || icons.document;
	}

	var config$1 = {
	  domain: 'https://app.letsbrief.com/',
	  // domain: 'https://brief-prod-app-staging.azurewebsites.net/',
	  stripe: 'pk_live_LAqtbNACEzRYOuZDDVgZhyyo',
	  path: {
	    imageProvider: imageProvider,
	    image: (fileImageBaseUrl + "/"),
	    document: (fileImageBaseUrl + "/"),
	    avatar: avatarUrl,
	    imgixImage: (imgixImageBaseUrl + "/"),
	    imgixDocument: (imgixImageBaseUrl + "/"),
	    imageUrl: imageUrl,
	    documentUrl: documentUrl,
	    documentIconUrl: documentIconUrl,
	    websiteRoot: 'https://app.letsbrief.com',
	    // websiteRoot: 'https://brief-prod-app-staging.azurewebsites.net',
	  },
	};

	/**
	 * Template7 1.4.2
	 * Mobile-first HTML template engine
	 * 
	 * http://www.idangero.us/template7/
	 * 
	 * Copyright 2019, Vladimir Kharlampidi
	 * The iDangero.us
	 * http://www.idangero.us/
	 * 
	 * Licensed under MIT
	 * 
	 * Released on: June 14, 2019
	 */

	var t7ctx;
	if (typeof window !== 'undefined') {
	  t7ctx = window;
	} else if (typeof global !== 'undefined') {
	  t7ctx = global;
	} else {
	  t7ctx = undefined;
	}

	var Template7Context = t7ctx;

	var Template7Utils = {
	  quoteSingleRexExp: new RegExp('\'', 'g'),
	  quoteDoubleRexExp: new RegExp('"', 'g'),
	  isFunction: function isFunction(func) {
	    return typeof func === 'function';
	  },
	  escape: function escape(string) {
	    if ( string === void 0 ) string = '';

	    return string
	      .replace(/&/g, '&amp;')
	      .replace(/</g, '&lt;')
	      .replace(/>/g, '&gt;')
	      .replace(/"/g, '&quot;')
	      .replace(/'/g, '&#039;');
	  },
	  helperToSlices: function helperToSlices(string) {
	    var quoteDoubleRexExp = Template7Utils.quoteDoubleRexExp;
	    var quoteSingleRexExp = Template7Utils.quoteSingleRexExp;
	    var helperParts = string.replace(/[{}#}]/g, '').trim().split(' ');
	    var slices = [];
	    var shiftIndex;
	    var i;
	    var j;
	    for (i = 0; i < helperParts.length; i += 1) {
	      var part = helperParts[i];
	      var blockQuoteRegExp = (void 0);
	      var openingQuote = (void 0);
	      if (i === 0) { slices.push(part); }
	      else if (part.indexOf('"') === 0 || part.indexOf('\'') === 0) {
	        blockQuoteRegExp = part.indexOf('"') === 0 ? quoteDoubleRexExp : quoteSingleRexExp;
	        openingQuote = part.indexOf('"') === 0 ? '"' : '\'';
	        // Plain String
	        if (part.match(blockQuoteRegExp).length === 2) {
	          // One word string
	          slices.push(part);
	        } else {
	          // Find closed Index
	          shiftIndex = 0;
	          for (j = i + 1; j < helperParts.length; j += 1) {
	            part += " " + (helperParts[j]);
	            if (helperParts[j].indexOf(openingQuote) >= 0) {
	              shiftIndex = j;
	              slices.push(part);
	              break;
	            }
	          }
	          if (shiftIndex) { i = shiftIndex; }
	        }
	      } else if (part.indexOf('=') > 0) {
	        // Hash
	        var hashParts = part.split('=');
	        var hashName = hashParts[0];
	        var hashContent = hashParts[1];
	        if (!blockQuoteRegExp) {
	          blockQuoteRegExp = hashContent.indexOf('"') === 0 ? quoteDoubleRexExp : quoteSingleRexExp;
	          openingQuote = hashContent.indexOf('"') === 0 ? '"' : '\'';
	        }
	        if (hashContent.match(blockQuoteRegExp).length !== 2) {
	          shiftIndex = 0;
	          for (j = i + 1; j < helperParts.length; j += 1) {
	            hashContent += " " + (helperParts[j]);
	            if (helperParts[j].indexOf(openingQuote) >= 0) {
	              shiftIndex = j;
	              break;
	            }
	          }
	          if (shiftIndex) { i = shiftIndex; }
	        }
	        var hash = [hashName, hashContent.replace(blockQuoteRegExp, '')];
	        slices.push(hash);
	      } else {
	        // Plain variable
	        slices.push(part);
	      }
	    }
	    return slices;
	  },
	  stringToBlocks: function stringToBlocks(string) {
	    var blocks = [];
	    var i;
	    var j;
	    if (!string) { return []; }
	    var stringBlocks = string.split(/({{[^{^}]*}})/);
	    for (i = 0; i < stringBlocks.length; i += 1) {
	      var block = stringBlocks[i];
	      if (block === '') { continue; }
	      if (block.indexOf('{{') < 0) {
	        blocks.push({
	          type: 'plain',
	          content: block,
	        });
	      } else {
	        if (block.indexOf('{/') >= 0) {
	          continue;
	        }
	        block = block
	          .replace(/{{([#/])*([ ])*/, '{{$1')
	          .replace(/([ ])*}}/, '}}');
	        if (block.indexOf('{#') < 0 && block.indexOf(' ') < 0 && block.indexOf('else') < 0) {
	          // Simple variable
	          blocks.push({
	            type: 'variable',
	            contextName: block.replace(/[{}]/g, ''),
	          });
	          continue;
	        }
	        // Helpers
	        var helperSlices = Template7Utils.helperToSlices(block);
	        var helperName = helperSlices[0];
	        var isPartial = helperName === '>';
	        var helperContext = [];
	        var helperHash = {};
	        for (j = 1; j < helperSlices.length; j += 1) {
	          var slice = helperSlices[j];
	          if (Array.isArray(slice)) {
	            // Hash
	            helperHash[slice[0]] = slice[1] === 'false' ? false : slice[1];
	          } else {
	            helperContext.push(slice);
	          }
	        }

	        if (block.indexOf('{#') >= 0) {
	          // Condition/Helper
	          var helperContent = '';
	          var elseContent = '';
	          var toSkip = 0;
	          var shiftIndex = (void 0);
	          var foundClosed = false;
	          var foundElse = false;
	          var depth = 0;
	          for (j = i + 1; j < stringBlocks.length; j += 1) {
	            if (stringBlocks[j].indexOf('{{#') >= 0) {
	              depth += 1;
	            }
	            if (stringBlocks[j].indexOf('{{/') >= 0) {
	              depth -= 1;
	            }
	            if (stringBlocks[j].indexOf(("{{#" + helperName)) >= 0) {
	              helperContent += stringBlocks[j];
	              if (foundElse) { elseContent += stringBlocks[j]; }
	              toSkip += 1;
	            } else if (stringBlocks[j].indexOf(("{{/" + helperName)) >= 0) {
	              if (toSkip > 0) {
	                toSkip -= 1;
	                helperContent += stringBlocks[j];
	                if (foundElse) { elseContent += stringBlocks[j]; }
	              } else {
	                shiftIndex = j;
	                foundClosed = true;
	                break;
	              }
	            } else if (stringBlocks[j].indexOf('else') >= 0 && depth === 0) {
	              foundElse = true;
	            } else {
	              if (!foundElse) { helperContent += stringBlocks[j]; }
	              if (foundElse) { elseContent += stringBlocks[j]; }
	            }
	          }
	          if (foundClosed) {
	            if (shiftIndex) { i = shiftIndex; }
	            if (helperName === 'raw') {
	              blocks.push({
	                type: 'plain',
	                content: helperContent,
	              });
	            } else {
	              blocks.push({
	                type: 'helper',
	                helperName: helperName,
	                contextName: helperContext,
	                content: helperContent,
	                inverseContent: elseContent,
	                hash: helperHash,
	              });
	            }
	          }
	        } else if (block.indexOf(' ') > 0) {
	          if (isPartial) {
	            helperName = '_partial';
	            if (helperContext[0]) {
	              if (helperContext[0].indexOf('[') === 0) { helperContext[0] = helperContext[0].replace(/[[\]]/g, ''); }
	              else { helperContext[0] = "\"" + (helperContext[0].replace(/"|'/g, '')) + "\""; }
	            }
	          }
	          blocks.push({
	            type: 'helper',
	            helperName: helperName,
	            contextName: helperContext,
	            hash: helperHash,
	          });
	        }
	      }
	    }
	    return blocks;
	  },
	  parseJsVariable: function parseJsVariable(expression, replace, object) {
	    return expression.split(/([+ \-*/^()&=|<>!%:?])/g).reduce(function (arr, part) {
	      if (!part) {
	        return arr;
	      }
	      if (part.indexOf(replace) < 0) {
	        arr.push(part);
	        return arr;
	      }
	      if (!object) {
	        arr.push(JSON.stringify(''));
	        return arr;
	      }

	      var variable = object;
	      if (part.indexOf((replace + ".")) >= 0) {
	        part.split((replace + "."))[1].split('.').forEach(function (partName) {
	          if (partName in variable) { variable = variable[partName]; }
	          else { variable = undefined; }
	        });
	      }
	      if (
	        (typeof variable === 'string')
	        || Array.isArray(variable)
	        || (variable.constructor && variable.constructor === Object)
	      ) {
	        variable = JSON.stringify(variable);
	      }
	      if (variable === undefined) { variable = 'undefined'; }

	      arr.push(variable);
	      return arr;
	    }, []).join('');

	  },
	  parseJsParents: function parseJsParents(expression, parents) {
	    return expression.split(/([+ \-*^()&=|<>!%:?])/g).reduce(function (arr, part) {
	      if (!part) {
	        return arr;
	      }

	      if (part.indexOf('../') < 0) {
	        arr.push(part);
	        return arr;
	      }

	      if (!parents || parents.length === 0) {
	        arr.push(JSON.stringify(''));
	        return arr;
	      }

	      var levelsUp = part.split('../').length - 1;
	      var parentData = levelsUp > parents.length ? parents[parents.length - 1] : parents[levelsUp - 1];

	      var variable = parentData;
	      var parentPart = part.replace(/..\//g, '');
	      parentPart.split('.').forEach(function (partName) {
	        if (typeof variable[partName] !== 'undefined') { variable = variable[partName]; }
	        else { variable = 'undefined'; }
	      });
	      if (variable === false || variable === true) {
	        arr.push(JSON.stringify(variable));
	        return arr;
	      }
	      if (variable === null || variable === 'undefined') {
	        arr.push(JSON.stringify(''));
	        return arr;
	      }
	      arr.push(JSON.stringify(variable));
	      return arr;
	    }, []).join('');
	  },
	  getCompileVar: function getCompileVar(name, ctx, data) {
	    if ( data === void 0 ) data = 'data_1';

	    var variable = ctx;
	    var parts;
	    var levelsUp = 0;
	    var newDepth;
	    if (name.indexOf('../') === 0) {
	      levelsUp = name.split('../').length - 1;
	      newDepth = variable.split('_')[1] - levelsUp;
	      variable = "ctx_" + (newDepth >= 1 ? newDepth : 1);
	      parts = name.split('../')[levelsUp].split('.');
	    } else if (name.indexOf('@global') === 0) {
	      variable = 'Template7.global';
	      parts = name.split('@global.')[1].split('.');
	    } else if (name.indexOf('@root') === 0) {
	      variable = 'root';
	      parts = name.split('@root.')[1].split('.');
	    } else {
	      parts = name.split('.');
	    }
	    for (var i = 0; i < parts.length; i += 1) {
	      var part = parts[i];
	      if (part.indexOf('@') === 0) {
	        var dataLevel = data.split('_')[1];
	        if (levelsUp > 0) {
	          dataLevel = newDepth;
	        }
	        if (i > 0) {
	          variable += "[(data_" + dataLevel + " && data_" + dataLevel + "." + (part.replace('@', '')) + ")]";
	        } else {
	          variable = "(data_" + dataLevel + " && data_" + dataLevel + "." + (part.replace('@', '')) + ")";
	        }
	      } else if (Number.isFinite ? Number.isFinite(part) : Template7Context.isFinite(part)) {
	        variable += "[" + part + "]";
	      } else if (part === 'this' || part.indexOf('this.') >= 0 || part.indexOf('this[') >= 0 || part.indexOf('this(') >= 0) {
	        variable = part.replace('this', ctx);
	      } else {
	        variable += "." + part;
	      }
	    }
	    return variable;
	  },
	  getCompiledArguments: function getCompiledArguments(contextArray, ctx, data) {
	    var arr = [];
	    for (var i = 0; i < contextArray.length; i += 1) {
	      if (/^['"]/.test(contextArray[i])) { arr.push(contextArray[i]); }
	      else if (/^(true|false|\d+)$/.test(contextArray[i])) { arr.push(contextArray[i]); }
	      else {
	        arr.push(Template7Utils.getCompileVar(contextArray[i], ctx, data));
	      }
	    }

	    return arr.join(', ');
	  },
	};

	/* eslint no-eval: "off" */

	var Template7Helpers = {
	  _partial: function _partial(partialName, options) {
	    var ctx = this;
	    var p = Template7Class.partials[partialName];
	    if (!p || (p && !p.template)) { return ''; }
	    if (!p.compiled) {
	      p.compiled = new Template7Class(p.template).compile();
	    }
	    Object.keys(options.hash).forEach(function (hashName) {
	      ctx[hashName] = options.hash[hashName];
	    });
	    return p.compiled(ctx, options.data, options.root);
	  },
	  escape: function escape(context) {
	    if (typeof context === 'undefined' || context === null) { return ''; }
	    if (typeof context !== 'string') {
	      throw new Error('Template7: Passed context to "escape" helper should be a string');
	    }
	    return Template7Utils.escape(context);
	  },
	  if: function if$1(context, options) {
	    var ctx = context;
	    if (Template7Utils.isFunction(ctx)) { ctx = ctx.call(this); }
	    if (ctx) {
	      return options.fn(this, options.data);
	    }

	    return options.inverse(this, options.data);
	  },
	  unless: function unless(context, options) {
	    var ctx = context;
	    if (Template7Utils.isFunction(ctx)) { ctx = ctx.call(this); }
	    if (!ctx) {
	      return options.fn(this, options.data);
	    }

	    return options.inverse(this, options.data);
	  },
	  each: function each(context, options) {
	    var ctx = context;
	    var ret = '';
	    var i = 0;
	    if (Template7Utils.isFunction(ctx)) { ctx = ctx.call(this); }
	    if (Array.isArray(ctx)) {
	      if (options.hash.reverse) {
	        ctx = ctx.reverse();
	      }
	      for (i = 0; i < ctx.length; i += 1) {
	        ret += options.fn(ctx[i], { first: i === 0, last: i === ctx.length - 1, index: i });
	      }
	      if (options.hash.reverse) {
	        ctx = ctx.reverse();
	      }
	    } else {
	      // eslint-disable-next-line
	      for (var key in ctx) {
	        i += 1;
	        ret += options.fn(ctx[key], { key: key });
	      }
	    }
	    if (i > 0) { return ret; }
	    return options.inverse(this);
	  },
	  with: function with$1(context, options) {
	    var ctx = context;
	    if (Template7Utils.isFunction(ctx)) { ctx = context.call(this); }
	    return options.fn(ctx);
	  },
	  join: function join(context, options) {
	    var ctx = context;
	    if (Template7Utils.isFunction(ctx)) { ctx = ctx.call(this); }
	    return ctx.join(options.hash.delimiter || options.hash.delimeter);
	  },
	  js: function js(expression, options) {
	    var data = options.data;
	    var func;
	    var execute = expression;
	    ('index first last key').split(' ').forEach(function (prop) {
	      if (typeof data[prop] !== 'undefined') {
	        var re1 = new RegExp(("this.@" + prop), 'g');
	        var re2 = new RegExp(("@" + prop), 'g');
	        execute = execute
	          .replace(re1, JSON.stringify(data[prop]))
	          .replace(re2, JSON.stringify(data[prop]));
	      }
	    });
	    if (options.root && execute.indexOf('@root') >= 0) {
	      execute = Template7Utils.parseJsVariable(execute, '@root', options.root);
	    }
	    if (execute.indexOf('@global') >= 0) {
	      execute = Template7Utils.parseJsVariable(execute, '@global', Template7Context.Template7.global);
	    }
	    if (execute.indexOf('../') >= 0) {
	      execute = Template7Utils.parseJsParents(execute, options.parents);
	    }
	    if (execute.indexOf('return') >= 0) {
	      func = "(function(){" + execute + "})";
	    } else {
	      func = "(function(){return (" + execute + ")})";
	    }
	    return eval(func).call(this);
	  },
	  js_if: function js_if(expression, options) {
	    var data = options.data;
	    var func;
	    var execute = expression;
	    ('index first last key').split(' ').forEach(function (prop) {
	      if (typeof data[prop] !== 'undefined') {
	        var re1 = new RegExp(("this.@" + prop), 'g');
	        var re2 = new RegExp(("@" + prop), 'g');
	        execute = execute
	          .replace(re1, JSON.stringify(data[prop]))
	          .replace(re2, JSON.stringify(data[prop]));
	      }
	    });
	    if (options.root && execute.indexOf('@root') >= 0) {
	      execute = Template7Utils.parseJsVariable(execute, '@root', options.root);
	    }
	    if (execute.indexOf('@global') >= 0) {
	      execute = Template7Utils.parseJsVariable(execute, '@global', Template7Context.Template7.global);
	    }
	    if (execute.indexOf('../') >= 0) {
	      execute = Template7Utils.parseJsParents(execute, options.parents);
	    }
	    if (execute.indexOf('return') >= 0) {
	      func = "(function(){" + execute + "})";
	    } else {
	      func = "(function(){return (" + execute + ")})";
	    }
	    var condition = eval(func).call(this);
	    if (condition) {
	      return options.fn(this, options.data);
	    }

	    return options.inverse(this, options.data);
	  },
	};
	Template7Helpers.js_compare = Template7Helpers.js_if;

	var Template7Options = {};
	var Template7Partials = {};

	var Template7Class = function Template7Class(template) {
	  var t = this;
	  t.template = template;
	};

	var staticAccessors = { options: { configurable: true },partials: { configurable: true },helpers: { configurable: true } };
	Template7Class.prototype.compile = function compile (template, depth) {
	    if ( template === void 0 ) template = this.template;
	    if ( depth === void 0 ) depth = 1;

	  var t = this;
	  if (t.compiled) { return t.compiled; }

	  if (typeof template !== 'string') {
	    throw new Error('Template7: Template must be a string');
	  }
	  var stringToBlocks = Template7Utils.stringToBlocks;
	    var getCompileVar = Template7Utils.getCompileVar;
	    var getCompiledArguments = Template7Utils.getCompiledArguments;

	  var blocks = stringToBlocks(template);
	  var ctx = "ctx_" + depth;
	  var data = "data_" + depth;
	  if (blocks.length === 0) {
	    return function empty() { return ''; };
	  }

	  function getCompileFn(block, newDepth) {
	    if (block.content) { return t.compile(block.content, newDepth); }
	    return function empty() { return ''; };
	  }
	  function getCompileInverse(block, newDepth) {
	    if (block.inverseContent) { return t.compile(block.inverseContent, newDepth); }
	    return function empty() { return ''; };
	  }

	  var resultString = '';
	  if (depth === 1) {
	    resultString += "(function (" + ctx + ", " + data + ", root) {\n";
	  } else {
	    resultString += "(function (" + ctx + ", " + data + ") {\n";
	  }
	  if (depth === 1) {
	    resultString += 'function isArray(arr){return Array.isArray(arr);}\n';
	    resultString += 'function isFunction(func){return (typeof func === \'function\');}\n';
	    resultString += 'function c(val, ctx) {if (typeof val !== "undefined" && val !== null) {if (isFunction(val)) {return val.call(ctx);} else return val;} else return "";}\n';
	    resultString += 'root = root || ctx_1 || {};\n';
	  }
	  resultString += 'var r = \'\';\n';
	  var i;
	  for (i = 0; i < blocks.length; i += 1) {
	    var block = blocks[i];
	    // Plain block
	    if (block.type === 'plain') {
	      // eslint-disable-next-line
	      resultString += "r +='" + ((block.content).replace(/\r/g, '\\r').replace(/\n/g, '\\n').replace(/'/g, '\\' + '\'')) + "';";
	      continue;
	    }
	    var variable = (void 0);
	    var compiledArguments = (void 0);
	    // Variable block
	    if (block.type === 'variable') {
	      variable = getCompileVar(block.contextName, ctx, data);
	      resultString += "r += c(" + variable + ", " + ctx + ");";
	    }
	    // Helpers block
	    if (block.type === 'helper') {
	      var parents = (void 0);
	      if (ctx !== 'ctx_1') {
	        var level = ctx.split('_')[1];
	        var parentsString = "ctx_" + (level - 1);
	        for (var j = level - 2; j >= 1; j -= 1) {
	          parentsString += ", ctx_" + j;
	        }
	        parents = "[" + parentsString + "]";
	      } else {
	        parents = "[" + ctx + "]";
	      }
	      var dynamicHelper = (void 0);
	      if (block.helperName.indexOf('[') === 0) {
	        block.helperName = getCompileVar(block.helperName.replace(/[[\]]/g, ''), ctx, data);
	        dynamicHelper = true;
	      }
	      if (dynamicHelper || block.helperName in Template7Helpers) {
	        compiledArguments = getCompiledArguments(block.contextName, ctx, data);
	        resultString += "r += (Template7Helpers" + (dynamicHelper ? ("[" + (block.helperName) + "]") : ("." + (block.helperName))) + ").call(" + ctx + ", " + (compiledArguments && ((compiledArguments + ", "))) + "{hash:" + (JSON.stringify(block.hash)) + ", data: " + data + " || {}, fn: " + (getCompileFn(block, depth + 1)) + ", inverse: " + (getCompileInverse(block, depth + 1)) + ", root: root, parents: " + parents + "});";
	      } else if (block.contextName.length > 0) {
	        throw new Error(("Template7: Missing helper: \"" + (block.helperName) + "\""));
	      } else {
	        variable = getCompileVar(block.helperName, ctx, data);
	        resultString += "if (" + variable + ") {";
	        resultString += "if (isArray(" + variable + ")) {";
	        resultString += "r += (Template7Helpers.each).call(" + ctx + ", " + variable + ", {hash:" + (JSON.stringify(block.hash)) + ", data: " + data + " || {}, fn: " + (getCompileFn(block, depth + 1)) + ", inverse: " + (getCompileInverse(block, depth + 1)) + ", root: root, parents: " + parents + "});";
	        resultString += '}else {';
	        resultString += "r += (Template7Helpers.with).call(" + ctx + ", " + variable + ", {hash:" + (JSON.stringify(block.hash)) + ", data: " + data + " || {}, fn: " + (getCompileFn(block, depth + 1)) + ", inverse: " + (getCompileInverse(block, depth + 1)) + ", root: root, parents: " + parents + "});";
	        resultString += '}}';
	      }
	    }
	  }
	  resultString += '\nreturn r;})';

	  if (depth === 1) {
	    // eslint-disable-next-line
	    t.compiled = eval(resultString);
	    return t.compiled;
	  }
	  return resultString;
	};
	staticAccessors.options.get = function () {
	  return Template7Options;
	};
	staticAccessors.partials.get = function () {
	  return Template7Partials;
	};
	staticAccessors.helpers.get = function () {
	  return Template7Helpers;
	};

	Object.defineProperties( Template7Class, staticAccessors );

	function Template7() {
	  var args = [], len = arguments.length;
	  while ( len-- ) args[ len ] = arguments[ len ];

	  var template = args[0];
	  var data = args[1];
	  if (args.length === 2) {
	    var instance = new Template7Class(template);
	    var rendered = instance.compile()(data);
	    instance = null;
	    return (rendered);
	  }
	  return new Template7Class(template);
	}
	Template7.registerHelper = function registerHelper(name, fn) {
	  Template7Class.helpers[name] = fn;
	};
	Template7.unregisterHelper = function unregisterHelper(name) {
	  Template7Class.helpers[name] = undefined;
	  delete Template7Class.helpers[name];
	};
	Template7.registerPartial = function registerPartial(name, template) {
	  Template7Class.partials[name] = { template: template };
	};
	Template7.unregisterPartial = function unregisterPartial(name) {
	  if (Template7Class.partials[name]) {
	    Template7Class.partials[name] = undefined;
	    delete Template7Class.partials[name];
	  }
	};
	Template7.compile = function compile(template, options) {
	  var instance = new Template7Class(template, options);
	  return instance.compile();
	};

	Template7.options = Template7Class.options;
	Template7.helpers = Template7Class.helpers;
	Template7.partials = Template7Class.partials;

	/**
	 * https://github.com/gre/bezier-easing
	 * BezierEasing - use bezier curve for transition easing function
	 * by Gaëtan Renaudeau 2014 - 2015 – MIT License
	 */

	/* eslint-disable */

	// These values are established by empiricism with tests (tradeoff: performance VS precision)
	var NEWTON_ITERATIONS = 4;
	var NEWTON_MIN_SLOPE = 0.001;
	var SUBDIVISION_PRECISION = 0.0000001;
	var SUBDIVISION_MAX_ITERATIONS = 10;

	var kSplineTableSize = 11;
	var kSampleStepSize = 1.0 / (kSplineTableSize - 1.0);

	var float32ArraySupported = typeof Float32Array === 'function';

	function A (aA1, aA2) { return 1.0 - 3.0 * aA2 + 3.0 * aA1; }
	function B (aA1, aA2) { return 3.0 * aA2 - 6.0 * aA1; }
	function C (aA1)      { return 3.0 * aA1; }

	// Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
	function calcBezier (aT, aA1, aA2) { return ((A(aA1, aA2) * aT + B(aA1, aA2)) * aT + C(aA1)) * aT; }

	// Returns dx/dt given t, x1, and x2, or dy/dt given t, y1, and y2.
	function getSlope (aT, aA1, aA2) { return 3.0 * A(aA1, aA2) * aT * aT + 2.0 * B(aA1, aA2) * aT + C(aA1); }

	function binarySubdivide (aX, aA, aB, mX1, mX2) {
	  var currentX, currentT, i = 0;
	  do {
	    currentT = aA + (aB - aA) / 2.0;
	    currentX = calcBezier(currentT, mX1, mX2) - aX;
	    if (currentX > 0.0) {
	      aB = currentT;
	    } else {
	      aA = currentT;
	    }
	  } while (Math.abs(currentX) > SUBDIVISION_PRECISION && ++i < SUBDIVISION_MAX_ITERATIONS);
	  return currentT;
	}

	function newtonRaphsonIterate (aX, aGuessT, mX1, mX2) {
	 for (var i = 0; i < NEWTON_ITERATIONS; ++i) {
	   var currentSlope = getSlope(aGuessT, mX1, mX2);
	   if (currentSlope === 0.0) {
	     return aGuessT;
	   }
	   var currentX = calcBezier(aGuessT, mX1, mX2) - aX;
	   aGuessT -= currentX / currentSlope;
	 }
	 return aGuessT;
	}

	function bezier (mX1, mY1, mX2, mY2) {
	  if (!(0 <= mX1 && mX1 <= 1 && 0 <= mX2 && mX2 <= 1)) {
	    throw new Error('bezier x values must be in [0, 1] range');
	  }

	  // Precompute samples table
	  var sampleValues = float32ArraySupported ? new Float32Array(kSplineTableSize) : new Array(kSplineTableSize);
	  if (mX1 !== mY1 || mX2 !== mY2) {
	    for (var i = 0; i < kSplineTableSize; ++i) {
	      sampleValues[i] = calcBezier(i * kSampleStepSize, mX1, mX2);
	    }
	  }

	  function getTForX (aX) {
	    var intervalStart = 0.0;
	    var currentSample = 1;
	    var lastSample = kSplineTableSize - 1;

	    for (; currentSample !== lastSample && sampleValues[currentSample] <= aX; ++currentSample) {
	      intervalStart += kSampleStepSize;
	    }
	    --currentSample;

	    // Interpolate to provide an initial guess for t
	    var dist = (aX - sampleValues[currentSample]) / (sampleValues[currentSample + 1] - sampleValues[currentSample]);
	    var guessForT = intervalStart + dist * kSampleStepSize;

	    var initialSlope = getSlope(guessForT, mX1, mX2);
	    if (initialSlope >= NEWTON_MIN_SLOPE) {
	      return newtonRaphsonIterate(aX, guessForT, mX1, mX2);
	    } else if (initialSlope === 0.0) {
	      return guessForT;
	    } else {
	      return binarySubdivide(aX, intervalStart, intervalStart + kSampleStepSize, mX1, mX2);
	    }
	  }

	  return function BezierEasing (x) {
	    if (mX1 === mY1 && mX2 === mY2) {
	      return x; // linear
	    }
	    // Because JavaScript number are imprecise, we should guarantee the extremes are right.
	    if (x === 0) {
	      return 0;
	    }
	    if (x === 1) {
	      return 1;
	    }
	    return calcBezier(getTForX(x), mY1, mY2);
	  };
	}

	/* eslint no-control-regex: "off" */

	// Remove Diacritics
	var defaultDiacriticsRemovalap = [
	  { base: 'A', letters: '\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F' },
	  { base: 'AA', letters: '\uA732' },
	  { base: 'AE', letters: '\u00C6\u01FC\u01E2' },
	  { base: 'AO', letters: '\uA734' },
	  { base: 'AU', letters: '\uA736' },
	  { base: 'AV', letters: '\uA738\uA73A' },
	  { base: 'AY', letters: '\uA73C' },
	  { base: 'B', letters: '\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181' },
	  { base: 'C', letters: '\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E' },
	  { base: 'D', letters: '\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779' },
	  { base: 'DZ', letters: '\u01F1\u01C4' },
	  { base: 'Dz', letters: '\u01F2\u01C5' },
	  { base: 'E', letters: '\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E' },
	  { base: 'F', letters: '\u0046\u24BB\uFF26\u1E1E\u0191\uA77B' },
	  { base: 'G', letters: '\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E' },
	  { base: 'H', letters: '\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D' },
	  { base: 'I', letters: '\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197' },
	  { base: 'J', letters: '\u004A\u24BF\uFF2A\u0134\u0248' },
	  { base: 'K', letters: '\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2' },
	  { base: 'L', letters: '\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780' },
	  { base: 'LJ', letters: '\u01C7' },
	  { base: 'Lj', letters: '\u01C8' },
	  { base: 'M', letters: '\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C' },
	  { base: 'N', letters: '\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4' },
	  { base: 'NJ', letters: '\u01CA' },
	  { base: 'Nj', letters: '\u01CB' },
	  { base: 'O', letters: '\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C' },
	  { base: 'OI', letters: '\u01A2' },
	  { base: 'OO', letters: '\uA74E' },
	  { base: 'OU', letters: '\u0222' },
	  { base: 'OE', letters: '\u008C\u0152' },
	  { base: 'oe', letters: '\u009C\u0153' },
	  { base: 'P', letters: '\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754' },
	  { base: 'Q', letters: '\u0051\u24C6\uFF31\uA756\uA758\u024A' },
	  { base: 'R', letters: '\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782' },
	  { base: 'S', letters: '\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784' },
	  { base: 'T', letters: '\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786' },
	  { base: 'TZ', letters: '\uA728' },
	  { base: 'U', letters: '\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244' },
	  { base: 'V', letters: '\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245' },
	  { base: 'VY', letters: '\uA760' },
	  { base: 'W', letters: '\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72' },
	  { base: 'X', letters: '\u0058\u24CD\uFF38\u1E8A\u1E8C' },
	  { base: 'Y', letters: '\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE' },
	  { base: 'Z', letters: '\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762' },
	  { base: 'a', letters: '\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250' },
	  { base: 'aa', letters: '\uA733' },
	  { base: 'ae', letters: '\u00E6\u01FD\u01E3' },
	  { base: 'ao', letters: '\uA735' },
	  { base: 'au', letters: '\uA737' },
	  { base: 'av', letters: '\uA739\uA73B' },
	  { base: 'ay', letters: '\uA73D' },
	  { base: 'b', letters: '\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253' },
	  { base: 'c', letters: '\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184' },
	  { base: 'd', letters: '\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A' },
	  { base: 'dz', letters: '\u01F3\u01C6' },
	  { base: 'e', letters: '\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD' },
	  { base: 'f', letters: '\u0066\u24D5\uFF46\u1E1F\u0192\uA77C' },
	  { base: 'g', letters: '\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F' },
	  { base: 'h', letters: '\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265' },
	  { base: 'hv', letters: '\u0195' },
	  { base: 'i', letters: '\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131' },
	  { base: 'j', letters: '\u006A\u24D9\uFF4A\u0135\u01F0\u0249' },
	  { base: 'k', letters: '\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3' },
	  { base: 'l', letters: '\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747' },
	  { base: 'lj', letters: '\u01C9' },
	  { base: 'm', letters: '\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F' },
	  { base: 'n', letters: '\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5' },
	  { base: 'nj', letters: '\u01CC' },
	  { base: 'o', letters: '\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275' },
	  { base: 'oi', letters: '\u01A3' },
	  { base: 'ou', letters: '\u0223' },
	  { base: 'oo', letters: '\uA74F' },
	  { base: 'p', letters: '\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755' },
	  { base: 'q', letters: '\u0071\u24E0\uFF51\u024B\uA757\uA759' },
	  { base: 'r', letters: '\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783' },
	  { base: 's', letters: '\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B' },
	  { base: 't', letters: '\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787' },
	  { base: 'tz', letters: '\uA729' },
	  { base: 'u', letters: '\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289' },
	  { base: 'v', letters: '\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C' },
	  { base: 'vy', letters: '\uA761' },
	  { base: 'w', letters: '\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73' },
	  { base: 'x', letters: '\u0078\u24E7\uFF58\u1E8B\u1E8D' },
	  { base: 'y', letters: '\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF' },
	  { base: 'z', letters: '\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763' } ];

	var diacriticsMap = {};
	for (var i = 0; i < defaultDiacriticsRemovalap.length; i += 1) {
	  var letters = defaultDiacriticsRemovalap[i].letters;
	  for (var j = 0; j < letters.length; j += 1) {
	    diacriticsMap[letters[j]] = defaultDiacriticsRemovalap[i].base;
	  }
	}

	var createPromise = function createPromise(handler) {
	  var resolved = false;
	  var rejected = false;
	  var resolveArgs;
	  var rejectArgs;
	  var promiseHandlers = {
	    then: undefined,
	    catch: undefined,
	  };
	  var promise = {
	    then: function then(thenHandler) {
	      if (resolved) {
	        thenHandler.apply(void 0, resolveArgs);
	      } else {
	        promiseHandlers.then = thenHandler;
	      }
	      return promise;
	    },
	    catch: function catch$1(catchHandler) {
	      if (rejected) {
	        catchHandler.apply(void 0, rejectArgs);
	      } else {
	        promiseHandlers.catch = catchHandler;
	      }
	      return promise;
	    },
	  };

	  function resolve() {
	    var args = [], len = arguments.length;
	    while ( len-- ) args[ len ] = arguments[ len ];

	    resolved = true;
	    if (promiseHandlers.then) { promiseHandlers.then.apply(promiseHandlers, args); }
	    else { resolveArgs = args; }
	  }
	  function reject() {
	    var args = [], len = arguments.length;
	    while ( len-- ) args[ len ] = arguments[ len ];

	    rejected = true;
	    if (promiseHandlers.catch) { promiseHandlers.catch.apply(promiseHandlers, args); }
	    else { rejectArgs = args; }
	  }
	  handler(resolve, reject);

	  return promise;
	};

	var Utils = {
	  mdPreloaderContent: "\n    <span class=\"preloader-inner\">\n      <span class=\"preloader-inner-gap\"></span>\n      <span class=\"preloader-inner-left\">\n          <span class=\"preloader-inner-half-circle\"></span>\n      </span>\n      <span class=\"preloader-inner-right\">\n          <span class=\"preloader-inner-half-circle\"></span>\n      </span>\n    </span>\n  ".trim(),
	  eventNameToColonCase: function eventNameToColonCase(eventName) {
	    var hasColon;
	    return eventName.split('').map(function (char, index) {
	      if (char.match(/[A-Z]/) && index !== 0 && !hasColon) {
	        hasColon = true;
	        return (":" + (char.toLowerCase()));
	      }
	      return char.toLowerCase();
	    }).join('');
	  },
	  deleteProps: function deleteProps(obj) {
	    var object = obj;
	    Object.keys(object).forEach(function (key) {
	      try {
	        object[key] = null;
	      } catch (e) {
	        // no getter for object
	      }
	      try {
	        delete object[key];
	      } catch (e) {
	        // something got wrong
	      }
	    });
	  },
	  bezier: function bezier$1() {
	    var args = [], len = arguments.length;
	    while ( len-- ) args[ len ] = arguments[ len ];

	    return bezier.apply(void 0, args);
	  },
	  nextTick: function nextTick(callback, delay) {
	    if ( delay === void 0 ) delay = 0;

	    return setTimeout(callback, delay);
	  },
	  nextFrame: function nextFrame(callback) {
	    return Utils.requestAnimationFrame(callback);
	  },
	  now: function now() {
	    return Date.now();
	  },
	  promise: function promise(handler) {
	    return win.Promise ? new Promise(handler) : createPromise(handler);
	  },
	  requestAnimationFrame: function requestAnimationFrame(callback) {
	    if (win.requestAnimationFrame) { return win.requestAnimationFrame(callback); }
	    else if (win.webkitRequestAnimationFrame) { return win.webkitRequestAnimationFrame(callback); }
	    return win.setTimeout(callback, 1000 / 60);
	  },
	  cancelAnimationFrame: function cancelAnimationFrame(id) {
	    if (win.cancelAnimationFrame) { return win.cancelAnimationFrame(id); }
	    else if (win.webkitCancelAnimationFrame) { return win.webkitCancelAnimationFrame(id); }
	    return win.clearTimeout(id);
	  },
	  removeDiacritics: function removeDiacritics(str) {
	    return str.replace(/[^\u0000-\u007E]/g, function (a) { return diacriticsMap[a] || a; });
	  },
	  parseUrlQuery: function parseUrlQuery(url) {
	    var query = {};
	    var urlToParse = url || win.location.href;
	    var i;
	    var params;
	    var param;
	    var length;
	    if (typeof urlToParse === 'string' && urlToParse.length) {
	      urlToParse = urlToParse.indexOf('?') > -1 ? urlToParse.replace(/\S*\?/, '') : '';
	      params = urlToParse.split('&').filter(function (paramsPart) { return paramsPart !== ''; });
	      length = params.length;

	      for (i = 0; i < length; i += 1) {
	        param = params[i].replace(/#\S+/g, '').split('=');
	        query[decodeURIComponent(param[0])] = typeof param[1] === 'undefined' ? undefined : decodeURIComponent(param[1]) || '';
	      }
	    }
	    return query;
	  },
	  getTranslate: function getTranslate(el, axis) {
	    if ( axis === void 0 ) axis = 'x';

	    var matrix;
	    var curTransform;
	    var transformMatrix;

	    var curStyle = win.getComputedStyle(el, null);

	    if (win.WebKitCSSMatrix) {
	      curTransform = curStyle.transform || curStyle.webkitTransform;
	      if (curTransform.split(',').length > 6) {
	        curTransform = curTransform.split(', ').map(function (a) { return a.replace(',', '.'); }).join(', ');
	      }
	      // Some old versions of Webkit choke when 'none' is passed; pass
	      // empty string instead in this case
	      transformMatrix = new win.WebKitCSSMatrix(curTransform === 'none' ? '' : curTransform);
	    } else {
	      transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform || curStyle.transform || curStyle.getPropertyValue('transform').replace('translate(', 'matrix(1, 0, 0, 1,');
	      matrix = transformMatrix.toString().split(',');
	    }

	    if (axis === 'x') {
	      // Latest Chrome and webkits Fix
	      if (win.WebKitCSSMatrix) { curTransform = transformMatrix.m41; }
	      // Crazy IE10 Matrix
	      else if (matrix.length === 16) { curTransform = parseFloat(matrix[12]); }
	      // Normal Browsers
	      else { curTransform = parseFloat(matrix[4]); }
	    }
	    if (axis === 'y') {
	      // Latest Chrome and webkits Fix
	      if (win.WebKitCSSMatrix) { curTransform = transformMatrix.m42; }
	      // Crazy IE10 Matrix
	      else if (matrix.length === 16) { curTransform = parseFloat(matrix[13]); }
	      // Normal Browsers
	      else { curTransform = parseFloat(matrix[5]); }
	    }
	    return curTransform || 0;
	  },
	  serializeObject: function serializeObject(obj, parents) {
	    if ( parents === void 0 ) parents = [];

	    if (typeof obj === 'string') { return obj; }
	    var resultArray = [];
	    var separator = '&';
	    var newParents;
	    function varName(name) {
	      if (parents.length > 0) {
	        var parentParts = '';
	        for (var j = 0; j < parents.length; j += 1) {
	          if (j === 0) { parentParts += parents[j]; }
	          else { parentParts += "[" + (encodeURIComponent(parents[j])) + "]"; }
	        }
	        return (parentParts + "[" + (encodeURIComponent(name)) + "]");
	      }
	      return encodeURIComponent(name);
	    }
	    function varValue(value) {
	      return encodeURIComponent(value);
	    }
	    Object.keys(obj).forEach(function (prop) {
	      var toPush;
	      if (Array.isArray(obj[prop])) {
	        toPush = [];
	        for (var i = 0; i < obj[prop].length; i += 1) {
	          if (!Array.isArray(obj[prop][i]) && typeof obj[prop][i] === 'object') {
	            newParents = parents.slice();
	            newParents.push(prop);
	            newParents.push(String(i));
	            toPush.push(Utils.serializeObject(obj[prop][i], newParents));
	          } else {
	            toPush.push(((varName(prop)) + "[]=" + (varValue(obj[prop][i]))));
	          }
	        }
	        if (toPush.length > 0) { resultArray.push(toPush.join(separator)); }
	      } else if (obj[prop] === null || obj[prop] === '') {
	        resultArray.push(((varName(prop)) + "="));
	      } else if (typeof obj[prop] === 'object') {
	        // Object, convert to named array
	        newParents = parents.slice();
	        newParents.push(prop);
	        toPush = Utils.serializeObject(obj[prop], newParents);
	        if (toPush !== '') { resultArray.push(toPush); }
	      } else if (typeof obj[prop] !== 'undefined' && obj[prop] !== '') {
	        // Should be string or plain value
	        resultArray.push(((varName(prop)) + "=" + (varValue(obj[prop]))));
	      } else if (obj[prop] === '') { resultArray.push(varName(prop)); }
	    });
	    return resultArray.join(separator);
	  },
	  isObject: function isObject(o) {
	    return typeof o === 'object' && o !== null && o.constructor && o.constructor === Object;
	  },
	  merge: function merge() {
	    var args = [], len$1 = arguments.length;
	    while ( len$1-- ) args[ len$1 ] = arguments[ len$1 ];

	    var to = args[0];
	    args.splice(0, 1);
	    var from = args;

	    for (var i = 0; i < from.length; i += 1) {
	      var nextSource = args[i];
	      if (nextSource !== undefined && nextSource !== null) {
	        var keysArray = Object.keys(Object(nextSource));
	        for (var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex += 1) {
	          var nextKey = keysArray[nextIndex];
	          var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
	          if (desc !== undefined && desc.enumerable) {
	            to[nextKey] = nextSource[nextKey];
	          }
	        }
	      }
	    }
	    return to;
	  },
	  extend: function extend() {
	    var args = [], len$1 = arguments.length;
	    while ( len$1-- ) args[ len$1 ] = arguments[ len$1 ];

	    var deep = true;
	    var to;
	    var from;
	    if (typeof args[0] === 'boolean') {
	      deep = args[0];
	      to = args[1];
	      args.splice(0, 2);
	      from = args;
	    } else {
	      to = args[0];
	      args.splice(0, 1);
	      from = args;
	    }
	    for (var i = 0; i < from.length; i += 1) {
	      var nextSource = args[i];
	      if (nextSource !== undefined && nextSource !== null) {
	        var keysArray = Object.keys(Object(nextSource));
	        for (var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex += 1) {
	          var nextKey = keysArray[nextIndex];
	          var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
	          if (desc !== undefined && desc.enumerable) {
	            if (!deep) {
	              to[nextKey] = nextSource[nextKey];
	            } else if (Utils.isObject(to[nextKey]) && Utils.isObject(nextSource[nextKey])) {
	              Utils.extend(to[nextKey], nextSource[nextKey]);
	            } else if (!Utils.isObject(to[nextKey]) && Utils.isObject(nextSource[nextKey])) {
	              to[nextKey] = {};
	              Utils.extend(to[nextKey], nextSource[nextKey]);
	            } else {
	              to[nextKey] = nextSource[nextKey];
	            }
	          }
	        }
	      }
	    }
	    return to;
	  },
	};

	var Device = (function Device() {
	  var ua = win.navigator.userAgent;

	  var device = {
	    ios: false,
	    android: false,
	    androidChrome: false,
	    desktop: false,
	    windows: false,
	    iphone: false,
	    iphoneX: false,
	    ipod: false,
	    ipad: false,
	    cordova: win.cordova || win.phonegap,
	    phonegap: win.cordova || win.phonegap,
	  };

	  var windows = ua.match(/(Windows Phone);?[\s\/]+([\d.]+)?/); // eslint-disable-line
	  var android = ua.match(/(Android);?[\s\/]+([\d.]+)?/); // eslint-disable-line
	  var ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
	  var ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
	  var iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
	  var iphoneX = iphone && win.screen.width === 375 && win.screen.height === 812;


	  // Windows
	  if (windows) {
	    device.os = 'windows';
	    device.osVersion = windows[2];
	    device.windows = true;
	  }
	  // Android
	  if (android && !windows) {
	    device.os = 'android';
	    device.osVersion = android[2];
	    device.android = true;
	    device.androidChrome = ua.toLowerCase().indexOf('chrome') >= 0;
	  }
	  if (ipad || iphone || ipod) {
	    device.os = 'ios';
	    device.ios = true;
	  }
	  // iOS
	  if (iphone && !ipod) {
	    device.osVersion = iphone[2].replace(/_/g, '.');
	    device.iphone = true;
	    device.iphoneX = iphoneX;
	  }
	  if (ipad) {
	    device.osVersion = ipad[2].replace(/_/g, '.');
	    device.ipad = true;
	  }
	  if (ipod) {
	    device.osVersion = ipod[3] ? ipod[3].replace(/_/g, '.') : null;
	    device.iphone = true;
	  }
	  // iOS 8+ changed UA
	  if (device.ios && device.osVersion && ua.indexOf('Version/') >= 0) {
	    if (device.osVersion.split('.')[0] === '10') {
	      device.osVersion = ua.toLowerCase().split('version/')[1].split(' ')[0];
	    }
	  }

	  // Webview
	  device.webView = (iphone || ipad || ipod) && (ua.match(/.*AppleWebKit(?!.*Safari)/i) || win.navigator.standalone);
	  device.webview = device.webView;


	  // Desktop
	  device.desktop = !(device.os || device.android || device.webView);

	  // Minimal UI
	  if (device.os && device.os === 'ios') {
	    var osVersionArr = device.osVersion.split('.');
	    var metaViewport = doc.querySelector('meta[name="viewport"]');
	    device.minimalUi =
	      !device.webView &&
	      (ipod || iphone) &&
	      (osVersionArr[0] * 1 === 7 ? osVersionArr[1] * 1 >= 1 : osVersionArr[0] * 1 > 7) &&
	      metaViewport && metaViewport.getAttribute('content').indexOf('minimal-ui') >= 0;
	  }

	  // Check for status bar and fullscreen app mode
	  device.needsStatusbarOverlay = function needsStatusbarOverlay() {
	    if ((device.webView || (device.android && device.cordova)) && (win.innerWidth * win.innerHeight === win.screen.width * win.screen.height)) {
	      if (device.iphoneX && (win.orientation === 90 || win.orientation === -90)) {
	        return false;
	      }
	      return true;
	    }
	    return false;
	  };
	  device.statusbar = device.needsStatusbarOverlay();

	  // Pixel Ratio
	  device.pixelRatio = win.devicePixelRatio || 1;

	  // Export object
	  return device;
	}());

	var Framework7Class = function Framework7Class(params, parents) {
	  if ( params === void 0 ) params = {};
	  if ( parents === void 0 ) parents = [];

	  var self = this;
	  self.params = params;

	  // Events
	  self.eventsParents = parents;
	  self.eventsListeners = {};

	  if (self.params && self.params.on) {
	    Object.keys(self.params.on).forEach(function (eventName) {
	      self.on(eventName, self.params.on[eventName]);
	    });
	  }
	};

	var staticAccessors$1 = { components: { configurable: true } };
	Framework7Class.prototype.on = function on (events, handler, priority) {
	  var self = this;
	  if (typeof handler !== 'function') { return self; }
	  var method = priority ? 'unshift' : 'push';
	  events.split(' ').forEach(function (event) {
	    if (!self.eventsListeners[event]) { self.eventsListeners[event] = []; }
	    self.eventsListeners[event][method](handler);
	  });
	  return self;
	};
	Framework7Class.prototype.once = function once (events, handler, priority) {
	  var self = this;
	  if (typeof handler !== 'function') { return self; }
	  function onceHandler() {
	      var args = [], len = arguments.length;
	      while ( len-- ) args[ len ] = arguments[ len ];

	    handler.apply(self, args);
	    self.off(events, onceHandler);
	  }
	  return self.on(events, onceHandler, priority);
	};
	Framework7Class.prototype.off = function off (events, handler) {
	  var self = this;
	  if (!self.eventsListeners) { return self; }
	  events.split(' ').forEach(function (event) {
	    if (typeof handler === 'undefined') {
	      self.eventsListeners[event] = [];
	    } else {
	      self.eventsListeners[event].forEach(function (eventHandler, index) {
	        if (eventHandler === handler) {
	          self.eventsListeners[event].splice(index, 1);
	        }
	      });
	    }
	  });
	  return self;
	};
	Framework7Class.prototype.emit = function emit () {
	    var args = [], len = arguments.length;
	    while ( len-- ) args[ len ] = arguments[ len ];

	  var self = this;
	  if (!self.eventsListeners) { return self; }
	  var events;
	  var data;
	  var context;
	  var eventsParents;
	  if (typeof args[0] === 'string' || Array.isArray(args[0])) {
	    events = args[0];
	    data = args.slice(1, args.length);
	    context = self;
	    eventsParents = self.eventsParents;
	  } else {
	    events = args[0].events;
	    data = args[0].data;
	    context = args[0].context || self;
	    eventsParents = args[0].local ? [] : args[0].parents || self.eventsParents;
	  }
	  var eventsArray = Array.isArray(events) ? events : events.split(' ');
	  var localEvents = eventsArray.map(function (eventName) { return eventName.replace('local::', ''); });
	  var parentEvents = eventsArray.filter(function (eventName) { return eventName.indexOf('local::') < 0; });

	  localEvents.forEach(function (event) {
	    if (self.eventsListeners && self.eventsListeners[event]) {
	      var handlers = [];
	      self.eventsListeners[event].forEach(function (eventHandler) {
	        handlers.push(eventHandler);
	      });
	      handlers.forEach(function (eventHandler) {
	        eventHandler.apply(context, data);
	      });
	    }
	  });
	  if (eventsParents && eventsParents.length > 0) {
	    eventsParents.forEach(function (eventsParent) {
	      eventsParent.emit.apply(eventsParent, [ parentEvents ].concat( data ));
	    });
	  }
	  return self;
	};
	Framework7Class.prototype.useModulesParams = function useModulesParams (instanceParams) {
	  var instance = this;
	  if (!instance.modules) { return; }
	  Object.keys(instance.modules).forEach(function (moduleName) {
	    var module = instance.modules[moduleName];
	    // Extend params
	    if (module.params) {
	      Utils.extend(instanceParams, module.params);
	    }
	  });
	};
	Framework7Class.prototype.useModules = function useModules (modulesParams) {
	    if ( modulesParams === void 0 ) modulesParams = {};

	  var instance = this;
	  if (!instance.modules) { return; }
	  Object.keys(instance.modules).forEach(function (moduleName) {
	    var module = instance.modules[moduleName];
	    var moduleParams = modulesParams[moduleName] || {};
	    // Extend instance methods and props
	    if (module.instance) {
	      Object.keys(module.instance).forEach(function (modulePropName) {
	        var moduleProp = module.instance[modulePropName];
	        if (typeof moduleProp === 'function') {
	          instance[modulePropName] = moduleProp.bind(instance);
	        } else {
	          instance[modulePropName] = moduleProp;
	        }
	      });
	    }
	    // Add event listeners
	    if (module.on && instance.on) {
	      Object.keys(module.on).forEach(function (moduleEventName) {
	        instance.on(moduleEventName, module.on[moduleEventName]);
	      });
	    }

	    // Module create callback
	    if (module.create) {
	      module.create.bind(instance)(moduleParams);
	    }
	  });
	};
	staticAccessors$1.components.set = function (components) {
	  var Class = this;
	  if (!Class.use) { return; }
	  Class.use(components);
	};
	Framework7Class.installModule = function installModule (module) {
	    var params = [], len = arguments.length - 1;
	    while ( len-- > 0 ) params[ len ] = arguments[ len + 1 ];

	  var Class = this;
	  if (!Class.prototype.modules) { Class.prototype.modules = {}; }
	  var name = module.name || (((Object.keys(Class.prototype.modules).length) + "_" + (Utils.now())));
	  Class.prototype.modules[name] = module;
	  // Prototype
	  if (module.proto) {
	    Object.keys(module.proto).forEach(function (key) {
	      Class.prototype[key] = module.proto[key];
	    });
	  }
	  // Class
	  if (module.static) {
	    Object.keys(module.static).forEach(function (key) {
	      Class[key] = module.static[key];
	    });
	  }
	  // Callback
	  if (module.install) {
	    module.install.apply(Class, params);
	  }
	  return Class;
	};
	Framework7Class.use = function use (module) {
	    var params = [], len = arguments.length - 1;
	    while ( len-- > 0 ) params[ len ] = arguments[ len + 1 ];

	  var Class = this;
	  if (Array.isArray(module)) {
	    module.forEach(function (m) { return Class.installModule(m); });
	    return Class;
	  }
	  return Class.installModule.apply(Class, [ module ].concat( params ));
	};

	Object.defineProperties( Framework7Class, staticAccessors$1 );

	var Framework7 = (function (Framework7Class$$1) {
	  function Framework7(params) {
	    Framework7Class$$1.call(this, params);

	    var passedParams = Utils.extend({}, params);

	    // App Instance
	    var app = this;

	    // Default
	    var defaults = {
	      version: '1.0.0',
	      id: 'io.framework7.testapp',
	      root: 'body',
	      theme: 'auto',
	      language: win.navigator.language,
	      routes: [],
	      name: 'Framework7',
	      initOnDeviceReady: true,
	      init: true,
	    };

	    // Extend defaults with modules params
	    app.useModulesParams(defaults);


	    // Extend defaults with passed params
	    app.params = Utils.extend(defaults, params);

	    var $rootEl = $$1(app.params.root);

	    Utils.extend(app, {
	      // App Id
	      id: app.params.id,
	      // App Name
	      name: app.params.name,
	      // App version
	      version: app.params.version,
	      // Routes
	      routes: app.params.routes,
	      // Lang
	      language: app.params.language,
	      // Root
	      root: $rootEl,
	      // RTL
	      rtl: $rootEl.css('direction') === 'rtl',
	      // Theme
	      theme: (function getTheme() {
	        if (app.params.theme === 'auto') {
	          return Device.ios ? 'ios' : 'md';
	        }
	        return app.params.theme;
	      }()),
	      // Initially passed parameters
	      passedParams: passedParams,
	    });

	    // Save Root
	    if (app.root && app.root[0]) {
	      app.root[0].f7 = app;
	    }

	    // Install Modules
	    app.useModules();

	    // Init
	    if (app.params.init) {
	      if (Device.cordova && app.params.initOnDeviceReady) {
	        $$1(doc).on('deviceready', function () {
	          app.init();
	        });
	      } else {
	        app.init();
	      }
	    }

	    // Return app instance
	    return app;
	  }

	  if ( Framework7Class$$1 ) Framework7.__proto__ = Framework7Class$$1;
	  Framework7.prototype = Object.create( Framework7Class$$1 && Framework7Class$$1.prototype );
	  Framework7.prototype.constructor = Framework7;

	  var prototypeAccessors = { $: { configurable: true },t7: { configurable: true } };
	  var staticAccessors = { Dom7: { configurable: true },$: { configurable: true },Template7: { configurable: true },Class: { configurable: true } };
	  Framework7.prototype.init = function init () {
	    var app = this;
	    if (app.initialized) { return; }

	    app.root.addClass('framework7-initializing');

	    // RTL attr
	    if (app.rtl) {
	      $$1('html').attr('dir', 'rtl');
	    }

	    // Root class
	    app.root.addClass('framework7-root');

	    // Theme class
	    $$1('html').removeClass('ios md').addClass(app.theme);

	    // Data
	    app.data = {};
	    if (app.params.data && typeof app.params.data === 'function') {
	      Utils.extend(app.data, app.params.data.bind(app)());
	    } else if (app.params.data) {
	      Utils.extend(app.data, app.params.data);
	    }
	    // Methods
	    app.methods = {};
	    if (app.params.methods) {
	      Utils.extend(app.methods, app.params.methods);
	    }
	    // Init class
	    Utils.nextFrame(function () {
	      app.root.removeClass('framework7-initializing');
	    });
	    // Emit, init other modules
	    app.initialized = true;
	    app.emit('init');
	  };
	  // eslint-disable-next-line
	  prototypeAccessors.$.get = function () {
	    return $$1;
	  };
	  // eslint-disable-next-line
	  prototypeAccessors.t7.get = function () {
	    return Template7;
	  };
	  staticAccessors.Dom7.get = function () {
	    return $$1;
	  };
	  staticAccessors.$.get = function () {
	    return $$1;
	  };
	  staticAccessors.Template7.get = function () {
	    return Template7;
	  };
	  staticAccessors.Class.get = function () {
	    return Framework7Class$$1;
	  };

	  Object.defineProperties( Framework7.prototype, prototypeAccessors );
	  Object.defineProperties( Framework7, staticAccessors );

	  return Framework7;
	}(Framework7Class));

	var globals = {};
	var jsonpRequests = 0;

	function Request(requestOptions) {
	  var globalsNoCallbacks = Utils.extend({}, globals);
	  ('beforeCreate beforeOpen beforeSend error complete success statusCode').split(' ').forEach(function (callbackName) {
	    delete globalsNoCallbacks[callbackName];
	  });
	  var defaults = Utils.extend({
	    url: win.location.toString(),
	    method: 'GET',
	    data: false,
	    async: true,
	    cache: true,
	    user: '',
	    password: '',
	    headers: {},
	    xhrFields: {},
	    statusCode: {},
	    processData: true,
	    dataType: 'text',
	    contentType: 'application/x-www-form-urlencoded',
	    timeout: 0,
	  }, globalsNoCallbacks);

	  var options = Utils.extend({}, defaults, requestOptions);
	  var proceedRequest;

	  // Function to run XHR callbacks and events
	  function fireCallback(callbackName) {
	    var data = [], len = arguments.length - 1;
	    while ( len-- > 0 ) data[ len ] = arguments[ len + 1 ];

	    /*
	      Callbacks:
	      beforeCreate (options),
	      beforeOpen (xhr, options),
	      beforeSend (xhr, options),
	      error (xhr, status),
	      complete (xhr, stautus),
	      success (response, status, xhr),
	      statusCode ()
	    */
	    var globalCallbackValue;
	    var optionCallbackValue;
	    if (globals[callbackName]) {
	      globalCallbackValue = globals[callbackName].apply(globals, data);
	    }
	    if (options[callbackName]) {
	      optionCallbackValue = options[callbackName].apply(options, data);
	    }
	    if (typeof globalCallbackValue !== 'boolean') { globalCallbackValue = true; }
	    if (typeof optionCallbackValue !== 'boolean') { optionCallbackValue = true; }
	    return (globalCallbackValue && optionCallbackValue);
	  }

	  // Before create callback
	  proceedRequest = fireCallback('beforeCreate', options);
	  if (proceedRequest === false) { return undefined; }

	  // For jQuery guys
	  if (options.type) { options.method = options.type; }

	  // Parameters Prefix
	  var paramsPrefix = options.url.indexOf('?') >= 0 ? '&' : '?';

	  // UC method
	  var method = options.method.toUpperCase();

	  // Data to modify GET URL
	  if ((method === 'GET' || method === 'HEAD' || method === 'OPTIONS' || method === 'DELETE') && options.data) {
	    var stringData;
	    if (typeof options.data === 'string') {
	      // Should be key=value string
	      if (options.data.indexOf('?') >= 0) { stringData = options.data.split('?')[1]; }
	      else { stringData = options.data; }
	    } else {
	      // Should be key=value object
	      stringData = Utils.serializeObject(options.data);
	    }
	    if (stringData.length) {
	      options.url += paramsPrefix + stringData;
	      if (paramsPrefix === '?') { paramsPrefix = '&'; }
	    }
	  }

	  // JSONP
	  if (options.dataType === 'json' && options.url.indexOf('callback=') >= 0) {
	    var callbackName = "f7jsonp_" + (Date.now() + ((jsonpRequests += 1)));
	    var abortTimeout;
	    var callbackSplit = options.url.split('callback=');
	    var requestUrl = (callbackSplit[0]) + "callback=" + callbackName;
	    if (callbackSplit[1].indexOf('&') >= 0) {
	      var addVars = callbackSplit[1].split('&').filter(function (el) { return el.indexOf('=') > 0; }).join('&');
	      if (addVars.length > 0) { requestUrl += "&" + addVars; }
	    }

	    // Create script
	    var script = doc.createElement('script');
	    script.type = 'text/javascript';
	    script.onerror = function onerror() {
	      clearTimeout(abortTimeout);
	      fireCallback('error', null, 'scripterror');
	      fireCallback('complete', null, 'scripterror');
	    };
	    script.src = requestUrl;

	    // Handler
	    win[callbackName] = function jsonpCallback(data) {
	      clearTimeout(abortTimeout);
	      fireCallback('success', data);
	      script.parentNode.removeChild(script);
	      script = null;
	      delete win[callbackName];
	    };
	    doc.querySelector('head').appendChild(script);

	    if (options.timeout > 0) {
	      abortTimeout = setTimeout(function () {
	        script.parentNode.removeChild(script);
	        script = null;
	        fireCallback('error', null, 'timeout');
	      }, options.timeout);
	    }

	    return undefined;
	  }

	  // Cache for GET/HEAD requests
	  if (method === 'GET' || method === 'HEAD' || method === 'OPTIONS' || method === 'DELETE') {
	    if (options.cache === false) {
	      options.url += paramsPrefix + "_nocache" + (Date.now());
	    }
	  }

	  // Create XHR
	  var xhr = new XMLHttpRequest();

	  // Save Request URL
	  xhr.requestUrl = options.url;
	  xhr.requestParameters = options;

	  // Before open callback
	  proceedRequest = fireCallback('beforeOpen', xhr, options);
	  if (proceedRequest === false) { return xhr; }

	  // Open XHR
	  xhr.open(method, options.url, options.async, options.user, options.password);

	  // Create POST Data
	  var postData = null;

	  if ((method === 'POST' || method === 'PUT' || method === 'PATCH') && options.data) {
	    if (options.processData) {
	      var postDataInstances = [ArrayBuffer, Blob, Document, FormData];
	      // Post Data
	      if (postDataInstances.indexOf(options.data.constructor) >= 0) {
	        postData = options.data;
	      } else {
	        // POST Headers
	        var boundary = "---------------------------" + (Date.now().toString(16));

	        if (options.contentType === 'multipart/form-data') {
	          xhr.setRequestHeader('Content-Type', ("multipart/form-data; boundary=" + boundary));
	        } else {
	          xhr.setRequestHeader('Content-Type', options.contentType);
	        }
	        postData = '';
	        var data$1 = Utils.serializeObject(options.data);
	        if (options.contentType === 'multipart/form-data') {
	          data$1 = data$1.split('&');
	          var newData = [];
	          for (var i = 0; i < data$1.length; i += 1) {
	            newData.push(("Content-Disposition: form-data; name=\"" + (data$1[i].split('=')[0]) + "\"\r\n\r\n" + (data$1[i].split('=')[1]) + "\r\n"));
	          }
	          postData = "--" + boundary + "\r\n" + (newData.join(("--" + boundary + "\r\n"))) + "--" + boundary + "--\r\n";
	        } else {
	          postData = data$1;
	        }
	      }
	    } else {
	      postData = options.data;
	      xhr.setRequestHeader('Content-Type', options.contentType);
	    }
	  }

	  // Additional headers
	  if (options.headers) {
	    Object.keys(options.headers).forEach(function (headerName) {
	      xhr.setRequestHeader(headerName, options.headers[headerName]);
	    });
	  }

	  // Check for crossDomain
	  if (typeof options.crossDomain === 'undefined') {
	    // eslint-disable-next-line
	    options.crossDomain = /^([\w-]+:)?\/\/([^\/]+)/.test(options.url) && RegExp.$2 !== win.location.host;
	  }

	  if (!options.crossDomain) {
	    xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	  }

	  if (options.xhrFields) {
	    Utils.extend(xhr, options.xhrFields);
	  }

	  var xhrTimeout;

	  // Handle XHR
	  xhr.onload = function onload() {
	    if (xhrTimeout) { clearTimeout(xhrTimeout); }
	    if ((xhr.status >= 200 && xhr.status < 300) || xhr.status === 0) {
	      var responseData;
	      if (options.dataType === 'json') {
	        var parseError;
	        try {
	          responseData = JSON.parse(xhr.responseText);
	        } catch (err) {
	          parseError = true;
	        }
	        if (!parseError) {
	          fireCallback('success', responseData, xhr.status, xhr);
	        } else {
	          fireCallback('error', xhr, 'parseerror');
	        }
	      } else {
	        responseData = xhr.responseType === 'text' || xhr.responseType === '' ? xhr.responseText : xhr.response;
	        fireCallback('success', responseData, xhr.status, xhr);
	      }
	    } else {
	      fireCallback('error', xhr, xhr.status);
	    }
	    if (options.statusCode) {
	      if (globals.statusCode && globals.statusCode[xhr.status]) { globals.statusCode[xhr.status](xhr); }
	      if (options.statusCode[xhr.status]) { options.statusCode[xhr.status](xhr); }
	    }
	    fireCallback('complete', xhr, xhr.status);
	  };

	  xhr.onerror = function onerror() {
	    if (xhrTimeout) { clearTimeout(xhrTimeout); }
	    fireCallback('error', xhr, xhr.status);
	    fireCallback('complete', xhr, 'error');
	  };

	  // Timeout
	  if (options.timeout > 0) {
	    xhr.onabort = function onabort() {
	      if (xhrTimeout) { clearTimeout(xhrTimeout); }
	    };
	    xhrTimeout = setTimeout(function () {
	      xhr.abort();
	      fireCallback('error', xhr, 'timeout');
	      fireCallback('complete', xhr, 'timeout');
	    }, options.timeout);
	  }

	  // Ajax start callback
	  proceedRequest = fireCallback('beforeSend', xhr, options);
	  if (proceedRequest === false) { return xhr; }

	  // Send XHR
	  xhr.send(postData);

	  // Return XHR object
	  return xhr;
	}
	function RequestShortcut(method) {
	  var args = [], len = arguments.length - 1;
	  while ( len-- > 0 ) args[ len ] = arguments[ len + 1 ];

	  var ref = [];
	  var url = ref[0];
	  var data = ref[1];
	  var success = ref[2];
	  var error = ref[3];
	  var dataType = ref[4];
	  if (typeof args[1] === 'function') {
	    var assign;
	    (assign = args, url = assign[0], success = assign[1], error = assign[2], dataType = assign[3]);
	  } else {
	    var assign$1;
	    (assign$1 = args, url = assign$1[0], data = assign$1[1], success = assign$1[2], error = assign$1[3], dataType = assign$1[4]);
	  }
	  [success, error].forEach(function (callback) {
	    if (typeof callback === 'string') {
	      dataType = callback;
	      if (callback === success) { success = undefined; }
	      else { error = undefined; }
	    }
	  });
	  dataType = dataType || (method === 'json' || method === 'postJSON' ? 'json' : undefined);
	  var requestOptions = {
	    url: url,
	    method: method === 'post' || method === 'postJSON' ? 'POST' : 'GET',
	    data: data,
	    success: success,
	    error: error,
	    dataType: dataType,
	  };
	  if (method === 'postJSON') {
	    Utils.extend(requestOptions, {
	      contentType: 'application/json',
	      processData: false,
	      crossDomain: true,
	      data: typeof data === 'string' ? data : JSON.stringify(data),
	    });
	  }
	  return Request(requestOptions);
	}
	Request.get = function get() {
	  var args = [], len = arguments.length;
	  while ( len-- ) args[ len ] = arguments[ len ];

	  return RequestShortcut.apply(void 0, [ 'get' ].concat( args ));
	};
	Request.post = function post() {
	  var args = [], len = arguments.length;
	  while ( len-- ) args[ len ] = arguments[ len ];

	  return RequestShortcut.apply(void 0, [ 'post' ].concat( args ));
	};
	Request.json = function json() {
	  var args = [], len = arguments.length;
	  while ( len-- ) args[ len ] = arguments[ len ];

	  return RequestShortcut.apply(void 0, [ 'json' ].concat( args ));
	};
	Request.getJSON = Request.json;
	Request.postJSON = function postJSON() {
	  var args = [], len = arguments.length;
	  while ( len-- ) args[ len ] = arguments[ len ];

	  return RequestShortcut.apply(void 0, [ 'postJSON' ].concat( args ));
	};
	Request.setup = function setup(options) {
	  if (options.type && !options.method) {
	    Utils.extend(options, { method: options.type });
	  }
	  Utils.extend(globals, options);
	};

	var Support = (function Support() {
	  var positionSticky = (function supportPositionSticky() {
	    var support = false;
	    var div = doc.createElement('div');
	    ('sticky -webkit-sticky -moz-sticky').split(' ').forEach(function (prop) {
	      if (support) { return; }
	      div.style.position = prop;
	      if (div.style.position === prop) {
	        support = true;
	      }
	    });
	    return support;
	  }());

	  var testDiv = doc.createElement('div');

	  return {
	    positionSticky: positionSticky,
	    touch: (function checkTouch() {
	      return !!(('ontouchstart' in win) || (win.DocumentTouch && doc instanceof win.DocumentTouch));
	    }()),

	    pointerEvents: !!(win.navigator.pointerEnabled || win.PointerEvent),
	    prefixedPointerEvents: !!win.navigator.msPointerEnabled,

	    transition: (function checkTransition() {
	      var style = testDiv.style;
	      return ('transition' in style || 'webkitTransition' in style || 'MozTransition' in style);
	    }()),
	    transforms3d: (win.Modernizr && win.Modernizr.csstransforms3d === true) || (function checkTransforms3d() {
	      var style = testDiv.style;
	      return ('webkitPerspective' in style || 'MozPerspective' in style || 'OPerspective' in style || 'MsPerspective' in style || 'perspective' in style);
	    }()),

	    flexbox: (function checkFlexbox() {
	      var div = doc.createElement('div').style;
	      var styles = ('alignItems webkitAlignItems webkitBoxAlign msFlexAlign mozBoxAlign webkitFlexDirection msFlexDirection mozBoxDirection mozBoxOrient webkitBoxDirection webkitBoxOrient').split(' ');
	      for (var i = 0; i < styles.length; i += 1) {
	        if (styles[i] in div) { return true; }
	      }
	      return false;
	    }()),

	    observer: (function checkObserver() {
	      return ('MutationObserver' in win || 'WebkitMutationObserver' in win);
	    }()),

	    passiveListener: (function checkPassiveListener() {
	      var supportsPassive = false;
	      try {
	        var opts = Object.defineProperty({}, 'passive', {
	          // eslint-disable-next-line
	          get: function get() {
	            supportsPassive = true;
	          },
	        });
	        win.addEventListener('testPassiveListener', null, opts);
	      } catch (e) {
	        // No support
	      }
	      return supportsPassive;
	    }()),

	    gestures: (function checkGestures() {
	      return 'ongesturestart' in win;
	    }()),
	  };
	}());

	var DeviceModule = {
	  name: 'device',
	  proto: {
	    device: Device,
	  },
	  static: {
	    device: Device,
	  },
	  on: {
	    init: function init() {
	      var classNames = [];
	      var html = doc.querySelector('html');
	      if (!html) { return; }
	      // Pixel Ratio
	      classNames.push(("device-pixel-ratio-" + (Math.floor(Device.pixelRatio))));
	      if (Device.pixelRatio >= 2) {
	        classNames.push('device-retina');
	      }
	      // OS classes
	      if (Device.os) {
	        classNames.push(
	          ("device-" + (Device.os)),
	          ("device-" + (Device.os) + "-" + (Device.osVersion.split('.')[0])),
	          ("device-" + (Device.os) + "-" + (Device.osVersion.replace(/\./g, '-')))
	        );
	        if (Device.os === 'ios') {
	          var major = parseInt(Device.osVersion.split('.')[0], 10);
	          for (var i = major - 1; i >= 6; i -= 1) {
	            classNames.push(("device-ios-gt-" + i));
	          }
	          if (Device.iphoneX) {
	            classNames.push('device-iphone-x');
	          }
	        }
	      } else if (Device.desktop) {
	        classNames.push('device-desktop');
	      }
	      if (Device.cordova || Device.phonegap) {
	        classNames.push('device-cordova');
	      }

	      // Add html classes
	      classNames.forEach(function (className) {
	        html.classList.add(className);
	      });
	    },
	  },
	};

	var SupportModule = {
	  name: 'support',
	  proto: {
	    support: Support,
	  },
	  static: {
	    support: Support,
	  },
	  on: {
	    init: function init() {
	      var html = doc.querySelector('html');
	      if (!html) { return; }
	      var classNames = [];
	      if (Support.positionSticky) {
	        classNames.push('support-position-sticky');
	      }
	      // Add html classes
	      classNames.forEach(function (className) {
	        html.classList.add(className);
	      });
	    },
	  },
	};

	var UtilsModule = {
	  name: 'utils',
	  proto: {
	    utils: Utils,
	  },
	  static: {
	    utils: Utils,
	  },
	};

	var ResizeModule = {
	  name: 'resize',
	  instance: {
	    getSize: function getSize() {
	      var app = this;
	      if (!app.root[0]) { return { width: 0, height: 0, left: 0, top: 0 }; }
	      var offset = app.root.offset();
	      var ref = [app.root[0].offsetWidth, app.root[0].offsetHeight, offset.left, offset.top];
	      var width = ref[0];
	      var height = ref[1];
	      var left = ref[2];
	      var top = ref[3];
	      app.width = width;
	      app.height = height;
	      app.left = left;
	      app.top = top;
	      return { width: width, height: height, left: left, top: top };
	    },
	  },
	  on: {
	    init: function init() {
	      var app = this;

	      // Get Size
	      app.getSize();

	      // Emit resize
	      win.addEventListener('resize', function () {
	        app.emit('resize');
	      }, false);

	      // Emit orientationchange
	      win.addEventListener('orientationchange', function () {
	        app.emit('orientationchange');
	      });
	    },
	    orientationchange: function orientationchange() {
	      var app = this;
	      if (app.device && app.device.minimalUi) {
	        if (win.orientation === 90 || win.orientation === -90) {
	          doc.body.scrollTop = 0;
	        }
	      }
	      // Fix iPad weird body scroll
	      if (app.device.ipad) {
	        doc.body.scrollLeft = 0;
	        setTimeout(function () {
	          doc.body.scrollLeft = 0;
	        }, 0);
	      }
	    },
	    resize: function resize() {
	      var app = this;
	      app.getSize();
	    },
	  },
	};

	/* eslint no-param-reassign: "off" */

	var RequestModule = {
	  name: 'request',
	  proto: {
	    request: Request,
	  },
	  static: {
	    request: Request,
	  },
	};

	function initTouch() {
	  var app = this;
	  var params = app.params.touch;
	  var useRipple = app.theme === 'md' && params.materialRipple;

	  if (Device.ios && Device.webView) {
	    // Strange hack required for iOS 8 webview to work on inputs
	    win.addEventListener('touchstart', function () {});
	  }

	  var touchStartX;
	  var touchStartY;
	  var touchStartTime;
	  var targetElement;
	  var trackClick;
	  var activeSelection;
	  var scrollParent;
	  var lastClickTime;
	  var isMoved;
	  var tapHoldFired;
	  var tapHoldTimeout;

	  var activableElement;
	  var activeTimeout;

	  var needsFastClick;
	  var needsFastClickTimeOut;

	  var rippleWave;
	  var rippleTarget;
	  var rippleTimeout;

	  function findActivableElement(el) {
	    var target = $$1(el);
	    var parents = target.parents(params.activeStateElements);
	    var activable;
	    if (target.is(params.activeStateElements)) {
	      activable = target;
	    }
	    if (parents.length > 0) {
	      activable = activable ? activable.add(parents) : parents;
	    }
	    return activable || target;
	  }

	  function isInsideScrollableView(el) {
	    var pageContent = el.parents('.page-content, .panel');

	    if (pageContent.length === 0) {
	      return false;
	    }

	    // This event handler covers the "tap to stop scrolling".
	    if (pageContent.prop('scrollHandlerSet') !== 'yes') {
	      pageContent.on('scroll', function () {
	        clearTimeout(activeTimeout);
	        clearTimeout(rippleTimeout);
	      });
	      pageContent.prop('scrollHandlerSet', 'yes');
	    }

	    return true;
	  }
	  function addActive() {
	    if (!activableElement) { return; }
	    activableElement.addClass('active-state');
	  }
	  function removeActive() {
	    if (!activableElement) { return; }
	    activableElement.removeClass('active-state');
	    activableElement = null;
	  }
	  function isFormElement(el) {
	    var nodes = ('input select textarea label').split(' ');
	    if (el.nodeName && nodes.indexOf(el.nodeName.toLowerCase()) >= 0) { return true; }
	    return false;
	  }
	  function androidNeedsBlur(el) {
	    var noBlur = ('button input textarea select').split(' ');
	    if (doc.activeElement && el !== doc.activeElement && doc.activeElement !== doc.body) {
	      if (noBlur.indexOf(el.nodeName.toLowerCase()) >= 0) {
	        return false;
	      }
	      return true;
	    }
	    return false;
	  }
	  function targetNeedsFastClick(el) {
	    /*
	    if (
	      Device.ios
	      &&
	      (
	        Device.osVersion.split('.')[0] > 9
	        ||
	        (Device.osVersion.split('.')[0] * 1 === 9 && Device.osVersion.split('.')[1] >= 1)
	      )
	    ) {
	      return false;
	    }
	    */
	    var $el = $$1(el);
	    if (el.nodeName.toLowerCase() === 'input' && (el.type === 'file' || el.type === 'range')) { return false; }
	    if (el.nodeName.toLowerCase() === 'select' && Device.android) { return false; }
	    if ($el.hasClass('no-fastclick') || $el.parents('.no-fastclick').length > 0) { return false; }
	    if (params.fastClicksExclude && $el.is(params.fastClicksExclude)) { return false; }
	    return true;
	  }
	  function targetNeedsFocus(el) {
	    if (doc.activeElement === el) {
	      return false;
	    }
	    var tag = el.nodeName.toLowerCase();
	    var skipInputs = ('button checkbox file image radio submit').split(' ');
	    if (el.disabled || el.readOnly) { return false; }
	    if (tag === 'textarea') { return true; }
	    if (tag === 'select') {
	      if (Device.android) { return false; }
	      return true;
	    }
	    if (tag === 'input' && skipInputs.indexOf(el.type) < 0) { return true; }
	    return false;
	  }
	  function targetNeedsPrevent(el) {
	    var $el = $$1(el);
	    var prevent = true;
	    if ($el.is('label') || $el.parents('label').length > 0) {
	      if (Device.android) {
	        prevent = false;
	      } else if (Device.ios && $el.is('input')) {
	        prevent = true;
	      } else { prevent = false; }
	    }
	    return prevent;
	  }

	  // Ripple handlers
	  function findRippleElement(el) {
	    var rippleElements = params.materialRippleElements;
	    var $el = $$1(el);
	    if ($el.is(rippleElements)) {
	      if ($el.hasClass('no-ripple')) {
	        return false;
	      }
	      return $el;
	    } else if ($el.parents(rippleElements).length > 0) {
	      var rippleParent = $el.parents(rippleElements).eq(0);
	      if (rippleParent.hasClass('no-ripple')) {
	        return false;
	      }
	      return rippleParent;
	    }
	    return false;
	  }
	  function createRipple($el, x, y) {
	    if (!$el) { return; }
	    rippleWave = app.touchRipple.create($el, x, y);
	  }

	  function removeRipple() {
	    if (!rippleWave) { return; }
	    rippleWave.remove();
	    rippleWave = undefined;
	    rippleTarget = undefined;
	  }
	  function rippleTouchStart(el) {
	    rippleTarget = findRippleElement(el);
	    if (!rippleTarget || rippleTarget.length === 0) {
	      rippleTarget = undefined;
	      return;
	    }
	    if (!isInsideScrollableView(rippleTarget)) {
	      createRipple(rippleTarget, touchStartX, touchStartY);
	    } else {
	      rippleTimeout = setTimeout(function () {
	        createRipple(rippleTarget, touchStartX, touchStartY);
	      }, 80);
	    }
	  }
	  function rippleTouchMove() {
	    clearTimeout(rippleTimeout);
	    removeRipple();
	  }
	  function rippleTouchEnd() {
	    if (rippleWave) {
	      removeRipple();
	    } else if (rippleTarget && !isMoved) {
	      clearTimeout(rippleTimeout);
	      createRipple(rippleTarget, touchStartX, touchStartY);
	      setTimeout(removeRipple, 0);
	    } else {
	      removeRipple();
	    }
	  }

	  // Mouse Handlers
	  function handleMouseDown(e) {
	    findActivableElement(e.target).addClass('active-state');
	    if ('which' in e && e.which === 3) {
	      setTimeout(function () {
	        $$1('.active-state').removeClass('active-state');
	      }, 0);
	    }
	    if (useRipple) {
	      touchStartX = e.pageX;
	      touchStartY = e.pageY;
	      rippleTouchStart(e.target, e.pageX, e.pageY);
	    }
	  }
	  function handleMouseMove() {
	    $$1('.active-state').removeClass('active-state');
	    if (useRipple) {
	      rippleTouchMove();
	    }
	  }
	  function handleMouseUp() {
	    $$1('.active-state').removeClass('active-state');
	    if (useRipple) {
	      rippleTouchEnd();
	    }
	  }

	  // Send Click
	  function sendClick(e) {
	    var touch = e.changedTouches[0];
	    var evt = doc.createEvent('MouseEvents');
	    var eventType = 'click';
	    if (Device.android && targetElement.nodeName.toLowerCase() === 'select') {
	      eventType = 'mousedown';
	    }
	    evt.initMouseEvent(eventType, true, true, win, 1, touch.screenX, touch.screenY, touch.clientX, touch.clientY, false, false, false, false, 0, null);
	    evt.forwardedTouchEvent = true;

	    if (app.device.ios && win.navigator.standalone) {
	      // Fix the issue happens in iOS home screen apps where the wrong element is selected during a momentum scroll.
	      // Upon tapping, we give the scrolling time to stop, then we grab the element based where the user tapped.
	      setTimeout(function () {
	        targetElement = doc.elementFromPoint(e.changedTouches[0].clientX, e.changedTouches[0].clientY);
	        targetElement.dispatchEvent(evt);
	      }, 10);
	    } else {
	      targetElement.dispatchEvent(evt);
	    }
	  }

	  // Touch Handlers
	  function handleTouchStart(e) {
	    var this$1 = this;

	    isMoved = false;
	    tapHoldFired = false;
	    if (e.targetTouches.length > 1) {
	      if (activableElement) { removeActive(); }
	      return true;
	    }
	    if (e.touches.length > 1 && activableElement) {
	      removeActive();
	    }
	    if (params.tapHold) {
	      if (tapHoldTimeout) { clearTimeout(tapHoldTimeout); }
	      tapHoldTimeout = setTimeout(function () {
	        if (e && e.touches && e.touches.length > 1) { return; }
	        tapHoldFired = true;
	        e.preventDefault();
	        $$1(e.target).trigger('taphold');
	      }, params.tapHoldDelay);
	    }
	    if (needsFastClickTimeOut) { clearTimeout(needsFastClickTimeOut); }
	    needsFastClick = targetNeedsFastClick(e.target);

	    if (!needsFastClick) {
	      trackClick = false;
	      return true;
	    }
	    if (Device.ios || (Device.android && 'getSelection' in win)) {
	      var selection = win.getSelection();
	      if (
	        selection.rangeCount &&
	        selection.focusNode !== doc.body &&
	        (!selection.isCollapsed || doc.activeElement === selection.focusNode)
	      ) {
	        activeSelection = true;
	        return true;
	      }

	      activeSelection = false;
	    }
	    if (Device.android) {
	      if (androidNeedsBlur(e.target)) {
	        doc.activeElement.blur();
	      }
	    }

	    trackClick = true;
	    targetElement = e.target;
	    touchStartTime = (new Date()).getTime();
	    touchStartX = e.targetTouches[0].pageX;
	    touchStartY = e.targetTouches[0].pageY;

	    // Detect scroll parent
	    if (Device.ios) {
	      scrollParent = undefined;
	      $$1(targetElement).parents().each(function () {
	        var parent = this$1;
	        if (parent.scrollHeight > parent.offsetHeight && !scrollParent) {
	          scrollParent = parent;
	          scrollParent.f7ScrollTop = scrollParent.scrollTop;
	        }
	      });
	    }
	    if ((touchStartTime - lastClickTime) < params.fastClicksDelayBetweenClicks) {
	      e.preventDefault();
	    }

	    if (params.activeState) {
	      activableElement = findActivableElement(targetElement);
	      // If it's inside a scrollable view, we don't trigger active-state yet,
	      // because it can be a scroll instead. Based on the link:
	      // http://labnote.beedesk.com/click-scroll-and-pseudo-active-on-mobile-webk
	      if (!isInsideScrollableView(activableElement)) {
	        addActive();
	      } else {
	        activeTimeout = setTimeout(addActive, 80);
	      }
	    }
	    if (useRipple) {
	      rippleTouchStart(targetElement, touchStartX, touchStartY);
	    }
	    return true;
	  }
	  function handleTouchMove(e) {
	    if (!trackClick) { return; }
	    var distance = params.fastClicksDistanceThreshold;
	    if (distance) {
	      var pageX = e.targetTouches[0].pageX;
	      var pageY = e.targetTouches[0].pageY;
	      if (Math.abs(pageX - touchStartX) > distance || Math.abs(pageY - touchStartY) > distance) {
	        isMoved = true;
	      }
	    } else {
	      isMoved = true;
	    }
	    if (isMoved) {
	      trackClick = false;
	      targetElement = null;
	      isMoved = true;
	      if (params.tapHold) {
	        clearTimeout(tapHoldTimeout);
	      }
	      if (params.activeState) {
	        clearTimeout(activeTimeout);
	        removeActive();
	      }
	      if (useRipple) {
	        rippleTouchMove();
	      }
	    }
	  }
	  function handleTouchEnd(e) {
	    clearTimeout(activeTimeout);
	    clearTimeout(tapHoldTimeout);

	    var touchEndTime = (new Date()).getTime();

	    if (!trackClick) {
	      if (!activeSelection && needsFastClick) {
	        if (!(Device.android && !e.cancelable) && e.cancelable) {
	          e.preventDefault();
	        }
	      }
	      return true;
	    }

	    if (doc.activeElement === e.target) {
	      if (params.activeState) { removeActive(); }
	      if (useRipple) {
	        rippleTouchEnd();
	      }
	      return true;
	    }

	    if (!activeSelection) {
	      e.preventDefault();
	    }

	    if ((touchEndTime - lastClickTime) < params.fastClicksDelayBetweenClicks) {
	      setTimeout(removeActive, 0);
	      return true;
	    }

	    lastClickTime = touchEndTime;

	    trackClick = false;

	    if (Device.ios && scrollParent) {
	      if (scrollParent.scrollTop !== scrollParent.f7ScrollTop) {
	        return false;
	      }
	    }

	    // Add active-state here because, in a very fast tap, the timeout didn't
	    // have the chance to execute. Removing active-state in a timeout gives
	    // the chance to the animation execute.
	    if (params.activeState) {
	      addActive();
	      setTimeout(removeActive, 0);
	    }
	    // Remove Ripple
	    if (useRipple) {
	      rippleTouchEnd();
	    }

	    // Trigger focus when required
	    if (targetNeedsFocus(targetElement)) {
	      if (Device.ios && Device.webView) {
	        targetElement.focus();
	        return false;
	      }

	      targetElement.focus();
	    }

	    // Blur active elements
	    if (doc.activeElement && targetElement !== doc.activeElement && doc.activeElement !== doc.body && targetElement.nodeName.toLowerCase() !== 'label') {
	      doc.activeElement.blur();
	    }

	    // Send click
	    e.preventDefault();
	    if (params.tapHoldPreventClicks && tapHoldFired) {
	      return false;
	    }
	    sendClick(e);
	    return false;
	  }
	  function handleTouchCancel() {
	    trackClick = false;
	    targetElement = null;

	    // Remove Active State
	    clearTimeout(activeTimeout);
	    clearTimeout(tapHoldTimeout);
	    if (params.activeState) {
	      removeActive();
	    }

	    // Remove Ripple
	    if (useRipple) {
	      rippleTouchEnd();
	    }
	  }

	  function handleClick(e) {
	    var allowClick = false;
	    if (trackClick) {
	      targetElement = null;
	      trackClick = false;
	      return true;
	    }
	    if ((e.target.type === 'submit' && e.detail === 0) || e.target.type === 'file') {
	      return true;
	    }
	    if (!targetElement) {
	      if (!isFormElement(e.target)) {
	        allowClick = true;
	      }
	    }
	    if (!needsFastClick) {
	      allowClick = true;
	    }
	    if (doc.activeElement === targetElement) {
	      allowClick = true;
	    }
	    if (e.forwardedTouchEvent) {
	      allowClick = true;
	    }
	    if (!e.cancelable) {
	      allowClick = true;
	    }
	    if (params.tapHold && params.tapHoldPreventClicks && tapHoldFired) {
	      allowClick = false;
	    }
	    if (!allowClick) {
	      e.stopImmediatePropagation();
	      e.stopPropagation();
	      if (targetElement) {
	        if (targetNeedsPrevent(targetElement) || isMoved) {
	          e.preventDefault();
	        }
	      } else {
	        e.preventDefault();
	      }
	      targetElement = null;
	    }
	    needsFastClickTimeOut = setTimeout(function () {
	      needsFastClick = false;
	    }, (Device.ios || Device.androidChrome ? 100 : 400));

	    if (params.tapHold) {
	      tapHoldTimeout = setTimeout(function () {
	        tapHoldFired = false;
	      }, (Device.ios || Device.androidChrome ? 100 : 400));
	    }

	    return allowClick;
	  }

	  function emitAppTouchEvent(name, e) {
	    app.emit({
	      events: name,
	      data: [e],
	    });
	  }
	  function appClick(e) {
	    emitAppTouchEvent('click', e);
	  }
	  function appTouchStartActive(e) {
	    emitAppTouchEvent('touchstart touchstart:active', e);
	  }
	  function appTouchMoveActive(e) {
	    emitAppTouchEvent('touchmove touchmove:active', e);
	  }
	  function appTouchEndActive(e) {
	    emitAppTouchEvent('touchend touchend:active', e);
	  }
	  function appTouchStartPassive(e) {
	    emitAppTouchEvent('touchstart:passive', e);
	  }
	  function appTouchMovePassive(e) {
	    emitAppTouchEvent('touchmove:passive', e);
	  }
	  function appTouchEndPassive(e) {
	    emitAppTouchEvent('touchend:passive', e);
	  }

	  var passiveListener = Support.passiveListener ? { passive: true } : false;
	  var activeListener = Support.passiveListener ? { passive: false } : false;

	  doc.addEventListener('click', appClick, true);

	  if (Support.passiveListener) {
	    doc.addEventListener(app.touchEvents.start, appTouchStartActive, activeListener);
	    doc.addEventListener(app.touchEvents.move, appTouchMoveActive, activeListener);
	    doc.addEventListener(app.touchEvents.end, appTouchEndActive, activeListener);

	    doc.addEventListener(app.touchEvents.start, appTouchStartPassive, passiveListener);
	    doc.addEventListener(app.touchEvents.move, appTouchMovePassive, passiveListener);
	    doc.addEventListener(app.touchEvents.end, appTouchEndPassive, passiveListener);
	  } else {
	    doc.addEventListener(app.touchEvents.start, function (e) {
	      appTouchStartActive(e);
	      appTouchStartPassive(e);
	    }, false);
	    doc.addEventListener(app.touchEvents.move, function (e) {
	      appTouchMoveActive(e);
	      appTouchMovePassive(e);
	    }, false);
	    doc.addEventListener(app.touchEvents.end, function (e) {
	      appTouchEndActive(e);
	      appTouchEndPassive(e);
	    }, false);
	  }

	  if (Support.touch) {
	    app.on('click', handleClick);
	    app.on('touchstart', handleTouchStart);
	    app.on('touchmove', handleTouchMove);
	    app.on('touchend', handleTouchEnd);
	    doc.addEventListener('touchcancel', handleTouchCancel, { passive: true });
	  } else if (params.activeState) {
	    app.on('touchstart', handleMouseDown);
	    app.on('touchmove', handleMouseMove);
	    app.on('touchend', handleMouseUp);
	  }
	  doc.addEventListener('contextmenu', function (e) {
	    if (params.disableContextMenu && (Device.ios || Device.android || Device.cordova)) {
	      e.preventDefault();
	    }
	    if (useRipple) {
	      if (activableElement) { removeActive(); }
	      rippleTouchEnd();
	    }
	  });
	}

	var TouchModule = {
	  name: 'touch',
	  params: {
	    touch: {
	      // Fast clicks
	      fastClicks: true,
	      fastClicksDistanceThreshold: 10,
	      fastClicksDelayBetweenClicks: 50,
	      fastClicksExclude: '', // CSS selector
	      // ContextMenu
	      disableContextMenu: true,
	      // Tap Hold
	      tapHold: false,
	      tapHoldDelay: 750,
	      tapHoldPreventClicks: true,
	      // Active State
	      activeState: true,
	      activeStateElements: 'a, button, label, span, .actions-button, .stepper-button, .stepper-button-plus, .stepper-button-minus',
	      materialRipple: true,
	      materialRippleElements: '.ripple, .link, .item-link, .links-list a, .button, button, .input-clear-button, .dialog-button, .tab-link, .item-radio, .item-checkbox, .actions-button, .searchbar-disable-button, .fab a, .checkbox, .radio, .data-table .sortable-cell:not(.input-cell), .notification-close-button, .stepper-button, .stepper-button-minus, .stepper-button-plus',
	    },
	  },
	  instance: {
	    touchEvents: {
	      start: Support.touch ? 'touchstart' : 'mousedown',
	      move: Support.touch ? 'touchmove' : 'mousemove',
	      end: Support.touch ? 'touchend' : 'mouseup',
	    },
	  },
	  on: {
	    init: initTouch,
	  },
	};

	/**
	 * Expose `pathToRegexp`.
	 */
	var pathToRegexp_1 = pathToRegexp;
	var parse_1 = parse;
	var compile_1 = compile;
	var tokensToFunction_1 = tokensToFunction;
	var tokensToRegExp_1 = tokensToRegExp;

	/**
	 * Default configs.
	 */
	var DEFAULT_DELIMITER = '/';
	var DEFAULT_DELIMITERS = './';

	/**
	 * The main path matching regexp utility.
	 *
	 * @type {RegExp}
	 */
	var PATH_REGEXP = new RegExp([
	  // Match escaped characters that would otherwise appear in future matches.
	  // This allows the user to escape special characters that won't transform.
	  '(\\\\.)',
	  // Match Express-style parameters and un-named parameters with a prefix
	  // and optional suffixes. Matches appear as:
	  //
	  // ":test(\\d+)?" => ["test", "\d+", undefined, "?"]
	  // "(\\d+)"  => [undefined, undefined, "\d+", undefined]
	  '(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?'
	].join('|'), 'g');

	/**
	 * Parse a string for the raw tokens.
	 *
	 * @param  {string}  str
	 * @param  {Object=} options
	 * @return {!Array}
	 */
	function parse (str, options) {
	  var tokens = [];
	  var key = 0;
	  var index = 0;
	  var path = '';
	  var defaultDelimiter = (options && options.delimiter) || DEFAULT_DELIMITER;
	  var delimiters = (options && options.delimiters) || DEFAULT_DELIMITERS;
	  var pathEscaped = false;
	  var res;

	  while ((res = PATH_REGEXP.exec(str)) !== null) {
	    var m = res[0];
	    var escaped = res[1];
	    var offset = res.index;
	    path += str.slice(index, offset);
	    index = offset + m.length;

	    // Ignore already escaped sequences.
	    if (escaped) {
	      path += escaped[1];
	      pathEscaped = true;
	      continue
	    }

	    var prev = '';
	    var next = str[index];
	    var name = res[2];
	    var capture = res[3];
	    var group = res[4];
	    var modifier = res[5];

	    if (!pathEscaped && path.length) {
	      var k = path.length - 1;

	      if (delimiters.indexOf(path[k]) > -1) {
	        prev = path[k];
	        path = path.slice(0, k);
	      }
	    }

	    // Push the current path onto the tokens.
	    if (path) {
	      tokens.push(path);
	      path = '';
	      pathEscaped = false;
	    }

	    var partial = prev !== '' && next !== undefined && next !== prev;
	    var repeat = modifier === '+' || modifier === '*';
	    var optional = modifier === '?' || modifier === '*';
	    var delimiter = prev || defaultDelimiter;
	    var pattern = capture || group;

	    tokens.push({
	      name: name || key++,
	      prefix: prev,
	      delimiter: delimiter,
	      optional: optional,
	      repeat: repeat,
	      partial: partial,
	      pattern: pattern ? escapeGroup(pattern) : '[^' + escapeString(delimiter) + ']+?'
	    });
	  }

	  // Push any remaining characters.
	  if (path || index < str.length) {
	    tokens.push(path + str.substr(index));
	  }

	  return tokens
	}

	/**
	 * Compile a string to a template function for the path.
	 *
	 * @param  {string}             str
	 * @param  {Object=}            options
	 * @return {!function(Object=, Object=)}
	 */
	function compile (str, options) {
	  return tokensToFunction(parse(str, options))
	}

	/**
	 * Expose a method for transforming tokens into the path function.
	 */
	function tokensToFunction (tokens) {
	  // Compile all the tokens into regexps.
	  var matches = new Array(tokens.length);

	  // Compile all the patterns before compilation.
	  for (var i = 0; i < tokens.length; i++) {
	    if (typeof tokens[i] === 'object') {
	      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$');
	    }
	  }

	  return function (data, options) {
	    var path = '';
	    var encode = (options && options.encode) || encodeURIComponent;

	    for (var i = 0; i < tokens.length; i++) {
	      var token = tokens[i];

	      if (typeof token === 'string') {
	        path += token;
	        continue
	      }

	      var value = data ? data[token.name] : undefined;
	      var segment;

	      if (Array.isArray(value)) {
	        if (!token.repeat) {
	          throw new TypeError('Expected "' + token.name + '" to not repeat, but got array')
	        }

	        if (value.length === 0) {
	          if (token.optional) { continue }

	          throw new TypeError('Expected "' + token.name + '" to not be empty')
	        }

	        for (var j = 0; j < value.length; j++) {
	          segment = encode(value[j], token);

	          if (!matches[i].test(segment)) {
	            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '"')
	          }

	          path += (j === 0 ? token.prefix : token.delimiter) + segment;
	        }

	        continue
	      }

	      if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
	        segment = encode(String(value), token);

	        if (!matches[i].test(segment)) {
	          throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but got "' + segment + '"')
	        }

	        path += token.prefix + segment;
	        continue
	      }

	      if (token.optional) {
	        // Prepend partial segment prefixes.
	        if (token.partial) { path += token.prefix; }

	        continue
	      }

	      throw new TypeError('Expected "' + token.name + '" to be ' + (token.repeat ? 'an array' : 'a string'))
	    }

	    return path
	  }
	}

	/**
	 * Escape a regular expression string.
	 *
	 * @param  {string} str
	 * @return {string}
	 */
	function escapeString (str) {
	  return str.replace(/([.+*?=^!:${}()[\]|/\\])/g, '\\$1')
	}

	/**
	 * Escape the capturing group by escaping special characters and meaning.
	 *
	 * @param  {string} group
	 * @return {string}
	 */
	function escapeGroup (group) {
	  return group.replace(/([=!:$/()])/g, '\\$1')
	}

	/**
	 * Get the flags for a regexp from the options.
	 *
	 * @param  {Object} options
	 * @return {string}
	 */
	function flags (options) {
	  return options && options.sensitive ? '' : 'i'
	}

	/**
	 * Pull out keys from a regexp.
	 *
	 * @param  {!RegExp} path
	 * @param  {Array=}  keys
	 * @return {!RegExp}
	 */
	function regexpToRegexp (path, keys) {
	  if (!keys) { return path }

	  // Use a negative lookahead to match only capturing groups.
	  var groups = path.source.match(/\((?!\?)/g);

	  if (groups) {
	    for (var i = 0; i < groups.length; i++) {
	      keys.push({
	        name: i,
	        prefix: null,
	        delimiter: null,
	        optional: false,
	        repeat: false,
	        partial: false,
	        pattern: null
	      });
	    }
	  }

	  return path
	}

	/**
	 * Transform an array into a regexp.
	 *
	 * @param  {!Array}  path
	 * @param  {Array=}  keys
	 * @param  {Object=} options
	 * @return {!RegExp}
	 */
	function arrayToRegexp (path, keys, options) {
	  var parts = [];

	  for (var i = 0; i < path.length; i++) {
	    parts.push(pathToRegexp(path[i], keys, options).source);
	  }

	  return new RegExp('(?:' + parts.join('|') + ')', flags(options))
	}

	/**
	 * Create a path regexp from string input.
	 *
	 * @param  {string}  path
	 * @param  {Array=}  keys
	 * @param  {Object=} options
	 * @return {!RegExp}
	 */
	function stringToRegexp (path, keys, options) {
	  return tokensToRegExp(parse(path, options), keys, options)
	}

	/**
	 * Expose a function for taking tokens and returning a RegExp.
	 *
	 * @param  {!Array}  tokens
	 * @param  {Array=}  keys
	 * @param  {Object=} options
	 * @return {!RegExp}
	 */
	function tokensToRegExp (tokens, keys, options) {
	  options = options || {};

	  var strict = options.strict;
	  var start = options.start !== false;
	  var end = options.end !== false;
	  var delimiter = escapeString(options.delimiter || DEFAULT_DELIMITER);
	  var delimiters = options.delimiters || DEFAULT_DELIMITERS;
	  var endsWith = [].concat(options.endsWith || []).map(escapeString).concat('$').join('|');
	  var route = start ? '^' : '';
	  var isEndDelimited = tokens.length === 0;

	  // Iterate over the tokens and create our regexp string.
	  for (var i = 0; i < tokens.length; i++) {
	    var token = tokens[i];

	    if (typeof token === 'string') {
	      route += escapeString(token);
	      isEndDelimited = i === tokens.length - 1 && delimiters.indexOf(token[token.length - 1]) > -1;
	    } else {
	      var capture = token.repeat
	        ? '(?:' + token.pattern + ')(?:' + escapeString(token.delimiter) + '(?:' + token.pattern + '))*'
	        : token.pattern;

	      if (keys) { keys.push(token); }

	      if (token.optional) {
	        if (token.partial) {
	          route += escapeString(token.prefix) + '(' + capture + ')?';
	        } else {
	          route += '(?:' + escapeString(token.prefix) + '(' + capture + '))?';
	        }
	      } else {
	        route += escapeString(token.prefix) + '(' + capture + ')';
	      }
	    }
	  }

	  if (end) {
	    if (!strict) { route += '(?:' + delimiter + ')?'; }

	    route += endsWith === '$' ? '$' : '(?=' + endsWith + ')';
	  } else {
	    if (!strict) { route += '(?:' + delimiter + '(?=' + endsWith + '))?'; }
	    if (!isEndDelimited) { route += '(?=' + delimiter + '|' + endsWith + ')'; }
	  }

	  return new RegExp(route, flags(options))
	}

	/**
	 * Normalize the given path string, returning a regular expression.
	 *
	 * An empty array can be passed in for the keys, which will hold the
	 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
	 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
	 *
	 * @param  {(string|RegExp|Array)} path
	 * @param  {Array=}                keys
	 * @param  {Object=}               options
	 * @return {!RegExp}
	 */
	function pathToRegexp (path, keys, options) {
	  if (path instanceof RegExp) {
	    return regexpToRegexp(path, keys)
	  }

	  if (Array.isArray(path)) {
	    return arrayToRegexp(/** @type {!Array} */ (path), keys, options)
	  }

	  return stringToRegexp(/** @type {string} */ (path), keys, options)
	}
	pathToRegexp_1.parse = parse_1;
	pathToRegexp_1.compile = compile_1;
	pathToRegexp_1.tokensToFunction = tokensToFunction_1;
	pathToRegexp_1.tokensToRegExp = tokensToRegExp_1;

	var tempDom = doc.createElement('div');

	var Framework7Component = function Framework7Component(opts, extendContext) {
	  if ( extendContext === void 0 ) extendContext = {};

	  var options = Utils.extend({}, opts);
	  var component = Utils.merge(this, extendContext, { $options: options });

	  // Apply context
	  ('beforeCreate created beforeMount mounted beforeDestroy destroyed').split(' ').forEach(function (cycleKey) {
	    if (options[cycleKey]) { options[cycleKey] = options[cycleKey].bind(component); }
	  });

	  if (options.data) {
	    options.data = options.data.bind(component);
	    // Data
	    Utils.extend(component, options.data());
	  }
	  if (options.render) { options.render = options.render.bind(component); }
	  if (options.methods) {
	    Object.keys(options.methods).forEach(function (methodName) {
	      component[methodName] = options.methods[methodName].bind(component);
	    });
	  }

	  // Bind Events
	  if (options.on) {
	    Object.keys(options.on).forEach(function (eventName) {
	      options.on[eventName] = options.on[eventName].bind(component);
	    });
	  }
	  if (options.once) {
	    Object.keys(options.once).forEach(function (eventName) {
	      options.once[eventName] = options.once[eventName].bind(component);
	    });
	  }

	  if (options.beforeCreate) { options.beforeCreate(); }

	  // Watchers
	  if (options.watch) {
	    Object.keys(options.watch).forEach(function (watchKey) {
	      var dataKeyValue = component[watchKey];
	      Object.defineProperty(component, watchKey, {
	        enumerable: true,
	        configurable: true,
	        set: function set(newValue) {
	          var previousValue = dataKeyValue;
	          dataKeyValue = newValue;
	          if (previousValue === newValue) { return; }
	          options.watch[watchKey].call(component, newValue, previousValue);
	        },
	        get: function get() {
	          return dataKeyValue;
	        },
	      });
	    });
	  }

	  // Render template

	  function render() {
	    var html = '';
	    if (options.render) {
	      html = options.render();
	    } else if (options.template) {
	      if (typeof options.template === 'string') {
	        try {
	          html = Template7.compile(options.template)(component);
	        } catch (err) {
	          throw err;
	        }
	      } else {
	        // Supposed to be function
	        html = options.template(component);
	      }
	    }
	    return html;
	  }

	  var html = render();

	  // Make Dom
	  if (html && typeof html === 'string') {
	    html = html.trim();
	    tempDom.innerHTML = html;
	  } else if (html) {
	    tempDom.innerHTML = '';
	    tempDom.appendChild(html);
	  }

	  // Extend component with $el
	  var el = tempDom.children[0];
	  var $el = $$1(el);
	  component.$el = $el;
	  component.el = el;
	  component.el = el;

	  // Find Events
	  var events = [];
	  $$1(tempDom).find('*').each(function (index, element) {
	    var attrs = [];
	    for (var i = 0; i < element.attributes.length; i += 1) {
	      var attr = element.attributes[i];
	      if (attr.name.indexOf('@') === 0) {
	        attrs.push({
	          name: attr.name,
	          value: attr.value,
	        });
	      }
	    }
	    attrs.forEach(function (attr) {
	      element.removeAttribute(attr.name);
	      var event = attr.name.replace('@', '');
	      var name = event;
	      var stop = false;
	      var prevent = false;
	      var once = false;
	      if (event.indexOf('.') >= 0) {
	        event.split('.').forEach(function (eventNamePart, eventNameIndex) {
	          if (eventNameIndex === 0) { name = eventNamePart; }
	          else {
	            if (eventNamePart === 'stop') { stop = true; }
	            if (eventNamePart === 'prevent') { prevent = true; }
	            if (eventNamePart === 'once') { once = true; }
	          }
	        });
	      }
	      var value = attr.value.toString();
	      events.push({
	        el: element,
	        name: name,
	        once: once,
	        handler: function handler() {
	          var args = [], len = arguments.length;
	          while ( len-- ) args[ len ] = arguments[ len ];

	          var e = args[0];
	          if (stop) { e.stopPropagation(); }
	          if (prevent) { e.preventDefault(); }
	          var methodName;
	          var method;
	          var customArgs = [];
	          if (value.indexOf('(') < 0) {
	            customArgs = args;
	            methodName = value;
	          } else {
	            methodName = value.split('(')[0];
	            value.split('(')[1].split(')')[0].split(',').forEach(function (argument) {
	              var arg = argument.trim();
	              // eslint-disable-next-line
	              if (!isNaN(arg)) { arg = parseFloat(arg); }
	              else if (arg === 'true') { arg = true; }
	              else if (arg === 'false') { arg = false; }
	              else if (arg === 'null') { arg = null; }
	              else if (arg === 'undefined') { arg = undefined; }
	              else if (arg[0] === '"') { arg = arg.replace(/"/g, ''); }
	              else if (arg[0] === '\'') { arg = arg.replace(/'/g, ''); }
	              else if (arg.indexOf('.') > 0) {
	                var deepArg;
	                arg.split('.').forEach(function (path) {
	                  if (!deepArg) { deepArg = component; }
	                  deepArg = deepArg[path];
	                });
	                arg = deepArg;
	              } else {
	                arg = component[arg];
	              }
	              customArgs.push(arg);
	            });
	          }
	          if (methodName.indexOf('.') >= 0) {
	            methodName.split('.').forEach(function (path, pathIndex) {
	              if (!method) { method = component; }
	              if (method[path]) { method = method[path]; }
	              else {
	                throw new Error(("Component doesn't have method \"" + (methodName.split('.').slice(0, pathIndex + 1).join('.')) + "\""));
	              }
	            });
	          } else {
	            if (!component[methodName]) {
	              throw new Error(("Component doesn't have method \"" + methodName + "\""));
	            }
	            method = component[methodName];
	          }
	          method.apply(void 0, customArgs);
	        },
	      });
	    });
	  });

	  // Set styles scope ID
	  var styleEl;
	  if (options.style) {
	    styleEl = doc.createElement('style');
	    styleEl.innerHTML = options.style;
	  }
	  if (options.styleScopeId) {
	    el.setAttribute('data-scope', options.styleScopeId);
	  }

	  // Attach events
	  function attachEvents() {
	    if (options.on) {
	      Object.keys(options.on).forEach(function (eventName) {
	        $el.on(Utils.eventNameToColonCase(eventName), options.on[eventName]);
	      });
	    }
	    if (options.once) {
	      Object.keys(options.once).forEach(function (eventName) {
	        $el.once(Utils.eventNameToColonCase(eventName), options.once[eventName]);
	      });
	    }
	    events.forEach(function (event) {
	      $$1(event.el)[event.once ? 'once' : 'on'](event.name, event.handler);
	    });
	  }

	  function detachEvents() {
	    if (options.on) {
	      Object.keys(options.on).forEach(function (eventName) {
	        $el.off(Utils.eventNameToColonCase(eventName), options.on[eventName]);
	      });
	    }
	    if (options.once) {
	      Object.keys(options.once).forEach(function (eventName) {
	        $el.off(Utils.eventNameToColonCase(eventName), options.once[eventName]);
	      });
	    }
	    events.forEach(function (event) {
	      $$1(event.el).off(event.name, event.handler);
	    });
	  }

	  attachEvents();

	  // Created callback
	  if (options.created) { options.created(); }

	  // Mount
	  component.$mount = function mount(mountMethod) {
	    if (options.beforeMount) { options.beforeMount(); }
	    if (styleEl) { $$1('head').append(styleEl); }
	    if (mountMethod) { mountMethod(el); }
	    if (options.mounted) { options.mounted(); }
	  };

	  // Destroy
	  component.$destroy = function destroy() {
	    if (options.beforeDestroy) { options.beforeDestroy(); }
	    if (styleEl) { $$1(styleEl).remove(); }
	    detachEvents();
	    if (options.destroyed) { options.destroyed(); }
	    // Delete component instance
	    if (el && el.f7Component) {
	      el.f7Component = null;
	      delete el.f7Component;
	    }
	    Utils.deleteProps(component);
	    component = null;
	  };

	  // Store component instance
	  for (var i = 0; i < tempDom.children.length; i += 1) {
	    tempDom.children[i].f7Component = component;
	  }

	  return component;
	};


	var Component = {
	  parse: function parse(componentString) {
	    var callbackName = "f7_component_callback_" + (new Date().getTime());

	    // Template
	    var template;
	    if (componentString.indexOf('<template>') >= 0) {
	      template = componentString
	        .split('<template>')
	        .filter(function (item, index) { return index > 0; })
	        .join('<template>')
	        .split('</template>')
	        .filter(function (item, index, arr) { return index < arr.length - 1; })
	        .join('</template>')
	        .replace(/{{#raw}}([ \n]*)<template/g, '{{#raw}}<template')
	        .replace(/\/template>([ \n]*){{\/raw}}/g, '/template>{{/raw}}')
	        .replace(/([ \n])<template/g, '$1{{#raw}}<template')
	        .replace(/\/template>([ \n])/g, '/template>{{/raw}}$1');
	    }

	    // Styles
	    var style;
	    var styleScopeId = Utils.now();
	    if (componentString.indexOf('<style>') >= 0) {
	      style = componentString.split('<style>')[1].split('</style>')[0];
	    } else if (componentString.indexOf('<style scoped>') >= 0) {
	      style = componentString.split('<style scoped>')[1].split('</style>')[0];
	      style = style.split('\n').map(function (line) {
	        if (line.indexOf('{') >= 0) {
	          if (line.indexOf('{{this}}') >= 0) {
	            return line.replace('{{this}}', ("[data-scope=\"" + styleScopeId + "\"]"));
	          }
	          return ("[data-scope=\"" + styleScopeId + "\"] " + (line.trim()));
	        }
	        return line;
	      }).join('\n');
	    }

	    var scriptContent;
	    if (componentString.indexOf('<script>') >= 0) {
	      var scripts = componentString.split('<script>');
	      scriptContent = scripts[scripts.length - 1].split('</script>')[0].trim();
	    } else {
	      scriptContent = 'return {}';
	    }
	    scriptContent = "window." + callbackName + " = function () {" + scriptContent + "}";

	    // Insert Script El
	    var scriptEl = doc.createElement('script');
	    scriptEl.innerHTML = scriptContent;
	    $$1('head').append(scriptEl);

	    var component = win[callbackName]();

	    // Remove Script El
	    $$1(scriptEl).remove();

	    if (!component.template && !component.render) {
	      component.template = template;
	    }
	    if (style) {
	      component.style = style;
	      component.styleScopeId = styleScopeId;
	    }
	    return component;
	  },
	  create: function create(c, extendContext) {
	    if ( extendContext === void 0 ) extendContext = {};

	    return new Framework7Component(c, extendContext);
	  },
	};

	var History = {
	  queue: [],
	  clearQueue: function clearQueue() {
	    if (History.queue.length === 0) { return; }
	    var currentQueue = History.queue.shift();
	    currentQueue();
	  },
	  routerQueue: [],
	  clearRouterQueue: function clearRouterQueue() {
	    if (History.routerQueue.length === 0) { return; }
	    var currentQueue = History.routerQueue.pop();
	    var router = currentQueue.router;
	    var stateUrl = currentQueue.stateUrl;
	    var action = currentQueue.action;

	    var animate = router.params.animate;
	    if (router.params.pushStateAnimate === false) { animate = false; }

	    if (action === 'back') {
	      router.back({ animate: animate, pushState: false });
	    }
	    if (action === 'load') {
	      router.navigate(stateUrl, { animate: animate, pushState: false });
	    }
	  },
	  handle: function handle(e) {
	    if (History.blockPopstate) { return; }
	    var app = this;
	    // const mainView = app.views.main;
	    var state = e.state;
	    History.previousState = History.state;
	    History.state = state;

	    History.allowChange = true;
	    History.clearQueue();

	    state = History.state;
	    if (!state) { state = {}; }

	    app.views.forEach(function (view) {
	      var router = view.router;
	      var viewState = state[view.id];
	      if (!viewState && view.params.pushState) {
	        viewState = {
	          url: view.router.history[0],
	        };
	      }
	      if (!viewState) { return; }
	      var stateUrl = viewState.url || undefined;

	      var animate = router.params.animate;
	      if (router.params.pushStateAnimate === false) { animate = false; }

	      if (stateUrl !== router.url) {
	        if (router.history.indexOf(stateUrl) >= 0) {
	          // Go Back
	          if (router.allowPageChange) {
	            router.back({ animate: animate, pushState: false });
	          } else {
	            History.routerQueue.push({
	              action: 'back',
	              router: router,
	            });
	          }
	        } else if (router.allowPageChange) {
	          // Load page
	          router.navigate(stateUrl, { animate: animate, pushState: false });
	        } else {
	          History.routerQueue.unshift({
	            action: 'load',
	            stateUrl: stateUrl,
	            router: router,
	          });
	        }
	      }
	    });
	  },
	  initViewState: function initViewState(viewId, viewState) {
	    var newState = Utils.extend({}, (History.state || {}), ( obj = {}, obj[viewId] = viewState, obj ));
	    var obj;
	    History.state = newState;
	    win.history.replaceState(newState, '');
	  },
	  push: function push(viewId, viewState, url) {
	    if (!History.allowChange) {
	      History.queue.push(function () {
	        History.push(viewId, viewState, url);
	      });
	      return;
	    }
	    History.previousState = History.state;
	    var newState = Utils.extend({}, (History.previousState || {}), ( obj = {}, obj[viewId] = viewState, obj ));
	    var obj;
	    History.state = newState;
	    win.history.pushState(newState, '', url);
	  },
	  replace: function replace(viewId, viewState, url) {
	    if (!History.allowChange) {
	      History.queue.push(function () {
	        History.replace(viewId, viewState, url);
	      });
	      return;
	    }
	    History.previousState = History.state;
	    var newState = Utils.extend({}, (History.previousState || {}), ( obj = {}, obj[viewId] = viewState, obj ));
	    var obj;
	    History.state = newState;
	    win.history.replaceState(newState, '', url);
	  },
	  go: function go(index) {
	    History.allowChange = false;
	    win.history.go(index);
	  },
	  back: function back() {
	    History.allowChange = false;
	    win.history.back();
	  },
	  allowChange: true,
	  previousState: {},
	  state: win.history.state,
	  blockPopstate: true,
	  init: function init(app) {
	    $$1(win).on('load', function () {
	      setTimeout(function () {
	        History.blockPopstate = false;
	      }, 0);
	    });

	    if (doc.readyState && doc.readyState === 'complete') {
	      History.blockPopstate = false;
	    }

	    $$1(win).on('popstate', History.handle.bind(app));
	  },
	};

	function SwipeBack(r) {
	  var router = r;
	  var $el = router.$el;
	  var $navbarEl = router.$navbarEl;
	  var app = router.app;
	  var params = router.params;
	  var isTouched = false;
	  var isMoved = false;
	  var touchesStart = {};
	  var isScrolling;
	  var currentPage = [];
	  var previousPage = [];
	  var viewContainerWidth;
	  var touchesDiff;
	  var allowViewTouchMove = true;
	  var touchStartTime;
	  var currentNavbar = [];
	  var previousNavbar = [];
	  var currentNavElements;
	  var previousNavElements;
	  var activeNavBackIcon;
	  var activeNavBackIconText;
	  var previousNavBackIcon;
	  // let previousNavBackIconText;
	  var dynamicNavbar;
	  var separateNavbar;
	  var pageShadow;
	  var pageOpacity;
	  var navbarWidth;

	  var paramsSwipeBackAnimateShadow = params[((app.theme) + "SwipeBackAnimateShadow")];
	  var paramsSwipeBackAnimateOpacity = params[((app.theme) + "SwipeBackAnimateOpacity")];
	  var paramsSwipeBackActiveArea = params[((app.theme) + "SwipeBackActiveArea")];
	  var paramsSwipeBackThreshold = params[((app.theme) + "SwipeBackThreshold")];

	  function handleTouchStart(e) {
	    var swipeBackEnabled = params[((app.theme) + "SwipeBack")];
	    if (!allowViewTouchMove || !swipeBackEnabled || isTouched || (app.swipeout && app.swipeout.el) || !router.allowPageChange) { return; }
	    if ($$1(e.target).closest('.range-slider, .calendar-months').length > 0) { return; }
	    isMoved = false;
	    isTouched = true;
	    isScrolling = undefined;
	    touchesStart.x = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
	    touchesStart.y = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
	    touchStartTime = Utils.now();
	    dynamicNavbar = router.dynamicNavbar;
	    separateNavbar = router.separateNavbar;
	  }
	  function handleTouchMove(e) {
	    if (!isTouched) { return; }
	    var pageX = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX;
	    var pageY = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;
	    if (typeof isScrolling === 'undefined') {
	      isScrolling = !!(isScrolling || Math.abs(pageY - touchesStart.y) > Math.abs(pageX - touchesStart.x)) || pageX < touchesStart.x;
	    }
	    if (isScrolling || e.f7PreventSwipeBack || app.preventSwipeBack) {
	      isTouched = false;
	      return;
	    }
	    if (!isMoved) {
	      // Calc values during first move fired
	      var cancel = false;
	      var target = $$1(e.target);

	      var swipeout = target.closest('.swipeout');
	      if (swipeout.length > 0) {
	        if (!app.rtl && swipeout.find('.swipeout-actions-left').length > 0) { cancel = true; }
	        if (app.rtl && swipeout.find('.swipeout-actions-right').length > 0) { cancel = true; }
	      }

	      currentPage = target.closest('.page');
	      if (currentPage.hasClass('no-swipeback') || target.closest('.no-swipeback').length > 0) { cancel = true; }
	      previousPage = $el.find('.page-previous:not(.stacked)');

	      var notFromBorder = touchesStart.x - $el.offset().left > paramsSwipeBackActiveArea;
	      viewContainerWidth = $el.width();
	      if (app.rtl) {
	        notFromBorder = touchesStart.x < ($el.offset().left - $el[0].scrollLeft) + (viewContainerWidth - paramsSwipeBackActiveArea);
	      } else {
	        notFromBorder = touchesStart.x - $el.offset().left > paramsSwipeBackActiveArea;
	      }
	      if (notFromBorder) { cancel = true; }
	      if (previousPage.length === 0 || currentPage.length === 0) { cancel = true; }
	      if (cancel) {
	        isTouched = false;
	        return;
	      }

	      if (paramsSwipeBackAnimateShadow) {
	        pageShadow = currentPage.find('.page-shadow-effect');
	        if (pageShadow.length === 0) {
	          pageShadow = $$1('<div class="page-shadow-effect"></div>');
	          currentPage.append(pageShadow);
	        }
	      }
	      if (paramsSwipeBackAnimateOpacity) {
	        pageOpacity = previousPage.find('.page-opacity-effect');
	        if (pageOpacity.length === 0) {
	          pageOpacity = $$1('<div class="page-opacity-effect"></div>');
	          previousPage.append(pageOpacity);
	        }
	      }

	      if (dynamicNavbar) {
	        if (separateNavbar) {
	          currentNavbar = $navbarEl.find('.navbar-current:not(.stacked)');
	          previousNavbar = $navbarEl.find('.navbar-previous:not(.stacked)');
	        } else {
	          currentNavbar = currentPage.children('.navbar').children('.navbar-inner');
	          previousNavbar = previousPage.children('.navbar').children('.navbar-inner');
	        }
	        navbarWidth = $navbarEl[0].offsetWidth;
	        currentNavElements = currentNavbar.children('.left, .title, .right, .subnavbar, .fading');
	        previousNavElements = previousNavbar.children('.left, .title, .right, .subnavbar, .fading');
	        if (params.iosAnimateNavbarBackIcon) {
	          if (currentNavbar.hasClass('sliding')) {
	            activeNavBackIcon = currentNavbar.children('.left').find('.back .icon');
	            activeNavBackIconText = currentNavbar.children('.left').find('.back span').eq(0);
	          } else {
	            activeNavBackIcon = currentNavbar.children('.left.sliding').find('.back .icon');
	            activeNavBackIconText = currentNavbar.children('.left.sliding').find('.back span').eq(0);
	          }
	          if (previousNavbar.hasClass('sliding')) {
	            previousNavBackIcon = previousNavbar.children('.left').find('.back .icon');
	            // previousNavBackIconText = previousNavbar.children('left').find('.back span').eq(0);
	          } else {
	            previousNavBackIcon = previousNavbar.children('.left.sliding').find('.back .icon');
	            // previousNavBackIconText = previousNavbar.children('.left.sliding').find('.back span').eq(0);
	          }
	        }
	      }

	      // Close/Hide Any Picker
	      if ($$1('.sheet.modal-in').length > 0 && app.sheet) {
	        app.sheet.close($$1('.sheet.modal-in'));
	      }
	    }
	    e.f7PreventPanelSwipe = true;
	    isMoved = true;
	    app.preventSwipePanelBySwipeBack = true;
	    e.preventDefault();

	    // RTL inverter
	    var inverter = app.rtl ? -1 : 1;

	    // Touches diff
	    touchesDiff = (pageX - touchesStart.x - paramsSwipeBackThreshold) * inverter;
	    if (touchesDiff < 0) { touchesDiff = 0; }
	    var percentage = touchesDiff / viewContainerWidth;

	    // Swipe Back Callback
	    var callbackData = {
	      percentage: percentage,
	      currentPageEl: currentPage[0],
	      previousPageEl: previousPage[0],
	      currentNavbarEl: currentNavbar[0],
	      previousNavbarEl: previousNavbar[0],
	    };
	    $el.trigger('swipeback:move', callbackData);
	    router.emit('swipebackMove', callbackData);

	    // Transform pages
	    var currentPageTranslate = touchesDiff * inverter;
	    var previousPageTranslate = ((touchesDiff / 5) - (viewContainerWidth / 5)) * inverter;
	    if (Device.pixelRatio === 1) {
	      currentPageTranslate = Math.round(currentPageTranslate);
	      previousPageTranslate = Math.round(previousPageTranslate);
	    }

	    currentPage.transform(("translate3d(" + currentPageTranslate + "px,0,0)"));
	    if (paramsSwipeBackAnimateShadow) { pageShadow[0].style.opacity = 1 - (1 * percentage); }

	    if (app.theme !== 'md') {
	      previousPage.transform(("translate3d(" + previousPageTranslate + "px,0,0)"));
	    }
	    if (paramsSwipeBackAnimateOpacity) { pageOpacity[0].style.opacity = 1 - (1 * percentage); }

	    // Dynamic Navbars Animation
	    if (dynamicNavbar) {
	      currentNavElements.each(function (index, navEl) {
	        var $navEl = $$1(navEl);
	        if (!$navEl.is('.subnavbar')) { $navEl[0].style.opacity = (1 - (Math.pow( percentage, 0.33 ))); }
	        if ($navEl[0].className.indexOf('sliding') >= 0 || currentNavbar.hasClass('sliding')) {
	          var activeNavTranslate = percentage * $navEl[0].f7NavbarRightOffset;
	          if (Device.pixelRatio === 1) { activeNavTranslate = Math.round(activeNavTranslate); }
	          $navEl.transform(("translate3d(" + activeNavTranslate + "px,0,0)"));
	          if (params.iosAnimateNavbarBackIcon) {
	            if ($navEl[0].className.indexOf('left') >= 0 && activeNavBackIcon.length > 0) {
	              var iconTranslate = -activeNavTranslate;
	              if (!separateNavbar) {
	                iconTranslate -= navbarWidth * percentage;
	              }
	              activeNavBackIcon.transform(("translate3d(" + iconTranslate + "px,0,0)"));
	            }
	          }
	        }
	      });
	      previousNavElements.each(function (index, navEl) {
	        var $navEl = $$1(navEl);
	        if (!$navEl.is('.subnavbar')) { $navEl[0].style.opacity = (Math.pow( percentage, 3 )); }
	        if ($navEl[0].className.indexOf('sliding') >= 0 || previousNavbar.hasClass('sliding')) {
	          var previousNavTranslate = $navEl[0].f7NavbarLeftOffset * (1 - percentage);
	          if ($navEl[0].className.indexOf('title') >= 0 && activeNavBackIcon && activeNavBackIcon.length && activeNavBackIconText.length) {
	            previousNavTranslate = ($navEl[0].f7NavbarLeftOffset + activeNavBackIconText[0].offsetLeft) * (1 - percentage);
	          } else {
	            previousNavTranslate = $navEl[0].f7NavbarLeftOffset * (1 - percentage);
	          }
	          if (Device.pixelRatio === 1) { previousNavTranslate = Math.round(previousNavTranslate); }
	          $navEl.transform(("translate3d(" + previousNavTranslate + "px,0,0)"));
	          if (params.iosAnimateNavbarBackIcon) {
	            if ($navEl[0].className.indexOf('left') >= 0 && previousNavBackIcon.length > 0) {
	              var iconTranslate = -previousNavTranslate;
	              if (!separateNavbar) {
	                iconTranslate += (navbarWidth / 5) * (1 - percentage);
	              }
	              previousNavBackIcon.transform(("translate3d(" + iconTranslate + "px,0,0)"));
	            }
	          }
	        }
	      });
	    }
	  }
	  function handleTouchEnd() {
	    app.preventSwipePanelBySwipeBack = false;
	    if (!isTouched || !isMoved) {
	      isTouched = false;
	      isMoved = false;
	      return;
	    }
	    isTouched = false;
	    isMoved = false;
	    if (touchesDiff === 0) {
	      $$1([currentPage[0], previousPage[0]]).transform('');
	      if (pageShadow && pageShadow.length > 0) { pageShadow.remove(); }
	      if (pageOpacity && pageOpacity.length > 0) { pageOpacity.remove(); }
	      if (dynamicNavbar) {
	        currentNavElements.transform('').css({ opacity: '' });
	        previousNavElements.transform('').css({ opacity: '' });
	        if (activeNavBackIcon && activeNavBackIcon.length > 0) { activeNavBackIcon.transform(''); }
	        if (previousNavBackIcon && activeNavBackIcon.length > 0) { previousNavBackIcon.transform(''); }
	      }
	      return;
	    }
	    var timeDiff = Utils.now() - touchStartTime;
	    var pageChanged = false;
	    // Swipe back to previous page
	    if (
	      (timeDiff < 300 && touchesDiff > 10) ||
	      (timeDiff >= 300 && touchesDiff > viewContainerWidth / 2)
	    ) {
	      currentPage.removeClass('page-current').addClass(("page-next" + (app.theme === 'md' ? ' page-next-on-right' : '')));
	      previousPage.removeClass('page-previous').addClass('page-current').removeAttr('aria-hidden');
	      if (pageShadow) { pageShadow[0].style.opacity = ''; }
	      if (pageOpacity) { pageOpacity[0].style.opacity = ''; }
	      if (dynamicNavbar) {
	        currentNavbar.removeClass('navbar-current').addClass('navbar-next');
	        previousNavbar.removeClass('navbar-previous').addClass('navbar-current').removeAttr('aria-hidden');
	      }
	      pageChanged = true;
	    }
	    // Reset custom styles
	    // Add transitioning class for transition-duration
	    $$1([currentPage[0], previousPage[0]]).addClass('page-transitioning page-transitioning-swipeback').transform('');

	    if (dynamicNavbar) {
	      currentNavElements.css({ opacity: '' })
	        .each(function (navElIndex, navEl) {
	          var translate = pageChanged ? navEl.f7NavbarRightOffset : 0;
	          var sliding = $$1(navEl);
	          var iconTranslate = pageChanged ? -translate : 0;
	          if (!separateNavbar && pageChanged) { iconTranslate -= navbarWidth; }
	          sliding.transform(("translate3d(" + translate + "px,0,0)"));
	          if (params.iosAnimateNavbarBackIcon) {
	            if (sliding.hasClass('left') && activeNavBackIcon.length > 0) {
	              activeNavBackIcon.addClass('navbar-transitioning').transform(("translate3d(" + iconTranslate + "px,0,0)"));
	            }
	          }
	        }).addClass('navbar-transitioning');

	      previousNavElements.transform('').css({ opacity: '' }).each(function (navElIndex, navEl) {
	        var translate = pageChanged ? 0 : navEl.f7NavbarLeftOffset;
	        var sliding = $$1(navEl);
	        var iconTranslate = pageChanged ? 0 : -translate;
	        if (!separateNavbar && !pageChanged) { iconTranslate += navbarWidth / 5; }
	        sliding.transform(("translate3d(" + translate + "px,0,0)"));
	        if (params.iosAnimateNavbarBackIcon) {
	          if (sliding.hasClass('left') && previousNavBackIcon.length > 0) {
	            previousNavBackIcon.addClass('navbar-transitioning').transform(("translate3d(" + iconTranslate + "px,0,0)"));
	          }
	        }
	      }).addClass('navbar-transitioning');
	    }
	    allowViewTouchMove = false;
	    router.allowPageChange = false;

	    // Swipe Back Callback
	    var callbackData = {
	      currentPage: currentPage[0],
	      previousPage: previousPage[0],
	      currentNavbar: currentNavbar[0],
	      previousNavbar: previousNavbar[0],
	    };

	    if (pageChanged) {
	      // Update Route
	      router.currentRoute = previousPage[0].f7Page.route;
	      router.currentPage = previousPage[0];

	      // Page before animation callback
	      router.pageCallback('beforeOut', currentPage, currentNavbar, 'current', 'next', { route: currentPage[0].f7Page.route, swipeBack: true });
	      router.pageCallback('beforeIn', previousPage, previousNavbar, 'previous', 'current', { route: previousPage[0].f7Page.route, swipeBack: true });

	      $el.trigger('swipeback:beforechange', callbackData);
	      router.emit('swipebackBeforeChange', callbackData);
	    } else {
	      $el.trigger('swipeback:beforereset', callbackData);
	      router.emit('swipebackBeforeReset', callbackData);
	    }

	    currentPage.transitionEnd(function () {
	      $$1([currentPage[0], previousPage[0]]).removeClass('page-transitioning page-transitioning-swipeback');

	      if (dynamicNavbar) {
	        currentNavElements.removeClass('navbar-transitioning').css({ opacity: '' }).transform('');
	        previousNavElements.removeClass('navbar-transitioning').css({ opacity: '' }).transform('');
	        if (activeNavBackIcon && activeNavBackIcon.length > 0) { activeNavBackIcon.removeClass('navbar-transitioning'); }
	        if (previousNavBackIcon && previousNavBackIcon.length > 0) { previousNavBackIcon.removeClass('navbar-transitioning'); }
	      }
	      allowViewTouchMove = true;
	      router.allowPageChange = true;
	      if (pageChanged) {
	        // Update History
	        if (router.history.length === 1) {
	          router.history.unshift(router.url);
	        }
	        router.history.pop();
	        router.saveHistory();

	        // Update push state
	        if (params.pushState) {
	          History.back();
	        }

	        // Page after animation callback
	        router.pageCallback('afterOut', currentPage, currentNavbar, 'current', 'next', { route: currentPage[0].f7Page.route, swipeBack: true });
	        router.pageCallback('afterIn', previousPage, previousNavbar, 'previous', 'current', { route: previousPage[0].f7Page.route, swipeBack: true });

	        // Remove Old Page
	        if (params.stackPages && router.initialPages.indexOf(currentPage[0]) >= 0) {
	          currentPage.addClass('stacked');
	          if (separateNavbar) {
	            currentNavbar.addClass('stacked');
	          }
	        } else {
	          router.pageCallback('beforeRemove', currentPage, currentNavbar, 'next', { swipeBack: true });
	          router.removePage(currentPage);
	          if (separateNavbar) {
	            router.removeNavbar(currentNavbar);
	          }
	        }

	        $el.trigger('swipeback:afterchange', callbackData);
	        router.emit('swipebackAfterChange', callbackData);

	        router.emit('routeChanged', router.currentRoute, router.previousRoute, router);

	        if (params.preloadPreviousPage) {
	          router.back(router.history[router.history.length - 2], { preload: true });
	        }
	      } else {
	        $el.trigger('swipeback:afterreset', callbackData);
	        router.emit('swipebackAfterReset', callbackData);
	      }
	      if (pageShadow && pageShadow.length > 0) { pageShadow.remove(); }
	      if (pageOpacity && pageOpacity.length > 0) { pageOpacity.remove(); }
	    });
	  }

	  function attachEvents() {
	    var passiveListener = (app.touchEvents.start === 'touchstart' && Support.passiveListener) ? { passive: true, capture: false } : false;
	    $el.on(app.touchEvents.start, handleTouchStart, passiveListener);
	    app.on('touchmove:active', handleTouchMove);
	    app.on('touchend:passive', handleTouchEnd);
	  }
	  function detachEvents() {
	    var passiveListener = (app.touchEvents.start === 'touchstart' && Support.passiveListener) ? { passive: true, capture: false } : false;
	    $el.off(app.touchEvents.start, handleTouchStart, passiveListener);
	    app.off('touchmove:active', handleTouchMove);
	    app.off('touchend:passive', handleTouchEnd);
	  }

	  attachEvents();

	  router.on('routerDestroy', detachEvents);
	}

	function redirect (direction, route, options) {
	  var router = this;
	  var redirect = route.route.redirect;
	  if (options.initial && router.params.pushState) {
	    options.replaceState = true; // eslint-disable-line
	    options.history = true; // eslint-disable-line
	  }
	  function redirectResolve(redirectUrl, redirectOptions) {
	    if ( redirectOptions === void 0 ) redirectOptions = {};

	    router.allowPageChange = true;
	    router[direction](redirectUrl, Utils.extend({}, options, redirectOptions));
	  }
	  function redirectReject() {
	    router.allowPageChange = true;
	  }
	  if (typeof redirect === 'function') {
	    router.allowPageChange = false;
	    var redirectUrl = redirect.call(router, route, redirectResolve, redirectReject);
	    if (redirectUrl && typeof redirectUrl === 'string') {
	      router.allowPageChange = true;
	      return router[direction](redirectUrl, options);
	    }
	    return router;
	  }
	  return router[direction](redirect, options);
	}

	function refreshPage() {
	  var router = this;
	  return router.navigate(router.currentRoute.url, {
	    ignoreCache: true,
	    reloadCurrent: true,
	  });
	}

	function forward(el, forwardOptions) {
	  if ( forwardOptions === void 0 ) forwardOptions = {};

	  var router = this;
	  var app = router.app;
	  var view = router.view;

	  var options = Utils.extend({
	    animate: router.params.animate,
	    pushState: true,
	    replaceState: false,
	    history: true,
	    reloadCurrent: router.params.reloadPages,
	    reloadPrevious: false,
	    reloadAll: false,
	    clearPreviousHistory: false,
	    on: {},
	  }, forwardOptions);

	  var dynamicNavbar = router.dynamicNavbar;
	  var separateNavbar = router.separateNavbar;

	  var $viewEl = router.$el;
	  var $newPage = $$1(el);
	  var reload = options.reloadPrevious || options.reloadCurrent || options.reloadAll;
	  var $oldPage;

	  var $navbarEl;
	  var $newNavbarInner;
	  var $oldNavbarInner;

	  if ($newPage.length) {
	    // Remove theme elements
	    router.removeThemeElements($newPage);
	  }

	  if (dynamicNavbar) {
	    $newNavbarInner = $newPage.children('.navbar').children('.navbar-inner');
	    if (separateNavbar) {
	      $navbarEl = router.$navbarEl;
	      if ($newNavbarInner.length > 0) {
	        $newPage.children('.navbar').remove();
	      }
	      if ($newNavbarInner.length === 0 && $newPage[0].f7Page) {
	        // Try from pageData
	        $newNavbarInner = $newPage[0].f7Page.$navbarEl;
	      }
	    }
	  }

	  router.allowPageChange = false;
	  if ($newPage.length === 0) {
	    router.allowPageChange = true;
	    return router;
	  }

	  // Pages In View
	  var $pagesInView = $viewEl
	    .children('.page:not(.stacked)')
	    .filter(function (index, pageInView) { return pageInView !== $newPage[0]; });

	  // Navbars In View
	  var $navbarsInView;
	  if (separateNavbar) {
	    $navbarsInView = $navbarEl
	      .children('.navbar-inner:not(.stacked)')
	      .filter(function (index, navbarInView) { return navbarInView !== $newNavbarInner[0]; });
	  }

	  // Exit when reload previous and only 1 page in view so nothing ro reload
	  if (options.reloadPrevious && $pagesInView.length < 2) {
	    router.allowPageChange = true;
	    return router;
	  }

	  // New Page
	  var newPagePosition = 'next';
	  if (options.reloadCurrent || options.reloadAll) {
	    newPagePosition = 'current';
	  } else if (options.reloadPrevious) {
	    newPagePosition = 'previous';
	  }
	  $newPage
	    .addClass(("page-" + newPagePosition))
	    .removeClass('stacked');

	  if (dynamicNavbar && $newNavbarInner.length) {
	    $newNavbarInner
	      .addClass(("navbar-" + newPagePosition))
	      .removeClass('stacked');
	  }

	  // Find Old Page
	  if (options.reloadCurrent) {
	    $oldPage = $pagesInView.eq($pagesInView.length - 1);
	    if (separateNavbar) {
	      // $oldNavbarInner = $navbarsInView.eq($pagesInView.length - 1);
	      $oldNavbarInner = $$1(app.navbar.getElByPage($oldPage));
	    }
	  } else if (options.reloadPrevious) {
	    $oldPage = $pagesInView.eq($pagesInView.length - 2);
	    if (separateNavbar) {
	      // $oldNavbarInner = $navbarsInView.eq($pagesInView.length - 2);
	      $oldNavbarInner = $$1(app.navbar.getElByPage($oldPage));
	    }
	  } else if (options.reloadAll) {
	    $oldPage = $pagesInView.filter(function (index, pageEl) { return pageEl !== $newPage[0]; });
	    if (separateNavbar) {
	      $oldNavbarInner = $navbarsInView.filter(function (index, navbarEl) { return navbarEl !== $newNavbarInner[0]; });
	    }
	  } else {
	    if ($pagesInView.length > 1) {
	      var i = 0;
	      for (i = 0; i < $pagesInView.length - 1; i += 1) {
	        var oldNavbarInnerEl = app.navbar.getElByPage($pagesInView.eq(i));
	        if (router.params.stackPages) {
	          $pagesInView.eq(i).addClass('stacked');
	          if (separateNavbar) {
	            // $navbarsInView.eq(i).addClass('stacked');
	            $$1(oldNavbarInnerEl).addClass('stacked');
	          }
	        } else {
	          // Page remove event
	          router.pageCallback('beforeRemove', $pagesInView[i], $navbarsInView && $navbarsInView[i], 'previous', undefined, options);
	          router.removePage($pagesInView[i]);
	          if (separateNavbar && oldNavbarInnerEl) {
	            router.removeNavbar(oldNavbarInnerEl);
	          }
	        }
	      }
	    }
	    $oldPage = $viewEl
	      .children('.page:not(.stacked)')
	      .filter(function (index, page) { return page !== $newPage[0]; });
	    if (separateNavbar) {
	      $oldNavbarInner = $navbarEl
	        .children('.navbar-inner:not(.stacked)')
	        .filter(function (index, navbarInner) { return navbarInner !== $newNavbarInner[0]; });
	    }
	  }
	  if (dynamicNavbar && !separateNavbar) {
	    $oldNavbarInner = $oldPage.children('.navbar').children('.navbar-inner');
	  }

	  // Push State
	  if (router.params.pushState && (options.pushState || options.replaceState) && !options.reloadPrevious) {
	    var pushStateRoot = router.params.pushStateRoot || '';
	    History[options.reloadCurrent || options.reloadAll || options.replaceState ? 'replace' : 'push'](
	      view.id,
	      {
	        url: options.route.url,
	      },
	      pushStateRoot + router.params.pushStateSeparator + options.route.url
	    );
	  }

	  if (!options.reloadPrevious) {
	    // Current Page & Navbar
	    router.currentPageEl = $newPage[0];
	    if (dynamicNavbar && $newNavbarInner.length) {
	      router.currentNavbarEl = $newNavbarInner[0];
	    } else {
	      delete router.currentNavbarEl;
	    }

	    // Current Route
	    router.currentRoute = options.route;
	  }

	  // Update router history
	  var url = options.route.url;

	  if (options.history) {
	    if ((options.reloadCurrent && router.history.length) > 0 || options.replaceState) {
	      router.history[router.history.length - (options.reloadPrevious ? 2 : 1)] = url;
	    } else if (options.reloadPrevious) {
	      router.history[router.history.length - 2] = url;
	    } else if (options.reloadAll) {
	      router.history = [url];
	    } else {
	      router.history.push(url);
	    }
	  }
	  router.saveHistory();

	  // Insert new page and navbar
	  var newPageInDom = $newPage.parents(doc).length > 0;
	  var f7Component = $newPage[0].f7Component;
	  if (options.reloadPrevious) {
	    if (f7Component && !newPageInDom) {
	      f7Component.$mount(function (componentEl) {
	        $$1(componentEl).insertBefore($oldPage);
	      });
	    } else {
	      $newPage.insertBefore($oldPage);
	    }
	    if (separateNavbar && $newNavbarInner.length) {
	      if ($oldNavbarInner.length) {
	        $newNavbarInner.insertBefore($oldNavbarInner);
	      } else {
	        if (!router.$navbarEl.parents(doc).length) {
	          router.$el.prepend(router.$navbarEl);
	        }
	        $navbarEl.append($newNavbarInner);
	      }
	    }
	  } else {
	    if ($oldPage.next('.page')[0] !== $newPage[0]) {
	      if (f7Component && !newPageInDom) {
	        f7Component.$mount(function (componentEl) {
	          $viewEl.append(componentEl);
	        });
	      } else {
	        $viewEl.append($newPage[0]);
	      }
	    }
	    if (separateNavbar && $newNavbarInner.length) {
	      if (!router.$navbarEl.parents(doc).length) {
	        router.$el.prepend(router.$navbarEl);
	      }
	      $navbarEl.append($newNavbarInner[0]);
	    }
	  }
	  if (!newPageInDom) {
	    router.pageCallback('mounted', $newPage, $newNavbarInner, newPagePosition, reload ? newPagePosition : 'current', options, $oldPage);
	  }

	  // Remove old page
	  if (options.reloadCurrent && $oldPage.length > 0) {
	    if (router.params.stackPages && router.initialPages.indexOf($oldPage[0]) >= 0) {
	      $oldPage.addClass('stacked');
	      if (separateNavbar) {
	        $oldNavbarInner.addClass('stacked');
	      }
	    } else {
	      // Page remove event
	      router.pageCallback('beforeRemove', $oldPage, $oldNavbarInner, 'previous', undefined, options);
	      router.removePage($oldPage);
	      if (separateNavbar && $oldNavbarInner && $oldNavbarInner.length) {
	        router.removeNavbar($oldNavbarInner);
	      }
	    }
	  } else if (options.reloadAll) {
	    $oldPage.each(function (index, pageEl) {
	      var $oldPageEl = $$1(pageEl);
	      var $oldNavbarInnerEl = $$1(app.navbar.getElByPage($oldPageEl));
	      if (router.params.stackPages && router.initialPages.indexOf($oldPageEl[0]) >= 0) {
	        $oldPageEl.addClass('stacked');
	        if (separateNavbar) {
	          $oldNavbarInnerEl.addClass('stacked');
	        }
	      } else {
	        // Page remove event
	        router.pageCallback('beforeRemove', $oldPageEl, $oldNavbarInner && $oldNavbarInner.eq(index), 'previous', undefined, options);
	        router.removePage($oldPageEl);
	        if (separateNavbar && $oldNavbarInnerEl.length) {
	          router.removeNavbar($oldNavbarInnerEl);
	        }
	      }
	    });
	  } else if (options.reloadPrevious) {
	    if (router.params.stackPages && router.initialPages.indexOf($oldPage[0]) >= 0) {
	      $oldPage.addClass('stacked');
	      if (separateNavbar) {
	        $oldNavbarInner.addClass('stacked');
	      }
	    } else {
	      // Page remove event
	      router.pageCallback('beforeRemove', $oldPage, $oldNavbarInner, 'previous', undefined, options);
	      router.removePage($oldPage);
	      if (separateNavbar && $oldNavbarInner && $oldNavbarInner.length) {
	        router.removeNavbar($oldNavbarInner);
	      }
	    }
	  }

	  // Load Tab
	  if (options.route.route.tab) {
	    router.tabLoad(options.route.route.tab, Utils.extend({}, options, {
	      history: false,
	      pushState: false,
	    }));
	  }

	  // Page init and before init events
	  router.pageCallback('init', $newPage, $newNavbarInner, newPagePosition, reload ? newPagePosition : 'current', options, $oldPage);

	  if (options.reloadCurrent || options.reloadAll) {
	    router.allowPageChange = true;
	    router.pageCallback('beforeIn', $newPage, $newNavbarInner, newPagePosition, 'current', options);
	    router.pageCallback('afterIn', $newPage, $newNavbarInner, newPagePosition, 'current', options);
	    if (options.reloadCurrent && options.clearPreviousHistory) { router.clearPreviousHistory(); }
	    return router;
	  }
	  if (options.reloadPrevious) {
	    router.allowPageChange = true;
	    return router;
	  }

	  // Before animation event
	  router.pageCallback('beforeIn', $newPage, $newNavbarInner, 'next', 'current', options);
	  router.pageCallback('beforeOut', $oldPage, $oldNavbarInner, 'current', 'previous', options);

	  // Animation
	  function afterAnimation() {
	    var pageClasses = 'page-previous page-current page-next';
	    var navbarClasses = 'navbar-previous navbar-current navbar-next';
	    $newPage.removeClass(pageClasses).addClass('page-current').removeAttr('aria-hidden');
	    $oldPage.removeClass(pageClasses).addClass('page-previous').attr('aria-hidden', 'true');
	    if (dynamicNavbar) {
	      $newNavbarInner.removeClass(navbarClasses).addClass('navbar-current').removeAttr('aria-hidden');
	      $oldNavbarInner.removeClass(navbarClasses).addClass('navbar-previous').attr('aria-hidden', 'true');
	    }
	    // After animation event
	    router.allowPageChange = true;
	    router.pageCallback('afterIn', $newPage, $newNavbarInner, 'next', 'current', options);
	    router.pageCallback('afterOut', $oldPage, $oldNavbarInner, 'current', 'previous', options);

	    var keepOldPage = app.theme === 'ios' ? (router.params.preloadPreviousPage || router.params.iosSwipeBack) : router.params.preloadPreviousPage;
	    if (!keepOldPage) {
	      if ($newPage.hasClass('smart-select-page') || $newPage.hasClass('photo-browser-page') || $newPage.hasClass('autocomplete-page')) {
	        keepOldPage = true;
	      }
	    }
	    if (!keepOldPage) {
	      if (router.params.stackPages) {
	        $oldPage.addClass('stacked');
	        if (separateNavbar) {
	          $oldNavbarInner.addClass('stacked');
	        }
	      } else if (!($newPage.attr('data-name') && $newPage.attr('data-name') === 'smart-select-page')) {
	        // Remove event
	        router.pageCallback('beforeRemove', $oldPage, $oldNavbarInner, 'previous', undefined, options);
	        router.removePage($oldPage);
	        if (separateNavbar && $oldNavbarInner.length) {
	          router.removeNavbar($oldNavbarInner);
	        }
	      }
	    }
	    if (options.clearPreviousHistory) { router.clearPreviousHistory(); }
	    router.emit('routeChanged', router.currentRoute, router.previousRoute, router);

	    if (router.params.pushState) {
	      History.clearRouterQueue();
	    }
	  }
	  function setPositionClasses() {
	    var pageClasses = 'page-previous page-current page-next';
	    var navbarClasses = 'navbar-previous navbar-current navbar-next';
	    $oldPage.removeClass(pageClasses).addClass('page-current').removeAttr('aria-hidden');
	    $newPage.removeClass(pageClasses).addClass('page-next').removeAttr('aria-hidden');
	    if (dynamicNavbar) {
	      $oldNavbarInner.removeClass(navbarClasses).addClass('navbar-current').removeAttr('aria-hidden');
	      $newNavbarInner.removeClass(navbarClasses).addClass('navbar-next').removeAttr('aria-hidden');
	    }
	  }
	  if (options.animate) {
	    var delay = router.app.theme === 'md' ? router.params.materialPageLoadDelay : router.params.iosPageLoadDelay;
	    if (delay) {
	      setTimeout(function () {
	        setPositionClasses();
	        router.animate($oldPage, $newPage, $oldNavbarInner, $newNavbarInner, 'forward', function () {
	          afterAnimation();
	        });
	      }, delay);
	    } else {
	      setPositionClasses();
	      router.animate($oldPage, $newPage, $oldNavbarInner, $newNavbarInner, 'forward', function () {
	        afterAnimation();
	      });
	    }
	  } else {
	    afterAnimation();
	  }
	  return router;
	}
	function load(loadParams, loadOptions, ignorePageChange) {
	  if ( loadParams === void 0 ) loadParams = {};
	  if ( loadOptions === void 0 ) loadOptions = {};

	  var router = this;
	  if (!router.allowPageChange && !ignorePageChange) { return router; }
	  var params = loadParams;
	  var options = loadOptions;
	  var url = params.url;
	  var content = params.content;
	  var el = params.el;
	  var pageName = params.pageName;
	  var template = params.template;
	  var templateUrl = params.templateUrl;
	  var component = params.component;
	  var componentUrl = params.componentUrl;

	  if (!options.reloadCurrent &&
	    options.route &&
	    options.route.route &&
	    options.route.route.parentPath &&
	    router.currentRoute.route &&
	    router.currentRoute.route.parentPath === options.route.route.parentPath) {
	    // Do something nested
	    if (options.route.url === router.url) {
	      return false;
	    }
	    // Check for same params
	    var sameParams = Object.keys(options.route.params).length === Object.keys(router.currentRoute.params).length;
	    if (sameParams) {
	      // Check for equal params name
	      Object.keys(options.route.params).forEach(function (paramName) {
	        if (
	          !(paramName in router.currentRoute.params) ||
	          (router.currentRoute.params[paramName] !== options.route.params[paramName])
	        ) {
	          sameParams = false;
	        }
	      });
	    }
	    if (sameParams) {
	      if (options.route.route.tab) {
	        return router.tabLoad(options.route.route.tab, options);
	      }
	      return false;
	    }
	  }

	  if (
	    options.route &&
	    options.route.url &&
	    router.url === options.route.url &&
	    !(options.reloadCurrent || options.reloadPrevious) &&
	    !router.params.allowDuplicateUrls
	  ) {
	    router.allowPageChange = true;
	    return false;
	  }

	  if (!options.route && url) {
	    options.route = router.parseRouteUrl(url);
	    Utils.extend(options.route, { route: { url: url, path: url } });
	  }

	  // Component Callbacks
	  function resolve(pageEl, newOptions) {
	    return router.forward(pageEl, Utils.extend(options, newOptions));
	  }
	  function reject() {
	    router.allowPageChange = true;
	    return router;
	  }

	  if (url || templateUrl || componentUrl) {
	    router.allowPageChange = false;
	  }

	  // Proceed
	  if (content) {
	    router.forward(router.getPageEl(content), options);
	  } else if (template || templateUrl) {
	    // Parse template and send page element
	    try {
	      router.pageTemplateLoader(template, templateUrl, options, resolve, reject);
	    } catch (err) {
	      router.allowPageChange = true;
	      throw err;
	    }
	  } else if (el) {
	    // Load page from specified HTMLElement or by page name in pages container
	    router.forward(router.getPageEl(el), options);
	  } else if (pageName) {
	    // Load page by page name in pages container
	    router.forward(router.$el.children((".page[data-name=\"" + pageName + "\"]")).eq(0), options);
	  } else if (component || componentUrl) {
	    // Load from component (F7/Vue/React/...)
	    try {
	      router.pageComponentLoader(router.el, component, componentUrl, options, resolve, reject);
	    } catch (err) {
	      router.allowPageChange = true;
	      throw err;
	    }
	  } else if (url) {
	    // Load using XHR
	    if (router.xhr) {
	      router.xhr.abort();
	      router.xhr = false;
	    }
	    router.xhrRequest(url, options)
	      .then(function (pageContent) {
	        router.forward(router.getPageEl(pageContent), options);
	      })
	      .catch(function () {
	        router.allowPageChange = true;
	      });
	  }
	  return router;
	}
	function navigate(navigateParams, navigateOptions) {
	  if ( navigateOptions === void 0 ) navigateOptions = {};

	  var router = this;
	  var url;
	  var createRoute;
	  if (typeof navigateParams === 'string') {
	    url = navigateParams;
	  } else {
	    url = navigateParams.url;
	    createRoute = navigateParams.route;
	  }
	  var app = router.app;
	  if (!router.view) {
	    if (app.views.main) {
	      app.views.main.router.navigate(url, navigateOptions);
	    }
	    return router;
	  }
	  if (url === '#' || url === '') {
	    return router;
	  }

	  var navigateUrl = url.replace('./', '');
	  if (navigateUrl[0] !== '/' && navigateUrl.indexOf('#') !== 0) {
	    var currentPath = router.currentRoute.parentPath || router.currentRoute.path;
	    navigateUrl = ((currentPath ? (currentPath + "/") : '/') + navigateUrl)
	      .replace('///', '/')
	      .replace('//', '/');
	  }
	  var route;
	  if (createRoute) {
	    route = Utils.extend(router.parseRouteUrl(navigateUrl), {
	      route: Utils.extend({}, createRoute),
	    });
	  } else {
	    route = router.findMatchingRoute(navigateUrl);
	  }

	  if (!route) {
	    return router;
	  }

	  if (route.route.redirect) {
	    return redirect.call(router, 'navigate', route, navigateOptions);
	  }

	  var options = {};
	  if (route.route.options) {
	    Utils.extend(options, route.route.options, navigateOptions, { route: route });
	  } else {
	    Utils.extend(options, navigateOptions, { route: route });
	  }
	  if (options && options.context) {
	    route.context = options.context;
	    options.route.context = options.context;
	  }
	  ('popup popover sheet loginScreen actions customModal').split(' ').forEach(function (modalLoadProp) {
	    if (route.route[modalLoadProp]) {
	      router.modalLoad(modalLoadProp, route, options);
	    }
	  });
	  ('url content component pageName el componentUrl template templateUrl').split(' ').forEach(function (pageLoadProp) {
	    if (route.route[pageLoadProp]) {
	      router.load(( obj = {}, obj[pageLoadProp] = route.route[pageLoadProp], obj ), options);
	      var obj;
	    }
	  });
	  // Async
	  function asyncResolve(resolveParams, resolveOptions) {
	    router.allowPageChange = false;
	    var resolvedAsModal = false;
	    if (resolveOptions && resolveOptions.context) {
	      if (!route.context) { route.context = resolveOptions.context; }
	      else { route.context = Utils.extend({}, route.context, resolveOptions.context); }
	      options.route.context = route.context;
	    }
	    ('popup popover sheet loginScreen actions customModal').split(' ').forEach(function (modalLoadProp) {
	      if (resolveParams[modalLoadProp]) {
	        resolvedAsModal = true;
	        var modalRoute = Utils.extend({}, route, { route: resolveParams });
	        router.allowPageChange = true;
	        router.modalLoad(modalLoadProp, modalRoute, Utils.extend(options, resolveOptions));
	      }
	    });
	    if (resolvedAsModal) { return; }
	    router.load(resolveParams, Utils.extend(options, resolveOptions), true);
	  }
	  function asyncReject() {
	    router.allowPageChange = true;
	  }
	  if (route.route.async) {
	    router.allowPageChange = false;

	    route.route.async.call(router, route, router.currentRoute, asyncResolve, asyncReject);
	  }
	  // Return Router
	  return router;
	}

	function tabLoad(tabRoute, loadOptions) {
	  if ( loadOptions === void 0 ) loadOptions = {};

	  var router = this;
	  var options = Utils.extend({
	    animate: router.params.animate,
	    pushState: true,
	    history: true,
	    parentPageEl: null,
	    preload: false,
	    on: {},
	  }, loadOptions);

	  var currentRoute;
	  var previousRoute;
	  if (options.route) {
	    // Set Route
	    if (!options.preload && options.route !== router.currentRoute) {
	      previousRoute = router.previousRoute;
	      router.currentRoute = options.route;
	    }
	    if (options.preload) {
	      currentRoute = options.route;
	      previousRoute = router.currentRoute;
	    } else {
	      currentRoute = router.currentRoute;
	      if (!previousRoute) { previousRoute = router.previousRoute; }
	    }

	    // Update Browser History
	    if (router.params.pushState && options.pushState && !options.reloadPrevious) {
	      History.replace(
	        router.view.id,
	        {
	          url: options.route.url,
	        },
	        (router.params.pushStateRoot || '') + router.params.pushStateSeparator + options.route.url
	      );
	    }

	    // Update Router History
	    if (options.history) {
	      router.history[Math.max(router.history.length - 1, 0)] = options.route.url;
	      router.saveHistory();
	    }
	  }

	  // Show Tab
	  var $parentPageEl = $$1(options.parentPageEl || router.currentPageEl);
	  var tabEl;
	  if ($parentPageEl.length && $parentPageEl.find(("#" + (tabRoute.id))).length) {
	    tabEl = $parentPageEl.find(("#" + (tabRoute.id))).eq(0);
	  } else if (router.view.selector) {
	    tabEl = (router.view.selector) + " #" + (tabRoute.id);
	  } else {
	    tabEl = "#" + (tabRoute.id);
	  }
	  var tabShowResult = router.app.tab.show({
	    tabEl: tabEl,
	    animate: options.animate,
	    tabRoute: options.route,
	  });

	  var $newTabEl = tabShowResult.$newTabEl;
	  var $oldTabEl = tabShowResult.$oldTabEl;
	  var animated = tabShowResult.animated;
	  var onTabsChanged = tabShowResult.onTabsChanged;

	  if ($newTabEl && $newTabEl.parents('.page').length > 0 && options.route) {
	    var tabParentPageData = $newTabEl.parents('.page')[0].f7Page;
	    if (tabParentPageData && options.route) {
	      tabParentPageData.route = options.route;
	    }
	  }

	  // Tab Content Loaded
	  function onTabLoaded(contentEl) {
	    // Remove theme elements
	    router.removeThemeElements($newTabEl);

	    var tabEventTarget = $newTabEl;
	    if (typeof contentEl !== 'string') { tabEventTarget = $$1(contentEl); }

	    tabEventTarget.trigger('tab:init tab:mounted', tabRoute);
	    router.emit('tabInit tabMounted', $newTabEl[0], tabRoute);

	    if ($oldTabEl && router.params.unloadTabContent) {
	      if (animated) {
	        onTabsChanged(function () {
	          router.tabRemove($oldTabEl, $newTabEl, tabRoute);
	        });
	      } else {
	        router.tabRemove($oldTabEl, $newTabEl, tabRoute);
	      }
	    }
	  }
	  if (!router.params.unloadTabContent) {
	    if ($newTabEl[0].f7RouterTabLoaded) { return router; }
	  }

	  // Load Tab Content
	  function loadTab(loadTabParams, loadTabOptions) {
	    // Load Tab Props
	    var url = loadTabParams.url;
	    var content = loadTabParams.content;
	    var el = loadTabParams.el;
	    var template = loadTabParams.template;
	    var templateUrl = loadTabParams.templateUrl;
	    var component = loadTabParams.component;
	    var componentUrl = loadTabParams.componentUrl;
	    // Component/Template Callbacks
	    function resolve(contentEl) {
	      router.allowPageChange = true;
	      if (!contentEl) { return; }
	      if (typeof contentEl === 'string') {
	        $newTabEl.html(contentEl);
	      } else {
	        $newTabEl.html('');
	        if (contentEl.f7Component) {
	          contentEl.f7Component.$mount(function (componentEl) {
	            $newTabEl.append(componentEl);
	          });
	        } else {
	          $newTabEl.append(contentEl);
	        }
	      }
	      if (!router.params.unloadTabContent) {
	        $newTabEl[0].f7RouterTabLoaded = true;
	      }
	      onTabLoaded(contentEl);
	    }
	    function reject() {
	      router.allowPageChange = true;
	      return router;
	    }

	    if (content) {
	      resolve(content);
	    } else if (template || templateUrl) {
	      try {
	        router.tabTemplateLoader(template, templateUrl, loadTabOptions, resolve, reject);
	      } catch (err) {
	        router.allowPageChange = true;
	        throw err;
	      }
	    } else if (el) {
	      resolve(el);
	    } else if (component || componentUrl) {
	      // Load from component (F7/Vue/React/...)
	      try {
	        router.tabComponentLoader($newTabEl[0], component, componentUrl, loadTabOptions, resolve, reject);
	      } catch (err) {
	        router.allowPageChange = true;
	        throw err;
	      }
	    } else if (url) {
	      // Load using XHR
	      if (router.xhr) {
	        router.xhr.abort();
	        router.xhr = false;
	      }
	      router.xhrRequest(url, loadTabOptions)
	        .then(function (tabContent) {
	          resolve(tabContent);
	        })
	        .catch(function () {
	          router.allowPageChange = true;
	        });
	    }
	  }

	  ('url content component el componentUrl template templateUrl').split(' ').forEach(function (tabLoadProp) {
	    if (tabRoute[tabLoadProp]) {
	      loadTab(( obj = {}, obj[tabLoadProp] = tabRoute[tabLoadProp], obj ), options);
	      var obj;
	    }
	  });

	  // Async
	  function asyncResolve(resolveParams, resolveOptions) {
	    loadTab(resolveParams, Utils.extend(options, resolveOptions));
	  }
	  function asyncReject() {
	    router.allowPageChange = true;
	  }
	  if (tabRoute.async) {
	    tabRoute.async.call(router, currentRoute, previousRoute, asyncResolve, asyncReject);
	  }
	  return router;
	}
	function tabRemove($oldTabEl, $newTabEl, tabRoute) {
	  var router = this;
	  var hasTabComponentChild;
	  $oldTabEl.children().each(function (index, tabChild) {
	    if (tabChild.f7Component) {
	      hasTabComponentChild = true;
	      $$1(tabChild).trigger('tab:beforeremove', tabRoute);
	      tabChild.f7Component.$destroy();
	    }
	  });
	  if (!hasTabComponentChild) {
	    $oldTabEl.trigger('tab:beforeremove', tabRoute);
	  }
	  router.emit('tabBeforeRemove', $oldTabEl[0], $newTabEl[0], tabRoute);
	  router.removeTabContent($oldTabEl[0], tabRoute);
	}

	function modalLoad(modalType, route, loadOptions) {
	  if ( loadOptions === void 0 ) loadOptions = {};

	  var router = this;
	  var app = router.app;

	  var options = Utils.extend({
	    animate: router.params.animate,
	    pushState: true,
	    history: true,
	    on: {},
	  }, loadOptions);

	  var modalParams = Utils.extend({}, route.route[modalType]);
	  var modalRoute = route.route;

	  function onModalLoaded() {
	    // Create Modal
	    var modal = app[modalType].create(modalParams);
	    modalRoute.modalInstance = modal;

	    var hasEl = modal.el;

	    function closeOnSwipeBack() {
	      modal.close();
	    }
	    modal.on('modalOpen', function () {
	      if (!hasEl) {
	        // Remove theme elements
	        router.removeThemeElements(modal.el);

	        // Emit events
	        modal.$el.trigger(((modalType.toLowerCase()) + ":init " + (modalType.toLowerCase()) + ":mounted"), route, modal);
	        router.emit(("modalInit " + modalType + "Init " + modalType + "Mounted"), modal.el, route, modal);
	      }
	      router.once('swipeBackMove', closeOnSwipeBack);
	    });
	    modal.on('modalClose', function () {
	      router.off('swipeBackMove', closeOnSwipeBack);
	      if (!modal.closeByRouter) {
	        router.back();
	      }
	    });

	    modal.on('modalClosed', function () {
	      modal.$el.trigger(((modalType.toLowerCase()) + ":beforeremove"), route, modal);
	      modal.emit(("modalBeforeRemove " + modalType + "BeforeRemove"), modal.el, route, modal);
	      var modalComponent = modal.el.f7Component;
	      if (modalComponent) {
	        modalComponent.$destroy();
	      }
	      Utils.nextTick(function () {
	        if (modalComponent || modalParams.component) {
	          router.removeModal(modal.el);
	        }
	        modal.destroy();
	        delete modalRoute.modalInstance;
	      });
	    });

	    if (options.route) {
	      // Update Browser History
	      if (router.params.pushState && options.pushState) {
	        History.push(
	          router.view.id,
	          {
	            url: options.route.url,
	            modal: modalType,
	          },
	          (router.params.pushStateRoot || '') + router.params.pushStateSeparator + options.route.url
	        );
	      }

	      // Set Route
	      if (options.route !== router.currentRoute) {
	        router.currentRoute = Utils.extend(options.route, { modal: modal });
	      }

	      // Update Router History
	      if (options.history) {
	        router.history.push(options.route.url);
	        router.saveHistory();
	      }
	    }

	    if (hasEl) {
	      // Remove theme elements
	      router.removeThemeElements(modal.el);

	      // Emit events
	      modal.$el.trigger(((modalType.toLowerCase()) + ":init " + (modalType.toLowerCase()) + ":mounted"), route, modal);
	      router.emit(("modalInit " + modalType + "Init " + modalType + "Mounted"), modal.el, route, modal);
	    }

	    // Open
	    modal.open();
	  }

	  // Load Modal Content
	  function loadModal(loadModalParams, loadModalOptions) {
	    // Load Modal Props
	    var url = loadModalParams.url;
	    var content = loadModalParams.content;
	    var template = loadModalParams.template;
	    var templateUrl = loadModalParams.templateUrl;
	    var component = loadModalParams.component;
	    var componentUrl = loadModalParams.componentUrl;

	    // Component/Template Callbacks
	    function resolve(contentEl) {
	      if (contentEl) {
	        if (typeof contentEl === 'string') {
	          modalParams.content = contentEl;
	        } else if (contentEl.f7Component) {
	          contentEl.f7Component.$mount(function (componentEl) {
	            modalParams.el = componentEl;
	            app.root.append(componentEl);
	          });
	        } else {
	          modalParams.el = contentEl;
	        }
	        onModalLoaded();
	      }
	    }
	    function reject() {
	      router.allowPageChange = true;
	      return router;
	    }

	    if (content) {
	      resolve(content);
	    } else if (template || templateUrl) {
	      try {
	        router.modalTemplateLoader(template, templateUrl, loadModalOptions, resolve, reject);
	      } catch (err) {
	        router.allowPageChange = true;
	        throw err;
	      }
	    } else if (component || componentUrl) {
	      // Load from component (F7/Vue/React/...)
	      try {
	        router.modalComponentLoader(app.root[0], component, componentUrl, loadModalOptions, resolve, reject);
	      } catch (err) {
	        router.allowPageChange = true;
	        throw err;
	      }
	    } else if (url) {
	      // Load using XHR
	      if (router.xhr) {
	        router.xhr.abort();
	        router.xhr = false;
	      }
	      router.xhrRequest(url, loadModalOptions)
	        .then(function (modalContent) {
	          modalParams.content = modalContent;
	          onModalLoaded();
	        })
	        .catch(function () {
	          router.allowPageChange = true;
	        });
	    } else {
	      onModalLoaded();
	    }
	  }

	  var foundLoadProp;
	  ('url content component el componentUrl template templateUrl').split(' ').forEach(function (modalLoadProp) {
	    if (modalParams[modalLoadProp] && !foundLoadProp) {
	      foundLoadProp = true;
	      loadModal(( obj = {}, obj[modalLoadProp] = modalParams[modalLoadProp], obj ), options);
	      var obj;
	    }
	  });
	  if (!foundLoadProp && modalType === 'actions') {
	    onModalLoaded();
	  }

	  // Async
	  function asyncResolve(resolveParams, resolveOptions) {
	    loadModal(resolveParams, Utils.extend(options, resolveOptions));
	  }
	  function asyncReject() {
	    router.allowPageChange = true;
	  }
	  if (modalParams.async) {
	    modalParams.async.call(router, options.route, router.currentRoute, asyncResolve, asyncReject);
	  }
	  return router;
	}
	function modalRemove(modal) {
	  Utils.extend(modal, { closeByRouter: true });
	  modal.close();
	}

	function backward(el, backwardOptions) {
	  var router = this;
	  var app = router.app;
	  var view = router.view;

	  var options = Utils.extend({
	    animate: router.params.animate,
	    pushState: true,
	  }, backwardOptions);

	  var dynamicNavbar = router.dynamicNavbar;
	  var separateNavbar = router.separateNavbar;

	  var $newPage = $$1(el);
	  var $oldPage = router.$el.children('.page-current');

	  if ($newPage.length) {
	    // Remove theme elements
	    router.removeThemeElements($newPage);
	  }

	  var $navbarEl;
	  var $newNavbarInner;
	  var $oldNavbarInner;

	  if (dynamicNavbar) {
	    $newNavbarInner = $newPage.children('.navbar').children('.navbar-inner');
	    if (separateNavbar) {
	      $navbarEl = router.$navbarEl;
	      if ($newNavbarInner.length > 0) {
	        $newPage.children('.navbar').remove();
	      }
	      if ($newNavbarInner.length === 0 && $newPage[0].f7Page) {
	        // Try from pageData
	        $newNavbarInner = $newPage[0].f7Page.$navbarEl;
	      }
	      $oldNavbarInner = $navbarEl.find('.navbar-current');
	    } else {
	      $oldNavbarInner = $oldPage.children('.navbar').children('.navbar-inner');
	    }
	  }

	  router.allowPageChange = false;
	  if ($newPage.length === 0 || $oldPage.length === 0) {
	    router.allowPageChange = true;
	    return router;
	  }

	  // Remove theme elements
	  router.removeThemeElements($newPage);

	  // New Page
	  $newPage
	    .addClass('page-previous')
	    .removeClass('stacked')
	    .removeAttr('aria-hidden');

	  if (dynamicNavbar && $newNavbarInner.length > 0) {
	    $newNavbarInner
	      .addClass('navbar-previous')
	      .removeClass('stacked')
	      .removeAttr('aria-hidden');
	  }


	  // Remove previous page in case of "forced"
	  var backIndex;
	  if (options.force) {
	    if ($oldPage.prev('.page-previous:not(.stacked)').length > 0 || $oldPage.prev('.page-previous').length === 0) {
	      if (router.history.indexOf(options.route.url) >= 0) {
	        backIndex = router.history.length - router.history.indexOf(options.route.url) - 1;
	        router.history = router.history.slice(0, router.history.indexOf(options.route.url) + 2);
	        view.history = router.history;
	      } else if (router.history[[router.history.length - 2]]) {
	        router.history[router.history.length - 2] = options.route.url;
	      } else {
	        router.history.unshift(router.url);
	      }

	      if (backIndex && router.params.stackPages) {
	        $oldPage.prevAll('.page-previous').each(function (index, pageToRemove) {
	          var $pageToRemove = $$1(pageToRemove);
	          var $navbarToRemove;
	          if (separateNavbar) {
	            // $navbarToRemove = $oldNavbarInner.prevAll('.navbar-previous').eq(index);
	            $navbarToRemove = $$1(app.navbar.getElByPage($pageToRemove));
	          }
	          if ($pageToRemove[0] !== $newPage[0] && $pageToRemove.index() > $newPage.index()) {
	            if (router.initialPages.indexOf($pageToRemove[0]) >= 0) {
	              $pageToRemove.addClass('stacked');
	              if (separateNavbar) {
	                $navbarToRemove.addClass('stacked');
	              }
	            } else {
	              router.pageCallback('beforeRemove', $pageToRemove, $navbarToRemove, 'previous', undefined, options);
	              router.removePage($pageToRemove);
	              if (separateNavbar && $navbarToRemove.length > 0) {
	                router.removeNavbar($navbarToRemove);
	              }
	            }
	          }
	        });
	      } else {
	        var $pageToRemove = $oldPage.prev('.page-previous:not(.stacked)');
	        var $navbarToRemove;
	        if (separateNavbar) {
	          // $navbarToRemove = $oldNavbarInner.prev('.navbar-inner:not(.stacked)');
	          $navbarToRemove = $$1(app.navbar.getElByPage($pageToRemove));
	        }
	        if (router.params.stackPages && router.initialPages.indexOf($pageToRemove[0]) >= 0) {
	          $pageToRemove.addClass('stacked');
	          $navbarToRemove.addClass('stacked');
	        } else if ($pageToRemove.length > 0) {
	          router.pageCallback('beforeRemove', $pageToRemove, $navbarToRemove, 'previous', undefined, options);
	          router.removePage($pageToRemove);
	          if (separateNavbar && $navbarToRemove.length) {
	            router.removeNavbar($navbarToRemove);
	          }
	        }
	      }
	    }
	  }

	  // Insert new page
	  var newPageInDom = $newPage.parents(doc).length > 0;
	  var f7Component = $newPage[0].f7Component;

	  function insertPage() {
	    if ($newPage.next($oldPage).length === 0) {
	      if (!newPageInDom && f7Component) {
	        f7Component.$mount(function (componentEl) {
	          $$1(componentEl).insertBefore($oldPage);
	        });
	      } else {
	        $newPage.insertBefore($oldPage);
	      }
	    }
	    if (separateNavbar && $newNavbarInner.length) {
	      $newNavbarInner.insertBefore($oldNavbarInner);
	      if ($oldNavbarInner.length > 0) {
	        $newNavbarInner.insertBefore($oldNavbarInner);
	      } else {
	        if (!router.$navbarEl.parents(doc).length) {
	          router.$el.prepend(router.$navbarEl);
	        }
	        $navbarEl.append($newNavbarInner);
	      }
	    }
	    if (!newPageInDom) {
	      router.pageCallback('mounted', $newPage, $newNavbarInner, 'previous', 'current', options, $oldPage);
	    }
	  }

	  if (options.preload) {
	    // Insert Page
	    insertPage();
	    // Tab route
	    if (options.route.route.tab) {
	      router.tabLoad(options.route.route.tab, Utils.extend({}, options, {
	        history: false,
	        pushState: false,
	        preload: true,
	      }));
	    }
	    // Page init and before init events
	    router.pageCallback('init', $newPage, $newNavbarInner, 'previous', 'current', options, $oldPage);
	    if ($newPage.prevAll('.page-previous:not(.stacked)').length > 0) {
	      $newPage.prevAll('.page-previous:not(.stacked)').each(function (index, pageToRemove) {
	        var $pageToRemove = $$1(pageToRemove);
	        var $navbarToRemove;
	        if (separateNavbar) {
	          // $navbarToRemove = $newNavbarInner.prevAll('.navbar-previous:not(.stacked)').eq(index);
	          $navbarToRemove = $$1(app.navbar.getElByPage($pageToRemove));
	        }
	        if (router.params.stackPages && router.initialPages.indexOf(pageToRemove) >= 0) {
	          $pageToRemove.addClass('stacked');
	          if (separateNavbar) {
	            $navbarToRemove.addClass('stacked');
	          }
	        } else {
	          router.pageCallback('beforeRemove', $pageToRemove, $navbarToRemove, 'previous', undefined);
	          router.removePage($pageToRemove);
	          if (separateNavbar && $navbarToRemove.length) {
	            router.removeNavbar($navbarToRemove);
	          }
	        }
	      });
	    }
	    router.allowPageChange = true;
	    return router;
	  }

	  // History State
	  if (router.params.pushState && options.pushState) {
	    if (backIndex) { History.go(-backIndex); }
	    else { History.back(); }
	  }

	  // Update History
	  if (router.history.length === 1) {
	    router.history.unshift(router.url);
	  }
	  router.history.pop();
	  router.saveHistory();

	  // Current Page & Navbar
	  router.currentPageEl = $newPage[0];
	  if (dynamicNavbar && $newNavbarInner.length) {
	    router.currentNavbarEl = $newNavbarInner[0];
	  } else {
	    delete router.currentNavbarEl;
	  }

	  // Current Route
	  router.currentRoute = options.route;

	  // Insert Page
	  insertPage();

	  // Load Tab
	  if (options.route.route.tab) {
	    router.tabLoad(options.route.route.tab, Utils.extend({}, options, {
	      history: false,
	      pushState: false,
	    }));
	  }

	  // Page init and before init events
	  router.pageCallback('init', $newPage, $newNavbarInner, 'previous', 'current', options, $oldPage);

	  // Before animation callback
	  router.pageCallback('beforeIn', $newPage, $newNavbarInner, 'previous', 'current', options);
	  router.pageCallback('beforeOut', $oldPage, $oldNavbarInner, 'current', 'next', options);

	  // Animation
	  function afterAnimation() {
	    // Set classes
	    var pageClasses = 'page-previous page-current page-next';
	    var navbarClasses = 'navbar-previous navbar-current navbar-next';
	    $newPage.removeClass(pageClasses).addClass('page-current').removeAttr('aria-hidden');
	    $oldPage.removeClass(pageClasses).addClass('page-next').attr('aria-hidden', 'true');
	    if (dynamicNavbar) {
	      $newNavbarInner.removeClass(navbarClasses).addClass('navbar-current').removeAttr('aria-hidden');
	      $oldNavbarInner.removeClass(navbarClasses).addClass('navbar-next').attr('aria-hidden', 'true');
	    }

	    // After animation event
	    router.pageCallback('afterIn', $newPage, $newNavbarInner, 'previous', 'current', options);
	    router.pageCallback('afterOut', $oldPage, $oldNavbarInner, 'current', 'next', options);

	    // Remove Old Page
	    if (router.params.stackPages && router.initialPages.indexOf($oldPage[0]) >= 0) {
	      $oldPage.addClass('stacked');
	      if (separateNavbar) {
	        $oldNavbarInner.addClass('stacked');
	      }
	    } else {
	      router.pageCallback('beforeRemove', $oldPage, $oldNavbarInner, 'next', undefined, options);
	      router.removePage($oldPage);
	      if (separateNavbar && $oldNavbarInner.length) {
	        router.removeNavbar($oldNavbarInner);
	      }
	    }

	    router.allowPageChange = true;
	    router.emit('routeChanged', router.currentRoute, router.previousRoute, router);

	    // Preload previous page
	    var preloadPreviousPage = app.theme === 'ios' ? (router.params.preloadPreviousPage || router.params.iosSwipeBack) : router.params.preloadPreviousPage;
	    if (preloadPreviousPage) {
	      router.back(router.history[router.history.length - 2], { preload: true });
	    }
	    if (router.params.pushState) {
	      History.clearRouterQueue();
	    }
	  }

	  function setPositionClasses() {
	    var pageClasses = 'page-previous page-current page-next';
	    var navbarClasses = 'navbar-previous navbar-current navbar-next';
	    $oldPage.removeClass(pageClasses).addClass('page-current');
	    $newPage.removeClass(pageClasses).addClass('page-previous').removeAttr('aria-hidden');
	    if (dynamicNavbar) {
	      $oldNavbarInner.removeClass(navbarClasses).addClass('navbar-current');
	      $newNavbarInner.removeClass(navbarClasses).addClass('navbar-previous').removeAttr('aria-hidden');
	    }
	  }

	  if (options.animate) {
	    setPositionClasses();
	    router.animate($oldPage, $newPage, $oldNavbarInner, $newNavbarInner, 'backward', function () {
	      afterAnimation();
	    });
	  } else {
	    afterAnimation();
	  }

	  return router;
	}
	function loadBack(backParams, backOptions, ignorePageChange) {
	  var router = this;

	  if (!router.allowPageChange && !ignorePageChange) { return router; }
	  var params = backParams;
	  var options = backOptions;
	  var url = params.url;
	  var content = params.content;
	  var el = params.el;
	  var pageName = params.pageName;
	  var template = params.template;
	  var templateUrl = params.templateUrl;
	  var component = params.component;
	  var componentUrl = params.componentUrl;

	  if (
	    options.route.url &&
	    router.url === options.route.url &&
	    !(options.reloadCurrent || options.reloadPrevious) &&
	    !router.params.allowDuplicateUrls
	  ) {
	    return false;
	  }

	  if (!options.route && url) {
	    options.route = router.parseRouteUrl(url);
	  }

	  // Component Callbacks
	  function resolve(pageEl, newOptions) {
	    return router.backward(pageEl, Utils.extend(options, newOptions));
	  }
	  function reject() {
	    router.allowPageChange = true;
	    return router;
	  }

	  if (url || templateUrl || componentUrl) {
	    router.allowPageChange = false;
	  }

	  // Proceed
	  if (content) {
	    router.backward(router.getPageEl(content), options);
	  } else if (template || templateUrl) {
	    // Parse template and send page element
	    try {
	      router.pageTemplateLoader(template, templateUrl, options, resolve, reject);
	    } catch (err) {
	      router.allowPageChange = true;
	      throw err;
	    }
	  } else if (el) {
	    // Load page from specified HTMLElement or by page name in pages container
	    router.backward(router.getPageEl(el), options);
	  } else if (pageName) {
	    // Load page by page name in pages container
	    router.backward(router.$el.children((".page[data-name=\"" + pageName + "\"]")).eq(0), options);
	  } else if (component || componentUrl) {
	    // Load from component (F7/Vue/React/...)
	    try {
	      router.pageComponentLoader(router.el, component, componentUrl, options, resolve, reject);
	    } catch (err) {
	      router.allowPageChange = true;
	      throw err;
	    }
	  } else if (url) {
	    // Load using XHR
	    if (router.xhr) {
	      router.xhr.abort();
	      router.xhr = false;
	    }
	    router.xhrRequest(url, options)
	      .then(function (pageContent) {
	        router.backward(router.getPageEl(pageContent), options);
	      })
	      .catch(function () {
	        router.allowPageChange = true;
	      });
	  }
	  return router;
	}
	function back() {
	  var args = [], len = arguments.length;
	  while ( len-- ) args[ len ] = arguments[ len ];

	  var navigateUrl;
	  var navigateOptions;
	  if (typeof args[0] === 'object') {
	    navigateOptions = args[0] || {};
	  } else {
	    navigateUrl = args[0];
	    navigateOptions = args[1] || {};
	  }

	  var router = this;
	  var app = router.app;
	  if (!router.view) {
	    app.views.main.router.back(navigateUrl, navigateOptions);
	    return router;
	  }

	  var currentRouteIsModal = router.currentRoute.modal;
	  var modalType;
	  if (!currentRouteIsModal) {
	    ('popup popover sheet loginScreen actions customModal').split(' ').forEach(function (modalLoadProp) {
	      if (router.currentRoute.route[modalLoadProp]) {
	        currentRouteIsModal = true;
	        modalType = modalLoadProp;
	      }
	    });
	  }
	  if (currentRouteIsModal) {
	    var modalToClose = router.currentRoute.modal ||
	                         router.currentRoute.route.modalInstance ||
	                         app[modalType].get();
	    var previousUrl = router.history[router.history.length - 2];
	    var previousRoute = router.findMatchingRoute(previousUrl);
	    if (!previousRoute && previousUrl) {
	      previousRoute = {
	        url: previousUrl,
	        path: previousUrl.split('?')[0],
	        query: Utils.parseUrlQuery(previousUrl),
	        route: {
	          path: previousUrl.split('?')[0],
	          url: previousUrl,
	        },
	      };
	    }
	    if (!previousRoute || !modalToClose) {
	      return router;
	    }
	    if (router.params.pushState && navigateOptions.pushState !== false) {
	      History.back();
	    }
	    router.currentRoute = previousRoute;
	    router.history.pop();
	    router.saveHistory();
	    router.modalRemove(modalToClose);
	    return router;
	  }
	  var $previousPage = router.$el.children('.page-current').prevAll('.page-previous').eq(0);
	  if (!navigateOptions.force && $previousPage.length > 0) {
	    if (router.params.pushState && $previousPage[0].f7Page && router.history[router.history.length - 2] !== $previousPage[0].f7Page.route.url) {
	      router.back(router.history[router.history.length - 2], Utils.extend(navigateOptions, { force: true }));
	      return router;
	    }
	    router.loadBack({ el: $previousPage }, Utils.extend(navigateOptions, {
	      route: $previousPage[0].f7Page.route,
	    }));
	    return router;
	  }

	  // Navigate URL
	  if (navigateUrl === '#') {
	    navigateUrl = undefined;
	  }
	  if (navigateUrl && navigateUrl[0] !== '/' && navigateUrl.indexOf('#') !== 0) {
	    navigateUrl = ((router.path || '/') + navigateUrl).replace('//', '/');
	  }
	  if (!navigateUrl && router.history.length > 1) {
	    navigateUrl = router.history[router.history.length - 2];
	  }

	  // Find route to load
	  var route = router.findMatchingRoute(navigateUrl);
	  if (!route) {
	    if (navigateUrl) {
	      route = {
	        url: navigateUrl,
	        path: navigateUrl.split('?')[0],
	        query: Utils.parseUrlQuery(navigateUrl),
	        route: {
	          path: navigateUrl.split('?')[0],
	          url: navigateUrl,
	        },
	      };
	    }
	  }
	  if (!route) {
	    return router;
	  }

	  if (route.route.redirect) {
	    return redirect.call(router, 'back', route, navigateOptions);
	  }

	  var options = {};
	  if (route.route.options) {
	    Utils.extend(options, route.route.options, navigateOptions, { route: route });
	  } else {
	    Utils.extend(options, navigateOptions, { route: route });
	  }

	  if (options && options.context) {
	    route.context = options.context;
	    options.route.context = options.context;
	  }

	  if (options.force && router.params.stackPages) {
	    router.$el.children('.page-previous.stacked').each(function (index, pageEl) {
	      if (pageEl.f7Page && pageEl.f7Page.route && pageEl.f7Page.route.url === route.url) {
	        router.loadBack({ el: pageEl }, options);
	      }
	    });
	  }

	  ('url content component pageName el componentUrl template templateUrl').split(' ').forEach(function (pageLoadProp) {
	    if (route.route[pageLoadProp]) {
	      router.loadBack(( obj = {}, obj[pageLoadProp] = route.route[pageLoadProp], obj ), options);
	      var obj;
	    }
	  });
	  // Async
	  function asyncResolve(resolveParams, resolveOptions) {
	    router.allowPageChange = false;
	    if (resolveOptions && resolveOptions.context) {
	      if (!route.context) { route.context = resolveOptions.context; }
	      else { route.context = Utils.extend({}, route.context, resolveOptions.context); }
	      options.route.context = route.context;
	    }
	    router.loadBack(resolveParams, Utils.extend(options, resolveOptions), true);
	  }
	  function asyncReject() {
	    router.allowPageChange = true;
	  }
	  if (route.route.async) {
	    router.allowPageChange = false;

	    route.route.async.call(router, route, router.currentRoute, asyncResolve, asyncReject);
	  }
	  // Return Router
	  return router;
	}

	function clearPreviousHistory() {
	  var router = this;
	  var app = router.app;
	  var separateNavbar = router.separateNavbar;
	  var url = router.history[router.history.length - 1];

	  var $currentPageEl = $$1(router.currentPageEl);

	  var $pagesToRemove = router.$el
	    .children('.page:not(.stacked)')
	    .filter(function (index, pageInView) { return pageInView !== $currentPageEl[0]; });

	  $pagesToRemove.each(function (index, pageEl) {
	    var $oldPageEl = $$1(pageEl);
	    var $oldNavbarInnerEl = $$1(app.navbar.getElByPage($oldPageEl));
	    if (router.params.stackPages && router.initialPages.indexOf($oldPageEl[0]) >= 0) {
	      $oldPageEl.addClass('stacked');
	      if (separateNavbar) {
	        $oldNavbarInnerEl.addClass('stacked');
	      }
	    } else {
	      // Page remove event
	      router.pageCallback('beforeRemove', $oldPageEl, $oldNavbarInnerEl, 'previous', undefined, {});
	      router.removePage($oldPageEl);
	      if (separateNavbar && $oldNavbarInnerEl.length) {
	        router.removeNavbar($oldNavbarInnerEl);
	      }
	    }
	  });

	  router.history = [url];
	  router.view.history = [url];
	  router.saveHistory();
	}

	var Router = (function (Framework7Class$$1) {
	  function Router(app, view) {
	    Framework7Class$$1.call(this, {}, [typeof view === 'undefined' ? app : view]);
	    var router = this;

	    // Is App Router
	    router.isAppRouter = typeof view === 'undefined';

	    if (router.isAppRouter) {
	      // App Router
	      Utils.extend(false, router, {
	        app: app,
	        params: app.params.view,
	        routes: app.routes || [],
	        cache: app.cache,
	      });
	    } else {
	      // View Router
	      Utils.extend(false, router, {
	        app: app,
	        view: view,
	        viewId: view.id,
	        params: view.params,
	        routes: view.routes,
	        $el: view.$el,
	        el: view.el,
	        $navbarEl: view.$navbarEl,
	        navbarEl: view.navbarEl,
	        history: view.history,
	        scrollHistory: view.scrollHistory,
	        cache: app.cache,
	        dynamicNavbar: app.theme === 'ios' && view.params.iosDynamicNavbar,
	        separateNavbar: app.theme === 'ios' && view.params.iosDynamicNavbar && view.params.iosSeparateDynamicNavbar,
	        initialPages: [],
	        initialNavbars: [],
	      });
	    }

	    // Install Modules
	    router.useModules();

	    // Temporary Dom
	    router.tempDom = doc.createElement('div');

	    // AllowPageChage
	    router.allowPageChange = true;

	    // Current Route
	    var currentRoute = {};
	    var previousRoute = {};
	    Object.defineProperty(router, 'currentRoute', {
	      enumerable: true,
	      configurable: true,
	      set: function set(newRoute) {
	        if ( newRoute === void 0 ) newRoute = {};

	        previousRoute = Utils.extend({}, currentRoute);
	        currentRoute = newRoute;
	        if (!currentRoute) { return; }
	        router.url = currentRoute.url;
	        router.emit('routeChange', newRoute, previousRoute, router);
	      },
	      get: function get() {
	        return currentRoute;
	      },
	    });
	    Object.defineProperty(router, 'previousRoute', {
	      enumerable: true,
	      configurable: true,
	      get: function get() {
	        return previousRoute;
	      },
	      set: function set(newRoute) {
	        previousRoute = newRoute;
	      },
	    });

	    Utils.extend(router, {
	      // Load
	      forward: forward,
	      load: load,
	      navigate: navigate,
	      refreshPage: refreshPage,
	      // Tab
	      tabLoad: tabLoad,
	      tabRemove: tabRemove,
	      // Modal
	      modalLoad: modalLoad,
	      modalRemove: modalRemove,
	      // Back
	      backward: backward,
	      loadBack: loadBack,
	      back: back,
	      // Clear history
	      clearPreviousHistory: clearPreviousHistory,
	    });

	    return router;
	  }

	  if ( Framework7Class$$1 ) Router.__proto__ = Framework7Class$$1;
	  Router.prototype = Object.create( Framework7Class$$1 && Framework7Class$$1.prototype );
	  Router.prototype.constructor = Router;
	  Router.prototype.animatableNavElements = function animatableNavElements (newNavbarInner, oldNavbarInner) {
	    var router = this;
	    var dynamicNavbar = router.dynamicNavbar;
	    var animateIcon = router.params.iosAnimateNavbarBackIcon;

	    var newNavEls;
	    var oldNavEls;
	    function animatableNavEl(el, navbarInner) {
	      var $el = $$1(el);
	      var isSliding = $el.hasClass('sliding') || navbarInner.hasClass('sliding');
	      var isSubnavbar = $el.hasClass('subnavbar');
	      var needsOpacityTransition = isSliding ? !isSubnavbar : true;
	      var hasIcon = isSliding && animateIcon && $el.hasClass('left') && $el.find('.back .icon').length > 0;
	      var $iconEl;
	      if (hasIcon) { $iconEl = $el.find('.back .icon'); }
	      return {
	        $el: $el,
	        $iconEl: $iconEl,
	        hasIcon: hasIcon,
	        leftOffset: $el[0].f7NavbarLeftOffset,
	        rightOffset: $el[0].f7NavbarRightOffset,
	        isSliding: isSliding,
	        isSubnavbar: isSubnavbar,
	        needsOpacityTransition: needsOpacityTransition,
	      };
	    }
	    if (dynamicNavbar) {
	      newNavEls = [];
	      oldNavEls = [];
	      newNavbarInner.children('.left, .right, .title, .subnavbar').each(function (index, navEl) {
	        newNavEls.push(animatableNavEl(navEl, newNavbarInner));
	      });
	      oldNavbarInner.children('.left, .right, .title, .subnavbar').each(function (index, navEl) {
	        oldNavEls.push(animatableNavEl(navEl, oldNavbarInner));
	      });
	      [oldNavEls, newNavEls].forEach(function (navEls) {
	        navEls.forEach(function (navEl) {
	          var n = navEl;
	          var isSliding = navEl.isSliding;
	          var $el = navEl.$el;
	          var otherEls = navEls === oldNavEls ? newNavEls : oldNavEls;
	          if (!(isSliding && $el.hasClass('title') && otherEls)) { return; }
	          otherEls.forEach(function (otherNavEl) {
	            if (otherNavEl.$el.hasClass('left') && otherNavEl.hasIcon) {
	              var iconTextEl = otherNavEl.$el.find('.back span')[0];
	              n.leftOffset += iconTextEl ? iconTextEl.offsetLeft : 0;
	            }
	          });
	        });
	      });
	    }

	    return { newNavEls: newNavEls, oldNavEls: oldNavEls };
	  };
	  Router.prototype.animateWithCSS = function animateWithCSS (oldPage, newPage, oldNavbarInner, newNavbarInner, direction, callback) {
	    var router = this;
	    var dynamicNavbar = router.dynamicNavbar;
	    var separateNavbar = router.separateNavbar;
	    var ios = router.app.theme === 'ios';
	    // Router Animation class
	    var routerTransitionClass = "router-transition-" + direction + " router-transition-css-" + direction;

	    var newNavEls;
	    var oldNavEls;
	    var navbarWidth = 0;

	    if (ios && dynamicNavbar) {
	      if (!separateNavbar) {
	        navbarWidth = newNavbarInner[0].offsetWidth;
	      }
	      var navEls = router.animatableNavElements(newNavbarInner, oldNavbarInner);
	      newNavEls = navEls.newNavEls;
	      oldNavEls = navEls.oldNavEls;
	    }

	    function animateNavbars(progress) {
	      if (ios && dynamicNavbar) {
	        newNavEls.forEach(function (navEl) {
	          var $el = navEl.$el;
	          var offset = direction === 'forward' ? navEl.rightOffset : navEl.leftOffset;
	          if (navEl.isSliding) {
	            $el.transform(("translate3d(" + (offset * (1 - progress)) + "px,0,0)"));
	          }
	          if (navEl.hasIcon) {
	            if (direction === 'forward') {
	              navEl.$iconEl.transform(("translate3d(" + ((-offset - navbarWidth) * (1 - progress)) + "px,0,0)"));
	            } else {
	              navEl.$iconEl.transform(("translate3d(" + ((-offset + (navbarWidth / 5)) * (1 - progress)) + "px,0,0)"));
	            }
	          }
	        });
	        oldNavEls.forEach(function (navEl) {
	          var $el = navEl.$el;
	          var offset = direction === 'forward' ? navEl.leftOffset : navEl.rightOffset;
	          if (navEl.isSliding) {
	            $el.transform(("translate3d(" + (offset * (progress)) + "px,0,0)"));
	          }
	          if (navEl.hasIcon) {
	            if (direction === 'forward') {
	              navEl.$iconEl.transform(("translate3d(" + ((-offset + (navbarWidth / 5)) * (progress)) + "px,0,0)"));
	            } else {
	              navEl.$iconEl.transform(("translate3d(" + ((-offset - navbarWidth) * (progress)) + "px,0,0)"));
	            }
	          }
	        });
	      }
	    }

	    // AnimationEnd Callback
	    function onDone() {
	      if (router.dynamicNavbar) {
	        if (newNavbarInner.hasClass('sliding')) {
	          newNavbarInner.find('.title, .left, .right, .left .icon, .subnavbar').transform('');
	        } else {
	          newNavbarInner.find('.sliding').transform('');
	        }
	        if (oldNavbarInner.hasClass('sliding')) {
	          oldNavbarInner.find('.title, .left, .right, .left .icon, .subnavbar').transform('');
	        } else {
	          oldNavbarInner.find('.sliding').transform('');
	        }
	      }
	      router.$el.removeClass(routerTransitionClass);
	      if (callback) { callback(); }
	    }

	    (direction === 'forward' ? newPage : oldPage).animationEnd(function () {
	      onDone();
	    });

	    // Animate
	    if (dynamicNavbar) {
	      // Prepare Navbars
	      animateNavbars(0);
	      Utils.nextTick(function () {
	        // Add class, start animation
	        animateNavbars(1);
	        router.$el.addClass(routerTransitionClass);
	      });
	    } else {
	      // Add class, start animation
	      router.$el.addClass(routerTransitionClass);
	    }
	  };
	  Router.prototype.animateWithJS = function animateWithJS (oldPage, newPage, oldNavbarInner, newNavbarInner, direction, callback) {
	    var router = this;
	    var dynamicNavbar = router.dynamicNavbar;
	    var separateNavbar = router.separateNavbar;
	    var ios = router.app.theme === 'ios';
	    var duration = ios ? 400 : 250;
	    var routerTransitionClass = "router-transition-" + direction + " router-transition-js-" + direction;

	    var startTime = null;
	    var done = false;

	    var newNavEls;
	    var oldNavEls;
	    var navbarWidth = 0;

	    if (ios && dynamicNavbar) {
	      if (!separateNavbar) {
	        navbarWidth = newNavbarInner[0].offsetWidth;
	      }
	      var navEls = router.animatableNavElements(newNavbarInner, oldNavbarInner);
	      newNavEls = navEls.newNavEls;
	      oldNavEls = navEls.oldNavEls;
	    }

	    var $shadowEl;
	    var $opacityEl;

	    if (ios) {
	      $shadowEl = $$1('<div class="page-shadow-effect"></div>');
	      $opacityEl = $$1('<div class="page-opacity-effect"></div>');

	      if (direction === 'forward') {
	        newPage.append($shadowEl);
	        oldPage.append($opacityEl);
	      } else {
	        newPage.append($opacityEl);
	        oldPage.append($shadowEl);
	      }
	    }
	    var easing = Utils.bezier(0.25, 0.1, 0.25, 1);

	    function onDone() {
	      newPage.transform('').css('opacity', '');
	      oldPage.transform('').css('opacity', '');
	      if (ios) {
	        $shadowEl.remove();
	        $opacityEl.remove();
	        if (dynamicNavbar) {
	          newNavEls.forEach(function (navEl) {
	            navEl.$el.transform('');
	            navEl.$el.css('opacity', '');
	          });
	          oldNavEls.forEach(function (navEl) {
	            navEl.$el.transform('');
	            navEl.$el.css('opacity', '');
	          });
	          newNavEls = [];
	          oldNavEls = [];
	        }
	      }

	      router.$el.removeClass(routerTransitionClass);

	      if (callback) { callback(); }
	    }

	    function render() {
	      var time = Utils.now();
	      if (!startTime) { startTime = time; }
	      var progress = Math.max(Math.min((time - startTime) / duration, 1), 0);
	      var easeProgress = easing(progress);

	      if (progress >= 1) {
	        done = true;
	      }
	      var inverter = router.app.rtl ? -1 : 1;
	      if (ios) {
	        if (direction === 'forward') {
	          newPage.transform(("translate3d(" + ((1 - easeProgress) * 100 * inverter) + "%,0,0)"));
	          oldPage.transform(("translate3d(" + (-easeProgress * 20 * inverter) + "%,0,0)"));
	          $shadowEl[0].style.opacity = easeProgress;
	          $opacityEl[0].style.opacity = easeProgress;
	        } else {
	          newPage.transform(("translate3d(" + (-(1 - easeProgress) * 20 * inverter) + "%,0,0)"));
	          oldPage.transform(("translate3d(" + (easeProgress * 100 * inverter) + "%,0,0)"));
	          $shadowEl[0].style.opacity = 1 - easeProgress;
	          $opacityEl[0].style.opacity = 1 - easeProgress;
	        }
	        if (dynamicNavbar) {
	          newNavEls.forEach(function (navEl) {
	            var $el = navEl.$el;
	            var offset = direction === 'forward' ? navEl.rightOffset : navEl.leftOffset;
	            if (navEl.needsOpacityTransition) {
	              $el[0].style.opacity = easeProgress;
	            }
	            if (navEl.isSliding) {
	              $el.transform(("translate3d(" + (offset * (1 - easeProgress)) + "px,0,0)"));
	            }
	            if (navEl.hasIcon) {
	              if (direction === 'forward') {
	                navEl.$iconEl.transform(("translate3d(" + ((-offset - navbarWidth) * (1 - easeProgress)) + "px,0,0)"));
	              } else {
	                navEl.$iconEl.transform(("translate3d(" + ((-offset + (navbarWidth / 5)) * (1 - easeProgress)) + "px,0,0)"));
	              }
	            }
	          });
	          oldNavEls.forEach(function (navEl) {
	            var $el = navEl.$el;
	            var offset = direction === 'forward' ? navEl.leftOffset : navEl.rightOffset;
	            if (navEl.needsOpacityTransition) {
	              $el[0].style.opacity = (1 - easeProgress);
	            }
	            if (navEl.isSliding) {
	              $el.transform(("translate3d(" + (offset * (easeProgress)) + "px,0,0)"));
	            }
	            if (navEl.hasIcon) {
	              if (direction === 'forward') {
	                navEl.$iconEl.transform(("translate3d(" + ((-offset + (navbarWidth / 5)) * (easeProgress)) + "px,0,0)"));
	              } else {
	                navEl.$iconEl.transform(("translate3d(" + ((-offset - navbarWidth) * (easeProgress)) + "px,0,0)"));
	              }
	            }
	          });
	        }
	      } else if (direction === 'forward') {
	        newPage.transform(("translate3d(0, " + ((1 - easeProgress) * 56) + "px,0)"));
	        newPage.css('opacity', easeProgress);
	      } else {
	        oldPage.transform(("translate3d(0, " + (easeProgress * 56) + "px,0)"));
	        oldPage.css('opacity', 1 - easeProgress);
	      }

	      if (done) {
	        onDone();
	        return;
	      }
	      Utils.nextFrame(render);
	    }

	    router.$el.addClass(routerTransitionClass);

	    Utils.nextFrame(render);
	  };
	  Router.prototype.animate = function animate () {
	    var args = [], len = arguments.length;
	    while ( len-- ) args[ len ] = arguments[ len ];

	    // Args: oldPage, newPage, oldNavbarInner, newNavbarInner, direction, callback
	    var router = this;
	    if (router.params.animateCustom) {
	      router.params.animateCustom.apply(router, args);
	    } else if (router.params.animateWithJS) {
	      router.animateWithJS.apply(router, args);
	    } else {
	      router.animateWithCSS.apply(router, args);
	    }
	  };
	  Router.prototype.removeModal = function removeModal (modalEl) {
	    var router = this;
	    router.removeEl(modalEl);
	  };
	  // eslint-disable-next-line
	  Router.prototype.removeTabContent = function removeTabContent (tabEl) {
	    var $tabEl = $$1(tabEl);
	    $tabEl.html('');
	  };
	  Router.prototype.removeNavbar = function removeNavbar (el) {
	    var router = this;
	    router.removeEl(el);
	  };
	  Router.prototype.removePage = function removePage (el) {
	    var router = this;
	    router.removeEl(el);
	  };
	  Router.prototype.removeEl = function removeEl (el) {
	    if (!el) { return; }
	    var router = this;
	    var $el = $$1(el);
	    if ($el.length === 0) { return; }
	    if ($el[0].f7Component && $el[0].f7Component.$destroy) {
	      $el[0].f7Component.$destroy();
	    }
	    $el.find('.tab').each(function (tabIndex, tabEl) {
	      $$1(tabEl).children().each(function (index, tabChild) {
	        if (tabChild.f7Component) {
	          $$1(tabChild).trigger('tab:beforeremove');
	          tabChild.f7Component.$destroy();
	        }
	      });
	    });
	    if (!router.params.removeElements) {
	      return;
	    }
	    if (router.params.removeElementsWithTimeout) {
	      setTimeout(function () {
	        $el.remove();
	      }, router.params.removeElementsTimeout);
	    } else {
	      $el.remove();
	    }
	  };
	  Router.prototype.getPageEl = function getPageEl (content) {
	    var router = this;
	    if (typeof content === 'string') {
	      router.tempDom.innerHTML = content;
	    } else {
	      if ($$1(content).hasClass('page')) {
	        return content;
	      }
	      router.tempDom.innerHTML = '';
	      $$1(router.tempDom).append(content);
	    }

	    return router.findElement('.page', router.tempDom);
	  };
	  Router.prototype.findElement = function findElement (stringSelector, container, notStacked) {
	    var router = this;
	    var view = router.view;
	    var app = router.app;

	    // Modals Selector
	    var modalsSelector = '.popup, .dialog, .popover, .actions-modal, .sheet-modal, .login-screen, .page';

	    var $container = $$1(container);
	    var selector = stringSelector;
	    if (notStacked) { selector += ':not(.stacked)'; }

	    var found = $container
	      .find(selector)
	      .filter(function (index, el) { return $$1(el).parents(modalsSelector).length === 0; });

	    if (found.length > 1) {
	      if (typeof view.selector === 'string') {
	        // Search in related view
	        found = $container.find(((view.selector) + " " + selector));
	      }
	      if (found.length > 1) {
	        // Search in main view
	        found = $container.find(("." + (app.params.viewMainClass) + " " + selector));
	      }
	    }
	    if (found.length === 1) { return found; }

	    // Try to find not stacked
	    if (!notStacked) { found = router.findElement(selector, $container, true); }
	    if (found && found.length === 1) { return found; }
	    if (found && found.length > 1) { return $$1(found[0]); }
	    return undefined;
	  };
	  Router.prototype.flattenRoutes = function flattenRoutes (routes) {
	    var this$1 = this;
	    if ( routes === void 0 ) routes = this.routes;

	    var flattenedRoutes = [];
	    routes.forEach(function (route) {
	      if ('routes' in route) {
	        var mergedPathsRoutes = route.routes.map(function (childRoute) {
	          var cRoute = Utils.extend({}, childRoute);
	          cRoute.path = (((route.path) + "/" + (cRoute.path))).replace('///', '/').replace('//', '/');
	          return cRoute;
	        });
	        flattenedRoutes = flattenedRoutes.concat(route, this$1.flattenRoutes(mergedPathsRoutes));
	      } else if ('tabs' in route && route.tabs) {
	        var mergedPathsRoutes$1 = route.tabs.map(function (tabRoute) {
	          var tRoute = Utils.extend({}, route, {
	            path: (((route.path) + "/" + (tabRoute.path))).replace('///', '/').replace('//', '/'),
	            parentPath: route.path,
	            tab: tabRoute,
	          });
	          delete tRoute.tabs;
	          return tRoute;
	        });
	        flattenedRoutes = flattenedRoutes.concat(this$1.flattenRoutes(mergedPathsRoutes$1));
	      } else {
	        flattenedRoutes.push(route);
	      }
	    });
	    return flattenedRoutes;
	  };
	  // eslint-disable-next-line
	  Router.prototype.parseRouteUrl = function parseRouteUrl (url) {
	    if (!url) { return {}; }
	    var query = Utils.parseUrlQuery(url);
	    var hash = url.split('#')[1];
	    var params = {};
	    var path = url.split('#')[0].split('?')[0];
	    return {
	      query: query,
	      hash: hash,
	      params: params,
	      url: url,
	      path: path,
	    };
	  };
	  Router.prototype.findTabRoute = function findTabRoute (tabEl) {
	    var router = this;
	    var $tabEl = $$1(tabEl);
	    var parentPath = router.currentRoute.route.parentPath;
	    var tabId = $tabEl.attr('id');
	    var flattenedRoutes = router.flattenRoutes(router.routes);
	    var foundTabRoute;
	    flattenedRoutes.forEach(function (route) {
	      if (
	        route.parentPath === parentPath &&
	        route.tab &&
	        route.tab.id === tabId
	      ) {
	        foundTabRoute = route;
	      }
	    });
	    return foundTabRoute;
	  };
	  Router.prototype.findRouteByKey = function findRouteByKey (key, value) {
	    var router = this;
	    var routes = router.routes;
	    var flattenedRoutes = router.flattenRoutes(routes);
	    var matchingRoute;

	    flattenedRoutes.forEach(function (route) {
	      if (matchingRoute) { return; }
	      if (route[key] === value) {
	        matchingRoute = route;
	      }
	    });
	    return matchingRoute;
	  };
	  Router.prototype.findMatchingRoute = function findMatchingRoute (url) {
	    if (!url) { return undefined; }
	    var router = this;
	    var routes = router.routes;
	    var flattenedRoutes = router.flattenRoutes(routes);
	    var ref = router.parseRouteUrl(url);
	    var path = ref.path;
	    var query = ref.query;
	    var hash = ref.hash;
	    var params = ref.params;
	    var matchingRoute;
	    flattenedRoutes.forEach(function (route) {
	      if (matchingRoute) { return; }
	      var keys = [];

	      var pathsToMatch = [route.path];
	      if (route.alias) {
	        if (typeof route.alias === 'string') { pathsToMatch.push(route.alias); }
	        else if (Array.isArray(route.alias)) {
	          route.alias.forEach(function (aliasPath) {
	            pathsToMatch.push(aliasPath);
	          });
	        }
	      }

	      var matched;
	      pathsToMatch.forEach(function (pathToMatch) {
	        if (matched) { return; }
	        matched = pathToRegexp_1(pathToMatch, keys).exec(path);
	      });

	      if (matched) {
	        keys.forEach(function (keyObj, index) {
	          var paramValue = matched[index + 1];
	          params[keyObj.name] = paramValue;
	        });

	        var parentPath;
	        if (route.parentPath) {
	          parentPath = path.split('/').slice(0, route.parentPath.split('/').length - 1).join('/');
	        }

	        matchingRoute = {
	          query: query,
	          hash: hash,
	          params: params,
	          url: url,
	          path: path,
	          parentPath: parentPath,
	          route: route,
	          name: route.name,
	        };
	      }
	    });
	    return matchingRoute;
	  };
	  Router.prototype.removeFromXhrCache = function removeFromXhrCache (url) {
	    var router = this;
	    var xhrCache = router.cache.xhr;
	    var index = false;
	    for (var i = 0; i < xhrCache.length; i += 1) {
	      if (xhrCache[i].url === url) { index = i; }
	    }
	    if (index !== false) { xhrCache.splice(index, 1); }
	  };
	  Router.prototype.xhrRequest = function xhrRequest (requestUrl, options) {
	    var router = this;
	    var params = router.params;
	    var ignoreCache = options.ignoreCache;
	    var url = requestUrl;

	    var hasQuery = url.indexOf('?') >= 0;
	    if (params.passRouteQueryToRequest &&
	      options &&
	      options.route &&
	      options.route.query &&
	      Object.keys(options.route.query).length
	    ) {
	      url += "" + (hasQuery ? '&' : '?') + (Utils.serializeObject(options.route.query));
	      hasQuery = true;
	    }

	    if (params.passRouteParamsToRequest &&
	      options &&
	      options.route &&
	      options.route.params &&
	      Object.keys(options.route.params).length
	    ) {
	      url += "" + (hasQuery ? '&' : '?') + (Utils.serializeObject(options.route.params));
	      hasQuery = true;
	    }

	    if (url.indexOf('{{') >= 0 &&
	      options &&
	      options.route &&
	      options.route.params &&
	      Object.keys(options.route.params).length
	    ) {
	      Object.keys(options.route.params).forEach(function (paramName) {
	        var regExp = new RegExp(("{{" + paramName + "}}"), 'g');
	        url = url.replace(regExp, options.route.params[paramName] || '');
	      });
	    }
	    // should we ignore get params or not
	    if (params.xhrCacheIgnoreGetParameters && url.indexOf('?') >= 0) {
	      url = url.split('?')[0];
	    }
	    return Utils.promise(function (resolve, reject) {
	      if (params.xhrCache && !ignoreCache && url.indexOf('nocache') < 0 && params.xhrCacheIgnore.indexOf(url) < 0) {
	        for (var i = 0; i < router.cache.xhr.length; i += 1) {
	          var cachedUrl = router.cache.xhr[i];
	          if (cachedUrl.url === url) {
	            // Check expiration
	            if (Utils.now() - cachedUrl.time < params.xhrCacheDuration) {
	              // Load from cache
	              resolve(cachedUrl.content);
	              return;
	            }
	          }
	        }
	      }
	      router.xhr = router.app.request({
	        url: url,
	        method: 'GET',
	        beforeSend: function beforeSend(xhr) {
	          router.emit('routerAjaxStart', xhr, options);
	        },
	        complete: function complete(xhr, status) {
	          router.emit('routerAjaxComplete', xhr);
	          if ((status !== 'error' && status !== 'timeout' && (xhr.status >= 200 && xhr.status < 300)) || xhr.status === 0) {
	            if (params.xhrCache && xhr.responseText !== '') {
	              router.removeFromXhrCache(url);
	              router.cache.xhr.push({
	                url: url,
	                time: Utils.now(),
	                content: xhr.responseText,
	              });
	            }
	            router.emit('routerAjaxSuccess', xhr, options);
	            resolve(xhr.responseText);
	          } else {
	            router.emit('routerAjaxError', xhr, options);
	            reject(xhr);
	          }
	        },
	        error: function error(xhr) {
	          router.emit('routerAjaxError', xhr, options);
	          reject(xhr);
	        },
	      });
	    });
	  };
	  // Remove theme elements
	  Router.prototype.removeThemeElements = function removeThemeElements (el) {
	    var router = this;
	    var theme = router.app.theme;
	    $$1(el).find(("." + (theme === 'md' ? 'ios' : 'md') + "-only, .if-" + (theme === 'md' ? 'ios' : 'md'))).remove();
	  };
	  Router.prototype.templateLoader = function templateLoader (template, templateUrl, options, resolve, reject) {
	    var router = this;
	    function compile(t) {
	      var compiledHtml;
	      var context;
	      try {
	        context = options.context || {};
	        if (typeof context === 'function') { context = context.call(router); }
	        else if (typeof context === 'string') {
	          try {
	            context = JSON.parse(context);
	          } catch (err) {
	            reject();
	            throw (err);
	          }
	        }
	        if (typeof t === 'function') {
	          compiledHtml = t(context);
	        } else {
	          compiledHtml = Template7.compile(t)(Utils.extend({}, context || {}, {
	            $app: router.app,
	            $root: Utils.extend({}, router.app.data, router.app.methods),
	            $route: options.route,
	            $router: router,
	            $theme: {
	              ios: router.app.theme === 'ios',
	              md: router.app.theme === 'md',
	            },
	          }));
	        }
	      } catch (err) {
	        reject();
	        throw (err);
	      }
	      resolve(compiledHtml, { context: context });
	    }
	    if (templateUrl) {
	      // Load via XHR
	      if (router.xhr) {
	        router.xhr.abort();
	        router.xhr = false;
	      }
	      router
	        .xhrRequest(templateUrl, options)
	        .then(function (templateContent) {
	          compile(templateContent);
	        })
	        .catch(function () {
	          reject();
	        });
	    } else {
	      compile(template);
	    }
	  };
	  Router.prototype.modalTemplateLoader = function modalTemplateLoader (template, templateUrl, options, resolve, reject) {
	    var router = this;
	    return router.templateLoader(template, templateUrl, options, function (html) {
	      resolve(html);
	    }, reject);
	  };
	  Router.prototype.tabTemplateLoader = function tabTemplateLoader (template, templateUrl, options, resolve, reject) {
	    var router = this;
	    return router.templateLoader(template, templateUrl, options, function (html) {
	      resolve(html);
	    }, reject);
	  };
	  Router.prototype.pageTemplateLoader = function pageTemplateLoader (template, templateUrl, options, resolve, reject) {
	    var router = this;
	    return router.templateLoader(template, templateUrl, options, function (html, newOptions) {
	      if ( newOptions === void 0 ) newOptions = {};

	      resolve(router.getPageEl(html), newOptions);
	    }, reject);
	  };
	  Router.prototype.componentLoader = function componentLoader (component, componentUrl, options, resolve, reject) {
	    if ( options === void 0 ) options = {};

	    var router = this;
	    var url = typeof component === 'string' ? component : componentUrl;
	    function compile(c) {
	      var context = options.context || {};
	      if (typeof context === 'function') { context = context.call(router); }
	      else if (typeof context === 'string') {
	        try {
	          context = JSON.parse(context);
	        } catch (err) {
	          reject();
	          throw (err);
	        }
	      }
	      var extendContext = Utils.merge(
	        {},
	        context,
	        {
	          $: $$1,
	          $$: $$1,
	          $app: router.app,
	          $root: Utils.merge({}, router.app.data, router.app.methods),
	          $route: options.route,
	          $router: router,
	          $dom7: $$1,
	          $theme: {
	            ios: router.app.theme === 'ios',
	            md: router.app.theme === 'md',
	          },
	        }
	      );
	      var createdComponent = Component.create(c, extendContext);
	      resolve(createdComponent.el);
	    }
	    if (url) {
	      // Load via XHR
	      if (router.xhr) {
	        router.xhr.abort();
	        router.xhr = false;
	      }
	      router
	        .xhrRequest(url, options)
	        .then(function (loadedComponent) {
	          compile(Component.parse(loadedComponent));
	        })
	        .catch(function (err) {
	          reject();
	          throw (err);
	        });
	    } else {
	      compile(component);
	    }
	  };
	  Router.prototype.modalComponentLoader = function modalComponentLoader (rootEl, component, componentUrl, options, resolve, reject) {
	    var router = this;
	    router.componentLoader(component, componentUrl, options, function (el) {
	      resolve(el);
	    }, reject);
	  };
	  Router.prototype.tabComponentLoader = function tabComponentLoader (tabEl, component, componentUrl, options, resolve, reject) {
	    var router = this;
	    router.componentLoader(component, componentUrl, options, function (el) {
	      resolve(el);
	    }, reject);
	  };
	  Router.prototype.pageComponentLoader = function pageComponentLoader (routerEl, component, componentUrl, options, resolve, reject) {
	    var router = this;
	    router.componentLoader(component, componentUrl, options, function (el, newOptions) {
	      if ( newOptions === void 0 ) newOptions = {};

	      resolve(el, newOptions);
	    }, reject);
	  };
	  Router.prototype.getPageData = function getPageData (pageEl, navbarEl, from, to, route, pageFromEl) {
	    if ( route === void 0 ) route = {};

	    var router = this;
	    var $pageEl = $$1(pageEl);
	    var $navbarEl = $$1(navbarEl);
	    var currentPage = $pageEl[0].f7Page || {};
	    var direction;
	    var pageFrom;
	    if ((from === 'next' && to === 'current') || (from === 'current' && to === 'previous')) { direction = 'forward'; }
	    if ((from === 'current' && to === 'next') || (from === 'previous' && to === 'current')) { direction = 'backward'; }
	    if (currentPage && !currentPage.fromPage) {
	      var $pageFromEl = $$1(pageFromEl);
	      if ($pageFromEl.length) {
	        pageFrom = $pageFromEl[0].f7Page;
	      }
	    }
	    pageFrom = currentPage.pageFrom || pageFrom;
	    if (pageFrom && pageFrom.pageFrom) {
	      pageFrom.pageFrom = null;
	    }
	    var page = {
	      app: router.app,
	      view: router.view,
	      router: router,
	      $el: $pageEl,
	      el: $pageEl[0],
	      $pageEl: $pageEl,
	      pageEl: $pageEl[0],
	      $navbarEl: $navbarEl,
	      navbarEl: $navbarEl[0],
	      name: $pageEl.attr('data-name'),
	      position: from,
	      from: from,
	      to: to,
	      direction: direction,
	      route: currentPage.route ? currentPage.route : route,
	      pageFrom: pageFrom,
	    };

	    if ($navbarEl && $navbarEl[0]) {
	      $navbarEl[0].f7Page = page;
	    }
	    $pageEl[0].f7Page = page;
	    return page;
	  };
	  // Callbacks
	  Router.prototype.pageCallback = function pageCallback (callback, pageEl, navbarEl, from, to, options, pageFromEl) {
	    if ( options === void 0 ) options = {};

	    if (!pageEl) { return; }
	    var router = this;
	    var $pageEl = $$1(pageEl);
	    if (!$pageEl.length) { return; }
	    var route = options.route;
	    var restoreScrollTopOnBack = router.params.restoreScrollTopOnBack;

	    var camelName = "page" + (callback[0].toUpperCase() + callback.slice(1, callback.length));
	    var colonName = "page:" + (callback.toLowerCase());

	    var page = {};
	    if (callback === 'beforeRemove' && $pageEl[0].f7Page) {
	      page = Utils.extend($pageEl[0].f7Page, { from: from, to: to, position: from });
	    } else {
	      page = router.getPageData(pageEl, navbarEl, from, to, route, pageFromEl);
	    }
	    page.swipeBack = !!options.swipeBack;

	    var ref = options.route ? options.route.route : {};
	    var on = ref.on; if ( on === void 0 ) on = {};
	    var once = ref.once; if ( once === void 0 ) once = {};
	    if (options.on) {
	      Utils.extend(on, options.on);
	    }
	    if (options.once) {
	      Utils.extend(once, options.once);
	    }

	    function attachEvents() {
	      if ($pageEl[0].f7RouteEventsAttached) { return; }
	      $pageEl[0].f7RouteEventsAttached = true;
	      if (on && Object.keys(on).length > 0) {
	        $pageEl[0].f7RouteEventsOn = on;
	        Object.keys(on).forEach(function (eventName) {
	          on[eventName] = on[eventName].bind(router);
	          $pageEl.on(Utils.eventNameToColonCase(eventName), on[eventName]);
	        });
	      }
	      if (once && Object.keys(once).length > 0) {
	        $pageEl[0].f7RouteEventsOnce = once;
	        Object.keys(once).forEach(function (eventName) {
	          once[eventName] = once[eventName].bind(router);
	          $pageEl.once(Utils.eventNameToColonCase(eventName), once[eventName]);
	        });
	      }
	    }

	    function detachEvents() {
	      if (!$pageEl[0].f7RouteEventsAttached) { return; }
	      if ($pageEl[0].f7RouteEventsOn) {
	        Object.keys($pageEl[0].f7RouteEventsOn).forEach(function (eventName) {
	          $pageEl.off(Utils.eventNameToColonCase(eventName), $pageEl[0].f7RouteEventsOn[eventName]);
	        });
	      }
	      if ($pageEl[0].f7RouteEventsOnce) {
	        Object.keys($pageEl[0].f7RouteEventsOnce).forEach(function (eventName) {
	          $pageEl.off(Utils.eventNameToColonCase(eventName), $pageEl[0].f7RouteEventsOnce[eventName]);
	        });
	      }
	      $pageEl[0].f7RouteEventsAttached = null;
	      $pageEl[0].f7RouteEventsOn = null;
	      $pageEl[0].f7RouteEventsOnce = null;
	      delete $pageEl[0].f7RouteEventsAttached;
	      delete $pageEl[0].f7RouteEventsOn;
	      delete $pageEl[0].f7RouteEventsOnce;
	    }

	    if (callback === 'mounted') {
	      attachEvents();
	    }
	    if (callback === 'init') {
	      if (restoreScrollTopOnBack && (from === 'previous' || !from) && to === 'current' && router.scrollHistory[page.route.url] && !$pageEl.hasClass('no-restore-scroll')) {
	        var $pageContent = $pageEl.find('.page-content');
	        if ($pageContent.length > 0) {
	          // eslint-disable-next-line
	          $pageContent = $pageContent.filter(function (pageContentIndex, pageContentEl) {
	            return (
	              $$1(pageContentEl).parents('.tab:not(.tab-active)').length === 0 &&
	              !$$1(pageContentEl).is('.tab:not(.tab-active)')
	            );
	          });
	        }
	        $pageContent.scrollTop(router.scrollHistory[page.route.url]);
	      }
	      attachEvents();
	      if ($pageEl[0].f7PageInitialized) {
	        $pageEl.trigger('page:reinit', page);
	        router.emit('pageReinit', page);
	        return;
	      }
	      $pageEl[0].f7PageInitialized = true;
	    }
	    if (restoreScrollTopOnBack && callback === 'beforeOut' && from === 'current' && to === 'previous') {
	      // Save scroll position
	      var $pageContent$1 = $pageEl.find('.page-content');
	      if ($pageContent$1.length > 0) {
	        // eslint-disable-next-line
	        $pageContent$1 = $pageContent$1.filter(function (pageContentIndex, pageContentEl) {
	          return (
	            $$1(pageContentEl).parents('.tab:not(.tab-active)').length === 0 &&
	            !$$1(pageContentEl).is('.tab:not(.tab-active)')
	          );
	        });
	      }
	      router.scrollHistory[page.route.url] = $pageContent$1.scrollTop();
	    }
	    if (restoreScrollTopOnBack && callback === 'beforeOut' && from === 'current' && to === 'next') {
	      // Delete scroll position
	      delete router.scrollHistory[page.route.url];
	    }

	    $pageEl.trigger(colonName, page);
	    router.emit(camelName, page);

	    if (callback === 'beforeRemove') {
	      detachEvents();
	      $pageEl[0].f7Page = null;
	    }
	  };
	  Router.prototype.saveHistory = function saveHistory () {
	    var router = this;
	    router.view.history = router.history;
	    if (router.params.pushState) {
	      win.localStorage[("f7router-" + (router.view.id) + "-history")] = JSON.stringify(router.history);
	    }
	  };
	  Router.prototype.restoreHistory = function restoreHistory () {
	    var router = this;
	    if (router.params.pushState && win.localStorage[("f7router-" + (router.view.id) + "-history")]) {
	      router.history = JSON.parse(win.localStorage[("f7router-" + (router.view.id) + "-history")]);
	      router.view.history = router.history;
	    }
	  };
	  Router.prototype.clearHistory = function clearHistory () {
	    var router = this;
	    router.history = [];
	    if (router.view) { router.view.history = []; }
	    router.saveHistory();
	  };
	  Router.prototype.init = function init () {
	    var router = this;
	    var app = router.app;
	    var view = router.view;

	    // Init Swipeback
	    {
	      if (
	        (view && router.params.iosSwipeBack && app.theme === 'ios') ||
	        (view && router.params.mdSwipeBack && app.theme === 'md')
	      ) {
	        SwipeBack(router);
	      }
	    }

	    // Dynamic not separated navbbar
	    if (router.dynamicNavbar && !router.separateNavbar) {
	      router.$el.addClass('router-dynamic-navbar-inside');
	    }

	    var initUrl = router.params.url;
	    var documentUrl = doc.location.href.split(doc.location.origin)[1];
	    var historyRestored;
	    if (!router.params.pushState || !router.params.pushStateOnLoad) {
	      if (!initUrl) {
	        initUrl = documentUrl;
	      }
	      if (doc.location.search && initUrl.indexOf('?') < 0) {
	        initUrl += doc.location.search;
	      }
	      if (doc.location.hash && initUrl.indexOf('#') < 0) {
	        initUrl += doc.location.hash;
	      }
	    } else {
	      if (router.params.pushStateRoot && documentUrl.indexOf(router.params.pushStateRoot) >= 0) {
	        documentUrl = documentUrl.split(router.params.pushStateRoot)[1];
	        if (documentUrl === '') { documentUrl = '/'; }
	      }
	      if (router.params.pushStateSeparator.length > 0 && documentUrl.indexOf(router.params.pushStateSeparator) >= 0) {
	        initUrl = documentUrl.split(router.params.pushStateSeparator)[1];
	      } else {
	        initUrl = documentUrl;
	      }
	      router.restoreHistory();
	      if (router.history.indexOf(initUrl) >= 0) {
	        router.history = router.history.slice(0, router.history.indexOf(initUrl) + 1);
	      } else if (router.params.url === initUrl) {
	        router.history = [initUrl];
	      } else if (History.state && History.state[view.id] && History.state[view.id].url === router.history[router.history.length - 1]) {
	        initUrl = router.history[router.history.length - 1];
	      } else {
	        router.history = [documentUrl.split(router.params.pushStateSeparator)[0] || '/', initUrl];
	      }
	      if (router.history.length > 1) {
	        historyRestored = true;
	      } else {
	        router.history = [];
	      }
	      router.saveHistory();
	    }
	    var currentRoute;
	    if (router.history.length > 1) {
	      // Will load page
	      currentRoute = router.findMatchingRoute(router.history[0]);
	      if (!currentRoute) {
	        currentRoute = Utils.extend(router.parseRouteUrl(router.history[0]), {
	          route: {
	            url: router.history[0],
	            path: router.history[0].split('?')[0],
	          },
	        });
	      }
	    } else {
	      // Don't load page
	      currentRoute = router.findMatchingRoute(initUrl);
	      if (!currentRoute) {
	        currentRoute = Utils.extend(router.parseRouteUrl(initUrl), {
	          route: {
	            url: initUrl,
	            path: initUrl.split('?')[0],
	          },
	        });
	      }
	    }

	    if (router.params.stackPages) {
	      router.$el.children('.page').each(function (index, pageEl) {
	        var $pageEl = $$1(pageEl);
	        router.initialPages.push($pageEl[0]);
	        if (router.separateNavbar && $pageEl.children('.navbar').length > 0) {
	          router.initialNavbars.push($pageEl.children('.navbar').find('.navbar-inner')[0]);
	        }
	      });
	    }

	    if (router.$el.children('.page:not(.stacked)').length === 0 && initUrl) {
	      // No pages presented in DOM, reload new page
	      router.navigate(initUrl, {
	        initial: true,
	        reloadCurrent: true,
	        pushState: false,
	      });
	    } else {
	      // Init current DOM page
	      var hasTabRoute;
	      router.currentRoute = currentRoute;
	      router.$el.children('.page:not(.stacked)').each(function (index, pageEl) {
	        var $pageEl = $$1(pageEl);
	        var $navbarInnerEl;
	        $pageEl.addClass('page-current');
	        if (router.separateNavbar) {
	          $navbarInnerEl = $pageEl.children('.navbar').children('.navbar-inner');
	          if ($navbarInnerEl.length > 0) {
	            if (!router.$navbarEl.parents(doc).length) {
	              router.$el.prepend(router.$navbarEl);
	            }
	            router.$navbarEl.append($navbarInnerEl);
	            $pageEl.children('.navbar').remove();
	          } else {
	            router.$navbarEl.addClass('navbar-hidden');
	          }
	        }
	        var initOptions = {
	          route: router.currentRoute,
	        };
	        if (router.currentRoute && router.currentRoute.route && router.currentRoute.route.options) {
	          Utils.extend(initOptions, router.currentRoute.route.options);
	        }
	        router.currentPageEl = $pageEl[0];
	        if (router.dynamicNavbar && $navbarInnerEl.length) {
	          router.currentNavbarEl = $navbarInnerEl[0];
	        }
	        router.removeThemeElements($pageEl);
	        if (router.dynamicNavbar && $navbarInnerEl.length) {
	          router.removeThemeElements($navbarInnerEl);
	        }
	        if (initOptions.route.route.tab) {
	          hasTabRoute = true;
	          router.tabLoad(initOptions.route.route.tab, Utils.extend({}, initOptions));
	        }
	        router.pageCallback('init', $pageEl, $navbarInnerEl, 'current', undefined, initOptions);
	      });
	      if (historyRestored) {
	        router.navigate(initUrl, {
	          initial: true,
	          pushState: false,
	          history: false,
	          animate: router.params.pushStateAnimateOnLoad,
	          once: {
	            pageAfterIn: function pageAfterIn() {
	              if (router.history.length > 2) {
	                router.back({ preload: true });
	              }
	            },
	          },
	        });
	      }
	      if (!historyRestored && !hasTabRoute) {
	        router.history.push(initUrl);
	        router.saveHistory();
	      }
	    }
	    if (initUrl && router.params.pushState && router.params.pushStateOnLoad && (!History.state || !History.state[view.id])) {
	      History.initViewState(view.id, {
	        url: initUrl,
	      });
	    }
	    router.emit('local::init routerInit', router);
	  };
	  Router.prototype.destroy = function destroy () {
	    var router = this;

	    router.emit('local::destroy routerDestroy', router);

	    // Delete props & methods
	    Object.keys(router).forEach(function (routerProp) {
	      router[routerProp] = null;
	      delete router[routerProp];
	    });

	    router = null;
	  };

	  return Router;
	}(Framework7Class));

	var Router$1 = {
	  name: 'router',
	  static: {
	    Router: Router,
	  },
	  instance: {
	    cache: {
	      xhr: [],
	      templates: [],
	      components: [],
	    },
	  },
	  create: function create() {
	    var instance = this;
	    if (instance.app) {
	      // View Router
	      if (instance.params.router) {
	        instance.router = new Router(instance.app, instance);
	      }
	    } else {
	      // App Router
	      instance.router = new Router(instance);
	    }
	  },
	};

	var View = (function (Framework7Class$$1) {
	  function View(appInstance, el, viewParams) {
	    if ( viewParams === void 0 ) viewParams = {};

	    Framework7Class$$1.call(this, viewParams, [appInstance]);

	    var app = appInstance;
	    var $el = $$1(el);
	    var view = this;

	    var defaults = {
	      routes: [],
	      routesAdd: [],
	    };

	    // Default View params
	    view.params = Utils.extend(defaults, app.params.view, viewParams);

	    // Routes
	    if (view.params.routes.length > 0) {
	      view.routes = view.params.routes;
	    } else {
	      view.routes = [].concat(app.routes, view.params.routesAdd);
	    }

	    // Selector
	    var selector;
	    if (typeof el === 'string') { selector = el; }
	    else {
	      // Supposed to be HTMLElement or Dom7
	      selector = ($el.attr('id') ? ("#" + ($el.attr('id'))) : '') + ($el.attr('class') ? ("." + ($el.attr('class').replace(/ /g, '.').replace('.active', ''))) : '');
	    }

	    // DynamicNavbar
	    var $navbarEl;
	    if (app.theme === 'ios' && view.params.iosDynamicNavbar && view.params.iosSeparateDynamicNavbar) {
	      $navbarEl = $el.children('.navbar').eq(0);
	      if ($navbarEl.length === 0) {
	        $navbarEl = $$1('<div class="navbar"></div>');
	      }
	    }

	    // View Props
	    Utils.extend(false, view, {
	      app: app,
	      $el: $el,
	      el: $el[0],
	      name: view.params.name,
	      main: view.params.main || $el.hasClass('view-main'),
	      $navbarEl: $navbarEl,
	      navbarEl: $navbarEl ? $navbarEl[0] : undefined,
	      selector: selector,
	      history: [],
	      scrollHistory: {},
	    });

	    // Save in DOM
	    $el[0].f7View = view;

	    // Install Modules
	    view.useModules();

	    // Add to app
	    app.views.push(view);
	    if (view.main) {
	      app.views.main = view;
	    }
	    if (view.name) {
	      app.views[view.name] = view;
	    }

	    // Index
	    view.index = app.views.indexOf(view);

	    // View ID
	    var viewId;
	    if (view.name) {
	      viewId = "view_" + (view.name);
	    } else if (view.main) {
	      viewId = 'view_main';
	    } else {
	      viewId = "view_" + (view.index);
	    }
	    view.id = viewId;

	    // Init View
	    if (app.initialized) {
	      view.init();
	    } else {
	      app.on('init', function () {
	        view.init();
	      });
	    }

	    return view;
	  }

	  if ( Framework7Class$$1 ) View.__proto__ = Framework7Class$$1;
	  View.prototype = Object.create( Framework7Class$$1 && Framework7Class$$1.prototype );
	  View.prototype.constructor = View;
	  View.prototype.destroy = function destroy () {
	    var view = this;
	    var app = view.app;

	    view.$el.trigger('view:beforedestroy', view);
	    view.emit('local::beforeDestroy viewBeforeDestroy', view);

	    if (view.main) {
	      app.views.main = null;
	      delete app.views.main;
	    } else if (view.name) {
	      app.views[view.name] = null;
	      delete app.views[view.name];
	    }
	    view.$el[0].f7View = null;
	    delete view.$el[0].f7View;

	    app.views.splice(app.views.indexOf(view), 1);

	    // Destroy Router
	    if (view.params.router && view.router) {
	      view.router.destroy();
	    }

	    view.emit('local::destroy viewDestroy', view);

	    // Delete props & methods
	    Object.keys(view).forEach(function (viewProp) {
	      view[viewProp] = null;
	      delete view[viewProp];
	    });

	    view = null;
	  };
	  View.prototype.init = function init () {
	    var view = this;
	    if (view.params.router) {
	      view.router.init();
	    }
	  };

	  return View;
	}(Framework7Class));

	// Use Router
	View.use(Router$1);

	function initClicks(app) {
	  function handleClicks(e) {
	    var clicked = $$1(e.target);
	    var clickedLink = clicked.closest('a');
	    var isLink = clickedLink.length > 0;
	    var url = isLink && clickedLink.attr('href');
	    var isTabLink = isLink && clickedLink.hasClass('tab-link') && (clickedLink.attr('data-tab') || (url && url.indexOf('#') === 0));

	    // Check if link is external
	    if (isLink) {
	      // eslint-disable-next-line
	      if (clickedLink.is(app.params.clicks.externalLinks) || (url && url.indexOf('javascript:') >= 0)) {
	        var target = clickedLink.attr('target');
	        if (url && (target === '_system' || target === '_blank' || target === '_browser')) {
	          e.preventDefault();
	          if (target !== '_browser' && win.cordova && win.cordova.InAppBrowser) {
	            win.cordova.InAppBrowser.open(url, target);
	          } else {
	            win.open(url, target);
	          }
	        }
	        return;
	      }
	    }

	    // Modules Clicks
	    Object.keys(app.modules).forEach(function (moduleName) {
	      var moduleClicks = app.modules[moduleName].clicks;
	      if (!moduleClicks) { return; }
	      Object.keys(moduleClicks).forEach(function (clickSelector) {
	        var matchingClickedElement = clicked.closest(clickSelector).eq(0);
	        if (matchingClickedElement.length > 0) {
	          moduleClicks[clickSelector].call(app, matchingClickedElement, matchingClickedElement.dataset());
	        }
	      });
	    });

	    // Load Page
	    var clickedLinkData = {};
	    if (isLink) {
	      e.preventDefault();
	      clickedLinkData = clickedLink.dataset();
	    }
	    var validUrl = url && url.length > 0 && url !== '#' && !isTabLink;
	    var template = clickedLinkData.template;
	    if (validUrl || clickedLink.hasClass('back') || template) {
	      var view;
	      if (clickedLinkData.view) {
	        view = $$1(clickedLinkData.view)[0].f7View;
	      } else {
	        view = clicked.parents('.view')[0] && clicked.parents('.view')[0].f7View;
	        if (!clickedLink.hasClass('back') && view && view.params.linksView) {
	          if (typeof view.params.linksView === 'string') { view = $$1(view.params.linksView)[0].f7View; }
	          else if (view.params.linksView instanceof View) { view = view.params.linksView; }
	        }
	      }
	      if (!view) {
	        if (app.views.main) { view = app.views.main; }
	      }
	      if (!view || !view.router) { return; }
	      if (clickedLinkData.context && typeof clickedLinkData.context === 'string') {
	        try {
	          clickedLinkData.context = JSON.parse(clickedLinkData.context);
	        } catch (err) {
	          // something wrong there
	        }
	      }
	      if (clickedLink.hasClass('back')) { view.router.back(url, clickedLinkData); }
	      else { view.router.navigate(url, clickedLinkData); }
	    }
	  }

	  app.on('click', handleClicks);

	  // Prevent scrolling on overlays
	  function preventScrolling(e) {
	    e.preventDefault();
	  }
	  if (Support.touch && !Device.android) {
	    var activeListener = Support.passiveListener ? { passive: false, capture: false } : false;
	    $$1(doc).on((app.params.touch.fastClicks ? 'touchstart' : 'touchmove'), '.panel-backdrop, .dialog-backdrop, .preloader-backdrop, .popup-backdrop, .searchbar-backdrop', preventScrolling, activeListener);
	  }
	}
	var ClicksModule = {
	  name: 'clicks',
	  params: {
	    clicks: {
	      // External Links
	      externalLinks: '.external',
	    },
	  },
	  on: {
	    init: function init() {
	      var app = this;
	      initClicks(app);
	    },
	  },
	};

	var HistoryModule = {
	  name: 'history',
	  static: {
	    history: History,
	  },
	  on: {
	    init: function init() {
	      History.init(this);
	    },
	  },
	};

	var keyPrefix = 'f7storage-';
	var Storage = {
	  get: function get(key) {
	    return Utils.promise(function (resolve, reject) {
	      try {
	        var value = JSON.parse(win.localStorage.getItem(("" + keyPrefix + key)));
	        resolve(value);
	      } catch (e) {
	        reject(e);
	      }
	    });
	  },
	  set: function set(key, value) {
	    return Utils.promise(function (resolve, reject) {
	      try {
	        win.localStorage.setItem(("" + keyPrefix + key), JSON.stringify(value));
	        resolve();
	      } catch (e) {
	        reject(e);
	      }
	    });
	  },
	  remove: function remove(key) {
	    return Utils.promise(function (resolve, reject) {
	      try {
	        win.localStorage.removeItem(("" + keyPrefix + key));
	        resolve();
	      } catch (e) {
	        reject(e);
	      }
	    });
	  },
	  clear: function clear() {

	  },
	  length: function length() {

	  },
	  keys: function keys() {
	    return Utils.promise(function (resolve, reject) {
	      try {
	        var keys = Object.keys(win.localStorage)
	          .filter(function (keyName) { return keyName.indexOf(keyPrefix) === 0; })
	          .map(function (keyName) { return keyName.replace(keyPrefix, ''); });
	        resolve(keys);
	      } catch (e) {
	        reject(e);
	      }
	    });
	  },
	  forEach: function forEach(callback) {
	    return Utils.promise(function (resolve, reject) {
	      try {
	        Object.keys(win.localStorage)
	          .filter(function (keyName) { return keyName.indexOf(keyPrefix) === 0; })
	          .forEach(function (keyName, index) {
	            var key = keyName.replace(keyPrefix, '');
	            Storage.get(key).then(function (value) {
	              callback(key, value, index);
	            });
	          });
	        resolve();
	      } catch (e) {
	        reject(e);
	      }
	    });
	  },
	};

	var StorageModule = {
	  name: 'storage',
	  static: {
	    Storage: Storage,
	    storage: Storage,
	  },
	};

	var Statusbar = {
	  hide: function hide() {
	    $$1('html').removeClass('with-statusbar');
	    if (Device.cordova && win.StatusBar) {
	      win.StatusBar.hide();
	    }
	  },
	  show: function show() {
	    if (Device.cordova && win.StatusBar) {
	      win.StatusBar.show();
	      Utils.nextTick(function () {
	        if (Device.needsStatusbarOverlay()) {
	          $$1('html').addClass('with-statusbar');
	        }
	      });
	      return;
	    }
	    $$1('html').addClass('with-statusbar');
	  },
	  onClick: function onClick() {
	    var app = this;
	    var pageContent;
	    if ($$1('.popup.modal-in').length > 0) {
	      // Check for opened popup
	      pageContent = $$1('.popup.modal-in').find('.page:not(.page-previous):not(.page-next):not(.cached)').find('.page-content');
	    } else if ($$1('.panel.panel-active').length > 0) {
	      // Check for opened panel
	      pageContent = $$1('.panel.panel-active').find('.page:not(.page-previous):not(.page-next):not(.cached)').find('.page-content');
	    } else if ($$1('.views > .view.tab-active').length > 0) {
	      // View in tab bar app layout
	      pageContent = $$1('.views > .view.tab-active').find('.page:not(.page-previous):not(.page-next):not(.cached)').find('.page-content');
	    } else if ($$1('.views').length > 0) {
	      pageContent = $$1('.views').find('.page:not(.page-previous):not(.page-next):not(.cached)').find('.page-content');
	    } else {
	      pageContent = app.root.children('.view').find('.page:not(.page-previous):not(.page-next):not(.cached)').find('.page-content');
	    }

	    if (pageContent && pageContent.length > 0) {
	      // Check for tab
	      if (pageContent.hasClass('tab')) {
	        pageContent = pageContent.parent('.tabs').children('.page-content.tab-active');
	      }
	      if (pageContent.length > 0) { pageContent.scrollTop(0, 300); }
	    }
	  },
	  setIosTextColor: function setIosTextColor(color) {
	    if (Device.cordova && win.StatusBar) {
	      if (color === 'white') {
	        win.StatusBar.styleLightContent();
	      } else {
	        win.StatusBar.styleDefault();
	      }
	    }
	  },
	  setBackgroundColor: function setBackgroundColor(color) {
	    $$1('.statusbar').css('background-color', color);
	    if (Device.cordova && win.StatusBar) {
	      win.StatusBar.backgroundColorByHexString(color);
	    }
	  },
	  isVisible: function isVisible() {
	    if (Device.cordova && win.StatusBar) {
	      return win.StatusBar.isVisible;
	    }
	    return false;
	  },
	  iosOverlaysWebView: function iosOverlaysWebView(overlays) {
	    if ( overlays === void 0 ) overlays = true;

	    if (!Device.ios) { return; }
	    if (Device.cordova && win.StatusBar) {
	      win.StatusBar.overlaysWebView(overlays);
	      if (overlays) {
	        $$1('html').addClass('with-statusbar');
	      } else {
	        $$1('html').removeClass('with-statusbar');
	      }
	    }
	  },
	  checkOverlay: function checkOverlay() {
	    if (Device.needsStatusbarOverlay()) {
	      $$1('html').addClass('with-statusbar');
	    } else {
	      $$1('html').removeClass('with-statusbar');
	    }
	  },
	  init: function init() {
	    var app = this;
	    var params = app.params.statusbar;
	    if (!params.enabled) { return; }

	    if (params.overlay === 'auto') {
	      if (Device.needsStatusbarOverlay()) {
	        $$1('html').addClass('with-statusbar');
	      } else {
	        $$1('html').removeClass('with-statusbar');
	      }

	      if (Device.ios && (Device.cordova || Device.webView)) {
	        if (win.orientation === 0) {
	          app.once('resize', function () {
	            Statusbar.checkOverlay();
	          });
	        }

	        $$1(doc).on('resume', function () {
	          Statusbar.checkOverlay();
	        }, false);

	        app.on(Device.ios ? 'orientationchange' : 'orientationchange resize', function () {
	          Statusbar.checkOverlay();
	        });
	      }
	    } else if (params.overlay === true) {
	      $$1('html').addClass('with-statusbar');
	    } else if (params.overlay === false) {
	      $$1('html').removeClass('with-statusbar');
	    }

	    if (Device.cordova && win.StatusBar) {
	      if (params.scrollTopOnClick) {
	        $$1(win).on('statusTap', Statusbar.onClick.bind(app));
	      }
	      if (params.iosOverlaysWebView) {
	        win.StatusBar.overlaysWebView(true);
	      } else {
	        win.StatusBar.overlaysWebView(false);
	      }

	      if (params.iosTextColor === 'white') {
	        win.StatusBar.styleLightContent();
	      } else {
	        win.StatusBar.styleDefault();
	      }
	    }
	    if (params.iosBackgroundColor && app.theme === 'ios') {
	      Statusbar.setBackgroundColor(params.iosBackgroundColor);
	    }
	    if (params.materialBackgroundColor && app.theme === 'md') {
	      Statusbar.setBackgroundColor(params.materialBackgroundColor);
	    }
	  },
	};

	var Statusbar$1 = {
	  name: 'statusbar',
	  params: {
	    statusbar: {
	      enabled: true,
	      overlay: 'auto',
	      scrollTopOnClick: true,
	      iosOverlaysWebView: true,
	      iosTextColor: 'black',
	      iosBackgroundColor: null,
	      materialBackgroundColor: null,
	    },
	  },
	  create: function create() {
	    var app = this;
	    Utils.extend(app, {
	      statusbar: {
	        checkOverlay: Statusbar.checkOverlay,
	        hide: Statusbar.hide,
	        show: Statusbar.show,
	        iosOverlaysWebView: Statusbar.iosOverlaysWebView,
	        setIosTextColor: Statusbar.setIosTextColor,
	        setBackgroundColor: Statusbar.setBackgroundColor,
	        isVisible: Statusbar.isVisible,
	        init: Statusbar.init.bind(app),
	      },
	    });
	  },
	  on: {
	    init: function init() {
	      var app = this;
	      Statusbar.init.call(app);
	    },
	  },
	  clicks: {
	    '.statusbar': function onStatusbarClick() {
	      var app = this;
	      if (!app.params.statusbar.enabled) { return; }
	      if (!app.params.statusbar.scrollTopOnClick) { return; }
	      Statusbar.onClick.call(app);
	    },
	  },
	};

	function getCurrentView(app) {
	  var popoverView = $$1('.popover.modal-in .view');
	  var popupView = $$1('.popup.modal-in .view');
	  var panelView = $$1('.panel.panel-active .view');
	  var appViews = $$1('.views');
	  if (appViews.length === 0) { appViews = app.root; }
	  // Find active view as tab
	  var appView = appViews.children('.view');
	  // Propably in tabs or split view
	  if (appView.length > 1) {
	    if (appView.hasClass('tab')) {
	      // Tabs
	      appView = appViews.children('.view.tab-active');
	    }
	  }
	  if (popoverView.length > 0 && popoverView[0].f7View) { return popoverView[0].f7View; }
	  if (popupView.length > 0 && popupView[0].f7View) { return popupView[0].f7View; }
	  if (panelView.length > 0 && panelView[0].f7View) { return panelView[0].f7View; }
	  if (appView.length > 0) {
	    if (appView.length === 1 && appView[0].f7View) { return appView[0].f7View; }
	    if (appView.length > 1) {
	      return app.views.main;
	    }
	  }
	  return undefined;
	}

	var View$1 = {
	  name: 'view',
	  params: {
	    view: {
	      name: undefined,
	      main: false,
	      router: true,
	      linksView: null,
	      stackPages: false,
	      xhrCache: true,
	      xhrCacheIgnore: [],
	      xhrCacheIgnoreGetParameters: false,
	      xhrCacheDuration: 1000 * 60 * 10, // Ten minutes
	      preloadPreviousPage: true,
	      uniqueHistory: false,
	      uniqueHistoryIgnoreGetParameters: false,
	      allowDuplicateUrls: false,
	      reloadPages: false,
	      removeElements: true,
	      removeElementsWithTimeout: false,
	      removeElementsTimeout: 0,
	      restoreScrollTopOnBack: true,
	      unloadTabContent: true,
	      passRouteQueryToRequest: true,
	      passRouteParamsToRequest: false,
	      // Swipe Back
	      iosSwipeBack: true,
	      iosSwipeBackAnimateShadow: true,
	      iosSwipeBackAnimateOpacity: true,
	      iosSwipeBackActiveArea: 30,
	      iosSwipeBackThreshold: 0,
	      mdSwipeBack: false,
	      mdSwipeBackAnimateShadow: true,
	      mdSwipeBackAnimateOpacity: false,
	      mdSwipeBackActiveArea: 30,
	      mdSwipeBackThreshold: 0,
	      // Push State
	      pushState: false,
	      pushStateRoot: undefined,
	      pushStateAnimate: true,
	      pushStateAnimateOnLoad: false,
	      pushStateSeparator: '#!',
	      pushStateOnLoad: true,
	      // Animate Pages
	      animate: true,
	      animateWithJS: false,
	      // iOS Dynamic Navbar
	      iosDynamicNavbar: true,
	      iosSeparateDynamicNavbar: true,
	      // Animate iOS Navbar Back Icon
	      iosAnimateNavbarBackIcon: true,
	      // Delays
	      iosPageLoadDelay: 0,
	      materialPageLoadDelay: 0,
	    },
	  },
	  static: {
	    View: View,
	  },
	  create: function create() {
	    var app = this;
	    Utils.extend(app, {
	      views: Utils.extend([], {
	        create: function create(el, params) {
	          return new View(app, el, params);
	        },
	        get: function get(viewEl) {
	          var $viewEl = $$1(viewEl);
	          if ($viewEl.length && $viewEl[0].f7View) { return $viewEl[0].f7View; }
	          return undefined;
	        },
	      }),
	    });
	    Object.defineProperty(app.views, 'current', {
	      enumerable: true,
	      configurable: true,
	      get: function get() {
	        return getCurrentView(app);
	      },
	    });
	    // Alias
	    app.view = app.views;
	  },
	  on: {
	    init: function init() {
	      var app = this;
	      $$1('.view-init').each(function (index, viewEl) {
	        if (viewEl.f7View) { return; }
	        var viewParams = $$1(viewEl).dataset();
	        app.views.create(viewEl, viewParams);
	      });
	    },
	    modalOpen: function modalOpen(modal) {
	      var app = this;
	      modal.$el.find('.view-init').each(function (index, viewEl) {
	        if (viewEl.f7View) { return; }
	        var viewParams = $$1(viewEl).dataset();
	        app.views.create(viewEl, viewParams);
	      });
	    },
	    modalBeforeDestroy: function modalBeforeDestroy(modal) {
	      if (!modal || !modal.$el) { return; }
	      modal.$el.find('.view-init').each(function (index, viewEl) {
	        var view = viewEl.f7View;
	        if (!view) { return; }
	        view.destroy();
	      });
	    },
	  },
	};

	var Navbar = {
	  size: function size(el) {
	    var app = this;
	    if (app.theme !== 'ios') { return; }
	    var $el = $$1(el);
	    if ($el.hasClass('navbar')) {
	      $el = $el.children('.navbar-inner').each(function (index, navbarEl) {
	        app.navbar.size(navbarEl);
	      });
	      return;
	    }
	    if (
	      $el.hasClass('stacked') ||
	      $el.parents('.stacked').length > 0 ||
	      $el.parents('.tab:not(.tab-active)').length > 0 ||
	      $el.parents('.popup:not(.modal-in)').length > 0
	    ) {
	      return;
	    }
	    var $viewEl = $el.parents('.view').eq(0);
	    var left = app.rtl ? $el.children('.right') : $el.children('.left');
	    var right = app.rtl ? $el.children('.left') : $el.children('.right');
	    var title = $el.children('.title');
	    var subnavbar = $el.children('.subnavbar');
	    var noLeft = left.length === 0;
	    var noRight = right.length === 0;
	    var leftWidth = noLeft ? 0 : left.outerWidth(true);
	    var rightWidth = noRight ? 0 : right.outerWidth(true);
	    var titleWidth = title.outerWidth(true);
	    var navbarStyles = $el.styles();
	    var navbarWidth = $el[0].offsetWidth;
	    var navbarInnerWidth = navbarWidth - parseInt(navbarStyles.paddingLeft, 10) - parseInt(navbarStyles.paddingRight, 10);
	    var isPrevious = $el.hasClass('navbar-previous');
	    var sliding = $el.hasClass('sliding');

	    var router;
	    var dynamicNavbar;
	    var separateNavbar;
	    var separateNavbarRightOffset = 0;
	    var separateNavbarLeftOffset = 0;

	    if ($viewEl.length > 0 && $viewEl[0].f7View) {
	      router = $viewEl[0].f7View.router;
	      dynamicNavbar = router && router.dynamicNavbar;
	      separateNavbar = router && router.separateNavbar;
	      if (!separateNavbar) {
	        separateNavbarRightOffset = navbarWidth;
	        separateNavbarLeftOffset = navbarWidth / 5;
	      }
	    }

	    var currLeft;
	    var diff;
	    if (noRight) {
	      currLeft = navbarInnerWidth - titleWidth;
	    }
	    if (noLeft) {
	      currLeft = 0;
	    }
	    if (!noLeft && !noRight) {
	      currLeft = ((navbarInnerWidth - rightWidth - titleWidth) + leftWidth) / 2;
	    }
	    var requiredLeft = (navbarInnerWidth - titleWidth) / 2;
	    if (navbarInnerWidth - leftWidth - rightWidth > titleWidth) {
	      if (requiredLeft < leftWidth) {
	        requiredLeft = leftWidth;
	      }
	      if (requiredLeft + titleWidth > navbarInnerWidth - rightWidth) {
	        requiredLeft = navbarInnerWidth - rightWidth - titleWidth;
	      }
	      diff = requiredLeft - currLeft;
	    } else {
	      diff = 0;
	    }

	    // RTL inverter
	    var inverter = app.rtl ? -1 : 1;

	    if (dynamicNavbar) {
	      if (title.hasClass('sliding') || (title.length > 0 && sliding)) {
	        var titleLeftOffset = (-(currLeft + diff) * inverter) + separateNavbarLeftOffset;
	        var titleRightOffset = ((navbarInnerWidth - currLeft - diff - titleWidth) * inverter) - separateNavbarRightOffset;

	        if (isPrevious) {
	          if (router && router.params.iosAnimateNavbarBackIcon) {
	            var activeNavbarBackLink = $el.parent().find('.navbar-current').children('.left.sliding').find('.back .icon ~ span');
	            if (activeNavbarBackLink.length > 0) {
	              titleLeftOffset += activeNavbarBackLink[0].offsetLeft;
	            }
	          }
	        }
	        title[0].f7NavbarLeftOffset = titleLeftOffset;
	        title[0].f7NavbarRightOffset = titleRightOffset;
	      }
	      if (!noLeft && (left.hasClass('sliding') || sliding)) {
	        if (app.rtl) {
	          left[0].f7NavbarLeftOffset = (-(navbarInnerWidth - left[0].offsetWidth) / 2) * inverter;
	          left[0].f7NavbarRightOffset = leftWidth * inverter;
	        } else {
	          left[0].f7NavbarLeftOffset = -leftWidth + separateNavbarLeftOffset;
	          left[0].f7NavbarRightOffset = ((navbarInnerWidth - left[0].offsetWidth) / 2) - separateNavbarRightOffset;
	          if (router && router.params.iosAnimateNavbarBackIcon && left.find('.back .icon').length > 0) {
	            left[0].f7NavbarRightOffset -= left.find('.back .icon')[0].offsetWidth;
	          }
	        }
	      }
	      if (!noRight && (right.hasClass('sliding') || sliding)) {
	        if (app.rtl) {
	          right[0].f7NavbarLeftOffset = -rightWidth * inverter;
	          right[0].f7NavbarRightOffset = ((navbarInnerWidth - right[0].offsetWidth) / 2) * inverter;
	        } else {
	          right[0].f7NavbarLeftOffset = (-(navbarInnerWidth - right[0].offsetWidth) / 2) + separateNavbarLeftOffset;
	          right[0].f7NavbarRightOffset = rightWidth - separateNavbarRightOffset;
	        }
	      }
	      if (subnavbar.length && (subnavbar.hasClass('sliding') || sliding)) {
	        subnavbar[0].f7NavbarLeftOffset = app.rtl ? subnavbar[0].offsetWidth : (-subnavbar[0].offsetWidth + separateNavbarLeftOffset);
	        subnavbar[0].f7NavbarRightOffset = (-subnavbar[0].f7NavbarLeftOffset - separateNavbarRightOffset) + separateNavbarLeftOffset;
	      }
	    }

	    // Title left
	    if (app.params.navbar.iosCenterTitle) {
	      var titleLeft = diff;
	      if (app.rtl && noLeft && noRight && title.length > 0) { titleLeft = -titleLeft; }
	      title.css({ left: (titleLeft + "px") });
	    }
	  },
	  hide: function hide(el, animate) {
	    if ( animate === void 0 ) animate = true;

	    var $el = $$1(el);
	    if ($el.hasClass('navbar-inner')) { $el = $el.parents('.navbar'); }
	    if (!$el.length) { return; }
	    if ($el.hasClass('navbar-hidden')) { return; }
	    var className = "navbar-hidden" + (animate ? ' navbar-transitioning' : '');
	    $el.transitionEnd(function () {
	      $el.removeClass('navbar-transitioning');
	    });
	    $el.addClass(className);
	  },
	  show: function show(el, animate) {
	    if ( el === void 0 ) el = '.navbar-hidden';
	    if ( animate === void 0 ) animate = true;

	    var $el = $$1(el);
	    if ($el.hasClass('navbar-inner')) { $el = $el.parents('.navbar'); }
	    if (!$el.length) { return; }
	    if (!$el.hasClass('navbar-hidden')) { return; }
	    if (animate) {
	      $el.addClass('navbar-transitioning');
	      $el.transitionEnd(function () {
	        $el.removeClass('navbar-transitioning');
	      });
	    }
	    $el.removeClass('navbar-hidden');
	  },
	  getElByPage: function getElByPage(page) {
	    var $pageEl;
	    var $navbarEl;
	    var pageData;
	    if (page.$navbarEl || page.$el) {
	      pageData = page;
	      $pageEl = page.$el;
	    } else {
	      $pageEl = $$1(page);
	      if ($pageEl.length > 0) { pageData = $pageEl[0].f7Page; }
	    }
	    if (pageData && pageData.$navbarEl && pageData.$navbarEl.length > 0) {
	      $navbarEl = pageData.$navbarEl;
	    } else if ($pageEl) {
	      $navbarEl = $pageEl.children('.navbar').children('.navbar-inner');
	    }
	    if (!$navbarEl || ($navbarEl && $navbarEl.length === 0)) { return undefined; }
	    return $navbarEl[0];
	  },
	  getPageByEl: function getPageByEl(navbarInnerEl) {
	    var $navbarInnerEl = $$1(navbarInnerEl);
	    if ($navbarInnerEl.hasClass('navbar')) {
	      $navbarInnerEl = $navbarInnerEl.find('.navbar-inner');
	      if ($navbarInnerEl.length > 1) { return undefined; }
	    }
	    return $navbarInnerEl[0].f7Page;
	  },
	  initHideNavbarOnScroll: function initHideNavbarOnScroll(pageEl, navbarInnerEl) {
	    var app = this;
	    var $pageEl = $$1(pageEl);
	    var $navbarEl = $$1(navbarInnerEl || app.navbar.getElByPage(pageEl)).closest('.navbar');

	    var previousScrollTop;
	    var currentScrollTop;

	    var scrollHeight;
	    var offsetHeight;
	    var reachEnd;
	    var action;
	    var navbarHidden;
	    function handleScroll() {
	      var scrollContent = this;
	      if ($pageEl.hasClass('page-previous')) { return; }
	      currentScrollTop = scrollContent.scrollTop;
	      scrollHeight = scrollContent.scrollHeight;
	      offsetHeight = scrollContent.offsetHeight;
	      reachEnd = currentScrollTop + offsetHeight >= scrollHeight;
	      navbarHidden = $navbarEl.hasClass('navbar-hidden');

	      if (reachEnd) {
	        if (app.params.navbar.showOnPageScrollEnd) {
	          action = 'show';
	        }
	      } else if (previousScrollTop > currentScrollTop) {
	        if (app.params.navbar.showOnPageScrollTop || currentScrollTop <= 44) {
	          action = 'show';
	        } else {
	          action = 'hide';
	        }
	      } else if (currentScrollTop > 44) {
	        action = 'hide';
	      } else {
	        action = 'show';
	      }

	      if (action === 'show' && navbarHidden) {
	        app.navbar.show($navbarEl);
	        navbarHidden = false;
	      } else if (action === 'hide' && !navbarHidden) {
	        app.navbar.hide($navbarEl);
	        navbarHidden = true;
	      }

	      previousScrollTop = currentScrollTop;
	    }
	    $pageEl.on('scroll', '.page-content', handleScroll, true);
	    $pageEl[0].f7ScrollNavbarHandler = handleScroll;
	  },
	};
	var Navbar$1 = {
	  name: 'navbar',
	  create: function create() {
	    var app = this;
	    Utils.extend(app, {
	      navbar: {
	        size: Navbar.size.bind(app),
	        hide: Navbar.hide.bind(app),
	        show: Navbar.show.bind(app),
	        getElByPage: Navbar.getElByPage.bind(app),
	        initHideNavbarOnScroll: Navbar.initHideNavbarOnScroll.bind(app),
	      },
	    });
	  },
	  params: {
	    navbar: {
	      scrollTopOnTitleClick: true,
	      iosCenterTitle: true,
	      hideOnPageScroll: false,
	      showOnPageScrollEnd: true,
	      showOnPageScrollTop: true,
	    },
	  },
	  on: {
	    'panelBreakpoint resize': function onResize() {
	      var app = this;
	      if (app.theme !== 'ios') { return; }
	      $$1('.navbar').each(function (index, navbarEl) {
	        app.navbar.size(navbarEl);
	      });
	    },
	    pageBeforeRemove: function pageBeforeRemove(page) {
	      if (page.$el[0].f7ScrollNavbarHandler) {
	        page.$el.off('scroll', '.page-content', page.$el[0].f7ScrollNavbarHandler, true);
	      }
	    },
	    pageBeforeIn: function pageBeforeIn(page) {
	      var app = this;
	      if (app.theme !== 'ios') { return; }
	      var $navbarEl;
	      var view = page.$el.parents('.view')[0].f7View;
	      var navbarInnerEl = app.navbar.getElByPage(page);
	      if (!navbarInnerEl) {
	        $navbarEl = page.$el.parents('.view').children('.navbar');
	      } else {
	        $navbarEl = $$1(navbarInnerEl).parents('.navbar');
	      }
	      if (page.$el.hasClass('no-navbar') || (view.router.dynamicNavbar && !navbarInnerEl)) {
	        var animate = !!(page.pageFrom && page.router.history.length > 0);
	        app.navbar.hide($navbarEl, animate);
	      } else {
	        app.navbar.show($navbarEl);
	      }
	    },
	    pageReinit: function pageReinit(page) {
	      var app = this;
	      if (app.theme !== 'ios') { return; }
	      var $navbarEl = $$1(app.navbar.getElByPage(page));
	      if (!$navbarEl || $navbarEl.length === 0) { return; }
	      app.navbar.size($navbarEl);
	    },
	    pageInit: function pageInit(page) {
	      var app = this;
	      var $navbarEl = $$1(app.navbar.getElByPage(page));
	      if (!$navbarEl || $navbarEl.length === 0) { return; }
	      if (app.theme === 'ios') {
	        app.navbar.size($navbarEl);
	      }
	      if (
	        app.params.navbar.hideOnPageScroll ||
	        page.$el.find('.hide-navbar-on-scroll').length ||
	        page.$el.hasClass('hide-navbar-on-scroll') ||
	        page.$el.find('.hide-bars-on-scroll').length ||
	        page.$el.hasClass('hide-bars-on-scroll')
	      ) {
	        if (
	          page.$el.find('.keep-navbar-on-scroll').length ||
	          page.$el.hasClass('keep-navbar-on-scroll') ||
	          page.$el.find('.keep-bars-on-scroll').length ||
	          page.$el.hasClass('keep-bars-on-scroll')
	        ) {
	          return;
	        }
	        app.navbar.initHideNavbarOnScroll(page.el, $navbarEl[0]);
	      }
	    },
	    modalOpen: function modalOpen(modal) {
	      var app = this;
	      if (app.theme !== 'ios') { return; }
	      modal.$el.find('.navbar:not(.navbar-previous):not(.stacked)').each(function (index, navbarEl) {
	        app.navbar.size(navbarEl);
	      });
	    },
	    panelOpen: function panelOpen(panel) {
	      var app = this;
	      if (app.theme !== 'ios') { return; }
	      panel.$el.find('.navbar:not(.navbar-previous):not(.stacked)').each(function (index, navbarEl) {
	        app.navbar.size(navbarEl);
	      });
	    },
	    panelSwipeOpen: function panelSwipeOpen(panel) {
	      var app = this;
	      if (app.theme !== 'ios') { return; }
	      panel.$el.find('.navbar:not(.navbar-previous):not(.stacked)').each(function (index, navbarEl) {
	        app.navbar.size(navbarEl);
	      });
	    },
	    tabShow: function tabShow(tabEl) {
	      var app = this;
	      $$1(tabEl).find('.navbar:not(.navbar-previous):not(.stacked)').each(function (index, navbarEl) {
	        app.navbar.size(navbarEl);
	      });
	    },
	  },
	  clicks: {
	    '.navbar .title': function onTitleClick($clickedEl) {
	      var app = this;
	      if (!app.params.navbar.scrollTopOnTitleClick) { return; }
	      if ($clickedEl.closest('a').length > 0) {
	        return;
	      }
	      var pageContent;
	      // Find active page
	      var navbar = $clickedEl.parents('.navbar');

	      // Static Layout
	      pageContent = navbar.parents('.page-content');

	      if (pageContent.length === 0) {
	        // Fixed Layout
	        if (navbar.parents('.page').length > 0) {
	          pageContent = navbar.parents('.page').find('.page-content');
	        }
	        // Through Layout
	        if (pageContent.length === 0) {
	          if (navbar.nextAll('.page-current:not(.stacked)').length > 0) {
	            pageContent = navbar.nextAll('.page-current:not(.stacked)').find('.page-content');
	          }
	        }
	      }
	      if (pageContent && pageContent.length > 0) {
	        // Check for tab
	        if (pageContent.hasClass('tab')) {
	          pageContent = pageContent.parent('.tabs').children('.page-content.tab-active');
	        }
	        if (pageContent.length > 0) { pageContent.scrollTop(0, 300); }
	      }
	    },
	  },
	};

	var Toolbar = {
	  setHighlight: function setHighlight(tabbarEl) {
	    var app = this;
	    if (app.theme !== 'md') { return; }

	    var $tabbarEl = $$1(tabbarEl);

	    if ($tabbarEl.length === 0 || !($tabbarEl.hasClass('tabbar') || $tabbarEl.hasClass('tabbar-labels'))) { return; }

	    if ($tabbarEl.find('.tab-link-highlight').length === 0) {
	      $tabbarEl.children('.toolbar-inner').append('<span class="tab-link-highlight"></span>');
	    }

	    var $highlightEl = $tabbarEl.find('.tab-link-highlight');
	    var $activeLink = $tabbarEl.find('.tab-link-active');
	    var highlightWidth;
	    var highlightTranslate;

	    if ($tabbarEl.hasClass('tabbar-scrollable') && $activeLink && $activeLink[0]) {
	      highlightWidth = ($activeLink[0].offsetWidth) + "px";
	      highlightTranslate = ($activeLink[0].offsetLeft) + "px";
	    } else {
	      var activeIndex = $activeLink.index();
	      var tabLinksCount = $tabbarEl.find('.tab-link').length;
	      highlightWidth = (100 / tabLinksCount) + "%";
	      highlightTranslate = ((app.rtl ? -activeIndex : activeIndex) * 100) + "%";
	    }

	    $highlightEl
	      .css('width', highlightWidth)
	      .transform(("translate3d(" + highlightTranslate + ",0,0)"));
	  },
	  init: function init(tabbarEl) {
	    var app = this;
	    app.toolbar.setHighlight(tabbarEl);
	  },
	  hide: function hide(el, animate) {
	    if ( animate === void 0 ) animate = true;

	    var $el = $$1(el);
	    if ($el.hasClass('toolbar-hidden')) { return; }
	    var className = "toolbar-hidden" + (animate ? ' toolbar-transitioning' : '');
	    $el.transitionEnd(function () {
	      $el.removeClass('toolbar-transitioning');
	    });
	    $el.addClass(className);
	  },
	  show: function show(el, animate) {
	    if ( animate === void 0 ) animate = true;

	    var $el = $$1(el);
	    if (!$el.hasClass('toolbar-hidden')) { return; }
	    if (animate) {
	      $el.addClass('toolbar-transitioning');
	      $el.transitionEnd(function () {
	        $el.removeClass('toolbar-transitioning');
	      });
	    }
	    $el.removeClass('toolbar-hidden');
	  },
	  initHideToolbarOnScroll: function initHideToolbarOnScroll(pageEl) {
	    var app = this;
	    var $pageEl = $$1(pageEl);
	    var $toolbarEl = $pageEl.parents('.view').children('.toolbar');
	    if ($toolbarEl.length === 0) {
	      $toolbarEl = $pageEl.find('.toolbar');
	    }
	    if ($toolbarEl.length === 0) {
	      $toolbarEl = $pageEl.parents('.views').children('.tabbar, .tabbar-labels');
	    }
	    if ($toolbarEl.length === 0) {
	      return;
	    }

	    var previousScrollTop;
	    var currentScrollTop;

	    var scrollHeight;
	    var offsetHeight;
	    var reachEnd;
	    var action;
	    var toolbarHidden;
	    function handleScroll() {
	      var scrollContent = this;
	      if ($pageEl.hasClass('page-previous')) { return; }
	      currentScrollTop = scrollContent.scrollTop;
	      scrollHeight = scrollContent.scrollHeight;
	      offsetHeight = scrollContent.offsetHeight;
	      reachEnd = currentScrollTop + offsetHeight >= scrollHeight;
	      toolbarHidden = $toolbarEl.hasClass('toolbar-hidden');

	      if (reachEnd) {
	        if (app.params.toolbar.showOnPageScrollEnd) {
	          action = 'show';
	        }
	      } else if (previousScrollTop > currentScrollTop) {
	        if (app.params.toolbar.showOnPageScrollTop || currentScrollTop <= 44) {
	          action = 'show';
	        } else {
	          action = 'hide';
	        }
	      } else if (currentScrollTop > 44) {
	        action = 'hide';
	      } else {
	        action = 'show';
	      }

	      if (action === 'show' && toolbarHidden) {
	        app.toolbar.show($toolbarEl);
	        toolbarHidden = false;
	      } else if (action === 'hide' && !toolbarHidden) {
	        app.toolbar.hide($toolbarEl);
	        toolbarHidden = true;
	      }

	      previousScrollTop = currentScrollTop;
	    }
	    $pageEl.on('scroll', '.page-content', handleScroll, true);
	    $pageEl[0].f7ScrollToolbarHandler = handleScroll;
	  },
	};
	var Toolbar$1 = {
	  name: 'toolbar',
	  create: function create() {
	    var app = this;
	    Utils.extend(app, {
	      toolbar: {
	        hide: Toolbar.hide.bind(app),
	        show: Toolbar.show.bind(app),
	        setHighlight: Toolbar.setHighlight.bind(app),
	        initHideToolbarOnScroll: Toolbar.initHideToolbarOnScroll.bind(app),
	        init: Toolbar.init.bind(app),
	      },
	    });
	  },
	  params: {
	    toolbar: {
	      hideOnPageScroll: false,
	      showOnPageScrollEnd: true,
	      showOnPageScrollTop: true,
	    },
	  },
	  on: {
	    pageBeforeRemove: function pageBeforeRemove(page) {
	      if (page.$el[0].f7ScrollToolbarHandler) {
	        page.$el.off('scroll', '.page-content', page.$el[0].f7ScrollToolbarHandler, true);
	      }
	    },
	    pageBeforeIn: function pageBeforeIn(page) {
	      var app = this;
	      var $toolbarEl = page.$el.parents('.view').children('.toolbar');
	      if ($toolbarEl.length === 0) {
	        $toolbarEl = page.$el.find('.toolbar');
	      }
	      if ($toolbarEl.length === 0) {
	        $toolbarEl = page.$el.parents('.views').children('.tabbar, .tabbar-labels');
	      }
	      if ($toolbarEl.length === 0) {
	        return;
	      }
	      if (page.$el.hasClass('no-toolbar')) {
	        app.toolbar.hide($toolbarEl);
	      } else {
	        app.toolbar.show($toolbarEl);
	      }
	    },
	    pageInit: function pageInit(page) {
	      var app = this;
	      page.$el.find('.tabbar, .tabbar-labels').each(function (index, tabbarEl) {
	        app.toolbar.init(tabbarEl);
	      });
	      if (
	        app.params.toolbar.hideOnPageScroll ||
	        page.$el.find('.hide-toolbar-on-scroll').length ||
	        page.$el.hasClass('hide-toolbar-on-scroll') ||
	        page.$el.find('.hide-bars-on-scroll').length ||
	        page.$el.hasClass('hide-bars-on-scroll')
	      ) {
	        if (
	          page.$el.find('.keep-toolbar-on-scroll').length ||
	          page.$el.hasClass('keep-toolbar-on-scroll') ||
	          page.$el.find('.keep-bars-on-scroll').length ||
	          page.$el.hasClass('keep-bars-on-scroll')
	        ) {
	          return;
	        }
	        app.toolbar.initHideToolbarOnScroll(page.el);
	      }
	    },
	    init: function init() {
	      var app = this;
	      app.root.find('.tabbar, .tabbar-labels').each(function (index, tabbarEl) {
	        app.toolbar.init(tabbarEl);
	      });
	    },
	  },
	};

	var Subnavbar = {
	  name: 'subnavbar',
	  on: {
	    pageInit: function pageInit(page) {
	      if (page.$navbarEl && page.$navbarEl.length && page.$navbarEl.find('.subnavbar').length) {
	        page.$el.addClass('page-with-subnavbar');
	      }
	      if (page.$el.find('.subnavbar').length) {
	        page.$el.addClass('page-with-subnavbar');
	      }
	    },
	  },
	};

	var TouchRipple = function TouchRipple($el, x, y) {
	  var ripple = this;
	  if (!$el) { return undefined; }
	  var box = $el[0].getBoundingClientRect();
	  var center = {
	    x: x - box.left,
	    y: y - box.top,
	  };
	  var width = box.width;
	  var height = box.height;
	  var diameter = Math.max((Math.pow( ((Math.pow( height, 2 )) + (Math.pow( width, 2 ))), 0.5 )), 48);

	  ripple.$rippleWaveEl = $$1(("<div class=\"ripple-wave\" style=\"width: " + diameter + "px; height: " + diameter + "px; margin-top:-" + (diameter / 2) + "px; margin-left:-" + (diameter / 2) + "px; left:" + (center.x) + "px; top:" + (center.y) + "px;\"></div>"));

	  $el.prepend(ripple.$rippleWaveEl);

	  /* eslint no-underscore-dangle: ["error", { "allow": ["_clientLeft"] }] */
	  ripple._clientLeft = ripple.$rippleWaveEl[0].clientLeft;

	  ripple.rippleTransform = "translate3d(" + (-center.x + (width / 2)) + "px, " + (-center.y + (height / 2)) + "px, 0) scale(1)";

	  ripple.$rippleWaveEl.transform(ripple.rippleTransform);

	  return ripple;
	};
	TouchRipple.prototype.onRemove = function onRemove () {
	  var ripple = this;
	  ripple.$rippleWaveEl.remove();
	  Object.keys(ripple).forEach(function (key) {
	    ripple[key] = null;
	    delete ripple[key];
	  });
	  ripple = null;
	};
	TouchRipple.prototype.remove = function remove () {
	  var ripple = this;
	  if (ripple.removing) { return; }
	  var $rippleWaveEl = this.$rippleWaveEl;
	  var rippleTransform = this.rippleTransform;
	  var removeTimeout = Utils.nextTick(function () {
	    ripple.onRemove();
	  }, 400);
	  ripple.removing = true;
	  $rippleWaveEl
	    .addClass('ripple-wave-fill')
	    .transform(rippleTransform.replace('scale(1)', 'scale(1.01)'))
	    .transitionEnd(function () {
	      clearTimeout(removeTimeout);
	      Utils.nextFrame(function () {
	        $rippleWaveEl
	          .addClass('ripple-wave-out')
	          .transform(rippleTransform.replace('scale(1)', 'scale(1.01)'));

	        removeTimeout = Utils.nextTick(function () {
	          ripple.onRemove();
	        }, 700);

	        $rippleWaveEl.transitionEnd(function () {
	          clearTimeout(removeTimeout);
	          ripple.onRemove();
	        });
	      });
	    });
	};

	var TouchRipple$1 = {
	  name: 'touch-ripple',
	  static: {
	    TouchRipple: TouchRipple,
	  },
	  create: function create() {
	    var app = this;
	    app.touchRipple = {
	      create: function create() {
	        var args = [], len = arguments.length;
	        while ( len-- ) args[ len ] = arguments[ len ];

	        return new (Function.prototype.bind.apply( TouchRipple, [ null ].concat( args) ));
	      },
	    };
	  },
	};

	var openedModals = [];
	var dialogsQueue = [];
	function clearDialogsQueue() {
	  if (dialogsQueue.length === 0) { return; }
	  var dialog = dialogsQueue.shift();
	  dialog.open();
	}
	var Modal = (function (Framework7Class$$1) {
	  function Modal(app, params) {
	    Framework7Class$$1.call(this, params, [app]);

	    var modal = this;

	    var defaults = {};

	    // Extend defaults with modules params
	    modal.useModulesParams(defaults);

	    modal.params = Utils.extend(defaults, params);

	    // Install Modules
	    modal.useModules();

	    return this;
	  }

	  if ( Framework7Class$$1 ) Modal.__proto__ = Framework7Class$$1;
	  Modal.prototype = Object.create( Framework7Class$$1 && Framework7Class$$1.prototype );
	  Modal.prototype.constructor = Modal;
	  Modal.prototype.onOpen = function onOpen () {
	    var modal = this;
	    openedModals.push(modal);
	    $$1('html').addClass(("with-modal-" + (modal.type.toLowerCase())));
	    modal.$el.trigger(("modal:open " + (modal.type.toLowerCase()) + ":open"), modal);
	    modal.emit(("local::open modalOpen " + (modal.type) + "Open"), modal);
	  };
	  Modal.prototype.onOpened = function onOpened () {
	    var modal = this;
	    modal.$el.trigger(("modal:opened " + (modal.type.toLowerCase()) + ":opened"), modal);
	    modal.emit(("local::opened modalOpened " + (modal.type) + "Opened"), modal);
	  };
	  Modal.prototype.onClose = function onClose () {
	    var modal = this;
	    if (!modal.type || !modal.$el) { return; }
	    openedModals.splice(openedModals.indexOf(modal), 1);
	    $$1('html').removeClass(("with-modal-" + (modal.type.toLowerCase())));
	    modal.$el.trigger(("modal:close " + (modal.type.toLowerCase()) + ":close"), modal);
	    modal.emit(("local::close modalClose " + (modal.type) + "Close"), modal);
	  };
	  Modal.prototype.onClosed = function onClosed () {
	    var modal = this;
	    if (!modal.type || !modal.$el) { return; }
	    modal.$el.removeClass('modal-out');
	    modal.$el.hide();
	    modal.$el.trigger(("modal:closed " + (modal.type.toLowerCase()) + ":closed"), modal);
	    modal.emit(("local::closed modalClosed " + (modal.type) + "Closed"), modal);
	  };
	  Modal.prototype.open = function open (animateModal) {
	    var modal = this;
	    var app = modal.app;
	    var $el = modal.$el;
	    var $backdropEl = modal.$backdropEl;
	    var type = modal.type;
	    var animate = true;
	    if (typeof animateModal !== 'undefined') { animate = animateModal; }
	    else if (typeof modal.params.animate !== 'undefined') {
	      animate = modal.params.animate;
	    }

	    if (!$el || $el.hasClass('modal-in')) {
	      return modal;
	    }

	    if (type === 'dialog' && app.params.modal.queueDialogs) {
	      var pushToQueue;
	      if ($$1('.dialog.modal-in').length > 0) {
	        pushToQueue = true;
	      } else if (openedModals.length > 0) {
	        openedModals.forEach(function (openedModal) {
	          if (openedModal.type === 'dialog') { pushToQueue = true; }
	        });
	      }
	      if (pushToQueue) {
	        dialogsQueue.push(modal);
	        return modal;
	      }
	    }

	    var $modalParentEl = $el.parent();
	    var wasInDom = $el.parents(doc).length > 0;
	    if (app.params.modal.moveToRoot && !$modalParentEl.is(app.root)) {
	      app.root.append($el);
	      modal.once((type + "Closed"), function () {
	        if (wasInDom) {
	          $modalParentEl.append($el);
	        } else {
	          $el.remove();
	        }
	      });
	    }
	    // Show Modal
	    $el.show();

	    // Set Dialog offset
	    if (type === 'dialog') {
	      $el.css({
	        marginTop: ((-Math.round($el.outerHeight() / 2)) + "px"),
	      });
	    }

	    // Emit open
	    /* eslint no-underscore-dangle: ["error", { "allow": ["_clientLeft"] }] */
	    modal._clientLeft = $el[0].clientLeft;

	    // Backdrop
	    if ($backdropEl) {
	      $backdropEl[animate ? 'removeClass' : 'addClass']('not-animated');
	      $backdropEl.addClass('backdrop-in');
	    }
	    // Modal
	    function transitionEnd() {
	      if ($el.hasClass('modal-out')) {
	        modal.onClosed();
	      } else if ($el.hasClass('modal-in')) {
	        modal.onOpened();
	      }
	    }
	    if (animate) {
	      $el
	        .animationEnd(function () {
	          transitionEnd();
	        });
	      $el
	        .transitionEnd(function () {
	          transitionEnd();
	        });
	      $el
	        .removeClass('modal-out not-animated')
	        .addClass('modal-in');
	      modal.onOpen();
	    } else {
	      $el.removeClass('modal-out').addClass('modal-in not-animated');
	      modal.onOpen();
	      modal.onOpened();
	    }

	    return modal;
	  };
	  Modal.prototype.close = function close (animateModal) {
	    var modal = this;
	    var $el = modal.$el;
	    var $backdropEl = modal.$backdropEl;

	    var animate = true;
	    if (typeof animateModal !== 'undefined') { animate = animateModal; }
	    else if (typeof modal.params.animate !== 'undefined') {
	      animate = modal.params.animate;
	    }

	    if (!$el || !$el.hasClass('modal-in')) {
	      return modal;
	    }

	    // backdrop
	    if ($backdropEl) {
	      $backdropEl[animate ? 'removeClass' : 'addClass']('not-animated');
	      $backdropEl.removeClass('backdrop-in');
	    }

	    // Modal
	    $el[animate ? 'removeClass' : 'addClass']('not-animated');
	    function transitionEnd() {
	      if ($el.hasClass('modal-out')) {
	        modal.onClosed();
	      } else if ($el.hasClass('modal-in')) {
	        modal.onOpened();
	      }
	    }
	    if (animate) {
	      $el
	        .animationEnd(function () {
	          transitionEnd();
	        });
	      $el
	        .transitionEnd(function () {
	          transitionEnd();
	        });
	      $el
	        .removeClass('modal-in')
	        .addClass('modal-out');
	      // Emit close
	      modal.onClose();
	    } else {
	      $el
	        .addClass('not-animated')
	        .removeClass('modal-in')
	        .addClass('modal-out');
	      // Emit close
	      modal.onClose();
	      modal.onClosed();
	    }

	    if (modal.type === 'dialog') {
	      clearDialogsQueue();
	    }

	    return modal;
	  };
	  Modal.prototype.destroy = function destroy () {
	    var modal = this;
	    if (modal.destroyed) { return; }
	    modal.emit(("local::beforeDestroy modalBeforeDestroy " + (modal.type) + "BeforeDestroy"), modal);
	    if (modal.$el) {
	      modal.$el.trigger(("modal:beforedestroy " + (modal.type.toLowerCase()) + ":beforedestroy"), modal);
	      if (modal.$el.length && modal.$el[0].f7Modal) {
	        delete modal.$el[0].f7Modal;
	      }
	    }
	    Utils.deleteProps(modal);
	    modal.destroyed = true;
	  };

	  return Modal;
	}(Framework7Class));

	var CustomModal = (function (Modal$$1) {
	  function CustomModal(app, params) {
	    var extendedParams = Utils.extend({
	      backdrop: true,
	      closeByBackdropClick: true,
	      on: {},
	    }, params);

	    // Extends with open/close Modal methods;
	    Modal$$1.call(this, app, extendedParams);

	    var customModal = this;

	    customModal.params = extendedParams;

	    // Find Element
	    var $el;
	    if (!customModal.params.el) {
	      $el = $$1(customModal.params.content);
	    } else {
	      $el = $$1(customModal.params.el);
	    }

	    if ($el && $el.length > 0 && $el[0].f7Modal) {
	      return $el[0].f7Modal;
	    }

	    if ($el.length === 0) {
	      return customModal.destroy();
	    }
	    var $backdropEl;
	    if (customModal.params.backdrop) {
	      $backdropEl = app.root.children('.custom-modal-backdrop');
	      if ($backdropEl.length === 0) {
	        $backdropEl = $$1('<div class="custom-modal-backdrop"></div>');
	        app.root.append($backdropEl);
	      }
	    }

	    function handleClick(e) {
	      if (!customModal || customModal.destroyed) { return; }
	      if ($backdropEl && e.target === $backdropEl[0]) {
	        customModal.close();
	      }
	    }

	    customModal.on('customModalOpened', function () {
	      if (customModal.params.closeByBackdropClick && customModal.params.backdrop) {
	        app.on('click', handleClick);
	      }
	    });
	    customModal.on('customModalClose', function () {
	      if (customModal.params.closeByBackdropClick && customModal.params.backdrop) {
	        app.off('click', handleClick);
	      }
	    });

	    Utils.extend(customModal, {
	      app: app,
	      $el: $el,
	      el: $el[0],
	      $backdropEl: $backdropEl,
	      backdropEl: $backdropEl && $backdropEl[0],
	      type: 'customModal',
	    });

	    $el[0].f7Modal = customModal;

	    return customModal;
	  }

	  if ( Modal$$1 ) CustomModal.__proto__ = Modal$$1;
	  CustomModal.prototype = Object.create( Modal$$1 && Modal$$1.prototype );
	  CustomModal.prototype.constructor = CustomModal;

	  return CustomModal;
	}(Modal));

	var Modal$1 = {
	  name: 'modal',
	  static: {
	    Modal: Modal,
	    CustomModal: CustomModal,
	  },
	  create: function create() {
	    var app = this;
	    app.customModal = {
	      create: function create(params) {
	        return new CustomModal(app, params);
	      },
	    };
	  },
	  params: {
	    modal: {
	      moveToRoot: true,
	      queueDialogs: true,
	    },
	  },
	};

	/**
	 * Framework7 2.3.1
	 * Full featured mobile HTML framework for building iOS & Android apps
	 * http://framework7.io/
	 *
	 * Copyright 2014-2018 Vladimir Kharlampidi
	 *
	 * Released under the MIT License
	 *
	 * Released on: June 1, 2018
	 */

	// Install Core Modules & Components
	Framework7.use([
	  DeviceModule,
	  SupportModule,
	  UtilsModule,
	  ResizeModule,
	  RequestModule,
	  TouchModule,
	  ClicksModule,
	  Router$1,
	  HistoryModule,
	  StorageModule,
	  Statusbar$1,
	  View$1,
	  Navbar$1,
	  Toolbar$1,
	  Subnavbar,
	  TouchRipple$1,
	  Modal$1 ]);

	var Dialog = (function (Modal$$1) {
	  function Dialog(app, params) {
	    var extendedParams = Utils.extend({
	      title: app.params.dialog.title,
	      text: undefined,
	      content: '',
	      buttons: [],
	      verticalButtons: false,
	      onClick: undefined,
	      cssClass: undefined,
	      destroyOnClose: false,
	      on: {},
	    }, params);
	    if (typeof extendedParams.closeByBackdropClick === 'undefined') {
	      extendedParams.closeByBackdropClick = app.params.dialog.closeByBackdropClick;
	    }

	    // Extends with open/close Modal methods;
	    Modal$$1.call(this, app, extendedParams);

	    var dialog = this;

	    var title = extendedParams.title;
	    var text = extendedParams.text;
	    var content = extendedParams.content;
	    var buttons = extendedParams.buttons;
	    var verticalButtons = extendedParams.verticalButtons;
	    var cssClass = extendedParams.cssClass;

	    dialog.params = extendedParams;

	    // Find Element
	    var $el;
	    if (!dialog.params.el) {
	      var dialogClasses = ['dialog'];
	      if (buttons.length === 0) { dialogClasses.push('dialog-no-buttons'); }
	      if (buttons.length > 0) { dialogClasses.push(("dialog-buttons-" + (buttons.length))); }
	      if (verticalButtons) { dialogClasses.push('dialog-buttons-vertical'); }
	      if (cssClass) { dialogClasses.push(cssClass); }

	      var buttonsHTML = '';
	      if (buttons.length > 0) {
	        buttonsHTML = "\n          <div class=\"dialog-buttons\">\n            " + (buttons.map(function (button) { return ("\n              <span class=\"dialog-button" + (button.bold ? ' dialog-button-bold' : '') + (button.color ? (" color-" + (button.color)) : '') + (button.cssClass ? (" " + (button.cssClass)) : '') + "\">" + (button.text) + "</span>\n            "); }).join('')) + "\n          </div>\n        ";
	      }

	      var dialogHtml = "\n        <div class=\"" + (dialogClasses.join(' ')) + "\">\n          <div class=\"dialog-inner\">\n            " + (title ? ("<div class=\"dialog-title\">" + title + "</div>") : '') + "\n            " + (text ? ("<div class=\"dialog-text\">" + text + "</div>") : '') + "\n            " + content + "\n          </div>\n          " + buttonsHTML + "\n        </div>\n      ";
	      $el = $$1(dialogHtml);
	    } else {
	      $el = $$1(dialog.params.el);
	    }

	    if ($el && $el.length > 0 && $el[0].f7Modal) {
	      return $el[0].f7Modal;
	    }

	    if ($el.length === 0) {
	      return dialog.destroy();
	    }

	    var $backdropEl = app.root.children('.dialog-backdrop');
	    if ($backdropEl.length === 0) {
	      $backdropEl = $$1('<div class="dialog-backdrop"></div>');
	      app.root.append($backdropEl);
	    }

	    // Assign events
	    function buttonOnClick(e) {
	      var buttonEl = this;
	      var index = $$1(buttonEl).index();
	      var button = buttons[index];
	      if (button.onClick) { button.onClick(dialog, e); }
	      if (dialog.params.onClick) { dialog.params.onClick(dialog, index); }
	      if (button.close !== false) { dialog.close(); }
	    }
	    var addKeyboardHander;
	    function onKeyPress(e) {
	      var keyCode = e.keyCode;
	      buttons.forEach(function (button, index) {
	        if (button.keyCodes && button.keyCodes.indexOf(keyCode) >= 0) {
	          if (doc.activeElement) { doc.activeElement.blur(); }
	          if (button.onClick) { button.onClick(dialog, e); }
	          if (dialog.params.onClick) { dialog.params.onClick(dialog, index); }
	          if (button.close !== false) { dialog.close(); }
	        }
	      });
	    }
	    if (buttons && buttons.length > 0) {
	      dialog.on('open', function () {
	        $el.find('.dialog-button').each(function (index, buttonEl) {
	          var button = buttons[index];
	          if (button.keyCodes) { addKeyboardHander = true; }
	          $$1(buttonEl).on('click', buttonOnClick);
	        });
	        if (
	          addKeyboardHander &&
	          !app.device.ios &&
	          !app.device.android &&
	          !app.device.cordova
	        ) {
	          $$1(doc).on('keydown', onKeyPress);
	        }
	      });
	      dialog.on('close', function () {
	        $el.find('.dialog-button').each(function (index, buttonEl) {
	          $$1(buttonEl).off('click', buttonOnClick);
	        });
	        if (
	          addKeyboardHander &&
	          !app.device.ios &&
	          !app.device.android &&
	          !app.device.cordova
	        ) {
	          $$1(doc).off('keydown', onKeyPress);
	        }
	        addKeyboardHander = false;
	      });
	    }
	    Utils.extend(dialog, {
	      app: app,
	      $el: $el,
	      el: $el[0],
	      $backdropEl: $backdropEl,
	      backdropEl: $backdropEl[0],
	      type: 'dialog',
	      setProgress: function setProgress(progress, duration) {
	        app.progressbar.set($el.find('.progressbar'), progress, duration);
	        return dialog;
	      },
	      setText: function setText(newText) {
	        var $textEl = $el.find('.dialog-text');
	        if ($textEl.length === 0) {
	          $textEl = $$1('<div class="dialog-text"></div>');
	          if (typeof title !== 'undefined') {
	            $textEl.insertAfter($el.find('.dialog-title'));
	          } else {
	            $el.find('.dialog-inner').prepend($textEl);
	          }
	        }
	        $textEl.html(newText);
	        dialog.params.text = newText;
	        return dialog;
	      },
	      setTitle: function setTitle(newTitle) {
	        var $titleEl = $el.find('.dialog-title');
	        if ($titleEl.length === 0) {
	          $titleEl = $$1('<div class="dialog-title"></div>');
	          $el.find('.dialog-inner').prepend($titleEl);
	        }
	        $titleEl.html(newTitle);
	        dialog.params.title = newTitle;
	        return dialog;
	      },
	    });

	    function handleClick(e) {
	      var target = e.target;
	      var $target = $$1(target);
	      if ($target.closest(dialog.el).length === 0) {
	        if (
	          dialog.params.closeByBackdropClick &&
	          dialog.backdropEl &&
	          dialog.backdropEl === target
	        ) {
	          dialog.close();
	        }
	      }
	    }

	    dialog.on('opened', function () {
	      if (dialog.params.closeByBackdropClick) {
	        app.on('click', handleClick);
	      }
	    });
	    dialog.on('close', function () {
	      if (dialog.params.closeByBackdropClick) {
	        app.off('click', handleClick);
	      }
	    });

	    $el[0].f7Modal = dialog;

	    if (dialog.params.destroyOnClose) {
	      dialog.once('closed', function () {
	        setTimeout(function () {
	          dialog.destroy();
	        }, 0);
	      });
	    }

	    return dialog;
	  }

	  if ( Modal$$1 ) Dialog.__proto__ = Modal$$1;
	  Dialog.prototype = Object.create( Modal$$1 && Modal$$1.prototype );
	  Dialog.prototype.constructor = Dialog;

	  return Dialog;
	}(Modal));

	function ConstructorMethods (parameters) {
	  if ( parameters === void 0 ) parameters = {};

	  var defaultSelector = parameters.defaultSelector;
	  var constructor = parameters.constructor;
	  var domProp = parameters.domProp;
	  var app = parameters.app;
	  var addMethods = parameters.addMethods;
	  var methods = {
	    create: function create() {
	      var args = [], len = arguments.length;
	      while ( len-- ) args[ len ] = arguments[ len ];

	      if (app) { return new (Function.prototype.bind.apply( constructor, [ null ].concat( [app], args) )); }
	      return new (Function.prototype.bind.apply( constructor, [ null ].concat( args) ));
	    },
	    get: function get(el) {
	      if ( el === void 0 ) el = defaultSelector;

	      if (el instanceof constructor) { return el; }
	      var $el = $$1(el);
	      if ($el.length === 0) { return undefined; }
	      return $el[0][domProp];
	    },
	    destroy: function destroy(el) {
	      var instance = methods.get(el);
	      if (instance && instance.destroy) { return instance.destroy(); }
	      return undefined;
	    },
	  };
	  if (addMethods && Array.isArray(addMethods)) {
	    addMethods.forEach(function (methodName) {
	      methods[methodName] = function (el) {
	        var args = [], len = arguments.length - 1;
	        while ( len-- > 0 ) args[ len ] = arguments[ len + 1 ];

	        if ( el === void 0 ) el = defaultSelector;
	        var instance = methods.get(el);
	        if (instance && instance[methodName]) { return instance[methodName].apply(instance, args); }
	        return undefined;
	      };
	    });
	  }
	  return methods;
	}

	function ModalMethods (parameters) {
	  if ( parameters === void 0 ) parameters = {};

	  var defaultSelector = parameters.defaultSelector;
	  var constructor = parameters.constructor;
	  var app = parameters.app;
	  var methods = Utils.extend(
	    ConstructorMethods({
	      defaultSelector: defaultSelector,
	      constructor: constructor,
	      app: app,
	      domProp: 'f7Modal',
	    }),
	    {
	      open: function open(el, animate) {
	        var $el = $$1(el);
	        var instance = $el[0].f7Modal;
	        if (!instance) { instance = new constructor(app, { el: $el }); }
	        return instance.open(animate);
	      },
	      close: function close(el, animate) {
	        if ( el === void 0 ) el = defaultSelector;

	        var $el = $$1(el);
	        if ($el.length === 0) { return undefined; }
	        var instance = $el[0].f7Modal;
	        if (!instance) { instance = new constructor(app, { el: $el }); }
	        return instance.close(animate);
	      },
	    }
	  );
	  return methods;
	}

	var Dialog$1 = {
	  name: 'dialog',
	  params: {
	    dialog: {
	      title: undefined,
	      buttonOk: 'OK',
	      buttonCancel: 'Cancel',
	      usernamePlaceholder: 'Username',
	      passwordPlaceholder: 'Password',
	      preloaderTitle: 'Loading... ',
	      progressTitle: 'Loading... ',
	      closeByBackdropClick: false,
	      destroyPredefinedDialogs: true,
	      keyboardActions: true,
	    },
	  },
	  static: {
	    Dialog: Dialog,
	  },
	  create: function create() {
	    var app = this;
	    var defaultDialogTitle = app.params.dialog.title || app.name;
	    var destroyOnClose = app.params.dialog.destroyPredefinedDialogs;
	    var keyboardActions = app.params.dialog.keyboardActions;
	    app.dialog = Utils.extend(
	      ModalMethods({
	        app: app,
	        constructor: Dialog,
	        defaultSelector: '.dialog.modal-in',
	      }),
	      {
	        // Shortcuts
	        alert: function alert() {
	          var args = [], len = arguments.length;
	          while ( len-- ) args[ len ] = arguments[ len ];

	          var text = args[0];
	          var title = args[1];
	          var callbackOk = args[2];
	          if (args.length === 2 && typeof args[1] === 'function') {
	            var assign;
	            (assign = args, text = assign[0], callbackOk = assign[1], title = assign[2]);
	          }
	          return new Dialog(app, {
	            title: typeof title === 'undefined' ? defaultDialogTitle : title,
	            text: text,
	            buttons: [{
	              text: app.params.dialog.buttonOk,
	              bold: true,
	              onClick: callbackOk,
	              keyCodes: keyboardActions ? [13, 27] : null,
	            }],
	            destroyOnClose: destroyOnClose,
	          }).open();
	        },
	        prompt: function prompt() {
	          var args = [], len = arguments.length;
	          while ( len-- ) args[ len ] = arguments[ len ];

	          var text = args[0];
	          var title = args[1];
	          var callbackOk = args[2];
	          var callbackCancel = args[3];
	          if (typeof args[1] === 'function') {
	            var assign;
	            (assign = args, text = assign[0], callbackOk = assign[1], callbackCancel = assign[2], title = assign[3]);
	          }
	          return new Dialog(app, {
	            title: typeof title === 'undefined' ? defaultDialogTitle : title,
	            text: text,
	            content: '<div class="dialog-input-field item-input"><div class="item-input-wrap"><input type="text" class="dialog-input"></div></div>',
	            buttons: [
	              {
	                text: app.params.dialog.buttonCancel,
	                keyCodes: keyboardActions ? [27] : null,
	              },
	              {
	                text: app.params.dialog.buttonOk,
	                bold: true,
	                keyCodes: keyboardActions ? [13] : null,
	              } ],
	            onClick: function onClick(dialog, index) {
	              var inputValue = dialog.$el.find('.dialog-input').val();
	              if (index === 0 && callbackCancel) { callbackCancel(inputValue); }
	              if (index === 1 && callbackOk) { callbackOk(inputValue); }
	            },
	            destroyOnClose: destroyOnClose,
	          }).open();
	        },
	        confirm: function confirm() {
	          var args = [], len = arguments.length;
	          while ( len-- ) args[ len ] = arguments[ len ];

	          var text = args[0];
	          var title = args[1];
	          var callbackOk = args[2];
	          var callbackCancel = args[3];
	          if (typeof args[1] === 'function') {
	            var assign;
	            (assign = args, text = assign[0], callbackOk = assign[1], callbackCancel = assign[2], title = assign[3]);
	          }
	          return new Dialog(app, {
	            title: typeof title === 'undefined' ? defaultDialogTitle : title,
	            text: text,
	            buttons: [
	              {
	                text: app.params.dialog.buttonCancel,
	                onClick: callbackCancel,
	                keyCodes: keyboardActions ? [27] : null,
	              },
	              {
	                text: app.params.dialog.buttonOk,
	                bold: true,
	                onClick: callbackOk,
	                keyCodes: keyboardActions ? [13] : null,
	              } ],
	            destroyOnClose: destroyOnClose,
	          }).open();
	        },
	        login: function login() {
	          var args = [], len = arguments.length;
	          while ( len-- ) args[ len ] = arguments[ len ];

	          var text = args[0];
	          var title = args[1];
	          var callbackOk = args[2];
	          var callbackCancel = args[3];
	          if (typeof args[1] === 'function') {
	            var assign;
	            (assign = args, text = assign[0], callbackOk = assign[1], callbackCancel = assign[2], title = assign[3]);
	          }
	          return new Dialog(app, {
	            title: typeof title === 'undefined' ? defaultDialogTitle : title,
	            text: text,
	            content: ("\n              <div class=\"dialog-input-field dialog-input-double item-input\">\n                <div class=\"item-input-wrap\">\n                  <input type=\"text\" name=\"dialog-username\" placeholder=\"" + (app.params.dialog.usernamePlaceholder) + "\" class=\"dialog-input\">\n                </div>\n              </div>\n              <div class=\"dialog-input-field dialog-input-double item-input\">\n                <div class=\"item-input-wrap\">\n                  <input type=\"password\" name=\"dialog-password\" placeholder=\"" + (app.params.dialog.passwordPlaceholder) + "\" class=\"dialog-input\">\n                </div>\n              </div>"),
	            buttons: [
	              {
	                text: app.params.dialog.buttonCancel,
	                keyCodes: keyboardActions ? [27] : null,
	              },
	              {
	                text: app.params.dialog.buttonOk,
	                bold: true,
	                keyCodes: keyboardActions ? [13] : null,
	              } ],
	            onClick: function onClick(dialog, index) {
	              var username = dialog.$el.find('[name="dialog-username"]').val();
	              var password = dialog.$el.find('[name="dialog-password"]').val();
	              if (index === 0 && callbackCancel) { callbackCancel(username, password); }
	              if (index === 1 && callbackOk) { callbackOk(username, password); }
	            },
	            destroyOnClose: destroyOnClose,
	          }).open();
	        },
	        password: function password() {
	          var args = [], len = arguments.length;
	          while ( len-- ) args[ len ] = arguments[ len ];

	          var text = args[0];
	          var title = args[1];
	          var callbackOk = args[2];
	          var callbackCancel = args[3];
	          if (typeof args[1] === 'function') {
	            var assign;
	            (assign = args, text = assign[0], callbackOk = assign[1], callbackCancel = assign[2], title = assign[3]);
	          }
	          return new Dialog(app, {
	            title: typeof title === 'undefined' ? defaultDialogTitle : title,
	            text: text,
	            content: ("\n              <div class=\"dialog-input-field item-input\">\n                <div class=\"item-input-wrap\">\n                  <input type=\"password\" name=\"dialog-password\" placeholder=\"" + (app.params.dialog.passwordPlaceholder) + "\" class=\"dialog-input\">\n                </div>\n              </div>"),
	            buttons: [
	              {
	                text: app.params.dialog.buttonCancel,
	                keyCodes: keyboardActions ? [27] : null,
	              },
	              {
	                text: app.params.dialog.buttonOk,
	                bold: true,
	                keyCodes: keyboardActions ? [13] : null,
	              } ],
	            onClick: function onClick(dialog, index) {
	              var password = dialog.$el.find('[name="dialog-password"]').val();
	              if (index === 0 && callbackCancel) { callbackCancel(password); }
	              if (index === 1 && callbackOk) { callbackOk(password); }
	            },
	            destroyOnClose: destroyOnClose,
	          }).open();
	        },
	        preloader: function preloader(title) {
	          var preloaderInner = app.theme !== 'md' ? '' : Utils.mdPreloaderContent;
	          return new Dialog(app, {
	            title: typeof title === 'undefined' ? app.params.dialog.preloaderTitle : title,
	            content: ("<div class=\"preloader\">" + preloaderInner + "</div>"),
	            cssClass: 'dialog-preloader',
	            destroyOnClose: destroyOnClose,
	          }).open();
	        },
	        progress: function progress() {
	          var args = [], len = arguments.length;
	          while ( len-- ) args[ len ] = arguments[ len ];

	          var title = args[0];
	          var progress = args[1];
	          var color = args[2];
	          if (args.length === 2) {
	            if (typeof args[0] === 'number') {
	              var assign;
	              (assign = args, progress = assign[0], color = assign[1], title = assign[2]);
	            } else if (typeof args[0] === 'string' && typeof args[1] === 'string') {
	              var assign$1;
	              (assign$1 = args, title = assign$1[0], color = assign$1[1], progress = assign$1[2]);
	            }
	          } else if (args.length === 1) {
	            if (typeof args[0] === 'number') {
	              var assign$2;
	              (assign$2 = args, progress = assign$2[0], title = assign$2[1], color = assign$2[2]);
	            }
	          }
	          var infinite = typeof progress === 'undefined';
	          var dialog = new Dialog(app, {
	            title: typeof title === 'undefined' ? app.params.dialog.progressTitle : title,
	            cssClass: 'dialog-progress',
	            content: ("\n              <div class=\"progressbar" + (infinite ? '-infinite' : '') + (color ? (" color-" + color) : '') + "\">\n                " + (!infinite ? '<span></span>' : '') + "\n              </div>\n            "),
	            destroyOnClose: destroyOnClose,
	          });
	          if (!infinite) { dialog.setProgress(progress); }
	          return dialog.open();
	        },
	      }
	    );
	  },
	};

	var Popup = (function (Modal$$1) {
	  function Popup(app, params) {
	    var extendedParams = Utils.extend(
	      { on: {} },
	      app.params.popup,
	      params
	    );

	    // Extends with open/close Modal methods;
	    Modal$$1.call(this, app, extendedParams);

	    var popup = this;

	    popup.params = extendedParams;

	    // Find Element
	    var $el;
	    if (!popup.params.el) {
	      $el = $$1(popup.params.content);
	    } else {
	      $el = $$1(popup.params.el);
	    }

	    if ($el && $el.length > 0 && $el[0].f7Modal) {
	      return $el[0].f7Modal;
	    }

	    if ($el.length === 0) {
	      return popup.destroy();
	    }

	    var $backdropEl;
	    if (popup.params.backdrop) {
	      $backdropEl = app.root.children('.popup-backdrop');
	      if ($backdropEl.length === 0) {
	        $backdropEl = $$1('<div class="popup-backdrop"></div>');
	        app.root.append($backdropEl);
	      }
	    }

	    Utils.extend(popup, {
	      app: app,
	      $el: $el,
	      el: $el[0],
	      $backdropEl: $backdropEl,
	      backdropEl: $backdropEl && $backdropEl[0],
	      type: 'popup',
	    });

	    function handleClick(e) {
	      var target = e.target;
	      var $target = $$1(target);
	      if ($target.closest(popup.el).length === 0) {
	        if (
	          popup.params &&
	          popup.params.closeByBackdropClick &&
	          popup.params.backdrop &&
	          popup.backdropEl &&
	          popup.backdropEl === target
	        ) {
	          popup.close();
	        }
	      }
	    }

	    popup.on('popupOpened', function () {
	      if (popup.params.closeByBackdropClick) {
	        app.on('click', handleClick);
	      }
	    });
	    popup.on('popupClose', function () {
	      if (popup.params.closeByBackdropClick) {
	        app.off('click', handleClick);
	      }
	    });

	    $el[0].f7Modal = popup;

	    return popup;
	  }

	  if ( Modal$$1 ) Popup.__proto__ = Modal$$1;
	  Popup.prototype = Object.create( Modal$$1 && Modal$$1.prototype );
	  Popup.prototype.constructor = Popup;

	  return Popup;
	}(Modal));

	var Popup$1 = {
	  name: 'popup',
	  params: {
	    popup: {
	      backdrop: true,
	      closeByBackdropClick: true,
	    },
	  },
	  static: {
	    Popup: Popup,
	  },
	  create: function create() {
	    var app = this;
	    app.popup = ModalMethods({
	      app: app,
	      constructor: Popup,
	      defaultSelector: '.popup.modal-in',
	    });
	  },
	  clicks: {
	    '.popup-open': function openPopup($clickedEl, data) {
	      if ( data === void 0 ) data = {};

	      var app = this;
	      app.popup.open(data.popup, data.animate);
	    },
	    '.popup-close': function closePopup($clickedEl, data) {
	      if ( data === void 0 ) data = {};

	      var app = this;
	      app.popup.close(data.popup, data.animate);
	    },
	  },
	};

	var LoginScreen = (function (Modal$$1) {
	  function LoginScreen(app, params) {
	    var extendedParams = Utils.extend({
	      on: {},
	    }, params);

	    // Extends with open/close Modal methods;
	    Modal$$1.call(this, app, extendedParams);

	    var loginScreen = this;

	    loginScreen.params = extendedParams;

	    // Find Element
	    var $el;
	    if (!loginScreen.params.el) {
	      $el = $$1(loginScreen.params.content);
	    } else {
	      $el = $$1(loginScreen.params.el);
	    }

	    if ($el && $el.length > 0 && $el[0].f7Modal) {
	      return $el[0].f7Modal;
	    }

	    if ($el.length === 0) {
	      return loginScreen.destroy();
	    }

	    Utils.extend(loginScreen, {
	      app: app,
	      $el: $el,
	      el: $el[0],
	      type: 'loginScreen',
	    });

	    $el[0].f7Modal = loginScreen;

	    return loginScreen;
	  }

	  if ( Modal$$1 ) LoginScreen.__proto__ = Modal$$1;
	  LoginScreen.prototype = Object.create( Modal$$1 && Modal$$1.prototype );
	  LoginScreen.prototype.constructor = LoginScreen;

	  return LoginScreen;
	}(Modal));

	var LoginScreen$1 = {
	  name: 'loginScreen',
	  static: {
	    LoginScreen: LoginScreen,
	  },
	  create: function create() {
	    var app = this;
	    app.loginScreen = ModalMethods({
	      app: app,
	      constructor: LoginScreen,
	      defaultSelector: '.login-screen.modal-in',
	    });
	  },
	  clicks: {
	    '.login-screen-open': function openLoginScreen($clickedEl, data) {
	      if ( data === void 0 ) data = {};

	      var app = this;
	      app.loginScreen.open(data.loginScreen, data.animate);
	    },
	    '.login-screen-close': function closeLoginScreen($clickedEl, data) {
	      if ( data === void 0 ) data = {};

	      var app = this;
	      app.loginScreen.close(data.loginScreen, data.animate);
	    },
	  },
	};

	var Popover = (function (Modal$$1) {
	  function Popover(app, params) {
	    var extendedParams = Utils.extend(
	      { on: {} },
	      app.params.popover,
	      params
	    );

	    // Extends with open/close Modal methods;
	    Modal$$1.call(this, app, extendedParams);

	    var popover = this;

	    popover.params = extendedParams;

	    // Find Element
	    var $el;
	    if (!popover.params.el) {
	      $el = $$1(popover.params.content);
	    } else {
	      $el = $$1(popover.params.el);
	    }

	    if ($el && $el.length > 0 && $el[0].f7Modal) {
	      return $el[0].f7Modal;
	    }

	    // Find Target
	    var $targetEl = $$1(popover.params.targetEl).eq(0);

	    if ($el.length === 0) {
	      return popover.destroy();
	    }

	    // Backdrop
	    var $backdropEl;
	    if (popover.params.backdrop) {
	      $backdropEl = app.root.children('.popover-backdrop');
	      if ($backdropEl.length === 0) {
	        $backdropEl = $$1('<div class="popover-backdrop"></div>');
	        app.root.append($backdropEl);
	      }
	    }

	    // Find Angle
	    var $angleEl;
	    if ($el.find('.popover-angle').length === 0) {
	      $angleEl = $$1('<div class="popover-angle"></div>');
	      $el.prepend($angleEl);
	    } else {
	      $angleEl = $el.find('.popover-angle');
	    }

	    // Open
	    var originalOpen = popover.open;

	    Utils.extend(popover, {
	      app: app,
	      $el: $el,
	      el: $el[0],
	      $targetEl: $targetEl,
	      targetEl: $targetEl[0],
	      $angleEl: $angleEl,
	      angleEl: $angleEl[0],
	      $backdropEl: $backdropEl,
	      backdropEl: $backdropEl && $backdropEl[0],
	      type: 'popover',
	      open: function open() {
	        var args = [], len = arguments.length;
	        while ( len-- ) args[ len ] = arguments[ len ];

	        var targetEl = args[0];
	        var animate = args[1];
	        if (typeof args[0] === 'boolean') { var assign;
	          (assign = args, animate = assign[0], targetEl = assign[1]); }
	        if (targetEl) {
	          popover.$targetEl = $$1(targetEl);
	          popover.targetEl = popover.$targetEl[0];
	        }
	        originalOpen.call(popover, animate);
	      },
	    });

	    function handleResize() {
	      popover.resize();
	    }
	    popover.on('popoverOpen', function () {
	      popover.resize();
	      app.on('resize', handleResize);
	      popover.on('popoverClose popoverBeforeDestroy', function () {
	        app.off('resize', handleResize);
	      });
	    });

	    function handleClick(e) {
	      var target = e.target;
	      var $target = $$1(target);
	      if ($target.closest(popover.el).length === 0) {
	        if (
	          popover.params.closeByBackdropClick &&
	          popover.params.backdrop &&
	          popover.backdropEl &&
	          popover.backdropEl === target
	        ) {
	          popover.close();
	        } else if (popover.params.closeByOutsideClick) {
	          popover.close();
	        }
	      }
	    }

	    popover.on('popoverOpened', function () {
	      if (popover.params.closeByOutsideClick || popover.params.closeByBackdropClick) {
	        app.on('click', handleClick);
	      }
	    });
	    popover.on('popoverClose', function () {
	      if (popover.params.closeByOutsideClick || popover.params.closeByBackdropClick) {
	        app.off('click', handleClick);
	      }
	    });

	    $el[0].f7Modal = popover;

	    return popover;
	  }

	  if ( Modal$$1 ) Popover.__proto__ = Modal$$1;
	  Popover.prototype = Object.create( Modal$$1 && Modal$$1.prototype );
	  Popover.prototype.constructor = Popover;
	  Popover.prototype.resize = function resize () {
	    var popover = this;
	    var app = popover.app;
	    var $el = popover.$el;
	    var $targetEl = popover.$targetEl;
	    var $angleEl = popover.$angleEl;
	    var ref = popover.params;
	    var targetX = ref.targetX;
	    var targetY = ref.targetY;
	    $el.css({ left: '', top: '' });
	    var ref$1 = [$el.width(), $el.height()];
	    var width = ref$1[0];
	    var height = ref$1[1];
	    var angleSize = 0;
	    var angleLeft;
	    var angleTop;
	    if (app.theme === 'ios') {
	      $angleEl.removeClass('on-left on-right on-top on-bottom').css({ left: '', top: '' });
	      angleSize = $angleEl.width() / 2;
	    } else {
	      $el.removeClass('popover-on-left popover-on-right popover-on-top popover-on-bottom').css({ left: '', top: '' });
	    }

	    var targetWidth;
	    var targetHeight;
	    var targetOffsetLeft;
	    var targetOffsetTop;
	    if ($targetEl && $targetEl.length > 0) {
	      targetWidth = $targetEl.outerWidth();
	      targetHeight = $targetEl.outerHeight();

	      var targetOffset = $targetEl.offset();
	      targetOffsetLeft = targetOffset.left - app.left;
	      targetOffsetTop = targetOffset.top - app.top;

	      var targetParentPage = $targetEl.parents('.page');
	      if (targetParentPage.length > 0) {
	        targetOffsetTop -= targetParentPage[0].scrollTop;
	      }
	    } else if (typeof targetX !== 'undefined' && targetY !== 'undefined') {
	      targetOffsetLeft = targetX;
	      targetOffsetTop = targetY;
	      targetWidth = popover.params.targetWidth || 0;
	      targetHeight = popover.params.targetHeight || 0;
	    }

	    var ref$2 = [0, 0, 0];
	    var left = ref$2[0];
	    var top = ref$2[1];
	    var diff = ref$2[2];
	    // Top Position
	    var position = app.theme === 'md' ? 'bottom' : 'top';
	    if (app.theme === 'md') {
	      if (height < app.height - targetOffsetTop - targetHeight) {
	        // On bottom
	        position = 'bottom';
	        top = targetOffsetTop;
	      } else if (height < targetOffsetTop) {
	        // On top
	        top = (targetOffsetTop - height) + targetHeight;
	        position = 'top';
	      } else {
	        // On middle
	        position = 'bottom';
	        top = targetOffsetTop;
	      }

	      if (top <= 0) {
	        top = 8;
	      } else if (top + height >= app.height) {
	        top = app.height - height - 8;
	      }

	      // Horizontal Position
	      left = (targetOffsetLeft + targetWidth) - width - 8;
	      if (left + width >= app.width - 8) {
	        left = (targetOffsetLeft + targetWidth) - width - 8;
	      }
	      if (left < 8) {
	        left = 8;
	      }
	      if (position === 'top') {
	        $el.addClass('popover-on-top');
	      }
	      if (position === 'bottom') {
	        $el.addClass('popover-on-bottom');
	      }
	    } else {
	      if ((height + angleSize) < targetOffsetTop) {
	        // On top
	        top = targetOffsetTop - height - angleSize;
	      } else if ((height + angleSize) < app.height - targetOffsetTop - targetHeight) {
	        // On bottom
	        position = 'bottom';
	        top = targetOffsetTop + targetHeight + angleSize;
	      } else {
	        // On middle
	        position = 'middle';
	        top = ((targetHeight / 2) + targetOffsetTop) - (height / 2);
	        diff = top;
	        if (top <= 0) {
	          top = 5;
	        } else if (top + height >= app.height) {
	          top = app.height - height - 5;
	        }
	        diff -= top;
	      }

	      // Horizontal Position
	      if (position === 'top' || position === 'bottom') {
	        left = ((targetWidth / 2) + targetOffsetLeft) - (width / 2);
	        diff = left;
	        if (left < 5) { left = 5; }
	        if (left + width > app.width) { left = app.width - width - 5; }
	        if (left < 0) { left = 0; }
	        if (position === 'top') {
	          $angleEl.addClass('on-bottom');
	        }
	        if (position === 'bottom') {
	          $angleEl.addClass('on-top');
	        }
	        diff -= left;
	        angleLeft = ((width / 2) - angleSize) + diff;
	        angleLeft = Math.max(Math.min(angleLeft, width - (angleSize * 2) - 13), 13);
	        $angleEl.css({ left: (angleLeft + "px") });
	      } else if (position === 'middle') {
	        left = targetOffsetLeft - width - angleSize;
	        $angleEl.addClass('on-right');
	        if (left < 5 || (left + width > app.width)) {
	          if (left < 5) { left = targetOffsetLeft + targetWidth + angleSize; }
	          if (left + width > app.width) { left = app.width - width - 5; }
	          $angleEl.removeClass('on-right').addClass('on-left');
	        }
	        angleTop = ((height / 2) - angleSize) + diff;
	        angleTop = Math.max(Math.min(angleTop, height - (angleSize * 2) - 13), 13);
	        $angleEl.css({ top: (angleTop + "px") });
	      }
	    }

	    // Apply Styles
	    $el.css({ top: (top + "px"), left: (left + "px") });
	  };

	  return Popover;
	}(Modal));

	var Popover$1 = {
	  name: 'popover',
	  params: {
	    popover: {
	      closeByBackdropClick: true,
	      closeByOutsideClick: false,
	      backdrop: true,
	    },
	  },
	  static: {
	    Popover: Popover,
	  },
	  create: function create() {
	    var app = this;
	    app.popover = Utils.extend(
	      ModalMethods({
	        app: app,
	        constructor: Popover,
	        defaultSelector: '.popover.modal-in',
	      }),
	      {
	        open: function open(popoverEl, targetEl, animate) {
	          var $popoverEl = $$1(popoverEl);
	          var popover = $popoverEl[0].f7Modal;
	          if (!popover) { popover = new Popover(app, { el: $popoverEl, targetEl: targetEl }); }
	          return popover.open(targetEl, animate);
	        },
	      }
	    );
	  },
	  clicks: {
	    '.popover-open': function openPopover($clickedEl, data) {
	      if ( data === void 0 ) data = {};

	      var app = this;
	      app.popover.open(data.popover, $clickedEl, data.animate);
	    },
	    '.popover-close': function closePopover($clickedEl, data) {
	      if ( data === void 0 ) data = {};

	      var app = this;
	      app.popover.close(data.popover, data.animate);
	    },
	  },
	};

	/* eslint indent: ["off"] */

	var Actions = (function (Modal$$1) {
	  function Actions(app, params) {
	    var extendedParams = Utils.extend(
	      { on: {} },
	      app.params.actions,
	      params
	    );

	    // Extends with open/close Modal methods;
	    Modal$$1.call(this, app, extendedParams);

	    var actions = this;

	    actions.params = extendedParams;

	    // Buttons
	    var groups;
	    if (actions.params.buttons) {
	      groups = actions.params.buttons;
	      if (!Array.isArray(groups[0])) { groups = [groups]; }
	    }
	    actions.groups = groups;

	    // Find Element
	    var $el;
	    if (actions.params.el) {
	      $el = $$1(actions.params.el);
	    } else if (actions.params.content) {
	      $el = $$1(actions.params.content);
	    } else if (actions.params.buttons) {
	      if (actions.params.convertToPopover) {
	        actions.popoverHtml = actions.renderPopover();
	      }
	      actions.actionsHtml = actions.render();
	    }

	    if ($el && $el.length > 0 && $el[0].f7Modal) {
	      return $el[0].f7Modal;
	    }

	    if ($el && $el.length === 0 && !(actions.actionsHtml || actions.popoverHtml)) {
	      return actions.destroy();
	    }

	    // Backdrop
	    var $backdropEl;
	    if (actions.params.backdrop) {
	      $backdropEl = app.root.children('.actions-backdrop');
	      if ($backdropEl.length === 0) {
	        $backdropEl = $$1('<div class="actions-backdrop"></div>');
	        app.root.append($backdropEl);
	      }
	    }

	    var originalOpen = actions.open;
	    var originalClose = actions.close;

	    var popover;
	    function buttonOnClick(e) {
	      var buttonEl = this;
	      var buttonIndex;
	      var groupIndex;
	      if ($$1(buttonEl).hasClass('item-link')) {
	        buttonIndex = $$1(buttonEl).parents('li').index();
	        groupIndex = $$1(buttonEl).parents('.list').index();
	      } else {
	        buttonIndex = $$1(buttonEl).index();
	        groupIndex = $$1(buttonEl).parents('.actions-group').index();
	      }
	      if (typeof groups !== 'undefined') {
	        var button = groups[groupIndex][buttonIndex];
	        if (button.onClick) { button.onClick(actions, e); }
	        if (actions.params.onClick) { actions.params.onClick(actions, e); }
	        if (button.close !== false) { actions.close(); }
	      }
	    }
	    actions.open = function open(animate) {
	      var convertToPopover = false;
	      var ref = actions.params;
	      var targetEl = ref.targetEl;
	      var targetX = ref.targetX;
	      var targetY = ref.targetY;
	      var targetWidth = ref.targetWidth;
	      var targetHeight = ref.targetHeight;
	      if (actions.params.convertToPopover && (targetEl || (targetX !== undefined && targetY !== undefined))) {
	        // Popover
	        if (
	          actions.params.forceToPopover ||
	          (app.device.ios && app.device.ipad) ||
	          app.width >= 768
	        ) {
	          convertToPopover = true;
	        }
	      }
	      if (convertToPopover && actions.popoverHtml) {
	        popover = app.popover.create({
	          content: actions.popoverHtml,
	          backdrop: actions.params.backdrop,
	          targetEl: targetEl,
	          targetX: targetX,
	          targetY: targetY,
	          targetWidth: targetWidth,
	          targetHeight: targetHeight,
	        });
	        popover.open(animate);
	        popover.once('popoverOpened', function () {
	          popover.$el.find('.item-link').each(function (groupIndex, buttonEl) {
	            $$1(buttonEl).on('click', buttonOnClick);
	          });
	        });
	        popover.once('popoverClosed', function () {
	          popover.$el.find('.item-link').each(function (groupIndex, buttonEl) {
	            $$1(buttonEl).off('click', buttonOnClick);
	          });
	          Utils.nextTick(function () {
	            popover.destroy();
	            popover = undefined;
	          });
	        });
	      } else {
	        actions.$el = actions.actionsHtml ? $$1(actions.actionsHtml) : actions.$el;
	        actions.$el[0].f7Modal = actions;
	        if (actions.groups) {
	          actions.$el.find('.actions-button').each(function (groupIndex, buttonEl) {
	            $$1(buttonEl).on('click', buttonOnClick);
	          });
	          actions.once('actionsClosed', function () {
	            actions.$el.find('.actions-button').each(function (groupIndex, buttonEl) {
	              $$1(buttonEl).off('click', buttonOnClick);
	            });
	          });
	        }
	        actions.el = actions.$el[0];
	        originalOpen.call(actions, animate);
	      }
	      return actions;
	    };

	    actions.close = function close(animate) {
	      if (popover) {
	        popover.close(animate);
	      } else {
	        originalClose.call(actions, animate);
	      }
	      return actions;
	    };

	    Utils.extend(actions, {
	      app: app,
	      $el: $el,
	      el: $el ? $el[0] : undefined,
	      $backdropEl: $backdropEl,
	      backdropEl: $backdropEl && $backdropEl[0],
	      type: 'actions',
	    });

	    function handleClick(e) {
	      var target = e.target;
	      var $target = $$1(target);
	      if ($target.closest(actions.el).length === 0) {
	        if (
	          actions.params.closeByBackdropClick &&
	          actions.params.backdrop &&
	          actions.backdropEl &&
	          actions.backdropEl === target
	        ) {
	          actions.close();
	        } else if (actions.params.closeByOutsideClick) {
	          actions.close();
	        }
	      }
	    }

	    actions.on('opened', function () {
	      if (actions.params.closeByBackdropClick || actions.params.closeByOutsideClick) {
	        app.on('click', handleClick);
	      }
	    });
	    actions.on('close', function () {
	      if (actions.params.closeByBackdropClick || actions.params.closeByOutsideClick) {
	        app.off('click', handleClick);
	      }
	    });

	    if ($el) {
	      $el[0].f7Modal = actions;
	    }

	    return actions;
	  }

	  if ( Modal$$1 ) Actions.__proto__ = Modal$$1;
	  Actions.prototype = Object.create( Modal$$1 && Modal$$1.prototype );
	  Actions.prototype.constructor = Actions;
	  Actions.prototype.render = function render () {
	    var actions = this;
	    if (actions.params.render) { return actions.params.render.call(actions, actions); }
	    var groups = actions.groups;
	    return ("\n      <div class=\"actions-modal" + (actions.params.grid ? ' actions-grid' : '') + "\">\n        " + (groups.map(function (group) { return ("<div class=\"actions-group\">\n            " + (group.map(function (button) {
	              var buttonClasses = [("actions-" + (button.label ? 'label' : 'button'))];
	              var color = button.color;
	              var bg = button.bg;
	              var bold = button.bold;
	              var disabled = button.disabled;
	              var label = button.label;
	              var text = button.text;
	              var icon = button.icon;
	              if (color) { buttonClasses.push(("color-" + color)); }
	              if (bg) { buttonClasses.push(("bg-color-" + bg)); }
	              if (bold) { buttonClasses.push('actions-button-bold'); }
	              if (disabled) { buttonClasses.push('disabled'); }
	              if (label) {
	                return ("<div class=\"" + (buttonClasses.join(' ')) + "\">" + text + "</div>");
	              }
	              return ("\n                <div class=\"" + (buttonClasses.join(' ')) + "\">\n                  " + (icon ? ("<div class=\"actions-button-media\">" + icon + "</div>") : '') + "\n                  <div class=\"actions-button-text\">" + text + "</div>\n                </div>").trim();
	            }).join('')) + "\n          </div>"); }).join('')) + "\n      </div>\n    ").trim();
	  };
	  Actions.prototype.renderPopover = function renderPopover () {
	    var actions = this;
	    if (actions.params.renderPopover) { return actions.params.renderPopover.call(actions, actions); }
	    var groups = actions.groups;
	    return ("\n      <div class=\"popover popover-from-actions\">\n        <div class=\"popover-inner\">\n          " + (groups.map(function (group) { return ("\n            <div class=\"list\">\n              <ul>\n                " + (group.map(function (button) {
	                  var itemClasses = [];
	                  var color = button.color;
	                  var bg = button.bg;
	                  var bold = button.bold;
	                  var disabled = button.disabled;
	                  var label = button.label;
	                  var text = button.text;
	                  var icon = button.icon;
	                  if (color) { itemClasses.push(("color-" + color)); }
	                  if (bg) { itemClasses.push(("bg-color-" + bg)); }
	                  if (bold) { itemClasses.push('popover-from-actions-bold'); }
	                  if (disabled) { itemClasses.push('disabled'); }
	                  if (label) {
	                    itemClasses.push('popover-from-actions-label');
	                    return ("<li class=\"" + (itemClasses.join(' ')) + "\">" + text + "</li>");
	                  }
	                  itemClasses.push('item-link');
	                  if (icon) {
	                    itemClasses.push('item-content');
	                    return ("\n                      <li>\n                        <a class=\"" + (itemClasses.join(' ')) + "\">\n                          <div class=\"item-media\">\n                            " + icon + "\n                          </div>\n                          <div class=\"item-inner\">\n                            <div class=\"item-title\">\n                              " + text + "\n                            </div>\n                          </div>\n                        </a>\n                      </li>\n                    ");
	                  }
	                  itemClasses.push('list-button');
	                  return ("\n                    <li>\n                      <a href=\"#\" class=\"list-button " + (itemClasses.join(' ')) + "\">" + text + "</a>\n                    </li>\n                  ");
	                }).join('')) + "\n              </ul>\n            </div>\n          "); }).join('')) + "\n        </div>\n      </div>\n    ").trim();
	  };

	  return Actions;
	}(Modal));

	var Actions$1 = {
	  name: 'actions',
	  params: {
	    actions: {
	      convertToPopover: true,
	      forceToPopover: false,
	      closeByBackdropClick: true,
	      render: null,
	      renderPopover: null,
	      backdrop: true,
	    },
	  },
	  static: {
	    Actions: Actions,
	  },
	  create: function create() {
	    var app = this;
	    app.actions = ModalMethods({
	      app: app,
	      constructor: Actions,
	      defaultSelector: '.actions-modal.modal-in',
	    });
	  },
	  clicks: {
	    '.actions-open': function openActions($clickedEl, data) {
	      if ( data === void 0 ) data = {};

	      var app = this;
	      app.actions.open(data.actions, data.animate);
	    },
	    '.actions-close': function closeActions($clickedEl, data) {
	      if ( data === void 0 ) data = {};

	      var app = this;
	      app.actions.close(data.actions, data.animate);
	    },
	  },
	};

	var Toast = (function (Modal$$1) {
	  function Toast(app, params) {
	    var extendedParams = Utils.extend({
	      on: {},
	    }, app.params.toast, params);

	    // Extends with open/close Modal methods;
	    Modal$$1.call(this, app, extendedParams);

	    var toast = this;

	    toast.app = app;

	    toast.params = extendedParams;

	    var ref = toast.params;
	    var closeButton = ref.closeButton;
	    var closeTimeout = ref.closeTimeout;

	    var $el;
	    if (!toast.params.el) {
	      // Find Element
	      var toastHtml = toast.render();

	      $el = $$1(toastHtml);
	    } else {
	      $el = $$1(toast.params.el);
	    }

	    if ($el && $el.length > 0 && $el[0].f7Modal) {
	      return $el[0].f7Modal;
	    }

	    if ($el.length === 0) {
	      return toast.destroy();
	    }

	    Utils.extend(toast, {
	      $el: $el,
	      el: $el[0],
	      type: 'toast',
	    });

	    $el[0].f7Modal = toast;

	    if (closeButton) {
	      $el.find('.toast-button').on('click', function () {
	        toast.emit('local::closeButtonClick toastCloseButtonClick', toast);
	        toast.close();
	      });

	      toast.on('beforeDestroy', function () {
	        $el.find('.toast-button').off('click');
	      });
	    }

	    var timeoutId;
	    toast.on('open', function () {
	      $$1('.toast.modal-in').each(function (index, openedEl) {
	        var toastInstance = app.toast.get(openedEl);
	        if (openedEl !== toast.el && toastInstance) {
	          toastInstance.close();
	        }
	      });
	      if (closeTimeout) {
	        timeoutId = Utils.nextTick(function () {
	          toast.close();
	        }, closeTimeout);
	      }
	    });
	    toast.on('close', function () {
	      win.clearTimeout(timeoutId);
	    });

	    if (toast.params.destroyOnClose) {
	      toast.once('closed', function () {
	        setTimeout(function () {
	          toast.destroy();
	        }, 0);
	      });
	    }

	    return toast;
	  }

	  if ( Modal$$1 ) Toast.__proto__ = Modal$$1;
	  Toast.prototype = Object.create( Modal$$1 && Modal$$1.prototype );
	  Toast.prototype.constructor = Toast;
	  Toast.prototype.render = function render () {
	    var toast = this;
	    var app = toast.app;
	    if (toast.params.render) { return toast.params.render.call(toast, toast); }
	    var ref = toast.params;
	    var position = ref.position;
	    var cssClass = ref.cssClass;
	    var icon = ref.icon;
	    var text = ref.text;
	    var closeButton = ref.closeButton;
	    var closeButtonColor = ref.closeButtonColor;
	    var closeButtonText = ref.closeButtonText;
	    return ("\n      <div class=\"toast toast-" + position + " " + (cssClass || '') + " " + (icon ? 'toast-with-icon' : '') + "\">\n        <div class=\"toast-content\">\n          " + (icon ? ("<div class=\"toast-icon\">" + icon + "</div>") : '') + "\n          <div class=\"toast-text\">" + text + "</div>\n          " + (closeButton && !icon ? ("\n          <a class=\"toast-button " + (app.theme === 'md' ? 'button' : 'link') + " " + (closeButtonColor ? ("color-" + closeButtonColor) : '') + "\">" + closeButtonText + "</a>\n          ").trim() : '') + "\n        </div>\n      </div>\n    ").trim();
	  };

	  return Toast;
	}(Modal));

	var Toast$1 = {
	  name: 'toast',
	  static: {
	    Toast: Toast,
	  },
	  create: function create() {
	    var app = this;
	    app.toast = Utils.extend(
	      {},
	      ModalMethods({
	        app: app,
	        constructor: Toast,
	        defaultSelector: '.toast.modal-in',
	      }),
	      {
	        // Shortcuts
	        show: function show(params) {
	          Utils.extend(params, {
	            destroyOnClose: true,
	          });
	          return new Toast(app, params).open();
	        },
	      }
	    );
	  },
	  params: {
	    toast: {
	      icon: null,
	      text: null,
	      position: 'bottom',
	      closeButton: false,
	      closeButtonColor: null,
	      closeButtonText: 'Ok',
	      closeTimeout: null,
	      cssClass: null,
	      render: null,
	    },
	  },
	};

	var Preloader = {
	  init: function init(el) {
	    var app = this;
	    if (app.theme !== 'md') { return; }
	    var $el = $$1(el);
	    if ($el.length === 0 || $el.children('.preloader-inner').length > 0) { return; }
	    $el.append(Utils.mdPreloaderContent);
	  },
	  // Modal
	  visible: false,
	  show: function show(color) {
	    if ( color === void 0 ) color = 'white';

	    var app = this;
	    if (Preloader.visible) { return; }
	    var preloaderInner = app.theme !== 'md' ? '' : Utils.mdPreloaderContent;
	    $$1('html').addClass('with-modal-preloader');
	    app.root.append(("\n      <div class=\"preloader-backdrop\"></div>\n      <div class=\"preloader-modal\">\n        <div class=\"preloader color-" + color + "\">" + preloaderInner + "</div>\n      </div>\n    "));
	    Preloader.visible = true;
	  },
	  hide: function hide() {
	    var app = this;
	    if (!Preloader.visible) { return; }
	    $$1('html').removeClass('with-modal-preloader');
	    app.root.find('.preloader-backdrop, .preloader-modal').remove();
	    Preloader.visible = false;
	  },
	};
	var Preloader$1 = {
	  name: 'preloader',
	  create: function create() {
	    var app = this;
	    Utils.extend(app, {
	      preloader: {
	        init: Preloader.init.bind(app),
	        show: Preloader.show.bind(app),
	        hide: Preloader.hide.bind(app),
	      },
	    });
	  },
	  on: {
	    photoBrowserOpen: function photoBrowserOpen(pb) {
	      var app = this;
	      if (app.theme !== 'md') { return; }
	      pb.$el.find('.preloader').each(function (index, preloaderEl) {
	        app.preloader.init(preloaderEl);
	      });
	    },
	    pageInit: function pageInit(page) {
	      var app = this;
	      if (app.theme !== 'md') { return; }
	      page.$el.find('.preloader').each(function (index, preloaderEl) {
	        app.preloader.init(preloaderEl);
	      });
	    },
	  },
	};

	var Progressbar = {
	  set: function set() {
	    var args = [], len = arguments.length;
	    while ( len-- ) args[ len ] = arguments[ len ];

	    var app = this;
	    var el = args[0];
	    var progress = args[1];
	    var duration = args[2];
	    if (typeof args[0] === 'number') {
	      var assign;
	      (assign = args, progress = assign[0], duration = assign[1]);
	      el = app.root;
	    }
	    if (typeof progress === 'undefined' || progress === null) { return el; }
	    if (!progress) { progress = 0; }

	    var $el = $$1(el || app.root);
	    if ($el.length === 0) {
	      return el;
	    }
	    var progressNormalized = Math.min(Math.max(progress, 0), 100);
	    var $progressbarEl;
	    if ($el.hasClass('progressbar')) { $progressbarEl = $el.eq(0); }
	    else {
	      $progressbarEl = $el.children('.progressbar');
	    }
	    if ($progressbarEl.length === 0 || $progressbarEl.hasClass('progressbar-infinite')) {
	      return $progressbarEl;
	    }
	    var $progressbarLine = $progressbarEl.children('span');
	    if ($progressbarLine.length === 0) {
	      $progressbarLine = $$1('<span></span>');
	      $progressbarEl.append($progressbarLine);
	    }
	    $progressbarLine
	      .transition(typeof duration !== 'undefined' ? duration : '')
	      .transform(("translate3d(" + ((-100 + progressNormalized)) + "%,0,0)"));

	    return $progressbarEl[0];
	  },
	  show: function show() {
	    var args = [], len = arguments.length;
	    while ( len-- ) args[ len ] = arguments[ len ];

	    var app = this;

	    // '.page', 50, 'multi'
	    var el = args[0];
	    var progress = args[1];
	    var color = args[2];
	    var type = 'determined';

	    if (args.length === 2) {
	      if ((typeof args[0] === 'string' || typeof args[0] === 'object') && typeof args[1] === 'string') {
	        // '.page', 'multi'
	        var assign;
	        (assign = args, el = assign[0], color = assign[1], progress = assign[2]);
	        type = 'infinite';
	      } else if (typeof args[0] === 'number' && typeof args[1] === 'string') {
	        // 50, 'multi'
	        var assign$1;
	        (assign$1 = args, progress = assign$1[0], color = assign$1[1]);
	        el = app.root;
	      }
	    } else if (args.length === 1) {
	      if (typeof args[0] === 'number') {
	        el = app.root;
	        progress = args[0];
	      } else if (typeof args[0] === 'string') {
	        type = 'infinite';
	        el = app.root;
	        color = args[0];
	      }
	    } else if (args.length === 0) {
	      type = 'infinite';
	      el = app.root;
	    }

	    var $el = $$1(el);
	    if ($el.length === 0) { return undefined; }

	    var $progressbarEl;
	    if ($el.hasClass('progressbar') || $el.hasClass('progressbar-infinite')) {
	      $progressbarEl = $el;
	    } else {
	      $progressbarEl = $el.children('.progressbar:not(.progressbar-out), .progressbar-infinite:not(.progressbar-out)');
	      if ($progressbarEl.length === 0) {
	        $progressbarEl = $$1(("\n          <span class=\"progressbar" + (type === 'infinite' ? '-infinite' : '') + (color ? (" color-" + color) : '') + " progressbar-in\">\n            " + (type === 'infinite' ? '' : '<span></span>') + "\n          </span>"));
	        $el.append($progressbarEl);
	      }
	    }

	    if (typeof progress !== 'undefined') {
	      app.progressbar.set($progressbarEl, progress);
	    }

	    return $progressbarEl[0];
	  },
	  hide: function hide(el, removeAfterHide) {
	    if ( removeAfterHide === void 0 ) removeAfterHide = true;

	    var app = this;
	    var $el = $$1(el || app.root);
	    if ($el.length === 0) { return undefined; }
	    var $progressbarEl;
	    if ($el.hasClass('progressbar') || $el.hasClass('progressbar-infinite')) {
	      $progressbarEl = $el;
	    } else {
	      $progressbarEl = $el.children('.progressbar, .progressbar-infinite');
	    }
	    if ($progressbarEl.length === 0 || !$progressbarEl.hasClass('progressbar-in') || $progressbarEl.hasClass('progressbar-out')) {
	      return $progressbarEl;
	    }
	    $progressbarEl
	      .removeClass('progressbar-in')
	      .addClass('progressbar-out')
	      .animationEnd(function () {
	        if (removeAfterHide) {
	          $progressbarEl.remove();
	        }
	      });
	    return $progressbarEl;
	  },
	};

	var Progressbar$1 = {
	  name: 'progressbar',
	  create: function create() {
	    var app = this;
	    Utils.extend(app, {
	      progressbar: {
	        set: Progressbar.set.bind(app),
	        show: Progressbar.show.bind(app),
	        hide: Progressbar.hide.bind(app),
	      },
	    });
	  },
	  on: {
	    pageInit: function pageInit(page) {
	      var app = this;
	      page.$el.find('.progressbar').each(function (index, progressbarEl) {
	        var $progressbarEl = $$1(progressbarEl);
	        app.progressbar.set($progressbarEl, $progressbarEl.attr('data-progress'));
	      });
	    },
	  },
	};

	var Swipeout = {
	  init: function init() {
	    var app = this;
	    var touchesStart = {};
	    var isTouched;
	    var isMoved;
	    var isScrolling;
	    var touchStartTime;
	    var touchesDiff;
	    var $swipeoutEl;
	    var $swipeoutContent;
	    var $actionsRight;
	    var $actionsLeft;
	    var actionsLeftWidth;
	    var actionsRightWidth;
	    var translate;
	    var opened;
	    var openedActionsSide;
	    var $leftButtons;
	    var $rightButtons;
	    var direction;
	    var $overswipeLeftButton;
	    var $overswipeRightButton;
	    var overswipeLeft;
	    var overswipeRight;

	    function handleTouchStart(e) {
	      if (!Swipeout.allow) { return; }
	      isMoved = false;
	      isTouched = true;
	      isScrolling = undefined;
	      touchesStart.x = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
	      touchesStart.y = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
	      touchStartTime = (new Date()).getTime();
	      $swipeoutEl = $$1(this);
	    }
	    function handleTouchMove(e) {
	      if (!isTouched) { return; }
	      var pageX = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX;
	      var pageY = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;
	      if (typeof isScrolling === 'undefined') {
	        isScrolling = !!(isScrolling || Math.abs(pageY - touchesStart.y) > Math.abs(pageX - touchesStart.x));
	      }
	      if (isScrolling) {
	        isTouched = false;
	        return;
	      }

	      if (!isMoved) {
	        if ($$1('.list.sortable-opened').length > 0) { return; }
	        $swipeoutContent = $swipeoutEl.find('.swipeout-content');
	        $actionsRight = $swipeoutEl.find('.swipeout-actions-right');
	        $actionsLeft = $swipeoutEl.find('.swipeout-actions-left');
	        actionsLeftWidth = null;
	        actionsRightWidth = null;
	        $leftButtons = null;
	        $rightButtons = null;
	        $overswipeRightButton = null;
	        $overswipeLeftButton = null;
	        if ($actionsLeft.length > 0) {
	          actionsLeftWidth = $actionsLeft.outerWidth();
	          $leftButtons = $actionsLeft.children('a');
	          $overswipeLeftButton = $actionsLeft.find('.swipeout-overswipe');
	        }
	        if ($actionsRight.length > 0) {
	          actionsRightWidth = $actionsRight.outerWidth();
	          $rightButtons = $actionsRight.children('a');
	          $overswipeRightButton = $actionsRight.find('.swipeout-overswipe');
	        }
	        opened = $swipeoutEl.hasClass('swipeout-opened');
	        if (opened) {
	          openedActionsSide = $swipeoutEl.find('.swipeout-actions-left.swipeout-actions-opened').length > 0 ? 'left' : 'right';
	        }
	        $swipeoutEl.removeClass('swipeout-transitioning');
	        if (!app.params.swipeout.noFollow) {
	          $swipeoutEl.find('.swipeout-actions-opened').removeClass('swipeout-actions-opened');
	          $swipeoutEl.removeClass('swipeout-opened');
	        }
	      }
	      isMoved = true;
	      e.preventDefault();

	      touchesDiff = pageX - touchesStart.x;
	      translate = touchesDiff;

	      if (opened) {
	        if (openedActionsSide === 'right') { translate -= actionsRightWidth; }
	        else { translate += actionsLeftWidth; }
	      }

	      if (
	        (translate > 0 && $actionsLeft.length === 0)
	        ||
	        (translate < 0 && $actionsRight.length === 0)
	      ) {
	        if (!opened) {
	          isTouched = false;
	          isMoved = false;
	          $swipeoutContent.transform('');
	          if ($rightButtons && $rightButtons.length > 0) {
	            $rightButtons.transform('');
	          }
	          if ($leftButtons && $leftButtons.length > 0) {
	            $leftButtons.transform('');
	          }
	          return;
	        }
	        translate = 0;
	      }

	      if (translate < 0) { direction = 'to-left'; }
	      else if (translate > 0) { direction = 'to-right'; }
	      else if (!direction) { direction = 'to-left'; }

	      var buttonOffset;
	      var progress;

	      e.f7PreventSwipePanel = true;
	      if (app.params.swipeout.noFollow) {
	        if (opened) {
	          if (openedActionsSide === 'right' && touchesDiff > 0) {
	            app.swipeout.close($swipeoutEl);
	          }
	          if (openedActionsSide === 'left' && touchesDiff < 0) {
	            app.swipeout.close($swipeoutEl);
	          }
	        } else {
	          if (touchesDiff < 0 && $actionsRight.length > 0) {
	            app.swipeout.open($swipeoutEl, 'right');
	          }
	          if (touchesDiff > 0 && $actionsLeft.length > 0) {
	            app.swipeout.open($swipeoutEl, 'left');
	          }
	        }
	        isTouched = false;
	        isMoved = false;
	        return;
	      }
	      overswipeLeft = false;
	      overswipeRight = false;
	      if ($actionsRight.length > 0) {
	        // Show right actions
	        var buttonTranslate = translate;
	        progress = buttonTranslate / actionsRightWidth;
	        if (buttonTranslate < -actionsRightWidth) {
	          buttonTranslate = -actionsRightWidth - (Math.pow( (-buttonTranslate - actionsRightWidth), 0.8 ));
	          translate = buttonTranslate;
	          if ($overswipeRightButton.length > 0) {
	            overswipeRight = true;
	          }
	        }
	        if (direction !== 'to-left') {
	          progress = 0;
	          buttonTranslate = 0;
	        }
	        $rightButtons.each(function (index, buttonEl) {
	          var $buttonEl = $$1(buttonEl);
	          if (typeof buttonEl.f7SwipeoutButtonOffset === 'undefined') {
	            $buttonEl[0].f7SwipeoutButtonOffset = buttonEl.offsetLeft;
	          }
	          buttonOffset = buttonEl.f7SwipeoutButtonOffset;
	          if ($overswipeRightButton.length > 0 && $buttonEl.hasClass('swipeout-overswipe') && direction === 'to-left') {
	            $buttonEl.css({ left: ((overswipeRight ? -buttonOffset : 0) + "px") });
	            if (overswipeRight) {
	              $buttonEl.addClass('swipeout-overswipe-active');
	            } else {
	              $buttonEl.removeClass('swipeout-overswipe-active');
	            }
	          }
	          $buttonEl.transform(("translate3d(" + (buttonTranslate - (buttonOffset * (1 + Math.max(progress, -1)))) + "px,0,0)"));
	        });
	      }
	      if ($actionsLeft.length > 0) {
	        // Show left actions
	        var buttonTranslate$1 = translate;
	        progress = buttonTranslate$1 / actionsLeftWidth;
	        if (buttonTranslate$1 > actionsLeftWidth) {
	          buttonTranslate$1 = actionsLeftWidth + (Math.pow( (buttonTranslate$1 - actionsLeftWidth), 0.8 ));
	          translate = buttonTranslate$1;
	          if ($overswipeLeftButton.length > 0) {
	            overswipeLeft = true;
	          }
	        }
	        if (direction !== 'to-right') {
	          buttonTranslate$1 = 0;
	          progress = 0;
	        }
	        $leftButtons.each(function (index, buttonEl) {
	          var $buttonEl = $$1(buttonEl);
	          if (typeof buttonEl.f7SwipeoutButtonOffset === 'undefined') {
	            $buttonEl[0].f7SwipeoutButtonOffset = actionsLeftWidth - buttonEl.offsetLeft - buttonEl.offsetWidth;
	          }
	          buttonOffset = buttonEl.f7SwipeoutButtonOffset;
	          if ($overswipeLeftButton.length > 0 && $buttonEl.hasClass('swipeout-overswipe') && direction === 'to-right') {
	            $buttonEl.css({ left: ((overswipeLeft ? buttonOffset : 0) + "px") });
	            if (overswipeLeft) {
	              $buttonEl.addClass('swipeout-overswipe-active');
	            } else {
	              $buttonEl.removeClass('swipeout-overswipe-active');
	            }
	          }
	          if ($leftButtons.length > 1) {
	            $buttonEl.css('z-index', $leftButtons.length - index);
	          }
	          $buttonEl.transform(("translate3d(" + (buttonTranslate$1 + (buttonOffset * (1 - Math.min(progress, 1)))) + "px,0,0)"));
	        });
	      }
	      $swipeoutEl.trigger('swipeout', progress);
	      app.emit('swipeout', $swipeoutEl[0], progress);
	      $swipeoutContent.transform(("translate3d(" + translate + "px,0,0)"));
	    }
	    function handleTouchEnd() {
	      if (!isTouched || !isMoved) {
	        isTouched = false;
	        isMoved = false;
	        return;
	      }

	      isTouched = false;
	      isMoved = false;
	      var timeDiff = (new Date()).getTime() - touchStartTime;
	      var $actions = direction === 'to-left' ? $actionsRight : $actionsLeft;
	      var actionsWidth = direction === 'to-left' ? actionsRightWidth : actionsLeftWidth;
	      var action;
	      var $buttons;
	      var i;

	      if (
	        (
	          timeDiff < 300
	          &&
	          (
	            (touchesDiff < -10 && direction === 'to-left')
	            ||
	            (touchesDiff > 10 && direction === 'to-right')
	          )
	        )
	        ||
	        (
	          timeDiff >= 300
	          &&
	          (Math.abs(translate) > actionsWidth / 2)
	        )
	      ) {
	        action = 'open';
	      } else {
	        action = 'close';
	      }
	      if (timeDiff < 300) {
	        if (Math.abs(translate) === 0) { action = 'close'; }
	        if (Math.abs(translate) === actionsWidth) { action = 'open'; }
	      }

	      if (action === 'open') {
	        Swipeout.el = $swipeoutEl[0];
	        $swipeoutEl.trigger('swipeout:open');
	        app.emit('swipeoutOpen', $swipeoutEl[0]);
	        $swipeoutEl.addClass('swipeout-opened swipeout-transitioning');
	        var newTranslate = direction === 'to-left' ? -actionsWidth : actionsWidth;
	        $swipeoutContent.transform(("translate3d(" + newTranslate + "px,0,0)"));
	        $actions.addClass('swipeout-actions-opened');
	        $buttons = direction === 'to-left' ? $rightButtons : $leftButtons;
	        if ($buttons) {
	          for (i = 0; i < $buttons.length; i += 1) {
	            $$1($buttons[i]).transform(("translate3d(" + newTranslate + "px,0,0)"));
	          }
	        }
	        if (overswipeRight) {
	          $actionsRight.find('.swipeout-overswipe')[0].click();
	        }
	        if (overswipeLeft) {
	          $actionsLeft.find('.swipeout-overswipe')[0].click();
	        }
	      } else {
	        $swipeoutEl.trigger('swipeout:close');
	        app.emit('swipeoutClose', $swipeoutEl[0]);
	        Swipeout.el = undefined;
	        $swipeoutEl.addClass('swipeout-transitioning').removeClass('swipeout-opened');
	        $swipeoutContent.transform('');
	        $actions.removeClass('swipeout-actions-opened');
	      }

	      var buttonOffset;
	      if ($leftButtons && $leftButtons.length > 0 && $leftButtons !== $buttons) {
	        $leftButtons.each(function (index, buttonEl) {
	          var $buttonEl = $$1(buttonEl);
	          buttonOffset = buttonEl.f7SwipeoutButtonOffset;
	          if (typeof buttonOffset === 'undefined') {
	            $buttonEl[0].f7SwipeoutButtonOffset = actionsLeftWidth - buttonEl.offsetLeft - buttonEl.offsetWidth;
	          }
	          $buttonEl.transform(("translate3d(" + buttonOffset + "px,0,0)"));
	        });
	      }
	      if ($rightButtons && $rightButtons.length > 0 && $rightButtons !== $buttons) {
	        $rightButtons.each(function (index, buttonEl) {
	          var $buttonEl = $$1(buttonEl);
	          buttonOffset = buttonEl.f7SwipeoutButtonOffset;
	          if (typeof buttonOffset === 'undefined') {
	            $buttonEl[0].f7SwipeoutButtonOffset = buttonEl.offsetLeft;
	          }
	          $buttonEl.transform(("translate3d(" + (-buttonOffset) + "px,0,0)"));
	        });
	      }
	      $swipeoutContent.transitionEnd(function () {
	        if ((opened && action === 'open') || (!opened && action === 'close')) { return; }
	        $swipeoutEl.trigger(action === 'open' ? 'swipeout:opened' : 'swipeout:closed');
	        app.emit(action === 'open' ? 'swipeoutOpened' : 'swipeoutClosed', $swipeoutEl[0]);
	        $swipeoutEl.removeClass('swipeout-transitioning');
	        if (opened && action === 'close') {
	          if ($actionsRight.length > 0) {
	            $rightButtons.transform('');
	          }
	          if ($actionsLeft.length > 0) {
	            $leftButtons.transform('');
	          }
	        }
	      });
	    }

	    var passiveListener = app.support.passiveListener ? { passive: true } : false;

	    app.on('touchstart', function (e) {
	      if (Swipeout.el) {
	        var $targetEl = $$1(e.target);
	        if (!(
	          $$1(Swipeout.el).is($targetEl[0]) ||
	          $targetEl.parents('.swipeout').is(Swipeout.el) ||
	          $targetEl.hasClass('modal-in') ||
	          ($targetEl.attr('class') || '').indexOf('-backdrop') > 0 ||
	          $targetEl.hasClass('actions-modal') ||
	          $targetEl.parents('.actions-modal.modal-in, .dialog.modal-in').length > 0
	        )) {
	          app.swipeout.close(Swipeout.el);
	        }
	      }
	    });
	    $$1(doc).on(app.touchEvents.start, 'li.swipeout', handleTouchStart, passiveListener);
	    app.on('touchmove:active', handleTouchMove);
	    app.on('touchend:passive', handleTouchEnd);
	  },
	  allow: true,
	  el: undefined,
	  open: function open() {
	    var args = [], len = arguments.length;
	    while ( len-- ) args[ len ] = arguments[ len ];

	    var app = this;
	    var el = args[0];
	    var side = args[1];
	    var callback = args[2];
	    if (typeof args[1] === 'function') {
	      var assign;
	      (assign = args, el = assign[0], callback = assign[1], side = assign[2]);
	    }
	    var $el = $$1(el).eq(0);

	    if ($el.length === 0) { return; }
	    if (!$el.hasClass('swipeout') || $el.hasClass('swipeout-opened')) { return; }
	    if (!side) {
	      if ($el.find('.swipeout-actions-right').length > 0) { side = 'right'; }
	      else { side = 'left'; }
	    }
	    var $swipeoutActions = $el.find((".swipeout-actions-" + side));
	    var $swipeoutContent = $el.find('.swipeout-content');
	    if ($swipeoutActions.length === 0) { return; }
	    $el.trigger('swipeout:open').addClass('swipeout-opened').removeClass('swipeout-transitioning');
	    app.emit('swipeoutOpen', $el[0]);
	    $swipeoutActions.addClass('swipeout-actions-opened');
	    var $buttons = $swipeoutActions.children('a');
	    var swipeoutActionsWidth = $swipeoutActions.outerWidth();
	    var translate = side === 'right' ? -swipeoutActionsWidth : swipeoutActionsWidth;
	    if ($buttons.length > 1) {
	      $buttons.each(function (buttonIndex, buttonEl) {
	        var $buttonEl = $$1(buttonEl);
	        if (side === 'right') {
	          $buttonEl.transform(("translate3d(" + (-buttonEl.offsetLeft) + "px,0,0)"));
	        } else {
	          $buttonEl.css('z-index', $buttons.length - buttonIndex).transform(("translate3d(" + (swipeoutActionsWidth - buttonEl.offsetWidth - buttonEl.offsetLeft) + "px,0,0)"));
	        }
	      });
	    }
	    $el.addClass('swipeout-transitioning');
	    $swipeoutContent.transitionEnd(function () {
	      $el.trigger('swipeout:opened');
	      app.emit('swipeoutOpened', $el[0]);
	      if (callback) { callback.call($el[0]); }
	    });
	    Utils.nextFrame(function () {
	      $buttons.transform(("translate3d(" + translate + "px,0,0)"));
	      $swipeoutContent.transform(("translate3d(" + translate + "px,0,0)"));
	    });
	    Swipeout.el = $el[0];
	  },
	  close: function close(el, callback) {
	    var app = this;
	    var $el = $$1(el).eq(0);
	    if ($el.length === 0) { return; }
	    if (!$el.hasClass('swipeout-opened')) { return; }
	    var side = $el.find('.swipeout-actions-opened').hasClass('swipeout-actions-right') ? 'right' : 'left';
	    var $swipeoutActions = $el.find('.swipeout-actions-opened').removeClass('swipeout-actions-opened');
	    var $buttons = $swipeoutActions.children('a');
	    var swipeoutActionsWidth = $swipeoutActions.outerWidth();
	    Swipeout.allow = false;
	    $el.trigger('swipeout:close');
	    app.emit('swipeoutClose', $el[0]);
	    $el.removeClass('swipeout-opened').addClass('swipeout-transitioning');

	    var closeTimeout;
	    function onSwipeoutClose() {
	      Swipeout.allow = true;
	      if ($el.hasClass('swipeout-opened')) { return; }
	      $el.removeClass('swipeout-transitioning');
	      $buttons.transform('');
	      $el.trigger('swipeout:closed');
	      app.emit('swipeoutClosed', $el[0]);
	      if (callback) { callback.call($el[0]); }
	      if (closeTimeout) { clearTimeout(closeTimeout); }
	    }
	    $el.find('.swipeout-content').transform('').transitionEnd(onSwipeoutClose);
	    closeTimeout = setTimeout(onSwipeoutClose, 500);

	    $buttons.each(function (index, buttonEl) {
	      var $buttonEl = $$1(buttonEl);
	      if (side === 'right') {
	        $buttonEl.transform(("translate3d(" + (-buttonEl.offsetLeft) + "px,0,0)"));
	      } else {
	        $buttonEl.transform(("translate3d(" + (swipeoutActionsWidth - buttonEl.offsetWidth - buttonEl.offsetLeft) + "px,0,0)"));
	      }
	      $buttonEl.css({ left: '0px' }).removeClass('swipeout-overswipe-active');
	    });
	    if (Swipeout.el && Swipeout.el === $el[0]) { Swipeout.el = undefined; }
	  },
	  delete: function delete$1(el, callback) {
	    var app = this;
	    var $el = $$1(el).eq(0);
	    if ($el.length === 0) { return; }
	    Swipeout.el = undefined;
	    $el.trigger('swipeout:delete');
	    app.emit('swipeoutDelete', $el[0]);
	    $el.css({ height: (($el.outerHeight()) + "px") });
	    $el.transitionEnd(function () {
	      $el.trigger('swipeout:deleted');
	      app.emit('swipeoutDeleted', $el[0]);
	      if (callback) { callback.call($el[0]); }
	      if ($el.parents('.virtual-list').length > 0) {
	        var virtualList = $el.parents('.virtual-list')[0].f7VirtualList;
	        var virtualIndex = $el[0].f7VirtualListIndex;
	        if (virtualList && typeof virtualIndex !== 'undefined') { virtualList.deleteItem(virtualIndex); }
	      } else if (app.params.swipeout.removeElements) {
	        if (app.params.swipeout.removeElementsWithTimeout) {
	          setTimeout(function () {
	            $el.remove();
	          }, app.params.swipeout.removeElementsTimeout);
	        } else {
	          $el.remove();
	        }
	      } else {
	        $el.removeClass('swipeout-deleting swipeout-transitioning');
	      }
	    });
	    // eslint-disable-next-line
	    $el[0]._clientLeft = $el[0].clientLeft;
	    $el
	      .addClass('swipeout-deleting swipeout-transitioning')
	      .css({ height: '0px' })
	      .find('.swipeout-content')
	      .transform('translate3d(-100%,0,0)');
	  },
	};
	var Swipeout$1 = {
	  name: 'swipeout',
	  params: {
	    swipeout: {
	      actionsNoFold: false,
	      noFollow: false,
	      removeElements: true,
	      removeElementsWithTimeout: false,
	      removeElementsTimeout: 0,
	    },
	  },
	  create: function create() {
	    var app = this;
	    Utils.extend(app, {
	      swipeout: {
	        init: Swipeout.init.bind(app),
	        open: Swipeout.open.bind(app),
	        close: Swipeout.close.bind(app),
	        delete: Swipeout.delete.bind(app),
	      },
	    });
	    Object.defineProperty(app.swipeout, 'el', {
	      enumerable: true,
	      configurable: true,
	      get: function () { return Swipeout.el; },
	      set: function set(el) {
	        Swipeout.el = el;
	      },
	    });
	    Object.defineProperty(app.swipeout, 'allow', {
	      enumerable: true,
	      configurable: true,
	      get: function () { return Swipeout.allow; },
	      set: function set(allow) {
	        Swipeout.allow = allow;
	      },
	    });
	  },
	  clicks: {
	    '.swipeout-open': function openSwipeout($clickedEl, data) {
	      if ( data === void 0 ) data = {};

	      var app = this;
	      app.swipeout.open(data.swipeout, data.side);
	    },
	    '.swipeout-close': function closeSwipeout($clickedEl) {
	      var app = this;
	      var $swipeoutEl = $clickedEl.closest('.swipeout');
	      if ($swipeoutEl.length === 0) { return; }
	      app.swipeout.close($swipeoutEl);
	    },
	    '.swipeout-delete': function deleteSwipeout($clickedEl, data) {
	      if ( data === void 0 ) data = {};

	      var app = this;
	      var $swipeoutEl = $clickedEl.closest('.swipeout');
	      if ($swipeoutEl.length === 0) { return; }
	      var confirm = data.confirm;
	      var confirmTitle = data.confirmTitle;
	      if (data.confirm) {
	        app.dialog.confirm(confirm, confirmTitle, function () {
	          app.swipeout.delete($swipeoutEl);
	        });
	      } else {
	        app.swipeout.delete($swipeoutEl);
	      }
	    },
	  },
	  on: {
	    init: function init() {
	      var app = this;
	      if (!app.params.swipeout) { return; }
	      app.swipeout.init();
	    },
	  },
	};

	var VirtualList = (function (Framework7Class$$1) {
	  function VirtualList(app, params) {
	    if ( params === void 0 ) params = {};

	    Framework7Class$$1.call(this, params, [app]);
	    var vl = this;

	    var defaults = {
	      cols: 1,
	      height: app.theme === 'md' ? 48 : 44,
	      cache: true,
	      dynamicHeightBufferSize: 1,
	      showFilteredItemsOnly: false,
	      renderExternal: undefined,
	      setListHeight: true,
	      searchByItem: undefined,
	      searchAll: undefined,
	      itemTemplate: undefined,
	      ul: null,
	      createUl: true,
	      renderItem: function renderItem(item) {
	        return ("\n          <li>\n            <div class=\"item-content\">\n              <div class=\"item-inner\">\n                <div class=\"item-title\">" + item + "</div>\n              </div>\n            </div>\n          </li>\n        ").trim();
	      },
	      on: {},
	    };

	    // Extend defaults with modules params
	    vl.useModulesParams(defaults);

	    vl.params = Utils.extend(defaults, params);
	    if (vl.params.height === undefined || !vl.params.height) {
	      vl.params.height = app.theme === 'md' ? 48 : 44;
	    }

	    vl.$el = $$1(params.el);
	    vl.el = vl.$el[0];

	    if (vl.$el.length === 0) { return undefined; }
	    vl.$el[0].f7VirtualList = vl;

	    vl.items = vl.params.items;
	    if (vl.params.showFilteredItemsOnly) {
	      vl.filteredItems = [];
	    }
	    if (vl.params.itemTemplate) {
	      if (typeof vl.params.itemTemplate === 'string') { vl.renderItem = Template7.compile(vl.params.itemTemplate); }
	      else if (typeof vl.params.itemTemplate === 'function') { vl.renderItem = vl.params.itemTemplate; }
	    } else if (vl.params.renderItem) {
	      vl.renderItem = vl.params.renderItem;
	    }
	    vl.$pageContentEl = vl.$el.parents('.page-content');
	    vl.pageContentEl = vl.$pageContentEl[0];

	    // Bad scroll
	    if (typeof vl.params.updatableScroll !== 'undefined') {
	      vl.updatableScroll = vl.params.updatableScroll;
	    } else {
	      vl.updatableScroll = true;
	      if (Device.ios && Device.osVersion.split('.')[0] < 8) {
	        vl.updatableScroll = false;
	      }
	    }

	    // Append <ul>
	    var ul = vl.params.ul;
	    vl.$ul = ul ? $$1(vl.params.ul) : vl.$el.children('ul');
	    if (vl.$ul.length === 0 && vl.params.createUl) {
	      vl.$el.append('<ul></ul>');
	      vl.$ul = vl.$el.children('ul');
	    }
	    vl.ul = vl.$ul[0];

	    var $itemsWrapEl;
	    if (!vl.ul && !vl.params.createUl) { $itemsWrapEl = vl.$el; }
	    else { $itemsWrapEl = vl.$ul; }

	    Utils.extend(vl, {
	      $itemsWrapEl: $itemsWrapEl,
	      itemsWrapEl: $itemsWrapEl[0],
	      // DOM cached items
	      domCache: {},
	      displayDomCache: {},
	      // Temporary DOM Element
	      tempDomElement: doc.createElement('ul'),
	      // Last repain position
	      lastRepaintY: null,
	      // Fragment
	      fragment: doc.createDocumentFragment(),
	      // Props
	      pageHeight: undefined,
	      rowsPerScreen: undefined,
	      rowsBefore: undefined,
	      rowsAfter: undefined,
	      rowsToRender: undefined,
	      maxBufferHeight: 0,
	      listHeight: undefined,
	      dynamicHeight: typeof vl.params.height === 'function',
	    });

	    // Install Modules
	    vl.useModules();

	    // Attach events
	    var handleScrollBound = vl.handleScroll.bind(vl);
	    var handleResizeBound = vl.handleResize.bind(vl);
	    var $pageEl;
	    var $tabEl;
	    var $panelEl;
	    var $popupEl;
	    vl.attachEvents = function attachEvents() {
	      $pageEl = vl.$el.parents('.page').eq(0);
	      $tabEl = vl.$el.parents('.tab').eq(0);
	      $panelEl = vl.$el.parents('.panel').eq(0);
	      $popupEl = vl.$el.parents('.popup').eq(0);

	      vl.$pageContentEl.on('scroll', handleScrollBound);
	      if ($pageEl) { $pageEl.on('page:reinit', handleResizeBound); }
	      if ($tabEl) { $tabEl.on('tab:show', handleResizeBound); }
	      if ($panelEl) { $panelEl.on('panel:open', handleResizeBound); }
	      if ($popupEl) { $popupEl.on('popup:open', handleResizeBound); }
	      app.on('resize', handleResizeBound);
	    };
	    vl.detachEvents = function attachEvents() {
	      vl.$pageContentEl.off('scroll', handleScrollBound);
	      if ($pageEl) { $pageEl.off('page:reinit', handleResizeBound); }
	      if ($tabEl) { $tabEl.off('tab:show', handleResizeBound); }
	      if ($panelEl) { $panelEl.off('panel:open', handleResizeBound); }
	      if ($popupEl) { $popupEl.off('popup:open', handleResizeBound); }
	      app.off('resize', handleResizeBound);
	    };
	    // Init
	    vl.init();

	    return vl;
	  }

	  if ( Framework7Class$$1 ) VirtualList.__proto__ = Framework7Class$$1;
	  VirtualList.prototype = Object.create( Framework7Class$$1 && Framework7Class$$1.prototype );
	  VirtualList.prototype.constructor = VirtualList;
	  VirtualList.prototype.setListSize = function setListSize () {
	    var vl = this;
	    var items = vl.filteredItems || vl.items;
	    vl.pageHeight = vl.$pageContentEl[0].offsetHeight;
	    if (vl.dynamicHeight) {
	      vl.listHeight = 0;
	      vl.heights = [];
	      for (var i = 0; i < items.length; i += 1) {
	        var itemHeight = vl.params.height(items[i]);
	        vl.listHeight += itemHeight;
	        vl.heights.push(itemHeight);
	      }
	    } else {
	      vl.listHeight = Math.ceil(items.length / vl.params.cols) * vl.params.height;
	      vl.rowsPerScreen = Math.ceil(vl.pageHeight / vl.params.height);
	      vl.rowsBefore = vl.params.rowsBefore || vl.rowsPerScreen * 2;
	      vl.rowsAfter = vl.params.rowsAfter || vl.rowsPerScreen;
	      vl.rowsToRender = (vl.rowsPerScreen + vl.rowsBefore + vl.rowsAfter);
	      vl.maxBufferHeight = (vl.rowsBefore / 2) * vl.params.height;
	    }

	    if (vl.updatableScroll || vl.params.setListHeight) {
	      vl.$itemsWrapEl.css({ height: ((vl.listHeight) + "px") });
	    }
	  };
	  VirtualList.prototype.render = function render (force, forceScrollTop) {
	    var vl = this;
	    if (force) { vl.lastRepaintY = null; }

	    var scrollTop = -(vl.$el[0].getBoundingClientRect().top - vl.$pageContentEl[0].getBoundingClientRect().top);

	    if (typeof forceScrollTop !== 'undefined') { scrollTop = forceScrollTop; }
	    if (vl.lastRepaintY === null || Math.abs(scrollTop - vl.lastRepaintY) > vl.maxBufferHeight || (!vl.updatableScroll && (vl.$pageContentEl[0].scrollTop + vl.pageHeight >= vl.$pageContentEl[0].scrollHeight))) {
	      vl.lastRepaintY = scrollTop;
	    } else {
	      return;
	    }

	    var items = vl.filteredItems || vl.items;
	    var fromIndex;
	    var toIndex;
	    var heightBeforeFirstItem = 0;
	    var heightBeforeLastItem = 0;
	    if (vl.dynamicHeight) {
	      var itemTop = 0;
	      var itemHeight;
	      vl.maxBufferHeight = vl.pageHeight;

	      for (var j = 0; j < vl.heights.length; j += 1) {
	        itemHeight = vl.heights[j];
	        if (typeof fromIndex === 'undefined') {
	          if (itemTop + itemHeight >= scrollTop - (vl.pageHeight * 2 * vl.params.dynamicHeightBufferSize)) { fromIndex = j; }
	          else { heightBeforeFirstItem += itemHeight; }
	        }

	        if (typeof toIndex === 'undefined') {
	          if (itemTop + itemHeight >= scrollTop + (vl.pageHeight * 2 * vl.params.dynamicHeightBufferSize) || j === vl.heights.length - 1) { toIndex = j + 1; }
	          heightBeforeLastItem += itemHeight;
	        }
	        itemTop += itemHeight;
	      }
	      toIndex = Math.min(toIndex, items.length);
	    } else {
	      fromIndex = (parseInt(scrollTop / vl.params.height, 10) - vl.rowsBefore) * vl.params.cols;
	      if (fromIndex < 0) {
	        fromIndex = 0;
	      }
	      toIndex = Math.min(fromIndex + (vl.rowsToRender * vl.params.cols), items.length);
	    }

	    var topPosition;
	    var renderExternalItems = [];
	    vl.reachEnd = false;
	    var i;
	    for (i = fromIndex; i < toIndex; i += 1) {
	      var itemEl = (void 0);
	      // Define real item index
	      var index = vl.items.indexOf(items[i]);

	      if (i === fromIndex) { vl.currentFromIndex = index; }
	      if (i === toIndex - 1) { vl.currentToIndex = index; }
	      if (vl.filteredItems) {
	        if (vl.items[index] === vl.filteredItems[vl.filteredItems.length - 1]) { vl.reachEnd = true; }
	      } else if (index === vl.items.length - 1) { vl.reachEnd = true; }

	      // Find items
	      if (vl.params.renderExternal) {
	        renderExternalItems.push(items[i]);
	      } else if (vl.domCache[index]) {
	        itemEl = vl.domCache[index];
	        itemEl.f7VirtualListIndex = index;
	      } else {
	        if (vl.renderItem) {
	          vl.tempDomElement.innerHTML = vl.renderItem(items[i], index).trim();
	        } else {
	          vl.tempDomElement.innerHTML = items[i].toString().trim();
	        }
	        itemEl = vl.tempDomElement.childNodes[0];
	        if (vl.params.cache) { vl.domCache[index] = itemEl; }
	        itemEl.f7VirtualListIndex = index;
	      }

	      // Set item top position
	      if (i === fromIndex) {
	        if (vl.dynamicHeight) {
	          topPosition = heightBeforeFirstItem;
	        } else {
	          topPosition = ((i * vl.params.height) / vl.params.cols);
	        }
	      }
	      if (!vl.params.renderExternal) {
	        itemEl.style.top = topPosition + "px";

	        // Before item insert
	        vl.emit('local::itemBeforeInsert vlItemBeforeInsert', vl, itemEl, items[i]);

	        // Append item to fragment
	        vl.fragment.appendChild(itemEl);
	      }
	    }

	    // Update list height with not updatable scroll
	    if (!vl.updatableScroll) {
	      if (vl.dynamicHeight) {
	        vl.itemsWrapEl.style.height = heightBeforeLastItem + "px";
	      } else {
	        vl.itemsWrapEl.style.height = ((i * vl.params.height) / vl.params.cols) + "px";
	      }
	    }

	    // Update list html
	    if (vl.params.renderExternal) {
	      if (items && items.length === 0) {
	        vl.reachEnd = true;
	      }
	    } else {
	      vl.emit('local::beforeClear vlBeforeClear', vl, vl.fragment);
	      vl.itemsWrapEl.innerHTML = '';

	      vl.emit('local::itemsBeforeInsert vlItemsBeforeInsert', vl, vl.fragment);

	      if (items && items.length === 0) {
	        vl.reachEnd = true;
	        if (vl.params.emptyTemplate) { vl.itemsWrapEl.innerHTML = vl.params.emptyTemplate; }
	      } else {
	        vl.itemsWrapEl.appendChild(vl.fragment);
	      }

	      vl.emit('local::itemsAfterInsert vlItemsAfterInsert', vl, vl.fragment);
	    }

	    if (typeof forceScrollTop !== 'undefined' && force) {
	      vl.$pageContentEl.scrollTop(forceScrollTop, 0);
	    }
	    if (vl.params.renderExternal) {
	      vl.params.renderExternal(vl, {
	        fromIndex: fromIndex,
	        toIndex: toIndex,
	        listHeight: vl.listHeight,
	        topPosition: topPosition,
	        items: renderExternalItems,
	      });
	    }
	  };
	  // Filter
	  VirtualList.prototype.filterItems = function filterItems (indexes, resetScrollTop) {
	    if ( resetScrollTop === void 0 ) resetScrollTop = true;

	    var vl = this;
	    vl.filteredItems = [];
	    for (var i = 0; i < indexes.length; i += 1) {
	      vl.filteredItems.push(vl.items[indexes[i]]);
	    }
	    if (resetScrollTop) {
	      vl.$pageContentEl[0].scrollTop = 0;
	    }
	    vl.update();
	  };
	  VirtualList.prototype.resetFilter = function resetFilter () {
	    var vl = this;
	    if (vl.params.showFilteredItemsOnly) {
	      vl.filteredItems = [];
	    } else {
	      vl.filteredItems = null;
	      delete vl.filteredItems;
	    }
	    vl.update();
	  };
	  VirtualList.prototype.scrollToItem = function scrollToItem (index) {
	    var vl = this;
	    if (index > vl.items.length) { return false; }
	    var itemTop = 0;
	    if (vl.dynamicHeight) {
	      for (var i = 0; i < index; i += 1) {
	        itemTop += vl.heights[i];
	      }
	    } else {
	      itemTop = index * vl.params.height;
	    }
	    var listTop = vl.$el[0].offsetTop;
	    vl.render(true, (listTop + itemTop) - parseInt(vl.$pageContentEl.css('padding-top'), 10));
	    return true;
	  };
	  VirtualList.prototype.handleScroll = function handleScroll () {
	    var vl = this;
	    vl.render();
	  };
	  // Handle resize event
	  VirtualList.prototype.isVisible = function isVisible () {
	    var vl = this;
	    return !!(vl.el.offsetWidth || vl.el.offsetHeight || vl.el.getClientRects().length);
	  };
	  VirtualList.prototype.handleResize = function handleResize () {
	    var vl = this;
	    if (vl.isVisible()) {
	      vl.setListSize();
	      vl.render(true);
	    }
	  };
	  // Append
	  VirtualList.prototype.appendItems = function appendItems (items) {
	    var vl = this;
	    for (var i = 0; i < items.length; i += 1) {
	      vl.items.push(items[i]);
	    }
	    vl.update();
	  };
	  VirtualList.prototype.appendItem = function appendItem (item) {
	    var vl = this;
	    vl.appendItems([item]);
	  };
	  // Replace
	  VirtualList.prototype.replaceAllItems = function replaceAllItems (items) {
	    var vl = this;
	    vl.items = items;
	    delete vl.filteredItems;
	    vl.domCache = {};
	    vl.update();
	  };
	  VirtualList.prototype.replaceItem = function replaceItem (index, item) {
	    var vl = this;
	    vl.items[index] = item;
	    if (vl.params.cache) { delete vl.domCache[index]; }
	    vl.update();
	  };
	  // Prepend
	  VirtualList.prototype.prependItems = function prependItems (items) {
	    var vl = this;
	    for (var i = items.length - 1; i >= 0; i -= 1) {
	      vl.items.unshift(items[i]);
	    }
	    if (vl.params.cache) {
	      var newCache = {};
	      Object.keys(vl.domCache).forEach(function (cached) {
	        newCache[parseInt(cached, 10) + items.length] = vl.domCache[cached];
	      });
	      vl.domCache = newCache;
	    }
	    vl.update();
	  };
	  VirtualList.prototype.prependItem = function prependItem (item) {
	    var vl = this;
	    vl.prependItems([item]);
	  };

	  // Move
	  VirtualList.prototype.moveItem = function moveItem (from, to) {
	    var vl = this;
	    var fromIndex = from;
	    var toIndex = to;
	    if (fromIndex === toIndex) { return; }
	    // remove item from array
	    var item = vl.items.splice(fromIndex, 1)[0];
	    if (toIndex >= vl.items.length) {
	      // Add item to the end
	      vl.items.push(item);
	      toIndex = vl.items.length - 1;
	    } else {
	    // Add item to new index
	      vl.items.splice(toIndex, 0, item);
	    }
	    // Update cache
	    if (vl.params.cache) {
	      var newCache = {};
	      Object.keys(vl.domCache).forEach(function (cached) {
	        var cachedIndex = parseInt(cached, 10);
	        var leftIndex = fromIndex < toIndex ? fromIndex : toIndex;
	        var rightIndex = fromIndex < toIndex ? toIndex : fromIndex;
	        var indexShift = fromIndex < toIndex ? -1 : 1;
	        if (cachedIndex < leftIndex || cachedIndex > rightIndex) { newCache[cachedIndex] = vl.domCache[cachedIndex]; }
	        if (cachedIndex === leftIndex) { newCache[rightIndex] = vl.domCache[cachedIndex]; }
	        if (cachedIndex > leftIndex && cachedIndex <= rightIndex) { newCache[cachedIndex + indexShift] = vl.domCache[cachedIndex]; }
	      });
	      vl.domCache = newCache;
	    }
	    vl.update();
	  };
	  // Insert before
	  VirtualList.prototype.insertItemBefore = function insertItemBefore (index, item) {
	    var vl = this;
	    if (index === 0) {
	      vl.prependItem(item);
	      return;
	    }
	    if (index >= vl.items.length) {
	      vl.appendItem(item);
	      return;
	    }
	    vl.items.splice(index, 0, item);
	    // Update cache
	    if (vl.params.cache) {
	      var newCache = {};
	      Object.keys(vl.domCache).forEach(function (cached) {
	        var cachedIndex = parseInt(cached, 10);
	        if (cachedIndex >= index) {
	          newCache[cachedIndex + 1] = vl.domCache[cachedIndex];
	        }
	      });
	      vl.domCache = newCache;
	    }
	    vl.update();
	  };
	  // Delete
	  VirtualList.prototype.deleteItems = function deleteItems (indexes) {
	    var vl = this;
	    var prevIndex;
	    var indexShift = 0;
	    var loop = function ( i ) {
	      var index = indexes[i];
	      if (typeof prevIndex !== 'undefined') {
	        if (index > prevIndex) {
	          indexShift = -i;
	        }
	      }
	      index += indexShift;
	      prevIndex = indexes[i];
	      // Delete item
	      var deletedItem = vl.items.splice(index, 1)[0];

	      // Delete from filtered
	      if (vl.filteredItems && vl.filteredItems.indexOf(deletedItem) >= 0) {
	        vl.filteredItems.splice(vl.filteredItems.indexOf(deletedItem), 1);
	      }
	      // Update cache
	      if (vl.params.cache) {
	        var newCache = {};
	        Object.keys(vl.domCache).forEach(function (cached) {
	          var cachedIndex = parseInt(cached, 10);
	          if (cachedIndex === index) {
	            delete vl.domCache[index];
	          } else if (parseInt(cached, 10) > index) {
	            newCache[cachedIndex - 1] = vl.domCache[cached];
	          } else {
	            newCache[cachedIndex] = vl.domCache[cached];
	          }
	        });
	        vl.domCache = newCache;
	      }
	    };

	    for (var i = 0; i < indexes.length; i += 1) loop( i );
	    vl.update();
	  };
	  VirtualList.prototype.deleteAllItems = function deleteAllItems () {
	    var vl = this;
	    vl.items = [];
	    delete vl.filteredItems;
	    if (vl.params.cache) { vl.domCache = {}; }
	    vl.update();
	  };
	  VirtualList.prototype.deleteItem = function deleteItem (index) {
	    var vl = this;
	    vl.deleteItems([index]);
	  };
	  // Clear cache
	  VirtualList.prototype.clearCache = function clearCache () {
	    var vl = this;
	    vl.domCache = {};
	  };
	  // Update Virtual List
	  VirtualList.prototype.update = function update (deleteCache) {
	    var vl = this;
	    if (deleteCache && vl.params.cache) {
	      vl.domCache = {};
	    }
	    vl.setListSize();
	    vl.render(true);
	  };
	  VirtualList.prototype.init = function init () {
	    var vl = this;
	    vl.attachEvents();
	    vl.setListSize();
	    vl.render();
	  };
	  VirtualList.prototype.destroy = function destroy () {
	    var vl = this;
	    vl.detachEvents();
	    vl.$el[0].f7VirtualList = null;
	    delete vl.$el[0].f7VirtualList;
	    Utils.deleteProps(vl);
	    vl = null;
	  };

	  return VirtualList;
	}(Framework7Class));

	var VirtualList$1 = {
	  name: 'virtualList',
	  static: {
	    VirtualList: VirtualList,
	  },
	  create: function create() {
	    var app = this;
	    app.virtualList = ConstructorMethods({
	      defaultSelector: '.virtual-list',
	      constructor: VirtualList,
	      app: app,
	      domProp: 'f7VirtualList',
	    });
	  },
	};

	var Tab = {
	  show: function show() {
	    var args = [], len = arguments.length;
	    while ( len-- ) args[ len ] = arguments[ len ];

	    var app = this;
	    var tabEl;
	    var tabLinkEl;
	    var animate;
	    var tabRoute;
	    if (args.length === 1 && args[0].constructor === Object) {
	      tabEl = args[0].tabEl;
	      tabLinkEl = args[0].tabLinkEl;
	      animate = args[0].animate;
	      tabRoute = args[0].tabRoute;
	    } else {
	      var assign;
	      (assign = args, tabEl = assign[0], tabLinkEl = assign[1], animate = assign[2], tabRoute = assign[3]);
	      if (typeof args[1] === 'boolean') {
	        var assign$1;
	        (assign$1 = args, tabEl = assign$1[0], animate = assign$1[1], tabLinkEl = assign$1[2], tabRoute = assign$1[3]);
	        if (args.length > 2 && tabLinkEl.constructor === Object) {
	          var assign$2;
	          (assign$2 = args, tabEl = assign$2[0], animate = assign$2[1], tabRoute = assign$2[2], tabLinkEl = assign$2[3]);
	        }
	      }
	    }
	    if (typeof animate === 'undefined') { animate = true; }

	    var $newTabEl = $$1(tabEl);
	    if (tabRoute && $newTabEl[0]) {
	      $newTabEl[0].f7TabRoute = tabRoute;
	    }

	    if ($newTabEl.length === 0 || $newTabEl.hasClass('tab-active')) {
	      return {
	        $newTabEl: $newTabEl,
	        newTabEl: $newTabEl[0],
	      };
	    }

	    var $tabLinkEl;
	    if (tabLinkEl) { $tabLinkEl = $$1(tabLinkEl); }

	    var $tabsEl = $newTabEl.parent('.tabs');
	    if ($tabsEl.length === 0) {
	      return {
	        $newTabEl: $newTabEl,
	        newTabEl: $newTabEl[0],
	      };
	    }

	    // Release swipeouts in hidden tabs
	    if (app.swipeout) { app.swipeout.allowOpen = true; }

	    // Animated tabs
	    var tabsChangedCallbacks = [];

	    function onTabsChanged(callback) {
	      tabsChangedCallbacks.push(callback);
	    }
	    function tabsChanged() {
	      tabsChangedCallbacks.forEach(function (callback) {
	        callback();
	      });
	    }

	    var animated = false;

	    if ($tabsEl.parent().hasClass('tabs-animated-wrap')) {
	      $tabsEl.parent()[animate ? 'removeClass' : 'addClass']('not-animated');

	      var transitionDuration = parseFloat($tabsEl.css('transition-duration').replace(',', '.'));
	      if (animate && transitionDuration) {
	        $tabsEl.transitionEnd(tabsChanged);
	        animated = true;
	      }

	      var tabsTranslate = (app.rtl ? $newTabEl.index() : -$newTabEl.index()) * 100;
	      $tabsEl.transform(("translate3d(" + tabsTranslate + "%,0,0)"));
	    }

	    // Swipeable tabs
	    if ($tabsEl.parent().hasClass('tabs-swipeable-wrap') && app.swiper) {
	      var swiper = $tabsEl.parent()[0].swiper;
	      if (swiper && swiper.activeIndex !== $newTabEl.index()) {
	        animated = true;
	        swiper
	          .once('slideChangeTransitionEnd', function () {
	            tabsChanged();
	          })
	          .slideTo($newTabEl.index(), animate ? undefined : 0);
	      }
	    }

	    // Remove active class from old tabs
	    var $oldTabEl = $tabsEl.children('.tab-active');
	    $oldTabEl
	      .removeClass('tab-active')
	      .trigger('tab:hide');
	    app.emit('tabHide', $oldTabEl[0]);

	    // Trigger 'show' event on new tab
	    $newTabEl
	      .addClass('tab-active')
	      .trigger('tab:show');
	    app.emit('tabShow', $newTabEl[0]);

	    // Find related link for new tab
	    if (!$tabLinkEl) {
	      // Search by id
	      if (typeof tabEl === 'string') { $tabLinkEl = $$1((".tab-link[href=\"" + tabEl + "\"]")); }
	      else { $tabLinkEl = $$1((".tab-link[href=\"#" + ($newTabEl.attr('id')) + "\"]")); }
	      // Search by data-tab
	      if (!$tabLinkEl || ($tabLinkEl && $tabLinkEl.length === 0)) {
	        $$1('[data-tab]').each(function (index, el) {
	          if ($newTabEl.is($$1(el).attr('data-tab'))) { $tabLinkEl = $$1(el); }
	        });
	      }
	      if (tabRoute && (!$tabLinkEl || ($tabLinkEl && $tabLinkEl.length === 0))) {
	        $tabLinkEl = $$1(("[data-route-tab-id=\"" + (tabRoute.route.tab.id) + "\"]"));
	        if ($tabLinkEl.length === 0) {
	          $tabLinkEl = $$1((".tab-link[href=\"" + (tabRoute.url) + "\"]"));
	        }
	      }
	      if ($tabLinkEl.length > 1 && $newTabEl.parents('.page').length) {
	        // eslint-disable-next-line
	        $tabLinkEl = $tabLinkEl.filter(function (index, tabLinkElement) {
	          return $$1(tabLinkElement).parents('.page')[0] === $newTabEl.parents('.page')[0];
	        });
	        if (app.theme === 'ios' && $tabLinkEl.length === 0 && tabRoute) {
	          var $pageEl = $newTabEl.parents('.page');
	          var $navbarEl = $$1(app.navbar.getElByPage($pageEl));
	          $tabLinkEl = $navbarEl.find(("[data-route-tab-id=\"" + (tabRoute.route.tab.id) + "\"]"));
	          if ($tabLinkEl.length === 0) {
	            $tabLinkEl = $navbarEl.find((".tab-link[href=\"" + (tabRoute.url) + "\"]"));
	          }
	        }
	      }
	    }
	    if ($tabLinkEl.length > 0) {
	      // Find related link for old tab
	      var $oldTabLinkEl;
	      if ($oldTabEl && $oldTabEl.length > 0) {
	        // Search by id
	        var oldTabId = $oldTabEl.attr('id');
	        if (oldTabId) {
	          $oldTabLinkEl = $$1((".tab-link[href=\"#" + oldTabId + "\"]"));
	          // Search by data-route-tab-id
	          if (!$oldTabLinkEl || ($oldTabLinkEl && $oldTabLinkEl.length === 0)) {
	            $oldTabLinkEl = $$1((".tab-link[data-route-tab-id=\"" + oldTabId + "\"]"));
	          }
	        }
	        // Search by data-tab
	        if (!$oldTabLinkEl || ($oldTabLinkEl && $oldTabLinkEl.length === 0)) {
	          $$1('[data-tab]').each(function (index, tabLinkElement) {
	            if ($oldTabEl.is($$1(tabLinkElement).attr('data-tab'))) { $oldTabLinkEl = $$1(tabLinkElement); }
	          });
	        }
	        if (!$oldTabLinkEl || ($oldTabLinkEl && $oldTabLinkEl.length === 0)) {
	          $oldTabLinkEl = $tabLinkEl.siblings('.tab-link-active');
	        }
	      } else if (tabRoute) {
	        $oldTabLinkEl = $tabLinkEl.siblings('.tab-link-active');
	      }

	      if ($oldTabLinkEl && $oldTabLinkEl.length > 1 && $oldTabEl && $oldTabEl.parents('.page').length) {
	        // eslint-disable-next-line
	        $oldTabLinkEl = $oldTabLinkEl.filter(function (index, tabLinkElement) {
	          return $$1(tabLinkElement).parents('.page')[0] === $oldTabEl.parents('.page')[0];
	        });
	      }

	      if ($oldTabLinkEl && $oldTabLinkEl.length > 0) { $oldTabLinkEl.removeClass('tab-link-active'); }

	      // Update links' classes
	      if ($tabLinkEl && $tabLinkEl.length > 0) {
	        $tabLinkEl.addClass('tab-link-active');
	        // Material Highlight
	        if (app.theme === 'md' && app.toolbar) {
	          var $tabbarEl = $tabLinkEl.parents('.tabbar, .tabbar-labels');
	          if ($tabbarEl.length > 0) {
	            app.toolbar.setHighlight($tabbarEl);
	          }
	        }
	      }
	    }
	    return {
	      $newTabEl: $newTabEl,
	      newTabEl: $newTabEl[0],
	      $oldTabEl: $oldTabEl,
	      oldTabEl: $oldTabEl[0],
	      onTabsChanged: onTabsChanged,
	      animated: animated,
	    };
	  },
	};
	var Tabs = {
	  name: 'tabs',
	  create: function create() {
	    var app = this;
	    Utils.extend(app, {
	      tab: {
	        show: Tab.show.bind(app),
	      },
	    });
	  },
	  clicks: {
	    '.tab-link': function tabLinkClick($clickedEl, data) {
	      if ( data === void 0 ) data = {};

	      var app = this;
	      if (($clickedEl.attr('href') && $clickedEl.attr('href').indexOf('#') === 0) || $clickedEl.attr('data-tab')) {
	        app.tab.show({
	          tabEl: data.tab || $clickedEl.attr('href'),
	          tabLinkEl: $clickedEl,
	          animate: data.animate,
	        });
	      }
	    },
	  },
	};

	function swipePanel(panel) {
	  var app = panel.app;
	  Utils.extend(panel, {
	    swipeable: true,
	    swipeInitialized: true,
	  });
	  var params = app.params.panel;
	  var $el = panel.$el;
	  var $backdropEl = panel.$backdropEl;
	  var side = panel.side;
	  var effect = panel.effect;
	  var otherPanel;

	  var isTouched;
	  var isMoved;
	  var isScrolling;
	  var touchesStart = {};
	  var touchStartTime;
	  var touchesDiff;
	  var translate;
	  var backdropOpacity;
	  var panelWidth;
	  var direction;

	  var $viewEl;

	  var touchMoves = 0;
	  function handleTouchStart(e) {
	    if (!panel.swipeable) { return; }
	    if (!app.panel.allowOpen || (!params.swipe && !params.swipeOnlyClose) || isTouched) { return; }
	    if ($$1('.modal-in, .photo-browser-in').length > 0) { return; }
	    otherPanel = app.panel[side === 'left' ? 'right' : 'left'] || {};
	    if (!panel.opened && otherPanel.opened) { return; }
	    if (!(params.swipeCloseOpposite || params.swipeOnlyClose)) {
	      if (otherPanel.opened) { return; }
	    }
	    if (e.target && e.target.nodeName.toLowerCase() === 'input' && e.target.type === 'range') { return; }
	    if ($$1(e.target).closest('.range-slider, .tabs-swipeable-wrap, .calendar-months, .no-swipe-panel').length > 0) { return; }
	    touchesStart.x = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
	    touchesStart.y = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
	    if (params.swipeOnlyClose && !panel.opened) {
	      return;
	    }
	    if (params.swipe !== 'both' && params.swipeCloseOpposite && params.swipe !== side && !panel.opened) {
	      return;
	    }
	    if (params.swipeActiveArea && !panel.opened) {
	      if (side === 'left') {
	        if (touchesStart.x > params.swipeActiveArea) { return; }
	      }
	      if (side === 'right') {
	        if (touchesStart.x < app.width - params.swipeActiveArea) { return; }
	      }
	    }
	    if (params.swipeCloseActiveAreaSide && panel.opened) {
	      if (side === 'left') {
	        if (touchesStart.x < ($el[0].offsetWidth - params.swipeCloseActiveAreaSide)) { return; }
	      }
	      if (side === 'right') {
	        if (touchesStart.x > ((app.width - $el[0].offsetWidth) + params.swipeCloseActiveAreaSide)) { return; }
	      }
	    }
	    touchMoves = 0;
	    $viewEl = $$1(panel.getViewEl());
	    isMoved = false;
	    isTouched = true;
	    isScrolling = undefined;

	    touchStartTime = Utils.now();
	    direction = undefined;
	  }
	  function handleTouchMove(e) {
	    if (!isTouched) { return; }
	    touchMoves += 1;
	    if (touchMoves < 2) { return; }
	    if (e.f7PreventSwipePanel || app.preventSwipePanelBySwipeBack || app.preventSwipePanel) {
	      isTouched = false;
	      return;
	    }
	    var pageX = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX;
	    var pageY = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;
	    if (typeof isScrolling === 'undefined') {
	      isScrolling = !!(isScrolling || Math.abs(pageY - touchesStart.y) > Math.abs(pageX - touchesStart.x));
	    }
	    if (isScrolling) {
	      isTouched = false;
	      return;
	    }
	    if (!direction) {
	      if (pageX > touchesStart.x) {
	        direction = 'to-right';
	      } else {
	        direction = 'to-left';
	      }

	      if (params.swipe === 'both') {
	        if (params.swipeActiveArea > 0 && !panel.opened) {
	          if (side === 'left' && touchesStart.x > params.swipeActiveArea) {
	            isTouched = false;
	            return;
	          }
	          if (side === 'right' && touchesStart.x < app.width - params.swipeActiveArea) {
	            isTouched = false;
	            return;
	          }
	        }
	      }
	      if ($el.hasClass('panel-visible-by-breakpoint')) {
	        isTouched = false;
	        return;
	      }

	      if (
	        (side === 'left' &&
	          (
	            direction === 'to-left' && !$el.hasClass('panel-active')
	          )
	        )
	        ||
	        (side === 'right' &&
	          (
	            direction === 'to-right' && !$el.hasClass('panel-active')
	          )
	        )
	      ) {
	        isTouched = false;
	        return;
	      }
	    }

	    if (params.swipeNoFollow) {
	      var timeDiff = (new Date()).getTime() - touchStartTime;
	      if (timeDiff < 300) {
	        if (direction === 'to-left') {
	          if (side === 'right') { app.panel.open(side); }
	          if (side === 'left' && $el.hasClass('panel-active')) { app.panel.close(); }
	        }
	        if (direction === 'to-right') {
	          if (side === 'left') { app.panel.open(side); }
	          if (side === 'right' && $el.hasClass('panel-active')) { app.panel.close(); }
	        }
	      }
	      isTouched = false;
	      isMoved = false;
	      return;
	    }

	    if (!isMoved) {
	      if (!panel.opened) {
	        $el.show();
	        $backdropEl.show();
	        $el.trigger('panel:swipeopen', panel);
	        panel.emit('local::swipeOpen panelSwipeOpen', panel);
	      }
	      panelWidth = $el[0].offsetWidth;
	      $el.transition(0);
	    }

	    isMoved = true;

	    e.preventDefault();
	    var threshold = panel.opened ? 0 : -params.swipeThreshold;
	    if (side === 'right') { threshold = -threshold; }

	    touchesDiff = (pageX - touchesStart.x) + threshold;

	    if (side === 'right') {
	      if (effect === 'cover') {
	        translate = touchesDiff + (panel.opened ? 0 : panelWidth);
	        if (translate < 0) { translate = 0; }
	        if (translate > panelWidth) {
	          translate = panelWidth;
	        }
	      } else {
	        translate = touchesDiff - (panel.opened ? panelWidth : 0);
	        if (translate > 0) { translate = 0; }
	        if (translate < -panelWidth) {
	          translate = -panelWidth;
	        }
	      }
	    } else {
	      translate = touchesDiff + (panel.opened ? panelWidth : 0);
	      if (translate < 0) { translate = 0; }
	      if (translate > panelWidth) {
	        translate = panelWidth;
	      }
	    }
	    if (effect === 'reveal') {
	      $viewEl.transform(("translate3d(" + translate + "px,0,0)")).transition(0);
	      $backdropEl.transform(("translate3d(" + translate + "px,0,0)")).transition(0);

	      $el.trigger('panel:swipe', panel, Math.abs(translate / panelWidth));
	      panel.emit('local::swipe panelSwipe', panel, Math.abs(translate / panelWidth));
	    } else {
	      if (side === 'left') { translate -= panelWidth; }
	      $el.transform(("translate3d(" + translate + "px,0,0)")).transition(0);

	      $backdropEl.transition(0);
	      backdropOpacity = 1 - Math.abs(translate / panelWidth);
	      $backdropEl.css({ opacity: backdropOpacity });

	      $el.trigger('panel:swipe', panel, Math.abs(translate / panelWidth));
	      panel.emit('local::swipe panelSwipe', panel, Math.abs(translate / panelWidth));
	    }
	  }
	  function handleTouchEnd() {
	    if (!isTouched || !isMoved) {
	      isTouched = false;
	      isMoved = false;
	      return;
	    }
	    isTouched = false;
	    isMoved = false;
	    var timeDiff = (new Date()).getTime() - touchStartTime;
	    var action;
	    var edge = (translate === 0 || Math.abs(translate) === panelWidth);

	    var threshold = params.swipeThreshold || 0;

	    if (!panel.opened) {
	      if (Math.abs(touchesDiff) < threshold) {
	        action = 'reset';
	      } else if (effect === 'cover') {
	        if (translate === 0) {
	          action = 'swap'; // open
	        } else if (timeDiff < 300 && Math.abs(translate) > 0) {
	          action = 'swap'; // open
	        } else if (timeDiff >= 300 && Math.abs(translate) < panelWidth / 2) {
	          action = 'swap'; // open
	        } else {
	          action = 'reset'; // close
	        }
	      } else if (translate === 0) {
	        action = 'reset';
	      } else if (
	        (timeDiff < 300 && Math.abs(translate) > 0)
	        ||
	        (timeDiff >= 300 && (Math.abs(translate) >= panelWidth / 2))
	      ) {
	        action = 'swap';
	      } else {
	        action = 'reset';
	      }
	    } else if (effect === 'cover') {
	      if (translate === 0) {
	        action = 'reset'; // open
	      } else if (timeDiff < 300 && Math.abs(translate) > 0) {
	        action = 'swap'; // open
	      } else if (timeDiff >= 300 && Math.abs(translate) < panelWidth / 2) {
	        action = 'reset'; // open
	      } else {
	        action = 'swap'; // close
	      }
	    } else if (translate === -panelWidth) {
	      action = 'reset';
	    } else if (
	      (timeDiff < 300 && Math.abs(translate) >= 0)
	      ||
	      (timeDiff >= 300 && (Math.abs(translate) <= panelWidth / 2))
	    ) {
	      if (side === 'left' && translate === panelWidth) { action = 'reset'; }
	      else { action = 'swap'; }
	    } else {
	      action = 'reset';
	    }
	    if (action === 'swap') {
	      if (panel.opened) {
	        panel.close(!edge);
	      } else {
	        panel.open(!edge);
	      }
	    }
	    if (action === 'reset') {
	      if (!panel.opened) {
	        if (edge) {
	          $el.css({ display: '' });
	        } else {
	          var target = effect === 'reveal' ? $viewEl : $el;
	          $$1('html').addClass('with-panel-transitioning');
	          target.transitionEnd(function () {
	            if ($el.hasClass('panel-active')) { return; }
	            $el.css({ display: '' });
	            $$1('html').removeClass('with-panel-transitioning');
	          });
	        }
	      }
	    }
	    if (effect === 'reveal') {
	      Utils.nextFrame(function () {
	        $viewEl.transition('');
	        $viewEl.transform('');
	      });
	    }
	    $el.transition('').transform('');
	    $backdropEl.css({ display: '' }).transform('').transition('').css('opacity', '');
	  }

	  // Add Events
	  app.on('touchstart:passive', handleTouchStart);
	  app.on('touchmove:active', handleTouchMove);
	  app.on('touchend:passive', handleTouchEnd);
	  panel.on('panelDestroy', function () {
	    app.off('touchstart:passive', handleTouchStart);
	    app.off('touchmove:active', handleTouchMove);
	    app.off('touchend:passive', handleTouchEnd);
	  });
	}

	var Panel = (function (Framework7Class$$1) {
	  function Panel(app, params) {
	    if ( params === void 0 ) params = {};

	    Framework7Class$$1.call(this, params, [app]);
	    var panel = this;

	    var el = params.el;
	    var $el = $$1(el);
	    if ($el.length === 0) { return panel; }
	    if ($el[0].f7Panel) { return $el[0].f7Panel; }

	    $el[0].f7Panel = panel;

	    var opened = params.opened;
	    var side = params.side;
	    var effect = params.effect;
	    if (typeof opened === 'undefined') { opened = $el.hasClass('panel-active'); }
	    if (typeof side === 'undefined') { side = $el.hasClass('panel-left') ? 'left' : 'right'; }
	    if (typeof effect === 'undefined') { effect = $el.hasClass('panel-cover') ? 'cover' : 'reveal'; }

	    if (!app.panel[side]) {
	      Utils.extend(app.panel, ( obj = {}, obj[side] = panel, obj ));
	      var obj;
	    }

	    var $backdropEl = $$1('.panel-backdrop');
	    if ($backdropEl.length === 0) {
	      $backdropEl = $$1('<div class="panel-backdrop"></div>');
	      $backdropEl.insertBefore($el);
	    }

	    Utils.extend(panel, {
	      app: app,
	      side: side,
	      effect: effect,
	      $el: $el,
	      el: $el[0],
	      opened: opened,
	      $backdropEl: $backdropEl,
	      backdropEl: $backdropEl[0],
	    });

	    // Install Modules
	    panel.useModules();

	    // Init
	    panel.init();

	    return panel;
	  }

	  if ( Framework7Class$$1 ) Panel.__proto__ = Framework7Class$$1;
	  Panel.prototype = Object.create( Framework7Class$$1 && Framework7Class$$1.prototype );
	  Panel.prototype.constructor = Panel;
	  Panel.prototype.init = function init () {
	    var panel = this;
	    var app = panel.app;
	    if (app.params.panel[((panel.side) + "Breakpoint")]) {
	      panel.initBreakpoints();
	    }
	    {
	      if (
	        (app.params.panel.swipe === panel.side)
	        ||
	        (app.params.panel.swipe === 'both')
	        ||
	        (app.params.panel.swipe && app.params.panel.swipe !== panel.side && app.params.panel.swipeCloseOpposite)
	      ) {
	        panel.initSwipePanel();
	      }
	    }
	  };
	  Panel.prototype.getViewEl = function getViewEl () {
	    var panel = this;
	    var app = panel.app;
	    var viewEl;
	    if (app.root.children('.views').length > 0) {
	      viewEl = app.root.children('.views')[0];
	    } else {
	      viewEl = app.root.children('.view')[0];
	    }
	    return viewEl;
	  };
	  Panel.prototype.setBreakpoint = function setBreakpoint () {
	    var panel = this;
	    var app = panel.app;
	    var side = panel.side;
	    var $el = panel.$el;
	    var $viewEl = $$1(panel.getViewEl());
	    var breakpoint = app.params.panel[(side + "Breakpoint")];
	    var wasVisible = $el.hasClass('panel-visible-by-breakpoint');

	    if (app.width >= breakpoint) {
	      if (!wasVisible) {
	        $$1('html').removeClass(("with-panel-" + side + "-reveal with-panel-" + side + "-cover with-panel"));
	        $el.css('display', '').addClass('panel-visible-by-breakpoint').removeClass('panel-active');
	        panel.onOpen();
	        panel.onOpened();
	        $viewEl.css(( obj = {}, obj[("margin-" + side)] = (($el.width()) + "px"), obj ));
	        var obj;
	        app.allowPanelOpen = true;
	        app.emit('local::breakpoint panelBreakpoint');
	        panel.$el.trigger('panel:breakpoint', panel);
	      }
	    } else if (wasVisible) {
	      $el.css('display', '').removeClass('panel-visible-by-breakpoint panel-active');
	      panel.onClose();
	      panel.onClosed();
	      $viewEl.css(( obj$1 = {}, obj$1[("margin-" + side)] = '', obj$1 ));
	      var obj$1;
	      app.emit('local::breakpoint panelBreakpoint');
	      panel.$el.trigger('panel:breakpoint', panel);
	    }
	  };
	  Panel.prototype.initBreakpoints = function initBreakpoints () {
	    var panel = this;
	    var app = panel.app;
	    panel.resizeHandler = function resizeHandler() {
	      panel.setBreakpoint();
	    };
	    if (app.params.panel[((panel.side) + "Breakpoint")]) {
	      app.on('resize', panel.resizeHandler);
	    }
	    panel.setBreakpoint();
	    return panel;
	  };
	  Panel.prototype.initSwipePanel = function initSwipePanel () {
	    {
	      swipePanel(this);
	    }
	  };
	  Panel.prototype.destroy = function destroy () {
	    var panel = this;
	    var app = panel.app;

	    panel.emit('local::beforeDestroy panelBeforeDestroy', panel);
	    panel.$el.trigger('panel:beforedestroy', panel);

	    if (panel.resizeHandler) {
	      app.off('resize', panel.resizeHandler);
	    }
	    panel.$el.trigger('panel:destroy', panel);
	    panel.emit('local::destroy panelDestroy');
	    delete app.panel[panel.side];
	    delete panel.el.f7Panel;
	    Utils.deleteProps(panel);
	    panel = null;
	  };
	  Panel.prototype.open = function open (animate) {
	    if ( animate === void 0 ) animate = true;

	    var panel = this;
	    var app = panel.app;
	    if (!app.panel.allowOpen) { return false; }

	    var side = panel.side;
	    var effect = panel.effect;
	    var $el = panel.$el;
	    var $backdropEl = panel.$backdropEl;
	    var opened = panel.opened;

	    // Ignore if opened
	    if (opened || $el.hasClass('panel-visible-by-breakpoint') || $el.hasClass('panel-active')) { return false; }

	    // Close if some panel is opened
	    app.panel.close(side === 'left' ? 'right' : 'left', animate);

	    app.panel.allowOpen = false;

	    $el[animate ? 'removeClass' : 'addClass']('not-animated');
	    $el
	      .css({ display: 'block' })
	      .addClass('panel-active');

	    $backdropEl[animate ? 'removeClass' : 'addClass']('not-animated');
	    $backdropEl.show();

	    /* eslint no-underscore-dangle: ["error", { "allow": ["_clientLeft"] }] */
	    panel._clientLeft = $el[0].clientLeft;

	    $$1('html').addClass(("with-panel with-panel-" + side + "-" + effect));
	    panel.onOpen();

	    // Transition End;
	    var transitionEndTarget = effect === 'reveal' ? $el.nextAll('.view, .views').eq(0) : $el;

	    function panelTransitionEnd() {
	      transitionEndTarget.transitionEnd(function (e) {
	        if ($$1(e.target).is(transitionEndTarget)) {
	          if ($el.hasClass('panel-active')) {
	            panel.onOpened();
	            $backdropEl.css({ display: '' });
	          } else {
	            panel.onClosed();
	            $backdropEl.css({ display: '' });
	          }
	        } else { panelTransitionEnd(); }
	      });
	    }
	    if (animate) {
	      panelTransitionEnd();
	    } else {
	      panel.onOpened();
	      $backdropEl.css({ display: '' });
	    }

	    return true;
	  };
	  Panel.prototype.close = function close (animate) {
	    if ( animate === void 0 ) animate = true;

	    var panel = this;
	    var app = panel.app;

	    var side = panel.side;
	    var effect = panel.effect;
	    var $el = panel.$el;
	    var $backdropEl = panel.$backdropEl;
	    var opened = panel.opened;

	    if (!opened || $el.hasClass('panel-visible-by-breakpoint') || !$el.hasClass('panel-active')) { return false; }

	    $el[animate ? 'removeClass' : 'addClass']('not-animated');
	    $el.removeClass('panel-active');

	    $backdropEl[animate ? 'removeClass' : 'addClass']('not-animated');

	    var transitionEndTarget = effect === 'reveal' ? $el.nextAll('.view, .views').eq(0) : $el;

	    panel.onClose();
	    app.panel.allowOpen = false;

	    if (animate) {
	      transitionEndTarget.transitionEnd(function () {
	        if ($el.hasClass('panel-active')) { return; }
	        $el.css({ display: '' });
	        $$1('html').removeClass('with-panel-transitioning');
	        panel.onClosed();
	      });
	      $$1('html')
	        .removeClass(("with-panel with-panel-" + side + "-" + effect))
	        .addClass('with-panel-transitioning');
	    } else {
	      $el.css({ display: '' });
	      $el.removeClass('not-animated');
	      $$1('html').removeClass(("with-panel with-panel-transitioning with-panel-" + side + "-" + effect));
	      panel.onClosed();
	    }
	    return true;
	  };
	  Panel.prototype.onOpen = function onOpen () {
	    var panel = this;
	    panel.opened = true;
	    panel.$el.trigger('panel:open', panel);
	    panel.emit('local::open panelOpen', panel);
	  };
	  Panel.prototype.onOpened = function onOpened () {
	    var panel = this;
	    var app = panel.app;
	    app.panel.allowOpen = true;

	    panel.$el.trigger('panel:opened', panel);
	    panel.emit('local::opened panelOpened', panel);
	  };
	  Panel.prototype.onClose = function onClose () {
	    var panel = this;
	    panel.opened = false;
	    panel.$el.addClass('panel-closing');
	    panel.$el.trigger('panel:close', panel);
	    panel.emit('local::close panelClose', panel);
	  };
	  Panel.prototype.onClosed = function onClosed () {
	    var panel = this;
	    var app = panel.app;
	    app.panel.allowOpen = true;
	    panel.$el.removeClass('panel-closing');
	    panel.$el.trigger('panel:closed', panel);
	    panel.emit('local::closed panelClosed', panel);
	  };

	  return Panel;
	}(Framework7Class));

	var Panel$1 = {
	  name: 'panel',
	  params: {
	    panel: {
	      leftBreakpoint: 0,
	      rightBreakpoint: 0,
	      swipe: undefined, // or 'left' or 'right' or 'both'
	      swipeActiveArea: 0,
	      swipeCloseActiveAreaSide: 0,
	      swipeCloseOpposite: true,
	      swipeOnlyClose: false,
	      swipeNoFollow: false,
	      swipeThreshold: 0,
	      closeByBackdropClick: true,
	    },
	  },
	  static: {
	    Panel: Panel,
	  },
	  instance: {
	    panel: {
	      allowOpen: true,
	    },
	  },
	  create: function create() {
	    var app = this;
	    Utils.extend(app.panel, {
	      disableSwipe: function disableSwipe(panel) {
	        if ( panel === void 0 ) panel = 'both';

	        var side;
	        var panels = [];
	        if (typeof panel === 'string') {
	          if (panel === 'both') {
	            side = 'both';
	            panels = [app.panel.left, app.panel.right];
	          } else {
	            side = panel;
	            panels.push(app.panel[side]);
	          }
	        } else {
	          panels = [panel];
	        }
	        panels.forEach(function (panelInstance) {
	          if (panelInstance) { Utils.extend(panelInstance, { swipeable: false }); }
	        });
	      },
	      enableSwipe: function enableSwipe(panel) {
	        if ( panel === void 0 ) panel = 'both';

	        var panels = [];
	        var side;
	        if (typeof panel === 'string') {
	          side = panel;
	          if (
	            (app.params.panel.swipe === 'left' && side === 'right') ||
	            (app.params.panel.swipe === 'right' && side === 'left') ||
	            side === 'both'
	          ) {
	            side = 'both';
	            app.params.panel.swipe = side;
	            panels = [app.panel.left, app.panel.right];
	          } else {
	            app.params.panel.swipe = side;
	            panels.push(app.panel[side]);
	          }
	        } else if (panel) {
	          panels.push(panel);
	        }
	        if (panels.length) {
	          panels.forEach(function (panelInstance) {
	            if (!panelInstance) { return; }
	            if (!panelInstance.swipeInitialized) {
	              panelInstance.initSwipePanel();
	            } else {
	              Utils.extend(panelInstance, { swipeable: true });
	            }
	          });
	        }
	      },
	      create: function create(params) {
	        return new Panel(app, params);
	      },
	      open: function open(side, animate) {
	        var panelSide = side;
	        if (!panelSide) {
	          if ($$1('.panel').length > 1) {
	            return false;
	          }
	          panelSide = $$1('.panel').hasClass('panel-left') ? 'left' : 'right';
	        }
	        if (!panelSide) { return false; }
	        if (app.panel[panelSide]) {
	          return app.panel[panelSide].open(animate);
	        }
	        var $panelEl = $$1((".panel-" + panelSide));
	        if ($panelEl.length > 0) {
	          return app.panel.create({ el: $panelEl }).open(animate);
	        }
	        return false;
	      },
	      close: function close(side, animate) {
	        var $panelEl;
	        var panelSide;
	        if (panelSide) {
	          panelSide = side;
	          $panelEl = $$1((".panel-" + panelSide));
	        } else {
	          $panelEl = $$1('.panel.panel-active');
	          panelSide = $panelEl.hasClass('panel-left') ? 'left' : 'right';
	        }
	        if (!panelSide) { return false; }
	        if (app.panel[panelSide]) {
	          return app.panel[panelSide].close(animate);
	        }
	        if ($panelEl.length > 0) {
	          return app.panel.create({ el: $panelEl }).close(animate);
	        }
	        return false;
	      },
	      get: function get(side) {
	        var panelSide = side;
	        if (!panelSide) {
	          if ($$1('.panel').length > 1) {
	            return undefined;
	          }
	          panelSide = $$1('.panel').hasClass('panel-left') ? 'left' : 'right';
	        }
	        if (!panelSide) { return undefined; }
	        if (app.panel[panelSide]) {
	          return app.panel[panelSide];
	        }
	        var $panelEl = $$1((".panel-" + panelSide));
	        if ($panelEl.length > 0) {
	          return app.panel.create({ el: $panelEl });
	        }
	        return undefined;
	      },
	    });
	  },
	  on: {
	    init: function init() {
	      var app = this;

	      // Create Panels
	      $$1('.panel').each(function (index, panelEl) {
	        var side = $$1(panelEl).hasClass('panel-left') ? 'left' : 'right';
	        app.panel[side] = app.panel.create({ el: panelEl, side: side });
	      });
	    },
	  },
	  clicks: {
	    '.panel-open': function open(clickedEl, data) {
	      if ( data === void 0 ) data = {};

	      var app = this;
	      var side = 'left';
	      if (data.panel === 'right' || ($$1('.panel').length === 1 && $$1('.panel').hasClass('panel-right'))) {
	        side = 'right';
	      }
	      app.panel.open(side, data.animate);
	    },
	    '.panel-close': function close(clickedEl, data) {
	      if ( data === void 0 ) data = {};

	      var app = this;
	      var side = data.panel;
	      app.panel.close(side, data.animate);
	    },
	    '.panel-backdrop': function close() {
	      var app = this;
	      var $panelEl = $$1('.panel-active');
	      var instance = $panelEl[0] && $panelEl[0].f7Panel;
	      $panelEl.trigger('panel:backdrop-click');
	      if (instance) {
	        instance.emit('backdropClick', instance);
	      }
	      app.emit('panelBackdropClick', instance || $panelEl[0]);
	      if (app.params.panel.closeByBackdropClick) { app.panel.close(); }
	    },
	  },
	};

	var Card = {
	  name: 'card',
	};

	// Form Data
	var FormData$1 = {
	  store: function store(form, data) {
	    var app = this;
	    var formId = form;

	    var $formEl = $$1(form);
	    if ($formEl.length && $formEl.is('form') && $formEl.attr('id')) {
	      formId = $formEl.attr('id');
	    }
	    // Store form data in app.formsData
	    app.form.data[("form-" + formId)] = data;

	    // Store form data in local storage also
	    try {
	      win.localStorage[("f7form-" + formId)] = JSON.stringify(data);
	    } catch (e) {
	      throw e;
	    }
	  },
	  get: function get(form) {
	    var app = this;
	    var formId = form;

	    var $formEl = $$1(form);
	    if ($formEl.length && $formEl.is('form') && $formEl.attr('id')) {
	      formId = $formEl.attr('id');
	    }

	    try {
	      if (win.localStorage[("f7form-" + formId)]) {
	        return JSON.parse(win.localStorage[("f7form-" + formId)]);
	      }
	    } catch (e) {
	      throw e;
	    }
	    if (app.form.data[("form-" + formId)]) {
	      return app.form.data[("form-" + formId)];
	    }
	    return undefined;
	  },
	  remove: function remove(form) {
	    var app = this;
	    var formId = form;

	    var $formEl = $$1(form);
	    if ($formEl.length && $formEl.is('form') && $formEl.attr('id')) {
	      formId = $formEl.attr('id');
	    }

	    // Delete form data from app.formsData
	    if (app.form.data[("form-" + formId)]) {
	      app.form.data[("form-" + formId)] = '';
	      delete app.form.data[("form-" + formId)];
	    }

	    // Delete form data from local storage also
	    try {
	      if (win.localStorage[("f7form-" + formId)]) {
	        win.localStorage[("f7form-" + formId)] = '';
	        win.localStorage.removeItem(("f7form-" + formId));
	      }
	    } catch (e) {
	      throw e;
	    }
	  },
	};

	// Form Storage
	var FormStorage = {
	  init: function init(formEl) {
	    var app = this;
	    var $formEl = $$1(formEl);
	    var formId = $formEl.attr('id');
	    if (!formId) { return; }
	    var initialData = app.form.getFormData(formId);
	    if (initialData) {
	      app.form.fillFromData($formEl, initialData);
	    }
	    function store() {
	      var data = app.form.convertToData($formEl);
	      if (!data) { return; }
	      app.form.storeFormData(formId, data);
	      $formEl.trigger('form:storedata', data);
	      app.emit('formStoreData', $formEl[0], data);
	    }
	    $formEl.on('change submit', store);
	  },
	  destroy: function destroy(formEl) {
	    var $formEl = $$1(formEl);
	    $formEl.off('change submit');
	  },
	};

	// Form To/From Data
	function formToData(formEl) {
	  var app = this;
	  var $formEl = $$1(formEl).eq(0);
	  if ($formEl.length === 0) { return undefined; }

	  // Form data
	  var data = {};

	  // Skip input types
	  var skipTypes = ['submit', 'image', 'button', 'file'];
	  var skipNames = [];
	  $formEl.find('input, select, textarea').each(function (inputIndex, inputEl) {
	    var $inputEl = $$1(inputEl);
	    if ($inputEl.hasClass('ignore-store-data') || $inputEl.hasClass('no-store-data')) {
	      return;
	    }
	    var name = $inputEl.attr('name');
	    var type = $inputEl.attr('type');
	    var tag = inputEl.nodeName.toLowerCase();
	    if (skipTypes.indexOf(type) >= 0) { return; }
	    if (skipNames.indexOf(name) >= 0 || !name) { return; }
	    if (tag === 'select' && $inputEl.prop('multiple')) {
	      skipNames.push(name);
	      data[name] = [];
	      $formEl.find(("select[name=\"" + name + "\"] option")).each(function (index, el) {
	        if (el.selected) { data[name].push(el.value); }
	      });
	    } else {
	      switch (type) {
	        case 'checkbox':
	          skipNames.push(name);
	          data[name] = [];
	          $formEl.find(("input[name=\"" + name + "\"]")).each(function (index, el) {
	            if (el.checked) { data[name].push(el.value); }
	          });
	          break;
	        case 'radio':
	          skipNames.push(name);
	          $formEl.find(("input[name=\"" + name + "\"]")).each(function (index, el) {
	            if (el.checked) { data[name] = el.value; }
	          });
	          break;
	        default:
	          data[name] = $inputEl.val();
	          break;
	      }
	    }
	  });
	  $formEl.trigger('form:todata', data);
	  app.emit('formToData', $formEl[0], data);

	  return data;
	}
	function formFromData(formEl, formData) {
	  var app = this;
	  var $formEl = $$1(formEl).eq(0);
	  if (!$formEl.length) { return; }

	  var data = formData;
	  var formId = $formEl.attr('id');

	  if (!data && formId) {
	    data = app.form.getFormData(formId);
	  }

	  if (!data) { return; }

	  // Skip input types
	  var skipTypes = ['submit', 'image', 'button', 'file'];
	  var skipNames = [];

	  $formEl.find('input, select, textarea').each(function (inputIndex, inputEl) {
	    var $inputEl = $$1(inputEl);
	    if ($inputEl.hasClass('ignore-store-data') || $inputEl.hasClass('no-store-data')) {
	      return;
	    }
	    var name = $inputEl.attr('name');
	    var type = $inputEl.attr('type');
	    var tag = inputEl.nodeName.toLowerCase();
	    if (typeof data[name] === 'undefined' || data[name] === null) { return; }
	    if (skipTypes.indexOf(type) >= 0) { return; }
	    if (skipNames.indexOf(name) >= 0 || !name) { return; }
	    if (tag === 'select' && $inputEl.prop('multiple')) {
	      skipNames.push(name);
	      $formEl.find(("select[name=\"" + name + "\"] option")).each(function (index, el) {
	        var selectEl = el;
	        if (data[name].indexOf(el.value) >= 0) { selectEl.selected = true; }
	        else { selectEl.selected = false; }
	      });
	    } else {
	      switch (type) {
	        case 'checkbox':
	          skipNames.push(name);
	          $formEl.find(("input[name=\"" + name + "\"]")).each(function (index, el) {
	            var checkboxEl = el;
	            if (data[name].indexOf(el.value) >= 0) { checkboxEl.checked = true; }
	            else { checkboxEl.checked = false; }
	          });
	          break;
	        case 'radio':
	          skipNames.push(name);
	          $formEl.find(("input[name=\"" + name + "\"]")).each(function (index, el) {
	            var radioEl = el;
	            if (data[name] === el.value) { radioEl.checked = true; }
	            else { radioEl.checked = false; }
	          });
	          break;
	        default:
	          $inputEl.val(data[name]);
	          break;
	      }
	    }
	    if (tag === 'select' || tag === 'input' || tag === 'textarea') {
	      $inputEl.trigger('change', 'fromdata');
	    }
	  });
	  $formEl.trigger('form:fromdata', data);
	  app.emit('formFromData', $formEl[0], data);
	}

	function initAjaxForm() {
	  var app = this;

	  function onSubmitChange(e, fromData) {
	    var $formEl = $$1(this);
	    if (e.type === 'change' && !$formEl.hasClass('form-ajax-submit-onchange')) { return; }
	    if (e.type === 'submit') { e.preventDefault(); }

	    if (e.type === 'change' && fromData === 'fromdata') { return; }

	    var method = ($formEl.attr('method') || 'GET').toUpperCase();
	    var contentType = $formEl.prop('enctype') || $formEl.attr('enctype');

	    var url = $formEl.attr('action');
	    if (!url) { return; }

	    var data;
	    if (method === 'POST') {
	      if (contentType === 'application/x-www-form-urlencoded') {
	        data = app.form.convertToData($formEl[0]);
	      } else {
	        data = new win.FormData($formEl[0]);
	      }
	    } else {
	      data = Utils.serializeObject(app.form.convertToData($formEl[0]));
	    }

	    var xhr = app.request({
	      method: method,
	      url: url,
	      contentType: contentType,
	      data: data,
	      beforeSend: function beforeSend() {
	        $formEl.trigger('formajax:beforesend', data, xhr);
	        app.emit('formAjaxBeforeSend', $formEl[0], data, xhr);
	      },
	      error: function error() {
	        $formEl.trigger('formajax:error', data, xhr);
	        app.emit('formAjaxError', $formEl[0], data, xhr);
	      },
	      complete: function complete() {
	        $formEl.trigger('formajax:complete', data, xhr);
	        app.emit('formAjaxComplete', $formEl[0], data, xhr);
	      },
	      success: function success() {
	        $formEl.trigger('formajax:success', data, xhr);
	        app.emit('formAjaxSuccess', $formEl[0], data, xhr);
	      },
	    });
	  }
	  $$1(doc).on('submit change', 'form.form-ajax-submit, form.form-ajax-submit-onchange', onSubmitChange);
	}

	var Form = {
	  name: 'form',
	  create: function create() {
	    var app = this;
	    Utils.extend(app, {
	      form: {
	        data: {},
	        storeFormData: FormData$1.store.bind(app),
	        getFormData: FormData$1.get.bind(app),
	        removeFormData: FormData$1.remove.bind(app),
	        convertToData: formToData.bind(app),
	        fillFromData: formFromData.bind(app),
	        storage: {
	          init: FormStorage.init.bind(app),
	          destroy: FormStorage.destroy.bind(app),
	        },
	      },
	    });
	  },
	  on: {
	    init: function init() {
	      var app = this;
	      initAjaxForm.call(app);
	    },
	    tabBeforeRemove: function tabBeforeRemove(tabEl) {
	      var app = this;
	      $$1(tabEl).find('.form-store-data').each(function (index, formEl) {
	        app.form.storage.destroy(formEl);
	      });
	    },
	    tabMounted: function tabMounted(tabEl) {
	      var app = this;
	      $$1(tabEl).find('.form-store-data').each(function (index, formEl) {
	        app.form.storage.init(formEl);
	      });
	    },
	    pageBeforeRemove: function pageBeforeRemove(page) {
	      var app = this;
	      page.$el.find('.form-store-data').each(function (index, formEl) {
	        app.form.storage.destroy(formEl);
	      });
	    },
	    pageInit: function pageInit(page) {
	      var app = this;
	      page.$el.find('.form-store-data').each(function (index, formEl) {
	        app.form.storage.init(formEl);
	      });
	    },
	  },
	};

	var Input = {
	  ignoreTypes: ['checkbox', 'button', 'submit', 'range', 'radio', 'image'],
	  createTextareaResizableShadow: function createTextareaResizableShadow() {
	    var $shadowEl = $$1(doc.createElement('textarea'));
	    $shadowEl.addClass('textarea-resizable-shadow');
	    $shadowEl.prop({
	      disabled: true,
	      readonly: true,
	    });
	    Input.textareaResizableShadow = $shadowEl;
	  },
	  textareaResizableShadow: undefined,
	  resizeTextarea: function resizeTextarea(textareaEl) {
	    var app = this;
	    var $textareaEl = $$1(textareaEl);
	    if (!Input.textareaResizableShadow) {
	      Input.createTextareaResizableShadow();
	    }
	    var $shadowEl = Input.textareaResizableShadow;
	    if (!$textareaEl.length) { return; }
	    if (!$textareaEl.hasClass('resizable')) { return; }
	    if (Input.textareaResizableShadow.parents().length === 0) {
	      app.root.append($shadowEl);
	    }

	    var styles = win.getComputedStyle($textareaEl[0]);
	    ('padding margin width font-size font-family font-style font-weight line-height font-variant text-transform letter-spacing border box-sizing display').split(' ').forEach(function (style) {
	      var styleValue = styles[style];
	      if (('font-size line-height letter-spacing width').split(' ').indexOf(style) >= 0) {
	        styleValue = styleValue.replace(',', '.');
	      }
	      $shadowEl.css(style, styleValue);
	    });
	    var currentHeight = $textareaEl[0].clientHeight;

	    $shadowEl.val('');
	    var initialHeight = $shadowEl[0].scrollHeight;

	    $shadowEl.val($textareaEl.val());
	    $shadowEl.css('height', 0);
	    var scrollHeight = $shadowEl[0].scrollHeight;

	    if (currentHeight !== scrollHeight) {
	      if (scrollHeight > initialHeight) {
	        $textareaEl.css('height', (scrollHeight + "px"));
	        $textareaEl.trigger('textarea:resize', { initialHeight: initialHeight, currentHeight: currentHeight, scrollHeight: scrollHeight });
	      } else if (scrollHeight < currentHeight) {
	        $textareaEl.css('height', '');
	        $textareaEl.trigger('textarea:resize', { initialHeight: initialHeight, currentHeight: currentHeight, scrollHeight: scrollHeight });
	      }
	    }
	  },
	  validate: function validate(inputEl) {
	    var $inputEl = $$1(inputEl);
	    if (!$inputEl.length) { return; }
	    var $itemInputEl = $inputEl.parents('.item-input');
	    var $inputWrapEl = $inputEl.parents('.input');
	    var validity = $inputEl[0].validity;
	    var validationMessage = $inputEl.dataset().errorMessage || $inputEl[0].validationMessage || '';
	    if (!validity) { return; }
	    if (!validity.valid) {
	      var $errorEl = $inputEl.nextAll('.item-input-error-message, .input-error-message');
	      if (validationMessage) {
	        if ($errorEl.length === 0) {
	          $errorEl = $$1(("<div class=\"" + ($inputWrapEl.length ? 'input-error-message' : 'item-input-error-message') + "\"></div>"));
	          $errorEl.insertAfter($inputEl);
	        }
	        $errorEl.text(validationMessage);
	      }
	      if ($errorEl.length > 0) {
	        $itemInputEl.addClass('item-input-with-error-message');
	        $inputWrapEl.addClass('input-with-eror-message');
	      }
	      $itemInputEl.addClass('item-input-invalid');
	      $inputWrapEl.addClass('input-invalid');
	      $inputEl.addClass('input-invalid');
	    } else {
	      $itemInputEl.removeClass('item-input-invalid item-input-with-error-message');
	      $inputWrapEl.removeClass('input-invalid input-with-error-message');
	      $inputEl.removeClass('input-invalid');
	    }
	  },
	  validateInputs: function validateInputs(el) {
	    var app = this;
	    $$1(el).find('input, textarea, select').each(function (index, inputEl) {
	      app.input.validate(inputEl);
	    });
	  },
	  focus: function focus(inputEl) {
	    var $inputEl = $$1(inputEl);
	    var type = $inputEl.attr('type');
	    if (Input.ignoreTypes.indexOf(type) >= 0) { return; }
	    $inputEl.parents('.item-input').addClass('item-input-focused');
	    $inputEl.parents('.input').addClass('input-focused');
	    $inputEl.addClass('input-focused');
	  },
	  blur: function blur(inputEl) {
	    var $inputEl = $$1(inputEl);
	    $inputEl.parents('.item-input').removeClass('item-input-focused');
	    $inputEl.parents('.input').removeClass('input-focused');
	    $inputEl.removeClass('input-focused');
	  },
	  checkEmptyState: function checkEmptyState(inputEl) {
	    var $inputEl = $$1(inputEl);
	    var value = $inputEl.val();
	    var $itemInputEl = $inputEl.parents('.item-input');
	    var $inputWrapEl = $inputEl.parents('.input');
	    if ((value && (typeof value === 'string' && value.trim() !== '')) || (Array.isArray(value) && value.length > 0)) {
	      $itemInputEl.addClass('item-input-with-value');
	      $inputWrapEl.addClass('input-with-value');
	      $inputEl.addClass('input-with-value');
	      $inputEl.trigger('input:notempty');
	    } else {
	      $itemInputEl.removeClass('item-input-with-value');
	      $inputWrapEl.removeClass('input-with-value');
	      $inputEl.removeClass('input-with-value');
	      $inputEl.trigger('input:empty');
	    }
	  },
	  scrollIntoView: function scrollIntoView(inputEl, duration, centered, force) {
	    if ( duration === void 0 ) duration = 0;

	    var $inputEl = $$1(inputEl);
	    var $scrollableEl = $inputEl.parents('.page-content, .panel').eq(0);
	    if (!$scrollableEl.length) {
	      return false;
	    }
	    var contentHeight = $scrollableEl[0].offsetHeight;
	    var contentScrollTop = $scrollableEl[0].scrollTop;
	    var contentPaddingTop = parseInt($scrollableEl.css('padding-top'), 10);
	    var contentPaddingBottom = parseInt($scrollableEl.css('padding-bottom'), 10);
	    var contentOffsetTop = $scrollableEl.offset().top - contentScrollTop;

	    var inputOffsetTop = $inputEl.offset().top - contentOffsetTop;
	    var inputHeight = $inputEl[0].offsetHeight;

	    var min = (inputOffsetTop + contentScrollTop) - contentPaddingTop;
	    var max = ((inputOffsetTop + contentScrollTop) - contentHeight) + contentPaddingBottom + inputHeight;
	    var centeredPosition = min + ((max - min) / 2);

	    if (contentScrollTop > min) {
	      $scrollableEl.scrollTop(centered ? centeredPosition : min, duration);
	      return true;
	    } else if (contentScrollTop < max) {
	      $scrollableEl.scrollTop(centered ? centeredPosition : max, duration);
	      return true;
	    } else if (force) {
	      $scrollableEl.scrollTop(centered ? centeredPosition : max, duration);
	    }
	    return false;
	  },
	  init: function init() {
	    var app = this;
	    Input.createTextareaResizableShadow();
	    function onFocus() {
	      var inputEl = this;
	      if (app.params.input.scrollIntoViewOnFocus) {
	        if (Device.android) {
	          $$1(win).once('resize', function () {
	            if (doc && doc.activeElement === inputEl) {
	              app.input.scrollIntoView(inputEl, app.params.input.scrollIntoViewDuration, app.params.input.scrollIntoViewCentered, app.params.input.scrollIntoViewAlways);
	            }
	          });
	        } else {
	          app.input.scrollIntoView(inputEl, app.params.input.scrollIntoViewDuration, app.params.input.scrollIntoViewCentered, app.params.input.scrollIntoViewAlways);
	        }
	      }
	      app.input.focus(inputEl);
	    }
	    function onBlur() {
	      var $inputEl = $$1(this);
	      var tag = $inputEl[0].nodeName.toLowerCase();
	      app.input.blur($inputEl);
	      if ($inputEl.dataset().validate || $inputEl.attr('validate') !== null) {
	        app.input.validate($inputEl);
	      }
	      // Resize textarea
	      if (tag === 'textarea' && $inputEl.hasClass('resizable')) {
	        if (Input.textareaResizableShadow) { Input.textareaResizableShadow.remove(); }
	      }
	    }
	    function onChange() {
	      var $inputEl = $$1(this);
	      var type = $inputEl.attr('type');
	      var tag = $inputEl[0].nodeName.toLowerCase();
	      if (Input.ignoreTypes.indexOf(type) >= 0) { return; }

	      // Check Empty State
	      app.input.checkEmptyState($inputEl);

	      // Check validation
	      if ($inputEl.dataset().validate || $inputEl.attr('validate') !== null) {
	        app.input.validate($inputEl);
	      }

	      // Resize textarea
	      if (tag === 'textarea' && $inputEl.hasClass('resizable')) {
	        app.input.resizeTextarea($inputEl);
	      }
	    }
	    function onInvalid(e) {
	      var $inputEl = $$1(this);
	      if ($inputEl.dataset().validate || $inputEl.attr('validate') !== null) {
	        e.preventDefault();
	        app.input.validate($inputEl);
	      }
	    }
	    function clearInput() {
	      var $clicked = $$1(this);
	      var $inputEl = $clicked.siblings('input, textarea').eq(0);
	      var previousValue = $inputEl.val();
	      $inputEl
	        .val('')
	        .trigger('change input')
	        .focus()
	        .trigger('input:clear', previousValue);
	    }
	    $$1(doc).on('click', '.input-clear-button', clearInput);
	    $$1(doc).on('change input', 'input, textarea, select', onChange, true);
	    $$1(doc).on('focus', 'input, textarea, select', onFocus, true);
	    $$1(doc).on('blur', 'input, textarea, select', onBlur, true);
	    $$1(doc).on('invalid', 'input, textarea, select', onInvalid, true);
	  },
	};

	var Input$1 = {
	  name: 'input',
	  params: {
	    input: {
	      scrollIntoViewOnFocus: Device.android,
	      scrollIntoViewCentered: false,
	      scrollIntoViewDuration: 0,
	      scrollIntoViewAlways: false,
	    },
	  },
	  create: function create() {
	    var app = this;
	    Utils.extend(app, {
	      input: {
	        scrollIntoView: Input.scrollIntoView.bind(app),
	        focus: Input.focus.bind(app),
	        blur: Input.blur.bind(app),
	        validate: Input.validate.bind(app),
	        validateInputs: Input.validateInputs.bind(app),
	        checkEmptyState: Input.checkEmptyState.bind(app),
	        resizeTextarea: Input.resizeTextarea.bind(app),
	        init: Input.init.bind(app),
	      },
	    });
	  },
	  on: {
	    init: function init() {
	      var app = this;
	      app.input.init();
	    },
	    tabMounted: function tabMounted(tabEl) {
	      var app = this;
	      var $tabEl = $$1(tabEl);
	      $tabEl.find('.item-input, .input').each(function (itemInputIndex, itemInputEl) {
	        var $itemInputEl = $$1(itemInputEl);
	        $itemInputEl.find('input, select, textarea').each(function (inputIndex, inputEl) {
	          var $inputEl = $$1(inputEl);
	          if (Input.ignoreTypes.indexOf($inputEl.attr('type')) >= 0) { return; }
	          app.input.checkEmptyState($inputEl);
	        });
	      });
	      $tabEl.find('textarea.resizable').each(function (textareaIndex, textareaEl) {
	        app.input.resizeTextarea(textareaEl);
	      });
	    },
	    pageInit: function pageInit(page) {
	      var app = this;
	      var $pageEl = page.$el;
	      $pageEl.find('.item-input, .input').each(function (itemInputIndex, itemInputEl) {
	        var $itemInputEl = $$1(itemInputEl);
	        $itemInputEl.find('input, select, textarea').each(function (inputIndex, inputEl) {
	          var $inputEl = $$1(inputEl);
	          if (Input.ignoreTypes.indexOf($inputEl.attr('type')) >= 0) { return; }
	          app.input.checkEmptyState($inputEl);
	        });
	      });
	      $pageEl.find('textarea.resizable').each(function (textareaIndex, textareaEl) {
	        app.input.resizeTextarea(textareaEl);
	      });
	    },
	  },
	};

	var Checkbox = {
	  name: 'checkbox',
	};

	var Radio = {
	  name: 'radio',
	};

	var Toggle = (function (Framework7Class$$1) {
	  function Toggle(app, params) {
	    if ( params === void 0 ) params = {};

	    Framework7Class$$1.call(this, params, [app]);
	    var toggle = this;

	    var defaults = {};

	    // Extend defaults with modules params
	    toggle.useModulesParams(defaults);

	    toggle.params = Utils.extend(defaults, params);

	    var el = toggle.params.el;
	    if (!el) { return toggle; }

	    var $el = $$1(el);
	    if ($el.length === 0) { return toggle; }


	    var $inputEl = $el.children('input[type="checkbox"]');

	    Utils.extend(toggle, {
	      app: app,
	      $el: $el,
	      el: $el[0],
	      $inputEl: $inputEl,
	      inputEl: $inputEl[0],
	      disabled: $el.hasClass('disabled') || $inputEl.hasClass('disabled') || $inputEl.attr('disabled') || $inputEl[0].disabled,
	    });

	    Object.defineProperty(toggle, 'checked', {
	      enumerable: true,
	      configurable: true,
	      set: function set(checked) {
	        if (!toggle || typeof toggle.$inputEl === 'undefined') { return; }
	        if (toggle.checked === checked) { return; }
	        $inputEl[0].checked = checked;
	        toggle.$inputEl.trigger('change');
	      },
	      get: function get() {
	        return $inputEl[0].checked;
	      },
	    });

	    $el[0].f7Toggle = toggle;

	    var isTouched;
	    var touchesStart = {};
	    var isScrolling;
	    var touchesDiff;
	    var toggleWidth;
	    var touchStartTime;
	    var touchStartChecked;
	    function handleTouchStart(e) {
	      if (isTouched || toggle.disabled) { return; }
	      touchesStart.x = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
	      touchesStart.y = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
	      touchesDiff = 0;

	      isTouched = true;
	      isScrolling = undefined;
	      touchStartTime = Utils.now();
	      touchStartChecked = toggle.checked;

	      toggleWidth = $el[0].offsetWidth;
	      Utils.nextTick(function () {
	        if (isTouched) {
	          $el.addClass('toggle-active-state');
	        }
	      });
	    }
	    function handleTouchMove(e) {
	      if (!isTouched || toggle.disabled) { return; }
	      var pageX = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX;
	      var pageY = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;
	      var inverter = app.rtl ? -1 : 1;

	      if (typeof isScrolling === 'undefined') {
	        isScrolling = !!(isScrolling || Math.abs(pageY - touchesStart.y) > Math.abs(pageX - touchesStart.x));
	      }
	      if (isScrolling) {
	        isTouched = false;
	        return;
	      }
	      e.preventDefault();

	      touchesDiff = pageX - touchesStart.x;


	      var changed;
	      if (touchesDiff * inverter < 0 && Math.abs(touchesDiff) > toggleWidth / 3 && touchStartChecked) {
	        changed = true;
	      }
	      if (touchesDiff * inverter > 0 && Math.abs(touchesDiff) > toggleWidth / 3 && !touchStartChecked) {
	        changed = true;
	      }
	      if (changed) {
	        touchesStart.x = pageX;
	        toggle.checked = !touchStartChecked;
	        touchStartChecked = !touchStartChecked;
	      }
	    }
	    function handleTouchEnd() {
	      if (!isTouched || toggle.disabled) {
	        if (isScrolling) { $el.removeClass('toggle-active-state'); }
	        isTouched = false;
	        return;
	      }
	      var inverter = app.rtl ? -1 : 1;
	      isTouched = false;

	      $el.removeClass('toggle-active-state');

	      var changed;
	      if ((Utils.now() - touchStartTime) < 300) {
	        if (touchesDiff * inverter < 0 && touchStartChecked) {
	          changed = true;
	        }
	        if (touchesDiff * inverter > 0 && !touchStartChecked) {
	          changed = true;
	        }
	        if (changed) {
	          toggle.checked = !touchStartChecked;
	        }
	      }
	    }
	    function handleInputChange() {
	      toggle.$el.trigger('toggle:change', toggle);
	      toggle.emit('local::change toggleChange', toggle);
	    }
	    toggle.attachEvents = function attachEvents() {
	      {
	        if (!Support.touch) { return; }
	        var passive = Support.passiveListener ? { passive: true } : false;
	        $el.on(app.touchEvents.start, handleTouchStart, passive);
	        app.on('touchmove', handleTouchMove);
	        app.on('touchend:passive', handleTouchEnd);
	      }
	      toggle.$inputEl.on('change', handleInputChange);
	    };
	    toggle.detachEvents = function detachEvents() {
	      {
	        if (!Support.touch) { return; }
	        var passive = Support.passiveListener ? { passive: true } : false;
	        $el.off(app.touchEvents.start, handleTouchStart, passive);
	        app.off('touchmove', handleTouchMove);
	        app.off('touchend:passive', handleTouchEnd);
	      }
	      toggle.$inputEl.off('change', handleInputChange);
	    };


	    // Install Modules
	    toggle.useModules();

	    // Init
	    toggle.init();
	  }

	  if ( Framework7Class$$1 ) Toggle.__proto__ = Framework7Class$$1;
	  Toggle.prototype = Object.create( Framework7Class$$1 && Framework7Class$$1.prototype );
	  Toggle.prototype.constructor = Toggle;
	  Toggle.prototype.toggle = function toggle () {
	    var toggle = this;
	    toggle.checked = !toggle.checked;
	  };
	  Toggle.prototype.init = function init () {
	    var toggle = this;
	    toggle.attachEvents();
	  };
	  Toggle.prototype.destroy = function destroy () {
	    var toggle = this;
	    toggle.$el.trigger('toggle:beforedestroy', toggle);
	    toggle.emit('local::beforeDestroy toggleBeforeDestroy', toggle);
	    delete toggle.$el[0].f7Toggle;
	    toggle.detachEvents();
	    Utils.deleteProps(toggle);
	    toggle = null;
	  };

	  return Toggle;
	}(Framework7Class));

	var Toggle$1 = {
	  name: 'toggle',
	  create: function create() {
	    var app = this;
	    app.toggle = ConstructorMethods({
	      defaultSelector: '.toggle',
	      constructor: Toggle,
	      app: app,
	      domProp: 'f7Toggle',
	    });
	  },
	  static: {
	    Toggle: Toggle,
	  },
	  on: {
	    tabMounted: function tabMounted(tabEl) {
	      var app = this;
	      $$1(tabEl).find('.toggle-init').each(function (index, toggleEl) { return app.toggle.create({ el: toggleEl }); });
	    },
	    tabBeforeRemove: function tabBeforeRemove(tabEl) {
	      $$1(tabEl).find('.toggle-init').each(function (index, toggleEl) {
	        if (toggleEl.f7Toggle) { toggleEl.f7Toggle.destroy(); }
	      });
	    },
	    pageInit: function pageInit(page) {
	      var app = this;
	      page.$el.find('.toggle-init').each(function (index, toggleEl) { return app.toggle.create({ el: toggleEl }); });
	    },
	    pageBeforeRemove: function pageBeforeRemove(page) {
	      page.$el.find('.toggle-init').each(function (index, toggleEl) {
	        if (toggleEl.f7Toggle) { toggleEl.f7Toggle.destroy(); }
	      });
	    },
	  },
	};

	var SmartSelect = (function (Framework7Class$$1) {
	  function SmartSelect(app, params) {
	    if ( params === void 0 ) params = {};

	    Framework7Class$$1.call(this, params, [app]);
	    var ss = this;
	    ss.app = app;
	    var defaults = Utils.extend({
	      on: {},
	    }, app.params.smartSelect);

	    var $el = $$1(params.el).eq(0);
	    if ($el.length === 0) { return ss; }

	    var $selectEl = $el.find('select').eq(0);
	    if ($selectEl.length === 0) { return ss; }

	    var $valueEl = $$1(params.valueEl);
	    if ($valueEl.length === 0) {
	      $valueEl = $el.find('.item-after');
	    }
	    if ($valueEl.length === 0) {
	      $valueEl = $$1('<div class="item-after"></div>');
	      $valueEl.insertAfter($el.find('.item-title'));
	    }

	    // Extend defaults with modules params
	    ss.useModulesParams(defaults);

	    // View
	    var view = params.view;
	    if (!view) {
	      view = $el.parents('.view').length && $el.parents('.view')[0].f7View;
	    }
	    if (!view) {
	      throw Error('Smart Select requires initialized View');
	    }

	    // Url
	    var url = params.url;
	    if (!url) {
	      if ($el.attr('href') && $el.attr('href') !== '#') { url = $el.attr('href'); }
	      else { url = ($selectEl.attr('name').toLowerCase()) + "-select/"; }
	    }
	    if (!url) { url = ss.params.url; }

	    var multiple = $selectEl[0].multiple;
	    var inputType = multiple ? 'checkbox' : 'radio';
	    var id = Utils.now();
	    Utils.extend(ss, {
	      params: Utils.extend(defaults, params),
	      $el: $el,
	      el: $el[0],
	      $selectEl: $selectEl,
	      selectEl: $selectEl[0],
	      $valueEl: $valueEl,
	      valueEl: $valueEl[0],
	      url: url,
	      multiple: multiple,
	      inputType: inputType,
	      id: id,
	      view: view,
	      inputName: (inputType + "-" + id),
	      selectName: $selectEl.attr('name'),
	      maxLength: $selectEl.attr('maxlength') || params.maxLength,
	    });
	    $el[0].f7SmartSelect = ss;

	    // Events
	    function onClick() {
	      ss.open();
	    }
	    function onChange() {
	      ss.setValue();
	    }
	    ss.attachEvents = function attachEvents() {
	      $el.on('click', onClick);
	      $el.on('change', 'select', onChange);
	    };
	    ss.detachEvents = function detachEvents() {
	      $el.off('click', onClick);
	      $el.off('change', 'select', onChange);
	    };

	    function handleInputChange() {
	      var optionEl;
	      var text;
	      var inputEl = this;
	      var value = inputEl.value;
	      var optionText = [];
	      var displayAs;
	      if (inputEl.type === 'checkbox') {
	        for (var i = 0; i < ss.selectEl.options.length; i += 1) {
	          optionEl = ss.selectEl.options[i];
	          if (optionEl.value === value) {
	            optionEl.selected = inputEl.checked;
	          }
	          if (optionEl.selected) {
	            displayAs = optionEl.dataset ? optionEl.dataset.displayAs : $$1(optionEl).data('display-value-as');
	            text = displayAs && typeof displayAs !== 'undefined' ? displayAs : optionEl.textContent;
	            optionText.push(text.trim());
	          }
	        }
	        if (ss.maxLength) {
	          ss.checkMaxLength();
	        }
	      } else {
	        optionEl = ss.$selectEl.find(("option[value=\"" + value + "\"]"))[0];
	        displayAs = optionEl.dataset ? optionEl.dataset.displayAs : $$1(optionEl).data('display-as');
	        text = displayAs && typeof displayAs !== 'undefined' ? displayAs : optionEl.textContent;
	        optionText = [text];
	        ss.selectEl.value = value;
	      }

	      ss.$selectEl.trigger('change');
	      ss.$valueEl.text(optionText.join(', '));
	      if (ss.params.closeOnSelect && ss.inputType === 'radio') {
	        ss.close();
	      }
	    }

	    ss.attachInputsEvents = function attachInputsEvents() {
	      ss.$containerEl.on('change', 'input[type="checkbox"], input[type="radio"]', handleInputChange);
	    };
	    ss.detachInputsEvents = function detachInputsEvents() {
	      ss.$containerEl.off('change', 'input[type="checkbox"], input[type="radio"]', handleInputChange);
	    };

	    // Install Modules
	    ss.useModules();

	    // Init
	    ss.init();

	    return ss;
	  }

	  if ( Framework7Class$$1 ) SmartSelect.__proto__ = Framework7Class$$1;
	  SmartSelect.prototype = Object.create( Framework7Class$$1 && Framework7Class$$1.prototype );
	  SmartSelect.prototype.constructor = SmartSelect;
	  SmartSelect.prototype.checkMaxLength = function checkMaxLength () {
	    var ss = this;
	    var $containerEl = ss.$containerEl;
	    if (ss.selectEl.selectedOptions.length >= ss.maxLength) {
	      $containerEl.find('input[type="checkbox"]').each(function (index, inputEl) {
	        if (!inputEl.checked) {
	          $$1(inputEl).parents('li').addClass('disabled');
	        } else {
	          $$1(inputEl).parents('li').removeClass('disabled');
	        }
	      });
	    } else {
	      $containerEl.find('.disabled').removeClass('disabled');
	    }
	  };
	  SmartSelect.prototype.setValue = function setValue (value) {
	    var ss = this;
	    var valueArray = [];
	    if (typeof value !== 'undefined') {
	      if (Array.isArray(value)) {
	        valueArray = value;
	      } else {
	        valueArray = [value];
	      }
	    } else {
	      ss.$selectEl.find('option').each(function (optionIndex, optionEl) {
	        var $optionEl = $$1(optionEl);
	        if (optionEl.selected) {
	          var displayAs = optionEl.dataset ? optionEl.dataset.displayAs : $optionEl.data('display-value-as');
	          if (displayAs && typeof displayAs !== 'undefined') {
	            valueArray.push(displayAs);
	          } else {
	            valueArray.push(optionEl.textContent.trim());
	          }
	        }
	      });
	    }
	    ss.$valueEl.text(valueArray.join(', '));
	  };
	  SmartSelect.prototype.getItemsData = function getItemsData () {
	    var ss = this;
	    var items = [];
	    var previousGroupEl;
	    ss.$selectEl.find('option').each(function (index, optionEl) {
	      var $optionEl = $$1(optionEl);
	      var optionData = $optionEl.dataset();
	      var optionImage = optionData.optionImage || ss.params.optionImage;
	      var optionIcon = optionData.optionIcon || ss.params.optionIcon;
	      var optionHasMedia = optionImage || optionIcon;
	      // if (material) optionHasMedia = optionImage || optionIcon;
	      var optionColor = optionData.optionColor;

	      var optionClassName = optionData.optionClass || '';
	      if ($optionEl[0].disabled) { optionClassName += ' disabled'; }

	      var optionGroupEl = $optionEl.parent('optgroup')[0];
	      var optionGroupLabel = optionGroupEl && optionGroupEl.label;
	      var optionIsLabel = false;
	      if (optionGroupEl && optionGroupEl !== previousGroupEl) {
	        optionIsLabel = true;
	        previousGroupEl = optionGroupEl;
	        items.push({
	          groupLabel: optionGroupLabel,
	          isLabel: optionIsLabel,
	        });
	      }
	      items.push({
	        value: $optionEl[0].value,
	        text: $optionEl[0].textContent.trim(),
	        selected: $optionEl[0].selected,
	        groupEl: optionGroupEl,
	        groupLabel: optionGroupLabel,
	        image: optionImage,
	        icon: optionIcon,
	        color: optionColor,
	        className: optionClassName,
	        disabled: $optionEl[0].disabled,
	        id: ss.id,
	        hasMedia: optionHasMedia,
	        checkbox: ss.inputType === 'checkbox',
	        radio: ss.inputType === 'radio',
	        inputName: ss.inputName,
	        inputType: ss.inputType,
	      });
	    });
	    ss.items = items;
	    return items;
	  };
	  SmartSelect.prototype.renderSearchbar = function renderSearchbar () {
	    var ss = this;
	    if (ss.params.renderSearchbar) { return ss.params.renderSearchbar.call(ss); }
	    var searchbarHTML = "\n      <form class=\"searchbar\">\n        <div class=\"searchbar-inner\">\n          <div class=\"searchbar-input-wrap\">\n            <input type=\"search\" placeholder=\"" + (ss.params.searchbarPlaceholder) + "\"/>\n            <i class=\"searchbar-icon\"></i>\n            <span class=\"input-clear-button\"></span>\n          </div>\n          <span class=\"searchbar-disable-button\">" + (ss.params.searchbarDisableText) + "</span>\n        </div>\n      </form>\n    ";
	    return searchbarHTML;
	  };
	  SmartSelect.prototype.renderItem = function renderItem (item, index) {
	    var ss = this;
	    if (ss.params.renderItem) { return ss.params.renderItem.call(ss, item, index); }
	    var itemHtml;
	    if (item.isLabel) {
	      itemHtml = "<li class=\"item-divider\">" + (item.groupLabel) + "</li>";
	    } else {
	      itemHtml = "\n        <li class=\"" + (item.className || '') + "\">\n          <label class=\"item-" + (item.inputType) + " item-content\">\n            <input type=\"" + (item.inputType) + "\" name=\"" + (item.inputName) + "\" value=\"" + (item.value) + "\" " + (item.selected ? 'checked' : '') + "/>\n            <i class=\"icon icon-" + (item.inputType) + "\"></i>\n            " + (item.hasMedia ? ("\n              <div class=\"item-media\">\n                " + (item.icon ? ("<i class=\"icon " + (item.icon) + "\"></i>") : '') + "\n                " + (item.image ? ("<img src=\"" + (item.image) + "\">") : '') + "\n              </div>\n            ") : '') + "\n            <div class=\"item-inner\">\n              <div class=\"item-title" + (item.color ? (" color-" + (item.color)) : '') + "\">" + (item.text) + "</div>\n            </div>\n          </label>\n        </li>\n      ";
	    }
	    return itemHtml;
	  };
	  SmartSelect.prototype.renderItems = function renderItems () {
	    var ss = this;
	    if (ss.params.renderItems) { return ss.params.renderItems.call(ss, ss.items); }
	    var itemsHtml = "\n      " + (ss.items.map(function (item, index) { return ("" + (ss.renderItem(item, index))); }).join('')) + "\n    ";
	    return itemsHtml;
	  };
	  SmartSelect.prototype.renderPage = function renderPage () {
	    var ss = this;
	    if (ss.params.renderPage) { return ss.params.renderPage.call(ss, ss.items); }
	    var pageTitle = ss.params.pageTitle;
	    if (typeof pageTitle === 'undefined') {
	      pageTitle = ss.$el.find('.item-title').text().trim();
	    }
	    var pageHtml = "\n      <div class=\"page smart-select-page\" data-name=\"smart-select-page\" data-select-name=\"" + (ss.selectName) + "\">\n        <div class=\"navbar " + (ss.params.navbarColorTheme ? ("color-theme-" + (ss.params.navbarColorTheme)) : '') + "\">\n          <div class=\"navbar-inner sliding " + (ss.params.navbarColorTheme ? ("color-theme-" + (ss.params.navbarColorTheme)) : '') + "\">\n            <div class=\"left\">\n              <a href=\"#\" class=\"link back\">\n                <i class=\"icon icon-back\"></i>\n                <span class=\"ios-only\">" + (ss.params.pageBackLinkText) + "</span>\n              </a>\n            </div>\n            " + (pageTitle ? ("<div class=\"title\">" + pageTitle + "</div>") : '') + "\n            " + (ss.params.searchbar ? ("<div class=\"subnavbar\">" + (ss.renderSearchbar()) + "</div>") : '') + "\n          </div>\n        </div>\n        " + (ss.params.searchbar ? '<div class="searchbar-backdrop"></div>' : '') + "\n        <div class=\"page-content\">\n          <div class=\"list smart-select-list-" + (ss.id) + " " + (ss.params.virtualList ? ' virtual-list' : '') + " " + (ss.params.formColorTheme ? ("color-theme-" + (ss.params.formColorTheme)) : '') + "\">\n            <ul>" + (!ss.params.virtualList && ss.renderItems(ss.items)) + "</ul>\n          </div>\n        </div>\n      </div>\n    ";
	    return pageHtml;
	  };
	  SmartSelect.prototype.renderPopup = function renderPopup () {
	    var ss = this;
	    if (ss.params.renderPopup) { return ss.params.renderPopup.call(ss, ss.items); }
	    var pageTitle = ss.params.pageTitle;
	    if (typeof pageTitle === 'undefined') {
	      pageTitle = ss.$el.find('.item-title').text().trim();
	    }
	    var popupHtml = "\n      <div class=\"popup smart-select-popup\" data-select-name=\"" + (ss.selectName) + "\">\n        <div class=\"view\">\n          <div class=\"page smart-select-page " + (ss.params.searchbar ? 'page-with-subnavbar' : '') + "\" data-name=\"smart-select-page\">\n            <div class=\"navbar" + (ss.params.navbarColorTheme ? ("theme-" + (ss.params.navbarColorTheme)) : '') + "\">\n              <div class=\"navbar-inner sliding\">\n                <div class=\"left\">\n                  <a href=\"#\" class=\"link popup-close\">\n                    <i class=\"icon icon-back\"></i>\n                    <span class=\"ios-only\">" + (ss.params.popupCloseLinkText) + "</span>\n                  </a>\n                </div>\n                " + (pageTitle ? ("<div class=\"title\">" + pageTitle + "</div>") : '') + "\n                " + (ss.params.searchbar ? ("<div class=\"subnavbar\">" + (ss.renderSearchbar()) + "</div>") : '') + "\n              </div>\n            </div>\n            " + (ss.params.searchbar ? '<div class="searchbar-backdrop"></div>' : '') + "\n            <div class=\"page-content\">\n              <div class=\"list smart-select-list-" + (ss.id) + " " + (ss.params.virtualList ? ' virtual-list' : '') + (ss.params.formColorTheme ? ("theme-" + (ss.params.formColorTheme)) : '') + "\">\n                <ul>" + (!ss.params.virtualList && ss.renderItems(ss.items)) + "</ul>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    ";
	    return popupHtml;
	  };
	  SmartSelect.prototype.renderSheet = function renderSheet () {
	    var ss = this;
	    if (ss.params.renderSheet) { return ss.params.renderSheet.call(ss, ss.items); }
	    var sheetHtml = "\n      <div class=\"sheet-modal smart-select-sheet\" data-select-name=\"" + (ss.selectName) + "\">\n        <div class=\"toolbar " + (ss.params.toolbarColorTheme ? ("theme-" + (ss.params.toolbarColorTheme)) : '') + "\">\n          <div class=\"toolbar-inner\">\n            <div class=\"left\"></div>\n            <div class=\"right\">\n              <a class=\"link sheet-close\">" + (ss.params.sheetCloseLinkText) + "</a>\n            </div>\n          </div>\n        </div>\n        <div class=\"sheet-modal-inner\">\n          <div class=\"page-content\">\n            <div class=\"list smart-select-list-" + (ss.id) + " " + (ss.params.virtualList ? ' virtual-list' : '') + (ss.params.formColorTheme ? ("theme-" + (ss.params.formColorTheme)) : '') + "\">\n              <ul>" + (!ss.params.virtualList && ss.renderItems(ss.items)) + "</ul>\n            </div>\n          </div>\n        </div>\n      </div>\n    ";
	    return sheetHtml;
	  };
	  SmartSelect.prototype.renderPopover = function renderPopover () {
	    var ss = this;
	    if (ss.params.renderPopover) { return ss.params.renderPopover.call(ss, ss.items); }
	    var popoverHtml = "\n      <div class=\"popover smart-select-popover\" data-select-name=\"" + (ss.selectName) + "\">\n        <div class=\"popover-inner\">\n          <div class=\"list smart-select-list-" + (ss.id) + " " + (ss.params.virtualList ? ' virtual-list' : '') + (ss.params.formColorTheme ? ("theme-" + (ss.params.formColorTheme)) : '') + "\">\n            <ul>" + (!ss.params.virtualList && ss.renderItems(ss.items)) + "</ul>\n          </div>\n        </div>\n      </div>\n    ";
	    return popoverHtml;
	  };
	  SmartSelect.prototype.onOpen = function onOpen (type, containerEl) {
	    var ss = this;
	    var app = ss.app;
	    var $containerEl = $$1(containerEl);
	    ss.$containerEl = $containerEl;
	    ss.openedIn = type;
	    ss.opened = true;

	    // Init VL
	    if (ss.params.virtualList) {
	      ss.vl = app.virtualList.create({
	        el: $containerEl.find('.virtual-list'),
	        items: ss.items,
	        renderItem: ss.renderItem.bind(ss),
	        height: ss.params.virtualListHeight,
	        searchByItem: function searchByItem(query, item) {
	          if (item.text && item.text.toLowerCase().indexOf(query.trim().toLowerCase()) >= 0) { return true; }
	          return false;
	        },
	      });
	    }

	    // Init SB
	    if (ss.params.searchbar) {
	      var $searchbarEl = $containerEl.find('.searchbar');
	      if (type === 'page' && app.theme === 'ios') {
	        $searchbarEl = $$1(app.navbar.getElByPage($containerEl)).find('.searchbar');
	      }
	      ss.searchbar = app.searchbar.create({
	        el: $searchbarEl,
	        backdropEl: $containerEl.find('.searchbar-backdrop'),
	        searchContainer: (".smart-select-list-" + (ss.id)),
	        searchIn: '.item-title',
	      });
	    }

	    // Check for max length
	    if (ss.maxLength) {
	      ss.checkMaxLength();
	    }

	    // Close on select
	    if (ss.params.closeOnSelect) {
	      ss.$containerEl.find(("input[type=\"radio\"][name=\"" + (ss.inputName) + "\"]:checked")).parents('label').once('click', function () {
	        ss.close();
	      });
	    }

	    // Attach input events
	    ss.attachInputsEvents();

	    ss.$el.trigger('smartselect:open', ss);
	    ss.emit('local::open smartSelectOpen', ss);
	  };
	  SmartSelect.prototype.onOpened = function onOpened () {
	    var ss = this;

	    ss.$el.trigger('smartselect:opened', ss);
	    ss.emit('local::opened smartSelectOpened', ss);
	  };
	  SmartSelect.prototype.onClose = function onClose () {
	    var ss = this;
	    if (ss.destroyed) { return; }

	    // Destroy VL
	    if (ss.vl && ss.vl.destroy) {
	      ss.vl.destroy();
	      ss.vl = null;
	      delete ss.vl;
	    }

	    // Destroy SB
	    if (ss.searchbar && ss.searchbar.destroy) {
	      ss.searchbar.destroy();
	      ss.searchbar = null;
	      delete ss.searchbar;
	    }
	    // Detach events
	    ss.detachInputsEvents();

	    ss.$el.trigger('smartselect:close', ss);
	    ss.emit('local::close smartSelectClose', ss);
	  };
	  SmartSelect.prototype.onClosed = function onClosed () {
	    var ss = this;
	    if (ss.destroyed) { return; }
	    ss.opened = false;
	    ss.$containerEl = null;
	    delete ss.$containerEl;

	    ss.$el.trigger('smartselect:closed', ss);
	    ss.emit('local::closed smartSelectClosed', ss);
	  };
	  SmartSelect.prototype.openPage = function openPage () {
	    var ss = this;
	    if (ss.opened) { return ss; }
	    ss.getItemsData();
	    var pageHtml = ss.renderPage(ss.items);

	    ss.view.router.navigate({
	      url: ss.url,
	      route: {
	        content: pageHtml,
	        path: ss.url,
	        on: {
	          pageBeforeIn: function pageBeforeIn(e, page) {
	            ss.onOpen('page', page.el);
	          },
	          pageAfterIn: function pageAfterIn(e, page) {
	            ss.onOpened('page', page.el);
	          },
	          pageBeforeOut: function pageBeforeOut(e, page) {
	            ss.onClose('page', page.el);
	          },
	          pageAfterOut: function pageAfterOut(e, page) {
	            ss.onClosed('page', page.el);
	          },
	        },
	      },
	    });
	    return ss;
	  };
	  SmartSelect.prototype.openPopup = function openPopup () {
	    var ss = this;
	    if (ss.opened) { return ss; }
	    ss.getItemsData();
	    var popupHtml = ss.renderPopup(ss.items);

	    var popupParams = {
	      content: popupHtml,
	      on: {
	        popupOpen: function popupOpen(popup) {
	          ss.onOpen('popup', popup.el);
	        },
	        popupOpened: function popupOpened(popup) {
	          ss.onOpened('popup', popup.el);
	        },
	        popupClose: function popupClose(popup) {
	          ss.onClose('popup', popup.el);
	        },
	        popupClosed: function popupClosed(popup) {
	          ss.onClosed('popup', popup.el);
	        },
	      },
	    };

	    if (ss.params.routableModals) {
	      ss.view.router.navigate({
	        url: ss.url,
	        route: {
	          path: ss.url,
	          popup: popupParams,
	        },
	      });
	    } else {
	      ss.modal = ss.app.popup.create(popupParams).open();
	    }
	    return ss;
	  };
	  SmartSelect.prototype.openSheet = function openSheet () {
	    var ss = this;
	    if (ss.opened) { return ss; }
	    ss.getItemsData();
	    var sheetHtml = ss.renderSheet(ss.items);

	    var sheetParams = {
	      content: sheetHtml,
	      backdrop: false,
	      scrollToEl: ss.$el,
	      closeByOutsideClick: true,
	      on: {
	        sheetOpen: function sheetOpen(sheet) {
	          ss.onOpen('sheet', sheet.el);
	        },
	        sheetOpened: function sheetOpened(sheet) {
	          ss.onOpened('sheet', sheet.el);
	        },
	        sheetClose: function sheetClose(sheet) {
	          ss.onClose('sheet', sheet.el);
	        },
	        sheetClosed: function sheetClosed(sheet) {
	          ss.onClosed('sheet', sheet.el);
	        },
	      },
	    };

	    if (ss.params.routableModals) {
	      ss.view.router.navigate({
	        url: ss.url,
	        route: {
	          path: ss.url,
	          sheet: sheetParams,
	        },
	      });
	    } else {
	      ss.modal = ss.app.sheet.create(sheetParams).open();
	    }
	    return ss;
	  };
	  SmartSelect.prototype.openPopover = function openPopover () {
	    var ss = this;
	    if (ss.opened) { return ss; }
	    ss.getItemsData();
	    var popoverHtml = ss.renderPopover(ss.items);
	    var popoverParams = {
	      content: popoverHtml,
	      targetEl: ss.$el,
	      on: {
	        popoverOpen: function popoverOpen(popover) {
	          ss.onOpen('popover', popover.el);
	        },
	        popoverOpened: function popoverOpened(popover) {
	          ss.onOpened('popover', popover.el);
	        },
	        popoverClose: function popoverClose(popover) {
	          ss.onClose('popover', popover.el);
	        },
	        popoverClosed: function popoverClosed(popover) {
	          ss.onClosed('popover', popover.el);
	        },
	      },
	    };
	    if (ss.params.routableModals) {
	      ss.view.router.navigate({
	        url: ss.url,
	        route: {
	          path: ss.url,
	          popover: popoverParams,
	        },
	      });
	    } else {
	      ss.modal = ss.app.popover.create(popoverParams).open();
	    }
	    return ss;
	  };
	  SmartSelect.prototype.open = function open (type) {
	    var ss = this;
	    if (ss.opened) { return ss; }
	    var openIn = type || ss.params.openIn;
	    ss[("open" + (openIn.split('').map(function (el, index) {
	      if (index === 0) { return el.toUpperCase(); }
	      return el;
	    }).join('')))]();
	    return ss;
	  };
	  SmartSelect.prototype.close = function close () {
	    var ss = this;
	    if (!ss.opened) { return ss; }
	    if (ss.params.routableModals || ss.openedIn === 'page') {
	      ss.view.router.back();
	    } else {
	      ss.modal.once('modalClosed', function () {
	        Utils.nextTick(function () {
	          ss.modal.destroy();
	          delete ss.modal;
	        });
	      });
	      ss.modal.close();
	    }
	    return ss;
	  };
	  SmartSelect.prototype.init = function init () {
	    var ss = this;
	    ss.attachEvents();
	    ss.setValue();
	  };
	  SmartSelect.prototype.destroy = function destroy () {
	    var ss = this;
	    ss.emit('local::beforeDestroy smartSelectBeforeDestroy', ss);
	    ss.$el.trigger('smartselect:beforedestroy', ss);
	    ss.detachEvents();
	    delete ss.$el[0].f7SmartSelect;
	    Utils.deleteProps(ss);
	    ss.destroyed = true;
	  };

	  return SmartSelect;
	}(Framework7Class));

	var SmartSelect$1 = {
	  name: 'smartSelect',
	  params: {
	    smartSelect: {
	      el: undefined,
	      valueEl: undefined,
	      openIn: 'page', // or 'popup' or 'sheet' or 'popover'
	      pageTitle: undefined,
	      pageBackLinkText: 'Back',
	      popupCloseLinkText: 'Close',
	      sheetCloseLinkText: 'Done',
	      searchbar: false,
	      searchbarPlaceholder: 'Search',
	      searchbarDisableText: 'Cancel',
	      closeOnSelect: false,
	      virtualList: false,
	      virtualListHeight: undefined,
	      formColorTheme: undefined,
	      navbarColorTheme: undefined,
	      routableModals: true,
	      url: 'select/',
	      /*
	        Custom render functions
	      */
	      renderPage: undefined,
	      renderPopup: undefined,
	      renderSheet: undefined,
	      renderPopover: undefined,
	      renderItems: undefined,
	      renderItem: undefined,
	      renderSearchbar: undefined,
	    },
	  },
	  static: {
	    SmartSelect: SmartSelect,
	  },
	  create: function create() {
	    var app = this;
	    app.smartSelect = Utils.extend(
	      ConstructorMethods({
	        defaultSelector: '.smart-select',
	        constructor: SmartSelect,
	        app: app,
	        domProp: 'f7SmartSelect',
	      }),
	      {
	        open: function open(smartSelectEl) {
	          var ss = app.smartSelect.get(smartSelectEl);
	          if (ss && ss.open) { return ss.open(); }
	          return undefined;
	        },
	        close: function close(smartSelectEl) {
	          var ss = app.smartSelect.get(smartSelectEl);
	          if (ss && ss.close) { return ss.close(); }
	          return undefined;
	        },
	      }
	    );
	  },

	  on: {
	    tabMounted: function tabMounted(tabEl) {
	      var app = this;
	      $$1(tabEl).find('.smart-select-init').each(function (index, smartSelectEl) {
	        app.smartSelect.create(Utils.extend({ el: smartSelectEl }, $$1(smartSelectEl).dataset()));
	      });
	    },
	    tabBeforeRemove: function tabBeforeRemove(tabEl) {
	      $$1(tabEl).find('.smart-select-init').each(function (index, smartSelectEl) {
	        if (smartSelectEl.f7SmartSelect && smartSelectEl.f7SmartSelect.destroy) {
	          smartSelectEl.f7SmartSelect.destroy();
	        }
	      });
	    },
	    pageInit: function pageInit(page) {
	      var app = this;
	      page.$el.find('.smart-select-init').each(function (index, smartSelectEl) {
	        app.smartSelect.create(Utils.extend({ el: smartSelectEl }, $$1(smartSelectEl).dataset()));
	      });
	    },
	    pageBeforeRemove: function pageBeforeRemove(page) {
	      page.$el.find('.smart-select-init').each(function (index, smartSelectEl) {
	        if (smartSelectEl.f7SmartSelect && smartSelectEl.f7SmartSelect.destroy) {
	          smartSelectEl.f7SmartSelect.destroy();
	        }
	      });
	    },
	  },
	  clicks: {
	    '.smart-select': function open($clickedEl, data) {
	      var app = this;
	      if (!$clickedEl[0].f7SmartSelect) {
	        var ss = app.smartSelect.create(Utils.extend({ el: $clickedEl }, data));
	        ss.open();
	      }
	    },
	  },
	};

	var InfiniteScroll = {
	  handleScroll: function handleScroll(el, e) {
	    var app = this;
	    var $el = $$1(el);
	    var scrollTop = $el[0].scrollTop;
	    var scrollHeight = $el[0].scrollHeight;
	    var height = $el[0].offsetHeight;
	    var distance = $el[0].getAttribute('data-infinite-distance');

	    var virtualListContainer = $el.find('.virtual-list');
	    var virtualList;

	    var onTop = $el.hasClass('infinite-scroll-top');
	    if (!distance) { distance = 50; }
	    if (typeof distance === 'string' && distance.indexOf('%') >= 0) {
	      distance = (parseInt(distance, 10) / 100) * height;
	    }
	    if (distance > height) { distance = height; }
	    if (onTop) {
	      if (scrollTop < distance) {
	        $el.trigger('infinite', e);
	        app.emit('infinite', $el[0], e);
	      }
	    } else if (scrollTop + height >= scrollHeight - distance) {
	      if (virtualListContainer.length > 0) {
	        virtualList = virtualListContainer.eq(-1)[0].f7VirtualList;
	        if (virtualList && !virtualList.reachEnd && !virtualList.params.updatableScroll) {
	          return;
	        }
	      }
	      $el.trigger('infinite', e);
	      app.emit('infinite', $el[0], e);
	    }
	  },
	  create: function create(el) {
	    var $el = $$1(el);
	    var app = this;
	    $el.on('scroll', function handle(e) {
	      app.infiniteScroll.handle(this, e);
	    });
	  },
	  destroy: function destroy(el) {
	    var $el = $$1(el);
	    $el.off('scroll');
	  },
	};
	var InfiniteScroll$1 = {
	  name: 'infiniteScroll',
	  create: function create() {
	    var app = this;
	    Utils.extend(app, {
	      infiniteScroll: {
	        handle: InfiniteScroll.handleScroll.bind(app),
	        create: InfiniteScroll.create.bind(app),
	        destroy: InfiniteScroll.destroy.bind(app),
	      },
	    });
	  },
	  on: {
	    tabMounted: function tabMounted(tabEl) {
	      var app = this;
	      var $tabEl = $$1(tabEl);
	      $tabEl.find('.infinite-scroll-content').each(function (index, el) {
	        app.infiniteScroll.create(el);
	      });
	    },
	    tabBeforeRemove: function tabBeforeRemove(tabEl) {
	      var $tabEl = $$1(tabEl);
	      var app = this;
	      $tabEl.find('.infinite-scroll-content').each(function (index, el) {
	        app.infiniteScroll.destroy(el);
	      });
	    },
	    pageInit: function pageInit(page) {
	      var app = this;
	      page.$el.find('.infinite-scroll-content').each(function (index, el) {
	        app.infiniteScroll.create(el);
	      });
	    },
	    pageBeforeRemove: function pageBeforeRemove(page) {
	      var app = this;
	      page.$el.find('.infinite-scroll-content').each(function (index, el) {
	        app.infiniteScroll.destroy(el);
	      });
	    },
	  },
	};

	var Lazy = {
	  destroy: function destroy(pageEl) {
	    var $pageEl = $$1(pageEl).closest('.page');
	    if (!$pageEl.length) { return; }
	    if ($pageEl[0].f7LazyDestroy) {
	      $pageEl[0].f7LazyDestroy();
	    }
	  },
	  create: function create(pageEl) {
	    var app = this;
	    var $pageEl = $$1(pageEl).closest('.page').eq(0);

	    // Lazy images
	    var lazyLoadImages = $pageEl.find('.lazy');
	    if (lazyLoadImages.length === 0 && !$pageEl.hasClass('lazy')) { return; }

	    // Placeholder
	    var placeholderSrc = app.params.lazy.placeholder;

	    if (placeholderSrc !== false) {
	      lazyLoadImages.each(function (index, lazyEl) {
	        if ($$1(lazyEl).attr('data-src') && !$$1(lazyEl).attr('src')) { $$1(lazyEl).attr('src', placeholderSrc); }
	      });
	    }

	    // load image
	    var imagesSequence = [];
	    var imageIsLoading = false;

	    function onImageComplete(lazyEl) {
	      if (imagesSequence.indexOf(lazyEl) >= 0) {
	        imagesSequence.splice(imagesSequence.indexOf(lazyEl), 1);
	      }
	      imageIsLoading = false;
	      if (app.params.lazy.sequential && imagesSequence.length > 0) {
	        imageIsLoading = true;
	        app.lazy.loadImage(imagesSequence[0], onImageComplete);
	      }
	    }

	    function lazyHandler() {
	      app.lazy.load($pageEl, function (lazyEl) {
	        if (app.params.lazy.sequential && imageIsLoading) {
	          if (imagesSequence.indexOf(lazyEl) < 0) { imagesSequence.push(lazyEl); }
	          return;
	        }
	        imageIsLoading = true;
	        app.lazy.loadImage(lazyEl, onImageComplete);
	      });
	    }

	    function attachEvents() {
	      $pageEl[0].f7LazyAttached = true;
	      $pageEl.on('lazy', lazyHandler);
	      $pageEl.on('scroll', lazyHandler, true);
	      $pageEl.find('.tab').on('tab:mounted tab:show', lazyHandler);
	      app.on('resize', lazyHandler);
	    }
	    function detachEvents() {
	      $pageEl[0].f7LazyAttached = false;
	      delete $pageEl[0].f7LazyAttached;
	      $pageEl.off('lazy', lazyHandler);
	      $pageEl.off('scroll', lazyHandler, true);
	      $pageEl.find('.tab').off('tab:mounted tab:show', lazyHandler);
	      app.off('resize', lazyHandler);
	    }

	    // Store detach function
	    if (!$pageEl[0].f7LazyDestroy) {
	      $pageEl[0].f7LazyDestroy = detachEvents;
	    }

	    // Attach events
	    if (!$pageEl[0].f7LazyAttached) {
	      attachEvents();
	    }

	    // Run loader on page load/init
	    lazyHandler();
	  },
	  isInViewport: function isInViewport(lazyEl) {
	    var app = this;
	    var rect = lazyEl.getBoundingClientRect();
	    var threshold = app.params.lazy.threshold || 0;

	    return (
	      rect.top >= (0 - threshold) &&
	      rect.left >= (0 - threshold) &&
	      rect.top <= (app.height + threshold) &&
	      rect.left <= (app.width + threshold)
	    );
	  },
	  loadImage: function loadImage(imageEl, callback) {
	    var app = this;
	    var $imageEl = $$1(imageEl);

	    var bg = $imageEl.attr('data-background');
	    var src = bg || $imageEl.attr('data-src');
	    if (!src) { return; }
	    function onLoad() {
	      $imageEl.removeClass('lazy').addClass('lazy-loaded');
	      if (bg) {
	        $imageEl.css('background-image', ("url(" + src + ")"));
	      } else {
	        $imageEl.attr('src', src);
	      }
	      if (callback) { callback(imageEl); }
	      $imageEl.trigger('lazy:loaded');
	      app.emit('lazyLoaded', $imageEl[0]);
	    }

	    function onError() {
	      $imageEl.removeClass('lazy').addClass('lazy-loaded');
	      if (bg) {
	        $imageEl.css('background-image', ("url(" + (app.params.lazy.placeholder || '') + ")"));
	      } else {
	        $imageEl.attr('src', app.params.lazy.placeholder || '');
	      }
	      if (callback) { callback(imageEl); }
	      $imageEl.trigger('lazy:error');
	      app.emit('lazyError', $imageEl[0]);
	    }
	    var image = new win.Image();
	    image.onload = onLoad;
	    image.onerror = onError;
	    image.src = src;

	    $imageEl.removeAttr('data-src').removeAttr('data-background');

	    // Add loaded callback and events
	    $imageEl.trigger('lazy:load');
	    app.emit('lazyLoad', $imageEl[0]);
	  },
	  load: function load(pageEl, callback) {
	    var app = this;
	    var $pageEl = $$1(pageEl);
	    if (!$pageEl.hasClass('page')) { $pageEl = $pageEl.parents('.page').eq(0); }
	    if ($pageEl.length === 0) {
	      return;
	    }
	    $pageEl.find('.lazy').each(function (index, lazyEl) {
	      var $lazyEl = $$1(lazyEl);
	      if ($lazyEl.parents('.tab:not(.tab-active)').length > 0) {
	        return;
	      }
	      if (app.lazy.isInViewport(lazyEl)) {
	        if (callback) { callback(lazyEl); }
	        else { app.lazy.loadImage(lazyEl); }
	      }
	    });
	  },

	};
	var Lazy$1 = {
	  name: 'lazy',
	  params: {
	    lazy: {
	      placeholder: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABAQMAAAAl21bKAAAAA1BMVEXCwsK592mkAAAACklEQVQI12NgAAAAAgAB4iG8MwAAAABJRU5ErkJggg==',
	      threshold: 0,
	      sequential: true,
	    },
	  },
	  create: function create() {
	    var app = this;
	    Utils.extend(app, {
	      lazy: {
	        create: Lazy.create.bind(app),
	        destroy: Lazy.destroy.bind(app),
	        loadImage: Lazy.loadImage.bind(app),
	        load: Lazy.load.bind(app),
	        isInViewport: Lazy.isInViewport.bind(app),
	      },
	    });
	  },
	  on: {
	    pageInit: function pageInit(page) {
	      var app = this;
	      if (page.$el.find('.lazy').length > 0 || page.$el.hasClass('lazy')) {
	        app.lazy.create(page.$el);
	      }
	    },
	    pageAfterIn: function pageAfterIn(page) {
	      var app = this;
	      if (page.$el.find('.lazy').length > 0 || page.$el.hasClass('lazy')) {
	        app.lazy.create(page.$el);
	      }
	    },
	    pageBeforeRemove: function pageBeforeRemove(page) {
	      var app = this;
	      if (page.$el.find('.lazy').length > 0 || page.$el.hasClass('lazy')) {
	        app.lazy.destroy(page.$el);
	      }
	    },
	    tabMounted: function tabMounted(tabEl) {
	      var app = this;
	      var $tabEl = $$1(tabEl);
	      if ($tabEl.find('.lazy').length > 0 || $tabEl.hasClass('lazy')) {
	        app.lazy.create($tabEl);
	      }
	    },
	    tabBeforeRemove: function tabBeforeRemove(tabEl) {
	      var app = this;
	      var $tabEl = $$1(tabEl);
	      if ($tabEl.find('.lazy').length > 0 || $tabEl.hasClass('lazy')) {
	        app.lazy.destroy($tabEl);
	      }
	    },
	  },
	};

	var Searchbar = (function (FrameworkClass) {
	  function Searchbar(app, params) {
	    if ( params === void 0 ) params = {};

	    FrameworkClass.call(this, params, [app]);

	    var sb = this;

	    var defaults = {
	      el: undefined,
	      inputEl: undefined,
	      disableButton: true,
	      disableButtonEl: undefined,
	      backdropEl: undefined,
	      searchContainer: undefined, // container to search, HTMLElement or CSS selector
	      searchItem: 'li', // single item selector, CSS selector
	      searchIn: undefined, // where to search in item, CSS selector
	      ignore: '.searchbar-ignore',
	      foundEl: '.searchbar-found',
	      notFoundEl: '.searchbar-not-found',
	      hideOnEnableEl: '.searchbar-hide-on-enable',
	      hideOnSearchEl: '.searchbar-hide-on-search',
	      backdrop: true,
	      removeDiacritics: true,
	      customSearch: false,
	      hideDividers: true,
	      hideGroups: true,
	      disableOnBackdropClick: true,
	      expandable: false,
	    };

	    // Extend defaults with modules params
	    sb.useModulesParams(defaults);

	    sb.params = Utils.extend(defaults, params);

	    var $el = $$1(sb.params.el);
	    if ($el.length === 0) { return sb; }

	    $el[0].f7Searchbar = sb;

	    var $pageEl;
	    var $navbarEl;
	    if ($el.parents('.page').length > 0) {
	      $pageEl = $el.parents('.page');
	    } else {
	      $navbarEl = $el.parents('.navbar-inner');
	      if ($navbarEl.length > 0) {
	        if ($navbarEl[0].f7Page) {
	          $pageEl = $navbarEl[0].f7Page.$el;
	        } else {
	          var $currentPageEl = $el.parents('.view').find('.page-current');
	          if ($currentPageEl[0] && $currentPageEl[0].f7Page && $currentPageEl[0].f7Page.navbarEl === $navbarEl[0]) {
	            $pageEl = $currentPageEl;
	          }
	        }
	      }
	    }

	    var $foundEl;
	    if (params.foundEl) {
	      $foundEl = $$1(params.foundEl);
	    } else if (typeof sb.params.foundEl === 'string' && $pageEl) {
	      $foundEl = $pageEl.find(sb.params.foundEl);
	    }

	    var $notFoundEl;
	    if (params.notFoundEl) {
	      $notFoundEl = $$1(params.notFoundEl);
	    } else if (typeof sb.params.notFoundEl === 'string' && $pageEl) {
	      $notFoundEl = $pageEl.find(sb.params.notFoundEl);
	    }

	    var $hideOnEnableEl;
	    if (params.hideOnEnableEl) {
	      $hideOnEnableEl = $$1(params.hideOnEnableEl);
	    } else if (typeof sb.params.hideOnEnableEl === 'string' && $pageEl) {
	      $hideOnEnableEl = $pageEl.find(sb.params.hideOnEnableEl);
	    }

	    var $hideOnSearchEl;
	    if (params.hideOnSearchEl) {
	      $hideOnSearchEl = $$1(params.hideOnSearchEl);
	    } else if (typeof sb.params.hideOnSearchEl === 'string' && $pageEl) {
	      $hideOnSearchEl = $pageEl.find(sb.params.hideOnSearchEl);
	    }

	    var $backdropEl;
	    if (sb.params.backdrop) {
	      if (sb.params.backdropEl) {
	        $backdropEl = $$1(sb.params.backdropEl);
	      } else if ($pageEl && $pageEl.length > 0) {
	        $backdropEl = $pageEl.find('.searchbar-backdrop');
	      } else {
	        $backdropEl = $el.siblings('.searchbar-backdrop');
	      }
	      if ($backdropEl.length === 0) {
	        $backdropEl = $$1('<div class="searchbar-backdrop"></div>');
	        if ($pageEl && $pageEl.length) {
	          if ($el.parents($pageEl).length > 0 && $navbarEl && $el.parents($navbarEl).length === 0) {
	            $backdropEl.insertBefore($el);
	          } else {
	            $backdropEl.insertBefore($pageEl.find('.page-content').eq(0));
	          }
	        } else {
	          $backdropEl.insertBefore($el);
	        }
	      }
	    }

	    var $searchContainer;
	    if (sb.params.searchContainer) {
	      $searchContainer = $$1(sb.params.searchContainer);
	    }

	    var $inputEl;
	    if (sb.params.inputEl) {
	      $inputEl = $$1(sb.params.inputEl);
	    } else {
	      $inputEl = $el.find('input[type="search"]').eq(0);
	    }

	    var $disableButtonEl;
	    if (sb.params.disableButton) {
	      if (sb.params.disableButtonEl) {
	        $disableButtonEl = $$1(sb.params.disableButtonEl);
	      } else {
	        $disableButtonEl = $el.find('.searchbar-disable-button');
	      }
	    }

	    Utils.extend(sb, {
	      app: app,
	      view: app.views.get($el.parents('.view')),
	      $el: $el,
	      el: $el[0],
	      $backdropEl: $backdropEl,
	      backdropEl: $backdropEl && $backdropEl[0],
	      $searchContainer: $searchContainer,
	      searchContainer: $searchContainer && $searchContainer[0],
	      $inputEl: $inputEl,
	      inputEl: $inputEl[0],
	      $disableButtonEl: $disableButtonEl,
	      disableButtonEl: $disableButtonEl && $disableButtonEl[0],
	      disableButtonHasMargin: false,
	      $pageEl: $pageEl,
	      pageEl: $pageEl && $pageEl[0],
	      $navbarEl: $navbarEl,
	      navbarEl: $navbarEl && $navbarEl[0],
	      $foundEl: $foundEl,
	      foundEl: $foundEl && $foundEl[0],
	      $notFoundEl: $notFoundEl,
	      notFoundEl: $notFoundEl && $notFoundEl[0],
	      $hideOnEnableEl: $hideOnEnableEl,
	      hideOnEnableEl: $hideOnEnableEl && $hideOnEnableEl[0],
	      $hideOnSearchEl: $hideOnSearchEl,
	      hideOnSearchEl: $hideOnSearchEl && $hideOnSearchEl[0],
	      previousQuery: '',
	      query: '',
	      isVirtualList: $searchContainer && $searchContainer.hasClass('virtual-list'),
	      virtualList: undefined,
	      enabled: false,
	      expandable: sb.params.expandable || $el.hasClass('searchbar-expandable'),
	    });

	    // Events
	    function preventSubmit(e) {
	      e.preventDefault();
	    }
	    function onInputFocus(e) {
	      sb.enable(e);
	      sb.$el.addClass('searchbar-focused');
	    }
	    function onInputBlur() {
	      sb.$el.removeClass('searchbar-focused');
	    }
	    function onInputChange() {
	      var value = sb.$inputEl.val().trim();
	      if (
	        (
	          (sb.$searchContainer && sb.$searchContainer.length > 0) &&
	          (sb.params.searchIn || sb.isVirtualList || sb.params.searchIn === sb.params.searchItem)
	        ) ||
	        sb.params.customSearch
	      ) {
	        sb.search(value, true);
	      }
	    }
	    function onInputClear(e, previousValue) {
	      sb.$el.trigger('searchbar:clear', previousValue);
	      sb.emit('local::clear searchbarClear', sb, previousValue);
	    }
	    function disableOnClick(e) {
	      sb.disable(e);
	    }
	    function onPageBeforeOut() {
	      if (!sb || (sb && !sb.$el)) { return; }
	      if (sb.enabled) {
	        sb.$el.removeClass('searchbar-enabled');
	      }
	    }
	    function onPageBeforeIn() {
	      if (!sb || (sb && !sb.$el)) { return; }
	      if (sb.enabled) {
	        sb.$el.addClass('searchbar-enabled');
	      }
	    }
	    sb.attachEvents = function attachEvents() {
	      $el.on('submit', preventSubmit);
	      if (sb.params.disableButton) {
	        sb.$disableButtonEl.on('click', disableOnClick);
	      }
	      if (sb.params.disableOnBackdropClick && sb.$backdropEl) {
	        sb.$backdropEl.on('click', disableOnClick);
	      }
	      if (sb.expandable && app.theme === 'ios' && sb.view && $navbarEl && sb.$pageEl) {
	        sb.$pageEl.on('page:beforeout', onPageBeforeOut);
	        sb.$pageEl.on('page:beforein', onPageBeforeIn);
	      }
	      sb.$inputEl.on('focus', onInputFocus);
	      sb.$inputEl.on('blur', onInputBlur);
	      sb.$inputEl.on('change input compositionend', onInputChange);
	      sb.$inputEl.on('input:clear', onInputClear);
	    };
	    sb.detachEvents = function detachEvents() {
	      $el.off('submit', preventSubmit);
	      if (sb.params.disableButton) {
	        sb.$disableButtonEl.off('click', disableOnClick);
	      }
	      if (sb.params.disableOnBackdropClick && sb.$backdropEl) {
	        sb.$backdropEl.off('click', disableOnClick);
	      }
	      if (sb.expandable && app.theme === 'ios' && sb.view && $navbarEl && sb.$pageEl) {
	        sb.$pageEl.on('page:beforeout', onPageBeforeOut);
	        sb.$pageEl.on('page:beforein', onPageBeforeIn);
	      }
	      sb.$inputEl.off('focus', onInputFocus);
	      sb.$inputEl.off('blur', onInputBlur);
	      sb.$inputEl.off('change input compositionend', onInputChange);
	      sb.$inputEl.off('input:clear', onInputClear);
	    };

	    // Install Modules
	    sb.useModules();

	    // Init
	    sb.init();

	    return sb;
	  }

	  if ( FrameworkClass ) Searchbar.__proto__ = FrameworkClass;
	  Searchbar.prototype = Object.create( FrameworkClass && FrameworkClass.prototype );
	  Searchbar.prototype.constructor = Searchbar;
	  Searchbar.prototype.clear = function clear (e) {
	    var sb = this;
	    if (!sb.query && e && $$1(e.target).hasClass('searchbar-clear')) {
	      sb.disable();
	      return sb;
	    }
	    var previousQuery = sb.value;
	    sb.$inputEl.val('').trigger('change').focus();
	    sb.$el.trigger('searchbar:clear', previousQuery);
	    sb.emit('local::clear searchbarClear', sb, previousQuery);
	    return sb;
	  };
	  Searchbar.prototype.setDisableButtonMargin = function setDisableButtonMargin () {
	    var sb = this;
	    if (sb.expandable) { return; }
	    var app = sb.app;
	    sb.$disableButtonEl.transition(0).show();
	    sb.$disableButtonEl.css(("margin-" + (app.rtl ? 'left' : 'right')), ((-sb.disableButtonEl.offsetWidth) + "px"));
	    /* eslint no-underscore-dangle: ["error", { "allow": ["_clientLeft"] }] */
	    sb._clientLeft = sb.$disableButtonEl[0].clientLeft;
	    sb.$disableButtonEl.transition('');
	    sb.disableButtonHasMargin = true;
	  };
	  Searchbar.prototype.enable = function enable (setFocus) {
	    var sb = this;
	    if (sb.enabled) { return sb; }
	    var app = sb.app;
	    sb.enabled = true;
	    function enable() {
	      if (sb.$backdropEl && ((sb.$searchContainer && sb.$searchContainer.length) || sb.params.customSearch) && !sb.$el.hasClass('searchbar-enabled') && !sb.query) {
	        sb.backdropShow();
	      }
	      sb.$el.addClass('searchbar-enabled');
	      if (!sb.expandable && sb.$disableButtonEl && sb.$disableButtonEl.length > 0 && app.theme === 'ios') {
	        if (!sb.disableButtonHasMargin) {
	          sb.setDisableButtonMargin();
	        }
	        sb.$disableButtonEl.css(("margin-" + (app.rtl ? 'left' : 'right')), '0px');
	      }
	      if (sb.$hideOnEnableEl) { sb.$hideOnEnableEl.addClass('hidden-by-searchbar'); }
	      sb.$el.trigger('searchbar:enable');
	      sb.emit('local::enable searchbarEnable', sb);
	    }
	    var needsFocus = false;
	    if (setFocus === true) {
	      if (doc.activeElement !== sb.inputEl) {
	        needsFocus = true;
	      }
	    }
	    var isIos = app.device.ios && app.theme === 'ios';
	    if (isIos) {
	      if (sb.expandable) {
	        if (needsFocus) { sb.$inputEl.focus(); }
	        enable();
	      } else {
	        if (needsFocus) { sb.$inputEl.focus(); }
	        if (setFocus && (setFocus.type === 'focus' || setFocus === true)) {
	          Utils.nextTick(function () {
	            enable();
	          }, 400);
	        } else {
	          enable();
	        }
	      }
	    } else {
	      if (needsFocus) { sb.$inputEl.focus(); }
	      if (app.theme === 'md' && sb.expandable) {
	        sb.$el.parents('.page, .view, .navbar-inner').scrollLeft(0);
	      }
	      enable();
	    }
	    return sb;
	  };
	  Searchbar.prototype.disable = function disable () {
	    var sb = this;
	    if (!sb.enabled) { return sb; }
	    var app = sb.app;
	    sb.$inputEl.val('').trigger('change');
	    sb.$el.removeClass('searchbar-enabled');
	    sb.$el.removeClass('searchbar-focused');
	    if (!sb.expandable && sb.$disableButtonEl && sb.$disableButtonEl.length > 0 && app.theme === 'ios') {
	      sb.$disableButtonEl.css(("margin-" + (app.rtl ? 'left' : 'right')), ((-sb.disableButtonEl.offsetWidth) + "px"));
	    }

	    if (sb.$backdropEl && ((sb.$searchContainer && sb.$searchContainer.length) || sb.params.customSearch)) {
	      sb.backdropHide();
	    }

	    sb.enabled = false;

	    sb.$inputEl.blur();

	    if (sb.$hideOnEnableEl) { sb.$hideOnEnableEl.removeClass('hidden-by-searchbar'); }

	    sb.$el.trigger('searchbar:disable');
	    sb.emit('local::disable searchbarDisable', sb);
	    return sb;
	  };
	  Searchbar.prototype.toggle = function toggle () {
	    var sb = this;
	    if (sb.enabled) { sb.disable(); }
	    else { sb.enable(true); }
	    return sb;
	  };
	  Searchbar.prototype.backdropShow = function backdropShow () {
	    var sb = this;
	    if (sb.$backdropEl) {
	      sb.$backdropEl.addClass('searchbar-backdrop-in');
	    }
	    return sb;
	  };
	  Searchbar.prototype.backdropHide = function backdropHide () {
	    var sb = this;
	    if (sb.$backdropEl) {
	      sb.$backdropEl.removeClass('searchbar-backdrop-in');
	    }
	    return sb;
	  };
	  Searchbar.prototype.search = function search (query, internal) {
	    var sb = this;
	    if (sb.previousQuery && query.trim() === sb.previousQuery) { return sb; }
	    if (typeof (sb.previousQuery) !== 'undefined' && sb.previousQuery.trim() === '' && query.trim() === '') { return sb; }
	    sb.previousQuery = query.trim();

	    if (!internal) {
	      if (!sb.enabled) {
	        sb.enable();
	      }
	      sb.$inputEl.val(query);
	    }
	    sb.query = query;
	    sb.value = query;

	    var $searchContainer = sb.$searchContainer;
	    var $el = sb.$el;
	    var $foundEl = sb.$foundEl;
	    var $notFoundEl = sb.$notFoundEl;
	    var $hideOnSearchEl = sb.$hideOnSearchEl;
	    var isVirtualList = sb.isVirtualList;

	    // Hide on search element
	    if (query.length > 0 && $hideOnSearchEl) {
	      $hideOnSearchEl.addClass('hidden-by-searchbar');
	    } else if ($hideOnSearchEl) {
	      $hideOnSearchEl.removeClass('hidden-by-searchbar');
	    }
	    // Add active/inactive classes on overlay
	    if (
	      ($searchContainer && $searchContainer.length && $el.hasClass('searchbar-enabled')) ||
	      (sb.params.customSearch && $el.hasClass('searchbar-enabled'))
	    ) {
	      if (query.length === 0) {
	        sb.backdropShow();
	      } else {
	        sb.backdropHide();
	      }
	    }

	    if (sb.params.customSearch) {
	      $el.trigger('searchbar:search', query, sb.previousQuery);
	      sb.emit('local::search searchbarSearch', sb, query, sb.previousQuery);
	      return sb;
	    }

	    var foundItems = [];
	    var vlQuery;
	    if (isVirtualList) {
	      sb.virtualList = $searchContainer[0].f7VirtualList;
	      if (query.trim() === '') {
	        sb.virtualList.resetFilter();
	        if ($notFoundEl) { $notFoundEl.hide(); }
	        if ($foundEl) { $foundEl.show(); }
	        return sb;
	      }
	      vlQuery = sb.params.removeDiacritics ? Utils.removeDiacritics(query) : query;
	      if (sb.virtualList.params.searchAll) {
	        foundItems = sb.virtualList.params.searchAll(vlQuery, sb.virtualList.items) || [];
	      } else if (sb.virtualList.params.searchByItem) {
	        for (var i = 0; i < sb.virtualList.items.length; i += 1) {
	          if (sb.virtualList.params.searchByItem(vlQuery, sb.virtualList.params.items[i], i)) {
	            foundItems.push(i);
	          }
	        }
	      }
	    } else {
	      var values;
	      if (sb.params.removeDiacritics) { values = Utils.removeDiacritics(query.trim().toLowerCase()).split(' '); }
	      else {
	        values = query.trim().toLowerCase().split(' ');
	      }
	      $searchContainer.find(sb.params.searchItem).removeClass('hidden-by-searchbar').each(function (itemIndex, itemEl) {
	        var $itemEl = $$1(itemEl);
	        var compareWithText = [];
	        var $searchIn = sb.params.searchIn ? $itemEl.find(sb.params.searchIn) : $itemEl;
	        if (sb.params.searchIn === sb.params.searchItem) {
	          $searchIn = $itemEl;
	        }
	        $searchIn.each(function (searchInIndex, searchInEl) {
	          var itemText = $$1(searchInEl).text().trim().toLowerCase();
	          if (sb.params.removeDiacritics) { itemText = Utils.removeDiacritics(itemText); }
	          compareWithText.push(itemText);
	        });
	        compareWithText = compareWithText.join(' ');
	        var wordsMatch = 0;
	        for (var i = 0; i < values.length; i += 1) {
	          if (compareWithText.indexOf(values[i]) >= 0) { wordsMatch += 1; }
	        }
	        if (wordsMatch !== values.length && !(sb.params.ignore && $itemEl.is(sb.params.ignore))) {
	          $itemEl.addClass('hidden-by-searchbar');
	        } else {
	          foundItems.push($itemEl[0]);
	        }
	      });

	      if (sb.params.hideDividers) {
	        $searchContainer.find('.item-divider, .list-group-title').each(function (titleIndex, titleEl) {
	          var $titleEl = $$1(titleEl);
	          var $nextElements = $titleEl.nextAll('li');
	          var hide = true;
	          for (var i = 0; i < $nextElements.length; i += 1) {
	            var $nextEl = $nextElements.eq(i);
	            if ($nextEl.hasClass('list-group-title') || $nextEl.hasClass('item-divider')) { break; }
	            if (!$nextEl.hasClass('hidden-by-searchbar')) {
	              hide = false;
	            }
	          }
	          var ignore = sb.params.ignore && $titleEl.is(sb.params.ignore);
	          if (hide && !ignore) { $titleEl.addClass('hidden-by-searchbar'); }
	          else { $titleEl.removeClass('hidden-by-searchbar'); }
	        });
	      }
	      if (sb.params.hideGroups) {
	        $searchContainer.find('.list-group').each(function (groupIndex, groupEl) {
	          var $groupEl = $$1(groupEl);
	          var ignore = sb.params.ignore && $groupEl.is(sb.params.ignore);
	          var notHidden = $groupEl.find('li:not(.hidden-by-searchbar)');
	          if (notHidden.length === 0 && !ignore) {
	            $groupEl.addClass('hidden-by-searchbar');
	          } else {
	            $groupEl.removeClass('hidden-by-searchbar');
	          }
	        });
	      }
	    }

	    if (foundItems.length === 0) {
	      if ($notFoundEl) { $notFoundEl.show(); }
	      if ($foundEl) { $foundEl.hide(); }
	    } else {
	      if ($notFoundEl) { $notFoundEl.hide(); }
	      if ($foundEl) { $foundEl.show(); }
	    }
	    if (isVirtualList && sb.virtualList) {
	      sb.virtualList.filterItems(foundItems);
	    }

	    $el.trigger('searchbar:search', query, sb.previousQuery, foundItems);
	    sb.emit('local::search searchbarSearch', sb, query, sb.previousQuery, foundItems);

	    return sb;
	  };
	  Searchbar.prototype.init = function init () {
	    var sb = this;
	    sb.attachEvents();
	  };
	  Searchbar.prototype.destroy = function destroy () {
	    var sb = this;
	    sb.emit('local::beforeDestroy searchbarBeforeDestroy', sb);
	    sb.$el.trigger('searchbar:beforedestroy', sb);
	    sb.detachEvents();
	    delete sb.$el.f7Searchbar;
	    Utils.deleteProps(sb);
	  };

	  return Searchbar;
	}(Framework7Class));

	var Searchbar$1 = {
	  name: 'searchbar',
	  static: {
	    Searchbar: Searchbar,
	  },
	  create: function create() {
	    var app = this;
	    app.searchbar = ConstructorMethods({
	      defaultSelector: '.searchbar',
	      constructor: Searchbar,
	      app: app,
	      domProp: 'f7Searchbar',
	      addMethods: 'clear enable disable toggle search'.split(' '),
	    });
	  },
	  on: {
	    tabMounted: function tabMounted(tabEl) {
	      var app = this;
	      $$1(tabEl).find('.searchbar-init').each(function (index, searchbarEl) {
	        var $searchbarEl = $$1(searchbarEl);
	        app.searchbar.create(Utils.extend($searchbarEl.dataset(), { el: searchbarEl }));
	      });
	    },
	    tabBeforeRemove: function tabBeforeRemove(tabEl) {
	      $$1(tabEl).find('.searchbar-init').each(function (index, searchbarEl) {
	        if (searchbarEl.f7Searchbar && searchbarEl.f7Searchbar.destroy) {
	          searchbarEl.f7Searchbar.destroy();
	        }
	      });
	    },
	    pageInit: function pageInit(page) {
	      var app = this;
	      page.$el.find('.searchbar-init').each(function (index, searchbarEl) {
	        var $searchbarEl = $$1(searchbarEl);
	        app.searchbar.create(Utils.extend($searchbarEl.dataset(), { el: searchbarEl }));
	      });
	      if (app.theme === 'ios' && page.view && page.view.router.separateNavbar && page.$navbarEl && page.$navbarEl.length > 0) {
	        page.$navbarEl.find('.searchbar-init').each(function (index, searchbarEl) {
	          var $searchbarEl = $$1(searchbarEl);
	          app.searchbar.create(Utils.extend($searchbarEl.dataset(), { el: searchbarEl }));
	        });
	      }
	    },
	    pageBeforeRemove: function pageBeforeRemove(page) {
	      var app = this;
	      page.$el.find('.searchbar-init').each(function (index, searchbarEl) {
	        if (searchbarEl.f7Searchbar && searchbarEl.f7Searchbar.destroy) {
	          searchbarEl.f7Searchbar.destroy();
	        }
	      });
	      if (app.theme === 'ios' && page.view && page.view.router.separateNavbar && page.$navbarEl && page.$navbarEl.length > 0) {
	        page.$navbarEl.find('.searchbar-init').each(function (index, searchbarEl) {
	          if (searchbarEl.f7Searchbar && searchbarEl.f7Searchbar.destroy) {
	            searchbarEl.f7Searchbar.destroy();
	          }
	        });
	      }
	    },
	  },
	  clicks: {
	    '.searchbar-clear': function clear($clickedEl, data) {
	      if ( data === void 0 ) data = {};

	      var app = this;
	      var sb = app.searchbar.get(data.searchbar);
	      if (sb) { sb.clear(); }
	    },
	    '.searchbar-enable': function enable($clickedEl, data) {
	      if ( data === void 0 ) data = {};

	      var app = this;
	      var sb = app.searchbar.get(data.searchbar);
	      if (sb) { sb.enable(true); }
	    },
	    '.searchbar-disable': function disable($clickedEl, data) {
	      if ( data === void 0 ) data = {};

	      var app = this;
	      var sb = app.searchbar.get(data.searchbar);
	      if (sb) { sb.disable(); }
	    },
	    '.searchbar-toggle': function toggle($clickedEl, data) {
	      if ( data === void 0 ) data = {};

	      var app = this;
	      var sb = app.searchbar.get(data.searchbar);
	      if (sb) { sb.toggle(); }
	    },
	  },
	};

	var Calendar = (function (Framework7Class$$1) {
	  function Calendar(app, params) {
	    if ( params === void 0 ) params = {};

	    Framework7Class$$1.call(this, params, [app]);
	    var calendar = this;
	    calendar.params = Utils.extend({}, app.params.calendar, params);

	    var $containerEl;
	    if (calendar.params.containerEl) {
	      $containerEl = $$1(calendar.params.containerEl);
	      if ($containerEl.length === 0) { return calendar; }
	    }

	    var $inputEl;
	    if (calendar.params.inputEl) {
	      $inputEl = $$1(calendar.params.inputEl);
	    }

	    var view;
	    if ($inputEl) {
	      view = $inputEl.parents('.view').length && $inputEl.parents('.view')[0].f7View;
	    }
	    if (!view) { view = app.views.main; }

	    var isHorizontal = calendar.params.direction === 'horizontal';

	    var inverter = 1;
	    if (isHorizontal) {
	      inverter = app.rtl ? -1 : 1;
	    }

	    Utils.extend(calendar, {
	      app: app,
	      $containerEl: $containerEl,
	      containerEl: $containerEl && $containerEl[0],
	      inline: $containerEl && $containerEl.length > 0,
	      $inputEl: $inputEl,
	      inputEl: $inputEl && $inputEl[0],
	      initialized: false,
	      opened: false,
	      url: calendar.params.url,
	      isHorizontal: isHorizontal,
	      inverter: inverter,
	      view: view,
	      animating: false,
	    });

	    function onInputClick() {
	      calendar.open();
	    }
	    function onInputFocus(e) {
	      e.preventDefault();
	    }
	    function onHtmlClick(e) {
	      var $targetEl = $$1(e.target);
	      if (calendar.isPopover()) { return; }
	      if (!calendar.opened) { return; }
	      if ($targetEl.closest('[class*="backdrop"]').length) { return; }
	      if ($inputEl && $inputEl.length > 0) {
	        if ($targetEl[0] !== $inputEl[0] && $targetEl.closest('.sheet-modal, .calendar-modal').length === 0) {
	          calendar.close();
	        }
	      } else if ($$1(e.target).closest('.sheet-modal, .calendar-modal').length === 0) {
	        calendar.close();
	      }
	    }

	    // Events
	    Utils.extend(calendar, {
	      attachInputEvents: function attachInputEvents() {
	        calendar.$inputEl.on('click', onInputClick);
	        if (calendar.params.inputReadOnly) {
	          calendar.$inputEl.on('focus mousedown', onInputFocus);
	        }
	      },
	      detachInputEvents: function detachInputEvents() {
	        calendar.$inputEl.off('click', onInputClick);
	        if (calendar.params.inputReadOnly) {
	          calendar.$inputEl.off('focus mousedown', onInputFocus);
	        }
	      },
	      attachHtmlEvents: function attachHtmlEvents() {
	        app.on('click', onHtmlClick);
	      },
	      detachHtmlEvents: function detachHtmlEvents() {
	        app.off('click', onHtmlClick);
	      },
	    });
	    calendar.attachCalendarEvents = function attachCalendarEvents() {
	      var allowItemClick = true;
	      var isTouched;
	      var isMoved;
	      var touchStartX;
	      var touchStartY;
	      var touchCurrentX;
	      var touchCurrentY;
	      var touchStartTime;
	      var touchEndTime;
	      var currentTranslate;
	      var wrapperWidth;
	      var wrapperHeight;
	      var percentage;
	      var touchesDiff;
	      var isScrolling;

	      var $el = calendar.$el;
	      var $wrapperEl = calendar.$wrapperEl;

	      function handleTouchStart(e) {
	        if (isMoved || isTouched) { return; }
	        isTouched = true;
	        touchStartX = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
	        touchCurrentX = touchStartX;
	        touchStartY = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
	        touchCurrentY = touchStartY;
	        touchStartTime = (new Date()).getTime();
	        percentage = 0;
	        allowItemClick = true;
	        isScrolling = undefined;
	        currentTranslate = calendar.monthsTranslate;
	      }
	      function handleTouchMove(e) {
	        if (!isTouched) { return; }
	        var isH = calendar.isHorizontal;

	        touchCurrentX = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX;
	        touchCurrentY = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;
	        if (typeof isScrolling === 'undefined') {
	          isScrolling = !!(isScrolling || Math.abs(touchCurrentY - touchStartY) > Math.abs(touchCurrentX - touchStartX));
	        }
	        if (isH && isScrolling) {
	          isTouched = false;
	          return;
	        }
	        e.preventDefault();
	        if (calendar.animating) {
	          isTouched = false;
	          return;
	        }
	        allowItemClick = false;
	        if (!isMoved) {
	          // First move
	          isMoved = true;
	          wrapperWidth = $wrapperEl[0].offsetWidth;
	          wrapperHeight = $wrapperEl[0].offsetHeight;
	          $wrapperEl.transition(0);
	        }

	        touchesDiff = isH ? touchCurrentX - touchStartX : touchCurrentY - touchStartY;
	        percentage = touchesDiff / (isH ? wrapperWidth : wrapperHeight);
	        currentTranslate = ((calendar.monthsTranslate * calendar.inverter) + percentage) * 100;

	        // Transform wrapper
	        $wrapperEl.transform(("translate3d(" + (isH ? currentTranslate : 0) + "%, " + (isH ? 0 : currentTranslate) + "%, 0)"));
	      }
	      function handleTouchEnd() {
	        if (!isTouched || !isMoved) {
	          isTouched = false;
	          isMoved = false;
	          return;
	        }
	        isTouched = false;
	        isMoved = false;

	        touchEndTime = new Date().getTime();
	        if (touchEndTime - touchStartTime < 300) {
	          if (Math.abs(touchesDiff) < 10) {
	            calendar.resetMonth();
	          } else if (touchesDiff >= 10) {
	            if (app.rtl) { calendar.nextMonth(); }
	            else { calendar.prevMonth(); }
	          } else if (app.rtl) { calendar.prevMonth(); }
	          else { calendar.nextMonth(); }
	        } else if (percentage <= -0.5) {
	          if (app.rtl) { calendar.prevMonth(); }
	          else { calendar.nextMonth(); }
	        } else if (percentage >= 0.5) {
	          if (app.rtl) { calendar.nextMonth(); }
	          else { calendar.prevMonth(); }
	        } else {
	          calendar.resetMonth();
	        }

	        // Allow click
	        setTimeout(function () {
	          allowItemClick = true;
	        }, 100);
	      }

	      function handleDayClick(e) {
	        if (!allowItemClick) { return; }
	        var $dayEl = $$1(e.target).parents('.calendar-day');
	        if ($dayEl.length === 0 && $$1(e.target).hasClass('calendar-day')) {
	          $dayEl = $$1(e.target);
	        }
	        if ($dayEl.length === 0) { return; }
	        if ($dayEl.hasClass('calendar-day-disabled')) { return; }
	        if (!calendar.params.rangePicker) {
	          if ($dayEl.hasClass('calendar-day-next')) { calendar.nextMonth(); }
	          if ($dayEl.hasClass('calendar-day-prev')) { calendar.prevMonth(); }
	        }
	        var dateYear = $dayEl.attr('data-year');
	        var dateMonth = $dayEl.attr('data-month');
	        var dateDay = $dayEl.attr('data-day');
	        calendar.emit(
	          'local::dayClick calendarDayClick',
	          calendar,
	          $dayEl[0],
	          dateYear,
	          dateMonth,
	          dateDay
	        );
	        if (!$dayEl.hasClass('calendar-day-selected') || calendar.params.multiple || calendar.params.rangePicker) {
	          calendar.addValue(new Date(dateYear, dateMonth, dateDay, 0, 0, 0));
	        }
	        if (calendar.params.closeOnSelect) {
	          if (
	            (calendar.params.rangePicker && calendar.value.length === 2) ||
	            !calendar.params.rangePicker
	          ) {
	            calendar.close();
	          }
	        }
	      }
	      function onNextMonthClick() {
	        calendar.nextMonth();
	      }
	      function onPrevMonthClick() {
	        calendar.prevMonth();
	      }
	      function onNextYearClick() {
	        calendar.nextYear();
	      }
	      function onPrevYearClick() {
	        calendar.prevYear();
	      }

	      var passiveListener = app.touchEvents.start === 'touchstart' && app.support.passiveListener ? { passive: true, capture: false } : false;
	      // Selectors clicks
	      $el.find('.calendar-prev-month-button').on('click', onPrevMonthClick);
	      $el.find('.calendar-next-month-button').on('click', onNextMonthClick);
	      $el.find('.calendar-prev-year-button').on('click', onPrevYearClick);
	      $el.find('.calendar-next-year-button').on('click', onNextYearClick);
	      // Day clicks
	      $wrapperEl.on('click', handleDayClick);
	      // Touch events
	      {
	        if (calendar.params.touchMove) {
	          $wrapperEl.on(app.touchEvents.start, handleTouchStart, passiveListener);
	          app.on('touchmove:active', handleTouchMove);
	          app.on('touchend:passive', handleTouchEnd);
	        }
	      }

	      calendar.detachCalendarEvents = function detachCalendarEvents() {
	        $el.find('.calendar-prev-month-button').off('click', onPrevMonthClick);
	        $el.find('.calendar-next-month-button').off('click', onNextMonthClick);
	        $el.find('.calendar-prev-year-button').off('click', onPrevYearClick);
	        $el.find('.calendar-next-year-button').off('click', onNextYearClick);
	        $wrapperEl.off('click', handleDayClick);
	        {
	          if (calendar.params.touchMove) {
	            $wrapperEl.off(app.touchEvents.start, handleTouchStart, passiveListener);
	            app.off('touchmove:active', handleTouchMove);
	            app.off('touchend:passive', handleTouchEnd);
	          }
	        }
	      };
	    };

	    calendar.init();

	    return calendar;
	  }

	  if ( Framework7Class$$1 ) Calendar.__proto__ = Framework7Class$$1;
	  Calendar.prototype = Object.create( Framework7Class$$1 && Framework7Class$$1.prototype );
	  Calendar.prototype.constructor = Calendar;
	  // eslint-disable-next-line
	  Calendar.prototype.normalizeDate = function normalizeDate (date) {
	    var d = new Date(date);
	    return new Date(d.getFullYear(), d.getMonth(), d.getDate());
	  };
	  Calendar.prototype.normalizeValues = function normalizeValues (values) {
	    var calendar = this;
	    var newValues = [];
	    if (values && Array.isArray(values)) {
	      newValues = values.map(function (val) { return calendar.normalizeDate(val); });
	    }
	    return newValues;
	  };
	  Calendar.prototype.initInput = function initInput () {
	    var calendar = this;
	    if (!calendar.$inputEl) { return; }
	    if (calendar.params.inputReadOnly) { calendar.$inputEl.prop('readOnly', true); }
	  };
	  Calendar.prototype.isPopover = function isPopover () {
	    var calendar = this;
	    var app = calendar.app;
	    var modal = calendar.modal;
	    var params = calendar.params;
	    if (params.openIn === 'sheet') { return false; }
	    if (modal && modal.type !== 'popover') { return false; }

	    if (!calendar.inline && calendar.inputEl) {
	      if (params.openIn === 'popover') { return true; }
	      else if (app.device.ios) {
	        return !!app.device.ipad;
	      } else if (app.width >= 768) {
	        return true;
	      }
	    }
	    return false;
	  };
	  Calendar.prototype.formatDate = function formatDate (d) {
	    var calendar = this;
	    var date = new Date(d);
	    var year = date.getFullYear();
	    var month = date.getMonth();
	    var month1 = month + 1;
	    var day = date.getDate();
	    var weekDay = date.getDay();
	    var ref = calendar.params;
	    var dateFormat = ref.dateFormat;
	    var monthNames = ref.monthNames;
	    var monthNamesShort = ref.monthNamesShort;
	    var dayNames = ref.dayNames;
	    var dayNamesShort = ref.dayNamesShort;

	    return dateFormat
	      .replace(/yyyy/g, year)
	      .replace(/yy/g, String(year).substring(2))
	      .replace(/mm/g, month1 < 10 ? ("0" + month1) : month1)
	      .replace(/m(\W+)/g, (month1 + "$1"))
	      .replace(/MM/g, monthNames[month])
	      .replace(/M(\W+)/g, ((monthNamesShort[month]) + "$1"))
	      .replace(/dd/g, day < 10 ? ("0" + day) : day)
	      .replace(/d(\W+)/g, (day + "$1"))
	      .replace(/DD/g, dayNames[weekDay])
	      .replace(/D(\W+)/g, ((dayNamesShort[weekDay]) + "$1"));
	  };
	  Calendar.prototype.formatValue = function formatValue () {
	    var calendar = this;
	    var value = calendar.value;
	    if (calendar.params.formatValue) {
	      return calendar.params.formatValue.call(calendar, value);
	    }
	    return value
	      .map(function (v) { return calendar.formatDate(v); })
	      .join(calendar.params.rangePicker ? ' - ' : ', ');
	  };
	  Calendar.prototype.addValue = function addValue (newValue) {
	    var calendar = this;
	    var ref = calendar.params;
	    var multiple = ref.multiple;
	    var rangePicker = ref.rangePicker;
	    if (multiple) {
	      if (!calendar.value) { calendar.value = []; }
	      var inValuesIndex;
	      for (var i = 0; i < calendar.value.length; i += 1) {
	        if (new Date(newValue).getTime() === new Date(calendar.value[i]).getTime()) {
	          inValuesIndex = i;
	        }
	      }
	      if (typeof inValuesIndex === 'undefined') {
	        calendar.value.push(newValue);
	      } else {
	        calendar.value.splice(inValuesIndex, 1);
	      }
	      calendar.updateValue();
	    } else if (rangePicker) {
	      if (!calendar.value) { calendar.value = []; }
	      if (calendar.value.length === 2 || calendar.value.length === 0) {
	        calendar.value = [];
	      }
	      if (calendar.value[0] !== newValue) { calendar.value.push(newValue); }
	      else { calendar.value = []; }
	      calendar.value.sort(function (a, b) { return a - b; });
	      calendar.updateValue();
	    } else {
	      calendar.value = [newValue];
	      calendar.updateValue();
	    }
	  };
	  Calendar.prototype.setValue = function setValue (values) {
	    var calendar = this;
	    calendar.value = values;
	    calendar.updateValue();
	  };
	  Calendar.prototype.getValue = function getValue () {
	    var calendar = this;
	    return calendar.value;
	  };
	  Calendar.prototype.updateValue = function updateValue (onlyHeader) {
	    var calendar = this;
	    var $el = calendar.$el;
	    var $wrapperEl = calendar.$wrapperEl;
	    var $inputEl = calendar.$inputEl;
	    var value = calendar.value;
	    var params = calendar.params;
	    var i;
	    if ($el && $el.length > 0) {
	      $wrapperEl.find('.calendar-day-selected').removeClass('calendar-day-selected');
	      var valueDate;
	      if (params.rangePicker && value.length === 2) {
	        for (i = new Date(value[0]).getTime(); i <= new Date(value[1]).getTime(); i += 24 * 60 * 60 * 1000) {
	          valueDate = new Date(i);
	          $wrapperEl.find((".calendar-day[data-date=\"" + (valueDate.getFullYear()) + "-" + (valueDate.getMonth()) + "-" + (valueDate.getDate()) + "\"]")).addClass('calendar-day-selected');
	        }
	      } else {
	        for (i = 0; i < calendar.value.length; i += 1) {
	          valueDate = new Date(value[i]);
	          $wrapperEl.find((".calendar-day[data-date=\"" + (valueDate.getFullYear()) + "-" + (valueDate.getMonth()) + "-" + (valueDate.getDate()) + "\"]")).addClass('calendar-day-selected');
	        }
	      }
	    }
	    if (!onlyHeader) {
	      calendar.emit('local::change calendarChange', calendar, value);
	    }


	    if (($inputEl && $inputEl.length) || params.header) {
	      var inputValue = calendar.formatValue(value);
	      if (params.header && $el && $el.length) {
	        $el.find('.calendar-selected-date').text(inputValue);
	      }
	      if ($inputEl && $inputEl.length && !onlyHeader) {
	        $inputEl.val(inputValue);
	        $inputEl.trigger('change');
	      }
	    }
	  };
	  Calendar.prototype.updateCurrentMonthYear = function updateCurrentMonthYear (dir) {
	    var calendar = this;
	    var $months = calendar.$months;
	    var $el = calendar.$el;
	    var params = calendar.params;
	    if (typeof dir === 'undefined') {
	      calendar.currentMonth = parseInt($months.eq(1).attr('data-month'), 10);
	      calendar.currentYear = parseInt($months.eq(1).attr('data-year'), 10);
	    } else {
	      calendar.currentMonth = parseInt($months.eq(dir === 'next' ? ($months.length - 1) : 0).attr('data-month'), 10);
	      calendar.currentYear = parseInt($months.eq(dir === 'next' ? ($months.length - 1) : 0).attr('data-year'), 10);
	    }
	    $el.find('.current-month-value').text(params.monthNames[calendar.currentMonth]);
	    $el.find('.current-year-value').text(calendar.currentYear);
	  };
	  Calendar.prototype.update = function update () {
	    var calendar = this;
	    var currentYear = calendar.currentYear;
	    var currentMonth = calendar.currentMonth;
	    var $wrapperEl = calendar.$wrapperEl;
	    var currentDate = new Date(currentYear, currentMonth);
	    var prevMonthHtml = calendar.renderMonth(currentDate, 'prev');
	    var currentMonthHtml = calendar.renderMonth(currentDate);
	    var nextMonthHtml = calendar.renderMonth(currentDate, 'next');

	    $wrapperEl
	      .transition(0)
	      .html(("" + prevMonthHtml + currentMonthHtml + nextMonthHtml))
	      .transform('translate3d(0,0,0)');
	    calendar.$months = $wrapperEl.find('.calendar-month');
	    calendar.monthsTranslate = 0;
	    calendar.setMonthsTranslate();
	    calendar.$months.each(function (index, monthEl) {
	      calendar.emit(
	        'local::monthAdd calendarMonthAdd',
	        monthEl
	      );
	    });
	  };
	  Calendar.prototype.onMonthChangeStart = function onMonthChangeStart (dir) {
	    var calendar = this;
	    var $months = calendar.$months;
	    var currentYear = calendar.currentYear;
	    var currentMonth = calendar.currentMonth;
	    calendar.updateCurrentMonthYear(dir);
	    $months.removeClass('calendar-month-current calendar-month-prev calendar-month-next');
	    var currentIndex = dir === 'next' ? $months.length - 1 : 0;

	    $months.eq(currentIndex).addClass('calendar-month-current');
	    $months.eq(dir === 'next' ? currentIndex - 1 : currentIndex + 1).addClass(dir === 'next' ? 'calendar-month-prev' : 'calendar-month-next');

	    calendar.emit(
	      'local::monthYearChangeStart calendarMonthYearChangeStart',
	      calendar,
	      currentYear,
	      currentMonth
	    );
	  };
	  Calendar.prototype.onMonthChangeEnd = function onMonthChangeEnd (dir, rebuildBoth) {
	    var calendar = this;
	    var currentYear = calendar.currentYear;
	    var currentMonth = calendar.currentMonth;
	    var $wrapperEl = calendar.$wrapperEl;
	    var monthsTranslate = calendar.monthsTranslate;
	    calendar.animating = false;
	    var nextMonthHtml;
	    var prevMonthHtml;
	    var currentMonthHtml;
	    $wrapperEl
	      .find('.calendar-month:not(.calendar-month-prev):not(.calendar-month-current):not(.calendar-month-next)')
	      .remove();

	    if (typeof dir === 'undefined') {
	      dir = 'next'; // eslint-disable-line
	      rebuildBoth = true; // eslint-disable-line
	    }
	    if (!rebuildBoth) {
	      currentMonthHtml = calendar.renderMonth(new Date(currentYear, currentMonth), dir);
	    } else {
	      $wrapperEl.find('.calendar-month-next, .calendar-month-prev').remove();
	      prevMonthHtml = calendar.renderMonth(new Date(currentYear, currentMonth), 'prev');
	      nextMonthHtml = calendar.renderMonth(new Date(currentYear, currentMonth), 'next');
	    }
	    if (dir === 'next' || rebuildBoth) {
	      $wrapperEl.append(currentMonthHtml || nextMonthHtml);
	    }
	    if (dir === 'prev' || rebuildBoth) {
	      $wrapperEl.prepend(currentMonthHtml || prevMonthHtml);
	    }
	    var $months = $wrapperEl.find('.calendar-month');
	    calendar.$months = $months;
	    calendar.setMonthsTranslate(monthsTranslate);
	    calendar.emit(
	      'local::monthAdd calendarMonthAdd',
	      calendar,
	      dir === 'next' ? $months.eq($months.length - 1)[0] : $months.eq(0)[0]
	    );
	    calendar.emit(
	      'local::monthYearChangeEnd calendarMonthYearChangeEnd',
	      calendar,
	      currentYear,
	      currentMonth
	    );
	  };
	  Calendar.prototype.setMonthsTranslate = function setMonthsTranslate (translate) {
	    var calendar = this;
	    var $months = calendar.$months;
	    var isH = calendar.isHorizontal;
	    var inverter = calendar.inverter;
	    // eslint-disable-next-line
	    translate = translate || calendar.monthsTranslate || 0;
	    if (typeof calendar.monthsTranslate === 'undefined') {
	      calendar.monthsTranslate = translate;
	    }
	    $months.removeClass('calendar-month-current calendar-month-prev calendar-month-next');
	    var prevMonthTranslate = -(translate + 1) * 100 * inverter;
	    var currentMonthTranslate = -translate * 100 * inverter;
	    var nextMonthTranslate = -(translate - 1) * 100 * inverter;
	    $months.eq(0)
	      .transform(("translate3d(" + (isH ? prevMonthTranslate : 0) + "%, " + (isH ? 0 : prevMonthTranslate) + "%, 0)"))
	      .addClass('calendar-month-prev');
	    $months.eq(1)
	      .transform(("translate3d(" + (isH ? currentMonthTranslate : 0) + "%, " + (isH ? 0 : currentMonthTranslate) + "%, 0)"))
	      .addClass('calendar-month-current');
	    $months.eq(2)
	      .transform(("translate3d(" + (isH ? nextMonthTranslate : 0) + "%, " + (isH ? 0 : nextMonthTranslate) + "%, 0)"))
	      .addClass('calendar-month-next');
	  };
	  Calendar.prototype.nextMonth = function nextMonth (transition) {
	    var calendar = this;
	    var params = calendar.params;
	    var $wrapperEl = calendar.$wrapperEl;
	    var inverter = calendar.inverter;
	    var isH = calendar.isHorizontal;
	    if (typeof transition === 'undefined' || typeof transition === 'object') {
	      transition = ''; // eslint-disable-line
	      if (!params.animate) { transition = 0; } // eslint-disable-line
	    }
	    var nextMonth = parseInt(calendar.$months.eq(calendar.$months.length - 1).attr('data-month'), 10);
	    var nextYear = parseInt(calendar.$months.eq(calendar.$months.length - 1).attr('data-year'), 10);
	    var nextDate = new Date(nextYear, nextMonth);
	    var nextDateTime = nextDate.getTime();
	    var transitionEndCallback = !calendar.animating;
	    if (params.maxDate) {
	      if (nextDateTime > new Date(params.maxDate).getTime()) {
	        calendar.resetMonth();
	        return;
	      }
	    }
	    calendar.monthsTranslate -= 1;
	    if (nextMonth === calendar.currentMonth) {
	      var nextMonthTranslate = -(calendar.monthsTranslate) * 100 * inverter;
	      var nextMonthHtml = $$1(calendar.renderMonth(nextDateTime, 'next'))
	        .transform(("translate3d(" + (isH ? nextMonthTranslate : 0) + "%, " + (isH ? 0 : nextMonthTranslate) + "%, 0)"))
	        .addClass('calendar-month-next');
	      $wrapperEl.append(nextMonthHtml[0]);
	      calendar.$months = $wrapperEl.find('.calendar-month');
	      calendar.emit(
	        'local::monthAdd calendarMonthAdd',
	        calendar.$months.eq(calendar.$months.length - 1)[0]
	      );
	    }
	    calendar.animating = true;
	    calendar.onMonthChangeStart('next');
	    var translate = (calendar.monthsTranslate * 100) * inverter;

	    $wrapperEl.transition(transition).transform(("translate3d(" + (isH ? translate : 0) + "%, " + (isH ? 0 : translate) + "%, 0)"));
	    if (transitionEndCallback) {
	      $wrapperEl.transitionEnd(function () {
	        calendar.onMonthChangeEnd('next');
	      });
	    }
	    if (!params.animate) {
	      calendar.onMonthChangeEnd('next');
	    }
	  };
	  Calendar.prototype.prevMonth = function prevMonth (transition) {
	    var calendar = this;
	    var params = calendar.params;
	    var $wrapperEl = calendar.$wrapperEl;
	    var inverter = calendar.inverter;
	    var isH = calendar.isHorizontal;
	    if (typeof transition === 'undefined' || typeof transition === 'object') {
	      transition = ''; // eslint-disable-line
	      if (!params.animate) { transition = 0; } // eslint-disable-line
	    }
	    var prevMonth = parseInt(calendar.$months.eq(0).attr('data-month'), 10);
	    var prevYear = parseInt(calendar.$months.eq(0).attr('data-year'), 10);
	    var prevDate = new Date(prevYear, prevMonth + 1, -1);
	    var prevDateTime = prevDate.getTime();
	    var transitionEndCallback = !calendar.animating;
	    if (params.minDate) {
	      if (prevDateTime < new Date(params.minDate).getTime()) {
	        calendar.resetMonth();
	        return;
	      }
	    }
	    calendar.monthsTranslate += 1;
	    if (prevMonth === calendar.currentMonth) {
	      var prevMonthTranslate = -(calendar.monthsTranslate) * 100 * inverter;
	      var prevMonthHtml = $$1(calendar.renderMonth(prevDateTime, 'prev'))
	        .transform(("translate3d(" + (isH ? prevMonthTranslate : 0) + "%, " + (isH ? 0 : prevMonthTranslate) + "%, 0)"))
	        .addClass('calendar-month-prev');
	      $wrapperEl.prepend(prevMonthHtml[0]);
	      calendar.$months = $wrapperEl.find('.calendar-month');
	      calendar.emit(
	        'local::monthAdd calendarMonthAdd',
	        calendar.$months.eq(0)[0]
	      );
	    }
	    calendar.animating = true;
	    calendar.onMonthChangeStart('prev');
	    var translate = (calendar.monthsTranslate * 100) * inverter;
	    $wrapperEl
	      .transition(transition)
	      .transform(("translate3d(" + (isH ? translate : 0) + "%, " + (isH ? 0 : translate) + "%, 0)"));
	    if (transitionEndCallback) {
	      $wrapperEl.transitionEnd(function () {
	        calendar.onMonthChangeEnd('prev');
	      });
	    }
	    if (!params.animate) {
	      calendar.onMonthChangeEnd('prev');
	    }
	  };
	  Calendar.prototype.resetMonth = function resetMonth (transition) {
	    if ( transition === void 0 ) transition = '';

	    var calendar = this;
	    var $wrapperEl = calendar.$wrapperEl;
	    var inverter = calendar.inverter;
	    var isH = calendar.isHorizontal;
	    var monthsTranslate = calendar.monthsTranslate;
	    var translate = (monthsTranslate * 100) * inverter;
	    $wrapperEl
	      .transition(transition)
	      .transform(("translate3d(" + (isH ? translate : 0) + "%, " + (isH ? 0 : translate) + "%, 0)"));
	  };
	  // eslint-disable-next-line
	  Calendar.prototype.setYearMonth = function setYearMonth (year, month, transition) {
	    var calendar = this;
	    var params = calendar.params;
	    var isH = calendar.isHorizontal;
	    var $wrapperEl = calendar.$wrapperEl;
	    var inverter = calendar.inverter;
	    // eslint-disable-next-line
	    if (typeof year === 'undefined') { year = calendar.currentYear; }
	    // eslint-disable-next-line
	    if (typeof month === 'undefined') { month = calendar.currentMonth; }
	    if (typeof transition === 'undefined' || typeof transition === 'object') {
	      // eslint-disable-next-line
	      transition = '';
	      // eslint-disable-next-line
	      if (!params.animate) { transition = 0; }
	    }
	    var targetDate;
	    if (year < calendar.currentYear) {
	      targetDate = new Date(year, month + 1, -1).getTime();
	    } else {
	      targetDate = new Date(year, month).getTime();
	    }
	    if (params.maxDate && targetDate > new Date(params.maxDate).getTime()) {
	      return false;
	    }
	    if (params.minDate && targetDate < new Date(params.minDate).getTime()) {
	      return false;
	    }
	    var currentDate = new Date(calendar.currentYear, calendar.currentMonth).getTime();
	    var dir = targetDate > currentDate ? 'next' : 'prev';
	    var newMonthHTML = calendar.renderMonth(new Date(year, month));
	    calendar.monthsTranslate = calendar.monthsTranslate || 0;
	    var prevTranslate = calendar.monthsTranslate;
	    var monthTranslate;
	    var transitionEndCallback = !calendar.animating;
	    if (targetDate > currentDate) {
	      // To next
	      calendar.monthsTranslate -= 1;
	      if (!calendar.animating) { calendar.$months.eq(calendar.$months.length - 1).remove(); }
	      $wrapperEl.append(newMonthHTML);
	      calendar.$months = $wrapperEl.find('.calendar-month');
	      monthTranslate = -(prevTranslate - 1) * 100 * inverter;
	      calendar.$months
	        .eq(calendar.$months.length - 1)
	        .transform(("translate3d(" + (isH ? monthTranslate : 0) + "%, " + (isH ? 0 : monthTranslate) + "%, 0)"))
	        .addClass('calendar-month-next');
	    } else {
	      // To prev
	      calendar.monthsTranslate += 1;
	      if (!calendar.animating) { calendar.$months.eq(0).remove(); }
	      $wrapperEl.prepend(newMonthHTML);
	      calendar.$months = $wrapperEl.find('.calendar-month');
	      monthTranslate = -(prevTranslate + 1) * 100 * inverter;
	      calendar.$months
	        .eq(0)
	        .transform(("translate3d(" + (isH ? monthTranslate : 0) + "%, " + (isH ? 0 : monthTranslate) + "%, 0)"))
	        .addClass('calendar-month-prev');
	    }
	    calendar.emit(
	      'local::monthAdd calendarMonthAdd',
	      dir === 'next'
	        ? calendar.$months.eq(calendar.$months.length - 1)[0]
	        : calendar.$months.eq(0)[0]
	    );

	    calendar.animating = true;
	    calendar.onMonthChangeStart(dir);
	    var wrapperTranslate = (calendar.monthsTranslate * 100) * inverter;
	    $wrapperEl
	      .transition(transition)
	      .transform(("translate3d(" + (isH ? wrapperTranslate : 0) + "%, " + (isH ? 0 : wrapperTranslate) + "%, 0)"));
	    if (transitionEndCallback) {
	      $wrapperEl.transitionEnd(function () {
	        calendar.onMonthChangeEnd(dir, true);
	      });
	    }
	    if (!params.animate) {
	      calendar.onMonthChangeEnd(dir);
	    }
	  };
	  Calendar.prototype.nextYear = function nextYear () {
	    var calendar = this;
	    calendar.setYearMonth(calendar.currentYear + 1);
	  };
	  Calendar.prototype.prevYear = function prevYear () {
	    var calendar = this;
	    calendar.setYearMonth(calendar.currentYear - 1);
	  };
	  // eslint-disable-next-line
	  Calendar.prototype.dateInRange = function dateInRange (dayDate, range) {
	    var match = false;
	    var i;
	    if (!range) { return false; }
	    if (Array.isArray(range)) {
	      for (i = 0; i < range.length; i += 1) {
	        if (range[i].from || range[i].to) {
	          if (range[i].from && range[i].to) {
	            if ((dayDate <= new Date(range[i].to).getTime()) && (dayDate >= new Date(range[i].from).getTime())) {
	              match = true;
	            }
	          } else if (range[i].from) {
	            if (dayDate >= new Date(range[i].from).getTime()) {
	              match = true;
	            }
	          } else if (range[i].to) {
	            if (dayDate <= new Date(range[i].to).getTime()) {
	              match = true;
	            }
	          }
	        } else if (dayDate === new Date(range[i]).getTime()) {
	          match = true;
	        }
	      }
	    } else if (range.from || range.to) {
	      if (range.from && range.to) {
	        if ((dayDate <= new Date(range.to).getTime()) && (dayDate >= new Date(range.from).getTime())) {
	          match = true;
	        }
	      } else if (range.from) {
	        if (dayDate >= new Date(range.from).getTime()) {
	          match = true;
	        }
	      } else if (range.to) {
	        if (dayDate <= new Date(range.to).getTime()) {
	          match = true;
	        }
	      }
	    } else if (typeof range === 'function') {
	      match = range(new Date(dayDate));
	    }
	    return match;
	  };
	  // eslint-disable-next-line
	  Calendar.prototype.daysInMonth = function daysInMonth (date) {
	    var d = new Date(date);
	    return new Date(d.getFullYear(), d.getMonth() + 1, 0).getDate();
	  };
	  Calendar.prototype.renderMonths = function renderMonths (date) {
	    var calendar = this;
	    if (calendar.params.renderMonths) {
	      return calendar.params.renderMonths.call(calendar, date);
	    }
	    return ("\n      <div class=\"calendar-months-wrapper\">\n        " + (calendar.renderMonth(date, 'prev')) + "\n        " + (calendar.renderMonth(date)) + "\n        " + (calendar.renderMonth(date, 'next')) + "\n      </div>\n    ").trim();
	  };
	  Calendar.prototype.renderMonth = function renderMonth (d, offset) {
	    var calendar = this;
	    var params = calendar.params;
	    var value = calendar.value;
	    if (params.renderMonth) {
	      return params.renderMonth.call(calendar, d, offset);
	    }
	    var date = new Date(d);
	    var year = date.getFullYear();
	    var month = date.getMonth();

	    if (offset === 'next') {
	      if (month === 11) { date = new Date(year + 1, 0); }
	      else { date = new Date(year, month + 1, 1); }
	    }
	    if (offset === 'prev') {
	      if (month === 0) { date = new Date(year - 1, 11); }
	      else { date = new Date(year, month - 1, 1); }
	    }
	    if (offset === 'next' || offset === 'prev') {
	      month = date.getMonth();
	      year = date.getFullYear();
	    }

	    var currentValues = [];
	    var today = new Date().setHours(0, 0, 0, 0);
	    var minDate = params.minDate ? new Date(params.minDate).getTime() : null;
	    var maxDate = params.maxDate ? new Date(params.maxDate).getTime() : null;
	    var rows = 6;
	    var cols = 7;
	    var daysInPrevMonth = calendar.daysInMonth(new Date(date.getFullYear(), date.getMonth()).getTime() - (10 * 24 * 60 * 60 * 1000));
	    var daysInMonth = calendar.daysInMonth(date);
	    var minDayNumber = params.firstDay === 6 ? 0 : 1;

	    var monthHtml = '';
	    var dayIndex = 0 + (params.firstDay - 1);
	    var disabled;
	    var hasEvent;
	    var firstDayOfMonthIndex = new Date(date.getFullYear(), date.getMonth()).getDay();
	    if (firstDayOfMonthIndex === 0) { firstDayOfMonthIndex = 7; }

	    if (value && value.length) {
	      for (var i = 0; i < value.length; i += 1) {
	        currentValues.push(new Date(value[i]).setHours(0, 0, 0, 0));
	      }
	    }

	    for (var row = 1; row <= rows; row += 1) {
	      var rowHtml = '';
	      for (var col = 1; col <= cols; col += 1) {
	        dayIndex += 1;
	        var dayDate = (void 0);
	        var dayNumber = dayIndex - firstDayOfMonthIndex;
	        var addClass = '';
	        if (row === 1 && col === 1 && dayNumber > minDayNumber && params.firstDay !== 1) {
	          dayIndex -= 7;
	          dayNumber = dayIndex - firstDayOfMonthIndex;
	        }

	        var weekDayIndex = ((col - 1) + params.firstDay > 6)
	          ? ((col - 1 - 7) + params.firstDay)
	          : ((col - 1) + params.firstDay);

	        if (dayNumber < 0) {
	          dayNumber = daysInPrevMonth + dayNumber + 1;
	          addClass += ' calendar-day-prev';
	          dayDate = new Date(month - 1 < 0 ? year - 1 : year, month - 1 < 0 ? 11 : month - 1, dayNumber).getTime();
	        } else {
	          dayNumber += 1;
	          if (dayNumber > daysInMonth) {
	            dayNumber -= daysInMonth;
	            addClass += ' calendar-day-next';
	            dayDate = new Date(month + 1 > 11 ? year + 1 : year, month + 1 > 11 ? 0 : month + 1, dayNumber).getTime();
	          } else {
	            dayDate = new Date(year, month, dayNumber).getTime();
	          }
	        }
	        // Today
	        if (dayDate === today) { addClass += ' calendar-day-today'; }

	        // Selected
	        if (params.rangePicker && currentValues.length === 2) {
	          if (dayDate >= currentValues[0] && dayDate <= currentValues[1]) { addClass += ' calendar-day-selected'; }
	        } else if (currentValues.indexOf(dayDate) >= 0) { addClass += ' calendar-day-selected'; }
	        // Weekend
	        if (params.weekendDays.indexOf(weekDayIndex) >= 0) {
	          addClass += ' calendar-day-weekend';
	        }
	        // Has Events
	        hasEvent = false;
	        if (params.events) {
	          if (calendar.dateInRange(dayDate, params.events)) {
	            hasEvent = true;
	          }
	        }
	        if (hasEvent) {
	          addClass += ' calendar-day-has-events';
	        }
	        // Custom Ranges
	        if (params.rangesClasses) {
	          for (var k = 0; k < params.rangesClasses.length; k += 1) {
	            if (calendar.dateInRange(dayDate, params.rangesClasses[k].range)) {
	              addClass += " " + (params.rangesClasses[k].cssClass);
	            }
	          }
	        }
	        // Disabled
	        disabled = false;
	        if ((minDate && dayDate < minDate) || (maxDate && dayDate > maxDate)) {
	          disabled = true;
	        }
	        if (params.disabled) {
	          if (calendar.dateInRange(dayDate, params.disabled)) {
	            disabled = true;
	          }
	        }
	        if (disabled) {
	          addClass += ' calendar-day-disabled';
	        }

	        dayDate = new Date(dayDate);
	        var dayYear = dayDate.getFullYear();
	        var dayMonth = dayDate.getMonth();
	        rowHtml += ("\n          <div data-year=\"" + dayYear + "\" data-month=\"" + dayMonth + "\" data-day=\"" + dayNumber + "\" class=\"calendar-day" + addClass + "\" data-date=\"" + dayYear + "-" + dayMonth + "-" + dayNumber + "\">\n            <span>" + dayNumber + "</span>\n          </div>").trim();
	      }
	      monthHtml += "<div class=\"calendar-row\">" + rowHtml + "</div>";
	    }
	    monthHtml = "<div class=\"calendar-month\" data-year=\"" + year + "\" data-month=\"" + month + "\">" + monthHtml + "</div>";
	    return monthHtml;
	  };
	  Calendar.prototype.renderWeekHeader = function renderWeekHeader () {
	    var calendar = this;
	    if (calendar.params.renderWeekHeader) {
	      return calendar.params.renderWeekHeader.call(calendar);
	    }
	    var params = calendar.params;
	    var weekDaysHtml = '';
	    for (var i = 0; i < 7; i += 1) {
	      var dayIndex = (i + params.firstDay > 6)
	        ? ((i - 7) + params.firstDay)
	        : (i + params.firstDay);
	      var dayName = params.dayNamesShort[dayIndex];
	      weekDaysHtml += "<div class=\"calendar-week-day\">" + dayName + "</div>";
	    }
	    return ("\n      <div class=\"calendar-week-header\">\n        " + weekDaysHtml + "\n      </div>\n    ").trim();
	  };
	  Calendar.prototype.renderMonthSelector = function renderMonthSelector () {
	    var calendar = this;
	    var app = calendar.app;
	    if (calendar.params.renderMonthSelector) {
	      return calendar.params.renderMonthSelector.call(calendar);
	    }

	    var needsBlackIcon;
	    if (calendar.inline && calendar.$containerEl.closest('.theme-dark').length === 0) {
	      needsBlackIcon = true;
	    } else if (app.root.closest('.theme-dark').length === 0) {
	      needsBlackIcon = true;
	    }

	    var iconColor = app.theme === 'md' && needsBlackIcon ? 'color-black' : '';
	    return ("\n      <div class=\"calendar-month-selector\">\n        <a href=\"#\" class=\"link icon-only calendar-prev-month-button\">\n          <i class=\"icon icon-prev " + iconColor + "\"></i>\n        </a>\n        <span class=\"current-month-value\"></span>\n        <a href=\"#\" class=\"link icon-only calendar-next-month-button\">\n          <i class=\"icon icon-next " + iconColor + "\"></i>\n        </a>\n      </div>\n    ").trim();
	  };
	  Calendar.prototype.renderYearSelector = function renderYearSelector () {
	    var calendar = this;
	    var app = calendar.app;
	    if (calendar.params.renderYearSelector) {
	      return calendar.params.renderYearSelector.call(calendar);
	    }

	    var needsBlackIcon;
	    if (calendar.inline && calendar.$containerEl.closest('.theme-dark').length === 0) {
	      needsBlackIcon = true;
	    } else if (app.root.closest('.theme-dark').length === 0) {
	      needsBlackIcon = true;
	    }

	    var iconColor = app.theme === 'md' && needsBlackIcon ? 'color-black' : '';
	    return ("\n      <div class=\"calendar-year-selector\">\n        <a href=\"#\" class=\"link icon-only calendar-prev-year-button\">\n          <i class=\"icon icon-prev " + iconColor + "\"></i>\n        </a>\n        <span class=\"current-year-value\"></span>\n        <a href=\"#\" class=\"link icon-only calendar-next-year-button\">\n          <i class=\"icon icon-next " + iconColor + "\"></i>\n        </a>\n      </div>\n    ").trim();
	  };
	  Calendar.prototype.renderHeader = function renderHeader () {
	    var calendar = this;
	    if (calendar.params.renderHeader) {
	      return calendar.params.renderHeader.call(calendar);
	    }
	    return ("\n      <div class=\"calendar-header\">\n        <div class=\"calendar-selected-date\">" + (calendar.params.headerPlaceholder) + "</div>\n      </div>\n    ").trim();
	  };
	  Calendar.prototype.renderFooter = function renderFooter () {
	    var calendar = this;
	    var app = calendar.app;
	    if (calendar.params.renderFooter) {
	      return calendar.params.renderFooter.call(calendar);
	    }
	    return ("\n      <div class=\"calendar-footer\">\n        <a href=\"#\" class=\"" + (app.theme === 'md' ? 'button' : 'link') + " calendar-close sheet-close popover-close\">" + (calendar.params.toolbarCloseText) + "</a>\n      </div>\n    ").trim();
	  };
	  Calendar.prototype.renderToolbar = function renderToolbar () {
	    var calendar = this;
	    if (calendar.params.renderToolbar) {
	      return calendar.params.renderToolbar.call(calendar, calendar);
	    }
	    return ("\n      <div class=\"toolbar no-shadow\">\n        <div class=\"toolbar-inner\">\n          " + (calendar.renderMonthSelector()) + "\n          " + (calendar.renderYearSelector()) + "\n        </div>\n      </div>\n    ").trim();
	  };
	  // eslint-disable-next-line
	  Calendar.prototype.renderInline = function renderInline () {
	    var calendar = this;
	    var ref = calendar.params;
	    var cssClass = ref.cssClass;
	    var toolbar = ref.toolbar;
	    var header = ref.header;
	    var footer = ref.footer;
	    var rangePicker = ref.rangePicker;
	    var weekHeader = ref.weekHeader;
	    var value = calendar.value;
	    var date = value && value.length ? value[0] : new Date().setHours(0, 0, 0);
	    var inlineHtml = ("\n      <div class=\"calendar calendar-inline " + (rangePicker ? 'calendar-range' : '') + " " + (cssClass || '') + "\">\n        " + (header ? calendar.renderHeader() : '') + "\n        " + (toolbar ? calendar.renderToolbar() : '') + "\n        " + (weekHeader ? calendar.renderWeekHeader() : '') + "\n        <div class=\"calendar-months\">\n          " + (calendar.renderMonths(date)) + "\n        </div>\n        " + (footer ? calendar.renderFooter() : '') + "\n      </div>\n    ").trim();

	    return inlineHtml;
	  };
	  Calendar.prototype.renderCustomModal = function renderCustomModal () {
	    var calendar = this;
	    var ref = calendar.params;
	    var cssClass = ref.cssClass;
	    var toolbar = ref.toolbar;
	    var header = ref.header;
	    var footer = ref.footer;
	    var rangePicker = ref.rangePicker;
	    var weekHeader = ref.weekHeader;
	    var value = calendar.value;
	    var date = value && value.length ? value[0] : new Date().setHours(0, 0, 0);
	    var sheetHtml = ("\n      <div class=\"calendar calendar-modal " + (rangePicker ? 'calendar-range' : '') + " " + (cssClass || '') + "\">\n        " + (header ? calendar.renderHeader() : '') + "\n        " + (toolbar ? calendar.renderToolbar() : '') + "\n        " + (weekHeader ? calendar.renderWeekHeader() : '') + "\n        <div class=\"calendar-months\">\n          " + (calendar.renderMonths(date)) + "\n        </div>\n        " + (footer ? calendar.renderFooter() : '') + "\n      </div>\n    ").trim();

	    return sheetHtml;
	  };
	  Calendar.prototype.renderSheet = function renderSheet () {
	    var calendar = this;
	    var ref = calendar.params;
	    var cssClass = ref.cssClass;
	    var toolbar = ref.toolbar;
	    var header = ref.header;
	    var footer = ref.footer;
	    var rangePicker = ref.rangePicker;
	    var weekHeader = ref.weekHeader;
	    var value = calendar.value;
	    var date = value && value.length ? value[0] : new Date().setHours(0, 0, 0);
	    var sheetHtml = ("\n      <div class=\"sheet-modal calendar calendar-sheet " + (rangePicker ? 'calendar-range' : '') + " " + (cssClass || '') + "\">\n        " + (header ? calendar.renderHeader() : '') + "\n        " + (toolbar ? calendar.renderToolbar() : '') + "\n        " + (weekHeader ? calendar.renderWeekHeader() : '') + "\n        <div class=\"sheet-modal-inner calendar-months\">\n          " + (calendar.renderMonths(date)) + "\n        </div>\n        " + (footer ? calendar.renderFooter() : '') + "\n      </div>\n    ").trim();

	    return sheetHtml;
	  };
	  Calendar.prototype.renderPopover = function renderPopover () {
	    var calendar = this;
	    var ref = calendar.params;
	    var cssClass = ref.cssClass;
	    var toolbar = ref.toolbar;
	    var header = ref.header;
	    var footer = ref.footer;
	    var rangePicker = ref.rangePicker;
	    var weekHeader = ref.weekHeader;
	    var value = calendar.value;
	    var date = value && value.length ? value[0] : new Date().setHours(0, 0, 0);
	    var popoverHtml = ("\n      <div class=\"popover calendar-popover\">\n        <div class=\"popover-inner\">\n          <div class=\"calendar " + (rangePicker ? 'calendar-range' : '') + " " + (cssClass || '') + "\">\n            " + (header ? calendar.renderHeader() : '') + "\n            " + (toolbar ? calendar.renderToolbar() : '') + "\n            " + (weekHeader ? calendar.renderWeekHeader() : '') + "\n            <div class=\"calendar-months\">\n              " + (calendar.renderMonths(date)) + "\n            </div>\n            " + (footer ? calendar.renderFooter() : '') + "\n          </div>\n        </div>\n      </div>\n    ").trim();

	    return popoverHtml;
	  };
	  Calendar.prototype.render = function render () {
	    var calendar = this;
	    var params = calendar.params;
	    if (params.render) { return params.render.call(calendar); }
	    if (!calendar.inline) {
	      var modalType = params.openIn;
	      if (modalType === 'auto') { modalType = calendar.isPopover() ? 'popover' : 'sheet'; }

	      if (modalType === 'popover') { return calendar.renderPopover(); }
	      else if (modalType === 'sheet') { return calendar.renderSheet(); }
	      return calendar.renderCustomModal();
	    }
	    return calendar.renderInline();
	  };
	  Calendar.prototype.onOpen = function onOpen () {
	    var calendar = this;
	    var initialized = calendar.initialized;
	    var $el = calendar.$el;
	    var app = calendar.app;
	    var $inputEl = calendar.$inputEl;
	    var inline = calendar.inline;
	    var value = calendar.value;
	    var params = calendar.params;
	    calendar.opened = true;

	    // Init main events
	    calendar.attachCalendarEvents();

	    var updateValue = !value && params.value;

	    // Set value
	    if (!initialized) {
	      if (value) { calendar.setValue(value, 0); }
	      else if (params.value) {
	        calendar.setValue(calendar.normalizeValues(params.value), 0);
	      }
	    } else if (value) {
	      calendar.setValue(value, 0);
	    }

	    // Update current month and year
	    calendar.updateCurrentMonthYear();

	    // Set initial translate
	    calendar.monthsTranslate = 0;
	    calendar.setMonthsTranslate();

	    // Update input value
	    if (updateValue) { calendar.updateValue(); }
	    else if (params.header && value) {
	      calendar.updateValue(true);
	    }

	    // Extra focus
	    if (!inline && $inputEl.length && app.theme === 'md') {
	      $inputEl.trigger('focus');
	    }

	    calendar.initialized = true;

	    calendar.$months.each(function (index, monthEl) {
	      calendar.emit('local::monthAdd calendarMonthAdd', monthEl);
	    });

	    // Trigger events
	    if ($el) {
	      $el.trigger('calendar:open', calendar);
	    }
	    if ($inputEl) {
	      $inputEl.trigger('calendar:open', calendar);
	    }
	    calendar.emit('local::open calendarOpen', calendar);
	  };
	  Calendar.prototype.onOpened = function onOpened () {
	    var calendar = this;
	    if (calendar.$el) {
	      calendar.$el.trigger('calendar:opened', calendar);
	    }
	    if (calendar.$inputEl) {
	      calendar.$inputEl.trigger('calendar:opened', calendar);
	    }
	    calendar.emit('local::opened calendarOpened', calendar);
	  };
	  Calendar.prototype.onClose = function onClose () {
	    var calendar = this;
	    var app = calendar.app;

	    if (calendar.$inputEl && app.theme === 'md') {
	      calendar.$inputEl.trigger('blur');
	    }
	    if (calendar.detachCalendarEvents) {
	      calendar.detachCalendarEvents();
	    }

	    if (calendar.$el) {
	      calendar.$el.trigger('calendar:close', calendar);
	    }
	    if (calendar.$inputEl) {
	      calendar.$inputEl.trigger('calendar:close', calendar);
	    }
	    calendar.emit('local::close calendarClose', calendar);
	  };
	  Calendar.prototype.onClosed = function onClosed () {
	    var calendar = this;
	    calendar.opened = false;

	    if (!calendar.inline) {
	      Utils.nextTick(function () {
	        if (calendar.modal && calendar.modal.el && calendar.modal.destroy) {
	          if (!calendar.params.routableModals) {
	            calendar.modal.destroy();
	          }
	        }
	        delete calendar.modal;
	      });
	    }
	    if (calendar.$el) {
	      calendar.$el.trigger('calendar:closed', calendar);
	    }
	    if (calendar.$inputEl) {
	      calendar.$inputEl.trigger('calendar:closed', calendar);
	    }
	    calendar.emit('local::closed calendarClosed', calendar);
	  };
	  Calendar.prototype.open = function open () {
	    var calendar = this;
	    var app = calendar.app;
	    var opened = calendar.opened;
	    var inline = calendar.inline;
	    var $inputEl = calendar.$inputEl;
	    var params = calendar.params;
	    if (opened) { return; }

	    if (inline) {
	      calendar.$el = $$1(calendar.render());
	      calendar.$el[0].f7Calendar = calendar;
	      calendar.$wrapperEl = calendar.$el.find('.calendar-months-wrapper');
	      calendar.$months = calendar.$wrapperEl.find('.calendar-month');
	      calendar.$containerEl.append(calendar.$el);
	      calendar.onOpen();
	      calendar.onOpened();
	      return;
	    }
	    var modalType = params.openIn;
	    if (modalType === 'auto') {
	      modalType = calendar.isPopover() ? 'popover' : 'sheet';
	    }
	    var modalContent = calendar.render();

	    var modalParams = {
	      targetEl: $inputEl,
	      scrollToEl: calendar.params.scrollToInput ? $inputEl : undefined,
	      content: modalContent,
	      backdrop: modalType === 'popover' && app.params.popover.backdrop !== false,
	      on: {
	        open: function open() {
	          var modal = this;
	          calendar.modal = modal;
	          calendar.$el = modalType === 'popover' ? modal.$el.find('.calendar') : modal.$el;
	          calendar.$wrapperEl = calendar.$el.find('.calendar-months-wrapper');
	          calendar.$months = calendar.$wrapperEl.find('.calendar-month');
	          calendar.$el[0].f7Calendar = calendar;
	          if (modalType === 'customModal') {
	            $$1(calendar.$el).find('.calendar-close').once('click', function () {
	              calendar.close();
	            });
	          }
	          calendar.onOpen();
	        },
	        opened: function opened() { calendar.onOpened(); },
	        close: function close() { calendar.onClose(); },
	        closed: function closed() { calendar.onClosed(); },
	      },
	    };
	    if (calendar.params.routableModals) {
	      calendar.view.router.navigate({
	        url: calendar.url,
	        route: ( obj = {
	          path: calendar.url,
	        }, obj[modalType] = modalParams, obj ),
	      });
	      var obj;
	    } else {
	      calendar.modal = app[modalType].create(modalParams);
	      calendar.modal.open();
	    }
	  };
	  Calendar.prototype.close = function close () {
	    var calendar = this;
	    var opened = calendar.opened;
	    var inline = calendar.inline;
	    if (!opened) { return; }
	    if (inline) {
	      calendar.onClose();
	      calendar.onClosed();
	      return;
	    }
	    if (calendar.params.routableModals) {
	      calendar.view.router.back();
	    } else {
	      calendar.modal.close();
	    }
	  };
	  Calendar.prototype.init = function init () {
	    var calendar = this;

	    calendar.initInput();

	    if (calendar.inline) {
	      calendar.open();
	      calendar.emit('local::init calendarInit', calendar);
	      return;
	    }

	    if (!calendar.initialized && calendar.params.value) {
	      calendar.setValue(calendar.normalizeValues(calendar.params.value));
	    }

	    // Attach input Events
	    if (calendar.$inputEl) {
	      calendar.attachInputEvents();
	    }
	    if (calendar.params.closeByOutsideClick) {
	      calendar.attachHtmlEvents();
	    }
	    calendar.emit('local::init calendarInit', calendar);
	  };
	  Calendar.prototype.destroy = function destroy () {
	    var calendar = this;
	    if (calendar.destroyed) { return; }
	    var $el = calendar.$el;
	    calendar.emit('local::beforeDestroy calendarBeforeDestroy', calendar);
	    if ($el) { $el.trigger('calendar:beforedestroy', calendar); }

	    calendar.close();

	    // Detach Events
	    if (calendar.$inputEl) {
	      calendar.detachInputEvents();
	    }
	    if (calendar.params.closeByOutsideClick) {
	      calendar.detachHtmlEvents();
	    }

	    if ($el && $el.length) { delete calendar.$el[0].f7Calendar; }
	    Utils.deleteProps(calendar);
	    calendar.destroyed = true;
	  };

	  return Calendar;
	}(Framework7Class));

	var Calendar$1 = {
	  name: 'calendar',
	  static: {
	    Calendar: Calendar,
	  },
	  create: function create() {
	    var app = this;
	    app.calendar = ConstructorMethods({
	      defaultSelector: '.calendar',
	      constructor: Calendar,
	      app: app,
	      domProp: 'f7Calendar',
	    });
	    app.calendar.close = function close(el) {
	      if ( el === void 0 ) el = '.calendar';

	      var $el = $$1(el);
	      if ($el.length === 0) { return; }
	      var calendar = $el[0].f7Calendar;
	      if (!calendar || (calendar && !calendar.opened)) { return; }
	      calendar.close();
	    };
	  },
	  params: {
	    calendar: {
	      // Calendar settings
	      monthNames: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
	      monthNamesShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
	      dayNames: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
	      dayNamesShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
	      firstDay: 1, // First day of the week, Monday
	      weekendDays: [0, 6], // Sunday and Saturday
	      multiple: false,
	      rangePicker: false,
	      dateFormat: 'yyyy-mm-dd',
	      direction: 'horizontal', // or 'vertical'
	      minDate: null,
	      maxDate: null,
	      disabled: null, // dates range of disabled days
	      events: null, // dates range of days with events
	      rangesClasses: null, // array with custom classes date ranges
	      touchMove: true,
	      animate: true,
	      closeOnSelect: false,
	      monthSelector: true,
	      yearSelector: true,
	      weekHeader: true,
	      value: null,
	      // Common opener settings
	      containerEl: null,
	      openIn: 'auto', // or 'popover' or 'sheet' or 'customModal'
	      formatValue: null,
	      inputEl: null,
	      inputReadOnly: true,
	      closeByOutsideClick: true,
	      scrollToInput: true,
	      header: false,
	      headerPlaceholder: 'Select date',
	      footer: false,
	      toolbar: true,
	      toolbarCloseText: 'Done',
	      cssClass: null,
	      routableModals: true,
	      view: null,
	      url: 'date/',
	      // Render functions
	      renderWeekHeader: null,
	      renderMonths: null,
	      renderMonth: null,
	      renderMonthSelector: null,
	      renderYearSelector: null,
	      renderHeader: null,
	      renderFooter: null,
	      renderToolbar: null,
	      renderInline: null,
	      renderPopover: null,
	      renderSheet: null,
	      render: null,
	    },
	  },
	};

	var Messages = (function (Framework7Class$$1) {
	  function Messages(app, params) {
	    if ( params === void 0 ) params = {};

	    Framework7Class$$1.call(this, params, [app]);

	    var m = this;

	    var defaults = {
	      autoLayout: true,
	      messages: [],
	      newMessagesFirst: false,
	      scrollMessages: true,
	      scrollMessagesOnEdge: true,
	      firstMessageRule: undefined,
	      lastMessageRule: undefined,
	      tailMessageRule: undefined,
	      sameNameMessageRule: undefined,
	      sameHeaderMessageRule: undefined,
	      sameFooterMessageRule: undefined,
	      sameAvatarMessageRule: undefined,
	      customClassMessageRule: undefined,
	      renderMessage: undefined,
	    };

	    // Extend defaults with modules params
	    m.useModulesParams(defaults);

	    m.params = Utils.extend(defaults, params);

	    var $el = $$1(params.el).eq(0);
	    if ($el.length === 0) { return m; }

	    $el[0].f7Messages = m;

	    var $pageContentEl = $el.closest('.page-content').eq(0);

	    Utils.extend(m, {
	      messages: m.params.messages,
	      $el: $el,
	      el: $el[0],
	      $pageContentEl: $pageContentEl,
	      pageContentEl: $pageContentEl[0],

	    });
	    // Install Modules
	    m.useModules();

	    // Init
	    m.init();

	    return m;
	  }

	  if ( Framework7Class$$1 ) Messages.__proto__ = Framework7Class$$1;
	  Messages.prototype = Object.create( Framework7Class$$1 && Framework7Class$$1.prototype );
	  Messages.prototype.constructor = Messages;
	  // eslint-disable-next-line
	  Messages.prototype.getMessageData = function getMessageData (messageEl) {
	    var $messageEl = $$1(messageEl);
	    var data = {
	      name: $messageEl.find('.message-name').html(),
	      header: $messageEl.find('.message-header').html(),
	      textHeader: $messageEl.find('.message-text-header').html(),
	      textFooter: $messageEl.find('.message-text-footer').html(),
	      footer: $messageEl.find('.message-footer').html(),
	      isTitle: $messageEl.hasClass('messages-title'),
	      type: $messageEl.hasClass('message-sent') ? 'sent' : 'received',
	      text: $messageEl.find('.message-text').html(),
	      image: $messageEl.find('.message-image').html(),
	      imageSrc: $messageEl.find('.message-image img').attr('src'),
	      typing: $messageEl.hasClass('message-typing'),
	    };
	    if (data.isTitle) {
	      data.text = $messageEl.html();
	    }
	    if (data.text && data.textHeader) {
	      data.text = data.text.replace(("<div class=\"message-text-header\">" + (data.textHeader) + "</div>"), '');
	    }
	    if (data.text && data.textFooter) {
	      data.text = data.text.replace(("<div class=\"message-text-footer\">" + (data.textFooter) + "</div>"), '');
	    }
	    var avatar = $messageEl.find('.message-avatar').css('background-image');
	    if (avatar === 'none' || avatar === '') { avatar = undefined; }
	    if (avatar && typeof avatar === 'string') {
	      avatar = avatar.replace('url(', '').replace(')', '').replace(/"/g, '').replace(/'/g, '');
	    } else {
	      avatar = undefined;
	    }
	    data.avatar = avatar;

	    return data;
	  };
	  Messages.prototype.getMessagesData = function getMessagesData () {
	    var m = this;
	    var data = [];
	    m.$el.find('.message, .messages-title').each(function (index, messageEl) {
	      data.push(m.getMessageData(messageEl));
	    });
	    return data;
	  };
	  Messages.prototype.renderMessage = function renderMessage (messageToRender) {
	    var m = this;
	    var message = Utils.extend({
	      type: 'sent',
	    }, messageToRender);
	    if (m.params.renderMessage) {
	      return m.params.renderMessage.call(m, message);
	    }
	    if (message.isTitle) {
	      return ("<div class=\"messages-title\">" + (message.text) + "</div>");
	    }
	    return ("\n      <div class=\"message message-" + (message.type) + " " + (message.isTyping ? 'message-typing' : '') + "\">\n        " + (message.avatar ? ("\n        <div class=\"message-avatar\" style=\"background-image:url(" + (message.avatar) + ")\"></div>\n        ") : '') + "\n        <div class=\"message-content\">\n          " + (message.name ? ("<div class=\"message-name\">" + (message.name) + "</div>") : '') + "\n          " + (message.header ? ("<div class=\"message-header\">" + (message.header) + "</div>") : '') + "\n          <div class=\"message-bubble\">\n            " + (message.textHeader ? ("<div class=\"message-text-header\">" + (message.textHeader) + "</div>") : '') + "\n            " + (message.image ? ("<div class=\"message-image\">" + (message.image) + "</div>") : '') + "\n            " + (message.imageSrc && !message.image ? ("<div class=\"message-image\"><img src=\"" + (message.imageSrc) + "\"></div>") : '') + "\n            " + (message.text || message.isTyping ? ("<div class=\"message-text\">" + (message.text || '') + (message.isTyping ? '<div class="message-typing-indicator"><div></div><div></div><div></div></div>' : '') + "</div>") : '') + "\n            " + (message.textFooter ? ("<div class=\"message-text-footer\">" + (message.textFooter) + "</div>") : '') + "\n          </div>\n          " + (message.footer ? ("<div class=\"message-footer\">" + (message.footer) + "</div>") : '') + "\n        </div>\n      </div>\n    ");
	  };
	  Messages.prototype.renderMessages = function renderMessages (messagesToRender, method) {
	    if ( messagesToRender === void 0 ) messagesToRender = this.messages;
	    if ( method === void 0 ) method = this.params.newMessagesFirst ? 'prepend' : 'append';

	    var m = this;
	    var html = messagesToRender.map(function (message) { return m.renderMessage(message); }).join('');
	    m.$el[method](html);
	  };
	  Messages.prototype.isFirstMessage = function isFirstMessage () {
	    var args = [], len = arguments.length;
	    while ( len-- ) args[ len ] = arguments[ len ];

	    var m = this;
	    if (m.params.firstMessageRule) { return (ref = m.params).firstMessageRule.apply(ref, args); }
	    return false;
	    var ref;
	  };
	  Messages.prototype.isLastMessage = function isLastMessage () {
	    var args = [], len = arguments.length;
	    while ( len-- ) args[ len ] = arguments[ len ];

	    var m = this;
	    if (m.params.lastMessageRule) { return (ref = m.params).lastMessageRule.apply(ref, args); }
	    return false;
	    var ref;
	  };
	  Messages.prototype.isTailMessage = function isTailMessage () {
	    var args = [], len = arguments.length;
	    while ( len-- ) args[ len ] = arguments[ len ];

	    var m = this;
	    if (m.params.tailMessageRule) { return (ref = m.params).tailMessageRule.apply(ref, args); }
	    return false;
	    var ref;
	  };
	  Messages.prototype.isSameNameMessage = function isSameNameMessage () {
	    var args = [], len = arguments.length;
	    while ( len-- ) args[ len ] = arguments[ len ];

	    var m = this;
	    if (m.params.sameNameMessageRule) { return (ref = m.params).sameNameMessageRule.apply(ref, args); }
	    return false;
	    var ref;
	  };
	  Messages.prototype.isSameHeaderMessage = function isSameHeaderMessage () {
	    var args = [], len = arguments.length;
	    while ( len-- ) args[ len ] = arguments[ len ];

	    var m = this;
	    if (m.params.sameHeaderMessageRule) { return (ref = m.params).sameHeaderMessageRule.apply(ref, args); }
	    return false;
	    var ref;
	  };
	  Messages.prototype.isSameFooterMessage = function isSameFooterMessage () {
	    var args = [], len = arguments.length;
	    while ( len-- ) args[ len ] = arguments[ len ];

	    var m = this;
	    if (m.params.sameFooterMessageRule) { return (ref = m.params).sameFooterMessageRule.apply(ref, args); }
	    return false;
	    var ref;
	  };
	  Messages.prototype.isSameAvatarMessage = function isSameAvatarMessage () {
	    var args = [], len = arguments.length;
	    while ( len-- ) args[ len ] = arguments[ len ];

	    var m = this;
	    if (m.params.sameAvatarMessageRule) { return (ref = m.params).sameAvatarMessageRule.apply(ref, args); }
	    return false;
	    var ref;
	  };
	  Messages.prototype.isCustomClassMessage = function isCustomClassMessage () {
	    var args = [], len = arguments.length;
	    while ( len-- ) args[ len ] = arguments[ len ];

	    var m = this;
	    if (m.params.customClassMessageRule) { return (ref = m.params).customClassMessageRule.apply(ref, args); }
	    return undefined;
	    var ref;
	  };
	  Messages.prototype.layout = function layout () {
	    var m = this;
	    m.$el.find('.message, .messages-title').each(function (index, messageEl) {
	      var $messageEl = $$1(messageEl);
	      if (!m.messages) {
	        m.messages = m.getMessagesData();
	      }
	      var classes = [];
	      var message = m.messages[index];
	      var previousMessage = m.messages[index - 1];
	      var nextMessage = m.messages[index + 1];
	      if (m.isFirstMessage(message, previousMessage, nextMessage)) {
	        classes.push('message-first');
	      }
	      if (m.isLastMessage(message, previousMessage, nextMessage)) {
	        classes.push('message-last');
	      }
	      if (m.isTailMessage(message, previousMessage, nextMessage)) {
	        classes.push('message-tail');
	      }
	      if (m.isSameNameMessage(message, previousMessage, nextMessage)) {
	        classes.push('message-same-name');
	      }
	      if (m.isSameHeaderMessage(message, previousMessage, nextMessage)) {
	        classes.push('message-same-header');
	      }
	      if (m.isSameFooterMessage(message, previousMessage, nextMessage)) {
	        classes.push('message-same-footer');
	      }
	      if (m.isSameAvatarMessage(message, previousMessage, nextMessage)) {
	        classes.push('message-same-avatar');
	      }
	      var customMessageClasses = m.isCustomClassMessage(message, previousMessage, nextMessage);
	      if (customMessageClasses && customMessageClasses.length) {
	        if (typeof customMessageClasses === 'string') {
	          customMessageClasses = customMessageClasses.split(' ');
	        }
	        customMessageClasses.forEach(function (customClass) {
	          classes.push(customClass);
	        });
	      }
	      $messageEl.removeClass('message-first message-last message-tail message-same-name message-same-header message-same-footer message-same-avatar');
	      classes.forEach(function (className) {
	        $messageEl.addClass(className);
	      });
	    });
	  };
	  Messages.prototype.clear = function clear () {
	    var m = this;
	    m.messages = [];
	    m.$el.html('');
	  };
	  Messages.prototype.removeMessage = function removeMessage (messageToRemove, layout) {
	    if ( layout === void 0 ) layout = true;

	    var m = this;
	    // Index or El
	    var index;
	    var $el;
	    if (typeof messageToRemove === 'number') {
	      index = messageToRemove;
	      $el = m.$el.find('.message, .messages-title').eq(index);
	    } else if (m.messages && m.messages.indexOf(messageToRemove) >= 0) {
	      index = m.messages.indexOf(messageToRemove);
	      $el = m.$el.children().eq(index);
	    } else {
	      $el = $$1(messageToRemove);
	      index = $el.index();
	    }
	    if ($el.length === 0) {
	      return m;
	    }
	    $el.remove();
	    m.messages.splice(index, 1);
	    if (m.params.autoLayout && layout) { m.layout(); }
	    return m;
	  };
	  Messages.prototype.removeMessages = function removeMessages (messagesToRemove, layout) {
	    if ( layout === void 0 ) layout = true;

	    var m = this;
	    if (Array.isArray(messagesToRemove)) {
	      var messagesToRemoveEls = [];
	      messagesToRemove.forEach(function (messageToRemoveIndex) {
	        messagesToRemoveEls.push(m.$el.find('.message, .messages-title').eq(messageToRemoveIndex));
	      });
	      messagesToRemoveEls.forEach(function (messageToRemove) {
	        m.removeMessage(messageToRemove, false);
	      });
	    } else {
	      $$1(messagesToRemove).each(function (index, messageToRemove) {
	        m.removeMessage(messageToRemove, false);
	      });
	    }
	    if (m.params.autoLayout && layout) { m.layout(); }
	    return m;
	  };

	  Messages.prototype.addMessage = function addMessage () {
	    var args = [], len = arguments.length;
	    while ( len-- ) args[ len ] = arguments[ len ];

	    var m = this;
	    var messageToAdd;
	    var animate;
	    var method;
	    if (typeof args[1] === 'boolean') {
	      var assign;
	      (assign = args, messageToAdd = assign[0], animate = assign[1], method = assign[2]);
	    } else {
	      var assign$1;
	      (assign$1 = args, messageToAdd = assign$1[0], method = assign$1[1], animate = assign$1[2]);
	    }
	    if (typeof animate === 'undefined') {
	      animate = true;
	    }
	    if (typeof method === 'undefined') {
	      method = m.params.newMessagesFirst ? 'prepend' : 'append';
	    }

	    return m.addMessages([messageToAdd], animate, method);
	  };
	  Messages.prototype.addMessages = function addMessages () {
	    var args = [], len = arguments.length;
	    while ( len-- ) args[ len ] = arguments[ len ];

	    var m = this;
	    var messagesToAdd;
	    var animate;
	    var method;
	    if (typeof args[1] === 'boolean') {
	      var assign;
	      (assign = args, messagesToAdd = assign[0], animate = assign[1], method = assign[2]);
	    } else {
	      var assign$1;
	      (assign$1 = args, messagesToAdd = assign$1[0], method = assign$1[1], animate = assign$1[2]);
	    }
	    if (typeof animate === 'undefined') {
	      animate = true;
	    }
	    if (typeof method === 'undefined') {
	      method = m.params.newMessagesFirst ? 'prepend' : 'append';
	    }

	    // Define scroll positions before new messages added
	    var scrollHeightBefore = m.pageContentEl.scrollHeight;
	    var heightBefore = m.pageContentEl.offsetHeight;
	    var scrollBefore = m.pageContentEl.scrollTop;

	    // Add message to DOM and data
	    var messagesHTML = '';
	    var typingMessage = m.messages.filter(function (el) { return el.isTyping; })[0];
	    messagesToAdd.forEach(function (messageToAdd) {
	      if (typingMessage) {
	        if (method === 'append') {
	          m.messages.splice(m.messages.indexOf(typingMessage), 0, messageToAdd);
	        } else {
	          m.messages.splice(m.messages.indexOf(typingMessage) + 1, 0, messageToAdd);
	        }
	      } else {
	        m.messages[method === 'append' ? 'push' : 'unshift'](messageToAdd);
	      }
	      messagesHTML += m.renderMessage(messageToAdd);
	    });
	    var $messagesEls = $$1(messagesHTML);
	    if (animate) {
	      if (method === 'append' && !m.params.newMessagesFirst) {
	        $messagesEls.addClass('message-appear-from-bottom');
	      }
	      if (method === 'prepend' && m.params.newMessagesFirst) {
	        $messagesEls.addClass('message-appear-from-top');
	      }
	    }
	    if (typingMessage) {
	      if (method === 'append') {
	        $messagesEls.insertBefore(m.$el.find('.message-typing'));
	      } else {
	        $messagesEls.insertAfter(m.$el.find('.message-typing'));
	      }
	    } else {
	      m.$el[method]($messagesEls);
	    }

	    // Layout
	    if (m.params.autoLayout) { m.layout(); }

	    if (method === 'prepend' && !typingMessage) {
	      m.pageContentEl.scrollTop = scrollBefore + (m.pageContentEl.scrollHeight - scrollHeightBefore);
	    }

	    if (m.params.scrollMessages && ((method === 'append' && !m.params.newMessagesFirst) || (method === 'prepend' && m.params.newMessagesFirst && !typingMessage))) {
	      if (m.params.scrollMessagesOnEdge) {
	        var onEdge = false;
	        if (m.params.newMessagesFirst && scrollBefore === 0) {
	          onEdge = true;
	        }
	        if (!m.params.newMessagesFirst && (scrollBefore - (scrollHeightBefore - heightBefore) >= -10)) {
	          onEdge = true;
	        }
	        if (onEdge) { m.scroll(animate ? undefined : 0); }
	      } else {
	        m.scroll(animate ? undefined : 0);
	      }
	    }

	    return m;
	  };
	  Messages.prototype.showTyping = function showTyping (message) {
	    if ( message === void 0 ) message = {};

	    var m = this;
	    var typingMessage = m.messages.filter(function (el) { return el.isTyping; })[0];
	    if (typingMessage) {
	      m.removeMessage(m.messages.indexOf(typingMessage));
	    }
	    m.addMessage(Utils.extend({
	      type: 'received',
	      isTyping: true,
	    }, message));
	    return m;
	  };
	  Messages.prototype.hideTyping = function hideTyping () {
	    var m = this;
	    var typingMessageIndex;
	    var typingFound;
	    m.messages.forEach(function (message, index) {
	      if (message.isTyping) { typingMessageIndex = index; }
	    });
	    if (typeof typingMessageIndex !== 'undefined') {
	      if (m.$el.find('.message').eq(typingMessageIndex).hasClass('message-typing')) {
	        typingFound = true;
	        m.removeMessage(typingMessageIndex);
	      }
	    }
	    if (!typingFound) {
	      var $typingMessageEl = m.$el.find('.message-typing');
	      if ($typingMessageEl.length) {
	        m.removeMessage($typingMessageEl);
	      }
	    }
	    return m;
	  };
	  Messages.prototype.scroll = function scroll (duration, scrollTop) {
	    if ( duration === void 0 ) duration = 300;

	    var m = this;
	    var currentScroll = m.pageContentEl.scrollTop;
	    var newScrollTop;
	    if (typeof scrollTop !== 'undefined') { newScrollTop = scrollTop; }
	    else {
	      newScrollTop = m.params.newMessagesFirst ? 0 : m.pageContentEl.scrollHeight - m.pageContentEl.offsetHeight;
	      if (newScrollTop === currentScroll) { return m; }
	    }
	    m.$pageContentEl.scrollTop(newScrollTop, duration);
	    return m;
	  };
	  Messages.prototype.init = function init () {
	    var m = this;
	    if (!m.messages || m.messages.length === 0) {
	      m.messages = m.getMessagesData();
	    }
	    if (m.params.messages && m.params.messages.length) {
	      m.renderMessages();
	    }
	    if (m.params.autoLayout) { m.layout(); }
	    if (m.params.scrollMessages) { m.scroll(0); }
	  };
	  Messages.prototype.destroy = function destroy () {
	    var m = this;
	    m.emit('local::beforeDestroy messagesBeforeDestroy', m);
	    m.$el.trigger('messages:beforedestroy', m);
	    m.$el[0].f7Messages = null;
	    delete m.$el[0].f7Messages;
	    Utils.deleteProps(m);
	  };

	  return Messages;
	}(Framework7Class));

	var Messages$1 = {
	  name: 'messages',
	  static: {
	    Messages: Messages,
	  },
	  create: function create() {
	    var app = this;
	    app.messages = ConstructorMethods({
	      defaultSelector: '.messages',
	      constructor: Messages,
	      app: app,
	      domProp: 'f7Messages',
	      addMethods: 'renderMessages layout scroll clear removeMessage removeMessages addMessage addMessages'.split(' '),
	    });
	  },
	  on: {
	    tabBeforeRemove: function tabBeforeRemove(tabEl) {
	      var app = this;
	      $$1(tabEl).find('.messages-init').each(function (index, messagesEl) {
	        app.messages.destroy(messagesEl);
	      });
	    },
	    tabMounted: function tabMounted(tabEl) {
	      var app = this;
	      $$1(tabEl).find('.messages-init').each(function (index, messagesEl) {
	        app.messages.create({ el: messagesEl });
	      });
	    },
	    pageBeforeRemove: function pageBeforeRemove(page) {
	      var app = this;
	      page.$el.find('.messages-init').each(function (index, messagesEl) {
	        app.messages.destroy(messagesEl);
	      });
	    },
	    pageInit: function pageInit(page) {
	      var app = this;
	      page.$el.find('.messages-init').each(function (index, messagesEl) {
	        app.messages.create({ el: messagesEl });
	      });
	    },
	  },
	  clicks: {

	  },
	};

	var Messagebar = (function (Framework7Class$$1) {
	  function Messagebar(app, params) {
	    if ( params === void 0 ) params = {};

	    Framework7Class$$1.call(this, params, [app]);

	    var messagebar = this;

	    var defaults = {
	      top: false,
	      topOffset: 0,
	      bottomOffset: 0,
	      attachments: [],
	      renderAttachments: undefined,
	      renderAttachment: undefined,
	      maxHeight: null,
	      resizePage: true,
	    };

	    // Extend defaults with modules params
	    messagebar.useModulesParams(defaults);

	    messagebar.params = Utils.extend(defaults, params);

	    // El
	    var $el = $$1(messagebar.params.el);
	    if ($el.length === 0) { return messagebar; }

	    $el[0].f7Messagebar = messagebar;

	    // Page and PageContent
	    var $pageEl = $el.parents('.page').eq(0);
	    var $pageContentEl = $pageEl.find('.page-content').eq(0);

	    // Area
	    var $areaEl = $el.find('.messagebar-area');

	    // Textarea
	    var $textareaEl;
	    if (messagebar.params.textareaEl) {
	      $textareaEl = $$1(messagebar.params.textareaEl);
	    } else {
	      $textareaEl = $el.find('textarea');
	    }

	    // Attachments & Library
	    var $attachmentsEl = $el.find('.messagebar-attachments');
	    var $sheetEl = $el.find('.messagebar-sheet');

	    if (messagebar.params.top) {
	      $el.addClass('messagebar-top');
	    }

	    Utils.extend(messagebar, {
	      $el: $el,
	      el: $el[0],
	      $areaEl: $areaEl,
	      areaEl: $areaEl[0],
	      $textareaEl: $textareaEl,
	      textareaEl: $textareaEl[0],
	      $attachmentsEl: $attachmentsEl,
	      attachmentsEl: $attachmentsEl[0],
	      attachmentsVisible: $attachmentsEl.hasClass('messagebar-attachments-visible'),
	      $sheetEl: $sheetEl,
	      sheetEl: $sheetEl[0],
	      sheetVisible: $sheetEl.hasClass('messagebar-sheet-visible'),
	      $pageEl: $pageEl,
	      pageEl: $pageEl[0],
	      $pageContentEl: $pageContentEl,
	      pageContentEl: $pageContentEl,
	      top: $el.hasClass('messagebar-top') || messagebar.params.top,
	      attachments: [],
	    });

	    // Events
	    function onAppResize() {
	      if (messagebar.params.resizePage) {
	        messagebar.resizePage();
	      }
	    }
	    function onSubmit(e) {
	      e.preventDefault();
	    }
	    function onAttachmentClick(e) {
	      var index = $$1(this).index();
	      if ($$1(e.target).closest('.messagebar-attachment-delete').length) {
	        $$1(this).trigger('messagebar:attachmentdelete', index);
	        messagebar.emit('local::attachmentDelete messagebarAttachmentDelete', messagebar, this, index);
	      } else {
	        $$1(this).trigger('messagebar:attachmentclick', index);
	        messagebar.emit('local::attachmentClick messagebarAttachmentClick', messagebar, this, index);
	      }
	    }
	    function onTextareaChange() {
	      messagebar.checkEmptyState();
	      messagebar.$el.trigger('messagebar:change');
	      messagebar.emit('local::change messagebarChange', messagebar);
	    }
	    function onTextareaFocus() {
	      messagebar.sheetHide();
	      messagebar.$el.addClass('messagebar-focused');
	      messagebar.$el.trigger('messagebar:focus');
	      messagebar.emit('local::focus messagebarFocus', messagebar);
	    }
	    function onTextareaBlur() {
	      messagebar.$el.removeClass('messagebar-focused');
	      messagebar.$el.trigger('messagebar:blur');
	      messagebar.emit('local::blur messagebarBlur', messagebar);
	    }

	    messagebar.attachEvents = function attachEvents() {
	      $el.on('textarea:resize', onAppResize);
	      $el.on('submit', onSubmit);
	      $el.on('click', '.messagebar-attachment', onAttachmentClick);
	      $textareaEl.on('change input', onTextareaChange);
	      $textareaEl.on('focus', onTextareaFocus);
	      $textareaEl.on('blur', onTextareaBlur);
	      app.on('resize', onAppResize);
	    };
	    messagebar.detachEvents = function detachEvents() {
	      $el.off('textarea:resize', onAppResize);
	      $el.off('submit', onSubmit);
	      $el.off('click', '.messagebar-attachment', onAttachmentClick);
	      $textareaEl.off('change input', onTextareaChange);
	      $textareaEl.off('focus', onTextareaFocus);
	      $textareaEl.off('blur', onTextareaBlur);
	      app.off('resize', onAppResize);
	    };


	    // Install Modules
	    messagebar.useModules();

	    // Init
	    messagebar.init();

	    return messagebar;
	  }

	  if ( Framework7Class$$1 ) Messagebar.__proto__ = Framework7Class$$1;
	  Messagebar.prototype = Object.create( Framework7Class$$1 && Framework7Class$$1.prototype );
	  Messagebar.prototype.constructor = Messagebar;
	  Messagebar.prototype.focus = function focus () {
	    var messagebar = this;
	    messagebar.$textareaEl.focus();
	    return messagebar;
	  };
	  Messagebar.prototype.blur = function blur () {
	    var messagebar = this;
	    messagebar.$textareaEl.blur();
	    return messagebar;
	  };
	  Messagebar.prototype.clear = function clear () {
	    var messagebar = this;
	    messagebar.$textareaEl.val('').trigger('change');
	    return messagebar;
	  };
	  Messagebar.prototype.getValue = function getValue () {
	    var messagebar = this;
	    return messagebar.$textareaEl.val().trim();
	  };
	  Messagebar.prototype.setValue = function setValue (value) {
	    var messagebar = this;
	    messagebar.$textareaEl.val(value).trigger('change');
	    return messagebar;
	  };
	  Messagebar.prototype.setPlaceholder = function setPlaceholder (placeholder) {
	    var messagebar = this;
	    messagebar.$textareaEl.attr('placeholder', placeholder);
	    return messagebar;
	  };
	  Messagebar.prototype.resizePage = function resizePage () {
	    var messagebar = this;
	    var params = messagebar.params;
	    var $el = messagebar.$el;
	    var top = messagebar.top;
	    var $pageEl = messagebar.$pageEl;
	    var $pageContentEl = messagebar.$pageContentEl;
	    var $areaEl = messagebar.$areaEl;
	    var $textareaEl = messagebar.$textareaEl;
	    var $sheetEl = messagebar.$sheetEl;
	    var $attachmentsEl = messagebar.$attachmentsEl;
	    var elHeight = $el[0].offsetHeight;
	    var maxHeight = params.maxHeight;
	    if (top) ; else {
	      var currentPaddingBottom = parseInt($pageContentEl.css('padding-bottom'), 10);
	      var requiredPaddingBottom = elHeight + params.bottomOffset;
	      if (requiredPaddingBottom !== currentPaddingBottom && $pageContentEl.length) {
	        var currentPaddingTop = parseInt($pageContentEl.css('padding-top'), 10);
	        var pageScrollHeight = $pageContentEl[0].scrollHeight;
	        var pageOffsetHeight = $pageContentEl[0].offsetHeight;
	        var pageScrollTop = $pageContentEl[0].scrollTop;
	        var scrollOnBottom = (pageScrollTop === pageScrollHeight - pageOffsetHeight);
	        if (!maxHeight) {
	          maxHeight = $pageEl[0].offsetHeight - currentPaddingTop - $sheetEl.outerHeight() - $attachmentsEl.outerHeight() - parseInt($areaEl.css('margin-top'), 10) - parseInt($areaEl.css('margin-bottom'), 10);
	        }
	        $textareaEl.css('max-height', (maxHeight + "px"));
	        $pageContentEl.css('padding-bottom', (requiredPaddingBottom + "px"));
	        if (scrollOnBottom) {
	          $pageContentEl.scrollTop($pageContentEl[0].scrollHeight - pageOffsetHeight);
	        }
	        $el.trigger('messagebar:resizepage');
	        messagebar.emit('local::resizePage messagebarResizePage', messagebar);
	      }
	    }
	  };
	  Messagebar.prototype.checkEmptyState = function checkEmptyState () {
	    var messagebar = this;
	    var $el = messagebar.$el;
	    var $textareaEl = messagebar.$textareaEl;
	    var value = $textareaEl.val().trim();
	    if (value && value.length) {
	      $el.addClass('messagebar-with-value');
	    } else {
	      $el.removeClass('messagebar-with-value');
	    }
	  };
	  Messagebar.prototype.attachmentsCreate = function attachmentsCreate (innerHTML) {
	    if ( innerHTML === void 0 ) innerHTML = '';

	    var messagebar = this;
	    var $attachmentsEl = $$1(("<div class=\"messagebar-attachments\">" + innerHTML + "</div>"));
	    $attachmentsEl.insertBefore(messagebar.$textareaEl);
	    Utils.extend(messagebar, {
	      $attachmentsEl: $attachmentsEl,
	      attachmentsEl: $attachmentsEl[0],
	    });
	    return messagebar;
	  };
	  Messagebar.prototype.attachmentsShow = function attachmentsShow (innerHTML) {
	    if ( innerHTML === void 0 ) innerHTML = '';

	    var messagebar = this;
	    messagebar.$attachmentsEl = messagebar.$el.find('.messagebar-attachments');
	    if (messagebar.$attachmentsEl.length === 0) {
	      messagebar.attachmentsCreate(innerHTML);
	    }
	    messagebar.$el.addClass('messagebar-attachments-visible');
	    messagebar.attachmentsVisible = true;
	    if (messagebar.params.resizePage) {
	      messagebar.resizePage();
	    }
	    return messagebar;
	  };
	  Messagebar.prototype.attachmentsHide = function attachmentsHide () {
	    var messagebar = this;
	    messagebar.$el.removeClass('messagebar-attachments-visible');
	    messagebar.attachmentsVisible = false;
	    if (messagebar.params.resizePage) {
	      messagebar.resizePage();
	    }
	    return messagebar;
	  };
	  Messagebar.prototype.attachmentsToggle = function attachmentsToggle () {
	    var messagebar = this;
	    if (messagebar.attachmentsVisible) {
	      messagebar.attachmentsHide();
	    } else {
	      messagebar.attachmentsShow();
	    }
	    return messagebar;
	  };
	  Messagebar.prototype.renderAttachment = function renderAttachment (attachment) {
	    var messagebar = this;
	    if (messagebar.params.renderAttachment) {
	      return messagebar.params.renderAttachment.call(messagebar, attachment);
	    }
	    return ("\n      <div class=\"messagebar-attachment\">\n        <img src=\"" + attachment + "\">\n        <span class=\"messagebar-attachment-delete\"></span>\n      </div>\n    ");
	  };
	  Messagebar.prototype.renderAttachments = function renderAttachments () {
	    var messagebar = this;
	    var html;
	    if (messagebar.params.renderAttachments) {
	      html = messagebar.params.renderAttachments.call(messagebar, messagebar.attachments);
	    } else {
	      html = "" + (messagebar.attachments.map(function (attachment) { return messagebar.renderAttachment(attachment); }).join(''));
	    }
	    if (messagebar.$attachmentsEl.length === 0) {
	      messagebar.attachmentsCreate(html);
	    } else {
	      messagebar.$attachmentsEl.html(html);
	    }
	  };
	  Messagebar.prototype.sheetCreate = function sheetCreate (innerHTML) {
	    if ( innerHTML === void 0 ) innerHTML = '';

	    var messagebar = this;
	    var $sheetEl = $$1(("<div class=\"messagebar-sheet\">" + innerHTML + "</div>"));
	    messagebar.$el.append($sheetEl);
	    Utils.extend(messagebar, {
	      $sheetEl: $sheetEl,
	      sheetEl: $sheetEl[0],
	    });
	    return messagebar;
	  };
	  Messagebar.prototype.sheetShow = function sheetShow (innerHTML) {
	    if ( innerHTML === void 0 ) innerHTML = '';

	    var messagebar = this;
	    messagebar.$sheetEl = messagebar.$el.find('.messagebar-sheet');
	    if (messagebar.$sheetEl.length === 0) {
	      messagebar.sheetCreate(innerHTML);
	    }
	    messagebar.$el.addClass('messagebar-sheet-visible');
	    messagebar.sheetVisible = true;
	    if (messagebar.params.resizePage) {
	      messagebar.resizePage();
	    }
	    return messagebar;
	  };
	  Messagebar.prototype.sheetHide = function sheetHide () {
	    var messagebar = this;
	    messagebar.$el.removeClass('messagebar-sheet-visible');
	    messagebar.sheetVisible = false;
	    if (messagebar.params.resizePage) {
	      messagebar.resizePage();
	    }
	    return messagebar;
	  };
	  Messagebar.prototype.sheetToggle = function sheetToggle () {
	    var messagebar = this;
	    if (messagebar.sheetVisible) {
	      messagebar.sheetHide();
	    } else {
	      messagebar.sheetShow();
	    }
	    return messagebar;
	  };
	  Messagebar.prototype.init = function init () {
	    var messagebar = this;
	    messagebar.attachEvents();
	    messagebar.checkEmptyState();
	    return messagebar;
	  };
	  Messagebar.prototype.destroy = function destroy () {
	    var messagebar = this;
	    messagebar.emit('local::beforeDestroy messagebarBeforeDestroy', messagebar);
	    messagebar.$el.trigger('messagebar:beforedestroy', messagebar);
	    messagebar.detachEvents();
	    messagebar.$el[0].f7Messagebar = null;
	    delete messagebar.$el[0].f7Messagebar;
	    Utils.deleteProps(messagebar);
	  };

	  return Messagebar;
	}(Framework7Class));

	var Messagebar$1 = {
	  name: 'messagebar',
	  static: {
	    Messagebar: Messagebar,
	  },
	  create: function create() {
	    var app = this;
	    app.messagebar = ConstructorMethods({
	      defaultSelector: '.messagebar',
	      constructor: Messagebar,
	      app: app,
	      domProp: 'f7Messagebar',
	      addMethods: 'clear getValue setValue setPlaceholder resizePage focus blur attachmentsCreate attachmentsShow attachmentsHide attachmentsToggle renderAttachments sheetCreate sheetShow sheetHide sheetToggle'.split(' '),
	    });
	  },
	  on: {
	    tabBeforeRemove: function tabBeforeRemove(tabEl) {
	      var app = this;
	      $$1(tabEl).find('.messagebar-init').each(function (index, messagebarEl) {
	        app.messagebar.destroy(messagebarEl);
	      });
	    },
	    tabMounted: function tabMounted(tabEl) {
	      var app = this;
	      $$1(tabEl).find('.messagebar-init').each(function (index, messagebarEl) {
	        app.messagebar.create(Utils.extend({ el: messagebarEl }, $$1(messagebarEl).dataset()));
	      });
	    },
	    pageBeforeRemove: function pageBeforeRemove(page) {
	      var app = this;
	      page.$el.find('.messagebar-init').each(function (index, messagebarEl) {
	        app.messagebar.destroy(messagebarEl);
	      });
	    },
	    pageInit: function pageInit(page) {
	      var app = this;
	      page.$el.find('.messagebar-init').each(function (index, messagebarEl) {
	        app.messagebar.create(Utils.extend({ el: messagebarEl }, $$1(messagebarEl).dataset()));
	      });
	    },
	  },
	};

	function updateSize () {
	  var swiper = this;
	  var width;
	  var height;
	  var $el = swiper.$el;
	  if (typeof swiper.params.width !== 'undefined') {
	    width = swiper.params.width;
	  } else {
	    width = $el[0].clientWidth;
	  }
	  if (typeof swiper.params.height !== 'undefined') {
	    height = swiper.params.height;
	  } else {
	    height = $el[0].clientHeight;
	  }
	  if ((width === 0 && swiper.isHorizontal()) || (height === 0 && swiper.isVertical())) {
	    return;
	  }

	  // Subtract paddings
	  width = width - parseInt($el.css('padding-left'), 10) - parseInt($el.css('padding-right'), 10);
	  height = height - parseInt($el.css('padding-top'), 10) - parseInt($el.css('padding-bottom'), 10);

	  Utils.extend(swiper, {
	    width: width,
	    height: height,
	    size: swiper.isHorizontal() ? width : height,
	  });
	}

	function updateSlides () {
	  var swiper = this;
	  var params = swiper.params;

	  var $wrapperEl = swiper.$wrapperEl;
	  var swiperSize = swiper.size;
	  var rtl = swiper.rtlTranslate;
	  var wrongRTL = swiper.wrongRTL;
	  var isVirtual = swiper.virtual && params.virtual.enabled;
	  var previousSlidesLength = isVirtual ? swiper.virtual.slides.length : swiper.slides.length;
	  var slides = $wrapperEl.children(("." + (swiper.params.slideClass)));
	  var slidesLength = isVirtual ? swiper.virtual.slides.length : slides.length;
	  var snapGrid = [];
	  var slidesGrid = [];
	  var slidesSizesGrid = [];

	  var offsetBefore = params.slidesOffsetBefore;
	  if (typeof offsetBefore === 'function') {
	    offsetBefore = params.slidesOffsetBefore.call(swiper);
	  }

	  var offsetAfter = params.slidesOffsetAfter;
	  if (typeof offsetAfter === 'function') {
	    offsetAfter = params.slidesOffsetAfter.call(swiper);
	  }

	  var previousSnapGridLength = swiper.snapGrid.length;
	  var previousSlidesGridLength = swiper.snapGrid.length;

	  var spaceBetween = params.spaceBetween;
	  var slidePosition = -offsetBefore;
	  var prevSlideSize = 0;
	  var index = 0;
	  if (typeof swiperSize === 'undefined') {
	    return;
	  }
	  if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) {
	    spaceBetween = (parseFloat(spaceBetween.replace('%', '')) / 100) * swiperSize;
	  }

	  swiper.virtualSize = -spaceBetween;

	  // reset margins
	  if (rtl) { slides.css({ marginLeft: '', marginTop: '' }); }
	  else { slides.css({ marginRight: '', marginBottom: '' }); }

	  var slidesNumberEvenToRows;
	  if (params.slidesPerColumn > 1) {
	    if (Math.floor(slidesLength / params.slidesPerColumn) === slidesLength / swiper.params.slidesPerColumn) {
	      slidesNumberEvenToRows = slidesLength;
	    } else {
	      slidesNumberEvenToRows = Math.ceil(slidesLength / params.slidesPerColumn) * params.slidesPerColumn;
	    }
	    if (params.slidesPerView !== 'auto' && params.slidesPerColumnFill === 'row') {
	      slidesNumberEvenToRows = Math.max(slidesNumberEvenToRows, params.slidesPerView * params.slidesPerColumn);
	    }
	  }

	  // Calc slides
	  var slideSize;
	  var slidesPerColumn = params.slidesPerColumn;
	  var slidesPerRow = slidesNumberEvenToRows / slidesPerColumn;
	  var numFullColumns = slidesPerRow - ((params.slidesPerColumn * slidesPerRow) - slidesLength);
	  for (var i = 0; i < slidesLength; i += 1) {
	    slideSize = 0;
	    var slide = slides.eq(i);
	    if (params.slidesPerColumn > 1) {
	      // Set slides order
	      var newSlideOrderIndex = (void 0);
	      var column = (void 0);
	      var row = (void 0);
	      if (params.slidesPerColumnFill === 'column') {
	        column = Math.floor(i / slidesPerColumn);
	        row = i - (column * slidesPerColumn);
	        if (column > numFullColumns || (column === numFullColumns && row === slidesPerColumn - 1)) {
	          row += 1;
	          if (row >= slidesPerColumn) {
	            row = 0;
	            column += 1;
	          }
	        }
	        newSlideOrderIndex = column + ((row * slidesNumberEvenToRows) / slidesPerColumn);
	        slide
	          .css({
	            '-webkit-box-ordinal-group': newSlideOrderIndex,
	            '-moz-box-ordinal-group': newSlideOrderIndex,
	            '-ms-flex-order': newSlideOrderIndex,
	            '-webkit-order': newSlideOrderIndex,
	            order: newSlideOrderIndex,
	          });
	      } else {
	        row = Math.floor(i / slidesPerRow);
	        column = i - (row * slidesPerRow);
	      }
	      slide
	        .css(
	          ("margin-" + (swiper.isHorizontal() ? 'top' : 'left')),
	          (row !== 0 && params.spaceBetween) && (((params.spaceBetween) + "px"))
	        )
	        .attr('data-swiper-column', column)
	        .attr('data-swiper-row', row);
	    }
	    if (slide.css('display') === 'none') { continue; } // eslint-disable-line

	    if (params.slidesPerView === 'auto') {
	      var slideStyles = win.getComputedStyle(slide[0], null);
	      var currentTransform = slide[0].style.transform;
	      var currentWebKitTransform = slide[0].style.webkitTransform;
	      if (currentTransform) {
	        slide[0].style.transform = 'none';
	      }
	      if (currentWebKitTransform) {
	        slide[0].style.webkitTransform = 'none';
	      }
	      if (swiper.isHorizontal()) {
	        slideSize = slide[0].getBoundingClientRect().width +
	          parseFloat(slideStyles.getPropertyValue('margin-left')) +
	          parseFloat(slideStyles.getPropertyValue('margin-right'));
	      } else {
	        slideSize = slide[0].getBoundingClientRect().height +
	          parseFloat(slideStyles.getPropertyValue('margin-top')) +
	          parseFloat(slideStyles.getPropertyValue('margin-bottom'));
	      }
	      if (currentTransform) {
	        slide[0].style.transform = currentTransform;
	      }
	      if (currentWebKitTransform) {
	        slide[0].style.webkitTransform = currentWebKitTransform;
	      }
	      if (params.roundLengths) { slideSize = Math.floor(slideSize); }
	    } else {
	      slideSize = (swiperSize - ((params.slidesPerView - 1) * spaceBetween)) / params.slidesPerView;
	      if (params.roundLengths) { slideSize = Math.floor(slideSize); }

	      if (slides[i]) {
	        if (swiper.isHorizontal()) {
	          slides[i].style.width = slideSize + "px";
	        } else {
	          slides[i].style.height = slideSize + "px";
	        }
	      }
	    }
	    if (slides[i]) {
	      slides[i].swiperSlideSize = slideSize;
	    }
	    slidesSizesGrid.push(slideSize);


	    if (params.centeredSlides) {
	      slidePosition = slidePosition + (slideSize / 2) + (prevSlideSize / 2) + spaceBetween;
	      if (prevSlideSize === 0 && i !== 0) { slidePosition = slidePosition - (swiperSize / 2) - spaceBetween; }
	      if (i === 0) { slidePosition = slidePosition - (swiperSize / 2) - spaceBetween; }
	      if (Math.abs(slidePosition) < 1 / 1000) { slidePosition = 0; }
	      if ((index) % params.slidesPerGroup === 0) { snapGrid.push(slidePosition); }
	      slidesGrid.push(slidePosition);
	    } else {
	      if ((index) % params.slidesPerGroup === 0) { snapGrid.push(slidePosition); }
	      slidesGrid.push(slidePosition);
	      slidePosition = slidePosition + slideSize + spaceBetween;
	    }

	    swiper.virtualSize += slideSize + spaceBetween;

	    prevSlideSize = slideSize;

	    index += 1;
	  }
	  swiper.virtualSize = Math.max(swiper.virtualSize, swiperSize) + offsetAfter;
	  var newSlidesGrid;

	  if (
	    rtl && wrongRTL && (params.effect === 'slide' || params.effect === 'coverflow')) {
	    $wrapperEl.css({ width: ((swiper.virtualSize + params.spaceBetween) + "px") });
	  }
	  if (!Support.flexbox || params.setWrapperSize) {
	    if (swiper.isHorizontal()) { $wrapperEl.css({ width: ((swiper.virtualSize + params.spaceBetween) + "px") }); }
	    else { $wrapperEl.css({ height: ((swiper.virtualSize + params.spaceBetween) + "px") }); }
	  }

	  if (params.slidesPerColumn > 1) {
	    swiper.virtualSize = (slideSize + params.spaceBetween) * slidesNumberEvenToRows;
	    swiper.virtualSize = Math.ceil(swiper.virtualSize / params.slidesPerColumn) - params.spaceBetween;
	    if (swiper.isHorizontal()) { $wrapperEl.css({ width: ((swiper.virtualSize + params.spaceBetween) + "px") }); }
	    else { $wrapperEl.css({ height: ((swiper.virtualSize + params.spaceBetween) + "px") }); }
	    if (params.centeredSlides) {
	      newSlidesGrid = [];
	      for (var i$1 = 0; i$1 < snapGrid.length; i$1 += 1) {
	        if (snapGrid[i$1] < swiper.virtualSize + snapGrid[0]) { newSlidesGrid.push(snapGrid[i$1]); }
	      }
	      snapGrid = newSlidesGrid;
	    }
	  }

	  // Remove last grid elements depending on width
	  if (!params.centeredSlides) {
	    newSlidesGrid = [];
	    for (var i$2 = 0; i$2 < snapGrid.length; i$2 += 1) {
	      if (snapGrid[i$2] <= swiper.virtualSize - swiperSize) {
	        newSlidesGrid.push(snapGrid[i$2]);
	      }
	    }
	    snapGrid = newSlidesGrid;
	    if (Math.floor(swiper.virtualSize - swiperSize) - Math.floor(snapGrid[snapGrid.length - 1]) > 1) {
	      snapGrid.push(swiper.virtualSize - swiperSize);
	    }
	  }
	  if (snapGrid.length === 0) { snapGrid = [0]; }

	  if (params.spaceBetween !== 0) {
	    if (swiper.isHorizontal()) {
	      if (rtl) { slides.css({ marginLeft: (spaceBetween + "px") }); }
	      else { slides.css({ marginRight: (spaceBetween + "px") }); }
	    } else { slides.css({ marginBottom: (spaceBetween + "px") }); }
	  }

	  Utils.extend(swiper, {
	    slides: slides,
	    snapGrid: snapGrid,
	    slidesGrid: slidesGrid,
	    slidesSizesGrid: slidesSizesGrid,
	  });

	  if (slidesLength !== previousSlidesLength) {
	    swiper.emit('slidesLengthChange');
	  }
	  if (snapGrid.length !== previousSnapGridLength) {
	    if (swiper.params.watchOverflow) { swiper.checkOverflow(); }
	    swiper.emit('snapGridLengthChange');
	  }
	  if (slidesGrid.length !== previousSlidesGridLength) {
	    swiper.emit('slidesGridLengthChange');
	  }

	  if (params.watchSlidesProgress || params.watchSlidesVisibility) {
	    swiper.updateSlidesOffset();
	  }
	}

	function updateAutoHeight (speed) {
	  var swiper = this;
	  var activeSlides = [];
	  var newHeight = 0;
	  var i;
	  if (typeof speed === 'number') {
	    swiper.setTransition(speed);
	  } else if (speed === true) {
	    swiper.setTransition(swiper.params.speed);
	  }
	  // Find slides currently in view
	  if (swiper.params.slidesPerView !== 'auto' && swiper.params.slidesPerView > 1) {
	    for (i = 0; i < Math.ceil(swiper.params.slidesPerView); i += 1) {
	      var index = swiper.activeIndex + i;
	      if (index > swiper.slides.length) { break; }
	      activeSlides.push(swiper.slides.eq(index)[0]);
	    }
	  } else {
	    activeSlides.push(swiper.slides.eq(swiper.activeIndex)[0]);
	  }

	  // Find new height from highest slide in view
	  for (i = 0; i < activeSlides.length; i += 1) {
	    if (typeof activeSlides[i] !== 'undefined') {
	      var height = activeSlides[i].offsetHeight;
	      newHeight = height > newHeight ? height : newHeight;
	    }
	  }

	  // Update Height
	  if (newHeight) { swiper.$wrapperEl.css('height', (newHeight + "px")); }
	}

	function updateSlidesOffset () {
	  var swiper = this;
	  var slides = swiper.slides;
	  for (var i = 0; i < slides.length; i += 1) {
	    slides[i].swiperSlideOffset = swiper.isHorizontal() ? slides[i].offsetLeft : slides[i].offsetTop;
	  }
	}

	function updateSlidesProgress (translate) {
	  if ( translate === void 0 ) translate = (this && this.translate) || 0;

	  var swiper = this;
	  var params = swiper.params;

	  var slides = swiper.slides;
	  var rtl = swiper.rtlTranslate;

	  if (slides.length === 0) { return; }
	  if (typeof slides[0].swiperSlideOffset === 'undefined') { swiper.updateSlidesOffset(); }

	  var offsetCenter = -translate;
	  if (rtl) { offsetCenter = translate; }

	  // Visible Slides
	  slides.removeClass(params.slideVisibleClass);

	  for (var i = 0; i < slides.length; i += 1) {
	    var slide = slides[i];
	    var slideProgress =
	      (
	        (offsetCenter + (params.centeredSlides ? swiper.minTranslate() : 0)) - slide.swiperSlideOffset
	      ) / (slide.swiperSlideSize + params.spaceBetween);
	    if (params.watchSlidesVisibility) {
	      var slideBefore = -(offsetCenter - slide.swiperSlideOffset);
	      var slideAfter = slideBefore + swiper.slidesSizesGrid[i];
	      var isVisible =
	                (slideBefore >= 0 && slideBefore < swiper.size) ||
	                (slideAfter > 0 && slideAfter <= swiper.size) ||
	                (slideBefore <= 0 && slideAfter >= swiper.size);
	      if (isVisible) {
	        slides.eq(i).addClass(params.slideVisibleClass);
	      }
	    }
	    slide.progress = rtl ? -slideProgress : slideProgress;
	  }
	}

	function updateProgress (translate) {
	  if ( translate === void 0 ) translate = (this && this.translate) || 0;

	  var swiper = this;
	  var params = swiper.params;

	  var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
	  var progress = swiper.progress;
	  var isBeginning = swiper.isBeginning;
	  var isEnd = swiper.isEnd;
	  var wasBeginning = isBeginning;
	  var wasEnd = isEnd;
	  if (translatesDiff === 0) {
	    progress = 0;
	    isBeginning = true;
	    isEnd = true;
	  } else {
	    progress = (translate - swiper.minTranslate()) / (translatesDiff);
	    isBeginning = progress <= 0;
	    isEnd = progress >= 1;
	  }
	  Utils.extend(swiper, {
	    progress: progress,
	    isBeginning: isBeginning,
	    isEnd: isEnd,
	  });

	  if (params.watchSlidesProgress || params.watchSlidesVisibility) { swiper.updateSlidesProgress(translate); }

	  if (isBeginning && !wasBeginning) {
	    swiper.emit('reachBeginning toEdge');
	  }
	  if (isEnd && !wasEnd) {
	    swiper.emit('reachEnd toEdge');
	  }
	  if ((wasBeginning && !isBeginning) || (wasEnd && !isEnd)) {
	    swiper.emit('fromEdge');
	  }

	  swiper.emit('progress', progress);
	}

	function updateSlidesClasses () {
	  var swiper = this;

	  var slides = swiper.slides;
	  var params = swiper.params;
	  var $wrapperEl = swiper.$wrapperEl;
	  var activeIndex = swiper.activeIndex;
	  var realIndex = swiper.realIndex;
	  var isVirtual = swiper.virtual && params.virtual.enabled;

	  slides.removeClass(((params.slideActiveClass) + " " + (params.slideNextClass) + " " + (params.slidePrevClass) + " " + (params.slideDuplicateActiveClass) + " " + (params.slideDuplicateNextClass) + " " + (params.slideDuplicatePrevClass)));

	  var activeSlide;
	  if (isVirtual) {
	    activeSlide = swiper.$wrapperEl.find(("." + (params.slideClass) + "[data-swiper-slide-index=\"" + activeIndex + "\"]"));
	  } else {
	    activeSlide = slides.eq(activeIndex);
	  }

	  // Active classes
	  activeSlide.addClass(params.slideActiveClass);

	  if (params.loop) {
	    // Duplicate to all looped slides
	    if (activeSlide.hasClass(params.slideDuplicateClass)) {
	      $wrapperEl
	        .children(("." + (params.slideClass) + ":not(." + (params.slideDuplicateClass) + ")[data-swiper-slide-index=\"" + realIndex + "\"]"))
	        .addClass(params.slideDuplicateActiveClass);
	    } else {
	      $wrapperEl
	        .children(("." + (params.slideClass) + "." + (params.slideDuplicateClass) + "[data-swiper-slide-index=\"" + realIndex + "\"]"))
	        .addClass(params.slideDuplicateActiveClass);
	    }
	  }
	  // Next Slide
	  var nextSlide = activeSlide.nextAll(("." + (params.slideClass))).eq(0).addClass(params.slideNextClass);
	  if (params.loop && nextSlide.length === 0) {
	    nextSlide = slides.eq(0);
	    nextSlide.addClass(params.slideNextClass);
	  }
	  // Prev Slide
	  var prevSlide = activeSlide.prevAll(("." + (params.slideClass))).eq(0).addClass(params.slidePrevClass);
	  if (params.loop && prevSlide.length === 0) {
	    prevSlide = slides.eq(-1);
	    prevSlide.addClass(params.slidePrevClass);
	  }
	  if (params.loop) {
	    // Duplicate to all looped slides
	    if (nextSlide.hasClass(params.slideDuplicateClass)) {
	      $wrapperEl
	        .children(("." + (params.slideClass) + ":not(." + (params.slideDuplicateClass) + ")[data-swiper-slide-index=\"" + (nextSlide.attr('data-swiper-slide-index')) + "\"]"))
	        .addClass(params.slideDuplicateNextClass);
	    } else {
	      $wrapperEl
	        .children(("." + (params.slideClass) + "." + (params.slideDuplicateClass) + "[data-swiper-slide-index=\"" + (nextSlide.attr('data-swiper-slide-index')) + "\"]"))
	        .addClass(params.slideDuplicateNextClass);
	    }
	    if (prevSlide.hasClass(params.slideDuplicateClass)) {
	      $wrapperEl
	        .children(("." + (params.slideClass) + ":not(." + (params.slideDuplicateClass) + ")[data-swiper-slide-index=\"" + (prevSlide.attr('data-swiper-slide-index')) + "\"]"))
	        .addClass(params.slideDuplicatePrevClass);
	    } else {
	      $wrapperEl
	        .children(("." + (params.slideClass) + "." + (params.slideDuplicateClass) + "[data-swiper-slide-index=\"" + (prevSlide.attr('data-swiper-slide-index')) + "\"]"))
	        .addClass(params.slideDuplicatePrevClass);
	    }
	  }
	}

	function updateActiveIndex (newActiveIndex) {
	  var swiper = this;
	  var translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
	  var slidesGrid = swiper.slidesGrid;
	  var snapGrid = swiper.snapGrid;
	  var params = swiper.params;
	  var previousIndex = swiper.activeIndex;
	  var previousRealIndex = swiper.realIndex;
	  var previousSnapIndex = swiper.snapIndex;
	  var activeIndex = newActiveIndex;
	  var snapIndex;
	  if (typeof activeIndex === 'undefined') {
	    for (var i = 0; i < slidesGrid.length; i += 1) {
	      if (typeof slidesGrid[i + 1] !== 'undefined') {
	        if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1] - ((slidesGrid[i + 1] - slidesGrid[i]) / 2)) {
	          activeIndex = i;
	        } else if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1]) {
	          activeIndex = i + 1;
	        }
	      } else if (translate >= slidesGrid[i]) {
	        activeIndex = i;
	      }
	    }
	    // Normalize slideIndex
	    if (params.normalizeSlideIndex) {
	      if (activeIndex < 0 || typeof activeIndex === 'undefined') { activeIndex = 0; }
	    }
	  }
	  if (snapGrid.indexOf(translate) >= 0) {
	    snapIndex = snapGrid.indexOf(translate);
	  } else {
	    snapIndex = Math.floor(activeIndex / params.slidesPerGroup);
	  }
	  if (snapIndex >= snapGrid.length) { snapIndex = snapGrid.length - 1; }
	  if (activeIndex === previousIndex) {
	    if (snapIndex !== previousSnapIndex) {
	      swiper.snapIndex = snapIndex;
	      swiper.emit('snapIndexChange');
	    }
	    return;
	  }

	  // Get real index
	  var realIndex = parseInt(swiper.slides.eq(activeIndex).attr('data-swiper-slide-index') || activeIndex, 10);

	  Utils.extend(swiper, {
	    snapIndex: snapIndex,
	    realIndex: realIndex,
	    previousIndex: previousIndex,
	    activeIndex: activeIndex,
	  });
	  swiper.emit('activeIndexChange');
	  swiper.emit('snapIndexChange');
	  if (previousRealIndex !== realIndex) {
	    swiper.emit('realIndexChange');
	  }
	  swiper.emit('slideChange');
	}

	function updateClickedSlide (e) {
	  var swiper = this;
	  var params = swiper.params;
	  var slide = $$1(e.target).closest(("." + (params.slideClass)))[0];
	  var slideFound = false;
	  if (slide) {
	    for (var i = 0; i < swiper.slides.length; i += 1) {
	      if (swiper.slides[i] === slide) { slideFound = true; }
	    }
	  }

	  if (slide && slideFound) {
	    swiper.clickedSlide = slide;
	    if (swiper.virtual && swiper.params.virtual.enabled) {
	      swiper.clickedIndex = parseInt($$1(slide).attr('data-swiper-slide-index'), 10);
	    } else {
	      swiper.clickedIndex = $$1(slide).index();
	    }
	  } else {
	    swiper.clickedSlide = undefined;
	    swiper.clickedIndex = undefined;
	    return;
	  }
	  if (params.slideToClickedSlide && swiper.clickedIndex !== undefined && swiper.clickedIndex !== swiper.activeIndex) {
	    swiper.slideToClickedSlide();
	  }
	}

	var update = {
	  updateSize: updateSize,
	  updateSlides: updateSlides,
	  updateAutoHeight: updateAutoHeight,
	  updateSlidesOffset: updateSlidesOffset,
	  updateSlidesProgress: updateSlidesProgress,
	  updateProgress: updateProgress,
	  updateSlidesClasses: updateSlidesClasses,
	  updateActiveIndex: updateActiveIndex,
	  updateClickedSlide: updateClickedSlide,
	};

	function getTranslate (axis) {
	  if ( axis === void 0 ) axis = this.isHorizontal() ? 'x' : 'y';

	  var swiper = this;

	  var params = swiper.params;
	  var rtl = swiper.rtlTranslate;
	  var translate = swiper.translate;
	  var $wrapperEl = swiper.$wrapperEl;

	  if (params.virtualTranslate) {
	    return rtl ? -translate : translate;
	  }

	  var currentTranslate = Utils.getTranslate($wrapperEl[0], axis);
	  if (rtl) { currentTranslate = -currentTranslate; }

	  return currentTranslate || 0;
	}

	function setTranslate (translate, byController) {
	  var swiper = this;
	  var rtl = swiper.rtlTranslate;
	  var params = swiper.params;
	  var $wrapperEl = swiper.$wrapperEl;
	  var progress = swiper.progress;
	  var x = 0;
	  var y = 0;
	  var z = 0;

	  if (swiper.isHorizontal()) {
	    x = rtl ? -translate : translate;
	  } else {
	    y = translate;
	  }

	  if (params.roundLengths) {
	    x = Math.floor(x);
	    y = Math.floor(y);
	  }

	  if (!params.virtualTranslate) {
	    if (Support.transforms3d) { $wrapperEl.transform(("translate3d(" + x + "px, " + y + "px, " + z + "px)")); }
	    else { $wrapperEl.transform(("translate(" + x + "px, " + y + "px)")); }
	  }

	  swiper.translate = swiper.isHorizontal() ? x : y;

	  // Check if we need to update progress
	  var newProgress;
	  var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
	  if (translatesDiff === 0) {
	    newProgress = 0;
	  } else {
	    newProgress = (translate - swiper.minTranslate()) / (translatesDiff);
	  }
	  if (newProgress !== progress) {
	    swiper.updateProgress(translate);
	  }

	  swiper.emit('setTranslate', swiper.translate, byController);
	}

	function minTranslate () {
	  return (-this.snapGrid[0]);
	}

	function maxTranslate () {
	  return (-this.snapGrid[this.snapGrid.length - 1]);
	}

	var translate = {
	  getTranslate: getTranslate,
	  setTranslate: setTranslate,
	  minTranslate: minTranslate,
	  maxTranslate: maxTranslate,
	};

	function setTransition (duration, byController) {
	  var swiper = this;

	  swiper.$wrapperEl.transition(duration);

	  swiper.emit('setTransition', duration, byController);
	}

	function transitionStart (runCallbacks, direction) {
	  if ( runCallbacks === void 0 ) runCallbacks = true;

	  var swiper = this;
	  var activeIndex = swiper.activeIndex;
	  var params = swiper.params;
	  var previousIndex = swiper.previousIndex;
	  if (params.autoHeight) {
	    swiper.updateAutoHeight();
	  }

	  var dir = direction;
	  if (!dir) {
	    if (activeIndex > previousIndex) { dir = 'next'; }
	    else if (activeIndex < previousIndex) { dir = 'prev'; }
	    else { dir = 'reset'; }
	  }

	  swiper.emit('transitionStart');

	  if (runCallbacks && activeIndex !== previousIndex) {
	    if (dir === 'reset') {
	      swiper.emit('slideResetTransitionStart');
	      return;
	    }
	    swiper.emit('slideChangeTransitionStart');
	    if (dir === 'next') {
	      swiper.emit('slideNextTransitionStart');
	    } else {
	      swiper.emit('slidePrevTransitionStart');
	    }
	  }
	}

	function transitionEnd$1 (runCallbacks, direction) {
	  if ( runCallbacks === void 0 ) runCallbacks = true;

	  var swiper = this;
	  var activeIndex = swiper.activeIndex;
	  var previousIndex = swiper.previousIndex;
	  swiper.animating = false;
	  swiper.setTransition(0);

	  var dir = direction;
	  if (!dir) {
	    if (activeIndex > previousIndex) { dir = 'next'; }
	    else if (activeIndex < previousIndex) { dir = 'prev'; }
	    else { dir = 'reset'; }
	  }

	  swiper.emit('transitionEnd');

	  if (runCallbacks && activeIndex !== previousIndex) {
	    if (dir === 'reset') {
	      swiper.emit('slideResetTransitionEnd');
	      return;
	    }
	    swiper.emit('slideChangeTransitionEnd');
	    if (dir === 'next') {
	      swiper.emit('slideNextTransitionEnd');
	    } else {
	      swiper.emit('slidePrevTransitionEnd');
	    }
	  }
	}

	var transition$2 = {
	  setTransition: setTransition,
	  transitionStart: transitionStart,
	  transitionEnd: transitionEnd$1,
	};

	function slideTo (index, speed, runCallbacks, internal) {
	  if ( index === void 0 ) index = 0;
	  if ( speed === void 0 ) speed = this.params.speed;
	  if ( runCallbacks === void 0 ) runCallbacks = true;

	  var swiper = this;
	  var slideIndex = index;
	  if (slideIndex < 0) { slideIndex = 0; }

	  var params = swiper.params;
	  var snapGrid = swiper.snapGrid;
	  var slidesGrid = swiper.slidesGrid;
	  var previousIndex = swiper.previousIndex;
	  var activeIndex = swiper.activeIndex;
	  var rtl = swiper.rtlTranslate;
	  if (swiper.animating && params.preventIntercationOnTransition) {
	    return false;
	  }

	  var snapIndex = Math.floor(slideIndex / params.slidesPerGroup);
	  if (snapIndex >= snapGrid.length) { snapIndex = snapGrid.length - 1; }

	  if ((activeIndex || params.initialSlide || 0) === (previousIndex || 0) && runCallbacks) {
	    swiper.emit('beforeSlideChangeStart');
	  }

	  var translate = -snapGrid[snapIndex];

	  // Update progress
	  swiper.updateProgress(translate);

	  // Normalize slideIndex
	  if (params.normalizeSlideIndex) {
	    for (var i = 0; i < slidesGrid.length; i += 1) {
	      if (-Math.floor(translate * 100) >= Math.floor(slidesGrid[i] * 100)) {
	        slideIndex = i;
	      }
	    }
	  }
	  // Directions locks
	  if (swiper.initialized && slideIndex !== activeIndex) {
	    if (!swiper.allowSlideNext && translate < swiper.translate && translate < swiper.minTranslate()) {
	      return false;
	    }
	    if (!swiper.allowSlidePrev && translate > swiper.translate && translate > swiper.maxTranslate()) {
	      if ((activeIndex || 0) !== slideIndex) { return false; }
	    }
	  }

	  var direction;
	  if (slideIndex > activeIndex) { direction = 'next'; }
	  else if (slideIndex < activeIndex) { direction = 'prev'; }
	  else { direction = 'reset'; }


	  // Update Index
	  if ((rtl && -translate === swiper.translate) || (!rtl && translate === swiper.translate)) {
	    swiper.updateActiveIndex(slideIndex);
	    // Update Height
	    if (params.autoHeight) {
	      swiper.updateAutoHeight();
	    }
	    swiper.updateSlidesClasses();
	    if (params.effect !== 'slide') {
	      swiper.setTranslate(translate);
	    }
	    if (direction !== 'reset') {
	      swiper.transitionStart(runCallbacks, direction);
	      swiper.transitionEnd(runCallbacks, direction);
	    }
	    return false;
	  }

	  if (speed === 0 || !Support.transition) {
	    swiper.setTransition(0);
	    swiper.setTranslate(translate);
	    swiper.updateActiveIndex(slideIndex);
	    swiper.updateSlidesClasses();
	    swiper.emit('beforeTransitionStart', speed, internal);
	    swiper.transitionStart(runCallbacks, direction);
	    swiper.transitionEnd(runCallbacks, direction);
	  } else {
	    swiper.setTransition(speed);
	    swiper.setTranslate(translate);
	    swiper.updateActiveIndex(slideIndex);
	    swiper.updateSlidesClasses();
	    swiper.emit('beforeTransitionStart', speed, internal);
	    swiper.transitionStart(runCallbacks, direction);
	    if (!swiper.animating) {
	      swiper.animating = true;
	      if (!swiper.onSlideToWrapperTransitionEnd) {
	        swiper.onSlideToWrapperTransitionEnd = function transitionEnd(e) {
	          if (!swiper || swiper.destroyed) { return; }
	          if (e.target !== this) { return; }
	          swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
	          swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.onSlideToWrapperTransitionEnd);
	          swiper.transitionEnd(runCallbacks, direction);
	        };
	      }
	      swiper.$wrapperEl[0].addEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
	      swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.onSlideToWrapperTransitionEnd);
	    }
	  }

	  return true;
	}

	function slideToLoop (index, speed, runCallbacks, internal) {
	  if ( index === void 0 ) index = 0;
	  if ( speed === void 0 ) speed = this.params.speed;
	  if ( runCallbacks === void 0 ) runCallbacks = true;

	  var swiper = this;
	  var newIndex = index;
	  if (swiper.params.loop) {
	    newIndex += swiper.loopedSlides;
	  }

	  return swiper.slideTo(newIndex, speed, runCallbacks, internal);
	}

	/* eslint no-unused-vars: "off" */
	function slideNext (speed, runCallbacks, internal) {
	  if ( speed === void 0 ) speed = this.params.speed;
	  if ( runCallbacks === void 0 ) runCallbacks = true;

	  var swiper = this;
	  var params = swiper.params;
	  var animating = swiper.animating;
	  if (params.loop) {
	    if (animating) { return false; }
	    swiper.loopFix();
	    // eslint-disable-next-line
	    swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
	    return swiper.slideTo(swiper.activeIndex + params.slidesPerGroup, speed, runCallbacks, internal);
	  }
	  return swiper.slideTo(swiper.activeIndex + params.slidesPerGroup, speed, runCallbacks, internal);
	}

	/* eslint no-unused-vars: "off" */
	function slidePrev (speed, runCallbacks, internal) {
	  if ( speed === void 0 ) speed = this.params.speed;
	  if ( runCallbacks === void 0 ) runCallbacks = true;

	  var swiper = this;
	  var params = swiper.params;
	  var animating = swiper.animating;
	  var snapGrid = swiper.snapGrid;
	  var slidesGrid = swiper.slidesGrid;
	  var rtlTranslate = swiper.rtlTranslate;

	  if (params.loop) {
	    if (animating) { return false; }
	    swiper.loopFix();
	    // eslint-disable-next-line
	    swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
	  }
	  var translate = rtlTranslate ? swiper.translate : -swiper.translate;

	  var normalizedTranslate = translate < 0 ? -Math.floor(Math.abs(translate)) : Math.floor(translate);
	  var normalizedSnapGrid = snapGrid.map(function (val) { return Math.floor(val); });
	  var normalizedSlidesGrid = slidesGrid.map(function (val) { return Math.floor(val); });

	  var currentSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate)];
	  var prevSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate) - 1];
	  var prevIndex;
	  if (typeof prevSnap !== 'undefined') {
	    prevIndex = slidesGrid.indexOf(prevSnap);
	    if (prevIndex < 0) { prevIndex = swiper.activeIndex - 1; }
	  }
	  return swiper.slideTo(prevIndex, speed, runCallbacks, internal);
	}

	/* eslint no-unused-vars: "off" */
	function slideReset (speed, runCallbacks, internal) {
	  if ( speed === void 0 ) speed = this.params.speed;
	  if ( runCallbacks === void 0 ) runCallbacks = true;

	  var swiper = this;
	  return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
	}

	/* eslint no-unused-vars: "off" */
	function slideToClosest (speed, runCallbacks, internal) {
	  if ( speed === void 0 ) speed = this.params.speed;
	  if ( runCallbacks === void 0 ) runCallbacks = true;

	  var swiper = this;
	  var index = swiper.activeIndex;
	  var snapIndex = Math.floor(index / swiper.params.slidesPerGroup);

	  if (snapIndex < swiper.snapGrid.length - 1) {
	    var translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;

	    var currentSnap = swiper.snapGrid[snapIndex];
	    var nextSnap = swiper.snapGrid[snapIndex + 1];

	    if ((translate - currentSnap) > (nextSnap - currentSnap) / 2) {
	      index = swiper.params.slidesPerGroup;
	    }
	  }

	  return swiper.slideTo(index, speed, runCallbacks, internal);
	}

	function slideToClickedSlide () {
	  var swiper = this;
	  var params = swiper.params;
	  var $wrapperEl = swiper.$wrapperEl;

	  var slidesPerView = params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : params.slidesPerView;
	  var slideToIndex = swiper.clickedIndex;
	  var realIndex;
	  if (params.loop) {
	    if (swiper.animating) { return; }
	    realIndex = parseInt($$1(swiper.clickedSlide).attr('data-swiper-slide-index'), 10);
	    if (params.centeredSlides) {
	      if (
	        (slideToIndex < swiper.loopedSlides - (slidesPerView / 2)) ||
	        (slideToIndex > (swiper.slides.length - swiper.loopedSlides) + (slidesPerView / 2))
	      ) {
	        swiper.loopFix();
	        slideToIndex = $wrapperEl
	          .children(("." + (params.slideClass) + "[data-swiper-slide-index=\"" + realIndex + "\"]:not(." + (params.slideDuplicateClass) + ")"))
	          .eq(0)
	          .index();

	        Utils.nextTick(function () {
	          swiper.slideTo(slideToIndex);
	        });
	      } else {
	        swiper.slideTo(slideToIndex);
	      }
	    } else if (slideToIndex > swiper.slides.length - slidesPerView) {
	      swiper.loopFix();
	      slideToIndex = $wrapperEl
	        .children(("." + (params.slideClass) + "[data-swiper-slide-index=\"" + realIndex + "\"]:not(." + (params.slideDuplicateClass) + ")"))
	        .eq(0)
	        .index();

	      Utils.nextTick(function () {
	        swiper.slideTo(slideToIndex);
	      });
	    } else {
	      swiper.slideTo(slideToIndex);
	    }
	  } else {
	    swiper.slideTo(slideToIndex);
	  }
	}

	var slide = {
	  slideTo: slideTo,
	  slideToLoop: slideToLoop,
	  slideNext: slideNext,
	  slidePrev: slidePrev,
	  slideReset: slideReset,
	  slideToClosest: slideToClosest,
	  slideToClickedSlide: slideToClickedSlide,
	};

	function loopCreate () {
	  var swiper = this;
	  var params = swiper.params;
	  var $wrapperEl = swiper.$wrapperEl;
	  // Remove duplicated slides
	  $wrapperEl.children(("." + (params.slideClass) + "." + (params.slideDuplicateClass))).remove();

	  var slides = $wrapperEl.children(("." + (params.slideClass)));

	  if (params.loopFillGroupWithBlank) {
	    var blankSlidesNum = params.slidesPerGroup - (slides.length % params.slidesPerGroup);
	    if (blankSlidesNum !== params.slidesPerGroup) {
	      for (var i = 0; i < blankSlidesNum; i += 1) {
	        var blankNode = $$1(doc.createElement('div')).addClass(((params.slideClass) + " " + (params.slideBlankClass)));
	        $wrapperEl.append(blankNode);
	      }
	      slides = $wrapperEl.children(("." + (params.slideClass)));
	    }
	  }

	  if (params.slidesPerView === 'auto' && !params.loopedSlides) { params.loopedSlides = slides.length; }

	  swiper.loopedSlides = parseInt(params.loopedSlides || params.slidesPerView, 10);
	  swiper.loopedSlides += params.loopAdditionalSlides;
	  if (swiper.loopedSlides > slides.length) {
	    swiper.loopedSlides = slides.length;
	  }

	  var prependSlides = [];
	  var appendSlides = [];
	  slides.each(function (index, el) {
	    var slide = $$1(el);
	    if (index < swiper.loopedSlides) { appendSlides.push(el); }
	    if (index < slides.length && index >= slides.length - swiper.loopedSlides) { prependSlides.push(el); }
	    slide.attr('data-swiper-slide-index', index);
	  });
	  for (var i$1 = 0; i$1 < appendSlides.length; i$1 += 1) {
	    $wrapperEl.append($$1(appendSlides[i$1].cloneNode(true)).addClass(params.slideDuplicateClass));
	  }
	  for (var i$2 = prependSlides.length - 1; i$2 >= 0; i$2 -= 1) {
	    $wrapperEl.prepend($$1(prependSlides[i$2].cloneNode(true)).addClass(params.slideDuplicateClass));
	  }
	}

	function loopFix () {
	  var swiper = this;
	  var params = swiper.params;
	  var activeIndex = swiper.activeIndex;
	  var slides = swiper.slides;
	  var loopedSlides = swiper.loopedSlides;
	  var allowSlidePrev = swiper.allowSlidePrev;
	  var allowSlideNext = swiper.allowSlideNext;
	  var snapGrid = swiper.snapGrid;
	  var rtl = swiper.rtlTranslate;
	  var newIndex;
	  swiper.allowSlidePrev = true;
	  swiper.allowSlideNext = true;

	  var snapTranslate = -snapGrid[activeIndex];
	  var diff = snapTranslate - swiper.getTranslate();


	  // Fix For Negative Oversliding
	  if (activeIndex < loopedSlides) {
	    newIndex = (slides.length - (loopedSlides * 3)) + activeIndex;
	    newIndex += loopedSlides;
	    var slideChanged = swiper.slideTo(newIndex, 0, false, true);
	    if (slideChanged && diff !== 0) {
	      swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
	    }
	  } else if ((params.slidesPerView === 'auto' && activeIndex >= loopedSlides * 2) || (activeIndex >= slides.length - loopedSlides)) {
	    // Fix For Positive Oversliding
	    newIndex = -slides.length + activeIndex + loopedSlides;
	    newIndex += loopedSlides;
	    var slideChanged$1 = swiper.slideTo(newIndex, 0, false, true);
	    if (slideChanged$1 && diff !== 0) {
	      swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
	    }
	  }
	  swiper.allowSlidePrev = allowSlidePrev;
	  swiper.allowSlideNext = allowSlideNext;
	}

	function loopDestroy () {
	  var swiper = this;
	  var $wrapperEl = swiper.$wrapperEl;
	  var params = swiper.params;
	  var slides = swiper.slides;
	  $wrapperEl.children(("." + (params.slideClass) + "." + (params.slideDuplicateClass))).remove();
	  slides.removeAttr('data-swiper-slide-index');
	}

	var loop = {
	  loopCreate: loopCreate,
	  loopFix: loopFix,
	  loopDestroy: loopDestroy,
	};

	function setGrabCursor (moving) {
	  var swiper = this;
	  if (Support.touch || !swiper.params.simulateTouch || (swiper.params.watchOverflow && swiper.isLocked)) { return; }
	  var el = swiper.el;
	  el.style.cursor = 'move';
	  el.style.cursor = moving ? '-webkit-grabbing' : '-webkit-grab';
	  el.style.cursor = moving ? '-moz-grabbin' : '-moz-grab';
	  el.style.cursor = moving ? 'grabbing' : 'grab';
	}

	function unsetGrabCursor () {
	  var swiper = this;
	  if (Support.touch || (swiper.params.watchOverflow && swiper.isLocked)) { return; }
	  swiper.el.style.cursor = '';
	}

	var grabCursor = {
	  setGrabCursor: setGrabCursor,
	  unsetGrabCursor: unsetGrabCursor,
	};

	function appendSlide (slides) {
	  var swiper = this;
	  var $wrapperEl = swiper.$wrapperEl;
	  var params = swiper.params;
	  if (params.loop) {
	    swiper.loopDestroy();
	  }
	  if (typeof slides === 'object' && 'length' in slides) {
	    for (var i = 0; i < slides.length; i += 1) {
	      if (slides[i]) { $wrapperEl.append(slides[i]); }
	    }
	  } else {
	    $wrapperEl.append(slides);
	  }
	  if (params.loop) {
	    swiper.loopCreate();
	  }
	  if (!(params.observer && Support.observer)) {
	    swiper.update();
	  }
	}

	function prependSlide (slides) {
	  var swiper = this;
	  var params = swiper.params;
	  var $wrapperEl = swiper.$wrapperEl;
	  var activeIndex = swiper.activeIndex;

	  if (params.loop) {
	    swiper.loopDestroy();
	  }
	  var newActiveIndex = activeIndex + 1;
	  if (typeof slides === 'object' && 'length' in slides) {
	    for (var i = 0; i < slides.length; i += 1) {
	      if (slides[i]) { $wrapperEl.prepend(slides[i]); }
	    }
	    newActiveIndex = activeIndex + slides.length;
	  } else {
	    $wrapperEl.prepend(slides);
	  }
	  if (params.loop) {
	    swiper.loopCreate();
	  }
	  if (!(params.observer && Support.observer)) {
	    swiper.update();
	  }
	  swiper.slideTo(newActiveIndex, 0, false);
	}

	function addSlide (index, slides) {
	  var swiper = this;
	  var $wrapperEl = swiper.$wrapperEl;
	  var params = swiper.params;
	  var activeIndex = swiper.activeIndex;
	  var activeIndexBuffer = activeIndex;
	  if (params.loop) {
	    activeIndexBuffer -= swiper.loopedSlides;
	    swiper.loopDestroy();
	    swiper.slides = $wrapperEl.children(("." + (params.slideClass)));
	  }
	  var baseLength = swiper.slides.length;
	  if (index <= 0) {
	    swiper.prependSlide(slides);
	    return;
	  } else if (index >= baseLength) {
	    swiper.appendSlide(slides);
	    return;
	  }
	  var newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + 1 : activeIndexBuffer;

	  var slidesBuffer = [];
	  for (var i = baseLength - 1; i >= index; i -= 1) {
	    var currentSlide = swiper.slides.eq(i);
	    currentSlide.remove();
	    slidesBuffer.unshift(currentSlide);
	  }

	  if (typeof slides === 'object' && 'length' in slides) {
	    for (var i$1 = 0; i$1 < slides.length; i$1 += 1) {
	      if (slides[i$1]) { $wrapperEl.append(slides[i$1]); }
	    }
	    newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + slides.length : activeIndexBuffer;
	  } else {
	    $wrapperEl.append(slides);
	  }

	  for (var i$2 = 0; i$2 < slidesBuffer.length; i$2 += 1) {
	    $wrapperEl.append(slidesBuffer[i$2]);
	  }

	  if (params.loop) {
	    swiper.loopCreate();
	  }
	  if (!(params.observer && Support.observer)) {
	    swiper.update();
	  }
	  if (params.loop) {
	    swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
	  } else {
	    swiper.slideTo(newActiveIndex, 0, false);
	  }
	}

	function removeSlide (slidesIndexes) {
	  var swiper = this;
	  var params = swiper.params;
	  var $wrapperEl = swiper.$wrapperEl;
	  var activeIndex = swiper.activeIndex;

	  var activeIndexBuffer = activeIndex;
	  if (params.loop) {
	    activeIndexBuffer -= swiper.loopedSlides;
	    swiper.loopDestroy();
	    swiper.slides = $wrapperEl.children(("." + (params.slideClass)));
	  }
	  var newActiveIndex = activeIndexBuffer;
	  var indexToRemove;

	  if (typeof slidesIndexes === 'object' && 'length' in slidesIndexes) {
	    for (var i = 0; i < slidesIndexes.length; i += 1) {
	      indexToRemove = slidesIndexes[i];
	      if (swiper.slides[indexToRemove]) { swiper.slides.eq(indexToRemove).remove(); }
	      if (indexToRemove < newActiveIndex) { newActiveIndex -= 1; }
	    }
	    newActiveIndex = Math.max(newActiveIndex, 0);
	  } else {
	    indexToRemove = slidesIndexes;
	    if (swiper.slides[indexToRemove]) { swiper.slides.eq(indexToRemove).remove(); }
	    if (indexToRemove < newActiveIndex) { newActiveIndex -= 1; }
	    newActiveIndex = Math.max(newActiveIndex, 0);
	  }

	  if (params.loop) {
	    swiper.loopCreate();
	  }

	  if (!(params.observer && Support.observer)) {
	    swiper.update();
	  }
	  if (params.loop) {
	    swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
	  } else {
	    swiper.slideTo(newActiveIndex, 0, false);
	  }
	}

	function removeAllSlides () {
	  var swiper = this;

	  var slidesIndexes = [];
	  for (var i = 0; i < swiper.slides.length; i += 1) {
	    slidesIndexes.push(i);
	  }
	  swiper.removeSlide(slidesIndexes);
	}

	var manipulation = {
	  appendSlide: appendSlide,
	  prependSlide: prependSlide,
	  addSlide: addSlide,
	  removeSlide: removeSlide,
	  removeAllSlides: removeAllSlides,
	};

	function onTouchStart (event) {
	  var swiper = this;
	  var data = swiper.touchEventsData;
	  var params = swiper.params;
	  var touches = swiper.touches;
	  if (swiper.animating && params.preventIntercationOnTransition) {
	    return;
	  }
	  var e = event;
	  if (e.originalEvent) { e = e.originalEvent; }
	  data.isTouchEvent = e.type === 'touchstart';
	  if (!data.isTouchEvent && 'which' in e && e.which === 3) { return; }
	  if (data.isTouched && data.isMoved) { return; }
	  if (params.noSwiping && $$1(e.target).closest(params.noSwipingSelector ? params.noSwipingSelector : ("." + (params.noSwipingClass)))[0]) {
	    swiper.allowClick = true;
	    return;
	  }
	  if (params.swipeHandler) {
	    if (!$$1(e).closest(params.swipeHandler)[0]) { return; }
	  }

	  touches.currentX = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
	  touches.currentY = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
	  var startX = touches.currentX;
	  var startY = touches.currentY;

	  // Do NOT start if iOS edge swipe is detected. Otherwise iOS app (UIWebView) cannot swipe-to-go-back anymore

	  if (
	    Device.ios &&
	    !Device.cordova &&
	    params.iOSEdgeSwipeDetection &&
	    ((startX <= params.iOSEdgeSwipeThreshold) ||
	    (startX >= win.screen.width - params.iOSEdgeSwipeThreshold))
	  ) {
	    return;
	  }

	  Utils.extend(data, {
	    isTouched: true,
	    isMoved: false,
	    allowTouchCallbacks: true,
	    isScrolling: undefined,
	    startMoving: undefined,
	  });

	  touches.startX = startX;
	  touches.startY = startY;
	  data.touchStartTime = Utils.now();
	  swiper.allowClick = true;
	  swiper.updateSize();
	  swiper.swipeDirection = undefined;
	  if (params.threshold > 0) { data.allowThresholdMove = false; }
	  if (e.type !== 'touchstart') {
	    var preventDefault = true;
	    if ($$1(e.target).is(data.formElements)) { preventDefault = false; }
	    if (
	      doc.activeElement &&
	      $$1(doc.activeElement).is(data.formElements) &&
	      doc.activeElement !== e.target
	    ) {
	      doc.activeElement.blur();
	    }
	    if (preventDefault && swiper.allowTouchMove) {
	      e.preventDefault();
	    }
	  }
	  swiper.emit('touchStart', e);
	}

	function onTouchMove (event) {
	  var swiper = this;
	  var data = swiper.touchEventsData;
	  var params = swiper.params;
	  var touches = swiper.touches;
	  var rtl = swiper.rtlTranslate;
	  var e = event;
	  if (e.originalEvent) { e = e.originalEvent; }
	  if (!data.isTouched) {
	    if (data.startMoving && data.isScrolling) {
	      swiper.emit('touchMoveOpposite', e);
	    }
	    return;
	  }
	  if (data.isTouchEvent && e.type === 'mousemove') { return; }
	  var pageX = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX;
	  var pageY = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;
	  if (e.preventedByNestedSwiper) {
	    touches.startX = pageX;
	    touches.startY = pageY;
	    return;
	  }
	  if (!swiper.allowTouchMove) {
	    // isMoved = true;
	    swiper.allowClick = false;
	    if (data.isTouched) {
	      Utils.extend(touches, {
	        startX: pageX,
	        startY: pageY,
	        currentX: pageX,
	        currentY: pageY,
	      });
	      data.touchStartTime = Utils.now();
	    }
	    return;
	  }
	  if (data.isTouchEvent && params.touchReleaseOnEdges && !params.loop) {
	    if (swiper.isVertical()) {
	      // Vertical
	      if (
	        (pageY < touches.startY && swiper.translate <= swiper.maxTranslate()) ||
	        (pageY > touches.startY && swiper.translate >= swiper.minTranslate())
	      ) {
	        data.isTouched = false;
	        data.isMoved = false;
	        return;
	      }
	    } else if (
	      (pageX < touches.startX && swiper.translate <= swiper.maxTranslate()) ||
	      (pageX > touches.startX && swiper.translate >= swiper.minTranslate())
	    ) {
	      return;
	    }
	  }
	  if (data.isTouchEvent && doc.activeElement) {
	    if (e.target === doc.activeElement && $$1(e.target).is(data.formElements)) {
	      data.isMoved = true;
	      swiper.allowClick = false;
	      return;
	    }
	  }
	  if (data.allowTouchCallbacks) {
	    swiper.emit('touchMove', e);
	  }
	  if (e.targetTouches && e.targetTouches.length > 1) { return; }

	  touches.currentX = pageX;
	  touches.currentY = pageY;

	  var diffX = touches.currentX - touches.startX;
	  var diffY = touches.currentY - touches.startY;

	  if (typeof data.isScrolling === 'undefined') {
	    var touchAngle;
	    if ((swiper.isHorizontal() && touches.currentY === touches.startY) || (swiper.isVertical() && touches.currentX === touches.startX)) {
	      data.isScrolling = false;
	    } else {
	      // eslint-disable-next-line
	      if ((diffX * diffX) + (diffY * diffY) >= 25) {
	        touchAngle = (Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180) / Math.PI;
	        data.isScrolling = swiper.isHorizontal() ? touchAngle > params.touchAngle : (90 - touchAngle > params.touchAngle);
	      }
	    }
	  }
	  if (data.isScrolling) {
	    swiper.emit('touchMoveOpposite', e);
	  }
	  if (typeof startMoving === 'undefined') {
	    if (touches.currentX !== touches.startX || touches.currentY !== touches.startY) {
	      data.startMoving = true;
	    }
	  }
	  if (data.isScrolling) {
	    data.isTouched = false;
	    return;
	  }
	  if (!data.startMoving) {
	    return;
	  }
	  swiper.allowClick = false;
	  e.preventDefault();
	  if (params.touchMoveStopPropagation && !params.nested) {
	    e.stopPropagation();
	  }

	  if (!data.isMoved) {
	    if (params.loop) {
	      swiper.loopFix();
	    }
	    data.startTranslate = swiper.getTranslate();
	    swiper.setTransition(0);
	    if (swiper.animating) {
	      swiper.$wrapperEl.trigger('webkitTransitionEnd transitionend');
	    }
	    data.allowMomentumBounce = false;
	    // Grab Cursor
	    if (params.grabCursor && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
	      swiper.setGrabCursor(true);
	    }
	    swiper.emit('sliderFirstMove', e);
	  }
	  swiper.emit('sliderMove', e);
	  data.isMoved = true;

	  var diff = swiper.isHorizontal() ? diffX : diffY;
	  touches.diff = diff;

	  diff *= params.touchRatio;
	  if (rtl) { diff = -diff; }

	  swiper.swipeDirection = diff > 0 ? 'prev' : 'next';
	  data.currentTranslate = diff + data.startTranslate;

	  var disableParentSwiper = true;
	  var resistanceRatio = params.resistanceRatio;
	  if (params.touchReleaseOnEdges) {
	    resistanceRatio = 0;
	  }
	  if ((diff > 0 && data.currentTranslate > swiper.minTranslate())) {
	    disableParentSwiper = false;
	    if (params.resistance) { data.currentTranslate = (swiper.minTranslate() - 1) + (Math.pow( (-swiper.minTranslate() + data.startTranslate + diff), resistanceRatio )); }
	  } else if (diff < 0 && data.currentTranslate < swiper.maxTranslate()) {
	    disableParentSwiper = false;
	    if (params.resistance) { data.currentTranslate = (swiper.maxTranslate() + 1) - (Math.pow( (swiper.maxTranslate() - data.startTranslate - diff), resistanceRatio )); }
	  }

	  if (disableParentSwiper) {
	    e.preventedByNestedSwiper = true;
	  }

	  // Directions locks
	  if (!swiper.allowSlideNext && swiper.swipeDirection === 'next' && data.currentTranslate < data.startTranslate) {
	    data.currentTranslate = data.startTranslate;
	  }
	  if (!swiper.allowSlidePrev && swiper.swipeDirection === 'prev' && data.currentTranslate > data.startTranslate) {
	    data.currentTranslate = data.startTranslate;
	  }


	  // Threshold
	  if (params.threshold > 0) {
	    if (Math.abs(diff) > params.threshold || data.allowThresholdMove) {
	      if (!data.allowThresholdMove) {
	        data.allowThresholdMove = true;
	        touches.startX = touches.currentX;
	        touches.startY = touches.currentY;
	        data.currentTranslate = data.startTranslate;
	        touches.diff = swiper.isHorizontal() ? touches.currentX - touches.startX : touches.currentY - touches.startY;
	        return;
	      }
	    } else {
	      data.currentTranslate = data.startTranslate;
	      return;
	    }
	  }

	  if (!params.followFinger) { return; }

	  // Update active index in free mode
	  if (params.freeMode || params.watchSlidesProgress || params.watchSlidesVisibility) {
	    swiper.updateActiveIndex();
	    swiper.updateSlidesClasses();
	  }
	  if (params.freeMode) {
	    // Velocity
	    if (data.velocities.length === 0) {
	      data.velocities.push({
	        position: touches[swiper.isHorizontal() ? 'startX' : 'startY'],
	        time: data.touchStartTime,
	      });
	    }
	    data.velocities.push({
	      position: touches[swiper.isHorizontal() ? 'currentX' : 'currentY'],
	      time: Utils.now(),
	    });
	  }
	  // Update progress
	  swiper.updateProgress(data.currentTranslate);
	  // Update translate
	  swiper.setTranslate(data.currentTranslate);
	}

	function onTouchEnd (event) {
	  var swiper = this;
	  var data = swiper.touchEventsData;

	  var params = swiper.params;
	  var touches = swiper.touches;
	  var rtl = swiper.rtlTranslate;
	  var $wrapperEl = swiper.$wrapperEl;
	  var slidesGrid = swiper.slidesGrid;
	  var snapGrid = swiper.snapGrid;
	  var e = event;
	  if (e.originalEvent) { e = e.originalEvent; }
	  if (data.allowTouchCallbacks) {
	    swiper.emit('touchEnd', e);
	  }
	  data.allowTouchCallbacks = false;
	  if (!data.isTouched) {
	    if (data.isMoved && params.grabCursor) {
	      swiper.setGrabCursor(false);
	    }
	    data.isMoved = false;
	    data.startMoving = false;
	    return;
	  }
	  // Return Grab Cursor
	  if (params.grabCursor && data.isMoved && data.isTouched && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
	    swiper.setGrabCursor(false);
	  }

	  // Time diff
	  var touchEndTime = Utils.now();
	  var timeDiff = touchEndTime - data.touchStartTime;

	  // Tap, doubleTap, Click
	  if (swiper.allowClick) {
	    swiper.updateClickedSlide(e);
	    swiper.emit('tap', e);
	    if (timeDiff < 300 && (touchEndTime - data.lastClickTime) > 300) {
	      if (data.clickTimeout) { clearTimeout(data.clickTimeout); }
	      data.clickTimeout = Utils.nextTick(function () {
	        if (!swiper || swiper.destroyed) { return; }
	        swiper.emit('click', e);
	      }, 300);
	    }
	    if (timeDiff < 300 && (touchEndTime - data.lastClickTime) < 300) {
	      if (data.clickTimeout) { clearTimeout(data.clickTimeout); }
	      swiper.emit('doubleTap', e);
	    }
	  }

	  data.lastClickTime = Utils.now();
	  Utils.nextTick(function () {
	    if (!swiper.destroyed) { swiper.allowClick = true; }
	  });

	  if (!data.isTouched || !data.isMoved || !swiper.swipeDirection || touches.diff === 0 || data.currentTranslate === data.startTranslate) {
	    data.isTouched = false;
	    data.isMoved = false;
	    data.startMoving = false;
	    return;
	  }
	  data.isTouched = false;
	  data.isMoved = false;
	  data.startMoving = false;

	  var currentPos;
	  if (params.followFinger) {
	    currentPos = rtl ? swiper.translate : -swiper.translate;
	  } else {
	    currentPos = -data.currentTranslate;
	  }

	  if (params.freeMode) {
	    if (currentPos < -swiper.minTranslate()) {
	      swiper.slideTo(swiper.activeIndex);
	      return;
	    } else if (currentPos > -swiper.maxTranslate()) {
	      if (swiper.slides.length < snapGrid.length) {
	        swiper.slideTo(snapGrid.length - 1);
	      } else {
	        swiper.slideTo(swiper.slides.length - 1);
	      }
	      return;
	    }

	    if (params.freeModeMomentum) {
	      if (data.velocities.length > 1) {
	        var lastMoveEvent = data.velocities.pop();
	        var velocityEvent = data.velocities.pop();

	        var distance = lastMoveEvent.position - velocityEvent.position;
	        var time = lastMoveEvent.time - velocityEvent.time;
	        swiper.velocity = distance / time;
	        swiper.velocity /= 2;
	        if (Math.abs(swiper.velocity) < params.freeModeMinimumVelocity) {
	          swiper.velocity = 0;
	        }
	        // this implies that the user stopped moving a finger then released.
	        // There would be no events with distance zero, so the last event is stale.
	        if (time > 150 || (Utils.now() - lastMoveEvent.time) > 300) {
	          swiper.velocity = 0;
	        }
	      } else {
	        swiper.velocity = 0;
	      }
	      swiper.velocity *= params.freeModeMomentumVelocityRatio;

	      data.velocities.length = 0;
	      var momentumDuration = 1000 * params.freeModeMomentumRatio;
	      var momentumDistance = swiper.velocity * momentumDuration;

	      var newPosition = swiper.translate + momentumDistance;
	      if (rtl) { newPosition = -newPosition; }

	      var doBounce = false;
	      var afterBouncePosition;
	      var bounceAmount = Math.abs(swiper.velocity) * 20 * params.freeModeMomentumBounceRatio;
	      var needsLoopFix;
	      if (newPosition < swiper.maxTranslate()) {
	        if (params.freeModeMomentumBounce) {
	          if (newPosition + swiper.maxTranslate() < -bounceAmount) {
	            newPosition = swiper.maxTranslate() - bounceAmount;
	          }
	          afterBouncePosition = swiper.maxTranslate();
	          doBounce = true;
	          data.allowMomentumBounce = true;
	        } else {
	          newPosition = swiper.maxTranslate();
	        }
	        if (params.loop && params.centeredSlides) { needsLoopFix = true; }
	      } else if (newPosition > swiper.minTranslate()) {
	        if (params.freeModeMomentumBounce) {
	          if (newPosition - swiper.minTranslate() > bounceAmount) {
	            newPosition = swiper.minTranslate() + bounceAmount;
	          }
	          afterBouncePosition = swiper.minTranslate();
	          doBounce = true;
	          data.allowMomentumBounce = true;
	        } else {
	          newPosition = swiper.minTranslate();
	        }
	        if (params.loop && params.centeredSlides) { needsLoopFix = true; }
	      } else if (params.freeModeSticky) {
	        var nextSlide;
	        for (var j = 0; j < snapGrid.length; j += 1) {
	          if (snapGrid[j] > -newPosition) {
	            nextSlide = j;
	            break;
	          }
	        }

	        if (Math.abs(snapGrid[nextSlide] - newPosition) < Math.abs(snapGrid[nextSlide - 1] - newPosition) || swiper.swipeDirection === 'next') {
	          newPosition = snapGrid[nextSlide];
	        } else {
	          newPosition = snapGrid[nextSlide - 1];
	        }
	        newPosition = -newPosition;
	      }
	      if (needsLoopFix) {
	        swiper.once('transitionEnd', function () {
	          swiper.loopFix();
	        });
	      }
	      // Fix duration
	      if (swiper.velocity !== 0) {
	        if (rtl) {
	          momentumDuration = Math.abs((-newPosition - swiper.translate) / swiper.velocity);
	        } else {
	          momentumDuration = Math.abs((newPosition - swiper.translate) / swiper.velocity);
	        }
	      } else if (params.freeModeSticky) {
	        swiper.slideToClosest();
	        return;
	      }

	      if (params.freeModeMomentumBounce && doBounce) {
	        swiper.updateProgress(afterBouncePosition);
	        swiper.setTransition(momentumDuration);
	        swiper.setTranslate(newPosition);
	        swiper.transitionStart(true, swiper.swipeDirection);
	        swiper.animating = true;
	        $wrapperEl.transitionEnd(function () {
	          if (!swiper || swiper.destroyed || !data.allowMomentumBounce) { return; }
	          swiper.emit('momentumBounce');

	          swiper.setTransition(params.speed);
	          swiper.setTranslate(afterBouncePosition);
	          $wrapperEl.transitionEnd(function () {
	            if (!swiper || swiper.destroyed) { return; }
	            swiper.transitionEnd();
	          });
	        });
	      } else if (swiper.velocity) {
	        swiper.updateProgress(newPosition);
	        swiper.setTransition(momentumDuration);
	        swiper.setTranslate(newPosition);
	        swiper.transitionStart(true, swiper.swipeDirection);
	        if (!swiper.animating) {
	          swiper.animating = true;
	          $wrapperEl.transitionEnd(function () {
	            if (!swiper || swiper.destroyed) { return; }
	            swiper.transitionEnd();
	          });
	        }
	      } else {
	        swiper.updateProgress(newPosition);
	      }

	      swiper.updateActiveIndex();
	      swiper.updateSlidesClasses();
	    } else if (params.freeModeSticky) {
	      swiper.slideToClosest();
	      return;
	    }

	    if (!params.freeModeMomentum || timeDiff >= params.longSwipesMs) {
	      swiper.updateProgress();
	      swiper.updateActiveIndex();
	      swiper.updateSlidesClasses();
	    }
	    return;
	  }

	  // Find current slide
	  var stopIndex = 0;
	  var groupSize = swiper.slidesSizesGrid[0];
	  for (var i = 0; i < slidesGrid.length; i += params.slidesPerGroup) {
	    if (typeof slidesGrid[i + params.slidesPerGroup] !== 'undefined') {
	      if (currentPos >= slidesGrid[i] && currentPos < slidesGrid[i + params.slidesPerGroup]) {
	        stopIndex = i;
	        groupSize = slidesGrid[i + params.slidesPerGroup] - slidesGrid[i];
	      }
	    } else if (currentPos >= slidesGrid[i]) {
	      stopIndex = i;
	      groupSize = slidesGrid[slidesGrid.length - 1] - slidesGrid[slidesGrid.length - 2];
	    }
	  }

	  // Find current slide size
	  var ratio = (currentPos - slidesGrid[stopIndex]) / groupSize;

	  if (timeDiff > params.longSwipesMs) {
	    // Long touches
	    if (!params.longSwipes) {
	      swiper.slideTo(swiper.activeIndex);
	      return;
	    }
	    if (swiper.swipeDirection === 'next') {
	      if (ratio >= params.longSwipesRatio) { swiper.slideTo(stopIndex + params.slidesPerGroup); }
	      else { swiper.slideTo(stopIndex); }
	    }
	    if (swiper.swipeDirection === 'prev') {
	      if (ratio > (1 - params.longSwipesRatio)) { swiper.slideTo(stopIndex + params.slidesPerGroup); }
	      else { swiper.slideTo(stopIndex); }
	    }
	  } else {
	    // Short swipes
	    if (!params.shortSwipes) {
	      swiper.slideTo(swiper.activeIndex);
	      return;
	    }
	    if (swiper.swipeDirection === 'next') {
	      swiper.slideTo(stopIndex + params.slidesPerGroup);
	    }
	    if (swiper.swipeDirection === 'prev') {
	      swiper.slideTo(stopIndex);
	    }
	  }
	}

	function onResize () {
	  var swiper = this;

	  var params = swiper.params;
	  var el = swiper.el;

	  if (el && el.offsetWidth === 0) { return; }

	  // Breakpoints
	  if (params.breakpoints) {
	    swiper.setBreakpoint();
	  }

	  // Save locks
	  var allowSlideNext = swiper.allowSlideNext;
	  var allowSlidePrev = swiper.allowSlidePrev;
	  var snapGrid = swiper.snapGrid;

	  // Disable locks on resize
	  swiper.allowSlideNext = true;
	  swiper.allowSlidePrev = true;

	  swiper.updateSize();
	  swiper.updateSlides();

	  if (params.freeMode) {
	    var newTranslate = Math.min(Math.max(swiper.translate, swiper.maxTranslate()), swiper.minTranslate());
	    swiper.setTranslate(newTranslate);
	    swiper.updateActiveIndex();
	    swiper.updateSlidesClasses();

	    if (params.autoHeight) {
	      swiper.updateAutoHeight();
	    }
	  } else {
	    swiper.updateSlidesClasses();
	    if ((params.slidesPerView === 'auto' || params.slidesPerView > 1) && swiper.isEnd && !swiper.params.centeredSlides) {
	      swiper.slideTo(swiper.slides.length - 1, 0, false, true);
	    } else {
	      swiper.slideTo(swiper.activeIndex, 0, false, true);
	    }
	  }
	  // Return locks after resize
	  swiper.allowSlidePrev = allowSlidePrev;
	  swiper.allowSlideNext = allowSlideNext;

	  if (swiper.params.watchOverflow && snapGrid !== swiper.snapGrid) {
	    swiper.checkOverflow();
	  }
	}

	function onClick (e) {
	  var swiper = this;
	  if (!swiper.allowClick) {
	    if (swiper.params.preventClicks) { e.preventDefault(); }
	    if (swiper.params.preventClicksPropagation && swiper.animating) {
	      e.stopPropagation();
	      e.stopImmediatePropagation();
	    }
	  }
	}

	function attachEvents() {
	  var swiper = this;
	  var params = swiper.params;
	  var touchEvents = swiper.touchEvents;
	  var el = swiper.el;
	  var wrapperEl = swiper.wrapperEl;

	  {
	    swiper.onTouchStart = onTouchStart.bind(swiper);
	    swiper.onTouchMove = onTouchMove.bind(swiper);
	    swiper.onTouchEnd = onTouchEnd.bind(swiper);
	  }

	  swiper.onClick = onClick.bind(swiper);

	  var target = params.touchEventsTarget === 'container' ? el : wrapperEl;
	  var capture = !!params.nested;

	  // Touch Events
	  {
	    if (!Support.touch && (Support.pointerEvents || Support.prefixedPointerEvents)) {
	      target.addEventListener(touchEvents.start, swiper.onTouchStart, false);
	      doc.addEventListener(touchEvents.move, swiper.onTouchMove, capture);
	      doc.addEventListener(touchEvents.end, swiper.onTouchEnd, false);
	    } else {
	      if (Support.touch) {
	        var passiveListener = touchEvents.start === 'touchstart' && Support.passiveListener && params.passiveListeners ? { passive: true, capture: false } : false;
	        target.addEventListener(touchEvents.start, swiper.onTouchStart, passiveListener);
	        target.addEventListener(touchEvents.move, swiper.onTouchMove, Support.passiveListener ? { passive: false, capture: capture } : capture);
	        target.addEventListener(touchEvents.end, swiper.onTouchEnd, passiveListener);
	      }
	      if ((params.simulateTouch && !Device.ios && !Device.android) || (params.simulateTouch && !Support.touch && Device.ios)) {
	        target.addEventListener('mousedown', swiper.onTouchStart, false);
	        doc.addEventListener('mousemove', swiper.onTouchMove, capture);
	        doc.addEventListener('mouseup', swiper.onTouchEnd, false);
	      }
	    }
	    // Prevent Links Clicks
	    if (params.preventClicks || params.preventClicksPropagation) {
	      target.addEventListener('click', swiper.onClick, true);
	    }
	  }

	  // Resize handler
	  swiper.on((Device.ios || Device.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate'), onResize, true);
	}

	function detachEvents() {
	  var swiper = this;

	  var params = swiper.params;
	  var touchEvents = swiper.touchEvents;
	  var el = swiper.el;
	  var wrapperEl = swiper.wrapperEl;

	  var target = params.touchEventsTarget === 'container' ? el : wrapperEl;
	  var capture = !!params.nested;

	  // Touch Events
	  {
	    if (!Support.touch && (Support.pointerEvents || Support.prefixedPointerEvents)) {
	      target.removeEventListener(touchEvents.start, swiper.onTouchStart, false);
	      doc.removeEventListener(touchEvents.move, swiper.onTouchMove, capture);
	      doc.removeEventListener(touchEvents.end, swiper.onTouchEnd, false);
	    } else {
	      if (Support.touch) {
	        var passiveListener = touchEvents.start === 'onTouchStart' && Support.passiveListener && params.passiveListeners ? { passive: true, capture: false } : false;
	        target.removeEventListener(touchEvents.start, swiper.onTouchStart, passiveListener);
	        target.removeEventListener(touchEvents.move, swiper.onTouchMove, capture);
	        target.removeEventListener(touchEvents.end, swiper.onTouchEnd, passiveListener);
	      }
	      if ((params.simulateTouch && !Device.ios && !Device.android) || (params.simulateTouch && !Support.touch && Device.ios)) {
	        target.removeEventListener('mousedown', swiper.onTouchStart, false);
	        doc.removeEventListener('mousemove', swiper.onTouchMove, capture);
	        doc.removeEventListener('mouseup', swiper.onTouchEnd, false);
	      }
	    }
	    // Prevent Links Clicks
	    if (params.preventClicks || params.preventClicksPropagation) {
	      target.removeEventListener('click', swiper.onClick, true);
	    }
	  }

	  // Resize handler
	  swiper.off((Device.ios || Device.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate'), onResize);
	}

	var events$1 = {
	  attachEvents: attachEvents,
	  detachEvents: detachEvents,
	};

	function setBreakpoint () {
	  var swiper = this;
	  var activeIndex = swiper.activeIndex;
	  var initialized = swiper.initialized;
	  var loopedSlides = swiper.loopedSlides; if ( loopedSlides === void 0 ) loopedSlides = 0;
	  var params = swiper.params;
	  var breakpoints = params.breakpoints;
	  if (!breakpoints || (breakpoints && Object.keys(breakpoints).length === 0)) { return; }
	  // Set breakpoint for window width and update parameters
	  var breakpoint = swiper.getBreakpoint(breakpoints);
	  if (breakpoint && swiper.currentBreakpoint !== breakpoint) {
	    var breakPointsParams = breakpoint in breakpoints ? breakpoints[breakpoint] : swiper.originalParams;
	    var needsReLoop = params.loop && (breakPointsParams.slidesPerView !== params.slidesPerView);

	    Utils.extend(swiper.params, breakPointsParams);

	    Utils.extend(swiper, {
	      allowTouchMove: swiper.params.allowTouchMove,
	      allowSlideNext: swiper.params.allowSlideNext,
	      allowSlidePrev: swiper.params.allowSlidePrev,
	    });

	    swiper.currentBreakpoint = breakpoint;

	    if (needsReLoop && initialized) {
	      swiper.loopDestroy();
	      swiper.loopCreate();
	      swiper.updateSlides();
	      swiper.slideTo((activeIndex - loopedSlides) + swiper.loopedSlides, 0, false);
	    }
	    swiper.emit('breakpoint', breakPointsParams);
	  }
	}

	function getBreakpoint (breakpoints) {
	  // Get breakpoint for window width
	  if (!breakpoints) { return undefined; }
	  var breakpoint = false;
	  var points = [];
	  Object.keys(breakpoints).forEach(function (point) {
	    points.push(point);
	  });
	  points.sort(function (a, b) { return parseInt(a, 10) - parseInt(b, 10); });
	  for (var i = 0; i < points.length; i += 1) {
	    var point = points[i];
	    if (point >= win.innerWidth && !breakpoint) {
	      breakpoint = point;
	    }
	  }
	  return breakpoint || 'max';
	}

	var breakpoints = { setBreakpoint: setBreakpoint, getBreakpoint: getBreakpoint };

	var Browser = (function Browser() {
	  function isSafari() {
	    var ua = win.navigator.userAgent.toLowerCase();
	    return (ua.indexOf('safari') >= 0 && ua.indexOf('chrome') < 0 && ua.indexOf('android') < 0);
	  }
	  return {
	    isIE: !!win.navigator.userAgent.match(/Trident/g) || !!win.navigator.userAgent.match(/MSIE/g),
	    isSafari: isSafari(),
	    isUiWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(win.navigator.userAgent),
	  };
	}());

	function addClasses () {
	  var swiper = this;
	  var classNames = swiper.classNames;
	  var params = swiper.params;
	  var rtl = swiper.rtl;
	  var $el = swiper.$el;
	  var suffixes = [];

	  suffixes.push(params.direction);

	  if (params.freeMode) {
	    suffixes.push('free-mode');
	  }
	  if (!Support.flexbox) {
	    suffixes.push('no-flexbox');
	  }
	  if (params.autoHeight) {
	    suffixes.push('autoheight');
	  }
	  if (rtl) {
	    suffixes.push('rtl');
	  }
	  if (params.slidesPerColumn > 1) {
	    suffixes.push('multirow');
	  }
	  if (Device.android) {
	    suffixes.push('android');
	  }
	  if (Device.ios) {
	    suffixes.push('ios');
	  }
	  // WP8 Touch Events Fix
	  if (Browser.isIE && (Support.pointerEvents || Support.prefixedPointerEvents)) {
	    suffixes.push(("wp8-" + (params.direction)));
	  }

	  suffixes.forEach(function (suffix) {
	    classNames.push(params.containerModifierClass + suffix);
	  });

	  $el.addClass(classNames.join(' '));
	}

	function removeClasses () {
	  var swiper = this;
	  var $el = swiper.$el;
	  var classNames = swiper.classNames;

	  $el.removeClass(classNames.join(' '));
	}

	var classes = { addClasses: addClasses, removeClasses: removeClasses };

	function loadImage (imageEl, src, srcset, sizes, checkForComplete, callback) {
	  var image;
	  function onReady() {
	    if (callback) { callback(); }
	  }
	  if (!imageEl.complete || !checkForComplete) {
	    if (src) {
	      image = new win.Image();
	      image.onload = onReady;
	      image.onerror = onReady;
	      if (sizes) {
	        image.sizes = sizes;
	      }
	      if (srcset) {
	        image.srcset = srcset;
	      }
	      if (src) {
	        image.src = src;
	      }
	    } else {
	      onReady();
	    }
	  } else {
	    // image already loaded...
	    onReady();
	  }
	}

	function preloadImages () {
	  var swiper = this;
	  swiper.imagesToLoad = swiper.$el.find('img');
	  function onReady() {
	    if (typeof swiper === 'undefined' || swiper === null || !swiper || swiper.destroyed) { return; }
	    if (swiper.imagesLoaded !== undefined) { swiper.imagesLoaded += 1; }
	    if (swiper.imagesLoaded === swiper.imagesToLoad.length) {
	      if (swiper.params.updateOnImagesReady) { swiper.update(); }
	      swiper.emit('imagesReady');
	    }
	  }
	  for (var i = 0; i < swiper.imagesToLoad.length; i += 1) {
	    var imageEl = swiper.imagesToLoad[i];
	    swiper.loadImage(
	      imageEl,
	      imageEl.currentSrc || imageEl.getAttribute('src'),
	      imageEl.srcset || imageEl.getAttribute('srcset'),
	      imageEl.sizes || imageEl.getAttribute('sizes'),
	      true,
	      onReady
	    );
	  }
	}

	var images = {
	  loadImage: loadImage,
	  preloadImages: preloadImages,
	};

	function checkOverflow() {
	  var swiper = this;
	  var wasLocked = swiper.isLocked;

	  swiper.isLocked = swiper.snapGrid.length === 1;
	  swiper.allowSlideNext = !swiper.isLocked;
	  swiper.allowSlidePrev = !swiper.isLocked;

	  // events
	  if (wasLocked !== swiper.isLocked) { swiper.emit(swiper.isLocked ? 'lock' : 'unlock'); }

	  if (wasLocked && wasLocked !== swiper.isLocked) {
	    swiper.isEnd = false;
	    swiper.navigation.update();
	  }
	}

	var checkOverflow$1 = { checkOverflow: checkOverflow };

	var defaults = {
	  init: true,
	  direction: 'horizontal',
	  touchEventsTarget: 'container',
	  initialSlide: 0,
	  speed: 300,
	  //
	  preventIntercationOnTransition: false,

	  // To support iOS's swipe-to-go-back gesture (when being used in-app, with UIWebView).
	  iOSEdgeSwipeDetection: false,
	  iOSEdgeSwipeThreshold: 20,

	  // Free mode
	  freeMode: false,
	  freeModeMomentum: true,
	  freeModeMomentumRatio: 1,
	  freeModeMomentumBounce: true,
	  freeModeMomentumBounceRatio: 1,
	  freeModeMomentumVelocityRatio: 1,
	  freeModeSticky: false,
	  freeModeMinimumVelocity: 0.02,

	  // Autoheight
	  autoHeight: false,

	  // Set wrapper width
	  setWrapperSize: false,

	  // Virtual Translate
	  virtualTranslate: false,

	  // Effects
	  effect: 'slide', // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'

	  // Breakpoints
	  breakpoints: undefined,

	  // Slides grid
	  spaceBetween: 0,
	  slidesPerView: 1,
	  slidesPerColumn: 1,
	  slidesPerColumnFill: 'column',
	  slidesPerGroup: 1,
	  centeredSlides: false,
	  slidesOffsetBefore: 0, // in px
	  slidesOffsetAfter: 0, // in px
	  normalizeSlideIndex: true,

	  // Disable swiper and hide navigation when container not overflow
	  watchOverflow: false,

	  // Round length
	  roundLengths: false,

	  // Touches
	  touchRatio: 1,
	  touchAngle: 45,
	  simulateTouch: true,
	  shortSwipes: true,
	  longSwipes: true,
	  longSwipesRatio: 0.5,
	  longSwipesMs: 300,
	  followFinger: true,
	  allowTouchMove: true,
	  threshold: 0,
	  touchMoveStopPropagation: true,
	  touchReleaseOnEdges: false,

	  // Unique Navigation Elements
	  uniqueNavElements: true,

	  // Resistance
	  resistance: true,
	  resistanceRatio: 0.85,

	  // Progress
	  watchSlidesProgress: false,
	  watchSlidesVisibility: false,

	  // Cursor
	  grabCursor: false,

	  // Clicks
	  preventClicks: true,
	  preventClicksPropagation: true,
	  slideToClickedSlide: false,

	  // Images
	  preloadImages: true,
	  updateOnImagesReady: true,

	  // loop
	  loop: false,
	  loopAdditionalSlides: 0,
	  loopedSlides: null,
	  loopFillGroupWithBlank: false,

	  // Swiping/no swiping
	  allowSlidePrev: true,
	  allowSlideNext: true,
	  swipeHandler: null, // '.swipe-handler',
	  noSwiping: true,
	  noSwipingClass: 'swiper-no-swiping',
	  noSwipingSelector: null,

	  // Passive Listeners
	  passiveListeners: true,

	  // NS
	  containerModifierClass: 'swiper-container-', // NEW
	  slideClass: 'swiper-slide',
	  slideBlankClass: 'swiper-slide-invisible-blank',
	  slideActiveClass: 'swiper-slide-active',
	  slideDuplicateActiveClass: 'swiper-slide-duplicate-active',
	  slideVisibleClass: 'swiper-slide-visible',
	  slideDuplicateClass: 'swiper-slide-duplicate',
	  slideNextClass: 'swiper-slide-next',
	  slideDuplicateNextClass: 'swiper-slide-duplicate-next',
	  slidePrevClass: 'swiper-slide-prev',
	  slideDuplicatePrevClass: 'swiper-slide-duplicate-prev',
	  wrapperClass: 'swiper-wrapper',

	  // Callbacks
	  runCallbacksOnInit: true,
	};

	var prototypes = {
	  update: update,
	  translate: translate,
	  transition: transition$2,
	  slide: slide,
	  loop: loop,
	  grabCursor: grabCursor,
	  manipulation: manipulation,
	  events: events$1,
	  breakpoints: breakpoints,
	  checkOverflow: checkOverflow$1,
	  classes: classes,
	  images: images,
	};

	var extendedDefaults = {};

	var Swiper = (function (SwiperClass) {
	  function Swiper() {
	    var args = [], len = arguments.length;
	    while ( len-- ) args[ len ] = arguments[ len ];

	    var el;
	    var params;
	    if (args.length === 1 && args[0].constructor && args[0].constructor === Object) {
	      params = args[0];
	    } else {
	      var assign;
	      (assign = args, el = assign[0], params = assign[1]);
	    }
	    if (!params) { params = {}; }

	    params = Utils.extend({}, params);
	    if (el && !params.el) { params.el = el; }

	    SwiperClass.call(this, params);

	    Object.keys(prototypes).forEach(function (prototypeGroup) {
	      Object.keys(prototypes[prototypeGroup]).forEach(function (protoMethod) {
	        if (!Swiper.prototype[protoMethod]) {
	          Swiper.prototype[protoMethod] = prototypes[prototypeGroup][protoMethod];
	        }
	      });
	    });

	    // Swiper Instance
	    var swiper = this;
	    if (typeof swiper.modules === 'undefined') {
	      swiper.modules = {};
	    }
	    Object.keys(swiper.modules).forEach(function (moduleName) {
	      var module = swiper.modules[moduleName];
	      if (module.params) {
	        var moduleParamName = Object.keys(module.params)[0];
	        var moduleParams = module.params[moduleParamName];
	        if (typeof moduleParams !== 'object') { return; }
	        if (!(moduleParamName in params && 'enabled' in moduleParams)) { return; }
	        if (params[moduleParamName] === true) {
	          params[moduleParamName] = { enabled: true };
	        }
	        if (
	          typeof params[moduleParamName] === 'object' &&
	          !('enabled' in params[moduleParamName])
	        ) {
	          params[moduleParamName].enabled = true;
	        }
	        if (!params[moduleParamName]) { params[moduleParamName] = { enabled: false }; }
	      }
	    });

	    // Extend defaults with modules params
	    var swiperParams = Utils.extend({}, defaults);
	    swiper.useModulesParams(swiperParams);

	    // Extend defaults with passed params
	    swiper.params = Utils.extend({}, swiperParams, extendedDefaults, params);
	    swiper.originalParams = Utils.extend({}, swiper.params);
	    swiper.passedParams = Utils.extend({}, params);

	    // Save Dom lib
	    swiper.$ = $$1;

	    // Find el
	    var $el = $$1(swiper.params.el);
	    el = $el[0];

	    if (!el) {
	      return undefined;
	    }

	    if ($el.length > 1) {
	      var swipers = [];
	      $el.each(function (index, containerEl) {
	        var newParams = Utils.extend({}, params, { el: containerEl });
	        swipers.push(new Swiper(newParams));
	      });
	      return swipers;
	    }

	    el.swiper = swiper;
	    $el.data('swiper', swiper);

	    // Find Wrapper
	    var $wrapperEl = $el.children(("." + (swiper.params.wrapperClass)));

	    // Extend Swiper
	    Utils.extend(swiper, {
	      $el: $el,
	      el: el,
	      $wrapperEl: $wrapperEl,
	      wrapperEl: $wrapperEl[0],

	      // Classes
	      classNames: [],

	      // Slides
	      slides: $$1(),
	      slidesGrid: [],
	      snapGrid: [],
	      slidesSizesGrid: [],

	      // isDirection
	      isHorizontal: function isHorizontal() {
	        return swiper.params.direction === 'horizontal';
	      },
	      isVertical: function isVertical() {
	        return swiper.params.direction === 'vertical';
	      },
	      // RTL
	      rtl: (el.dir.toLowerCase() === 'rtl' || $el.css('direction') === 'rtl'),
	      rtlTranslate: swiper.params.direction === 'horizontal' && (el.dir.toLowerCase() === 'rtl' || $el.css('direction') === 'rtl'),
	      wrongRTL: $wrapperEl.css('display') === '-webkit-box',

	      // Indexes
	      activeIndex: 0,
	      realIndex: 0,

	      //
	      isBeginning: true,
	      isEnd: false,

	      // Props
	      translate: 0,
	      progress: 0,
	      velocity: 0,
	      animating: false,

	      // Locks
	      allowSlideNext: swiper.params.allowSlideNext,
	      allowSlidePrev: swiper.params.allowSlidePrev,

	      // Touch Events
	      touchEvents: (function touchEvents() {
	        var touch = ['touchstart', 'touchmove', 'touchend'];
	        var desktop = ['mousedown', 'mousemove', 'mouseup'];
	        if (Support.pointerEvents) {
	          desktop = ['pointerdown', 'pointermove', 'pointerup'];
	        } else if (Support.prefixedPointerEvents) {
	          desktop = ['MSPointerDown', 'MSPointerMove', 'MSPointerUp'];
	        }
	        swiper.touchEventsTouch = {
	          start: touch[0],
	          move: touch[1],
	          end: touch[2],
	        };
	        swiper.touchEventsDesktop = {
	          start: desktop[0],
	          move: desktop[1],
	          end: desktop[2],
	        };
	        return Support.touch || !swiper.params.simulateTouch ? swiper.touchEventsTouch : swiper.touchEventsDesktop;
	      }()),
	      touchEventsData: {
	        isTouched: undefined,
	        isMoved: undefined,
	        allowTouchCallbacks: undefined,
	        touchStartTime: undefined,
	        isScrolling: undefined,
	        currentTranslate: undefined,
	        startTranslate: undefined,
	        allowThresholdMove: undefined,
	        // Form elements to match
	        formElements: 'input, select, option, textarea, button, video',
	        // Last click time
	        lastClickTime: Utils.now(),
	        clickTimeout: undefined,
	        // Velocities
	        velocities: [],
	        allowMomentumBounce: undefined,
	        isTouchEvent: undefined,
	        startMoving: undefined,
	      },

	      // Clicks
	      allowClick: true,

	      // Touches
	      allowTouchMove: swiper.params.allowTouchMove,

	      touches: {
	        startX: 0,
	        startY: 0,
	        currentX: 0,
	        currentY: 0,
	        diff: 0,
	      },

	      // Images
	      imagesToLoad: [],
	      imagesLoaded: 0,

	    });

	    // Install Modules
	    swiper.useModules();

	    // Init
	    if (swiper.params.init) {
	      swiper.init();
	    }

	    // Return app instance
	    return swiper;
	  }

	  if ( SwiperClass ) Swiper.__proto__ = SwiperClass;
	  Swiper.prototype = Object.create( SwiperClass && SwiperClass.prototype );
	  Swiper.prototype.constructor = Swiper;

	  var staticAccessors = { extendedDefaults: { configurable: true },defaults: { configurable: true },Class: { configurable: true },$: { configurable: true } };
	  Swiper.prototype.slidesPerViewDynamic = function slidesPerViewDynamic () {
	    var swiper = this;
	    var params = swiper.params;
	    var slides = swiper.slides;
	    var slidesGrid = swiper.slidesGrid;
	    var swiperSize = swiper.size;
	    var activeIndex = swiper.activeIndex;
	    var spv = 1;
	    if (params.centeredSlides) {
	      var slideSize = slides[activeIndex].swiperSlideSize;
	      var breakLoop;
	      for (var i = activeIndex + 1; i < slides.length; i += 1) {
	        if (slides[i] && !breakLoop) {
	          slideSize += slides[i].swiperSlideSize;
	          spv += 1;
	          if (slideSize > swiperSize) { breakLoop = true; }
	        }
	      }
	      for (var i$1 = activeIndex - 1; i$1 >= 0; i$1 -= 1) {
	        if (slides[i$1] && !breakLoop) {
	          slideSize += slides[i$1].swiperSlideSize;
	          spv += 1;
	          if (slideSize > swiperSize) { breakLoop = true; }
	        }
	      }
	    } else {
	      for (var i$2 = activeIndex + 1; i$2 < slides.length; i$2 += 1) {
	        if (slidesGrid[i$2] - slidesGrid[activeIndex] < swiperSize) {
	          spv += 1;
	        }
	      }
	    }
	    return spv;
	  };
	  Swiper.prototype.update = function update$$1 () {
	    var swiper = this;
	    if (!swiper || swiper.destroyed) { return; }
	    var snapGrid = swiper.snapGrid;
	    var params = swiper.params;
	    // Breakpoints
	    if (params.breakpoints) {
	      swiper.setBreakpoint();
	    }
	    swiper.updateSize();
	    swiper.updateSlides();
	    swiper.updateProgress();
	    swiper.updateSlidesClasses();

	    function setTranslate() {
	      var translateValue = swiper.rtlTranslate ? swiper.translate * -1 : swiper.translate;
	      var newTranslate = Math.min(Math.max(translateValue, swiper.maxTranslate()), swiper.minTranslate());
	      swiper.setTranslate(newTranslate);
	      swiper.updateActiveIndex();
	      swiper.updateSlidesClasses();
	    }
	    var translated;
	    if (swiper.params.freeMode) {
	      setTranslate();
	      if (swiper.params.autoHeight) {
	        swiper.updateAutoHeight();
	      }
	    } else {
	      if ((swiper.params.slidesPerView === 'auto' || swiper.params.slidesPerView > 1) && swiper.isEnd && !swiper.params.centeredSlides) {
	        translated = swiper.slideTo(swiper.slides.length - 1, 0, false, true);
	      } else {
	        translated = swiper.slideTo(swiper.activeIndex, 0, false, true);
	      }
	      if (!translated) {
	        setTranslate();
	      }
	    }
	    if (params.watchOverflow && snapGrid !== swiper.snapGrid) {
	      swiper.checkOverflow();
	    }
	    swiper.emit('update');
	  };
	  Swiper.prototype.init = function init () {
	    var swiper = this;
	    if (swiper.initialized) { return; }

	    swiper.emit('beforeInit');

	    // Set breakpoint
	    if (swiper.params.breakpoints) {
	      swiper.setBreakpoint();
	    }

	    // Add Classes
	    swiper.addClasses();

	    // Create loop
	    if (swiper.params.loop) {
	      swiper.loopCreate();
	    }

	    // Update size
	    swiper.updateSize();

	    // Update slides
	    swiper.updateSlides();

	    if (swiper.params.watchOverflow) {
	      swiper.checkOverflow();
	    }

	    // Set Grab Cursor
	    if (swiper.params.grabCursor) {
	      swiper.setGrabCursor();
	    }

	    if (swiper.params.preloadImages) {
	      swiper.preloadImages();
	    }

	    // Slide To Initial Slide
	    if (swiper.params.loop) {
	      swiper.slideTo(swiper.params.initialSlide + swiper.loopedSlides, 0, swiper.params.runCallbacksOnInit);
	    } else {
	      swiper.slideTo(swiper.params.initialSlide, 0, swiper.params.runCallbacksOnInit);
	    }

	    // Attach events
	    swiper.attachEvents();

	    // Init Flag
	    swiper.initialized = true;

	    // Emit
	    swiper.emit('init');
	  };
	  Swiper.prototype.destroy = function destroy (deleteInstance, cleanStyles) {
	    if ( deleteInstance === void 0 ) deleteInstance = true;
	    if ( cleanStyles === void 0 ) cleanStyles = true;

	    var swiper = this;
	    var params = swiper.params;
	    var $el = swiper.$el;
	    var $wrapperEl = swiper.$wrapperEl;
	    var slides = swiper.slides;

	    if (typeof swiper.params === 'undefined' || swiper.destroyed) {
	      return null;
	    }

	    swiper.emit('beforeDestroy');

	    // Init Flag
	    swiper.initialized = false;

	    // Detach events
	    swiper.detachEvents();

	    // Destroy loop
	    if (params.loop) {
	      swiper.loopDestroy();
	    }

	    // Cleanup styles
	    if (cleanStyles) {
	      swiper.removeClasses();
	      $el.removeAttr('style');
	      $wrapperEl.removeAttr('style');
	      if (slides && slides.length) {
	        slides
	          .removeClass([
	            params.slideVisibleClass,
	            params.slideActiveClass,
	            params.slideNextClass,
	            params.slidePrevClass ].join(' '))
	          .removeAttr('style')
	          .removeAttr('data-swiper-slide-index')
	          .removeAttr('data-swiper-column')
	          .removeAttr('data-swiper-row');
	      }
	    }

	    swiper.emit('destroy');

	    // Detach emitter events
	    Object.keys(swiper.eventsListeners).forEach(function (eventName) {
	      swiper.off(eventName);
	    });

	    if (deleteInstance !== false) {
	      swiper.$el[0].swiper = null;
	      swiper.$el.data('swiper', null);
	      Utils.deleteProps(swiper);
	    }
	    swiper.destroyed = true;

	    return null;
	  };
	  Swiper.extendDefaults = function extendDefaults (newDefaults) {
	    Utils.extend(extendedDefaults, newDefaults);
	  };
	  staticAccessors.extendedDefaults.get = function () {
	    return extendedDefaults;
	  };
	  staticAccessors.defaults.get = function () {
	    return defaults;
	  };
	  staticAccessors.Class.get = function () {
	    return SwiperClass;
	  };
	  staticAccessors.$.get = function () {
	    return $$1;
	  };

	  Object.defineProperties( Swiper, staticAccessors );

	  return Swiper;
	}(Framework7Class));

	var Device$1 = {
	  name: 'device',
	  proto: {
	    device: Device,
	  },
	  static: {
	    device: Device,
	  },
	};

	var Support$1 = {
	  name: 'support',
	  proto: {
	    support: Support,
	  },
	  static: {
	    support: Support,
	  },
	};

	var Browser$1 = {
	  name: 'browser',
	  proto: {
	    browser: Browser,
	  },
	  static: {
	    browser: Browser,
	  },
	};

	var Resize = {
	  name: 'resize',
	  create: function create() {
	    var swiper = this;
	    Utils.extend(swiper, {
	      resize: {
	        resizeHandler: function resizeHandler() {
	          if (!swiper || swiper.destroyed || !swiper.initialized) { return; }
	          swiper.emit('beforeResize');
	          swiper.emit('resize');
	        },
	        orientationChangeHandler: function orientationChangeHandler() {
	          if (!swiper || swiper.destroyed || !swiper.initialized) { return; }
	          swiper.emit('orientationchange');
	        },
	      },
	    });
	  },
	  on: {
	    init: function init() {
	      var swiper = this;
	      // Emit resize
	      win.addEventListener('resize', swiper.resize.resizeHandler);

	      // Emit orientationchange
	      win.addEventListener('orientationchange', swiper.resize.orientationChangeHandler);
	    },
	    destroy: function destroy() {
	      var swiper = this;
	      win.removeEventListener('resize', swiper.resize.resizeHandler);
	      win.removeEventListener('orientationchange', swiper.resize.orientationChangeHandler);
	    },
	  },
	};

	var Observer$1 = {
	  func: win.MutationObserver || win.WebkitMutationObserver,
	  attach: function attach(target, options) {
	    if ( options === void 0 ) options = {};

	    var swiper = this;

	    var ObserverFunc = Observer$1.func;
	    var observer = new ObserverFunc(function (mutations) {
	      mutations.forEach(function (mutation) {
	        swiper.emit('observerUpdate', mutation);
	      });
	    });

	    observer.observe(target, {
	      attributes: typeof options.attributes === 'undefined' ? true : options.attributes,
	      childList: typeof options.childList === 'undefined' ? true : options.childList,
	      characterData: typeof options.characterData === 'undefined' ? true : options.characterData,
	    });

	    swiper.observer.observers.push(observer);
	  },
	  init: function init() {
	    var swiper = this;
	    if (!Support.observer || !swiper.params.observer) { return; }
	    if (swiper.params.observeParents) {
	      var containerParents = swiper.$el.parents();
	      for (var i = 0; i < containerParents.length; i += 1) {
	        swiper.observer.attach(containerParents[i]);
	      }
	    }
	    // Observe container
	    swiper.observer.attach(swiper.$el[0], { childList: false });

	    // Observe wrapper
	    swiper.observer.attach(swiper.$wrapperEl[0], { attributes: false });
	  },
	  destroy: function destroy() {
	    var swiper = this;
	    swiper.observer.observers.forEach(function (observer) {
	      observer.disconnect();
	    });
	    swiper.observer.observers = [];
	  },
	};

	var Observer$2 = {
	  name: 'observer',
	  params: {
	    observer: false,
	    observeParents: false,
	  },
	  create: function create() {
	    var swiper = this;
	    Utils.extend(swiper, {
	      observer: {
	        init: Observer$1.init.bind(swiper),
	        attach: Observer$1.attach.bind(swiper),
	        destroy: Observer$1.destroy.bind(swiper),
	        observers: [],
	      },
	    });
	  },
	  on: {
	    init: function init() {
	      var swiper = this;
	      swiper.observer.init();
	    },
	    destroy: function destroy() {
	      var swiper = this;
	      swiper.observer.destroy();
	    },
	  },
	};

	var Virtual = {
	  update: function update(force) {
	    var swiper = this;
	    var ref = swiper.params;
	    var slidesPerView = ref.slidesPerView;
	    var slidesPerGroup = ref.slidesPerGroup;
	    var centeredSlides = ref.centeredSlides;
	    var ref$1 = swiper.virtual;
	    var previousFrom = ref$1.from;
	    var previousTo = ref$1.to;
	    var slides = ref$1.slides;
	    var previousSlidesGrid = ref$1.slidesGrid;
	    var renderSlide = ref$1.renderSlide;
	    var previousOffset = ref$1.offset;
	    swiper.updateActiveIndex();
	    var activeIndex = swiper.activeIndex || 0;

	    var offsetProp;
	    if (swiper.rtlTranslate) { offsetProp = 'right'; }
	    else { offsetProp = swiper.isHorizontal() ? 'left' : 'top'; }

	    var slidesAfter;
	    var slidesBefore;
	    if (centeredSlides) {
	      slidesAfter = Math.floor(slidesPerView / 2) + slidesPerGroup;
	      slidesBefore = Math.floor(slidesPerView / 2) + slidesPerGroup;
	    } else {
	      slidesAfter = slidesPerView + (slidesPerGroup - 1);
	      slidesBefore = slidesPerGroup;
	    }
	    var from = Math.max((activeIndex || 0) - slidesBefore, 0);
	    var to = Math.min((activeIndex || 0) + slidesAfter, slides.length - 1);
	    var offset = (swiper.slidesGrid[from] || 0) - (swiper.slidesGrid[0] || 0);

	    Utils.extend(swiper.virtual, {
	      from: from,
	      to: to,
	      offset: offset,
	      slidesGrid: swiper.slidesGrid,
	    });

	    function onRendered() {
	      swiper.updateSlides();
	      swiper.updateProgress();
	      swiper.updateSlidesClasses();
	      if (swiper.lazy && swiper.params.lazy.enabled) {
	        swiper.lazy.load();
	      }
	    }

	    if (previousFrom === from && previousTo === to && !force) {
	      if (swiper.slidesGrid !== previousSlidesGrid && offset !== previousOffset) {
	        swiper.slides.css(offsetProp, (offset + "px"));
	      }
	      swiper.updateProgress();
	      return;
	    }
	    if (swiper.params.virtual.renderExternal) {
	      swiper.params.virtual.renderExternal.call(swiper, {
	        offset: offset,
	        from: from,
	        to: to,
	        slides: (function getSlides() {
	          var slidesToRender = [];
	          for (var i = from; i <= to; i += 1) {
	            slidesToRender.push(slides[i]);
	          }
	          return slidesToRender;
	        }()),
	      });
	      onRendered();
	      return;
	    }
	    var prependIndexes = [];
	    var appendIndexes = [];
	    if (force) {
	      swiper.$wrapperEl.find(("." + (swiper.params.slideClass))).remove();
	    } else {
	      for (var i = previousFrom; i <= previousTo; i += 1) {
	        if (i < from || i > to) {
	          swiper.$wrapperEl.find(("." + (swiper.params.slideClass) + "[data-swiper-slide-index=\"" + i + "\"]")).remove();
	        }
	      }
	    }
	    for (var i$1 = 0; i$1 < slides.length; i$1 += 1) {
	      if (i$1 >= from && i$1 <= to) {
	        if (typeof previousTo === 'undefined' || force) {
	          appendIndexes.push(i$1);
	        } else {
	          if (i$1 > previousTo) { appendIndexes.push(i$1); }
	          if (i$1 < previousFrom) { prependIndexes.push(i$1); }
	        }
	      }
	    }
	    appendIndexes.forEach(function (index) {
	      swiper.$wrapperEl.append(renderSlide(slides[index], index));
	    });
	    prependIndexes.sort(function (a, b) { return a < b; }).forEach(function (index) {
	      swiper.$wrapperEl.prepend(renderSlide(slides[index], index));
	    });
	    swiper.$wrapperEl.children('.swiper-slide').css(offsetProp, (offset + "px"));
	    onRendered();
	  },
	  renderSlide: function renderSlide(slide, index) {
	    var swiper = this;
	    var params = swiper.params.virtual;
	    if (params.cache && swiper.virtual.cache[index]) {
	      return swiper.virtual.cache[index];
	    }
	    var $slideEl = params.renderSlide
	      ? $$1(params.renderSlide.call(swiper, slide, index))
	      : $$1(("<div class=\"" + (swiper.params.slideClass) + "\" data-swiper-slide-index=\"" + index + "\">" + slide + "</div>"));
	    if (!$slideEl.attr('data-swiper-slide-index')) { $slideEl.attr('data-swiper-slide-index', index); }
	    if (params.cache) { swiper.virtual.cache[index] = $slideEl; }
	    return $slideEl;
	  },
	  appendSlide: function appendSlide(slide) {
	    var swiper = this;
	    swiper.virtual.slides.push(slide);
	    swiper.virtual.update(true);
	  },
	  prependSlide: function prependSlide(slide) {
	    var swiper = this;
	    swiper.virtual.slides.unshift(slide);
	    if (swiper.params.virtual.cache) {
	      var cache = swiper.virtual.cache;
	      var newCache = {};
	      Object.keys(cache).forEach(function (cachedIndex) {
	        newCache[cachedIndex + 1] = cache[cachedIndex];
	      });
	      swiper.virtual.cache = newCache;
	    }
	    swiper.virtual.update(true);
	    swiper.slideNext(0);
	  },
	};

	var Virtual$1 = {
	  name: 'virtual',
	  params: {
	    virtual: {
	      enabled: false,
	      slides: [],
	      cache: true,
	      renderSlide: null,
	      renderExternal: null,
	    },
	  },
	  create: function create() {
	    var swiper = this;
	    Utils.extend(swiper, {
	      virtual: {
	        update: Virtual.update.bind(swiper),
	        appendSlide: Virtual.appendSlide.bind(swiper),
	        prependSlide: Virtual.prependSlide.bind(swiper),
	        renderSlide: Virtual.renderSlide.bind(swiper),
	        slides: swiper.params.virtual.slides,
	        cache: {},
	      },
	    });
	  },
	  on: {
	    beforeInit: function beforeInit() {
	      var swiper = this;
	      if (!swiper.params.virtual.enabled) { return; }
	      swiper.classNames.push(((swiper.params.containerModifierClass) + "virtual"));
	      var overwriteParams = {
	        watchSlidesProgress: true,
	      };
	      Utils.extend(swiper.params, overwriteParams);
	      Utils.extend(swiper.originalParams, overwriteParams);

	      swiper.virtual.update();
	    },
	    setTranslate: function setTranslate() {
	      var swiper = this;
	      if (!swiper.params.virtual.enabled) { return; }
	      swiper.virtual.update();
	    },
	  },
	};

	var Navigation = {
	  update: function update() {
	    // Update Navigation Buttons
	    var swiper = this;
	    var params = swiper.params.navigation;

	    if (swiper.params.loop) { return; }
	    var ref = swiper.navigation;
	    var $nextEl = ref.$nextEl;
	    var $prevEl = ref.$prevEl;

	    if ($prevEl && $prevEl.length > 0) {
	      if (swiper.isBeginning) {
	        $prevEl.addClass(params.disabledClass);
	      } else {
	        $prevEl.removeClass(params.disabledClass);
	      }
	      $prevEl[swiper.params.watchOverflow && swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
	    }
	    if ($nextEl && $nextEl.length > 0) {
	      if (swiper.isEnd) {
	        $nextEl.addClass(params.disabledClass);
	      } else {
	        $nextEl.removeClass(params.disabledClass);
	      }
	      $nextEl[swiper.params.watchOverflow && swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
	    }
	  },
	  init: function init() {
	    var swiper = this;
	    var params = swiper.params.navigation;
	    if (!(params.nextEl || params.prevEl)) { return; }

	    var $nextEl;
	    var $prevEl;
	    if (params.nextEl) {
	      $nextEl = $$1(params.nextEl);
	      if (
	        swiper.params.uniqueNavElements &&
	        typeof params.nextEl === 'string' &&
	        $nextEl.length > 1 &&
	        swiper.$el.find(params.nextEl).length === 1
	      ) {
	        $nextEl = swiper.$el.find(params.nextEl);
	      }
	    }
	    if (params.prevEl) {
	      $prevEl = $$1(params.prevEl);
	      if (
	        swiper.params.uniqueNavElements &&
	        typeof params.prevEl === 'string' &&
	        $prevEl.length > 1 &&
	        swiper.$el.find(params.prevEl).length === 1
	      ) {
	        $prevEl = swiper.$el.find(params.prevEl);
	      }
	    }

	    if ($nextEl && $nextEl.length > 0) {
	      $nextEl.on('click', function (e) {
	        e.preventDefault();
	        if (swiper.isEnd && !swiper.params.loop) { return; }
	        swiper.slideNext();
	      });
	    }
	    if ($prevEl && $prevEl.length > 0) {
	      $prevEl.on('click', function (e) {
	        e.preventDefault();
	        if (swiper.isBeginning && !swiper.params.loop) { return; }
	        swiper.slidePrev();
	      });
	    }

	    Utils.extend(swiper.navigation, {
	      $nextEl: $nextEl,
	      nextEl: $nextEl && $nextEl[0],
	      $prevEl: $prevEl,
	      prevEl: $prevEl && $prevEl[0],
	    });
	  },
	  destroy: function destroy() {
	    var swiper = this;
	    var ref = swiper.navigation;
	    var $nextEl = ref.$nextEl;
	    var $prevEl = ref.$prevEl;
	    if ($nextEl && $nextEl.length) {
	      $nextEl.off('click');
	      $nextEl.removeClass(swiper.params.navigation.disabledClass);
	    }
	    if ($prevEl && $prevEl.length) {
	      $prevEl.off('click');
	      $prevEl.removeClass(swiper.params.navigation.disabledClass);
	    }
	  },
	};

	var Navigation$1 = {
	  name: 'navigation',
	  params: {
	    navigation: {
	      nextEl: null,
	      prevEl: null,

	      hideOnClick: false,
	      disabledClass: 'swiper-button-disabled',
	      hiddenClass: 'swiper-button-hidden',
	      lockClass: 'swiper-button-lock',
	    },
	  },
	  create: function create() {
	    var swiper = this;
	    Utils.extend(swiper, {
	      navigation: {
	        init: Navigation.init.bind(swiper),
	        update: Navigation.update.bind(swiper),
	        destroy: Navigation.destroy.bind(swiper),
	      },
	    });
	  },
	  on: {
	    init: function init() {
	      var swiper = this;
	      swiper.navigation.init();
	      swiper.navigation.update();
	    },
	    toEdge: function toEdge() {
	      var swiper = this;
	      swiper.navigation.update();
	    },
	    fromEdge: function fromEdge() {
	      var swiper = this;
	      swiper.navigation.update();
	    },
	    destroy: function destroy() {
	      var swiper = this;
	      swiper.navigation.destroy();
	    },
	    click: function click(e) {
	      var swiper = this;
	      var ref = swiper.navigation;
	      var $nextEl = ref.$nextEl;
	      var $prevEl = ref.$prevEl;
	      if (
	        swiper.params.navigation.hideOnClick &&
	        !$$1(e.target).is($prevEl) &&
	        !$$1(e.target).is($nextEl)
	      ) {
	        if ($nextEl) { $nextEl.toggleClass(swiper.params.navigation.hiddenClass); }
	        if ($prevEl) { $prevEl.toggleClass(swiper.params.navigation.hiddenClass); }
	      }
	    },
	  },
	};

	var Pagination = {
	  update: function update() {
	    // Render || Update Pagination bullets/items
	    var swiper = this;
	    var rtl = swiper.rtl;
	    var params = swiper.params.pagination;
	    if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) { return; }
	    var slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
	    var $el = swiper.pagination.$el;
	    // Current/Total
	    var current;
	    var total = swiper.params.loop ? Math.ceil((slidesLength - (swiper.loopedSlides * 2)) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
	    if (swiper.params.loop) {
	      current = Math.ceil((swiper.activeIndex - swiper.loopedSlides) / swiper.params.slidesPerGroup);
	      if (current > slidesLength - 1 - (swiper.loopedSlides * 2)) {
	        current -= (slidesLength - (swiper.loopedSlides * 2));
	      }
	      if (current > total - 1) { current -= total; }
	      if (current < 0 && swiper.params.paginationType !== 'bullets') { current = total + current; }
	    } else if (typeof swiper.snapIndex !== 'undefined') {
	      current = swiper.snapIndex;
	    } else {
	      current = swiper.activeIndex || 0;
	    }
	    // Types
	    if (params.type === 'bullets' && swiper.pagination.bullets && swiper.pagination.bullets.length > 0) {
	      var bullets = swiper.pagination.bullets;
	      var firstIndex;
	      var lastIndex;
	      var midIndex;
	      if (params.dynamicBullets) {
	        swiper.pagination.bulletSize = bullets.eq(0)[swiper.isHorizontal() ? 'outerWidth' : 'outerHeight'](true);
	        $el.css(swiper.isHorizontal() ? 'width' : 'height', ((swiper.pagination.bulletSize * (params.dynamicMainBullets + 4)) + "px"));
	        if (params.dynamicMainBullets > 1 && swiper.previousIndex !== undefined) {
	          swiper.pagination.dynamicBulletIndex += (current - swiper.previousIndex);
	          if (swiper.pagination.dynamicBulletIndex > (params.dynamicMainBullets - 1)) {
	            swiper.pagination.dynamicBulletIndex = params.dynamicMainBullets - 1;
	          } else if (swiper.pagination.dynamicBulletIndex < 0) {
	            swiper.pagination.dynamicBulletIndex = 0;
	          }
	        }
	        firstIndex = current - swiper.pagination.dynamicBulletIndex;
	        lastIndex = firstIndex + (Math.min(bullets.length, params.dynamicMainBullets) - 1);
	        midIndex = (lastIndex + firstIndex) / 2;
	      }
	      bullets.removeClass(((params.bulletActiveClass) + " " + (params.bulletActiveClass) + "-next " + (params.bulletActiveClass) + "-next-next " + (params.bulletActiveClass) + "-prev " + (params.bulletActiveClass) + "-prev-prev " + (params.bulletActiveClass) + "-main"));
	      if ($el.length > 1) {
	        bullets.each(function (index, bullet) {
	          var $bullet = $$1(bullet);
	          var bulletIndex = $bullet.index();
	          if (bulletIndex === current) {
	            $bullet.addClass(params.bulletActiveClass);
	          }
	          if (params.dynamicBullets) {
	            if (bulletIndex >= firstIndex && bulletIndex <= lastIndex) {
	              $bullet.addClass(((params.bulletActiveClass) + "-main"));
	            }
	            if (bulletIndex === firstIndex) {
	              $bullet
	                .prev()
	                .addClass(((params.bulletActiveClass) + "-prev"))
	                .prev()
	                .addClass(((params.bulletActiveClass) + "-prev-prev"));
	            }
	            if (bulletIndex === lastIndex) {
	              $bullet
	                .next()
	                .addClass(((params.bulletActiveClass) + "-next"))
	                .next()
	                .addClass(((params.bulletActiveClass) + "-next-next"));
	            }
	          }
	        });
	      } else {
	        var $bullet = bullets.eq(current);
	        $bullet.addClass(params.bulletActiveClass);
	        if (params.dynamicBullets) {
	          var $firstDisplayedBullet = bullets.eq(firstIndex);
	          var $lastDisplayedBullet = bullets.eq(lastIndex);
	          for (var i = firstIndex; i <= lastIndex; i += 1) {
	            bullets.eq(i).addClass(((params.bulletActiveClass) + "-main"));
	          }
	          $firstDisplayedBullet
	            .prev()
	            .addClass(((params.bulletActiveClass) + "-prev"))
	            .prev()
	            .addClass(((params.bulletActiveClass) + "-prev-prev"));
	          $lastDisplayedBullet
	            .next()
	            .addClass(((params.bulletActiveClass) + "-next"))
	            .next()
	            .addClass(((params.bulletActiveClass) + "-next-next"));
	        }
	      }
	      if (params.dynamicBullets) {
	        var dynamicBulletsLength = Math.min(bullets.length, params.dynamicMainBullets + 4);
	        var bulletsOffset = (((swiper.pagination.bulletSize * dynamicBulletsLength) - (swiper.pagination.bulletSize)) / 2) - (midIndex * swiper.pagination.bulletSize);
	        var offsetProp = rtl ? 'right' : 'left';
	        bullets.css(swiper.isHorizontal() ? offsetProp : 'top', (bulletsOffset + "px"));
	      }
	    }
	    if (params.type === 'fraction') {
	      $el.find(("." + (params.currentClass))).text(params.formatFractionCurrent(current + 1));
	      $el.find(("." + (params.totalClass))).text(params.formatFractionTotal(total));
	    }
	    if (params.type === 'progressbar') {
	      var progressbarDirection;
	      if (params.progressbarOpposite) {
	        progressbarDirection = swiper.isHorizontal() ? 'vertical' : 'horizontal';
	      } else {
	        progressbarDirection = swiper.isHorizontal() ? 'horizontal' : 'vertical';
	      }
	      var scale = (current + 1) / total;
	      var scaleX = 1;
	      var scaleY = 1;
	      if (progressbarDirection === 'horizontal') {
	        scaleX = scale;
	      } else {
	        scaleY = scale;
	      }
	      $el.find(("." + (params.progressbarFillClass))).transform(("translate3d(0,0,0) scaleX(" + scaleX + ") scaleY(" + scaleY + ")")).transition(swiper.params.speed);
	    }
	    if (params.type === 'custom' && params.renderCustom) {
	      $el.html(params.renderCustom(swiper, current + 1, total));
	      swiper.emit('paginationRender', swiper, $el[0]);
	    } else {
	      swiper.emit('paginationUpdate', swiper, $el[0]);
	    }
	    $el[swiper.params.watchOverflow && swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
	  },
	  render: function render() {
	    // Render Container
	    var swiper = this;
	    var params = swiper.params.pagination;
	    if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) { return; }
	    var slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;

	    var $el = swiper.pagination.$el;
	    var paginationHTML = '';
	    if (params.type === 'bullets') {
	      var numberOfBullets = swiper.params.loop ? Math.ceil((slidesLength - (swiper.loopedSlides * 2)) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
	      for (var i = 0; i < numberOfBullets; i += 1) {
	        if (params.renderBullet) {
	          paginationHTML += params.renderBullet.call(swiper, i, params.bulletClass);
	        } else {
	          paginationHTML += "<" + (params.bulletElement) + " class=\"" + (params.bulletClass) + "\"></" + (params.bulletElement) + ">";
	        }
	      }
	      $el.html(paginationHTML);
	      swiper.pagination.bullets = $el.find(("." + (params.bulletClass)));
	    }
	    if (params.type === 'fraction') {
	      if (params.renderFraction) {
	        paginationHTML = params.renderFraction.call(swiper, params.currentClass, params.totalClass);
	      } else {
	        paginationHTML =
	        "<span class=\"" + (params.currentClass) + "\"></span>" +
	        ' / ' +
	        "<span class=\"" + (params.totalClass) + "\"></span>";
	      }
	      $el.html(paginationHTML);
	    }
	    if (params.type === 'progressbar') {
	      if (params.renderProgressbar) {
	        paginationHTML = params.renderProgressbar.call(swiper, params.progressbarFillClass);
	      } else {
	        paginationHTML = "<span class=\"" + (params.progressbarFillClass) + "\"></span>";
	      }
	      $el.html(paginationHTML);
	    }
	    if (params.type !== 'custom') {
	      swiper.emit('paginationRender', swiper.pagination.$el[0]);
	    }
	  },
	  init: function init() {
	    var swiper = this;
	    var params = swiper.params.pagination;
	    if (!params.el) { return; }

	    var $el = $$1(params.el);
	    if ($el.length === 0) { return; }

	    if (
	      swiper.params.uniqueNavElements &&
	      typeof params.el === 'string' &&
	      $el.length > 1 &&
	      swiper.$el.find(params.el).length === 1
	    ) {
	      $el = swiper.$el.find(params.el);
	    }

	    if (params.type === 'bullets' && params.clickable) {
	      $el.addClass(params.clickableClass);
	    }

	    $el.addClass(params.modifierClass + params.type);

	    if (params.type === 'bullets' && params.dynamicBullets) {
	      $el.addClass(("" + (params.modifierClass) + (params.type) + "-dynamic"));
	      swiper.pagination.dynamicBulletIndex = 0;
	      if (params.dynamicMainBullets < 1) {
	        params.dynamicMainBullets = 1;
	      }
	    }
	    if (params.type === 'progressbar' && params.progressbarOpposite) {
	      $el.addClass(params.progressbarOppositeClass);
	    }

	    if (params.clickable) {
	      $el.on('click', ("." + (params.bulletClass)), function onClick(e) {
	        e.preventDefault();
	        var index = $$1(this).index() * swiper.params.slidesPerGroup;
	        if (swiper.params.loop) { index += swiper.loopedSlides; }
	        swiper.slideTo(index);
	      });
	    }

	    Utils.extend(swiper.pagination, {
	      $el: $el,
	      el: $el[0],
	    });
	  },
	  destroy: function destroy() {
	    var swiper = this;
	    var params = swiper.params.pagination;
	    if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) { return; }
	    var $el = swiper.pagination.$el;

	    $el.removeClass(params.hiddenClass);
	    $el.removeClass(params.modifierClass + params.type);
	    if (swiper.pagination.bullets) { swiper.pagination.bullets.removeClass(params.bulletActiveClass); }
	    if (params.clickable) {
	      $el.off('click', ("." + (params.bulletClass)));
	    }
	  },
	};

	var Pagination$1 = {
	  name: 'pagination',
	  params: {
	    pagination: {
	      el: null,
	      bulletElement: 'span',
	      clickable: false,
	      hideOnClick: false,
	      renderBullet: null,
	      renderProgressbar: null,
	      renderFraction: null,
	      renderCustom: null,
	      progressbarOpposite: false,
	      type: 'bullets', // 'bullets' or 'progressbar' or 'fraction' or 'custom'
	      dynamicBullets: false,
	      dynamicMainBullets: 1,
	      formatFractionCurrent: function (number) { return number; },
	      formatFractionTotal: function (number) { return number; },
	      bulletClass: 'swiper-pagination-bullet',
	      bulletActiveClass: 'swiper-pagination-bullet-active',
	      modifierClass: 'swiper-pagination-', // NEW
	      currentClass: 'swiper-pagination-current',
	      totalClass: 'swiper-pagination-total',
	      hiddenClass: 'swiper-pagination-hidden',
	      progressbarFillClass: 'swiper-pagination-progressbar-fill',
	      progressbarOppositeClass: 'swiper-pagination-progressbar-opposite',
	      clickableClass: 'swiper-pagination-clickable', // NEW
	      lockClass: 'swiper-pagination-lock',
	    },
	  },
	  create: function create() {
	    var swiper = this;
	    Utils.extend(swiper, {
	      pagination: {
	        init: Pagination.init.bind(swiper),
	        render: Pagination.render.bind(swiper),
	        update: Pagination.update.bind(swiper),
	        destroy: Pagination.destroy.bind(swiper),
	        dynamicBulletIndex: 0,
	      },
	    });
	  },
	  on: {
	    init: function init() {
	      var swiper = this;
	      swiper.pagination.init();
	      swiper.pagination.render();
	      swiper.pagination.update();
	    },
	    activeIndexChange: function activeIndexChange() {
	      var swiper = this;
	      if (swiper.params.loop) {
	        swiper.pagination.update();
	      } else if (typeof swiper.snapIndex === 'undefined') {
	        swiper.pagination.update();
	      }
	    },
	    snapIndexChange: function snapIndexChange() {
	      var swiper = this;
	      if (!swiper.params.loop) {
	        swiper.pagination.update();
	      }
	    },
	    slidesLengthChange: function slidesLengthChange() {
	      var swiper = this;
	      if (swiper.params.loop) {
	        swiper.pagination.render();
	        swiper.pagination.update();
	      }
	    },
	    snapGridLengthChange: function snapGridLengthChange() {
	      var swiper = this;
	      if (!swiper.params.loop) {
	        swiper.pagination.render();
	        swiper.pagination.update();
	      }
	    },
	    destroy: function destroy() {
	      var swiper = this;
	      swiper.pagination.destroy();
	    },
	    click: function click(e) {
	      var swiper = this;
	      if (
	        swiper.params.pagination.el &&
	        swiper.params.pagination.hideOnClick &&
	        swiper.pagination.$el.length > 0 &&
	        !$$1(e.target).hasClass(swiper.params.pagination.bulletClass)
	      ) {
	        swiper.pagination.$el.toggleClass(swiper.params.pagination.hiddenClass);
	      }
	    },
	  },
	};

	var Scrollbar = {
	  setTranslate: function setTranslate() {
	    var swiper = this;
	    if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) { return; }
	    var scrollbar = swiper.scrollbar;
	    var rtl = swiper.rtlTranslate;
	    var progress = swiper.progress;
	    var dragSize = scrollbar.dragSize;
	    var trackSize = scrollbar.trackSize;
	    var $dragEl = scrollbar.$dragEl;
	    var $el = scrollbar.$el;
	    var params = swiper.params.scrollbar;

	    var newSize = dragSize;
	    var newPos = (trackSize - dragSize) * progress;
	    if (rtl) {
	      newPos = -newPos;
	      if (newPos > 0) {
	        newSize = dragSize - newPos;
	        newPos = 0;
	      } else if (-newPos + dragSize > trackSize) {
	        newSize = trackSize + newPos;
	      }
	    } else if (newPos < 0) {
	      newSize = dragSize + newPos;
	      newPos = 0;
	    } else if (newPos + dragSize > trackSize) {
	      newSize = trackSize - newPos;
	    }
	    if (swiper.isHorizontal()) {
	      if (Support.transforms3d) {
	        $dragEl.transform(("translate3d(" + newPos + "px, 0, 0)"));
	      } else {
	        $dragEl.transform(("translateX(" + newPos + "px)"));
	      }
	      $dragEl[0].style.width = newSize + "px";
	    } else {
	      if (Support.transforms3d) {
	        $dragEl.transform(("translate3d(0px, " + newPos + "px, 0)"));
	      } else {
	        $dragEl.transform(("translateY(" + newPos + "px)"));
	      }
	      $dragEl[0].style.height = newSize + "px";
	    }
	    if (params.hide) {
	      clearTimeout(swiper.scrollbar.timeout);
	      $el[0].style.opacity = 1;
	      swiper.scrollbar.timeout = setTimeout(function () {
	        $el[0].style.opacity = 0;
	        $el.transition(400);
	      }, 1000);
	    }
	  },
	  setTransition: function setTransition(duration) {
	    var swiper = this;
	    if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) { return; }
	    swiper.scrollbar.$dragEl.transition(duration);
	  },
	  updateSize: function updateSize() {
	    var swiper = this;
	    if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) { return; }

	    var scrollbar = swiper.scrollbar;
	    var $dragEl = scrollbar.$dragEl;
	    var $el = scrollbar.$el;

	    $dragEl[0].style.width = '';
	    $dragEl[0].style.height = '';
	    var trackSize = swiper.isHorizontal() ? $el[0].offsetWidth : $el[0].offsetHeight;

	    var divider = swiper.size / swiper.virtualSize;
	    var moveDivider = divider * (trackSize / swiper.size);
	    var dragSize;
	    if (swiper.params.scrollbar.dragSize === 'auto') {
	      dragSize = trackSize * divider;
	    } else {
	      dragSize = parseInt(swiper.params.scrollbar.dragSize, 10);
	    }

	    if (swiper.isHorizontal()) {
	      $dragEl[0].style.width = dragSize + "px";
	    } else {
	      $dragEl[0].style.height = dragSize + "px";
	    }

	    if (divider >= 1) {
	      $el[0].style.display = 'none';
	    } else {
	      $el[0].style.display = '';
	    }
	    if (swiper.params.scrollbarHide) {
	      $el[0].style.opacity = 0;
	    }
	    Utils.extend(scrollbar, {
	      trackSize: trackSize,
	      divider: divider,
	      moveDivider: moveDivider,
	      dragSize: dragSize,
	    });
	    scrollbar.$el[swiper.params.watchOverflow && swiper.isLocked ? 'addClass' : 'removeClass'](swiper.params.scrollbar.lockClass);
	  },
	  setDragPosition: function setDragPosition(e) {
	    var swiper = this;
	    var scrollbar = swiper.scrollbar;
	    var rtl = swiper.rtlTranslate;
	    var $el = scrollbar.$el;
	    var dragSize = scrollbar.dragSize;
	    var trackSize = scrollbar.trackSize;

	    var pointerPosition;
	    if (swiper.isHorizontal()) {
	      pointerPosition = ((e.type === 'touchstart' || e.type === 'touchmove') ? e.targetTouches[0].pageX : e.pageX || e.clientX);
	    } else {
	      pointerPosition = ((e.type === 'touchstart' || e.type === 'touchmove') ? e.targetTouches[0].pageY : e.pageY || e.clientY);
	    }
	    var positionRatio;
	    positionRatio = ((pointerPosition) - $el.offset()[swiper.isHorizontal() ? 'left' : 'top'] - (dragSize / 2)) / (trackSize - dragSize);
	    positionRatio = Math.max(Math.min(positionRatio, 1), 0);
	    if (rtl) {
	      positionRatio = 1 - positionRatio;
	    }

	    var position = swiper.minTranslate() + ((swiper.maxTranslate() - swiper.minTranslate()) * positionRatio);

	    swiper.updateProgress(position);
	    swiper.setTranslate(position);
	    swiper.updateActiveIndex();
	    swiper.updateSlidesClasses();
	  },
	  onDragStart: function onDragStart(e) {
	    var swiper = this;
	    var params = swiper.params.scrollbar;
	    var scrollbar = swiper.scrollbar;
	    var $wrapperEl = swiper.$wrapperEl;
	    var $el = scrollbar.$el;
	    var $dragEl = scrollbar.$dragEl;
	    swiper.scrollbar.isTouched = true;
	    e.preventDefault();
	    e.stopPropagation();

	    $wrapperEl.transition(100);
	    $dragEl.transition(100);
	    scrollbar.setDragPosition(e);

	    clearTimeout(swiper.scrollbar.dragTimeout);

	    $el.transition(0);
	    if (params.hide) {
	      $el.css('opacity', 1);
	    }
	    swiper.emit('scrollbarDragStart', e);
	  },
	  onDragMove: function onDragMove(e) {
	    var swiper = this;
	    var scrollbar = swiper.scrollbar;
	    var $wrapperEl = swiper.$wrapperEl;
	    var $el = scrollbar.$el;
	    var $dragEl = scrollbar.$dragEl;

	    if (!swiper.scrollbar.isTouched) { return; }
	    if (e.preventDefault) { e.preventDefault(); }
	    else { e.returnValue = false; }
	    scrollbar.setDragPosition(e);
	    $wrapperEl.transition(0);
	    $el.transition(0);
	    $dragEl.transition(0);
	    swiper.emit('scrollbarDragMove', e);
	  },
	  onDragEnd: function onDragEnd(e) {
	    var swiper = this;

	    var params = swiper.params.scrollbar;
	    var scrollbar = swiper.scrollbar;
	    var $el = scrollbar.$el;

	    if (!swiper.scrollbar.isTouched) { return; }
	    swiper.scrollbar.isTouched = false;
	    if (params.hide) {
	      clearTimeout(swiper.scrollbar.dragTimeout);
	      swiper.scrollbar.dragTimeout = Utils.nextTick(function () {
	        $el.css('opacity', 0);
	        $el.transition(400);
	      }, 1000);
	    }
	    swiper.emit('scrollbarDragEnd', e);
	    if (params.snapOnRelease) {
	      swiper.slideToClosest();
	    }
	  },
	  enableDraggable: function enableDraggable() {
	    var swiper = this;
	    if (!swiper.params.scrollbar.el) { return; }
	    var scrollbar = swiper.scrollbar;
	    var touchEvents = swiper.touchEvents;
	    var touchEventsDesktop = swiper.touchEventsDesktop;
	    var params = swiper.params;
	    var $el = scrollbar.$el;
	    var target = $el[0];
	    var activeListener = Support.passiveListener && params.passiveListener ? { passive: false, capture: false } : false;
	    var passiveListener = Support.passiveListener && params.passiveListener ? { passive: true, capture: false } : false;
	    if (!Support.touch && (Support.pointerEvents || Support.prefixedPointerEvents)) {
	      target.addEventListener(touchEventsDesktop.start, swiper.scrollbar.onDragStart, activeListener);
	      doc.addEventListener(touchEventsDesktop.move, swiper.scrollbar.onDragMove, activeListener);
	      doc.addEventListener(touchEventsDesktop.end, swiper.scrollbar.onDragEnd, passiveListener);
	    } else {
	      if (Support.touch) {
	        target.addEventListener(touchEvents.start, swiper.scrollbar.onDragStart, activeListener);
	        target.addEventListener(touchEvents.move, swiper.scrollbar.onDragMove, activeListener);
	        target.addEventListener(touchEvents.end, swiper.scrollbar.onDragEnd, passiveListener);
	      }
	      if ((params.simulateTouch && !Device.ios && !Device.android) || (params.simulateTouch && !Support.touch && Device.ios)) {
	        target.addEventListener('mousedown', swiper.scrollbar.onDragStart, activeListener);
	        doc.addEventListener('mousemove', swiper.scrollbar.onDragMove, activeListener);
	        doc.addEventListener('mouseup', swiper.scrollbar.onDragEnd, passiveListener);
	      }
	    }
	  },
	  disableDraggable: function disableDraggable() {
	    var swiper = this;
	    if (!swiper.params.scrollbar.el) { return; }
	    var scrollbar = swiper.scrollbar;
	    var touchEvents = swiper.touchEvents;
	    var touchEventsDesktop = swiper.touchEventsDesktop;
	    var params = swiper.params;
	    var $el = scrollbar.$el;
	    var target = $el[0];
	    var activeListener = Support.passiveListener && params.passiveListener ? { passive: false, capture: false } : false;
	    var passiveListener = Support.passiveListener && params.passiveListener ? { passive: true, capture: false } : false;
	    if (!Support.touch && (Support.pointerEvents || Support.prefixedPointerEvents)) {
	      target.removeEventListener(touchEventsDesktop.start, swiper.scrollbar.onDragStart, activeListener);
	      doc.removeEventListener(touchEventsDesktop.move, swiper.scrollbar.onDragMove, activeListener);
	      doc.removeEventListener(touchEventsDesktop.end, swiper.scrollbar.onDragEnd, passiveListener);
	    } else {
	      if (Support.touch) {
	        target.removeEventListener(touchEvents.start, swiper.scrollbar.onDragStart, activeListener);
	        target.removeEventListener(touchEvents.move, swiper.scrollbar.onDragMove, activeListener);
	        target.removeEventListener(touchEvents.end, swiper.scrollbar.onDragEnd, passiveListener);
	      }
	      if ((params.simulateTouch && !Device.ios && !Device.android) || (params.simulateTouch && !Support.touch && Device.ios)) {
	        target.removeEventListener('mousedown', swiper.scrollbar.onDragStart, activeListener);
	        doc.removeEventListener('mousemove', swiper.scrollbar.onDragMove, activeListener);
	        doc.removeEventListener('mouseup', swiper.scrollbar.onDragEnd, passiveListener);
	      }
	    }
	  },
	  init: function init() {
	    var swiper = this;
	    if (!swiper.params.scrollbar.el) { return; }
	    var scrollbar = swiper.scrollbar;
	    var $swiperEl = swiper.$el;
	    var params = swiper.params.scrollbar;

	    var $el = $$1(params.el);
	    if (swiper.params.uniqueNavElements && typeof params.el === 'string' && $el.length > 1 && $swiperEl.find(params.el).length === 1) {
	      $el = $swiperEl.find(params.el);
	    }

	    var $dragEl = $el.find(("." + (swiper.params.scrollbar.dragClass)));
	    if ($dragEl.length === 0) {
	      $dragEl = $$1(("<div class=\"" + (swiper.params.scrollbar.dragClass) + "\"></div>"));
	      $el.append($dragEl);
	    }

	    Utils.extend(scrollbar, {
	      $el: $el,
	      el: $el[0],
	      $dragEl: $dragEl,
	      dragEl: $dragEl[0],
	    });

	    if (params.draggable) {
	      scrollbar.enableDraggable();
	    }
	  },
	  destroy: function destroy() {
	    var swiper = this;
	    swiper.scrollbar.disableDraggable();
	  },
	};

	var Scrollbar$1 = {
	  name: 'scrollbar',
	  params: {
	    scrollbar: {
	      el: null,
	      dragSize: 'auto',
	      hide: false,
	      draggable: false,
	      snapOnRelease: true,
	      lockClass: 'swiper-scrollbar-lock',
	      dragClass: 'swiper-scrollbar-drag',
	    },
	  },
	  create: function create() {
	    var swiper = this;
	    Utils.extend(swiper, {
	      scrollbar: {
	        init: Scrollbar.init.bind(swiper),
	        destroy: Scrollbar.destroy.bind(swiper),
	        updateSize: Scrollbar.updateSize.bind(swiper),
	        setTranslate: Scrollbar.setTranslate.bind(swiper),
	        setTransition: Scrollbar.setTransition.bind(swiper),
	        enableDraggable: Scrollbar.enableDraggable.bind(swiper),
	        disableDraggable: Scrollbar.disableDraggable.bind(swiper),
	        setDragPosition: Scrollbar.setDragPosition.bind(swiper),
	        onDragStart: Scrollbar.onDragStart.bind(swiper),
	        onDragMove: Scrollbar.onDragMove.bind(swiper),
	        onDragEnd: Scrollbar.onDragEnd.bind(swiper),
	        isTouched: false,
	        timeout: null,
	        dragTimeout: null,
	      },
	    });
	  },
	  on: {
	    init: function init() {
	      var swiper = this;
	      swiper.scrollbar.init();
	      swiper.scrollbar.updateSize();
	      swiper.scrollbar.setTranslate();
	    },
	    update: function update() {
	      var swiper = this;
	      swiper.scrollbar.updateSize();
	    },
	    resize: function resize() {
	      var swiper = this;
	      swiper.scrollbar.updateSize();
	    },
	    observerUpdate: function observerUpdate() {
	      var swiper = this;
	      swiper.scrollbar.updateSize();
	    },
	    setTranslate: function setTranslate() {
	      var swiper = this;
	      swiper.scrollbar.setTranslate();
	    },
	    setTransition: function setTransition(duration) {
	      var swiper = this;
	      swiper.scrollbar.setTransition(duration);
	    },
	    destroy: function destroy() {
	      var swiper = this;
	      swiper.scrollbar.destroy();
	    },
	  },
	};

	var Parallax = {
	  setTransform: function setTransform(el, progress) {
	    var swiper = this;
	    var rtl = swiper.rtl;

	    var $el = $$1(el);
	    var rtlFactor = rtl ? -1 : 1;

	    var p = $el.attr('data-swiper-parallax') || '0';
	    var x = $el.attr('data-swiper-parallax-x');
	    var y = $el.attr('data-swiper-parallax-y');
	    var scale = $el.attr('data-swiper-parallax-scale');
	    var opacity = $el.attr('data-swiper-parallax-opacity');

	    if (x || y) {
	      x = x || '0';
	      y = y || '0';
	    } else if (swiper.isHorizontal()) {
	      x = p;
	      y = '0';
	    } else {
	      y = p;
	      x = '0';
	    }

	    if ((x).indexOf('%') >= 0) {
	      x = (parseInt(x, 10) * progress * rtlFactor) + "%";
	    } else {
	      x = (x * progress * rtlFactor) + "px";
	    }
	    if ((y).indexOf('%') >= 0) {
	      y = (parseInt(y, 10) * progress) + "%";
	    } else {
	      y = (y * progress) + "px";
	    }

	    if (typeof opacity !== 'undefined' && opacity !== null) {
	      var currentOpacity = opacity - ((opacity - 1) * (1 - Math.abs(progress)));
	      $el[0].style.opacity = currentOpacity;
	    }
	    if (typeof scale === 'undefined' || scale === null) {
	      $el.transform(("translate3d(" + x + ", " + y + ", 0px)"));
	    } else {
	      var currentScale = scale - ((scale - 1) * (1 - Math.abs(progress)));
	      $el.transform(("translate3d(" + x + ", " + y + ", 0px) scale(" + currentScale + ")"));
	    }
	  },
	  setTranslate: function setTranslate() {
	    var swiper = this;
	    var $el = swiper.$el;
	    var slides = swiper.slides;
	    var progress = swiper.progress;
	    var snapGrid = swiper.snapGrid;
	    $el.children('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y]')
	      .each(function (index, el) {
	        swiper.parallax.setTransform(el, progress);
	      });
	    slides.each(function (slideIndex, slideEl) {
	      var slideProgress = slideEl.progress;
	      if (swiper.params.slidesPerGroup > 1 && swiper.params.slidesPerView !== 'auto') {
	        slideProgress += Math.ceil(slideIndex / 2) - (progress * (snapGrid.length - 1));
	      }
	      slideProgress = Math.min(Math.max(slideProgress, -1), 1);
	      $$1(slideEl).find('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y]')
	        .each(function (index, el) {
	          swiper.parallax.setTransform(el, slideProgress);
	        });
	    });
	  },
	  setTransition: function setTransition(duration) {
	    if ( duration === void 0 ) duration = this.params.speed;

	    var swiper = this;
	    var $el = swiper.$el;
	    $el.find('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y]')
	      .each(function (index, parallaxEl) {
	        var $parallaxEl = $$1(parallaxEl);
	        var parallaxDuration = parseInt($parallaxEl.attr('data-swiper-parallax-duration'), 10) || duration;
	        if (duration === 0) { parallaxDuration = 0; }
	        $parallaxEl.transition(parallaxDuration);
	      });
	  },
	};

	var Parallax$1 = {
	  name: 'parallax',
	  params: {
	    parallax: {
	      enabled: false,
	    },
	  },
	  create: function create() {
	    var swiper = this;
	    Utils.extend(swiper, {
	      parallax: {
	        setTransform: Parallax.setTransform.bind(swiper),
	        setTranslate: Parallax.setTranslate.bind(swiper),
	        setTransition: Parallax.setTransition.bind(swiper),
	      },
	    });
	  },
	  on: {
	    beforeInit: function beforeInit() {
	      var swiper = this;
	      if (!swiper.params.parallax.enabled) { return; }
	      swiper.params.watchSlidesProgress = true;
	    },
	    init: function init() {
	      var swiper = this;
	      if (!swiper.params.parallax) { return; }
	      swiper.parallax.setTranslate();
	    },
	    setTranslate: function setTranslate() {
	      var swiper = this;
	      if (!swiper.params.parallax) { return; }
	      swiper.parallax.setTranslate();
	    },
	    setTransition: function setTransition(duration) {
	      var swiper = this;
	      if (!swiper.params.parallax) { return; }
	      swiper.parallax.setTransition(duration);
	    },
	  },
	};

	var Zoom = {
	  // Calc Scale From Multi-touches
	  getDistanceBetweenTouches: function getDistanceBetweenTouches(e) {
	    if (e.targetTouches.length < 2) { return 1; }
	    var x1 = e.targetTouches[0].pageX;
	    var y1 = e.targetTouches[0].pageY;
	    var x2 = e.targetTouches[1].pageX;
	    var y2 = e.targetTouches[1].pageY;
	    var distance = Math.sqrt((Math.pow( (x2 - x1), 2 )) + (Math.pow( (y2 - y1), 2 )));
	    return distance;
	  },
	  // Events
	  onGestureStart: function onGestureStart(e) {
	    var swiper = this;
	    var params = swiper.params.zoom;
	    var zoom = swiper.zoom;
	    var gesture = zoom.gesture;
	    zoom.fakeGestureTouched = false;
	    zoom.fakeGestureMoved = false;
	    if (!Support.gestures) {
	      if (e.type !== 'touchstart' || (e.type === 'touchstart' && e.targetTouches.length < 2)) {
	        return;
	      }
	      zoom.fakeGestureTouched = true;
	      gesture.scaleStart = Zoom.getDistanceBetweenTouches(e);
	    }
	    if (!gesture.$slideEl || !gesture.$slideEl.length) {
	      gesture.$slideEl = $$1(e.target).closest('.swiper-slide');
	      if (gesture.$slideEl.length === 0) { gesture.$slideEl = swiper.slides.eq(swiper.activeIndex); }
	      gesture.$imageEl = gesture.$slideEl.find('img, svg, canvas');
	      gesture.$imageWrapEl = gesture.$imageEl.parent(("." + (params.containerClass)));
	      gesture.maxRatio = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;
	      if (gesture.$imageWrapEl.length === 0) {
	        gesture.$imageEl = undefined;
	        return;
	      }
	    }
	    gesture.$imageEl.transition(0);
	    swiper.zoom.isScaling = true;
	  },
	  onGestureChange: function onGestureChange(e) {
	    var swiper = this;
	    var params = swiper.params.zoom;
	    var zoom = swiper.zoom;
	    var gesture = zoom.gesture;
	    if (!Support.gestures) {
	      if (e.type !== 'touchmove' || (e.type === 'touchmove' && e.targetTouches.length < 2)) {
	        return;
	      }
	      zoom.fakeGestureMoved = true;
	      gesture.scaleMove = Zoom.getDistanceBetweenTouches(e);
	    }
	    if (!gesture.$imageEl || gesture.$imageEl.length === 0) { return; }
	    if (Support.gestures) {
	      swiper.zoom.scale = e.scale * zoom.currentScale;
	    } else {
	      zoom.scale = (gesture.scaleMove / gesture.scaleStart) * zoom.currentScale;
	    }
	    if (zoom.scale > gesture.maxRatio) {
	      zoom.scale = (gesture.maxRatio - 1) + (Math.pow( ((zoom.scale - gesture.maxRatio) + 1), 0.5 ));
	    }
	    if (zoom.scale < params.minRatio) {
	      zoom.scale = (params.minRatio + 1) - (Math.pow( ((params.minRatio - zoom.scale) + 1), 0.5 ));
	    }
	    gesture.$imageEl.transform(("translate3d(0,0,0) scale(" + (zoom.scale) + ")"));
	  },
	  onGestureEnd: function onGestureEnd(e) {
	    var swiper = this;
	    var params = swiper.params.zoom;
	    var zoom = swiper.zoom;
	    var gesture = zoom.gesture;
	    if (!Support.gestures) {
	      if (!zoom.fakeGestureTouched || !zoom.fakeGestureMoved) {
	        return;
	      }
	      if (e.type !== 'touchend' || (e.type === 'touchend' && e.changedTouches.length < 2 && !Device.android)) {
	        return;
	      }
	      zoom.fakeGestureTouched = false;
	      zoom.fakeGestureMoved = false;
	    }
	    if (!gesture.$imageEl || gesture.$imageEl.length === 0) { return; }
	    zoom.scale = Math.max(Math.min(zoom.scale, gesture.maxRatio), params.minRatio);
	    gesture.$imageEl.transition(swiper.params.speed).transform(("translate3d(0,0,0) scale(" + (zoom.scale) + ")"));
	    zoom.currentScale = zoom.scale;
	    zoom.isScaling = false;
	    if (zoom.scale === 1) { gesture.$slideEl = undefined; }
	  },
	  onTouchStart: function onTouchStart(e) {
	    var swiper = this;
	    var zoom = swiper.zoom;
	    var gesture = zoom.gesture;
	    var image = zoom.image;
	    if (!gesture.$imageEl || gesture.$imageEl.length === 0) { return; }
	    if (image.isTouched) { return; }
	    if (Device.android) { e.preventDefault(); }
	    image.isTouched = true;
	    image.touchesStart.x = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
	    image.touchesStart.y = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
	  },
	  onTouchMove: function onTouchMove(e) {
	    var swiper = this;
	    var zoom = swiper.zoom;
	    var gesture = zoom.gesture;
	    var image = zoom.image;
	    var velocity = zoom.velocity;
	    if (!gesture.$imageEl || gesture.$imageEl.length === 0) { return; }
	    swiper.allowClick = false;
	    if (!image.isTouched || !gesture.$slideEl) { return; }

	    if (!image.isMoved) {
	      image.width = gesture.$imageEl[0].offsetWidth;
	      image.height = gesture.$imageEl[0].offsetHeight;
	      image.startX = Utils.getTranslate(gesture.$imageWrapEl[0], 'x') || 0;
	      image.startY = Utils.getTranslate(gesture.$imageWrapEl[0], 'y') || 0;
	      gesture.slideWidth = gesture.$slideEl[0].offsetWidth;
	      gesture.slideHeight = gesture.$slideEl[0].offsetHeight;
	      gesture.$imageWrapEl.transition(0);
	      if (swiper.rtl) {
	        image.startX = -image.startX;
	        image.startY = -image.startY;
	      }
	    }
	    // Define if we need image drag
	    var scaledWidth = image.width * zoom.scale;
	    var scaledHeight = image.height * zoom.scale;

	    if (scaledWidth < gesture.slideWidth && scaledHeight < gesture.slideHeight) { return; }

	    image.minX = Math.min(((gesture.slideWidth / 2) - (scaledWidth / 2)), 0);
	    image.maxX = -image.minX;
	    image.minY = Math.min(((gesture.slideHeight / 2) - (scaledHeight / 2)), 0);
	    image.maxY = -image.minY;

	    image.touchesCurrent.x = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX;
	    image.touchesCurrent.y = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;

	    if (!image.isMoved && !zoom.isScaling) {
	      if (
	        swiper.isHorizontal() &&
	        (
	          (Math.floor(image.minX) === Math.floor(image.startX) && image.touchesCurrent.x < image.touchesStart.x) ||
	          (Math.floor(image.maxX) === Math.floor(image.startX) && image.touchesCurrent.x > image.touchesStart.x)
	        )
	      ) {
	        image.isTouched = false;
	        return;
	      } else if (
	        !swiper.isHorizontal() &&
	        (
	          (Math.floor(image.minY) === Math.floor(image.startY) && image.touchesCurrent.y < image.touchesStart.y) ||
	          (Math.floor(image.maxY) === Math.floor(image.startY) && image.touchesCurrent.y > image.touchesStart.y)
	        )
	      ) {
	        image.isTouched = false;
	        return;
	      }
	    }
	    e.preventDefault();
	    e.stopPropagation();

	    image.isMoved = true;
	    image.currentX = (image.touchesCurrent.x - image.touchesStart.x) + image.startX;
	    image.currentY = (image.touchesCurrent.y - image.touchesStart.y) + image.startY;

	    if (image.currentX < image.minX) {
	      image.currentX = (image.minX + 1) - (Math.pow( ((image.minX - image.currentX) + 1), 0.8 ));
	    }
	    if (image.currentX > image.maxX) {
	      image.currentX = (image.maxX - 1) + (Math.pow( ((image.currentX - image.maxX) + 1), 0.8 ));
	    }

	    if (image.currentY < image.minY) {
	      image.currentY = (image.minY + 1) - (Math.pow( ((image.minY - image.currentY) + 1), 0.8 ));
	    }
	    if (image.currentY > image.maxY) {
	      image.currentY = (image.maxY - 1) + (Math.pow( ((image.currentY - image.maxY) + 1), 0.8 ));
	    }

	    // Velocity
	    if (!velocity.prevPositionX) { velocity.prevPositionX = image.touchesCurrent.x; }
	    if (!velocity.prevPositionY) { velocity.prevPositionY = image.touchesCurrent.y; }
	    if (!velocity.prevTime) { velocity.prevTime = Date.now(); }
	    velocity.x = (image.touchesCurrent.x - velocity.prevPositionX) / (Date.now() - velocity.prevTime) / 2;
	    velocity.y = (image.touchesCurrent.y - velocity.prevPositionY) / (Date.now() - velocity.prevTime) / 2;
	    if (Math.abs(image.touchesCurrent.x - velocity.prevPositionX) < 2) { velocity.x = 0; }
	    if (Math.abs(image.touchesCurrent.y - velocity.prevPositionY) < 2) { velocity.y = 0; }
	    velocity.prevPositionX = image.touchesCurrent.x;
	    velocity.prevPositionY = image.touchesCurrent.y;
	    velocity.prevTime = Date.now();

	    gesture.$imageWrapEl.transform(("translate3d(" + (image.currentX) + "px, " + (image.currentY) + "px,0)"));
	  },
	  onTouchEnd: function onTouchEnd() {
	    var swiper = this;
	    var zoom = swiper.zoom;
	    var gesture = zoom.gesture;
	    var image = zoom.image;
	    var velocity = zoom.velocity;
	    if (!gesture.$imageEl || gesture.$imageEl.length === 0) { return; }
	    if (!image.isTouched || !image.isMoved) {
	      image.isTouched = false;
	      image.isMoved = false;
	      return;
	    }
	    image.isTouched = false;
	    image.isMoved = false;
	    var momentumDurationX = 300;
	    var momentumDurationY = 300;
	    var momentumDistanceX = velocity.x * momentumDurationX;
	    var newPositionX = image.currentX + momentumDistanceX;
	    var momentumDistanceY = velocity.y * momentumDurationY;
	    var newPositionY = image.currentY + momentumDistanceY;

	    // Fix duration
	    if (velocity.x !== 0) { momentumDurationX = Math.abs((newPositionX - image.currentX) / velocity.x); }
	    if (velocity.y !== 0) { momentumDurationY = Math.abs((newPositionY - image.currentY) / velocity.y); }
	    var momentumDuration = Math.max(momentumDurationX, momentumDurationY);

	    image.currentX = newPositionX;
	    image.currentY = newPositionY;

	    // Define if we need image drag
	    var scaledWidth = image.width * zoom.scale;
	    var scaledHeight = image.height * zoom.scale;
	    image.minX = Math.min(((gesture.slideWidth / 2) - (scaledWidth / 2)), 0);
	    image.maxX = -image.minX;
	    image.minY = Math.min(((gesture.slideHeight / 2) - (scaledHeight / 2)), 0);
	    image.maxY = -image.minY;
	    image.currentX = Math.max(Math.min(image.currentX, image.maxX), image.minX);
	    image.currentY = Math.max(Math.min(image.currentY, image.maxY), image.minY);

	    gesture.$imageWrapEl.transition(momentumDuration).transform(("translate3d(" + (image.currentX) + "px, " + (image.currentY) + "px,0)"));
	  },
	  onTransitionEnd: function onTransitionEnd() {
	    var swiper = this;
	    var zoom = swiper.zoom;
	    var gesture = zoom.gesture;
	    if (gesture.$slideEl && swiper.previousIndex !== swiper.activeIndex) {
	      gesture.$imageEl.transform('translate3d(0,0,0) scale(1)');
	      gesture.$imageWrapEl.transform('translate3d(0,0,0)');
	      gesture.$slideEl = undefined;
	      gesture.$imageEl = undefined;
	      gesture.$imageWrapEl = undefined;

	      zoom.scale = 1;
	      zoom.currentScale = 1;
	    }
	  },
	  // Toggle Zoom
	  toggle: function toggle(e) {
	    var swiper = this;
	    var zoom = swiper.zoom;

	    if (zoom.scale && zoom.scale !== 1) {
	      // Zoom Out
	      zoom.out();
	    } else {
	      // Zoom In
	      zoom.in(e);
	    }
	  },
	  in: function in$1(e) {
	    var swiper = this;

	    var zoom = swiper.zoom;
	    var params = swiper.params.zoom;
	    var gesture = zoom.gesture;
	    var image = zoom.image;

	    if (!gesture.$slideEl) {
	      gesture.$slideEl = swiper.clickedSlide ? $$1(swiper.clickedSlide) : swiper.slides.eq(swiper.activeIndex);
	      gesture.$imageEl = gesture.$slideEl.find('img, svg, canvas');
	      gesture.$imageWrapEl = gesture.$imageEl.parent(("." + (params.containerClass)));
	    }
	    if (!gesture.$imageEl || gesture.$imageEl.length === 0) { return; }

	    gesture.$slideEl.addClass(("" + (params.zoomedSlideClass)));

	    var touchX;
	    var touchY;
	    var offsetX;
	    var offsetY;
	    var diffX;
	    var diffY;
	    var translateX;
	    var translateY;
	    var imageWidth;
	    var imageHeight;
	    var scaledWidth;
	    var scaledHeight;
	    var translateMinX;
	    var translateMinY;
	    var translateMaxX;
	    var translateMaxY;
	    var slideWidth;
	    var slideHeight;

	    if (typeof image.touchesStart.x === 'undefined' && e) {
	      touchX = e.type === 'touchend' ? e.changedTouches[0].pageX : e.pageX;
	      touchY = e.type === 'touchend' ? e.changedTouches[0].pageY : e.pageY;
	    } else {
	      touchX = image.touchesStart.x;
	      touchY = image.touchesStart.y;
	    }

	    zoom.scale = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;
	    zoom.currentScale = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;
	    if (e) {
	      slideWidth = gesture.$slideEl[0].offsetWidth;
	      slideHeight = gesture.$slideEl[0].offsetHeight;
	      offsetX = gesture.$slideEl.offset().left;
	      offsetY = gesture.$slideEl.offset().top;
	      diffX = (offsetX + (slideWidth / 2)) - touchX;
	      diffY = (offsetY + (slideHeight / 2)) - touchY;

	      imageWidth = gesture.$imageEl[0].offsetWidth;
	      imageHeight = gesture.$imageEl[0].offsetHeight;
	      scaledWidth = imageWidth * zoom.scale;
	      scaledHeight = imageHeight * zoom.scale;

	      translateMinX = Math.min(((slideWidth / 2) - (scaledWidth / 2)), 0);
	      translateMinY = Math.min(((slideHeight / 2) - (scaledHeight / 2)), 0);
	      translateMaxX = -translateMinX;
	      translateMaxY = -translateMinY;

	      translateX = diffX * zoom.scale;
	      translateY = diffY * zoom.scale;

	      if (translateX < translateMinX) {
	        translateX = translateMinX;
	      }
	      if (translateX > translateMaxX) {
	        translateX = translateMaxX;
	      }

	      if (translateY < translateMinY) {
	        translateY = translateMinY;
	      }
	      if (translateY > translateMaxY) {
	        translateY = translateMaxY;
	      }
	    } else {
	      translateX = 0;
	      translateY = 0;
	    }
	    gesture.$imageWrapEl.transition(300).transform(("translate3d(" + translateX + "px, " + translateY + "px,0)"));
	    gesture.$imageEl.transition(300).transform(("translate3d(0,0,0) scale(" + (zoom.scale) + ")"));
	  },
	  out: function out() {
	    var swiper = this;

	    var zoom = swiper.zoom;
	    var params = swiper.params.zoom;
	    var gesture = zoom.gesture;

	    if (!gesture.$slideEl) {
	      gesture.$slideEl = swiper.clickedSlide ? $$1(swiper.clickedSlide) : swiper.slides.eq(swiper.activeIndex);
	      gesture.$imageEl = gesture.$slideEl.find('img, svg, canvas');
	      gesture.$imageWrapEl = gesture.$imageEl.parent(("." + (params.containerClass)));
	    }
	    if (!gesture.$imageEl || gesture.$imageEl.length === 0) { return; }

	    zoom.scale = 1;
	    zoom.currentScale = 1;
	    gesture.$imageWrapEl.transition(300).transform('translate3d(0,0,0)');
	    gesture.$imageEl.transition(300).transform('translate3d(0,0,0) scale(1)');
	    gesture.$slideEl.removeClass(("" + (params.zoomedSlideClass)));
	    gesture.$slideEl = undefined;
	  },
	  // Attach/Detach Events
	  enable: function enable() {
	    var swiper = this;
	    var zoom = swiper.zoom;
	    if (zoom.enabled) { return; }
	    zoom.enabled = true;

	    var passiveListener = swiper.touchEvents.start === 'touchstart' && Support.passiveListener && swiper.params.passiveListeners ? { passive: true, capture: false } : false;

	    // Scale image
	    if (Support.gestures) {
	      swiper.$wrapperEl.on('gesturestart', '.swiper-slide', zoom.onGestureStart, passiveListener);
	      swiper.$wrapperEl.on('gesturechange', '.swiper-slide', zoom.onGestureChange, passiveListener);
	      swiper.$wrapperEl.on('gestureend', '.swiper-slide', zoom.onGestureEnd, passiveListener);
	    } else if (swiper.touchEvents.start === 'touchstart') {
	      swiper.$wrapperEl.on(swiper.touchEvents.start, '.swiper-slide', zoom.onGestureStart, passiveListener);
	      swiper.$wrapperEl.on(swiper.touchEvents.move, '.swiper-slide', zoom.onGestureChange, passiveListener);
	      swiper.$wrapperEl.on(swiper.touchEvents.end, '.swiper-slide', zoom.onGestureEnd, passiveListener);
	    }

	    // Move image
	    swiper.$wrapperEl.on(swiper.touchEvents.move, ("." + (swiper.params.zoom.containerClass)), zoom.onTouchMove);
	  },
	  disable: function disable() {
	    var swiper = this;
	    var zoom = swiper.zoom;
	    if (!zoom.enabled) { return; }

	    swiper.zoom.enabled = false;

	    var passiveListener = swiper.touchEvents.start === 'touchstart' && Support.passiveListener && swiper.params.passiveListeners ? { passive: true, capture: false } : false;

	    // Scale image
	    if (Support.gestures) {
	      swiper.$wrapperEl.off('gesturestart', '.swiper-slide', zoom.onGestureStart, passiveListener);
	      swiper.$wrapperEl.off('gesturechange', '.swiper-slide', zoom.onGestureChange, passiveListener);
	      swiper.$wrapperEl.off('gestureend', '.swiper-slide', zoom.onGestureEnd, passiveListener);
	    } else if (swiper.touchEvents.start === 'touchstart') {
	      swiper.$wrapperEl.off(swiper.touchEvents.start, '.swiper-slide', zoom.onGestureStart, passiveListener);
	      swiper.$wrapperEl.off(swiper.touchEvents.move, '.swiper-slide', zoom.onGestureChange, passiveListener);
	      swiper.$wrapperEl.off(swiper.touchEvents.end, '.swiper-slide', zoom.onGestureEnd, passiveListener);
	    }

	    // Move image
	    swiper.$wrapperEl.off(swiper.touchEvents.move, ("." + (swiper.params.zoom.containerClass)), zoom.onTouchMove);
	  },
	};

	var Zoom$1 = {
	  name: 'zoom',
	  params: {
	    zoom: {
	      enabled: false,
	      maxRatio: 3,
	      minRatio: 1,
	      toggle: true,
	      containerClass: 'swiper-zoom-container',
	      zoomedSlideClass: 'swiper-slide-zoomed',
	    },
	  },
	  create: function create() {
	    var swiper = this;
	    var zoom = {
	      enabled: false,
	      scale: 1,
	      currentScale: 1,
	      isScaling: false,
	      gesture: {
	        $slideEl: undefined,
	        slideWidth: undefined,
	        slideHeight: undefined,
	        $imageEl: undefined,
	        $imageWrapEl: undefined,
	        maxRatio: 3,
	      },
	      image: {
	        isTouched: undefined,
	        isMoved: undefined,
	        currentX: undefined,
	        currentY: undefined,
	        minX: undefined,
	        minY: undefined,
	        maxX: undefined,
	        maxY: undefined,
	        width: undefined,
	        height: undefined,
	        startX: undefined,
	        startY: undefined,
	        touchesStart: {},
	        touchesCurrent: {},
	      },
	      velocity: {
	        x: undefined,
	        y: undefined,
	        prevPositionX: undefined,
	        prevPositionY: undefined,
	        prevTime: undefined,
	      },
	    };
	    ('onGestureStart onGestureChange onGestureEnd onTouchStart onTouchMove onTouchEnd onTransitionEnd toggle enable disable in out').split(' ').forEach(function (methodName) {
	      zoom[methodName] = Zoom[methodName].bind(swiper);
	    });
	    Utils.extend(swiper, {
	      zoom: zoom,
	    });
	  },
	  on: {
	    init: function init() {
	      var swiper = this;
	      if (swiper.params.zoom.enabled) {
	        swiper.zoom.enable();
	      }
	    },
	    destroy: function destroy() {
	      var swiper = this;
	      swiper.zoom.disable();
	    },
	    touchStart: function touchStart(e) {
	      var swiper = this;
	      if (!swiper.zoom.enabled) { return; }
	      swiper.zoom.onTouchStart(e);
	    },
	    touchEnd: function touchEnd(e) {
	      var swiper = this;
	      if (!swiper.zoom.enabled) { return; }
	      swiper.zoom.onTouchEnd(e);
	    },
	    doubleTap: function doubleTap(e) {
	      var swiper = this;
	      if (swiper.params.zoom.enabled && swiper.zoom.enabled && swiper.params.zoom.toggle) {
	        swiper.zoom.toggle(e);
	      }
	    },
	    transitionEnd: function transitionEnd() {
	      var swiper = this;
	      if (swiper.zoom.enabled && swiper.params.zoom.enabled) {
	        swiper.zoom.onTransitionEnd();
	      }
	    },
	  },
	};

	var Lazy$2 = {
	  loadInSlide: function loadInSlide(index, loadInDuplicate) {
	    if ( loadInDuplicate === void 0 ) loadInDuplicate = true;

	    var swiper = this;
	    var params = swiper.params.lazy;
	    if (typeof index === 'undefined') { return; }
	    if (swiper.slides.length === 0) { return; }
	    var isVirtual = swiper.virtual && swiper.params.virtual.enabled;

	    var $slideEl = isVirtual
	      ? swiper.$wrapperEl.children(("." + (swiper.params.slideClass) + "[data-swiper-slide-index=\"" + index + "\"]"))
	      : swiper.slides.eq(index);

	    var $images = $slideEl.find(("." + (params.elementClass) + ":not(." + (params.loadedClass) + "):not(." + (params.loadingClass) + ")"));
	    if ($slideEl.hasClass(params.elementClass) && !$slideEl.hasClass(params.loadedClass) && !$slideEl.hasClass(params.loadingClass)) {
	      $images = $images.add($slideEl[0]);
	    }
	    if ($images.length === 0) { return; }

	    $images.each(function (imageIndex, imageEl) {
	      var $imageEl = $$1(imageEl);
	      $imageEl.addClass(params.loadingClass);

	      var background = $imageEl.attr('data-background');
	      var src = $imageEl.attr('data-src');
	      var srcset = $imageEl.attr('data-srcset');
	      var sizes = $imageEl.attr('data-sizes');

	      swiper.loadImage($imageEl[0], (src || background), srcset, sizes, false, function () {
	        if (typeof swiper === 'undefined' || swiper === null || !swiper || (swiper && !swiper.params) || swiper.destroyed) { return; }
	        if (background) {
	          $imageEl.css('background-image', ("url(\"" + background + "\")"));
	          $imageEl.removeAttr('data-background');
	        } else {
	          if (srcset) {
	            $imageEl.attr('srcset', srcset);
	            $imageEl.removeAttr('data-srcset');
	          }
	          if (sizes) {
	            $imageEl.attr('sizes', sizes);
	            $imageEl.removeAttr('data-sizes');
	          }
	          if (src) {
	            $imageEl.attr('src', src);
	            $imageEl.removeAttr('data-src');
	          }
	        }

	        $imageEl.addClass(params.loadedClass).removeClass(params.loadingClass);
	        $slideEl.find(("." + (params.preloaderClass))).remove();
	        if (swiper.params.loop && loadInDuplicate) {
	          var slideOriginalIndex = $slideEl.attr('data-swiper-slide-index');
	          if ($slideEl.hasClass(swiper.params.slideDuplicateClass)) {
	            var originalSlide = swiper.$wrapperEl.children(("[data-swiper-slide-index=\"" + slideOriginalIndex + "\"]:not(." + (swiper.params.slideDuplicateClass) + ")"));
	            swiper.lazy.loadInSlide(originalSlide.index(), false);
	          } else {
	            var duplicatedSlide = swiper.$wrapperEl.children(("." + (swiper.params.slideDuplicateClass) + "[data-swiper-slide-index=\"" + slideOriginalIndex + "\"]"));
	            swiper.lazy.loadInSlide(duplicatedSlide.index(), false);
	          }
	        }
	        swiper.emit('lazyImageReady', $slideEl[0], $imageEl[0]);
	      });

	      swiper.emit('lazyImageLoad', $slideEl[0], $imageEl[0]);
	    });
	  },
	  load: function load() {
	    var swiper = this;
	    var $wrapperEl = swiper.$wrapperEl;
	    var swiperParams = swiper.params;
	    var slides = swiper.slides;
	    var activeIndex = swiper.activeIndex;
	    var isVirtual = swiper.virtual && swiperParams.virtual.enabled;
	    var params = swiperParams.lazy;

	    var slidesPerView = swiperParams.slidesPerView;
	    if (slidesPerView === 'auto') {
	      slidesPerView = 0;
	    }

	    function slideExist(index) {
	      if (isVirtual) {
	        if ($wrapperEl.children(("." + (swiperParams.slideClass) + "[data-swiper-slide-index=\"" + index + "\"]")).length) {
	          return true;
	        }
	      } else if (slides[index]) { return true; }
	      return false;
	    }
	    function slideIndex(slideEl) {
	      if (isVirtual) {
	        return $$1(slideEl).attr('data-swiper-slide-index');
	      }
	      return $$1(slideEl).index();
	    }

	    if (!swiper.lazy.initialImageLoaded) { swiper.lazy.initialImageLoaded = true; }
	    if (swiper.params.watchSlidesVisibility) {
	      $wrapperEl.children(("." + (swiperParams.slideVisibleClass))).each(function (elIndex, slideEl) {
	        var index = isVirtual ? $$1(slideEl).attr('data-swiper-slide-index') : $$1(slideEl).index();
	        swiper.lazy.loadInSlide(index);
	      });
	    } else if (slidesPerView > 1) {
	      for (var i = activeIndex; i < activeIndex + slidesPerView; i += 1) {
	        if (slideExist(i)) { swiper.lazy.loadInSlide(i); }
	      }
	    } else {
	      swiper.lazy.loadInSlide(activeIndex);
	    }
	    if (params.loadPrevNext) {
	      if (slidesPerView > 1 || (params.loadPrevNextAmount && params.loadPrevNextAmount > 1)) {
	        var amount = params.loadPrevNextAmount;
	        var spv = slidesPerView;
	        var maxIndex = Math.min(activeIndex + spv + Math.max(amount, spv), slides.length);
	        var minIndex = Math.max(activeIndex - Math.max(spv, amount), 0);
	        // Next Slides
	        for (var i$1 = activeIndex + slidesPerView; i$1 < maxIndex; i$1 += 1) {
	          if (slideExist(i$1)) { swiper.lazy.loadInSlide(i$1); }
	        }
	        // Prev Slides
	        for (var i$2 = minIndex; i$2 < activeIndex; i$2 += 1) {
	          if (slideExist(i$2)) { swiper.lazy.loadInSlide(i$2); }
	        }
	      } else {
	        var nextSlide = $wrapperEl.children(("." + (swiperParams.slideNextClass)));
	        if (nextSlide.length > 0) { swiper.lazy.loadInSlide(slideIndex(nextSlide)); }

	        var prevSlide = $wrapperEl.children(("." + (swiperParams.slidePrevClass)));
	        if (prevSlide.length > 0) { swiper.lazy.loadInSlide(slideIndex(prevSlide)); }
	      }
	    }
	  },
	};

	var Lazy$3 = {
	  name: 'lazy',
	  params: {
	    lazy: {
	      enabled: false,
	      loadPrevNext: false,
	      loadPrevNextAmount: 1,
	      loadOnTransitionStart: false,

	      elementClass: 'swiper-lazy',
	      loadingClass: 'swiper-lazy-loading',
	      loadedClass: 'swiper-lazy-loaded',
	      preloaderClass: 'swiper-lazy-preloader',
	    },
	  },
	  create: function create() {
	    var swiper = this;
	    Utils.extend(swiper, {
	      lazy: {
	        initialImageLoaded: false,
	        load: Lazy$2.load.bind(swiper),
	        loadInSlide: Lazy$2.loadInSlide.bind(swiper),
	      },
	    });
	  },
	  on: {
	    beforeInit: function beforeInit() {
	      var swiper = this;
	      if (swiper.params.lazy.enabled && swiper.params.preloadImages) {
	        swiper.params.preloadImages = false;
	      }
	    },
	    init: function init() {
	      var swiper = this;
	      if (swiper.params.lazy.enabled && !swiper.params.loop && swiper.params.initialSlide === 0) {
	        swiper.lazy.load();
	      }
	    },
	    scroll: function scroll() {
	      var swiper = this;
	      if (swiper.params.freeMode && !swiper.params.freeModeSticky) {
	        swiper.lazy.load();
	      }
	    },
	    resize: function resize() {
	      var swiper = this;
	      if (swiper.params.lazy.enabled) {
	        swiper.lazy.load();
	      }
	    },
	    scrollbarDragMove: function scrollbarDragMove() {
	      var swiper = this;
	      if (swiper.params.lazy.enabled) {
	        swiper.lazy.load();
	      }
	    },
	    transitionStart: function transitionStart() {
	      var swiper = this;
	      if (swiper.params.lazy.enabled) {
	        if (swiper.params.lazy.loadOnTransitionStart || (!swiper.params.lazy.loadOnTransitionStart && !swiper.lazy.initialImageLoaded)) {
	          swiper.lazy.load();
	        }
	      }
	    },
	    transitionEnd: function transitionEnd() {
	      var swiper = this;
	      if (swiper.params.lazy.enabled && !swiper.params.lazy.loadOnTransitionStart) {
	        swiper.lazy.load();
	      }
	    },
	  },
	};

	/* eslint no-bitwise: ["error", { "allow": [">>"] }] */

	var Controller = {
	  LinearSpline: function LinearSpline(x, y) {
	    var binarySearch = (function search() {
	      var maxIndex;
	      var minIndex;
	      var guess;
	      return function (array, val) {
	        minIndex = -1;
	        maxIndex = array.length;
	        while (maxIndex - minIndex > 1) {
	          guess = maxIndex + minIndex >> 1;
	          if (array[guess] <= val) {
	            minIndex = guess;
	          } else {
	            maxIndex = guess;
	          }
	        }
	        return maxIndex;
	      };
	    }());
	    this.x = x;
	    this.y = y;
	    this.lastIndex = x.length - 1;
	    // Given an x value (x2), return the expected y2 value:
	    // (x1,y1) is the known point before given value,
	    // (x3,y3) is the known point after given value.
	    var i1;
	    var i3;

	    this.interpolate = function interpolate(x2) {
	      if (!x2) { return 0; }

	      // Get the indexes of x1 and x3 (the array indexes before and after given x2):
	      i3 = binarySearch(this.x, x2);
	      i1 = i3 - 1;

	      // We have our indexes i1 & i3, so we can calculate already:
	      // y2 := ((x2−x1) × (y3−y1)) ÷ (x3−x1) + y1
	      return (((x2 - this.x[i1]) * (this.y[i3] - this.y[i1])) / (this.x[i3] - this.x[i1])) + this.y[i1];
	    };
	    return this;
	  },
	  // xxx: for now i will just save one spline function to to
	  getInterpolateFunction: function getInterpolateFunction(c) {
	    var swiper = this;
	    if (!swiper.controller.spline) {
	      swiper.controller.spline = swiper.params.loop ?
	        new Controller.LinearSpline(swiper.slidesGrid, c.slidesGrid) :
	        new Controller.LinearSpline(swiper.snapGrid, c.snapGrid);
	    }
	  },
	  setTranslate: function setTranslate(setTranslate$1, byController) {
	    var swiper = this;
	    var controlled = swiper.controller.control;
	    var multiplier;
	    var controlledTranslate;
	    function setControlledTranslate(c) {
	      // this will create an Interpolate function based on the snapGrids
	      // x is the Grid of the scrolled scroller and y will be the controlled scroller
	      // it makes sense to create this only once and recall it for the interpolation
	      // the function does a lot of value caching for performance
	      var translate = swiper.rtlTranslate ? -swiper.translate : swiper.translate;
	      if (swiper.params.controller.by === 'slide') {
	        swiper.controller.getInterpolateFunction(c);
	        // i am not sure why the values have to be multiplicated this way, tried to invert the snapGrid
	        // but it did not work out
	        controlledTranslate = -swiper.controller.spline.interpolate(-translate);
	      }

	      if (!controlledTranslate || swiper.params.controller.by === 'container') {
	        multiplier = (c.maxTranslate() - c.minTranslate()) / (swiper.maxTranslate() - swiper.minTranslate());
	        controlledTranslate = ((translate - swiper.minTranslate()) * multiplier) + c.minTranslate();
	      }

	      if (swiper.params.controller.inverse) {
	        controlledTranslate = c.maxTranslate() - controlledTranslate;
	      }
	      c.updateProgress(controlledTranslate);
	      c.setTranslate(controlledTranslate, swiper);
	      c.updateActiveIndex();
	      c.updateSlidesClasses();
	    }
	    if (Array.isArray(controlled)) {
	      for (var i = 0; i < controlled.length; i += 1) {
	        if (controlled[i] !== byController && controlled[i] instanceof Swiper) {
	          setControlledTranslate(controlled[i]);
	        }
	      }
	    } else if (controlled instanceof Swiper && byController !== controlled) {
	      setControlledTranslate(controlled);
	    }
	  },
	  setTransition: function setTransition(duration, byController) {
	    var swiper = this;
	    var controlled = swiper.controller.control;
	    var i;
	    function setControlledTransition(c) {
	      c.setTransition(duration, swiper);
	      if (duration !== 0) {
	        c.transitionStart();
	        c.$wrapperEl.transitionEnd(function () {
	          if (!controlled) { return; }
	          if (c.params.loop && swiper.params.controller.by === 'slide') {
	            c.loopFix();
	          }
	          c.transitionEnd();
	        });
	      }
	    }
	    if (Array.isArray(controlled)) {
	      for (i = 0; i < controlled.length; i += 1) {
	        if (controlled[i] !== byController && controlled[i] instanceof Swiper) {
	          setControlledTransition(controlled[i]);
	        }
	      }
	    } else if (controlled instanceof Swiper && byController !== controlled) {
	      setControlledTransition(controlled);
	    }
	  },
	};
	var Controller$1 = {
	  name: 'controller',
	  params: {
	    controller: {
	      control: undefined,
	      inverse: false,
	      by: 'slide', // or 'container'
	    },
	  },
	  create: function create() {
	    var swiper = this;
	    Utils.extend(swiper, {
	      controller: {
	        control: swiper.params.controller.control,
	        getInterpolateFunction: Controller.getInterpolateFunction.bind(swiper),
	        setTranslate: Controller.setTranslate.bind(swiper),
	        setTransition: Controller.setTransition.bind(swiper),
	      },
	    });
	  },
	  on: {
	    update: function update() {
	      var swiper = this;
	      if (!swiper.controller.control) { return; }
	      if (swiper.controller.spline) {
	        swiper.controller.spline = undefined;
	        delete swiper.controller.spline;
	      }
	    },
	    resize: function resize() {
	      var swiper = this;
	      if (!swiper.controller.control) { return; }
	      if (swiper.controller.spline) {
	        swiper.controller.spline = undefined;
	        delete swiper.controller.spline;
	      }
	    },
	    observerUpdate: function observerUpdate() {
	      var swiper = this;
	      if (!swiper.controller.control) { return; }
	      if (swiper.controller.spline) {
	        swiper.controller.spline = undefined;
	        delete swiper.controller.spline;
	      }
	    },
	    setTranslate: function setTranslate(translate, byController) {
	      var swiper = this;
	      if (!swiper.controller.control) { return; }
	      swiper.controller.setTranslate(translate, byController);
	    },
	    setTransition: function setTransition(duration, byController) {
	      var swiper = this;
	      if (!swiper.controller.control) { return; }
	      swiper.controller.setTransition(duration, byController);
	    },
	  },
	};

	var a11y = {
	  makeElFocusable: function makeElFocusable($el) {
	    $el.attr('tabIndex', '0');
	    return $el;
	  },
	  addElRole: function addElRole($el, role) {
	    $el.attr('role', role);
	    return $el;
	  },
	  addElLabel: function addElLabel($el, label) {
	    $el.attr('aria-label', label);
	    return $el;
	  },
	  disableEl: function disableEl($el) {
	    $el.attr('aria-disabled', true);
	    return $el;
	  },
	  enableEl: function enableEl($el) {
	    $el.attr('aria-disabled', false);
	    return $el;
	  },
	  onEnterKey: function onEnterKey(e) {
	    var swiper = this;
	    var params = swiper.params.a11y;
	    if (e.keyCode !== 13) { return; }
	    var $targetEl = $$1(e.target);
	    if (swiper.navigation && swiper.navigation.$nextEl && $targetEl.is(swiper.navigation.$nextEl)) {
	      if (!(swiper.isEnd && !swiper.params.loop)) {
	        swiper.slideNext();
	      }
	      if (swiper.isEnd) {
	        swiper.a11y.notify(params.lastSlideMessage);
	      } else {
	        swiper.a11y.notify(params.nextSlideMessage);
	      }
	    }
	    if (swiper.navigation && swiper.navigation.$prevEl && $targetEl.is(swiper.navigation.$prevEl)) {
	      if (!(swiper.isBeginning && !swiper.params.loop)) {
	        swiper.slidePrev();
	      }
	      if (swiper.isBeginning) {
	        swiper.a11y.notify(params.firstSlideMessage);
	      } else {
	        swiper.a11y.notify(params.prevSlideMessage);
	      }
	    }
	    if (swiper.pagination && $targetEl.is(("." + (swiper.params.pagination.bulletClass)))) {
	      $targetEl[0].click();
	    }
	  },
	  notify: function notify(message) {
	    var swiper = this;
	    var notification = swiper.a11y.liveRegion;
	    if (notification.length === 0) { return; }
	    notification.html('');
	    notification.html(message);
	  },
	  updateNavigation: function updateNavigation() {
	    var swiper = this;

	    if (swiper.params.loop) { return; }
	    var ref = swiper.navigation;
	    var $nextEl = ref.$nextEl;
	    var $prevEl = ref.$prevEl;

	    if ($prevEl && $prevEl.length > 0) {
	      if (swiper.isBeginning) {
	        swiper.a11y.disableEl($prevEl);
	      } else {
	        swiper.a11y.enableEl($prevEl);
	      }
	    }
	    if ($nextEl && $nextEl.length > 0) {
	      if (swiper.isEnd) {
	        swiper.a11y.disableEl($nextEl);
	      } else {
	        swiper.a11y.enableEl($nextEl);
	      }
	    }
	  },
	  updatePagination: function updatePagination() {
	    var swiper = this;
	    var params = swiper.params.a11y;
	    if (swiper.pagination && swiper.params.pagination.clickable && swiper.pagination.bullets && swiper.pagination.bullets.length) {
	      swiper.pagination.bullets.each(function (bulletIndex, bulletEl) {
	        var $bulletEl = $$1(bulletEl);
	        swiper.a11y.makeElFocusable($bulletEl);
	        swiper.a11y.addElRole($bulletEl, 'button');
	        swiper.a11y.addElLabel($bulletEl, params.paginationBulletMessage.replace(/{{index}}/, $bulletEl.index() + 1));
	      });
	    }
	  },
	  init: function init() {
	    var swiper = this;

	    swiper.$el.append(swiper.a11y.liveRegion);

	    // Navigation
	    var params = swiper.params.a11y;
	    var $nextEl;
	    var $prevEl;
	    if (swiper.navigation && swiper.navigation.$nextEl) {
	      $nextEl = swiper.navigation.$nextEl;
	    }
	    if (swiper.navigation && swiper.navigation.$prevEl) {
	      $prevEl = swiper.navigation.$prevEl;
	    }
	    if ($nextEl) {
	      swiper.a11y.makeElFocusable($nextEl);
	      swiper.a11y.addElRole($nextEl, 'button');
	      swiper.a11y.addElLabel($nextEl, params.nextSlideMessage);
	      $nextEl.on('keydown', swiper.a11y.onEnterKey);
	    }
	    if ($prevEl) {
	      swiper.a11y.makeElFocusable($prevEl);
	      swiper.a11y.addElRole($prevEl, 'button');
	      swiper.a11y.addElLabel($prevEl, params.prevSlideMessage);
	      $prevEl.on('keydown', swiper.a11y.onEnterKey);
	    }

	    // Pagination
	    if (swiper.pagination && swiper.params.pagination.clickable && swiper.pagination.bullets && swiper.pagination.bullets.length) {
	      swiper.pagination.$el.on('keydown', ("." + (swiper.params.pagination.bulletClass)), swiper.a11y.onEnterKey);
	    }
	  },
	  destroy: function destroy() {
	    var swiper = this;
	    if (swiper.a11y.liveRegion && swiper.a11y.liveRegion.length > 0) { swiper.a11y.liveRegion.remove(); }

	    var $nextEl;
	    var $prevEl;
	    if (swiper.navigation && swiper.navigation.$nextEl) {
	      $nextEl = swiper.navigation.$nextEl;
	    }
	    if (swiper.navigation && swiper.navigation.$prevEl) {
	      $prevEl = swiper.navigation.$prevEl;
	    }
	    if ($nextEl) {
	      $nextEl.off('keydown', swiper.a11y.onEnterKey);
	    }
	    if ($prevEl) {
	      $prevEl.off('keydown', swiper.a11y.onEnterKey);
	    }

	    // Pagination
	    if (swiper.pagination && swiper.params.pagination.clickable && swiper.pagination.bullets && swiper.pagination.bullets.length) {
	      swiper.pagination.$el.off('keydown', ("." + (swiper.params.pagination.bulletClass)), swiper.a11y.onEnterKey);
	    }
	  },
	};
	var A11y = {
	  name: 'a11y',
	  params: {
	    a11y: {
	      enabled: true,
	      notificationClass: 'swiper-notification',
	      prevSlideMessage: 'Previous slide',
	      nextSlideMessage: 'Next slide',
	      firstSlideMessage: 'This is the first slide',
	      lastSlideMessage: 'This is the last slide',
	      paginationBulletMessage: 'Go to slide {{index}}',
	    },
	  },
	  create: function create() {
	    var swiper = this;
	    Utils.extend(swiper, {
	      a11y: {
	        liveRegion: $$1(("<span class=\"" + (swiper.params.a11y.notificationClass) + "\" aria-live=\"assertive\" aria-atomic=\"true\"></span>")),
	      },
	    });
	    Object.keys(a11y).forEach(function (methodName) {
	      swiper.a11y[methodName] = a11y[methodName].bind(swiper);
	    });
	  },
	  on: {
	    init: function init() {
	      var swiper = this;
	      if (!swiper.params.a11y.enabled) { return; }
	      swiper.a11y.init();
	      swiper.a11y.updateNavigation();
	    },
	    toEdge: function toEdge() {
	      var swiper = this;
	      if (!swiper.params.a11y.enabled) { return; }
	      swiper.a11y.updateNavigation();
	    },
	    fromEdge: function fromEdge() {
	      var swiper = this;
	      if (!swiper.params.a11y.enabled) { return; }
	      swiper.a11y.updateNavigation();
	    },
	    paginationUpdate: function paginationUpdate() {
	      var swiper = this;
	      if (!swiper.params.a11y.enabled) { return; }
	      swiper.a11y.updatePagination();
	    },
	    destroy: function destroy() {
	      var swiper = this;
	      if (!swiper.params.a11y.enabled) { return; }
	      swiper.a11y.destroy();
	    },
	  },
	};

	/* eslint no-underscore-dangle: "off" */

	var Autoplay = {
	  run: function run() {
	    var swiper = this;
	    var $activeSlideEl = swiper.slides.eq(swiper.activeIndex);
	    var delay = swiper.params.autoplay.delay;
	    if ($activeSlideEl.attr('data-swiper-autoplay')) {
	      delay = $activeSlideEl.attr('data-swiper-autoplay') || swiper.params.autoplay.delay;
	    }
	    swiper.autoplay.timeout = Utils.nextTick(function () {
	      if (swiper.params.autoplay.reverseDirection) {
	        if (swiper.params.loop) {
	          swiper.loopFix();
	          swiper.slidePrev(swiper.params.speed, true, true);
	          swiper.emit('autoplay');
	        } else if (!swiper.isBeginning) {
	          swiper.slidePrev(swiper.params.speed, true, true);
	          swiper.emit('autoplay');
	        } else if (!swiper.params.autoplay.stopOnLastSlide) {
	          swiper.slideTo(swiper.slides.length - 1, swiper.params.speed, true, true);
	          swiper.emit('autoplay');
	        } else {
	          swiper.autoplay.stop();
	        }
	      } else if (swiper.params.loop) {
	        swiper.loopFix();
	        swiper.slideNext(swiper.params.speed, true, true);
	        swiper.emit('autoplay');
	      } else if (!swiper.isEnd) {
	        swiper.slideNext(swiper.params.speed, true, true);
	        swiper.emit('autoplay');
	      } else if (!swiper.params.autoplay.stopOnLastSlide) {
	        swiper.slideTo(0, swiper.params.speed, true, true);
	        swiper.emit('autoplay');
	      } else {
	        swiper.autoplay.stop();
	      }
	    }, delay);
	  },
	  start: function start() {
	    var swiper = this;
	    if (typeof swiper.autoplay.timeout !== 'undefined') { return false; }
	    if (swiper.autoplay.running) { return false; }
	    swiper.autoplay.running = true;
	    swiper.emit('autoplayStart');
	    swiper.autoplay.run();
	    return true;
	  },
	  stop: function stop() {
	    var swiper = this;
	    if (!swiper.autoplay.running) { return false; }
	    if (typeof swiper.autoplay.timeout === 'undefined') { return false; }

	    if (swiper.autoplay.timeout) {
	      clearTimeout(swiper.autoplay.timeout);
	      swiper.autoplay.timeout = undefined;
	    }
	    swiper.autoplay.running = false;
	    swiper.emit('autoplayStop');
	    return true;
	  },
	  pause: function pause(speed) {
	    var swiper = this;
	    if (!swiper.autoplay.running) { return; }
	    if (swiper.autoplay.paused) { return; }
	    if (swiper.autoplay.timeout) { clearTimeout(swiper.autoplay.timeout); }
	    swiper.autoplay.paused = true;
	    if (speed === 0 || !swiper.params.autoplay.waitForTransition) {
	      swiper.autoplay.paused = false;
	      swiper.autoplay.run();
	    } else {
	      swiper.$wrapperEl[0].addEventListener('transitionend', swiper.autoplay.onTransitionEnd);
	      swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.autoplay.onTransitionEnd);
	    }
	  },
	};

	var Autoplay$1 = {
	  name: 'autoplay',
	  params: {
	    autoplay: {
	      enabled: false,
	      delay: 3000,
	      waitForTransition: true,
	      disableOnInteraction: true,
	      stopOnLastSlide: false,
	      reverseDirection: false,
	    },
	  },
	  create: function create() {
	    var swiper = this;
	    Utils.extend(swiper, {
	      autoplay: {
	        running: false,
	        paused: false,
	        run: Autoplay.run.bind(swiper),
	        start: Autoplay.start.bind(swiper),
	        stop: Autoplay.stop.bind(swiper),
	        pause: Autoplay.pause.bind(swiper),
	        onTransitionEnd: function onTransitionEnd(e) {
	          if (!swiper || swiper.destroyed || !swiper.$wrapperEl) { return; }
	          if (e.target !== this) { return; }
	          swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.autoplay.onTransitionEnd);
	          swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.autoplay.onTransitionEnd);
	          swiper.autoplay.paused = false;
	          if (!swiper.autoplay.running) {
	            swiper.autoplay.stop();
	          } else {
	            swiper.autoplay.run();
	          }
	        },
	      },
	    });
	  },
	  on: {
	    init: function init() {
	      var swiper = this;
	      if (swiper.params.autoplay.enabled) {
	        swiper.autoplay.start();
	      }
	    },
	    beforeTransitionStart: function beforeTransitionStart(speed, internal) {
	      var swiper = this;
	      if (swiper.autoplay.running) {
	        if (internal || !swiper.params.autoplay.disableOnInteraction) {
	          swiper.autoplay.pause(speed);
	        } else {
	          swiper.autoplay.stop();
	        }
	      }
	    },
	    sliderFirstMove: function sliderFirstMove() {
	      var swiper = this;
	      if (swiper.autoplay.running) {
	        if (swiper.params.autoplay.disableOnInteraction) {
	          swiper.autoplay.stop();
	        } else {
	          swiper.autoplay.pause();
	        }
	      }
	    },
	    destroy: function destroy() {
	      var swiper = this;
	      if (swiper.autoplay.running) {
	        swiper.autoplay.stop();
	      }
	    },
	  },
	};

	var Fade = {
	  setTranslate: function setTranslate() {
	    var swiper = this;
	    var slides = swiper.slides;
	    for (var i = 0; i < slides.length; i += 1) {
	      var $slideEl = swiper.slides.eq(i);
	      var offset = $slideEl[0].swiperSlideOffset;
	      var tx = -offset;
	      if (!swiper.params.virtualTranslate) { tx -= swiper.translate; }
	      var ty = 0;
	      if (!swiper.isHorizontal()) {
	        ty = tx;
	        tx = 0;
	      }
	      var slideOpacity = swiper.params.fadeEffect.crossFade ?
	        Math.max(1 - Math.abs($slideEl[0].progress), 0) :
	        1 + Math.min(Math.max($slideEl[0].progress, -1), 0);
	      $slideEl
	        .css({
	          opacity: slideOpacity,
	        })
	        .transform(("translate3d(" + tx + "px, " + ty + "px, 0px)"));
	    }
	  },
	  setTransition: function setTransition(duration) {
	    var swiper = this;
	    var slides = swiper.slides;
	    var $wrapperEl = swiper.$wrapperEl;
	    slides.transition(duration);
	    if (swiper.params.virtualTranslate && duration !== 0) {
	      var eventTriggered = false;
	      slides.transitionEnd(function () {
	        if (eventTriggered) { return; }
	        if (!swiper || swiper.destroyed) { return; }
	        eventTriggered = true;
	        swiper.animating = false;
	        var triggerEvents = ['webkitTransitionEnd', 'transitionend'];
	        for (var i = 0; i < triggerEvents.length; i += 1) {
	          $wrapperEl.trigger(triggerEvents[i]);
	        }
	      });
	    }
	  },
	};

	var EffectFade = {
	  name: 'effect-fade',
	  params: {
	    fadeEffect: {
	      crossFade: false,
	    },
	  },
	  create: function create() {
	    var swiper = this;
	    Utils.extend(swiper, {
	      fadeEffect: {
	        setTranslate: Fade.setTranslate.bind(swiper),
	        setTransition: Fade.setTransition.bind(swiper),
	      },
	    });
	  },
	  on: {
	    beforeInit: function beforeInit() {
	      var swiper = this;
	      if (swiper.params.effect !== 'fade') { return; }
	      swiper.classNames.push(((swiper.params.containerModifierClass) + "fade"));
	      var overwriteParams = {
	        slidesPerView: 1,
	        slidesPerColumn: 1,
	        slidesPerGroup: 1,
	        watchSlidesProgress: true,
	        spaceBetween: 0,
	        virtualTranslate: true,
	      };
	      Utils.extend(swiper.params, overwriteParams);
	      Utils.extend(swiper.originalParams, overwriteParams);
	    },
	    setTranslate: function setTranslate() {
	      var swiper = this;
	      if (swiper.params.effect !== 'fade') { return; }
	      swiper.fadeEffect.setTranslate();
	    },
	    setTransition: function setTransition(duration) {
	      var swiper = this;
	      if (swiper.params.effect !== 'fade') { return; }
	      swiper.fadeEffect.setTransition(duration);
	    },
	  },
	};

	var Cube = {
	  setTranslate: function setTranslate() {
	    var swiper = this;
	    var $el = swiper.$el;
	    var $wrapperEl = swiper.$wrapperEl;
	    var slides = swiper.slides;
	    var swiperWidth = swiper.width;
	    var swiperHeight = swiper.height;
	    var rtl = swiper.rtlTranslate;
	    var swiperSize = swiper.size;
	    var params = swiper.params.cubeEffect;
	    var isHorizontal = swiper.isHorizontal();
	    var isVirtual = swiper.virtual && swiper.params.virtual.enabled;
	    var wrapperRotate = 0;
	    var $cubeShadowEl;
	    if (params.shadow) {
	      if (isHorizontal) {
	        $cubeShadowEl = $wrapperEl.find('.swiper-cube-shadow');
	        if ($cubeShadowEl.length === 0) {
	          $cubeShadowEl = $$1('<div class="swiper-cube-shadow"></div>');
	          $wrapperEl.append($cubeShadowEl);
	        }
	        $cubeShadowEl.css({ height: (swiperWidth + "px") });
	      } else {
	        $cubeShadowEl = $el.find('.swiper-cube-shadow');
	        if ($cubeShadowEl.length === 0) {
	          $cubeShadowEl = $$1('<div class="swiper-cube-shadow"></div>');
	          $el.append($cubeShadowEl);
	        }
	      }
	    }
	    for (var i = 0; i < slides.length; i += 1) {
	      var $slideEl = slides.eq(i);
	      var slideIndex = i;
	      if (isVirtual) {
	        slideIndex = parseInt($slideEl.attr('data-swiper-slide-index'), 10);
	      }
	      var slideAngle = slideIndex * 90;
	      var round = Math.floor(slideAngle / 360);
	      if (rtl) {
	        slideAngle = -slideAngle;
	        round = Math.floor(-slideAngle / 360);
	      }
	      var progress = Math.max(Math.min($slideEl[0].progress, 1), -1);
	      var tx = 0;
	      var ty = 0;
	      var tz = 0;
	      if (slideIndex % 4 === 0) {
	        tx = -round * 4 * swiperSize;
	        tz = 0;
	      } else if ((slideIndex - 1) % 4 === 0) {
	        tx = 0;
	        tz = -round * 4 * swiperSize;
	      } else if ((slideIndex - 2) % 4 === 0) {
	        tx = swiperSize + (round * 4 * swiperSize);
	        tz = swiperSize;
	      } else if ((slideIndex - 3) % 4 === 0) {
	        tx = -swiperSize;
	        tz = (3 * swiperSize) + (swiperSize * 4 * round);
	      }
	      if (rtl) {
	        tx = -tx;
	      }

	      if (!isHorizontal) {
	        ty = tx;
	        tx = 0;
	      }

	      var transform = "rotateX(" + (isHorizontal ? 0 : -slideAngle) + "deg) rotateY(" + (isHorizontal ? slideAngle : 0) + "deg) translate3d(" + tx + "px, " + ty + "px, " + tz + "px)";
	      if (progress <= 1 && progress > -1) {
	        wrapperRotate = (slideIndex * 90) + (progress * 90);
	        if (rtl) { wrapperRotate = (-slideIndex * 90) - (progress * 90); }
	      }
	      $slideEl.transform(transform);
	      if (params.slideShadows) {
	        // Set shadows
	        var shadowBefore = isHorizontal ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
	        var shadowAfter = isHorizontal ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');
	        if (shadowBefore.length === 0) {
	          shadowBefore = $$1(("<div class=\"swiper-slide-shadow-" + (isHorizontal ? 'left' : 'top') + "\"></div>"));
	          $slideEl.append(shadowBefore);
	        }
	        if (shadowAfter.length === 0) {
	          shadowAfter = $$1(("<div class=\"swiper-slide-shadow-" + (isHorizontal ? 'right' : 'bottom') + "\"></div>"));
	          $slideEl.append(shadowAfter);
	        }
	        if (shadowBefore.length) { shadowBefore[0].style.opacity = Math.max(-progress, 0); }
	        if (shadowAfter.length) { shadowAfter[0].style.opacity = Math.max(progress, 0); }
	      }
	    }
	    $wrapperEl.css({
	      '-webkit-transform-origin': ("50% 50% -" + (swiperSize / 2) + "px"),
	      '-moz-transform-origin': ("50% 50% -" + (swiperSize / 2) + "px"),
	      '-ms-transform-origin': ("50% 50% -" + (swiperSize / 2) + "px"),
	      'transform-origin': ("50% 50% -" + (swiperSize / 2) + "px"),
	    });

	    if (params.shadow) {
	      if (isHorizontal) {
	        $cubeShadowEl.transform(("translate3d(0px, " + ((swiperWidth / 2) + params.shadowOffset) + "px, " + (-swiperWidth / 2) + "px) rotateX(90deg) rotateZ(0deg) scale(" + (params.shadowScale) + ")"));
	      } else {
	        var shadowAngle = Math.abs(wrapperRotate) - (Math.floor(Math.abs(wrapperRotate) / 90) * 90);
	        var multiplier = 1.5 - (
	          (Math.sin((shadowAngle * 2 * Math.PI) / 360) / 2) +
	          (Math.cos((shadowAngle * 2 * Math.PI) / 360) / 2)
	        );
	        var scale1 = params.shadowScale;
	        var scale2 = params.shadowScale / multiplier;
	        var offset = params.shadowOffset;
	        $cubeShadowEl.transform(("scale3d(" + scale1 + ", 1, " + scale2 + ") translate3d(0px, " + ((swiperHeight / 2) + offset) + "px, " + (-swiperHeight / 2 / scale2) + "px) rotateX(-90deg)"));
	      }
	    }
	    var zFactor = (Browser.isSafari || Browser.isUiWebView) ? (-swiperSize / 2) : 0;
	    $wrapperEl
	      .transform(("translate3d(0px,0," + zFactor + "px) rotateX(" + (swiper.isHorizontal() ? 0 : wrapperRotate) + "deg) rotateY(" + (swiper.isHorizontal() ? -wrapperRotate : 0) + "deg)"));
	  },
	  setTransition: function setTransition(duration) {
	    var swiper = this;
	    var $el = swiper.$el;
	    var slides = swiper.slides;
	    slides
	      .transition(duration)
	      .find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left')
	      .transition(duration);
	    if (swiper.params.cubeEffect.shadow && !swiper.isHorizontal()) {
	      $el.find('.swiper-cube-shadow').transition(duration);
	    }
	  },
	};

	var EffectCube = {
	  name: 'effect-cube',
	  params: {
	    cubeEffect: {
	      slideShadows: true,
	      shadow: true,
	      shadowOffset: 20,
	      shadowScale: 0.94,
	    },
	  },
	  create: function create() {
	    var swiper = this;
	    Utils.extend(swiper, {
	      cubeEffect: {
	        setTranslate: Cube.setTranslate.bind(swiper),
	        setTransition: Cube.setTransition.bind(swiper),
	      },
	    });
	  },
	  on: {
	    beforeInit: function beforeInit() {
	      var swiper = this;
	      if (swiper.params.effect !== 'cube') { return; }
	      swiper.classNames.push(((swiper.params.containerModifierClass) + "cube"));
	      swiper.classNames.push(((swiper.params.containerModifierClass) + "3d"));
	      var overwriteParams = {
	        slidesPerView: 1,
	        slidesPerColumn: 1,
	        slidesPerGroup: 1,
	        watchSlidesProgress: true,
	        resistanceRatio: 0,
	        spaceBetween: 0,
	        centeredSlides: false,
	        virtualTranslate: true,
	      };
	      Utils.extend(swiper.params, overwriteParams);
	      Utils.extend(swiper.originalParams, overwriteParams);
	    },
	    setTranslate: function setTranslate() {
	      var swiper = this;
	      if (swiper.params.effect !== 'cube') { return; }
	      swiper.cubeEffect.setTranslate();
	    },
	    setTransition: function setTransition(duration) {
	      var swiper = this;
	      if (swiper.params.effect !== 'cube') { return; }
	      swiper.cubeEffect.setTransition(duration);
	    },
	  },
	};

	var Flip = {
	  setTranslate: function setTranslate() {
	    var swiper = this;
	    var slides = swiper.slides;
	    var rtl = swiper.rtlTranslate;
	    for (var i = 0; i < slides.length; i += 1) {
	      var $slideEl = slides.eq(i);
	      var progress = $slideEl[0].progress;
	      if (swiper.params.flipEffect.limitRotation) {
	        progress = Math.max(Math.min($slideEl[0].progress, 1), -1);
	      }
	      var offset = $slideEl[0].swiperSlideOffset;
	      var rotate = -180 * progress;
	      var rotateY = rotate;
	      var rotateX = 0;
	      var tx = -offset;
	      var ty = 0;
	      if (!swiper.isHorizontal()) {
	        ty = tx;
	        tx = 0;
	        rotateX = -rotateY;
	        rotateY = 0;
	      } else if (rtl) {
	        rotateY = -rotateY;
	      }

	      $slideEl[0].style.zIndex = -Math.abs(Math.round(progress)) + slides.length;

	      if (swiper.params.flipEffect.slideShadows) {
	        // Set shadows
	        var shadowBefore = swiper.isHorizontal() ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
	        var shadowAfter = swiper.isHorizontal() ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');
	        if (shadowBefore.length === 0) {
	          shadowBefore = $$1(("<div class=\"swiper-slide-shadow-" + (swiper.isHorizontal() ? 'left' : 'top') + "\"></div>"));
	          $slideEl.append(shadowBefore);
	        }
	        if (shadowAfter.length === 0) {
	          shadowAfter = $$1(("<div class=\"swiper-slide-shadow-" + (swiper.isHorizontal() ? 'right' : 'bottom') + "\"></div>"));
	          $slideEl.append(shadowAfter);
	        }
	        if (shadowBefore.length) { shadowBefore[0].style.opacity = Math.max(-progress, 0); }
	        if (shadowAfter.length) { shadowAfter[0].style.opacity = Math.max(progress, 0); }
	      }
	      $slideEl
	        .transform(("translate3d(" + tx + "px, " + ty + "px, 0px) rotateX(" + rotateX + "deg) rotateY(" + rotateY + "deg)"));
	    }
	  },
	  setTransition: function setTransition(duration) {
	    var swiper = this;
	    var slides = swiper.slides;
	    var activeIndex = swiper.activeIndex;
	    var $wrapperEl = swiper.$wrapperEl;
	    slides
	      .transition(duration)
	      .find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left')
	      .transition(duration);
	    if (swiper.params.virtualTranslate && duration !== 0) {
	      var eventTriggered = false;
	      // eslint-disable-next-line
	      slides.eq(activeIndex).transitionEnd(function onTransitionEnd() {
	        if (eventTriggered) { return; }
	        if (!swiper || swiper.destroyed) { return; }
	        // if (!$(this).hasClass(swiper.params.slideActiveClass)) return;
	        eventTriggered = true;
	        swiper.animating = false;
	        var triggerEvents = ['webkitTransitionEnd', 'transitionend'];
	        for (var i = 0; i < triggerEvents.length; i += 1) {
	          $wrapperEl.trigger(triggerEvents[i]);
	        }
	      });
	    }
	  },
	};

	var EffectFlip = {
	  name: 'effect-flip',
	  params: {
	    flipEffect: {
	      slideShadows: true,
	      limitRotation: true,
	    },
	  },
	  create: function create() {
	    var swiper = this;
	    Utils.extend(swiper, {
	      flipEffect: {
	        setTranslate: Flip.setTranslate.bind(swiper),
	        setTransition: Flip.setTransition.bind(swiper),
	      },
	    });
	  },
	  on: {
	    beforeInit: function beforeInit() {
	      var swiper = this;
	      if (swiper.params.effect !== 'flip') { return; }
	      swiper.classNames.push(((swiper.params.containerModifierClass) + "flip"));
	      swiper.classNames.push(((swiper.params.containerModifierClass) + "3d"));
	      var overwriteParams = {
	        slidesPerView: 1,
	        slidesPerColumn: 1,
	        slidesPerGroup: 1,
	        watchSlidesProgress: true,
	        spaceBetween: 0,
	        virtualTranslate: true,
	      };
	      Utils.extend(swiper.params, overwriteParams);
	      Utils.extend(swiper.originalParams, overwriteParams);
	    },
	    setTranslate: function setTranslate() {
	      var swiper = this;
	      if (swiper.params.effect !== 'flip') { return; }
	      swiper.flipEffect.setTranslate();
	    },
	    setTransition: function setTransition(duration) {
	      var swiper = this;
	      if (swiper.params.effect !== 'flip') { return; }
	      swiper.flipEffect.setTransition(duration);
	    },
	  },
	};

	var Coverflow = {
	  setTranslate: function setTranslate() {
	    var swiper = this;
	    var swiperWidth = swiper.width;
	    var swiperHeight = swiper.height;
	    var slides = swiper.slides;
	    var $wrapperEl = swiper.$wrapperEl;
	    var slidesSizesGrid = swiper.slidesSizesGrid;
	    var params = swiper.params.coverflowEffect;
	    var isHorizontal = swiper.isHorizontal();
	    var transform = swiper.translate;
	    var center = isHorizontal ? -transform + (swiperWidth / 2) : -transform + (swiperHeight / 2);
	    var rotate = isHorizontal ? params.rotate : -params.rotate;
	    var translate = params.depth;
	    // Each slide offset from center
	    for (var i = 0, length = slides.length; i < length; i += 1) {
	      var $slideEl = slides.eq(i);
	      var slideSize = slidesSizesGrid[i];
	      var slideOffset = $slideEl[0].swiperSlideOffset;
	      var offsetMultiplier = ((center - slideOffset - (slideSize / 2)) / slideSize) * params.modifier;

	      var rotateY = isHorizontal ? rotate * offsetMultiplier : 0;
	      var rotateX = isHorizontal ? 0 : rotate * offsetMultiplier;
	      // var rotateZ = 0
	      var translateZ = -translate * Math.abs(offsetMultiplier);

	      var translateY = isHorizontal ? 0 : params.stretch * (offsetMultiplier);
	      var translateX = isHorizontal ? params.stretch * (offsetMultiplier) : 0;

	      // Fix for ultra small values
	      if (Math.abs(translateX) < 0.001) { translateX = 0; }
	      if (Math.abs(translateY) < 0.001) { translateY = 0; }
	      if (Math.abs(translateZ) < 0.001) { translateZ = 0; }
	      if (Math.abs(rotateY) < 0.001) { rotateY = 0; }
	      if (Math.abs(rotateX) < 0.001) { rotateX = 0; }

	      var slideTransform = "translate3d(" + translateX + "px," + translateY + "px," + translateZ + "px)  rotateX(" + rotateX + "deg) rotateY(" + rotateY + "deg)";

	      $slideEl.transform(slideTransform);
	      $slideEl[0].style.zIndex = -Math.abs(Math.round(offsetMultiplier)) + 1;
	      if (params.slideShadows) {
	        // Set shadows
	        var $shadowBeforeEl = isHorizontal ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
	        var $shadowAfterEl = isHorizontal ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');
	        if ($shadowBeforeEl.length === 0) {
	          $shadowBeforeEl = $$1(("<div class=\"swiper-slide-shadow-" + (isHorizontal ? 'left' : 'top') + "\"></div>"));
	          $slideEl.append($shadowBeforeEl);
	        }
	        if ($shadowAfterEl.length === 0) {
	          $shadowAfterEl = $$1(("<div class=\"swiper-slide-shadow-" + (isHorizontal ? 'right' : 'bottom') + "\"></div>"));
	          $slideEl.append($shadowAfterEl);
	        }
	        if ($shadowBeforeEl.length) { $shadowBeforeEl[0].style.opacity = offsetMultiplier > 0 ? offsetMultiplier : 0; }
	        if ($shadowAfterEl.length) { $shadowAfterEl[0].style.opacity = (-offsetMultiplier) > 0 ? -offsetMultiplier : 0; }
	      }
	    }

	    // Set correct perspective for IE10
	    if (Support.pointerEvents || Support.prefixedPointerEvents) {
	      var ws = $wrapperEl[0].style;
	      ws.perspectiveOrigin = center + "px 50%";
	    }
	  },
	  setTransition: function setTransition(duration) {
	    var swiper = this;
	    swiper.slides
	      .transition(duration)
	      .find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left')
	      .transition(duration);
	  },
	};

	var EffectCoverflow = {
	  name: 'effect-coverflow',
	  params: {
	    coverflowEffect: {
	      rotate: 50,
	      stretch: 0,
	      depth: 100,
	      modifier: 1,
	      slideShadows: true,
	    },
	  },
	  create: function create() {
	    var swiper = this;
	    Utils.extend(swiper, {
	      coverflowEffect: {
	        setTranslate: Coverflow.setTranslate.bind(swiper),
	        setTransition: Coverflow.setTransition.bind(swiper),
	      },
	    });
	  },
	  on: {
	    beforeInit: function beforeInit() {
	      var swiper = this;
	      if (swiper.params.effect !== 'coverflow') { return; }

	      swiper.classNames.push(((swiper.params.containerModifierClass) + "coverflow"));
	      swiper.classNames.push(((swiper.params.containerModifierClass) + "3d"));

	      swiper.params.watchSlidesProgress = true;
	      swiper.originalParams.watchSlidesProgress = true;
	    },
	    setTranslate: function setTranslate() {
	      var swiper = this;
	      if (swiper.params.effect !== 'coverflow') { return; }
	      swiper.coverflowEffect.setTranslate();
	    },
	    setTransition: function setTransition(duration) {
	      var swiper = this;
	      if (swiper.params.effect !== 'coverflow') { return; }
	      swiper.coverflowEffect.setTransition(duration);
	    },
	  },
	};

	// Swiper Class

	Swiper.use([
	  Device$1,
	  Browser$1,
	  Support$1,
	  Resize,
	  Observer$2,
	  Virtual$1,
	  Navigation$1,
	  Pagination$1,
	  Scrollbar$1,
	  Parallax$1,
	  Zoom$1,
	  Lazy$3,
	  Controller$1,
	  A11y,
	  Autoplay$1,
	  EffectFade,
	  EffectCube,
	  EffectFlip,
	  EffectCoverflow ]);

	function initSwipers(swiperEl) {
	  var app = this;
	  var $swiperEl = $$1(swiperEl);
	  if ($swiperEl.length === 0) { return; }
	  if ($swiperEl[0].swiper) { return; }
	  var initialSlide;
	  var params = {};
	  var isTabs;
	  var isRoutableTabs;
	  if ($swiperEl.hasClass('tabs-swipeable-wrap')) {
	    $swiperEl
	      .addClass('swiper-container')
	      .children('.tabs')
	      .addClass('swiper-wrapper')
	      .children('.tab')
	      .addClass('swiper-slide');
	    initialSlide = $swiperEl.children('.tabs').children('.tab-active').index();
	    isTabs = true;
	    isRoutableTabs = $swiperEl.find('.tabs-routable').length > 0;
	  }
	  if ($swiperEl.attr('data-swiper')) {
	    params = JSON.parse($swiperEl.attr('data-swiper'));
	  } else {
	    params = $swiperEl.dataset();
	    Object.keys(params).forEach(function (key) {
	      var value = params[key];
	      if (typeof value === 'string' && value.indexOf('{') === 0 && value.indexOf('}') > 0) {
	        try {
	          params[key] = JSON.parse(value);
	        } catch (e) {
	          // not JSON
	        }
	      }
	    });
	  }
	  if (typeof params.initialSlide === 'undefined' && typeof initialSlide !== 'undefined') {
	    params.initialSlide = initialSlide;
	  }

	  var swiper = app.swiper.create($swiperEl[0], params);
	  if (isTabs) {
	    swiper.on('slideChange', function () {
	      if (isRoutableTabs) {
	        var view = app.views.get($swiperEl.parents('.view'));
	        if (!view) { view = app.views.main; }
	        var router = view.router;
	        var tabRoute = router.findTabRoute(swiper.slides.eq(swiper.activeIndex)[0]);
	        if (tabRoute) { router.navigate(tabRoute.path); }
	      } else {
	        app.tab.show({
	          tabEl: swiper.slides.eq(swiper.activeIndex),
	        });
	      }
	    });
	  }
	}

	var Swiper$1 = {
	  name: 'swiper',
	  static: {
	    Swiper: Swiper,
	  },
	  create: function create() {
	    var app = this;
	    app.swiper = ConstructorMethods({
	      defaultSelector: '.swiper-container',
	      constructor: Swiper,
	      domProp: 'swiper',
	    });
	  },
	  on: {
	    pageBeforeRemove: function pageBeforeRemove(page) {
	      var app = this;
	      page.$el.find('.swiper-init, .tabs-swipeable-wrap').each(function (index, swiperEl) {
	        app.swiper.destroy(swiperEl);
	      });
	    },
	    pageMounted: function pageMounted(page) {
	      var app = this;
	      page.$el.find('.tabs-swipeable-wrap').each(function (index, swiperEl) {
	        initSwipers.call(app, swiperEl);
	      });
	    },
	    pageInit: function pageInit(page) {
	      var app = this;
	      page.$el.find('.swiper-init, .tabs-swipeable-wrap').each(function (index, swiperEl) {
	        initSwipers.call(app, swiperEl);
	      });
	    },
	    pageReinit: function pageReinit(page) {
	      var app = this;
	      page.$el.find('.swiper-init, .tabs-swipeable-wrap').each(function (index, swiperEl) {
	        var swiper = app.swiper.get(swiperEl);
	        if (swiper && swiper.update) { swiper.update(); }
	      });
	    },
	    tabMounted: function tabMounted(tabEl) {
	      var app = this;
	      $$1(tabEl).find('.swiper-init, .tabs-swipeable-wrap').each(function (index, swiperEl) {
	        initSwipers.call(app, swiperEl);
	      });
	    },
	    tabShow: function tabShow(tabEl) {
	      var app = this;
	      $$1(tabEl).find('.swiper-init, .tabs-swipeable-wrap').each(function (index, swiperEl) {
	        var swiper = app.swiper.get(swiperEl);
	        if (swiper && swiper.update) { swiper.update(); }
	      });
	    },
	    tabBeforeRemove: function tabBeforeRemove(tabEl) {
	      var app = this;
	      $$1(tabEl).find('.swiper-init, .tabs-swipeable-wrap').each(function (index, swiperEl) {
	        app.swiper.destroy(swiperEl);
	      });
	    },
	  },
	};

	/* eslint indent: ["off"] */

	var PhotoBrowser = (function (Framework7Class$$1) {
	  function PhotoBrowser(app, params) {
	    if ( params === void 0 ) params = {};

	    Framework7Class$$1.call(this, params, [app]);

	    var pb = this;
	    pb.app = app;

	    var defaults = Utils.extend({
	      on: {},
	    }, app.params.photoBrowser);

	    // Extend defaults with modules params
	    pb.useModulesParams(defaults);

	    pb.params = Utils.extend(defaults, params);

	    Utils.extend(pb, {
	      exposed: false,
	      opened: false,
	      activeIndex: pb.params.swiper.initialSlide,
	      url: pb.params.url,
	      view: pb.params.view || app.views.main,
	      swipeToClose: {
	        allow: true,
	        isTouched: false,
	        diff: undefined,
	        start: undefined,
	        current: undefined,
	        started: false,
	        activeSlide: undefined,
	        timeStart: undefined,
	      },
	    });

	    // Install Modules
	    pb.useModules();

	    // Init
	    pb.init();
	  }

	  if ( Framework7Class$$1 ) PhotoBrowser.__proto__ = Framework7Class$$1;
	  PhotoBrowser.prototype = Object.create( Framework7Class$$1 && Framework7Class$$1.prototype );
	  PhotoBrowser.prototype.constructor = PhotoBrowser;
	  PhotoBrowser.prototype.onSlideChange = function onSlideChange (swiper) {
	    var pb = this;
	    pb.activeIndex = swiper.activeIndex;

	    var current = swiper.activeIndex + 1;
	    var total = pb.params.virtualSlides ? pb.params.photos.length : swiper.slides.length;
	    if (swiper.params.loop) {
	      total -= 2;
	      current -= swiper.loopedSlides;
	      if (current < 1) { current = total + current; }
	      if (current > total) { current -= total; }
	    }

	    var $activeSlideEl = pb.params.virtualSlides
	      ? swiper.$wrapperEl.find((".swiper-slide[data-swiper-slide-index=\"" + (swiper.activeIndex) + "\"]"))
	      : swiper.slides.eq(swiper.activeIndex);
	    var $previousSlideEl = pb.params.virtualSlides
	      ? swiper.$wrapperEl.find((".swiper-slide[data-swiper-slide-index=\"" + (swiper.previousIndex) + "\"]"))
	      : swiper.slides.eq(swiper.previousIndex);

	    var $currentEl = pb.$el.find('.photo-browser-current');
	    var $totalEl = pb.$el.find('.photo-browser-total');
	    if (pb.params.type === 'page' && pb.params.navbar && $currentEl.length === 0 && pb.app.theme === 'ios') {
	      var navbarEl = pb.app.navbar.getElByPage(pb.$el);
	      if (navbarEl) {
	        $currentEl = $$1(navbarEl).find('.photo-browser-current');
	        $totalEl = $$1(navbarEl).find('.photo-browser-total');
	      }
	    }
	    $currentEl.text(current);
	    $totalEl.text(total);

	    // Update captions
	    if (pb.captions.length > 0) {
	      var captionIndex = swiper.params.loop ? $activeSlideEl.attr('data-swiper-slide-index') : pb.activeIndex;
	      pb.$captionsContainerEl.find('.photo-browser-caption-active').removeClass('photo-browser-caption-active');
	      pb.$captionsContainerEl.find(("[data-caption-index=\"" + captionIndex + "\"]")).addClass('photo-browser-caption-active');
	    }

	    // Stop Video
	    var previousSlideVideo = $previousSlideEl.find('video');
	    if (previousSlideVideo.length > 0) {
	      if ('pause' in previousSlideVideo[0]) { previousSlideVideo[0].pause(); }
	    }
	  };
	  PhotoBrowser.prototype.onTouchStart = function onTouchStart () {
	    var pb = this;
	    var swipeToClose = pb.swipeToClose;
	    if (!swipeToClose.allow) { return; }
	    swipeToClose.isTouched = true;
	  };
	  PhotoBrowser.prototype.onTouchMove = function onTouchMove (e) {
	    var pb = this;
	    var swipeToClose = pb.swipeToClose;

	    if (!swipeToClose.isTouched) { return; }
	    if (!swipeToClose.started) {
	      swipeToClose.started = true;
	      swipeToClose.start = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;
	      if (pb.params.virtualSlides) {
	        swipeToClose.activeSlide = pb.swiper.$wrapperEl.children('.swiper-slide-active');
	      } else {
	        swipeToClose.activeSlide = pb.swiper.slides.eq(pb.swiper.activeIndex);
	      }
	      swipeToClose.timeStart = Utils.now();
	    }
	    e.preventDefault();
	    swipeToClose.current = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;
	    swipeToClose.diff = swipeToClose.start - swipeToClose.current;
	    var opacity = 1 - (Math.abs(swipeToClose.diff) / 300);
	    var color = pb.exposed || pb.params.theme === 'dark' ? 0 : 255;
	    swipeToClose.activeSlide.transform(("translate3d(0," + (-swipeToClose.diff) + "px,0)"));
	    pb.swiper.$el.css('background-color', ("rgba(" + color + ", " + color + ", " + color + ", " + opacity + ")")).transition(0);
	  };
	  PhotoBrowser.prototype.onTouchEnd = function onTouchEnd () {
	    var pb = this;
	    var swipeToClose = pb.swipeToClose;
	    swipeToClose.isTouched = false;
	    if (!swipeToClose.started) {
	      swipeToClose.started = false;
	      return;
	    }
	    swipeToClose.started = false;
	    swipeToClose.allow = false;
	    var diff = Math.abs(swipeToClose.diff);
	    var timeDiff = (new Date()).getTime() - swipeToClose.timeStart;
	    if ((timeDiff < 300 && diff > 20) || (timeDiff >= 300 && diff > 100)) {
	      Utils.nextTick(function () {
	        if (pb.$el) {
	          if (swipeToClose.diff < 0) { pb.$el.addClass('swipe-close-to-bottom'); }
	          else { pb.$el.addClass('swipe-close-to-top'); }
	        }
	        pb.emit('local::swipeToClose', pb);
	        pb.close();
	        swipeToClose.allow = true;
	      });
	      return;
	    }
	    if (diff !== 0) {
	      swipeToClose.activeSlide.addClass('photo-browser-transitioning').transitionEnd(function () {
	        swipeToClose.allow = true;
	        swipeToClose.activeSlide.removeClass('photo-browser-transitioning');
	      });
	    } else {
	      swipeToClose.allow = true;
	    }
	    pb.swiper.$el.transition('').css('background-color', '');
	    swipeToClose.activeSlide.transform('');
	  };

	  // Render Functions
	  PhotoBrowser.prototype.renderNavbar = function renderNavbar () {
	    var pb = this;
	    if (pb.params.renderNavbar) { return pb.params.renderNavbar.call(pb); }

	    var iconsColor = pb.params.iconsColor;
	    if (!pb.params.iconsColor && pb.params.theme === 'dark') { iconsColor = 'white'; }

	    var backLinkText = pb.app.theme === 'ios' && pb.params.backLinkText ? pb.params.backLinkText : '';

	    var isPopup = pb.params.type !== 'page';
	    var navbarHtml = ("\n      <div class=\"navbar\">\n        <div class=\"navbar-inner sliding\">\n          <div class=\"left\">\n            <a href=\"#\" class=\"link " + (isPopup ? 'popup-close' : '') + " " + (!backLinkText ? 'icon-only' : '') + " " + (!isPopup ? 'back' : '') + "\" " + (isPopup ? 'data-popup=".photo-browser-popup"' : '') + ">\n              <i class=\"icon icon-back " + (iconsColor ? ("color-" + iconsColor) : '') + "\"></i>\n              " + (backLinkText ? ("<span>" + backLinkText + "</span>") : '') + "\n            </a>\n          </div>\n          <div class=\"title\">\n            <span class=\"photo-browser-current\"></span>\n            <span class=\"photo-browser-of\">" + (pb.params.navbarOfText) + "</span>\n            <span class=\"photo-browser-total\"></span>\n          </div>\n          <div class=\"right\"></div>\n        </div>\n      </div>\n    ").trim();
	    return navbarHtml;
	  };
	  PhotoBrowser.prototype.renderToolbar = function renderToolbar () {
	    var pb = this;
	    if (pb.params.renderToolbar) { return pb.params.renderToolbar.call(pb); }

	    var iconsColor = pb.params.iconsColor;
	    if (!pb.params.iconsColor && pb.params.theme === 'dark') { iconsColor = 'white'; }

	    var toolbarHtml = ("\n      <div class=\"toolbar tabbar toolbar-bottom-md\">\n        <div class=\"toolbar-inner\">\n          <a href=\"#\" class=\"link photo-browser-prev\">\n            <i class=\"icon icon-back " + (iconsColor ? ("color-" + iconsColor) : '') + "\"></i>\n          </a>\n          <a href=\"#\" class=\"link photo-browser-next\">\n            <i class=\"icon icon-forward " + (iconsColor ? ("color-" + iconsColor) : '') + "\"></i>\n          </a>\n        </div>\n      </div>\n    ").trim();
	    return toolbarHtml;
	  };
	  PhotoBrowser.prototype.renderCaption = function renderCaption (caption, index) {
	    var pb = this;
	    if (pb.params.renderCaption) { return pb.params.renderCaption.call(pb, caption, index); }
	    var captionHtml = ("\n      <div class=\"photo-browser-caption\" data-caption-index=\"" + index + "\">\n        " + caption + "\n      </div>\n    ").trim();
	    return captionHtml;
	  };
	  PhotoBrowser.prototype.renderObject = function renderObject (photo, index) {
	    var pb = this;
	    if (pb.params.renderObject) { return pb.params.renderObject.call(pb, photo, index); }
	    var objHtml = "\n      <div class=\"photo-browser-slide photo-browser-object-slide swiper-slide\" data-swiper-slide-index=\"" + index + "\">" + (photo.html ? photo.html : photo) + "</div>\n    ";
	    return objHtml;
	  };
	  PhotoBrowser.prototype.renderLazyPhoto = function renderLazyPhoto (photo, index) {
	    var pb = this;
	    if (pb.params.renderLazyPhoto) { return pb.params.renderLazyPhoto.call(pb, photo, index); }
	    var photoHtml = ("\n      <div class=\"photo-browser-slide photo-browser-slide-lazy swiper-slide\" data-swiper-slide-index=\"" + index + "\">\n          <div class=\"preloader swiper-lazy-preloader " + (pb.params.theme === 'dark' ? 'color-white' : '') + "\">" + (pb.app.theme === 'md' ? Utils.mdPreloaderContent : '') + "</div>\n          <span class=\"swiper-zoom-container\">\n              <img data-src=\"" + (photo.url ? photo.url : photo) + "\" class=\"swiper-lazy\">\n          </span>\n      </div>\n    ").trim();
	    return photoHtml;
	  };
	  PhotoBrowser.prototype.renderPhoto = function renderPhoto (photo, index) {
	    var pb = this;
	    if (pb.params.renderPhoto) { return pb.params.renderPhoto.call(pb, photo, index); }
	    var photoHtml = ("\n      <div class=\"photo-browser-slide swiper-slide\" data-swiper-slide-index=\"" + index + "\">\n        <span class=\"swiper-zoom-container\">\n          <img src=\"" + (photo.url ? photo.url : photo) + "\">\n        </span>\n      </div>\n    ").trim();
	    return photoHtml;
	  };
	  PhotoBrowser.prototype.render = function render () {
	    var pb = this;
	    if (pb.params.render) { return pb.params.render.call(pb, pb.params); }
	    var html = ("\n      <div class=\"photo-browser photo-browser-" + (pb.params.theme) + "\">\n        <div class=\"view\">\n          <div class=\"page photo-browser-page photo-browser-page-" + (pb.params.theme) + " no-toolbar " + (!pb.params.navbar ? 'no-navbar' : '') + "\" data-name=\"photo-browser-page\">\n            " + (pb.params.navbar ? pb.renderNavbar() : '') + "\n            " + (pb.params.toolbar ? pb.renderToolbar() : '') + "\n            <div class=\"photo-browser-captions photo-browser-captions-" + (pb.params.captionsTheme || pb.params.theme) + "\">\n              " + (pb.params.photos.map(function (photo, index) {
	                if (photo.caption) { return pb.renderCaption(photo.caption, index); }
	                return '';
	              }).join(' ')) + "\n            </div>\n            <div class=\"photo-browser-swiper-container swiper-container\">\n              <div class=\"photo-browser-swiper-wrapper swiper-wrapper\">\n                " + (pb.params.virtualSlides ? '' : pb.params.photos.map(function (photo, index) {
	                  if (photo.html || ((typeof photo === 'string' || photo instanceof String) && photo.indexOf('<') >= 0 && photo.indexOf('>') >= 0)) {
	                    return pb.renderObject(photo, index);
	                  } else if (pb.params.swiper.lazy === true || (pb.params.swiper.lazy && pb.params.swiper.lazy.enabled)) {
	                    return pb.renderLazyPhoto(photo, index);
	                  }
	                  return pb.renderPhoto(photo, index);
	                }).join(' ')) + "\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    ").trim();
	    return html;
	  };
	  PhotoBrowser.prototype.renderStandalone = function renderStandalone () {
	    var pb = this;
	    if (pb.params.renderStandalone) { return pb.params.renderStandalone.call(pb); }
	    var standaloneHtml = "<div class=\"popup photo-browser-popup photo-browser-standalone popup-tablet-fullscreen\">" + (pb.render()) + "</div>";
	    return standaloneHtml;
	  };
	  PhotoBrowser.prototype.renderPage = function renderPage () {
	    var pb = this;
	    if (pb.params.renderPage) { return pb.params.renderPage.call(pb); }
	    var pageHtml = pb.render();

	    return pageHtml;
	  };
	  PhotoBrowser.prototype.renderPopup = function renderPopup () {
	    var pb = this;
	    if (pb.params.renderPopup) { return pb.params.renderPopup.call(pb); }
	    var popupHtml = "<div class=\"popup photo-browser-popup\">" + (pb.render()) + "</div>";

	    return popupHtml;
	  };

	  // Callbacks
	  PhotoBrowser.prototype.onOpen = function onOpen (type, el) {
	    var pb = this;
	    var app = pb.app;
	    var $el = $$1(el);

	    $el[0].f7PhotoBrowser = pb;

	    pb.$el = $el;
	    pb.el = $el[0];
	    pb.openedIn = type;
	    pb.opened = true;

	    pb.$swiperContainerEl = pb.$el.find('.photo-browser-swiper-container');
	    pb.$swiperWrapperEl = pb.$el.find('.photo-browser-swiper-wrapper');
	    pb.slides = pb.$el.find('.photo-browser-slide');
	    pb.$captionsContainerEl = pb.$el.find('.photo-browser-captions');
	    pb.captions = pb.$el.find('.photo-browser-caption');

	    // Init Swiper
	    var swiperParams = Utils.extend({}, pb.params.swiper, {
	      initialSlide: pb.activeIndex,
	      on: {
	        tap: function tap(e) {
	          pb.emit('local::tap', e);
	        },
	        click: function click(e) {
	          if (pb.params.exposition) {
	            pb.expositionToggle();
	          }
	          pb.emit('local::click', e);
	        },
	        doubleTap: function doubleTap(e) {
	          pb.emit('local::doubleTap', e);
	        },
	        slideChange: function slideChange() {
	          var args = [], len = arguments.length;
	          while ( len-- ) args[ len ] = arguments[ len ];

	          var swiper = this;
	          pb.onSlideChange(swiper);
	          pb.emit.apply(pb, [ 'local::slideChange' ].concat( args ));
	        },
	        transitionStart: function transitionStart() {
	          var args = [], len = arguments.length;
	          while ( len-- ) args[ len ] = arguments[ len ];

	          pb.emit.apply(pb, [ 'local::transitionStart' ].concat( args ));
	        },
	        transitionEnd: function transitionEnd() {
	          var args = [], len = arguments.length;
	          while ( len-- ) args[ len ] = arguments[ len ];

	          pb.emit.apply(pb, [ 'local::transitionEnd' ].concat( args ));
	        },
	        slideChangeTransitionStart: function slideChangeTransitionStart() {
	          var args = [], len = arguments.length;
	          while ( len-- ) args[ len ] = arguments[ len ];

	          pb.emit.apply(pb, [ 'local::slideChangeTransitionStart' ].concat( args ));
	        },
	        slideChangeTransitionEnd: function slideChangeTransitionEnd() {
	          var args = [], len = arguments.length;
	          while ( len-- ) args[ len ] = arguments[ len ];

	          pb.emit.apply(pb, [ 'local::slideChangeTransitionEnd' ].concat( args ));
	        },
	        lazyImageLoad: function lazyImageLoad() {
	          var args = [], len = arguments.length;
	          while ( len-- ) args[ len ] = arguments[ len ];

	          pb.emit.apply(pb, [ 'local::lazyImageLoad' ].concat( args ));
	        },
	        lazyImageReady: function lazyImageReady() {
	          var args = [], len = arguments.length;
	          while ( len-- ) args[ len ] = arguments[ len ];

	          var slideEl = args[0];
	          $$1(slideEl).removeClass('photo-browser-slide-lazy');
	          pb.emit.apply(pb, [ 'local::lazyImageReady' ].concat( args ));
	        },
	      },
	    });
	    if (pb.params.swipeToClose && pb.params.type !== 'page') {
	      Utils.extend(swiperParams.on, {
	        touchStart: function touchStart(e) {
	          pb.onTouchStart(e);
	          pb.emit('local::touchStart', e);
	        },
	        touchMoveOpposite: function touchMoveOpposite(e) {
	          pb.onTouchMove(e);
	          pb.emit('local::touchMoveOpposite', e);
	        },
	        touchEnd: function touchEnd(e) {
	          pb.onTouchEnd(e);
	          pb.emit('local::touchEnd', e);
	        },
	      });
	    }
	    if (pb.params.virtualSlides) {
	      Utils.extend(swiperParams, {
	        virtual: {
	          slides: pb.params.photos,
	          renderSlide: function renderSlide(photo, index) {
	            if (photo.html || ((typeof photo === 'string' || photo instanceof String) && photo.indexOf('<') >= 0 && photo.indexOf('>') >= 0)) {
	              return pb.renderObject(photo, index);
	            } else if (pb.params.swiper.lazy === true || (pb.params.swiper.lazy && pb.params.swiper.lazy.enabled)) {
	              return pb.renderLazyPhoto(photo, index);
	            }
	            return pb.renderPhoto(photo, index);
	          },
	        },
	      });
	    }

	    pb.swiper = app.swiper.create(pb.$swiperContainerEl, swiperParams);

	    if (pb.activeIndex === 0) {
	      pb.onSlideChange(pb.swiper);
	    }
	    if (pb.$el) {
	      pb.$el.trigger('photobrowser:open');
	    }
	    pb.emit('local::open photoBrowserOpen', pb);
	  };
	  PhotoBrowser.prototype.onOpened = function onOpened () {
	    var pb = this;

	    if (pb.$el) {
	      pb.$el.trigger('photobrowser:opened');
	    }
	    pb.emit('local::opened photoBrowserOpened', pb);
	  };
	  PhotoBrowser.prototype.onClose = function onClose () {
	    var pb = this;
	    if (pb.destroyed) { return; }

	    // Destroy Swiper
	    if (pb.swiper && pb.swiper.destroy) {
	      pb.swiper.destroy(true, false);
	      pb.swiper = null;
	      delete pb.swiper;
	    }
	    if (pb.$el) {
	      pb.$el.trigger('photobrowser:close');
	    }
	    pb.emit('local::close photoBrowserClose', pb);
	  };
	  PhotoBrowser.prototype.onClosed = function onClosed () {
	    var pb = this;
	    if (pb.destroyed) { return; }
	    pb.opened = false;
	    pb.$el = null;
	    pb.el = null;
	    delete pb.$el;
	    delete pb.el;
	    if (pb.$el) {
	      pb.$el.trigger('photobrowser:closed');
	    }
	    pb.emit('local::closed photoBrowserClosed', pb);
	  };

	  // Open
	  PhotoBrowser.prototype.openPage = function openPage () {
	    var pb = this;
	    if (pb.opened) { return pb; }

	    var pageHtml = pb.renderPage();

	    pb.view.router.navigate({
	      url: pb.url,
	      route: {
	        content: pageHtml,
	        path: pb.url,
	        on: {
	          pageBeforeIn: function pageBeforeIn(e, page) {
	            pb.view.$el.addClass(("with-photo-browser-page with-photo-browser-page-" + (pb.params.theme)));
	            pb.onOpen('page', page.el);
	          },
	          pageAfterIn: function pageAfterIn(e, page) {
	            pb.onOpened('page', page.el);
	          },
	          pageBeforeOut: function pageBeforeOut(e, page) {
	            pb.view.$el.removeClass(("with-photo-browser-page with-photo-browser-page-exposed with-photo-browser-page-" + (pb.params.theme)));
	            pb.onClose('page', page.el);
	          },
	          pageAfterOut: function pageAfterOut(e, page) {
	            pb.onClosed('page', page.el);
	          },
	        },
	      },
	    });
	    return pb;
	  };

	  PhotoBrowser.prototype.openStandalone = function openStandalone () {
	    var pb = this;
	    if (pb.opened) { return pb; }

	    var standaloneHtml = pb.renderStandalone();

	    var popupParams = {
	      backdrop: false,
	      content: standaloneHtml,
	      on: {
	        popupOpen: function popupOpen(popup) {
	          pb.onOpen('popup', popup.el);
	        },
	        popupOpened: function popupOpened(popup) {
	          pb.onOpened('popup', popup.el);
	        },
	        popupClose: function popupClose(popup) {
	          pb.onClose('popup', popup.el);
	        },
	        popupClosed: function popupClosed(popup) {
	          pb.onClosed('popup', popup.el);
	        },
	      },
	    };

	    if (pb.params.routableModals) {
	      pb.view.router.navigate({
	        url: pb.url,
	        route: {
	          path: pb.url,
	          popup: popupParams,
	        },
	      });
	    } else {
	      pb.modal = pb.app.popup.create(popupParams).open();
	    }
	    return pb;
	  };

	  PhotoBrowser.prototype.openPopup = function openPopup () {
	    var pb = this;
	    if (pb.opened) { return pb; }

	    var popupHtml = pb.renderPopup();

	    var popupParams = {
	      content: popupHtml,
	      on: {
	        popupOpen: function popupOpen(popup) {
	          pb.onOpen('popup', popup.el);
	        },
	        popupOpened: function popupOpened(popup) {
	          pb.onOpened('popup', popup.el);
	        },
	        popupClose: function popupClose(popup) {
	          pb.onClose('popup', popup.el);
	        },
	        popupClosed: function popupClosed(popup) {
	          pb.onClosed('popup', popup.el);
	        },
	      },
	    };

	    if (pb.params.routableModals) {
	      pb.view.router.navigate({
	        url: pb.url,
	        route: {
	          path: pb.url,
	          popup: popupParams,
	        },
	      });
	    } else {
	      pb.modal = pb.app.popup.create(popupParams).open();
	    }
	    return pb;
	  };

	  // Exposition
	  PhotoBrowser.prototype.expositionEnable = function expositionEnable () {
	    var pb = this;
	    if (pb.params.type === 'page') {
	      pb.view.$el.addClass('with-photo-browser-page-exposed');
	    }
	    if (pb.$el) { pb.$el.addClass('photo-browser-exposed'); }
	    if (pb.params.expositionHideCaptions) { pb.$captionsContainerEl.addClass('photo-browser-captions-exposed'); }
	    pb.exposed = true;
	    return pb;
	  };
	  PhotoBrowser.prototype.expositionDisable = function expositionDisable () {
	    var pb = this;
	    if (pb.params.type === 'page') {
	      pb.view.$el.removeClass('with-photo-browser-page-exposed');
	    }
	    if (pb.$el) { pb.$el.removeClass('photo-browser-exposed'); }
	    if (pb.params.expositionHideCaptions) { pb.$captionsContainerEl.removeClass('photo-browser-captions-exposed'); }
	    pb.exposed = false;
	    return pb;
	  };
	  PhotoBrowser.prototype.expositionToggle = function expositionToggle () {
	    var pb = this;
	    if (pb.params.type === 'page') {
	      pb.view.$el.toggleClass('with-photo-browser-page-exposed');
	    }
	    if (pb.$el) { pb.$el.toggleClass('photo-browser-exposed'); }
	    if (pb.params.expositionHideCaptions) { pb.$captionsContainerEl.toggleClass('photo-browser-captions-exposed'); }
	    pb.exposed = !pb.exposed;
	    return pb;
	  };
	  PhotoBrowser.prototype.open = function open (index) {
	    var pb = this;
	    var type = pb.params.type;
	    if (pb.opened) {
	      if (pb.swiper && typeof index !== 'undefined') {
	        pb.swiper.slideTo(parseInt(index, 10));
	      }
	      return pb;
	    } else if (typeof index !== 'undefined') {
	      pb.activeIndex = index;
	    }
	    if (type === 'standalone') {
	      pb.openStandalone();
	    }
	    if (type === 'page') {
	      pb.openPage();
	    }
	    if (type === 'popup') {
	      pb.openPopup();
	    }
	    return pb;
	  };
	  PhotoBrowser.prototype.close = function close () {
	    var pb = this;
	    if (!pb.opened) { return pb; }
	    if (pb.params.routableModals || pb.openedIn === 'page') {
	      if (pb.view) { pb.view.router.back(); }
	    } else {
	      pb.modal.once('modalClosed', function () {
	        Utils.nextTick(function () {
	          pb.modal.destroy();
	          delete pb.modal;
	        });
	      });
	      pb.modal.close();
	    }
	    return pb;
	  };
	  // eslint-disable-next-line
	  PhotoBrowser.prototype.init = function init () {};
	  PhotoBrowser.prototype.destroy = function destroy () {
	    var pb = this;
	    pb.emit('local::beforeDestroy photoBrowserBeforeDestroy', pb);
	    if (pb.$el) {
	      pb.$el.trigger('photobrowser:beforedestroy');
	      delete pb.$el[0].f7PhotoBrowser;
	    }
	    Utils.deleteProps(pb);
	    pb = null;
	  };

	  return PhotoBrowser;
	}(Framework7Class));

	var PhotoBrowser$1 = {
	  name: 'photoBrowser',
	  params: {
	    photoBrowser: {
	      photos: [],
	      exposition: true,
	      expositionHideCaptions: false,
	      type: 'standalone',
	      navbar: true,
	      toolbar: true,
	      theme: 'light',
	      captionsTheme: undefined,
	      iconsColor: undefined,
	      swipeToClose: true,
	      backLinkText: 'Close',
	      navbarOfText: 'of',
	      view: undefined,
	      url: 'photos/',
	      routableModals: true,
	      virtualSlides: true,

	      renderNavbar: undefined,
	      renderToolbar: undefined,
	      renderCaption: undefined,
	      renderObject: undefined,
	      renderLazyPhoto: undefined,
	      renderPhoto: undefined,
	      renderPage: undefined,
	      renderPopup: undefined,
	      renderStandalone: undefined,

	      swiper: {
	        initialSlide: 0,
	        spaceBetween: 20,
	        speed: 300,
	        loop: false,
	        preloadImages: true,
	        navigation: {
	          nextEl: '.photo-browser-next',
	          prevEl: '.photo-browser-prev',
	        },
	        zoom: {
	          enabled: true,
	          maxRatio: 3,
	          minRatio: 1,
	        },
	        lazy: {
	          enabled: true,
	        },
	      },
	    },
	  },
	  create: function create() {
	    var app = this;
	    app.photoBrowser = ConstructorMethods({
	      defaultSelector: '.photo-browser',
	      constructor: PhotoBrowser,
	      app: app,
	      domProp: 'f7PhotoBrowser',
	    });
	  },
	  static: {
	    PhotoBrowser: PhotoBrowser,
	  },
	};

	var Sheet = (function (Modal$$1) {
	  function Sheet(app, params) {
	    var extendedParams = Utils.extend(
	      { on: {} },
	      app.params.sheet,
	      params
	    );

	    // Extends with open/close Modal methods;
	    Modal$$1.call(this, app, extendedParams);

	    var sheet = this;

	    sheet.params = extendedParams;

	    // Find Element
	    var $el;
	    if (!sheet.params.el) {
	      $el = $$1(sheet.params.content);
	    } else {
	      $el = $$1(sheet.params.el);
	    }

	    if ($el && $el.length > 0 && $el[0].f7Modal) {
	      return $el[0].f7Modal;
	    }

	    if ($el.length === 0) {
	      return sheet.destroy();
	    }
	    var $backdropEl;
	    if (sheet.params.backdrop) {
	      $backdropEl = app.root.children('.sheet-backdrop');
	      if ($backdropEl.length === 0) {
	        $backdropEl = $$1('<div class="sheet-backdrop"></div>');
	        app.root.append($backdropEl);
	      }
	    }

	    var $pageContentEl;
	    function scrollToOpen() {
	      var $scrollEl = $$1(sheet.params.scrollToEl).eq(0);
	      if ($scrollEl.length === 0) { return; }
	      $pageContentEl = $scrollEl.parents('.page-content');
	      if ($pageContentEl.length === 0) { return; }

	      var paddingTop = parseInt($pageContentEl.css('padding-top'), 10);
	      var paddingBottom = parseInt($pageContentEl.css('padding-bottom'), 10);
	      var pageHeight = $pageContentEl[0].offsetHeight - paddingTop - $el.height();
	      var pageScrollHeight = $pageContentEl[0].scrollHeight - paddingTop - $el.height();
	      var pageScroll = $pageContentEl.scrollTop();

	      var newPaddingBottom;

	      var scrollElTop = ($scrollEl.offset().top - paddingTop) + $scrollEl[0].offsetHeight;
	      if (scrollElTop > pageHeight) {
	        var scrollTop = (pageScroll + scrollElTop) - pageHeight;
	        if (scrollTop + pageHeight > pageScrollHeight) {
	          newPaddingBottom = ((scrollTop + pageHeight) - pageScrollHeight) + paddingBottom;
	          if (pageHeight === pageScrollHeight) {
	            newPaddingBottom = $el.height();
	          }
	          $pageContentEl.css({
	            'padding-bottom': (newPaddingBottom + "px"),
	          });
	        }
	        $pageContentEl.scrollTop(scrollTop, 300);
	      }
	    }

	    function scrollToClose() {
	      if ($pageContentEl && $pageContentEl.length > 0) {
	        $pageContentEl.css({
	          'padding-bottom': '',
	        });
	      }
	    }
	    function handleClick(e) {
	      var target = e.target;
	      var $target = $$1(target);
	      if ($target.closest(sheet.el).length === 0) {
	        if (
	          sheet.params.closeByBackdropClick &&
	          sheet.params.backdrop &&
	          sheet.backdropEl &&
	          sheet.backdropEl === target
	        ) {
	          sheet.close();
	        } else if (sheet.params.closeByOutsideClick) {
	          sheet.close();
	        }
	      }
	    }

	    sheet.on('sheetOpen', function () {
	      if (sheet.params.scrollToEl) {
	        scrollToOpen();
	      }
	    });
	    sheet.on('sheetOpened', function () {
	      if (sheet.params.closeByOutsideClick || sheet.params.closeByBackdropClick) {
	        app.on('click', handleClick);
	      }
	    });
	    sheet.on('sheetClose', function () {
	      if (sheet.params.scrollToEl) {
	        scrollToClose();
	      }
	      if (sheet.params.closeByOutsideClick || sheet.params.closeByBackdropClick) {
	        app.off('click', handleClick);
	      }
	    });

	    Utils.extend(sheet, {
	      app: app,
	      $el: $el,
	      el: $el[0],
	      $backdropEl: $backdropEl,
	      backdropEl: $backdropEl && $backdropEl[0],
	      type: 'sheet',
	    });

	    $el[0].f7Modal = sheet;

	    return sheet;
	  }

	  if ( Modal$$1 ) Sheet.__proto__ = Modal$$1;
	  Sheet.prototype = Object.create( Modal$$1 && Modal$$1.prototype );
	  Sheet.prototype.constructor = Sheet;

	  return Sheet;
	}(Modal));

	var Sheet$1 = {
	  name: 'sheet',
	  params: {
	    sheet: {
	      closeByBackdropClick: true,
	      closeByOutsideClick: false,
	    },
	  },
	  static: {
	    Sheet: Sheet,
	  },
	  create: function create() {
	    var app = this;
	    if (!app.passedParams.sheet || app.passedParams.sheet.backdrop === undefined) {
	      app.params.sheet.backdrop = app.theme === 'md';
	    }
	    app.sheet = Utils.extend(
	      {},
	      ModalMethods({
	        app: app,
	        constructor: Sheet,
	        defaultSelector: '.sheet-modal.modal-in',
	      })
	    );
	  },
	  clicks: {
	    '.sheet-open': function openSheet($clickedEl, data) {
	      if ( data === void 0 ) data = {};

	      var app = this;
	      if ($$1('.sheet-modal.modal-in').length > 0 && data.sheet && $$1(data.sheet)[0] !== $$1('.sheet-modal.modal-in')[0]) {
	        app.sheet.close('.sheet-modal.modal-in');
	      }
	      app.sheet.open(data.sheet, data.animate);
	    },
	    '.sheet-close': function closeSheet($clickedEl, data) {
	      if ( data === void 0 ) data = {};

	      var app = this;
	      app.sheet.close(data.sheet, data.animate);
	    },
	  },
	};

	Framework7.use([
	  Dialog$1,
	  Popup$1,
	  LoginScreen$1,
	  Popover$1,
	  Actions$1,
	  Toast$1,
	  Preloader$1,
	  Progressbar$1,
	  Swipeout$1,
	  VirtualList$1,
	  Tabs,
	  Panel$1,
	  Card,
	  Form,
	  Input$1,
	  Checkbox,
	  Radio,
	  Toggle$1,
	  SmartSelect$1,
	  InfiniteScroll$1,
	  Lazy$1,
	  Searchbar$1,
	  Calendar$1,
	  Messages$1,
	  Messagebar$1,
	  Swiper$1,
	  PhotoBrowser$1,
	  Modal$1,
	  Sheet$1 ]);

	// Brief Instance
	//
	var isDesktop = Framework7.device.desktop;
	var isIpad = Framework7.device.ipad;
	var ratio = window.devicePixelRatio || 1;
	var screen$1 = {
	  width : window.screen.width * ratio,
	  height : window.screen.height * ratio
	};

	var Brief$1 = {
	  isDesktop: isDesktop,
	  isBigScreen: isDesktop || isIpad || screen$1.width >= 1500,
	  isLive: window.location.href.indexOf('localhost') === -1,
	  isPhoneGap: !!window.cordova,
	  isCordova: !!window.cordova,
	  isIPhoneX: Framework7.device.ios && screen$1.width === 1125 && screen$1.height === 2436,
	  isLoggedIn: function isLoggedIn() {
	    return !!window.localStorage.getItem('access_token');
	  },
	  token: null,
	  device_id: null,
	  app: {},
	  bus: {},
	  events: new Vue(),
	  f7: {},
	  domain: window.cordova ? config$1.path.websiteRoot : '',
	  api: ((window.cordova ? config$1.path.websiteRoot : '') + "/api"),
	  imagePath: config$1.path.image,
	  openInSystemBrowser: function openInSystemBrowser(url) {
	    if (Brief$1.isCordova) {
	      if (window.cordova && window.cordova.InAppBrowser) {
	        window.cordova.InAppBrowser.open(url, '_system', 'location=no,toolbarcolor=#7113ff,closebuttoncolor=#ffffff,navigationbuttoncolor=#ffffff');
	      }
	    } else {
	      window.open(url, '_blank');
	    }
	  },
	  onLine: function onLine() {
	    if (Brief$1.isCordova && window.Connection) {
	      return window.navigator.connection.type !== window.Connection.NONE;
	    }
	    return window.navigator.onLine;
	  },
	  sendError: function sendError(message) {
	    var data = {
	      access_token: window.localStorage.getItem('access_token'),
	      device_id: window.localStorage.getItem('device_id'),
	      error: message,
	    };
	    Framework7.request({
	      url: ((Brief$1.api) + "/error/send"),
	      method: 'POST',
	      dataType: 'json',
	      processData: false,
	      contentType: 'application/json',
	      data: JSON.stringify(data),
	      crossDomain: true,
	    });
	  },
	  notify: function notify(title, text) {
	    if (!Brief$1.f7) { return; }
	    Brief$1.f7.toast.create({
	      text: ("" + ((title + "<br>") || '') + (text || '')),
	      closeButton: true,
	      closeButtonText: 'Ok',
	      closeTimeout: 4000,
	    }).open();
	  },
	  closeNotification: function closeNotification() {
	    if (!Brief$1.f7) { return; }
	    Brief$1.f7.toast.close();
	  },
	  showProgress: function showProgress(el) {
	    var $el = $$1(el);
	    if ($el.find('.progressbar, .progressbar-infinite').length) 
	      { return; }
	    var $navbar = $el.find('.navbar');
	    if (!$navbar.length)
	      { return; }
	    var $progressbarEl = $$1('<div class="progressbar-infinite progressbar-in"></div>');
	    $navbar.append($progressbarEl);
	    Brief$1.f7.progressbar.show($progressbarEl);
	    return $progressbarEl;
	  },
	  hideProgress: function hideProgress(el) {
	    var $el = $$1(el);
	    var $progressbarEl = $el.find('.progressbar, .progressbar-infinite');
	    if (!$el.length)
	      { return; }
	    Brief$1.f7.progressbar.hide($progressbarEl);
	  },
	  showPreloader: function showPreloader(text) {
	    Brief$1.f7.dialog.preloader(text);
	  },
	  hidePreloader: function hidePreloader() {
	    Brief$1.f7.dialog.close();
	  },
	  alert: function alert(text, title) {
	    Brief$1.f7.dialog.alert(text, title);
	  }
	};

	// Online/offline
	(Brief$1.isCordova ? document : window).addEventListener('online', function () {
	  Brief$1.events.$emit('online');
	}, false);
	(Brief$1.isCordova ? document : window).addEventListener('offline', function () {
	  Brief$1.events.$emit('offline');
	}, false);

	var Utils$1 = {
	  isUndefined: function isUndefined(value) {
	    if (value === undefined) { return true; }
	    if (value === null) { return true; }
	    if (value === '') { return true; }
	    if (value.trim && value.trim() === '') { return true; }

	    return false;
	  },
	  newGuid: function newGuid() {
	    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
	      var r = Math.random() * 16 | 0; // eslint-disable-line
	      var v = c === 'x' ? r : (r & 0x3 | 0x8); // eslint-disable-line
	      return v.toString(16);
	    });
	  },

	  getRandomNumber: function getRandomNumber() {
	    return Math.floor(Math.random() * 99999) + 1000000;
	  },

	  resetCursor: function resetCursor(input) {
	    if (input.setSelectionRange) {
	      input.focus();
	      input.setSelectionRange(0, 0);
	    } else if (input.createTextRange) {
	      var range = input.createTextRange();
	      range.collapse(true);
	      range.moveEnd('character', 0);
	      range.moveStart('character', 0);
	      range.select();
	    }
	  },

	  isEmail: function isEmail(email) {
	    // eslint-disable-next-line
	    var re = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
	    return re.test(email);
	  },

	  setTimeoutTrigger: function setTimeoutTrigger(eventName, data) {
	    setTimeout(function () {
	      Brief$1.events.$emit(eventName, data);
	    }, 500);
	  },

	  callFunctionWithDelay: function callFunctionWithDelay(fn, delayInMili) {
	    setTimeout(function () {
	      fn();
	    }, delayInMili);
	  },

	  clone: function clone(obj) {
	    if (obj == null || typeof obj !== 'object') { return obj; }
	    var copy = obj.constructor();
	    // eslint-disable-next-line
	    for (var attr in obj) {
	      if (obj.hasOwnProperty(attr)) { copy[attr] = obj[attr]; } // eslint-disable-line
	    }
	    return copy;
	  },

	  mobileDevice: function mobileDevice() {
	    var device = Framework7.device;
	    return device.android || device.androidChrome || device.ios || device.ipad || device.iphone;
	  },

	  getMilisecondsFromDate: function getMilisecondsFromDate(dateString) {
	    if (!dateString) { return dateString; }
	    if (typeof dateString !== 'string') { return dateString.getTime(); }
	    if (dateString.endsWith('Z')) { return new Date(dateString).getTime(); }
	    return parseInt(dateString.findReplace('/Date(', '').findReplace(')/', ''), 10);
	  },

	  orderByDate: function orderByDate(list, descending, dateField) {
	    if (Utils$1.isUndefined(list)) { return null; }
	    return list.sort(function (a, b) {
	      var idA = new Date(Utils$1.getMilisecondsFromDate(a[dateField] || new Date()));
	      var idB = new Date(Utils$1.getMilisecondsFromDate(b[dateField] || new Date()));
	      if (descending) { return idB - idA; }
	      return idA - idB;
	    });
	  },

	  stringToDate: function stringToDate(value) {
	    return new Date(parseInt(value.replace('/Date(', '').replace(')/', ''), 10));
	  },

	  stringToMvcDate: function stringToMvcDate(value) {
	    var date = Utils$1.stringToDate(value);
	    return date.toISOString();
	  },

	  textToHtml: function textToHtml(text) {
	    if (!text) { return null; }
	    return text.replace(new RegExp('\r?\n', 'g'), '<br />'); // eslint-disable-line
	  },

	  escapeHtml: function escapeHtml(text) {
	    return text
	      .replace(/</g, '&lt;')
	      .replace(/>/g, '&gt;')
	      .replace(/"/g, '&quot;')
	      .replace(/'/g, '&#039;');
	  },

	  getUtcDateString: function getUtcDateString() {
	    var now = new Date();
	    return now.toISOString();
	  },

	  getUtcMvcString: function getUtcMvcString() {
	    var utcDate = Utils$1.getUtcDate();
	    return ("/Date(" + (utcDate.getTime()) + ")/");
	  },

	  highlight: function highlight(searchString, text) {
	    var r = new RegExp(("(" + searchString + ")"), 'gi');
	    return text.replace(r, '<span class="highlight">$1</span>');
	  },

	  detectIE: function detectIE() {
	    var ua = window.navigator.userAgent;
	    var msie = ua.indexOf('MSIE ');
	    if (msie > 0) {
	      // IE 10 or older => return version number
	      return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
	    }

	    var trident = ua.indexOf('Trident/');
	    if (trident > 0) {
	      // IE 11 => return version number
	      var rv = ua.indexOf('rv:');
	      return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
	    }

	    // other browser
	    return false;
	  },

	  // Utils
	  generateUUID_segment: function generateUUID_segment() {
	    return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
	  },
	  generateUUID: function generateUUID() {
	    var s = Utils$1.generateUUID_segment;
	    return ((s() + s()) + "-" + (s()) + "-" + (s()) + "-" + (s()) + "-" + (s()) + (s()) + (s()));
	  },
	  getDeviceId: function getDeviceId() {
	    var id = window.localStorage.getItem('device_id');
	    if (!id) {
	      id = window.device && window.device.uuid ? window.device.uuid : Utils$1.generateUUID();
	      window.localStorage.setItem('device_id', id);
	    }
	    return id;
	  },
	  dataURItoBlob: function dataURItoBlob(dataURI) {
	    // convert base64 to raw binary data held in a string
	    // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
	    var byteString = window.atob(dataURI.split(',')[1]);

	    // separate out the mime component
	    var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

	    // write the bytes of the string to an ArrayBuffer
	    var ab = new ArrayBuffer(byteString.length);

	    // create a view into the buffer
	    var ia = new Uint8Array(ab);

	    // set the bytes of the buffer to the correct values
	    for (var i = 0; i < byteString.length; i += 1) {
	      ia[i] = byteString.charCodeAt(i);
	    }

	    // write the ArrayBuffer to a blob, and you're done
	    var blob = new window.Blob([ab], { type: mimeString });
	    return blob;
	  },
	  channelTypes: function channelTypes(type) {
	    var map = {
	      facebook: 'facebookstream',
	      email: 'emailstream',
	      room: 'roomstream',
	      website: 'websitechannel',
	      instagram: 'instagramchannel',
	    };
	    return map[type] || type;
	  },
	  capitalize: function capitalize(str) {
	    return str.split(' ')
	      .map(function (word) { return word[0].toUpperCase() + word.substring(1, word.length); })
	      .join(' ');
	  },
	  getLanguages: function getLanguages() {
	    return [{
	      lang: 'ar',
	      name: 'Arabic',
	    }, {
	      lang: 'bs',
	      name: 'Bosnian',
	    }, {
	      lang: 'bg',
	      name: 'Bulgarian',
	    }, {
	      lang: 'ca',
	      name: 'Catalan',
	    }, {
	      lang: 'zh',
	      name: 'Chinese',
	    }, {
	      lang: 'hr',
	      name: 'Croatian',
	    }, {
	      lang: 'cs',
	      name: 'Czech',
	    }, {
	      lang: 'da',
	      name: 'Danish',
	    }, {
	      lang: 'nl',
	      name: 'Dutch',
	    }, {
	      lang: 'en',
	      name: 'English',
	    }, {
	      lang: 'et',
	      name: 'Estonian',
	    }, {
	      lang: 'fi',
	      name: 'Finnish',
	    }, {
	      lang: 'fr',
	      name: 'French',
	    }, {
	      lang: 'de',
	      name: 'German',
	    }, {
	      lang: 'el',
	      name: 'Greek',
	    }, {
	      lang: 'he',
	      name: 'Hebrew',
	    }, {
	      lang: 'hu',
	      name: 'Hungarian',
	    }, {
	      lang: 'id',
	      name: 'Indonesian',
	    }, {
	      lang: 'it',
	      name: 'Italian',
	    }, {
	      lang: 'ja',
	      name: 'Japanese',
	    }, {
	      lang: 'ko',
	      name: 'Korean',
	    }, {
	      lang: 'lv',
	      name: 'Latviski',
	    }, {
	      lang: 'lt',
	      name: 'Lithuanian',
	    }, {
	      lang: 'mn',
	      name: 'Mongolian',
	    }, {
	      lang: 'no',
	      name: 'Norwegian',
	    }, {
	      lang: 'pl',
	      name: 'Polish',
	    }, {
	      lang: 'pt',
	      name: 'Portuguese',
	    }, {
	      lang: 'ro',
	      name: 'Romanian',
	    }, {
	      lang: 'ru',
	      name: 'Russian',
	    }, {
	      lang: 'sr',
	      name: 'Serbian',
	    }, {
	      lang: 'sl',
	      name: 'Slovenian',
	    }, {
	      lang: 'es',
	      name: 'Spanish',
	    }, {
	      lang: 'sv',
	      name: 'Swedish',
	    }, {
	      lang: 'tr',
	      name: 'Turkish',
	    }, {
	      lang: 'vi',
	      name: 'Vietnamese',
	    }];
	  },
	  getParameterByName: function getParameterByName(name, url) {
	    name = name.replace(/[\[\]]/g, '\\$&');
	    var regex = new RegExp(("[?&]" + name + "(=([^&#]*)|&|#|$)"));


	    var results = regex.exec(url);
	    if (!results) { return null; }
	    if (!results[2]) { return ''; }
	    return decodeURIComponent(results[2].replace(/\+/g, ' '));
	  },
	  canAddConversation: function canAddConversation(conversations, conv) {
	    if (conversations.length === 0 || conversations.length < 30) {
	      return true;
	    }
	    var oldestConversation = lodash.orderBy(conversations, function (x) { return x.sendDate; })[0];
	    if (!oldestConversation.sendDate || !conv.sendDate) {
	      return true;
	    }
	    return conv.sendDate >= oldestConversation.sendDate;
	  },
	  loopEvery: function loopEvery(intervalDelay, func) {
	    func();
	    var loopIntervalRef = setInterval(function () {
	      func();
	    }, intervalDelay);
	  
	    return loopIntervalRef;
	  },
	  extend: Framework7.utils.extend,
	};

	function Prototypes () {
	  var String = window.String;
	  if (typeof String.prototype.startsWith !== 'function') {
	    String.prototype.startsWith = function startsWith(str) {
	      return this.indexOf(str) === 0;
	    };
	  }

	  if (typeof String.prototype.endsWith !== 'function') {
	    String.prototype.endsWith = function endsWith(suffix) {
	      return this.indexOf(suffix, this.length - suffix.length) !== -1;
	    };
	  }

	  if (typeof String.prototype.contains !== 'function') {
	    String.prototype.contains = function contains(str) {
	      return this.indexOf(str) !== -1;
	    };
	  }

	  if (!String.prototype.trim) {
	    String.prototype.trim = function trim() {
	      return this.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
	    };
	  }

	  if (typeof String.prototype.findReplace !== 'function') {
	    String.prototype.findReplace = function findReplace(searchString, replaceString) {
	      return this.contains(searchString) ? this.replace(searchString, replaceString) : this;
	    };
	  }
	}

	/* eslint no-bitwise: ["off"] */
	/* eslint no-unused-expressions: ["off"] */
	/* eslint no-param-reassign: ["off"] */
	/* eslint prefer-rest-params: ["off"] */
	/* eslint no-extend-native: ["off"] */
	/* eslint no-restricted-syntax: ["off"] */
	/* eslint no-void: ["off"] */
	/* eslint no-prototype-builtins: ["off"] */

	function Shims () {
	  if (typeof Object.assign !== 'function') {
	    Object.assign = function assign(target) {
	      var arguments$1 = arguments;

	      if (target == null) {
	        throw new TypeError('Cannot convert undefined or null to object');
	      }

	      target = Object(target);
	      for (var index = 1; index < arguments.length; index += 1) {
	        var source = arguments$1[index];
	        if (source != null) {
	          for (var key in source) {
	            if (Object.prototype.hasOwnProperty.call(source, key)) {
	              target[key] = source[key];
	            }
	          }
	        }
	      }
	      return target;
	    };
	  }

	  if (!Array.prototype.findIndex) {
	    Object.defineProperty(Array.prototype, 'findIndex', {
	      value: function value(predicate) {
	        if (this == null) {
	          throw new TypeError('Array.prototype.findIndex called on null or undefined');
	        }
	        if (typeof predicate !== 'function') {
	          throw new TypeError('predicate must be a function');
	        }
	        var list = Object(this);
	        var length = list.length >>> 0;
	        var thisArg = arguments[1];
	        var value;

	        for (var i = 0; i < length; i += 1) {
	          value = list[i];
	          if (predicate.call(thisArg, value, i, list)) {
	            return i;
	          }
	        }
	        return -1;
	      },
	    });
	  }

	  if (!Array.prototype.find) {
	    Object.defineProperty(Array.prototype, 'find', {
	      value: function value(predicate) {
	        if (this === null) {
	          throw new TypeError('Array.prototype.find called on null or undefined');
	        }
	        if (typeof predicate !== 'function') {
	          throw new TypeError('predicate must be a function');
	        }
	        var list = Object(this);
	        var length = list.length >>> 0;
	        var thisArg = arguments[1];
	        var value;

	        for (var i = 0; i < length; i += 1) {
	          value = list[i];
	          if (predicate.call(thisArg, value, i, list)) {
	            return value;
	          }
	        }
	        return undefined;
	      },
	    });
	  }

	  if (!Array.prototype.filter) {
	    Array.prototype.filter = function filter(fun/* , thisArg */) {
	      if (this === void 0 || this === null) {
	        throw new TypeError();
	      }

	      var t = Object(this);
	      var len = t.length >>> 0;
	      if (typeof fun !== 'function') {
	        throw new TypeError();
	      }

	      var res = [];
	      var thisArg = arguments.length >= 2 ? arguments[1] : void 0;
	      for (var i = 0; i < len; i += 1) {
	        if (i in t) {
	          var val = t[i];

	          if (fun.call(thisArg, val, i, t)) {
	            res.push(val);
	          }
	        }
	      }

	      return res;
	    };
	  }

	  // Production steps of ECMA-262, Edition 5, 15.4.4.19
	  // Reference: http://es5.github.io/#x15.4.4.19
	  if (!Array.prototype.map) {
	    Array.prototype.map = function map(callback, thisArg) {
	      var T;
	      var k;

	      if (this == null) {
	        throw new TypeError(' this is null or not defined');
	      }

	      var O = Object(this);

	      var len = O.length >>> 0;

	      if (typeof callback !== 'function') {
	        throw new TypeError((callback + " is not a function"));
	      }

	      if (arguments.length > 1) {
	        T = thisArg;
	      }

	      var A = new Array(len);

	      k = 0;

	      while (k < len) {
	        var kValue = (void 0);
	        var mappedValue = (void 0);
	        if (k in O) {
	          kValue = O[k];
	          mappedValue = callback.call(T, kValue, k, O);
	          A[k] = mappedValue;
	        }
	        k += 1;
	      }

	      return A;
	    };
	  }

	  if (!Array.equals) {
	    Array.equals = function equals(arr1, arr2) {
	      // if the other array is a falsy value, return
	      if (!arr2) { return false; }

	      // compare lengths - can save a lot of time
	      if (arr1.length !== arr2.length) { return false; }

	      for (var i = 0, l = arr1.length; i < l; i += 1) {
	        // Check if we have nested arrays
	        if (Array.isArray(arr1[i]) && Array.isArray(arr2[i])) {
	          // recurse into the nested arrays
	          if (!Array.equals(arr1[i], arr2[i])) { return false; }
	        } else if (arr1[i] instanceof Object && arr2[i] instanceof Object) {
	          // recurse into another objects
	          // console.log("Recursing to compare ", this[propName],"with",object2[propName], " both named \""+propName+"\"");
	          if (!Object.equals(arr1[i], arr2[i])) { return false; }
	        } else if (arr1[i] !== arr2[i]) {
	          // Warning - two different object instances will never be equal: {x:20} != {x:20}
	          return false;
	        }
	      }
	      return true;
	    };
	  }
	  if (!Object.equals) {
	    Object.equals = function equals(object1, object2) {
	      var propName;
	      for (propName in object1) {
	        if (object1.hasOwnProperty(propName) !== object2.hasOwnProperty(propName)) {
	          return false;
	        } if (typeof object1[propName] !== typeof object2[propName]) {
	          return false;
	        }
	      }
	      for (propName in object2) {
	        if (object1.hasOwnProperty(propName) !== object2.hasOwnProperty(propName)) {
	          return false;
	        } if (typeof object1[propName] !== typeof object2[propName]) {
	          return false;
	        }
	        if (!object1.hasOwnProperty(propName)) { continue; } // eslint-disable-line

	        if (object1[propName] instanceof Array && object2[propName] instanceof Array) {
	          if (!Array.equals(object1[propName], object2[propName])) { return false; }
	        } else if (object1[propName] instanceof Object && object2[propName] instanceof Object) {
	          if (!Object.equals(object1[propName], object2[propName])) { return false; }
	        } else if (object1[propName] !== object2[propName]) {
	          return false;
	        }
	      }
	      return true;
	    };
	  }

	  if (!('classList' in document.documentElement) && Object.defineProperty && typeof HTMLElement !== 'undefined') {
	    Object.defineProperty(window.HTMLElement.prototype, 'classList', {
	      get: function get() {
	        var self = this;
	        function update(fn) {
	          return function (value) {
	            var classes = self.className.split(/\s+/);
	            var index = classes.indexOf(value);

	            fn(classes, index, value);
	            self.className = classes.join(' ');
	          };
	        }

	        var ret = {
	          add: update(function (classes, index, value) {
	            ~index || classes.push(value);
	          }),

	          remove: update(function (classes, index) {
	            ~index && classes.splice(index, 1);
	          }),

	          toggle: update(function (classes, index, value) {
	            ~index ? classes.splice(index, 1) : classes.push(value);
	          }),

	          contains: function contains(value) {
	            return !!~self.className.split(/\s+/).indexOf(value);
	          },

	          item: function item(i) {
	            return self.className.split(/\s+/)[i] || null;
	          },
	        };

	        Object.defineProperty(ret, 'length', {
	          get: function get() {
	            return self.className.split(/\s+/).length;
	          },
	        });

	        return ret;
	      },
	    });
	  }
	}

	var UniversalLinks = {
	  onLogin: function onLogin() {},
	  subscribe: function subscribe() {
	    if (!window.universalLinks) {
	      return;
	    }
	    window.universalLinks.subscribe('deeplink', function (eventData) {
	      if (Brief$1 && Brief$1.app && Brief$1.app.$off) {
	        Brief$1.app.$off('login', UniversalLinks.onLogin);
	      }

	      var path = eventData.path;
	      var params = eventData.params;

	      if (path && path.indexOf('google/login') > -1) {
	        return;
	      }

	      var query = Object.keys(params)
	        .map(function (key) { return (key + "=" + (params[key])); })
	        .join('&');

	      var url = (path + "/" + (query.length ? ("?" + query) : '')).replace('//', '/');

	      UniversalLinks.handle(url);
	    });
	  },
	  handle: function handle(url) {
	    if (Brief$1.isLoggedIn()) {
	      // Logged in and passing to login, no sense: return
	      if (url.indexOf('/account/') === 0) { return; }
	      if (url.indexOf('/user/') >= 0 || url.indexOf('/contact/') >= 0) {
	        // Open right panel
	        Brief$1.f7.panel.open('right');
	        Brief$1.viewRight.router.navigate(url);
	        return;
	      }
	      // Otherwise load in main view
	      var reloadAll = false;

	      var newUrlParts = url.split('/').filter(function (part) { return part !== ''; });
	      var oldUrlParts = Brief$1.viewMain.router.url.split('/').filter(function (part) { return part !== ''; });
	      if (newUrlParts[0] !== oldUrlParts[0] && newUrlParts[1] !== oldUrlParts[1]) {
	        reloadAll = true;
	      }

	      if (url.includes('team/billing')) {
	        return;
	      }
	      Brief$1.viewMain.router.navigate(url, { reloadAll: reloadAll });
	    } else {
	      if (url.indexOf('/account/') < 0) {
	        // Need to be loaded after log in
	        if (Brief$1.app && Brief$1.app.$once) {
	          UniversalLinks.onLogin = function () {
	            setTimeout(function () {
	              UniversalLinks.handle(url);
	            }, 1000);
	          };
	          Brief$1.app.$once('login', UniversalLinks.onLogin);
	        }
	        return;
	      }
	      // Load in account view
	      Brief$1.viewLogin.router.navigate(url, { reloadCurrent: true });
	    }
	  },
	};

	function UniversalLinks$1 () {
	  UniversalLinks.subscribe();
	}

	function PhoneGap () {
	  var isResuming = false;
	  function resume() {
	    isResuming = true;
	    setTimeout(function () {
	      isResuming = false;
	    }, 1000);

	    Brief$1.events.$emit('sync');
	  }

	  function initResumeHandler() {
	    document.addEventListener('resume', resume, false);
	    document.addEventListener('active', resume, false);
	  }

	  function initBrowser() {
	    $$1(document).on('click', 'a.external[target="_blank"]', function onClick(e) {
	      e.stopPropagation();
	      e.preventDefault();
	      window.open($$1(this).attr('href'), '_blank', 'toolbarposition=top,enableViewportScale=yes');
	    });
	  }

	  // Keyboard Fixes
	  var keyboardTimeout;

	  var scrolledOnKeyboardVisible;

	  // eslint-disable-next-line
	  function scrollInputIntoView(inputEl, animated, keyboardHeight) {
	    if ( animated === void 0 ) animated = false;
	    if ( keyboardHeight === void 0 ) keyboardHeight = 0;

	    if (scrolledOnKeyboardVisible) { return; }
	    scrolledOnKeyboardVisible = true;
	    if (!inputEl) { return; }
	    var $inputEl = $$1(inputEl);
	    if (!$inputEl.is('input, select, textarea') || $inputEl.parents('.page-content').length < 0) {
	      return;
	    }
	    var $scrollableEl = $inputEl.parents('.page-content, .panel').eq(0);
	    if (!$scrollableEl.length) {
	      return;
	    }
	    var contentHeight = $scrollableEl[0].offsetHeight;
	    var contentScrollTop = $scrollableEl[0].scrollTop;
	    var contentScrollHeight = $scrollableEl[0].scrollHeight;
	    var contentPaddingTop = parseInt($scrollableEl.css('padding-top'), 10);
	    var contentPaddingBottom = parseInt($scrollableEl.css('padding-bottom'), 10);
	    var contentOffsetTop = $scrollableEl.offset().top - contentScrollTop;

	    var inputOffsetTop = $inputEl.offset().top - contentOffsetTop;
	    var inputHeight = $inputEl[0].offsetHeight;

	    var min = (inputOffsetTop + contentScrollTop) - contentPaddingTop;
	    var max = ((inputOffsetTop + contentScrollTop) - contentHeight) + contentPaddingBottom + inputHeight;
	    var centerPosition = min + ((max - min) / 2);
	    centerPosition = Math.min(contentScrollHeight - contentHeight, Math.max(centerPosition, 0));

	    var scrollable = centerPosition !== contentScrollTop;

	    if (scrollable) {
	      $scrollableEl.scrollTop(centerPosition, 250);
	      if ($inputEl.is('input, textarea')) {
	        // eslint-disable-next-line
	        inputEl.value = (inputEl.value) + "_fix_ios_focus_";
	        // eslint-disable-next-line
	        inputEl.value = inputEl.value.replace('_fix_ios_focus_', '');
	      }
	    }
	  }

	  function keyboardShowHandler(e) {
	    if (isResuming)
	      { return; }
	    
	    stopScrollToBottom();
	    clearTimeout(keyboardTimeout);
	    keyboardTimeout = setTimeout(function () {
	      document.body.scrollTop = 0;

	      // Scroll input to View in iOS
	      if (!scrolledOnKeyboardVisible) {
	        scrollInputIntoView(document.activeElement, false, e.keyboardHeight);
	      }

	      // Restore messages images
	      setTimeout(function () {
	        $$1('.brief-messages .message-attachments .message-image').each(function updateMessageImage() {
	          var p = $$1(this).parent();
	          var m = $$1(this).remove();
	          p.append(m);
	        });
	      }, 0);
	    }, 0);
	  }

	  function keyboardHideHandler() {
	    if (isResuming)
	      { return; }
	    
	    stopScrollToBottom();
	    clearTimeout(keyboardTimeout);
	    keyboardTimeout = setTimeout(function () {
	      var isIos = window.device.platform.toLowerCase() === 'ios';
	      if (isIos) { window.Keyboard.hideFormAccessoryBar(true); }
	      // Unset scrolled flag
	      scrolledOnKeyboardVisible = false;
	      // Restore messages images
	      setTimeout(function () {
	        $$1('.messages .message-pic .message-image').each(function updateMessageImage() {
	          var p = $$1(this).parent();
	          var m = $$1(this).remove();
	          p.append(m);
	        });
	      }, 0);
	    }, 0);
	  }

	  function stopLoop(loopIntervalRef) {
	    clearInterval(loopIntervalRef);
	  }

	  var scrollDelay = 10;
	  var scrollMax = 10000;
	  var scrollLoopRef;
	  function scrollToBottom() {
	    stopScrollToBottom();

	    var messagesScrollContainer = getMessagesScrollContainer();
	    if (messagesScrollContainer.length === 0)
	      { return; }

	    scrollLoopRef = Utils$1.loopEvery(scrollDelay, function () {
	      messagesScrollContainer.scrollTop(scrollMax);
	    });
	  }

	  function getMessagesScrollContainer() {
	    return $$1('.messages-content');
	  }

	  function stopScrollToBottom() {
	    stopLoop(scrollLoopRef);
	  }

	  function initKeyboard() {
	    var isIos = window.device.platform.toLowerCase() === 'ios';
	    if (isIos) {
	      window.Keyboard.hideFormAccessoryBar(true);
	      $$1(document).on('touchstart', 'input, textarea, select', function (e) {
	        var nodeName = e.target.nodeName.toLowerCase();
	        if (nodeName === 'select') {
	          window.Keyboard.hideFormAccessoryBar(false);
	        } else {
	          window.Keyboard.hideFormAccessoryBar(true);
	        }
	      }, true);
	    }

	    window.addEventListener('keyboardDidShow', keyboardShowHandler);
	    window.addEventListener('keyboardDidHide', keyboardHideHandler);

	    window.addEventListener('keyboardWillShow', function (e) { 
	      scrollToBottom();
	      $$1('html').addClass('keyboard-show'); 
	      if (isIos) { $$1('body').css('height', ("calc(100% - " + (e.keyboardHeight) + "px)")); }
	      setTimeout(function () {
	        stopScrollToBottom();
	      }, 1000);
	    });

	    window.addEventListener('keyboardWillHide', function (e) { 
	      scrollToBottom();
	      if (isIos) { $$1('body').css('height', '100%'); }
	      setTimeout(function () {
	        $$1('html').removeClass('keyboard-show');
	      }, 50);
	      setTimeout(function () {
	        stopScrollToBottom();
	      }, 1000);
	    });
	  }

	  function fixStatusBarForAndroid() {
	    if (window.device.platform.toLowerCase() !== 'android')
	      { return; }
	    
	    if (!window.StatusBar)
	      { return; }

	    window.StatusBar.overlaysWebView(false);
	    window.StatusBar.backgroundColorByHexString('#f7f7f8');
	    window.StatusBar.styleDefault();
	  }

	  function init() {
	    initResumeHandler();
	    initBrowser();
	    initKeyboard();
	    fixStatusBarForAndroid();
	  }
	  
	  try {
	    init();
	  } catch (err) {
	    try {
	      Brief$1.sendError(("Failed to init phonegap: " + (JSON.stringify(err))));
	    } catch (e) {
	      // failed
	    }
	  }
	}

	/* eslint no-param-reassign: ["off"] */
	/* eslint no-console: ["off"] */
	var facebookConnectPlugin = {
	  getLoginStatus: function getLoginStatus(s, f) {
	    var isSuccess = false;
	    setTimeout(function () {
	      if (!isSuccess) {
	        f('Make sure you logged into your account and have admin permissions for this Page');
	      }
	    }, 10000);

	    var FB = window.FB;

	    // Try will catch errors when SDK has not been init
	    try {
	      FB.getLoginStatus(function (response) {
	        isSuccess = true;
	        s(response);
	      });
	    } catch (error) {
	      isSuccess = true;
	      if (!f) {
	        console.error(error.message);
	      } else {
	        f(error.message);
	      }
	    }
	  },

	  showDialog: function showDialog(options, s, f) {
	    var FB = window.FB;

	    if (!options.name) {
	      options.name = '';
	    }
	    if (!options.message) {
	      options.message = '';
	    }
	    if (!options.caption) {
	      options.caption = '';
	    }
	    if (!options.description) {
	      options.description = '';
	    }
	    if (!options.href) {
	      options.href = '';
	    }
	    if (!options.picture) {
	      options.picture = '';
	    }

	    // Try will catch errors when SDK has not been init
	    try {
	      FB.ui(
	        options,
	        function (response) {
	          if (response && (response.request || !response.error_code)) {
	            s(response);
	          } else {
	            f(response);
	          }
	        }
	      );
	    } catch (error) {
	      if (!f) {
	        console.error(error.message);
	      } else {
	        f(error.message);
	      }
	    }
	  },
	  // Attach this to a UI element, this requires user interaction.
	  login: function login(permissions, s, f) {
	    var FB = window.FB;

	    // JS SDK takes an object here but the native SDKs use array.
	    var permissionObj = {};
	    if (permissions && permissions.length > 0) {
	      permissionObj.scope = permissions.toString();
	    }

	    FB.login(function (response) {
	      if (response.authResponse) {
	        s(response);
	      } else {
	        f(response.status);
	      }
	    }, permissionObj);
	  },

	  getAccessToken: function getAccessToken(s, f) {
	    var FB = window.FB;

	    var response = FB.getAccessToken();
	    if (!response) {
	      if (!f) {
	        console.error('NO_TOKEN');
	      } else {
	        f('NO_TOKEN');
	      }
	    } else {
	      s(response);
	    }
	  },

	  logEvent: function logEvent(eventName, params, valueToSum, s) {
	    // AppEvents are not avaliable in JS.
	    s();
	  },

	  logPurchase: function logPurchase(value, currency, s) {
	    // AppEvents are not avaliable in JS.
	    s();
	  },

	  logout: function logout(s, f) {
	    var FB = window.FB;

	    // Try will catch errors when SDK has not been init
	    try {
	      FB.logout(function (response) {
	        s(response);
	      });
	    } catch (error) {
	      if (!f) {
	        console.error(error.message);
	      } else {
	        f(error.message);
	      }
	    }
	  },

	  api: function api(graphPath, permissions, s, f) {
	    var FB = window.FB;

	    // JS API does not take additional permissions

	    // Try will catch errors when SDK has not been init
	    try {
	      FB.api(graphPath, function (response) {
	        if (response.error) {
	          f(response);
	        } else {
	          s(response);
	        }
	      });
	    } catch (error) {
	      if (!f) {
	        console.error(error.message);
	      } else {
	        f(error.message);
	      }
	    }
	  },
	};

	if (!('toJSON' in Error.prototype)) {
	  window.Object.defineProperty(Error.prototype, 'toJSON', {
	    value: function value() {
	      var this$1 = this;

	      var alt = {};

	      Object.getOwnPropertyNames(this).forEach(function (key) {
	        alt[key] = this$1[key];
	      }, this);

	      return alt;
	    },
	    configurable: true,
	    writable: true,
	  });
	}

	function trackErrors () {
	  window.onerror = function onError(msg, url, lineNo, columnNo, error) {
	    var message = "Message: " + msg;
	    if (url) { message = message + "\nURL: " + url; }
	    if (lineNo) { message = message + "\nLine: " + lineNo; }
	    if (columnNo) { message = message + "\nColumn: " + columnNo; }
	    if (error) { message = message + "\nError object: " + (JSON.stringify(error)); }

	    Brief$1.sendError(message);
	  };
	}

	var localforage = createCommonjsModule(function (module, exports) {
	/*!
	    localForage -- Offline Storage, Improved
	    Version 1.9.0
	    https://localforage.github.io/localForage
	    (c) 2013-2017 Mozilla, Apache License 2.0
	*/
	(function(f){{module.exports=f();}})(function(){return (function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof commonjsRequire=="function"&&commonjsRequire;if(!u&&a){ return a(o,!0); }if(i){ return i(o,!0); }var f=new Error("Cannot find module '"+o+"'");throw (f.code="MODULE_NOT_FOUND", f)}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r);}return n[o].exports}var i=typeof commonjsRequire=="function"&&commonjsRequire;for(var o=0;o<r.length;o++){ s(r[o]); }return s})({1:[function(_dereq_,module,exports){
	(function (global){
	var Mutation = global.MutationObserver || global.WebKitMutationObserver;

	var scheduleDrain;

	{
	  if (Mutation) {
	    var called = 0;
	    var observer = new Mutation(nextTick);
	    var element = global.document.createTextNode('');
	    observer.observe(element, {
	      characterData: true
	    });
	    scheduleDrain = function () {
	      element.data = (called = ++called % 2);
	    };
	  } else if (!global.setImmediate && typeof global.MessageChannel !== 'undefined') {
	    var channel = new global.MessageChannel();
	    channel.port1.onmessage = nextTick;
	    scheduleDrain = function () {
	      channel.port2.postMessage(0);
	    };
	  } else if ('document' in global && 'onreadystatechange' in global.document.createElement('script')) {
	    scheduleDrain = function () {

	      // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
	      // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
	      var scriptEl = global.document.createElement('script');
	      scriptEl.onreadystatechange = function () {
	        nextTick();

	        scriptEl.onreadystatechange = null;
	        scriptEl.parentNode.removeChild(scriptEl);
	        scriptEl = null;
	      };
	      global.document.documentElement.appendChild(scriptEl);
	    };
	  } else {
	    scheduleDrain = function () {
	      setTimeout(nextTick, 0);
	    };
	  }
	}

	var draining;
	var queue = [];
	//named nextTick for less confusing stack traces
	function nextTick() {
	  draining = true;
	  var i, oldQueue;
	  var len = queue.length;
	  while (len) {
	    oldQueue = queue;
	    queue = [];
	    i = -1;
	    while (++i < len) {
	      oldQueue[i]();
	    }
	    len = queue.length;
	  }
	  draining = false;
	}

	module.exports = immediate;
	function immediate(task) {
	  if (queue.push(task) === 1 && !draining) {
	    scheduleDrain();
	  }
	}

	}).call(this,typeof commonjsGlobal !== "undefined" ? commonjsGlobal : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {});
	},{}],2:[function(_dereq_,module,exports){
	var immediate = _dereq_(1);

	/* istanbul ignore next */
	function INTERNAL() {}

	var handlers = {};

	var REJECTED = ['REJECTED'];
	var FULFILLED = ['FULFILLED'];
	var PENDING = ['PENDING'];

	module.exports = Promise;

	function Promise(resolver) {
	  if (typeof resolver !== 'function') {
	    throw new TypeError('resolver must be a function');
	  }
	  this.state = PENDING;
	  this.queue = [];
	  this.outcome = void 0;
	  if (resolver !== INTERNAL) {
	    safelyResolveThenable(this, resolver);
	  }
	}

	Promise.prototype["catch"] = function (onRejected) {
	  return this.then(null, onRejected);
	};
	Promise.prototype.then = function (onFulfilled, onRejected) {
	  if (typeof onFulfilled !== 'function' && this.state === FULFILLED ||
	    typeof onRejected !== 'function' && this.state === REJECTED) {
	    return this;
	  }
	  var promise = new this.constructor(INTERNAL);
	  if (this.state !== PENDING) {
	    var resolver = this.state === FULFILLED ? onFulfilled : onRejected;
	    unwrap(promise, resolver, this.outcome);
	  } else {
	    this.queue.push(new QueueItem(promise, onFulfilled, onRejected));
	  }

	  return promise;
	};
	function QueueItem(promise, onFulfilled, onRejected) {
	  this.promise = promise;
	  if (typeof onFulfilled === 'function') {
	    this.onFulfilled = onFulfilled;
	    this.callFulfilled = this.otherCallFulfilled;
	  }
	  if (typeof onRejected === 'function') {
	    this.onRejected = onRejected;
	    this.callRejected = this.otherCallRejected;
	  }
	}
	QueueItem.prototype.callFulfilled = function (value) {
	  handlers.resolve(this.promise, value);
	};
	QueueItem.prototype.otherCallFulfilled = function (value) {
	  unwrap(this.promise, this.onFulfilled, value);
	};
	QueueItem.prototype.callRejected = function (value) {
	  handlers.reject(this.promise, value);
	};
	QueueItem.prototype.otherCallRejected = function (value) {
	  unwrap(this.promise, this.onRejected, value);
	};

	function unwrap(promise, func, value) {
	  immediate(function () {
	    var returnValue;
	    try {
	      returnValue = func(value);
	    } catch (e) {
	      return handlers.reject(promise, e);
	    }
	    if (returnValue === promise) {
	      handlers.reject(promise, new TypeError('Cannot resolve promise with itself'));
	    } else {
	      handlers.resolve(promise, returnValue);
	    }
	  });
	}

	handlers.resolve = function (self, value) {
	  var result = tryCatch(getThen, value);
	  if (result.status === 'error') {
	    return handlers.reject(self, result.value);
	  }
	  var thenable = result.value;

	  if (thenable) {
	    safelyResolveThenable(self, thenable);
	  } else {
	    self.state = FULFILLED;
	    self.outcome = value;
	    var i = -1;
	    var len = self.queue.length;
	    while (++i < len) {
	      self.queue[i].callFulfilled(value);
	    }
	  }
	  return self;
	};
	handlers.reject = function (self, error) {
	  self.state = REJECTED;
	  self.outcome = error;
	  var i = -1;
	  var len = self.queue.length;
	  while (++i < len) {
	    self.queue[i].callRejected(error);
	  }
	  return self;
	};

	function getThen(obj) {
	  // Make sure we only access the accessor once as required by the spec
	  var then = obj && obj.then;
	  if (obj && (typeof obj === 'object' || typeof obj === 'function') && typeof then === 'function') {
	    return function appyThen() {
	      then.apply(obj, arguments);
	    };
	  }
	}

	function safelyResolveThenable(self, thenable) {
	  // Either fulfill, reject or reject with error
	  var called = false;
	  function onError(value) {
	    if (called) {
	      return;
	    }
	    called = true;
	    handlers.reject(self, value);
	  }

	  function onSuccess(value) {
	    if (called) {
	      return;
	    }
	    called = true;
	    handlers.resolve(self, value);
	  }

	  function tryToUnwrap() {
	    thenable(onSuccess, onError);
	  }

	  var result = tryCatch(tryToUnwrap);
	  if (result.status === 'error') {
	    onError(result.value);
	  }
	}

	function tryCatch(func, value) {
	  var out = {};
	  try {
	    out.value = func(value);
	    out.status = 'success';
	  } catch (e) {
	    out.status = 'error';
	    out.value = e;
	  }
	  return out;
	}

	Promise.resolve = resolve;
	function resolve(value) {
	  if (value instanceof this) {
	    return value;
	  }
	  return handlers.resolve(new this(INTERNAL), value);
	}

	Promise.reject = reject;
	function reject(reason) {
	  var promise = new this(INTERNAL);
	  return handlers.reject(promise, reason);
	}

	Promise.all = all;
	function all(iterable) {
	  var self = this;
	  if (Object.prototype.toString.call(iterable) !== '[object Array]') {
	    return this.reject(new TypeError('must be an array'));
	  }

	  var len = iterable.length;
	  var called = false;
	  if (!len) {
	    return this.resolve([]);
	  }

	  var values = new Array(len);
	  var resolved = 0;
	  var i = -1;
	  var promise = new this(INTERNAL);

	  while (++i < len) {
	    allResolver(iterable[i], i);
	  }
	  return promise;
	  function allResolver(value, i) {
	    self.resolve(value).then(resolveFromAll, function (error) {
	      if (!called) {
	        called = true;
	        handlers.reject(promise, error);
	      }
	    });
	    function resolveFromAll(outValue) {
	      values[i] = outValue;
	      if (++resolved === len && !called) {
	        called = true;
	        handlers.resolve(promise, values);
	      }
	    }
	  }
	}

	Promise.race = race;
	function race(iterable) {
	  var self = this;
	  if (Object.prototype.toString.call(iterable) !== '[object Array]') {
	    return this.reject(new TypeError('must be an array'));
	  }

	  var len = iterable.length;
	  var called = false;
	  if (!len) {
	    return this.resolve([]);
	  }

	  var i = -1;
	  var promise = new this(INTERNAL);

	  while (++i < len) {
	    resolver(iterable[i]);
	  }
	  return promise;
	  function resolver(value) {
	    self.resolve(value).then(function (response) {
	      if (!called) {
	        called = true;
	        handlers.resolve(promise, response);
	      }
	    }, function (error) {
	      if (!called) {
	        called = true;
	        handlers.reject(promise, error);
	      }
	    });
	  }
	}

	},{"1":1}],3:[function(_dereq_,module,exports){
	(function (global){
	if (typeof global.Promise !== 'function') {
	  global.Promise = _dereq_(2);
	}

	}).call(this,typeof commonjsGlobal !== "undefined" ? commonjsGlobal : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {});
	},{"2":2}],4:[function(_dereq_,module,exports){

	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function getIDB() {
	    /* global indexedDB,webkitIndexedDB,mozIndexedDB,OIndexedDB,msIndexedDB */
	    try {
	        if (typeof indexedDB !== 'undefined') {
	            return indexedDB;
	        }
	        if (typeof webkitIndexedDB !== 'undefined') {
	            return webkitIndexedDB;
	        }
	        if (typeof mozIndexedDB !== 'undefined') {
	            return mozIndexedDB;
	        }
	        if (typeof OIndexedDB !== 'undefined') {
	            return OIndexedDB;
	        }
	        if (typeof msIndexedDB !== 'undefined') {
	            return msIndexedDB;
	        }
	    } catch (e) {
	        return;
	    }
	}

	var idb = getIDB();

	function isIndexedDBValid() {
	    try {
	        // Initialize IndexedDB; fall back to vendor-prefixed versions
	        // if needed.
	        if (!idb || !idb.open) {
	            return false;
	        }
	        // We mimic PouchDB here;
	        //
	        // We test for openDatabase because IE Mobile identifies itself
	        // as Safari. Oh the lulz...
	        var isSafari = typeof openDatabase !== 'undefined' && /(Safari|iPhone|iPad|iPod)/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent) && !/BlackBerry/.test(navigator.platform);

	        var hasFetch = typeof fetch === 'function' && fetch.toString().indexOf('[native code') !== -1;

	        // Safari <10.1 does not meet our requirements for IDB support
	        // (see: https://github.com/pouchdb/pouchdb/issues/5572).
	        // Safari 10.1 shipped with fetch, we can use that to detect it.
	        // Note: this creates issues with `window.fetch` polyfills and
	        // overrides; see:
	        // https://github.com/localForage/localForage/issues/856
	        return (!isSafari || hasFetch) && typeof indexedDB !== 'undefined' &&
	        // some outdated implementations of IDB that appear on Samsung
	        // and HTC Android devices <4.4 are missing IDBKeyRange
	        // See: https://github.com/mozilla/localForage/issues/128
	        // See: https://github.com/mozilla/localForage/issues/272
	        typeof IDBKeyRange !== 'undefined';
	    } catch (e) {
	        return false;
	    }
	}

	// Abstracts constructing a Blob object, so it also works in older
	// browsers that don't support the native Blob constructor. (i.e.
	// old QtWebKit versions, at least).
	// Abstracts constructing a Blob object, so it also works in older
	// browsers that don't support the native Blob constructor. (i.e.
	// old QtWebKit versions, at least).
	function createBlob(parts, properties) {
	    /* global BlobBuilder,MSBlobBuilder,MozBlobBuilder,WebKitBlobBuilder */
	    parts = parts || [];
	    properties = properties || {};
	    try {
	        return new Blob(parts, properties);
	    } catch (e) {
	        if (e.name !== 'TypeError') {
	            throw e;
	        }
	        var Builder = typeof BlobBuilder !== 'undefined' ? BlobBuilder : typeof MSBlobBuilder !== 'undefined' ? MSBlobBuilder : typeof MozBlobBuilder !== 'undefined' ? MozBlobBuilder : WebKitBlobBuilder;
	        var builder = new Builder();
	        for (var i = 0; i < parts.length; i += 1) {
	            builder.append(parts[i]);
	        }
	        return builder.getBlob(properties.type);
	    }
	}

	// This is CommonJS because lie is an external dependency, so Rollup
	// can just ignore it.
	if (typeof Promise === 'undefined') {
	    // In the "nopromises" build this will just throw if you don't have
	    // a global promise object, but it would throw anyway later.
	    _dereq_(3);
	}
	var Promise$1 = Promise;

	function executeCallback(promise, callback) {
	    if (callback) {
	        promise.then(function (result) {
	            callback(null, result);
	        }, function (error) {
	            callback(error);
	        });
	    }
	}

	function executeTwoCallbacks(promise, callback, errorCallback) {
	    if (typeof callback === 'function') {
	        promise.then(callback);
	    }

	    if (typeof errorCallback === 'function') {
	        promise["catch"](errorCallback);
	    }
	}

	function normalizeKey(key) {
	    // Cast the key to a string, as that's all we can set as a key.
	    if (typeof key !== 'string') {
	        console.warn(key + ' used as a key, but it is not a string.');
	        key = String(key);
	    }

	    return key;
	}

	function getCallback() {
	    if (arguments.length && typeof arguments[arguments.length - 1] === 'function') {
	        return arguments[arguments.length - 1];
	    }
	}

	// Some code originally from async_storage.js in
	// [Gaia](https://github.com/mozilla-b2g/gaia).

	var DETECT_BLOB_SUPPORT_STORE = 'local-forage-detect-blob-support';
	var supportsBlobs = void 0;
	var dbContexts = {};
	var toString = Object.prototype.toString;

	// Transaction Modes
	var READ_ONLY = 'readonly';
	var READ_WRITE = 'readwrite';

	// Transform a binary string to an array buffer, because otherwise
	// weird stuff happens when you try to work with the binary string directly.
	// It is known.
	// From http://stackoverflow.com/questions/14967647/ (continues on next line)
	// encode-decode-image-with-base64-breaks-image (2013-04-21)
	function _binStringToArrayBuffer(bin) {
	    var length = bin.length;
	    var buf = new ArrayBuffer(length);
	    var arr = new Uint8Array(buf);
	    for (var i = 0; i < length; i++) {
	        arr[i] = bin.charCodeAt(i);
	    }
	    return buf;
	}

	//
	// Blobs are not supported in all versions of IndexedDB, notably
	// Chrome <37 and Android <5. In those versions, storing a blob will throw.
	//
	// Various other blob bugs exist in Chrome v37-42 (inclusive).
	// Detecting them is expensive and confusing to users, and Chrome 37-42
	// is at very low usage worldwide, so we do a hacky userAgent check instead.
	//
	// content-type bug: https://code.google.com/p/chromium/issues/detail?id=408120
	// 404 bug: https://code.google.com/p/chromium/issues/detail?id=447916
	// FileReader bug: https://code.google.com/p/chromium/issues/detail?id=447836
	//
	// Code borrowed from PouchDB. See:
	// https://github.com/pouchdb/pouchdb/blob/master/packages/node_modules/pouchdb-adapter-idb/src/blobSupport.js
	//
	function _checkBlobSupportWithoutCaching(idb) {
	    return new Promise$1(function (resolve) {
	        var txn = idb.transaction(DETECT_BLOB_SUPPORT_STORE, READ_WRITE);
	        var blob = createBlob(['']);
	        txn.objectStore(DETECT_BLOB_SUPPORT_STORE).put(blob, 'key');

	        txn.onabort = function (e) {
	            // If the transaction aborts now its due to not being able to
	            // write to the database, likely due to the disk being full
	            e.preventDefault();
	            e.stopPropagation();
	            resolve(false);
	        };

	        txn.oncomplete = function () {
	            var matchedChrome = navigator.userAgent.match(/Chrome\/(\d+)/);
	            var matchedEdge = navigator.userAgent.match(/Edge\//);
	            // MS Edge pretends to be Chrome 42:
	            // https://msdn.microsoft.com/en-us/library/hh869301%28v=vs.85%29.aspx
	            resolve(matchedEdge || !matchedChrome || parseInt(matchedChrome[1], 10) >= 43);
	        };
	    })["catch"](function () {
	        return false; // error, so assume unsupported
	    });
	}

	function _checkBlobSupport(idb) {
	    if (typeof supportsBlobs === 'boolean') {
	        return Promise$1.resolve(supportsBlobs);
	    }
	    return _checkBlobSupportWithoutCaching(idb).then(function (value) {
	        supportsBlobs = value;
	        return supportsBlobs;
	    });
	}

	function _deferReadiness(dbInfo) {
	    var dbContext = dbContexts[dbInfo.name];

	    // Create a deferred object representing the current database operation.
	    var deferredOperation = {};

	    deferredOperation.promise = new Promise$1(function (resolve, reject) {
	        deferredOperation.resolve = resolve;
	        deferredOperation.reject = reject;
	    });

	    // Enqueue the deferred operation.
	    dbContext.deferredOperations.push(deferredOperation);

	    // Chain its promise to the database readiness.
	    if (!dbContext.dbReady) {
	        dbContext.dbReady = deferredOperation.promise;
	    } else {
	        dbContext.dbReady = dbContext.dbReady.then(function () {
	            return deferredOperation.promise;
	        });
	    }
	}

	function _advanceReadiness(dbInfo) {
	    var dbContext = dbContexts[dbInfo.name];

	    // Dequeue a deferred operation.
	    var deferredOperation = dbContext.deferredOperations.pop();

	    // Resolve its promise (which is part of the database readiness
	    // chain of promises).
	    if (deferredOperation) {
	        deferredOperation.resolve();
	        return deferredOperation.promise;
	    }
	}

	function _rejectReadiness(dbInfo, err) {
	    var dbContext = dbContexts[dbInfo.name];

	    // Dequeue a deferred operation.
	    var deferredOperation = dbContext.deferredOperations.pop();

	    // Reject its promise (which is part of the database readiness
	    // chain of promises).
	    if (deferredOperation) {
	        deferredOperation.reject(err);
	        return deferredOperation.promise;
	    }
	}

	function _getConnection(dbInfo, upgradeNeeded) {
	    return new Promise$1(function (resolve, reject) {
	        dbContexts[dbInfo.name] = dbContexts[dbInfo.name] || createDbContext();

	        if (dbInfo.db) {
	            if (upgradeNeeded) {
	                _deferReadiness(dbInfo);
	                dbInfo.db.close();
	            } else {
	                return resolve(dbInfo.db);
	            }
	        }

	        var dbArgs = [dbInfo.name];

	        if (upgradeNeeded) {
	            dbArgs.push(dbInfo.version);
	        }

	        var openreq = idb.open.apply(idb, dbArgs);

	        if (upgradeNeeded) {
	            openreq.onupgradeneeded = function (e) {
	                var db = openreq.result;
	                try {
	                    db.createObjectStore(dbInfo.storeName);
	                    if (e.oldVersion <= 1) {
	                        // Added when support for blob shims was added
	                        db.createObjectStore(DETECT_BLOB_SUPPORT_STORE);
	                    }
	                } catch (ex) {
	                    if (ex.name === 'ConstraintError') {
	                        console.warn('The database "' + dbInfo.name + '"' + ' has been upgraded from version ' + e.oldVersion + ' to version ' + e.newVersion + ', but the storage "' + dbInfo.storeName + '" already exists.');
	                    } else {
	                        throw ex;
	                    }
	                }
	            };
	        }

	        openreq.onerror = function (e) {
	            e.preventDefault();
	            reject(openreq.error);
	        };

	        openreq.onsuccess = function () {
	            resolve(openreq.result);
	            _advanceReadiness(dbInfo);
	        };
	    });
	}

	function _getOriginalConnection(dbInfo) {
	    return _getConnection(dbInfo, false);
	}

	function _getUpgradedConnection(dbInfo) {
	    return _getConnection(dbInfo, true);
	}

	function _isUpgradeNeeded(dbInfo, defaultVersion) {
	    if (!dbInfo.db) {
	        return true;
	    }

	    var isNewStore = !dbInfo.db.objectStoreNames.contains(dbInfo.storeName);
	    var isDowngrade = dbInfo.version < dbInfo.db.version;
	    var isUpgrade = dbInfo.version > dbInfo.db.version;

	    if (isDowngrade) {
	        // If the version is not the default one
	        // then warn for impossible downgrade.
	        if (dbInfo.version !== defaultVersion) {
	            console.warn('The database "' + dbInfo.name + '"' + " can't be downgraded from version " + dbInfo.db.version + ' to version ' + dbInfo.version + '.');
	        }
	        // Align the versions to prevent errors.
	        dbInfo.version = dbInfo.db.version;
	    }

	    if (isUpgrade || isNewStore) {
	        // If the store is new then increment the version (if needed).
	        // This will trigger an "upgradeneeded" event which is required
	        // for creating a store.
	        if (isNewStore) {
	            var incVersion = dbInfo.db.version + 1;
	            if (incVersion > dbInfo.version) {
	                dbInfo.version = incVersion;
	            }
	        }

	        return true;
	    }

	    return false;
	}

	// encode a blob for indexeddb engines that don't support blobs
	function _encodeBlob(blob) {
	    return new Promise$1(function (resolve, reject) {
	        var reader = new FileReader();
	        reader.onerror = reject;
	        reader.onloadend = function (e) {
	            var base64 = btoa(e.target.result || '');
	            resolve({
	                __local_forage_encoded_blob: true,
	                data: base64,
	                type: blob.type
	            });
	        };
	        reader.readAsBinaryString(blob);
	    });
	}

	// decode an encoded blob
	function _decodeBlob(encodedBlob) {
	    var arrayBuff = _binStringToArrayBuffer(atob(encodedBlob.data));
	    return createBlob([arrayBuff], { type: encodedBlob.type });
	}

	// is this one of our fancy encoded blobs?
	function _isEncodedBlob(value) {
	    return value && value.__local_forage_encoded_blob;
	}

	// Specialize the default `ready()` function by making it dependent
	// on the current database operations. Thus, the driver will be actually
	// ready when it's been initialized (default) *and* there are no pending
	// operations on the database (initiated by some other instances).
	function _fullyReady(callback) {
	    var self = this;

	    var promise = self._initReady().then(function () {
	        var dbContext = dbContexts[self._dbInfo.name];

	        if (dbContext && dbContext.dbReady) {
	            return dbContext.dbReady;
	        }
	    });

	    executeTwoCallbacks(promise, callback, callback);
	    return promise;
	}

	// Try to establish a new db connection to replace the
	// current one which is broken (i.e. experiencing
	// InvalidStateError while creating a transaction).
	function _tryReconnect(dbInfo) {
	    _deferReadiness(dbInfo);

	    var dbContext = dbContexts[dbInfo.name];
	    var forages = dbContext.forages;

	    for (var i = 0; i < forages.length; i++) {
	        var forage = forages[i];
	        if (forage._dbInfo.db) {
	            forage._dbInfo.db.close();
	            forage._dbInfo.db = null;
	        }
	    }
	    dbInfo.db = null;

	    return _getOriginalConnection(dbInfo).then(function (db) {
	        dbInfo.db = db;
	        if (_isUpgradeNeeded(dbInfo)) {
	            // Reopen the database for upgrading.
	            return _getUpgradedConnection(dbInfo);
	        }
	        return db;
	    }).then(function (db) {
	        // store the latest db reference
	        // in case the db was upgraded
	        dbInfo.db = dbContext.db = db;
	        for (var i = 0; i < forages.length; i++) {
	            forages[i]._dbInfo.db = db;
	        }
	    })["catch"](function (err) {
	        _rejectReadiness(dbInfo, err);
	        throw err;
	    });
	}

	// FF doesn't like Promises (micro-tasks) and IDDB store operations,
	// so we have to do it with callbacks
	function createTransaction(dbInfo, mode, callback, retries) {
	    if (retries === undefined) {
	        retries = 1;
	    }

	    try {
	        var tx = dbInfo.db.transaction(dbInfo.storeName, mode);
	        callback(null, tx);
	    } catch (err) {
	        if (retries > 0 && (!dbInfo.db || err.name === 'InvalidStateError' || err.name === 'NotFoundError')) {
	            return Promise$1.resolve().then(function () {
	                if (!dbInfo.db || err.name === 'NotFoundError' && !dbInfo.db.objectStoreNames.contains(dbInfo.storeName) && dbInfo.version <= dbInfo.db.version) {
	                    // increase the db version, to create the new ObjectStore
	                    if (dbInfo.db) {
	                        dbInfo.version = dbInfo.db.version + 1;
	                    }
	                    // Reopen the database for upgrading.
	                    return _getUpgradedConnection(dbInfo);
	                }
	            }).then(function () {
	                return _tryReconnect(dbInfo).then(function () {
	                    createTransaction(dbInfo, mode, callback, retries - 1);
	                });
	            })["catch"](callback);
	        }

	        callback(err);
	    }
	}

	function createDbContext() {
	    return {
	        // Running localForages sharing a database.
	        forages: [],
	        // Shared database.
	        db: null,
	        // Database readiness (promise).
	        dbReady: null,
	        // Deferred operations on the database.
	        deferredOperations: []
	    };
	}

	// Open the IndexedDB database (automatically creates one if one didn't
	// previously exist), using any options set in the config.
	function _initStorage(options) {
	    var self = this;
	    var dbInfo = {
	        db: null
	    };

	    if (options) {
	        for (var i in options) {
	            dbInfo[i] = options[i];
	        }
	    }

	    // Get the current context of the database;
	    var dbContext = dbContexts[dbInfo.name];

	    // ...or create a new context.
	    if (!dbContext) {
	        dbContext = createDbContext();
	        // Register the new context in the global container.
	        dbContexts[dbInfo.name] = dbContext;
	    }

	    // Register itself as a running localForage in the current context.
	    dbContext.forages.push(self);

	    // Replace the default `ready()` function with the specialized one.
	    if (!self._initReady) {
	        self._initReady = self.ready;
	        self.ready = _fullyReady;
	    }

	    // Create an array of initialization states of the related localForages.
	    var initPromises = [];

	    function ignoreErrors() {
	        // Don't handle errors here,
	        // just makes sure related localForages aren't pending.
	        return Promise$1.resolve();
	    }

	    for (var j = 0; j < dbContext.forages.length; j++) {
	        var forage = dbContext.forages[j];
	        if (forage !== self) {
	            // Don't wait for itself...
	            initPromises.push(forage._initReady()["catch"](ignoreErrors));
	        }
	    }

	    // Take a snapshot of the related localForages.
	    var forages = dbContext.forages.slice(0);

	    // Initialize the connection process only when
	    // all the related localForages aren't pending.
	    return Promise$1.all(initPromises).then(function () {
	        dbInfo.db = dbContext.db;
	        // Get the connection or open a new one without upgrade.
	        return _getOriginalConnection(dbInfo);
	    }).then(function (db) {
	        dbInfo.db = db;
	        if (_isUpgradeNeeded(dbInfo, self._defaultConfig.version)) {
	            // Reopen the database for upgrading.
	            return _getUpgradedConnection(dbInfo);
	        }
	        return db;
	    }).then(function (db) {
	        dbInfo.db = dbContext.db = db;
	        self._dbInfo = dbInfo;
	        // Share the final connection amongst related localForages.
	        for (var k = 0; k < forages.length; k++) {
	            var forage = forages[k];
	            if (forage !== self) {
	                // Self is already up-to-date.
	                forage._dbInfo.db = dbInfo.db;
	                forage._dbInfo.version = dbInfo.version;
	            }
	        }
	    });
	}

	function getItem(key, callback) {
	    var self = this;

	    key = normalizeKey(key);

	    var promise = new Promise$1(function (resolve, reject) {
	        self.ready().then(function () {
	            createTransaction(self._dbInfo, READ_ONLY, function (err, transaction) {
	                if (err) {
	                    return reject(err);
	                }

	                try {
	                    var store = transaction.objectStore(self._dbInfo.storeName);
	                    var req = store.get(key);

	                    req.onsuccess = function () {
	                        var value = req.result;
	                        if (value === undefined) {
	                            value = null;
	                        }
	                        if (_isEncodedBlob(value)) {
	                            value = _decodeBlob(value);
	                        }
	                        resolve(value);
	                    };

	                    req.onerror = function () {
	                        reject(req.error);
	                    };
	                } catch (e) {
	                    reject(e);
	                }
	            });
	        })["catch"](reject);
	    });

	    executeCallback(promise, callback);
	    return promise;
	}

	// Iterate over all items stored in database.
	function iterate(iterator, callback) {
	    var self = this;

	    var promise = new Promise$1(function (resolve, reject) {
	        self.ready().then(function () {
	            createTransaction(self._dbInfo, READ_ONLY, function (err, transaction) {
	                if (err) {
	                    return reject(err);
	                }

	                try {
	                    var store = transaction.objectStore(self._dbInfo.storeName);
	                    var req = store.openCursor();
	                    var iterationNumber = 1;

	                    req.onsuccess = function () {
	                        var cursor = req.result;

	                        if (cursor) {
	                            var value = cursor.value;
	                            if (_isEncodedBlob(value)) {
	                                value = _decodeBlob(value);
	                            }
	                            var result = iterator(value, cursor.key, iterationNumber++);

	                            // when the iterator callback returns any
	                            // (non-`undefined`) value, then we stop
	                            // the iteration immediately
	                            if (result !== void 0) {
	                                resolve(result);
	                            } else {
	                                cursor["continue"]();
	                            }
	                        } else {
	                            resolve();
	                        }
	                    };

	                    req.onerror = function () {
	                        reject(req.error);
	                    };
	                } catch (e) {
	                    reject(e);
	                }
	            });
	        })["catch"](reject);
	    });

	    executeCallback(promise, callback);

	    return promise;
	}

	function setItem(key, value, callback) {
	    var self = this;

	    key = normalizeKey(key);

	    var promise = new Promise$1(function (resolve, reject) {
	        var dbInfo;
	        self.ready().then(function () {
	            dbInfo = self._dbInfo;
	            if (toString.call(value) === '[object Blob]') {
	                return _checkBlobSupport(dbInfo.db).then(function (blobSupport) {
	                    if (blobSupport) {
	                        return value;
	                    }
	                    return _encodeBlob(value);
	                });
	            }
	            return value;
	        }).then(function (value) {
	            createTransaction(self._dbInfo, READ_WRITE, function (err, transaction) {
	                if (err) {
	                    return reject(err);
	                }

	                try {
	                    var store = transaction.objectStore(self._dbInfo.storeName);

	                    // The reason we don't _save_ null is because IE 10 does
	                    // not support saving the `null` type in IndexedDB. How
	                    // ironic, given the bug below!
	                    // See: https://github.com/mozilla/localForage/issues/161
	                    if (value === null) {
	                        value = undefined;
	                    }

	                    var req = store.put(value, key);

	                    transaction.oncomplete = function () {
	                        // Cast to undefined so the value passed to
	                        // callback/promise is the same as what one would get out
	                        // of `getItem()` later. This leads to some weirdness
	                        // (setItem('foo', undefined) will return `null`), but
	                        // it's not my fault localStorage is our baseline and that
	                        // it's weird.
	                        if (value === undefined) {
	                            value = null;
	                        }

	                        resolve(value);
	                    };
	                    transaction.onabort = transaction.onerror = function () {
	                        var err = req.error ? req.error : req.transaction.error;
	                        reject(err);
	                    };
	                } catch (e) {
	                    reject(e);
	                }
	            });
	        })["catch"](reject);
	    });

	    executeCallback(promise, callback);
	    return promise;
	}

	function removeItem(key, callback) {
	    var self = this;

	    key = normalizeKey(key);

	    var promise = new Promise$1(function (resolve, reject) {
	        self.ready().then(function () {
	            createTransaction(self._dbInfo, READ_WRITE, function (err, transaction) {
	                if (err) {
	                    return reject(err);
	                }

	                try {
	                    var store = transaction.objectStore(self._dbInfo.storeName);
	                    // We use a Grunt task to make this safe for IE and some
	                    // versions of Android (including those used by Cordova).
	                    // Normally IE won't like `.delete()` and will insist on
	                    // using `['delete']()`, but we have a build step that
	                    // fixes this for us now.
	                    var req = store["delete"](key);
	                    transaction.oncomplete = function () {
	                        resolve();
	                    };

	                    transaction.onerror = function () {
	                        reject(req.error);
	                    };

	                    // The request will be also be aborted if we've exceeded our storage
	                    // space.
	                    transaction.onabort = function () {
	                        var err = req.error ? req.error : req.transaction.error;
	                        reject(err);
	                    };
	                } catch (e) {
	                    reject(e);
	                }
	            });
	        })["catch"](reject);
	    });

	    executeCallback(promise, callback);
	    return promise;
	}

	function clear(callback) {
	    var self = this;

	    var promise = new Promise$1(function (resolve, reject) {
	        self.ready().then(function () {
	            createTransaction(self._dbInfo, READ_WRITE, function (err, transaction) {
	                if (err) {
	                    return reject(err);
	                }

	                try {
	                    var store = transaction.objectStore(self._dbInfo.storeName);
	                    var req = store.clear();

	                    transaction.oncomplete = function () {
	                        resolve();
	                    };

	                    transaction.onabort = transaction.onerror = function () {
	                        var err = req.error ? req.error : req.transaction.error;
	                        reject(err);
	                    };
	                } catch (e) {
	                    reject(e);
	                }
	            });
	        })["catch"](reject);
	    });

	    executeCallback(promise, callback);
	    return promise;
	}

	function length(callback) {
	    var self = this;

	    var promise = new Promise$1(function (resolve, reject) {
	        self.ready().then(function () {
	            createTransaction(self._dbInfo, READ_ONLY, function (err, transaction) {
	                if (err) {
	                    return reject(err);
	                }

	                try {
	                    var store = transaction.objectStore(self._dbInfo.storeName);
	                    var req = store.count();

	                    req.onsuccess = function () {
	                        resolve(req.result);
	                    };

	                    req.onerror = function () {
	                        reject(req.error);
	                    };
	                } catch (e) {
	                    reject(e);
	                }
	            });
	        })["catch"](reject);
	    });

	    executeCallback(promise, callback);
	    return promise;
	}

	function key(n, callback) {
	    var self = this;

	    var promise = new Promise$1(function (resolve, reject) {
	        if (n < 0) {
	            resolve(null);

	            return;
	        }

	        self.ready().then(function () {
	            createTransaction(self._dbInfo, READ_ONLY, function (err, transaction) {
	                if (err) {
	                    return reject(err);
	                }

	                try {
	                    var store = transaction.objectStore(self._dbInfo.storeName);
	                    var advanced = false;
	                    var req = store.openKeyCursor();

	                    req.onsuccess = function () {
	                        var cursor = req.result;
	                        if (!cursor) {
	                            // this means there weren't enough keys
	                            resolve(null);

	                            return;
	                        }

	                        if (n === 0) {
	                            // We have the first key, return it if that's what they
	                            // wanted.
	                            resolve(cursor.key);
	                        } else {
	                            if (!advanced) {
	                                // Otherwise, ask the cursor to skip ahead n
	                                // records.
	                                advanced = true;
	                                cursor.advance(n);
	                            } else {
	                                // When we get here, we've got the nth key.
	                                resolve(cursor.key);
	                            }
	                        }
	                    };

	                    req.onerror = function () {
	                        reject(req.error);
	                    };
	                } catch (e) {
	                    reject(e);
	                }
	            });
	        })["catch"](reject);
	    });

	    executeCallback(promise, callback);
	    return promise;
	}

	function keys(callback) {
	    var self = this;

	    var promise = new Promise$1(function (resolve, reject) {
	        self.ready().then(function () {
	            createTransaction(self._dbInfo, READ_ONLY, function (err, transaction) {
	                if (err) {
	                    return reject(err);
	                }

	                try {
	                    var store = transaction.objectStore(self._dbInfo.storeName);
	                    var req = store.openKeyCursor();
	                    var keys = [];

	                    req.onsuccess = function () {
	                        var cursor = req.result;

	                        if (!cursor) {
	                            resolve(keys);
	                            return;
	                        }

	                        keys.push(cursor.key);
	                        cursor["continue"]();
	                    };

	                    req.onerror = function () {
	                        reject(req.error);
	                    };
	                } catch (e) {
	                    reject(e);
	                }
	            });
	        })["catch"](reject);
	    });

	    executeCallback(promise, callback);
	    return promise;
	}

	function dropInstance(options, callback) {
	    callback = getCallback.apply(this, arguments);

	    var currentConfig = this.config();
	    options = typeof options !== 'function' && options || {};
	    if (!options.name) {
	        options.name = options.name || currentConfig.name;
	        options.storeName = options.storeName || currentConfig.storeName;
	    }

	    var self = this;
	    var promise;
	    if (!options.name) {
	        promise = Promise$1.reject('Invalid arguments');
	    } else {
	        var isCurrentDb = options.name === currentConfig.name && self._dbInfo.db;

	        var dbPromise = isCurrentDb ? Promise$1.resolve(self._dbInfo.db) : _getOriginalConnection(options).then(function (db) {
	            var dbContext = dbContexts[options.name];
	            var forages = dbContext.forages;
	            dbContext.db = db;
	            for (var i = 0; i < forages.length; i++) {
	                forages[i]._dbInfo.db = db;
	            }
	            return db;
	        });

	        if (!options.storeName) {
	            promise = dbPromise.then(function (db) {
	                _deferReadiness(options);

	                var dbContext = dbContexts[options.name];
	                var forages = dbContext.forages;

	                db.close();
	                for (var i = 0; i < forages.length; i++) {
	                    var forage = forages[i];
	                    forage._dbInfo.db = null;
	                }

	                var dropDBPromise = new Promise$1(function (resolve, reject) {
	                    var req = idb.deleteDatabase(options.name);

	                    req.onerror = req.onblocked = function (err) {
	                        var db = req.result;
	                        if (db) {
	                            db.close();
	                        }
	                        reject(err);
	                    };

	                    req.onsuccess = function () {
	                        var db = req.result;
	                        if (db) {
	                            db.close();
	                        }
	                        resolve(db);
	                    };
	                });

	                return dropDBPromise.then(function (db) {
	                    dbContext.db = db;
	                    for (var i = 0; i < forages.length; i++) {
	                        var _forage = forages[i];
	                        _advanceReadiness(_forage._dbInfo);
	                    }
	                })["catch"](function (err) {
	                    (_rejectReadiness(options, err) || Promise$1.resolve())["catch"](function () {});
	                    throw err;
	                });
	            });
	        } else {
	            promise = dbPromise.then(function (db) {
	                if (!db.objectStoreNames.contains(options.storeName)) {
	                    return;
	                }

	                var newVersion = db.version + 1;

	                _deferReadiness(options);

	                var dbContext = dbContexts[options.name];
	                var forages = dbContext.forages;

	                db.close();
	                for (var i = 0; i < forages.length; i++) {
	                    var forage = forages[i];
	                    forage._dbInfo.db = null;
	                    forage._dbInfo.version = newVersion;
	                }

	                var dropObjectPromise = new Promise$1(function (resolve, reject) {
	                    var req = idb.open(options.name, newVersion);

	                    req.onerror = function (err) {
	                        var db = req.result;
	                        db.close();
	                        reject(err);
	                    };

	                    req.onupgradeneeded = function () {
	                        var db = req.result;
	                        db.deleteObjectStore(options.storeName);
	                    };

	                    req.onsuccess = function () {
	                        var db = req.result;
	                        db.close();
	                        resolve(db);
	                    };
	                });

	                return dropObjectPromise.then(function (db) {
	                    dbContext.db = db;
	                    for (var j = 0; j < forages.length; j++) {
	                        var _forage2 = forages[j];
	                        _forage2._dbInfo.db = db;
	                        _advanceReadiness(_forage2._dbInfo);
	                    }
	                })["catch"](function (err) {
	                    (_rejectReadiness(options, err) || Promise$1.resolve())["catch"](function () {});
	                    throw err;
	                });
	            });
	        }
	    }

	    executeCallback(promise, callback);
	    return promise;
	}

	var asyncStorage = {
	    _driver: 'asyncStorage',
	    _initStorage: _initStorage,
	    _support: isIndexedDBValid(),
	    iterate: iterate,
	    getItem: getItem,
	    setItem: setItem,
	    removeItem: removeItem,
	    clear: clear,
	    length: length,
	    key: key,
	    keys: keys,
	    dropInstance: dropInstance
	};

	function isWebSQLValid() {
	    return typeof openDatabase === 'function';
	}

	// Sadly, the best way to save binary data in WebSQL/localStorage is serializing
	// it to Base64, so this is how we store it to prevent very strange errors with less
	// verbose ways of binary <-> string data storage.
	var BASE_CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';

	var BLOB_TYPE_PREFIX = '~~local_forage_type~';
	var BLOB_TYPE_PREFIX_REGEX = /^~~local_forage_type~([^~]+)~/;

	var SERIALIZED_MARKER = '__lfsc__:';
	var SERIALIZED_MARKER_LENGTH = SERIALIZED_MARKER.length;

	// OMG the serializations!
	var TYPE_ARRAYBUFFER = 'arbf';
	var TYPE_BLOB = 'blob';
	var TYPE_INT8ARRAY = 'si08';
	var TYPE_UINT8ARRAY = 'ui08';
	var TYPE_UINT8CLAMPEDARRAY = 'uic8';
	var TYPE_INT16ARRAY = 'si16';
	var TYPE_INT32ARRAY = 'si32';
	var TYPE_UINT16ARRAY = 'ur16';
	var TYPE_UINT32ARRAY = 'ui32';
	var TYPE_FLOAT32ARRAY = 'fl32';
	var TYPE_FLOAT64ARRAY = 'fl64';
	var TYPE_SERIALIZED_MARKER_LENGTH = SERIALIZED_MARKER_LENGTH + TYPE_ARRAYBUFFER.length;

	var toString$1 = Object.prototype.toString;

	function stringToBuffer(serializedString) {
	    // Fill the string into a ArrayBuffer.
	    var bufferLength = serializedString.length * 0.75;
	    var len = serializedString.length;
	    var i;
	    var p = 0;
	    var encoded1, encoded2, encoded3, encoded4;

	    if (serializedString[serializedString.length - 1] === '=') {
	        bufferLength--;
	        if (serializedString[serializedString.length - 2] === '=') {
	            bufferLength--;
	        }
	    }

	    var buffer = new ArrayBuffer(bufferLength);
	    var bytes = new Uint8Array(buffer);

	    for (i = 0; i < len; i += 4) {
	        encoded1 = BASE_CHARS.indexOf(serializedString[i]);
	        encoded2 = BASE_CHARS.indexOf(serializedString[i + 1]);
	        encoded3 = BASE_CHARS.indexOf(serializedString[i + 2]);
	        encoded4 = BASE_CHARS.indexOf(serializedString[i + 3]);

	        /*jslint bitwise: true */
	        bytes[p++] = encoded1 << 2 | encoded2 >> 4;
	        bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
	        bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
	    }
	    return buffer;
	}

	// Converts a buffer to a string to store, serialized, in the backend
	// storage library.
	function bufferToString(buffer) {
	    // base64-arraybuffer
	    var bytes = new Uint8Array(buffer);
	    var base64String = '';
	    var i;

	    for (i = 0; i < bytes.length; i += 3) {
	        /*jslint bitwise: true */
	        base64String += BASE_CHARS[bytes[i] >> 2];
	        base64String += BASE_CHARS[(bytes[i] & 3) << 4 | bytes[i + 1] >> 4];
	        base64String += BASE_CHARS[(bytes[i + 1] & 15) << 2 | bytes[i + 2] >> 6];
	        base64String += BASE_CHARS[bytes[i + 2] & 63];
	    }

	    if (bytes.length % 3 === 2) {
	        base64String = base64String.substring(0, base64String.length - 1) + '=';
	    } else if (bytes.length % 3 === 1) {
	        base64String = base64String.substring(0, base64String.length - 2) + '==';
	    }

	    return base64String;
	}

	// Serialize a value, afterwards executing a callback (which usually
	// instructs the `setItem()` callback/promise to be executed). This is how
	// we store binary data with localStorage.
	function serialize(value, callback) {
	    var valueType = '';
	    if (value) {
	        valueType = toString$1.call(value);
	    }

	    // Cannot use `value instanceof ArrayBuffer` or such here, as these
	    // checks fail when running the tests using casper.js...
	    //
	    // TODO: See why those tests fail and use a better solution.
	    if (value && (valueType === '[object ArrayBuffer]' || value.buffer && toString$1.call(value.buffer) === '[object ArrayBuffer]')) {
	        // Convert binary arrays to a string and prefix the string with
	        // a special marker.
	        var buffer;
	        var marker = SERIALIZED_MARKER;

	        if (value instanceof ArrayBuffer) {
	            buffer = value;
	            marker += TYPE_ARRAYBUFFER;
	        } else {
	            buffer = value.buffer;

	            if (valueType === '[object Int8Array]') {
	                marker += TYPE_INT8ARRAY;
	            } else if (valueType === '[object Uint8Array]') {
	                marker += TYPE_UINT8ARRAY;
	            } else if (valueType === '[object Uint8ClampedArray]') {
	                marker += TYPE_UINT8CLAMPEDARRAY;
	            } else if (valueType === '[object Int16Array]') {
	                marker += TYPE_INT16ARRAY;
	            } else if (valueType === '[object Uint16Array]') {
	                marker += TYPE_UINT16ARRAY;
	            } else if (valueType === '[object Int32Array]') {
	                marker += TYPE_INT32ARRAY;
	            } else if (valueType === '[object Uint32Array]') {
	                marker += TYPE_UINT32ARRAY;
	            } else if (valueType === '[object Float32Array]') {
	                marker += TYPE_FLOAT32ARRAY;
	            } else if (valueType === '[object Float64Array]') {
	                marker += TYPE_FLOAT64ARRAY;
	            } else {
	                callback(new Error('Failed to get type for BinaryArray'));
	            }
	        }

	        callback(marker + bufferToString(buffer));
	    } else if (valueType === '[object Blob]') {
	        // Conver the blob to a binaryArray and then to a string.
	        var fileReader = new FileReader();

	        fileReader.onload = function () {
	            // Backwards-compatible prefix for the blob type.
	            var str = BLOB_TYPE_PREFIX + value.type + '~' + bufferToString(this.result);

	            callback(SERIALIZED_MARKER + TYPE_BLOB + str);
	        };

	        fileReader.readAsArrayBuffer(value);
	    } else {
	        try {
	            callback(JSON.stringify(value));
	        } catch (e) {
	            console.error("Couldn't convert value into a JSON string: ", value);

	            callback(null, e);
	        }
	    }
	}

	// Deserialize data we've inserted into a value column/field. We place
	// special markers into our strings to mark them as encoded; this isn't
	// as nice as a meta field, but it's the only sane thing we can do whilst
	// keeping localStorage support intact.
	//
	// Oftentimes this will just deserialize JSON content, but if we have a
	// special marker (SERIALIZED_MARKER, defined above), we will extract
	// some kind of arraybuffer/binary data/typed array out of the string.
	function deserialize(value) {
	    // If we haven't marked this string as being specially serialized (i.e.
	    // something other than serialized JSON), we can just return it and be
	    // done with it.
	    if (value.substring(0, SERIALIZED_MARKER_LENGTH) !== SERIALIZED_MARKER) {
	        return JSON.parse(value);
	    }

	    // The following code deals with deserializing some kind of Blob or
	    // TypedArray. First we separate out the type of data we're dealing
	    // with from the data itself.
	    var serializedString = value.substring(TYPE_SERIALIZED_MARKER_LENGTH);
	    var type = value.substring(SERIALIZED_MARKER_LENGTH, TYPE_SERIALIZED_MARKER_LENGTH);

	    var blobType;
	    // Backwards-compatible blob type serialization strategy.
	    // DBs created with older versions of localForage will simply not have the blob type.
	    if (type === TYPE_BLOB && BLOB_TYPE_PREFIX_REGEX.test(serializedString)) {
	        var matcher = serializedString.match(BLOB_TYPE_PREFIX_REGEX);
	        blobType = matcher[1];
	        serializedString = serializedString.substring(matcher[0].length);
	    }
	    var buffer = stringToBuffer(serializedString);

	    // Return the right type based on the code/type set during
	    // serialization.
	    switch (type) {
	        case TYPE_ARRAYBUFFER:
	            return buffer;
	        case TYPE_BLOB:
	            return createBlob([buffer], { type: blobType });
	        case TYPE_INT8ARRAY:
	            return new Int8Array(buffer);
	        case TYPE_UINT8ARRAY:
	            return new Uint8Array(buffer);
	        case TYPE_UINT8CLAMPEDARRAY:
	            return new Uint8ClampedArray(buffer);
	        case TYPE_INT16ARRAY:
	            return new Int16Array(buffer);
	        case TYPE_UINT16ARRAY:
	            return new Uint16Array(buffer);
	        case TYPE_INT32ARRAY:
	            return new Int32Array(buffer);
	        case TYPE_UINT32ARRAY:
	            return new Uint32Array(buffer);
	        case TYPE_FLOAT32ARRAY:
	            return new Float32Array(buffer);
	        case TYPE_FLOAT64ARRAY:
	            return new Float64Array(buffer);
	        default:
	            throw new Error('Unkown type: ' + type);
	    }
	}

	var localforageSerializer = {
	    serialize: serialize,
	    deserialize: deserialize,
	    stringToBuffer: stringToBuffer,
	    bufferToString: bufferToString
	};

	/*
	 * Includes code from:
	 *
	 * base64-arraybuffer
	 * https://github.com/niklasvh/base64-arraybuffer
	 *
	 * Copyright (c) 2012 Niklas von Hertzen
	 * Licensed under the MIT license.
	 */

	function createDbTable(t, dbInfo, callback, errorCallback) {
	    t.executeSql('CREATE TABLE IF NOT EXISTS ' + dbInfo.storeName + ' ' + '(id INTEGER PRIMARY KEY, key unique, value)', [], callback, errorCallback);
	}

	// Open the WebSQL database (automatically creates one if one didn't
	// previously exist), using any options set in the config.
	function _initStorage$1(options) {
	    var self = this;
	    var dbInfo = {
	        db: null
	    };

	    if (options) {
	        for (var i in options) {
	            dbInfo[i] = typeof options[i] !== 'string' ? options[i].toString() : options[i];
	        }
	    }

	    var dbInfoPromise = new Promise$1(function (resolve, reject) {
	        // Open the database; the openDatabase API will automatically
	        // create it for us if it doesn't exist.
	        try {
	            dbInfo.db = openDatabase(dbInfo.name, String(dbInfo.version), dbInfo.description, dbInfo.size);
	        } catch (e) {
	            return reject(e);
	        }

	        // Create our key/value table if it doesn't exist.
	        dbInfo.db.transaction(function (t) {
	            createDbTable(t, dbInfo, function () {
	                self._dbInfo = dbInfo;
	                resolve();
	            }, function (t, error) {
	                reject(error);
	            });
	        }, reject);
	    });

	    dbInfo.serializer = localforageSerializer;
	    return dbInfoPromise;
	}

	function tryExecuteSql(t, dbInfo, sqlStatement, args, callback, errorCallback) {
	    t.executeSql(sqlStatement, args, callback, function (t, error) {
	        if (error.code === error.SYNTAX_ERR) {
	            t.executeSql('SELECT name FROM sqlite_master ' + "WHERE type='table' AND name = ?", [dbInfo.storeName], function (t, results) {
	                if (!results.rows.length) {
	                    // if the table is missing (was deleted)
	                    // re-create it table and retry
	                    createDbTable(t, dbInfo, function () {
	                        t.executeSql(sqlStatement, args, callback, errorCallback);
	                    }, errorCallback);
	                } else {
	                    errorCallback(t, error);
	                }
	            }, errorCallback);
	        } else {
	            errorCallback(t, error);
	        }
	    }, errorCallback);
	}

	function getItem$1(key, callback) {
	    var self = this;

	    key = normalizeKey(key);

	    var promise = new Promise$1(function (resolve, reject) {
	        self.ready().then(function () {
	            var dbInfo = self._dbInfo;
	            dbInfo.db.transaction(function (t) {
	                tryExecuteSql(t, dbInfo, 'SELECT * FROM ' + dbInfo.storeName + ' WHERE key = ? LIMIT 1', [key], function (t, results) {
	                    var result = results.rows.length ? results.rows.item(0).value : null;

	                    // Check to see if this is serialized content we need to
	                    // unpack.
	                    if (result) {
	                        result = dbInfo.serializer.deserialize(result);
	                    }

	                    resolve(result);
	                }, function (t, error) {
	                    reject(error);
	                });
	            });
	        })["catch"](reject);
	    });

	    executeCallback(promise, callback);
	    return promise;
	}

	function iterate$1(iterator, callback) {
	    var self = this;

	    var promise = new Promise$1(function (resolve, reject) {
	        self.ready().then(function () {
	            var dbInfo = self._dbInfo;

	            dbInfo.db.transaction(function (t) {
	                tryExecuteSql(t, dbInfo, 'SELECT * FROM ' + dbInfo.storeName, [], function (t, results) {
	                    var rows = results.rows;
	                    var length = rows.length;

	                    for (var i = 0; i < length; i++) {
	                        var item = rows.item(i);
	                        var result = item.value;

	                        // Check to see if this is serialized content
	                        // we need to unpack.
	                        if (result) {
	                            result = dbInfo.serializer.deserialize(result);
	                        }

	                        result = iterator(result, item.key, i + 1);

	                        // void(0) prevents problems with redefinition
	                        // of `undefined`.
	                        if (result !== void 0) {
	                            resolve(result);
	                            return;
	                        }
	                    }

	                    resolve();
	                }, function (t, error) {
	                    reject(error);
	                });
	            });
	        })["catch"](reject);
	    });

	    executeCallback(promise, callback);
	    return promise;
	}

	function _setItem(key, value, callback, retriesLeft) {
	    var self = this;

	    key = normalizeKey(key);

	    var promise = new Promise$1(function (resolve, reject) {
	        self.ready().then(function () {
	            // The localStorage API doesn't return undefined values in an
	            // "expected" way, so undefined is always cast to null in all
	            // drivers. See: https://github.com/mozilla/localForage/pull/42
	            if (value === undefined) {
	                value = null;
	            }

	            // Save the original value to pass to the callback.
	            var originalValue = value;

	            var dbInfo = self._dbInfo;
	            dbInfo.serializer.serialize(value, function (value, error) {
	                if (error) {
	                    reject(error);
	                } else {
	                    dbInfo.db.transaction(function (t) {
	                        tryExecuteSql(t, dbInfo, 'INSERT OR REPLACE INTO ' + dbInfo.storeName + ' ' + '(key, value) VALUES (?, ?)', [key, value], function () {
	                            resolve(originalValue);
	                        }, function (t, error) {
	                            reject(error);
	                        });
	                    }, function (sqlError) {
	                        // The transaction failed; check
	                        // to see if it's a quota error.
	                        if (sqlError.code === sqlError.QUOTA_ERR) {
	                            // We reject the callback outright for now, but
	                            // it's worth trying to re-run the transaction.
	                            // Even if the user accepts the prompt to use
	                            // more storage on Safari, this error will
	                            // be called.
	                            //
	                            // Try to re-run the transaction.
	                            if (retriesLeft > 0) {
	                                resolve(_setItem.apply(self, [key, originalValue, callback, retriesLeft - 1]));
	                                return;
	                            }
	                            reject(sqlError);
	                        }
	                    });
	                }
	            });
	        })["catch"](reject);
	    });

	    executeCallback(promise, callback);
	    return promise;
	}

	function setItem$1(key, value, callback) {
	    return _setItem.apply(this, [key, value, callback, 1]);
	}

	function removeItem$1(key, callback) {
	    var self = this;

	    key = normalizeKey(key);

	    var promise = new Promise$1(function (resolve, reject) {
	        self.ready().then(function () {
	            var dbInfo = self._dbInfo;
	            dbInfo.db.transaction(function (t) {
	                tryExecuteSql(t, dbInfo, 'DELETE FROM ' + dbInfo.storeName + ' WHERE key = ?', [key], function () {
	                    resolve();
	                }, function (t, error) {
	                    reject(error);
	                });
	            });
	        })["catch"](reject);
	    });

	    executeCallback(promise, callback);
	    return promise;
	}

	// Deletes every item in the table.
	// TODO: Find out if this resets the AUTO_INCREMENT number.
	function clear$1(callback) {
	    var self = this;

	    var promise = new Promise$1(function (resolve, reject) {
	        self.ready().then(function () {
	            var dbInfo = self._dbInfo;
	            dbInfo.db.transaction(function (t) {
	                tryExecuteSql(t, dbInfo, 'DELETE FROM ' + dbInfo.storeName, [], function () {
	                    resolve();
	                }, function (t, error) {
	                    reject(error);
	                });
	            });
	        })["catch"](reject);
	    });

	    executeCallback(promise, callback);
	    return promise;
	}

	// Does a simple `COUNT(key)` to get the number of items stored in
	// localForage.
	function length$1(callback) {
	    var self = this;

	    var promise = new Promise$1(function (resolve, reject) {
	        self.ready().then(function () {
	            var dbInfo = self._dbInfo;
	            dbInfo.db.transaction(function (t) {
	                // Ahhh, SQL makes this one soooooo easy.
	                tryExecuteSql(t, dbInfo, 'SELECT COUNT(key) as c FROM ' + dbInfo.storeName, [], function (t, results) {
	                    var result = results.rows.item(0).c;
	                    resolve(result);
	                }, function (t, error) {
	                    reject(error);
	                });
	            });
	        })["catch"](reject);
	    });

	    executeCallback(promise, callback);
	    return promise;
	}

	// Return the key located at key index X; essentially gets the key from a
	// `WHERE id = ?`. This is the most efficient way I can think to implement
	// this rarely-used (in my experience) part of the API, but it can seem
	// inconsistent, because we do `INSERT OR REPLACE INTO` on `setItem()`, so
	// the ID of each key will change every time it's updated. Perhaps a stored
	// procedure for the `setItem()` SQL would solve this problem?
	// TODO: Don't change ID on `setItem()`.
	function key$1(n, callback) {
	    var self = this;

	    var promise = new Promise$1(function (resolve, reject) {
	        self.ready().then(function () {
	            var dbInfo = self._dbInfo;
	            dbInfo.db.transaction(function (t) {
	                tryExecuteSql(t, dbInfo, 'SELECT key FROM ' + dbInfo.storeName + ' WHERE id = ? LIMIT 1', [n + 1], function (t, results) {
	                    var result = results.rows.length ? results.rows.item(0).key : null;
	                    resolve(result);
	                }, function (t, error) {
	                    reject(error);
	                });
	            });
	        })["catch"](reject);
	    });

	    executeCallback(promise, callback);
	    return promise;
	}

	function keys$1(callback) {
	    var self = this;

	    var promise = new Promise$1(function (resolve, reject) {
	        self.ready().then(function () {
	            var dbInfo = self._dbInfo;
	            dbInfo.db.transaction(function (t) {
	                tryExecuteSql(t, dbInfo, 'SELECT key FROM ' + dbInfo.storeName, [], function (t, results) {
	                    var keys = [];

	                    for (var i = 0; i < results.rows.length; i++) {
	                        keys.push(results.rows.item(i).key);
	                    }

	                    resolve(keys);
	                }, function (t, error) {
	                    reject(error);
	                });
	            });
	        })["catch"](reject);
	    });

	    executeCallback(promise, callback);
	    return promise;
	}

	// https://www.w3.org/TR/webdatabase/#databases
	// > There is no way to enumerate or delete the databases available for an origin from this API.
	function getAllStoreNames(db) {
	    return new Promise$1(function (resolve, reject) {
	        db.transaction(function (t) {
	            t.executeSql('SELECT name FROM sqlite_master ' + "WHERE type='table' AND name <> '__WebKitDatabaseInfoTable__'", [], function (t, results) {
	                var storeNames = [];

	                for (var i = 0; i < results.rows.length; i++) {
	                    storeNames.push(results.rows.item(i).name);
	                }

	                resolve({
	                    db: db,
	                    storeNames: storeNames
	                });
	            }, function (t, error) {
	                reject(error);
	            });
	        }, function (sqlError) {
	            reject(sqlError);
	        });
	    });
	}

	function dropInstance$1(options, callback) {
	    callback = getCallback.apply(this, arguments);

	    var currentConfig = this.config();
	    options = typeof options !== 'function' && options || {};
	    if (!options.name) {
	        options.name = options.name || currentConfig.name;
	        options.storeName = options.storeName || currentConfig.storeName;
	    }

	    var self = this;
	    var promise;
	    if (!options.name) {
	        promise = Promise$1.reject('Invalid arguments');
	    } else {
	        promise = new Promise$1(function (resolve) {
	            var db;
	            if (options.name === currentConfig.name) {
	                // use the db reference of the current instance
	                db = self._dbInfo.db;
	            } else {
	                db = openDatabase(options.name, '', '', 0);
	            }

	            if (!options.storeName) {
	                // drop all database tables
	                resolve(getAllStoreNames(db));
	            } else {
	                resolve({
	                    db: db,
	                    storeNames: [options.storeName]
	                });
	            }
	        }).then(function (operationInfo) {
	            return new Promise$1(function (resolve, reject) {
	                operationInfo.db.transaction(function (t) {
	                    function dropTable(storeName) {
	                        return new Promise$1(function (resolve, reject) {
	                            t.executeSql('DROP TABLE IF EXISTS ' + storeName, [], function () {
	                                resolve();
	                            }, function (t, error) {
	                                reject(error);
	                            });
	                        });
	                    }

	                    var operations = [];
	                    for (var i = 0, len = operationInfo.storeNames.length; i < len; i++) {
	                        operations.push(dropTable(operationInfo.storeNames[i]));
	                    }

	                    Promise$1.all(operations).then(function () {
	                        resolve();
	                    })["catch"](function (e) {
	                        reject(e);
	                    });
	                }, function (sqlError) {
	                    reject(sqlError);
	                });
	            });
	        });
	    }

	    executeCallback(promise, callback);
	    return promise;
	}

	var webSQLStorage = {
	    _driver: 'webSQLStorage',
	    _initStorage: _initStorage$1,
	    _support: isWebSQLValid(),
	    iterate: iterate$1,
	    getItem: getItem$1,
	    setItem: setItem$1,
	    removeItem: removeItem$1,
	    clear: clear$1,
	    length: length$1,
	    key: key$1,
	    keys: keys$1,
	    dropInstance: dropInstance$1
	};

	function isLocalStorageValid() {
	    try {
	        return typeof localStorage !== 'undefined' && 'setItem' in localStorage &&
	        // in IE8 typeof localStorage.setItem === 'object'
	        !!localStorage.setItem;
	    } catch (e) {
	        return false;
	    }
	}

	function _getKeyPrefix(options, defaultConfig) {
	    var keyPrefix = options.name + '/';

	    if (options.storeName !== defaultConfig.storeName) {
	        keyPrefix += options.storeName + '/';
	    }
	    return keyPrefix;
	}

	// Check if localStorage throws when saving an item
	function checkIfLocalStorageThrows() {
	    var localStorageTestKey = '_localforage_support_test';

	    try {
	        localStorage.setItem(localStorageTestKey, true);
	        localStorage.removeItem(localStorageTestKey);

	        return false;
	    } catch (e) {
	        return true;
	    }
	}

	// Check if localStorage is usable and allows to save an item
	// This method checks if localStorage is usable in Safari Private Browsing
	// mode, or in any other case where the available quota for localStorage
	// is 0 and there wasn't any saved items yet.
	function _isLocalStorageUsable() {
	    return !checkIfLocalStorageThrows() || localStorage.length > 0;
	}

	// Config the localStorage backend, using options set in the config.
	function _initStorage$2(options) {
	    var self = this;
	    var dbInfo = {};
	    if (options) {
	        for (var i in options) {
	            dbInfo[i] = options[i];
	        }
	    }

	    dbInfo.keyPrefix = _getKeyPrefix(options, self._defaultConfig);

	    if (!_isLocalStorageUsable()) {
	        return Promise$1.reject();
	    }

	    self._dbInfo = dbInfo;
	    dbInfo.serializer = localforageSerializer;

	    return Promise$1.resolve();
	}

	// Remove all keys from the datastore, effectively destroying all data in
	// the app's key/value store!
	function clear$2(callback) {
	    var self = this;
	    var promise = self.ready().then(function () {
	        var keyPrefix = self._dbInfo.keyPrefix;

	        for (var i = localStorage.length - 1; i >= 0; i--) {
	            var key = localStorage.key(i);

	            if (key.indexOf(keyPrefix) === 0) {
	                localStorage.removeItem(key);
	            }
	        }
	    });

	    executeCallback(promise, callback);
	    return promise;
	}

	// Retrieve an item from the store. Unlike the original async_storage
	// library in Gaia, we don't modify return values at all. If a key's value
	// is `undefined`, we pass that value to the callback function.
	function getItem$2(key, callback) {
	    var self = this;

	    key = normalizeKey(key);

	    var promise = self.ready().then(function () {
	        var dbInfo = self._dbInfo;
	        var result = localStorage.getItem(dbInfo.keyPrefix + key);

	        // If a result was found, parse it from the serialized
	        // string into a JS object. If result isn't truthy, the key
	        // is likely undefined and we'll pass it straight to the
	        // callback.
	        if (result) {
	            result = dbInfo.serializer.deserialize(result);
	        }

	        return result;
	    });

	    executeCallback(promise, callback);
	    return promise;
	}

	// Iterate over all items in the store.
	function iterate$2(iterator, callback) {
	    var self = this;

	    var promise = self.ready().then(function () {
	        var dbInfo = self._dbInfo;
	        var keyPrefix = dbInfo.keyPrefix;
	        var keyPrefixLength = keyPrefix.length;
	        var length = localStorage.length;

	        // We use a dedicated iterator instead of the `i` variable below
	        // so other keys we fetch in localStorage aren't counted in
	        // the `iterationNumber` argument passed to the `iterate()`
	        // callback.
	        //
	        // See: github.com/mozilla/localForage/pull/435#discussion_r38061530
	        var iterationNumber = 1;

	        for (var i = 0; i < length; i++) {
	            var key = localStorage.key(i);
	            if (key.indexOf(keyPrefix) !== 0) {
	                continue;
	            }
	            var value = localStorage.getItem(key);

	            // If a result was found, parse it from the serialized
	            // string into a JS object. If result isn't truthy, the
	            // key is likely undefined and we'll pass it straight
	            // to the iterator.
	            if (value) {
	                value = dbInfo.serializer.deserialize(value);
	            }

	            value = iterator(value, key.substring(keyPrefixLength), iterationNumber++);

	            if (value !== void 0) {
	                return value;
	            }
	        }
	    });

	    executeCallback(promise, callback);
	    return promise;
	}

	// Same as localStorage's key() method, except takes a callback.
	function key$2(n, callback) {
	    var self = this;
	    var promise = self.ready().then(function () {
	        var dbInfo = self._dbInfo;
	        var result;
	        try {
	            result = localStorage.key(n);
	        } catch (error) {
	            result = null;
	        }

	        // Remove the prefix from the key, if a key is found.
	        if (result) {
	            result = result.substring(dbInfo.keyPrefix.length);
	        }

	        return result;
	    });

	    executeCallback(promise, callback);
	    return promise;
	}

	function keys$2(callback) {
	    var self = this;
	    var promise = self.ready().then(function () {
	        var dbInfo = self._dbInfo;
	        var length = localStorage.length;
	        var keys = [];

	        for (var i = 0; i < length; i++) {
	            var itemKey = localStorage.key(i);
	            if (itemKey.indexOf(dbInfo.keyPrefix) === 0) {
	                keys.push(itemKey.substring(dbInfo.keyPrefix.length));
	            }
	        }

	        return keys;
	    });

	    executeCallback(promise, callback);
	    return promise;
	}

	// Supply the number of keys in the datastore to the callback function.
	function length$2(callback) {
	    var self = this;
	    var promise = self.keys().then(function (keys) {
	        return keys.length;
	    });

	    executeCallback(promise, callback);
	    return promise;
	}

	// Remove an item from the store, nice and simple.
	function removeItem$2(key, callback) {
	    var self = this;

	    key = normalizeKey(key);

	    var promise = self.ready().then(function () {
	        var dbInfo = self._dbInfo;
	        localStorage.removeItem(dbInfo.keyPrefix + key);
	    });

	    executeCallback(promise, callback);
	    return promise;
	}

	// Set a key's value and run an optional callback once the value is set.
	// Unlike Gaia's implementation, the callback function is passed the value,
	// in case you want to operate on that value only after you're sure it
	// saved, or something like that.
	function setItem$2(key, value, callback) {
	    var self = this;

	    key = normalizeKey(key);

	    var promise = self.ready().then(function () {
	        // Convert undefined values to null.
	        // https://github.com/mozilla/localForage/pull/42
	        if (value === undefined) {
	            value = null;
	        }

	        // Save the original value to pass to the callback.
	        var originalValue = value;

	        return new Promise$1(function (resolve, reject) {
	            var dbInfo = self._dbInfo;
	            dbInfo.serializer.serialize(value, function (value, error) {
	                if (error) {
	                    reject(error);
	                } else {
	                    try {
	                        localStorage.setItem(dbInfo.keyPrefix + key, value);
	                        resolve(originalValue);
	                    } catch (e) {
	                        // localStorage capacity exceeded.
	                        // TODO: Make this a specific error/event.
	                        if (e.name === 'QuotaExceededError' || e.name === 'NS_ERROR_DOM_QUOTA_REACHED') {
	                            reject(e);
	                        }
	                        reject(e);
	                    }
	                }
	            });
	        });
	    });

	    executeCallback(promise, callback);
	    return promise;
	}

	function dropInstance$2(options, callback) {
	    callback = getCallback.apply(this, arguments);

	    options = typeof options !== 'function' && options || {};
	    if (!options.name) {
	        var currentConfig = this.config();
	        options.name = options.name || currentConfig.name;
	        options.storeName = options.storeName || currentConfig.storeName;
	    }

	    var self = this;
	    var promise;
	    if (!options.name) {
	        promise = Promise$1.reject('Invalid arguments');
	    } else {
	        promise = new Promise$1(function (resolve) {
	            if (!options.storeName) {
	                resolve(options.name + '/');
	            } else {
	                resolve(_getKeyPrefix(options, self._defaultConfig));
	            }
	        }).then(function (keyPrefix) {
	            for (var i = localStorage.length - 1; i >= 0; i--) {
	                var key = localStorage.key(i);

	                if (key.indexOf(keyPrefix) === 0) {
	                    localStorage.removeItem(key);
	                }
	            }
	        });
	    }

	    executeCallback(promise, callback);
	    return promise;
	}

	var localStorageWrapper = {
	    _driver: 'localStorageWrapper',
	    _initStorage: _initStorage$2,
	    _support: isLocalStorageValid(),
	    iterate: iterate$2,
	    getItem: getItem$2,
	    setItem: setItem$2,
	    removeItem: removeItem$2,
	    clear: clear$2,
	    length: length$2,
	    key: key$2,
	    keys: keys$2,
	    dropInstance: dropInstance$2
	};

	var sameValue = function sameValue(x, y) {
	    return x === y || typeof x === 'number' && typeof y === 'number' && isNaN(x) && isNaN(y);
	};

	var includes = function includes(array, searchElement) {
	    var len = array.length;
	    var i = 0;
	    while (i < len) {
	        if (sameValue(array[i], searchElement)) {
	            return true;
	        }
	        i++;
	    }

	    return false;
	};

	var isArray = Array.isArray || function (arg) {
	    return Object.prototype.toString.call(arg) === '[object Array]';
	};

	// Drivers are stored here when `defineDriver()` is called.
	// They are shared across all instances of localForage.
	var DefinedDrivers = {};

	var DriverSupport = {};

	var DefaultDrivers = {
	    INDEXEDDB: asyncStorage,
	    WEBSQL: webSQLStorage,
	    LOCALSTORAGE: localStorageWrapper
	};

	var DefaultDriverOrder = [DefaultDrivers.INDEXEDDB._driver, DefaultDrivers.WEBSQL._driver, DefaultDrivers.LOCALSTORAGE._driver];

	var OptionalDriverMethods = ['dropInstance'];

	var LibraryMethods = ['clear', 'getItem', 'iterate', 'key', 'keys', 'length', 'removeItem', 'setItem'].concat(OptionalDriverMethods);

	var DefaultConfig = {
	    description: '',
	    driver: DefaultDriverOrder.slice(),
	    name: 'localforage',
	    // Default DB size is _JUST UNDER_ 5MB, as it's the highest size
	    // we can use without a prompt.
	    size: 4980736,
	    storeName: 'keyvaluepairs',
	    version: 1.0
	};

	function callWhenReady(localForageInstance, libraryMethod) {
	    localForageInstance[libraryMethod] = function () {
	        var _args = arguments;
	        return localForageInstance.ready().then(function () {
	            return localForageInstance[libraryMethod].apply(localForageInstance, _args);
	        });
	    };
	}

	function extend() {
	    var arguments$1 = arguments;

	    for (var i = 1; i < arguments.length; i++) {
	        var arg = arguments$1[i];

	        if (arg) {
	            for (var _key in arg) {
	                if (arg.hasOwnProperty(_key)) {
	                    if (isArray(arg[_key])) {
	                        arguments$1[0][_key] = arg[_key].slice();
	                    } else {
	                        arguments$1[0][_key] = arg[_key];
	                    }
	                }
	            }
	        }
	    }

	    return arguments[0];
	}

	var LocalForage = function () {
	    function LocalForage(options) {
	        var this$1 = this;

	        _classCallCheck(this, LocalForage);

	        for (var driverTypeKey in DefaultDrivers) {
	            if (DefaultDrivers.hasOwnProperty(driverTypeKey)) {
	                var driver = DefaultDrivers[driverTypeKey];
	                var driverName = driver._driver;
	                this$1[driverTypeKey] = driverName;

	                if (!DefinedDrivers[driverName]) {
	                    // we don't need to wait for the promise,
	                    // since the default drivers can be defined
	                    // in a blocking manner
	                    this$1.defineDriver(driver);
	                }
	            }
	        }

	        this._defaultConfig = extend({}, DefaultConfig);
	        this._config = extend({}, this._defaultConfig, options);
	        this._driverSet = null;
	        this._initDriver = null;
	        this._ready = false;
	        this._dbInfo = null;

	        this._wrapLibraryMethodsWithReady();
	        this.setDriver(this._config.driver)["catch"](function () {});
	    }

	    // Set any config values for localForage; can be called anytime before
	    // the first API call (e.g. `getItem`, `setItem`).
	    // We loop through options so we don't overwrite existing config
	    // values.


	    LocalForage.prototype.config = function config(options) {
	        var this$1 = this;

	        // If the options argument is an object, we use it to set values.
	        // Otherwise, we return either a specified config value or all
	        // config values.
	        if ((typeof options === 'undefined' ? 'undefined' : _typeof(options)) === 'object') {
	            // If localforage is ready and fully initialized, we can't set
	            // any new configuration values. Instead, we return an error.
	            if (this._ready) {
	                return new Error("Can't call config() after localforage " + 'has been used.');
	            }

	            for (var i in options) {
	                if (i === 'storeName') {
	                    options[i] = options[i].replace(/\W/g, '_');
	                }

	                if (i === 'version' && typeof options[i] !== 'number') {
	                    return new Error('Database version must be a number.');
	                }

	                this$1._config[i] = options[i];
	            }

	            // after all config options are set and
	            // the driver option is used, try setting it
	            if ('driver' in options && options.driver) {
	                return this.setDriver(this._config.driver);
	            }

	            return true;
	        } else if (typeof options === 'string') {
	            return this._config[options];
	        } else {
	            return this._config;
	        }
	    };

	    // Used to define a custom driver, shared across all instances of
	    // localForage.


	    LocalForage.prototype.defineDriver = function defineDriver(driverObject, callback, errorCallback) {
	        var promise = new Promise$1(function (resolve, reject) {
	            try {
	                var driverName = driverObject._driver;
	                var complianceError = new Error('Custom driver not compliant; see ' + 'https://mozilla.github.io/localForage/#definedriver');

	                // A driver name should be defined and not overlap with the
	                // library-defined, default drivers.
	                if (!driverObject._driver) {
	                    reject(complianceError);
	                    return;
	                }

	                var driverMethods = LibraryMethods.concat('_initStorage');
	                for (var i = 0, len = driverMethods.length; i < len; i++) {
	                    var driverMethodName = driverMethods[i];

	                    // when the property is there,
	                    // it should be a method even when optional
	                    var isRequired = !includes(OptionalDriverMethods, driverMethodName);
	                    if ((isRequired || driverObject[driverMethodName]) && typeof driverObject[driverMethodName] !== 'function') {
	                        reject(complianceError);
	                        return;
	                    }
	                }

	                var configureMissingMethods = function configureMissingMethods() {
	                    var methodNotImplementedFactory = function methodNotImplementedFactory(methodName) {
	                        return function () {
	                            var error = new Error('Method ' + methodName + ' is not implemented by the current driver');
	                            var promise = Promise$1.reject(error);
	                            executeCallback(promise, arguments[arguments.length - 1]);
	                            return promise;
	                        };
	                    };

	                    for (var _i = 0, _len = OptionalDriverMethods.length; _i < _len; _i++) {
	                        var optionalDriverMethod = OptionalDriverMethods[_i];
	                        if (!driverObject[optionalDriverMethod]) {
	                            driverObject[optionalDriverMethod] = methodNotImplementedFactory(optionalDriverMethod);
	                        }
	                    }
	                };

	                configureMissingMethods();

	                var setDriverSupport = function setDriverSupport(support) {
	                    if (DefinedDrivers[driverName]) {
	                        console.info('Redefining LocalForage driver: ' + driverName);
	                    }
	                    DefinedDrivers[driverName] = driverObject;
	                    DriverSupport[driverName] = support;
	                    // don't use a then, so that we can define
	                    // drivers that have simple _support methods
	                    // in a blocking manner
	                    resolve();
	                };

	                if ('_support' in driverObject) {
	                    if (driverObject._support && typeof driverObject._support === 'function') {
	                        driverObject._support().then(setDriverSupport, reject);
	                    } else {
	                        setDriverSupport(!!driverObject._support);
	                    }
	                } else {
	                    setDriverSupport(true);
	                }
	            } catch (e) {
	                reject(e);
	            }
	        });

	        executeTwoCallbacks(promise, callback, errorCallback);
	        return promise;
	    };

	    LocalForage.prototype.driver = function driver() {
	        return this._driver || null;
	    };

	    LocalForage.prototype.getDriver = function getDriver(driverName, callback, errorCallback) {
	        var getDriverPromise = DefinedDrivers[driverName] ? Promise$1.resolve(DefinedDrivers[driverName]) : Promise$1.reject(new Error('Driver not found.'));

	        executeTwoCallbacks(getDriverPromise, callback, errorCallback);
	        return getDriverPromise;
	    };

	    LocalForage.prototype.getSerializer = function getSerializer(callback) {
	        var serializerPromise = Promise$1.resolve(localforageSerializer);
	        executeTwoCallbacks(serializerPromise, callback);
	        return serializerPromise;
	    };

	    LocalForage.prototype.ready = function ready(callback) {
	        var self = this;

	        var promise = self._driverSet.then(function () {
	            if (self._ready === null) {
	                self._ready = self._initDriver();
	            }

	            return self._ready;
	        });

	        executeTwoCallbacks(promise, callback, callback);
	        return promise;
	    };

	    LocalForage.prototype.setDriver = function setDriver(drivers, callback, errorCallback) {
	        var self = this;

	        if (!isArray(drivers)) {
	            drivers = [drivers];
	        }

	        var supportedDrivers = this._getSupportedDrivers(drivers);

	        function setDriverToConfig() {
	            self._config.driver = self.driver();
	        }

	        function extendSelfWithDriver(driver) {
	            self._extend(driver);
	            setDriverToConfig();

	            self._ready = self._initStorage(self._config);
	            return self._ready;
	        }

	        function initDriver(supportedDrivers) {
	            return function () {
	                var currentDriverIndex = 0;

	                function driverPromiseLoop() {
	                    while (currentDriverIndex < supportedDrivers.length) {
	                        var driverName = supportedDrivers[currentDriverIndex];
	                        currentDriverIndex++;

	                        self._dbInfo = null;
	                        self._ready = null;

	                        return self.getDriver(driverName).then(extendSelfWithDriver)["catch"](driverPromiseLoop);
	                    }

	                    setDriverToConfig();
	                    var error = new Error('No available storage method found.');
	                    self._driverSet = Promise$1.reject(error);
	                    return self._driverSet;
	                }

	                return driverPromiseLoop();
	            };
	        }

	        // There might be a driver initialization in progress
	        // so wait for it to finish in order to avoid a possible
	        // race condition to set _dbInfo
	        var oldDriverSetDone = this._driverSet !== null ? this._driverSet["catch"](function () {
	            return Promise$1.resolve();
	        }) : Promise$1.resolve();

	        this._driverSet = oldDriverSetDone.then(function () {
	            var driverName = supportedDrivers[0];
	            self._dbInfo = null;
	            self._ready = null;

	            return self.getDriver(driverName).then(function (driver) {
	                self._driver = driver._driver;
	                setDriverToConfig();
	                self._wrapLibraryMethodsWithReady();
	                self._initDriver = initDriver(supportedDrivers);
	            });
	        })["catch"](function () {
	            setDriverToConfig();
	            var error = new Error('No available storage method found.');
	            self._driverSet = Promise$1.reject(error);
	            return self._driverSet;
	        });

	        executeTwoCallbacks(this._driverSet, callback, errorCallback);
	        return this._driverSet;
	    };

	    LocalForage.prototype.supports = function supports(driverName) {
	        return !!DriverSupport[driverName];
	    };

	    LocalForage.prototype._extend = function _extend(libraryMethodsAndProperties) {
	        extend(this, libraryMethodsAndProperties);
	    };

	    LocalForage.prototype._getSupportedDrivers = function _getSupportedDrivers(drivers) {
	        var this$1 = this;

	        var supportedDrivers = [];
	        for (var i = 0, len = drivers.length; i < len; i++) {
	            var driverName = drivers[i];
	            if (this$1.supports(driverName)) {
	                supportedDrivers.push(driverName);
	            }
	        }
	        return supportedDrivers;
	    };

	    LocalForage.prototype._wrapLibraryMethodsWithReady = function _wrapLibraryMethodsWithReady() {
	        var this$1 = this;

	        // Add a stub for each driver API method that delays the call to the
	        // corresponding driver method until localForage is ready. These stubs
	        // will be replaced by the driver methods as soon as the driver is
	        // loaded, so there is no performance impact.
	        for (var i = 0, len = LibraryMethods.length; i < len; i++) {
	            callWhenReady(this$1, LibraryMethods[i]);
	        }
	    };

	    LocalForage.prototype.createInstance = function createInstance(options) {
	        return new LocalForage(options);
	    };

	    return LocalForage;
	}();

	// The actual localForage object that we expose as a module or via a
	// global. It's extended by pulling in one of our other libraries.


	var localforage_js = new LocalForage();

	module.exports = localforage_js;

	},{"3":3}]},{},[4])(4)
	});
	});

	/**
	 * Framework7 Vue 2.3.0
	 * Build full featured iOS & Android apps using Framework7 & Vue
	 * http://framework7.io/vue/
	 *
	 * Copyright 2014-2018 Vladimir Kharlampidi
	 *
	 * Released under the MIT License
	 *
	 * Released on: May 27, 2018
	 */

	var Utils$2 = {
	  isTrueProp: function isTrueProp(val) {
	    return val === true || val === '';
	  },
	  isStringProp: function isStringProp(val) {
	    return typeof val === 'string' && val !== '';
	  },
	  isObject: function isObject(o) {
	    return typeof o === 'object' && o !== null && o.constructor && o.constructor === Object;
	  },
	  now: function now() {
	    return Date.now();
	  },
	  extend: function extend() {
	    var args = [], len$1 = arguments.length;
	    while ( len$1-- ) args[ len$1 ] = arguments[ len$1 ];

	    var deep = true;
	    var to;
	    var from;
	    if (typeof args[0] === 'boolean') {
	      var assign;
	      (assign = args, deep = assign[0], to = assign[1]);
	      args.splice(0, 2);
	      from = args;
	    } else {
	      var assign$1;
	      (assign$1 = args, to = assign$1[0]);
	      args.splice(0, 1);
	      from = args;
	    }
	    for (var i = 0; i < from.length; i += 1) {
	      var nextSource = args[i];
	      if (nextSource !== undefined && nextSource !== null) {
	        var keysArray = Object.keys(Object(nextSource));
	        for (var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex += 1) {
	          var nextKey = keysArray[nextIndex];
	          var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
	          if (desc !== undefined && desc.enumerable) {
	            if (!deep) {
	              to[nextKey] = nextSource[nextKey];
	            } else if (Utils$2.isObject(to[nextKey]) && Utils$2.isObject(nextSource[nextKey])) {
	              Utils$2.extend(to[nextKey], nextSource[nextKey]);
	            } else if (!Utils$2.isObject(to[nextKey]) && Utils$2.isObject(nextSource[nextKey])) {
	              to[nextKey] = {};
	              Utils$2.extend(to[nextKey], nextSource[nextKey]);
	            } else {
	              to[nextKey] = nextSource[nextKey];
	            }
	          }
	        }
	      }
	    }
	    return to;
	  },
	};

	var Directives = {};
	['color', 'color-theme', 'text-color', 'bg-color', 'border-color', 'ripple-color'].forEach(function (name) {
	  Directives[("f7-" + name)] = function f7ColorDirective(el, binding) {
	    var value = binding.value;
	    var oldValue = binding.oldValue;
	    if (value === oldValue) { return; }
	    if (!value && !oldValue) { return; }
	    if (oldValue) {
	      el.classList.remove((name + "-" + oldValue));
	    }
	    if (value) {
	      el.classList.add((name + "-" + value));
	    }
	  };
	});

	/* eslint no-underscore-dangle: "off" */

	var routerComponentIdCounter = 0;

	var VueRouter = {
	  proto: {
	    pageComponentLoader: function pageComponentLoader(routerEl, component, componentUrl, options, resolve, reject) {
	      var router = this;
	      var el = router.$el[0];
	      var routerVue;
	      function findRouterVue(vueComponent) {
	        if (routerVue) { return; }
	        if (
	          vueComponent.$vnode &&
	          vueComponent.$vnode.tag &&
	          vueComponent.$vnode.tag.indexOf('f7-view') >= 0 &&
	          vueComponent.pages
	        ) {
	          routerVue = vueComponent;
	          return;
	        }
	        if (!vueComponent.$children || vueComponent.$children.length === 0) { return; }
	        vueComponent.$children.forEach(function (childComponent) {
	          findRouterVue(childComponent);
	        });
	      }

	      findRouterVue(el.__vue__);

	      if (!routerVue || !routerVue.pages) {
	        reject();
	        return;
	      }
	      var id = (Utils$2.now()) + "_" + ((routerComponentIdCounter += 1));
	      var pageData = {
	        component: component,
	        id: id,
	        params: Utils$2.extend({}, options.route.params),
	      };
	      routerVue.$f7route = options.route;
	      routerVue.pages.push(pageData);
	      routerVue.$nextTick(function () {
	        var pageEl = el.children[el.children.length - 1];
	        pageData.el = pageEl;

	        var pageEvents;
	        if (component.on) {
	          var pageVueFound;
	          var pageVue = pageEl.__vue__;
	          while (pageVue.$parent && !pageVueFound) {
	            if (pageVue.$parent.$el === pageEl) {
	              pageVue = pageVue.$parent;
	            } else {
	              pageVueFound = true;
	            }
	          }
	          if (pageVue) {
	            pageEvents = Utils$2.extend({}, component.on);
	            Object.keys(pageEvents).forEach(function (pageEvent) {
	              pageEvents[pageEvent] = pageEvents[pageEvent].bind(pageVue);
	            });
	          }
	        }

	        resolve(pageEl, { on: pageEvents });
	      });
	    },
	    removePage: function removePage($pageEl) {
	      if (!$pageEl) { return; }
	      var router = this;
	      var routerVue = router.$el[0].__vue__;

	      var pageEl;
	      if ('length' in $pageEl) {
	        // Dom7
	        if ($pageEl.length === 0) { return; }
	        pageEl = $pageEl[0];
	      } else {
	        pageEl = $pageEl;
	      }
	      if (!pageEl) { return; }
	      var pageVueFound;
	      routerVue.pages.forEach(function (page, index) {
	        if (page.el === pageEl) {
	          pageVueFound = true;
	          routerVue.pages.splice(index, 1);
	        }
	      });
	      if (!pageVueFound) {
	        pageEl.parentNode.removeChild(pageEl);
	      }
	    },
	    tabComponentLoader: function tabComponentLoader(tabEl, component, componentUrl, options, resolve, reject) {
	      if (!tabEl) { reject(); }

	      var tabVue = tabEl.__vue__;
	      if (!tabVue) { reject(); }

	      var id = (Utils$2.now()) + "_" + ((routerComponentIdCounter += 1));
	      tabVue.$set(tabVue, 'tabContent', {
	        id: id,
	        component: component,
	        params: Utils$2.extend({}, options.route.params),
	      });

	      var pageEvents;
	      if (component.on) {
	        pageEvents = Utils$2.extend({}, component.on);
	        Object.keys(pageEvents).forEach(function (pageEvent) {
	          pageEvents[pageEvent] = pageEvents[pageEvent].bind(tabVue);
	        });
	      }

	      tabVue.$nextTick(function () {
	        var tabContentEl = tabEl.children[0];
	        resolve(tabContentEl, { on: pageEvents });
	      });
	    },
	    removeTabContent: function removeTabContent(tabEl) {
	      if (!tabEl) { return; }

	      var tabVue = tabEl.__vue__;
	      if (!tabVue) {
	        tabEl.innerHTML = ''; // eslint-disable-line
	        return;
	      }

	      tabVue.$set(tabVue, 'tabContent', null);
	    },
	    modalComponentLoader: function modalComponentLoader(rootEl, component, componentUrl, options, resolve, reject) {
	      var router = this;
	      var modalsEl = document.querySelector('.framework7-modals');
	      if (!modalsEl) {
	        reject();
	        return;
	      }

	      var modalsVue = modalsEl.__vue__;
	      if (!modalsVue) {
	        reject();
	        return;
	      }

	      var id = (Utils$2.now()) + "_" + ((routerComponentIdCounter += 1));
	      var modalData = {
	        component: component,
	        id: id,
	        params: Utils$2.extend({}, options.route.params),
	      };
	      modalsVue.$f7route = options.route;
	      modalsVue.modals.push(modalData);

	      modalsVue.$nextTick(function () {
	        var modalEl = modalsEl.children[modalsEl.children.length - 1];
	        modalData.el = modalEl;

	        var modalEvents;
	        var modalVueFound;
	        var modalVue = modalEl.__vue__;
	        while (modalVue.$parent && !modalVueFound) {
	          if (modalVue.$parent.$el === modalEl) {
	            modalVue = modalVue.$parent;
	          } else {
	            modalVueFound = true;
	          }
	        }
	        if (component.on && modalVue) {
	          modalEvents = Utils$2.extend({}, component.on);
	          Object.keys(modalEvents).forEach(function (pageEvent) {
	            modalEvents[pageEvent] = modalEvents[pageEvent].bind(modalVue);
	          });
	        }

	        modalEl.addEventListener('modal:closed', function () {
	          modalsVue.$nextTick(function () {
	            router.removeModal(modalEl, modalVue);
	          });
	        });

	        resolve(modalEl, { on: modalEvents });
	      });
	    },
	    removeModal: function removeModal(modalEl, modalVue) {
	      if (!modalVue) { return; }

	      var modalsEl = document.querySelector('.framework7-modals');
	      if (!modalsEl) { return; }

	      var modalsVue = modalsEl.__vue__;
	      if (!modalsVue) { return; }

	      var modalVueFound;
	      modalsVue.modals.forEach(function (modal, index) {
	        if (modal.el === modalEl) {
	          modalVueFound = true;
	          modalsVue.modals.splice(index, 1);
	        }
	      });

	      if (!modalVueFound) {
	        modalEl.parentNode.removeChild(modalEl);
	      }
	    },
	  },
	};

	/* eslint no-param-reassign: "off" */

	// eslint-disable-next-line


	var VuePlugin = {
	  install: function install(Vue, Framework7) {
	    if ( Framework7 === void 0 ) Framework7 = window.Framework7;

	    // Check for F7
	    if (typeof Framework7 === 'undefined') {
	      throw new Error('Framework7 is undefined, make sure you have passed it as an argument: Vue.use(Framework7Vue, Framework7)');
	    }
	    // Event Hub
	    var eventHub = new Vue();

	    // Flags
	    var f7Ready = false;
	    var f7Instance;

	    // Define protos
	    Object.defineProperty(Vue.prototype, '$f7', {
	      get: function get() {
	        return f7Instance;
	      },
	    });

	    var $theme = {};
	    Object.defineProperty(Vue.prototype, '$theme', {
	      get: function get() {
	        return {
	          ios: f7Instance ? f7Instance.theme === 'ios' : $theme.ios,
	          md: f7Instance ? f7Instance.theme === 'md' : $theme.md,
	        };
	      },
	    });
	    Vue.prototype.Dom7 = Framework7.$;
	    Vue.prototype.$$ = Framework7.$;
	    Vue.prototype.$device = Framework7.device;
	    Vue.prototype.$request = Framework7.request;
	    Vue.prototype.$utils = Framework7.utils;

	    // Init F7
	    function initFramework7(rootEl, params, routes) {
	      var f7Params = Utils$2.extend({}, (params || {}), { root: rootEl });
	      if (routes && routes.length && !f7Params.routes) { f7Params.routes = routes; }

	      f7Instance = new Framework7(f7Params);
	      f7Ready = true;
	      eventHub.$emit('f7Ready', f7Instance);
	    }

	    // Extend F7 Router
	    Framework7.Router
	      .use(VueRouter)
	      .use({
	        on: {
	          routeChange: function routeChange(to, from, router) {
	            eventHub.$emit('f7RouteChange', to, from, router);
	          },
	          routeChanged: function routeChanged(to, from, router) {
	            eventHub.$emit('f7RouteChanged', to, from, router);
	          },
	        },
	      });

	    // Mixin
	    Vue.mixin({
	      directives: Directives,
	      components: {
	        // eslint-disable-next-line
	        
	      },
	      beforeCreate: function beforeCreate() {
	        var self = this;
	        if (self === self.$root) {
	          var ref = (self.$options.framework7 || {});
	          var theme = ref.theme;
	          if (theme === 'md') { $theme.md = true; }
	          if (theme === 'ios') { $theme.ios = true; }
	          if (!theme || theme === 'auto') {
	            $theme.ios = !!(Framework7.Device || Framework7.device).ios;
	            $theme.md = !(Framework7.Device || Framework7.device).ios;
	          }
	        }

	        var $route;
	        var $router;
	        var parent = self;
	        while (parent && !$router && !$route) {
	          if (parent.$f7route) { $route = parent.$f7route; }
	          if (parent.$f7router) { $router = parent.$f7router; }
	          else if (parent.f7View) {
	            $router = parent.f7View.router;
	          } else if (parent.$el && parent.$el.f7View) {
	            $router = parent.$el.f7View.router;
	          }
	          parent = parent.$parent;
	        }
	        if ($route && $router) {
	          self.$f7route = $route;
	          self.$f7router = $router;
	          self.$f7Route = $route;
	          self.$f7Router = $router;
	        }
	      },
	      beforeDestroy: function beforeDestroy() {
	        var self = this;
	        if (self.$f7RouteChangeCallback) { eventHub.$off('f7RouteChange', self.$f7RouteChangeCallback); }
	        if (self.$f7RouteChangedCallback) { eventHub.$off('f7RouteChanged', self.$f7RouteChangedCallback); }
	      },
	      created: function created() {
	        var self = this;

	        var routeChangeCallback = self.onF7RouteChange || self.F7RouteChange || self.f7RouteChange || self.f7routeChange;
	        var routeChangedCallback = self.onF7RouteChanged || self.F7RouteChanged || self.f7RouteChanged || self.f7routeChanged;
	        if (!routeChangeCallback && !routeChangedCallback) { return; }

	        function hasRouter(router) {
	          return (self.$f7router && router === self.$f7router) ||
	                 (!self.$f7router && self.$f7 && self.$f7.router);
	        }

	        function addRoutesCallbacks() {
	          if (routeChangeCallback) {
	            self.$f7RouteChangeCallback = function onRouteChange(to, from, router) {
	              if (hasRouter(router)) {
	                routeChangeCallback(to, from, router);
	              }
	            };
	            eventHub.$on('f7RouteChange', self.$f7RouteChangeCallback);
	          }
	          if (routeChangedCallback) {
	            self.$f7RouteChangedCallback = function onRouteChanged(to, from, router) {
	              if (hasRouter(router)) {
	                routeChangedCallback(to, from, router);
	              }
	            };
	            eventHub.$on('f7RouteChanged', self.$f7RouteChangedCallback);
	          }
	        }

	        if (!self.$f7) { eventHub.$once('f7Ready', addRoutesCallbacks); }
	        else { addRoutesCallbacks(); }
	      },
	      mounted: function mounted() {
	        var self = this;
	        if (self === self.$root) {
	          initFramework7(self.$root.$el, self.$options.framework7, self.$options.routes);
	        }
	        var callback = self.onF7Ready || self.onF7ready || self.onF7Init || self.onF7init || self.f7Ready || self.f7Init || self.f7ready || self.f7init;
	        if (!callback) { return; }
	        if (f7Ready) { callback(f7Instance); }
	        else {
	          eventHub.$once('f7Ready', function (f7) {
	            callback(f7);
	          });
	        }
	      },
	    });
	  },
	};

	var Mixins = {
	  colorProps: {
	    color: String,
	    colorTheme: String,
	    textColor: String,
	    bgColor: String,
	    borderColor: String,
	    rippleColor: String,
	    themeDark: Boolean,
	  },
	  colorClasses: function colorClasses(self) {
	    var color = self.color;
	    var colorTheme = self.colorTheme;
	    var textColor = self.textColor;
	    var bgColor = self.bgColor;
	    var borderColor = self.borderColor;
	    var rippleColor = self.rippleColor;
	    var themeDark = self.themeDark;

	    return ( obj = {
	      'theme-dark': themeDark,
	    }, obj[("color-" + color)] = color, obj[("color-theme-" + colorTheme)] = colorTheme, obj[("text-color-" + textColor)] = textColor, obj[("bg-color-" + bgColor)] = bgColor, obj[("border-color-" + borderColor)] = borderColor, obj[("ripple-color-" + rippleColor)] = rippleColor, obj );
	    var obj;
	  },
	  linkIconProps: {
	    icon: String,
	    iconMaterial: String,
	    iconIon: String,
	    iconFa: String,
	    iconF7: String,
	    iconIfMd: String,
	    iconIfIos: String,
	    iconColor: String,
	    iconSize: [String, Number],
	  },
	  linkRouterProps: {
	    back: Boolean,
	    external: Boolean,
	    force: Boolean,
	    animate: Boolean,
	    ignoreCache: Boolean,
	    pageName: String,
	    reloadCurrent: Boolean,
	    reloadAll: Boolean,
	    reloadPrevious: Boolean,
	    routeTabId: String,
	    view: String,
	  },
	  linkRouterAttrs: function linkRouterAttrs(self) {
	    var force = self.force;
	    var reloadCurrent = self.reloadCurrent;
	    var reloadPrevious = self.reloadPrevious;
	    var reloadAll = self.reloadAll;
	    var animate = self.animate;
	    var ignoreCache = self.ignoreCache;
	    var routeTabId = self.routeTabId;
	    var view = self.view;

	    return {
	      'data-force': force,
	      'data-reload-current': reloadCurrent,
	      'data-reload-all': reloadAll,
	      'data-reload-previous': reloadPrevious,
	      'data-animate': ('animate' in self.$options.propsData) ? animate.toString() : undefined,
	      'data-ignore-cache': ignoreCache,
	      'data-route-tab-id': routeTabId,
	      'data-view': Utils$2.isStringProp(view) ? view : false,
	    };
	  },
	  linkRouterClasses: function linkRouterClasses(self) {
	    var back = self.back;
	    var linkBack = self.linkBack;
	    var external = self.external;

	    return {
	      back: back || linkBack,
	      external: external,
	    };
	  },
	  linkActionsProps: {
	    // Panel
	    panelOpen: [Boolean, String],
	    panelClose: [Boolean, String],

	    // Popup
	    popupOpen: [Boolean, String],
	    popupClose: [Boolean, String],

	    // Actions
	    actionsOpen: [Boolean, String],
	    actionsClose: [Boolean, String],

	    // Popover
	    popoverOpen: [Boolean, String],
	    popoverClose: [Boolean, String],

	    // Login Screen
	    loginScreenOpen: [Boolean, String],
	    loginScreenClose: [Boolean, String],

	    // Picker
	    sheetOpen: [Boolean, String],
	    sheetClose: [Boolean, String],

	    // Sortable
	    sortableEnable: [Boolean, String],
	    sortableDisable: [Boolean, String],
	    sortableToggle: [Boolean, String],
	  },
	  linkActionsAttrs: function linkActionsAttrs(self) {
	    var panelOpen = self.panelOpen;
	    var panelClose = self.panelClose;
	    var popupOpen = self.popupOpen;
	    var popupClose = self.popupClose;
	    var actionsOpen = self.actionsOpen;
	    var actionsClose = self.actionsClose;
	    var popoverOpen = self.popoverOpen;
	    var popoverClose = self.popoverClose;
	    var loginScreenOpen = self.loginScreenOpen;
	    var loginScreenClose = self.loginScreenClose;
	    var sheetOpen = self.sheetOpen;
	    var sheetClose = self.sheetClose;
	    var sortableEnable = self.sortableEnable;
	    var sortableDisable = self.sortableDisable;
	    var sortableToggle = self.sortableToggle;

	    return {
	      'data-panel': (Utils$2.isStringProp(panelOpen) && panelOpen) ||
	                    (Utils$2.isStringProp(panelClose) && panelClose),
	      'data-popup': (Utils$2.isStringProp(popupOpen) && popupOpen) ||
	                    (Utils$2.isStringProp(popupClose) && popupClose),
	      'data-actions': (Utils$2.isStringProp(actionsOpen) && actionsOpen) ||
	                    (Utils$2.isStringProp(actionsClose) && actionsClose),
	      'data-popover': (Utils$2.isStringProp(popoverOpen) && popoverOpen) ||
	                      (Utils$2.isStringProp(popoverClose) && popoverClose),
	      'data-sheet': (Utils$2.isStringProp(sheetOpen) && sheetOpen) ||
	                    (Utils$2.isStringProp(sheetClose) && sheetClose),
	      'data-login-screen': (Utils$2.isStringProp(loginScreenOpen) && loginScreenOpen) ||
	                           (Utils$2.isStringProp(loginScreenClose) && loginScreenClose),
	      'data-sortable': (Utils$2.isStringProp(sortableEnable) && sortableEnable) ||
	                       (Utils$2.isStringProp(sortableDisable) && sortableDisable) ||
	                       (Utils$2.isStringProp(sortableToggle) && sortableToggle),
	    };
	  },
	  linkActionsClasses: function linkActionsClasses(self) {
	    var panelOpen = self.panelOpen;
	    var panelClose = self.panelClose;
	    var popupOpen = self.popupOpen;
	    var actionsClose = self.actionsClose;
	    var actionsOpen = self.actionsOpen;
	    var popupClose = self.popupClose;
	    var popoverOpen = self.popoverOpen;
	    var popoverClose = self.popoverClose;
	    var loginScreenOpen = self.loginScreenOpen;
	    var loginScreenClose = self.loginScreenClose;
	    var sheetOpen = self.sheetOpen;
	    var sheetClose = self.sheetClose;
	    var sortableEnable = self.sortableEnable;
	    var sortableDisable = self.sortableDisable;
	    var sortableToggle = self.sortableToggle;
	    return {
	      'panel-close': Utils$2.isTrueProp(panelClose),
	      'panel-open': panelOpen || panelOpen === '',
	      'popup-close': Utils$2.isTrueProp(popupClose),
	      'popup-open': popupOpen || popupOpen === '',
	      'actions-close': Utils$2.isTrueProp(actionsClose),
	      'actions-open': actionsOpen || actionsOpen === '',
	      'popover-close': Utils$2.isTrueProp(popoverClose),
	      'popover-open': popoverOpen || popoverOpen === '',
	      'sheet-close': Utils$2.isTrueProp(sheetClose),
	      'sheet-open': sheetOpen || sheetOpen === '',
	      'login-screen-close': Utils$2.isTrueProp(loginScreenClose),
	      'login-screen-open': loginScreenOpen || loginScreenOpen === '',
	      'sortable-enable': Utils$2.isTrueProp(sortableEnable),
	      'sortable-disable': Utils$2.isTrueProp(sortableDisable),
	      'sortable-toggle': sortableToggle === true || sortableToggle.length,
	    };
	  },
	};

	var accordionContent = {render: function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"accordion-item-content",class:_vm.classes},[_vm._t("default")],2)},staticRenderFns: [],
	  props: Mixins.colorProps,
	  name: 'f7-accordion-content',
	  computed: {
	    classes: function classes() {
	      var self = this;
	      return Mixins.colorClasses(self);
	    },
	  },
	};

	var AccordionItemProps = Utils$2.extend(
	  {
	    opened: Boolean,
	  },
	  Mixins.colorProps
	);

	var accordionItem = {render: function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"accordion-item",class:_vm.classes,on:{"accordion:open":_vm.onOpen,"accordion:opened":_vm.onOpened,"accordion:close":_vm.onClose,"accordion:closed":_vm.onClosed}},[_vm._t("default")],2)},staticRenderFns: [],
	  name: 'f7-accordion-item',
	  props: AccordionItemProps,
	  computed: {
	    classes: function classes() {
	      var self = this;
	      return Utils$2.extend(
	        {
	          'accordion-item-opened': self.opened,
	        },
	        Mixins.colorClasses(self)
	      );
	    },
	  },
	  methods: {
	    onOpen: function onOpen(event) {
	      this.$emit('accordion:open', event);
	    },
	    onOpened: function onOpened(event) {
	      this.$emit('accordion:opened', event);
	    },
	    onClose: function onClose(event) {
	      this.$emit('accordion:close', event);
	    },
	    onClosed: function onClosed(event) {
	      this.$emit('accordion:closed', event);
	    },
	  },
	};

	var accordionToggle = {render: function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"accordion-item-toggle",class:_vm.classes},[_vm._t("default")],2)},staticRenderFns: [],
	  props: Mixins.colorProps,
	  name: 'f7-accordion-toggle',
	  computed: {
	    classes: function classes() {
	      var self = this;
	      return Mixins.colorClasses(self);
	    },
	  },
	};

	var accordion = {render: function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"accordion-list",class:_vm.classes},[_vm._t("default")],2)},staticRenderFns: [],
	  props: Mixins.colorProps,
	  name: 'f7-accordion',
	  computed: {
	    classes: function classes() {
	      var self = this;
	      return Mixins.colorClasses(self);
	    },
	  },
	};

	var ActionsButtonProps = Utils$2.extend(
	  {
	    bold: Boolean,
	    close: {
	      type: Boolean,
	      default: true,
	    },
	  },
	  Mixins.colorProps
	);

	var ActionsLabelProps = Utils$2.extend(
	  {
	    bold: Boolean,
	  },
	  Mixins.colorProps
	);

	var ActionsProps = Utils$2.extend(
	  {
	    opened: Boolean,
	    grid: Boolean,
	    convertToPopover: Boolean,
	    forceToPopover: Boolean,
	    target: [String, Object],
	  },
	  Mixins.colorProps
	);

	var f7Badge = {render: function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"badge",class:_vm.classes},[_vm._t("default")],2)},staticRenderFns: [],
	  props: Mixins.colorProps,
	  name: 'f7-badge',
	  computed: {
	    classes: function classes() {
	      var self = this;
	      return Mixins.colorClasses(self);
	    },
	  },
	};

	var blockFooter = {render: function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block-footer",class:_vm.classes},[_vm._t("default")],2)},staticRenderFns: [],
	  name: 'f7-block-footer',
	  props: Mixins.colorProps,
	  computed: {
	    classes: function classes() {
	      var self = this;
	      return Mixins.colorClasses(self);
	    },
	  },
	};

	var blockHeader = {render: function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block-header",class:_vm.classes},[_vm._t("default")],2)},staticRenderFns: [],
	  props: Mixins.colorProps,
	  name: 'f7-block-header',
	  computed: {
	    classes: function classes() {
	      var self = this;
	      return Mixins.colorClasses(self);
	    },
	  },
	};

	var blockTitle = {render: function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block-title",class:_vm.classes},[_vm._t("default")],2)},staticRenderFns: [],
	  props: Mixins.colorProps,
	  name: 'f7-block-title',
	  computed: {
	    classes: function classes() {
	      var self = this;
	      return Mixins.colorClasses(self);
	    },
	  },
	};

	var BlockProps = Utils$2.extend(
	  {
	    inset: Boolean,
	    tabletInset: Boolean,
	    strong: Boolean,
	    tabs: Boolean,
	    tab: Boolean,
	    tabActive: Boolean,
	    accordionList: Boolean,
	    noHairlines: Boolean,
	    noHairlinesMd: Boolean,
	    noHairlinesIos: Boolean,
	  },
	  Mixins.colorProps
	);

	var block = {render: function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block",class:_vm.classes,on:{"tab:show":_vm.onTabShow,"tab:hide":_vm.onTabHide}},[_vm._t("default")],2)},staticRenderFns: [],
	  name: 'f7-block',
	  props: BlockProps,
	  computed: {
	    classes: function classes() {
	      var self = this;
	      return Utils$2.extend(
	        {
	          inset: self.inset,
	          'block-strong': self.strong,
	          'accordion-list': self.accordionList,
	          'tablet-inset': self.tabletInset,
	          tabs: self.tabs,
	          tab: self.tab,
	          'tab-active': self.tabActive,
	          'no-hairlines': self.noHairlines,
	          'no-hairlines-md': self.noHairlinesMd,
	          'no-hairlines-ios': self.noHairlinesIos,
	        },
	        Mixins.colorClasses(self)
	      );
	    },
	  },
	  methods: {
	    onTabShow: function onTabShow(e) {
	      this.$emit('tab:show', e);
	    },
	    onTabHide: function onTabHide(e) {
	      this.$emit('tab:hide', e);
	    },
	  },
	};

	var IconProps = Utils$2.extend(
	  {
	    material: String, // Material Icons
	    f7: String, // Framework7 Icons
	    ion: String, // Ionicons
	    fa: String, // Font Awesome
	    icon: String, // Custom
	    ifMd: String,
	    ifIos: String,
	    size: [String, Number],
	  },
	  Mixins.colorProps
	);

	var f7Icon = {render: function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{staticClass:"icon",class:_vm.classes,style:({'font-size':_vm.sizeComputed})},[_vm._v(_vm._s(_vm.iconTextComputed)),_vm._t("default")],2)},staticRenderFns: [],
	  name: 'f7-icon',
	  props: IconProps,
	  computed: {
	    sizeComputed: function sizeComputed() {
	      var self = this;
	      var size = self.size;
	      if (typeof size === 'number' || parseFloat(size) === size * 1) {
	        size = size + "px";
	      }
	      return size;
	    },
	    iconTextComputed: function iconTextComputed() {
	      var self = this;
	      var text = self.material || self.f7;
	      if (self.ifMd && self.$theme.md && (self.ifMd.indexOf('material:') >= 0 || self.ifMd.indexOf('f7:') >= 0)) {
	        text = self.ifMd.split(':')[1];
	      } else if (self.ifIos && self.$theme.ios && (self.ifIos.indexOf('material:') >= 0 || self.ifIos.indexOf('f7:') >= 0)) {
	        text = self.ifIos.split(':')[1];
	      }
	      return text;
	    },
	    classes: function classes() {
	      var classes = {};
	      var self = this;
	      if (self.ifMd || self.ifIos) {
	        var parts = self[self.$theme.md ? 'ifMd' : 'ifIos'].split(':');
	        var prop = parts[0];
	        var value = parts[1];
	        if (prop === 'material' || prop === 'fa' || prop === 'f7') {
	          classes.fa = prop === 'fa';
	          classes['material-icons'] = prop === 'material';
	          classes['f7-icons'] = prop === 'f7';
	        }
	        if (prop === 'fa' || prop === 'ion') {
	          classes[(prop + "-" + value)] = true;
	        }
	        if (prop === 'icon') {
	          classes[value] = true;
	        }
	      } else {
	        classes = {
	          'material-icons': this.material,
	          'f7-icons': this.f7,
	          fa: this.fa,
	        };
	        if (this.ion) { classes[("ion-" + (this.ion))] = true; }
	        if (this.fa) { classes[("fa-" + (this.fa))] = true; }
	        if (this.icon) { classes[this.icon] = true; }
	      }
	      return Utils$2.extend(classes, Mixins.colorClasses(self));
	    },
	  },
	};

	var ButtonProps = Utils$2.extend(
	  {
	    noFastclick: Boolean,
	    noFastClick: Boolean,
	    text: String,
	    tabLink: [Boolean, String],
	    tabLinkActive: Boolean,
	    href: {
	      type: [String, Boolean],
	      default: '#',
	    },

	    round: Boolean,
	    roundMd: Boolean,
	    roundIos: Boolean,
	    fill: Boolean,
	    fillMd: Boolean,
	    fillIos: Boolean,
	    big: Boolean,
	    bigMd: Boolean,
	    bigIos: Boolean,
	    small: Boolean,
	    smallMd: Boolean,
	    smallIos: Boolean,
	    raised: Boolean,
	    outline: Boolean,
	    active: Boolean,
	    disabled: Boolean,
	  },
	  Mixins.colorProps,
	  Mixins.linkIconProps,
	  Mixins.linkRouterProps,
	  Mixins.linkActionsProps
	);

	var button = {
	  name: 'f7-button',
	  components: {
	    f7Icon: f7Icon,
	  },
	  props: ButtonProps,
	  render: function render(c) {
	    var self = this;
	    var iconEl;
	    var textEl;
	    if (self.text) {
	      textEl = c('span', {}, self.text);
	    }
	    if (self.icon || self.iconMaterial || self.iconIon || self.iconFa || self.iconF7 || self.iconIfMd || self.iconIfIos) {
	      iconEl = c('f7-icon', {
	        props: {
	          material: self.iconMaterial,
	          ion: self.iconIon,
	          fa: self.iconFa,
	          f7: self.iconF7,
	          icon: self.icon,
	          ifMd: self.iconIfMd,
	          ifIos: self.iconIfIos,
	          color: self.iconColor,
	          size: self.iconSize,
	        },
	      });
	    }
	    self.classes.button = true;
	    var linkEl = c('a', {
	      class: self.classes,
	      attrs: self.attrs,
	      on: {
	        click: self.onClick,
	      },
	    }, [iconEl, textEl, self.$slots.default]);

	    return linkEl;
	  },
	  computed: {
	    attrs: function attrs() {
	      var self = this;
	      var href = self.href;
	      var target = self.target;
	      var tabLink = self.tabLink;
	      var hrefComputed = href;
	      if (href === true) { hrefComputed = '#'; }
	      if (href === false) { hrefComputed = undefined; } // no href attribute
	      return Utils$2.extend(
	        {
	          href: hrefComputed,
	          target: target,
	          'data-tab': Utils$2.isStringProp(tabLink) && tabLink,
	        },
	        Mixins.linkRouterAttrs(self),
	        Mixins.linkActionsAttrs(self)
	      );
	    },
	    classes: function classes() {
	      var self = this;
	      var noFastclick = self.noFastclick;
	      var noFastClick = self.noFastClick;
	      var tabLink = self.tabLink;
	      var tabLinkActive = self.tabLinkActive;
	      var round = self.round;
	      var roundIos = self.roundIos;
	      var roundMd = self.roundMd;
	      var fill = self.fill;
	      var fillIos = self.fillIos;
	      var fillMd = self.fillMd;
	      var big = self.big;
	      var bigIos = self.bigIos;
	      var bigMd = self.bigMd;
	      var small = self.small;
	      var smallIos = self.smallIos;
	      var smallMd = self.smallMd;
	      var raised = self.raised;
	      var active = self.active;
	      var outline = self.outline;
	      var disabled = self.disabled;

	      return Utils$2.extend(
	        {
	          'tab-link': tabLink || tabLink === '',
	          'tab-link-active': tabLinkActive,
	          'no-fastclick': noFastclick || noFastClick,

	          'button-round': round,
	          'button-round-ios': roundIos,
	          'button-round-md': roundMd,
	          'button-fill': fill,
	          'button-fill-ios': fillIos,
	          'button-fill-md': fillMd,
	          'button-big': big,
	          'button-big-ios': bigIos,
	          'button-big-md': bigMd,
	          'button-small': small,
	          'button-small-ios': smallIos,
	          'button-small-md': smallMd,
	          'button-raised': raised,
	          'button-active': active,
	          'button-outline': outline,

	          disabled: disabled,
	        },
	        Mixins.colorClasses(self),
	        Mixins.linkRouterClasses(self),
	        Mixins.linkActionsClasses(self)
	      );
	    },
	  },
	  methods: {
	    onClick: function onClick(event) {
	      this.$emit('click', event);
	    },
	  },
	};

	var CardContentProps = Utils$2.extend(
	  {
	    padding: {
	      type: Boolean,
	      default: true,
	    },
	  },
	  Mixins.colorProps
	);

	var f7CardContent = {render: function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-content",class:_vm.classes},[_vm._t("default")],2)},staticRenderFns: [],
	  name: 'f7-card-content',
	  props: CardContentProps,
	  computed: {
	    classes: function classes() {
	      var self = this;
	      return Utils$2.extend(
	        {
	          'card-content-padding': self.padding,
	        },
	        Mixins.colorClasses(self)
	      );
	    },
	  },
	};

	var f7CardFooter = {render: function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-footer",class:_vm.classes},[_vm._t("default")],2)},staticRenderFns: [],
	  props: Mixins.colorProps,
	  name: 'f7-card-footer',
	  computed: {
	    classes: function classes() {
	      var self = this;
	      return Mixins.colorClasses(self);
	    },
	  },
	};

	var f7CardHeader = {render: function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header",class:_vm.classes},[_vm._t("default")],2)},staticRenderFns: [],
	  props: Mixins.colorProps,
	  name: 'f7-card-header',
	  computed: {
	    classes: function classes() {
	      var self = this;
	      return Mixins.colorClasses(self);
	    },
	  },
	};

	var CardProps = Utils$2.extend(
	  {
	    title: [String, Number],
	    content: [String, Number],
	    footer: [String, Number],
	    padding: {
	      type: Boolean,
	      default: true,
	    },
	  },
	  Mixins.colorProps
	);

	var card = {
	  name: 'f7-card',
	  components: {
	    f7CardHeader: f7CardHeader,
	    f7CardContent: f7CardContent,
	    f7CardFooter: f7CardFooter,
	  },
	  props: CardProps,
	  render: function render(c) {
	    var self = this;
	    var headerEl;
	    var contentEl;
	    var footerEl;

	    if (self.title || (self.$slots && self.$slots.header)) {
	      headerEl = c('f7-card-header', [self.title, self.$slots.header]);
	    }
	    if (self.content || (self.$slots && self.$slots.content)) {
	      contentEl = c('f7-card-content', { props: { padding: self.padding } }, [self.content, self.$slots.content]);
	    }
	    if (self.footer || (self.$slots && self.$slots.footer)) {
	      footerEl = c('f7-card-footer', [self.footer, self.$slots.footer]);
	    }
	    return c('div', { staticClass: 'card', class: self.classes }, [headerEl, contentEl, footerEl, self.$slots.default]);
	  },
	  computed: {
	    classes: function classes() {
	      var self = this;
	      return Mixins.colorClasses(self);
	    },
	  },
	};

	var CheckboxProps = Utils$2.extend({
	  checked: Boolean,
	  name: [Number, String],
	  value: [Number, String, Boolean],
	  disabled: Boolean,
	  readonly: Boolean,
	}, Mixins.colorProps);

	var checkbox = {
	  name: 'f7-checkbox',
	  props: CheckboxProps,
	  render: function render(c) {
	    var self = this;

	    var inputEl = c('input', {
	      attrs: {
	        type: 'checkbox',
	        name: self.name,
	      },
	      domProps: {
	        value: self.value,
	        disabled: self.disabled,
	        readonly: self.readonly,
	        checked: self.checked,
	      },
	      on: {
	        change: self.onChange,
	      },
	    });

	    var iconEl = c('i', { staticClass: 'icon-checkbox' });

	    return c('label', {
	      staticClass: 'checkbox',
	      class: self.classes,
	    }, [inputEl, iconEl, self.$slots.default]);
	  },
	  computed: {
	    classes: function classes() {
	      var self = this;
	      return Utils$2.extend(
	        {
	          disabled: self.disabled,
	        },
	        Mixins.colorClasses(self)
	      );
	    },
	  },
	  methods: {
	    onChange: function onChange(event) {
	      this.$emit('change', event);
	    },
	  },
	};

	var ChipProps = Utils$2.extend({
	  media: String,
	  text: [String, Number],
	  deleteable: Boolean,
	  mediaBgColor: String,
	  mediaTextColor: String,
	}, Mixins.colorProps);

	var chip = {
	  name: 'f7-chip',
	  props: ChipProps,
	  render: function render(c) {
	    var self = this;
	    var mediaEl;
	    var labelEl;
	    var deleteEl;
	    if (self.media || (self.$slots && self.$slots.media)) {
	      mediaEl = c('div', { staticClass: 'chip-media', class: self.mediaClasses }, self.media || self.$slots.media);
	    }
	    if (self.text || (self.$slots && self.$slots.text)) {
	      labelEl = c('div', { staticClass: 'chip-label' }, [self.text, self.$slots.text]);
	    }
	    if (self.deleteable) {
	      deleteEl = c('a', {
	        staticClass: 'chip-delete',
	        attrs: {
	          href: '#',
	        },
	        on: {
	          click: self.onDeleteClick,
	        },
	      });
	    }
	    return c('div', {
	      staticClass: 'chip',
	      class: self.classes,
	      on: {
	        click: self.onClick,
	      },
	    }, [mediaEl, labelEl, deleteEl]);
	  },
	  computed: {
	    classes: function classes() {
	      var self = this;
	      return Mixins.colorClasses(self);
	    },
	    mediaClasses: function mediaClasses() {
	      var c = {};
	      if (this.mediaTextColor) { c[("text-color-" + (this.mediaTextColor))] = true; }
	      if (this.mediaBgColor) { c[("bg-color-" + (this.mediaBgColor))] = true; }
	      return c;
	    },
	  },
	  methods: {
	    onClick: function onClick(event) {
	      this.$emit('click', event);
	    },
	    onDeleteClick: function onDeleteClick(event) {
	      this.$emit('delete', event);
	    },
	  },
	};

	var ColProps = Utils$2.extend(
	  {
	    tag: {
	      type: String,
	      default: 'div',
	    },
	    width: {
	      type: [Number, String],
	      default: 'auto',
	    },
	    tabletWidth: {
	      type: [Number, String],
	    },
	    desktopWidth: {
	      type: [Number, String],
	    },
	  },
	  Mixins.colorProps
	);

	var col = {
	  name: 'f7-col',
	  props: ColProps,
	  render: function render(c) {
	    var self = this;
	    return c(self.tag, {
	      class: self.classes,
	    }, [self.$slots.default]);
	  },
	  computed: {
	    classes: function classes() {
	      var self = this;
	      return Utils$2.extend(
	        ( obj = {
	          col: self.width === 'auto',
	        }, obj[("col-" + (self.width))] = self.width !== 'auto', obj[("tablet-" + (self.tabletWidth))] = self.tabletWidth, obj[("desktop-" + (self.desktopWidth))] = self.desktopWidth, obj ),
	        Mixins.colorClasses(self)
	      );
	      var obj;
	    },
	  },
	};

	var FabButtonProps = Utils$2.extend(
	  {
	    fabClose: Boolean,
	  },
	  Mixins.colorProps
	);

	var fabButton = {render: function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:_vm.classes,on:{"click":_vm.onClick}},[_vm._t("default")],2)},staticRenderFns: [],
	  name: 'f7-fab-button',
	  props: FabButtonProps,
	  computed: {
	    classes: function classes() {
	      var self = this;
	      return Utils$2.extend(
	        {
	          'fab-close': self.fabClose,
	        },
	        Mixins.colorClasses(self)
	      );
	    },
	  },
	  methods: {
	    onClick: function onClick(event) {
	      this.$emit('click', event);
	    },
	  },
	};

	var FabButtonsProps = Utils$2.extend(
	  {
	    position: {
	      type: String,
	      default: 'top',
	    },
	  },
	  Mixins.colorProps
	);

	var fabButtons = {render: function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fab-buttons",class:_vm.classes},[_vm._t("default")],2)},staticRenderFns: [],
	  name: 'f7-fab-buttons',
	  props: FabButtonsProps,
	  computed: {
	    classes: function classes() {
	      var self = this;
	      return Utils$2.extend(
	        ( obj = {}, obj[("fab-buttons-" + (self.position))] = true, obj ),
	        Mixins.colorClasses(self)
	      );
	      var obj;
	    },
	  },
	};

	var FabProps = Utils$2.extend(
	  {
	    morphTo: String,
	    href: [Boolean, String],
	    position: {
	      type: String,
	      default: 'right-bottom',
	    },
	  },
	  Mixins.colorProps
	);

	var fab = {
	  name: 'f7-fab',
	  props: FabProps,
	  render: function render(c) {
	    var self = this;

	    var href = self.href;
	    if (href === true) { href = '#'; }
	    if (href === false) { href = undefined; } // no href attribute

	    var linkChildren = [];
	    var fabChildren = [];

	    if (self.$slots.default) {
	      for (var i = 0; i < self.$slots.default.length; i += 1) {
	        var child = self.$slots.default[i];
	        if (child.tag && child.tag.indexOf('fab-buttons') >= 0) {
	          fabChildren.push(child);
	        } else {
	          linkChildren.push(child);
	        }
	      }
	    }

	    var linkEl = c('a', {
	      attrs: {
	        href: href,
	      },
	      on: {
	        click: self.onClick,
	      },
	    }, linkChildren);

	    fabChildren.push(linkEl);

	    return c('div', {
	      staticClass: 'fab',
	      class: self.classes,
	      attrs: {
	        'data-morph-to': self.morphTo,
	      },
	    }, fabChildren);
	  },
	  computed: {
	    classes: function classes() {
	      var self = this;
	      return Utils$2.extend(
	        ( obj = {
	          'fab-morph': self.morphTo,
	        }, obj[("fab-" + (self.position))] = true, obj ),
	        Mixins.colorClasses(self)
	      );
	      var obj;
	    },
	  },
	  methods: {
	    onClick: function onClick(event) {
	      var self = this;
	      self.$emit('click', event);
	    },
	  },
	};

	var ToggleProps = Utils$2.extend({
	  init: {
	    type: Boolean,
	    default: true,
	  },
	  checked: Boolean,
	  disabled: Boolean,
	  readonly: Boolean,
	  name: String,
	  value: [String, Number, Array],
	}, Mixins.colorProps);

	var f7Toggle = {
	  name: 'f7-toggle',
	  render: function render(c) {
	    var self = this;

	    return c('label', {
	      staticClass: 'toggle',
	      class: Utils$2.extend(
	        {
	          disabled: self.disabled,
	        },
	        Mixins.colorClasses(self)
	      ),
	    }, [
	      c('input', {
	        attrs: {
	          type: 'checkbox',
	          name: self.name,
	        },
	        domProps: {
	          disabled: self.disabled,
	          readonly: self.readonly,
	          checked: self.checked,
	          value: self.value,
	        },
	        on: {
	          change: self.onChange,
	        },
	      }),
	      c('span', { staticClass: 'toggle-icon' }) ]);
	  },
	  props: ToggleProps,
	  watch: {
	    checked: function checked(newValue) {
	      var self = this;
	      if (!self.f7Toggle) { return; }
	      self.f7Toggle.checked = newValue;
	    },
	  },
	  beforeDestroy: function beforeDestroy() {
	    var self = this;
	    if (self.f7Toggle && self.f7Toggle.destroy && self.f7Toggle.$el) { self.f7Toggle.destroy(); }
	  },
	  methods: {
	    toggle: function toggle() {
	      var self = this;
	      if (self.f7Toggle && self.f7Toggle.setValue) { self.f7Toggle.toggle(); }
	    },
	    onChange: function onChange(e) {
	      var self = this;
	      self.$emit('change', e);
	    },
	    onF7Ready: function onF7Ready(f7) {
	      var self = this;
	      if (!self.init) { return; }
	      self.$nextTick(function () {
	        self.f7Toggle = f7.toggle.create({
	          el: self.$el,
	          on: {
	            change: function change(toggle) {
	              self.$emit('toggle:change', toggle.checked);
	            },
	          },
	        });
	      });
	    },
	  },
	};

	var RangeProps = Utils$2.extend({
	  init: {
	    type: Boolean,
	    default: true,
	  },
	  value: {
	    type: [Number, Array, String],
	    default: 0,
	  },
	  min: {
	    type: [Number, String],
	    default: 0,
	  },
	  max: {
	    type: [Number, String],
	    default: 100,
	  },
	  step: {
	    type: [Number, String],
	    default: 1,
	  },
	  label: {
	    type: Boolean,
	    default: false,
	  },
	  dual: {
	    type: Boolean,
	    default: false,
	  },
	  disabled: Boolean,
	  draggableBar: {
	    type: Boolean,
	    default: true,
	  },
	}, Mixins.colorProps);

	var f7Range = {
	  name: 'f7-range',
	  render: function render(c) {
	    var self = this;

	    return c('div', {
	      staticClass: 'range-slider',
	      class: Utils$2.extend({
	        disabled: self.disabled,
	      }, Mixins.colorClasses(self)),
	    });
	  },
	  props: RangeProps,
	  watch: {
	    value: function value(newValue) {
	      var self = this;
	      if (!self.f7Range) { return; }
	      self.f7Range.setValue(newValue);
	    },
	  },
	  beforeDestroy: function beforeDestroy() {
	    var self = this;
	    if (self.f7Range && self.f7Range.destroy) { self.f7Range.destroy(); }
	  },
	  methods: {
	    setValue: function setValue(newValue) {
	      var self = this;
	      if (self.f7Range && self.f7Range.setValue) { self.f7Range.setValue(newValue); }
	    },
	    getValue: function getValue() {
	      var self = this;
	      if (self.f7Range && self.f7Range.getValue) {
	        return self.f7Range.getValue();
	      }
	      return undefined;
	    },
	    onF7Ready: function onF7Ready(f7) {
	      var self = this;
	      if (!self.init) { return; }
	      self.$nextTick(function () {
	        self.f7Range = f7.range.create({
	          el: self.$el,
	          value: self.value,
	          min: self.min,
	          max: self.max,
	          step: self.step,
	          label: self.label,
	          dual: self.dual,
	          draggableBar: self.draggableBar,
	          on: {
	            change: function change(range, value) {
	              self.$emit('range:change', value);
	            },
	            changed: function changed(range, value) {
	              self.$emit('range:changed', value);
	            },
	          },
	        });
	      });
	    },
	  },
	};

	var InputProps = Utils$2.extend(
	  {
	    // Inputs
	    type: String,
	    name: String,
	    value: [String, Number, Array],
	    placeholder: String,
	    id: String,
	    size: [String, Number],
	    accept: [String, Number],
	    autocomplete: [String],
	    autocorrect: [String],
	    autocapitalize: [String],
	    spellcheck: [String],
	    autofocus: Boolean,
	    autosave: String,
	    checked: Boolean,
	    disabled: Boolean,
	    max: [String, Number],
	    min: [String, Number],
	    step: [String, Number],
	    maxlength: [String, Number],
	    minlength: [String, Number],
	    multiple: Boolean,
	    readonly: Boolean,
	    required: Boolean,
	    inputStyle: String,
	    pattern: String,
	    validate: Boolean,
	    tabindex: [String, Number],
	    resizable: Boolean,
	    clearButton: Boolean,

	    // Error, Info
	    errorMessage: String,
	    info: String,

	    // Components
	    wrap: {
	      type: Boolean,
	      default: true,
	    },
	  },
	  Mixins.colorProps
	);

	var f7Input = {
	  name: 'f7-input',
	  components: {
	    f7Toggle: f7Toggle,
	    f7Range: f7Range,
	  },
	  props: InputProps,
	  render: function render(c) {
	    var inputEl;
	    var self = this;
	    var attrs = {
	      name: self.name,
	      type: self.type,
	      placeholder: self.placeholder,
	      id: self.id,
	      value: self.value,
	      size: self.size,
	      accept: self.accept,
	      autocomplete: self.autocomplete,
	      autocorrect: self.autocorrect,
	      autocapitalize: self.autocapitalize,
	      spellcheck: self.spellcheck,
	      autofocus: self.autofocus,
	      autosave: self.autosave,
	      checked: self.checked,
	      disabled: self.disabled,
	      max: self.max,
	      maxlength: self.maxlength,
	      min: self.min,
	      minlength: self.minlength,
	      step: self.step,
	      multiple: self.multiple,
	      readonly: self.readonly,
	      required: self.required,
	      pattern: self.pattern,
	      validate: self.validate,
	      tabindex: self.tabindex,
	      'data-error-message': self.errorMessage,
	    };
	    var on = {
	      focus: self.onFocus,
	      blur: self.onBlur,
	      input: self.onInput,
	      change: self.onChange,
	      'textarea:resize': self.onTextareaResize,
	      'input:notempty': self.onInputNotEmpty,
	      'input:empty': self.onInputEmpty,
	      'input:clear': self.onInputClear,
	    };
	    if (self.type === 'select' || self.type === 'textarea' || self.type === 'file') {
	      delete attrs.value;
	      if (self.type === 'select') {
	        inputEl = c('select', {
	          attrs: attrs, on: on, style: self.inputStyle, domProps: { value: self.value },
	        }, self.$slots.default);
	      } else if (self.type === 'file') {
	        inputEl = c('input', { attrs: attrs, style: self.inputStyle, on: on }, self.$slots.default);
	      } else {
	        inputEl = c('textarea', {
	          attrs: attrs,
	          style: self.inputStyle,
	          on: on,
	          class: { resizable: self.resizable },
	          domProps: { value: self.value },
	        }, self.$slots.default);
	      }
	    } else if ((self.$slots.default && self.$slots.default.length > 0) || !self.type) {
	      inputEl = self.$slots.default;
	    } else if (self.type === 'toggle') {
	      inputEl = c('f7-toggle', { props: attrs, on: on, attrs: { id: attrs.id } });
	    } else if (self.type === 'range') {
	      on['range:change'] = self.onChange;
	      inputEl = c('f7-range', { props: attrs, on: on, attrs: { id: attrs.id } });
	    } else {
	      inputEl = c('input', {
	        attrs: attrs,
	        style: self.inputStyle,
	        on: on,
	        domProps: { value: self.value, checked: self.checked },
	      });
	    }

	    var clearButtonEl;
	    if (self.clearButton) {
	      clearButtonEl = c('span', { staticClass: 'input-clear-button' });
	    }

	    var $parent = self.$parent;
	    var foundItemContent;
	    while ($parent && !foundItemContent) {
	      var tag = $parent.$vnode && $parent.$vnode.tag;
	      if (tag && (tag.indexOf('list-item') > 0 || tag.indexOf('list-item-content') > 0)) {
	        foundItemContent = $parent;
	      }
	      $parent = $parent.$parent;
	    }
	    if (foundItemContent) { foundItemContent.itemInputForced = true; }
	    if (foundItemContent && (self.info || (self.$slots.info && self.$slots.info.length))) { foundItemContent.itemInputWithInfoForced = true; }

	    var infoEl;
	    if (self.info || (self.$slots.info && self.$slots.info.length)) {
	      infoEl = c('div', { staticClass: 'item-input-info' }, [self.info, self.$slots.info]);
	    }

	    var itemInput = self.wrap ? c('div', { staticClass: 'item-input-wrap', class: self.classes }, [inputEl, clearButtonEl, infoEl]) : inputEl;
	    return itemInput;
	  },
	  computed: {
	    classes: function classes() {
	      var self = this;
	      return Mixins.colorClasses(self);
	    },
	  },
	  watch: {
	    value: function value() {
	      var self = this;
	      if (self.type === 'range' || self.type === 'toggle') { return; }
	      var f7 = self.$f7;
	      if (!f7) { return; }
	      var inputEl = self.wrap ? self.$el.querySelector('input, select, textarea') : self.$el;
	      self.$nextTick(function () {
	        f7.input.checkEmptyState(inputEl);
	        if (self.validate) {
	          f7.input.validate(inputEl);
	        }
	        if (self.resizable) {
	          f7.input.resizeTextarea(inputEl);
	        }
	      });
	    },
	  },
	  methods: {
	    onF7Ready: function onF7Ready(f7) {
	      var self = this;
	      var inputEl = self.wrap ? self.$el.querySelector('input, select, textarea') : self.$el;
	      f7.input.checkEmptyState(inputEl);
	      if (self.validate) {
	        f7.input.validate(inputEl);
	      }
	      if (self.resizable) {
	        f7.input.resizeTextarea(inputEl);
	      }
	    },
	    onTextareaResize: function onTextareaResize(event) {
	      this.$emit('textarea:resize', event);
	    },
	    onInputNotEmpty: function onInputNotEmpty(event) {
	      this.$emit('input:notempty', event);
	    },
	    onInputEmpty: function onInputEmpty(event) {
	      this.$emit('input:empty', event);
	    },
	    onInputClear: function onInputClear(event) {
	      this.$emit('input:clear', event);
	    },
	    onInput: function onInput(event) {
	      this.$emit('input', event);
	    },
	    onFocus: function onFocus(event) {
	      this.$emit('focus', event);
	    },
	    onBlur: function onBlur(event) {
	      this.$emit('blur', event);
	    },
	    onChange: function onChange(event) {
	      var self = this;
	      self.$emit('change', event);
	    },
	  },
	};

	var LabelProps = Utils$2.extend(
	  {
	    floating: Boolean,
	    inline: Boolean,
	  },
	  Mixins.colorProps
	);

	var label = {
	  name: 'f7-label',
	  props: LabelProps,
	  render: function render(c) {
	    var self = this;

	    if (self.inline) {
	      var $parent = self.$parent;
	      var foundItemContent;
	      while ($parent && !foundItemContent) {
	        var tag = $parent.$vnode && $parent.$vnode.tag;
	        if (tag && (tag.indexOf('list-item') > 0 || tag.indexOf('list-item-content') > 0)) {
	          foundItemContent = $parent;
	        }
	        $parent = $parent.$parent;
	      }
	      if (foundItemContent) { foundItemContent.inlineLabelForced = true; }
	    }

	    return c('div', {
	      staticClass: 'item-title',
	      class: self.classes,
	    }, [self.$slots.default]);
	  },
	  computed: {
	    classes: function classes() {
	      var self = this;
	      return Utils$2.extend(
	        {
	          'item-label': !self.floating,
	          'item-floating-label': self.floating,
	        },
	        Mixins.colorClasses(self)
	      );
	    },
	  },
	};

	var LinkProps = Utils$2.extend(
	  {
	    noLinkClass: Boolean,
	    noFastClick: Boolean,
	    noFastclick: Boolean,
	    text: String,
	    tabLink: [Boolean, String],
	    tabLinkActive: Boolean,
	    iconOnly: Boolean,
	    badge: [String, Number],
	    badgeColor: [String],
	    iconBadge: [String, Number],
	    href: {
	      type: [String, Boolean],
	      default: '#',
	    },
	  },
	  Mixins.colorProps,
	  Mixins.linkIconProps,
	  Mixins.linkRouterProps,
	  Mixins.linkActionsProps
	);

	var f7Link = {
	  name: 'f7-link',
	  components: {
	    f7Badge: f7Badge,
	    f7Icon: f7Icon,
	  },
	  props: LinkProps,
	  render: function render(c) {
	    var self = this;
	    var isTabbarLabel = (self.tabLink || self.tabLink === '') && self.$parent && self.$parent.tabbar && self.$parent.labels;

	    var iconEl;
	    var textEl;
	    var badgeEl;
	    var iconBadgeEl;

	    if (self.text) {
	      if (self.badge) { badgeEl = c('f7-badge', { props: { color: self.badgeColor } }, self.badge); }
	      textEl = c('span', { class: { 'tabbar-label': isTabbarLabel } }, [self.text, badgeEl]);
	    }
	    if (self.icon || self.iconMaterial || self.iconIon || self.iconFa || self.iconF7 || (self.iconIfMd && self.$theme.md) || (self.iconIfIos && self.$theme.ios)) {
	      if (self.iconBadge) { iconBadgeEl = c('f7-badge', { props: { color: self.badgeColor } }, self.iconBadge); }
	      iconEl = c('f7-icon', {
	        props: {
	          material: self.iconMaterial,
	          ion: self.iconIon,
	          fa: self.iconFa,
	          f7: self.iconF7,
	          icon: self.icon,
	          ifMd: self.iconIfMd,
	          ifIos: self.iconIfIos,
	          color: self.iconColor,
	          size: self.iconSize,
	        },
	      }, [iconBadgeEl]);
	    }
	    if (
	      self.iconOnly ||
	      (!self.text && self.$slots.default && self.$slots.default.length === 0) ||
	      (!self.text && !self.$slots.default)
	    ) {
	      self.classes['icon-only'] = true;
	    }
	    self.classes.link = !(self.noLinkClass || isTabbarLabel);
	    var linkEl = c('a', {
	      class: self.classes,
	      attrs: self.attrs,
	      on: {
	        click: self.onClick,
	      },
	    }, [iconEl, textEl, self.$slots.default]);
	    return linkEl;
	  },
	  computed: {
	    attrs: function attrs() {
	      var self = this;
	      var href = self.href;
	      var target = self.target;
	      var tabLink = self.tabLink;
	      var hrefComputed = href;
	      if (href === true) { hrefComputed = '#'; }
	      if (href === false) { hrefComputed = undefined; } // no href attribute
	      return Utils$2.extend(
	        {
	          href: hrefComputed,
	          target: target,
	          'data-tab': Utils$2.isStringProp(tabLink) && tabLink,
	        },
	        Mixins.linkRouterAttrs(self),
	        Mixins.linkActionsAttrs(self)
	      );
	    },
	    classes: function classes() {
	      var self = this;
	      var noFastclick = self.noFastclick;
	      var noFastClick = self.noFastClick;
	      var tabLink = self.tabLink;
	      var tabLinkActive = self.tabLinkActive;

	      return Utils$2.extend(
	        {
	          'tab-link': tabLink || tabLink === '',
	          'tab-link-active': tabLinkActive,
	          'no-fastclick': noFastclick || noFastClick,
	        },
	        Mixins.colorClasses(self),
	        Mixins.linkRouterClasses(self),
	        Mixins.linkActionsClasses(self)
	      );
	    },
	  },
	  methods: {
	    onClick: function onClick(event) {
	      this.$emit('click', event);
	    },
	  },
	};

	var ListButtonProps = Utils$2.extend(
	  {
	    noFastclick: Boolean,
	    noFastClick: Boolean,
	    title: [String, Number],
	    text: [String, Number],
	    tabLink: [Boolean, String],
	    tabLinkActive: Boolean,
	    link: [Boolean, String],
	    href: [Boolean, String],
	    target: String,
	  },
	  Mixins.colorProps,
	  Mixins.linkRouterProps,
	  Mixins.linkActionsProps
	);

	var listButton = {
	  name: 'f7-list-button',
	  render: function render(c) {
	    var self = this;
	    var linkEl = c('a', {
	      staticClass: 'item-link list-button',
	      attrs: self.attrs,
	      class: self.classes,
	      on: {
	        click: self.onClick,
	      },
	    }, [self.title || self.text, self.$slots.default]);
	    return c('li', {}, [linkEl]);
	  },
	  props: ListButtonProps,
	  computed: {
	    attrs: function attrs() {
	      var self = this;
	      // Link Props
	      var link = self.link;
	      var href = self.href;
	      var target = self.target;
	      var tabLink = self.tabLink;

	      return Utils$2.extend(
	        {
	          href: ((typeof link === 'boolean' && typeof href === 'boolean') ? '#' : (link || href)),
	          target: target,
	          'data-tab': Utils$2.isStringProp(tabLink) && tabLink,
	        },
	        Mixins.linkRouterAttrs(self),
	        Mixins.linkActionsAttrs(self)
	      );
	    },
	    classes: function classes() {
	      var self = this;

	      var noFastclick = self.noFastclick;
	      var noFastClick = self.noFastClick;
	      var tabLink = self.tabLink;
	      var tabLinkActive = self.tabLinkActive;

	      return Utils$2.extend(
	        {
	          'tab-link': tabLink || tabLink === '',
	          'tab-link-active': tabLinkActive,
	          'no-fastclick': noFastclick || noFastClick,
	        },
	        Mixins.colorClasses(self),
	        Mixins.linkRouterClasses(self),
	        Mixins.linkActionsClasses(self)
	      );
	    },
	  },
	  methods: {
	    onClick: function onClick(event) {
	      this.$emit('click', event);
	    },
	  },
	};

	var ListGroupProps = Utils$2.extend(
	  {
	    mediaList: Boolean,
	    sortable: Boolean,
	  },
	  Mixins.colorProps
	);

	var ListIndexProps = Utils$2.extend(
	  {
	    init: {
	      type: Boolean,
	      default: true,
	    },
	    listEl: [String, Object],
	    indexes: {
	      type: [String, Array],
	      default: 'auto',
	    },
	    scrollList: {
	      type: Boolean,
	      default: true,
	    },
	    label: {
	      type: Boolean,
	      default: false,
	    },
	    iosItemHeight: {
	      type: Number,
	      default: 14,
	    },
	    mdItemHeight: {
	      type: Number,
	      default: 14,
	    },
	  },
	  Mixins.colorProps
	);

	var listItemCell = {render: function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item-cell",class:_vm.classes},[_vm._t("default")],2)},staticRenderFns: [],
	  name: 'f7-list-item-cell',
	  props: Mixins.colorProps,
	  computed: {
	    classes: function classes() {
	      var self = this;
	      return Mixins.colorClasses(self);
	    },
	  },
	};

	var ListItemContentProps = Utils$2.extend(
	  {
	    title: [String, Number],
	    text: [String, Number],
	    media: String,
	    subtitle: [String, Number],
	    header: [String, Number],
	    footer: [String, Number],
	    after: [String, Number],
	    badge: [String, Number],
	    badgeColor: String,
	    mediaList: Boolean,
	    itemInput: Boolean,
	    itemInputWithInfo: Boolean,
	    inlineLabel: Boolean,

	    checkbox: Boolean,
	    checked: Boolean,
	    radio: Boolean,
	    name: String,
	    value: [String, Number, Array],
	    readonly: Boolean,
	    required: Boolean,
	    disabled: Boolean,
	  },
	  Mixins.colorProps
	);

	var f7ListItemContent = {
	  name: 'f7-list-item-content',
	  components: {
	    f7Badge: f7Badge,
	  },
	  props: ListItemContentProps,
	  render: function render(c) {
	    var self = this;
	    var slotsContentStart = [];
	    var slotsContent = [];
	    var slotsContentEnd = [];
	    var slotsInnerStart = [];
	    var slotsInner = [];
	    var slotsInnerEnd = [];
	    var slotsAfterStart = [];
	    var slotsAfter = [];
	    var slotsAfterEnd = [];
	    var slotsMedia = [];
	    var slotsBeforeTitle = [];
	    var slotsTitle = [];
	    var slotsAfterTitle = [];
	    var slotsSubtitle = [];
	    var slotsText = [];
	    var slotsHeader = [];
	    var slotsFooter = [];

	    var ref = [];
	    var titleEl = ref[0];
	    var afterWrapEl = ref[1];
	    var afterEl = ref[2];
	    var badgeEl = ref[3];
	    var innerEl = ref[4];
	    var titleRowEl = ref[5];
	    var subtitleEl = ref[6];
	    var textEl = ref[7];
	    var mediaEl = ref[8];
	    var inputEl = ref[9];
	    var inputIconEl = ref[10];
	    var headerEl = ref[11];
	    var footerEl = ref[12];

	    if (self.$slots.default && self.$slots.default.length > 0) {
	      for (var i = 0; i < self.$slots.default.length; i += 1) {
	        var slotName = self.$slots.default[i].data ? self.$slots.default[i].data.slot : undefined;
	        if (!slotName || (slotName === 'inner')) { slotsInner.push(self.$slots.default[i]); }
	        if (slotName === 'content-start') { slotsContentStart.push(self.$slots.default[i]); }
	        if (slotName === 'content') { slotsContent.push(self.$slots.default[i]); }
	        if (slotName === 'content-end') { slotsContentEnd.push(self.$slots.default[i]); }
	        if (slotName === 'after-start') { slotsAfterStart.push(self.$slots.default[i]); }
	        if (slotName === 'after') { slotsAfter.push(self.$slots.default[i]); }
	        if (slotName === 'after-end') { slotsAfterEnd.push(self.$slots.default[i]); }
	        if (slotName === 'media') { slotsMedia.push(self.$slots.default[i]); }
	        if (slotName === 'inner-start') { slotsInnerStart.push(self.$slots.default[i]); }
	        if (slotName === 'inner-end') { slotsInnerEnd.push(self.$slots.default[i]); }
	        if (slotName === 'before-title') { slotsBeforeTitle.push(self.$slots.default[i]); }
	        if (slotName === 'title') { slotsTitle.push(self.$slots.default[i]); }
	        if (slotName === 'after-title') { slotsAfterTitle.push(self.$slots.default[i]); }
	        if (slotName === 'subtitle') { slotsSubtitle.push(self.$slots.default[i]); }
	        if (slotName === 'text') { slotsText.push(self.$slots.default[i]); }
	        if (slotName === 'header') { slotsHeader.push(self.$slots.default[i]); }
	        if (slotName === 'footer') { slotsFooter.push(self.$slots.default[i]); }
	      }
	    }

	    // Input
	    if (self.radio || self.checkbox) {
	      inputEl = c('input', {
	        attrs: {
	          value: self.value,
	          name: self.name,
	          checked: self.checked,
	          readonly: self.readonly,
	          disabled: self.disabled,
	          required: self.required,
	          type: self.radio ? 'radio' : 'checkbox',
	        },
	        on: {
	          change: self.onChange,
	        },
	        domProps: {
	          checked: self.checked,
	          disabled: self.disabled,
	          required: self.required,
	        },
	      });
	      inputIconEl = c('i', { staticClass: ("icon icon-" + (self.radio ? 'radio' : 'checkbox')) });
	    }
	    // Media
	    if (self.media || slotsMedia.length) {
	      var mediaImgEl;
	      if (self.media) {
	        mediaImgEl = c('img', { attrs: { src: self.media } });
	      }
	      mediaEl = c('div', { staticClass: 'item-media' }, [mediaImgEl, slotsMedia]);
	    }
	    // Inner Elements
	    if (self.header || slotsHeader.length) {
	      headerEl = c('div', { staticClass: 'item-header' }, [self.header, slotsHeader]);
	    }
	    if (self.footer || slotsFooter.length) {
	      footerEl = c('div', { staticClass: 'item-footer' }, [self.footer, slotsFooter]);
	    }
	    if (self.title || slotsTitle.length) {
	      titleEl = c('div', { staticClass: 'item-title' }, [!self.mediaList && headerEl, self.title, slotsTitle, !self.mediaList && footerEl]);
	    }
	    if (self.subtitle || slotsSubtitle.length) {
	      subtitleEl = c('div', { staticClass: 'item-subtitle' }, [self.subtitle, slotsSubtitle]);
	    }
	    if (self.text || slotsText.length) {
	      textEl = c('div', { staticClass: 'item-text' }, [self.text, slotsText]);
	    }
	    if (self.after || self.badge || slotsAfter.length) {
	      if (self.after) {
	        afterEl = c('span', [self.after]);
	      }
	      if (self.badge) {
	        badgeEl = c('f7-badge', { props: { color: self.badgeColor } }, [self.badge]);
	      }
	      afterWrapEl = c('div', { staticClass: 'item-after' }, [slotsAfterStart, afterEl, badgeEl, slotsAfter, slotsAfterEnd]);
	    }
	    if (self.mediaList) {
	      titleRowEl = c('div', { staticClass: 'item-title-row' }, [slotsBeforeTitle, titleEl, slotsAfterTitle, afterWrapEl]);
	    }
	    innerEl = c('div', { staticClass: 'item-inner' }, self.mediaList ? [slotsInnerStart, headerEl, titleRowEl, subtitleEl, textEl, slotsInner, footerEl, slotsInnerEnd] : [slotsInnerStart, slotsBeforeTitle, titleEl, slotsAfterTitle, afterWrapEl, slotsInner, slotsInnerEnd]);

	    // Finalize
	    return c((self.checkbox || self.radio) ? 'label' : 'div', {
	      staticClass: 'item-content',
	      class: Utils$2.extend(
	        {
	          'item-checkbox': self.checkbox,
	          'item-radio': self.radio,
	          'item-input': self.itemInput || self.itemInputForced,
	          'inline-label': self.inlineLabel || self.inlineLabelForced,
	          'item-input-with-info': self.itemInputWithInfo || self.itemInputWithInfoForced,
	        },
	        Mixins.colorClasses(self)
	      ),
	      on: {
	        click: self.onClick,
	      },
	    }, [slotsContentStart, inputEl, inputIconEl, mediaEl, innerEl, slotsContent, slotsContentEnd]);
	  },
	  data: function data() {
	    return {
	      itemInputForced: false,
	      inlineLabelForced: false,
	      itemInputWithInfoForced: false,
	    };
	  },
	  methods: {
	    onClick: function onClick(event) {
	      this.$emit('click', event);
	    },
	    onChange: function onChange(event) {
	      this.$emit('change', event);
	    },
	    onInput: function onInput(event) {
	      this.$emit('input', event);
	    },
	  },
	};

	var listItemRow = {render: function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item-row",class:_vm.classes},[_vm._t("default")],2)},staticRenderFns: [],
	  name: 'f7-list-item-row',
	  props: Mixins.colorProps,
	  computed: {
	    classes: function classes() {
	      var self = this;
	      return Mixins.colorClasses(self);
	    },
	  },
	};

	var ListItemProps = Utils$2.extend(
	  {
	    title: [String, Number],
	    text: [String, Number],
	    media: String,
	    subtitle: [String, Number],
	    header: [String, Number],
	    footer: [String, Number],

	    // Link Props
	    link: [Boolean, String],
	    target: String,
	    noFastclick: Boolean,
	    noFastClick: Boolean,

	    after: [String, Number],
	    badge: [String, Number],
	    badgeColor: String,

	    mediaItem: Boolean,
	    mediaList: Boolean,
	    divider: Boolean,
	    groupTitle: Boolean,
	    swipeout: Boolean,
	    sortable: Boolean,
	    accordionItem: Boolean,
	    accordionItemOpened: Boolean,

	    // Smart Select
	    smartSelect: Boolean,
	    smartSelectParams: Object,

	    // Inputs
	    checkbox: Boolean,
	    radio: Boolean,
	    checked: Boolean,
	    name: String,
	    value: [String, Number, Array],
	    readonly: Boolean,
	    required: Boolean,
	    disabled: Boolean,
	    itemInput: Boolean,
	    itemInputWithInfo: Boolean,
	    inlineLabel: Boolean,
	  },
	  Mixins.colorProps,
	  Mixins.linkRouterProps,
	  Mixins.linkActionsProps
	);

	var listItem = {
	  name: 'f7-list-item',
	  components: {
	    f7ListItemContent: f7ListItemContent,
	  },
	  props: ListItemProps,
	  render: function render(c) {
	    var self = this;

	    var liChildren;
	    var linkEl;
	    var itemContentEl;

	    if (!self.simpleListComputed) {
	      // Item Content
	      itemContentEl = c('f7-list-item-content', {
	        props: {
	          title: self.title,
	          text: self.text,
	          media: self.media,
	          subtitle: self.subtitle,
	          after: self.after,
	          header: self.header,
	          footer: self.footer,
	          badge: self.badge,
	          badgeColor: self.badgeColor,
	          mediaList: self.mediaListComputed,
	          accordionItem: self.accordionItem,

	          checkbox: self.checkbox,
	          checked: self.checked,
	          radio: self.radio,
	          name: self.name,
	          value: self.value,
	          readonly: self.readonly,
	          required: self.required,
	          disabled: self.disabled,
	          itemInput: self.itemInput || self.itemInputForced,
	          itemInputWithInfo: self.itemInputWithInfo || self.itemInputWithInfoForced,
	          inlineLabel: self.inlineLabel || self.inlineLabelForced,
	        },
	        on: (self.link || self.href || self.accordionItem || self.smartSelect) ? {} : { click: self.onClick, change: self.onChange },
	      }, [
	        self.$slots['content-start'],
	        self.$slots.content,
	        self.$slots['content-end'],
	        self.$slots.media,
	        self.$slots['inner-start'],
	        self.$slots.inner,
	        self.$slots['inner-end'],
	        self.$slots['after-start'],
	        self.$slots.after,
	        self.$slots['after-end'],
	        self.$slots.header,
	        self.$slots.footer,
	        self.$slots['before-title'],
	        self.$slots.title,
	        self.$slots['after-title'],
	        self.$slots.subtitle,
	        self.$slots.text,
	        (self.swipeout || self.accordionItem ? [] : self.$slots.default) ]);

	      // Link
	      if (self.link || self.href || self.accordionItem || self.smartSelect) {
	        linkEl = c('a', {
	          attrs: Utils$2.extend(
	            {
	              href: self.link === true || self.accordionItem || self.smartSelect ? '#' : self.link || self.href,
	              target: self.target,
	            },
	            Mixins.linkRouterAttrs(self),
	            Mixins.linkActionsAttrs(self)
	          ),
	          class: Utils$2.extend(
	            {
	              'item-link': true,
	              'no-fastclick': self.noFastclick || self.noFastClick,
	              'smart-select': self.smartSelect,
	            },
	            Mixins.linkRouterClasses(self),
	            Mixins.linkActionsClasses(self)
	          ),
	          on: {
	            click: self.onClick,
	          },
	        }, [itemContentEl]);
	      }
	    }

	    if (self.divider || self.groupTitle) {
	      liChildren = [c('span', self.$slots.default || self.title)];
	    } else if (self.simpleListComputed) {
	      liChildren = [self.title, self.$slots.default];
	    } else {
	      var linkItemEl = (self.link || self.href || self.smartSelect || self.accordionItem) ? linkEl : itemContentEl;
	      if (self.swipeout) {
	        liChildren = [c('div', { class: { 'swipeout-content': true } }, [linkItemEl])];
	      } else {
	        liChildren = [linkItemEl];
	      }
	      if (self.sortableComputed) {
	        liChildren.push(c('div', { class: { 'sortable-handler': true } }));
	      }
	      if (self.swipeout || self.accordionItem) {
	        liChildren.push(self.$slots.default);
	      }
	      liChildren.unshift(self.$slots['root-start']);
	      liChildren.push(self.$slots.root);
	      liChildren.push(self.$slots['root-end']);
	    }

	    return c(
	      'li',
	      {
	        class: Utils$2.extend(
	          {
	            'item-divider': self.divider,
	            'list-group-title': self.groupTitle,
	            'media-item': self.mediaItem,
	            swipeout: self.swipeout,
	            'accordion-item': self.accordionItem,
	            'accordion-item-opened': self.accordionItemOpened,
	          },
	          Mixins.colorClasses(self)
	        ),
	        on: {
	          'swipeout:open': self.onSwipeoutOpen,
	          'swipeout:opened': self.onSwipeoutOpened,
	          'swipeout:close': self.onSwipeoutClose,
	          'swipeout:closed': self.onSwipeoutClosed,
	          'swipeout:delete': self.onSwipeoutDelete,
	          'swipeout:deleted': self.onSwipeoutDeleted,
	          swipeout: self.onSwipeout,
	          'accordion:open': self.onAccOpen,
	          'accordion:opened': self.onAccOpened,
	          'accordion:close': self.onAccClose,
	          'accordion:closed': self.onAccClosed,
	        },
	      },
	      liChildren
	    );
	  },
	  data: function data() {
	    return {
	      itemInputForced: false,
	      inlineLabelForced: false,
	      itemInputWithInfoForced: false,
	    };
	  },
	  computed: {
	    sortableComputed: function sortableComputed() {
	      return this.sortable || this.$parent.sortable || this.$parent.sortableComputed;
	    },
	    mediaListComputed: function mediaListComputed() {
	      return this.mediaList || this.mediaItem || this.$parent.mediaList || this.$parent.mediaListComputed;
	    },
	    simpleListComputed: function simpleListComputed() {
	      return this.simpleList || this.$parent.simpleList || (this.$parent.$parent && this.$parent.simpleList);
	    },
	  },
	  beforeDestroy: function beforeDestroy() {
	    var self = this;
	    if (self.smartSelect && self.f7SmartSelect) {
	      self.f7SmartSelect.destroy();
	    }
	  },
	  methods: {
	    onF7Ready: function onF7Ready(f7) {
	      var self = this;
	      if (!self.smartSelect) { return; }
	      var smartSelectParams = Utils$2.extend({ el: self.$el.querySelector('a.smart-select') }, (self.smartSelectParams || {}));
	      self.f7SmartSelect = f7.smartSelect.create(smartSelectParams);
	    },
	    onClick: function onClick(event) {
	      var self = this;
	      if (self.smartSelect && self.f7SmartSelect) {
	        self.f7SmartSelect.open();
	      }
	      if (event.target.tagName.toLowerCase() !== 'input') {
	        self.$emit('click', event);
	      }
	    },
	    onSwipeoutDeleted: function onSwipeoutDeleted(event) {
	      this.$emit('swipeout:deleted', event);
	    },
	    onSwipeoutDelete: function onSwipeoutDelete(event) {
	      this.$emit('swipeout:delete', event);
	    },
	    onSwipeoutClose: function onSwipeoutClose(event) {
	      this.$emit('swipeout:close', event);
	    },
	    onSwipeoutClosed: function onSwipeoutClosed(event) {
	      this.$emit('swipeout:closed', event);
	    },
	    onSwipeoutOpen: function onSwipeoutOpen(event) {
	      this.$emit('swipeout:open', event);
	    },
	    onSwipeoutOpened: function onSwipeoutOpened(event) {
	      this.$emit('swipeout:opened', event);
	    },
	    onSwipeout: function onSwipeout(event) {
	      this.$emit('swipeout', event);
	    },
	    onAccClose: function onAccClose(event) {
	      this.$emit('accordion:close', event);
	    },
	    onAccClosed: function onAccClosed(event) {
	      this.$emit('accordion:closed', event);
	    },
	    onAccOpen: function onAccOpen(event) {
	      this.$emit('accordion:open', event);
	    },
	    onAccOpened: function onAccOpened(event) {
	      this.$emit('accordion:opened', event);
	    },
	    onChange: function onChange(event) {
	      this.$emit('change', event);
	    },
	    onInput: function onInput(event) {
	      this.$emit('input', event);
	    },
	  },
	};

	var ListProps = Utils$2.extend(
	  {
	    inset: Boolean,
	    tabletInset: Boolean,
	    mediaList: Boolean,
	    sortable: Boolean,
	    sortableEnabled: Boolean,
	    accordionList: Boolean,
	    contactsList: Boolean,
	    simpleList: Boolean,
	    linksList: Boolean,

	    noHairlines: Boolean,
	    noHairlinesBetween: Boolean,
	    noHairlinesMd: Boolean,
	    noHairlinesBetweenMd: Boolean,
	    noHairlinesIos: Boolean,
	    noHairlinesBetweenIos: Boolean,

	    // Tab
	    tab: Boolean,
	    tabActive: Boolean,

	    // Form
	    form: Boolean,
	    formStoreData: Boolean,
	    inlineLabels: Boolean,

	    // Virtual List
	    virtualList: Boolean,
	    virtualListParams: Object,
	  },
	  Mixins.colorProps
	);

	var list = {
	  name: 'f7-list',
	  props: ListProps,
	  beforeDestroy: function beforeDestroy() {
	    var self = this;
	    if (!(self.virtualList && self.f7VirtualList)) { return; }
	    if (self.f7VirtualList.destroy) { self.f7VirtualList.destroy(); }
	  },
	  render: function render(c) {
	    var self = this;

	    var listChildren = [];
	    var ulChildren = self.$slots.list || [];

	    if (self.$slots.default) {
	      for (var i = 0; i < self.$slots.default.length; i += 1) {
	        var tag = self.$slots.default[i].tag;
	        if (tag && !(tag === 'li' || tag.indexOf('list-item') >= 0 || tag.indexOf('list-button') >= 0)) {
	          listChildren.push(self.$slots.default[i]);
	        } else if (tag) {
	          ulChildren.push(self.$slots.default[i]);
	        }
	      }
	    }
	    var blockEl = c(
	      self.form ? 'form' : 'div',
	      {
	        staticClass: 'list',
	        class: Utils$2.extend(
	          {
	            inset: self.inset,
	            'tablet-inset': self.tabletInset,
	            'media-list': self.mediaList,
	            'simple-list': self.simpleList,
	            'links-list': self.linksList,
	            sortable: self.sortable,
	            'accordion-list': self.accordionList,
	            'contacts-list': self.contactsList,
	            'virtual-list': self.virtualList,
	            'sortable-enabled': self.sortableEnabled,
	            tab: self.tab,
	            'tab-active': self.tabActive,
	            'no-hairlines': self.noHairlines,
	            'no-hairlines-between': self.noHairlinesBetween,
	            'no-hairlines-md': self.noHairlinesMd,
	            'no-hairlines-between-md': self.noHairlinesBetweenMd,
	            'no-hairlines-ios': self.noHairlinesIos,
	            'no-hairlines-between-ios': self.noHairlinesBetweenIos,
	            'form-store-data': self.formStoreData,
	            'inline-labels': self.inlineLabels,
	          },
	          Mixins.colorClasses(self)
	        ),
	        on: {
	          'sortable:enable': self.onSortableEnable,
	          'sortable:disable': self.onSortableDisable,
	          'sortable:sort': self.onSortableSort,
	          'tab:show': self.onTabShow,
	          'tab:hide': self.onTabHide,
	        },
	      },
	      [
	        ulChildren.length > 0 ?
	          [
	            self.$slots['before-list'],
	            c('ul', {}, ulChildren),
	            self.$slots['after-list'],
	            listChildren ] :
	          [
	            self.$slots['before-list'],
	            listChildren,
	            self.$slots['after-list'] ] ]
	    );
	    return blockEl;
	  },
	  methods: {
	    onSortableEnable: function onSortableEnable(event) {
	      this.$emit('sortable:enable', event);
	    },
	    onSortableDisable: function onSortableDisable(event) {
	      this.$emit('sortable:disable', event);
	    },
	    onSortableSort: function onSortableSort(event) {
	      this.$emit('sortable:sort', event, event.detail);
	    },
	    onTabShow: function onTabShow(e) {
	      this.$emit('tab:show', e);
	    },
	    onTabHide: function onTabHide(e) {
	      this.$emit('tab:hide', e);
	    },
	    onF7Ready: function onF7Ready(f7) {
	      var self = this;
	      // Init Virtual List
	      if (!self.virtualList) { return; }
	      var $$ = self.$$;
	      var $el = $$(self.$el);
	      var templateScript = $el.find('script');
	      var template = templateScript.html();
	      if (!template && templateScript.length > 0) {
	        template = templateScript[0].outerHTML;
	        // eslint-disable-next-line
	        template = /\<script type="text\/template7"\>(.*)<\/script>/.exec(template)[1];
	      }
	      var vlParams = self.virtualListParams || {};
	      if (!template && !vlParams.renderItem && !vlParams.itemTemplate && !vlParams.renderExternal) { return; }
	      if (template) { template = self.$t7.compile(template); }

	      self.f7VirtualList = f7.virtualList.create(Utils$2.extend(
	        {
	          el: self.$el,
	          itemTemplate: template,
	          on: {
	            itemBeforeInsert: function itemBeforeInsert(itemEl, item) {
	              var vl = this;
	              self.$emit('virtual:itembeforeinsert', vl, itemEl, item);
	            },
	            beforeClear: function beforeClear(fragment) {
	              var vl = this;
	              self.$emit('virtual:beforeclear', vl, fragment);
	            },
	            itemsBeforeInsert: function itemsBeforeInsert(fragment) {
	              var vl = this;
	              self.$emit('virtual:itemsbeforeinsert', vl, fragment);
	            },
	            itemsAfterInsert: function itemsAfterInsert(fragment) {
	              var vl = this;
	              self.$emit('virtual:itemsafterinsert', vl, fragment);
	            },
	          },
	        },
	        vlParams
	      ));
	    },
	  },
	};

	var loginScreenTitle = {render: function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login-screen-title",class:_vm.classes},[_vm._t("default")],2)},staticRenderFns: [],
	  name: 'f7-login-screen-title',
	  props: Mixins.colorProps,
	  computed: {
	    classes: function classes() {
	      var self = this;
	      return Mixins.colorClasses(self);
	    },
	  },
	};

	var LoginScreenProps = Utils$2.extend(
	  {
	    opened: Boolean,
	  },
	  Mixins.colorProps
	);

	var MessageProps = Utils$2.extend(
	  {
	    text: String,
	    name: String,
	    avatar: String,
	    type: {
	      type: String,
	      default: 'sent',
	    },
	    image: String,
	    header: String,
	    footer: String,
	    textHeader: String,
	    textFooter: String,
	    first: Boolean,
	    last: Boolean,
	    tail: Boolean,
	    sameName: Boolean,
	    sameHeader: Boolean,
	    sameFooter: Boolean,
	    sameAvatar: Boolean,
	    typing: Boolean,
	  },
	  Mixins.colorProps
	);

	var MessagebarAttachmentProps = Utils$2.extend(
	  {
	    image: String,
	    deletable: {
	      type: Boolean,
	      default: true,
	    },
	  },
	  Mixins.colorProps
	);

	var MessagebarSheetItemProps = Utils$2.extend(
	  {
	    image: String,
	    checked: Boolean,
	  },
	  Mixins.colorProps
	);

	var MessagebarProps = Utils$2.extend(
	  {
	    sheetVisible: Boolean,
	    attachmentsVisible: Boolean,
	    top: Boolean,
	    resizable: {
	      type: Boolean,
	      default: true,
	    },
	    bottomOffset: {
	      type: Number,
	      default: 0,
	    },
	    topOffset: {
	      type: Number,
	      default: 0,
	    },
	    maxHeight: Number,
	    sendLink: String,
	    value: [String, Number, Array],
	    disabled: Boolean,
	    readonly: Boolean,
	    name: String,
	    placeholder: {
	      type: String,
	      default: 'Message',
	    },
	    init: {
	      type: Boolean,
	      default: true,
	    },
	  },
	  Mixins.colorProps
	);

	var MessagesProps = Utils$2.extend(
	  {
	    autoLayout: {
	      type: Boolean,
	      default: false,
	    },
	    messages: {
	      type: Array,
	      default: function default$1() {
	        return [];
	      },
	    },
	    newMessagesFirst: {
	      type: Boolean,
	      default: false,
	    },
	    scrollMessages: {
	      type: Boolean,
	      default: true,
	    },
	    scrollMessagesOnEdge: {
	      type: Boolean,
	      default: true,
	    },
	    firstMessageRule: Function,
	    lastMessageRule: Function,
	    tailMessageRule: Function,
	    sameNameMessageRule: Function,
	    sameHeaderMessageRule: Function,
	    sameFooterMessageRule: Function,
	    sameAvatarMessageRule: Function,
	    customClassMessageRule: Function,
	    renderMessage: Function,

	    init: {
	      type: Boolean,
	      default: true,
	    },
	  },
	  Mixins.colorProps
	);

	var NavLeftProps = Utils$2.extend({
	  backLink: [Boolean, String],
	  backLinkUrl: String,
	  backLinkForce: Boolean,
	  sliding: Boolean,
	}, Mixins.colorProps);

	var f7NavLeft = {render: function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"left",class:_vm.classes},[(_vm.backLink)?_c('f7-link',{class:{'icon-only': (_vm.backLink === true || _vm.backLink && _vm.$theme.md)},attrs:{"href":_vm.backLinkUrl || '#',"back":"","icon":"icon-back","text":_vm.backLink !== true && !_vm.$theme.md ? _vm.backLink : undefined,"force":_vm.backLinkForce || undefined},on:{"click":_vm.onBackClick}}):_vm._e(),_vm._v(" "),_vm._t("default")],2)},staticRenderFns: [],
	  name: 'f7-nav-left',
	  components: {
	    f7Link: f7Link,
	  },
	  props: NavLeftProps,
	  computed: {
	    classes: function classes() {
	      return Utils$2.extend({
	        sliding: this.slidng,
	      }, Mixins.colorClasses(this));
	    },
	  },
	  methods: {
	    onBackClick: function onBackClick(e) {
	      this.$emit('back-click', e);
	      this.$emit('click:back', e);
	    },
	  },
	};

	var NavRightProps = Utils$2.extend({
	  sliding: Boolean,
	}, Mixins.colorProps);

	var navRight = {render: function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"right",class:_vm.classes},[_vm._t("default")],2)},staticRenderFns: [],
	  name: 'f7-nav-right',
	  props: NavRightProps,
	  computed: {
	    classes: function classes() {
	      return Utils$2.extend({
	        sliding: this.slidng,
	      }, Mixins.colorClasses(this));
	    },
	  },
	};

	var NavTitleProps = Utils$2.extend({
	  title: String,
	  subtitle: String,
	  sliding: Boolean,
	}, Mixins.colorProps);

	var f7NavTitle = {render: function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title",class:_vm.classes},[_vm._t("default",[_vm._v(_vm._s(_vm.title)),(_vm.subtitle)?_c('span',{staticClass:"subtitle"},[_vm._v(_vm._s(_vm.subtitle))]):_vm._e()])],2)},staticRenderFns: [],
	  name: 'f7-nav-title',
	  props: NavTitleProps,
	  computed: {
	    classes: function classes() {
	      return Utils$2.extend({
	        sliding: this.slidng,
	      }, Mixins.colorClasses(this));
	    },
	  },
	};

	var NavbarProps = Utils$2.extend({
	  backLink: [Boolean, String],
	  backLinkUrl: String,
	  backLinkForce: Boolean,
	  sliding: {
	    type: Boolean,
	    default: true,
	  },
	  title: String,
	  subtitle: String,
	  hidden: Boolean,
	  noShadow: Boolean,
	  noHairline: Boolean,
	  inner: {
	    type: Boolean,
	    default: true,
	  },
	}, Mixins.colorProps);

	var navbar = {
	  name: 'f7-navbar',
	  components: {
	    f7NavLeft: f7NavLeft,
	    f7NavTitle: f7NavTitle,
	  },
	  render: function render(c) {
	    var self = this;
	    var innerEl;
	    var leftEl;
	    var titleEl;
	    if (self.inner) {
	      if (self.backLink) {
	        leftEl = c('f7-nav-left', {
	          props: {
	            backLink: self.backLink,
	            backLinkUrl: self.backLinkUrl,
	            backLinkForce: self.backLinkForce,
	          },
	          on: {
	            'back-click': self.onBackClick,
	          },
	        });
	      }
	      if (self.title || self.subtitle) {
	        titleEl = c('f7-nav-title', {
	          props: {
	            title: self.title,
	            subtitle: self.subtitle,
	          },
	        });
	      }
	      innerEl = c('div', { ref: 'inner', staticClass: 'navbar-inner', class: { sliding: self.sliding } }, [leftEl, titleEl, self.$slots.default]);
	    }
	    return c('div', {
	      staticClass: 'navbar',
	      class: self.classes,
	    }, [self.$slots['before-inner'], innerEl, self.$slots['after-inner']]);
	  },
	  updated: function updated() {
	    var self = this;
	    if (!self.$f7) { return; }
	    self.$nextTick(function () {
	      if (self.$el && self.$el.children && self.$el.children.length) {
	        self.$f7.navbar.size(self.$el);
	      } else if (self.$refs.inner) {
	        self.$f7.navbar.size(self.$refs.inner);
	      }
	    });
	  },
	  props: NavbarProps,
	  computed: {
	    classes: function classes() {
	      var self = this;
	      return Utils$2.extend({
	        'navbar-hidden': self.hidden,
	        'no-shadow': self.noShadow,
	        'no-hairline': self.noHairline,
	      }, Mixins.colorClasses(self));
	    },
	  },
	  methods: {
	    hide: function hide(animate) {
	      var self = this;
	      if (!self.$f7) { return; }
	      self.$f7.navbar.hide(self.$el, animate);
	    },
	    show: function show(animate) {
	      var self = this;
	      if (!self.$f7) { return; }
	      self.$f7.navbar.show(self.$el, animate);
	    },
	    size: function size() {
	      var self = this;
	      if (!self.$f7) { return; }
	      self.$f7.navbar.size(self.$el);
	    },
	    onBackClick: function onBackClick(e) {
	      this.$emit('back-click', e);
	      this.$emit('click:back', e);
	    },
	  },
	};

	var PageContentProps = Utils$2.extend({
	  tab: Boolean,
	  tabActive: Boolean,
	  ptr: Boolean,
	  ptrDistance: Number,
	  ptrPreloader: {
	    type: Boolean,
	    default: true,
	  },
	  infinite: Boolean,
	  infiniteTop: Boolean,
	  infiniteDistance: Number,
	  infinitePreloader: {
	    type: Boolean,
	    default: true,
	  },
	  hideBarsOnScroll: Boolean,
	  hideNavbarOnScroll: Boolean,
	  hideToolbarOnScroll: Boolean,
	  messagesContent: Boolean,
	  loginScreen: Boolean,
	}, Mixins.colorProps);

	var f7PageContent = {
	  name: 'f7-page-content',
	  render: function render(c) {
	    var self = this;

	    var ptrEl;
	    var infiniteEl;

	    if (self.ptr && (self.ptrPreloader)) {
	      ptrEl = c('div', { staticClass: 'ptr-preloader' }, [
	        c('div', { staticClass: 'preloader' }),
	        c('div', { staticClass: 'ptr-arrow' }) ]);
	    }
	    if ((self.infinite) && self.infinitePreloader) {
	      infiniteEl = c('div', { staticClass: 'preloader infinite-scroll-preloader' });
	    }
	    return c('div', {
	      staticClass: 'page-content',
	      class: self.classes,
	      attrs: {
	        'data-ptr-distance': self.ptrDistance,
	        'data-infinite-distance': self.infiniteDistance,
	      },
	      on: {
	        'ptr:pullstart': self.onPtrPullStart,
	        'ptr:pullmove': self.onPtrPullMove,
	        'ptr:pullend': self.onPtrPullEnd,
	        'ptr:refresh': self.onPtrRefresh,
	        'ptr:done': self.onPtrRefreshDone,
	        infinite: self.onInfinite,
	        'tab:show': self.onTabShow,
	        'tab:hide': self.onTabHide,
	      },
	    }, (self.infiniteTop ? [ptrEl, infiniteEl, self.$slots.default] : [ptrEl, self.$slots.default, infiniteEl]));
	  },
	  props: PageContentProps,
	  computed: {
	    classes: function classes() {
	      var self = this;
	      return Utils$2.extend({
	        tab: self.tab,
	        'tab-active': self.tabActive,
	        'ptr-content': self.ptr,
	        'infinite-scroll-content': self.infinite,
	        'infinite-scroll-top': self.infiniteTop,
	        'hide-bars-on-scroll': self.hideBarsOnScroll,
	        'hide-navbar-on-scroll': self.hideNavbarOnScroll,
	        'hide-toolbar-on-scroll': self.hideToolbarOnScroll,
	        'messages-content': self.messagesContent,
	        'login-screen-content': self.loginScreen,
	      }, Mixins.colorClasses(self));
	    },
	  },
	  methods: {
	    onPtrPullStart: function onPtrPullStart(event) {
	      this.$emit('ptr:pullstart', event);
	    },
	    onPtrPullMove: function onPtrPullMove(event) {
	      this.$emit('ptr:pullmove', event);
	    },
	    onPtrPullEnd: function onPtrPullEnd(event) {
	      this.$emit('ptr:pullend', event);
	    },
	    onPtrRefresh: function onPtrRefresh(event) {
	      this.$emit('ptr:refresh', event, event.detail);
	    },
	    onPtrRefreshDone: function onPtrRefreshDone(event) {
	      this.$emit('ptr:done', event);
	    },
	    onInfinite: function onInfinite(event) {
	      this.$emit('infinite', event);
	    },
	    onTabShow: function onTabShow(e) {
	      var self = this;
	      self.$emit('tab:show', e);
	    },
	    onTabHide: function onTabHide(e) {
	      var self = this;
	      self.$emit('tab:hide', e);
	    },
	  },
	};

	var PageProps = Utils$2.extend({
	  name: String,
	  stacked: Boolean,
	  withSubnavbar: Boolean,
	  subnavbar: Boolean,
	  noNavbar: Boolean,
	  noToolbar: Boolean,
	  tabs: Boolean,
	  pageContent: {
	    type: Boolean,
	    default: true,
	  },
	  noSwipeback: Boolean,
	  // Page Content Props
	  ptr: Boolean,
	  ptrDistance: Number,
	  ptrPreloader: {
	    type: Boolean,
	    default: true,
	  },
	  infinite: Boolean,
	  infiniteTop: Boolean,
	  infiniteDistance: Number,
	  infinitePreloader: {
	    type: Boolean,
	    default: true,
	  },
	  hideBarsOnScroll: Boolean,
	  hideNavbarOnScroll: Boolean,
	  hideToolbarOnScroll: Boolean,
	  messagesContent: Boolean,
	  loginScreen: Boolean,
	}, Mixins.colorProps);

	var page = {
	  name: 'f7-page',
	  components: {
	    f7PageContent: f7PageContent,
	  },
	  render: function render(c) {
	    var fixedList = [];
	    var staticList = [];
	    var self = this;

	    var pageContentEl;

	    var fixedTags = ('navbar toolbar tabbar subnavbar searchbar messagebar fab list-index').split(' ');

	    var tag;
	    var child;
	    var withSubnavbar;
	    var withSearchbar;
	    var withMessages = self.$options.propsData.withMessages;

	    if (self.$slots.default) {
	      for (var i = 0; i < self.$slots.default.length; i += 1) {
	        child = self.$slots.default[i];
	        tag = child.tag;
	        if (!tag) {
	          staticList.push(child);
	          continue; // eslint-disable-line
	        }
	        var isFixed = false;
	        if (tag.indexOf('subnavbar') >= 0) { withSubnavbar = true; }
	        if (tag.indexOf('searchbar') >= 0) { withSearchbar = true; }
	        if (typeof withMessages === 'undefined' && tag.indexOf('messages') >= 0) { withMessages = true; }
	        for (var j = 0; j < fixedTags.length; j += 1) {
	          if (tag.indexOf(fixedTags[j]) >= 0) {
	            isFixed = true;
	          }
	        }
	        if (isFixed) { fixedList.push(child); }
	        else { staticList.push(child); }
	      }
	    }

	    if (fixedList.length > 0 && withSearchbar) {
	      fixedList.push(c('div', { class: { 'searchbar-overlay': true } }));
	    }
	    if (self.pageContent) {
	      pageContentEl = c('f7-page-content', {
	        props: {
	          ptr: self.ptr,
	          ptrDistance: self.ptrDistance,
	          ptrPreloader: self.ptrPreloader,
	          infinite: self.infinite,
	          infiniteTop: self.infiniteTop,
	          infiniteDistance: self.infiniteDistance,
	          infinitePreloader: self.infinitePreloader,
	          hideBarsOnScroll: self.hideBarsOnScroll,
	          hideNavbarOnScroll: self.hideNavbarOnScroll,
	          hideToolbarOnScroll: self.hideToolbarOnScroll,
	          messagesContent: self.messagesContent || withMessages,
	          loginScreen: self.loginScreen,
	        },
	        on: {
	          'ptr:pullstart': self.onPtrPullStart,
	          'ptr:pullmove': self.onPtrPullMove,
	          'ptr:pullend': self.onPtrPullEnd,
	          'ptr:refresh': self.onPtrRefresh,
	          'ptr:done': self.onPtrRefreshDone,
	          infinite: self.onInfinite,
	        },
	      }, [self.$slots.static, staticList]);
	    } else {
	      pageContentEl = [];
	      if (self.$slots.default && fixedList.length > 0) {
	        for (var i$1 = 0; i$1 < self.$slots.default.length; i$1 += 1) {
	          if (fixedList.indexOf(self.$slots.default[i$1]) < 0) {
	            pageContentEl.push(self.$slots.default[i$1]);
	          }
	        }
	      } else {
	        pageContentEl = [self.$slots.default];
	      }
	    }
	    fixedList.push(self.$slots.fixed);

	    if (withSubnavbar) { self.classes['page-with-subnavbar'] = true; }

	    var pageEl = c('div', {
	      staticClass: 'page',
	      class: self.classes,
	      attrs: {
	        'data-name': self.name,
	      },
	      on: {
	        'page:mounted': self.onPageMounted,
	        'page:init': self.onPageInit,
	        'page:reinit': self.onPageReinit,
	        'page:beforein': self.onPageBeforeIn,
	        'page:afterin': self.onPageAfterIn,
	        'page:beforeout': self.onPageBeforeOut,
	        'page:afterout': self.onPageAfterOut,
	        'page:beforeremove': self.onPageBeforeRemove,
	      },
	    }, [fixedList, pageContentEl]);

	    return pageEl;
	  },
	  props: PageProps,
	  computed: {
	    classes: function classes() {
	      return Utils$2.extend({
	        stacked: this.stacked,
	        tabs: this.tabs,
	        'page-with-subnavbar': this.subnavbar || this.withSubnavbar,
	        'no-navbar': this.noNavbar,
	        'no-toolbar': this.noToolbar,
	        'no-swipeback': this.noSwipeback,
	      }, Mixins.colorClasses(this));
	    },
	  },
	  methods: {
	    onPtrPullStart: function onPtrPullStart(event) {
	      this.$emit('ptr:pullstart', event);
	    },
	    onPtrPullMove: function onPtrPullMove(event) {
	      this.$emit('ptr:pullmove', event);
	    },
	    onPtrPullEnd: function onPtrPullEnd(event) {
	      this.$emit('ptr:pullend', event);
	    },
	    onPtrRefresh: function onPtrRefresh(event) {
	      this.$emit('ptr:refresh', event, event.detail);
	    },
	    onPtrRefreshDone: function onPtrRefreshDone(event) {
	      this.$emit('ptr:done', event);
	    },
	    onInfinite: function onInfinite(event) {
	      this.$emit('infinite', event);
	    },
	    onPageMounted: function onPageMounted(event) {
	      this.$emit('page:mounted', event, event.detail);
	    },
	    onPageInit: function onPageInit(event) {
	      this.$emit('page:init', event, event.detail);
	    },
	    onPageReinit: function onPageReinit(event) {
	      this.$emit('page:reinit', event, event.detail);
	    },
	    onPageBeforeIn: function onPageBeforeIn(event) {
	      this.$emit('page:beforein', event, event.detail);
	    },
	    onPageBeforeOut: function onPageBeforeOut(event) {
	      this.$emit('page:beforeout', event, event.detail);
	    },
	    onPageAfterOut: function onPageAfterOut(event) {
	      this.$emit('page:afterout', event, event.detail);
	    },
	    onPageAfterIn: function onPageAfterIn(event) {
	      this.$emit('page:afterin', event, event.detail);
	    },
	    onPageBeforeRemove: function onPageBeforeRemove(event) {
	      this.$emit('page:beforeremove', event, event.detail);
	    },
	  },
	};

	var PanelProps = Utils$2.extend(
	  {
	    side: String,
	    effect: String,
	    cover: Boolean,
	    reveal: Boolean,
	    left: Boolean,
	    right: Boolean,
	    opened: Boolean,
	  },
	  Mixins.colorProps
	);

	var panel = {render: function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel",class:_vm.classes,on:{"panel:open":_vm.onOpen,"panel:opened":_vm.onOpened,"panel:close":_vm.onClose,"panel:closed":_vm.onClosed,"panel:backdrop-click":_vm.onBackdropClick,"panel:swipe":_vm.onPanelSwipe,"panel:swipeopen":_vm.onPanelSwipeOpen,"panel:breakpoint":_vm.onBreakpoint}},[_vm._t("default")],2)},staticRenderFns: [],
	  props: PanelProps,
	  computed: {
	    classes: function classes() {
	      var self = this;
	      var side = self.side || (self.left ? 'left' : 'right');
	      var effect = self.effect || (self.reveal ? 'reveal' : 'cover');
	      return Utils$2.extend(
	        ( obj = {
	          'panel-active': self.opened,
	        }, obj[("panel-" + side)] = side, obj[("panel-" + effect)] = effect, obj ),
	        Mixins.colorClasses(self)
	      );
	      var obj;
	    },
	  },
	  watch: {
	    opened: function opened(opened$1) {
	      var self = this;
	      if (!self.$f7) { return; }
	      var side = self.side || (self.left ? 'left' : 'right');
	      if (opened$1) {
	        self.$f7.panel.open(side);
	      } else {
	        self.$f7.panel.open(side);
	      }
	    },
	  },
	  beforeDestroy: function beforeDestroy() {
	    var self = this;
	    if (self.f7Panel) { self.f7Panel.destroy(); }
	  },
	  mounted: function mounted() {
	    var self = this;
	    if (self.opened) {
	      self.$el.style.display = 'block';
	    }
	    var $ = self.$;
	    if (!$) { return; }
	    var side = self.side || (self.left ? 'left' : 'right');
	    var effect = self.effect || (self.reveal ? 'reveal' : 'cover');
	    if (self.opened) {
	      $('html').addClass(("with-panel-" + side + "-" + effect));
	    }
	  },
	  methods: {
	    onOpen: function onOpen(event) {
	      this.$emit('panel:open', event);
	    },
	    onOpened: function onOpened(event) {
	      this.$emit('panel:opened', event);
	    },
	    onClose: function onClose(event) {
	      this.$emit('panel:close', event);
	    },
	    onClosed: function onClosed(event) {
	      this.$emit('panel:closed', event);
	    },
	    onBackdropClick: function onBackdropClick(event) {
	      this.$emit('panel:backdrop-click', event);
	    },
	    onPanelSwipe: function onPanelSwipe(event) {
	      this.$emit('panel:swipe', event);
	    },
	    onPanelSwipeOpen: function onPanelSwipeOpen(event) {
	      this.$emit('panel:swipeopen', event);
	    },
	    onBreakpoint: function onBreakpoint(event) {
	      this.$emit('panel:breakpoint', event);
	    },
	    onF7Ready: function onF7Ready() {
	      var self = this;
	      var $ = self.$$;
	      if (!$) { return; }
	      if ($('.panel-backdrop').length === 0) {
	        $('<div class="panel-backdrop"></div>').insertBefore(self.$el);
	      }
	      self.f7Panel = self.$f7.panel.create({ el: self.$el });
	    },
	    open: function open(animate) {
	      var self = this;
	      if (!self.$f7) { return; }
	      var side = self.side || (self.left ? 'left' : 'right');
	      self.$f7.panel.open(side, animate);
	    },
	    close: function close(animate) {
	      var self = this;
	      if (!self.$f7) { return; }
	      var side = self.side || (self.left ? 'left' : 'right');
	      self.$f7.panel.close(side, animate);
	    },
	  },
	};

	var PopoverProps = Utils$2.extend(
	  {
	    opened: Boolean,
	    target: [String, Object],
	  },
	  Mixins.colorProps
	);

	var popover = {
	  name: 'f7-popover',
	  render: function render(c) {
	    var self = this;
	    var angleEl = c('div', { staticClass: 'popover-angle' });
	    var innerEl = c('div', { staticClass: 'popover-inner' }, self.$slots.default);
	    return c('div', {
	      class: self.classes,
	      staticClass: 'popover',
	      on: {
	        'popover:open': self.onOpen,
	        'popover:opened': self.onOpened,
	        'popover:close': self.onClose,
	        'popover:closed': self.onClosed,
	      },
	    }, [angleEl, innerEl]);
	  },
	  watch: {
	    opened: function opened(opened$1) {
	      var self = this;
	      if (!self.f7Popover) { return; }
	      if (opened$1) {
	        self.f7Popover.open();
	      } else {
	        self.f7Popover.close();
	      }
	    },
	  },
	  props: PopoverProps,
	  computed: {
	    classes: function classes() {
	      var self = this;
	      return Mixins.colorClasses(self);
	    },
	  },
	  beforeDestroy: function beforeDestroy() {
	    var self = this;
	    if (self.f7Popover) { self.f7Popover.destroy(); }
	  },
	  methods: {
	    onOpen: function onOpen(event) {
	      this.$emit('popover:open', event);
	    },
	    onOpened: function onOpened(event) {
	      this.$emit('popover:opened', event);
	    },
	    onClose: function onClose(event) {
	      this.$emit('popover:close', event);
	    },
	    onClosed: function onClosed(event) {
	      this.$emit('popover:closed', event);
	    },
	    open: function open(target, animate) {
	      var self = this;
	      if (!self.$f7) { return undefined; }
	      return self.$f7.popover.open(self.$el, target, animate);
	    },
	    close: function close(animate) {
	      var self = this;
	      if (!self.$f7) { return undefined; }
	      return self.$f7.sheet.close(self.$el, animate);
	    },
	    onF7Ready: function onF7Ready() {
	      var self = this;
	      var popoverParams = {
	        el: self.$el,
	      };
	      if (self.target) { popoverParams.targetEl = self.target; }
	      self.f7Popover = self.$f7.popover.create(popoverParams);
	      if (self.opened && self.target) {
	        self.f7Popover.open(self.target, false);
	      }
	    },
	  },
	};

	var PopupProps = Utils$2.extend(
	  {
	    'tablet-fullscreen': Boolean,
	    opened: Boolean,
	  },
	  Mixins.colorProps
	);

	var popup = {
	  name: 'f7-popup',
	  render: function render(c) {
	    var self = this;
	    return c('div', {
	      staticClass: 'popup',
	      class: self.classes,
	      on: {
	        'popup:open': self.onOpen,
	        'popup:opened': self.onOpened,
	        'popup:close': self.onClose,
	        'popup:closed': self.onClosed,
	      },
	    }, self.$slots.default);
	  },
	  watch: {
	    opened: function opened(opened$1) {
	      var self = this;
	      if (!self.f7Popup) { return; }
	      if (opened$1) {
	        self.f7Popup.open();
	      } else {
	        self.f7Popup.close();
	      }
	    },
	  },
	  props: PopupProps,
	  computed: {
	    classes: function classes() {
	      var self = this;
	      return Utils$2.extend({
	        'popup-tablet-fullscreen': self.tabletFullscreen,
	      }, Mixins.colorClasses(self));
	    },
	  },
	  beforeDestroy: function beforeDestroy() {
	    var self = this;
	    if (self.f7Popup) { self.f7Popup.destroy(); }
	  },
	  methods: {
	    onOpen: function onOpen(event) {
	      this.$emit('popup:open', event);
	    },
	    onOpened: function onOpened(event) {
	      this.$emit('popup:opened', event);
	    },
	    onClose: function onClose(event) {
	      this.$emit('popup:close', event);
	    },
	    onClosed: function onClosed(event) {
	      this.$emit('popup:closed', event);
	    },
	    open: function open(animate) {
	      var self = this;
	      if (!self.$f7) { return undefined; }
	      return self.$f7.popup.open(self.$el, animate);
	    },
	    close: function close(animate) {
	      var self = this;
	      if (!self.$f7) { return undefined; }
	      return self.$f7.popup.close(self.$el, animate);
	    },
	    onF7Ready: function onF7Ready() {
	      var self = this;
	      self.f7Popup = self.$f7.popup.create({
	        el: self.$el,
	      });
	      if (self.opened) {
	        self.f7Popup.open(false);
	      }
	    },
	  },
	};

	var PreloaderProps = Utils$2.extend({
	  size: [Number, String],
	}, Mixins.colorProps);

	var preloader = {render: function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"preloader",class:_vm.classes,style:({'width': (_vm.sizeComputed ? ((_vm.sizeComputed) + "px") : ''), 'height': (_vm.sizeComputed ? ((_vm.sizeComputed) + "px") : '')})},[(_vm.$theme.md)?_c('span',{staticClass:"preloader-inner"},[_c('span',{staticClass:"preloader-inner-gap"}),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1)]):_vm._e()])},staticRenderFns: [function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"preloader-inner-left"},[_c('span',{staticClass:"preloader-inner-half-circle"})])},function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"preloader-inner-right"},[_c('span',{staticClass:"preloader-inner-half-circle"})])}],
	  name: 'f7-preloader',
	  props: PreloaderProps,
	  computed: {
	    classes: function classes() {
	      return Mixins.colorClasses(this);
	    },
	    sizeComputed: function sizeComputed() {
	      var s = this.size;
	      if (s && typeof s === 'string' && s.indexOf('px') >= 0) {
	        s = s.replace('px', '');
	      }
	      return s;
	    },
	  },
	};

	var ProgressbarProps = Utils$2.extend({
	  progress: Number,
	  infinite: Boolean,
	}, Mixins.colorProps);

	var progressbar = {
	  name: 'f7-progressbar',
	  render: function render(c) {
	    var self = this;
	    var progress = self.progress;
	    return c('span', {
	      staticClass: 'progressbar',
	      class: self.classes,
	      attrs: {
	        'data-progress': progress,
	      },
	    }, [
	      c('span', {
	        style: {
	          transform: progress ? ("translate3d(" + (-100 + progress) + "%, 0, 0)") : '',
	          '-webkit-transform': progress ? ("translate3d(" + (-100 + progress) + "%, 0, 0)") : '',
	        },
	      }) ]);
	  },
	  props: ProgressbarProps,
	  computed: {
	    classes: function classes() {
	      return Utils$2.extend({
	        'progressbar-infinite': this.infinite,
	      }, Mixins.colorClasses(this));
	    },
	  },
	  methods: {
	    set: function set(progress, speed) {
	      var self = this;
	      if (!self.$f7) { return; }
	      self.$f7.progressbar.set(self.$el, progress, speed);
	    },
	  },
	};

	var RadioProps = Utils$2.extend({
	  checked: Boolean,
	  name: [Number, String],
	  value: [Number, String, Boolean],
	  disabled: Boolean,
	  readonly: Boolean,
	}, Mixins.colorProps);

	var radio = {
	  name: 'f7-radio',
	  props: RadioProps,
	  render: function render(c) {
	    var self = this;

	    var inputEl = c('input', {
	      attrs: {
	        type: 'radio',
	        name: self.name,
	      },
	      domProps: {
	        value: self.value,
	        disabled: self.disabled,
	        readonly: self.readonly,
	        checked: self.checked,
	      },
	      on: {
	        change: self.onChange,
	      },
	    });

	    var iconEl = c('i', { staticClass: 'icon-radio' });

	    return c('label', {
	      staticClass: 'radio',
	      class: Utils$2.extend({
	        disabled: self.disabled,
	      }, Mixins.colorClasses(self)),
	    }, [inputEl, iconEl, self.$slots.default]);
	  },
	  methods: {
	    onChange: function onChange(event) {
	      this.$emit('change', event);
	    },
	  },
	};

	var RowProps = Utils$2.extend(
	  {
	    noGap: Boolean,
	    tag: {
	      type: String,
	      default: 'div',
	    },
	  },
	  Mixins.colorProps
	);

	var row = {
	  name: 'f7-row',
	  props: RowProps,
	  render: function render(c) {
	    var self = this;
	    return c(self.tag, {
	      staticClass: 'row',
	      class: self.classes,
	    }, [self.$slots.default]);
	  },
	  computed: {
	    classes: function classes() {
	      var self = this;
	      return Utils$2.extend(
	        {
	          'no-gap': self.noGap,
	        },
	        Mixins.colorClasses(self)
	      );
	    },
	  },
	};

	var SearchbarProps = Utils$2.extend(
	  {
	    noShadow: Boolean,
	    noHairline: Boolean,
	    form: {
	      type: Boolean,
	      default: true,
	    },
	    placeholder: {
	      type: String,
	      default: 'Search',
	    },
	    disableButton: {
	      type: Boolean,
	      default: true,
	    },
	    disableButtonText: {
	      type: String,
	      default: 'Cancel',
	    },
	    clearButton: {
	      type: Boolean,
	      default: true,
	    },

	    // SB Params
	    expandable: Boolean,
	    searchContainer: [String, Object],
	    searchIn: {
	      type: String,
	      default: '.item-title',
	    },
	    searchItem: {
	      type: String,
	      default: 'li',
	    },
	    foundEl: {
	      type: [String, Object],
	      default: '.searchbar-found',
	    },
	    notFoundEl: {
	      type: [String, Object],
	      default: '.searchbar-not-found',
	    },
	    backdrop: {
	      type: Boolean,
	      default: true,
	    },
	    backdropEl: [String, Object],
	    hideOnEnableEl: {
	      type: [String, Object],
	      default: '.searchbar-hide-on-enable',
	    },
	    hideOnSearchEl: {
	      type: [String, Object],
	      default: '.searchbar-hide-on-search',
	    },
	    ignore: {
	      type: String,
	      default: '.searchbar-ignore',
	    },
	    customSearch: {
	      type: Boolean,
	      default: false,
	    },
	    removeDiacritics: {
	      type: Boolean,
	      default: false,
	    },
	    hideDividers: {
	      type: Boolean,
	      default: true,
	    },
	    hideGroups: {
	      type: Boolean,
	      default: true,
	    },
	    init: {
	      type: Boolean,
	      default: true,
	    },
	  },
	  Mixins.colorProps
	);

	var searchbar = {
	  name: 'f7-searchbar',
	  render: function render(c) {
	    var self = this;
	    var clearEl;
	    var disableEl;

	    var inputEl = c('input', {
	      attrs: {
	        placeholder: self.placeholder,
	        type: 'search',
	      },
	      on: {
	        input: self.onInput,
	        change: self.onChange,
	        focus: self.onFocus,
	        blur: self.onBlur,
	      },
	    });
	    if (self.clearButton) {
	      clearEl = c('span', {
	        staticClass: 'input-clear-button',
	        on: {
	          click: self.onClearButtonClick,
	        },
	      });
	    }
	    if (self.disableButton) {
	      disableEl = c('span', {
	        staticClass: 'searchbar-disable-button',
	        on: {
	          click: self.onDisableButtonClick,
	        },
	      }, [self.disableButtonText]);
	    }
	    var iconEl = c('i', {
	      staticClass: 'searchbar-icon',
	    });

	    var inputWrapEl = c('div', { staticClass: 'searchbar-input-wrap' }, [self.$slots['input-wrap-start'], inputEl, iconEl, clearEl, self.$slots['input-wrap-end']]);

	    var innerEl = c('div', {
	      staticClass: 'searchbar-inner',
	    }, [self.$slots['inner-start'], inputWrapEl, disableEl, self.$slots['inner-end'], self.$slots.default]);

	    return c(self.form ? 'form' : 'div', {
	      staticClass: 'searchbar',
	      class: Utils$2.extend({
	        'no-shadow': self.noShadow,
	        'no-hairline': self.noHairline,
	        'searchbar-expandable': self.expandable,
	      }, Mixins.colorClasses(self)),
	      on: {
	        submit: self.onSubmit,
	      },
	    }, [self.$slots['before-inner'], innerEl, self.$slots['after-inner']]);
	  },
	  beforeDestroy: function beforeDestroy() {
	    if (this.f7Searchbar && this.f7Searchbar.destroy) { this.f7Searchbar.destroy(); }
	  },
	  props: SearchbarProps,
	  methods: {
	    search: function search(query) {
	      if (!this.f7Searchbar) { return undefined; }
	      return this.f7Searchbar.search(query);
	    },
	    enable: function enable() {
	      if (!this.f7Searchbar) { return undefined; }
	      return this.f7Searchbar.enable();
	    },
	    disable: function disable() {
	      if (!this.f7Searchbar) { return undefined; }
	      return this.f7Searchbar.disable();
	    },
	    toggle: function toggle() {
	      if (!this.f7Searchbar) { return undefined; }
	      return this.toggle.disable();
	    },
	    clear: function clear() {
	      if (!this.f7Searchbar) { return undefined; }
	      return this.f7Searchbar.clear();
	    },
	    onChange: function onChange(event) {
	      this.$emit('change', event);
	    },
	    onInput: function onInput(event) {
	      this.$emit('input', event);
	    },
	    onFocus: function onFocus(event) {
	      this.$emit('focus', event);
	    },
	    onBlur: function onBlur(event) {
	      this.$emit('blur', event);
	    },
	    onSubmit: function onSubmit(event) {
	      this.$emit('submit', event);
	    },
	    onClearButtonClick: function onClearButtonClick(event) {
	      this.$emit('click:clear', event);
	    },
	    onDisableButtonClick: function onDisableButtonClick(event) {
	      this.$emit('click:disable', event);
	    },

	    onF7Ready: function onF7Ready() {
	      var self = this;
	      if (!self.init) { return; }
	      var params = {
	        el: self.$el,
	        searchContainer: self.searchContainer,
	        searchIn: self.searchIn,
	        searchItem: self.searchItem,
	        hideOnEnableEl: self.hideOnEnableEl,
	        hideOnSearchEl: self.hideOnSearchEl,
	        foundEl: self.foundEl,
	        notFoundEl: self.notFoundEl,
	        backdrop: self.backdrop,
	        backdropEl: self.backdropEl,
	        disableButton: self.disableButton,
	        ignore: self.ignore,
	        customSearch: self.customSearch,
	        removeDiacritics: self.removeDiacritics,
	        hideDividers: self.hideDividers,
	        hideGroups: self.hideGroups,
	        on: {
	          search: function search(searchbar, query, previousQuery) {
	            self.$emit('searchbar:search', searchbar, query, previousQuery);
	          },
	          clear: function clear(searchbar, previousQuery) {
	            self.$emit('searchbar:clear', searchbar, previousQuery);
	          },
	          enable: function enable(searchbar) {
	            self.$emit('searchbar:enable', searchbar);
	          },
	          disable: function disable(searchbar) {
	            self.$emit('searchbar:disable', searchbar);
	          },
	        },
	      };
	      Object.keys(params).forEach(function (key) {
	        if (typeof params[key] === 'undefined' || params[key] === '') {
	          delete params[key];
	        }
	      });
	      self.f7Searchbar = self.$f7.searchbar.create(params);
	    },
	  },
	};

	var SegmentedProps = Utils$2.extend({
	  raised: Boolean,
	  round: Boolean,
	  tag: {
	    type: String,
	    default: 'div',
	  },
	}, Mixins.colorProps);

	var segmented = {
	  name: 'f7-segmented',
	  props: SegmentedProps,
	  render: function render(c) {
	    var self = this;
	    return c(self.tag, {
	      staticClass: 'segmented',
	      class: Utils$2.extend({
	        'segmented-raised': self.raised,
	        'segmented-round': self.round,
	      }, Mixins.colorClasses(self)),
	    }, [self.$slots.default]);
	  },
	};

	var SheetProps = Utils$2.extend(
	  {
	    opened: Boolean,
	    backdrop: Boolean,
	  },
	  Mixins.colorProps
	);

	var sheet = {
	  name: 'f7-sheet',
	  render: function render(c) {
	    var self = this;
	    var fixedList = [];
	    var staticList = [];
	    var fixedTags = ('navbar toolbar tabbar subnavbar searchbar messagebar fab').split(' ');

	    var tag;
	    var child;

	    if (self.$slots.default) {
	      for (var i = 0; i < self.$slots.default.length; i += 1) {
	        child = self.$slots.default[i];
	        tag = child.tag;
	        if (!tag) {
	          staticList.push(child);
	          continue; // eslint-disable-line
	        }
	        var isFixed = false;
	        for (var j = 0; j < fixedTags.length; j += 1) {
	          if (tag.indexOf(fixedTags[j]) >= 0) {
	            isFixed = true;
	          }
	        }
	        if (isFixed) { fixedList.push(child); }
	        else { staticList.push(child); }
	      }
	    }

	    var innerEl = c('div', {
	      staticClass: 'sheet-modal-inner',
	    }, staticList);

	    return c('div', {
	      class: self.classes,
	      staticClass: 'sheet-modal',
	      on: {
	        'sheet:open': self.onOpen,
	        'sheet:opened': self.onOpened,
	        'sheet:close': self.onClose,
	        'sheet:closed': self.onClosed,
	      },
	    }, [fixedList, innerEl]);
	  },
	  watch: {
	    opened: function opened(opened$1) {
	      var self = this;
	      if (!self.f7Sheet) { return; }
	      if (opened$1) {
	        self.f7Sheet.open();
	      } else {
	        self.f7Sheet.close();
	      }
	    },
	  },
	  props: SheetProps,
	  computed: {
	    classes: function classes() {
	      var self = this;
	      return Mixins.colorClasses(self);
	    },
	  },
	  beforeDestroy: function beforeDestroy() {
	    var self = this;
	    if (self.f7Sheet) { self.f7Sheet.destroy(); }
	  },
	  methods: {
	    onOpen: function onOpen(event) {
	      this.$emit('sheet:open', event);
	    },
	    onOpened: function onOpened(event) {
	      this.$emit('sheet:opened', event);
	    },
	    onClose: function onClose(event) {
	      this.$emit('sheet:close', event);
	    },
	    onClosed: function onClosed(event) {
	      this.$emit('sheet:closed', event);
	    },
	    open: function open(animate) {
	      var self = this;
	      if (!self.$f7) { return undefined; }
	      return self.$f7.sheet.open(self.$el, animate);
	    },
	    close: function close(animate) {
	      var self = this;
	      if (!self.$f7) { return undefined; }
	      return self.$f7.sheet.close(self.$el, animate);
	    },
	    onF7Ready: function onF7Ready() {
	      var self = this;
	      var backdrop = self.backdrop;
	      if (self.$options.propsData.backdrop === undefined) {
	        var app = self.$f7;
	        backdrop = app.params.sheet && app.params.sheet.backdrop !== undefined ? app.params.sheet.backdrop : self.$theme.md;
	      }
	      self.f7Sheet = self.$f7.sheet.create({
	        el: self.$el,
	        backdrop: backdrop,
	      });
	      if (self.opened) {
	        self.f7Sheet.open(false);
	      }
	    },
	  },
	};

	var statusbar = {render: function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"statusbar",class:_vm.classes})},staticRenderFns: [],
	  name: 'f7-statusbar',
	  props: Mixins.colorProps,
	  computed: {
	    classes: function classes() {
	      var self = this;
	      return Mixins.colorClasses(self);
	    },
	  },
	};

	var StepperProps = Utils$2.extend({
	  init: {
	    type: Boolean,
	    default: true,
	  },
	  value: {
	    type: Number,
	    default: 0,
	  },
	  min: {
	    type: Number,
	    default: 0,
	  },
	  max: {
	    type: Number,
	    default: 100,
	  },
	  step: {
	    type: Number,
	    default: 1,
	  },
	  formatValue: Function,
	  input: {
	    type: Boolean,
	    default: true,
	  },
	  inputType: {
	    type: String,
	    default: 'text',
	  },
	  inputReadonly: {
	    type: Boolean,
	    default: true,
	  },
	  autorepeat: {
	    type: Boolean,
	    default: false,
	  },
	  autorepeatDynamic: {
	    type: Boolean,
	    default: false,
	  },
	  wraps: {
	    type: Boolean,
	    default: false,
	  },
	  disabled: Boolean,
	  buttonsOnly: Boolean,

	  round: Boolean,
	  roundMd: Boolean,
	  roundIos: Boolean,
	  fill: Boolean,
	  fillMd: Boolean,
	  fillIos: Boolean,
	  big: Boolean,
	  bigMd: Boolean,
	  bigIos: Boolean,
	  small: Boolean,
	  smallMd: Boolean,
	  smallIos: Boolean,
	  raised: Boolean,
	}, Mixins.colorProps);

	var SubnavbarProps = Utils$2.extend({
	  sliding: Boolean,
	  title: String,
	  inner: {
	    type: Boolean,
	    default: true,
	  },
	}, Mixins.colorProps);

	var subnavbar = {render: function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"subnavbar",class:_vm.classes},[(_vm.inner)?_c('div',{staticClass:"subnavbar-inner"},[(_vm.title)?_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_vm._v(" "),_vm._t("default")],2):_vm._t("default")],2)},staticRenderFns: [],
	  name: 'f7-subnavbar',
	  props: SubnavbarProps,
	  computed: {
	    classes: function classes() {
	      return Utils$2.extend({
	        sliding: this.sliding,
	      }, Mixins.colorClasses(this));
	    },
	  },
	};

	var SwipeoutActionsProps = Utils$2.extend({
	  left: Boolean,
	  right: Boolean,
	  side: String,
	}, Mixins.colorProps);

	var swipeoutActions = {render: function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classes},[_vm._t("default")],2)},staticRenderFns: [],
	  name: 'f7-swipeout-actions',
	  props: SwipeoutActionsProps,
	  computed: {
	    classes: function classes() {
	      return Utils$2.extend(( obj = {}, obj[("swipeout-actions-" + (this.sideComputed))] = true, obj ), Mixins.colorClasses(this));
	      var obj;
	    },
	    sideComputed: function sideComputed() {
	      if (!this.side) {
	        if (this.left) { return 'left'; }
	        if (this.right) { return 'right'; }
	        return 'right';
	      }
	      return this.side;
	    },
	  },
	  data: function data() {
	    return {};
	  },
	};

	var SwipeoutButtonProps = Utils$2.extend({
	  text: String,
	  confirmText: String,
	  overswipe: Boolean,
	  close: Boolean,
	  delete: Boolean,
	}, Mixins.colorProps);

	var swipeoutButton = {render: function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:_vm.classes,attrs:{"data-confirm":_vm.confirmText || undefined},on:{"click":_vm.onClick}},[_vm._t("default",[_vm._v(_vm._s(_vm.text))])],2)},staticRenderFns: [],
	  name: 'f7-swipeout-button',
	  props: SwipeoutButtonProps,
	  computed: {
	    classes: function classes() {
	      return Utils$2.extend({
	        'swipeout-overswipe': this.overswipe,
	        'swipeout-delete': this.delete,
	        'swipeout-close': this.close,
	      }, Mixins.colorClasses(this));
	    },
	  },
	  methods: {
	    onClick: function onClick(event) {
	      this.$emit('click', event);
	    },
	  },
	};

	var swiperSlide = {render: function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"swiper-slide"},[(_vm.zoom)?_c('div',{staticClass:"swiper-zoom-container"},[_vm._t("default")],2):_vm._t("default")],2)},staticRenderFns: [],
	  name: 'f7-swiper-slide',
	  props: {
	    zoom: Boolean,
	  },
	};

	var SwiperProps = Utils$2.extend({
	  params: Object,
	  pagination: Boolean,
	  scrollbar: Boolean,
	  navigation: Boolean,
	  init: {
	    type: Boolean,
	    default: true,
	  },
	}, Mixins.colorProps);

	var swiper = {render: function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"swiper-container",class:_vm.classes},[_vm._t("before-wrapper"),_vm._v(" "),_c('div',{staticClass:"swiper-wrapper"},[_vm._t("default")],2),_vm._v(" "),(_vm.paginationComputed === true)?_c('div',{staticClass:"swiper-pagination"}):_vm._e(),_vm._v(" "),(_vm.scrollbarComputed === true)?_c('div',{staticClass:"swiper-scrollbar"}):_vm._e(),_vm._v(" "),(_vm.navigationComputed === true)?_c('div',{staticClass:"swiper-button-next"}):_vm._e(),_vm._v(" "),(_vm.navigationComputed === true)?_c('div',{staticClass:"swiper-button-prev"}):_vm._e(),_vm._v(" "),_vm._t("after-wrapper")],2)},staticRenderFns: [],
	  name: 'f7-swiper',
	  beforeDestroy: function beforeDestroy() {
	    var self = this;
	    if (!self.init) { return; }
	    if (self.swiper && self.swiper.destroy) { self.swiper.destroy(); }
	  },
	  data: function data() {
	    return {
	      initialUpdate: false,
	    };
	  },
	  updated: function updated() {
	    var self = this;
	    if (!self.initialUpdate) {
	      self.initialUpdate = true;
	      return;
	    }
	    if (self.swiper && self.swiper.update) { self.swiper.update(); }
	  },
	  props: SwiperProps,
	  computed: {
	    classes: function classes() {
	      return Mixins.colorClasses(this);
	    },
	    paginationComputed: function paginationComputed() {
	      var self = this;
	      if (self.pagination === true || (self.params && self.params.pagination && !self.params.pagination.el)) {
	        return true;
	      }
	      return false;
	    },
	    scrollbarComputed: function scrollbarComputed() {
	      var self = this;
	      if (self.scrollbar === true || (self.params && self.params.scrollbar && !self.params.scrollbar.el)) {
	        return true;
	      }
	      return false;
	    },
	    navigationComputed: function navigationComputed() {
	      var self = this;
	      if (self.navigation === true || (self.params && self.params.navigation && !self.params.navigation.nextEl && !self.params.navigation.prevEl)) {
	        return true;
	      }
	      return false;
	    },
	  },
	  methods: {
	    onF7Ready: function onF7Ready(f7) {
	      var self = this;
	      if (!self.init) { return; }
	      var params = {
	        pagination: {},
	        navigation: {},
	        scrollbar: {},
	      };
	      if (self.params) { Utils$2.extend(params, self.params); }
	      if (self.pagination && !params.pagination.el) { params.pagination.el = '.swiper-pagination'; }
	      if (self.navigation && !params.navigation.nextEl && !params.navigation.prevEl) {
	        params.navigation.nextEl = '.swiper-button-next';
	        params.navigation.prevEl = '.swiper-button-prev';
	      }
	      if (self.scrollbar && !params.scrollbar.el) { params.scrollbar.el = '.swiper-scrollbar'; }

	      self.swiper = f7.swiper.create(this.$el, params);
	    },
	  },
	};

	var TabProps = Utils$2.extend({
	  tabActive: Boolean,
	  id: String,
	}, Mixins.colorProps);

	var tab = {
	  name: 'f7-tab',
	  props: TabProps,
	  data: function data() {
	    return {
	      tabContent: null,
	    };
	  },
	  render: function render(c) {
	    var self = this;

	    return c(
	      'div', {
	        staticClass: 'tab',
	        attrs: {
	          id: self.id,
	        },
	        class: Utils$2.extend({
	          'tab-active': self.tabActive,
	        }, Mixins.colorClasses(self)),
	        on: {
	          'tab:show': self.onTabShow,
	          'tab:hide': self.onTabHide,
	        },
	      },
	      [self.tabContent ? c(self.tabContent.component, { tag: 'component', props: self.tabContent.params, key: self.tabContent.id }) : self.$slots.default]
	    );
	  },
	  methods: {
	    show: function show(animate) {
	      if (!this.$f7) { return; }
	      this.$f7.tab.show(this.$el, animate);
	    },
	    onTabShow: function onTabShow(e) {
	      this.$emit('tab:show', e);
	    },
	    onTabHide: function onTabHide(e) {
	      this.$emit('tab:hide', e);
	    },
	  },
	};

	var TabsProps = Utils$2.extend({
	  animated: Boolean,
	  swipeable: Boolean,
	  routable: Boolean,
	}, Mixins.colorProps);

	var tabs = {
	  name: 'f7-tabs',
	  render: function render(c) {
	    var self = this;
	    var tabsEl = c('div', { staticClass: 'tabs' }, [self.$slots.default]);
	    if (self.animated || self.swipeable) { return c('div', { class: self.classes }, [tabsEl]); }
	    return tabsEl;
	  },
	  props: TabsProps,
	  computed: {
	    classes: function classes() {
	      return Utils$2.extend({
	        'tabs-animated-wrap': this.animated,
	        'tabs-swipeable-wrap': this.swipeable,
	        'tabs-routable': this.routable,
	      }, Mixins.colorClasses(this));
	    },
	  },
	};

	var ToolbarProps = Utils$2.extend({
	  bottomMd: Boolean,
	  tabbar: Boolean,
	  labels: Boolean,
	  scrollable: Boolean,
	  hidden: Boolean,
	  noShadow: Boolean,
	  noHairline: Boolean,
	  inner: {
	    type: Boolean,
	    default: true,
	  },
	}, Mixins.colorProps);

	var toolbar = {render: function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"toolbar",class:_vm.classes},[_vm._t("before-inner"),_vm._v(" "),(_vm.inner)?_c('div',{staticClass:"toolbar-inner"},[_vm._t("default")],2):_vm._t("default"),_vm._v(" "),_vm._t("after-inner")],2)},staticRenderFns: [],
	  name: 'f7-toolbar',
	  props: ToolbarProps,
	  updated: function updated() {
	    var self = this;
	    if (self.tabbar && self.$f7) {
	      self.$nextTick(function () {
	        self.$f7.toolbar.setHighlight(self.$el);
	      });
	    }
	  },
	  computed: {
	    classes: function classes() {
	      var self = this;
	      return Utils$2.extend({
	        'toolbar-bottom-md': self.bottomMd,
	        tabbar: self.tabbar,
	        'tabbar-labels': self.labels,
	        'tabbar-scrollable': self.scrollable,
	        'toolbar-hidden': self.hidden,
	        'no-shadow': self.noShadow,
	        'no-hairline': self.noHairline,
	      }, Mixins.colorClasses(self));
	    },
	  },
	  methods: {
	    hide: function hide(animate) {
	      var self = this;
	      if (!self.$f7) { return; }
	      self.$f7.toolbar.hide(this.$el, animate);
	    },
	    show: function show(animate) {
	      var self = this;
	      if (!self.$f7) { return; }
	      self.$f7.toolbar.show(this.$el, animate);
	    },
	    onF7Ready: function onF7Ready(f7) {
	      var self = this;
	      if (self.tabbar) { f7.toolbar.setHighlight(self.$el); }
	    },
	  },
	};

	var ViewProps = Utils$2.extend(
	  {
	    tab: Boolean,
	    tabActive: Boolean,

	    name: String,
	    router: Boolean,
	    linksView: [Object, String],
	    url: String,
	    main: Boolean,
	    stackPages: Boolean,
	    xhrCache: String,
	    xhrCacheIgnore: Array,
	    xhrCacheIgnoreGetParameters: Boolean,
	    xhrCacheDuration: Number,
	    preloadPreviousPage: Boolean,
	    uniqueHistory: Boolean,
	    uniqueHistoryIgnoreGetParameters: Boolean,
	    allowDuplicateUrls: Boolean,
	    reloadPages: Boolean,
	    removeElements: Boolean,
	    removeElementsWithTimeout: Boolean,
	    removeElementsTimeout: Number,
	    restoreScrollTopOnBack: Boolean,
	    // Swipe Back
	    iosSwipeBack: Boolean,
	    iosSwipeBackAnimateShadow: Boolean,
	    iosSwipeBackAnimateOpacity: Boolean,
	    iosSwipeBackActiveArea: Number,
	    iosSwipeBackThreshold: Number,
	    // Push State
	    pushState: Boolean,
	    pushStateRoot: String,
	    pushStateAnimate: Boolean,
	    pushStateAnimateOnLoad: Boolean,
	    pushStateSeparator: String,
	    pushStateOnLoad: Boolean,
	    // Animate Pages
	    animate: Boolean,
	    // iOS Dynamic Navbar
	    iosDynamicNavbar: Boolean,
	    iosSeparateDynamicNavbar: Boolean,
	    // Animate iOS Navbar Back Icon
	    iosAnimateNavbarBackIcon: Boolean,
	    // MD Theme delay
	    materialPageLoadDelay: Number,

	    passRouteQueryToRequest: Boolean,
	    passRouteParamsToRequest: Boolean,
	    routes: Array,
	    routesAdd: Array,

	    init: {
	      type: Boolean,
	      default: true,
	    },
	  },
	  Mixins.colorProps
	);

	var view = {
	  name: 'f7-view',
	  props: ViewProps,
	  render: function render(c) {
	    var self = this;
	    var pages = self.pages.map(function (page) { return c(page.component, {
	      tag: 'component',
	      props: page.params ? page.params || {} : {},
	      key: page.id,
	    }); });
	    return c(
	      'div',
	      {
	        staticClass: 'view',
	        ref: 'view',
	        class: self.classes,
	        on: {
	          'swipeback:move': self.onSwipeBackMove,
	          'swipeback:beforechange': self.onSwipeBackBeforeChange,
	          'swipeback:afterchange': self.onSwipeBackAfterChange,
	          'swipeback:beforereset': self.onSwipeBackBeforeReset,
	          'swipeback:afterreset': self.onSwipeBackAfterReset,
	          'tab:show': self.onTabShow,
	          'tab:hide': self.onTabHide,
	        },
	      },
	      [
	        self.$slots.default,
	        pages ]
	    );
	  },
	  beforeDestroy: function beforeDestroy() {
	    var self = this;
	    if (self.f7View && self.f7View.destroy) { self.f7View.destroy(); }
	  },
	  data: function data() {
	    return {
	      pages: [],
	    };
	  },
	  computed: {
	    classes: function classes() {
	      return Utils$2.extend(
	        {
	          'view-main': this.main,
	          'tab-active': this.tabActive,
	          tab: this.tab,
	        },
	        Mixins.colorClasses(this)
	      );
	    },
	  },
	  methods: {
	    onF7Ready: function onF7Ready(f7) {
	      var self = this;
	      if (!self.init) { return; }

	      // Init View
	      self.f7View = f7.views.create(self.$el, self.$options.propsData);
	    },
	    onSwipeBackMove: function onSwipeBackMove(event) {
	      this.$emit('swipeback:move', event, event.detail);
	    },
	    onSwipeBackBeforeChange: function onSwipeBackBeforeChange(event) {
	      this.$emit('swipeback:beforechange', event, event.detail);
	    },
	    onSwipeBackAfterChange: function onSwipeBackAfterChange(event) {
	      this.$emit('swipeback:afterchange', event, event.detail);
	    },
	    onSwipeBackBeforeReset: function onSwipeBackBeforeReset(event) {
	      this.$emit('swipeback:beforereset', event, event.detail);
	    },
	    onSwipeBackAfterReset: function onSwipeBackAfterReset(event) {
	      this.$emit('swipeback:afterreset', event, event.detail);
	    },
	    onTabShow: function onTabShow(e) {
	      this.$emit('tab:show', e);
	    },
	    onTabHide: function onTabHide(e) {
	      this.$emit('tab:hide', e);
	    },
	  },
	};

	var ViewsProps = Utils$2.extend(
	  {
	    tabs: Boolean,
	  },
	  Mixins.colorProps
	);

	var views = {render: function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"views",class:_vm.classes},[_vm._t("default")],2)},staticRenderFns: [],
	  name: 'f7-views',
	  props: ViewsProps,
	  computed: {
	    classes: function classes() {
	      return Utils$2.extend(
	        {
	          tabs: this.tabs,
	        },
	        Mixins.colorClasses(this)
	      );
	    },
	  },
	};

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject$1(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}

	var isObject_1 = isObject$1;

	var isObject$2 = /*#__PURE__*/Object.freeze({
		default: isObject_1,
		__moduleExports: isObject_1
	});

	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

	var _freeGlobal = freeGlobal;

	var _freeGlobal$1 = /*#__PURE__*/Object.freeze({
		default: _freeGlobal,
		__moduleExports: _freeGlobal
	});

	var freeGlobal$1 = ( _freeGlobal$1 && _freeGlobal ) || _freeGlobal$1;

	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

	/** Used as a reference to the global object. */
	var root = freeGlobal$1 || freeSelf || Function('return this')();

	var _root = root;

	var _root$1 = /*#__PURE__*/Object.freeze({
		default: _root,
		__moduleExports: _root
	});

	var root$1 = ( _root$1 && _root ) || _root$1;

	/**
	 * Gets the timestamp of the number of milliseconds that have elapsed since
	 * the Unix epoch (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Date
	 * @returns {number} Returns the timestamp.
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => Logs the number of milliseconds it took for the deferred invocation.
	 */
	var now = function() {
	  return root$1.Date.now();
	};

	var now_1 = now;

	var now$1 = /*#__PURE__*/Object.freeze({
		default: now_1,
		__moduleExports: now_1
	});

	/** Used to match a single whitespace character. */
	var reWhitespace = /\s/;

	/**
	 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
	 * character of `string`.
	 *
	 * @private
	 * @param {string} string The string to inspect.
	 * @returns {number} Returns the index of the last non-whitespace character.
	 */
	function trimmedEndIndex(string) {
	  var index = string.length;

	  while (index-- && reWhitespace.test(string.charAt(index))) {}
	  return index;
	}

	var _trimmedEndIndex = trimmedEndIndex;

	var _trimmedEndIndex$1 = /*#__PURE__*/Object.freeze({
		default: _trimmedEndIndex,
		__moduleExports: _trimmedEndIndex
	});

	var trimmedEndIndex$1 = ( _trimmedEndIndex$1 && _trimmedEndIndex ) || _trimmedEndIndex$1;

	/** Used to match leading whitespace. */
	var reTrimStart = /^\s+/;

	/**
	 * The base implementation of `_.trim`.
	 *
	 * @private
	 * @param {string} string The string to trim.
	 * @returns {string} Returns the trimmed string.
	 */
	function baseTrim(string) {
	  return string
	    ? string.slice(0, trimmedEndIndex$1(string) + 1).replace(reTrimStart, '')
	    : string;
	}

	var _baseTrim = baseTrim;

	var _baseTrim$1 = /*#__PURE__*/Object.freeze({
		default: _baseTrim,
		__moduleExports: _baseTrim
	});

	/** Built-in value references. */
	var Symbol$1 = root$1.Symbol;

	var _Symbol = Symbol$1;

	var _Symbol$1 = /*#__PURE__*/Object.freeze({
		default: _Symbol,
		__moduleExports: _Symbol
	});

	var Symbol$2 = ( _Symbol$1 && _Symbol ) || _Symbol$1;

	/** Used for built-in method references. */
	var objectProto = Object.prototype;

	/** Used to check objects for own properties. */
	var hasOwnProperty$1 = objectProto.hasOwnProperty;

	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;

	/** Built-in value references. */
	var symToStringTag = Symbol$2 ? Symbol$2.toStringTag : undefined;

	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty$1.call(value, symToStringTag),
	      tag = value[symToStringTag];

	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}

	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}

	var _getRawTag = getRawTag;

	var _getRawTag$1 = /*#__PURE__*/Object.freeze({
		default: _getRawTag,
		__moduleExports: _getRawTag
	});

	/** Used for built-in method references. */
	var objectProto$1 = Object.prototype;

	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString$1 = objectProto$1.toString;

	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString$1.call(value);
	}

	var _objectToString = objectToString;

	var _objectToString$1 = /*#__PURE__*/Object.freeze({
		default: _objectToString,
		__moduleExports: _objectToString
	});

	var getRawTag$1 = ( _getRawTag$1 && _getRawTag ) || _getRawTag$1;

	var objectToString$1 = ( _objectToString$1 && _objectToString ) || _objectToString$1;

	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';

	/** Built-in value references. */
	var symToStringTag$1 = Symbol$2 ? Symbol$2.toStringTag : undefined;

	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag$1 && symToStringTag$1 in Object(value))
	    ? getRawTag$1(value)
	    : objectToString$1(value);
	}

	var _baseGetTag = baseGetTag;

	var _baseGetTag$1 = /*#__PURE__*/Object.freeze({
		default: _baseGetTag,
		__moduleExports: _baseGetTag
	});

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}

	var isObjectLike_1 = isObjectLike;

	var isObjectLike$1 = /*#__PURE__*/Object.freeze({
		default: isObjectLike_1,
		__moduleExports: isObjectLike_1
	});

	var baseGetTag$1 = ( _baseGetTag$1 && _baseGetTag ) || _baseGetTag$1;

	var isObjectLike$2 = ( isObjectLike$1 && isObjectLike_1 ) || isObjectLike$1;

	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';

	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike$2(value) && baseGetTag$1(value) == symbolTag);
	}

	var isSymbol_1 = isSymbol;

	var isSymbol$1 = /*#__PURE__*/Object.freeze({
		default: isSymbol_1,
		__moduleExports: isSymbol_1
	});

	var baseTrim$1 = ( _baseTrim$1 && _baseTrim ) || _baseTrim$1;

	var isObject$3 = ( isObject$2 && isObject_1 ) || isObject$2;

	var isSymbol$2 = ( isSymbol$1 && isSymbol_1 ) || isSymbol$1;

	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;

	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;

	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;

	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;

	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber$1(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol$2(value)) {
	    return NAN;
	  }
	  if (isObject$3(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject$3(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = baseTrim$1(value);
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}

	var toNumber_1 = toNumber$1;

	var toNumber$2 = /*#__PURE__*/Object.freeze({
		default: toNumber_1,
		__moduleExports: toNumber_1
	});

	var now$2 = ( now$1 && now_1 ) || now$1;

	var toNumber$3 = ( toNumber$2 && toNumber_1 ) || toNumber$2;

	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;

	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed `func` invocations and a `flush` method to immediately invoke them.
	 * Provide `options` to indicate whether `func` should be invoked on the
	 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	 * with the last arguments provided to the debounced function. Subsequent
	 * calls to the debounced function return the result of the last `func`
	 * invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the debounced function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=false]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {number} [options.maxWait]
	 *  The maximum time `func` is allowed to be delayed before it's invoked.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // Avoid costly calculations while the window size is in flux.
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	 * jQuery(element).on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', debounced);
	 *
	 * // Cancel the trailing debounced invocation.
	 * jQuery(window).on('popstate', debounced.cancel);
	 */
	function debounce(func, wait, options) {
	  var lastArgs,
	      lastThis,
	      maxWait,
	      result,
	      timerId,
	      lastCallTime,
	      lastInvokeTime = 0,
	      leading = false,
	      maxing = false,
	      trailing = true;

	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  wait = toNumber$3(wait) || 0;
	  if (isObject$3(options)) {
	    leading = !!options.leading;
	    maxing = 'maxWait' in options;
	    maxWait = maxing ? nativeMax(toNumber$3(options.maxWait) || 0, wait) : maxWait;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }

	  function invokeFunc(time) {
	    var args = lastArgs,
	        thisArg = lastThis;

	    lastArgs = lastThis = undefined;
	    lastInvokeTime = time;
	    result = func.apply(thisArg, args);
	    return result;
	  }

	  function leadingEdge(time) {
	    // Reset any `maxWait` timer.
	    lastInvokeTime = time;
	    // Start the timer for the trailing edge.
	    timerId = setTimeout(timerExpired, wait);
	    // Invoke the leading edge.
	    return leading ? invokeFunc(time) : result;
	  }

	  function remainingWait(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime,
	        timeWaiting = wait - timeSinceLastCall;

	    return maxing
	      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
	      : timeWaiting;
	  }

	  function shouldInvoke(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime;

	    // Either this is the first call, activity has stopped and we're at the
	    // trailing edge, the system time has gone backwards and we're treating
	    // it as the trailing edge, or we've hit the `maxWait` limit.
	    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	  }

	  function timerExpired() {
	    var time = now$2();
	    if (shouldInvoke(time)) {
	      return trailingEdge(time);
	    }
	    // Restart the timer.
	    timerId = setTimeout(timerExpired, remainingWait(time));
	  }

	  function trailingEdge(time) {
	    timerId = undefined;

	    // Only invoke if we have `lastArgs` which means `func` has been
	    // debounced at least once.
	    if (trailing && lastArgs) {
	      return invokeFunc(time);
	    }
	    lastArgs = lastThis = undefined;
	    return result;
	  }

	  function cancel() {
	    if (timerId !== undefined) {
	      clearTimeout(timerId);
	    }
	    lastInvokeTime = 0;
	    lastArgs = lastCallTime = lastThis = timerId = undefined;
	  }

	  function flush() {
	    return timerId === undefined ? result : trailingEdge(now$2());
	  }

	  function debounced() {
	    var time = now$2(),
	        isInvoking = shouldInvoke(time);

	    lastArgs = arguments;
	    lastThis = this;
	    lastCallTime = time;

	    if (isInvoking) {
	      if (timerId === undefined) {
	        return leadingEdge(lastCallTime);
	      }
	      if (maxing) {
	        // Handle invocations in a tight loop.
	        clearTimeout(timerId);
	        timerId = setTimeout(timerExpired, wait);
	        return invokeFunc(lastCallTime);
	      }
	    }
	    if (timerId === undefined) {
	      timerId = setTimeout(timerExpired, wait);
	    }
	    return result;
	  }
	  debounced.cancel = cancel;
	  debounced.flush = flush;
	  return debounced;
	}

	var debounce_1 = debounce;

	var jquery = createCommonjsModule(function (module) {
	/*!
	 * jQuery JavaScript Library v3.3.1
	 * https://jquery.com/
	 *
	 * Includes Sizzle.js
	 * https://sizzlejs.com/
	 *
	 * Copyright JS Foundation and other contributors
	 * Released under the MIT license
	 * https://jquery.org/license
	 *
	 * Date: 2018-01-20T17:24Z
	 */
	( function( global, factory ) {

		{

			// For CommonJS and CommonJS-like environments where a proper `window`
			// is present, execute the factory and get jQuery.
			// For environments that do not have a `window` with a `document`
			// (such as Node.js), expose a factory as module.exports.
			// This accentuates the need for the creation of a real `window`.
			// e.g. var jQuery = require("jquery")(window);
			// See ticket #14549 for more info.
			module.exports = global.document ?
				factory( global, true ) :
				function( w ) {
					if ( !w.document ) {
						throw new Error( "jQuery requires a window with a document" );
					}
					return factory( w );
				};
		}

	// Pass this if window is not defined yet
	} )( typeof window !== "undefined" ? window : commonjsGlobal, function( window, noGlobal ) {

	var arr = [];

	var document = window.document;

	var getProto = Object.getPrototypeOf;

	var slice = arr.slice;

	var concat = arr.concat;

	var push = arr.push;

	var indexOf = arr.indexOf;

	var class2type = {};

	var toString = class2type.toString;

	var hasOwn = class2type.hasOwnProperty;

	var fnToString = hasOwn.toString;

	var ObjectFunctionString = fnToString.call( Object );

	var support = {};

	var isFunction = function isFunction( obj ) {

	      // Support: Chrome <=57, Firefox <=52
	      // In some browsers, typeof returns "function" for HTML <object> elements
	      // (i.e., `typeof document.createElement( "object" ) === "function"`).
	      // We don't want to classify *any* DOM node as a function.
	      return typeof obj === "function" && typeof obj.nodeType !== "number";
	  };


	var isWindow = function isWindow( obj ) {
			return obj != null && obj === obj.window;
		};




		var preservedScriptAttributes = {
			type: true,
			src: true,
			noModule: true
		};

		function DOMEval( code, doc, node ) {
			doc = doc || document;

			var i,
				script = doc.createElement( "script" );

			script.text = code;
			if ( node ) {
				for ( i in preservedScriptAttributes ) {
					if ( node[ i ] ) {
						script[ i ] = node[ i ];
					}
				}
			}
			doc.head.appendChild( script ).parentNode.removeChild( script );
		}


	function toType( obj ) {
		if ( obj == null ) {
			return obj + "";
		}

		// Support: Android <=2.3 only (functionish RegExp)
		return typeof obj === "object" || typeof obj === "function" ?
			class2type[ toString.call( obj ) ] || "object" :
			typeof obj;
	}
	/* global Symbol */
	// Defining this global in .eslintrc.json would create a danger of using the global
	// unguarded in another place, it seems safer to define global only for this module



	var
		version = "3.3.1",

		// Define a local copy of jQuery
		jQuery = function( selector, context ) {

			// The jQuery object is actually just the init constructor 'enhanced'
			// Need init if jQuery is called (just allow error to be thrown if not included)
			return new jQuery.fn.init( selector, context );
		},

		// Support: Android <=4.0 only
		// Make sure we trim BOM and NBSP
		rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;

	jQuery.fn = jQuery.prototype = {

		// The current version of jQuery being used
		jquery: version,

		constructor: jQuery,

		// The default length of a jQuery object is 0
		length: 0,

		toArray: function() {
			return slice.call( this );
		},

		// Get the Nth element in the matched element set OR
		// Get the whole matched element set as a clean array
		get: function( num ) {

			// Return all the elements in a clean array
			if ( num == null ) {
				return slice.call( this );
			}

			// Return just the one element from the set
			return num < 0 ? this[ num + this.length ] : this[ num ];
		},

		// Take an array of elements and push it onto the stack
		// (returning the new matched element set)
		pushStack: function( elems ) {

			// Build a new jQuery matched element set
			var ret = jQuery.merge( this.constructor(), elems );

			// Add the old object onto the stack (as a reference)
			ret.prevObject = this;

			// Return the newly-formed element set
			return ret;
		},

		// Execute a callback for every element in the matched set.
		each: function( callback ) {
			return jQuery.each( this, callback );
		},

		map: function( callback ) {
			return this.pushStack( jQuery.map( this, function( elem, i ) {
				return callback.call( elem, i, elem );
			} ) );
		},

		slice: function() {
			return this.pushStack( slice.apply( this, arguments ) );
		},

		first: function() {
			return this.eq( 0 );
		},

		last: function() {
			return this.eq( -1 );
		},

		eq: function( i ) {
			var len = this.length,
				j = +i + ( i < 0 ? len : 0 );
			return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
		},

		end: function() {
			return this.prevObject || this.constructor();
		},

		// For internal use only.
		// Behaves like an Array's method, not like a jQuery method.
		push: push,
		sort: arr.sort,
		splice: arr.splice
	};

	jQuery.extend = jQuery.fn.extend = function() {
		var arguments$1 = arguments;

		var options, name, src, copy, copyIsArray, clone,
			target = arguments[ 0 ] || {},
			i = 1,
			length = arguments.length,
			deep = false;

		// Handle a deep copy situation
		if ( typeof target === "boolean" ) {
			deep = target;

			// Skip the boolean and the target
			target = arguments[ i ] || {};
			i++;
		}

		// Handle case when target is a string or something (possible in deep copy)
		if ( typeof target !== "object" && !isFunction( target ) ) {
			target = {};
		}

		// Extend jQuery itself if only one argument is passed
		if ( i === length ) {
			target = this;
			i--;
		}

		for ( ; i < length; i++ ) {

			// Only deal with non-null/undefined values
			if ( ( options = arguments$1[ i ] ) != null ) {

				// Extend the base object
				for ( name in options ) {
					src = target[ name ];
					copy = options[ name ];

					// Prevent never-ending loop
					if ( target === copy ) {
						continue;
					}

					// Recurse if we're merging plain objects or arrays
					if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
						( copyIsArray = Array.isArray( copy ) ) ) ) {

						if ( copyIsArray ) {
							copyIsArray = false;
							clone = src && Array.isArray( src ) ? src : [];

						} else {
							clone = src && jQuery.isPlainObject( src ) ? src : {};
						}

						// Never move original objects, clone them
						target[ name ] = jQuery.extend( deep, clone, copy );

					// Don't bring in undefined values
					} else if ( copy !== undefined ) {
						target[ name ] = copy;
					}
				}
			}
		}

		// Return the modified object
		return target;
	};

	jQuery.extend( {

		// Unique for each copy of jQuery on the page
		expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),

		// Assume jQuery is ready without the ready module
		isReady: true,

		error: function( msg ) {
			throw new Error( msg );
		},

		noop: function() {},

		isPlainObject: function( obj ) {
			var proto, Ctor;

			// Detect obvious negatives
			// Use toString instead of jQuery.type to catch host objects
			if ( !obj || toString.call( obj ) !== "[object Object]" ) {
				return false;
			}

			proto = getProto( obj );

			// Objects with no prototype (e.g., `Object.create( null )`) are plain
			if ( !proto ) {
				return true;
			}

			// Objects with prototype are plain iff they were constructed by a global Object function
			Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
			return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
		},

		isEmptyObject: function( obj ) {

			/* eslint-disable no-unused-vars */
			// See https://github.com/eslint/eslint/issues/6125
			var name;

			for ( name in obj ) {
				return false;
			}
			return true;
		},

		// Evaluates a script in a global context
		globalEval: function( code ) {
			DOMEval( code );
		},

		each: function( obj, callback ) {
			var length, i = 0;

			if ( isArrayLike( obj ) ) {
				length = obj.length;
				for ( ; i < length; i++ ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			} else {
				for ( i in obj ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			}

			return obj;
		},

		// Support: Android <=4.0 only
		trim: function( text ) {
			return text == null ?
				"" :
				( text + "" ).replace( rtrim, "" );
		},

		// results is for internal usage only
		makeArray: function( arr, results ) {
			var ret = results || [];

			if ( arr != null ) {
				if ( isArrayLike( Object( arr ) ) ) {
					jQuery.merge( ret,
						typeof arr === "string" ?
						[ arr ] : arr
					);
				} else {
					push.call( ret, arr );
				}
			}

			return ret;
		},

		inArray: function( elem, arr, i ) {
			return arr == null ? -1 : indexOf.call( arr, elem, i );
		},

		// Support: Android <=4.0 only, PhantomJS 1 only
		// push.apply(_, arraylike) throws on ancient WebKit
		merge: function( first, second ) {
			var len = +second.length,
				j = 0,
				i = first.length;

			for ( ; j < len; j++ ) {
				first[ i++ ] = second[ j ];
			}

			first.length = i;

			return first;
		},

		grep: function( elems, callback, invert ) {
			var callbackInverse,
				matches = [],
				i = 0,
				length = elems.length,
				callbackExpect = !invert;

			// Go through the array, only saving the items
			// that pass the validator function
			for ( ; i < length; i++ ) {
				callbackInverse = !callback( elems[ i ], i );
				if ( callbackInverse !== callbackExpect ) {
					matches.push( elems[ i ] );
				}
			}

			return matches;
		},

		// arg is for internal usage only
		map: function( elems, callback, arg ) {
			var length, value,
				i = 0,
				ret = [];

			// Go through the array, translating each of the items to their new values
			if ( isArrayLike( elems ) ) {
				length = elems.length;
				for ( ; i < length; i++ ) {
					value = callback( elems[ i ], i, arg );

					if ( value != null ) {
						ret.push( value );
					}
				}

			// Go through every key on the object,
			} else {
				for ( i in elems ) {
					value = callback( elems[ i ], i, arg );

					if ( value != null ) {
						ret.push( value );
					}
				}
			}

			// Flatten any nested arrays
			return concat.apply( [], ret );
		},

		// A global GUID counter for objects
		guid: 1,

		// jQuery.support is not used in Core but other projects attach their
		// properties to it so it needs to exist.
		support: support
	} );

	if ( typeof Symbol === "function" ) {
		jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
	}

	// Populate the class2type map
	jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
	function( i, name ) {
		class2type[ "[object " + name + "]" ] = name.toLowerCase();
	} );

	function isArrayLike( obj ) {

		// Support: real iOS 8.2 only (not reproducible in simulator)
		// `in` check used to prevent JIT error (gh-2145)
		// hasOwn isn't used here due to false negatives
		// regarding Nodelist length in IE
		var length = !!obj && "length" in obj && obj.length,
			type = toType( obj );

		if ( isFunction( obj ) || isWindow( obj ) ) {
			return false;
		}

		return type === "array" || length === 0 ||
			typeof length === "number" && length > 0 && ( length - 1 ) in obj;
	}
	var Sizzle =
	/*!
	 * Sizzle CSS Selector Engine v2.3.3
	 * https://sizzlejs.com/
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license
	 * http://jquery.org/license
	 *
	 * Date: 2016-08-08
	 */
	(function( window ) {

	var i,
		support,
		Expr,
		getText,
		isXML,
		tokenize,
		compile,
		select,
		outermostContext,
		sortInput,
		hasDuplicate,

		// Local document vars
		setDocument,
		document,
		docElem,
		documentIsHTML,
		rbuggyQSA,
		rbuggyMatches,
		matches,
		contains,

		// Instance-specific data
		expando = "sizzle" + 1 * new Date(),
		preferredDoc = window.document,
		dirruns = 0,
		done = 0,
		classCache = createCache(),
		tokenCache = createCache(),
		compilerCache = createCache(),
		sortOrder = function( a, b ) {
			if ( a === b ) {
				hasDuplicate = true;
			}
			return 0;
		},

		// Instance methods
		hasOwn = ({}).hasOwnProperty,
		arr = [],
		pop = arr.pop,
		push_native = arr.push,
		push = arr.push,
		slice = arr.slice,
		// Use a stripped-down indexOf as it's faster than native
		// https://jsperf.com/thor-indexof-vs-for/5
		indexOf = function( list, elem ) {
			var i = 0,
				len = list.length;
			for ( ; i < len; i++ ) {
				if ( list[i] === elem ) {
					return i;
				}
			}
			return -1;
		},

		booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",

		// Regular expressions

		// http://www.w3.org/TR/css3-selectors/#whitespace
		whitespace = "[\\x20\\t\\r\\n\\f]",

		// http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
		identifier = "(?:\\\\.|[\\w-]|[^\0-\\xa0])+",

		// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
		attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
			// Operator (capture 2)
			"*([*^$|!~]?=)" + whitespace +
			// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
			"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace +
			"*\\]",

		pseudos = ":(" + identifier + ")(?:\\((" +
			// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
			// 1. quoted (capture 3; capture 4 or capture 5)
			"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
			// 2. simple (capture 6)
			"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
			// 3. anything else (capture 2)
			".*" +
			")\\)|)",

		// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
		rwhitespace = new RegExp( whitespace + "+", "g" ),
		rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g" ),

		rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
		rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*" ),

		rattributeQuotes = new RegExp( "=" + whitespace + "*([^\\]'\"]*?)" + whitespace + "*\\]", "g" ),

		rpseudo = new RegExp( pseudos ),
		ridentifier = new RegExp( "^" + identifier + "$" ),

		matchExpr = {
			"ID": new RegExp( "^#(" + identifier + ")" ),
			"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
			"TAG": new RegExp( "^(" + identifier + "|[*])" ),
			"ATTR": new RegExp( "^" + attributes ),
			"PSEUDO": new RegExp( "^" + pseudos ),
			"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace +
				"*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace +
				"*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
			"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
			// For use in libraries implementing .is()
			// We use this for POS matching in `select`
			"needsContext": new RegExp( "^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
				whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
		},

		rinputs = /^(?:input|select|textarea|button)$/i,
		rheader = /^h\d$/i,

		rnative = /^[^{]+\{\s*\[native \w/,

		// Easily-parseable/retrievable ID or TAG or CLASS selectors
		rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,

		rsibling = /[+~]/,

		// CSS escapes
		// http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
		runescape = new RegExp( "\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig" ),
		funescape = function( _, escaped, escapedWhitespace ) {
			var high = "0x" + escaped - 0x10000;
			// NaN means non-codepoint
			// Support: Firefox<24
			// Workaround erroneous numeric interpretation of +"0x"
			return high !== high || escapedWhitespace ?
				escaped :
				high < 0 ?
					// BMP codepoint
					String.fromCharCode( high + 0x10000 ) :
					// Supplemental Plane codepoint (surrogate pair)
					String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
		},

		// CSS string/identifier serialization
		// https://drafts.csswg.org/cssom/#common-serializing-idioms
		rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
		fcssescape = function( ch, asCodePoint ) {
			if ( asCodePoint ) {

				// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
				if ( ch === "\0" ) {
					return "\uFFFD";
				}

				// Control characters and (dependent upon position) numbers get escaped as code points
				return ch.slice( 0, -1 ) + "\\" + ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
			}

			// Other potentially-special ASCII characters get backslash-escaped
			return "\\" + ch;
		},

		// Used for iframes
		// See setDocument()
		// Removing the function wrapper causes a "Permission Denied"
		// error in IE
		unloadHandler = function() {
			setDocument();
		},

		disabledAncestor = addCombinator(
			function( elem ) {
				return elem.disabled === true && ("form" in elem || "label" in elem);
			},
			{ dir: "parentNode", next: "legend" }
		);

	// Optimize for push.apply( _, NodeList )
	try {
		push.apply(
			(arr = slice.call( preferredDoc.childNodes )),
			preferredDoc.childNodes
		);
		// Support: Android<4.0
		// Detect silently failing push.apply
		arr[ preferredDoc.childNodes.length ].nodeType;
	} catch ( e ) {
		push = { apply: arr.length ?

			// Leverage slice if possible
			function( target, els ) {
				push_native.apply( target, slice.call(els) );
			} :

			// Support: IE<9
			// Otherwise append directly
			function( target, els ) {
				var j = target.length,
					i = 0;
				// Can't trust NodeList.length
				while ( (target[j++] = els[i++]) ) {}
				target.length = j - 1;
			}
		};
	}

	function Sizzle( selector, context, results, seed ) {
		var m, i, elem, nid, match, groups, newSelector,
			newContext = context && context.ownerDocument,

			// nodeType defaults to 9, since context defaults to document
			nodeType = context ? context.nodeType : 9;

		results = results || [];

		// Return early from calls with invalid selector or context
		if ( typeof selector !== "string" || !selector ||
			nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {

			return results;
		}

		// Try to shortcut find operations (as opposed to filters) in HTML documents
		if ( !seed ) {

			if ( ( context ? context.ownerDocument || context : preferredDoc ) !== document ) {
				setDocument( context );
			}
			context = context || document;

			if ( documentIsHTML ) {

				// If the selector is sufficiently simple, try using a "get*By*" DOM method
				// (excepting DocumentFragment context, where the methods don't exist)
				if ( nodeType !== 11 && (match = rquickExpr.exec( selector )) ) {

					// ID selector
					if ( (m = match[1]) ) {

						// Document context
						if ( nodeType === 9 ) {
							if ( (elem = context.getElementById( m )) ) {

								// Support: IE, Opera, Webkit
								// TODO: identify versions
								// getElementById can match elements by name instead of ID
								if ( elem.id === m ) {
									results.push( elem );
									return results;
								}
							} else {
								return results;
							}

						// Element context
						} else {

							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( newContext && (elem = newContext.getElementById( m )) &&
								contains( context, elem ) &&
								elem.id === m ) {

								results.push( elem );
								return results;
							}
						}

					// Type selector
					} else if ( match[2] ) {
						push.apply( results, context.getElementsByTagName( selector ) );
						return results;

					// Class selector
					} else if ( (m = match[3]) && support.getElementsByClassName &&
						context.getElementsByClassName ) {

						push.apply( results, context.getElementsByClassName( m ) );
						return results;
					}
				}

				// Take advantage of querySelectorAll
				if ( support.qsa &&
					!compilerCache[ selector + " " ] &&
					(!rbuggyQSA || !rbuggyQSA.test( selector )) ) {

					if ( nodeType !== 1 ) {
						newContext = context;
						newSelector = selector;

					// qSA looks outside Element context, which is not what we want
					// Thanks to Andrew Dupont for this workaround technique
					// Support: IE <=8
					// Exclude object elements
					} else if ( context.nodeName.toLowerCase() !== "object" ) {

						// Capture the context ID, setting it first if necessary
						if ( (nid = context.getAttribute( "id" )) ) {
							nid = nid.replace( rcssescape, fcssescape );
						} else {
							context.setAttribute( "id", (nid = expando) );
						}

						// Prefix every selector in the list
						groups = tokenize( selector );
						i = groups.length;
						while ( i-- ) {
							groups[i] = "#" + nid + " " + toSelector( groups[i] );
						}
						newSelector = groups.join( "," );

						// Expand context for sibling selectors
						newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
							context;
					}

					if ( newSelector ) {
						try {
							push.apply( results,
								newContext.querySelectorAll( newSelector )
							);
							return results;
						} catch ( qsaError ) {
						} finally {
							if ( nid === expando ) {
								context.removeAttribute( "id" );
							}
						}
					}
				}
			}
		}

		// All others
		return select( selector.replace( rtrim, "$1" ), context, results, seed );
	}

	/**
	 * Create key-value caches of limited size
	 * @returns {function(string, object)} Returns the Object data after storing it on itself with
	 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
	 *	deleting the oldest entry
	 */
	function createCache() {
		var keys = [];

		function cache( key, value ) {
			// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
			if ( keys.push( key + " " ) > Expr.cacheLength ) {
				// Only keep the most recent entries
				delete cache[ keys.shift() ];
			}
			return (cache[ key + " " ] = value);
		}
		return cache;
	}

	/**
	 * Mark a function for special use by Sizzle
	 * @param {Function} fn The function to mark
	 */
	function markFunction( fn ) {
		fn[ expando ] = true;
		return fn;
	}

	/**
	 * Support testing using an element
	 * @param {Function} fn Passed the created element and returns a boolean result
	 */
	function assert( fn ) {
		var el = document.createElement("fieldset");

		try {
			return !!fn( el );
		} catch (e) {
			return false;
		} finally {
			// Remove from its parent by default
			if ( el.parentNode ) {
				el.parentNode.removeChild( el );
			}
			// release memory in IE
			el = null;
		}
	}

	/**
	 * Adds the same handler for all of the specified attrs
	 * @param {String} attrs Pipe-separated list of attributes
	 * @param {Function} handler The method that will be applied
	 */
	function addHandle( attrs, handler ) {
		var arr = attrs.split("|"),
			i = arr.length;

		while ( i-- ) {
			Expr.attrHandle[ arr[i] ] = handler;
		}
	}

	/**
	 * Checks document order of two siblings
	 * @param {Element} a
	 * @param {Element} b
	 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
	 */
	function siblingCheck( a, b ) {
		var cur = b && a,
			diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
				a.sourceIndex - b.sourceIndex;

		// Use IE sourceIndex if available on both nodes
		if ( diff ) {
			return diff;
		}

		// Check if b follows a
		if ( cur ) {
			while ( (cur = cur.nextSibling) ) {
				if ( cur === b ) {
					return -1;
				}
			}
		}

		return a ? 1 : -1;
	}

	/**
	 * Returns a function to use in pseudos for input types
	 * @param {String} type
	 */
	function createInputPseudo( type ) {
		return function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === type;
		};
	}

	/**
	 * Returns a function to use in pseudos for buttons
	 * @param {String} type
	 */
	function createButtonPseudo( type ) {
		return function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return (name === "input" || name === "button") && elem.type === type;
		};
	}

	/**
	 * Returns a function to use in pseudos for :enabled/:disabled
	 * @param {Boolean} disabled true for :disabled; false for :enabled
	 */
	function createDisabledPseudo( disabled ) {

		// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
		return function( elem ) {

			// Only certain elements can match :enabled or :disabled
			// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
			// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
			if ( "form" in elem ) {

				// Check for inherited disabledness on relevant non-disabled elements:
				// * listed form-associated elements in a disabled fieldset
				//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
				//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
				// * option elements in a disabled optgroup
				//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
				// All such elements have a "form" property.
				if ( elem.parentNode && elem.disabled === false ) {

					// Option elements defer to a parent optgroup if present
					if ( "label" in elem ) {
						if ( "label" in elem.parentNode ) {
							return elem.parentNode.disabled === disabled;
						} else {
							return elem.disabled === disabled;
						}
					}

					// Support: IE 6 - 11
					// Use the isDisabled shortcut property to check for disabled fieldset ancestors
					return elem.isDisabled === disabled ||

						// Where there is no isDisabled, check manually
						/* jshint -W018 */
						elem.isDisabled !== !disabled &&
							disabledAncestor( elem ) === disabled;
				}

				return elem.disabled === disabled;

			// Try to winnow out elements that can't be disabled before trusting the disabled property.
			// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
			// even exist on them, let alone have a boolean value.
			} else if ( "label" in elem ) {
				return elem.disabled === disabled;
			}

			// Remaining elements are neither :enabled nor :disabled
			return false;
		};
	}

	/**
	 * Returns a function to use in pseudos for positionals
	 * @param {Function} fn
	 */
	function createPositionalPseudo( fn ) {
		return markFunction(function( argument ) {
			argument = +argument;
			return markFunction(function( seed, matches ) {
				var j,
					matchIndexes = fn( [], seed.length, argument ),
					i = matchIndexes.length;

				// Match elements found at the specified indexes
				while ( i-- ) {
					if ( seed[ (j = matchIndexes[i]) ] ) {
						seed[j] = !(matches[j] = seed[j]);
					}
				}
			});
		});
	}

	/**
	 * Checks a node for validity as a Sizzle context
	 * @param {Element|Object=} context
	 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
	 */
	function testContext( context ) {
		return context && typeof context.getElementsByTagName !== "undefined" && context;
	}

	// Expose support vars for convenience
	support = Sizzle.support = {};

	/**
	 * Detects XML nodes
	 * @param {Element|Object} elem An element or a document
	 * @returns {Boolean} True iff elem is a non-HTML XML node
	 */
	isXML = Sizzle.isXML = function( elem ) {
		// documentElement is verified for cases where it doesn't yet exist
		// (such as loading iframes in IE - #4833)
		var documentElement = elem && (elem.ownerDocument || elem).documentElement;
		return documentElement ? documentElement.nodeName !== "HTML" : false;
	};

	/**
	 * Sets document-related variables once based on the current document
	 * @param {Element|Object} [doc] An element or document object to use to set the document
	 * @returns {Object} Returns the current document
	 */
	setDocument = Sizzle.setDocument = function( node ) {
		var hasCompare, subWindow,
			doc = node ? node.ownerDocument || node : preferredDoc;

		// Return early if doc is invalid or already selected
		if ( doc === document || doc.nodeType !== 9 || !doc.documentElement ) {
			return document;
		}

		// Update global variables
		document = doc;
		docElem = document.documentElement;
		documentIsHTML = !isXML( document );

		// Support: IE 9-11, Edge
		// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
		if ( preferredDoc !== document &&
			(subWindow = document.defaultView) && subWindow.top !== subWindow ) {

			// Support: IE 11, Edge
			if ( subWindow.addEventListener ) {
				subWindow.addEventListener( "unload", unloadHandler, false );

			// Support: IE 9 - 10 only
			} else if ( subWindow.attachEvent ) {
				subWindow.attachEvent( "onunload", unloadHandler );
			}
		}

		/* Attributes
		---------------------------------------------------------------------- */

		// Support: IE<8
		// Verify that getAttribute really returns attributes and not properties
		// (excepting IE8 booleans)
		support.attributes = assert(function( el ) {
			el.className = "i";
			return !el.getAttribute("className");
		});

		/* getElement(s)By*
		---------------------------------------------------------------------- */

		// Check if getElementsByTagName("*") returns only elements
		support.getElementsByTagName = assert(function( el ) {
			el.appendChild( document.createComment("") );
			return !el.getElementsByTagName("*").length;
		});

		// Support: IE<9
		support.getElementsByClassName = rnative.test( document.getElementsByClassName );

		// Support: IE<10
		// Check if getElementById returns elements by name
		// The broken getElementById methods don't pick up programmatically-set names,
		// so use a roundabout getElementsByName test
		support.getById = assert(function( el ) {
			docElem.appendChild( el ).id = expando;
			return !document.getElementsByName || !document.getElementsByName( expando ).length;
		});

		// ID filter and find
		if ( support.getById ) {
			Expr.filter["ID"] = function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					return elem.getAttribute("id") === attrId;
				};
			};
			Expr.find["ID"] = function( id, context ) {
				if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
					var elem = context.getElementById( id );
					return elem ? [ elem ] : [];
				}
			};
		} else {
			Expr.filter["ID"] =  function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					var node = typeof elem.getAttributeNode !== "undefined" &&
						elem.getAttributeNode("id");
					return node && node.value === attrId;
				};
			};

			// Support: IE 6 - 7 only
			// getElementById is not reliable as a find shortcut
			Expr.find["ID"] = function( id, context ) {
				if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
					var node, i, elems,
						elem = context.getElementById( id );

					if ( elem ) {

						// Verify the id attribute
						node = elem.getAttributeNode("id");
						if ( node && node.value === id ) {
							return [ elem ];
						}

						// Fall back on getElementsByName
						elems = context.getElementsByName( id );
						i = 0;
						while ( (elem = elems[i++]) ) {
							node = elem.getAttributeNode("id");
							if ( node && node.value === id ) {
								return [ elem ];
							}
						}
					}

					return [];
				}
			};
		}

		// Tag
		Expr.find["TAG"] = support.getElementsByTagName ?
			function( tag, context ) {
				if ( typeof context.getElementsByTagName !== "undefined" ) {
					return context.getElementsByTagName( tag );

				// DocumentFragment nodes don't have gEBTN
				} else if ( support.qsa ) {
					return context.querySelectorAll( tag );
				}
			} :

			function( tag, context ) {
				var elem,
					tmp = [],
					i = 0,
					// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
					results = context.getElementsByTagName( tag );

				// Filter out possible comments
				if ( tag === "*" ) {
					while ( (elem = results[i++]) ) {
						if ( elem.nodeType === 1 ) {
							tmp.push( elem );
						}
					}

					return tmp;
				}
				return results;
			};

		// Class
		Expr.find["CLASS"] = support.getElementsByClassName && function( className, context ) {
			if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
				return context.getElementsByClassName( className );
			}
		};

		/* QSA/matchesSelector
		---------------------------------------------------------------------- */

		// QSA and matchesSelector support

		// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
		rbuggyMatches = [];

		// qSa(:focus) reports false when true (Chrome 21)
		// We allow this because of a bug in IE8/9 that throws an error
		// whenever `document.activeElement` is accessed on an iframe
		// So, we allow :focus to pass through QSA all the time to avoid the IE error
		// See https://bugs.jquery.com/ticket/13378
		rbuggyQSA = [];

		if ( (support.qsa = rnative.test( document.querySelectorAll )) ) {
			// Build QSA regex
			// Regex strategy adopted from Diego Perini
			assert(function( el ) {
				// Select is set to empty string on purpose
				// This is to test IE's treatment of not explicitly
				// setting a boolean content attribute,
				// since its presence should be enough
				// https://bugs.jquery.com/ticket/12359
				docElem.appendChild( el ).innerHTML = "<a id='" + expando + "'></a>" +
					"<select id='" + expando + "-\r\\' msallowcapture=''>" +
					"<option selected=''></option></select>";

				// Support: IE8, Opera 11-12.16
				// Nothing should be selected when empty strings follow ^= or $= or *=
				// The test attribute must be unknown in Opera but "safe" for WinRT
				// https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
				if ( el.querySelectorAll("[msallowcapture^='']").length ) {
					rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
				}

				// Support: IE8
				// Boolean attributes and "value" are not treated correctly
				if ( !el.querySelectorAll("[selected]").length ) {
					rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
				}

				// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
				if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
					rbuggyQSA.push("~=");
				}

				// Webkit/Opera - :checked should return selected option elements
				// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				// IE8 throws error here and will not see later tests
				if ( !el.querySelectorAll(":checked").length ) {
					rbuggyQSA.push(":checked");
				}

				// Support: Safari 8+, iOS 8+
				// https://bugs.webkit.org/show_bug.cgi?id=136851
				// In-page `selector#id sibling-combinator selector` fails
				if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
					rbuggyQSA.push(".#.+[+~]");
				}
			});

			assert(function( el ) {
				el.innerHTML = "<a href='' disabled='disabled'></a>" +
					"<select disabled='disabled'><option/></select>";

				// Support: Windows 8 Native Apps
				// The type and name attributes are restricted during .innerHTML assignment
				var input = document.createElement("input");
				input.setAttribute( "type", "hidden" );
				el.appendChild( input ).setAttribute( "name", "D" );

				// Support: IE8
				// Enforce case-sensitivity of name attribute
				if ( el.querySelectorAll("[name=d]").length ) {
					rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
				}

				// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
				// IE8 throws error here and will not see later tests
				if ( el.querySelectorAll(":enabled").length !== 2 ) {
					rbuggyQSA.push( ":enabled", ":disabled" );
				}

				// Support: IE9-11+
				// IE's :disabled selector does not pick up the children of disabled fieldsets
				docElem.appendChild( el ).disabled = true;
				if ( el.querySelectorAll(":disabled").length !== 2 ) {
					rbuggyQSA.push( ":enabled", ":disabled" );
				}

				// Opera 10-11 does not throw on post-comma invalid pseudos
				el.querySelectorAll("*,:x");
				rbuggyQSA.push(",.*:");
			});
		}

		if ( (support.matchesSelector = rnative.test( (matches = docElem.matches ||
			docElem.webkitMatchesSelector ||
			docElem.mozMatchesSelector ||
			docElem.oMatchesSelector ||
			docElem.msMatchesSelector) )) ) {

			assert(function( el ) {
				// Check to see if it's possible to do matchesSelector
				// on a disconnected node (IE 9)
				support.disconnectedMatch = matches.call( el, "*" );

				// This should fail with an exception
				// Gecko does not error, returns false instead
				matches.call( el, "[s!='']:x" );
				rbuggyMatches.push( "!=", pseudos );
			});
		}

		rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join("|") );
		rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join("|") );

		/* Contains
		---------------------------------------------------------------------- */
		hasCompare = rnative.test( docElem.compareDocumentPosition );

		// Element contains another
		// Purposefully self-exclusive
		// As in, an element does not contain itself
		contains = hasCompare || rnative.test( docElem.contains ) ?
			function( a, b ) {
				var adown = a.nodeType === 9 ? a.documentElement : a,
					bup = b && b.parentNode;
				return a === bup || !!( bup && bup.nodeType === 1 && (
					adown.contains ?
						adown.contains( bup ) :
						a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
				));
			} :
			function( a, b ) {
				if ( b ) {
					while ( (b = b.parentNode) ) {
						if ( b === a ) {
							return true;
						}
					}
				}
				return false;
			};

		/* Sorting
		---------------------------------------------------------------------- */

		// Document order sorting
		sortOrder = hasCompare ?
		function( a, b ) {

			// Flag for duplicate removal
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}

			// Sort on method existence if only one input has compareDocumentPosition
			var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
			if ( compare ) {
				return compare;
			}

			// Calculate position if both inputs belong to the same document
			compare = ( a.ownerDocument || a ) === ( b.ownerDocument || b ) ?
				a.compareDocumentPosition( b ) :

				// Otherwise we know they are disconnected
				1;

			// Disconnected nodes
			if ( compare & 1 ||
				(!support.sortDetached && b.compareDocumentPosition( a ) === compare) ) {

				// Choose the first element that is related to our preferred document
				if ( a === document || a.ownerDocument === preferredDoc && contains(preferredDoc, a) ) {
					return -1;
				}
				if ( b === document || b.ownerDocument === preferredDoc && contains(preferredDoc, b) ) {
					return 1;
				}

				// Maintain original order
				return sortInput ?
					( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
					0;
			}

			return compare & 4 ? -1 : 1;
		} :
		function( a, b ) {
			// Exit early if the nodes are identical
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}

			var cur,
				i = 0,
				aup = a.parentNode,
				bup = b.parentNode,
				ap = [ a ],
				bp = [ b ];

			// Parentless nodes are either documents or disconnected
			if ( !aup || !bup ) {
				return a === document ? -1 :
					b === document ? 1 :
					aup ? -1 :
					bup ? 1 :
					sortInput ?
					( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
					0;

			// If the nodes are siblings, we can do a quick check
			} else if ( aup === bup ) {
				return siblingCheck( a, b );
			}

			// Otherwise we need full lists of their ancestors for comparison
			cur = a;
			while ( (cur = cur.parentNode) ) {
				ap.unshift( cur );
			}
			cur = b;
			while ( (cur = cur.parentNode) ) {
				bp.unshift( cur );
			}

			// Walk down the tree looking for a discrepancy
			while ( ap[i] === bp[i] ) {
				i++;
			}

			return i ?
				// Do a sibling check if the nodes have a common ancestor
				siblingCheck( ap[i], bp[i] ) :

				// Otherwise nodes in our document sort first
				ap[i] === preferredDoc ? -1 :
				bp[i] === preferredDoc ? 1 :
				0;
		};

		return document;
	};

	Sizzle.matches = function( expr, elements ) {
		return Sizzle( expr, null, null, elements );
	};

	Sizzle.matchesSelector = function( elem, expr ) {
		// Set document vars if needed
		if ( ( elem.ownerDocument || elem ) !== document ) {
			setDocument( elem );
		}

		// Make sure that attribute selectors are quoted
		expr = expr.replace( rattributeQuotes, "='$1']" );

		if ( support.matchesSelector && documentIsHTML &&
			!compilerCache[ expr + " " ] &&
			( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
			( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {

			try {
				var ret = matches.call( elem, expr );

				// IE 9's matchesSelector returns false on disconnected nodes
				if ( ret || support.disconnectedMatch ||
						// As well, disconnected nodes are said to be in a document
						// fragment in IE 9
						elem.document && elem.document.nodeType !== 11 ) {
					return ret;
				}
			} catch (e) {}
		}

		return Sizzle( expr, document, null, [ elem ] ).length > 0;
	};

	Sizzle.contains = function( context, elem ) {
		// Set document vars if needed
		if ( ( context.ownerDocument || context ) !== document ) {
			setDocument( context );
		}
		return contains( context, elem );
	};

	Sizzle.attr = function( elem, name ) {
		// Set document vars if needed
		if ( ( elem.ownerDocument || elem ) !== document ) {
			setDocument( elem );
		}

		var fn = Expr.attrHandle[ name.toLowerCase() ],
			// Don't get fooled by Object.prototype properties (jQuery #13807)
			val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
				fn( elem, name, !documentIsHTML ) :
				undefined;

		return val !== undefined ?
			val :
			support.attributes || !documentIsHTML ?
				elem.getAttribute( name ) :
				(val = elem.getAttributeNode(name)) && val.specified ?
					val.value :
					null;
	};

	Sizzle.escape = function( sel ) {
		return (sel + "").replace( rcssescape, fcssescape );
	};

	Sizzle.error = function( msg ) {
		throw new Error( "Syntax error, unrecognized expression: " + msg );
	};

	/**
	 * Document sorting and removing duplicates
	 * @param {ArrayLike} results
	 */
	Sizzle.uniqueSort = function( results ) {
		var elem,
			duplicates = [],
			j = 0,
			i = 0;

		// Unless we *know* we can detect duplicates, assume their presence
		hasDuplicate = !support.detectDuplicates;
		sortInput = !support.sortStable && results.slice( 0 );
		results.sort( sortOrder );

		if ( hasDuplicate ) {
			while ( (elem = results[i++]) ) {
				if ( elem === results[ i ] ) {
					j = duplicates.push( i );
				}
			}
			while ( j-- ) {
				results.splice( duplicates[ j ], 1 );
			}
		}

		// Clear input after sorting to release objects
		// See https://github.com/jquery/sizzle/pull/225
		sortInput = null;

		return results;
	};

	/**
	 * Utility function for retrieving the text value of an array of DOM nodes
	 * @param {Array|Element} elem
	 */
	getText = Sizzle.getText = function( elem ) {
		var node,
			ret = "",
			i = 0,
			nodeType = elem.nodeType;

		if ( !nodeType ) {
			// If no nodeType, this is expected to be an array
			while ( (node = elem[i++]) ) {
				// Do not traverse comment nodes
				ret += getText( node );
			}
		} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
			// Use textContent for elements
			// innerText usage removed for consistency of new lines (jQuery #11153)
			if ( typeof elem.textContent === "string" ) {
				return elem.textContent;
			} else {
				// Traverse its children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					ret += getText( elem );
				}
			}
		} else if ( nodeType === 3 || nodeType === 4 ) {
			return elem.nodeValue;
		}
		// Do not include comment or processing instruction nodes

		return ret;
	};

	Expr = Sizzle.selectors = {

		// Can be adjusted by the user
		cacheLength: 50,

		createPseudo: markFunction,

		match: matchExpr,

		attrHandle: {},

		find: {},

		relative: {
			">": { dir: "parentNode", first: true },
			" ": { dir: "parentNode" },
			"+": { dir: "previousSibling", first: true },
			"~": { dir: "previousSibling" }
		},

		preFilter: {
			"ATTR": function( match ) {
				match[1] = match[1].replace( runescape, funescape );

				// Move the given value to match[3] whether quoted or unquoted
				match[3] = ( match[3] || match[4] || match[5] || "" ).replace( runescape, funescape );

				if ( match[2] === "~=" ) {
					match[3] = " " + match[3] + " ";
				}

				return match.slice( 0, 4 );
			},

			"CHILD": function( match ) {
				/* matches from matchExpr["CHILD"]
					1 type (only|nth|...)
					2 what (child|of-type)
					3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
					4 xn-component of xn+y argument ([+-]?\d*n|)
					5 sign of xn-component
					6 x of xn-component
					7 sign of y-component
					8 y of y-component
				*/
				match[1] = match[1].toLowerCase();

				if ( match[1].slice( 0, 3 ) === "nth" ) {
					// nth-* requires argument
					if ( !match[3] ) {
						Sizzle.error( match[0] );
					}

					// numeric x and y parameters for Expr.filter.CHILD
					// remember that false/true cast respectively to 0/1
					match[4] = +( match[4] ? match[5] + (match[6] || 1) : 2 * ( match[3] === "even" || match[3] === "odd" ) );
					match[5] = +( ( match[7] + match[8] ) || match[3] === "odd" );

				// other types prohibit arguments
				} else if ( match[3] ) {
					Sizzle.error( match[0] );
				}

				return match;
			},

			"PSEUDO": function( match ) {
				var excess,
					unquoted = !match[6] && match[2];

				if ( matchExpr["CHILD"].test( match[0] ) ) {
					return null;
				}

				// Accept quoted arguments as-is
				if ( match[3] ) {
					match[2] = match[4] || match[5] || "";

				// Strip excess characters from unquoted arguments
				} else if ( unquoted && rpseudo.test( unquoted ) &&
					// Get excess from tokenize (recursively)
					(excess = tokenize( unquoted, true )) &&
					// advance to the next closing parenthesis
					(excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length) ) {

					// excess is a negative index
					match[0] = match[0].slice( 0, excess );
					match[2] = unquoted.slice( 0, excess );
				}

				// Return only captures needed by the pseudo filter method (type and argument)
				return match.slice( 0, 3 );
			}
		},

		filter: {

			"TAG": function( nodeNameSelector ) {
				var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
				return nodeNameSelector === "*" ?
					function() { return true; } :
					function( elem ) {
						return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
					};
			},

			"CLASS": function( className ) {
				var pattern = classCache[ className + " " ];

				return pattern ||
					(pattern = new RegExp( "(^|" + whitespace + ")" + className + "(" + whitespace + "|$)" )) &&
					classCache( className, function( elem ) {
						return pattern.test( typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "" );
					});
			},

			"ATTR": function( name, operator, check ) {
				return function( elem ) {
					var result = Sizzle.attr( elem, name );

					if ( result == null ) {
						return operator === "!=";
					}
					if ( !operator ) {
						return true;
					}

					result += "";

					return operator === "=" ? result === check :
						operator === "!=" ? result !== check :
						operator === "^=" ? check && result.indexOf( check ) === 0 :
						operator === "*=" ? check && result.indexOf( check ) > -1 :
						operator === "$=" ? check && result.slice( -check.length ) === check :
						operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
						operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
						false;
				};
			},

			"CHILD": function( type, what, argument, first, last ) {
				var simple = type.slice( 0, 3 ) !== "nth",
					forward = type.slice( -4 ) !== "last",
					ofType = what === "of-type";

				return first === 1 && last === 0 ?

					// Shortcut for :nth-*(n)
					function( elem ) {
						return !!elem.parentNode;
					} :

					function( elem, context, xml ) {
						var cache, uniqueCache, outerCache, node, nodeIndex, start,
							dir = simple !== forward ? "nextSibling" : "previousSibling",
							parent = elem.parentNode,
							name = ofType && elem.nodeName.toLowerCase(),
							useCache = !xml && !ofType,
							diff = false;

						if ( parent ) {

							// :(first|last|only)-(child|of-type)
							if ( simple ) {
								while ( dir ) {
									node = elem;
									while ( (node = node[ dir ]) ) {
										if ( ofType ?
											node.nodeName.toLowerCase() === name :
											node.nodeType === 1 ) {

											return false;
										}
									}
									// Reverse direction for :only-* (if we haven't yet done so)
									start = dir = type === "only" && !start && "nextSibling";
								}
								return true;
							}

							start = [ forward ? parent.firstChild : parent.lastChild ];

							// non-xml :nth-child(...) stores cache data on `parent`
							if ( forward && useCache ) {

								// Seek `elem` from a previously-cached index

								// ...in a gzip-friendly way
								node = parent;
								outerCache = node[ expando ] || (node[ expando ] = {});

								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									(outerCache[ node.uniqueID ] = {});

								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex && cache[ 2 ];
								node = nodeIndex && parent.childNodes[ nodeIndex ];

								while ( (node = ++nodeIndex && node && node[ dir ] ||

									// Fallback to seeking `elem` from the start
									(diff = nodeIndex = 0) || start.pop()) ) {

									// When found, cache indexes on `parent` and break
									if ( node.nodeType === 1 && ++diff && node === elem ) {
										uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
										break;
									}
								}

							} else {
								// Use previously-cached element index if available
								if ( useCache ) {
									// ...in a gzip-friendly way
									node = elem;
									outerCache = node[ expando ] || (node[ expando ] = {});

									// Support: IE <9 only
									// Defend against cloned attroperties (jQuery gh-1709)
									uniqueCache = outerCache[ node.uniqueID ] ||
										(outerCache[ node.uniqueID ] = {});

									cache = uniqueCache[ type ] || [];
									nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
									diff = nodeIndex;
								}

								// xml :nth-child(...)
								// or :nth-last-child(...) or :nth(-last)?-of-type(...)
								if ( diff === false ) {
									// Use the same loop as above to seek `elem` from the start
									while ( (node = ++nodeIndex && node && node[ dir ] ||
										(diff = nodeIndex = 0) || start.pop()) ) {

										if ( ( ofType ?
											node.nodeName.toLowerCase() === name :
											node.nodeType === 1 ) &&
											++diff ) {

											// Cache the index of each encountered element
											if ( useCache ) {
												outerCache = node[ expando ] || (node[ expando ] = {});

												// Support: IE <9 only
												// Defend against cloned attroperties (jQuery gh-1709)
												uniqueCache = outerCache[ node.uniqueID ] ||
													(outerCache[ node.uniqueID ] = {});

												uniqueCache[ type ] = [ dirruns, diff ];
											}

											if ( node === elem ) {
												break;
											}
										}
									}
								}
							}

							// Incorporate the offset, then check against cycle size
							diff -= last;
							return diff === first || ( diff % first === 0 && diff / first >= 0 );
						}
					};
			},

			"PSEUDO": function( pseudo, argument ) {
				// pseudo-class names are case-insensitive
				// http://www.w3.org/TR/selectors/#pseudo-classes
				// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
				// Remember that setFilters inherits from pseudos
				var args,
					fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
						Sizzle.error( "unsupported pseudo: " + pseudo );

				// The user may use createPseudo to indicate that
				// arguments are needed to create the filter function
				// just as Sizzle does
				if ( fn[ expando ] ) {
					return fn( argument );
				}

				// But maintain support for old signatures
				if ( fn.length > 1 ) {
					args = [ pseudo, pseudo, "", argument ];
					return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
						markFunction(function( seed, matches ) {
							var idx,
								matched = fn( seed, argument ),
								i = matched.length;
							while ( i-- ) {
								idx = indexOf( seed, matched[i] );
								seed[ idx ] = !( matches[ idx ] = matched[i] );
							}
						}) :
						function( elem ) {
							return fn( elem, 0, args );
						};
				}

				return fn;
			}
		},

		pseudos: {
			// Potentially complex pseudos
			"not": markFunction(function( selector ) {
				// Trim the selector passed to compile
				// to avoid treating leading and trailing
				// spaces as combinators
				var input = [],
					results = [],
					matcher = compile( selector.replace( rtrim, "$1" ) );

				return matcher[ expando ] ?
					markFunction(function( seed, matches, context, xml ) {
						var elem,
							unmatched = matcher( seed, null, xml, [] ),
							i = seed.length;

						// Match elements unmatched by `matcher`
						while ( i-- ) {
							if ( (elem = unmatched[i]) ) {
								seed[i] = !(matches[i] = elem);
							}
						}
					}) :
					function( elem, context, xml ) {
						input[0] = elem;
						matcher( input, null, xml, results );
						// Don't keep the element (issue #299)
						input[0] = null;
						return !results.pop();
					};
			}),

			"has": markFunction(function( selector ) {
				return function( elem ) {
					return Sizzle( selector, elem ).length > 0;
				};
			}),

			"contains": markFunction(function( text ) {
				text = text.replace( runescape, funescape );
				return function( elem ) {
					return ( elem.textContent || elem.innerText || getText( elem ) ).indexOf( text ) > -1;
				};
			}),

			// "Whether an element is represented by a :lang() selector
			// is based solely on the element's language value
			// being equal to the identifier C,
			// or beginning with the identifier C immediately followed by "-".
			// The matching of C against the element's language value is performed case-insensitively.
			// The identifier C does not have to be a valid language name."
			// http://www.w3.org/TR/selectors/#lang-pseudo
			"lang": markFunction( function( lang ) {
				// lang value must be a valid identifier
				if ( !ridentifier.test(lang || "") ) {
					Sizzle.error( "unsupported lang: " + lang );
				}
				lang = lang.replace( runescape, funescape ).toLowerCase();
				return function( elem ) {
					var elemLang;
					do {
						if ( (elemLang = documentIsHTML ?
							elem.lang :
							elem.getAttribute("xml:lang") || elem.getAttribute("lang")) ) {

							elemLang = elemLang.toLowerCase();
							return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
						}
					} while ( (elem = elem.parentNode) && elem.nodeType === 1 );
					return false;
				};
			}),

			// Miscellaneous
			"target": function( elem ) {
				var hash = window.location && window.location.hash;
				return hash && hash.slice( 1 ) === elem.id;
			},

			"root": function( elem ) {
				return elem === docElem;
			},

			"focus": function( elem ) {
				return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
			},

			// Boolean properties
			"enabled": createDisabledPseudo( false ),
			"disabled": createDisabledPseudo( true ),

			"checked": function( elem ) {
				// In CSS3, :checked should return both checked and selected elements
				// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				var nodeName = elem.nodeName.toLowerCase();
				return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected);
			},

			"selected": function( elem ) {
				// Accessing this property makes selected-by-default
				// options in Safari work properly
				if ( elem.parentNode ) {
					elem.parentNode.selectedIndex;
				}

				return elem.selected === true;
			},

			// Contents
			"empty": function( elem ) {
				// http://www.w3.org/TR/selectors/#empty-pseudo
				// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
				//   but not by others (comment: 8; processing instruction: 7; etc.)
				// nodeType < 6 works because attributes (2) do not appear as children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					if ( elem.nodeType < 6 ) {
						return false;
					}
				}
				return true;
			},

			"parent": function( elem ) {
				return !Expr.pseudos["empty"]( elem );
			},

			// Element/input types
			"header": function( elem ) {
				return rheader.test( elem.nodeName );
			},

			"input": function( elem ) {
				return rinputs.test( elem.nodeName );
			},

			"button": function( elem ) {
				var name = elem.nodeName.toLowerCase();
				return name === "input" && elem.type === "button" || name === "button";
			},

			"text": function( elem ) {
				var attr;
				return elem.nodeName.toLowerCase() === "input" &&
					elem.type === "text" &&

					// Support: IE<8
					// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
					( (attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text" );
			},

			// Position-in-collection
			"first": createPositionalPseudo(function() {
				return [ 0 ];
			}),

			"last": createPositionalPseudo(function( matchIndexes, length ) {
				return [ length - 1 ];
			}),

			"eq": createPositionalPseudo(function( matchIndexes, length, argument ) {
				return [ argument < 0 ? argument + length : argument ];
			}),

			"even": createPositionalPseudo(function( matchIndexes, length ) {
				var i = 0;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),

			"odd": createPositionalPseudo(function( matchIndexes, length ) {
				var i = 1;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),

			"lt": createPositionalPseudo(function( matchIndexes, length, argument ) {
				var i = argument < 0 ? argument + length : argument;
				for ( ; --i >= 0; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),

			"gt": createPositionalPseudo(function( matchIndexes, length, argument ) {
				var i = argument < 0 ? argument + length : argument;
				for ( ; ++i < length; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			})
		}
	};

	Expr.pseudos["nth"] = Expr.pseudos["eq"];

	// Add button/input type pseudos
	for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
		Expr.pseudos[ i ] = createInputPseudo( i );
	}
	for ( i in { submit: true, reset: true } ) {
		Expr.pseudos[ i ] = createButtonPseudo( i );
	}

	// Easy API for creating new setFilters
	function setFilters() {}
	setFilters.prototype = Expr.filters = Expr.pseudos;
	Expr.setFilters = new setFilters();

	tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
		var matched, match, tokens, type,
			soFar, groups, preFilters,
			cached = tokenCache[ selector + " " ];

		if ( cached ) {
			return parseOnly ? 0 : cached.slice( 0 );
		}

		soFar = selector;
		groups = [];
		preFilters = Expr.preFilter;

		while ( soFar ) {

			// Comma and first run
			if ( !matched || (match = rcomma.exec( soFar )) ) {
				if ( match ) {
					// Don't consume trailing commas as valid
					soFar = soFar.slice( match[0].length ) || soFar;
				}
				groups.push( (tokens = []) );
			}

			matched = false;

			// Combinators
			if ( (match = rcombinators.exec( soFar )) ) {
				matched = match.shift();
				tokens.push({
					value: matched,
					// Cast descendant combinators to space
					type: match[0].replace( rtrim, " " )
				});
				soFar = soFar.slice( matched.length );
			}

			// Filters
			for ( type in Expr.filter ) {
				if ( (match = matchExpr[ type ].exec( soFar )) && (!preFilters[ type ] ||
					(match = preFilters[ type ]( match ))) ) {
					matched = match.shift();
					tokens.push({
						value: matched,
						type: type,
						matches: match
					});
					soFar = soFar.slice( matched.length );
				}
			}

			if ( !matched ) {
				break;
			}
		}

		// Return the length of the invalid excess
		// if we're just parsing
		// Otherwise, throw an error or return tokens
		return parseOnly ?
			soFar.length :
			soFar ?
				Sizzle.error( selector ) :
				// Cache the tokens
				tokenCache( selector, groups ).slice( 0 );
	};

	function toSelector( tokens ) {
		var i = 0,
			len = tokens.length,
			selector = "";
		for ( ; i < len; i++ ) {
			selector += tokens[i].value;
		}
		return selector;
	}

	function addCombinator( matcher, combinator, base ) {
		var dir = combinator.dir,
			skip = combinator.next,
			key = skip || dir,
			checkNonElements = base && key === "parentNode",
			doneName = done++;

		return combinator.first ?
			// Check against closest ancestor/preceding element
			function( elem, context, xml ) {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						return matcher( elem, context, xml );
					}
				}
				return false;
			} :

			// Check against all ancestor/preceding elements
			function( elem, context, xml ) {
				var oldCache, uniqueCache, outerCache,
					newCache = [ dirruns, doneName ];

				// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
				if ( xml ) {
					while ( (elem = elem[ dir ]) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							if ( matcher( elem, context, xml ) ) {
								return true;
							}
						}
					}
				} else {
					while ( (elem = elem[ dir ]) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							outerCache = elem[ expando ] || (elem[ expando ] = {});

							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ elem.uniqueID ] || (outerCache[ elem.uniqueID ] = {});

							if ( skip && skip === elem.nodeName.toLowerCase() ) {
								elem = elem[ dir ] || elem;
							} else if ( (oldCache = uniqueCache[ key ]) &&
								oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {

								// Assign to newCache so results back-propagate to previous elements
								return (newCache[ 2 ] = oldCache[ 2 ]);
							} else {
								// Reuse newcache so results back-propagate to previous elements
								uniqueCache[ key ] = newCache;

								// A match means we're done; a fail means we have to keep checking
								if ( (newCache[ 2 ] = matcher( elem, context, xml )) ) {
									return true;
								}
							}
						}
					}
				}
				return false;
			};
	}

	function elementMatcher( matchers ) {
		return matchers.length > 1 ?
			function( elem, context, xml ) {
				var i = matchers.length;
				while ( i-- ) {
					if ( !matchers[i]( elem, context, xml ) ) {
						return false;
					}
				}
				return true;
			} :
			matchers[0];
	}

	function multipleContexts( selector, contexts, results ) {
		var i = 0,
			len = contexts.length;
		for ( ; i < len; i++ ) {
			Sizzle( selector, contexts[i], results );
		}
		return results;
	}

	function condense( unmatched, map, filter, context, xml ) {
		var elem,
			newUnmatched = [],
			i = 0,
			len = unmatched.length,
			mapped = map != null;

		for ( ; i < len; i++ ) {
			if ( (elem = unmatched[i]) ) {
				if ( !filter || filter( elem, context, xml ) ) {
					newUnmatched.push( elem );
					if ( mapped ) {
						map.push( i );
					}
				}
			}
		}

		return newUnmatched;
	}

	function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
		if ( postFilter && !postFilter[ expando ] ) {
			postFilter = setMatcher( postFilter );
		}
		if ( postFinder && !postFinder[ expando ] ) {
			postFinder = setMatcher( postFinder, postSelector );
		}
		return markFunction(function( seed, results, context, xml ) {
			var temp, i, elem,
				preMap = [],
				postMap = [],
				preexisting = results.length,

				// Get initial elements from seed or context
				elems = seed || multipleContexts( selector || "*", context.nodeType ? [ context ] : context, [] ),

				// Prefilter to get matcher input, preserving a map for seed-results synchronization
				matcherIn = preFilter && ( seed || !selector ) ?
					condense( elems, preMap, preFilter, context, xml ) :
					elems,

				matcherOut = matcher ?
					// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
					postFinder || ( seed ? preFilter : preexisting || postFilter ) ?

						// ...intermediate processing is necessary
						[] :

						// ...otherwise use results directly
						results :
					matcherIn;

			// Find primary matches
			if ( matcher ) {
				matcher( matcherIn, matcherOut, context, xml );
			}

			// Apply postFilter
			if ( postFilter ) {
				temp = condense( matcherOut, postMap );
				postFilter( temp, [], context, xml );

				// Un-match failing elements by moving them back to matcherIn
				i = temp.length;
				while ( i-- ) {
					if ( (elem = temp[i]) ) {
						matcherOut[ postMap[i] ] = !(matcherIn[ postMap[i] ] = elem);
					}
				}
			}

			if ( seed ) {
				if ( postFinder || preFilter ) {
					if ( postFinder ) {
						// Get the final matcherOut by condensing this intermediate into postFinder contexts
						temp = [];
						i = matcherOut.length;
						while ( i-- ) {
							if ( (elem = matcherOut[i]) ) {
								// Restore matcherIn since elem is not yet a final match
								temp.push( (matcherIn[i] = elem) );
							}
						}
						postFinder( null, (matcherOut = []), temp, xml );
					}

					// Move matched elements from seed to results to keep them synchronized
					i = matcherOut.length;
					while ( i-- ) {
						if ( (elem = matcherOut[i]) &&
							(temp = postFinder ? indexOf( seed, elem ) : preMap[i]) > -1 ) {

							seed[temp] = !(results[temp] = elem);
						}
					}
				}

			// Add elements to results, through postFinder if defined
			} else {
				matcherOut = condense(
					matcherOut === results ?
						matcherOut.splice( preexisting, matcherOut.length ) :
						matcherOut
				);
				if ( postFinder ) {
					postFinder( null, results, matcherOut, xml );
				} else {
					push.apply( results, matcherOut );
				}
			}
		});
	}

	function matcherFromTokens( tokens ) {
		var checkContext, matcher, j,
			len = tokens.length,
			leadingRelative = Expr.relative[ tokens[0].type ],
			implicitRelative = leadingRelative || Expr.relative[" "],
			i = leadingRelative ? 1 : 0,

			// The foundational matcher ensures that elements are reachable from top-level context(s)
			matchContext = addCombinator( function( elem ) {
				return elem === checkContext;
			}, implicitRelative, true ),
			matchAnyContext = addCombinator( function( elem ) {
				return indexOf( checkContext, elem ) > -1;
			}, implicitRelative, true ),
			matchers = [ function( elem, context, xml ) {
				var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
					(checkContext = context).nodeType ?
						matchContext( elem, context, xml ) :
						matchAnyContext( elem, context, xml ) );
				// Avoid hanging onto element (issue #299)
				checkContext = null;
				return ret;
			} ];

		for ( ; i < len; i++ ) {
			if ( (matcher = Expr.relative[ tokens[i].type ]) ) {
				matchers = [ addCombinator(elementMatcher( matchers ), matcher) ];
			} else {
				matcher = Expr.filter[ tokens[i].type ].apply( null, tokens[i].matches );

				// Return special upon seeing a positional matcher
				if ( matcher[ expando ] ) {
					// Find the next relative operator (if any) for proper handling
					j = ++i;
					for ( ; j < len; j++ ) {
						if ( Expr.relative[ tokens[j].type ] ) {
							break;
						}
					}
					return setMatcher(
						i > 1 && elementMatcher( matchers ),
						i > 1 && toSelector(
							// If the preceding token was a descendant combinator, insert an implicit any-element `*`
							tokens.slice( 0, i - 1 ).concat({ value: tokens[ i - 2 ].type === " " ? "*" : "" })
						).replace( rtrim, "$1" ),
						matcher,
						i < j && matcherFromTokens( tokens.slice( i, j ) ),
						j < len && matcherFromTokens( (tokens = tokens.slice( j )) ),
						j < len && toSelector( tokens )
					);
				}
				matchers.push( matcher );
			}
		}

		return elementMatcher( matchers );
	}

	function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
		var bySet = setMatchers.length > 0,
			byElement = elementMatchers.length > 0,
			superMatcher = function( seed, context, xml, results, outermost ) {
				var elem, j, matcher,
					matchedCount = 0,
					i = "0",
					unmatched = seed && [],
					setMatched = [],
					contextBackup = outermostContext,
					// We must always have either seed elements or outermost context
					elems = seed || byElement && Expr.find["TAG"]( "*", outermost ),
					// Use integer dirruns iff this is the outermost matcher
					dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
					len = elems.length;

				if ( outermost ) {
					outermostContext = context === document || context || outermost;
				}

				// Add elements passing elementMatchers directly to results
				// Support: IE<9, Safari
				// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
				for ( ; i !== len && (elem = elems[i]) != null; i++ ) {
					if ( byElement && elem ) {
						j = 0;
						if ( !context && elem.ownerDocument !== document ) {
							setDocument( elem );
							xml = !documentIsHTML;
						}
						while ( (matcher = elementMatchers[j++]) ) {
							if ( matcher( elem, context || document, xml) ) {
								results.push( elem );
								break;
							}
						}
						if ( outermost ) {
							dirruns = dirrunsUnique;
						}
					}

					// Track unmatched elements for set filters
					if ( bySet ) {
						// They will have gone through all possible matchers
						if ( (elem = !matcher && elem) ) {
							matchedCount--;
						}

						// Lengthen the array for every element, matched or not
						if ( seed ) {
							unmatched.push( elem );
						}
					}
				}

				// `i` is now the count of elements visited above, and adding it to `matchedCount`
				// makes the latter nonnegative.
				matchedCount += i;

				// Apply set filters to unmatched elements
				// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
				// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
				// no element matchers and no seed.
				// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
				// case, which will result in a "00" `matchedCount` that differs from `i` but is also
				// numerically zero.
				if ( bySet && i !== matchedCount ) {
					j = 0;
					while ( (matcher = setMatchers[j++]) ) {
						matcher( unmatched, setMatched, context, xml );
					}

					if ( seed ) {
						// Reintegrate element matches to eliminate the need for sorting
						if ( matchedCount > 0 ) {
							while ( i-- ) {
								if ( !(unmatched[i] || setMatched[i]) ) {
									setMatched[i] = pop.call( results );
								}
							}
						}

						// Discard index placeholder values to get only actual matches
						setMatched = condense( setMatched );
					}

					// Add matches to results
					push.apply( results, setMatched );

					// Seedless set matches succeeding multiple successful matchers stipulate sorting
					if ( outermost && !seed && setMatched.length > 0 &&
						( matchedCount + setMatchers.length ) > 1 ) {

						Sizzle.uniqueSort( results );
					}
				}

				// Override manipulation of globals by nested matchers
				if ( outermost ) {
					dirruns = dirrunsUnique;
					outermostContext = contextBackup;
				}

				return unmatched;
			};

		return bySet ?
			markFunction( superMatcher ) :
			superMatcher;
	}

	compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
		var i,
			setMatchers = [],
			elementMatchers = [],
			cached = compilerCache[ selector + " " ];

		if ( !cached ) {
			// Generate a function of recursive functions that can be used to check each element
			if ( !match ) {
				match = tokenize( selector );
			}
			i = match.length;
			while ( i-- ) {
				cached = matcherFromTokens( match[i] );
				if ( cached[ expando ] ) {
					setMatchers.push( cached );
				} else {
					elementMatchers.push( cached );
				}
			}

			// Cache the compiled function
			cached = compilerCache( selector, matcherFromGroupMatchers( elementMatchers, setMatchers ) );

			// Save selector and tokenization
			cached.selector = selector;
		}
		return cached;
	};

	/**
	 * A low-level selection function that works with Sizzle's compiled
	 *  selector functions
	 * @param {String|Function} selector A selector or a pre-compiled
	 *  selector function built with Sizzle.compile
	 * @param {Element} context
	 * @param {Array} [results]
	 * @param {Array} [seed] A set of elements to match against
	 */
	select = Sizzle.select = function( selector, context, results, seed ) {
		var i, tokens, token, type, find,
			compiled = typeof selector === "function" && selector,
			match = !seed && tokenize( (selector = compiled.selector || selector) );

		results = results || [];

		// Try to minimize operations if there is only one selector in the list and no seed
		// (the latter of which guarantees us context)
		if ( match.length === 1 ) {

			// Reduce context if the leading compound selector is an ID
			tokens = match[0] = match[0].slice( 0 );
			if ( tokens.length > 2 && (token = tokens[0]).type === "ID" &&
					context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[1].type ] ) {

				context = ( Expr.find["ID"]( token.matches[0].replace(runescape, funescape), context ) || [] )[0];
				if ( !context ) {
					return results;

				// Precompiled matchers will still verify ancestry, so step up a level
				} else if ( compiled ) {
					context = context.parentNode;
				}

				selector = selector.slice( tokens.shift().value.length );
			}

			// Fetch a seed set for right-to-left matching
			i = matchExpr["needsContext"].test( selector ) ? 0 : tokens.length;
			while ( i-- ) {
				token = tokens[i];

				// Abort if we hit a combinator
				if ( Expr.relative[ (type = token.type) ] ) {
					break;
				}
				if ( (find = Expr.find[ type ]) ) {
					// Search, expanding context for leading sibling combinators
					if ( (seed = find(
						token.matches[0].replace( runescape, funescape ),
						rsibling.test( tokens[0].type ) && testContext( context.parentNode ) || context
					)) ) {

						// If seed is empty or no tokens remain, we can return early
						tokens.splice( i, 1 );
						selector = seed.length && toSelector( tokens );
						if ( !selector ) {
							push.apply( results, seed );
							return results;
						}

						break;
					}
				}
			}
		}

		// Compile and execute a filtering function if one is not provided
		// Provide `match` to avoid retokenization if we modified the selector above
		( compiled || compile( selector, match ) )(
			seed,
			context,
			!documentIsHTML,
			results,
			!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
		);
		return results;
	};

	// One-time assignments

	// Sort stability
	support.sortStable = expando.split("").sort( sortOrder ).join("") === expando;

	// Support: Chrome 14-35+
	// Always assume duplicates if they aren't passed to the comparison function
	support.detectDuplicates = !!hasDuplicate;

	// Initialize against the default document
	setDocument();

	// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
	// Detached nodes confoundingly follow *each other*
	support.sortDetached = assert(function( el ) {
		// Should return 1, but returns 4 (following)
		return el.compareDocumentPosition( document.createElement("fieldset") ) & 1;
	});

	// Support: IE<8
	// Prevent attribute/property "interpolation"
	// https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
	if ( !assert(function( el ) {
		el.innerHTML = "<a href='#'></a>";
		return el.firstChild.getAttribute("href") === "#" ;
	}) ) {
		addHandle( "type|href|height|width", function( elem, name, isXML ) {
			if ( !isXML ) {
				return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
			}
		});
	}

	// Support: IE<9
	// Use defaultValue in place of getAttribute("value")
	if ( !support.attributes || !assert(function( el ) {
		el.innerHTML = "<input/>";
		el.firstChild.setAttribute( "value", "" );
		return el.firstChild.getAttribute( "value" ) === "";
	}) ) {
		addHandle( "value", function( elem, name, isXML ) {
			if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
				return elem.defaultValue;
			}
		});
	}

	// Support: IE<9
	// Use getAttributeNode to fetch booleans when getAttribute lies
	if ( !assert(function( el ) {
		return el.getAttribute("disabled") == null;
	}) ) {
		addHandle( booleans, function( elem, name, isXML ) {
			var val;
			if ( !isXML ) {
				return elem[ name ] === true ? name.toLowerCase() :
						(val = elem.getAttributeNode( name )) && val.specified ?
						val.value :
					null;
			}
		});
	}

	return Sizzle;

	})( window );



	jQuery.find = Sizzle;
	jQuery.expr = Sizzle.selectors;

	// Deprecated
	jQuery.expr[ ":" ] = jQuery.expr.pseudos;
	jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
	jQuery.text = Sizzle.getText;
	jQuery.isXMLDoc = Sizzle.isXML;
	jQuery.contains = Sizzle.contains;
	jQuery.escapeSelector = Sizzle.escape;




	var dir = function( elem, dir, until ) {
		var matched = [],
			truncate = until !== undefined;

		while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
			if ( elem.nodeType === 1 ) {
				if ( truncate && jQuery( elem ).is( until ) ) {
					break;
				}
				matched.push( elem );
			}
		}
		return matched;
	};


	var siblings = function( n, elem ) {
		var matched = [];

		for ( ; n; n = n.nextSibling ) {
			if ( n.nodeType === 1 && n !== elem ) {
				matched.push( n );
			}
		}

		return matched;
	};


	var rneedsContext = jQuery.expr.match.needsContext;



	function nodeName( elem, name ) {

	  return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();

	}var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );



	// Implement the identical functionality for filter and not
	function winnow( elements, qualifier, not ) {
		if ( isFunction( qualifier ) ) {
			return jQuery.grep( elements, function( elem, i ) {
				return !!qualifier.call( elem, i, elem ) !== not;
			} );
		}

		// Single element
		if ( qualifier.nodeType ) {
			return jQuery.grep( elements, function( elem ) {
				return ( elem === qualifier ) !== not;
			} );
		}

		// Arraylike of elements (jQuery, arguments, Array)
		if ( typeof qualifier !== "string" ) {
			return jQuery.grep( elements, function( elem ) {
				return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
			} );
		}

		// Filtered directly for both simple and complex selectors
		return jQuery.filter( qualifier, elements, not );
	}

	jQuery.filter = function( expr, elems, not ) {
		var elem = elems[ 0 ];

		if ( not ) {
			expr = ":not(" + expr + ")";
		}

		if ( elems.length === 1 && elem.nodeType === 1 ) {
			return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
		}

		return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
			return elem.nodeType === 1;
		} ) );
	};

	jQuery.fn.extend( {
		find: function( selector ) {
			var i, ret,
				len = this.length,
				self = this;

			if ( typeof selector !== "string" ) {
				return this.pushStack( jQuery( selector ).filter( function() {
					var this$1 = this;

					for ( i = 0; i < len; i++ ) {
						if ( jQuery.contains( self[ i ], this$1 ) ) {
							return true;
						}
					}
				} ) );
			}

			ret = this.pushStack( [] );

			for ( i = 0; i < len; i++ ) {
				jQuery.find( selector, self[ i ], ret );
			}

			return len > 1 ? jQuery.uniqueSort( ret ) : ret;
		},
		filter: function( selector ) {
			return this.pushStack( winnow( this, selector || [], false ) );
		},
		not: function( selector ) {
			return this.pushStack( winnow( this, selector || [], true ) );
		},
		is: function( selector ) {
			return !!winnow(
				this,

				// If this is a positional/relative selector, check membership in the returned set
				// so $("p:first").is("p:last") won't return true for a doc with two "p".
				typeof selector === "string" && rneedsContext.test( selector ) ?
					jQuery( selector ) :
					selector || [],
				false
			).length;
		}
	} );


	// Initialize a jQuery object


	// A central reference to the root jQuery(document)
	var rootjQuery,

		// A simple way to check for HTML strings
		// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
		// Strict HTML recognition (#11290: must start with <)
		// Shortcut simple #id case for speed
		rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,

		init = jQuery.fn.init = function( selector, context, root ) {
			var this$1 = this;

			var match, elem;

			// HANDLE: $(""), $(null), $(undefined), $(false)
			if ( !selector ) {
				return this;
			}

			// Method init() accepts an alternate rootjQuery
			// so migrate can support jQuery.sub (gh-2101)
			root = root || rootjQuery;

			// Handle HTML strings
			if ( typeof selector === "string" ) {
				if ( selector[ 0 ] === "<" &&
					selector[ selector.length - 1 ] === ">" &&
					selector.length >= 3 ) {

					// Assume that strings that start and end with <> are HTML and skip the regex check
					match = [ null, selector, null ];

				} else {
					match = rquickExpr.exec( selector );
				}

				// Match html or make sure no context is specified for #id
				if ( match && ( match[ 1 ] || !context ) ) {

					// HANDLE: $(html) -> $(array)
					if ( match[ 1 ] ) {
						context = context instanceof jQuery ? context[ 0 ] : context;

						// Option to run scripts is true for back-compat
						// Intentionally let the error be thrown if parseHTML is not present
						jQuery.merge( this, jQuery.parseHTML(
							match[ 1 ],
							context && context.nodeType ? context.ownerDocument || context : document,
							true
						) );

						// HANDLE: $(html, props)
						if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
							for ( match in context ) {

								// Properties of context are called as methods if possible
								if ( isFunction( this$1[ match ] ) ) {
									this$1[ match ]( context[ match ] );

								// ...and otherwise set as attributes
								} else {
									this$1.attr( match, context[ match ] );
								}
							}
						}

						return this;

					// HANDLE: $(#id)
					} else {
						elem = document.getElementById( match[ 2 ] );

						if ( elem ) {

							// Inject the element directly into the jQuery object
							this[ 0 ] = elem;
							this.length = 1;
						}
						return this;
					}

				// HANDLE: $(expr, $(...))
				} else if ( !context || context.jquery ) {
					return ( context || root ).find( selector );

				// HANDLE: $(expr, context)
				// (which is just equivalent to: $(context).find(expr)
				} else {
					return this.constructor( context ).find( selector );
				}

			// HANDLE: $(DOMElement)
			} else if ( selector.nodeType ) {
				this[ 0 ] = selector;
				this.length = 1;
				return this;

			// HANDLE: $(function)
			// Shortcut for document ready
			} else if ( isFunction( selector ) ) {
				return root.ready !== undefined ?
					root.ready( selector ) :

					// Execute immediately if ready is not present
					selector( jQuery );
			}

			return jQuery.makeArray( selector, this );
		};

	// Give the init function the jQuery prototype for later instantiation
	init.prototype = jQuery.fn;

	// Initialize central reference
	rootjQuery = jQuery( document );


	var rparentsprev = /^(?:parents|prev(?:Until|All))/,

		// Methods guaranteed to produce a unique set when starting from a unique set
		guaranteedUnique = {
			children: true,
			contents: true,
			next: true,
			prev: true
		};

	jQuery.fn.extend( {
		has: function( target ) {
			var targets = jQuery( target, this ),
				l = targets.length;

			return this.filter( function() {
				var this$1 = this;

				var i = 0;
				for ( ; i < l; i++ ) {
					if ( jQuery.contains( this$1, targets[ i ] ) ) {
						return true;
					}
				}
			} );
		},

		closest: function( selectors, context ) {
			var cur,
				i = 0,
				l = this.length,
				matched = [],
				targets = typeof selectors !== "string" && jQuery( selectors );

			// Positional selectors never match, since there's no _selection_ context
			if ( !rneedsContext.test( selectors ) ) {
				for ( ; i < l; i++ ) {
					for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {

						// Always skip document fragments
						if ( cur.nodeType < 11 && ( targets ?
							targets.index( cur ) > -1 :

							// Don't pass non-elements to Sizzle
							cur.nodeType === 1 &&
								jQuery.find.matchesSelector( cur, selectors ) ) ) {

							matched.push( cur );
							break;
						}
					}
				}
			}

			return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
		},

		// Determine the position of an element within the set
		index: function( elem ) {

			// No argument, return index in parent
			if ( !elem ) {
				return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
			}

			// Index in selector
			if ( typeof elem === "string" ) {
				return indexOf.call( jQuery( elem ), this[ 0 ] );
			}

			// Locate the position of the desired element
			return indexOf.call( this,

				// If it receives a jQuery object, the first element is used
				elem.jquery ? elem[ 0 ] : elem
			);
		},

		add: function( selector, context ) {
			return this.pushStack(
				jQuery.uniqueSort(
					jQuery.merge( this.get(), jQuery( selector, context ) )
				)
			);
		},

		addBack: function( selector ) {
			return this.add( selector == null ?
				this.prevObject : this.prevObject.filter( selector )
			);
		}
	} );

	function sibling( cur, dir ) {
		while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
		return cur;
	}

	jQuery.each( {
		parent: function( elem ) {
			var parent = elem.parentNode;
			return parent && parent.nodeType !== 11 ? parent : null;
		},
		parents: function( elem ) {
			return dir( elem, "parentNode" );
		},
		parentsUntil: function( elem, i, until ) {
			return dir( elem, "parentNode", until );
		},
		next: function( elem ) {
			return sibling( elem, "nextSibling" );
		},
		prev: function( elem ) {
			return sibling( elem, "previousSibling" );
		},
		nextAll: function( elem ) {
			return dir( elem, "nextSibling" );
		},
		prevAll: function( elem ) {
			return dir( elem, "previousSibling" );
		},
		nextUntil: function( elem, i, until ) {
			return dir( elem, "nextSibling", until );
		},
		prevUntil: function( elem, i, until ) {
			return dir( elem, "previousSibling", until );
		},
		siblings: function( elem ) {
			return siblings( ( elem.parentNode || {} ).firstChild, elem );
		},
		children: function( elem ) {
			return siblings( elem.firstChild );
		},
		contents: function( elem ) {
	        if ( nodeName( elem, "iframe" ) ) {
	            return elem.contentDocument;
	        }

	        // Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
	        // Treat the template element as a regular one in browsers that
	        // don't support it.
	        if ( nodeName( elem, "template" ) ) {
	            elem = elem.content || elem;
	        }

	        return jQuery.merge( [], elem.childNodes );
		}
	}, function( name, fn ) {
		jQuery.fn[ name ] = function( until, selector ) {
			var matched = jQuery.map( this, fn, until );

			if ( name.slice( -5 ) !== "Until" ) {
				selector = until;
			}

			if ( selector && typeof selector === "string" ) {
				matched = jQuery.filter( selector, matched );
			}

			if ( this.length > 1 ) {

				// Remove duplicates
				if ( !guaranteedUnique[ name ] ) {
					jQuery.uniqueSort( matched );
				}

				// Reverse order for parents* and prev-derivatives
				if ( rparentsprev.test( name ) ) {
					matched.reverse();
				}
			}

			return this.pushStack( matched );
		};
	} );
	var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );



	// Convert String-formatted options into Object-formatted ones
	function createOptions( options ) {
		var object = {};
		jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
			object[ flag ] = true;
		} );
		return object;
	}

	/*
	 * Create a callback list using the following parameters:
	 *
	 *	options: an optional list of space-separated options that will change how
	 *			the callback list behaves or a more traditional option object
	 *
	 * By default a callback list will act like an event callback list and can be
	 * "fired" multiple times.
	 *
	 * Possible options:
	 *
	 *	once:			will ensure the callback list can only be fired once (like a Deferred)
	 *
	 *	memory:			will keep track of previous values and will call any callback added
	 *					after the list has been fired right away with the latest "memorized"
	 *					values (like a Deferred)
	 *
	 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
	 *
	 *	stopOnFalse:	interrupt callings when a callback returns false
	 *
	 */
	jQuery.Callbacks = function( options ) {

		// Convert options from String-formatted to Object-formatted if needed
		// (we check in cache first)
		options = typeof options === "string" ?
			createOptions( options ) :
			jQuery.extend( {}, options );

		var // Flag to know if list is currently firing
			firing,

			// Last fire value for non-forgettable lists
			memory,

			// Flag to know if list was already fired
			fired,

			// Flag to prevent firing
			locked,

			// Actual callback list
			list = [],

			// Queue of execution data for repeatable lists
			queue = [],

			// Index of currently firing callback (modified by add/remove as needed)
			firingIndex = -1,

			// Fire callbacks
			fire = function() {

				// Enforce single-firing
				locked = locked || options.once;

				// Execute callbacks for all pending executions,
				// respecting firingIndex overrides and runtime changes
				fired = firing = true;
				for ( ; queue.length; firingIndex = -1 ) {
					memory = queue.shift();
					while ( ++firingIndex < list.length ) {

						// Run callback and check for early termination
						if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
							options.stopOnFalse ) {

							// Jump to end and forget the data so .add doesn't re-fire
							firingIndex = list.length;
							memory = false;
						}
					}
				}

				// Forget the data if we're done with it
				if ( !options.memory ) {
					memory = false;
				}

				firing = false;

				// Clean up if we're done firing for good
				if ( locked ) {

					// Keep an empty list if we have data for future add calls
					if ( memory ) {
						list = [];

					// Otherwise, this object is spent
					} else {
						list = "";
					}
				}
			},

			// Actual Callbacks object
			self = {

				// Add a callback or a collection of callbacks to the list
				add: function() {
					if ( list ) {

						// If we have memory from a past run, we should fire after adding
						if ( memory && !firing ) {
							firingIndex = list.length - 1;
							queue.push( memory );
						}

						( function add( args ) {
							jQuery.each( args, function( _, arg ) {
								if ( isFunction( arg ) ) {
									if ( !options.unique || !self.has( arg ) ) {
										list.push( arg );
									}
								} else if ( arg && arg.length && toType( arg ) !== "string" ) {

									// Inspect recursively
									add( arg );
								}
							} );
						} )( arguments );

						if ( memory && !firing ) {
							fire();
						}
					}
					return this;
				},

				// Remove a callback from the list
				remove: function() {
					jQuery.each( arguments, function( _, arg ) {
						var index;
						while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
							list.splice( index, 1 );

							// Handle firing indexes
							if ( index <= firingIndex ) {
								firingIndex--;
							}
						}
					} );
					return this;
				},

				// Check if a given callback is in the list.
				// If no argument is given, return whether or not list has callbacks attached.
				has: function( fn ) {
					return fn ?
						jQuery.inArray( fn, list ) > -1 :
						list.length > 0;
				},

				// Remove all callbacks from the list
				empty: function() {
					if ( list ) {
						list = [];
					}
					return this;
				},

				// Disable .fire and .add
				// Abort any current/pending executions
				// Clear all callbacks and values
				disable: function() {
					locked = queue = [];
					list = memory = "";
					return this;
				},
				disabled: function() {
					return !list;
				},

				// Disable .fire
				// Also disable .add unless we have memory (since it would have no effect)
				// Abort any pending executions
				lock: function() {
					locked = queue = [];
					if ( !memory && !firing ) {
						list = memory = "";
					}
					return this;
				},
				locked: function() {
					return !!locked;
				},

				// Call all callbacks with the given context and arguments
				fireWith: function( context, args ) {
					if ( !locked ) {
						args = args || [];
						args = [ context, args.slice ? args.slice() : args ];
						queue.push( args );
						if ( !firing ) {
							fire();
						}
					}
					return this;
				},

				// Call all the callbacks with the given arguments
				fire: function() {
					self.fireWith( this, arguments );
					return this;
				},

				// To know if the callbacks have already been called at least once
				fired: function() {
					return !!fired;
				}
			};

		return self;
	};


	function Identity( v ) {
		return v;
	}
	function Thrower( ex ) {
		throw ex;
	}

	function adoptValue( value, resolve, reject, noValue ) {
		var method;

		try {

			// Check for promise aspect first to privilege synchronous behavior
			if ( value && isFunction( ( method = value.promise ) ) ) {
				method.call( value ).done( resolve ).fail( reject );

			// Other thenables
			} else if ( value && isFunction( ( method = value.then ) ) ) {
				method.call( value, resolve, reject );

			// Other non-thenables
			} else {

				// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
				// * false: [ value ].slice( 0 ) => resolve( value )
				// * true: [ value ].slice( 1 ) => resolve()
				resolve.apply( undefined, [ value ].slice( noValue ) );
			}

		// For Promises/A+, convert exceptions into rejections
		// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
		// Deferred#then to conditionally suppress rejection.
		} catch ( value ) {

			// Support: Android 4.0 only
			// Strict mode functions invoked without .call/.apply get global-object context
			reject.apply( undefined, [ value ] );
		}
	}

	jQuery.extend( {

		Deferred: function( func ) {
			var tuples = [

					// action, add listener, callbacks,
					// ... .then handlers, argument index, [final state]
					[ "notify", "progress", jQuery.Callbacks( "memory" ),
						jQuery.Callbacks( "memory" ), 2 ],
					[ "resolve", "done", jQuery.Callbacks( "once memory" ),
						jQuery.Callbacks( "once memory" ), 0, "resolved" ],
					[ "reject", "fail", jQuery.Callbacks( "once memory" ),
						jQuery.Callbacks( "once memory" ), 1, "rejected" ]
				],
				state = "pending",
				promise = {
					state: function() {
						return state;
					},
					always: function() {
						deferred.done( arguments ).fail( arguments );
						return this;
					},
					"catch": function( fn ) {
						return promise.then( null, fn );
					},

					// Keep pipe for back-compat
					pipe: function( /* fnDone, fnFail, fnProgress */ ) {
						var fns = arguments;

						return jQuery.Deferred( function( newDefer ) {
							jQuery.each( tuples, function( i, tuple ) {

								// Map tuples (progress, done, fail) to arguments (done, fail, progress)
								var fn = isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];

								// deferred.progress(function() { bind to newDefer or newDefer.notify })
								// deferred.done(function() { bind to newDefer or newDefer.resolve })
								// deferred.fail(function() { bind to newDefer or newDefer.reject })
								deferred[ tuple[ 1 ] ]( function() {
									var returned = fn && fn.apply( this, arguments );
									if ( returned && isFunction( returned.promise ) ) {
										returned.promise()
											.progress( newDefer.notify )
											.done( newDefer.resolve )
											.fail( newDefer.reject );
									} else {
										newDefer[ tuple[ 0 ] + "With" ](
											this,
											fn ? [ returned ] : arguments
										);
									}
								} );
							} );
							fns = null;
						} ).promise();
					},
					then: function( onFulfilled, onRejected, onProgress ) {
						var maxDepth = 0;
						function resolve( depth, deferred, handler, special ) {
							return function() {
								var that = this,
									args = arguments,
									mightThrow = function() {
										var returned, then;

										// Support: Promises/A+ section 2.3.3.3.3
										// https://promisesaplus.com/#point-59
										// Ignore double-resolution attempts
										if ( depth < maxDepth ) {
											return;
										}

										returned = handler.apply( that, args );

										// Support: Promises/A+ section 2.3.1
										// https://promisesaplus.com/#point-48
										if ( returned === deferred.promise() ) {
											throw new TypeError( "Thenable self-resolution" );
										}

										// Support: Promises/A+ sections 2.3.3.1, 3.5
										// https://promisesaplus.com/#point-54
										// https://promisesaplus.com/#point-75
										// Retrieve `then` only once
										then = returned &&

											// Support: Promises/A+ section 2.3.4
											// https://promisesaplus.com/#point-64
											// Only check objects and functions for thenability
											( typeof returned === "object" ||
												typeof returned === "function" ) &&
											returned.then;

										// Handle a returned thenable
										if ( isFunction( then ) ) {

											// Special processors (notify) just wait for resolution
											if ( special ) {
												then.call(
													returned,
													resolve( maxDepth, deferred, Identity, special ),
													resolve( maxDepth, deferred, Thrower, special )
												);

											// Normal processors (resolve) also hook into progress
											} else {

												// ...and disregard older resolution values
												maxDepth++;

												then.call(
													returned,
													resolve( maxDepth, deferred, Identity, special ),
													resolve( maxDepth, deferred, Thrower, special ),
													resolve( maxDepth, deferred, Identity,
														deferred.notifyWith )
												);
											}

										// Handle all other returned values
										} else {

											// Only substitute handlers pass on context
											// and multiple values (non-spec behavior)
											if ( handler !== Identity ) {
												that = undefined;
												args = [ returned ];
											}

											// Process the value(s)
											// Default process is resolve
											( special || deferred.resolveWith )( that, args );
										}
									},

									// Only normal processors (resolve) catch and reject exceptions
									process = special ?
										mightThrow :
										function() {
											try {
												mightThrow();
											} catch ( e ) {

												if ( jQuery.Deferred.exceptionHook ) {
													jQuery.Deferred.exceptionHook( e,
														process.stackTrace );
												}

												// Support: Promises/A+ section 2.3.3.3.4.1
												// https://promisesaplus.com/#point-61
												// Ignore post-resolution exceptions
												if ( depth + 1 >= maxDepth ) {

													// Only substitute handlers pass on context
													// and multiple values (non-spec behavior)
													if ( handler !== Thrower ) {
														that = undefined;
														args = [ e ];
													}

													deferred.rejectWith( that, args );
												}
											}
										};

								// Support: Promises/A+ section 2.3.3.3.1
								// https://promisesaplus.com/#point-57
								// Re-resolve promises immediately to dodge false rejection from
								// subsequent errors
								if ( depth ) {
									process();
								} else {

									// Call an optional hook to record the stack, in case of exception
									// since it's otherwise lost when execution goes async
									if ( jQuery.Deferred.getStackHook ) {
										process.stackTrace = jQuery.Deferred.getStackHook();
									}
									window.setTimeout( process );
								}
							};
						}

						return jQuery.Deferred( function( newDefer ) {

							// progress_handlers.add( ... )
							tuples[ 0 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									isFunction( onProgress ) ?
										onProgress :
										Identity,
									newDefer.notifyWith
								)
							);

							// fulfilled_handlers.add( ... )
							tuples[ 1 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									isFunction( onFulfilled ) ?
										onFulfilled :
										Identity
								)
							);

							// rejected_handlers.add( ... )
							tuples[ 2 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									isFunction( onRejected ) ?
										onRejected :
										Thrower
								)
							);
						} ).promise();
					},

					// Get a promise for this deferred
					// If obj is provided, the promise aspect is added to the object
					promise: function( obj ) {
						return obj != null ? jQuery.extend( obj, promise ) : promise;
					}
				},
				deferred = {};

			// Add list-specific methods
			jQuery.each( tuples, function( i, tuple ) {
				var list = tuple[ 2 ],
					stateString = tuple[ 5 ];

				// promise.progress = list.add
				// promise.done = list.add
				// promise.fail = list.add
				promise[ tuple[ 1 ] ] = list.add;

				// Handle state
				if ( stateString ) {
					list.add(
						function() {

							// state = "resolved" (i.e., fulfilled)
							// state = "rejected"
							state = stateString;
						},

						// rejected_callbacks.disable
						// fulfilled_callbacks.disable
						tuples[ 3 - i ][ 2 ].disable,

						// rejected_handlers.disable
						// fulfilled_handlers.disable
						tuples[ 3 - i ][ 3 ].disable,

						// progress_callbacks.lock
						tuples[ 0 ][ 2 ].lock,

						// progress_handlers.lock
						tuples[ 0 ][ 3 ].lock
					);
				}

				// progress_handlers.fire
				// fulfilled_handlers.fire
				// rejected_handlers.fire
				list.add( tuple[ 3 ].fire );

				// deferred.notify = function() { deferred.notifyWith(...) }
				// deferred.resolve = function() { deferred.resolveWith(...) }
				// deferred.reject = function() { deferred.rejectWith(...) }
				deferred[ tuple[ 0 ] ] = function() {
					deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
					return this;
				};

				// deferred.notifyWith = list.fireWith
				// deferred.resolveWith = list.fireWith
				// deferred.rejectWith = list.fireWith
				deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
			} );

			// Make the deferred a promise
			promise.promise( deferred );

			// Call given func if any
			if ( func ) {
				func.call( deferred, deferred );
			}

			// All done!
			return deferred;
		},

		// Deferred helper
		when: function( singleValue ) {
			var

				// count of uncompleted subordinates
				remaining = arguments.length,

				// count of unprocessed arguments
				i = remaining,

				// subordinate fulfillment data
				resolveContexts = Array( i ),
				resolveValues = slice.call( arguments ),

				// the master Deferred
				master = jQuery.Deferred(),

				// subordinate callback factory
				updateFunc = function( i ) {
					return function( value ) {
						resolveContexts[ i ] = this;
						resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
						if ( !( --remaining ) ) {
							master.resolveWith( resolveContexts, resolveValues );
						}
					};
				};

			// Single- and empty arguments are adopted like Promise.resolve
			if ( remaining <= 1 ) {
				adoptValue( singleValue, master.done( updateFunc( i ) ).resolve, master.reject,
					!remaining );

				// Use .then() to unwrap secondary thenables (cf. gh-3000)
				if ( master.state() === "pending" ||
					isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {

					return master.then();
				}
			}

			// Multiple arguments are aggregated like Promise.all array elements
			while ( i-- ) {
				adoptValue( resolveValues[ i ], updateFunc( i ), master.reject );
			}

			return master.promise();
		}
	} );


	// These usually indicate a programmer mistake during development,
	// warn about them ASAP rather than swallowing them by default.
	var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;

	jQuery.Deferred.exceptionHook = function( error, stack ) {

		// Support: IE 8 - 9 only
		// Console exists when dev tools are open, which can happen at any time
		if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
			window.console.warn( "jQuery.Deferred exception: " + error.message, error.stack, stack );
		}
	};




	jQuery.readyException = function( error ) {
		window.setTimeout( function() {
			throw error;
		} );
	};




	// The deferred used on DOM ready
	var readyList = jQuery.Deferred();

	jQuery.fn.ready = function( fn ) {

		readyList
			.then( fn )

			// Wrap jQuery.readyException in a function so that the lookup
			// happens at the time of error handling instead of callback
			// registration.
			.catch( function( error ) {
				jQuery.readyException( error );
			} );

		return this;
	};

	jQuery.extend( {

		// Is the DOM ready to be used? Set to true once it occurs.
		isReady: false,

		// A counter to track how many items to wait for before
		// the ready event fires. See #6781
		readyWait: 1,

		// Handle when the DOM is ready
		ready: function( wait ) {

			// Abort if there are pending holds or we're already ready
			if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
				return;
			}

			// Remember that the DOM is ready
			jQuery.isReady = true;

			// If a normal DOM Ready event fired, decrement, and wait if need be
			if ( wait !== true && --jQuery.readyWait > 0 ) {
				return;
			}

			// If there are functions bound, to execute
			readyList.resolveWith( document, [ jQuery ] );
		}
	} );

	jQuery.ready.then = readyList.then;

	// The ready event handler and self cleanup method
	function completed() {
		document.removeEventListener( "DOMContentLoaded", completed );
		window.removeEventListener( "load", completed );
		jQuery.ready();
	}

	// Catch cases where $(document).ready() is called
	// after the browser event has already occurred.
	// Support: IE <=9 - 10 only
	// Older IE sometimes signals "interactive" too soon
	if ( document.readyState === "complete" ||
		( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {

		// Handle it asynchronously to allow scripts the opportunity to delay ready
		window.setTimeout( jQuery.ready );

	} else {

		// Use the handy event callback
		document.addEventListener( "DOMContentLoaded", completed );

		// A fallback to window.onload, that will always work
		window.addEventListener( "load", completed );
	}




	// Multifunctional method to get and set values of a collection
	// The value/s can optionally be executed if it's a function
	var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
		var i = 0,
			len = elems.length,
			bulk = key == null;

		// Sets many values
		if ( toType( key ) === "object" ) {
			chainable = true;
			for ( i in key ) {
				access( elems, fn, i, key[ i ], true, emptyGet, raw );
			}

		// Sets one value
		} else if ( value !== undefined ) {
			chainable = true;

			if ( !isFunction( value ) ) {
				raw = true;
			}

			if ( bulk ) {

				// Bulk operations run against the entire set
				if ( raw ) {
					fn.call( elems, value );
					fn = null;

				// ...except when executing function values
				} else {
					bulk = fn;
					fn = function( elem, key, value ) {
						return bulk.call( jQuery( elem ), value );
					};
				}
			}

			if ( fn ) {
				for ( ; i < len; i++ ) {
					fn(
						elems[ i ], key, raw ?
						value :
						value.call( elems[ i ], i, fn( elems[ i ], key ) )
					);
				}
			}
		}

		if ( chainable ) {
			return elems;
		}

		// Gets
		if ( bulk ) {
			return fn.call( elems );
		}

		return len ? fn( elems[ 0 ], key ) : emptyGet;
	};


	// Matches dashed string for camelizing
	var rmsPrefix = /^-ms-/,
		rdashAlpha = /-([a-z])/g;

	// Used by camelCase as callback to replace()
	function fcamelCase( all, letter ) {
		return letter.toUpperCase();
	}

	// Convert dashed to camelCase; used by the css and data modules
	// Support: IE <=9 - 11, Edge 12 - 15
	// Microsoft forgot to hump their vendor prefix (#9572)
	function camelCase( string ) {
		return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
	}
	var acceptData = function( owner ) {

		// Accepts only:
		//  - Node
		//    - Node.ELEMENT_NODE
		//    - Node.DOCUMENT_NODE
		//  - Object
		//    - Any
		return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
	};




	function Data() {
		this.expando = jQuery.expando + Data.uid++;
	}

	Data.uid = 1;

	Data.prototype = {

		cache: function( owner ) {

			// Check if the owner object already has a cache
			var value = owner[ this.expando ];

			// If not, create one
			if ( !value ) {
				value = {};

				// We can accept data for non-element nodes in modern browsers,
				// but we should not, see #8335.
				// Always return an empty object.
				if ( acceptData( owner ) ) {

					// If it is a node unlikely to be stringify-ed or looped over
					// use plain assignment
					if ( owner.nodeType ) {
						owner[ this.expando ] = value;

					// Otherwise secure it in a non-enumerable property
					// configurable must be true to allow the property to be
					// deleted when data is removed
					} else {
						Object.defineProperty( owner, this.expando, {
							value: value,
							configurable: true
						} );
					}
				}
			}

			return value;
		},
		set: function( owner, data, value ) {
			var prop,
				cache = this.cache( owner );

			// Handle: [ owner, key, value ] args
			// Always use camelCase key (gh-2257)
			if ( typeof data === "string" ) {
				cache[ camelCase( data ) ] = value;

			// Handle: [ owner, { properties } ] args
			} else {

				// Copy the properties one-by-one to the cache object
				for ( prop in data ) {
					cache[ camelCase( prop ) ] = data[ prop ];
				}
			}
			return cache;
		},
		get: function( owner, key ) {
			return key === undefined ?
				this.cache( owner ) :

				// Always use camelCase key (gh-2257)
				owner[ this.expando ] && owner[ this.expando ][ camelCase( key ) ];
		},
		access: function( owner, key, value ) {

			// In cases where either:
			//
			//   1. No key was specified
			//   2. A string key was specified, but no value provided
			//
			// Take the "read" path and allow the get method to determine
			// which value to return, respectively either:
			//
			//   1. The entire cache object
			//   2. The data stored at the key
			//
			if ( key === undefined ||
					( ( key && typeof key === "string" ) && value === undefined ) ) {

				return this.get( owner, key );
			}

			// When the key is not a string, or both a key and value
			// are specified, set or extend (existing objects) with either:
			//
			//   1. An object of properties
			//   2. A key and value
			//
			this.set( owner, key, value );

			// Since the "set" path can have two possible entry points
			// return the expected data based on which path was taken[*]
			return value !== undefined ? value : key;
		},
		remove: function( owner, key ) {
			var i,
				cache = owner[ this.expando ];

			if ( cache === undefined ) {
				return;
			}

			if ( key !== undefined ) {

				// Support array or space separated string of keys
				if ( Array.isArray( key ) ) {

					// If key is an array of keys...
					// We always set camelCase keys, so remove that.
					key = key.map( camelCase );
				} else {
					key = camelCase( key );

					// If a key with the spaces exists, use it.
					// Otherwise, create an array by matching non-whitespace
					key = key in cache ?
						[ key ] :
						( key.match( rnothtmlwhite ) || [] );
				}

				i = key.length;

				while ( i-- ) {
					delete cache[ key[ i ] ];
				}
			}

			// Remove the expando if there's no more data
			if ( key === undefined || jQuery.isEmptyObject( cache ) ) {

				// Support: Chrome <=35 - 45
				// Webkit & Blink performance suffers when deleting properties
				// from DOM nodes, so set to undefined instead
				// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
				if ( owner.nodeType ) {
					owner[ this.expando ] = undefined;
				} else {
					delete owner[ this.expando ];
				}
			}
		},
		hasData: function( owner ) {
			var cache = owner[ this.expando ];
			return cache !== undefined && !jQuery.isEmptyObject( cache );
		}
	};
	var dataPriv = new Data();

	var dataUser = new Data();



	//	Implementation Summary
	//
	//	1. Enforce API surface and semantic compatibility with 1.9.x branch
	//	2. Improve the module's maintainability by reducing the storage
	//		paths to a single mechanism.
	//	3. Use the same single mechanism to support "private" and "user" data.
	//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
	//	5. Avoid exposing implementation details on user objects (eg. expando properties)
	//	6. Provide a clear path for implementation upgrade to WeakMap in 2014

	var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
		rmultiDash = /[A-Z]/g;

	function getData( data ) {
		if ( data === "true" ) {
			return true;
		}

		if ( data === "false" ) {
			return false;
		}

		if ( data === "null" ) {
			return null;
		}

		// Only convert to a number if it doesn't change the string
		if ( data === +data + "" ) {
			return +data;
		}

		if ( rbrace.test( data ) ) {
			return JSON.parse( data );
		}

		return data;
	}

	function dataAttr( elem, key, data ) {
		var name;

		// If nothing was found internally, try to fetch any
		// data from the HTML5 data-* attribute
		if ( data === undefined && elem.nodeType === 1 ) {
			name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
			data = elem.getAttribute( name );

			if ( typeof data === "string" ) {
				try {
					data = getData( data );
				} catch ( e ) {}

				// Make sure we set the data so it isn't changed later
				dataUser.set( elem, key, data );
			} else {
				data = undefined;
			}
		}
		return data;
	}

	jQuery.extend( {
		hasData: function( elem ) {
			return dataUser.hasData( elem ) || dataPriv.hasData( elem );
		},

		data: function( elem, name, data ) {
			return dataUser.access( elem, name, data );
		},

		removeData: function( elem, name ) {
			dataUser.remove( elem, name );
		},

		// TODO: Now that all calls to _data and _removeData have been replaced
		// with direct calls to dataPriv methods, these can be deprecated.
		_data: function( elem, name, data ) {
			return dataPriv.access( elem, name, data );
		},

		_removeData: function( elem, name ) {
			dataPriv.remove( elem, name );
		}
	} );

	jQuery.fn.extend( {
		data: function( key, value ) {
			var i, name, data,
				elem = this[ 0 ],
				attrs = elem && elem.attributes;

			// Gets all values
			if ( key === undefined ) {
				if ( this.length ) {
					data = dataUser.get( elem );

					if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
						i = attrs.length;
						while ( i-- ) {

							// Support: IE 11 only
							// The attrs elements can be null (#14894)
							if ( attrs[ i ] ) {
								name = attrs[ i ].name;
								if ( name.indexOf( "data-" ) === 0 ) {
									name = camelCase( name.slice( 5 ) );
									dataAttr( elem, name, data[ name ] );
								}
							}
						}
						dataPriv.set( elem, "hasDataAttrs", true );
					}
				}

				return data;
			}

			// Sets multiple values
			if ( typeof key === "object" ) {
				return this.each( function() {
					dataUser.set( this, key );
				} );
			}

			return access( this, function( value ) {
				var data;

				// The calling jQuery object (element matches) is not empty
				// (and therefore has an element appears at this[ 0 ]) and the
				// `value` parameter was not undefined. An empty jQuery object
				// will result in `undefined` for elem = this[ 0 ] which will
				// throw an exception if an attempt to read a data cache is made.
				if ( elem && value === undefined ) {

					// Attempt to get data from the cache
					// The key will always be camelCased in Data
					data = dataUser.get( elem, key );
					if ( data !== undefined ) {
						return data;
					}

					// Attempt to "discover" the data in
					// HTML5 custom data-* attrs
					data = dataAttr( elem, key );
					if ( data !== undefined ) {
						return data;
					}

					// We tried really hard, but the data doesn't exist.
					return;
				}

				// Set the data...
				this.each( function() {

					// We always store the camelCased key
					dataUser.set( this, key, value );
				} );
			}, null, value, arguments.length > 1, null, true );
		},

		removeData: function( key ) {
			return this.each( function() {
				dataUser.remove( this, key );
			} );
		}
	} );


	jQuery.extend( {
		queue: function( elem, type, data ) {
			var queue;

			if ( elem ) {
				type = ( type || "fx" ) + "queue";
				queue = dataPriv.get( elem, type );

				// Speed up dequeue by getting out quickly if this is just a lookup
				if ( data ) {
					if ( !queue || Array.isArray( data ) ) {
						queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
					} else {
						queue.push( data );
					}
				}
				return queue || [];
			}
		},

		dequeue: function( elem, type ) {
			type = type || "fx";

			var queue = jQuery.queue( elem, type ),
				startLength = queue.length,
				fn = queue.shift(),
				hooks = jQuery._queueHooks( elem, type ),
				next = function() {
					jQuery.dequeue( elem, type );
				};

			// If the fx queue is dequeued, always remove the progress sentinel
			if ( fn === "inprogress" ) {
				fn = queue.shift();
				startLength--;
			}

			if ( fn ) {

				// Add a progress sentinel to prevent the fx queue from being
				// automatically dequeued
				if ( type === "fx" ) {
					queue.unshift( "inprogress" );
				}

				// Clear up the last queue stop function
				delete hooks.stop;
				fn.call( elem, next, hooks );
			}

			if ( !startLength && hooks ) {
				hooks.empty.fire();
			}
		},

		// Not public - generate a queueHooks object, or return the current one
		_queueHooks: function( elem, type ) {
			var key = type + "queueHooks";
			return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
				empty: jQuery.Callbacks( "once memory" ).add( function() {
					dataPriv.remove( elem, [ type + "queue", key ] );
				} )
			} );
		}
	} );

	jQuery.fn.extend( {
		queue: function( type, data ) {
			var setter = 2;

			if ( typeof type !== "string" ) {
				data = type;
				type = "fx";
				setter--;
			}

			if ( arguments.length < setter ) {
				return jQuery.queue( this[ 0 ], type );
			}

			return data === undefined ?
				this :
				this.each( function() {
					var queue = jQuery.queue( this, type, data );

					// Ensure a hooks for this queue
					jQuery._queueHooks( this, type );

					if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
						jQuery.dequeue( this, type );
					}
				} );
		},
		dequeue: function( type ) {
			return this.each( function() {
				jQuery.dequeue( this, type );
			} );
		},
		clearQueue: function( type ) {
			return this.queue( type || "fx", [] );
		},

		// Get a promise resolved when queues of a certain type
		// are emptied (fx is the type by default)
		promise: function( type, obj ) {
			var tmp,
				count = 1,
				defer = jQuery.Deferred(),
				elements = this,
				i = this.length,
				resolve = function() {
					if ( !( --count ) ) {
						defer.resolveWith( elements, [ elements ] );
					}
				};

			if ( typeof type !== "string" ) {
				obj = type;
				type = undefined;
			}
			type = type || "fx";

			while ( i-- ) {
				tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
				if ( tmp && tmp.empty ) {
					count++;
					tmp.empty.add( resolve );
				}
			}
			resolve();
			return defer.promise( obj );
		}
	} );
	var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;

	var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );


	var cssExpand = [ "Top", "Right", "Bottom", "Left" ];

	var isHiddenWithinTree = function( elem, el ) {

			// isHiddenWithinTree might be called from jQuery#filter function;
			// in that case, element will be second argument
			elem = el || elem;

			// Inline style trumps all
			return elem.style.display === "none" ||
				elem.style.display === "" &&

				// Otherwise, check computed style
				// Support: Firefox <=43 - 45
				// Disconnected elements can have computed display: none, so first confirm that elem is
				// in the document.
				jQuery.contains( elem.ownerDocument, elem ) &&

				jQuery.css( elem, "display" ) === "none";
		};

	var swap = function( elem, options, callback, args ) {
		var ret, name,
			old = {};

		// Remember the old values, and insert the new ones
		for ( name in options ) {
			old[ name ] = elem.style[ name ];
			elem.style[ name ] = options[ name ];
		}

		ret = callback.apply( elem, args || [] );

		// Revert the old values
		for ( name in options ) {
			elem.style[ name ] = old[ name ];
		}

		return ret;
	};




	function adjustCSS( elem, prop, valueParts, tween ) {
		var adjusted, scale,
			maxIterations = 20,
			currentValue = tween ?
				function() {
					return tween.cur();
				} :
				function() {
					return jQuery.css( elem, prop, "" );
				},
			initial = currentValue(),
			unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),

			// Starting value computation is required for potential unit mismatches
			initialInUnit = ( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
				rcssNum.exec( jQuery.css( elem, prop ) );

		if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {

			// Support: Firefox <=54
			// Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
			initial = initial / 2;

			// Trust units reported by jQuery.css
			unit = unit || initialInUnit[ 3 ];

			// Iteratively approximate from a nonzero starting point
			initialInUnit = +initial || 1;

			while ( maxIterations-- ) {

				// Evaluate and update our best guess (doubling guesses that zero out).
				// Finish if the scale equals or crosses 1 (making the old*new product non-positive).
				jQuery.style( elem, prop, initialInUnit + unit );
				if ( ( 1 - scale ) * ( 1 - ( scale = currentValue() / initial || 0.5 ) ) <= 0 ) {
					maxIterations = 0;
				}
				initialInUnit = initialInUnit / scale;

			}

			initialInUnit = initialInUnit * 2;
			jQuery.style( elem, prop, initialInUnit + unit );

			// Make sure we update the tween properties later on
			valueParts = valueParts || [];
		}

		if ( valueParts ) {
			initialInUnit = +initialInUnit || +initial || 0;

			// Apply relative offset (+=/-=) if specified
			adjusted = valueParts[ 1 ] ?
				initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
				+valueParts[ 2 ];
			if ( tween ) {
				tween.unit = unit;
				tween.start = initialInUnit;
				tween.end = adjusted;
			}
		}
		return adjusted;
	}


	var defaultDisplayMap = {};

	function getDefaultDisplay( elem ) {
		var temp,
			doc = elem.ownerDocument,
			nodeName = elem.nodeName,
			display = defaultDisplayMap[ nodeName ];

		if ( display ) {
			return display;
		}

		temp = doc.body.appendChild( doc.createElement( nodeName ) );
		display = jQuery.css( temp, "display" );

		temp.parentNode.removeChild( temp );

		if ( display === "none" ) {
			display = "block";
		}
		defaultDisplayMap[ nodeName ] = display;

		return display;
	}

	function showHide( elements, show ) {
		var display, elem,
			values = [],
			index = 0,
			length = elements.length;

		// Determine new display value for elements that need to change
		for ( ; index < length; index++ ) {
			elem = elements[ index ];
			if ( !elem.style ) {
				continue;
			}

			display = elem.style.display;
			if ( show ) {

				// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
				// check is required in this first loop unless we have a nonempty display value (either
				// inline or about-to-be-restored)
				if ( display === "none" ) {
					values[ index ] = dataPriv.get( elem, "display" ) || null;
					if ( !values[ index ] ) {
						elem.style.display = "";
					}
				}
				if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
					values[ index ] = getDefaultDisplay( elem );
				}
			} else {
				if ( display !== "none" ) {
					values[ index ] = "none";

					// Remember what we're overwriting
					dataPriv.set( elem, "display", display );
				}
			}
		}

		// Set the display of the elements in a second loop to avoid constant reflow
		for ( index = 0; index < length; index++ ) {
			if ( values[ index ] != null ) {
				elements[ index ].style.display = values[ index ];
			}
		}

		return elements;
	}

	jQuery.fn.extend( {
		show: function() {
			return showHide( this, true );
		},
		hide: function() {
			return showHide( this );
		},
		toggle: function( state ) {
			if ( typeof state === "boolean" ) {
				return state ? this.show() : this.hide();
			}

			return this.each( function() {
				if ( isHiddenWithinTree( this ) ) {
					jQuery( this ).show();
				} else {
					jQuery( this ).hide();
				}
			} );
		}
	} );
	var rcheckableType = ( /^(?:checkbox|radio)$/i );

	var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]+)/i );

	var rscriptType = ( /^$|^module$|\/(?:java|ecma)script/i );



	// We have to close these tags to support XHTML (#13200)
	var wrapMap = {

		// Support: IE <=9 only
		option: [ 1, "<select multiple='multiple'>", "</select>" ],

		// XHTML parsers do not magically insert elements in the
		// same way that tag soup parsers do. So we cannot shorten
		// this by omitting <tbody> or other required elements.
		thead: [ 1, "<table>", "</table>" ],
		col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
		tr: [ 2, "<table><tbody>", "</tbody></table>" ],
		td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],

		_default: [ 0, "", "" ]
	};

	// Support: IE <=9 only
	wrapMap.optgroup = wrapMap.option;

	wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
	wrapMap.th = wrapMap.td;


	function getAll( context, tag ) {

		// Support: IE <=9 - 11 only
		// Use typeof to avoid zero-argument method invocation on host objects (#15151)
		var ret;

		if ( typeof context.getElementsByTagName !== "undefined" ) {
			ret = context.getElementsByTagName( tag || "*" );

		} else if ( typeof context.querySelectorAll !== "undefined" ) {
			ret = context.querySelectorAll( tag || "*" );

		} else {
			ret = [];
		}

		if ( tag === undefined || tag && nodeName( context, tag ) ) {
			return jQuery.merge( [ context ], ret );
		}

		return ret;
	}


	// Mark scripts as having already been evaluated
	function setGlobalEval( elems, refElements ) {
		var i = 0,
			l = elems.length;

		for ( ; i < l; i++ ) {
			dataPriv.set(
				elems[ i ],
				"globalEval",
				!refElements || dataPriv.get( refElements[ i ], "globalEval" )
			);
		}
	}


	var rhtml = /<|&#?\w+;/;

	function buildFragment( elems, context, scripts, selection, ignored ) {
		var elem, tmp, tag, wrap, contains, j,
			fragment = context.createDocumentFragment(),
			nodes = [],
			i = 0,
			l = elems.length;

		for ( ; i < l; i++ ) {
			elem = elems[ i ];

			if ( elem || elem === 0 ) {

				// Add nodes directly
				if ( toType( elem ) === "object" ) {

					// Support: Android <=4.0 only, PhantomJS 1 only
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );

				// Convert non-html into a text node
				} else if ( !rhtml.test( elem ) ) {
					nodes.push( context.createTextNode( elem ) );

				// Convert html into DOM nodes
				} else {
					tmp = tmp || fragment.appendChild( context.createElement( "div" ) );

					// Deserialize a standard representation
					tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
					wrap = wrapMap[ tag ] || wrapMap._default;
					tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];

					// Descend through wrappers to the right content
					j = wrap[ 0 ];
					while ( j-- ) {
						tmp = tmp.lastChild;
					}

					// Support: Android <=4.0 only, PhantomJS 1 only
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, tmp.childNodes );

					// Remember the top-level container
					tmp = fragment.firstChild;

					// Ensure the created nodes are orphaned (#12392)
					tmp.textContent = "";
				}
			}
		}

		// Remove wrapper from fragment
		fragment.textContent = "";

		i = 0;
		while ( ( elem = nodes[ i++ ] ) ) {

			// Skip elements already in the context collection (trac-4087)
			if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
				if ( ignored ) {
					ignored.push( elem );
				}
				continue;
			}

			contains = jQuery.contains( elem.ownerDocument, elem );

			// Append to fragment
			tmp = getAll( fragment.appendChild( elem ), "script" );

			// Preserve script evaluation history
			if ( contains ) {
				setGlobalEval( tmp );
			}

			// Capture executables
			if ( scripts ) {
				j = 0;
				while ( ( elem = tmp[ j++ ] ) ) {
					if ( rscriptType.test( elem.type || "" ) ) {
						scripts.push( elem );
					}
				}
			}
		}

		return fragment;
	}


	( function() {
		var fragment = document.createDocumentFragment(),
			div = fragment.appendChild( document.createElement( "div" ) ),
			input = document.createElement( "input" );

		// Support: Android 4.0 - 4.3 only
		// Check state lost if the name is set (#11217)
		// Support: Windows Web Apps (WWA)
		// `name` and `type` must use .setAttribute for WWA (#14901)
		input.setAttribute( "type", "radio" );
		input.setAttribute( "checked", "checked" );
		input.setAttribute( "name", "t" );

		div.appendChild( input );

		// Support: Android <=4.1 only
		// Older WebKit doesn't clone checked state correctly in fragments
		support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;

		// Support: IE <=11 only
		// Make sure textarea (and checkbox) defaultValue is properly cloned
		div.innerHTML = "<textarea>x</textarea>";
		support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
	} )();
	var documentElement = document.documentElement;



	var
		rkeyEvent = /^key/,
		rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
		rtypenamespace = /^([^.]*)(?:\.(.+)|)/;

	function returnTrue() {
		return true;
	}

	function returnFalse() {
		return false;
	}

	// Support: IE <=9 only
	// See #13393 for more info
	function safeActiveElement() {
		try {
			return document.activeElement;
		} catch ( err ) { }
	}

	function on( elem, types, selector, data, fn, one ) {
		var origFn, type;

		// Types can be a map of types/handlers
		if ( typeof types === "object" ) {

			// ( types-Object, selector, data )
			if ( typeof selector !== "string" ) {

				// ( types-Object, data )
				data = data || selector;
				selector = undefined;
			}
			for ( type in types ) {
				on( elem, type, selector, data, types[ type ], one );
			}
			return elem;
		}

		if ( data == null && fn == null ) {

			// ( types, fn )
			fn = selector;
			data = selector = undefined;
		} else if ( fn == null ) {
			if ( typeof selector === "string" ) {

				// ( types, selector, fn )
				fn = data;
				data = undefined;
			} else {

				// ( types, data, fn )
				fn = data;
				data = selector;
				selector = undefined;
			}
		}
		if ( fn === false ) {
			fn = returnFalse;
		} else if ( !fn ) {
			return elem;
		}

		if ( one === 1 ) {
			origFn = fn;
			fn = function( event ) {

				// Can use an empty set, since event contains the info
				jQuery().off( event );
				return origFn.apply( this, arguments );
			};

			// Use same guid so caller can remove using origFn
			fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
		}
		return elem.each( function() {
			jQuery.event.add( this, types, fn, data, selector );
		} );
	}

	/*
	 * Helper functions for managing events -- not part of the public interface.
	 * Props to Dean Edwards' addEvent library for many of the ideas.
	 */
	jQuery.event = {

		global: {},

		add: function( elem, types, handler, data, selector ) {

			var handleObjIn, eventHandle, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = dataPriv.get( elem );

			// Don't attach events to noData or text/comment nodes (but allow plain objects)
			if ( !elemData ) {
				return;
			}

			// Caller can pass in an object of custom data in lieu of the handler
			if ( handler.handler ) {
				handleObjIn = handler;
				handler = handleObjIn.handler;
				selector = handleObjIn.selector;
			}

			// Ensure that invalid selectors throw exceptions at attach time
			// Evaluate against documentElement in case elem is a non-element node (e.g., document)
			if ( selector ) {
				jQuery.find.matchesSelector( documentElement, selector );
			}

			// Make sure that the handler has a unique ID, used to find/remove it later
			if ( !handler.guid ) {
				handler.guid = jQuery.guid++;
			}

			// Init the element's event structure and main handler, if this is the first
			if ( !( events = elemData.events ) ) {
				events = elemData.events = {};
			}
			if ( !( eventHandle = elemData.handle ) ) {
				eventHandle = elemData.handle = function( e ) {

					// Discard the second event of a jQuery.event.trigger() and
					// when an event is called after a page has unloaded
					return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
						jQuery.event.dispatch.apply( elem, arguments ) : undefined;
				};
			}

			// Handle multiple events separated by a space
			types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

				// There *must* be a type, no attaching namespace-only handlers
				if ( !type ) {
					continue;
				}

				// If event changes its type, use the special event handlers for the changed type
				special = jQuery.event.special[ type ] || {};

				// If selector defined, determine special event api type, otherwise given type
				type = ( selector ? special.delegateType : special.bindType ) || type;

				// Update special based on newly reset type
				special = jQuery.event.special[ type ] || {};

				// handleObj is passed to all event handlers
				handleObj = jQuery.extend( {
					type: type,
					origType: origType,
					data: data,
					handler: handler,
					guid: handler.guid,
					selector: selector,
					needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
					namespace: namespaces.join( "." )
				}, handleObjIn );

				// Init the event handler queue if we're the first
				if ( !( handlers = events[ type ] ) ) {
					handlers = events[ type ] = [];
					handlers.delegateCount = 0;

					// Only use addEventListener if the special events handler returns false
					if ( !special.setup ||
						special.setup.call( elem, data, namespaces, eventHandle ) === false ) {

						if ( elem.addEventListener ) {
							elem.addEventListener( type, eventHandle );
						}
					}
				}

				if ( special.add ) {
					special.add.call( elem, handleObj );

					if ( !handleObj.handler.guid ) {
						handleObj.handler.guid = handler.guid;
					}
				}

				// Add to the element's handler list, delegates in front
				if ( selector ) {
					handlers.splice( handlers.delegateCount++, 0, handleObj );
				} else {
					handlers.push( handleObj );
				}

				// Keep track of which events have ever been used, for event optimization
				jQuery.event.global[ type ] = true;
			}

		},

		// Detach an event or set of events from an element
		remove: function( elem, types, handler, selector, mappedTypes ) {

			var j, origCount, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );

			if ( !elemData || !( events = elemData.events ) ) {
				return;
			}

			// Once for each type.namespace in types; type may be omitted
			types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

				// Unbind all events (on this namespace, if provided) for the element
				if ( !type ) {
					for ( type in events ) {
						jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
					}
					continue;
				}

				special = jQuery.event.special[ type ] || {};
				type = ( selector ? special.delegateType : special.bindType ) || type;
				handlers = events[ type ] || [];
				tmp = tmp[ 2 ] &&
					new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );

				// Remove matching events
				origCount = j = handlers.length;
				while ( j-- ) {
					handleObj = handlers[ j ];

					if ( ( mappedTypes || origType === handleObj.origType ) &&
						( !handler || handler.guid === handleObj.guid ) &&
						( !tmp || tmp.test( handleObj.namespace ) ) &&
						( !selector || selector === handleObj.selector ||
							selector === "**" && handleObj.selector ) ) {
						handlers.splice( j, 1 );

						if ( handleObj.selector ) {
							handlers.delegateCount--;
						}
						if ( special.remove ) {
							special.remove.call( elem, handleObj );
						}
					}
				}

				// Remove generic event handler if we removed something and no more handlers exist
				// (avoids potential for endless recursion during removal of special event handlers)
				if ( origCount && !handlers.length ) {
					if ( !special.teardown ||
						special.teardown.call( elem, namespaces, elemData.handle ) === false ) {

						jQuery.removeEvent( elem, type, elemData.handle );
					}

					delete events[ type ];
				}
			}

			// Remove data and the expando if it's no longer used
			if ( jQuery.isEmptyObject( events ) ) {
				dataPriv.remove( elem, "handle events" );
			}
		},

		dispatch: function( nativeEvent ) {
			var arguments$1 = arguments;


			// Make a writable jQuery.Event from the native event object
			var event = jQuery.event.fix( nativeEvent );

			var i, j, ret, matched, handleObj, handlerQueue,
				args = new Array( arguments.length ),
				handlers = ( dataPriv.get( this, "events" ) || {} )[ event.type ] || [],
				special = jQuery.event.special[ event.type ] || {};

			// Use the fix-ed jQuery.Event rather than the (read-only) native event
			args[ 0 ] = event;

			for ( i = 1; i < arguments.length; i++ ) {
				args[ i ] = arguments$1[ i ];
			}

			event.delegateTarget = this;

			// Call the preDispatch hook for the mapped type, and let it bail if desired
			if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
				return;
			}

			// Determine handlers
			handlerQueue = jQuery.event.handlers.call( this, event, handlers );

			// Run delegates first; they may want to stop propagation beneath us
			i = 0;
			while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
				event.currentTarget = matched.elem;

				j = 0;
				while ( ( handleObj = matched.handlers[ j++ ] ) &&
					!event.isImmediatePropagationStopped() ) {

					// Triggered event must either 1) have no namespace, or 2) have namespace(s)
					// a subset or equal to those in the bound event (both can have no namespace).
					if ( !event.rnamespace || event.rnamespace.test( handleObj.namespace ) ) {

						event.handleObj = handleObj;
						event.data = handleObj.data;

						ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
							handleObj.handler ).apply( matched.elem, args );

						if ( ret !== undefined ) {
							if ( ( event.result = ret ) === false ) {
								event.preventDefault();
								event.stopPropagation();
							}
						}
					}
				}
			}

			// Call the postDispatch hook for the mapped type
			if ( special.postDispatch ) {
				special.postDispatch.call( this, event );
			}

			return event.result;
		},

		handlers: function( event, handlers ) {
			var this$1 = this;

			var i, handleObj, sel, matchedHandlers, matchedSelectors,
				handlerQueue = [],
				delegateCount = handlers.delegateCount,
				cur = event.target;

			// Find delegate handlers
			if ( delegateCount &&

				// Support: IE <=9
				// Black-hole SVG <use> instance trees (trac-13180)
				cur.nodeType &&

				// Support: Firefox <=42
				// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
				// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
				// Support: IE 11 only
				// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
				!( event.type === "click" && event.button >= 1 ) ) {

				for ( ; cur !== this; cur = cur.parentNode || this ) {

					// Don't check non-elements (#13208)
					// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
					if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
						matchedHandlers = [];
						matchedSelectors = {};
						for ( i = 0; i < delegateCount; i++ ) {
							handleObj = handlers[ i ];

							// Don't conflict with Object.prototype properties (#13203)
							sel = handleObj.selector + " ";

							if ( matchedSelectors[ sel ] === undefined ) {
								matchedSelectors[ sel ] = handleObj.needsContext ?
									jQuery( sel, this$1 ).index( cur ) > -1 :
									jQuery.find( sel, this$1, null, [ cur ] ).length;
							}
							if ( matchedSelectors[ sel ] ) {
								matchedHandlers.push( handleObj );
							}
						}
						if ( matchedHandlers.length ) {
							handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
						}
					}
				}
			}

			// Add the remaining (directly-bound) handlers
			cur = this;
			if ( delegateCount < handlers.length ) {
				handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
			}

			return handlerQueue;
		},

		addProp: function( name, hook ) {
			Object.defineProperty( jQuery.Event.prototype, name, {
				enumerable: true,
				configurable: true,

				get: isFunction( hook ) ?
					function() {
						if ( this.originalEvent ) {
								return hook( this.originalEvent );
						}
					} :
					function() {
						if ( this.originalEvent ) {
								return this.originalEvent[ name ];
						}
					},

				set: function( value ) {
					Object.defineProperty( this, name, {
						enumerable: true,
						configurable: true,
						writable: true,
						value: value
					} );
				}
			} );
		},

		fix: function( originalEvent ) {
			return originalEvent[ jQuery.expando ] ?
				originalEvent :
				new jQuery.Event( originalEvent );
		},

		special: {
			load: {

				// Prevent triggered image.load events from bubbling to window.load
				noBubble: true
			},
			focus: {

				// Fire native event if possible so blur/focus sequence is correct
				trigger: function() {
					if ( this !== safeActiveElement() && this.focus ) {
						this.focus();
						return false;
					}
				},
				delegateType: "focusin"
			},
			blur: {
				trigger: function() {
					if ( this === safeActiveElement() && this.blur ) {
						this.blur();
						return false;
					}
				},
				delegateType: "focusout"
			},
			click: {

				// For checkbox, fire native event so checked state will be right
				trigger: function() {
					if ( this.type === "checkbox" && this.click && nodeName( this, "input" ) ) {
						this.click();
						return false;
					}
				},

				// For cross-browser consistency, don't fire native .click() on links
				_default: function( event ) {
					return nodeName( event.target, "a" );
				}
			},

			beforeunload: {
				postDispatch: function( event ) {

					// Support: Firefox 20+
					// Firefox doesn't alert if the returnValue field is not set.
					if ( event.result !== undefined && event.originalEvent ) {
						event.originalEvent.returnValue = event.result;
					}
				}
			}
		}
	};

	jQuery.removeEvent = function( elem, type, handle ) {

		// This "if" is needed for plain objects
		if ( elem.removeEventListener ) {
			elem.removeEventListener( type, handle );
		}
	};

	jQuery.Event = function( src, props ) {

		// Allow instantiation without the 'new' keyword
		if ( !( this instanceof jQuery.Event ) ) {
			return new jQuery.Event( src, props );
		}

		// Event object
		if ( src && src.type ) {
			this.originalEvent = src;
			this.type = src.type;

			// Events bubbling up the document may have been marked as prevented
			// by a handler lower down the tree; reflect the correct value.
			this.isDefaultPrevented = src.defaultPrevented ||
					src.defaultPrevented === undefined &&

					// Support: Android <=2.3 only
					src.returnValue === false ?
				returnTrue :
				returnFalse;

			// Create target properties
			// Support: Safari <=6 - 7 only
			// Target should not be a text node (#504, #13143)
			this.target = ( src.target && src.target.nodeType === 3 ) ?
				src.target.parentNode :
				src.target;

			this.currentTarget = src.currentTarget;
			this.relatedTarget = src.relatedTarget;

		// Event type
		} else {
			this.type = src;
		}

		// Put explicitly provided properties onto the event object
		if ( props ) {
			jQuery.extend( this, props );
		}

		// Create a timestamp if incoming event doesn't have one
		this.timeStamp = src && src.timeStamp || Date.now();

		// Mark it as fixed
		this[ jQuery.expando ] = true;
	};

	// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
	// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
	jQuery.Event.prototype = {
		constructor: jQuery.Event,
		isDefaultPrevented: returnFalse,
		isPropagationStopped: returnFalse,
		isImmediatePropagationStopped: returnFalse,
		isSimulated: false,

		preventDefault: function() {
			var e = this.originalEvent;

			this.isDefaultPrevented = returnTrue;

			if ( e && !this.isSimulated ) {
				e.preventDefault();
			}
		},
		stopPropagation: function() {
			var e = this.originalEvent;

			this.isPropagationStopped = returnTrue;

			if ( e && !this.isSimulated ) {
				e.stopPropagation();
			}
		},
		stopImmediatePropagation: function() {
			var e = this.originalEvent;

			this.isImmediatePropagationStopped = returnTrue;

			if ( e && !this.isSimulated ) {
				e.stopImmediatePropagation();
			}

			this.stopPropagation();
		}
	};

	// Includes all common event props including KeyEvent and MouseEvent specific props
	jQuery.each( {
		altKey: true,
		bubbles: true,
		cancelable: true,
		changedTouches: true,
		ctrlKey: true,
		detail: true,
		eventPhase: true,
		metaKey: true,
		pageX: true,
		pageY: true,
		shiftKey: true,
		view: true,
		"char": true,
		charCode: true,
		key: true,
		keyCode: true,
		button: true,
		buttons: true,
		clientX: true,
		clientY: true,
		offsetX: true,
		offsetY: true,
		pointerId: true,
		pointerType: true,
		screenX: true,
		screenY: true,
		targetTouches: true,
		toElement: true,
		touches: true,

		which: function( event ) {
			var button = event.button;

			// Add which for key events
			if ( event.which == null && rkeyEvent.test( event.type ) ) {
				return event.charCode != null ? event.charCode : event.keyCode;
			}

			// Add which for click: 1 === left; 2 === middle; 3 === right
			if ( !event.which && button !== undefined && rmouseEvent.test( event.type ) ) {
				if ( button & 1 ) {
					return 1;
				}

				if ( button & 2 ) {
					return 3;
				}

				if ( button & 4 ) {
					return 2;
				}

				return 0;
			}

			return event.which;
		}
	}, jQuery.event.addProp );

	// Create mouseenter/leave events using mouseover/out and event-time checks
	// so that event delegation works in jQuery.
	// Do the same for pointerenter/pointerleave and pointerover/pointerout
	//
	// Support: Safari 7 only
	// Safari sends mouseenter too often; see:
	// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
	// for the description of the bug (it existed in older Chrome versions as well).
	jQuery.each( {
		mouseenter: "mouseover",
		mouseleave: "mouseout",
		pointerenter: "pointerover",
		pointerleave: "pointerout"
	}, function( orig, fix ) {
		jQuery.event.special[ orig ] = {
			delegateType: fix,
			bindType: fix,

			handle: function( event ) {
				var ret,
					target = this,
					related = event.relatedTarget,
					handleObj = event.handleObj;

				// For mouseenter/leave call the handler if related is outside the target.
				// NB: No relatedTarget if the mouse left/entered the browser window
				if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
					event.type = handleObj.origType;
					ret = handleObj.handler.apply( this, arguments );
					event.type = fix;
				}
				return ret;
			}
		};
	} );

	jQuery.fn.extend( {

		on: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn );
		},
		one: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn, 1 );
		},
		off: function( types, selector, fn ) {
			var this$1 = this;

			var handleObj, type;
			if ( types && types.preventDefault && types.handleObj ) {

				// ( event )  dispatched jQuery.Event
				handleObj = types.handleObj;
				jQuery( types.delegateTarget ).off(
					handleObj.namespace ?
						handleObj.origType + "." + handleObj.namespace :
						handleObj.origType,
					handleObj.selector,
					handleObj.handler
				);
				return this;
			}
			if ( typeof types === "object" ) {

				// ( types-object [, selector] )
				for ( type in types ) {
					this$1.off( type, selector, types[ type ] );
				}
				return this;
			}
			if ( selector === false || typeof selector === "function" ) {

				// ( types [, fn] )
				fn = selector;
				selector = undefined;
			}
			if ( fn === false ) {
				fn = returnFalse;
			}
			return this.each( function() {
				jQuery.event.remove( this, types, fn, selector );
			} );
		}
	} );


	var

		/* eslint-disable max-len */

		// See https://github.com/eslint/eslint/issues/3229
		rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi,

		/* eslint-enable */

		// Support: IE <=10 - 11, Edge 12 - 13 only
		// In IE/Edge using regex groups here causes severe slowdowns.
		// See https://connect.microsoft.com/IE/feedback/details/1736512/
		rnoInnerhtml = /<script|<style|<link/i,

		// checked="checked" or checked
		rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
		rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;

	// Prefer a tbody over its parent table for containing new rows
	function manipulationTarget( elem, content ) {
		if ( nodeName( elem, "table" ) &&
			nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {

			return jQuery( elem ).children( "tbody" )[ 0 ] || elem;
		}

		return elem;
	}

	// Replace/restore the type attribute of script elements for safe DOM manipulation
	function disableScript( elem ) {
		elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
		return elem;
	}
	function restoreScript( elem ) {
		if ( ( elem.type || "" ).slice( 0, 5 ) === "true/" ) {
			elem.type = elem.type.slice( 5 );
		} else {
			elem.removeAttribute( "type" );
		}

		return elem;
	}

	function cloneCopyEvent( src, dest ) {
		var i, l, type, pdataOld, pdataCur, udataOld, udataCur, events;

		if ( dest.nodeType !== 1 ) {
			return;
		}

		// 1. Copy private data: events, handlers, etc.
		if ( dataPriv.hasData( src ) ) {
			pdataOld = dataPriv.access( src );
			pdataCur = dataPriv.set( dest, pdataOld );
			events = pdataOld.events;

			if ( events ) {
				delete pdataCur.handle;
				pdataCur.events = {};

				for ( type in events ) {
					for ( i = 0, l = events[ type ].length; i < l; i++ ) {
						jQuery.event.add( dest, type, events[ type ][ i ] );
					}
				}
			}
		}

		// 2. Copy user data
		if ( dataUser.hasData( src ) ) {
			udataOld = dataUser.access( src );
			udataCur = jQuery.extend( {}, udataOld );

			dataUser.set( dest, udataCur );
		}
	}

	// Fix IE bugs, see support tests
	function fixInput( src, dest ) {
		var nodeName = dest.nodeName.toLowerCase();

		// Fails to persist the checked state of a cloned checkbox or radio button.
		if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
			dest.checked = src.checked;

		// Fails to return the selected option to the default selected state when cloning options
		} else if ( nodeName === "input" || nodeName === "textarea" ) {
			dest.defaultValue = src.defaultValue;
		}
	}

	function domManip( collection, args, callback, ignored ) {

		// Flatten any nested arrays
		args = concat.apply( [], args );

		var fragment, first, scripts, hasScripts, node, doc,
			i = 0,
			l = collection.length,
			iNoClone = l - 1,
			value = args[ 0 ],
			valueIsFunction = isFunction( value );

		// We can't cloneNode fragments that contain checked, in WebKit
		if ( valueIsFunction ||
				( l > 1 && typeof value === "string" &&
					!support.checkClone && rchecked.test( value ) ) ) {
			return collection.each( function( index ) {
				var self = collection.eq( index );
				if ( valueIsFunction ) {
					args[ 0 ] = value.call( this, index, self.html() );
				}
				domManip( self, args, callback, ignored );
			} );
		}

		if ( l ) {
			fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
			first = fragment.firstChild;

			if ( fragment.childNodes.length === 1 ) {
				fragment = first;
			}

			// Require either new content or an interest in ignored elements to invoke the callback
			if ( first || ignored ) {
				scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
				hasScripts = scripts.length;

				// Use the original fragment for the last item
				// instead of the first because it can end up
				// being emptied incorrectly in certain situations (#8070).
				for ( ; i < l; i++ ) {
					node = fragment;

					if ( i !== iNoClone ) {
						node = jQuery.clone( node, true, true );

						// Keep references to cloned scripts for later restoration
						if ( hasScripts ) {

							// Support: Android <=4.0 only, PhantomJS 1 only
							// push.apply(_, arraylike) throws on ancient WebKit
							jQuery.merge( scripts, getAll( node, "script" ) );
						}
					}

					callback.call( collection[ i ], node, i );
				}

				if ( hasScripts ) {
					doc = scripts[ scripts.length - 1 ].ownerDocument;

					// Reenable scripts
					jQuery.map( scripts, restoreScript );

					// Evaluate executable scripts on first document insertion
					for ( i = 0; i < hasScripts; i++ ) {
						node = scripts[ i ];
						if ( rscriptType.test( node.type || "" ) &&
							!dataPriv.access( node, "globalEval" ) &&
							jQuery.contains( doc, node ) ) {

							if ( node.src && ( node.type || "" ).toLowerCase()  !== "module" ) {

								// Optional AJAX dependency, but won't run scripts if not present
								if ( jQuery._evalUrl ) {
									jQuery._evalUrl( node.src );
								}
							} else {
								DOMEval( node.textContent.replace( rcleanScript, "" ), doc, node );
							}
						}
					}
				}
			}
		}

		return collection;
	}

	function remove( elem, selector, keepData ) {
		var node,
			nodes = selector ? jQuery.filter( selector, elem ) : elem,
			i = 0;

		for ( ; ( node = nodes[ i ] ) != null; i++ ) {
			if ( !keepData && node.nodeType === 1 ) {
				jQuery.cleanData( getAll( node ) );
			}

			if ( node.parentNode ) {
				if ( keepData && jQuery.contains( node.ownerDocument, node ) ) {
					setGlobalEval( getAll( node, "script" ) );
				}
				node.parentNode.removeChild( node );
			}
		}

		return elem;
	}

	jQuery.extend( {
		htmlPrefilter: function( html ) {
			return html.replace( rxhtmlTag, "<$1></$2>" );
		},

		clone: function( elem, dataAndEvents, deepDataAndEvents ) {
			var i, l, srcElements, destElements,
				clone = elem.cloneNode( true ),
				inPage = jQuery.contains( elem.ownerDocument, elem );

			// Fix IE cloning issues
			if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
					!jQuery.isXMLDoc( elem ) ) {

				// We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
				destElements = getAll( clone );
				srcElements = getAll( elem );

				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					fixInput( srcElements[ i ], destElements[ i ] );
				}
			}

			// Copy the events from the original to the clone
			if ( dataAndEvents ) {
				if ( deepDataAndEvents ) {
					srcElements = srcElements || getAll( elem );
					destElements = destElements || getAll( clone );

					for ( i = 0, l = srcElements.length; i < l; i++ ) {
						cloneCopyEvent( srcElements[ i ], destElements[ i ] );
					}
				} else {
					cloneCopyEvent( elem, clone );
				}
			}

			// Preserve script evaluation history
			destElements = getAll( clone, "script" );
			if ( destElements.length > 0 ) {
				setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
			}

			// Return the cloned set
			return clone;
		},

		cleanData: function( elems ) {
			var data, elem, type,
				special = jQuery.event.special,
				i = 0;

			for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
				if ( acceptData( elem ) ) {
					if ( ( data = elem[ dataPriv.expando ] ) ) {
						if ( data.events ) {
							for ( type in data.events ) {
								if ( special[ type ] ) {
									jQuery.event.remove( elem, type );

								// This is a shortcut to avoid jQuery.event.remove's overhead
								} else {
									jQuery.removeEvent( elem, type, data.handle );
								}
							}
						}

						// Support: Chrome <=35 - 45+
						// Assign undefined instead of using delete, see Data#remove
						elem[ dataPriv.expando ] = undefined;
					}
					if ( elem[ dataUser.expando ] ) {

						// Support: Chrome <=35 - 45+
						// Assign undefined instead of using delete, see Data#remove
						elem[ dataUser.expando ] = undefined;
					}
				}
			}
		}
	} );

	jQuery.fn.extend( {
		detach: function( selector ) {
			return remove( this, selector, true );
		},

		remove: function( selector ) {
			return remove( this, selector );
		},

		text: function( value ) {
			return access( this, function( value ) {
				return value === undefined ?
					jQuery.text( this ) :
					this.empty().each( function() {
						if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
							this.textContent = value;
						}
					} );
			}, null, value, arguments.length );
		},

		append: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.appendChild( elem );
				}
			} );
		},

		prepend: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.insertBefore( elem, target.firstChild );
				}
			} );
		},

		before: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this );
				}
			} );
		},

		after: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this.nextSibling );
				}
			} );
		},

		empty: function() {
			var elem,
				i = 0;

			for ( ; ( elem = this[ i ] ) != null; i++ ) {
				if ( elem.nodeType === 1 ) {

					// Prevent memory leaks
					jQuery.cleanData( getAll( elem, false ) );

					// Remove any remaining nodes
					elem.textContent = "";
				}
			}

			return this;
		},

		clone: function( dataAndEvents, deepDataAndEvents ) {
			dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
			deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

			return this.map( function() {
				return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
			} );
		},

		html: function( value ) {
			return access( this, function( value ) {
				var this$1 = this;

				var elem = this[ 0 ] || {},
					i = 0,
					l = this.length;

				if ( value === undefined && elem.nodeType === 1 ) {
					return elem.innerHTML;
				}

				// See if we can take a shortcut and just use innerHTML
				if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
					!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {

					value = jQuery.htmlPrefilter( value );

					try {
						for ( ; i < l; i++ ) {
							elem = this$1[ i ] || {};

							// Remove element nodes and prevent memory leaks
							if ( elem.nodeType === 1 ) {
								jQuery.cleanData( getAll( elem, false ) );
								elem.innerHTML = value;
							}
						}

						elem = 0;

					// If using innerHTML throws an exception, use the fallback method
					} catch ( e ) {}
				}

				if ( elem ) {
					this.empty().append( value );
				}
			}, null, value, arguments.length );
		},

		replaceWith: function() {
			var ignored = [];

			// Make the changes, replacing each non-ignored context element with the new content
			return domManip( this, arguments, function( elem ) {
				var parent = this.parentNode;

				if ( jQuery.inArray( this, ignored ) < 0 ) {
					jQuery.cleanData( getAll( this ) );
					if ( parent ) {
						parent.replaceChild( elem, this );
					}
				}

			// Force callback invocation
			}, ignored );
		}
	} );

	jQuery.each( {
		appendTo: "append",
		prependTo: "prepend",
		insertBefore: "before",
		insertAfter: "after",
		replaceAll: "replaceWith"
	}, function( name, original ) {
		jQuery.fn[ name ] = function( selector ) {
			var this$1 = this;

			var elems,
				ret = [],
				insert = jQuery( selector ),
				last = insert.length - 1,
				i = 0;

			for ( ; i <= last; i++ ) {
				elems = i === last ? this$1 : this$1.clone( true );
				jQuery( insert[ i ] )[ original ]( elems );

				// Support: Android <=4.0 only, PhantomJS 1 only
				// .get() because push.apply(_, arraylike) throws on ancient WebKit
				push.apply( ret, elems.get() );
			}

			return this.pushStack( ret );
		};
	} );
	var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );

	var getStyles = function( elem ) {

			// Support: IE <=11 only, Firefox <=30 (#15098, #14150)
			// IE throws on elements created in popups
			// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
			var view = elem.ownerDocument.defaultView;

			if ( !view || !view.opener ) {
				view = window;
			}

			return view.getComputedStyle( elem );
		};

	var rboxStyle = new RegExp( cssExpand.join( "|" ), "i" );



	( function() {

		// Executing both pixelPosition & boxSizingReliable tests require only one layout
		// so they're executed at the same time to save the second computation.
		function computeStyleTests() {

			// This is a singleton, we need to execute it only once
			if ( !div ) {
				return;
			}

			container.style.cssText = "position:absolute;left:-11111px;width:60px;" +
				"margin-top:1px;padding:0;border:0";
			div.style.cssText =
				"position:relative;display:block;box-sizing:border-box;overflow:scroll;" +
				"margin:auto;border:1px;padding:1px;" +
				"width:60%;top:1%";
			documentElement.appendChild( container ).appendChild( div );

			var divStyle = window.getComputedStyle( div );
			pixelPositionVal = divStyle.top !== "1%";

			// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
			reliableMarginLeftVal = roundPixelMeasures( divStyle.marginLeft ) === 12;

			// Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
			// Some styles come back with percentage values, even though they shouldn't
			div.style.right = "60%";
			pixelBoxStylesVal = roundPixelMeasures( divStyle.right ) === 36;

			// Support: IE 9 - 11 only
			// Detect misreporting of content dimensions for box-sizing:border-box elements
			boxSizingReliableVal = roundPixelMeasures( divStyle.width ) === 36;

			// Support: IE 9 only
			// Detect overflow:scroll screwiness (gh-3699)
			div.style.position = "absolute";
			scrollboxSizeVal = div.offsetWidth === 36 || "absolute";

			documentElement.removeChild( container );

			// Nullify the div so it wouldn't be stored in the memory and
			// it will also be a sign that checks already performed
			div = null;
		}

		function roundPixelMeasures( measure ) {
			return Math.round( parseFloat( measure ) );
		}

		var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal,
			reliableMarginLeftVal,
			container = document.createElement( "div" ),
			div = document.createElement( "div" );

		// Finish early in limited (non-browser) environments
		if ( !div.style ) {
			return;
		}

		// Support: IE <=9 - 11 only
		// Style of cloned element affects source element cloned (#8908)
		div.style.backgroundClip = "content-box";
		div.cloneNode( true ).style.backgroundClip = "";
		support.clearCloneStyle = div.style.backgroundClip === "content-box";

		jQuery.extend( support, {
			boxSizingReliable: function() {
				computeStyleTests();
				return boxSizingReliableVal;
			},
			pixelBoxStyles: function() {
				computeStyleTests();
				return pixelBoxStylesVal;
			},
			pixelPosition: function() {
				computeStyleTests();
				return pixelPositionVal;
			},
			reliableMarginLeft: function() {
				computeStyleTests();
				return reliableMarginLeftVal;
			},
			scrollboxSize: function() {
				computeStyleTests();
				return scrollboxSizeVal;
			}
		} );
	} )();


	function curCSS( elem, name, computed ) {
		var width, minWidth, maxWidth, ret,

			// Support: Firefox 51+
			// Retrieving style before computed somehow
			// fixes an issue with getting wrong values
			// on detached elements
			style = elem.style;

		computed = computed || getStyles( elem );

		// getPropertyValue is needed for:
		//   .css('filter') (IE 9 only, #12537)
		//   .css('--customProperty) (#3144)
		if ( computed ) {
			ret = computed.getPropertyValue( name ) || computed[ name ];

			if ( ret === "" && !jQuery.contains( elem.ownerDocument, elem ) ) {
				ret = jQuery.style( elem, name );
			}

			// A tribute to the "awesome hack by Dean Edwards"
			// Android Browser returns percentage for some values,
			// but width seems to be reliably pixels.
			// This is against the CSSOM draft spec:
			// https://drafts.csswg.org/cssom/#resolved-values
			if ( !support.pixelBoxStyles() && rnumnonpx.test( ret ) && rboxStyle.test( name ) ) {

				// Remember the original values
				width = style.width;
				minWidth = style.minWidth;
				maxWidth = style.maxWidth;

				// Put in the new values to get a computed value out
				style.minWidth = style.maxWidth = style.width = ret;
				ret = computed.width;

				// Revert the changed values
				style.width = width;
				style.minWidth = minWidth;
				style.maxWidth = maxWidth;
			}
		}

		return ret !== undefined ?

			// Support: IE <=9 - 11 only
			// IE returns zIndex value as an integer.
			ret + "" :
			ret;
	}


	function addGetHookIf( conditionFn, hookFn ) {

		// Define the hook, we'll check on the first run if it's really needed.
		return {
			get: function() {
				if ( conditionFn() ) {

					// Hook not needed (or it's not possible to use it due
					// to missing dependency), remove it.
					delete this.get;
					return;
				}

				// Hook needed; redefine it so that the support test is not executed again.
				return ( this.get = hookFn ).apply( this, arguments );
			}
		};
	}


	var

		// Swappable if display is none or starts with table
		// except "table", "table-cell", or "table-caption"
		// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
		rdisplayswap = /^(none|table(?!-c[ea]).+)/,
		rcustomProp = /^--/,
		cssShow = { position: "absolute", visibility: "hidden", display: "block" },
		cssNormalTransform = {
			letterSpacing: "0",
			fontWeight: "400"
		},

		cssPrefixes = [ "Webkit", "Moz", "ms" ],
		emptyStyle = document.createElement( "div" ).style;

	// Return a css property mapped to a potentially vendor prefixed property
	function vendorPropName( name ) {

		// Shortcut for names that are not vendor prefixed
		if ( name in emptyStyle ) {
			return name;
		}

		// Check for vendor prefixed names
		var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
			i = cssPrefixes.length;

		while ( i-- ) {
			name = cssPrefixes[ i ] + capName;
			if ( name in emptyStyle ) {
				return name;
			}
		}
	}

	// Return a property mapped along what jQuery.cssProps suggests or to
	// a vendor prefixed property.
	function finalPropName( name ) {
		var ret = jQuery.cssProps[ name ];
		if ( !ret ) {
			ret = jQuery.cssProps[ name ] = vendorPropName( name ) || name;
		}
		return ret;
	}

	function setPositiveNumber( elem, value, subtract ) {

		// Any relative (+/-) values have already been
		// normalized at this point
		var matches = rcssNum.exec( value );
		return matches ?

			// Guard against undefined "subtract", e.g., when used as in cssHooks
			Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
			value;
	}

	function boxModelAdjustment( elem, dimension, box, isBorderBox, styles, computedVal ) {
		var i = dimension === "width" ? 1 : 0,
			extra = 0,
			delta = 0;

		// Adjustment may not be necessary
		if ( box === ( isBorderBox ? "border" : "content" ) ) {
			return 0;
		}

		for ( ; i < 4; i += 2 ) {

			// Both box models exclude margin
			if ( box === "margin" ) {
				delta += jQuery.css( elem, box + cssExpand[ i ], true, styles );
			}

			// If we get here with a content-box, we're seeking "padding" or "border" or "margin"
			if ( !isBorderBox ) {

				// Add padding
				delta += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );

				// For "border" or "margin", add border
				if ( box !== "padding" ) {
					delta += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );

				// But still keep track of it otherwise
				} else {
					extra += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}

			// If we get here with a border-box (content + padding + border), we're seeking "content" or
			// "padding" or "margin"
			} else {

				// For "content", subtract padding
				if ( box === "content" ) {
					delta -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
				}

				// For "content" or "padding", subtract border
				if ( box !== "margin" ) {
					delta -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
			}
		}

		// Account for positive content-box scroll gutter when requested by providing computedVal
		if ( !isBorderBox && computedVal >= 0 ) {

			// offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
			// Assuming integer scroll gutter, subtract the rest and round down
			delta += Math.max( 0, Math.ceil(
				elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
				computedVal -
				delta -
				extra -
				0.5
			) );
		}

		return delta;
	}

	function getWidthOrHeight( elem, dimension, extra ) {

		// Start with computed style
		var styles = getStyles( elem ),
			val = curCSS( elem, dimension, styles ),
			isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
			valueIsBorderBox = isBorderBox;

		// Support: Firefox <=54
		// Return a confounding non-pixel value or feign ignorance, as appropriate.
		if ( rnumnonpx.test( val ) ) {
			if ( !extra ) {
				return val;
			}
			val = "auto";
		}

		// Check for style in case a browser which returns unreliable values
		// for getComputedStyle silently falls back to the reliable elem.style
		valueIsBorderBox = valueIsBorderBox &&
			( support.boxSizingReliable() || val === elem.style[ dimension ] );

		// Fall back to offsetWidth/offsetHeight when value is "auto"
		// This happens for inline elements with no explicit setting (gh-3571)
		// Support: Android <=4.1 - 4.3 only
		// Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
		if ( val === "auto" ||
			!parseFloat( val ) && jQuery.css( elem, "display", false, styles ) === "inline" ) {

			val = elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ];

			// offsetWidth/offsetHeight provide border-box values
			valueIsBorderBox = true;
		}

		// Normalize "" and auto
		val = parseFloat( val ) || 0;

		// Adjust for the element's box model
		return ( val +
			boxModelAdjustment(
				elem,
				dimension,
				extra || ( isBorderBox ? "border" : "content" ),
				valueIsBorderBox,
				styles,

				// Provide the current computed size to request scroll gutter calculation (gh-3589)
				val
			)
		) + "px";
	}

	jQuery.extend( {

		// Add in style property hooks for overriding the default
		// behavior of getting and setting a style property
		cssHooks: {
			opacity: {
				get: function( elem, computed ) {
					if ( computed ) {

						// We should always get a number back from opacity
						var ret = curCSS( elem, "opacity" );
						return ret === "" ? "1" : ret;
					}
				}
			}
		},

		// Don't automatically add "px" to these possibly-unitless properties
		cssNumber: {
			"animationIterationCount": true,
			"columnCount": true,
			"fillOpacity": true,
			"flexGrow": true,
			"flexShrink": true,
			"fontWeight": true,
			"lineHeight": true,
			"opacity": true,
			"order": true,
			"orphans": true,
			"widows": true,
			"zIndex": true,
			"zoom": true
		},

		// Add in properties whose names you wish to fix before
		// setting or getting the value
		cssProps: {},

		// Get and set the style property on a DOM Node
		style: function( elem, name, value, extra ) {

			// Don't set styles on text and comment nodes
			if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
				return;
			}

			// Make sure that we're working with the right name
			var ret, type, hooks,
				origName = camelCase( name ),
				isCustomProp = rcustomProp.test( name ),
				style = elem.style;

			// Make sure that we're working with the right name. We don't
			// want to query the value if it is a CSS custom property
			// since they are user-defined.
			if ( !isCustomProp ) {
				name = finalPropName( origName );
			}

			// Gets hook for the prefixed version, then unprefixed version
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

			// Check if we're setting a value
			if ( value !== undefined ) {
				type = typeof value;

				// Convert "+=" or "-=" to relative numbers (#7345)
				if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
					value = adjustCSS( elem, name, ret );

					// Fixes bug #9237
					type = "number";
				}

				// Make sure that null and NaN values aren't set (#7116)
				if ( value == null || value !== value ) {
					return;
				}

				// If a number was passed in, add the unit (except for certain CSS properties)
				if ( type === "number" ) {
					value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
				}

				// background-* props affect original clone's values
				if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
					style[ name ] = "inherit";
				}

				// If a hook was provided, use that value, otherwise just set the specified value
				if ( !hooks || !( "set" in hooks ) ||
					( value = hooks.set( elem, value, extra ) ) !== undefined ) {

					if ( isCustomProp ) {
						style.setProperty( name, value );
					} else {
						style[ name ] = value;
					}
				}

			} else {

				// If a hook was provided get the non-computed value from there
				if ( hooks && "get" in hooks &&
					( ret = hooks.get( elem, false, extra ) ) !== undefined ) {

					return ret;
				}

				// Otherwise just get the value from the style object
				return style[ name ];
			}
		},

		css: function( elem, name, extra, styles ) {
			var val, num, hooks,
				origName = camelCase( name ),
				isCustomProp = rcustomProp.test( name );

			// Make sure that we're working with the right name. We don't
			// want to modify the value if it is a CSS custom property
			// since they are user-defined.
			if ( !isCustomProp ) {
				name = finalPropName( origName );
			}

			// Try prefixed name followed by the unprefixed name
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

			// If a hook was provided get the computed value from there
			if ( hooks && "get" in hooks ) {
				val = hooks.get( elem, true, extra );
			}

			// Otherwise, if a way to get the computed value exists, use that
			if ( val === undefined ) {
				val = curCSS( elem, name, styles );
			}

			// Convert "normal" to computed value
			if ( val === "normal" && name in cssNormalTransform ) {
				val = cssNormalTransform[ name ];
			}

			// Make numeric if forced or a qualifier was provided and val looks numeric
			if ( extra === "" || extra ) {
				num = parseFloat( val );
				return extra === true || isFinite( num ) ? num || 0 : val;
			}

			return val;
		}
	} );

	jQuery.each( [ "height", "width" ], function( i, dimension ) {
		jQuery.cssHooks[ dimension ] = {
			get: function( elem, computed, extra ) {
				if ( computed ) {

					// Certain elements can have dimension info if we invisibly show them
					// but it must have a current display style that would benefit
					return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&

						// Support: Safari 8+
						// Table columns in Safari have non-zero offsetWidth & zero
						// getBoundingClientRect().width unless display is changed.
						// Support: IE <=11 only
						// Running getBoundingClientRect on a disconnected node
						// in IE throws an error.
						( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
							swap( elem, cssShow, function() {
								return getWidthOrHeight( elem, dimension, extra );
							} ) :
							getWidthOrHeight( elem, dimension, extra );
				}
			},

			set: function( elem, value, extra ) {
				var matches,
					styles = getStyles( elem ),
					isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
					subtract = extra && boxModelAdjustment(
						elem,
						dimension,
						extra,
						isBorderBox,
						styles
					);

				// Account for unreliable border-box dimensions by comparing offset* to computed and
				// faking a content-box to get border and padding (gh-3699)
				if ( isBorderBox && support.scrollboxSize() === styles.position ) {
					subtract -= Math.ceil(
						elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
						parseFloat( styles[ dimension ] ) -
						boxModelAdjustment( elem, dimension, "border", false, styles ) -
						0.5
					);
				}

				// Convert to pixels if value adjustment is needed
				if ( subtract && ( matches = rcssNum.exec( value ) ) &&
					( matches[ 3 ] || "px" ) !== "px" ) {

					elem.style[ dimension ] = value;
					value = jQuery.css( elem, dimension );
				}

				return setPositiveNumber( elem, value, subtract );
			}
		};
	} );

	jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
		function( elem, computed ) {
			if ( computed ) {
				return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
					elem.getBoundingClientRect().left -
						swap( elem, { marginLeft: 0 }, function() {
							return elem.getBoundingClientRect().left;
						} )
					) + "px";
			}
		}
	);

	// These hooks are used by animate to expand properties
	jQuery.each( {
		margin: "",
		padding: "",
		border: "Width"
	}, function( prefix, suffix ) {
		jQuery.cssHooks[ prefix + suffix ] = {
			expand: function( value ) {
				var i = 0,
					expanded = {},

					// Assumes a single number if not a string
					parts = typeof value === "string" ? value.split( " " ) : [ value ];

				for ( ; i < 4; i++ ) {
					expanded[ prefix + cssExpand[ i ] + suffix ] =
						parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
				}

				return expanded;
			}
		};

		if ( prefix !== "margin" ) {
			jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
		}
	} );

	jQuery.fn.extend( {
		css: function( name, value ) {
			return access( this, function( elem, name, value ) {
				var styles, len,
					map = {},
					i = 0;

				if ( Array.isArray( name ) ) {
					styles = getStyles( elem );
					len = name.length;

					for ( ; i < len; i++ ) {
						map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
					}

					return map;
				}

				return value !== undefined ?
					jQuery.style( elem, name, value ) :
					jQuery.css( elem, name );
			}, name, value, arguments.length > 1 );
		}
	} );


	function Tween( elem, options, prop, end, easing ) {
		return new Tween.prototype.init( elem, options, prop, end, easing );
	}
	jQuery.Tween = Tween;

	Tween.prototype = {
		constructor: Tween,
		init: function( elem, options, prop, end, easing, unit ) {
			this.elem = elem;
			this.prop = prop;
			this.easing = easing || jQuery.easing._default;
			this.options = options;
			this.start = this.now = this.cur();
			this.end = end;
			this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
		},
		cur: function() {
			var hooks = Tween.propHooks[ this.prop ];

			return hooks && hooks.get ?
				hooks.get( this ) :
				Tween.propHooks._default.get( this );
		},
		run: function( percent ) {
			var eased,
				hooks = Tween.propHooks[ this.prop ];

			if ( this.options.duration ) {
				this.pos = eased = jQuery.easing[ this.easing ](
					percent, this.options.duration * percent, 0, 1, this.options.duration
				);
			} else {
				this.pos = eased = percent;
			}
			this.now = ( this.end - this.start ) * eased + this.start;

			if ( this.options.step ) {
				this.options.step.call( this.elem, this.now, this );
			}

			if ( hooks && hooks.set ) {
				hooks.set( this );
			} else {
				Tween.propHooks._default.set( this );
			}
			return this;
		}
	};

	Tween.prototype.init.prototype = Tween.prototype;

	Tween.propHooks = {
		_default: {
			get: function( tween ) {
				var result;

				// Use a property on the element directly when it is not a DOM element,
				// or when there is no matching style property that exists.
				if ( tween.elem.nodeType !== 1 ||
					tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
					return tween.elem[ tween.prop ];
				}

				// Passing an empty string as a 3rd parameter to .css will automatically
				// attempt a parseFloat and fallback to a string if the parse fails.
				// Simple values such as "10px" are parsed to Float;
				// complex values such as "rotate(1rad)" are returned as-is.
				result = jQuery.css( tween.elem, tween.prop, "" );

				// Empty strings, null, undefined and "auto" are converted to 0.
				return !result || result === "auto" ? 0 : result;
			},
			set: function( tween ) {

				// Use step hook for back compat.
				// Use cssHook if its there.
				// Use .style if available and use plain properties where available.
				if ( jQuery.fx.step[ tween.prop ] ) {
					jQuery.fx.step[ tween.prop ]( tween );
				} else if ( tween.elem.nodeType === 1 &&
					( tween.elem.style[ jQuery.cssProps[ tween.prop ] ] != null ||
						jQuery.cssHooks[ tween.prop ] ) ) {
					jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
				} else {
					tween.elem[ tween.prop ] = tween.now;
				}
			}
		}
	};

	// Support: IE <=9 only
	// Panic based approach to setting things on disconnected nodes
	Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
		set: function( tween ) {
			if ( tween.elem.nodeType && tween.elem.parentNode ) {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	};

	jQuery.easing = {
		linear: function( p ) {
			return p;
		},
		swing: function( p ) {
			return 0.5 - Math.cos( p * Math.PI ) / 2;
		},
		_default: "swing"
	};

	jQuery.fx = Tween.prototype.init;

	// Back compat <1.8 extension point
	jQuery.fx.step = {};




	var
		fxNow, inProgress,
		rfxtypes = /^(?:toggle|show|hide)$/,
		rrun = /queueHooks$/;

	function schedule() {
		if ( inProgress ) {
			if ( document.hidden === false && window.requestAnimationFrame ) {
				window.requestAnimationFrame( schedule );
			} else {
				window.setTimeout( schedule, jQuery.fx.interval );
			}

			jQuery.fx.tick();
		}
	}

	// Animations created synchronously will run synchronously
	function createFxNow() {
		window.setTimeout( function() {
			fxNow = undefined;
		} );
		return ( fxNow = Date.now() );
	}

	// Generate parameters to create a standard animation
	function genFx( type, includeWidth ) {
		var which,
			i = 0,
			attrs = { height: type };

		// If we include width, step value is 1 to do all cssExpand values,
		// otherwise step value is 2 to skip over Left and Right
		includeWidth = includeWidth ? 1 : 0;
		for ( ; i < 4; i += 2 - includeWidth ) {
			which = cssExpand[ i ];
			attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
		}

		if ( includeWidth ) {
			attrs.opacity = attrs.width = type;
		}

		return attrs;
	}

	function createTween( value, prop, animation ) {
		var tween,
			collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
			index = 0,
			length = collection.length;
		for ( ; index < length; index++ ) {
			if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {

				// We're done with this property
				return tween;
			}
		}
	}

	function defaultPrefilter( elem, props, opts ) {
		var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
			isBox = "width" in props || "height" in props,
			anim = this,
			orig = {},
			style = elem.style,
			hidden = elem.nodeType && isHiddenWithinTree( elem ),
			dataShow = dataPriv.get( elem, "fxshow" );

		// Queue-skipping animations hijack the fx hooks
		if ( !opts.queue ) {
			hooks = jQuery._queueHooks( elem, "fx" );
			if ( hooks.unqueued == null ) {
				hooks.unqueued = 0;
				oldfire = hooks.empty.fire;
				hooks.empty.fire = function() {
					if ( !hooks.unqueued ) {
						oldfire();
					}
				};
			}
			hooks.unqueued++;

			anim.always( function() {

				// Ensure the complete handler is called before this completes
				anim.always( function() {
					hooks.unqueued--;
					if ( !jQuery.queue( elem, "fx" ).length ) {
						hooks.empty.fire();
					}
				} );
			} );
		}

		// Detect show/hide animations
		for ( prop in props ) {
			value = props[ prop ];
			if ( rfxtypes.test( value ) ) {
				delete props[ prop ];
				toggle = toggle || value === "toggle";
				if ( value === ( hidden ? "hide" : "show" ) ) {

					// Pretend to be hidden if this is a "show" and
					// there is still data from a stopped show/hide
					if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
						hidden = true;

					// Ignore all other no-op show/hide data
					} else {
						continue;
					}
				}
				orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
			}
		}

		// Bail out if this is a no-op like .hide().hide()
		propTween = !jQuery.isEmptyObject( props );
		if ( !propTween && jQuery.isEmptyObject( orig ) ) {
			return;
		}

		// Restrict "overflow" and "display" styles during box animations
		if ( isBox && elem.nodeType === 1 ) {

			// Support: IE <=9 - 11, Edge 12 - 15
			// Record all 3 overflow attributes because IE does not infer the shorthand
			// from identically-valued overflowX and overflowY and Edge just mirrors
			// the overflowX value there.
			opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];

			// Identify a display type, preferring old show/hide data over the CSS cascade
			restoreDisplay = dataShow && dataShow.display;
			if ( restoreDisplay == null ) {
				restoreDisplay = dataPriv.get( elem, "display" );
			}
			display = jQuery.css( elem, "display" );
			if ( display === "none" ) {
				if ( restoreDisplay ) {
					display = restoreDisplay;
				} else {

					// Get nonempty value(s) by temporarily forcing visibility
					showHide( [ elem ], true );
					restoreDisplay = elem.style.display || restoreDisplay;
					display = jQuery.css( elem, "display" );
					showHide( [ elem ] );
				}
			}

			// Animate inline elements as inline-block
			if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
				if ( jQuery.css( elem, "float" ) === "none" ) {

					// Restore the original display value at the end of pure show/hide animations
					if ( !propTween ) {
						anim.done( function() {
							style.display = restoreDisplay;
						} );
						if ( restoreDisplay == null ) {
							display = style.display;
							restoreDisplay = display === "none" ? "" : display;
						}
					}
					style.display = "inline-block";
				}
			}
		}

		if ( opts.overflow ) {
			style.overflow = "hidden";
			anim.always( function() {
				style.overflow = opts.overflow[ 0 ];
				style.overflowX = opts.overflow[ 1 ];
				style.overflowY = opts.overflow[ 2 ];
			} );
		}

		// Implement show/hide animations
		propTween = false;
		for ( prop in orig ) {

			// General show/hide setup for this element animation
			if ( !propTween ) {
				if ( dataShow ) {
					if ( "hidden" in dataShow ) {
						hidden = dataShow.hidden;
					}
				} else {
					dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
				}

				// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
				if ( toggle ) {
					dataShow.hidden = !hidden;
				}

				// Show elements before animating them
				if ( hidden ) {
					showHide( [ elem ], true );
				}

				/* eslint-disable no-loop-func */

				anim.done( function() {

				/* eslint-enable no-loop-func */

					// The final step of a "hide" animation is actually hiding the element
					if ( !hidden ) {
						showHide( [ elem ] );
					}
					dataPriv.remove( elem, "fxshow" );
					for ( prop in orig ) {
						jQuery.style( elem, prop, orig[ prop ] );
					}
				} );
			}

			// Per-property setup
			propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
			if ( !( prop in dataShow ) ) {
				dataShow[ prop ] = propTween.start;
				if ( hidden ) {
					propTween.end = propTween.start;
					propTween.start = 0;
				}
			}
		}
	}

	function propFilter( props, specialEasing ) {
		var index, name, easing, value, hooks;

		// camelCase, specialEasing and expand cssHook pass
		for ( index in props ) {
			name = camelCase( index );
			easing = specialEasing[ name ];
			value = props[ index ];
			if ( Array.isArray( value ) ) {
				easing = value[ 1 ];
				value = props[ index ] = value[ 0 ];
			}

			if ( index !== name ) {
				props[ name ] = value;
				delete props[ index ];
			}

			hooks = jQuery.cssHooks[ name ];
			if ( hooks && "expand" in hooks ) {
				value = hooks.expand( value );
				delete props[ name ];

				// Not quite $.extend, this won't overwrite existing keys.
				// Reusing 'index' because we have the correct "name"
				for ( index in value ) {
					if ( !( index in props ) ) {
						props[ index ] = value[ index ];
						specialEasing[ index ] = easing;
					}
				}
			} else {
				specialEasing[ name ] = easing;
			}
		}
	}

	function Animation( elem, properties, options ) {
		var result,
			stopped,
			index = 0,
			length = Animation.prefilters.length,
			deferred = jQuery.Deferred().always( function() {

				// Don't match elem in the :animated selector
				delete tick.elem;
			} ),
			tick = function() {
				if ( stopped ) {
					return false;
				}
				var currentTime = fxNow || createFxNow(),
					remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),

					// Support: Android 2.3 only
					// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
					temp = remaining / animation.duration || 0,
					percent = 1 - temp,
					index = 0,
					length = animation.tweens.length;

				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( percent );
				}

				deferred.notifyWith( elem, [ animation, percent, remaining ] );

				// If there's more to do, yield
				if ( percent < 1 && length ) {
					return remaining;
				}

				// If this was an empty animation, synthesize a final progress notification
				if ( !length ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
				}

				// Resolve the animation and report its conclusion
				deferred.resolveWith( elem, [ animation ] );
				return false;
			},
			animation = deferred.promise( {
				elem: elem,
				props: jQuery.extend( {}, properties ),
				opts: jQuery.extend( true, {
					specialEasing: {},
					easing: jQuery.easing._default
				}, options ),
				originalProperties: properties,
				originalOptions: options,
				startTime: fxNow || createFxNow(),
				duration: options.duration,
				tweens: [],
				createTween: function( prop, end ) {
					var tween = jQuery.Tween( elem, animation.opts, prop, end,
							animation.opts.specialEasing[ prop ] || animation.opts.easing );
					animation.tweens.push( tween );
					return tween;
				},
				stop: function( gotoEnd ) {
					var index = 0,

						// If we are going to the end, we want to run all the tweens
						// otherwise we skip this part
						length = gotoEnd ? animation.tweens.length : 0;
					if ( stopped ) {
						return this;
					}
					stopped = true;
					for ( ; index < length; index++ ) {
						animation.tweens[ index ].run( 1 );
					}

					// Resolve when we played the last frame; otherwise, reject
					if ( gotoEnd ) {
						deferred.notifyWith( elem, [ animation, 1, 0 ] );
						deferred.resolveWith( elem, [ animation, gotoEnd ] );
					} else {
						deferred.rejectWith( elem, [ animation, gotoEnd ] );
					}
					return this;
				}
			} ),
			props = animation.props;

		propFilter( props, animation.opts.specialEasing );

		for ( ; index < length; index++ ) {
			result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
			if ( result ) {
				if ( isFunction( result.stop ) ) {
					jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
						result.stop.bind( result );
				}
				return result;
			}
		}

		jQuery.map( props, createTween, animation );

		if ( isFunction( animation.opts.start ) ) {
			animation.opts.start.call( elem, animation );
		}

		// Attach callbacks from options
		animation
			.progress( animation.opts.progress )
			.done( animation.opts.done, animation.opts.complete )
			.fail( animation.opts.fail )
			.always( animation.opts.always );

		jQuery.fx.timer(
			jQuery.extend( tick, {
				elem: elem,
				anim: animation,
				queue: animation.opts.queue
			} )
		);

		return animation;
	}

	jQuery.Animation = jQuery.extend( Animation, {

		tweeners: {
			"*": [ function( prop, value ) {
				var tween = this.createTween( prop, value );
				adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
				return tween;
			} ]
		},

		tweener: function( props, callback ) {
			if ( isFunction( props ) ) {
				callback = props;
				props = [ "*" ];
			} else {
				props = props.match( rnothtmlwhite );
			}

			var prop,
				index = 0,
				length = props.length;

			for ( ; index < length; index++ ) {
				prop = props[ index ];
				Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
				Animation.tweeners[ prop ].unshift( callback );
			}
		},

		prefilters: [ defaultPrefilter ],

		prefilter: function( callback, prepend ) {
			if ( prepend ) {
				Animation.prefilters.unshift( callback );
			} else {
				Animation.prefilters.push( callback );
			}
		}
	} );

	jQuery.speed = function( speed, easing, fn ) {
		var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
			complete: fn || !fn && easing ||
				isFunction( speed ) && speed,
			duration: speed,
			easing: fn && easing || easing && !isFunction( easing ) && easing
		};

		// Go to the end state if fx are off
		if ( jQuery.fx.off ) {
			opt.duration = 0;

		} else {
			if ( typeof opt.duration !== "number" ) {
				if ( opt.duration in jQuery.fx.speeds ) {
					opt.duration = jQuery.fx.speeds[ opt.duration ];

				} else {
					opt.duration = jQuery.fx.speeds._default;
				}
			}
		}

		// Normalize opt.queue - true/undefined/null -> "fx"
		if ( opt.queue == null || opt.queue === true ) {
			opt.queue = "fx";
		}

		// Queueing
		opt.old = opt.complete;

		opt.complete = function() {
			if ( isFunction( opt.old ) ) {
				opt.old.call( this );
			}

			if ( opt.queue ) {
				jQuery.dequeue( this, opt.queue );
			}
		};

		return opt;
	};

	jQuery.fn.extend( {
		fadeTo: function( speed, to, easing, callback ) {

			// Show any hidden elements after setting opacity to 0
			return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()

				// Animate to the value specified
				.end().animate( { opacity: to }, speed, easing, callback );
		},
		animate: function( prop, speed, easing, callback ) {
			var empty = jQuery.isEmptyObject( prop ),
				optall = jQuery.speed( speed, easing, callback ),
				doAnimation = function() {

					// Operate on a copy of prop so per-property easing won't be lost
					var anim = Animation( this, jQuery.extend( {}, prop ), optall );

					// Empty animations, or finishing resolves immediately
					if ( empty || dataPriv.get( this, "finish" ) ) {
						anim.stop( true );
					}
				};
				doAnimation.finish = doAnimation;

			return empty || optall.queue === false ?
				this.each( doAnimation ) :
				this.queue( optall.queue, doAnimation );
		},
		stop: function( type, clearQueue, gotoEnd ) {
			var stopQueue = function( hooks ) {
				var stop = hooks.stop;
				delete hooks.stop;
				stop( gotoEnd );
			};

			if ( typeof type !== "string" ) {
				gotoEnd = clearQueue;
				clearQueue = type;
				type = undefined;
			}
			if ( clearQueue && type !== false ) {
				this.queue( type || "fx", [] );
			}

			return this.each( function() {
				var this$1 = this;

				var dequeue = true,
					index = type != null && type + "queueHooks",
					timers = jQuery.timers,
					data = dataPriv.get( this );

				if ( index ) {
					if ( data[ index ] && data[ index ].stop ) {
						stopQueue( data[ index ] );
					}
				} else {
					for ( index in data ) {
						if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
							stopQueue( data[ index ] );
						}
					}
				}

				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this$1 &&
						( type == null || timers[ index ].queue === type ) ) {

						timers[ index ].anim.stop( gotoEnd );
						dequeue = false;
						timers.splice( index, 1 );
					}
				}

				// Start the next in the queue if the last step wasn't forced.
				// Timers currently will call their complete callbacks, which
				// will dequeue but only if they were gotoEnd.
				if ( dequeue || !gotoEnd ) {
					jQuery.dequeue( this, type );
				}
			} );
		},
		finish: function( type ) {
			if ( type !== false ) {
				type = type || "fx";
			}
			return this.each( function() {
				var this$1 = this;

				var index,
					data = dataPriv.get( this ),
					queue = data[ type + "queue" ],
					hooks = data[ type + "queueHooks" ],
					timers = jQuery.timers,
					length = queue ? queue.length : 0;

				// Enable finishing flag on private data
				data.finish = true;

				// Empty the queue first
				jQuery.queue( this, type, [] );

				if ( hooks && hooks.stop ) {
					hooks.stop.call( this, true );
				}

				// Look for any active animations, and finish them
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this$1 && timers[ index ].queue === type ) {
						timers[ index ].anim.stop( true );
						timers.splice( index, 1 );
					}
				}

				// Look for any animations in the old queue and finish them
				for ( index = 0; index < length; index++ ) {
					if ( queue[ index ] && queue[ index ].finish ) {
						queue[ index ].finish.call( this$1 );
					}
				}

				// Turn off finishing flag
				delete data.finish;
			} );
		}
	} );

	jQuery.each( [ "toggle", "show", "hide" ], function( i, name ) {
		var cssFn = jQuery.fn[ name ];
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return speed == null || typeof speed === "boolean" ?
				cssFn.apply( this, arguments ) :
				this.animate( genFx( name, true ), speed, easing, callback );
		};
	} );

	// Generate shortcuts for custom animations
	jQuery.each( {
		slideDown: genFx( "show" ),
		slideUp: genFx( "hide" ),
		slideToggle: genFx( "toggle" ),
		fadeIn: { opacity: "show" },
		fadeOut: { opacity: "hide" },
		fadeToggle: { opacity: "toggle" }
	}, function( name, props ) {
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return this.animate( props, speed, easing, callback );
		};
	} );

	jQuery.timers = [];
	jQuery.fx.tick = function() {
		var timer,
			i = 0,
			timers = jQuery.timers;

		fxNow = Date.now();

		for ( ; i < timers.length; i++ ) {
			timer = timers[ i ];

			// Run the timer and safely remove it when done (allowing for external removal)
			if ( !timer() && timers[ i ] === timer ) {
				timers.splice( i--, 1 );
			}
		}

		if ( !timers.length ) {
			jQuery.fx.stop();
		}
		fxNow = undefined;
	};

	jQuery.fx.timer = function( timer ) {
		jQuery.timers.push( timer );
		jQuery.fx.start();
	};

	jQuery.fx.interval = 13;
	jQuery.fx.start = function() {
		if ( inProgress ) {
			return;
		}

		inProgress = true;
		schedule();
	};

	jQuery.fx.stop = function() {
		inProgress = null;
	};

	jQuery.fx.speeds = {
		slow: 600,
		fast: 200,

		// Default speed
		_default: 400
	};


	// Based off of the plugin by Clint Helfers, with permission.
	// https://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
	jQuery.fn.delay = function( time, type ) {
		time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
		type = type || "fx";

		return this.queue( type, function( next, hooks ) {
			var timeout = window.setTimeout( next, time );
			hooks.stop = function() {
				window.clearTimeout( timeout );
			};
		} );
	};


	( function() {
		var input = document.createElement( "input" ),
			select = document.createElement( "select" ),
			opt = select.appendChild( document.createElement( "option" ) );

		input.type = "checkbox";

		// Support: Android <=4.3 only
		// Default value for a checkbox should be "on"
		support.checkOn = input.value !== "";

		// Support: IE <=11 only
		// Must access selectedIndex to make default options select
		support.optSelected = opt.selected;

		// Support: IE <=11 only
		// An input loses its value after becoming a radio
		input = document.createElement( "input" );
		input.value = "t";
		input.type = "radio";
		support.radioValue = input.value === "t";
	} )();


	var boolHook,
		attrHandle = jQuery.expr.attrHandle;

	jQuery.fn.extend( {
		attr: function( name, value ) {
			return access( this, jQuery.attr, name, value, arguments.length > 1 );
		},

		removeAttr: function( name ) {
			return this.each( function() {
				jQuery.removeAttr( this, name );
			} );
		}
	} );

	jQuery.extend( {
		attr: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;

			// Don't get/set attributes on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}

			// Fallback to prop when attributes are not supported
			if ( typeof elem.getAttribute === "undefined" ) {
				return jQuery.prop( elem, name, value );
			}

			// Attribute hooks are determined by the lowercase version
			// Grab necessary hook if one is defined
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
				hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
					( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
			}

			if ( value !== undefined ) {
				if ( value === null ) {
					jQuery.removeAttr( elem, name );
					return;
				}

				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}

				elem.setAttribute( name, value + "" );
				return value;
			}

			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}

			ret = jQuery.find.attr( elem, name );

			// Non-existent attributes return null, we normalize to undefined
			return ret == null ? undefined : ret;
		},

		attrHooks: {
			type: {
				set: function( elem, value ) {
					if ( !support.radioValue && value === "radio" &&
						nodeName( elem, "input" ) ) {
						var val = elem.value;
						elem.setAttribute( "type", value );
						if ( val ) {
							elem.value = val;
						}
						return value;
					}
				}
			}
		},

		removeAttr: function( elem, value ) {
			var name,
				i = 0,

				// Attribute names can contain non-HTML whitespace characters
				// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
				attrNames = value && value.match( rnothtmlwhite );

			if ( attrNames && elem.nodeType === 1 ) {
				while ( ( name = attrNames[ i++ ] ) ) {
					elem.removeAttribute( name );
				}
			}
		}
	} );

	// Hooks for boolean attributes
	boolHook = {
		set: function( elem, value, name ) {
			if ( value === false ) {

				// Remove boolean attributes when set to false
				jQuery.removeAttr( elem, name );
			} else {
				elem.setAttribute( name, name );
			}
			return name;
		}
	};

	jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( i, name ) {
		var getter = attrHandle[ name ] || jQuery.find.attr;

		attrHandle[ name ] = function( elem, name, isXML ) {
			var ret, handle,
				lowercaseName = name.toLowerCase();

			if ( !isXML ) {

				// Avoid an infinite loop by temporarily removing this function from the getter
				handle = attrHandle[ lowercaseName ];
				attrHandle[ lowercaseName ] = ret;
				ret = getter( elem, name, isXML ) != null ?
					lowercaseName :
					null;
				attrHandle[ lowercaseName ] = handle;
			}
			return ret;
		};
	} );




	var rfocusable = /^(?:input|select|textarea|button)$/i,
		rclickable = /^(?:a|area)$/i;

	jQuery.fn.extend( {
		prop: function( name, value ) {
			return access( this, jQuery.prop, name, value, arguments.length > 1 );
		},

		removeProp: function( name ) {
			return this.each( function() {
				delete this[ jQuery.propFix[ name ] || name ];
			} );
		}
	} );

	jQuery.extend( {
		prop: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;

			// Don't get/set properties on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}

			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {

				// Fix name and attach hooks
				name = jQuery.propFix[ name ] || name;
				hooks = jQuery.propHooks[ name ];
			}

			if ( value !== undefined ) {
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}

				return ( elem[ name ] = value );
			}

			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}

			return elem[ name ];
		},

		propHooks: {
			tabIndex: {
				get: function( elem ) {

					// Support: IE <=9 - 11 only
					// elem.tabIndex doesn't always return the
					// correct value when it hasn't been explicitly set
					// https://web.archive.org/web/20141116233347/http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
					// Use proper attribute retrieval(#12072)
					var tabindex = jQuery.find.attr( elem, "tabindex" );

					if ( tabindex ) {
						return parseInt( tabindex, 10 );
					}

					if (
						rfocusable.test( elem.nodeName ) ||
						rclickable.test( elem.nodeName ) &&
						elem.href
					) {
						return 0;
					}

					return -1;
				}
			}
		},

		propFix: {
			"for": "htmlFor",
			"class": "className"
		}
	} );

	// Support: IE <=11 only
	// Accessing the selectedIndex property
	// forces the browser to respect setting selected
	// on the option
	// The getter ensures a default option is selected
	// when in an optgroup
	// eslint rule "no-unused-expressions" is disabled for this code
	// since it considers such accessions noop
	if ( !support.optSelected ) {
		jQuery.propHooks.selected = {
			get: function( elem ) {

				/* eslint no-unused-expressions: "off" */

				var parent = elem.parentNode;
				if ( parent && parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
				return null;
			},
			set: function( elem ) {

				/* eslint no-unused-expressions: "off" */

				var parent = elem.parentNode;
				if ( parent ) {
					parent.selectedIndex;

					if ( parent.parentNode ) {
						parent.parentNode.selectedIndex;
					}
				}
			}
		};
	}

	jQuery.each( [
		"tabIndex",
		"readOnly",
		"maxLength",
		"cellSpacing",
		"cellPadding",
		"rowSpan",
		"colSpan",
		"useMap",
		"frameBorder",
		"contentEditable"
	], function() {
		jQuery.propFix[ this.toLowerCase() ] = this;
	} );




		// Strip and collapse whitespace according to HTML spec
		// https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
		function stripAndCollapse( value ) {
			var tokens = value.match( rnothtmlwhite ) || [];
			return tokens.join( " " );
		}


	function getClass( elem ) {
		return elem.getAttribute && elem.getAttribute( "class" ) || "";
	}

	function classesToArray( value ) {
		if ( Array.isArray( value ) ) {
			return value;
		}
		if ( typeof value === "string" ) {
			return value.match( rnothtmlwhite ) || [];
		}
		return [];
	}

	jQuery.fn.extend( {
		addClass: function( value ) {
			var classes, elem, cur, curValue, clazz, j, finalValue,
				i = 0;

			if ( isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
				} );
			}

			classes = classesToArray( value );

			if ( classes.length ) {
				while ( ( elem = this[ i++ ] ) ) {
					curValue = getClass( elem );
					cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

					if ( cur ) {
						j = 0;
						while ( ( clazz = classes[ j++ ] ) ) {
							if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
								cur += clazz + " ";
							}
						}

						// Only assign if different to avoid unneeded rendering.
						finalValue = stripAndCollapse( cur );
						if ( curValue !== finalValue ) {
							elem.setAttribute( "class", finalValue );
						}
					}
				}
			}

			return this;
		},

		removeClass: function( value ) {
			var classes, elem, cur, curValue, clazz, j, finalValue,
				i = 0;

			if ( isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
				} );
			}

			if ( !arguments.length ) {
				return this.attr( "class", "" );
			}

			classes = classesToArray( value );

			if ( classes.length ) {
				while ( ( elem = this[ i++ ] ) ) {
					curValue = getClass( elem );

					// This expression is here for better compressibility (see addClass)
					cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

					if ( cur ) {
						j = 0;
						while ( ( clazz = classes[ j++ ] ) ) {

							// Remove *all* instances
							while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
								cur = cur.replace( " " + clazz + " ", " " );
							}
						}

						// Only assign if different to avoid unneeded rendering.
						finalValue = stripAndCollapse( cur );
						if ( curValue !== finalValue ) {
							elem.setAttribute( "class", finalValue );
						}
					}
				}
			}

			return this;
		},

		toggleClass: function( value, stateVal ) {
			var type = typeof value,
				isValidValue = type === "string" || Array.isArray( value );

			if ( typeof stateVal === "boolean" && isValidValue ) {
				return stateVal ? this.addClass( value ) : this.removeClass( value );
			}

			if ( isFunction( value ) ) {
				return this.each( function( i ) {
					jQuery( this ).toggleClass(
						value.call( this, i, getClass( this ), stateVal ),
						stateVal
					);
				} );
			}

			return this.each( function() {
				var className, i, self, classNames;

				if ( isValidValue ) {

					// Toggle individual class names
					i = 0;
					self = jQuery( this );
					classNames = classesToArray( value );

					while ( ( className = classNames[ i++ ] ) ) {

						// Check each className given, space separated list
						if ( self.hasClass( className ) ) {
							self.removeClass( className );
						} else {
							self.addClass( className );
						}
					}

				// Toggle whole class name
				} else if ( value === undefined || type === "boolean" ) {
					className = getClass( this );
					if ( className ) {

						// Store className if set
						dataPriv.set( this, "__className__", className );
					}

					// If the element has a class name or if we're passed `false`,
					// then remove the whole classname (if there was one, the above saved it).
					// Otherwise bring back whatever was previously saved (if anything),
					// falling back to the empty string if nothing was stored.
					if ( this.setAttribute ) {
						this.setAttribute( "class",
							className || value === false ?
							"" :
							dataPriv.get( this, "__className__" ) || ""
						);
					}
				}
			} );
		},

		hasClass: function( selector ) {
			var className, elem,
				i = 0;

			className = " " + selector + " ";
			while ( ( elem = this[ i++ ] ) ) {
				if ( elem.nodeType === 1 &&
					( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
						return true;
				}
			}

			return false;
		}
	} );




	var rreturn = /\r/g;

	jQuery.fn.extend( {
		val: function( value ) {
			var hooks, ret, valueIsFunction,
				elem = this[ 0 ];

			if ( !arguments.length ) {
				if ( elem ) {
					hooks = jQuery.valHooks[ elem.type ] ||
						jQuery.valHooks[ elem.nodeName.toLowerCase() ];

					if ( hooks &&
						"get" in hooks &&
						( ret = hooks.get( elem, "value" ) ) !== undefined
					) {
						return ret;
					}

					ret = elem.value;

					// Handle most common string cases
					if ( typeof ret === "string" ) {
						return ret.replace( rreturn, "" );
					}

					// Handle cases where value is null/undef or number
					return ret == null ? "" : ret;
				}

				return;
			}

			valueIsFunction = isFunction( value );

			return this.each( function( i ) {
				var val;

				if ( this.nodeType !== 1 ) {
					return;
				}

				if ( valueIsFunction ) {
					val = value.call( this, i, jQuery( this ).val() );
				} else {
					val = value;
				}

				// Treat null/undefined as ""; convert numbers to string
				if ( val == null ) {
					val = "";

				} else if ( typeof val === "number" ) {
					val += "";

				} else if ( Array.isArray( val ) ) {
					val = jQuery.map( val, function( value ) {
						return value == null ? "" : value + "";
					} );
				}

				hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];

				// If set returns undefined, fall back to normal setting
				if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
					this.value = val;
				}
			} );
		}
	} );

	jQuery.extend( {
		valHooks: {
			option: {
				get: function( elem ) {

					var val = jQuery.find.attr( elem, "value" );
					return val != null ?
						val :

						// Support: IE <=10 - 11 only
						// option.text throws exceptions (#14686, #14858)
						// Strip and collapse whitespace
						// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
						stripAndCollapse( jQuery.text( elem ) );
				}
			},
			select: {
				get: function( elem ) {
					var value, option, i,
						options = elem.options,
						index = elem.selectedIndex,
						one = elem.type === "select-one",
						values = one ? null : [],
						max = one ? index + 1 : options.length;

					if ( index < 0 ) {
						i = max;

					} else {
						i = one ? index : 0;
					}

					// Loop through all the selected options
					for ( ; i < max; i++ ) {
						option = options[ i ];

						// Support: IE <=9 only
						// IE8-9 doesn't update selected after form reset (#2551)
						if ( ( option.selected || i === index ) &&

								// Don't return options that are disabled or in a disabled optgroup
								!option.disabled &&
								( !option.parentNode.disabled ||
									!nodeName( option.parentNode, "optgroup" ) ) ) {

							// Get the specific value for the option
							value = jQuery( option ).val();

							// We don't need an array for one selects
							if ( one ) {
								return value;
							}

							// Multi-Selects return an array
							values.push( value );
						}
					}

					return values;
				},

				set: function( elem, value ) {
					var optionSet, option,
						options = elem.options,
						values = jQuery.makeArray( value ),
						i = options.length;

					while ( i-- ) {
						option = options[ i ];

						/* eslint-disable no-cond-assign */

						if ( option.selected =
							jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
						) {
							optionSet = true;
						}

						/* eslint-enable no-cond-assign */
					}

					// Force browsers to behave consistently when non-matching value is set
					if ( !optionSet ) {
						elem.selectedIndex = -1;
					}
					return values;
				}
			}
		}
	} );

	// Radios and checkboxes getter/setter
	jQuery.each( [ "radio", "checkbox" ], function() {
		jQuery.valHooks[ this ] = {
			set: function( elem, value ) {
				if ( Array.isArray( value ) ) {
					return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
				}
			}
		};
		if ( !support.checkOn ) {
			jQuery.valHooks[ this ].get = function( elem ) {
				return elem.getAttribute( "value" ) === null ? "on" : elem.value;
			};
		}
	} );




	// Return jQuery for attributes-only inclusion


	support.focusin = "onfocusin" in window;


	var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
		stopPropagationCallback = function( e ) {
			e.stopPropagation();
		};

	jQuery.extend( jQuery.event, {

		trigger: function( event, data, elem, onlyHandlers ) {

			var i, cur, tmp, bubbleType, ontype, handle, special, lastElement,
				eventPath = [ elem || document ],
				type = hasOwn.call( event, "type" ) ? event.type : event,
				namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];

			cur = lastElement = tmp = elem = elem || document;

			// Don't do events on text and comment nodes
			if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
				return;
			}

			// focus/blur morphs to focusin/out; ensure we're not firing them right now
			if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
				return;
			}

			if ( type.indexOf( "." ) > -1 ) {

				// Namespaced trigger; create a regexp to match event type in handle()
				namespaces = type.split( "." );
				type = namespaces.shift();
				namespaces.sort();
			}
			ontype = type.indexOf( ":" ) < 0 && "on" + type;

			// Caller can pass in a jQuery.Event object, Object, or just an event type string
			event = event[ jQuery.expando ] ?
				event :
				new jQuery.Event( type, typeof event === "object" && event );

			// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
			event.isTrigger = onlyHandlers ? 2 : 3;
			event.namespace = namespaces.join( "." );
			event.rnamespace = event.namespace ?
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
				null;

			// Clean up the event in case it is being reused
			event.result = undefined;
			if ( !event.target ) {
				event.target = elem;
			}

			// Clone any incoming data and prepend the event, creating the handler arg list
			data = data == null ?
				[ event ] :
				jQuery.makeArray( data, [ event ] );

			// Allow special events to draw outside the lines
			special = jQuery.event.special[ type ] || {};
			if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
				return;
			}

			// Determine event propagation path in advance, per W3C events spec (#9951)
			// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
			if ( !onlyHandlers && !special.noBubble && !isWindow( elem ) ) {

				bubbleType = special.delegateType || type;
				if ( !rfocusMorph.test( bubbleType + type ) ) {
					cur = cur.parentNode;
				}
				for ( ; cur; cur = cur.parentNode ) {
					eventPath.push( cur );
					tmp = cur;
				}

				// Only add window if we got to document (e.g., not plain obj or detached DOM)
				if ( tmp === ( elem.ownerDocument || document ) ) {
					eventPath.push( tmp.defaultView || tmp.parentWindow || window );
				}
			}

			// Fire handlers on the event path
			i = 0;
			while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
				lastElement = cur;
				event.type = i > 1 ?
					bubbleType :
					special.bindType || type;

				// jQuery handler
				handle = ( dataPriv.get( cur, "events" ) || {} )[ event.type ] &&
					dataPriv.get( cur, "handle" );
				if ( handle ) {
					handle.apply( cur, data );
				}

				// Native handler
				handle = ontype && cur[ ontype ];
				if ( handle && handle.apply && acceptData( cur ) ) {
					event.result = handle.apply( cur, data );
					if ( event.result === false ) {
						event.preventDefault();
					}
				}
			}
			event.type = type;

			// If nobody prevented the default action, do it now
			if ( !onlyHandlers && !event.isDefaultPrevented() ) {

				if ( ( !special._default ||
					special._default.apply( eventPath.pop(), data ) === false ) &&
					acceptData( elem ) ) {

					// Call a native DOM method on the target with the same name as the event.
					// Don't do default actions on window, that's where global variables be (#6170)
					if ( ontype && isFunction( elem[ type ] ) && !isWindow( elem ) ) {

						// Don't re-trigger an onFOO event when we call its FOO() method
						tmp = elem[ ontype ];

						if ( tmp ) {
							elem[ ontype ] = null;
						}

						// Prevent re-triggering of the same event, since we already bubbled it above
						jQuery.event.triggered = type;

						if ( event.isPropagationStopped() ) {
							lastElement.addEventListener( type, stopPropagationCallback );
						}

						elem[ type ]();

						if ( event.isPropagationStopped() ) {
							lastElement.removeEventListener( type, stopPropagationCallback );
						}

						jQuery.event.triggered = undefined;

						if ( tmp ) {
							elem[ ontype ] = tmp;
						}
					}
				}
			}

			return event.result;
		},

		// Piggyback on a donor event to simulate a different one
		// Used only for `focus(in | out)` events
		simulate: function( type, elem, event ) {
			var e = jQuery.extend(
				new jQuery.Event(),
				event,
				{
					type: type,
					isSimulated: true
				}
			);

			jQuery.event.trigger( e, null, elem );
		}

	} );

	jQuery.fn.extend( {

		trigger: function( type, data ) {
			return this.each( function() {
				jQuery.event.trigger( type, data, this );
			} );
		},
		triggerHandler: function( type, data ) {
			var elem = this[ 0 ];
			if ( elem ) {
				return jQuery.event.trigger( type, data, elem, true );
			}
		}
	} );


	// Support: Firefox <=44
	// Firefox doesn't have focus(in | out) events
	// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
	//
	// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
	// focus(in | out) events fire after focus & blur events,
	// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
	// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
	if ( !support.focusin ) {
		jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {

			// Attach a single capturing handler on the document while someone wants focusin/focusout
			var handler = function( event ) {
				jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
			};

			jQuery.event.special[ fix ] = {
				setup: function() {
					var doc = this.ownerDocument || this,
						attaches = dataPriv.access( doc, fix );

					if ( !attaches ) {
						doc.addEventListener( orig, handler, true );
					}
					dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
				},
				teardown: function() {
					var doc = this.ownerDocument || this,
						attaches = dataPriv.access( doc, fix ) - 1;

					if ( !attaches ) {
						doc.removeEventListener( orig, handler, true );
						dataPriv.remove( doc, fix );

					} else {
						dataPriv.access( doc, fix, attaches );
					}
				}
			};
		} );
	}
	var location = window.location;

	var nonce = Date.now();

	var rquery = ( /\?/ );



	// Cross-browser xml parsing
	jQuery.parseXML = function( data ) {
		var xml;
		if ( !data || typeof data !== "string" ) {
			return null;
		}

		// Support: IE 9 - 11 only
		// IE throws on parseFromString with invalid input.
		try {
			xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
		} catch ( e ) {
			xml = undefined;
		}

		if ( !xml || xml.getElementsByTagName( "parsererror" ).length ) {
			jQuery.error( "Invalid XML: " + data );
		}
		return xml;
	};


	var
		rbracket = /\[\]$/,
		rCRLF = /\r?\n/g,
		rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
		rsubmittable = /^(?:input|select|textarea|keygen)/i;

	function buildParams( prefix, obj, traditional, add ) {
		var name;

		if ( Array.isArray( obj ) ) {

			// Serialize array item.
			jQuery.each( obj, function( i, v ) {
				if ( traditional || rbracket.test( prefix ) ) {

					// Treat each array item as a scalar.
					add( prefix, v );

				} else {

					// Item is non-scalar (array or object), encode its numeric index.
					buildParams(
						prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
						v,
						traditional,
						add
					);
				}
			} );

		} else if ( !traditional && toType( obj ) === "object" ) {

			// Serialize object item.
			for ( name in obj ) {
				buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
			}

		} else {

			// Serialize scalar item.
			add( prefix, obj );
		}
	}

	// Serialize an array of form elements or a set of
	// key/values into a query string
	jQuery.param = function( a, traditional ) {
		var prefix,
			s = [],
			add = function( key, valueOrFunction ) {

				// If value is a function, invoke it and use its return value
				var value = isFunction( valueOrFunction ) ?
					valueOrFunction() :
					valueOrFunction;

				s[ s.length ] = encodeURIComponent( key ) + "=" +
					encodeURIComponent( value == null ? "" : value );
			};

		// If an array was passed in, assume that it is an array of form elements.
		if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {

			// Serialize the form elements
			jQuery.each( a, function() {
				add( this.name, this.value );
			} );

		} else {

			// If traditional, encode the "old" way (the way 1.3.2 or older
			// did it), otherwise encode params recursively.
			for ( prefix in a ) {
				buildParams( prefix, a[ prefix ], traditional, add );
			}
		}

		// Return the resulting serialization
		return s.join( "&" );
	};

	jQuery.fn.extend( {
		serialize: function() {
			return jQuery.param( this.serializeArray() );
		},
		serializeArray: function() {
			return this.map( function() {

				// Can add propHook for "elements" to filter or add form elements
				var elements = jQuery.prop( this, "elements" );
				return elements ? jQuery.makeArray( elements ) : this;
			} )
			.filter( function() {
				var type = this.type;

				// Use .is( ":disabled" ) so that fieldset[disabled] works
				return this.name && !jQuery( this ).is( ":disabled" ) &&
					rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
					( this.checked || !rcheckableType.test( type ) );
			} )
			.map( function( i, elem ) {
				var val = jQuery( this ).val();

				if ( val == null ) {
					return null;
				}

				if ( Array.isArray( val ) ) {
					return jQuery.map( val, function( val ) {
						return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
					} );
				}

				return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
			} ).get();
		}
	} );


	var
		r20 = /%20/g,
		rhash = /#.*$/,
		rantiCache = /([?&])_=[^&]*/,
		rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,

		// #7653, #8125, #8152: local protocol detection
		rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
		rnoContent = /^(?:GET|HEAD)$/,
		rprotocol = /^\/\//,

		/* Prefilters
		 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
		 * 2) These are called:
		 *    - BEFORE asking for a transport
		 *    - AFTER param serialization (s.data is a string if s.processData is true)
		 * 3) key is the dataType
		 * 4) the catchall symbol "*" can be used
		 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
		 */
		prefilters = {},

		/* Transports bindings
		 * 1) key is the dataType
		 * 2) the catchall symbol "*" can be used
		 * 3) selection will start with transport dataType and THEN go to "*" if needed
		 */
		transports = {},

		// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
		allTypes = "*/".concat( "*" ),

		// Anchor tag for parsing the document origin
		originAnchor = document.createElement( "a" );
		originAnchor.href = location.href;

	// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
	function addToPrefiltersOrTransports( structure ) {

		// dataTypeExpression is optional and defaults to "*"
		return function( dataTypeExpression, func ) {

			if ( typeof dataTypeExpression !== "string" ) {
				func = dataTypeExpression;
				dataTypeExpression = "*";
			}

			var dataType,
				i = 0,
				dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];

			if ( isFunction( func ) ) {

				// For each dataType in the dataTypeExpression
				while ( ( dataType = dataTypes[ i++ ] ) ) {

					// Prepend if requested
					if ( dataType[ 0 ] === "+" ) {
						dataType = dataType.slice( 1 ) || "*";
						( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );

					// Otherwise append
					} else {
						( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
					}
				}
			}
		};
	}

	// Base inspection function for prefilters and transports
	function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {

		var inspected = {},
			seekingTransport = ( structure === transports );

		function inspect( dataType ) {
			var selected;
			inspected[ dataType ] = true;
			jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
				var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
				if ( typeof dataTypeOrTransport === "string" &&
					!seekingTransport && !inspected[ dataTypeOrTransport ] ) {

					options.dataTypes.unshift( dataTypeOrTransport );
					inspect( dataTypeOrTransport );
					return false;
				} else if ( seekingTransport ) {
					return !( selected = dataTypeOrTransport );
				}
			} );
			return selected;
		}

		return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
	}

	// A special extend for ajax options
	// that takes "flat" options (not to be deep extended)
	// Fixes #9887
	function ajaxExtend( target, src ) {
		var key, deep,
			flatOptions = jQuery.ajaxSettings.flatOptions || {};

		for ( key in src ) {
			if ( src[ key ] !== undefined ) {
				( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
			}
		}
		if ( deep ) {
			jQuery.extend( true, target, deep );
		}

		return target;
	}

	/* Handles responses to an ajax request:
	 * - finds the right dataType (mediates between content-type and expected dataType)
	 * - returns the corresponding response
	 */
	function ajaxHandleResponses( s, jqXHR, responses ) {

		var ct, type, finalDataType, firstDataType,
			contents = s.contents,
			dataTypes = s.dataTypes;

		// Remove auto dataType and get content-type in the process
		while ( dataTypes[ 0 ] === "*" ) {
			dataTypes.shift();
			if ( ct === undefined ) {
				ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
			}
		}

		// Check if we're dealing with a known content-type
		if ( ct ) {
			for ( type in contents ) {
				if ( contents[ type ] && contents[ type ].test( ct ) ) {
					dataTypes.unshift( type );
					break;
				}
			}
		}

		// Check to see if we have a response for the expected dataType
		if ( dataTypes[ 0 ] in responses ) {
			finalDataType = dataTypes[ 0 ];
		} else {

			// Try convertible dataTypes
			for ( type in responses ) {
				if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
					finalDataType = type;
					break;
				}
				if ( !firstDataType ) {
					firstDataType = type;
				}
			}

			// Or just use first one
			finalDataType = finalDataType || firstDataType;
		}

		// If we found a dataType
		// We add the dataType to the list if needed
		// and return the corresponding response
		if ( finalDataType ) {
			if ( finalDataType !== dataTypes[ 0 ] ) {
				dataTypes.unshift( finalDataType );
			}
			return responses[ finalDataType ];
		}
	}

	/* Chain conversions given the request and the original response
	 * Also sets the responseXXX fields on the jqXHR instance
	 */
	function ajaxConvert( s, response, jqXHR, isSuccess ) {
		var conv2, current, conv, tmp, prev,
			converters = {},

			// Work with a copy of dataTypes in case we need to modify it for conversion
			dataTypes = s.dataTypes.slice();

		// Create converters map with lowercased keys
		if ( dataTypes[ 1 ] ) {
			for ( conv in s.converters ) {
				converters[ conv.toLowerCase() ] = s.converters[ conv ];
			}
		}

		current = dataTypes.shift();

		// Convert to each sequential dataType
		while ( current ) {

			if ( s.responseFields[ current ] ) {
				jqXHR[ s.responseFields[ current ] ] = response;
			}

			// Apply the dataFilter if provided
			if ( !prev && isSuccess && s.dataFilter ) {
				response = s.dataFilter( response, s.dataType );
			}

			prev = current;
			current = dataTypes.shift();

			if ( current ) {

				// There's only work to do if current dataType is non-auto
				if ( current === "*" ) {

					current = prev;

				// Convert response if prev dataType is non-auto and differs from current
				} else if ( prev !== "*" && prev !== current ) {

					// Seek a direct converter
					conv = converters[ prev + " " + current ] || converters[ "* " + current ];

					// If none found, seek a pair
					if ( !conv ) {
						for ( conv2 in converters ) {

							// If conv2 outputs current
							tmp = conv2.split( " " );
							if ( tmp[ 1 ] === current ) {

								// If prev can be converted to accepted input
								conv = converters[ prev + " " + tmp[ 0 ] ] ||
									converters[ "* " + tmp[ 0 ] ];
								if ( conv ) {

									// Condense equivalence converters
									if ( conv === true ) {
										conv = converters[ conv2 ];

									// Otherwise, insert the intermediate dataType
									} else if ( converters[ conv2 ] !== true ) {
										current = tmp[ 0 ];
										dataTypes.unshift( tmp[ 1 ] );
									}
									break;
								}
							}
						}
					}

					// Apply converter (if not an equivalence)
					if ( conv !== true ) {

						// Unless errors are allowed to bubble, catch and return them
						if ( conv && s.throws ) {
							response = conv( response );
						} else {
							try {
								response = conv( response );
							} catch ( e ) {
								return {
									state: "parsererror",
									error: conv ? e : "No conversion from " + prev + " to " + current
								};
							}
						}
					}
				}
			}
		}

		return { state: "success", data: response };
	}

	jQuery.extend( {

		// Counter for holding the number of active queries
		active: 0,

		// Last-Modified header cache for next request
		lastModified: {},
		etag: {},

		ajaxSettings: {
			url: location.href,
			type: "GET",
			isLocal: rlocalProtocol.test( location.protocol ),
			global: true,
			processData: true,
			async: true,
			contentType: "application/x-www-form-urlencoded; charset=UTF-8",

			/*
			timeout: 0,
			data: null,
			dataType: null,
			username: null,
			password: null,
			cache: null,
			throws: false,
			traditional: false,
			headers: {},
			*/

			accepts: {
				"*": allTypes,
				text: "text/plain",
				html: "text/html",
				xml: "application/xml, text/xml",
				json: "application/json, text/javascript"
			},

			contents: {
				xml: /\bxml\b/,
				html: /\bhtml/,
				json: /\bjson\b/
			},

			responseFields: {
				xml: "responseXML",
				text: "responseText",
				json: "responseJSON"
			},

			// Data converters
			// Keys separate source (or catchall "*") and destination types with a single space
			converters: {

				// Convert anything to text
				"* text": String,

				// Text to html (true = no transformation)
				"text html": true,

				// Evaluate text as a json expression
				"text json": JSON.parse,

				// Parse text as xml
				"text xml": jQuery.parseXML
			},

			// For options that shouldn't be deep extended:
			// you can add your own custom options here if
			// and when you create one that shouldn't be
			// deep extended (see ajaxExtend)
			flatOptions: {
				url: true,
				context: true
			}
		},

		// Creates a full fledged settings object into target
		// with both ajaxSettings and settings fields.
		// If target is omitted, writes into ajaxSettings.
		ajaxSetup: function( target, settings ) {
			return settings ?

				// Building a settings object
				ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :

				// Extending ajaxSettings
				ajaxExtend( jQuery.ajaxSettings, target );
		},

		ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
		ajaxTransport: addToPrefiltersOrTransports( transports ),

		// Main method
		ajax: function( url, options ) {

			// If url is an object, simulate pre-1.5 signature
			if ( typeof url === "object" ) {
				options = url;
				url = undefined;
			}

			// Force options to be an object
			options = options || {};

			var transport,

				// URL without anti-cache param
				cacheURL,

				// Response headers
				responseHeadersString,
				responseHeaders,

				// timeout handle
				timeoutTimer,

				// Url cleanup var
				urlAnchor,

				// Request state (becomes false upon send and true upon completion)
				completed,

				// To know if global events are to be dispatched
				fireGlobals,

				// Loop variable
				i,

				// uncached part of the url
				uncached,

				// Create the final options object
				s = jQuery.ajaxSetup( {}, options ),

				// Callbacks context
				callbackContext = s.context || s,

				// Context for global events is callbackContext if it is a DOM node or jQuery collection
				globalEventContext = s.context &&
					( callbackContext.nodeType || callbackContext.jquery ) ?
						jQuery( callbackContext ) :
						jQuery.event,

				// Deferreds
				deferred = jQuery.Deferred(),
				completeDeferred = jQuery.Callbacks( "once memory" ),

				// Status-dependent callbacks
				statusCode = s.statusCode || {},

				// Headers (they are sent all at once)
				requestHeaders = {},
				requestHeadersNames = {},

				// Default abort message
				strAbort = "canceled",

				// Fake xhr
				jqXHR = {
					readyState: 0,

					// Builds headers hashtable if needed
					getResponseHeader: function( key ) {
						var match;
						if ( completed ) {
							if ( !responseHeaders ) {
								responseHeaders = {};
								while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
									responseHeaders[ match[ 1 ].toLowerCase() ] = match[ 2 ];
								}
							}
							match = responseHeaders[ key.toLowerCase() ];
						}
						return match == null ? null : match;
					},

					// Raw string
					getAllResponseHeaders: function() {
						return completed ? responseHeadersString : null;
					},

					// Caches the header
					setRequestHeader: function( name, value ) {
						if ( completed == null ) {
							name = requestHeadersNames[ name.toLowerCase() ] =
								requestHeadersNames[ name.toLowerCase() ] || name;
							requestHeaders[ name ] = value;
						}
						return this;
					},

					// Overrides response content-type header
					overrideMimeType: function( type ) {
						if ( completed == null ) {
							s.mimeType = type;
						}
						return this;
					},

					// Status-dependent callbacks
					statusCode: function( map ) {
						var code;
						if ( map ) {
							if ( completed ) {

								// Execute the appropriate callbacks
								jqXHR.always( map[ jqXHR.status ] );
							} else {

								// Lazy-add the new callbacks in a way that preserves old ones
								for ( code in map ) {
									statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
								}
							}
						}
						return this;
					},

					// Cancel the request
					abort: function( statusText ) {
						var finalText = statusText || strAbort;
						if ( transport ) {
							transport.abort( finalText );
						}
						done( 0, finalText );
						return this;
					}
				};

			// Attach deferreds
			deferred.promise( jqXHR );

			// Add protocol if not provided (prefilters might expect it)
			// Handle falsy url in the settings object (#10093: consistency with old signature)
			// We also use the url parameter if available
			s.url = ( ( url || s.url || location.href ) + "" )
				.replace( rprotocol, location.protocol + "//" );

			// Alias method option to type as per ticket #12004
			s.type = options.method || options.type || s.method || s.type;

			// Extract dataTypes list
			s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];

			// A cross-domain request is in order when the origin doesn't match the current origin.
			if ( s.crossDomain == null ) {
				urlAnchor = document.createElement( "a" );

				// Support: IE <=8 - 11, Edge 12 - 15
				// IE throws exception on accessing the href property if url is malformed,
				// e.g. http://example.com:80x/
				try {
					urlAnchor.href = s.url;

					// Support: IE <=8 - 11 only
					// Anchor's host property isn't correctly set when s.url is relative
					urlAnchor.href = urlAnchor.href;
					s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
						urlAnchor.protocol + "//" + urlAnchor.host;
				} catch ( e ) {

					// If there is an error parsing the URL, assume it is crossDomain,
					// it can be rejected by the transport if it is invalid
					s.crossDomain = true;
				}
			}

			// Convert data if not already a string
			if ( s.data && s.processData && typeof s.data !== "string" ) {
				s.data = jQuery.param( s.data, s.traditional );
			}

			// Apply prefilters
			inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );

			// If request was aborted inside a prefilter, stop there
			if ( completed ) {
				return jqXHR;
			}

			// We can fire global events as of now if asked to
			// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
			fireGlobals = jQuery.event && s.global;

			// Watch for a new set of requests
			if ( fireGlobals && jQuery.active++ === 0 ) {
				jQuery.event.trigger( "ajaxStart" );
			}

			// Uppercase the type
			s.type = s.type.toUpperCase();

			// Determine if request has content
			s.hasContent = !rnoContent.test( s.type );

			// Save the URL in case we're toying with the If-Modified-Since
			// and/or If-None-Match header later on
			// Remove hash to simplify url manipulation
			cacheURL = s.url.replace( rhash, "" );

			// More options handling for requests with no content
			if ( !s.hasContent ) {

				// Remember the hash so we can put it back
				uncached = s.url.slice( cacheURL.length );

				// If data is available and should be processed, append data to url
				if ( s.data && ( s.processData || typeof s.data === "string" ) ) {
					cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;

					// #9682: remove data so that it's not used in an eventual retry
					delete s.data;
				}

				// Add or update anti-cache param if needed
				if ( s.cache === false ) {
					cacheURL = cacheURL.replace( rantiCache, "$1" );
					uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce++ ) + uncached;
				}

				// Put hash and anti-cache on the URL that will be requested (gh-1732)
				s.url = cacheURL + uncached;

			// Change '%20' to '+' if this is encoded form body content (gh-2658)
			} else if ( s.data && s.processData &&
				( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
				s.data = s.data.replace( r20, "+" );
			}

			// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
			if ( s.ifModified ) {
				if ( jQuery.lastModified[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
				}
				if ( jQuery.etag[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
				}
			}

			// Set the correct header, if data is being sent
			if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
				jqXHR.setRequestHeader( "Content-Type", s.contentType );
			}

			// Set the Accepts header for the server, depending on the dataType
			jqXHR.setRequestHeader(
				"Accept",
				s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
					s.accepts[ s.dataTypes[ 0 ] ] +
						( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
					s.accepts[ "*" ]
			);

			// Check for headers option
			for ( i in s.headers ) {
				jqXHR.setRequestHeader( i, s.headers[ i ] );
			}

			// Allow custom headers/mimetypes and early abort
			if ( s.beforeSend &&
				( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {

				// Abort if not done already and return
				return jqXHR.abort();
			}

			// Aborting is no longer a cancellation
			strAbort = "abort";

			// Install callbacks on deferreds
			completeDeferred.add( s.complete );
			jqXHR.done( s.success );
			jqXHR.fail( s.error );

			// Get transport
			transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );

			// If no transport, we auto-abort
			if ( !transport ) {
				done( -1, "No Transport" );
			} else {
				jqXHR.readyState = 1;

				// Send global event
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
				}

				// If request was aborted inside ajaxSend, stop there
				if ( completed ) {
					return jqXHR;
				}

				// Timeout
				if ( s.async && s.timeout > 0 ) {
					timeoutTimer = window.setTimeout( function() {
						jqXHR.abort( "timeout" );
					}, s.timeout );
				}

				try {
					completed = false;
					transport.send( requestHeaders, done );
				} catch ( e ) {

					// Rethrow post-completion exceptions
					if ( completed ) {
						throw e;
					}

					// Propagate others as results
					done( -1, e );
				}
			}

			// Callback for when everything is done
			function done( status, nativeStatusText, responses, headers ) {
				var isSuccess, success, error, response, modified,
					statusText = nativeStatusText;

				// Ignore repeat invocations
				if ( completed ) {
					return;
				}

				completed = true;

				// Clear timeout if it exists
				if ( timeoutTimer ) {
					window.clearTimeout( timeoutTimer );
				}

				// Dereference transport for early garbage collection
				// (no matter how long the jqXHR object will be used)
				transport = undefined;

				// Cache response headers
				responseHeadersString = headers || "";

				// Set readyState
				jqXHR.readyState = status > 0 ? 4 : 0;

				// Determine if successful
				isSuccess = status >= 200 && status < 300 || status === 304;

				// Get response data
				if ( responses ) {
					response = ajaxHandleResponses( s, jqXHR, responses );
				}

				// Convert no matter what (that way responseXXX fields are always set)
				response = ajaxConvert( s, response, jqXHR, isSuccess );

				// If successful, handle type chaining
				if ( isSuccess ) {

					// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
					if ( s.ifModified ) {
						modified = jqXHR.getResponseHeader( "Last-Modified" );
						if ( modified ) {
							jQuery.lastModified[ cacheURL ] = modified;
						}
						modified = jqXHR.getResponseHeader( "etag" );
						if ( modified ) {
							jQuery.etag[ cacheURL ] = modified;
						}
					}

					// if no content
					if ( status === 204 || s.type === "HEAD" ) {
						statusText = "nocontent";

					// if not modified
					} else if ( status === 304 ) {
						statusText = "notmodified";

					// If we have data, let's convert it
					} else {
						statusText = response.state;
						success = response.data;
						error = response.error;
						isSuccess = !error;
					}
				} else {

					// Extract error from statusText and normalize for non-aborts
					error = statusText;
					if ( status || !statusText ) {
						statusText = "error";
						if ( status < 0 ) {
							status = 0;
						}
					}
				}

				// Set data for the fake xhr object
				jqXHR.status = status;
				jqXHR.statusText = ( nativeStatusText || statusText ) + "";

				// Success/Error
				if ( isSuccess ) {
					deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
				} else {
					deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
				}

				// Status-dependent callbacks
				jqXHR.statusCode( statusCode );
				statusCode = undefined;

				if ( fireGlobals ) {
					globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
						[ jqXHR, s, isSuccess ? success : error ] );
				}

				// Complete
				completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );

				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );

					// Handle the global AJAX counter
					if ( !( --jQuery.active ) ) {
						jQuery.event.trigger( "ajaxStop" );
					}
				}
			}

			return jqXHR;
		},

		getJSON: function( url, data, callback ) {
			return jQuery.get( url, data, callback, "json" );
		},

		getScript: function( url, callback ) {
			return jQuery.get( url, undefined, callback, "script" );
		}
	} );

	jQuery.each( [ "get", "post" ], function( i, method ) {
		jQuery[ method ] = function( url, data, callback, type ) {

			// Shift arguments if data argument was omitted
			if ( isFunction( data ) ) {
				type = type || callback;
				callback = data;
				data = undefined;
			}

			// The url can be an options object (which then must have .url)
			return jQuery.ajax( jQuery.extend( {
				url: url,
				type: method,
				dataType: type,
				data: data,
				success: callback
			}, jQuery.isPlainObject( url ) && url ) );
		};
	} );


	jQuery._evalUrl = function( url ) {
		return jQuery.ajax( {
			url: url,

			// Make this explicit, since user can override this through ajaxSetup (#11264)
			type: "GET",
			dataType: "script",
			cache: true,
			async: false,
			global: false,
			"throws": true
		} );
	};


	jQuery.fn.extend( {
		wrapAll: function( html ) {
			var wrap;

			if ( this[ 0 ] ) {
				if ( isFunction( html ) ) {
					html = html.call( this[ 0 ] );
				}

				// The elements to wrap the target around
				wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );

				if ( this[ 0 ].parentNode ) {
					wrap.insertBefore( this[ 0 ] );
				}

				wrap.map( function() {
					var elem = this;

					while ( elem.firstElementChild ) {
						elem = elem.firstElementChild;
					}

					return elem;
				} ).append( this );
			}

			return this;
		},

		wrapInner: function( html ) {
			if ( isFunction( html ) ) {
				return this.each( function( i ) {
					jQuery( this ).wrapInner( html.call( this, i ) );
				} );
			}

			return this.each( function() {
				var self = jQuery( this ),
					contents = self.contents();

				if ( contents.length ) {
					contents.wrapAll( html );

				} else {
					self.append( html );
				}
			} );
		},

		wrap: function( html ) {
			var htmlIsFunction = isFunction( html );

			return this.each( function( i ) {
				jQuery( this ).wrapAll( htmlIsFunction ? html.call( this, i ) : html );
			} );
		},

		unwrap: function( selector ) {
			this.parent( selector ).not( "body" ).each( function() {
				jQuery( this ).replaceWith( this.childNodes );
			} );
			return this;
		}
	} );


	jQuery.expr.pseudos.hidden = function( elem ) {
		return !jQuery.expr.pseudos.visible( elem );
	};
	jQuery.expr.pseudos.visible = function( elem ) {
		return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
	};




	jQuery.ajaxSettings.xhr = function() {
		try {
			return new window.XMLHttpRequest();
		} catch ( e ) {}
	};

	var xhrSuccessStatus = {

			// File protocol always yields status code 0, assume 200
			0: 200,

			// Support: IE <=9 only
			// #1450: sometimes IE returns 1223 when it should be 204
			1223: 204
		},
		xhrSupported = jQuery.ajaxSettings.xhr();

	support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
	support.ajax = xhrSupported = !!xhrSupported;

	jQuery.ajaxTransport( function( options ) {
		var callback, errorCallback;

		// Cross domain only allowed if supported through XMLHttpRequest
		if ( support.cors || xhrSupported && !options.crossDomain ) {
			return {
				send: function( headers, complete ) {
					var i,
						xhr = options.xhr();

					xhr.open(
						options.type,
						options.url,
						options.async,
						options.username,
						options.password
					);

					// Apply custom fields if provided
					if ( options.xhrFields ) {
						for ( i in options.xhrFields ) {
							xhr[ i ] = options.xhrFields[ i ];
						}
					}

					// Override mime type if needed
					if ( options.mimeType && xhr.overrideMimeType ) {
						xhr.overrideMimeType( options.mimeType );
					}

					// X-Requested-With header
					// For cross-domain requests, seeing as conditions for a preflight are
					// akin to a jigsaw puzzle, we simply never set it to be sure.
					// (it can always be set on a per-request basis or even using ajaxSetup)
					// For same-domain requests, won't change header if already provided.
					if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
						headers[ "X-Requested-With" ] = "XMLHttpRequest";
					}

					// Set headers
					for ( i in headers ) {
						xhr.setRequestHeader( i, headers[ i ] );
					}

					// Callback
					callback = function( type ) {
						return function() {
							if ( callback ) {
								callback = errorCallback = xhr.onload =
									xhr.onerror = xhr.onabort = xhr.ontimeout =
										xhr.onreadystatechange = null;

								if ( type === "abort" ) {
									xhr.abort();
								} else if ( type === "error" ) {

									// Support: IE <=9 only
									// On a manual native abort, IE9 throws
									// errors on any property access that is not readyState
									if ( typeof xhr.status !== "number" ) {
										complete( 0, "error" );
									} else {
										complete(

											// File: protocol always yields status 0; see #8605, #14207
											xhr.status,
											xhr.statusText
										);
									}
								} else {
									complete(
										xhrSuccessStatus[ xhr.status ] || xhr.status,
										xhr.statusText,

										// Support: IE <=9 only
										// IE9 has no XHR2 but throws on binary (trac-11426)
										// For XHR2 non-text, let the caller handle it (gh-2498)
										( xhr.responseType || "text" ) !== "text"  ||
										typeof xhr.responseText !== "string" ?
											{ binary: xhr.response } :
											{ text: xhr.responseText },
										xhr.getAllResponseHeaders()
									);
								}
							}
						};
					};

					// Listen to events
					xhr.onload = callback();
					errorCallback = xhr.onerror = xhr.ontimeout = callback( "error" );

					// Support: IE 9 only
					// Use onreadystatechange to replace onabort
					// to handle uncaught aborts
					if ( xhr.onabort !== undefined ) {
						xhr.onabort = errorCallback;
					} else {
						xhr.onreadystatechange = function() {

							// Check readyState before timeout as it changes
							if ( xhr.readyState === 4 ) {

								// Allow onerror to be called first,
								// but that will not handle a native abort
								// Also, save errorCallback to a variable
								// as xhr.onerror cannot be accessed
								window.setTimeout( function() {
									if ( callback ) {
										errorCallback();
									}
								} );
							}
						};
					}

					// Create the abort callback
					callback = callback( "abort" );

					try {

						// Do send the request (this may raise an exception)
						xhr.send( options.hasContent && options.data || null );
					} catch ( e ) {

						// #14683: Only rethrow if this hasn't been notified as an error yet
						if ( callback ) {
							throw e;
						}
					}
				},

				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	} );




	// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
	jQuery.ajaxPrefilter( function( s ) {
		if ( s.crossDomain ) {
			s.contents.script = false;
		}
	} );

	// Install script dataType
	jQuery.ajaxSetup( {
		accepts: {
			script: "text/javascript, application/javascript, " +
				"application/ecmascript, application/x-ecmascript"
		},
		contents: {
			script: /\b(?:java|ecma)script\b/
		},
		converters: {
			"text script": function( text ) {
				jQuery.globalEval( text );
				return text;
			}
		}
	} );

	// Handle cache's special case and crossDomain
	jQuery.ajaxPrefilter( "script", function( s ) {
		if ( s.cache === undefined ) {
			s.cache = false;
		}
		if ( s.crossDomain ) {
			s.type = "GET";
		}
	} );

	// Bind script tag hack transport
	jQuery.ajaxTransport( "script", function( s ) {

		// This transport only deals with cross domain requests
		if ( s.crossDomain ) {
			var script, callback;
			return {
				send: function( _, complete ) {
					script = jQuery( "<script>" ).prop( {
						charset: s.scriptCharset,
						src: s.url
					} ).on(
						"load error",
						callback = function( evt ) {
							script.remove();
							callback = null;
							if ( evt ) {
								complete( evt.type === "error" ? 404 : 200, evt.type );
							}
						}
					);

					// Use native DOM manipulation to avoid our domManip AJAX trickery
					document.head.appendChild( script[ 0 ] );
				},
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	} );




	var oldCallbacks = [],
		rjsonp = /(=)\?(?=&|$)|\?\?/;

	// Default jsonp settings
	jQuery.ajaxSetup( {
		jsonp: "callback",
		jsonpCallback: function() {
			var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce++ ) );
			this[ callback ] = true;
			return callback;
		}
	} );

	// Detect, normalize options and install callbacks for jsonp requests
	jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {

		var callbackName, overwritten, responseContainer,
			jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
				"url" :
				typeof s.data === "string" &&
					( s.contentType || "" )
						.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
					rjsonp.test( s.data ) && "data"
			);

		// Handle iff the expected data type is "jsonp" or we have a parameter to set
		if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {

			// Get callback name, remembering preexisting value associated with it
			callbackName = s.jsonpCallback = isFunction( s.jsonpCallback ) ?
				s.jsonpCallback() :
				s.jsonpCallback;

			// Insert callback into url or form data
			if ( jsonProp ) {
				s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
			} else if ( s.jsonp !== false ) {
				s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
			}

			// Use data converter to retrieve json after script execution
			s.converters[ "script json" ] = function() {
				if ( !responseContainer ) {
					jQuery.error( callbackName + " was not called" );
				}
				return responseContainer[ 0 ];
			};

			// Force json dataType
			s.dataTypes[ 0 ] = "json";

			// Install callback
			overwritten = window[ callbackName ];
			window[ callbackName ] = function() {
				responseContainer = arguments;
			};

			// Clean-up function (fires after converters)
			jqXHR.always( function() {

				// If previous value didn't exist - remove it
				if ( overwritten === undefined ) {
					jQuery( window ).removeProp( callbackName );

				// Otherwise restore preexisting value
				} else {
					window[ callbackName ] = overwritten;
				}

				// Save back as free
				if ( s[ callbackName ] ) {

					// Make sure that re-using the options doesn't screw things around
					s.jsonpCallback = originalSettings.jsonpCallback;

					// Save the callback name for future use
					oldCallbacks.push( callbackName );
				}

				// Call if it was a function and we have a response
				if ( responseContainer && isFunction( overwritten ) ) {
					overwritten( responseContainer[ 0 ] );
				}

				responseContainer = overwritten = undefined;
			} );

			// Delegate to script
			return "script";
		}
	} );




	// Support: Safari 8 only
	// In Safari 8 documents created via document.implementation.createHTMLDocument
	// collapse sibling forms: the second one becomes a child of the first one.
	// Because of that, this security measure has to be disabled in Safari 8.
	// https://bugs.webkit.org/show_bug.cgi?id=137337
	support.createHTMLDocument = ( function() {
		var body = document.implementation.createHTMLDocument( "" ).body;
		body.innerHTML = "<form></form><form></form>";
		return body.childNodes.length === 2;
	} )();


	// Argument "data" should be string of html
	// context (optional): If specified, the fragment will be created in this context,
	// defaults to document
	// keepScripts (optional): If true, will include scripts passed in the html string
	jQuery.parseHTML = function( data, context, keepScripts ) {
		if ( typeof data !== "string" ) {
			return [];
		}
		if ( typeof context === "boolean" ) {
			keepScripts = context;
			context = false;
		}

		var base, parsed, scripts;

		if ( !context ) {

			// Stop scripts or inline event handlers from being executed immediately
			// by using document.implementation
			if ( support.createHTMLDocument ) {
				context = document.implementation.createHTMLDocument( "" );

				// Set the base href for the created document
				// so any parsed elements with URLs
				// are based on the document's URL (gh-2965)
				base = context.createElement( "base" );
				base.href = document.location.href;
				context.head.appendChild( base );
			} else {
				context = document;
			}
		}

		parsed = rsingleTag.exec( data );
		scripts = !keepScripts && [];

		// Single tag
		if ( parsed ) {
			return [ context.createElement( parsed[ 1 ] ) ];
		}

		parsed = buildFragment( [ data ], context, scripts );

		if ( scripts && scripts.length ) {
			jQuery( scripts ).remove();
		}

		return jQuery.merge( [], parsed.childNodes );
	};


	/**
	 * Load a url into a page
	 */
	jQuery.fn.load = function( url, params, callback ) {
		var selector, type, response,
			self = this,
			off = url.indexOf( " " );

		if ( off > -1 ) {
			selector = stripAndCollapse( url.slice( off ) );
			url = url.slice( 0, off );
		}

		// If it's a function
		if ( isFunction( params ) ) {

			// We assume that it's the callback
			callback = params;
			params = undefined;

		// Otherwise, build a param string
		} else if ( params && typeof params === "object" ) {
			type = "POST";
		}

		// If we have elements to modify, make the request
		if ( self.length > 0 ) {
			jQuery.ajax( {
				url: url,

				// If "type" variable is undefined, then "GET" method will be used.
				// Make value of this field explicit since
				// user can override it through ajaxSetup method
				type: type || "GET",
				dataType: "html",
				data: params
			} ).done( function( responseText ) {

				// Save response for use in complete callback
				response = arguments;

				self.html( selector ?

					// If a selector was specified, locate the right elements in a dummy div
					// Exclude scripts to avoid IE 'Permission Denied' errors
					jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :

					// Otherwise use the full result
					responseText );

			// If the request succeeds, this function gets "data", "status", "jqXHR"
			// but they are ignored because response was set above.
			// If it fails, this function gets "jqXHR", "status", "error"
			} ).always( callback && function( jqXHR, status ) {
				self.each( function() {
					callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
				} );
			} );
		}

		return this;
	};




	// Attach a bunch of functions for handling common AJAX events
	jQuery.each( [
		"ajaxStart",
		"ajaxStop",
		"ajaxComplete",
		"ajaxError",
		"ajaxSuccess",
		"ajaxSend"
	], function( i, type ) {
		jQuery.fn[ type ] = function( fn ) {
			return this.on( type, fn );
		};
	} );




	jQuery.expr.pseudos.animated = function( elem ) {
		return jQuery.grep( jQuery.timers, function( fn ) {
			return elem === fn.elem;
		} ).length;
	};




	jQuery.offset = {
		setOffset: function( elem, options, i ) {
			var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
				position = jQuery.css( elem, "position" ),
				curElem = jQuery( elem ),
				props = {};

			// Set position first, in-case top/left are set even on static elem
			if ( position === "static" ) {
				elem.style.position = "relative";
			}

			curOffset = curElem.offset();
			curCSSTop = jQuery.css( elem, "top" );
			curCSSLeft = jQuery.css( elem, "left" );
			calculatePosition = ( position === "absolute" || position === "fixed" ) &&
				( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;

			// Need to be able to calculate position if either
			// top or left is auto and position is either absolute or fixed
			if ( calculatePosition ) {
				curPosition = curElem.position();
				curTop = curPosition.top;
				curLeft = curPosition.left;

			} else {
				curTop = parseFloat( curCSSTop ) || 0;
				curLeft = parseFloat( curCSSLeft ) || 0;
			}

			if ( isFunction( options ) ) {

				// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
				options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
			}

			if ( options.top != null ) {
				props.top = ( options.top - curOffset.top ) + curTop;
			}
			if ( options.left != null ) {
				props.left = ( options.left - curOffset.left ) + curLeft;
			}

			if ( "using" in options ) {
				options.using.call( elem, props );

			} else {
				curElem.css( props );
			}
		}
	};

	jQuery.fn.extend( {

		// offset() relates an element's border box to the document origin
		offset: function( options ) {

			// Preserve chaining for setter
			if ( arguments.length ) {
				return options === undefined ?
					this :
					this.each( function( i ) {
						jQuery.offset.setOffset( this, options, i );
					} );
			}

			var rect, win,
				elem = this[ 0 ];

			if ( !elem ) {
				return;
			}

			// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
			// Support: IE <=11 only
			// Running getBoundingClientRect on a
			// disconnected node in IE throws an error
			if ( !elem.getClientRects().length ) {
				return { top: 0, left: 0 };
			}

			// Get document-relative position by adding viewport scroll to viewport-relative gBCR
			rect = elem.getBoundingClientRect();
			win = elem.ownerDocument.defaultView;
			return {
				top: rect.top + win.pageYOffset,
				left: rect.left + win.pageXOffset
			};
		},

		// position() relates an element's margin box to its offset parent's padding box
		// This corresponds to the behavior of CSS absolute positioning
		position: function() {
			if ( !this[ 0 ] ) {
				return;
			}

			var offsetParent, offset, doc,
				elem = this[ 0 ],
				parentOffset = { top: 0, left: 0 };

			// position:fixed elements are offset from the viewport, which itself always has zero offset
			if ( jQuery.css( elem, "position" ) === "fixed" ) {

				// Assume position:fixed implies availability of getBoundingClientRect
				offset = elem.getBoundingClientRect();

			} else {
				offset = this.offset();

				// Account for the *real* offset parent, which can be the document or its root element
				// when a statically positioned element is identified
				doc = elem.ownerDocument;
				offsetParent = elem.offsetParent || doc.documentElement;
				while ( offsetParent &&
					( offsetParent === doc.body || offsetParent === doc.documentElement ) &&
					jQuery.css( offsetParent, "position" ) === "static" ) {

					offsetParent = offsetParent.parentNode;
				}
				if ( offsetParent && offsetParent !== elem && offsetParent.nodeType === 1 ) {

					// Incorporate borders into its offset, since they are outside its content origin
					parentOffset = jQuery( offsetParent ).offset();
					parentOffset.top += jQuery.css( offsetParent, "borderTopWidth", true );
					parentOffset.left += jQuery.css( offsetParent, "borderLeftWidth", true );
				}
			}

			// Subtract parent offsets and element margins
			return {
				top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
				left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
			};
		},

		// This method will return documentElement in the following cases:
		// 1) For the element inside the iframe without offsetParent, this method will return
		//    documentElement of the parent window
		// 2) For the hidden or detached element
		// 3) For body or html element, i.e. in case of the html node - it will return itself
		//
		// but those exceptions were never presented as a real life use-cases
		// and might be considered as more preferable results.
		//
		// This logic, however, is not guaranteed and can change at any point in the future
		offsetParent: function() {
			return this.map( function() {
				var offsetParent = this.offsetParent;

				while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
					offsetParent = offsetParent.offsetParent;
				}

				return offsetParent || documentElement;
			} );
		}
	} );

	// Create scrollLeft and scrollTop methods
	jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
		var top = "pageYOffset" === prop;

		jQuery.fn[ method ] = function( val ) {
			return access( this, function( elem, method, val ) {

				// Coalesce documents and windows
				var win;
				if ( isWindow( elem ) ) {
					win = elem;
				} else if ( elem.nodeType === 9 ) {
					win = elem.defaultView;
				}

				if ( val === undefined ) {
					return win ? win[ prop ] : elem[ method ];
				}

				if ( win ) {
					win.scrollTo(
						!top ? val : win.pageXOffset,
						top ? val : win.pageYOffset
					);

				} else {
					elem[ method ] = val;
				}
			}, method, val, arguments.length );
		};
	} );

	// Support: Safari <=7 - 9.1, Chrome <=37 - 49
	// Add the top/left cssHooks using jQuery.fn.position
	// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
	// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
	// getComputedStyle returns percent when specified for top/left/bottom/right;
	// rather than make the css module depend on the offset module, just check for it here
	jQuery.each( [ "top", "left" ], function( i, prop ) {
		jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
			function( elem, computed ) {
				if ( computed ) {
					computed = curCSS( elem, prop );

					// If curCSS returns percentage, fallback to offset
					return rnumnonpx.test( computed ) ?
						jQuery( elem ).position()[ prop ] + "px" :
						computed;
				}
			}
		);
	} );


	// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
	jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
		jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name },
			function( defaultExtra, funcName ) {

			// Margin is only for outerHeight, outerWidth
			jQuery.fn[ funcName ] = function( margin, value ) {
				var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
					extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );

				return access( this, function( elem, type, value ) {
					var doc;

					if ( isWindow( elem ) ) {

						// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
						return funcName.indexOf( "outer" ) === 0 ?
							elem[ "inner" + name ] :
							elem.document.documentElement[ "client" + name ];
					}

					// Get document width or height
					if ( elem.nodeType === 9 ) {
						doc = elem.documentElement;

						// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
						// whichever is greatest
						return Math.max(
							elem.body[ "scroll" + name ], doc[ "scroll" + name ],
							elem.body[ "offset" + name ], doc[ "offset" + name ],
							doc[ "client" + name ]
						);
					}

					return value === undefined ?

						// Get width or height on the element, requesting but not forcing parseFloat
						jQuery.css( elem, type, extra ) :

						// Set width or height on the element
						jQuery.style( elem, type, value, extra );
				}, type, chainable ? margin : undefined, chainable );
			};
		} );
	} );


	jQuery.each( ( "blur focus focusin focusout resize scroll click dblclick " +
		"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
		"change select submit keydown keypress keyup contextmenu" ).split( " " ),
		function( i, name ) {

		// Handle event binding
		jQuery.fn[ name ] = function( data, fn ) {
			return arguments.length > 0 ?
				this.on( name, null, data, fn ) :
				this.trigger( name );
		};
	} );

	jQuery.fn.extend( {
		hover: function( fnOver, fnOut ) {
			return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
		}
	} );




	jQuery.fn.extend( {

		bind: function( types, data, fn ) {
			return this.on( types, null, data, fn );
		},
		unbind: function( types, fn ) {
			return this.off( types, null, fn );
		},

		delegate: function( selector, types, data, fn ) {
			return this.on( types, selector, data, fn );
		},
		undelegate: function( selector, types, fn ) {

			// ( namespace ) or ( selector, types [, fn] )
			return arguments.length === 1 ?
				this.off( selector, "**" ) :
				this.off( types, selector || "**", fn );
		}
	} );

	// Bind a function to a context, optionally partially applying any
	// arguments.
	// jQuery.proxy is deprecated to promote standards (specifically Function#bind)
	// However, it is not slated for removal any time soon
	jQuery.proxy = function( fn, context ) {
		var tmp, args, proxy;

		if ( typeof context === "string" ) {
			tmp = fn[ context ];
			context = fn;
			fn = tmp;
		}

		// Quick check to determine if target is callable, in the spec
		// this throws a TypeError, but we will just return undefined.
		if ( !isFunction( fn ) ) {
			return undefined;
		}

		// Simulated bind
		args = slice.call( arguments, 2 );
		proxy = function() {
			return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
		};

		// Set the guid of unique handler to the same of original handler, so it can be removed
		proxy.guid = fn.guid = fn.guid || jQuery.guid++;

		return proxy;
	};

	jQuery.holdReady = function( hold ) {
		if ( hold ) {
			jQuery.readyWait++;
		} else {
			jQuery.ready( true );
		}
	};
	jQuery.isArray = Array.isArray;
	jQuery.parseJSON = JSON.parse;
	jQuery.nodeName = nodeName;
	jQuery.isFunction = isFunction;
	jQuery.isWindow = isWindow;
	jQuery.camelCase = camelCase;
	jQuery.type = toType;

	jQuery.now = Date.now;

	jQuery.isNumeric = function( obj ) {

		// As of jQuery 3.0, isNumeric is limited to
		// strings and numbers (primitives or objects)
		// that can be coerced to finite numbers (gh-2662)
		var type = jQuery.type( obj );
		return ( type === "number" || type === "string" ) &&

			// parseFloat NaNs numeric-cast false positives ("")
			// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
			// subtraction forces infinities to NaN
			!isNaN( obj - parseFloat( obj ) );
	};




	var

		// Map over jQuery in case of overwrite
		_jQuery = window.jQuery,

		// Map over the $ in case of overwrite
		_$ = window.$;

	jQuery.noConflict = function( deep ) {
		if ( window.$ === jQuery ) {
			window.$ = _$;
		}

		if ( deep && window.jQuery === jQuery ) {
			window.jQuery = _jQuery;
		}

		return jQuery;
	};

	// Expose jQuery and $ identifiers, even in AMD
	// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
	// and CommonJS for browser emulators (#13566)
	if ( !noGlobal ) {
		window.jQuery = window.$ = jQuery;
	}




	return jQuery;
	} );
	});

	/**
	 * Parses an URI
	 *
	 * @author Steven Levithan <stevenlevithan.com> (MIT license)
	 * @api private
	 */

	var re = /^(?:(?![^:@]+:[^:@\/]*@)(http|https|ws|wss):\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?((?:[a-f0-9]{0,4}:){2,7}[a-f0-9]{0,4}|[^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/;

	var parts = [
	    'source', 'protocol', 'authority', 'userInfo', 'user', 'password', 'host', 'port', 'relative', 'path', 'directory', 'file', 'query', 'anchor'
	];

	var parseuri = function parseuri(str) {
	    var src = str,
	        b = str.indexOf('['),
	        e = str.indexOf(']');

	    if (b != -1 && e != -1) {
	        str = str.substring(0, b) + str.substring(b, e).replace(/:/g, ';') + str.substring(e, str.length);
	    }

	    var m = re.exec(str || ''),
	        uri = {},
	        i = 14;

	    while (i--) {
	        uri[parts[i]] = m[i] || '';
	    }

	    if (b != -1 && e != -1) {
	        uri.source = src;
	        uri.host = uri.host.substring(1, uri.host.length - 1).replace(/;/g, ':');
	        uri.authority = uri.authority.replace('[', '').replace(']', '').replace(/;/g, ':');
	        uri.ipv6uri = true;
	    }

	    uri.pathNames = pathNames(uri, uri['path']);
	    uri.queryKey = queryKey(uri, uri['query']);

	    return uri;
	};

	function pathNames(obj, path) {
	    var regx = /\/{2,9}/g,
	        names = path.replace(regx, "/").split("/");

	    if (path.substr(0, 1) == '/' || path.length === 0) {
	        names.splice(0, 1);
	    }
	    if (path.substr(path.length - 1, 1) == '/') {
	        names.splice(names.length - 1, 1);
	    }

	    return names;
	}

	function queryKey(uri, query) {
	    var data = {};

	    query.replace(/(?:^|&)([^&=]*)=?([^&]*)/g, function ($0, $1, $2) {
	        if ($1) {
	            data[$1] = $2;
	        }
	    });

	    return data;
	}

	var parseuri$1 = /*#__PURE__*/Object.freeze({
		default: parseuri,
		__moduleExports: parseuri
	});

	/**
	 * Helpers.
	 */

	var s = 1000;
	var m = s * 60;
	var h = m * 60;
	var d = h * 24;
	var y = d * 365.25;

	/**
	 * Parse or format the given `val`.
	 *
	 * Options:
	 *
	 *  - `long` verbose formatting [false]
	 *
	 * @param {String|Number} val
	 * @param {Object} [options]
	 * @throws {Error} throw an error if val is not a non-empty string or a number
	 * @return {String|Number}
	 * @api public
	 */

	var ms = function(val, options) {
	  options = options || {};
	  var type = typeof val;
	  if (type === 'string' && val.length > 0) {
	    return parse$1(val);
	  } else if (type === 'number' && isNaN(val) === false) {
	    return options.long ? fmtLong(val) : fmtShort(val);
	  }
	  throw new Error(
	    'val is not a non-empty string or a valid number. val=' +
	      JSON.stringify(val)
	  );
	};

	/**
	 * Parse the given `str` and return milliseconds.
	 *
	 * @param {String} str
	 * @return {Number}
	 * @api private
	 */

	function parse$1(str) {
	  str = String(str);
	  if (str.length > 100) {
	    return;
	  }
	  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(
	    str
	  );
	  if (!match) {
	    return;
	  }
	  var n = parseFloat(match[1]);
	  var type = (match[2] || 'ms').toLowerCase();
	  switch (type) {
	    case 'years':
	    case 'year':
	    case 'yrs':
	    case 'yr':
	    case 'y':
	      return n * y;
	    case 'days':
	    case 'day':
	    case 'd':
	      return n * d;
	    case 'hours':
	    case 'hour':
	    case 'hrs':
	    case 'hr':
	    case 'h':
	      return n * h;
	    case 'minutes':
	    case 'minute':
	    case 'mins':
	    case 'min':
	    case 'm':
	      return n * m;
	    case 'seconds':
	    case 'second':
	    case 'secs':
	    case 'sec':
	    case 's':
	      return n * s;
	    case 'milliseconds':
	    case 'millisecond':
	    case 'msecs':
	    case 'msec':
	    case 'ms':
	      return n;
	    default:
	      return undefined;
	  }
	}

	/**
	 * Short format for `ms`.
	 *
	 * @param {Number} ms
	 * @return {String}
	 * @api private
	 */

	function fmtShort(ms) {
	  if (ms >= d) {
	    return Math.round(ms / d) + 'd';
	  }
	  if (ms >= h) {
	    return Math.round(ms / h) + 'h';
	  }
	  if (ms >= m) {
	    return Math.round(ms / m) + 'm';
	  }
	  if (ms >= s) {
	    return Math.round(ms / s) + 's';
	  }
	  return ms + 'ms';
	}

	/**
	 * Long format for `ms`.
	 *
	 * @param {Number} ms
	 * @return {String}
	 * @api private
	 */

	function fmtLong(ms) {
	  return plural(ms, d, 'day') ||
	    plural(ms, h, 'hour') ||
	    plural(ms, m, 'minute') ||
	    plural(ms, s, 'second') ||
	    ms + ' ms';
	}

	/**
	 * Pluralization helper.
	 */

	function plural(ms, n, name) {
	  if (ms < n) {
	    return;
	  }
	  if (ms < n * 1.5) {
	    return Math.floor(ms / n) + ' ' + name;
	  }
	  return Math.ceil(ms / n) + ' ' + name + 's';
	}

	var ms$1 = /*#__PURE__*/Object.freeze({
		default: ms,
		__moduleExports: ms
	});

	var require$$0 = ( ms$1 && ms ) || ms$1;

	var debug = createCommonjsModule(function (module, exports) {
	/**
	 * This is the common logic for both the Node.js and web browser
	 * implementations of `debug()`.
	 *
	 * Expose `debug()` as the module.
	 */

	exports = module.exports = createDebug.debug = createDebug['default'] = createDebug;
	exports.coerce = coerce;
	exports.disable = disable;
	exports.enable = enable;
	exports.enabled = enabled;
	exports.humanize = require$$0;

	/**
	 * Active `debug` instances.
	 */
	exports.instances = [];

	/**
	 * The currently active debug mode names, and names to skip.
	 */

	exports.names = [];
	exports.skips = [];

	/**
	 * Map of special "%n" handling functions, for the debug "format" argument.
	 *
	 * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
	 */

	exports.formatters = {};

	/**
	 * Select a color.
	 * @param {String} namespace
	 * @return {Number}
	 * @api private
	 */

	function selectColor(namespace) {
	  var hash = 0, i;

	  for (i in namespace) {
	    hash  = ((hash << 5) - hash) + namespace.charCodeAt(i);
	    hash |= 0; // Convert to 32bit integer
	  }

	  return exports.colors[Math.abs(hash) % exports.colors.length];
	}

	/**
	 * Create a debugger with the given `namespace`.
	 *
	 * @param {String} namespace
	 * @return {Function}
	 * @api public
	 */

	function createDebug(namespace) {

	  var prevTime;

	  function debug() {
	    var arguments$1 = arguments;

	    // disabled?
	    if (!debug.enabled) { return; }

	    var self = debug;

	    // set `diff` timestamp
	    var curr = +new Date();
	    var ms = curr - (prevTime || curr);
	    self.diff = ms;
	    self.prev = prevTime;
	    self.curr = curr;
	    prevTime = curr;

	    // turn the `arguments` into a proper Array
	    var args = new Array(arguments.length);
	    for (var i = 0; i < args.length; i++) {
	      args[i] = arguments$1[i];
	    }

	    args[0] = exports.coerce(args[0]);

	    if ('string' !== typeof args[0]) {
	      // anything else let's inspect with %O
	      args.unshift('%O');
	    }

	    // apply any `formatters` transformations
	    var index = 0;
	    args[0] = args[0].replace(/%([a-zA-Z%])/g, function(match, format) {
	      // if we encounter an escaped % then don't increase the array index
	      if (match === '%%') { return match; }
	      index++;
	      var formatter = exports.formatters[format];
	      if ('function' === typeof formatter) {
	        var val = args[index];
	        match = formatter.call(self, val);

	        // now we need to remove `args[index]` since it's inlined in the `format`
	        args.splice(index, 1);
	        index--;
	      }
	      return match;
	    });

	    // apply env-specific formatting (colors, etc.)
	    exports.formatArgs.call(self, args);

	    var logFn = debug.log || exports.log || console.log.bind(console);
	    logFn.apply(self, args);
	  }

	  debug.namespace = namespace;
	  debug.enabled = exports.enabled(namespace);
	  debug.useColors = exports.useColors();
	  debug.color = selectColor(namespace);
	  debug.destroy = destroy;

	  // env-specific initialization logic for debug instances
	  if ('function' === typeof exports.init) {
	    exports.init(debug);
	  }

	  exports.instances.push(debug);

	  return debug;
	}

	function destroy () {
	  var index = exports.instances.indexOf(this);
	  if (index !== -1) {
	    exports.instances.splice(index, 1);
	    return true;
	  } else {
	    return false;
	  }
	}

	/**
	 * Enables a debug mode by namespaces. This can include modes
	 * separated by a colon and wildcards.
	 *
	 * @param {String} namespaces
	 * @api public
	 */

	function enable(namespaces) {
	  exports.save(namespaces);

	  exports.names = [];
	  exports.skips = [];

	  var i;
	  var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
	  var len = split.length;

	  for (i = 0; i < len; i++) {
	    if (!split[i]) { continue; } // ignore empty strings
	    namespaces = split[i].replace(/\*/g, '.*?');
	    if (namespaces[0] === '-') {
	      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
	    } else {
	      exports.names.push(new RegExp('^' + namespaces + '$'));
	    }
	  }

	  for (i = 0; i < exports.instances.length; i++) {
	    var instance = exports.instances[i];
	    instance.enabled = exports.enabled(instance.namespace);
	  }
	}

	/**
	 * Disable debug output.
	 *
	 * @api public
	 */

	function disable() {
	  exports.enable('');
	}

	/**
	 * Returns true if the given mode name is enabled, false otherwise.
	 *
	 * @param {String} name
	 * @return {Boolean}
	 * @api public
	 */

	function enabled(name) {
	  if (name[name.length - 1] === '*') {
	    return true;
	  }
	  var i, len;
	  for (i = 0, len = exports.skips.length; i < len; i++) {
	    if (exports.skips[i].test(name)) {
	      return false;
	    }
	  }
	  for (i = 0, len = exports.names.length; i < len; i++) {
	    if (exports.names[i].test(name)) {
	      return true;
	    }
	  }
	  return false;
	}

	/**
	 * Coerce `val`.
	 *
	 * @param {Mixed} val
	 * @return {Mixed}
	 * @api private
	 */

	function coerce(val) {
	  if (val instanceof Error) { return val.stack || val.message; }
	  return val;
	}
	});
	var debug_1 = debug.coerce;
	var debug_2 = debug.disable;
	var debug_3 = debug.enable;
	var debug_4 = debug.enabled;
	var debug_5 = debug.humanize;
	var debug_6 = debug.instances;
	var debug_7 = debug.names;
	var debug_8 = debug.skips;
	var debug_9 = debug.formatters;

	var debug$1 = /*#__PURE__*/Object.freeze({
		default: debug,
		__moduleExports: debug,
		coerce: debug_1,
		disable: debug_2,
		enable: debug_3,
		enabled: debug_4,
		humanize: debug_5,
		instances: debug_6,
		names: debug_7,
		skips: debug_8,
		formatters: debug_9
	});

	var require$$0$1 = ( debug$1 && debug ) || debug$1;

	var browser = createCommonjsModule(function (module, exports) {
	/**
	 * This is the web browser implementation of `debug()`.
	 *
	 * Expose `debug()` as the module.
	 */

	exports = module.exports = require$$0$1;
	exports.log = log;
	exports.formatArgs = formatArgs;
	exports.save = save;
	exports.load = load;
	exports.useColors = useColors;
	exports.storage = 'undefined' != typeof chrome
	               && 'undefined' != typeof chrome.storage
	                  ? chrome.storage.local
	                  : localstorage();

	/**
	 * Colors.
	 */

	exports.colors = [
	  '#0000CC', '#0000FF', '#0033CC', '#0033FF', '#0066CC', '#0066FF', '#0099CC',
	  '#0099FF', '#00CC00', '#00CC33', '#00CC66', '#00CC99', '#00CCCC', '#00CCFF',
	  '#3300CC', '#3300FF', '#3333CC', '#3333FF', '#3366CC', '#3366FF', '#3399CC',
	  '#3399FF', '#33CC00', '#33CC33', '#33CC66', '#33CC99', '#33CCCC', '#33CCFF',
	  '#6600CC', '#6600FF', '#6633CC', '#6633FF', '#66CC00', '#66CC33', '#9900CC',
	  '#9900FF', '#9933CC', '#9933FF', '#99CC00', '#99CC33', '#CC0000', '#CC0033',
	  '#CC0066', '#CC0099', '#CC00CC', '#CC00FF', '#CC3300', '#CC3333', '#CC3366',
	  '#CC3399', '#CC33CC', '#CC33FF', '#CC6600', '#CC6633', '#CC9900', '#CC9933',
	  '#CCCC00', '#CCCC33', '#FF0000', '#FF0033', '#FF0066', '#FF0099', '#FF00CC',
	  '#FF00FF', '#FF3300', '#FF3333', '#FF3366', '#FF3399', '#FF33CC', '#FF33FF',
	  '#FF6600', '#FF6633', '#FF9900', '#FF9933', '#FFCC00', '#FFCC33'
	];

	/**
	 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
	 * and the Firebug extension (any Firefox version) are known
	 * to support "%c" CSS customizations.
	 *
	 * TODO: add a `localStorage` variable to explicitly enable/disable colors
	 */

	function useColors() {
	  // NB: In an Electron preload script, document will be defined but not fully
	  // initialized. Since we know we're in Chrome, we'll just detect this case
	  // explicitly
	  if (typeof window !== 'undefined' && window.process && window.process.type === 'renderer') {
	    return true;
	  }

	  // Internet Explorer and Edge do not support colors.
	  if (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/)) {
	    return false;
	  }

	  // is webkit? http://stackoverflow.com/a/16459606/376773
	  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
	  return (typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance) ||
	    // is firebug? http://stackoverflow.com/a/398120/376773
	    (typeof window !== 'undefined' && window.console && (window.console.firebug || (window.console.exception && window.console.table))) ||
	    // is firefox >= v31?
	    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
	    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31) ||
	    // double check webkit in userAgent just in case we are in a worker
	    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/));
	}

	/**
	 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
	 */

	exports.formatters.j = function(v) {
	  try {
	    return JSON.stringify(v);
	  } catch (err) {
	    return '[UnexpectedJSONParseError]: ' + err.message;
	  }
	};


	/**
	 * Colorize log arguments if enabled.
	 *
	 * @api public
	 */

	function formatArgs(args) {
	  var useColors = this.useColors;

	  args[0] = (useColors ? '%c' : '')
	    + this.namespace
	    + (useColors ? ' %c' : ' ')
	    + args[0]
	    + (useColors ? '%c ' : ' ')
	    + '+' + exports.humanize(this.diff);

	  if (!useColors) { return; }

	  var c = 'color: ' + this.color;
	  args.splice(1, 0, c, 'color: inherit');

	  // the final "%c" is somewhat tricky, because there could be other
	  // arguments passed either before or after the %c, so we need to
	  // figure out the correct index to insert the CSS into
	  var index = 0;
	  var lastC = 0;
	  args[0].replace(/%[a-zA-Z%]/g, function(match) {
	    if ('%%' === match) { return; }
	    index++;
	    if ('%c' === match) {
	      // we only are interested in the *last* %c
	      // (the user may have provided their own)
	      lastC = index;
	    }
	  });

	  args.splice(lastC, 0, c);
	}

	/**
	 * Invokes `console.log()` when available.
	 * No-op when `console.log` is not a "function".
	 *
	 * @api public
	 */

	function log() {
	  // this hackery is required for IE8/9, where
	  // the `console.log` function doesn't have 'apply'
	  return 'object' === typeof console
	    && console.log
	    && Function.prototype.apply.call(console.log, console, arguments);
	}

	/**
	 * Save `namespaces`.
	 *
	 * @param {String} namespaces
	 * @api private
	 */

	function save(namespaces) {
	  try {
	    if (null == namespaces) {
	      exports.storage.removeItem('debug');
	    } else {
	      exports.storage.debug = namespaces;
	    }
	  } catch(e) {}
	}

	/**
	 * Load `namespaces`.
	 *
	 * @return {String} returns the previously persisted debug modes
	 * @api private
	 */

	function load() {
	  var r;
	  try {
	    r = exports.storage.debug;
	  } catch(e) {}

	  // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
	  if (!r && typeof process !== 'undefined' && 'env' in process) {
	    r = process.env.DEBUG;
	  }

	  return r;
	}

	/**
	 * Enable namespaces listed in `localStorage.debug` initially.
	 */

	exports.enable(load());

	/**
	 * Localstorage attempts to return the localstorage.
	 *
	 * This is necessary because safari throws
	 * when a user disables cookies/localstorage
	 * and you attempt to access it.
	 *
	 * @return {LocalStorage}
	 * @api private
	 */

	function localstorage() {
	  try {
	    return window.localStorage;
	  } catch (e) {}
	}
	});
	var browser_1 = browser.log;
	var browser_2 = browser.formatArgs;
	var browser_3 = browser.save;
	var browser_4 = browser.load;
	var browser_5 = browser.useColors;
	var browser_6 = browser.storage;
	var browser_7 = browser.colors;

	var browser$1 = /*#__PURE__*/Object.freeze({
		default: browser,
		__moduleExports: browser,
		log: browser_1,
		formatArgs: browser_2,
		save: browser_3,
		load: browser_4,
		useColors: browser_5,
		storage: browser_6,
		colors: browser_7
	});

	var parseuri$2 = ( parseuri$1 && parseuri ) || parseuri$1;

	var require$$0$2 = ( browser$1 && browser ) || browser$1;

	/**
	 * Module dependencies.
	 */


	var debug$2 = require$$0$2('socket.io-client:url');

	/**
	 * Module exports.
	 */

	var url_1 = url;

	/**
	 * URL parser.
	 *
	 * @param {String} url
	 * @param {Object} An object meant to mimic window.location.
	 *                 Defaults to window.location.
	 * @api public
	 */

	function url (uri, loc) {
	  var obj = uri;

	  // default to window.location
	  loc = loc || (typeof location !== 'undefined' && location);
	  if (null == uri) { uri = loc.protocol + '//' + loc.host; }

	  // relative path support
	  if ('string' === typeof uri) {
	    if ('/' === uri.charAt(0)) {
	      if ('/' === uri.charAt(1)) {
	        uri = loc.protocol + uri;
	      } else {
	        uri = loc.host + uri;
	      }
	    }

	    if (!/^(https?|wss?):\/\//.test(uri)) {
	      debug$2('protocol-less url %s', uri);
	      if ('undefined' !== typeof loc) {
	        uri = loc.protocol + '//' + uri;
	      } else {
	        uri = 'https://' + uri;
	      }
	    }

	    // parse
	    debug$2('parse %s', uri);
	    obj = parseuri$2(uri);
	  }

	  // make sure we treat `localhost:80` and `localhost` equally
	  if (!obj.port) {
	    if (/^(http|ws)$/.test(obj.protocol)) {
	      obj.port = '80';
	    } else if (/^(http|ws)s$/.test(obj.protocol)) {
	      obj.port = '443';
	    }
	  }

	  obj.path = obj.path || '/';

	  var ipv6 = obj.host.indexOf(':') !== -1;
	  var host = ipv6 ? '[' + obj.host + ']' : obj.host;

	  // define unique id
	  obj.id = obj.protocol + '://' + host + ':' + obj.port;
	  // define href
	  obj.href = obj.protocol + '://' + host + (loc && loc.port === obj.port ? '' : (':' + obj.port));

	  return obj;
	}

	var url$1 = /*#__PURE__*/Object.freeze({
		default: url_1,
		__moduleExports: url_1
	});

	var componentEmitter = createCommonjsModule(function (module) {
	/**
	 * Expose `Emitter`.
	 */

	{
	  module.exports = Emitter;
	}

	/**
	 * Initialize a new `Emitter`.
	 *
	 * @api public
	 */

	function Emitter(obj) {
	  if (obj) { return mixin(obj); }
	}
	/**
	 * Mixin the emitter properties.
	 *
	 * @param {Object} obj
	 * @return {Object}
	 * @api private
	 */

	function mixin(obj) {
	  for (var key in Emitter.prototype) {
	    obj[key] = Emitter.prototype[key];
	  }
	  return obj;
	}

	/**
	 * Listen on the given `event` with `fn`.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */

	Emitter.prototype.on =
	Emitter.prototype.addEventListener = function(event, fn){
	  this._callbacks = this._callbacks || {};
	  (this._callbacks['$' + event] = this._callbacks['$' + event] || [])
	    .push(fn);
	  return this;
	};

	/**
	 * Adds an `event` listener that will be invoked a single
	 * time then automatically removed.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */

	Emitter.prototype.once = function(event, fn){
	  function on() {
	    this.off(event, on);
	    fn.apply(this, arguments);
	  }

	  on.fn = fn;
	  this.on(event, on);
	  return this;
	};

	/**
	 * Remove the given callback for `event` or all
	 * registered callbacks.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */

	Emitter.prototype.off =
	Emitter.prototype.removeListener =
	Emitter.prototype.removeAllListeners =
	Emitter.prototype.removeEventListener = function(event, fn){
	  this._callbacks = this._callbacks || {};

	  // all
	  if (0 == arguments.length) {
	    this._callbacks = {};
	    return this;
	  }

	  // specific event
	  var callbacks = this._callbacks['$' + event];
	  if (!callbacks) { return this; }

	  // remove all handlers
	  if (1 == arguments.length) {
	    delete this._callbacks['$' + event];
	    return this;
	  }

	  // remove specific handler
	  var cb;
	  for (var i = 0; i < callbacks.length; i++) {
	    cb = callbacks[i];
	    if (cb === fn || cb.fn === fn) {
	      callbacks.splice(i, 1);
	      break;
	    }
	  }

	  // Remove event specific arrays for event types that no
	  // one is subscribed for to avoid memory leak.
	  if (callbacks.length === 0) {
	    delete this._callbacks['$' + event];
	  }

	  return this;
	};

	/**
	 * Emit `event` with the given args.
	 *
	 * @param {String} event
	 * @param {Mixed} ...
	 * @return {Emitter}
	 */

	Emitter.prototype.emit = function(event){
	  var arguments$1 = arguments;
	  var this$1 = this;

	  this._callbacks = this._callbacks || {};

	  var args = new Array(arguments.length - 1)
	    , callbacks = this._callbacks['$' + event];

	  for (var i = 1; i < arguments.length; i++) {
	    args[i - 1] = arguments$1[i];
	  }

	  if (callbacks) {
	    callbacks = callbacks.slice(0);
	    for (var i = 0, len = callbacks.length; i < len; ++i) {
	      callbacks[i].apply(this$1, args);
	    }
	  }

	  return this;
	};

	/**
	 * Return array of callbacks for `event`.
	 *
	 * @param {String} event
	 * @return {Array}
	 * @api public
	 */

	Emitter.prototype.listeners = function(event){
	  this._callbacks = this._callbacks || {};
	  return this._callbacks['$' + event] || [];
	};

	/**
	 * Check if this emitter has `event` handlers.
	 *
	 * @param {String} event
	 * @return {Boolean}
	 * @api public
	 */

	Emitter.prototype.hasListeners = function(event){
	  return !! this.listeners(event).length;
	};
	});

	var componentEmitter$1 = /*#__PURE__*/Object.freeze({
		default: componentEmitter,
		__moduleExports: componentEmitter
	});

	var toString$1 = {}.toString;

	var isarray = Array.isArray || function (arr) {
	  return toString$1.call(arr) == '[object Array]';
	};

	var isarray$1 = /*#__PURE__*/Object.freeze({
		default: isarray,
		__moduleExports: isarray
	});

	var isBuffer = isBuf;

	var withNativeBuffer = typeof Buffer === 'function' && typeof Buffer.isBuffer === 'function';
	var withNativeArrayBuffer = typeof ArrayBuffer === 'function';

	var isView = function (obj) {
	  return typeof ArrayBuffer.isView === 'function' ? ArrayBuffer.isView(obj) : (obj.buffer instanceof ArrayBuffer);
	};

	/**
	 * Returns true if obj is a buffer or an arraybuffer.
	 *
	 * @api private
	 */

	function isBuf(obj) {
	  return (withNativeBuffer && Buffer.isBuffer(obj)) ||
	          (withNativeArrayBuffer && (obj instanceof ArrayBuffer || isView(obj)));
	}

	var isBuffer$1 = /*#__PURE__*/Object.freeze({
		default: isBuffer,
		__moduleExports: isBuffer
	});

	var isArray = ( isarray$1 && isarray ) || isarray$1;

	var isBuf$1 = ( isBuffer$1 && isBuffer ) || isBuffer$1;

	/*global Blob,File*/

	/**
	 * Module requirements
	 */



	var toString$2 = Object.prototype.toString;
	var withNativeBlob = typeof Blob === 'function' || (typeof Blob !== 'undefined' && toString$2.call(Blob) === '[object BlobConstructor]');
	var withNativeFile = typeof File === 'function' || (typeof File !== 'undefined' && toString$2.call(File) === '[object FileConstructor]');

	/**
	 * Replaces every Buffer | ArrayBuffer in packet with a numbered placeholder.
	 * Anything with blobs or files should be fed through removeBlobs before coming
	 * here.
	 *
	 * @param {Object} packet - socket.io event packet
	 * @return {Object} with deconstructed packet and list of buffers
	 * @api public
	 */

	var deconstructPacket = function(packet) {
	  var buffers = [];
	  var packetData = packet.data;
	  var pack = packet;
	  pack.data = _deconstructPacket(packetData, buffers);
	  pack.attachments = buffers.length; // number of binary 'attachments'
	  return {packet: pack, buffers: buffers};
	};

	function _deconstructPacket(data, buffers) {
	  if (!data) { return data; }

	  if (isBuf$1(data)) {
	    var placeholder = { _placeholder: true, num: buffers.length };
	    buffers.push(data);
	    return placeholder;
	  } else if (isArray(data)) {
	    var newData = new Array(data.length);
	    for (var i = 0; i < data.length; i++) {
	      newData[i] = _deconstructPacket(data[i], buffers);
	    }
	    return newData;
	  } else if (typeof data === 'object' && !(data instanceof Date)) {
	    var newData = {};
	    for (var key in data) {
	      newData[key] = _deconstructPacket(data[key], buffers);
	    }
	    return newData;
	  }
	  return data;
	}

	/**
	 * Reconstructs a binary packet from its placeholder packet and buffers
	 *
	 * @param {Object} packet - event packet with placeholders
	 * @param {Array} buffers - binary buffers to put in placeholder positions
	 * @return {Object} reconstructed packet
	 * @api public
	 */

	var reconstructPacket = function(packet, buffers) {
	  packet.data = _reconstructPacket(packet.data, buffers);
	  packet.attachments = undefined; // no longer useful
	  return packet;
	};

	function _reconstructPacket(data, buffers) {
	  if (!data) { return data; }

	  if (data && data._placeholder) {
	    return buffers[data.num]; // appropriate buffer (should be natural order anyway)
	  } else if (isArray(data)) {
	    for (var i = 0; i < data.length; i++) {
	      data[i] = _reconstructPacket(data[i], buffers);
	    }
	  } else if (typeof data === 'object') {
	    for (var key in data) {
	      data[key] = _reconstructPacket(data[key], buffers);
	    }
	  }

	  return data;
	}

	/**
	 * Asynchronously removes Blobs or Files from data via
	 * FileReader's readAsArrayBuffer method. Used before encoding
	 * data as msgpack. Calls callback with the blobless data.
	 *
	 * @param {Object} data
	 * @param {Function} callback
	 * @api private
	 */

	var removeBlobs = function(data, callback) {
	  function _removeBlobs(obj, curKey, containingObject) {
	    if (!obj) { return obj; }

	    // convert any blob
	    if ((withNativeBlob && obj instanceof Blob) ||
	        (withNativeFile && obj instanceof File)) {
	      pendingBlobs++;

	      // async filereader
	      var fileReader = new FileReader();
	      fileReader.onload = function() { // this.result == arraybuffer
	        if (containingObject) {
	          containingObject[curKey] = this.result;
	        }
	        else {
	          bloblessData = this.result;
	        }

	        // if nothing pending its callback time
	        if(! --pendingBlobs) {
	          callback(bloblessData);
	        }
	      };

	      fileReader.readAsArrayBuffer(obj); // blob -> arraybuffer
	    } else if (isArray(obj)) { // handle array
	      for (var i = 0; i < obj.length; i++) {
	        _removeBlobs(obj[i], i, obj);
	      }
	    } else if (typeof obj === 'object' && !isBuf$1(obj)) { // and object
	      for (var key in obj) {
	        _removeBlobs(obj[key], key, obj);
	      }
	    }
	  }

	  var pendingBlobs = 0;
	  var bloblessData = data;
	  _removeBlobs(bloblessData);
	  if (!pendingBlobs) {
	    callback(bloblessData);
	  }
	};

	var binary = {
		deconstructPacket: deconstructPacket,
		reconstructPacket: reconstructPacket,
		removeBlobs: removeBlobs
	};

	var binary$1 = /*#__PURE__*/Object.freeze({
		default: binary,
		__moduleExports: binary,
		deconstructPacket: deconstructPacket,
		reconstructPacket: reconstructPacket,
		removeBlobs: removeBlobs
	});

	var Emitter = ( componentEmitter$1 && componentEmitter ) || componentEmitter$1;

	var binary$2 = ( binary$1 && binary ) || binary$1;

	var socket_ioParser = createCommonjsModule(function (module, exports) {
	/**
	 * Module dependencies.
	 */

	var debug = require$$0$2('socket.io-parser');





	/**
	 * Protocol version.
	 *
	 * @api public
	 */

	exports.protocol = 4;

	/**
	 * Packet types.
	 *
	 * @api public
	 */

	exports.types = [
	  'CONNECT',
	  'DISCONNECT',
	  'EVENT',
	  'ACK',
	  'ERROR',
	  'BINARY_EVENT',
	  'BINARY_ACK'
	];

	/**
	 * Packet type `connect`.
	 *
	 * @api public
	 */

	exports.CONNECT = 0;

	/**
	 * Packet type `disconnect`.
	 *
	 * @api public
	 */

	exports.DISCONNECT = 1;

	/**
	 * Packet type `event`.
	 *
	 * @api public
	 */

	exports.EVENT = 2;

	/**
	 * Packet type `ack`.
	 *
	 * @api public
	 */

	exports.ACK = 3;

	/**
	 * Packet type `error`.
	 *
	 * @api public
	 */

	exports.ERROR = 4;

	/**
	 * Packet type 'binary event'
	 *
	 * @api public
	 */

	exports.BINARY_EVENT = 5;

	/**
	 * Packet type `binary ack`. For acks with binary arguments.
	 *
	 * @api public
	 */

	exports.BINARY_ACK = 6;

	/**
	 * Encoder constructor.
	 *
	 * @api public
	 */

	exports.Encoder = Encoder;

	/**
	 * Decoder constructor.
	 *
	 * @api public
	 */

	exports.Decoder = Decoder;

	/**
	 * A socket.io Encoder instance
	 *
	 * @api public
	 */

	function Encoder() {}

	var ERROR_PACKET = exports.ERROR + '"encode error"';

	/**
	 * Encode a packet as a single string if non-binary, or as a
	 * buffer sequence, depending on packet type.
	 *
	 * @param {Object} obj - packet object
	 * @param {Function} callback - function to handle encodings (likely engine.write)
	 * @return Calls callback with Array of encodings
	 * @api public
	 */

	Encoder.prototype.encode = function(obj, callback){
	  debug('encoding packet %j', obj);

	  if (exports.BINARY_EVENT === obj.type || exports.BINARY_ACK === obj.type) {
	    encodeAsBinary(obj, callback);
	  } else {
	    var encoding = encodeAsString(obj);
	    callback([encoding]);
	  }
	};

	/**
	 * Encode packet as string.
	 *
	 * @param {Object} packet
	 * @return {String} encoded
	 * @api private
	 */

	function encodeAsString(obj) {

	  // first is type
	  var str = '' + obj.type;

	  // attachments if we have them
	  if (exports.BINARY_EVENT === obj.type || exports.BINARY_ACK === obj.type) {
	    str += obj.attachments + '-';
	  }

	  // if we have a namespace other than `/`
	  // we append it followed by a comma `,`
	  if (obj.nsp && '/' !== obj.nsp) {
	    str += obj.nsp + ',';
	  }

	  // immediately followed by the id
	  if (null != obj.id) {
	    str += obj.id;
	  }

	  // json data
	  if (null != obj.data) {
	    var payload = tryStringify(obj.data);
	    if (payload !== false) {
	      str += payload;
	    } else {
	      return ERROR_PACKET;
	    }
	  }

	  debug('encoded %j as %s', obj, str);
	  return str;
	}

	function tryStringify(str) {
	  try {
	    return JSON.stringify(str);
	  } catch(e){
	    return false;
	  }
	}

	/**
	 * Encode packet as 'buffer sequence' by removing blobs, and
	 * deconstructing packet into object with placeholders and
	 * a list of buffers.
	 *
	 * @param {Object} packet
	 * @return {Buffer} encoded
	 * @api private
	 */

	function encodeAsBinary(obj, callback) {

	  function writeEncoding(bloblessData) {
	    var deconstruction = binary$2.deconstructPacket(bloblessData);
	    var pack = encodeAsString(deconstruction.packet);
	    var buffers = deconstruction.buffers;

	    buffers.unshift(pack); // add packet info to beginning of data list
	    callback(buffers); // write all the buffers
	  }

	  binary$2.removeBlobs(obj, writeEncoding);
	}

	/**
	 * A socket.io Decoder instance
	 *
	 * @return {Object} decoder
	 * @api public
	 */

	function Decoder() {
	  this.reconstructor = null;
	}

	/**
	 * Mix in `Emitter` with Decoder.
	 */

	Emitter(Decoder.prototype);

	/**
	 * Decodes an encoded packet string into packet JSON.
	 *
	 * @param {String} obj - encoded packet
	 * @return {Object} packet
	 * @api public
	 */

	Decoder.prototype.add = function(obj) {
	  var packet;
	  if (typeof obj === 'string') {
	    packet = decodeString(obj);
	    if (exports.BINARY_EVENT === packet.type || exports.BINARY_ACK === packet.type) { // binary packet's json
	      this.reconstructor = new BinaryReconstructor(packet);

	      // no attachments, labeled binary but no binary data to follow
	      if (this.reconstructor.reconPack.attachments === 0) {
	        this.emit('decoded', packet);
	      }
	    } else { // non-binary full packet
	      this.emit('decoded', packet);
	    }
	  } else if (isBuf$1(obj) || obj.base64) { // raw binary data
	    if (!this.reconstructor) {
	      throw new Error('got binary data when not reconstructing a packet');
	    } else {
	      packet = this.reconstructor.takeBinaryData(obj);
	      if (packet) { // received final buffer
	        this.reconstructor = null;
	        this.emit('decoded', packet);
	      }
	    }
	  } else {
	    throw new Error('Unknown type: ' + obj);
	  }
	};

	/**
	 * Decode a packet String (JSON data)
	 *
	 * @param {String} str
	 * @return {Object} packet
	 * @api private
	 */

	function decodeString(str) {
	  var i = 0;
	  // look up type
	  var p = {
	    type: Number(str.charAt(0))
	  };

	  if (null == exports.types[p.type]) {
	    return error('unknown packet type ' + p.type);
	  }

	  // look up attachments if type binary
	  if (exports.BINARY_EVENT === p.type || exports.BINARY_ACK === p.type) {
	    var start = i + 1;
	    while (str.charAt(++i) !== '-' && i != str.length) {}
	    var buf = str.substring(start, i);
	    if (buf != Number(buf) || str.charAt(i) !== '-') {
	      throw new Error('Illegal attachments');
	    }
	    p.attachments = Number(buf);
	  }

	  // look up namespace (if any)
	  if ('/' === str.charAt(i + 1)) {
	    var start = i + 1;
	    while (++i) {
	      var c = str.charAt(i);
	      if (',' === c) { break; }
	      if (i === str.length) { break; }
	    }
	    p.nsp = str.substring(start, i);
	  } else {
	    p.nsp = '/';
	  }

	  // look up id
	  var next = str.charAt(i + 1);
	  if ('' !== next && Number(next) == next) {
	    var start = i + 1;
	    while (++i) {
	      var c = str.charAt(i);
	      if (null == c || Number(c) != c) {
	        --i;
	        break;
	      }
	      if (i === str.length) { break; }
	    }
	    p.id = Number(str.substring(start, i + 1));
	  }

	  // look up json data
	  if (str.charAt(++i)) {
	    var payload = tryParse(str.substr(i));
	    var isPayloadValid = payload !== false && (p.type === exports.ERROR || isArray(payload));
	    if (isPayloadValid) {
	      p.data = payload;
	    } else {
	      return error('invalid payload');
	    }
	  }

	  debug('decoded %s as %j', str, p);
	  return p;
	}

	function tryParse(str) {
	  try {
	    return JSON.parse(str);
	  } catch(e){
	    return false;
	  }
	}

	/**
	 * Deallocates a parser's resources
	 *
	 * @api public
	 */

	Decoder.prototype.destroy = function() {
	  if (this.reconstructor) {
	    this.reconstructor.finishedReconstruction();
	  }
	};

	/**
	 * A manager of a binary event's 'buffer sequence'. Should
	 * be constructed whenever a packet of type BINARY_EVENT is
	 * decoded.
	 *
	 * @param {Object} packet
	 * @return {BinaryReconstructor} initialized reconstructor
	 * @api private
	 */

	function BinaryReconstructor(packet) {
	  this.reconPack = packet;
	  this.buffers = [];
	}

	/**
	 * Method to be called when binary data received from connection
	 * after a BINARY_EVENT packet.
	 *
	 * @param {Buffer | ArrayBuffer} binData - the raw binary data received
	 * @return {null | Object} returns null if more binary data is expected or
	 *   a reconstructed packet object if all buffers have been received.
	 * @api private
	 */

	BinaryReconstructor.prototype.takeBinaryData = function(binData) {
	  this.buffers.push(binData);
	  if (this.buffers.length === this.reconPack.attachments) { // done with buffer list
	    var packet = binary$2.reconstructPacket(this.reconPack, this.buffers);
	    this.finishedReconstruction();
	    return packet;
	  }
	  return null;
	};

	/**
	 * Cleans up binary packet reconstruction variables.
	 *
	 * @api private
	 */

	BinaryReconstructor.prototype.finishedReconstruction = function() {
	  this.reconPack = null;
	  this.buffers = [];
	};

	function error(msg) {
	  return {
	    type: exports.ERROR,
	    data: 'parser error: ' + msg
	  };
	}
	});
	var socket_ioParser_1 = socket_ioParser.protocol;
	var socket_ioParser_2 = socket_ioParser.types;
	var socket_ioParser_3 = socket_ioParser.CONNECT;
	var socket_ioParser_4 = socket_ioParser.DISCONNECT;
	var socket_ioParser_5 = socket_ioParser.EVENT;
	var socket_ioParser_6 = socket_ioParser.ACK;
	var socket_ioParser_7 = socket_ioParser.ERROR;
	var socket_ioParser_8 = socket_ioParser.BINARY_EVENT;
	var socket_ioParser_9 = socket_ioParser.BINARY_ACK;
	var socket_ioParser_10 = socket_ioParser.Encoder;
	var socket_ioParser_11 = socket_ioParser.Decoder;

	var socket_ioParser$1 = /*#__PURE__*/Object.freeze({
		default: socket_ioParser,
		__moduleExports: socket_ioParser,
		protocol: socket_ioParser_1,
		types: socket_ioParser_2,
		CONNECT: socket_ioParser_3,
		DISCONNECT: socket_ioParser_4,
		EVENT: socket_ioParser_5,
		ACK: socket_ioParser_6,
		ERROR: socket_ioParser_7,
		BINARY_EVENT: socket_ioParser_8,
		BINARY_ACK: socket_ioParser_9,
		Encoder: socket_ioParser_10,
		Decoder: socket_ioParser_11
	});

	var hasCors = createCommonjsModule(function (module) {
	/**
	 * Module exports.
	 *
	 * Logic borrowed from Modernizr:
	 *
	 *   - https://github.com/Modernizr/Modernizr/blob/master/feature-detects/cors.js
	 */

	try {
	  module.exports = typeof XMLHttpRequest !== 'undefined' &&
	    'withCredentials' in new XMLHttpRequest();
	} catch (err) {
	  // if XMLHttp support is disabled in IE then it will throw
	  // when trying to create
	  module.exports = false;
	}
	});

	var hasCors$1 = /*#__PURE__*/Object.freeze({
		default: hasCors,
		__moduleExports: hasCors
	});

	var globalThis_browser = (function () {
	  if (typeof self !== 'undefined') {
	    return self;
	  } else if (typeof window !== 'undefined') {
	    return window;
	  } else {
	    return Function('return this')(); // eslint-disable-line no-new-func
	  }
	})();

	var globalThis_browser$1 = /*#__PURE__*/Object.freeze({
		default: globalThis_browser,
		__moduleExports: globalThis_browser
	});

	var hasCORS = ( hasCors$1 && hasCors ) || hasCors$1;

	var globalThis = ( globalThis_browser$1 && globalThis_browser ) || globalThis_browser$1;

	// browser shim for xmlhttprequest module




	var xmlhttprequest = function (opts) {
	  var xdomain = opts.xdomain;

	  // scheme must be same when usign XDomainRequest
	  // http://blogs.msdn.com/b/ieinternals/archive/2010/05/13/xdomainrequest-restrictions-limitations-and-workarounds.aspx
	  var xscheme = opts.xscheme;

	  // XDomainRequest has a flow of not sending cookie, therefore it should be disabled as a default.
	  // https://github.com/Automattic/engine.io-client/pull/217
	  var enablesXDR = opts.enablesXDR;

	  // XMLHttpRequest can be disabled on IE
	  try {
	    if ('undefined' !== typeof XMLHttpRequest && (!xdomain || hasCORS)) {
	      return new XMLHttpRequest();
	    }
	  } catch (e) { }

	  // Use XDomainRequest for IE8 if enablesXDR is true
	  // because loading bar keeps flashing when using jsonp-polling
	  // https://github.com/yujiosaka/socke.io-ie8-loading-example
	  try {
	    if ('undefined' !== typeof XDomainRequest && !xscheme && enablesXDR) {
	      return new XDomainRequest();
	    }
	  } catch (e) { }

	  if (!xdomain) {
	    try {
	      return new globalThis[['Active'].concat('Object').join('X')]('Microsoft.XMLHTTP');
	    } catch (e) { }
	  }
	};

	var xmlhttprequest$1 = /*#__PURE__*/Object.freeze({
		default: xmlhttprequest,
		__moduleExports: xmlhttprequest
	});

	/**
	 * Gets the keys for an object.
	 *
	 * @return {Array} keys
	 * @api private
	 */

	var keys = Object.keys || function keys (obj){
	  var arr = [];
	  var has = Object.prototype.hasOwnProperty;

	  for (var i in obj) {
	    if (has.call(obj, i)) {
	      arr.push(i);
	    }
	  }
	  return arr;
	};

	var keys$1 = /*#__PURE__*/Object.freeze({
		default: keys,
		__moduleExports: keys
	});

	var toString$3 = {}.toString;

	var isarray$2 = Array.isArray || function (arr) {
	  return toString$3.call(arr) == '[object Array]';
	};

	var isarray$3 = /*#__PURE__*/Object.freeze({
		default: isarray$2,
		__moduleExports: isarray$2
	});

	var isArray$1 = ( isarray$3 && isarray$2 ) || isarray$3;

	/* global Blob File */

	/*
	 * Module requirements.
	 */



	var toString$4 = Object.prototype.toString;
	var withNativeBlob$1 = typeof Blob === 'function' ||
	                        typeof Blob !== 'undefined' && toString$4.call(Blob) === '[object BlobConstructor]';
	var withNativeFile$1 = typeof File === 'function' ||
	                        typeof File !== 'undefined' && toString$4.call(File) === '[object FileConstructor]';

	/**
	 * Module exports.
	 */

	var hasBinary2 = hasBinary;

	/**
	 * Checks for binary data.
	 *
	 * Supports Buffer, ArrayBuffer, Blob and File.
	 *
	 * @param {Object} anything
	 * @api public
	 */

	function hasBinary (obj) {
	  if (!obj || typeof obj !== 'object') {
	    return false;
	  }

	  if (isArray$1(obj)) {
	    for (var i = 0, l = obj.length; i < l; i++) {
	      if (hasBinary(obj[i])) {
	        return true;
	      }
	    }
	    return false;
	  }

	  if ((typeof Buffer === 'function' && Buffer.isBuffer && Buffer.isBuffer(obj)) ||
	    (typeof ArrayBuffer === 'function' && obj instanceof ArrayBuffer) ||
	    (withNativeBlob$1 && obj instanceof Blob) ||
	    (withNativeFile$1 && obj instanceof File)
	  ) {
	    return true;
	  }

	  // see: https://github.com/Automattic/has-binary/pull/4
	  if (obj.toJSON && typeof obj.toJSON === 'function' && arguments.length === 1) {
	    return hasBinary(obj.toJSON(), true);
	  }

	  for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key) && hasBinary(obj[key])) {
	      return true;
	    }
	  }

	  return false;
	}

	var hasBinary2$1 = /*#__PURE__*/Object.freeze({
		default: hasBinary2,
		__moduleExports: hasBinary2
	});

	/**
	 * An abstraction for slicing an arraybuffer even when
	 * ArrayBuffer.prototype.slice is not supported
	 *
	 * @api public
	 */

	var arraybuffer_slice = function(arraybuffer, start, end) {
	  var bytes = arraybuffer.byteLength;
	  start = start || 0;
	  end = end || bytes;

	  if (arraybuffer.slice) { return arraybuffer.slice(start, end); }

	  if (start < 0) { start += bytes; }
	  if (end < 0) { end += bytes; }
	  if (end > bytes) { end = bytes; }

	  if (start >= bytes || start >= end || bytes === 0) {
	    return new ArrayBuffer(0);
	  }

	  var abv = new Uint8Array(arraybuffer);
	  var result = new Uint8Array(end - start);
	  for (var i = start, ii = 0; i < end; i++, ii++) {
	    result[ii] = abv[i];
	  }
	  return result.buffer;
	};

	var arraybuffer_slice$1 = /*#__PURE__*/Object.freeze({
		default: arraybuffer_slice,
		__moduleExports: arraybuffer_slice
	});

	var after_1 = after;

	function after(count, callback, err_cb) {
	    var bail = false;
	    err_cb = err_cb || noop$1;
	    proxy.count = count;

	    return (count === 0) ? callback() : proxy

	    function proxy(err, result) {
	        if (proxy.count <= 0) {
	            throw new Error('after called too many times')
	        }
	        --proxy.count;

	        // after first error, rest are passed to err_cb
	        if (err) {
	            bail = true;
	            callback(err);
	            // future error callbacks will go to error handler
	            callback = err_cb;
	        } else if (proxy.count === 0 && !bail) {
	            callback(null, result);
	        }
	    }
	}

	function noop$1() {}

	var after$1 = /*#__PURE__*/Object.freeze({
		default: after_1,
		__moduleExports: after_1
	});

	/*! https://mths.be/utf8js v2.1.2 by @mathias */

	var stringFromCharCode = String.fromCharCode;

	// Taken from https://mths.be/punycode
	function ucs2decode(string) {
		var output = [];
		var counter = 0;
		var length = string.length;
		var value;
		var extra;
		while (counter < length) {
			value = string.charCodeAt(counter++);
			if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
				// high surrogate, and there is a next character
				extra = string.charCodeAt(counter++);
				if ((extra & 0xFC00) == 0xDC00) { // low surrogate
					output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
				} else {
					// unmatched surrogate; only append this code unit, in case the next
					// code unit is the high surrogate of a surrogate pair
					output.push(value);
					counter--;
				}
			} else {
				output.push(value);
			}
		}
		return output;
	}

	// Taken from https://mths.be/punycode
	function ucs2encode(array) {
		var length = array.length;
		var index = -1;
		var value;
		var output = '';
		while (++index < length) {
			value = array[index];
			if (value > 0xFFFF) {
				value -= 0x10000;
				output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
				value = 0xDC00 | value & 0x3FF;
			}
			output += stringFromCharCode(value);
		}
		return output;
	}

	function checkScalarValue(codePoint, strict) {
		if (codePoint >= 0xD800 && codePoint <= 0xDFFF) {
			if (strict) {
				throw Error(
					'Lone surrogate U+' + codePoint.toString(16).toUpperCase() +
					' is not a scalar value'
				);
			}
			return false;
		}
		return true;
	}
	/*--------------------------------------------------------------------------*/

	function createByte(codePoint, shift) {
		return stringFromCharCode(((codePoint >> shift) & 0x3F) | 0x80);
	}

	function encodeCodePoint(codePoint, strict) {
		if ((codePoint & 0xFFFFFF80) == 0) { // 1-byte sequence
			return stringFromCharCode(codePoint);
		}
		var symbol = '';
		if ((codePoint & 0xFFFFF800) == 0) { // 2-byte sequence
			symbol = stringFromCharCode(((codePoint >> 6) & 0x1F) | 0xC0);
		}
		else if ((codePoint & 0xFFFF0000) == 0) { // 3-byte sequence
			if (!checkScalarValue(codePoint, strict)) {
				codePoint = 0xFFFD;
			}
			symbol = stringFromCharCode(((codePoint >> 12) & 0x0F) | 0xE0);
			symbol += createByte(codePoint, 6);
		}
		else if ((codePoint & 0xFFE00000) == 0) { // 4-byte sequence
			symbol = stringFromCharCode(((codePoint >> 18) & 0x07) | 0xF0);
			symbol += createByte(codePoint, 12);
			symbol += createByte(codePoint, 6);
		}
		symbol += stringFromCharCode((codePoint & 0x3F) | 0x80);
		return symbol;
	}

	function utf8encode(string, opts) {
		opts = opts || {};
		var strict = false !== opts.strict;

		var codePoints = ucs2decode(string);
		var length = codePoints.length;
		var index = -1;
		var codePoint;
		var byteString = '';
		while (++index < length) {
			codePoint = codePoints[index];
			byteString += encodeCodePoint(codePoint, strict);
		}
		return byteString;
	}

	/*--------------------------------------------------------------------------*/

	function readContinuationByte() {
		if (byteIndex >= byteCount) {
			throw Error('Invalid byte index');
		}

		var continuationByte = byteArray[byteIndex] & 0xFF;
		byteIndex++;

		if ((continuationByte & 0xC0) == 0x80) {
			return continuationByte & 0x3F;
		}

		// If we end up here, it’s not a continuation byte
		throw Error('Invalid continuation byte');
	}

	function decodeSymbol(strict) {
		var byte1;
		var byte2;
		var byte3;
		var byte4;
		var codePoint;

		if (byteIndex > byteCount) {
			throw Error('Invalid byte index');
		}

		if (byteIndex == byteCount) {
			return false;
		}

		// Read first byte
		byte1 = byteArray[byteIndex] & 0xFF;
		byteIndex++;

		// 1-byte sequence (no continuation bytes)
		if ((byte1 & 0x80) == 0) {
			return byte1;
		}

		// 2-byte sequence
		if ((byte1 & 0xE0) == 0xC0) {
			byte2 = readContinuationByte();
			codePoint = ((byte1 & 0x1F) << 6) | byte2;
			if (codePoint >= 0x80) {
				return codePoint;
			} else {
				throw Error('Invalid continuation byte');
			}
		}

		// 3-byte sequence (may include unpaired surrogates)
		if ((byte1 & 0xF0) == 0xE0) {
			byte2 = readContinuationByte();
			byte3 = readContinuationByte();
			codePoint = ((byte1 & 0x0F) << 12) | (byte2 << 6) | byte3;
			if (codePoint >= 0x0800) {
				return checkScalarValue(codePoint, strict) ? codePoint : 0xFFFD;
			} else {
				throw Error('Invalid continuation byte');
			}
		}

		// 4-byte sequence
		if ((byte1 & 0xF8) == 0xF0) {
			byte2 = readContinuationByte();
			byte3 = readContinuationByte();
			byte4 = readContinuationByte();
			codePoint = ((byte1 & 0x07) << 0x12) | (byte2 << 0x0C) |
				(byte3 << 0x06) | byte4;
			if (codePoint >= 0x010000 && codePoint <= 0x10FFFF) {
				return codePoint;
			}
		}

		throw Error('Invalid UTF-8 detected');
	}

	var byteArray;
	var byteCount;
	var byteIndex;
	function utf8decode(byteString, opts) {
		opts = opts || {};
		var strict = false !== opts.strict;

		byteArray = ucs2decode(byteString);
		byteCount = byteArray.length;
		byteIndex = 0;
		var codePoints = [];
		var tmp;
		while ((tmp = decodeSymbol(strict)) !== false) {
			codePoints.push(tmp);
		}
		return ucs2encode(codePoints);
	}

	var utf8 = {
		version: '2.1.2',
		encode: utf8encode,
		decode: utf8decode
	};
	var utf8_1 = utf8.version;
	var utf8_2 = utf8.encode;
	var utf8_3 = utf8.decode;

	var utf8$1 = /*#__PURE__*/Object.freeze({
		default: utf8,
		__moduleExports: utf8,
		version: utf8_1,
		encode: utf8_2,
		decode: utf8_3
	});

	var base64Arraybuffer = createCommonjsModule(function (module, exports) {
	/*
	 * base64-arraybuffer
	 * https://github.com/niklasvh/base64-arraybuffer
	 *
	 * Copyright (c) 2012 Niklas von Hertzen
	 * Licensed under the MIT license.
	 */
	(function(chars){

	  exports.encode = function(arraybuffer) {
	    var bytes = new Uint8Array(arraybuffer),
	    i, len = bytes.length, base64 = "";

	    for (i = 0; i < len; i+=3) {
	      base64 += chars[bytes[i] >> 2];
	      base64 += chars[((bytes[i] & 3) << 4) | (bytes[i + 1] >> 4)];
	      base64 += chars[((bytes[i + 1] & 15) << 2) | (bytes[i + 2] >> 6)];
	      base64 += chars[bytes[i + 2] & 63];
	    }

	    if ((len % 3) === 2) {
	      base64 = base64.substring(0, base64.length - 1) + "=";
	    } else if (len % 3 === 1) {
	      base64 = base64.substring(0, base64.length - 2) + "==";
	    }

	    return base64;
	  };

	  exports.decode =  function(base64) {
	    var bufferLength = base64.length * 0.75,
	    len = base64.length, i, p = 0,
	    encoded1, encoded2, encoded3, encoded4;

	    if (base64[base64.length - 1] === "=") {
	      bufferLength--;
	      if (base64[base64.length - 2] === "=") {
	        bufferLength--;
	      }
	    }

	    var arraybuffer = new ArrayBuffer(bufferLength),
	    bytes = new Uint8Array(arraybuffer);

	    for (i = 0; i < len; i+=4) {
	      encoded1 = chars.indexOf(base64[i]);
	      encoded2 = chars.indexOf(base64[i+1]);
	      encoded3 = chars.indexOf(base64[i+2]);
	      encoded4 = chars.indexOf(base64[i+3]);

	      bytes[p++] = (encoded1 << 2) | (encoded2 >> 4);
	      bytes[p++] = ((encoded2 & 15) << 4) | (encoded3 >> 2);
	      bytes[p++] = ((encoded3 & 3) << 6) | (encoded4 & 63);
	    }

	    return arraybuffer;
	  };
	})("ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/");
	});
	var base64Arraybuffer_1 = base64Arraybuffer.encode;
	var base64Arraybuffer_2 = base64Arraybuffer.decode;

	var base64Arraybuffer$1 = /*#__PURE__*/Object.freeze({
		default: base64Arraybuffer,
		__moduleExports: base64Arraybuffer,
		encode: base64Arraybuffer_1,
		decode: base64Arraybuffer_2
	});

	/**
	 * Create a blob builder even when vendor prefixes exist
	 */

	var BlobBuilder$1 = typeof BlobBuilder$1 !== 'undefined' ? BlobBuilder$1 :
	  typeof WebKitBlobBuilder !== 'undefined' ? WebKitBlobBuilder :
	  typeof MSBlobBuilder !== 'undefined' ? MSBlobBuilder :
	  typeof MozBlobBuilder !== 'undefined' ? MozBlobBuilder : 
	  false;

	/**
	 * Check if Blob constructor is supported
	 */

	var blobSupported = (function() {
	  try {
	    var a = new Blob(['hi']);
	    return a.size === 2;
	  } catch(e) {
	    return false;
	  }
	})();

	/**
	 * Check if Blob constructor supports ArrayBufferViews
	 * Fails in Safari 6, so we need to map to ArrayBuffers there.
	 */

	var blobSupportsArrayBufferView = blobSupported && (function() {
	  try {
	    var b = new Blob([new Uint8Array([1,2])]);
	    return b.size === 2;
	  } catch(e) {
	    return false;
	  }
	})();

	/**
	 * Check if BlobBuilder is supported
	 */

	var blobBuilderSupported = BlobBuilder$1
	  && BlobBuilder$1.prototype.append
	  && BlobBuilder$1.prototype.getBlob;

	/**
	 * Helper function that maps ArrayBufferViews to ArrayBuffers
	 * Used by BlobBuilder constructor and old browsers that didn't
	 * support it in the Blob constructor.
	 */

	function mapArrayBufferViews(ary) {
	  return ary.map(function(chunk) {
	    if (chunk.buffer instanceof ArrayBuffer) {
	      var buf = chunk.buffer;

	      // if this is a subarray, make a copy so we only
	      // include the subarray region from the underlying buffer
	      if (chunk.byteLength !== buf.byteLength) {
	        var copy = new Uint8Array(chunk.byteLength);
	        copy.set(new Uint8Array(buf, chunk.byteOffset, chunk.byteLength));
	        buf = copy.buffer;
	      }

	      return buf;
	    }

	    return chunk;
	  });
	}

	function BlobBuilderConstructor(ary, options) {
	  options = options || {};

	  var bb = new BlobBuilder$1();
	  mapArrayBufferViews(ary).forEach(function(part) {
	    bb.append(part);
	  });

	  return (options.type) ? bb.getBlob(options.type) : bb.getBlob();
	}
	function BlobConstructor(ary, options) {
	  return new Blob(mapArrayBufferViews(ary), options || {});
	}
	if (typeof Blob !== 'undefined') {
	  BlobBuilderConstructor.prototype = Blob.prototype;
	  BlobConstructor.prototype = Blob.prototype;
	}

	var blob = (function() {
	  if (blobSupported) {
	    return blobSupportsArrayBufferView ? Blob : BlobConstructor;
	  } else if (blobBuilderSupported) {
	    return BlobBuilderConstructor;
	  } else {
	    return undefined;
	  }
	})();

	var blob$1 = /*#__PURE__*/Object.freeze({
		default: blob,
		__moduleExports: blob
	});

	var keys$2 = ( keys$1 && keys ) || keys$1;

	var hasBinary$1 = ( hasBinary2$1 && hasBinary2 ) || hasBinary2$1;

	var sliceBuffer = ( arraybuffer_slice$1 && arraybuffer_slice ) || arraybuffer_slice$1;

	var after$2 = ( after$1 && after_1 ) || after$1;

	var utf8$2 = ( utf8$1 && utf8 ) || utf8$1;

	var require$$0$3 = ( base64Arraybuffer$1 && base64Arraybuffer ) || base64Arraybuffer$1;

	var Blob$1 = ( blob$1 && blob ) || blob$1;

	var browser$2 = createCommonjsModule(function (module, exports) {
	/**
	 * Module dependencies.
	 */







	var base64encoder;
	if (typeof ArrayBuffer !== 'undefined') {
	  base64encoder = require$$0$3;
	}

	/**
	 * Check if we are running an android browser. That requires us to use
	 * ArrayBuffer with polling transports...
	 *
	 * http://ghinda.net/jpeg-blob-ajax-android/
	 */

	var isAndroid = typeof navigator !== 'undefined' && /Android/i.test(navigator.userAgent);

	/**
	 * Check if we are running in PhantomJS.
	 * Uploading a Blob with PhantomJS does not work correctly, as reported here:
	 * https://github.com/ariya/phantomjs/issues/11395
	 * @type boolean
	 */
	var isPhantomJS = typeof navigator !== 'undefined' && /PhantomJS/i.test(navigator.userAgent);

	/**
	 * When true, avoids using Blobs to encode payloads.
	 * @type boolean
	 */
	var dontSendBlobs = isAndroid || isPhantomJS;

	/**
	 * Current protocol version.
	 */

	exports.protocol = 3;

	/**
	 * Packet types.
	 */

	var packets = exports.packets = {
	    open:     0    // non-ws
	  , close:    1    // non-ws
	  , ping:     2
	  , pong:     3
	  , message:  4
	  , upgrade:  5
	  , noop:     6
	};

	var packetslist = keys$2(packets);

	/**
	 * Premade error packet.
	 */

	var err = { type: 'error', data: 'parser error' };

	/**
	 * Create a blob api even for blob builder when vendor prefixes exist
	 */



	/**
	 * Encodes a packet.
	 *
	 *     <packet type id> [ <data> ]
	 *
	 * Example:
	 *
	 *     5hello world
	 *     3
	 *     4
	 *
	 * Binary is encoded in an identical principle
	 *
	 * @api private
	 */

	exports.encodePacket = function (packet, supportsBinary, utf8encode, callback) {
	  if (typeof supportsBinary === 'function') {
	    callback = supportsBinary;
	    supportsBinary = false;
	  }

	  if (typeof utf8encode === 'function') {
	    callback = utf8encode;
	    utf8encode = null;
	  }

	  var data = (packet.data === undefined)
	    ? undefined
	    : packet.data.buffer || packet.data;

	  if (typeof ArrayBuffer !== 'undefined' && data instanceof ArrayBuffer) {
	    return encodeArrayBuffer(packet, supportsBinary, callback);
	  } else if (typeof Blob$1 !== 'undefined' && data instanceof Blob$1) {
	    return encodeBlob(packet, supportsBinary, callback);
	  }

	  // might be an object with { base64: true, data: dataAsBase64String }
	  if (data && data.base64) {
	    return encodeBase64Object(packet, callback);
	  }

	  // Sending data as a utf-8 string
	  var encoded = packets[packet.type];

	  // data fragment is optional
	  if (undefined !== packet.data) {
	    encoded += utf8encode ? utf8$2.encode(String(packet.data), { strict: false }) : String(packet.data);
	  }

	  return callback('' + encoded);

	};

	function encodeBase64Object(packet, callback) {
	  // packet data is an object { base64: true, data: dataAsBase64String }
	  var message = 'b' + exports.packets[packet.type] + packet.data.data;
	  return callback(message);
	}

	/**
	 * Encode packet helpers for binary types
	 */

	function encodeArrayBuffer(packet, supportsBinary, callback) {
	  if (!supportsBinary) {
	    return exports.encodeBase64Packet(packet, callback);
	  }

	  var data = packet.data;
	  var contentArray = new Uint8Array(data);
	  var resultBuffer = new Uint8Array(1 + data.byteLength);

	  resultBuffer[0] = packets[packet.type];
	  for (var i = 0; i < contentArray.length; i++) {
	    resultBuffer[i+1] = contentArray[i];
	  }

	  return callback(resultBuffer.buffer);
	}

	function encodeBlobAsArrayBuffer(packet, supportsBinary, callback) {
	  if (!supportsBinary) {
	    return exports.encodeBase64Packet(packet, callback);
	  }

	  var fr = new FileReader();
	  fr.onload = function() {
	    exports.encodePacket({ type: packet.type, data: fr.result }, supportsBinary, true, callback);
	  };
	  return fr.readAsArrayBuffer(packet.data);
	}

	function encodeBlob(packet, supportsBinary, callback) {
	  if (!supportsBinary) {
	    return exports.encodeBase64Packet(packet, callback);
	  }

	  if (dontSendBlobs) {
	    return encodeBlobAsArrayBuffer(packet, supportsBinary, callback);
	  }

	  var length = new Uint8Array(1);
	  length[0] = packets[packet.type];
	  var blob = new Blob$1([length.buffer, packet.data]);

	  return callback(blob);
	}

	/**
	 * Encodes a packet with binary data in a base64 string
	 *
	 * @param {Object} packet, has `type` and `data`
	 * @return {String} base64 encoded message
	 */

	exports.encodeBase64Packet = function(packet, callback) {
	  var message = 'b' + exports.packets[packet.type];
	  if (typeof Blob$1 !== 'undefined' && packet.data instanceof Blob$1) {
	    var fr = new FileReader();
	    fr.onload = function() {
	      var b64 = fr.result.split(',')[1];
	      callback(message + b64);
	    };
	    return fr.readAsDataURL(packet.data);
	  }

	  var b64data;
	  try {
	    b64data = String.fromCharCode.apply(null, new Uint8Array(packet.data));
	  } catch (e) {
	    // iPhone Safari doesn't let you apply with typed arrays
	    var typed = new Uint8Array(packet.data);
	    var basic = new Array(typed.length);
	    for (var i = 0; i < typed.length; i++) {
	      basic[i] = typed[i];
	    }
	    b64data = String.fromCharCode.apply(null, basic);
	  }
	  message += btoa(b64data);
	  return callback(message);
	};

	/**
	 * Decodes a packet. Changes format to Blob if requested.
	 *
	 * @return {Object} with `type` and `data` (if any)
	 * @api private
	 */

	exports.decodePacket = function (data, binaryType, utf8decode) {
	  if (data === undefined) {
	    return err;
	  }
	  // String data
	  if (typeof data === 'string') {
	    if (data.charAt(0) === 'b') {
	      return exports.decodeBase64Packet(data.substr(1), binaryType);
	    }

	    if (utf8decode) {
	      data = tryDecode(data);
	      if (data === false) {
	        return err;
	      }
	    }
	    var type = data.charAt(0);

	    if (Number(type) != type || !packetslist[type]) {
	      return err;
	    }

	    if (data.length > 1) {
	      return { type: packetslist[type], data: data.substring(1) };
	    } else {
	      return { type: packetslist[type] };
	    }
	  }

	  var asArray = new Uint8Array(data);
	  var type = asArray[0];
	  var rest = sliceBuffer(data, 1);
	  if (Blob$1 && binaryType === 'blob') {
	    rest = new Blob$1([rest]);
	  }
	  return { type: packetslist[type], data: rest };
	};

	function tryDecode(data) {
	  try {
	    data = utf8$2.decode(data, { strict: false });
	  } catch (e) {
	    return false;
	  }
	  return data;
	}

	/**
	 * Decodes a packet encoded in a base64 string
	 *
	 * @param {String} base64 encoded message
	 * @return {Object} with `type` and `data` (if any)
	 */

	exports.decodeBase64Packet = function(msg, binaryType) {
	  var type = packetslist[msg.charAt(0)];
	  if (!base64encoder) {
	    return { type: type, data: { base64: true, data: msg.substr(1) } };
	  }

	  var data = base64encoder.decode(msg.substr(1));

	  if (binaryType === 'blob' && Blob$1) {
	    data = new Blob$1([data]);
	  }

	  return { type: type, data: data };
	};

	/**
	 * Encodes multiple messages (payload).
	 *
	 *     <length>:data
	 *
	 * Example:
	 *
	 *     11:hello world2:hi
	 *
	 * If any contents are binary, they will be encoded as base64 strings. Base64
	 * encoded strings are marked with a b before the length specifier
	 *
	 * @param {Array} packets
	 * @api private
	 */

	exports.encodePayload = function (packets, supportsBinary, callback) {
	  if (typeof supportsBinary === 'function') {
	    callback = supportsBinary;
	    supportsBinary = null;
	  }

	  var isBinary = hasBinary$1(packets);

	  if (supportsBinary && isBinary) {
	    if (Blob$1 && !dontSendBlobs) {
	      return exports.encodePayloadAsBlob(packets, callback);
	    }

	    return exports.encodePayloadAsArrayBuffer(packets, callback);
	  }

	  if (!packets.length) {
	    return callback('0:');
	  }

	  function setLengthHeader(message) {
	    return message.length + ':' + message;
	  }

	  function encodeOne(packet, doneCallback) {
	    exports.encodePacket(packet, !isBinary ? false : supportsBinary, false, function(message) {
	      doneCallback(null, setLengthHeader(message));
	    });
	  }

	  map(packets, encodeOne, function(err, results) {
	    return callback(results.join(''));
	  });
	};

	/**
	 * Async array map using after
	 */

	function map(ary, each, done) {
	  var result = new Array(ary.length);
	  var next = after$2(ary.length, done);

	  var eachWithIndex = function(i, el, cb) {
	    each(el, function(error, msg) {
	      result[i] = msg;
	      cb(error, result);
	    });
	  };

	  for (var i = 0; i < ary.length; i++) {
	    eachWithIndex(i, ary[i], next);
	  }
	}

	/*
	 * Decodes data when a payload is maybe expected. Possible binary contents are
	 * decoded from their base64 representation
	 *
	 * @param {String} data, callback method
	 * @api public
	 */

	exports.decodePayload = function (data, binaryType, callback) {
	  if (typeof data !== 'string') {
	    return exports.decodePayloadAsBinary(data, binaryType, callback);
	  }

	  if (typeof binaryType === 'function') {
	    callback = binaryType;
	    binaryType = null;
	  }

	  var packet;
	  if (data === '') {
	    // parser error - ignoring payload
	    return callback(err, 0, 1);
	  }

	  var length = '', n, msg;

	  for (var i = 0, l = data.length; i < l; i++) {
	    var chr = data.charAt(i);

	    if (chr !== ':') {
	      length += chr;
	      continue;
	    }

	    if (length === '' || (length != (n = Number(length)))) {
	      // parser error - ignoring payload
	      return callback(err, 0, 1);
	    }

	    msg = data.substr(i + 1, n);

	    if (length != msg.length) {
	      // parser error - ignoring payload
	      return callback(err, 0, 1);
	    }

	    if (msg.length) {
	      packet = exports.decodePacket(msg, binaryType, false);

	      if (err.type === packet.type && err.data === packet.data) {
	        // parser error in individual packet - ignoring payload
	        return callback(err, 0, 1);
	      }

	      var ret = callback(packet, i + n, l);
	      if (false === ret) { return; }
	    }

	    // advance cursor
	    i += n;
	    length = '';
	  }

	  if (length !== '') {
	    // parser error - ignoring payload
	    return callback(err, 0, 1);
	  }

	};

	/**
	 * Encodes multiple messages (payload) as binary.
	 *
	 * <1 = binary, 0 = string><number from 0-9><number from 0-9>[...]<number
	 * 255><data>
	 *
	 * Example:
	 * 1 3 255 1 2 3, if the binary contents are interpreted as 8 bit integers
	 *
	 * @param {Array} packets
	 * @return {ArrayBuffer} encoded payload
	 * @api private
	 */

	exports.encodePayloadAsArrayBuffer = function(packets, callback) {
	  if (!packets.length) {
	    return callback(new ArrayBuffer(0));
	  }

	  function encodeOne(packet, doneCallback) {
	    exports.encodePacket(packet, true, true, function(data) {
	      return doneCallback(null, data);
	    });
	  }

	  map(packets, encodeOne, function(err, encodedPackets) {
	    var totalLength = encodedPackets.reduce(function(acc, p) {
	      var len;
	      if (typeof p === 'string'){
	        len = p.length;
	      } else {
	        len = p.byteLength;
	      }
	      return acc + len.toString().length + len + 2; // string/binary identifier + separator = 2
	    }, 0);

	    var resultArray = new Uint8Array(totalLength);

	    var bufferIndex = 0;
	    encodedPackets.forEach(function(p) {
	      var isString = typeof p === 'string';
	      var ab = p;
	      if (isString) {
	        var view = new Uint8Array(p.length);
	        for (var i = 0; i < p.length; i++) {
	          view[i] = p.charCodeAt(i);
	        }
	        ab = view.buffer;
	      }

	      if (isString) { // not true binary
	        resultArray[bufferIndex++] = 0;
	      } else { // true binary
	        resultArray[bufferIndex++] = 1;
	      }

	      var lenStr = ab.byteLength.toString();
	      for (var i = 0; i < lenStr.length; i++) {
	        resultArray[bufferIndex++] = parseInt(lenStr[i]);
	      }
	      resultArray[bufferIndex++] = 255;

	      var view = new Uint8Array(ab);
	      for (var i = 0; i < view.length; i++) {
	        resultArray[bufferIndex++] = view[i];
	      }
	    });

	    return callback(resultArray.buffer);
	  });
	};

	/**
	 * Encode as Blob
	 */

	exports.encodePayloadAsBlob = function(packets, callback) {
	  function encodeOne(packet, doneCallback) {
	    exports.encodePacket(packet, true, true, function(encoded) {
	      var binaryIdentifier = new Uint8Array(1);
	      binaryIdentifier[0] = 1;
	      if (typeof encoded === 'string') {
	        var view = new Uint8Array(encoded.length);
	        for (var i = 0; i < encoded.length; i++) {
	          view[i] = encoded.charCodeAt(i);
	        }
	        encoded = view.buffer;
	        binaryIdentifier[0] = 0;
	      }

	      var len = (encoded instanceof ArrayBuffer)
	        ? encoded.byteLength
	        : encoded.size;

	      var lenStr = len.toString();
	      var lengthAry = new Uint8Array(lenStr.length + 1);
	      for (var i = 0; i < lenStr.length; i++) {
	        lengthAry[i] = parseInt(lenStr[i]);
	      }
	      lengthAry[lenStr.length] = 255;

	      if (Blob$1) {
	        var blob = new Blob$1([binaryIdentifier.buffer, lengthAry.buffer, encoded]);
	        doneCallback(null, blob);
	      }
	    });
	  }

	  map(packets, encodeOne, function(err, results) {
	    return callback(new Blob$1(results));
	  });
	};

	/*
	 * Decodes data when a payload is maybe expected. Strings are decoded by
	 * interpreting each byte as a key code for entries marked to start with 0. See
	 * description of encodePayloadAsBinary
	 *
	 * @param {ArrayBuffer} data, callback method
	 * @api public
	 */

	exports.decodePayloadAsBinary = function (data, binaryType, callback) {
	  if (typeof binaryType === 'function') {
	    callback = binaryType;
	    binaryType = null;
	  }

	  var bufferTail = data;
	  var buffers = [];

	  while (bufferTail.byteLength > 0) {
	    var tailArray = new Uint8Array(bufferTail);
	    var isString = tailArray[0] === 0;
	    var msgLength = '';

	    for (var i = 1; ; i++) {
	      if (tailArray[i] === 255) { break; }

	      // 310 = char length of Number.MAX_VALUE
	      if (msgLength.length > 310) {
	        return callback(err, 0, 1);
	      }

	      msgLength += tailArray[i];
	    }

	    bufferTail = sliceBuffer(bufferTail, 2 + msgLength.length);
	    msgLength = parseInt(msgLength);

	    var msg = sliceBuffer(bufferTail, 0, msgLength);
	    if (isString) {
	      try {
	        msg = String.fromCharCode.apply(null, new Uint8Array(msg));
	      } catch (e) {
	        // iPhone Safari doesn't let you apply to typed arrays
	        var typed = new Uint8Array(msg);
	        msg = '';
	        for (var i = 0; i < typed.length; i++) {
	          msg += String.fromCharCode(typed[i]);
	        }
	      }
	    }

	    buffers.push(msg);
	    bufferTail = sliceBuffer(bufferTail, msgLength);
	  }

	  var total = buffers.length;
	  buffers.forEach(function(buffer, i) {
	    callback(exports.decodePacket(buffer, binaryType, true), i, total);
	  });
	};
	});
	var browser_1$1 = browser$2.protocol;
	var browser_2$1 = browser$2.packets;
	var browser_3$1 = browser$2.encodePacket;
	var browser_4$1 = browser$2.encodeBase64Packet;
	var browser_5$1 = browser$2.decodePacket;
	var browser_6$1 = browser$2.decodeBase64Packet;
	var browser_7$1 = browser$2.encodePayload;
	var browser_8 = browser$2.decodePayload;
	var browser_9 = browser$2.encodePayloadAsArrayBuffer;
	var browser_10 = browser$2.encodePayloadAsBlob;
	var browser_11 = browser$2.decodePayloadAsBinary;

	var browser$3 = /*#__PURE__*/Object.freeze({
		default: browser$2,
		__moduleExports: browser$2,
		protocol: browser_1$1,
		packets: browser_2$1,
		encodePacket: browser_3$1,
		encodeBase64Packet: browser_4$1,
		decodePacket: browser_5$1,
		decodeBase64Packet: browser_6$1,
		encodePayload: browser_7$1,
		decodePayload: browser_8,
		encodePayloadAsArrayBuffer: browser_9,
		encodePayloadAsBlob: browser_10,
		decodePayloadAsBinary: browser_11
	});

	var parser = ( browser$3 && browser$2 ) || browser$3;

	/**
	 * Module dependencies.
	 */




	/**
	 * Module exports.
	 */

	var transport = Transport;

	/**
	 * Transport abstract constructor.
	 *
	 * @param {Object} options.
	 * @api private
	 */

	function Transport (opts) {
	  this.path = opts.path;
	  this.hostname = opts.hostname;
	  this.port = opts.port;
	  this.secure = opts.secure;
	  this.query = opts.query;
	  this.timestampParam = opts.timestampParam;
	  this.timestampRequests = opts.timestampRequests;
	  this.readyState = '';
	  this.agent = opts.agent || false;
	  this.socket = opts.socket;
	  this.enablesXDR = opts.enablesXDR;
	  this.withCredentials = opts.withCredentials;

	  // SSL options for Node.js client
	  this.pfx = opts.pfx;
	  this.key = opts.key;
	  this.passphrase = opts.passphrase;
	  this.cert = opts.cert;
	  this.ca = opts.ca;
	  this.ciphers = opts.ciphers;
	  this.rejectUnauthorized = opts.rejectUnauthorized;
	  this.forceNode = opts.forceNode;

	  // results of ReactNative environment detection
	  this.isReactNative = opts.isReactNative;

	  // other options for Node.js client
	  this.extraHeaders = opts.extraHeaders;
	  this.localAddress = opts.localAddress;
	}

	/**
	 * Mix in `Emitter`.
	 */

	Emitter(Transport.prototype);

	/**
	 * Emits an error.
	 *
	 * @param {String} str
	 * @return {Transport} for chaining
	 * @api public
	 */

	Transport.prototype.onError = function (msg, desc) {
	  var err = new Error(msg);
	  err.type = 'TransportError';
	  err.description = desc;
	  this.emit('error', err);
	  return this;
	};

	/**
	 * Opens the transport.
	 *
	 * @api public
	 */

	Transport.prototype.open = function () {
	  if ('closed' === this.readyState || '' === this.readyState) {
	    this.readyState = 'opening';
	    this.doOpen();
	  }

	  return this;
	};

	/**
	 * Closes the transport.
	 *
	 * @api private
	 */

	Transport.prototype.close = function () {
	  if ('opening' === this.readyState || 'open' === this.readyState) {
	    this.doClose();
	    this.onClose();
	  }

	  return this;
	};

	/**
	 * Sends multiple packets.
	 *
	 * @param {Array} packets
	 * @api private
	 */

	Transport.prototype.send = function (packets) {
	  if ('open' === this.readyState) {
	    this.write(packets);
	  } else {
	    throw new Error('Transport not open');
	  }
	};

	/**
	 * Called upon open
	 *
	 * @api private
	 */

	Transport.prototype.onOpen = function () {
	  this.readyState = 'open';
	  this.writable = true;
	  this.emit('open');
	};

	/**
	 * Called with data.
	 *
	 * @param {String} data
	 * @api private
	 */

	Transport.prototype.onData = function (data) {
	  var packet = parser.decodePacket(data, this.socket.binaryType);
	  this.onPacket(packet);
	};

	/**
	 * Called with a decoded packet.
	 */

	Transport.prototype.onPacket = function (packet) {
	  this.emit('packet', packet);
	};

	/**
	 * Called upon close.
	 *
	 * @api private
	 */

	Transport.prototype.onClose = function () {
	  this.readyState = 'closed';
	  this.emit('close');
	};

	var transport$1 = /*#__PURE__*/Object.freeze({
		default: transport,
		__moduleExports: transport
	});

	/**
	 * Compiles a querystring
	 * Returns string representation of the object
	 *
	 * @param {Object}
	 * @api private
	 */

	var encode = function (obj) {
	  var str = '';

	  for (var i in obj) {
	    if (obj.hasOwnProperty(i)) {
	      if (str.length) { str += '&'; }
	      str += encodeURIComponent(i) + '=' + encodeURIComponent(obj[i]);
	    }
	  }

	  return str;
	};

	/**
	 * Parses a simple querystring into an object
	 *
	 * @param {String} qs
	 * @api private
	 */

	var decode = function(qs){
	  var qry = {};
	  var pairs = qs.split('&');
	  for (var i = 0, l = pairs.length; i < l; i++) {
	    var pair = pairs[i].split('=');
	    qry[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
	  }
	  return qry;
	};

	var parseqs = {
		encode: encode,
		decode: decode
	};

	var parseqs$1 = /*#__PURE__*/Object.freeze({
		default: parseqs,
		__moduleExports: parseqs,
		encode: encode,
		decode: decode
	});

	var componentInherit = function(a, b){
	  var fn = function(){};
	  fn.prototype = b.prototype;
	  a.prototype = new fn;
	  a.prototype.constructor = a;
	};

	var componentInherit$1 = /*#__PURE__*/Object.freeze({
		default: componentInherit,
		__moduleExports: componentInherit
	});

	var alphabet = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-_'.split('')
	  , length = 64
	  , map$1 = {}
	  , seed = 0
	  , i$1 = 0
	  , prev$1;

	/**
	 * Return a string representing the specified number.
	 *
	 * @param {Number} num The number to convert.
	 * @returns {String} The string representation of the number.
	 * @api public
	 */
	function encode$1(num) {
	  var encoded = '';

	  do {
	    encoded = alphabet[num % length] + encoded;
	    num = Math.floor(num / length);
	  } while (num > 0);

	  return encoded;
	}

	/**
	 * Return the integer value specified by the given string.
	 *
	 * @param {String} str The string to convert.
	 * @returns {Number} The integer value represented by the string.
	 * @api public
	 */
	function decode$1(str) {
	  var decoded = 0;

	  for (i$1 = 0; i$1 < str.length; i$1++) {
	    decoded = decoded * length + map$1[str.charAt(i$1)];
	  }

	  return decoded;
	}

	/**
	 * Yeast: A tiny growing id generator.
	 *
	 * @returns {String} A unique id.
	 * @api public
	 */
	function yeast() {
	  var now = encode$1(+new Date());

	  if (now !== prev$1) { return seed = 0, prev$1 = now; }
	  return now +'.'+ encode$1(seed++);
	}

	//
	// Map each character to its index.
	//
	for (; i$1 < length; i$1++) { map$1[alphabet[i$1]] = i$1; }

	//
	// Expose the `yeast`, `encode` and `decode` functions.
	//
	yeast.encode = encode$1;
	yeast.decode = decode$1;
	var yeast_1 = yeast;

	var yeast$1 = /*#__PURE__*/Object.freeze({
		default: yeast_1,
		__moduleExports: yeast_1
	});

	var Transport$1 = ( transport$1 && transport ) || transport$1;

	var parseqs$2 = ( parseqs$1 && parseqs ) || parseqs$1;

	var inherit = ( componentInherit$1 && componentInherit ) || componentInherit$1;

	var yeast$2 = ( yeast$1 && yeast_1 ) || yeast$1;

	var require$$1 = ( xmlhttprequest$1 && xmlhttprequest ) || xmlhttprequest$1;

	/**
	 * Module dependencies.
	 */






	var debug$3 = require$$0$2('engine.io-client:polling');

	/**
	 * Module exports.
	 */

	var polling = Polling;

	/**
	 * Is XHR2 supported?
	 */

	var hasXHR2 = (function () {
	  var XMLHttpRequest = require$$1;
	  var xhr = new XMLHttpRequest({ xdomain: false });
	  return null != xhr.responseType;
	})();

	/**
	 * Polling interface.
	 *
	 * @param {Object} opts
	 * @api private
	 */

	function Polling (opts) {
	  var forceBase64 = (opts && opts.forceBase64);
	  if (!hasXHR2 || forceBase64) {
	    this.supportsBinary = false;
	  }
	  Transport$1.call(this, opts);
	}

	/**
	 * Inherits from Transport.
	 */

	inherit(Polling, Transport$1);

	/**
	 * Transport name.
	 */

	Polling.prototype.name = 'polling';

	/**
	 * Opens the socket (triggers polling). We write a PING message to determine
	 * when the transport is open.
	 *
	 * @api private
	 */

	Polling.prototype.doOpen = function () {
	  this.poll();
	};

	/**
	 * Pauses polling.
	 *
	 * @param {Function} callback upon buffers are flushed and transport is paused
	 * @api private
	 */

	Polling.prototype.pause = function (onPause) {
	  var self = this;

	  this.readyState = 'pausing';

	  function pause () {
	    debug$3('paused');
	    self.readyState = 'paused';
	    onPause();
	  }

	  if (this.polling || !this.writable) {
	    var total = 0;

	    if (this.polling) {
	      debug$3('we are currently polling - waiting to pause');
	      total++;
	      this.once('pollComplete', function () {
	        debug$3('pre-pause polling complete');
	        --total || pause();
	      });
	    }

	    if (!this.writable) {
	      debug$3('we are currently writing - waiting to pause');
	      total++;
	      this.once('drain', function () {
	        debug$3('pre-pause writing complete');
	        --total || pause();
	      });
	    }
	  } else {
	    pause();
	  }
	};

	/**
	 * Starts polling cycle.
	 *
	 * @api public
	 */

	Polling.prototype.poll = function () {
	  debug$3('polling');
	  this.polling = true;
	  this.doPoll();
	  this.emit('poll');
	};

	/**
	 * Overloads onData to detect payloads.
	 *
	 * @api private
	 */

	Polling.prototype.onData = function (data) {
	  var self = this;
	  debug$3('polling got data %s', data);
	  var callback = function (packet, index, total) {
	    // if its the first message we consider the transport open
	    if ('opening' === self.readyState && packet.type === 'open') {
	      self.onOpen();
	    }

	    // if its a close packet, we close the ongoing requests
	    if ('close' === packet.type) {
	      self.onClose();
	      return false;
	    }

	    // otherwise bypass onData and handle the message
	    self.onPacket(packet);
	  };

	  // decode payload
	  parser.decodePayload(data, this.socket.binaryType, callback);

	  // if an event did not trigger closing
	  if ('closed' !== this.readyState) {
	    // if we got data we're not polling
	    this.polling = false;
	    this.emit('pollComplete');

	    if ('open' === this.readyState) {
	      this.poll();
	    } else {
	      debug$3('ignoring poll - transport state "%s"', this.readyState);
	    }
	  }
	};

	/**
	 * For polling, send a close packet.
	 *
	 * @api private
	 */

	Polling.prototype.doClose = function () {
	  var self = this;

	  function close () {
	    debug$3('writing close packet');
	    self.write([{ type: 'close' }]);
	  }

	  if ('open' === this.readyState) {
	    debug$3('transport open - closing');
	    close();
	  } else {
	    // in case we're trying to close while
	    // handshaking is in progress (GH-164)
	    debug$3('transport not open - deferring close');
	    this.once('open', close);
	  }
	};

	/**
	 * Writes a packets payload.
	 *
	 * @param {Array} data packets
	 * @param {Function} drain callback
	 * @api private
	 */

	Polling.prototype.write = function (packets) {
	  var self = this;
	  this.writable = false;
	  var callbackfn = function () {
	    self.writable = true;
	    self.emit('drain');
	  };

	  parser.encodePayload(packets, this.supportsBinary, function (data) {
	    self.doWrite(data, callbackfn);
	  });
	};

	/**
	 * Generates uri for connection.
	 *
	 * @api private
	 */

	Polling.prototype.uri = function () {
	  var query = this.query || {};
	  var schema = this.secure ? 'https' : 'http';
	  var port = '';

	  // cache busting is forced
	  if (false !== this.timestampRequests) {
	    query[this.timestampParam] = yeast$2();
	  }

	  if (!this.supportsBinary && !query.sid) {
	    query.b64 = 1;
	  }

	  query = parseqs$2.encode(query);

	  // avoid port if default for schema
	  if (this.port && (('https' === schema && Number(this.port) !== 443) ||
	     ('http' === schema && Number(this.port) !== 80))) {
	    port = ':' + this.port;
	  }

	  // prepend ? to query
	  if (query.length) {
	    query = '?' + query;
	  }

	  var ipv6 = this.hostname.indexOf(':') !== -1;
	  return schema + '://' + (ipv6 ? '[' + this.hostname + ']' : this.hostname) + port + this.path + query;
	};

	var polling$1 = /*#__PURE__*/Object.freeze({
		default: polling,
		__moduleExports: polling
	});

	var Polling$1 = ( polling$1 && polling ) || polling$1;

	/* global attachEvent */

	/**
	 * Module requirements.
	 */





	var debug$4 = require$$0$2('engine.io-client:polling-xhr');


	/**
	 * Module exports.
	 */

	var pollingXhr = XHR;
	var Request_1 = Request$1;

	/**
	 * Empty function
	 */

	function empty$1 () {}

	/**
	 * XHR Polling constructor.
	 *
	 * @param {Object} opts
	 * @api public
	 */

	function XHR (opts) {
	  Polling$1.call(this, opts);
	  this.requestTimeout = opts.requestTimeout;
	  this.extraHeaders = opts.extraHeaders;

	  if (typeof location !== 'undefined') {
	    var isSSL = 'https:' === location.protocol;
	    var port = location.port;

	    // some user agents have empty `location.port`
	    if (!port) {
	      port = isSSL ? 443 : 80;
	    }

	    this.xd = (typeof location !== 'undefined' && opts.hostname !== location.hostname) ||
	      port !== opts.port;
	    this.xs = opts.secure !== isSSL;
	  }
	}

	/**
	 * Inherits from Polling.
	 */

	inherit(XHR, Polling$1);

	/**
	 * XHR supports binary
	 */

	XHR.prototype.supportsBinary = true;

	/**
	 * Creates a request.
	 *
	 * @param {String} method
	 * @api private
	 */

	XHR.prototype.request = function (opts) {
	  opts = opts || {};
	  opts.uri = this.uri();
	  opts.xd = this.xd;
	  opts.xs = this.xs;
	  opts.agent = this.agent || false;
	  opts.supportsBinary = this.supportsBinary;
	  opts.enablesXDR = this.enablesXDR;
	  opts.withCredentials = this.withCredentials;

	  // SSL options for Node.js client
	  opts.pfx = this.pfx;
	  opts.key = this.key;
	  opts.passphrase = this.passphrase;
	  opts.cert = this.cert;
	  opts.ca = this.ca;
	  opts.ciphers = this.ciphers;
	  opts.rejectUnauthorized = this.rejectUnauthorized;
	  opts.requestTimeout = this.requestTimeout;

	  // other options for Node.js client
	  opts.extraHeaders = this.extraHeaders;

	  return new Request$1(opts);
	};

	/**
	 * Sends data.
	 *
	 * @param {String} data to send.
	 * @param {Function} called upon flush.
	 * @api private
	 */

	XHR.prototype.doWrite = function (data, fn) {
	  var isBinary = typeof data !== 'string' && data !== undefined;
	  var req = this.request({ method: 'POST', data: data, isBinary: isBinary });
	  var self = this;
	  req.on('success', fn);
	  req.on('error', function (err) {
	    self.onError('xhr post error', err);
	  });
	  this.sendXhr = req;
	};

	/**
	 * Starts a poll cycle.
	 *
	 * @api private
	 */

	XHR.prototype.doPoll = function () {
	  debug$4('xhr poll');
	  var req = this.request();
	  var self = this;
	  req.on('data', function (data) {
	    self.onData(data);
	  });
	  req.on('error', function (err) {
	    self.onError('xhr poll error', err);
	  });
	  this.pollXhr = req;
	};

	/**
	 * Request constructor
	 *
	 * @param {Object} options
	 * @api public
	 */

	function Request$1 (opts) {
	  this.method = opts.method || 'GET';
	  this.uri = opts.uri;
	  this.xd = !!opts.xd;
	  this.xs = !!opts.xs;
	  this.async = false !== opts.async;
	  this.data = undefined !== opts.data ? opts.data : null;
	  this.agent = opts.agent;
	  this.isBinary = opts.isBinary;
	  this.supportsBinary = opts.supportsBinary;
	  this.enablesXDR = opts.enablesXDR;
	  this.withCredentials = opts.withCredentials;
	  this.requestTimeout = opts.requestTimeout;

	  // SSL options for Node.js client
	  this.pfx = opts.pfx;
	  this.key = opts.key;
	  this.passphrase = opts.passphrase;
	  this.cert = opts.cert;
	  this.ca = opts.ca;
	  this.ciphers = opts.ciphers;
	  this.rejectUnauthorized = opts.rejectUnauthorized;

	  // other options for Node.js client
	  this.extraHeaders = opts.extraHeaders;

	  this.create();
	}

	/**
	 * Mix in `Emitter`.
	 */

	Emitter(Request$1.prototype);

	/**
	 * Creates the XHR object and sends the request.
	 *
	 * @api private
	 */

	Request$1.prototype.create = function () {
	  var this$1 = this;

	  var opts = { agent: this.agent, xdomain: this.xd, xscheme: this.xs, enablesXDR: this.enablesXDR };

	  // SSL options for Node.js client
	  opts.pfx = this.pfx;
	  opts.key = this.key;
	  opts.passphrase = this.passphrase;
	  opts.cert = this.cert;
	  opts.ca = this.ca;
	  opts.ciphers = this.ciphers;
	  opts.rejectUnauthorized = this.rejectUnauthorized;

	  var xhr = this.xhr = new require$$1(opts);
	  var self = this;

	  try {
	    debug$4('xhr open %s: %s', this.method, this.uri);
	    xhr.open(this.method, this.uri, this.async);
	    try {
	      if (this.extraHeaders) {
	        xhr.setDisableHeaderCheck && xhr.setDisableHeaderCheck(true);
	        for (var i in this$1.extraHeaders) {
	          if (this$1.extraHeaders.hasOwnProperty(i)) {
	            xhr.setRequestHeader(i, this$1.extraHeaders[i]);
	          }
	        }
	      }
	    } catch (e) {}

	    if ('POST' === this.method) {
	      try {
	        if (this.isBinary) {
	          xhr.setRequestHeader('Content-type', 'application/octet-stream');
	        } else {
	          xhr.setRequestHeader('Content-type', 'text/plain;charset=UTF-8');
	        }
	      } catch (e) {}
	    }

	    try {
	      xhr.setRequestHeader('Accept', '*/*');
	    } catch (e) {}

	    // ie6 check
	    if ('withCredentials' in xhr) {
	      xhr.withCredentials = this.withCredentials;
	    }

	    if (this.requestTimeout) {
	      xhr.timeout = this.requestTimeout;
	    }

	    if (this.hasXDR()) {
	      xhr.onload = function () {
	        self.onLoad();
	      };
	      xhr.onerror = function () {
	        self.onError(xhr.responseText);
	      };
	    } else {
	      xhr.onreadystatechange = function () {
	        if (xhr.readyState === 2) {
	          try {
	            var contentType = xhr.getResponseHeader('Content-Type');
	            if (self.supportsBinary && contentType === 'application/octet-stream' || contentType === 'application/octet-stream; charset=UTF-8') {
	              xhr.responseType = 'arraybuffer';
	            }
	          } catch (e) {}
	        }
	        if (4 !== xhr.readyState) { return; }
	        if (200 === xhr.status || 1223 === xhr.status) {
	          self.onLoad();
	        } else {
	          // make sure the `error` event handler that's user-set
	          // does not throw in the same tick and gets caught here
	          setTimeout(function () {
	            self.onError(typeof xhr.status === 'number' ? xhr.status : 0);
	          }, 0);
	        }
	      };
	    }

	    debug$4('xhr data %s', this.data);
	    xhr.send(this.data);
	  } catch (e) {
	    // Need to defer since .create() is called directly fhrom the constructor
	    // and thus the 'error' event can only be only bound *after* this exception
	    // occurs.  Therefore, also, we cannot throw here at all.
	    setTimeout(function () {
	      self.onError(e);
	    }, 0);
	    return;
	  }

	  if (typeof document !== 'undefined') {
	    this.index = Request$1.requestsCount++;
	    Request$1.requests[this.index] = this;
	  }
	};

	/**
	 * Called upon successful response.
	 *
	 * @api private
	 */

	Request$1.prototype.onSuccess = function () {
	  this.emit('success');
	  this.cleanup();
	};

	/**
	 * Called if we have data.
	 *
	 * @api private
	 */

	Request$1.prototype.onData = function (data) {
	  this.emit('data', data);
	  this.onSuccess();
	};

	/**
	 * Called upon error.
	 *
	 * @api private
	 */

	Request$1.prototype.onError = function (err) {
	  this.emit('error', err);
	  this.cleanup(true);
	};

	/**
	 * Cleans up house.
	 *
	 * @api private
	 */

	Request$1.prototype.cleanup = function (fromError) {
	  if ('undefined' === typeof this.xhr || null === this.xhr) {
	    return;
	  }
	  // xmlhttprequest
	  if (this.hasXDR()) {
	    this.xhr.onload = this.xhr.onerror = empty$1;
	  } else {
	    this.xhr.onreadystatechange = empty$1;
	  }

	  if (fromError) {
	    try {
	      this.xhr.abort();
	    } catch (e) {}
	  }

	  if (typeof document !== 'undefined') {
	    delete Request$1.requests[this.index];
	  }

	  this.xhr = null;
	};

	/**
	 * Called upon load.
	 *
	 * @api private
	 */

	Request$1.prototype.onLoad = function () {
	  var data;
	  try {
	    var contentType;
	    try {
	      contentType = this.xhr.getResponseHeader('Content-Type');
	    } catch (e) {}
	    if (contentType === 'application/octet-stream' || contentType === 'application/octet-stream; charset=UTF-8') {
	      data = this.xhr.response || this.xhr.responseText;
	    } else {
	      data = this.xhr.responseText;
	    }
	  } catch (e) {
	    this.onError(e);
	  }
	  if (null != data) {
	    this.onData(data);
	  }
	};

	/**
	 * Check if it has XDomainRequest.
	 *
	 * @api private
	 */

	Request$1.prototype.hasXDR = function () {
	  return typeof XDomainRequest !== 'undefined' && !this.xs && this.enablesXDR;
	};

	/**
	 * Aborts the request.
	 *
	 * @api public
	 */

	Request$1.prototype.abort = function () {
	  this.cleanup();
	};

	/**
	 * Aborts pending requests when unloading the window. This is needed to prevent
	 * memory leaks (e.g. when using IE) and to ensure that no spurious error is
	 * emitted.
	 */

	Request$1.requestsCount = 0;
	Request$1.requests = {};

	if (typeof document !== 'undefined') {
	  if (typeof attachEvent === 'function') {
	    attachEvent('onunload', unloadHandler);
	  } else if (typeof addEventListener === 'function') {
	    var terminationEvent = 'onpagehide' in globalThis ? 'pagehide' : 'unload';
	    addEventListener(terminationEvent, unloadHandler, false);
	  }
	}

	function unloadHandler () {
	  for (var i in Request$1.requests) {
	    if (Request$1.requests.hasOwnProperty(i)) {
	      Request$1.requests[i].abort();
	    }
	  }
	}
	pollingXhr.Request = Request_1;

	var pollingXhr$1 = /*#__PURE__*/Object.freeze({
		default: pollingXhr,
		__moduleExports: pollingXhr,
		Request: Request_1
	});

	/**
	 * Module requirements.
	 */





	/**
	 * Module exports.
	 */

	var pollingJsonp = JSONPPolling;

	/**
	 * Cached regular expressions.
	 */

	var rNewline = /\n/g;
	var rEscapedNewline = /\\n/g;

	/**
	 * Global JSONP callbacks.
	 */

	var callbacks$1;

	/**
	 * Noop.
	 */

	function empty$2 () { }

	/**
	 * JSONP Polling constructor.
	 *
	 * @param {Object} opts.
	 * @api public
	 */

	function JSONPPolling (opts) {
	  Polling$1.call(this, opts);

	  this.query = this.query || {};

	  // define global callbacks array if not present
	  // we do this here (lazily) to avoid unneeded global pollution
	  if (!callbacks$1) {
	    // we need to consider multiple engines in the same page
	    callbacks$1 = globalThis.___eio = (globalThis.___eio || []);
	  }

	  // callback identifier
	  this.index = callbacks$1.length;

	  // add callback to jsonp global
	  var self = this;
	  callbacks$1.push(function (msg) {
	    self.onData(msg);
	  });

	  // append to query string
	  this.query.j = this.index;

	  // prevent spurious errors from being emitted when the window is unloaded
	  if (typeof addEventListener === 'function') {
	    addEventListener('beforeunload', function () {
	      if (self.script) { self.script.onerror = empty$2; }
	    }, false);
	  }
	}

	/**
	 * Inherits from Polling.
	 */

	inherit(JSONPPolling, Polling$1);

	/*
	 * JSONP only supports binary as base64 encoded strings
	 */

	JSONPPolling.prototype.supportsBinary = false;

	/**
	 * Closes the socket.
	 *
	 * @api private
	 */

	JSONPPolling.prototype.doClose = function () {
	  if (this.script) {
	    this.script.parentNode.removeChild(this.script);
	    this.script = null;
	  }

	  if (this.form) {
	    this.form.parentNode.removeChild(this.form);
	    this.form = null;
	    this.iframe = null;
	  }

	  Polling$1.prototype.doClose.call(this);
	};

	/**
	 * Starts a poll cycle.
	 *
	 * @api private
	 */

	JSONPPolling.prototype.doPoll = function () {
	  var self = this;
	  var script = document.createElement('script');

	  if (this.script) {
	    this.script.parentNode.removeChild(this.script);
	    this.script = null;
	  }

	  script.async = true;
	  script.src = this.uri();
	  script.onerror = function (e) {
	    self.onError('jsonp poll error', e);
	  };

	  var insertAt = document.getElementsByTagName('script')[0];
	  if (insertAt) {
	    insertAt.parentNode.insertBefore(script, insertAt);
	  } else {
	    (document.head || document.body).appendChild(script);
	  }
	  this.script = script;

	  var isUAgecko = 'undefined' !== typeof navigator && /gecko/i.test(navigator.userAgent);

	  if (isUAgecko) {
	    setTimeout(function () {
	      var iframe = document.createElement('iframe');
	      document.body.appendChild(iframe);
	      document.body.removeChild(iframe);
	    }, 100);
	  }
	};

	/**
	 * Writes with a hidden iframe.
	 *
	 * @param {String} data to send
	 * @param {Function} called upon flush.
	 * @api private
	 */

	JSONPPolling.prototype.doWrite = function (data, fn) {
	  var self = this;

	  if (!this.form) {
	    var form = document.createElement('form');
	    var area = document.createElement('textarea');
	    var id = this.iframeId = 'eio_iframe_' + this.index;
	    var iframe;

	    form.className = 'socketio';
	    form.style.position = 'absolute';
	    form.style.top = '-1000px';
	    form.style.left = '-1000px';
	    form.target = id;
	    form.method = 'POST';
	    form.setAttribute('accept-charset', 'utf-8');
	    area.name = 'd';
	    form.appendChild(area);
	    document.body.appendChild(form);

	    this.form = form;
	    this.area = area;
	  }

	  this.form.action = this.uri();

	  function complete () {
	    initIframe();
	    fn();
	  }

	  function initIframe () {
	    if (self.iframe) {
	      try {
	        self.form.removeChild(self.iframe);
	      } catch (e) {
	        self.onError('jsonp polling iframe removal error', e);
	      }
	    }

	    try {
	      // ie6 dynamic iframes with target="" support (thanks Chris Lambacher)
	      var html = '<iframe src="javascript:0" name="' + self.iframeId + '">';
	      iframe = document.createElement(html);
	    } catch (e) {
	      iframe = document.createElement('iframe');
	      iframe.name = self.iframeId;
	      iframe.src = 'javascript:0';
	    }

	    iframe.id = self.iframeId;

	    self.form.appendChild(iframe);
	    self.iframe = iframe;
	  }

	  initIframe();

	  // escape \n to prevent it from being converted into \r\n by some UAs
	  // double escaping is required for escaped new lines because unescaping of new lines can be done safely on server-side
	  data = data.replace(rEscapedNewline, '\\\n');
	  this.area.value = data.replace(rNewline, '\\n');

	  try {
	    this.form.submit();
	  } catch (e) {}

	  if (this.iframe.attachEvent) {
	    this.iframe.onreadystatechange = function () {
	      if (self.iframe.readyState === 'complete') {
	        complete();
	      }
	    };
	  } else {
	    this.iframe.onload = complete;
	  }
	};

	var pollingJsonp$1 = /*#__PURE__*/Object.freeze({
		default: pollingJsonp,
		__moduleExports: pollingJsonp
	});

	var empty$3 = {};

	var empty$4 = /*#__PURE__*/Object.freeze({
		default: empty$3
	});

	var require$$1$1 = ( empty$4 && empty$3 ) || empty$4;

	/**
	 * Module dependencies.
	 */






	var debug$5 = require$$0$2('engine.io-client:websocket');

	var BrowserWebSocket, NodeWebSocket;

	if (typeof WebSocket !== 'undefined') {
	  BrowserWebSocket = WebSocket;
	} else if (typeof self !== 'undefined') {
	  BrowserWebSocket = self.WebSocket || self.MozWebSocket;
	}

	if (typeof window === 'undefined') {
	  try {
	    NodeWebSocket = require$$1$1;
	  } catch (e) { }
	}

	/**
	 * Get either the `WebSocket` or `MozWebSocket` globals
	 * in the browser or try to resolve WebSocket-compatible
	 * interface exposed by `ws` for Node-like environment.
	 */

	var WebSocketImpl = BrowserWebSocket || NodeWebSocket;

	/**
	 * Module exports.
	 */

	var websocket = WS;

	/**
	 * WebSocket transport constructor.
	 *
	 * @api {Object} connection options
	 * @api public
	 */

	function WS (opts) {
	  var forceBase64 = (opts && opts.forceBase64);
	  if (forceBase64) {
	    this.supportsBinary = false;
	  }
	  this.perMessageDeflate = opts.perMessageDeflate;
	  this.usingBrowserWebSocket = BrowserWebSocket && !opts.forceNode;
	  this.protocols = opts.protocols;
	  if (!this.usingBrowserWebSocket) {
	    WebSocketImpl = NodeWebSocket;
	  }
	  Transport$1.call(this, opts);
	}

	/**
	 * Inherits from Transport.
	 */

	inherit(WS, Transport$1);

	/**
	 * Transport name.
	 *
	 * @api public
	 */

	WS.prototype.name = 'websocket';

	/*
	 * WebSockets support binary
	 */

	WS.prototype.supportsBinary = true;

	/**
	 * Opens socket.
	 *
	 * @api private
	 */

	WS.prototype.doOpen = function () {
	  if (!this.check()) {
	    // let probe timeout
	    return;
	  }

	  var uri = this.uri();
	  var protocols = this.protocols;

	  var opts = {};

	  if (!this.isReactNative) {
	    opts.agent = this.agent;
	    opts.perMessageDeflate = this.perMessageDeflate;

	    // SSL options for Node.js client
	    opts.pfx = this.pfx;
	    opts.key = this.key;
	    opts.passphrase = this.passphrase;
	    opts.cert = this.cert;
	    opts.ca = this.ca;
	    opts.ciphers = this.ciphers;
	    opts.rejectUnauthorized = this.rejectUnauthorized;
	  }

	  if (this.extraHeaders) {
	    opts.headers = this.extraHeaders;
	  }
	  if (this.localAddress) {
	    opts.localAddress = this.localAddress;
	  }

	  try {
	    this.ws =
	      this.usingBrowserWebSocket && !this.isReactNative
	        ? protocols
	          ? new WebSocketImpl(uri, protocols)
	          : new WebSocketImpl(uri)
	        : new WebSocketImpl(uri, protocols, opts);
	  } catch (err) {
	    return this.emit('error', err);
	  }

	  if (this.ws.binaryType === undefined) {
	    this.supportsBinary = false;
	  }

	  if (this.ws.supports && this.ws.supports.binary) {
	    this.supportsBinary = true;
	    this.ws.binaryType = 'nodebuffer';
	  } else {
	    this.ws.binaryType = 'arraybuffer';
	  }

	  this.addEventListeners();
	};

	/**
	 * Adds event listeners to the socket
	 *
	 * @api private
	 */

	WS.prototype.addEventListeners = function () {
	  var self = this;

	  this.ws.onopen = function () {
	    self.onOpen();
	  };
	  this.ws.onclose = function () {
	    self.onClose();
	  };
	  this.ws.onmessage = function (ev) {
	    self.onData(ev.data);
	  };
	  this.ws.onerror = function (e) {
	    self.onError('websocket error', e);
	  };
	};

	/**
	 * Writes data to socket.
	 *
	 * @param {Array} array of packets.
	 * @api private
	 */

	WS.prototype.write = function (packets) {
	  var self = this;
	  this.writable = false;

	  // encodePacket efficient as it uses WS framing
	  // no need for encodePayload
	  var total = packets.length;
	  for (var i = 0, l = total; i < l; i++) {
	    (function (packet) {
	      parser.encodePacket(packet, self.supportsBinary, function (data) {
	        if (!self.usingBrowserWebSocket) {
	          // always create a new object (GH-437)
	          var opts = {};
	          if (packet.options) {
	            opts.compress = packet.options.compress;
	          }

	          if (self.perMessageDeflate) {
	            var len = 'string' === typeof data ? Buffer.byteLength(data) : data.length;
	            if (len < self.perMessageDeflate.threshold) {
	              opts.compress = false;
	            }
	          }
	        }

	        // Sometimes the websocket has already been closed but the browser didn't
	        // have a chance of informing us about it yet, in that case send will
	        // throw an error
	        try {
	          if (self.usingBrowserWebSocket) {
	            // TypeError is thrown when passing the second argument on Safari
	            self.ws.send(data);
	          } else {
	            self.ws.send(data, opts);
	          }
	        } catch (e) {
	          debug$5('websocket closed before onclose event');
	        }

	        --total || done();
	      });
	    })(packets[i]);
	  }

	  function done () {
	    self.emit('flush');

	    // fake drain
	    // defer to next tick to allow Socket to clear writeBuffer
	    setTimeout(function () {
	      self.writable = true;
	      self.emit('drain');
	    }, 0);
	  }
	};

	/**
	 * Called upon close
	 *
	 * @api private
	 */

	WS.prototype.onClose = function () {
	  Transport$1.prototype.onClose.call(this);
	};

	/**
	 * Closes socket.
	 *
	 * @api private
	 */

	WS.prototype.doClose = function () {
	  if (typeof this.ws !== 'undefined') {
	    this.ws.close();
	  }
	};

	/**
	 * Generates uri for connection.
	 *
	 * @api private
	 */

	WS.prototype.uri = function () {
	  var query = this.query || {};
	  var schema = this.secure ? 'wss' : 'ws';
	  var port = '';

	  // avoid port if default for schema
	  if (this.port && (('wss' === schema && Number(this.port) !== 443) ||
	    ('ws' === schema && Number(this.port) !== 80))) {
	    port = ':' + this.port;
	  }

	  // append timestamp to URI
	  if (this.timestampRequests) {
	    query[this.timestampParam] = yeast$2();
	  }

	  // communicate binary support capabilities
	  if (!this.supportsBinary) {
	    query.b64 = 1;
	  }

	  query = parseqs$2.encode(query);

	  // prepend ? to query
	  if (query.length) {
	    query = '?' + query;
	  }

	  var ipv6 = this.hostname.indexOf(':') !== -1;
	  return schema + '://' + (ipv6 ? '[' + this.hostname + ']' : this.hostname) + port + this.path + query;
	};

	/**
	 * Feature detection for WebSocket.
	 *
	 * @return {Boolean} whether this transport is available.
	 * @api public
	 */

	WS.prototype.check = function () {
	  return !!WebSocketImpl && !('__initialize' in WebSocketImpl && this.name === WS.prototype.name);
	};

	var websocket$1 = /*#__PURE__*/Object.freeze({
		default: websocket,
		__moduleExports: websocket
	});

	var XHR$1 = ( pollingXhr$1 && pollingXhr ) || pollingXhr$1;

	var JSONP = ( pollingJsonp$1 && pollingJsonp ) || pollingJsonp$1;

	var websocket$2 = ( websocket$1 && websocket ) || websocket$1;

	/**
	 * Module dependencies
	 */






	/**
	 * Export transports.
	 */

	var polling_1 = polling$2;
	var websocket_1 = websocket$2;

	/**
	 * Polling transport polymorphic constructor.
	 * Decides on xhr vs jsonp based on feature detection.
	 *
	 * @api private
	 */

	function polling$2 (opts) {
	  var xhr;
	  var xd = false;
	  var xs = false;
	  var jsonp = false !== opts.jsonp;

	  if (typeof location !== 'undefined') {
	    var isSSL = 'https:' === location.protocol;
	    var port = location.port;

	    // some user agents have empty `location.port`
	    if (!port) {
	      port = isSSL ? 443 : 80;
	    }

	    xd = opts.hostname !== location.hostname || port !== opts.port;
	    xs = opts.secure !== isSSL;
	  }

	  opts.xdomain = xd;
	  opts.xscheme = xs;
	  xhr = new require$$1(opts);

	  if ('open' in xhr && !opts.forceJSONP) {
	    return new XHR$1(opts);
	  } else {
	    if (!jsonp) { throw new Error('JSONP disabled'); }
	    return new JSONP(opts);
	  }
	}

	var transports = {
		polling: polling_1,
		websocket: websocket_1
	};

	var transports$1 = /*#__PURE__*/Object.freeze({
		default: transports,
		__moduleExports: transports,
		polling: polling_1,
		websocket: websocket_1
	});

	var indexOf$1 = [].indexOf;

	var indexof = function(arr, obj){
	  if (indexOf$1) { return arr.indexOf(obj); }
	  for (var i = 0; i < arr.length; ++i) {
	    if (arr[i] === obj) { return i; }
	  }
	  return -1;
	};

	var indexof$1 = /*#__PURE__*/Object.freeze({
		default: indexof,
		__moduleExports: indexof
	});

	var transports$2 = ( transports$1 && transports ) || transports$1;

	var index$2 = ( indexof$1 && indexof ) || indexof$1;

	/**
	 * Module dependencies.
	 */



	var debug$6 = require$$0$2('engine.io-client:socket');





	/**
	 * Module exports.
	 */

	var socket = Socket;

	/**
	 * Socket constructor.
	 *
	 * @param {String|Object} uri or options
	 * @param {Object} options
	 * @api public
	 */

	function Socket (uri, opts) {
	  if (!(this instanceof Socket)) { return new Socket(uri, opts); }

	  opts = opts || {};

	  if (uri && 'object' === typeof uri) {
	    opts = uri;
	    uri = null;
	  }

	  if (uri) {
	    uri = parseuri$2(uri);
	    opts.hostname = uri.host;
	    opts.secure = uri.protocol === 'https' || uri.protocol === 'wss';
	    opts.port = uri.port;
	    if (uri.query) { opts.query = uri.query; }
	  } else if (opts.host) {
	    opts.hostname = parseuri$2(opts.host).host;
	  }

	  this.secure = null != opts.secure ? opts.secure
	    : (typeof location !== 'undefined' && 'https:' === location.protocol);

	  if (opts.hostname && !opts.port) {
	    // if no port is specified manually, use the protocol default
	    opts.port = this.secure ? '443' : '80';
	  }

	  this.agent = opts.agent || false;
	  this.hostname = opts.hostname ||
	    (typeof location !== 'undefined' ? location.hostname : 'localhost');
	  this.port = opts.port || (typeof location !== 'undefined' && location.port
	      ? location.port
	      : (this.secure ? 443 : 80));
	  this.query = opts.query || {};
	  if ('string' === typeof this.query) { this.query = parseqs$2.decode(this.query); }
	  this.upgrade = false !== opts.upgrade;
	  this.path = (opts.path || '/engine.io').replace(/\/$/, '') + '/';
	  this.forceJSONP = !!opts.forceJSONP;
	  this.jsonp = false !== opts.jsonp;
	  this.forceBase64 = !!opts.forceBase64;
	  this.enablesXDR = !!opts.enablesXDR;
	  this.withCredentials = false !== opts.withCredentials;
	  this.timestampParam = opts.timestampParam || 't';
	  this.timestampRequests = opts.timestampRequests;
	  this.transports = opts.transports || ['polling', 'websocket'];
	  this.transportOptions = opts.transportOptions || {};
	  this.readyState = '';
	  this.writeBuffer = [];
	  this.prevBufferLen = 0;
	  this.policyPort = opts.policyPort || 843;
	  this.rememberUpgrade = opts.rememberUpgrade || false;
	  this.binaryType = null;
	  this.onlyBinaryUpgrades = opts.onlyBinaryUpgrades;
	  this.perMessageDeflate = false !== opts.perMessageDeflate ? (opts.perMessageDeflate || {}) : false;

	  if (true === this.perMessageDeflate) { this.perMessageDeflate = {}; }
	  if (this.perMessageDeflate && null == this.perMessageDeflate.threshold) {
	    this.perMessageDeflate.threshold = 1024;
	  }

	  // SSL options for Node.js client
	  this.pfx = opts.pfx || undefined;
	  this.key = opts.key || undefined;
	  this.passphrase = opts.passphrase || undefined;
	  this.cert = opts.cert || undefined;
	  this.ca = opts.ca || undefined;
	  this.ciphers = opts.ciphers || undefined;
	  this.rejectUnauthorized = opts.rejectUnauthorized === undefined ? true : opts.rejectUnauthorized;
	  this.forceNode = !!opts.forceNode;

	  // detect ReactNative environment
	  this.isReactNative = (typeof navigator !== 'undefined' && typeof navigator.product === 'string' && navigator.product.toLowerCase() === 'reactnative');

	  // other options for Node.js or ReactNative client
	  if (typeof self === 'undefined' || this.isReactNative) {
	    if (opts.extraHeaders && Object.keys(opts.extraHeaders).length > 0) {
	      this.extraHeaders = opts.extraHeaders;
	    }

	    if (opts.localAddress) {
	      this.localAddress = opts.localAddress;
	    }
	  }

	  // set on handshake
	  this.id = null;
	  this.upgrades = null;
	  this.pingInterval = null;
	  this.pingTimeout = null;

	  // set on heartbeat
	  this.pingIntervalTimer = null;
	  this.pingTimeoutTimer = null;

	  this.open();
	}

	Socket.priorWebsocketSuccess = false;

	/**
	 * Mix in `Emitter`.
	 */

	Emitter(Socket.prototype);

	/**
	 * Protocol version.
	 *
	 * @api public
	 */

	Socket.protocol = parser.protocol; // this is an int

	/**
	 * Expose deps for legacy compatibility
	 * and standalone browser access.
	 */

	Socket.Socket = Socket;
	Socket.Transport = Transport$1;
	Socket.transports = transports$2;
	Socket.parser = parser;

	/**
	 * Creates transport of the given type.
	 *
	 * @param {String} transport name
	 * @return {Transport}
	 * @api private
	 */

	Socket.prototype.createTransport = function (name) {
	  debug$6('creating transport "%s"', name);
	  var query = clone(this.query);

	  // append engine.io protocol identifier
	  query.EIO = parser.protocol;

	  // transport name
	  query.transport = name;

	  // per-transport options
	  var options = this.transportOptions[name] || {};

	  // session id if we already have one
	  if (this.id) { query.sid = this.id; }

	  var transport = new transports$2[name]({
	    query: query,
	    socket: this,
	    agent: options.agent || this.agent,
	    hostname: options.hostname || this.hostname,
	    port: options.port || this.port,
	    secure: options.secure || this.secure,
	    path: options.path || this.path,
	    forceJSONP: options.forceJSONP || this.forceJSONP,
	    jsonp: options.jsonp || this.jsonp,
	    forceBase64: options.forceBase64 || this.forceBase64,
	    enablesXDR: options.enablesXDR || this.enablesXDR,
	    withCredentials: options.withCredentials || this.withCredentials,
	    timestampRequests: options.timestampRequests || this.timestampRequests,
	    timestampParam: options.timestampParam || this.timestampParam,
	    policyPort: options.policyPort || this.policyPort,
	    pfx: options.pfx || this.pfx,
	    key: options.key || this.key,
	    passphrase: options.passphrase || this.passphrase,
	    cert: options.cert || this.cert,
	    ca: options.ca || this.ca,
	    ciphers: options.ciphers || this.ciphers,
	    rejectUnauthorized: options.rejectUnauthorized || this.rejectUnauthorized,
	    perMessageDeflate: options.perMessageDeflate || this.perMessageDeflate,
	    extraHeaders: options.extraHeaders || this.extraHeaders,
	    forceNode: options.forceNode || this.forceNode,
	    localAddress: options.localAddress || this.localAddress,
	    requestTimeout: options.requestTimeout || this.requestTimeout,
	    protocols: options.protocols || void (0),
	    isReactNative: this.isReactNative
	  });

	  return transport;
	};

	function clone (obj) {
	  var o = {};
	  for (var i in obj) {
	    if (obj.hasOwnProperty(i)) {
	      o[i] = obj[i];
	    }
	  }
	  return o;
	}

	/**
	 * Initializes transport to use and starts probe.
	 *
	 * @api private
	 */
	Socket.prototype.open = function () {
	  var transport;
	  if (this.rememberUpgrade && Socket.priorWebsocketSuccess && this.transports.indexOf('websocket') !== -1) {
	    transport = 'websocket';
	  } else if (0 === this.transports.length) {
	    // Emit error on next tick so it can be listened to
	    var self = this;
	    setTimeout(function () {
	      self.emit('error', 'No transports available');
	    }, 0);
	    return;
	  } else {
	    transport = this.transports[0];
	  }
	  this.readyState = 'opening';

	  // Retry with the next transport if the transport is disabled (jsonp: false)
	  try {
	    transport = this.createTransport(transport);
	  } catch (e) {
	    this.transports.shift();
	    this.open();
	    return;
	  }

	  transport.open();
	  this.setTransport(transport);
	};

	/**
	 * Sets the current transport. Disables the existing one (if any).
	 *
	 * @api private
	 */

	Socket.prototype.setTransport = function (transport) {
	  debug$6('setting transport %s', transport.name);
	  var self = this;

	  if (this.transport) {
	    debug$6('clearing existing transport %s', this.transport.name);
	    this.transport.removeAllListeners();
	  }

	  // set up transport
	  this.transport = transport;

	  // set up transport listeners
	  transport
	  .on('drain', function () {
	    self.onDrain();
	  })
	  .on('packet', function (packet) {
	    self.onPacket(packet);
	  })
	  .on('error', function (e) {
	    self.onError(e);
	  })
	  .on('close', function () {
	    self.onClose('transport close');
	  });
	};

	/**
	 * Probes a transport.
	 *
	 * @param {String} transport name
	 * @api private
	 */

	Socket.prototype.probe = function (name) {
	  debug$6('probing transport "%s"', name);
	  var transport = this.createTransport(name, { probe: 1 });
	  var failed = false;
	  var self = this;

	  Socket.priorWebsocketSuccess = false;

	  function onTransportOpen () {
	    if (self.onlyBinaryUpgrades) {
	      var upgradeLosesBinary = !this.supportsBinary && self.transport.supportsBinary;
	      failed = failed || upgradeLosesBinary;
	    }
	    if (failed) { return; }

	    debug$6('probe transport "%s" opened', name);
	    transport.send([{ type: 'ping', data: 'probe' }]);
	    transport.once('packet', function (msg) {
	      if (failed) { return; }
	      if ('pong' === msg.type && 'probe' === msg.data) {
	        debug$6('probe transport "%s" pong', name);
	        self.upgrading = true;
	        self.emit('upgrading', transport);
	        if (!transport) { return; }
	        Socket.priorWebsocketSuccess = 'websocket' === transport.name;

	        debug$6('pausing current transport "%s"', self.transport.name);
	        self.transport.pause(function () {
	          if (failed) { return; }
	          if ('closed' === self.readyState) { return; }
	          debug$6('changing transport and sending upgrade packet');

	          cleanup();

	          self.setTransport(transport);
	          transport.send([{ type: 'upgrade' }]);
	          self.emit('upgrade', transport);
	          transport = null;
	          self.upgrading = false;
	          self.flush();
	        });
	      } else {
	        debug$6('probe transport "%s" failed', name);
	        var err = new Error('probe error');
	        err.transport = transport.name;
	        self.emit('upgradeError', err);
	      }
	    });
	  }

	  function freezeTransport () {
	    if (failed) { return; }

	    // Any callback called by transport should be ignored since now
	    failed = true;

	    cleanup();

	    transport.close();
	    transport = null;
	  }

	  // Handle any error that happens while probing
	  function onerror (err) {
	    var error = new Error('probe error: ' + err);
	    error.transport = transport.name;

	    freezeTransport();

	    debug$6('probe transport "%s" failed because of error: %s', name, err);

	    self.emit('upgradeError', error);
	  }

	  function onTransportClose () {
	    onerror('transport closed');
	  }

	  // When the socket is closed while we're probing
	  function onclose () {
	    onerror('socket closed');
	  }

	  // When the socket is upgraded while we're probing
	  function onupgrade (to) {
	    if (transport && to.name !== transport.name) {
	      debug$6('"%s" works - aborting "%s"', to.name, transport.name);
	      freezeTransport();
	    }
	  }

	  // Remove all listeners on the transport and on self
	  function cleanup () {
	    transport.removeListener('open', onTransportOpen);
	    transport.removeListener('error', onerror);
	    transport.removeListener('close', onTransportClose);
	    self.removeListener('close', onclose);
	    self.removeListener('upgrading', onupgrade);
	  }

	  transport.once('open', onTransportOpen);
	  transport.once('error', onerror);
	  transport.once('close', onTransportClose);

	  this.once('close', onclose);
	  this.once('upgrading', onupgrade);

	  transport.open();
	};

	/**
	 * Called when connection is deemed open.
	 *
	 * @api public
	 */

	Socket.prototype.onOpen = function () {
	  var this$1 = this;

	  debug$6('socket open');
	  this.readyState = 'open';
	  Socket.priorWebsocketSuccess = 'websocket' === this.transport.name;
	  this.emit('open');
	  this.flush();

	  // we check for `readyState` in case an `open`
	  // listener already closed the socket
	  if ('open' === this.readyState && this.upgrade && this.transport.pause) {
	    debug$6('starting upgrade probes');
	    for (var i = 0, l = this.upgrades.length; i < l; i++) {
	      this$1.probe(this$1.upgrades[i]);
	    }
	  }
	};

	/**
	 * Handles a packet.
	 *
	 * @api private
	 */

	Socket.prototype.onPacket = function (packet) {
	  if ('opening' === this.readyState || 'open' === this.readyState ||
	      'closing' === this.readyState) {
	    debug$6('socket receive: type "%s", data "%s"', packet.type, packet.data);

	    this.emit('packet', packet);

	    // Socket is live - any packet counts
	    this.emit('heartbeat');

	    switch (packet.type) {
	      case 'open':
	        this.onHandshake(JSON.parse(packet.data));
	        break;

	      case 'pong':
	        this.setPing();
	        this.emit('pong');
	        break;

	      case 'error':
	        var err = new Error('server error');
	        err.code = packet.data;
	        this.onError(err);
	        break;

	      case 'message':
	        this.emit('data', packet.data);
	        this.emit('message', packet.data);
	        break;
	    }
	  } else {
	    debug$6('packet received with socket readyState "%s"', this.readyState);
	  }
	};

	/**
	 * Called upon handshake completion.
	 *
	 * @param {Object} handshake obj
	 * @api private
	 */

	Socket.prototype.onHandshake = function (data) {
	  this.emit('handshake', data);
	  this.id = data.sid;
	  this.transport.query.sid = data.sid;
	  this.upgrades = this.filterUpgrades(data.upgrades);
	  this.pingInterval = data.pingInterval;
	  this.pingTimeout = data.pingTimeout;
	  this.onOpen();
	  // In case open handler closes socket
	  if ('closed' === this.readyState) { return; }
	  this.setPing();

	  // Prolong liveness of socket on heartbeat
	  this.removeListener('heartbeat', this.onHeartbeat);
	  this.on('heartbeat', this.onHeartbeat);
	};

	/**
	 * Resets ping timeout.
	 *
	 * @api private
	 */

	Socket.prototype.onHeartbeat = function (timeout) {
	  clearTimeout(this.pingTimeoutTimer);
	  var self = this;
	  self.pingTimeoutTimer = setTimeout(function () {
	    if ('closed' === self.readyState) { return; }
	    self.onClose('ping timeout');
	  }, timeout || (self.pingInterval + self.pingTimeout));
	};

	/**
	 * Pings server every `this.pingInterval` and expects response
	 * within `this.pingTimeout` or closes connection.
	 *
	 * @api private
	 */

	Socket.prototype.setPing = function () {
	  var self = this;
	  clearTimeout(self.pingIntervalTimer);
	  self.pingIntervalTimer = setTimeout(function () {
	    debug$6('writing ping packet - expecting pong within %sms', self.pingTimeout);
	    self.ping();
	    self.onHeartbeat(self.pingTimeout);
	  }, self.pingInterval);
	};

	/**
	* Sends a ping packet.
	*
	* @api private
	*/

	Socket.prototype.ping = function () {
	  var self = this;
	  this.sendPacket('ping', function () {
	    self.emit('ping');
	  });
	};

	/**
	 * Called on `drain` event
	 *
	 * @api private
	 */

	Socket.prototype.onDrain = function () {
	  this.writeBuffer.splice(0, this.prevBufferLen);

	  // setting prevBufferLen = 0 is very important
	  // for example, when upgrading, upgrade packet is sent over,
	  // and a nonzero prevBufferLen could cause problems on `drain`
	  this.prevBufferLen = 0;

	  if (0 === this.writeBuffer.length) {
	    this.emit('drain');
	  } else {
	    this.flush();
	  }
	};

	/**
	 * Flush write buffers.
	 *
	 * @api private
	 */

	Socket.prototype.flush = function () {
	  if ('closed' !== this.readyState && this.transport.writable &&
	    !this.upgrading && this.writeBuffer.length) {
	    debug$6('flushing %d packets in socket', this.writeBuffer.length);
	    this.transport.send(this.writeBuffer);
	    // keep track of current length of writeBuffer
	    // splice writeBuffer and callbackBuffer on `drain`
	    this.prevBufferLen = this.writeBuffer.length;
	    this.emit('flush');
	  }
	};

	/**
	 * Sends a message.
	 *
	 * @param {String} message.
	 * @param {Function} callback function.
	 * @param {Object} options.
	 * @return {Socket} for chaining.
	 * @api public
	 */

	Socket.prototype.write =
	Socket.prototype.send = function (msg, options, fn) {
	  this.sendPacket('message', msg, options, fn);
	  return this;
	};

	/**
	 * Sends a packet.
	 *
	 * @param {String} packet type.
	 * @param {String} data.
	 * @param {Object} options.
	 * @param {Function} callback function.
	 * @api private
	 */

	Socket.prototype.sendPacket = function (type, data, options, fn) {
	  if ('function' === typeof data) {
	    fn = data;
	    data = undefined;
	  }

	  if ('function' === typeof options) {
	    fn = options;
	    options = null;
	  }

	  if ('closing' === this.readyState || 'closed' === this.readyState) {
	    return;
	  }

	  options = options || {};
	  options.compress = false !== options.compress;

	  var packet = {
	    type: type,
	    data: data,
	    options: options
	  };
	  this.emit('packetCreate', packet);
	  this.writeBuffer.push(packet);
	  if (fn) { this.once('flush', fn); }
	  this.flush();
	};

	/**
	 * Closes the connection.
	 *
	 * @api private
	 */

	Socket.prototype.close = function () {
	  if ('opening' === this.readyState || 'open' === this.readyState) {
	    this.readyState = 'closing';

	    var self = this;

	    if (this.writeBuffer.length) {
	      this.once('drain', function () {
	        if (this.upgrading) {
	          waitForUpgrade();
	        } else {
	          close();
	        }
	      });
	    } else if (this.upgrading) {
	      waitForUpgrade();
	    } else {
	      close();
	    }
	  }

	  function close () {
	    self.onClose('forced close');
	    debug$6('socket closing - telling transport to close');
	    self.transport.close();
	  }

	  function cleanupAndClose () {
	    self.removeListener('upgrade', cleanupAndClose);
	    self.removeListener('upgradeError', cleanupAndClose);
	    close();
	  }

	  function waitForUpgrade () {
	    // wait for upgrade to finish since we can't send packets while pausing a transport
	    self.once('upgrade', cleanupAndClose);
	    self.once('upgradeError', cleanupAndClose);
	  }

	  return this;
	};

	/**
	 * Called upon transport error
	 *
	 * @api private
	 */

	Socket.prototype.onError = function (err) {
	  debug$6('socket error %j', err);
	  Socket.priorWebsocketSuccess = false;
	  this.emit('error', err);
	  this.onClose('transport error', err);
	};

	/**
	 * Called upon transport close.
	 *
	 * @api private
	 */

	Socket.prototype.onClose = function (reason, desc) {
	  if ('opening' === this.readyState || 'open' === this.readyState || 'closing' === this.readyState) {
	    debug$6('socket close with reason: "%s"', reason);
	    var self = this;

	    // clear timers
	    clearTimeout(this.pingIntervalTimer);
	    clearTimeout(this.pingTimeoutTimer);

	    // stop event from firing again for transport
	    this.transport.removeAllListeners('close');

	    // ensure transport won't stay open
	    this.transport.close();

	    // ignore further transport communication
	    this.transport.removeAllListeners();

	    // set ready state
	    this.readyState = 'closed';

	    // clear session id
	    this.id = null;

	    // emit close event
	    this.emit('close', reason, desc);

	    // clean buffers after, so users can still
	    // grab the buffers on `close` event
	    self.writeBuffer = [];
	    self.prevBufferLen = 0;
	  }
	};

	/**
	 * Filters upgrades, returning only those matching client transports.
	 *
	 * @param {Array} server upgrades
	 * @api private
	 *
	 */

	Socket.prototype.filterUpgrades = function (upgrades) {
	  var this$1 = this;

	  var filteredUpgrades = [];
	  for (var i = 0, j = upgrades.length; i < j; i++) {
	    if (~index$2(this$1.transports, upgrades[i])) { filteredUpgrades.push(upgrades[i]); }
	  }
	  return filteredUpgrades;
	};

	var socket$1 = /*#__PURE__*/Object.freeze({
		default: socket,
		__moduleExports: socket
	});

	var require$$0$4 = ( socket$1 && socket ) || socket$1;

	var lib = require$$0$4;

	/**
	 * Exports parser
	 *
	 * @api public
	 *
	 */
	var parser$1 = parser;
	lib.parser = parser$1;

	var lib$1 = /*#__PURE__*/Object.freeze({
		default: lib,
		__moduleExports: lib,
		parser: parser$1
	});

	var toArray_1 = toArray$2;

	function toArray$2(list, index) {
	    var array = [];

	    index = index || 0;

	    for (var i = index || 0; i < list.length; i++) {
	        array[i - index] = list[i];
	    }

	    return array
	}

	var toArray$3 = /*#__PURE__*/Object.freeze({
		default: toArray_1,
		__moduleExports: toArray_1
	});

	/**
	 * Module exports.
	 */

	var on_1 = on$1;

	/**
	 * Helper for subscriptions.
	 *
	 * @param {Object|EventEmitter} obj with `Emitter` mixin or `EventEmitter`
	 * @param {String} event name
	 * @param {Function} callback
	 * @api public
	 */

	function on$1 (obj, ev, fn) {
	  obj.on(ev, fn);
	  return {
	    destroy: function () {
	      obj.removeListener(ev, fn);
	    }
	  };
	}

	var on$2 = /*#__PURE__*/Object.freeze({
		default: on_1,
		__moduleExports: on_1
	});

	/**
	 * Slice reference.
	 */

	var slice = [].slice;

	/**
	 * Bind `obj` to `fn`.
	 *
	 * @param {Object} obj
	 * @param {Function|String} fn or string
	 * @return {Function}
	 * @api public
	 */

	var componentBind = function(obj, fn){
	  if ('string' == typeof fn) { fn = obj[fn]; }
	  if ('function' != typeof fn) { throw new Error('bind() requires a function'); }
	  var args = slice.call(arguments, 2);
	  return function(){
	    return fn.apply(obj, args.concat(slice.call(arguments)));
	  }
	};

	var componentBind$1 = /*#__PURE__*/Object.freeze({
		default: componentBind,
		__moduleExports: componentBind
	});

	var parser$2 = ( socket_ioParser$1 && socket_ioParser ) || socket_ioParser$1;

	var toArray$4 = ( toArray$3 && toArray_1 ) || toArray$3;

	var on$3 = ( on$2 && on_1 ) || on$2;

	var bind$1 = ( componentBind$1 && componentBind ) || componentBind$1;

	var socket$2 = createCommonjsModule(function (module, exports) {
	/**
	 * Module dependencies.
	 */






	var debug = require$$0$2('socket.io-client:socket');



	/**
	 * Module exports.
	 */

	module.exports = exports = Socket;

	/**
	 * Internal events (blacklisted).
	 * These events can't be emitted by the user.
	 *
	 * @api private
	 */

	var events = {
	  connect: 1,
	  connect_error: 1,
	  connect_timeout: 1,
	  connecting: 1,
	  disconnect: 1,
	  error: 1,
	  reconnect: 1,
	  reconnect_attempt: 1,
	  reconnect_failed: 1,
	  reconnect_error: 1,
	  reconnecting: 1,
	  ping: 1,
	  pong: 1
	};

	/**
	 * Shortcut to `Emitter#emit`.
	 */

	var emit = Emitter.prototype.emit;

	/**
	 * `Socket` constructor.
	 *
	 * @api public
	 */

	function Socket (io, nsp, opts) {
	  this.io = io;
	  this.nsp = nsp;
	  this.json = this; // compat
	  this.ids = 0;
	  this.acks = {};
	  this.receiveBuffer = [];
	  this.sendBuffer = [];
	  this.connected = false;
	  this.disconnected = true;
	  this.flags = {};
	  if (opts && opts.query) {
	    this.query = opts.query;
	  }
	  if (this.io.autoConnect) { this.open(); }
	}

	/**
	 * Mix in `Emitter`.
	 */

	Emitter(Socket.prototype);

	/**
	 * Subscribe to open, close and packet events
	 *
	 * @api private
	 */

	Socket.prototype.subEvents = function () {
	  if (this.subs) { return; }

	  var io = this.io;
	  this.subs = [
	    on$3(io, 'open', bind$1(this, 'onopen')),
	    on$3(io, 'packet', bind$1(this, 'onpacket')),
	    on$3(io, 'close', bind$1(this, 'onclose'))
	  ];
	};

	/**
	 * "Opens" the socket.
	 *
	 * @api public
	 */

	Socket.prototype.open =
	Socket.prototype.connect = function () {
	  if (this.connected) { return this; }

	  this.subEvents();
	  if (!this.io.reconnecting) { this.io.open(); } // ensure open
	  if ('open' === this.io.readyState) { this.onopen(); }
	  this.emit('connecting');
	  return this;
	};

	/**
	 * Sends a `message` event.
	 *
	 * @return {Socket} self
	 * @api public
	 */

	Socket.prototype.send = function () {
	  var args = toArray$4(arguments);
	  args.unshift('message');
	  this.emit.apply(this, args);
	  return this;
	};

	/**
	 * Override `emit`.
	 * If the event is in `events`, it's emitted normally.
	 *
	 * @param {String} event name
	 * @return {Socket} self
	 * @api public
	 */

	Socket.prototype.emit = function (ev) {
	  if (events.hasOwnProperty(ev)) {
	    emit.apply(this, arguments);
	    return this;
	  }

	  var args = toArray$4(arguments);
	  var packet = {
	    type: (this.flags.binary !== undefined ? this.flags.binary : hasBinary$1(args)) ? parser$2.BINARY_EVENT : parser$2.EVENT,
	    data: args
	  };

	  packet.options = {};
	  packet.options.compress = !this.flags || false !== this.flags.compress;

	  // event ack callback
	  if ('function' === typeof args[args.length - 1]) {
	    debug('emitting packet with ack id %d', this.ids);
	    this.acks[this.ids] = args.pop();
	    packet.id = this.ids++;
	  }

	  if (this.connected) {
	    this.packet(packet);
	  } else {
	    this.sendBuffer.push(packet);
	  }

	  this.flags = {};

	  return this;
	};

	/**
	 * Sends a packet.
	 *
	 * @param {Object} packet
	 * @api private
	 */

	Socket.prototype.packet = function (packet) {
	  packet.nsp = this.nsp;
	  this.io.packet(packet);
	};

	/**
	 * Called upon engine `open`.
	 *
	 * @api private
	 */

	Socket.prototype.onopen = function () {
	  debug('transport is open - connecting');

	  // write connect packet if necessary
	  if ('/' !== this.nsp) {
	    if (this.query) {
	      var query = typeof this.query === 'object' ? parseqs$2.encode(this.query) : this.query;
	      debug('sending connect packet with query %s', query);
	      this.packet({type: parser$2.CONNECT, query: query});
	    } else {
	      this.packet({type: parser$2.CONNECT});
	    }
	  }
	};

	/**
	 * Called upon engine `close`.
	 *
	 * @param {String} reason
	 * @api private
	 */

	Socket.prototype.onclose = function (reason) {
	  debug('close (%s)', reason);
	  this.connected = false;
	  this.disconnected = true;
	  delete this.id;
	  this.emit('disconnect', reason);
	};

	/**
	 * Called with socket packet.
	 *
	 * @param {Object} packet
	 * @api private
	 */

	Socket.prototype.onpacket = function (packet) {
	  var sameNamespace = packet.nsp === this.nsp;
	  var rootNamespaceError = packet.type === parser$2.ERROR && packet.nsp === '/';

	  if (!sameNamespace && !rootNamespaceError) { return; }

	  switch (packet.type) {
	    case parser$2.CONNECT:
	      this.onconnect();
	      break;

	    case parser$2.EVENT:
	      this.onevent(packet);
	      break;

	    case parser$2.BINARY_EVENT:
	      this.onevent(packet);
	      break;

	    case parser$2.ACK:
	      this.onack(packet);
	      break;

	    case parser$2.BINARY_ACK:
	      this.onack(packet);
	      break;

	    case parser$2.DISCONNECT:
	      this.ondisconnect();
	      break;

	    case parser$2.ERROR:
	      this.emit('error', packet.data);
	      break;
	  }
	};

	/**
	 * Called upon a server event.
	 *
	 * @param {Object} packet
	 * @api private
	 */

	Socket.prototype.onevent = function (packet) {
	  var args = packet.data || [];
	  debug('emitting event %j', args);

	  if (null != packet.id) {
	    debug('attaching ack callback to event');
	    args.push(this.ack(packet.id));
	  }

	  if (this.connected) {
	    emit.apply(this, args);
	  } else {
	    this.receiveBuffer.push(args);
	  }
	};

	/**
	 * Produces an ack callback to emit with an event.
	 *
	 * @api private
	 */

	Socket.prototype.ack = function (id) {
	  var self = this;
	  var sent = false;
	  return function () {
	    // prevent double callbacks
	    if (sent) { return; }
	    sent = true;
	    var args = toArray$4(arguments);
	    debug('sending ack %j', args);

	    self.packet({
	      type: hasBinary$1(args) ? parser$2.BINARY_ACK : parser$2.ACK,
	      id: id,
	      data: args
	    });
	  };
	};

	/**
	 * Called upon a server acknowlegement.
	 *
	 * @param {Object} packet
	 * @api private
	 */

	Socket.prototype.onack = function (packet) {
	  var ack = this.acks[packet.id];
	  if ('function' === typeof ack) {
	    debug('calling ack %s with %j', packet.id, packet.data);
	    ack.apply(this, packet.data);
	    delete this.acks[packet.id];
	  } else {
	    debug('bad ack %s', packet.id);
	  }
	};

	/**
	 * Called upon server connect.
	 *
	 * @api private
	 */

	Socket.prototype.onconnect = function () {
	  this.connected = true;
	  this.disconnected = false;
	  this.emit('connect');
	  this.emitBuffered();
	};

	/**
	 * Emit buffered events (received and emitted).
	 *
	 * @api private
	 */

	Socket.prototype.emitBuffered = function () {
	  var this$1 = this;

	  var i;
	  for (i = 0; i < this.receiveBuffer.length; i++) {
	    emit.apply(this$1, this$1.receiveBuffer[i]);
	  }
	  this.receiveBuffer = [];

	  for (i = 0; i < this.sendBuffer.length; i++) {
	    this$1.packet(this$1.sendBuffer[i]);
	  }
	  this.sendBuffer = [];
	};

	/**
	 * Called upon server disconnect.
	 *
	 * @api private
	 */

	Socket.prototype.ondisconnect = function () {
	  debug('server disconnect (%s)', this.nsp);
	  this.destroy();
	  this.onclose('io server disconnect');
	};

	/**
	 * Called upon forced client/server side disconnections,
	 * this method ensures the manager stops tracking us and
	 * that reconnections don't get triggered for this.
	 *
	 * @api private.
	 */

	Socket.prototype.destroy = function () {
	  var this$1 = this;

	  if (this.subs) {
	    // clean subscriptions to avoid reconnections
	    for (var i = 0; i < this.subs.length; i++) {
	      this$1.subs[i].destroy();
	    }
	    this.subs = null;
	  }

	  this.io.destroy(this);
	};

	/**
	 * Disconnects the socket manually.
	 *
	 * @return {Socket} self
	 * @api public
	 */

	Socket.prototype.close =
	Socket.prototype.disconnect = function () {
	  if (this.connected) {
	    debug('performing disconnect (%s)', this.nsp);
	    this.packet({ type: parser$2.DISCONNECT });
	  }

	  // remove socket from pool
	  this.destroy();

	  if (this.connected) {
	    // fire events
	    this.onclose('io client disconnect');
	  }
	  return this;
	};

	/**
	 * Sets the compress flag.
	 *
	 * @param {Boolean} if `true`, compresses the sending data
	 * @return {Socket} self
	 * @api public
	 */

	Socket.prototype.compress = function (compress) {
	  this.flags.compress = compress;
	  return this;
	};

	/**
	 * Sets the binary flag
	 *
	 * @param {Boolean} whether the emitted data contains binary
	 * @return {Socket} self
	 * @api public
	 */

	Socket.prototype.binary = function (binary) {
	  this.flags.binary = binary;
	  return this;
	};
	});

	var socket$3 = /*#__PURE__*/Object.freeze({
		default: socket$2,
		__moduleExports: socket$2
	});

	/**
	 * Expose `Backoff`.
	 */

	var backo2 = Backoff;

	/**
	 * Initialize backoff timer with `opts`.
	 *
	 * - `min` initial timeout in milliseconds [100]
	 * - `max` max timeout [10000]
	 * - `jitter` [0]
	 * - `factor` [2]
	 *
	 * @param {Object} opts
	 * @api public
	 */

	function Backoff(opts) {
	  opts = opts || {};
	  this.ms = opts.min || 100;
	  this.max = opts.max || 10000;
	  this.factor = opts.factor || 2;
	  this.jitter = opts.jitter > 0 && opts.jitter <= 1 ? opts.jitter : 0;
	  this.attempts = 0;
	}

	/**
	 * Return the backoff duration.
	 *
	 * @return {Number}
	 * @api public
	 */

	Backoff.prototype.duration = function(){
	  var ms = this.ms * Math.pow(this.factor, this.attempts++);
	  if (this.jitter) {
	    var rand =  Math.random();
	    var deviation = Math.floor(rand * this.jitter * ms);
	    ms = (Math.floor(rand * 10) & 1) == 0  ? ms - deviation : ms + deviation;
	  }
	  return Math.min(ms, this.max) | 0;
	};

	/**
	 * Reset the number of attempts.
	 *
	 * @api public
	 */

	Backoff.prototype.reset = function(){
	  this.attempts = 0;
	};

	/**
	 * Set the minimum duration
	 *
	 * @api public
	 */

	Backoff.prototype.setMin = function(min){
	  this.ms = min;
	};

	/**
	 * Set the maximum duration
	 *
	 * @api public
	 */

	Backoff.prototype.setMax = function(max){
	  this.max = max;
	};

	/**
	 * Set the jitter
	 *
	 * @api public
	 */

	Backoff.prototype.setJitter = function(jitter){
	  this.jitter = jitter;
	};

	var backo2$1 = /*#__PURE__*/Object.freeze({
		default: backo2,
		__moduleExports: backo2
	});

	var eio = ( lib$1 && lib ) || lib$1;

	var Socket$1 = ( socket$3 && socket$2 ) || socket$3;

	var Backoff$1 = ( backo2$1 && backo2 ) || backo2$1;

	/**
	 * Module dependencies.
	 */







	var debug$7 = require$$0$2('socket.io-client:manager');



	/**
	 * IE6+ hasOwnProperty
	 */

	var has$1 = Object.prototype.hasOwnProperty;

	/**
	 * Module exports
	 */

	var manager = Manager;

	/**
	 * `Manager` constructor.
	 *
	 * @param {String} engine instance or engine uri/opts
	 * @param {Object} options
	 * @api public
	 */

	function Manager (uri, opts) {
	  if (!(this instanceof Manager)) { return new Manager(uri, opts); }
	  if (uri && ('object' === typeof uri)) {
	    opts = uri;
	    uri = undefined;
	  }
	  opts = opts || {};

	  opts.path = opts.path || '/socket.io';
	  this.nsps = {};
	  this.subs = [];
	  this.opts = opts;
	  this.reconnection(opts.reconnection !== false);
	  this.reconnectionAttempts(opts.reconnectionAttempts || Infinity);
	  this.reconnectionDelay(opts.reconnectionDelay || 1000);
	  this.reconnectionDelayMax(opts.reconnectionDelayMax || 5000);
	  this.randomizationFactor(opts.randomizationFactor || 0.5);
	  this.backoff = new Backoff$1({
	    min: this.reconnectionDelay(),
	    max: this.reconnectionDelayMax(),
	    jitter: this.randomizationFactor()
	  });
	  this.timeout(null == opts.timeout ? 20000 : opts.timeout);
	  this.readyState = 'closed';
	  this.uri = uri;
	  this.connecting = [];
	  this.lastPing = null;
	  this.encoding = false;
	  this.packetBuffer = [];
	  var _parser = opts.parser || parser$2;
	  this.encoder = new _parser.Encoder();
	  this.decoder = new _parser.Decoder();
	  this.autoConnect = opts.autoConnect !== false;
	  if (this.autoConnect) { this.open(); }
	}

	/**
	 * Propagate given event to sockets and emit on `this`
	 *
	 * @api private
	 */

	Manager.prototype.emitAll = function () {
	  var arguments$1 = arguments;
	  var this$1 = this;

	  this.emit.apply(this, arguments);
	  for (var nsp in this$1.nsps) {
	    if (has$1.call(this$1.nsps, nsp)) {
	      this$1.nsps[nsp].emit.apply(this$1.nsps[nsp], arguments$1);
	    }
	  }
	};

	/**
	 * Update `socket.id` of all sockets
	 *
	 * @api private
	 */

	Manager.prototype.updateSocketIds = function () {
	  var this$1 = this;

	  for (var nsp in this$1.nsps) {
	    if (has$1.call(this$1.nsps, nsp)) {
	      this$1.nsps[nsp].id = this$1.generateId(nsp);
	    }
	  }
	};

	/**
	 * generate `socket.id` for the given `nsp`
	 *
	 * @param {String} nsp
	 * @return {String}
	 * @api private
	 */

	Manager.prototype.generateId = function (nsp) {
	  return (nsp === '/' ? '' : (nsp + '#')) + this.engine.id;
	};

	/**
	 * Mix in `Emitter`.
	 */

	Emitter(Manager.prototype);

	/**
	 * Sets the `reconnection` config.
	 *
	 * @param {Boolean} true/false if it should automatically reconnect
	 * @return {Manager} self or value
	 * @api public
	 */

	Manager.prototype.reconnection = function (v) {
	  if (!arguments.length) { return this._reconnection; }
	  this._reconnection = !!v;
	  return this;
	};

	/**
	 * Sets the reconnection attempts config.
	 *
	 * @param {Number} max reconnection attempts before giving up
	 * @return {Manager} self or value
	 * @api public
	 */

	Manager.prototype.reconnectionAttempts = function (v) {
	  if (!arguments.length) { return this._reconnectionAttempts; }
	  this._reconnectionAttempts = v;
	  return this;
	};

	/**
	 * Sets the delay between reconnections.
	 *
	 * @param {Number} delay
	 * @return {Manager} self or value
	 * @api public
	 */

	Manager.prototype.reconnectionDelay = function (v) {
	  if (!arguments.length) { return this._reconnectionDelay; }
	  this._reconnectionDelay = v;
	  this.backoff && this.backoff.setMin(v);
	  return this;
	};

	Manager.prototype.randomizationFactor = function (v) {
	  if (!arguments.length) { return this._randomizationFactor; }
	  this._randomizationFactor = v;
	  this.backoff && this.backoff.setJitter(v);
	  return this;
	};

	/**
	 * Sets the maximum delay between reconnections.
	 *
	 * @param {Number} delay
	 * @return {Manager} self or value
	 * @api public
	 */

	Manager.prototype.reconnectionDelayMax = function (v) {
	  if (!arguments.length) { return this._reconnectionDelayMax; }
	  this._reconnectionDelayMax = v;
	  this.backoff && this.backoff.setMax(v);
	  return this;
	};

	/**
	 * Sets the connection timeout. `false` to disable
	 *
	 * @return {Manager} self or value
	 * @api public
	 */

	Manager.prototype.timeout = function (v) {
	  if (!arguments.length) { return this._timeout; }
	  this._timeout = v;
	  return this;
	};

	/**
	 * Starts trying to reconnect if reconnection is enabled and we have not
	 * started reconnecting yet
	 *
	 * @api private
	 */

	Manager.prototype.maybeReconnectOnOpen = function () {
	  // Only try to reconnect if it's the first time we're connecting
	  if (!this.reconnecting && this._reconnection && this.backoff.attempts === 0) {
	    // keeps reconnection from firing twice for the same reconnection loop
	    this.reconnect();
	  }
	};

	/**
	 * Sets the current transport `socket`.
	 *
	 * @param {Function} optional, callback
	 * @return {Manager} self
	 * @api public
	 */

	Manager.prototype.open =
	Manager.prototype.connect = function (fn, opts) {
	  debug$7('readyState %s', this.readyState);
	  if (~this.readyState.indexOf('open')) { return this; }

	  debug$7('opening %s', this.uri);
	  this.engine = eio(this.uri, this.opts);
	  var socket = this.engine;
	  var self = this;
	  this.readyState = 'opening';
	  this.skipReconnect = false;

	  // emit `open`
	  var openSub = on$3(socket, 'open', function () {
	    self.onopen();
	    fn && fn();
	  });

	  // emit `connect_error`
	  var errorSub = on$3(socket, 'error', function (data) {
	    debug$7('connect_error');
	    self.cleanup();
	    self.readyState = 'closed';
	    self.emitAll('connect_error', data);
	    if (fn) {
	      var err = new Error('Connection error');
	      err.data = data;
	      fn(err);
	    } else {
	      // Only do this if there is no fn to handle the error
	      self.maybeReconnectOnOpen();
	    }
	  });

	  // emit `connect_timeout`
	  if (false !== this._timeout) {
	    var timeout = this._timeout;
	    debug$7('connect attempt will timeout after %d', timeout);

	    if (timeout === 0) {
	      openSub.destroy(); // prevents a race condition with the 'open' event
	    }

	    // set timer
	    var timer = setTimeout(function () {
	      debug$7('connect attempt timed out after %d', timeout);
	      openSub.destroy();
	      socket.close();
	      socket.emit('error', 'timeout');
	      self.emitAll('connect_timeout', timeout);
	    }, timeout);

	    this.subs.push({
	      destroy: function () {
	        clearTimeout(timer);
	      }
	    });
	  }

	  this.subs.push(openSub);
	  this.subs.push(errorSub);

	  return this;
	};

	/**
	 * Called upon transport open.
	 *
	 * @api private
	 */

	Manager.prototype.onopen = function () {
	  debug$7('open');

	  // clear old subs
	  this.cleanup();

	  // mark as open
	  this.readyState = 'open';
	  this.emit('open');

	  // add new subs
	  var socket = this.engine;
	  this.subs.push(on$3(socket, 'data', bind$1(this, 'ondata')));
	  this.subs.push(on$3(socket, 'ping', bind$1(this, 'onping')));
	  this.subs.push(on$3(socket, 'pong', bind$1(this, 'onpong')));
	  this.subs.push(on$3(socket, 'error', bind$1(this, 'onerror')));
	  this.subs.push(on$3(socket, 'close', bind$1(this, 'onclose')));
	  this.subs.push(on$3(this.decoder, 'decoded', bind$1(this, 'ondecoded')));
	};

	/**
	 * Called upon a ping.
	 *
	 * @api private
	 */

	Manager.prototype.onping = function () {
	  this.lastPing = new Date();
	  this.emitAll('ping');
	};

	/**
	 * Called upon a packet.
	 *
	 * @api private
	 */

	Manager.prototype.onpong = function () {
	  this.emitAll('pong', new Date() - this.lastPing);
	};

	/**
	 * Called with data.
	 *
	 * @api private
	 */

	Manager.prototype.ondata = function (data) {
	  this.decoder.add(data);
	};

	/**
	 * Called when parser fully decodes a packet.
	 *
	 * @api private
	 */

	Manager.prototype.ondecoded = function (packet) {
	  this.emit('packet', packet);
	};

	/**
	 * Called upon socket error.
	 *
	 * @api private
	 */

	Manager.prototype.onerror = function (err) {
	  debug$7('error', err);
	  this.emitAll('error', err);
	};

	/**
	 * Creates a new socket for the given `nsp`.
	 *
	 * @return {Socket}
	 * @api public
	 */

	Manager.prototype.socket = function (nsp, opts) {
	  var socket = this.nsps[nsp];
	  if (!socket) {
	    socket = new Socket$1(this, nsp, opts);
	    this.nsps[nsp] = socket;
	    var self = this;
	    socket.on('connecting', onConnecting);
	    socket.on('connect', function () {
	      socket.id = self.generateId(nsp);
	    });

	    if (this.autoConnect) {
	      // manually call here since connecting event is fired before listening
	      onConnecting();
	    }
	  }

	  function onConnecting () {
	    if (!~index$2(self.connecting, socket)) {
	      self.connecting.push(socket);
	    }
	  }

	  return socket;
	};

	/**
	 * Called upon a socket close.
	 *
	 * @param {Socket} socket
	 */

	Manager.prototype.destroy = function (socket) {
	  var index = index$2(this.connecting, socket);
	  if (~index) { this.connecting.splice(index, 1); }
	  if (this.connecting.length) { return; }

	  this.close();
	};

	/**
	 * Writes a packet.
	 *
	 * @param {Object} packet
	 * @api private
	 */

	Manager.prototype.packet = function (packet) {
	  debug$7('writing packet %j', packet);
	  var self = this;
	  if (packet.query && packet.type === 0) { packet.nsp += '?' + packet.query; }

	  if (!self.encoding) {
	    // encode, then write to engine with result
	    self.encoding = true;
	    this.encoder.encode(packet, function (encodedPackets) {
	      for (var i = 0; i < encodedPackets.length; i++) {
	        self.engine.write(encodedPackets[i], packet.options);
	      }
	      self.encoding = false;
	      self.processPacketQueue();
	    });
	  } else { // add packet to the queue
	    self.packetBuffer.push(packet);
	  }
	};

	/**
	 * If packet buffer is non-empty, begins encoding the
	 * next packet in line.
	 *
	 * @api private
	 */

	Manager.prototype.processPacketQueue = function () {
	  if (this.packetBuffer.length > 0 && !this.encoding) {
	    var pack = this.packetBuffer.shift();
	    this.packet(pack);
	  }
	};

	/**
	 * Clean up transport subscriptions and packet buffer.
	 *
	 * @api private
	 */

	Manager.prototype.cleanup = function () {
	  var this$1 = this;

	  debug$7('cleanup');

	  var subsLength = this.subs.length;
	  for (var i = 0; i < subsLength; i++) {
	    var sub = this$1.subs.shift();
	    sub.destroy();
	  }

	  this.packetBuffer = [];
	  this.encoding = false;
	  this.lastPing = null;

	  this.decoder.destroy();
	};

	/**
	 * Close the current socket.
	 *
	 * @api private
	 */

	Manager.prototype.close =
	Manager.prototype.disconnect = function () {
	  debug$7('disconnect');
	  this.skipReconnect = true;
	  this.reconnecting = false;
	  if ('opening' === this.readyState) {
	    // `onclose` will not fire because
	    // an open event never happened
	    this.cleanup();
	  }
	  this.backoff.reset();
	  this.readyState = 'closed';
	  if (this.engine) { this.engine.close(); }
	};

	/**
	 * Called upon engine close.
	 *
	 * @api private
	 */

	Manager.prototype.onclose = function (reason) {
	  debug$7('onclose');

	  this.cleanup();
	  this.backoff.reset();
	  this.readyState = 'closed';
	  this.emit('close', reason);

	  if (this._reconnection && !this.skipReconnect) {
	    this.reconnect();
	  }
	};

	/**
	 * Attempt a reconnection.
	 *
	 * @api private
	 */

	Manager.prototype.reconnect = function () {
	  if (this.reconnecting || this.skipReconnect) { return this; }

	  var self = this;

	  if (this.backoff.attempts >= this._reconnectionAttempts) {
	    debug$7('reconnect failed');
	    this.backoff.reset();
	    this.emitAll('reconnect_failed');
	    this.reconnecting = false;
	  } else {
	    var delay = this.backoff.duration();
	    debug$7('will wait %dms before reconnect attempt', delay);

	    this.reconnecting = true;
	    var timer = setTimeout(function () {
	      if (self.skipReconnect) { return; }

	      debug$7('attempting reconnect');
	      self.emitAll('reconnect_attempt', self.backoff.attempts);
	      self.emitAll('reconnecting', self.backoff.attempts);

	      // check again for the case socket closed in above events
	      if (self.skipReconnect) { return; }

	      self.open(function (err) {
	        if (err) {
	          debug$7('reconnect attempt error');
	          self.reconnecting = false;
	          self.reconnect();
	          self.emitAll('reconnect_error', err.data);
	        } else {
	          debug$7('reconnect success');
	          self.onreconnect();
	        }
	      });
	    }, delay);

	    this.subs.push({
	      destroy: function () {
	        clearTimeout(timer);
	      }
	    });
	  }
	};

	/**
	 * Called upon successful reconnect.
	 *
	 * @api private
	 */

	Manager.prototype.onreconnect = function () {
	  var attempt = this.backoff.attempts;
	  this.reconnecting = false;
	  this.backoff.reset();
	  this.updateSocketIds();
	  this.emitAll('reconnect', attempt);
	};

	var manager$1 = /*#__PURE__*/Object.freeze({
		default: manager,
		__moduleExports: manager
	});

	var url$2 = ( url$1 && url_1 ) || url$1;

	var Manager$1 = ( manager$1 && manager ) || manager$1;

	var lib$2 = createCommonjsModule(function (module, exports) {
	/**
	 * Module dependencies.
	 */




	var debug = require$$0$2('socket.io-client');

	/**
	 * Module exports.
	 */

	module.exports = exports = lookup;

	/**
	 * Managers cache.
	 */

	var cache = exports.managers = {};

	/**
	 * Looks up an existing `Manager` for multiplexing.
	 * If the user summons:
	 *
	 *   `io('http://localhost/a');`
	 *   `io('http://localhost/b');`
	 *
	 * We reuse the existing instance based on same scheme/port/host,
	 * and we initialize sockets for each namespace.
	 *
	 * @api public
	 */

	function lookup (uri, opts) {
	  if (typeof uri === 'object') {
	    opts = uri;
	    uri = undefined;
	  }

	  opts = opts || {};

	  var parsed = url$2(uri);
	  var source = parsed.source;
	  var id = parsed.id;
	  var path = parsed.path;
	  var sameNamespace = cache[id] && path in cache[id].nsps;
	  var newConnection = opts.forceNew || opts['force new connection'] ||
	                      false === opts.multiplex || sameNamespace;

	  var io;

	  if (newConnection) {
	    debug('ignoring socket cache for %s', source);
	    io = Manager$1(source, opts);
	  } else {
	    if (!cache[id]) {
	      debug('new io instance for %s', source);
	      cache[id] = Manager$1(source, opts);
	    }
	    io = cache[id];
	  }
	  if (parsed.query && !opts.query) {
	    opts.query = parsed.query;
	  }
	  return io.socket(parsed.path, opts);
	}

	/**
	 * Protocol version.
	 *
	 * @api public
	 */

	exports.protocol = parser$2.protocol;

	/**
	 * `connect`.
	 *
	 * @param {String} uri
	 * @api public
	 */

	exports.connect = lookup;

	/**
	 * Expose constructors for standalone build.
	 *
	 * @api public
	 */

	exports.Manager = Manager$1;
	exports.Socket = Socket$1;
	});
	var lib_1 = lib$2.managers;
	var lib_2 = lib$2.protocol;
	var lib_3 = lib$2.connect;
	var lib_4 = lib$2.Manager;
	var lib_5 = lib$2.Socket;

	/* eslint no-param-reassign: ["off"] */

	var ClientStorage = {
	  save: function save(key, value) {
	    if (typeof key === 'undefined' || key === null) { return undefined; }
	    var valueToStore = null;
	    if (typeof value !== 'string') {
	      valueToStore = JSON.stringify(value);
	    } else {
	      valueToStore = value;
	    }

	    return localforage.setItem(key, valueToStore);
	  },
	  get: function get(key) {
	    return localforage.getItem(key)
	      .then(function (value) {
	        if (!value) { return null; }
	        if (value.indexOf('{') === 0 || value.indexOf('[') === 0) {
	          try {
	            value = JSON.parse(value);
	          } catch (e) {
	            ClientStorage.remove(key);
	            value = null;
	          }
	        }
	        return value;
	      });
	  },
	  remove: function remove(key) {
	    if (typeof key === 'undefined' || key === null) { return undefined; }
	    return localforage.removeItem(key);
	  },
	};

	/* eslint no-param-reassign: ["off"] */

	function Queue() {
	  var current = this;
	  current.dataLoaded = false;

	  var queueClientStorageKey = 'GlobalQueueKey';
	  var retryLimit = 3;
	  var queuePostingDelay = 2000;
	  var queue = [];
	  var isPosting = false;
	  var currentQueueItem;
	  var retryCount = 0;
	  var intervalRef = null;
	  var onloadCallbacks = [];

	  localforage.getItem(queueClientStorageKey).then(function (q) {
	    queue = q || [];
	    if (!Array.isArray(queue)) { queue = []; }
	    current.dataLoaded = true;
	    onloadCallbacks.forEach(function (callback) {
	      callback();
	    });
	  });

	  function stopInterval() {
	    clearInterval(intervalRef);
	    intervalRef = null;
	  }

	  function saveQueueToClientStorage() {
	    var saveQueue = [];
	    queue.forEach(function (queueItem) {
	      var saveQueueItem = Object.assign({}, queueItem);
	      // remove callback
	      if (saveQueueItem.callback) { delete saveQueueItem.callback; }
	      // remove extra files data from storage
	      saveQueueItem.data = Object.assign({}, queueItem.data);
	      if (saveQueueItem.data.files && saveQueueItem.data.files.length) {
	        var files = [];
	        saveQueueItem.data.files.forEach(function (file) {
	          files.push({ originalFile: file.originalFile });
	        });
	        saveQueueItem.data.files = files;
	      }
	      Object.keys(saveQueueItem.data).forEach(function (key) {
	        if (typeof saveQueueItem.data[key] === 'function') { delete saveQueueItem.data[key]; }
	      });
	      saveQueue.push(saveQueueItem);
	    });
	    localforage.setItem(queueClientStorageKey, saveQueue);
	  }

	  function commonPost(url, data, callback, callbackError) {
	    var isFormData = data.files || data.formData;
	    data.access_token = window.localStorage.getItem('access_token');
	    data.device_id = window.localStorage.getItem('device_id');

	    var dataToPost = Object.assign({}, data);

	    if (isFormData) {
	      var formData = new window.FormData();
	      var files = [];
	      if (dataToPost.files) {
	        dataToPost.files.forEach(function (file) {
	          files.push({
	            field: 'files',
	            value: file.originalFile,
	          });
	        });
	        delete dataToPost.files;
	      }
	      var jsonData = Object.assign(
	        {},
	        dataToPost
	      );
	      files.forEach(function (file) {
	        formData.append(file.field, file.value, file.value.name);
	      });
	      formData.append('_json', JSON.stringify(jsonData));
	      dataToPost = formData;
	    }

	    Framework7.request({
	      url: Brief$1.api + url,
	      method: 'POST',
	      dataType: 'json',
	      processData: isFormData,
	      contentType: isFormData ? 'multipart/form-data' : 'application/json',
	      data: isFormData ? dataToPost : JSON.stringify(dataToPost),
	      crossDomain: !isFormData,
	      success: function success(res) {
	        if (!res.success) {
	          if (data.isSendMessage) {
	            Brief$1.events.$emit('send-message-error');
	          }
	          Brief$1.notify('Error!', res.data.Message || res.data);
	          if (res.data && res.data.authFailed) {
	            Brief$1.logout();
	          }
	        } else {
	          if (res.data && res.data.notify && res.data.message) {
	            Brief$1.notify('Success', res.data.message);
	          }
	        }
	        callback(res);
	      },
	      error: function error() {
	        Brief$1.events.$emit('post-error');
	        callbackError();
	      },
	    });
	  }

	  function postNextItemFromQueue() {
	    if (isPosting) { return; }

	    var nextItemInLine = queue.shift();
	    if (!nextItemInLine) {
	      stopInterval();
	      saveQueueToClientStorage();
	      return;
	    }

	    isPosting = true;
	    currentQueueItem = nextItemInLine;
	    commonPost(
	      nextItemInLine.url,
	      nextItemInLine.data,
	      function (response) {
	        isPosting = false;
	        var data = response.data;
	        if (!(nextItemInLine.data instanceof window.FormData)) {
	          if (data) { nextItemInLine.data.id = data.id; }
	          nextItemInLine.data.isNew = false;
	        }

	        saveQueueToClientStorage();
	        if (nextItemInLine.callback) { nextItemInLine.callback(response); }
	        postNextItemFromQueue();
	      },
	      function () {
	        isPosting = false;

	        var alreadyExists = queue.find(function (item) { return item.key === nextItemInLine.key; });
	        if (alreadyExists) { return; }

	        retryCount += 1;

	        queue.push(nextItemInLine);
	        saveQueueToClientStorage();
	        if (retryCount >= retryLimit) { stopInterval(); }
	      }
	    );
	  }
	  current.getQueue = function getQueue() {
	    if ((!queue || !queue.length) && !currentQueueItem) { return []; }
	    var currentQueue = [];
	    if (currentQueueItem) { currentQueue.push(currentQueueItem); }
	    currentQueue.push.apply(currentQueue, queue);
	    return currentQueue;
	  };
	  current.start = function start() {
	    if (queue.length === 0) { return; }

	    if (!isPosting) {
	      postNextItemFromQueue();
	    }

	    if (intervalRef) { return; }

	    retryCount = 0;

	    intervalRef = setInterval(postNextItemFromQueue, queuePostingDelay);
	  };

	  current.add = function add(url, data, callback) {
	    var self = this;

	    var uniqueItemKey = url + JSON.stringify(data);
	    var alreadyExists = queue.find(function (item) { return item.key === uniqueItemKey; });

	    if (alreadyExists) { return; }

	    var queueData = {
	      key: uniqueItemKey,
	      url: url,
	      data: data,
	      callback: callback,
	    };
	    queue.push(queueData);

	    saveQueueToClientStorage();
	    self.start();
	  };
	  current.onload = function onload(callback) {
	    if (current.dataLoaded) { callback(); }
	    else { onloadCallbacks.push(callback); }
	  };
	  current.checkStoreMessagesQueue = function checkStoreMessagesQueue(sendingMessages, allMessages) {
	    if (!sendingMessages.length) { return; }
	    function addMessage(newMessage) {
	      var hasMessage;
	      allMessages.forEach(function (message) {
	        if (newMessage.id && newMessage.id === message.id) { hasMessage = true; }
	        if (newMessage.queueId && message.queueId === newMessage.queueId) { hasMessage = true; }
	      });
	      if (hasMessage) { return; }
	      allMessages.push(newMessage);
	    }
	    current.onload(function () {
	      var queueItems = current.getQueue();
	      if (!queueItems.length) { return; }
	      sendingMessages.forEach(function (message) {
	        queueItems.forEach(function (item) {
	          if (message.queueId && message.queueId === item.data.queueId) {
	            item.callback = function callback() {
	              sendingMessages.splice(sendingMessages.indexOf(message), 1);
	              var messageIndex = allMessages.indexOf(message);
	              if (messageIndex >= 0) {
	                allMessages.splice(messageIndex, 1);
	              }
	            };
	            addMessage(message);
	          }
	        });
	      });
	    });
	  };
	}

	var queue$1 = new Queue();

	/* eslint no-param-reassign: ["off"] */

	var localStorage$1 = window.localStorage;

	var defaultSettings = {
	  preProcess: null,
	  getUrl: null,
	  getData: null,
	  getStarted: null,
	  getFinished: null,
	  getLocalFinished: null,
	  subscribeFinished: null,
	  postUrl: null,
	  postData: null,
	  postFinished: null,
	  postNowUrl: null,
	  postNowData: null,
	  postNowFinished: null,
	  getMoreStarted: null,
	  getMoreFinished: null,
	  targetArrayName: null,
	  sync: true,
	  loadFromLocalStorage: true,
	};

	var defaultPaging = {
	  skip: 0,
	  take: 30,
	};

	var socket$4;

	function initSocket() {
	  socket$4 = lib$2(Brief$1.domain, { transports: ['websocket', 'polling'], forceNew: true });

	  socket$4.on('connect', function () {
	    if (localStorage$1.getItem('access_token')) {
	      socket$4.emit('authenticate', {
	        token: localStorage$1.getItem('access_token'),
	        device_id: localStorage$1.getItem('device_id'),
	      });
	      queue$1.onload(function () {
	        queue$1.start();
	      });
	    }
	  });

	  socket$4.on('reconnect', function () {
	    socket$4.emit('authenticate', {
	      token: localStorage$1.getItem('access_token'),
	      device_id: localStorage$1.getItem('device_id'),
	    });
	    queue$1.onload(function () {
	      queue$1.start();
	    });
	  });

	  socket$4.on('unauthorized', function () {
	    Brief$1.logout();
	  });

	  socket$4.on(("update-access-token" + (localStorage$1.getItem('device_id'))), function (accessToken) {
	    localStorage$1.setItem('access_token', accessToken);
	  });
	}

	if (localStorage$1.getItem('access_token') && localStorage$1.getItem('device_id')) {
	  initSocket();
	} else {
	  Brief$1.events.$on('login', function () {
	    if (localStorage$1.getItem('access_token')) {
	      initSocket();
	    } else {
	      setTimeout(function () { return initSocket(); }, 1000);
	    }
	  });
	}


	function Store(component, options) {
	  var currentStore = this;

	  // Events Listeners
	  var eventsListeners = {};

	  // Schedule
	  var onlineGetQueue = [];
	  var onlinePostQueue = [];

	  var subscribeChannels = [];

	  function proceedOnlineQueueOnce() {
	    onlineGetQueue.forEach(function (getRequest) {
	      currentStore.isLoading = true;
	      getRequest();
	    });
	    onlinePostQueue.forEach(function (postRequest) {
	      postRequest();
	    });
	    onlineGetQueue = [];
	    onlinePostQueue = [];
	  }

	  Vue.set(currentStore, 'isLoading', false);
	  Vue.set(currentStore, 'noMoreToGet', false);

	  var clientStoreKey = null;
	  var isLoadingInternal = false;
	  var currentGetRequest = null;
	  var settings = Object.assign({}, defaultSettings, options);

	  Brief$1.events.$once('online', proceedOnlineQueueOnce);

	  function sync() {
	    currentStore.reload();
	  }

	  function convertToUrl(controller, action) {
	    return ("/" + controller + "/" + action);
	  }

	  function convertToChannel(controller, action) {
	    return ("subscribe-" + controller + "-" + action);
	  }

	  function convertToPostChannel(url) {
	    return ("post" + (url.replace(/\//g, '-')));
	  }

	  function getArrayName(data) {
	    if (settings.targetArrayName) {
	      return settings.targetArrayName;
	    }
	    var foundKey;
	    Object.keys(data).forEach(function (key) {
	      if (key === 'generated_keys') {
	        return;
	      }
	      var property = data[key];
	      if (Array.isArray(property)) {
	        foundKey = key;
	      }
	    });
	    return foundKey;
	  }

	  function getNewItemsFromArray() {
	    var arrayName = getArrayName(currentStore);
	    var array = currentStore[arrayName];

	    if (!array) {
	      return null;
	    }

	    return array.filter(function (item) { return item.isNew === true; });
	  }

	  function getDataToPost(postFullArray) {
	    if (!postFullArray) {
	      var newItems = getNewItemsFromArray();
	      if (newItems && newItems.length > 0) {
	        return newItems;
	      }
	    }
	    return currentStore;
	  }

	  function addItemToQueue(newItem, originalData) {
	    var isFormData = newItem.files || newItem.formData;
	    var postUrl;
	    var postData;
	    if (isFormData) {
	      postUrl = settings.postFormUrl;
	      postData = newItem;
	    } else {
	      postUrl = settings.postUrl;
	      postData = Object.assign(newItem, settings.postData);
	    }
	    if (postUrl.indexOf('null') >= 0 || postUrl.indexOf('undefined') >= 0) {
	      return;
	    }
	    queue$1.add(postUrl, postData, function (response) {
	      if (!response.success && response.data && response.data.isDemo) {
	        Brief$1.f7.popup.open($$1('.demo-popup')[0]);
	        return;
	      }
	      if (isFormData) {
	        if (originalData && response && response.data) {
	          originalData.isNew = false;
	          originalData.id = response.data.id;
	        }
	        if (settings.postFormFinished) {
	          settings.postFormFinished.call(component, response);
	        }
	        currentStore.emit('postFormFinished', response);
	        if (!response.success && currentStore.messages) {
	          currentStore.messages.pop();
	        }
	      } else {
	        if (settings.postFinished) {
	          settings.postFinished.call(component, response);
	        }
	        currentStore.emit('postFinished', response);
	      }
	      currentStore.saveClient();
	    });
	  }

	  function addToQueue(dataToPost, originalData) {
	    if (Array.isArray(dataToPost)) {
	      dataToPost.forEach(addItemToQueue);
	    } else {
	      addItemToQueue(dataToPost, originalData);
	    }
	  }

	  function setProperties(responseData) {
	    // eslint-disable-next-line
	    for (var key in responseData) {
	      // eslint-disable-next-line
	      if (!responseData.hasOwnProperty(key)) {
	        continue;
	      }
	      if (Array.isArray(currentStore[key]) && Array.isArray(responseData[key]) && currentStore[key] !== null && responseData[key] !== null) {
	        if (!Array.equals(currentStore[key], responseData[key])) {
	          Vue.set(currentStore, key, responseData[key]);
	        }
	      } else if (typeof currentStore[key] === 'object' && typeof responseData[key] === 'object' && currentStore[key] !== null && responseData[key] !== null) {
	        if (!Object.equals(currentStore[key], responseData[key])) {
	          Vue.set(currentStore, key, responseData[key]);
	        }
	      } else {
	        Vue.set(currentStore, key, responseData[key]);
	      }
	    }
	  }

	  function handleGetError(response) {
	    if (settings.getError) {
	      settings.getError.call(component, response);
	      currentStore.emit('getError');
	    }
	  }

	  function hasNewItems(dataArray, storeArray) {
	    if (!storeArray || storeArray.length === 0) {
	      return false;
	    }
	    var sameItems = storeArray.filter(function (c) { return dataArray.some(function (d) { return c.Id === d.Id; }); });
	    return dataArray.length > sameItems.length;
	  }

	  function handleGetResponse(response) {
	    var responseData = response.data;
	    var arrayName = getArrayName(responseData);
	    var hasNewItem = false;
	    if (arrayName) {
	      var dataArray = responseData[arrayName];
	      var storeArray = currentStore[arrayName];
	      hasNewItem = hasNewItems(dataArray, storeArray);
	      currentStore.noMoreToGet = (dataArray.length < settings.getData.take) && !responseData.hasMore;
	    }

	    setProperties(responseData);

	    if (settings.getFinished) {
	      settings.getFinished.call(component, hasNewItem);
	    }
	    currentStore.emit('getFinished', hasNewItem);

	    currentStore.saveClient();
	  }

	  function handleGetMoreResponse(response) {
	    var responseData = response.data;
	    if (responseData) {
	      var arrayName = getArrayName(currentStore);
	      var dataArray = responseData[arrayName];
	      currentStore.noMoreToGet = (dataArray.length < settings.getData.take) && !responseData.hasMore;
	  
	      var array = currentStore[arrayName];
	      currentStore[arrayName] = array.concat(dataArray); 
	    }

	    if (settings.getMoreFinished) {
	      settings.getMoreFinished.call(component);
	    }
	    currentStore.emit('getMoreFinished');
	  }

	  function commonPost(url, data, useSocket, callback) {
	    if (data) {
	      data.access_token = localStorage$1.getItem('access_token');
	      data.device_id = localStorage$1.getItem('device_id');
	    }

	    function sendRequest() {
	      Framework7.request({
	        url: Brief$1.api + url,
	        method: 'POST',
	        dataType: 'json',
	        processData: false,
	        contentType: 'application/json',
	        data: JSON.stringify(data),
	        crossDomain: true,
	        success: function success(res) {
	          if (!res.success) {
	            if (res.data && res.data.isDemo) {
	              Brief$1.f7.popup.open($$1('.demo-popup')[0]);
	              return;
	            }
	            Brief$1.notify('', res.data.Message || res.data);

	            if (res.data && res.data.authFailed) {
	              Brief$1.logout();
	            }
	          } else {
	            if (res.data && res.data.notify && res.data.message) {
	              Brief$1.notify('Success', res.data.message);
	            }

	            setProperties(res.data);
	          }

	          if (settings.postNowFinished)
	            { settings.postNowFinished.call(component, res); }
	          
	          if (callback)
	            { callback.call(component, res); }
	            
	          currentStore.emit('postNowFinished', res);
	        },
	        error: function error() {
	          Brief$1.notify('Error!', 'Please check your internet connection');
	        },
	      });
	    }

	    if (useSocket && socket$4.connected) {
	      socket$4.emit(convertToPostChannel(url), data);
	    } else {
	      if (!Brief$1.onLine()) {
	        onlinePostQueue.push(sendRequest);
	        return;
	      }
	      sendRequest();
	    }
	  }

	  function handleError(error) {
	    if (error && error.status === 401) {
	      // eslint-disable-next-line
	      Brief$1.viewMain.router.navigate(Brief$1.api + endpoints.login, { reloadCurrent: true });
	    }
	  }

	  function handleResponse(response) {
	    currentStore.isLoading = false;
	    isLoadingInternal = false;

	    var callback = this.callback;
	    var callbackError = this.callbackError;

	    if (response.data && response.data.authFailed) {
	      Brief$1.logout();
	    }

	    if (!response.success && callbackError) {
	      // eslint-disable-next-line
	      callbackError(response.data);
	      return;
	    }

	    if (callback) {
	      callback(response);
	    }
	  }

	  function commonGet(url, data, callback, callbackError) {
	    if (data) {
	      data.access_token = localStorage$1.getItem('access_token');
	      data.device_id = localStorage$1.getItem('device_id');
	    }
	    function sendRequest() {
	      currentGetRequest = Framework7.request({
	        url: Brief$1.api + url,
	        method: 'GET',
	        dataType: 'json',
	        processData: false,
	        contentType: 'application/json',
	        data: data,
	        success: function success(res) {
	          handleResponse.call({ callback: callback, callbackError: callbackError }, res);
	        },
	        error: function error() {
	          currentStore.isLoading = false;
	          if (callbackError) {
	            callbackError();
	          } else {
	            handleError();
	          }
	        },
	      });
	    }
	    if (!Brief$1.onLine()) {
	      currentStore.isLoading = false;
	      onlineGetQueue = [sendRequest];
	      return;
	    }
	    sendRequest();
	  }

	  function findItemIndex(list, id) {
	    for (var i = 0; i < list.length; i += 1) {
	      if (list[i].id === id) {
	        return i;
	      }
	    }
	    return -1;
	  }

	  function addOrUpdate(list, item) {
	    if (item.deleteThis) {
	      var itemIndex = findItemIndex(list, item.id);
	      if (itemIndex !== -1) {
	        list.splice(itemIndex, 1);
	      }
	    } else {
	      var itemIndex$1 = findItemIndex(list, item.id);
	      if (itemIndex$1 === -1) {
	        list.push(item);
	      } else {
	        Vue.set(list, itemIndex$1, Object.assign({}, list[itemIndex$1] || {}, item));
	      }
	    }
	  }

	  function removeNewItem(list) {
	    for (var i = 0; i < list.length; i += 1) {
	      if (!list[i].id || list[i].queueId) {
	        var item = list[i];
	        list.splice(i, 1);
	        return item;
	      }
	    }
	    return null;
	  }

	  function init() {
	    if (settings.get) {
	      var ref = settings.get;
	      var controller = ref[0];
	      var action = ref[1];
	      var data = ref[2];
	      settings.getUrl = convertToUrl(controller, action);
	      settings.getData = Object.assign({}, defaultPaging, data);
	      clientStoreKey = settings.getUrl + JSON.stringify(settings.getData);

	      // eslint-disable-next-line
	      if (component && component._uid && settings.sync) {
	        Brief$1.events.$on('sync', sync);
	      }
	    }

	    if (settings.post) {
	      var ref$1 = settings.post;
	      var controller$1 = ref$1[0];
	      var action$1 = ref$1[1];
	      var data$1 = ref$1[2];
	      var postFullArray = settings.post[3] === true;
	      settings.postUrl = convertToUrl(controller$1, action$1);
	      settings.postData = Object.assign({}, defaultPaging, data$1);
	      settings.postFullArray = postFullArray;
	    }

	    if (settings.postNow) {
	      var ref$2 = settings.postNow;
	      var controller$2 = ref$2[0];
	      var action$2 = ref$2[1];
	      var data$2 = ref$2[2];
	      var postNowFullArray = settings.postNow[3] === true;
	      settings.postNowUrl = convertToUrl(controller$2, action$2);
	      settings.postNowData = Object.assign({}, data$2);
	      settings.postNowFullArray = postNowFullArray;
	    }
	    if (settings.postForm) {
	      var ref$3 = settings.postForm;
	      var controller$3 = ref$3[0];
	      var action$3 = ref$3[1];
	      var data$3 = ref$3[2];
	      settings.postFormUrl = convertToUrl(controller$3, action$3);
	      settings.postFormData = Object.assign({}, data$3);
	    }

	    if (settings.subscribe)
	      { setupSubscriptions(settings.subscribe); }

	    queue$1.onload(function () {
	      queue$1.start();
	    });

	    function setupSubscriptions(subscribe) {
	      var firstItem = subscribe[0];
	      if (Array.isArray(firstItem)) {
	        subscribe.forEach(function (arrayItem) {
	          setupSubscribe(arrayItem);
	        });
	      } else {
	        setupSubscribe(subscribe);
	      }
	    }

	    function setupSubscribe(subscribe) {
	      var key = null;
	      var processLocally = false;
	      var controller = subscribe[0];
	      var action = subscribe[1] || null;
	      var array = subscribe[2] || null;

	      if (subscribe[3]) {
	        key = subscribe[3].subscriptionKey;
	        processLocally = subscribe[3].processLocally;
	      }

	      if (!currentStore[array]) {
	        Vue.set(currentStore, array, []);
	      }

	      var subscribeChannel = convertToChannel(controller, action) + (key ? key : '');
	      subscribeChannels.push(subscribeChannel);

	      socket$4.on(subscribeChannel, function (responseData) {
	        if (isLoadingInternal) { return; }
	        if (!responseData) {
	          currentStore[array] = [];
	          return;
	        }

	        if (!settings.skipTeamCheck && responseData.ownerTeamId && responseData.ownerTeamId !== component.$root.loggedInUser.ownerTeamId) {
	          return false; // eslint-disable-line
	        }

	        if (settings.preProcess) {
	          var canContinue = settings.preProcess.call(component, responseData);
	          if (!canContinue)
	            { return; }
	        }

	        if (processLocally) {
	          if (settings.subscribeFinished) {
	            settings.subscribeFinished.call(component, responseData);
	          }
	          currentStore.emit('subscribeFinished', responseData);
	        } else {
	          if (!key || (key != null && key === responseData.subscriptionKey)) {
	            var oldItem = removeNewItem(currentStore[array]);
	            if (oldItem && oldItem.files) {
	              responseData.files = oldItem.files;
	            }
	            addOrUpdate(currentStore[array], responseData);
	          }
	          if (settings.subscribeFinished) { settings.subscribeFinished.call(component, responseData); }
	          currentStore.emit('subscribeFinished', responseData);
	        }

	        currentStore.saveClient();
	      });
	    }
	  }

	  currentStore.clear = function clear() {
	    ClientStorage.remove(clientStoreKey);
	  };

	  currentStore.get = function get(data) {
	    if (isLoadingInternal && currentGetRequest) { currentGetRequest.abort(); }

	    Object.assign(settings.getData, data);

	    ClientStorage.get(clientStoreKey).then(function (clientData) {
	      if (clientData && settings.loadFromLocalStorage) {
	        setProperties(clientData);
	        if (settings.getLocalFinished) {
	          settings.getLocalFinished.call(component);
	        } else if (settings.getFinished) {
	          settings.getFinished.call(component, false);
	        }
	        currentStore.emit('getLocalFinished');
	      }

	      if (settings.getStarted) { settings.getStarted.call(component); }
	      currentStore.emit('getStarted');

	      isLoadingInternal = true;
	      currentStore.isLoading = true;
	      commonGet(settings.getUrl, settings.getData, handleGetResponse, handleGetError);
	    });
	  };

	  currentStore.post = function post(data) {
	    var dataToPost = getDataToPost(settings.postFullArray);
	    if (data) { dataToPost = Object.assign({}, dataToPost, data); }

	    addToQueue(dataToPost);

	    currentStore.saveClient();
	  };

	  currentStore.postNow = function postNow(data, useSocket, callback) {
	    var dataToPost = getDataToPost(settings.postNowFullArray);

	    dataToPost = Object.assign({}, dataToPost, data);

	    if (settings.postNowData) { dataToPost = Object.assign({}, dataToPost, settings.postNowData); }

	    commonPost(settings.postNowUrl, dataToPost, useSocket, callback);
	  };
	  
	  currentStore.postForm = function postForm(postData) {
	    var data = Object.assign({ formData: true }, postData, settings.postFormData || {});

	    addToQueue(data, postData);

	    currentStore.saveClient();
	  };

	  currentStore.getMore = function getMore(data) {
	    if (isLoadingInternal || currentStore.noMoreToGet) { return; }

	    var mergedData = Object.assign({}, settings.getData, data);

	    var arrayName = getArrayName(currentStore);
	    var array = currentStore[arrayName];
	    mergedData.skip = array.length;
	    if (settings.itemsGroupKey) {
	      var skip = 0;
	      array.forEach(function (a) {
	        var groupItems = a[settings.itemsGroupKey];
	        if (groupItems) {
	          skip += groupItems.length;
	        }
	      });
	      mergedData.skip = skip;
	    }
	    if (settings.getMoreStarted) { settings.getMoreStarted.call(component); }
	    currentStore.emit('getMoreStarted');

	    isLoadingInternal = true;
	    currentStore.isLoading = true;

	    commonGet(settings.getUrl, mergedData, handleGetMoreResponse);
	  };

	  currentStore.reload = function reload(data) {
	    if (isLoadingInternal) { return; }

	    var mergedData = Object.assign({}, settings.getData, data);

	    var arrayName = getArrayName(currentStore);
	    if (!arrayName) { return; }

	    var array = currentStore[arrayName];

	    if (!array) { return; }

	    mergedData.skip = 0;
	    mergedData.take = 30;

	    if (settings.getStarted) { settings.getStarted.call(component); }
	    currentStore.emit('getStarted');

	    isLoadingInternal = true;
	    currentStore.isLoading = true;
	    commonGet(settings.getUrl, mergedData, handleGetResponse, handleGetError);
	  };

	  currentStore.saveClient = function saveClient() {
	    function getProperties() {
	      var storeData = Object.assign({}, currentStore);
	      var storeDataString = JSON.stringify(storeData);
	      return JSON.parse(storeDataString);
	    }
	    ClientStorage.save(clientStoreKey, getProperties());
	  };

	  currentStore.dispose = function dispose() {
	    onlineGetQueue = [];
	    onlinePostQueue = [];
	    Brief$1.events.$off('online', proceedOnlineQueueOnce);

	    // eslint-disable-next-line
	    if (component && component._uid) {
	      Brief$1.events.$off('sync', sync);
	    }

	    subscribeChannels.forEach(function (subscribeChannel) {
	      socket$4.off(subscribeChannel);
	    });
	    subscribeChannels = [];

	    currentStore.off();
	  };

	  currentStore.on = function on(events, handler) {
	    var self = this;
	    if (typeof handler !== 'function') { return self; }
	    events.split(' ').forEach(function (event) {
	      if (!eventsListeners[event]) { eventsListeners[event] = []; }
	      eventsListeners[event].push(handler);
	    });
	    return self;
	  };
	  currentStore.once = function once(events, handler) {
	    var self = this;
	    if (typeof handler !== 'function') { return self; }
	    function onceHandler() {
	      var args = [], len = arguments.length;
	      while ( len-- ) args[ len ] = arguments[ len ];

	      handler.apply(self, args);
	      self.$off(events, onceHandler);
	    }
	    return self.$on(events, onceHandler);
	  };
	  currentStore.off = function off(events, handler) {
	    var self = this;
	    if (!eventsListeners) { return self; }
	    if (typeof events === 'undefined') {
	      Object.keys(eventsListeners).forEach(function (eventName) {
	        delete eventsListeners[eventName];
	      });
	      return self;
	    }
	    events.split(' ').forEach(function (event) {
	      if (typeof handler === 'undefined') {
	        eventsListeners[event] = [];
	      } else {
	        eventsListeners[event].forEach(function (eventHandler, index) {
	          if (eventHandler === handler) {
	            eventsListeners[event].splice(index, 1);
	          }
	        });
	      }
	    });
	    return self;
	  };
	  currentStore.emit = function emit(events) {
	    var data = [], len = arguments.length - 1;
	    while ( len-- > 0 ) data[ len ] = arguments[ len + 1 ];

	    var self = this;
	    if (!eventsListeners) { return self; }
	    var eventsArray = Array.isArray(events) ? events : events.split(' ');

	    eventsArray.forEach(function (event) {
	      if (eventsListeners[event]) {
	        var handlers = [];
	        eventsListeners[event].forEach(function (eventHandler) {
	          handlers.push(eventHandler);
	        });
	        handlers.forEach(function (eventHandler) {
	          eventHandler.apply(self, data);
	        });
	      }
	    });
	    return self;
	  };

	  init();

	  return currentStore;
	}

	//

	function contactPush(self, contact, replace) {
	  var tempContact = {
	    id: contact.contactId,
	    firstName: contact.firstName,
	    lastName: contact.lastName,
	    email: contact.email,
	    type: contact.contactType,
	    displayField: !contact.firstName && !contact.lastName ? contact.email : (((contact.firstName || '') + " " + (contact.lastName || ''))).trim(),
	  };
	  self.$emit(("selectedcontacts:" + (replace ? 'replace' : 'add')), tempContact);
	  self.$emit('querychange', '');
	}

	function contactItemClick(item) {
	  contactPush(this, item);
	  this.$emit('itemindexchange', 0);
	  Brief$1.events.$emit('force-input-focus');
	}

	function callSearch(self, key) {
	  if (self.searchedContacts.length === 0 || key === 'enter') {
	    if (Utils$1.isEmail(self.query.trim())) {
	      self.$emit('selectedcontacts:add', {
	        email: self.query.trim(),
	        displayField: self.query,
	      });
	      self.$emit('querychange', '');
	      return;
	    } else if (!Utils$1.isUndefined(self.query)) {
	      Brief$1.notify('Error!', 'Invalid email address');
	      Brief$1.events.$emit('force-input-focus');
	      return;
	    }
	  } else {
	    contactPush(self, self.searchedContacts[self.itemIndex]);
	    self.$emit('searchedcontacts:replace', self.searchedContacts.filter(function (c) { return c.contactId !== self.searchedContacts[self.itemIndex].contactId; }));

	    self.$emit('itemindexchange', 0);
	  }
	}

	function isOtherKeyFunctionCalled(event) {
	  var keyCode = event.which || event.keyCode;
	  return keyCode === 38 || keyCode === 40 || keyCode === 9 || keyCode === 13 || keyCode === 32 || keyCode === 8;
	}

	function handleUp(event) {
	  var this$1 = this;

	  var isOtherKey = isOtherKeyFunctionCalled(event);
	  if (!isOtherKey) {
	    setTimeout(function () {
	      this$1.$emit('contactsearch');
	    }, 0);
	  }
	}
	function enter$1() {
	  return callSearch(this, 'enter');
	}
	function tab$1() {
	  if (Utils$1.isUndefined(this.query)) {
	    this.showContactContainer = false;
	    return;
	  }
	  callSearch(this, 'tab');
	}
	function down() {
	  if (this.itemIndex >= this.searchedContacts.length - 1) { return; }
	  this.$emit('itemindexchange', this.itemIndex + 1);
	}
	function up() {
	  if (this.itemIndex <= 0) { return; }
	  this.$emit('itemindexchange', this.itemIndex - 1);
	}
	function back$1() {
	  if (this.selectedContacts.length > 0 && Utils$1.isUndefined(this.query)) {
	    if (this.searchedContacts.length > 0) { this.$emit('searchedcontacts:replace', []); } else {
	      this.$emit('selectedcontacts:remove', this.selectedContacts.length - 1);
	    }
	  } else if (!Utils$1.isUndefined(this.query)) { this.$emit('contactsearch', this.query); }
	}
	function remove$4(item) {
	  var index = this.selectedContacts.indexOf(item);
	  this.$emit('selectedcontacts:remove', index);
	}

	var script = {
	  name: 'ContactAutoComplete',
	  props: ['query', 'selectedContacts', 'searchedContacts', 'itemIndex', 'to', 'isLoading'],
	  mounted: function mounted() {
	    if (this.to) {
	      contactPush(this, { email: this.to }, true);
	    }
	  },
	  beforeDestroy: function dispose() {
	    Brief$1.events.$off('force-input-focus');
	    Brief$1.events.$off('force-input-lose-focus');
	  },
	  computed: {
	    showContactSelected: {
	      get: function get() {
	        return this.selectedContacts != null && this.selectedContacts.length > 0;
	      },
	    },
	    showContactContainer: {
	      get: function get() {
	        return this.query && this.searchedContacts != null && this.searchedContacts.length > 0;
	      },
	      set: function set(value) {
	        if (value === false) { this.$emit('searchedcontacts:replace', []); }
	      },
	    },
	  },
	  methods: {
	    handleUp: handleUp,
	    remove: remove$4,
	    onUp: up,
	    onDown: down,
	    onBack: back$1,
	    onEnter: enter$1,
	    onTab: tab$1,
	    onContactItemClick: contactItemClick,
	    onInput: function onInput(event) {
	      this.$emit('querychange', event.target.value);
	    },
	    loadContact: function loadContact(event, contact) {
	      if (event.target.nodeName.toLowerCase() === 'a') { return; }
	      Brief$1.f7.panel.open('right');
	      Brief$1.viewRight.router.navigate(("/contact/" + (contact.type || 'emailContact') + "/" + (contact.id) + "/"));
	    },
	  },
	  created: function created() {
	    var self = this;
	    Brief$1.events.$on('force-input-focus', function () {
	      $$1('[placeholder="Email"]').focus();
	    });
	    Brief$1.events.$on('force-input-lose-focus', function () {
	      self.onTab();
	    });
	  },
	};

	function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
	    if (typeof shadowMode !== 'boolean') {
	        createInjectorSSR = createInjector;
	        createInjector = shadowMode;
	        shadowMode = false;
	    }
	    // Vue.extend constructor export interop.
	    var options = typeof script === 'function' ? script.options : script;
	    // render functions
	    if (template && template.render) {
	        options.render = template.render;
	        options.staticRenderFns = template.staticRenderFns;
	        options._compiled = true;
	        // functional template
	        if (isFunctionalTemplate) {
	            options.functional = true;
	        }
	    }
	    // scopedId
	    if (scopeId) {
	        options._scopeId = scopeId;
	    }
	    var hook;
	    if (moduleIdentifier) {
	        // server build
	        hook = function (context) {
	            // 2.3 injection
	            context =
	                context || // cached call
	                    (this.$vnode && this.$vnode.ssrContext) || // stateful
	                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
	            // 2.2 with runInNewContext: true
	            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
	                context = __VUE_SSR_CONTEXT__;
	            }
	            // inject component styles
	            if (style) {
	                style.call(this, createInjectorSSR(context));
	            }
	            // register component module identifier for async chunk inference
	            if (context && context._registeredComponents) {
	                context._registeredComponents.add(moduleIdentifier);
	            }
	        };
	        // used by ssr in case component is cached and beforeCreate
	        // never gets called
	        options._ssrRegister = hook;
	    }
	    else if (style) {
	        hook = shadowMode
	            ? function (context) {
	                style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
	            }
	            : function (context) {
	                style.call(this, createInjector(context));
	            };
	    }
	    if (hook) {
	        if (options.functional) {
	            // register for functional component in vue file
	            var originalRender = options.render;
	            options.render = function renderWithStyleInjection(h, context) {
	                hook.call(context);
	                return originalRender(h, context);
	            };
	        }
	        else {
	            // inject component registration as beforeCreate hook
	            var existing = options.beforeCreate;
	            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
	        }
	    }
	    return script;
	}

	/* script */
	var __vue_script__ = script;

	/* template */
	var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"email-item",staticStyle:{"list-style":"none"}},[_c('div',{staticClass:"item-content item-input"},[_c('div',{staticClass:"item-inner"},[_c('div',{staticClass:"item-input-wrap"},[(_vm.showContactSelected)?_c('div',{staticClass:"tags-list"},_vm._l((_vm.selectedContacts),function(contact,index){return _c('f7-chip',{key:index,attrs:{"text":contact.displayField,"deleteable":""},on:{"delete":function($event){return _vm.remove(contact)}},nativeOn:{"click":function($event){return _vm.loadContact($event, contact)}}})}),1):_vm._e(),_vm._v(" "),_c('input',{attrs:{"type":"text","placeholder":_vm.selectedContacts.length === 0 ? 'Email' : undefined},domProps:{"value":_vm.query},on:{"input":_vm.onInput,"keyup":[function($event){return _vm.handleUp($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"up",38,$event.key,["Up","ArrowUp"])){ return null; }return _vm.onUp.apply(null, arguments)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"down",40,$event.key,["Down","ArrowDown"])){ return null; }return _vm.onDown.apply(null, arguments)},function($event){if(!$event.type.indexOf('key')&&$event.keyCode!==8){ return null; }return _vm.onBack.apply(null, arguments)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.onEnter.apply(null, arguments)},function($event){if(!$event.type.indexOf('key')&&$event.keyCode!==32){ return null; }return _vm.onEnter.apply(null, arguments)}],"keydown":function($event){if(!$event.type.indexOf('key')&&$event.keyCode!==9){ return null; }return _vm.onTab.apply(null, arguments)},"click":function($event){$event.stopPropagation();}}})]),_vm._v(" "),(_vm.isLoading)?_c('f7-preloader'):_vm._e()],1)]),_vm._v(" "),(_vm.showContactContainer)?_c('div',{staticClass:"list tags-search-results"},[_c('ul',_vm._l((_vm.searchedContacts),function(contact,index){return _c('li',{key:index},[_c('a',{staticClass:"item-link item-content",class:{'itemSelected': index== _vm.itemIndex},attrs:{"href":"#"},on:{"click":function($event){return _vm.onContactItemClick(contact)}}},[_c('div',{staticClass:"item-inner"},[_c('div',{staticClass:"item-title",domProps:{"innerHTML":_vm._s(contact.displayField)}})])])])}),0)]):_vm._e()])};
	var __vue_staticRenderFns__ = [];

	  /* style */
	  var __vue_inject_styles__ = undefined;
	  /* scoped */
	  var __vue_scope_id__ = undefined;
	  /* module identifier */
	  var __vue_module_identifier__ = undefined;
	  /* functional template */
	  var __vue_is_functional_template__ = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__ = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
	    __vue_inject_styles__,
	    __vue_script__,
	    __vue_scope_id__,
	    __vue_is_functional_template__,
	    __vue_module_identifier__,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	var emojiMart = createCommonjsModule(function (module, exports) {
	(function webpackUniversalModuleDefinition(root, factory) {
		{ module.exports = factory(); }
	})(typeof self !== 'undefined' ? self : commonjsGlobal, function() {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, {
	/******/ 				configurable: false,
	/******/ 				enumerable: true,
	/******/ 				get: getter
	/******/ 			});
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 66);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ (function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function(useSourceMap) {
		var list = [];

		// return the list of modules as css string
		list.toString = function toString() {
			return this.map(function (item) {
				var content = cssWithMappingToString(item, useSourceMap);
				if(item[2]) {
					return "@media " + item[2] + "{" + content + "}";
				} else {
					return content;
				}
			}).join("");
		};

		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			var this$1 = this;

			if(typeof modules === "string")
				{ modules = [[null, modules, ""]]; }
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this$1[i][0];
				if(typeof id === "number")
					{ alreadyImportedModules[id] = true; }
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};

	function cssWithMappingToString(item, useSourceMap) {
		var content = item[1] || '';
		var cssMapping = item[3];
		if (!cssMapping) {
			return content;
		}

		if (useSourceMap && typeof btoa === 'function') {
			var sourceMapping = toComment(cssMapping);
			var sourceURLs = cssMapping.sources.map(function (source) {
				return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
			});

			return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
		}

		return [content].join('\n');
	}

	// Adapted from convert-source-map (MIT)
	function toComment(sourceMap) {
		// eslint-disable-next-line no-undef
		var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
		var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

		return '/*# ' + data + ' */';
	}


	/***/ }),
	/* 1 */
	/***/ (function(module, exports, __webpack_require__) {

	/*
	  MIT License http://www.opensource.org/licenses/mit-license.php
	  Author Tobias Koppers @sokra
	  Modified by Evan You @yyx990803
	*/

	var hasDocument = typeof document !== 'undefined';

	if (typeof DEBUG !== 'undefined' && DEBUG) {
	  if (!hasDocument) {
	    throw new Error(
	    'vue-style-loader cannot be used in a non-browser environment. ' +
	    "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
	  ) }
	}

	var listToStyles = __webpack_require__(70);

	/*
	type StyleObject = {
	  id: number;
	  parts: Array<StyleObjectPart>
	}

	type StyleObjectPart = {
	  css: string;
	  media: string;
	  sourceMap: ?string
	}
	*/

	var stylesInDom = {/*
	  [id: number]: {
	    id: number,
	    refs: number,
	    parts: Array<(obj?: StyleObjectPart) => void>
	  }
	*/};

	var head = hasDocument && (document.head || document.getElementsByTagName('head')[0]);
	var singletonElement = null;
	var singletonCounter = 0;
	var isProduction = false;
	var noop = function () {};
	var options = null;
	var ssrIdKey = 'data-vue-ssr-id';

	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase());

	module.exports = function (parentId, list, _isProduction, _options) {
	  isProduction = _isProduction;

	  options = _options || {};

	  var styles = listToStyles(parentId, list);
	  addStylesToDom(styles);

	  return function update (newList) {
	    var mayRemove = [];
	    for (var i = 0; i < styles.length; i++) {
	      var item = styles[i];
	      var domStyle = stylesInDom[item.id];
	      domStyle.refs--;
	      mayRemove.push(domStyle);
	    }
	    if (newList) {
	      styles = listToStyles(parentId, newList);
	      addStylesToDom(styles);
	    } else {
	      styles = [];
	    }
	    for (var i = 0; i < mayRemove.length; i++) {
	      var domStyle = mayRemove[i];
	      if (domStyle.refs === 0) {
	        for (var j = 0; j < domStyle.parts.length; j++) {
	          domStyle.parts[j]();
	        }
	        delete stylesInDom[domStyle.id];
	      }
	    }
	  }
	};

	function addStylesToDom (styles /* Array<StyleObject> */) {
	  for (var i = 0; i < styles.length; i++) {
	    var item = styles[i];
	    var domStyle = stylesInDom[item.id];
	    if (domStyle) {
	      domStyle.refs++;
	      for (var j = 0; j < domStyle.parts.length; j++) {
	        domStyle.parts[j](item.parts[j]);
	      }
	      for (; j < item.parts.length; j++) {
	        domStyle.parts.push(addStyle(item.parts[j]));
	      }
	      if (domStyle.parts.length > item.parts.length) {
	        domStyle.parts.length = item.parts.length;
	      }
	    } else {
	      var parts = [];
	      for (var j = 0; j < item.parts.length; j++) {
	        parts.push(addStyle(item.parts[j]));
	      }
	      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts };
	    }
	  }
	}

	function createStyleElement () {
	  var styleElement = document.createElement('style');
	  styleElement.type = 'text/css';
	  head.appendChild(styleElement);
	  return styleElement
	}

	function addStyle (obj /* StyleObjectPart */) {
	  var update, remove;
	  var styleElement = document.querySelector('style[' + ssrIdKey + '~="' + obj.id + '"]');

	  if (styleElement) {
	    if (isProduction) {
	      // has SSR styles and in production mode.
	      // simply do nothing.
	      return noop
	    } else {
	      // has SSR styles but in dev mode.
	      // for some reason Chrome can't handle source map in server-rendered
	      // style tags - source maps in <style> only works if the style tag is
	      // created and inserted dynamically. So we remove the server rendered
	      // styles and inject new ones.
	      styleElement.parentNode.removeChild(styleElement);
	    }
	  }

	  if (isOldIE) {
	    // use singleton mode for IE9.
	    var styleIndex = singletonCounter++;
	    styleElement = singletonElement || (singletonElement = createStyleElement());
	    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
	    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
	  } else {
	    // use multi-style-tag mode in all other cases
	    styleElement = createStyleElement();
	    update = applyToTag.bind(null, styleElement);
	    remove = function () {
	      styleElement.parentNode.removeChild(styleElement);
	    };
	  }

	  update(obj);

	  return function updateStyle (newObj /* StyleObjectPart */) {
	    if (newObj) {
	      if (newObj.css === obj.css &&
	          newObj.media === obj.media &&
	          newObj.sourceMap === obj.sourceMap) {
	        return
	      }
	      update(obj = newObj);
	    } else {
	      remove();
	    }
	  }
	}

	var replaceText = (function () {
	  var textStore = [];

	  return function (index, replacement) {
	    textStore[index] = replacement;
	    return textStore.filter(Boolean).join('\n')
	  }
	})();

	function applyToSingletonTag (styleElement, index, remove, obj) {
	  var css = remove ? '' : obj.css;

	  if (styleElement.styleSheet) {
	    styleElement.styleSheet.cssText = replaceText(index, css);
	  } else {
	    var cssNode = document.createTextNode(css);
	    var childNodes = styleElement.childNodes;
	    if (childNodes[index]) { styleElement.removeChild(childNodes[index]); }
	    if (childNodes.length) {
	      styleElement.insertBefore(cssNode, childNodes[index]);
	    } else {
	      styleElement.appendChild(cssNode);
	    }
	  }
	}

	function applyToTag (styleElement, obj) {
	  var css = obj.css;
	  var media = obj.media;
	  var sourceMap = obj.sourceMap;

	  if (media) {
	    styleElement.setAttribute('media', media);
	  }
	  if (options.ssrId) {
	    styleElement.setAttribute(ssrIdKey, obj.id);
	  }

	  if (sourceMap) {
	    // https://developer.chrome.com/devtools/docs/javascript-debugging
	    // this makes source maps inside style tags work properly in Chrome
	    css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */';
	    // http://stackoverflow.com/a/26603875
	    css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */';
	  }

	  if (styleElement.styleSheet) {
	    styleElement.styleSheet.cssText = css;
	  } else {
	    while (styleElement.firstChild) {
	      styleElement.removeChild(styleElement.firstChild);
	    }
	    styleElement.appendChild(document.createTextNode(css));
	  }
	}


	/***/ }),
	/* 2 */
	/***/ (function(module, exports, __webpack_require__) {

	var store = __webpack_require__(31)('wks');
	var uid = __webpack_require__(21);
	var Symbol = __webpack_require__(4).Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';

	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};

	$exports.store = store;


	/***/ }),
	/* 3 */
	/***/ (function(module, exports) {

	var core = module.exports = { version: '2.5.3' };
	if (typeof __e == 'number') { __e = core; } // eslint-disable-line no-undef


	/***/ }),
	/* 4 */
	/***/ (function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') { __g = global; } // eslint-disable-line no-undef


	/***/ }),
	/* 5 */
	/***/ (function(module, exports) {

	/* globals __VUE_SSR_CONTEXT__ */

	// IMPORTANT: Do NOT use ES2015 features in this file.
	// This module is a runtime utility for cleaner component module output and will
	// be included in the final webpack user bundle.

	module.exports = function normalizeComponent (
	  rawScriptExports,
	  compiledTemplate,
	  functionalTemplate,
	  injectStyles,
	  scopeId,
	  moduleIdentifier /* server only */
	) {
	  var esModule;
	  var scriptExports = rawScriptExports = rawScriptExports || {};

	  // ES6 modules interop
	  var type = typeof rawScriptExports.default;
	  if (type === 'object' || type === 'function') {
	    esModule = rawScriptExports;
	    scriptExports = rawScriptExports.default;
	  }

	  // Vue.extend constructor export interop
	  var options = typeof scriptExports === 'function'
	    ? scriptExports.options
	    : scriptExports;

	  // render functions
	  if (compiledTemplate) {
	    options.render = compiledTemplate.render;
	    options.staticRenderFns = compiledTemplate.staticRenderFns;
	    options._compiled = true;
	  }

	  // functional template
	  if (functionalTemplate) {
	    options.functional = true;
	  }

	  // scopedId
	  if (scopeId) {
	    options._scopeId = scopeId;
	  }

	  var hook;
	  if (moduleIdentifier) { // server build
	    hook = function (context) {
	      // 2.3 injection
	      context =
	        context || // cached call
	        (this.$vnode && this.$vnode.ssrContext) || // stateful
	        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
	      // 2.2 with runInNewContext: true
	      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
	        context = __VUE_SSR_CONTEXT__;
	      }
	      // inject component styles
	      if (injectStyles) {
	        injectStyles.call(this, context);
	      }
	      // register component module identifier for async chunk inferrence
	      if (context && context._registeredComponents) {
	        context._registeredComponents.add(moduleIdentifier);
	      }
	    };
	    // used by ssr in case component is cached and beforeCreate
	    // never gets called
	    options._ssrRegister = hook;
	  } else if (injectStyles) {
	    hook = injectStyles;
	  }

	  if (hook) {
	    var functional = options.functional;
	    var existing = functional
	      ? options.render
	      : options.beforeCreate;

	    if (!functional) {
	      // inject component registration as beforeCreate hook
	      options.beforeCreate = existing
	        ? [].concat(existing, hook)
	        : [hook];
	    } else {
	      // for template-only hot-reload because in that case the render fn doesn't
	      // go through the normalizer
	      options._injectStyles = hook;
	      // register for functioal component in vue file
	      options.render = function renderWithStyleInjection (h, context) {
	        hook.call(context);
	        return existing(h, context)
	      };
	    }
	  }

	  return {
	    esModule: esModule,
	    exports: scriptExports,
	    options: options
	  }
	};


	/***/ }),
	/* 6 */
	/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(9);
	var IE8_DOM_DEFINE = __webpack_require__(47);
	var toPrimitive = __webpack_require__(28);
	var dP = Object.defineProperty;

	exports.f = __webpack_require__(10) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) { try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ } }
	  if ('get' in Attributes || 'set' in Attributes) { throw TypeError('Accessors not supported!'); }
	  if ('value' in Attributes) { O[P] = Attributes.value; }
	  return O;
	};


	/***/ }),
	/* 7 */
	/***/ (function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


	/***/ }),
	/* 8 */
	/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(6);
	var createDesc = __webpack_require__(16);
	module.exports = __webpack_require__(10) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


	/***/ }),
	/* 9 */
	/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(15);
	module.exports = function (it) {
	  if (!isObject(it)) { throw TypeError(it + ' is not an object!'); }
	  return it;
	};


	/***/ }),
	/* 10 */
	/***/ (function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(11)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


	/***/ }),
	/* 11 */
	/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


	/***/ }),
	/* 12 */
	/***/ (function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(52);
	var defined = __webpack_require__(26);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


	/***/ }),
	/* 13 */
	/***/ (function(module, exports, __webpack_require__) {


	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.measureScrollbar = exports.unifiedToNative = exports.deepMerge = exports.intersect = exports.uniq = exports.getSanitizedData = exports.getData = undefined;

	var _typeof2 = __webpack_require__(82);

	var _typeof3 = _interopRequireDefault(_typeof2);

	var _keys = __webpack_require__(107);

	var _keys2 = _interopRequireDefault(_keys);

	var _assign = __webpack_require__(56);

	var _assign2 = _interopRequireDefault(_assign);

	var _buildSearch = __webpack_require__(44);

	var _buildSearch2 = _interopRequireDefault(_buildSearch);

	var _data = __webpack_require__(20);

	var _data2 = _interopRequireDefault(_data);

	var _stringFromCodePoint = __webpack_require__(114);

	var _stringFromCodePoint2 = _interopRequireDefault(_stringFromCodePoint);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var _JSON = JSON;

	var COLONS_REGEX = /^(?:\:([^\:]+)\:)(?:\:skin-tone-(\d)\:)?$/;
	var SKINS = ['1F3FA', '1F3FB', '1F3FC', '1F3FD', '1F3FE', '1F3FF'];

	function unifiedToNative(unified) {
	  var unicodes = unified.split('-'),
	      codePoints = unicodes.map(function (u) {
	    return '0x' + u;
	  });

	  return _stringFromCodePoint2.default.apply(null, codePoints);
	}

	function sanitize(emoji) {
	  var name = emoji.name;
	  var short_names = emoji.short_names;
	  var skin_tone = emoji.skin_tone;
	  var skin_variations = emoji.skin_variations;
	  var emoticons = emoji.emoticons;
	  var unified = emoji.unified;
	  var custom = emoji.custom;
	  var imageUrl = emoji.imageUrl;
	  var id = emoji.id || short_names[0];
	  var colons = ':' + id + ':';

	  if (custom) {
	    return {
	      id: id,
	      name: name,
	      colons: colons,
	      emoticons: emoticons,
	      custom: custom,
	      imageUrl: imageUrl
	    };
	  }

	  if (skin_tone) {
	    colons += ':skin-tone-' + skin_tone + ':';
	  }

	  return {
	    id: id,
	    name: name,
	    colons: colons,
	    emoticons: emoticons,
	    unified: unified.toLowerCase(),
	    skin: skin_tone || (skin_variations ? 1 : null),
	    native: unifiedToNative(unified)
	  };
	}

	function getSanitizedData() {
	  return sanitize(getData.apply(undefined, arguments));
	}

	function cloneEmoji(emoji) {
	  if (typeof emoji === 'string') {
	    return emoji;
	  }

	  return (0, _assign2.default)({}, emoji);
	}

	function getData(_emoji, skin, set) {
	  var emoji = cloneEmoji(_emoji);
	  var emojiData = {};

	  if (typeof emoji == 'string') {
	    var matches = emoji.match(COLONS_REGEX);

	    if (matches) {
	      emoji = matches[1];

	      if (matches[2]) {
	        skin = parseInt(matches[2]);
	      }
	    }

	    if (_data2.default.short_names.hasOwnProperty(emoji)) {
	      emoji = _data2.default.short_names[emoji];
	    }

	    if (_data2.default.emojis.hasOwnProperty(emoji)) {
	      emojiData = _data2.default.emojis[emoji];
	    } else {
	      return null;
	    }
	  } else if (emoji.id) {
	    if (_data2.default.short_names.hasOwnProperty(emoji.id)) {
	      emoji.id = _data2.default.short_names[emoji.id];
	    }

	    if (_data2.default.emojis.hasOwnProperty(emoji.id)) {
	      emojiData = _data2.default.emojis[emoji.id];
	      skin || (skin = emoji.skin);
	    }
	  }

	  if (!(0, _keys2.default)(emojiData).length) {
	    emojiData = emoji;
	    emojiData.custom = true;

	    if (!emojiData.search) {
	      emojiData.search = (0, _buildSearch2.default)(emoji);
	    }
	  }

	  emojiData.emoticons || (emojiData.emoticons = []);
	  emojiData.variations || (emojiData.variations = []);

	  if (emojiData.skin_variations && skin > 1) {
	    emojiData = JSON.parse(_JSON.stringify(emojiData));

	    var skinKey = SKINS[skin - 1],
	        variationData = emojiData.skin_variations[skinKey];

	    if (!variationData.variations && emojiData.variations) {
	      delete emojiData.variations;
	    }

	    if (set == 'native' || variationData['has_img_' + set]) {
	      emojiData.skin_tone = skin;

	      for (var k in variationData) {
	        var v = variationData[k];
	        emojiData[k] = v;
	      }
	    }
	  }

	  if (emojiData.variations && emojiData.variations.length) {
	    emojiData = JSON.parse(_JSON.stringify(emojiData));
	    emojiData.unified = emojiData.variations.shift();
	  }

	  return emojiData;
	}

	function uniq(arr) {
	  return arr.reduce(function (acc, item) {
	    if (acc.indexOf(item) === -1) {
	      acc.push(item);
	    }
	    return acc;
	  }, []);
	}

	function intersect(a, b) {
	  var uniqA = uniq(a);
	  var uniqB = uniq(b);

	  return uniqA.filter(function (item) {
	    return uniqB.indexOf(item) >= 0;
	  });
	}

	function deepMerge(a, b) {
	  var o = {};

	  for (var key in a) {
	    var originalValue = a[key],
	        value = originalValue;

	    if (b.hasOwnProperty(key)) {
	      value = b[key];
	    }

	    if ((typeof value === 'undefined' ? 'undefined' : (0, _typeof3.default)(value)) === 'object') {
	      value = deepMerge(originalValue, value);
	    }

	    o[key] = value;
	  }

	  return o;
	}

	// https://github.com/sonicdoe/measure-scrollbar
	function measureScrollbar() {
	  if (typeof document == 'undefined') { return 0; }
	  var div = document.createElement('div');

	  div.style.width = '100px';
	  div.style.height = '100px';
	  div.style.overflow = 'scroll';
	  div.style.position = 'absolute';
	  div.style.top = '-9999px';

	  document.body.appendChild(div);
	  var scrollbarWidth = div.offsetWidth - div.clientWidth;
	  document.body.removeChild(div);

	  return scrollbarWidth;
	}

	exports.getData = getData;
	exports.getSanitizedData = getSanitizedData;
	exports.uniq = uniq;
	exports.intersect = intersect;
	exports.deepMerge = deepMerge;
	exports.unifiedToNative = unifiedToNative;
	exports.measureScrollbar = measureScrollbar;

	/***/ }),
	/* 14 */
	/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(4);
	var core = __webpack_require__(3);
	var ctx = __webpack_require__(46);
	var hide = __webpack_require__(8);
	var PROTOTYPE = 'prototype';

	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var IS_WRAP = type & $export.W;
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE];
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
	  var key, own, out;
	  if (IS_GLOBAL) { source = name; }
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    if (own && key in exports) { continue; }
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function (C) {
	      var F = function (a, b, c) {
	        if (this instanceof C) {
	          switch (arguments.length) {
	            case 0: return new C();
	            case 1: return new C(a);
	            case 2: return new C(a, b);
	          } return new C(a, b, c);
	        } return C.apply(this, arguments);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
	    if (IS_PROTO) {
	      (exports.virtual || (exports.virtual = {}))[key] = out;
	      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
	      if (type & $export.R && expProto && !expProto[key]) { hide(expProto, key, out); }
	    }
	  }
	};
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


	/***/ }),
	/* 15 */
	/***/ (function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


	/***/ }),
	/* 16 */
	/***/ (function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


	/***/ }),
	/* 17 */
	/***/ (function(module, exports) {

	module.exports = {};


	/***/ }),
	/* 18 */
	/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(51);
	var enumBugKeys = __webpack_require__(32);

	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


	/***/ }),
	/* 19 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_emoji_vue__ = __webpack_require__(43);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_emoji_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_emoji_vue__);
	/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_emoji_vue__) { if(__WEBPACK_IMPORT_KEY__ !== 'default') { (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_emoji_vue__[key]; }); }(__WEBPACK_IMPORT_KEY__)); } }
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_484e8d34_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_emoji_vue__ = __webpack_require__(115);
	var disposed = false;
	function injectStyle (ssrContext) {
	  if (disposed) { return }
	  __webpack_require__(79);
	}
	var normalizeComponent = __webpack_require__(5);
	/* script */


	/* template */

	/* template functional */
	var __vue_template_functional__ = false;
	/* styles */
	var __vue_styles__ = injectStyle;
	/* scopeId */
	var __vue_scopeId__ = "data-v-484e8d34";
	/* moduleIdentifier (server only) */
	var __vue_module_identifier__ = null;
	var Component = normalizeComponent(
	  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_emoji_vue___default.a,
	  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_484e8d34_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_emoji_vue__["a" /* default */],
	  __vue_template_functional__,
	  __vue_styles__,
	  __vue_scopeId__,
	  __vue_module_identifier__
	);
	Component.options.__file = "src/components/emoji.vue";

	/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


	/***/ }),
	/* 20 */
	/***/ (function(module, exports, __webpack_require__) {


	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _buildSearch = __webpack_require__(44);

	var _buildSearch2 = _interopRequireDefault(_buildSearch);

	var _data = __webpack_require__(81);

	var _data2 = _interopRequireDefault(_data);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function uncompress(list) {
	  for (var short_name in list) {
	    var datum = list[short_name];

	    if (!datum.short_names) { datum.short_names = []; }
	    datum.short_names.unshift(short_name);

	    datum.sheet_x = datum.sheet[0];
	    datum.sheet_y = datum.sheet[1];
	    delete datum.sheet;

	    if (!datum.text) { datum.text = ''; }
	    if (datum.added_in !== null && !datum.added_in) { datum.added_in = '6.0'; }

	    datum.search = (0, _buildSearch2.default)({
	      short_names: datum.short_names,
	      name: datum.name,
	      keywords: datum.keywords,
	      emoticons: datum.emoticons
	    });
	  }
	}

	uncompress(_data2.default.emojis);
	uncompress(_data2.default.skins);

	exports.default = _data2.default;

	/***/ }),
	/* 21 */
	/***/ (function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


	/***/ }),
	/* 22 */
	/***/ (function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(26);
	module.exports = function (it) {
	  return Object(defined(it));
	};


	/***/ }),
	/* 23 */
	/***/ (function(module, exports) {

	exports.f = {}.propertyIsEnumerable;


	/***/ }),
	/* 24 */
	/***/ (function(module, exports, __webpack_require__) {

	var $at = __webpack_require__(85)(true);

	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(45)(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) { return { value: undefined, done: true }; }
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});


	/***/ }),
	/* 25 */
	/***/ (function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


	/***/ }),
	/* 26 */
	/***/ (function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) { throw TypeError("Can't call method on  " + it); }
	  return it;
	};


	/***/ }),
	/* 27 */
	/***/ (function(module, exports) {

	module.exports = true;


	/***/ }),
	/* 28 */
	/***/ (function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(15);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) { return it; }
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) { return val; }
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) { return val; }
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) { return val; }
	  throw TypeError("Can't convert object to primitive value");
	};


	/***/ }),
	/* 29 */
	/***/ (function(module, exports) {

	var toString = {}.toString;

	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


	/***/ }),
	/* 30 */
	/***/ (function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(31)('keys');
	var uid = __webpack_require__(21);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


	/***/ }),
	/* 31 */
	/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(4);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	module.exports = function (key) {
	  return store[key] || (store[key] = {});
	};


	/***/ }),
	/* 32 */
	/***/ (function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


	/***/ }),
	/* 33 */
	/***/ (function(module, exports, __webpack_require__) {

	var def = __webpack_require__(6).f;
	var has = __webpack_require__(7);
	var TAG = __webpack_require__(2)('toStringTag');

	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) { def(it, TAG, { configurable: true, value: tag }); }
	};


	/***/ }),
	/* 34 */
	/***/ (function(module, exports, __webpack_require__) {

	exports.f = __webpack_require__(2);


	/***/ }),
	/* 35 */
	/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(4);
	var core = __webpack_require__(3);
	var LIBRARY = __webpack_require__(27);
	var wksExt = __webpack_require__(34);
	var defineProperty = __webpack_require__(6).f;
	module.exports = function (name) {
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if (name.charAt(0) != '_' && !(name in $Symbol)) { defineProperty($Symbol, name, { value: wksExt.f(name) }); }
	};


	/***/ }),
	/* 36 */
	/***/ (function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;


	/***/ }),
	/* 37 */
	/***/ (function(module, exports, __webpack_require__) {


	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _store = __webpack_require__(38);

	var _store2 = _interopRequireDefault(_store);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var DEFAULTS = ['+1', 'grinning', 'kissing_heart', 'heart_eyes', 'laughing', 'stuck_out_tongue_winking_eye', 'sweat_smile', 'joy', 'scream', 'disappointed', 'unamused', 'weary', 'sob', 'sunglasses', 'heart', 'poop'];

	var frequently = void 0,
	    initialized = void 0;
	var defaults = {};

	function init() {
	  initialized = true;
	  frequently = _store2.default.get('frequently');
	}

	function add(emoji) {
	  if (!initialized) { init(); }
	  var id = emoji.id;


	  frequently || (frequently = defaults);
	  frequently[id] || (frequently[id] = 0);
	  frequently[id] += 1;

	  _store2.default.set('last', id);
	  _store2.default.set('frequently', frequently);
	}

	function get(perLine) {
	  if (!initialized) { init(); }
	  if (!frequently) {
	    defaults = {};

	    var result = [];

	    for (var i = 0; i < perLine; i++) {
	      defaults[DEFAULTS[i]] = perLine - i;
	      result.push(DEFAULTS[i]);
	    }

	    return result;
	  }

	  var quantity = perLine * 4;
	  var frequentlyKeys = [];

	  for (var key in frequently) {
	    if (frequently.hasOwnProperty(key)) {
	      frequentlyKeys.push(key);
	    }
	  }

	  var sorted = frequentlyKeys.sort(function (a, b) {
	    return frequently[a] - frequently[b];
	  }).reverse();
	  var sliced = sorted.slice(0, quantity);

	  var last = _store2.default.get('last');

	  if (last && sliced.indexOf(last) == -1) {
	    sliced.pop();
	    sliced.push(last);
	  }

	  return sliced;
	}

	exports.default = { add: add, get: get };

	/***/ }),
	/* 38 */
	/***/ (function(module, exports, __webpack_require__) {


	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var NAMESPACE = 'emoji-mart';

	var _JSON = JSON;

	var isLocalStorageSupported = typeof window !== 'undefined' && 'localStorage' in window;

	var getter = void 0;
	var setter = void 0;

	function setHandlers(handlers) {
	  handlers || (handlers = {});

	  getter = handlers.getter;
	  setter = handlers.setter;
	}

	function setNamespace(namespace) {
	  NAMESPACE = namespace;
	}

	function update(state) {
	  for (var key in state) {
	    var value = state[key];
	    set(key, value);
	  }
	}

	function set(key, value) {
	  if (setter) {
	    setter(key, value);
	  } else {
	    if (!isLocalStorageSupported) { return; }
	    try {
	      window.localStorage[NAMESPACE + '.' + key] = _JSON.stringify(value);
	    } catch (e) {}
	  }
	}

	function get(key) {
	  if (getter) {
	    return getter(key);
	  } else {
	    if (!isLocalStorageSupported) { return; }
	    try {
	      var value = window.localStorage[NAMESPACE + '.' + key];
	    } catch (e) {
	      return;
	    }

	    if (value) {
	      return JSON.parse(value);
	    }
	  }
	}

	exports.default = { update: update, set: set, get: get, setNamespace: setNamespace, setHandlers: setHandlers };

	/***/ }),
	/* 39 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_anchors_vue__ = __webpack_require__(40);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_anchors_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_anchors_vue__);
	/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_anchors_vue__) { if(__WEBPACK_IMPORT_KEY__ !== 'default') { (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_anchors_vue__[key]; }); }(__WEBPACK_IMPORT_KEY__)); } }
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_51188104_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_anchors_vue__ = __webpack_require__(74);
	var disposed = false;
	function injectStyle (ssrContext) {
	  if (disposed) { return }
	  __webpack_require__(68);
	  __webpack_require__(71);
	}
	var normalizeComponent = __webpack_require__(5);
	/* script */


	/* template */

	/* template functional */
	var __vue_template_functional__ = false;
	/* styles */
	var __vue_styles__ = injectStyle;
	/* scopeId */
	var __vue_scopeId__ = "data-v-51188104";
	/* moduleIdentifier (server only) */
	var __vue_module_identifier__ = null;
	var Component = normalizeComponent(
	  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_anchors_vue___default.a,
	  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_51188104_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_anchors_vue__["a" /* default */],
	  __vue_template_functional__,
	  __vue_styles__,
	  __vue_scopeId__,
	  __vue_module_identifier__
	);
	Component.options.__file = "src/components/anchors.vue";

	/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


	/***/ }),
	/* 40 */
	/***/ (function(module, exports, __webpack_require__) {


	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _svgs = __webpack_require__(73);

	var _svgs2 = _interopRequireDefault(_svgs);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = {
	  props: {
	    i18n: {
	      type: Object,
	      required: true
	    },
	    color: {
	      type: String
	    },
	    categories: {
	      type: Array,
	      required: true
	    },
	    activeCategory: {
	      type: Object,
	      default: function _default() {
	        return {};
	      }
	    }
	  },
	  created: function created() {
	    this.svgs = _svgs2.default;
	  }
	}; //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//

	/***/ }),
	/* 41 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_category_vue__ = __webpack_require__(42);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_category_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_category_vue__);
	/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_category_vue__) { if(__WEBPACK_IMPORT_KEY__ !== 'default') { (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_category_vue__[key]; }); }(__WEBPACK_IMPORT_KEY__)); } }
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_376cda0e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_category_vue__ = __webpack_require__(116);
	var disposed = false;
	function injectStyle (ssrContext) {
	  if (disposed) { return }
	  __webpack_require__(75);
	  __webpack_require__(77);
	}
	var normalizeComponent = __webpack_require__(5);
	/* script */


	/* template */

	/* template functional */
	var __vue_template_functional__ = false;
	/* styles */
	var __vue_styles__ = injectStyle;
	/* scopeId */
	var __vue_scopeId__ = "data-v-376cda0e";
	/* moduleIdentifier (server only) */
	var __vue_module_identifier__ = null;
	var Component = normalizeComponent(
	  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_category_vue___default.a,
	  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_376cda0e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_category_vue__["a" /* default */],
	  __vue_template_functional__,
	  __vue_styles__,
	  __vue_scopeId__,
	  __vue_module_identifier__
	);
	Component.options.__file = "src/components/category.vue";

	/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


	/***/ }),
	/* 42 */
	/***/ (function(module, exports, __webpack_require__) {


	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _emoji = __webpack_require__(19);

	var _emoji2 = _interopRequireDefault(_emoji);

	var _frequently = __webpack_require__(37);

	var _frequently2 = _interopRequireDefault(_frequently);

	var _utils = __webpack_require__(13);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = {
	  props: {
	    i18n: {
	      type: Object,
	      required: true
	    },
	    id: {
	      type: String,
	      required: true
	    },
	    name: {
	      type: String,
	      required: true
	    },
	    emojis: {
	      type: Array
	    },
	    emojiProps: {
	      type: Object,
	      required: true
	    }
	  },
	  computed: {
	    isVisible: function isVisible() {
	      return !!this.emojis;
	    },
	    isSearch: function isSearch() {
	      return this.name == 'Search';
	    },
	    hasResults: function hasResults() {
	      return this.emojis.length > 0;
	    }
	  },
	  components: {
	    Emoji: _emoji2.default
	  }
	}; //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//

	/***/ }),
	/* 43 */
	/***/ (function(module, exports, __webpack_require__) {


	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _data = __webpack_require__(20);

	var _data2 = _interopRequireDefault(_data);

	var _utils = __webpack_require__(13);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//


	var SHEET_COLUMNS = 52;

	exports.default = {
	  props: {
	    backgroundImageFn: {
	      type: Function,
	      default: function _default(set, sheetSize) {
	        return 'https://unpkg.com/emoji-datasource-' + set + '@' + '4.0.2' + '/img/' + set + '/sheets/' + sheetSize + '.png';
	      }
	    },
	    native: {
	      type: Boolean,
	      default: false
	    },
	    forceSize: {
	      type: Boolean,
	      default: false
	    },
	    tooltip: {
	      type: Boolean,
	      default: false
	    },
	    fallback: {
	      type: Function
	    },
	    skin: {
	      type: Number,
	      default: 1
	    },
	    sheetSize: {
	      type: Number,
	      default: 64
	    },
	    set: {
	      type: String,
	      default: 'apple'
	    },
	    size: {
	      type: Number,
	      default: 24
	    },
	    emoji: {
	      type: [String, Object],
	      required: true
	    }
	  },
	  computed: {
	    data: function data() {
	      return (0, _utils.getData)(this.emoji, this.skin, this.set);
	    },
	    sanitizedData: function sanitizedData() {
	      return (0, _utils.getSanitizedData)(this.emoji, this.skin, this.set);
	    },
	    isNative: function isNative() {
	      return this.native;
	    },
	    isCustom: function isCustom() {
	      return this.data.custom;
	    },
	    hasEmoji: function hasEmoji() {
	      return this.data['has_img_' + this.set];
	    },
	    nativeEmoji: function nativeEmoji() {
	      if (this.data.unified) {
	        return (0, _utils.unifiedToNative)(this.data.unified);
	      } else {
	        return '';
	      }
	    },
	    fallbackEmoji: function fallbackEmoji() {
	      return this.fallback ? this.fallback(this.emoji) : null;
	    },
	    nativeEmojiStyles: function nativeEmojiStyles() {
	      var styles = { fontSize: this.size + 'px' };

	      if (this.forceSize) {
	        styles.display = 'inline-block';
	        styles.width = this.size + 'px';
	        styles.height = this.size + 'px';
	      }

	      return styles;
	    },
	    fallbackEmojiStyles: function fallbackEmojiStyles() {
	      if (this.isCustom) {
	        return this.customEmojiStyles;
	      } else if (this.hasEmoji) {
	        return {
	          display: 'inline-block',
	          width: this.size + 'px',
	          height: this.size + 'px',
	          backgroundImage: 'url(' + this.backgroundImageFn(this.set, this.sheetSize) + ')',
	          backgroundSize: 100 * SHEET_COLUMNS + '%',
	          backgroundPosition: this.getPosition()
	        };
	      } else {
	        return null;
	      }
	    },
	    customEmojiStyles: function customEmojiStyles() {
	      return {
	        display: 'inline-block',
	        width: this.size + 'px',
	        height: this.size + 'px',
	        backgroundImage: 'url(' + this.data.imageUrl + ')',
	        backgroundSize: '100%'
	      };
	    },
	    title: function title() {
	      return this.tooltip ? this.data.short_names[0] : null;
	    }
	  },
	  methods: {
	    getPosition: function getPosition() {
	      var multiply = 100 / (SHEET_COLUMNS - 1),
	          x = multiply * this.data.sheet_x,
	          y = multiply * this.data.sheet_y;

	      return x + '% ' + y + '%';
	    },
	    onClick: function onClick() {
	      this.$emit('click', this.sanitizedData);
	    },
	    onMouseEnter: function onMouseEnter() {
	      this.$emit('mouseenter', this.sanitizedData);
	    },
	    onMouseLeave: function onMouseLeave() {
	      this.$emit('mouseleave', this.sanitizedData);
	    }
	  }
	};

	/***/ }),
	/* 44 */
	/***/ (function(module, exports, __webpack_require__) {


	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	exports.default = function (data) {
	  var search = [];

	  var addToSearch = function addToSearch(strings, split) {
	    if (!strings) {
	      return;
	    }
	(Array.isArray(strings) ? strings : [strings]).forEach(function (string) {
	(split ? string.split(/[-|_|\s]+/) : [string]).forEach(function (s) {
	        s = s.toLowerCase();

	        if (search.indexOf(s) == -1) {
	          search.push(s);
	        }
	      });
	    });
	  };

	  addToSearch(data.short_names, true);
	  addToSearch(data.name, true);
	  addToSearch(data.keywords, false);
	  addToSearch(data.emoticons, false);

	  return search.join(',');
	};

	/***/ }),
	/* 45 */
	/***/ (function(module, exports, __webpack_require__) {

	var LIBRARY = __webpack_require__(27);
	var $export = __webpack_require__(14);
	var redefine = __webpack_require__(49);
	var hide = __webpack_require__(8);
	var has = __webpack_require__(7);
	var Iterators = __webpack_require__(17);
	var $iterCreate = __webpack_require__(87);
	var setToStringTag = __webpack_require__(33);
	var getPrototypeOf = __webpack_require__(92);
	var ITERATOR = __webpack_require__(2)('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';

	var returnThis = function () { return this; };

	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) { return proto[kind]; }
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = (!BUGGY && $native) || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && !has(IteratorPrototype, ITERATOR)) { hide(IteratorPrototype, ITERATOR, returnThis); }
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) { for (key in methods) {
	      if (!(key in proto)) { redefine(proto, key, methods[key]); }
	    } } else { $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods); }
	  }
	  return methods;
	};


	/***/ }),
	/* 46 */
	/***/ (function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(86);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) { return fn; }
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


	/***/ }),
	/* 47 */
	/***/ (function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(10) && !__webpack_require__(11)(function () {
	  return Object.defineProperty(__webpack_require__(48)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


	/***/ }),
	/* 48 */
	/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(15);
	var document = __webpack_require__(4).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


	/***/ }),
	/* 49 */
	/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(8);


	/***/ }),
	/* 50 */
	/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__(9);
	var dPs = __webpack_require__(88);
	var enumBugKeys = __webpack_require__(32);
	var IE_PROTO = __webpack_require__(30)('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';

	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(48)('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(91).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) { delete createDict[PROTOTYPE][enumBugKeys[i]]; }
	  return createDict();
	};

	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else { result = createDict(); }
	  return Properties === undefined ? result : dPs(result, Properties);
	};


	/***/ }),
	/* 51 */
	/***/ (function(module, exports, __webpack_require__) {

	var has = __webpack_require__(7);
	var toIObject = __webpack_require__(12);
	var arrayIndexOf = __webpack_require__(89)(false);
	var IE_PROTO = __webpack_require__(30)('IE_PROTO');

	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) { if (key != IE_PROTO) { has(O, key) && result.push(key); } }
	  // Don't enum bug & hidden keys
	  while (names.length > i) { if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  } }
	  return result;
	};


	/***/ }),
	/* 52 */
	/***/ (function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(29);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


	/***/ }),
	/* 53 */
	/***/ (function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(25);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


	/***/ }),
	/* 54 */
	/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(93);
	var global = __webpack_require__(4);
	var hide = __webpack_require__(8);
	var Iterators = __webpack_require__(17);
	var TO_STRING_TAG = __webpack_require__(2)('toStringTag');

	var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
	  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
	  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
	  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
	  'TextTrackList,TouchList').split(',');

	for (var i = 0; i < DOMIterables.length; i++) {
	  var NAME = DOMIterables[i];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  if (proto && !proto[TO_STRING_TAG]) { hide(proto, TO_STRING_TAG, NAME); }
	  Iterators[NAME] = Iterators.Array;
	}


	/***/ }),
	/* 55 */
	/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys = __webpack_require__(51);
	var hiddenKeys = __webpack_require__(32).concat('length', 'prototype');

	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return $keys(O, hiddenKeys);
	};


	/***/ }),
	/* 56 */
	/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(111), __esModule: true };

	/***/ }),
	/* 57 */
	/***/ (function(module, exports, __webpack_require__) {


	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _toConsumableArray2 = __webpack_require__(122);

	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

	var _extends2 = __webpack_require__(131);

	var _extends3 = _interopRequireDefault(_extends2);

	var _getIterator2 = __webpack_require__(132);

	var _getIterator3 = _interopRequireDefault(_getIterator2);

	var _assign = __webpack_require__(56);

	var _assign2 = _interopRequireDefault(_assign);

	__webpack_require__(135);

	var _data2 = __webpack_require__(20);

	var _data3 = _interopRequireDefault(_data2);

	var _store = __webpack_require__(38);

	var _store2 = _interopRequireDefault(_store);

	var _frequently = __webpack_require__(37);

	var _frequently2 = _interopRequireDefault(_frequently);

	var _utils = __webpack_require__(13);

	var _anchors = __webpack_require__(39);

	var _anchors2 = _interopRequireDefault(_anchors);

	var _category = __webpack_require__(41);

	var _category2 = _interopRequireDefault(_category);

	var _emoji2 = __webpack_require__(19);

	var _emoji3 = _interopRequireDefault(_emoji2);

	var _preview = __webpack_require__(59);

	var _preview2 = _interopRequireDefault(_preview);

	var _search = __webpack_require__(63);

	var _search2 = _interopRequireDefault(_search);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//


	var RECENT_CATEGORY = { id: 'recent', name: 'Recent', emojis: null };
	var CUSTOM_CATEGORY = { id: 'custom', name: 'Custom', emojis: [] };

	var I18N = {
	  search: 'Search',
	  notfound: 'No Emoji Found',
	  categories: {
	    search: 'Search Results',
	    recent: 'Frequently Used',
	    people: 'Smileys & People',
	    nature: 'Animals & Nature',
	    foods: 'Food & Drink',
	    activity: 'Activity',
	    places: 'Travel & Places',
	    objects: 'Objects',
	    symbols: 'Symbols',
	    flags: 'Flags',
	    custom: 'Custom'
	  }
	};

	function makeCustomEmoji(emoji) {
	  return (0, _assign2.default)({}, emoji, {
	    id: emoji.short_names[0],
	    custom: true
	  });
	}

	exports.default = {
	  props: {
	    perLine: {
	      type: Number,
	      default: 9
	    },
	    emojiSize: {
	      type: Number,
	      default: 24
	    },
	    title: {
	      type: String,
	      default: 'Emoji Mart™'
	    },
	    emoji: {
	      type: String,
	      default: 'department_store'
	    },
	    color: {
	      type: String,
	      default: '#ae65c5'
	    },
	    set: {
	      type: String,
	      default: 'apple'
	    },
	    skin: {
	      type: Number,
	      default: null
	    },
	    defaultSkin: {
	      type: Number,
	      default: 1
	    },
	    native: {
	      type: Boolean,
	      default: false
	    },
	    backgroundImageFn: {
	      type: Function
	    },
	    sheetSize: {
	      type: Number,
	      default: 64
	    },
	    emojisToShowFilter: {
	      type: Function
	    },
	    emojiTooltip: {
	      type: Boolean,
	      default: false
	    },
	    include: {
	      type: Array
	    },
	    exclude: {
	      type: Array
	    },
	    recent: {
	      type: Array
	    },
	    autoFocus: {
	      type: Boolean,
	      default: false
	    },
	    custom: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    i18n: {
	      type: Object,
	      default: function _default() {
	        return I18N;
	      }
	    },
	    showPreview: {
	      type: Boolean,
	      default: true
	    },
	    showSearch: {
	      type: Boolean,
	      default: true
	    },
	    showCategories: {
	      type: Boolean,
	      default: true
	    },
	    showSkinTones: {
	      type: Boolean,
	      default: true
	    },
	    infiniteScroll: {
	      type: Boolean,
	      default: true
	    },
	    pickerStyles: {
	      type: Object,
	      default: function _default() {
	        return {};
	      }
	    }
	  },
	  data: function data() {
	    var _this = this;

	    var customEmojis = this.custom.map(makeCustomEmoji),
	        recentEmojis = this.recent || _frequently2.default.get(this.perLine);

	    if (recentEmojis.length) {
	      recentEmojis = recentEmojis.map(function (id) {
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;

	        try {
	          for (var _iterator = (0, _getIterator3.default)(customEmojis), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var customEmoji = _step.value;

	            if (customEmoji.id === id) {
	              return customEmoji;
	            }
	          }
	        } catch (err) {
	          _didIteratorError = true;
	          _iteratorError = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	              _iterator.return();
	            }
	          } finally {
	            if (_didIteratorError) {
	              throw _iteratorError;
	            }
	          }
	        }

	        return id;
	      });
	    }

	    if (this.emojisToShowFilter) {
	      customEmojis = customEmojis.filter(function (e) {
	        return _this.emojisToShowFilter(_data3.default.emojis[e] || e);
	      });
	      recentEmojis = recentEmojis.filter(function (e) {
	        return _this.emojisToShowFilter(_data3.default.emojis[e] || e);
	      });
	    }

	    return {
	      activeSkin: this.skin || _store2.default.get('skin') || this.defaultSkin,
	      categories: [],
	      activeCategory: null,
	      previewEmoji: null,
	      searchEmojis: null,
	      customEmojis: customEmojis,
	      recentEmojis: recentEmojis
	    };
	  },

	  computed: {
	    customStyles: function customStyles() {
	      return (0, _extends3.default)({
	        width: this.calculateWidth + 'px'
	      }, this.pickerStyles);
	    },
	    emojiProps: function emojiProps() {
	      return {
	        native: this.native,
	        skin: this.activeSkin,
	        size: this.emojiSize,
	        set: this.set,
	        sheetSize: this.sheetSize,
	        forceSize: this.native,
	        tooltip: this.emojiTooltip,
	        backgroundImageFn: this.backgroundImageFn,
	        onEnter: this.onEmojiEnter.bind(this),
	        onLeave: this.onEmojiLeave.bind(this),
	        onClick: this.onEmojiClick.bind(this)
	      };
	    },
	    skinProps: function skinProps() {
	      return {
	        skin: this.activeSkin
	      };
	    },
	    calculateWidth: function calculateWidth() {
	      return this.perLine * (this.emojiSize + 12) + 12 + 2 + (0, _utils.measureScrollbar)();
	    },
	    filteredCategories: function filteredCategories() {
	      var _this2 = this;

	      return this.categories.filter(function (category) {
	        var isIncluded = _this2.include && _this2.include.length ? _this2.include.indexOf(category.id) > -1 : true;
	        var isExcluded = _this2.exclude && _this2.exclude.length ? _this2.exclude.indexOf(category.id) > -1 : false;
	        var hasEmojis = category.emojis.length > 0;

	        if (_this2.emojisToShowFilter) {
	          hasEmojis = category.emojis.some(function (emoji) {
	            return _this2.emojisToShowFilter(_data3.default.emojis[emoji] || emoji);
	          });
	        }

	        return isIncluded && !isExcluded && hasEmojis;
	      });
	    }
	  },
	  created: function created() {
	    var _this3 = this,
	        _categories;

	    var categories = _data3.default.categories.map(function (c) {
	      var id = c.id;
	      var name = c.name;
	      var emojis = c.emojis;


	      if (_this3.emojisToShowFilter) {
	        emojis = c.emojis.filter(function (e) {
	          return _this3.emojisToShowFilter(_data3.default.emojis[e] || e);
	        });
	      }

	      return { id: id, name: name, emojis: emojis };
	    });

	    RECENT_CATEGORY.emojis = this.recentEmojis;
	    CUSTOM_CATEGORY.emojis = this.customEmojis;

	    this.categories.push(RECENT_CATEGORY);
	    (_categories = this.categories).push.apply(_categories, (0, _toConsumableArray3.default)(categories));
	    this.categories.push(CUSTOM_CATEGORY);

	    this.categories[0].first = true;
	    this.activeCategory = this.filteredCategories[0];
	  },

	  methods: {
	    onScroll: function onScroll() {
	      if (this.infiniteScroll && !this.waitingForPaint) {
	        this.waitingForPaint = true;
	        window.requestAnimationFrame(this.onScrollPaint.bind(this));
	      }
	    },
	    onScrollPaint: function onScrollPaint() {
	      var this$1 = this;

	      this.waitingForPaint = false;

	      var scrollTop = this.$refs.scroll.scrollTop,
	          activeCategory = this.filteredCategories[0];

	      for (var i = 0, l = this.filteredCategories.length; i < l; i++) {
	        var category = this$1.filteredCategories[i],
	            component = this$1.$refs.categories[i];

	        if (component && component.$el.offsetTop > scrollTop) {
	          break;
	        }

	        activeCategory = category;
	      }

	      this.activeCategory = activeCategory;
	    },
	    onAnchorClick: function onAnchorClick(category) {
	      var _this4 = this;

	      var i = this.filteredCategories.indexOf(category),
	          component = this.$refs.categories[i],
	          scrollToComponent = function scrollToComponent() {
	        if (component) {
	          var top = component.$el.offsetTop;

	          if (category.first) {
	            top = 0;
	          }

	          _this4.$refs.scroll.scrollTop = top;
	        }
	      };

	      if (this.searchEmojis) {
	        this.onSearch(null);
	        this.$refs.search.clear();

	        this.$nextTick(scrollToComponent);
	      } else if (this.infiniteScroll) {
	        scrollToComponent();
	      } else {
	        this.activeCategory = this.filteredCategories[i];
	      }
	    },
	    onSearch: function onSearch(emojis) {
	      this.searchEmojis = emojis;
	    },
	    onEmojiEnter: function onEmojiEnter(emoji) {
	      if (emoji.custom) {
	        // Use Array.prototype.find() when it is more widely supported.
	        var customEmoji = this.customEmojis.filter(function (_emoji) {
	          return _emoji.id === emoji.id;
	        })[0];
	        emoji = (0, _assign2.default)({}, emoji, customEmoji);
	      }

	      this.previewEmoji = emoji;
	    },
	    onEmojiLeave: function onEmojiLeave(emoji) {
	      this.previewEmoji = null;
	    },
	    onEmojiClick: function onEmojiClick(emoji) {
	      this.$emit('select', emoji);
	      _frequently2.default.add(emoji);
	    },
	    onSkinChange: function onSkinChange(skin) {
	      this.activeSkin = skin;
	      _store2.default.update({ skin: skin });

	      this.$emit('skin-change', skin);
	    }
	  },
	  components: {
	    Anchors: _anchors2.default,
	    Category: _category2.default,
	    Emoji: _emoji3.default,
	    Preview: _preview2.default,
	    Search: _search2.default
	  }
	};

	/***/ }),
	/* 58 */
	/***/ (function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(129);
	var ITERATOR = __webpack_require__(2)('iterator');
	var Iterators = __webpack_require__(17);
	module.exports = __webpack_require__(3).getIteratorMethod = function (it) {
	  if (it != undefined) { return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)]; }
	};


	/***/ }),
	/* 59 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_preview_vue__ = __webpack_require__(60);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_preview_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_preview_vue__);
	/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_preview_vue__) { if(__WEBPACK_IMPORT_KEY__ !== 'default') { (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_preview_vue__[key]; }); }(__WEBPACK_IMPORT_KEY__)); } }
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35056c30_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_preview_vue__ = __webpack_require__(141);
	var disposed = false;
	function injectStyle (ssrContext) {
	  if (disposed) { return }
	  __webpack_require__(136);
	}
	var normalizeComponent = __webpack_require__(5);
	/* script */


	/* template */

	/* template functional */
	var __vue_template_functional__ = false;
	/* styles */
	var __vue_styles__ = injectStyle;
	/* scopeId */
	var __vue_scopeId__ = "data-v-35056c30";
	/* moduleIdentifier (server only) */
	var __vue_module_identifier__ = null;
	var Component = normalizeComponent(
	  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_preview_vue___default.a,
	  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35056c30_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_preview_vue__["a" /* default */],
	  __vue_template_functional__,
	  __vue_styles__,
	  __vue_scopeId__,
	  __vue_module_identifier__
	);
	Component.options.__file = "src/components/preview.vue";

	/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


	/***/ }),
	/* 60 */
	/***/ (function(module, exports, __webpack_require__) {


	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _emoji = __webpack_require__(19);

	var _emoji2 = _interopRequireDefault(_emoji);

	var _skins = __webpack_require__(61);

	var _skins2 = _interopRequireDefault(_skins);

	var _utils = __webpack_require__(13);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = {
	  props: {
	    title: {
	      type: String,
	      required: true
	    },
	    emoji: {
	      type: [String, Object]
	    },
	    idleEmoji: {
	      type: [String, Object],
	      required: true
	    },
	    showSkinTones: {
	      type: Boolean,
	      default: true
	    },
	    emojiProps: {
	      type: Object,
	      required: true
	    },
	    skinProps: {
	      type: Object,
	      required: true
	    }
	  },
	  computed: {
	    data: function data() {
	      if (this.emoji && this.emoji.custom) {
	        return this.emoji;
	      } else if (this.emoji) {
	        return (0, _utils.getData)(this.emoji);
	      } else {
	        return {};
	      }
	    },
	    emojiShortNames: function emojiShortNames() {
	      return this.data.short_names;
	    },
	    emojiEmoticons: function emojiEmoticons() {
	      return this.data.emoticons;
	    }
	  },
	  components: {
	    Emoji: _emoji2.default,
	    Skins: _skins2.default
	  }
	}; //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//

	/***/ }),
	/* 61 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_skins_vue__ = __webpack_require__(62);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_skins_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_skins_vue__);
	/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_skins_vue__) { if(__WEBPACK_IMPORT_KEY__ !== 'default') { (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_skins_vue__[key]; }); }(__WEBPACK_IMPORT_KEY__)); } }
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c614894_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_skins_vue__ = __webpack_require__(140);
	var disposed = false;
	function injectStyle (ssrContext) {
	  if (disposed) { return }
	  __webpack_require__(138);
	}
	var normalizeComponent = __webpack_require__(5);
	/* script */


	/* template */

	/* template functional */
	var __vue_template_functional__ = false;
	/* styles */
	var __vue_styles__ = injectStyle;
	/* scopeId */
	var __vue_scopeId__ = "data-v-1c614894";
	/* moduleIdentifier (server only) */
	var __vue_module_identifier__ = null;
	var Component = normalizeComponent(
	  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_skins_vue___default.a,
	  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c614894_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_skins_vue__["a" /* default */],
	  __vue_template_functional__,
	  __vue_styles__,
	  __vue_scopeId__,
	  __vue_module_identifier__
	);
	Component.options.__file = "src/components/skins.vue";

	/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


	/***/ }),
	/* 62 */
	/***/ (function(module, exports, __webpack_require__) {


	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//


	exports.default = {
	  props: {
	    skin: {
	      type: Number,
	      required: true
	    }
	  },
	  data: function data() {
	    return {
	      opened: false
	    };
	  },

	  methods: {
	    onClick: function onClick(skinTone) {
	      if (this.opened) {
	        if (skinTone != this.skin) {
	          this.$emit('change', skinTone);
	        }
	      }

	      this.opened = !this.opened;
	    }
	  }
	};

	/***/ }),
	/* 63 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_search_vue__ = __webpack_require__(64);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_search_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_search_vue__);
	/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_search_vue__) { if(__WEBPACK_IMPORT_KEY__ !== 'default') { (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_search_vue__[key]; }); }(__WEBPACK_IMPORT_KEY__)); } }
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ad41bb8_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_search_vue__ = __webpack_require__(144);
	var disposed = false;
	function injectStyle (ssrContext) {
	  if (disposed) { return }
	  __webpack_require__(142);
	}
	var normalizeComponent = __webpack_require__(5);
	/* script */


	/* template */

	/* template functional */
	var __vue_template_functional__ = false;
	/* styles */
	var __vue_styles__ = injectStyle;
	/* scopeId */
	var __vue_scopeId__ = "data-v-4ad41bb8";
	/* moduleIdentifier (server only) */
	var __vue_module_identifier__ = null;
	var Component = normalizeComponent(
	  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_search_vue___default.a,
	  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ad41bb8_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_search_vue__["a" /* default */],
	  __vue_template_functional__,
	  __vue_styles__,
	  __vue_scopeId__,
	  __vue_module_identifier__
	);
	Component.options.__file = "src/components/search.vue";

	/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


	/***/ }),
	/* 64 */
	/***/ (function(module, exports, __webpack_require__) {


	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _emojiIndex = __webpack_require__(65);

	var _emojiIndex2 = _interopRequireDefault(_emojiIndex);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = {
	  props: {
	    i18n: {
	      type: Object,
	      required: true
	    },
	    maxResults: {
	      type: Number,
	      default: 75
	    },
	    autoFocus: {
	      type: Boolean,
	      default: false
	    },
	    emojisToShowFilter: {
	      type: Function
	    },
	    include: {
	      type: Array
	    },
	    exclude: {
	      type: Array
	    },
	    custom: {
	      type: Array
	    }
	  },
	  data: function data() {
	    return {
	      value: ''
	    };
	  },

	  watch: {
	    value: function value() {
	      var emojis = _emojiIndex2.default.search(this.value, {
	        emojisToShowFilter: this.emojisToShowFilter,
	        maxResults: this.maxResults,
	        include: this.include,
	        exclude: this.exclude,
	        custom: this.custom
	      });

	      this.$emit('search', emojis);
	    }
	  },
	  methods: {
	    clear: function clear() {
	      this.value = '';
	    }
	  },
	  mounted: function mounted() {
	    var $input = this.$el.querySelector('input');

	    if (this.autoFocus) {
	      $input.focus();
	    }
	  }
	}; //
	//
	//
	//
	//
	//
	//
	//

	/***/ }),
	/* 65 */
	/***/ (function(module, exports, __webpack_require__) {


	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _data = __webpack_require__(20);

	var _data2 = _interopRequireDefault(_data);

	var _ = __webpack_require__(13);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var originalPool = {};
	var index = {};
	var emojisList = {};
	var emoticonsList = {};
	var customEmojisList = [];

	var _loop = function _loop(emoji) {
	  var emojiData = _data2.default.emojis[emoji];
	  var short_names = emojiData.short_names;
	  var emoticons = emojiData.emoticons;
	  var id = short_names[0];

	  if (emoticons) {
	    emoticons.forEach(function (emoticon) {
	      if (emoticonsList[emoticon]) {
	        return;
	      }

	      emoticonsList[emoticon] = id;
	    });
	  }

	  emojisList[id] = (0, _.getSanitizedData)(id);
	  originalPool[id] = emojiData;
	};

	for (var emoji in _data2.default.emojis) {
	  _loop(emoji);
	}

	function clearCustomEmojis(pool) {
	  customEmojisList.forEach(function (emoji) {
	    var emojiId = emoji.id || emoji.short_names[0];

	    delete pool[emojiId];
	    delete emojisList[emojiId];
	  });
	}

	function addCustomToPool(custom, pool) {
	  if (customEmojisList.length) { clearCustomEmojis(pool); }

	  custom.forEach(function (emoji) {
	    var emojiId = emoji.id || emoji.short_names[0];

	    if (emojiId && !pool[emojiId]) {
	      pool[emojiId] = (0, _.getData)(emoji);
	      emojisList[emojiId] = (0, _.getSanitizedData)(emoji);
	    }
	  });

	  customEmojisList = custom;
	  index = {};
	}

	function search(value) {
	  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

	  var emojisToShowFilter = _ref.emojisToShowFilter;
	  var maxResults = _ref.maxResults;
	  var include = _ref.include;
	  var exclude = _ref.exclude;
	  var _ref$custom = _ref.custom;
	  var custom = _ref$custom === undefined ? [] : _ref$custom;

	  if (customEmojisList != custom) { addCustomToPool(custom, originalPool); }

	  maxResults || (maxResults = 75);
	  include || (include = []);
	  exclude || (exclude = []);

	  var results = null,
	      pool = originalPool;

	  if (value.length) {
	    if (value == '-' || value == '-1') {
	      return [emojisList['-1']];
	    }

	    var values = value.toLowerCase().split(/[\s|,|\-|_]+/),
	        allResults = [];

	    if (values.length > 2) {
	      values = [values[0], values[1]];
	    }

	    if (include.length || exclude.length) {
	      pool = {};

	      _data2.default.categories.forEach(function (category) {
	        var isIncluded = include && include.length ? include.indexOf(category.id) > -1 : true;
	        var isExcluded = exclude && exclude.length ? exclude.indexOf(category.id) > -1 : false;
	        if (!isIncluded || isExcluded) {
	          return;
	        }

	        category.emojis.forEach(function (emojiId) {
	          return pool[emojiId] = _data2.default.emojis[emojiId];
	        });
	      });

	      if (custom.length) {
	        var customIsIncluded = include && include.length ? include.indexOf('custom') > -1 : true;
	        var customIsExcluded = exclude && exclude.length ? exclude.indexOf('custom') > -1 : false;
	        if (customIsIncluded && !customIsExcluded) {
	          addCustomToPool(custom, pool);
	        }
	      }
	    }

	    allResults = values.map(function (value) {
	      var aPool = pool,
	          aIndex = index,
	          length = 0;

	      for (var charIndex = 0; charIndex < value.length; charIndex++) {
	        var char = value[charIndex];
	        length++;

	        aIndex[char] || (aIndex[char] = {});
	        aIndex = aIndex[char];

	        if (!aIndex.results) {
	          (function () {
	            var scores = {};

	            aIndex.results = [];
	            aIndex.pool = {};

	            for (var _id in aPool) {
	              var emoji = aPool[_id];
	              var _search = emoji.search;
	              var sub = value.substr(0, length);
	              var subIndex = _search.indexOf(sub);

	              if (subIndex != -1) {
	                var score = subIndex + 1;
	                if (sub == _id) { score = 0; }

	                aIndex.results.push(emojisList[_id]);
	                aIndex.pool[_id] = emoji;

	                scores[_id] = score;
	              }
	            }

	            aIndex.results.sort(function (a, b) {
	              var aScore = scores[a.id],
	                  bScore = scores[b.id];

	              return aScore - bScore;
	            });
	          })();
	        }

	        aPool = aIndex.pool;
	      }

	      return aIndex.results;
	    }).filter(function (a) {
	      return a;
	    });

	    if (allResults.length > 1) {
	      results = _.intersect.apply(null, allResults);
	    } else if (allResults.length) {
	      results = allResults[0];
	    } else {
	      results = [];
	    }
	  }

	  if (results) {
	    if (emojisToShowFilter) {
	      results = results.filter(function (result) {
	        return emojisToShowFilter(pool[result.id]);
	      });
	    }

	    if (results && results.length > maxResults) {
	      results = results.slice(0, maxResults);
	    }
	  }

	  return results;
	}

	exports.default = { search: search, emojis: emojisList, emoticons: emoticonsList };

	/***/ }),
	/* 66 */
	/***/ (function(module, exports, __webpack_require__) {


	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.frequently = exports.store = exports.emojiIndex = exports.Category = exports.Emoji = exports.Picker = undefined;

	var _components = __webpack_require__(67);

	Object.defineProperty(exports, 'Picker', {
	  enumerable: true,
	  get: function get() {
	    return _components.Picker;
	  }
	});
	Object.defineProperty(exports, 'Emoji', {
	  enumerable: true,
	  get: function get() {
	    return _components.Emoji;
	  }
	});
	Object.defineProperty(exports, 'Category', {
	  enumerable: true,
	  get: function get() {
	    return _components.Category;
	  }
	});

	var _emojiIndex = __webpack_require__(65);

	var _emojiIndex2 = _interopRequireDefault(_emojiIndex);

	var _store = __webpack_require__(38);

	var _store2 = _interopRequireDefault(_store);

	var _frequently = __webpack_require__(37);

	var _frequently2 = _interopRequireDefault(_frequently);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.emojiIndex = _emojiIndex2.default;
	exports.store = _store2.default;
	exports.frequently = _frequently2.default;

	/***/ }),
	/* 67 */
	/***/ (function(module, exports, __webpack_require__) {


	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Skins = exports.Search = exports.Preview = exports.Picker = exports.Emoji = exports.Category = exports.Anchors = undefined;

	var _anchors = __webpack_require__(39);

	var _anchors2 = _interopRequireDefault(_anchors);

	var _category = __webpack_require__(41);

	var _category2 = _interopRequireDefault(_category);

	var _emoji = __webpack_require__(19);

	var _emoji2 = _interopRequireDefault(_emoji);

	var _picker = __webpack_require__(117);

	var _picker2 = _interopRequireDefault(_picker);

	var _preview = __webpack_require__(59);

	var _preview2 = _interopRequireDefault(_preview);

	var _search = __webpack_require__(63);

	var _search2 = _interopRequireDefault(_search);

	var _skins = __webpack_require__(61);

	var _skins2 = _interopRequireDefault(_skins);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.Anchors = _anchors2.default;
	exports.Category = _category2.default;
	exports.Emoji = _emoji2.default;
	exports.Picker = _picker2.default;
	exports.Preview = _preview2.default;
	exports.Search = _search2.default;
	exports.Skins = _skins2.default;

	/***/ }),
	/* 68 */
	/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(69);
	if(typeof content === 'string') { content = [[module.i, content, '']]; }
	if(content.locals) { module.exports = content.locals; }
	// add the styles to the DOM
	var update = __webpack_require__(1)("42627c02", content, false, {});

	/***/ }),
	/* 69 */
	/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(0)(false);
	// imports


	// module
	exports.push([module.i, "\n.emoji-mart-anchors[data-v-51188104] {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  padding: 0 6px;\n  color: #858585;\n  line-height: 0;\n}\n.emoji-mart-anchor[data-v-51188104] {\n  position: relative;\n  display: block;\n  flex: 1 1 auto;\n  text-align: center;\n  padding: 12px 4px;\n  overflow: hidden;\n  transition: color .1s ease-out;\n}\n.emoji-mart-anchor[data-v-51188104]:hover,\n.emoji-mart-anchor-selected[data-v-51188104] {\n  color: #464646;\n}\n.emoji-mart-anchor-selected .emoji-mart-anchor-bar[data-v-51188104] {\n  bottom: 0;\n}\n.emoji-mart-anchor-bar[data-v-51188104] {\n  position: absolute;\n  bottom: -3px; left: 0;\n  width: 100%; height: 3px;\n  background-color: #464646;\n}\n.emoji-mart-anchors i[data-v-51188104] {\n  display: inline-block;\n  width: 100%;\n  max-width: 22px;\n}\n\n", ""]);

	// exports


	/***/ }),
	/* 70 */
	/***/ (function(module, exports) {

	/**
	 * Translates the list format produced by css-loader into something
	 * easier to manipulate.
	 */
	module.exports = function listToStyles (parentId, list) {
	  var styles = [];
	  var newStyles = {};
	  for (var i = 0; i < list.length; i++) {
	    var item = list[i];
	    var id = item[0];
	    var css = item[1];
	    var media = item[2];
	    var sourceMap = item[3];
	    var part = {
	      id: parentId + ':' + i,
	      css: css,
	      media: media,
	      sourceMap: sourceMap
	    };
	    if (!newStyles[id]) {
	      styles.push(newStyles[id] = { id: id, parts: [part] });
	    } else {
	      newStyles[id].parts.push(part);
	    }
	  }
	  return styles
	};


	/***/ }),
	/* 71 */
	/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(72);
	if(typeof content === 'string') { content = [[module.i, content, '']]; }
	if(content.locals) { module.exports = content.locals; }
	// add the styles to the DOM
	var update = __webpack_require__(1)("26752f80", content, false, {});

	/***/ }),
	/* 72 */
	/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(0)(false);
	// imports


	// module
	exports.push([module.i, "\n.emoji-mart-anchors svg {\n  fill: currentColor;\n  max-height: 18px;\n}\n\n", ""]);

	// exports


	/***/ }),
	/* 73 */
	/***/ (function(module, exports, __webpack_require__) {


	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var SVGs = {
	  activity: "<path d=\"M12 0C5.373 0 0 5.372 0 12c0 6.627 5.373 12 12 12 6.628 0 12-5.373 12-12 0-6.628-5.372-12-12-12m9.949 11H17.05c.224-2.527 1.232-4.773 1.968-6.113A9.966 9.966 0 0 1 21.949 11M13 11V2.051a9.945 9.945 0 0 1 4.432 1.564c-.858 1.491-2.156 4.22-2.392 7.385H13zm-2 0H8.961c-.238-3.165-1.536-5.894-2.393-7.385A9.95 9.95 0 0 1 11 2.051V11zm0 2v8.949a9.937 9.937 0 0 1-4.432-1.564c.857-1.492 2.155-4.221 2.393-7.385H11zm4.04 0c.236 3.164 1.534 5.893 2.392 7.385A9.92 9.92 0 0 1 13 21.949V13h2.04zM4.982 4.887C5.718 6.227 6.726 8.473 6.951 11h-4.9a9.977 9.977 0 0 1 2.931-6.113M2.051 13h4.9c-.226 2.527-1.233 4.771-1.969 6.113A9.972 9.972 0 0 1 2.051 13m16.967 6.113c-.735-1.342-1.744-3.586-1.968-6.113h4.899a9.961 9.961 0 0 1-2.931 6.113\"/>",

	  custom: "<g transform=\"translate(2.000000, 1.000000)\"><rect id=\"Rectangle\" x=\"8\" y=\"0\" width=\"3\" height=\"21\" rx=\"1.5\"></rect><rect id=\"Rectangle\" transform=\"translate(9.843, 10.549) rotate(60) translate(-9.843, -10.549) \" x=\"8.343\" y=\"0.049\" width=\"3\" height=\"21\" rx=\"1.5\"></rect><rect id=\"Rectangle\" transform=\"translate(9.843, 10.549) rotate(-60) translate(-9.843, -10.549) \" x=\"8.343\" y=\"0.049\" width=\"3\" height=\"21\" rx=\"1.5\"></rect></g>",

	  flags: "<path d=\"M0 0l6.084 24H8L1.916 0zM21 5h-4l-1-4H4l3 12h3l1 4h13L21 5zM6.563 3h7.875l2 8H8.563l-2-8zm8.832 10l-2.856 1.904L12.063 13h3.332zM19 13l-1.5-6h1.938l2 8H16l3-2z\"/>",

	  foods: "<path d=\"M17 4.978c-1.838 0-2.876.396-3.68.934.513-1.172 1.768-2.934 4.68-2.934a1 1 0 0 0 0-2c-2.921 0-4.629 1.365-5.547 2.512-.064.078-.119.162-.18.244C11.73 1.838 10.798.023 9.207.023 8.579.022 7.85.306 7 .978 5.027 2.54 5.329 3.902 6.492 4.999 3.609 5.222 0 7.352 0 12.969c0 4.582 4.961 11.009 9 11.009 1.975 0 2.371-.486 3-1 .629.514 1.025 1 3 1 4.039 0 9-6.418 9-11 0-5.953-4.055-8-7-8M8.242 2.546c.641-.508.943-.523.965-.523.426.169.975 1.405 1.357 3.055-1.527-.629-2.741-1.352-2.98-1.846.059-.112.241-.356.658-.686M15 21.978c-1.08 0-1.21-.109-1.559-.402l-.176-.146c-.367-.302-.816-.452-1.266-.452s-.898.15-1.266.452l-.176.146c-.347.292-.477.402-1.557.402-2.813 0-7-5.389-7-9.009 0-5.823 4.488-5.991 5-5.991 1.939 0 2.484.471 3.387 1.251l.323.276a1.995 1.995 0 0 0 2.58 0l.323-.276c.902-.78 1.447-1.251 3.387-1.251.512 0 5 .168 5 6 0 3.617-4.187 9-7 9\"/>",

	  nature: "<path d=\"M15.5 8a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 15.5 8M8.5 8a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 8.5 8\"/><path d=\"M18.933 0h-.027c-.97 0-2.138.787-3.018 1.497-1.274-.374-2.612-.51-3.887-.51-1.285 0-2.616.133-3.874.517C7.245.79 6.069 0 5.093 0h-.027C3.352 0 .07 2.67.002 7.026c-.039 2.479.276 4.238 1.04 5.013.254.258.882.677 1.295.882.191 3.177.922 5.238 2.536 6.38.897.637 2.187.949 3.2 1.102C8.04 20.6 8 20.795 8 21c0 1.773 2.35 3 4 3 1.648 0 4-1.227 4-3 0-.201-.038-.393-.072-.586 2.573-.385 5.435-1.877 5.925-7.587.396-.22.887-.568 1.104-.788.763-.774 1.079-2.534 1.04-5.013C23.929 2.67 20.646 0 18.933 0M3.223 9.135c-.237.281-.837 1.155-.884 1.238-.15-.41-.368-1.349-.337-3.291.051-3.281 2.478-4.972 3.091-5.031.256.015.731.27 1.265.646-1.11 1.171-2.275 2.915-2.352 5.125-.133.546-.398.858-.783 1.313M12 22c-.901 0-1.954-.693-2-1 0-.654.475-1.236 1-1.602V20a1 1 0 1 0 2 0v-.602c.524.365 1 .947 1 1.602-.046.307-1.099 1-2 1m3-3.48v.02a4.752 4.752 0 0 0-1.262-1.02c1.092-.516 2.239-1.334 2.239-2.217 0-1.842-1.781-2.195-3.977-2.195-2.196 0-3.978.354-3.978 2.195 0 .883 1.148 1.701 2.238 2.217A4.8 4.8 0 0 0 9 18.539v-.025c-1-.076-2.182-.281-2.973-.842-1.301-.92-1.838-3.045-1.853-6.478l.023-.041c.496-.826 1.49-1.45 1.804-3.102 0-2.047 1.357-3.631 2.362-4.522C9.37 3.178 10.555 3 11.948 3c1.447 0 2.685.192 3.733.57 1 .9 2.316 2.465 2.316 4.48.313 1.651 1.307 2.275 1.803 3.102.035.058.068.117.102.178-.059 5.967-1.949 7.01-4.902 7.19m6.628-8.202c-.037-.065-.074-.13-.113-.195a7.587 7.587 0 0 0-.739-.987c-.385-.455-.648-.768-.782-1.313-.076-2.209-1.241-3.954-2.353-5.124.531-.376 1.004-.63 1.261-.647.636.071 3.044 1.764 3.096 5.031.027 1.81-.347 3.218-.37 3.235\"/>",

	  objects: "<path d=\"M12 0a9 9 0 0 0-5 16.482V21s2.035 3 5 3 5-3 5-3v-4.518A9 9 0 0 0 12 0zm0 2c3.86 0 7 3.141 7 7s-3.14 7-7 7-7-3.141-7-7 3.14-7 7-7zM9 17.477c.94.332 1.946.523 3 .523s2.06-.19 3-.523v.834c-.91.436-1.925.689-3 .689a6.924 6.924 0 0 1-3-.69v-.833zm.236 3.07A8.854 8.854 0 0 0 12 21c.965 0 1.888-.167 2.758-.451C14.155 21.173 13.153 22 12 22c-1.102 0-2.117-.789-2.764-1.453z\"/><path d=\"M14.745 12.449h-.004c-.852-.024-1.188-.858-1.577-1.824-.421-1.061-.703-1.561-1.182-1.566h-.009c-.481 0-.783.497-1.235 1.537-.436.982-.801 1.811-1.636 1.791l-.276-.043c-.565-.171-.853-.691-1.284-1.794-.125-.313-.202-.632-.27-.913-.051-.213-.127-.53-.195-.634C7.067 9.004 7.039 9 6.99 9A1 1 0 0 1 7 7h.01c1.662.017 2.015 1.373 2.198 2.134.486-.981 1.304-2.058 2.797-2.075 1.531.018 2.28 1.153 2.731 2.141l.002-.008C14.944 8.424 15.327 7 16.979 7h.032A1 1 0 1 1 17 9h-.011c-.149.076-.256.474-.319.709a6.484 6.484 0 0 1-.311.951c-.429.973-.79 1.789-1.614 1.789\"/>",

	  people: "<path d=\"M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0m0 22C6.486 22 2 17.514 2 12S6.486 2 12 2s10 4.486 10 10-4.486 10-10 10\"/><path d=\"M8 7a2 2 0 1 0-.001 3.999A2 2 0 0 0 8 7M16 7a2 2 0 1 0-.001 3.999A2 2 0 0 0 16 7M15.232 15c-.693 1.195-1.87 2-3.349 2-1.477 0-2.655-.805-3.347-2H15m3-2H6a6 6 0 1 0 12 0\"/>",

	  places: "<path d=\"M6.5 12C5.122 12 4 13.121 4 14.5S5.122 17 6.5 17 9 15.879 9 14.5 7.878 12 6.5 12m0 3c-.275 0-.5-.225-.5-.5s.225-.5.5-.5.5.225.5.5-.225.5-.5.5M17.5 12c-1.378 0-2.5 1.121-2.5 2.5s1.122 2.5 2.5 2.5 2.5-1.121 2.5-2.5-1.122-2.5-2.5-2.5m0 3c-.275 0-.5-.225-.5-.5s.225-.5.5-.5.5.225.5.5-.225.5-.5.5\"/><path d=\"M22.482 9.494l-1.039-.346L21.4 9h.6c.552 0 1-.439 1-.992 0-.006-.003-.008-.003-.008H23c0-1-.889-2-1.984-2h-.642l-.731-1.717C19.262 3.012 18.091 2 16.764 2H7.236C5.909 2 4.738 3.012 4.357 4.283L3.626 6h-.642C1.889 6 1 7 1 8h.003S1 8.002 1 8.008C1 8.561 1.448 9 2 9h.6l-.043.148-1.039.346a2.001 2.001 0 0 0-1.359 2.097l.751 7.508a1 1 0 0 0 .994.901H3v1c0 1.103.896 2 2 2h2c1.104 0 2-.897 2-2v-1h6v1c0 1.103.896 2 2 2h2c1.104 0 2-.897 2-2v-1h1.096a.999.999 0 0 0 .994-.901l.751-7.508a2.001 2.001 0 0 0-1.359-2.097M6.273 4.857C6.402 4.43 6.788 4 7.236 4h9.527c.448 0 .834.43.963.857L19.313 9H4.688l1.585-4.143zM7 21H5v-1h2v1zm12 0h-2v-1h2v1zm2.189-3H2.811l-.662-6.607L3 11h18l.852.393L21.189 18z\"/>",

	  recent: "<path d=\"M13 4h-2l-.001 7H9v2h2v2h2v-2h4v-2h-4z\"/><path d=\"M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0m0 22C6.486 22 2 17.514 2 12S6.486 2 12 2s10 4.486 10 10-4.486 10-10 10\"/>",

	  symbols: "<path d=\"M0 0h11v2H0zM4 11h3V6h4V4H0v2h4zM15.5 17c1.381 0 2.5-1.116 2.5-2.493s-1.119-2.493-2.5-2.493S13 13.13 13 14.507 14.119 17 15.5 17m0-2.986c.276 0 .5.222.5.493 0 .272-.224.493-.5.493s-.5-.221-.5-.493.224-.493.5-.493M21.5 19.014c-1.381 0-2.5 1.116-2.5 2.493S20.119 24 21.5 24s2.5-1.116 2.5-2.493-1.119-2.493-2.5-2.493m0 2.986a.497.497 0 0 1-.5-.493c0-.271.224-.493.5-.493s.5.222.5.493a.497.497 0 0 1-.5.493M22 13l-9 9 1.513 1.5 8.99-9.009zM17 11c2.209 0 4-1.119 4-2.5V2s.985-.161 1.498.949C23.01 4.055 23 6 23 6s1-1.119 1-3.135C24-.02 21 0 21 0h-2v6.347A5.853 5.853 0 0 0 17 6c-2.209 0-4 1.119-4 2.5s1.791 2.5 4 2.5M10.297 20.482l-1.475-1.585a47.54 47.54 0 0 1-1.442 1.129c-.307-.288-.989-1.016-2.045-2.183.902-.836 1.479-1.466 1.729-1.892s.376-.871.376-1.336c0-.592-.273-1.178-.818-1.759-.546-.581-1.329-.871-2.349-.871-1.008 0-1.79.293-2.344.879-.556.587-.832 1.181-.832 1.784 0 .813.419 1.748 1.256 2.805-.847.614-1.444 1.208-1.794 1.784a3.465 3.465 0 0 0-.523 1.833c0 .857.308 1.56.924 2.107.616.549 1.423.823 2.42.823 1.173 0 2.444-.379 3.813-1.137L8.235 24h2.819l-2.09-2.383 1.333-1.135zm-6.736-6.389a1.02 1.02 0 0 1 .73-.286c.31 0 .559.085.747.254a.849.849 0 0 1 .283.659c0 .518-.419 1.112-1.257 1.784-.536-.651-.805-1.231-.805-1.742a.901.901 0 0 1 .302-.669M3.74 22c-.427 0-.778-.116-1.057-.349-.279-.232-.418-.487-.418-.766 0-.594.509-1.288 1.527-2.083.968 1.134 1.717 1.946 2.248 2.438-.921.507-1.686.76-2.3.76\"/>"
	};

	exports.default = SVGs;

	/***/ }),
	/* 74 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	var render = function() {
	  var _vm = this;
	  var _h = _vm.$createElement;
	  var _c = _vm._self._c || _h;
	  return _c(
	    "div",
	    { staticClass: "emoji-mart-anchors" },
	    _vm._l(_vm.categories, function(category) {
	      return _c(
	        "span",
	        {
	          key: category.id,
	          class: {
	            "emoji-mart-anchor": true,
	            "emoji-mart-anchor-selected": category.id == _vm.activeCategory.id
	          },
	          style: {
	            color: category.id == _vm.activeCategory.id ? _vm.color : ""
	          },
	          attrs: { title: _vm.i18n.categories[category.id] },
	          on: {
	            click: function($event) {
	              _vm.$emit("click", category);
	            }
	          }
	        },
	        [
	          _c("svg", {
	            attrs: {
	              xmlns: "http://www.w3.org/2000/svg",
	              viewBox: "0 0 24 24",
	              width: "24",
	              height: "24"
	            },
	            domProps: { innerHTML: _vm._s(_vm.svgs[category.id]) }
	          }),
	          _vm._v(" "),
	          _c("span", {
	            staticClass: "emoji-mart-anchor-bar",
	            style: { backgroundColor: _vm.color }
	          })
	        ]
	      )
	    })
	  )
	};
	var staticRenderFns = [];
	render._withStripped = true;
	var esExports = { render: render, staticRenderFns: staticRenderFns };
	/* harmony default export */ __webpack_exports__["a"] = (esExports);

	/***/ }),
	/* 75 */
	/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(76);
	if(typeof content === 'string') { content = [[module.i, content, '']]; }
	if(content.locals) { module.exports = content.locals; }
	// add the styles to the DOM
	var update = __webpack_require__(1)("098a12ee", content, false, {});

	/***/ }),
	/* 76 */
	/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(0)(false);
	// imports


	// module
	exports.push([module.i, "\n.emoji-mart-category[data-v-376cda0e] {\n  position: relative;\n}\n.emoji-mart-category-label[data-v-376cda0e] {\n  position: sticky;\n  top: 0;\n}\n.emoji-mart-category .emoji-mart-emoji[data-v-376cda0e]:before {\n  z-index: 0;\n  content: \"\";\n  position: absolute;\n  top: 0; left: 0;\n  width: 100%; height: 100%;\n  background-color: #f4f4f4;\n  border-radius: 100%;\n  opacity: 0;\n}\n.emoji-mart-category .emoji-mart-emoji[data-v-376cda0e]:hover:before {\n  opacity: 1;\n}\n.emoji-mart-category-label[data-v-376cda0e] {\n  z-index: 2;\n  position: relative;\n  position: -webkit-sticky;\n  position: sticky;\n  top: 0;\n}\n.emoji-mart-category-label span[data-v-376cda0e] {\n  display: block;\n  width: 100%;\n  font-weight: 500;\n  padding: 5px 6px;\n  background-color: #fff;\n  background-color: rgba(255, 255, 255, .95);\n}\n.emoji-mart-no-results[data-v-376cda0e] {\n  font-size: 14px;\n  text-align: center;\n  padding-top: 70px;\n  color: #858585;\n}\n.emoji-mart-no-results .emoji-mart-category-label[data-v-376cda0e] {\n  display: none;\n}\n.emoji-mart-no-results .emoji-mart-no-results-label[data-v-376cda0e] {\n  margin-top: .2em;\n}\n.emoji-mart-no-results .emoji-mart-emoji[data-v-376cda0e]:hover:before {\n  content: none;\n}\n\n", ""]);

	// exports


	/***/ }),
	/* 77 */
	/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(78);
	if(typeof content === 'string') { content = [[module.i, content, '']]; }
	if(content.locals) { module.exports = content.locals; }
	// add the styles to the DOM
	var update = __webpack_require__(1)("711019be", content, false, {});

	/***/ }),
	/* 78 */
	/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(0)(false);
	// imports


	// module
	exports.push([module.i, "\n.emoji-mart-category .emoji-mart-emoji span {\n  z-index: 1;\n  position: relative;\n  text-align: center;\n  cursor: default;\n}\n\n", ""]);

	// exports


	/***/ }),
	/* 79 */
	/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(80);
	if(typeof content === 'string') { content = [[module.i, content, '']]; }
	if(content.locals) { module.exports = content.locals; }
	// add the styles to the DOM
	var update = __webpack_require__(1)("72b7f778", content, false, {});

	/***/ }),
	/* 80 */
	/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(0)(false);
	// imports


	// module
	exports.push([module.i, "\n.emoji-mart-emoji[data-v-484e8d34] {\n  position: relative;\n  display: inline-block;\n  font-size: 0;\n}\n\n", ""]);

	// exports


	/***/ }),
	/* 81 */
	/***/ (function(module, exports, __webpack_require__) {
	Object.defineProperty(exports,"__esModule",{value:true});exports.default={categories:[{id:"people",name:"Smileys & People",emojis:["grinning","grin","joy","rolling_on_the_floor_laughing","smiley","smile","sweat_smile","laughing","wink","blush","yum","sunglasses","heart_eyes","kissing_heart","kissing","kissing_smiling_eyes","kissing_closed_eyes","relaxed","slightly_smiling_face","hugging_face","star-struck","thinking_face","face_with_raised_eyebrow","neutral_face","expressionless","no_mouth","face_with_rolling_eyes","smirk","persevere","disappointed_relieved","open_mouth","zipper_mouth_face","hushed","sleepy","tired_face","sleeping","relieved","stuck_out_tongue","stuck_out_tongue_winking_eye","stuck_out_tongue_closed_eyes","drooling_face","unamused","sweat","pensive","confused","upside_down_face","money_mouth_face","astonished","white_frowning_face","slightly_frowning_face","confounded","disappointed","worried","triumph","cry","sob","frowning","anguished","fearful","weary","exploding_head","grimacing","cold_sweat","scream","flushed","zany_face","dizzy_face","rage","angry","face_with_symbols_on_mouth","mask","face_with_thermometer","face_with_head_bandage","nauseated_face","face_vomiting","sneezing_face","innocent","face_with_cowboy_hat","clown_face","lying_face","shushing_face","face_with_hand_over_mouth","face_with_monocle","nerd_face","smiling_imp","imp","japanese_ogre","japanese_goblin","skull","skull_and_crossbones","ghost","alien","space_invader","robot_face","hankey","smiley_cat","smile_cat","joy_cat","heart_eyes_cat","smirk_cat","kissing_cat","scream_cat","crying_cat_face","pouting_cat","see_no_evil","hear_no_evil","speak_no_evil","baby","child","boy","girl","adult","man","woman","older_adult","older_man","older_woman","male-doctor","female-doctor","male-student","female-student","male-teacher","female-teacher","male-judge","female-judge","male-farmer","female-farmer","male-cook","female-cook","male-mechanic","female-mechanic","male-factory-worker","female-factory-worker","male-office-worker","female-office-worker","male-scientist","female-scientist","male-technologist","female-technologist","male-singer","female-singer","male-artist","female-artist","male-pilot","female-pilot","male-astronaut","female-astronaut","male-firefighter","female-firefighter","cop","male-police-officer","female-police-officer","sleuth_or_spy","male-detective","female-detective","guardsman","male-guard","female-guard","construction_worker","male-construction-worker","female-construction-worker","prince","princess","man_with_turban","man-wearing-turban","woman-wearing-turban","man_with_gua_pi_mao","person_with_headscarf","bearded_person","person_with_blond_hair","blond-haired-man","blond-haired-woman","man_in_tuxedo","bride_with_veil","pregnant_woman","breast-feeding","angel","santa","mrs_claus","mage","female_mage","male_mage","fairy","female_fairy","male_fairy","vampire","female_vampire","male_vampire","merperson","mermaid","merman","elf","female_elf","male_elf","genie","female_genie","male_genie","zombie","female_zombie","male_zombie","person_frowning","man-frowning","woman-frowning","person_with_pouting_face","man-pouting","woman-pouting","no_good","man-gesturing-no","woman-gesturing-no","ok_woman","man-gesturing-ok","woman-gesturing-ok","information_desk_person","man-tipping-hand","woman-tipping-hand","raising_hand","man-raising-hand","woman-raising-hand","bow","man-bowing","woman-bowing","face_palm","man-facepalming","woman-facepalming","shrug","man-shrugging","woman-shrugging","massage","man-getting-massage","woman-getting-massage","haircut","man-getting-haircut","woman-getting-haircut","walking","man-walking","woman-walking","runner","man-running","woman-running","dancer","man_dancing","dancers","man-with-bunny-ears-partying","woman-with-bunny-ears-partying","person_in_steamy_room","woman_in_steamy_room","man_in_steamy_room","person_climbing","woman_climbing","man_climbing","person_in_lotus_position","woman_in_lotus_position","man_in_lotus_position","bath","sleeping_accommodation","man_in_business_suit_levitating","speaking_head_in_silhouette","bust_in_silhouette","busts_in_silhouette","fencer","horse_racing","skier","snowboarder","golfer","man-golfing","woman-golfing","surfer","man-surfing","woman-surfing","rowboat","man-rowing-boat","woman-rowing-boat","swimmer","man-swimming","woman-swimming","person_with_ball","man-bouncing-ball","woman-bouncing-ball","weight_lifter","man-lifting-weights","woman-lifting-weights","bicyclist","man-biking","woman-biking","mountain_bicyclist","man-mountain-biking","woman-mountain-biking","racing_car","racing_motorcycle","person_doing_cartwheel","man-cartwheeling","woman-cartwheeling","wrestlers","man-wrestling","woman-wrestling","water_polo","man-playing-water-polo","woman-playing-water-polo","handball","man-playing-handball","woman-playing-handball","juggling","man-juggling","woman-juggling","couple","two_men_holding_hands","two_women_holding_hands","couplekiss","woman-kiss-man","man-kiss-man","woman-kiss-woman","couple_with_heart","woman-heart-man","man-heart-man","woman-heart-woman","family","man-woman-boy","man-woman-girl","man-woman-girl-boy","man-woman-boy-boy","man-woman-girl-girl","man-man-boy","man-man-girl","man-man-girl-boy","man-man-boy-boy","man-man-girl-girl","woman-woman-boy","woman-woman-girl","woman-woman-girl-boy","woman-woman-boy-boy","woman-woman-girl-girl","man-boy","man-boy-boy","man-girl","man-girl-boy","man-girl-girl","woman-boy","woman-boy-boy","woman-girl","woman-girl-boy","woman-girl-girl","selfie","muscle","point_left","point_right","point_up","point_up_2","middle_finger","point_down","v","crossed_fingers","spock-hand","the_horns","call_me_hand","raised_hand_with_fingers_splayed","hand","ok_hand","+1","-1","fist","facepunch","left-facing_fist","right-facing_fist","raised_back_of_hand","wave","i_love_you_hand_sign","writing_hand","clap","open_hands","raised_hands","palms_up_together","pray","handshake","nail_care","ear","nose","footprints","eyes","eye","eye-in-speech-bubble","brain","tongue","lips","kiss","cupid","heart","heartbeat","broken_heart","two_hearts","sparkling_heart","heartpulse","blue_heart","green_heart","yellow_heart","orange_heart","purple_heart","black_heart","gift_heart","revolving_hearts","heart_decoration","heavy_heart_exclamation_mark_ornament","love_letter","zzz","anger","bomb","boom","sweat_drops","dash","dizzy","speech_balloon","left_speech_bubble","right_anger_bubble","thought_balloon","hole","eyeglasses","dark_sunglasses","necktie","shirt","jeans","scarf","gloves","coat","socks","dress","kimono","bikini","womans_clothes","purse","handbag","pouch","shopping_bags","school_satchel","mans_shoe","athletic_shoe","high_heel","sandal","boot","crown","womans_hat","tophat","mortar_board","billed_cap","helmet_with_white_cross","prayer_beads","lipstick","ring","gem"]},{id:"nature",name:"Animals & Nature",emojis:["monkey_face","monkey","gorilla","dog","dog2","poodle","wolf","fox_face","cat","cat2","lion_face","tiger","tiger2","leopard","horse","racehorse","unicorn_face","zebra_face","deer","cow","ox","water_buffalo","cow2","pig","pig2","boar","pig_nose","ram","sheep","goat","dromedary_camel","camel","giraffe_face","elephant","rhinoceros","mouse","mouse2","rat","hamster","rabbit","rabbit2","chipmunk","hedgehog","bat","bear","koala","panda_face","feet","turkey","chicken","rooster","hatching_chick","baby_chick","hatched_chick","bird","penguin","dove_of_peace","eagle","duck","owl","frog","crocodile","turtle","lizard","snake","dragon_face","dragon","sauropod","t-rex","whale","whale2","dolphin","fish","tropical_fish","blowfish","shark","octopus","shell","crab","shrimp","squid","snail","butterfly","bug","ant","bee","beetle","cricket","spider","spider_web","scorpion","bouquet","cherry_blossom","white_flower","rosette","rose","wilted_flower","hibiscus","sunflower","blossom","tulip","seedling","evergreen_tree","deciduous_tree","palm_tree","cactus","ear_of_rice","herb","shamrock","four_leaf_clover","maple_leaf","fallen_leaf","leaves"]},{id:"foods",name:"Food & Drink",emojis:["grapes","melon","watermelon","tangerine","lemon","banana","pineapple","apple","green_apple","pear","peach","cherries","strawberry","kiwifruit","tomato","coconut","avocado","eggplant","potato","carrot","corn","hot_pepper","cucumber","broccoli","mushroom","peanuts","chestnut","bread","croissant","baguette_bread","pretzel","pancakes","cheese_wedge","meat_on_bone","poultry_leg","cut_of_meat","bacon","hamburger","fries","pizza","hotdog","sandwich","taco","burrito","stuffed_flatbread","egg","fried_egg","shallow_pan_of_food","stew","bowl_with_spoon","green_salad","popcorn","canned_food","bento","rice_cracker","rice_ball","rice","curry","ramen","spaghetti","sweet_potato","oden","sushi","fried_shrimp","fish_cake","dango","dumpling","fortune_cookie","takeout_box","icecream","shaved_ice","ice_cream","doughnut","cookie","birthday","cake","pie","chocolate_bar","candy","lollipop","custard","honey_pot","baby_bottle","glass_of_milk","coffee","tea","sake","champagne","wine_glass","cocktail","tropical_drink","beer","beers","clinking_glasses","tumbler_glass","cup_with_straw","chopsticks","knife_fork_plate","fork_and_knife","spoon","hocho","amphora"]},{id:"activity",name:"Activities",emojis:["jack_o_lantern","christmas_tree","fireworks","sparkler","sparkles","balloon","tada","confetti_ball","tanabata_tree","bamboo","dolls","flags","wind_chime","rice_scene","ribbon","gift","reminder_ribbon","admission_tickets","ticket","medal","trophy","sports_medal","first_place_medal","second_place_medal","third_place_medal","soccer","baseball","basketball","volleyball","football","rugby_football","tennis","8ball","bowling","cricket_bat_and_ball","field_hockey_stick_and_ball","ice_hockey_stick_and_puck","table_tennis_paddle_and_ball","badminton_racquet_and_shuttlecock","boxing_glove","martial_arts_uniform","goal_net","dart","golf","ice_skate","fishing_pole_and_fish","running_shirt_with_sash","ski","sled","curling_stone","video_game","joystick","game_die","spades","hearts","diamonds","clubs","black_joker","mahjong","flower_playing_cards"]},{id:"places",name:"Travel & Places",emojis:["earth_africa","earth_americas","earth_asia","globe_with_meridians","world_map","japan","snow_capped_mountain","mountain","volcano","mount_fuji","camping","beach_with_umbrella","desert","desert_island","national_park","stadium","classical_building","building_construction","house_buildings","cityscape","derelict_house_building","house","house_with_garden","office","post_office","european_post_office","hospital","bank","hotel","love_hotel","convenience_store","school","department_store","factory","japanese_castle","european_castle","wedding","tokyo_tower","statue_of_liberty","church","mosque","synagogue","shinto_shrine","kaaba","fountain","tent","foggy","night_with_stars","sunrise_over_mountains","sunrise","city_sunset","city_sunrise","bridge_at_night","hotsprings","milky_way","carousel_horse","ferris_wheel","roller_coaster","barber","circus_tent","performing_arts","frame_with_picture","art","slot_machine","steam_locomotive","railway_car","bullettrain_side","bullettrain_front","train2","metro","light_rail","station","tram","monorail","mountain_railway","train","bus","oncoming_bus","trolleybus","minibus","ambulance","fire_engine","police_car","oncoming_police_car","taxi","oncoming_taxi","car","oncoming_automobile","blue_car","truck","articulated_lorry","tractor","bike","scooter","motor_scooter","busstop","motorway","railway_track","fuelpump","rotating_light","traffic_light","vertical_traffic_light","construction","octagonal_sign","anchor","boat","canoe","speedboat","passenger_ship","ferry","motor_boat","ship","airplane","small_airplane","airplane_departure","airplane_arriving","seat","helicopter","suspension_railway","mountain_cableway","aerial_tramway","satellite","rocket","flying_saucer","bellhop_bell","door","bed","couch_and_lamp","toilet","shower","bathtub","hourglass","hourglass_flowing_sand","watch","alarm_clock","stopwatch","timer_clock","mantelpiece_clock","clock12","clock1230","clock1","clock130","clock2","clock230","clock3","clock330","clock4","clock430","clock5","clock530","clock6","clock630","clock7","clock730","clock8","clock830","clock9","clock930","clock10","clock1030","clock11","clock1130","new_moon","waxing_crescent_moon","first_quarter_moon","moon","full_moon","waning_gibbous_moon","last_quarter_moon","waning_crescent_moon","crescent_moon","new_moon_with_face","first_quarter_moon_with_face","last_quarter_moon_with_face","thermometer","sunny","full_moon_with_face","sun_with_face","star","star2","stars","cloud","partly_sunny","thunder_cloud_and_rain","mostly_sunny","barely_sunny","partly_sunny_rain","rain_cloud","snow_cloud","lightning","tornado","fog","wind_blowing_face","cyclone","rainbow","closed_umbrella","umbrella","umbrella_with_rain_drops","umbrella_on_ground","zap","snowflake","snowman","snowman_without_snow","comet","fire","droplet","ocean"]},{id:"objects",name:"Objects",emojis:["mute","speaker","sound","loud_sound","loudspeaker","mega","postal_horn","bell","no_bell","musical_score","musical_note","notes","studio_microphone","level_slider","control_knobs","microphone","headphones","radio","saxophone","guitar","musical_keyboard","trumpet","violin","drum_with_drumsticks","iphone","calling","phone","telephone_receiver","pager","fax","battery","electric_plug","computer","desktop_computer","printer","keyboard","three_button_mouse","trackball","minidisc","floppy_disk","cd","dvd","movie_camera","film_frames","film_projector","clapper","tv","camera","camera_with_flash","video_camera","vhs","mag","mag_right","microscope","telescope","satellite_antenna","candle","bulb","flashlight","izakaya_lantern","notebook_with_decorative_cover","closed_book","book","green_book","blue_book","orange_book","books","notebook","ledger","page_with_curl","scroll","page_facing_up","newspaper","rolled_up_newspaper","bookmark_tabs","bookmark","label","moneybag","yen","dollar","euro","pound","money_with_wings","credit_card","chart","currency_exchange","heavy_dollar_sign","email","e-mail","incoming_envelope","envelope_with_arrow","outbox_tray","inbox_tray","package","mailbox","mailbox_closed","mailbox_with_mail","mailbox_with_no_mail","postbox","ballot_box_with_ballot","pencil2","black_nib","lower_left_fountain_pen","lower_left_ballpoint_pen","lower_left_paintbrush","lower_left_crayon","memo","briefcase","file_folder","open_file_folder","card_index_dividers","date","calendar","spiral_note_pad","spiral_calendar_pad","card_index","chart_with_upwards_trend","chart_with_downwards_trend","bar_chart","clipboard","pushpin","round_pushpin","paperclip","linked_paperclips","straight_ruler","triangular_ruler","scissors","card_file_box","file_cabinet","wastebasket","lock","unlock","lock_with_ink_pen","closed_lock_with_key","key","old_key","hammer","pick","hammer_and_pick","hammer_and_wrench","dagger_knife","crossed_swords","gun","bow_and_arrow","shield","wrench","nut_and_bolt","gear","compression","alembic","scales","link","chains","syringe","pill","smoking","coffin","funeral_urn","moyai","oil_drum","crystal_ball","shopping_trolley"]},{id:"symbols",name:"Symbols",emojis:["atm","put_litter_in_its_place","potable_water","wheelchair","mens","womens","restroom","baby_symbol","wc","passport_control","customs","baggage_claim","left_luggage","warning","children_crossing","no_entry","no_entry_sign","no_bicycles","no_smoking","do_not_litter","non-potable_water","no_pedestrians","no_mobile_phones","underage","radioactive_sign","biohazard_sign","arrow_up","arrow_upper_right","arrow_right","arrow_lower_right","arrow_down","arrow_lower_left","arrow_left","arrow_upper_left","arrow_up_down","left_right_arrow","leftwards_arrow_with_hook","arrow_right_hook","arrow_heading_up","arrow_heading_down","arrows_clockwise","arrows_counterclockwise","back","end","on","soon","top","place_of_worship","atom_symbol","om_symbol","star_of_david","wheel_of_dharma","yin_yang","latin_cross","orthodox_cross","star_and_crescent","peace_symbol","menorah_with_nine_branches","six_pointed_star","aries","taurus","gemini","cancer","leo","virgo","libra","scorpius","sagittarius","capricorn","aquarius","pisces","ophiuchus","twisted_rightwards_arrows","repeat","repeat_one","arrow_forward","fast_forward","black_right_pointing_double_triangle_with_vertical_bar","black_right_pointing_triangle_with_double_vertical_bar","arrow_backward","rewind","black_left_pointing_double_triangle_with_vertical_bar","arrow_up_small","arrow_double_up","arrow_down_small","arrow_double_down","double_vertical_bar","black_square_for_stop","black_circle_for_record","eject","cinema","low_brightness","high_brightness","signal_strength","vibration_mode","mobile_phone_off","female_sign","male_sign","medical_symbol","recycle","fleur_de_lis","trident","name_badge","beginner","o","white_check_mark","ballot_box_with_check","heavy_check_mark","heavy_multiplication_x","x","negative_squared_cross_mark","heavy_plus_sign","heavy_minus_sign","heavy_division_sign","curly_loop","loop","part_alternation_mark","eight_spoked_asterisk","eight_pointed_black_star","sparkle","bangbang","interrobang","question","grey_question","grey_exclamation","exclamation","wavy_dash","copyright","registered","tm","hash","keycap_star","zero","one","two","three","four","five","six","seven","eight","nine","keycap_ten","100","capital_abcd","abcd","1234","symbols","abc","a","ab","b","cl","cool","free","information_source","id","m","new","ng","o2","ok","parking","sos","up","vs","koko","sa","u6708","u6709","u6307","ideograph_advantage","u5272","u7121","u7981","accept","u7533","u5408","u7a7a","congratulations","secret","u55b6","u6e80","black_small_square","white_small_square","white_medium_square","black_medium_square","white_medium_small_square","black_medium_small_square","black_large_square","white_large_square","large_orange_diamond","large_blue_diamond","small_orange_diamond","small_blue_diamond","small_red_triangle","small_red_triangle_down","diamond_shape_with_a_dot_inside","radio_button","black_square_button","white_square_button","white_circle","black_circle","red_circle","large_blue_circle"]},{id:"flags",name:"Flags",emojis:["checkered_flag","cn","crossed_flags","de","es","flag-ac","flag-ad","flag-ae","flag-af","flag-ag","flag-ai","flag-al","flag-am","flag-ao","flag-aq","flag-ar","flag-as","flag-at","flag-au","flag-aw","flag-ax","flag-az","flag-ba","flag-bb","flag-bd","flag-be","flag-bf","flag-bg","flag-bh","flag-bi","flag-bj","flag-bl","flag-bm","flag-bn","flag-bo","flag-bq","flag-br","flag-bs","flag-bt","flag-bv","flag-bw","flag-by","flag-bz","flag-ca","flag-cc","flag-cd","flag-cf","flag-cg","flag-ch","flag-ci","flag-ck","flag-cl","flag-cm","flag-co","flag-cp","flag-cr","flag-cu","flag-cv","flag-cw","flag-cx","flag-cy","flag-cz","flag-dg","flag-dj","flag-dk","flag-dm","flag-do","flag-dz","flag-ea","flag-ec","flag-ee","flag-eg","flag-eh","flag-england","flag-er","flag-et","flag-eu","flag-fi","flag-fj","flag-fk","flag-fm","flag-fo","flag-ga","flag-gd","flag-ge","flag-gf","flag-gg","flag-gh","flag-gi","flag-gl","flag-gm","flag-gn","flag-gp","flag-gq","flag-gr","flag-gs","flag-gt","flag-gu","flag-gw","flag-gy","flag-hk","flag-hm","flag-hn","flag-hr","flag-ht","flag-hu","flag-ic","flag-id","flag-ie","flag-il","flag-im","flag-in","flag-io","flag-iq","flag-ir","flag-is","flag-je","flag-jm","flag-jo","flag-ke","flag-kg","flag-kh","flag-ki","flag-km","flag-kn","flag-kp","flag-kw","flag-ky","flag-kz","flag-la","flag-lb","flag-lc","flag-li","flag-lk","flag-lr","flag-ls","flag-lt","flag-lu","flag-lv","flag-ly","flag-ma","flag-mc","flag-md","flag-me","flag-mf","flag-mg","flag-mh","flag-mk","flag-ml","flag-mm","flag-mn","flag-mo","flag-mp","flag-mq","flag-mr","flag-ms","flag-mt","flag-mu","flag-mv","flag-mw","flag-mx","flag-my","flag-mz","flag-na","flag-nc","flag-ne","flag-nf","flag-ng","flag-ni","flag-nl","flag-no","flag-np","flag-nr","flag-nu","flag-nz","flag-om","flag-pa","flag-pe","flag-pf","flag-pg","flag-ph","flag-pk","flag-pl","flag-pm","flag-pn","flag-pr","flag-ps","flag-pt","flag-pw","flag-py","flag-qa","flag-re","flag-ro","flag-rs","flag-rw","flag-sa","flag-sb","flag-sc","flag-scotland","flag-sd","flag-se","flag-sg","flag-sh","flag-si","flag-sj","flag-sk","flag-sl","flag-sm","flag-sn","flag-so","flag-sr","flag-ss","flag-st","flag-sv","flag-sx","flag-sy","flag-sz","flag-ta","flag-tc","flag-td","flag-tf","flag-tg","flag-th","flag-tj","flag-tk","flag-tl","flag-tm","flag-tn","flag-to","flag-tr","flag-tt","flag-tv","flag-tw","flag-tz","flag-ua","flag-ug","flag-um","flag-uy","flag-uz","flag-va","flag-vc","flag-ve","flag-vg","flag-vi","flag-vn","flag-vu","flag-wales","flag-wf","flag-ws","flag-xk","flag-ye","flag-yt","flag-za","flag-zm","flag-zw","fr","gb","it","jp","kr","rainbow-flag","ru","triangular_flag_on_post","us","waving_black_flag","waving_white_flag"]}],emojis:{"100":{name:"Hundred Points Symbol",unified:"1F4AF",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["score","perfect","numbers","century","exam","quiz","test","pass","hundred"],sheet:[25,26]},"1234":{name:"Input Symbol for Numbers",unified:"1F522",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["numbers","blue-square"],sheet:[27,36]},monkey_face:{name:"Monkey Face",unified:"1F435",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,emoticons:[":o)"],keywords:["animal","nature","circus"],sheet:[13,31]},grinning:{name:"Grinning Face",unified:"1F600",non_qualified:null,text:":D",added_in:"6.1",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["face","smile","happy","joy",":D","grin"],sheet:[30,24]},earth_africa:{name:"Earth Globe Europe-Africa",unified:"1F30D",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["globe","world","international"],sheet:[6,5]},checkered_flag:{name:"Chequered Flag",unified:"1F3C1",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["contest","finishline","race","gokart"],sheet:[9,27]},mute:{name:"Speaker with Cancellation Stroke",unified:"1F507",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["sound","volume","silence","quiet"],sheet:[27,9]},jack_o_lantern:{name:"Jack-O-Lantern",unified:"1F383",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["halloween","light","pumpkin","creepy","fall"],sheet:[8,17]},atm:{name:"Automated Teller Machine",unified:"1F3E7",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["money","sales","cash","blue-square","payment","bank"],sheet:[12,4]},grapes:{name:"Grapes",unified:"1F347",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["fruit","food","wine"],sheet:[7,9]},earth_americas:{name:"Earth Globe Americas",unified:"1F30E",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["globe","world","USA","international"],sheet:[6,6]},grin:{name:"Grinning Face with Smiling Eyes",unified:"1F601",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["face","happy","smile","joy","kawaii"],sheet:[30,25]},melon:{name:"Melon",unified:"1F348",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["fruit","nature","food"],sheet:[7,10]},triangular_flag_on_post:{name:"Triangular Flag on Post",unified:"1F6A9",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["mark","milestone","place"],sheet:[35,14]},monkey:{name:"Monkey",unified:"1F412",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["animal","nature","banana","circus"],sheet:[12,48]},christmas_tree:{name:"Christmas Tree",unified:"1F384",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["festival","vacation","december","xmas","celebration"],sheet:[8,18]},put_litter_in_its_place:{name:"Put Litter in Its Place Symbol",unified:"1F6AE",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["blue-square","sign","human","info"],sheet:[35,19]},speaker:{name:"Speaker",unified:"1F508",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["sound","volume","silence","broadcast"],sheet:[27,10]},earth_asia:{name:"Earth Globe Asia-Australia",unified:"1F30F",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["globe","world","east","international"],sheet:[6,7]},crossed_flags:{name:"Crossed Flags",unified:"1F38C",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["japanese","nation","country","border"],sheet:[8,31]},joy:{name:"Face with Tears of Joy",unified:"1F602",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["face","cry","tears","weep","happy","happytears","haha"],sheet:[30,26]},sound:{name:"Speaker with One Sound Wave",unified:"1F509",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["volume","speaker","broadcast"],sheet:[27,11]},watermelon:{name:"Watermelon",unified:"1F349",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["fruit","food","picnic","summer"],sheet:[7,11]},gorilla:{name:"Gorilla",unified:"1F98D",non_qualified:null,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false,keywords:["animal","nature","circus"],sheet:[42,37]},fireworks:{name:"Fireworks",unified:"1F386",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["photo","festival","carnival","congratulations"],sheet:[8,25]},potable_water:{name:"Potable Water Symbol",unified:"1F6B0",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["blue-square","liquid","restroom","cleaning","faucet"],sheet:[35,21]},wheelchair:{name:"Wheelchair Symbol",unified:"267F",non_qualified:null,added_in:"4.1",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["blue-square","disabled","a11y","accessibility"],sheet:[48,10]},rolling_on_the_floor_laughing:{name:"Rolling on the Floor Laughing",unified:"1F923",non_qualified:null,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false,sheet:[38,26]},loud_sound:{name:"Speaker with Three Sound Waves",unified:"1F50A",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["volume","noise","noisy","speaker","broadcast"],sheet:[27,12]},waving_black_flag:{name:"Waving Black Flag",unified:"1F3F4",non_qualified:null,added_in:"7.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false,sheet:[12,19]},tangerine:{name:"Tangerine",unified:"1F34A",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["food","fruit","nature","orange"],sheet:[7,12]},dog:{name:"Dog Face",unified:"1F436",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["animal","friend","nature","woof","puppy","pet","faithful"],sheet:[13,32]},sparkler:{name:"Firework Sparkler",unified:"1F387",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["stars","night","shine"],sheet:[8,26]},globe_with_meridians:{name:"Globe with Meridians",unified:"1F310",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["earth","international","world","internet","interweb","i18n"],sheet:[6,8]},smiley:{name:"Smiling Face with Open Mouth",unified:"1F603",non_qualified:null,text:":)",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,emoticons:["=)","=-)"],keywords:["face","happy","joy","haha",":D",":)","smile","funny"],sheet:[30,27]},loudspeaker:{name:"Public Address Loudspeaker",unified:"1F4E2",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["volume","sound"],sheet:[26,25]},sparkles:{name:"Sparkles",unified:"2728",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["stars","shine","shiny","cool","awesome","good","magic"],sheet:[49,48]},"dog2":{name:"Dog",unified:"1F415",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["animal","nature","friend","doge","pet","faithful"],sheet:[12,51]},waving_white_flag:{name:"Waving White Flag",unified:"1F3F3-FE0F",non_qualified:"1F3F3",added_in:"7.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,sheet:[12,15]},world_map:{name:"World Map",unified:"1F5FA-FE0F",non_qualified:"1F5FA",added_in:"7.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,keywords:["location","direction"],sheet:[30,18]},lemon:{name:"Lemon",unified:"1F34B",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["fruit","nature"],sheet:[7,13]},mens:{name:"Mens Symbol",unified:"1F6B9",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["toilet","restroom","wc","blue-square","gender","male"],sheet:[36,29]},womens:{name:"Womens Symbol",unified:"1F6BA",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["purple-square","woman","female","toilet","loo","restroom","gender"],sheet:[36,30]},"rainbow-flag":{name:"Rainbow Flag",unified:"1F3F3-FE0F-200D-1F308",non_qualified:"1F3F3-200D-1F308",added_in:"7.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:true,sheet:[12,14]},smile:{name:"Smiling Face with Open Mouth and Smiling Eyes",unified:"1F604",non_qualified:null,text:":)",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,emoticons:["C:","c:",":D",":-D"],keywords:["face","happy","joy","funny","haha","laugh","like",":D",":)"],sheet:[30,28]},banana:{name:"Banana",unified:"1F34C",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["fruit","food","monkey"],sheet:[7,14]},mega:{name:"Cheering Megaphone",unified:"1F4E3",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["sound","speaker","volume"],sheet:[26,26]},japan:{name:"Silhouette of Japan",unified:"1F5FE",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["nation","country","japanese","asia"],sheet:[30,22]},poodle:{name:"Poodle",unified:"1F429",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["dog","animal","101","nature","pet"],sheet:[13,19]},balloon:{name:"Balloon",unified:"1F388",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["party","celebration","birthday","circus"],sheet:[8,27]},"flag-ac":{name:"Ascension Island Flag",unified:"1F1E6-1F1E8",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[0,31]},sweat_smile:{name:"Smiling Face with Open Mouth and Cold Sweat",unified:"1F605",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["face","hot","happy","laugh","sweat","smile","relief"],sheet:[30,29]},pineapple:{name:"Pineapple",unified:"1F34D",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["fruit","nature","food"],sheet:[7,15]},restroom:{name:"Restroom",unified:"1F6BB",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["blue-square","toilet","refresh","wc","gender"],sheet:[36,31]},postal_horn:{name:"Postal Horn",unified:"1F4EF",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["instrument","music"],sheet:[26,38]},wolf:{name:"Wolf Face",unified:"1F43A",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["animal","nature","wild"],sheet:[13,36]},tada:{name:"Party Popper",unified:"1F389",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["party","congratulations","birthday","magic","circus","celebration"],sheet:[8,28]},snow_capped_mountain:{name:"Snow Capped Mountain",unified:"1F3D4-FE0F",non_qualified:"1F3D4",added_in:"7.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,sheet:[11,37]},laughing:{name:"Smiling Face with Open Mouth and Tightly-Closed Eyes",unified:"1F606",non_qualified:null,short_names:["satisfied"],has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,emoticons:[":>",":->"],keywords:["happy","joy","lol","satisfied","haha","face","glad","XD","laugh"],sheet:[30,30]},apple:{name:"Red Apple",unified:"1F34E",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["fruit","mac","school"],sheet:[7,16]},"flag-ad":{name:"Andorra Flag",unified:"1F1E6-1F1E9",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[0,32]},fox_face:{name:"Fox Face",unified:"1F98A",non_qualified:null,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false,keywords:["animal","nature","face"],sheet:[42,34]},confetti_ball:{name:"Confetti Ball",unified:"1F38A",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["festival","party","birthday","circus"],sheet:[8,29]},bell:{name:"Bell",unified:"1F514",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["sound","notification","christmas","xmas","chime"],sheet:[27,22]},mountain:{name:"Mountain",unified:"26F0-FE0F",non_qualified:"26F0",added_in:"5.2",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,keywords:["photo","nature","environment"],sheet:[48,38]},baby_symbol:{name:"Baby Symbol",unified:"1F6BC",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["orange-square","child"],sheet:[36,32]},wc:{name:"Water Closet",unified:"1F6BE",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["toilet","restroom","blue-square"],sheet:[36,34]},wink:{name:"Winking Face",unified:"1F609",non_qualified:null,text:";)",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,emoticons:[";)",";-)"],keywords:["face","happy","mischievous","secret",";)","smile","eye"],sheet:[30,33]},no_bell:{name:"Bell with Cancellation Stroke",unified:"1F515",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["sound","volume","mute","quiet","silent"],sheet:[27,23]},green_apple:{name:"Green Apple",unified:"1F34F",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["fruit","nature"],sheet:[7,17]},tanabata_tree:{name:"Tanabata Tree",unified:"1F38B",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["plant","nature","branch","summer"],sheet:[8,30]},"flag-ae":{name:"United Arab Emirates Flag",unified:"1F1E6-1F1EA",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[0,33]},volcano:{name:"Volcano",unified:"1F30B",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["photo","nature","disaster"],sheet:[6,3]},cat:{name:"Cat Face",unified:"1F431",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["animal","meow","nature","pet","kitten"],sheet:[13,27]},"flag-af":{name:"Afghanistan Flag",unified:"1F1E6-1F1EB",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[0,34]},musical_score:{name:"Musical Score",unified:"1F3BC",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["treble","clef","compose"],sheet:[9,22]},blush:{name:"Smiling Face with Smiling Eyes",unified:"1F60A",non_qualified:null,text:":)",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["face","smile","happy","flushed","crush","embarrassed","shy","joy"],sheet:[30,34]},pear:{name:"Pear",unified:"1F350",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["fruit","nature","food"],sheet:[7,18]},bamboo:{name:"Pine Decoration",unified:"1F38D",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["plant","nature","vegetable","panda","pine_decoration"],sheet:[8,32]},passport_control:{name:"Passport Control",unified:"1F6C2",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["custom","blue-square"],sheet:[36,43]},mount_fuji:{name:"Mount Fuji",unified:"1F5FB",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["photo","mountain","nature","japanese"],sheet:[30,19]},"cat2":{name:"Cat",unified:"1F408",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["animal","meow","pet","cats"],sheet:[12,38]},musical_note:{name:"Musical Note",unified:"1F3B5",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["score","tone","sound"],sheet:[9,15]},dolls:{name:"Japanese Dolls",unified:"1F38E",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["japanese","toy","kimono"],sheet:[8,33]},lion_face:{name:"Lion Face",unified:"1F981",non_qualified:null,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false,sheet:[42,25]},camping:{name:"Camping",unified:"1F3D5-FE0F",non_qualified:"1F3D5",added_in:"7.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,keywords:["photo","outdoors","tent"],sheet:[11,38]},"flag-ag":{name:"Antigua & Barbuda Flag",unified:"1F1E6-1F1EC",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[0,35]},customs:{name:"Customs",unified:"1F6C3",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["passport","border","blue-square"],sheet:[36,44]},yum:{name:"Face Savouring Delicious Food",unified:"1F60B",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["happy","joy","tongue","smile","face","silly","yummy","nom","delicious","savouring"],sheet:[30,35]},peach:{name:"Peach",unified:"1F351",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["fruit","nature","food"],sheet:[7,19]},tiger:{name:"Tiger Face",unified:"1F42F",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["animal","cat","danger","wild","nature","roar"],sheet:[13,25]},notes:{name:"Multiple Musical Notes",unified:"1F3B6",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["music","score"],sheet:[9,16]},flags:{name:"Carp Streamer",unified:"1F38F",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["fish","japanese","koinobori","carp","banner"],sheet:[8,34]},beach_with_umbrella:{name:"Beach with Umbrella",unified:"1F3D6-FE0F",non_qualified:"1F3D6",added_in:"7.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,sheet:[11,39]},cherries:{name:"Cherries",unified:"1F352",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["food","fruit"],sheet:[7,20]},"flag-ai":{name:"Anguilla Flag",unified:"1F1E6-1F1EE",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[0,36]},baggage_claim:{name:"Baggage Claim",unified:"1F6C4",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["blue-square","airport","transport"],sheet:[36,45]},sunglasses:{name:"Smiling Face with Sunglasses",unified:"1F60E",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,emoticons:["8)"],keywords:["face","cool","smile","summer","beach","sunglass"],sheet:[30,38]},left_luggage:{name:"Left Luggage",unified:"1F6C5",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["blue-square","travel"],sheet:[36,46]},wind_chime:{name:"Wind Chime",unified:"1F390",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["nature","ding","spring","bell"],sheet:[8,35]},strawberry:{name:"Strawberry",unified:"1F353",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["fruit","food","nature"],sheet:[7,21]},desert:{name:"Desert",unified:"1F3DC-FE0F",non_qualified:"1F3DC",added_in:"7.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,keywords:["photo","warm","saharah"],sheet:[11,45]},studio_microphone:{name:"Studio Microphone",unified:"1F399-FE0F",non_qualified:"1F399",added_in:"7.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,keywords:["sing","recording","artist","talkshow"],sheet:[8,41]},"flag-al":{name:"Albania Flag",unified:"1F1E6-1F1F1",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[0,37]},"tiger2":{name:"Tiger",unified:"1F405",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["animal","nature","roar"],sheet:[12,35]},heart_eyes:{name:"Smiling Face with Heart-Shaped Eyes",unified:"1F60D",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["face","love","like","affection","valentines","infatuation","crush","heart"],sheet:[30,37]},desert_island:{name:"Desert Island",unified:"1F3DD-FE0F",non_qualified:"1F3DD",added_in:"7.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,keywords:["photo","tropical","mojito"],sheet:[11,46]},kiwifruit:{name:"Kiwifruit",unified:"1F95D",non_qualified:null,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false,sheet:[42,9]},rice_scene:{name:"Moon Viewing Ceremony",unified:"1F391",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["photo","japan","asia","tsukimi"],sheet:[8,36]},kissing_heart:{name:"Face Throwing a Kiss",unified:"1F618",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,emoticons:[":*",":-*"],keywords:["face","love","like","affection","valentines","infatuation","kiss"],sheet:[30,48]},warning:{name:"Warning Sign",unified:"26A0-FE0F",non_qualified:"26A0",added_in:"4.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:true,keywords:["exclamation","wip","alert","error","problem","issue"],sheet:[48,20]},"flag-am":{name:"Armenia Flag",unified:"1F1E6-1F1F2",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[0,38]},leopard:{name:"Leopard",unified:"1F406",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["animal","nature"],sheet:[12,36]},level_slider:{name:"Level Slider",unified:"1F39A-FE0F",non_qualified:"1F39A",added_in:"7.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,keywords:["scale"],sheet:[8,42]},horse:{name:"Horse Face",unified:"1F434",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["animal","brown","nature"],sheet:[13,30]},children_crossing:{name:"Children Crossing",unified:"1F6B8",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["school","warning","danger","sign","driving","yellow-diamond"],sheet:[36,28]},ribbon:{name:"Ribbon",unified:"1F380",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["decoration","pink","girl","bowtie"],sheet:[8,14]},national_park:{name:"National Park",unified:"1F3DE-FE0F",non_qualified:"1F3DE",added_in:"7.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,keywords:["photo","environment","nature"],sheet:[11,47]},control_knobs:{name:"Control Knobs",unified:"1F39B-FE0F",non_qualified:"1F39B",added_in:"7.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,keywords:["dial"],sheet:[8,43]},kissing:{name:"Kissing Face",unified:"1F617",non_qualified:null,added_in:"6.1",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["love","like","face","3","valentines","infatuation","kiss"],sheet:[30,47]},tomato:{name:"Tomato",unified:"1F345",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["fruit","vegetable","nature","food"],sheet:[7,7]},"flag-ao":{name:"Angola Flag",unified:"1F1E6-1F1F4",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[0,39]},stadium:{name:"Stadium",unified:"1F3DF-FE0F",non_qualified:"1F3DF",added_in:"7.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,keywords:["photo","place","sports","concert","venue"],sheet:[11,48]},"flag-aq":{name:"Antarctica Flag",unified:"1F1E6-1F1F6",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[0,40]},gift:{name:"Wrapped Present",unified:"1F381",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["present","birthday","christmas","xmas"],sheet:[8,15]},no_entry:{name:"No Entry",unified:"26D4",non_qualified:null,added_in:"5.2",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["limit","security","privacy","bad","denied","stop","circle"],sheet:[48,35]},kissing_smiling_eyes:{name:"Kissing Face with Smiling Eyes",unified:"1F619",non_qualified:null,added_in:"6.1",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["face","affection","valentines","infatuation","kiss"],sheet:[30,49]},coconut:{name:"Coconut",unified:"1F965",non_qualified:null,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,keywords:["fruit","nature","food","palm"],sheet:[42,17]},racehorse:{name:"Horse",unified:"1F40E",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["animal","gamble","luck"],sheet:[12,44]},microphone:{name:"Microphone",unified:"1F3A4",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["sound","music","PA","sing","talkshow"],sheet:[8,50]},classical_building:{name:"Classical Building",unified:"1F3DB-FE0F",non_qualified:"1F3DB",added_in:"7.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,keywords:["art","culture","history"],sheet:[11,44]},no_entry_sign:{name:"No Entry Sign",unified:"1F6AB",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["forbid","stop","limit","denied","disallow","circle"],sheet:[35,16]},reminder_ribbon:{name:"Reminder Ribbon",unified:"1F397-FE0F",non_qualified:"1F397",added_in:"7.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,keywords:["sports","cause","support","awareness"],sheet:[8,40]},kissing_closed_eyes:{name:"Kissing Face with Closed Eyes",unified:"1F61A",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["face","love","like","affection","valentines","infatuation","kiss"],sheet:[30,50]},unicorn_face:{name:"Unicorn Face",unified:"1F984",non_qualified:null,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false,sheet:[42,28]},"flag-ar":{name:"Argentina Flag",unified:"1F1E6-1F1F7",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[0,41]},headphones:{name:"Headphone",unified:"1F3A7",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["music","score","gadgets"],sheet:[9,1]},avocado:{name:"Avocado",unified:"1F951",non_qualified:null,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false,keywords:["fruit","food"],sheet:[41,49]},relaxed:{name:"White Smiling Face",unified:"263A-FE0F",non_qualified:"263A",added_in:"1.1",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:true,keywords:["face","blush","massage","happiness"],sheet:[47,41]},zebra_face:{name:"Zebra Face",unified:"1F993",non_qualified:null,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,sheet:[42,43]},eggplant:{name:"Aubergine",unified:"1F346",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["vegetable","nature","food","aubergine"],sheet:[7,8]},radio:{name:"Radio",unified:"1F4FB",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["communication","music","podcast","program"],sheet:[26,50]},building_construction:{name:"Building Construction",unified:"1F3D7-FE0F",non_qualified:"1F3D7",added_in:"7.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,keywords:["wip","working","progress"],sheet:[11,40]},"flag-as":{name:"American Samoa Flag",unified:"1F1E6-1F1F8",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[0,42]},admission_tickets:{name:"Admission Tickets",unified:"1F39F-FE0F",non_qualified:"1F39F",added_in:"7.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,sheet:[8,45]},no_bicycles:{name:"No Bicycles",unified:"1F6B3",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["cyclist","prohibited","circle"],sheet:[35,24]},no_smoking:{name:"No Smoking Symbol",unified:"1F6AD",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["cigarette","blue-square","smell","smoke"],sheet:[35,18]},slightly_smiling_face:{name:"Slightly Smiling Face",unified:"1F642",non_qualified:null,added_in:"7.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,emoticons:[":)","(:",":-)"],keywords:["face","smile"],sheet:[31,38]},"flag-at":{name:"Austria Flag",unified:"1F1E6-1F1F9",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[0,43]},ticket:{name:"Ticket",unified:"1F3AB",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["event","concert","pass"],sheet:[9,5]},saxophone:{name:"Saxophone",unified:"1F3B7",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["music","instrument","jazz","blues"],sheet:[9,17]},deer:{name:"Deer",unified:"1F98C",non_qualified:null,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false,keywords:["animal","nature","horns","venison"],sheet:[42,36]},house_buildings:{name:"House Buildings",unified:"1F3D8-FE0F",non_qualified:"1F3D8",added_in:"7.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,sheet:[11,41]},potato:{name:"Potato",unified:"1F954",non_qualified:null,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false,keywords:["food","tuber","vegatable","starch"],sheet:[42,0]},guitar:{name:"Guitar",unified:"1F3B8",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["music","instrument"],sheet:[9,18]},carrot:{name:"Carrot",unified:"1F955",non_qualified:null,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false,keywords:["vegetable","food","orange"],sheet:[42,1]},cityscape:{name:"Cityscape",unified:"1F3D9-FE0F",non_qualified:"1F3D9",added_in:"7.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,keywords:["photo","night life","urban"],sheet:[11,42]},"flag-au":{name:"Australia Flag",unified:"1F1E6-1F1FA",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[0,44]},do_not_litter:{name:"Do Not Litter Symbol",unified:"1F6AF",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["trash","bin","garbage","circle"],sheet:[35,20]},hugging_face:{name:"Hugging Face",unified:"1F917",non_qualified:null,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false,sheet:[37,31]},cow:{name:"Cow Face",unified:"1F42E",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["beef","ox","animal","nature","moo","milk"],sheet:[13,24]},medal:{name:"Medal",unified:"1F396-FE0F",non_qualified:"1F396",added_in:"7.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,sheet:[8,39]},musical_keyboard:{name:"Musical Keyboard",unified:"1F3B9",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["piano","instrument","compose"],sheet:[9,19]},corn:{name:"Ear of Maize",unified:"1F33D",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["food","vegetable","plant"],sheet:[6,51]},derelict_house_building:{name:"Derelict House Building",unified:"1F3DA-FE0F",non_qualified:"1F3DA",added_in:"7.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,sheet:[11,43]},"non-potable_water":{name:"Non-Potable Water Symbol",unified:"1F6B1",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["drink","faucet","tap","circle"],sheet:[35,22]},trophy:{name:"Trophy",unified:"1F3C6",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["win","award","contest","place","ftw","ceremony"],sheet:[10,19]},"flag-aw":{name:"Aruba Flag",unified:"1F1E6-1F1FC",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[0,45]},"star-struck":{name:"Grinning Face with Star Eyes",unified:"1F929",non_qualified:null,short_names:["grinning_face_with_star_eyes"],added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,sheet:[38,49]},ox:{name:"Ox",unified:"1F402",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["animal","cow","beef"],sheet:[12,32]},trumpet:{name:"Trumpet",unified:"1F3BA",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["music","brass"],sheet:[9,20]},hot_pepper:{name:"Hot Pepper",unified:"1F336-FE0F",non_qualified:"1F336",added_in:"7.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,keywords:["food","spicy","chilli","chili"],sheet:[6,44]},sports_medal:{name:"Sports Medal",unified:"1F3C5",non_qualified:null,added_in:"7.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false,sheet:[10,18]},"flag-ax":{name:"Åland Islands Flag",unified:"1F1E6-1F1FD",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[0,46]},water_buffalo:{name:"Water Buffalo",unified:"1F403",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["animal","nature","ox","cow"],sheet:[12,33]},no_pedestrians:{name:"No Pedestrians",unified:"1F6B7",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["rules","crossing","walking","circle"],sheet:[36,27]},thinking_face:{name:"Thinking Face",unified:"1F914",non_qualified:null,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false,sheet:[37,28]},house:{name:"House Building",unified:"1F3E0",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["building","home"],sheet:[11,49]},no_mobile_phones:{name:"No Mobile Phones",unified:"1F4F5",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["iphone","mute","circle"],sheet:[26,44]},"flag-az":{name:"Azerbaijan Flag",unified:"1F1E6-1F1FF",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[0,47]},first_place_medal:{name:"First Place Medal",unified:"1F947",non_qualified:null,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false,sheet:[41,42]},house_with_garden:{name:"House with Garden",unified:"1F3E1",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["home","plant","nature"],sheet:[11,50]},violin:{name:"Violin",unified:"1F3BB",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["music","instrument","orchestra","symphony"],sheet:[9,21]},face_with_raised_eyebrow:{name:"Face with One Eyebrow Raised",unified:"1F928",non_qualified:null,short_names:["face_with_one_eyebrow_raised"],added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,sheet:[38,48]},cucumber:{name:"Cucumber",unified:"1F952",non_qualified:null,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false,keywords:["fruit","food","pickle"],sheet:[41,50]},"cow2":{name:"Cow",unified:"1F404",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["beef","ox","animal","nature","moo","milk"],sheet:[12,34]},"flag-ba":{name:"Bosnia & Herzegovina Flag",unified:"1F1E7-1F1E6",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false,sheet:[0,48]},pig:{name:"Pig Face",unified:"1F437",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["animal","oink","nature"],sheet:[13,33]},drum_with_drumsticks:{name:"Drum with Drumsticks",unified:"1F941",non_qualified:null,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false,sheet:[41,37]},underage:{name:"No One Under Eighteen Symbol",unified:"1F51E",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["18","drink","pub","night","minor","circle"],sheet:[27,32]},broccoli:{name:"Broccoli",unified:"1F966",non_qualified:null,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,keywords:["fruit","food","vegetable"],sheet:[42,18]},office:{name:"Office Building",unified:"1F3E2",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["building","bureau","work"],sheet:[11,51]},second_place_medal:{name:"Second Place Medal",unified:"1F948",non_qualified:null,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false,sheet:[41,43]},neutral_face:{name:"Neutral Face",unified:"1F610",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,emoticons:[":|",":-|"],keywords:["indifference","meh",":|","neutral"],sheet:[30,40]},third_place_medal:{name:"Third Place Medal",unified:"1F949",non_qualified:null,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false,sheet:[41,44]},mushroom:{name:"Mushroom",unified:"1F344",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["plant","vegetable"],sheet:[7,6]},"flag-bb":{name:"Barbados Flag",unified:"1F1E7-1F1E7",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[0,49]},radioactive_sign:{name:"Radioactive Sign",unified:"2622-FE0F",non_qualified:"2622",added_in:"1.1",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,sheet:[47,33]},"pig2":{name:"Pig",unified:"1F416",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["animal","nature"],sheet:[13,0]},expressionless:{name:"Expressionless Face",unified:"1F611",non_qualified:null,added_in:"6.1",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["face","indifferent","-_-","meh","deadpan"],sheet:[30,41]},iphone:{name:"Mobile Phone",unified:"1F4F1",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["technology","apple","gadgets","dial"],sheet:[26,40]},post_office:{name:"Japanese Post Office",unified:"1F3E3",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["building","envelope","communication"],sheet:[12,0]},european_post_office:{name:"European Post Office",unified:"1F3E4",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["building","email"],sheet:[12,1]},soccer:{name:"Soccer Ball",unified:"26BD",non_qualified:null,added_in:"5.2",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["sports","football"],sheet:[48,26]},boar:{name:"Boar",unified:"1F417",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["animal","nature"],sheet:[13,1]},peanuts:{name:"Peanuts",unified:"1F95C",non_qualified:null,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false,keywords:["food","nut"],sheet:[42,8]},calling:{name:"Mobile Phone with Rightwards Arrow at Left",unified:"1F4F2",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["iphone","incoming"],sheet:[26,41]},biohazard_sign:{name:"Biohazard Sign",unified:"2623-FE0F",non_qualified:"2623",added_in:"1.1",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,sheet:[47,34]},"flag-bd":{name:"Bangladesh Flag",unified:"1F1E7-1F1E9",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[0,50]},no_mouth:{name:"Face Without Mouth",unified:"1F636",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["face","hellokitty"],sheet:[31,26]},face_with_rolling_eyes:{name:"Face with Rolling Eyes",unified:"1F644",non_qualified:null,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false,sheet:[31,40]},phone:{name:"Black Telephone",unified:"260E-FE0F",non_qualified:"260E",short_names:["telephone"],added_in:"1.1",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:true,keywords:["technology","communication","dial","telephone"],sheet:[47,21]},pig_nose:{name:"Pig Nose",unified:"1F43D",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["animal","oink"],sheet:[13,39]},chestnut:{name:"Chestnut",unified:"1F330",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["food","squirrel"],sheet:[6,38]},arrow_up:{name:"Upwards Black Arrow",unified:"2B06-FE0F",non_qualified:"2B06",added_in:"4.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:true,keywords:["blue-square","continue","top","direction"],sheet:[50,18]},hospital:{name:"Hospital",unified:"1F3E5",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["building","health","surgery","doctor"],sheet:[12,2]},"flag-be":{name:"Belgium Flag",unified:"1F1E7-1F1EA",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[0,51]},baseball:{name:"Baseball",unified:"26BE",non_qualified:null,added_in:"5.2",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["sports","balls"],sheet:[48,27]},smirk:{name:"Smirking Face",unified:"1F60F",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["face","smile","mean","prank","smug","sarcasm"],sheet:[30,39]},arrow_upper_right:{name:"North East Arrow",unified:"2197-FE0F",non_qualified:"2197",added_in:"1.1",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:true,keywords:["blue-square","point","direction","diagonal","northeast"],sheet:[46,36]},"flag-bf":{name:"Burkina Faso Flag",unified:"1F1E7-1F1EB",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[1,0]},basketball:{name:"Basketball and Hoop",unified:"1F3C0",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["sports","balls","NBA"],sheet:[9,26]},ram:{name:"Ram",unified:"1F40F",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["animal","sheep","nature"],sheet:[12,45]},bank:{name:"Bank",unified:"1F3E6",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["building","money","sales","cash","business","enterprise"],sheet:[12,3]},bread:{name:"Bread",unified:"1F35E",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["food","wheat","breakfast","toast"],sheet:[7,32]},telephone_receiver:{name:"Telephone Receiver",unified:"1F4DE",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["technology","communication","dial"],sheet:[26,21]},croissant:{name:"Croissant",unified:"1F950",non_qualified:null,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false,keywords:["food","bread","french"],sheet:[41,48]},pager:{name:"Pager",unified:"1F4DF",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["bbcall","oldschool","90s"],sheet:[26,22]},sheep:{name:"Sheep",unified:"1F411",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["animal","nature","wool","shipit"],sheet:[12,47]},arrow_right:{name:"Black Rightwards Arrow",unified:"27A1-FE0F",non_qualified:"27A1",added_in:"1.1",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:true,keywords:["blue-square","next"],sheet:[50,12]},persevere:{name:"Persevering Face",unified:"1F623",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["face","sick","no","upset","oops"],sheet:[31,7]},"flag-bg":{name:"Bulgaria Flag",unified:"1F1E7-1F1EC",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[1,1]},volleyball:{name:"Volleyball",unified:"1F3D0",non_qualified:null,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false,keywords:["sports","balls"],sheet:[11,33]},hotel:{name:"Hotel",unified:"1F3E8",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["building","accomodation","checkin"],sheet:[12,5]},arrow_lower_right:{name:"South East Arrow",unified:"2198-FE0F",non_qualified:"2198",added_in:"1.1",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:true,keywords:["blue-square","direction","diagonal","southeast"],sheet:[46,37]},goat:{name:"Goat",unified:"1F410",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["animal","nature"],sheet:[12,46]},"flag-bh":{name:"Bahrain Flag",unified:"1F1E7-1F1ED",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[1,2]},love_hotel:{name:"Love Hotel",unified:"1F3E9",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["like","affection","dating"],sheet:[12,6]},disappointed_relieved:{name:"Disappointed but Relieved Face",unified:"1F625",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["face","phew","sweat","nervous"],sheet:[31,9]},baguette_bread:{name:"Baguette Bread",unified:"1F956",non_qualified:null,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false,keywords:["food","bread","french"],sheet:[42,2]},football:{name:"American Football",unified:"1F3C8",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["sports","balls","NFL"],sheet:[10,26]},fax:{name:"Fax Machine",unified:"1F4E0",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["communication","technology"],sheet:[26,23]},convenience_store:{name:"Convenience Store",unified:"1F3EA",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["building","shopping","groceries"],sheet:[12,7]},dromedary_camel:{name:"Dromedary Camel",unified:"1F42A",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["animal","hot","desert","hump"],sheet:[13,20]},arrow_down:{name:"Downwards Black Arrow",unified:"2B07-FE0F",non_qualified:"2B07",added_in:"4.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:true,keywords:["blue-square","direction","bottom"],sheet:[50,19]},battery:{name:"Battery",unified:"1F50B",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["power","energy","sustain"],sheet:[27,13]},rugby_football:{name:"Rugby Football",unified:"1F3C9",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["sports","team"],sheet:[10,27]},pretzel:{name:"Pretzel",unified:"1F968",non_qualified:null,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,keywords:["food","bread","twisted"],sheet:[42,20]},open_mouth:{name:"Face with Open Mouth",unified:"1F62E",non_qualified:null,added_in:"6.1",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,emoticons:[":o",":-o",":O",":-O"],keywords:["face","surprise","impressed","wow","whoa",":O"],sheet:[31,18]},"flag-bi":{name:"Burundi Flag",unified:"1F1E7-1F1EE",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[1,3]},"flag-bj":{name:"Benin Flag",unified:"1F1E7-1F1EF",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[1,4]},pancakes:{name:"Pancakes",unified:"1F95E",non_qualified:null,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false,keywords:["food","breakfast","flapjacks","hotcakes"],sheet:[42,10]},school:{name:"School",unified:"1F3EB",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["building","student","education","learn","teach"],sheet:[12,8]},tennis:{name:"Tennis Racquet and Ball",unified:"1F3BE",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["sports","balls","green"],sheet:[9,24]},zipper_mouth_face:{name:"Zipper-Mouth Face",unified:"1F910",non_qualified:null,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false,keywords:["face","sealed","zipper","secret"],sheet:[37,24]},camel:{name:"Bactrian Camel",unified:"1F42B",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["animal","nature","hot","desert","hump"],sheet:[13,21]},arrow_lower_left:{name:"South West Arrow",unified:"2199-FE0F",non_qualified:"2199",added_in:"1.1",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:true,keywords:["blue-square","direction","diagonal","southwest"],sheet:[46,38]},electric_plug:{name:"Electric Plug",unified:"1F50C",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["charger","power"],sheet:[27,14]},cheese_wedge:{name:"Cheese Wedge",unified:"1F9C0",non_qualified:null,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false,sheet:[42,48]},hushed:{name:"Hushed Face",unified:"1F62F",non_qualified:null,added_in:"6.1",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["face","woo","shh"],sheet:[31,19]},computer:{name:"Personal Computer",unified:"1F4BB",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["technology","laptop","screen","display","monitor"],sheet:[25,38]},giraffe_face:{name:"Giraffe Face",unified:"1F992",non_qualified:null,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,sheet:[42,42]},"8ball":{name:"Billiards",unified:"1F3B1",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["pool","hobby","game","luck","magic"],sheet:[9,11]},"flag-bl":{name:"St. Barthélemy Flag",unified:"1F1E7-1F1F1",non_qualified:null,has_img_apple:true,has_img_google:false,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[1,5]},arrow_left:{name:"Leftwards Black Arrow",unified:"2B05-FE0F",non_qualified:"2B05",added_in:"4.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:true,keywords:["blue-square","previous","back"],sheet:[50,17]},department_store:{name:"Department Store",unified:"1F3EC",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["building","shopping","mall"],sheet:[12,9]},meat_on_bone:{name:"Meat on Bone",unified:"1F356",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["good","food","drumstick"],sheet:[7,24]},arrow_upper_left:{name:"North West Arrow",unified:"2196-FE0F",non_qualified:"2196",added_in:"1.1",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:true,keywords:["blue-square","point","direction","diagonal","northwest"],sheet:[46,35]},"flag-bm":{name:"Bermuda Flag",unified:"1F1E7-1F1F2",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[1,6]},sleepy:{name:"Sleepy Face",unified:"1F62A",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["face","tired","rest","nap"],sheet:[31,14]},bowling:{name:"Bowling",unified:"1F3B3",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["sports","fun","play"],sheet:[9,13]},factory:{name:"Factory",unified:"1F3ED",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["building","industry","pollution","smoke"],sheet:[12,10]},desktop_computer:{name:"Desktop Computer",unified:"1F5A5-FE0F",non_qualified:"1F5A5",added_in:"7.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,keywords:["technology","computing","screen"],sheet:[29,51]},elephant:{name:"Elephant",unified:"1F418",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["animal","nature","nose","th","circus"],sheet:[13,2]},rhinoceros:{name:"Rhinoceros",unified:"1F98F",non_qualified:null,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false,keywords:["animal","nature","horn"],sheet:[42,39]},arrow_up_down:{name:"Up Down Arrow",unified:"2195-FE0F",non_qualified:"2195",added_in:"1.1",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:true,keywords:["blue-square","direction","way","vertical"],sheet:[46,34]},cricket_bat_and_ball:{name:"Cricket Bat and Ball",unified:"1F3CF",non_qualified:null,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false,sheet:[11,32]},printer:{name:"Printer",unified:"1F5A8-FE0F",non_qualified:"1F5A8",added_in:"7.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,keywords:["paper","ink"],sheet:[30,0]},poultry_leg:{name:"Poultry Leg",unified:"1F357",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["food","meat","drumstick","bird","chicken","turkey"],sheet:[7,25]},tired_face:{name:"Tired Face",unified:"1F62B",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["sick","whine","upset","frustrated"],sheet:[31,15]},japanese_castle:{name:"Japanese Castle",unified:"1F3EF",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["photo","building"],sheet:[12,12]},"flag-bn":{name:"Brunei Flag",unified:"1F1E7-1F1F3",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false,sheet:[1,7]},field_hockey_stick_and_ball:{name:"Field Hockey Stick and Ball",unified:"1F3D1",non_qualified:null,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false,sheet:[11,34]},sleeping:{name:"Sleeping Face",unified:"1F634",non_qualified:null,added_in:"6.1",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["face","tired","sleepy","night","zzz"],sheet:[31,24]},left_right_arrow:{name:"Left Right Arrow",unified:"2194-FE0F",non_qualified:"2194",added_in:"1.1",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:true,keywords:["shape","direction","horizontal","sideways"],sheet:[46,33]},keyboard:{name:"Keyboard",unified:"2328-FE0F",non_qualified:"2328",added_in:"1.1",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,keywords:["technology","computer","type","input","text"],sheet:[46,43]},european_castle:{name:"European Castle",unified:"1F3F0",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["building","royalty","history"],sheet:[12,13]},mouse:{name:"Mouse Face",unified:"1F42D",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["animal","nature","cheese_wedge","rodent"],sheet:[13,23]},"flag-bo":{name:"Bolivia Flag",unified:"1F1E7-1F1F4",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[1,8]},cut_of_meat:{name:"Cut of Meat",unified:"1F969",non_qualified:null,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,sheet:[42,21]},ice_hockey_stick_and_puck:{name:"Ice Hockey Stick and Puck",unified:"1F3D2",non_qualified:null,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false,sheet:[11,35]},"mouse2":{name:"Mouse",unified:"1F401",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["animal","nature","rodent"],sheet:[12,31]},three_button_mouse:{name:"Three Button Mouse",unified:"1F5B1-FE0F",non_qualified:"1F5B1",added_in:"7.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,sheet:[30,1]},leftwards_arrow_with_hook:{name:"Leftwards Arrow with Hook",unified:"21A9-FE0F",non_qualified:"21A9",added_in:"1.1",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:true,keywords:["back","return","blue-square","undo","enter"],sheet:[46,39]},bacon:{name:"Bacon",unified:"1F953",non_qualified:null,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false,keywords:["food","breakfast","pork","pig","meat"],sheet:[41,51]},relieved:{name:"Relieved Face",unified:"1F60C",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["face","relaxed","phew","massage","happiness"],sheet:[30,36]},"flag-bq":{name:"Caribbean Netherlands Flag",unified:"1F1E7-1F1F6",non_qualified:null,has_img_apple:true,has_img_google:false,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[1,9]},wedding:{name:"Wedding",unified:"1F492",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["love","like","affection","couple","marriage","bride","groom"],sheet:[24,44]},tokyo_tower:{name:"Tokyo Tower",unified:"1F5FC",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["photo","japanese"],sheet:[30,20]},arrow_right_hook:{name:"Rightwards Arrow with Hook",unified:"21AA-FE0F",non_qualified:"21AA",added_in:"1.1",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:true,keywords:["blue-square","return","rotate","direction"],sheet:[46,40]},hamburger:{name:"Hamburger",unified:"1F354",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["meat","fast food","beef","cheeseburger","mcdonalds","burger king"],sheet:[7,22]},stuck_out_tongue:{name:"Face with Stuck-out Tongue",unified:"1F61B",non_qualified:null,text:":p",added_in:"6.1",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,emoticons:[":p",":-p",":P",":-P",":b",":-b"],keywords:["face","prank","childish","playful","mischievous","smile","tongue"],sheet:[30,51]},trackball:{name:"Trackball",unified:"1F5B2-FE0F",non_qualified:"1F5B2",added_in:"7.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,keywords:["technology","trackpad"],sheet:[30,2]},"flag-br":{name:"Brazil Flag",unified:"1F1E7-1F1F7",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[1,10]},rat:{name:"Rat",unified:"1F400",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["animal","mouse","rodent"],sheet:[12,30]},table_tennis_paddle_and_ball:{name:"Table Tennis Paddle and Ball",unified:"1F3D3",non_qualified:null,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false,sheet:[11,36]},minidisc:{name:"Minidisc",unified:"1F4BD",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["technology","record","data","disk","90s"],sheet:[25,40]},stuck_out_tongue_winking_eye:{name:"Face with Stuck-out Tongue and Winking Eye",unified:"1F61C",non_qualified:null,text:";p",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,emoticons:[";p",";-p",";b",";-b",";P",";-P"],keywords:["face","prank","childish","playful","mischievous","smile","wink","tongue"],sheet:[31,0]},fries:{name:"French Fries",unified:"1F35F",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["chips","snack","fast food"],sheet:[7,33]},badminton_racquet_and_shuttlecock:{name:"Badminton Racquet and Shuttlecock",unified:"1F3F8",non_qualified:null,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false,sheet:[12,22]},statue_of_liberty:{name:"Statue of Liberty",unified:"1F5FD",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["american","newyork"],sheet:[30,21]},"flag-bs":{name:"Bahamas Flag",unified:"1F1E7-1F1F8",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[1,11]},arrow_heading_up:{name:"Arrow Pointing Rightwards Then Curving Upwards",unified:"2934-FE0F",non_qualified:"2934",added_in:"3.2",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:true,keywords:["blue-square","direction","top"],sheet:[50,15]},hamster:{name:"Hamster Face",unified:"1F439",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["animal","nature"],sheet:[13,35]},stuck_out_tongue_closed_eyes:{name:"Face with Stuck-out Tongue and Tightly-Closed Eyes",unified:"1F61D",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["face","prank","playful","mischievous","smile","tongue"],sheet:[31,1]},pizza:{name:"Slice of Pizza",unified:"1F355",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["food","party"],sheet:[7,23]},boxing_glove:{name:"Boxing Glove",unified:"1F94A",non_qualified:null,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false,keywords:["sports","fighting"],sheet:[41,45]},floppy_disk:{name:"Floppy Disk",unified:"1F4BE",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["oldschool","technology","save","90s","80s"],sheet:[25,41]},arrow_heading_down:{name:"Arrow Pointing Rightwards Then Curving Downwards",unified:"2935-FE0F",non_qualified:"2935",added_in:"3.2",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:true,keywords:["blue-square","direction","bottom"],sheet:[50,16]},"flag-bt":{name:"Bhutan Flag",unified:"1F1E7-1F1F9",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[1,12]},rabbit:{name:"Rabbit Face",unified:"1F430",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["animal","nature","pet","spring","magic","bunny"],sheet:[13,26]},church:{name:"Church",unified:"26EA",non_qualified:null,added_in:"5.2",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["building","religion","christ"],sheet:[48,37]},drooling_face:{name:"Drooling Face",unified:"1F924",non_qualified:null,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false,keywords:["face"],sheet:[38,27]},"flag-bv":{name:"Bouvet Island Flag",unified:"1F1E7-1F1FB",non_qualified:null,has_img_apple:true,has_img_google:false,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[1,13]},mosque:{name:"Mosque",unified:"1F54C",non_qualified:null,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false,keywords:["islam","worship","minaret"],sheet:[28,15]},"rabbit2":{name:"Rabbit",unified:"1F407",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["animal","nature","pet","magic","spring"],sheet:[12,37]},hotdog:{name:"Hot Dog",unified:"1F32D",non_qualified:null,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false,keywords:["food","frankfurter"],sheet:[6,35]},martial_arts_uniform:{name:"Martial Arts Uniform",unified:"1F94B",non_qualified:null,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false,keywords:["judo","karate","taekwondo"],sheet:[41,46]},arrows_clockwise:{name:"Clockwise Downwards and Upwards Open Circle Arrows",unified:"1F503",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["sync","cycle","round","repeat"],sheet:[27,5]},cd:{name:"Optical Disc",unified:"1F4BF",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["technology","dvd","disk","disc","90s"],sheet:[25,42]},arrows_counterclockwise:{name:"Anticlockwise Downwards and Upwards Open Circle Arrows",unified:"1F504",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["blue-square","sync","cycle"],sheet:[27,6]},sandwich:{name:"Sandwich",unified:"1F96A",non_qualified:null,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,keywords:["food","lunch","bread"],sheet:[42,22]},chipmunk:{name:"Chipmunk",unified:"1F43F-FE0F",non_qualified:"1F43F",added_in:"7.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,keywords:["animal","nature","rodent","squirrel"],sheet:[13,41]},synagogue:{name:"Synagogue",unified:"1F54D",non_qualified:null,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false,keywords:["judaism","worship","temple","jewish"],sheet:[28,16]},unamused:{name:"Unamused Face",unified:"1F612",non_qualified:null,text:":(",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["indifference","bored","straight face","serious","sarcasm"],sheet:[30,42]},goal_net:{name:"Goal Net",unified:"1F945",non_qualified:null,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false,keywords:["sports"],sheet:[41,41]},"flag-bw":{name:"Botswana Flag",unified:"1F1E7-1F1FC",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[1,14]},dvd:{name:"Dvd",unified:"1F4C0",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["cd","disk","disc"],sheet:[25,43]},hedgehog:{name:"Hedgehog",unified:"1F994",non_qualified:null,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,keywords:["animal","nature","spiny"],sheet:[42,44]},dart:{name:"Direct Hit",unified:"1F3AF",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["game","play","bar","target","bullseye"],sheet:[9,9]},taco:{name:"Taco",unified:"1F32E",non_qualified:null,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false,keywords:["food","mexican"],sheet:[6,36]},back:{name:"Back with Leftwards Arrow Above",unified:"1F519",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["arrow","words","return"],sheet:[27,27]},"flag-by":{name:"Belarus Flag",unified:"1F1E7-1F1FE",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[1,15]},shinto_shrine:{name:"Shinto Shrine",unified:"26E9-FE0F",non_qualified:"26E9",added_in:"5.2",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,keywords:["temple","japan","kyoto"],sheet:[48,36]},movie_camera:{name:"Movie Camera",unified:"1F3A5",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["film","record"],sheet:[8,51]},sweat:{name:"Face with Cold Sweat",unified:"1F613",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["face","hot","sad","tired","exercise"],sheet:[30,43]},burrito:{name:"Burrito",unified:"1F32F",non_qualified:null,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false,keywords:["food","mexican"],sheet:[6,37]},"flag-bz":{name:"Belize Flag",unified:"1F1E7-1F1FF",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[1,16]},pensive:{name:"Pensive Face",unified:"1F614",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["face","sad","depressed","upset"],sheet:[30,44]},kaaba:{name:"Kaaba",unified:"1F54B",non_qualified:null,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false,keywords:["mecca","mosque","islam"],sheet:[28,14]},film_frames:{name:"Film Frames",unified:"1F39E-FE0F",non_qualified:"1F39E",added_in:"7.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,sheet:[8,44]},bat:{name:"Bat",unified:"1F987",non_qualified:null,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false,keywords:["animal","nature","blind","vampire"],sheet:[42,31]},golf:{name:"Flag in Hole",unified:"26F3",non_qualified:null,added_in:"5.2",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["sports","business","flag","hole","summer"],sheet:[48,41]},end:{name:"End with Leftwards Arrow Above",unified:"1F51A",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["words","arrow"],sheet:[27,28]},film_projector:{name:"Film Projector",unified:"1F4FD-FE0F",non_qualified:"1F4FD",added_in:"7.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,keywords:["video","tape","record","movie"],sheet:[27,0]},bear:{name:"Bear Face",unified:"1F43B",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["animal","nature","wild"],sheet:[13,37]},ice_skate:{name:"Ice Skate",unified:"26F8-FE0F",non_qualified:"26F8",added_in:"5.2",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,keywords:["sports"],sheet:[48,45]},fountain:{name:"Fountain",unified:"26F2",non_qualified:null,added_in:"5.2",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["photo","summer","water","fresh"],sheet:[48,40]},confused:{name:"Confused Face",unified:"1F615",non_qualified:null,added_in:"6.1",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,emoticons:[":\\",":-\\",":/",":-/"],keywords:["face","indifference","huh","weird","hmmm",":/"],sheet:[30,45]},"flag-ca":{name:"Canada Flag",unified:"1F1E8-1F1E6",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[1,17]},on:{name:"On with Exclamation Mark with Left Right Arrow Above",unified:"1F51B",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["arrow","words"],sheet:[27,29]},stuffed_flatbread:{name:"Stuffed Flatbread",unified:"1F959",non_qualified:null,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false,keywords:["food","flatbread","stuffed","gyro"],sheet:[42,5]},soon:{name:"Soon with Rightwards Arrow Above",unified:"1F51C",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["arrow","words"],sheet:[27,30]},upside_down_face:{name:"Upside-Down Face",unified:"1F643",non_qualified:null,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false,keywords:["face","flipped","silly","smile"],sheet:[31,39]},fishing_pole_and_fish:{name:"Fishing Pole and Fish",unified:"1F3A3",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["food","hobby","summer"],sheet:[8,49]},tent:{name:"Tent",unified:"26FA",non_qualified:null,added_in:"5.2",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["photo","camping","outdoors"],sheet:[49,12]},clapper:{name:"Clapper Board",unified:"1F3AC",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["movie","film","record"],sheet:[9,6]},egg:{name:"Egg",unified:"1F95A",non_qualified:null,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false,keywords:["food","chicken","breakfast"],sheet:[42,6]},"flag-cc":{name:"Cocos (keeling) Islands Flag",unified:"1F1E8-1F1E8",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[1,18]},koala:{name:"Koala",unified:"1F428",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["animal","nature"],sheet:[13,18]},foggy:{name:"Foggy",unified:"1F301",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["photo","mountain"],sheet:[5,45]},tv:{name:"Television",unified:"1F4FA",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["technology","program","oldschool","show","television"],sheet:[26,49]},panda_face:{name:"Panda Face",unified:"1F43C",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["animal","nature","panda"],sheet:[13,38]},fried_egg:{name:"Cooking",unified:"1F373",non_qualified:null,short_names:["cooking"],has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["food","breakfast","kitchen","egg"],sheet:[8,1]},top:{name:"Top with Upwards Arrow Above",unified:"1F51D",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["words","blue-square"],sheet:[27,31]},"flag-cd":{name:"Congo - Kinshasa Flag",unified:"1F1E8-1F1E9",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[1,19]},money_mouth_face:{name:"Money-Mouth Face",unified:"1F911",non_qualified:null,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false,keywords:["face","rich","dollar","money"],sheet:[37,25]},running_shirt_with_sash:{name:"Running Shirt with Sash",unified:"1F3BD",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["play","pageant"],sheet:[9,23]},astonished:{name:"Astonished Face",unified:"1F632",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["face","xox","surprised","poisoned"],sheet:[31,22]},feet:{name:"Paw Prints",unified:"1F43E",non_qualified:null,short_names:["paw_prints"],has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[13,40]},camera:{name:"Camera",unified:"1F4F7",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["gadgets","photography"],sheet:[26,46]},"flag-cf":{name:"Central African Republic Flag",unified:"1F1E8-1F1EB",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[1,20]},place_of_worship:{name:"Place of Worship",unified:"1F6D0",non_qualified:null,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false,keywords:["religion","church","temple","prayer"],sheet:[37,5]},night_with_stars:{name:"Night with Stars",unified:"1F303",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["evening","city","downtown"],sheet:[5,47]},ski:{name:"Ski and Ski Boot",unified:"1F3BF",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["sports","winter","cold","snow"],sheet:[9,25]},shallow_pan_of_food:{name:"Shallow Pan of Food",unified:"1F958",non_qualified:null,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false,keywords:["food","cooking","casserole","paella"],sheet:[42,4]},camera_with_flash:{name:"Camera with Flash",unified:"1F4F8",non_qualified:null,added_in:"7.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false,sheet:[26,47]},sunrise_over_mountains:{name:"Sunrise over Mountains",unified:"1F304",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["view","vacation","photo"],sheet:[5,48]},turkey:{name:"Turkey",unified:"1F983",non_qualified:null,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false,keywords:["animal","bird"],sheet:[42,27]},white_frowning_face:{name:"White Frowning Face",unified:"2639-FE0F",non_qualified:"2639",added_in:"1.1",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,sheet:[47,40]},"flag-cg":{name:"Congo - Brazzaville Flag",unified:"1F1E8-1F1EC",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[1,21]},stew:{name:"Pot of Food",unified:"1F372",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["food","meat","soup"],sheet:[8,0]},sled:{name:"Sled",unified:"1F6F7",non_qualified:null,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,keywords:["sleigh","luge","toboggan"],sheet:[37,22]},atom_symbol:{name:"Atom Symbol",unified:"269B-FE0F",non_qualified:"269B",added_in:"4.1",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,keywords:["science","physics","chemistry"],sheet:[48,18]},curling_stone:{name:"Curling Stone",unified:"1F94C",non_qualified:null,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,keywords:["sports"],sheet:[41,47]},slightly_frowning_face:{name:"Slightly Frowning Face",unified:"1F641",non_qualified:null,added_in:"7.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false,keywords:["face","frowning","disappointed","sad","upset"],sheet:[31,37]},sunrise:{name:"Sunrise",unified:"1F305",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["morning","view","vacation","photo"],sheet:[5,49]},om_symbol:{name:"Om Symbol",unified:"1F549-FE0F",non_qualified:"1F549",added_in:"7.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,sheet:[28,12]},chicken:{name:"Chicken",unified:"1F414",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["animal","cluck","nature","bird"],sheet:[12,50]},bowl_with_spoon:{name:"Bowl with Spoon",unified:"1F963",non_qualified:null,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,keywords:["food","breakfast","cereal","oatmeal","porridge"],sheet:[42,15]},"flag-ch":{name:"Switzerland Flag",unified:"1F1E8-1F1ED",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[1,22]},video_camera:{name:"Video Camera",unified:"1F4F9",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["film","record"],sheet:[26,48]},video_game:{name:"Video Game",unified:"1F3AE",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["play","console","PS4","controller"],sheet:[9,8]},rooster:{name:"Rooster",unified:"1F413",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["animal","nature","chicken"],sheet:[12,49]},vhs:{name:"Videocassette",unified:"1F4FC",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["record","video","oldschool","90s","80s"],sheet:[26,51]},city_sunset:{name:"Cityscape at Dusk",unified:"1F306",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["photo","evening","sky","buildings"],sheet:[5,50]},confounded:{name:"Confounded Face",unified:"1F616",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["face","confused","sick","unwell","oops",":S"],sheet:[30,46]},green_salad:{name:"Green Salad",unified:"1F957",non_qualified:null,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false,keywords:["food","healthy","lettuce"],sheet:[42,3]},star_of_david:{name:"Star of David",unified:"2721-FE0F",non_qualified:"2721",added_in:"1.1",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,keywords:["judaism"],sheet:[49,47]},"flag-ci":{name:"Côte D’ivoire Flag",unified:"1F1E8-1F1EE",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[1,23]},popcorn:{name:"Popcorn",unified:"1F37F",non_qualified:null,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false,keywords:["food","movie theater","films","snack"],sheet:[8,13]},city_sunrise:{name:"Sunset over Buildings",unified:"1F307",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["photo","good morning","dawn"],sheet:[5,51]},disappointed:{name:"Disappointed Face",unified:"1F61E",non_qualified:null,text:":(",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,emoticons:["):",":(",":-("],keywords:["face","sad","upset","depressed",":("],sheet:[31,2]},mag:{name:"Left-Pointing Magnifying Glass",unified:"1F50D",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["search","zoom","find","detective"],sheet:[27,15]},hatching_chick:{name:"Hatching Chick",unified:"1F423",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["animal","chicken","egg","born","baby","bird"],sheet:[13,13]},joystick:{name:"Joystick",unified:"1F579-FE0F",non_qualified:"1F579",added_in:"7.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,keywords:["game","play"],sheet:[29,20]},wheel_of_dharma:{name:"Wheel of Dharma",unified:"2638-FE0F",non_qualified:"2638",added_in:"1.1",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,keywords:["hinduism","buddhism","sikhism","jainism"],sheet:[47,39]},"flag-ck":{name:"Cook Islands Flag",unified:"1F1E8-1F1F0",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[1,24]},canned_food:{name:"Canned Food",unified:"1F96B",non_qualified:null,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,keywords:["food","soup"],sheet:[42,23]},worried:{name:"Worried Face",unified:"1F61F",non_qualified:null,added_in:"6.1",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["face","concern","nervous",":("],sheet:[31,3]},baby_chick:{name:"Baby Chick",unified:"1F424",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["animal","chicken","bird"],sheet:[13,14]},"flag-cl":{name:"Chile Flag",unified:"1F1E8-1F1F1",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[1,25]},game_die:{name:"Game Die",unified:"1F3B2",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["dice","random","tabletop","play","luck"],sheet:[9,12]},mag_right:{name:"Right-Pointing Magnifying Glass",unified:"1F50E",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["search","zoom","find","detective"],sheet:[27,16]},yin_yang:{name:"Yin Yang",unified:"262F-FE0F",non_qualified:"262F",added_in:"1.1",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,keywords:["balance"],sheet:[47,38]},bridge_at_night:{name:"Bridge at Night",unified:"1F309",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["photo","sanfrancisco"],sheet:[6,1]},spades:{name:"Black Spade Suit",unified:"2660-FE0F",non_qualified:"2660",added_in:"1.1",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:true,keywords:["poker","cards","suits","magic"],sheet:[48,4]},hatched_chick:{name:"Front-Facing Baby Chick",unified:"1F425",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["animal","chicken","baby","bird"],sheet:[13,15]},"flag-cm":{name:"Cameroon Flag",unified:"1F1E8-1F1F2",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[1,26]},latin_cross:{name:"Latin Cross",unified:"271D-FE0F",non_qualified:"271D",added_in:"1.1",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,keywords:["christianity"],sheet:[49,46]},triumph:{name:"Face with Look of Triumph",unified:"1F624",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["face","gas","phew","proud","pride"],sheet:[31,8]},hotsprings:{name:"Hot Springs",unified:"2668-FE0F",non_qualified:"2668",added_in:"1.1",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:true,keywords:["bath","warm","relax"],sheet:[48,8]},bento:{name:"Bento Box",unified:"1F371",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["food","japanese","box"],sheet:[7,51]},microscope:{name:"Microscope",unified:"1F52C",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["laboratory","experiment","zoomin","science","study"],sheet:[27,46]},cry:{name:"Crying Face",unified:"1F622",non_qualified:null,text:":'(",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,emoticons:[":'("],keywords:["face","tears","sad","depressed","upset",":'("],sheet:[31,6]},bird:{name:"Bird",unified:"1F426",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["animal","nature","fly","tweet","spring"],sheet:[13,16]},cn:{name:"China Flag",unified:"1F1E8-1F1F3",non_qualified:null,short_names:["flag-cn"],has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["china","chinese","prc","flag","country","nation","banner"],sheet:[1,27]},telescope:{name:"Telescope",unified:"1F52D",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["stars","space","zoom","science","astronomy"],sheet:[27,47]},rice_cracker:{name:"Rice Cracker",unified:"1F358",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["food","japanese"],sheet:[7,26]},hearts:{name:"Black Heart Suit",unified:"2665-FE0F",non_qualified:"2665",added_in:"1.1",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:true,keywords:["poker","cards","magic","suits"],sheet:[48,6]},orthodox_cross:{name:"Orthodox Cross",unified:"2626-FE0F",non_qualified:"2626",added_in:"1.1",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,keywords:["suppedaneum","religion"],sheet:[47,35]},milky_way:{name:"Milky Way",unified:"1F30C",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["photo","space","stars"],sheet:[6,4]},rice_ball:{name:"Rice Ball",unified:"1F359",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["food","japanese"],sheet:[7,27]},satellite_antenna:{name:"Satellite Antenna",unified:"1F4E1",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[26,24]},"flag-co":{name:"Colombia Flag",unified:"1F1E8-1F1F4",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[1,28]},carousel_horse:{name:"Carousel Horse",unified:"1F3A0",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["photo","carnival"],sheet:[8,46]},sob:{name:"Loudly Crying Face",unified:"1F62D",non_qualified:null,text:":'(",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["face","cry","tears","sad","upset","depressed"],sheet:[31,17]},diamonds:{name:"Black Diamond Suit",unified:"2666-FE0F",non_qualified:"2666",added_in:"1.1",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:true,keywords:["poker","cards","magic","suits"],sheet:[48,7]},star_and_crescent:{name:"Star and Crescent",unified:"262A-FE0F",non_qualified:"262A",added_in:"1.1",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,keywords:["islam"],sheet:[47,36]},penguin:{name:"Penguin",unified:"1F427",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["animal","nature"],sheet:[13,17]},dove_of_peace:{name:"Dove of Peace",unified:"1F54A-FE0F",non_qualified:"1F54A",added_in:"7.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,sheet:[28,13]},"flag-cp":{name:"Clipperton Island Flag",unified:"1F1E8-1F1F5",non_qualified:null,has_img_apple:true,has_img_google:false,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false,sheet:[1,29]},ferris_wheel:{name:"Ferris Wheel",unified:"1F3A1",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["photo","carnival","londoneye"],sheet:[8,47]},clubs:{name:"Black Club Suit",unified:"2663-FE0F",non_qualified:"2663",added_in:"1.1",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:true,keywords:["poker","cards","magic","suits"],sheet:[48,5]},peace_symbol:{name:"Peace Symbol",unified:"262E-FE0F",non_qualified:"262E",added_in:"1.1",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,keywords:["hippie"],sheet:[47,37]},candle:{name:"Candle",unified:"1F56F-FE0F",non_qualified:"1F56F",added_in:"7.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,keywords:["fire","wax"],sheet:[28,42]},frowning:{name:"Frowning Face with Open Mouth",unified:"1F626",non_qualified:null,added_in:"6.1",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["face","aw","what"],sheet:[31,10]},rice:{name:"Cooked Rice",unified:"1F35A",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["food","china","asian"],sheet:[7,28]},"flag-cr":{name:"Costa Rica Flag",unified:"1F1E8-1F1F7",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[1,30]},roller_coaster:{name:"Roller Coaster",unified:"1F3A2",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["carnival","playground","photo","fun"],sheet:[8,48]},menorah_with_nine_branches:{name:"Menorah with Nine Branches",unified:"1F54E",non_qualified:null,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false,sheet:[28,17]},black_joker:{name:"Playing Card Black Joker",unified:"1F0CF",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["poker","cards","game","play","magic"],sheet:[0,15]},eagle:{name:"Eagle",unified:"1F985",non_qualified:null,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false,keywords:["animal","nature","bird"],sheet:[42,29]},curry:{name:"Curry and Rice",unified:"1F35B",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["food","spicy","hot","indian"],sheet:[7,29]},bulb:{name:"Electric Light Bulb",unified:"1F4A1",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["light","electricity","idea"],sheet:[25,7]},anguished:{name:"Anguished Face",unified:"1F627",non_qualified:null,added_in:"6.1",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,emoticons:["D:"],keywords:["face","stunned","nervous"],sheet:[31,11]},"flag-cu":{name:"Cuba Flag",unified:"1F1E8-1F1FA",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[1,31]},barber:{name:"Barber Pole",unified:"1F488",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["hair","salon","style"],sheet:[24,34]},duck:{name:"Duck",unified:"1F986",non_qualified:null,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false,keywords:["animal","nature","bird","mallard"],sheet:[42,30]},six_pointed_star:{name:"Six Pointed Star with Middle Dot",unified:"1F52F",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["purple-square","religion","jewish","hexagram"],sheet:[27,49]},ramen:{name:"Steaming Bowl",unified:"1F35C",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["food","japanese","noodle","chopsticks"],sheet:[7,30]},flashlight:{name:"Electric Torch",unified:"1F526",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["dark","camping","sight","night"],sheet:[27,40]},mahjong:{name:"Mahjong Tile Red Dragon",unified:"1F004",non_qualified:null,added_in:"5.1",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["game","play","chinese","kanji"],sheet:[0,14]},fearful:{name:"Fearful Face",unified:"1F628",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["face","scared","terrified","nervous","oops","huh"],sheet:[31,12]},aries:{name:"Aries",unified:"2648",non_qualified:null,added_in:"1.1",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["sign","purple-square","zodiac","astrology"],sheet:[47,44]},spaghetti:{name:"Spaghetti",unified:"1F35D",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["food","italian","noodle"],sheet:[7,31]},circus_tent:{name:"Circus Tent",unified:"1F3AA",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["festival","carnival","party"],sheet:[9,4]},izakaya_lantern:{name:"Izakaya Lantern",unified:"1F3EE",non_qualified:null,short_names:["lantern"],has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["light","paper","halloween","spooky"],sheet:[12,11]},"flag-cv":{name:"Cape Verde Flag",unified:"1F1E8-1F1FB",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[1,32]},weary:{name:"Weary Face",unified:"1F629",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["face","tired","sleepy","sad","frustrated","upset"],sheet:[31,13]},flower_playing_cards:{name:"Flower Playing Cards",unified:"1F3B4",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["game","sunset","red"],sheet:[9,14]},owl:{name:"Owl",unified:"1F989",non_qualified:null,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false,keywords:["animal","nature","bird","hoot"],sheet:[42,33]},performing_arts:{name:"Performing Arts",unified:"1F3AD",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["acting","theater","drama"],sheet:[9,7]},frog:{name:"Frog Face",unified:"1F438",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["animal","nature","croak","toad"],sheet:[13,34]},"flag-cw":{name:"Curaçao Flag",unified:"1F1E8-1F1FC",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[1,33]},notebook_with_decorative_cover:{name:"Notebook with Decorative Cover",unified:"1F4D4",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["classroom","notes","record","paper","study"],sheet:[26,11]},exploding_head:{name:"Shocked Face with Exploding Head",unified:"1F92F",non_qualified:null,short_names:["shocked_face_with_exploding_head"],added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,keywords:["face","shocked","mind","blown"],sheet:[39,3]},taurus:{name:"Taurus",unified:"2649",non_qualified:null,added_in:"1.1",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["purple-square","sign","zodiac","astrology"],sheet:[47,45]},sweet_potato:{name:"Roasted Sweet Potato",unified:"1F360",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["food","nature"],sheet:[7,34]},closed_book:{name:"Closed Book",unified:"1F4D5",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["read","library","knowledge","textbook","learn"],sheet:[26,12]},gemini:{name:"Gemini",unified:"264A",non_qualified:null,added_in:"1.1",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["sign","zodiac","purple-square","astrology"],sheet:[47,46]},frame_with_picture:{name:"Frame with Picture",unified:"1F5BC-FE0F",non_qualified:"1F5BC",added_in:"7.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,sheet:[30,3]},"flag-cx":{name:"Christmas Island Flag",unified:"1F1E8-1F1FD",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[1,34]},grimacing:{name:"Grimacing Face",unified:"1F62C",non_qualified:null,added_in:"6.1",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["face","grimace","teeth"],sheet:[31,16]},crocodile:{name:"Crocodile",unified:"1F40A",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["animal","nature","reptile","lizard","alligator"],sheet:[12,40]},oden:{name:"Oden",unified:"1F362",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["food","japanese"],sheet:[7,36]},"flag-cy":{name:"Cyprus Flag",unified:"1F1E8-1F1FE",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[1,35]},book:{name:"Open Book",unified:"1F4D6",non_qualified:null,short_names:["open_book"],has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[26,13]},turtle:{name:"Turtle",unified:"1F422",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["animal","slow","nature","tortoise"],sheet:[13,12]},art:{name:"Artist Palette",unified:"1F3A8",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["design","paint","draw","colors"],sheet:[9,2]},sushi:{name:"Sushi",unified:"1F363",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["food","fish","japanese","rice"],sheet:[7,37]},cold_sweat:{name:"Face with Open Mouth and Cold Sweat",unified:"1F630",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["face","nervous","sweat"],sheet:[31,20]},cancer:{name:"Cancer",unified:"264B",non_qualified:null,added_in:"1.1",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["sign","zodiac","purple-square","astrology"],sheet:[47,47]},fried_shrimp:{name:"Fried Shrimp",unified:"1F364",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["food","animal","appetizer","summer"],sheet:[7,38]},slot_machine:{name:"Slot Machine",unified:"1F3B0",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["bet","gamble","vegas","fruit machine","luck","casino"],sheet:[9,10]},scream:{name:"Face Screaming in Fear",unified:"1F631",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["face","munch","scared","omg"],sheet:[31,21]},green_book:{name:"Green Book",unified:"1F4D7",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["read","library","knowledge","study"],sheet:[26,14]},leo:{name:"Leo",unified:"264C",non_qualified:null,added_in:"1.1",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["sign","purple-square","zodiac","astrology"],sheet:[47,48]},"flag-cz":{name:"Czechia Flag",unified:"1F1E8-1F1FF",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[1,36]},lizard:{name:"Lizard",unified:"1F98E",non_qualified:null,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false,keywords:["animal","nature","reptile"],sheet:[42,38]},virgo:{name:"Virgo",unified:"264D",non_qualified:null,added_in:"1.1",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["sign","zodiac","purple-square","astrology"],sheet:[47,49]},steam_locomotive:{name:"Steam Locomotive",unified:"1F682",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["transportation","vehicle","train"],sheet:[34,10]},de:{name:"Germany Flag",unified:"1F1E9-1F1EA",non_qualified:null,short_names:["flag-de"],has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["german","nation","flag","country","banner"],sheet:[1,37]},flushed:{name:"Flushed Face",unified:"1F633",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["face","blush","shy","flattered"],sheet:[31,23]},blue_book:{name:"Blue Book",unified:"1F4D8",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["read","library","knowledge","learn","study"],sheet:[26,15]},snake:{name:"Snake",unified:"1F40D",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["animal","evil","nature","hiss","python"],sheet:[12,43]},fish_cake:{name:"Fish Cake with Swirl Design",unified:"1F365",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["food","japan","sea","beach","narutomaki","pink","swirl","kamaboko","surimi","ramen"],sheet:[7,39]},railway_car:{name:"Railway Car",unified:"1F683",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["transportation","vehicle"],sheet:[34,11]},dango:{name:"Dango",unified:"1F361",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["food","dessert","sweet","japanese","barbecue","meat"],sheet:[7,35]},orange_book:{name:"Orange Book",unified:"1F4D9",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["read","library","knowledge","textbook","study"],sheet:[26,16]},libra:{name:"Libra",unified:"264E",non_qualified:null,added_in:"1.1",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["sign","purple-square","zodiac","astrology"],sheet:[47,50]},dragon_face:{name:"Dragon Face",unified:"1F432",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["animal","myth","nature","chinese","green"],sheet:[13,28]},"flag-dg":{name:"Diego Garcia Flag",unified:"1F1E9-1F1EC",non_qualified:null,has_img_apple:true,has_img_google:false,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[1,38]},zany_face:{name:"Grinning Face with One Large and One Small Eye",unified:"1F92A",non_qualified:null,short_names:["grinning_face_with_one_large_and_one_small_eye"],added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,sheet:[38,50]},books:{name:"Books",unified:"1F4DA",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["literature","library","study"],sheet:[26,17]},dragon:{name:"Dragon",unified:"1F409",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["animal","myth","nature","chinese","green"],sheet:[12,39]},"flag-dj":{name:"Djibouti Flag",unified:"1F1E9-1F1EF",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[1,39]},dumpling:{name:"Dumpling",unified:"1F95F",non_qualified:null,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,keywords:["food","empanada","pierogi","potsticker"],sheet:[42,11]},dizzy_face:{name:"Dizzy Face",unified:"1F635",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["spent","unconscious","xox","dizzy"],sheet:[31,25]},scorpius:{name:"Scorpius",unified:"264F",non_qualified:null,added_in:"1.1",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["sign","zodiac","purple-square","astrology","scorpio"],sheet:[47,51]},bullettrain_side:{name:"High-Speed Train",unified:"1F684",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["transportation","vehicle"],sheet:[34,12]},bullettrain_front:{name:"High-Speed Train with Bullet Nose",unified:"1F685",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["transportation","vehicle","speed","fast","public","travel"],sheet:[34,13]},notebook:{name:"Notebook",unified:"1F4D3",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["stationery","record","notes","paper","study"],sheet:[26,10]},fortune_cookie:{name:"Fortune Cookie",unified:"1F960",non_qualified:null,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,keywords:["food","prophecy"],sheet:[42,12]},sagittarius:{name:"Sagittarius",unified:"2650",non_qualified:null,added_in:"1.1",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["sign","zodiac","purple-square","astrology"],sheet:[48,0]},sauropod:{name:"Sauropod",unified:"1F995",non_qualified:null,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,keywords:["animal","nature","dinosaur","brachiosaurus","brontosaurus","diplodocus","extinct"],sheet:[42,45]},"flag-dk":{name:"Denmark Flag",unified:"1F1E9-1F1F0",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[1,40]},rage:{name:"Pouting Face",unified:"1F621",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["angry","mad","hate","despise"],sheet:[31,5]},ledger:{name:"Ledger",unified:"1F4D2",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["notes","paper"],sheet:[26,9]},angry:{name:"Angry Face",unified:"1F620",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,emoticons:[">:(",">:-("],keywords:["mad","face","annoyed","frustrated"],sheet:[31,4]},"t-rex":{name:"T-Rex",unified:"1F996",non_qualified:null,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,keywords:["animal","nature","dinosaur","tyrannosaurus","extinct"],sheet:[42,46]},capricorn:{name:"Capricorn",unified:"2651",non_qualified:null,added_in:"1.1",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["sign","zodiac","purple-square","astrology"],sheet:[48,1]},takeout_box:{name:"Takeout Box",unified:"1F961",non_qualified:null,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,keywords:["food","leftovers"],sheet:[42,13]},"flag-dm":{name:"Dominica Flag",unified:"1F1E9-1F1F2",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[1,41]},"train2":{name:"Train",unified:"1F686",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["transportation","vehicle"],sheet:[34,14]},page_with_curl:{name:"Page with Curl",unified:"1F4C3",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["documents","office","paper"],sheet:[25,46]},whale:{name:"Spouting Whale",unified:"1F433",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["animal","nature","sea","ocean"],sheet:[13,29]},face_with_symbols_on_mouth:{name:"Serious Face with Symbols Covering Mouth",unified:"1F92C",non_qualified:null,short_names:["serious_face_with_symbols_covering_mouth"],added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,sheet:[39,0]},"flag-do":{name:"Dominican Republic Flag",unified:"1F1E9-1F1F4",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[1,42]},metro:{name:"Metro",unified:"1F687",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["transportation","blue-square","mrt","underground","tube"],sheet:[34,15]},icecream:{name:"Soft Ice Cream",unified:"1F366",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["food","hot","dessert","summer"],sheet:[7,40]},aquarius:{name:"Aquarius",unified:"2652",non_qualified:null,added_in:"1.1",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["sign","purple-square","zodiac","astrology"],sheet:[48,2]},"flag-dz":{name:"Algeria Flag",unified:"1F1E9-1F1FF",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[1,43]},"whale2":{name:"Whale",unified:"1F40B",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["animal","nature","sea","ocean"],sheet:[12,41]},mask:{name:"Face with Medical Mask",unified:"1F637",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["face","sick","ill","disease"],sheet:[31,27]},scroll:{name:"Scroll",unified:"1F4DC",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["documents","ancient","history","paper"],sheet:[26,19]},shaved_ice:{name:"Shaved Ice",unified:"1F367",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["hot","dessert","summer"],sheet:[7,41]},pisces:{name:"Pisces",unified:"2653",non_qualified:null,added_in:"1.1",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["purple-square","sign","zodiac","astrology"],sheet:[48,3]},light_rail:{name:"Light Rail",unified:"1F688",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["transportation","vehicle"],sheet:[34,16]},dolphin:{name:"Dolphin",unified:"1F42C",non_qualified:null,short_names:["flipper"],has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["animal","nature","fish","sea","ocean","flipper","fins","beach"],sheet:[13,22]},face_with_thermometer:{name:"Face with Thermometer",unified:"1F912",non_qualified:null,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false,keywords:["sick","temperature","thermometer","cold","fever"],sheet:[37,26]},"flag-ea":{name:"Ceuta & Melilla Flag",unified:"1F1EA-1F1E6",non_qualified:null,has_img_apple:true,has_img_google:false,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[1,44]},ophiuchus:{name:"Ophiuchus",unified:"26CE",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["sign","purple-square","constellation","astrology"],sheet:[48,31]},station:{name:"Station",unified:"1F689",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["transportation","vehicle","public"],sheet:[34,17]},ice_cream:{name:"Ice Cream",unified:"1F368",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["food","hot","dessert"],sheet:[7,42]},page_facing_up:{name:"Page Facing Up",unified:"1F4C4",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["documents","office","paper","information"],sheet:[25,47]},doughnut:{name:"Doughnut",unified:"1F369",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["food","dessert","snack","sweet","donut"],sheet:[7,43]},face_with_head_bandage:{name:"Face with Head-Bandage",unified:"1F915",non_qualified:null,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false,keywords:["injured","clumsy","bandage","hurt"],sheet:[37,29]},fish:{name:"Fish",unified:"1F41F",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["animal","food","nature"],sheet:[13,9]},newspaper:{name:"Newspaper",unified:"1F4F0",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["press","headline"],sheet:[26,39]},tram:{name:"Tram",unified:"1F68A",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["transportation","vehicle"],sheet:[34,18]},"flag-ec":{name:"Ecuador Flag",unified:"1F1EA-1F1E8",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[1,45]},twisted_rightwards_arrows:{name:"Twisted Rightwards Arrows",unified:"1F500",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["blue-square","shuffle","music","random"],sheet:[27,2]},"flag-ee":{name:"Estonia Flag",unified:"1F1EA-1F1EA",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[1,46]},cookie:{name:"Cookie",unified:"1F36A",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["food","snack","oreo","chocolate","sweet","dessert"],sheet:[7,44]},monorail:{name:"Monorail",unified:"1F69D",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["transportation","vehicle"],sheet:[34,37]},tropical_fish:{name:"Tropical Fish",unified:"1F420",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["animal","swim","ocean","beach","nemo"],sheet:[13,10]},rolled_up_newspaper:{name:"Rolled Up Newspaper",unified:"1F5DE-FE0F",non_qualified:"1F5DE",added_in:"7.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,sheet:[30,12]},nauseated_face:{name:"Nauseated Face",unified:"1F922",non_qualified:null,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false,keywords:["face","vomit","gross","green","sick","throw up","ill"],sheet:[38,25]},repeat:{name:"Clockwise Rightwards and Leftwards Open Circle Arrows",unified:"1F501",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["loop","record"],sheet:[27,3]},bookmark_tabs:{name:"Bookmark Tabs",unified:"1F4D1",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["favorite","save","order","tidy"],sheet:[26,8]},repeat_one:{name:"Clockwise Rightwards and Leftwards Open Circle Arrows with Circled One Overlay",unified:"1F502",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["blue-square","loop"],sheet:[27,4]},"flag-eg":{name:"Egypt Flag",unified:"1F1EA-1F1EC",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[1,47]},mountain_railway:{name:"Mountain Railway",unified:"1F69E",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["transportation","vehicle"],sheet:[34,38]},birthday:{name:"Birthday Cake",unified:"1F382",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["food","dessert","cake"],sheet:[8,16]},blowfish:{name:"Blowfish",unified:"1F421",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["animal","nature","food","sea","ocean"],sheet:[13,11]},face_vomiting:{name:"Face with Open Mouth Vomiting",unified:"1F92E",non_qualified:null,short_names:["face_with_open_mouth_vomiting"],added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,sheet:[39,2]},arrow_forward:{name:"Black Right-Pointing Triangle",unified:"25B6-FE0F",non_qualified:"25B6",added_in:"1.1",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:true,keywords:["blue-square","right","direction","play"],sheet:[47,10]},bookmark:{name:"Bookmark",unified:"1F516",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["favorite","label","save"],sheet:[27,24]},"flag-eh":{name:"Western Sahara Flag",unified:"1F1EA-1F1ED",non_qualified:null,has_img_apple:true,has_img_google:false,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[1,48]},shark:{name:"Shark",unified:"1F988",non_qualified:null,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false,keywords:["animal","nature","fish","sea","ocean","jaws","fins","beach"],sheet:[42,32]},train:{name:"Tram Car",unified:"1F68B",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["transportation","vehicle","carriage","public","travel"],sheet:[34,19]},sneezing_face:{name:"Sneezing Face",unified:"1F927",non_qualified:null,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false,keywords:["face","gesundheit","sneeze","sick","allergy"],sheet:[38,47]},cake:{name:"Shortcake",unified:"1F370",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["food","dessert"],sheet:[7,50]},bus:{name:"Bus",unified:"1F68C",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["car","vehicle","transportation"],sheet:[34,20]},pie:{name:"Pie",unified:"1F967",non_qualified:null,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,keywords:["food","dessert","pastry"],sheet:[42,19]},innocent:{name:"Smiling Face with Halo",unified:"1F607",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["face","angel","heaven","halo"],sheet:[30,31]},fast_forward:{name:"Black Right-Pointing Double Triangle",unified:"23E9",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["blue-square","play","speed","continue"],sheet:[46,45]},label:{name:"Label",unified:"1F3F7-FE0F",non_qualified:"1F3F7",added_in:"7.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,keywords:["sale","tag"],sheet:[12,21]},octopus:{name:"Octopus",unified:"1F419",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["animal","creature","ocean","sea","nature","beach"],sheet:[13,3]},"flag-er":{name:"Eritrea Flag",unified:"1F1EA-1F1F7",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[1,49]},black_right_pointing_double_triangle_with_vertical_bar:{name:"Black Right Pointing Double Triangle with Vertical Bar",unified:"23ED-FE0F",non_qualified:"23ED",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,sheet:[46,49]},chocolate_bar:{name:"Chocolate Bar",unified:"1F36B",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["food","snack","dessert","sweet"],sheet:[7,45]},oncoming_bus:{name:"Oncoming Bus",unified:"1F68D",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["vehicle","transportation"],sheet:[34,21]},shell:{name:"Spiral Shell",unified:"1F41A",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["nature","sea","beach"],sheet:[13,4]},face_with_cowboy_hat:{name:"Face with Cowboy Hat",unified:"1F920",non_qualified:null,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false,sheet:[38,23]},moneybag:{name:"Money Bag",unified:"1F4B0",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["dollar","payment","coins","sale"],sheet:[25,27]},es:{name:"Spain Flag",unified:"1F1EA-1F1F8",non_qualified:null,short_names:["flag-es"],has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["spain","flag","nation","country","banner"],sheet:[1,50]},crab:{name:"Crab",unified:"1F980",non_qualified:null,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false,keywords:["animal","crustacean"],sheet:[42,24]},yen:{name:"Banknote with Yen Sign",unified:"1F4B4",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["money","sales","japanese","dollar","currency"],sheet:[25,31]},"flag-et":{name:"Ethiopia Flag",unified:"1F1EA-1F1F9",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[1,51]},clown_face:{name:"Clown Face",unified:"1F921",non_qualified:null,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false,keywords:["face"],sheet:[38,24]},black_right_pointing_triangle_with_double_vertical_bar:{name:"Black Right Pointing Triangle with Double Vertical Bar",unified:"23EF-FE0F",non_qualified:"23EF",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,sheet:[46,51]},trolleybus:{name:"Trolleybus",unified:"1F68E",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["bart","transportation","vehicle"],sheet:[34,22]},candy:{name:"Candy",unified:"1F36C",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["snack","dessert","sweet","lolly"],sheet:[7,46]},lying_face:{name:"Lying Face",unified:"1F925",non_qualified:null,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false,keywords:["face","lie","pinocchio"],sheet:[38,28]},arrow_backward:{name:"Black Left-Pointing Triangle",unified:"25C0-FE0F",non_qualified:"25C0",added_in:"1.1",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:true,keywords:["blue-square","left","direction"],sheet:[47,11]},dollar:{name:"Banknote with Dollar Sign",unified:"1F4B5",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["money","sales","bill","currency"],sheet:[25,32]},shrimp:{name:"Shrimp",unified:"1F990",non_qualified:null,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false,keywords:["animal","ocean","nature","seafood"],sheet:[42,40]},minibus:{name:"Minibus",unified:"1F690",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["vehicle","car","transportation"],sheet:[34,24]},"flag-eu":{name:"European Union Flag",unified:"1F1EA-1F1FA",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[2,0]},lollipop:{name:"Lollipop",unified:"1F36D",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["food","snack","candy","sweet"],sheet:[7,47]},squid:{name:"Squid",unified:"1F991",non_qualified:null,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false,keywords:["animal","nature","ocean","sea"],sheet:[42,41]},euro:{name:"Banknote with Euro Sign",unified:"1F4B6",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["money","sales","dollar","currency"],sheet:[25,33]},"flag-fi":{name:"Finland Flag",unified:"1F1EB-1F1EE",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[2,1]},ambulance:{name:"Ambulance",unified:"1F691",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["health","911","hospital"],sheet:[34,25]},custard:{name:"Custard",unified:"1F36E",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["dessert","food"],sheet:[7,48]},shushing_face:{name:"Face with Finger Covering Closed Lips",unified:"1F92B",non_qualified:null,short_names:["face_with_finger_covering_closed_lips"],added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,sheet:[38,51]},rewind:{name:"Black Left-Pointing Double Triangle",unified:"23EA",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["play","blue-square"],sheet:[46,46]},black_left_pointing_double_triangle_with_vertical_bar:{name:"Black Left Pointing Double Triangle with Vertical Bar",unified:"23EE-FE0F",non_qualified:"23EE",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,sheet:[46,50]},face_with_hand_over_mouth:{name:"Smiling Face with Smiling Eyes and Hand Covering Mouth",unified:"1F92D",non_qualified:null,short_names:["smiling_face_with_smiling_eyes_and_hand_covering_mouth"],added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,sheet:[39,1]},"flag-fj":{name:"Fiji Flag",unified:"1F1EB-1F1EF",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[2,2]},honey_pot:{name:"Honey Pot",unified:"1F36F",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["bees","sweet","kitchen"],sheet:[7,49]},snail:{name:"Snail",unified:"1F40C",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["slow","animal","shell"],sheet:[12,42]},pound:{name:"Banknote with Pound Sign",unified:"1F4B7",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["british","sterling","money","sales","bills","uk","england","currency"],sheet:[25,34]},fire_engine:{name:"Fire Engine",unified:"1F692",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["transportation","cars","vehicle"],sheet:[34,26]},baby_bottle:{name:"Baby Bottle",unified:"1F37C",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["food","container","milk"],sheet:[8,10]},"flag-fk":{name:"Falkland Islands Flag",unified:"1F1EB-1F1F0",non_qualified:null,has_img_apple:true,has_img_google:false,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[2,3]},butterfly:{name:"Butterfly",unified:"1F98B",non_qualified:null,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false,keywords:["animal","insect","nature","caterpillar"],sheet:[42,35]},money_with_wings:{name:"Money with Wings",unified:"1F4B8",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["dollar","bills","payment","sale"],sheet:[25,35]},face_with_monocle:{name:"Face with Monocle",unified:"1F9D0",non_qualified:null,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,sheet:[42,49]},police_car:{name:"Police Car",unified:"1F693",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["vehicle","cars","transportation","law","legal","enforcement"],sheet:[34,27]},arrow_up_small:{name:"Up-Pointing Small Red Triangle",unified:"1F53C",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["blue-square","triangle","direction","point","forward","top"],sheet:[28,10]},"flag-fm":{name:"Micronesia Flag",unified:"1F1EB-1F1F2",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[2,4]},glass_of_milk:{name:"Glass of Milk",unified:"1F95B",non_qualified:null,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false,sheet:[42,7]},credit_card:{name:"Credit Card",unified:"1F4B3",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["money","sales","dollar","bill","payment","shopping"],sheet:[25,30]},oncoming_police_car:{name:"Oncoming Police Car",unified:"1F694",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["vehicle","law","legal","enforcement","911"],sheet:[34,28]},bug:{name:"Bug",unified:"1F41B",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["animal","insect","nature","worm"],sheet:[13,5]},nerd_face:{name:"Nerd Face",unified:"1F913",non_qualified:null,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false,keywords:["face","nerdy","geek","dork"],sheet:[37,27]},arrow_double_up:{name:"Black Up-Pointing Double Triangle",unified:"23EB",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["blue-square","direction","top"],sheet:[46,47]},chart:{name:"Chart with Upwards Trend and Yen Sign",unified:"1F4B9",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["green-square","graph","presentation","stats"],sheet:[25,36]},"flag-fo":{name:"Faroe Islands Flag",unified:"1F1EB-1F1F4",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[2,5]},ant:{name:"Ant",unified:"1F41C",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["animal","insect","nature","bug"],sheet:[13,6]},arrow_down_small:{name:"Down-Pointing Small Red Triangle",unified:"1F53D",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["blue-square","direction","bottom"],sheet:[28,11]},smiling_imp:{name:"Smiling Face with Horns",unified:"1F608",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["devil","horns"],sheet:[30,32]},taxi:{name:"Taxi",unified:"1F695",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["uber","vehicle","cars","transportation"],sheet:[34,29]},coffee:{name:"Hot Beverage",unified:"2615",non_qualified:null,added_in:"4.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["beverage","caffeine","latte","espresso"],sheet:[47,24]},fr:{name:"France Flag",unified:"1F1EB-1F1F7",non_qualified:null,short_names:["flag-fr"],has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["banner","flag","nation","france","french","country"],sheet:[2,6]},oncoming_taxi:{name:"Oncoming Taxi",unified:"1F696",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["vehicle","cars","uber"],sheet:[34,30]},arrow_double_down:{name:"Black Down-Pointing Double Triangle",unified:"23EC",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["blue-square","direction","bottom"],sheet:[46,48]},imp:{name:"Imp",unified:"1F47F",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["devil","angry","horns"],sheet:[22,51]},currency_exchange:{name:"Currency Exchange",unified:"1F4B1",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["money","sales","dollar","travel"],sheet:[25,28]},tea:{name:"Teacup Without Handle",unified:"1F375",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["drink","bowl","breakfast","green","british"],sheet:[8,3]},bee:{name:"Honeybee",unified:"1F41D",non_qualified:null,short_names:["honeybee"],has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[13,7]},heavy_dollar_sign:{name:"Heavy Dollar Sign",unified:"1F4B2",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["money","sales","payment","currency","buck"],sheet:[25,29]},car:{name:"Automobile",unified:"1F697",non_qualified:null,short_names:["red_car"],has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[34,31]},sake:{name:"Sake Bottle and Cup",unified:"1F376",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["wine","drink","drunk","beverage","japanese","alcohol","booze"],sheet:[8,4]},"flag-ga":{name:"Gabon Flag",unified:"1F1EC-1F1E6",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[2,7]},beetle:{name:"Lady Beetle",unified:"1F41E",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["animal","insect","nature","ladybug"],sheet:[13,8]},japanese_ogre:{name:"Japanese Ogre",unified:"1F479",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["monster","red","mask","halloween","scary","creepy","devil","demon","japanese","ogre"],sheet:[22,40]},double_vertical_bar:{name:"Double Vertical Bar",unified:"23F8-FE0F",non_qualified:"23F8",added_in:"7.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,sheet:[47,4]},champagne:{name:"Bottle with Popping Cork",unified:"1F37E",non_qualified:null,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false,keywords:["drink","wine","bottle","celebration"],sheet:[8,12]},japanese_goblin:{name:"Japanese Goblin",unified:"1F47A",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["red","evil","mask","monster","scary","creepy","japanese","goblin"],sheet:[22,41]},black_square_for_stop:{name:"Black Square for Stop",unified:"23F9-FE0F",non_qualified:"23F9",added_in:"7.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,sheet:[47,5]},oncoming_automobile:{name:"Oncoming Automobile",unified:"1F698",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["car","vehicle","transportation"],sheet:[34,32]},email:{name:"Envelope",unified:"2709-FE0F",non_qualified:"2709",short_names:["envelope"],added_in:"1.1",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:true,keywords:["letter","postal","inbox","communication"],sheet:[49,17]},cricket:{name:"Cricket",unified:"1F997",non_qualified:null,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,keywords:["sports"],sheet:[42,47]},gb:{name:"United Kingdom Flag",unified:"1F1EC-1F1E7",non_qualified:null,short_names:["uk","flag-gb"],has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[2,8]},black_circle_for_record:{name:"Black Circle for Record",unified:"23FA-FE0F",non_qualified:"23FA",added_in:"7.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,sheet:[47,6]},"flag-gd":{name:"Grenada Flag",unified:"1F1EC-1F1E9",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[2,9]},spider:{name:"Spider",unified:"1F577-FE0F",non_qualified:"1F577",added_in:"7.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,keywords:["animal","arachnid"],sheet:[29,18]},blue_car:{name:"Recreational Vehicle",unified:"1F699",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["transportation","vehicle"],sheet:[34,33]},skull:{name:"Skull",unified:"1F480",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["dead","skeleton","creepy","death"],sheet:[23,0]},"e-mail":{name:"E-Mail Symbol",unified:"1F4E7",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["communication","inbox"],sheet:[26,30]},wine_glass:{name:"Wine Glass",unified:"1F377",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["drink","beverage","drunk","alcohol","booze"],sheet:[8,5]},spider_web:{name:"Spider Web",unified:"1F578-FE0F",non_qualified:"1F578",added_in:"7.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,keywords:["animal","insect","arachnid","silk"],sheet:[29,19]},cocktail:{name:"Cocktail Glass",unified:"1F378",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["drink","drunk","alcohol","beverage","booze","mojito"],sheet:[8,6]},skull_and_crossbones:{name:"Skull and Crossbones",unified:"2620-FE0F",non_qualified:"2620",added_in:"1.1",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,keywords:["poison","danger","deadly","scary","death","pirate","evil"],sheet:[47,32]},"flag-ge":{name:"Georgia Flag",unified:"1F1EC-1F1EA",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[2,10]},eject:{name:"Eject",unified:"23CF-FE0F",non_qualified:"23CF",added_in:"4.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,sheet:[46,44]},truck:{name:"Delivery Truck",unified:"1F69A",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["cars","transportation"],sheet:[34,34]},incoming_envelope:{name:"Incoming Envelope",unified:"1F4E8",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["email","inbox"],sheet:[26,31]},tropical_drink:{name:"Tropical Drink",unified:"1F379",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["beverage","cocktail","summer","beach","alcohol","booze","mojito"],sheet:[8,7]},scorpion:{name:"Scorpion",unified:"1F982",non_qualified:null,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false,keywords:["animal","arachnid"],sheet:[42,26]},cinema:{name:"Cinema",unified:"1F3A6",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["blue-square","record","film","movie","curtain","stage","theater"],sheet:[9,0]},articulated_lorry:{name:"Articulated Lorry",unified:"1F69B",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["vehicle","cars","transportation","express"],sheet:[34,35]},envelope_with_arrow:{name:"Envelope with Downwards Arrow Above",unified:"1F4E9",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["email","communication"],sheet:[26,32]},ghost:{name:"Ghost",unified:"1F47B",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["halloween","spooky","scary"],sheet:[22,42]},"flag-gf":{name:"French Guiana Flag",unified:"1F1EC-1F1EB",non_qualified:null,has_img_apple:true,has_img_google:false,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[2,11]},bouquet:{name:"Bouquet",unified:"1F490",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["flowers","nature","spring"],sheet:[24,42]},tractor:{name:"Tractor",unified:"1F69C",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["vehicle","car","farming","agriculture"],sheet:[34,36]},beer:{name:"Beer Mug",unified:"1F37A",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["relax","beverage","drink","drunk","party","pub","summer","alcohol","booze"],sheet:[8,8]},outbox_tray:{name:"Outbox Tray",unified:"1F4E4",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["inbox","email"],sheet:[26,27]},low_brightness:{name:"Low Brightness Symbol",unified:"1F505",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["sun","afternoon","warm","summer"],sheet:[27,7]},alien:{name:"Extraterrestrial Alien",unified:"1F47D",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["UFO","paul","weird","outer_space"],sheet:[22,49]},"flag-gg":{name:"Guernsey Flag",unified:"1F1EC-1F1EC",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[2,12]},cherry_blossom:{name:"Cherry Blossom",unified:"1F338",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["nature","plant","spring","flower"],sheet:[6,46]},inbox_tray:{name:"Inbox Tray",unified:"1F4E5",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["email","documents"],sheet:[26,28]},"flag-gh":{name:"Ghana Flag",unified:"1F1EC-1F1ED",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[2,13]},bike:{name:"Bicycle",unified:"1F6B2",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["sports","bicycle","exercise","hipster"],sheet:[35,23]},space_invader:{name:"Alien Monster",unified:"1F47E",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["game","arcade","play"],sheet:[22,50]},beers:{name:"Clinking Beer Mugs",unified:"1F37B",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["relax","beverage","drink","drunk","party","pub","summer","alcohol","booze"],sheet:[8,9]},high_brightness:{name:"High Brightness Symbol",unified:"1F506",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["sun","light"],sheet:[27,8]},package:{name:"Package",unified:"1F4E6",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["mail","gift","cardboard","box","moving"],sheet:[26,29]},scooter:{name:"Scooter",unified:"1F6F4",non_qualified:null,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false,sheet:[37,19]},white_flower:{name:"White Flower",unified:"1F4AE",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["japanese","spring"],sheet:[25,25]},clinking_glasses:{name:"Clinking Glasses",unified:"1F942",non_qualified:null,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false,keywords:["beverage","drink","party","alcohol","celebrate","cheers"],sheet:[41,38]},robot_face:{name:"Robot Face",unified:"1F916",non_qualified:null,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false,sheet:[37,30]},signal_strength:{name:"Antenna with Bars",unified:"1F4F6",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["blue-square","reception","phone","internet","connection","wifi","bluetooth","bars"],sheet:[26,45]},"flag-gi":{name:"Gibraltar Flag",unified:"1F1EC-1F1EE",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[2,14]},"flag-gl":{name:"Greenland Flag",unified:"1F1EC-1F1F1",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[2,15]},motor_scooter:{name:"Motor Scooter",unified:"1F6F5",non_qualified:null,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false,keywords:["vehicle","vespa","sasha"],sheet:[37,20]},mailbox:{name:"Closed Mailbox with Raised Flag",unified:"1F4EB",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["email","inbox","communication"],sheet:[26,34]},vibration_mode:{name:"Vibration Mode",unified:"1F4F3",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["orange-square","phone"],sheet:[26,42]},hankey:{name:"Pile of Poo",unified:"1F4A9",non_qualified:null,short_names:["poop","shit"],has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[25,15]},rosette:{name:"Rosette",unified:"1F3F5-FE0F",non_qualified:"1F3F5",added_in:"7.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,keywords:["flower","decoration","military"],sheet:[12,20]},tumbler_glass:{name:"Tumbler Glass",unified:"1F943",non_qualified:null,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false,keywords:["drink","beverage","drunk","alcohol","liquor","booze","bourbon","scotch","whisky","glass","shot"],sheet:[41,39]},cup_with_straw:{name:"Cup with Straw",unified:"1F964",non_qualified:null,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,keywords:["drink","soda"],sheet:[42,16]},"flag-gm":{name:"Gambia Flag",unified:"1F1EC-1F1F2",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[2,16]},mailbox_closed:{name:"Closed Mailbox with Lowered Flag",unified:"1F4EA",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["email","communication","inbox"],sheet:[26,33]},mobile_phone_off:{name:"Mobile Phone off",unified:"1F4F4",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["mute","orange-square","silence","quiet"],sheet:[26,43]},busstop:{name:"Bus Stop",unified:"1F68F",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["transportation","wait"],sheet:[34,23]},smiley_cat:{name:"Smiling Cat Face with Open Mouth",unified:"1F63A",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["animal","cats","happy","smile"],sheet:[31,30]},rose:{name:"Rose",unified:"1F339",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["flowers","valentines","love","spring"],sheet:[6,47]},motorway:{name:"Motorway",unified:"1F6E3-FE0F",non_qualified:"1F6E3",added_in:"7.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,keywords:["road","cupertino","interstate","highway"],sheet:[37,11]},smile_cat:{name:"Grinning Cat Face with Smiling Eyes",unified:"1F638",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["animal","cats","smile"],sheet:[31,28]},"flag-gn":{name:"Guinea Flag",unified:"1F1EC-1F1F3",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[2,17]},wilted_flower:{name:"Wilted Flower",unified:"1F940",non_qualified:null,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false,keywords:["plant","nature","flower"],sheet:[41,36]},mailbox_with_mail:{name:"Open Mailbox with Raised Flag",unified:"1F4EC",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["email","inbox","communication"],sheet:[26,35]},chopsticks:{name:"Chopsticks",unified:"1F962",non_qualified:null,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,keywords:["food"],sheet:[42,14]},female_sign:{name:"Female Sign",unified:"2640-FE0F",non_qualified:"2640",added_in:"1.1",has_img_apple:false,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,sheet:[47,42]},mailbox_with_no_mail:{name:"Open Mailbox with Lowered Flag",unified:"1F4ED",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["email","inbox"],sheet:[26,36]},knife_fork_plate:{name:"Knife Fork Plate",unified:"1F37D-FE0F",non_qualified:"1F37D",added_in:"7.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,sheet:[8,11]},hibiscus:{name:"Hibiscus",unified:"1F33A",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["plant","vegetable","flowers","beach"],sheet:[6,48]},"flag-gp":{name:"Guadeloupe Flag",unified:"1F1EC-1F1F5",non_qualified:null,has_img_apple:true,has_img_google:false,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[2,18]},railway_track:{name:"Railway Track",unified:"1F6E4-FE0F",non_qualified:"1F6E4",added_in:"7.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,keywords:["train","transportation"],sheet:[37,12]},male_sign:{name:"Male Sign",unified:"2642-FE0F",non_qualified:"2642",added_in:"1.1",has_img_apple:false,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,sheet:[47,43]},joy_cat:{name:"Cat Face with Tears of Joy",unified:"1F639",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["animal","cats","haha","happy","tears"],sheet:[31,29]},fuelpump:{name:"Fuel Pump",unified:"26FD",non_qualified:null,added_in:"5.2",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["gas station","petroleum"],sheet:[49,13]},sunflower:{name:"Sunflower",unified:"1F33B",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["nature","plant","fall"],sheet:[6,49]},postbox:{name:"Postbox",unified:"1F4EE",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["email","letter","envelope"],sheet:[26,37]},"flag-gq":{name:"Equatorial Guinea Flag",unified:"1F1EC-1F1F6",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[2,19]},heart_eyes_cat:{name:"Smiling Cat Face with Heart-Shaped Eyes",unified:"1F63B",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["animal","love","like","affection","cats","valentines","heart"],sheet:[31,31]},fork_and_knife:{name:"Fork and Knife",unified:"1F374",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["cutlery","kitchen"],sheet:[8,2]},medical_symbol:{name:"Medical Symbol",unified:"2695-FE0F",non_qualified:"2695",short_names:["staff_of_aesculapius"],added_in:"4.1",has_img_apple:false,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,sheet:[48,14]},recycle:{name:"Black Universal Recycling Symbol",unified:"267B-FE0F",non_qualified:"267B",added_in:"3.2",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:true,keywords:["arrow","environment","garbage","trash"],sheet:[48,9]},spoon:{name:"Spoon",unified:"1F944",non_qualified:null,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false,keywords:["cutlery","kitchen","tableware"],sheet:[41,40]},blossom:{name:"Blossom",unified:"1F33C",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["nature","flowers","yellow"],sheet:[6,50]},rotating_light:{name:"Police Cars Revolving Light",unified:"1F6A8",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["police","ambulance","911","emergency","alert","error","pinged","law","legal"],sheet:[35,13]},smirk_cat:{name:"Cat Face with Wry Smile",unified:"1F63C",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["animal","cats","smirk"],sheet:[31,32]},ballot_box_with_ballot:{name:"Ballot Box with Ballot",unified:"1F5F3-FE0F",non_qualified:"1F5F3",added_in:"7.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,sheet:[30,17]},"flag-gr":{name:"Greece Flag",unified:"1F1EC-1F1F7",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[2,20]},kissing_cat:{name:"Kissing Cat Face with Closed Eyes",unified:"1F63D",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["animal","cats","kiss"],sheet:[31,33]},"pencil2":{name:"Pencil",unified:"270F-FE0F",non_qualified:"270F",added_in:"1.1",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:true,keywords:["stationery","write","paper","writing","school","study"],sheet:[49,42]},traffic_light:{name:"Horizontal Traffic Light",unified:"1F6A5",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["transportation","signal"],sheet:[35,10]},fleur_de_lis:{name:"Fleur De Lis",unified:"269C-FE0F",non_qualified:"269C",added_in:"4.1",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,keywords:["decorative","scout"],sheet:[48,19]},tulip:{name:"Tulip",unified:"1F337",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["flowers","plant","nature","summer","spring"],sheet:[6,45]},hocho:{name:"Hocho",unified:"1F52A",non_qualified:null,short_names:["knife"],has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["knife","blade","cutlery","kitchen","weapon"],sheet:[27,44]},"flag-gs":{name:"South Georgia & South Sandwich Islands Flag",unified:"1F1EC-1F1F8",non_qualified:null,has_img_apple:true,has_img_google:false,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[2,21]},seedling:{name:"Seedling",unified:"1F331",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["plant","nature","grass","lawn","spring"],sheet:[6,39]},amphora:{name:"Amphora",unified:"1F3FA",non_qualified:null,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false,keywords:["vase","jar"],sheet:[12,24]},scream_cat:{name:"Weary Cat Face",unified:"1F640",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["animal","cats","munch","scared","scream"],sheet:[31,36]},vertical_traffic_light:{name:"Vertical Traffic Light",unified:"1F6A6",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["transportation","driving"],sheet:[35,11]},black_nib:{name:"Black Nib",unified:"2712-FE0F",non_qualified:"2712",added_in:"1.1",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:true,keywords:["pen","stationery","writing","write"],sheet:[49,43]},"flag-gt":{name:"Guatemala Flag",unified:"1F1EC-1F1F9",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[2,22]},trident:{name:"Trident Emblem",unified:"1F531",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["weapon","spear"],sheet:[27,51]},"flag-gu":{name:"Guam Flag",unified:"1F1EC-1F1FA",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[2,23]},name_badge:{name:"Name Badge",unified:"1F4DB",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["fire","forbid"],sheet:[26,18]},construction:{name:"Construction Sign",unified:"1F6A7",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["wip","progress","caution","warning"],sheet:[35,12]},lower_left_fountain_pen:{name:"Lower Left Fountain Pen",unified:"1F58B-FE0F",non_qualified:"1F58B",added_in:"7.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,sheet:[29,29]},evergreen_tree:{name:"Evergreen Tree",unified:"1F332",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["plant","nature"],sheet:[6,40]},crying_cat_face:{name:"Crying Cat Face",unified:"1F63F",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["animal","tears","weep","sad","cats","upset","cry"],sheet:[31,35]},"flag-gw":{name:"Guinea-Bissau Flag",unified:"1F1EC-1F1FC",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[2,24]},lower_left_ballpoint_pen:{name:"Lower Left Ballpoint Pen",unified:"1F58A-FE0F",non_qualified:"1F58A",added_in:"7.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,sheet:[29,28]},pouting_cat:{name:"Pouting Cat Face",unified:"1F63E",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["animal","cats"],sheet:[31,34]},deciduous_tree:{name:"Deciduous Tree",unified:"1F333",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["plant","nature"],sheet:[6,41]},octagonal_sign:{name:"Octagonal Sign",unified:"1F6D1",non_qualified:null,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false,sheet:[37,6]},beginner:{name:"Japanese Symbol for Beginner",unified:"1F530",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["badge","shield"],sheet:[27,50]},"flag-gy":{name:"Guyana Flag",unified:"1F1EC-1F1FE",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[2,25]},lower_left_paintbrush:{name:"Lower Left Paintbrush",unified:"1F58C-FE0F",non_qualified:"1F58C",added_in:"7.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,sheet:[29,30]},o:{name:"Heavy Large Circle",unified:"2B55",non_qualified:null,added_in:"5.2",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["circle","round"],sheet:[50,23]},palm_tree:{name:"Palm Tree",unified:"1F334",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["plant","vegetable","nature","summer","beach","mojito","tropical"],sheet:[6,42]},anchor:{name:"Anchor",unified:"2693",non_qualified:null,added_in:"4.1",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["ship","ferry","sea","boat"],sheet:[48,12]},see_no_evil:{name:"See-No-Evil Monkey",unified:"1F648",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["monkey","animal","nature","haha"],sheet:[32,43]},boat:{name:"Sailboat",unified:"26F5",non_qualified:null,short_names:["sailboat"],added_in:"5.2",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[48,43]},white_check_mark:{name:"White Heavy Check Mark",unified:"2705",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["green-square","ok","agree","vote","election","answer","tick"],sheet:[49,15]},"flag-hk":{name:"Hong Kong Sar China Flag",unified:"1F1ED-1F1F0",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[2,26]},lower_left_crayon:{name:"Lower Left Crayon",unified:"1F58D-FE0F",non_qualified:"1F58D",added_in:"7.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,sheet:[29,31]},hear_no_evil:{name:"Hear-No-Evil Monkey",unified:"1F649",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["animal","monkey","nature"],sheet:[32,44]},cactus:{name:"Cactus",unified:"1F335",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["vegetable","plant","nature"],sheet:[6,43]},ear_of_rice:{name:"Ear of Rice",unified:"1F33E",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["nature","plant"],sheet:[7,0]},speak_no_evil:{name:"Speak-No-Evil Monkey",unified:"1F64A",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["monkey","animal","nature","omg"],sheet:[32,45]},"flag-hm":{name:"Heard & Mcdonald Islands Flag",unified:"1F1ED-1F1F2",non_qualified:null,has_img_apple:true,has_img_google:false,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[2,27]},ballot_box_with_check:{name:"Ballot Box with Check",unified:"2611-FE0F",non_qualified:"2611",added_in:"1.1",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:true,keywords:["ok","agree","confirm","black-square","vote","election","yes","tick"],sheet:[47,22]},canoe:{name:"Canoe",unified:"1F6F6",non_qualified:null,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false,keywords:["boat","paddle","water","ship"],sheet:[37,21]},memo:{name:"Memo",unified:"1F4DD",non_qualified:null,short_names:["pencil"],has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["write","documents","stationery","pencil","paper","writing","legal","exam","quiz","test","study","compose"],sheet:[26,20]},herb:{name:"Herb",unified:"1F33F",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["vegetable","plant","medicine","weed","grass","lawn"],sheet:[7,1]},"flag-hn":{name:"Honduras Flag",unified:"1F1ED-1F1F3",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[2,28]},heavy_check_mark:{name:"Heavy Check Mark",unified:"2714-FE0F",non_qualified:"2714",added_in:"1.1",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:true,keywords:["ok","nike","answer","yes","tick"],sheet:[49,44]},briefcase:{name:"Briefcase",unified:"1F4BC",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["business","documents","work","law","legal","job","career"],sheet:[25,39]},speedboat:{name:"Speedboat",unified:"1F6A4",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["ship","transportation","vehicle","summer"],sheet:[35,9]},baby:{name:"Baby",unified:"1F476",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,skin_variations:{"1F3FB":{unified:"1F476-1F3FB",non_qualified:null,image:"1f476-1f3fb.png",sheet_x:22,sheet_y:11,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FC":{unified:"1F476-1F3FC",non_qualified:null,image:"1f476-1f3fc.png",sheet_x:22,sheet_y:12,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FD":{unified:"1F476-1F3FD",non_qualified:null,image:"1f476-1f3fd.png",sheet_x:22,sheet_y:13,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FE":{unified:"1F476-1F3FE",non_qualified:null,image:"1f476-1f3fe.png",sheet_x:22,sheet_y:14,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FF":{unified:"1F476-1F3FF",non_qualified:null,image:"1f476-1f3ff.png",sheet_x:22,sheet_y:15,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true}},keywords:["child","boy","girl","toddler"],sheet:[22,10]},heavy_multiplication_x:{name:"Heavy Multiplication X",unified:"2716-FE0F",non_qualified:"2716",added_in:"1.1",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:true,keywords:["math","calculation"],sheet:[49,45]},child:{name:"Child",unified:"1F9D2",non_qualified:null,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F9D2-1F3FB",non_qualified:null,image:"1f9d2-1f3fb.png",sheet_x:43,sheet_y:5,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FC":{unified:"1F9D2-1F3FC",non_qualified:null,image:"1f9d2-1f3fc.png",sheet_x:43,sheet_y:6,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FD":{unified:"1F9D2-1F3FD",non_qualified:null,image:"1f9d2-1f3fd.png",sheet_x:43,sheet_y:7,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FE":{unified:"1F9D2-1F3FE",non_qualified:null,image:"1f9d2-1f3fe.png",sheet_x:43,sheet_y:8,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FF":{unified:"1F9D2-1F3FF",non_qualified:null,image:"1f9d2-1f3ff.png",sheet_x:43,sheet_y:9,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false}},keywords:["gender-neutral","young"],sheet:[43,4]},shamrock:{name:"Shamrock",unified:"2618-FE0F",non_qualified:"2618",added_in:"4.1",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,keywords:["vegetable","plant","nature","irish","clover"],sheet:[47,25]},passenger_ship:{name:"Passenger Ship",unified:"1F6F3-FE0F",non_qualified:"1F6F3",added_in:"7.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,keywords:["yacht","cruise","ferry"],sheet:[37,18]},"flag-hr":{name:"Croatia Flag",unified:"1F1ED-1F1F7",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[2,29]},file_folder:{name:"File Folder",unified:"1F4C1",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["documents","business","office"],sheet:[25,44]},x:{name:"Cross Mark",unified:"274C",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["no","delete","remove","cancel"],sheet:[50,1]},four_leaf_clover:{name:"Four Leaf Clover",unified:"1F340",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["vegetable","plant","nature","lucky","irish"],sheet:[7,2]},open_file_folder:{name:"Open File Folder",unified:"1F4C2",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["documents","load"],sheet:[25,45]},boy:{name:"Boy",unified:"1F466",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,skin_variations:{"1F3FB":{unified:"1F466-1F3FB",non_qualified:null,image:"1f466-1f3fb.png",sheet_x:15,sheet_y:43,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FC":{unified:"1F466-1F3FC",non_qualified:null,image:"1f466-1f3fc.png",sheet_x:15,sheet_y:44,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FD":{unified:"1F466-1F3FD",non_qualified:null,image:"1f466-1f3fd.png",sheet_x:15,sheet_y:45,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FE":{unified:"1F466-1F3FE",non_qualified:null,image:"1f466-1f3fe.png",sheet_x:15,sheet_y:46,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FF":{unified:"1F466-1F3FF",non_qualified:null,image:"1f466-1f3ff.png",sheet_x:15,sheet_y:47,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true}},keywords:["man","male","guy","teenager"],sheet:[15,42]},ferry:{name:"Ferry",unified:"26F4-FE0F",non_qualified:"26F4",added_in:"5.2",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,keywords:["boat","ship","yacht"],sheet:[48,42]},"flag-ht":{name:"Haiti Flag",unified:"1F1ED-1F1F9",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[2,30]},girl:{name:"Girl",unified:"1F467",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,skin_variations:{"1F3FB":{unified:"1F467-1F3FB",non_qualified:null,image:"1f467-1f3fb.png",sheet_x:15,sheet_y:49,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FC":{unified:"1F467-1F3FC",non_qualified:null,image:"1f467-1f3fc.png",sheet_x:15,sheet_y:50,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FD":{unified:"1F467-1F3FD",non_qualified:null,image:"1f467-1f3fd.png",sheet_x:15,sheet_y:51,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FE":{unified:"1F467-1F3FE",non_qualified:null,image:"1f467-1f3fe.png",sheet_x:16,sheet_y:0,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FF":{unified:"1F467-1F3FF",non_qualified:null,image:"1f467-1f3ff.png",sheet_x:16,sheet_y:1,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true}},keywords:["female","woman","teenager"],sheet:[15,48]},negative_squared_cross_mark:{name:"Negative Squared Cross Mark",unified:"274E",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["x","green-square","no","deny"],sheet:[50,2]},"flag-hu":{name:"Hungary Flag",unified:"1F1ED-1F1FA",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[2,31]},card_index_dividers:{name:"Card Index Dividers",unified:"1F5C2-FE0F",non_qualified:"1F5C2",added_in:"7.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,keywords:["organizing","business","stationery"],sheet:[30,4]},maple_leaf:{name:"Maple Leaf",unified:"1F341",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["nature","plant","vegetable","ca","fall"],sheet:[7,3]},motor_boat:{name:"Motor Boat",unified:"1F6E5-FE0F",non_qualified:"1F6E5",added_in:"7.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,keywords:["ship"],sheet:[37,13]},"flag-ic":{name:"Canary Islands Flag",unified:"1F1EE-1F1E8",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[2,32]},fallen_leaf:{name:"Fallen Leaf",unified:"1F342",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["nature","plant","vegetable","leaves"],sheet:[7,4]},adult:{name:"Adult",unified:"1F9D1",non_qualified:null,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F9D1-1F3FB",non_qualified:null,image:"1f9d1-1f3fb.png",sheet_x:42,sheet_y:51,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FC":{unified:"1F9D1-1F3FC",non_qualified:null,image:"1f9d1-1f3fc.png",sheet_x:43,sheet_y:0,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FD":{unified:"1F9D1-1F3FD",non_qualified:null,image:"1f9d1-1f3fd.png",sheet_x:43,sheet_y:1,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FE":{unified:"1F9D1-1F3FE",non_qualified:null,image:"1f9d1-1f3fe.png",sheet_x:43,sheet_y:2,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FF":{unified:"1F9D1-1F3FF",non_qualified:null,image:"1f9d1-1f3ff.png",sheet_x:43,sheet_y:3,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false}},keywords:["gender-neutral","person"],sheet:[42,50]},ship:{name:"Ship",unified:"1F6A2",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["transportation","titanic","deploy"],sheet:[34,42]},heavy_plus_sign:{name:"Heavy Plus Sign",unified:"2795",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["math","calculation","addition","more","increase"],sheet:[50,9]},date:{name:"Calendar",unified:"1F4C5",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["calendar","schedule"],sheet:[25,48]},man:{name:"Man",unified:"1F468",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,skin_variations:{"1F3FB":{unified:"1F468-1F3FB",non_qualified:null,image:"1f468-1f3fb.png",sheet_x:18,sheet_y:12,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FC":{unified:"1F468-1F3FC",non_qualified:null,image:"1f468-1f3fc.png",sheet_x:18,sheet_y:13,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FD":{unified:"1F468-1F3FD",non_qualified:null,image:"1f468-1f3fd.png",sheet_x:18,sheet_y:14,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FE":{unified:"1F468-1F3FE",non_qualified:null,image:"1f468-1f3fe.png",sheet_x:18,sheet_y:15,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FF":{unified:"1F468-1F3FF",non_qualified:null,image:"1f468-1f3ff.png",sheet_x:18,sheet_y:16,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true}},keywords:["mustache","father","dad","guy","classy","sir","moustache"],sheet:[18,11]},"flag-id":{name:"Indonesia Flag",unified:"1F1EE-1F1E9",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[2,33]},leaves:{name:"Leaf Fluttering in Wind",unified:"1F343",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["nature","plant","tree","vegetable","grass","lawn","spring"],sheet:[7,5]},heavy_minus_sign:{name:"Heavy Minus Sign",unified:"2796",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["math","calculation","subtract","less"],sheet:[50,10]},calendar:{name:"Tear-off Calendar",unified:"1F4C6",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["schedule","date","planning"],sheet:[25,49]},airplane:{name:"Airplane",unified:"2708-FE0F",non_qualified:"2708",added_in:"1.1",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:true,keywords:["vehicle","transportation","flight","fly"],sheet:[49,16]},spiral_note_pad:{name:"Spiral Note Pad",unified:"1F5D2-FE0F",non_qualified:"1F5D2",added_in:"7.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,sheet:[30,8]},heavy_division_sign:{name:"Heavy Division Sign",unified:"2797",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["divide","math","calculation"],sheet:[50,11]},small_airplane:{name:"Small Airplane",unified:"1F6E9-FE0F",non_qualified:"1F6E9",added_in:"7.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,keywords:["flight","transportation","fly","vehicle"],sheet:[37,14]},woman:{name:"Woman",unified:"1F469",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,skin_variations:{"1F3FB":{unified:"1F469-1F3FB",non_qualified:null,image:"1f469-1f3fb.png",sheet_x:20,sheet_y:24,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FC":{unified:"1F469-1F3FC",non_qualified:null,image:"1f469-1f3fc.png",sheet_x:20,sheet_y:25,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FD":{unified:"1F469-1F3FD",non_qualified:null,image:"1f469-1f3fd.png",sheet_x:20,sheet_y:26,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FE":{unified:"1F469-1F3FE",non_qualified:null,image:"1f469-1f3fe.png",sheet_x:20,sheet_y:27,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FF":{unified:"1F469-1F3FF",non_qualified:null,image:"1f469-1f3ff.png",sheet_x:20,sheet_y:28,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true}},keywords:["female","girls","lady"],sheet:[20,23]},"flag-ie":{name:"Ireland Flag",unified:"1F1EE-1F1EA",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[2,34]},curly_loop:{name:"Curly Loop",unified:"27B0",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["scribble","draw","shape","squiggle"],sheet:[50,13]},"flag-il":{name:"Israel Flag",unified:"1F1EE-1F1F1",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[2,35]},airplane_departure:{name:"Airplane Departure",unified:"1F6EB",non_qualified:null,added_in:"7.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false,sheet:[37,15]},spiral_calendar_pad:{name:"Spiral Calendar Pad",unified:"1F5D3-FE0F",non_qualified:"1F5D3",added_in:"7.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,sheet:[30,9]},older_adult:{name:"Older Adult",unified:"1F9D3",non_qualified:null,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F9D3-1F3FB",non_qualified:null,image:"1f9d3-1f3fb.png",sheet_x:43,sheet_y:11,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FC":{unified:"1F9D3-1F3FC",non_qualified:null,image:"1f9d3-1f3fc.png",sheet_x:43,sheet_y:12,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FD":{unified:"1F9D3-1F3FD",non_qualified:null,image:"1f9d3-1f3fd.png",sheet_x:43,sheet_y:13,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FE":{unified:"1F9D3-1F3FE",non_qualified:null,image:"1f9d3-1f3fe.png",sheet_x:43,sheet_y:14,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FF":{unified:"1F9D3-1F3FF",non_qualified:null,image:"1f9d3-1f3ff.png",sheet_x:43,sheet_y:15,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false}},keywords:["human","elder","senior","gender-neutral"],sheet:[43,10]},airplane_arriving:{name:"Airplane Arriving",unified:"1F6EC",non_qualified:null,added_in:"7.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false,sheet:[37,16]},card_index:{name:"Card Index",unified:"1F4C7",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["business","stationery"],sheet:[25,50]},loop:{name:"Double Curly Loop",unified:"27BF",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["tape","cassette"],sheet:[50,14]},older_man:{name:"Older Man",unified:"1F474",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,skin_variations:{"1F3FB":{unified:"1F474-1F3FB",non_qualified:null,image:"1f474-1f3fb.png",sheet_x:21,sheet_y:51,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FC":{unified:"1F474-1F3FC",non_qualified:null,image:"1f474-1f3fc.png",sheet_x:22,sheet_y:0,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FD":{unified:"1F474-1F3FD",non_qualified:null,image:"1f474-1f3fd.png",sheet_x:22,sheet_y:1,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FE":{unified:"1F474-1F3FE",non_qualified:null,image:"1f474-1f3fe.png",sheet_x:22,sheet_y:2,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FF":{unified:"1F474-1F3FF",non_qualified:null,image:"1f474-1f3ff.png",sheet_x:22,sheet_y:3,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true}},keywords:["human","male","men","old","elder","senior"],sheet:[21,50]},"flag-im":{name:"Isle of Man Flag",unified:"1F1EE-1F1F2",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[2,36]},"flag-in":{name:"India Flag",unified:"1F1EE-1F1F3",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[2,37]},chart_with_upwards_trend:{name:"Chart with Upwards Trend",unified:"1F4C8",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["graph","presentation","stats","recovery","business","economics","money","sales","good","success"],sheet:[25,51]},part_alternation_mark:{name:"Part Alternation Mark",unified:"303D-FE0F",non_qualified:"303D",added_in:"3.2",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:true,keywords:["graph","presentation","stats","business","economics","bad"],sheet:[50,25]},seat:{name:"Seat",unified:"1F4BA",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["sit","airplane","transport","bus","flight","fly"],sheet:[25,37]},older_woman:{name:"Older Woman",unified:"1F475",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,skin_variations:{"1F3FB":{unified:"1F475-1F3FB",non_qualified:null,image:"1f475-1f3fb.png",sheet_x:22,sheet_y:5,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FC":{unified:"1F475-1F3FC",non_qualified:null,image:"1f475-1f3fc.png",sheet_x:22,sheet_y:6,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FD":{unified:"1F475-1F3FD",non_qualified:null,image:"1f475-1f3fd.png",sheet_x:22,sheet_y:7,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FE":{unified:"1F475-1F3FE",non_qualified:null,image:"1f475-1f3fe.png",sheet_x:22,sheet_y:8,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FF":{unified:"1F475-1F3FF",non_qualified:null,image:"1f475-1f3ff.png",sheet_x:22,sheet_y:9,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true}},keywords:["human","female","women","lady","old","elder","senior"],sheet:[22,4]},eight_spoked_asterisk:{name:"Eight Spoked Asterisk",unified:"2733-FE0F",non_qualified:"2733",added_in:"1.1",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:true,keywords:["star","sparkle","green-square"],sheet:[49,49]},chart_with_downwards_trend:{name:"Chart with Downwards Trend",unified:"1F4C9",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["graph","presentation","stats","recession","business","economics","money","sales","bad","failure"],sheet:[26,0]},"flag-io":{name:"British Indian Ocean Territory Flag",unified:"1F1EE-1F1F4",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[2,38]},"male-doctor":{name:"Male Doctor",unified:"1F468-200D-2695-FE0F",non_qualified:"1F468-200D-2695",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F468-1F3FB-200D-2695-FE0F",image:"1f468-1f3fb-200d-2695-fe0f.png",sheet_x:17,sheet_y:44,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FC":{unified:"1F468-1F3FC-200D-2695-FE0F",image:"1f468-1f3fc-200d-2695-fe0f.png",sheet_x:17,sheet_y:45,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FD":{unified:"1F468-1F3FD-200D-2695-FE0F",image:"1f468-1f3fd-200d-2695-fe0f.png",sheet_x:17,sheet_y:46,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FE":{unified:"1F468-1F3FE-200D-2695-FE0F",image:"1f468-1f3fe-200d-2695-fe0f.png",sheet_x:17,sheet_y:47,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FF":{unified:"1F468-1F3FF-200D-2695-FE0F",image:"1f468-1f3ff-200d-2695-fe0f.png",sheet_x:17,sheet_y:48,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false}},sheet:[17,43]},helicopter:{name:"Helicopter",unified:"1F681",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["transportation","vehicle","fly"],sheet:[34,9]},"female-doctor":{name:"Female Doctor",unified:"1F469-200D-2695-FE0F",non_qualified:"1F469-200D-2695",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F469-1F3FB-200D-2695-FE0F",image:"1f469-1f3fb-200d-2695-fe0f.png",sheet_x:20,sheet_y:2,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FC":{unified:"1F469-1F3FC-200D-2695-FE0F",image:"1f469-1f3fc-200d-2695-fe0f.png",sheet_x:20,sheet_y:3,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FD":{unified:"1F469-1F3FD-200D-2695-FE0F",image:"1f469-1f3fd-200d-2695-fe0f.png",sheet_x:20,sheet_y:4,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FE":{unified:"1F469-1F3FE-200D-2695-FE0F",image:"1f469-1f3fe-200d-2695-fe0f.png",sheet_x:20,sheet_y:5,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FF":{unified:"1F469-1F3FF-200D-2695-FE0F",image:"1f469-1f3ff-200d-2695-fe0f.png",sheet_x:20,sheet_y:6,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false}},sheet:[20,1]},suspension_railway:{name:"Suspension Railway",unified:"1F69F",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["vehicle","transportation"],sheet:[34,39]},bar_chart:{name:"Bar Chart",unified:"1F4CA",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["graph","presentation","stats"],sheet:[26,1]},"flag-iq":{name:"Iraq Flag",unified:"1F1EE-1F1F6",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[2,39]},eight_pointed_black_star:{name:"Eight Pointed Black Star",unified:"2734-FE0F",non_qualified:"2734",added_in:"1.1",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:true,keywords:["orange-square","shape","polygon"],sheet:[49,50]},mountain_cableway:{name:"Mountain Cableway",unified:"1F6A0",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["transportation","vehicle","ski"],sheet:[34,40]},"male-student":{name:"Male Student",unified:"1F468-200D-1F393",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F468-1F3FB-200D-1F393",image:"1f468-1f3fb-200d-1f393.png",sheet_x:16,sheet_y:15,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FC":{unified:"1F468-1F3FC-200D-1F393",image:"1f468-1f3fc-200d-1f393.png",sheet_x:16,sheet_y:16,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FD":{unified:"1F468-1F3FD-200D-1F393",image:"1f468-1f3fd-200d-1f393.png",sheet_x:16,sheet_y:17,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FE":{unified:"1F468-1F3FE-200D-1F393",image:"1f468-1f3fe-200d-1f393.png",sheet_x:16,sheet_y:18,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FF":{unified:"1F468-1F3FF-200D-1F393",image:"1f468-1f3ff-200d-1f393.png",sheet_x:16,sheet_y:19,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false}},sheet:[16,14]},clipboard:{name:"Clipboard",unified:"1F4CB",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["stationery","documents"],sheet:[26,2]},"flag-ir":{name:"Iran Flag",unified:"1F1EE-1F1F7",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[2,40]},sparkle:{name:"Sparkle",unified:"2747-FE0F",non_qualified:"2747",added_in:"1.1",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:true,keywords:["stars","green-square","awesome","good","fireworks"],sheet:[50,0]},"female-student":{name:"Female Student",unified:"1F469-200D-1F393",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F469-1F3FB-200D-1F393",image:"1f469-1f3fb-200d-1f393.png",sheet_x:18,sheet_y:30,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FC":{unified:"1F469-1F3FC-200D-1F393",image:"1f469-1f3fc-200d-1f393.png",sheet_x:18,sheet_y:31,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FD":{unified:"1F469-1F3FD-200D-1F393",image:"1f469-1f3fd-200d-1f393.png",sheet_x:18,sheet_y:32,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FE":{unified:"1F469-1F3FE-200D-1F393",image:"1f469-1f3fe-200d-1f393.png",sheet_x:18,sheet_y:33,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FF":{unified:"1F469-1F3FF-200D-1F393",image:"1f469-1f3ff-200d-1f393.png",sheet_x:18,sheet_y:34,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false}},sheet:[18,29]},pushpin:{name:"Pushpin",unified:"1F4CC",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["stationery","mark","here"],sheet:[26,3]},aerial_tramway:{name:"Aerial Tramway",unified:"1F6A1",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["transportation","vehicle","ski"],sheet:[34,41]},"flag-is":{name:"Iceland Flag",unified:"1F1EE-1F1F8",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[2,41]},bangbang:{name:"Double Exclamation Mark",unified:"203C-FE0F",non_qualified:"203C",added_in:"1.1",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:true,keywords:["exclamation","surprise"],sheet:[46,29]},interrobang:{name:"Exclamation Question Mark",unified:"2049-FE0F",non_qualified:"2049",added_in:"3.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:true,keywords:["wat","punctuation","surprise"],sheet:[46,30]},satellite:{name:"Satellite",unified:"1F6F0-FE0F",non_qualified:"1F6F0",added_in:"7.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,keywords:["communication","future","radio","space"],sheet:[37,17]},it:{name:"Italy Flag",unified:"1F1EE-1F1F9",non_qualified:null,short_names:["flag-it"],has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["italy","flag","nation","country","banner"],sheet:[2,42]},"male-teacher":{name:"Male Teacher",unified:"1F468-200D-1F3EB",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F468-1F3FB-200D-1F3EB",image:"1f468-1f3fb-200d-1f3eb.png",sheet_x:16,sheet_y:33,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FC":{unified:"1F468-1F3FC-200D-1F3EB",image:"1f468-1f3fc-200d-1f3eb.png",sheet_x:16,sheet_y:34,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FD":{unified:"1F468-1F3FD-200D-1F3EB",image:"1f468-1f3fd-200d-1f3eb.png",sheet_x:16,sheet_y:35,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FE":{unified:"1F468-1F3FE-200D-1F3EB",image:"1f468-1f3fe-200d-1f3eb.png",sheet_x:16,sheet_y:36,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FF":{unified:"1F468-1F3FF-200D-1F3EB",image:"1f468-1f3ff-200d-1f3eb.png",sheet_x:16,sheet_y:37,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false}},sheet:[16,32]},round_pushpin:{name:"Round Pushpin",unified:"1F4CD",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["stationery","location","map","here"],sheet:[26,4]},"flag-je":{name:"Jersey Flag",unified:"1F1EF-1F1EA",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[2,43]},question:{name:"Black Question Mark Ornament",unified:"2753",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["doubt","confused"],sheet:[50,3]},rocket:{name:"Rocket",unified:"1F680",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["launch","ship","staffmode","NASA","outer space","outer_space","fly"],sheet:[34,8]},"female-teacher":{name:"Female Teacher",unified:"1F469-200D-1F3EB",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F469-1F3FB-200D-1F3EB",image:"1f469-1f3fb-200d-1f3eb.png",sheet_x:18,sheet_y:48,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FC":{unified:"1F469-1F3FC-200D-1F3EB",image:"1f469-1f3fc-200d-1f3eb.png",sheet_x:18,sheet_y:49,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FD":{unified:"1F469-1F3FD-200D-1F3EB",image:"1f469-1f3fd-200d-1f3eb.png",sheet_x:18,sheet_y:50,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FE":{unified:"1F469-1F3FE-200D-1F3EB",image:"1f469-1f3fe-200d-1f3eb.png",sheet_x:18,sheet_y:51,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FF":{unified:"1F469-1F3FF-200D-1F3EB",image:"1f469-1f3ff-200d-1f3eb.png",sheet_x:19,sheet_y:0,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false}},sheet:[18,47]},paperclip:{name:"Paperclip",unified:"1F4CE",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["documents","stationery"],sheet:[26,5]},linked_paperclips:{name:"Linked Paperclips",unified:"1F587-FE0F",non_qualified:"1F587",added_in:"7.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,sheet:[29,27]},flying_saucer:{name:"Flying Saucer",unified:"1F6F8",non_qualified:null,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,keywords:["transportation","vehicle","ufo"],sheet:[37,23]},"male-judge":{name:"Male Judge",unified:"1F468-200D-2696-FE0F",non_qualified:"1F468-200D-2696",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F468-1F3FB-200D-2696-FE0F",image:"1f468-1f3fb-200d-2696-fe0f.png",sheet_x:17,sheet_y:50,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FC":{unified:"1F468-1F3FC-200D-2696-FE0F",image:"1f468-1f3fc-200d-2696-fe0f.png",sheet_x:17,sheet_y:51,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FD":{unified:"1F468-1F3FD-200D-2696-FE0F",image:"1f468-1f3fd-200d-2696-fe0f.png",sheet_x:18,sheet_y:0,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FE":{unified:"1F468-1F3FE-200D-2696-FE0F",image:"1f468-1f3fe-200d-2696-fe0f.png",sheet_x:18,sheet_y:1,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FF":{unified:"1F468-1F3FF-200D-2696-FE0F",image:"1f468-1f3ff-200d-2696-fe0f.png",sheet_x:18,sheet_y:2,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false}},sheet:[17,49]},grey_question:{name:"White Question Mark Ornament",unified:"2754",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["doubts","gray","huh","confused"],sheet:[50,4]},"flag-jm":{name:"Jamaica Flag",unified:"1F1EF-1F1F2",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[2,44]},bellhop_bell:{name:"Bellhop Bell",unified:"1F6CE-FE0F",non_qualified:"1F6CE",added_in:"7.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,keywords:["service"],sheet:[37,3]},straight_ruler:{name:"Straight Ruler",unified:"1F4CF",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["stationery","calculate","length","math","school","drawing","architect","sketch"],sheet:[26,6]},"flag-jo":{name:"Jordan Flag",unified:"1F1EF-1F1F4",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[2,45]},"female-judge":{name:"Female Judge",unified:"1F469-200D-2696-FE0F",non_qualified:"1F469-200D-2696",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F469-1F3FB-200D-2696-FE0F",image:"1f469-1f3fb-200d-2696-fe0f.png",sheet_x:20,sheet_y:8,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FC":{unified:"1F469-1F3FC-200D-2696-FE0F",image:"1f469-1f3fc-200d-2696-fe0f.png",sheet_x:20,sheet_y:9,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FD":{unified:"1F469-1F3FD-200D-2696-FE0F",image:"1f469-1f3fd-200d-2696-fe0f.png",sheet_x:20,sheet_y:10,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FE":{unified:"1F469-1F3FE-200D-2696-FE0F",image:"1f469-1f3fe-200d-2696-fe0f.png",sheet_x:20,sheet_y:11,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FF":{unified:"1F469-1F3FF-200D-2696-FE0F",image:"1f469-1f3ff-200d-2696-fe0f.png",sheet_x:20,sheet_y:12,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false}},sheet:[20,7]},grey_exclamation:{name:"White Exclamation Mark Ornament",unified:"2755",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["surprise","punctuation","gray","wow","warning"],sheet:[50,5]},door:{name:"Door",unified:"1F6AA",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["house","entry","exit"],sheet:[35,15]},"male-farmer":{name:"Male Farmer",unified:"1F468-200D-1F33E",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F468-1F3FB-200D-1F33E",image:"1f468-1f3fb-200d-1f33e.png",sheet_x:16,sheet_y:3,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FC":{unified:"1F468-1F3FC-200D-1F33E",image:"1f468-1f3fc-200d-1f33e.png",sheet_x:16,sheet_y:4,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FD":{unified:"1F468-1F3FD-200D-1F33E",image:"1f468-1f3fd-200d-1f33e.png",sheet_x:16,sheet_y:5,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FE":{unified:"1F468-1F3FE-200D-1F33E",image:"1f468-1f3fe-200d-1f33e.png",sheet_x:16,sheet_y:6,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FF":{unified:"1F468-1F3FF-200D-1F33E",image:"1f468-1f3ff-200d-1f33e.png",sheet_x:16,sheet_y:7,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false}},sheet:[16,2]},jp:{name:"Japan Flag",unified:"1F1EF-1F1F5",non_qualified:null,short_names:["flag-jp"],has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["japanese","nation","flag","country","banner"],sheet:[2,46]},triangular_ruler:{name:"Triangular Ruler",unified:"1F4D0",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["stationery","math","architect","sketch"],sheet:[26,7]},exclamation:{name:"Heavy Exclamation Mark Symbol",unified:"2757",non_qualified:null,short_names:["heavy_exclamation_mark"],added_in:"5.2",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["heavy_exclamation_mark","danger","surprise","punctuation","wow","warning"],sheet:[50,6]},bed:{name:"Bed",unified:"1F6CF-FE0F",non_qualified:"1F6CF",added_in:"7.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,keywords:["sleep","rest"],sheet:[37,4]},"female-farmer":{name:"Female Farmer",unified:"1F469-200D-1F33E",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F469-1F3FB-200D-1F33E",image:"1f469-1f3fb-200d-1f33e.png",sheet_x:18,sheet_y:18,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FC":{unified:"1F469-1F3FC-200D-1F33E",image:"1f469-1f3fc-200d-1f33e.png",sheet_x:18,sheet_y:19,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FD":{unified:"1F469-1F3FD-200D-1F33E",image:"1f469-1f3fd-200d-1f33e.png",sheet_x:18,sheet_y:20,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FE":{unified:"1F469-1F3FE-200D-1F33E",image:"1f469-1f3fe-200d-1f33e.png",sheet_x:18,sheet_y:21,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FF":{unified:"1F469-1F3FF-200D-1F33E",image:"1f469-1f3ff-200d-1f33e.png",sheet_x:18,sheet_y:22,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false}},sheet:[18,17]},scissors:{name:"Black Scissors",unified:"2702-FE0F",non_qualified:"2702",added_in:"1.1",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:true,keywords:["stationery","cut"],sheet:[49,14]},wavy_dash:{name:"Wavy Dash",unified:"3030-FE0F",non_qualified:"3030",added_in:"1.1",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:true,keywords:["draw","line","moustache","mustache","squiggle","scribble"],sheet:[50,24]},"flag-ke":{name:"Kenya Flag",unified:"1F1F0-1F1EA",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[2,47]},"flag-kg":{name:"Kyrgyzstan Flag",unified:"1F1F0-1F1EC",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[2,48]},couch_and_lamp:{name:"Couch and Lamp",unified:"1F6CB-FE0F",non_qualified:"1F6CB",added_in:"7.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,keywords:["read","chill"],sheet:[36,47]},"male-cook":{name:"Male Cook",unified:"1F468-200D-1F373",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F468-1F3FB-200D-1F373",image:"1f468-1f3fb-200d-1f373.png",sheet_x:16,sheet_y:9,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FC":{unified:"1F468-1F3FC-200D-1F373",image:"1f468-1f3fc-200d-1f373.png",sheet_x:16,sheet_y:10,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FD":{unified:"1F468-1F3FD-200D-1F373",image:"1f468-1f3fd-200d-1f373.png",sheet_x:16,sheet_y:11,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FE":{unified:"1F468-1F3FE-200D-1F373",image:"1f468-1f3fe-200d-1f373.png",sheet_x:16,sheet_y:12,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FF":{unified:"1F468-1F3FF-200D-1F373",image:"1f468-1f3ff-200d-1f373.png",sheet_x:16,sheet_y:13,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false}},sheet:[16,8]},card_file_box:{name:"Card File Box",unified:"1F5C3-FE0F",non_qualified:"1F5C3",added_in:"7.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,keywords:["business","stationery"],sheet:[30,5]},copyright:{name:"Copyright Sign",unified:"00A9-FE0F",non_qualified:"00A9",added_in:"1.1",has_img_apple:true,has_img_google:true,has_img_twitter:false,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false,keywords:["ip","license","circle","law","legal"],sheet:[0,12]},file_cabinet:{name:"File Cabinet",unified:"1F5C4-FE0F",non_qualified:"1F5C4",added_in:"7.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,keywords:["filing","organizing"],sheet:[30,6]},registered:{name:"Registered Sign",unified:"00AE-FE0F",non_qualified:"00AE",added_in:"1.1",has_img_apple:true,has_img_google:true,has_img_twitter:false,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false,keywords:["alphabet","circle"],sheet:[0,13]},"flag-kh":{name:"Cambodia Flag",unified:"1F1F0-1F1ED",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[2,49]},"female-cook":{name:"Female Cook",unified:"1F469-200D-1F373",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F469-1F3FB-200D-1F373",image:"1f469-1f3fb-200d-1f373.png",sheet_x:18,sheet_y:24,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FC":{unified:"1F469-1F3FC-200D-1F373",image:"1f469-1f3fc-200d-1f373.png",sheet_x:18,sheet_y:25,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FD":{unified:"1F469-1F3FD-200D-1F373",image:"1f469-1f3fd-200d-1f373.png",sheet_x:18,sheet_y:26,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FE":{unified:"1F469-1F3FE-200D-1F373",image:"1f469-1f3fe-200d-1f373.png",sheet_x:18,sheet_y:27,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FF":{unified:"1F469-1F3FF-200D-1F373",image:"1f469-1f3ff-200d-1f373.png",sheet_x:18,sheet_y:28,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false}},sheet:[18,23]},toilet:{name:"Toilet",unified:"1F6BD",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["restroom","wc","washroom","bathroom","potty"],sheet:[36,33]},wastebasket:{name:"Wastebasket",unified:"1F5D1-FE0F",non_qualified:"1F5D1",added_in:"7.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,keywords:["bin","trash","rubbish","garbage","toss"],sheet:[30,7]},"flag-ki":{name:"Kiribati Flag",unified:"1F1F0-1F1EE",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[2,50]},shower:{name:"Shower",unified:"1F6BF",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["clean","water","bathroom"],sheet:[36,35]},"male-mechanic":{name:"Male Mechanic",unified:"1F468-200D-1F527",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F468-1F3FB-200D-1F527",image:"1f468-1f3fb-200d-1f527.png",sheet_x:17,sheet_y:20,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FC":{unified:"1F468-1F3FC-200D-1F527",image:"1f468-1f3fc-200d-1f527.png",sheet_x:17,sheet_y:21,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FD":{unified:"1F468-1F3FD-200D-1F527",image:"1f468-1f3fd-200d-1f527.png",sheet_x:17,sheet_y:22,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FE":{unified:"1F468-1F3FE-200D-1F527",image:"1f468-1f3fe-200d-1f527.png",sheet_x:17,sheet_y:23,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FF":{unified:"1F468-1F3FF-200D-1F527",image:"1f468-1f3ff-200d-1f527.png",sheet_x:17,sheet_y:24,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false}},sheet:[17,19]},tm:{name:"Trade Mark Sign",unified:"2122-FE0F",non_qualified:"2122",added_in:"1.1",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:true,keywords:["trademark","brand","law","legal"],sheet:[46,31]},hash:{name:"Hash Key",unified:"0023-FE0F-20E3",non_qualified:"0023-20E3",added_in:"3.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false,keywords:["symbol","blue-square","twitter"],sheet:[0,0]},"flag-km":{name:"Comoros Flag",unified:"1F1F0-1F1F2",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[2,51]},bathtub:{name:"Bathtub",unified:"1F6C1",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["clean","shower","bathroom"],sheet:[36,42]},"female-mechanic":{name:"Female Mechanic",unified:"1F469-200D-1F527",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F469-1F3FB-200D-1F527",image:"1f469-1f3fb-200d-1f527.png",sheet_x:19,sheet_y:30,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FC":{unified:"1F469-1F3FC-200D-1F527",image:"1f469-1f3fc-200d-1f527.png",sheet_x:19,sheet_y:31,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FD":{unified:"1F469-1F3FD-200D-1F527",image:"1f469-1f3fd-200d-1f527.png",sheet_x:19,sheet_y:32,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FE":{unified:"1F469-1F3FE-200D-1F527",image:"1f469-1f3fe-200d-1f527.png",sheet_x:19,sheet_y:33,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FF":{unified:"1F469-1F3FF-200D-1F527",image:"1f469-1f3ff-200d-1f527.png",sheet_x:19,sheet_y:34,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false}},sheet:[19,29]},lock:{name:"Lock",unified:"1F512",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["security","password","padlock"],sheet:[27,20]},"male-factory-worker":{name:"Male Factory Worker",unified:"1F468-200D-1F3ED",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F468-1F3FB-200D-1F3ED",image:"1f468-1f3fb-200d-1f3ed.png",sheet_x:16,sheet_y:39,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FC":{unified:"1F468-1F3FC-200D-1F3ED",image:"1f468-1f3fc-200d-1f3ed.png",sheet_x:16,sheet_y:40,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FD":{unified:"1F468-1F3FD-200D-1F3ED",image:"1f468-1f3fd-200d-1f3ed.png",sheet_x:16,sheet_y:41,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FE":{unified:"1F468-1F3FE-200D-1F3ED",image:"1f468-1f3fe-200d-1f3ed.png",sheet_x:16,sheet_y:42,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FF":{unified:"1F468-1F3FF-200D-1F3ED",image:"1f468-1f3ff-200d-1f3ed.png",sheet_x:16,sheet_y:43,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false}},sheet:[16,38]},"flag-kn":{name:"St. Kitts & Nevis Flag",unified:"1F1F0-1F1F3",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[3,0]},hourglass:{name:"Hourglass",unified:"231B",non_qualified:null,added_in:"1.1",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["time","clock","oldschool","limit","exam","quiz","test"],sheet:[46,42]},keycap_star:{name:"Keycap Star",unified:"002A-FE0F-20E3",non_qualified:"002A-20E3",added_in:"3.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false,sheet:[0,1]},unlock:{name:"Open Lock",unified:"1F513",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["privacy","security"],sheet:[27,21]},"flag-kp":{name:"North Korea Flag",unified:"1F1F0-1F1F5",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[3,1]},"female-factory-worker":{name:"Female Factory Worker",unified:"1F469-200D-1F3ED",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F469-1F3FB-200D-1F3ED",image:"1f469-1f3fb-200d-1f3ed.png",sheet_x:19,sheet_y:2,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FC":{unified:"1F469-1F3FC-200D-1F3ED",image:"1f469-1f3fc-200d-1f3ed.png",sheet_x:19,sheet_y:3,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FD":{unified:"1F469-1F3FD-200D-1F3ED",image:"1f469-1f3fd-200d-1f3ed.png",sheet_x:19,sheet_y:4,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FE":{unified:"1F469-1F3FE-200D-1F3ED",image:"1f469-1f3fe-200d-1f3ed.png",sheet_x:19,sheet_y:5,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FF":{unified:"1F469-1F3FF-200D-1F3ED",image:"1f469-1f3ff-200d-1f3ed.png",sheet_x:19,sheet_y:6,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false}},sheet:[19,1]},zero:{name:"Keycap 0",unified:"0030-FE0F-20E3",non_qualified:"0030-20E3",added_in:"3.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false,keywords:["0","numbers","blue-square","null"],sheet:[0,2]},lock_with_ink_pen:{name:"Lock with Ink Pen",unified:"1F50F",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["security","secret"],sheet:[27,17]},hourglass_flowing_sand:{name:"Hourglass with Flowing Sand",unified:"23F3",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["oldschool","time","countdown"],sheet:[47,3]},one:{name:"Keycap 1",unified:"0031-FE0F-20E3",non_qualified:"0031-20E3",added_in:"3.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false,keywords:["blue-square","numbers","1"],sheet:[0,3]},kr:{name:"South Korea Flag",unified:"1F1F0-1F1F7",non_qualified:null,short_names:["flag-kr"],has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["south","korea","nation","flag","country","banner"],sheet:[3,2]},watch:{name:"Watch",unified:"231A",non_qualified:null,added_in:"1.1",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["time","accessories"],sheet:[46,41]},"male-office-worker":{name:"Male Office Worker",unified:"1F468-200D-1F4BC",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F468-1F3FB-200D-1F4BC",image:"1f468-1f3fb-200d-1f4bc.png",sheet_x:17,sheet_y:14,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FC":{unified:"1F468-1F3FC-200D-1F4BC",image:"1f468-1f3fc-200d-1f4bc.png",sheet_x:17,sheet_y:15,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FD":{unified:"1F468-1F3FD-200D-1F4BC",image:"1f468-1f3fd-200d-1f4bc.png",sheet_x:17,sheet_y:16,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FE":{unified:"1F468-1F3FE-200D-1F4BC",image:"1f468-1f3fe-200d-1f4bc.png",sheet_x:17,sheet_y:17,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FF":{unified:"1F468-1F3FF-200D-1F4BC",image:"1f468-1f3ff-200d-1f4bc.png",sheet_x:17,sheet_y:18,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false}},sheet:[17,13]},closed_lock_with_key:{name:"Closed Lock with Key",unified:"1F510",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["security","privacy"],sheet:[27,18]},"female-office-worker":{name:"Female Office Worker",unified:"1F469-200D-1F4BC",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F469-1F3FB-200D-1F4BC",image:"1f469-1f3fb-200d-1f4bc.png",sheet_x:19,sheet_y:24,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FC":{unified:"1F469-1F3FC-200D-1F4BC",image:"1f469-1f3fc-200d-1f4bc.png",sheet_x:19,sheet_y:25,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FD":{unified:"1F469-1F3FD-200D-1F4BC",image:"1f469-1f3fd-200d-1f4bc.png",sheet_x:19,sheet_y:26,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FE":{unified:"1F469-1F3FE-200D-1F4BC",image:"1f469-1f3fe-200d-1f4bc.png",sheet_x:19,sheet_y:27,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FF":{unified:"1F469-1F3FF-200D-1F4BC",image:"1f469-1f3ff-200d-1f4bc.png",sheet_x:19,sheet_y:28,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false}},sheet:[19,23]},two:{name:"Keycap 2",unified:"0032-FE0F-20E3",non_qualified:"0032-20E3",added_in:"3.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false,keywords:["numbers","2","prime","blue-square"],sheet:[0,4]},alarm_clock:{name:"Alarm Clock",unified:"23F0",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["time","wake"],sheet:[47,0]},key:{name:"Key",unified:"1F511",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["lock","door","password"],sheet:[27,19]},"flag-kw":{name:"Kuwait Flag",unified:"1F1F0-1F1FC",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[3,3]},stopwatch:{name:"Stopwatch",unified:"23F1-FE0F",non_qualified:"23F1",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,keywords:["time","deadline"],sheet:[47,1]},"male-scientist":{name:"Male Scientist",unified:"1F468-200D-1F52C",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F468-1F3FB-200D-1F52C",image:"1f468-1f3fb-200d-1f52c.png",sheet_x:17,sheet_y:26,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FC":{unified:"1F468-1F3FC-200D-1F52C",image:"1f468-1f3fc-200d-1f52c.png",sheet_x:17,sheet_y:27,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FD":{unified:"1F468-1F3FD-200D-1F52C",image:"1f468-1f3fd-200d-1f52c.png",sheet_x:17,sheet_y:28,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FE":{unified:"1F468-1F3FE-200D-1F52C",image:"1f468-1f3fe-200d-1f52c.png",sheet_x:17,sheet_y:29,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FF":{unified:"1F468-1F3FF-200D-1F52C",image:"1f468-1f3ff-200d-1f52c.png",sheet_x:17,sheet_y:30,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false}},sheet:[17,25]},three:{name:"Keycap 3",unified:"0033-FE0F-20E3",non_qualified:"0033-20E3",added_in:"3.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false,keywords:["3","numbers","prime","blue-square"],sheet:[0,5]},"flag-ky":{name:"Cayman Islands Flag",unified:"1F1F0-1F1FE",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[3,4]},old_key:{name:"Old Key",unified:"1F5DD-FE0F",non_qualified:"1F5DD",added_in:"7.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,keywords:["lock","door","password"],sheet:[30,11]},"flag-kz":{name:"Kazakhstan Flag",unified:"1F1F0-1F1FF",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[3,5]},hammer:{name:"Hammer",unified:"1F528",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["tools","build","create"],sheet:[27,42]},"female-scientist":{name:"Female Scientist",unified:"1F469-200D-1F52C",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F469-1F3FB-200D-1F52C",image:"1f469-1f3fb-200d-1f52c.png",sheet_x:19,sheet_y:36,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FC":{unified:"1F469-1F3FC-200D-1F52C",image:"1f469-1f3fc-200d-1f52c.png",sheet_x:19,sheet_y:37,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FD":{unified:"1F469-1F3FD-200D-1F52C",image:"1f469-1f3fd-200d-1f52c.png",sheet_x:19,sheet_y:38,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FE":{unified:"1F469-1F3FE-200D-1F52C",image:"1f469-1f3fe-200d-1f52c.png",sheet_x:19,sheet_y:39,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FF":{unified:"1F469-1F3FF-200D-1F52C",image:"1f469-1f3ff-200d-1f52c.png",sheet_x:19,sheet_y:40,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false}},sheet:[19,35]},timer_clock:{name:"Timer Clock",unified:"23F2-FE0F",non_qualified:"23F2",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,keywords:["alarm"],sheet:[47,2]},four:{name:"Keycap 4",unified:"0034-FE0F-20E3",non_qualified:"0034-20E3",added_in:"3.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false,keywords:["4","numbers","blue-square"],sheet:[0,6]},"male-technologist":{name:"Male Technologist",unified:"1F468-200D-1F4BB",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F468-1F3FB-200D-1F4BB",image:"1f468-1f3fb-200d-1f4bb.png",sheet_x:17,sheet_y:8,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FC":{unified:"1F468-1F3FC-200D-1F4BB",image:"1f468-1f3fc-200d-1f4bb.png",sheet_x:17,sheet_y:9,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FD":{unified:"1F468-1F3FD-200D-1F4BB",image:"1f468-1f3fd-200d-1f4bb.png",sheet_x:17,sheet_y:10,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FE":{unified:"1F468-1F3FE-200D-1F4BB",image:"1f468-1f3fe-200d-1f4bb.png",sheet_x:17,sheet_y:11,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FF":{unified:"1F468-1F3FF-200D-1F4BB",image:"1f468-1f3ff-200d-1f4bb.png",sheet_x:17,sheet_y:12,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false}},sheet:[17,7]},mantelpiece_clock:{name:"Mantelpiece Clock",unified:"1F570-FE0F",non_qualified:"1F570",added_in:"7.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,keywords:["time"],sheet:[28,43]},five:{name:"Keycap 5",unified:"0035-FE0F-20E3",non_qualified:"0035-20E3",added_in:"3.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false,keywords:["5","numbers","blue-square","prime"],sheet:[0,7]},"flag-la":{name:"Laos Flag",unified:"1F1F1-1F1E6",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[3,6]},pick:{name:"Pick",unified:"26CF-FE0F",non_qualified:"26CF",added_in:"5.2",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,keywords:["tools","dig"],sheet:[48,32]},"flag-lb":{name:"Lebanon Flag",unified:"1F1F1-1F1E7",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[3,7]},"clock12":{name:"Clock Face Twelve Oclock",unified:"1F55B",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["time","noon","midnight","midday","late","early","schedule"],sheet:[28,29]},hammer_and_pick:{name:"Hammer and Pick",unified:"2692-FE0F",non_qualified:"2692",added_in:"4.1",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,keywords:["tools","build","create"],sheet:[48,11]},six:{name:"Keycap 6",unified:"0036-FE0F-20E3",non_qualified:"0036-20E3",added_in:"3.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false,keywords:["6","numbers","blue-square"],sheet:[0,8]},"female-technologist":{name:"Female Technologist",unified:"1F469-200D-1F4BB",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F469-1F3FB-200D-1F4BB",image:"1f469-1f3fb-200d-1f4bb.png",sheet_x:19,sheet_y:18,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FC":{unified:"1F469-1F3FC-200D-1F4BB",image:"1f469-1f3fc-200d-1f4bb.png",sheet_x:19,sheet_y:19,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FD":{unified:"1F469-1F3FD-200D-1F4BB",image:"1f469-1f3fd-200d-1f4bb.png",sheet_x:19,sheet_y:20,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FE":{unified:"1F469-1F3FE-200D-1F4BB",image:"1f469-1f3fe-200d-1f4bb.png",sheet_x:19,sheet_y:21,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FF":{unified:"1F469-1F3FF-200D-1F4BB",image:"1f469-1f3ff-200d-1f4bb.png",sheet_x:19,sheet_y:22,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false}},sheet:[19,17]},hammer_and_wrench:{name:"Hammer and Wrench",unified:"1F6E0-FE0F",non_qualified:"1F6E0",added_in:"7.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,keywords:["tools","build","create"],sheet:[37,8]},"flag-lc":{name:"St. Lucia Flag",unified:"1F1F1-1F1E8",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[3,8]},"clock1230":{name:"Clock Face Twelve-Thirty",unified:"1F567",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["time","late","early","schedule"],sheet:[28,41]},seven:{name:"Keycap 7",unified:"0037-FE0F-20E3",non_qualified:"0037-20E3",added_in:"3.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false,keywords:["7","numbers","blue-square","prime"],sheet:[0,9]},"male-singer":{name:"Male Singer",unified:"1F468-200D-1F3A4",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F468-1F3FB-200D-1F3A4",image:"1f468-1f3fb-200d-1f3a4.png",sheet_x:16,sheet_y:21,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FC":{unified:"1F468-1F3FC-200D-1F3A4",image:"1f468-1f3fc-200d-1f3a4.png",sheet_x:16,sheet_y:22,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FD":{unified:"1F468-1F3FD-200D-1F3A4",image:"1f468-1f3fd-200d-1f3a4.png",sheet_x:16,sheet_y:23,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FE":{unified:"1F468-1F3FE-200D-1F3A4",image:"1f468-1f3fe-200d-1f3a4.png",sheet_x:16,sheet_y:24,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FF":{unified:"1F468-1F3FF-200D-1F3A4",image:"1f468-1f3ff-200d-1f3a4.png",sheet_x:16,sheet_y:25,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false}},sheet:[16,20]},eight:{name:"Keycap 8",unified:"0038-FE0F-20E3",non_qualified:"0038-20E3",added_in:"3.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false,keywords:["8","blue-square","numbers"],sheet:[0,10]},"flag-li":{name:"Liechtenstein Flag",unified:"1F1F1-1F1EE",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[3,9]},dagger_knife:{name:"Dagger Knife",unified:"1F5E1-FE0F",non_qualified:"1F5E1",added_in:"7.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,sheet:[30,13]},"clock1":{name:"Clock Face One Oclock",unified:"1F550",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["time","late","early","schedule"],sheet:[28,18]},"female-singer":{name:"Female Singer",unified:"1F469-200D-1F3A4",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F469-1F3FB-200D-1F3A4",image:"1f469-1f3fb-200d-1f3a4.png",sheet_x:18,sheet_y:36,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FC":{unified:"1F469-1F3FC-200D-1F3A4",image:"1f469-1f3fc-200d-1f3a4.png",sheet_x:18,sheet_y:37,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FD":{unified:"1F469-1F3FD-200D-1F3A4",image:"1f469-1f3fd-200d-1f3a4.png",sheet_x:18,sheet_y:38,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FE":{unified:"1F469-1F3FE-200D-1F3A4",image:"1f469-1f3fe-200d-1f3a4.png",sheet_x:18,sheet_y:39,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FF":{unified:"1F469-1F3FF-200D-1F3A4",image:"1f469-1f3ff-200d-1f3a4.png",sheet_x:18,sheet_y:40,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false}},sheet:[18,35]},"male-artist":{name:"Male Artist",unified:"1F468-200D-1F3A8",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F468-1F3FB-200D-1F3A8",image:"1f468-1f3fb-200d-1f3a8.png",sheet_x:16,sheet_y:27,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FC":{unified:"1F468-1F3FC-200D-1F3A8",image:"1f468-1f3fc-200d-1f3a8.png",sheet_x:16,sheet_y:28,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FD":{unified:"1F468-1F3FD-200D-1F3A8",image:"1f468-1f3fd-200d-1f3a8.png",sheet_x:16,sheet_y:29,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FE":{unified:"1F468-1F3FE-200D-1F3A8",image:"1f468-1f3fe-200d-1f3a8.png",sheet_x:16,sheet_y:30,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FF":{unified:"1F468-1F3FF-200D-1F3A8",image:"1f468-1f3ff-200d-1f3a8.png",sheet_x:16,sheet_y:31,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false}},sheet:[16,26]},crossed_swords:{name:"Crossed Swords",unified:"2694-FE0F",non_qualified:"2694",added_in:"4.1",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,keywords:["weapon"],sheet:[48,13]},nine:{name:"Keycap 9",unified:"0039-FE0F-20E3",non_qualified:"0039-20E3",added_in:"3.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false,keywords:["blue-square","numbers","9"],sheet:[0,11]},"flag-lk":{name:"Sri Lanka Flag",unified:"1F1F1-1F1F0",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[3,10]},"clock130":{name:"Clock Face One-Thirty",unified:"1F55C",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["time","late","early","schedule"],sheet:[28,30]},"clock2":{name:"Clock Face Two Oclock",unified:"1F551",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["time","late","early","schedule"],sheet:[28,19]},gun:{name:"Pistol",unified:"1F52B",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["violence","weapon","pistol","revolver"],sheet:[27,45]},keycap_ten:{name:"Keycap Ten",unified:"1F51F",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["numbers","10","blue-square"],sheet:[27,33]},"female-artist":{name:"Female Artist",unified:"1F469-200D-1F3A8",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F469-1F3FB-200D-1F3A8",image:"1f469-1f3fb-200d-1f3a8.png",sheet_x:18,sheet_y:42,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FC":{unified:"1F469-1F3FC-200D-1F3A8",image:"1f469-1f3fc-200d-1f3a8.png",sheet_x:18,sheet_y:43,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FD":{unified:"1F469-1F3FD-200D-1F3A8",image:"1f469-1f3fd-200d-1f3a8.png",sheet_x:18,sheet_y:44,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FE":{unified:"1F469-1F3FE-200D-1F3A8",image:"1f469-1f3fe-200d-1f3a8.png",sheet_x:18,sheet_y:45,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FF":{unified:"1F469-1F3FF-200D-1F3A8",image:"1f469-1f3ff-200d-1f3a8.png",sheet_x:18,sheet_y:46,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false}},sheet:[18,41]},"flag-lr":{name:"Liberia Flag",unified:"1F1F1-1F1F7",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[3,11]},"clock230":{name:"Clock Face Two-Thirty",unified:"1F55D",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["time","late","early","schedule"],sheet:[28,31]},bow_and_arrow:{name:"Bow and Arrow",unified:"1F3F9",non_qualified:null,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false,keywords:["sports"],sheet:[12,23]},"male-pilot":{name:"Male Pilot",unified:"1F468-200D-2708-FE0F",non_qualified:"1F468-200D-2708",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F468-1F3FB-200D-2708-FE0F",image:"1f468-1f3fb-200d-2708-fe0f.png",sheet_x:18,sheet_y:4,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FC":{unified:"1F468-1F3FC-200D-2708-FE0F",image:"1f468-1f3fc-200d-2708-fe0f.png",sheet_x:18,sheet_y:5,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FD":{unified:"1F468-1F3FD-200D-2708-FE0F",image:"1f468-1f3fd-200d-2708-fe0f.png",sheet_x:18,sheet_y:6,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FE":{unified:"1F468-1F3FE-200D-2708-FE0F",image:"1f468-1f3fe-200d-2708-fe0f.png",sheet_x:18,sheet_y:7,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FF":{unified:"1F468-1F3FF-200D-2708-FE0F",image:"1f468-1f3ff-200d-2708-fe0f.png",sheet_x:18,sheet_y:8,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false}},sheet:[18,3]},"flag-ls":{name:"Lesotho Flag",unified:"1F1F1-1F1F8",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[3,12]},"flag-lt":{name:"Lithuania Flag",unified:"1F1F1-1F1F9",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[3,13]},capital_abcd:{name:"Input Symbol for Latin Capital Letters",unified:"1F520",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["alphabet","words","blue-square"],sheet:[27,34]},"female-pilot":{name:"Female Pilot",unified:"1F469-200D-2708-FE0F",non_qualified:"1F469-200D-2708",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F469-1F3FB-200D-2708-FE0F",image:"1f469-1f3fb-200d-2708-fe0f.png",sheet_x:20,sheet_y:14,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FC":{unified:"1F469-1F3FC-200D-2708-FE0F",image:"1f469-1f3fc-200d-2708-fe0f.png",sheet_x:20,sheet_y:15,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FD":{unified:"1F469-1F3FD-200D-2708-FE0F",image:"1f469-1f3fd-200d-2708-fe0f.png",sheet_x:20,sheet_y:16,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FE":{unified:"1F469-1F3FE-200D-2708-FE0F",image:"1f469-1f3fe-200d-2708-fe0f.png",sheet_x:20,sheet_y:17,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FF":{unified:"1F469-1F3FF-200D-2708-FE0F",image:"1f469-1f3ff-200d-2708-fe0f.png",sheet_x:20,sheet_y:18,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false}},sheet:[20,13]},"clock3":{name:"Clock Face Three Oclock",unified:"1F552",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["time","late","early","schedule"],sheet:[28,20]},shield:{name:"Shield",unified:"1F6E1-FE0F",non_qualified:"1F6E1",added_in:"7.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,keywords:["protection","security"],sheet:[37,9]},"male-astronaut":{name:"Male Astronaut",unified:"1F468-200D-1F680",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F468-1F3FB-200D-1F680",image:"1f468-1f3fb-200d-1f680.png",sheet_x:17,sheet_y:32,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FC":{unified:"1F468-1F3FC-200D-1F680",image:"1f468-1f3fc-200d-1f680.png",sheet_x:17,sheet_y:33,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FD":{unified:"1F468-1F3FD-200D-1F680",image:"1f468-1f3fd-200d-1f680.png",sheet_x:17,sheet_y:34,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FE":{unified:"1F468-1F3FE-200D-1F680",image:"1f468-1f3fe-200d-1f680.png",sheet_x:17,sheet_y:35,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FF":{unified:"1F468-1F3FF-200D-1F680",image:"1f468-1f3ff-200d-1f680.png",sheet_x:17,sheet_y:36,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false}},sheet:[17,31]},abcd:{name:"Input Symbol for Latin Small Letters",unified:"1F521",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["blue-square","alphabet"],sheet:[27,35]},"clock330":{name:"Clock Face Three-Thirty",unified:"1F55E",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["time","late","early","schedule"],sheet:[28,32]},"flag-lu":{name:"Luxembourg Flag",unified:"1F1F1-1F1FA",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[3,14]},wrench:{name:"Wrench",unified:"1F527",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["tools","diy","ikea","fix","maintainer"],sheet:[27,41]},nut_and_bolt:{name:"Nut and Bolt",unified:"1F529",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["handy","tools","fix"],sheet:[27,43]},"clock4":{name:"Clock Face Four Oclock",unified:"1F553",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["time","late","early","schedule"],sheet:[28,21]},"female-astronaut":{name:"Female Astronaut",unified:"1F469-200D-1F680",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F469-1F3FB-200D-1F680",image:"1f469-1f3fb-200d-1f680.png",sheet_x:19,sheet_y:42,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FC":{unified:"1F469-1F3FC-200D-1F680",image:"1f469-1f3fc-200d-1f680.png",sheet_x:19,sheet_y:43,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FD":{unified:"1F469-1F3FD-200D-1F680",image:"1f469-1f3fd-200d-1f680.png",sheet_x:19,sheet_y:44,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FE":{unified:"1F469-1F3FE-200D-1F680",image:"1f469-1f3fe-200d-1f680.png",sheet_x:19,sheet_y:45,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FF":{unified:"1F469-1F3FF-200D-1F680",image:"1f469-1f3ff-200d-1f680.png",sheet_x:19,sheet_y:46,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false}},sheet:[19,41]},"flag-lv":{name:"Latvia Flag",unified:"1F1F1-1F1FB",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[3,15]},gear:{name:"Gear",unified:"2699-FE0F",non_qualified:"2699",added_in:"4.1",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,keywords:["cog"],sheet:[48,17]},"male-firefighter":{name:"Male Firefighter",unified:"1F468-200D-1F692",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F468-1F3FB-200D-1F692",image:"1f468-1f3fb-200d-1f692.png",sheet_x:17,sheet_y:38,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FC":{unified:"1F468-1F3FC-200D-1F692",image:"1f468-1f3fc-200d-1f692.png",sheet_x:17,sheet_y:39,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FD":{unified:"1F468-1F3FD-200D-1F692",image:"1f468-1f3fd-200d-1f692.png",sheet_x:17,sheet_y:40,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FE":{unified:"1F468-1F3FE-200D-1F692",image:"1f468-1f3fe-200d-1f692.png",sheet_x:17,sheet_y:41,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FF":{unified:"1F468-1F3FF-200D-1F692",image:"1f468-1f3ff-200d-1f692.png",sheet_x:17,sheet_y:42,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false}},sheet:[17,37]},"flag-ly":{name:"Libya Flag",unified:"1F1F1-1F1FE",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[3,16]},symbols:{name:"Input Symbol for Symbols",unified:"1F523",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["blue-square","music","note","ampersand","percent","glyphs","characters"],sheet:[27,37]},"clock430":{name:"Clock Face Four-Thirty",unified:"1F55F",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["time","late","early","schedule"],sheet:[28,33]},"flag-ma":{name:"Morocco Flag",unified:"1F1F2-1F1E6",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[3,17]},compression:{name:"Compression",unified:"1F5DC-FE0F",non_qualified:"1F5DC",added_in:"7.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,sheet:[30,10]},"female-firefighter":{name:"Female Firefighter",unified:"1F469-200D-1F692",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F469-1F3FB-200D-1F692",image:"1f469-1f3fb-200d-1f692.png",sheet_x:19,sheet_y:48,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FC":{unified:"1F469-1F3FC-200D-1F692",image:"1f469-1f3fc-200d-1f692.png",sheet_x:19,sheet_y:49,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FD":{unified:"1F469-1F3FD-200D-1F692",image:"1f469-1f3fd-200d-1f692.png",sheet_x:19,sheet_y:50,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FE":{unified:"1F469-1F3FE-200D-1F692",image:"1f469-1f3fe-200d-1f692.png",sheet_x:19,sheet_y:51,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FF":{unified:"1F469-1F3FF-200D-1F692",image:"1f469-1f3ff-200d-1f692.png",sheet_x:20,sheet_y:0,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false}},sheet:[19,47]},abc:{name:"Input Symbol for Latin Letters",unified:"1F524",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["blue-square","alphabet"],sheet:[27,38]},"clock5":{name:"Clock Face Five Oclock",unified:"1F554",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["time","late","early","schedule"],sheet:[28,22]},"clock530":{name:"Clock Face Five-Thirty",unified:"1F560",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["time","late","early","schedule"],sheet:[28,34]},a:{name:"Negative Squared Latin Capital Letter a",unified:"1F170-FE0F",non_qualified:"1F170",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:true,keywords:["red-square","alphabet","letter"],sheet:[0,16]},alembic:{name:"Alembic",unified:"2697-FE0F",non_qualified:"2697",added_in:"4.1",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,keywords:["distilling","science","experiment","chemistry"],sheet:[48,16]},"flag-mc":{name:"Monaco Flag",unified:"1F1F2-1F1E8",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[3,18]},cop:{name:"Police Officer",unified:"1F46E",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:true,skin_variations:{"1F3FB":{unified:"1F46E-1F3FB",non_qualified:null,image:"1f46e-1f3fb.png",sheet_x:20,sheet_y:46,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:true},"1F3FC":{unified:"1F46E-1F3FC",non_qualified:null,image:"1f46e-1f3fc.png",sheet_x:20,sheet_y:47,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:true},"1F3FD":{unified:"1F46E-1F3FD",non_qualified:null,image:"1f46e-1f3fd.png",sheet_x:20,sheet_y:48,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:true},"1F3FE":{unified:"1F46E-1F3FE",non_qualified:null,image:"1f46e-1f3fe.png",sheet_x:20,sheet_y:49,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:true},"1F3FF":{unified:"1F46E-1F3FF",non_qualified:null,image:"1f46e-1f3ff.png",sheet_x:20,sheet_y:50,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:true}},obsoleted_by:"1F46E-200D-2642-FE0F",sheet:[20,45]},scales:{name:"Scales",unified:"2696-FE0F",non_qualified:"2696",added_in:"4.1",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,sheet:[48,15]},"clock6":{name:"Clock Face Six Oclock",unified:"1F555",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["time","late","early","schedule","dawn","dusk"],sheet:[28,23]},"flag-md":{name:"Moldova Flag",unified:"1F1F2-1F1E9",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[3,19]},ab:{name:"Negative Squared Ab",unified:"1F18E",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["red-square","alphabet"],sheet:[0,20]},"male-police-officer":{name:"Male Police Officer",unified:"1F46E-200D-2642-FE0F",non_qualified:"1F46E-200D-2642",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F46E-1F3FB-200D-2642-FE0F",image:"1f46e-1f3fb-200d-2642-fe0f.png",sheet_x:20,sheet_y:40,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FC":{unified:"1F46E-1F3FC-200D-2642-FE0F",image:"1f46e-1f3fc-200d-2642-fe0f.png",sheet_x:20,sheet_y:41,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FD":{unified:"1F46E-1F3FD-200D-2642-FE0F",image:"1f46e-1f3fd-200d-2642-fe0f.png",sheet_x:20,sheet_y:42,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FE":{unified:"1F46E-1F3FE-200D-2642-FE0F",image:"1f46e-1f3fe-200d-2642-fe0f.png",sheet_x:20,sheet_y:43,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FF":{unified:"1F46E-1F3FF-200D-2642-FE0F",image:"1f46e-1f3ff-200d-2642-fe0f.png",sheet_x:20,sheet_y:44,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false}},obsoletes:"1F46E",sheet:[20,39]},link:{name:"Link Symbol",unified:"1F517",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["rings","url"],sheet:[27,25]},"flag-me":{name:"Montenegro Flag",unified:"1F1F2-1F1EA",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[3,20]},"clock630":{name:"Clock Face Six-Thirty",unified:"1F561",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["time","late","early","schedule"],sheet:[28,35]},b:{name:"Negative Squared Latin Capital Letter B",unified:"1F171-FE0F",non_qualified:"1F171",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:true,keywords:["red-square","alphabet","letter"],sheet:[0,17]},"female-police-officer":{name:"Female Police Officer",unified:"1F46E-200D-2640-FE0F",non_qualified:"1F46E-200D-2640",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F46E-1F3FB-200D-2640-FE0F",image:"1f46e-1f3fb-200d-2640-fe0f.png",sheet_x:20,sheet_y:34,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FC":{unified:"1F46E-1F3FC-200D-2640-FE0F",image:"1f46e-1f3fc-200d-2640-fe0f.png",sheet_x:20,sheet_y:35,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FD":{unified:"1F46E-1F3FD-200D-2640-FE0F",image:"1f46e-1f3fd-200d-2640-fe0f.png",sheet_x:20,sheet_y:36,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FE":{unified:"1F46E-1F3FE-200D-2640-FE0F",image:"1f46e-1f3fe-200d-2640-fe0f.png",sheet_x:20,sheet_y:37,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FF":{unified:"1F46E-1F3FF-200D-2640-FE0F",image:"1f46e-1f3ff-200d-2640-fe0f.png",sheet_x:20,sheet_y:38,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false}},sheet:[20,33]},"clock7":{name:"Clock Face Seven Oclock",unified:"1F556",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["time","late","early","schedule"],sheet:[28,24]},cl:{name:"Squared Cl",unified:"1F191",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["alphabet","words","red-square"],sheet:[0,21]},sleuth_or_spy:{name:"Sleuth or Spy",unified:"1F575-FE0F",non_qualified:"1F575",added_in:"7.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F575-1F3FB",non_qualified:null,image:"1f575-1f3fb.png",sheet_x:29,sheet_y:12,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:false},"1F3FC":{unified:"1F575-1F3FC",non_qualified:null,image:"1f575-1f3fc.png",sheet_x:29,sheet_y:13,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:false},"1F3FD":{unified:"1F575-1F3FD",non_qualified:null,image:"1f575-1f3fd.png",sheet_x:29,sheet_y:14,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:false},"1F3FE":{unified:"1F575-1F3FE",non_qualified:null,image:"1f575-1f3fe.png",sheet_x:29,sheet_y:15,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:false},"1F3FF":{unified:"1F575-1F3FF",non_qualified:null,image:"1f575-1f3ff.png",sheet_x:29,sheet_y:16,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:false}},obsoleted_by:"1F575-FE0F-200D-2642-FE0F",sheet:[29,11]},"flag-mf":{name:"St. Martin Flag",unified:"1F1F2-1F1EB",non_qualified:null,has_img_apple:true,has_img_google:false,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[3,21]},chains:{name:"Chains",unified:"26D3-FE0F",non_qualified:"26D3",added_in:"5.2",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,keywords:["lock","arrest"],sheet:[48,34]},syringe:{name:"Syringe",unified:"1F489",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["health","hospital","drugs","blood","medicine","needle","doctor","nurse"],sheet:[24,35]},"male-detective":{name:"Male Detective",unified:"1F575-FE0F-200D-2642-FE0F",non_qualified:null,added_in:"7.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F575-1F3FB-200D-2642-FE0F",image:"1f575-1f3fb-200d-2642-fe0f.png",sheet_x:29,sheet_y:6,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FC":{unified:"1F575-1F3FC-200D-2642-FE0F",image:"1f575-1f3fc-200d-2642-fe0f.png",sheet_x:29,sheet_y:7,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FD":{unified:"1F575-1F3FD-200D-2642-FE0F",image:"1f575-1f3fd-200d-2642-fe0f.png",sheet_x:29,sheet_y:8,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FE":{unified:"1F575-1F3FE-200D-2642-FE0F",image:"1f575-1f3fe-200d-2642-fe0f.png",sheet_x:29,sheet_y:9,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FF":{unified:"1F575-1F3FF-200D-2642-FE0F",image:"1f575-1f3ff-200d-2642-fe0f.png",sheet_x:29,sheet_y:10,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false}},obsoletes:"1F575-FE0F",sheet:[29,5]},cool:{name:"Squared Cool",unified:"1F192",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["words","blue-square"],sheet:[0,22]},"clock730":{name:"Clock Face Seven-Thirty",unified:"1F562",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["time","late","early","schedule"],sheet:[28,36]},"flag-mg":{name:"Madagascar Flag",unified:"1F1F2-1F1EC",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[3,22]},free:{name:"Squared Free",unified:"1F193",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["blue-square","words"],sheet:[0,23]},"flag-mh":{name:"Marshall Islands Flag",unified:"1F1F2-1F1ED",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[3,23]},"clock8":{name:"Clock Face Eight Oclock",unified:"1F557",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["time","late","early","schedule"],sheet:[28,25]},pill:{name:"Pill",unified:"1F48A",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["health","medicine","doctor","pharmacy","drug"],sheet:[24,36]},"female-detective":{name:"Female Detective",unified:"1F575-FE0F-200D-2640-FE0F",non_qualified:null,added_in:"7.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F575-1F3FB-200D-2640-FE0F",image:"1f575-1f3fb-200d-2640-fe0f.png",sheet_x:29,sheet_y:0,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FC":{unified:"1F575-1F3FC-200D-2640-FE0F",image:"1f575-1f3fc-200d-2640-fe0f.png",sheet_x:29,sheet_y:1,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FD":{unified:"1F575-1F3FD-200D-2640-FE0F",image:"1f575-1f3fd-200d-2640-fe0f.png",sheet_x:29,sheet_y:2,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FE":{unified:"1F575-1F3FE-200D-2640-FE0F",image:"1f575-1f3fe-200d-2640-fe0f.png",sheet_x:29,sheet_y:3,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FF":{unified:"1F575-1F3FF-200D-2640-FE0F",image:"1f575-1f3ff-200d-2640-fe0f.png",sheet_x:29,sheet_y:4,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false}},sheet:[28,51]},"clock830":{name:"Clock Face Eight-Thirty",unified:"1F563",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["time","late","early","schedule"],sheet:[28,37]},guardsman:{name:"Guardsman",unified:"1F482",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:true,skin_variations:{"1F3FB":{unified:"1F482-1F3FB",non_qualified:null,image:"1f482-1f3fb.png",sheet_x:23,sheet_y:32,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:true},"1F3FC":{unified:"1F482-1F3FC",non_qualified:null,image:"1f482-1f3fc.png",sheet_x:23,sheet_y:33,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:true},"1F3FD":{unified:"1F482-1F3FD",non_qualified:null,image:"1f482-1f3fd.png",sheet_x:23,sheet_y:34,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:true},"1F3FE":{unified:"1F482-1F3FE",non_qualified:null,image:"1f482-1f3fe.png",sheet_x:23,sheet_y:35,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:true},"1F3FF":{unified:"1F482-1F3FF",non_qualified:null,image:"1f482-1f3ff.png",sheet_x:23,sheet_y:36,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:true}},obsoleted_by:"1F482-200D-2642-FE0F",keywords:["uk","gb","british","male","guy","royal"],sheet:[23,31]},information_source:{name:"Information Source",unified:"2139-FE0F",non_qualified:"2139",added_in:"3.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:true,keywords:["blue-square","alphabet","letter"],sheet:[46,32]},"flag-mk":{name:"Macedonia Flag",unified:"1F1F2-1F1F0",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[3,24]},smoking:{name:"Smoking Symbol",unified:"1F6AC",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["kills","tobacco","cigarette","joint","smoke"],sheet:[35,17]},id:{name:"Squared Id",unified:"1F194",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["purple-square","words"],sheet:[0,24]},"clock9":{name:"Clock Face Nine Oclock",unified:"1F558",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["time","late","early","schedule"],sheet:[28,26]},"flag-ml":{name:"Mali Flag",unified:"1F1F2-1F1F1",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[3,25]},coffin:{name:"Coffin",unified:"26B0-FE0F",non_qualified:"26B0",added_in:"4.1",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,keywords:["vampire","dead","die","death","rip","graveyard","cemetery","casket","funeral","box"],sheet:[48,24]},"male-guard":{name:"Male Guard",unified:"1F482-200D-2642-FE0F",non_qualified:"1F482-200D-2642",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F482-1F3FB-200D-2642-FE0F",image:"1f482-1f3fb-200d-2642-fe0f.png",sheet_x:23,sheet_y:26,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FC":{unified:"1F482-1F3FC-200D-2642-FE0F",image:"1f482-1f3fc-200d-2642-fe0f.png",sheet_x:23,sheet_y:27,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FD":{unified:"1F482-1F3FD-200D-2642-FE0F",image:"1f482-1f3fd-200d-2642-fe0f.png",sheet_x:23,sheet_y:28,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FE":{unified:"1F482-1F3FE-200D-2642-FE0F",image:"1f482-1f3fe-200d-2642-fe0f.png",sheet_x:23,sheet_y:29,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FF":{unified:"1F482-1F3FF-200D-2642-FE0F",image:"1f482-1f3ff-200d-2642-fe0f.png",sheet_x:23,sheet_y:30,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false}},obsoletes:"1F482",sheet:[23,25]},m:{name:"Circled Latin Capital Letter M",unified:"24C2-FE0F",non_qualified:"24C2",added_in:"1.1",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:true,keywords:["alphabet","blue-circle","letter"],sheet:[47,7]},funeral_urn:{name:"Funeral Urn",unified:"26B1-FE0F",non_qualified:"26B1",added_in:"4.1",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,keywords:["dead","die","death","rip","ashes"],sheet:[48,25]},"female-guard":{name:"Female Guard",unified:"1F482-200D-2640-FE0F",non_qualified:"1F482-200D-2640",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F482-1F3FB-200D-2640-FE0F",image:"1f482-1f3fb-200d-2640-fe0f.png",sheet_x:23,sheet_y:20,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FC":{unified:"1F482-1F3FC-200D-2640-FE0F",image:"1f482-1f3fc-200d-2640-fe0f.png",sheet_x:23,sheet_y:21,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FD":{unified:"1F482-1F3FD-200D-2640-FE0F",image:"1f482-1f3fd-200d-2640-fe0f.png",sheet_x:23,sheet_y:22,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FE":{unified:"1F482-1F3FE-200D-2640-FE0F",image:"1f482-1f3fe-200d-2640-fe0f.png",sheet_x:23,sheet_y:23,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FF":{unified:"1F482-1F3FF-200D-2640-FE0F",image:"1f482-1f3ff-200d-2640-fe0f.png",sheet_x:23,sheet_y:24,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false}},sheet:[23,19]},"flag-mm":{name:"Myanmar (burma) Flag",unified:"1F1F2-1F1F2",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[3,26]},"clock930":{name:"Clock Face Nine-Thirty",unified:"1F564",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["time","late","early","schedule"],sheet:[28,38]},moyai:{name:"Moyai",unified:"1F5FF",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["rock","easter island","moai"],sheet:[30,23]},new:{name:"Squared New",unified:"1F195",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["blue-square","words","start"],sheet:[0,25]},"flag-mn":{name:"Mongolia Flag",unified:"1F1F2-1F1F3",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[3,27]},construction_worker:{name:"Construction Worker",unified:"1F477",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:true,skin_variations:{"1F3FB":{unified:"1F477-1F3FB",non_qualified:null,image:"1f477-1f3fb.png",sheet_x:22,sheet_y:29,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:true},"1F3FC":{unified:"1F477-1F3FC",non_qualified:null,image:"1f477-1f3fc.png",sheet_x:22,sheet_y:30,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:true},"1F3FD":{unified:"1F477-1F3FD",non_qualified:null,image:"1f477-1f3fd.png",sheet_x:22,sheet_y:31,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:true},"1F3FE":{unified:"1F477-1F3FE",non_qualified:null,image:"1f477-1f3fe.png",sheet_x:22,sheet_y:32,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:true},"1F3FF":{unified:"1F477-1F3FF",non_qualified:null,image:"1f477-1f3ff.png",sheet_x:22,sheet_y:33,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:true}},obsoleted_by:"1F477-200D-2642-FE0F",sheet:[22,28]},"clock10":{name:"Clock Face Ten Oclock",unified:"1F559",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["time","late","early","schedule"],sheet:[28,27]},"clock1030":{name:"Clock Face Ten-Thirty",unified:"1F565",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["time","late","early","schedule"],sheet:[28,39]},ng:{name:"Squared Ng",unified:"1F196",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["blue-square","words","shape","icon"],sheet:[0,26]},"male-construction-worker":{name:"Male Construction Worker",unified:"1F477-200D-2642-FE0F",non_qualified:"1F477-200D-2642",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F477-1F3FB-200D-2642-FE0F",image:"1f477-1f3fb-200d-2642-fe0f.png",sheet_x:22,sheet_y:23,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FC":{unified:"1F477-1F3FC-200D-2642-FE0F",image:"1f477-1f3fc-200d-2642-fe0f.png",sheet_x:22,sheet_y:24,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FD":{unified:"1F477-1F3FD-200D-2642-FE0F",image:"1f477-1f3fd-200d-2642-fe0f.png",sheet_x:22,sheet_y:25,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FE":{unified:"1F477-1F3FE-200D-2642-FE0F",image:"1f477-1f3fe-200d-2642-fe0f.png",sheet_x:22,sheet_y:26,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FF":{unified:"1F477-1F3FF-200D-2642-FE0F",image:"1f477-1f3ff-200d-2642-fe0f.png",sheet_x:22,sheet_y:27,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false}},obsoletes:"1F477",sheet:[22,22]},"flag-mo":{name:"Macau Sar China Flag",unified:"1F1F2-1F1F4",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[3,28]},oil_drum:{name:"Oil Drum",unified:"1F6E2-FE0F",non_qualified:"1F6E2",added_in:"7.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,keywords:["barrell"],sheet:[37,10]},"o2":{name:"Negative Squared Latin Capital Letter O",unified:"1F17E-FE0F",non_qualified:"1F17E",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:true,keywords:["alphabet","red-square","letter"],sheet:[0,18]},"female-construction-worker":{name:"Female Construction Worker",unified:"1F477-200D-2640-FE0F",non_qualified:"1F477-200D-2640",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F477-1F3FB-200D-2640-FE0F",image:"1f477-1f3fb-200d-2640-fe0f.png",sheet_x:22,sheet_y:17,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FC":{unified:"1F477-1F3FC-200D-2640-FE0F",image:"1f477-1f3fc-200d-2640-fe0f.png",sheet_x:22,sheet_y:18,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FD":{unified:"1F477-1F3FD-200D-2640-FE0F",image:"1f477-1f3fd-200d-2640-fe0f.png",sheet_x:22,sheet_y:19,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FE":{unified:"1F477-1F3FE-200D-2640-FE0F",image:"1f477-1f3fe-200d-2640-fe0f.png",sheet_x:22,sheet_y:20,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FF":{unified:"1F477-1F3FF-200D-2640-FE0F",image:"1f477-1f3ff-200d-2640-fe0f.png",sheet_x:22,sheet_y:21,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false}},sheet:[22,16]},"clock11":{name:"Clock Face Eleven Oclock",unified:"1F55A",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["time","late","early","schedule"],sheet:[28,28]},crystal_ball:{name:"Crystal Ball",unified:"1F52E",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["disco","party","magic","circus","fortune_teller"],sheet:[27,48]},"flag-mp":{name:"Northern Mariana Islands Flag",unified:"1F1F2-1F1F5",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[3,29]},"flag-mq":{name:"Martinique Flag",unified:"1F1F2-1F1F6",non_qualified:null,has_img_apple:true,has_img_google:false,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[3,30]},prince:{name:"Prince",unified:"1F934",non_qualified:null,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F934-1F3FB",non_qualified:null,image:"1f934-1f3fb.png",sheet_x:39,sheet_y:29,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false},"1F3FC":{unified:"1F934-1F3FC",non_qualified:null,image:"1f934-1f3fc.png",sheet_x:39,sheet_y:30,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false},"1F3FD":{unified:"1F934-1F3FD",non_qualified:null,image:"1f934-1f3fd.png",sheet_x:39,sheet_y:31,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false},"1F3FE":{unified:"1F934-1F3FE",non_qualified:null,image:"1f934-1f3fe.png",sheet_x:39,sheet_y:32,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false},"1F3FF":{unified:"1F934-1F3FF",non_qualified:null,image:"1f934-1f3ff.png",sheet_x:39,sheet_y:33,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false}},keywords:["boy","man","male","crown","royal","king"],sheet:[39,28]},ok:{name:"Squared Ok",unified:"1F197",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["good","agree","yes","blue-square"],sheet:[0,27]},"clock1130":{name:"Clock Face Eleven-Thirty",unified:"1F566",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["time","late","early","schedule"],sheet:[28,40]},shopping_trolley:{name:"Shopping Trolley",unified:"1F6D2",non_qualified:null,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false,sheet:[37,7]},"flag-mr":{name:"Mauritania Flag",unified:"1F1F2-1F1F7",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[3,31]},princess:{name:"Princess",unified:"1F478",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,skin_variations:{"1F3FB":{unified:"1F478-1F3FB",non_qualified:null,image:"1f478-1f3fb.png",sheet_x:22,sheet_y:35,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FC":{unified:"1F478-1F3FC",non_qualified:null,image:"1f478-1f3fc.png",sheet_x:22,sheet_y:36,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FD":{unified:"1F478-1F3FD",non_qualified:null,image:"1f478-1f3fd.png",sheet_x:22,sheet_y:37,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FE":{unified:"1F478-1F3FE",non_qualified:null,image:"1f478-1f3fe.png",sheet_x:22,sheet_y:38,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FF":{unified:"1F478-1F3FF",non_qualified:null,image:"1f478-1f3ff.png",sheet_x:22,sheet_y:39,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true}},keywords:["girl","woman","female","blond","crown","royal","queen"],sheet:[22,34]},new_moon:{name:"New Moon Symbol",unified:"1F311",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["nature","twilight","planet","space","night","evening","sleep"],sheet:[6,9]},parking:{name:"Negative Squared Latin Capital Letter P",unified:"1F17F-FE0F",non_qualified:"1F17F",added_in:"5.2",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:true,keywords:["cars","blue-square","alphabet","letter"],sheet:[0,19]},sos:{name:"Squared Sos",unified:"1F198",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["help","red-square","words","emergency","911"],sheet:[0,28]},man_with_turban:{name:"Man with Turban",unified:"1F473",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:true,skin_variations:{"1F3FB":{unified:"1F473-1F3FB",non_qualified:null,image:"1f473-1f3fb.png",sheet_x:21,sheet_y:45,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:true},"1F3FC":{unified:"1F473-1F3FC",non_qualified:null,image:"1f473-1f3fc.png",sheet_x:21,sheet_y:46,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:true},"1F3FD":{unified:"1F473-1F3FD",non_qualified:null,image:"1f473-1f3fd.png",sheet_x:21,sheet_y:47,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:true},"1F3FE":{unified:"1F473-1F3FE",non_qualified:null,image:"1f473-1f3fe.png",sheet_x:21,sheet_y:48,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:true},"1F3FF":{unified:"1F473-1F3FF",non_qualified:null,image:"1f473-1f3ff.png",sheet_x:21,sheet_y:49,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:true}},obsoleted_by:"1F473-200D-2642-FE0F",keywords:["male","indian","hinduism","arabs"],sheet:[21,44]},"flag-ms":{name:"Montserrat Flag",unified:"1F1F2-1F1F8",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[3,32]},waxing_crescent_moon:{name:"Waxing Crescent Moon Symbol",unified:"1F312",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["nature","twilight","planet","space","night","evening","sleep"],sheet:[6,10]},up:{name:"Squared Up with Exclamation Mark",unified:"1F199",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["blue-square","above","high"],sheet:[0,29]},first_quarter_moon:{name:"First Quarter Moon Symbol",unified:"1F313",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["nature","twilight","planet","space","night","evening","sleep"],sheet:[6,11]},"flag-mt":{name:"Malta Flag",unified:"1F1F2-1F1F9",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[3,33]},"man-wearing-turban":{name:"Man Wearing Turban",unified:"1F473-200D-2642-FE0F",non_qualified:"1F473-200D-2642",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F473-1F3FB-200D-2642-FE0F",image:"1f473-1f3fb-200d-2642-fe0f.png",sheet_x:21,sheet_y:39,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FC":{unified:"1F473-1F3FC-200D-2642-FE0F",image:"1f473-1f3fc-200d-2642-fe0f.png",sheet_x:21,sheet_y:40,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FD":{unified:"1F473-1F3FD-200D-2642-FE0F",image:"1f473-1f3fd-200d-2642-fe0f.png",sheet_x:21,sheet_y:41,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FE":{unified:"1F473-1F3FE-200D-2642-FE0F",image:"1f473-1f3fe-200d-2642-fe0f.png",sheet_x:21,sheet_y:42,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FF":{unified:"1F473-1F3FF-200D-2642-FE0F",image:"1f473-1f3ff-200d-2642-fe0f.png",sheet_x:21,sheet_y:43,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false}},obsoletes:"1F473",sheet:[21,38]},moon:{name:"Waxing Gibbous Moon Symbol",unified:"1F314",non_qualified:null,short_names:["waxing_gibbous_moon"],has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[6,12]},"woman-wearing-turban":{name:"Woman Wearing Turban",unified:"1F473-200D-2640-FE0F",non_qualified:"1F473-200D-2640",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F473-1F3FB-200D-2640-FE0F",image:"1f473-1f3fb-200d-2640-fe0f.png",sheet_x:21,sheet_y:33,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FC":{unified:"1F473-1F3FC-200D-2640-FE0F",image:"1f473-1f3fc-200d-2640-fe0f.png",sheet_x:21,sheet_y:34,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FD":{unified:"1F473-1F3FD-200D-2640-FE0F",image:"1f473-1f3fd-200d-2640-fe0f.png",sheet_x:21,sheet_y:35,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FE":{unified:"1F473-1F3FE-200D-2640-FE0F",image:"1f473-1f3fe-200d-2640-fe0f.png",sheet_x:21,sheet_y:36,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FF":{unified:"1F473-1F3FF-200D-2640-FE0F",image:"1f473-1f3ff-200d-2640-fe0f.png",sheet_x:21,sheet_y:37,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false}},sheet:[21,32]},vs:{name:"Squared Vs",unified:"1F19A",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["words","orange-square"],sheet:[0,30]},"flag-mu":{name:"Mauritius Flag",unified:"1F1F2-1F1FA",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[3,34]},man_with_gua_pi_mao:{name:"Man with Gua Pi Mao",unified:"1F472",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,skin_variations:{"1F3FB":{unified:"1F472-1F3FB",non_qualified:null,image:"1f472-1f3fb.png",sheet_x:21,sheet_y:27,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FC":{unified:"1F472-1F3FC",non_qualified:null,image:"1f472-1f3fc.png",sheet_x:21,sheet_y:28,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FD":{unified:"1F472-1F3FD",non_qualified:null,image:"1f472-1f3fd.png",sheet_x:21,sheet_y:29,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FE":{unified:"1F472-1F3FE",non_qualified:null,image:"1f472-1f3fe.png",sheet_x:21,sheet_y:30,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FF":{unified:"1F472-1F3FF",non_qualified:null,image:"1f472-1f3ff.png",sheet_x:21,sheet_y:31,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true}},keywords:["male","boy","chinese"],sheet:[21,26]},koko:{name:"Squared Katakana Koko",unified:"1F201",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["blue-square","here","katakana","japanese","destination"],sheet:[5,29]},full_moon:{name:"Full Moon Symbol",unified:"1F315",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["nature","yellow","twilight","planet","space","night","evening","sleep"],sheet:[6,13]},"flag-mv":{name:"Maldives Flag",unified:"1F1F2-1F1FB",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[3,35]},person_with_headscarf:{name:"Person with Headscarf",unified:"1F9D5",non_qualified:null,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F9D5-1F3FB",non_qualified:null,image:"1f9d5-1f3fb.png",sheet_x:43,sheet_y:23,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FC":{unified:"1F9D5-1F3FC",non_qualified:null,image:"1f9d5-1f3fc.png",sheet_x:43,sheet_y:24,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FD":{unified:"1F9D5-1F3FD",non_qualified:null,image:"1f9d5-1f3fd.png",sheet_x:43,sheet_y:25,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FE":{unified:"1F9D5-1F3FE",non_qualified:null,image:"1f9d5-1f3fe.png",sheet_x:43,sheet_y:26,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FF":{unified:"1F9D5-1F3FF",non_qualified:null,image:"1f9d5-1f3ff.png",sheet_x:43,sheet_y:27,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false}},sheet:[43,22]},waning_gibbous_moon:{name:"Waning Gibbous Moon Symbol",unified:"1F316",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["nature","twilight","planet","space","night","evening","sleep","waxing_gibbous_moon"],sheet:[6,14]},sa:{name:"Squared Katakana Sa",unified:"1F202-FE0F",non_qualified:"1F202",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:true,keywords:["japanese","blue-square","katakana"],sheet:[5,30]},"flag-mw":{name:"Malawi Flag",unified:"1F1F2-1F1FC",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[3,36]},last_quarter_moon:{name:"Last Quarter Moon Symbol",unified:"1F317",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["nature","twilight","planet","space","night","evening","sleep"],sheet:[6,15]},"u6708":{name:"Squared Cjk Unified Ideograph-6708",unified:"1F237-FE0F",non_qualified:"1F237",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:true,keywords:["chinese","month","moon","japanese","orange-square","kanji"],sheet:[5,38]},bearded_person:{name:"Bearded Person",unified:"1F9D4",non_qualified:null,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F9D4-1F3FB",non_qualified:null,image:"1f9d4-1f3fb.png",sheet_x:43,sheet_y:17,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FC":{unified:"1F9D4-1F3FC",non_qualified:null,image:"1f9d4-1f3fc.png",sheet_x:43,sheet_y:18,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FD":{unified:"1F9D4-1F3FD",non_qualified:null,image:"1f9d4-1f3fd.png",sheet_x:43,sheet_y:19,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FE":{unified:"1F9D4-1F3FE",non_qualified:null,image:"1f9d4-1f3fe.png",sheet_x:43,sheet_y:20,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FF":{unified:"1F9D4-1F3FF",non_qualified:null,image:"1f9d4-1f3ff.png",sheet_x:43,sheet_y:21,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false}},keywords:["person","bewhiskered"],sheet:[43,16]},"flag-mx":{name:"Mexico Flag",unified:"1F1F2-1F1FD",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[3,37]},"u6709":{name:"Squared Cjk Unified Ideograph-6709",unified:"1F236",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["orange-square","chinese","have","kanji"],sheet:[5,37]},person_with_blond_hair:{name:"Person with Blond Hair",unified:"1F471",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:true,skin_variations:{"1F3FB":{unified:"1F471-1F3FB",non_qualified:null,image:"1f471-1f3fb.png",sheet_x:21,sheet_y:21,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:true},"1F3FC":{unified:"1F471-1F3FC",non_qualified:null,image:"1f471-1f3fc.png",sheet_x:21,sheet_y:22,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:true},"1F3FD":{unified:"1F471-1F3FD",non_qualified:null,image:"1f471-1f3fd.png",sheet_x:21,sheet_y:23,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:true},"1F3FE":{unified:"1F471-1F3FE",non_qualified:null,image:"1f471-1f3fe.png",sheet_x:21,sheet_y:24,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:true},"1F3FF":{unified:"1F471-1F3FF",non_qualified:null,image:"1f471-1f3ff.png",sheet_x:21,sheet_y:25,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:true}},obsoleted_by:"1F471-200D-2642-FE0F",sheet:[21,20]},waning_crescent_moon:{name:"Waning Crescent Moon Symbol",unified:"1F318",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["nature","twilight","planet","space","night","evening","sleep"],sheet:[6,16]},"flag-my":{name:"Malaysia Flag",unified:"1F1F2-1F1FE",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[3,38]},"u6307":{name:"Squared Cjk Unified Ideograph-6307",unified:"1F22F",non_qualified:null,added_in:"5.2",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["chinese","point","green-square","kanji"],sheet:[5,32]},"blond-haired-man":{name:"Blond Haired Man",unified:"1F471-200D-2642-FE0F",non_qualified:"1F471-200D-2642",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F471-1F3FB-200D-2642-FE0F",image:"1f471-1f3fb-200d-2642-fe0f.png",sheet_x:21,sheet_y:15,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FC":{unified:"1F471-1F3FC-200D-2642-FE0F",image:"1f471-1f3fc-200d-2642-fe0f.png",sheet_x:21,sheet_y:16,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FD":{unified:"1F471-1F3FD-200D-2642-FE0F",image:"1f471-1f3fd-200d-2642-fe0f.png",sheet_x:21,sheet_y:17,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FE":{unified:"1F471-1F3FE-200D-2642-FE0F",image:"1f471-1f3fe-200d-2642-fe0f.png",sheet_x:21,sheet_y:18,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FF":{unified:"1F471-1F3FF-200D-2642-FE0F",image:"1f471-1f3ff-200d-2642-fe0f.png",sheet_x:21,sheet_y:19,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false}},obsoletes:"1F471",sheet:[21,14]},crescent_moon:{name:"Crescent Moon",unified:"1F319",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["night","sleep","sky","evening","magic"],sheet:[6,17]},"flag-mz":{name:"Mozambique Flag",unified:"1F1F2-1F1FF",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[3,39]},new_moon_with_face:{name:"New Moon with Face",unified:"1F31A",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["nature","twilight","planet","space","night","evening","sleep"],sheet:[6,18]},"flag-na":{name:"Namibia Flag",unified:"1F1F3-1F1E6",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[3,40]},"blond-haired-woman":{name:"Blond Haired Woman",unified:"1F471-200D-2640-FE0F",non_qualified:"1F471-200D-2640",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F471-1F3FB-200D-2640-FE0F",image:"1f471-1f3fb-200d-2640-fe0f.png",sheet_x:21,sheet_y:9,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FC":{unified:"1F471-1F3FC-200D-2640-FE0F",image:"1f471-1f3fc-200d-2640-fe0f.png",sheet_x:21,sheet_y:10,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FD":{unified:"1F471-1F3FD-200D-2640-FE0F",image:"1f471-1f3fd-200d-2640-fe0f.png",sheet_x:21,sheet_y:11,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FE":{unified:"1F471-1F3FE-200D-2640-FE0F",image:"1f471-1f3fe-200d-2640-fe0f.png",sheet_x:21,sheet_y:12,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FF":{unified:"1F471-1F3FF-200D-2640-FE0F",image:"1f471-1f3ff-200d-2640-fe0f.png",sheet_x:21,sheet_y:13,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false}},sheet:[21,8]},ideograph_advantage:{name:"Circled Ideograph Advantage",unified:"1F250",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["chinese","kanji","obtain","get","circle"],sheet:[5,42]},first_quarter_moon_with_face:{name:"First Quarter Moon with Face",unified:"1F31B",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["nature","twilight","planet","space","night","evening","sleep"],sheet:[6,19]},man_in_tuxedo:{name:"Man in Tuxedo",unified:"1F935",non_qualified:null,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F935-1F3FB",non_qualified:null,image:"1f935-1f3fb.png",sheet_x:39,sheet_y:35,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false},"1F3FC":{unified:"1F935-1F3FC",non_qualified:null,image:"1f935-1f3fc.png",sheet_x:39,sheet_y:36,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false},"1F3FD":{unified:"1F935-1F3FD",non_qualified:null,image:"1f935-1f3fd.png",sheet_x:39,sheet_y:37,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false},"1F3FE":{unified:"1F935-1F3FE",non_qualified:null,image:"1f935-1f3fe.png",sheet_x:39,sheet_y:38,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false},"1F3FF":{unified:"1F935-1F3FF",non_qualified:null,image:"1f935-1f3ff.png",sheet_x:39,sheet_y:39,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false}},keywords:["couple","marriage","wedding","groom"],sheet:[39,34]},"flag-nc":{name:"New Caledonia Flag",unified:"1F1F3-1F1E8",non_qualified:null,has_img_apple:true,has_img_google:false,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[3,41]},"u5272":{name:"Squared Cjk Unified Ideograph-5272",unified:"1F239",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["cut","divide","chinese","kanji","pink-square"],sheet:[5,40]},"flag-ne":{name:"Niger Flag",unified:"1F1F3-1F1EA",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[3,42]},last_quarter_moon_with_face:{name:"Last Quarter Moon with Face",unified:"1F31C",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["nature","twilight","planet","space","night","evening","sleep"],sheet:[6,20]},"u7121":{name:"Squared Cjk Unified Ideograph-7121",unified:"1F21A",non_qualified:null,added_in:"5.2",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["nothing","chinese","kanji","japanese","orange-square"],sheet:[5,31]},bride_with_veil:{name:"Bride with Veil",unified:"1F470",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,skin_variations:{"1F3FB":{unified:"1F470-1F3FB",non_qualified:null,image:"1f470-1f3fb.png",sheet_x:21,sheet_y:3,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FC":{unified:"1F470-1F3FC",non_qualified:null,image:"1f470-1f3fc.png",sheet_x:21,sheet_y:4,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FD":{unified:"1F470-1F3FD",non_qualified:null,image:"1f470-1f3fd.png",sheet_x:21,sheet_y:5,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FE":{unified:"1F470-1F3FE",non_qualified:null,image:"1f470-1f3fe.png",sheet_x:21,sheet_y:6,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FF":{unified:"1F470-1F3FF",non_qualified:null,image:"1f470-1f3ff.png",sheet_x:21,sheet_y:7,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true}},keywords:["couple","marriage","wedding","woman","bride"],sheet:[21,2]},"u7981":{name:"Squared Cjk Unified Ideograph-7981",unified:"1F232",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["kanji","japanese","chinese","forbidden","limit","restricted","red-square"],sheet:[5,33]},pregnant_woman:{name:"Pregnant Woman",unified:"1F930",non_qualified:null,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F930-1F3FB",non_qualified:null,image:"1f930-1f3fb.png",sheet_x:39,sheet_y:5,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false},"1F3FC":{unified:"1F930-1F3FC",non_qualified:null,image:"1f930-1f3fc.png",sheet_x:39,sheet_y:6,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false},"1F3FD":{unified:"1F930-1F3FD",non_qualified:null,image:"1f930-1f3fd.png",sheet_x:39,sheet_y:7,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false},"1F3FE":{unified:"1F930-1F3FE",non_qualified:null,image:"1f930-1f3fe.png",sheet_x:39,sheet_y:8,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false},"1F3FF":{unified:"1F930-1F3FF",non_qualified:null,image:"1f930-1f3ff.png",sheet_x:39,sheet_y:9,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false}},keywords:["baby"],sheet:[39,4]},thermometer:{name:"Thermometer",unified:"1F321-FE0F",non_qualified:"1F321",added_in:"7.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,keywords:["weather","temperature","hot","cold"],sheet:[6,25]},"flag-nf":{name:"Norfolk Island Flag",unified:"1F1F3-1F1EB",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[3,43]},sunny:{name:"Black Sun with Rays",unified:"2600-FE0F",non_qualified:"2600",added_in:"1.1",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:true,keywords:["weather","nature","brightness","summer","beach","spring"],sheet:[47,16]},accept:{name:"Circled Ideograph Accept",unified:"1F251",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["ok","good","chinese","kanji","agree","yes","orange-circle"],sheet:[5,43]},"flag-ng":{name:"Nigeria Flag",unified:"1F1F3-1F1EC",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[3,44]},"breast-feeding":{name:"Breast-Feeding",unified:"1F931",non_qualified:null,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F931-1F3FB",non_qualified:null,image:"1f931-1f3fb.png",sheet_x:39,sheet_y:11,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FC":{unified:"1F931-1F3FC",non_qualified:null,image:"1f931-1f3fc.png",sheet_x:39,sheet_y:12,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FD":{unified:"1F931-1F3FD",non_qualified:null,image:"1f931-1f3fd.png",sheet_x:39,sheet_y:13,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FE":{unified:"1F931-1F3FE",non_qualified:null,image:"1f931-1f3fe.png",sheet_x:39,sheet_y:14,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FF":{unified:"1F931-1F3FF",non_qualified:null,image:"1f931-1f3ff.png",sheet_x:39,sheet_y:15,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false}},sheet:[39,10]},full_moon_with_face:{name:"Full Moon with Face",unified:"1F31D",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["nature","twilight","planet","space","night","evening","sleep"],sheet:[6,21]},"flag-ni":{name:"Nicaragua Flag",unified:"1F1F3-1F1EE",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[3,45]},"u7533":{name:"Squared Cjk Unified Ideograph-7533",unified:"1F238",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["chinese","japanese","kanji","orange-square"],sheet:[5,39]},angel:{name:"Baby Angel",unified:"1F47C",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,skin_variations:{"1F3FB":{unified:"1F47C-1F3FB",non_qualified:null,image:"1f47c-1f3fb.png",sheet_x:22,sheet_y:44,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FC":{unified:"1F47C-1F3FC",non_qualified:null,image:"1f47c-1f3fc.png",sheet_x:22,sheet_y:45,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FD":{unified:"1F47C-1F3FD",non_qualified:null,image:"1f47c-1f3fd.png",sheet_x:22,sheet_y:46,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FE":{unified:"1F47C-1F3FE",non_qualified:null,image:"1f47c-1f3fe.png",sheet_x:22,sheet_y:47,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FF":{unified:"1F47C-1F3FF",non_qualified:null,image:"1f47c-1f3ff.png",sheet_x:22,sheet_y:48,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true}},keywords:["heaven","wings","halo"],sheet:[22,43]},sun_with_face:{name:"Sun with Face",unified:"1F31E",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["nature","morning","sky"],sheet:[6,22]},santa:{name:"Father Christmas",unified:"1F385",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,skin_variations:{"1F3FB":{unified:"1F385-1F3FB",non_qualified:null,image:"1f385-1f3fb.png",sheet_x:8,sheet_y:20,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FC":{unified:"1F385-1F3FC",non_qualified:null,image:"1f385-1f3fc.png",sheet_x:8,sheet_y:21,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FD":{unified:"1F385-1F3FD",non_qualified:null,image:"1f385-1f3fd.png",sheet_x:8,sheet_y:22,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FE":{unified:"1F385-1F3FE",non_qualified:null,image:"1f385-1f3fe.png",sheet_x:8,sheet_y:23,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FF":{unified:"1F385-1F3FF",non_qualified:null,image:"1f385-1f3ff.png",sheet_x:8,sheet_y:24,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true}},keywords:["festival","man","male","xmas","father christmas"],sheet:[8,19]},"u5408":{name:"Squared Cjk Unified Ideograph-5408",unified:"1F234",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["japanese","chinese","join","kanji","red-square"],sheet:[5,35]},"flag-nl":{name:"Netherlands Flag",unified:"1F1F3-1F1F1",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[3,46]},mrs_claus:{name:"Mother Christmas",unified:"1F936",non_qualified:null,short_names:["mother_christmas"],added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F936-1F3FB",non_qualified:null,image:"1f936-1f3fb.png",sheet_x:39,sheet_y:41,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false},"1F3FC":{unified:"1F936-1F3FC",non_qualified:null,image:"1f936-1f3fc.png",sheet_x:39,sheet_y:42,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false},"1F3FD":{unified:"1F936-1F3FD",non_qualified:null,image:"1f936-1f3fd.png",sheet_x:39,sheet_y:43,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false},"1F3FE":{unified:"1F936-1F3FE",non_qualified:null,image:"1f936-1f3fe.png",sheet_x:39,sheet_y:44,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false},"1F3FF":{unified:"1F936-1F3FF",non_qualified:null,image:"1f936-1f3ff.png",sheet_x:39,sheet_y:45,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false}},keywords:["woman","female","xmas","mother christmas"],sheet:[39,40]},"u7a7a":{name:"Squared Cjk Unified Ideograph-7a7a",unified:"1F233",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["kanji","japanese","chinese","empty","sky","blue-square"],sheet:[5,34]},star:{name:"White Medium Star",unified:"2B50",non_qualified:null,added_in:"5.1",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["night","yellow"],sheet:[50,22]},"flag-no":{name:"Norway Flag",unified:"1F1F3-1F1F4",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[3,47]},mage:{name:"Mage",unified:"1F9D9",non_qualified:null,added_in:"10.0",has_img_apple:true,has_img_google:false,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F9D9-1F3FB",non_qualified:null,image:"1f9d9-1f3fb.png",sheet_x:44,sheet_y:43,added_in:"10.0",has_img_apple:true,has_img_google:false,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,obsoleted_by:"1F9D9-1F3FB-200D-2640-FE0F"},"1F3FC":{unified:"1F9D9-1F3FC",non_qualified:null,image:"1f9d9-1f3fc.png",sheet_x:44,sheet_y:44,added_in:"10.0",has_img_apple:true,has_img_google:false,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,obsoleted_by:"1F9D9-1F3FC-200D-2640-FE0F"},"1F3FD":{unified:"1F9D9-1F3FD",non_qualified:null,image:"1f9d9-1f3fd.png",sheet_x:44,sheet_y:45,added_in:"10.0",has_img_apple:true,has_img_google:false,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,obsoleted_by:"1F9D9-1F3FD-200D-2640-FE0F"},"1F3FE":{unified:"1F9D9-1F3FE",non_qualified:null,image:"1f9d9-1f3fe.png",sheet_x:44,sheet_y:46,added_in:"10.0",has_img_apple:true,has_img_google:false,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,obsoleted_by:"1F9D9-1F3FE-200D-2640-FE0F"},"1F3FF":{unified:"1F9D9-1F3FF",non_qualified:null,image:"1f9d9-1f3ff.png",sheet_x:44,sheet_y:47,added_in:"10.0",has_img_apple:true,has_img_google:false,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,obsoleted_by:"1F9D9-1F3FF-200D-2640-FE0F"}},obsoleted_by:"1F9D9-200D-2640-FE0F",sheet:[44,42]},"star2":{name:"Glowing Star",unified:"1F31F",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["night","sparkle","awesome","good","magic"],sheet:[6,23]},"flag-np":{name:"Nepal Flag",unified:"1F1F3-1F1F5",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[3,48]},congratulations:{name:"Circled Ideograph Congratulation",unified:"3297-FE0F",non_qualified:"3297",added_in:"1.1",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:true,keywords:["chinese","kanji","japanese","red-circle"],sheet:[50,26]},"flag-nr":{name:"Nauru Flag",unified:"1F1F3-1F1F7",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[3,49]},stars:{name:"Shooting Star",unified:"1F320",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["night","photo"],sheet:[6,24]},female_mage:{name:"Female Mage",unified:"1F9D9-200D-2640-FE0F",non_qualified:"1F9D9-200D-2640",added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F9D9-1F3FB-200D-2640-FE0F",image:"1f9d9-1f3fb-200d-2640-fe0f.png",sheet_x:44,sheet_y:31,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false,obsoletes:"1F9D9-1F3FB"},"1F3FC":{unified:"1F9D9-1F3FC-200D-2640-FE0F",image:"1f9d9-1f3fc-200d-2640-fe0f.png",sheet_x:44,sheet_y:32,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false,obsoletes:"1F9D9-1F3FC"},"1F3FD":{unified:"1F9D9-1F3FD-200D-2640-FE0F",image:"1f9d9-1f3fd-200d-2640-fe0f.png",sheet_x:44,sheet_y:33,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false,obsoletes:"1F9D9-1F3FD"},"1F3FE":{unified:"1F9D9-1F3FE-200D-2640-FE0F",image:"1f9d9-1f3fe-200d-2640-fe0f.png",sheet_x:44,sheet_y:34,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false,obsoletes:"1F9D9-1F3FE"},"1F3FF":{unified:"1F9D9-1F3FF-200D-2640-FE0F",image:"1f9d9-1f3ff-200d-2640-fe0f.png",sheet_x:44,sheet_y:35,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false,obsoletes:"1F9D9-1F3FF"}},obsoletes:"1F9D9",sheet:[44,30]},secret:{name:"Circled Ideograph Secret",unified:"3299-FE0F",non_qualified:"3299",added_in:"1.1",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:true,keywords:["privacy","chinese","sshh","kanji","red-circle"],sheet:[50,27]},"flag-nu":{name:"Niue Flag",unified:"1F1F3-1F1FA",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[3,50]},"u55b6":{name:"Squared Cjk Unified Ideograph-55b6",unified:"1F23A",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["japanese","opening hours","orange-square"],sheet:[5,41]},male_mage:{name:"Male Mage",unified:"1F9D9-200D-2642-FE0F",non_qualified:"1F9D9-200D-2642",added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F9D9-1F3FB-200D-2642-FE0F",image:"1f9d9-1f3fb-200d-2642-fe0f.png",sheet_x:44,sheet_y:37,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FC":{unified:"1F9D9-1F3FC-200D-2642-FE0F",image:"1f9d9-1f3fc-200d-2642-fe0f.png",sheet_x:44,sheet_y:38,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FD":{unified:"1F9D9-1F3FD-200D-2642-FE0F",image:"1f9d9-1f3fd-200d-2642-fe0f.png",sheet_x:44,sheet_y:39,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FE":{unified:"1F9D9-1F3FE-200D-2642-FE0F",image:"1f9d9-1f3fe-200d-2642-fe0f.png",sheet_x:44,sheet_y:40,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FF":{unified:"1F9D9-1F3FF-200D-2642-FE0F",image:"1f9d9-1f3ff-200d-2642-fe0f.png",sheet_x:44,sheet_y:41,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false}},sheet:[44,36]},cloud:{name:"Cloud",unified:"2601-FE0F",non_qualified:"2601",added_in:"1.1",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:true,keywords:["weather","sky"],sheet:[47,17]},"flag-nz":{name:"New Zealand Flag",unified:"1F1F3-1F1FF",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[3,51]},partly_sunny:{name:"Sun Behind Cloud",unified:"26C5",non_qualified:null,added_in:"5.2",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["weather","nature","cloudy","morning","fall","spring"],sheet:[48,29]},fairy:{name:"Fairy",unified:"1F9DA",non_qualified:null,added_in:"10.0",has_img_apple:true,has_img_google:false,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F9DA-1F3FB",non_qualified:null,image:"1f9da-1f3fb.png",sheet_x:45,sheet_y:9,added_in:"10.0",has_img_apple:true,has_img_google:false,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false,obsoleted_by:"1F9DA-1F3FB-200D-2640-FE0F"},"1F3FC":{unified:"1F9DA-1F3FC",non_qualified:null,image:"1f9da-1f3fc.png",sheet_x:45,sheet_y:10,added_in:"10.0",has_img_apple:true,has_img_google:false,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false,obsoleted_by:"1F9DA-1F3FC-200D-2640-FE0F"},"1F3FD":{unified:"1F9DA-1F3FD",non_qualified:null,image:"1f9da-1f3fd.png",sheet_x:45,sheet_y:11,added_in:"10.0",has_img_apple:true,has_img_google:false,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false,obsoleted_by:"1F9DA-1F3FD-200D-2640-FE0F"},"1F3FE":{unified:"1F9DA-1F3FE",non_qualified:null,image:"1f9da-1f3fe.png",sheet_x:45,sheet_y:12,added_in:"10.0",has_img_apple:true,has_img_google:false,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false,obsoleted_by:"1F9DA-1F3FE-200D-2640-FE0F"},"1F3FF":{unified:"1F9DA-1F3FF",non_qualified:null,image:"1f9da-1f3ff.png",sheet_x:45,sheet_y:13,added_in:"10.0",has_img_apple:true,has_img_google:false,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false,obsoleted_by:"1F9DA-1F3FF-200D-2640-FE0F"}},obsoleted_by:"1F9DA-200D-2640-FE0F",sheet:[45,8]},"u6e80":{name:"Squared Cjk Unified Ideograph-6e80",unified:"1F235",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["full","chinese","japanese","red-square","kanji"],sheet:[5,36]},black_small_square:{name:"Black Small Square",unified:"25AA-FE0F",non_qualified:"25AA",added_in:"1.1",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:true,keywords:["shape","icon"],sheet:[47,8]},thunder_cloud_and_rain:{name:"Thunder Cloud and Rain",unified:"26C8-FE0F",non_qualified:"26C8",added_in:"5.2",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,sheet:[48,30]},female_fairy:{name:"Female Fairy",unified:"1F9DA-200D-2640-FE0F",non_qualified:"1F9DA-200D-2640",added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F9DA-1F3FB-200D-2640-FE0F",image:"1f9da-1f3fb-200d-2640-fe0f.png",sheet_x:44,sheet_y:49,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false,obsoletes:"1F9DA-1F3FB"},"1F3FC":{unified:"1F9DA-1F3FC-200D-2640-FE0F",image:"1f9da-1f3fc-200d-2640-fe0f.png",sheet_x:44,sheet_y:50,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false,obsoletes:"1F9DA-1F3FC"},"1F3FD":{unified:"1F9DA-1F3FD-200D-2640-FE0F",image:"1f9da-1f3fd-200d-2640-fe0f.png",sheet_x:44,sheet_y:51,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false,obsoletes:"1F9DA-1F3FD"},"1F3FE":{unified:"1F9DA-1F3FE-200D-2640-FE0F",image:"1f9da-1f3fe-200d-2640-fe0f.png",sheet_x:45,sheet_y:0,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false,obsoletes:"1F9DA-1F3FE"},"1F3FF":{unified:"1F9DA-1F3FF-200D-2640-FE0F",image:"1f9da-1f3ff-200d-2640-fe0f.png",sheet_x:45,sheet_y:1,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false,obsoletes:"1F9DA-1F3FF"}},obsoletes:"1F9DA",sheet:[44,48]},"flag-om":{name:"Oman Flag",unified:"1F1F4-1F1F2",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[4,0]},white_small_square:{name:"White Small Square",unified:"25AB-FE0F",non_qualified:"25AB",added_in:"1.1",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:true,keywords:["shape","icon"],sheet:[47,9]},"flag-pa":{name:"Panama Flag",unified:"1F1F5-1F1E6",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[4,1]},mostly_sunny:{name:"Mostly Sunny",unified:"1F324-FE0F",non_qualified:"1F324",short_names:["sun_small_cloud"],added_in:"7.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,sheet:[6,26]},male_fairy:{name:"Male Fairy",unified:"1F9DA-200D-2642-FE0F",non_qualified:"1F9DA-200D-2642",added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F9DA-1F3FB-200D-2642-FE0F",image:"1f9da-1f3fb-200d-2642-fe0f.png",sheet_x:45,sheet_y:3,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FC":{unified:"1F9DA-1F3FC-200D-2642-FE0F",image:"1f9da-1f3fc-200d-2642-fe0f.png",sheet_x:45,sheet_y:4,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FD":{unified:"1F9DA-1F3FD-200D-2642-FE0F",image:"1f9da-1f3fd-200d-2642-fe0f.png",sheet_x:45,sheet_y:5,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FE":{unified:"1F9DA-1F3FE-200D-2642-FE0F",image:"1f9da-1f3fe-200d-2642-fe0f.png",sheet_x:45,sheet_y:6,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FF":{unified:"1F9DA-1F3FF-200D-2642-FE0F",image:"1f9da-1f3ff-200d-2642-fe0f.png",sheet_x:45,sheet_y:7,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false}},sheet:[45,2]},barely_sunny:{name:"Barely Sunny",unified:"1F325-FE0F",non_qualified:"1F325",short_names:["sun_behind_cloud"],added_in:"7.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,sheet:[6,27]},white_medium_square:{name:"White Medium Square",unified:"25FB-FE0F",non_qualified:"25FB",added_in:"3.2",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:true,keywords:["shape","stone","icon"],sheet:[47,12]},"flag-pe":{name:"Peru Flag",unified:"1F1F5-1F1EA",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[4,2]},vampire:{name:"Vampire",unified:"1F9DB",non_qualified:null,added_in:"10.0",has_img_apple:true,has_img_google:false,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F9DB-1F3FB",non_qualified:null,image:"1f9db-1f3fb.png",sheet_x:45,sheet_y:27,added_in:"10.0",has_img_apple:true,has_img_google:false,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false,obsoleted_by:"1F9DB-1F3FB-200D-2640-FE0F"},"1F3FC":{unified:"1F9DB-1F3FC",non_qualified:null,image:"1f9db-1f3fc.png",sheet_x:45,sheet_y:28,added_in:"10.0",has_img_apple:true,has_img_google:false,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false,obsoleted_by:"1F9DB-1F3FC-200D-2640-FE0F"},"1F3FD":{unified:"1F9DB-1F3FD",non_qualified:null,image:"1f9db-1f3fd.png",sheet_x:45,sheet_y:29,added_in:"10.0",has_img_apple:true,has_img_google:false,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false,obsoleted_by:"1F9DB-1F3FD-200D-2640-FE0F"},"1F3FE":{unified:"1F9DB-1F3FE",non_qualified:null,image:"1f9db-1f3fe.png",sheet_x:45,sheet_y:30,added_in:"10.0",has_img_apple:true,has_img_google:false,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false,obsoleted_by:"1F9DB-1F3FE-200D-2640-FE0F"},"1F3FF":{unified:"1F9DB-1F3FF",non_qualified:null,image:"1f9db-1f3ff.png",sheet_x:45,sheet_y:31,added_in:"10.0",has_img_apple:true,has_img_google:false,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false,obsoleted_by:"1F9DB-1F3FF-200D-2640-FE0F"}},obsoleted_by:"1F9DB-200D-2640-FE0F",sheet:[45,26]},female_vampire:{name:"Female Vampire",unified:"1F9DB-200D-2640-FE0F",non_qualified:"1F9DB-200D-2640",added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F9DB-1F3FB-200D-2640-FE0F",image:"1f9db-1f3fb-200d-2640-fe0f.png",sheet_x:45,sheet_y:15,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false,obsoletes:"1F9DB-1F3FB"},"1F3FC":{unified:"1F9DB-1F3FC-200D-2640-FE0F",image:"1f9db-1f3fc-200d-2640-fe0f.png",sheet_x:45,sheet_y:16,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false,obsoletes:"1F9DB-1F3FC"},"1F3FD":{unified:"1F9DB-1F3FD-200D-2640-FE0F",image:"1f9db-1f3fd-200d-2640-fe0f.png",sheet_x:45,sheet_y:17,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false,obsoletes:"1F9DB-1F3FD"},"1F3FE":{unified:"1F9DB-1F3FE-200D-2640-FE0F",image:"1f9db-1f3fe-200d-2640-fe0f.png",sheet_x:45,sheet_y:18,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false,obsoletes:"1F9DB-1F3FE"},"1F3FF":{unified:"1F9DB-1F3FF-200D-2640-FE0F",image:"1f9db-1f3ff-200d-2640-fe0f.png",sheet_x:45,sheet_y:19,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false,obsoletes:"1F9DB-1F3FF"}},obsoletes:"1F9DB",sheet:[45,14]},partly_sunny_rain:{name:"Partly Sunny Rain",unified:"1F326-FE0F",non_qualified:"1F326",short_names:["sun_behind_rain_cloud"],added_in:"7.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,sheet:[6,28]},"flag-pf":{name:"French Polynesia Flag",unified:"1F1F5-1F1EB",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[4,3]},black_medium_square:{name:"Black Medium Square",unified:"25FC-FE0F",non_qualified:"25FC",added_in:"3.2",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:true,keywords:["shape","button","icon"],sheet:[47,13]},white_medium_small_square:{name:"White Medium Small Square",unified:"25FD",non_qualified:null,added_in:"3.2",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["shape","stone","icon","button"],sheet:[47,14]},rain_cloud:{name:"Rain Cloud",unified:"1F327-FE0F",non_qualified:"1F327",added_in:"7.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,sheet:[6,29]},"flag-pg":{name:"Papua New Guinea Flag",unified:"1F1F5-1F1EC",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[4,4]},male_vampire:{name:"Male Vampire",unified:"1F9DB-200D-2642-FE0F",non_qualified:"1F9DB-200D-2642",added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F9DB-1F3FB-200D-2642-FE0F",image:"1f9db-1f3fb-200d-2642-fe0f.png",sheet_x:45,sheet_y:21,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FC":{unified:"1F9DB-1F3FC-200D-2642-FE0F",image:"1f9db-1f3fc-200d-2642-fe0f.png",sheet_x:45,sheet_y:22,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FD":{unified:"1F9DB-1F3FD-200D-2642-FE0F",image:"1f9db-1f3fd-200d-2642-fe0f.png",sheet_x:45,sheet_y:23,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FE":{unified:"1F9DB-1F3FE-200D-2642-FE0F",image:"1f9db-1f3fe-200d-2642-fe0f.png",sheet_x:45,sheet_y:24,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FF":{unified:"1F9DB-1F3FF-200D-2642-FE0F",image:"1f9db-1f3ff-200d-2642-fe0f.png",sheet_x:45,sheet_y:25,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false}},sheet:[45,20]},"flag-ph":{name:"Philippines Flag",unified:"1F1F5-1F1ED",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[4,5]},merperson:{name:"Merperson",unified:"1F9DC",non_qualified:null,added_in:"10.0",has_img_apple:true,has_img_google:false,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F9DC-1F3FB",non_qualified:null,image:"1f9dc-1f3fb.png",sheet_x:45,sheet_y:45,added_in:"10.0",has_img_apple:true,has_img_google:false,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,obsoleted_by:"1F9DC-1F3FB-200D-2642-FE0F"},"1F3FC":{unified:"1F9DC-1F3FC",non_qualified:null,image:"1f9dc-1f3fc.png",sheet_x:45,sheet_y:46,added_in:"10.0",has_img_apple:true,has_img_google:false,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,obsoleted_by:"1F9DC-1F3FC-200D-2642-FE0F"},"1F3FD":{unified:"1F9DC-1F3FD",non_qualified:null,image:"1f9dc-1f3fd.png",sheet_x:45,sheet_y:47,added_in:"10.0",has_img_apple:true,has_img_google:false,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,obsoleted_by:"1F9DC-1F3FD-200D-2642-FE0F"},"1F3FE":{unified:"1F9DC-1F3FE",non_qualified:null,image:"1f9dc-1f3fe.png",sheet_x:45,sheet_y:48,added_in:"10.0",has_img_apple:true,has_img_google:false,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,obsoleted_by:"1F9DC-1F3FE-200D-2642-FE0F"},"1F3FF":{unified:"1F9DC-1F3FF",non_qualified:null,image:"1f9dc-1f3ff.png",sheet_x:45,sheet_y:49,added_in:"10.0",has_img_apple:true,has_img_google:false,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,obsoleted_by:"1F9DC-1F3FF-200D-2642-FE0F"}},obsoleted_by:"1F9DC-200D-2642-FE0F",sheet:[45,44]},black_medium_small_square:{name:"Black Medium Small Square",unified:"25FE",non_qualified:null,added_in:"3.2",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["icon","shape","button"],sheet:[47,15]},snow_cloud:{name:"Snow Cloud",unified:"1F328-FE0F",non_qualified:"1F328",added_in:"7.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,sheet:[6,30]},lightning:{name:"Lightning",unified:"1F329-FE0F",non_qualified:"1F329",short_names:["lightning_cloud"],added_in:"7.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,sheet:[6,31]},black_large_square:{name:"Black Large Square",unified:"2B1B",non_qualified:null,added_in:"5.1",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["shape","icon","button"],sheet:[50,20]},mermaid:{name:"Mermaid",unified:"1F9DC-200D-2640-FE0F",non_qualified:"1F9DC-200D-2640",added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F9DC-1F3FB-200D-2640-FE0F",image:"1f9dc-1f3fb-200d-2640-fe0f.png",sheet_x:45,sheet_y:33,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FC":{unified:"1F9DC-1F3FC-200D-2640-FE0F",image:"1f9dc-1f3fc-200d-2640-fe0f.png",sheet_x:45,sheet_y:34,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FD":{unified:"1F9DC-1F3FD-200D-2640-FE0F",image:"1f9dc-1f3fd-200d-2640-fe0f.png",sheet_x:45,sheet_y:35,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FE":{unified:"1F9DC-1F3FE-200D-2640-FE0F",image:"1f9dc-1f3fe-200d-2640-fe0f.png",sheet_x:45,sheet_y:36,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FF":{unified:"1F9DC-1F3FF-200D-2640-FE0F",image:"1f9dc-1f3ff-200d-2640-fe0f.png",sheet_x:45,sheet_y:37,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false}},keywords:["woman","female","merwoman","ariel"],sheet:[45,32]},"flag-pk":{name:"Pakistan Flag",unified:"1F1F5-1F1F0",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[4,6]},merman:{name:"Merman",unified:"1F9DC-200D-2642-FE0F",non_qualified:"1F9DC-200D-2642",added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F9DC-1F3FB-200D-2642-FE0F",image:"1f9dc-1f3fb-200d-2642-fe0f.png",sheet_x:45,sheet_y:39,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false,obsoletes:"1F9DC-1F3FB"},"1F3FC":{unified:"1F9DC-1F3FC-200D-2642-FE0F",image:"1f9dc-1f3fc-200d-2642-fe0f.png",sheet_x:45,sheet_y:40,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false,obsoletes:"1F9DC-1F3FC"},"1F3FD":{unified:"1F9DC-1F3FD-200D-2642-FE0F",image:"1f9dc-1f3fd-200d-2642-fe0f.png",sheet_x:45,sheet_y:41,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false,obsoletes:"1F9DC-1F3FD"},"1F3FE":{unified:"1F9DC-1F3FE-200D-2642-FE0F",image:"1f9dc-1f3fe-200d-2642-fe0f.png",sheet_x:45,sheet_y:42,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false,obsoletes:"1F9DC-1F3FE"},"1F3FF":{unified:"1F9DC-1F3FF-200D-2642-FE0F",image:"1f9dc-1f3ff-200d-2642-fe0f.png",sheet_x:45,sheet_y:43,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false,obsoletes:"1F9DC-1F3FF"}},obsoletes:"1F9DC",keywords:["man","male","triton"],sheet:[45,38]},white_large_square:{name:"White Large Square",unified:"2B1C",non_qualified:null,added_in:"5.1",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["shape","icon","stone","button"],sheet:[50,21]},tornado:{name:"Tornado",unified:"1F32A-FE0F",non_qualified:"1F32A",short_names:["tornado_cloud"],added_in:"7.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,keywords:["weather","cyclone","twister"],sheet:[6,32]},"flag-pl":{name:"Poland Flag",unified:"1F1F5-1F1F1",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[4,7]},elf:{name:"Elf",unified:"1F9DD",non_qualified:null,added_in:"10.0",has_img_apple:true,has_img_google:false,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F9DD-1F3FB",non_qualified:null,image:"1f9dd-1f3fb.png",sheet_x:46,sheet_y:11,added_in:"10.0",has_img_apple:true,has_img_google:false,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,obsoleted_by:"1F9DD-1F3FB-200D-2642-FE0F"},"1F3FC":{unified:"1F9DD-1F3FC",non_qualified:null,image:"1f9dd-1f3fc.png",sheet_x:46,sheet_y:12,added_in:"10.0",has_img_apple:true,has_img_google:false,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,obsoleted_by:"1F9DD-1F3FC-200D-2642-FE0F"},"1F3FD":{unified:"1F9DD-1F3FD",non_qualified:null,image:"1f9dd-1f3fd.png",sheet_x:46,sheet_y:13,added_in:"10.0",has_img_apple:true,has_img_google:false,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,obsoleted_by:"1F9DD-1F3FD-200D-2642-FE0F"},"1F3FE":{unified:"1F9DD-1F3FE",non_qualified:null,image:"1f9dd-1f3fe.png",sheet_x:46,sheet_y:14,added_in:"10.0",has_img_apple:true,has_img_google:false,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,obsoleted_by:"1F9DD-1F3FE-200D-2642-FE0F"},"1F3FF":{unified:"1F9DD-1F3FF",non_qualified:null,image:"1f9dd-1f3ff.png",sheet_x:46,sheet_y:15,added_in:"10.0",has_img_apple:true,has_img_google:false,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,obsoleted_by:"1F9DD-1F3FF-200D-2642-FE0F"}},obsoleted_by:"1F9DD-200D-2642-FE0F",sheet:[46,10]},fog:{name:"Fog",unified:"1F32B-FE0F",non_qualified:"1F32B",added_in:"7.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,keywords:["weather"],sheet:[6,33]},large_orange_diamond:{name:"Large Orange Diamond",unified:"1F536",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["shape","jewel","gem"],sheet:[28,4]},"flag-pm":{name:"St. Pierre & Miquelon Flag",unified:"1F1F5-1F1F2",non_qualified:null,has_img_apple:true,has_img_google:false,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[4,8]},"flag-pn":{name:"Pitcairn Islands Flag",unified:"1F1F5-1F1F3",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[4,9]},wind_blowing_face:{name:"Wind Blowing Face",unified:"1F32C-FE0F",non_qualified:"1F32C",added_in:"7.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,sheet:[6,34]},female_elf:{name:"Female Elf",unified:"1F9DD-200D-2640-FE0F",non_qualified:"1F9DD-200D-2640",added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F9DD-1F3FB-200D-2640-FE0F",image:"1f9dd-1f3fb-200d-2640-fe0f.png",sheet_x:45,sheet_y:51,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FC":{unified:"1F9DD-1F3FC-200D-2640-FE0F",image:"1f9dd-1f3fc-200d-2640-fe0f.png",sheet_x:46,sheet_y:0,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FD":{unified:"1F9DD-1F3FD-200D-2640-FE0F",image:"1f9dd-1f3fd-200d-2640-fe0f.png",sheet_x:46,sheet_y:1,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FE":{unified:"1F9DD-1F3FE-200D-2640-FE0F",image:"1f9dd-1f3fe-200d-2640-fe0f.png",sheet_x:46,sheet_y:2,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FF":{unified:"1F9DD-1F3FF-200D-2640-FE0F",image:"1f9dd-1f3ff-200d-2640-fe0f.png",sheet_x:46,sheet_y:3,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false}},sheet:[45,50]},large_blue_diamond:{name:"Large Blue Diamond",unified:"1F537",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["shape","jewel","gem"],sheet:[28,5]},male_elf:{name:"Male Elf",unified:"1F9DD-200D-2642-FE0F",non_qualified:"1F9DD-200D-2642",added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F9DD-1F3FB-200D-2642-FE0F",image:"1f9dd-1f3fb-200d-2642-fe0f.png",sheet_x:46,sheet_y:5,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false,obsoletes:"1F9DD-1F3FB"},"1F3FC":{unified:"1F9DD-1F3FC-200D-2642-FE0F",image:"1f9dd-1f3fc-200d-2642-fe0f.png",sheet_x:46,sheet_y:6,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false,obsoletes:"1F9DD-1F3FC"},"1F3FD":{unified:"1F9DD-1F3FD-200D-2642-FE0F",image:"1f9dd-1f3fd-200d-2642-fe0f.png",sheet_x:46,sheet_y:7,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false,obsoletes:"1F9DD-1F3FD"},"1F3FE":{unified:"1F9DD-1F3FE-200D-2642-FE0F",image:"1f9dd-1f3fe-200d-2642-fe0f.png",sheet_x:46,sheet_y:8,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false,obsoletes:"1F9DD-1F3FE"},"1F3FF":{unified:"1F9DD-1F3FF-200D-2642-FE0F",image:"1f9dd-1f3ff-200d-2642-fe0f.png",sheet_x:46,sheet_y:9,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false,obsoletes:"1F9DD-1F3FF"}},obsoletes:"1F9DD",sheet:[46,4]},small_orange_diamond:{name:"Small Orange Diamond",unified:"1F538",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["shape","jewel","gem"],sheet:[28,6]},"flag-pr":{name:"Puerto Rico Flag",unified:"1F1F5-1F1F7",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[4,10]},cyclone:{name:"Cyclone",unified:"1F300",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["weather","swirl","blue","cloud","vortex","spiral","whirlpool","spin","tornado","hurricane","typhoon"],sheet:[5,44]},rainbow:{name:"Rainbow",unified:"1F308",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["nature","happy","unicorn_face","photo","sky","spring"],sheet:[6,0]},small_blue_diamond:{name:"Small Blue Diamond",unified:"1F539",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["shape","jewel","gem"],sheet:[28,7]},genie:{name:"Genie",unified:"1F9DE",non_qualified:null,added_in:"10.0",has_img_apple:true,has_img_google:false,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,obsoleted_by:"1F9DE-200D-2642-FE0F",sheet:[46,18]},"flag-ps":{name:"Palestinian Territories Flag",unified:"1F1F5-1F1F8",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[4,11]},small_red_triangle:{name:"Up-Pointing Red Triangle",unified:"1F53A",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["shape","direction","up","top"],sheet:[28,8]},closed_umbrella:{name:"Closed Umbrella",unified:"1F302",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["weather","rain","drizzle"],sheet:[5,46]},female_genie:{name:"Female Genie",unified:"1F9DE-200D-2640-FE0F",non_qualified:"1F9DE-200D-2640",added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,sheet:[46,16]},"flag-pt":{name:"Portugal Flag",unified:"1F1F5-1F1F9",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[4,12]},"flag-pw":{name:"Palau Flag",unified:"1F1F5-1F1FC",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[4,13]},small_red_triangle_down:{name:"Down-Pointing Red Triangle",unified:"1F53B",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["shape","direction","bottom"],sheet:[28,9]},umbrella:{name:"Umbrella",unified:"2602-FE0F",non_qualified:"2602",added_in:"1.1",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,keywords:["rainy","weather","spring"],sheet:[47,18]},male_genie:{name:"Male Genie",unified:"1F9DE-200D-2642-FE0F",non_qualified:"1F9DE-200D-2642",added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,obsoletes:"1F9DE",sheet:[46,17]},zombie:{name:"Zombie",unified:"1F9DF",non_qualified:null,added_in:"10.0",has_img_apple:true,has_img_google:false,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,obsoleted_by:"1F9DF-200D-2642-FE0F",sheet:[46,21]},"flag-py":{name:"Paraguay Flag",unified:"1F1F5-1F1FE",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[4,14]},diamond_shape_with_a_dot_inside:{name:"Diamond Shape with a Dot Inside",unified:"1F4A0",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["jewel","blue","gem","crystal","fancy"],sheet:[25,6]},umbrella_with_rain_drops:{name:"Umbrella with Rain Drops",unified:"2614",non_qualified:null,added_in:"4.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[47,23]},radio_button:{name:"Radio Button",unified:"1F518",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["input","old","music","circle"],sheet:[27,26]},female_zombie:{name:"Female Zombie",unified:"1F9DF-200D-2640-FE0F",non_qualified:"1F9DF-200D-2640",added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,sheet:[46,19]},"flag-qa":{name:"Qatar Flag",unified:"1F1F6-1F1E6",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[4,15]},umbrella_on_ground:{name:"Umbrella on Ground",unified:"26F1-FE0F",non_qualified:"26F1",added_in:"5.2",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,sheet:[48,39]},black_square_button:{name:"Black Square Button",unified:"1F532",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["shape","input","frame"],sheet:[28,0]},zap:{name:"High Voltage Sign",unified:"26A1",non_qualified:null,added_in:"4.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["thunder","weather","lightning bolt","fast"],sheet:[48,21]},male_zombie:{name:"Male Zombie",unified:"1F9DF-200D-2642-FE0F",non_qualified:"1F9DF-200D-2642",added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,obsoletes:"1F9DF",sheet:[46,20]},"flag-re":{name:"Réunion Flag",unified:"1F1F7-1F1EA",non_qualified:null,has_img_apple:true,has_img_google:false,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[4,16]},"flag-ro":{name:"Romania Flag",unified:"1F1F7-1F1F4",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[4,17]},snowflake:{name:"Snowflake",unified:"2744-FE0F",non_qualified:"2744",added_in:"1.1",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:true,keywords:["winter","season","cold","weather","christmas","xmas"],sheet:[49,51]},white_square_button:{name:"White Square Button",unified:"1F533",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["shape","input"],sheet:[28,1]},person_frowning:{name:"Person Frowning",unified:"1F64D",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:true,skin_variations:{"1F3FB":{unified:"1F64D-1F3FB",non_qualified:null,image:"1f64d-1f3fb.png",sheet_x:33,sheet_y:31,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:true},"1F3FC":{unified:"1F64D-1F3FC",non_qualified:null,image:"1f64d-1f3fc.png",sheet_x:33,sheet_y:32,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:true},"1F3FD":{unified:"1F64D-1F3FD",non_qualified:null,image:"1f64d-1f3fd.png",sheet_x:33,sheet_y:33,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:true},"1F3FE":{unified:"1F64D-1F3FE",non_qualified:null,image:"1f64d-1f3fe.png",sheet_x:33,sheet_y:34,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:true},"1F3FF":{unified:"1F64D-1F3FF",non_qualified:null,image:"1f64d-1f3ff.png",sheet_x:33,sheet_y:35,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:true}},obsoleted_by:"1F64D-200D-2640-FE0F",sheet:[33,30]},"flag-rs":{name:"Serbia Flag",unified:"1F1F7-1F1F8",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[4,18]},"man-frowning":{name:"Man Frowning",unified:"1F64D-200D-2642-FE0F",non_qualified:"1F64D-200D-2642",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F64D-1F3FB-200D-2642-FE0F",image:"1f64d-1f3fb-200d-2642-fe0f.png",sheet_x:33,sheet_y:25,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FC":{unified:"1F64D-1F3FC-200D-2642-FE0F",image:"1f64d-1f3fc-200d-2642-fe0f.png",sheet_x:33,sheet_y:26,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FD":{unified:"1F64D-1F3FD-200D-2642-FE0F",image:"1f64d-1f3fd-200d-2642-fe0f.png",sheet_x:33,sheet_y:27,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FE":{unified:"1F64D-1F3FE-200D-2642-FE0F",image:"1f64d-1f3fe-200d-2642-fe0f.png",sheet_x:33,sheet_y:28,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FF":{unified:"1F64D-1F3FF-200D-2642-FE0F",image:"1f64d-1f3ff-200d-2642-fe0f.png",sheet_x:33,sheet_y:29,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false}},sheet:[33,24]},white_circle:{name:"Medium White Circle",unified:"26AA",non_qualified:null,added_in:"4.1",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["shape","round"],sheet:[48,22]},snowman:{name:"Snowman",unified:"2603-FE0F",non_qualified:"2603",added_in:"1.1",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,keywords:["winter","season","cold","weather","christmas","xmas","frozen","without_snow"],sheet:[47,19]},snowman_without_snow:{name:"Snowman Without Snow",unified:"26C4",non_qualified:null,added_in:"5.2",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[48,28]},ru:{name:"Russia Flag",unified:"1F1F7-1F1FA",non_qualified:null,short_names:["flag-ru"],has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["russian","federation","flag","nation","country","banner"],sheet:[4,19]},black_circle:{name:"Medium Black Circle",unified:"26AB",non_qualified:null,added_in:"4.1",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["shape","button","round"],sheet:[48,23]},"woman-frowning":{name:"Woman Frowning",unified:"1F64D-200D-2640-FE0F",non_qualified:"1F64D-200D-2640",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F64D-1F3FB-200D-2640-FE0F",image:"1f64d-1f3fb-200d-2640-fe0f.png",sheet_x:33,sheet_y:19,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FC":{unified:"1F64D-1F3FC-200D-2640-FE0F",image:"1f64d-1f3fc-200d-2640-fe0f.png",sheet_x:33,sheet_y:20,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FD":{unified:"1F64D-1F3FD-200D-2640-FE0F",image:"1f64d-1f3fd-200d-2640-fe0f.png",sheet_x:33,sheet_y:21,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FE":{unified:"1F64D-1F3FE-200D-2640-FE0F",image:"1f64d-1f3fe-200d-2640-fe0f.png",sheet_x:33,sheet_y:22,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FF":{unified:"1F64D-1F3FF-200D-2640-FE0F",image:"1f64d-1f3ff-200d-2640-fe0f.png",sheet_x:33,sheet_y:23,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false}},obsoletes:"1F64D",sheet:[33,18]},"flag-rw":{name:"Rwanda Flag",unified:"1F1F7-1F1FC",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[4,20]},comet:{name:"Comet",unified:"2604-FE0F",non_qualified:"2604",added_in:"1.1",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,keywords:["space"],sheet:[47,20]},person_with_pouting_face:{name:"Person with Pouting Face",unified:"1F64E",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:true,skin_variations:{"1F3FB":{unified:"1F64E-1F3FB",non_qualified:null,image:"1f64e-1f3fb.png",sheet_x:33,sheet_y:49,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:true},"1F3FC":{unified:"1F64E-1F3FC",non_qualified:null,image:"1f64e-1f3fc.png",sheet_x:33,sheet_y:50,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:true},"1F3FD":{unified:"1F64E-1F3FD",non_qualified:null,image:"1f64e-1f3fd.png",sheet_x:33,sheet_y:51,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:true},"1F3FE":{unified:"1F64E-1F3FE",non_qualified:null,image:"1f64e-1f3fe.png",sheet_x:34,sheet_y:0,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:true},"1F3FF":{unified:"1F64E-1F3FF",non_qualified:null,image:"1f64e-1f3ff.png",sheet_x:34,sheet_y:1,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:true}},obsoleted_by:"1F64E-200D-2640-FE0F",sheet:[33,48]},red_circle:{name:"Large Red Circle",unified:"1F534",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["shape","error","danger"],sheet:[28,2]},large_blue_circle:{name:"Large Blue Circle",unified:"1F535",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["shape","icon","button"],sheet:[28,3]},"man-pouting":{name:"Man Pouting",unified:"1F64E-200D-2642-FE0F",non_qualified:"1F64E-200D-2642",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F64E-1F3FB-200D-2642-FE0F",image:"1f64e-1f3fb-200d-2642-fe0f.png",sheet_x:33,sheet_y:43,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FC":{unified:"1F64E-1F3FC-200D-2642-FE0F",image:"1f64e-1f3fc-200d-2642-fe0f.png",sheet_x:33,sheet_y:44,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FD":{unified:"1F64E-1F3FD-200D-2642-FE0F",image:"1f64e-1f3fd-200d-2642-fe0f.png",sheet_x:33,sheet_y:45,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FE":{unified:"1F64E-1F3FE-200D-2642-FE0F",image:"1f64e-1f3fe-200d-2642-fe0f.png",sheet_x:33,sheet_y:46,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FF":{unified:"1F64E-1F3FF-200D-2642-FE0F",image:"1f64e-1f3ff-200d-2642-fe0f.png",sheet_x:33,sheet_y:47,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false}},sheet:[33,42]},"flag-sa":{name:"Saudi Arabia Flag",unified:"1F1F8-1F1E6",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[4,21]},fire:{name:"Fire",unified:"1F525",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["hot","cook","flame"],sheet:[27,39]},"woman-pouting":{name:"Woman Pouting",unified:"1F64E-200D-2640-FE0F",non_qualified:"1F64E-200D-2640",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F64E-1F3FB-200D-2640-FE0F",image:"1f64e-1f3fb-200d-2640-fe0f.png",sheet_x:33,sheet_y:37,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FC":{unified:"1F64E-1F3FC-200D-2640-FE0F",image:"1f64e-1f3fc-200d-2640-fe0f.png",sheet_x:33,sheet_y:38,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FD":{unified:"1F64E-1F3FD-200D-2640-FE0F",image:"1f64e-1f3fd-200d-2640-fe0f.png",sheet_x:33,sheet_y:39,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FE":{unified:"1F64E-1F3FE-200D-2640-FE0F",image:"1f64e-1f3fe-200d-2640-fe0f.png",sheet_x:33,sheet_y:40,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FF":{unified:"1F64E-1F3FF-200D-2640-FE0F",image:"1f64e-1f3ff-200d-2640-fe0f.png",sheet_x:33,sheet_y:41,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false}},obsoletes:"1F64E",sheet:[33,36]},"flag-sb":{name:"Solomon Islands Flag",unified:"1F1F8-1F1E7",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[4,22]},droplet:{name:"Droplet",unified:"1F4A7",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["water","drip","faucet","spring"],sheet:[25,13]},no_good:{name:"Face with No Good Gesture",unified:"1F645",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:true,skin_variations:{"1F3FB":{unified:"1F645-1F3FB",non_qualified:null,image:"1f645-1f3fb.png",sheet_x:32,sheet_y:2,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:true},"1F3FC":{unified:"1F645-1F3FC",non_qualified:null,image:"1f645-1f3fc.png",sheet_x:32,sheet_y:3,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:true},"1F3FD":{unified:"1F645-1F3FD",non_qualified:null,image:"1f645-1f3fd.png",sheet_x:32,sheet_y:4,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:true},"1F3FE":{unified:"1F645-1F3FE",non_qualified:null,image:"1f645-1f3fe.png",sheet_x:32,sheet_y:5,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:true},"1F3FF":{unified:"1F645-1F3FF",non_qualified:null,image:"1f645-1f3ff.png",sheet_x:32,sheet_y:6,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:true}},obsoleted_by:"1F645-200D-2640-FE0F",sheet:[32,1]},"flag-sc":{name:"Seychelles Flag",unified:"1F1F8-1F1E8",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[4,23]},ocean:{name:"Water Wave",unified:"1F30A",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["sea","water","wave","nature","tsunami","disaster"],sheet:[6,2]},"man-gesturing-no":{name:"Man Gesturing No",unified:"1F645-200D-2642-FE0F",non_qualified:"1F645-200D-2642",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F645-1F3FB-200D-2642-FE0F",image:"1f645-1f3fb-200d-2642-fe0f.png",sheet_x:31,sheet_y:48,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FC":{unified:"1F645-1F3FC-200D-2642-FE0F",image:"1f645-1f3fc-200d-2642-fe0f.png",sheet_x:31,sheet_y:49,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FD":{unified:"1F645-1F3FD-200D-2642-FE0F",image:"1f645-1f3fd-200d-2642-fe0f.png",sheet_x:31,sheet_y:50,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FE":{unified:"1F645-1F3FE-200D-2642-FE0F",image:"1f645-1f3fe-200d-2642-fe0f.png",sheet_x:31,sheet_y:51,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FF":{unified:"1F645-1F3FF-200D-2642-FE0F",image:"1f645-1f3ff-200d-2642-fe0f.png",sheet_x:32,sheet_y:0,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false}},sheet:[31,47]},"flag-sd":{name:"Sudan Flag",unified:"1F1F8-1F1E9",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[4,24]},"woman-gesturing-no":{name:"Woman Gesturing No",unified:"1F645-200D-2640-FE0F",non_qualified:"1F645-200D-2640",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F645-1F3FB-200D-2640-FE0F",image:"1f645-1f3fb-200d-2640-fe0f.png",sheet_x:31,sheet_y:42,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FC":{unified:"1F645-1F3FC-200D-2640-FE0F",image:"1f645-1f3fc-200d-2640-fe0f.png",sheet_x:31,sheet_y:43,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FD":{unified:"1F645-1F3FD-200D-2640-FE0F",image:"1f645-1f3fd-200d-2640-fe0f.png",sheet_x:31,sheet_y:44,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FE":{unified:"1F645-1F3FE-200D-2640-FE0F",image:"1f645-1f3fe-200d-2640-fe0f.png",sheet_x:31,sheet_y:45,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FF":{unified:"1F645-1F3FF-200D-2640-FE0F",image:"1f645-1f3ff-200d-2640-fe0f.png",sheet_x:31,sheet_y:46,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false}},obsoletes:"1F645",sheet:[31,41]},"flag-se":{name:"Sweden Flag",unified:"1F1F8-1F1EA",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[4,25]},"flag-sg":{name:"Singapore Flag",unified:"1F1F8-1F1EC",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[4,26]},ok_woman:{name:"Face with Ok Gesture",unified:"1F646",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:true,skin_variations:{"1F3FB":{unified:"1F646-1F3FB",non_qualified:null,image:"1f646-1f3fb.png",sheet_x:32,sheet_y:20,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:true},"1F3FC":{unified:"1F646-1F3FC",non_qualified:null,image:"1f646-1f3fc.png",sheet_x:32,sheet_y:21,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:true},"1F3FD":{unified:"1F646-1F3FD",non_qualified:null,image:"1f646-1f3fd.png",sheet_x:32,sheet_y:22,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:true},"1F3FE":{unified:"1F646-1F3FE",non_qualified:null,image:"1f646-1f3fe.png",sheet_x:32,sheet_y:23,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:true},"1F3FF":{unified:"1F646-1F3FF",non_qualified:null,image:"1f646-1f3ff.png",sheet_x:32,sheet_y:24,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:true}},obsoleted_by:"1F646-200D-2640-FE0F",keywords:["women","girl","female","pink","human","woman"],sheet:[32,19]},"flag-sh":{name:"St. Helena Flag",unified:"1F1F8-1F1ED",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[4,27]},"man-gesturing-ok":{name:"Man Gesturing Ok",unified:"1F646-200D-2642-FE0F",non_qualified:"1F646-200D-2642",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F646-1F3FB-200D-2642-FE0F",image:"1f646-1f3fb-200d-2642-fe0f.png",sheet_x:32,sheet_y:14,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FC":{unified:"1F646-1F3FC-200D-2642-FE0F",image:"1f646-1f3fc-200d-2642-fe0f.png",sheet_x:32,sheet_y:15,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FD":{unified:"1F646-1F3FD-200D-2642-FE0F",image:"1f646-1f3fd-200d-2642-fe0f.png",sheet_x:32,sheet_y:16,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FE":{unified:"1F646-1F3FE-200D-2642-FE0F",image:"1f646-1f3fe-200d-2642-fe0f.png",sheet_x:32,sheet_y:17,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FF":{unified:"1F646-1F3FF-200D-2642-FE0F",image:"1f646-1f3ff-200d-2642-fe0f.png",sheet_x:32,sheet_y:18,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false}},sheet:[32,13]},"flag-si":{name:"Slovenia Flag",unified:"1F1F8-1F1EE",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[4,28]},"woman-gesturing-ok":{name:"Woman Gesturing Ok",unified:"1F646-200D-2640-FE0F",non_qualified:"1F646-200D-2640",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F646-1F3FB-200D-2640-FE0F",image:"1f646-1f3fb-200d-2640-fe0f.png",sheet_x:32,sheet_y:8,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FC":{unified:"1F646-1F3FC-200D-2640-FE0F",image:"1f646-1f3fc-200d-2640-fe0f.png",sheet_x:32,sheet_y:9,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FD":{unified:"1F646-1F3FD-200D-2640-FE0F",image:"1f646-1f3fd-200d-2640-fe0f.png",sheet_x:32,sheet_y:10,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FE":{unified:"1F646-1F3FE-200D-2640-FE0F",image:"1f646-1f3fe-200d-2640-fe0f.png",sheet_x:32,sheet_y:11,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FF":{unified:"1F646-1F3FF-200D-2640-FE0F",image:"1f646-1f3ff-200d-2640-fe0f.png",sheet_x:32,sheet_y:12,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false}},obsoletes:"1F646",sheet:[32,7]},information_desk_person:{name:"Information Desk Person",unified:"1F481",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:true,skin_variations:{"1F3FB":{unified:"1F481-1F3FB",non_qualified:null,image:"1f481-1f3fb.png",sheet_x:23,sheet_y:14,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:true},"1F3FC":{unified:"1F481-1F3FC",non_qualified:null,image:"1f481-1f3fc.png",sheet_x:23,sheet_y:15,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:true},"1F3FD":{unified:"1F481-1F3FD",non_qualified:null,image:"1f481-1f3fd.png",sheet_x:23,sheet_y:16,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:true},"1F3FE":{unified:"1F481-1F3FE",non_qualified:null,image:"1f481-1f3fe.png",sheet_x:23,sheet_y:17,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:true},"1F3FF":{unified:"1F481-1F3FF",non_qualified:null,image:"1f481-1f3ff.png",sheet_x:23,sheet_y:18,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:true}},obsoleted_by:"1F481-200D-2640-FE0F",sheet:[23,13]},"flag-sj":{name:"Svalbard & Jan Mayen Flag",unified:"1F1F8-1F1EF",non_qualified:null,has_img_apple:true,has_img_google:false,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[4,29]},"man-tipping-hand":{name:"Man Tipping Hand",unified:"1F481-200D-2642-FE0F",non_qualified:"1F481-200D-2642",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F481-1F3FB-200D-2642-FE0F",image:"1f481-1f3fb-200d-2642-fe0f.png",sheet_x:23,sheet_y:8,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FC":{unified:"1F481-1F3FC-200D-2642-FE0F",image:"1f481-1f3fc-200d-2642-fe0f.png",sheet_x:23,sheet_y:9,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FD":{unified:"1F481-1F3FD-200D-2642-FE0F",image:"1f481-1f3fd-200d-2642-fe0f.png",sheet_x:23,sheet_y:10,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FE":{unified:"1F481-1F3FE-200D-2642-FE0F",image:"1f481-1f3fe-200d-2642-fe0f.png",sheet_x:23,sheet_y:11,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FF":{unified:"1F481-1F3FF-200D-2642-FE0F",image:"1f481-1f3ff-200d-2642-fe0f.png",sheet_x:23,sheet_y:12,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false}},sheet:[23,7]},"flag-sk":{name:"Slovakia Flag",unified:"1F1F8-1F1F0",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[4,30]},"flag-sl":{name:"Sierra Leone Flag",unified:"1F1F8-1F1F1",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[4,31]},"woman-tipping-hand":{name:"Woman Tipping Hand",unified:"1F481-200D-2640-FE0F",non_qualified:"1F481-200D-2640",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F481-1F3FB-200D-2640-FE0F",image:"1f481-1f3fb-200d-2640-fe0f.png",sheet_x:23,sheet_y:2,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FC":{unified:"1F481-1F3FC-200D-2640-FE0F",image:"1f481-1f3fc-200d-2640-fe0f.png",sheet_x:23,sheet_y:3,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FD":{unified:"1F481-1F3FD-200D-2640-FE0F",image:"1f481-1f3fd-200d-2640-fe0f.png",sheet_x:23,sheet_y:4,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FE":{unified:"1F481-1F3FE-200D-2640-FE0F",image:"1f481-1f3fe-200d-2640-fe0f.png",sheet_x:23,sheet_y:5,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FF":{unified:"1F481-1F3FF-200D-2640-FE0F",image:"1f481-1f3ff-200d-2640-fe0f.png",sheet_x:23,sheet_y:6,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false}},obsoletes:"1F481",sheet:[23,1]},"flag-sm":{name:"San Marino Flag",unified:"1F1F8-1F1F2",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[4,32]},raising_hand:{name:"Happy Person Raising One Hand",unified:"1F64B",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:true,skin_variations:{"1F3FB":{unified:"1F64B-1F3FB",non_qualified:null,image:"1f64b-1f3fb.png",sheet_x:33,sheet_y:7,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:true},"1F3FC":{unified:"1F64B-1F3FC",non_qualified:null,image:"1f64b-1f3fc.png",sheet_x:33,sheet_y:8,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:true},"1F3FD":{unified:"1F64B-1F3FD",non_qualified:null,image:"1f64b-1f3fd.png",sheet_x:33,sheet_y:9,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:true},"1F3FE":{unified:"1F64B-1F3FE",non_qualified:null,image:"1f64b-1f3fe.png",sheet_x:33,sheet_y:10,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:true},"1F3FF":{unified:"1F64B-1F3FF",non_qualified:null,image:"1f64b-1f3ff.png",sheet_x:33,sheet_y:11,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:true}},obsoleted_by:"1F64B-200D-2640-FE0F",sheet:[33,6]},"flag-sn":{name:"Senegal Flag",unified:"1F1F8-1F1F3",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[4,33]},"man-raising-hand":{name:"Man Raising Hand",unified:"1F64B-200D-2642-FE0F",non_qualified:"1F64B-200D-2642",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F64B-1F3FB-200D-2642-FE0F",image:"1f64b-1f3fb-200d-2642-fe0f.png",sheet_x:33,sheet_y:1,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FC":{unified:"1F64B-1F3FC-200D-2642-FE0F",image:"1f64b-1f3fc-200d-2642-fe0f.png",sheet_x:33,sheet_y:2,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FD":{unified:"1F64B-1F3FD-200D-2642-FE0F",image:"1f64b-1f3fd-200d-2642-fe0f.png",sheet_x:33,sheet_y:3,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FE":{unified:"1F64B-1F3FE-200D-2642-FE0F",image:"1f64b-1f3fe-200d-2642-fe0f.png",sheet_x:33,sheet_y:4,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FF":{unified:"1F64B-1F3FF-200D-2642-FE0F",image:"1f64b-1f3ff-200d-2642-fe0f.png",sheet_x:33,sheet_y:5,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false}},sheet:[33,0]},"flag-so":{name:"Somalia Flag",unified:"1F1F8-1F1F4",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[4,34]},"woman-raising-hand":{name:"Woman Raising Hand",unified:"1F64B-200D-2640-FE0F",non_qualified:"1F64B-200D-2640",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F64B-1F3FB-200D-2640-FE0F",image:"1f64b-1f3fb-200d-2640-fe0f.png",sheet_x:32,sheet_y:47,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FC":{unified:"1F64B-1F3FC-200D-2640-FE0F",image:"1f64b-1f3fc-200d-2640-fe0f.png",sheet_x:32,sheet_y:48,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FD":{unified:"1F64B-1F3FD-200D-2640-FE0F",image:"1f64b-1f3fd-200d-2640-fe0f.png",sheet_x:32,sheet_y:49,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FE":{unified:"1F64B-1F3FE-200D-2640-FE0F",image:"1f64b-1f3fe-200d-2640-fe0f.png",sheet_x:32,sheet_y:50,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FF":{unified:"1F64B-1F3FF-200D-2640-FE0F",image:"1f64b-1f3ff-200d-2640-fe0f.png",sheet_x:32,sheet_y:51,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false}},obsoletes:"1F64B",sheet:[32,46]},"flag-sr":{name:"Suriname Flag",unified:"1F1F8-1F1F7",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[4,35]},bow:{name:"Person Bowing Deeply",unified:"1F647",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:true,skin_variations:{"1F3FB":{unified:"1F647-1F3FB",non_qualified:null,image:"1f647-1f3fb.png",sheet_x:32,sheet_y:38,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:true},"1F3FC":{unified:"1F647-1F3FC",non_qualified:null,image:"1f647-1f3fc.png",sheet_x:32,sheet_y:39,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:true},"1F3FD":{unified:"1F647-1F3FD",non_qualified:null,image:"1f647-1f3fd.png",sheet_x:32,sheet_y:40,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:true},"1F3FE":{unified:"1F647-1F3FE",non_qualified:null,image:"1f647-1f3fe.png",sheet_x:32,sheet_y:41,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:true},"1F3FF":{unified:"1F647-1F3FF",non_qualified:null,image:"1f647-1f3ff.png",sheet_x:32,sheet_y:42,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:true}},obsoleted_by:"1F647-200D-2642-FE0F",sheet:[32,37]},"man-bowing":{name:"Man Bowing",unified:"1F647-200D-2642-FE0F",non_qualified:"1F647-200D-2642",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F647-1F3FB-200D-2642-FE0F",image:"1f647-1f3fb-200d-2642-fe0f.png",sheet_x:32,sheet_y:32,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FC":{unified:"1F647-1F3FC-200D-2642-FE0F",image:"1f647-1f3fc-200d-2642-fe0f.png",sheet_x:32,sheet_y:33,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FD":{unified:"1F647-1F3FD-200D-2642-FE0F",image:"1f647-1f3fd-200d-2642-fe0f.png",sheet_x:32,sheet_y:34,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FE":{unified:"1F647-1F3FE-200D-2642-FE0F",image:"1f647-1f3fe-200d-2642-fe0f.png",sheet_x:32,sheet_y:35,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FF":{unified:"1F647-1F3FF-200D-2642-FE0F",image:"1f647-1f3ff-200d-2642-fe0f.png",sheet_x:32,sheet_y:36,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false}},obsoletes:"1F647",sheet:[32,31]},"flag-ss":{name:"South Sudan Flag",unified:"1F1F8-1F1F8",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[4,36]},"woman-bowing":{name:"Woman Bowing",unified:"1F647-200D-2640-FE0F",non_qualified:"1F647-200D-2640",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F647-1F3FB-200D-2640-FE0F",image:"1f647-1f3fb-200d-2640-fe0f.png",sheet_x:32,sheet_y:26,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FC":{unified:"1F647-1F3FC-200D-2640-FE0F",image:"1f647-1f3fc-200d-2640-fe0f.png",sheet_x:32,sheet_y:27,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FD":{unified:"1F647-1F3FD-200D-2640-FE0F",image:"1f647-1f3fd-200d-2640-fe0f.png",sheet_x:32,sheet_y:28,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FE":{unified:"1F647-1F3FE-200D-2640-FE0F",image:"1f647-1f3fe-200d-2640-fe0f.png",sheet_x:32,sheet_y:29,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FF":{unified:"1F647-1F3FF-200D-2640-FE0F",image:"1f647-1f3ff-200d-2640-fe0f.png",sheet_x:32,sheet_y:30,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false}},sheet:[32,25]},"flag-st":{name:"São Tomé & Príncipe Flag",unified:"1F1F8-1F1F9",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[4,37]},face_palm:{name:"Face Palm",unified:"1F926",non_qualified:null,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F926-1F3FB",non_qualified:null,image:"1f926-1f3fb.png",sheet_x:38,sheet_y:42,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:false},"1F3FC":{unified:"1F926-1F3FC",non_qualified:null,image:"1f926-1f3fc.png",sheet_x:38,sheet_y:43,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:false},"1F3FD":{unified:"1F926-1F3FD",non_qualified:null,image:"1f926-1f3fd.png",sheet_x:38,sheet_y:44,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:false},"1F3FE":{unified:"1F926-1F3FE",non_qualified:null,image:"1f926-1f3fe.png",sheet_x:38,sheet_y:45,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:false},"1F3FF":{unified:"1F926-1F3FF",non_qualified:null,image:"1f926-1f3ff.png",sheet_x:38,sheet_y:46,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:false}},sheet:[38,41]},"flag-sv":{name:"El Salvador Flag",unified:"1F1F8-1F1FB",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[4,38]},"man-facepalming":{name:"Man Facepalming",unified:"1F926-200D-2642-FE0F",non_qualified:"1F926-200D-2642",added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F926-1F3FB-200D-2642-FE0F",image:"1f926-1f3fb-200d-2642-fe0f.png",sheet_x:38,sheet_y:36,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FC":{unified:"1F926-1F3FC-200D-2642-FE0F",image:"1f926-1f3fc-200d-2642-fe0f.png",sheet_x:38,sheet_y:37,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FD":{unified:"1F926-1F3FD-200D-2642-FE0F",image:"1f926-1f3fd-200d-2642-fe0f.png",sheet_x:38,sheet_y:38,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FE":{unified:"1F926-1F3FE-200D-2642-FE0F",image:"1f926-1f3fe-200d-2642-fe0f.png",sheet_x:38,sheet_y:39,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FF":{unified:"1F926-1F3FF-200D-2642-FE0F",image:"1f926-1f3ff-200d-2642-fe0f.png",sheet_x:38,sheet_y:40,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false}},sheet:[38,35]},"flag-sx":{name:"Sint Maarten Flag",unified:"1F1F8-1F1FD",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[4,39]},"flag-sy":{name:"Syria Flag",unified:"1F1F8-1F1FE",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[4,40]},"woman-facepalming":{name:"Woman Facepalming",unified:"1F926-200D-2640-FE0F",non_qualified:"1F926-200D-2640",added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F926-1F3FB-200D-2640-FE0F",image:"1f926-1f3fb-200d-2640-fe0f.png",sheet_x:38,sheet_y:30,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FC":{unified:"1F926-1F3FC-200D-2640-FE0F",image:"1f926-1f3fc-200d-2640-fe0f.png",sheet_x:38,sheet_y:31,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FD":{unified:"1F926-1F3FD-200D-2640-FE0F",image:"1f926-1f3fd-200d-2640-fe0f.png",sheet_x:38,sheet_y:32,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FE":{unified:"1F926-1F3FE-200D-2640-FE0F",image:"1f926-1f3fe-200d-2640-fe0f.png",sheet_x:38,sheet_y:33,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FF":{unified:"1F926-1F3FF-200D-2640-FE0F",image:"1f926-1f3ff-200d-2640-fe0f.png",sheet_x:38,sheet_y:34,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false}},sheet:[38,29]},shrug:{name:"Shrug",unified:"1F937",non_qualified:null,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F937-1F3FB",non_qualified:null,image:"1f937-1f3fb.png",sheet_x:40,sheet_y:7,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:false},"1F3FC":{unified:"1F937-1F3FC",non_qualified:null,image:"1f937-1f3fc.png",sheet_x:40,sheet_y:8,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:false},"1F3FD":{unified:"1F937-1F3FD",non_qualified:null,image:"1f937-1f3fd.png",sheet_x:40,sheet_y:9,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:false},"1F3FE":{unified:"1F937-1F3FE",non_qualified:null,image:"1f937-1f3fe.png",sheet_x:40,sheet_y:10,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:false},"1F3FF":{unified:"1F937-1F3FF",non_qualified:null,image:"1f937-1f3ff.png",sheet_x:40,sheet_y:11,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:false}},sheet:[40,6]},"flag-sz":{name:"Swaziland Flag",unified:"1F1F8-1F1FF",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[4,41]},"flag-ta":{name:"Tristan Da Cunha Flag",unified:"1F1F9-1F1E6",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[4,42]},"man-shrugging":{name:"Man Shrugging",unified:"1F937-200D-2642-FE0F",non_qualified:"1F937-200D-2642",added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F937-1F3FB-200D-2642-FE0F",image:"1f937-1f3fb-200d-2642-fe0f.png",sheet_x:40,sheet_y:1,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FC":{unified:"1F937-1F3FC-200D-2642-FE0F",image:"1f937-1f3fc-200d-2642-fe0f.png",sheet_x:40,sheet_y:2,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FD":{unified:"1F937-1F3FD-200D-2642-FE0F",image:"1f937-1f3fd-200d-2642-fe0f.png",sheet_x:40,sheet_y:3,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FE":{unified:"1F937-1F3FE-200D-2642-FE0F",image:"1f937-1f3fe-200d-2642-fe0f.png",sheet_x:40,sheet_y:4,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FF":{unified:"1F937-1F3FF-200D-2642-FE0F",image:"1f937-1f3ff-200d-2642-fe0f.png",sheet_x:40,sheet_y:5,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false}},sheet:[40,0]},"woman-shrugging":{name:"Woman Shrugging",unified:"1F937-200D-2640-FE0F",non_qualified:"1F937-200D-2640",added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F937-1F3FB-200D-2640-FE0F",image:"1f937-1f3fb-200d-2640-fe0f.png",sheet_x:39,sheet_y:47,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FC":{unified:"1F937-1F3FC-200D-2640-FE0F",image:"1f937-1f3fc-200d-2640-fe0f.png",sheet_x:39,sheet_y:48,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FD":{unified:"1F937-1F3FD-200D-2640-FE0F",image:"1f937-1f3fd-200d-2640-fe0f.png",sheet_x:39,sheet_y:49,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FE":{unified:"1F937-1F3FE-200D-2640-FE0F",image:"1f937-1f3fe-200d-2640-fe0f.png",sheet_x:39,sheet_y:50,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FF":{unified:"1F937-1F3FF-200D-2640-FE0F",image:"1f937-1f3ff-200d-2640-fe0f.png",sheet_x:39,sheet_y:51,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false}},sheet:[39,46]},"flag-tc":{name:"Turks & Caicos Islands Flag",unified:"1F1F9-1F1E8",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[4,43]},massage:{name:"Face Massage",unified:"1F486",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:true,skin_variations:{"1F3FB":{unified:"1F486-1F3FB",non_qualified:null,image:"1f486-1f3fb.png",sheet_x:24,sheet_y:11,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:true},"1F3FC":{unified:"1F486-1F3FC",non_qualified:null,image:"1f486-1f3fc.png",sheet_x:24,sheet_y:12,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:true},"1F3FD":{unified:"1F486-1F3FD",non_qualified:null,image:"1f486-1f3fd.png",sheet_x:24,sheet_y:13,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:true},"1F3FE":{unified:"1F486-1F3FE",non_qualified:null,image:"1f486-1f3fe.png",sheet_x:24,sheet_y:14,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:true},"1F3FF":{unified:"1F486-1F3FF",non_qualified:null,image:"1f486-1f3ff.png",sheet_x:24,sheet_y:15,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:true}},obsoleted_by:"1F486-200D-2640-FE0F",sheet:[24,10]},"flag-td":{name:"Chad Flag",unified:"1F1F9-1F1E9",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[4,44]},"man-getting-massage":{name:"Man Getting Massage",unified:"1F486-200D-2642-FE0F",non_qualified:"1F486-200D-2642",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F486-1F3FB-200D-2642-FE0F",image:"1f486-1f3fb-200d-2642-fe0f.png",sheet_x:24,sheet_y:5,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FC":{unified:"1F486-1F3FC-200D-2642-FE0F",image:"1f486-1f3fc-200d-2642-fe0f.png",sheet_x:24,sheet_y:6,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FD":{unified:"1F486-1F3FD-200D-2642-FE0F",image:"1f486-1f3fd-200d-2642-fe0f.png",sheet_x:24,sheet_y:7,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FE":{unified:"1F486-1F3FE-200D-2642-FE0F",image:"1f486-1f3fe-200d-2642-fe0f.png",sheet_x:24,sheet_y:8,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FF":{unified:"1F486-1F3FF-200D-2642-FE0F",image:"1f486-1f3ff-200d-2642-fe0f.png",sheet_x:24,sheet_y:9,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false}},sheet:[24,4]},"flag-tf":{name:"French Southern Territories Flag",unified:"1F1F9-1F1EB",non_qualified:null,has_img_apple:true,has_img_google:false,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[4,45]},"woman-getting-massage":{name:"Woman Getting Massage",unified:"1F486-200D-2640-FE0F",non_qualified:"1F486-200D-2640",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F486-1F3FB-200D-2640-FE0F",image:"1f486-1f3fb-200d-2640-fe0f.png",sheet_x:23,sheet_y:51,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FC":{unified:"1F486-1F3FC-200D-2640-FE0F",image:"1f486-1f3fc-200d-2640-fe0f.png",sheet_x:24,sheet_y:0,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FD":{unified:"1F486-1F3FD-200D-2640-FE0F",image:"1f486-1f3fd-200d-2640-fe0f.png",sheet_x:24,sheet_y:1,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FE":{unified:"1F486-1F3FE-200D-2640-FE0F",image:"1f486-1f3fe-200d-2640-fe0f.png",sheet_x:24,sheet_y:2,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FF":{unified:"1F486-1F3FF-200D-2640-FE0F",image:"1f486-1f3ff-200d-2640-fe0f.png",sheet_x:24,sheet_y:3,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false}},obsoletes:"1F486",sheet:[23,50]},"flag-tg":{name:"Togo Flag",unified:"1F1F9-1F1EC",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[4,46]},haircut:{name:"Haircut",unified:"1F487",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:true,skin_variations:{"1F3FB":{unified:"1F487-1F3FB",non_qualified:null,image:"1f487-1f3fb.png",sheet_x:24,sheet_y:29,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:true},"1F3FC":{unified:"1F487-1F3FC",non_qualified:null,image:"1f487-1f3fc.png",sheet_x:24,sheet_y:30,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:true},"1F3FD":{unified:"1F487-1F3FD",non_qualified:null,image:"1f487-1f3fd.png",sheet_x:24,sheet_y:31,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:true},"1F3FE":{unified:"1F487-1F3FE",non_qualified:null,image:"1f487-1f3fe.png",sheet_x:24,sheet_y:32,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:true},"1F3FF":{unified:"1F487-1F3FF",non_qualified:null,image:"1f487-1f3ff.png",sheet_x:24,sheet_y:33,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:true}},obsoleted_by:"1F487-200D-2640-FE0F",sheet:[24,28]},"flag-th":{name:"Thailand Flag",unified:"1F1F9-1F1ED",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[4,47]},"man-getting-haircut":{name:"Man Getting Haircut",unified:"1F487-200D-2642-FE0F",non_qualified:"1F487-200D-2642",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F487-1F3FB-200D-2642-FE0F",image:"1f487-1f3fb-200d-2642-fe0f.png",sheet_x:24,sheet_y:23,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FC":{unified:"1F487-1F3FC-200D-2642-FE0F",image:"1f487-1f3fc-200d-2642-fe0f.png",sheet_x:24,sheet_y:24,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FD":{unified:"1F487-1F3FD-200D-2642-FE0F",image:"1f487-1f3fd-200d-2642-fe0f.png",sheet_x:24,sheet_y:25,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FE":{unified:"1F487-1F3FE-200D-2642-FE0F",image:"1f487-1f3fe-200d-2642-fe0f.png",sheet_x:24,sheet_y:26,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FF":{unified:"1F487-1F3FF-200D-2642-FE0F",image:"1f487-1f3ff-200d-2642-fe0f.png",sheet_x:24,sheet_y:27,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false}},sheet:[24,22]},"flag-tj":{name:"Tajikistan Flag",unified:"1F1F9-1F1EF",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[4,48]},"flag-tk":{name:"Tokelau Flag",unified:"1F1F9-1F1F0",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[4,49]},"woman-getting-haircut":{name:"Woman Getting Haircut",unified:"1F487-200D-2640-FE0F",non_qualified:"1F487-200D-2640",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F487-1F3FB-200D-2640-FE0F",image:"1f487-1f3fb-200d-2640-fe0f.png",sheet_x:24,sheet_y:17,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FC":{unified:"1F487-1F3FC-200D-2640-FE0F",image:"1f487-1f3fc-200d-2640-fe0f.png",sheet_x:24,sheet_y:18,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FD":{unified:"1F487-1F3FD-200D-2640-FE0F",image:"1f487-1f3fd-200d-2640-fe0f.png",sheet_x:24,sheet_y:19,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FE":{unified:"1F487-1F3FE-200D-2640-FE0F",image:"1f487-1f3fe-200d-2640-fe0f.png",sheet_x:24,sheet_y:20,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FF":{unified:"1F487-1F3FF-200D-2640-FE0F",image:"1f487-1f3ff-200d-2640-fe0f.png",sheet_x:24,sheet_y:21,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false}},obsoletes:"1F487",sheet:[24,16]},walking:{name:"Pedestrian",unified:"1F6B6",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:true,skin_variations:{"1F3FB":{unified:"1F6B6-1F3FB",non_qualified:null,image:"1f6b6-1f3fb.png",sheet_x:36,sheet_y:22,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:true},"1F3FC":{unified:"1F6B6-1F3FC",non_qualified:null,image:"1f6b6-1f3fc.png",sheet_x:36,sheet_y:23,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:true},"1F3FD":{unified:"1F6B6-1F3FD",non_qualified:null,image:"1f6b6-1f3fd.png",sheet_x:36,sheet_y:24,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:true},"1F3FE":{unified:"1F6B6-1F3FE",non_qualified:null,image:"1f6b6-1f3fe.png",sheet_x:36,sheet_y:25,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:true},"1F3FF":{unified:"1F6B6-1F3FF",non_qualified:null,image:"1f6b6-1f3ff.png",sheet_x:36,sheet_y:26,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:true}},obsoleted_by:"1F6B6-200D-2642-FE0F",sheet:[36,21]},"flag-tl":{name:"Timor-Leste Flag",unified:"1F1F9-1F1F1",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[4,50]},"man-walking":{name:"Man Walking",unified:"1F6B6-200D-2642-FE0F",non_qualified:"1F6B6-200D-2642",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F6B6-1F3FB-200D-2642-FE0F",image:"1f6b6-1f3fb-200d-2642-fe0f.png",sheet_x:36,sheet_y:16,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FC":{unified:"1F6B6-1F3FC-200D-2642-FE0F",image:"1f6b6-1f3fc-200d-2642-fe0f.png",sheet_x:36,sheet_y:17,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FD":{unified:"1F6B6-1F3FD-200D-2642-FE0F",image:"1f6b6-1f3fd-200d-2642-fe0f.png",sheet_x:36,sheet_y:18,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FE":{unified:"1F6B6-1F3FE-200D-2642-FE0F",image:"1f6b6-1f3fe-200d-2642-fe0f.png",sheet_x:36,sheet_y:19,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FF":{unified:"1F6B6-1F3FF-200D-2642-FE0F",image:"1f6b6-1f3ff-200d-2642-fe0f.png",sheet_x:36,sheet_y:20,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false}},obsoletes:"1F6B6",sheet:[36,15]},"flag-tm":{name:"Turkmenistan Flag",unified:"1F1F9-1F1F2",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[4,51]},"woman-walking":{name:"Woman Walking",unified:"1F6B6-200D-2640-FE0F",non_qualified:"1F6B6-200D-2640",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F6B6-1F3FB-200D-2640-FE0F",image:"1f6b6-1f3fb-200d-2640-fe0f.png",sheet_x:36,sheet_y:10,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FC":{unified:"1F6B6-1F3FC-200D-2640-FE0F",image:"1f6b6-1f3fc-200d-2640-fe0f.png",sheet_x:36,sheet_y:11,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FD":{unified:"1F6B6-1F3FD-200D-2640-FE0F",image:"1f6b6-1f3fd-200d-2640-fe0f.png",sheet_x:36,sheet_y:12,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FE":{unified:"1F6B6-1F3FE-200D-2640-FE0F",image:"1f6b6-1f3fe-200d-2640-fe0f.png",sheet_x:36,sheet_y:13,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FF":{unified:"1F6B6-1F3FF-200D-2640-FE0F",image:"1f6b6-1f3ff-200d-2640-fe0f.png",sheet_x:36,sheet_y:14,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false}},sheet:[36,9]},"flag-tn":{name:"Tunisia Flag",unified:"1F1F9-1F1F3",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[5,0]},runner:{name:"Runner",unified:"1F3C3",non_qualified:null,short_names:["running"],has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:true,skin_variations:{"1F3FB":{unified:"1F3C3-1F3FB",non_qualified:null,image:"1f3c3-1f3fb.png",sheet_x:9,sheet_y:47,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:true},"1F3FC":{unified:"1F3C3-1F3FC",non_qualified:null,image:"1f3c3-1f3fc.png",sheet_x:9,sheet_y:48,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:true},"1F3FD":{unified:"1F3C3-1F3FD",non_qualified:null,image:"1f3c3-1f3fd.png",sheet_x:9,sheet_y:49,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:true},"1F3FE":{unified:"1F3C3-1F3FE",non_qualified:null,image:"1f3c3-1f3fe.png",sheet_x:9,sheet_y:50,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:true},"1F3FF":{unified:"1F3C3-1F3FF",non_qualified:null,image:"1f3c3-1f3ff.png",sheet_x:9,sheet_y:51,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:true}},obsoleted_by:"1F3C3-200D-2642-FE0F",sheet:[9,46]},"flag-to":{name:"Tonga Flag",unified:"1F1F9-1F1F4",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[5,1]},"man-running":{name:"Man Running",unified:"1F3C3-200D-2642-FE0F",non_qualified:"1F3C3-200D-2642",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F3C3-1F3FB-200D-2642-FE0F",image:"1f3c3-1f3fb-200d-2642-fe0f.png",sheet_x:9,sheet_y:41,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FC":{unified:"1F3C3-1F3FC-200D-2642-FE0F",image:"1f3c3-1f3fc-200d-2642-fe0f.png",sheet_x:9,sheet_y:42,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FD":{unified:"1F3C3-1F3FD-200D-2642-FE0F",image:"1f3c3-1f3fd-200d-2642-fe0f.png",sheet_x:9,sheet_y:43,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FE":{unified:"1F3C3-1F3FE-200D-2642-FE0F",image:"1f3c3-1f3fe-200d-2642-fe0f.png",sheet_x:9,sheet_y:44,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FF":{unified:"1F3C3-1F3FF-200D-2642-FE0F",image:"1f3c3-1f3ff-200d-2642-fe0f.png",sheet_x:9,sheet_y:45,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false}},obsoletes:"1F3C3",sheet:[9,40]},"flag-tr":{name:"Turkey Flag",unified:"1F1F9-1F1F7",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[5,2]},"flag-tt":{name:"Trinidad & Tobago Flag",unified:"1F1F9-1F1F9",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[5,3]},"woman-running":{name:"Woman Running",unified:"1F3C3-200D-2640-FE0F",non_qualified:"1F3C3-200D-2640",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F3C3-1F3FB-200D-2640-FE0F",image:"1f3c3-1f3fb-200d-2640-fe0f.png",sheet_x:9,sheet_y:35,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FC":{unified:"1F3C3-1F3FC-200D-2640-FE0F",image:"1f3c3-1f3fc-200d-2640-fe0f.png",sheet_x:9,sheet_y:36,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FD":{unified:"1F3C3-1F3FD-200D-2640-FE0F",image:"1f3c3-1f3fd-200d-2640-fe0f.png",sheet_x:9,sheet_y:37,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FE":{unified:"1F3C3-1F3FE-200D-2640-FE0F",image:"1f3c3-1f3fe-200d-2640-fe0f.png",sheet_x:9,sheet_y:38,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FF":{unified:"1F3C3-1F3FF-200D-2640-FE0F",image:"1f3c3-1f3ff-200d-2640-fe0f.png",sheet_x:9,sheet_y:39,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false}},sheet:[9,34]},"flag-tv":{name:"Tuvalu Flag",unified:"1F1F9-1F1FB",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[5,4]},dancer:{name:"Dancer",unified:"1F483",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,skin_variations:{"1F3FB":{unified:"1F483-1F3FB",non_qualified:null,image:"1f483-1f3fb.png",sheet_x:23,sheet_y:38,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FC":{unified:"1F483-1F3FC",non_qualified:null,image:"1f483-1f3fc.png",sheet_x:23,sheet_y:39,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FD":{unified:"1F483-1F3FD",non_qualified:null,image:"1f483-1f3fd.png",sheet_x:23,sheet_y:40,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FE":{unified:"1F483-1F3FE",non_qualified:null,image:"1f483-1f3fe.png",sheet_x:23,sheet_y:41,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FF":{unified:"1F483-1F3FF",non_qualified:null,image:"1f483-1f3ff.png",sheet_x:23,sheet_y:42,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true}},keywords:["female","girl","woman","fun"],sheet:[23,37]},"flag-tw":{name:"Taiwan Flag",unified:"1F1F9-1F1FC",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[5,5]},man_dancing:{name:"Man Dancing",unified:"1F57A",non_qualified:null,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F57A-1F3FB",non_qualified:null,image:"1f57a-1f3fb.png",sheet_x:29,sheet_y:22,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false},"1F3FC":{unified:"1F57A-1F3FC",non_qualified:null,image:"1f57a-1f3fc.png",sheet_x:29,sheet_y:23,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false},"1F3FD":{unified:"1F57A-1F3FD",non_qualified:null,image:"1f57a-1f3fd.png",sheet_x:29,sheet_y:24,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false},"1F3FE":{unified:"1F57A-1F3FE",non_qualified:null,image:"1f57a-1f3fe.png",sheet_x:29,sheet_y:25,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false},"1F3FF":{unified:"1F57A-1F3FF",non_qualified:null,image:"1f57a-1f3ff.png",sheet_x:29,sheet_y:26,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false}},keywords:["male","boy","fun","dancer"],sheet:[29,21]},dancers:{name:"Woman with Bunny Ears",unified:"1F46F",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:true,obsoleted_by:"1F46F-200D-2640-FE0F",sheet:[21,1]},"flag-tz":{name:"Tanzania Flag",unified:"1F1F9-1F1FF",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[5,6]},"flag-ua":{name:"Ukraine Flag",unified:"1F1FA-1F1E6",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[5,7]},"man-with-bunny-ears-partying":{name:"Man with Bunny Ears Partying",unified:"1F46F-200D-2642-FE0F",non_qualified:"1F46F-200D-2642",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,sheet:[21,0]},"woman-with-bunny-ears-partying":{name:"Woman with Bunny Ears Partying",unified:"1F46F-200D-2640-FE0F",non_qualified:"1F46F-200D-2640",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,obsoletes:"1F46F",sheet:[20,51]},"flag-ug":{name:"Uganda Flag",unified:"1F1FA-1F1EC",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[5,8]},"flag-um":{name:"U.s. Outlying Islands Flag",unified:"1F1FA-1F1F2",non_qualified:null,has_img_apple:true,has_img_google:false,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[5,9]},person_in_steamy_room:{name:"Person in Steamy Room",unified:"1F9D6",non_qualified:null,added_in:"10.0",has_img_apple:true,has_img_google:false,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F9D6-1F3FB",non_qualified:null,image:"1f9d6-1f3fb.png",sheet_x:43,sheet_y:41,added_in:"10.0",has_img_apple:true,has_img_google:false,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,obsoleted_by:"1F9D6-1F3FB-200D-2642-FE0F"},"1F3FC":{unified:"1F9D6-1F3FC",non_qualified:null,image:"1f9d6-1f3fc.png",sheet_x:43,sheet_y:42,added_in:"10.0",has_img_apple:true,has_img_google:false,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,obsoleted_by:"1F9D6-1F3FC-200D-2642-FE0F"},"1F3FD":{unified:"1F9D6-1F3FD",non_qualified:null,image:"1f9d6-1f3fd.png",sheet_x:43,sheet_y:43,added_in:"10.0",has_img_apple:true,has_img_google:false,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,obsoleted_by:"1F9D6-1F3FD-200D-2642-FE0F"},"1F3FE":{unified:"1F9D6-1F3FE",non_qualified:null,image:"1f9d6-1f3fe.png",sheet_x:43,sheet_y:44,added_in:"10.0",has_img_apple:true,has_img_google:false,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,obsoleted_by:"1F9D6-1F3FE-200D-2642-FE0F"},"1F3FF":{unified:"1F9D6-1F3FF",non_qualified:null,image:"1f9d6-1f3ff.png",sheet_x:43,sheet_y:45,added_in:"10.0",has_img_apple:true,has_img_google:false,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,obsoleted_by:"1F9D6-1F3FF-200D-2642-FE0F"}},obsoleted_by:"1F9D6-200D-2642-FE0F",sheet:[43,40]},woman_in_steamy_room:{name:"Woman in Steamy Room",unified:"1F9D6-200D-2640-FE0F",non_qualified:"1F9D6-200D-2640",added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F9D6-1F3FB-200D-2640-FE0F",image:"1f9d6-1f3fb-200d-2640-fe0f.png",sheet_x:43,sheet_y:29,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FC":{unified:"1F9D6-1F3FC-200D-2640-FE0F",image:"1f9d6-1f3fc-200d-2640-fe0f.png",sheet_x:43,sheet_y:30,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FD":{unified:"1F9D6-1F3FD-200D-2640-FE0F",image:"1f9d6-1f3fd-200d-2640-fe0f.png",sheet_x:43,sheet_y:31,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FE":{unified:"1F9D6-1F3FE-200D-2640-FE0F",image:"1f9d6-1f3fe-200d-2640-fe0f.png",sheet_x:43,sheet_y:32,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FF":{unified:"1F9D6-1F3FF-200D-2640-FE0F",image:"1f9d6-1f3ff-200d-2640-fe0f.png",sheet_x:43,sheet_y:33,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false}},keywords:["female","woman","spa","steamroom","sauna"],sheet:[43,28]},"flag-un":{name:"United Nations Flag",unified:"1F1FA-1F1F3",non_qualified:null,has_img_apple:false,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,sheet:[5,10]},us:{name:"United States Flag",unified:"1F1FA-1F1F8",non_qualified:null,short_names:["flag-us"],has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["united","states","america","flag","nation","country","banner"],sheet:[5,11]},man_in_steamy_room:{name:"Man in Steamy Room",unified:"1F9D6-200D-2642-FE0F",non_qualified:"1F9D6-200D-2642",added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F9D6-1F3FB-200D-2642-FE0F",image:"1f9d6-1f3fb-200d-2642-fe0f.png",sheet_x:43,sheet_y:35,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false,obsoletes:"1F9D6-1F3FB"},"1F3FC":{unified:"1F9D6-1F3FC-200D-2642-FE0F",image:"1f9d6-1f3fc-200d-2642-fe0f.png",sheet_x:43,sheet_y:36,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false,obsoletes:"1F9D6-1F3FC"},"1F3FD":{unified:"1F9D6-1F3FD-200D-2642-FE0F",image:"1f9d6-1f3fd-200d-2642-fe0f.png",sheet_x:43,sheet_y:37,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false,obsoletes:"1F9D6-1F3FD"},"1F3FE":{unified:"1F9D6-1F3FE-200D-2642-FE0F",image:"1f9d6-1f3fe-200d-2642-fe0f.png",sheet_x:43,sheet_y:38,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false,obsoletes:"1F9D6-1F3FE"},"1F3FF":{unified:"1F9D6-1F3FF-200D-2642-FE0F",image:"1f9d6-1f3ff-200d-2642-fe0f.png",sheet_x:43,sheet_y:39,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false,obsoletes:"1F9D6-1F3FF"}},obsoletes:"1F9D6",keywords:["male","man","spa","steamroom","sauna"],sheet:[43,34]},person_climbing:{name:"Person Climbing",unified:"1F9D7",non_qualified:null,added_in:"10.0",has_img_apple:true,has_img_google:false,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F9D7-1F3FB",non_qualified:null,image:"1f9d7-1f3fb.png",sheet_x:44,sheet_y:7,added_in:"10.0",has_img_apple:true,has_img_google:false,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,obsoleted_by:"1F9D7-1F3FB-200D-2640-FE0F"},"1F3FC":{unified:"1F9D7-1F3FC",non_qualified:null,image:"1f9d7-1f3fc.png",sheet_x:44,sheet_y:8,added_in:"10.0",has_img_apple:true,has_img_google:false,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,obsoleted_by:"1F9D7-1F3FC-200D-2640-FE0F"},"1F3FD":{unified:"1F9D7-1F3FD",non_qualified:null,image:"1f9d7-1f3fd.png",sheet_x:44,sheet_y:9,added_in:"10.0",has_img_apple:true,has_img_google:false,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,obsoleted_by:"1F9D7-1F3FD-200D-2640-FE0F"},"1F3FE":{unified:"1F9D7-1F3FE",non_qualified:null,image:"1f9d7-1f3fe.png",sheet_x:44,sheet_y:10,added_in:"10.0",has_img_apple:true,has_img_google:false,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,obsoleted_by:"1F9D7-1F3FE-200D-2640-FE0F"},"1F3FF":{unified:"1F9D7-1F3FF",non_qualified:null,image:"1f9d7-1f3ff.png",sheet_x:44,sheet_y:11,added_in:"10.0",has_img_apple:true,has_img_google:false,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,obsoleted_by:"1F9D7-1F3FF-200D-2640-FE0F"}},obsoleted_by:"1F9D7-200D-2640-FE0F",sheet:[44,6]},"flag-uy":{name:"Uruguay Flag",unified:"1F1FA-1F1FE",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[5,12]},woman_climbing:{name:"Woman Climbing",unified:"1F9D7-200D-2640-FE0F",non_qualified:"1F9D7-200D-2640",added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F9D7-1F3FB-200D-2640-FE0F",image:"1f9d7-1f3fb-200d-2640-fe0f.png",sheet_x:43,sheet_y:47,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false,obsoletes:"1F9D7-1F3FB"},"1F3FC":{unified:"1F9D7-1F3FC-200D-2640-FE0F",image:"1f9d7-1f3fc-200d-2640-fe0f.png",sheet_x:43,sheet_y:48,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false,obsoletes:"1F9D7-1F3FC"},"1F3FD":{unified:"1F9D7-1F3FD-200D-2640-FE0F",image:"1f9d7-1f3fd-200d-2640-fe0f.png",sheet_x:43,sheet_y:49,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false,obsoletes:"1F9D7-1F3FD"},"1F3FE":{unified:"1F9D7-1F3FE-200D-2640-FE0F",image:"1f9d7-1f3fe-200d-2640-fe0f.png",sheet_x:43,sheet_y:50,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false,obsoletes:"1F9D7-1F3FE"},"1F3FF":{unified:"1F9D7-1F3FF-200D-2640-FE0F",image:"1f9d7-1f3ff-200d-2640-fe0f.png",sheet_x:43,sheet_y:51,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false,obsoletes:"1F9D7-1F3FF"}},obsoletes:"1F9D7",sheet:[43,46]},"flag-uz":{name:"Uzbekistan Flag",unified:"1F1FA-1F1FF",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[5,13]},man_climbing:{name:"Man Climbing",unified:"1F9D7-200D-2642-FE0F",non_qualified:"1F9D7-200D-2642",added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F9D7-1F3FB-200D-2642-FE0F",image:"1f9d7-1f3fb-200d-2642-fe0f.png",sheet_x:44,sheet_y:1,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FC":{unified:"1F9D7-1F3FC-200D-2642-FE0F",image:"1f9d7-1f3fc-200d-2642-fe0f.png",sheet_x:44,sheet_y:2,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FD":{unified:"1F9D7-1F3FD-200D-2642-FE0F",image:"1f9d7-1f3fd-200d-2642-fe0f.png",sheet_x:44,sheet_y:3,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FE":{unified:"1F9D7-1F3FE-200D-2642-FE0F",image:"1f9d7-1f3fe-200d-2642-fe0f.png",sheet_x:44,sheet_y:4,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FF":{unified:"1F9D7-1F3FF-200D-2642-FE0F",image:"1f9d7-1f3ff-200d-2642-fe0f.png",sheet_x:44,sheet_y:5,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false}},sheet:[44,0]},"flag-va":{name:"Vatican City Flag",unified:"1F1FB-1F1E6",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[5,14]},person_in_lotus_position:{name:"Person in Lotus Position",unified:"1F9D8",non_qualified:null,added_in:"10.0",has_img_apple:true,has_img_google:false,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F9D8-1F3FB",non_qualified:null,image:"1f9d8-1f3fb.png",sheet_x:44,sheet_y:25,added_in:"10.0",has_img_apple:true,has_img_google:false,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,obsoleted_by:"1F9D8-1F3FB-200D-2640-FE0F"},"1F3FC":{unified:"1F9D8-1F3FC",non_qualified:null,image:"1f9d8-1f3fc.png",sheet_x:44,sheet_y:26,added_in:"10.0",has_img_apple:true,has_img_google:false,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,obsoleted_by:"1F9D8-1F3FC-200D-2640-FE0F"},"1F3FD":{unified:"1F9D8-1F3FD",non_qualified:null,image:"1f9d8-1f3fd.png",sheet_x:44,sheet_y:27,added_in:"10.0",has_img_apple:true,has_img_google:false,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,obsoleted_by:"1F9D8-1F3FD-200D-2640-FE0F"},"1F3FE":{unified:"1F9D8-1F3FE",non_qualified:null,image:"1f9d8-1f3fe.png",sheet_x:44,sheet_y:28,added_in:"10.0",has_img_apple:true,has_img_google:false,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,obsoleted_by:"1F9D8-1F3FE-200D-2640-FE0F"},"1F3FF":{unified:"1F9D8-1F3FF",non_qualified:null,image:"1f9d8-1f3ff.png",sheet_x:44,sheet_y:29,added_in:"10.0",has_img_apple:true,has_img_google:false,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,obsoleted_by:"1F9D8-1F3FF-200D-2640-FE0F"}},obsoleted_by:"1F9D8-200D-2640-FE0F",sheet:[44,24]},"flag-vc":{name:"St. Vincent & Grenadines Flag",unified:"1F1FB-1F1E8",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[5,15]},"flag-ve":{name:"Venezuela Flag",unified:"1F1FB-1F1EA",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[5,16]},woman_in_lotus_position:{name:"Woman in Lotus Position",unified:"1F9D8-200D-2640-FE0F",non_qualified:"1F9D8-200D-2640",added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F9D8-1F3FB-200D-2640-FE0F",image:"1f9d8-1f3fb-200d-2640-fe0f.png",sheet_x:44,sheet_y:13,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false,obsoletes:"1F9D8-1F3FB"},"1F3FC":{unified:"1F9D8-1F3FC-200D-2640-FE0F",image:"1f9d8-1f3fc-200d-2640-fe0f.png",sheet_x:44,sheet_y:14,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false,obsoletes:"1F9D8-1F3FC"},"1F3FD":{unified:"1F9D8-1F3FD-200D-2640-FE0F",image:"1f9d8-1f3fd-200d-2640-fe0f.png",sheet_x:44,sheet_y:15,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false,obsoletes:"1F9D8-1F3FD"},"1F3FE":{unified:"1F9D8-1F3FE-200D-2640-FE0F",image:"1f9d8-1f3fe-200d-2640-fe0f.png",sheet_x:44,sheet_y:16,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false,obsoletes:"1F9D8-1F3FE"},"1F3FF":{unified:"1F9D8-1F3FF-200D-2640-FE0F",image:"1f9d8-1f3ff-200d-2640-fe0f.png",sheet_x:44,sheet_y:17,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false,obsoletes:"1F9D8-1F3FF"}},obsoletes:"1F9D8",keywords:["woman","female","meditation","yoga","serenity","zen","mindfulness"],sheet:[44,12]},man_in_lotus_position:{name:"Man in Lotus Position",unified:"1F9D8-200D-2642-FE0F",non_qualified:"1F9D8-200D-2642",added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F9D8-1F3FB-200D-2642-FE0F",image:"1f9d8-1f3fb-200d-2642-fe0f.png",sheet_x:44,sheet_y:19,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FC":{unified:"1F9D8-1F3FC-200D-2642-FE0F",image:"1f9d8-1f3fc-200d-2642-fe0f.png",sheet_x:44,sheet_y:20,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FD":{unified:"1F9D8-1F3FD-200D-2642-FE0F",image:"1f9d8-1f3fd-200d-2642-fe0f.png",sheet_x:44,sheet_y:21,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FE":{unified:"1F9D8-1F3FE-200D-2642-FE0F",image:"1f9d8-1f3fe-200d-2642-fe0f.png",sheet_x:44,sheet_y:22,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FF":{unified:"1F9D8-1F3FF-200D-2642-FE0F",image:"1f9d8-1f3ff-200d-2642-fe0f.png",sheet_x:44,sheet_y:23,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false}},keywords:["man","male","meditation","yoga","serenity","zen","mindfulness"],sheet:[44,18]},"flag-vg":{name:"British Virgin Islands Flag",unified:"1F1FB-1F1EC",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[5,17]},"flag-vi":{name:"U.s. Virgin Islands Flag",unified:"1F1FB-1F1EE",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[5,18]},bath:{name:"Bath",unified:"1F6C0",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,skin_variations:{"1F3FB":{unified:"1F6C0-1F3FB",non_qualified:null,image:"1f6c0-1f3fb.png",sheet_x:36,sheet_y:37,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FC":{unified:"1F6C0-1F3FC",non_qualified:null,image:"1f6c0-1f3fc.png",sheet_x:36,sheet_y:38,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FD":{unified:"1F6C0-1F3FD",non_qualified:null,image:"1f6c0-1f3fd.png",sheet_x:36,sheet_y:39,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FE":{unified:"1F6C0-1F3FE",non_qualified:null,image:"1f6c0-1f3fe.png",sheet_x:36,sheet_y:40,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FF":{unified:"1F6C0-1F3FF",non_qualified:null,image:"1f6c0-1f3ff.png",sheet_x:36,sheet_y:41,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true}},keywords:["clean","shower","bathroom"],sheet:[36,36]},sleeping_accommodation:{name:"Sleeping Accommodation",unified:"1F6CC",non_qualified:null,added_in:"7.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F6CC-1F3FB",non_qualified:null,image:"1f6cc-1f3fb.png",sheet_x:36,sheet_y:49,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FC":{unified:"1F6CC-1F3FC",non_qualified:null,image:"1f6cc-1f3fc.png",sheet_x:36,sheet_y:50,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FD":{unified:"1F6CC-1F3FD",non_qualified:null,image:"1f6cc-1f3fd.png",sheet_x:36,sheet_y:51,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FE":{unified:"1F6CC-1F3FE",non_qualified:null,image:"1f6cc-1f3fe.png",sheet_x:37,sheet_y:0,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FF":{unified:"1F6CC-1F3FF",non_qualified:null,image:"1f6cc-1f3ff.png",sheet_x:37,sheet_y:1,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false}},sheet:[36,48]},"flag-vn":{name:"Vietnam Flag",unified:"1F1FB-1F1F3",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[5,19]},man_in_business_suit_levitating:{name:"Man in Business Suit Levitating",unified:"1F574-FE0F",non_qualified:"1F574",added_in:"7.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F574-1F3FB",non_qualified:null,image:"1f574-1f3fb.png",sheet_x:28,sheet_y:46,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FC":{unified:"1F574-1F3FC",non_qualified:null,image:"1f574-1f3fc.png",sheet_x:28,sheet_y:47,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FD":{unified:"1F574-1F3FD",non_qualified:null,image:"1f574-1f3fd.png",sheet_x:28,sheet_y:48,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FE":{unified:"1F574-1F3FE",non_qualified:null,image:"1f574-1f3fe.png",sheet_x:28,sheet_y:49,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FF":{unified:"1F574-1F3FF",non_qualified:null,image:"1f574-1f3ff.png",sheet_x:28,sheet_y:50,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false}},sheet:[28,45]},"flag-vu":{name:"Vanuatu Flag",unified:"1F1FB-1F1FA",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[5,20]},"flag-wf":{name:"Wallis & Futuna Flag",unified:"1F1FC-1F1EB",non_qualified:null,has_img_apple:true,has_img_google:false,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[5,21]},speaking_head_in_silhouette:{name:"Speaking Head in Silhouette",unified:"1F5E3-FE0F",non_qualified:"1F5E3",added_in:"7.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,sheet:[30,14]},bust_in_silhouette:{name:"Bust in Silhouette",unified:"1F464",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["user","person","human"],sheet:[15,40]},"flag-ws":{name:"Samoa Flag",unified:"1F1FC-1F1F8",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[5,22]},busts_in_silhouette:{name:"Busts in Silhouette",unified:"1F465",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["user","person","human","group","team"],sheet:[15,41]},"flag-xk":{name:"Kosovo Flag",unified:"1F1FD-1F1F0",non_qualified:null,has_img_apple:true,has_img_google:false,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[5,23]},fencer:{name:"Fencer",unified:"1F93A",non_qualified:null,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false,sheet:[40,48]},"flag-ye":{name:"Yemen Flag",unified:"1F1FE-1F1EA",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[5,24]},"flag-yt":{name:"Mayotte Flag",unified:"1F1FE-1F1F9",non_qualified:null,has_img_apple:true,has_img_google:false,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[5,25]},horse_racing:{name:"Horse Racing",unified:"1F3C7",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,skin_variations:{"1F3FB":{unified:"1F3C7-1F3FB",non_qualified:null,image:"1f3c7-1f3fb.png",sheet_x:10,sheet_y:21,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FC":{unified:"1F3C7-1F3FC",non_qualified:null,image:"1f3c7-1f3fc.png",sheet_x:10,sheet_y:22,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FD":{unified:"1F3C7-1F3FD",non_qualified:null,image:"1f3c7-1f3fd.png",sheet_x:10,sheet_y:23,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FE":{unified:"1F3C7-1F3FE",non_qualified:null,image:"1f3c7-1f3fe.png",sheet_x:10,sheet_y:24,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FF":{unified:"1F3C7-1F3FF",non_qualified:null,image:"1f3c7-1f3ff.png",sheet_x:10,sheet_y:25,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true}},keywords:["animal","betting","competition","gambling","luck"],sheet:[10,20]},"flag-za":{name:"South Africa Flag",unified:"1F1FF-1F1E6",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[5,26]},skier:{name:"Skier",unified:"26F7-FE0F",non_qualified:"26F7",added_in:"5.2",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,keywords:["sports","winter","snow"],sheet:[48,44]},"flag-zm":{name:"Zambia Flag",unified:"1F1FF-1F1F2",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[5,27]},snowboarder:{name:"Snowboarder",unified:"1F3C2",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,skin_variations:{"1F3FB":{unified:"1F3C2-1F3FB",non_qualified:null,image:"1f3c2-1f3fb.png",sheet_x:9,sheet_y:29,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:true},"1F3FC":{unified:"1F3C2-1F3FC",non_qualified:null,image:"1f3c2-1f3fc.png",sheet_x:9,sheet_y:30,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:true},"1F3FD":{unified:"1F3C2-1F3FD",non_qualified:null,image:"1f3c2-1f3fd.png",sheet_x:9,sheet_y:31,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:true},"1F3FE":{unified:"1F3C2-1F3FE",non_qualified:null,image:"1f3c2-1f3fe.png",sheet_x:9,sheet_y:32,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:true},"1F3FF":{unified:"1F3C2-1F3FF",non_qualified:null,image:"1f3c2-1f3ff.png",sheet_x:9,sheet_y:33,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:true}},keywords:["sports","winter"],sheet:[9,28]},golfer:{name:"Golfer",unified:"1F3CC-FE0F",non_qualified:"1F3CC",added_in:"7.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F3CC-1F3FB",non_qualified:null,image:"1f3cc-1f3fb.png",sheet_x:11,sheet_y:25,added_in:"8.0",has_img_apple:true,has_img_google:false,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FC":{unified:"1F3CC-1F3FC",non_qualified:null,image:"1f3cc-1f3fc.png",sheet_x:11,sheet_y:26,added_in:"8.0",has_img_apple:true,has_img_google:false,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FD":{unified:"1F3CC-1F3FD",non_qualified:null,image:"1f3cc-1f3fd.png",sheet_x:11,sheet_y:27,added_in:"8.0",has_img_apple:true,has_img_google:false,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FE":{unified:"1F3CC-1F3FE",non_qualified:null,image:"1f3cc-1f3fe.png",sheet_x:11,sheet_y:28,added_in:"8.0",has_img_apple:true,has_img_google:false,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FF":{unified:"1F3CC-1F3FF",non_qualified:null,image:"1f3cc-1f3ff.png",sheet_x:11,sheet_y:29,added_in:"8.0",has_img_apple:true,has_img_google:false,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false}},obsoleted_by:"1F3CC-FE0F-200D-2642-FE0F",sheet:[11,24]},"flag-zw":{name:"Zimbabwe Flag",unified:"1F1FF-1F1FC",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[5,28]},"man-golfing":{name:"Man Golfing",unified:"1F3CC-FE0F-200D-2642-FE0F",non_qualified:null,added_in:"7.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F3CC-1F3FB-200D-2642-FE0F",image:"1f3cc-1f3fb-200d-2642-fe0f.png",sheet_x:11,sheet_y:19,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FC":{unified:"1F3CC-1F3FC-200D-2642-FE0F",image:"1f3cc-1f3fc-200d-2642-fe0f.png",sheet_x:11,sheet_y:20,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FD":{unified:"1F3CC-1F3FD-200D-2642-FE0F",image:"1f3cc-1f3fd-200d-2642-fe0f.png",sheet_x:11,sheet_y:21,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FE":{unified:"1F3CC-1F3FE-200D-2642-FE0F",image:"1f3cc-1f3fe-200d-2642-fe0f.png",sheet_x:11,sheet_y:22,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FF":{unified:"1F3CC-1F3FF-200D-2642-FE0F",image:"1f3cc-1f3ff-200d-2642-fe0f.png",sheet_x:11,sheet_y:23,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false}},obsoletes:"1F3CC-FE0F",sheet:[11,18]},"flag-england":{name:"England Flag",unified:"1F3F4-E0067-E0062-E0065-E006E-E0067-E007F",non_qualified:null,added_in:"7.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,sheet:[12,16]},"woman-golfing":{name:"Woman Golfing",unified:"1F3CC-FE0F-200D-2640-FE0F",non_qualified:null,added_in:"7.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F3CC-1F3FB-200D-2640-FE0F",image:"1f3cc-1f3fb-200d-2640-fe0f.png",sheet_x:11,sheet_y:13,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FC":{unified:"1F3CC-1F3FC-200D-2640-FE0F",image:"1f3cc-1f3fc-200d-2640-fe0f.png",sheet_x:11,sheet_y:14,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FD":{unified:"1F3CC-1F3FD-200D-2640-FE0F",image:"1f3cc-1f3fd-200d-2640-fe0f.png",sheet_x:11,sheet_y:15,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FE":{unified:"1F3CC-1F3FE-200D-2640-FE0F",image:"1f3cc-1f3fe-200d-2640-fe0f.png",sheet_x:11,sheet_y:16,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FF":{unified:"1F3CC-1F3FF-200D-2640-FE0F",image:"1f3cc-1f3ff-200d-2640-fe0f.png",sheet_x:11,sheet_y:17,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false}},sheet:[11,12]},"flag-scotland":{name:"Scotland Flag",unified:"1F3F4-E0067-E0062-E0073-E0063-E0074-E007F",non_qualified:null,added_in:"7.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,sheet:[12,17]},"flag-wales":{name:"Wales Flag",unified:"1F3F4-E0067-E0062-E0077-E006C-E0073-E007F",non_qualified:null,added_in:"7.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,sheet:[12,18]},surfer:{name:"Surfer",unified:"1F3C4",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:true,skin_variations:{"1F3FB":{unified:"1F3C4-1F3FB",non_qualified:null,image:"1f3c4-1f3fb.png",sheet_x:10,sheet_y:13,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:true},"1F3FC":{unified:"1F3C4-1F3FC",non_qualified:null,image:"1f3c4-1f3fc.png",sheet_x:10,sheet_y:14,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:true},"1F3FD":{unified:"1F3C4-1F3FD",non_qualified:null,image:"1f3c4-1f3fd.png",sheet_x:10,sheet_y:15,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:true},"1F3FE":{unified:"1F3C4-1F3FE",non_qualified:null,image:"1f3c4-1f3fe.png",sheet_x:10,sheet_y:16,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:true},"1F3FF":{unified:"1F3C4-1F3FF",non_qualified:null,image:"1f3c4-1f3ff.png",sheet_x:10,sheet_y:17,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:true}},obsoleted_by:"1F3C4-200D-2642-FE0F",sheet:[10,12]},"man-surfing":{name:"Man Surfing",unified:"1F3C4-200D-2642-FE0F",non_qualified:"1F3C4-200D-2642",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F3C4-1F3FB-200D-2642-FE0F",image:"1f3c4-1f3fb-200d-2642-fe0f.png",sheet_x:10,sheet_y:7,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FC":{unified:"1F3C4-1F3FC-200D-2642-FE0F",image:"1f3c4-1f3fc-200d-2642-fe0f.png",sheet_x:10,sheet_y:8,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FD":{unified:"1F3C4-1F3FD-200D-2642-FE0F",image:"1f3c4-1f3fd-200d-2642-fe0f.png",sheet_x:10,sheet_y:9,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FE":{unified:"1F3C4-1F3FE-200D-2642-FE0F",image:"1f3c4-1f3fe-200d-2642-fe0f.png",sheet_x:10,sheet_y:10,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FF":{unified:"1F3C4-1F3FF-200D-2642-FE0F",image:"1f3c4-1f3ff-200d-2642-fe0f.png",sheet_x:10,sheet_y:11,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false}},obsoletes:"1F3C4",sheet:[10,6]},"woman-surfing":{name:"Woman Surfing",unified:"1F3C4-200D-2640-FE0F",non_qualified:"1F3C4-200D-2640",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F3C4-1F3FB-200D-2640-FE0F",image:"1f3c4-1f3fb-200d-2640-fe0f.png",sheet_x:10,sheet_y:1,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FC":{unified:"1F3C4-1F3FC-200D-2640-FE0F",image:"1f3c4-1f3fc-200d-2640-fe0f.png",sheet_x:10,sheet_y:2,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FD":{unified:"1F3C4-1F3FD-200D-2640-FE0F",image:"1f3c4-1f3fd-200d-2640-fe0f.png",sheet_x:10,sheet_y:3,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FE":{unified:"1F3C4-1F3FE-200D-2640-FE0F",image:"1f3c4-1f3fe-200d-2640-fe0f.png",sheet_x:10,sheet_y:4,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FF":{unified:"1F3C4-1F3FF-200D-2640-FE0F",image:"1f3c4-1f3ff-200d-2640-fe0f.png",sheet_x:10,sheet_y:5,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false}},sheet:[10,0]},rowboat:{name:"Rowboat",unified:"1F6A3",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:true,skin_variations:{"1F3FB":{unified:"1F6A3-1F3FB",non_qualified:null,image:"1f6a3-1f3fb.png",sheet_x:35,sheet_y:4,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:false},"1F3FC":{unified:"1F6A3-1F3FC",non_qualified:null,image:"1f6a3-1f3fc.png",sheet_x:35,sheet_y:5,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:false},"1F3FD":{unified:"1F6A3-1F3FD",non_qualified:null,image:"1f6a3-1f3fd.png",sheet_x:35,sheet_y:6,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:false},"1F3FE":{unified:"1F6A3-1F3FE",non_qualified:null,image:"1f6a3-1f3fe.png",sheet_x:35,sheet_y:7,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:false},"1F3FF":{unified:"1F6A3-1F3FF",non_qualified:null,image:"1f6a3-1f3ff.png",sheet_x:35,sheet_y:8,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:false}},obsoleted_by:"1F6A3-200D-2642-FE0F",sheet:[35,3]},"man-rowing-boat":{name:"Man Rowing Boat",unified:"1F6A3-200D-2642-FE0F",non_qualified:"1F6A3-200D-2642",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F6A3-1F3FB-200D-2642-FE0F",image:"1f6a3-1f3fb-200d-2642-fe0f.png",sheet_x:34,sheet_y:50,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FC":{unified:"1F6A3-1F3FC-200D-2642-FE0F",image:"1f6a3-1f3fc-200d-2642-fe0f.png",sheet_x:34,sheet_y:51,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FD":{unified:"1F6A3-1F3FD-200D-2642-FE0F",image:"1f6a3-1f3fd-200d-2642-fe0f.png",sheet_x:35,sheet_y:0,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FE":{unified:"1F6A3-1F3FE-200D-2642-FE0F",image:"1f6a3-1f3fe-200d-2642-fe0f.png",sheet_x:35,sheet_y:1,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FF":{unified:"1F6A3-1F3FF-200D-2642-FE0F",image:"1f6a3-1f3ff-200d-2642-fe0f.png",sheet_x:35,sheet_y:2,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false}},obsoletes:"1F6A3",sheet:[34,49]},"woman-rowing-boat":{name:"Woman Rowing Boat",unified:"1F6A3-200D-2640-FE0F",non_qualified:"1F6A3-200D-2640",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F6A3-1F3FB-200D-2640-FE0F",image:"1f6a3-1f3fb-200d-2640-fe0f.png",sheet_x:34,sheet_y:44,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FC":{unified:"1F6A3-1F3FC-200D-2640-FE0F",image:"1f6a3-1f3fc-200d-2640-fe0f.png",sheet_x:34,sheet_y:45,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FD":{unified:"1F6A3-1F3FD-200D-2640-FE0F",image:"1f6a3-1f3fd-200d-2640-fe0f.png",sheet_x:34,sheet_y:46,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FE":{unified:"1F6A3-1F3FE-200D-2640-FE0F",image:"1f6a3-1f3fe-200d-2640-fe0f.png",sheet_x:34,sheet_y:47,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FF":{unified:"1F6A3-1F3FF-200D-2640-FE0F",image:"1f6a3-1f3ff-200d-2640-fe0f.png",sheet_x:34,sheet_y:48,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false}},sheet:[34,43]},swimmer:{name:"Swimmer",unified:"1F3CA",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:true,skin_variations:{"1F3FB":{unified:"1F3CA-1F3FB",non_qualified:null,image:"1f3ca-1f3fb.png",sheet_x:10,sheet_y:41,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:true},"1F3FC":{unified:"1F3CA-1F3FC",non_qualified:null,image:"1f3ca-1f3fc.png",sheet_x:10,sheet_y:42,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:true},"1F3FD":{unified:"1F3CA-1F3FD",non_qualified:null,image:"1f3ca-1f3fd.png",sheet_x:10,sheet_y:43,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:true},"1F3FE":{unified:"1F3CA-1F3FE",non_qualified:null,image:"1f3ca-1f3fe.png",sheet_x:10,sheet_y:44,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:true},"1F3FF":{unified:"1F3CA-1F3FF",non_qualified:null,image:"1f3ca-1f3ff.png",sheet_x:10,sheet_y:45,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:true}},obsoleted_by:"1F3CA-200D-2642-FE0F",sheet:[10,40]},"man-swimming":{name:"Man Swimming",unified:"1F3CA-200D-2642-FE0F",non_qualified:"1F3CA-200D-2642",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F3CA-1F3FB-200D-2642-FE0F",image:"1f3ca-1f3fb-200d-2642-fe0f.png",sheet_x:10,sheet_y:35,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FC":{unified:"1F3CA-1F3FC-200D-2642-FE0F",image:"1f3ca-1f3fc-200d-2642-fe0f.png",sheet_x:10,sheet_y:36,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FD":{unified:"1F3CA-1F3FD-200D-2642-FE0F",image:"1f3ca-1f3fd-200d-2642-fe0f.png",sheet_x:10,sheet_y:37,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FE":{unified:"1F3CA-1F3FE-200D-2642-FE0F",image:"1f3ca-1f3fe-200d-2642-fe0f.png",sheet_x:10,sheet_y:38,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FF":{unified:"1F3CA-1F3FF-200D-2642-FE0F",image:"1f3ca-1f3ff-200d-2642-fe0f.png",sheet_x:10,sheet_y:39,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false}},obsoletes:"1F3CA",sheet:[10,34]},"woman-swimming":{name:"Woman Swimming",unified:"1F3CA-200D-2640-FE0F",non_qualified:"1F3CA-200D-2640",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F3CA-1F3FB-200D-2640-FE0F",image:"1f3ca-1f3fb-200d-2640-fe0f.png",sheet_x:10,sheet_y:29,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FC":{unified:"1F3CA-1F3FC-200D-2640-FE0F",image:"1f3ca-1f3fc-200d-2640-fe0f.png",sheet_x:10,sheet_y:30,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FD":{unified:"1F3CA-1F3FD-200D-2640-FE0F",image:"1f3ca-1f3fd-200d-2640-fe0f.png",sheet_x:10,sheet_y:31,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FE":{unified:"1F3CA-1F3FE-200D-2640-FE0F",image:"1f3ca-1f3fe-200d-2640-fe0f.png",sheet_x:10,sheet_y:32,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FF":{unified:"1F3CA-1F3FF-200D-2640-FE0F",image:"1f3ca-1f3ff-200d-2640-fe0f.png",sheet_x:10,sheet_y:33,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false}},sheet:[10,28]},person_with_ball:{name:"Person with Ball",unified:"26F9-FE0F",non_qualified:"26F9",added_in:"5.2",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"26F9-1F3FB",non_qualified:null,image:"26f9-1f3fb.png",sheet_x:49,sheet_y:7,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:false},"1F3FC":{unified:"26F9-1F3FC",non_qualified:null,image:"26f9-1f3fc.png",sheet_x:49,sheet_y:8,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:false},"1F3FD":{unified:"26F9-1F3FD",non_qualified:null,image:"26f9-1f3fd.png",sheet_x:49,sheet_y:9,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:false},"1F3FE":{unified:"26F9-1F3FE",non_qualified:null,image:"26f9-1f3fe.png",sheet_x:49,sheet_y:10,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:false},"1F3FF":{unified:"26F9-1F3FF",non_qualified:null,image:"26f9-1f3ff.png",sheet_x:49,sheet_y:11,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:false}},obsoleted_by:"26F9-FE0F-200D-2642-FE0F",sheet:[49,6]},"man-bouncing-ball":{name:"Man Bouncing Ball",unified:"26F9-FE0F-200D-2642-FE0F",non_qualified:null,added_in:"5.2",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"26F9-1F3FB-200D-2642-FE0F",image:"26f9-1f3fb-200d-2642-fe0f.png",sheet_x:49,sheet_y:1,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FC":{unified:"26F9-1F3FC-200D-2642-FE0F",image:"26f9-1f3fc-200d-2642-fe0f.png",sheet_x:49,sheet_y:2,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FD":{unified:"26F9-1F3FD-200D-2642-FE0F",image:"26f9-1f3fd-200d-2642-fe0f.png",sheet_x:49,sheet_y:3,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FE":{unified:"26F9-1F3FE-200D-2642-FE0F",image:"26f9-1f3fe-200d-2642-fe0f.png",sheet_x:49,sheet_y:4,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FF":{unified:"26F9-1F3FF-200D-2642-FE0F",image:"26f9-1f3ff-200d-2642-fe0f.png",sheet_x:49,sheet_y:5,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false}},obsoletes:"26F9-FE0F",sheet:[49,0]},"woman-bouncing-ball":{name:"Woman Bouncing Ball",unified:"26F9-FE0F-200D-2640-FE0F",non_qualified:null,added_in:"5.2",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"26F9-1F3FB-200D-2640-FE0F",image:"26f9-1f3fb-200d-2640-fe0f.png",sheet_x:48,sheet_y:47,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FC":{unified:"26F9-1F3FC-200D-2640-FE0F",image:"26f9-1f3fc-200d-2640-fe0f.png",sheet_x:48,sheet_y:48,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FD":{unified:"26F9-1F3FD-200D-2640-FE0F",image:"26f9-1f3fd-200d-2640-fe0f.png",sheet_x:48,sheet_y:49,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FE":{unified:"26F9-1F3FE-200D-2640-FE0F",image:"26f9-1f3fe-200d-2640-fe0f.png",sheet_x:48,sheet_y:50,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FF":{unified:"26F9-1F3FF-200D-2640-FE0F",image:"26f9-1f3ff-200d-2640-fe0f.png",sheet_x:48,sheet_y:51,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false}},sheet:[48,46]},weight_lifter:{name:"Weight Lifter",unified:"1F3CB-FE0F",non_qualified:"1F3CB",added_in:"7.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F3CB-1F3FB",non_qualified:null,image:"1f3cb-1f3fb.png",sheet_x:11,sheet_y:7,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:false},"1F3FC":{unified:"1F3CB-1F3FC",non_qualified:null,image:"1f3cb-1f3fc.png",sheet_x:11,sheet_y:8,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:false},"1F3FD":{unified:"1F3CB-1F3FD",non_qualified:null,image:"1f3cb-1f3fd.png",sheet_x:11,sheet_y:9,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:false},"1F3FE":{unified:"1F3CB-1F3FE",non_qualified:null,image:"1f3cb-1f3fe.png",sheet_x:11,sheet_y:10,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:false},"1F3FF":{unified:"1F3CB-1F3FF",non_qualified:null,image:"1f3cb-1f3ff.png",sheet_x:11,sheet_y:11,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:false}},obsoleted_by:"1F3CB-FE0F-200D-2642-FE0F",sheet:[11,6]},"man-lifting-weights":{name:"Man Lifting Weights",unified:"1F3CB-FE0F-200D-2642-FE0F",non_qualified:null,added_in:"7.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F3CB-1F3FB-200D-2642-FE0F",image:"1f3cb-1f3fb-200d-2642-fe0f.png",sheet_x:11,sheet_y:1,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FC":{unified:"1F3CB-1F3FC-200D-2642-FE0F",image:"1f3cb-1f3fc-200d-2642-fe0f.png",sheet_x:11,sheet_y:2,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FD":{unified:"1F3CB-1F3FD-200D-2642-FE0F",image:"1f3cb-1f3fd-200d-2642-fe0f.png",sheet_x:11,sheet_y:3,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FE":{unified:"1F3CB-1F3FE-200D-2642-FE0F",image:"1f3cb-1f3fe-200d-2642-fe0f.png",sheet_x:11,sheet_y:4,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FF":{unified:"1F3CB-1F3FF-200D-2642-FE0F",image:"1f3cb-1f3ff-200d-2642-fe0f.png",sheet_x:11,sheet_y:5,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false}},obsoletes:"1F3CB-FE0F",sheet:[11,0]},"woman-lifting-weights":{name:"Woman Lifting Weights",unified:"1F3CB-FE0F-200D-2640-FE0F",non_qualified:null,added_in:"7.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F3CB-1F3FB-200D-2640-FE0F",image:"1f3cb-1f3fb-200d-2640-fe0f.png",sheet_x:10,sheet_y:47,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FC":{unified:"1F3CB-1F3FC-200D-2640-FE0F",image:"1f3cb-1f3fc-200d-2640-fe0f.png",sheet_x:10,sheet_y:48,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FD":{unified:"1F3CB-1F3FD-200D-2640-FE0F",image:"1f3cb-1f3fd-200d-2640-fe0f.png",sheet_x:10,sheet_y:49,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FE":{unified:"1F3CB-1F3FE-200D-2640-FE0F",image:"1f3cb-1f3fe-200d-2640-fe0f.png",sheet_x:10,sheet_y:50,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FF":{unified:"1F3CB-1F3FF-200D-2640-FE0F",image:"1f3cb-1f3ff-200d-2640-fe0f.png",sheet_x:10,sheet_y:51,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false}},sheet:[10,46]},bicyclist:{name:"Bicyclist",unified:"1F6B4",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:true,skin_variations:{"1F3FB":{unified:"1F6B4-1F3FB",non_qualified:null,image:"1f6b4-1f3fb.png",sheet_x:35,sheet_y:38,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:true},"1F3FC":{unified:"1F6B4-1F3FC",non_qualified:null,image:"1f6b4-1f3fc.png",sheet_x:35,sheet_y:39,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:true},"1F3FD":{unified:"1F6B4-1F3FD",non_qualified:null,image:"1f6b4-1f3fd.png",sheet_x:35,sheet_y:40,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:true},"1F3FE":{unified:"1F6B4-1F3FE",non_qualified:null,image:"1f6b4-1f3fe.png",sheet_x:35,sheet_y:41,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:true},"1F3FF":{unified:"1F6B4-1F3FF",non_qualified:null,image:"1f6b4-1f3ff.png",sheet_x:35,sheet_y:42,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:true}},obsoleted_by:"1F6B4-200D-2642-FE0F",sheet:[35,37]},"man-biking":{name:"Man Biking",unified:"1F6B4-200D-2642-FE0F",non_qualified:"1F6B4-200D-2642",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F6B4-1F3FB-200D-2642-FE0F",image:"1f6b4-1f3fb-200d-2642-fe0f.png",sheet_x:35,sheet_y:32,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FC":{unified:"1F6B4-1F3FC-200D-2642-FE0F",image:"1f6b4-1f3fc-200d-2642-fe0f.png",sheet_x:35,sheet_y:33,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FD":{unified:"1F6B4-1F3FD-200D-2642-FE0F",image:"1f6b4-1f3fd-200d-2642-fe0f.png",sheet_x:35,sheet_y:34,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FE":{unified:"1F6B4-1F3FE-200D-2642-FE0F",image:"1f6b4-1f3fe-200d-2642-fe0f.png",sheet_x:35,sheet_y:35,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FF":{unified:"1F6B4-1F3FF-200D-2642-FE0F",image:"1f6b4-1f3ff-200d-2642-fe0f.png",sheet_x:35,sheet_y:36,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false}},obsoletes:"1F6B4",sheet:[35,31]},"woman-biking":{name:"Woman Biking",unified:"1F6B4-200D-2640-FE0F",non_qualified:"1F6B4-200D-2640",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F6B4-1F3FB-200D-2640-FE0F",image:"1f6b4-1f3fb-200d-2640-fe0f.png",sheet_x:35,sheet_y:26,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FC":{unified:"1F6B4-1F3FC-200D-2640-FE0F",image:"1f6b4-1f3fc-200d-2640-fe0f.png",sheet_x:35,sheet_y:27,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FD":{unified:"1F6B4-1F3FD-200D-2640-FE0F",image:"1f6b4-1f3fd-200d-2640-fe0f.png",sheet_x:35,sheet_y:28,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FE":{unified:"1F6B4-1F3FE-200D-2640-FE0F",image:"1f6b4-1f3fe-200d-2640-fe0f.png",sheet_x:35,sheet_y:29,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FF":{unified:"1F6B4-1F3FF-200D-2640-FE0F",image:"1f6b4-1f3ff-200d-2640-fe0f.png",sheet_x:35,sheet_y:30,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false}},sheet:[35,25]},mountain_bicyclist:{name:"Mountain Bicyclist",unified:"1F6B5",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:true,skin_variations:{"1F3FB":{unified:"1F6B5-1F3FB",non_qualified:null,image:"1f6b5-1f3fb.png",sheet_x:36,sheet_y:4,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:true},"1F3FC":{unified:"1F6B5-1F3FC",non_qualified:null,image:"1f6b5-1f3fc.png",sheet_x:36,sheet_y:5,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:true},"1F3FD":{unified:"1F6B5-1F3FD",non_qualified:null,image:"1f6b5-1f3fd.png",sheet_x:36,sheet_y:6,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:true},"1F3FE":{unified:"1F6B5-1F3FE",non_qualified:null,image:"1f6b5-1f3fe.png",sheet_x:36,sheet_y:7,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:true},"1F3FF":{unified:"1F6B5-1F3FF",non_qualified:null,image:"1f6b5-1f3ff.png",sheet_x:36,sheet_y:8,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:true}},obsoleted_by:"1F6B5-200D-2642-FE0F",sheet:[36,3]},"man-mountain-biking":{name:"Man Mountain Biking",unified:"1F6B5-200D-2642-FE0F",non_qualified:"1F6B5-200D-2642",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F6B5-1F3FB-200D-2642-FE0F",image:"1f6b5-1f3fb-200d-2642-fe0f.png",sheet_x:35,sheet_y:50,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FC":{unified:"1F6B5-1F3FC-200D-2642-FE0F",image:"1f6b5-1f3fc-200d-2642-fe0f.png",sheet_x:35,sheet_y:51,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FD":{unified:"1F6B5-1F3FD-200D-2642-FE0F",image:"1f6b5-1f3fd-200d-2642-fe0f.png",sheet_x:36,sheet_y:0,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FE":{unified:"1F6B5-1F3FE-200D-2642-FE0F",image:"1f6b5-1f3fe-200d-2642-fe0f.png",sheet_x:36,sheet_y:1,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FF":{unified:"1F6B5-1F3FF-200D-2642-FE0F",image:"1f6b5-1f3ff-200d-2642-fe0f.png",sheet_x:36,sheet_y:2,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false}},obsoletes:"1F6B5",sheet:[35,49]},"woman-mountain-biking":{name:"Woman Mountain Biking",unified:"1F6B5-200D-2640-FE0F",non_qualified:"1F6B5-200D-2640",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F6B5-1F3FB-200D-2640-FE0F",image:"1f6b5-1f3fb-200d-2640-fe0f.png",sheet_x:35,sheet_y:44,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FC":{unified:"1F6B5-1F3FC-200D-2640-FE0F",image:"1f6b5-1f3fc-200d-2640-fe0f.png",sheet_x:35,sheet_y:45,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FD":{unified:"1F6B5-1F3FD-200D-2640-FE0F",image:"1f6b5-1f3fd-200d-2640-fe0f.png",sheet_x:35,sheet_y:46,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FE":{unified:"1F6B5-1F3FE-200D-2640-FE0F",image:"1f6b5-1f3fe-200d-2640-fe0f.png",sheet_x:35,sheet_y:47,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FF":{unified:"1F6B5-1F3FF-200D-2640-FE0F",image:"1f6b5-1f3ff-200d-2640-fe0f.png",sheet_x:35,sheet_y:48,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false}},sheet:[35,43]},racing_car:{name:"Racing Car",unified:"1F3CE-FE0F",non_qualified:"1F3CE",added_in:"7.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,keywords:["sports","race","fast","formula","f1"],sheet:[11,31]},racing_motorcycle:{name:"Racing Motorcycle",unified:"1F3CD-FE0F",non_qualified:"1F3CD",added_in:"7.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,sheet:[11,30]},person_doing_cartwheel:{name:"Person Doing Cartwheel",unified:"1F938",non_qualified:null,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F938-1F3FB",non_qualified:null,image:"1f938-1f3fb.png",sheet_x:40,sheet_y:25,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:false},"1F3FC":{unified:"1F938-1F3FC",non_qualified:null,image:"1f938-1f3fc.png",sheet_x:40,sheet_y:26,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:false},"1F3FD":{unified:"1F938-1F3FD",non_qualified:null,image:"1f938-1f3fd.png",sheet_x:40,sheet_y:27,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:false},"1F3FE":{unified:"1F938-1F3FE",non_qualified:null,image:"1f938-1f3fe.png",sheet_x:40,sheet_y:28,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:false},"1F3FF":{unified:"1F938-1F3FF",non_qualified:null,image:"1f938-1f3ff.png",sheet_x:40,sheet_y:29,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:false}},sheet:[40,24]},"man-cartwheeling":{name:"Man Cartwheeling",unified:"1F938-200D-2642-FE0F",non_qualified:"1F938-200D-2642",added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F938-1F3FB-200D-2642-FE0F",image:"1f938-1f3fb-200d-2642-fe0f.png",sheet_x:40,sheet_y:19,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FC":{unified:"1F938-1F3FC-200D-2642-FE0F",image:"1f938-1f3fc-200d-2642-fe0f.png",sheet_x:40,sheet_y:20,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FD":{unified:"1F938-1F3FD-200D-2642-FE0F",image:"1f938-1f3fd-200d-2642-fe0f.png",sheet_x:40,sheet_y:21,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FE":{unified:"1F938-1F3FE-200D-2642-FE0F",image:"1f938-1f3fe-200d-2642-fe0f.png",sheet_x:40,sheet_y:22,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FF":{unified:"1F938-1F3FF-200D-2642-FE0F",image:"1f938-1f3ff-200d-2642-fe0f.png",sheet_x:40,sheet_y:23,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false}},sheet:[40,18]},"woman-cartwheeling":{name:"Woman Cartwheeling",unified:"1F938-200D-2640-FE0F",non_qualified:"1F938-200D-2640",added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F938-1F3FB-200D-2640-FE0F",image:"1f938-1f3fb-200d-2640-fe0f.png",sheet_x:40,sheet_y:13,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FC":{unified:"1F938-1F3FC-200D-2640-FE0F",image:"1f938-1f3fc-200d-2640-fe0f.png",sheet_x:40,sheet_y:14,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FD":{unified:"1F938-1F3FD-200D-2640-FE0F",image:"1f938-1f3fd-200d-2640-fe0f.png",sheet_x:40,sheet_y:15,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FE":{unified:"1F938-1F3FE-200D-2640-FE0F",image:"1f938-1f3fe-200d-2640-fe0f.png",sheet_x:40,sheet_y:16,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FF":{unified:"1F938-1F3FF-200D-2640-FE0F",image:"1f938-1f3ff-200d-2640-fe0f.png",sheet_x:40,sheet_y:17,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false}},sheet:[40,12]},wrestlers:{name:"Wrestlers",unified:"1F93C",non_qualified:null,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:false,sheet:[40,51]},"man-wrestling":{name:"Man Wrestling",unified:"1F93C-200D-2642-FE0F",non_qualified:"1F93C-200D-2642",added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,sheet:[40,50]},"woman-wrestling":{name:"Woman Wrestling",unified:"1F93C-200D-2640-FE0F",non_qualified:"1F93C-200D-2640",added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,sheet:[40,49]},water_polo:{name:"Water Polo",unified:"1F93D",non_qualified:null,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F93D-1F3FB",non_qualified:null,image:"1f93d-1f3fb.png",sheet_x:41,sheet_y:13,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:false},"1F3FC":{unified:"1F93D-1F3FC",non_qualified:null,image:"1f93d-1f3fc.png",sheet_x:41,sheet_y:14,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:false},"1F3FD":{unified:"1F93D-1F3FD",non_qualified:null,image:"1f93d-1f3fd.png",sheet_x:41,sheet_y:15,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:false},"1F3FE":{unified:"1F93D-1F3FE",non_qualified:null,image:"1f93d-1f3fe.png",sheet_x:41,sheet_y:16,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:false},"1F3FF":{unified:"1F93D-1F3FF",non_qualified:null,image:"1f93d-1f3ff.png",sheet_x:41,sheet_y:17,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:false}},sheet:[41,12]},"man-playing-water-polo":{name:"Man Playing Water Polo",unified:"1F93D-200D-2642-FE0F",non_qualified:"1F93D-200D-2642",added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F93D-1F3FB-200D-2642-FE0F",image:"1f93d-1f3fb-200d-2642-fe0f.png",sheet_x:41,sheet_y:7,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FC":{unified:"1F93D-1F3FC-200D-2642-FE0F",image:"1f93d-1f3fc-200d-2642-fe0f.png",sheet_x:41,sheet_y:8,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FD":{unified:"1F93D-1F3FD-200D-2642-FE0F",image:"1f93d-1f3fd-200d-2642-fe0f.png",sheet_x:41,sheet_y:9,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FE":{unified:"1F93D-1F3FE-200D-2642-FE0F",image:"1f93d-1f3fe-200d-2642-fe0f.png",sheet_x:41,sheet_y:10,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FF":{unified:"1F93D-1F3FF-200D-2642-FE0F",image:"1f93d-1f3ff-200d-2642-fe0f.png",sheet_x:41,sheet_y:11,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false}},sheet:[41,6]},"woman-playing-water-polo":{name:"Woman Playing Water Polo",unified:"1F93D-200D-2640-FE0F",non_qualified:"1F93D-200D-2640",added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F93D-1F3FB-200D-2640-FE0F",image:"1f93d-1f3fb-200d-2640-fe0f.png",sheet_x:41,sheet_y:1,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FC":{unified:"1F93D-1F3FC-200D-2640-FE0F",image:"1f93d-1f3fc-200d-2640-fe0f.png",sheet_x:41,sheet_y:2,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FD":{unified:"1F93D-1F3FD-200D-2640-FE0F",image:"1f93d-1f3fd-200d-2640-fe0f.png",sheet_x:41,sheet_y:3,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FE":{unified:"1F93D-1F3FE-200D-2640-FE0F",image:"1f93d-1f3fe-200d-2640-fe0f.png",sheet_x:41,sheet_y:4,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FF":{unified:"1F93D-1F3FF-200D-2640-FE0F",image:"1f93d-1f3ff-200d-2640-fe0f.png",sheet_x:41,sheet_y:5,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false}},sheet:[41,0]},handball:{name:"Handball",unified:"1F93E",non_qualified:null,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F93E-1F3FB",non_qualified:null,image:"1f93e-1f3fb.png",sheet_x:41,sheet_y:31,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:false},"1F3FC":{unified:"1F93E-1F3FC",non_qualified:null,image:"1f93e-1f3fc.png",sheet_x:41,sheet_y:32,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:false},"1F3FD":{unified:"1F93E-1F3FD",non_qualified:null,image:"1f93e-1f3fd.png",sheet_x:41,sheet_y:33,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:false},"1F3FE":{unified:"1F93E-1F3FE",non_qualified:null,image:"1f93e-1f3fe.png",sheet_x:41,sheet_y:34,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:false},"1F3FF":{unified:"1F93E-1F3FF",non_qualified:null,image:"1f93e-1f3ff.png",sheet_x:41,sheet_y:35,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:false}},sheet:[41,30]},"man-playing-handball":{name:"Man Playing Handball",unified:"1F93E-200D-2642-FE0F",non_qualified:"1F93E-200D-2642",added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F93E-1F3FB-200D-2642-FE0F",image:"1f93e-1f3fb-200d-2642-fe0f.png",sheet_x:41,sheet_y:25,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FC":{unified:"1F93E-1F3FC-200D-2642-FE0F",image:"1f93e-1f3fc-200d-2642-fe0f.png",sheet_x:41,sheet_y:26,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FD":{unified:"1F93E-1F3FD-200D-2642-FE0F",image:"1f93e-1f3fd-200d-2642-fe0f.png",sheet_x:41,sheet_y:27,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FE":{unified:"1F93E-1F3FE-200D-2642-FE0F",image:"1f93e-1f3fe-200d-2642-fe0f.png",sheet_x:41,sheet_y:28,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FF":{unified:"1F93E-1F3FF-200D-2642-FE0F",image:"1f93e-1f3ff-200d-2642-fe0f.png",sheet_x:41,sheet_y:29,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false}},sheet:[41,24]},"woman-playing-handball":{name:"Woman Playing Handball",unified:"1F93E-200D-2640-FE0F",non_qualified:"1F93E-200D-2640",added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F93E-1F3FB-200D-2640-FE0F",image:"1f93e-1f3fb-200d-2640-fe0f.png",sheet_x:41,sheet_y:19,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FC":{unified:"1F93E-1F3FC-200D-2640-FE0F",image:"1f93e-1f3fc-200d-2640-fe0f.png",sheet_x:41,sheet_y:20,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FD":{unified:"1F93E-1F3FD-200D-2640-FE0F",image:"1f93e-1f3fd-200d-2640-fe0f.png",sheet_x:41,sheet_y:21,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FE":{unified:"1F93E-1F3FE-200D-2640-FE0F",image:"1f93e-1f3fe-200d-2640-fe0f.png",sheet_x:41,sheet_y:22,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FF":{unified:"1F93E-1F3FF-200D-2640-FE0F",image:"1f93e-1f3ff-200d-2640-fe0f.png",sheet_x:41,sheet_y:23,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false}},sheet:[41,18]},juggling:{name:"Juggling",unified:"1F939",non_qualified:null,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F939-1F3FB",non_qualified:null,image:"1f939-1f3fb.png",sheet_x:40,sheet_y:43,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false},"1F3FC":{unified:"1F939-1F3FC",non_qualified:null,image:"1f939-1f3fc.png",sheet_x:40,sheet_y:44,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false},"1F3FD":{unified:"1F939-1F3FD",non_qualified:null,image:"1f939-1f3fd.png",sheet_x:40,sheet_y:45,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false},"1F3FE":{unified:"1F939-1F3FE",non_qualified:null,image:"1f939-1f3fe.png",sheet_x:40,sheet_y:46,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false},"1F3FF":{unified:"1F939-1F3FF",non_qualified:null,image:"1f939-1f3ff.png",sheet_x:40,sheet_y:47,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false}},sheet:[40,42]},"man-juggling":{name:"Man Juggling",unified:"1F939-200D-2642-FE0F",non_qualified:"1F939-200D-2642",added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F939-1F3FB-200D-2642-FE0F",image:"1f939-1f3fb-200d-2642-fe0f.png",sheet_x:40,sheet_y:37,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FC":{unified:"1F939-1F3FC-200D-2642-FE0F",image:"1f939-1f3fc-200d-2642-fe0f.png",sheet_x:40,sheet_y:38,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FD":{unified:"1F939-1F3FD-200D-2642-FE0F",image:"1f939-1f3fd-200d-2642-fe0f.png",sheet_x:40,sheet_y:39,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FE":{unified:"1F939-1F3FE-200D-2642-FE0F",image:"1f939-1f3fe-200d-2642-fe0f.png",sheet_x:40,sheet_y:40,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FF":{unified:"1F939-1F3FF-200D-2642-FE0F",image:"1f939-1f3ff-200d-2642-fe0f.png",sheet_x:40,sheet_y:41,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false}},sheet:[40,36]},"woman-juggling":{name:"Woman Juggling",unified:"1F939-200D-2640-FE0F",non_qualified:"1F939-200D-2640",added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F939-1F3FB-200D-2640-FE0F",image:"1f939-1f3fb-200d-2640-fe0f.png",sheet_x:40,sheet_y:31,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FC":{unified:"1F939-1F3FC-200D-2640-FE0F",image:"1f939-1f3fc-200d-2640-fe0f.png",sheet_x:40,sheet_y:32,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FD":{unified:"1F939-1F3FD-200D-2640-FE0F",image:"1f939-1f3fd-200d-2640-fe0f.png",sheet_x:40,sheet_y:33,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FE":{unified:"1F939-1F3FE-200D-2640-FE0F",image:"1f939-1f3fe-200d-2640-fe0f.png",sheet_x:40,sheet_y:34,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false},"1F3FF":{unified:"1F939-1F3FF-200D-2640-FE0F",image:"1f939-1f3ff-200d-2640-fe0f.png",sheet_x:40,sheet_y:35,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false}},sheet:[40,30]},couple:{name:"Man and Woman Holding Hands",unified:"1F46B",non_qualified:null,short_names:["man_and_woman_holding_hands"],has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["pair","people","human","love","date","dating","like","affection","valentines","marriage"],sheet:[20,30]},two_men_holding_hands:{name:"Two Men Holding Hands",unified:"1F46C",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["pair","couple","love","like","bromance","friendship","people","human"],sheet:[20,31]},two_women_holding_hands:{name:"Two Women Holding Hands",unified:"1F46D",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["pair","friendship","couple","love","like","female","people","human"],sheet:[20,32]},couplekiss:{name:"Kiss",unified:"1F48F",non_qualified:null,has_img_apple:true,has_img_google:false,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:true,obsoleted_by:"1F469-200D-2764-FE0F-200D-1F48B-200D-1F468",sheet:[24,41]},"woman-kiss-man":{name:"Woman Kiss Man",unified:"1F469-200D-2764-FE0F-200D-1F48B-200D-1F468",non_qualified:"1F469-200D-2764-200D-1F48B-200D-1F468",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,obsoletes:"1F48F",sheet:[20,21]},"man-kiss-man":{name:"Man Kiss Man",unified:"1F468-200D-2764-FE0F-200D-1F48B-200D-1F468",non_qualified:"1F468-200D-2764-200D-1F48B-200D-1F468",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:true,sheet:[18,10]},"woman-kiss-woman":{name:"Woman Kiss Woman",unified:"1F469-200D-2764-FE0F-200D-1F48B-200D-1F469",non_qualified:"1F469-200D-2764-200D-1F48B-200D-1F469",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:true,sheet:[20,22]},couple_with_heart:{name:"Couple with Heart",unified:"1F491",non_qualified:null,has_img_apple:true,has_img_google:false,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:true,obsoleted_by:"1F469-200D-2764-FE0F-200D-1F468",sheet:[24,43]},"woman-heart-man":{name:"Woman Heart Man",unified:"1F469-200D-2764-FE0F-200D-1F468",non_qualified:"1F469-200D-2764-200D-1F468",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,obsoletes:"1F491",sheet:[20,19]},"man-heart-man":{name:"Man Heart Man",unified:"1F468-200D-2764-FE0F-200D-1F468",non_qualified:"1F468-200D-2764-200D-1F468",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:true,sheet:[18,9]},"woman-heart-woman":{name:"Woman Heart Woman",unified:"1F469-200D-2764-FE0F-200D-1F469",non_qualified:"1F469-200D-2764-200D-1F469",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:true,sheet:[20,20]},family:{name:"Family",unified:"1F46A",non_qualified:null,short_names:["man-woman-boy"],has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:false,has_img_messenger:true,obsoleted_by:"1F468-200D-1F469-200D-1F466",sheet:[20,29]},"man-woman-boy":{name:"Man Woman Boy",unified:"1F468-200D-1F469-200D-1F466",non_qualified:null,short_names:["family"],has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:true,obsoletes:"1F46A",sheet:[17,2]},"man-woman-girl":{name:"Man Woman Girl",unified:"1F468-200D-1F469-200D-1F467",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[17,4]},"man-woman-girl-boy":{name:"Man Woman Girl Boy",unified:"1F468-200D-1F469-200D-1F467-200D-1F466",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[17,5]},"man-woman-boy-boy":{name:"Man Woman Boy Boy",unified:"1F468-200D-1F469-200D-1F466-200D-1F466",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[17,3]},"man-woman-girl-girl":{name:"Man Woman Girl Girl",unified:"1F468-200D-1F469-200D-1F467-200D-1F467",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[17,6]},"man-man-boy":{name:"Man Man Boy",unified:"1F468-200D-1F468-200D-1F466",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[16,49]},"man-man-girl":{name:"Man Man Girl",unified:"1F468-200D-1F468-200D-1F467",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[16,51]},"man-man-girl-boy":{name:"Man Man Girl Boy",unified:"1F468-200D-1F468-200D-1F467-200D-1F466",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[17,0]},"man-man-boy-boy":{name:"Man Man Boy Boy",unified:"1F468-200D-1F468-200D-1F466-200D-1F466",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[16,50]},"man-man-girl-girl":{name:"Man Man Girl Girl",unified:"1F468-200D-1F468-200D-1F467-200D-1F467",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[17,1]},"woman-woman-boy":{name:"Woman Woman Boy",unified:"1F469-200D-1F469-200D-1F466",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[19,12]},"woman-woman-girl":{name:"Woman Woman Girl",unified:"1F469-200D-1F469-200D-1F467",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[19,14]},"woman-woman-girl-boy":{name:"Woman Woman Girl Boy",unified:"1F469-200D-1F469-200D-1F467-200D-1F466",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[19,15]},"woman-woman-boy-boy":{name:"Woman Woman Boy Boy",unified:"1F469-200D-1F469-200D-1F466-200D-1F466",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[19,13]},"woman-woman-girl-girl":{name:"Woman Woman Girl Girl",unified:"1F469-200D-1F469-200D-1F467-200D-1F467",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[19,16]},"man-boy":{name:"Man Boy",unified:"1F468-200D-1F466",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,sheet:[16,45]},"man-boy-boy":{name:"Man Boy Boy",unified:"1F468-200D-1F466-200D-1F466",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,sheet:[16,44]},"man-girl":{name:"Man Girl",unified:"1F468-200D-1F467",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,sheet:[16,48]},"man-girl-boy":{name:"Man Girl Boy",unified:"1F468-200D-1F467-200D-1F466",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,sheet:[16,46]},"man-girl-girl":{name:"Man Girl Girl",unified:"1F468-200D-1F467-200D-1F467",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,sheet:[16,47]},"woman-boy":{name:"Woman Boy",unified:"1F469-200D-1F466",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,sheet:[19,8]},"woman-boy-boy":{name:"Woman Boy Boy",unified:"1F469-200D-1F466-200D-1F466",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,sheet:[19,7]},"woman-girl":{name:"Woman Girl",unified:"1F469-200D-1F467",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,sheet:[19,11]},"woman-girl-boy":{name:"Woman Girl Boy",unified:"1F469-200D-1F467-200D-1F466",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,sheet:[19,9]},"woman-girl-girl":{name:"Woman Girl Girl",unified:"1F469-200D-1F467-200D-1F467",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,sheet:[19,10]},selfie:{name:"Selfie",unified:"1F933",non_qualified:null,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F933-1F3FB",non_qualified:null,image:"1f933-1f3fb.png",sheet_x:39,sheet_y:23,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false},"1F3FC":{unified:"1F933-1F3FC",non_qualified:null,image:"1f933-1f3fc.png",sheet_x:39,sheet_y:24,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false},"1F3FD":{unified:"1F933-1F3FD",non_qualified:null,image:"1f933-1f3fd.png",sheet_x:39,sheet_y:25,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false},"1F3FE":{unified:"1F933-1F3FE",non_qualified:null,image:"1f933-1f3fe.png",sheet_x:39,sheet_y:26,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false},"1F3FF":{unified:"1F933-1F3FF",non_qualified:null,image:"1f933-1f3ff.png",sheet_x:39,sheet_y:27,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false}},keywords:["camera","phone"],sheet:[39,22]},muscle:{name:"Flexed Biceps",unified:"1F4AA",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,skin_variations:{"1F3FB":{unified:"1F4AA-1F3FB",non_qualified:null,image:"1f4aa-1f3fb.png",sheet_x:25,sheet_y:17,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FC":{unified:"1F4AA-1F3FC",non_qualified:null,image:"1f4aa-1f3fc.png",sheet_x:25,sheet_y:18,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FD":{unified:"1F4AA-1F3FD",non_qualified:null,image:"1f4aa-1f3fd.png",sheet_x:25,sheet_y:19,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FE":{unified:"1F4AA-1F3FE",non_qualified:null,image:"1f4aa-1f3fe.png",sheet_x:25,sheet_y:20,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FF":{unified:"1F4AA-1F3FF",non_qualified:null,image:"1f4aa-1f3ff.png",sheet_x:25,sheet_y:21,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true}},keywords:["arm","flex","hand","summer","strong","biceps"],sheet:[25,16]},point_left:{name:"White Left Pointing Backhand Index",unified:"1F448",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,skin_variations:{"1F3FB":{unified:"1F448-1F3FB",non_qualified:null,image:"1f448-1f3fb.png",sheet_x:14,sheet_y:20,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FC":{unified:"1F448-1F3FC",non_qualified:null,image:"1f448-1f3fc.png",sheet_x:14,sheet_y:21,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FD":{unified:"1F448-1F3FD",non_qualified:null,image:"1f448-1f3fd.png",sheet_x:14,sheet_y:22,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FE":{unified:"1F448-1F3FE",non_qualified:null,image:"1f448-1f3fe.png",sheet_x:14,sheet_y:23,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FF":{unified:"1F448-1F3FF",non_qualified:null,image:"1f448-1f3ff.png",sheet_x:14,sheet_y:24,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true}},keywords:["direction","fingers","hand","left"],sheet:[14,19]},point_right:{name:"White Right Pointing Backhand Index",unified:"1F449",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,skin_variations:{"1F3FB":{unified:"1F449-1F3FB",non_qualified:null,image:"1f449-1f3fb.png",sheet_x:14,sheet_y:26,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FC":{unified:"1F449-1F3FC",non_qualified:null,image:"1f449-1f3fc.png",sheet_x:14,sheet_y:27,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FD":{unified:"1F449-1F3FD",non_qualified:null,image:"1f449-1f3fd.png",sheet_x:14,sheet_y:28,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FE":{unified:"1F449-1F3FE",non_qualified:null,image:"1f449-1f3fe.png",sheet_x:14,sheet_y:29,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FF":{unified:"1F449-1F3FF",non_qualified:null,image:"1f449-1f3ff.png",sheet_x:14,sheet_y:30,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true}},keywords:["fingers","hand","direction","right"],sheet:[14,25]},point_up:{name:"White Up Pointing Index",unified:"261D-FE0F",non_qualified:"261D",added_in:"1.1",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:true,skin_variations:{"1F3FB":{unified:"261D-1F3FB",non_qualified:null,image:"261d-1f3fb.png",sheet_x:47,sheet_y:27,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FC":{unified:"261D-1F3FC",non_qualified:null,image:"261d-1f3fc.png",sheet_x:47,sheet_y:28,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FD":{unified:"261D-1F3FD",non_qualified:null,image:"261d-1f3fd.png",sheet_x:47,sheet_y:29,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FE":{unified:"261D-1F3FE",non_qualified:null,image:"261d-1f3fe.png",sheet_x:47,sheet_y:30,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FF":{unified:"261D-1F3FF",non_qualified:null,image:"261d-1f3ff.png",sheet_x:47,sheet_y:31,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true}},keywords:["hand","fingers","direction","up"],sheet:[47,26]},"point_up_2":{name:"White Up Pointing Backhand Index",unified:"1F446",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,skin_variations:{"1F3FB":{unified:"1F446-1F3FB",non_qualified:null,image:"1f446-1f3fb.png",sheet_x:14,sheet_y:8,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FC":{unified:"1F446-1F3FC",non_qualified:null,image:"1f446-1f3fc.png",sheet_x:14,sheet_y:9,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FD":{unified:"1F446-1F3FD",non_qualified:null,image:"1f446-1f3fd.png",sheet_x:14,sheet_y:10,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FE":{unified:"1F446-1F3FE",non_qualified:null,image:"1f446-1f3fe.png",sheet_x:14,sheet_y:11,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FF":{unified:"1F446-1F3FF",non_qualified:null,image:"1f446-1f3ff.png",sheet_x:14,sheet_y:12,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true}},keywords:["fingers","hand","direction","up"],sheet:[14,7]},middle_finger:{name:"Reversed Hand with Middle Finger Extended",unified:"1F595",non_qualified:null,short_names:["reversed_hand_with_middle_finger_extended"],added_in:"7.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F595-1F3FB",non_qualified:null,image:"1f595-1f3fb.png",sheet_x:29,sheet_y:39,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false},"1F3FC":{unified:"1F595-1F3FC",non_qualified:null,image:"1f595-1f3fc.png",sheet_x:29,sheet_y:40,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false},"1F3FD":{unified:"1F595-1F3FD",non_qualified:null,image:"1f595-1f3fd.png",sheet_x:29,sheet_y:41,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false},"1F3FE":{unified:"1F595-1F3FE",non_qualified:null,image:"1f595-1f3fe.png",sheet_x:29,sheet_y:42,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false},"1F3FF":{unified:"1F595-1F3FF",non_qualified:null,image:"1f595-1f3ff.png",sheet_x:29,sheet_y:43,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false}},sheet:[29,38]},point_down:{name:"White Down Pointing Backhand Index",unified:"1F447",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,skin_variations:{"1F3FB":{unified:"1F447-1F3FB",non_qualified:null,image:"1f447-1f3fb.png",sheet_x:14,sheet_y:14,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FC":{unified:"1F447-1F3FC",non_qualified:null,image:"1f447-1f3fc.png",sheet_x:14,sheet_y:15,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FD":{unified:"1F447-1F3FD",non_qualified:null,image:"1f447-1f3fd.png",sheet_x:14,sheet_y:16,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FE":{unified:"1F447-1F3FE",non_qualified:null,image:"1f447-1f3fe.png",sheet_x:14,sheet_y:17,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FF":{unified:"1F447-1F3FF",non_qualified:null,image:"1f447-1f3ff.png",sheet_x:14,sheet_y:18,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true}},keywords:["fingers","hand","direction","down"],sheet:[14,13]},v:{name:"Victory Hand",unified:"270C-FE0F",non_qualified:"270C",added_in:"1.1",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:true,skin_variations:{"1F3FB":{unified:"270C-1F3FB",non_qualified:null,image:"270c-1f3fb.png",sheet_x:49,sheet_y:31,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FC":{unified:"270C-1F3FC",non_qualified:null,image:"270c-1f3fc.png",sheet_x:49,sheet_y:32,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FD":{unified:"270C-1F3FD",non_qualified:null,image:"270c-1f3fd.png",sheet_x:49,sheet_y:33,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FE":{unified:"270C-1F3FE",non_qualified:null,image:"270c-1f3fe.png",sheet_x:49,sheet_y:34,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FF":{unified:"270C-1F3FF",non_qualified:null,image:"270c-1f3ff.png",sheet_x:49,sheet_y:35,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true}},keywords:["fingers","ohyeah","hand","peace","victory","two"],sheet:[49,30]},crossed_fingers:{name:"Hand with Index and Middle Fingers Crossed",unified:"1F91E",non_qualified:null,short_names:["hand_with_index_and_middle_fingers_crossed"],added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F91E-1F3FB",non_qualified:null,image:"1f91e-1f3fb.png",sheet_x:38,sheet_y:12,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false},"1F3FC":{unified:"1F91E-1F3FC",non_qualified:null,image:"1f91e-1f3fc.png",sheet_x:38,sheet_y:13,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false},"1F3FD":{unified:"1F91E-1F3FD",non_qualified:null,image:"1f91e-1f3fd.png",sheet_x:38,sheet_y:14,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false},"1F3FE":{unified:"1F91E-1F3FE",non_qualified:null,image:"1f91e-1f3fe.png",sheet_x:38,sheet_y:15,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false},"1F3FF":{unified:"1F91E-1F3FF",non_qualified:null,image:"1f91e-1f3ff.png",sheet_x:38,sheet_y:16,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false}},keywords:["good","lucky"],sheet:[38,11]},"spock-hand":{name:"Raised Hand with Part Between Middle and Ring Fingers",unified:"1F596",non_qualified:null,added_in:"7.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F596-1F3FB",non_qualified:null,image:"1f596-1f3fb.png",sheet_x:29,sheet_y:45,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false},"1F3FC":{unified:"1F596-1F3FC",non_qualified:null,image:"1f596-1f3fc.png",sheet_x:29,sheet_y:46,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false},"1F3FD":{unified:"1F596-1F3FD",non_qualified:null,image:"1f596-1f3fd.png",sheet_x:29,sheet_y:47,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false},"1F3FE":{unified:"1F596-1F3FE",non_qualified:null,image:"1f596-1f3fe.png",sheet_x:29,sheet_y:48,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false},"1F3FF":{unified:"1F596-1F3FF",non_qualified:null,image:"1f596-1f3ff.png",sheet_x:29,sheet_y:49,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false}},sheet:[29,44]},the_horns:{name:"Sign of the Horns",unified:"1F918",non_qualified:null,short_names:["sign_of_the_horns"],added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F918-1F3FB",non_qualified:null,image:"1f918-1f3fb.png",sheet_x:37,sheet_y:33,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false},"1F3FC":{unified:"1F918-1F3FC",non_qualified:null,image:"1f918-1f3fc.png",sheet_x:37,sheet_y:34,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false},"1F3FD":{unified:"1F918-1F3FD",non_qualified:null,image:"1f918-1f3fd.png",sheet_x:37,sheet_y:35,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false},"1F3FE":{unified:"1F918-1F3FE",non_qualified:null,image:"1f918-1f3fe.png",sheet_x:37,sheet_y:36,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false},"1F3FF":{unified:"1F918-1F3FF",non_qualified:null,image:"1f918-1f3ff.png",sheet_x:37,sheet_y:37,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false}},sheet:[37,32]},call_me_hand:{name:"Call Me Hand",unified:"1F919",non_qualified:null,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F919-1F3FB",non_qualified:null,image:"1f919-1f3fb.png",sheet_x:37,sheet_y:39,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false},"1F3FC":{unified:"1F919-1F3FC",non_qualified:null,image:"1f919-1f3fc.png",sheet_x:37,sheet_y:40,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false},"1F3FD":{unified:"1F919-1F3FD",non_qualified:null,image:"1f919-1f3fd.png",sheet_x:37,sheet_y:41,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false},"1F3FE":{unified:"1F919-1F3FE",non_qualified:null,image:"1f919-1f3fe.png",sheet_x:37,sheet_y:42,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false},"1F3FF":{unified:"1F919-1F3FF",non_qualified:null,image:"1f919-1f3ff.png",sheet_x:37,sheet_y:43,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false}},keywords:["hands","gesture"],sheet:[37,38]},raised_hand_with_fingers_splayed:{name:"Raised Hand with Fingers Splayed",unified:"1F590-FE0F",non_qualified:"1F590",added_in:"7.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F590-1F3FB",non_qualified:null,image:"1f590-1f3fb.png",sheet_x:29,sheet_y:33,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false},"1F3FC":{unified:"1F590-1F3FC",non_qualified:null,image:"1f590-1f3fc.png",sheet_x:29,sheet_y:34,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false},"1F3FD":{unified:"1F590-1F3FD",non_qualified:null,image:"1f590-1f3fd.png",sheet_x:29,sheet_y:35,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false},"1F3FE":{unified:"1F590-1F3FE",non_qualified:null,image:"1f590-1f3fe.png",sheet_x:29,sheet_y:36,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false},"1F3FF":{unified:"1F590-1F3FF",non_qualified:null,image:"1f590-1f3ff.png",sheet_x:29,sheet_y:37,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false}},keywords:["hand","fingers","palm"],sheet:[29,32]},hand:{name:"Raised Hand",unified:"270B",non_qualified:null,short_names:["raised_hand"],has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,skin_variations:{"1F3FB":{unified:"270B-1F3FB",non_qualified:null,image:"270b-1f3fb.png",sheet_x:49,sheet_y:25,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FC":{unified:"270B-1F3FC",non_qualified:null,image:"270b-1f3fc.png",sheet_x:49,sheet_y:26,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FD":{unified:"270B-1F3FD",non_qualified:null,image:"270b-1f3fd.png",sheet_x:49,sheet_y:27,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FE":{unified:"270B-1F3FE",non_qualified:null,image:"270b-1f3fe.png",sheet_x:49,sheet_y:28,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FF":{unified:"270B-1F3FF",non_qualified:null,image:"270b-1f3ff.png",sheet_x:49,sheet_y:29,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true}},sheet:[49,24]},ok_hand:{name:"Ok Hand Sign",unified:"1F44C",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,skin_variations:{"1F3FB":{unified:"1F44C-1F3FB",non_qualified:null,image:"1f44c-1f3fb.png",sheet_x:14,sheet_y:44,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FC":{unified:"1F44C-1F3FC",non_qualified:null,image:"1f44c-1f3fc.png",sheet_x:14,sheet_y:45,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FD":{unified:"1F44C-1F3FD",non_qualified:null,image:"1f44c-1f3fd.png",sheet_x:14,sheet_y:46,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FE":{unified:"1F44C-1F3FE",non_qualified:null,image:"1f44c-1f3fe.png",sheet_x:14,sheet_y:47,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FF":{unified:"1F44C-1F3FF",non_qualified:null,image:"1f44c-1f3ff.png",sheet_x:14,sheet_y:48,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true}},keywords:["fingers","limbs","perfect","ok","okay"],sheet:[14,43]},"+1":{name:"Thumbs Up Sign",unified:"1F44D",non_qualified:null,short_names:["thumbsup"],has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,skin_variations:{"1F3FB":{unified:"1F44D-1F3FB",non_qualified:null,image:"1f44d-1f3fb.png",sheet_x:14,sheet_y:50,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FC":{unified:"1F44D-1F3FC",non_qualified:null,image:"1f44d-1f3fc.png",sheet_x:14,sheet_y:51,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FD":{unified:"1F44D-1F3FD",non_qualified:null,image:"1f44d-1f3fd.png",sheet_x:15,sheet_y:0,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FE":{unified:"1F44D-1F3FE",non_qualified:null,image:"1f44d-1f3fe.png",sheet_x:15,sheet_y:1,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FF":{unified:"1F44D-1F3FF",non_qualified:null,image:"1f44d-1f3ff.png",sheet_x:15,sheet_y:2,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true}},keywords:["thumbsup","yes","awesome","good","agree","accept","cool","hand","like"],sheet:[14,49]},"-1":{name:"Thumbs Down Sign",unified:"1F44E",non_qualified:null,short_names:["thumbsdown"],has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,skin_variations:{"1F3FB":{unified:"1F44E-1F3FB",non_qualified:null,image:"1f44e-1f3fb.png",sheet_x:15,sheet_y:4,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FC":{unified:"1F44E-1F3FC",non_qualified:null,image:"1f44e-1f3fc.png",sheet_x:15,sheet_y:5,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FD":{unified:"1F44E-1F3FD",non_qualified:null,image:"1f44e-1f3fd.png",sheet_x:15,sheet_y:6,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FE":{unified:"1F44E-1F3FE",non_qualified:null,image:"1f44e-1f3fe.png",sheet_x:15,sheet_y:7,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FF":{unified:"1F44E-1F3FF",non_qualified:null,image:"1f44e-1f3ff.png",sheet_x:15,sheet_y:8,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true}},keywords:["thumbsdown","no","dislike","hand"],sheet:[15,3]},fist:{name:"Raised Fist",unified:"270A",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,skin_variations:{"1F3FB":{unified:"270A-1F3FB",non_qualified:null,image:"270a-1f3fb.png",sheet_x:49,sheet_y:19,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FC":{unified:"270A-1F3FC",non_qualified:null,image:"270a-1f3fc.png",sheet_x:49,sheet_y:20,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FD":{unified:"270A-1F3FD",non_qualified:null,image:"270a-1f3fd.png",sheet_x:49,sheet_y:21,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FE":{unified:"270A-1F3FE",non_qualified:null,image:"270a-1f3fe.png",sheet_x:49,sheet_y:22,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FF":{unified:"270A-1F3FF",non_qualified:null,image:"270a-1f3ff.png",sheet_x:49,sheet_y:23,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true}},keywords:["fingers","hand","grasp"],sheet:[49,18]},facepunch:{name:"Fisted Hand Sign",unified:"1F44A",non_qualified:null,short_names:["punch"],has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,skin_variations:{"1F3FB":{unified:"1F44A-1F3FB",non_qualified:null,image:"1f44a-1f3fb.png",sheet_x:14,sheet_y:32,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FC":{unified:"1F44A-1F3FC",non_qualified:null,image:"1f44a-1f3fc.png",sheet_x:14,sheet_y:33,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FD":{unified:"1F44A-1F3FD",non_qualified:null,image:"1f44a-1f3fd.png",sheet_x:14,sheet_y:34,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FE":{unified:"1F44A-1F3FE",non_qualified:null,image:"1f44a-1f3fe.png",sheet_x:14,sheet_y:35,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FF":{unified:"1F44A-1F3FF",non_qualified:null,image:"1f44a-1f3ff.png",sheet_x:14,sheet_y:36,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true}},keywords:["angry","violence","fist","hit","attack","hand"],sheet:[14,31]},"left-facing_fist":{name:"Left-Facing Fist",unified:"1F91B",non_qualified:null,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F91B-1F3FB",non_qualified:null,image:"1f91b-1f3fb.png",sheet_x:37,sheet_y:51,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false},"1F3FC":{unified:"1F91B-1F3FC",non_qualified:null,image:"1f91b-1f3fc.png",sheet_x:38,sheet_y:0,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false},"1F3FD":{unified:"1F91B-1F3FD",non_qualified:null,image:"1f91b-1f3fd.png",sheet_x:38,sheet_y:1,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false},"1F3FE":{unified:"1F91B-1F3FE",non_qualified:null,image:"1f91b-1f3fe.png",sheet_x:38,sheet_y:2,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false},"1F3FF":{unified:"1F91B-1F3FF",non_qualified:null,image:"1f91b-1f3ff.png",sheet_x:38,sheet_y:3,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false}},sheet:[37,50]},"right-facing_fist":{name:"Right-Facing Fist",unified:"1F91C",non_qualified:null,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F91C-1F3FB",non_qualified:null,image:"1f91c-1f3fb.png",sheet_x:38,sheet_y:5,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false},"1F3FC":{unified:"1F91C-1F3FC",non_qualified:null,image:"1f91c-1f3fc.png",sheet_x:38,sheet_y:6,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false},"1F3FD":{unified:"1F91C-1F3FD",non_qualified:null,image:"1f91c-1f3fd.png",sheet_x:38,sheet_y:7,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false},"1F3FE":{unified:"1F91C-1F3FE",non_qualified:null,image:"1f91c-1f3fe.png",sheet_x:38,sheet_y:8,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false},"1F3FF":{unified:"1F91C-1F3FF",non_qualified:null,image:"1f91c-1f3ff.png",sheet_x:38,sheet_y:9,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false}},sheet:[38,4]},raised_back_of_hand:{name:"Raised Back of Hand",unified:"1F91A",non_qualified:null,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F91A-1F3FB",non_qualified:null,image:"1f91a-1f3fb.png",sheet_x:37,sheet_y:45,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false},"1F3FC":{unified:"1F91A-1F3FC",non_qualified:null,image:"1f91a-1f3fc.png",sheet_x:37,sheet_y:46,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false},"1F3FD":{unified:"1F91A-1F3FD",non_qualified:null,image:"1f91a-1f3fd.png",sheet_x:37,sheet_y:47,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false},"1F3FE":{unified:"1F91A-1F3FE",non_qualified:null,image:"1f91a-1f3fe.png",sheet_x:37,sheet_y:48,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false},"1F3FF":{unified:"1F91A-1F3FF",non_qualified:null,image:"1f91a-1f3ff.png",sheet_x:37,sheet_y:49,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false}},keywords:["fingers","raised","backhand"],sheet:[37,44]},wave:{name:"Waving Hand Sign",unified:"1F44B",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,skin_variations:{"1F3FB":{unified:"1F44B-1F3FB",non_qualified:null,image:"1f44b-1f3fb.png",sheet_x:14,sheet_y:38,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FC":{unified:"1F44B-1F3FC",non_qualified:null,image:"1f44b-1f3fc.png",sheet_x:14,sheet_y:39,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FD":{unified:"1F44B-1F3FD",non_qualified:null,image:"1f44b-1f3fd.png",sheet_x:14,sheet_y:40,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FE":{unified:"1F44B-1F3FE",non_qualified:null,image:"1f44b-1f3fe.png",sheet_x:14,sheet_y:41,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FF":{unified:"1F44B-1F3FF",non_qualified:null,image:"1f44b-1f3ff.png",sheet_x:14,sheet_y:42,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true}},keywords:["hands","gesture","goodbye","solong","farewell","hello","hi","palm"],sheet:[14,37]},i_love_you_hand_sign:{name:"I Love You Hand Sign",unified:"1F91F",non_qualified:null,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F91F-1F3FB",non_qualified:null,image:"1f91f-1f3fb.png",sheet_x:38,sheet_y:18,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FC":{unified:"1F91F-1F3FC",non_qualified:null,image:"1f91f-1f3fc.png",sheet_x:38,sheet_y:19,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FD":{unified:"1F91F-1F3FD",non_qualified:null,image:"1f91f-1f3fd.png",sheet_x:38,sheet_y:20,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FE":{unified:"1F91F-1F3FE",non_qualified:null,image:"1f91f-1f3fe.png",sheet_x:38,sheet_y:21,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FF":{unified:"1F91F-1F3FF",non_qualified:null,image:"1f91f-1f3ff.png",sheet_x:38,sheet_y:22,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false}},sheet:[38,17]},writing_hand:{name:"Writing Hand",unified:"270D-FE0F",non_qualified:"270D",added_in:"1.1",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"270D-1F3FB",non_qualified:null,image:"270d-1f3fb.png",sheet_x:49,sheet_y:37,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false},"1F3FC":{unified:"270D-1F3FC",non_qualified:null,image:"270d-1f3fc.png",sheet_x:49,sheet_y:38,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false},"1F3FD":{unified:"270D-1F3FD",non_qualified:null,image:"270d-1f3fd.png",sheet_x:49,sheet_y:39,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false},"1F3FE":{unified:"270D-1F3FE",non_qualified:null,image:"270d-1f3fe.png",sheet_x:49,sheet_y:40,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false},"1F3FF":{unified:"270D-1F3FF",non_qualified:null,image:"270d-1f3ff.png",sheet_x:49,sheet_y:41,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false}},keywords:["lower_left_ballpoint_pen","stationery","write","compose"],sheet:[49,36]},clap:{name:"Clapping Hands Sign",unified:"1F44F",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,skin_variations:{"1F3FB":{unified:"1F44F-1F3FB",non_qualified:null,image:"1f44f-1f3fb.png",sheet_x:15,sheet_y:10,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FC":{unified:"1F44F-1F3FC",non_qualified:null,image:"1f44f-1f3fc.png",sheet_x:15,sheet_y:11,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FD":{unified:"1F44F-1F3FD",non_qualified:null,image:"1f44f-1f3fd.png",sheet_x:15,sheet_y:12,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FE":{unified:"1F44F-1F3FE",non_qualified:null,image:"1f44f-1f3fe.png",sheet_x:15,sheet_y:13,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FF":{unified:"1F44F-1F3FF",non_qualified:null,image:"1f44f-1f3ff.png",sheet_x:15,sheet_y:14,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true}},keywords:["hands","praise","applause","congrats","yay"],sheet:[15,9]},open_hands:{name:"Open Hands Sign",unified:"1F450",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,skin_variations:{"1F3FB":{unified:"1F450-1F3FB",non_qualified:null,image:"1f450-1f3fb.png",sheet_x:15,sheet_y:16,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FC":{unified:"1F450-1F3FC",non_qualified:null,image:"1f450-1f3fc.png",sheet_x:15,sheet_y:17,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FD":{unified:"1F450-1F3FD",non_qualified:null,image:"1f450-1f3fd.png",sheet_x:15,sheet_y:18,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FE":{unified:"1F450-1F3FE",non_qualified:null,image:"1f450-1f3fe.png",sheet_x:15,sheet_y:19,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FF":{unified:"1F450-1F3FF",non_qualified:null,image:"1f450-1f3ff.png",sheet_x:15,sheet_y:20,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true}},keywords:["fingers","butterfly","hands","open"],sheet:[15,15]},raised_hands:{name:"Person Raising Both Hands in Celebration",unified:"1F64C",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,skin_variations:{"1F3FB":{unified:"1F64C-1F3FB",non_qualified:null,image:"1f64c-1f3fb.png",sheet_x:33,sheet_y:13,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FC":{unified:"1F64C-1F3FC",non_qualified:null,image:"1f64c-1f3fc.png",sheet_x:33,sheet_y:14,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FD":{unified:"1F64C-1F3FD",non_qualified:null,image:"1f64c-1f3fd.png",sheet_x:33,sheet_y:15,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FE":{unified:"1F64C-1F3FE",non_qualified:null,image:"1f64c-1f3fe.png",sheet_x:33,sheet_y:16,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FF":{unified:"1F64C-1F3FF",non_qualified:null,image:"1f64c-1f3ff.png",sheet_x:33,sheet_y:17,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true}},keywords:["gesture","hooray","yea","celebration","hands"],sheet:[33,12]},palms_up_together:{name:"Palms Up Together",unified:"1F932",non_qualified:null,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,skin_variations:{"1F3FB":{unified:"1F932-1F3FB",non_qualified:null,image:"1f932-1f3fb.png",sheet_x:39,sheet_y:17,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FC":{unified:"1F932-1F3FC",non_qualified:null,image:"1f932-1f3fc.png",sheet_x:39,sheet_y:18,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FD":{unified:"1F932-1F3FD",non_qualified:null,image:"1f932-1f3fd.png",sheet_x:39,sheet_y:19,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FE":{unified:"1F932-1F3FE",non_qualified:null,image:"1f932-1f3fe.png",sheet_x:39,sheet_y:20,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false},"1F3FF":{unified:"1F932-1F3FF",non_qualified:null,image:"1f932-1f3ff.png",sheet_x:39,sheet_y:21,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false}},sheet:[39,16]},pray:{name:"Person with Folded Hands",unified:"1F64F",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,skin_variations:{"1F3FB":{unified:"1F64F-1F3FB",non_qualified:null,image:"1f64f-1f3fb.png",sheet_x:34,sheet_y:3,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FC":{unified:"1F64F-1F3FC",non_qualified:null,image:"1f64f-1f3fc.png",sheet_x:34,sheet_y:4,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FD":{unified:"1F64F-1F3FD",non_qualified:null,image:"1f64f-1f3fd.png",sheet_x:34,sheet_y:5,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FE":{unified:"1F64F-1F3FE",non_qualified:null,image:"1f64f-1f3fe.png",sheet_x:34,sheet_y:6,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FF":{unified:"1F64F-1F3FF",non_qualified:null,image:"1f64f-1f3ff.png",sheet_x:34,sheet_y:7,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true}},keywords:["please","hope","wish","namaste","highfive"],sheet:[34,2]},handshake:{name:"Handshake",unified:"1F91D",non_qualified:null,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false,keywords:["agreement","shake"],sheet:[38,10]},nail_care:{name:"Nail Polish",unified:"1F485",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,skin_variations:{"1F3FB":{unified:"1F485-1F3FB",non_qualified:null,image:"1f485-1f3fb.png",sheet_x:23,sheet_y:45,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FC":{unified:"1F485-1F3FC",non_qualified:null,image:"1f485-1f3fc.png",sheet_x:23,sheet_y:46,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FD":{unified:"1F485-1F3FD",non_qualified:null,image:"1f485-1f3fd.png",sheet_x:23,sheet_y:47,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FE":{unified:"1F485-1F3FE",non_qualified:null,image:"1f485-1f3fe.png",sheet_x:23,sheet_y:48,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FF":{unified:"1F485-1F3FF",non_qualified:null,image:"1f485-1f3ff.png",sheet_x:23,sheet_y:49,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true}},keywords:["beauty","manicure","finger","fashion","nail"],sheet:[23,44]},ear:{name:"Ear",unified:"1F442",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,skin_variations:{"1F3FB":{unified:"1F442-1F3FB",non_qualified:null,image:"1f442-1f3fb.png",sheet_x:13,sheet_y:46,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FC":{unified:"1F442-1F3FC",non_qualified:null,image:"1f442-1f3fc.png",sheet_x:13,sheet_y:47,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FD":{unified:"1F442-1F3FD",non_qualified:null,image:"1f442-1f3fd.png",sheet_x:13,sheet_y:48,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FE":{unified:"1F442-1F3FE",non_qualified:null,image:"1f442-1f3fe.png",sheet_x:13,sheet_y:49,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FF":{unified:"1F442-1F3FF",non_qualified:null,image:"1f442-1f3ff.png",sheet_x:13,sheet_y:50,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true}},keywords:["face","hear","sound","listen"],sheet:[13,45]},nose:{name:"Nose",unified:"1F443",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,skin_variations:{"1F3FB":{unified:"1F443-1F3FB",non_qualified:null,image:"1f443-1f3fb.png",sheet_x:14,sheet_y:0,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FC":{unified:"1F443-1F3FC",non_qualified:null,image:"1f443-1f3fc.png",sheet_x:14,sheet_y:1,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FD":{unified:"1F443-1F3FD",non_qualified:null,image:"1f443-1f3fd.png",sheet_x:14,sheet_y:2,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FE":{unified:"1F443-1F3FE",non_qualified:null,image:"1f443-1f3fe.png",sheet_x:14,sheet_y:3,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true},"1F3FF":{unified:"1F443-1F3FF",non_qualified:null,image:"1f443-1f3ff.png",sheet_x:14,sheet_y:4,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true}},keywords:["smell","sniff"],sheet:[13,51]},footprints:{name:"Footprints",unified:"1F463",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["feet","tracking","walking","beach"],sheet:[15,39]},eyes:{name:"Eyes",unified:"1F440",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["look","watch","stalk","peek","see"],sheet:[13,42]},eye:{name:"Eye",unified:"1F441-FE0F",non_qualified:"1F441",added_in:"7.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,keywords:["face","look","see","watch","stare"],sheet:[13,44]},"eye-in-speech-bubble":{name:"Eye in Speech Bubble",unified:"1F441-FE0F-200D-1F5E8-FE0F",non_qualified:null,added_in:"7.0",has_img_apple:true,has_img_google:true,has_img_twitter:false,has_img_emojione:false,has_img_facebook:false,has_img_messenger:false,sheet:[13,43]},brain:{name:"Brain",unified:"1F9E0",non_qualified:null,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,keywords:["smart","intelligent"],sheet:[46,22]},tongue:{name:"Tongue",unified:"1F445",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["mouth","playful"],sheet:[14,6]},lips:{name:"Mouth",unified:"1F444",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["mouth","kiss"],sheet:[14,5]},kiss:{name:"Kiss Mark",unified:"1F48B",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["face","lips","love","like","affection","valentines"],sheet:[24,37]},cupid:{name:"Heart with Arrow",unified:"1F498",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["love","like","heart","affection","valentines"],sheet:[24,50]},heart:{name:"Heavy Black Heart",unified:"2764-FE0F",non_qualified:"2764",text:"<3",added_in:"1.1",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:true,emoticons:["<3"],keywords:["love","like","valentines"],sheet:[50,8]},heartbeat:{name:"Beating Heart",unified:"1F493",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["love","like","affection","valentines","pink","heart"],sheet:[24,45]},broken_heart:{name:"Broken Heart",unified:"1F494",non_qualified:null,text:"</3",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,emoticons:["</3"],keywords:["sad","sorry","break","heart","heartbreak"],sheet:[24,46]},two_hearts:{name:"Two Hearts",unified:"1F495",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["love","like","affection","valentines","heart"],sheet:[24,47]},sparkling_heart:{name:"Sparkling Heart",unified:"1F496",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["love","like","affection","valentines"],sheet:[24,48]},heartpulse:{name:"Growing Heart",unified:"1F497",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["like","love","affection","valentines","pink"],sheet:[24,49]},blue_heart:{name:"Blue Heart",unified:"1F499",non_qualified:null,text:"<3",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["love","like","affection","valentines"],sheet:[24,51]},green_heart:{name:"Green Heart",unified:"1F49A",non_qualified:null,text:"<3",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["love","like","affection","valentines"],sheet:[25,0]},yellow_heart:{name:"Yellow Heart",unified:"1F49B",non_qualified:null,text:"<3",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["love","like","affection","valentines"],sheet:[25,1]},orange_heart:{name:"Orange Heart",unified:"1F9E1",non_qualified:null,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,keywords:["love","like","affection","valentines"],sheet:[46,23]},purple_heart:{name:"Purple Heart",unified:"1F49C",non_qualified:null,text:"<3",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["love","like","affection","valentines"],sheet:[25,2]},black_heart:{name:"Black Heart",unified:"1F5A4",non_qualified:null,added_in:"9.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false,keywords:["evil"],sheet:[29,50]},gift_heart:{name:"Heart with Ribbon",unified:"1F49D",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["love","valentines"],sheet:[25,3]},revolving_hearts:{name:"Revolving Hearts",unified:"1F49E",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["love","like","affection","valentines"],sheet:[25,4]},heart_decoration:{name:"Heart Decoration",unified:"1F49F",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["purple-square","love","like"],sheet:[25,5]},heavy_heart_exclamation_mark_ornament:{name:"Heavy Heart Exclamation Mark Ornament",unified:"2763-FE0F",non_qualified:"2763",added_in:"1.1",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,sheet:[50,7]},love_letter:{name:"Love Letter",unified:"1F48C",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["email","like","affection","envelope","valentines"],sheet:[24,38]},zzz:{name:"Sleeping Symbol",unified:"1F4A4",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["sleepy","tired","dream"],sheet:[25,10]},anger:{name:"Anger Symbol",unified:"1F4A2",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["angry","mad"],sheet:[25,8]},bomb:{name:"Bomb",unified:"1F4A3",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["boom","explode","explosion","terrorism"],sheet:[25,9]},boom:{name:"Collision Symbol",unified:"1F4A5",non_qualified:null,short_names:["collision"],has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["bomb","explode","explosion","collision","blown"],sheet:[25,11]},sweat_drops:{name:"Splashing Sweat Symbol",unified:"1F4A6",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["water","drip","oops"],sheet:[25,12]},dash:{name:"Dash Symbol",unified:"1F4A8",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["wind","air","fast","shoo","fart","smoke","puff"],sheet:[25,14]},dizzy:{name:"Dizzy Symbol",unified:"1F4AB",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["star","sparkle","shoot","magic"],sheet:[25,22]},speech_balloon:{name:"Speech Balloon",unified:"1F4AC",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["bubble","words","message","talk","chatting"],sheet:[25,23]},left_speech_bubble:{name:"Left Speech Bubble",unified:"1F5E8-FE0F",non_qualified:"1F5E8",added_in:"7.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,keywords:["words","message","talk","chatting"],sheet:[30,15]},right_anger_bubble:{name:"Right Anger Bubble",unified:"1F5EF-FE0F",non_qualified:"1F5EF",added_in:"7.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,keywords:["caption","speech","thinking","mad"],sheet:[30,16]},thought_balloon:{name:"Thought Balloon",unified:"1F4AD",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["bubble","cloud","speech","thinking","dream"],sheet:[25,24]},hole:{name:"Hole",unified:"1F573-FE0F",non_qualified:"1F573",added_in:"7.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,keywords:["embarrassing"],sheet:[28,44]},eyeglasses:{name:"Eyeglasses",unified:"1F453",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["fashion","accessories","eyesight","nerdy","dork","geek"],sheet:[15,23]},dark_sunglasses:{name:"Dark Sunglasses",unified:"1F576-FE0F",non_qualified:"1F576",added_in:"7.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,keywords:["face","cool","accessories"],sheet:[29,17]},necktie:{name:"Necktie",unified:"1F454",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["shirt","suitup","formal","fashion","cloth","business"],sheet:[15,24]},shirt:{name:"T-Shirt",unified:"1F455",non_qualified:null,short_names:["tshirt"],has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,sheet:[15,25]},jeans:{name:"Jeans",unified:"1F456",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["fashion","shopping"],sheet:[15,26]},scarf:{name:"Scarf",unified:"1F9E3",non_qualified:null,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,keywords:["neck","winter","clothes"],sheet:[46,25]},gloves:{name:"Gloves",unified:"1F9E4",non_qualified:null,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,keywords:["hands","winter","clothes"],sheet:[46,26]},coat:{name:"Coat",unified:"1F9E5",non_qualified:null,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,keywords:["jacket"],sheet:[46,27]},socks:{name:"Socks",unified:"1F9E6",non_qualified:null,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,keywords:["stockings","clothes"],sheet:[46,28]},dress:{name:"Dress",unified:"1F457",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["clothes","fashion","shopping"],sheet:[15,27]},kimono:{name:"Kimono",unified:"1F458",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["dress","fashion","women","female","japanese"],sheet:[15,28]},bikini:{name:"Bikini",unified:"1F459",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["swimming","female","woman","girl","fashion","beach","summer"],sheet:[15,29]},womans_clothes:{name:"Womans Clothes",unified:"1F45A",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["fashion","shopping_bags","female"],sheet:[15,30]},purse:{name:"Purse",unified:"1F45B",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["fashion","accessories","money","sales","shopping"],sheet:[15,31]},handbag:{name:"Handbag",unified:"1F45C",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["fashion","accessory","accessories","shopping"],sheet:[15,32]},pouch:{name:"Pouch",unified:"1F45D",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["bag","accessories","shopping"],sheet:[15,33]},shopping_bags:{name:"Shopping Bags",unified:"1F6CD-FE0F",non_qualified:"1F6CD",added_in:"7.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,sheet:[37,2]},school_satchel:{name:"School Satchel",unified:"1F392",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["student","education","bag","backpack"],sheet:[8,37]},mans_shoe:{name:"Mans Shoe",unified:"1F45E",non_qualified:null,short_names:["shoe"],has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["fashion","male"],sheet:[15,34]},athletic_shoe:{name:"Athletic Shoe",unified:"1F45F",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["shoes","sports","sneakers"],sheet:[15,35]},high_heel:{name:"High-Heeled Shoe",unified:"1F460",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["fashion","shoes","female","pumps","stiletto"],sheet:[15,36]},sandal:{name:"Womans Sandal",unified:"1F461",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["shoes","fashion","flip flops"],sheet:[15,37]},boot:{name:"Womans Boots",unified:"1F462",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["shoes","fashion"],sheet:[15,38]},crown:{name:"Crown",unified:"1F451",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["king","kod","leader","royalty","lord"],sheet:[15,21]},womans_hat:{name:"Womans Hat",unified:"1F452",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["fashion","accessories","female","lady","spring"],sheet:[15,22]},tophat:{name:"Top Hat",unified:"1F3A9",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["magic","gentleman","classy","circus"],sheet:[9,3]},mortar_board:{name:"Graduation Cap",unified:"1F393",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["school","college","degree","university","graduation","cap","hat","legal","learn","education"],sheet:[8,38]},billed_cap:{name:"Billed Cap",unified:"1F9E2",non_qualified:null,added_in:"10.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,sheet:[46,24]},helmet_with_white_cross:{name:"Helmet with White Cross",unified:"26D1-FE0F",non_qualified:"26D1",added_in:"5.2",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:false,has_img_facebook:true,has_img_messenger:false,sheet:[48,33]},prayer_beads:{name:"Prayer Beads",unified:"1F4FF",non_qualified:null,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false,keywords:["dhikr","religious"],sheet:[27,1]},lipstick:{name:"Lipstick",unified:"1F484",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["female","girl","fashion","woman"],sheet:[23,43]},ring:{name:"Ring",unified:"1F48D",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["wedding","propose","marriage","valentines","diamond","fashion","jewelry","gem","engagement"],sheet:[24,39]},gem:{name:"Gem Stone",unified:"1F48E",non_qualified:null,has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:true,keywords:["blue","ruby","diamond","jewelry"],sheet:[24,40]}},skins:{"skin-tone-2":{name:"Emoji Modifier Fitzpatrick Type-1-2",unified:"1F3FB",non_qualified:null,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false,sheet:[12,25]},"skin-tone-3":{name:"Emoji Modifier Fitzpatrick Type-3",unified:"1F3FC",non_qualified:null,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false,sheet:[12,26]},"skin-tone-4":{name:"Emoji Modifier Fitzpatrick Type-4",unified:"1F3FD",non_qualified:null,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false,sheet:[12,27]},"skin-tone-5":{name:"Emoji Modifier Fitzpatrick Type-5",unified:"1F3FE",non_qualified:null,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false,sheet:[12,28]},"skin-tone-6":{name:"Emoji Modifier Fitzpatrick Type-6",unified:"1F3FF",non_qualified:null,added_in:"8.0",has_img_apple:true,has_img_google:true,has_img_twitter:true,has_img_emojione:true,has_img_facebook:true,has_img_messenger:false,sheet:[12,29]}},short_names:{satisfied:"laughing",grinning_face_with_star_eyes:"star-struck",face_with_one_eyebrow_raised:"face_with_raised_eyebrow",telephone:"phone",cooking:"fried_egg",paw_prints:"feet","flag-cn":"cn",lantern:"izakaya_lantern",shocked_face_with_exploding_head:"exploding_head",open_book:"book","flag-de":"de",grinning_face_with_one_large_and_one_small_eye:"zany_face",serious_face_with_symbols_covering_mouth:"face_with_symbols_on_mouth",flipper:"dolphin",face_with_open_mouth_vomiting:"face_vomiting","flag-es":"es",face_with_finger_covering_closed_lips:"shushing_face",smiling_face_with_smiling_eyes_and_hand_covering_mouth:"face_with_hand_over_mouth","flag-fr":"fr",honeybee:"bee",red_car:"car",envelope:"email",uk:"gb","flag-gb":"gb",poop:"hankey",shit:"hankey",staff_of_aesculapius:"medical_symbol",knife:"hocho",sailboat:"boat",pencil:"memo","flag-it":"it","flag-jp":"jp",heavy_exclamation_mark:"exclamation","flag-kr":"kr",waxing_gibbous_moon:"moon",mother_christmas:"mrs_claus",sun_small_cloud:"mostly_sunny",sun_behind_cloud:"barely_sunny",sun_behind_rain_cloud:"partly_sunny_rain",lightning_cloud:"lightning",tornado_cloud:"tornado","flag-ru":"ru",running:"runner","flag-us":"us",man_and_woman_holding_hands:"couple","man-woman-boy":"family",family:"man-woman-boy",reversed_hand_with_middle_finger_extended:"middle_finger",hand_with_index_and_middle_fingers_crossed:"crossed_fingers",sign_of_the_horns:"the_horns",raised_hand:"hand",thumbsup:"+1",thumbsdown:"-1",punch:"facepunch",collision:"boom",tshirt:"shirt",shoe:"mans_shoe"}};

	/***/ }),
	/* 82 */
	/***/ (function(module, exports, __webpack_require__) {


	exports.__esModule = true;

	var _iterator = __webpack_require__(83);

	var _iterator2 = _interopRequireDefault(_iterator);

	var _symbol = __webpack_require__(96);

	var _symbol2 = _interopRequireDefault(_symbol);

	var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
	  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
	} : function (obj) {
	  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
	};

	/***/ }),
	/* 83 */
	/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(84), __esModule: true };

	/***/ }),
	/* 84 */
	/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(24);
	__webpack_require__(54);
	module.exports = __webpack_require__(34).f('iterator');


	/***/ }),
	/* 85 */
	/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(25);
	var defined = __webpack_require__(26);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) { return TO_STRING ? '' : undefined; }
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};


	/***/ }),
	/* 86 */
	/***/ (function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') { throw TypeError(it + ' is not a function!'); }
	  return it;
	};


	/***/ }),
	/* 87 */
	/***/ (function(module, exports, __webpack_require__) {

	var create = __webpack_require__(50);
	var descriptor = __webpack_require__(16);
	var setToStringTag = __webpack_require__(33);
	var IteratorPrototype = {};

	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(8)(IteratorPrototype, __webpack_require__(2)('iterator'), function () { return this; });

	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};


	/***/ }),
	/* 88 */
	/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(6);
	var anObject = __webpack_require__(9);
	var getKeys = __webpack_require__(18);

	module.exports = __webpack_require__(10) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) { dP.f(O, P = keys[i++], Properties[P]); }
	  return O;
	};


	/***/ }),
	/* 89 */
	/***/ (function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(12);
	var toLength = __webpack_require__(53);
	var toAbsoluteIndex = __webpack_require__(90);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) { while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) { return true; }
	    // Array#indexOf ignores holes, Array#includes - not
	    } } else { for (;length > index; index++) { if (IS_INCLUDES || index in O) {
	      if (O[index] === el) { return IS_INCLUDES || index || 0; }
	    } } } return !IS_INCLUDES && -1;
	  };
	};


	/***/ }),
	/* 90 */
	/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(25);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


	/***/ }),
	/* 91 */
	/***/ (function(module, exports, __webpack_require__) {

	var document = __webpack_require__(4).document;
	module.exports = document && document.documentElement;


	/***/ }),
	/* 92 */
	/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__(7);
	var toObject = __webpack_require__(22);
	var IE_PROTO = __webpack_require__(30)('IE_PROTO');
	var ObjectProto = Object.prototype;

	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) { return O[IE_PROTO]; }
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};


	/***/ }),
	/* 93 */
	/***/ (function(module, exports, __webpack_require__) {

	var addToUnscopables = __webpack_require__(94);
	var step = __webpack_require__(95);
	var Iterators = __webpack_require__(17);
	var toIObject = __webpack_require__(12);

	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(45)(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') { return step(0, index); }
	  if (kind == 'values') { return step(0, O[index]); }
	  return step(0, [index, O[index]]);
	}, 'values');

	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;

	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');


	/***/ }),
	/* 94 */
	/***/ (function(module, exports) {

	module.exports = function () { /* empty */ };


	/***/ }),
	/* 95 */
	/***/ (function(module, exports) {

	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};


	/***/ }),
	/* 96 */
	/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(97), __esModule: true };

	/***/ }),
	/* 97 */
	/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(98);
	__webpack_require__(104);
	__webpack_require__(105);
	__webpack_require__(106);
	module.exports = __webpack_require__(3).Symbol;


	/***/ }),
	/* 98 */
	/***/ (function(module, exports, __webpack_require__) {

	// ECMAScript 6 symbols shim
	var global = __webpack_require__(4);
	var has = __webpack_require__(7);
	var DESCRIPTORS = __webpack_require__(10);
	var $export = __webpack_require__(14);
	var redefine = __webpack_require__(49);
	var META = __webpack_require__(99).KEY;
	var $fails = __webpack_require__(11);
	var shared = __webpack_require__(31);
	var setToStringTag = __webpack_require__(33);
	var uid = __webpack_require__(21);
	var wks = __webpack_require__(2);
	var wksExt = __webpack_require__(34);
	var wksDefine = __webpack_require__(35);
	var enumKeys = __webpack_require__(100);
	var isArray = __webpack_require__(101);
	var anObject = __webpack_require__(9);
	var isObject = __webpack_require__(15);
	var toIObject = __webpack_require__(12);
	var toPrimitive = __webpack_require__(28);
	var createDesc = __webpack_require__(16);
	var _create = __webpack_require__(50);
	var gOPNExt = __webpack_require__(102);
	var $GOPD = __webpack_require__(103);
	var $DP = __webpack_require__(6);
	var $keys = __webpack_require__(18);
	var gOPD = $GOPD.f;
	var dP = $DP.f;
	var gOPN = gOPNExt.f;
	var $Symbol = global.Symbol;
	var $JSON = global.JSON;
	var _stringify = $JSON && $JSON.stringify;
	var PROTOTYPE = 'prototype';
	var HIDDEN = wks('_hidden');
	var TO_PRIMITIVE = wks('toPrimitive');
	var isEnum = {}.propertyIsEnumerable;
	var SymbolRegistry = shared('symbol-registry');
	var AllSymbols = shared('symbols');
	var OPSymbols = shared('op-symbols');
	var ObjectProto = Object[PROTOTYPE];
	var USE_NATIVE = typeof $Symbol == 'function';
	var QObject = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function () {
	  return _create(dP({}, 'a', {
	    get: function () { return dP(this, 'a', { value: 7 }).a; }
	  })).a != 7;
	}) ? function (it, key, D) {
	  var protoDesc = gOPD(ObjectProto, key);
	  if (protoDesc) { delete ObjectProto[key]; }
	  dP(it, key, D);
	  if (protoDesc && it !== ObjectProto) { dP(ObjectProto, key, protoDesc); }
	} : dP;

	var wrap = function (tag) {
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};

	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
	  return typeof it == 'symbol';
	} : function (it) {
	  return it instanceof $Symbol;
	};

	var $defineProperty = function defineProperty(it, key, D) {
	  if (it === ObjectProto) { $defineProperty(OPSymbols, key, D); }
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if (has(AllSymbols, key)) {
	    if (!D.enumerable) {
	      if (!has(it, HIDDEN)) { dP(it, HIDDEN, createDesc(1, {})); }
	      it[HIDDEN][key] = true;
	    } else {
	      if (has(it, HIDDEN) && it[HIDDEN][key]) { it[HIDDEN][key] = false; }
	      D = _create(D, { enumerable: createDesc(0, false) });
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P) {
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P));
	  var i = 0;
	  var l = keys.length;
	  var key;
	  while (l > i) { $defineProperty(it, key = keys[i++], P[key]); }
	  return it;
	};
	var $create = function create(it, P) {
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key) {
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) { return false; }
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
	  it = toIObject(it);
	  key = toPrimitive(key, true);
	  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) { return; }
	  var D = gOPD(it, key);
	  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) { D.enumerable = true; }
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it) {
	  var names = gOPN(toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) { result.push(key); }
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
	  var IS_OP = it === ObjectProto;
	  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) { result.push(AllSymbols[key]); }
	  } return result;
	};

	// 19.4.1.1 Symbol([description])
	if (!USE_NATIVE) {
	  $Symbol = function Symbol() {
	    if (this instanceof $Symbol) { throw TypeError('Symbol is not a constructor!'); }
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function (value) {
	      if (this === ObjectProto) { $set.call(OPSymbols, value); }
	      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) { this[HIDDEN][tag] = false; }
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if (DESCRIPTORS && setter) { setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set }); }
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
	    return this._k;
	  });

	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f = $defineProperty;
	  __webpack_require__(55).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(23).f = $propertyIsEnumerable;
	  __webpack_require__(36).f = $getOwnPropertySymbols;

	  if (DESCRIPTORS && !__webpack_require__(27)) {
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }

	  wksExt.f = function (name) {
	    return wrap(wks(name));
	  };
	}

	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

	for (var es6Symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), j = 0; es6Symbols.length > j;){ wks(es6Symbols[j++]); }

	for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) { wksDefine(wellKnownSymbols[k++]); }

	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function (key) {
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(sym) {
	    if (!isSymbol(sym)) { throw TypeError(sym + ' is not a symbol!'); }
	    for (var key in SymbolRegistry) { if (SymbolRegistry[key] === sym) { return key; } }
	  },
	  useSetter: function () { setter = true; },
	  useSimple: function () { setter = false; }
	});

	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});

	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it) {
	    var arguments$1 = arguments;

	    var args = [it];
	    var i = 1;
	    var replacer, $replacer;
	    while (arguments.length > i) { args.push(arguments$1[i++]); }
	    $replacer = replacer = args[1];
	    if (!isObject(replacer) && it === undefined || isSymbol(it)) { return; } // IE8 returns string on undefined
	    if (!isArray(replacer)) { replacer = function (key, value) {
	      if (typeof $replacer == 'function') { value = $replacer.call(this, key, value); }
	      if (!isSymbol(value)) { return value; }
	    }; }
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});

	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(8)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);


	/***/ }),
	/* 99 */
	/***/ (function(module, exports, __webpack_require__) {

	var META = __webpack_require__(21)('meta');
	var isObject = __webpack_require__(15);
	var has = __webpack_require__(7);
	var setDesc = __webpack_require__(6).f;
	var id = 0;
	var isExtensible = Object.isExtensible || function () {
	  return true;
	};
	var FREEZE = !__webpack_require__(11)(function () {
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function (it) {
	  setDesc(it, META, { value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  } });
	};
	var fastKey = function (it, create) {
	  // return primitive with prefix
	  if (!isObject(it)) { return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it; }
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) { return 'F'; }
	    // not necessary to add metadata
	    if (!create) { return 'E'; }
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function (it, create) {
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) { return true; }
	    // not necessary to add metadata
	    if (!create) { return false; }
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function (it) {
	  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) { setMeta(it); }
	  return it;
	};
	var meta = module.exports = {
	  KEY: META,
	  NEED: false,
	  fastKey: fastKey,
	  getWeak: getWeak,
	  onFreeze: onFreeze
	};


	/***/ }),
	/* 100 */
	/***/ (function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(18);
	var gOPS = __webpack_require__(36);
	var pIE = __webpack_require__(23);
	module.exports = function (it) {
	  var result = getKeys(it);
	  var getSymbols = gOPS.f;
	  if (getSymbols) {
	    var symbols = getSymbols(it);
	    var isEnum = pIE.f;
	    var i = 0;
	    var key;
	    while (symbols.length > i) { if (isEnum.call(it, key = symbols[i++])) { result.push(key); } }
	  } return result;
	};


	/***/ }),
	/* 101 */
	/***/ (function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(29);
	module.exports = Array.isArray || function isArray(arg) {
	  return cof(arg) == 'Array';
	};


	/***/ }),
	/* 102 */
	/***/ (function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(12);
	var gOPN = __webpack_require__(55).f;
	var toString = {}.toString;

	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];

	var getWindowNames = function (it) {
	  try {
	    return gOPN(it);
	  } catch (e) {
	    return windowNames.slice();
	  }
	};

	module.exports.f = function getOwnPropertyNames(it) {
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


	/***/ }),
	/* 103 */
	/***/ (function(module, exports, __webpack_require__) {

	var pIE = __webpack_require__(23);
	var createDesc = __webpack_require__(16);
	var toIObject = __webpack_require__(12);
	var toPrimitive = __webpack_require__(28);
	var has = __webpack_require__(7);
	var IE8_DOM_DEFINE = __webpack_require__(47);
	var gOPD = Object.getOwnPropertyDescriptor;

	exports.f = __webpack_require__(10) ? gOPD : function getOwnPropertyDescriptor(O, P) {
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if (IE8_DOM_DEFINE) { try {
	    return gOPD(O, P);
	  } catch (e) { /* empty */ } }
	  if (has(O, P)) { return createDesc(!pIE.f.call(O, P), O[P]); }
	};


	/***/ }),
	/* 104 */
	/***/ (function(module, exports) {



	/***/ }),
	/* 105 */
	/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(35)('asyncIterator');


	/***/ }),
	/* 106 */
	/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(35)('observable');


	/***/ }),
	/* 107 */
	/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(108), __esModule: true };

	/***/ }),
	/* 108 */
	/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(109);
	module.exports = __webpack_require__(3).Object.keys;


	/***/ }),
	/* 109 */
	/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(22);
	var $keys = __webpack_require__(18);

	__webpack_require__(110)('keys', function () {
	  return function keys(it) {
	    return $keys(toObject(it));
	  };
	});


	/***/ }),
	/* 110 */
	/***/ (function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(14);
	var core = __webpack_require__(3);
	var fails = __webpack_require__(11);
	module.exports = function (KEY, exec) {
	  var fn = (core.Object || {})[KEY] || Object[KEY];
	  var exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
	};


	/***/ }),
	/* 111 */
	/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(112);
	module.exports = __webpack_require__(3).Object.assign;


	/***/ }),
	/* 112 */
	/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(14);

	$export($export.S + $export.F, 'Object', { assign: __webpack_require__(113) });


	/***/ }),
	/* 113 */
	/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.1 Object.assign(target, source, ...)
	var getKeys = __webpack_require__(18);
	var gOPS = __webpack_require__(36);
	var pIE = __webpack_require__(23);
	var toObject = __webpack_require__(22);
	var IObject = __webpack_require__(52);
	var $assign = Object.assign;

	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(11)(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) { B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) {
	  var arguments$1 = arguments;
	 // eslint-disable-line no-unused-vars
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments$1[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) { if (isEnum.call(S, key = keys[j++])) { T[key] = S[key]; } }
	  } return T;
	} : $assign;


	/***/ }),
	/* 114 */
	/***/ (function(module, exports, __webpack_require__) {


	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var _String = String;

	exports.default = _String.fromCodePoint || function stringFromCodePoint() {
	  var arguments$1 = arguments;

	  var MAX_SIZE = 0x4000;
	  var codeUnits = [];
	  var highSurrogate;
	  var lowSurrogate;
	  var index = -1;
	  var length = arguments.length;
	  if (!length) {
	    return '';
	  }
	  var result = '';
	  while (++index < length) {
	    var codePoint = Number(arguments$1[index]);
	    if (!isFinite(codePoint) || // `NaN`, `+Infinity`, or `-Infinity`
	    codePoint < 0 || // not a valid Unicode code point
	    codePoint > 0x10ffff || // not a valid Unicode code point
	    Math.floor(codePoint) != codePoint // not an integer
	    ) {
	        throw RangeError('Invalid code point: ' + codePoint);
	      }
	    if (codePoint <= 0xffff) {
	      // BMP code point
	      codeUnits.push(codePoint);
	    } else {
	      // Astral code point; split in surrogate halves
	      // http://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
	      codePoint -= 0x10000;
	      highSurrogate = (codePoint >> 10) + 0xd800;
	      lowSurrogate = codePoint % 0x400 + 0xdc00;
	      codeUnits.push(highSurrogate, lowSurrogate);
	    }
	    if (index + 1 === length || codeUnits.length > MAX_SIZE) {
	      result += String.fromCharCode.apply(null, codeUnits);
	      codeUnits.length = 0;
	    }
	  }
	  return result;
	};

	/***/ }),
	/* 115 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	var render = function() {
	  var _vm = this;
	  var _h = _vm.$createElement;
	  var _c = _vm._self._c || _h;
	  return _c(
	    "span",
	    {
	      staticClass: "emoji-mart-emoji",
	      on: {
	        mouseenter: _vm.onMouseEnter,
	        mouseleave: _vm.onMouseLeave,
	        click: _vm.onClick
	      }
	    },
	    [
	      _vm.isCustom
	        ? _c("span", {
	            style: _vm.customEmojiStyles,
	            attrs: { title: _vm.title }
	          })
	        : _vm.isNative
	          ? _c(
	              "span",
	              { style: _vm.nativeEmojiStyles, attrs: { title: _vm.title } },
	              [_vm._v(_vm._s(_vm.nativeEmoji))]
	            )
	          : _vm.hasEmoji
	            ? _c("span", {
	                style: _vm.fallbackEmojiStyles,
	                attrs: { title: _vm.title }
	              })
	            : _c("span", [_vm._v(_vm._s(_vm.fallbackEmoji))])
	    ]
	  )
	};
	var staticRenderFns = [];
	render._withStripped = true;
	var esExports = { render: render, staticRenderFns: staticRenderFns };
	/* harmony default export */ __webpack_exports__["a"] = (esExports);

	/***/ }),
	/* 116 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	var render = function() {
	  var _vm = this;
	  var _h = _vm.$createElement;
	  var _c = _vm._self._c || _h;
	  return _vm.isVisible && (_vm.isSearch || _vm.hasResults)
	    ? _c(
	        "div",
	        {
	          class: {
	            "emoji-mart-category": true,
	            "emoji-mart-no-results": !_vm.hasResults
	          }
	        },
	        [
	          _c("div", { staticClass: "emoji-mart-category-label" }, [
	            _c("span", [_vm._v(_vm._s(_vm.i18n.categories[_vm.id]))])
	          ]),
	          _vm._v(" "),
	          _vm._l(_vm.emojis, function(emoji) {
	            return _c("emoji", {
	              key: emoji.id || emoji,
	              attrs: {
	                emoji: emoji,
	                native: _vm.emojiProps.native,
	                skin: _vm.emojiProps.skin,
	                set: _vm.emojiProps.set,
	                size: _vm.emojiProps.size,
	                "sheet-size": _vm.emojiProps.sheetSize,
	                "force-size": _vm.emojiProps.forceSize,
	                tooltip: _vm.emojiProps.tooltip,
	                "background-image-fn": _vm.emojiProps.backgroundImageFn
	              },
	              on: {
	                click: _vm.emojiProps.onClick,
	                mouseenter: _vm.emojiProps.onEnter,
	                mouseleave: _vm.emojiProps.onLeave
	              }
	            })
	          }),
	          _vm._v(" "),
	          !_vm.hasResults
	            ? _c(
	                "div",
	                [
	                  _c("emoji", {
	                    attrs: {
	                      size: _vm.emojiProps.size,
	                      emoji: "sleuth_or_spy",
	                      native: _vm.emojiProps.native,
	                      skin: _vm.emojiProps.skin,
	                      set: _vm.emojiProps.set,
	                      "sheet-size": _vm.emojiProps.sheetSize,
	                      "background-image-fn": _vm.emojiProps.backgroundImageFn
	                    }
	                  }),
	                  _vm._v(" "),
	                  _c("div", { staticClass: "emoji-mart-no-results-label" }, [
	                    _vm._v(_vm._s(_vm.i18n.notfound))
	                  ])
	                ],
	                1
	              )
	            : _vm._e()
	        ],
	        2
	      )
	    : _vm._e()
	};
	var staticRenderFns = [];
	render._withStripped = true;
	var esExports = { render: render, staticRenderFns: staticRenderFns };
	/* harmony default export */ __webpack_exports__["a"] = (esExports);

	/***/ }),
	/* 117 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_picker_vue__ = __webpack_require__(57);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_picker_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_picker_vue__);
	/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_picker_vue__) { if(__WEBPACK_IMPORT_KEY__ !== 'default') { (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_picker_vue__[key]; }); }(__WEBPACK_IMPORT_KEY__)); } }
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2076db9e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_picker_vue__ = __webpack_require__(145);
	var disposed = false;
	function injectStyle (ssrContext) {
	  if (disposed) { return }
	  __webpack_require__(118);
	  __webpack_require__(120);
	}
	var normalizeComponent = __webpack_require__(5);
	/* script */


	/* template */

	/* template functional */
	var __vue_template_functional__ = false;
	/* styles */
	var __vue_styles__ = injectStyle;
	/* scopeId */
	var __vue_scopeId__ = "data-v-2076db9e";
	/* moduleIdentifier (server only) */
	var __vue_module_identifier__ = null;
	var Component = normalizeComponent(
	  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_picker_vue___default.a,
	  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2076db9e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_picker_vue__["a" /* default */],
	  __vue_template_functional__,
	  __vue_styles__,
	  __vue_scopeId__,
	  __vue_module_identifier__
	);
	Component.options.__file = "src/components/picker.vue";

	/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


	/***/ }),
	/* 118 */
	/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(119);
	if(typeof content === 'string') { content = [[module.i, content, '']]; }
	if(content.locals) { module.exports = content.locals; }
	// add the styles to the DOM
	var update = __webpack_require__(1)("3bbd9804", content, false, {});

	/***/ }),
	/* 119 */
	/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(0)(false);
	// imports


	// module
	exports.push([module.i, "\n.emoji-mart,\n.emoji-mart * {\n  box-sizing: border-box;\n  line-height: 1.15;\n}\n.emoji-mart .emoji-mart-emoji {\n  padding: 6px;\n}\n\n", ""]);

	// exports


	/***/ }),
	/* 120 */
	/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(121);
	if(typeof content === 'string') { content = [[module.i, content, '']]; }
	if(content.locals) { module.exports = content.locals; }
	// add the styles to the DOM
	var update = __webpack_require__(1)("726aa66c", content, false, {});

	/***/ }),
	/* 121 */
	/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(0)(false);
	// imports


	// module
	exports.push([module.i, "\n.emoji-mart[data-v-2076db9e] {\n  font-family: -apple-system, BlinkMacSystemFont, \"Helvetica Neue\", sans-serif;\n  font-size: 16px;\n  display: flex;\n  flex-direction: column;\n  height: 420px;\n  color: #222427;\n  border: 1px solid #d9d9d9;\n  border-radius: 5px;\n  background: #fff;\n}\n.emoji-mart-bar[data-v-2076db9e] {\n  flex: 0;\n  border: 0 solid #d9d9d9;\n}\n.emoji-mart-bar[data-v-2076db9e]:first-child {\n  border-bottom-width: 1px;\n  border-top-left-radius: 5px;\n  border-top-right-radius: 5px;\n}\n.emoji-mart-bar[data-v-2076db9e]:last-child {\n  border-top-width: 1px;\n  border-bottom-left-radius: 5px;\n  border-bottom-right-radius: 5px;\n}\n.emoji-mart-search[data-v-2076db9e] {\n  flex: 0;\n}\n.emoji-mart-scroll[data-v-2076db9e] {\n  position: relative;\n  overflow-y: scroll;\n  flex: 1;\n  padding: 0 6px 6px 6px;\n  z-index: 0; /* Fix for rendering sticky positioned category labels on Chrome */\n  will-change: transform; /* avoids \"repaints on scroll\" in mobile Chrome */\n  -webkit-overflow-scrolling: touch;\n}\n\n", ""]);

	// exports


	/***/ }),
	/* 122 */
	/***/ (function(module, exports, __webpack_require__) {


	exports.__esModule = true;

	var _from = __webpack_require__(123);

	var _from2 = _interopRequireDefault(_from);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = function (arr) {
	  if (Array.isArray(arr)) {
	    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
	      arr2[i] = arr[i];
	    }

	    return arr2;
	  } else {
	    return (0, _from2.default)(arr);
	  }
	};

	/***/ }),
	/* 123 */
	/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(124), __esModule: true };

	/***/ }),
	/* 124 */
	/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(24);
	__webpack_require__(125);
	module.exports = __webpack_require__(3).Array.from;


	/***/ }),
	/* 125 */
	/***/ (function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(46);
	var $export = __webpack_require__(14);
	var toObject = __webpack_require__(22);
	var call = __webpack_require__(126);
	var isArrayIter = __webpack_require__(127);
	var toLength = __webpack_require__(53);
	var createProperty = __webpack_require__(128);
	var getIterFn = __webpack_require__(58);

	$export($export.S + $export.F * !__webpack_require__(130)(function (iter) { }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
	    var O = toObject(arrayLike);
	    var C = typeof this == 'function' ? this : Array;
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var index = 0;
	    var iterFn = getIterFn(O);
	    var length, result, step, iterator;
	    if (mapping) { mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2); }
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
	      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
	        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
	      }
	    } else {
	      length = toLength(O.length);
	      for (result = new C(length); length > index; index++) {
	        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});


	/***/ }),
	/* 126 */
	/***/ (function(module, exports, __webpack_require__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(9);
	module.exports = function (iterator, fn, value, entries) {
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch (e) {
	    var ret = iterator['return'];
	    if (ret !== undefined) { anObject(ret.call(iterator)); }
	    throw e;
	  }
	};


	/***/ }),
	/* 127 */
	/***/ (function(module, exports, __webpack_require__) {

	// check on default Array iterator
	var Iterators = __webpack_require__(17);
	var ITERATOR = __webpack_require__(2)('iterator');
	var ArrayProto = Array.prototype;

	module.exports = function (it) {
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};


	/***/ }),
	/* 128 */
	/***/ (function(module, exports, __webpack_require__) {

	var $defineProperty = __webpack_require__(6);
	var createDesc = __webpack_require__(16);

	module.exports = function (object, index, value) {
	  if (index in object) { $defineProperty.f(object, index, createDesc(0, value)); }
	  else { object[index] = value; }
	};


	/***/ }),
	/* 129 */
	/***/ (function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(29);
	var TAG = __webpack_require__(2)('toStringTag');
	// ES3 wrong here
	var ARG = cof(function () { return arguments; }()) == 'Arguments';

	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (e) { /* empty */ }
	};

	module.exports = function (it) {
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};


	/***/ }),
	/* 130 */
	/***/ (function(module, exports, __webpack_require__) {

	var ITERATOR = __webpack_require__(2)('iterator');
	var SAFE_CLOSING = false;

	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function () { SAFE_CLOSING = true; };
	} catch (e) { /* empty */ }

	module.exports = function (exec, skipClosing) {
	  if (!skipClosing && !SAFE_CLOSING) { return false; }
	  var safe = false;
	  try {
	    var arr = [7];
	    var iter = arr[ITERATOR]();
	    iter.next = function () { return { done: safe = true }; };
	    arr[ITERATOR] = function () { return iter; };
	    exec(arr);
	  } catch (e) { /* empty */ }
	  return safe;
	};


	/***/ }),
	/* 131 */
	/***/ (function(module, exports, __webpack_require__) {


	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var _Object = Object;

	exports.default = _Object.assign || function (target) {
	  var arguments$1 = arguments;

	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments$1[i];

	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }

	  return target;
	};

	/***/ }),
	/* 132 */
	/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(133), __esModule: true };

	/***/ }),
	/* 133 */
	/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(54);
	__webpack_require__(24);
	module.exports = __webpack_require__(134);


	/***/ }),
	/* 134 */
	/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(9);
	var get = __webpack_require__(58);
	module.exports = __webpack_require__(3).getIterator = function (it) {
	  var iterFn = get(it);
	  if (typeof iterFn != 'function') { throw TypeError(it + ' is not iterable!'); }
	  return anObject(iterFn.call(it));
	};


	/***/ }),
	/* 135 */
	/***/ (function(module, exports, __webpack_require__) {


	// http://paulirish.com/2011/requestanimationframe-for-smart-animating/
	// http://my.opera.com/emoller/blog/2011/12/20/requestanimationframe-for-smart-er-animating

	// requestAnimationFrame polyfill by Erik Möller. fixes from Paul Irish and Tino Zijdel

	// MIT license

	var isWindowAvailable = typeof window !== 'undefined';

	isWindowAvailable && function () {
	  var lastTime = 0;
	  var vendors = ['ms', 'moz', 'webkit', 'o'];

	  for (var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
	    window.requestAnimationFrame = window[vendors[x] + 'RequestAnimationFrame'];
	    window.cancelAnimationFrame = window[vendors[x] + 'CancelAnimationFrame'] || window[vendors[x] + 'CancelRequestAnimationFrame'];
	  }

	  if (!window.requestAnimationFrame) { window.requestAnimationFrame = function (callback, element) {
	    var currTime = new Date().getTime();
	    var timeToCall = Math.max(0, 16 - (currTime - lastTime));
	    var id = window.setTimeout(function () {
	      callback(currTime + timeToCall);
	    }, timeToCall);

	    lastTime = currTime + timeToCall;
	    return id;
	  }; }

	  if (!window.cancelAnimationFrame) { window.cancelAnimationFrame = function (id) {
	    clearTimeout(id);
	  }; }
	}();

	/***/ }),
	/* 136 */
	/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(137);
	if(typeof content === 'string') { content = [[module.i, content, '']]; }
	if(content.locals) { module.exports = content.locals; }
	// add the styles to the DOM
	var update = __webpack_require__(1)("648f661a", content, false, {});

	/***/ }),
	/* 137 */
	/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(0)(false);
	// imports


	// module
	exports.push([module.i, "\n.emoji-mart-preview[data-v-35056c30] {\n  position: relative;\n  height: 70px;\n}\n.emoji-mart-preview-emoji[data-v-35056c30],\n.emoji-mart-preview-data[data-v-35056c30],\n.emoji-mart-preview-skins[data-v-35056c30] {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n}\n.emoji-mart-preview-emoji[data-v-35056c30] {\n  left: 12px;\n}\n.emoji-mart-preview-data[data-v-35056c30] {\n  left: 68px; right: 12px;\n  word-break: break-all;\n}\n.emoji-mart-preview-skins[data-v-35056c30] {\n  right: 30px;\n  text-align: right;\n}\n.emoji-mart-preview-name[data-v-35056c30] {\n  font-size: 14px;\n}\n.emoji-mart-preview-shortname[data-v-35056c30] {\n  font-size: 12px;\n  color: #888;\n}\n.emoji-mart-preview-shortname + .emoji-mart-preview-shortname[data-v-35056c30],\n.emoji-mart-preview-shortname + .emoji-mart-preview-emoticon[data-v-35056c30],\n.emoji-mart-preview-emoticon + .emoji-mart-preview-emoticon[data-v-35056c30] {\n  margin-left: .5em;\n}\n.emoji-mart-preview-emoticon[data-v-35056c30] {\n  font-size: 11px;\n  color: #bbb;\n}\n.emoji-mart-title span[data-v-35056c30] {\n  display: inline-block;\n  vertical-align: middle;\n}\n.emoji-mart-title .emoji-mart-emoji[data-v-35056c30] {\n  padding: 0;\n}\n.emoji-mart-title-label[data-v-35056c30] {\n  color: #999A9C;\n  font-size: 21px;\n  font-weight: 300;\n}\n\n", ""]);

	// exports


	/***/ }),
	/* 138 */
	/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(139);
	if(typeof content === 'string') { content = [[module.i, content, '']]; }
	if(content.locals) { module.exports = content.locals; }
	// add the styles to the DOM
	var update = __webpack_require__(1)("2b486c2e", content, false, {});

	/***/ }),
	/* 139 */
	/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(0)(false);
	// imports


	// module
	exports.push([module.i, "\n.emoji-mart-skin-swatches[data-v-1c614894] {\n  font-size: 0;\n  padding: 2px 0;\n  border: 1px solid #d9d9d9;\n  border-radius: 12px;\n  background-color: #fff;\n}\n.emoji-mart-skin-swatches-opened .emoji-mart-skin-swatch[data-v-1c614894] {\n  width: 16px;\n  padding: 0 2px;\n}\n.emoji-mart-skin-swatches-opened .emoji-mart-skin-swatch-selected[data-v-1c614894]:after {\n  opacity: .75;\n}\n.emoji-mart-skin-swatch[data-v-1c614894] {\n  display: inline-block;\n  width: 0;\n  vertical-align: middle;\n  transition-property: width, padding;\n  transition-duration: .125s;\n  transition-timing-function: ease-out;\n}\n.emoji-mart-skin-swatch[data-v-1c614894]:nth-child(1) { transition-delay: 0s\n}\n.emoji-mart-skin-swatch[data-v-1c614894]:nth-child(2) { transition-delay: .03s\n}\n.emoji-mart-skin-swatch[data-v-1c614894]:nth-child(3) { transition-delay: .06s\n}\n.emoji-mart-skin-swatch[data-v-1c614894]:nth-child(4) { transition-delay: .09s\n}\n.emoji-mart-skin-swatch[data-v-1c614894]:nth-child(5) { transition-delay: .12s\n}\n.emoji-mart-skin-swatch[data-v-1c614894]:nth-child(6) { transition-delay: .15s\n}\n.emoji-mart-skin-swatch-selected[data-v-1c614894] {\n  position: relative;\n  width: 16px;\n  padding: 0 2px;\n}\n.emoji-mart-skin-swatch-selected[data-v-1c614894]:after {\n  content: \"\";\n  position: absolute;\n  top: 50%; left: 50%;\n  width: 4px; height: 4px;\n  margin: -2px 0 0 -2px;\n  background-color: #fff;\n  border-radius: 100%;\n  pointer-events: none;\n  opacity: 0;\n  transition: opacity .2s ease-out;\n}\n.emoji-mart-skin[data-v-1c614894] {\n  display: inline-block;\n  width: 100%; padding-top: 100%;\n  max-width: 12px;\n  border-radius: 100%;\n}\n.emoji-mart-skin-tone-1[data-v-1c614894] { background-color: #ffc93a\n}\n.emoji-mart-skin-tone-2[data-v-1c614894] { background-color: #fadcbc\n}\n.emoji-mart-skin-tone-3[data-v-1c614894] { background-color: #e0bb95\n}\n.emoji-mart-skin-tone-4[data-v-1c614894] { background-color: #bf8f68\n}\n.emoji-mart-skin-tone-5[data-v-1c614894] { background-color: #9b643d\n}\n.emoji-mart-skin-tone-6[data-v-1c614894] { background-color: #594539\n}\n\n", ""]);

	// exports


	/***/ }),
	/* 140 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	var render = function() {
	  var _vm = this;
	  var _h = _vm.$createElement;
	  var _c = _vm._self._c || _h;
	  return _c(
	    "div",
	    {
	      class: {
	        "emoji-mart-skin-swatches": true,
	        "emoji-mart-skin-swatches-opened": _vm.opened
	      }
	    },
	    _vm._l(6, function(skinTone) {
	      return _c(
	        "span",
	        {
	          key: skinTone,
	          class: {
	            "emoji-mart-skin-swatch": true,
	            "emoji-mart-skin-swatch-selected": _vm.skin == skinTone
	          }
	        },
	        [
	          _c("span", {
	            class: "emoji-mart-skin emoji-mart-skin-tone-" + skinTone,
	            on: {
	              click: function($event) {
	                _vm.onClick(skinTone);
	              }
	            }
	          })
	        ]
	      )
	    })
	  )
	};
	var staticRenderFns = [];
	render._withStripped = true;
	var esExports = { render: render, staticRenderFns: staticRenderFns };
	/* harmony default export */ __webpack_exports__["a"] = (esExports);

	/***/ }),
	/* 141 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	var render = function() {
	  var _vm = this;
	  var _h = _vm.$createElement;
	  var _c = _vm._self._c || _h;
	  return _c(
	    "div",
	    { staticClass: "emoji-mart-preview" },
	    [
	      _vm.emoji
	        ? [
	            _c(
	              "div",
	              { staticClass: "emoji-mart-preview-emoji" },
	              [
	                _c("emoji", {
	                  attrs: {
	                    emoji: _vm.emoji,
	                    native: _vm.emojiProps.native,
	                    skin: _vm.emojiProps.skin,
	                    set: _vm.emojiProps.set,
	                    size: 38,
	                    "sheet-size": _vm.emojiProps.sheetSize,
	                    "force-size": _vm.emojiProps.forceSize,
	                    "background-image-fn": _vm.emojiProps.backgroundImageFn
	                  }
	                })
	              ],
	              1
	            ),
	            _vm._v(" "),
	            _c("div", { staticClass: "emoji-mart-preview-data" }, [
	              _c("div", { staticClass: "emoji-mart-preview-name" }, [
	                _vm._v(_vm._s(_vm.emoji.name))
	              ]),
	              _vm._v(" "),
	              _c(
	                "div",
	                { staticClass: "emoji-mart-preview-shortnames" },
	                _vm._l(_vm.emojiShortNames, function(shortName) {
	                  return _c(
	                    "span",
	                    {
	                      key: shortName,
	                      staticClass: "emoji-mart-preview-shortname"
	                    },
	                    [_vm._v(":" + _vm._s(shortName) + ":")]
	                  )
	                })
	              ),
	              _vm._v(" "),
	              _c(
	                "div",
	                { staticClass: "emoji-mart-preview-emoticons" },
	                _vm._l(_vm.emojiEmoticons, function(emoticon) {
	                  return _c(
	                    "span",
	                    {
	                      key: emoticon,
	                      staticClass: "emoji-mart-preview-emoticon"
	                    },
	                    [_vm._v(_vm._s(emoticon))]
	                  )
	                })
	              )
	            ])
	          ]
	        : [
	            _c(
	              "div",
	              { staticClass: "emoji-mart-preview-emoji" },
	              [
	                _c("emoji", {
	                  attrs: {
	                    emoji: _vm.idleEmoji,
	                    native: _vm.emojiProps.native,
	                    skin: _vm.emojiProps.skin,
	                    set: _vm.emojiProps.set,
	                    size: 38,
	                    "sheet-size": _vm.emojiProps.sheetSize,
	                    "force-size": _vm.emojiProps.forceSize,
	                    "background-image-fn": _vm.emojiProps.backgroundImageFn
	                  }
	                })
	              ],
	              1
	            ),
	            _vm._v(" "),
	            _c("div", { staticClass: "emoji-mart-preview-data" }, [
	              _c("span", { staticClass: "emoji-mart-title-label" }, [
	                _vm._v(_vm._s(_vm.title))
	              ])
	            ]),
	            _vm._v(" "),
	            _vm.showSkinTones
	              ? _c(
	                  "div",
	                  { staticClass: "emoji-mart-preview-skins" },
	                  [
	                    _c("skins", {
	                      attrs: { skin: _vm.skinProps.skin },
	                      on: {
	                        change: function($event) {
	                          _vm.$emit("change", $event);
	                        }
	                      }
	                    })
	                  ],
	                  1
	                )
	              : _vm._e()
	          ]
	    ],
	    2
	  )
	};
	var staticRenderFns = [];
	render._withStripped = true;
	var esExports = { render: render, staticRenderFns: staticRenderFns };
	/* harmony default export */ __webpack_exports__["a"] = (esExports);

	/***/ }),
	/* 142 */
	/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(143);
	if(typeof content === 'string') { content = [[module.i, content, '']]; }
	if(content.locals) { module.exports = content.locals; }
	// add the styles to the DOM
	var update = __webpack_require__(1)("0cd29f7e", content, false, {});

	/***/ }),
	/* 143 */
	/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(0)(false);
	// imports


	// module
	exports.push([module.i, "\n.emoji-mart-search[data-v-4ad41bb8] {\n  margin-top: 6px;\n  padding: 0 6px;\n}\n.emoji-mart-search input[data-v-4ad41bb8] {\n  font-size: 16px;\n  display: block;\n  width: 100%;\n  padding: .2em .6em;\n  border-radius: 25px;\n  border: 1px solid #d9d9d9;\n  outline: 0;\n}\n\n", ""]);

	// exports


	/***/ }),
	/* 144 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	var render = function() {
	  var _vm = this;
	  var _h = _vm.$createElement;
	  var _c = _vm._self._c || _h;
	  return _c("div", { staticClass: "emoji-mart-search" }, [
	    _c("input", {
	      directives: [
	        {
	          name: "model",
	          rawName: "v-model",
	          value: _vm.value,
	          expression: "value"
	        }
	      ],
	      attrs: { type: "text", placeholder: _vm.i18n.search },
	      domProps: { value: _vm.value },
	      on: {
	        input: function($event) {
	          if ($event.target.composing) {
	            return
	          }
	          _vm.value = $event.target.value;
	        }
	      }
	    })
	  ])
	};
	var staticRenderFns = [];
	render._withStripped = true;
	var esExports = { render: render, staticRenderFns: staticRenderFns };
	/* harmony default export */ __webpack_exports__["a"] = (esExports);

	/***/ }),
	/* 145 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	var render = function() {
	  var _vm = this;
	  var _h = _vm.$createElement;
	  var _c = _vm._self._c || _h;
	  return _c(
	    "div",
	    { staticClass: "emoji-mart", style: _vm.customStyles },
	    [
	      _vm.showCategories
	        ? _c(
	            "div",
	            { staticClass: "emoji-mart-bar" },
	            [
	              _c("anchors", {
	                attrs: {
	                  i18n: _vm.i18n,
	                  color: _vm.color,
	                  categories: _vm.filteredCategories,
	                  "active-category": _vm.activeCategory
	                },
	                on: { click: _vm.onAnchorClick }
	              })
	            ],
	            1
	          )
	        : _vm._e(),
	      _vm._v(" "),
	      _vm.showSearch
	        ? _c("search", {
	            ref: "search",
	            attrs: {
	              i18n: _vm.i18n,
	              "emojis-to-show-filter": _vm.emojisToShowFilter,
	              include: _vm.include,
	              exclude: _vm.exclude,
	              custom: _vm.customEmojis,
	              recent: _vm.recentEmojis,
	              "auto-focus": _vm.autoFocus
	            },
	            on: { search: _vm.onSearch }
	          })
	        : _vm._e(),
	      _vm._v(" "),
	      _c(
	        "div",
	        {
	          ref: "scroll",
	          staticClass: "emoji-mart-scroll",
	          on: { scroll: _vm.onScroll }
	        },
	        [
	          _c("category", {
	            directives: [
	              {
	                name: "show",
	                rawName: "v-show",
	                value: _vm.searchEmojis,
	                expression: "searchEmojis"
	              }
	            ],
	            attrs: {
	              i18n: _vm.i18n,
	              id: "search",
	              name: "Search",
	              emojis: _vm.searchEmojis,
	              "emoji-props": _vm.emojiProps
	            }
	          }),
	          _vm._v(" "),
	          _vm._l(_vm.filteredCategories, function(category) {
	            return _c("category", {
	              directives: [
	                {
	                  name: "show",
	                  rawName: "v-show",
	                  value:
	                    !_vm.searchEmojis &&
	                    (_vm.infiniteScroll || category == _vm.activeCategory),
	                  expression:
	                    "!searchEmojis && (infiniteScroll || category == activeCategory)"
	                }
	              ],
	              key: category.id,
	              ref: "categories",
	              refInFor: true,
	              attrs: {
	                i18n: _vm.i18n,
	                id: category.id,
	                name: category.name,
	                emojis: category.emojis,
	                "emoji-props": _vm.emojiProps
	              }
	            })
	          })
	        ],
	        2
	      ),
	      _vm._v(" "),
	      _vm.showPreview
	        ? _c(
	            "div",
	            { staticClass: "emoji-mart-bar" },
	            [
	              _c("preview", {
	                attrs: {
	                  title: _vm.title,
	                  emoji: _vm.previewEmoji,
	                  "idle-emoji": _vm.emoji,
	                  "show-skin-tones": _vm.showSkinTones,
	                  "emoji-props": _vm.emojiProps,
	                  "skin-props": _vm.skinProps
	                },
	                on: { change: _vm.onSkinChange }
	              })
	            ],
	            1
	          )
	        : _vm._e()
	    ],
	    1
	  )
	};
	var staticRenderFns = [];
	render._withStripped = true;
	var esExports = { render: render, staticRenderFns: staticRenderFns };
	/* harmony default export */ __webpack_exports__["a"] = (esExports);

	/***/ })
	/******/ ]);
	});
	});

	var Emoji = unwrapExports(emojiMart);

	//

	function highlight(searchString, text) {
	  var r = new RegExp(("(" + searchString + ")"), 'gi');
	  return text.replace(r, '<span class="highlight">$1</span>');
	}
	function queryContains(data, query) {
	  return !Utils$1.isUndefined(data) && data.toLowerCase().contains(query.toLowerCase());
	}

	function prepareContacts(tempContacts, contacts) {
	  var this$1 = this;

	  if (!contacts || contacts.length === 0) { return; }
	  Object.keys(contacts).forEach(function (c) {
	    var contact = contacts[c];
	    if (queryContains(contact.firstName, this$1.query)) {
	      contact.displayField = highlight(this$1.query, contact.firstName);
	    } else {
	      contact.displayField = contact.firstName;
	    }

	    if (queryContains(contact.lastName, this$1.query)) {
	      contact.displayField = (contact.displayField) + " " + (highlight(this$1.query, contact.lastName));
	    } else {
	      contact.displayField = (contact.displayField) + " " + (contact.lastName);
	    }

	    if (!Utils$1.isUndefined(contact.displayField)) {
	      if (!contact.displayField.contains('<span')) {
	        contact.displayField = highlight(this$1.query, contact.email);
	      }
	    } else {
	      contact.displayField = highlight(this$1.query, contact.email);
	    }

	    contact.itemSelected = false;
	    tempContacts.push(contact);
	  });
	}

	function getContactFinished() {
	  var tempContacts = [];
	  prepareContacts.bind(this)(tempContacts, this.storeContacts.contacts);
	  prepareContacts.bind(this)(tempContacts, this.storeContacts.recentContacts);
	  if (tempContacts.length > 0) { tempContacts[0].itemSelected = true; }

	  this.contacts = tempContacts;
	}

	var script$1 = {
	  components: {
	    contactAutocomplete: __vue_component__,
	    picker: Emoji.Picker,
	  },
	  props: {
	    id: String,
	    hideCamera: Boolean,
	    fileUpload: Boolean,
	    signature: String,
	    messagesLoaded: {
	      type: Boolean,
	      default: true,
	    },
	    sending: Boolean,
	    disableFocusAfterSend: Boolean,
	    focusOnLoad: Boolean,
	    type: String,
	    placeholder: {
	      type: String,
	      default: 'Message',
	    },
	    useMentions: Boolean,
	    showContactSelect: Boolean,
	    top: Boolean,
	    editingMessage: Object,
	    clearDataOnSend: {
	      type: Boolean,
	      default: true,
	    },
	    textToHtml: {
	      type: Boolean,
	      default: true,
	    },
	    desktopSendOnEnter: Boolean,
	    template: String,
	  },
	  data: function data() {
	    var self = this;

	    var storeUsers;
	    if (self.useMentions) {
	      storeUsers = new Store(self, {
	        get: ['user', 'list'],
	      });
	    }

	    var storeContacts = new Store(self, {
	      get: ['contact', 'list', { take: 6 }],
	      getFinished: getContactFinished,
	    });

	    var templateLoaded = false;
	    var storeSavedReplies = new Store(self, {
	      get: ['savedreply', 'list', { channelId: self.id }],
	      getFinished: function () {
	        if (!self.template || templateLoaded)
	          { return; }
	        var templateToLoad = self.channelReplies.find(function (t) { return t.slug.toLowerCase() === self.template; });
	        if (templateToLoad) {
	          self.insertTemplate(templateToLoad, false);
	          templateLoaded = true;
	        }
	      }
	    });

	    if (self.template)
	      { storeSavedReplies.get(); }

	    return {
	      text: null,
	      textComputed: null,
	      buttonText: 'Send',
	      files: [],
	      signatureLocal: '',
	      mentionsQuery: undefined,
	      showActions: false,
	      mentions: {
	        users: {},
	        channels: {},
	      },
	      storeUsers: storeUsers,
	      storeSavedReplies: storeSavedReplies,
	      storeContacts: storeContacts,
	      selectedMentionIndex: Brief$1.isCordova || Utils$1.mobileDevice() ? -1 : 0,
	      selectedReplyIndex: Brief$1.isCordova || Utils$1.mobileDevice() ? -1 : 0,
	      actionsType: 'users',
	      savedRepliesQuery: undefined,
	      selectedContacts: [],
	      contacts: [],
	      itemIndex: 0,
	      query: '',
	      selectedReplyType: 'Reply sender',
	      needToShowReplyOptions: false,
	      inputWasFocused: false,
	      enterCallback: undefined,
	      emojiVisible: false,
	      inputCaretPosition: 0,
	      closeOptions: false,
	      openSend: false,
	    };
	  },
	  computed: {
	    emojiEnabled: function emojiEnabled() {
	      return Brief$1.isDesktop;
	    },
	    signatureComputed: function signatureComputed() {
	      return this.signature || this.signatureLocal;
	    },
	    channelReplies: function channelReplies() {
	      var self = this;
	      if (!self.storeSavedReplies.replies) { return []; }
	      return self.storeSavedReplies.replies.filter(function (reply) { return reply.scope === 'TEAM' || (reply.scope === 'CHANNEL' && reply.channelId === self.id); });
	    },
	  },
	  created: function created() {
	    var self = this;
	    ClientStorage.get(((self.id) + "-signature"))
	      .then(function (signature) {
	        if (Utils$1.isUndefined(self.signature)) { self.signatureLocal = signature; } else { self.signatureLocal = self.signature; }
	      });
	  },
	  mounted: function mounted() {
	    var this$1 = this;

	    var self = this;

	    Brief$1.events.$on(['template-created', 'template-edited', 'template-deleted'], function () {
	      self.storeSavedReplies.reload();
	    });

	    self.messagebar = Brief$1.f7.messagebar.create({ el: self.$el, maxHeight: 170, top: self.top });
	    if (!self.top) { self.messagebar.resizePage(); }

	    self.$nextTick(function () {
	      if (self.textComputed === null) {
	        ClientStorage.get(self.id)
	          .then(function (text) {
	            if (self.textComputed !== null)
	              { return; }
	            self.textComputed = text || '';
	            self.text = text || '';
	            self.$nextTick(function () {
	              if (self.type === 'wall' && self.textComputed === '') { return; }
	              if (self.messagebar.getValue()) { self.resizeBar(); }
	            });
	          });
	      }
	      if (self.focusOnLoad && !self.sending && self.messagesLoaded && !Brief$1.isCordova) {
	        $$1(self.$el).parents('.page').once('page:afteranimation', function () {
	          self.messagebar.textareaEl.focus();
	        });
	      }
	    });

	    if (self.emojiEnabled) {
	      document.addEventListener("click", self.handleEmojiClick);

	      setTimeout(function () {
	        document.getElementById('text-input').addEventListener('keyup', function (e) {
	          self.inputCaretPosition = e.target.selectionStart;
	        });
	        document.getElementById('text-input').addEventListener('mouseup', function (e) {
	          self.inputCaretPosition = e.target.selectionStart;
	        });
	      }, 100);
	    }

	    if (!Brief$1.isCordova) {
	      document.addEventListener("drag", function( event ) {
	      }, false);
	      document.addEventListener("dragstart", function( event ) {
	        event.target.style.opacity = .5;
	      }, false);

	      document.addEventListener("dragend", function( event ) {
	        event.target.style.opacity = "";
	      }, false);
	      document.addEventListener("dragover", function( event ) {
	        event.preventDefault();
	      }, false);
	      document.addEventListener("dragenter", function( event ) {
	        if (event.target.className == "brief-messages") {
	          event.target.style.background = 'repeating-linear-gradient( 45deg, #606dbc, #606dbc 10px, #465298 10px, #465298 20px)';
	          event.target.style.opacity = 0.1;
	        }
	      }, false);
	      document.addEventListener("dragleave", function( event ) {
	        if (event.target.className == "brief-messages") {
	          event.target.style.background = "";
	          event.target.style.opacity = 1;
	        }
	      }, false);
	      document.addEventListener("drop", function( event ) {
	        event.preventDefault();
	        if (event.target.className == "brief-messages") {
	          event.target.style.background = "";
	          event.target.style.opacity = 1;
	        }
	        var file;
	        if (event.dataTransfer.items) {
	          for (var i = 0; i < event.dataTransfer.items.length; i++) {
	            if (event.dataTransfer.items[i].kind === 'file') {
	              file = event.dataTransfer.items[i].getAsFile();
	            }
	          }
	        } else {
	          for (var i = 0; i < event.dataTransfer.files.length; i++) {
	            file = event.dataTransfer.files[i];
	          }
	        }
	        var reader = new window.FileReader();
	        reader.onload = function onload() {
	          var src = reader.result;
	          var fileObject = {
	            type: file.type,
	            contentType: file.type,
	            size: file.size,
	            contentLength: file.size,
	            name: file.name,
	            originalFilename: file.name,
	            src: src,
	            isFromSrc: true,
	            isReady: true,
	            originalFile: file,
	          };
	          if (file.type.indexOf('image') === 0) {
	            var img = new window.Image();
	            img.onload = function imgOnload() {
	              fileObject.width = img.width;
	              fileObject.height = img.height;
	            };
	            img.src = src;
	          }
	          self.files.push(fileObject);
	        };
	        try {
	          reader.readAsDataURL(file);
	        } catch (err) {
	          console.log(err);
	        }

	      }, false);

	      (function ($) {
	        var defaults;
	        $.event.fix = (function (originalFix) {
	          return function (event) {
	            event = originalFix.apply(this, arguments);
	            if (event.type.indexOf('copy') === 0 || event.type.indexOf('paste') === 0) {
	              event.clipboardData = event.originalEvent.clipboardData;
	            }
	            return event;
	          };
	        })($.event.fix);
	        defaults = {
	          callback: $.noop,
	          matchType: /image.*/
	        };
	        return $.fn.pasteImageReader = function (options) {
	          if (typeof options === "function") {
	            options = {
	              callback: options
	            };
	          }
	          options = $.extend({}, defaults, options);
	          return this.each(function () {
	            var $this, element;
	            element = this;
	            $this = $(this);
	            return $this.bind('paste', function (event) {
	              var clipboardData, found;
	              found = false;
	              clipboardData = event.clipboardData;
	              return Array.prototype.forEach.call(clipboardData.types, function (type, i) {
	                var file, reader;
	                if (found) {
	                  return;
	                }
	                if (type.match(options.matchType) || clipboardData.items[i].type.match(options.matchType)) {
	                  jquery('#isPasting').css('display', 'block');
	                  file = clipboardData.items[i].getAsFile();
	                  reader = new FileReader();
	                  reader.onload = function (evt) {
	                    return options.callback.call(element, {
	                      dataURL: evt.target.result,
	                      event: evt,
	                      file: file,
	                      name: file.name
	                    });
	                  };
	                  reader.readAsDataURL(file);
	                  return found = true;
	                }
	              });
	            });
	          });
	        };
	      })(jquery);

	      jquery("html").pasteImageReader(function (results) {
	        var file = results.file;
	        var reader = new window.FileReader();
	        reader.onload = function onload() {
	          var src = reader.result;
	          var fileObject = {
	            type: file.type,
	            contentType: file.type,
	            size: file.size,
	            contentLength: file.size,
	            name: file.name,
	            originalFilename: file.name,
	            src: src,
	            isFromSrc: true,
	            isReady: true,
	            originalFile: file,
	          };
	          if (file.type.indexOf('image') === 0) {
	            var img = new window.Image();
	            img.onload = function imgOnload() {
	              jquery('#isPasting').css('display', 'none');
	              fileObject.width = img.width;
	              fileObject.height = img.height;
	            };
	            img.src = src;
	          }
	          self.files.push(fileObject);
	        };
	        try {
	          reader.readAsDataURL(file);
	        } catch (err) {
	          console.log(err);
	        }
	      });
	    }

	    Brief$1.events.$on('common-write-contacts', function (contacts) {
	      if (contacts.length > 1) {
	        this$1.needToShowReplyOptions = true;
	      }
	      this$1.selectedContacts = contacts.map(function (contact) { return ({
	        id: contact.id,
	        firstName: contact.firstName,
	        lastName: contact.lastName,
	        email: contact.email,
	        type: contact.contactType,
	        displayField: (Utils$1.isUndefined(contact.firstName) && Utils$1.isUndefined(contact.lastName)) ? contact.email : (((contact.firstName || '') + " " + (contact.lastName || ''))).trim(),
	      }); });
	    });
	    Brief$1.events.$on('send-message-error', function () {
	      if (!self.prevData) {
	        return;
	      }
	      self.textComputed = self.prevData.text;
	      self.files = self.prevData.files;
	    });
	  },
	  beforeDestroy: function beforeDestroy() {
	    var self = this;
	    Brief$1.events.$off(['template-created', 'template-edited', 'template-deleted']);
	    if (self.storeUsers) { self.storeUsers.dispose(); }
	    self.messagebar.destroy();
	    document.removeEventListener("click", self.handleEmojiClick);
	  },
	  watch: {
	    'storeUsers.users': function checkStoreUsersChange(newUsers) {
	      var self = this;
	      if (self.actionsType !== 'users') { return; }
	      self.showActions = newUsers.length > 0;
	      if (!Brief$1.isCordova && !Utils$1.mobileDevice) {
	        self.selectedMentionIndex = 0;
	      }
	    },
	    editingMessage: function editingMessage(message, oldValue) {
	      var self = this;
	      // Enable
	      if ((message && !oldValue) || (message && message.id !== oldValue.id)) {
	        // Remove files
	        self.files.forEach(function (file) {
	          self.onAttachmentDelete(file);
	        });
	        self.files = [];

	        // Update textarea
	        var text = message.text
	          .replace(/<br>/g, '\n')
	          .replace(/<br \/>/g, '\n')
	          .replace(/<br\/>/g, '\n');

	        self.textComputed = text;
	      }
	    },
	    'files.length': function watchFilesLength(length, lengthBefore) {
	      var self = this;
	      if (!self.messagebar) { return; }
	      if (length === lengthBefore) { return; }
	      self.$nextTick(function () {
	        if (length > 0) { self.messagebar.attachmentsShow(); }
	        else { self.messagebar.attachmentsHide(); }
	      });
	    },
	    signature: function signature(newV) {
	      var self = this;
	      if (!Utils$1.isUndefined(self.signature) && self.inputInFocus) {
	        self.textComputed = "\n\r" + (self.getSignature(newV));
	        self.text = "\n\r" + (self.getSignature(newV));
	        self.resizeBar();
	        setTimeout(function () {
	          Utils$1.resetCursor(self.messagebar.textareaEl);
	        }, 10);
	      }
	      if (Utils$1.isUndefined(newV)) { ClientStorage.save(((self.id) + "-signature"), newV); }
	    },
	    signatureComputed: function signatureComputed(newV, oldV) {
	      if (this.text && this.text.trim() === this.getSignature(oldV)) {
	        // change signature in current common-write
	        this.text = "\n\r" + (this.getSignature(newV) || '');
	        this.textComputed = this.text;
	      }
	    },
	    messagesLoaded: function messagesLoaded() {
	      var self = this;
	      self.$nextTick(function () {
	        if (self.focusOnLoad && !self.sending && self.messagesLoaded && self.messagebar && !Brief$1.isCordova) {
	          self.messagebar.textareaEl.focus();
	        }
	      });
	    },
	    textComputed: function textComputed(newValue, oldValue) {
	      var self = this;

	      if (!self.editingMessage && !Utils$1.isUndefined(newValue) && newValue.trim() !== self.getSignature(self.signature)) {
	        if (oldValue !== null) { self.$emit('typing', newValue.trim()); }
	        ClientStorage.save(self.id, newValue.trim());
	      } else {
	        ClientStorage.remove(self.id);
	      }

	      self.text = newValue;

	      self.closeOptions = self.text && self.text.length > 1;
	      self.openSend = self.text && self.text.length > 0;

	      self.resizeBar();
	    },
	  },
	  methods: {
	    editTemplate: function editTemplate(e) {
	      e.stopPropagation();
	    },
	    resizeBar: function resizeBar() {
	      var self = this;
	      self.$nextTick(function () {
	        Brief$1.f7.input.resizeTextarea(self.messagebar.textareaEl);
	        if (!self.top) {
	          self.messagebar.resizePage(); 
	          self.$emit('resize');
	          setTimeout(function () { 
	            self.messagebar.resizePage(); 
	            self.$emit('resize');
	          }, 50);
	        }
	      });
	    },
	    openOptions: function openOptions() {
	      this.closeOptions = false;
	    },
	    toggleEmoji: function toggleEmoji() {
	      this.emojiVisible = !this.emojiVisible;
	    },
	    addEmoji: function addEmoji(emoji) {
	      this.textComputed = this.textComputed.slice(0, this.inputCaretPosition) + emoji.native + this.textComputed.slice(this.inputCaretPosition);
	      this.emojiVisible = false;
	    },
	    handleEmojiClick: function handleEmojiClick(evt) {
	      var emojiWindowElement = document.getElementById('emoji-window');
	      var emojiButtonElement = document.getElementById('input-emoji-button');
	      var targetElement = evt.target;

	      do {
	        if (targetElement === emojiWindowElement || targetElement === emojiButtonElement) {
	          return;
	        }
	        targetElement = targetElement.parentNode;
	      } while (targetElement);
	    },
	    getSignature: function getSignature(signature) {
	      var signatureText = signature ? signature.trim() : null;
	      return signatureText;
	    },
	    send: function send() {
	      var self = this;

	      if (self.$root.loggedInUser && self.$root.loggedInUser.plan && self.$root.loggedInUser.plan.sentMessagesIncluded) {
	        if (self.$root.loggedInUser.plan.status !== 'active') {
	          Brief$1.notify('Subscription is inactive', ("Current status is \"" + (self.$root.loggedInUser.plan.status) + "\". Activate your plan in \"Settings\" to be able to send messages."));
	          return;
	        }
	        if (self.$root.loggedInUser.sentMessagesCount >= self.$root.loggedInUser.plan.sentMessagesIncluded) {
	          Brief$1.notify('You already reached monthly limit of messages', 'Upgrade your plan in "Settings" to be able to send more messages');
	          return;
	        }
	      }

	      if (!Brief$1.onLine()) { return; }

	      if (Utils$1.isUndefined(self.text) && self.files.length === 0) { return; }

	      self.text = self.text.trim();

	      // Check mentions
	      var mentions;
	      if (self.useMentions) {
	        if (self.mentions && self.mentions.users) {
	          Object.keys(self.mentions.users).forEach(function (mentionedUsed) {
	            if (self.text.indexOf(("@" + mentionedUsed)) < 0) {
	              delete self.mentions.users[mentionedUsed];
	            }
	          });
	        }
	        if (self.mentions && self.mentions.channels) {
	          Object.keys(self.mentions.channels).forEach(function (mentionedChannel) {
	            if (self.text.indexOf(("#" + mentionedChannel)) < 0) {
	              delete self.mentions.channels[mentionedChannel];
	            }
	          });
	        }
	        mentions = self.mentions;
	      }

	      var filesToSend = [];

	      self.files.forEach(function (file) {
	        var contentLength = file.contentLength;
	        var contentType = file.contentType;
	        var height = file.height;
	        var name = file.name;
	        var originalFilename = file.originalFilename;
	        var size = file.size;
	        var type = file.type;
	        var width = file.width;
	        var src = file.src;
	        var originalFile = file.originalFile;

	        filesToSend.push({
	          contentLength: contentLength,
	          contentType: contentType,
	          height: height,
	          name: name,
	          originalFilename: originalFilename,
	          size: size,
	          type: type,
	          width: width,
	          src: src,
	          isFromSrc: true,
	          originalFile: originalFile,
	        });
	      });

	      var dataToSend = {
	        isNew: true,
	        streamId: self.id,
	        conversationId: self.id,
	        //text: self.textToHtml ? Utils.textToHtml(self.text) : self.text,
	        text: self.text,
	        files: filesToSend,
	        isMyMessage: true,
	        mentions: mentions,
	        isSendMessage: true,
	      };

	      self.prevData = {
	        text: self.text,
	        files: self.files,
	      };

	      if (self.clearDataOnSend) {
	        self.text = '';
	        self.textComputed = '';
	        self.files = [];
	        self.messagebar.clear();
	        ClientStorage.remove(self.id);
	      }

	      if (!self.disableFocusAfterSend && !filesToSend.length) {
	        self.messagebar.textareaEl.focus();
	      }

	      self.$emit('send', dataToSend);
	    },
	    onEnter: function onEnter(e) {
	      var self = this;

	      if (e.type === 'keyup' && e.shiftKey)
	        { return; }

	      if (e.type === 'keyup' && (Brief$1.isCordova || !Brief$1.isDesktop)) {
	        if (['email', 'facebook', 'instagram', 'website', 'sms', 'wall', 'email-compose'].includes(self.type)) {
	          return;
	        }
	      }

	      if (!Brief$1.isCordova && !self.desktopSendOnEnter)
	        { return; }

	      // if (self.showActions) {
	      //   if (self.actionsType === 'users' && self.selectedMentionIndex >= 0) {
	      //     self.insertMention(self.storeUsers.users[self.selectedMentionIndex]);
	      //   } else if (self.actionsType === 'replies' && self.selectedReplyIndex >= 0) {
	      //     self.insertReply(self.channelReplies[self.selectedReplyIndex]);
	      //   }
	      //   return;
	      // }

	      self.send();
	    },
	    onEnterCheck: function onEnterCheck(e) {
	      if (Brief$1.isCordova || !Brief$1.isDesktop) { return; }

	      if (!e.shiftKey && this.desktopSendOnEnter) {
	        e.stopPropagation();
	        e.preventDefault();
	      }
	    },
	    onKeyDown: function onKeyDown(e) {
	      var self = this;
	      var keyCode = e.keyCode;
	      var isNavigateActions = self.showActions && (keyCode === 40 || keyCode === 38);
	      if (!isNavigateActions) {
	        if (keyCode === 38 && self.type === 'room') {
	          self.$emit('editLastMessage');
	        }
	        return;
	      }

	      e.preventDefault();
	      e.stopPropagation();

	      var storeItems = self.actionsType === 'users' ? self.storeUsers.users : self.channelReplies;

	      var newActionIndex = self.actionsType === 'users' ? self.selectedMentionIndex : self.selectedReplyIndex;

	      if (keyCode === 40) {
	        // Down
	        newActionIndex += 1;
	        if (newActionIndex >= storeItems.length) {
	          newActionIndex = 0;
	        }
	      }
	      if (keyCode === 38) {
	        // Up
	        newActionIndex -= 1;
	        if (newActionIndex < 0) {
	          newActionIndex = storeItems.length - 1;
	        }
	      }
	      if (keyCode === 40 || keyCode === 38) {
	        if (self.actionsType === 'users') {
	          self.selectedMentionIndex = newActionIndex;
	        } else {
	          self.selectedReplyIndex = newActionIndex;
	        }
	      }
	    },
	    onKeyUp: function onKeyUp() {
	    },
	    onClick: function onClick() {
	    },
	    loopEvery: function loopEvery(intervalDelay, duration, func) {
	      var self = this;

	      clearInterval(self.loopIntervalRef);

	      func();

	      self.loopIntervalRef = setInterval(function () {
	        func();
	      }, intervalDelay);

	      setTimeout(function () {
	        clearInterval(self.loopIntervalRef);
	      }, duration);
	    },
	    resizePageWhileKeyboardAnimates: function resizePageWhileKeyboardAnimates() {
	      var self = this;
	      if (!self.top) {
	        if (Brief$1.isCordova)
	          { self.loopEvery(10, 350, function () { self.messagebar.resizePage(); }); }
	        else
	          { self.messagebar.resizePage(); }
	      }
	    },
	    onFocus: function onFocus() {
	      var self = this;
	      Brief$1.f7.preventSwipeBack = true;
	      Brief$1.f7.preventSwipePanel = true;
	      if (self.getSignature(this.signature) && Utils$1.isUndefined(self.text)) {
	        self.textComputed = "\n\r" + (self.getSignature(this.signature));
	        self.text = "\n\r" + (self.getSignature(this.signature));
	        self.resizeBar();
	        setTimeout(function () {
	          Utils$1.resetCursor(self.messagebar.textareaEl);
	        }, 10);
	      }
	      self.resizePageWhileKeyboardAnimates();
	      self.inputInFocus = true;
	      self.inputWasFocused = true;
	    },
	    onBlur: function onBlur() {
	      var self = this;
	      Brief$1.f7.preventSwipeBack = false;
	      Brief$1.f7.preventSwipePanel = false;
	      self.resizePageWhileKeyboardAnimates();
	      self.inputInFocus = false;
	    },
	    onChange: function onChange() {
	      var self = this;
	      self.resizeBar();
	    },
	    onTouchMove: function onTouchMove(e) {
	      e.f7PreventSwipeBack = true;
	      e.f7PreventSwipePanel = true;
	    },
	    cancelEditing: function cancelEditing() {
	      var self = this;
	      self.textComputed = '';
	      self.$emit('cancelEditing');
	    },
	    onFilesChange: function onFilesChange(e) {
	      var self = this;
	      var files = [];
	      for (var i = 0; i < e.target.files.length; i += 1) {
	        files.push(e.target.files[i]);
	      }
	      files.forEach(function (file) {
	        var reader = new window.FileReader();
	        reader.onload = function onload() {
	          var src = reader.result;
	          var fileObject = {
	            type: file.type,
	            contentType: file.type,
	            size: file.size,
	            contentLength: file.size,
	            name: file.name,
	            originalFilename: file.name,
	            src: src,
	            isReady: true,
	            originalFile: file,
	          };
	          if (file.type.indexOf('image') === 0) {
	            var img = new window.Image();
	            img.onload = function imgOnload() {
	              fileObject.width = img.width;
	              fileObject.height = img.height;
	            };
	            img.src = src;
	          }
	          self.files.push(fileObject);
	        };
	        try {
	          reader.readAsDataURL(file);
	        } catch (err) {
	          console.log(err);
	        }
	      });
	    },
	    onAttachmentDelete: function onAttachmentDelete(file) {
	      var self = this;
	      self.files.splice(self.files.indexOf(file), 1);
	    },
	    onTemplatesOpen: function onTemplatesOpen() {
	      var self = this;
	      self.storeSavedReplies.get();
	    },
	    insertMention: function insertMention(user) {
	      var self = this;
	      if (!self.useMentions) { return; }
	      var text = self.textComputed;
	      var selectionStart = self.messagebar.textareaEl.selectionStart;
	      var mentionName = ((user.firstName) + " " + (user.lastName)).replace(/ /g, '_');

	      var newText = text
	        .substring(0, selectionStart)
	        .split('@')
	        .map(function (el, index, arr) {
	          if (index === arr.length - 1) { return mentionName; }
	          return el;
	        }).join('@');
	      newText += " " + (text.substring(selectionStart, text.length));

	      var diff = newText.length - text.length;
	      var newSelectionStart = selectionStart + diff;

	      // Add To mentions object
	      self.mentions.users[mentionName] = user.userId;

	      self.showActions = false;
	      self.mentionsQuery = undefined;

	      self.textComputed = newText;

	      self.messagebar.textareaEl.value = newText;
	      self.messagebar.textareaEl.selectionStart = newSelectionStart;
	      self.messagebar.textareaEl.selectionEnd = newSelectionStart;

	      self.messagebar.textareaEl.focus();
	    },
	    insertTemplate: function insertTemplate(template, focus) {
	      var self = this;

	      var signature = self.getSignature(self.signature);
	      var newText = signature 
	        ? template.text + "\n\r" + signature 
	        : template.text;

	      self.textComputed = newText;
	      self.messagebar.textareaEl.value = newText;

	      self.resizeBar();

	      Brief$1.f7.sheet.close();

	      if (focus) {
	        var end = newText.length;
	        setTimeout(function () {
	          self.messagebar.textareaEl.setSelectionRange(end, end);
	          self.messagebar.textareaEl.focus();
	        }, 60);
	      }
	    },
	    selectReplyType: function selectReplyType(replyType) {
	      this.selectedReplyType = replyType;
	      this.showActions = false;
	      Brief$1.events.$emit('common-write-reply-type:updated', replyType);
	    },
	    changeReplyType: function changeReplyType() {
	      this.selectedReplyType = null;
	      this.actionsType = 'email';
	      this.showActions = true;
	    },
	    findActionsQuery: function findActionsQuery(selector) {
	      var self = this;
	      var text = (self.textComputed || '');
	      var selectionStart = self.messagebar.textareaEl.selectionStart || (text.length - 1);
	      var textBeforeCursor = text.substring(0, selectionStart);

	      var query;

	      if (textBeforeCursor.indexOf(selector) >= 0) {
	        textBeforeCursor.split(selector).forEach(function (mention, index) {
	          if (index === 0) { return; }
	          if (mention.indexOf(' ') >= 0) { return; }
	          if (mention.indexOf('\n') >= 0) { return; }
	          var nextChar = text[selectionStart];
	          if (!nextChar || nextChar === ' ' || nextChar === '\n') {
	            query = mention;
	          }
	        });
	      }

	      return query;
	    },
	    updateContacts: function updateContacts() {
	      Brief$1.events.$emit('common-write-contacts:updated', this.selectedContacts.map(function (contact) { return ({
	        id: contact.id,
	        firstName: contact.firstName,
	        lastName: contact.lastName,
	        email: contact.email,
	        contactTYpe: contact.type,
	      }); }));
	    },
	    onTextChange: function onTextChange(newText) {
	      this.text = newText;
	    },
	    onQueryChange: function onQueryChange(newQuery) {
	      this.query = newQuery;
	    },
	    onItemIndexChange: function onItemIndexChange(newIndex) {
	      this.itemIndex = newIndex;
	    },
	    onSelectedContactsAdd: function onSelectedContactsAdd(newContact) {
	      var self = this;
	      self.selectedContacts.push(newContact);
	      this.updateContacts();
	      ClientStorage.save(((self.channelId) + ":contacts"), self.selectedContacts);
	    },
	    onSelectedContactsReplace: function onSelectedContactsReplace(newContact) {
	      var self = this;
	      self.selectedContacts = [newContact];
	      this.updateContacts();
	      ClientStorage.save(((self.channelId) + ":contacts"), self.selectedContacts);
	    },
	    onSelectedContactsRemove: function onSelectedContactsRemove(index) {
	      var self = this;
	      self.selectedContacts.splice(index, 1);
	      this.updateContacts();
	      ClientStorage.save(((self.channelId) + ":contacts"), self.selectedContacts);
	    },
	    onSearchedContactsReplace: function onSearchedContactsReplace(newArr) {
	      var self = this;
	      self.contacts = newArr;
	      ClientStorage.save(((self.channelId) + ":contacts"), self.selectedContacts);
	    },
	    debounceSearch: debounce_1(function debounceSearch() {
	      var self = this;
	      self.storeContacts.get({ query: self.query });
	    }, 500),
	    onContactSearch: function onContactSearch() {
	      var self = this;
	      self.itemIndex = 0;
	      if (Utils$1.isUndefined(self.query)) {
	        self.contacts = [];
	        return;
	      }
	      if (self.isLoading) { return; }
	      self.debounceSearch();
	    },
	  },
	};

	/* script */
	var __vue_script__$1 = script$1;

	/* template */
	var __vue_render__$1 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"toolbar messagebar"},[_c('div',{staticClass:"preloader",staticStyle:{"display":"none"},attrs:{"id":"isPasting"}}),_vm._v(" "),(_vm.selectedReplyType && _vm.needToShowReplyOptions)?_c('div',[_c('ul',[_c('li',{staticClass:"action-selected",staticStyle:{"list-style":"none"}},[_c('a',{staticClass:"item-link item-content",attrs:{"href":"#"},on:{"click":function($event){return _vm.changeReplyType()}}},[_c('div',{staticClass:"item-inner"},[_c('div',{staticClass:"item-title",staticStyle:{"color":"#aa48dc"}},[_vm._v("\n                "+_vm._s(_vm.selectedReplyType)+"\n              "),_c('f7-icon',{staticStyle:{"display":"inline-block"},attrs:{"if-ios":"f7:chevron_down","if-md":"material:expand_more"}})],1)])])])])]):_vm._e(),_vm._v(" "),(_vm.showContactSelect && _vm.selectedReplyType === 'Reply some')?_c('ul',[_c('contact-autocomplete',{attrs:{"query":_vm.query,"searched-contacts":_vm.contacts,"selected-contacts":_vm.selectedContacts,"item-index":_vm.itemIndex,"to":_vm.$f7route.query.to},on:{"contactsearch":_vm.onContactSearch,"querychange":_vm.onQueryChange,"itemindexchange":_vm.onItemIndexChange,"selectedcontacts:add":_vm.onSelectedContactsAdd,"selectedcontacts:replace":_vm.onSelectedContactsReplace,"selectedcontacts:remove":_vm.onSelectedContactsRemove,"searchedcontacts:replace":_vm.onSearchedContactsReplace}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"toolbar-inner"},[_c('div',{staticClass:"options"},[_c('f7-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.closeOptions),expression:"closeOptions"}],staticClass:"open-options",attrs:{"icon-material":"keyboard_arrow_right","icon-size":"36"},on:{"click":_vm.openOptions}}),_vm._v(" "),(_vm.editingMessage && !_vm.closeOptions)?_c('a',{staticClass:"link",on:{"click":_vm.cancelEditing}},[_vm._v("Cancel")]):_vm._e(),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(!_vm.editingMessage && !_vm.closeOptions),expression:"!editingMessage && !closeOptions"}],staticClass:"camera link",class:{ 'disabled': !_vm.fileUpload }},[_c('f7-icon',{attrs:{"material":"camera_alt"}}),_vm._v(" "),_c('input',{attrs:{"type":"file","multiple":""},on:{"change":_vm.onFilesChange}})],1),_vm._v(" "),_c('f7-link',{directives:[{name:"show",rawName:"v-show",value:(!_vm.editingMessage && !_vm.closeOptions),expression:"!editingMessage && !closeOptions"}],staticClass:"templates",attrs:{"icon-material":"chat","sheet-open":(".templates-sheet-" + _vm._uid)}})],1),_vm._v(" "),_c('div',{staticClass:"messagebar-area",class:{ 'close-options': _vm.closeOptions, 'open-send': _vm.openSend }},[(_vm.files && _vm.files.length > 0)?_c('common-files',{attrs:{"files":_vm.files,"createMode":true,"attachments":true},on:{"attachmentDelete":_vm.onAttachmentDelete},nativeOn:{"touchmove":function($event){return _vm.onTouchMove.apply(null, arguments)}}}):_c('div',{staticClass:"messagebar-attachments"}),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","align-items":"flex-end"}},[_c('f7-input',{staticStyle:{"flex-grow":"1"},attrs:{"id":"text-input","type":"textarea","resizable":"","placeholder":_vm.placeholder,"value":_vm.textComputed,"disabled":_vm.sending,"wrap":false,"tabindex":"3"},on:{"click":_vm.onClick,"input":function($event){_vm.textComputed = $event.target.value;},"focus":_vm.onFocus,"blur":_vm.onBlur,"change":function($event){return _vm.onChange()},"keyup":_vm.onKeyUp},nativeOn:{"keydown":[function($event){return _vm.onKeyDown.apply(null, arguments)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.onEnterCheck.apply(null, arguments)}],"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.onEnter.apply(null, arguments)}}}),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","gap":"8px","align-items":"flex-end","padding":"8px"}},[_vm._t("default"),_vm._v(" "),(_vm.emojiEnabled)?_c('svg',{staticClass:"input-emoji-button",staticStyle:{"cursor":"pointer"},attrs:{"id":"input-emoji-button","height":"24","width":"24","viewBox":"2 2 20 20","xmlns":"http://www.w3.org/2000/svg"},on:{"click":_vm.toggleEmoji}},[_c('path',{attrs:{"d":"M0 0h24v24H0z","fill":"none"}}),_vm._v(" "),_c('path',{attrs:{"d":"M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 6.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z"}})]):_vm._e()],2)],1)],1),_vm._v(" "),(_vm.textComputed && _vm.textComputed.length > 0)?_c('f7-link',{staticClass:"send-button",class:{ 'no-fastclick': _vm.$device.android },on:{"click":_vm.send}},[_vm._v(_vm._s(_vm.editingMessage ? 'Save' :  _vm.type === 'note' ? 'Add' : 'Send'))]):_vm._e()],1),_vm._v(" "),(_vm.emojiVisible && _vm.emojiEnabled)?_c('picker',{style:({ position: 'fixed', bottom: _vm.top ? undefined : '187px', top: !_vm.top ? undefined : '187px', right: '1px', zIndex: 100 }),attrs:{"id":"emoji-window","showPreview":false,"sheetSize":32,"infiniteScroll":false,"include":['people', 'nature', 'foods', 'activity'],"set":"apple"},on:{"select":_vm.addEmoji}}):_vm._e(),_vm._v(" "),_c('f7-sheet',{class:("templates-sheet templates-sheet-" + _vm._uid),on:{"sheet:open":_vm.onTemplatesOpen}},[_c('f7-block',{staticStyle:{"display":"flex","align-items":"center","justify-content":"space-between"}},[_c('h2',[_vm._v("Templates")]),_vm._v(" "),_c('f7-button',{attrs:{"small":"","fill":"","round":"","href":"/replies/add/","view":".popup-main-view","popup-open":".popup-main","reload-current":""}},[_vm._v("New")])],1),_vm._v(" "),(!_vm.storeSavedReplies.isLoading)?_c('div',{staticClass:"list media-list"},[_c('ul',_vm._l((_vm.channelReplies),function(template,index){return _c('li',{key:index,staticStyle:{"display":"flex","justify-content":"space-between"}},[_c('a',{staticClass:"item-link item-content",attrs:{"href":"#"},on:{"click":function($event){return _vm.insertTemplate(template, true)}}},[_c('div',{staticClass:"item-inner",staticStyle:{"padding-right":"0"}},[_c('div',{staticClass:"item-title-row"},[_c('div',{staticClass:"item-title"},[_c('b',[_vm._v(_vm._s(template.title)+":")]),_vm._v(" "),_c('span',{staticStyle:{"color":"#595560"}},[_vm._v(_vm._s(template.text))])])])])]),_vm._v(" "),_c('f7-link',{staticStyle:{"margin":"0 16px"},attrs:{"href":("/replies/edit/" + (template.id) + "/"),"view":".popup-main-view","popup-open":".popup-main","reload-current":""},on:{"click":_vm.editTemplate}},[_c('f7-icon',{attrs:{"material":"edit"}})],1)],1)}),0)]):_c('div',{staticClass:"center-content",staticStyle:{"height":"70%"}},[_c('f7-preloader',{attrs:{"size":"68px"}})],1)],1)],1)};
	var __vue_staticRenderFns__$1 = [];

	  /* style */
	  var __vue_inject_styles__$1 = undefined;
	  /* scoped */
	  var __vue_scope_id__$1 = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$1 = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$1 = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$1 = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$1, staticRenderFns: __vue_staticRenderFns__$1 },
	    __vue_inject_styles__$1,
	    __vue_script__$1,
	    __vue_scope_id__$1,
	    __vue_is_functional_template__$1,
	    __vue_module_identifier__$1,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//

	var script$2 = {
	  data: function data() {
	    return {
	      badgeCount: 0,
	    };
	  },
	  mounted: function mounted() {
	    var self = this;
	    Brief$1.events.$on('streams-badge-refresh', function (count) {
	      self.badgeCount = count;
	    });
	  },
	};

	/* script */
	var __vue_script__$2 = script$2;

	/* template */
	var __vue_render__$2 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.badgeCount > 0),expression:"badgeCount > 0"}],staticClass:"badge streams-count-badge color-red"},[_vm._v(_vm._s(_vm.badgeCount))])};
	var __vue_staticRenderFns__$2 = [];

	  /* style */
	  var __vue_inject_styles__$2 = undefined;
	  /* scoped */
	  var __vue_scope_id__$2 = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$2 = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$2 = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$2 = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$2, staticRenderFns: __vue_staticRenderFns__$2 },
	    __vue_inject_styles__$2,
	    __vue_script__$2,
	    __vue_scope_id__$2,
	    __vue_is_functional_template__$2,
	    __vue_module_identifier__$2,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//

	var script$3 = {
	  props: ['use-img', 'files', 'createMode', 'lazy', 'attachments', 'message-id', 'message-type'],
	  data: function data() {
	    return {
	      mobileDevice: Utils$1.mobileDevice(),
	    };
	  },
	  computed: {
	    createModeComputed: function createModeComputed() {
	      var self = this;
	      return self.createMode || false;
	    },
	  },
	  mounted: function mounted() {
	    var self = this;
	    self.swiper = null;
	    if (self.attachments) { return; }
	    Brief$1.events.$on('files-updated', self.initSwipers);
	    self.initSwipers();
	  },
	  beforeDestroy: function beforeDestroy() {
	    var self = this;
	    if (self.attachments) { return; }
	    Brief$1.events.$off('files-updated', self.initSwipers);
	    if (self.swiper) { self.swiper.destroy(); }
	  },
	  methods: {
	    initSwipers: function initSwipers() {
	      var self = this;
	      self.$nextTick(function () {
	        if (self.swiper) {
	          if (self.createMode) { self.swiper.destroy(); } else { return; }
	        }

	        var $el = $$1(self.$el);
	        var $swiperContainer = $el;
	        if ($swiperContainer.length === 0) { return; }

	        var $swiperImages = $el.find('.message-image');
	        if ($swiperImages.length <= 1) { return; }

	        var $swiperPagination = $el.find('.swiper-pagination');
	        var $swiperNextButton = $swiperContainer.find('.swiper-button-next');
	        var $swiperPrevButton = $swiperContainer.find('.swiper-button-prev');

	        self.swiper = Brief$1.f7.swiper.create($swiperContainer[0], {
	          spaceBetween: 10,
	          slidesPerView: self.createMode ? 2 : 1,
	          centeredSlides: self.createMode,
	          preloadImages: false,
	          updateOnImagesReady: true,
	          pagination: {
	            el: $swiperPagination[0],
	            hide: false,
	            clickable: true,
	          },
	          navigation: {
	            nextEl: $swiperNextButton[0],
	            prevEl: $swiperPrevButton[0],
	          },
	          lazy: self.lazy,
	        });

	        if (self.createMode) {
	          setTimeout(function () {
	            self.swiper.slideTo($swiperImages.length - 1);
	          }, 10);
	        }
	      });
	    },
	    attachmentDelete: function attachmentDelete(file) {
	      this.$emit('attachmentDelete', file);
	    },
	    fileClick: function fileClick() {
	      if (!this.$listeners.click) {
	        return;
	      }
	      this.$listeners.click();
	    },
	  },
	};

	/* script */
	var __vue_script__$3 = script$3;

	/* template */
	var __vue_render__$3 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.attachments)?_c('f7-swiper',{staticClass:"message-attachments",class:{'message-attachments-multiple': _vm.files.length > 1},attrs:{"pagination":true,"navigation":!_vm.mobileDevice && _vm.files && _vm.files.length > 1,"init":false}},_vm._l((_vm.files),function(file,index){return _c('f7-swiper-slide',[(index > 0 && _vm.useImg && _vm.lazy)?_c('f7-preloader',{staticClass:"swiper-lazy-preloader"}):_vm._e(),_vm._v(" "),_c('common-file',{attrs:{"file":file,"createMode":_vm.createModeComputed,"use-img":_vm.useImg,"lazy":_vm.lazy,"index":index,"message-id":_vm.messageId,"message-type":_vm.messageType,"use-custom-click":!!_vm.$listeners.click},on:{"click":_vm.fileClick}})],1)}),1):_c('div',{staticClass:"messagebar-attachments"},_vm._l((_vm.files),function(file,index){return _c('div',{staticClass:"messagebar-attachment"},[(!file.isReady && _vm.createModeComputed)?_c('div',{staticClass:"preloader-wrap"},[_c('f7-preloader',{attrs:{"color":"white"}})],1):_vm._e(),_vm._v(" "),_c('common-file',{attrs:{"file":file,"message-id":_vm.messageId,"message-type":_vm.messageType,"createMode":_vm.createModeComputed,"use-img":_vm.useImg,"lazy":_vm.lazy,"index":index}}),_vm._v(" "),_c('div',{staticClass:"messagebar-attachment-delete",on:{"click":function($event){return _vm.attachmentDelete(file)}}})],1)}),0)};
	var __vue_staticRenderFns__$3 = [];

	  /* style */
	  var __vue_inject_styles__$3 = undefined;
	  /* scoped */
	  var __vue_scope_id__$3 = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$3 = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$3 = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$3 = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$3, staticRenderFns: __vue_staticRenderFns__$3 },
	    __vue_inject_styles__$3,
	    __vue_script__$3,
	    __vue_scope_id__$3,
	    __vue_is_functional_template__$3,
	    __vue_module_identifier__$3,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	var script$4 = {
	  props: ['file', 'createMode', 'use-img', 'index', 'lazy', 'use-custom-click', 'message-id', 'message-type'],
	  computed: {
	    isImage: function isImage() {
	      var contentType = this.file.type || this.file.contentType;
	      if (!contentType) { return false; }
	      return contentType.startsWith('image');
	    },
	    isVideo: function isVideo() {
	      var contentType = this.file.type || this.file.contentType;
	      if (!contentType) { return false; }
	      return contentType.startsWith('video') || contentType.startsWith('application/octet-stream');
	    },
	    isDocument: function isDocument() {
	      var contentType = this.file.type || this.file.contentType;
	      if (!contentType) { return false; }
	      return !contentType.startsWith('image') && !contentType.startsWith('video') && !contentType.startsWith('application/octet-stream');
	    },
	  },
	  // eslint-disable-next-line
	  render: function render(c) {
	    var self = this;
	    var tag;
	    if (self.isImage) {
	      tag = 'common-image';
	    }
	    if (self.isVideo) {
	      tag = 'common-video';
	    }
	    if (self.isDocument) {
	      tag = 'common-document';
	    }
	    if (tag) {
	      return c(tag, {
	        props: {
	          file: self.file,
	          createMode: self.createMode,
	          useImg: self.useImg,
	          index: self.index,
	          lazy: self.lazy,
	          messageId: self.messageId,
	          messageType: self.messageType,
	        },
	        on: self.useCustomClick ? {
	          click: self.$listeners.click,
	        } : undefined,
	      });
	    }
	  },
	};

	/* script */
	var __vue_script__$4 = script$4;

	/* template */

	  /* style */
	  var __vue_inject_styles__$4 = undefined;
	  /* scoped */
	  var __vue_scope_id__$4 = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$4 = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$4 = undefined;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$4 = /*#__PURE__*/normalizeComponent(
	    {},
	    __vue_inject_styles__$4,
	    __vue_script__$4,
	    __vue_scope_id__$4,
	    __vue_is_functional_template__$4,
	    __vue_module_identifier__$4,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	function getImageUrl(image, height) {
	  if ( height === void 0 ) height = null;

	  var self = this;
	  var url = '';
	  if (self.createMode || image.isFromSrc) {
	    url = image.src;
	  } else if (image.filename) {
	    url = self.path.imageUrl(image.filename);
	  } else {
	    url = image.url;
	  }
	  if (!self.createMode && !image.isFromSrc && url) {
	    if (url.indexOf('?') === -1) {
	      url = url + "?autorotate=true";
	    } else {
	      url = url + "&autorotate=true";
	    }
	    url = url + "&h=" + height;
	  }
	  return url;
	}

	function getRenderedSize(image) {
	  var maxWidth = Brief$1.viewMain.el.offsetWidth;
	  var maxHeight = 300;
	  var scaledWidth = Math.min(maxWidth, image.width);
	  var scaledHeight = Math.min(maxHeight, image.height);
	  var ratioWidth = scaledWidth / image.width;
	  var ratioHeight = scaledHeight / image.height;
	  var ratio = Math.min(ratioWidth, ratioHeight);

	  return {
	    width: image.width * ratio,
	    height: image.height * ratio,
	  };
	}

	var script$5 = {
	  render: function render(c) {
	    var self = this;
	    var file = self.file;
	    var url;
	    if (self.createMode) {
	      url = file.src;
	    } else if (!file.url) {
	      url = self.path.imageUrl(file.filename || file.id || file.fileId, ("autorotate=true&h=" + (self.imageSize)));
	    } else if (file.url) {
	      url = file.url;
	    }
	    if (file.src && !file.url) {
	      url = file.src;
	    }
	    if (self.useImg) {
	      var newImageSize = getRenderedSize(file);
	      var src;
	      if (self.$el && self.lazy) {
	        // Already rendered
	        src = url;
	      } else {
	        src = self.lazy ? undefined : url;
	      }
	      return c('img', {
	        staticClass: 'message-image',
	        attrs: {
	          src: src,
	          'data-src': self.lazy ? url : undefined,
	        },
	        style: {
	          width: ((newImageSize.width) + "px"),
	          height: ((newImageSize.height) + "px"),
	        },
	        class: {
	          'swiper-lazy': self.lazy && self.index > 0,
	          lazy: self.lazy && self.index === 0,
	        },
	        on: {
	          click: self.$listeners.click || self.viewImage,
	          load: function load(event) {
	            event.target.style.width = '';
	            event.target.style.height = '';
	          },
	        },
	      });
	    }
	    return c('span', {
	      staticClass: 'message-image',
	      style: {
	        'background-image': ("url(" + url + ")"),
	      },
	      on: {
	        click: self.$listeners.click || self.viewImage,
	      },
	    });
	  },
	  props: ['file', 'createMode', 'use-img', 'index', 'lazy'],
	  data: function data() {
	    return {
	      imageSize: Brief$1.f7.device.pixelRatio > 1 ? '500' : '300',
	    };
	  },
	  methods: {
	    viewImage: function viewImage() {
	      var self = this;
	      var images = [];
	      var selectedIndex = 0;
	      var selectedImageId = self.file.id || self.file.url;

	      var parent = self.$parent;
	      var files;
	      while (parent && !files) {
	        if (parent.files) {
	          files = parent.files;
	        }
	        parent = parent.$parent;
	      }
	      if (!files) {
	        return;
	      }

	      var imagesData = files.filter(function (file) { return file.contentType && file.contentType.startsWith('image'); });
	      for (var i = 0; i < imagesData.length; i += 1) {
	        var image = imagesData[i];

	        var currentId = image.id || image.url;
	        if (currentId === selectedImageId) { selectedIndex = i; }

	        var url = getImageUrl.bind(self)(image, 1000);

	        if (url) {
	          images.push(url);
	        }
	      }

	      function renderNavbar() {
	        return "\n        <div class=\"navbar\">\n          <div class=\"navbar-inner sliding\">\n            <div class=\"left\">\n              <a href=\"#\" class=\"link icon-only photobrowser-download\">\n                <i class=\"icon material-icons color-white\">file_download</i>\n              </a>\n            </div>\n            <div class=\"title\">\n              <span class=\"photo-browser-current\"></span>\n              <span class=\"photo-browser-of\">of</span>\n              <span class=\"photo-browser-total\"></span>\n            </div>\n            <div class=\"right\">\n              <a href=\"#\" class=\"link popup-close\" data-popup=\".photo-browser-popup\">\n                <i class=\"icon material-icons color-white\" style=\"font-size: 30px;\">close</i>\n              </a>\n            </div>\n          </div>\n        </div> ";
	      }
	      var photoBrowser = Brief$1.f7.photoBrowser.create({
	        photos: images,
	        navbar: true,
	        toolbar: Brief$1.isDesktop,
	        exposition: !Brief$1.isDesktop,
	        backLinkText: 'Close',
	        theme: 'dark',
	        renderNavbar: Brief$1.isCordova ? renderNavbar : undefined,
	        swiper: {
	          initialSlide: selectedIndex,
	          lazy: true,
	        },
	        on: {
	          open: function open(pb) {
	            if (Brief$1.isCordova) {
	              $$1(pb.$containerEl || pb.$el).find('.photobrowser-download').on('click', function (e) {
	                e.preventDefault();
	                Brief$1.f7.preloader.show();
	                var src = getImageUrl.bind(self)(imagesData[pb.swiper.activeIndex], null);
	                window.plugins.socialsharing.shareWithOptions({
	                  files: [src],
	                }, function () {
	                  Brief$1.f7.preloader.hide();
	                }, function () {
	                  Brief$1.f7.preloader.hide();
	                });
	              });
	            }
	          },
	          close: function close(browser) {
	            $$1(browser.container).find('img').off('taphold');
	          },
	        },
	      });

	      photoBrowser.open();
	      if (!Brief$1.isCordova) {
	        document.addEventListener('keydown', function(e) {
	          if (e.code === 'Escape' && photoBrowser) {
	            photoBrowser.close();
	            photoBrowser = null;
	          }
	        }, false);
	      }
	    },
	    shareImage: function shareImage() {
	      var self = this;
	      var url = getImageUrl.bind(self)(self.file);
	      if (window.plugins && window.plugins.socialsharing) { window.plugins.socialsharing.share(null, null, url); }
	    },
	  },
	};

	/* script */
	var __vue_script__$5 = script$5;

	/* template */

	  /* style */
	  var __vue_inject_styles__$5 = undefined;
	  /* scoped */
	  var __vue_scope_id__$5 = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$5 = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$5 = undefined;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$5 = /*#__PURE__*/normalizeComponent(
	    {},
	    __vue_inject_styles__$5,
	    __vue_script__$5,
	    __vue_scope_id__$5,
	    __vue_is_functional_template__$5,
	    __vue_module_identifier__$5,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//

	var script$6 = {
	  props: ['file', 'createMode'],
	  data: function data() {
	    return {
	      isStarted: false,
	    };
	  },
	  mounted: function mounted() {
	    var self = this;
	    Brief$1.events.$on('video-started', self.stopVideo);
	  },
	  beforeDestroy: function beforeDestroy() {
	    var self = this;
	    Brief$1.events.$off('video-started', self.stopVideo);
	  },
	  methods: {
	    startVideo: function startVideo() {
	      var self = this;
	      Brief$1.events.$emit('video-started', self);
	      self.isStarted = true;
	    },
	    stopVideo: function stopVideo(current) {
	      var self = this;
	      if (current === self) { return; }
	      self.isStarted = false;
	    },
	  },
	  computed: {
	    src: function src() {
	      var self = this;

	      var fileSrc = self.file.filename || self.file.url;
	      if (fileSrc.startsWith('http'))
	        { return fileSrc; }

	      return self.path.documentUrl(fileSrc);
	    },
	  },
	};

	/* script */
	var __vue_script__$6 = script$6;

	/* template */
	var __vue_render__$4 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"video-container"},[(!_vm.isStarted)?_c('span',{staticClass:"message-image message-image-video-placeholder",style:('background-image: url(' + _vm.path.documentIconUrl('play') + ')'),attrs:{"src":_vm.path.documentIconUrl('play')},on:{"click":_vm.startVideo}}):_vm._e(),_vm._v(" "),(_vm.isStarted)?_c('video',{staticClass:"message-image message-image-video",attrs:{"src":_vm.src,"type":_vm.file.contentType,"height":_vm.file.height || 260,"width":_vm.file.width || 260,"controls":"","autoplay":""}}):_vm._e()])};
	var __vue_staticRenderFns__$4 = [];

	  /* style */
	  var __vue_inject_styles__$6 = undefined;
	  /* scoped */
	  var __vue_scope_id__$6 = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$6 = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$6 = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$6 = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$4, staticRenderFns: __vue_staticRenderFns__$4 },
	    __vue_inject_styles__$6,
	    __vue_script__$6,
	    __vue_scope_id__$6,
	    __vue_is_functional_template__$6,
	    __vue_module_identifier__$6,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//

	var extensionsWithIcons = {
	  pdf: 'pdf',
	  txt: 'txt',
	  doc: 'doc',
	  docx: 'doc',
	  xls: 'xls',
	  xlsx: 'xls',
	};
	var script$7 = {
	  props: ['file', 'createMode', 'message-id', 'message-type'],
	  computed: {
	    icon: {
	      get: function get() {
	        var filename = (this.file.filename || this.file.originalFilename);
	        if (!filename)
	          { return 'document'; }

	        var extension = filename.split('.');
	        extension = extension[extension.length - 1];
	        // eslint-disable-next-line
	        return extensionsWithIcons.hasOwnProperty(extension)
	          ? (("ext-" + (extensionsWithIcons[extension])))
	          : 'document';
	      },
	    },
	  },
	  methods: {
	    viewDocument: function viewDocument() {
	      var self = this;
	      var url;
	      if (self.messageType === 'email' && !self.file.filename) {
	        url = (self.domain) + "api/email/attachment?id=" + (self.messageId) + "&name=" + (self.file.originalFilename);
	      } else {
	        url = self.path.documentUrl(self.file);
	      }
	      Brief$1.openInSystemBrowser(url);
	    },
	  },
	};

	/* script */
	var __vue_script__$7 = script$7;

	/* template */
	var __vue_render__$5 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.createMode)?_c('span',{staticClass:"message-image",style:('background-image: url(' + _vm.path.documentIconUrl('document') + ')'),on:{"click":_vm.viewDocument}}):_c('span',{staticClass:"message-image message-image-document",style:('background-image:url(' + _vm.path.documentIconUrl(_vm.icon) + ')'),on:{"click":_vm.viewDocument}})};
	var __vue_staticRenderFns__$5 = [];

	  /* style */
	  var __vue_inject_styles__$7 = undefined;
	  /* scoped */
	  var __vue_scope_id__$7 = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$7 = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$7 = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$7 = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$5, staticRenderFns: __vue_staticRenderFns__$5 },
	    __vue_inject_styles__$7,
	    __vue_script__$7,
	    __vue_scope_id__$7,
	    __vue_is_functional_template__$7,
	    __vue_module_identifier__$7,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//

	var script$8 = {
	  props: ['avatar', 'type', 'small'],
	  computed: {
	    photoUrl: function photoUrl() {
	      var defaultAvatar = this.type === 'team' ? 'team_avatar.png' : 'avatar.png';
	      if (this.avatar && this.avatar.avatarUrl)
	        { return this.avatar.avatarUrl; }
	      return this.path.imageUrl(
	        this.avatar && this.avatar.filename ? this.avatar.filename : defaultAvatar,
	        ("h=" + (Math.ceil(34 * Brief$1.f7.device.pixelRatio)) + "&404=avatar&autorotate=true")
	      );
	    },
	  },
	};

	/* script */
	var __vue_script__$8 = script$8;

	/* template */
	var __vue_render__$6 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:{ 'common-avatar': true, 'small': _vm.small },style:('background-image:url(' + _vm.photoUrl + ');')})};
	var __vue_staticRenderFns__$6 = [];

	  /* style */
	  var __vue_inject_styles__$8 = undefined;
	  /* scoped */
	  var __vue_scope_id__$8 = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$8 = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$8 = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$8 = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$6, staticRenderFns: __vue_staticRenderFns__$6 },
	    __vue_inject_styles__$8,
	    __vue_script__$8,
	    __vue_scope_id__$8,
	    __vue_is_functional_template__$8,
	    __vue_module_identifier__$8,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//

	function handleFocusEvent() {
	  var self = this;
	  var $input = $$1(self.$el).find('input');
	  setTimeout(function () {
	    $input.focus();
	  }, 900);
	}
	function handlePostTag(response) {
	  var self = this;

	  if (response.success) {
	    var tempTag = {
	      name: self.query,
	      displayField: ("#" + (self.query)),
	    };
	    self.$emit('selecteditems:add', tempTag);
	    self.queryHolder = '';
	  }
	}
	function selectRange(input, iStart, iLength) {
	  if (input.createTextRange) {
	    var oRange = input.createTextRange();
	    oRange.moveStart('character', iStart);
	    oRange.moveEnd('character', iLength - input.value.length);
	    oRange.select();
	  } else if (input.setSelectionRange) {
	    input.setSelectionRange(iStart, iLength);
	  }
	  input.focus();
	}
	function typeAhead(input, sSuggestion) {
	  if (input.createTextRange || input.setSelectionRange) {
	    var iLen = input.value.length;
	    input.value = sSuggestion;
	    this.queryHolder = sSuggestion;
	    selectRange(input, iLen, sSuggestion.length);
	  }
	}
	function isQueryHasHashKey() {
	  return !Utils$1.isUndefined(this.query) && this.query.indexOf('#') >= 0;
	}
	function tagSearch(query) {
	  var self = this;
	  query = query || self.query;

	  self.store.tmpQuery = Utils$1.isUndefined(query) ? '' : query.replace('#', '');

	  if (Utils$1.isUndefined(self.store.tmpQuery)) {
	    self.tags = [];
	    return;
	  }
	  self.store.postNow({
	    query: self.store.tmpQuery,
	    take: 6,
	  });
	}
	function createDisplayField(store, tag) {
	  tag.displayField = "#" + (Utils$1.highlight(store.tmpQuery, tag.name));
	}
	function handlePostTags(response) {
	  var self = this;
	  var tmpSelected = Utils$1.isUndefined(this.selectedItems) ? [] : this.selectedItems.map(function (item) { return item.name; });
	  if (response.success) {
	    self.store.tags = response.data.tags.filter(function (tag) { return tmpSelected.indexOf(tag.name) === -1; });
	    self.store.tags.forEach(function (tag) {
	      createDisplayField(self.store, tag);
	    });
	  }
	}

	var script$9 = {
	  props: {
	    hashTagSearch: Boolean,
	    selectedItems: Array,
	    title: {
	      type: String,
	      default: 'Search',
	    },
	    query: String,
	    forceFocusEvent: [String, Boolean],
	    disableHashTag: Boolean,
	    enableTagSaving: Boolean,
	    suggestion: String,
	    preloader: Boolean,
	    name: String,
	    wrap: Boolean,
	    searchIcon: {
	      type: Boolean,
	      default: true,
	    },
	  },
	  data: function data() {
	    var self = this;
	    var store = new Store(self, {
	      postNow: ['tag', 'list'],
	      postNowFinished: handlePostTags,
	    });
	    var storeCreate = new Store(self, {
	      postNow: ['tag', 'create'],
	      postNowFinished: handlePostTag,
	    });
	    store.tagIndex = -1;
	    store.tags = [];
	    store.isEnterKey = false;
	    store.keyCode = null;
	    store.tmpQuery = '';
	    return {
	      store: store,
	      storeCreate: storeCreate,
	      controlId: parseInt((Math.random() * 100000), 10).toString(),
	      oldInputValue: '',
	    };
	  },
	  mounted: function mounted() {
	    var self = this;
	    self.$nextTick(function () {
	      if (self.forceFocusEvent) {
	        $$1(document).on(self.forceFocusEvent, handleFocusEvent.bind(self));
	      }
	    });
	  },
	  computed: {
	    queryHolder: {
	      get: function get() {
	        return this.query;
	      },
	      set: function set(newValue) {
	        var self = this;
	        var query = newValue;
	        if (self.query !== query) {
	          self.$emit('querychange', query);

	          if (!self.disableHashTag) {
	            if (Utils$1.isUndefined(query) && Utils$1.isUndefined(self.selectedItems)) { self.$emit('hashtagsearchchange', false); }

	            if ((self.hashTagSearch && !self.store.isEnterKey) || !Utils$1.isUndefined(self.selectedItems)) { tagSearch.bind(self)(query); }

	            if (self.store.isEnterKey && Utils$1.isUndefined(self.selectedItems)) { self.$emit('hashtagsearchchange', false); }
	          }
	          if (!self.hashTagSearch && Utils$1.isUndefined(self.selectedItems)) {
	            self.store.isEnterKey = false;
	          }
	        }
	      },
	    },
	  },
	  beforeDestroy: function beforeDestroy() {
	    var self = this;
	    if (self.forceFocusEvent) {
	      $$1(document).on(self.forceFocusEvent, handleFocusEvent.bind(this));
	    }
	    self.store.dispose();
	    self.storeCreate.dispose();
	  },
	  methods: {
	    cancel: function cancel() {
	      if (!this.disableHashTag) {
	        if (Utils$1.isUndefined(this.selectedItems)) { this.$emit('hashtagsearchchange', false); }
	      }
	      this.queryHolder = null;
	    },
	    reloadOnEmpty: function reloadOnEmpty() {
	      if (Utils$1.isUndefined(this.selectedItems)) {
	        var self = this;

	        if (!Utils$1.isUndefined(self.query)) { return; }
	        this.$emit('querychange', this.query);
	      }
	    },
	    addNewTag: function addNewTag(tag) {
	      var self = this;
	      self.storeCreate.postNow({ name: tag || self.query });
	    },
	    onEnter: function onEnter() {
	      if (this.store.tags.length === 0 && this.enableTagSaving) {
	        this.addNewTag();
	      }
	      if (this.store.tagIndex > -1) {
	        this.store.isEnterKey = true;
	        if (Utils$1.isUndefined(this.selectedItems)) {
	          this.queryHolder = "#" + (this.store.tags[this.store.tagIndex].name);
	        } else {
	          this.$emit('selecteditems:add', this.store.tags[this.store.tagIndex]);
	          this.queryHolder = '';
	        }
	        this.store.tagIndex = -1;
	        this.store.tags = [];
	      } else {
	        this.$emit('enterpress', this.query);
	      }
	    },
	    onUp: function onUp() {
	      if (!this.disableHashTag) {
	        if (this.store.tagIndex <= 0) { return; }
	        this.store.tagIndex -= 1;
	      }
	    },
	    onDown: function onDown() {
	      if (!this.disableHashTag) {
	        if (this.store.tagIndex >= this.store.tags.length - 1) { return; }
	        this.store.tagIndex += 1;
	      }
	    },
	    onTagClick: function onTagClick(tag) {
	      if (!Utils$1.isUndefined(tag)) {
	        this.store.isEnterKey = true;
	        if (Utils$1.isUndefined(this.selectedItems)) {
	          this.$emit('querychange', '');
	          this.queryHolder = "#" + (tag.name);
	        } else {
	          this.$emit('selecteditems:add', tag);
	          this.queryHolder = '';
	        }
	        this.store.tagIndex = -1;
	        this.store.tags = [];
	      }
	    },
	    onKeyUp: function onKeyUp(event) {
	      this.oldInputValue = event.target.value;
	    },
	    onInput: function onInput() {
	      var self = this;
	      var input = $$1(("#" + (self.controlId)));
	      var value = input.val().trim();

	      if (!this.disableHashTag) {
	        if (value.indexOf('#') === 0) {
	          self.$emit('hashtagsearchchange', true);
	        } else {
	          self.$emit('hashtagsearchchange', false);
	        }
	      }
	      if (!Utils$1.isUndefined(self.suggestion)) {
	        if (value.indexOf('@') < 0 || value.indexOf('@') !== value.length - 1) { return; }
	        if (
	          (self.oldInputValue === value + self.suggestion) ||
	          (
	            self.oldInputValue.indexOf('@') < self.oldInputValue.length - 1 &&
	            self.oldInputValue.indexOf('@') >= 0)
	        ) {
	          return;
	        }
	        typeAhead.bind(self)(input[0], value + self.suggestion);
	      }
	    },
	    onBack: function onBack() {
	      if (!this.disableHashTag) {
	        if (isQueryHasHashKey.bind(this)()) { this.$emit('hashtagsearchchange', true); }
	      }
	    },
	    onTab: function onTab() {
	      var self = this;

	      if (Utils$1.isUndefined(self.query)) { self.store.tags = []; }
	    },
	    onRemove: function onRemove(item) {
	      var index = this.selectedItems.indexOf(item);
	      this.$emit('selecteditems:remove', index);
	    },
	  },
	};

	/* script */
	var __vue_script__$9 = script$9;

	/* template */
	var __vue_render__$7 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'searchbar-wrap' : _vm.wrap}},[_c('div',{staticClass:"searchbar",class:{'searchbar-not-empty': _vm.query != null && _vm.query.length > 0}},[_c('div',{staticClass:"searchbar-inner"},[(_vm.selectedItems && _vm.selectedItems.length> 0)?_c('div',{staticClass:"tags-list"},_vm._l((_vm.selectedItems),function(item){return _c('f7-chip',{attrs:{"text":item.name,"deleteable":""},on:{"delete":function($event){return _vm.onRemove(item)}}})}),1):_vm._e(),_vm._v(" "),(_vm.name)?_c('div',{staticClass:"item-title",staticStyle:{"padding-right":"5px"}},[_vm._v(_vm._s(_vm.name))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"searchbar-input-wrap"},[(_vm.searchIcon)?_c('i',{staticClass:"searchbar-icon"}):_vm._e(),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.queryHolder),expression:"queryHolder"}],staticStyle:{"height":"inherit"},attrs:{"type":"search","placeholder":_vm.title,"name":_vm.controlId,"id":_vm.controlId,"autocomplete":"new-password"},domProps:{"value":(_vm.queryHolder)},on:{"keyup":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.onEnter.apply(null, arguments)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"up",38,$event.key,["Up","ArrowUp"])){ return null; }return _vm.onUp.apply(null, arguments)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"down",40,$event.key,["Down","ArrowDown"])){ return null; }return _vm.onDown.apply(null, arguments)},function($event){if(!$event.type.indexOf('key')&&$event.keyCode!==8){ return null; }return _vm.onBack.apply(null, arguments)},_vm.onKeyUp],"blur":_vm.reloadOnEmpty,"input":[function($event){if($event.target.composing){ return; }_vm.queryHolder=$event.target.value;},_vm.onInput],"keydown":function($event){if(!$event.type.indexOf('key')&&$event.keyCode!==9){ return null; }return _vm.onTab.apply(null, arguments)}}}),_vm._v(" "),(_vm.preloader)?_c('f7-preloader'):_c('span',{staticClass:"input-clear-button",on:{"click":_vm.cancel}})],1),_vm._v(" "),(_vm.hashTagSearch && _vm.enableTagSaving && _vm.queryHolder && _vm.queryHolder.length && (!_vm.store.tags || _vm.store.tags.length === 0))?_c('a',{staticClass:"link icon-only save-tag-link",attrs:{"href":"#"},on:{"click":function($event){return _vm.addNewTag()}}},[_c('f7-icon',{attrs:{"if-ios":"f7:add_round_fill","if-md":"material:add_circle"}})],1):_vm._e()])]),_vm._v(" "),(_vm.hashTagSearch && (_vm.store.tags != null && _vm.store.tags.length > 0))?_c('div',{staticClass:"list tags-search-results"},[_c('ul',_vm._l((_vm.store.tags),function(item,index){return _c('li',[_c('a',{staticClass:"item-link item-content",class:{'itemSelected': index == _vm.store.tagIndex},attrs:{"href":"#"},on:{"click":function($event){return _vm.onTagClick(item)}}},[_c('div',{staticClass:"item-inner"},[_c('div',{staticClass:"item-title",domProps:{"innerHTML":_vm._s(item.displayField)}})])])])}),0)]):_vm._e()])};
	var __vue_staticRenderFns__$7 = [];

	  /* style */
	  var __vue_inject_styles__$9 = undefined;
	  /* scoped */
	  var __vue_scope_id__$9 = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$9 = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$9 = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$9 = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$7, staticRenderFns: __vue_staticRenderFns__$7 },
	    __vue_inject_styles__$9,
	    __vue_script__$9,
	    __vue_scope_id__$9,
	    __vue_is_functional_template__$9,
	    __vue_module_identifier__$9,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//

	var script$a = {
	  props: {
	    root: Boolean,
	    title: String,
	    type: String,
	    contactId: String,
	    subtitle: String,
	    titleLink: [Boolean, String],
	    canSearch: Boolean,
	    canAssign: Boolean,
	    notesCount: Number,
	  },
	  updated: function updated() {
	    var this$1 = this;

	    this.$nextTick(function () {
	      if (this$1.$f7 && this$1.innerEl && this$1.$theme.ios) {
	        this$1.$f7.navbar.size(this$1.innerEl);
	      }
	    });
	  },
	  mounted: function mounted() {
	    this.innerEl = this.$el.querySelector('.navbar-inner');
	  },
	  computed: {
	    rootComputed: function rootComputed() {
	      return this.root;
	    },
	    assignLink: function assignLink() {
	      return ("/" + (this.type) + "/" + (this.$f7route.params.channelId) + "/assign/" + (this.$f7route.params.conversationId) + "/");
	    },
	  },
	  methods: {
	    openNotes: function openNotes() {
	      var self = this;
	      Brief$1.f7.panel.open('right');
	      Brief$1.viewRight.router.navigate(("/notes/" + (self.contactId) + "/?conversationId=" + (this.$f7route.params.conversationId)));
	    },
	    search: function search(bar, query) {
	      this.query = query;
	      this.debounceSearch();
	    },
	    clear: function clear() {
	      this.query = '';
	      this.debounceSearch();
	    },
	    enable: function enable() {
	      this.query = '';
	      this.debounceSearch();
	    },
	    disable: function disable() {
	      this.query = '';
	      this.debounceSearch();
	    },
	    debounceSearch: lodash.debounce(function debounceSearch() {
	      Brief$1.events.$emit('topsearch', this.query);
	    }, 500),
	  },
	};

	/* script */
	var __vue_script__$a = script$a;

	/* template */
	var __vue_render__$8 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f7-navbar',[_c('f7-searchbar',{staticClass:"searchbar-demo",attrs:{"expandable":"","custom-search":true,"backdrop":false},on:{"searchbar:search":_vm.search,"searchbar:clear":_vm.clear,"searchbar:enable":_vm.enable,"searchbar:disable":_vm.disable}}),_vm._v(" "),_c('f7-nav-left',[_c('common-nav-placeholder')],1),_vm._v(" "),_c('f7-nav-title',{attrs:{"sliding":"","title":_vm.titleLink ? undefined : _vm.title,"subtitle":_vm.subtitle}},[(_vm.titleLink)?_c('f7-link',{class:_vm.subtitle ? 'hasSubtitle' : '',attrs:{"href":_vm.titleLink}},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_vm._v(" "),(_vm.titleLink && _vm.subtitle)?_c('span',{staticClass:"subtitle"},[_vm._v(_vm._s(_vm.subtitle))]):_vm._e()],1),_vm._v(" "),(_vm.$slots['nav-right'] && _vm.$slots['nav-right'].length > 0)?_c('f7-nav-right',[_vm._t("nav-right")],2):_vm._e(),_vm._v(" "),_vm._t("default")],2)};
	var __vue_staticRenderFns__$8 = [];

	  /* style */
	  var __vue_inject_styles__$a = undefined;
	  /* scoped */
	  var __vue_scope_id__$a = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$a = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$a = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$a = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$8, staticRenderFns: __vue_staticRenderFns__$8 },
	    __vue_inject_styles__$a,
	    __vue_script__$a,
	    __vue_scope_id__$a,
	    __vue_is_functional_template__$a,
	    __vue_module_identifier__$a,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	var push;

	var PushNotificationsCordova = {
	  init: init,
	  requestPermission: requestPermission,
	  hasGrantedPermission: hasGrantedPermission,
	  hasDeniedPermission: hasDeniedPermission,
	  openDeviceSettings: openDeviceSettings
	};

	function init(attempt) {
	  if ( attempt === void 0 ) attempt = 0;

	  if (!window.PushNotification) {
	    if (attempt <= 3)
	      { setTimeout(function () { return init(attempt++); }, 3000); }
	    return;
	  }

	  hasGrantedPermission(function (hasGranted) {
	    if (!hasGranted)
	      { return; }
	    
	    requestPermission();
	    initBadgeHandler();
	  });
	}

	function requestPermission(callback) {
	  push = window.PushNotification.init({
	    android: {
	      icon: 'icon',
	      iconColor: '#7113ff',
	      sound: 'true',
	      vibrate: 'true'
	    },
	    ios: {
	      alert: 'true',
	      badge: 'true',
	      sound: 'true'
	    },
	    windows: {}
	  });
	  
	  push.on('registration', function (data) { return handlePushRegistration(data, callback); });
	  push.on('notification', handlePushNotification);
	  push.on('error', handlePushError);
	}

	function hasGrantedPermission(callback) {
	  window.PushNotification.hasPermission(function (data) {
	    callback(data.isEnabled);
	  });
	}

	function hasDeniedPermission(callback) {
	  if (window.device.platform.toLowerCase() === 'android')
	    { hasDeniedPermissionAndroid(callback); }
	  else
	    { hasDeniedPermissionIos(callback); }
	}

	function hasDeniedPermissionIos(callback) {
	  cordova.plugins.diagnostic.getRemoteNotificationsAuthorizationStatus(
	    function (status) {
	      var hasDenied = status === cordova.plugins.diagnostic.permissionStatus.DENIED_ALWAYS;
	      callback(hasDenied);
	    },
	    function (error) {
	      console.error("The following error occurred: " + error);
	      callback(false);
	    }
	  );
	}

	function hasDeniedPermissionAndroid(callback) {
	  cordova.plugins.diagnostic.isRemoteNotificationsEnabled(
	    function (notDenied) {
	      var hasDenied = !notDenied;
	      callback(hasDenied);
	    },
	    function (error) {
	      console.error("The following error occurred: " + error);
	      callback(false);
	    }
	  );
	}

	function openDeviceSettings(callback) {
	  if (window.device.platform.toLowerCase() === 'android')
	    { cordova.plugins.diagnostic.switchToNotificationSettings(callback, callback); }
	  else 
	    { cordova.plugins.diagnostic.switchToSettings(callback, callback); }
	}

	var loopIntervalRef;
	function handlePushRegistration(data, callback) {
	  loopIntervalRef = Utils$1.loopEvery(3000, function () {
	    if (window.localStorage.getItem('access_token')) {
	      clearInterval(loopIntervalRef);
	      registerDevice(data, callback);
	    }
	  });
	}

	function handlePushNotification(data) {
	  if (push && push.finish)
	    { push.finish(function () { }, function () { }, data.additionalData.notId); }
	  
	  handleBadgeCount(data.count);

	  if (!data.additionalData)
	    { return; }
	  
	  if (data.additionalData.foreground)
	    { return; }

	  var url = getUrl(data.additionalData);
	  if (!url)
	    { return; }
	  
	  window.localStorage.setItem('nuid_url', url);
	  if (data.additionalData.userId && data.additionalData.userId !== window.localStorage.getItem('user_id')) {
	    window.localStorage.setItem('nuid', data.additionalData.userId);
	    Brief$1.f7.preloader.show();
	    setTimeout(function () {
	      Brief$1.f7.preloader.hide();
	      window.location.reload();
	    }, 300);
	    return;
	  }

	  loadPageFromNotification(url);
	}

	function handleBadgeCount(currentCount) {
	  var count = +(currentCount || 0);
	  setBadge(count + 1);
	}

	function handlePushError(err) {
	  Brief$1.sendError(("Firebase handle push error: " + (JSON.stringify(err))));
	}

	function initBadgeHandler() {
	  Brief$1.events.$on('streams-badge-refresh', function (count) {
	    setBadge(count);
	  });
	}

	function registerDevice(data, callback) {
	  var device = window.device;

	  var dataToSend = {
	    access_token: window.localStorage.getItem('access_token'),
	    device_id: device.uuid,
	    token: data.registrationId,
	    type: device.platform.toLowerCase(),
	    deviceType: device.platform.toLowerCase(),
	    uuid: device.uuid,
	  };
	  
	  Brief$1.f7.request({
	    url: ((Brief$1.api) + "/firebase/subscribe"),
	    method: 'POST',
	    dataType: 'json',
	    processData: false,
	    contentType: 'application/json',
	    crossDomain: true,
	    data: JSON.stringify(dataToSend),
	    success: function success(data) {
	      if (callback) { callback(); }
	      if (!data.success)
	        { Brief$1.sendError(("Push Notification subscribe error: " + (JSON.stringify(data)))); }
	    },
	    error: function error(err) {
	      if (callback) { callback(); }
	      try {
	        Brief$1.sendError(("Failed to register device for Push Notifications: " + (JSON.stringify(dataToSend))));
	        Brief$1.sendError(("Push Notification error: " + (JSON.stringify(err))));
	      } catch (e) {
	        // failed
	      }
	    },
	  });
	}

	function loadPageFromNotification(url) {
	  Brief$1.f7.preloader.show();
	  setTimeout(function () {
	    Brief$1.f7.preloader.hide();
	    Brief$1.viewMain.router.navigate(url);
	  }, 1000);
	}

	function getUrl(data) {
	  if (data.conversationId)
	    { return ("/message/list/" + (data.pageType) + "/" + (data.pageId) + "/" + (encodeURIComponent(data.conversationId))); }
	  
	  return "";
	}

	function setBadge(count) {
	  if (!push)
	    { return; }

	  push.setApplicationIconBadgeNumber(function () {}, function () {}, count);
	}

	var messaging;

	var PushNotificationsWeb = {
	  init: init$1,
	  requestPermission: requestPermission$1,
	  hasGrantedPermission: hasGrantedPermission$1,
	  hasDeniedPermission: hasDeniedPermission$1,
	  openDeviceSettings: openDeviceSettings$1
	};

	function init$1() {
	  firebase.initializeApp({
	    apiKey: 'AIzaSyB1C2-KRFqmdsp4qdOlnn6B1IhCKh0J-LU',
	    authDomain: 'brief-prod-26280.firebaseapp.com',
	    databaseURL: 'https://brief-prod-26280.firebaseio.com',
	    projectId: 'brief-prod-26280',
	    storageBucket: 'brief-prod-26280.appspot.com',
	    messagingSenderId: '792909902493',
	  });
	  messaging = firebase.messaging();
	  messaging.usePublicVapidKey('BNIa60GauEZXg1kGCc9XMOr2BTYOE9zrEesxNXb-_n5iXqFkaUvDP6uYryQzlOPN42YO0AZiMinOXRs0VxuXM2k');
	}

	function requestPermission$1(callback) {
	  messaging.requestPermission().then(function () {
	    messaging.getToken().then(function (token) {
	      subscribe(token, callback);
	    });
	  }).catch(function (err) {
	    if (callback) { callback(err); }
	  });
	}

	function hasGrantedPermission$1(callback) {
	  callback(window.Notification.permission === 'granted');
	}

	function hasDeniedPermission$1(callback) {
	  callback(window.Notification.permission === 'denied');
	}

	function openDeviceSettings$1(callback) {
	  callback();
	}

	function subscribe(token, callback) {
	  Brief$1.f7.request.postJSON(((Brief$1.api) + "/firebase/subscribe"), {
	    token: token,
	    deviceType: 'browser',
	    device_id: window.localStorage.device_id,
	    access_token: window.localStorage.access_token,
	  }, function (err) {
	    if (callback) { callback(err); }
	  });
	}

	var STORAGE_KEY_NOTIFICATIONS_NOT_NOW = 'notifications_not_now';

	var PushNotificationsType;

	var PushNotifications = {
	  init: init$2,
	  canAskForPermission: canAskForPermission,
	  setNotNow: setNotNow,
	  getNotNow: getNotNow,
	  requestPermission: requestPermission$2,
	  hasGrantedPermission: hasGrantedPermission$2,
	  hasDeniedPermission: hasDeniedPermission$2,
	  openDeviceSettings: openDeviceSettings$2
	};

	function init$2() {
	  PushNotificationsType = Brief$1.isCordova 
	    ? PushNotificationsCordova 
	    : PushNotificationsWeb;

	  PushNotificationsType.init();
	}

	function canAskForPermission(callback) {
	  getPermissions(function (ref) {
	    var notNow = ref.notNow;
	    var hasGranted = ref.hasGranted;
	    var hasDenied = ref.hasDenied;

	    var canAskForPermission = !notNow && !hasGranted && !hasDenied;
	    callback(canAskForPermission);
	  });
	}

	function setNotNow() {
	  window.localStorage.setItem(STORAGE_KEY_NOTIFICATIONS_NOT_NOW, 'true');
	}

	function getNotNow() {
	  return window.localStorage.getItem(STORAGE_KEY_NOTIFICATIONS_NOT_NOW);
	}

	function requestPermission$2(callback) {
	  PushNotificationsType.requestPermission(callback);
	}

	function hasGrantedPermission$2(callback) {
	  PushNotificationsType.hasGrantedPermission(callback);
	}

	function hasDeniedPermission$2(callback) {
	  PushNotificationsType.hasDeniedPermission(callback);
	}

	function openDeviceSettings$2(callback) {
	  PushNotificationsType.openDeviceSettings(callback);
	}

	function getPermissions(callback) {
	  var notNow = getNotNow();
	  hasGrantedPermission$2(function (hasGranted) {
	    hasDeniedPermission$2(function (hasDenied) {
	      callback({ notNow: notNow, hasGranted: hasGranted, hasDenied: hasDenied });
	    });
	  });  
	}

	//

	var script$b = {
	  props: {
	    root: Boolean,
	  },
	  data: function data() {
	    var this$1 = this;

	    this.$nextTick(function () {
	      this$1.checkNotifications();
	      this$1.checkLimit();
	    });
	    return {
	      isCordova: Brief$1.isCordova,
	      remindEnableNotifications: false,
	      remindTurnOnNotifications: false,
	      shouldShowAlmostLimitMessage: false,
	      shouldShowLimitMessage: false,
	      shouldInactiveStatusMessage: false,
	    };
	  },
	  computed: {
	    hasPlan: function hasPlan() {
	      return this.$root.loggedInUser && this.$root.loggedInUser.plan && this.$root.loggedInUser.plan.sentMessagesIncluded !== undefined;
	    },
	    isLimit: function isLimit() {
	      if (!this.hasPlan)
	        { return false; }

	      if (this.isInactiveStatus)
	        { return false; }
	      
	      return this.$root.loggedInUser.sentMessagesCount >= this.$root.loggedInUser.plan.sentMessagesIncluded;
	    },
	    isAlmostLimit: function isAlmostLimit() {
	      if (!this.hasPlan)
	        { return false; }

	      if (this.isInactiveStatus)
	        { return false; }
	      
	      if (this.isLimit)
	        { return false; }
	      
	      return (this.$root.loggedInUser.sentMessagesCount / this.$root.loggedInUser.plan.sentMessagesIncluded) >= 0.9;
	    },
	    isInactiveStatus: function isInactiveStatus() {
	      if (!this.hasPlan)
	        { return false; }
	      
	      return this.$root.loggedInUser.plan.status !== 'active';
	    },
	  },
	  methods: {
	    enableNotifications: function enableNotifications() {
	      var self = this;
	      PushNotifications.requestPermission(function () {
	        self.remindEnableNotifications = false;
	      });
	    },
	    openDeviceSettings: function openDeviceSettings() {
	      var self = this;
	      PushNotifications.openDeviceSettings(function () {
	        self.remindTurnOnNotifications = false;
	      });
	    },
	    ignoreNotificationReminder: function ignoreNotificationReminder(e) {
	      e.preventDefault();
	      e.stopPropagation();
	      window.localStorage.setItem('notifications_ignore', 'true');
	      this.remindEnableNotifications = false;
	      this.remindTurnOnNotifications = false;
	    },
	    hideLimitMessage: function hideLimitMessage() {
	      window.localStorage.setItem('hide_limit_message', 'true');
	      window.localStorage.setItem('hide_limit_message_month', new Date().getMonth().toString());
	      this.shouldShowLimitMessage = false;
	    },
	    hideAlmostLimitMessage: function hideAlmostLimitMessage() {
	      window.localStorage.setItem('hide_almost_limit_message', 'true');
	      window.localStorage.setItem('hide_almost_limit_message_month', new Date().getMonth().toString());
	      this.shouldShowAlmostLimitMessage = false;
	    },
	    hideInactiveStatusMessage: function hideInactiveStatusMessage() {
	      window.localStorage.setItem('hide_inactive_status_message', 'true');
	      window.localStorage.setItem('hide_inactive_status_message_month', new Date().getMonth().toString());
	      this.shouldInactiveStatusMessage = false;
	    },
	    checkNotifications: function checkNotifications() {
	      var self = this;

	      if (PushNotifications.canAskForPermission(function (canAsk) {
	        if (canAsk) {
	          setTimeout(function () {
	            self.checkNotifications();
	          }, 3000);
	          return;
	        }

	        var ignoreNotificationReminder = window.localStorage.getItem('notifications_ignore');
	        if (ignoreNotificationReminder)
	          { return; }

	        PushNotifications.hasGrantedPermission(function (hasGrantedPermission) {
	          PushNotifications.hasDeniedPermission(function (hasDeniedPermission) {
	            self.remindEnableNotifications = !hasGrantedPermission && !hasDeniedPermission;
	            self.remindTurnOnNotifications = hasDeniedPermission;
	          });
	        });
	      }));
	    },
	    checkLimit: function checkLimit() {
	      var self = this;
	      var monthOfClosedLimit = window.localStorage.getItem('hide_almost_limit_message_month') || window.localStorage.getItem('hide_almost_limit_message_month') || window.localStorage.getItem('hide_inactive_status_message_month');
	      if (monthOfClosedLimit !== new Date().getMonth().toString()) {
	        window.localStorage.setItem('hide_limit_message_month', '');
	        window.localStorage.setItem('hide_almost_limit_message_month', '');
	        window.localStorage.setItem('hide_inactive_status_message_month', '');
	      }
	      var hideAlmostLimit = window.localStorage.getItem('hide_almost_limit_message');
	      if (!hideAlmostLimit) {
	        self.shouldShowAlmostLimitMessage = true;
	      }
	      var hideLimit = window.localStorage.getItem('hide_limit_message');
	      if (!hideLimit) {
	        self.shouldShowLimitMessage = true;
	      }
	      var hideInactiveStatus = window.localStorage.getItem('hide_inactive_status_message');
	      if (!hideInactiveStatus) {
	        self.shouldInactiveStatusMessage = true;
	      }
	    },
	  },
	};

	/* script */
	var __vue_script__$b = script$b;

	/* template */
	var __vue_render__$9 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.remindEnableNotifications)?_c('div',{staticClass:"top-banner blue",on:{"click":_vm.enableNotifications}},[_vm._m(0),_vm._v(" "),_c('f7-link',{staticClass:"from-banner",attrs:{"icon-only":"","icon-if-ios":"f7:close_round","icon-if-md":"material:cancel"},on:{"click":_vm.ignoreNotificationReminder}})],1):_vm._e(),_vm._v(" "),(_vm.remindTurnOnNotifications)?_c('div',{staticClass:"top-banner orange",on:{"click":_vm.openDeviceSettings}},[(_vm.isCordova)?_c('span',[_vm._v("Turn on notifications for Brief in your "),_c('u',[_vm._v("device settings")])]):_vm._e(),_vm._v(" "),(!_vm.isCordova)?_c('span',[_vm._v("Turn on notifications for Brief in your "),_c('u',[_vm._v("browser settings")])]):_vm._e(),_vm._v(" "),_c('f7-link',{staticClass:"from-banner",attrs:{"icon-only":"","icon-if-ios":"f7:close_round","icon-if-md":"material:cancel"},on:{"click":_vm.ignoreNotificationReminder}})],1):_vm._e(),_vm._v(" "),(_vm.isAlmostLimit && _vm.shouldShowAlmostLimitMessage)?_c('div',{staticClass:"top-banner orange"},[_c('span',[_vm._v("You have almost reached the monthly limit of your plan ("+_vm._s(_vm.$root.loggedInUser.plan.sentMessagesIncluded)+" messages/month). Make sure to upgrade your plan to be able to send more messages.")]),_vm._v(" "),_c('f7-button',{staticStyle:{"flex-shrink":"0"},attrs:{"href":"/plan/settings/"},on:{"click":function($event){return _vm.hideAlmostLimitMessage()}}},[_vm._v("Upgrade")]),_vm._v(" "),_c('f7-link',{staticClass:"from-banner",attrs:{"icon-only":"","icon-if-ios":"f7:close_round","icon-if-md":"material:cancel"},on:{"click":function($event){return _vm.hideAlmostLimitMessage()}}})],1):_vm._e(),_vm._v(" "),(_vm.isLimit && _vm.shouldShowLimitMessage)?_c('div',{staticClass:"top-banner red"},[_c('span',[_vm._v("You have reached the monthly limit of your plan. Upgrade your plan to be able to send messages.")]),_vm._v(" "),_c('f7-button',{staticStyle:{"flex-shrink":"0"},attrs:{"href":"/plan/settings/"},on:{"click":function($event){return _vm.hideLimitMessage()}}},[_vm._v("Upgrade")]),_vm._v(" "),_c('f7-link',{staticClass:"from-banner",attrs:{"icon-only":"","icon-if-ios":"f7:close_round","icon-if-md":"material:cancel"},on:{"click":function($event){return _vm.hideLimitMessage()}}})],1):_vm._e(),_vm._v(" "),(_vm.isInactiveStatus && _vm.shouldInactiveStatusMessage)?_c('div',{staticClass:"top-banner red"},[_c('span',[_vm._v("Subscription is inactive. Current status is \""+_vm._s(_vm.$root.loggedInUser.plan.status)+"\".")]),_vm._v(" "),_c('f7-button',{staticStyle:{"flex-shrink":"0"},attrs:{"href":"/subscription/settings/"},on:{"click":function($event){return _vm.hideInactiveStatusMessage()}}},[_vm._v("Activate")]),_vm._v(" "),_c('f7-link',{staticClass:"from-banner",attrs:{"icon-only":"","icon-if-ios":"f7:close_round","icon-if-md":"material:cancel"},on:{"click":function($event){return _vm.hideInactiveStatusMessage()}}})],1):_vm._e()])};
	var __vue_staticRenderFns__$9 = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._v("Brief needs your permission to "),_c('u',[_vm._v("enable notifications")])])}];

	  /* style */
	  var __vue_inject_styles__$b = undefined;
	  /* scoped */
	  var __vue_scope_id__$b = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$b = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$b = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$b = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$9, staticRenderFns: __vue_staticRenderFns__$9 },
	    __vue_inject_styles__$b,
	    __vue_script__$b,
	    __vue_scope_id__$b,
	    __vue_is_functional_template__$b,
	    __vue_module_identifier__$b,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//
	//
	//
	//
	//

	var script$c = {
	  props: {
	    text: String,
	    link: String,
	    href: String,
	    white: Boolean,
	    disabled: Boolean,
	  },
	  methods: {
	    onClick: function onClick(e) {
	      this.$emit('click', e);
	    },
	  },
	};

	/* script */
	var __vue_script__$c = script$c;

	/* template */
	var __vue_render__$a = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f7-toolbar',{staticClass:"toolbar-button toolbar-bottom toolbar-bottom-md",class:{'toolbar-button-white': _vm.white, 'toolbar-button-disabled': _vm.disabled}},[_c('f7-link',{attrs:{"href":_vm.link || _vm.href},on:{"click":_vm.onClick}},[_vm._t("icon-before-text"),_vm._v(_vm._s(_vm.text)),_vm._t("icon-after-text")],2)],1)};
	var __vue_staticRenderFns__$a = [];

	  /* style */
	  var __vue_inject_styles__$c = undefined;
	  /* scoped */
	  var __vue_scope_id__$c = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$c = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$c = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$c = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$a, staticRenderFns: __vue_staticRenderFns__$a },
	    __vue_inject_styles__$c,
	    __vue_script__$c,
	    __vue_scope_id__$c,
	    __vue_is_functional_template__$c,
	    __vue_module_identifier__$c,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//! moment.js
	//! version : 2.29.4
	//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
	//! license : MIT
	//! momentjs.com

	var hookCallback;

	function hooks$1() {
	    return hookCallback.apply(null, arguments);
	}

	// This is done to register the method called with moment()
	// without creating circular dependencies.
	function setHookCallback(callback) {
	    hookCallback = callback;
	}

	function isArray$2(input) {
	    return (
	        input instanceof Array ||
	        Object.prototype.toString.call(input) === '[object Array]'
	    );
	}

	function isObject$4(input) {
	    // IE8 will treat undefined and null as object if it wasn't for
	    // input != null
	    return (
	        input != null &&
	        Object.prototype.toString.call(input) === '[object Object]'
	    );
	}

	function hasOwnProp(a, b) {
	    return Object.prototype.hasOwnProperty.call(a, b);
	}

	function isObjectEmpty(obj) {
	    if (Object.getOwnPropertyNames) {
	        return Object.getOwnPropertyNames(obj).length === 0;
	    } else {
	        var k;
	        for (k in obj) {
	            if (hasOwnProp(obj, k)) {
	                return false;
	            }
	        }
	        return true;
	    }
	}

	function isUndefined(input) {
	    return input === void 0;
	}

	function isNumber(input) {
	    return (
	        typeof input === 'number' ||
	        Object.prototype.toString.call(input) === '[object Number]'
	    );
	}

	function isDate(input) {
	    return (
	        input instanceof Date ||
	        Object.prototype.toString.call(input) === '[object Date]'
	    );
	}

	function map$2(arr, fn) {
	    var res = [],
	        i,
	        arrLen = arr.length;
	    for (i = 0; i < arrLen; ++i) {
	        res.push(fn(arr[i], i));
	    }
	    return res;
	}

	function extend$1(a, b) {
	    for (var i in b) {
	        if (hasOwnProp(b, i)) {
	            a[i] = b[i];
	        }
	    }

	    if (hasOwnProp(b, 'toString')) {
	        a.toString = b.toString;
	    }

	    if (hasOwnProp(b, 'valueOf')) {
	        a.valueOf = b.valueOf;
	    }

	    return a;
	}

	function createUTC(input, format, locale, strict) {
	    return createLocalOrUTC(input, format, locale, strict, true).utc();
	}

	function defaultParsingFlags() {
	    // We need to deep clone this object.
	    return {
	        empty: false,
	        unusedTokens: [],
	        unusedInput: [],
	        overflow: -2,
	        charsLeftOver: 0,
	        nullInput: false,
	        invalidEra: null,
	        invalidMonth: null,
	        invalidFormat: false,
	        userInvalidated: false,
	        iso: false,
	        parsedDateParts: [],
	        era: null,
	        meridiem: null,
	        rfc2822: false,
	        weekdayMismatch: false,
	    };
	}

	function getParsingFlags(m) {
	    if (m._pf == null) {
	        m._pf = defaultParsingFlags();
	    }
	    return m._pf;
	}

	var some;
	if (Array.prototype.some) {
	    some = Array.prototype.some;
	} else {
	    some = function (fun) {
	        var this$1 = this;

	        var t = Object(this),
	            len = t.length >>> 0,
	            i;

	        for (i = 0; i < len; i++) {
	            if (i in t && fun.call(this$1, t[i], i, t)) {
	                return true;
	            }
	        }

	        return false;
	    };
	}

	function isValid(m) {
	    if (m._isValid == null) {
	        var flags = getParsingFlags(m),
	            parsedParts = some.call(flags.parsedDateParts, function (i) {
	                return i != null;
	            }),
	            isNowValid =
	                !isNaN(m._d.getTime()) &&
	                flags.overflow < 0 &&
	                !flags.empty &&
	                !flags.invalidEra &&
	                !flags.invalidMonth &&
	                !flags.invalidWeekday &&
	                !flags.weekdayMismatch &&
	                !flags.nullInput &&
	                !flags.invalidFormat &&
	                !flags.userInvalidated &&
	                (!flags.meridiem || (flags.meridiem && parsedParts));

	        if (m._strict) {
	            isNowValid =
	                isNowValid &&
	                flags.charsLeftOver === 0 &&
	                flags.unusedTokens.length === 0 &&
	                flags.bigHour === undefined;
	        }

	        if (Object.isFrozen == null || !Object.isFrozen(m)) {
	            m._isValid = isNowValid;
	        } else {
	            return isNowValid;
	        }
	    }
	    return m._isValid;
	}

	function createInvalid(flags) {
	    var m = createUTC(NaN);
	    if (flags != null) {
	        extend$1(getParsingFlags(m), flags);
	    } else {
	        getParsingFlags(m).userInvalidated = true;
	    }

	    return m;
	}

	// Plugins that add properties should also add the key here (null value),
	// so we can properly clone ourselves.
	var momentProperties = (hooks$1.momentProperties = []),
	    updateInProgress = false;

	function copyConfig(to, from) {
	    var i,
	        prop,
	        val,
	        momentPropertiesLen = momentProperties.length;

	    if (!isUndefined(from._isAMomentObject)) {
	        to._isAMomentObject = from._isAMomentObject;
	    }
	    if (!isUndefined(from._i)) {
	        to._i = from._i;
	    }
	    if (!isUndefined(from._f)) {
	        to._f = from._f;
	    }
	    if (!isUndefined(from._l)) {
	        to._l = from._l;
	    }
	    if (!isUndefined(from._strict)) {
	        to._strict = from._strict;
	    }
	    if (!isUndefined(from._tzm)) {
	        to._tzm = from._tzm;
	    }
	    if (!isUndefined(from._isUTC)) {
	        to._isUTC = from._isUTC;
	    }
	    if (!isUndefined(from._offset)) {
	        to._offset = from._offset;
	    }
	    if (!isUndefined(from._pf)) {
	        to._pf = getParsingFlags(from);
	    }
	    if (!isUndefined(from._locale)) {
	        to._locale = from._locale;
	    }

	    if (momentPropertiesLen > 0) {
	        for (i = 0; i < momentPropertiesLen; i++) {
	            prop = momentProperties[i];
	            val = from[prop];
	            if (!isUndefined(val)) {
	                to[prop] = val;
	            }
	        }
	    }

	    return to;
	}

	// Moment prototype object
	function Moment(config) {
	    copyConfig(this, config);
	    this._d = new Date(config._d != null ? config._d.getTime() : NaN);
	    if (!this.isValid()) {
	        this._d = new Date(NaN);
	    }
	    // Prevent infinite loop in case updateOffset creates new moment
	    // objects.
	    if (updateInProgress === false) {
	        updateInProgress = true;
	        hooks$1.updateOffset(this);
	        updateInProgress = false;
	    }
	}

	function isMoment(obj) {
	    return (
	        obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
	    );
	}

	function warn$1(msg) {
	    if (
	        hooks$1.suppressDeprecationWarnings === false &&
	        typeof console !== 'undefined' &&
	        console.warn
	    ) {
	        console.warn('Deprecation warning: ' + msg);
	    }
	}

	function deprecate(msg, fn) {
	    var firstTime = true;

	    return extend$1(function () {
	        var arguments$1 = arguments;

	        if (hooks$1.deprecationHandler != null) {
	            hooks$1.deprecationHandler(null, msg);
	        }
	        if (firstTime) {
	            var args = [],
	                arg,
	                i,
	                key,
	                argLen = arguments.length;
	            for (i = 0; i < argLen; i++) {
	                arg = '';
	                if (typeof arguments$1[i] === 'object') {
	                    arg += '\n[' + i + '] ';
	                    for (key in arguments[0]) {
	                        if (hasOwnProp(arguments$1[0], key)) {
	                            arg += key + ': ' + arguments$1[0][key] + ', ';
	                        }
	                    }
	                    arg = arg.slice(0, -2); // Remove trailing comma and space
	                } else {
	                    arg = arguments$1[i];
	                }
	                args.push(arg);
	            }
	            warn$1(
	                msg +
	                    '\nArguments: ' +
	                    Array.prototype.slice.call(args).join('') +
	                    '\n' +
	                    new Error().stack
	            );
	            firstTime = false;
	        }
	        return fn.apply(this, arguments);
	    }, fn);
	}

	var deprecations = {};

	function deprecateSimple(name, msg) {
	    if (hooks$1.deprecationHandler != null) {
	        hooks$1.deprecationHandler(name, msg);
	    }
	    if (!deprecations[name]) {
	        warn$1(msg);
	        deprecations[name] = true;
	    }
	}

	hooks$1.suppressDeprecationWarnings = false;
	hooks$1.deprecationHandler = null;

	function isFunction(input) {
	    return (
	        (typeof Function !== 'undefined' && input instanceof Function) ||
	        Object.prototype.toString.call(input) === '[object Function]'
	    );
	}

	function set$1(config) {
	    var this$1 = this;

	    var prop, i;
	    for (i in config) {
	        if (hasOwnProp(config, i)) {
	            prop = config[i];
	            if (isFunction(prop)) {
	                this$1[i] = prop;
	            } else {
	                this$1['_' + i] = prop;
	            }
	        }
	    }
	    this._config = config;
	    // Lenient ordinal parsing accepts just a number in addition to
	    // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
	    // TODO: Remove "ordinalParse" fallback in next major release.
	    this._dayOfMonthOrdinalParseLenient = new RegExp(
	        (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
	            '|' +
	            /\d{1,2}/.source
	    );
	}

	function mergeConfigs(parentConfig, childConfig) {
	    var res = extend$1({}, parentConfig),
	        prop;
	    for (prop in childConfig) {
	        if (hasOwnProp(childConfig, prop)) {
	            if (isObject$4(parentConfig[prop]) && isObject$4(childConfig[prop])) {
	                res[prop] = {};
	                extend$1(res[prop], parentConfig[prop]);
	                extend$1(res[prop], childConfig[prop]);
	            } else if (childConfig[prop] != null) {
	                res[prop] = childConfig[prop];
	            } else {
	                delete res[prop];
	            }
	        }
	    }
	    for (prop in parentConfig) {
	        if (
	            hasOwnProp(parentConfig, prop) &&
	            !hasOwnProp(childConfig, prop) &&
	            isObject$4(parentConfig[prop])
	        ) {
	            // make sure changes to properties don't modify parent config
	            res[prop] = extend$1({}, res[prop]);
	        }
	    }
	    return res;
	}

	function Locale(config) {
	    if (config != null) {
	        this.set(config);
	    }
	}

	var keys$3;

	if (Object.keys) {
	    keys$3 = Object.keys;
	} else {
	    keys$3 = function (obj) {
	        var i,
	            res = [];
	        for (i in obj) {
	            if (hasOwnProp(obj, i)) {
	                res.push(i);
	            }
	        }
	        return res;
	    };
	}

	var defaultCalendar = {
	    sameDay: '[Today at] LT',
	    nextDay: '[Tomorrow at] LT',
	    nextWeek: 'dddd [at] LT',
	    lastDay: '[Yesterday at] LT',
	    lastWeek: '[Last] dddd [at] LT',
	    sameElse: 'L',
	};

	function calendar(key, mom, now) {
	    var output = this._calendar[key] || this._calendar['sameElse'];
	    return isFunction(output) ? output.call(mom, now) : output;
	}

	function zeroFill(number, targetLength, forceSign) {
	    var absNumber = '' + Math.abs(number),
	        zerosToFill = targetLength - absNumber.length,
	        sign = number >= 0;
	    return (
	        (sign ? (forceSign ? '+' : '') : '-') +
	        Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
	        absNumber
	    );
	}

	var formattingTokens =
	        /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
	    localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
	    formatFunctions = {},
	    formatTokenFunctions = {};

	// token:    'M'
	// padded:   ['MM', 2]
	// ordinal:  'Mo'
	// callback: function () { this.month() + 1 }
	function addFormatToken(token, padded, ordinal, callback) {
	    var func = callback;
	    if (typeof callback === 'string') {
	        func = function () {
	            return this[callback]();
	        };
	    }
	    if (token) {
	        formatTokenFunctions[token] = func;
	    }
	    if (padded) {
	        formatTokenFunctions[padded[0]] = function () {
	            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
	        };
	    }
	    if (ordinal) {
	        formatTokenFunctions[ordinal] = function () {
	            return this.localeData().ordinal(
	                func.apply(this, arguments),
	                token
	            );
	        };
	    }
	}

	function removeFormattingTokens(input) {
	    if (input.match(/\[[\s\S]/)) {
	        return input.replace(/^\[|\]$/g, '');
	    }
	    return input.replace(/\\/g, '');
	}

	function makeFormatFunction(format) {
	    var array = format.match(formattingTokens),
	        i,
	        length;

	    for (i = 0, length = array.length; i < length; i++) {
	        if (formatTokenFunctions[array[i]]) {
	            array[i] = formatTokenFunctions[array[i]];
	        } else {
	            array[i] = removeFormattingTokens(array[i]);
	        }
	    }

	    return function (mom) {
	        var output = '',
	            i;
	        for (i = 0; i < length; i++) {
	            output += isFunction(array[i])
	                ? array[i].call(mom, format)
	                : array[i];
	        }
	        return output;
	    };
	}

	// format date using native date object
	function formatMoment(m, format) {
	    if (!m.isValid()) {
	        return m.localeData().invalidDate();
	    }

	    format = expandFormat(format, m.localeData());
	    formatFunctions[format] =
	        formatFunctions[format] || makeFormatFunction(format);

	    return formatFunctions[format](m);
	}

	function expandFormat(format, locale) {
	    var i = 5;

	    function replaceLongDateFormatTokens(input) {
	        return locale.longDateFormat(input) || input;
	    }

	    localFormattingTokens.lastIndex = 0;
	    while (i >= 0 && localFormattingTokens.test(format)) {
	        format = format.replace(
	            localFormattingTokens,
	            replaceLongDateFormatTokens
	        );
	        localFormattingTokens.lastIndex = 0;
	        i -= 1;
	    }

	    return format;
	}

	var defaultLongDateFormat = {
	    LTS: 'h:mm:ss A',
	    LT: 'h:mm A',
	    L: 'MM/DD/YYYY',
	    LL: 'MMMM D, YYYY',
	    LLL: 'MMMM D, YYYY h:mm A',
	    LLLL: 'dddd, MMMM D, YYYY h:mm A',
	};

	function longDateFormat(key) {
	    var format = this._longDateFormat[key],
	        formatUpper = this._longDateFormat[key.toUpperCase()];

	    if (format || !formatUpper) {
	        return format;
	    }

	    this._longDateFormat[key] = formatUpper
	        .match(formattingTokens)
	        .map(function (tok) {
	            if (
	                tok === 'MMMM' ||
	                tok === 'MM' ||
	                tok === 'DD' ||
	                tok === 'dddd'
	            ) {
	                return tok.slice(1);
	            }
	            return tok;
	        })
	        .join('');

	    return this._longDateFormat[key];
	}

	var defaultInvalidDate = 'Invalid date';

	function invalidDate() {
	    return this._invalidDate;
	}

	var defaultOrdinal = '%d',
	    defaultDayOfMonthOrdinalParse = /\d{1,2}/;

	function ordinal(number) {
	    return this._ordinal.replace('%d', number);
	}

	var defaultRelativeTime = {
	    future: 'in %s',
	    past: '%s ago',
	    s: 'a few seconds',
	    ss: '%d seconds',
	    m: 'a minute',
	    mm: '%d minutes',
	    h: 'an hour',
	    hh: '%d hours',
	    d: 'a day',
	    dd: '%d days',
	    w: 'a week',
	    ww: '%d weeks',
	    M: 'a month',
	    MM: '%d months',
	    y: 'a year',
	    yy: '%d years',
	};

	function relativeTime(number, withoutSuffix, string, isFuture) {
	    var output = this._relativeTime[string];
	    return isFunction(output)
	        ? output(number, withoutSuffix, string, isFuture)
	        : output.replace(/%d/i, number);
	}

	function pastFuture(diff, output) {
	    var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	    return isFunction(format) ? format(output) : format.replace(/%s/i, output);
	}

	var aliases = {};

	function addUnitAlias(unit, shorthand) {
	    var lowerCase = unit.toLowerCase();
	    aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
	}

	function normalizeUnits(units) {
	    return typeof units === 'string'
	        ? aliases[units] || aliases[units.toLowerCase()]
	        : undefined;
	}

	function normalizeObjectUnits(inputObject) {
	    var normalizedInput = {},
	        normalizedProp,
	        prop;

	    for (prop in inputObject) {
	        if (hasOwnProp(inputObject, prop)) {
	            normalizedProp = normalizeUnits(prop);
	            if (normalizedProp) {
	                normalizedInput[normalizedProp] = inputObject[prop];
	            }
	        }
	    }

	    return normalizedInput;
	}

	var priorities = {};

	function addUnitPriority(unit, priority) {
	    priorities[unit] = priority;
	}

	function getPrioritizedUnits(unitsObj) {
	    var units = [],
	        u;
	    for (u in unitsObj) {
	        if (hasOwnProp(unitsObj, u)) {
	            units.push({ unit: u, priority: priorities[u] });
	        }
	    }
	    units.sort(function (a, b) {
	        return a.priority - b.priority;
	    });
	    return units;
	}

	function isLeapYear(year) {
	    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	}

	function absFloor(number) {
	    if (number < 0) {
	        // -0 -> 0
	        return Math.ceil(number) || 0;
	    } else {
	        return Math.floor(number);
	    }
	}

	function toInt(argumentForCoercion) {
	    var coercedNumber = +argumentForCoercion,
	        value = 0;

	    if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	        value = absFloor(coercedNumber);
	    }

	    return value;
	}

	function makeGetSet(unit, keepTime) {
	    return function (value) {
	        if (value != null) {
	            set$1$1(this, unit, value);
	            hooks$1.updateOffset(this, keepTime);
	            return this;
	        } else {
	            return get(this, unit);
	        }
	    };
	}

	function get(mom, unit) {
	    return mom.isValid()
	        ? mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]()
	        : NaN;
	}

	function set$1$1(mom, unit, value) {
	    if (mom.isValid() && !isNaN(value)) {
	        if (
	            unit === 'FullYear' &&
	            isLeapYear(mom.year()) &&
	            mom.month() === 1 &&
	            mom.date() === 29
	        ) {
	            value = toInt(value);
	            mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](
	                value,
	                mom.month(),
	                daysInMonth(value, mom.month())
	            );
	        } else {
	            mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
	        }
	    }
	}

	// MOMENTS

	function stringGet(units) {
	    units = normalizeUnits(units);
	    if (isFunction(this[units])) {
	        return this[units]();
	    }
	    return this;
	}

	function stringSet(units, value) {
	    var this$1 = this;

	    if (typeof units === 'object') {
	        units = normalizeObjectUnits(units);
	        var prioritized = getPrioritizedUnits(units),
	            i,
	            prioritizedLen = prioritized.length;
	        for (i = 0; i < prioritizedLen; i++) {
	            this$1[prioritized[i].unit](units[prioritized[i].unit]);
	        }
	    } else {
	        units = normalizeUnits(units);
	        if (isFunction(this[units])) {
	            return this[units](value);
	        }
	    }
	    return this;
	}

	var match1 = /\d/, //       0 - 9
	    match2 = /\d\d/, //      00 - 99
	    match3 = /\d{3}/, //     000 - 999
	    match4 = /\d{4}/, //    0000 - 9999
	    match6 = /[+-]?\d{6}/, // -999999 - 999999
	    match1to2 = /\d\d?/, //       0 - 99
	    match3to4 = /\d\d\d\d?/, //     999 - 9999
	    match5to6 = /\d\d\d\d\d\d?/, //   99999 - 999999
	    match1to3 = /\d{1,3}/, //       0 - 999
	    match1to4 = /\d{1,4}/, //       0 - 9999
	    match1to6 = /[+-]?\d{1,6}/, // -999999 - 999999
	    matchUnsigned = /\d+/, //       0 - inf
	    matchSigned = /[+-]?\d+/, //    -inf - inf
	    matchOffset = /Z|[+-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
	    matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, // +00 -00 +00:00 -00:00 +0000 -0000 or Z
	    matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
	    // any word (or two) characters or numbers including two/three word month in arabic.
	    // includes scottish gaelic two word and hyphenated months
	    matchWord =
	        /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
	    regexes;

	regexes = {};

	function addRegexToken(token, regex, strictRegex) {
	    regexes[token] = isFunction(regex)
	        ? regex
	        : function (isStrict, localeData) {
	              return isStrict && strictRegex ? strictRegex : regex;
	          };
	}

	function getParseRegexForToken(token, config) {
	    if (!hasOwnProp(regexes, token)) {
	        return new RegExp(unescapeFormat(token));
	    }

	    return regexes[token](config._strict, config._locale);
	}

	// Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	function unescapeFormat(s) {
	    return regexEscape(
	        s
	            .replace('\\', '')
	            .replace(
	                /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
	                function (matched, p1, p2, p3, p4) {
	                    return p1 || p2 || p3 || p4;
	                }
	            )
	    );
	}

	function regexEscape(s) {
	    return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	}

	var tokens = {};

	function addParseToken(token, callback) {
	    var i,
	        func = callback,
	        tokenLen;
	    if (typeof token === 'string') {
	        token = [token];
	    }
	    if (isNumber(callback)) {
	        func = function (input, array) {
	            array[callback] = toInt(input);
	        };
	    }
	    tokenLen = token.length;
	    for (i = 0; i < tokenLen; i++) {
	        tokens[token[i]] = func;
	    }
	}

	function addWeekParseToken(token, callback) {
	    addParseToken(token, function (input, array, config, token) {
	        config._w = config._w || {};
	        callback(input, config._w, config, token);
	    });
	}

	function addTimeToArrayFromToken(token, input, config) {
	    if (input != null && hasOwnProp(tokens, token)) {
	        tokens[token](input, config._a, config, token);
	    }
	}

	var YEAR = 0,
	    MONTH = 1,
	    DATE = 2,
	    HOUR = 3,
	    MINUTE = 4,
	    SECOND = 5,
	    MILLISECOND = 6,
	    WEEK = 7,
	    WEEKDAY = 8;

	function mod(n, x) {
	    return ((n % x) + x) % x;
	}

	var indexOf$2;

	if (Array.prototype.indexOf) {
	    indexOf$2 = Array.prototype.indexOf;
	} else {
	    indexOf$2 = function (o) {
	        var this$1 = this;

	        // I know
	        var i;
	        for (i = 0; i < this.length; ++i) {
	            if (this$1[i] === o) {
	                return i;
	            }
	        }
	        return -1;
	    };
	}

	function daysInMonth(year, month) {
	    if (isNaN(year) || isNaN(month)) {
	        return NaN;
	    }
	    var modMonth = mod(month, 12);
	    year += (month - modMonth) / 12;
	    return modMonth === 1
	        ? isLeapYear(year)
	            ? 29
	            : 28
	        : 31 - ((modMonth % 7) % 2);
	}

	// FORMATTING

	addFormatToken('M', ['MM', 2], 'Mo', function () {
	    return this.month() + 1;
	});

	addFormatToken('MMM', 0, 0, function (format) {
	    return this.localeData().monthsShort(this, format);
	});

	addFormatToken('MMMM', 0, 0, function (format) {
	    return this.localeData().months(this, format);
	});

	// ALIASES

	addUnitAlias('month', 'M');

	// PRIORITY

	addUnitPriority('month', 8);

	// PARSING

	addRegexToken('M', match1to2);
	addRegexToken('MM', match1to2, match2);
	addRegexToken('MMM', function (isStrict, locale) {
	    return locale.monthsShortRegex(isStrict);
	});
	addRegexToken('MMMM', function (isStrict, locale) {
	    return locale.monthsRegex(isStrict);
	});

	addParseToken(['M', 'MM'], function (input, array) {
	    array[MONTH] = toInt(input) - 1;
	});

	addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
	    var month = config._locale.monthsParse(input, token, config._strict);
	    // if we didn't find a month name, mark the date as invalid.
	    if (month != null) {
	        array[MONTH] = month;
	    } else {
	        getParsingFlags(config).invalidMonth = input;
	    }
	});

	// LOCALES

	var defaultLocaleMonths =
	        'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	    defaultLocaleMonthsShort =
	        'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
	    defaultMonthsShortRegex = matchWord,
	    defaultMonthsRegex = matchWord;

	function localeMonths(m, format) {
	    if (!m) {
	        return isArray$2(this._months)
	            ? this._months
	            : this._months['standalone'];
	    }
	    return isArray$2(this._months)
	        ? this._months[m.month()]
	        : this._months[
	              (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
	                  ? 'format'
	                  : 'standalone'
	          ][m.month()];
	}

	function localeMonthsShort(m, format) {
	    if (!m) {
	        return isArray$2(this._monthsShort)
	            ? this._monthsShort
	            : this._monthsShort['standalone'];
	    }
	    return isArray$2(this._monthsShort)
	        ? this._monthsShort[m.month()]
	        : this._monthsShort[
	              MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'
	          ][m.month()];
	}

	function handleStrictParse(monthName, format, strict) {
	    var this$1 = this;

	    var i,
	        ii,
	        mom,
	        llc = monthName.toLocaleLowerCase();
	    if (!this._monthsParse) {
	        // this is not used
	        this._monthsParse = [];
	        this._longMonthsParse = [];
	        this._shortMonthsParse = [];
	        for (i = 0; i < 12; ++i) {
	            mom = createUTC([2000, i]);
	            this$1._shortMonthsParse[i] = this$1.monthsShort(
	                mom,
	                ''
	            ).toLocaleLowerCase();
	            this$1._longMonthsParse[i] = this$1.months(mom, '').toLocaleLowerCase();
	        }
	    }

	    if (strict) {
	        if (format === 'MMM') {
	            ii = indexOf$2.call(this._shortMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf$2.call(this._longMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    } else {
	        if (format === 'MMM') {
	            ii = indexOf$2.call(this._shortMonthsParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$2.call(this._longMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf$2.call(this._longMonthsParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$2.call(this._shortMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    }
	}

	function localeMonthsParse(monthName, format, strict) {
	    var this$1 = this;

	    var i, mom, regex;

	    if (this._monthsParseExact) {
	        return handleStrictParse.call(this, monthName, format, strict);
	    }

	    if (!this._monthsParse) {
	        this._monthsParse = [];
	        this._longMonthsParse = [];
	        this._shortMonthsParse = [];
	    }

	    // TODO: add sorting
	    // Sorting makes sure if one month (or abbr) is a prefix of another
	    // see sorting in computeMonthsParse
	    for (i = 0; i < 12; i++) {
	        // make the regex if we don't have it already
	        mom = createUTC([2000, i]);
	        if (strict && !this$1._longMonthsParse[i]) {
	            this$1._longMonthsParse[i] = new RegExp(
	                '^' + this$1.months(mom, '').replace('.', '') + '$',
	                'i'
	            );
	            this$1._shortMonthsParse[i] = new RegExp(
	                '^' + this$1.monthsShort(mom, '').replace('.', '') + '$',
	                'i'
	            );
	        }
	        if (!strict && !this$1._monthsParse[i]) {
	            regex =
	                '^' + this$1.months(mom, '') + '|^' + this$1.monthsShort(mom, '');
	            this$1._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	        }
	        // test the regex
	        if (
	            strict &&
	            format === 'MMMM' &&
	            this$1._longMonthsParse[i].test(monthName)
	        ) {
	            return i;
	        } else if (
	            strict &&
	            format === 'MMM' &&
	            this$1._shortMonthsParse[i].test(monthName)
	        ) {
	            return i;
	        } else if (!strict && this$1._monthsParse[i].test(monthName)) {
	            return i;
	        }
	    }
	}

	// MOMENTS

	function setMonth(mom, value) {
	    var dayOfMonth;

	    if (!mom.isValid()) {
	        // No op
	        return mom;
	    }

	    if (typeof value === 'string') {
	        if (/^\d+$/.test(value)) {
	            value = toInt(value);
	        } else {
	            value = mom.localeData().monthsParse(value);
	            // TODO: Another silent failure?
	            if (!isNumber(value)) {
	                return mom;
	            }
	        }
	    }

	    dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
	    mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
	    return mom;
	}

	function getSetMonth(value) {
	    if (value != null) {
	        setMonth(this, value);
	        hooks$1.updateOffset(this, true);
	        return this;
	    } else {
	        return get(this, 'Month');
	    }
	}

	function getDaysInMonth() {
	    return daysInMonth(this.year(), this.month());
	}

	function monthsShortRegex(isStrict) {
	    if (this._monthsParseExact) {
	        if (!hasOwnProp(this, '_monthsRegex')) {
	            computeMonthsParse.call(this);
	        }
	        if (isStrict) {
	            return this._monthsShortStrictRegex;
	        } else {
	            return this._monthsShortRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_monthsShortRegex')) {
	            this._monthsShortRegex = defaultMonthsShortRegex;
	        }
	        return this._monthsShortStrictRegex && isStrict
	            ? this._monthsShortStrictRegex
	            : this._monthsShortRegex;
	    }
	}

	function monthsRegex(isStrict) {
	    if (this._monthsParseExact) {
	        if (!hasOwnProp(this, '_monthsRegex')) {
	            computeMonthsParse.call(this);
	        }
	        if (isStrict) {
	            return this._monthsStrictRegex;
	        } else {
	            return this._monthsRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_monthsRegex')) {
	            this._monthsRegex = defaultMonthsRegex;
	        }
	        return this._monthsStrictRegex && isStrict
	            ? this._monthsStrictRegex
	            : this._monthsRegex;
	    }
	}

	function computeMonthsParse() {
	    var this$1 = this;

	    function cmpLenRev(a, b) {
	        return b.length - a.length;
	    }

	    var shortPieces = [],
	        longPieces = [],
	        mixedPieces = [],
	        i,
	        mom;
	    for (i = 0; i < 12; i++) {
	        // make the regex if we don't have it already
	        mom = createUTC([2000, i]);
	        shortPieces.push(this$1.monthsShort(mom, ''));
	        longPieces.push(this$1.months(mom, ''));
	        mixedPieces.push(this$1.months(mom, ''));
	        mixedPieces.push(this$1.monthsShort(mom, ''));
	    }
	    // Sorting makes sure if one month (or abbr) is a prefix of another it
	    // will match the longer piece.
	    shortPieces.sort(cmpLenRev);
	    longPieces.sort(cmpLenRev);
	    mixedPieces.sort(cmpLenRev);
	    for (i = 0; i < 12; i++) {
	        shortPieces[i] = regexEscape(shortPieces[i]);
	        longPieces[i] = regexEscape(longPieces[i]);
	    }
	    for (i = 0; i < 24; i++) {
	        mixedPieces[i] = regexEscape(mixedPieces[i]);
	    }

	    this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	    this._monthsShortRegex = this._monthsRegex;
	    this._monthsStrictRegex = new RegExp(
	        '^(' + longPieces.join('|') + ')',
	        'i'
	    );
	    this._monthsShortStrictRegex = new RegExp(
	        '^(' + shortPieces.join('|') + ')',
	        'i'
	    );
	}

	// FORMATTING

	addFormatToken('Y', 0, 0, function () {
	    var y = this.year();
	    return y <= 9999 ? zeroFill(y, 4) : '+' + y;
	});

	addFormatToken(0, ['YY', 2], 0, function () {
	    return this.year() % 100;
	});

	addFormatToken(0, ['YYYY', 4], 0, 'year');
	addFormatToken(0, ['YYYYY', 5], 0, 'year');
	addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

	// ALIASES

	addUnitAlias('year', 'y');

	// PRIORITIES

	addUnitPriority('year', 1);

	// PARSING

	addRegexToken('Y', matchSigned);
	addRegexToken('YY', match1to2, match2);
	addRegexToken('YYYY', match1to4, match4);
	addRegexToken('YYYYY', match1to6, match6);
	addRegexToken('YYYYYY', match1to6, match6);

	addParseToken(['YYYYY', 'YYYYYY'], YEAR);
	addParseToken('YYYY', function (input, array) {
	    array[YEAR] =
	        input.length === 2 ? hooks$1.parseTwoDigitYear(input) : toInt(input);
	});
	addParseToken('YY', function (input, array) {
	    array[YEAR] = hooks$1.parseTwoDigitYear(input);
	});
	addParseToken('Y', function (input, array) {
	    array[YEAR] = parseInt(input, 10);
	});

	// HELPERS

	function daysInYear(year) {
	    return isLeapYear(year) ? 366 : 365;
	}

	// HOOKS

	hooks$1.parseTwoDigitYear = function (input) {
	    return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	};

	// MOMENTS

	var getSetYear = makeGetSet('FullYear', true);

	function getIsLeapYear() {
	    return isLeapYear(this.year());
	}

	function createDate(y, m, d, h, M, s, ms) {
	    // can't just apply() to create a date:
	    // https://stackoverflow.com/q/181348
	    var date;
	    // the date constructor remaps years 0-99 to 1900-1999
	    if (y < 100 && y >= 0) {
	        // preserve leap years using a full 400 year cycle, then reset
	        date = new Date(y + 400, m, d, h, M, s, ms);
	        if (isFinite(date.getFullYear())) {
	            date.setFullYear(y);
	        }
	    } else {
	        date = new Date(y, m, d, h, M, s, ms);
	    }

	    return date;
	}

	function createUTCDate(y) {
	    var date, args;
	    // the Date.UTC function remaps years 0-99 to 1900-1999
	    if (y < 100 && y >= 0) {
	        args = Array.prototype.slice.call(arguments);
	        // preserve leap years using a full 400 year cycle, then reset
	        args[0] = y + 400;
	        date = new Date(Date.UTC.apply(null, args));
	        if (isFinite(date.getUTCFullYear())) {
	            date.setUTCFullYear(y);
	        }
	    } else {
	        date = new Date(Date.UTC.apply(null, arguments));
	    }

	    return date;
	}

	// start-of-first-week - start-of-year
	function firstWeekOffset(year, dow, doy) {
	    var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
	        fwd = 7 + dow - doy,
	        // first-week day local weekday -- which local weekday is fwd
	        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

	    return -fwdlw + fwd - 1;
	}

	// https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
	    var localWeekday = (7 + weekday - dow) % 7,
	        weekOffset = firstWeekOffset(year, dow, doy),
	        dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
	        resYear,
	        resDayOfYear;

	    if (dayOfYear <= 0) {
	        resYear = year - 1;
	        resDayOfYear = daysInYear(resYear) + dayOfYear;
	    } else if (dayOfYear > daysInYear(year)) {
	        resYear = year + 1;
	        resDayOfYear = dayOfYear - daysInYear(year);
	    } else {
	        resYear = year;
	        resDayOfYear = dayOfYear;
	    }

	    return {
	        year: resYear,
	        dayOfYear: resDayOfYear,
	    };
	}

	function weekOfYear(mom, dow, doy) {
	    var weekOffset = firstWeekOffset(mom.year(), dow, doy),
	        week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
	        resWeek,
	        resYear;

	    if (week < 1) {
	        resYear = mom.year() - 1;
	        resWeek = week + weeksInYear(resYear, dow, doy);
	    } else if (week > weeksInYear(mom.year(), dow, doy)) {
	        resWeek = week - weeksInYear(mom.year(), dow, doy);
	        resYear = mom.year() + 1;
	    } else {
	        resYear = mom.year();
	        resWeek = week;
	    }

	    return {
	        week: resWeek,
	        year: resYear,
	    };
	}

	function weeksInYear(year, dow, doy) {
	    var weekOffset = firstWeekOffset(year, dow, doy),
	        weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
	    return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
	}

	// FORMATTING

	addFormatToken('w', ['ww', 2], 'wo', 'week');
	addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

	// ALIASES

	addUnitAlias('week', 'w');
	addUnitAlias('isoWeek', 'W');

	// PRIORITIES

	addUnitPriority('week', 5);
	addUnitPriority('isoWeek', 5);

	// PARSING

	addRegexToken('w', match1to2);
	addRegexToken('ww', match1to2, match2);
	addRegexToken('W', match1to2);
	addRegexToken('WW', match1to2, match2);

	addWeekParseToken(
	    ['w', 'ww', 'W', 'WW'],
	    function (input, week, config, token) {
	        week[token.substr(0, 1)] = toInt(input);
	    }
	);

	// HELPERS

	// LOCALES

	function localeWeek(mom) {
	    return weekOfYear(mom, this._week.dow, this._week.doy).week;
	}

	var defaultLocaleWeek = {
	    dow: 0, // Sunday is the first day of the week.
	    doy: 6, // The week that contains Jan 6th is the first week of the year.
	};

	function localeFirstDayOfWeek() {
	    return this._week.dow;
	}

	function localeFirstDayOfYear() {
	    return this._week.doy;
	}

	// MOMENTS

	function getSetWeek(input) {
	    var week = this.localeData().week(this);
	    return input == null ? week : this.add((input - week) * 7, 'd');
	}

	function getSetISOWeek(input) {
	    var week = weekOfYear(this, 1, 4).week;
	    return input == null ? week : this.add((input - week) * 7, 'd');
	}

	// FORMATTING

	addFormatToken('d', 0, 'do', 'day');

	addFormatToken('dd', 0, 0, function (format) {
	    return this.localeData().weekdaysMin(this, format);
	});

	addFormatToken('ddd', 0, 0, function (format) {
	    return this.localeData().weekdaysShort(this, format);
	});

	addFormatToken('dddd', 0, 0, function (format) {
	    return this.localeData().weekdays(this, format);
	});

	addFormatToken('e', 0, 0, 'weekday');
	addFormatToken('E', 0, 0, 'isoWeekday');

	// ALIASES

	addUnitAlias('day', 'd');
	addUnitAlias('weekday', 'e');
	addUnitAlias('isoWeekday', 'E');

	// PRIORITY
	addUnitPriority('day', 11);
	addUnitPriority('weekday', 11);
	addUnitPriority('isoWeekday', 11);

	// PARSING

	addRegexToken('d', match1to2);
	addRegexToken('e', match1to2);
	addRegexToken('E', match1to2);
	addRegexToken('dd', function (isStrict, locale) {
	    return locale.weekdaysMinRegex(isStrict);
	});
	addRegexToken('ddd', function (isStrict, locale) {
	    return locale.weekdaysShortRegex(isStrict);
	});
	addRegexToken('dddd', function (isStrict, locale) {
	    return locale.weekdaysRegex(isStrict);
	});

	addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
	    var weekday = config._locale.weekdaysParse(input, token, config._strict);
	    // if we didn't get a weekday name, mark the date as invalid
	    if (weekday != null) {
	        week.d = weekday;
	    } else {
	        getParsingFlags(config).invalidWeekday = input;
	    }
	});

	addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
	    week[token] = toInt(input);
	});

	// HELPERS

	function parseWeekday(input, locale) {
	    if (typeof input !== 'string') {
	        return input;
	    }

	    if (!isNaN(input)) {
	        return parseInt(input, 10);
	    }

	    input = locale.weekdaysParse(input);
	    if (typeof input === 'number') {
	        return input;
	    }

	    return null;
	}

	function parseIsoWeekday(input, locale) {
	    if (typeof input === 'string') {
	        return locale.weekdaysParse(input) % 7 || 7;
	    }
	    return isNaN(input) ? null : input;
	}

	// LOCALES
	function shiftWeekdays(ws, n) {
	    return ws.slice(n, 7).concat(ws.slice(0, n));
	}

	var defaultLocaleWeekdays =
	        'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    defaultWeekdaysRegex = matchWord,
	    defaultWeekdaysShortRegex = matchWord,
	    defaultWeekdaysMinRegex = matchWord;

	function localeWeekdays(m, format) {
	    var weekdays = isArray$2(this._weekdays)
	        ? this._weekdays
	        : this._weekdays[
	              m && m !== true && this._weekdays.isFormat.test(format)
	                  ? 'format'
	                  : 'standalone'
	          ];
	    return m === true
	        ? shiftWeekdays(weekdays, this._week.dow)
	        : m
	        ? weekdays[m.day()]
	        : weekdays;
	}

	function localeWeekdaysShort(m) {
	    return m === true
	        ? shiftWeekdays(this._weekdaysShort, this._week.dow)
	        : m
	        ? this._weekdaysShort[m.day()]
	        : this._weekdaysShort;
	}

	function localeWeekdaysMin(m) {
	    return m === true
	        ? shiftWeekdays(this._weekdaysMin, this._week.dow)
	        : m
	        ? this._weekdaysMin[m.day()]
	        : this._weekdaysMin;
	}

	function handleStrictParse$1(weekdayName, format, strict) {
	    var this$1 = this;

	    var i,
	        ii,
	        mom,
	        llc = weekdayName.toLocaleLowerCase();
	    if (!this._weekdaysParse) {
	        this._weekdaysParse = [];
	        this._shortWeekdaysParse = [];
	        this._minWeekdaysParse = [];

	        for (i = 0; i < 7; ++i) {
	            mom = createUTC([2000, 1]).day(i);
	            this$1._minWeekdaysParse[i] = this$1.weekdaysMin(
	                mom,
	                ''
	            ).toLocaleLowerCase();
	            this$1._shortWeekdaysParse[i] = this$1.weekdaysShort(
	                mom,
	                ''
	            ).toLocaleLowerCase();
	            this$1._weekdaysParse[i] = this$1.weekdays(mom, '').toLocaleLowerCase();
	        }
	    }

	    if (strict) {
	        if (format === 'dddd') {
	            ii = indexOf$2.call(this._weekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else if (format === 'ddd') {
	            ii = indexOf$2.call(this._shortWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf$2.call(this._minWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    } else {
	        if (format === 'dddd') {
	            ii = indexOf$2.call(this._weekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$2.call(this._shortWeekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$2.call(this._minWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else if (format === 'ddd') {
	            ii = indexOf$2.call(this._shortWeekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$2.call(this._weekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$2.call(this._minWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf$2.call(this._minWeekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$2.call(this._weekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$2.call(this._shortWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    }
	}

	function localeWeekdaysParse(weekdayName, format, strict) {
	    var this$1 = this;

	    var i, mom, regex;

	    if (this._weekdaysParseExact) {
	        return handleStrictParse$1.call(this, weekdayName, format, strict);
	    }

	    if (!this._weekdaysParse) {
	        this._weekdaysParse = [];
	        this._minWeekdaysParse = [];
	        this._shortWeekdaysParse = [];
	        this._fullWeekdaysParse = [];
	    }

	    for (i = 0; i < 7; i++) {
	        // make the regex if we don't have it already

	        mom = createUTC([2000, 1]).day(i);
	        if (strict && !this$1._fullWeekdaysParse[i]) {
	            this$1._fullWeekdaysParse[i] = new RegExp(
	                '^' + this$1.weekdays(mom, '').replace('.', '\\.?') + '$',
	                'i'
	            );
	            this$1._shortWeekdaysParse[i] = new RegExp(
	                '^' + this$1.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
	                'i'
	            );
	            this$1._minWeekdaysParse[i] = new RegExp(
	                '^' + this$1.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
	                'i'
	            );
	        }
	        if (!this$1._weekdaysParse[i]) {
	            regex =
	                '^' +
	                this$1.weekdays(mom, '') +
	                '|^' +
	                this$1.weekdaysShort(mom, '') +
	                '|^' +
	                this$1.weekdaysMin(mom, '');
	            this$1._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	        }
	        // test the regex
	        if (
	            strict &&
	            format === 'dddd' &&
	            this$1._fullWeekdaysParse[i].test(weekdayName)
	        ) {
	            return i;
	        } else if (
	            strict &&
	            format === 'ddd' &&
	            this$1._shortWeekdaysParse[i].test(weekdayName)
	        ) {
	            return i;
	        } else if (
	            strict &&
	            format === 'dd' &&
	            this$1._minWeekdaysParse[i].test(weekdayName)
	        ) {
	            return i;
	        } else if (!strict && this$1._weekdaysParse[i].test(weekdayName)) {
	            return i;
	        }
	    }
	}

	// MOMENTS

	function getSetDayOfWeek(input) {
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	    var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
	    if (input != null) {
	        input = parseWeekday(input, this.localeData());
	        return this.add(input - day, 'd');
	    } else {
	        return day;
	    }
	}

	function getSetLocaleDayOfWeek(input) {
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	    var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	    return input == null ? weekday : this.add(input - weekday, 'd');
	}

	function getSetISODayOfWeek(input) {
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }

	    // behaves the same as moment#day except
	    // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	    // as a setter, sunday should belong to the previous week.

	    if (input != null) {
	        var weekday = parseIsoWeekday(input, this.localeData());
	        return this.day(this.day() % 7 ? weekday : weekday - 7);
	    } else {
	        return this.day() || 7;
	    }
	}

	function weekdaysRegex(isStrict) {
	    if (this._weekdaysParseExact) {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            computeWeekdaysParse.call(this);
	        }
	        if (isStrict) {
	            return this._weekdaysStrictRegex;
	        } else {
	            return this._weekdaysRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            this._weekdaysRegex = defaultWeekdaysRegex;
	        }
	        return this._weekdaysStrictRegex && isStrict
	            ? this._weekdaysStrictRegex
	            : this._weekdaysRegex;
	    }
	}

	function weekdaysShortRegex(isStrict) {
	    if (this._weekdaysParseExact) {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            computeWeekdaysParse.call(this);
	        }
	        if (isStrict) {
	            return this._weekdaysShortStrictRegex;
	        } else {
	            return this._weekdaysShortRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_weekdaysShortRegex')) {
	            this._weekdaysShortRegex = defaultWeekdaysShortRegex;
	        }
	        return this._weekdaysShortStrictRegex && isStrict
	            ? this._weekdaysShortStrictRegex
	            : this._weekdaysShortRegex;
	    }
	}

	function weekdaysMinRegex(isStrict) {
	    if (this._weekdaysParseExact) {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            computeWeekdaysParse.call(this);
	        }
	        if (isStrict) {
	            return this._weekdaysMinStrictRegex;
	        } else {
	            return this._weekdaysMinRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_weekdaysMinRegex')) {
	            this._weekdaysMinRegex = defaultWeekdaysMinRegex;
	        }
	        return this._weekdaysMinStrictRegex && isStrict
	            ? this._weekdaysMinStrictRegex
	            : this._weekdaysMinRegex;
	    }
	}

	function computeWeekdaysParse() {
	    var this$1 = this;

	    function cmpLenRev(a, b) {
	        return b.length - a.length;
	    }

	    var minPieces = [],
	        shortPieces = [],
	        longPieces = [],
	        mixedPieces = [],
	        i,
	        mom,
	        minp,
	        shortp,
	        longp;
	    for (i = 0; i < 7; i++) {
	        // make the regex if we don't have it already
	        mom = createUTC([2000, 1]).day(i);
	        minp = regexEscape(this$1.weekdaysMin(mom, ''));
	        shortp = regexEscape(this$1.weekdaysShort(mom, ''));
	        longp = regexEscape(this$1.weekdays(mom, ''));
	        minPieces.push(minp);
	        shortPieces.push(shortp);
	        longPieces.push(longp);
	        mixedPieces.push(minp);
	        mixedPieces.push(shortp);
	        mixedPieces.push(longp);
	    }
	    // Sorting makes sure if one weekday (or abbr) is a prefix of another it
	    // will match the longer piece.
	    minPieces.sort(cmpLenRev);
	    shortPieces.sort(cmpLenRev);
	    longPieces.sort(cmpLenRev);
	    mixedPieces.sort(cmpLenRev);

	    this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	    this._weekdaysShortRegex = this._weekdaysRegex;
	    this._weekdaysMinRegex = this._weekdaysRegex;

	    this._weekdaysStrictRegex = new RegExp(
	        '^(' + longPieces.join('|') + ')',
	        'i'
	    );
	    this._weekdaysShortStrictRegex = new RegExp(
	        '^(' + shortPieces.join('|') + ')',
	        'i'
	    );
	    this._weekdaysMinStrictRegex = new RegExp(
	        '^(' + minPieces.join('|') + ')',
	        'i'
	    );
	}

	// FORMATTING

	function hFormat() {
	    return this.hours() % 12 || 12;
	}

	function kFormat() {
	    return this.hours() || 24;
	}

	addFormatToken('H', ['HH', 2], 0, 'hour');
	addFormatToken('h', ['hh', 2], 0, hFormat);
	addFormatToken('k', ['kk', 2], 0, kFormat);

	addFormatToken('hmm', 0, 0, function () {
	    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
	});

	addFormatToken('hmmss', 0, 0, function () {
	    return (
	        '' +
	        hFormat.apply(this) +
	        zeroFill(this.minutes(), 2) +
	        zeroFill(this.seconds(), 2)
	    );
	});

	addFormatToken('Hmm', 0, 0, function () {
	    return '' + this.hours() + zeroFill(this.minutes(), 2);
	});

	addFormatToken('Hmmss', 0, 0, function () {
	    return (
	        '' +
	        this.hours() +
	        zeroFill(this.minutes(), 2) +
	        zeroFill(this.seconds(), 2)
	    );
	});

	function meridiem(token, lowercase) {
	    addFormatToken(token, 0, 0, function () {
	        return this.localeData().meridiem(
	            this.hours(),
	            this.minutes(),
	            lowercase
	        );
	    });
	}

	meridiem('a', true);
	meridiem('A', false);

	// ALIASES

	addUnitAlias('hour', 'h');

	// PRIORITY
	addUnitPriority('hour', 13);

	// PARSING

	function matchMeridiem(isStrict, locale) {
	    return locale._meridiemParse;
	}

	addRegexToken('a', matchMeridiem);
	addRegexToken('A', matchMeridiem);
	addRegexToken('H', match1to2);
	addRegexToken('h', match1to2);
	addRegexToken('k', match1to2);
	addRegexToken('HH', match1to2, match2);
	addRegexToken('hh', match1to2, match2);
	addRegexToken('kk', match1to2, match2);

	addRegexToken('hmm', match3to4);
	addRegexToken('hmmss', match5to6);
	addRegexToken('Hmm', match3to4);
	addRegexToken('Hmmss', match5to6);

	addParseToken(['H', 'HH'], HOUR);
	addParseToken(['k', 'kk'], function (input, array, config) {
	    var kInput = toInt(input);
	    array[HOUR] = kInput === 24 ? 0 : kInput;
	});
	addParseToken(['a', 'A'], function (input, array, config) {
	    config._isPm = config._locale.isPM(input);
	    config._meridiem = input;
	});
	addParseToken(['h', 'hh'], function (input, array, config) {
	    array[HOUR] = toInt(input);
	    getParsingFlags(config).bigHour = true;
	});
	addParseToken('hmm', function (input, array, config) {
	    var pos = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos));
	    array[MINUTE] = toInt(input.substr(pos));
	    getParsingFlags(config).bigHour = true;
	});
	addParseToken('hmmss', function (input, array, config) {
	    var pos1 = input.length - 4,
	        pos2 = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos1));
	    array[MINUTE] = toInt(input.substr(pos1, 2));
	    array[SECOND] = toInt(input.substr(pos2));
	    getParsingFlags(config).bigHour = true;
	});
	addParseToken('Hmm', function (input, array, config) {
	    var pos = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos));
	    array[MINUTE] = toInt(input.substr(pos));
	});
	addParseToken('Hmmss', function (input, array, config) {
	    var pos1 = input.length - 4,
	        pos2 = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos1));
	    array[MINUTE] = toInt(input.substr(pos1, 2));
	    array[SECOND] = toInt(input.substr(pos2));
	});

	// LOCALES

	function localeIsPM(input) {
	    // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	    // Using charAt should be more compatible.
	    return (input + '').toLowerCase().charAt(0) === 'p';
	}

	var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
	    // Setting the hour should keep the time, because the user explicitly
	    // specified which hour they want. So trying to maintain the same hour (in
	    // a new timezone) makes sense. Adding/subtracting hours does not follow
	    // this rule.
	    getSetHour = makeGetSet('Hours', true);

	function localeMeridiem(hours, minutes, isLower) {
	    if (hours > 11) {
	        return isLower ? 'pm' : 'PM';
	    } else {
	        return isLower ? 'am' : 'AM';
	    }
	}

	var baseConfig = {
	    calendar: defaultCalendar,
	    longDateFormat: defaultLongDateFormat,
	    invalidDate: defaultInvalidDate,
	    ordinal: defaultOrdinal,
	    dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
	    relativeTime: defaultRelativeTime,

	    months: defaultLocaleMonths,
	    monthsShort: defaultLocaleMonthsShort,

	    week: defaultLocaleWeek,

	    weekdays: defaultLocaleWeekdays,
	    weekdaysMin: defaultLocaleWeekdaysMin,
	    weekdaysShort: defaultLocaleWeekdaysShort,

	    meridiemParse: defaultLocaleMeridiemParse,
	};

	// internal storage for locale config files
	var locales = {},
	    localeFamilies = {},
	    globalLocale;

	function commonPrefix(arr1, arr2) {
	    var i,
	        minl = Math.min(arr1.length, arr2.length);
	    for (i = 0; i < minl; i += 1) {
	        if (arr1[i] !== arr2[i]) {
	            return i;
	        }
	    }
	    return minl;
	}

	function normalizeLocale(key) {
	    return key ? key.toLowerCase().replace('_', '-') : key;
	}

	// pick the locale from the array
	// try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	// substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	function chooseLocale(names) {
	    var i = 0,
	        j,
	        next,
	        locale,
	        split;

	    while (i < names.length) {
	        split = normalizeLocale(names[i]).split('-');
	        j = split.length;
	        next = normalizeLocale(names[i + 1]);
	        next = next ? next.split('-') : null;
	        while (j > 0) {
	            locale = loadLocale(split.slice(0, j).join('-'));
	            if (locale) {
	                return locale;
	            }
	            if (
	                next &&
	                next.length >= j &&
	                commonPrefix(split, next) >= j - 1
	            ) {
	                //the next array item is better than a shallower substring of this one
	                break;
	            }
	            j--;
	        }
	        i++;
	    }
	    return globalLocale;
	}

	function isLocaleNameSane(name) {
	    // Prevent names that look like filesystem paths, i.e contain '/' or '\'
	    return name.match('^[^/\\\\]*$') != null;
	}

	function loadLocale(name) {
	    var oldLocale = null,
	        aliasedRequire;
	    // TODO: Find a better way to register and load all the locales in Node
	    if (
	        locales[name] === undefined &&
	        typeof module !== 'undefined' &&
	        module &&
	        module.exports &&
	        isLocaleNameSane(name)
	    ) {
	        try {
	            oldLocale = globalLocale._abbr;
	            aliasedRequire = require;
	            aliasedRequire('./locale/' + name);
	            getSetGlobalLocale(oldLocale);
	        } catch (e) {
	            // mark as not found to avoid repeating expensive file require call causing high CPU
	            // when trying to find en-US, en_US, en-us for every format call
	            locales[name] = null; // null means not found
	        }
	    }
	    return locales[name];
	}

	// This function will load locale and then set the global locale.  If
	// no arguments are passed in, it will simply return the current global
	// locale key.
	function getSetGlobalLocale(key, values) {
	    var data;
	    if (key) {
	        if (isUndefined(values)) {
	            data = getLocale(key);
	        } else {
	            data = defineLocale(key, values);
	        }

	        if (data) {
	            // moment.duration._locale = moment._locale = data;
	            globalLocale = data;
	        } else {
	            if (typeof console !== 'undefined' && console.warn) {
	                //warn user if arguments are passed but the locale could not be set
	                console.warn(
	                    'Locale ' + key + ' not found. Did you forget to load it?'
	                );
	            }
	        }
	    }

	    return globalLocale._abbr;
	}

	function defineLocale(name, config) {
	    if (config !== null) {
	        var locale,
	            parentConfig = baseConfig;
	        config.abbr = name;
	        if (locales[name] != null) {
	            deprecateSimple(
	                'defineLocaleOverride',
	                'use moment.updateLocale(localeName, config) to change ' +
	                    'an existing locale. moment.defineLocale(localeName, ' +
	                    'config) should only be used for creating a new locale ' +
	                    'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
	            );
	            parentConfig = locales[name]._config;
	        } else if (config.parentLocale != null) {
	            if (locales[config.parentLocale] != null) {
	                parentConfig = locales[config.parentLocale]._config;
	            } else {
	                locale = loadLocale(config.parentLocale);
	                if (locale != null) {
	                    parentConfig = locale._config;
	                } else {
	                    if (!localeFamilies[config.parentLocale]) {
	                        localeFamilies[config.parentLocale] = [];
	                    }
	                    localeFamilies[config.parentLocale].push({
	                        name: name,
	                        config: config,
	                    });
	                    return null;
	                }
	            }
	        }
	        locales[name] = new Locale(mergeConfigs(parentConfig, config));

	        if (localeFamilies[name]) {
	            localeFamilies[name].forEach(function (x) {
	                defineLocale(x.name, x.config);
	            });
	        }

	        // backwards compat for now: also set the locale
	        // make sure we set the locale AFTER all child locales have been
	        // created, so we won't end up with the child locale set.
	        getSetGlobalLocale(name);

	        return locales[name];
	    } else {
	        // useful for testing
	        delete locales[name];
	        return null;
	    }
	}

	function updateLocale(name, config) {
	    if (config != null) {
	        var locale,
	            tmpLocale,
	            parentConfig = baseConfig;

	        if (locales[name] != null && locales[name].parentLocale != null) {
	            // Update existing child locale in-place to avoid memory-leaks
	            locales[name].set(mergeConfigs(locales[name]._config, config));
	        } else {
	            // MERGE
	            tmpLocale = loadLocale(name);
	            if (tmpLocale != null) {
	                parentConfig = tmpLocale._config;
	            }
	            config = mergeConfigs(parentConfig, config);
	            if (tmpLocale == null) {
	                // updateLocale is called for creating a new locale
	                // Set abbr so it will have a name (getters return
	                // undefined otherwise).
	                config.abbr = name;
	            }
	            locale = new Locale(config);
	            locale.parentLocale = locales[name];
	            locales[name] = locale;
	        }

	        // backwards compat for now: also set the locale
	        getSetGlobalLocale(name);
	    } else {
	        // pass null for config to unupdate, useful for tests
	        if (locales[name] != null) {
	            if (locales[name].parentLocale != null) {
	                locales[name] = locales[name].parentLocale;
	                if (name === getSetGlobalLocale()) {
	                    getSetGlobalLocale(name);
	                }
	            } else if (locales[name] != null) {
	                delete locales[name];
	            }
	        }
	    }
	    return locales[name];
	}

	// returns locale data
	function getLocale(key) {
	    var locale;

	    if (key && key._locale && key._locale._abbr) {
	        key = key._locale._abbr;
	    }

	    if (!key) {
	        return globalLocale;
	    }

	    if (!isArray$2(key)) {
	        //short-circuit everything else
	        locale = loadLocale(key);
	        if (locale) {
	            return locale;
	        }
	        key = [key];
	    }

	    return chooseLocale(key);
	}

	function listLocales() {
	    return keys$3(locales);
	}

	function checkOverflow$2(m) {
	    var overflow,
	        a = m._a;

	    if (a && getParsingFlags(m).overflow === -2) {
	        overflow =
	            a[MONTH] < 0 || a[MONTH] > 11
	                ? MONTH
	                : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH])
	                ? DATE
	                : a[HOUR] < 0 ||
	                  a[HOUR] > 24 ||
	                  (a[HOUR] === 24 &&
	                      (a[MINUTE] !== 0 ||
	                          a[SECOND] !== 0 ||
	                          a[MILLISECOND] !== 0))
	                ? HOUR
	                : a[MINUTE] < 0 || a[MINUTE] > 59
	                ? MINUTE
	                : a[SECOND] < 0 || a[SECOND] > 59
	                ? SECOND
	                : a[MILLISECOND] < 0 || a[MILLISECOND] > 999
	                ? MILLISECOND
	                : -1;

	        if (
	            getParsingFlags(m)._overflowDayOfYear &&
	            (overflow < YEAR || overflow > DATE)
	        ) {
	            overflow = DATE;
	        }
	        if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
	            overflow = WEEK;
	        }
	        if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
	            overflow = WEEKDAY;
	        }

	        getParsingFlags(m).overflow = overflow;
	    }

	    return m;
	}

	// iso 8601 regex
	// 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
	var extendedIsoRegex =
	        /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
	    basicIsoRegex =
	        /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
	    tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
	    isoDates = [
	        ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
	        ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
	        ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
	        ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
	        ['YYYY-DDD', /\d{4}-\d{3}/],
	        ['YYYY-MM', /\d{4}-\d\d/, false],
	        ['YYYYYYMMDD', /[+-]\d{10}/],
	        ['YYYYMMDD', /\d{8}/],
	        ['GGGG[W]WWE', /\d{4}W\d{3}/],
	        ['GGGG[W]WW', /\d{4}W\d{2}/, false],
	        ['YYYYDDD', /\d{7}/],
	        ['YYYYMM', /\d{6}/, false],
	        ['YYYY', /\d{4}/, false] ],
	    // iso time formats and regexes
	    isoTimes = [
	        ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
	        ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
	        ['HH:mm:ss', /\d\d:\d\d:\d\d/],
	        ['HH:mm', /\d\d:\d\d/],
	        ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
	        ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
	        ['HHmmss', /\d\d\d\d\d\d/],
	        ['HHmm', /\d\d\d\d/],
	        ['HH', /\d\d/] ],
	    aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
	    // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
	    rfc2822 =
	        /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
	    obsOffsets = {
	        UT: 0,
	        GMT: 0,
	        EDT: -4 * 60,
	        EST: -5 * 60,
	        CDT: -5 * 60,
	        CST: -6 * 60,
	        MDT: -6 * 60,
	        MST: -7 * 60,
	        PDT: -7 * 60,
	        PST: -8 * 60,
	    };

	// date from iso format
	function configFromISO(config) {
	    var i,
	        l,
	        string = config._i,
	        match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
	        allowTime,
	        dateFormat,
	        timeFormat,
	        tzFormat,
	        isoDatesLen = isoDates.length,
	        isoTimesLen = isoTimes.length;

	    if (match) {
	        getParsingFlags(config).iso = true;
	        for (i = 0, l = isoDatesLen; i < l; i++) {
	            if (isoDates[i][1].exec(match[1])) {
	                dateFormat = isoDates[i][0];
	                allowTime = isoDates[i][2] !== false;
	                break;
	            }
	        }
	        if (dateFormat == null) {
	            config._isValid = false;
	            return;
	        }
	        if (match[3]) {
	            for (i = 0, l = isoTimesLen; i < l; i++) {
	                if (isoTimes[i][1].exec(match[3])) {
	                    // match[2] should be 'T' or space
	                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
	                    break;
	                }
	            }
	            if (timeFormat == null) {
	                config._isValid = false;
	                return;
	            }
	        }
	        if (!allowTime && timeFormat != null) {
	            config._isValid = false;
	            return;
	        }
	        if (match[4]) {
	            if (tzRegex.exec(match[4])) {
	                tzFormat = 'Z';
	            } else {
	                config._isValid = false;
	                return;
	            }
	        }
	        config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
	        configFromStringAndFormat(config);
	    } else {
	        config._isValid = false;
	    }
	}

	function extractFromRFC2822Strings(
	    yearStr,
	    monthStr,
	    dayStr,
	    hourStr,
	    minuteStr,
	    secondStr
	) {
	    var result = [
	        untruncateYear(yearStr),
	        defaultLocaleMonthsShort.indexOf(monthStr),
	        parseInt(dayStr, 10),
	        parseInt(hourStr, 10),
	        parseInt(minuteStr, 10) ];

	    if (secondStr) {
	        result.push(parseInt(secondStr, 10));
	    }

	    return result;
	}

	function untruncateYear(yearStr) {
	    var year = parseInt(yearStr, 10);
	    if (year <= 49) {
	        return 2000 + year;
	    } else if (year <= 999) {
	        return 1900 + year;
	    }
	    return year;
	}

	function preprocessRFC2822(s) {
	    // Remove comments and folding whitespace and replace multiple-spaces with a single space
	    return s
	        .replace(/\([^()]*\)|[\n\t]/g, ' ')
	        .replace(/(\s\s+)/g, ' ')
	        .replace(/^\s\s*/, '')
	        .replace(/\s\s*$/, '');
	}

	function checkWeekday(weekdayStr, parsedInput, config) {
	    if (weekdayStr) {
	        // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
	        var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
	            weekdayActual = new Date(
	                parsedInput[0],
	                parsedInput[1],
	                parsedInput[2]
	            ).getDay();
	        if (weekdayProvided !== weekdayActual) {
	            getParsingFlags(config).weekdayMismatch = true;
	            config._isValid = false;
	            return false;
	        }
	    }
	    return true;
	}

	function calculateOffset(obsOffset, militaryOffset, numOffset) {
	    if (obsOffset) {
	        return obsOffsets[obsOffset];
	    } else if (militaryOffset) {
	        // the only allowed military tz is Z
	        return 0;
	    } else {
	        var hm = parseInt(numOffset, 10),
	            m = hm % 100,
	            h = (hm - m) / 100;
	        return h * 60 + m;
	    }
	}

	// date and time from ref 2822 format
	function configFromRFC2822(config) {
	    var match = rfc2822.exec(preprocessRFC2822(config._i)),
	        parsedArray;
	    if (match) {
	        parsedArray = extractFromRFC2822Strings(
	            match[4],
	            match[3],
	            match[2],
	            match[5],
	            match[6],
	            match[7]
	        );
	        if (!checkWeekday(match[1], parsedArray, config)) {
	            return;
	        }

	        config._a = parsedArray;
	        config._tzm = calculateOffset(match[8], match[9], match[10]);

	        config._d = createUTCDate.apply(null, config._a);
	        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

	        getParsingFlags(config).rfc2822 = true;
	    } else {
	        config._isValid = false;
	    }
	}

	// date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
	function configFromString(config) {
	    var matched = aspNetJsonRegex.exec(config._i);
	    if (matched !== null) {
	        config._d = new Date(+matched[1]);
	        return;
	    }

	    configFromISO(config);
	    if (config._isValid === false) {
	        delete config._isValid;
	    } else {
	        return;
	    }

	    configFromRFC2822(config);
	    if (config._isValid === false) {
	        delete config._isValid;
	    } else {
	        return;
	    }

	    if (config._strict) {
	        config._isValid = false;
	    } else {
	        // Final attempt, use Input Fallback
	        hooks$1.createFromInputFallback(config);
	    }
	}

	hooks$1.createFromInputFallback = deprecate(
	    'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
	        'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
	        'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.',
	    function (config) {
	        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	    }
	);

	// Pick the first defined of two or three arguments.
	function defaults$1(a, b, c) {
	    if (a != null) {
	        return a;
	    }
	    if (b != null) {
	        return b;
	    }
	    return c;
	}

	function currentDateArray(config) {
	    // hooks is actually the exported moment object
	    var nowValue = new Date(hooks$1.now());
	    if (config._useUTC) {
	        return [
	            nowValue.getUTCFullYear(),
	            nowValue.getUTCMonth(),
	            nowValue.getUTCDate() ];
	    }
	    return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
	}

	// convert an array to a date.
	// the array should mirror the parameters below
	// note: all values past the year are optional and will default to the lowest possible value.
	// [year, month, day , hour, minute, second, millisecond]
	function configFromArray(config) {
	    var i,
	        date,
	        input = [],
	        currentDate,
	        expectedWeekday,
	        yearToUse;

	    if (config._d) {
	        return;
	    }

	    currentDate = currentDateArray(config);

	    //compute day of the year from weeks and weekdays
	    if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	        dayOfYearFromWeekInfo(config);
	    }

	    //if the day of the year is set, figure out what it is
	    if (config._dayOfYear != null) {
	        yearToUse = defaults$1(config._a[YEAR], currentDate[YEAR]);

	        if (
	            config._dayOfYear > daysInYear(yearToUse) ||
	            config._dayOfYear === 0
	        ) {
	            getParsingFlags(config)._overflowDayOfYear = true;
	        }

	        date = createUTCDate(yearToUse, 0, config._dayOfYear);
	        config._a[MONTH] = date.getUTCMonth();
	        config._a[DATE] = date.getUTCDate();
	    }

	    // Default to current date.
	    // * if no year, month, day of month are given, default to today
	    // * if day of month is given, default month and year
	    // * if month is given, default only year
	    // * if year is given, don't default anything
	    for (i = 0; i < 3 && config._a[i] == null; ++i) {
	        config._a[i] = input[i] = currentDate[i];
	    }

	    // Zero out whatever was not defaulted, including time
	    for (; i < 7; i++) {
	        config._a[i] = input[i] =
	            config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i];
	    }

	    // Check for 24:00:00.000
	    if (
	        config._a[HOUR] === 24 &&
	        config._a[MINUTE] === 0 &&
	        config._a[SECOND] === 0 &&
	        config._a[MILLISECOND] === 0
	    ) {
	        config._nextDay = true;
	        config._a[HOUR] = 0;
	    }

	    config._d = (config._useUTC ? createUTCDate : createDate).apply(
	        null,
	        input
	    );
	    expectedWeekday = config._useUTC
	        ? config._d.getUTCDay()
	        : config._d.getDay();

	    // Apply timezone offset from input. The actual utcOffset can be changed
	    // with parseZone.
	    if (config._tzm != null) {
	        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	    }

	    if (config._nextDay) {
	        config._a[HOUR] = 24;
	    }

	    // check for mismatching day of week
	    if (
	        config._w &&
	        typeof config._w.d !== 'undefined' &&
	        config._w.d !== expectedWeekday
	    ) {
	        getParsingFlags(config).weekdayMismatch = true;
	    }
	}

	function dayOfYearFromWeekInfo(config) {
	    var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;

	    w = config._w;
	    if (w.GG != null || w.W != null || w.E != null) {
	        dow = 1;
	        doy = 4;

	        // TODO: We need to take the current isoWeekYear, but that depends on
	        // how we interpret now (local, utc, fixed offset). So create
	        // a now version of current config (take local/utc/offset flags, and
	        // create now).
	        weekYear = defaults$1(
	            w.GG,
	            config._a[YEAR],
	            weekOfYear(createLocal(), 1, 4).year
	        );
	        week = defaults$1(w.W, 1);
	        weekday = defaults$1(w.E, 1);
	        if (weekday < 1 || weekday > 7) {
	            weekdayOverflow = true;
	        }
	    } else {
	        dow = config._locale._week.dow;
	        doy = config._locale._week.doy;

	        curWeek = weekOfYear(createLocal(), dow, doy);

	        weekYear = defaults$1(w.gg, config._a[YEAR], curWeek.year);

	        // Default to current week.
	        week = defaults$1(w.w, curWeek.week);

	        if (w.d != null) {
	            // weekday -- low day numbers are considered next week
	            weekday = w.d;
	            if (weekday < 0 || weekday > 6) {
	                weekdayOverflow = true;
	            }
	        } else if (w.e != null) {
	            // local weekday -- counting starts from beginning of week
	            weekday = w.e + dow;
	            if (w.e < 0 || w.e > 6) {
	                weekdayOverflow = true;
	            }
	        } else {
	            // default to beginning of week
	            weekday = dow;
	        }
	    }
	    if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
	        getParsingFlags(config)._overflowWeeks = true;
	    } else if (weekdayOverflow != null) {
	        getParsingFlags(config)._overflowWeekday = true;
	    } else {
	        temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
	        config._a[YEAR] = temp.year;
	        config._dayOfYear = temp.dayOfYear;
	    }
	}

	// constant that refers to the ISO standard
	hooks$1.ISO_8601 = function () {};

	// constant that refers to the RFC 2822 form
	hooks$1.RFC_2822 = function () {};

	// date from string and format string
	function configFromStringAndFormat(config) {
	    // TODO: Move this to another part of the creation flow to prevent circular deps
	    if (config._f === hooks$1.ISO_8601) {
	        configFromISO(config);
	        return;
	    }
	    if (config._f === hooks$1.RFC_2822) {
	        configFromRFC2822(config);
	        return;
	    }
	    config._a = [];
	    getParsingFlags(config).empty = true;

	    // This array is used to make a Date, either with `new Date` or `Date.UTC`
	    var string = '' + config._i,
	        i,
	        parsedInput,
	        tokens,
	        token,
	        skipped,
	        stringLength = string.length,
	        totalParsedInputLength = 0,
	        era,
	        tokenLen;

	    tokens =
	        expandFormat(config._f, config._locale).match(formattingTokens) || [];
	    tokenLen = tokens.length;
	    for (i = 0; i < tokenLen; i++) {
	        token = tokens[i];
	        parsedInput = (string.match(getParseRegexForToken(token, config)) ||
	            [])[0];
	        if (parsedInput) {
	            skipped = string.substr(0, string.indexOf(parsedInput));
	            if (skipped.length > 0) {
	                getParsingFlags(config).unusedInput.push(skipped);
	            }
	            string = string.slice(
	                string.indexOf(parsedInput) + parsedInput.length
	            );
	            totalParsedInputLength += parsedInput.length;
	        }
	        // don't parse if it's not a known token
	        if (formatTokenFunctions[token]) {
	            if (parsedInput) {
	                getParsingFlags(config).empty = false;
	            } else {
	                getParsingFlags(config).unusedTokens.push(token);
	            }
	            addTimeToArrayFromToken(token, parsedInput, config);
	        } else if (config._strict && !parsedInput) {
	            getParsingFlags(config).unusedTokens.push(token);
	        }
	    }

	    // add remaining unparsed input length to the string
	    getParsingFlags(config).charsLeftOver =
	        stringLength - totalParsedInputLength;
	    if (string.length > 0) {
	        getParsingFlags(config).unusedInput.push(string);
	    }

	    // clear _12h flag if hour is <= 12
	    if (
	        config._a[HOUR] <= 12 &&
	        getParsingFlags(config).bigHour === true &&
	        config._a[HOUR] > 0
	    ) {
	        getParsingFlags(config).bigHour = undefined;
	    }

	    getParsingFlags(config).parsedDateParts = config._a.slice(0);
	    getParsingFlags(config).meridiem = config._meridiem;
	    // handle meridiem
	    config._a[HOUR] = meridiemFixWrap(
	        config._locale,
	        config._a[HOUR],
	        config._meridiem
	    );

	    // handle era
	    era = getParsingFlags(config).era;
	    if (era !== null) {
	        config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
	    }

	    configFromArray(config);
	    checkOverflow$2(config);
	}

	function meridiemFixWrap(locale, hour, meridiem) {
	    var isPm;

	    if (meridiem == null) {
	        // nothing to do
	        return hour;
	    }
	    if (locale.meridiemHour != null) {
	        return locale.meridiemHour(hour, meridiem);
	    } else if (locale.isPM != null) {
	        // Fallback
	        isPm = locale.isPM(meridiem);
	        if (isPm && hour < 12) {
	            hour += 12;
	        }
	        if (!isPm && hour === 12) {
	            hour = 0;
	        }
	        return hour;
	    } else {
	        // this is not supposed to happen
	        return hour;
	    }
	}

	// date from string and array of format strings
	function configFromStringAndArray(config) {
	    var tempConfig,
	        bestMoment,
	        scoreToBeat,
	        i,
	        currentScore,
	        validFormatFound,
	        bestFormatIsValid = false,
	        configfLen = config._f.length;

	    if (configfLen === 0) {
	        getParsingFlags(config).invalidFormat = true;
	        config._d = new Date(NaN);
	        return;
	    }

	    for (i = 0; i < configfLen; i++) {
	        currentScore = 0;
	        validFormatFound = false;
	        tempConfig = copyConfig({}, config);
	        if (config._useUTC != null) {
	            tempConfig._useUTC = config._useUTC;
	        }
	        tempConfig._f = config._f[i];
	        configFromStringAndFormat(tempConfig);

	        if (isValid(tempConfig)) {
	            validFormatFound = true;
	        }

	        // if there is any input that was not parsed add a penalty for that format
	        currentScore += getParsingFlags(tempConfig).charsLeftOver;

	        //or tokens
	        currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

	        getParsingFlags(tempConfig).score = currentScore;

	        if (!bestFormatIsValid) {
	            if (
	                scoreToBeat == null ||
	                currentScore < scoreToBeat ||
	                validFormatFound
	            ) {
	                scoreToBeat = currentScore;
	                bestMoment = tempConfig;
	                if (validFormatFound) {
	                    bestFormatIsValid = true;
	                }
	            }
	        } else {
	            if (currentScore < scoreToBeat) {
	                scoreToBeat = currentScore;
	                bestMoment = tempConfig;
	            }
	        }
	    }

	    extend$1(config, bestMoment || tempConfig);
	}

	function configFromObject(config) {
	    if (config._d) {
	        return;
	    }

	    var i = normalizeObjectUnits(config._i),
	        dayOrDate = i.day === undefined ? i.date : i.day;
	    config._a = map$2(
	        [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
	        function (obj) {
	            return obj && parseInt(obj, 10);
	        }
	    );

	    configFromArray(config);
	}

	function createFromConfig(config) {
	    var res = new Moment(checkOverflow$2(prepareConfig(config)));
	    if (res._nextDay) {
	        // Adding is smart enough around DST
	        res.add(1, 'd');
	        res._nextDay = undefined;
	    }

	    return res;
	}

	function prepareConfig(config) {
	    var input = config._i,
	        format = config._f;

	    config._locale = config._locale || getLocale(config._l);

	    if (input === null || (format === undefined && input === '')) {
	        return createInvalid({ nullInput: true });
	    }

	    if (typeof input === 'string') {
	        config._i = input = config._locale.preparse(input);
	    }

	    if (isMoment(input)) {
	        return new Moment(checkOverflow$2(input));
	    } else if (isDate(input)) {
	        config._d = input;
	    } else if (isArray$2(format)) {
	        configFromStringAndArray(config);
	    } else if (format) {
	        configFromStringAndFormat(config);
	    } else {
	        configFromInput(config);
	    }

	    if (!isValid(config)) {
	        config._d = null;
	    }

	    return config;
	}

	function configFromInput(config) {
	    var input = config._i;
	    if (isUndefined(input)) {
	        config._d = new Date(hooks$1.now());
	    } else if (isDate(input)) {
	        config._d = new Date(input.valueOf());
	    } else if (typeof input === 'string') {
	        configFromString(config);
	    } else if (isArray$2(input)) {
	        config._a = map$2(input.slice(0), function (obj) {
	            return parseInt(obj, 10);
	        });
	        configFromArray(config);
	    } else if (isObject$4(input)) {
	        configFromObject(config);
	    } else if (isNumber(input)) {
	        // from milliseconds
	        config._d = new Date(input);
	    } else {
	        hooks$1.createFromInputFallback(config);
	    }
	}

	function createLocalOrUTC(input, format, locale, strict, isUTC) {
	    var c = {};

	    if (format === true || format === false) {
	        strict = format;
	        format = undefined;
	    }

	    if (locale === true || locale === false) {
	        strict = locale;
	        locale = undefined;
	    }

	    if (
	        (isObject$4(input) && isObjectEmpty(input)) ||
	        (isArray$2(input) && input.length === 0)
	    ) {
	        input = undefined;
	    }
	    // object construction must be done this way.
	    // https://github.com/moment/moment/issues/1423
	    c._isAMomentObject = true;
	    c._useUTC = c._isUTC = isUTC;
	    c._l = locale;
	    c._i = input;
	    c._f = format;
	    c._strict = strict;

	    return createFromConfig(c);
	}

	function createLocal(input, format, locale, strict) {
	    return createLocalOrUTC(input, format, locale, strict, false);
	}

	var prototypeMin = deprecate(
	        'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
	        function () {
	            var other = createLocal.apply(null, arguments);
	            if (this.isValid() && other.isValid()) {
	                return other < this ? this : other;
	            } else {
	                return createInvalid();
	            }
	        }
	    ),
	    prototypeMax = deprecate(
	        'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
	        function () {
	            var other = createLocal.apply(null, arguments);
	            if (this.isValid() && other.isValid()) {
	                return other > this ? this : other;
	            } else {
	                return createInvalid();
	            }
	        }
	    );

	// Pick a moment m from moments so that m[fn](other) is true for all
	// other. This relies on the function fn to be transitive.
	//
	// moments should either be an array of moment objects or an array, whose
	// first element is an array of moment objects.
	function pickBy(fn, moments) {
	    var res, i;
	    if (moments.length === 1 && isArray$2(moments[0])) {
	        moments = moments[0];
	    }
	    if (!moments.length) {
	        return createLocal();
	    }
	    res = moments[0];
	    for (i = 1; i < moments.length; ++i) {
	        if (!moments[i].isValid() || moments[i][fn](res)) {
	            res = moments[i];
	        }
	    }
	    return res;
	}

	// TODO: Use [].sort instead?
	function min() {
	    var args = [].slice.call(arguments, 0);

	    return pickBy('isBefore', args);
	}

	function max() {
	    var args = [].slice.call(arguments, 0);

	    return pickBy('isAfter', args);
	}

	var now$3 = function () {
	    return Date.now ? Date.now() : +new Date();
	};

	var ordering = [
	    'year',
	    'quarter',
	    'month',
	    'week',
	    'day',
	    'hour',
	    'minute',
	    'second',
	    'millisecond' ];

	function isDurationValid(m) {
	    var key,
	        unitHasDecimal = false,
	        i,
	        orderLen = ordering.length;
	    for (key in m) {
	        if (
	            hasOwnProp(m, key) &&
	            !(
	                indexOf$2.call(ordering, key) !== -1 &&
	                (m[key] == null || !isNaN(m[key]))
	            )
	        ) {
	            return false;
	        }
	    }

	    for (i = 0; i < orderLen; ++i) {
	        if (m[ordering[i]]) {
	            if (unitHasDecimal) {
	                return false; // only allow non-integers for smallest unit
	            }
	            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
	                unitHasDecimal = true;
	            }
	        }
	    }

	    return true;
	}

	function isValid$1() {
	    return this._isValid;
	}

	function createInvalid$1() {
	    return createDuration(NaN);
	}

	function Duration(duration) {
	    var normalizedInput = normalizeObjectUnits(duration),
	        years = normalizedInput.year || 0,
	        quarters = normalizedInput.quarter || 0,
	        months = normalizedInput.month || 0,
	        weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
	        days = normalizedInput.day || 0,
	        hours = normalizedInput.hour || 0,
	        minutes = normalizedInput.minute || 0,
	        seconds = normalizedInput.second || 0,
	        milliseconds = normalizedInput.millisecond || 0;

	    this._isValid = isDurationValid(normalizedInput);

	    // representation for dateAddRemove
	    this._milliseconds =
	        +milliseconds +
	        seconds * 1e3 + // 1000
	        minutes * 6e4 + // 1000 * 60
	        hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
	    // Because of dateAddRemove treats 24 hours as different from a
	    // day when working around DST, we need to store them separately
	    this._days = +days + weeks * 7;
	    // It is impossible to translate months into days without knowing
	    // which months you are are talking about, so we have to store
	    // it separately.
	    this._months = +months + quarters * 3 + years * 12;

	    this._data = {};

	    this._locale = getLocale();

	    this._bubble();
	}

	function isDuration(obj) {
	    return obj instanceof Duration;
	}

	function absRound(number) {
	    if (number < 0) {
	        return Math.round(-1 * number) * -1;
	    } else {
	        return Math.round(number);
	    }
	}

	// compare two arrays, return the number of differences
	function compareArrays(array1, array2, dontConvert) {
	    var len = Math.min(array1.length, array2.length),
	        lengthDiff = Math.abs(array1.length - array2.length),
	        diffs = 0,
	        i;
	    for (i = 0; i < len; i++) {
	        if (
	            (dontConvert && array1[i] !== array2[i]) ||
	            (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))
	        ) {
	            diffs++;
	        }
	    }
	    return diffs + lengthDiff;
	}

	// FORMATTING

	function offset$1(token, separator) {
	    addFormatToken(token, 0, 0, function () {
	        var offset = this.utcOffset(),
	            sign = '+';
	        if (offset < 0) {
	            offset = -offset;
	            sign = '-';
	        }
	        return (
	            sign +
	            zeroFill(~~(offset / 60), 2) +
	            separator +
	            zeroFill(~~offset % 60, 2)
	        );
	    });
	}

	offset$1('Z', ':');
	offset$1('ZZ', '');

	// PARSING

	addRegexToken('Z', matchShortOffset);
	addRegexToken('ZZ', matchShortOffset);
	addParseToken(['Z', 'ZZ'], function (input, array, config) {
	    config._useUTC = true;
	    config._tzm = offsetFromString(matchShortOffset, input);
	});

	// HELPERS

	// timezone chunker
	// '+10:00' > ['10',  '00']
	// '-1530'  > ['-15', '30']
	var chunkOffset = /([\+\-]|\d\d)/gi;

	function offsetFromString(matcher, string) {
	    var matches = (string || '').match(matcher),
	        chunk,
	        parts,
	        minutes;

	    if (matches === null) {
	        return null;
	    }

	    chunk = matches[matches.length - 1] || [];
	    parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
	    minutes = +(parts[1] * 60) + toInt(parts[2]);

	    return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
	}

	// Return a moment from input, that is local/utc/zone equivalent to model.
	function cloneWithOffset(input, model) {
	    var res, diff;
	    if (model._isUTC) {
	        res = model.clone();
	        diff =
	            (isMoment(input) || isDate(input)
	                ? input.valueOf()
	                : createLocal(input).valueOf()) - res.valueOf();
	        // Use low-level api, because this fn is low-level api.
	        res._d.setTime(res._d.valueOf() + diff);
	        hooks$1.updateOffset(res, false);
	        return res;
	    } else {
	        return createLocal(input).local();
	    }
	}

	function getDateOffset(m) {
	    // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	    // https://github.com/moment/moment/pull/1871
	    return -Math.round(m._d.getTimezoneOffset());
	}

	// HOOKS

	// This function will be called whenever a moment is mutated.
	// It is intended to keep the offset in sync with the timezone.
	hooks$1.updateOffset = function () {};

	// MOMENTS

	// keepLocalTime = true means only change the timezone, without
	// affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	// 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	// +0200, so we adjust the time as needed, to be valid.
	//
	// Keeping the time actually adds/subtracts (one hour)
	// from the actual represented time. That is why we call updateOffset
	// a second time. In case it wants us to change the offset again
	// _changeInProgress == true case, then we have to adjust, because
	// there is no such time in the given timezone.
	function getSetOffset(input, keepLocalTime, keepMinutes) {
	    var offset = this._offset || 0,
	        localAdjust;
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	    if (input != null) {
	        if (typeof input === 'string') {
	            input = offsetFromString(matchShortOffset, input);
	            if (input === null) {
	                return this;
	            }
	        } else if (Math.abs(input) < 16 && !keepMinutes) {
	            input = input * 60;
	        }
	        if (!this._isUTC && keepLocalTime) {
	            localAdjust = getDateOffset(this);
	        }
	        this._offset = input;
	        this._isUTC = true;
	        if (localAdjust != null) {
	            this.add(localAdjust, 'm');
	        }
	        if (offset !== input) {
	            if (!keepLocalTime || this._changeInProgress) {
	                addSubtract(
	                    this,
	                    createDuration(input - offset, 'm'),
	                    1,
	                    false
	                );
	            } else if (!this._changeInProgress) {
	                this._changeInProgress = true;
	                hooks$1.updateOffset(this, true);
	                this._changeInProgress = null;
	            }
	        }
	        return this;
	    } else {
	        return this._isUTC ? offset : getDateOffset(this);
	    }
	}

	function getSetZone(input, keepLocalTime) {
	    if (input != null) {
	        if (typeof input !== 'string') {
	            input = -input;
	        }

	        this.utcOffset(input, keepLocalTime);

	        return this;
	    } else {
	        return -this.utcOffset();
	    }
	}

	function setOffsetToUTC(keepLocalTime) {
	    return this.utcOffset(0, keepLocalTime);
	}

	function setOffsetToLocal(keepLocalTime) {
	    if (this._isUTC) {
	        this.utcOffset(0, keepLocalTime);
	        this._isUTC = false;

	        if (keepLocalTime) {
	            this.subtract(getDateOffset(this), 'm');
	        }
	    }
	    return this;
	}

	function setOffsetToParsedOffset() {
	    if (this._tzm != null) {
	        this.utcOffset(this._tzm, false, true);
	    } else if (typeof this._i === 'string') {
	        var tZone = offsetFromString(matchOffset, this._i);
	        if (tZone != null) {
	            this.utcOffset(tZone);
	        } else {
	            this.utcOffset(0, true);
	        }
	    }
	    return this;
	}

	function hasAlignedHourOffset(input) {
	    if (!this.isValid()) {
	        return false;
	    }
	    input = input ? createLocal(input).utcOffset() : 0;

	    return (this.utcOffset() - input) % 60 === 0;
	}

	function isDaylightSavingTime() {
	    return (
	        this.utcOffset() > this.clone().month(0).utcOffset() ||
	        this.utcOffset() > this.clone().month(5).utcOffset()
	    );
	}

	function isDaylightSavingTimeShifted() {
	    if (!isUndefined(this._isDSTShifted)) {
	        return this._isDSTShifted;
	    }

	    var c = {},
	        other;

	    copyConfig(c, this);
	    c = prepareConfig(c);

	    if (c._a) {
	        other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
	        this._isDSTShifted =
	            this.isValid() && compareArrays(c._a, other.toArray()) > 0;
	    } else {
	        this._isDSTShifted = false;
	    }

	    return this._isDSTShifted;
	}

	function isLocal() {
	    return this.isValid() ? !this._isUTC : false;
	}

	function isUtcOffset() {
	    return this.isValid() ? this._isUTC : false;
	}

	function isUtc() {
	    return this.isValid() ? this._isUTC && this._offset === 0 : false;
	}

	// ASP.NET json date format regex
	var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
	    // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	    // and further modified to allow for strings containing both week and day
	    isoRegex =
	        /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

	function createDuration(input, key) {
	    var duration = input,
	        // matching against regexp is expensive, do it on demand
	        match = null,
	        sign,
	        ret,
	        diffRes;

	    if (isDuration(input)) {
	        duration = {
	            ms: input._milliseconds,
	            d: input._days,
	            M: input._months,
	        };
	    } else if (isNumber(input) || !isNaN(+input)) {
	        duration = {};
	        if (key) {
	            duration[key] = +input;
	        } else {
	            duration.milliseconds = +input;
	        }
	    } else if ((match = aspNetRegex.exec(input))) {
	        sign = match[1] === '-' ? -1 : 1;
	        duration = {
	            y: 0,
	            d: toInt(match[DATE]) * sign,
	            h: toInt(match[HOUR]) * sign,
	            m: toInt(match[MINUTE]) * sign,
	            s: toInt(match[SECOND]) * sign,
	            ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign, // the millisecond decimal point is included in the match
	        };
	    } else if ((match = isoRegex.exec(input))) {
	        sign = match[1] === '-' ? -1 : 1;
	        duration = {
	            y: parseIso(match[2], sign),
	            M: parseIso(match[3], sign),
	            w: parseIso(match[4], sign),
	            d: parseIso(match[5], sign),
	            h: parseIso(match[6], sign),
	            m: parseIso(match[7], sign),
	            s: parseIso(match[8], sign),
	        };
	    } else if (duration == null) {
	        // checks for null or undefined
	        duration = {};
	    } else if (
	        typeof duration === 'object' &&
	        ('from' in duration || 'to' in duration)
	    ) {
	        diffRes = momentsDifference(
	            createLocal(duration.from),
	            createLocal(duration.to)
	        );

	        duration = {};
	        duration.ms = diffRes.milliseconds;
	        duration.M = diffRes.months;
	    }

	    ret = new Duration(duration);

	    if (isDuration(input) && hasOwnProp(input, '_locale')) {
	        ret._locale = input._locale;
	    }

	    if (isDuration(input) && hasOwnProp(input, '_isValid')) {
	        ret._isValid = input._isValid;
	    }

	    return ret;
	}

	createDuration.fn = Duration.prototype;
	createDuration.invalid = createInvalid$1;

	function parseIso(inp, sign) {
	    // We'd normally use ~~inp for this, but unfortunately it also
	    // converts floats to ints.
	    // inp may be undefined, so careful calling replace on it.
	    var res = inp && parseFloat(inp.replace(',', '.'));
	    // apply sign while we're at it
	    return (isNaN(res) ? 0 : res) * sign;
	}

	function positiveMomentsDifference(base, other) {
	    var res = {};

	    res.months =
	        other.month() - base.month() + (other.year() - base.year()) * 12;
	    if (base.clone().add(res.months, 'M').isAfter(other)) {
	        --res.months;
	    }

	    res.milliseconds = +other - +base.clone().add(res.months, 'M');

	    return res;
	}

	function momentsDifference(base, other) {
	    var res;
	    if (!(base.isValid() && other.isValid())) {
	        return { milliseconds: 0, months: 0 };
	    }

	    other = cloneWithOffset(other, base);
	    if (base.isBefore(other)) {
	        res = positiveMomentsDifference(base, other);
	    } else {
	        res = positiveMomentsDifference(other, base);
	        res.milliseconds = -res.milliseconds;
	        res.months = -res.months;
	    }

	    return res;
	}

	// TODO: remove 'name' arg after deprecation is removed
	function createAdder(direction, name) {
	    return function (val, period) {
	        var dur, tmp;
	        //invert the arguments, but complain about it
	        if (period !== null && !isNaN(+period)) {
	            deprecateSimple(
	                name,
	                'moment().' +
	                    name +
	                    '(period, number) is deprecated. Please use moment().' +
	                    name +
	                    '(number, period). ' +
	                    'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
	            );
	            tmp = val;
	            val = period;
	            period = tmp;
	        }

	        dur = createDuration(val, period);
	        addSubtract(this, dur, direction);
	        return this;
	    };
	}

	function addSubtract(mom, duration, isAdding, updateOffset) {
	    var milliseconds = duration._milliseconds,
	        days = absRound(duration._days),
	        months = absRound(duration._months);

	    if (!mom.isValid()) {
	        // No op
	        return;
	    }

	    updateOffset = updateOffset == null ? true : updateOffset;

	    if (months) {
	        setMonth(mom, get(mom, 'Month') + months * isAdding);
	    }
	    if (days) {
	        set$1$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
	    }
	    if (milliseconds) {
	        mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
	    }
	    if (updateOffset) {
	        hooks$1.updateOffset(mom, days || months);
	    }
	}

	var add$3 = createAdder(1, 'add'),
	    subtract = createAdder(-1, 'subtract');

	function isString(input) {
	    return typeof input === 'string' || input instanceof String;
	}

	// type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
	function isMomentInput(input) {
	    return (
	        isMoment(input) ||
	        isDate(input) ||
	        isString(input) ||
	        isNumber(input) ||
	        isNumberOrStringArray(input) ||
	        isMomentInputObject(input) ||
	        input === null ||
	        input === undefined
	    );
	}

	function isMomentInputObject(input) {
	    var objectTest = isObject$4(input) && !isObjectEmpty(input),
	        propertyTest = false,
	        properties = [
	            'years',
	            'year',
	            'y',
	            'months',
	            'month',
	            'M',
	            'days',
	            'day',
	            'd',
	            'dates',
	            'date',
	            'D',
	            'hours',
	            'hour',
	            'h',
	            'minutes',
	            'minute',
	            'm',
	            'seconds',
	            'second',
	            's',
	            'milliseconds',
	            'millisecond',
	            'ms' ],
	        i,
	        property,
	        propertyLen = properties.length;

	    for (i = 0; i < propertyLen; i += 1) {
	        property = properties[i];
	        propertyTest = propertyTest || hasOwnProp(input, property);
	    }

	    return objectTest && propertyTest;
	}

	function isNumberOrStringArray(input) {
	    var arrayTest = isArray$2(input),
	        dataTypeTest = false;
	    if (arrayTest) {
	        dataTypeTest =
	            input.filter(function (item) {
	                return !isNumber(item) && isString(input);
	            }).length === 0;
	    }
	    return arrayTest && dataTypeTest;
	}

	function isCalendarSpec(input) {
	    var objectTest = isObject$4(input) && !isObjectEmpty(input),
	        propertyTest = false,
	        properties = [
	            'sameDay',
	            'nextDay',
	            'lastDay',
	            'nextWeek',
	            'lastWeek',
	            'sameElse' ],
	        i,
	        property;

	    for (i = 0; i < properties.length; i += 1) {
	        property = properties[i];
	        propertyTest = propertyTest || hasOwnProp(input, property);
	    }

	    return objectTest && propertyTest;
	}

	function getCalendarFormat(myMoment, now) {
	    var diff = myMoment.diff(now, 'days', true);
	    return diff < -6
	        ? 'sameElse'
	        : diff < -1
	        ? 'lastWeek'
	        : diff < 0
	        ? 'lastDay'
	        : diff < 1
	        ? 'sameDay'
	        : diff < 2
	        ? 'nextDay'
	        : diff < 7
	        ? 'nextWeek'
	        : 'sameElse';
	}

	function calendar$1(time, formats) {
	    // Support for single parameter, formats only overload to the calendar function
	    if (arguments.length === 1) {
	        if (!arguments[0]) {
	            time = undefined;
	            formats = undefined;
	        } else if (isMomentInput(arguments[0])) {
	            time = arguments[0];
	            formats = undefined;
	        } else if (isCalendarSpec(arguments[0])) {
	            formats = arguments[0];
	            time = undefined;
	        }
	    }
	    // We want to compare the start of today, vs this.
	    // Getting start-of-today depends on whether we're local/utc/offset or not.
	    var now = time || createLocal(),
	        sod = cloneWithOffset(now, this).startOf('day'),
	        format = hooks$1.calendarFormat(this, sod) || 'sameElse',
	        output =
	            formats &&
	            (isFunction(formats[format])
	                ? formats[format].call(this, now)
	                : formats[format]);

	    return this.format(
	        output || this.localeData().calendar(format, this, createLocal(now))
	    );
	}

	function clone$1() {
	    return new Moment(this);
	}

	function isAfter(input, units) {
	    var localInput = isMoment(input) ? input : createLocal(input);
	    if (!(this.isValid() && localInput.isValid())) {
	        return false;
	    }
	    units = normalizeUnits(units) || 'millisecond';
	    if (units === 'millisecond') {
	        return this.valueOf() > localInput.valueOf();
	    } else {
	        return localInput.valueOf() < this.clone().startOf(units).valueOf();
	    }
	}

	function isBefore(input, units) {
	    var localInput = isMoment(input) ? input : createLocal(input);
	    if (!(this.isValid() && localInput.isValid())) {
	        return false;
	    }
	    units = normalizeUnits(units) || 'millisecond';
	    if (units === 'millisecond') {
	        return this.valueOf() < localInput.valueOf();
	    } else {
	        return this.clone().endOf(units).valueOf() < localInput.valueOf();
	    }
	}

	function isBetween(from, to, units, inclusivity) {
	    var localFrom = isMoment(from) ? from : createLocal(from),
	        localTo = isMoment(to) ? to : createLocal(to);
	    if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
	        return false;
	    }
	    inclusivity = inclusivity || '()';
	    return (
	        (inclusivity[0] === '('
	            ? this.isAfter(localFrom, units)
	            : !this.isBefore(localFrom, units)) &&
	        (inclusivity[1] === ')'
	            ? this.isBefore(localTo, units)
	            : !this.isAfter(localTo, units))
	    );
	}

	function isSame(input, units) {
	    var localInput = isMoment(input) ? input : createLocal(input),
	        inputMs;
	    if (!(this.isValid() && localInput.isValid())) {
	        return false;
	    }
	    units = normalizeUnits(units) || 'millisecond';
	    if (units === 'millisecond') {
	        return this.valueOf() === localInput.valueOf();
	    } else {
	        inputMs = localInput.valueOf();
	        return (
	            this.clone().startOf(units).valueOf() <= inputMs &&
	            inputMs <= this.clone().endOf(units).valueOf()
	        );
	    }
	}

	function isSameOrAfter(input, units) {
	    return this.isSame(input, units) || this.isAfter(input, units);
	}

	function isSameOrBefore(input, units) {
	    return this.isSame(input, units) || this.isBefore(input, units);
	}

	function diff(input, units, asFloat) {
	    var that, zoneDelta, output;

	    if (!this.isValid()) {
	        return NaN;
	    }

	    that = cloneWithOffset(input, this);

	    if (!that.isValid()) {
	        return NaN;
	    }

	    zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

	    units = normalizeUnits(units);

	    switch (units) {
	        case 'year':
	            output = monthDiff(this, that) / 12;
	            break;
	        case 'month':
	            output = monthDiff(this, that);
	            break;
	        case 'quarter':
	            output = monthDiff(this, that) / 3;
	            break;
	        case 'second':
	            output = (this - that) / 1e3;
	            break; // 1000
	        case 'minute':
	            output = (this - that) / 6e4;
	            break; // 1000 * 60
	        case 'hour':
	            output = (this - that) / 36e5;
	            break; // 1000 * 60 * 60
	        case 'day':
	            output = (this - that - zoneDelta) / 864e5;
	            break; // 1000 * 60 * 60 * 24, negate dst
	        case 'week':
	            output = (this - that - zoneDelta) / 6048e5;
	            break; // 1000 * 60 * 60 * 24 * 7, negate dst
	        default:
	            output = this - that;
	    }

	    return asFloat ? output : absFloor(output);
	}

	function monthDiff(a, b) {
	    if (a.date() < b.date()) {
	        // end-of-month calculations work correct when the start month has more
	        // days than the end month.
	        return -monthDiff(b, a);
	    }
	    // difference in months
	    var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
	        // b is in (anchor - 1 month, anchor + 1 month)
	        anchor = a.clone().add(wholeMonthDiff, 'months'),
	        anchor2,
	        adjust;

	    if (b - anchor < 0) {
	        anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	        // linear across the month
	        adjust = (b - anchor) / (anchor - anchor2);
	    } else {
	        anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	        // linear across the month
	        adjust = (b - anchor) / (anchor2 - anchor);
	    }

	    //check for negative zero, return zero if negative zero
	    return -(wholeMonthDiff + adjust) || 0;
	}

	hooks$1.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	hooks$1.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

	function toString$5() {
	    return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	}

	function toISOString(keepOffset) {
	    if (!this.isValid()) {
	        return null;
	    }
	    var utc = keepOffset !== true,
	        m = utc ? this.clone().utc() : this;
	    if (m.year() < 0 || m.year() > 9999) {
	        return formatMoment(
	            m,
	            utc
	                ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
	                : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
	        );
	    }
	    if (isFunction(Date.prototype.toISOString)) {
	        // native implementation is ~50x faster, use it when we can
	        if (utc) {
	            return this.toDate().toISOString();
	        } else {
	            return new Date(this.valueOf() + this.utcOffset() * 60 * 1000)
	                .toISOString()
	                .replace('Z', formatMoment(m, 'Z'));
	        }
	    }
	    return formatMoment(
	        m,
	        utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
	    );
	}

	/**
	 * Return a human readable representation of a moment that can
	 * also be evaluated to get a new moment which is the same
	 *
	 * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
	 */
	function inspect() {
	    if (!this.isValid()) {
	        return 'moment.invalid(/* ' + this._i + ' */)';
	    }
	    var func = 'moment',
	        zone = '',
	        prefix,
	        year,
	        datetime,
	        suffix;
	    if (!this.isLocal()) {
	        func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
	        zone = 'Z';
	    }
	    prefix = '[' + func + '("]';
	    year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
	    datetime = '-MM-DD[T]HH:mm:ss.SSS';
	    suffix = zone + '[")]';

	    return this.format(prefix + year + datetime + suffix);
	}

	function format(inputString) {
	    if (!inputString) {
	        inputString = this.isUtc()
	            ? hooks$1.defaultFormatUtc
	            : hooks$1.defaultFormat;
	    }
	    var output = formatMoment(this, inputString);
	    return this.localeData().postformat(output);
	}

	function from(time, withoutSuffix) {
	    if (
	        this.isValid() &&
	        ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
	    ) {
	        return createDuration({ to: this, from: time })
	            .locale(this.locale())
	            .humanize(!withoutSuffix);
	    } else {
	        return this.localeData().invalidDate();
	    }
	}

	function fromNow(withoutSuffix) {
	    return this.from(createLocal(), withoutSuffix);
	}

	function to(time, withoutSuffix) {
	    if (
	        this.isValid() &&
	        ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
	    ) {
	        return createDuration({ from: this, to: time })
	            .locale(this.locale())
	            .humanize(!withoutSuffix);
	    } else {
	        return this.localeData().invalidDate();
	    }
	}

	function toNow(withoutSuffix) {
	    return this.to(createLocal(), withoutSuffix);
	}

	// If passed a locale key, it will set the locale for this
	// instance.  Otherwise, it will return the locale configuration
	// variables for this instance.
	function locale(key) {
	    var newLocaleData;

	    if (key === undefined) {
	        return this._locale._abbr;
	    } else {
	        newLocaleData = getLocale(key);
	        if (newLocaleData != null) {
	            this._locale = newLocaleData;
	        }
	        return this;
	    }
	}

	var lang = deprecate(
	    'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
	    function (key) {
	        if (key === undefined) {
	            return this.localeData();
	        } else {
	            return this.locale(key);
	        }
	    }
	);

	function localeData() {
	    return this._locale;
	}

	var MS_PER_SECOND = 1000,
	    MS_PER_MINUTE = 60 * MS_PER_SECOND,
	    MS_PER_HOUR = 60 * MS_PER_MINUTE,
	    MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;

	// actual modulo - handles negative numbers (for dates before 1970):
	function mod$1(dividend, divisor) {
	    return ((dividend % divisor) + divisor) % divisor;
	}

	function localStartOfDate(y, m, d) {
	    // the date constructor remaps years 0-99 to 1900-1999
	    if (y < 100 && y >= 0) {
	        // preserve leap years using a full 400 year cycle, then reset
	        return new Date(y + 400, m, d) - MS_PER_400_YEARS;
	    } else {
	        return new Date(y, m, d).valueOf();
	    }
	}

	function utcStartOfDate(y, m, d) {
	    // Date.UTC remaps years 0-99 to 1900-1999
	    if (y < 100 && y >= 0) {
	        // preserve leap years using a full 400 year cycle, then reset
	        return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
	    } else {
	        return Date.UTC(y, m, d);
	    }
	}

	function startOf(units) {
	    var time, startOfDate;
	    units = normalizeUnits(units);
	    if (units === undefined || units === 'millisecond' || !this.isValid()) {
	        return this;
	    }

	    startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

	    switch (units) {
	        case 'year':
	            time = startOfDate(this.year(), 0, 1);
	            break;
	        case 'quarter':
	            time = startOfDate(
	                this.year(),
	                this.month() - (this.month() % 3),
	                1
	            );
	            break;
	        case 'month':
	            time = startOfDate(this.year(), this.month(), 1);
	            break;
	        case 'week':
	            time = startOfDate(
	                this.year(),
	                this.month(),
	                this.date() - this.weekday()
	            );
	            break;
	        case 'isoWeek':
	            time = startOfDate(
	                this.year(),
	                this.month(),
	                this.date() - (this.isoWeekday() - 1)
	            );
	            break;
	        case 'day':
	        case 'date':
	            time = startOfDate(this.year(), this.month(), this.date());
	            break;
	        case 'hour':
	            time = this._d.valueOf();
	            time -= mod$1(
	                time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
	                MS_PER_HOUR
	            );
	            break;
	        case 'minute':
	            time = this._d.valueOf();
	            time -= mod$1(time, MS_PER_MINUTE);
	            break;
	        case 'second':
	            time = this._d.valueOf();
	            time -= mod$1(time, MS_PER_SECOND);
	            break;
	    }

	    this._d.setTime(time);
	    hooks$1.updateOffset(this, true);
	    return this;
	}

	function endOf(units) {
	    var time, startOfDate;
	    units = normalizeUnits(units);
	    if (units === undefined || units === 'millisecond' || !this.isValid()) {
	        return this;
	    }

	    startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

	    switch (units) {
	        case 'year':
	            time = startOfDate(this.year() + 1, 0, 1) - 1;
	            break;
	        case 'quarter':
	            time =
	                startOfDate(
	                    this.year(),
	                    this.month() - (this.month() % 3) + 3,
	                    1
	                ) - 1;
	            break;
	        case 'month':
	            time = startOfDate(this.year(), this.month() + 1, 1) - 1;
	            break;
	        case 'week':
	            time =
	                startOfDate(
	                    this.year(),
	                    this.month(),
	                    this.date() - this.weekday() + 7
	                ) - 1;
	            break;
	        case 'isoWeek':
	            time =
	                startOfDate(
	                    this.year(),
	                    this.month(),
	                    this.date() - (this.isoWeekday() - 1) + 7
	                ) - 1;
	            break;
	        case 'day':
	        case 'date':
	            time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
	            break;
	        case 'hour':
	            time = this._d.valueOf();
	            time +=
	                MS_PER_HOUR -
	                mod$1(
	                    time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
	                    MS_PER_HOUR
	                ) -
	                1;
	            break;
	        case 'minute':
	            time = this._d.valueOf();
	            time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
	            break;
	        case 'second':
	            time = this._d.valueOf();
	            time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
	            break;
	    }

	    this._d.setTime(time);
	    hooks$1.updateOffset(this, true);
	    return this;
	}

	function valueOf() {
	    return this._d.valueOf() - (this._offset || 0) * 60000;
	}

	function unix() {
	    return Math.floor(this.valueOf() / 1000);
	}

	function toDate() {
	    return new Date(this.valueOf());
	}

	function toArray$5() {
	    var m = this;
	    return [
	        m.year(),
	        m.month(),
	        m.date(),
	        m.hour(),
	        m.minute(),
	        m.second(),
	        m.millisecond() ];
	}

	function toObject$1() {
	    var m = this;
	    return {
	        years: m.year(),
	        months: m.month(),
	        date: m.date(),
	        hours: m.hours(),
	        minutes: m.minutes(),
	        seconds: m.seconds(),
	        milliseconds: m.milliseconds(),
	    };
	}

	function toJSON() {
	    // new Date(NaN).toJSON() === null
	    return this.isValid() ? this.toISOString() : null;
	}

	function isValid$2() {
	    return isValid(this);
	}

	function parsingFlags() {
	    return extend$1({}, getParsingFlags(this));
	}

	function invalidAt() {
	    return getParsingFlags(this).overflow;
	}

	function creationData() {
	    return {
	        input: this._i,
	        format: this._f,
	        locale: this._locale,
	        isUTC: this._isUTC,
	        strict: this._strict,
	    };
	}

	addFormatToken('N', 0, 0, 'eraAbbr');
	addFormatToken('NN', 0, 0, 'eraAbbr');
	addFormatToken('NNN', 0, 0, 'eraAbbr');
	addFormatToken('NNNN', 0, 0, 'eraName');
	addFormatToken('NNNNN', 0, 0, 'eraNarrow');

	addFormatToken('y', ['y', 1], 'yo', 'eraYear');
	addFormatToken('y', ['yy', 2], 0, 'eraYear');
	addFormatToken('y', ['yyy', 3], 0, 'eraYear');
	addFormatToken('y', ['yyyy', 4], 0, 'eraYear');

	addRegexToken('N', matchEraAbbr);
	addRegexToken('NN', matchEraAbbr);
	addRegexToken('NNN', matchEraAbbr);
	addRegexToken('NNNN', matchEraName);
	addRegexToken('NNNNN', matchEraNarrow);

	addParseToken(
	    ['N', 'NN', 'NNN', 'NNNN', 'NNNNN'],
	    function (input, array, config, token) {
	        var era = config._locale.erasParse(input, token, config._strict);
	        if (era) {
	            getParsingFlags(config).era = era;
	        } else {
	            getParsingFlags(config).invalidEra = input;
	        }
	    }
	);

	addRegexToken('y', matchUnsigned);
	addRegexToken('yy', matchUnsigned);
	addRegexToken('yyy', matchUnsigned);
	addRegexToken('yyyy', matchUnsigned);
	addRegexToken('yo', matchEraYearOrdinal);

	addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
	addParseToken(['yo'], function (input, array, config, token) {
	    var match;
	    if (config._locale._eraYearOrdinalRegex) {
	        match = input.match(config._locale._eraYearOrdinalRegex);
	    }

	    if (config._locale.eraYearOrdinalParse) {
	        array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
	    } else {
	        array[YEAR] = parseInt(input, 10);
	    }
	});

	function localeEras(m, format) {
	    var i,
	        l,
	        date,
	        eras = this._eras || getLocale('en')._eras;
	    for (i = 0, l = eras.length; i < l; ++i) {
	        switch (typeof eras[i].since) {
	            case 'string':
	                // truncate time
	                date = hooks$1(eras[i].since).startOf('day');
	                eras[i].since = date.valueOf();
	                break;
	        }

	        switch (typeof eras[i].until) {
	            case 'undefined':
	                eras[i].until = +Infinity;
	                break;
	            case 'string':
	                // truncate time
	                date = hooks$1(eras[i].until).startOf('day').valueOf();
	                eras[i].until = date.valueOf();
	                break;
	        }
	    }
	    return eras;
	}

	function localeErasParse(eraName, format, strict) {
	    var i,
	        l,
	        eras = this.eras(),
	        name,
	        abbr,
	        narrow;
	    eraName = eraName.toUpperCase();

	    for (i = 0, l = eras.length; i < l; ++i) {
	        name = eras[i].name.toUpperCase();
	        abbr = eras[i].abbr.toUpperCase();
	        narrow = eras[i].narrow.toUpperCase();

	        if (strict) {
	            switch (format) {
	                case 'N':
	                case 'NN':
	                case 'NNN':
	                    if (abbr === eraName) {
	                        return eras[i];
	                    }
	                    break;

	                case 'NNNN':
	                    if (name === eraName) {
	                        return eras[i];
	                    }
	                    break;

	                case 'NNNNN':
	                    if (narrow === eraName) {
	                        return eras[i];
	                    }
	                    break;
	            }
	        } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
	            return eras[i];
	        }
	    }
	}

	function localeErasConvertYear(era, year) {
	    var dir = era.since <= era.until ? +1 : -1;
	    if (year === undefined) {
	        return hooks$1(era.since).year();
	    } else {
	        return hooks$1(era.since).year() + (year - era.offset) * dir;
	    }
	}

	function getEraName() {
	    var this$1 = this;

	    var i,
	        l,
	        val,
	        eras = this.localeData().eras();
	    for (i = 0, l = eras.length; i < l; ++i) {
	        // truncate time
	        val = this$1.clone().startOf('day').valueOf();

	        if (eras[i].since <= val && val <= eras[i].until) {
	            return eras[i].name;
	        }
	        if (eras[i].until <= val && val <= eras[i].since) {
	            return eras[i].name;
	        }
	    }

	    return '';
	}

	function getEraNarrow() {
	    var this$1 = this;

	    var i,
	        l,
	        val,
	        eras = this.localeData().eras();
	    for (i = 0, l = eras.length; i < l; ++i) {
	        // truncate time
	        val = this$1.clone().startOf('day').valueOf();

	        if (eras[i].since <= val && val <= eras[i].until) {
	            return eras[i].narrow;
	        }
	        if (eras[i].until <= val && val <= eras[i].since) {
	            return eras[i].narrow;
	        }
	    }

	    return '';
	}

	function getEraAbbr() {
	    var this$1 = this;

	    var i,
	        l,
	        val,
	        eras = this.localeData().eras();
	    for (i = 0, l = eras.length; i < l; ++i) {
	        // truncate time
	        val = this$1.clone().startOf('day').valueOf();

	        if (eras[i].since <= val && val <= eras[i].until) {
	            return eras[i].abbr;
	        }
	        if (eras[i].until <= val && val <= eras[i].since) {
	            return eras[i].abbr;
	        }
	    }

	    return '';
	}

	function getEraYear() {
	    var this$1 = this;

	    var i,
	        l,
	        dir,
	        val,
	        eras = this.localeData().eras();
	    for (i = 0, l = eras.length; i < l; ++i) {
	        dir = eras[i].since <= eras[i].until ? +1 : -1;

	        // truncate time
	        val = this$1.clone().startOf('day').valueOf();

	        if (
	            (eras[i].since <= val && val <= eras[i].until) ||
	            (eras[i].until <= val && val <= eras[i].since)
	        ) {
	            return (
	                (this$1.year() - hooks$1(eras[i].since).year()) * dir +
	                eras[i].offset
	            );
	        }
	    }

	    return this.year();
	}

	function erasNameRegex(isStrict) {
	    if (!hasOwnProp(this, '_erasNameRegex')) {
	        computeErasParse.call(this);
	    }
	    return isStrict ? this._erasNameRegex : this._erasRegex;
	}

	function erasAbbrRegex(isStrict) {
	    if (!hasOwnProp(this, '_erasAbbrRegex')) {
	        computeErasParse.call(this);
	    }
	    return isStrict ? this._erasAbbrRegex : this._erasRegex;
	}

	function erasNarrowRegex(isStrict) {
	    if (!hasOwnProp(this, '_erasNarrowRegex')) {
	        computeErasParse.call(this);
	    }
	    return isStrict ? this._erasNarrowRegex : this._erasRegex;
	}

	function matchEraAbbr(isStrict, locale) {
	    return locale.erasAbbrRegex(isStrict);
	}

	function matchEraName(isStrict, locale) {
	    return locale.erasNameRegex(isStrict);
	}

	function matchEraNarrow(isStrict, locale) {
	    return locale.erasNarrowRegex(isStrict);
	}

	function matchEraYearOrdinal(isStrict, locale) {
	    return locale._eraYearOrdinalRegex || matchUnsigned;
	}

	function computeErasParse() {
	    var abbrPieces = [],
	        namePieces = [],
	        narrowPieces = [],
	        mixedPieces = [],
	        i,
	        l,
	        eras = this.eras();

	    for (i = 0, l = eras.length; i < l; ++i) {
	        namePieces.push(regexEscape(eras[i].name));
	        abbrPieces.push(regexEscape(eras[i].abbr));
	        narrowPieces.push(regexEscape(eras[i].narrow));

	        mixedPieces.push(regexEscape(eras[i].name));
	        mixedPieces.push(regexEscape(eras[i].abbr));
	        mixedPieces.push(regexEscape(eras[i].narrow));
	    }

	    this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	    this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
	    this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
	    this._erasNarrowRegex = new RegExp(
	        '^(' + narrowPieces.join('|') + ')',
	        'i'
	    );
	}

	// FORMATTING

	addFormatToken(0, ['gg', 2], 0, function () {
	    return this.weekYear() % 100;
	});

	addFormatToken(0, ['GG', 2], 0, function () {
	    return this.isoWeekYear() % 100;
	});

	function addWeekYearFormatToken(token, getter) {
	    addFormatToken(0, [token, token.length], 0, getter);
	}

	addWeekYearFormatToken('gggg', 'weekYear');
	addWeekYearFormatToken('ggggg', 'weekYear');
	addWeekYearFormatToken('GGGG', 'isoWeekYear');
	addWeekYearFormatToken('GGGGG', 'isoWeekYear');

	// ALIASES

	addUnitAlias('weekYear', 'gg');
	addUnitAlias('isoWeekYear', 'GG');

	// PRIORITY

	addUnitPriority('weekYear', 1);
	addUnitPriority('isoWeekYear', 1);

	// PARSING

	addRegexToken('G', matchSigned);
	addRegexToken('g', matchSigned);
	addRegexToken('GG', match1to2, match2);
	addRegexToken('gg', match1to2, match2);
	addRegexToken('GGGG', match1to4, match4);
	addRegexToken('gggg', match1to4, match4);
	addRegexToken('GGGGG', match1to6, match6);
	addRegexToken('ggggg', match1to6, match6);

	addWeekParseToken(
	    ['gggg', 'ggggg', 'GGGG', 'GGGGG'],
	    function (input, week, config, token) {
	        week[token.substr(0, 2)] = toInt(input);
	    }
	);

	addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
	    week[token] = hooks$1.parseTwoDigitYear(input);
	});

	// MOMENTS

	function getSetWeekYear(input) {
	    return getSetWeekYearHelper.call(
	        this,
	        input,
	        this.week(),
	        this.weekday(),
	        this.localeData()._week.dow,
	        this.localeData()._week.doy
	    );
	}

	function getSetISOWeekYear(input) {
	    return getSetWeekYearHelper.call(
	        this,
	        input,
	        this.isoWeek(),
	        this.isoWeekday(),
	        1,
	        4
	    );
	}

	function getISOWeeksInYear() {
	    return weeksInYear(this.year(), 1, 4);
	}

	function getISOWeeksInISOWeekYear() {
	    return weeksInYear(this.isoWeekYear(), 1, 4);
	}

	function getWeeksInYear() {
	    var weekInfo = this.localeData()._week;
	    return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	}

	function getWeeksInWeekYear() {
	    var weekInfo = this.localeData()._week;
	    return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
	}

	function getSetWeekYearHelper(input, week, weekday, dow, doy) {
	    var weeksTarget;
	    if (input == null) {
	        return weekOfYear(this, dow, doy).year;
	    } else {
	        weeksTarget = weeksInYear(input, dow, doy);
	        if (week > weeksTarget) {
	            week = weeksTarget;
	        }
	        return setWeekAll.call(this, input, week, weekday, dow, doy);
	    }
	}

	function setWeekAll(weekYear, week, weekday, dow, doy) {
	    var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
	        date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

	    this.year(date.getUTCFullYear());
	    this.month(date.getUTCMonth());
	    this.date(date.getUTCDate());
	    return this;
	}

	// FORMATTING

	addFormatToken('Q', 0, 'Qo', 'quarter');

	// ALIASES

	addUnitAlias('quarter', 'Q');

	// PRIORITY

	addUnitPriority('quarter', 7);

	// PARSING

	addRegexToken('Q', match1);
	addParseToken('Q', function (input, array) {
	    array[MONTH] = (toInt(input) - 1) * 3;
	});

	// MOMENTS

	function getSetQuarter(input) {
	    return input == null
	        ? Math.ceil((this.month() + 1) / 3)
	        : this.month((input - 1) * 3 + (this.month() % 3));
	}

	// FORMATTING

	addFormatToken('D', ['DD', 2], 'Do', 'date');

	// ALIASES

	addUnitAlias('date', 'D');

	// PRIORITY
	addUnitPriority('date', 9);

	// PARSING

	addRegexToken('D', match1to2);
	addRegexToken('DD', match1to2, match2);
	addRegexToken('Do', function (isStrict, locale) {
	    // TODO: Remove "ordinalParse" fallback in next major release.
	    return isStrict
	        ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
	        : locale._dayOfMonthOrdinalParseLenient;
	});

	addParseToken(['D', 'DD'], DATE);
	addParseToken('Do', function (input, array) {
	    array[DATE] = toInt(input.match(match1to2)[0]);
	});

	// MOMENTS

	var getSetDayOfMonth = makeGetSet('Date', true);

	// FORMATTING

	addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

	// ALIASES

	addUnitAlias('dayOfYear', 'DDD');

	// PRIORITY
	addUnitPriority('dayOfYear', 4);

	// PARSING

	addRegexToken('DDD', match1to3);
	addRegexToken('DDDD', match3);
	addParseToken(['DDD', 'DDDD'], function (input, array, config) {
	    config._dayOfYear = toInt(input);
	});

	// HELPERS

	// MOMENTS

	function getSetDayOfYear(input) {
	    var dayOfYear =
	        Math.round(
	            (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
	        ) + 1;
	    return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
	}

	// FORMATTING

	addFormatToken('m', ['mm', 2], 0, 'minute');

	// ALIASES

	addUnitAlias('minute', 'm');

	// PRIORITY

	addUnitPriority('minute', 14);

	// PARSING

	addRegexToken('m', match1to2);
	addRegexToken('mm', match1to2, match2);
	addParseToken(['m', 'mm'], MINUTE);

	// MOMENTS

	var getSetMinute = makeGetSet('Minutes', false);

	// FORMATTING

	addFormatToken('s', ['ss', 2], 0, 'second');

	// ALIASES

	addUnitAlias('second', 's');

	// PRIORITY

	addUnitPriority('second', 15);

	// PARSING

	addRegexToken('s', match1to2);
	addRegexToken('ss', match1to2, match2);
	addParseToken(['s', 'ss'], SECOND);

	// MOMENTS

	var getSetSecond = makeGetSet('Seconds', false);

	// FORMATTING

	addFormatToken('S', 0, 0, function () {
	    return ~~(this.millisecond() / 100);
	});

	addFormatToken(0, ['SS', 2], 0, function () {
	    return ~~(this.millisecond() / 10);
	});

	addFormatToken(0, ['SSS', 3], 0, 'millisecond');
	addFormatToken(0, ['SSSS', 4], 0, function () {
	    return this.millisecond() * 10;
	});
	addFormatToken(0, ['SSSSS', 5], 0, function () {
	    return this.millisecond() * 100;
	});
	addFormatToken(0, ['SSSSSS', 6], 0, function () {
	    return this.millisecond() * 1000;
	});
	addFormatToken(0, ['SSSSSSS', 7], 0, function () {
	    return this.millisecond() * 10000;
	});
	addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
	    return this.millisecond() * 100000;
	});
	addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
	    return this.millisecond() * 1000000;
	});

	// ALIASES

	addUnitAlias('millisecond', 'ms');

	// PRIORITY

	addUnitPriority('millisecond', 16);

	// PARSING

	addRegexToken('S', match1to3, match1);
	addRegexToken('SS', match1to3, match2);
	addRegexToken('SSS', match1to3, match3);

	var token, getSetMillisecond;
	for (token = 'SSSS'; token.length <= 9; token += 'S') {
	    addRegexToken(token, matchUnsigned);
	}

	function parseMs(input, array) {
	    array[MILLISECOND] = toInt(('0.' + input) * 1000);
	}

	for (token = 'S'; token.length <= 9; token += 'S') {
	    addParseToken(token, parseMs);
	}

	getSetMillisecond = makeGetSet('Milliseconds', false);

	// FORMATTING

	addFormatToken('z', 0, 0, 'zoneAbbr');
	addFormatToken('zz', 0, 0, 'zoneName');

	// MOMENTS

	function getZoneAbbr() {
	    return this._isUTC ? 'UTC' : '';
	}

	function getZoneName() {
	    return this._isUTC ? 'Coordinated Universal Time' : '';
	}

	var proto = Moment.prototype;

	proto.add = add$3;
	proto.calendar = calendar$1;
	proto.clone = clone$1;
	proto.diff = diff;
	proto.endOf = endOf;
	proto.format = format;
	proto.from = from;
	proto.fromNow = fromNow;
	proto.to = to;
	proto.toNow = toNow;
	proto.get = stringGet;
	proto.invalidAt = invalidAt;
	proto.isAfter = isAfter;
	proto.isBefore = isBefore;
	proto.isBetween = isBetween;
	proto.isSame = isSame;
	proto.isSameOrAfter = isSameOrAfter;
	proto.isSameOrBefore = isSameOrBefore;
	proto.isValid = isValid$2;
	proto.lang = lang;
	proto.locale = locale;
	proto.localeData = localeData;
	proto.max = prototypeMax;
	proto.min = prototypeMin;
	proto.parsingFlags = parsingFlags;
	proto.set = stringSet;
	proto.startOf = startOf;
	proto.subtract = subtract;
	proto.toArray = toArray$5;
	proto.toObject = toObject$1;
	proto.toDate = toDate;
	proto.toISOString = toISOString;
	proto.inspect = inspect;
	if (typeof Symbol !== 'undefined' && Symbol.for != null) {
	    proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
	        return 'Moment<' + this.format() + '>';
	    };
	}
	proto.toJSON = toJSON;
	proto.toString = toString$5;
	proto.unix = unix;
	proto.valueOf = valueOf;
	proto.creationData = creationData;
	proto.eraName = getEraName;
	proto.eraNarrow = getEraNarrow;
	proto.eraAbbr = getEraAbbr;
	proto.eraYear = getEraYear;
	proto.year = getSetYear;
	proto.isLeapYear = getIsLeapYear;
	proto.weekYear = getSetWeekYear;
	proto.isoWeekYear = getSetISOWeekYear;
	proto.quarter = proto.quarters = getSetQuarter;
	proto.month = getSetMonth;
	proto.daysInMonth = getDaysInMonth;
	proto.week = proto.weeks = getSetWeek;
	proto.isoWeek = proto.isoWeeks = getSetISOWeek;
	proto.weeksInYear = getWeeksInYear;
	proto.weeksInWeekYear = getWeeksInWeekYear;
	proto.isoWeeksInYear = getISOWeeksInYear;
	proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
	proto.date = getSetDayOfMonth;
	proto.day = proto.days = getSetDayOfWeek;
	proto.weekday = getSetLocaleDayOfWeek;
	proto.isoWeekday = getSetISODayOfWeek;
	proto.dayOfYear = getSetDayOfYear;
	proto.hour = proto.hours = getSetHour;
	proto.minute = proto.minutes = getSetMinute;
	proto.second = proto.seconds = getSetSecond;
	proto.millisecond = proto.milliseconds = getSetMillisecond;
	proto.utcOffset = getSetOffset;
	proto.utc = setOffsetToUTC;
	proto.local = setOffsetToLocal;
	proto.parseZone = setOffsetToParsedOffset;
	proto.hasAlignedHourOffset = hasAlignedHourOffset;
	proto.isDST = isDaylightSavingTime;
	proto.isLocal = isLocal;
	proto.isUtcOffset = isUtcOffset;
	proto.isUtc = isUtc;
	proto.isUTC = isUtc;
	proto.zoneAbbr = getZoneAbbr;
	proto.zoneName = getZoneName;
	proto.dates = deprecate(
	    'dates accessor is deprecated. Use date instead.',
	    getSetDayOfMonth
	);
	proto.months = deprecate(
	    'months accessor is deprecated. Use month instead',
	    getSetMonth
	);
	proto.years = deprecate(
	    'years accessor is deprecated. Use year instead',
	    getSetYear
	);
	proto.zone = deprecate(
	    'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
	    getSetZone
	);
	proto.isDSTShifted = deprecate(
	    'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
	    isDaylightSavingTimeShifted
	);

	function createUnix(input) {
	    return createLocal(input * 1000);
	}

	function createInZone() {
	    return createLocal.apply(null, arguments).parseZone();
	}

	function preParsePostFormat(string) {
	    return string;
	}

	var proto$1 = Locale.prototype;

	proto$1.calendar = calendar;
	proto$1.longDateFormat = longDateFormat;
	proto$1.invalidDate = invalidDate;
	proto$1.ordinal = ordinal;
	proto$1.preparse = preParsePostFormat;
	proto$1.postformat = preParsePostFormat;
	proto$1.relativeTime = relativeTime;
	proto$1.pastFuture = pastFuture;
	proto$1.set = set$1;
	proto$1.eras = localeEras;
	proto$1.erasParse = localeErasParse;
	proto$1.erasConvertYear = localeErasConvertYear;
	proto$1.erasAbbrRegex = erasAbbrRegex;
	proto$1.erasNameRegex = erasNameRegex;
	proto$1.erasNarrowRegex = erasNarrowRegex;

	proto$1.months = localeMonths;
	proto$1.monthsShort = localeMonthsShort;
	proto$1.monthsParse = localeMonthsParse;
	proto$1.monthsRegex = monthsRegex;
	proto$1.monthsShortRegex = monthsShortRegex;
	proto$1.week = localeWeek;
	proto$1.firstDayOfYear = localeFirstDayOfYear;
	proto$1.firstDayOfWeek = localeFirstDayOfWeek;

	proto$1.weekdays = localeWeekdays;
	proto$1.weekdaysMin = localeWeekdaysMin;
	proto$1.weekdaysShort = localeWeekdaysShort;
	proto$1.weekdaysParse = localeWeekdaysParse;

	proto$1.weekdaysRegex = weekdaysRegex;
	proto$1.weekdaysShortRegex = weekdaysShortRegex;
	proto$1.weekdaysMinRegex = weekdaysMinRegex;

	proto$1.isPM = localeIsPM;
	proto$1.meridiem = localeMeridiem;

	function get$1(format, index, field, setter) {
	    var locale = getLocale(),
	        utc = createUTC().set(setter, index);
	    return locale[field](utc, format);
	}

	function listMonthsImpl(format, index, field) {
	    if (isNumber(format)) {
	        index = format;
	        format = undefined;
	    }

	    format = format || '';

	    if (index != null) {
	        return get$1(format, index, field, 'month');
	    }

	    var i,
	        out = [];
	    for (i = 0; i < 12; i++) {
	        out[i] = get$1(format, i, field, 'month');
	    }
	    return out;
	}

	// ()
	// (5)
	// (fmt, 5)
	// (fmt)
	// (true)
	// (true, 5)
	// (true, fmt, 5)
	// (true, fmt)
	function listWeekdaysImpl(localeSorted, format, index, field) {
	    if (typeof localeSorted === 'boolean') {
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }

	        format = format || '';
	    } else {
	        format = localeSorted;
	        index = format;
	        localeSorted = false;

	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }

	        format = format || '';
	    }

	    var locale = getLocale(),
	        shift = localeSorted ? locale._week.dow : 0,
	        i,
	        out = [];

	    if (index != null) {
	        return get$1(format, (index + shift) % 7, field, 'day');
	    }

	    for (i = 0; i < 7; i++) {
	        out[i] = get$1(format, (i + shift) % 7, field, 'day');
	    }
	    return out;
	}

	function listMonths(format, index) {
	    return listMonthsImpl(format, index, 'months');
	}

	function listMonthsShort(format, index) {
	    return listMonthsImpl(format, index, 'monthsShort');
	}

	function listWeekdays(localeSorted, format, index) {
	    return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
	}

	function listWeekdaysShort(localeSorted, format, index) {
	    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
	}

	function listWeekdaysMin(localeSorted, format, index) {
	    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
	}

	getSetGlobalLocale('en', {
	    eras: [
	        {
	            since: '0001-01-01',
	            until: +Infinity,
	            offset: 1,
	            name: 'Anno Domini',
	            narrow: 'AD',
	            abbr: 'AD',
	        },
	        {
	            since: '0000-12-31',
	            until: -Infinity,
	            offset: 1,
	            name: 'Before Christ',
	            narrow: 'BC',
	            abbr: 'BC',
	        } ],
	    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	    ordinal: function (number) {
	        var b = number % 10,
	            output =
	                toInt((number % 100) / 10) === 1
	                    ? 'th'
	                    : b === 1
	                    ? 'st'
	                    : b === 2
	                    ? 'nd'
	                    : b === 3
	                    ? 'rd'
	                    : 'th';
	        return number + output;
	    },
	});

	// Side effect imports

	hooks$1.lang = deprecate(
	    'moment.lang is deprecated. Use moment.locale instead.',
	    getSetGlobalLocale
	);
	hooks$1.langData = deprecate(
	    'moment.langData is deprecated. Use moment.localeData instead.',
	    getLocale
	);

	var mathAbs = Math.abs;

	function abs() {
	    var data = this._data;

	    this._milliseconds = mathAbs(this._milliseconds);
	    this._days = mathAbs(this._days);
	    this._months = mathAbs(this._months);

	    data.milliseconds = mathAbs(data.milliseconds);
	    data.seconds = mathAbs(data.seconds);
	    data.minutes = mathAbs(data.minutes);
	    data.hours = mathAbs(data.hours);
	    data.months = mathAbs(data.months);
	    data.years = mathAbs(data.years);

	    return this;
	}

	function addSubtract$1(duration, input, value, direction) {
	    var other = createDuration(input, value);

	    duration._milliseconds += direction * other._milliseconds;
	    duration._days += direction * other._days;
	    duration._months += direction * other._months;

	    return duration._bubble();
	}

	// supports only 2.0-style add(1, 's') or add(duration)
	function add$1$1(input, value) {
	    return addSubtract$1(this, input, value, 1);
	}

	// supports only 2.0-style subtract(1, 's') or subtract(duration)
	function subtract$1(input, value) {
	    return addSubtract$1(this, input, value, -1);
	}

	function absCeil(number) {
	    if (number < 0) {
	        return Math.floor(number);
	    } else {
	        return Math.ceil(number);
	    }
	}

	function bubble() {
	    var milliseconds = this._milliseconds,
	        days = this._days,
	        months = this._months,
	        data = this._data,
	        seconds,
	        minutes,
	        hours,
	        years,
	        monthsFromDays;

	    // if we have a mix of positive and negative values, bubble down first
	    // check: https://github.com/moment/moment/issues/2166
	    if (
	        !(
	            (milliseconds >= 0 && days >= 0 && months >= 0) ||
	            (milliseconds <= 0 && days <= 0 && months <= 0)
	        )
	    ) {
	        milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
	        days = 0;
	        months = 0;
	    }

	    // The following code bubbles up values, see the tests for
	    // examples of what that means.
	    data.milliseconds = milliseconds % 1000;

	    seconds = absFloor(milliseconds / 1000);
	    data.seconds = seconds % 60;

	    minutes = absFloor(seconds / 60);
	    data.minutes = minutes % 60;

	    hours = absFloor(minutes / 60);
	    data.hours = hours % 24;

	    days += absFloor(hours / 24);

	    // convert days to months
	    monthsFromDays = absFloor(daysToMonths(days));
	    months += monthsFromDays;
	    days -= absCeil(monthsToDays(monthsFromDays));

	    // 12 months -> 1 year
	    years = absFloor(months / 12);
	    months %= 12;

	    data.days = days;
	    data.months = months;
	    data.years = years;

	    return this;
	}

	function daysToMonths(days) {
	    // 400 years have 146097 days (taking into account leap year rules)
	    // 400 years have 12 months === 4800
	    return (days * 4800) / 146097;
	}

	function monthsToDays(months) {
	    // the reverse of daysToMonths
	    return (months * 146097) / 4800;
	}

	function as(units) {
	    if (!this.isValid()) {
	        return NaN;
	    }
	    var days,
	        months,
	        milliseconds = this._milliseconds;

	    units = normalizeUnits(units);

	    if (units === 'month' || units === 'quarter' || units === 'year') {
	        days = this._days + milliseconds / 864e5;
	        months = this._months + daysToMonths(days);
	        switch (units) {
	            case 'month':
	                return months;
	            case 'quarter':
	                return months / 3;
	            case 'year':
	                return months / 12;
	        }
	    } else {
	        // handle milliseconds separately because of floating point math errors (issue #1867)
	        days = this._days + Math.round(monthsToDays(this._months));
	        switch (units) {
	            case 'week':
	                return days / 7 + milliseconds / 6048e5;
	            case 'day':
	                return days + milliseconds / 864e5;
	            case 'hour':
	                return days * 24 + milliseconds / 36e5;
	            case 'minute':
	                return days * 1440 + milliseconds / 6e4;
	            case 'second':
	                return days * 86400 + milliseconds / 1000;
	            // Math.floor prevents floating point math errors here
	            case 'millisecond':
	                return Math.floor(days * 864e5) + milliseconds;
	            default:
	                throw new Error('Unknown unit ' + units);
	        }
	    }
	}

	// TODO: Use this.as('ms')?
	function valueOf$1() {
	    if (!this.isValid()) {
	        return NaN;
	    }
	    return (
	        this._milliseconds +
	        this._days * 864e5 +
	        (this._months % 12) * 2592e6 +
	        toInt(this._months / 12) * 31536e6
	    );
	}

	function makeAs(alias) {
	    return function () {
	        return this.as(alias);
	    };
	}

	var asMilliseconds = makeAs('ms'),
	    asSeconds = makeAs('s'),
	    asMinutes = makeAs('m'),
	    asHours = makeAs('h'),
	    asDays = makeAs('d'),
	    asWeeks = makeAs('w'),
	    asMonths = makeAs('M'),
	    asQuarters = makeAs('Q'),
	    asYears = makeAs('y');

	function clone$1$1() {
	    return createDuration(this);
	}

	function get$2(units) {
	    units = normalizeUnits(units);
	    return this.isValid() ? this[units + 's']() : NaN;
	}

	function makeGetter(name) {
	    return function () {
	        return this.isValid() ? this._data[name] : NaN;
	    };
	}

	var milliseconds = makeGetter('milliseconds'),
	    seconds = makeGetter('seconds'),
	    minutes = makeGetter('minutes'),
	    hours = makeGetter('hours'),
	    days = makeGetter('days'),
	    months = makeGetter('months'),
	    years = makeGetter('years');

	function weeks() {
	    return absFloor(this.days() / 7);
	}

	var round = Math.round,
	    thresholds = {
	        ss: 44, // a few seconds to seconds
	        s: 45, // seconds to minute
	        m: 45, // minutes to hour
	        h: 22, // hours to day
	        d: 26, // days to month/week
	        w: null, // weeks to month
	        M: 11, // months to year
	    };

	// helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	    return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	}

	function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
	    var duration = createDuration(posNegDuration).abs(),
	        seconds = round(duration.as('s')),
	        minutes = round(duration.as('m')),
	        hours = round(duration.as('h')),
	        days = round(duration.as('d')),
	        months = round(duration.as('M')),
	        weeks = round(duration.as('w')),
	        years = round(duration.as('y')),
	        a =
	            (seconds <= thresholds.ss && ['s', seconds]) ||
	            (seconds < thresholds.s && ['ss', seconds]) ||
	            (minutes <= 1 && ['m']) ||
	            (minutes < thresholds.m && ['mm', minutes]) ||
	            (hours <= 1 && ['h']) ||
	            (hours < thresholds.h && ['hh', hours]) ||
	            (days <= 1 && ['d']) ||
	            (days < thresholds.d && ['dd', days]);

	    if (thresholds.w != null) {
	        a =
	            a ||
	            (weeks <= 1 && ['w']) ||
	            (weeks < thresholds.w && ['ww', weeks]);
	    }
	    a = a ||
	        (months <= 1 && ['M']) ||
	        (months < thresholds.M && ['MM', months]) ||
	        (years <= 1 && ['y']) || ['yy', years];

	    a[2] = withoutSuffix;
	    a[3] = +posNegDuration > 0;
	    a[4] = locale;
	    return substituteTimeAgo.apply(null, a);
	}

	// This function allows you to set the rounding function for relative time strings
	function getSetRelativeTimeRounding(roundingFunction) {
	    if (roundingFunction === undefined) {
	        return round;
	    }
	    if (typeof roundingFunction === 'function') {
	        round = roundingFunction;
	        return true;
	    }
	    return false;
	}

	// This function allows you to set a threshold for relative time strings
	function getSetRelativeTimeThreshold(threshold, limit) {
	    if (thresholds[threshold] === undefined) {
	        return false;
	    }
	    if (limit === undefined) {
	        return thresholds[threshold];
	    }
	    thresholds[threshold] = limit;
	    if (threshold === 's') {
	        thresholds.ss = limit - 1;
	    }
	    return true;
	}

	function humanize(argWithSuffix, argThresholds) {
	    if (!this.isValid()) {
	        return this.localeData().invalidDate();
	    }

	    var withSuffix = false,
	        th = thresholds,
	        locale,
	        output;

	    if (typeof argWithSuffix === 'object') {
	        argThresholds = argWithSuffix;
	        argWithSuffix = false;
	    }
	    if (typeof argWithSuffix === 'boolean') {
	        withSuffix = argWithSuffix;
	    }
	    if (typeof argThresholds === 'object') {
	        th = Object.assign({}, thresholds, argThresholds);
	        if (argThresholds.s != null && argThresholds.ss == null) {
	            th.ss = argThresholds.s - 1;
	        }
	    }

	    locale = this.localeData();
	    output = relativeTime$1(this, !withSuffix, th, locale);

	    if (withSuffix) {
	        output = locale.pastFuture(+this, output);
	    }

	    return locale.postformat(output);
	}

	var abs$1 = Math.abs;

	function sign(x) {
	    return (x > 0) - (x < 0) || +x;
	}

	function toISOString$1() {
	    // for ISO strings we do not use the normal bubbling rules:
	    //  * milliseconds bubble up until they become hours
	    //  * days do not bubble at all
	    //  * months bubble up until they become years
	    // This is because there is no context-free conversion between hours and days
	    // (think of clock changes)
	    // and also not between days and months (28-31 days per month)
	    if (!this.isValid()) {
	        return this.localeData().invalidDate();
	    }

	    var seconds = abs$1(this._milliseconds) / 1000,
	        days = abs$1(this._days),
	        months = abs$1(this._months),
	        minutes,
	        hours,
	        years,
	        s,
	        total = this.asSeconds(),
	        totalSign,
	        ymSign,
	        daysSign,
	        hmsSign;

	    if (!total) {
	        // this is the same as C#'s (Noda) and python (isodate)...
	        // but not other JS (goog.date)
	        return 'P0D';
	    }

	    // 3600 seconds -> 60 minutes -> 1 hour
	    minutes = absFloor(seconds / 60);
	    hours = absFloor(minutes / 60);
	    seconds %= 60;
	    minutes %= 60;

	    // 12 months -> 1 year
	    years = absFloor(months / 12);
	    months %= 12;

	    // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	    s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';

	    totalSign = total < 0 ? '-' : '';
	    ymSign = sign(this._months) !== sign(total) ? '-' : '';
	    daysSign = sign(this._days) !== sign(total) ? '-' : '';
	    hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

	    return (
	        totalSign +
	        'P' +
	        (years ? ymSign + years + 'Y' : '') +
	        (months ? ymSign + months + 'M' : '') +
	        (days ? daysSign + days + 'D' : '') +
	        (hours || minutes || seconds ? 'T' : '') +
	        (hours ? hmsSign + hours + 'H' : '') +
	        (minutes ? hmsSign + minutes + 'M' : '') +
	        (seconds ? hmsSign + s + 'S' : '')
	    );
	}

	var proto$2 = Duration.prototype;

	proto$2.isValid = isValid$1;
	proto$2.abs = abs;
	proto$2.add = add$1$1;
	proto$2.subtract = subtract$1;
	proto$2.as = as;
	proto$2.asMilliseconds = asMilliseconds;
	proto$2.asSeconds = asSeconds;
	proto$2.asMinutes = asMinutes;
	proto$2.asHours = asHours;
	proto$2.asDays = asDays;
	proto$2.asWeeks = asWeeks;
	proto$2.asMonths = asMonths;
	proto$2.asQuarters = asQuarters;
	proto$2.asYears = asYears;
	proto$2.valueOf = valueOf$1;
	proto$2._bubble = bubble;
	proto$2.clone = clone$1$1;
	proto$2.get = get$2;
	proto$2.milliseconds = milliseconds;
	proto$2.seconds = seconds;
	proto$2.minutes = minutes;
	proto$2.hours = hours;
	proto$2.days = days;
	proto$2.weeks = weeks;
	proto$2.months = months;
	proto$2.years = years;
	proto$2.humanize = humanize;
	proto$2.toISOString = toISOString$1;
	proto$2.toString = toISOString$1;
	proto$2.toJSON = toISOString$1;
	proto$2.locale = locale;
	proto$2.localeData = localeData;

	proto$2.toIsoString = deprecate(
	    'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
	    toISOString$1
	);
	proto$2.lang = lang;

	// FORMATTING

	addFormatToken('X', 0, 0, 'unix');
	addFormatToken('x', 0, 0, 'valueOf');

	// PARSING

	addRegexToken('x', matchSigned);
	addRegexToken('X', matchTimestamp);
	addParseToken('X', function (input, array, config) {
	    config._d = new Date(parseFloat(input) * 1000);
	});
	addParseToken('x', function (input, array, config) {
	    config._d = new Date(toInt(input));
	});

	//! moment.js

	hooks$1.version = '2.29.4';

	setHookCallback(createLocal);

	hooks$1.fn = proto;
	hooks$1.min = min;
	hooks$1.max = max;
	hooks$1.now = now$3;
	hooks$1.utc = createUTC;
	hooks$1.unix = createUnix;
	hooks$1.months = listMonths;
	hooks$1.isDate = isDate;
	hooks$1.locale = getSetGlobalLocale;
	hooks$1.invalid = createInvalid;
	hooks$1.duration = createDuration;
	hooks$1.isMoment = isMoment;
	hooks$1.weekdays = listWeekdays;
	hooks$1.parseZone = createInZone;
	hooks$1.localeData = getLocale;
	hooks$1.isDuration = isDuration;
	hooks$1.monthsShort = listMonthsShort;
	hooks$1.weekdaysMin = listWeekdaysMin;
	hooks$1.defineLocale = defineLocale;
	hooks$1.updateLocale = updateLocale;
	hooks$1.locales = listLocales;
	hooks$1.weekdaysShort = listWeekdaysShort;
	hooks$1.normalizeUnits = normalizeUnits;
	hooks$1.relativeTimeRounding = getSetRelativeTimeRounding;
	hooks$1.relativeTimeThreshold = getSetRelativeTimeThreshold;
	hooks$1.calendarFormat = getCalendarFormat;
	hooks$1.prototype = proto;

	// currently HTML5 input type only supports 24-hour formats
	hooks$1.HTML5_FMT = {
	    DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
	    DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
	    DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
	    DATE: 'YYYY-MM-DD', // <input type="date" />
	    TIME: 'HH:mm', // <input type="time" />
	    TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
	    TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
	    WEEK: 'GGGG-[W]WW', // <input type="week" />
	    MONTH: 'YYYY-MM', // <input type="month" />
	};

	var moment = /*#__PURE__*/Object.freeze({
		default: hooks$1
	});

	var hookCallback$1;

	function hooks$2() {
	    return hookCallback$1.apply(null, arguments);
	}

	// This is done to register the method called with moment()
	// without creating circular dependencies.
	function setHookCallback$1(callback) {
	    hookCallback$1 = callback;
	}

	function isArray$3(input) {
	    return (
	        input instanceof Array ||
	        Object.prototype.toString.call(input) === '[object Array]'
	    );
	}

	function isObject$5(input) {
	    // IE8 will treat undefined and null as object if it wasn't for
	    // input != null
	    return (
	        input != null &&
	        Object.prototype.toString.call(input) === '[object Object]'
	    );
	}

	function hasOwnProp$1(a, b) {
	    return Object.prototype.hasOwnProperty.call(a, b);
	}

	function isObjectEmpty$1(obj) {
	    if (Object.getOwnPropertyNames) {
	        return Object.getOwnPropertyNames(obj).length === 0;
	    } else {
	        var k;
	        for (k in obj) {
	            if (hasOwnProp$1(obj, k)) {
	                return false;
	            }
	        }
	        return true;
	    }
	}

	function isUndefined$1(input) {
	    return input === void 0;
	}

	function isNumber$1(input) {
	    return (
	        typeof input === 'number' ||
	        Object.prototype.toString.call(input) === '[object Number]'
	    );
	}

	function isDate$1(input) {
	    return (
	        input instanceof Date ||
	        Object.prototype.toString.call(input) === '[object Date]'
	    );
	}

	function map$3(arr, fn) {
	    var res = [],
	        i,
	        arrLen = arr.length;
	    for (i = 0; i < arrLen; ++i) {
	        res.push(fn(arr[i], i));
	    }
	    return res;
	}

	function extend$2(a, b) {
	    for (var i in b) {
	        if (hasOwnProp$1(b, i)) {
	            a[i] = b[i];
	        }
	    }

	    if (hasOwnProp$1(b, 'toString')) {
	        a.toString = b.toString;
	    }

	    if (hasOwnProp$1(b, 'valueOf')) {
	        a.valueOf = b.valueOf;
	    }

	    return a;
	}

	function createUTC$1(input, format, locale, strict) {
	    return createLocalOrUTC$1(input, format, locale, strict, true).utc();
	}

	function defaultParsingFlags$1() {
	    // We need to deep clone this object.
	    return {
	        empty: false,
	        unusedTokens: [],
	        unusedInput: [],
	        overflow: -2,
	        charsLeftOver: 0,
	        nullInput: false,
	        invalidEra: null,
	        invalidMonth: null,
	        invalidFormat: false,
	        userInvalidated: false,
	        iso: false,
	        parsedDateParts: [],
	        era: null,
	        meridiem: null,
	        rfc2822: false,
	        weekdayMismatch: false,
	    };
	}

	function getParsingFlags$1(m) {
	    if (m._pf == null) {
	        m._pf = defaultParsingFlags$1();
	    }
	    return m._pf;
	}

	var some$1;
	if (Array.prototype.some) {
	    some$1 = Array.prototype.some;
	} else {
	    some$1 = function (fun) {
	        var this$1 = this;

	        var t = Object(this),
	            len = t.length >>> 0,
	            i;

	        for (i = 0; i < len; i++) {
	            if (i in t && fun.call(this$1, t[i], i, t)) {
	                return true;
	            }
	        }

	        return false;
	    };
	}

	function isValid$3(m) {
	    if (m._isValid == null) {
	        var flags = getParsingFlags$1(m),
	            parsedParts = some$1.call(flags.parsedDateParts, function (i) {
	                return i != null;
	            }),
	            isNowValid =
	                !isNaN(m._d.getTime()) &&
	                flags.overflow < 0 &&
	                !flags.empty &&
	                !flags.invalidEra &&
	                !flags.invalidMonth &&
	                !flags.invalidWeekday &&
	                !flags.weekdayMismatch &&
	                !flags.nullInput &&
	                !flags.invalidFormat &&
	                !flags.userInvalidated &&
	                (!flags.meridiem || (flags.meridiem && parsedParts));

	        if (m._strict) {
	            isNowValid =
	                isNowValid &&
	                flags.charsLeftOver === 0 &&
	                flags.unusedTokens.length === 0 &&
	                flags.bigHour === undefined;
	        }

	        if (Object.isFrozen == null || !Object.isFrozen(m)) {
	            m._isValid = isNowValid;
	        } else {
	            return isNowValid;
	        }
	    }
	    return m._isValid;
	}

	function createInvalid$2(flags) {
	    var m = createUTC$1(NaN);
	    if (flags != null) {
	        extend$2(getParsingFlags$1(m), flags);
	    } else {
	        getParsingFlags$1(m).userInvalidated = true;
	    }

	    return m;
	}

	// Plugins that add properties should also add the key here (null value),
	// so we can properly clone ourselves.
	var momentProperties$1 = (hooks$2.momentProperties = []),
	    updateInProgress$1 = false;

	function copyConfig$1(to, from) {
	    var i,
	        prop,
	        val,
	        momentPropertiesLen = momentProperties$1.length;

	    if (!isUndefined$1(from._isAMomentObject)) {
	        to._isAMomentObject = from._isAMomentObject;
	    }
	    if (!isUndefined$1(from._i)) {
	        to._i = from._i;
	    }
	    if (!isUndefined$1(from._f)) {
	        to._f = from._f;
	    }
	    if (!isUndefined$1(from._l)) {
	        to._l = from._l;
	    }
	    if (!isUndefined$1(from._strict)) {
	        to._strict = from._strict;
	    }
	    if (!isUndefined$1(from._tzm)) {
	        to._tzm = from._tzm;
	    }
	    if (!isUndefined$1(from._isUTC)) {
	        to._isUTC = from._isUTC;
	    }
	    if (!isUndefined$1(from._offset)) {
	        to._offset = from._offset;
	    }
	    if (!isUndefined$1(from._pf)) {
	        to._pf = getParsingFlags$1(from);
	    }
	    if (!isUndefined$1(from._locale)) {
	        to._locale = from._locale;
	    }

	    if (momentPropertiesLen > 0) {
	        for (i = 0; i < momentPropertiesLen; i++) {
	            prop = momentProperties$1[i];
	            val = from[prop];
	            if (!isUndefined$1(val)) {
	                to[prop] = val;
	            }
	        }
	    }

	    return to;
	}

	// Moment prototype object
	function Moment$1(config) {
	    copyConfig$1(this, config);
	    this._d = new Date(config._d != null ? config._d.getTime() : NaN);
	    if (!this.isValid()) {
	        this._d = new Date(NaN);
	    }
	    // Prevent infinite loop in case updateOffset creates new moment
	    // objects.
	    if (updateInProgress$1 === false) {
	        updateInProgress$1 = true;
	        hooks$2.updateOffset(this);
	        updateInProgress$1 = false;
	    }
	}

	function isMoment$1(obj) {
	    return (
	        obj instanceof Moment$1 || (obj != null && obj._isAMomentObject != null)
	    );
	}

	function warn$2(msg) {
	    if (
	        hooks$2.suppressDeprecationWarnings === false &&
	        typeof console !== 'undefined' &&
	        console.warn
	    ) {
	        console.warn('Deprecation warning: ' + msg);
	    }
	}

	function deprecate$1(msg, fn) {
	    var firstTime = true;

	    return extend$2(function () {
	        var arguments$1 = arguments;

	        if (hooks$2.deprecationHandler != null) {
	            hooks$2.deprecationHandler(null, msg);
	        }
	        if (firstTime) {
	            var args = [],
	                arg,
	                i,
	                key,
	                argLen = arguments.length;
	            for (i = 0; i < argLen; i++) {
	                arg = '';
	                if (typeof arguments$1[i] === 'object') {
	                    arg += '\n[' + i + '] ';
	                    for (key in arguments[0]) {
	                        if (hasOwnProp$1(arguments$1[0], key)) {
	                            arg += key + ': ' + arguments$1[0][key] + ', ';
	                        }
	                    }
	                    arg = arg.slice(0, -2); // Remove trailing comma and space
	                } else {
	                    arg = arguments$1[i];
	                }
	                args.push(arg);
	            }
	            warn$2(
	                msg +
	                    '\nArguments: ' +
	                    Array.prototype.slice.call(args).join('') +
	                    '\n' +
	                    new Error().stack
	            );
	            firstTime = false;
	        }
	        return fn.apply(this, arguments);
	    }, fn);
	}

	var deprecations$1 = {};

	function deprecateSimple$1(name, msg) {
	    if (hooks$2.deprecationHandler != null) {
	        hooks$2.deprecationHandler(name, msg);
	    }
	    if (!deprecations$1[name]) {
	        warn$2(msg);
	        deprecations$1[name] = true;
	    }
	}

	hooks$2.suppressDeprecationWarnings = false;
	hooks$2.deprecationHandler = null;

	function isFunction$1(input) {
	    return (
	        (typeof Function !== 'undefined' && input instanceof Function) ||
	        Object.prototype.toString.call(input) === '[object Function]'
	    );
	}

	function set$2(config) {
	    var this$1 = this;

	    var prop, i;
	    for (i in config) {
	        if (hasOwnProp$1(config, i)) {
	            prop = config[i];
	            if (isFunction$1(prop)) {
	                this$1[i] = prop;
	            } else {
	                this$1['_' + i] = prop;
	            }
	        }
	    }
	    this._config = config;
	    // Lenient ordinal parsing accepts just a number in addition to
	    // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
	    // TODO: Remove "ordinalParse" fallback in next major release.
	    this._dayOfMonthOrdinalParseLenient = new RegExp(
	        (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
	            '|' +
	            /\d{1,2}/.source
	    );
	}

	function mergeConfigs$1(parentConfig, childConfig) {
	    var res = extend$2({}, parentConfig),
	        prop;
	    for (prop in childConfig) {
	        if (hasOwnProp$1(childConfig, prop)) {
	            if (isObject$5(parentConfig[prop]) && isObject$5(childConfig[prop])) {
	                res[prop] = {};
	                extend$2(res[prop], parentConfig[prop]);
	                extend$2(res[prop], childConfig[prop]);
	            } else if (childConfig[prop] != null) {
	                res[prop] = childConfig[prop];
	            } else {
	                delete res[prop];
	            }
	        }
	    }
	    for (prop in parentConfig) {
	        if (
	            hasOwnProp$1(parentConfig, prop) &&
	            !hasOwnProp$1(childConfig, prop) &&
	            isObject$5(parentConfig[prop])
	        ) {
	            // make sure changes to properties don't modify parent config
	            res[prop] = extend$2({}, res[prop]);
	        }
	    }
	    return res;
	}

	function Locale$1(config) {
	    if (config != null) {
	        this.set(config);
	    }
	}

	var keys$4;

	if (Object.keys) {
	    keys$4 = Object.keys;
	} else {
	    keys$4 = function (obj) {
	        var i,
	            res = [];
	        for (i in obj) {
	            if (hasOwnProp$1(obj, i)) {
	                res.push(i);
	            }
	        }
	        return res;
	    };
	}

	var defaultCalendar$1 = {
	    sameDay: '[Today at] LT',
	    nextDay: '[Tomorrow at] LT',
	    nextWeek: 'dddd [at] LT',
	    lastDay: '[Yesterday at] LT',
	    lastWeek: '[Last] dddd [at] LT',
	    sameElse: 'L',
	};

	function calendar$2(key, mom, now) {
	    var output = this._calendar[key] || this._calendar['sameElse'];
	    return isFunction$1(output) ? output.call(mom, now) : output;
	}

	function zeroFill$1(number, targetLength, forceSign) {
	    var absNumber = '' + Math.abs(number),
	        zerosToFill = targetLength - absNumber.length,
	        sign = number >= 0;
	    return (
	        (sign ? (forceSign ? '+' : '') : '-') +
	        Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
	        absNumber
	    );
	}

	var formattingTokens$1 =
	        /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
	    localFormattingTokens$1 = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
	    formatFunctions$1 = {},
	    formatTokenFunctions$1 = {};

	// token:    'M'
	// padded:   ['MM', 2]
	// ordinal:  'Mo'
	// callback: function () { this.month() + 1 }
	function addFormatToken$1(token, padded, ordinal, callback) {
	    var func = callback;
	    if (typeof callback === 'string') {
	        func = function () {
	            return this[callback]();
	        };
	    }
	    if (token) {
	        formatTokenFunctions$1[token] = func;
	    }
	    if (padded) {
	        formatTokenFunctions$1[padded[0]] = function () {
	            return zeroFill$1(func.apply(this, arguments), padded[1], padded[2]);
	        };
	    }
	    if (ordinal) {
	        formatTokenFunctions$1[ordinal] = function () {
	            return this.localeData().ordinal(
	                func.apply(this, arguments),
	                token
	            );
	        };
	    }
	}

	function removeFormattingTokens$1(input) {
	    if (input.match(/\[[\s\S]/)) {
	        return input.replace(/^\[|\]$/g, '');
	    }
	    return input.replace(/\\/g, '');
	}

	function makeFormatFunction$1(format) {
	    var array = format.match(formattingTokens$1),
	        i,
	        length;

	    for (i = 0, length = array.length; i < length; i++) {
	        if (formatTokenFunctions$1[array[i]]) {
	            array[i] = formatTokenFunctions$1[array[i]];
	        } else {
	            array[i] = removeFormattingTokens$1(array[i]);
	        }
	    }

	    return function (mom) {
	        var output = '',
	            i;
	        for (i = 0; i < length; i++) {
	            output += isFunction$1(array[i])
	                ? array[i].call(mom, format)
	                : array[i];
	        }
	        return output;
	    };
	}

	// format date using native date object
	function formatMoment$1(m, format) {
	    if (!m.isValid()) {
	        return m.localeData().invalidDate();
	    }

	    format = expandFormat$1(format, m.localeData());
	    formatFunctions$1[format] =
	        formatFunctions$1[format] || makeFormatFunction$1(format);

	    return formatFunctions$1[format](m);
	}

	function expandFormat$1(format, locale) {
	    var i = 5;

	    function replaceLongDateFormatTokens(input) {
	        return locale.longDateFormat(input) || input;
	    }

	    localFormattingTokens$1.lastIndex = 0;
	    while (i >= 0 && localFormattingTokens$1.test(format)) {
	        format = format.replace(
	            localFormattingTokens$1,
	            replaceLongDateFormatTokens
	        );
	        localFormattingTokens$1.lastIndex = 0;
	        i -= 1;
	    }

	    return format;
	}

	var defaultLongDateFormat$1 = {
	    LTS: 'h:mm:ss A',
	    LT: 'h:mm A',
	    L: 'MM/DD/YYYY',
	    LL: 'MMMM D, YYYY',
	    LLL: 'MMMM D, YYYY h:mm A',
	    LLLL: 'dddd, MMMM D, YYYY h:mm A',
	};

	function longDateFormat$1(key) {
	    var format = this._longDateFormat[key],
	        formatUpper = this._longDateFormat[key.toUpperCase()];

	    if (format || !formatUpper) {
	        return format;
	    }

	    this._longDateFormat[key] = formatUpper
	        .match(formattingTokens$1)
	        .map(function (tok) {
	            if (
	                tok === 'MMMM' ||
	                tok === 'MM' ||
	                tok === 'DD' ||
	                tok === 'dddd'
	            ) {
	                return tok.slice(1);
	            }
	            return tok;
	        })
	        .join('');

	    return this._longDateFormat[key];
	}

	var defaultInvalidDate$1 = 'Invalid date';

	function invalidDate$1() {
	    return this._invalidDate;
	}

	var defaultOrdinal$1 = '%d',
	    defaultDayOfMonthOrdinalParse$1 = /\d{1,2}/;

	function ordinal$1(number) {
	    return this._ordinal.replace('%d', number);
	}

	var defaultRelativeTime$1 = {
	    future: 'in %s',
	    past: '%s ago',
	    s: 'a few seconds',
	    ss: '%d seconds',
	    m: 'a minute',
	    mm: '%d minutes',
	    h: 'an hour',
	    hh: '%d hours',
	    d: 'a day',
	    dd: '%d days',
	    w: 'a week',
	    ww: '%d weeks',
	    M: 'a month',
	    MM: '%d months',
	    y: 'a year',
	    yy: '%d years',
	};

	function relativeTime$2(number, withoutSuffix, string, isFuture) {
	    var output = this._relativeTime[string];
	    return isFunction$1(output)
	        ? output(number, withoutSuffix, string, isFuture)
	        : output.replace(/%d/i, number);
	}

	function pastFuture$1(diff, output) {
	    var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	    return isFunction$1(format) ? format(output) : format.replace(/%s/i, output);
	}

	var aliases$1 = {};

	function addUnitAlias$1(unit, shorthand) {
	    var lowerCase = unit.toLowerCase();
	    aliases$1[lowerCase] = aliases$1[lowerCase + 's'] = aliases$1[shorthand] = unit;
	}

	function normalizeUnits$1(units) {
	    return typeof units === 'string'
	        ? aliases$1[units] || aliases$1[units.toLowerCase()]
	        : undefined;
	}

	function normalizeObjectUnits$1(inputObject) {
	    var normalizedInput = {},
	        normalizedProp,
	        prop;

	    for (prop in inputObject) {
	        if (hasOwnProp$1(inputObject, prop)) {
	            normalizedProp = normalizeUnits$1(prop);
	            if (normalizedProp) {
	                normalizedInput[normalizedProp] = inputObject[prop];
	            }
	        }
	    }

	    return normalizedInput;
	}

	var priorities$1 = {};

	function addUnitPriority$1(unit, priority) {
	    priorities$1[unit] = priority;
	}

	function getPrioritizedUnits$1(unitsObj) {
	    var units = [],
	        u;
	    for (u in unitsObj) {
	        if (hasOwnProp$1(unitsObj, u)) {
	            units.push({ unit: u, priority: priorities$1[u] });
	        }
	    }
	    units.sort(function (a, b) {
	        return a.priority - b.priority;
	    });
	    return units;
	}

	function isLeapYear$1(year) {
	    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	}

	function absFloor$1(number) {
	    if (number < 0) {
	        // -0 -> 0
	        return Math.ceil(number) || 0;
	    } else {
	        return Math.floor(number);
	    }
	}

	function toInt$1(argumentForCoercion) {
	    var coercedNumber = +argumentForCoercion,
	        value = 0;

	    if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	        value = absFloor$1(coercedNumber);
	    }

	    return value;
	}

	function makeGetSet$1(unit, keepTime) {
	    return function (value) {
	        if (value != null) {
	            set$3(this, unit, value);
	            hooks$2.updateOffset(this, keepTime);
	            return this;
	        } else {
	            return get$3(this, unit);
	        }
	    };
	}

	function get$3(mom, unit) {
	    return mom.isValid()
	        ? mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]()
	        : NaN;
	}

	function set$3(mom, unit, value) {
	    if (mom.isValid() && !isNaN(value)) {
	        if (
	            unit === 'FullYear' &&
	            isLeapYear$1(mom.year()) &&
	            mom.month() === 1 &&
	            mom.date() === 29
	        ) {
	            value = toInt$1(value);
	            mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](
	                value,
	                mom.month(),
	                daysInMonth$1(value, mom.month())
	            );
	        } else {
	            mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
	        }
	    }
	}

	// MOMENTS

	function stringGet$1(units) {
	    units = normalizeUnits$1(units);
	    if (isFunction$1(this[units])) {
	        return this[units]();
	    }
	    return this;
	}

	function stringSet$1(units, value) {
	    var this$1 = this;

	    if (typeof units === 'object') {
	        units = normalizeObjectUnits$1(units);
	        var prioritized = getPrioritizedUnits$1(units),
	            i,
	            prioritizedLen = prioritized.length;
	        for (i = 0; i < prioritizedLen; i++) {
	            this$1[prioritized[i].unit](units[prioritized[i].unit]);
	        }
	    } else {
	        units = normalizeUnits$1(units);
	        if (isFunction$1(this[units])) {
	            return this[units](value);
	        }
	    }
	    return this;
	}

	var match1$1 = /\d/, //       0 - 9
	    match2$1 = /\d\d/, //      00 - 99
	    match3$1 = /\d{3}/, //     000 - 999
	    match4$1 = /\d{4}/, //    0000 - 9999
	    match6$1 = /[+-]?\d{6}/, // -999999 - 999999
	    match1to2$1 = /\d\d?/, //       0 - 99
	    match3to4$1 = /\d\d\d\d?/, //     999 - 9999
	    match5to6$1 = /\d\d\d\d\d\d?/, //   99999 - 999999
	    match1to3$1 = /\d{1,3}/, //       0 - 999
	    match1to4$1 = /\d{1,4}/, //       0 - 9999
	    match1to6$1 = /[+-]?\d{1,6}/, // -999999 - 999999
	    matchUnsigned$1 = /\d+/, //       0 - inf
	    matchSigned$1 = /[+-]?\d+/, //    -inf - inf
	    matchOffset$1 = /Z|[+-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
	    matchShortOffset$1 = /Z|[+-]\d\d(?::?\d\d)?/gi, // +00 -00 +00:00 -00:00 +0000 -0000 or Z
	    matchTimestamp$1 = /[+-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
	    // any word (or two) characters or numbers including two/three word month in arabic.
	    // includes scottish gaelic two word and hyphenated months
	    matchWord$1 =
	        /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
	    regexes$1;

	regexes$1 = {};

	function addRegexToken$1(token, regex, strictRegex) {
	    regexes$1[token] = isFunction$1(regex)
	        ? regex
	        : function (isStrict, localeData) {
	              return isStrict && strictRegex ? strictRegex : regex;
	          };
	}

	function getParseRegexForToken$1(token, config) {
	    if (!hasOwnProp$1(regexes$1, token)) {
	        return new RegExp(unescapeFormat$1(token));
	    }

	    return regexes$1[token](config._strict, config._locale);
	}

	// Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	function unescapeFormat$1(s) {
	    return regexEscape$1(
	        s
	            .replace('\\', '')
	            .replace(
	                /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
	                function (matched, p1, p2, p3, p4) {
	                    return p1 || p2 || p3 || p4;
	                }
	            )
	    );
	}

	function regexEscape$1(s) {
	    return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	}

	var tokens$1 = {};

	function addParseToken$1(token, callback) {
	    var i,
	        func = callback,
	        tokenLen;
	    if (typeof token === 'string') {
	        token = [token];
	    }
	    if (isNumber$1(callback)) {
	        func = function (input, array) {
	            array[callback] = toInt$1(input);
	        };
	    }
	    tokenLen = token.length;
	    for (i = 0; i < tokenLen; i++) {
	        tokens$1[token[i]] = func;
	    }
	}

	function addWeekParseToken$1(token, callback) {
	    addParseToken$1(token, function (input, array, config, token) {
	        config._w = config._w || {};
	        callback(input, config._w, config, token);
	    });
	}

	function addTimeToArrayFromToken$1(token, input, config) {
	    if (input != null && hasOwnProp$1(tokens$1, token)) {
	        tokens$1[token](input, config._a, config, token);
	    }
	}

	var YEAR$1 = 0,
	    MONTH$1 = 1,
	    DATE$1 = 2,
	    HOUR$1 = 3,
	    MINUTE$1 = 4,
	    SECOND$1 = 5,
	    MILLISECOND$1 = 6,
	    WEEK$1 = 7,
	    WEEKDAY$1 = 8;

	function mod$2(n, x) {
	    return ((n % x) + x) % x;
	}

	var indexOf$3;

	if (Array.prototype.indexOf) {
	    indexOf$3 = Array.prototype.indexOf;
	} else {
	    indexOf$3 = function (o) {
	        var this$1 = this;

	        // I know
	        var i;
	        for (i = 0; i < this.length; ++i) {
	            if (this$1[i] === o) {
	                return i;
	            }
	        }
	        return -1;
	    };
	}

	function daysInMonth$1(year, month) {
	    if (isNaN(year) || isNaN(month)) {
	        return NaN;
	    }
	    var modMonth = mod$2(month, 12);
	    year += (month - modMonth) / 12;
	    return modMonth === 1
	        ? isLeapYear$1(year)
	            ? 29
	            : 28
	        : 31 - ((modMonth % 7) % 2);
	}

	// FORMATTING

	addFormatToken$1('M', ['MM', 2], 'Mo', function () {
	    return this.month() + 1;
	});

	addFormatToken$1('MMM', 0, 0, function (format) {
	    return this.localeData().monthsShort(this, format);
	});

	addFormatToken$1('MMMM', 0, 0, function (format) {
	    return this.localeData().months(this, format);
	});

	// ALIASES

	addUnitAlias$1('month', 'M');

	// PRIORITY

	addUnitPriority$1('month', 8);

	// PARSING

	addRegexToken$1('M', match1to2$1);
	addRegexToken$1('MM', match1to2$1, match2$1);
	addRegexToken$1('MMM', function (isStrict, locale) {
	    return locale.monthsShortRegex(isStrict);
	});
	addRegexToken$1('MMMM', function (isStrict, locale) {
	    return locale.monthsRegex(isStrict);
	});

	addParseToken$1(['M', 'MM'], function (input, array) {
	    array[MONTH$1] = toInt$1(input) - 1;
	});

	addParseToken$1(['MMM', 'MMMM'], function (input, array, config, token) {
	    var month = config._locale.monthsParse(input, token, config._strict);
	    // if we didn't find a month name, mark the date as invalid.
	    if (month != null) {
	        array[MONTH$1] = month;
	    } else {
	        getParsingFlags$1(config).invalidMonth = input;
	    }
	});

	// LOCALES

	var defaultLocaleMonths$1 =
	        'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	    defaultLocaleMonthsShort$1 =
	        'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    MONTHS_IN_FORMAT$1 = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
	    defaultMonthsShortRegex$1 = matchWord$1,
	    defaultMonthsRegex$1 = matchWord$1;

	function localeMonths$1(m, format) {
	    if (!m) {
	        return isArray$3(this._months)
	            ? this._months
	            : this._months['standalone'];
	    }
	    return isArray$3(this._months)
	        ? this._months[m.month()]
	        : this._months[
	              (this._months.isFormat || MONTHS_IN_FORMAT$1).test(format)
	                  ? 'format'
	                  : 'standalone'
	          ][m.month()];
	}

	function localeMonthsShort$1(m, format) {
	    if (!m) {
	        return isArray$3(this._monthsShort)
	            ? this._monthsShort
	            : this._monthsShort['standalone'];
	    }
	    return isArray$3(this._monthsShort)
	        ? this._monthsShort[m.month()]
	        : this._monthsShort[
	              MONTHS_IN_FORMAT$1.test(format) ? 'format' : 'standalone'
	          ][m.month()];
	}

	function handleStrictParse$2(monthName, format, strict) {
	    var this$1 = this;

	    var i,
	        ii,
	        mom,
	        llc = monthName.toLocaleLowerCase();
	    if (!this._monthsParse) {
	        // this is not used
	        this._monthsParse = [];
	        this._longMonthsParse = [];
	        this._shortMonthsParse = [];
	        for (i = 0; i < 12; ++i) {
	            mom = createUTC$1([2000, i]);
	            this$1._shortMonthsParse[i] = this$1.monthsShort(
	                mom,
	                ''
	            ).toLocaleLowerCase();
	            this$1._longMonthsParse[i] = this$1.months(mom, '').toLocaleLowerCase();
	        }
	    }

	    if (strict) {
	        if (format === 'MMM') {
	            ii = indexOf$3.call(this._shortMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf$3.call(this._longMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    } else {
	        if (format === 'MMM') {
	            ii = indexOf$3.call(this._shortMonthsParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$3.call(this._longMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf$3.call(this._longMonthsParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$3.call(this._shortMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    }
	}

	function localeMonthsParse$1(monthName, format, strict) {
	    var this$1 = this;

	    var i, mom, regex;

	    if (this._monthsParseExact) {
	        return handleStrictParse$2.call(this, monthName, format, strict);
	    }

	    if (!this._monthsParse) {
	        this._monthsParse = [];
	        this._longMonthsParse = [];
	        this._shortMonthsParse = [];
	    }

	    // TODO: add sorting
	    // Sorting makes sure if one month (or abbr) is a prefix of another
	    // see sorting in computeMonthsParse
	    for (i = 0; i < 12; i++) {
	        // make the regex if we don't have it already
	        mom = createUTC$1([2000, i]);
	        if (strict && !this$1._longMonthsParse[i]) {
	            this$1._longMonthsParse[i] = new RegExp(
	                '^' + this$1.months(mom, '').replace('.', '') + '$',
	                'i'
	            );
	            this$1._shortMonthsParse[i] = new RegExp(
	                '^' + this$1.monthsShort(mom, '').replace('.', '') + '$',
	                'i'
	            );
	        }
	        if (!strict && !this$1._monthsParse[i]) {
	            regex =
	                '^' + this$1.months(mom, '') + '|^' + this$1.monthsShort(mom, '');
	            this$1._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	        }
	        // test the regex
	        if (
	            strict &&
	            format === 'MMMM' &&
	            this$1._longMonthsParse[i].test(monthName)
	        ) {
	            return i;
	        } else if (
	            strict &&
	            format === 'MMM' &&
	            this$1._shortMonthsParse[i].test(monthName)
	        ) {
	            return i;
	        } else if (!strict && this$1._monthsParse[i].test(monthName)) {
	            return i;
	        }
	    }
	}

	// MOMENTS

	function setMonth$1(mom, value) {
	    var dayOfMonth;

	    if (!mom.isValid()) {
	        // No op
	        return mom;
	    }

	    if (typeof value === 'string') {
	        if (/^\d+$/.test(value)) {
	            value = toInt$1(value);
	        } else {
	            value = mom.localeData().monthsParse(value);
	            // TODO: Another silent failure?
	            if (!isNumber$1(value)) {
	                return mom;
	            }
	        }
	    }

	    dayOfMonth = Math.min(mom.date(), daysInMonth$1(mom.year(), value));
	    mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
	    return mom;
	}

	function getSetMonth$1(value) {
	    if (value != null) {
	        setMonth$1(this, value);
	        hooks$2.updateOffset(this, true);
	        return this;
	    } else {
	        return get$3(this, 'Month');
	    }
	}

	function getDaysInMonth$1() {
	    return daysInMonth$1(this.year(), this.month());
	}

	function monthsShortRegex$1(isStrict) {
	    if (this._monthsParseExact) {
	        if (!hasOwnProp$1(this, '_monthsRegex')) {
	            computeMonthsParse$1.call(this);
	        }
	        if (isStrict) {
	            return this._monthsShortStrictRegex;
	        } else {
	            return this._monthsShortRegex;
	        }
	    } else {
	        if (!hasOwnProp$1(this, '_monthsShortRegex')) {
	            this._monthsShortRegex = defaultMonthsShortRegex$1;
	        }
	        return this._monthsShortStrictRegex && isStrict
	            ? this._monthsShortStrictRegex
	            : this._monthsShortRegex;
	    }
	}

	function monthsRegex$1(isStrict) {
	    if (this._monthsParseExact) {
	        if (!hasOwnProp$1(this, '_monthsRegex')) {
	            computeMonthsParse$1.call(this);
	        }
	        if (isStrict) {
	            return this._monthsStrictRegex;
	        } else {
	            return this._monthsRegex;
	        }
	    } else {
	        if (!hasOwnProp$1(this, '_monthsRegex')) {
	            this._monthsRegex = defaultMonthsRegex$1;
	        }
	        return this._monthsStrictRegex && isStrict
	            ? this._monthsStrictRegex
	            : this._monthsRegex;
	    }
	}

	function computeMonthsParse$1() {
	    var this$1 = this;

	    function cmpLenRev(a, b) {
	        return b.length - a.length;
	    }

	    var shortPieces = [],
	        longPieces = [],
	        mixedPieces = [],
	        i,
	        mom;
	    for (i = 0; i < 12; i++) {
	        // make the regex if we don't have it already
	        mom = createUTC$1([2000, i]);
	        shortPieces.push(this$1.monthsShort(mom, ''));
	        longPieces.push(this$1.months(mom, ''));
	        mixedPieces.push(this$1.months(mom, ''));
	        mixedPieces.push(this$1.monthsShort(mom, ''));
	    }
	    // Sorting makes sure if one month (or abbr) is a prefix of another it
	    // will match the longer piece.
	    shortPieces.sort(cmpLenRev);
	    longPieces.sort(cmpLenRev);
	    mixedPieces.sort(cmpLenRev);
	    for (i = 0; i < 12; i++) {
	        shortPieces[i] = regexEscape$1(shortPieces[i]);
	        longPieces[i] = regexEscape$1(longPieces[i]);
	    }
	    for (i = 0; i < 24; i++) {
	        mixedPieces[i] = regexEscape$1(mixedPieces[i]);
	    }

	    this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	    this._monthsShortRegex = this._monthsRegex;
	    this._monthsStrictRegex = new RegExp(
	        '^(' + longPieces.join('|') + ')',
	        'i'
	    );
	    this._monthsShortStrictRegex = new RegExp(
	        '^(' + shortPieces.join('|') + ')',
	        'i'
	    );
	}

	// FORMATTING

	addFormatToken$1('Y', 0, 0, function () {
	    var y = this.year();
	    return y <= 9999 ? zeroFill$1(y, 4) : '+' + y;
	});

	addFormatToken$1(0, ['YY', 2], 0, function () {
	    return this.year() % 100;
	});

	addFormatToken$1(0, ['YYYY', 4], 0, 'year');
	addFormatToken$1(0, ['YYYYY', 5], 0, 'year');
	addFormatToken$1(0, ['YYYYYY', 6, true], 0, 'year');

	// ALIASES

	addUnitAlias$1('year', 'y');

	// PRIORITIES

	addUnitPriority$1('year', 1);

	// PARSING

	addRegexToken$1('Y', matchSigned$1);
	addRegexToken$1('YY', match1to2$1, match2$1);
	addRegexToken$1('YYYY', match1to4$1, match4$1);
	addRegexToken$1('YYYYY', match1to6$1, match6$1);
	addRegexToken$1('YYYYYY', match1to6$1, match6$1);

	addParseToken$1(['YYYYY', 'YYYYYY'], YEAR$1);
	addParseToken$1('YYYY', function (input, array) {
	    array[YEAR$1] =
	        input.length === 2 ? hooks$2.parseTwoDigitYear(input) : toInt$1(input);
	});
	addParseToken$1('YY', function (input, array) {
	    array[YEAR$1] = hooks$2.parseTwoDigitYear(input);
	});
	addParseToken$1('Y', function (input, array) {
	    array[YEAR$1] = parseInt(input, 10);
	});

	// HELPERS

	function daysInYear$1(year) {
	    return isLeapYear$1(year) ? 366 : 365;
	}

	// HOOKS

	hooks$2.parseTwoDigitYear = function (input) {
	    return toInt$1(input) + (toInt$1(input) > 68 ? 1900 : 2000);
	};

	// MOMENTS

	var getSetYear$1 = makeGetSet$1('FullYear', true);

	function getIsLeapYear$1() {
	    return isLeapYear$1(this.year());
	}

	function createDate$1(y, m, d, h, M, s, ms) {
	    // can't just apply() to create a date:
	    // https://stackoverflow.com/q/181348
	    var date;
	    // the date constructor remaps years 0-99 to 1900-1999
	    if (y < 100 && y >= 0) {
	        // preserve leap years using a full 400 year cycle, then reset
	        date = new Date(y + 400, m, d, h, M, s, ms);
	        if (isFinite(date.getFullYear())) {
	            date.setFullYear(y);
	        }
	    } else {
	        date = new Date(y, m, d, h, M, s, ms);
	    }

	    return date;
	}

	function createUTCDate$1(y) {
	    var date, args;
	    // the Date.UTC function remaps years 0-99 to 1900-1999
	    if (y < 100 && y >= 0) {
	        args = Array.prototype.slice.call(arguments);
	        // preserve leap years using a full 400 year cycle, then reset
	        args[0] = y + 400;
	        date = new Date(Date.UTC.apply(null, args));
	        if (isFinite(date.getUTCFullYear())) {
	            date.setUTCFullYear(y);
	        }
	    } else {
	        date = new Date(Date.UTC.apply(null, arguments));
	    }

	    return date;
	}

	// start-of-first-week - start-of-year
	function firstWeekOffset$1(year, dow, doy) {
	    var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
	        fwd = 7 + dow - doy,
	        // first-week day local weekday -- which local weekday is fwd
	        fwdlw = (7 + createUTCDate$1(year, 0, fwd).getUTCDay() - dow) % 7;

	    return -fwdlw + fwd - 1;
	}

	// https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	function dayOfYearFromWeeks$1(year, week, weekday, dow, doy) {
	    var localWeekday = (7 + weekday - dow) % 7,
	        weekOffset = firstWeekOffset$1(year, dow, doy),
	        dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
	        resYear,
	        resDayOfYear;

	    if (dayOfYear <= 0) {
	        resYear = year - 1;
	        resDayOfYear = daysInYear$1(resYear) + dayOfYear;
	    } else if (dayOfYear > daysInYear$1(year)) {
	        resYear = year + 1;
	        resDayOfYear = dayOfYear - daysInYear$1(year);
	    } else {
	        resYear = year;
	        resDayOfYear = dayOfYear;
	    }

	    return {
	        year: resYear,
	        dayOfYear: resDayOfYear,
	    };
	}

	function weekOfYear$1(mom, dow, doy) {
	    var weekOffset = firstWeekOffset$1(mom.year(), dow, doy),
	        week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
	        resWeek,
	        resYear;

	    if (week < 1) {
	        resYear = mom.year() - 1;
	        resWeek = week + weeksInYear$1(resYear, dow, doy);
	    } else if (week > weeksInYear$1(mom.year(), dow, doy)) {
	        resWeek = week - weeksInYear$1(mom.year(), dow, doy);
	        resYear = mom.year() + 1;
	    } else {
	        resYear = mom.year();
	        resWeek = week;
	    }

	    return {
	        week: resWeek,
	        year: resYear,
	    };
	}

	function weeksInYear$1(year, dow, doy) {
	    var weekOffset = firstWeekOffset$1(year, dow, doy),
	        weekOffsetNext = firstWeekOffset$1(year + 1, dow, doy);
	    return (daysInYear$1(year) - weekOffset + weekOffsetNext) / 7;
	}

	// FORMATTING

	addFormatToken$1('w', ['ww', 2], 'wo', 'week');
	addFormatToken$1('W', ['WW', 2], 'Wo', 'isoWeek');

	// ALIASES

	addUnitAlias$1('week', 'w');
	addUnitAlias$1('isoWeek', 'W');

	// PRIORITIES

	addUnitPriority$1('week', 5);
	addUnitPriority$1('isoWeek', 5);

	// PARSING

	addRegexToken$1('w', match1to2$1);
	addRegexToken$1('ww', match1to2$1, match2$1);
	addRegexToken$1('W', match1to2$1);
	addRegexToken$1('WW', match1to2$1, match2$1);

	addWeekParseToken$1(
	    ['w', 'ww', 'W', 'WW'],
	    function (input, week, config, token) {
	        week[token.substr(0, 1)] = toInt$1(input);
	    }
	);

	// HELPERS

	// LOCALES

	function localeWeek$1(mom) {
	    return weekOfYear$1(mom, this._week.dow, this._week.doy).week;
	}

	var defaultLocaleWeek$1 = {
	    dow: 0, // Sunday is the first day of the week.
	    doy: 6, // The week that contains Jan 6th is the first week of the year.
	};

	function localeFirstDayOfWeek$1() {
	    return this._week.dow;
	}

	function localeFirstDayOfYear$1() {
	    return this._week.doy;
	}

	// MOMENTS

	function getSetWeek$1(input) {
	    var week = this.localeData().week(this);
	    return input == null ? week : this.add((input - week) * 7, 'd');
	}

	function getSetISOWeek$1(input) {
	    var week = weekOfYear$1(this, 1, 4).week;
	    return input == null ? week : this.add((input - week) * 7, 'd');
	}

	// FORMATTING

	addFormatToken$1('d', 0, 'do', 'day');

	addFormatToken$1('dd', 0, 0, function (format) {
	    return this.localeData().weekdaysMin(this, format);
	});

	addFormatToken$1('ddd', 0, 0, function (format) {
	    return this.localeData().weekdaysShort(this, format);
	});

	addFormatToken$1('dddd', 0, 0, function (format) {
	    return this.localeData().weekdays(this, format);
	});

	addFormatToken$1('e', 0, 0, 'weekday');
	addFormatToken$1('E', 0, 0, 'isoWeekday');

	// ALIASES

	addUnitAlias$1('day', 'd');
	addUnitAlias$1('weekday', 'e');
	addUnitAlias$1('isoWeekday', 'E');

	// PRIORITY
	addUnitPriority$1('day', 11);
	addUnitPriority$1('weekday', 11);
	addUnitPriority$1('isoWeekday', 11);

	// PARSING

	addRegexToken$1('d', match1to2$1);
	addRegexToken$1('e', match1to2$1);
	addRegexToken$1('E', match1to2$1);
	addRegexToken$1('dd', function (isStrict, locale) {
	    return locale.weekdaysMinRegex(isStrict);
	});
	addRegexToken$1('ddd', function (isStrict, locale) {
	    return locale.weekdaysShortRegex(isStrict);
	});
	addRegexToken$1('dddd', function (isStrict, locale) {
	    return locale.weekdaysRegex(isStrict);
	});

	addWeekParseToken$1(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
	    var weekday = config._locale.weekdaysParse(input, token, config._strict);
	    // if we didn't get a weekday name, mark the date as invalid
	    if (weekday != null) {
	        week.d = weekday;
	    } else {
	        getParsingFlags$1(config).invalidWeekday = input;
	    }
	});

	addWeekParseToken$1(['d', 'e', 'E'], function (input, week, config, token) {
	    week[token] = toInt$1(input);
	});

	// HELPERS

	function parseWeekday$1(input, locale) {
	    if (typeof input !== 'string') {
	        return input;
	    }

	    if (!isNaN(input)) {
	        return parseInt(input, 10);
	    }

	    input = locale.weekdaysParse(input);
	    if (typeof input === 'number') {
	        return input;
	    }

	    return null;
	}

	function parseIsoWeekday$1(input, locale) {
	    if (typeof input === 'string') {
	        return locale.weekdaysParse(input) % 7 || 7;
	    }
	    return isNaN(input) ? null : input;
	}

	// LOCALES
	function shiftWeekdays$1(ws, n) {
	    return ws.slice(n, 7).concat(ws.slice(0, n));
	}

	var defaultLocaleWeekdays$1 =
	        'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    defaultLocaleWeekdaysShort$1 = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    defaultLocaleWeekdaysMin$1 = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    defaultWeekdaysRegex$1 = matchWord$1,
	    defaultWeekdaysShortRegex$1 = matchWord$1,
	    defaultWeekdaysMinRegex$1 = matchWord$1;

	function localeWeekdays$1(m, format) {
	    var weekdays = isArray$3(this._weekdays)
	        ? this._weekdays
	        : this._weekdays[
	              m && m !== true && this._weekdays.isFormat.test(format)
	                  ? 'format'
	                  : 'standalone'
	          ];
	    return m === true
	        ? shiftWeekdays$1(weekdays, this._week.dow)
	        : m
	        ? weekdays[m.day()]
	        : weekdays;
	}

	function localeWeekdaysShort$1(m) {
	    return m === true
	        ? shiftWeekdays$1(this._weekdaysShort, this._week.dow)
	        : m
	        ? this._weekdaysShort[m.day()]
	        : this._weekdaysShort;
	}

	function localeWeekdaysMin$1(m) {
	    return m === true
	        ? shiftWeekdays$1(this._weekdaysMin, this._week.dow)
	        : m
	        ? this._weekdaysMin[m.day()]
	        : this._weekdaysMin;
	}

	function handleStrictParse$3(weekdayName, format, strict) {
	    var this$1 = this;

	    var i,
	        ii,
	        mom,
	        llc = weekdayName.toLocaleLowerCase();
	    if (!this._weekdaysParse) {
	        this._weekdaysParse = [];
	        this._shortWeekdaysParse = [];
	        this._minWeekdaysParse = [];

	        for (i = 0; i < 7; ++i) {
	            mom = createUTC$1([2000, 1]).day(i);
	            this$1._minWeekdaysParse[i] = this$1.weekdaysMin(
	                mom,
	                ''
	            ).toLocaleLowerCase();
	            this$1._shortWeekdaysParse[i] = this$1.weekdaysShort(
	                mom,
	                ''
	            ).toLocaleLowerCase();
	            this$1._weekdaysParse[i] = this$1.weekdays(mom, '').toLocaleLowerCase();
	        }
	    }

	    if (strict) {
	        if (format === 'dddd') {
	            ii = indexOf$3.call(this._weekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else if (format === 'ddd') {
	            ii = indexOf$3.call(this._shortWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf$3.call(this._minWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    } else {
	        if (format === 'dddd') {
	            ii = indexOf$3.call(this._weekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$3.call(this._shortWeekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$3.call(this._minWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else if (format === 'ddd') {
	            ii = indexOf$3.call(this._shortWeekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$3.call(this._weekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$3.call(this._minWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf$3.call(this._minWeekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$3.call(this._weekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$3.call(this._shortWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    }
	}

	function localeWeekdaysParse$1(weekdayName, format, strict) {
	    var this$1 = this;

	    var i, mom, regex;

	    if (this._weekdaysParseExact) {
	        return handleStrictParse$3.call(this, weekdayName, format, strict);
	    }

	    if (!this._weekdaysParse) {
	        this._weekdaysParse = [];
	        this._minWeekdaysParse = [];
	        this._shortWeekdaysParse = [];
	        this._fullWeekdaysParse = [];
	    }

	    for (i = 0; i < 7; i++) {
	        // make the regex if we don't have it already

	        mom = createUTC$1([2000, 1]).day(i);
	        if (strict && !this$1._fullWeekdaysParse[i]) {
	            this$1._fullWeekdaysParse[i] = new RegExp(
	                '^' + this$1.weekdays(mom, '').replace('.', '\\.?') + '$',
	                'i'
	            );
	            this$1._shortWeekdaysParse[i] = new RegExp(
	                '^' + this$1.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
	                'i'
	            );
	            this$1._minWeekdaysParse[i] = new RegExp(
	                '^' + this$1.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
	                'i'
	            );
	        }
	        if (!this$1._weekdaysParse[i]) {
	            regex =
	                '^' +
	                this$1.weekdays(mom, '') +
	                '|^' +
	                this$1.weekdaysShort(mom, '') +
	                '|^' +
	                this$1.weekdaysMin(mom, '');
	            this$1._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	        }
	        // test the regex
	        if (
	            strict &&
	            format === 'dddd' &&
	            this$1._fullWeekdaysParse[i].test(weekdayName)
	        ) {
	            return i;
	        } else if (
	            strict &&
	            format === 'ddd' &&
	            this$1._shortWeekdaysParse[i].test(weekdayName)
	        ) {
	            return i;
	        } else if (
	            strict &&
	            format === 'dd' &&
	            this$1._minWeekdaysParse[i].test(weekdayName)
	        ) {
	            return i;
	        } else if (!strict && this$1._weekdaysParse[i].test(weekdayName)) {
	            return i;
	        }
	    }
	}

	// MOMENTS

	function getSetDayOfWeek$1(input) {
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	    var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
	    if (input != null) {
	        input = parseWeekday$1(input, this.localeData());
	        return this.add(input - day, 'd');
	    } else {
	        return day;
	    }
	}

	function getSetLocaleDayOfWeek$1(input) {
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	    var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	    return input == null ? weekday : this.add(input - weekday, 'd');
	}

	function getSetISODayOfWeek$1(input) {
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }

	    // behaves the same as moment#day except
	    // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	    // as a setter, sunday should belong to the previous week.

	    if (input != null) {
	        var weekday = parseIsoWeekday$1(input, this.localeData());
	        return this.day(this.day() % 7 ? weekday : weekday - 7);
	    } else {
	        return this.day() || 7;
	    }
	}

	function weekdaysRegex$1(isStrict) {
	    if (this._weekdaysParseExact) {
	        if (!hasOwnProp$1(this, '_weekdaysRegex')) {
	            computeWeekdaysParse$1.call(this);
	        }
	        if (isStrict) {
	            return this._weekdaysStrictRegex;
	        } else {
	            return this._weekdaysRegex;
	        }
	    } else {
	        if (!hasOwnProp$1(this, '_weekdaysRegex')) {
	            this._weekdaysRegex = defaultWeekdaysRegex$1;
	        }
	        return this._weekdaysStrictRegex && isStrict
	            ? this._weekdaysStrictRegex
	            : this._weekdaysRegex;
	    }
	}

	function weekdaysShortRegex$1(isStrict) {
	    if (this._weekdaysParseExact) {
	        if (!hasOwnProp$1(this, '_weekdaysRegex')) {
	            computeWeekdaysParse$1.call(this);
	        }
	        if (isStrict) {
	            return this._weekdaysShortStrictRegex;
	        } else {
	            return this._weekdaysShortRegex;
	        }
	    } else {
	        if (!hasOwnProp$1(this, '_weekdaysShortRegex')) {
	            this._weekdaysShortRegex = defaultWeekdaysShortRegex$1;
	        }
	        return this._weekdaysShortStrictRegex && isStrict
	            ? this._weekdaysShortStrictRegex
	            : this._weekdaysShortRegex;
	    }
	}

	function weekdaysMinRegex$1(isStrict) {
	    if (this._weekdaysParseExact) {
	        if (!hasOwnProp$1(this, '_weekdaysRegex')) {
	            computeWeekdaysParse$1.call(this);
	        }
	        if (isStrict) {
	            return this._weekdaysMinStrictRegex;
	        } else {
	            return this._weekdaysMinRegex;
	        }
	    } else {
	        if (!hasOwnProp$1(this, '_weekdaysMinRegex')) {
	            this._weekdaysMinRegex = defaultWeekdaysMinRegex$1;
	        }
	        return this._weekdaysMinStrictRegex && isStrict
	            ? this._weekdaysMinStrictRegex
	            : this._weekdaysMinRegex;
	    }
	}

	function computeWeekdaysParse$1() {
	    var this$1 = this;

	    function cmpLenRev(a, b) {
	        return b.length - a.length;
	    }

	    var minPieces = [],
	        shortPieces = [],
	        longPieces = [],
	        mixedPieces = [],
	        i,
	        mom,
	        minp,
	        shortp,
	        longp;
	    for (i = 0; i < 7; i++) {
	        // make the regex if we don't have it already
	        mom = createUTC$1([2000, 1]).day(i);
	        minp = regexEscape$1(this$1.weekdaysMin(mom, ''));
	        shortp = regexEscape$1(this$1.weekdaysShort(mom, ''));
	        longp = regexEscape$1(this$1.weekdays(mom, ''));
	        minPieces.push(minp);
	        shortPieces.push(shortp);
	        longPieces.push(longp);
	        mixedPieces.push(minp);
	        mixedPieces.push(shortp);
	        mixedPieces.push(longp);
	    }
	    // Sorting makes sure if one weekday (or abbr) is a prefix of another it
	    // will match the longer piece.
	    minPieces.sort(cmpLenRev);
	    shortPieces.sort(cmpLenRev);
	    longPieces.sort(cmpLenRev);
	    mixedPieces.sort(cmpLenRev);

	    this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	    this._weekdaysShortRegex = this._weekdaysRegex;
	    this._weekdaysMinRegex = this._weekdaysRegex;

	    this._weekdaysStrictRegex = new RegExp(
	        '^(' + longPieces.join('|') + ')',
	        'i'
	    );
	    this._weekdaysShortStrictRegex = new RegExp(
	        '^(' + shortPieces.join('|') + ')',
	        'i'
	    );
	    this._weekdaysMinStrictRegex = new RegExp(
	        '^(' + minPieces.join('|') + ')',
	        'i'
	    );
	}

	// FORMATTING

	function hFormat$1() {
	    return this.hours() % 12 || 12;
	}

	function kFormat$1() {
	    return this.hours() || 24;
	}

	addFormatToken$1('H', ['HH', 2], 0, 'hour');
	addFormatToken$1('h', ['hh', 2], 0, hFormat$1);
	addFormatToken$1('k', ['kk', 2], 0, kFormat$1);

	addFormatToken$1('hmm', 0, 0, function () {
	    return '' + hFormat$1.apply(this) + zeroFill$1(this.minutes(), 2);
	});

	addFormatToken$1('hmmss', 0, 0, function () {
	    return (
	        '' +
	        hFormat$1.apply(this) +
	        zeroFill$1(this.minutes(), 2) +
	        zeroFill$1(this.seconds(), 2)
	    );
	});

	addFormatToken$1('Hmm', 0, 0, function () {
	    return '' + this.hours() + zeroFill$1(this.minutes(), 2);
	});

	addFormatToken$1('Hmmss', 0, 0, function () {
	    return (
	        '' +
	        this.hours() +
	        zeroFill$1(this.minutes(), 2) +
	        zeroFill$1(this.seconds(), 2)
	    );
	});

	function meridiem$1(token, lowercase) {
	    addFormatToken$1(token, 0, 0, function () {
	        return this.localeData().meridiem(
	            this.hours(),
	            this.minutes(),
	            lowercase
	        );
	    });
	}

	meridiem$1('a', true);
	meridiem$1('A', false);

	// ALIASES

	addUnitAlias$1('hour', 'h');

	// PRIORITY
	addUnitPriority$1('hour', 13);

	// PARSING

	function matchMeridiem$1(isStrict, locale) {
	    return locale._meridiemParse;
	}

	addRegexToken$1('a', matchMeridiem$1);
	addRegexToken$1('A', matchMeridiem$1);
	addRegexToken$1('H', match1to2$1);
	addRegexToken$1('h', match1to2$1);
	addRegexToken$1('k', match1to2$1);
	addRegexToken$1('HH', match1to2$1, match2$1);
	addRegexToken$1('hh', match1to2$1, match2$1);
	addRegexToken$1('kk', match1to2$1, match2$1);

	addRegexToken$1('hmm', match3to4$1);
	addRegexToken$1('hmmss', match5to6$1);
	addRegexToken$1('Hmm', match3to4$1);
	addRegexToken$1('Hmmss', match5to6$1);

	addParseToken$1(['H', 'HH'], HOUR$1);
	addParseToken$1(['k', 'kk'], function (input, array, config) {
	    var kInput = toInt$1(input);
	    array[HOUR$1] = kInput === 24 ? 0 : kInput;
	});
	addParseToken$1(['a', 'A'], function (input, array, config) {
	    config._isPm = config._locale.isPM(input);
	    config._meridiem = input;
	});
	addParseToken$1(['h', 'hh'], function (input, array, config) {
	    array[HOUR$1] = toInt$1(input);
	    getParsingFlags$1(config).bigHour = true;
	});
	addParseToken$1('hmm', function (input, array, config) {
	    var pos = input.length - 2;
	    array[HOUR$1] = toInt$1(input.substr(0, pos));
	    array[MINUTE$1] = toInt$1(input.substr(pos));
	    getParsingFlags$1(config).bigHour = true;
	});
	addParseToken$1('hmmss', function (input, array, config) {
	    var pos1 = input.length - 4,
	        pos2 = input.length - 2;
	    array[HOUR$1] = toInt$1(input.substr(0, pos1));
	    array[MINUTE$1] = toInt$1(input.substr(pos1, 2));
	    array[SECOND$1] = toInt$1(input.substr(pos2));
	    getParsingFlags$1(config).bigHour = true;
	});
	addParseToken$1('Hmm', function (input, array, config) {
	    var pos = input.length - 2;
	    array[HOUR$1] = toInt$1(input.substr(0, pos));
	    array[MINUTE$1] = toInt$1(input.substr(pos));
	});
	addParseToken$1('Hmmss', function (input, array, config) {
	    var pos1 = input.length - 4,
	        pos2 = input.length - 2;
	    array[HOUR$1] = toInt$1(input.substr(0, pos1));
	    array[MINUTE$1] = toInt$1(input.substr(pos1, 2));
	    array[SECOND$1] = toInt$1(input.substr(pos2));
	});

	// LOCALES

	function localeIsPM$1(input) {
	    // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	    // Using charAt should be more compatible.
	    return (input + '').toLowerCase().charAt(0) === 'p';
	}

	var defaultLocaleMeridiemParse$1 = /[ap]\.?m?\.?/i,
	    // Setting the hour should keep the time, because the user explicitly
	    // specified which hour they want. So trying to maintain the same hour (in
	    // a new timezone) makes sense. Adding/subtracting hours does not follow
	    // this rule.
	    getSetHour$1 = makeGetSet$1('Hours', true);

	function localeMeridiem$1(hours, minutes, isLower) {
	    if (hours > 11) {
	        return isLower ? 'pm' : 'PM';
	    } else {
	        return isLower ? 'am' : 'AM';
	    }
	}

	var baseConfig$1 = {
	    calendar: defaultCalendar$1,
	    longDateFormat: defaultLongDateFormat$1,
	    invalidDate: defaultInvalidDate$1,
	    ordinal: defaultOrdinal$1,
	    dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse$1,
	    relativeTime: defaultRelativeTime$1,

	    months: defaultLocaleMonths$1,
	    monthsShort: defaultLocaleMonthsShort$1,

	    week: defaultLocaleWeek$1,

	    weekdays: defaultLocaleWeekdays$1,
	    weekdaysMin: defaultLocaleWeekdaysMin$1,
	    weekdaysShort: defaultLocaleWeekdaysShort$1,

	    meridiemParse: defaultLocaleMeridiemParse$1,
	};

	// internal storage for locale config files
	var locales$1 = {},
	    localeFamilies$1 = {},
	    globalLocale$1;

	function commonPrefix$1(arr1, arr2) {
	    var i,
	        minl = Math.min(arr1.length, arr2.length);
	    for (i = 0; i < minl; i += 1) {
	        if (arr1[i] !== arr2[i]) {
	            return i;
	        }
	    }
	    return minl;
	}

	function normalizeLocale$1(key) {
	    return key ? key.toLowerCase().replace('_', '-') : key;
	}

	// pick the locale from the array
	// try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	// substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	function chooseLocale$1(names) {
	    var i = 0,
	        j,
	        next,
	        locale,
	        split;

	    while (i < names.length) {
	        split = normalizeLocale$1(names[i]).split('-');
	        j = split.length;
	        next = normalizeLocale$1(names[i + 1]);
	        next = next ? next.split('-') : null;
	        while (j > 0) {
	            locale = loadLocale$1(split.slice(0, j).join('-'));
	            if (locale) {
	                return locale;
	            }
	            if (
	                next &&
	                next.length >= j &&
	                commonPrefix$1(split, next) >= j - 1
	            ) {
	                //the next array item is better than a shallower substring of this one
	                break;
	            }
	            j--;
	        }
	        i++;
	    }
	    return globalLocale$1;
	}

	function isLocaleNameSane$1(name) {
	    // Prevent names that look like filesystem paths, i.e contain '/' or '\'
	    return name.match('^[^/\\\\]*$') != null;
	}

	function loadLocale$1(name) {
	    var oldLocale = null,
	        aliasedRequire;
	    // TODO: Find a better way to register and load all the locales in Node
	    if (
	        locales$1[name] === undefined &&
	        typeof module !== 'undefined' &&
	        module &&
	        module.exports &&
	        isLocaleNameSane$1(name)
	    ) {
	        try {
	            oldLocale = globalLocale$1._abbr;
	            aliasedRequire = require;
	            aliasedRequire('./locale/' + name);
	            getSetGlobalLocale$1(oldLocale);
	        } catch (e) {
	            // mark as not found to avoid repeating expensive file require call causing high CPU
	            // when trying to find en-US, en_US, en-us for every format call
	            locales$1[name] = null; // null means not found
	        }
	    }
	    return locales$1[name];
	}

	// This function will load locale and then set the global locale.  If
	// no arguments are passed in, it will simply return the current global
	// locale key.
	function getSetGlobalLocale$1(key, values) {
	    var data;
	    if (key) {
	        if (isUndefined$1(values)) {
	            data = getLocale$1(key);
	        } else {
	            data = defineLocale$1(key, values);
	        }

	        if (data) {
	            // moment.duration._locale = moment._locale = data;
	            globalLocale$1 = data;
	        } else {
	            if (typeof console !== 'undefined' && console.warn) {
	                //warn user if arguments are passed but the locale could not be set
	                console.warn(
	                    'Locale ' + key + ' not found. Did you forget to load it?'
	                );
	            }
	        }
	    }

	    return globalLocale$1._abbr;
	}

	function defineLocale$1(name, config) {
	    if (config !== null) {
	        var locale,
	            parentConfig = baseConfig$1;
	        config.abbr = name;
	        if (locales$1[name] != null) {
	            deprecateSimple$1(
	                'defineLocaleOverride',
	                'use moment.updateLocale(localeName, config) to change ' +
	                    'an existing locale. moment.defineLocale(localeName, ' +
	                    'config) should only be used for creating a new locale ' +
	                    'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
	            );
	            parentConfig = locales$1[name]._config;
	        } else if (config.parentLocale != null) {
	            if (locales$1[config.parentLocale] != null) {
	                parentConfig = locales$1[config.parentLocale]._config;
	            } else {
	                locale = loadLocale$1(config.parentLocale);
	                if (locale != null) {
	                    parentConfig = locale._config;
	                } else {
	                    if (!localeFamilies$1[config.parentLocale]) {
	                        localeFamilies$1[config.parentLocale] = [];
	                    }
	                    localeFamilies$1[config.parentLocale].push({
	                        name: name,
	                        config: config,
	                    });
	                    return null;
	                }
	            }
	        }
	        locales$1[name] = new Locale$1(mergeConfigs$1(parentConfig, config));

	        if (localeFamilies$1[name]) {
	            localeFamilies$1[name].forEach(function (x) {
	                defineLocale$1(x.name, x.config);
	            });
	        }

	        // backwards compat for now: also set the locale
	        // make sure we set the locale AFTER all child locales have been
	        // created, so we won't end up with the child locale set.
	        getSetGlobalLocale$1(name);

	        return locales$1[name];
	    } else {
	        // useful for testing
	        delete locales$1[name];
	        return null;
	    }
	}

	function updateLocale$1(name, config) {
	    if (config != null) {
	        var locale,
	            tmpLocale,
	            parentConfig = baseConfig$1;

	        if (locales$1[name] != null && locales$1[name].parentLocale != null) {
	            // Update existing child locale in-place to avoid memory-leaks
	            locales$1[name].set(mergeConfigs$1(locales$1[name]._config, config));
	        } else {
	            // MERGE
	            tmpLocale = loadLocale$1(name);
	            if (tmpLocale != null) {
	                parentConfig = tmpLocale._config;
	            }
	            config = mergeConfigs$1(parentConfig, config);
	            if (tmpLocale == null) {
	                // updateLocale is called for creating a new locale
	                // Set abbr so it will have a name (getters return
	                // undefined otherwise).
	                config.abbr = name;
	            }
	            locale = new Locale$1(config);
	            locale.parentLocale = locales$1[name];
	            locales$1[name] = locale;
	        }

	        // backwards compat for now: also set the locale
	        getSetGlobalLocale$1(name);
	    } else {
	        // pass null for config to unupdate, useful for tests
	        if (locales$1[name] != null) {
	            if (locales$1[name].parentLocale != null) {
	                locales$1[name] = locales$1[name].parentLocale;
	                if (name === getSetGlobalLocale$1()) {
	                    getSetGlobalLocale$1(name);
	                }
	            } else if (locales$1[name] != null) {
	                delete locales$1[name];
	            }
	        }
	    }
	    return locales$1[name];
	}

	// returns locale data
	function getLocale$1(key) {
	    var locale;

	    if (key && key._locale && key._locale._abbr) {
	        key = key._locale._abbr;
	    }

	    if (!key) {
	        return globalLocale$1;
	    }

	    if (!isArray$3(key)) {
	        //short-circuit everything else
	        locale = loadLocale$1(key);
	        if (locale) {
	            return locale;
	        }
	        key = [key];
	    }

	    return chooseLocale$1(key);
	}

	function listLocales$1() {
	    return keys$4(locales$1);
	}

	function checkOverflow$3(m) {
	    var overflow,
	        a = m._a;

	    if (a && getParsingFlags$1(m).overflow === -2) {
	        overflow =
	            a[MONTH$1] < 0 || a[MONTH$1] > 11
	                ? MONTH$1
	                : a[DATE$1] < 1 || a[DATE$1] > daysInMonth$1(a[YEAR$1], a[MONTH$1])
	                ? DATE$1
	                : a[HOUR$1] < 0 ||
	                  a[HOUR$1] > 24 ||
	                  (a[HOUR$1] === 24 &&
	                      (a[MINUTE$1] !== 0 ||
	                          a[SECOND$1] !== 0 ||
	                          a[MILLISECOND$1] !== 0))
	                ? HOUR$1
	                : a[MINUTE$1] < 0 || a[MINUTE$1] > 59
	                ? MINUTE$1
	                : a[SECOND$1] < 0 || a[SECOND$1] > 59
	                ? SECOND$1
	                : a[MILLISECOND$1] < 0 || a[MILLISECOND$1] > 999
	                ? MILLISECOND$1
	                : -1;

	        if (
	            getParsingFlags$1(m)._overflowDayOfYear &&
	            (overflow < YEAR$1 || overflow > DATE$1)
	        ) {
	            overflow = DATE$1;
	        }
	        if (getParsingFlags$1(m)._overflowWeeks && overflow === -1) {
	            overflow = WEEK$1;
	        }
	        if (getParsingFlags$1(m)._overflowWeekday && overflow === -1) {
	            overflow = WEEKDAY$1;
	        }

	        getParsingFlags$1(m).overflow = overflow;
	    }

	    return m;
	}

	// iso 8601 regex
	// 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
	var extendedIsoRegex$1 =
	        /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
	    basicIsoRegex$1 =
	        /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
	    tzRegex$1 = /Z|[+-]\d\d(?::?\d\d)?/,
	    isoDates$1 = [
	        ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
	        ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
	        ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
	        ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
	        ['YYYY-DDD', /\d{4}-\d{3}/],
	        ['YYYY-MM', /\d{4}-\d\d/, false],
	        ['YYYYYYMMDD', /[+-]\d{10}/],
	        ['YYYYMMDD', /\d{8}/],
	        ['GGGG[W]WWE', /\d{4}W\d{3}/],
	        ['GGGG[W]WW', /\d{4}W\d{2}/, false],
	        ['YYYYDDD', /\d{7}/],
	        ['YYYYMM', /\d{6}/, false],
	        ['YYYY', /\d{4}/, false] ],
	    // iso time formats and regexes
	    isoTimes$1 = [
	        ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
	        ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
	        ['HH:mm:ss', /\d\d:\d\d:\d\d/],
	        ['HH:mm', /\d\d:\d\d/],
	        ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
	        ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
	        ['HHmmss', /\d\d\d\d\d\d/],
	        ['HHmm', /\d\d\d\d/],
	        ['HH', /\d\d/] ],
	    aspNetJsonRegex$1 = /^\/?Date\((-?\d+)/i,
	    // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
	    rfc2822$1 =
	        /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
	    obsOffsets$1 = {
	        UT: 0,
	        GMT: 0,
	        EDT: -4 * 60,
	        EST: -5 * 60,
	        CDT: -5 * 60,
	        CST: -6 * 60,
	        MDT: -6 * 60,
	        MST: -7 * 60,
	        PDT: -7 * 60,
	        PST: -8 * 60,
	    };

	// date from iso format
	function configFromISO$1(config) {
	    var i,
	        l,
	        string = config._i,
	        match = extendedIsoRegex$1.exec(string) || basicIsoRegex$1.exec(string),
	        allowTime,
	        dateFormat,
	        timeFormat,
	        tzFormat,
	        isoDatesLen = isoDates$1.length,
	        isoTimesLen = isoTimes$1.length;

	    if (match) {
	        getParsingFlags$1(config).iso = true;
	        for (i = 0, l = isoDatesLen; i < l; i++) {
	            if (isoDates$1[i][1].exec(match[1])) {
	                dateFormat = isoDates$1[i][0];
	                allowTime = isoDates$1[i][2] !== false;
	                break;
	            }
	        }
	        if (dateFormat == null) {
	            config._isValid = false;
	            return;
	        }
	        if (match[3]) {
	            for (i = 0, l = isoTimesLen; i < l; i++) {
	                if (isoTimes$1[i][1].exec(match[3])) {
	                    // match[2] should be 'T' or space
	                    timeFormat = (match[2] || ' ') + isoTimes$1[i][0];
	                    break;
	                }
	            }
	            if (timeFormat == null) {
	                config._isValid = false;
	                return;
	            }
	        }
	        if (!allowTime && timeFormat != null) {
	            config._isValid = false;
	            return;
	        }
	        if (match[4]) {
	            if (tzRegex$1.exec(match[4])) {
	                tzFormat = 'Z';
	            } else {
	                config._isValid = false;
	                return;
	            }
	        }
	        config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
	        configFromStringAndFormat$1(config);
	    } else {
	        config._isValid = false;
	    }
	}

	function extractFromRFC2822Strings$1(
	    yearStr,
	    monthStr,
	    dayStr,
	    hourStr,
	    minuteStr,
	    secondStr
	) {
	    var result = [
	        untruncateYear$1(yearStr),
	        defaultLocaleMonthsShort$1.indexOf(monthStr),
	        parseInt(dayStr, 10),
	        parseInt(hourStr, 10),
	        parseInt(minuteStr, 10) ];

	    if (secondStr) {
	        result.push(parseInt(secondStr, 10));
	    }

	    return result;
	}

	function untruncateYear$1(yearStr) {
	    var year = parseInt(yearStr, 10);
	    if (year <= 49) {
	        return 2000 + year;
	    } else if (year <= 999) {
	        return 1900 + year;
	    }
	    return year;
	}

	function preprocessRFC2822$1(s) {
	    // Remove comments and folding whitespace and replace multiple-spaces with a single space
	    return s
	        .replace(/\([^()]*\)|[\n\t]/g, ' ')
	        .replace(/(\s\s+)/g, ' ')
	        .replace(/^\s\s*/, '')
	        .replace(/\s\s*$/, '');
	}

	function checkWeekday$1(weekdayStr, parsedInput, config) {
	    if (weekdayStr) {
	        // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
	        var weekdayProvided = defaultLocaleWeekdaysShort$1.indexOf(weekdayStr),
	            weekdayActual = new Date(
	                parsedInput[0],
	                parsedInput[1],
	                parsedInput[2]
	            ).getDay();
	        if (weekdayProvided !== weekdayActual) {
	            getParsingFlags$1(config).weekdayMismatch = true;
	            config._isValid = false;
	            return false;
	        }
	    }
	    return true;
	}

	function calculateOffset$1(obsOffset, militaryOffset, numOffset) {
	    if (obsOffset) {
	        return obsOffsets$1[obsOffset];
	    } else if (militaryOffset) {
	        // the only allowed military tz is Z
	        return 0;
	    } else {
	        var hm = parseInt(numOffset, 10),
	            m = hm % 100,
	            h = (hm - m) / 100;
	        return h * 60 + m;
	    }
	}

	// date and time from ref 2822 format
	function configFromRFC2822$1(config) {
	    var match = rfc2822$1.exec(preprocessRFC2822$1(config._i)),
	        parsedArray;
	    if (match) {
	        parsedArray = extractFromRFC2822Strings$1(
	            match[4],
	            match[3],
	            match[2],
	            match[5],
	            match[6],
	            match[7]
	        );
	        if (!checkWeekday$1(match[1], parsedArray, config)) {
	            return;
	        }

	        config._a = parsedArray;
	        config._tzm = calculateOffset$1(match[8], match[9], match[10]);

	        config._d = createUTCDate$1.apply(null, config._a);
	        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

	        getParsingFlags$1(config).rfc2822 = true;
	    } else {
	        config._isValid = false;
	    }
	}

	// date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
	function configFromString$1(config) {
	    var matched = aspNetJsonRegex$1.exec(config._i);
	    if (matched !== null) {
	        config._d = new Date(+matched[1]);
	        return;
	    }

	    configFromISO$1(config);
	    if (config._isValid === false) {
	        delete config._isValid;
	    } else {
	        return;
	    }

	    configFromRFC2822$1(config);
	    if (config._isValid === false) {
	        delete config._isValid;
	    } else {
	        return;
	    }

	    if (config._strict) {
	        config._isValid = false;
	    } else {
	        // Final attempt, use Input Fallback
	        hooks$2.createFromInputFallback(config);
	    }
	}

	hooks$2.createFromInputFallback = deprecate$1(
	    'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
	        'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
	        'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.',
	    function (config) {
	        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	    }
	);

	// Pick the first defined of two or three arguments.
	function defaults$2(a, b, c) {
	    if (a != null) {
	        return a;
	    }
	    if (b != null) {
	        return b;
	    }
	    return c;
	}

	function currentDateArray$1(config) {
	    // hooks is actually the exported moment object
	    var nowValue = new Date(hooks$2.now());
	    if (config._useUTC) {
	        return [
	            nowValue.getUTCFullYear(),
	            nowValue.getUTCMonth(),
	            nowValue.getUTCDate() ];
	    }
	    return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
	}

	// convert an array to a date.
	// the array should mirror the parameters below
	// note: all values past the year are optional and will default to the lowest possible value.
	// [year, month, day , hour, minute, second, millisecond]
	function configFromArray$1(config) {
	    var i,
	        date,
	        input = [],
	        currentDate,
	        expectedWeekday,
	        yearToUse;

	    if (config._d) {
	        return;
	    }

	    currentDate = currentDateArray$1(config);

	    //compute day of the year from weeks and weekdays
	    if (config._w && config._a[DATE$1] == null && config._a[MONTH$1] == null) {
	        dayOfYearFromWeekInfo$1(config);
	    }

	    //if the day of the year is set, figure out what it is
	    if (config._dayOfYear != null) {
	        yearToUse = defaults$2(config._a[YEAR$1], currentDate[YEAR$1]);

	        if (
	            config._dayOfYear > daysInYear$1(yearToUse) ||
	            config._dayOfYear === 0
	        ) {
	            getParsingFlags$1(config)._overflowDayOfYear = true;
	        }

	        date = createUTCDate$1(yearToUse, 0, config._dayOfYear);
	        config._a[MONTH$1] = date.getUTCMonth();
	        config._a[DATE$1] = date.getUTCDate();
	    }

	    // Default to current date.
	    // * if no year, month, day of month are given, default to today
	    // * if day of month is given, default month and year
	    // * if month is given, default only year
	    // * if year is given, don't default anything
	    for (i = 0; i < 3 && config._a[i] == null; ++i) {
	        config._a[i] = input[i] = currentDate[i];
	    }

	    // Zero out whatever was not defaulted, including time
	    for (; i < 7; i++) {
	        config._a[i] = input[i] =
	            config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i];
	    }

	    // Check for 24:00:00.000
	    if (
	        config._a[HOUR$1] === 24 &&
	        config._a[MINUTE$1] === 0 &&
	        config._a[SECOND$1] === 0 &&
	        config._a[MILLISECOND$1] === 0
	    ) {
	        config._nextDay = true;
	        config._a[HOUR$1] = 0;
	    }

	    config._d = (config._useUTC ? createUTCDate$1 : createDate$1).apply(
	        null,
	        input
	    );
	    expectedWeekday = config._useUTC
	        ? config._d.getUTCDay()
	        : config._d.getDay();

	    // Apply timezone offset from input. The actual utcOffset can be changed
	    // with parseZone.
	    if (config._tzm != null) {
	        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	    }

	    if (config._nextDay) {
	        config._a[HOUR$1] = 24;
	    }

	    // check for mismatching day of week
	    if (
	        config._w &&
	        typeof config._w.d !== 'undefined' &&
	        config._w.d !== expectedWeekday
	    ) {
	        getParsingFlags$1(config).weekdayMismatch = true;
	    }
	}

	function dayOfYearFromWeekInfo$1(config) {
	    var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;

	    w = config._w;
	    if (w.GG != null || w.W != null || w.E != null) {
	        dow = 1;
	        doy = 4;

	        // TODO: We need to take the current isoWeekYear, but that depends on
	        // how we interpret now (local, utc, fixed offset). So create
	        // a now version of current config (take local/utc/offset flags, and
	        // create now).
	        weekYear = defaults$2(
	            w.GG,
	            config._a[YEAR$1],
	            weekOfYear$1(createLocal$1(), 1, 4).year
	        );
	        week = defaults$2(w.W, 1);
	        weekday = defaults$2(w.E, 1);
	        if (weekday < 1 || weekday > 7) {
	            weekdayOverflow = true;
	        }
	    } else {
	        dow = config._locale._week.dow;
	        doy = config._locale._week.doy;

	        curWeek = weekOfYear$1(createLocal$1(), dow, doy);

	        weekYear = defaults$2(w.gg, config._a[YEAR$1], curWeek.year);

	        // Default to current week.
	        week = defaults$2(w.w, curWeek.week);

	        if (w.d != null) {
	            // weekday -- low day numbers are considered next week
	            weekday = w.d;
	            if (weekday < 0 || weekday > 6) {
	                weekdayOverflow = true;
	            }
	        } else if (w.e != null) {
	            // local weekday -- counting starts from beginning of week
	            weekday = w.e + dow;
	            if (w.e < 0 || w.e > 6) {
	                weekdayOverflow = true;
	            }
	        } else {
	            // default to beginning of week
	            weekday = dow;
	        }
	    }
	    if (week < 1 || week > weeksInYear$1(weekYear, dow, doy)) {
	        getParsingFlags$1(config)._overflowWeeks = true;
	    } else if (weekdayOverflow != null) {
	        getParsingFlags$1(config)._overflowWeekday = true;
	    } else {
	        temp = dayOfYearFromWeeks$1(weekYear, week, weekday, dow, doy);
	        config._a[YEAR$1] = temp.year;
	        config._dayOfYear = temp.dayOfYear;
	    }
	}

	// constant that refers to the ISO standard
	hooks$2.ISO_8601 = function () {};

	// constant that refers to the RFC 2822 form
	hooks$2.RFC_2822 = function () {};

	// date from string and format string
	function configFromStringAndFormat$1(config) {
	    // TODO: Move this to another part of the creation flow to prevent circular deps
	    if (config._f === hooks$2.ISO_8601) {
	        configFromISO$1(config);
	        return;
	    }
	    if (config._f === hooks$2.RFC_2822) {
	        configFromRFC2822$1(config);
	        return;
	    }
	    config._a = [];
	    getParsingFlags$1(config).empty = true;

	    // This array is used to make a Date, either with `new Date` or `Date.UTC`
	    var string = '' + config._i,
	        i,
	        parsedInput,
	        tokens,
	        token,
	        skipped,
	        stringLength = string.length,
	        totalParsedInputLength = 0,
	        era,
	        tokenLen;

	    tokens =
	        expandFormat$1(config._f, config._locale).match(formattingTokens$1) || [];
	    tokenLen = tokens.length;
	    for (i = 0; i < tokenLen; i++) {
	        token = tokens[i];
	        parsedInput = (string.match(getParseRegexForToken$1(token, config)) ||
	            [])[0];
	        if (parsedInput) {
	            skipped = string.substr(0, string.indexOf(parsedInput));
	            if (skipped.length > 0) {
	                getParsingFlags$1(config).unusedInput.push(skipped);
	            }
	            string = string.slice(
	                string.indexOf(parsedInput) + parsedInput.length
	            );
	            totalParsedInputLength += parsedInput.length;
	        }
	        // don't parse if it's not a known token
	        if (formatTokenFunctions$1[token]) {
	            if (parsedInput) {
	                getParsingFlags$1(config).empty = false;
	            } else {
	                getParsingFlags$1(config).unusedTokens.push(token);
	            }
	            addTimeToArrayFromToken$1(token, parsedInput, config);
	        } else if (config._strict && !parsedInput) {
	            getParsingFlags$1(config).unusedTokens.push(token);
	        }
	    }

	    // add remaining unparsed input length to the string
	    getParsingFlags$1(config).charsLeftOver =
	        stringLength - totalParsedInputLength;
	    if (string.length > 0) {
	        getParsingFlags$1(config).unusedInput.push(string);
	    }

	    // clear _12h flag if hour is <= 12
	    if (
	        config._a[HOUR$1] <= 12 &&
	        getParsingFlags$1(config).bigHour === true &&
	        config._a[HOUR$1] > 0
	    ) {
	        getParsingFlags$1(config).bigHour = undefined;
	    }

	    getParsingFlags$1(config).parsedDateParts = config._a.slice(0);
	    getParsingFlags$1(config).meridiem = config._meridiem;
	    // handle meridiem
	    config._a[HOUR$1] = meridiemFixWrap$1(
	        config._locale,
	        config._a[HOUR$1],
	        config._meridiem
	    );

	    // handle era
	    era = getParsingFlags$1(config).era;
	    if (era !== null) {
	        config._a[YEAR$1] = config._locale.erasConvertYear(era, config._a[YEAR$1]);
	    }

	    configFromArray$1(config);
	    checkOverflow$3(config);
	}

	function meridiemFixWrap$1(locale, hour, meridiem) {
	    var isPm;

	    if (meridiem == null) {
	        // nothing to do
	        return hour;
	    }
	    if (locale.meridiemHour != null) {
	        return locale.meridiemHour(hour, meridiem);
	    } else if (locale.isPM != null) {
	        // Fallback
	        isPm = locale.isPM(meridiem);
	        if (isPm && hour < 12) {
	            hour += 12;
	        }
	        if (!isPm && hour === 12) {
	            hour = 0;
	        }
	        return hour;
	    } else {
	        // this is not supposed to happen
	        return hour;
	    }
	}

	// date from string and array of format strings
	function configFromStringAndArray$1(config) {
	    var tempConfig,
	        bestMoment,
	        scoreToBeat,
	        i,
	        currentScore,
	        validFormatFound,
	        bestFormatIsValid = false,
	        configfLen = config._f.length;

	    if (configfLen === 0) {
	        getParsingFlags$1(config).invalidFormat = true;
	        config._d = new Date(NaN);
	        return;
	    }

	    for (i = 0; i < configfLen; i++) {
	        currentScore = 0;
	        validFormatFound = false;
	        tempConfig = copyConfig$1({}, config);
	        if (config._useUTC != null) {
	            tempConfig._useUTC = config._useUTC;
	        }
	        tempConfig._f = config._f[i];
	        configFromStringAndFormat$1(tempConfig);

	        if (isValid$3(tempConfig)) {
	            validFormatFound = true;
	        }

	        // if there is any input that was not parsed add a penalty for that format
	        currentScore += getParsingFlags$1(tempConfig).charsLeftOver;

	        //or tokens
	        currentScore += getParsingFlags$1(tempConfig).unusedTokens.length * 10;

	        getParsingFlags$1(tempConfig).score = currentScore;

	        if (!bestFormatIsValid) {
	            if (
	                scoreToBeat == null ||
	                currentScore < scoreToBeat ||
	                validFormatFound
	            ) {
	                scoreToBeat = currentScore;
	                bestMoment = tempConfig;
	                if (validFormatFound) {
	                    bestFormatIsValid = true;
	                }
	            }
	        } else {
	            if (currentScore < scoreToBeat) {
	                scoreToBeat = currentScore;
	                bestMoment = tempConfig;
	            }
	        }
	    }

	    extend$2(config, bestMoment || tempConfig);
	}

	function configFromObject$1(config) {
	    if (config._d) {
	        return;
	    }

	    var i = normalizeObjectUnits$1(config._i),
	        dayOrDate = i.day === undefined ? i.date : i.day;
	    config._a = map$3(
	        [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
	        function (obj) {
	            return obj && parseInt(obj, 10);
	        }
	    );

	    configFromArray$1(config);
	}

	function createFromConfig$1(config) {
	    var res = new Moment$1(checkOverflow$3(prepareConfig$1(config)));
	    if (res._nextDay) {
	        // Adding is smart enough around DST
	        res.add(1, 'd');
	        res._nextDay = undefined;
	    }

	    return res;
	}

	function prepareConfig$1(config) {
	    var input = config._i,
	        format = config._f;

	    config._locale = config._locale || getLocale$1(config._l);

	    if (input === null || (format === undefined && input === '')) {
	        return createInvalid$2({ nullInput: true });
	    }

	    if (typeof input === 'string') {
	        config._i = input = config._locale.preparse(input);
	    }

	    if (isMoment$1(input)) {
	        return new Moment$1(checkOverflow$3(input));
	    } else if (isDate$1(input)) {
	        config._d = input;
	    } else if (isArray$3(format)) {
	        configFromStringAndArray$1(config);
	    } else if (format) {
	        configFromStringAndFormat$1(config);
	    } else {
	        configFromInput$1(config);
	    }

	    if (!isValid$3(config)) {
	        config._d = null;
	    }

	    return config;
	}

	function configFromInput$1(config) {
	    var input = config._i;
	    if (isUndefined$1(input)) {
	        config._d = new Date(hooks$2.now());
	    } else if (isDate$1(input)) {
	        config._d = new Date(input.valueOf());
	    } else if (typeof input === 'string') {
	        configFromString$1(config);
	    } else if (isArray$3(input)) {
	        config._a = map$3(input.slice(0), function (obj) {
	            return parseInt(obj, 10);
	        });
	        configFromArray$1(config);
	    } else if (isObject$5(input)) {
	        configFromObject$1(config);
	    } else if (isNumber$1(input)) {
	        // from milliseconds
	        config._d = new Date(input);
	    } else {
	        hooks$2.createFromInputFallback(config);
	    }
	}

	function createLocalOrUTC$1(input, format, locale, strict, isUTC) {
	    var c = {};

	    if (format === true || format === false) {
	        strict = format;
	        format = undefined;
	    }

	    if (locale === true || locale === false) {
	        strict = locale;
	        locale = undefined;
	    }

	    if (
	        (isObject$5(input) && isObjectEmpty$1(input)) ||
	        (isArray$3(input) && input.length === 0)
	    ) {
	        input = undefined;
	    }
	    // object construction must be done this way.
	    // https://github.com/moment/moment/issues/1423
	    c._isAMomentObject = true;
	    c._useUTC = c._isUTC = isUTC;
	    c._l = locale;
	    c._i = input;
	    c._f = format;
	    c._strict = strict;

	    return createFromConfig$1(c);
	}

	function createLocal$1(input, format, locale, strict) {
	    return createLocalOrUTC$1(input, format, locale, strict, false);
	}

	var prototypeMin$1 = deprecate$1(
	        'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
	        function () {
	            var other = createLocal$1.apply(null, arguments);
	            if (this.isValid() && other.isValid()) {
	                return other < this ? this : other;
	            } else {
	                return createInvalid$2();
	            }
	        }
	    ),
	    prototypeMax$1 = deprecate$1(
	        'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
	        function () {
	            var other = createLocal$1.apply(null, arguments);
	            if (this.isValid() && other.isValid()) {
	                return other > this ? this : other;
	            } else {
	                return createInvalid$2();
	            }
	        }
	    );

	// Pick a moment m from moments so that m[fn](other) is true for all
	// other. This relies on the function fn to be transitive.
	//
	// moments should either be an array of moment objects or an array, whose
	// first element is an array of moment objects.
	function pickBy$1(fn, moments) {
	    var res, i;
	    if (moments.length === 1 && isArray$3(moments[0])) {
	        moments = moments[0];
	    }
	    if (!moments.length) {
	        return createLocal$1();
	    }
	    res = moments[0];
	    for (i = 1; i < moments.length; ++i) {
	        if (!moments[i].isValid() || moments[i][fn](res)) {
	            res = moments[i];
	        }
	    }
	    return res;
	}

	// TODO: Use [].sort instead?
	function min$1() {
	    var args = [].slice.call(arguments, 0);

	    return pickBy$1('isBefore', args);
	}

	function max$1() {
	    var args = [].slice.call(arguments, 0);

	    return pickBy$1('isAfter', args);
	}

	var now$4 = function () {
	    return Date.now ? Date.now() : +new Date();
	};

	var ordering$1 = [
	    'year',
	    'quarter',
	    'month',
	    'week',
	    'day',
	    'hour',
	    'minute',
	    'second',
	    'millisecond' ];

	function isDurationValid$1(m) {
	    var key,
	        unitHasDecimal = false,
	        i,
	        orderLen = ordering$1.length;
	    for (key in m) {
	        if (
	            hasOwnProp$1(m, key) &&
	            !(
	                indexOf$3.call(ordering$1, key) !== -1 &&
	                (m[key] == null || !isNaN(m[key]))
	            )
	        ) {
	            return false;
	        }
	    }

	    for (i = 0; i < orderLen; ++i) {
	        if (m[ordering$1[i]]) {
	            if (unitHasDecimal) {
	                return false; // only allow non-integers for smallest unit
	            }
	            if (parseFloat(m[ordering$1[i]]) !== toInt$1(m[ordering$1[i]])) {
	                unitHasDecimal = true;
	            }
	        }
	    }

	    return true;
	}

	function isValid$4() {
	    return this._isValid;
	}

	function createInvalid$3() {
	    return createDuration$1(NaN);
	}

	function Duration$1(duration) {
	    var normalizedInput = normalizeObjectUnits$1(duration),
	        years = normalizedInput.year || 0,
	        quarters = normalizedInput.quarter || 0,
	        months = normalizedInput.month || 0,
	        weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
	        days = normalizedInput.day || 0,
	        hours = normalizedInput.hour || 0,
	        minutes = normalizedInput.minute || 0,
	        seconds = normalizedInput.second || 0,
	        milliseconds = normalizedInput.millisecond || 0;

	    this._isValid = isDurationValid$1(normalizedInput);

	    // representation for dateAddRemove
	    this._milliseconds =
	        +milliseconds +
	        seconds * 1e3 + // 1000
	        minutes * 6e4 + // 1000 * 60
	        hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
	    // Because of dateAddRemove treats 24 hours as different from a
	    // day when working around DST, we need to store them separately
	    this._days = +days + weeks * 7;
	    // It is impossible to translate months into days without knowing
	    // which months you are are talking about, so we have to store
	    // it separately.
	    this._months = +months + quarters * 3 + years * 12;

	    this._data = {};

	    this._locale = getLocale$1();

	    this._bubble();
	}

	function isDuration$1(obj) {
	    return obj instanceof Duration$1;
	}

	function absRound$1(number) {
	    if (number < 0) {
	        return Math.round(-1 * number) * -1;
	    } else {
	        return Math.round(number);
	    }
	}

	// compare two arrays, return the number of differences
	function compareArrays$1(array1, array2, dontConvert) {
	    var len = Math.min(array1.length, array2.length),
	        lengthDiff = Math.abs(array1.length - array2.length),
	        diffs = 0,
	        i;
	    for (i = 0; i < len; i++) {
	        if (
	            (dontConvert && array1[i] !== array2[i]) ||
	            (!dontConvert && toInt$1(array1[i]) !== toInt$1(array2[i]))
	        ) {
	            diffs++;
	        }
	    }
	    return diffs + lengthDiff;
	}

	// FORMATTING

	function offset$2(token, separator) {
	    addFormatToken$1(token, 0, 0, function () {
	        var offset = this.utcOffset(),
	            sign = '+';
	        if (offset < 0) {
	            offset = -offset;
	            sign = '-';
	        }
	        return (
	            sign +
	            zeroFill$1(~~(offset / 60), 2) +
	            separator +
	            zeroFill$1(~~offset % 60, 2)
	        );
	    });
	}

	offset$2('Z', ':');
	offset$2('ZZ', '');

	// PARSING

	addRegexToken$1('Z', matchShortOffset$1);
	addRegexToken$1('ZZ', matchShortOffset$1);
	addParseToken$1(['Z', 'ZZ'], function (input, array, config) {
	    config._useUTC = true;
	    config._tzm = offsetFromString$1(matchShortOffset$1, input);
	});

	// HELPERS

	// timezone chunker
	// '+10:00' > ['10',  '00']
	// '-1530'  > ['-15', '30']
	var chunkOffset$1 = /([\+\-]|\d\d)/gi;

	function offsetFromString$1(matcher, string) {
	    var matches = (string || '').match(matcher),
	        chunk,
	        parts,
	        minutes;

	    if (matches === null) {
	        return null;
	    }

	    chunk = matches[matches.length - 1] || [];
	    parts = (chunk + '').match(chunkOffset$1) || ['-', 0, 0];
	    minutes = +(parts[1] * 60) + toInt$1(parts[2]);

	    return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
	}

	// Return a moment from input, that is local/utc/zone equivalent to model.
	function cloneWithOffset$1(input, model) {
	    var res, diff;
	    if (model._isUTC) {
	        res = model.clone();
	        diff =
	            (isMoment$1(input) || isDate$1(input)
	                ? input.valueOf()
	                : createLocal$1(input).valueOf()) - res.valueOf();
	        // Use low-level api, because this fn is low-level api.
	        res._d.setTime(res._d.valueOf() + diff);
	        hooks$2.updateOffset(res, false);
	        return res;
	    } else {
	        return createLocal$1(input).local();
	    }
	}

	function getDateOffset$1(m) {
	    // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	    // https://github.com/moment/moment/pull/1871
	    return -Math.round(m._d.getTimezoneOffset());
	}

	// HOOKS

	// This function will be called whenever a moment is mutated.
	// It is intended to keep the offset in sync with the timezone.
	hooks$2.updateOffset = function () {};

	// MOMENTS

	// keepLocalTime = true means only change the timezone, without
	// affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	// 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	// +0200, so we adjust the time as needed, to be valid.
	//
	// Keeping the time actually adds/subtracts (one hour)
	// from the actual represented time. That is why we call updateOffset
	// a second time. In case it wants us to change the offset again
	// _changeInProgress == true case, then we have to adjust, because
	// there is no such time in the given timezone.
	function getSetOffset$1(input, keepLocalTime, keepMinutes) {
	    var offset = this._offset || 0,
	        localAdjust;
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	    if (input != null) {
	        if (typeof input === 'string') {
	            input = offsetFromString$1(matchShortOffset$1, input);
	            if (input === null) {
	                return this;
	            }
	        } else if (Math.abs(input) < 16 && !keepMinutes) {
	            input = input * 60;
	        }
	        if (!this._isUTC && keepLocalTime) {
	            localAdjust = getDateOffset$1(this);
	        }
	        this._offset = input;
	        this._isUTC = true;
	        if (localAdjust != null) {
	            this.add(localAdjust, 'm');
	        }
	        if (offset !== input) {
	            if (!keepLocalTime || this._changeInProgress) {
	                addSubtract$2(
	                    this,
	                    createDuration$1(input - offset, 'm'),
	                    1,
	                    false
	                );
	            } else if (!this._changeInProgress) {
	                this._changeInProgress = true;
	                hooks$2.updateOffset(this, true);
	                this._changeInProgress = null;
	            }
	        }
	        return this;
	    } else {
	        return this._isUTC ? offset : getDateOffset$1(this);
	    }
	}

	function getSetZone$1(input, keepLocalTime) {
	    if (input != null) {
	        if (typeof input !== 'string') {
	            input = -input;
	        }

	        this.utcOffset(input, keepLocalTime);

	        return this;
	    } else {
	        return -this.utcOffset();
	    }
	}

	function setOffsetToUTC$1(keepLocalTime) {
	    return this.utcOffset(0, keepLocalTime);
	}

	function setOffsetToLocal$1(keepLocalTime) {
	    if (this._isUTC) {
	        this.utcOffset(0, keepLocalTime);
	        this._isUTC = false;

	        if (keepLocalTime) {
	            this.subtract(getDateOffset$1(this), 'm');
	        }
	    }
	    return this;
	}

	function setOffsetToParsedOffset$1() {
	    if (this._tzm != null) {
	        this.utcOffset(this._tzm, false, true);
	    } else if (typeof this._i === 'string') {
	        var tZone = offsetFromString$1(matchOffset$1, this._i);
	        if (tZone != null) {
	            this.utcOffset(tZone);
	        } else {
	            this.utcOffset(0, true);
	        }
	    }
	    return this;
	}

	function hasAlignedHourOffset$1(input) {
	    if (!this.isValid()) {
	        return false;
	    }
	    input = input ? createLocal$1(input).utcOffset() : 0;

	    return (this.utcOffset() - input) % 60 === 0;
	}

	function isDaylightSavingTime$1() {
	    return (
	        this.utcOffset() > this.clone().month(0).utcOffset() ||
	        this.utcOffset() > this.clone().month(5).utcOffset()
	    );
	}

	function isDaylightSavingTimeShifted$1() {
	    if (!isUndefined$1(this._isDSTShifted)) {
	        return this._isDSTShifted;
	    }

	    var c = {},
	        other;

	    copyConfig$1(c, this);
	    c = prepareConfig$1(c);

	    if (c._a) {
	        other = c._isUTC ? createUTC$1(c._a) : createLocal$1(c._a);
	        this._isDSTShifted =
	            this.isValid() && compareArrays$1(c._a, other.toArray()) > 0;
	    } else {
	        this._isDSTShifted = false;
	    }

	    return this._isDSTShifted;
	}

	function isLocal$1() {
	    return this.isValid() ? !this._isUTC : false;
	}

	function isUtcOffset$1() {
	    return this.isValid() ? this._isUTC : false;
	}

	function isUtc$1() {
	    return this.isValid() ? this._isUTC && this._offset === 0 : false;
	}

	// ASP.NET json date format regex
	var aspNetRegex$1 = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
	    // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	    // and further modified to allow for strings containing both week and day
	    isoRegex$1 =
	        /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

	function createDuration$1(input, key) {
	    var duration = input,
	        // matching against regexp is expensive, do it on demand
	        match = null,
	        sign,
	        ret,
	        diffRes;

	    if (isDuration$1(input)) {
	        duration = {
	            ms: input._milliseconds,
	            d: input._days,
	            M: input._months,
	        };
	    } else if (isNumber$1(input) || !isNaN(+input)) {
	        duration = {};
	        if (key) {
	            duration[key] = +input;
	        } else {
	            duration.milliseconds = +input;
	        }
	    } else if ((match = aspNetRegex$1.exec(input))) {
	        sign = match[1] === '-' ? -1 : 1;
	        duration = {
	            y: 0,
	            d: toInt$1(match[DATE$1]) * sign,
	            h: toInt$1(match[HOUR$1]) * sign,
	            m: toInt$1(match[MINUTE$1]) * sign,
	            s: toInt$1(match[SECOND$1]) * sign,
	            ms: toInt$1(absRound$1(match[MILLISECOND$1] * 1000)) * sign, // the millisecond decimal point is included in the match
	        };
	    } else if ((match = isoRegex$1.exec(input))) {
	        sign = match[1] === '-' ? -1 : 1;
	        duration = {
	            y: parseIso$1(match[2], sign),
	            M: parseIso$1(match[3], sign),
	            w: parseIso$1(match[4], sign),
	            d: parseIso$1(match[5], sign),
	            h: parseIso$1(match[6], sign),
	            m: parseIso$1(match[7], sign),
	            s: parseIso$1(match[8], sign),
	        };
	    } else if (duration == null) {
	        // checks for null or undefined
	        duration = {};
	    } else if (
	        typeof duration === 'object' &&
	        ('from' in duration || 'to' in duration)
	    ) {
	        diffRes = momentsDifference$1(
	            createLocal$1(duration.from),
	            createLocal$1(duration.to)
	        );

	        duration = {};
	        duration.ms = diffRes.milliseconds;
	        duration.M = diffRes.months;
	    }

	    ret = new Duration$1(duration);

	    if (isDuration$1(input) && hasOwnProp$1(input, '_locale')) {
	        ret._locale = input._locale;
	    }

	    if (isDuration$1(input) && hasOwnProp$1(input, '_isValid')) {
	        ret._isValid = input._isValid;
	    }

	    return ret;
	}

	createDuration$1.fn = Duration$1.prototype;
	createDuration$1.invalid = createInvalid$3;

	function parseIso$1(inp, sign) {
	    // We'd normally use ~~inp for this, but unfortunately it also
	    // converts floats to ints.
	    // inp may be undefined, so careful calling replace on it.
	    var res = inp && parseFloat(inp.replace(',', '.'));
	    // apply sign while we're at it
	    return (isNaN(res) ? 0 : res) * sign;
	}

	function positiveMomentsDifference$1(base, other) {
	    var res = {};

	    res.months =
	        other.month() - base.month() + (other.year() - base.year()) * 12;
	    if (base.clone().add(res.months, 'M').isAfter(other)) {
	        --res.months;
	    }

	    res.milliseconds = +other - +base.clone().add(res.months, 'M');

	    return res;
	}

	function momentsDifference$1(base, other) {
	    var res;
	    if (!(base.isValid() && other.isValid())) {
	        return { milliseconds: 0, months: 0 };
	    }

	    other = cloneWithOffset$1(other, base);
	    if (base.isBefore(other)) {
	        res = positiveMomentsDifference$1(base, other);
	    } else {
	        res = positiveMomentsDifference$1(other, base);
	        res.milliseconds = -res.milliseconds;
	        res.months = -res.months;
	    }

	    return res;
	}

	// TODO: remove 'name' arg after deprecation is removed
	function createAdder$1(direction, name) {
	    return function (val, period) {
	        var dur, tmp;
	        //invert the arguments, but complain about it
	        if (period !== null && !isNaN(+period)) {
	            deprecateSimple$1(
	                name,
	                'moment().' +
	                    name +
	                    '(period, number) is deprecated. Please use moment().' +
	                    name +
	                    '(number, period). ' +
	                    'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
	            );
	            tmp = val;
	            val = period;
	            period = tmp;
	        }

	        dur = createDuration$1(val, period);
	        addSubtract$2(this, dur, direction);
	        return this;
	    };
	}

	function addSubtract$2(mom, duration, isAdding, updateOffset) {
	    var milliseconds = duration._milliseconds,
	        days = absRound$1(duration._days),
	        months = absRound$1(duration._months);

	    if (!mom.isValid()) {
	        // No op
	        return;
	    }

	    updateOffset = updateOffset == null ? true : updateOffset;

	    if (months) {
	        setMonth$1(mom, get$3(mom, 'Month') + months * isAdding);
	    }
	    if (days) {
	        set$3(mom, 'Date', get$3(mom, 'Date') + days * isAdding);
	    }
	    if (milliseconds) {
	        mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
	    }
	    if (updateOffset) {
	        hooks$2.updateOffset(mom, days || months);
	    }
	}

	var add$4 = createAdder$1(1, 'add'),
	    subtract$2 = createAdder$1(-1, 'subtract');

	function isString$1(input) {
	    return typeof input === 'string' || input instanceof String;
	}

	// type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
	function isMomentInput$1(input) {
	    return (
	        isMoment$1(input) ||
	        isDate$1(input) ||
	        isString$1(input) ||
	        isNumber$1(input) ||
	        isNumberOrStringArray$1(input) ||
	        isMomentInputObject$1(input) ||
	        input === null ||
	        input === undefined
	    );
	}

	function isMomentInputObject$1(input) {
	    var objectTest = isObject$5(input) && !isObjectEmpty$1(input),
	        propertyTest = false,
	        properties = [
	            'years',
	            'year',
	            'y',
	            'months',
	            'month',
	            'M',
	            'days',
	            'day',
	            'd',
	            'dates',
	            'date',
	            'D',
	            'hours',
	            'hour',
	            'h',
	            'minutes',
	            'minute',
	            'm',
	            'seconds',
	            'second',
	            's',
	            'milliseconds',
	            'millisecond',
	            'ms' ],
	        i,
	        property,
	        propertyLen = properties.length;

	    for (i = 0; i < propertyLen; i += 1) {
	        property = properties[i];
	        propertyTest = propertyTest || hasOwnProp$1(input, property);
	    }

	    return objectTest && propertyTest;
	}

	function isNumberOrStringArray$1(input) {
	    var arrayTest = isArray$3(input),
	        dataTypeTest = false;
	    if (arrayTest) {
	        dataTypeTest =
	            input.filter(function (item) {
	                return !isNumber$1(item) && isString$1(input);
	            }).length === 0;
	    }
	    return arrayTest && dataTypeTest;
	}

	function isCalendarSpec$1(input) {
	    var objectTest = isObject$5(input) && !isObjectEmpty$1(input),
	        propertyTest = false,
	        properties = [
	            'sameDay',
	            'nextDay',
	            'lastDay',
	            'nextWeek',
	            'lastWeek',
	            'sameElse' ],
	        i,
	        property;

	    for (i = 0; i < properties.length; i += 1) {
	        property = properties[i];
	        propertyTest = propertyTest || hasOwnProp$1(input, property);
	    }

	    return objectTest && propertyTest;
	}

	function getCalendarFormat$1(myMoment, now) {
	    var diff = myMoment.diff(now, 'days', true);
	    return diff < -6
	        ? 'sameElse'
	        : diff < -1
	        ? 'lastWeek'
	        : diff < 0
	        ? 'lastDay'
	        : diff < 1
	        ? 'sameDay'
	        : diff < 2
	        ? 'nextDay'
	        : diff < 7
	        ? 'nextWeek'
	        : 'sameElse';
	}

	function calendar$3(time, formats) {
	    // Support for single parameter, formats only overload to the calendar function
	    if (arguments.length === 1) {
	        if (!arguments[0]) {
	            time = undefined;
	            formats = undefined;
	        } else if (isMomentInput$1(arguments[0])) {
	            time = arguments[0];
	            formats = undefined;
	        } else if (isCalendarSpec$1(arguments[0])) {
	            formats = arguments[0];
	            time = undefined;
	        }
	    }
	    // We want to compare the start of today, vs this.
	    // Getting start-of-today depends on whether we're local/utc/offset or not.
	    var now = time || createLocal$1(),
	        sod = cloneWithOffset$1(now, this).startOf('day'),
	        format = hooks$2.calendarFormat(this, sod) || 'sameElse',
	        output =
	            formats &&
	            (isFunction$1(formats[format])
	                ? formats[format].call(this, now)
	                : formats[format]);

	    return this.format(
	        output || this.localeData().calendar(format, this, createLocal$1(now))
	    );
	}

	function clone$2() {
	    return new Moment$1(this);
	}

	function isAfter$1(input, units) {
	    var localInput = isMoment$1(input) ? input : createLocal$1(input);
	    if (!(this.isValid() && localInput.isValid())) {
	        return false;
	    }
	    units = normalizeUnits$1(units) || 'millisecond';
	    if (units === 'millisecond') {
	        return this.valueOf() > localInput.valueOf();
	    } else {
	        return localInput.valueOf() < this.clone().startOf(units).valueOf();
	    }
	}

	function isBefore$1(input, units) {
	    var localInput = isMoment$1(input) ? input : createLocal$1(input);
	    if (!(this.isValid() && localInput.isValid())) {
	        return false;
	    }
	    units = normalizeUnits$1(units) || 'millisecond';
	    if (units === 'millisecond') {
	        return this.valueOf() < localInput.valueOf();
	    } else {
	        return this.clone().endOf(units).valueOf() < localInput.valueOf();
	    }
	}

	function isBetween$1(from, to, units, inclusivity) {
	    var localFrom = isMoment$1(from) ? from : createLocal$1(from),
	        localTo = isMoment$1(to) ? to : createLocal$1(to);
	    if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
	        return false;
	    }
	    inclusivity = inclusivity || '()';
	    return (
	        (inclusivity[0] === '('
	            ? this.isAfter(localFrom, units)
	            : !this.isBefore(localFrom, units)) &&
	        (inclusivity[1] === ')'
	            ? this.isBefore(localTo, units)
	            : !this.isAfter(localTo, units))
	    );
	}

	function isSame$1(input, units) {
	    var localInput = isMoment$1(input) ? input : createLocal$1(input),
	        inputMs;
	    if (!(this.isValid() && localInput.isValid())) {
	        return false;
	    }
	    units = normalizeUnits$1(units) || 'millisecond';
	    if (units === 'millisecond') {
	        return this.valueOf() === localInput.valueOf();
	    } else {
	        inputMs = localInput.valueOf();
	        return (
	            this.clone().startOf(units).valueOf() <= inputMs &&
	            inputMs <= this.clone().endOf(units).valueOf()
	        );
	    }
	}

	function isSameOrAfter$1(input, units) {
	    return this.isSame(input, units) || this.isAfter(input, units);
	}

	function isSameOrBefore$1(input, units) {
	    return this.isSame(input, units) || this.isBefore(input, units);
	}

	function diff$1(input, units, asFloat) {
	    var that, zoneDelta, output;

	    if (!this.isValid()) {
	        return NaN;
	    }

	    that = cloneWithOffset$1(input, this);

	    if (!that.isValid()) {
	        return NaN;
	    }

	    zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

	    units = normalizeUnits$1(units);

	    switch (units) {
	        case 'year':
	            output = monthDiff$1(this, that) / 12;
	            break;
	        case 'month':
	            output = monthDiff$1(this, that);
	            break;
	        case 'quarter':
	            output = monthDiff$1(this, that) / 3;
	            break;
	        case 'second':
	            output = (this - that) / 1e3;
	            break; // 1000
	        case 'minute':
	            output = (this - that) / 6e4;
	            break; // 1000 * 60
	        case 'hour':
	            output = (this - that) / 36e5;
	            break; // 1000 * 60 * 60
	        case 'day':
	            output = (this - that - zoneDelta) / 864e5;
	            break; // 1000 * 60 * 60 * 24, negate dst
	        case 'week':
	            output = (this - that - zoneDelta) / 6048e5;
	            break; // 1000 * 60 * 60 * 24 * 7, negate dst
	        default:
	            output = this - that;
	    }

	    return asFloat ? output : absFloor$1(output);
	}

	function monthDiff$1(a, b) {
	    if (a.date() < b.date()) {
	        // end-of-month calculations work correct when the start month has more
	        // days than the end month.
	        return -monthDiff$1(b, a);
	    }
	    // difference in months
	    var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
	        // b is in (anchor - 1 month, anchor + 1 month)
	        anchor = a.clone().add(wholeMonthDiff, 'months'),
	        anchor2,
	        adjust;

	    if (b - anchor < 0) {
	        anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	        // linear across the month
	        adjust = (b - anchor) / (anchor - anchor2);
	    } else {
	        anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	        // linear across the month
	        adjust = (b - anchor) / (anchor2 - anchor);
	    }

	    //check for negative zero, return zero if negative zero
	    return -(wholeMonthDiff + adjust) || 0;
	}

	hooks$2.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	hooks$2.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

	function toString$6() {
	    return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	}

	function toISOString$2(keepOffset) {
	    if (!this.isValid()) {
	        return null;
	    }
	    var utc = keepOffset !== true,
	        m = utc ? this.clone().utc() : this;
	    if (m.year() < 0 || m.year() > 9999) {
	        return formatMoment$1(
	            m,
	            utc
	                ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
	                : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
	        );
	    }
	    if (isFunction$1(Date.prototype.toISOString)) {
	        // native implementation is ~50x faster, use it when we can
	        if (utc) {
	            return this.toDate().toISOString();
	        } else {
	            return new Date(this.valueOf() + this.utcOffset() * 60 * 1000)
	                .toISOString()
	                .replace('Z', formatMoment$1(m, 'Z'));
	        }
	    }
	    return formatMoment$1(
	        m,
	        utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
	    );
	}

	/**
	 * Return a human readable representation of a moment that can
	 * also be evaluated to get a new moment which is the same
	 *
	 * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
	 */
	function inspect$1() {
	    if (!this.isValid()) {
	        return 'moment.invalid(/* ' + this._i + ' */)';
	    }
	    var func = 'moment',
	        zone = '',
	        prefix,
	        year,
	        datetime,
	        suffix;
	    if (!this.isLocal()) {
	        func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
	        zone = 'Z';
	    }
	    prefix = '[' + func + '("]';
	    year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
	    datetime = '-MM-DD[T]HH:mm:ss.SSS';
	    suffix = zone + '[")]';

	    return this.format(prefix + year + datetime + suffix);
	}

	function format$1(inputString) {
	    if (!inputString) {
	        inputString = this.isUtc()
	            ? hooks$2.defaultFormatUtc
	            : hooks$2.defaultFormat;
	    }
	    var output = formatMoment$1(this, inputString);
	    return this.localeData().postformat(output);
	}

	function from$1(time, withoutSuffix) {
	    if (
	        this.isValid() &&
	        ((isMoment$1(time) && time.isValid()) || createLocal$1(time).isValid())
	    ) {
	        return createDuration$1({ to: this, from: time })
	            .locale(this.locale())
	            .humanize(!withoutSuffix);
	    } else {
	        return this.localeData().invalidDate();
	    }
	}

	function fromNow$1(withoutSuffix) {
	    return this.from(createLocal$1(), withoutSuffix);
	}

	function to$1(time, withoutSuffix) {
	    if (
	        this.isValid() &&
	        ((isMoment$1(time) && time.isValid()) || createLocal$1(time).isValid())
	    ) {
	        return createDuration$1({ from: this, to: time })
	            .locale(this.locale())
	            .humanize(!withoutSuffix);
	    } else {
	        return this.localeData().invalidDate();
	    }
	}

	function toNow$1(withoutSuffix) {
	    return this.to(createLocal$1(), withoutSuffix);
	}

	// If passed a locale key, it will set the locale for this
	// instance.  Otherwise, it will return the locale configuration
	// variables for this instance.
	function locale$1(key) {
	    var newLocaleData;

	    if (key === undefined) {
	        return this._locale._abbr;
	    } else {
	        newLocaleData = getLocale$1(key);
	        if (newLocaleData != null) {
	            this._locale = newLocaleData;
	        }
	        return this;
	    }
	}

	var lang$1 = deprecate$1(
	    'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
	    function (key) {
	        if (key === undefined) {
	            return this.localeData();
	        } else {
	            return this.locale(key);
	        }
	    }
	);

	function localeData$1() {
	    return this._locale;
	}

	var MS_PER_SECOND$1 = 1000,
	    MS_PER_MINUTE$1 = 60 * MS_PER_SECOND$1,
	    MS_PER_HOUR$1 = 60 * MS_PER_MINUTE$1,
	    MS_PER_400_YEARS$1 = (365 * 400 + 97) * 24 * MS_PER_HOUR$1;

	// actual modulo - handles negative numbers (for dates before 1970):
	function mod$3(dividend, divisor) {
	    return ((dividend % divisor) + divisor) % divisor;
	}

	function localStartOfDate$1(y, m, d) {
	    // the date constructor remaps years 0-99 to 1900-1999
	    if (y < 100 && y >= 0) {
	        // preserve leap years using a full 400 year cycle, then reset
	        return new Date(y + 400, m, d) - MS_PER_400_YEARS$1;
	    } else {
	        return new Date(y, m, d).valueOf();
	    }
	}

	function utcStartOfDate$1(y, m, d) {
	    // Date.UTC remaps years 0-99 to 1900-1999
	    if (y < 100 && y >= 0) {
	        // preserve leap years using a full 400 year cycle, then reset
	        return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS$1;
	    } else {
	        return Date.UTC(y, m, d);
	    }
	}

	function startOf$1(units) {
	    var time, startOfDate;
	    units = normalizeUnits$1(units);
	    if (units === undefined || units === 'millisecond' || !this.isValid()) {
	        return this;
	    }

	    startOfDate = this._isUTC ? utcStartOfDate$1 : localStartOfDate$1;

	    switch (units) {
	        case 'year':
	            time = startOfDate(this.year(), 0, 1);
	            break;
	        case 'quarter':
	            time = startOfDate(
	                this.year(),
	                this.month() - (this.month() % 3),
	                1
	            );
	            break;
	        case 'month':
	            time = startOfDate(this.year(), this.month(), 1);
	            break;
	        case 'week':
	            time = startOfDate(
	                this.year(),
	                this.month(),
	                this.date() - this.weekday()
	            );
	            break;
	        case 'isoWeek':
	            time = startOfDate(
	                this.year(),
	                this.month(),
	                this.date() - (this.isoWeekday() - 1)
	            );
	            break;
	        case 'day':
	        case 'date':
	            time = startOfDate(this.year(), this.month(), this.date());
	            break;
	        case 'hour':
	            time = this._d.valueOf();
	            time -= mod$3(
	                time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE$1),
	                MS_PER_HOUR$1
	            );
	            break;
	        case 'minute':
	            time = this._d.valueOf();
	            time -= mod$3(time, MS_PER_MINUTE$1);
	            break;
	        case 'second':
	            time = this._d.valueOf();
	            time -= mod$3(time, MS_PER_SECOND$1);
	            break;
	    }

	    this._d.setTime(time);
	    hooks$2.updateOffset(this, true);
	    return this;
	}

	function endOf$1(units) {
	    var time, startOfDate;
	    units = normalizeUnits$1(units);
	    if (units === undefined || units === 'millisecond' || !this.isValid()) {
	        return this;
	    }

	    startOfDate = this._isUTC ? utcStartOfDate$1 : localStartOfDate$1;

	    switch (units) {
	        case 'year':
	            time = startOfDate(this.year() + 1, 0, 1) - 1;
	            break;
	        case 'quarter':
	            time =
	                startOfDate(
	                    this.year(),
	                    this.month() - (this.month() % 3) + 3,
	                    1
	                ) - 1;
	            break;
	        case 'month':
	            time = startOfDate(this.year(), this.month() + 1, 1) - 1;
	            break;
	        case 'week':
	            time =
	                startOfDate(
	                    this.year(),
	                    this.month(),
	                    this.date() - this.weekday() + 7
	                ) - 1;
	            break;
	        case 'isoWeek':
	            time =
	                startOfDate(
	                    this.year(),
	                    this.month(),
	                    this.date() - (this.isoWeekday() - 1) + 7
	                ) - 1;
	            break;
	        case 'day':
	        case 'date':
	            time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
	            break;
	        case 'hour':
	            time = this._d.valueOf();
	            time +=
	                MS_PER_HOUR$1 -
	                mod$3(
	                    time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE$1),
	                    MS_PER_HOUR$1
	                ) -
	                1;
	            break;
	        case 'minute':
	            time = this._d.valueOf();
	            time += MS_PER_MINUTE$1 - mod$3(time, MS_PER_MINUTE$1) - 1;
	            break;
	        case 'second':
	            time = this._d.valueOf();
	            time += MS_PER_SECOND$1 - mod$3(time, MS_PER_SECOND$1) - 1;
	            break;
	    }

	    this._d.setTime(time);
	    hooks$2.updateOffset(this, true);
	    return this;
	}

	function valueOf$2() {
	    return this._d.valueOf() - (this._offset || 0) * 60000;
	}

	function unix$1() {
	    return Math.floor(this.valueOf() / 1000);
	}

	function toDate$1() {
	    return new Date(this.valueOf());
	}

	function toArray$6() {
	    var m = this;
	    return [
	        m.year(),
	        m.month(),
	        m.date(),
	        m.hour(),
	        m.minute(),
	        m.second(),
	        m.millisecond() ];
	}

	function toObject$2() {
	    var m = this;
	    return {
	        years: m.year(),
	        months: m.month(),
	        date: m.date(),
	        hours: m.hours(),
	        minutes: m.minutes(),
	        seconds: m.seconds(),
	        milliseconds: m.milliseconds(),
	    };
	}

	function toJSON$1() {
	    // new Date(NaN).toJSON() === null
	    return this.isValid() ? this.toISOString() : null;
	}

	function isValid$5() {
	    return isValid$3(this);
	}

	function parsingFlags$1() {
	    return extend$2({}, getParsingFlags$1(this));
	}

	function invalidAt$1() {
	    return getParsingFlags$1(this).overflow;
	}

	function creationData$1() {
	    return {
	        input: this._i,
	        format: this._f,
	        locale: this._locale,
	        isUTC: this._isUTC,
	        strict: this._strict,
	    };
	}

	addFormatToken$1('N', 0, 0, 'eraAbbr');
	addFormatToken$1('NN', 0, 0, 'eraAbbr');
	addFormatToken$1('NNN', 0, 0, 'eraAbbr');
	addFormatToken$1('NNNN', 0, 0, 'eraName');
	addFormatToken$1('NNNNN', 0, 0, 'eraNarrow');

	addFormatToken$1('y', ['y', 1], 'yo', 'eraYear');
	addFormatToken$1('y', ['yy', 2], 0, 'eraYear');
	addFormatToken$1('y', ['yyy', 3], 0, 'eraYear');
	addFormatToken$1('y', ['yyyy', 4], 0, 'eraYear');

	addRegexToken$1('N', matchEraAbbr$1);
	addRegexToken$1('NN', matchEraAbbr$1);
	addRegexToken$1('NNN', matchEraAbbr$1);
	addRegexToken$1('NNNN', matchEraName$1);
	addRegexToken$1('NNNNN', matchEraNarrow$1);

	addParseToken$1(
	    ['N', 'NN', 'NNN', 'NNNN', 'NNNNN'],
	    function (input, array, config, token) {
	        var era = config._locale.erasParse(input, token, config._strict);
	        if (era) {
	            getParsingFlags$1(config).era = era;
	        } else {
	            getParsingFlags$1(config).invalidEra = input;
	        }
	    }
	);

	addRegexToken$1('y', matchUnsigned$1);
	addRegexToken$1('yy', matchUnsigned$1);
	addRegexToken$1('yyy', matchUnsigned$1);
	addRegexToken$1('yyyy', matchUnsigned$1);
	addRegexToken$1('yo', matchEraYearOrdinal$1);

	addParseToken$1(['y', 'yy', 'yyy', 'yyyy'], YEAR$1);
	addParseToken$1(['yo'], function (input, array, config, token) {
	    var match;
	    if (config._locale._eraYearOrdinalRegex) {
	        match = input.match(config._locale._eraYearOrdinalRegex);
	    }

	    if (config._locale.eraYearOrdinalParse) {
	        array[YEAR$1] = config._locale.eraYearOrdinalParse(input, match);
	    } else {
	        array[YEAR$1] = parseInt(input, 10);
	    }
	});

	function localeEras$1(m, format) {
	    var i,
	        l,
	        date,
	        eras = this._eras || getLocale$1('en')._eras;
	    for (i = 0, l = eras.length; i < l; ++i) {
	        switch (typeof eras[i].since) {
	            case 'string':
	                // truncate time
	                date = hooks$2(eras[i].since).startOf('day');
	                eras[i].since = date.valueOf();
	                break;
	        }

	        switch (typeof eras[i].until) {
	            case 'undefined':
	                eras[i].until = +Infinity;
	                break;
	            case 'string':
	                // truncate time
	                date = hooks$2(eras[i].until).startOf('day').valueOf();
	                eras[i].until = date.valueOf();
	                break;
	        }
	    }
	    return eras;
	}

	function localeErasParse$1(eraName, format, strict) {
	    var i,
	        l,
	        eras = this.eras(),
	        name,
	        abbr,
	        narrow;
	    eraName = eraName.toUpperCase();

	    for (i = 0, l = eras.length; i < l; ++i) {
	        name = eras[i].name.toUpperCase();
	        abbr = eras[i].abbr.toUpperCase();
	        narrow = eras[i].narrow.toUpperCase();

	        if (strict) {
	            switch (format) {
	                case 'N':
	                case 'NN':
	                case 'NNN':
	                    if (abbr === eraName) {
	                        return eras[i];
	                    }
	                    break;

	                case 'NNNN':
	                    if (name === eraName) {
	                        return eras[i];
	                    }
	                    break;

	                case 'NNNNN':
	                    if (narrow === eraName) {
	                        return eras[i];
	                    }
	                    break;
	            }
	        } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
	            return eras[i];
	        }
	    }
	}

	function localeErasConvertYear$1(era, year) {
	    var dir = era.since <= era.until ? +1 : -1;
	    if (year === undefined) {
	        return hooks$2(era.since).year();
	    } else {
	        return hooks$2(era.since).year() + (year - era.offset) * dir;
	    }
	}

	function getEraName$1() {
	    var this$1 = this;

	    var i,
	        l,
	        val,
	        eras = this.localeData().eras();
	    for (i = 0, l = eras.length; i < l; ++i) {
	        // truncate time
	        val = this$1.clone().startOf('day').valueOf();

	        if (eras[i].since <= val && val <= eras[i].until) {
	            return eras[i].name;
	        }
	        if (eras[i].until <= val && val <= eras[i].since) {
	            return eras[i].name;
	        }
	    }

	    return '';
	}

	function getEraNarrow$1() {
	    var this$1 = this;

	    var i,
	        l,
	        val,
	        eras = this.localeData().eras();
	    for (i = 0, l = eras.length; i < l; ++i) {
	        // truncate time
	        val = this$1.clone().startOf('day').valueOf();

	        if (eras[i].since <= val && val <= eras[i].until) {
	            return eras[i].narrow;
	        }
	        if (eras[i].until <= val && val <= eras[i].since) {
	            return eras[i].narrow;
	        }
	    }

	    return '';
	}

	function getEraAbbr$1() {
	    var this$1 = this;

	    var i,
	        l,
	        val,
	        eras = this.localeData().eras();
	    for (i = 0, l = eras.length; i < l; ++i) {
	        // truncate time
	        val = this$1.clone().startOf('day').valueOf();

	        if (eras[i].since <= val && val <= eras[i].until) {
	            return eras[i].abbr;
	        }
	        if (eras[i].until <= val && val <= eras[i].since) {
	            return eras[i].abbr;
	        }
	    }

	    return '';
	}

	function getEraYear$1() {
	    var this$1 = this;

	    var i,
	        l,
	        dir,
	        val,
	        eras = this.localeData().eras();
	    for (i = 0, l = eras.length; i < l; ++i) {
	        dir = eras[i].since <= eras[i].until ? +1 : -1;

	        // truncate time
	        val = this$1.clone().startOf('day').valueOf();

	        if (
	            (eras[i].since <= val && val <= eras[i].until) ||
	            (eras[i].until <= val && val <= eras[i].since)
	        ) {
	            return (
	                (this$1.year() - hooks$2(eras[i].since).year()) * dir +
	                eras[i].offset
	            );
	        }
	    }

	    return this.year();
	}

	function erasNameRegex$1(isStrict) {
	    if (!hasOwnProp$1(this, '_erasNameRegex')) {
	        computeErasParse$1.call(this);
	    }
	    return isStrict ? this._erasNameRegex : this._erasRegex;
	}

	function erasAbbrRegex$1(isStrict) {
	    if (!hasOwnProp$1(this, '_erasAbbrRegex')) {
	        computeErasParse$1.call(this);
	    }
	    return isStrict ? this._erasAbbrRegex : this._erasRegex;
	}

	function erasNarrowRegex$1(isStrict) {
	    if (!hasOwnProp$1(this, '_erasNarrowRegex')) {
	        computeErasParse$1.call(this);
	    }
	    return isStrict ? this._erasNarrowRegex : this._erasRegex;
	}

	function matchEraAbbr$1(isStrict, locale) {
	    return locale.erasAbbrRegex(isStrict);
	}

	function matchEraName$1(isStrict, locale) {
	    return locale.erasNameRegex(isStrict);
	}

	function matchEraNarrow$1(isStrict, locale) {
	    return locale.erasNarrowRegex(isStrict);
	}

	function matchEraYearOrdinal$1(isStrict, locale) {
	    return locale._eraYearOrdinalRegex || matchUnsigned$1;
	}

	function computeErasParse$1() {
	    var abbrPieces = [],
	        namePieces = [],
	        narrowPieces = [],
	        mixedPieces = [],
	        i,
	        l,
	        eras = this.eras();

	    for (i = 0, l = eras.length; i < l; ++i) {
	        namePieces.push(regexEscape$1(eras[i].name));
	        abbrPieces.push(regexEscape$1(eras[i].abbr));
	        narrowPieces.push(regexEscape$1(eras[i].narrow));

	        mixedPieces.push(regexEscape$1(eras[i].name));
	        mixedPieces.push(regexEscape$1(eras[i].abbr));
	        mixedPieces.push(regexEscape$1(eras[i].narrow));
	    }

	    this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	    this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
	    this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
	    this._erasNarrowRegex = new RegExp(
	        '^(' + narrowPieces.join('|') + ')',
	        'i'
	    );
	}

	// FORMATTING

	addFormatToken$1(0, ['gg', 2], 0, function () {
	    return this.weekYear() % 100;
	});

	addFormatToken$1(0, ['GG', 2], 0, function () {
	    return this.isoWeekYear() % 100;
	});

	function addWeekYearFormatToken$1(token, getter) {
	    addFormatToken$1(0, [token, token.length], 0, getter);
	}

	addWeekYearFormatToken$1('gggg', 'weekYear');
	addWeekYearFormatToken$1('ggggg', 'weekYear');
	addWeekYearFormatToken$1('GGGG', 'isoWeekYear');
	addWeekYearFormatToken$1('GGGGG', 'isoWeekYear');

	// ALIASES

	addUnitAlias$1('weekYear', 'gg');
	addUnitAlias$1('isoWeekYear', 'GG');

	// PRIORITY

	addUnitPriority$1('weekYear', 1);
	addUnitPriority$1('isoWeekYear', 1);

	// PARSING

	addRegexToken$1('G', matchSigned$1);
	addRegexToken$1('g', matchSigned$1);
	addRegexToken$1('GG', match1to2$1, match2$1);
	addRegexToken$1('gg', match1to2$1, match2$1);
	addRegexToken$1('GGGG', match1to4$1, match4$1);
	addRegexToken$1('gggg', match1to4$1, match4$1);
	addRegexToken$1('GGGGG', match1to6$1, match6$1);
	addRegexToken$1('ggggg', match1to6$1, match6$1);

	addWeekParseToken$1(
	    ['gggg', 'ggggg', 'GGGG', 'GGGGG'],
	    function (input, week, config, token) {
	        week[token.substr(0, 2)] = toInt$1(input);
	    }
	);

	addWeekParseToken$1(['gg', 'GG'], function (input, week, config, token) {
	    week[token] = hooks$2.parseTwoDigitYear(input);
	});

	// MOMENTS

	function getSetWeekYear$1(input) {
	    return getSetWeekYearHelper$1.call(
	        this,
	        input,
	        this.week(),
	        this.weekday(),
	        this.localeData()._week.dow,
	        this.localeData()._week.doy
	    );
	}

	function getSetISOWeekYear$1(input) {
	    return getSetWeekYearHelper$1.call(
	        this,
	        input,
	        this.isoWeek(),
	        this.isoWeekday(),
	        1,
	        4
	    );
	}

	function getISOWeeksInYear$1() {
	    return weeksInYear$1(this.year(), 1, 4);
	}

	function getISOWeeksInISOWeekYear$1() {
	    return weeksInYear$1(this.isoWeekYear(), 1, 4);
	}

	function getWeeksInYear$1() {
	    var weekInfo = this.localeData()._week;
	    return weeksInYear$1(this.year(), weekInfo.dow, weekInfo.doy);
	}

	function getWeeksInWeekYear$1() {
	    var weekInfo = this.localeData()._week;
	    return weeksInYear$1(this.weekYear(), weekInfo.dow, weekInfo.doy);
	}

	function getSetWeekYearHelper$1(input, week, weekday, dow, doy) {
	    var weeksTarget;
	    if (input == null) {
	        return weekOfYear$1(this, dow, doy).year;
	    } else {
	        weeksTarget = weeksInYear$1(input, dow, doy);
	        if (week > weeksTarget) {
	            week = weeksTarget;
	        }
	        return setWeekAll$1.call(this, input, week, weekday, dow, doy);
	    }
	}

	function setWeekAll$1(weekYear, week, weekday, dow, doy) {
	    var dayOfYearData = dayOfYearFromWeeks$1(weekYear, week, weekday, dow, doy),
	        date = createUTCDate$1(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

	    this.year(date.getUTCFullYear());
	    this.month(date.getUTCMonth());
	    this.date(date.getUTCDate());
	    return this;
	}

	// FORMATTING

	addFormatToken$1('Q', 0, 'Qo', 'quarter');

	// ALIASES

	addUnitAlias$1('quarter', 'Q');

	// PRIORITY

	addUnitPriority$1('quarter', 7);

	// PARSING

	addRegexToken$1('Q', match1$1);
	addParseToken$1('Q', function (input, array) {
	    array[MONTH$1] = (toInt$1(input) - 1) * 3;
	});

	// MOMENTS

	function getSetQuarter$1(input) {
	    return input == null
	        ? Math.ceil((this.month() + 1) / 3)
	        : this.month((input - 1) * 3 + (this.month() % 3));
	}

	// FORMATTING

	addFormatToken$1('D', ['DD', 2], 'Do', 'date');

	// ALIASES

	addUnitAlias$1('date', 'D');

	// PRIORITY
	addUnitPriority$1('date', 9);

	// PARSING

	addRegexToken$1('D', match1to2$1);
	addRegexToken$1('DD', match1to2$1, match2$1);
	addRegexToken$1('Do', function (isStrict, locale) {
	    // TODO: Remove "ordinalParse" fallback in next major release.
	    return isStrict
	        ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
	        : locale._dayOfMonthOrdinalParseLenient;
	});

	addParseToken$1(['D', 'DD'], DATE$1);
	addParseToken$1('Do', function (input, array) {
	    array[DATE$1] = toInt$1(input.match(match1to2$1)[0]);
	});

	// MOMENTS

	var getSetDayOfMonth$1 = makeGetSet$1('Date', true);

	// FORMATTING

	addFormatToken$1('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

	// ALIASES

	addUnitAlias$1('dayOfYear', 'DDD');

	// PRIORITY
	addUnitPriority$1('dayOfYear', 4);

	// PARSING

	addRegexToken$1('DDD', match1to3$1);
	addRegexToken$1('DDDD', match3$1);
	addParseToken$1(['DDD', 'DDDD'], function (input, array, config) {
	    config._dayOfYear = toInt$1(input);
	});

	// HELPERS

	// MOMENTS

	function getSetDayOfYear$1(input) {
	    var dayOfYear =
	        Math.round(
	            (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
	        ) + 1;
	    return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
	}

	// FORMATTING

	addFormatToken$1('m', ['mm', 2], 0, 'minute');

	// ALIASES

	addUnitAlias$1('minute', 'm');

	// PRIORITY

	addUnitPriority$1('minute', 14);

	// PARSING

	addRegexToken$1('m', match1to2$1);
	addRegexToken$1('mm', match1to2$1, match2$1);
	addParseToken$1(['m', 'mm'], MINUTE$1);

	// MOMENTS

	var getSetMinute$1 = makeGetSet$1('Minutes', false);

	// FORMATTING

	addFormatToken$1('s', ['ss', 2], 0, 'second');

	// ALIASES

	addUnitAlias$1('second', 's');

	// PRIORITY

	addUnitPriority$1('second', 15);

	// PARSING

	addRegexToken$1('s', match1to2$1);
	addRegexToken$1('ss', match1to2$1, match2$1);
	addParseToken$1(['s', 'ss'], SECOND$1);

	// MOMENTS

	var getSetSecond$1 = makeGetSet$1('Seconds', false);

	// FORMATTING

	addFormatToken$1('S', 0, 0, function () {
	    return ~~(this.millisecond() / 100);
	});

	addFormatToken$1(0, ['SS', 2], 0, function () {
	    return ~~(this.millisecond() / 10);
	});

	addFormatToken$1(0, ['SSS', 3], 0, 'millisecond');
	addFormatToken$1(0, ['SSSS', 4], 0, function () {
	    return this.millisecond() * 10;
	});
	addFormatToken$1(0, ['SSSSS', 5], 0, function () {
	    return this.millisecond() * 100;
	});
	addFormatToken$1(0, ['SSSSSS', 6], 0, function () {
	    return this.millisecond() * 1000;
	});
	addFormatToken$1(0, ['SSSSSSS', 7], 0, function () {
	    return this.millisecond() * 10000;
	});
	addFormatToken$1(0, ['SSSSSSSS', 8], 0, function () {
	    return this.millisecond() * 100000;
	});
	addFormatToken$1(0, ['SSSSSSSSS', 9], 0, function () {
	    return this.millisecond() * 1000000;
	});

	// ALIASES

	addUnitAlias$1('millisecond', 'ms');

	// PRIORITY

	addUnitPriority$1('millisecond', 16);

	// PARSING

	addRegexToken$1('S', match1to3$1, match1$1);
	addRegexToken$1('SS', match1to3$1, match2$1);
	addRegexToken$1('SSS', match1to3$1, match3$1);

	var token$1, getSetMillisecond$1;
	for (token$1 = 'SSSS'; token$1.length <= 9; token$1 += 'S') {
	    addRegexToken$1(token$1, matchUnsigned$1);
	}

	function parseMs$1(input, array) {
	    array[MILLISECOND$1] = toInt$1(('0.' + input) * 1000);
	}

	for (token$1 = 'S'; token$1.length <= 9; token$1 += 'S') {
	    addParseToken$1(token$1, parseMs$1);
	}

	getSetMillisecond$1 = makeGetSet$1('Milliseconds', false);

	// FORMATTING

	addFormatToken$1('z', 0, 0, 'zoneAbbr');
	addFormatToken$1('zz', 0, 0, 'zoneName');

	// MOMENTS

	function getZoneAbbr$1() {
	    return this._isUTC ? 'UTC' : '';
	}

	function getZoneName$1() {
	    return this._isUTC ? 'Coordinated Universal Time' : '';
	}

	var proto$3 = Moment$1.prototype;

	proto$3.add = add$4;
	proto$3.calendar = calendar$3;
	proto$3.clone = clone$2;
	proto$3.diff = diff$1;
	proto$3.endOf = endOf$1;
	proto$3.format = format$1;
	proto$3.from = from$1;
	proto$3.fromNow = fromNow$1;
	proto$3.to = to$1;
	proto$3.toNow = toNow$1;
	proto$3.get = stringGet$1;
	proto$3.invalidAt = invalidAt$1;
	proto$3.isAfter = isAfter$1;
	proto$3.isBefore = isBefore$1;
	proto$3.isBetween = isBetween$1;
	proto$3.isSame = isSame$1;
	proto$3.isSameOrAfter = isSameOrAfter$1;
	proto$3.isSameOrBefore = isSameOrBefore$1;
	proto$3.isValid = isValid$5;
	proto$3.lang = lang$1;
	proto$3.locale = locale$1;
	proto$3.localeData = localeData$1;
	proto$3.max = prototypeMax$1;
	proto$3.min = prototypeMin$1;
	proto$3.parsingFlags = parsingFlags$1;
	proto$3.set = stringSet$1;
	proto$3.startOf = startOf$1;
	proto$3.subtract = subtract$2;
	proto$3.toArray = toArray$6;
	proto$3.toObject = toObject$2;
	proto$3.toDate = toDate$1;
	proto$3.toISOString = toISOString$2;
	proto$3.inspect = inspect$1;
	if (typeof Symbol !== 'undefined' && Symbol.for != null) {
	    proto$3[Symbol.for('nodejs.util.inspect.custom')] = function () {
	        return 'Moment<' + this.format() + '>';
	    };
	}
	proto$3.toJSON = toJSON$1;
	proto$3.toString = toString$6;
	proto$3.unix = unix$1;
	proto$3.valueOf = valueOf$2;
	proto$3.creationData = creationData$1;
	proto$3.eraName = getEraName$1;
	proto$3.eraNarrow = getEraNarrow$1;
	proto$3.eraAbbr = getEraAbbr$1;
	proto$3.eraYear = getEraYear$1;
	proto$3.year = getSetYear$1;
	proto$3.isLeapYear = getIsLeapYear$1;
	proto$3.weekYear = getSetWeekYear$1;
	proto$3.isoWeekYear = getSetISOWeekYear$1;
	proto$3.quarter = proto$3.quarters = getSetQuarter$1;
	proto$3.month = getSetMonth$1;
	proto$3.daysInMonth = getDaysInMonth$1;
	proto$3.week = proto$3.weeks = getSetWeek$1;
	proto$3.isoWeek = proto$3.isoWeeks = getSetISOWeek$1;
	proto$3.weeksInYear = getWeeksInYear$1;
	proto$3.weeksInWeekYear = getWeeksInWeekYear$1;
	proto$3.isoWeeksInYear = getISOWeeksInYear$1;
	proto$3.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear$1;
	proto$3.date = getSetDayOfMonth$1;
	proto$3.day = proto$3.days = getSetDayOfWeek$1;
	proto$3.weekday = getSetLocaleDayOfWeek$1;
	proto$3.isoWeekday = getSetISODayOfWeek$1;
	proto$3.dayOfYear = getSetDayOfYear$1;
	proto$3.hour = proto$3.hours = getSetHour$1;
	proto$3.minute = proto$3.minutes = getSetMinute$1;
	proto$3.second = proto$3.seconds = getSetSecond$1;
	proto$3.millisecond = proto$3.milliseconds = getSetMillisecond$1;
	proto$3.utcOffset = getSetOffset$1;
	proto$3.utc = setOffsetToUTC$1;
	proto$3.local = setOffsetToLocal$1;
	proto$3.parseZone = setOffsetToParsedOffset$1;
	proto$3.hasAlignedHourOffset = hasAlignedHourOffset$1;
	proto$3.isDST = isDaylightSavingTime$1;
	proto$3.isLocal = isLocal$1;
	proto$3.isUtcOffset = isUtcOffset$1;
	proto$3.isUtc = isUtc$1;
	proto$3.isUTC = isUtc$1;
	proto$3.zoneAbbr = getZoneAbbr$1;
	proto$3.zoneName = getZoneName$1;
	proto$3.dates = deprecate$1(
	    'dates accessor is deprecated. Use date instead.',
	    getSetDayOfMonth$1
	);
	proto$3.months = deprecate$1(
	    'months accessor is deprecated. Use month instead',
	    getSetMonth$1
	);
	proto$3.years = deprecate$1(
	    'years accessor is deprecated. Use year instead',
	    getSetYear$1
	);
	proto$3.zone = deprecate$1(
	    'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
	    getSetZone$1
	);
	proto$3.isDSTShifted = deprecate$1(
	    'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
	    isDaylightSavingTimeShifted$1
	);

	function createUnix$1(input) {
	    return createLocal$1(input * 1000);
	}

	function createInZone$1() {
	    return createLocal$1.apply(null, arguments).parseZone();
	}

	function preParsePostFormat$1(string) {
	    return string;
	}

	var proto$4 = Locale$1.prototype;

	proto$4.calendar = calendar$2;
	proto$4.longDateFormat = longDateFormat$1;
	proto$4.invalidDate = invalidDate$1;
	proto$4.ordinal = ordinal$1;
	proto$4.preparse = preParsePostFormat$1;
	proto$4.postformat = preParsePostFormat$1;
	proto$4.relativeTime = relativeTime$2;
	proto$4.pastFuture = pastFuture$1;
	proto$4.set = set$2;
	proto$4.eras = localeEras$1;
	proto$4.erasParse = localeErasParse$1;
	proto$4.erasConvertYear = localeErasConvertYear$1;
	proto$4.erasAbbrRegex = erasAbbrRegex$1;
	proto$4.erasNameRegex = erasNameRegex$1;
	proto$4.erasNarrowRegex = erasNarrowRegex$1;

	proto$4.months = localeMonths$1;
	proto$4.monthsShort = localeMonthsShort$1;
	proto$4.monthsParse = localeMonthsParse$1;
	proto$4.monthsRegex = monthsRegex$1;
	proto$4.monthsShortRegex = monthsShortRegex$1;
	proto$4.week = localeWeek$1;
	proto$4.firstDayOfYear = localeFirstDayOfYear$1;
	proto$4.firstDayOfWeek = localeFirstDayOfWeek$1;

	proto$4.weekdays = localeWeekdays$1;
	proto$4.weekdaysMin = localeWeekdaysMin$1;
	proto$4.weekdaysShort = localeWeekdaysShort$1;
	proto$4.weekdaysParse = localeWeekdaysParse$1;

	proto$4.weekdaysRegex = weekdaysRegex$1;
	proto$4.weekdaysShortRegex = weekdaysShortRegex$1;
	proto$4.weekdaysMinRegex = weekdaysMinRegex$1;

	proto$4.isPM = localeIsPM$1;
	proto$4.meridiem = localeMeridiem$1;

	function get$4(format, index, field, setter) {
	    var locale = getLocale$1(),
	        utc = createUTC$1().set(setter, index);
	    return locale[field](utc, format);
	}

	function listMonthsImpl$1(format, index, field) {
	    if (isNumber$1(format)) {
	        index = format;
	        format = undefined;
	    }

	    format = format || '';

	    if (index != null) {
	        return get$4(format, index, field, 'month');
	    }

	    var i,
	        out = [];
	    for (i = 0; i < 12; i++) {
	        out[i] = get$4(format, i, field, 'month');
	    }
	    return out;
	}

	// ()
	// (5)
	// (fmt, 5)
	// (fmt)
	// (true)
	// (true, 5)
	// (true, fmt, 5)
	// (true, fmt)
	function listWeekdaysImpl$1(localeSorted, format, index, field) {
	    if (typeof localeSorted === 'boolean') {
	        if (isNumber$1(format)) {
	            index = format;
	            format = undefined;
	        }

	        format = format || '';
	    } else {
	        format = localeSorted;
	        index = format;
	        localeSorted = false;

	        if (isNumber$1(format)) {
	            index = format;
	            format = undefined;
	        }

	        format = format || '';
	    }

	    var locale = getLocale$1(),
	        shift = localeSorted ? locale._week.dow : 0,
	        i,
	        out = [];

	    if (index != null) {
	        return get$4(format, (index + shift) % 7, field, 'day');
	    }

	    for (i = 0; i < 7; i++) {
	        out[i] = get$4(format, (i + shift) % 7, field, 'day');
	    }
	    return out;
	}

	function listMonths$1(format, index) {
	    return listMonthsImpl$1(format, index, 'months');
	}

	function listMonthsShort$1(format, index) {
	    return listMonthsImpl$1(format, index, 'monthsShort');
	}

	function listWeekdays$1(localeSorted, format, index) {
	    return listWeekdaysImpl$1(localeSorted, format, index, 'weekdays');
	}

	function listWeekdaysShort$1(localeSorted, format, index) {
	    return listWeekdaysImpl$1(localeSorted, format, index, 'weekdaysShort');
	}

	function listWeekdaysMin$1(localeSorted, format, index) {
	    return listWeekdaysImpl$1(localeSorted, format, index, 'weekdaysMin');
	}

	getSetGlobalLocale$1('en', {
	    eras: [
	        {
	            since: '0001-01-01',
	            until: +Infinity,
	            offset: 1,
	            name: 'Anno Domini',
	            narrow: 'AD',
	            abbr: 'AD',
	        },
	        {
	            since: '0000-12-31',
	            until: -Infinity,
	            offset: 1,
	            name: 'Before Christ',
	            narrow: 'BC',
	            abbr: 'BC',
	        } ],
	    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	    ordinal: function (number) {
	        var b = number % 10,
	            output =
	                toInt$1((number % 100) / 10) === 1
	                    ? 'th'
	                    : b === 1
	                    ? 'st'
	                    : b === 2
	                    ? 'nd'
	                    : b === 3
	                    ? 'rd'
	                    : 'th';
	        return number + output;
	    },
	});

	// Side effect imports

	hooks$2.lang = deprecate$1(
	    'moment.lang is deprecated. Use moment.locale instead.',
	    getSetGlobalLocale$1
	);
	hooks$2.langData = deprecate$1(
	    'moment.langData is deprecated. Use moment.localeData instead.',
	    getLocale$1
	);

	var mathAbs$1 = Math.abs;

	function abs$2() {
	    var data = this._data;

	    this._milliseconds = mathAbs$1(this._milliseconds);
	    this._days = mathAbs$1(this._days);
	    this._months = mathAbs$1(this._months);

	    data.milliseconds = mathAbs$1(data.milliseconds);
	    data.seconds = mathAbs$1(data.seconds);
	    data.minutes = mathAbs$1(data.minutes);
	    data.hours = mathAbs$1(data.hours);
	    data.months = mathAbs$1(data.months);
	    data.years = mathAbs$1(data.years);

	    return this;
	}

	function addSubtract$3(duration, input, value, direction) {
	    var other = createDuration$1(input, value);

	    duration._milliseconds += direction * other._milliseconds;
	    duration._days += direction * other._days;
	    duration._months += direction * other._months;

	    return duration._bubble();
	}

	// supports only 2.0-style add(1, 's') or add(duration)
	function add$5(input, value) {
	    return addSubtract$3(this, input, value, 1);
	}

	// supports only 2.0-style subtract(1, 's') or subtract(duration)
	function subtract$3(input, value) {
	    return addSubtract$3(this, input, value, -1);
	}

	function absCeil$1(number) {
	    if (number < 0) {
	        return Math.floor(number);
	    } else {
	        return Math.ceil(number);
	    }
	}

	function bubble$1() {
	    var milliseconds = this._milliseconds,
	        days = this._days,
	        months = this._months,
	        data = this._data,
	        seconds,
	        minutes,
	        hours,
	        years,
	        monthsFromDays;

	    // if we have a mix of positive and negative values, bubble down first
	    // check: https://github.com/moment/moment/issues/2166
	    if (
	        !(
	            (milliseconds >= 0 && days >= 0 && months >= 0) ||
	            (milliseconds <= 0 && days <= 0 && months <= 0)
	        )
	    ) {
	        milliseconds += absCeil$1(monthsToDays$1(months) + days) * 864e5;
	        days = 0;
	        months = 0;
	    }

	    // The following code bubbles up values, see the tests for
	    // examples of what that means.
	    data.milliseconds = milliseconds % 1000;

	    seconds = absFloor$1(milliseconds / 1000);
	    data.seconds = seconds % 60;

	    minutes = absFloor$1(seconds / 60);
	    data.minutes = minutes % 60;

	    hours = absFloor$1(minutes / 60);
	    data.hours = hours % 24;

	    days += absFloor$1(hours / 24);

	    // convert days to months
	    monthsFromDays = absFloor$1(daysToMonths$1(days));
	    months += monthsFromDays;
	    days -= absCeil$1(monthsToDays$1(monthsFromDays));

	    // 12 months -> 1 year
	    years = absFloor$1(months / 12);
	    months %= 12;

	    data.days = days;
	    data.months = months;
	    data.years = years;

	    return this;
	}

	function daysToMonths$1(days) {
	    // 400 years have 146097 days (taking into account leap year rules)
	    // 400 years have 12 months === 4800
	    return (days * 4800) / 146097;
	}

	function monthsToDays$1(months) {
	    // the reverse of daysToMonths
	    return (months * 146097) / 4800;
	}

	function as$1(units) {
	    if (!this.isValid()) {
	        return NaN;
	    }
	    var days,
	        months,
	        milliseconds = this._milliseconds;

	    units = normalizeUnits$1(units);

	    if (units === 'month' || units === 'quarter' || units === 'year') {
	        days = this._days + milliseconds / 864e5;
	        months = this._months + daysToMonths$1(days);
	        switch (units) {
	            case 'month':
	                return months;
	            case 'quarter':
	                return months / 3;
	            case 'year':
	                return months / 12;
	        }
	    } else {
	        // handle milliseconds separately because of floating point math errors (issue #1867)
	        days = this._days + Math.round(monthsToDays$1(this._months));
	        switch (units) {
	            case 'week':
	                return days / 7 + milliseconds / 6048e5;
	            case 'day':
	                return days + milliseconds / 864e5;
	            case 'hour':
	                return days * 24 + milliseconds / 36e5;
	            case 'minute':
	                return days * 1440 + milliseconds / 6e4;
	            case 'second':
	                return days * 86400 + milliseconds / 1000;
	            // Math.floor prevents floating point math errors here
	            case 'millisecond':
	                return Math.floor(days * 864e5) + milliseconds;
	            default:
	                throw new Error('Unknown unit ' + units);
	        }
	    }
	}

	// TODO: Use this.as('ms')?
	function valueOf$3() {
	    if (!this.isValid()) {
	        return NaN;
	    }
	    return (
	        this._milliseconds +
	        this._days * 864e5 +
	        (this._months % 12) * 2592e6 +
	        toInt$1(this._months / 12) * 31536e6
	    );
	}

	function makeAs$1(alias) {
	    return function () {
	        return this.as(alias);
	    };
	}

	var asMilliseconds$1 = makeAs$1('ms'),
	    asSeconds$1 = makeAs$1('s'),
	    asMinutes$1 = makeAs$1('m'),
	    asHours$1 = makeAs$1('h'),
	    asDays$1 = makeAs$1('d'),
	    asWeeks$1 = makeAs$1('w'),
	    asMonths$1 = makeAs$1('M'),
	    asQuarters$1 = makeAs$1('Q'),
	    asYears$1 = makeAs$1('y');

	function clone$3() {
	    return createDuration$1(this);
	}

	function get$5(units) {
	    units = normalizeUnits$1(units);
	    return this.isValid() ? this[units + 's']() : NaN;
	}

	function makeGetter$1(name) {
	    return function () {
	        return this.isValid() ? this._data[name] : NaN;
	    };
	}

	var milliseconds$1 = makeGetter$1('milliseconds'),
	    seconds$1 = makeGetter$1('seconds'),
	    minutes$1 = makeGetter$1('minutes'),
	    hours$1 = makeGetter$1('hours'),
	    days$1 = makeGetter$1('days'),
	    months$1 = makeGetter$1('months'),
	    years$1 = makeGetter$1('years');

	function weeks$1() {
	    return absFloor$1(this.days() / 7);
	}

	var round$1 = Math.round,
	    thresholds$1 = {
	        ss: 44, // a few seconds to seconds
	        s: 45, // seconds to minute
	        m: 45, // minutes to hour
	        h: 22, // hours to day
	        d: 26, // days to month/week
	        w: null, // weeks to month
	        M: 11, // months to year
	    };

	// helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	function substituteTimeAgo$1(string, number, withoutSuffix, isFuture, locale) {
	    return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	}

	function relativeTime$3(posNegDuration, withoutSuffix, thresholds, locale) {
	    var duration = createDuration$1(posNegDuration).abs(),
	        seconds = round$1(duration.as('s')),
	        minutes = round$1(duration.as('m')),
	        hours = round$1(duration.as('h')),
	        days = round$1(duration.as('d')),
	        months = round$1(duration.as('M')),
	        weeks = round$1(duration.as('w')),
	        years = round$1(duration.as('y')),
	        a =
	            (seconds <= thresholds.ss && ['s', seconds]) ||
	            (seconds < thresholds.s && ['ss', seconds]) ||
	            (minutes <= 1 && ['m']) ||
	            (minutes < thresholds.m && ['mm', minutes]) ||
	            (hours <= 1 && ['h']) ||
	            (hours < thresholds.h && ['hh', hours]) ||
	            (days <= 1 && ['d']) ||
	            (days < thresholds.d && ['dd', days]);

	    if (thresholds.w != null) {
	        a =
	            a ||
	            (weeks <= 1 && ['w']) ||
	            (weeks < thresholds.w && ['ww', weeks]);
	    }
	    a = a ||
	        (months <= 1 && ['M']) ||
	        (months < thresholds.M && ['MM', months]) ||
	        (years <= 1 && ['y']) || ['yy', years];

	    a[2] = withoutSuffix;
	    a[3] = +posNegDuration > 0;
	    a[4] = locale;
	    return substituteTimeAgo$1.apply(null, a);
	}

	// This function allows you to set the rounding function for relative time strings
	function getSetRelativeTimeRounding$1(roundingFunction) {
	    if (roundingFunction === undefined) {
	        return round$1;
	    }
	    if (typeof roundingFunction === 'function') {
	        round$1 = roundingFunction;
	        return true;
	    }
	    return false;
	}

	// This function allows you to set a threshold for relative time strings
	function getSetRelativeTimeThreshold$1(threshold, limit) {
	    if (thresholds$1[threshold] === undefined) {
	        return false;
	    }
	    if (limit === undefined) {
	        return thresholds$1[threshold];
	    }
	    thresholds$1[threshold] = limit;
	    if (threshold === 's') {
	        thresholds$1.ss = limit - 1;
	    }
	    return true;
	}

	function humanize$1(argWithSuffix, argThresholds) {
	    if (!this.isValid()) {
	        return this.localeData().invalidDate();
	    }

	    var withSuffix = false,
	        th = thresholds$1,
	        locale,
	        output;

	    if (typeof argWithSuffix === 'object') {
	        argThresholds = argWithSuffix;
	        argWithSuffix = false;
	    }
	    if (typeof argWithSuffix === 'boolean') {
	        withSuffix = argWithSuffix;
	    }
	    if (typeof argThresholds === 'object') {
	        th = Object.assign({}, thresholds$1, argThresholds);
	        if (argThresholds.s != null && argThresholds.ss == null) {
	            th.ss = argThresholds.s - 1;
	        }
	    }

	    locale = this.localeData();
	    output = relativeTime$3(this, !withSuffix, th, locale);

	    if (withSuffix) {
	        output = locale.pastFuture(+this, output);
	    }

	    return locale.postformat(output);
	}

	var abs$3 = Math.abs;

	function sign$1(x) {
	    return (x > 0) - (x < 0) || +x;
	}

	function toISOString$3() {
	    // for ISO strings we do not use the normal bubbling rules:
	    //  * milliseconds bubble up until they become hours
	    //  * days do not bubble at all
	    //  * months bubble up until they become years
	    // This is because there is no context-free conversion between hours and days
	    // (think of clock changes)
	    // and also not between days and months (28-31 days per month)
	    if (!this.isValid()) {
	        return this.localeData().invalidDate();
	    }

	    var seconds = abs$3(this._milliseconds) / 1000,
	        days = abs$3(this._days),
	        months = abs$3(this._months),
	        minutes,
	        hours,
	        years,
	        s,
	        total = this.asSeconds(),
	        totalSign,
	        ymSign,
	        daysSign,
	        hmsSign;

	    if (!total) {
	        // this is the same as C#'s (Noda) and python (isodate)...
	        // but not other JS (goog.date)
	        return 'P0D';
	    }

	    // 3600 seconds -> 60 minutes -> 1 hour
	    minutes = absFloor$1(seconds / 60);
	    hours = absFloor$1(minutes / 60);
	    seconds %= 60;
	    minutes %= 60;

	    // 12 months -> 1 year
	    years = absFloor$1(months / 12);
	    months %= 12;

	    // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	    s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';

	    totalSign = total < 0 ? '-' : '';
	    ymSign = sign$1(this._months) !== sign$1(total) ? '-' : '';
	    daysSign = sign$1(this._days) !== sign$1(total) ? '-' : '';
	    hmsSign = sign$1(this._milliseconds) !== sign$1(total) ? '-' : '';

	    return (
	        totalSign +
	        'P' +
	        (years ? ymSign + years + 'Y' : '') +
	        (months ? ymSign + months + 'M' : '') +
	        (days ? daysSign + days + 'D' : '') +
	        (hours || minutes || seconds ? 'T' : '') +
	        (hours ? hmsSign + hours + 'H' : '') +
	        (minutes ? hmsSign + minutes + 'M' : '') +
	        (seconds ? hmsSign + s + 'S' : '')
	    );
	}

	var proto$5 = Duration$1.prototype;

	proto$5.isValid = isValid$4;
	proto$5.abs = abs$2;
	proto$5.add = add$5;
	proto$5.subtract = subtract$3;
	proto$5.as = as$1;
	proto$5.asMilliseconds = asMilliseconds$1;
	proto$5.asSeconds = asSeconds$1;
	proto$5.asMinutes = asMinutes$1;
	proto$5.asHours = asHours$1;
	proto$5.asDays = asDays$1;
	proto$5.asWeeks = asWeeks$1;
	proto$5.asMonths = asMonths$1;
	proto$5.asQuarters = asQuarters$1;
	proto$5.asYears = asYears$1;
	proto$5.valueOf = valueOf$3;
	proto$5._bubble = bubble$1;
	proto$5.clone = clone$3;
	proto$5.get = get$5;
	proto$5.milliseconds = milliseconds$1;
	proto$5.seconds = seconds$1;
	proto$5.minutes = minutes$1;
	proto$5.hours = hours$1;
	proto$5.days = days$1;
	proto$5.weeks = weeks$1;
	proto$5.months = months$1;
	proto$5.years = years$1;
	proto$5.humanize = humanize$1;
	proto$5.toISOString = toISOString$3;
	proto$5.toString = toISOString$3;
	proto$5.toJSON = toISOString$3;
	proto$5.locale = locale$1;
	proto$5.localeData = localeData$1;

	proto$5.toIsoString = deprecate$1(
	    'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
	    toISOString$3
	);
	proto$5.lang = lang$1;

	// Side effect imports

	// FORMATTING

	addFormatToken$1('X', 0, 0, 'unix');
	addFormatToken$1('x', 0, 0, 'valueOf');

	// PARSING

	addRegexToken$1('x', matchSigned$1);
	addRegexToken$1('X', matchTimestamp$1);
	addParseToken$1('X', function (input, array, config) {
	    config._d = new Date(parseFloat(input) * 1000);
	});
	addParseToken$1('x', function (input, array, config) {
	    config._d = new Date(toInt$1(input));
	});

	// Side effect imports

	//! moment.js

	hooks$2.version = '2.29.4';

	setHookCallback$1(createLocal$1);

	hooks$2.fn = proto$3;
	hooks$2.min = min$1;
	hooks$2.max = max$1;
	hooks$2.now = now$4;
	hooks$2.utc = createUTC$1;
	hooks$2.unix = createUnix$1;
	hooks$2.months = listMonths$1;
	hooks$2.isDate = isDate$1;
	hooks$2.locale = getSetGlobalLocale$1;
	hooks$2.invalid = createInvalid$2;
	hooks$2.duration = createDuration$1;
	hooks$2.isMoment = isMoment$1;
	hooks$2.weekdays = listWeekdays$1;
	hooks$2.parseZone = createInZone$1;
	hooks$2.localeData = getLocale$1;
	hooks$2.isDuration = isDuration$1;
	hooks$2.monthsShort = listMonthsShort$1;
	hooks$2.weekdaysMin = listWeekdaysMin$1;
	hooks$2.defineLocale = defineLocale$1;
	hooks$2.updateLocale = updateLocale$1;
	hooks$2.locales = listLocales$1;
	hooks$2.weekdaysShort = listWeekdaysShort$1;
	hooks$2.normalizeUnits = normalizeUnits$1;
	hooks$2.relativeTimeRounding = getSetRelativeTimeRounding$1;
	hooks$2.relativeTimeThreshold = getSetRelativeTimeThreshold$1;
	hooks$2.calendarFormat = getCalendarFormat$1;
	hooks$2.prototype = proto$3;

	// currently HTML5 input type only supports 24-hour formats
	hooks$2.HTML5_FMT = {
	    DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
	    DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
	    DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
	    DATE: 'YYYY-MM-DD', // <input type="date" />
	    TIME: 'HH:mm', // <input type="time" />
	    TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
	    TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
	    WEEK: 'GGGG-[W]WW', // <input type="week" />
	    MONTH: 'YYYY-MM', // <input type="month" />
	};

	//! moment.js locale configuration

	hooks$2.defineLocale('af', {
	    months: 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split(
	        '_'
	    ),
	    monthsShort: 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
	    weekdays: 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split(
	        '_'
	    ),
	    weekdaysShort: 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
	    weekdaysMin: 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
	    meridiemParse: /vm|nm/i,
	    isPM: function (input) {
	        return /^nm$/i.test(input);
	    },
	    meridiem: function (hours, minutes, isLower) {
	        if (hours < 12) {
	            return isLower ? 'vm' : 'VM';
	        } else {
	            return isLower ? 'nm' : 'NM';
	        }
	    },
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd, D MMMM YYYY HH:mm',
	    },
	    calendar: {
	        sameDay: '[Vandag om] LT',
	        nextDay: '[Môre om] LT',
	        nextWeek: 'dddd [om] LT',
	        lastDay: '[Gister om] LT',
	        lastWeek: '[Laas] dddd [om] LT',
	        sameElse: 'L',
	    },
	    relativeTime: {
	        future: 'oor %s',
	        past: '%s gelede',
	        s: "'n paar sekondes",
	        ss: '%d sekondes',
	        m: "'n minuut",
	        mm: '%d minute',
	        h: "'n uur",
	        hh: '%d ure',
	        d: "'n dag",
	        dd: '%d dae',
	        M: "'n maand",
	        MM: '%d maande',
	        y: "'n jaar",
	        yy: '%d jaar',
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	    ordinal: function (number) {
	        return (
	            number +
	            (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
	        ); // Thanks to Joris Röling : https://github.com/jjupiter
	    },
	    week: {
	        dow: 1, // Maandag is die eerste dag van die week.
	        doy: 4, // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
	    },
	});

	//! moment.js locale configuration

	var pluralForm = function (n) {
	        return n === 0
	            ? 0
	            : n === 1
	            ? 1
	            : n === 2
	            ? 2
	            : n % 100 >= 3 && n % 100 <= 10
	            ? 3
	            : n % 100 >= 11
	            ? 4
	            : 5;
	    },
	    plurals = {
	        s: [
	            'أقل من ثانية',
	            'ثانية واحدة',
	            ['ثانيتان', 'ثانيتين'],
	            '%d ثوان',
	            '%d ثانية',
	            '%d ثانية' ],
	        m: [
	            'أقل من دقيقة',
	            'دقيقة واحدة',
	            ['دقيقتان', 'دقيقتين'],
	            '%d دقائق',
	            '%d دقيقة',
	            '%d دقيقة' ],
	        h: [
	            'أقل من ساعة',
	            'ساعة واحدة',
	            ['ساعتان', 'ساعتين'],
	            '%d ساعات',
	            '%d ساعة',
	            '%d ساعة' ],
	        d: [
	            'أقل من يوم',
	            'يوم واحد',
	            ['يومان', 'يومين'],
	            '%d أيام',
	            '%d يومًا',
	            '%d يوم' ],
	        M: [
	            'أقل من شهر',
	            'شهر واحد',
	            ['شهران', 'شهرين'],
	            '%d أشهر',
	            '%d شهرا',
	            '%d شهر' ],
	        y: [
	            'أقل من عام',
	            'عام واحد',
	            ['عامان', 'عامين'],
	            '%d أعوام',
	            '%d عامًا',
	            '%d عام' ],
	    },
	    pluralize = function (u) {
	        return function (number, withoutSuffix, string, isFuture) {
	            var f = pluralForm(number),
	                str = plurals[u][pluralForm(number)];
	            if (f === 2) {
	                str = str[withoutSuffix ? 0 : 1];
	            }
	            return str.replace(/%d/i, number);
	        };
	    },
	    months$2 = [
	        'جانفي',
	        'فيفري',
	        'مارس',
	        'أفريل',
	        'ماي',
	        'جوان',
	        'جويلية',
	        'أوت',
	        'سبتمبر',
	        'أكتوبر',
	        'نوفمبر',
	        'ديسمبر' ];

	hooks$2.defineLocale('ar-dz', {
	    months: months$2,
	    monthsShort: months$2,
	    weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact: true,
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'D/\u200FM/\u200FYYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd D MMMM YYYY HH:mm',
	    },
	    meridiemParse: /ص|م/,
	    isPM: function (input) {
	        return 'م' === input;
	    },
	    meridiem: function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ص';
	        } else {
	            return 'م';
	        }
	    },
	    calendar: {
	        sameDay: '[اليوم عند الساعة] LT',
	        nextDay: '[غدًا عند الساعة] LT',
	        nextWeek: 'dddd [عند الساعة] LT',
	        lastDay: '[أمس عند الساعة] LT',
	        lastWeek: 'dddd [عند الساعة] LT',
	        sameElse: 'L',
	    },
	    relativeTime: {
	        future: 'بعد %s',
	        past: 'منذ %s',
	        s: pluralize('s'),
	        ss: pluralize('s'),
	        m: pluralize('m'),
	        mm: pluralize('m'),
	        h: pluralize('h'),
	        hh: pluralize('h'),
	        d: pluralize('d'),
	        dd: pluralize('d'),
	        M: pluralize('M'),
	        MM: pluralize('M'),
	        y: pluralize('y'),
	        yy: pluralize('y'),
	    },
	    postformat: function (string) {
	        return string.replace(/,/g, '،');
	    },
	    week: {
	        dow: 0, // Sunday is the first day of the week.
	        doy: 4, // The week that contains Jan 4th is the first week of the year.
	    },
	});

	//! moment.js locale configuration

	hooks$2.defineLocale('ar-kw', {
	    months: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
	        '_'
	    ),
	    monthsShort:
	        'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
	            '_'
	        ),
	    weekdays: 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort: 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact: true,
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd D MMMM YYYY HH:mm',
	    },
	    calendar: {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L',
	    },
	    relativeTime: {
	        future: 'في %s',
	        past: 'منذ %s',
	        s: 'ثوان',
	        ss: '%d ثانية',
	        m: 'دقيقة',
	        mm: '%d دقائق',
	        h: 'ساعة',
	        hh: '%d ساعات',
	        d: 'يوم',
	        dd: '%d أيام',
	        M: 'شهر',
	        MM: '%d أشهر',
	        y: 'سنة',
	        yy: '%d سنوات',
	    },
	    week: {
	        dow: 0, // Sunday is the first day of the week.
	        doy: 12, // The week that contains Jan 12th is the first week of the year.
	    },
	});

	//! moment.js locale configuration

	var symbolMap = {
	        1: '1',
	        2: '2',
	        3: '3',
	        4: '4',
	        5: '5',
	        6: '6',
	        7: '7',
	        8: '8',
	        9: '9',
	        0: '0',
	    },
	    pluralForm$1 = function (n) {
	        return n === 0
	            ? 0
	            : n === 1
	            ? 1
	            : n === 2
	            ? 2
	            : n % 100 >= 3 && n % 100 <= 10
	            ? 3
	            : n % 100 >= 11
	            ? 4
	            : 5;
	    },
	    plurals$1 = {
	        s: [
	            'أقل من ثانية',
	            'ثانية واحدة',
	            ['ثانيتان', 'ثانيتين'],
	            '%d ثوان',
	            '%d ثانية',
	            '%d ثانية' ],
	        m: [
	            'أقل من دقيقة',
	            'دقيقة واحدة',
	            ['دقيقتان', 'دقيقتين'],
	            '%d دقائق',
	            '%d دقيقة',
	            '%d دقيقة' ],
	        h: [
	            'أقل من ساعة',
	            'ساعة واحدة',
	            ['ساعتان', 'ساعتين'],
	            '%d ساعات',
	            '%d ساعة',
	            '%d ساعة' ],
	        d: [
	            'أقل من يوم',
	            'يوم واحد',
	            ['يومان', 'يومين'],
	            '%d أيام',
	            '%d يومًا',
	            '%d يوم' ],
	        M: [
	            'أقل من شهر',
	            'شهر واحد',
	            ['شهران', 'شهرين'],
	            '%d أشهر',
	            '%d شهرا',
	            '%d شهر' ],
	        y: [
	            'أقل من عام',
	            'عام واحد',
	            ['عامان', 'عامين'],
	            '%d أعوام',
	            '%d عامًا',
	            '%d عام' ],
	    },
	    pluralize$1 = function (u) {
	        return function (number, withoutSuffix, string, isFuture) {
	            var f = pluralForm$1(number),
	                str = plurals$1[u][pluralForm$1(number)];
	            if (f === 2) {
	                str = str[withoutSuffix ? 0 : 1];
	            }
	            return str.replace(/%d/i, number);
	        };
	    },
	    months$3 = [
	        'يناير',
	        'فبراير',
	        'مارس',
	        'أبريل',
	        'مايو',
	        'يونيو',
	        'يوليو',
	        'أغسطس',
	        'سبتمبر',
	        'أكتوبر',
	        'نوفمبر',
	        'ديسمبر' ];

	hooks$2.defineLocale('ar-ly', {
	    months: months$3,
	    monthsShort: months$3,
	    weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact: true,
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'D/\u200FM/\u200FYYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd D MMMM YYYY HH:mm',
	    },
	    meridiemParse: /ص|م/,
	    isPM: function (input) {
	        return 'م' === input;
	    },
	    meridiem: function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ص';
	        } else {
	            return 'م';
	        }
	    },
	    calendar: {
	        sameDay: '[اليوم عند الساعة] LT',
	        nextDay: '[غدًا عند الساعة] LT',
	        nextWeek: 'dddd [عند الساعة] LT',
	        lastDay: '[أمس عند الساعة] LT',
	        lastWeek: 'dddd [عند الساعة] LT',
	        sameElse: 'L',
	    },
	    relativeTime: {
	        future: 'بعد %s',
	        past: 'منذ %s',
	        s: pluralize$1('s'),
	        ss: pluralize$1('s'),
	        m: pluralize$1('m'),
	        mm: pluralize$1('m'),
	        h: pluralize$1('h'),
	        hh: pluralize$1('h'),
	        d: pluralize$1('d'),
	        dd: pluralize$1('d'),
	        M: pluralize$1('M'),
	        MM: pluralize$1('M'),
	        y: pluralize$1('y'),
	        yy: pluralize$1('y'),
	    },
	    preparse: function (string) {
	        return string.replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string
	            .replace(/\d/g, function (match) {
	                return symbolMap[match];
	            })
	            .replace(/,/g, '،');
	    },
	    week: {
	        dow: 6, // Saturday is the first day of the week.
	        doy: 12, // The week that contains Jan 12th is the first week of the year.
	    },
	});

	//! moment.js locale configuration

	hooks$2.defineLocale('ar-ma', {
	    months: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
	        '_'
	    ),
	    monthsShort:
	        'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
	            '_'
	        ),
	    weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort: 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact: true,
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd D MMMM YYYY HH:mm',
	    },
	    calendar: {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L',
	    },
	    relativeTime: {
	        future: 'في %s',
	        past: 'منذ %s',
	        s: 'ثوان',
	        ss: '%d ثانية',
	        m: 'دقيقة',
	        mm: '%d دقائق',
	        h: 'ساعة',
	        hh: '%d ساعات',
	        d: 'يوم',
	        dd: '%d أيام',
	        M: 'شهر',
	        MM: '%d أشهر',
	        y: 'سنة',
	        yy: '%d سنوات',
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4, // The week that contains Jan 4th is the first week of the year.
	    },
	});

	//! moment.js locale configuration

	var symbolMap$1 = {
	        1: '١',
	        2: '٢',
	        3: '٣',
	        4: '٤',
	        5: '٥',
	        6: '٦',
	        7: '٧',
	        8: '٨',
	        9: '٩',
	        0: '٠',
	    },
	    numberMap = {
	        '١': '1',
	        '٢': '2',
	        '٣': '3',
	        '٤': '4',
	        '٥': '5',
	        '٦': '6',
	        '٧': '7',
	        '٨': '8',
	        '٩': '9',
	        '٠': '0',
	    };

	hooks$2.defineLocale('ar-sa', {
	    months: 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
	        '_'
	    ),
	    monthsShort:
	        'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
	            '_'
	        ),
	    weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact: true,
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd D MMMM YYYY HH:mm',
	    },
	    meridiemParse: /ص|م/,
	    isPM: function (input) {
	        return 'م' === input;
	    },
	    meridiem: function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ص';
	        } else {
	            return 'م';
	        }
	    },
	    calendar: {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L',
	    },
	    relativeTime: {
	        future: 'في %s',
	        past: 'منذ %s',
	        s: 'ثوان',
	        ss: '%d ثانية',
	        m: 'دقيقة',
	        mm: '%d دقائق',
	        h: 'ساعة',
	        hh: '%d ساعات',
	        d: 'يوم',
	        dd: '%d أيام',
	        M: 'شهر',
	        MM: '%d أشهر',
	        y: 'سنة',
	        yy: '%d سنوات',
	    },
	    preparse: function (string) {
	        return string
	            .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                return numberMap[match];
	            })
	            .replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string
	            .replace(/\d/g, function (match) {
	                return symbolMap$1[match];
	            })
	            .replace(/,/g, '،');
	    },
	    week: {
	        dow: 0, // Sunday is the first day of the week.
	        doy: 6, // The week that contains Jan 6th is the first week of the year.
	    },
	});

	//! moment.js locale configuration

	hooks$2.defineLocale('ar-tn', {
	    months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
	        '_'
	    ),
	    monthsShort:
	        'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
	            '_'
	        ),
	    weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact: true,
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd D MMMM YYYY HH:mm',
	    },
	    calendar: {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L',
	    },
	    relativeTime: {
	        future: 'في %s',
	        past: 'منذ %s',
	        s: 'ثوان',
	        ss: '%d ثانية',
	        m: 'دقيقة',
	        mm: '%d دقائق',
	        h: 'ساعة',
	        hh: '%d ساعات',
	        d: 'يوم',
	        dd: '%d أيام',
	        M: 'شهر',
	        MM: '%d أشهر',
	        y: 'سنة',
	        yy: '%d سنوات',
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4, // The week that contains Jan 4th is the first week of the year.
	    },
	});

	//! moment.js locale configuration

	var symbolMap$2 = {
	        1: '١',
	        2: '٢',
	        3: '٣',
	        4: '٤',
	        5: '٥',
	        6: '٦',
	        7: '٧',
	        8: '٨',
	        9: '٩',
	        0: '٠',
	    },
	    numberMap$1 = {
	        '١': '1',
	        '٢': '2',
	        '٣': '3',
	        '٤': '4',
	        '٥': '5',
	        '٦': '6',
	        '٧': '7',
	        '٨': '8',
	        '٩': '9',
	        '٠': '0',
	    },
	    pluralForm$2 = function (n) {
	        return n === 0
	            ? 0
	            : n === 1
	            ? 1
	            : n === 2
	            ? 2
	            : n % 100 >= 3 && n % 100 <= 10
	            ? 3
	            : n % 100 >= 11
	            ? 4
	            : 5;
	    },
	    plurals$2 = {
	        s: [
	            'أقل من ثانية',
	            'ثانية واحدة',
	            ['ثانيتان', 'ثانيتين'],
	            '%d ثوان',
	            '%d ثانية',
	            '%d ثانية' ],
	        m: [
	            'أقل من دقيقة',
	            'دقيقة واحدة',
	            ['دقيقتان', 'دقيقتين'],
	            '%d دقائق',
	            '%d دقيقة',
	            '%d دقيقة' ],
	        h: [
	            'أقل من ساعة',
	            'ساعة واحدة',
	            ['ساعتان', 'ساعتين'],
	            '%d ساعات',
	            '%d ساعة',
	            '%d ساعة' ],
	        d: [
	            'أقل من يوم',
	            'يوم واحد',
	            ['يومان', 'يومين'],
	            '%d أيام',
	            '%d يومًا',
	            '%d يوم' ],
	        M: [
	            'أقل من شهر',
	            'شهر واحد',
	            ['شهران', 'شهرين'],
	            '%d أشهر',
	            '%d شهرا',
	            '%d شهر' ],
	        y: [
	            'أقل من عام',
	            'عام واحد',
	            ['عامان', 'عامين'],
	            '%d أعوام',
	            '%d عامًا',
	            '%d عام' ],
	    },
	    pluralize$2 = function (u) {
	        return function (number, withoutSuffix, string, isFuture) {
	            var f = pluralForm$2(number),
	                str = plurals$2[u][pluralForm$2(number)];
	            if (f === 2) {
	                str = str[withoutSuffix ? 0 : 1];
	            }
	            return str.replace(/%d/i, number);
	        };
	    },
	    months$4 = [
	        'يناير',
	        'فبراير',
	        'مارس',
	        'أبريل',
	        'مايو',
	        'يونيو',
	        'يوليو',
	        'أغسطس',
	        'سبتمبر',
	        'أكتوبر',
	        'نوفمبر',
	        'ديسمبر' ];

	hooks$2.defineLocale('ar', {
	    months: months$4,
	    monthsShort: months$4,
	    weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact: true,
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'D/\u200FM/\u200FYYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd D MMMM YYYY HH:mm',
	    },
	    meridiemParse: /ص|م/,
	    isPM: function (input) {
	        return 'م' === input;
	    },
	    meridiem: function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ص';
	        } else {
	            return 'م';
	        }
	    },
	    calendar: {
	        sameDay: '[اليوم عند الساعة] LT',
	        nextDay: '[غدًا عند الساعة] LT',
	        nextWeek: 'dddd [عند الساعة] LT',
	        lastDay: '[أمس عند الساعة] LT',
	        lastWeek: 'dddd [عند الساعة] LT',
	        sameElse: 'L',
	    },
	    relativeTime: {
	        future: 'بعد %s',
	        past: 'منذ %s',
	        s: pluralize$2('s'),
	        ss: pluralize$2('s'),
	        m: pluralize$2('m'),
	        mm: pluralize$2('m'),
	        h: pluralize$2('h'),
	        hh: pluralize$2('h'),
	        d: pluralize$2('d'),
	        dd: pluralize$2('d'),
	        M: pluralize$2('M'),
	        MM: pluralize$2('M'),
	        y: pluralize$2('y'),
	        yy: pluralize$2('y'),
	    },
	    preparse: function (string) {
	        return string
	            .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                return numberMap$1[match];
	            })
	            .replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string
	            .replace(/\d/g, function (match) {
	                return symbolMap$2[match];
	            })
	            .replace(/,/g, '،');
	    },
	    week: {
	        dow: 6, // Saturday is the first day of the week.
	        doy: 12, // The week that contains Jan 12th is the first week of the year.
	    },
	});

	//! moment.js locale configuration

	var suffixes = {
	    1: '-inci',
	    5: '-inci',
	    8: '-inci',
	    70: '-inci',
	    80: '-inci',
	    2: '-nci',
	    7: '-nci',
	    20: '-nci',
	    50: '-nci',
	    3: '-üncü',
	    4: '-üncü',
	    100: '-üncü',
	    6: '-ncı',
	    9: '-uncu',
	    10: '-uncu',
	    30: '-uncu',
	    60: '-ıncı',
	    90: '-ıncı',
	};

	hooks$2.defineLocale('az', {
	    months: 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split(
	        '_'
	    ),
	    monthsShort: 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
	    weekdays:
	        'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split(
	            '_'
	        ),
	    weekdaysShort: 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
	    weekdaysMin: 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
	    weekdaysParseExact: true,
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD.MM.YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd, D MMMM YYYY HH:mm',
	    },
	    calendar: {
	        sameDay: '[bugün saat] LT',
	        nextDay: '[sabah saat] LT',
	        nextWeek: '[gələn həftə] dddd [saat] LT',
	        lastDay: '[dünən] LT',
	        lastWeek: '[keçən həftə] dddd [saat] LT',
	        sameElse: 'L',
	    },
	    relativeTime: {
	        future: '%s sonra',
	        past: '%s əvvəl',
	        s: 'bir neçə saniyə',
	        ss: '%d saniyə',
	        m: 'bir dəqiqə',
	        mm: '%d dəqiqə',
	        h: 'bir saat',
	        hh: '%d saat',
	        d: 'bir gün',
	        dd: '%d gün',
	        M: 'bir ay',
	        MM: '%d ay',
	        y: 'bir il',
	        yy: '%d il',
	    },
	    meridiemParse: /gecə|səhər|gündüz|axşam/,
	    isPM: function (input) {
	        return /^(gündüz|axşam)$/.test(input);
	    },
	    meridiem: function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'gecə';
	        } else if (hour < 12) {
	            return 'səhər';
	        } else if (hour < 17) {
	            return 'gündüz';
	        } else {
	            return 'axşam';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
	    ordinal: function (number) {
	        if (number === 0) {
	            // special case for zero
	            return number + '-ıncı';
	        }
	        var a = number % 10,
	            b = (number % 100) - a,
	            c = number >= 100 ? 100 : null;
	        return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 7, // The week that contains Jan 7th is the first week of the year.
	    },
	});

	//! moment.js locale configuration

	function plural$1(word, num) {
	    var forms = word.split('_');
	    return num % 10 === 1 && num % 100 !== 11
	        ? forms[0]
	        : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
	        ? forms[1]
	        : forms[2];
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    var format = {
	        ss: withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
	        mm: withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
	        hh: withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
	        dd: 'дзень_дні_дзён',
	        MM: 'месяц_месяцы_месяцаў',
	        yy: 'год_гады_гадоў',
	    };
	    if (key === 'm') {
	        return withoutSuffix ? 'хвіліна' : 'хвіліну';
	    } else if (key === 'h') {
	        return withoutSuffix ? 'гадзіна' : 'гадзіну';
	    } else {
	        return number + ' ' + plural$1(format[key], +number);
	    }
	}

	hooks$2.defineLocale('be', {
	    months: {
	        format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split(
	            '_'
	        ),
	        standalone:
	            'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split(
	                '_'
	            ),
	    },
	    monthsShort:
	        'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
	    weekdays: {
	        format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split(
	            '_'
	        ),
	        standalone:
	            'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split(
	                '_'
	            ),
	        isFormat: /\[ ?[Ууў] ?(?:мінулую|наступную)? ?\] ?dddd/,
	    },
	    weekdaysShort: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	    weekdaysMin: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD.MM.YYYY',
	        LL: 'D MMMM YYYY г.',
	        LLL: 'D MMMM YYYY г., HH:mm',
	        LLLL: 'dddd, D MMMM YYYY г., HH:mm',
	    },
	    calendar: {
	        sameDay: '[Сёння ў] LT',
	        nextDay: '[Заўтра ў] LT',
	        lastDay: '[Учора ў] LT',
	        nextWeek: function () {
	            return '[У] dddd [ў] LT';
	        },
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 5:
	                case 6:
	                    return '[У мінулую] dddd [ў] LT';
	                case 1:
	                case 2:
	                case 4:
	                    return '[У мінулы] dddd [ў] LT';
	            }
	        },
	        sameElse: 'L',
	    },
	    relativeTime: {
	        future: 'праз %s',
	        past: '%s таму',
	        s: 'некалькі секунд',
	        m: relativeTimeWithPlural,
	        mm: relativeTimeWithPlural,
	        h: relativeTimeWithPlural,
	        hh: relativeTimeWithPlural,
	        d: 'дзень',
	        dd: relativeTimeWithPlural,
	        M: 'месяц',
	        MM: relativeTimeWithPlural,
	        y: 'год',
	        yy: relativeTimeWithPlural,
	    },
	    meridiemParse: /ночы|раніцы|дня|вечара/,
	    isPM: function (input) {
	        return /^(дня|вечара)$/.test(input);
	    },
	    meridiem: function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ночы';
	        } else if (hour < 12) {
	            return 'раніцы';
	        } else if (hour < 17) {
	            return 'дня';
	        } else {
	            return 'вечара';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'M':
	            case 'd':
	            case 'DDD':
	            case 'w':
	            case 'W':
	                return (number % 10 === 2 || number % 10 === 3) &&
	                    number % 100 !== 12 &&
	                    number % 100 !== 13
	                    ? number + '-і'
	                    : number + '-ы';
	            case 'D':
	                return number + '-га';
	            default:
	                return number;
	        }
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 7, // The week that contains Jan 7th is the first week of the year.
	    },
	});

	//! moment.js locale configuration

	hooks$2.defineLocale('bg', {
	    months: 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split(
	        '_'
	    ),
	    monthsShort: 'яну_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
	    weekdays: 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split(
	        '_'
	    ),
	    weekdaysShort: 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
	    weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	    longDateFormat: {
	        LT: 'H:mm',
	        LTS: 'H:mm:ss',
	        L: 'D.MM.YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY H:mm',
	        LLLL: 'dddd, D MMMM YYYY H:mm',
	    },
	    calendar: {
	        sameDay: '[Днес в] LT',
	        nextDay: '[Утре в] LT',
	        nextWeek: 'dddd [в] LT',
	        lastDay: '[Вчера в] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 6:
	                    return '[Миналата] dddd [в] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[Миналия] dddd [в] LT';
	            }
	        },
	        sameElse: 'L',
	    },
	    relativeTime: {
	        future: 'след %s',
	        past: 'преди %s',
	        s: 'няколко секунди',
	        ss: '%d секунди',
	        m: 'минута',
	        mm: '%d минути',
	        h: 'час',
	        hh: '%d часа',
	        d: 'ден',
	        dd: '%d дена',
	        w: 'седмица',
	        ww: '%d седмици',
	        M: 'месец',
	        MM: '%d месеца',
	        y: 'година',
	        yy: '%d години',
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	    ordinal: function (number) {
	        var lastDigit = number % 10,
	            last2Digits = number % 100;
	        if (number === 0) {
	            return number + '-ев';
	        } else if (last2Digits === 0) {
	            return number + '-ен';
	        } else if (last2Digits > 10 && last2Digits < 20) {
	            return number + '-ти';
	        } else if (lastDigit === 1) {
	            return number + '-ви';
	        } else if (lastDigit === 2) {
	            return number + '-ри';
	        } else if (lastDigit === 7 || lastDigit === 8) {
	            return number + '-ми';
	        } else {
	            return number + '-ти';
	        }
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 7, // The week that contains Jan 7th is the first week of the year.
	    },
	});

	//! moment.js locale configuration

	var symbolMap$3 = {
	        1: '১',
	        2: '২',
	        3: '৩',
	        4: '৪',
	        5: '৫',
	        6: '৬',
	        7: '৭',
	        8: '৮',
	        9: '৯',
	        0: '০',
	    },
	    numberMap$2 = {
	        '১': '1',
	        '২': '2',
	        '৩': '3',
	        '৪': '4',
	        '৫': '5',
	        '৬': '6',
	        '৭': '7',
	        '৮': '8',
	        '৯': '9',
	        '০': '0',
	    };

	hooks$2.defineLocale('bn', {
	    months: 'জানুয়ারি_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split(
	        '_'
	    ),
	    monthsShort:
	        'জানু_ফেব্রু_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্ট_অক্টো_নভে_ডিসে'.split(
	            '_'
	        ),
	    weekdays: 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split(
	        '_'
	    ),
	    weekdaysShort: 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
	    weekdaysMin: 'রবি_সোম_মঙ্গল_বুধ_বৃহ_শুক্র_শনি'.split('_'),
	    longDateFormat: {
	        LT: 'A h:mm সময়',
	        LTS: 'A h:mm:ss সময়',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY, A h:mm সময়',
	        LLLL: 'dddd, D MMMM YYYY, A h:mm সময়',
	    },
	    calendar: {
	        sameDay: '[আজ] LT',
	        nextDay: '[আগামীকাল] LT',
	        nextWeek: 'dddd, LT',
	        lastDay: '[গতকাল] LT',
	        lastWeek: '[গত] dddd, LT',
	        sameElse: 'L',
	    },
	    relativeTime: {
	        future: '%s পরে',
	        past: '%s আগে',
	        s: 'কয়েক সেকেন্ড',
	        ss: '%d সেকেন্ড',
	        m: 'এক মিনিট',
	        mm: '%d মিনিট',
	        h: 'এক ঘন্টা',
	        hh: '%d ঘন্টা',
	        d: 'এক দিন',
	        dd: '%d দিন',
	        M: 'এক মাস',
	        MM: '%d মাস',
	        y: 'এক বছর',
	        yy: '%d বছর',
	    },
	    preparse: function (string) {
	        return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
	            return numberMap$2[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap$3[match];
	        });
	    },
	    meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
	    meridiemHour: function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (
	            (meridiem === 'রাত' && hour >= 4) ||
	            (meridiem === 'দুপুর' && hour < 5) ||
	            meridiem === 'বিকাল'
	        ) {
	            return hour + 12;
	        } else {
	            return hour;
	        }
	    },
	    meridiem: function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'রাত';
	        } else if (hour < 10) {
	            return 'সকাল';
	        } else if (hour < 17) {
	            return 'দুপুর';
	        } else if (hour < 20) {
	            return 'বিকাল';
	        } else {
	            return 'রাত';
	        }
	    },
	    week: {
	        dow: 0, // Sunday is the first day of the week.
	        doy: 6, // The week that contains Jan 6th is the first week of the year.
	    },
	});

	//! moment.js locale configuration

	var symbolMap$4 = {
	        1: '༡',
	        2: '༢',
	        3: '༣',
	        4: '༤',
	        5: '༥',
	        6: '༦',
	        7: '༧',
	        8: '༨',
	        9: '༩',
	        0: '༠',
	    },
	    numberMap$3 = {
	        '༡': '1',
	        '༢': '2',
	        '༣': '3',
	        '༤': '4',
	        '༥': '5',
	        '༦': '6',
	        '༧': '7',
	        '༨': '8',
	        '༩': '9',
	        '༠': '0',
	    };

	hooks$2.defineLocale('bo', {
	    months: 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split(
	        '_'
	    ),
	    monthsShort:
	        'ཟླ་1_ཟླ་2_ཟླ་3_ཟླ་4_ཟླ་5_ཟླ་6_ཟླ་7_ཟླ་8_ཟླ་9_ཟླ་10_ཟླ་11_ཟླ་12'.split(
	            '_'
	        ),
	    monthsShortRegex: /^(ཟླ་\d{1,2})/,
	    monthsParseExact: true,
	    weekdays:
	        'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split(
	            '_'
	        ),
	    weekdaysShort: 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split(
	        '_'
	    ),
	    weekdaysMin: 'ཉི_ཟླ_མིག_ལྷག_ཕུར_སངས_སྤེན'.split('_'),
	    longDateFormat: {
	        LT: 'A h:mm',
	        LTS: 'A h:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY, A h:mm',
	        LLLL: 'dddd, D MMMM YYYY, A h:mm',
	    },
	    calendar: {
	        sameDay: '[དི་རིང] LT',
	        nextDay: '[སང་ཉིན] LT',
	        nextWeek: '[བདུན་ཕྲག་རྗེས་མ], LT',
	        lastDay: '[ཁ་སང] LT',
	        lastWeek: '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
	        sameElse: 'L',
	    },
	    relativeTime: {
	        future: '%s ལ་',
	        past: '%s སྔན་ལ',
	        s: 'ལམ་སང',
	        ss: '%d སྐར་ཆ།',
	        m: 'སྐར་མ་གཅིག',
	        mm: '%d སྐར་མ',
	        h: 'ཆུ་ཚོད་གཅིག',
	        hh: '%d ཆུ་ཚོད',
	        d: 'ཉིན་གཅིག',
	        dd: '%d ཉིན་',
	        M: 'ཟླ་བ་གཅིག',
	        MM: '%d ཟླ་བ',
	        y: 'ལོ་གཅིག',
	        yy: '%d ལོ',
	    },
	    preparse: function (string) {
	        return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
	            return numberMap$3[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap$4[match];
	        });
	    },
	    meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
	    meridiemHour: function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (
	            (meridiem === 'མཚན་མོ' && hour >= 4) ||
	            (meridiem === 'ཉིན་གུང' && hour < 5) ||
	            meridiem === 'དགོང་དག'
	        ) {
	            return hour + 12;
	        } else {
	            return hour;
	        }
	    },
	    meridiem: function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'མཚན་མོ';
	        } else if (hour < 10) {
	            return 'ཞོགས་ཀས';
	        } else if (hour < 17) {
	            return 'ཉིན་གུང';
	        } else if (hour < 20) {
	            return 'དགོང་དག';
	        } else {
	            return 'མཚན་མོ';
	        }
	    },
	    week: {
	        dow: 0, // Sunday is the first day of the week.
	        doy: 6, // The week that contains Jan 6th is the first week of the year.
	    },
	});

	//! moment.js locale configuration

	function relativeTimeWithMutation(number, withoutSuffix, key) {
	    var format = {
	        mm: 'munutenn',
	        MM: 'miz',
	        dd: 'devezh',
	    };
	    return number + ' ' + mutation(format[key], number);
	}
	function specialMutationForYears(number) {
	    switch (lastNumber(number)) {
	        case 1:
	        case 3:
	        case 4:
	        case 5:
	        case 9:
	            return number + ' bloaz';
	        default:
	            return number + ' vloaz';
	    }
	}
	function lastNumber(number) {
	    if (number > 9) {
	        return lastNumber(number % 10);
	    }
	    return number;
	}
	function mutation(text, number) {
	    if (number === 2) {
	        return softMutation(text);
	    }
	    return text;
	}
	function softMutation(text) {
	    var mutationTable = {
	        m: 'v',
	        b: 'v',
	        d: 'z',
	    };
	    if (mutationTable[text.charAt(0)] === undefined) {
	        return text;
	    }
	    return mutationTable[text.charAt(0)] + text.substring(1);
	}

	var monthsParse = [
	        /^gen/i,
	        /^c[ʼ\']hwe/i,
	        /^meu/i,
	        /^ebr/i,
	        /^mae/i,
	        /^(mez|eve)/i,
	        /^gou/i,
	        /^eos/i,
	        /^gwe/i,
	        /^her/i,
	        /^du/i,
	        /^ker/i ],
	    monthsRegex$2 =
	        /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu|gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,
	    monthsStrictRegex =
	        /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu)/i,
	    monthsShortStrictRegex =
	        /^(gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,
	    fullWeekdaysParse = [
	        /^sul/i,
	        /^lun/i,
	        /^meurzh/i,
	        /^merc[ʼ\']her/i,
	        /^yaou/i,
	        /^gwener/i,
	        /^sadorn/i ],
	    shortWeekdaysParse = [
	        /^Sul/i,
	        /^Lun/i,
	        /^Meu/i,
	        /^Mer/i,
	        /^Yao/i,
	        /^Gwe/i,
	        /^Sad/i ],
	    minWeekdaysParse = [
	        /^Su/i,
	        /^Lu/i,
	        /^Me([^r]|$)/i,
	        /^Mer/i,
	        /^Ya/i,
	        /^Gw/i,
	        /^Sa/i ];

	hooks$2.defineLocale('br', {
	    months: 'Genver_Cʼhwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split(
	        '_'
	    ),
	    monthsShort: 'Gen_Cʼhwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
	    weekdays: 'Sul_Lun_Meurzh_Mercʼher_Yaou_Gwener_Sadorn'.split('_'),
	    weekdaysShort: 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
	    weekdaysMin: 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
	    weekdaysParse: minWeekdaysParse,
	    fullWeekdaysParse: fullWeekdaysParse,
	    shortWeekdaysParse: shortWeekdaysParse,
	    minWeekdaysParse: minWeekdaysParse,

	    monthsRegex: monthsRegex$2,
	    monthsShortRegex: monthsRegex$2,
	    monthsStrictRegex: monthsStrictRegex,
	    monthsShortStrictRegex: monthsShortStrictRegex,
	    monthsParse: monthsParse,
	    longMonthsParse: monthsParse,
	    shortMonthsParse: monthsParse,

	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D [a viz] MMMM YYYY',
	        LLL: 'D [a viz] MMMM YYYY HH:mm',
	        LLLL: 'dddd, D [a viz] MMMM YYYY HH:mm',
	    },
	    calendar: {
	        sameDay: '[Hiziv da] LT',
	        nextDay: '[Warcʼhoazh da] LT',
	        nextWeek: 'dddd [da] LT',
	        lastDay: '[Decʼh da] LT',
	        lastWeek: 'dddd [paset da] LT',
	        sameElse: 'L',
	    },
	    relativeTime: {
	        future: 'a-benn %s',
	        past: '%s ʼzo',
	        s: 'un nebeud segondennoù',
	        ss: '%d eilenn',
	        m: 'ur vunutenn',
	        mm: relativeTimeWithMutation,
	        h: 'un eur',
	        hh: '%d eur',
	        d: 'un devezh',
	        dd: relativeTimeWithMutation,
	        M: 'ur miz',
	        MM: relativeTimeWithMutation,
	        y: 'ur bloaz',
	        yy: specialMutationForYears,
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
	    ordinal: function (number) {
	        var output = number === 1 ? 'añ' : 'vet';
	        return number + output;
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4, // The week that contains Jan 4th is the first week of the year.
	    },
	    meridiemParse: /a.m.|g.m./, // goude merenn | a-raok merenn
	    isPM: function (token) {
	        return token === 'g.m.';
	    },
	    meridiem: function (hour, minute, isLower) {
	        return hour < 12 ? 'a.m.' : 'g.m.';
	    },
	});

	//! moment.js locale configuration

	function translate$1(number, withoutSuffix, key) {
	    var result = number + ' ';
	    switch (key) {
	        case 'ss':
	            if (number === 1) {
	                result += 'sekunda';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'sekunde';
	            } else {
	                result += 'sekundi';
	            }
	            return result;
	        case 'm':
	            return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	        case 'mm':
	            if (number === 1) {
	                result += 'minuta';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'minute';
	            } else {
	                result += 'minuta';
	            }
	            return result;
	        case 'h':
	            return withoutSuffix ? 'jedan sat' : 'jednog sata';
	        case 'hh':
	            if (number === 1) {
	                result += 'sat';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'sata';
	            } else {
	                result += 'sati';
	            }
	            return result;
	        case 'dd':
	            if (number === 1) {
	                result += 'dan';
	            } else {
	                result += 'dana';
	            }
	            return result;
	        case 'MM':
	            if (number === 1) {
	                result += 'mjesec';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'mjeseca';
	            } else {
	                result += 'mjeseci';
	            }
	            return result;
	        case 'yy':
	            if (number === 1) {
	                result += 'godina';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'godine';
	            } else {
	                result += 'godina';
	            }
	            return result;
	    }
	}

	hooks$2.defineLocale('bs', {
	    months: 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split(
	        '_'
	    ),
	    monthsShort:
	        'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split(
	            '_'
	        ),
	    monthsParseExact: true,
	    weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
	        '_'
	    ),
	    weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	    weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact: true,
	    longDateFormat: {
	        LT: 'H:mm',
	        LTS: 'H:mm:ss',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm',
	        LLLL: 'dddd, D. MMMM YYYY H:mm',
	    },
	    calendar: {
	        sameDay: '[danas u] LT',
	        nextDay: '[sutra u] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedjelju] [u] LT';
	                case 3:
	                    return '[u] [srijedu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay: '[jučer u] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                    return '[prošlu] dddd [u] LT';
	                case 6:
	                    return '[prošle] [subote] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[prošli] dddd [u] LT';
	            }
	        },
	        sameElse: 'L',
	    },
	    relativeTime: {
	        future: 'za %s',
	        past: 'prije %s',
	        s: 'par sekundi',
	        ss: translate$1,
	        m: translate$1,
	        mm: translate$1,
	        h: translate$1,
	        hh: translate$1,
	        d: 'dan',
	        dd: translate$1,
	        M: 'mjesec',
	        MM: translate$1,
	        y: 'godinu',
	        yy: translate$1,
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal: '%d.',
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 7, // The week that contains Jan 7th is the first week of the year.
	    },
	});

	//! moment.js locale configuration

	hooks$2.defineLocale('ca', {
	    months: {
	        standalone:
	            'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split(
	                '_'
	            ),
	        format: "de gener_de febrer_de març_d'abril_de maig_de juny_de juliol_d'agost_de setembre_d'octubre_de novembre_de desembre".split(
	            '_'
	        ),
	        isFormat: /D[oD]?(\s)+MMMM/,
	    },
	    monthsShort:
	        'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split(
	            '_'
	        ),
	    monthsParseExact: true,
	    weekdays:
	        'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split(
	            '_'
	        ),
	    weekdaysShort: 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
	    weekdaysMin: 'dg_dl_dt_dc_dj_dv_ds'.split('_'),
	    weekdaysParseExact: true,
	    longDateFormat: {
	        LT: 'H:mm',
	        LTS: 'H:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM [de] YYYY',
	        ll: 'D MMM YYYY',
	        LLL: 'D MMMM [de] YYYY [a les] H:mm',
	        lll: 'D MMM YYYY, H:mm',
	        LLLL: 'dddd D MMMM [de] YYYY [a les] H:mm',
	        llll: 'ddd D MMM YYYY, H:mm',
	    },
	    calendar: {
	        sameDay: function () {
	            return '[avui a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	        },
	        nextDay: function () {
	            return '[demà a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	        },
	        nextWeek: function () {
	            return 'dddd [a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	        },
	        lastDay: function () {
	            return '[ahir a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	        },
	        lastWeek: function () {
	            return (
	                '[el] dddd [passat a ' +
	                (this.hours() !== 1 ? 'les' : 'la') +
	                '] LT'
	            );
	        },
	        sameElse: 'L',
	    },
	    relativeTime: {
	        future: "d'aquí %s",
	        past: 'fa %s',
	        s: 'uns segons',
	        ss: '%d segons',
	        m: 'un minut',
	        mm: '%d minuts',
	        h: 'una hora',
	        hh: '%d hores',
	        d: 'un dia',
	        dd: '%d dies',
	        M: 'un mes',
	        MM: '%d mesos',
	        y: 'un any',
	        yy: '%d anys',
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
	    ordinal: function (number, period) {
	        var output =
	            number === 1
	                ? 'r'
	                : number === 2
	                ? 'n'
	                : number === 3
	                ? 'r'
	                : number === 4
	                ? 't'
	                : 'è';
	        if (period === 'w' || period === 'W') {
	            output = 'a';
	        }
	        return number + output;
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4, // The week that contains Jan 4th is the first week of the year.
	    },
	});

	//! moment.js locale configuration

	var months$5 = {
	        format: 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split(
	            '_'
	        ),
	        standalone:
	            'ledna_února_března_dubna_května_června_července_srpna_září_října_listopadu_prosince'.split(
	                '_'
	            ),
	    },
	    monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_'),
	    monthsParse$1 = [
	        /^led/i,
	        /^úno/i,
	        /^bře/i,
	        /^dub/i,
	        /^kvě/i,
	        /^(čvn|červen$|června)/i,
	        /^(čvc|červenec|července)/i,
	        /^srp/i,
	        /^zář/i,
	        /^říj/i,
	        /^lis/i,
	        /^pro/i ],
	    // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
	    // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
	    monthsRegex$3 =
	        /^(leden|únor|březen|duben|květen|červenec|července|červen|června|srpen|září|říjen|listopad|prosinec|led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i;

	function plural$2(n) {
	    return n > 1 && n < 5 && ~~(n / 10) !== 1;
	}
	function translate$2(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's': // a few seconds / in a few seconds / a few seconds ago
	            return withoutSuffix || isFuture ? 'pár sekund' : 'pár sekundami';
	        case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural$2(number) ? 'sekundy' : 'sekund');
	            } else {
	                return result + 'sekundami';
	            }
	        case 'm': // a minute / in a minute / a minute ago
	            return withoutSuffix ? 'minuta' : isFuture ? 'minutu' : 'minutou';
	        case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural$2(number) ? 'minuty' : 'minut');
	            } else {
	                return result + 'minutami';
	            }
	        case 'h': // an hour / in an hour / an hour ago
	            return withoutSuffix ? 'hodina' : isFuture ? 'hodinu' : 'hodinou';
	        case 'hh': // 9 hours / in 9 hours / 9 hours ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural$2(number) ? 'hodiny' : 'hodin');
	            } else {
	                return result + 'hodinami';
	            }
	        case 'd': // a day / in a day / a day ago
	            return withoutSuffix || isFuture ? 'den' : 'dnem';
	        case 'dd': // 9 days / in 9 days / 9 days ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural$2(number) ? 'dny' : 'dní');
	            } else {
	                return result + 'dny';
	            }
	        case 'M': // a month / in a month / a month ago
	            return withoutSuffix || isFuture ? 'měsíc' : 'měsícem';
	        case 'MM': // 9 months / in 9 months / 9 months ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural$2(number) ? 'měsíce' : 'měsíců');
	            } else {
	                return result + 'měsíci';
	            }
	        case 'y': // a year / in a year / a year ago
	            return withoutSuffix || isFuture ? 'rok' : 'rokem';
	        case 'yy': // 9 years / in 9 years / 9 years ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural$2(number) ? 'roky' : 'let');
	            } else {
	                return result + 'lety';
	            }
	    }
	}

	hooks$2.defineLocale('cs', {
	    months: months$5,
	    monthsShort: monthsShort,
	    monthsRegex: monthsRegex$3,
	    monthsShortRegex: monthsRegex$3,
	    // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
	    // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
	    monthsStrictRegex:
	        /^(leden|ledna|února|únor|březen|března|duben|dubna|květen|května|červenec|července|červen|června|srpen|srpna|září|říjen|října|listopadu|listopad|prosinec|prosince)/i,
	    monthsShortStrictRegex:
	        /^(led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i,
	    monthsParse: monthsParse$1,
	    longMonthsParse: monthsParse$1,
	    shortMonthsParse: monthsParse$1,
	    weekdays: 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
	    weekdaysShort: 'ne_po_út_st_čt_pá_so'.split('_'),
	    weekdaysMin: 'ne_po_út_st_čt_pá_so'.split('_'),
	    longDateFormat: {
	        LT: 'H:mm',
	        LTS: 'H:mm:ss',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm',
	        LLLL: 'dddd D. MMMM YYYY H:mm',
	        l: 'D. M. YYYY',
	    },
	    calendar: {
	        sameDay: '[dnes v] LT',
	        nextDay: '[zítra v] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[v neděli v] LT';
	                case 1:
	                case 2:
	                    return '[v] dddd [v] LT';
	                case 3:
	                    return '[ve středu v] LT';
	                case 4:
	                    return '[ve čtvrtek v] LT';
	                case 5:
	                    return '[v pátek v] LT';
	                case 6:
	                    return '[v sobotu v] LT';
	            }
	        },
	        lastDay: '[včera v] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[minulou neděli v] LT';
	                case 1:
	                case 2:
	                    return '[minulé] dddd [v] LT';
	                case 3:
	                    return '[minulou středu v] LT';
	                case 4:
	                case 5:
	                    return '[minulý] dddd [v] LT';
	                case 6:
	                    return '[minulou sobotu v] LT';
	            }
	        },
	        sameElse: 'L',
	    },
	    relativeTime: {
	        future: 'za %s',
	        past: 'před %s',
	        s: translate$2,
	        ss: translate$2,
	        m: translate$2,
	        mm: translate$2,
	        h: translate$2,
	        hh: translate$2,
	        d: translate$2,
	        dd: translate$2,
	        M: translate$2,
	        MM: translate$2,
	        y: translate$2,
	        yy: translate$2,
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal: '%d.',
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4, // The week that contains Jan 4th is the first week of the year.
	    },
	});

	//! moment.js locale configuration

	hooks$2.defineLocale('cv', {
	    months: 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split(
	        '_'
	    ),
	    monthsShort: 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
	    weekdays:
	        'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split(
	            '_'
	        ),
	    weekdaysShort: 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
	    weekdaysMin: 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD-MM-YYYY',
	        LL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
	        LLL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	        LLLL: 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	    },
	    calendar: {
	        sameDay: '[Паян] LT [сехетре]',
	        nextDay: '[Ыран] LT [сехетре]',
	        lastDay: '[Ӗнер] LT [сехетре]',
	        nextWeek: '[Ҫитес] dddd LT [сехетре]',
	        lastWeek: '[Иртнӗ] dddd LT [сехетре]',
	        sameElse: 'L',
	    },
	    relativeTime: {
	        future: function (output) {
	            var affix = /сехет$/i.exec(output)
	                ? 'рен'
	                : /ҫул$/i.exec(output)
	                ? 'тан'
	                : 'ран';
	            return output + affix;
	        },
	        past: '%s каялла',
	        s: 'пӗр-ик ҫеккунт',
	        ss: '%d ҫеккунт',
	        m: 'пӗр минут',
	        mm: '%d минут',
	        h: 'пӗр сехет',
	        hh: '%d сехет',
	        d: 'пӗр кун',
	        dd: '%d кун',
	        M: 'пӗр уйӑх',
	        MM: '%d уйӑх',
	        y: 'пӗр ҫул',
	        yy: '%d ҫул',
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
	    ordinal: '%d-мӗш',
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 7, // The week that contains Jan 7th is the first week of the year.
	    },
	});

	//! moment.js locale configuration

	hooks$2.defineLocale('cy', {
	    months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split(
	        '_'
	    ),
	    monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split(
	        '_'
	    ),
	    weekdays:
	        'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split(
	            '_'
	        ),
	    weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
	    weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
	    weekdaysParseExact: true,
	    // time formats are the same as en-gb
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd, D MMMM YYYY HH:mm',
	    },
	    calendar: {
	        sameDay: '[Heddiw am] LT',
	        nextDay: '[Yfory am] LT',
	        nextWeek: 'dddd [am] LT',
	        lastDay: '[Ddoe am] LT',
	        lastWeek: 'dddd [diwethaf am] LT',
	        sameElse: 'L',
	    },
	    relativeTime: {
	        future: 'mewn %s',
	        past: '%s yn ôl',
	        s: 'ychydig eiliadau',
	        ss: '%d eiliad',
	        m: 'munud',
	        mm: '%d munud',
	        h: 'awr',
	        hh: '%d awr',
	        d: 'diwrnod',
	        dd: '%d diwrnod',
	        M: 'mis',
	        MM: '%d mis',
	        y: 'blwyddyn',
	        yy: '%d flynedd',
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
	    // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
	    ordinal: function (number) {
	        var b = number,
	            output = '',
	            lookup = [
	                '',
	                'af',
	                'il',
	                'ydd',
	                'ydd',
	                'ed',
	                'ed',
	                'ed',
	                'fed',
	                'fed',
	                'fed', // 1af to 10fed
	                'eg',
	                'fed',
	                'eg',
	                'eg',
	                'fed',
	                'eg',
	                'eg',
	                'fed',
	                'eg',
	                'fed' ];
	        if (b > 20) {
	            if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
	                output = 'fed'; // not 30ain, 70ain or 90ain
	            } else {
	                output = 'ain';
	            }
	        } else if (b > 0) {
	            output = lookup[b];
	        }
	        return number + output;
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4, // The week that contains Jan 4th is the first week of the year.
	    },
	});

	//! moment.js locale configuration

	hooks$2.defineLocale('da', {
	    months: 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split(
	        '_'
	    ),
	    monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	    weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	    weekdaysShort: 'søn_man_tir_ons_tor_fre_lør'.split('_'),
	    weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY HH:mm',
	        LLLL: 'dddd [d.] D. MMMM YYYY [kl.] HH:mm',
	    },
	    calendar: {
	        sameDay: '[i dag kl.] LT',
	        nextDay: '[i morgen kl.] LT',
	        nextWeek: 'på dddd [kl.] LT',
	        lastDay: '[i går kl.] LT',
	        lastWeek: '[i] dddd[s kl.] LT',
	        sameElse: 'L',
	    },
	    relativeTime: {
	        future: 'om %s',
	        past: '%s siden',
	        s: 'få sekunder',
	        ss: '%d sekunder',
	        m: 'et minut',
	        mm: '%d minutter',
	        h: 'en time',
	        hh: '%d timer',
	        d: 'en dag',
	        dd: '%d dage',
	        M: 'en måned',
	        MM: '%d måneder',
	        y: 'et år',
	        yy: '%d år',
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal: '%d.',
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4, // The week that contains Jan 4th is the first week of the year.
	    },
	});

	//! moment.js locale configuration

	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        m: ['eine Minute', 'einer Minute'],
	        h: ['eine Stunde', 'einer Stunde'],
	        d: ['ein Tag', 'einem Tag'],
	        dd: [number + ' Tage', number + ' Tagen'],
	        w: ['eine Woche', 'einer Woche'],
	        M: ['ein Monat', 'einem Monat'],
	        MM: [number + ' Monate', number + ' Monaten'],
	        y: ['ein Jahr', 'einem Jahr'],
	        yy: [number + ' Jahre', number + ' Jahren'],
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}

	hooks$2.defineLocale('de-at', {
	    months: 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
	        '_'
	    ),
	    monthsShort:
	        'Jän._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact: true,
	    weekdays:
	        'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
	            '_'
	        ),
	    weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	    weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact: true,
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY HH:mm',
	        LLLL: 'dddd, D. MMMM YYYY HH:mm',
	    },
	    calendar: {
	        sameDay: '[heute um] LT [Uhr]',
	        sameElse: 'L',
	        nextDay: '[morgen um] LT [Uhr]',
	        nextWeek: 'dddd [um] LT [Uhr]',
	        lastDay: '[gestern um] LT [Uhr]',
	        lastWeek: '[letzten] dddd [um] LT [Uhr]',
	    },
	    relativeTime: {
	        future: 'in %s',
	        past: 'vor %s',
	        s: 'ein paar Sekunden',
	        ss: '%d Sekunden',
	        m: processRelativeTime,
	        mm: '%d Minuten',
	        h: processRelativeTime,
	        hh: '%d Stunden',
	        d: processRelativeTime,
	        dd: processRelativeTime,
	        w: processRelativeTime,
	        ww: '%d Wochen',
	        M: processRelativeTime,
	        MM: processRelativeTime,
	        y: processRelativeTime,
	        yy: processRelativeTime,
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal: '%d.',
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4, // The week that contains Jan 4th is the first week of the year.
	    },
	});

	//! moment.js locale configuration

	function processRelativeTime$1(number, withoutSuffix, key, isFuture) {
	    var format = {
	        m: ['eine Minute', 'einer Minute'],
	        h: ['eine Stunde', 'einer Stunde'],
	        d: ['ein Tag', 'einem Tag'],
	        dd: [number + ' Tage', number + ' Tagen'],
	        w: ['eine Woche', 'einer Woche'],
	        M: ['ein Monat', 'einem Monat'],
	        MM: [number + ' Monate', number + ' Monaten'],
	        y: ['ein Jahr', 'einem Jahr'],
	        yy: [number + ' Jahre', number + ' Jahren'],
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}

	hooks$2.defineLocale('de-ch', {
	    months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
	        '_'
	    ),
	    monthsShort:
	        'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact: true,
	    weekdays:
	        'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
	            '_'
	        ),
	    weekdaysShort: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	    weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact: true,
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY HH:mm',
	        LLLL: 'dddd, D. MMMM YYYY HH:mm',
	    },
	    calendar: {
	        sameDay: '[heute um] LT [Uhr]',
	        sameElse: 'L',
	        nextDay: '[morgen um] LT [Uhr]',
	        nextWeek: 'dddd [um] LT [Uhr]',
	        lastDay: '[gestern um] LT [Uhr]',
	        lastWeek: '[letzten] dddd [um] LT [Uhr]',
	    },
	    relativeTime: {
	        future: 'in %s',
	        past: 'vor %s',
	        s: 'ein paar Sekunden',
	        ss: '%d Sekunden',
	        m: processRelativeTime$1,
	        mm: '%d Minuten',
	        h: processRelativeTime$1,
	        hh: '%d Stunden',
	        d: processRelativeTime$1,
	        dd: processRelativeTime$1,
	        w: processRelativeTime$1,
	        ww: '%d Wochen',
	        M: processRelativeTime$1,
	        MM: processRelativeTime$1,
	        y: processRelativeTime$1,
	        yy: processRelativeTime$1,
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal: '%d.',
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4, // The week that contains Jan 4th is the first week of the year.
	    },
	});

	//! moment.js locale configuration

	function processRelativeTime$2(number, withoutSuffix, key, isFuture) {
	    var format = {
	        m: ['eine Minute', 'einer Minute'],
	        h: ['eine Stunde', 'einer Stunde'],
	        d: ['ein Tag', 'einem Tag'],
	        dd: [number + ' Tage', number + ' Tagen'],
	        w: ['eine Woche', 'einer Woche'],
	        M: ['ein Monat', 'einem Monat'],
	        MM: [number + ' Monate', number + ' Monaten'],
	        y: ['ein Jahr', 'einem Jahr'],
	        yy: [number + ' Jahre', number + ' Jahren'],
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}

	hooks$2.defineLocale('de', {
	    months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
	        '_'
	    ),
	    monthsShort:
	        'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact: true,
	    weekdays:
	        'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
	            '_'
	        ),
	    weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	    weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact: true,
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY HH:mm',
	        LLLL: 'dddd, D. MMMM YYYY HH:mm',
	    },
	    calendar: {
	        sameDay: '[heute um] LT [Uhr]',
	        sameElse: 'L',
	        nextDay: '[morgen um] LT [Uhr]',
	        nextWeek: 'dddd [um] LT [Uhr]',
	        lastDay: '[gestern um] LT [Uhr]',
	        lastWeek: '[letzten] dddd [um] LT [Uhr]',
	    },
	    relativeTime: {
	        future: 'in %s',
	        past: 'vor %s',
	        s: 'ein paar Sekunden',
	        ss: '%d Sekunden',
	        m: processRelativeTime$2,
	        mm: '%d Minuten',
	        h: processRelativeTime$2,
	        hh: '%d Stunden',
	        d: processRelativeTime$2,
	        dd: processRelativeTime$2,
	        w: processRelativeTime$2,
	        ww: '%d Wochen',
	        M: processRelativeTime$2,
	        MM: processRelativeTime$2,
	        y: processRelativeTime$2,
	        yy: processRelativeTime$2,
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal: '%d.',
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4, // The week that contains Jan 4th is the first week of the year.
	    },
	});

	//! moment.js locale configuration

	var months$6 = [
	        'ޖެނުއަރީ',
	        'ފެބްރުއަރީ',
	        'މާރިޗު',
	        'އޭޕްރީލު',
	        'މޭ',
	        'ޖޫން',
	        'ޖުލައި',
	        'އޯގަސްޓު',
	        'ސެޕްޓެމްބަރު',
	        'އޮކްޓޯބަރު',
	        'ނޮވެމްބަރު',
	        'ޑިސެމްބަރު' ],
	    weekdays = [
	        'އާދިއްތަ',
	        'ހޯމަ',
	        'އަންގާރަ',
	        'ބުދަ',
	        'ބުރާސްފަތި',
	        'ހުކުރު',
	        'ހޮނިހިރު' ];

	hooks$2.defineLocale('dv', {
	    months: months$6,
	    monthsShort: months$6,
	    weekdays: weekdays,
	    weekdaysShort: weekdays,
	    weekdaysMin: 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'D/M/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd D MMMM YYYY HH:mm',
	    },
	    meridiemParse: /މކ|މފ/,
	    isPM: function (input) {
	        return 'މފ' === input;
	    },
	    meridiem: function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'މކ';
	        } else {
	            return 'މފ';
	        }
	    },
	    calendar: {
	        sameDay: '[މިއަދު] LT',
	        nextDay: '[މާދަމާ] LT',
	        nextWeek: 'dddd LT',
	        lastDay: '[އިއްޔެ] LT',
	        lastWeek: '[ފާއިތުވި] dddd LT',
	        sameElse: 'L',
	    },
	    relativeTime: {
	        future: 'ތެރޭގައި %s',
	        past: 'ކުރިން %s',
	        s: 'ސިކުންތުކޮޅެއް',
	        ss: 'd% ސިކުންތު',
	        m: 'މިނިޓެއް',
	        mm: 'މިނިޓު %d',
	        h: 'ގަޑިއިރެއް',
	        hh: 'ގަޑިއިރު %d',
	        d: 'ދުވަހެއް',
	        dd: 'ދުވަސް %d',
	        M: 'މަހެއް',
	        MM: 'މަސް %d',
	        y: 'އަހަރެއް',
	        yy: 'އަހަރު %d',
	    },
	    preparse: function (string) {
	        return string.replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/,/g, '،');
	    },
	    week: {
	        dow: 7, // Sunday is the first day of the week.
	        doy: 12, // The week that contains Jan 12th is the first week of the year.
	    },
	});

	//! moment.js locale configuration

	function isFunction$2(input) {
	    return (
	        (typeof Function !== 'undefined' && input instanceof Function) ||
	        Object.prototype.toString.call(input) === '[object Function]'
	    );
	}

	hooks$2.defineLocale('el', {
	    monthsNominativeEl:
	        'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split(
	            '_'
	        ),
	    monthsGenitiveEl:
	        'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split(
	            '_'
	        ),
	    months: function (momentToFormat, format) {
	        if (!momentToFormat) {
	            return this._monthsNominativeEl;
	        } else if (
	            typeof format === 'string' &&
	            /D/.test(format.substring(0, format.indexOf('MMMM')))
	        ) {
	            // if there is a day number before 'MMMM'
	            return this._monthsGenitiveEl[momentToFormat.month()];
	        } else {
	            return this._monthsNominativeEl[momentToFormat.month()];
	        }
	    },
	    monthsShort: 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
	    weekdays: 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split(
	        '_'
	    ),
	    weekdaysShort: 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
	    weekdaysMin: 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
	    meridiem: function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'μμ' : 'ΜΜ';
	        } else {
	            return isLower ? 'πμ' : 'ΠΜ';
	        }
	    },
	    isPM: function (input) {
	        return (input + '').toLowerCase()[0] === 'μ';
	    },
	    meridiemParse: /[ΠΜ]\.?Μ?\.?/i,
	    longDateFormat: {
	        LT: 'h:mm A',
	        LTS: 'h:mm:ss A',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY h:mm A',
	        LLLL: 'dddd, D MMMM YYYY h:mm A',
	    },
	    calendarEl: {
	        sameDay: '[Σήμερα {}] LT',
	        nextDay: '[Αύριο {}] LT',
	        nextWeek: 'dddd [{}] LT',
	        lastDay: '[Χθες {}] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 6:
	                    return '[το προηγούμενο] dddd [{}] LT';
	                default:
	                    return '[την προηγούμενη] dddd [{}] LT';
	            }
	        },
	        sameElse: 'L',
	    },
	    calendar: function (key, mom) {
	        var output = this._calendarEl[key],
	            hours = mom && mom.hours();
	        if (isFunction$2(output)) {
	            output = output.apply(mom);
	        }
	        return output.replace('{}', hours % 12 === 1 ? 'στη' : 'στις');
	    },
	    relativeTime: {
	        future: 'σε %s',
	        past: '%s πριν',
	        s: 'λίγα δευτερόλεπτα',
	        ss: '%d δευτερόλεπτα',
	        m: 'ένα λεπτό',
	        mm: '%d λεπτά',
	        h: 'μία ώρα',
	        hh: '%d ώρες',
	        d: 'μία μέρα',
	        dd: '%d μέρες',
	        M: 'ένας μήνας',
	        MM: '%d μήνες',
	        y: 'ένας χρόνος',
	        yy: '%d χρόνια',
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}η/,
	    ordinal: '%dη',
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4, // The week that contains Jan 4st is the first week of the year.
	    },
	});

	//! moment.js locale configuration

	hooks$2.defineLocale('en-au', {
	    months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	        '_'
	    ),
	    monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	        '_'
	    ),
	    weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat: {
	        LT: 'h:mm A',
	        LTS: 'h:mm:ss A',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY h:mm A',
	        LLLL: 'dddd, D MMMM YYYY h:mm A',
	    },
	    calendar: {
	        sameDay: '[Today at] LT',
	        nextDay: '[Tomorrow at] LT',
	        nextWeek: 'dddd [at] LT',
	        lastDay: '[Yesterday at] LT',
	        lastWeek: '[Last] dddd [at] LT',
	        sameElse: 'L',
	    },
	    relativeTime: {
	        future: 'in %s',
	        past: '%s ago',
	        s: 'a few seconds',
	        ss: '%d seconds',
	        m: 'a minute',
	        mm: '%d minutes',
	        h: 'an hour',
	        hh: '%d hours',
	        d: 'a day',
	        dd: '%d days',
	        M: 'a month',
	        MM: '%d months',
	        y: 'a year',
	        yy: '%d years',
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal: function (number) {
	        var b = number % 10,
	            output =
	                ~~((number % 100) / 10) === 1
	                    ? 'th'
	                    : b === 1
	                    ? 'st'
	                    : b === 2
	                    ? 'nd'
	                    : b === 3
	                    ? 'rd'
	                    : 'th';
	        return number + output;
	    },
	    week: {
	        dow: 0, // Sunday is the first day of the week.
	        doy: 4, // The week that contains Jan 4th is the first week of the year.
	    },
	});

	//! moment.js locale configuration

	hooks$2.defineLocale('en-ca', {
	    months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	        '_'
	    ),
	    monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	        '_'
	    ),
	    weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat: {
	        LT: 'h:mm A',
	        LTS: 'h:mm:ss A',
	        L: 'YYYY-MM-DD',
	        LL: 'MMMM D, YYYY',
	        LLL: 'MMMM D, YYYY h:mm A',
	        LLLL: 'dddd, MMMM D, YYYY h:mm A',
	    },
	    calendar: {
	        sameDay: '[Today at] LT',
	        nextDay: '[Tomorrow at] LT',
	        nextWeek: 'dddd [at] LT',
	        lastDay: '[Yesterday at] LT',
	        lastWeek: '[Last] dddd [at] LT',
	        sameElse: 'L',
	    },
	    relativeTime: {
	        future: 'in %s',
	        past: '%s ago',
	        s: 'a few seconds',
	        ss: '%d seconds',
	        m: 'a minute',
	        mm: '%d minutes',
	        h: 'an hour',
	        hh: '%d hours',
	        d: 'a day',
	        dd: '%d days',
	        M: 'a month',
	        MM: '%d months',
	        y: 'a year',
	        yy: '%d years',
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal: function (number) {
	        var b = number % 10,
	            output =
	                ~~((number % 100) / 10) === 1
	                    ? 'th'
	                    : b === 1
	                    ? 'st'
	                    : b === 2
	                    ? 'nd'
	                    : b === 3
	                    ? 'rd'
	                    : 'th';
	        return number + output;
	    },
	});

	//! moment.js locale configuration

	hooks$2.defineLocale('en-gb', {
	    months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	        '_'
	    ),
	    monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	        '_'
	    ),
	    weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd, D MMMM YYYY HH:mm',
	    },
	    calendar: {
	        sameDay: '[Today at] LT',
	        nextDay: '[Tomorrow at] LT',
	        nextWeek: 'dddd [at] LT',
	        lastDay: '[Yesterday at] LT',
	        lastWeek: '[Last] dddd [at] LT',
	        sameElse: 'L',
	    },
	    relativeTime: {
	        future: 'in %s',
	        past: '%s ago',
	        s: 'a few seconds',
	        ss: '%d seconds',
	        m: 'a minute',
	        mm: '%d minutes',
	        h: 'an hour',
	        hh: '%d hours',
	        d: 'a day',
	        dd: '%d days',
	        M: 'a month',
	        MM: '%d months',
	        y: 'a year',
	        yy: '%d years',
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal: function (number) {
	        var b = number % 10,
	            output =
	                ~~((number % 100) / 10) === 1
	                    ? 'th'
	                    : b === 1
	                    ? 'st'
	                    : b === 2
	                    ? 'nd'
	                    : b === 3
	                    ? 'rd'
	                    : 'th';
	        return number + output;
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4, // The week that contains Jan 4th is the first week of the year.
	    },
	});

	//! moment.js locale configuration

	hooks$2.defineLocale('en-ie', {
	    months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	        '_'
	    ),
	    monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	        '_'
	    ),
	    weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd D MMMM YYYY HH:mm',
	    },
	    calendar: {
	        sameDay: '[Today at] LT',
	        nextDay: '[Tomorrow at] LT',
	        nextWeek: 'dddd [at] LT',
	        lastDay: '[Yesterday at] LT',
	        lastWeek: '[Last] dddd [at] LT',
	        sameElse: 'L',
	    },
	    relativeTime: {
	        future: 'in %s',
	        past: '%s ago',
	        s: 'a few seconds',
	        ss: '%d seconds',
	        m: 'a minute',
	        mm: '%d minutes',
	        h: 'an hour',
	        hh: '%d hours',
	        d: 'a day',
	        dd: '%d days',
	        M: 'a month',
	        MM: '%d months',
	        y: 'a year',
	        yy: '%d years',
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal: function (number) {
	        var b = number % 10,
	            output =
	                ~~((number % 100) / 10) === 1
	                    ? 'th'
	                    : b === 1
	                    ? 'st'
	                    : b === 2
	                    ? 'nd'
	                    : b === 3
	                    ? 'rd'
	                    : 'th';
	        return number + output;
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4, // The week that contains Jan 4th is the first week of the year.
	    },
	});

	//! moment.js locale configuration

	hooks$2.defineLocale('en-nz', {
	    months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	        '_'
	    ),
	    monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	        '_'
	    ),
	    weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat: {
	        LT: 'h:mm A',
	        LTS: 'h:mm:ss A',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY h:mm A',
	        LLLL: 'dddd, D MMMM YYYY h:mm A',
	    },
	    calendar: {
	        sameDay: '[Today at] LT',
	        nextDay: '[Tomorrow at] LT',
	        nextWeek: 'dddd [at] LT',
	        lastDay: '[Yesterday at] LT',
	        lastWeek: '[Last] dddd [at] LT',
	        sameElse: 'L',
	    },
	    relativeTime: {
	        future: 'in %s',
	        past: '%s ago',
	        s: 'a few seconds',
	        ss: '%d seconds',
	        m: 'a minute',
	        mm: '%d minutes',
	        h: 'an hour',
	        hh: '%d hours',
	        d: 'a day',
	        dd: '%d days',
	        M: 'a month',
	        MM: '%d months',
	        y: 'a year',
	        yy: '%d years',
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal: function (number) {
	        var b = number % 10,
	            output =
	                ~~((number % 100) / 10) === 1
	                    ? 'th'
	                    : b === 1
	                    ? 'st'
	                    : b === 2
	                    ? 'nd'
	                    : b === 3
	                    ? 'rd'
	                    : 'th';
	        return number + output;
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4, // The week that contains Jan 4th is the first week of the year.
	    },
	});

	//! moment.js locale configuration

	hooks$2.defineLocale('eo', {
	    months: 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split(
	        '_'
	    ),
	    monthsShort: 'jan_feb_mart_apr_maj_jun_jul_aŭg_sept_okt_nov_dec'.split('_'),
	    weekdays: 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
	    weekdaysShort: 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
	    weekdaysMin: 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'YYYY-MM-DD',
	        LL: '[la] D[-an de] MMMM, YYYY',
	        LLL: '[la] D[-an de] MMMM, YYYY HH:mm',
	        LLLL: 'dddd[n], [la] D[-an de] MMMM, YYYY HH:mm',
	        llll: 'ddd, [la] D[-an de] MMM, YYYY HH:mm',
	    },
	    meridiemParse: /[ap]\.t\.m/i,
	    isPM: function (input) {
	        return input.charAt(0).toLowerCase() === 'p';
	    },
	    meridiem: function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'p.t.m.' : 'P.T.M.';
	        } else {
	            return isLower ? 'a.t.m.' : 'A.T.M.';
	        }
	    },
	    calendar: {
	        sameDay: '[Hodiaŭ je] LT',
	        nextDay: '[Morgaŭ je] LT',
	        nextWeek: 'dddd[n je] LT',
	        lastDay: '[Hieraŭ je] LT',
	        lastWeek: '[pasintan] dddd[n je] LT',
	        sameElse: 'L',
	    },
	    relativeTime: {
	        future: 'post %s',
	        past: 'antaŭ %s',
	        s: 'kelkaj sekundoj',
	        ss: '%d sekundoj',
	        m: 'unu minuto',
	        mm: '%d minutoj',
	        h: 'unu horo',
	        hh: '%d horoj',
	        d: 'unu tago', //ne 'diurno', ĉar estas uzita por proksimumo
	        dd: '%d tagoj',
	        M: 'unu monato',
	        MM: '%d monatoj',
	        y: 'unu jaro',
	        yy: '%d jaroj',
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}a/,
	    ordinal: '%da',
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 7, // The week that contains Jan 7th is the first week of the year.
	    },
	});

	//! moment.js locale configuration

	var monthsShortDot =
	        'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
	            '_'
	        ),
	    monthsShort$1 = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
	    monthsParse$2 = [
	        /^ene/i,
	        /^feb/i,
	        /^mar/i,
	        /^abr/i,
	        /^may/i,
	        /^jun/i,
	        /^jul/i,
	        /^ago/i,
	        /^sep/i,
	        /^oct/i,
	        /^nov/i,
	        /^dic/i ],
	    monthsRegex$4 =
	        /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

	hooks$2.defineLocale('es-do', {
	    months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
	        '_'
	    ),
	    monthsShort: function (m, format) {
	        if (!m) {
	            return monthsShortDot;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShort$1[m.month()];
	        } else {
	            return monthsShortDot[m.month()];
	        }
	    },
	    monthsRegex: monthsRegex$4,
	    monthsShortRegex: monthsRegex$4,
	    monthsStrictRegex:
	        /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	    monthsShortStrictRegex:
	        /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	    monthsParse: monthsParse$2,
	    longMonthsParse: monthsParse$2,
	    shortMonthsParse: monthsParse$2,
	    weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	    weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	    weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	    weekdaysParseExact: true,
	    longDateFormat: {
	        LT: 'h:mm A',
	        LTS: 'h:mm:ss A',
	        L: 'DD/MM/YYYY',
	        LL: 'D [de] MMMM [de] YYYY',
	        LLL: 'D [de] MMMM [de] YYYY h:mm A',
	        LLLL: 'dddd, D [de] MMMM [de] YYYY h:mm A',
	    },
	    calendar: {
	        sameDay: function () {
	            return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	        },
	        nextDay: function () {
	            return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	        },
	        nextWeek: function () {
	            return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	        },
	        lastDay: function () {
	            return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	        },
	        lastWeek: function () {
	            return (
	                '[el] dddd [pasado a la' +
	                (this.hours() !== 1 ? 's' : '') +
	                '] LT'
	            );
	        },
	        sameElse: 'L',
	    },
	    relativeTime: {
	        future: 'en %s',
	        past: 'hace %s',
	        s: 'unos segundos',
	        ss: '%d segundos',
	        m: 'un minuto',
	        mm: '%d minutos',
	        h: 'una hora',
	        hh: '%d horas',
	        d: 'un día',
	        dd: '%d días',
	        w: 'una semana',
	        ww: '%d semanas',
	        M: 'un mes',
	        MM: '%d meses',
	        y: 'un año',
	        yy: '%d años',
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}º/,
	    ordinal: '%dº',
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4, // The week that contains Jan 4th is the first week of the year.
	    },
	});

	//! moment.js locale configuration

	var monthsShortDot$1 =
	        'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
	            '_'
	        ),
	    monthsShort$2 = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
	    monthsParse$3 = [
	        /^ene/i,
	        /^feb/i,
	        /^mar/i,
	        /^abr/i,
	        /^may/i,
	        /^jun/i,
	        /^jul/i,
	        /^ago/i,
	        /^sep/i,
	        /^oct/i,
	        /^nov/i,
	        /^dic/i ],
	    monthsRegex$5 =
	        /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

	hooks$2.defineLocale('es', {
	    months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
	        '_'
	    ),
	    monthsShort: function (m, format) {
	        if (!m) {
	            return monthsShortDot$1;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShort$2[m.month()];
	        } else {
	            return monthsShortDot$1[m.month()];
	        }
	    },
	    monthsRegex: monthsRegex$5,
	    monthsShortRegex: monthsRegex$5,
	    monthsStrictRegex:
	        /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	    monthsShortStrictRegex:
	        /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	    monthsParse: monthsParse$3,
	    longMonthsParse: monthsParse$3,
	    shortMonthsParse: monthsParse$3,
	    weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	    weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	    weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	    weekdaysParseExact: true,
	    longDateFormat: {
	        LT: 'H:mm',
	        LTS: 'H:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D [de] MMMM [de] YYYY',
	        LLL: 'D [de] MMMM [de] YYYY H:mm',
	        LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
	    },
	    calendar: {
	        sameDay: function () {
	            return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	        },
	        nextDay: function () {
	            return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	        },
	        nextWeek: function () {
	            return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	        },
	        lastDay: function () {
	            return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	        },
	        lastWeek: function () {
	            return (
	                '[el] dddd [pasado a la' +
	                (this.hours() !== 1 ? 's' : '') +
	                '] LT'
	            );
	        },
	        sameElse: 'L',
	    },
	    relativeTime: {
	        future: 'en %s',
	        past: 'hace %s',
	        s: 'unos segundos',
	        ss: '%d segundos',
	        m: 'un minuto',
	        mm: '%d minutos',
	        h: 'una hora',
	        hh: '%d horas',
	        d: 'un día',
	        dd: '%d días',
	        w: 'una semana',
	        ww: '%d semanas',
	        M: 'un mes',
	        MM: '%d meses',
	        y: 'un año',
	        yy: '%d años',
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}º/,
	    ordinal: '%dº',
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4, // The week that contains Jan 4th is the first week of the year.
	    },
	    invalidDate: 'Fecha inválida',
	});

	//! moment.js locale configuration

	function processRelativeTime$3(number, withoutSuffix, key, isFuture) {
	    var format = {
	        s: ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
	        ss: [number + 'sekundi', number + 'sekundit'],
	        m: ['ühe minuti', 'üks minut'],
	        mm: [number + ' minuti', number + ' minutit'],
	        h: ['ühe tunni', 'tund aega', 'üks tund'],
	        hh: [number + ' tunni', number + ' tundi'],
	        d: ['ühe päeva', 'üks päev'],
	        M: ['kuu aja', 'kuu aega', 'üks kuu'],
	        MM: [number + ' kuu', number + ' kuud'],
	        y: ['ühe aasta', 'aasta', 'üks aasta'],
	        yy: [number + ' aasta', number + ' aastat'],
	    };
	    if (withoutSuffix) {
	        return format[key][2] ? format[key][2] : format[key][1];
	    }
	    return isFuture ? format[key][0] : format[key][1];
	}

	hooks$2.defineLocale('et', {
	    months: 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split(
	        '_'
	    ),
	    monthsShort:
	        'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
	    weekdays:
	        'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split(
	            '_'
	        ),
	    weekdaysShort: 'P_E_T_K_N_R_L'.split('_'),
	    weekdaysMin: 'P_E_T_K_N_R_L'.split('_'),
	    longDateFormat: {
	        LT: 'H:mm',
	        LTS: 'H:mm:ss',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm',
	        LLLL: 'dddd, D. MMMM YYYY H:mm',
	    },
	    calendar: {
	        sameDay: '[Täna,] LT',
	        nextDay: '[Homme,] LT',
	        nextWeek: '[Järgmine] dddd LT',
	        lastDay: '[Eile,] LT',
	        lastWeek: '[Eelmine] dddd LT',
	        sameElse: 'L',
	    },
	    relativeTime: {
	        future: '%s pärast',
	        past: '%s tagasi',
	        s: processRelativeTime$3,
	        ss: processRelativeTime$3,
	        m: processRelativeTime$3,
	        mm: processRelativeTime$3,
	        h: processRelativeTime$3,
	        hh: processRelativeTime$3,
	        d: processRelativeTime$3,
	        dd: '%d päeva',
	        M: processRelativeTime$3,
	        MM: processRelativeTime$3,
	        y: processRelativeTime$3,
	        yy: processRelativeTime$3,
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal: '%d.',
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4, // The week that contains Jan 4th is the first week of the year.
	    },
	});

	//! moment.js locale configuration

	hooks$2.defineLocale('eu', {
	    months: 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split(
	        '_'
	    ),
	    monthsShort:
	        'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split(
	            '_'
	        ),
	    monthsParseExact: true,
	    weekdays:
	        'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split(
	            '_'
	        ),
	    weekdaysShort: 'ig._al._ar._az._og._ol._lr.'.split('_'),
	    weekdaysMin: 'ig_al_ar_az_og_ol_lr'.split('_'),
	    weekdaysParseExact: true,
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'YYYY-MM-DD',
	        LL: 'YYYY[ko] MMMM[ren] D[a]',
	        LLL: 'YYYY[ko] MMMM[ren] D[a] HH:mm',
	        LLLL: 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
	        l: 'YYYY-M-D',
	        ll: 'YYYY[ko] MMM D[a]',
	        lll: 'YYYY[ko] MMM D[a] HH:mm',
	        llll: 'ddd, YYYY[ko] MMM D[a] HH:mm',
	    },
	    calendar: {
	        sameDay: '[gaur] LT[etan]',
	        nextDay: '[bihar] LT[etan]',
	        nextWeek: 'dddd LT[etan]',
	        lastDay: '[atzo] LT[etan]',
	        lastWeek: '[aurreko] dddd LT[etan]',
	        sameElse: 'L',
	    },
	    relativeTime: {
	        future: '%s barru',
	        past: 'duela %s',
	        s: 'segundo batzuk',
	        ss: '%d segundo',
	        m: 'minutu bat',
	        mm: '%d minutu',
	        h: 'ordu bat',
	        hh: '%d ordu',
	        d: 'egun bat',
	        dd: '%d egun',
	        M: 'hilabete bat',
	        MM: '%d hilabete',
	        y: 'urte bat',
	        yy: '%d urte',
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal: '%d.',
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 7, // The week that contains Jan 7th is the first week of the year.
	    },
	});

	//! moment.js locale configuration

	var symbolMap$5 = {
	        1: '۱',
	        2: '۲',
	        3: '۳',
	        4: '۴',
	        5: '۵',
	        6: '۶',
	        7: '۷',
	        8: '۸',
	        9: '۹',
	        0: '۰',
	    },
	    numberMap$4 = {
	        '۱': '1',
	        '۲': '2',
	        '۳': '3',
	        '۴': '4',
	        '۵': '5',
	        '۶': '6',
	        '۷': '7',
	        '۸': '8',
	        '۹': '9',
	        '۰': '0',
	    };

	hooks$2.defineLocale('fa', {
	    months: 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split(
	        '_'
	    ),
	    monthsShort:
	        'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split(
	            '_'
	        ),
	    weekdays:
	        'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split(
	            '_'
	        ),
	    weekdaysShort:
	        'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split(
	            '_'
	        ),
	    weekdaysMin: 'ی_د_س_چ_پ_ج_ش'.split('_'),
	    weekdaysParseExact: true,
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd, D MMMM YYYY HH:mm',
	    },
	    meridiemParse: /قبل از ظهر|بعد از ظهر/,
	    isPM: function (input) {
	        return /بعد از ظهر/.test(input);
	    },
	    meridiem: function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'قبل از ظهر';
	        } else {
	            return 'بعد از ظهر';
	        }
	    },
	    calendar: {
	        sameDay: '[امروز ساعت] LT',
	        nextDay: '[فردا ساعت] LT',
	        nextWeek: 'dddd [ساعت] LT',
	        lastDay: '[دیروز ساعت] LT',
	        lastWeek: 'dddd [پیش] [ساعت] LT',
	        sameElse: 'L',
	    },
	    relativeTime: {
	        future: 'در %s',
	        past: '%s پیش',
	        s: 'چند ثانیه',
	        ss: '%d ثانیه',
	        m: 'یک دقیقه',
	        mm: '%d دقیقه',
	        h: 'یک ساعت',
	        hh: '%d ساعت',
	        d: 'یک روز',
	        dd: '%d روز',
	        M: 'یک ماه',
	        MM: '%d ماه',
	        y: 'یک سال',
	        yy: '%d سال',
	    },
	    preparse: function (string) {
	        return string
	            .replace(/[۰-۹]/g, function (match) {
	                return numberMap$4[match];
	            })
	            .replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string
	            .replace(/\d/g, function (match) {
	                return symbolMap$5[match];
	            })
	            .replace(/,/g, '،');
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}م/,
	    ordinal: '%dم',
	    week: {
	        dow: 6, // Saturday is the first day of the week.
	        doy: 12, // The week that contains Jan 12th is the first week of the year.
	    },
	});

	//! moment.js locale configuration

	var numbersPast =
	        'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(
	            ' '
	        ),
	    numbersFuture = [
	        'nolla',
	        'yhden',
	        'kahden',
	        'kolmen',
	        'neljän',
	        'viiden',
	        'kuuden',
	        numbersPast[7],
	        numbersPast[8],
	        numbersPast[9] ];
	function translate$3(number, withoutSuffix, key, isFuture) {
	    var result = '';
	    switch (key) {
	        case 's':
	            return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
	        case 'ss':
	            result = isFuture ? 'sekunnin' : 'sekuntia';
	            break;
	        case 'm':
	            return isFuture ? 'minuutin' : 'minuutti';
	        case 'mm':
	            result = isFuture ? 'minuutin' : 'minuuttia';
	            break;
	        case 'h':
	            return isFuture ? 'tunnin' : 'tunti';
	        case 'hh':
	            result = isFuture ? 'tunnin' : 'tuntia';
	            break;
	        case 'd':
	            return isFuture ? 'päivän' : 'päivä';
	        case 'dd':
	            result = isFuture ? 'päivän' : 'päivää';
	            break;
	        case 'M':
	            return isFuture ? 'kuukauden' : 'kuukausi';
	        case 'MM':
	            result = isFuture ? 'kuukauden' : 'kuukautta';
	            break;
	        case 'y':
	            return isFuture ? 'vuoden' : 'vuosi';
	        case 'yy':
	            result = isFuture ? 'vuoden' : 'vuotta';
	            break;
	    }
	    result = verbalNumber(number, isFuture) + ' ' + result;
	    return result;
	}
	function verbalNumber(number, isFuture) {
	    return number < 10
	        ? isFuture
	            ? numbersFuture[number]
	            : numbersPast[number]
	        : number;
	}

	hooks$2.defineLocale('fi', {
	    months: 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split(
	        '_'
	    ),
	    monthsShort:
	        'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split(
	            '_'
	        ),
	    weekdays:
	        'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split(
	            '_'
	        ),
	    weekdaysShort: 'su_ma_ti_ke_to_pe_la'.split('_'),
	    weekdaysMin: 'su_ma_ti_ke_to_pe_la'.split('_'),
	    longDateFormat: {
	        LT: 'HH.mm',
	        LTS: 'HH.mm.ss',
	        L: 'DD.MM.YYYY',
	        LL: 'Do MMMM[ta] YYYY',
	        LLL: 'Do MMMM[ta] YYYY, [klo] HH.mm',
	        LLLL: 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
	        l: 'D.M.YYYY',
	        ll: 'Do MMM YYYY',
	        lll: 'Do MMM YYYY, [klo] HH.mm',
	        llll: 'ddd, Do MMM YYYY, [klo] HH.mm',
	    },
	    calendar: {
	        sameDay: '[tänään] [klo] LT',
	        nextDay: '[huomenna] [klo] LT',
	        nextWeek: 'dddd [klo] LT',
	        lastDay: '[eilen] [klo] LT',
	        lastWeek: '[viime] dddd[na] [klo] LT',
	        sameElse: 'L',
	    },
	    relativeTime: {
	        future: '%s päästä',
	        past: '%s sitten',
	        s: translate$3,
	        ss: translate$3,
	        m: translate$3,
	        mm: translate$3,
	        h: translate$3,
	        hh: translate$3,
	        d: translate$3,
	        dd: translate$3,
	        M: translate$3,
	        MM: translate$3,
	        y: translate$3,
	        yy: translate$3,
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal: '%d.',
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4, // The week that contains Jan 4th is the first week of the year.
	    },
	});

	//! moment.js locale configuration

	hooks$2.defineLocale('fo', {
	    months: 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split(
	        '_'
	    ),
	    monthsShort: 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	    weekdays:
	        'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split(
	            '_'
	        ),
	    weekdaysShort: 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
	    weekdaysMin: 'su_má_tý_mi_hó_fr_le'.split('_'),
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd D. MMMM, YYYY HH:mm',
	    },
	    calendar: {
	        sameDay: '[Í dag kl.] LT',
	        nextDay: '[Í morgin kl.] LT',
	        nextWeek: 'dddd [kl.] LT',
	        lastDay: '[Í gjár kl.] LT',
	        lastWeek: '[síðstu] dddd [kl] LT',
	        sameElse: 'L',
	    },
	    relativeTime: {
	        future: 'um %s',
	        past: '%s síðani',
	        s: 'fá sekund',
	        ss: '%d sekundir',
	        m: 'ein minuttur',
	        mm: '%d minuttir',
	        h: 'ein tími',
	        hh: '%d tímar',
	        d: 'ein dagur',
	        dd: '%d dagar',
	        M: 'ein mánaður',
	        MM: '%d mánaðir',
	        y: 'eitt ár',
	        yy: '%d ár',
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal: '%d.',
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4, // The week that contains Jan 4th is the first week of the year.
	    },
	});

	//! moment.js locale configuration

	hooks$2.defineLocale('fr-ca', {
	    months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
	        '_'
	    ),
	    monthsShort:
	        'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
	            '_'
	        ),
	    monthsParseExact: true,
	    weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	    weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	    weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
	    weekdaysParseExact: true,
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'YYYY-MM-DD',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd D MMMM YYYY HH:mm',
	    },
	    calendar: {
	        sameDay: '[Aujourd’hui à] LT',
	        nextDay: '[Demain à] LT',
	        nextWeek: 'dddd [à] LT',
	        lastDay: '[Hier à] LT',
	        lastWeek: 'dddd [dernier à] LT',
	        sameElse: 'L',
	    },
	    relativeTime: {
	        future: 'dans %s',
	        past: 'il y a %s',
	        s: 'quelques secondes',
	        ss: '%d secondes',
	        m: 'une minute',
	        mm: '%d minutes',
	        h: 'une heure',
	        hh: '%d heures',
	        d: 'un jour',
	        dd: '%d jours',
	        M: 'un mois',
	        MM: '%d mois',
	        y: 'un an',
	        yy: '%d ans',
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            // Words with masculine grammatical gender: mois, trimestre, jour
	            default:
	            case 'M':
	            case 'Q':
	            case 'D':
	            case 'DDD':
	            case 'd':
	                return number + (number === 1 ? 'er' : 'e');

	            // Words with feminine grammatical gender: semaine
	            case 'w':
	            case 'W':
	                return number + (number === 1 ? 're' : 'e');
	        }
	    },
	});

	//! moment.js locale configuration

	hooks$2.defineLocale('fr-ch', {
	    months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
	        '_'
	    ),
	    monthsShort:
	        'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
	            '_'
	        ),
	    monthsParseExact: true,
	    weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	    weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	    weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
	    weekdaysParseExact: true,
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD.MM.YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd D MMMM YYYY HH:mm',
	    },
	    calendar: {
	        sameDay: '[Aujourd’hui à] LT',
	        nextDay: '[Demain à] LT',
	        nextWeek: 'dddd [à] LT',
	        lastDay: '[Hier à] LT',
	        lastWeek: 'dddd [dernier à] LT',
	        sameElse: 'L',
	    },
	    relativeTime: {
	        future: 'dans %s',
	        past: 'il y a %s',
	        s: 'quelques secondes',
	        ss: '%d secondes',
	        m: 'une minute',
	        mm: '%d minutes',
	        h: 'une heure',
	        hh: '%d heures',
	        d: 'un jour',
	        dd: '%d jours',
	        M: 'un mois',
	        MM: '%d mois',
	        y: 'un an',
	        yy: '%d ans',
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            // Words with masculine grammatical gender: mois, trimestre, jour
	            default:
	            case 'M':
	            case 'Q':
	            case 'D':
	            case 'DDD':
	            case 'd':
	                return number + (number === 1 ? 'er' : 'e');

	            // Words with feminine grammatical gender: semaine
	            case 'w':
	            case 'W':
	                return number + (number === 1 ? 're' : 'e');
	        }
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4, // The week that contains Jan 4th is the first week of the year.
	    },
	});

	//! moment.js locale configuration

	var monthsStrictRegex$1 =
	        /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
	    monthsShortStrictRegex$1 =
	        /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?)/i,
	    monthsRegex$6 =
	        /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?|janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
	    monthsParse$4 = [
	        /^janv/i,
	        /^févr/i,
	        /^mars/i,
	        /^avr/i,
	        /^mai/i,
	        /^juin/i,
	        /^juil/i,
	        /^août/i,
	        /^sept/i,
	        /^oct/i,
	        /^nov/i,
	        /^déc/i ];

	hooks$2.defineLocale('fr', {
	    months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
	        '_'
	    ),
	    monthsShort:
	        'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
	            '_'
	        ),
	    monthsRegex: monthsRegex$6,
	    monthsShortRegex: monthsRegex$6,
	    monthsStrictRegex: monthsStrictRegex$1,
	    monthsShortStrictRegex: monthsShortStrictRegex$1,
	    monthsParse: monthsParse$4,
	    longMonthsParse: monthsParse$4,
	    shortMonthsParse: monthsParse$4,
	    weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	    weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	    weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
	    weekdaysParseExact: true,
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd D MMMM YYYY HH:mm',
	    },
	    calendar: {
	        sameDay: '[Aujourd’hui à] LT',
	        nextDay: '[Demain à] LT',
	        nextWeek: 'dddd [à] LT',
	        lastDay: '[Hier à] LT',
	        lastWeek: 'dddd [dernier à] LT',
	        sameElse: 'L',
	    },
	    relativeTime: {
	        future: 'dans %s',
	        past: 'il y a %s',
	        s: 'quelques secondes',
	        ss: '%d secondes',
	        m: 'une minute',
	        mm: '%d minutes',
	        h: 'une heure',
	        hh: '%d heures',
	        d: 'un jour',
	        dd: '%d jours',
	        w: 'une semaine',
	        ww: '%d semaines',
	        M: 'un mois',
	        MM: '%d mois',
	        y: 'un an',
	        yy: '%d ans',
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            // TODO: Return 'e' when day of month > 1. Move this case inside
	            // block for masculine words below.
	            // See https://github.com/moment/moment/issues/3375
	            case 'D':
	                return number + (number === 1 ? 'er' : '');

	            // Words with masculine grammatical gender: mois, trimestre, jour
	            default:
	            case 'M':
	            case 'Q':
	            case 'DDD':
	            case 'd':
	                return number + (number === 1 ? 'er' : 'e');

	            // Words with feminine grammatical gender: semaine
	            case 'w':
	            case 'W':
	                return number + (number === 1 ? 're' : 'e');
	        }
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4, // The week that contains Jan 4th is the first week of the year.
	    },
	});

	//! moment.js locale configuration

	var monthsShortWithDots =
	        'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_'),
	    monthsShortWithoutDots =
	        'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');

	hooks$2.defineLocale('fy', {
	    months: 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split(
	        '_'
	    ),
	    monthsShort: function (m, format) {
	        if (!m) {
	            return monthsShortWithDots;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShortWithoutDots[m.month()];
	        } else {
	            return monthsShortWithDots[m.month()];
	        }
	    },
	    monthsParseExact: true,
	    weekdays: 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split(
	        '_'
	    ),
	    weekdaysShort: 'si._mo._ti._wo._to._fr._so.'.split('_'),
	    weekdaysMin: 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
	    weekdaysParseExact: true,
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD-MM-YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd D MMMM YYYY HH:mm',
	    },
	    calendar: {
	        sameDay: '[hjoed om] LT',
	        nextDay: '[moarn om] LT',
	        nextWeek: 'dddd [om] LT',
	        lastDay: '[juster om] LT',
	        lastWeek: '[ôfrûne] dddd [om] LT',
	        sameElse: 'L',
	    },
	    relativeTime: {
	        future: 'oer %s',
	        past: '%s lyn',
	        s: 'in pear sekonden',
	        ss: '%d sekonden',
	        m: 'ien minút',
	        mm: '%d minuten',
	        h: 'ien oere',
	        hh: '%d oeren',
	        d: 'ien dei',
	        dd: '%d dagen',
	        M: 'ien moanne',
	        MM: '%d moannen',
	        y: 'ien jier',
	        yy: '%d jierren',
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	    ordinal: function (number) {
	        return (
	            number +
	            (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
	        );
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4, // The week that contains Jan 4th is the first week of the year.
	    },
	});

	//! moment.js locale configuration

	var months$7 = [
	        'Am Faoilleach',
	        'An Gearran',
	        'Am Màrt',
	        'An Giblean',
	        'An Cèitean',
	        'An t-Ògmhios',
	        'An t-Iuchar',
	        'An Lùnastal',
	        'An t-Sultain',
	        'An Dàmhair',
	        'An t-Samhain',
	        'An Dùbhlachd' ],
	    monthsShort$3 = [
	        'Faoi',
	        'Gear',
	        'Màrt',
	        'Gibl',
	        'Cèit',
	        'Ògmh',
	        'Iuch',
	        'Lùn',
	        'Sult',
	        'Dàmh',
	        'Samh',
	        'Dùbh' ],
	    weekdays$1 = [
	        'Didòmhnaich',
	        'Diluain',
	        'Dimàirt',
	        'Diciadain',
	        'Diardaoin',
	        'Dihaoine',
	        'Disathairne' ],
	    weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'],
	    weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];

	hooks$2.defineLocale('gd', {
	    months: months$7,
	    monthsShort: monthsShort$3,
	    monthsParseExact: true,
	    weekdays: weekdays$1,
	    weekdaysShort: weekdaysShort,
	    weekdaysMin: weekdaysMin,
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd, D MMMM YYYY HH:mm',
	    },
	    calendar: {
	        sameDay: '[An-diugh aig] LT',
	        nextDay: '[A-màireach aig] LT',
	        nextWeek: 'dddd [aig] LT',
	        lastDay: '[An-dè aig] LT',
	        lastWeek: 'dddd [seo chaidh] [aig] LT',
	        sameElse: 'L',
	    },
	    relativeTime: {
	        future: 'ann an %s',
	        past: 'bho chionn %s',
	        s: 'beagan diogan',
	        ss: '%d diogan',
	        m: 'mionaid',
	        mm: '%d mionaidean',
	        h: 'uair',
	        hh: '%d uairean',
	        d: 'latha',
	        dd: '%d latha',
	        M: 'mìos',
	        MM: '%d mìosan',
	        y: 'bliadhna',
	        yy: '%d bliadhna',
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
	    ordinal: function (number) {
	        var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	        return number + output;
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4, // The week that contains Jan 4th is the first week of the year.
	    },
	});

	//! moment.js locale configuration

	hooks$2.defineLocale('gl', {
	    months: 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split(
	        '_'
	    ),
	    monthsShort:
	        'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split(
	            '_'
	        ),
	    monthsParseExact: true,
	    weekdays: 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
	    weekdaysShort: 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
	    weekdaysMin: 'do_lu_ma_mé_xo_ve_sá'.split('_'),
	    weekdaysParseExact: true,
	    longDateFormat: {
	        LT: 'H:mm',
	        LTS: 'H:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D [de] MMMM [de] YYYY',
	        LLL: 'D [de] MMMM [de] YYYY H:mm',
	        LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
	    },
	    calendar: {
	        sameDay: function () {
	            return '[hoxe ' + (this.hours() !== 1 ? 'ás' : 'á') + '] LT';
	        },
	        nextDay: function () {
	            return '[mañá ' + (this.hours() !== 1 ? 'ás' : 'á') + '] LT';
	        },
	        nextWeek: function () {
	            return 'dddd [' + (this.hours() !== 1 ? 'ás' : 'a') + '] LT';
	        },
	        lastDay: function () {
	            return '[onte ' + (this.hours() !== 1 ? 'á' : 'a') + '] LT';
	        },
	        lastWeek: function () {
	            return (
	                '[o] dddd [pasado ' + (this.hours() !== 1 ? 'ás' : 'a') + '] LT'
	            );
	        },
	        sameElse: 'L',
	    },
	    relativeTime: {
	        future: function (str) {
	            if (str.indexOf('un') === 0) {
	                return 'n' + str;
	            }
	            return 'en ' + str;
	        },
	        past: 'hai %s',
	        s: 'uns segundos',
	        ss: '%d segundos',
	        m: 'un minuto',
	        mm: '%d minutos',
	        h: 'unha hora',
	        hh: '%d horas',
	        d: 'un día',
	        dd: '%d días',
	        M: 'un mes',
	        MM: '%d meses',
	        y: 'un ano',
	        yy: '%d anos',
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}º/,
	    ordinal: '%dº',
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4, // The week that contains Jan 4th is the first week of the year.
	    },
	});

	//! moment.js locale configuration

	function processRelativeTime$4(number, withoutSuffix, key, isFuture) {
	    var format = {
	        s: ['thoddea sekondamni', 'thodde sekond'],
	        ss: [number + ' sekondamni', number + ' sekond'],
	        m: ['eka mintan', 'ek minut'],
	        mm: [number + ' mintamni', number + ' mintam'],
	        h: ['eka voran', 'ek vor'],
	        hh: [number + ' voramni', number + ' voram'],
	        d: ['eka disan', 'ek dis'],
	        dd: [number + ' disamni', number + ' dis'],
	        M: ['eka mhoinean', 'ek mhoino'],
	        MM: [number + ' mhoineamni', number + ' mhoine'],
	        y: ['eka vorsan', 'ek voros'],
	        yy: [number + ' vorsamni', number + ' vorsam'],
	    };
	    return isFuture ? format[key][0] : format[key][1];
	}

	hooks$2.defineLocale('gom-latn', {
	    months: {
	        standalone:
	            'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split(
	                '_'
	            ),
	        format: 'Janerachea_Febrerachea_Marsachea_Abrilachea_Maiachea_Junachea_Julaiachea_Agostachea_Setembrachea_Otubrachea_Novembrachea_Dezembrachea'.split(
	            '_'
	        ),
	        isFormat: /MMMM(\s)+D[oD]?/,
	    },
	    monthsShort:
	        'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split('_'),
	    monthsParseExact: true,
	    weekdays: "Aitar_Somar_Mongllar_Budhvar_Birestar_Sukrar_Son'var".split('_'),
	    weekdaysShort: 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
	    weekdaysMin: 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
	    weekdaysParseExact: true,
	    longDateFormat: {
	        LT: 'A h:mm [vazta]',
	        LTS: 'A h:mm:ss [vazta]',
	        L: 'DD-MM-YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY A h:mm [vazta]',
	        LLLL: 'dddd, MMMM Do, YYYY, A h:mm [vazta]',
	        llll: 'ddd, D MMM YYYY, A h:mm [vazta]',
	    },
	    calendar: {
	        sameDay: '[Aiz] LT',
	        nextDay: '[Faleam] LT',
	        nextWeek: '[Fuddlo] dddd[,] LT',
	        lastDay: '[Kal] LT',
	        lastWeek: '[Fattlo] dddd[,] LT',
	        sameElse: 'L',
	    },
	    relativeTime: {
	        future: '%s',
	        past: '%s adim',
	        s: processRelativeTime$4,
	        ss: processRelativeTime$4,
	        m: processRelativeTime$4,
	        mm: processRelativeTime$4,
	        h: processRelativeTime$4,
	        hh: processRelativeTime$4,
	        d: processRelativeTime$4,
	        dd: processRelativeTime$4,
	        M: processRelativeTime$4,
	        MM: processRelativeTime$4,
	        y: processRelativeTime$4,
	        yy: processRelativeTime$4,
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(er)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            // the ordinal 'er' only applies to day of the month
	            case 'D':
	                return number + 'er';
	            default:
	            case 'M':
	            case 'Q':
	            case 'DDD':
	            case 'd':
	            case 'w':
	            case 'W':
	                return number;
	        }
	    },
	    week: {
	        dow: 0, // Sunday is the first day of the week
	        doy: 3, // The week that contains Jan 4th is the first week of the year (7 + 0 - 4)
	    },
	    meridiemParse: /rati|sokallim|donparam|sanje/,
	    meridiemHour: function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'rati') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'sokallim') {
	            return hour;
	        } else if (meridiem === 'donparam') {
	            return hour > 12 ? hour : hour + 12;
	        } else if (meridiem === 'sanje') {
	            return hour + 12;
	        }
	    },
	    meridiem: function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'rati';
	        } else if (hour < 12) {
	            return 'sokallim';
	        } else if (hour < 16) {
	            return 'donparam';
	        } else if (hour < 20) {
	            return 'sanje';
	        } else {
	            return 'rati';
	        }
	    },
	});

	//! moment.js locale configuration

	hooks$2.defineLocale('he', {
	    months: 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split(
	        '_'
	    ),
	    monthsShort:
	        'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
	    weekdays: 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
	    weekdaysShort: 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
	    weekdaysMin: 'א_ב_ג_ד_ה_ו_ש'.split('_'),
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D [ב]MMMM YYYY',
	        LLL: 'D [ב]MMMM YYYY HH:mm',
	        LLLL: 'dddd, D [ב]MMMM YYYY HH:mm',
	        l: 'D/M/YYYY',
	        ll: 'D MMM YYYY',
	        lll: 'D MMM YYYY HH:mm',
	        llll: 'ddd, D MMM YYYY HH:mm',
	    },
	    calendar: {
	        sameDay: '[היום ב־]LT',
	        nextDay: '[מחר ב־]LT',
	        nextWeek: 'dddd [בשעה] LT',
	        lastDay: '[אתמול ב־]LT',
	        lastWeek: '[ביום] dddd [האחרון בשעה] LT',
	        sameElse: 'L',
	    },
	    relativeTime: {
	        future: 'בעוד %s',
	        past: 'לפני %s',
	        s: 'מספר שניות',
	        ss: '%d שניות',
	        m: 'דקה',
	        mm: '%d דקות',
	        h: 'שעה',
	        hh: function (number) {
	            if (number === 2) {
	                return 'שעתיים';
	            }
	            return number + ' שעות';
	        },
	        d: 'יום',
	        dd: function (number) {
	            if (number === 2) {
	                return 'יומיים';
	            }
	            return number + ' ימים';
	        },
	        M: 'חודש',
	        MM: function (number) {
	            if (number === 2) {
	                return 'חודשיים';
	            }
	            return number + ' חודשים';
	        },
	        y: 'שנה',
	        yy: function (number) {
	            if (number === 2) {
	                return 'שנתיים';
	            } else if (number % 10 === 0 && number !== 10) {
	                return number + ' שנה';
	            }
	            return number + ' שנים';
	        },
	    },
	    meridiemParse:
	        /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
	    isPM: function (input) {
	        return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
	    },
	    meridiem: function (hour, minute, isLower) {
	        if (hour < 5) {
	            return 'לפנות בוקר';
	        } else if (hour < 10) {
	            return 'בבוקר';
	        } else if (hour < 12) {
	            return isLower ? 'לפנה"צ' : 'לפני הצהריים';
	        } else if (hour < 18) {
	            return isLower ? 'אחה"צ' : 'אחרי הצהריים';
	        } else {
	            return 'בערב';
	        }
	    },
	});

	//! moment.js locale configuration

	var symbolMap$6 = {
	        1: '१',
	        2: '२',
	        3: '३',
	        4: '४',
	        5: '५',
	        6: '६',
	        7: '७',
	        8: '८',
	        9: '९',
	        0: '०',
	    },
	    numberMap$5 = {
	        '१': '1',
	        '२': '2',
	        '३': '3',
	        '४': '4',
	        '५': '5',
	        '६': '6',
	        '७': '7',
	        '८': '8',
	        '९': '9',
	        '०': '0',
	    },
	    monthsParse$5 = [
	        /^जन/i,
	        /^फ़र|फर/i,
	        /^मार्च/i,
	        /^अप्रै/i,
	        /^मई/i,
	        /^जून/i,
	        /^जुल/i,
	        /^अग/i,
	        /^सितं|सित/i,
	        /^अक्टू/i,
	        /^नव|नवं/i,
	        /^दिसं|दिस/i ],
	    shortMonthsParse = [
	        /^जन/i,
	        /^फ़र/i,
	        /^मार्च/i,
	        /^अप्रै/i,
	        /^मई/i,
	        /^जून/i,
	        /^जुल/i,
	        /^अग/i,
	        /^सित/i,
	        /^अक्टू/i,
	        /^नव/i,
	        /^दिस/i ];

	hooks$2.defineLocale('hi', {
	    months: {
	        format: 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split(
	            '_'
	        ),
	        standalone:
	            'जनवरी_फरवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितंबर_अक्टूबर_नवंबर_दिसंबर'.split(
	                '_'
	            ),
	    },
	    monthsShort:
	        'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
	    weekdays: 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	    weekdaysShort: 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
	    weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
	    longDateFormat: {
	        LT: 'A h:mm बजे',
	        LTS: 'A h:mm:ss बजे',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY, A h:mm बजे',
	        LLLL: 'dddd, D MMMM YYYY, A h:mm बजे',
	    },

	    monthsParse: monthsParse$5,
	    longMonthsParse: monthsParse$5,
	    shortMonthsParse: shortMonthsParse,

	    monthsRegex:
	        /^(जनवरी|जन\.?|फ़रवरी|फरवरी|फ़र\.?|मार्च?|अप्रैल|अप्रै\.?|मई?|जून?|जुलाई|जुल\.?|अगस्त|अग\.?|सितम्बर|सितंबर|सित\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर|नव\.?|दिसम्बर|दिसंबर|दिस\.?)/i,

	    monthsShortRegex:
	        /^(जनवरी|जन\.?|फ़रवरी|फरवरी|फ़र\.?|मार्च?|अप्रैल|अप्रै\.?|मई?|जून?|जुलाई|जुल\.?|अगस्त|अग\.?|सितम्बर|सितंबर|सित\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर|नव\.?|दिसम्बर|दिसंबर|दिस\.?)/i,

	    monthsStrictRegex:
	        /^(जनवरी?|फ़रवरी|फरवरी?|मार्च?|अप्रैल?|मई?|जून?|जुलाई?|अगस्त?|सितम्बर|सितंबर|सित?\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर?|दिसम्बर|दिसंबर?)/i,

	    monthsShortStrictRegex:
	        /^(जन\.?|फ़र\.?|मार्च?|अप्रै\.?|मई?|जून?|जुल\.?|अग\.?|सित\.?|अक्टू\.?|नव\.?|दिस\.?)/i,

	    calendar: {
	        sameDay: '[आज] LT',
	        nextDay: '[कल] LT',
	        nextWeek: 'dddd, LT',
	        lastDay: '[कल] LT',
	        lastWeek: '[पिछले] dddd, LT',
	        sameElse: 'L',
	    },
	    relativeTime: {
	        future: '%s में',
	        past: '%s पहले',
	        s: 'कुछ ही क्षण',
	        ss: '%d सेकंड',
	        m: 'एक मिनट',
	        mm: '%d मिनट',
	        h: 'एक घंटा',
	        hh: '%d घंटे',
	        d: 'एक दिन',
	        dd: '%d दिन',
	        M: 'एक महीने',
	        MM: '%d महीने',
	        y: 'एक वर्ष',
	        yy: '%d वर्ष',
	    },
	    preparse: function (string) {
	        return string.replace(/[१२३४५६७८९०]/g, function (match) {
	            return numberMap$5[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap$6[match];
	        });
	    },
	    // Hindi notation for meridiems are quite fuzzy in practice. While there exists
	    // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
	    meridiemParse: /रात|सुबह|दोपहर|शाम/,
	    meridiemHour: function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'रात') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'सुबह') {
	            return hour;
	        } else if (meridiem === 'दोपहर') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'शाम') {
	            return hour + 12;
	        }
	    },
	    meridiem: function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'रात';
	        } else if (hour < 10) {
	            return 'सुबह';
	        } else if (hour < 17) {
	            return 'दोपहर';
	        } else if (hour < 20) {
	            return 'शाम';
	        } else {
	            return 'रात';
	        }
	    },
	    week: {
	        dow: 0, // Sunday is the first day of the week.
	        doy: 6, // The week that contains Jan 6th is the first week of the year.
	    },
	});

	//! moment.js locale configuration

	function translate$4(number, withoutSuffix, key) {
	    var result = number + ' ';
	    switch (key) {
	        case 'ss':
	            if (number === 1) {
	                result += 'sekunda';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'sekunde';
	            } else {
	                result += 'sekundi';
	            }
	            return result;
	        case 'm':
	            return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	        case 'mm':
	            if (number === 1) {
	                result += 'minuta';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'minute';
	            } else {
	                result += 'minuta';
	            }
	            return result;
	        case 'h':
	            return withoutSuffix ? 'jedan sat' : 'jednog sata';
	        case 'hh':
	            if (number === 1) {
	                result += 'sat';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'sata';
	            } else {
	                result += 'sati';
	            }
	            return result;
	        case 'dd':
	            if (number === 1) {
	                result += 'dan';
	            } else {
	                result += 'dana';
	            }
	            return result;
	        case 'MM':
	            if (number === 1) {
	                result += 'mjesec';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'mjeseca';
	            } else {
	                result += 'mjeseci';
	            }
	            return result;
	        case 'yy':
	            if (number === 1) {
	                result += 'godina';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'godine';
	            } else {
	                result += 'godina';
	            }
	            return result;
	    }
	}

	hooks$2.defineLocale('hr', {
	    months: {
	        format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split(
	            '_'
	        ),
	        standalone:
	            'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split(
	                '_'
	            ),
	    },
	    monthsShort:
	        'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split(
	            '_'
	        ),
	    monthsParseExact: true,
	    weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
	        '_'
	    ),
	    weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	    weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact: true,
	    longDateFormat: {
	        LT: 'H:mm',
	        LTS: 'H:mm:ss',
	        L: 'DD.MM.YYYY',
	        LL: 'Do MMMM YYYY',
	        LLL: 'Do MMMM YYYY H:mm',
	        LLLL: 'dddd, Do MMMM YYYY H:mm',
	    },
	    calendar: {
	        sameDay: '[danas u] LT',
	        nextDay: '[sutra u] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedjelju] [u] LT';
	                case 3:
	                    return '[u] [srijedu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay: '[jučer u] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[prošlu] [nedjelju] [u] LT';
	                case 3:
	                    return '[prošlu] [srijedu] [u] LT';
	                case 6:
	                    return '[prošle] [subote] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[prošli] dddd [u] LT';
	            }
	        },
	        sameElse: 'L',
	    },
	    relativeTime: {
	        future: 'za %s',
	        past: 'prije %s',
	        s: 'par sekundi',
	        ss: translate$4,
	        m: translate$4,
	        mm: translate$4,
	        h: translate$4,
	        hh: translate$4,
	        d: 'dan',
	        dd: translate$4,
	        M: 'mjesec',
	        MM: translate$4,
	        y: 'godinu',
	        yy: translate$4,
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal: '%d.',
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 7, // The week that contains Jan 7th is the first week of the year.
	    },
	});

	//! moment.js locale configuration

	var weekEndings =
	    'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
	function translate$5(number, withoutSuffix, key, isFuture) {
	    var num = number;
	    switch (key) {
	        case 's':
	            return isFuture || withoutSuffix
	                ? 'néhány másodperc'
	                : 'néhány másodperce';
	        case 'ss':
	            return num + (isFuture || withoutSuffix)
	                ? ' másodperc'
	                : ' másodperce';
	        case 'm':
	            return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
	        case 'mm':
	            return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
	        case 'h':
	            return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
	        case 'hh':
	            return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
	        case 'd':
	            return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
	        case 'dd':
	            return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
	        case 'M':
	            return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	        case 'MM':
	            return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	        case 'y':
	            return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
	        case 'yy':
	            return num + (isFuture || withoutSuffix ? ' év' : ' éve');
	    }
	    return '';
	}
	function week(isFuture) {
	    return (
	        (isFuture ? '' : '[múlt] ') +
	        '[' +
	        weekEndings[this.day()] +
	        '] LT[-kor]'
	    );
	}

	hooks$2.defineLocale('hu', {
	    months: 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split(
	        '_'
	    ),
	    monthsShort:
	        'jan._feb._márc._ápr._máj._jún._júl._aug._szept._okt._nov._dec.'.split(
	            '_'
	        ),
	    monthsParseExact: true,
	    weekdays: 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
	    weekdaysShort: 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
	    weekdaysMin: 'v_h_k_sze_cs_p_szo'.split('_'),
	    longDateFormat: {
	        LT: 'H:mm',
	        LTS: 'H:mm:ss',
	        L: 'YYYY.MM.DD.',
	        LL: 'YYYY. MMMM D.',
	        LLL: 'YYYY. MMMM D. H:mm',
	        LLLL: 'YYYY. MMMM D., dddd H:mm',
	    },
	    meridiemParse: /de|du/i,
	    isPM: function (input) {
	        return input.charAt(1).toLowerCase() === 'u';
	    },
	    meridiem: function (hours, minutes, isLower) {
	        if (hours < 12) {
	            return isLower === true ? 'de' : 'DE';
	        } else {
	            return isLower === true ? 'du' : 'DU';
	        }
	    },
	    calendar: {
	        sameDay: '[ma] LT[-kor]',
	        nextDay: '[holnap] LT[-kor]',
	        nextWeek: function () {
	            return week.call(this, true);
	        },
	        lastDay: '[tegnap] LT[-kor]',
	        lastWeek: function () {
	            return week.call(this, false);
	        },
	        sameElse: 'L',
	    },
	    relativeTime: {
	        future: '%s múlva',
	        past: '%s',
	        s: translate$5,
	        ss: translate$5,
	        m: translate$5,
	        mm: translate$5,
	        h: translate$5,
	        hh: translate$5,
	        d: translate$5,
	        dd: translate$5,
	        M: translate$5,
	        MM: translate$5,
	        y: translate$5,
	        yy: translate$5,
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal: '%d.',
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4, // The week that contains Jan 4th is the first week of the year.
	    },
	});

	//! moment.js locale configuration

	hooks$2.defineLocale('hy-am', {
	    months: {
	        format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split(
	            '_'
	        ),
	        standalone:
	            'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split(
	                '_'
	            ),
	    },
	    monthsShort: 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
	    weekdays:
	        'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split(
	            '_'
	        ),
	    weekdaysShort: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	    weekdaysMin: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD.MM.YYYY',
	        LL: 'D MMMM YYYY թ.',
	        LLL: 'D MMMM YYYY թ., HH:mm',
	        LLLL: 'dddd, D MMMM YYYY թ., HH:mm',
	    },
	    calendar: {
	        sameDay: '[այսօր] LT',
	        nextDay: '[վաղը] LT',
	        lastDay: '[երեկ] LT',
	        nextWeek: function () {
	            return 'dddd [օրը ժամը] LT';
	        },
	        lastWeek: function () {
	            return '[անցած] dddd [օրը ժամը] LT';
	        },
	        sameElse: 'L',
	    },
	    relativeTime: {
	        future: '%s հետո',
	        past: '%s առաջ',
	        s: 'մի քանի վայրկյան',
	        ss: '%d վայրկյան',
	        m: 'րոպե',
	        mm: '%d րոպե',
	        h: 'ժամ',
	        hh: '%d ժամ',
	        d: 'օր',
	        dd: '%d օր',
	        M: 'ամիս',
	        MM: '%d ամիս',
	        y: 'տարի',
	        yy: '%d տարի',
	    },
	    meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
	    isPM: function (input) {
	        return /^(ցերեկվա|երեկոյան)$/.test(input);
	    },
	    meridiem: function (hour) {
	        if (hour < 4) {
	            return 'գիշերվա';
	        } else if (hour < 12) {
	            return 'առավոտվա';
	        } else if (hour < 17) {
	            return 'ցերեկվա';
	        } else {
	            return 'երեկոյան';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'DDD':
	            case 'w':
	            case 'W':
	            case 'DDDo':
	                if (number === 1) {
	                    return number + '-ին';
	                }
	                return number + '-րդ';
	            default:
	                return number;
	        }
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 7, // The week that contains Jan 7th is the first week of the year.
	    },
	});

	//! moment.js locale configuration

	hooks$2.defineLocale('id', {
	    months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split(
	        '_'
	    ),
	    monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Agt_Sep_Okt_Nov_Des'.split('_'),
	    weekdays: 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
	    weekdaysShort: 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
	    weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
	    longDateFormat: {
	        LT: 'HH.mm',
	        LTS: 'HH.mm.ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY [pukul] HH.mm',
	        LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
	    },
	    meridiemParse: /pagi|siang|sore|malam/,
	    meridiemHour: function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'pagi') {
	            return hour;
	        } else if (meridiem === 'siang') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'sore' || meridiem === 'malam') {
	            return hour + 12;
	        }
	    },
	    meridiem: function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'pagi';
	        } else if (hours < 15) {
	            return 'siang';
	        } else if (hours < 19) {
	            return 'sore';
	        } else {
	            return 'malam';
	        }
	    },
	    calendar: {
	        sameDay: '[Hari ini pukul] LT',
	        nextDay: '[Besok pukul] LT',
	        nextWeek: 'dddd [pukul] LT',
	        lastDay: '[Kemarin pukul] LT',
	        lastWeek: 'dddd [lalu pukul] LT',
	        sameElse: 'L',
	    },
	    relativeTime: {
	        future: 'dalam %s',
	        past: '%s yang lalu',
	        s: 'beberapa detik',
	        ss: '%d detik',
	        m: 'semenit',
	        mm: '%d menit',
	        h: 'sejam',
	        hh: '%d jam',
	        d: 'sehari',
	        dd: '%d hari',
	        M: 'sebulan',
	        MM: '%d bulan',
	        y: 'setahun',
	        yy: '%d tahun',
	    },
	    week: {
	        dow: 0, // Sunday is the first day of the week.
	        doy: 6, // The week that contains Jan 6th is the first week of the year.
	    },
	});

	//! moment.js locale configuration

	function plural$3(n) {
	    if (n % 100 === 11) {
	        return true;
	    } else if (n % 10 === 1) {
	        return false;
	    }
	    return true;
	}
	function translate$6(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':
	            return withoutSuffix || isFuture
	                ? 'nokkrar sekúndur'
	                : 'nokkrum sekúndum';
	        case 'ss':
	            if (plural$3(number)) {
	                return (
	                    result +
	                    (withoutSuffix || isFuture ? 'sekúndur' : 'sekúndum')
	                );
	            }
	            return result + 'sekúnda';
	        case 'm':
	            return withoutSuffix ? 'mínúta' : 'mínútu';
	        case 'mm':
	            if (plural$3(number)) {
	                return (
	                    result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum')
	                );
	            } else if (withoutSuffix) {
	                return result + 'mínúta';
	            }
	            return result + 'mínútu';
	        case 'hh':
	            if (plural$3(number)) {
	                return (
	                    result +
	                    (withoutSuffix || isFuture
	                        ? 'klukkustundir'
	                        : 'klukkustundum')
	                );
	            }
	            return result + 'klukkustund';
	        case 'd':
	            if (withoutSuffix) {
	                return 'dagur';
	            }
	            return isFuture ? 'dag' : 'degi';
	        case 'dd':
	            if (plural$3(number)) {
	                if (withoutSuffix) {
	                    return result + 'dagar';
	                }
	                return result + (isFuture ? 'daga' : 'dögum');
	            } else if (withoutSuffix) {
	                return result + 'dagur';
	            }
	            return result + (isFuture ? 'dag' : 'degi');
	        case 'M':
	            if (withoutSuffix) {
	                return 'mánuður';
	            }
	            return isFuture ? 'mánuð' : 'mánuði';
	        case 'MM':
	            if (plural$3(number)) {
	                if (withoutSuffix) {
	                    return result + 'mánuðir';
	                }
	                return result + (isFuture ? 'mánuði' : 'mánuðum');
	            } else if (withoutSuffix) {
	                return result + 'mánuður';
	            }
	            return result + (isFuture ? 'mánuð' : 'mánuði');
	        case 'y':
	            return withoutSuffix || isFuture ? 'ár' : 'ári';
	        case 'yy':
	            if (plural$3(number)) {
	                return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
	            }
	            return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
	    }
	}

	hooks$2.defineLocale('is', {
	    months: 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split(
	        '_'
	    ),
	    monthsShort: 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
	    weekdays:
	        'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split(
	            '_'
	        ),
	    weekdaysShort: 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
	    weekdaysMin: 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
	    longDateFormat: {
	        LT: 'H:mm',
	        LTS: 'H:mm:ss',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY [kl.] H:mm',
	        LLLL: 'dddd, D. MMMM YYYY [kl.] H:mm',
	    },
	    calendar: {
	        sameDay: '[í dag kl.] LT',
	        nextDay: '[á morgun kl.] LT',
	        nextWeek: 'dddd [kl.] LT',
	        lastDay: '[í gær kl.] LT',
	        lastWeek: '[síðasta] dddd [kl.] LT',
	        sameElse: 'L',
	    },
	    relativeTime: {
	        future: 'eftir %s',
	        past: 'fyrir %s síðan',
	        s: translate$6,
	        ss: translate$6,
	        m: translate$6,
	        mm: translate$6,
	        h: 'klukkustund',
	        hh: translate$6,
	        d: translate$6,
	        dd: translate$6,
	        M: translate$6,
	        MM: translate$6,
	        y: translate$6,
	        yy: translate$6,
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal: '%d.',
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4, // The week that contains Jan 4th is the first week of the year.
	    },
	});

	//! moment.js locale configuration

	hooks$2.defineLocale('it', {
	    months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split(
	        '_'
	    ),
	    monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	    weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split(
	        '_'
	    ),
	    weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
	    weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd D MMMM YYYY HH:mm',
	    },
	    calendar: {
	        sameDay: function () {
	            return (
	                '[Oggi a' +
	                (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
	                ']LT'
	            );
	        },
	        nextDay: function () {
	            return (
	                '[Domani a' +
	                (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
	                ']LT'
	            );
	        },
	        nextWeek: function () {
	            return (
	                'dddd [a' +
	                (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
	                ']LT'
	            );
	        },
	        lastDay: function () {
	            return (
	                '[Ieri a' +
	                (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
	                ']LT'
	            );
	        },
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return (
	                        '[La scorsa] dddd [a' +
	                        (this.hours() > 1
	                            ? 'lle '
	                            : this.hours() === 0
	                            ? ' '
	                            : "ll'") +
	                        ']LT'
	                    );
	                default:
	                    return (
	                        '[Lo scorso] dddd [a' +
	                        (this.hours() > 1
	                            ? 'lle '
	                            : this.hours() === 0
	                            ? ' '
	                            : "ll'") +
	                        ']LT'
	                    );
	            }
	        },
	        sameElse: 'L',
	    },
	    relativeTime: {
	        future: 'tra %s',
	        past: '%s fa',
	        s: 'alcuni secondi',
	        ss: '%d secondi',
	        m: 'un minuto',
	        mm: '%d minuti',
	        h: "un'ora",
	        hh: '%d ore',
	        d: 'un giorno',
	        dd: '%d giorni',
	        w: 'una settimana',
	        ww: '%d settimane',
	        M: 'un mese',
	        MM: '%d mesi',
	        y: 'un anno',
	        yy: '%d anni',
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}º/,
	    ordinal: '%dº',
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4, // The week that contains Jan 4th is the first week of the year.
	    },
	});

	//! moment.js locale configuration

	hooks$2.defineLocale('ja', {
	    eras: [
	        {
	            since: '2019-05-01',
	            offset: 1,
	            name: '令和',
	            narrow: '㋿',
	            abbr: 'R',
	        },
	        {
	            since: '1989-01-08',
	            until: '2019-04-30',
	            offset: 1,
	            name: '平成',
	            narrow: '㍻',
	            abbr: 'H',
	        },
	        {
	            since: '1926-12-25',
	            until: '1989-01-07',
	            offset: 1,
	            name: '昭和',
	            narrow: '㍼',
	            abbr: 'S',
	        },
	        {
	            since: '1912-07-30',
	            until: '1926-12-24',
	            offset: 1,
	            name: '大正',
	            narrow: '㍽',
	            abbr: 'T',
	        },
	        {
	            since: '1873-01-01',
	            until: '1912-07-29',
	            offset: 6,
	            name: '明治',
	            narrow: '㍾',
	            abbr: 'M',
	        },
	        {
	            since: '0001-01-01',
	            until: '1873-12-31',
	            offset: 1,
	            name: '西暦',
	            narrow: 'AD',
	            abbr: 'AD',
	        },
	        {
	            since: '0000-12-31',
	            until: -Infinity,
	            offset: 1,
	            name: '紀元前',
	            narrow: 'BC',
	            abbr: 'BC',
	        } ],
	    eraYearOrdinalRegex: /(元|\d+)年/,
	    eraYearOrdinalParse: function (input, match) {
	        return match[1] === '元' ? 1 : parseInt(match[1] || input, 10);
	    },
	    months: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	        '_'
	    ),
	    weekdays: '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
	    weekdaysShort: '日_月_火_水_木_金_土'.split('_'),
	    weekdaysMin: '日_月_火_水_木_金_土'.split('_'),
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'YYYY/MM/DD',
	        LL: 'YYYY年M月D日',
	        LLL: 'YYYY年M月D日 HH:mm',
	        LLLL: 'YYYY年M月D日 dddd HH:mm',
	        l: 'YYYY/MM/DD',
	        ll: 'YYYY年M月D日',
	        lll: 'YYYY年M月D日 HH:mm',
	        llll: 'YYYY年M月D日(ddd) HH:mm',
	    },
	    meridiemParse: /午前|午後/i,
	    isPM: function (input) {
	        return input === '午後';
	    },
	    meridiem: function (hour, minute, isLower) {
	        if (hour < 12) {
	            return '午前';
	        } else {
	            return '午後';
	        }
	    },
	    calendar: {
	        sameDay: '[今日] LT',
	        nextDay: '[明日] LT',
	        nextWeek: function (now) {
	            if (now.week() !== this.week()) {
	                return '[来週]dddd LT';
	            } else {
	                return 'dddd LT';
	            }
	        },
	        lastDay: '[昨日] LT',
	        lastWeek: function (now) {
	            if (this.week() !== now.week()) {
	                return '[先週]dddd LT';
	            } else {
	                return 'dddd LT';
	            }
	        },
	        sameElse: 'L',
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}日/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'y':
	                return number === 1 ? '元年' : number + '年';
	            case 'd':
	            case 'D':
	            case 'DDD':
	                return number + '日';
	            default:
	                return number;
	        }
	    },
	    relativeTime: {
	        future: '%s後',
	        past: '%s前',
	        s: '数秒',
	        ss: '%d秒',
	        m: '1分',
	        mm: '%d分',
	        h: '1時間',
	        hh: '%d時間',
	        d: '1日',
	        dd: '%d日',
	        M: '1ヶ月',
	        MM: '%dヶ月',
	        y: '1年',
	        yy: '%d年',
	    },
	});

	//! moment.js locale configuration

	hooks$2.defineLocale('jv', {
	    months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split(
	        '_'
	    ),
	    monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
	    weekdays: 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
	    weekdaysShort: 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
	    weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
	    longDateFormat: {
	        LT: 'HH.mm',
	        LTS: 'HH.mm.ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY [pukul] HH.mm',
	        LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
	    },
	    meridiemParse: /enjing|siyang|sonten|ndalu/,
	    meridiemHour: function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'enjing') {
	            return hour;
	        } else if (meridiem === 'siyang') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
	            return hour + 12;
	        }
	    },
	    meridiem: function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'enjing';
	        } else if (hours < 15) {
	            return 'siyang';
	        } else if (hours < 19) {
	            return 'sonten';
	        } else {
	            return 'ndalu';
	        }
	    },
	    calendar: {
	        sameDay: '[Dinten puniko pukul] LT',
	        nextDay: '[Mbenjang pukul] LT',
	        nextWeek: 'dddd [pukul] LT',
	        lastDay: '[Kala wingi pukul] LT',
	        lastWeek: 'dddd [kepengker pukul] LT',
	        sameElse: 'L',
	    },
	    relativeTime: {
	        future: 'wonten ing %s',
	        past: '%s ingkang kepengker',
	        s: 'sawetawis detik',
	        ss: '%d detik',
	        m: 'setunggal menit',
	        mm: '%d menit',
	        h: 'setunggal jam',
	        hh: '%d jam',
	        d: 'sedinten',
	        dd: '%d dinten',
	        M: 'sewulan',
	        MM: '%d wulan',
	        y: 'setaun',
	        yy: '%d taun',
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 7, // The week that contains Jan 7th is the first week of the year.
	    },
	});

	//! moment.js locale configuration

	hooks$2.defineLocale('ka', {
	    months: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split(
	        '_'
	    ),
	    monthsShort: 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
	    weekdays: {
	        standalone:
	            'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split(
	                '_'
	            ),
	        format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split(
	            '_'
	        ),
	        isFormat: /(წინა|შემდეგ)/,
	    },
	    weekdaysShort: 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
	    weekdaysMin: 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd, D MMMM YYYY HH:mm',
	    },
	    calendar: {
	        sameDay: '[დღეს] LT[-ზე]',
	        nextDay: '[ხვალ] LT[-ზე]',
	        lastDay: '[გუშინ] LT[-ზე]',
	        nextWeek: '[შემდეგ] dddd LT[-ზე]',
	        lastWeek: '[წინა] dddd LT-ზე',
	        sameElse: 'L',
	    },
	    relativeTime: {
	        future: function (s) {
	            return s.replace(
	                /(წამ|წუთ|საათ|წელ|დღ|თვ)(ი|ე)/,
	                function ($0, $1, $2) {
	                    return $2 === 'ი' ? $1 + 'ში' : $1 + $2 + 'ში';
	                }
	            );
	        },
	        past: function (s) {
	            if (/(წამი|წუთი|საათი|დღე|თვე)/.test(s)) {
	                return s.replace(/(ი|ე)$/, 'ის წინ');
	            }
	            if (/წელი/.test(s)) {
	                return s.replace(/წელი$/, 'წლის წინ');
	            }
	            return s;
	        },
	        s: 'რამდენიმე წამი',
	        ss: '%d წამი',
	        m: 'წუთი',
	        mm: '%d წუთი',
	        h: 'საათი',
	        hh: '%d საათი',
	        d: 'დღე',
	        dd: '%d დღე',
	        M: 'თვე',
	        MM: '%d თვე',
	        y: 'წელი',
	        yy: '%d წელი',
	    },
	    dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
	    ordinal: function (number) {
	        if (number === 0) {
	            return number;
	        }
	        if (number === 1) {
	            return number + '-ლი';
	        }
	        if (
	            number < 20 ||
	            (number <= 100 && number % 20 === 0) ||
	            number % 100 === 0
	        ) {
	            return 'მე-' + number;
	        }
	        return number + '-ე';
	    },
	    week: {
	        dow: 1,
	        doy: 7,
	    },
	});

	//! moment.js locale configuration

	var suffixes$1 = {
	    0: '-ші',
	    1: '-ші',
	    2: '-ші',
	    3: '-ші',
	    4: '-ші',
	    5: '-ші',
	    6: '-шы',
	    7: '-ші',
	    8: '-ші',
	    9: '-шы',
	    10: '-шы',
	    20: '-шы',
	    30: '-шы',
	    40: '-шы',
	    50: '-ші',
	    60: '-шы',
	    70: '-ші',
	    80: '-ші',
	    90: '-шы',
	    100: '-ші',
	};

	hooks$2.defineLocale('kk', {
	    months: 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split(
	        '_'
	    ),
	    monthsShort: 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
	    weekdays: 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split(
	        '_'
	    ),
	    weekdaysShort: 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
	    weekdaysMin: 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD.MM.YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd, D MMMM YYYY HH:mm',
	    },
	    calendar: {
	        sameDay: '[Бүгін сағат] LT',
	        nextDay: '[Ертең сағат] LT',
	        nextWeek: 'dddd [сағат] LT',
	        lastDay: '[Кеше сағат] LT',
	        lastWeek: '[Өткен аптаның] dddd [сағат] LT',
	        sameElse: 'L',
	    },
	    relativeTime: {
	        future: '%s ішінде',
	        past: '%s бұрын',
	        s: 'бірнеше секунд',
	        ss: '%d секунд',
	        m: 'бір минут',
	        mm: '%d минут',
	        h: 'бір сағат',
	        hh: '%d сағат',
	        d: 'бір күн',
	        dd: '%d күн',
	        M: 'бір ай',
	        MM: '%d ай',
	        y: 'бір жыл',
	        yy: '%d жыл',
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
	    ordinal: function (number) {
	        var a = number % 10,
	            b = number >= 100 ? 100 : null;
	        return number + (suffixes$1[number] || suffixes$1[a] || suffixes$1[b]);
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 7, // The week that contains Jan 7th is the first week of the year.
	    },
	});

	//! moment.js locale configuration

	var symbolMap$7 = {
	        1: '១',
	        2: '២',
	        3: '៣',
	        4: '៤',
	        5: '៥',
	        6: '៦',
	        7: '៧',
	        8: '៨',
	        9: '៩',
	        0: '០',
	    },
	    numberMap$6 = {
	        '១': '1',
	        '២': '2',
	        '៣': '3',
	        '៤': '4',
	        '៥': '5',
	        '៦': '6',
	        '៧': '7',
	        '៨': '8',
	        '៩': '9',
	        '០': '0',
	    };

	hooks$2.defineLocale('km', {
	    months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
	        '_'
	    ),
	    monthsShort:
	        'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
	            '_'
	        ),
	    weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	    weekdaysShort: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
	    weekdaysMin: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
	    weekdaysParseExact: true,
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd, D MMMM YYYY HH:mm',
	    },
	    meridiemParse: /ព្រឹក|ល្ងាច/,
	    isPM: function (input) {
	        return input === 'ល្ងាច';
	    },
	    meridiem: function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ព្រឹក';
	        } else {
	            return 'ល្ងាច';
	        }
	    },
	    calendar: {
	        sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
	        nextDay: '[ស្អែក ម៉ោង] LT',
	        nextWeek: 'dddd [ម៉ោង] LT',
	        lastDay: '[ម្សិលមិញ ម៉ោង] LT',
	        lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
	        sameElse: 'L',
	    },
	    relativeTime: {
	        future: '%sទៀត',
	        past: '%sមុន',
	        s: 'ប៉ុន្មានវិនាទី',
	        ss: '%d វិនាទី',
	        m: 'មួយនាទី',
	        mm: '%d នាទី',
	        h: 'មួយម៉ោង',
	        hh: '%d ម៉ោង',
	        d: 'មួយថ្ងៃ',
	        dd: '%d ថ្ងៃ',
	        M: 'មួយខែ',
	        MM: '%d ខែ',
	        y: 'មួយឆ្នាំ',
	        yy: '%d ឆ្នាំ',
	    },
	    dayOfMonthOrdinalParse: /ទី\d{1,2}/,
	    ordinal: 'ទី%d',
	    preparse: function (string) {
	        return string.replace(/[១២៣៤៥៦៧៨៩០]/g, function (match) {
	            return numberMap$6[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap$7[match];
	        });
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4, // The week that contains Jan 4th is the first week of the year.
	    },
	});

	//! moment.js locale configuration

	var symbolMap$8 = {
	        1: '೧',
	        2: '೨',
	        3: '೩',
	        4: '೪',
	        5: '೫',
	        6: '೬',
	        7: '೭',
	        8: '೮',
	        9: '೯',
	        0: '೦',
	    },
	    numberMap$7 = {
	        '೧': '1',
	        '೨': '2',
	        '೩': '3',
	        '೪': '4',
	        '೫': '5',
	        '೬': '6',
	        '೭': '7',
	        '೮': '8',
	        '೯': '9',
	        '೦': '0',
	    };

	hooks$2.defineLocale('kn', {
	    months: 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split(
	        '_'
	    ),
	    monthsShort:
	        'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂ_ಅಕ್ಟೋ_ನವೆಂ_ಡಿಸೆಂ'.split(
	            '_'
	        ),
	    monthsParseExact: true,
	    weekdays: 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split(
	        '_'
	    ),
	    weekdaysShort: 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
	    weekdaysMin: 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
	    longDateFormat: {
	        LT: 'A h:mm',
	        LTS: 'A h:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY, A h:mm',
	        LLLL: 'dddd, D MMMM YYYY, A h:mm',
	    },
	    calendar: {
	        sameDay: '[ಇಂದು] LT',
	        nextDay: '[ನಾಳೆ] LT',
	        nextWeek: 'dddd, LT',
	        lastDay: '[ನಿನ್ನೆ] LT',
	        lastWeek: '[ಕೊನೆಯ] dddd, LT',
	        sameElse: 'L',
	    },
	    relativeTime: {
	        future: '%s ನಂತರ',
	        past: '%s ಹಿಂದೆ',
	        s: 'ಕೆಲವು ಕ್ಷಣಗಳು',
	        ss: '%d ಸೆಕೆಂಡುಗಳು',
	        m: 'ಒಂದು ನಿಮಿಷ',
	        mm: '%d ನಿಮಿಷ',
	        h: 'ಒಂದು ಗಂಟೆ',
	        hh: '%d ಗಂಟೆ',
	        d: 'ಒಂದು ದಿನ',
	        dd: '%d ದಿನ',
	        M: 'ಒಂದು ತಿಂಗಳು',
	        MM: '%d ತಿಂಗಳು',
	        y: 'ಒಂದು ವರ್ಷ',
	        yy: '%d ವರ್ಷ',
	    },
	    preparse: function (string) {
	        return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
	            return numberMap$7[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap$8[match];
	        });
	    },
	    meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
	    meridiemHour: function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'ರಾತ್ರಿ') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
	            return hour;
	        } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'ಸಂಜೆ') {
	            return hour + 12;
	        }
	    },
	    meridiem: function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ರಾತ್ರಿ';
	        } else if (hour < 10) {
	            return 'ಬೆಳಿಗ್ಗೆ';
	        } else if (hour < 17) {
	            return 'ಮಧ್ಯಾಹ್ನ';
	        } else if (hour < 20) {
	            return 'ಸಂಜೆ';
	        } else {
	            return 'ರಾತ್ರಿ';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
	    ordinal: function (number) {
	        return number + 'ನೇ';
	    },
	    week: {
	        dow: 0, // Sunday is the first day of the week.
	        doy: 6, // The week that contains Jan 6th is the first week of the year.
	    },
	});

	//! moment.js locale configuration

	hooks$2.defineLocale('ko', {
	    months: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	    monthsShort: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split(
	        '_'
	    ),
	    weekdays: '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
	    weekdaysShort: '일_월_화_수_목_금_토'.split('_'),
	    weekdaysMin: '일_월_화_수_목_금_토'.split('_'),
	    longDateFormat: {
	        LT: 'A h:mm',
	        LTS: 'A h:mm:ss',
	        L: 'YYYY.MM.DD.',
	        LL: 'YYYY년 MMMM D일',
	        LLL: 'YYYY년 MMMM D일 A h:mm',
	        LLLL: 'YYYY년 MMMM D일 dddd A h:mm',
	        l: 'YYYY.MM.DD.',
	        ll: 'YYYY년 MMMM D일',
	        lll: 'YYYY년 MMMM D일 A h:mm',
	        llll: 'YYYY년 MMMM D일 dddd A h:mm',
	    },
	    calendar: {
	        sameDay: '오늘 LT',
	        nextDay: '내일 LT',
	        nextWeek: 'dddd LT',
	        lastDay: '어제 LT',
	        lastWeek: '지난주 dddd LT',
	        sameElse: 'L',
	    },
	    relativeTime: {
	        future: '%s 후',
	        past: '%s 전',
	        s: '몇 초',
	        ss: '%d초',
	        m: '1분',
	        mm: '%d분',
	        h: '한 시간',
	        hh: '%d시간',
	        d: '하루',
	        dd: '%d일',
	        M: '한 달',
	        MM: '%d달',
	        y: '일 년',
	        yy: '%d년',
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(일|월|주)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'd':
	            case 'D':
	            case 'DDD':
	                return number + '일';
	            case 'M':
	                return number + '월';
	            case 'w':
	            case 'W':
	                return number + '주';
	            default:
	                return number;
	        }
	    },
	    meridiemParse: /오전|오후/,
	    isPM: function (token) {
	        return token === '오후';
	    },
	    meridiem: function (hour, minute, isUpper) {
	        return hour < 12 ? '오전' : '오후';
	    },
	});

	//! moment.js locale configuration

	var suffixes$2 = {
	    0: '-чү',
	    1: '-чи',
	    2: '-чи',
	    3: '-чү',
	    4: '-чү',
	    5: '-чи',
	    6: '-чы',
	    7: '-чи',
	    8: '-чи',
	    9: '-чу',
	    10: '-чу',
	    20: '-чы',
	    30: '-чу',
	    40: '-чы',
	    50: '-чү',
	    60: '-чы',
	    70: '-чи',
	    80: '-чи',
	    90: '-чу',
	    100: '-чү',
	};

	hooks$2.defineLocale('ky', {
	    months: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split(
	        '_'
	    ),
	    monthsShort: 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split(
	        '_'
	    ),
	    weekdays: 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split(
	        '_'
	    ),
	    weekdaysShort: 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
	    weekdaysMin: 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD.MM.YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd, D MMMM YYYY HH:mm',
	    },
	    calendar: {
	        sameDay: '[Бүгүн саат] LT',
	        nextDay: '[Эртең саат] LT',
	        nextWeek: 'dddd [саат] LT',
	        lastDay: '[Кечээ саат] LT',
	        lastWeek: '[Өткөн аптанын] dddd [күнү] [саат] LT',
	        sameElse: 'L',
	    },
	    relativeTime: {
	        future: '%s ичинде',
	        past: '%s мурун',
	        s: 'бирнече секунд',
	        ss: '%d секунд',
	        m: 'бир мүнөт',
	        mm: '%d мүнөт',
	        h: 'бир саат',
	        hh: '%d саат',
	        d: 'бир күн',
	        dd: '%d күн',
	        M: 'бир ай',
	        MM: '%d ай',
	        y: 'бир жыл',
	        yy: '%d жыл',
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
	    ordinal: function (number) {
	        var a = number % 10,
	            b = number >= 100 ? 100 : null;
	        return number + (suffixes$2[number] || suffixes$2[a] || suffixes$2[b]);
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 7, // The week that contains Jan 7th is the first week of the year.
	    },
	});

	//! moment.js locale configuration

	function processRelativeTime$5(number, withoutSuffix, key, isFuture) {
	    var format = {
	        m: ['eng Minutt', 'enger Minutt'],
	        h: ['eng Stonn', 'enger Stonn'],
	        d: ['een Dag', 'engem Dag'],
	        M: ['ee Mount', 'engem Mount'],
	        y: ['ee Joer', 'engem Joer'],
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	function processFutureTime(string) {
	    var number = string.substr(0, string.indexOf(' '));
	    if (eifelerRegelAppliesToNumber(number)) {
	        return 'a ' + string;
	    }
	    return 'an ' + string;
	}
	function processPastTime(string) {
	    var number = string.substr(0, string.indexOf(' '));
	    if (eifelerRegelAppliesToNumber(number)) {
	        return 'viru ' + string;
	    }
	    return 'virun ' + string;
	}
	/**
	 * Returns true if the word before the given number loses the '-n' ending.
	 * e.g. 'an 10 Deeg' but 'a 5 Deeg'
	 *
	 * @param number {integer}
	 * @returns {boolean}
	 */
	function eifelerRegelAppliesToNumber(number) {
	    number = parseInt(number, 10);
	    if (isNaN(number)) {
	        return false;
	    }
	    if (number < 0) {
	        // Negative Number --> always true
	        return true;
	    } else if (number < 10) {
	        // Only 1 digit
	        if (4 <= number && number <= 7) {
	            return true;
	        }
	        return false;
	    } else if (number < 100) {
	        // 2 digits
	        var lastDigit = number % 10,
	            firstDigit = number / 10;
	        if (lastDigit === 0) {
	            return eifelerRegelAppliesToNumber(firstDigit);
	        }
	        return eifelerRegelAppliesToNumber(lastDigit);
	    } else if (number < 10000) {
	        // 3 or 4 digits --> recursively check first digit
	        while (number >= 10) {
	            number = number / 10;
	        }
	        return eifelerRegelAppliesToNumber(number);
	    } else {
	        // Anything larger than 4 digits: recursively check first n-3 digits
	        number = number / 1000;
	        return eifelerRegelAppliesToNumber(number);
	    }
	}

	hooks$2.defineLocale('lb', {
	    months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split(
	        '_'
	    ),
	    monthsShort:
	        'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split(
	            '_'
	        ),
	    monthsParseExact: true,
	    weekdays:
	        'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split(
	            '_'
	        ),
	    weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
	    weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact: true,
	    longDateFormat: {
	        LT: 'H:mm [Auer]',
	        LTS: 'H:mm:ss [Auer]',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm [Auer]',
	        LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]',
	    },
	    calendar: {
	        sameDay: '[Haut um] LT',
	        sameElse: 'L',
	        nextDay: '[Muer um] LT',
	        nextWeek: 'dddd [um] LT',
	        lastDay: '[Gëschter um] LT',
	        lastWeek: function () {
	            // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
	            switch (this.day()) {
	                case 2:
	                case 4:
	                    return '[Leschten] dddd [um] LT';
	                default:
	                    return '[Leschte] dddd [um] LT';
	            }
	        },
	    },
	    relativeTime: {
	        future: processFutureTime,
	        past: processPastTime,
	        s: 'e puer Sekonnen',
	        ss: '%d Sekonnen',
	        m: processRelativeTime$5,
	        mm: '%d Minutten',
	        h: processRelativeTime$5,
	        hh: '%d Stonnen',
	        d: processRelativeTime$5,
	        dd: '%d Deeg',
	        M: processRelativeTime$5,
	        MM: '%d Méint',
	        y: processRelativeTime$5,
	        yy: '%d Joer',
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal: '%d.',
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4, // The week that contains Jan 4th is the first week of the year.
	    },
	});

	//! moment.js locale configuration

	hooks$2.defineLocale('lo', {
	    months: 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split(
	        '_'
	    ),
	    monthsShort:
	        'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split(
	            '_'
	        ),
	    weekdays: 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	    weekdaysShort: 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	    weekdaysMin: 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
	    weekdaysParseExact: true,
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'ວັນdddd D MMMM YYYY HH:mm',
	    },
	    meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
	    isPM: function (input) {
	        return input === 'ຕອນແລງ';
	    },
	    meridiem: function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ຕອນເຊົ້າ';
	        } else {
	            return 'ຕອນແລງ';
	        }
	    },
	    calendar: {
	        sameDay: '[ມື້ນີ້ເວລາ] LT',
	        nextDay: '[ມື້ອື່ນເວລາ] LT',
	        nextWeek: '[ວັນ]dddd[ໜ້າເວລາ] LT',
	        lastDay: '[ມື້ວານນີ້ເວລາ] LT',
	        lastWeek: '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
	        sameElse: 'L',
	    },
	    relativeTime: {
	        future: 'ອີກ %s',
	        past: '%sຜ່ານມາ',
	        s: 'ບໍ່ເທົ່າໃດວິນາທີ',
	        ss: '%d ວິນາທີ',
	        m: '1 ນາທີ',
	        mm: '%d ນາທີ',
	        h: '1 ຊົ່ວໂມງ',
	        hh: '%d ຊົ່ວໂມງ',
	        d: '1 ມື້',
	        dd: '%d ມື້',
	        M: '1 ເດືອນ',
	        MM: '%d ເດືອນ',
	        y: '1 ປີ',
	        yy: '%d ປີ',
	    },
	    dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
	    ordinal: function (number) {
	        return 'ທີ່' + number;
	    },
	});

	//! moment.js locale configuration

	var units = {
	    ss: 'sekundė_sekundžių_sekundes',
	    m: 'minutė_minutės_minutę',
	    mm: 'minutės_minučių_minutes',
	    h: 'valanda_valandos_valandą',
	    hh: 'valandos_valandų_valandas',
	    d: 'diena_dienos_dieną',
	    dd: 'dienos_dienų_dienas',
	    M: 'mėnuo_mėnesio_mėnesį',
	    MM: 'mėnesiai_mėnesių_mėnesius',
	    y: 'metai_metų_metus',
	    yy: 'metai_metų_metus',
	};
	function translateSeconds(number, withoutSuffix, key, isFuture) {
	    if (withoutSuffix) {
	        return 'kelios sekundės';
	    } else {
	        return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
	    }
	}
	function translateSingular(number, withoutSuffix, key, isFuture) {
	    return withoutSuffix
	        ? forms(key)[0]
	        : isFuture
	        ? forms(key)[1]
	        : forms(key)[2];
	}
	function special(number) {
	    return number % 10 === 0 || (number > 10 && number < 20);
	}
	function forms(key) {
	    return units[key].split('_');
	}
	function translate$7(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    if (number === 1) {
	        return (
	            result + translateSingular(number, withoutSuffix, key[0], isFuture)
	        );
	    } else if (withoutSuffix) {
	        return result + (special(number) ? forms(key)[1] : forms(key)[0]);
	    } else {
	        if (isFuture) {
	            return result + forms(key)[1];
	        } else {
	            return result + (special(number) ? forms(key)[1] : forms(key)[2]);
	        }
	    }
	}
	hooks$2.defineLocale('lt', {
	    months: {
	        format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split(
	            '_'
	        ),
	        standalone:
	            'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split(
	                '_'
	            ),
	        isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/,
	    },
	    monthsShort: 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
	    weekdays: {
	        format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split(
	            '_'
	        ),
	        standalone:
	            'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split(
	                '_'
	            ),
	        isFormat: /dddd HH:mm/,
	    },
	    weekdaysShort: 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
	    weekdaysMin: 'S_P_A_T_K_Pn_Š'.split('_'),
	    weekdaysParseExact: true,
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'YYYY-MM-DD',
	        LL: 'YYYY [m.] MMMM D [d.]',
	        LLL: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	        LLLL: 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
	        l: 'YYYY-MM-DD',
	        ll: 'YYYY [m.] MMMM D [d.]',
	        lll: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	        llll: 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]',
	    },
	    calendar: {
	        sameDay: '[Šiandien] LT',
	        nextDay: '[Rytoj] LT',
	        nextWeek: 'dddd LT',
	        lastDay: '[Vakar] LT',
	        lastWeek: '[Praėjusį] dddd LT',
	        sameElse: 'L',
	    },
	    relativeTime: {
	        future: 'po %s',
	        past: 'prieš %s',
	        s: translateSeconds,
	        ss: translate$7,
	        m: translateSingular,
	        mm: translate$7,
	        h: translateSingular,
	        hh: translate$7,
	        d: translateSingular,
	        dd: translate$7,
	        M: translateSingular,
	        MM: translate$7,
	        y: translateSingular,
	        yy: translate$7,
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-oji/,
	    ordinal: function (number) {
	        return number + '-oji';
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4, // The week that contains Jan 4th is the first week of the year.
	    },
	});

	//! moment.js locale configuration

	var units$1 = {
	    ss: 'sekundes_sekundēm_sekunde_sekundes'.split('_'),
	    m: 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	    mm: 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	    h: 'stundas_stundām_stunda_stundas'.split('_'),
	    hh: 'stundas_stundām_stunda_stundas'.split('_'),
	    d: 'dienas_dienām_diena_dienas'.split('_'),
	    dd: 'dienas_dienām_diena_dienas'.split('_'),
	    M: 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	    MM: 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	    y: 'gada_gadiem_gads_gadi'.split('_'),
	    yy: 'gada_gadiem_gads_gadi'.split('_'),
	};
	/**
	 * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
	 */
	function format$2(forms, number, withoutSuffix) {
	    if (withoutSuffix) {
	        // E.g. "21 minūte", "3 minūtes".
	        return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
	    } else {
	        // E.g. "21 minūtes" as in "pēc 21 minūtes".
	        // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
	        return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
	    }
	}
	function relativeTimeWithPlural$1(number, withoutSuffix, key) {
	    return number + ' ' + format$2(units$1[key], number, withoutSuffix);
	}
	function relativeTimeWithSingular(number, withoutSuffix, key) {
	    return format$2(units$1[key], number, withoutSuffix);
	}
	function relativeSeconds(number, withoutSuffix) {
	    return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
	}

	hooks$2.defineLocale('lv', {
	    months: 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split(
	        '_'
	    ),
	    monthsShort: 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
	    weekdays:
	        'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split(
	            '_'
	        ),
	    weekdaysShort: 'Sv_P_O_T_C_Pk_S'.split('_'),
	    weekdaysMin: 'Sv_P_O_T_C_Pk_S'.split('_'),
	    weekdaysParseExact: true,
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD.MM.YYYY.',
	        LL: 'YYYY. [gada] D. MMMM',
	        LLL: 'YYYY. [gada] D. MMMM, HH:mm',
	        LLLL: 'YYYY. [gada] D. MMMM, dddd, HH:mm',
	    },
	    calendar: {
	        sameDay: '[Šodien pulksten] LT',
	        nextDay: '[Rīt pulksten] LT',
	        nextWeek: 'dddd [pulksten] LT',
	        lastDay: '[Vakar pulksten] LT',
	        lastWeek: '[Pagājušā] dddd [pulksten] LT',
	        sameElse: 'L',
	    },
	    relativeTime: {
	        future: 'pēc %s',
	        past: 'pirms %s',
	        s: relativeSeconds,
	        ss: relativeTimeWithPlural$1,
	        m: relativeTimeWithSingular,
	        mm: relativeTimeWithPlural$1,
	        h: relativeTimeWithSingular,
	        hh: relativeTimeWithPlural$1,
	        d: relativeTimeWithSingular,
	        dd: relativeTimeWithPlural$1,
	        M: relativeTimeWithSingular,
	        MM: relativeTimeWithPlural$1,
	        y: relativeTimeWithSingular,
	        yy: relativeTimeWithPlural$1,
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal: '%d.',
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4, // The week that contains Jan 4th is the first week of the year.
	    },
	});

	//! moment.js locale configuration

	var translator = {
	    words: {
	        //Different grammatical cases
	        ss: ['sekund', 'sekunda', 'sekundi'],
	        m: ['jedan minut', 'jednog minuta'],
	        mm: ['minut', 'minuta', 'minuta'],
	        h: ['jedan sat', 'jednog sata'],
	        hh: ['sat', 'sata', 'sati'],
	        dd: ['dan', 'dana', 'dana'],
	        MM: ['mjesec', 'mjeseca', 'mjeseci'],
	        yy: ['godina', 'godine', 'godina'],
	    },
	    correctGrammaticalCase: function (number, wordKey) {
	        return number === 1
	            ? wordKey[0]
	            : number >= 2 && number <= 4
	            ? wordKey[1]
	            : wordKey[2];
	    },
	    translate: function (number, withoutSuffix, key) {
	        var wordKey = translator.words[key];
	        if (key.length === 1) {
	            return withoutSuffix ? wordKey[0] : wordKey[1];
	        } else {
	            return (
	                number +
	                ' ' +
	                translator.correctGrammaticalCase(number, wordKey)
	            );
	        }
	    },
	};

	hooks$2.defineLocale('me', {
	    months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split(
	        '_'
	    ),
	    monthsShort:
	        'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
	        '_'
	    ),
	    weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	    weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact: true,
	    longDateFormat: {
	        LT: 'H:mm',
	        LTS: 'H:mm:ss',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm',
	        LLLL: 'dddd, D. MMMM YYYY H:mm',
	    },
	    calendar: {
	        sameDay: '[danas u] LT',
	        nextDay: '[sjutra u] LT',

	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedjelju] [u] LT';
	                case 3:
	                    return '[u] [srijedu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay: '[juče u] LT',
	        lastWeek: function () {
	            var lastWeekDays = [
	                '[prošle] [nedjelje] [u] LT',
	                '[prošlog] [ponedjeljka] [u] LT',
	                '[prošlog] [utorka] [u] LT',
	                '[prošle] [srijede] [u] LT',
	                '[prošlog] [četvrtka] [u] LT',
	                '[prošlog] [petka] [u] LT',
	                '[prošle] [subote] [u] LT' ];
	            return lastWeekDays[this.day()];
	        },
	        sameElse: 'L',
	    },
	    relativeTime: {
	        future: 'za %s',
	        past: 'prije %s',
	        s: 'nekoliko sekundi',
	        ss: translator.translate,
	        m: translator.translate,
	        mm: translator.translate,
	        h: translator.translate,
	        hh: translator.translate,
	        d: 'dan',
	        dd: translator.translate,
	        M: 'mjesec',
	        MM: translator.translate,
	        y: 'godinu',
	        yy: translator.translate,
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal: '%d.',
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 7, // The week that contains Jan 7th is the first week of the year.
	    },
	});

	//! moment.js locale configuration

	hooks$2.defineLocale('mi', {
	    months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split(
	        '_'
	    ),
	    monthsShort:
	        'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split(
	            '_'
	        ),
	    monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	    monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	    monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	    monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
	    weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
	    weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	    weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY [i] HH:mm',
	        LLLL: 'dddd, D MMMM YYYY [i] HH:mm',
	    },
	    calendar: {
	        sameDay: '[i teie mahana, i] LT',
	        nextDay: '[apopo i] LT',
	        nextWeek: 'dddd [i] LT',
	        lastDay: '[inanahi i] LT',
	        lastWeek: 'dddd [whakamutunga i] LT',
	        sameElse: 'L',
	    },
	    relativeTime: {
	        future: 'i roto i %s',
	        past: '%s i mua',
	        s: 'te hēkona ruarua',
	        ss: '%d hēkona',
	        m: 'he meneti',
	        mm: '%d meneti',
	        h: 'te haora',
	        hh: '%d haora',
	        d: 'he ra',
	        dd: '%d ra',
	        M: 'he marama',
	        MM: '%d marama',
	        y: 'he tau',
	        yy: '%d tau',
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}º/,
	    ordinal: '%dº',
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4, // The week that contains Jan 4th is the first week of the year.
	    },
	});

	//! moment.js locale configuration

	hooks$2.defineLocale('mk', {
	    months: 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split(
	        '_'
	    ),
	    monthsShort: 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
	    weekdays: 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split(
	        '_'
	    ),
	    weekdaysShort: 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
	    weekdaysMin: 'нe_пo_вт_ср_че_пе_сa'.split('_'),
	    longDateFormat: {
	        LT: 'H:mm',
	        LTS: 'H:mm:ss',
	        L: 'D.MM.YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY H:mm',
	        LLLL: 'dddd, D MMMM YYYY H:mm',
	    },
	    calendar: {
	        sameDay: '[Денес во] LT',
	        nextDay: '[Утре во] LT',
	        nextWeek: '[Во] dddd [во] LT',
	        lastDay: '[Вчера во] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 6:
	                    return '[Изминатата] dddd [во] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[Изминатиот] dddd [во] LT';
	            }
	        },
	        sameElse: 'L',
	    },
	    relativeTime: {
	        future: 'за %s',
	        past: 'пред %s',
	        s: 'неколку секунди',
	        ss: '%d секунди',
	        m: 'една минута',
	        mm: '%d минути',
	        h: 'еден час',
	        hh: '%d часа',
	        d: 'еден ден',
	        dd: '%d дена',
	        M: 'еден месец',
	        MM: '%d месеци',
	        y: 'една година',
	        yy: '%d години',
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	    ordinal: function (number) {
	        var lastDigit = number % 10,
	            last2Digits = number % 100;
	        if (number === 0) {
	            return number + '-ев';
	        } else if (last2Digits === 0) {
	            return number + '-ен';
	        } else if (last2Digits > 10 && last2Digits < 20) {
	            return number + '-ти';
	        } else if (lastDigit === 1) {
	            return number + '-ви';
	        } else if (lastDigit === 2) {
	            return number + '-ри';
	        } else if (lastDigit === 7 || lastDigit === 8) {
	            return number + '-ми';
	        } else {
	            return number + '-ти';
	        }
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 7, // The week that contains Jan 7th is the first week of the year.
	    },
	});

	//! moment.js locale configuration

	hooks$2.defineLocale('ml', {
	    months: 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split(
	        '_'
	    ),
	    monthsShort:
	        'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split(
	            '_'
	        ),
	    monthsParseExact: true,
	    weekdays:
	        'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split(
	            '_'
	        ),
	    weekdaysShort: 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
	    weekdaysMin: 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
	    longDateFormat: {
	        LT: 'A h:mm -നു',
	        LTS: 'A h:mm:ss -നു',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY, A h:mm -നു',
	        LLLL: 'dddd, D MMMM YYYY, A h:mm -നു',
	    },
	    calendar: {
	        sameDay: '[ഇന്ന്] LT',
	        nextDay: '[നാളെ] LT',
	        nextWeek: 'dddd, LT',
	        lastDay: '[ഇന്നലെ] LT',
	        lastWeek: '[കഴിഞ്ഞ] dddd, LT',
	        sameElse: 'L',
	    },
	    relativeTime: {
	        future: '%s കഴിഞ്ഞ്',
	        past: '%s മുൻപ്',
	        s: 'അൽപ നിമിഷങ്ങൾ',
	        ss: '%d സെക്കൻഡ്',
	        m: 'ഒരു മിനിറ്റ്',
	        mm: '%d മിനിറ്റ്',
	        h: 'ഒരു മണിക്കൂർ',
	        hh: '%d മണിക്കൂർ',
	        d: 'ഒരു ദിവസം',
	        dd: '%d ദിവസം',
	        M: 'ഒരു മാസം',
	        MM: '%d മാസം',
	        y: 'ഒരു വർഷം',
	        yy: '%d വർഷം',
	    },
	    meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
	    meridiemHour: function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (
	            (meridiem === 'രാത്രി' && hour >= 4) ||
	            meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
	            meridiem === 'വൈകുന്നേരം'
	        ) {
	            return hour + 12;
	        } else {
	            return hour;
	        }
	    },
	    meridiem: function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'രാത്രി';
	        } else if (hour < 12) {
	            return 'രാവിലെ';
	        } else if (hour < 17) {
	            return 'ഉച്ച കഴിഞ്ഞ്';
	        } else if (hour < 20) {
	            return 'വൈകുന്നേരം';
	        } else {
	            return 'രാത്രി';
	        }
	    },
	});

	//! moment.js locale configuration

	var symbolMap$9 = {
	        1: '१',
	        2: '२',
	        3: '३',
	        4: '४',
	        5: '५',
	        6: '६',
	        7: '७',
	        8: '८',
	        9: '९',
	        0: '०',
	    },
	    numberMap$8 = {
	        '१': '1',
	        '२': '2',
	        '३': '3',
	        '४': '4',
	        '५': '5',
	        '६': '6',
	        '७': '7',
	        '८': '8',
	        '९': '9',
	        '०': '0',
	    };

	function relativeTimeMr(number, withoutSuffix, string, isFuture) {
	    var output = '';
	    if (withoutSuffix) {
	        switch (string) {
	            case 's':
	                output = 'काही सेकंद';
	                break;
	            case 'ss':
	                output = '%d सेकंद';
	                break;
	            case 'm':
	                output = 'एक मिनिट';
	                break;
	            case 'mm':
	                output = '%d मिनिटे';
	                break;
	            case 'h':
	                output = 'एक तास';
	                break;
	            case 'hh':
	                output = '%d तास';
	                break;
	            case 'd':
	                output = 'एक दिवस';
	                break;
	            case 'dd':
	                output = '%d दिवस';
	                break;
	            case 'M':
	                output = 'एक महिना';
	                break;
	            case 'MM':
	                output = '%d महिने';
	                break;
	            case 'y':
	                output = 'एक वर्ष';
	                break;
	            case 'yy':
	                output = '%d वर्षे';
	                break;
	        }
	    } else {
	        switch (string) {
	            case 's':
	                output = 'काही सेकंदां';
	                break;
	            case 'ss':
	                output = '%d सेकंदां';
	                break;
	            case 'm':
	                output = 'एका मिनिटा';
	                break;
	            case 'mm':
	                output = '%d मिनिटां';
	                break;
	            case 'h':
	                output = 'एका तासा';
	                break;
	            case 'hh':
	                output = '%d तासां';
	                break;
	            case 'd':
	                output = 'एका दिवसा';
	                break;
	            case 'dd':
	                output = '%d दिवसां';
	                break;
	            case 'M':
	                output = 'एका महिन्या';
	                break;
	            case 'MM':
	                output = '%d महिन्यां';
	                break;
	            case 'y':
	                output = 'एका वर्षा';
	                break;
	            case 'yy':
	                output = '%d वर्षां';
	                break;
	        }
	    }
	    return output.replace(/%d/i, number);
	}

	hooks$2.defineLocale('mr', {
	    months: 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split(
	        '_'
	    ),
	    monthsShort:
	        'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split(
	            '_'
	        ),
	    monthsParseExact: true,
	    weekdays: 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	    weekdaysShort: 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
	    weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
	    longDateFormat: {
	        LT: 'A h:mm वाजता',
	        LTS: 'A h:mm:ss वाजता',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY, A h:mm वाजता',
	        LLLL: 'dddd, D MMMM YYYY, A h:mm वाजता',
	    },
	    calendar: {
	        sameDay: '[आज] LT',
	        nextDay: '[उद्या] LT',
	        nextWeek: 'dddd, LT',
	        lastDay: '[काल] LT',
	        lastWeek: '[मागील] dddd, LT',
	        sameElse: 'L',
	    },
	    relativeTime: {
	        future: '%sमध्ये',
	        past: '%sपूर्वी',
	        s: relativeTimeMr,
	        ss: relativeTimeMr,
	        m: relativeTimeMr,
	        mm: relativeTimeMr,
	        h: relativeTimeMr,
	        hh: relativeTimeMr,
	        d: relativeTimeMr,
	        dd: relativeTimeMr,
	        M: relativeTimeMr,
	        MM: relativeTimeMr,
	        y: relativeTimeMr,
	        yy: relativeTimeMr,
	    },
	    preparse: function (string) {
	        return string.replace(/[१२३४५६७८९०]/g, function (match) {
	            return numberMap$8[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap$9[match];
	        });
	    },
	    meridiemParse: /पहाटे|सकाळी|दुपारी|सायंकाळी|रात्री/,
	    meridiemHour: function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'पहाटे' || meridiem === 'सकाळी') {
	            return hour;
	        } else if (
	            meridiem === 'दुपारी' ||
	            meridiem === 'सायंकाळी' ||
	            meridiem === 'रात्री'
	        ) {
	            return hour >= 12 ? hour : hour + 12;
	        }
	    },
	    meridiem: function (hour, minute, isLower) {
	        if (hour >= 0 && hour < 6) {
	            return 'पहाटे';
	        } else if (hour < 12) {
	            return 'सकाळी';
	        } else if (hour < 17) {
	            return 'दुपारी';
	        } else if (hour < 20) {
	            return 'सायंकाळी';
	        } else {
	            return 'रात्री';
	        }
	    },
	    week: {
	        dow: 0, // Sunday is the first day of the week.
	        doy: 6, // The week that contains Jan 6th is the first week of the year.
	    },
	});

	//! moment.js locale configuration

	hooks$2.defineLocale('ms-my', {
	    months: 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split(
	        '_'
	    ),
	    monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	    weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	    weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	    weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	    longDateFormat: {
	        LT: 'HH.mm',
	        LTS: 'HH.mm.ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY [pukul] HH.mm',
	        LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
	    },
	    meridiemParse: /pagi|tengahari|petang|malam/,
	    meridiemHour: function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'pagi') {
	            return hour;
	        } else if (meridiem === 'tengahari') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'petang' || meridiem === 'malam') {
	            return hour + 12;
	        }
	    },
	    meridiem: function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'pagi';
	        } else if (hours < 15) {
	            return 'tengahari';
	        } else if (hours < 19) {
	            return 'petang';
	        } else {
	            return 'malam';
	        }
	    },
	    calendar: {
	        sameDay: '[Hari ini pukul] LT',
	        nextDay: '[Esok pukul] LT',
	        nextWeek: 'dddd [pukul] LT',
	        lastDay: '[Kelmarin pukul] LT',
	        lastWeek: 'dddd [lepas pukul] LT',
	        sameElse: 'L',
	    },
	    relativeTime: {
	        future: 'dalam %s',
	        past: '%s yang lepas',
	        s: 'beberapa saat',
	        ss: '%d saat',
	        m: 'seminit',
	        mm: '%d minit',
	        h: 'sejam',
	        hh: '%d jam',
	        d: 'sehari',
	        dd: '%d hari',
	        M: 'sebulan',
	        MM: '%d bulan',
	        y: 'setahun',
	        yy: '%d tahun',
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 7, // The week that contains Jan 7th is the first week of the year.
	    },
	});

	//! moment.js locale configuration

	hooks$2.defineLocale('ms', {
	    months: 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split(
	        '_'
	    ),
	    monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	    weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	    weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	    weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	    longDateFormat: {
	        LT: 'HH.mm',
	        LTS: 'HH.mm.ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY [pukul] HH.mm',
	        LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
	    },
	    meridiemParse: /pagi|tengahari|petang|malam/,
	    meridiemHour: function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'pagi') {
	            return hour;
	        } else if (meridiem === 'tengahari') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'petang' || meridiem === 'malam') {
	            return hour + 12;
	        }
	    },
	    meridiem: function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'pagi';
	        } else if (hours < 15) {
	            return 'tengahari';
	        } else if (hours < 19) {
	            return 'petang';
	        } else {
	            return 'malam';
	        }
	    },
	    calendar: {
	        sameDay: '[Hari ini pukul] LT',
	        nextDay: '[Esok pukul] LT',
	        nextWeek: 'dddd [pukul] LT',
	        lastDay: '[Kelmarin pukul] LT',
	        lastWeek: 'dddd [lepas pukul] LT',
	        sameElse: 'L',
	    },
	    relativeTime: {
	        future: 'dalam %s',
	        past: '%s yang lepas',
	        s: 'beberapa saat',
	        ss: '%d saat',
	        m: 'seminit',
	        mm: '%d minit',
	        h: 'sejam',
	        hh: '%d jam',
	        d: 'sehari',
	        dd: '%d hari',
	        M: 'sebulan',
	        MM: '%d bulan',
	        y: 'setahun',
	        yy: '%d tahun',
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 7, // The week that contains Jan 7th is the first week of the year.
	    },
	});

	//! moment.js locale configuration

	var symbolMap$a = {
	        1: '၁',
	        2: '၂',
	        3: '၃',
	        4: '၄',
	        5: '၅',
	        6: '၆',
	        7: '၇',
	        8: '၈',
	        9: '၉',
	        0: '၀',
	    },
	    numberMap$9 = {
	        '၁': '1',
	        '၂': '2',
	        '၃': '3',
	        '၄': '4',
	        '၅': '5',
	        '၆': '6',
	        '၇': '7',
	        '၈': '8',
	        '၉': '9',
	        '၀': '0',
	    };

	hooks$2.defineLocale('my', {
	    months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split(
	        '_'
	    ),
	    monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
	    weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split(
	        '_'
	    ),
	    weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	    weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),

	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd D MMMM YYYY HH:mm',
	    },
	    calendar: {
	        sameDay: '[ယနေ.] LT [မှာ]',
	        nextDay: '[မနက်ဖြန်] LT [မှာ]',
	        nextWeek: 'dddd LT [မှာ]',
	        lastDay: '[မနေ.က] LT [မှာ]',
	        lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
	        sameElse: 'L',
	    },
	    relativeTime: {
	        future: 'လာမည့် %s မှာ',
	        past: 'လွန်ခဲ့သော %s က',
	        s: 'စက္ကန်.အနည်းငယ်',
	        ss: '%d စက္ကန့်',
	        m: 'တစ်မိနစ်',
	        mm: '%d မိနစ်',
	        h: 'တစ်နာရီ',
	        hh: '%d နာရီ',
	        d: 'တစ်ရက်',
	        dd: '%d ရက်',
	        M: 'တစ်လ',
	        MM: '%d လ',
	        y: 'တစ်နှစ်',
	        yy: '%d နှစ်',
	    },
	    preparse: function (string) {
	        return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
	            return numberMap$9[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap$a[match];
	        });
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4, // The week that contains Jan 4th is the first week of the year.
	    },
	});

	//! moment.js locale configuration

	hooks$2.defineLocale('nb', {
	    months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split(
	        '_'
	    ),
	    monthsShort:
	        'jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
	    monthsParseExact: true,
	    weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	    weekdaysShort: 'sø._ma._ti._on._to._fr._lø.'.split('_'),
	    weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
	    weekdaysParseExact: true,
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY [kl.] HH:mm',
	        LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm',
	    },
	    calendar: {
	        sameDay: '[i dag kl.] LT',
	        nextDay: '[i morgen kl.] LT',
	        nextWeek: 'dddd [kl.] LT',
	        lastDay: '[i går kl.] LT',
	        lastWeek: '[forrige] dddd [kl.] LT',
	        sameElse: 'L',
	    },
	    relativeTime: {
	        future: 'om %s',
	        past: '%s siden',
	        s: 'noen sekunder',
	        ss: '%d sekunder',
	        m: 'ett minutt',
	        mm: '%d minutter',
	        h: 'en time',
	        hh: '%d timer',
	        d: 'en dag',
	        dd: '%d dager',
	        w: 'en uke',
	        ww: '%d uker',
	        M: 'en måned',
	        MM: '%d måneder',
	        y: 'ett år',
	        yy: '%d år',
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal: '%d.',
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4, // The week that contains Jan 4th is the first week of the year.
	    },
	});

	//! moment.js locale configuration

	var symbolMap$b = {
	        1: '१',
	        2: '२',
	        3: '३',
	        4: '४',
	        5: '५',
	        6: '६',
	        7: '७',
	        8: '८',
	        9: '९',
	        0: '०',
	    },
	    numberMap$a = {
	        '१': '1',
	        '२': '2',
	        '३': '3',
	        '४': '4',
	        '५': '5',
	        '६': '6',
	        '७': '7',
	        '८': '8',
	        '९': '9',
	        '०': '0',
	    };

	hooks$2.defineLocale('ne', {
	    months: 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split(
	        '_'
	    ),
	    monthsShort:
	        'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split(
	            '_'
	        ),
	    monthsParseExact: true,
	    weekdays: 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split(
	        '_'
	    ),
	    weekdaysShort: 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
	    weekdaysMin: 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
	    weekdaysParseExact: true,
	    longDateFormat: {
	        LT: 'Aको h:mm बजे',
	        LTS: 'Aको h:mm:ss बजे',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY, Aको h:mm बजे',
	        LLLL: 'dddd, D MMMM YYYY, Aको h:mm बजे',
	    },
	    preparse: function (string) {
	        return string.replace(/[१२३४५६७८९०]/g, function (match) {
	            return numberMap$a[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap$b[match];
	        });
	    },
	    meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
	    meridiemHour: function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'राति') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'बिहान') {
	            return hour;
	        } else if (meridiem === 'दिउँसो') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'साँझ') {
	            return hour + 12;
	        }
	    },
	    meridiem: function (hour, minute, isLower) {
	        if (hour < 3) {
	            return 'राति';
	        } else if (hour < 12) {
	            return 'बिहान';
	        } else if (hour < 16) {
	            return 'दिउँसो';
	        } else if (hour < 20) {
	            return 'साँझ';
	        } else {
	            return 'राति';
	        }
	    },
	    calendar: {
	        sameDay: '[आज] LT',
	        nextDay: '[भोलि] LT',
	        nextWeek: '[आउँदो] dddd[,] LT',
	        lastDay: '[हिजो] LT',
	        lastWeek: '[गएको] dddd[,] LT',
	        sameElse: 'L',
	    },
	    relativeTime: {
	        future: '%sमा',
	        past: '%s अगाडि',
	        s: 'केही क्षण',
	        ss: '%d सेकेण्ड',
	        m: 'एक मिनेट',
	        mm: '%d मिनेट',
	        h: 'एक घण्टा',
	        hh: '%d घण्टा',
	        d: 'एक दिन',
	        dd: '%d दिन',
	        M: 'एक महिना',
	        MM: '%d महिना',
	        y: 'एक बर्ष',
	        yy: '%d बर्ष',
	    },
	    week: {
	        dow: 0, // Sunday is the first day of the week.
	        doy: 6, // The week that contains Jan 6th is the first week of the year.
	    },
	});

	//! moment.js locale configuration

	var monthsShortWithDots$1 =
	        'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	    monthsShortWithoutDots$1 =
	        'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	    monthsParse$6 = [
	        /^jan/i,
	        /^feb/i,
	        /^maart|mrt.?$/i,
	        /^apr/i,
	        /^mei$/i,
	        /^jun[i.]?$/i,
	        /^jul[i.]?$/i,
	        /^aug/i,
	        /^sep/i,
	        /^okt/i,
	        /^nov/i,
	        /^dec/i ],
	    monthsRegex$7 =
	        /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;

	hooks$2.defineLocale('nl-be', {
	    months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split(
	        '_'
	    ),
	    monthsShort: function (m, format) {
	        if (!m) {
	            return monthsShortWithDots$1;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShortWithoutDots$1[m.month()];
	        } else {
	            return monthsShortWithDots$1[m.month()];
	        }
	    },

	    monthsRegex: monthsRegex$7,
	    monthsShortRegex: monthsRegex$7,
	    monthsStrictRegex:
	        /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
	    monthsShortStrictRegex:
	        /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,

	    monthsParse: monthsParse$6,
	    longMonthsParse: monthsParse$6,
	    shortMonthsParse: monthsParse$6,

	    weekdays:
	        'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	    weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
	    weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
	    weekdaysParseExact: true,
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd D MMMM YYYY HH:mm',
	    },
	    calendar: {
	        sameDay: '[vandaag om] LT',
	        nextDay: '[morgen om] LT',
	        nextWeek: 'dddd [om] LT',
	        lastDay: '[gisteren om] LT',
	        lastWeek: '[afgelopen] dddd [om] LT',
	        sameElse: 'L',
	    },
	    relativeTime: {
	        future: 'over %s',
	        past: '%s geleden',
	        s: 'een paar seconden',
	        ss: '%d seconden',
	        m: 'één minuut',
	        mm: '%d minuten',
	        h: 'één uur',
	        hh: '%d uur',
	        d: 'één dag',
	        dd: '%d dagen',
	        M: 'één maand',
	        MM: '%d maanden',
	        y: 'één jaar',
	        yy: '%d jaar',
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	    ordinal: function (number) {
	        return (
	            number +
	            (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
	        );
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4, // The week that contains Jan 4th is the first week of the year.
	    },
	});

	//! moment.js locale configuration

	var monthsShortWithDots$2 =
	        'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	    monthsShortWithoutDots$2 =
	        'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	    monthsParse$7 = [
	        /^jan/i,
	        /^feb/i,
	        /^maart|mrt.?$/i,
	        /^apr/i,
	        /^mei$/i,
	        /^jun[i.]?$/i,
	        /^jul[i.]?$/i,
	        /^aug/i,
	        /^sep/i,
	        /^okt/i,
	        /^nov/i,
	        /^dec/i ],
	    monthsRegex$8 =
	        /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;

	hooks$2.defineLocale('nl', {
	    months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split(
	        '_'
	    ),
	    monthsShort: function (m, format) {
	        if (!m) {
	            return monthsShortWithDots$2;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShortWithoutDots$2[m.month()];
	        } else {
	            return monthsShortWithDots$2[m.month()];
	        }
	    },

	    monthsRegex: monthsRegex$8,
	    monthsShortRegex: monthsRegex$8,
	    monthsStrictRegex:
	        /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
	    monthsShortStrictRegex:
	        /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,

	    monthsParse: monthsParse$7,
	    longMonthsParse: monthsParse$7,
	    shortMonthsParse: monthsParse$7,

	    weekdays:
	        'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	    weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
	    weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
	    weekdaysParseExact: true,
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD-MM-YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd D MMMM YYYY HH:mm',
	    },
	    calendar: {
	        sameDay: '[vandaag om] LT',
	        nextDay: '[morgen om] LT',
	        nextWeek: 'dddd [om] LT',
	        lastDay: '[gisteren om] LT',
	        lastWeek: '[afgelopen] dddd [om] LT',
	        sameElse: 'L',
	    },
	    relativeTime: {
	        future: 'over %s',
	        past: '%s geleden',
	        s: 'een paar seconden',
	        ss: '%d seconden',
	        m: 'één minuut',
	        mm: '%d minuten',
	        h: 'één uur',
	        hh: '%d uur',
	        d: 'één dag',
	        dd: '%d dagen',
	        w: 'één week',
	        ww: '%d weken',
	        M: 'één maand',
	        MM: '%d maanden',
	        y: 'één jaar',
	        yy: '%d jaar',
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	    ordinal: function (number) {
	        return (
	            number +
	            (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
	        );
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4, // The week that contains Jan 4th is the first week of the year.
	    },
	});

	//! moment.js locale configuration

	hooks$2.defineLocale('nn', {
	    months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split(
	        '_'
	    ),
	    monthsShort:
	        'jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
	    monthsParseExact: true,
	    weekdays: 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
	    weekdaysShort: 'su._må._ty._on._to._fr._lau.'.split('_'),
	    weekdaysMin: 'su_må_ty_on_to_fr_la'.split('_'),
	    weekdaysParseExact: true,
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY [kl.] H:mm',
	        LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm',
	    },
	    calendar: {
	        sameDay: '[I dag klokka] LT',
	        nextDay: '[I morgon klokka] LT',
	        nextWeek: 'dddd [klokka] LT',
	        lastDay: '[I går klokka] LT',
	        lastWeek: '[Føregåande] dddd [klokka] LT',
	        sameElse: 'L',
	    },
	    relativeTime: {
	        future: 'om %s',
	        past: '%s sidan',
	        s: 'nokre sekund',
	        ss: '%d sekund',
	        m: 'eit minutt',
	        mm: '%d minutt',
	        h: 'ein time',
	        hh: '%d timar',
	        d: 'ein dag',
	        dd: '%d dagar',
	        w: 'ei veke',
	        ww: '%d veker',
	        M: 'ein månad',
	        MM: '%d månader',
	        y: 'eit år',
	        yy: '%d år',
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal: '%d.',
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4, // The week that contains Jan 4th is the first week of the year.
	    },
	});

	//! moment.js locale configuration

	var symbolMap$c = {
	        1: '੧',
	        2: '੨',
	        3: '੩',
	        4: '੪',
	        5: '੫',
	        6: '੬',
	        7: '੭',
	        8: '੮',
	        9: '੯',
	        0: '੦',
	    },
	    numberMap$b = {
	        '੧': '1',
	        '੨': '2',
	        '੩': '3',
	        '੪': '4',
	        '੫': '5',
	        '੬': '6',
	        '੭': '7',
	        '੮': '8',
	        '੯': '9',
	        '੦': '0',
	    };

	hooks$2.defineLocale('pa-in', {
	    // There are months name as per Nanakshahi Calendar but they are not used as rigidly in modern Punjabi.
	    months: 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split(
	        '_'
	    ),
	    monthsShort:
	        'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split(
	            '_'
	        ),
	    weekdays: 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split(
	        '_'
	    ),
	    weekdaysShort: 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	    weekdaysMin: 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	    longDateFormat: {
	        LT: 'A h:mm ਵਜੇ',
	        LTS: 'A h:mm:ss ਵਜੇ',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY, A h:mm ਵਜੇ',
	        LLLL: 'dddd, D MMMM YYYY, A h:mm ਵਜੇ',
	    },
	    calendar: {
	        sameDay: '[ਅਜ] LT',
	        nextDay: '[ਕਲ] LT',
	        nextWeek: '[ਅਗਲਾ] dddd, LT',
	        lastDay: '[ਕਲ] LT',
	        lastWeek: '[ਪਿਛਲੇ] dddd, LT',
	        sameElse: 'L',
	    },
	    relativeTime: {
	        future: '%s ਵਿੱਚ',
	        past: '%s ਪਿਛਲੇ',
	        s: 'ਕੁਝ ਸਕਿੰਟ',
	        ss: '%d ਸਕਿੰਟ',
	        m: 'ਇਕ ਮਿੰਟ',
	        mm: '%d ਮਿੰਟ',
	        h: 'ਇੱਕ ਘੰਟਾ',
	        hh: '%d ਘੰਟੇ',
	        d: 'ਇੱਕ ਦਿਨ',
	        dd: '%d ਦਿਨ',
	        M: 'ਇੱਕ ਮਹੀਨਾ',
	        MM: '%d ਮਹੀਨੇ',
	        y: 'ਇੱਕ ਸਾਲ',
	        yy: '%d ਸਾਲ',
	    },
	    preparse: function (string) {
	        return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
	            return numberMap$b[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap$c[match];
	        });
	    },
	    // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
	    // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
	    meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
	    meridiemHour: function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'ਰਾਤ') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'ਸਵੇਰ') {
	            return hour;
	        } else if (meridiem === 'ਦੁਪਹਿਰ') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'ਸ਼ਾਮ') {
	            return hour + 12;
	        }
	    },
	    meridiem: function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ਰਾਤ';
	        } else if (hour < 10) {
	            return 'ਸਵੇਰ';
	        } else if (hour < 17) {
	            return 'ਦੁਪਹਿਰ';
	        } else if (hour < 20) {
	            return 'ਸ਼ਾਮ';
	        } else {
	            return 'ਰਾਤ';
	        }
	    },
	    week: {
	        dow: 0, // Sunday is the first day of the week.
	        doy: 6, // The week that contains Jan 6th is the first week of the year.
	    },
	});

	//! moment.js locale configuration

	var monthsNominative =
	        'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split(
	            '_'
	        ),
	    monthsSubjective =
	        'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split(
	            '_'
	        ),
	    monthsParse$8 = [
	        /^sty/i,
	        /^lut/i,
	        /^mar/i,
	        /^kwi/i,
	        /^maj/i,
	        /^cze/i,
	        /^lip/i,
	        /^sie/i,
	        /^wrz/i,
	        /^paź/i,
	        /^lis/i,
	        /^gru/i ];
	function plural$4(n) {
	    return n % 10 < 5 && n % 10 > 1 && ~~(n / 10) % 10 !== 1;
	}
	function translate$8(number, withoutSuffix, key) {
	    var result = number + ' ';
	    switch (key) {
	        case 'ss':
	            return result + (plural$4(number) ? 'sekundy' : 'sekund');
	        case 'm':
	            return withoutSuffix ? 'minuta' : 'minutę';
	        case 'mm':
	            return result + (plural$4(number) ? 'minuty' : 'minut');
	        case 'h':
	            return withoutSuffix ? 'godzina' : 'godzinę';
	        case 'hh':
	            return result + (plural$4(number) ? 'godziny' : 'godzin');
	        case 'ww':
	            return result + (plural$4(number) ? 'tygodnie' : 'tygodni');
	        case 'MM':
	            return result + (plural$4(number) ? 'miesiące' : 'miesięcy');
	        case 'yy':
	            return result + (plural$4(number) ? 'lata' : 'lat');
	    }
	}

	hooks$2.defineLocale('pl', {
	    months: function (momentToFormat, format) {
	        if (!momentToFormat) {
	            return monthsNominative;
	        } else if (/D MMMM/.test(format)) {
	            return monthsSubjective[momentToFormat.month()];
	        } else {
	            return monthsNominative[momentToFormat.month()];
	        }
	    },
	    monthsShort: 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
	    monthsParse: monthsParse$8,
	    longMonthsParse: monthsParse$8,
	    shortMonthsParse: monthsParse$8,
	    weekdays:
	        'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
	    weekdaysShort: 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
	    weekdaysMin: 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD.MM.YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd, D MMMM YYYY HH:mm',
	    },
	    calendar: {
	        sameDay: '[Dziś o] LT',
	        nextDay: '[Jutro o] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[W niedzielę o] LT';

	                case 2:
	                    return '[We wtorek o] LT';

	                case 3:
	                    return '[W środę o] LT';

	                case 6:
	                    return '[W sobotę o] LT';

	                default:
	                    return '[W] dddd [o] LT';
	            }
	        },
	        lastDay: '[Wczoraj o] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[W zeszłą niedzielę o] LT';
	                case 3:
	                    return '[W zeszłą środę o] LT';
	                case 6:
	                    return '[W zeszłą sobotę o] LT';
	                default:
	                    return '[W zeszły] dddd [o] LT';
	            }
	        },
	        sameElse: 'L',
	    },
	    relativeTime: {
	        future: 'za %s',
	        past: '%s temu',
	        s: 'kilka sekund',
	        ss: translate$8,
	        m: translate$8,
	        mm: translate$8,
	        h: translate$8,
	        hh: translate$8,
	        d: '1 dzień',
	        dd: '%d dni',
	        w: 'tydzień',
	        ww: translate$8,
	        M: 'miesiąc',
	        MM: translate$8,
	        y: 'rok',
	        yy: translate$8,
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal: '%d.',
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4, // The week that contains Jan 4th is the first week of the year.
	    },
	});

	//! moment.js locale configuration

	hooks$2.defineLocale('pt-br', {
	    months: 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split(
	        '_'
	    ),
	    monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
	    weekdays:
	        'domingo_segunda-feira_terça-feira_quarta-feira_quinta-feira_sexta-feira_sábado'.split(
	            '_'
	        ),
	    weekdaysShort: 'dom_seg_ter_qua_qui_sex_sáb'.split('_'),
	    weekdaysMin: 'do_2ª_3ª_4ª_5ª_6ª_sá'.split('_'),
	    weekdaysParseExact: true,
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D [de] MMMM [de] YYYY',
	        LLL: 'D [de] MMMM [de] YYYY [às] HH:mm',
	        LLLL: 'dddd, D [de] MMMM [de] YYYY [às] HH:mm',
	    },
	    calendar: {
	        sameDay: '[Hoje às] LT',
	        nextDay: '[Amanhã às] LT',
	        nextWeek: 'dddd [às] LT',
	        lastDay: '[Ontem às] LT',
	        lastWeek: function () {
	            return this.day() === 0 || this.day() === 6
	                ? '[Último] dddd [às] LT' // Saturday + Sunday
	                : '[Última] dddd [às] LT'; // Monday - Friday
	        },
	        sameElse: 'L',
	    },
	    relativeTime: {
	        future: 'em %s',
	        past: 'há %s',
	        s: 'poucos segundos',
	        ss: '%d segundos',
	        m: 'um minuto',
	        mm: '%d minutos',
	        h: 'uma hora',
	        hh: '%d horas',
	        d: 'um dia',
	        dd: '%d dias',
	        M: 'um mês',
	        MM: '%d meses',
	        y: 'um ano',
	        yy: '%d anos',
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}º/,
	    ordinal: '%dº',
	    invalidDate: 'Data inválida',
	});

	//! moment.js locale configuration

	hooks$2.defineLocale('pt', {
	    months: 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split(
	        '_'
	    ),
	    monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
	    weekdays:
	        'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split(
	            '_'
	        ),
	    weekdaysShort: 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	    weekdaysMin: 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
	    weekdaysParseExact: true,
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D [de] MMMM [de] YYYY',
	        LLL: 'D [de] MMMM [de] YYYY HH:mm',
	        LLLL: 'dddd, D [de] MMMM [de] YYYY HH:mm',
	    },
	    calendar: {
	        sameDay: '[Hoje às] LT',
	        nextDay: '[Amanhã às] LT',
	        nextWeek: 'dddd [às] LT',
	        lastDay: '[Ontem às] LT',
	        lastWeek: function () {
	            return this.day() === 0 || this.day() === 6
	                ? '[Último] dddd [às] LT' // Saturday + Sunday
	                : '[Última] dddd [às] LT'; // Monday - Friday
	        },
	        sameElse: 'L',
	    },
	    relativeTime: {
	        future: 'em %s',
	        past: 'há %s',
	        s: 'segundos',
	        ss: '%d segundos',
	        m: 'um minuto',
	        mm: '%d minutos',
	        h: 'uma hora',
	        hh: '%d horas',
	        d: 'um dia',
	        dd: '%d dias',
	        w: 'uma semana',
	        ww: '%d semanas',
	        M: 'um mês',
	        MM: '%d meses',
	        y: 'um ano',
	        yy: '%d anos',
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}º/,
	    ordinal: '%dº',
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4, // The week that contains Jan 4th is the first week of the year.
	    },
	});

	//! moment.js locale configuration

	function relativeTimeWithPlural$2(number, withoutSuffix, key) {
	    var format = {
	            ss: 'secunde',
	            mm: 'minute',
	            hh: 'ore',
	            dd: 'zile',
	            ww: 'săptămâni',
	            MM: 'luni',
	            yy: 'ani',
	        },
	        separator = ' ';
	    if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
	        separator = ' de ';
	    }
	    return number + separator + format[key];
	}

	hooks$2.defineLocale('ro', {
	    months: 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split(
	        '_'
	    ),
	    monthsShort:
	        'ian._feb._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split(
	            '_'
	        ),
	    monthsParseExact: true,
	    weekdays: 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
	    weekdaysShort: 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
	    weekdaysMin: 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
	    longDateFormat: {
	        LT: 'H:mm',
	        LTS: 'H:mm:ss',
	        L: 'DD.MM.YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY H:mm',
	        LLLL: 'dddd, D MMMM YYYY H:mm',
	    },
	    calendar: {
	        sameDay: '[azi la] LT',
	        nextDay: '[mâine la] LT',
	        nextWeek: 'dddd [la] LT',
	        lastDay: '[ieri la] LT',
	        lastWeek: '[fosta] dddd [la] LT',
	        sameElse: 'L',
	    },
	    relativeTime: {
	        future: 'peste %s',
	        past: '%s în urmă',
	        s: 'câteva secunde',
	        ss: relativeTimeWithPlural$2,
	        m: 'un minut',
	        mm: relativeTimeWithPlural$2,
	        h: 'o oră',
	        hh: relativeTimeWithPlural$2,
	        d: 'o zi',
	        dd: relativeTimeWithPlural$2,
	        w: 'o săptămână',
	        ww: relativeTimeWithPlural$2,
	        M: 'o lună',
	        MM: relativeTimeWithPlural$2,
	        y: 'un an',
	        yy: relativeTimeWithPlural$2,
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 7, // The week that contains Jan 7th is the first week of the year.
	    },
	});

	//! moment.js locale configuration

	function plural$5(word, num) {
	    var forms = word.split('_');
	    return num % 10 === 1 && num % 100 !== 11
	        ? forms[0]
	        : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
	        ? forms[1]
	        : forms[2];
	}
	function relativeTimeWithPlural$3(number, withoutSuffix, key) {
	    var format = {
	        ss: withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
	        mm: withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
	        hh: 'час_часа_часов',
	        dd: 'день_дня_дней',
	        ww: 'неделя_недели_недель',
	        MM: 'месяц_месяца_месяцев',
	        yy: 'год_года_лет',
	    };
	    if (key === 'm') {
	        return withoutSuffix ? 'минута' : 'минуту';
	    } else {
	        return number + ' ' + plural$5(format[key], +number);
	    }
	}
	var monthsParse$9 = [
	    /^янв/i,
	    /^фев/i,
	    /^мар/i,
	    /^апр/i,
	    /^ма[йя]/i,
	    /^июн/i,
	    /^июл/i,
	    /^авг/i,
	    /^сен/i,
	    /^окт/i,
	    /^ноя/i,
	    /^дек/i ];

	// http://new.gramota.ru/spravka/rules/139-prop : § 103
	// Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
	// CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
	hooks$2.defineLocale('ru', {
	    months: {
	        format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split(
	            '_'
	        ),
	        standalone:
	            'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split(
	                '_'
	            ),
	    },
	    monthsShort: {
	        // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку?
	        format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split(
	            '_'
	        ),
	        standalone:
	            'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split(
	                '_'
	            ),
	    },
	    weekdays: {
	        standalone:
	            'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split(
	                '_'
	            ),
	        format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split(
	            '_'
	        ),
	        isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?] ?dddd/,
	    },
	    weekdaysShort: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	    weekdaysMin: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	    monthsParse: monthsParse$9,
	    longMonthsParse: monthsParse$9,
	    shortMonthsParse: monthsParse$9,

	    // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
	    monthsRegex:
	        /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,

	    // копия предыдущего
	    monthsShortRegex:
	        /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,

	    // полные названия с падежами
	    monthsStrictRegex:
	        /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,

	    // Выражение, которое соответствует только сокращённым формам
	    monthsShortStrictRegex:
	        /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
	    longDateFormat: {
	        LT: 'H:mm',
	        LTS: 'H:mm:ss',
	        L: 'DD.MM.YYYY',
	        LL: 'D MMMM YYYY г.',
	        LLL: 'D MMMM YYYY г., H:mm',
	        LLLL: 'dddd, D MMMM YYYY г., H:mm',
	    },
	    calendar: {
	        sameDay: '[Сегодня, в] LT',
	        nextDay: '[Завтра, в] LT',
	        lastDay: '[Вчера, в] LT',
	        nextWeek: function (now) {
	            if (now.week() !== this.week()) {
	                switch (this.day()) {
	                    case 0:
	                        return '[В следующее] dddd, [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[В следующий] dddd, [в] LT';
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[В следующую] dddd, [в] LT';
	                }
	            } else {
	                if (this.day() === 2) {
	                    return '[Во] dddd, [в] LT';
	                } else {
	                    return '[В] dddd, [в] LT';
	                }
	            }
	        },
	        lastWeek: function (now) {
	            if (now.week() !== this.week()) {
	                switch (this.day()) {
	                    case 0:
	                        return '[В прошлое] dddd, [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[В прошлый] dddd, [в] LT';
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[В прошлую] dddd, [в] LT';
	                }
	            } else {
	                if (this.day() === 2) {
	                    return '[Во] dddd, [в] LT';
	                } else {
	                    return '[В] dddd, [в] LT';
	                }
	            }
	        },
	        sameElse: 'L',
	    },
	    relativeTime: {
	        future: 'через %s',
	        past: '%s назад',
	        s: 'несколько секунд',
	        ss: relativeTimeWithPlural$3,
	        m: relativeTimeWithPlural$3,
	        mm: relativeTimeWithPlural$3,
	        h: 'час',
	        hh: relativeTimeWithPlural$3,
	        d: 'день',
	        dd: relativeTimeWithPlural$3,
	        w: 'неделя',
	        ww: relativeTimeWithPlural$3,
	        M: 'месяц',
	        MM: relativeTimeWithPlural$3,
	        y: 'год',
	        yy: relativeTimeWithPlural$3,
	    },
	    meridiemParse: /ночи|утра|дня|вечера/i,
	    isPM: function (input) {
	        return /^(дня|вечера)$/.test(input);
	    },
	    meridiem: function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ночи';
	        } else if (hour < 12) {
	            return 'утра';
	        } else if (hour < 17) {
	            return 'дня';
	        } else {
	            return 'вечера';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'M':
	            case 'd':
	            case 'DDD':
	                return number + '-й';
	            case 'D':
	                return number + '-го';
	            case 'w':
	            case 'W':
	                return number + '-я';
	            default:
	                return number;
	        }
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4, // The week that contains Jan 4th is the first week of the year.
	    },
	});

	//! moment.js locale configuration

	var months$8 = [
	        'جنوري',
	        'فيبروري',
	        'مارچ',
	        'اپريل',
	        'مئي',
	        'جون',
	        'جولاءِ',
	        'آگسٽ',
	        'سيپٽمبر',
	        'آڪٽوبر',
	        'نومبر',
	        'ڊسمبر' ],
	    days$2 = ['آچر', 'سومر', 'اڱارو', 'اربع', 'خميس', 'جمع', 'ڇنڇر'];

	hooks$2.defineLocale('sd', {
	    months: months$8,
	    monthsShort: months$8,
	    weekdays: days$2,
	    weekdaysShort: days$2,
	    weekdaysMin: days$2,
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd، D MMMM YYYY HH:mm',
	    },
	    meridiemParse: /صبح|شام/,
	    isPM: function (input) {
	        return 'شام' === input;
	    },
	    meridiem: function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'صبح';
	        }
	        return 'شام';
	    },
	    calendar: {
	        sameDay: '[اڄ] LT',
	        nextDay: '[سڀاڻي] LT',
	        nextWeek: 'dddd [اڳين هفتي تي] LT',
	        lastDay: '[ڪالهه] LT',
	        lastWeek: '[گزريل هفتي] dddd [تي] LT',
	        sameElse: 'L',
	    },
	    relativeTime: {
	        future: '%s پوء',
	        past: '%s اڳ',
	        s: 'چند سيڪنڊ',
	        ss: '%d سيڪنڊ',
	        m: 'هڪ منٽ',
	        mm: '%d منٽ',
	        h: 'هڪ ڪلاڪ',
	        hh: '%d ڪلاڪ',
	        d: 'هڪ ڏينهن',
	        dd: '%d ڏينهن',
	        M: 'هڪ مهينو',
	        MM: '%d مهينا',
	        y: 'هڪ سال',
	        yy: '%d سال',
	    },
	    preparse: function (string) {
	        return string.replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/,/g, '،');
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4, // The week that contains Jan 4th is the first week of the year.
	    },
	});

	//! moment.js locale configuration

	hooks$2.defineLocale('se', {
	    months: 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split(
	        '_'
	    ),
	    monthsShort:
	        'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
	    weekdays:
	        'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split(
	            '_'
	        ),
	    weekdaysShort: 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
	    weekdaysMin: 's_v_m_g_d_b_L'.split('_'),
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD.MM.YYYY',
	        LL: 'MMMM D. [b.] YYYY',
	        LLL: 'MMMM D. [b.] YYYY [ti.] HH:mm',
	        LLLL: 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm',
	    },
	    calendar: {
	        sameDay: '[otne ti] LT',
	        nextDay: '[ihttin ti] LT',
	        nextWeek: 'dddd [ti] LT',
	        lastDay: '[ikte ti] LT',
	        lastWeek: '[ovddit] dddd [ti] LT',
	        sameElse: 'L',
	    },
	    relativeTime: {
	        future: '%s geažes',
	        past: 'maŋit %s',
	        s: 'moadde sekunddat',
	        ss: '%d sekunddat',
	        m: 'okta minuhta',
	        mm: '%d minuhtat',
	        h: 'okta diimmu',
	        hh: '%d diimmut',
	        d: 'okta beaivi',
	        dd: '%d beaivvit',
	        M: 'okta mánnu',
	        MM: '%d mánut',
	        y: 'okta jahki',
	        yy: '%d jagit',
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal: '%d.',
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4, // The week that contains Jan 4th is the first week of the year.
	    },
	});

	//! moment.js locale configuration

	/*jshint -W100*/
	hooks$2.defineLocale('si', {
	    months: 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split(
	        '_'
	    ),
	    monthsShort: 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split(
	        '_'
	    ),
	    weekdays:
	        'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split(
	            '_'
	        ),
	    weekdaysShort: 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
	    weekdaysMin: 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
	    weekdaysParseExact: true,
	    longDateFormat: {
	        LT: 'a h:mm',
	        LTS: 'a h:mm:ss',
	        L: 'YYYY/MM/DD',
	        LL: 'YYYY MMMM D',
	        LLL: 'YYYY MMMM D, a h:mm',
	        LLLL: 'YYYY MMMM D [වැනි] dddd, a h:mm:ss',
	    },
	    calendar: {
	        sameDay: '[අද] LT[ට]',
	        nextDay: '[හෙට] LT[ට]',
	        nextWeek: 'dddd LT[ට]',
	        lastDay: '[ඊයේ] LT[ට]',
	        lastWeek: '[පසුගිය] dddd LT[ට]',
	        sameElse: 'L',
	    },
	    relativeTime: {
	        future: '%sකින්',
	        past: '%sකට පෙර',
	        s: 'තත්පර කිහිපය',
	        ss: 'තත්පර %d',
	        m: 'මිනිත්තුව',
	        mm: 'මිනිත්තු %d',
	        h: 'පැය',
	        hh: 'පැය %d',
	        d: 'දිනය',
	        dd: 'දින %d',
	        M: 'මාසය',
	        MM: 'මාස %d',
	        y: 'වසර',
	        yy: 'වසර %d',
	    },
	    dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
	    ordinal: function (number) {
	        return number + ' වැනි';
	    },
	    meridiemParse: /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
	    isPM: function (input) {
	        return input === 'ප.ව.' || input === 'පස් වරු';
	    },
	    meridiem: function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'ප.ව.' : 'පස් වරු';
	        } else {
	            return isLower ? 'පෙ.ව.' : 'පෙර වරු';
	        }
	    },
	});

	//! moment.js locale configuration

	var months$9 =
	        'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split(
	            '_'
	        ),
	    monthsShort$4 = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
	function plural$6(n) {
	    return n > 1 && n < 5;
	}
	function translate$9(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's': // a few seconds / in a few seconds / a few seconds ago
	            return withoutSuffix || isFuture ? 'pár sekúnd' : 'pár sekundami';
	        case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural$6(number) ? 'sekundy' : 'sekúnd');
	            } else {
	                return result + 'sekundami';
	            }
	        case 'm': // a minute / in a minute / a minute ago
	            return withoutSuffix ? 'minúta' : isFuture ? 'minútu' : 'minútou';
	        case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural$6(number) ? 'minúty' : 'minút');
	            } else {
	                return result + 'minútami';
	            }
	        case 'h': // an hour / in an hour / an hour ago
	            return withoutSuffix ? 'hodina' : isFuture ? 'hodinu' : 'hodinou';
	        case 'hh': // 9 hours / in 9 hours / 9 hours ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural$6(number) ? 'hodiny' : 'hodín');
	            } else {
	                return result + 'hodinami';
	            }
	        case 'd': // a day / in a day / a day ago
	            return withoutSuffix || isFuture ? 'deň' : 'dňom';
	        case 'dd': // 9 days / in 9 days / 9 days ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural$6(number) ? 'dni' : 'dní');
	            } else {
	                return result + 'dňami';
	            }
	        case 'M': // a month / in a month / a month ago
	            return withoutSuffix || isFuture ? 'mesiac' : 'mesiacom';
	        case 'MM': // 9 months / in 9 months / 9 months ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural$6(number) ? 'mesiace' : 'mesiacov');
	            } else {
	                return result + 'mesiacmi';
	            }
	        case 'y': // a year / in a year / a year ago
	            return withoutSuffix || isFuture ? 'rok' : 'rokom';
	        case 'yy': // 9 years / in 9 years / 9 years ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural$6(number) ? 'roky' : 'rokov');
	            } else {
	                return result + 'rokmi';
	            }
	    }
	}

	hooks$2.defineLocale('sk', {
	    months: months$9,
	    monthsShort: monthsShort$4,
	    weekdays: 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
	    weekdaysShort: 'ne_po_ut_st_št_pi_so'.split('_'),
	    weekdaysMin: 'ne_po_ut_st_št_pi_so'.split('_'),
	    longDateFormat: {
	        LT: 'H:mm',
	        LTS: 'H:mm:ss',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm',
	        LLLL: 'dddd D. MMMM YYYY H:mm',
	    },
	    calendar: {
	        sameDay: '[dnes o] LT',
	        nextDay: '[zajtra o] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[v nedeľu o] LT';
	                case 1:
	                case 2:
	                    return '[v] dddd [o] LT';
	                case 3:
	                    return '[v stredu o] LT';
	                case 4:
	                    return '[vo štvrtok o] LT';
	                case 5:
	                    return '[v piatok o] LT';
	                case 6:
	                    return '[v sobotu o] LT';
	            }
	        },
	        lastDay: '[včera o] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[minulú nedeľu o] LT';
	                case 1:
	                case 2:
	                    return '[minulý] dddd [o] LT';
	                case 3:
	                    return '[minulú stredu o] LT';
	                case 4:
	                case 5:
	                    return '[minulý] dddd [o] LT';
	                case 6:
	                    return '[minulú sobotu o] LT';
	            }
	        },
	        sameElse: 'L',
	    },
	    relativeTime: {
	        future: 'za %s',
	        past: 'pred %s',
	        s: translate$9,
	        ss: translate$9,
	        m: translate$9,
	        mm: translate$9,
	        h: translate$9,
	        hh: translate$9,
	        d: translate$9,
	        dd: translate$9,
	        M: translate$9,
	        MM: translate$9,
	        y: translate$9,
	        yy: translate$9,
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal: '%d.',
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4, // The week that contains Jan 4th is the first week of the year.
	    },
	});

	//! moment.js locale configuration

	function processRelativeTime$6(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':
	            return withoutSuffix || isFuture
	                ? 'nekaj sekund'
	                : 'nekaj sekundami';
	        case 'ss':
	            if (number === 1) {
	                result += withoutSuffix ? 'sekundo' : 'sekundi';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'sekundi' : 'sekundah';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'sekunde' : 'sekundah';
	            } else {
	                result += 'sekund';
	            }
	            return result;
	        case 'm':
	            return withoutSuffix ? 'ena minuta' : 'eno minuto';
	        case 'mm':
	            if (number === 1) {
	                result += withoutSuffix ? 'minuta' : 'minuto';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'minute' : 'minutami';
	            } else {
	                result += withoutSuffix || isFuture ? 'minut' : 'minutami';
	            }
	            return result;
	        case 'h':
	            return withoutSuffix ? 'ena ura' : 'eno uro';
	        case 'hh':
	            if (number === 1) {
	                result += withoutSuffix ? 'ura' : 'uro';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'uri' : 'urama';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'ure' : 'urami';
	            } else {
	                result += withoutSuffix || isFuture ? 'ur' : 'urami';
	            }
	            return result;
	        case 'd':
	            return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
	        case 'dd':
	            if (number === 1) {
	                result += withoutSuffix || isFuture ? 'dan' : 'dnem';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
	            } else {
	                result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
	            }
	            return result;
	        case 'M':
	            return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
	        case 'MM':
	            if (number === 1) {
	                result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
	            } else {
	                result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
	            }
	            return result;
	        case 'y':
	            return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
	        case 'yy':
	            if (number === 1) {
	                result += withoutSuffix || isFuture ? 'leto' : 'letom';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'leti' : 'letoma';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'leta' : 'leti';
	            } else {
	                result += withoutSuffix || isFuture ? 'let' : 'leti';
	            }
	            return result;
	    }
	}

	hooks$2.defineLocale('sl', {
	    months: 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split(
	        '_'
	    ),
	    monthsShort:
	        'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split(
	            '_'
	        ),
	    monthsParseExact: true,
	    weekdays: 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
	    weekdaysShort: 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
	    weekdaysMin: 'ne_po_to_sr_če_pe_so'.split('_'),
	    weekdaysParseExact: true,
	    longDateFormat: {
	        LT: 'H:mm',
	        LTS: 'H:mm:ss',
	        L: 'DD. MM. YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm',
	        LLLL: 'dddd, D. MMMM YYYY H:mm',
	    },
	    calendar: {
	        sameDay: '[danes ob] LT',
	        nextDay: '[jutri ob] LT',

	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[v] [nedeljo] [ob] LT';
	                case 3:
	                    return '[v] [sredo] [ob] LT';
	                case 6:
	                    return '[v] [soboto] [ob] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[v] dddd [ob] LT';
	            }
	        },
	        lastDay: '[včeraj ob] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[prejšnjo] [nedeljo] [ob] LT';
	                case 3:
	                    return '[prejšnjo] [sredo] [ob] LT';
	                case 6:
	                    return '[prejšnjo] [soboto] [ob] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[prejšnji] dddd [ob] LT';
	            }
	        },
	        sameElse: 'L',
	    },
	    relativeTime: {
	        future: 'čez %s',
	        past: 'pred %s',
	        s: processRelativeTime$6,
	        ss: processRelativeTime$6,
	        m: processRelativeTime$6,
	        mm: processRelativeTime$6,
	        h: processRelativeTime$6,
	        hh: processRelativeTime$6,
	        d: processRelativeTime$6,
	        dd: processRelativeTime$6,
	        M: processRelativeTime$6,
	        MM: processRelativeTime$6,
	        y: processRelativeTime$6,
	        yy: processRelativeTime$6,
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal: '%d.',
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 7, // The week that contains Jan 7th is the first week of the year.
	    },
	});

	//! moment.js locale configuration

	hooks$2.defineLocale('sq', {
	    months: 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split(
	        '_'
	    ),
	    monthsShort: 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
	    weekdays: 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split(
	        '_'
	    ),
	    weekdaysShort: 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
	    weekdaysMin: 'D_H_Ma_Më_E_P_Sh'.split('_'),
	    weekdaysParseExact: true,
	    meridiemParse: /PD|MD/,
	    isPM: function (input) {
	        return input.charAt(0) === 'M';
	    },
	    meridiem: function (hours, minutes, isLower) {
	        return hours < 12 ? 'PD' : 'MD';
	    },
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd, D MMMM YYYY HH:mm',
	    },
	    calendar: {
	        sameDay: '[Sot në] LT',
	        nextDay: '[Nesër në] LT',
	        nextWeek: 'dddd [në] LT',
	        lastDay: '[Dje në] LT',
	        lastWeek: 'dddd [e kaluar në] LT',
	        sameElse: 'L',
	    },
	    relativeTime: {
	        future: 'në %s',
	        past: '%s më parë',
	        s: 'disa sekonda',
	        ss: '%d sekonda',
	        m: 'një minutë',
	        mm: '%d minuta',
	        h: 'një orë',
	        hh: '%d orë',
	        d: 'një ditë',
	        dd: '%d ditë',
	        M: 'një muaj',
	        MM: '%d muaj',
	        y: 'një vit',
	        yy: '%d vite',
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal: '%d.',
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4, // The week that contains Jan 4th is the first week of the year.
	    },
	});

	//! moment.js locale configuration

	var translator$1 = {
	    words: {
	        //Different grammatical cases
	        ss: ['секунда', 'секунде', 'секунди'],
	        m: ['један минут', 'једног минута'],
	        mm: ['минут', 'минута', 'минута'],
	        h: ['један сат', 'једног сата'],
	        hh: ['сат', 'сата', 'сати'],
	        d: ['један дан', 'једног дана'],
	        dd: ['дан', 'дана', 'дана'],
	        M: ['један месец', 'једног месеца'],
	        MM: ['месец', 'месеца', 'месеци'],
	        y: ['једну годину', 'једне године'],
	        yy: ['годину', 'године', 'година'],
	    },
	    correctGrammaticalCase: function (number, wordKey) {
	        if (
	            number % 10 >= 1 &&
	            number % 10 <= 4 &&
	            (number % 100 < 10 || number % 100 >= 20)
	        ) {
	            return number % 10 === 1 ? wordKey[0] : wordKey[1];
	        }
	        return wordKey[2];
	    },
	    translate: function (number, withoutSuffix, key, isFuture) {
	        var wordKey = translator$1.words[key],
	            word;

	        if (key.length === 1) {
	            // Nominativ
	            if (key === 'y' && withoutSuffix) { return 'једна година'; }
	            return isFuture || withoutSuffix ? wordKey[0] : wordKey[1];
	        }

	        word = translator$1.correctGrammaticalCase(number, wordKey);
	        // Nominativ
	        if (key === 'yy' && withoutSuffix && word === 'годину') {
	            return number + ' година';
	        }

	        return number + ' ' + word;
	    },
	};

	hooks$2.defineLocale('sr-cyrl', {
	    months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split(
	        '_'
	    ),
	    monthsShort:
	        'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
	    monthsParseExact: true,
	    weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
	    weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
	    weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
	    weekdaysParseExact: true,
	    longDateFormat: {
	        LT: 'H:mm',
	        LTS: 'H:mm:ss',
	        L: 'D. M. YYYY.',
	        LL: 'D. MMMM YYYY.',
	        LLL: 'D. MMMM YYYY. H:mm',
	        LLLL: 'dddd, D. MMMM YYYY. H:mm',
	    },
	    calendar: {
	        sameDay: '[данас у] LT',
	        nextDay: '[сутра у] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[у] [недељу] [у] LT';
	                case 3:
	                    return '[у] [среду] [у] LT';
	                case 6:
	                    return '[у] [суботу] [у] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[у] dddd [у] LT';
	            }
	        },
	        lastDay: '[јуче у] LT',
	        lastWeek: function () {
	            var lastWeekDays = [
	                '[прошле] [недеље] [у] LT',
	                '[прошлог] [понедељка] [у] LT',
	                '[прошлог] [уторка] [у] LT',
	                '[прошле] [среде] [у] LT',
	                '[прошлог] [четвртка] [у] LT',
	                '[прошлог] [петка] [у] LT',
	                '[прошле] [суботе] [у] LT' ];
	            return lastWeekDays[this.day()];
	        },
	        sameElse: 'L',
	    },
	    relativeTime: {
	        future: 'за %s',
	        past: 'пре %s',
	        s: 'неколико секунди',
	        ss: translator$1.translate,
	        m: translator$1.translate,
	        mm: translator$1.translate,
	        h: translator$1.translate,
	        hh: translator$1.translate,
	        d: translator$1.translate,
	        dd: translator$1.translate,
	        M: translator$1.translate,
	        MM: translator$1.translate,
	        y: translator$1.translate,
	        yy: translator$1.translate,
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal: '%d.',
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 7, // The week that contains Jan 1st is the first week of the year.
	    },
	});

	//! moment.js locale configuration

	var translator$2 = {
	    words: {
	        //Different grammatical cases
	        ss: ['sekunda', 'sekunde', 'sekundi'],
	        m: ['jedan minut', 'jednog minuta'],
	        mm: ['minut', 'minuta', 'minuta'],
	        h: ['jedan sat', 'jednog sata'],
	        hh: ['sat', 'sata', 'sati'],
	        d: ['jedan dan', 'jednog dana'],
	        dd: ['dan', 'dana', 'dana'],
	        M: ['jedan mesec', 'jednog meseca'],
	        MM: ['mesec', 'meseca', 'meseci'],
	        y: ['jednu godinu', 'jedne godine'],
	        yy: ['godinu', 'godine', 'godina'],
	    },
	    correctGrammaticalCase: function (number, wordKey) {
	        if (
	            number % 10 >= 1 &&
	            number % 10 <= 4 &&
	            (number % 100 < 10 || number % 100 >= 20)
	        ) {
	            return number % 10 === 1 ? wordKey[0] : wordKey[1];
	        }
	        return wordKey[2];
	    },
	    translate: function (number, withoutSuffix, key, isFuture) {
	        var wordKey = translator$2.words[key],
	            word;

	        if (key.length === 1) {
	            // Nominativ
	            if (key === 'y' && withoutSuffix) { return 'jedna godina'; }
	            return isFuture || withoutSuffix ? wordKey[0] : wordKey[1];
	        }

	        word = translator$2.correctGrammaticalCase(number, wordKey);
	        // Nominativ
	        if (key === 'yy' && withoutSuffix && word === 'godinu') {
	            return number + ' godina';
	        }

	        return number + ' ' + word;
	    },
	};

	hooks$2.defineLocale('sr', {
	    months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split(
	        '_'
	    ),
	    monthsShort:
	        'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split(
	        '_'
	    ),
	    weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
	    weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact: true,
	    longDateFormat: {
	        LT: 'H:mm',
	        LTS: 'H:mm:ss',
	        L: 'D. M. YYYY.',
	        LL: 'D. MMMM YYYY.',
	        LLL: 'D. MMMM YYYY. H:mm',
	        LLLL: 'dddd, D. MMMM YYYY. H:mm',
	    },
	    calendar: {
	        sameDay: '[danas u] LT',
	        nextDay: '[sutra u] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedelju] [u] LT';
	                case 3:
	                    return '[u] [sredu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay: '[juče u] LT',
	        lastWeek: function () {
	            var lastWeekDays = [
	                '[prošle] [nedelje] [u] LT',
	                '[prošlog] [ponedeljka] [u] LT',
	                '[prošlog] [utorka] [u] LT',
	                '[prošle] [srede] [u] LT',
	                '[prošlog] [četvrtka] [u] LT',
	                '[prošlog] [petka] [u] LT',
	                '[prošle] [subote] [u] LT' ];
	            return lastWeekDays[this.day()];
	        },
	        sameElse: 'L',
	    },
	    relativeTime: {
	        future: 'za %s',
	        past: 'pre %s',
	        s: 'nekoliko sekundi',
	        ss: translator$2.translate,
	        m: translator$2.translate,
	        mm: translator$2.translate,
	        h: translator$2.translate,
	        hh: translator$2.translate,
	        d: translator$2.translate,
	        dd: translator$2.translate,
	        M: translator$2.translate,
	        MM: translator$2.translate,
	        y: translator$2.translate,
	        yy: translator$2.translate,
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal: '%d.',
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 7, // The week that contains Jan 7th is the first week of the year.
	    },
	});

	//! moment.js locale configuration

	hooks$2.defineLocale('ss', {
	    months: "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split(
	        '_'
	    ),
	    monthsShort: 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
	    weekdays:
	        'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split(
	            '_'
	        ),
	    weekdaysShort: 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
	    weekdaysMin: 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
	    weekdaysParseExact: true,
	    longDateFormat: {
	        LT: 'h:mm A',
	        LTS: 'h:mm:ss A',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY h:mm A',
	        LLLL: 'dddd, D MMMM YYYY h:mm A',
	    },
	    calendar: {
	        sameDay: '[Namuhla nga] LT',
	        nextDay: '[Kusasa nga] LT',
	        nextWeek: 'dddd [nga] LT',
	        lastDay: '[Itolo nga] LT',
	        lastWeek: 'dddd [leliphelile] [nga] LT',
	        sameElse: 'L',
	    },
	    relativeTime: {
	        future: 'nga %s',
	        past: 'wenteka nga %s',
	        s: 'emizuzwana lomcane',
	        ss: '%d mzuzwana',
	        m: 'umzuzu',
	        mm: '%d emizuzu',
	        h: 'lihora',
	        hh: '%d emahora',
	        d: 'lilanga',
	        dd: '%d emalanga',
	        M: 'inyanga',
	        MM: '%d tinyanga',
	        y: 'umnyaka',
	        yy: '%d iminyaka',
	    },
	    meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
	    meridiem: function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'ekuseni';
	        } else if (hours < 15) {
	            return 'emini';
	        } else if (hours < 19) {
	            return 'entsambama';
	        } else {
	            return 'ebusuku';
	        }
	    },
	    meridiemHour: function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'ekuseni') {
	            return hour;
	        } else if (meridiem === 'emini') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
	            if (hour === 0) {
	                return 0;
	            }
	            return hour + 12;
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}/,
	    ordinal: '%d',
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4, // The week that contains Jan 4th is the first week of the year.
	    },
	});

	//! moment.js locale configuration

	hooks$2.defineLocale('sv', {
	    months: 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split(
	        '_'
	    ),
	    monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	    weekdays: 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
	    weekdaysShort: 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
	    weekdaysMin: 'sö_må_ti_on_to_fr_lö'.split('_'),
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'YYYY-MM-DD',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY [kl.] HH:mm',
	        LLLL: 'dddd D MMMM YYYY [kl.] HH:mm',
	        lll: 'D MMM YYYY HH:mm',
	        llll: 'ddd D MMM YYYY HH:mm',
	    },
	    calendar: {
	        sameDay: '[Idag] LT',
	        nextDay: '[Imorgon] LT',
	        lastDay: '[Igår] LT',
	        nextWeek: '[På] dddd LT',
	        lastWeek: '[I] dddd[s] LT',
	        sameElse: 'L',
	    },
	    relativeTime: {
	        future: 'om %s',
	        past: 'för %s sedan',
	        s: 'några sekunder',
	        ss: '%d sekunder',
	        m: 'en minut',
	        mm: '%d minuter',
	        h: 'en timme',
	        hh: '%d timmar',
	        d: 'en dag',
	        dd: '%d dagar',
	        M: 'en månad',
	        MM: '%d månader',
	        y: 'ett år',
	        yy: '%d år',
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(\:e|\:a)/,
	    ordinal: function (number) {
	        var b = number % 10,
	            output =
	                ~~((number % 100) / 10) === 1
	                    ? ':e'
	                    : b === 1
	                    ? ':a'
	                    : b === 2
	                    ? ':a'
	                    : b === 3
	                    ? ':e'
	                    : ':e';
	        return number + output;
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4, // The week that contains Jan 4th is the first week of the year.
	    },
	});

	//! moment.js locale configuration

	hooks$2.defineLocale('sw', {
	    months: 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split(
	        '_'
	    ),
	    monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
	    weekdays:
	        'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split(
	            '_'
	        ),
	    weekdaysShort: 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
	    weekdaysMin: 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
	    weekdaysParseExact: true,
	    longDateFormat: {
	        LT: 'hh:mm A',
	        LTS: 'HH:mm:ss',
	        L: 'DD.MM.YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd, D MMMM YYYY HH:mm',
	    },
	    calendar: {
	        sameDay: '[leo saa] LT',
	        nextDay: '[kesho saa] LT',
	        nextWeek: '[wiki ijayo] dddd [saat] LT',
	        lastDay: '[jana] LT',
	        lastWeek: '[wiki iliyopita] dddd [saat] LT',
	        sameElse: 'L',
	    },
	    relativeTime: {
	        future: '%s baadaye',
	        past: 'tokea %s',
	        s: 'hivi punde',
	        ss: 'sekunde %d',
	        m: 'dakika moja',
	        mm: 'dakika %d',
	        h: 'saa limoja',
	        hh: 'masaa %d',
	        d: 'siku moja',
	        dd: 'siku %d',
	        M: 'mwezi mmoja',
	        MM: 'miezi %d',
	        y: 'mwaka mmoja',
	        yy: 'miaka %d',
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 7, // The week that contains Jan 7th is the first week of the year.
	    },
	});

	//! moment.js locale configuration

	var symbolMap$d = {
	        1: '௧',
	        2: '௨',
	        3: '௩',
	        4: '௪',
	        5: '௫',
	        6: '௬',
	        7: '௭',
	        8: '௮',
	        9: '௯',
	        0: '௦',
	    },
	    numberMap$c = {
	        '௧': '1',
	        '௨': '2',
	        '௩': '3',
	        '௪': '4',
	        '௫': '5',
	        '௬': '6',
	        '௭': '7',
	        '௮': '8',
	        '௯': '9',
	        '௦': '0',
	    };

	hooks$2.defineLocale('ta', {
	    months: 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split(
	        '_'
	    ),
	    monthsShort:
	        'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split(
	            '_'
	        ),
	    weekdays:
	        'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split(
	            '_'
	        ),
	    weekdaysShort: 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split(
	        '_'
	    ),
	    weekdaysMin: 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY, HH:mm',
	        LLLL: 'dddd, D MMMM YYYY, HH:mm',
	    },
	    calendar: {
	        sameDay: '[இன்று] LT',
	        nextDay: '[நாளை] LT',
	        nextWeek: 'dddd, LT',
	        lastDay: '[நேற்று] LT',
	        lastWeek: '[கடந்த வாரம்] dddd, LT',
	        sameElse: 'L',
	    },
	    relativeTime: {
	        future: '%s இல்',
	        past: '%s முன்',
	        s: 'ஒரு சில விநாடிகள்',
	        ss: '%d விநாடிகள்',
	        m: 'ஒரு நிமிடம்',
	        mm: '%d நிமிடங்கள்',
	        h: 'ஒரு மணி நேரம்',
	        hh: '%d மணி நேரம்',
	        d: 'ஒரு நாள்',
	        dd: '%d நாட்கள்',
	        M: 'ஒரு மாதம்',
	        MM: '%d மாதங்கள்',
	        y: 'ஒரு வருடம்',
	        yy: '%d ஆண்டுகள்',
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}வது/,
	    ordinal: function (number) {
	        return number + 'வது';
	    },
	    preparse: function (string) {
	        return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
	            return numberMap$c[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap$d[match];
	        });
	    },
	    // refer http://ta.wikipedia.org/s/1er1
	    meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
	    meridiem: function (hour, minute, isLower) {
	        if (hour < 2) {
	            return ' யாமம்';
	        } else if (hour < 6) {
	            return ' வைகறை'; // வைகறை
	        } else if (hour < 10) {
	            return ' காலை'; // காலை
	        } else if (hour < 14) {
	            return ' நண்பகல்'; // நண்பகல்
	        } else if (hour < 18) {
	            return ' எற்பாடு'; // எற்பாடு
	        } else if (hour < 22) {
	            return ' மாலை'; // மாலை
	        } else {
	            return ' யாமம்';
	        }
	    },
	    meridiemHour: function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'யாமம்') {
	            return hour < 2 ? hour : hour + 12;
	        } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
	            return hour;
	        } else if (meridiem === 'நண்பகல்') {
	            return hour >= 10 ? hour : hour + 12;
	        } else {
	            return hour + 12;
	        }
	    },
	    week: {
	        dow: 0, // Sunday is the first day of the week.
	        doy: 6, // The week that contains Jan 6th is the first week of the year.
	    },
	});

	//! moment.js locale configuration

	hooks$2.defineLocale('te', {
	    months: 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జులై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split(
	        '_'
	    ),
	    monthsShort:
	        'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జులై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split(
	            '_'
	        ),
	    monthsParseExact: true,
	    weekdays:
	        'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split(
	            '_'
	        ),
	    weekdaysShort: 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
	    weekdaysMin: 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
	    longDateFormat: {
	        LT: 'A h:mm',
	        LTS: 'A h:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY, A h:mm',
	        LLLL: 'dddd, D MMMM YYYY, A h:mm',
	    },
	    calendar: {
	        sameDay: '[నేడు] LT',
	        nextDay: '[రేపు] LT',
	        nextWeek: 'dddd, LT',
	        lastDay: '[నిన్న] LT',
	        lastWeek: '[గత] dddd, LT',
	        sameElse: 'L',
	    },
	    relativeTime: {
	        future: '%s లో',
	        past: '%s క్రితం',
	        s: 'కొన్ని క్షణాలు',
	        ss: '%d సెకన్లు',
	        m: 'ఒక నిమిషం',
	        mm: '%d నిమిషాలు',
	        h: 'ఒక గంట',
	        hh: '%d గంటలు',
	        d: 'ఒక రోజు',
	        dd: '%d రోజులు',
	        M: 'ఒక నెల',
	        MM: '%d నెలలు',
	        y: 'ఒక సంవత్సరం',
	        yy: '%d సంవత్సరాలు',
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}వ/,
	    ordinal: '%dవ',
	    meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
	    meridiemHour: function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'రాత్రి') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'ఉదయం') {
	            return hour;
	        } else if (meridiem === 'మధ్యాహ్నం') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'సాయంత్రం') {
	            return hour + 12;
	        }
	    },
	    meridiem: function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'రాత్రి';
	        } else if (hour < 10) {
	            return 'ఉదయం';
	        } else if (hour < 17) {
	            return 'మధ్యాహ్నం';
	        } else if (hour < 20) {
	            return 'సాయంత్రం';
	        } else {
	            return 'రాత్రి';
	        }
	    },
	    week: {
	        dow: 0, // Sunday is the first day of the week.
	        doy: 6, // The week that contains Jan 6th is the first week of the year.
	    },
	});

	//! moment.js locale configuration

	hooks$2.defineLocale('tet', {
	    months: 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juñu_Jullu_Agustu_Setembru_Outubru_Novembru_Dezembru'.split(
	        '_'
	    ),
	    monthsShort: 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	    weekdays: 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sesta_Sabadu'.split('_'),
	    weekdaysShort: 'Dom_Seg_Ters_Kua_Kint_Sest_Sab'.split('_'),
	    weekdaysMin: 'Do_Seg_Te_Ku_Ki_Ses_Sa'.split('_'),
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd, D MMMM YYYY HH:mm',
	    },
	    calendar: {
	        sameDay: '[Ohin iha] LT',
	        nextDay: '[Aban iha] LT',
	        nextWeek: 'dddd [iha] LT',
	        lastDay: '[Horiseik iha] LT',
	        lastWeek: 'dddd [semana kotuk] [iha] LT',
	        sameElse: 'L',
	    },
	    relativeTime: {
	        future: 'iha %s',
	        past: '%s liuba',
	        s: 'segundu balun',
	        ss: 'segundu %d',
	        m: 'minutu ida',
	        mm: 'minutu %d',
	        h: 'oras ida',
	        hh: 'oras %d',
	        d: 'loron ida',
	        dd: 'loron %d',
	        M: 'fulan ida',
	        MM: 'fulan %d',
	        y: 'tinan ida',
	        yy: 'tinan %d',
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal: function (number) {
	        var b = number % 10,
	            output =
	                ~~((number % 100) / 10) === 1
	                    ? 'th'
	                    : b === 1
	                    ? 'st'
	                    : b === 2
	                    ? 'nd'
	                    : b === 3
	                    ? 'rd'
	                    : 'th';
	        return number + output;
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4, // The week that contains Jan 4th is the first week of the year.
	    },
	});

	//! moment.js locale configuration

	hooks$2.defineLocale('th', {
	    months: 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split(
	        '_'
	    ),
	    monthsShort:
	        'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split(
	            '_'
	        ),
	    monthsParseExact: true,
	    weekdays: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
	    weekdaysShort: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
	    weekdaysMin: 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
	    weekdaysParseExact: true,
	    longDateFormat: {
	        LT: 'H:mm',
	        LTS: 'H:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY เวลา H:mm',
	        LLLL: 'วันddddที่ D MMMM YYYY เวลา H:mm',
	    },
	    meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
	    isPM: function (input) {
	        return input === 'หลังเที่ยง';
	    },
	    meridiem: function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ก่อนเที่ยง';
	        } else {
	            return 'หลังเที่ยง';
	        }
	    },
	    calendar: {
	        sameDay: '[วันนี้ เวลา] LT',
	        nextDay: '[พรุ่งนี้ เวลา] LT',
	        nextWeek: 'dddd[หน้า เวลา] LT',
	        lastDay: '[เมื่อวานนี้ เวลา] LT',
	        lastWeek: '[วัน]dddd[ที่แล้ว เวลา] LT',
	        sameElse: 'L',
	    },
	    relativeTime: {
	        future: 'อีก %s',
	        past: '%sที่แล้ว',
	        s: 'ไม่กี่วินาที',
	        ss: '%d วินาที',
	        m: '1 นาที',
	        mm: '%d นาที',
	        h: '1 ชั่วโมง',
	        hh: '%d ชั่วโมง',
	        d: '1 วัน',
	        dd: '%d วัน',
	        w: '1 สัปดาห์',
	        ww: '%d สัปดาห์',
	        M: '1 เดือน',
	        MM: '%d เดือน',
	        y: '1 ปี',
	        yy: '%d ปี',
	    },
	});

	//! moment.js locale configuration

	hooks$2.defineLocale('tl-ph', {
	    months: 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split(
	        '_'
	    ),
	    monthsShort: 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
	    weekdays: 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split(
	        '_'
	    ),
	    weekdaysShort: 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
	    weekdaysMin: 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'MM/D/YYYY',
	        LL: 'MMMM D, YYYY',
	        LLL: 'MMMM D, YYYY HH:mm',
	        LLLL: 'dddd, MMMM DD, YYYY HH:mm',
	    },
	    calendar: {
	        sameDay: 'LT [ngayong araw]',
	        nextDay: '[Bukas ng] LT',
	        nextWeek: 'LT [sa susunod na] dddd',
	        lastDay: 'LT [kahapon]',
	        lastWeek: 'LT [noong nakaraang] dddd',
	        sameElse: 'L',
	    },
	    relativeTime: {
	        future: 'sa loob ng %s',
	        past: '%s ang nakalipas',
	        s: 'ilang segundo',
	        ss: '%d segundo',
	        m: 'isang minuto',
	        mm: '%d minuto',
	        h: 'isang oras',
	        hh: '%d oras',
	        d: 'isang araw',
	        dd: '%d araw',
	        M: 'isang buwan',
	        MM: '%d buwan',
	        y: 'isang taon',
	        yy: '%d taon',
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}/,
	    ordinal: function (number) {
	        return number;
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4, // The week that contains Jan 4th is the first week of the year.
	    },
	});

	//! moment.js locale configuration

	var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');

	function translateFuture(output) {
	    var time = output;
	    time =
	        output.indexOf('jaj') !== -1
	            ? time.slice(0, -3) + 'leS'
	            : output.indexOf('jar') !== -1
	            ? time.slice(0, -3) + 'waQ'
	            : output.indexOf('DIS') !== -1
	            ? time.slice(0, -3) + 'nem'
	            : time + ' pIq';
	    return time;
	}

	function translatePast(output) {
	    var time = output;
	    time =
	        output.indexOf('jaj') !== -1
	            ? time.slice(0, -3) + 'Hu’'
	            : output.indexOf('jar') !== -1
	            ? time.slice(0, -3) + 'wen'
	            : output.indexOf('DIS') !== -1
	            ? time.slice(0, -3) + 'ben'
	            : time + ' ret';
	    return time;
	}

	function translate$a(number, withoutSuffix, string, isFuture) {
	    var numberNoun = numberAsNoun(number);
	    switch (string) {
	        case 'ss':
	            return numberNoun + ' lup';
	        case 'mm':
	            return numberNoun + ' tup';
	        case 'hh':
	            return numberNoun + ' rep';
	        case 'dd':
	            return numberNoun + ' jaj';
	        case 'MM':
	            return numberNoun + ' jar';
	        case 'yy':
	            return numberNoun + ' DIS';
	    }
	}

	function numberAsNoun(number) {
	    var hundred = Math.floor((number % 1000) / 100),
	        ten = Math.floor((number % 100) / 10),
	        one = number % 10,
	        word = '';
	    if (hundred > 0) {
	        word += numbersNouns[hundred] + 'vatlh';
	    }
	    if (ten > 0) {
	        word += (word !== '' ? ' ' : '') + numbersNouns[ten] + 'maH';
	    }
	    if (one > 0) {
	        word += (word !== '' ? ' ' : '') + numbersNouns[one];
	    }
	    return word === '' ? 'pagh' : word;
	}

	hooks$2.defineLocale('tlh', {
	    months: 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split(
	        '_'
	    ),
	    monthsShort:
	        'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split(
	            '_'
	        ),
	    monthsParseExact: true,
	    weekdays: 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split(
	        '_'
	    ),
	    weekdaysShort:
	        'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	    weekdaysMin:
	        'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD.MM.YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd, D MMMM YYYY HH:mm',
	    },
	    calendar: {
	        sameDay: '[DaHjaj] LT',
	        nextDay: '[wa’leS] LT',
	        nextWeek: 'LLL',
	        lastDay: '[wa’Hu’] LT',
	        lastWeek: 'LLL',
	        sameElse: 'L',
	    },
	    relativeTime: {
	        future: translateFuture,
	        past: translatePast,
	        s: 'puS lup',
	        ss: translate$a,
	        m: 'wa’ tup',
	        mm: translate$a,
	        h: 'wa’ rep',
	        hh: translate$a,
	        d: 'wa’ jaj',
	        dd: translate$a,
	        M: 'wa’ jar',
	        MM: translate$a,
	        y: 'wa’ DIS',
	        yy: translate$a,
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal: '%d.',
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4, // The week that contains Jan 4th is the first week of the year.
	    },
	});

	//! moment.js locale configuration

	var suffixes$3 = {
	    1: "'inci",
	    5: "'inci",
	    8: "'inci",
	    70: "'inci",
	    80: "'inci",
	    2: "'nci",
	    7: "'nci",
	    20: "'nci",
	    50: "'nci",
	    3: "'üncü",
	    4: "'üncü",
	    100: "'üncü",
	    6: "'ncı",
	    9: "'uncu",
	    10: "'uncu",
	    30: "'uncu",
	    60: "'ıncı",
	    90: "'ıncı",
	};

	hooks$2.defineLocale('tr', {
	    months: 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split(
	        '_'
	    ),
	    monthsShort: 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
	    weekdays: 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split(
	        '_'
	    ),
	    weekdaysShort: 'Paz_Pzt_Sal_Çar_Per_Cum_Cmt'.split('_'),
	    weekdaysMin: 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
	    meridiem: function (hours, minutes, isLower) {
	        if (hours < 12) {
	            return isLower ? 'öö' : 'ÖÖ';
	        } else {
	            return isLower ? 'ös' : 'ÖS';
	        }
	    },
	    meridiemParse: /öö|ÖÖ|ös|ÖS/,
	    isPM: function (input) {
	        return input === 'ös' || input === 'ÖS';
	    },
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD.MM.YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd, D MMMM YYYY HH:mm',
	    },
	    calendar: {
	        sameDay: '[bugün saat] LT',
	        nextDay: '[yarın saat] LT',
	        nextWeek: '[gelecek] dddd [saat] LT',
	        lastDay: '[dün] LT',
	        lastWeek: '[geçen] dddd [saat] LT',
	        sameElse: 'L',
	    },
	    relativeTime: {
	        future: '%s sonra',
	        past: '%s önce',
	        s: 'birkaç saniye',
	        ss: '%d saniye',
	        m: 'bir dakika',
	        mm: '%d dakika',
	        h: 'bir saat',
	        hh: '%d saat',
	        d: 'bir gün',
	        dd: '%d gün',
	        w: 'bir hafta',
	        ww: '%d hafta',
	        M: 'bir ay',
	        MM: '%d ay',
	        y: 'bir yıl',
	        yy: '%d yıl',
	    },
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'd':
	            case 'D':
	            case 'Do':
	            case 'DD':
	                return number;
	            default:
	                if (number === 0) {
	                    // special case for zero
	                    return number + "'ıncı";
	                }
	                var a = number % 10,
	                    b = (number % 100) - a,
	                    c = number >= 100 ? 100 : null;
	                return number + (suffixes$3[a] || suffixes$3[b] || suffixes$3[c]);
	        }
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 7, // The week that contains Jan 7th is the first week of the year.
	    },
	});

	//! moment.js locale configuration

	// After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
	// This is currently too difficult (maybe even impossible) to add.
	hooks$2.defineLocale('tzl', {
	    months: 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split(
	        '_'
	    ),
	    monthsShort: 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
	    weekdays: 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
	    weekdaysShort: 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
	    weekdaysMin: 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
	    longDateFormat: {
	        LT: 'HH.mm',
	        LTS: 'HH.mm.ss',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM [dallas] YYYY',
	        LLL: 'D. MMMM [dallas] YYYY HH.mm',
	        LLLL: 'dddd, [li] D. MMMM [dallas] YYYY HH.mm',
	    },
	    meridiemParse: /d\'o|d\'a/i,
	    isPM: function (input) {
	        return "d'o" === input.toLowerCase();
	    },
	    meridiem: function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? "d'o" : "D'O";
	        } else {
	            return isLower ? "d'a" : "D'A";
	        }
	    },
	    calendar: {
	        sameDay: '[oxhi à] LT',
	        nextDay: '[demà à] LT',
	        nextWeek: 'dddd [à] LT',
	        lastDay: '[ieiri à] LT',
	        lastWeek: '[sür el] dddd [lasteu à] LT',
	        sameElse: 'L',
	    },
	    relativeTime: {
	        future: 'osprei %s',
	        past: 'ja%s',
	        s: processRelativeTime$7,
	        ss: processRelativeTime$7,
	        m: processRelativeTime$7,
	        mm: processRelativeTime$7,
	        h: processRelativeTime$7,
	        hh: processRelativeTime$7,
	        d: processRelativeTime$7,
	        dd: processRelativeTime$7,
	        M: processRelativeTime$7,
	        MM: processRelativeTime$7,
	        y: processRelativeTime$7,
	        yy: processRelativeTime$7,
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal: '%d.',
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4, // The week that contains Jan 4th is the first week of the year.
	    },
	});

	function processRelativeTime$7(number, withoutSuffix, key, isFuture) {
	    var format = {
	        s: ['viensas secunds', "'iensas secunds"],
	        ss: [number + ' secunds', '' + number + ' secunds'],
	        m: ["'n míut", "'iens míut"],
	        mm: [number + ' míuts', '' + number + ' míuts'],
	        h: ["'n þora", "'iensa þora"],
	        hh: [number + ' þoras', '' + number + ' þoras'],
	        d: ["'n ziua", "'iensa ziua"],
	        dd: [number + ' ziuas', '' + number + ' ziuas'],
	        M: ["'n mes", "'iens mes"],
	        MM: [number + ' mesen', '' + number + ' mesen'],
	        y: ["'n ar", "'iens ar"],
	        yy: [number + ' ars', '' + number + ' ars'],
	    };
	    return isFuture
	        ? format[key][0]
	        : withoutSuffix
	        ? format[key][0]
	        : format[key][1];
	}

	//! moment.js locale configuration

	hooks$2.defineLocale('tzm-latn', {
	    months: 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split(
	        '_'
	    ),
	    monthsShort:
	        'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split(
	            '_'
	        ),
	    weekdays: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	    weekdaysShort: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	    weekdaysMin: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd D MMMM YYYY HH:mm',
	    },
	    calendar: {
	        sameDay: '[asdkh g] LT',
	        nextDay: '[aska g] LT',
	        nextWeek: 'dddd [g] LT',
	        lastDay: '[assant g] LT',
	        lastWeek: 'dddd [g] LT',
	        sameElse: 'L',
	    },
	    relativeTime: {
	        future: 'dadkh s yan %s',
	        past: 'yan %s',
	        s: 'imik',
	        ss: '%d imik',
	        m: 'minuḍ',
	        mm: '%d minuḍ',
	        h: 'saɛa',
	        hh: '%d tassaɛin',
	        d: 'ass',
	        dd: '%d ossan',
	        M: 'ayowr',
	        MM: '%d iyyirn',
	        y: 'asgas',
	        yy: '%d isgasn',
	    },
	    week: {
	        dow: 6, // Saturday is the first day of the week.
	        doy: 12, // The week that contains Jan 12th is the first week of the year.
	    },
	});

	//! moment.js locale configuration

	hooks$2.defineLocale('tzm', {
	    months: 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split(
	        '_'
	    ),
	    monthsShort:
	        'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split(
	            '_'
	        ),
	    weekdays: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	    weekdaysShort: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	    weekdaysMin: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd D MMMM YYYY HH:mm',
	    },
	    calendar: {
	        sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
	        nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
	        nextWeek: 'dddd [ⴴ] LT',
	        lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
	        lastWeek: 'dddd [ⴴ] LT',
	        sameElse: 'L',
	    },
	    relativeTime: {
	        future: 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
	        past: 'ⵢⴰⵏ %s',
	        s: 'ⵉⵎⵉⴽ',
	        ss: '%d ⵉⵎⵉⴽ',
	        m: 'ⵎⵉⵏⵓⴺ',
	        mm: '%d ⵎⵉⵏⵓⴺ',
	        h: 'ⵙⴰⵄⴰ',
	        hh: '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
	        d: 'ⴰⵙⵙ',
	        dd: '%d oⵙⵙⴰⵏ',
	        M: 'ⴰⵢoⵓⵔ',
	        MM: '%d ⵉⵢⵢⵉⵔⵏ',
	        y: 'ⴰⵙⴳⴰⵙ',
	        yy: '%d ⵉⵙⴳⴰⵙⵏ',
	    },
	    week: {
	        dow: 6, // Saturday is the first day of the week.
	        doy: 12, // The week that contains Jan 12th is the first week of the year.
	    },
	});

	//! moment.js locale configuration

	function plural$7(word, num) {
	    var forms = word.split('_');
	    return num % 10 === 1 && num % 100 !== 11
	        ? forms[0]
	        : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
	        ? forms[1]
	        : forms[2];
	}
	function relativeTimeWithPlural$4(number, withoutSuffix, key) {
	    var format = {
	        ss: withoutSuffix ? 'секунда_секунди_секунд' : 'секунду_секунди_секунд',
	        mm: withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
	        hh: withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
	        dd: 'день_дні_днів',
	        MM: 'місяць_місяці_місяців',
	        yy: 'рік_роки_років',
	    };
	    if (key === 'm') {
	        return withoutSuffix ? 'хвилина' : 'хвилину';
	    } else if (key === 'h') {
	        return withoutSuffix ? 'година' : 'годину';
	    } else {
	        return number + ' ' + plural$7(format[key], +number);
	    }
	}
	function weekdaysCaseReplace(m, format) {
	    var weekdays = {
	            nominative:
	                'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split(
	                    '_'
	                ),
	            accusative:
	                'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split(
	                    '_'
	                ),
	            genitive:
	                'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split(
	                    '_'
	                ),
	        },
	        nounCase;

	    if (m === true) {
	        return weekdays['nominative']
	            .slice(1, 7)
	            .concat(weekdays['nominative'].slice(0, 1));
	    }
	    if (!m) {
	        return weekdays['nominative'];
	    }

	    nounCase = /(\[[ВвУу]\]) ?dddd/.test(format)
	        ? 'accusative'
	        : /\[?(?:минулої|наступної)? ?\] ?dddd/.test(format)
	        ? 'genitive'
	        : 'nominative';
	    return weekdays[nounCase][m.day()];
	}
	function processHoursFunction(str) {
	    return function () {
	        return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
	    };
	}

	hooks$2.defineLocale('uk', {
	    months: {
	        format: 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split(
	            '_'
	        ),
	        standalone:
	            'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split(
	                '_'
	            ),
	    },
	    monthsShort: 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split(
	        '_'
	    ),
	    weekdays: weekdaysCaseReplace,
	    weekdaysShort: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	    weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD.MM.YYYY',
	        LL: 'D MMMM YYYY р.',
	        LLL: 'D MMMM YYYY р., HH:mm',
	        LLLL: 'dddd, D MMMM YYYY р., HH:mm',
	    },
	    calendar: {
	        sameDay: processHoursFunction('[Сьогодні '),
	        nextDay: processHoursFunction('[Завтра '),
	        lastDay: processHoursFunction('[Вчора '),
	        nextWeek: processHoursFunction('[У] dddd ['),
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 5:
	                case 6:
	                    return processHoursFunction('[Минулої] dddd [').call(this);
	                case 1:
	                case 2:
	                case 4:
	                    return processHoursFunction('[Минулого] dddd [').call(this);
	            }
	        },
	        sameElse: 'L',
	    },
	    relativeTime: {
	        future: 'за %s',
	        past: '%s тому',
	        s: 'декілька секунд',
	        ss: relativeTimeWithPlural$4,
	        m: relativeTimeWithPlural$4,
	        mm: relativeTimeWithPlural$4,
	        h: 'годину',
	        hh: relativeTimeWithPlural$4,
	        d: 'день',
	        dd: relativeTimeWithPlural$4,
	        M: 'місяць',
	        MM: relativeTimeWithPlural$4,
	        y: 'рік',
	        yy: relativeTimeWithPlural$4,
	    },
	    // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
	    meridiemParse: /ночі|ранку|дня|вечора/,
	    isPM: function (input) {
	        return /^(дня|вечора)$/.test(input);
	    },
	    meridiem: function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ночі';
	        } else if (hour < 12) {
	            return 'ранку';
	        } else if (hour < 17) {
	            return 'дня';
	        } else {
	            return 'вечора';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'M':
	            case 'd':
	            case 'DDD':
	            case 'w':
	            case 'W':
	                return number + '-й';
	            case 'D':
	                return number + '-го';
	            default:
	                return number;
	        }
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 7, // The week that contains Jan 7th is the first week of the year.
	    },
	});

	//! moment.js locale configuration

	var months$a = [
	        'جنوری',
	        'فروری',
	        'مارچ',
	        'اپریل',
	        'مئی',
	        'جون',
	        'جولائی',
	        'اگست',
	        'ستمبر',
	        'اکتوبر',
	        'نومبر',
	        'دسمبر' ],
	    days$3 = ['اتوار', 'پیر', 'منگل', 'بدھ', 'جمعرات', 'جمعہ', 'ہفتہ'];

	hooks$2.defineLocale('ur', {
	    months: months$a,
	    monthsShort: months$a,
	    weekdays: days$3,
	    weekdaysShort: days$3,
	    weekdaysMin: days$3,
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd، D MMMM YYYY HH:mm',
	    },
	    meridiemParse: /صبح|شام/,
	    isPM: function (input) {
	        return 'شام' === input;
	    },
	    meridiem: function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'صبح';
	        }
	        return 'شام';
	    },
	    calendar: {
	        sameDay: '[آج بوقت] LT',
	        nextDay: '[کل بوقت] LT',
	        nextWeek: 'dddd [بوقت] LT',
	        lastDay: '[گذشتہ روز بوقت] LT',
	        lastWeek: '[گذشتہ] dddd [بوقت] LT',
	        sameElse: 'L',
	    },
	    relativeTime: {
	        future: '%s بعد',
	        past: '%s قبل',
	        s: 'چند سیکنڈ',
	        ss: '%d سیکنڈ',
	        m: 'ایک منٹ',
	        mm: '%d منٹ',
	        h: 'ایک گھنٹہ',
	        hh: '%d گھنٹے',
	        d: 'ایک دن',
	        dd: '%d دن',
	        M: 'ایک ماہ',
	        MM: '%d ماہ',
	        y: 'ایک سال',
	        yy: '%d سال',
	    },
	    preparse: function (string) {
	        return string.replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/,/g, '،');
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4, // The week that contains Jan 4th is the first week of the year.
	    },
	});

	//! moment.js locale configuration

	hooks$2.defineLocale('uz-latn', {
	    months: 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split(
	        '_'
	    ),
	    monthsShort: 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
	    weekdays:
	        'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split(
	            '_'
	        ),
	    weekdaysShort: 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
	    weekdaysMin: 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'D MMMM YYYY, dddd HH:mm',
	    },
	    calendar: {
	        sameDay: '[Bugun soat] LT [da]',
	        nextDay: '[Ertaga] LT [da]',
	        nextWeek: 'dddd [kuni soat] LT [da]',
	        lastDay: '[Kecha soat] LT [da]',
	        lastWeek: "[O'tgan] dddd [kuni soat] LT [da]",
	        sameElse: 'L',
	    },
	    relativeTime: {
	        future: 'Yaqin %s ichida',
	        past: 'Bir necha %s oldin',
	        s: 'soniya',
	        ss: '%d soniya',
	        m: 'bir daqiqa',
	        mm: '%d daqiqa',
	        h: 'bir soat',
	        hh: '%d soat',
	        d: 'bir kun',
	        dd: '%d kun',
	        M: 'bir oy',
	        MM: '%d oy',
	        y: 'bir yil',
	        yy: '%d yil',
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 7, // The week that contains Jan 7th is the first week of the year.
	    },
	});

	//! moment.js locale configuration

	hooks$2.defineLocale('uz', {
	    months: 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split(
	        '_'
	    ),
	    monthsShort: 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	    weekdays: 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
	    weekdaysShort: 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
	    weekdaysMin: 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'D MMMM YYYY, dddd HH:mm',
	    },
	    calendar: {
	        sameDay: '[Бугун соат] LT [да]',
	        nextDay: '[Эртага] LT [да]',
	        nextWeek: 'dddd [куни соат] LT [да]',
	        lastDay: '[Кеча соат] LT [да]',
	        lastWeek: '[Утган] dddd [куни соат] LT [да]',
	        sameElse: 'L',
	    },
	    relativeTime: {
	        future: 'Якин %s ичида',
	        past: 'Бир неча %s олдин',
	        s: 'фурсат',
	        ss: '%d фурсат',
	        m: 'бир дакика',
	        mm: '%d дакика',
	        h: 'бир соат',
	        hh: '%d соат',
	        d: 'бир кун',
	        dd: '%d кун',
	        M: 'бир ой',
	        MM: '%d ой',
	        y: 'бир йил',
	        yy: '%d йил',
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 7, // The week that contains Jan 4th is the first week of the year.
	    },
	});

	//! moment.js locale configuration

	hooks$2.defineLocale('vi', {
	    months: 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split(
	        '_'
	    ),
	    monthsShort:
	        'Thg 01_Thg 02_Thg 03_Thg 04_Thg 05_Thg 06_Thg 07_Thg 08_Thg 09_Thg 10_Thg 11_Thg 12'.split(
	            '_'
	        ),
	    monthsParseExact: true,
	    weekdays: 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split(
	        '_'
	    ),
	    weekdaysShort: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	    weekdaysMin: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	    weekdaysParseExact: true,
	    meridiemParse: /sa|ch/i,
	    isPM: function (input) {
	        return /^ch$/i.test(input);
	    },
	    meridiem: function (hours, minutes, isLower) {
	        if (hours < 12) {
	            return isLower ? 'sa' : 'SA';
	        } else {
	            return isLower ? 'ch' : 'CH';
	        }
	    },
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM [năm] YYYY',
	        LLL: 'D MMMM [năm] YYYY HH:mm',
	        LLLL: 'dddd, D MMMM [năm] YYYY HH:mm',
	        l: 'DD/M/YYYY',
	        ll: 'D MMM YYYY',
	        lll: 'D MMM YYYY HH:mm',
	        llll: 'ddd, D MMM YYYY HH:mm',
	    },
	    calendar: {
	        sameDay: '[Hôm nay lúc] LT',
	        nextDay: '[Ngày mai lúc] LT',
	        nextWeek: 'dddd [tuần tới lúc] LT',
	        lastDay: '[Hôm qua lúc] LT',
	        lastWeek: 'dddd [tuần trước lúc] LT',
	        sameElse: 'L',
	    },
	    relativeTime: {
	        future: '%s tới',
	        past: '%s trước',
	        s: 'vài giây',
	        ss: '%d giây',
	        m: 'một phút',
	        mm: '%d phút',
	        h: 'một giờ',
	        hh: '%d giờ',
	        d: 'một ngày',
	        dd: '%d ngày',
	        w: 'một tuần',
	        ww: '%d tuần',
	        M: 'một tháng',
	        MM: '%d tháng',
	        y: 'một năm',
	        yy: '%d năm',
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}/,
	    ordinal: function (number) {
	        return number;
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4, // The week that contains Jan 4th is the first week of the year.
	    },
	});

	//! moment.js locale configuration

	hooks$2.defineLocale('x-pseudo', {
	    months: 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split(
	        '_'
	    ),
	    monthsShort:
	        'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split(
	            '_'
	        ),
	    monthsParseExact: true,
	    weekdays:
	        'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split(
	            '_'
	        ),
	    weekdaysShort: 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
	    weekdaysMin: 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
	    weekdaysParseExact: true,
	    longDateFormat: {
	        LT: 'HH:mm',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd, D MMMM YYYY HH:mm',
	    },
	    calendar: {
	        sameDay: '[T~ódá~ý át] LT',
	        nextDay: '[T~ómó~rró~w át] LT',
	        nextWeek: 'dddd [át] LT',
	        lastDay: '[Ý~ést~érdá~ý át] LT',
	        lastWeek: '[L~ást] dddd [át] LT',
	        sameElse: 'L',
	    },
	    relativeTime: {
	        future: 'í~ñ %s',
	        past: '%s á~gó',
	        s: 'á ~féw ~sécó~ñds',
	        ss: '%d s~écóñ~ds',
	        m: 'á ~míñ~úté',
	        mm: '%d m~íñú~tés',
	        h: 'á~ñ hó~úr',
	        hh: '%d h~óúrs',
	        d: 'á ~dáý',
	        dd: '%d d~áýs',
	        M: 'á ~móñ~th',
	        MM: '%d m~óñt~hs',
	        y: 'á ~ýéár',
	        yy: '%d ý~éárs',
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	    ordinal: function (number) {
	        var b = number % 10,
	            output =
	                ~~((number % 100) / 10) === 1
	                    ? 'th'
	                    : b === 1
	                    ? 'st'
	                    : b === 2
	                    ? 'nd'
	                    : b === 3
	                    ? 'rd'
	                    : 'th';
	        return number + output;
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4, // The week that contains Jan 4th is the first week of the year.
	    },
	});

	//! moment.js locale configuration

	hooks$2.defineLocale('yo', {
	    months: 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split(
	        '_'
	    ),
	    monthsShort: 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
	    weekdays: 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
	    weekdaysShort: 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
	    weekdaysMin: 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
	    longDateFormat: {
	        LT: 'h:mm A',
	        LTS: 'h:mm:ss A',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY h:mm A',
	        LLLL: 'dddd, D MMMM YYYY h:mm A',
	    },
	    calendar: {
	        sameDay: '[Ònì ni] LT',
	        nextDay: '[Ọ̀la ni] LT',
	        nextWeek: "dddd [Ọsẹ̀ tón'bọ] [ni] LT",
	        lastDay: '[Àna ni] LT',
	        lastWeek: 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
	        sameElse: 'L',
	    },
	    relativeTime: {
	        future: 'ní %s',
	        past: '%s kọjá',
	        s: 'ìsẹjú aayá die',
	        ss: 'aayá %d',
	        m: 'ìsẹjú kan',
	        mm: 'ìsẹjú %d',
	        h: 'wákati kan',
	        hh: 'wákati %d',
	        d: 'ọjọ́ kan',
	        dd: 'ọjọ́ %d',
	        M: 'osù kan',
	        MM: 'osù %d',
	        y: 'ọdún kan',
	        yy: 'ọdún %d',
	    },
	    dayOfMonthOrdinalParse: /ọjọ́\s\d{1,2}/,
	    ordinal: 'ọjọ́ %d',
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4, // The week that contains Jan 4th is the first week of the year.
	    },
	});

	//! moment.js locale configuration

	hooks$2.defineLocale('zh-cn', {
	    months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
	        '_'
	    ),
	    monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	        '_'
	    ),
	    weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	    weekdaysShort: '周日_周一_周二_周三_周四_周五_周六'.split('_'),
	    weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'YYYY/MM/DD',
	        LL: 'YYYY年M月D日',
	        LLL: 'YYYY年M月D日Ah点mm分',
	        LLLL: 'YYYY年M月D日ddddAh点mm分',
	        l: 'YYYY/M/D',
	        ll: 'YYYY年M月D日',
	        lll: 'YYYY年M月D日 HH:mm',
	        llll: 'YYYY年M月D日dddd HH:mm',
	    },
	    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	    meridiemHour: function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	            return hour;
	        } else if (meridiem === '下午' || meridiem === '晚上') {
	            return hour + 12;
	        } else {
	            // '中午'
	            return hour >= 11 ? hour : hour + 12;
	        }
	    },
	    meridiem: function (hour, minute, isLower) {
	        var hm = hour * 100 + minute;
	        if (hm < 600) {
	            return '凌晨';
	        } else if (hm < 900) {
	            return '早上';
	        } else if (hm < 1130) {
	            return '上午';
	        } else if (hm < 1230) {
	            return '中午';
	        } else if (hm < 1800) {
	            return '下午';
	        } else {
	            return '晚上';
	        }
	    },
	    calendar: {
	        sameDay: '[今天]LT',
	        nextDay: '[明天]LT',
	        nextWeek: function (now) {
	            if (now.week() !== this.week()) {
	                return '[下]dddLT';
	            } else {
	                return '[本]dddLT';
	            }
	        },
	        lastDay: '[昨天]LT',
	        lastWeek: function (now) {
	            if (this.week() !== now.week()) {
	                return '[上]dddLT';
	            } else {
	                return '[本]dddLT';
	            }
	        },
	        sameElse: 'L',
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'd':
	            case 'D':
	            case 'DDD':
	                return number + '日';
	            case 'M':
	                return number + '月';
	            case 'w':
	            case 'W':
	                return number + '周';
	            default:
	                return number;
	        }
	    },
	    relativeTime: {
	        future: '%s后',
	        past: '%s前',
	        s: '几秒',
	        ss: '%d 秒',
	        m: '1 分钟',
	        mm: '%d 分钟',
	        h: '1 小时',
	        hh: '%d 小时',
	        d: '1 天',
	        dd: '%d 天',
	        w: '1 周',
	        ww: '%d 周',
	        M: '1 个月',
	        MM: '%d 个月',
	        y: '1 年',
	        yy: '%d 年',
	    },
	    week: {
	        // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	        dow: 1, // Monday is the first day of the week.
	        doy: 4, // The week that contains Jan 4th is the first week of the year.
	    },
	});

	//! moment.js locale configuration

	hooks$2.defineLocale('zh-hk', {
	    months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
	        '_'
	    ),
	    monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	        '_'
	    ),
	    weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	    weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	    weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'YYYY/MM/DD',
	        LL: 'YYYY年M月D日',
	        LLL: 'YYYY年M月D日 HH:mm',
	        LLLL: 'YYYY年M月D日dddd HH:mm',
	        l: 'YYYY/M/D',
	        ll: 'YYYY年M月D日',
	        lll: 'YYYY年M月D日 HH:mm',
	        llll: 'YYYY年M月D日dddd HH:mm',
	    },
	    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	    meridiemHour: function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	            return hour;
	        } else if (meridiem === '中午') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === '下午' || meridiem === '晚上') {
	            return hour + 12;
	        }
	    },
	    meridiem: function (hour, minute, isLower) {
	        var hm = hour * 100 + minute;
	        if (hm < 600) {
	            return '凌晨';
	        } else if (hm < 900) {
	            return '早上';
	        } else if (hm < 1200) {
	            return '上午';
	        } else if (hm === 1200) {
	            return '中午';
	        } else if (hm < 1800) {
	            return '下午';
	        } else {
	            return '晚上';
	        }
	    },
	    calendar: {
	        sameDay: '[今天]LT',
	        nextDay: '[明天]LT',
	        nextWeek: '[下]ddddLT',
	        lastDay: '[昨天]LT',
	        lastWeek: '[上]ddddLT',
	        sameElse: 'L',
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'd':
	            case 'D':
	            case 'DDD':
	                return number + '日';
	            case 'M':
	                return number + '月';
	            case 'w':
	            case 'W':
	                return number + '週';
	            default:
	                return number;
	        }
	    },
	    relativeTime: {
	        future: '%s後',
	        past: '%s前',
	        s: '幾秒',
	        ss: '%d 秒',
	        m: '1 分鐘',
	        mm: '%d 分鐘',
	        h: '1 小時',
	        hh: '%d 小時',
	        d: '1 天',
	        dd: '%d 天',
	        M: '1 個月',
	        MM: '%d 個月',
	        y: '1 年',
	        yy: '%d 年',
	    },
	});

	//! moment.js locale configuration

	hooks$2.defineLocale('zh-tw', {
	    months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
	        '_'
	    ),
	    monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	        '_'
	    ),
	    weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	    weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	    weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'YYYY/MM/DD',
	        LL: 'YYYY年M月D日',
	        LLL: 'YYYY年M月D日 HH:mm',
	        LLLL: 'YYYY年M月D日dddd HH:mm',
	        l: 'YYYY/M/D',
	        ll: 'YYYY年M月D日',
	        lll: 'YYYY年M月D日 HH:mm',
	        llll: 'YYYY年M月D日dddd HH:mm',
	    },
	    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	    meridiemHour: function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	            return hour;
	        } else if (meridiem === '中午') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === '下午' || meridiem === '晚上') {
	            return hour + 12;
	        }
	    },
	    meridiem: function (hour, minute, isLower) {
	        var hm = hour * 100 + minute;
	        if (hm < 600) {
	            return '凌晨';
	        } else if (hm < 900) {
	            return '早上';
	        } else if (hm < 1130) {
	            return '上午';
	        } else if (hm < 1230) {
	            return '中午';
	        } else if (hm < 1800) {
	            return '下午';
	        } else {
	            return '晚上';
	        }
	    },
	    calendar: {
	        sameDay: '[今天] LT',
	        nextDay: '[明天] LT',
	        nextWeek: '[下]dddd LT',
	        lastDay: '[昨天] LT',
	        lastWeek: '[上]dddd LT',
	        sameElse: 'L',
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'd':
	            case 'D':
	            case 'DDD':
	                return number + '日';
	            case 'M':
	                return number + '月';
	            case 'w':
	            case 'W':
	                return number + '週';
	            default:
	                return number;
	        }
	    },
	    relativeTime: {
	        future: '%s後',
	        past: '%s前',
	        s: '幾秒',
	        ss: '%d 秒',
	        m: '1 分鐘',
	        mm: '%d 分鐘',
	        h: '1 小時',
	        hh: '%d 小時',
	        d: '1 天',
	        dd: '%d 天',
	        M: '1 個月',
	        MM: '%d 個月',
	        y: '1 年',
	        yy: '%d 年',
	    },
	});

	// Moment Language
	var language = window.navigator.languages
	  ? window.navigator.languages[0]
	  : (window.navigator.language || window.navigator.userLanguage);
	hooks$1.locale(language);

	function Datefy (value, format) {
	    if ( format === void 0 ) format = null;

	    if(format)
	    {
	        return hooks$1(Utils$1.getMilisecondsFromDate(value)).format(format);
	    }
	    else
	    {
	        return hooks$1(Utils$1.getMilisecondsFromDate(value)).calendar();
	    }
	}

	function Urlify (value) {
	  return (Utils$1.isUndefined(value) ? '' : encodeURIComponent(value));
	}

	//

	var script$d = {
	  props: {
	    items: Array,
	    itemHeight: {
	      type: Number,
	      default: 78,
	    },
	    photoAvatar: Boolean,
	  },
	  data: function data() {
	    var route = this.route;
	    var loggedInUser = this.$root.loggedInUser;
	    if (!route) { route = this.$f7route; }
	    return {
	      noTouch: !Utils$1.mobileDevice(),
	      vlItems: {},
	      route: route,
	      loggedInUser: loggedInUser,
	      isBigScreen: Brief$1.isBigScreen,
	    };
	  },
	  computed: {
	    photoAvatarSize: function photoAvatarSize() {
	      return this.$theme.ios ? 44 : 40;
	    },
	  },
	  watch: {
	    items: function items() {
	      var self = this;
	      if (self.vl) {
	        self.vl.replaceAllItems(self.items);
	      }
	    },
	  },
	  beforeDestroy: function beforeDestroy() {
	    var self = this;
	    if (self.vl && self.vl.destroy) {
	      self.vl.destroy();
	    }
	  },
	  methods: {
	    conversationInitial: function conversationInitial(item) {
	      var title = item.isOurMessage ? item.to : item.from;
	      return title && title.length ? title[0].toUpperCase() : 'C';
	    },
	    itemText: function itemText(item) {
	      var text = '';
	      if (item.text) {
	        text = item.text
	          .replace(/<br\s*[/]?>/gi, ' ')
	          .replace(/</gi, '')
	          .replace(/>/gi, '');
	      }
	      if (!text && ((item.files && item.files.length > 0) || item.hasFiles)) {
	        text = 'Attachment';
	      }
	      if (text.length > 150) {
	        text = (text.substr(0, 150)) + "...";
	      }
	      return text;
	    },
	    url: function url(item) {
	      var self = this;
	      return ("/message/list/" + (item.type) + "/" + (item.channelId) + "/" + (self.urlify(item.conversationId)));
	    },
	    getStatus: function getStatus(m) {
	      if (m.isHandled && m.isOurMessage) { return 'ourmessage'; }
	      if (m.isHandled) { return ''; }
	      if (m.isReadByMe === false || (m.hasRead && !m.hasRead.includes(this.loggedInUser.id))) { return 'unread'; }
	      // if (m.markedAsDone) return '';
	      // if (m.markedAsNotDone) return 'needsreply';
	      // if (m.isOurMessage) return 'ourmessage';
	      // if (m.isAnsweredByUs) return '';
	      // if (m.readByEveryone) return '';
	      return 'needsreply';
	    },
	    shouldShowHandledButton: function shouldShowHandledButton(m) {
	      return !m.isHandled;
	    },
	    urlify: function urlify(value) {
	      return Urlify(value);
	    },
	    datefy: function datefy(date) {
	      return Datefy(date);
	    },
	    markAsHandled: function markAsHandled(item) {
	      this.$emit('markAsHandled', item);
	    },
	    markAsWaiting: function markAsWaiting(item) {
	      this.$emit('markAsWaiting', item);
	    },
	    onClick: function onClick(item) {
	      this.$emit('click', item);
	    },
	    onImageError: function onImageError(item) {
	      this.$set(item, 'photoUrl', this.path.imageUrl('avatar.png'));
	    },
	    onF7Ready: function onF7Ready() {
	      var self = this;
	      self.vl = Brief$1.f7.virtualList.create({
	        el: self.$el,
	        items: self.items,
	        height: self.itemHeight,
	        cache: false,
	        renderExternal: function renderExternal(vl, data) {
	          self.vlItems = data;
	        },
	      });
	    },
	  },
	};

	/* script */
	var __vue_script__$d = script$d;

	/* template */
	var __vue_render__$b = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f7-list',{staticClass:"conversation-list",attrs:{"media-list":""}},[_c('ul',{style:('height:' + (_vm.vlItems.listHeight || 0) + 'px')},_vm._l((_vm.vlItems.items),function(item){return _c('li',{key:item.id,staticClass:"swipeout",class:{'swipeout-desktop': _vm.noTouch},style:('top:' + (_vm.vlItems.topPosition || 0) + 'px')},[_c('div',{staticClass:"swipeout-content"},[_c('a',{staticClass:"item-link",attrs:{"href":_vm.url(item),"data-view":".view-main","data-reload-all":_vm.isBigScreen},on:{"click":function($event){return _vm.onClick(item)}}},[_c('div',{staticClass:"item-content"},[_c('div',{staticClass:"item-media"},[(!_vm.photoAvatar && !item.photoUrl)?_c('span',{staticClass:"common-avatar"},[_vm._v(_vm._s(_vm.conversationInitial(item)))]):_c('img',{staticClass:"conversation-list-avatar",attrs:{"width":_vm.photoAvatarSize,"height":_vm.photoAvatarSize,"src":item.photoUrl || _vm.path.imageUrl('avatar.png')},on:{"error":function($event){return _vm.onImageError(item)}}}),_vm._v(" "),_c('div',{class:'item-status ' + _vm.getStatus(item)})]),_vm._v(" "),_c('div',{staticClass:"item-inner"},[_c('div',{staticClass:"item-title-row"},[_c('div',{staticClass:"item-title"},[_vm._v("\n                  "+_vm._s(item.isOurMessage ? item.to : item.from)+"\n                ")]),_vm._v(" "),_c('div',{staticClass:"item-after"},[_c('span',[_vm._v(_vm._s(_vm.datefy(item.sendDate)))])])]),_vm._v(" "),(item.subject)?_c('div',{staticClass:"item-subtitle"},[_vm._v(_vm._s(item.subject))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"item-text"},[(item.isOurMessage)?_c('span',{staticStyle:{"color":"black"}},[_vm._v(_vm._s(item.from)+": ")]):_vm._e(),_vm._v(_vm._s(_vm.itemText(item)))])])])])]),_vm._v(" "),_c('div',{staticClass:"swipeout-actions-right"},[_c('a',{staticClass:"swipeout-close mark-as-done",style:('display: ' + (_vm.shouldShowHandledButton(item) ? '' : 'none')),attrs:{"href":"#"},on:{"click":function($event){return _vm.markAsHandled(item)}}},[_c('f7-icon',{attrs:{"if-ios":"f7:check","if-md":"material:check"}}),_vm._v(" "),_c('span',[_vm._v("Handled")])],1),_vm._v(" "),_c('a',{staticClass:"swipeout-close mark-as-not-done",style:('display: ' + (!_vm.shouldShowHandledButton(item) ? '' : 'none')),attrs:{"href":"#"},on:{"click":function($event){return _vm.markAsWaiting(item)}}},[_c('f7-icon',{attrs:{"if-ios":"f7:time","if-md":"material:access_time"}}),_vm._v(" "),_c('span',[_vm._v("Waiting")])],1)])])}),0)])};
	var __vue_staticRenderFns__$b = [];

	  /* style */
	  var __vue_inject_styles__$d = undefined;
	  /* scoped */
	  var __vue_scope_id__$d = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$d = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$d = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$d = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$b, staticRenderFns: __vue_staticRenderFns__$b },
	    __vue_inject_styles__$d,
	    __vue_script__$d,
	    __vue_scope_id__$d,
	    __vue_is_functional_template__$d,
	    __vue_module_identifier__$d,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//
	//
	//
	//
	//
	//

	var script$e = {
	  props: ['text', 'subtext'],
	};

	/* script */
	var __vue_script__$e = script$e;

	/* template */
	var __vue_render__$c = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"common-empty-message"},[_vm._v(_vm._s(_vm.text || 'Very empty here'))]),_vm._v(" "),(_vm.subtext)?_c('div',{staticClass:"common-empty-message",staticStyle:{"top":"55%"}},[_vm._v(_vm._s(_vm.subtext))]):_vm._e()])};
	var __vue_staticRenderFns__$c = [];

	  /* style */
	  var __vue_inject_styles__$e = undefined;
	  /* scoped */
	  var __vue_scope_id__$e = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$e = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$e = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$e = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$c, staticRenderFns: __vue_staticRenderFns__$c },
	    __vue_inject_styles__$e,
	    __vue_script__$e,
	    __vue_scope_id__$e,
	    __vue_is_functional_template__$e,
	    __vue_module_identifier__$e,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//
	//
	//
	//
	//
	//

	var script$f = {
	  props: {
	    store: Object,
	  },
	  computed: {
	    classes: function classes() {
	      var self = this;
	      return {
	        online: self.$root.onLine,
	        offline: !self.$root.onLine,
	      };
	    },
	  },
	  watch: {
	    '$root.onLine': function onOnline(onLine, wasOnLine) {
	      var self = this;
	      if (onLine && !wasOnLine) {
	        // Became online
	        if (self.store && self.store.reload) { self.store.reload(); }
	      }
	    },
	  },
	};

	/* script */
	var __vue_script__$f = script$f;

	/* template */
	var __vue_render__$d = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"common-offline-indicator",class:_vm.classes},[(_vm.$root.onLine)?_c('span',[_vm._v("Connected")]):_c('span',[_vm._v("Offline")])])};
	var __vue_staticRenderFns__$d = [];

	  /* style */
	  var __vue_inject_styles__$f = undefined;
	  /* scoped */
	  var __vue_scope_id__$f = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$f = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$f = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$f = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$d, staticRenderFns: __vue_staticRenderFns__$d },
	    __vue_inject_styles__$f,
	    __vue_script__$f,
	    __vue_scope_id__$f,
	    __vue_is_functional_template__$f,
	    __vue_module_identifier__$f,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//

	var script$g = {
	  props: {
	    data: [Object, Boolean],
	  },
	  data: function data() {
	    return {
	      target: Brief$1.isCordova ? '_system' : '_blank',
	    };
	  },
	  computed: {
	    usePlaceholder: function usePlaceholder() {
	      return this.data === true;
	    },
	  },
	};

	/* script */
	var __vue_script__$g = script$g;

	/* template */
	var __vue_render__$e = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"url-preview external",class:{'url-preview-requested': _vm.usePlaceholder},attrs:{"target":_vm.target,"href":_vm.usePlaceholder ? '' : _vm.data.url}},[_c('span',{staticClass:"url-preview-title"},[_vm._v(_vm._s(_vm.usePlaceholder ? '' : _vm.data.title)),(_vm.usePlaceholder)?_c('span'):_vm._e()]),_vm._v(" "),_c('span',{staticClass:"url-preview-description"},[_vm._v(_vm._s(_vm.usePlaceholder ? '' : _vm.data.description)),_vm._l((3),function(n){return (_vm.usePlaceholder)?_c('span',{key:n}):_vm._e()})],2),_vm._v(" "),_c('span',{staticClass:"url-preview-image"},[(_vm.data && _vm.data.image)?_c('img',{attrs:{"src":_vm.data.image}}):_vm._e()])])};
	var __vue_staticRenderFns__$e = [];

	  /* style */
	  var __vue_inject_styles__$g = undefined;
	  /* scoped */
	  var __vue_scope_id__$g = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$g = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$g = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$g = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$e, staticRenderFns: __vue_staticRenderFns__$e },
	    __vue_inject_styles__$g,
	    __vue_script__$g,
	    __vue_scope_id__$g,
	    __vue_is_functional_template__$g,
	    __vue_module_identifier__$g,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//

	var script$h = {
	  props: {
	    message: Object,
	  },
	  data: function data() {
	    return {
	      subjectString: '',
	      img: null,
	      loading: true,
	      data: null,
	      text: ''
	    };
	  },
	  mounted: function mounted() {
	    var self = this;
	    Brief$1.f7.request({
	      url: ((Brief$1.api) + "/emailmessage/original"),
	      method: 'GET',
	      dataType: 'json',
	      data: {
	        id: self.message.id,
	        access_token: window.localStorage.getItem('access_token'),
	        device_id: window.localStorage.getItem('device_id'),
	      },
	      success: function success(response) {
	        self.loading = false;
	        var emailMessage = response.data;
	        self.data = response.data;
	        self.subjectString = emailMessage.subject;
	        function checkImage(images, src) {
	          var image = new window.Image();
	          image.onload = function onImageLoad() {
	            if (image.width === 1 || image.height === 1) {
	              var nextImage = images[images.indexOf(src) + 1];
	              if (nextImage) { checkImage(images, nextImage); }
	            } else {
	              self.img = src;
	            }
	          };
	          image.src = src;
	        }
	        if (emailMessage.html && emailMessage.html.length) {
	          self.iframe = document.createElement('iframe');
	          document.body.appendChild(self.iframe);
	          var body = self.iframe.contentDocument.body;
	          body.innerHTML = emailMessage.html;

	          var $body = $$1(body);
	          var text = $body.children('table').eq(0).text();
	          if (!text || !text.length) { text = $$1(body).text(); }
	          var $images = $body.find('img');
	          var images = [];
	          $images.each(function (index, img) {
	            images.push($$1(img).attr('src'));
	          });
	          self.text = self.message.textRaw || text;
	          checkImage(images, images[0]);

	          body.innerHTML = '';
	          document.body.removeChild(self.iframe);
	          self.iframe = null;
	        }
	      },
	      error: function error() {
	        self.loading = false;
	      },
	    });
	  },
	  methods: {
	    onClick: function onClick() {
	      var self = this;
	      self.$emit('click', self.data);
	    },
	  },
	};

	/* script */
	var __vue_script__$h = script$h;

	/* template */
	var __vue_render__$f = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"email-preview",on:{"click":_vm.onClick}},[_c('div',{staticClass:"email-preview-title"},[_vm._v(_vm._s(_vm.subjectString))]),_vm._v(" "),(_vm.text)?_c('div',{staticClass:"email-preview-text"},[_vm._v(_vm._s(_vm.text))]):_vm._e(),_vm._v(" "),(_vm.loading || _vm.img)?_c('div',{staticClass:"email-preview-image"},[(!_vm.loading && _vm.img)?_c('img',{attrs:{"src":_vm.img}}):_vm._e(),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"preloader-wrap"},[_c('f7-preloader')],1):_vm._e()]):_vm._e()])};
	var __vue_staticRenderFns__$f = [];

	  /* style */
	  var __vue_inject_styles__$h = undefined;
	  /* scoped */
	  var __vue_scope_id__$h = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$h = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$h = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$h = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$f, staticRenderFns: __vue_staticRenderFns__$f },
	    __vue_inject_styles__$h,
	    __vue_script__$h,
	    __vue_scope_id__$h,
	    __vue_is_functional_template__$h,
	    __vue_module_identifier__$h,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//

	var script$i = {
	  props: {
	    hasSubscription: Boolean,
	    billingPeriod: String,
	    currentPriceId: String,
	    plan: {
	      name: String,
	      prices: [{
	        id: String,
	        monthlyPrice: Number,
	        billingPeriod: String,
	        sentMessagesIncluded: Number,
	      }],
	    },
	  },
	  data: function data() {
	    var accessToken = window.localStorage.getItem('access_token');
	    var deviceId = window.localStorage.getItem('device_id');
	    var menuId = "menu-" + (this.plan.name);
	    var selectedPriceId = this.currentPriceId;

	    return {
	      accessToken: accessToken,
	      deviceId: deviceId,
	      menuId: menuId,
	      selectedPriceId: selectedPriceId
	    };
	  },
	  watch: {
	    currentPriceId: function currentPriceId(newPriceId) {
	      this.selectedPriceId = newPriceId;
	    }
	  },
	  computed: {
	    isCurrent: function isCurrent() {
	      var self = this;
	      return self.pricesForPeriod.some(function (p) { return p.id === self.currentPriceId; });
	    },
	    currentBorder: function currentBorder() {
	      return this.isCurrent ? '2px solid #7113ff' : 'none';
	    },
	    hasChanged: function hasChanged() {
	      return this.currentPriceId !== this.selectedPriceId;
	    },
	    selectedPrice: function selectedPrice() {
	      var self = this;
	      var selectedPrice = self.plan.prices.find(function (p) { return p.id === self.selectedPriceId; });
	      if (selectedPrice === undefined)
	        { return self.pricesForPeriod[0]; }

	      var existsInPeriod = self.pricesForPeriod.some(function (p) { return p.id === selectedPrice.id; });
	      if (existsInPeriod)
	        { return selectedPrice; }

	      return self.pricesForPeriod.find(function (p) { return p.sentMessagesIncluded === selectedPrice.sentMessagesIncluded; });
	    },
	    monthlyPrice: function monthlyPrice() {
	      var self = this;
	      return self.plan.prices.find(function (p) { return p.sentMessagesIncluded === self.selectedPrice.sentMessagesIncluded && p.billingPeriod === 'Monthly'; });
	    },
	    isFreePrice: function isFreePrice() {
	      return this.selectedPrice.monthlyPrice === 0;
	    },
	    pricesForPeriod: function pricesForPeriod() {
	      var self = this;
	      return this.plan.prices
	        .filter(function (p) { return p.monthlyPrice === 0 || p.billingPeriod === self.billingPeriod; })
	        .sort(function (a, b) { return a.monthlyPrice - b.monthlyPrice; });
	    }
	  },
	  methods: {
	    changePlan: function changePlan() {
	      Brief$1.events.$emit('change-plan', this.selectedPrice.id);
	    },
	    selectPrice: function selectPrice(priceId) {
	      this.selectedPriceId = priceId;
	    },
	    showRedirectProgress: function showRedirectProgress() {
	      Brief$1.showPreloader('Redirecting to payment provider');
	    },
	  }
	};

	/* script */
	var __vue_script__$i = script$i;

	/* template */
	var __vue_render__$g = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f7-block',{staticStyle:{"display":"flex","flex-direction":"column","gap":"28px","justify-content":"space-between","min-width":"275px","flex":"1","margin":"0"},style:({ border: _vm.currentBorder }),attrs:{"strong":"","inset":""}},[_c('div',[_c('div',{staticStyle:{"display":"flex","flex-direction":"column","gap":"16px","justify-content":"space-between","align-items":"center"}},[_c('span',{staticStyle:{"font-size":"26px","font-weight":"bold"}},[_vm._v(_vm._s(_vm.plan.name))]),_vm._v(" "),(_vm.isFreePrice)?_c('span',{staticStyle:{"font-size":"16px","font-weight":"bold"}},[_vm._v("Free")]):_c('span',{staticStyle:{"font-size":"16px","font-weight":"bold"}},[_vm._v("\n        $"+_vm._s(_vm.selectedPrice.monthlyPrice)+" "),_c('span',{staticStyle:{"color":"gray","font-weight":"normal"}},[_vm._v("/month "),(_vm.monthlyPrice && _vm.billingPeriod === 'Yearly')?_c('span',{staticStyle:{"text-decoration":"line-through"}},[_vm._v("($"+_vm._s(_vm.monthlyPrice.monthlyPrice)+")")]):_vm._e()])]),_vm._v(" "),_c('div',{staticStyle:{"color":"gray"}},[_vm._v("Including "),_c('f7-button',{staticStyle:{"display":"inline","font-size":"16px","font-weight":"bold","padding-right":"16px","position":"relative"},attrs:{"small":"","round":"","popover-open":("." + _vm.menuId)}},[_vm._v(_vm._s(_vm.selectedPrice.sentMessagesIncluded)),_c('span',{staticStyle:{"position":"absolute","top":"-8px"}},[_vm._v("⌄")])]),_vm._v(" sent messages/month")],1)])]),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","flex-direction":"column","gap":"5px"}},[_c('div',[_vm._v("- "),_c('b',[_vm._v("Unlimited")]),_vm._v(" Website Chat Widget Channels")]),_vm._v(" "),_c('div',[_vm._v("- "),_c('b',[_vm._v("Unlimited")]),_vm._v(" Instagram DM Channels")]),_vm._v(" "),_c('div',[_vm._v("- "),_c('b',[_vm._v("Unlimited")]),_vm._v(" Facebook DM Channels")]),_vm._v(" "),_c('div',[_vm._v("- "),_c('b',[_vm._v("Unlimited")]),_vm._v(" Email Chat Channels")])]),_vm._v(" "),_c('div',[(_vm.isCurrent && !_vm.hasChanged)?_c('f7-button',{attrs:{"big":"","outline":"","href":"#","disabled":""}},[_vm._v("Current plan")]):(_vm.hasSubscription)?_c('f7-button',{attrs:{"big":"","fill":""},on:{"click":_vm.changePlan}},[_vm._v("Select plan")]):_c('f7-button',{attrs:{"big":"","fill":"","href":("/api/stripe/checkout?access_token=" + _vm.accessToken + "&device_id&" + _vm.deviceId + "&selectedPriceId=" + (_vm.selectedPrice.id)),"external":""},on:{"click":_vm.showRedirectProgress}},[_vm._v("Select plan")])],1),_vm._v(" "),_c('f7-popover',{class:_vm.menuId},[_c('f7-list',_vm._l((_vm.pricesForPeriod),function(price){return _c('f7-list-item',{key:price.id,attrs:{"popover-close":"","link":"#","title":((price.sentMessagesIncluded) + " sent messages/month")},on:{"click":function($event){return _vm.selectPrice(price.id)}}})}),1)],1)],1)};
	var __vue_staticRenderFns__$g = [];

	  /* style */
	  var __vue_inject_styles__$i = undefined;
	  /* scoped */
	  var __vue_scope_id__$i = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$i = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$i = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$i = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$g, staticRenderFns: __vue_staticRenderFns__$g },
	    __vue_inject_styles__$i,
	    __vue_script__$i,
	    __vue_scope_id__$i,
	    __vue_is_functional_template__$i,
	    __vue_module_identifier__$i,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//
	//
	//
	//
	//
	//

	var script$j = {
	  props: {
	    checked: Boolean,
	  },
	};

	/* script */
	var __vue_script__$j = script$j;

	/* template */
	var __vue_render__$h = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"checkmark",class:{ animate: _vm.checked },attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 52 52"}},[_c('circle',{staticClass:"circle",attrs:{"cx":"26","cy":"26","r":"25","fill":"none"}}),_vm._v(" "),_c('path',{staticClass:"check",attrs:{"fill":"none","d":"M14.1 27.2l7.1 7.2 16.7-16.8"}})])};
	var __vue_staticRenderFns__$h = [];

	  /* style */
	  var __vue_inject_styles__$j = undefined;
	  /* scoped */
	  var __vue_scope_id__$j = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$j = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$j = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$j = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$h, staticRenderFns: __vue_staticRenderFns__$h },
	    __vue_inject_styles__$j,
	    __vue_script__$j,
	    __vue_scope_id__$j,
	    __vue_is_functional_template__$j,
	    __vue_module_identifier__$j,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//
	//
	//
	//
	//
	//

	var script$k = {
	};

	/* script */
	var __vue_script__$k = script$k;

	/* template */
	var __vue_render__$i = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"2 2 20 20","fill":"#ff9500"}},[_c('path',{attrs:{"d":"M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"}})])};
	var __vue_staticRenderFns__$i = [];

	  /* style */
	  var __vue_inject_styles__$k = undefined;
	  /* scoped */
	  var __vue_scope_id__$k = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$k = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$k = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$k = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$i, staticRenderFns: __vue_staticRenderFns__$i },
	    __vue_inject_styles__$k,
	    __vue_script__$k,
	    __vue_scope_id__$k,
	    __vue_is_functional_template__$k,
	    __vue_module_identifier__$k,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//
	//
	//

	var script$l = {
	  props: {
	    load: Boolean,
	  },
	};

	/* script */
	var __vue_script__$l = script$l;

	/* template */
	var __vue_render__$j = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"loader",class:{ animate: _vm.load }})};
	var __vue_staticRenderFns__$j = [];

	  /* style */
	  var __vue_inject_styles__$l = undefined;
	  /* scoped */
	  var __vue_scope_id__$l = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$l = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$l = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$l = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$j, staticRenderFns: __vue_staticRenderFns__$j },
	    __vue_inject_styles__$l,
	    __vue_script__$l,
	    __vue_scope_id__$l,
	    __vue_is_functional_template__$l,
	    __vue_module_identifier__$l,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//

	var script$m = {
	  data: function data() {
	    var store = new Store(this, {
	      get: ['team', 'dashboard'],
	    });
	    store.get();

	    return {
	      store: store,
	    };
	  },
	  mounted: function mounted() {
	  },
	};

	/* script */
	var __vue_script__$m = script$m;

	/* template */
	var __vue_render__$k = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('f7-block-title',[_vm._v("Current billing period ("+_vm._s(_vm.store.startDate)+" to "+_vm._s(_vm.store.endDate)+")")]),_vm._v(" "),_c('f7-list',[_c('f7-list-item',{attrs:{"title":"Customer messages sent"}},[_vm._v("\n      "+_vm._s(_vm.store.numberOfCustomerMessages || 0)+"\n    ")]),_vm._v(" "),_c('f7-list-item',{attrs:{"title":"Team messages sent"}},[_vm._v("\n      "+_vm._s(_vm.store.numberOfTeamMessages || 0)+"\n    ")]),_vm._v(" "),_c('f7-list-item',{attrs:{"title":"Total messages sent"}},[_vm._v("\n      "+_vm._s(_vm.store.numberOfTeamMessages + _vm.store.numberOfCustomerMessages || 0)+" of "+_vm._s(_vm.store.planMessages || '...')+"\n    ")])],1)],1)};
	var __vue_staticRenderFns__$k = [];

	  /* style */
	  var __vue_inject_styles__$m = undefined;
	  /* scoped */
	  var __vue_scope_id__$m = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$m = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$m = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$m = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$k, staticRenderFns: __vue_staticRenderFns__$k },
	    __vue_inject_styles__$m,
	    __vue_script__$m,
	    __vue_scope_id__$m,
	    __vue_is_functional_template__$m,
	    __vue_module_identifier__$m,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	/**
	 * @namespace Chart.helpers
	 */
	var helpers = {
		/**
		 * An empty function that can be used, for example, for optional callback.
		 */
		noop: function() {},

		/**
		 * Returns a unique id, sequentially generated from a global variable.
		 * @returns {Number}
		 * @function
		 */
		uid: (function() {
			var id = 0;
			return function() {
				return id++;
			};
		}()),

		/**
		 * Returns true if `value` is neither null nor undefined, else returns false.
		 * @param {*} value - The value to test.
		 * @returns {Boolean}
		 * @since 2.7.0
		 */
		isNullOrUndef: function(value) {
			return value === null || typeof value === 'undefined';
		},

		/**
		 * Returns true if `value` is an array, else returns false.
		 * @param {*} value - The value to test.
		 * @returns {Boolean}
		 * @function
		 */
		isArray: Array.isArray ? Array.isArray : function(value) {
			return Object.prototype.toString.call(value) === '[object Array]';
		},

		/**
		 * Returns true if `value` is an object (excluding null), else returns false.
		 * @param {*} value - The value to test.
		 * @returns {Boolean}
		 * @since 2.7.0
		 */
		isObject: function(value) {
			return value !== null && Object.prototype.toString.call(value) === '[object Object]';
		},

		/**
		 * Returns `value` if defined, else returns `defaultValue`.
		 * @param {*} value - The value to return if defined.
		 * @param {*} defaultValue - The value to return if `value` is undefined.
		 * @returns {*}
		 */
		valueOrDefault: function(value, defaultValue) {
			return typeof value === 'undefined' ? defaultValue : value;
		},

		/**
		 * Returns value at the given `index` in array if defined, else returns `defaultValue`.
		 * @param {Array} value - The array to lookup for value at `index`.
		 * @param {Number} index - The index in `value` to lookup for value.
		 * @param {*} defaultValue - The value to return if `value[index]` is undefined.
		 * @returns {*}
		 */
		valueAtIndexOrDefault: function(value, index, defaultValue) {
			return helpers.valueOrDefault(helpers.isArray(value) ? value[index] : value, defaultValue);
		},

		/**
		 * Calls `fn` with the given `args` in the scope defined by `thisArg` and returns the
		 * value returned by `fn`. If `fn` is not a function, this method returns undefined.
		 * @param {Function} fn - The function to call.
		 * @param {Array|undefined|null} args - The arguments with which `fn` should be called.
		 * @param {Object} [thisArg] - The value of `this` provided for the call to `fn`.
		 * @returns {*}
		 */
		callback: function(fn, args, thisArg) {
			if (fn && typeof fn.call === 'function') {
				return fn.apply(thisArg, args);
			}
		},

		/**
		 * Note(SB) for performance sake, this method should only be used when loopable type
		 * is unknown or in none intensive code (not called often and small loopable). Else
		 * it's preferable to use a regular for() loop and save extra function calls.
		 * @param {Object|Array} loopable - The object or array to be iterated.
		 * @param {Function} fn - The function to call for each item.
		 * @param {Object} [thisArg] - The value of `this` provided for the call to `fn`.
		 * @param {Boolean} [reverse] - If true, iterates backward on the loopable.
		 */
		each: function(loopable, fn, thisArg, reverse) {
			var i, len, keys;
			if (helpers.isArray(loopable)) {
				len = loopable.length;
				if (reverse) {
					for (i = len - 1; i >= 0; i--) {
						fn.call(thisArg, loopable[i], i);
					}
				} else {
					for (i = 0; i < len; i++) {
						fn.call(thisArg, loopable[i], i);
					}
				}
			} else if (helpers.isObject(loopable)) {
				keys = Object.keys(loopable);
				len = keys.length;
				for (i = 0; i < len; i++) {
					fn.call(thisArg, loopable[keys[i]], keys[i]);
				}
			}
		},

		/**
		 * Returns true if the `a0` and `a1` arrays have the same content, else returns false.
		 * @see http://stackoverflow.com/a/14853974
		 * @param {Array} a0 - The array to compare
		 * @param {Array} a1 - The array to compare
		 * @returns {Boolean}
		 */
		arrayEquals: function(a0, a1) {
			var i, ilen, v0, v1;

			if (!a0 || !a1 || a0.length !== a1.length) {
				return false;
			}

			for (i = 0, ilen = a0.length; i < ilen; ++i) {
				v0 = a0[i];
				v1 = a1[i];

				if (v0 instanceof Array && v1 instanceof Array) {
					if (!helpers.arrayEquals(v0, v1)) {
						return false;
					}
				} else if (v0 !== v1) {
					// NOTE: two different object instances will never be equal: {x:20} != {x:20}
					return false;
				}
			}

			return true;
		},

		/**
		 * Returns a deep copy of `source` without keeping references on objects and arrays.
		 * @param {*} source - The value to clone.
		 * @returns {*}
		 */
		clone: function(source) {
			if (helpers.isArray(source)) {
				return source.map(helpers.clone);
			}

			if (helpers.isObject(source)) {
				var target = {};
				var keys = Object.keys(source);
				var klen = keys.length;
				var k = 0;

				for (; k < klen; ++k) {
					target[keys[k]] = helpers.clone(source[keys[k]]);
				}

				return target;
			}

			return source;
		},

		/**
		 * The default merger when Chart.helpers.merge is called without merger option.
		 * Note(SB): this method is also used by configMerge and scaleMerge as fallback.
		 * @private
		 */
		_merger: function(key, target, source, options) {
			var tval = target[key];
			var sval = source[key];

			if (helpers.isObject(tval) && helpers.isObject(sval)) {
				helpers.merge(tval, sval, options);
			} else {
				target[key] = helpers.clone(sval);
			}
		},

		/**
		 * Merges source[key] in target[key] only if target[key] is undefined.
		 * @private
		 */
		_mergerIf: function(key, target, source) {
			var tval = target[key];
			var sval = source[key];

			if (helpers.isObject(tval) && helpers.isObject(sval)) {
				helpers.mergeIf(tval, sval);
			} else if (!target.hasOwnProperty(key)) {
				target[key] = helpers.clone(sval);
			}
		},

		/**
		 * Recursively deep copies `source` properties into `target` with the given `options`.
		 * IMPORTANT: `target` is not cloned and will be updated with `source` properties.
		 * @param {Object} target - The target object in which all sources are merged into.
		 * @param {Object|Array(Object)} source - Object(s) to merge into `target`.
		 * @param {Object} [options] - Merging options:
		 * @param {Function} [options.merger] - The merge method (key, target, source, options)
		 * @returns {Object} The `target` object.
		 */
		merge: function(target, source, options) {
			var sources = helpers.isArray(source) ? source : [source];
			var ilen = sources.length;
			var merge, i, keys, klen, k;

			if (!helpers.isObject(target)) {
				return target;
			}

			options = options || {};
			merge = options.merger || helpers._merger;

			for (i = 0; i < ilen; ++i) {
				source = sources[i];
				if (!helpers.isObject(source)) {
					continue;
				}

				keys = Object.keys(source);
				for (k = 0, klen = keys.length; k < klen; ++k) {
					merge(keys[k], target, source, options);
				}
			}

			return target;
		},

		/**
		 * Recursively deep copies `source` properties into `target` *only* if not defined in target.
		 * IMPORTANT: `target` is not cloned and will be updated with `source` properties.
		 * @param {Object} target - The target object in which all sources are merged into.
		 * @param {Object|Array(Object)} source - Object(s) to merge into `target`.
		 * @returns {Object} The `target` object.
		 */
		mergeIf: function(target, source) {
			return helpers.merge(target, source, {merger: helpers._mergerIf});
		},

		/**
		 * Applies the contents of two or more objects together into the first object.
		 * @param {Object} target - The target object in which all objects are merged into.
		 * @param {Object} arg1 - Object containing additional properties to merge in target.
		 * @param {Object} argN - Additional objects containing properties to merge in target.
		 * @returns {Object} The `target` object.
		 */
		extend: function(target) {
			var arguments$1 = arguments;

			var setFn = function(value, key) {
				target[key] = value;
			};
			for (var i = 1, ilen = arguments.length; i < ilen; ++i) {
				helpers.each(arguments$1[i], setFn);
			}
			return target;
		},

		/**
		 * Basic javascript inheritance based on the model created in Backbone.js
		 */
		inherits: function(extensions) {
			var me = this;
			var ChartElement = (extensions && extensions.hasOwnProperty('constructor')) ? extensions.constructor : function() {
				return me.apply(this, arguments);
			};

			var Surrogate = function() {
				this.constructor = ChartElement;
			};

			Surrogate.prototype = me.prototype;
			ChartElement.prototype = new Surrogate();
			ChartElement.extend = helpers.inherits;

			if (extensions) {
				helpers.extend(ChartElement.prototype, extensions);
			}

			ChartElement.__super__ = me.prototype;
			return ChartElement;
		}
	};

	var helpers_core = helpers;

	// DEPRECATIONS

	/**
	 * Provided for backward compatibility, use Chart.helpers.callback instead.
	 * @function Chart.helpers.callCallback
	 * @deprecated since version 2.6.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers.callCallback = helpers.callback;

	/**
	 * Provided for backward compatibility, use Array.prototype.indexOf instead.
	 * Array.prototype.indexOf compatibility: Chrome, Opera, Safari, FF1.5+, IE9+
	 * @function Chart.helpers.indexOf
	 * @deprecated since version 2.7.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers.indexOf = function(array, item, fromIndex) {
		return Array.prototype.indexOf.call(array, item, fromIndex);
	};

	/**
	 * Provided for backward compatibility, use Chart.helpers.valueOrDefault instead.
	 * @function Chart.helpers.getValueOrDefault
	 * @deprecated since version 2.7.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers.getValueOrDefault = helpers.valueOrDefault;

	/**
	 * Provided for backward compatibility, use Chart.helpers.valueAtIndexOrDefault instead.
	 * @function Chart.helpers.getValueAtIndexOrDefault
	 * @deprecated since version 2.7.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers.getValueAtIndexOrDefault = helpers.valueAtIndexOrDefault;

	var helpers_core$1 = /*#__PURE__*/Object.freeze({
		default: helpers_core,
		__moduleExports: helpers_core
	});

	var helpers$1 = ( helpers_core$1 && helpers_core ) || helpers_core$1;

	/**
	 * Easing functions adapted from Robert Penner's easing equations.
	 * @namespace Chart.helpers.easingEffects
	 * @see http://www.robertpenner.com/easing/
	 */
	var effects = {
		linear: function(t) {
			return t;
		},

		easeInQuad: function(t) {
			return t * t;
		},

		easeOutQuad: function(t) {
			return -t * (t - 2);
		},

		easeInOutQuad: function(t) {
			if ((t /= 0.5) < 1) {
				return 0.5 * t * t;
			}
			return -0.5 * ((--t) * (t - 2) - 1);
		},

		easeInCubic: function(t) {
			return t * t * t;
		},

		easeOutCubic: function(t) {
			return (t = t - 1) * t * t + 1;
		},

		easeInOutCubic: function(t) {
			if ((t /= 0.5) < 1) {
				return 0.5 * t * t * t;
			}
			return 0.5 * ((t -= 2) * t * t + 2);
		},

		easeInQuart: function(t) {
			return t * t * t * t;
		},

		easeOutQuart: function(t) {
			return -((t = t - 1) * t * t * t - 1);
		},

		easeInOutQuart: function(t) {
			if ((t /= 0.5) < 1) {
				return 0.5 * t * t * t * t;
			}
			return -0.5 * ((t -= 2) * t * t * t - 2);
		},

		easeInQuint: function(t) {
			return t * t * t * t * t;
		},

		easeOutQuint: function(t) {
			return (t = t - 1) * t * t * t * t + 1;
		},

		easeInOutQuint: function(t) {
			if ((t /= 0.5) < 1) {
				return 0.5 * t * t * t * t * t;
			}
			return 0.5 * ((t -= 2) * t * t * t * t + 2);
		},

		easeInSine: function(t) {
			return -Math.cos(t * (Math.PI / 2)) + 1;
		},

		easeOutSine: function(t) {
			return Math.sin(t * (Math.PI / 2));
		},

		easeInOutSine: function(t) {
			return -0.5 * (Math.cos(Math.PI * t) - 1);
		},

		easeInExpo: function(t) {
			return (t === 0) ? 0 : Math.pow(2, 10 * (t - 1));
		},

		easeOutExpo: function(t) {
			return (t === 1) ? 1 : -Math.pow(2, -10 * t) + 1;
		},

		easeInOutExpo: function(t) {
			if (t === 0) {
				return 0;
			}
			if (t === 1) {
				return 1;
			}
			if ((t /= 0.5) < 1) {
				return 0.5 * Math.pow(2, 10 * (t - 1));
			}
			return 0.5 * (-Math.pow(2, -10 * --t) + 2);
		},

		easeInCirc: function(t) {
			if (t >= 1) {
				return t;
			}
			return -(Math.sqrt(1 - t * t) - 1);
		},

		easeOutCirc: function(t) {
			return Math.sqrt(1 - (t = t - 1) * t);
		},

		easeInOutCirc: function(t) {
			if ((t /= 0.5) < 1) {
				return -0.5 * (Math.sqrt(1 - t * t) - 1);
			}
			return 0.5 * (Math.sqrt(1 - (t -= 2) * t) + 1);
		},

		easeInElastic: function(t) {
			var s = 1.70158;
			var p = 0;
			var a = 1;
			if (t === 0) {
				return 0;
			}
			if (t === 1) {
				return 1;
			}
			if (!p) {
				p = 0.3;
			}
			if (a < 1) {
				a = 1;
				s = p / 4;
			} else {
				s = p / (2 * Math.PI) * Math.asin(1 / a);
			}
			return -(a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p));
		},

		easeOutElastic: function(t) {
			var s = 1.70158;
			var p = 0;
			var a = 1;
			if (t === 0) {
				return 0;
			}
			if (t === 1) {
				return 1;
			}
			if (!p) {
				p = 0.3;
			}
			if (a < 1) {
				a = 1;
				s = p / 4;
			} else {
				s = p / (2 * Math.PI) * Math.asin(1 / a);
			}
			return a * Math.pow(2, -10 * t) * Math.sin((t - s) * (2 * Math.PI) / p) + 1;
		},

		easeInOutElastic: function(t) {
			var s = 1.70158;
			var p = 0;
			var a = 1;
			if (t === 0) {
				return 0;
			}
			if ((t /= 0.5) === 2) {
				return 1;
			}
			if (!p) {
				p = 0.45;
			}
			if (a < 1) {
				a = 1;
				s = p / 4;
			} else {
				s = p / (2 * Math.PI) * Math.asin(1 / a);
			}
			if (t < 1) {
				return -0.5 * (a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p));
			}
			return a * Math.pow(2, -10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p) * 0.5 + 1;
		},
		easeInBack: function(t) {
			var s = 1.70158;
			return t * t * ((s + 1) * t - s);
		},

		easeOutBack: function(t) {
			var s = 1.70158;
			return (t = t - 1) * t * ((s + 1) * t + s) + 1;
		},

		easeInOutBack: function(t) {
			var s = 1.70158;
			if ((t /= 0.5) < 1) {
				return 0.5 * (t * t * (((s *= (1.525)) + 1) * t - s));
			}
			return 0.5 * ((t -= 2) * t * (((s *= (1.525)) + 1) * t + s) + 2);
		},

		easeInBounce: function(t) {
			return 1 - effects.easeOutBounce(1 - t);
		},

		easeOutBounce: function(t) {
			if (t < (1 / 2.75)) {
				return 7.5625 * t * t;
			}
			if (t < (2 / 2.75)) {
				return 7.5625 * (t -= (1.5 / 2.75)) * t + 0.75;
			}
			if (t < (2.5 / 2.75)) {
				return 7.5625 * (t -= (2.25 / 2.75)) * t + 0.9375;
			}
			return 7.5625 * (t -= (2.625 / 2.75)) * t + 0.984375;
		},

		easeInOutBounce: function(t) {
			if (t < 0.5) {
				return effects.easeInBounce(t * 2) * 0.5;
			}
			return effects.easeOutBounce(t * 2 - 1) * 0.5 + 0.5;
		}
	};

	var helpers_easing = {
		effects: effects
	};

	// DEPRECATIONS

	/**
	 * Provided for backward compatibility, use Chart.helpers.easing.effects instead.
	 * @function Chart.helpers.easingEffects
	 * @deprecated since version 2.7.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers$1.easingEffects = effects;
	var helpers_easing_1 = helpers_easing.effects;

	var helpers_easing$1 = /*#__PURE__*/Object.freeze({
		default: helpers_easing,
		__moduleExports: helpers_easing,
		effects: helpers_easing_1
	});

	var helpers_canvas = createCommonjsModule(function (module) {



	/**
	 * @namespace Chart.helpers.canvas
	 */
	var exports = module.exports = {
		/**
		 * Clears the entire canvas associated to the given `chart`.
		 * @param {Chart} chart - The chart for which to clear the canvas.
		 */
		clear: function(chart) {
			chart.ctx.clearRect(0, 0, chart.width, chart.height);
		},

		/**
		 * Creates a "path" for a rectangle with rounded corners at position (x, y) with a
		 * given size (width, height) and the same `radius` for all corners.
		 * @param {CanvasRenderingContext2D} ctx - The canvas 2D Context.
		 * @param {Number} x - The x axis of the coordinate for the rectangle starting point.
		 * @param {Number} y - The y axis of the coordinate for the rectangle starting point.
		 * @param {Number} width - The rectangle's width.
		 * @param {Number} height - The rectangle's height.
		 * @param {Number} radius - The rounded amount (in pixels) for the four corners.
		 * @todo handle `radius` as top-left, top-right, bottom-right, bottom-left array/object?
		 */
		roundedRect: function(ctx, x, y, width, height, radius) {
			if (radius) {
				// NOTE(SB) `epsilon` helps to prevent minor artifacts appearing
				// on Chrome when `r` is exactly half the height or the width.
				var epsilon = 0.0000001;
				var r = Math.min(radius, (height / 2) - epsilon, (width / 2) - epsilon);

				ctx.moveTo(x + r, y);
				ctx.lineTo(x + width - r, y);
				ctx.arcTo(x + width, y, x + width, y + r, r);
				ctx.lineTo(x + width, y + height - r);
				ctx.arcTo(x + width, y + height, x + width - r, y + height, r);
				ctx.lineTo(x + r, y + height);
				ctx.arcTo(x, y + height, x, y + height - r, r);
				ctx.lineTo(x, y + r);
				ctx.arcTo(x, y, x + r, y, r);
				ctx.closePath();
				ctx.moveTo(x, y);
			} else {
				ctx.rect(x, y, width, height);
			}
		},

		drawPoint: function(ctx, style, radius, x, y, rotation) {
			var type, edgeLength, xOffset, yOffset, height, size;
			rotation = rotation || 0;

			if (style && typeof style === 'object') {
				type = style.toString();
				if (type === '[object HTMLImageElement]' || type === '[object HTMLCanvasElement]') {
					ctx.drawImage(style, x - style.width / 2, y - style.height / 2, style.width, style.height);
					return;
				}
			}

			if (isNaN(radius) || radius <= 0) {
				return;
			}

			ctx.save();
			ctx.translate(x, y);
			ctx.rotate(rotation * Math.PI / 180);
			ctx.beginPath();

			switch (style) {
			// Default includes circle
			default:
				ctx.arc(0, 0, radius, 0, Math.PI * 2);
				ctx.closePath();
				break;
			case 'triangle':
				edgeLength = 3 * radius / Math.sqrt(3);
				height = edgeLength * Math.sqrt(3) / 2;
				ctx.moveTo(-edgeLength / 2, height / 3);
				ctx.lineTo(edgeLength / 2, height / 3);
				ctx.lineTo(0, -2 * height / 3);
				ctx.closePath();
				break;
			case 'rect':
				size = 1 / Math.SQRT2 * radius;
				ctx.rect(-size, -size, 2 * size, 2 * size);
				break;
			case 'rectRounded':
				var offset = radius / Math.SQRT2;
				var leftX = -offset;
				var topY = -offset;
				var sideSize = Math.SQRT2 * radius;

				// NOTE(SB) the rounded rect implementation changed to use `arcTo`
				// instead of `quadraticCurveTo` since it generates better results
				// when rect is almost a circle. 0.425 (instead of 0.5) produces
				// results visually closer to the previous impl.
				this.roundedRect(ctx, leftX, topY, sideSize, sideSize, radius * 0.425);
				break;
			case 'rectRot':
				size = 1 / Math.SQRT2 * radius;
				ctx.moveTo(-size, 0);
				ctx.lineTo(0, size);
				ctx.lineTo(size, 0);
				ctx.lineTo(0, -size);
				ctx.closePath();
				break;
			case 'cross':
				ctx.moveTo(0, radius);
				ctx.lineTo(0, -radius);
				ctx.moveTo(-radius, 0);
				ctx.lineTo(radius, 0);
				break;
			case 'crossRot':
				xOffset = Math.cos(Math.PI / 4) * radius;
				yOffset = Math.sin(Math.PI / 4) * radius;
				ctx.moveTo(-xOffset, -yOffset);
				ctx.lineTo(xOffset, yOffset);
				ctx.moveTo(-xOffset, yOffset);
				ctx.lineTo(xOffset, -yOffset);
				break;
			case 'star':
				ctx.moveTo(0, radius);
				ctx.lineTo(0, -radius);
				ctx.moveTo(-radius, 0);
				ctx.lineTo(radius, 0);
				xOffset = Math.cos(Math.PI / 4) * radius;
				yOffset = Math.sin(Math.PI / 4) * radius;
				ctx.moveTo(-xOffset, -yOffset);
				ctx.lineTo(xOffset, yOffset);
				ctx.moveTo(-xOffset, yOffset);
				ctx.lineTo(xOffset, -yOffset);
				break;
			case 'line':
				ctx.moveTo(-radius, 0);
				ctx.lineTo(radius, 0);
				break;
			case 'dash':
				ctx.moveTo(0, 0);
				ctx.lineTo(radius, 0);
				break;
			}

			ctx.fill();
			ctx.stroke();
			ctx.restore();
		},

		clipArea: function(ctx, area) {
			ctx.save();
			ctx.beginPath();
			ctx.rect(area.left, area.top, area.right - area.left, area.bottom - area.top);
			ctx.clip();
		},

		unclipArea: function(ctx) {
			ctx.restore();
		},

		lineTo: function(ctx, previous, target, flip) {
			if (target.steppedLine) {
				if ((target.steppedLine === 'after' && !flip) || (target.steppedLine !== 'after' && flip)) {
					ctx.lineTo(previous.x, target.y);
				} else {
					ctx.lineTo(target.x, previous.y);
				}
				ctx.lineTo(target.x, target.y);
				return;
			}

			if (!target.tension) {
				ctx.lineTo(target.x, target.y);
				return;
			}

			ctx.bezierCurveTo(
				flip ? previous.controlPointPreviousX : previous.controlPointNextX,
				flip ? previous.controlPointPreviousY : previous.controlPointNextY,
				flip ? target.controlPointNextX : target.controlPointPreviousX,
				flip ? target.controlPointNextY : target.controlPointPreviousY,
				target.x,
				target.y);
		}
	};

	// DEPRECATIONS

	/**
	 * Provided for backward compatibility, use Chart.helpers.canvas.clear instead.
	 * @namespace Chart.helpers.clear
	 * @deprecated since version 2.7.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers$1.clear = exports.clear;

	/**
	 * Provided for backward compatibility, use Chart.helpers.canvas.roundedRect instead.
	 * @namespace Chart.helpers.drawRoundedRectangle
	 * @deprecated since version 2.7.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers$1.drawRoundedRectangle = function(ctx) {
		ctx.beginPath();
		exports.roundedRect.apply(exports, arguments);
	};
	});
	var helpers_canvas_1 = helpers_canvas.clear;
	var helpers_canvas_2 = helpers_canvas.roundedRect;
	var helpers_canvas_3 = helpers_canvas.drawPoint;
	var helpers_canvas_4 = helpers_canvas.clipArea;
	var helpers_canvas_5 = helpers_canvas.unclipArea;
	var helpers_canvas_6 = helpers_canvas.lineTo;

	var helpers_canvas$1 = /*#__PURE__*/Object.freeze({
		default: helpers_canvas,
		__moduleExports: helpers_canvas,
		clear: helpers_canvas_1,
		roundedRect: helpers_canvas_2,
		drawPoint: helpers_canvas_3,
		clipArea: helpers_canvas_4,
		unclipArea: helpers_canvas_5,
		lineTo: helpers_canvas_6
	});

	/**
	 * @alias Chart.helpers.options
	 * @namespace
	 */
	var helpers_options = {
		/**
		 * Converts the given line height `value` in pixels for a specific font `size`.
		 * @param {Number|String} value - The lineHeight to parse (eg. 1.6, '14px', '75%', '1.6em').
		 * @param {Number} size - The font size (in pixels) used to resolve relative `value`.
		 * @returns {Number} The effective line height in pixels (size * 1.2 if value is invalid).
		 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/line-height
		 * @since 2.7.0
		 */
		toLineHeight: function(value, size) {
			var matches = ('' + value).match(/^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/);
			if (!matches || matches[1] === 'normal') {
				return size * 1.2;
			}

			value = +matches[2];

			switch (matches[3]) {
			case 'px':
				return value;
			case '%':
				value /= 100;
				break;
			default:
				break;
			}

			return size * value;
		},

		/**
		 * Converts the given value into a padding object with pre-computed width/height.
		 * @param {Number|Object} value - If a number, set the value to all TRBL component,
		 *  else, if and object, use defined properties and sets undefined ones to 0.
		 * @returns {Object} The padding values (top, right, bottom, left, width, height)
		 * @since 2.7.0
		 */
		toPadding: function(value) {
			var t, r, b, l;

			if (helpers$1.isObject(value)) {
				t = +value.top || 0;
				r = +value.right || 0;
				b = +value.bottom || 0;
				l = +value.left || 0;
			} else {
				t = r = b = l = +value || 0;
			}

			return {
				top: t,
				right: r,
				bottom: b,
				left: l,
				height: t + b,
				width: l + r
			};
		},

		/**
		 * Evaluates the given `inputs` sequentially and returns the first defined value.
		 * @param {Array[]} inputs - An array of values, falling back to the last value.
		 * @param {Object} [context] - If defined and the current value is a function, the value
		 * is called with `context` as first argument and the result becomes the new input.
		 * @param {Number} [index] - If defined and the current value is an array, the value
		 * at `index` become the new input.
		 * @since 2.7.0
		 */
		resolve: function(inputs, context, index) {
			var i, ilen, value;

			for (i = 0, ilen = inputs.length; i < ilen; ++i) {
				value = inputs[i];
				if (value === undefined) {
					continue;
				}
				if (context !== undefined && typeof value === 'function') {
					value = value(context);
				}
				if (index !== undefined && helpers$1.isArray(value)) {
					value = value[index];
				}
				if (value !== undefined) {
					return value;
				}
			}
		}
	};
	var helpers_options_1 = helpers_options.toLineHeight;
	var helpers_options_2 = helpers_options.toPadding;
	var helpers_options_3 = helpers_options.resolve;

	var helpers_options$1 = /*#__PURE__*/Object.freeze({
		default: helpers_options,
		__moduleExports: helpers_options,
		toLineHeight: helpers_options_1,
		toPadding: helpers_options_2,
		resolve: helpers_options_3
	});

	var require$$1$2 = ( helpers_easing$1 && helpers_easing ) || helpers_easing$1;

	var require$$2 = ( helpers_canvas$1 && helpers_canvas ) || helpers_canvas$1;

	var require$$3 = ( helpers_options$1 && helpers_options ) || helpers_options$1;

	var helpers$2 = helpers$1;
	var easing = require$$1$2;
	var canvas = require$$2;
	var options = require$$3;
	helpers$2.easing = easing;
	helpers$2.canvas = canvas;
	helpers$2.options = options;

	var helpers$3 = /*#__PURE__*/Object.freeze({
		default: helpers$2,
		__moduleExports: helpers$2,
		easing: easing,
		canvas: canvas,
		options: options
	});

	var helpers$4 = ( helpers$3 && helpers$2 ) || helpers$3;

	var core_defaults = {
		/**
		 * @private
		 */
		_set: function(scope, values) {
			return helpers$4.merge(this[scope] || (this[scope] = {}), values);
		}
	};
	var core_defaults_1 = core_defaults._set;

	var core_defaults$1 = /*#__PURE__*/Object.freeze({
		default: core_defaults,
		__moduleExports: core_defaults,
		_set: core_defaults_1
	});

	var defaults$3 = ( core_defaults$1 && core_defaults ) || core_defaults$1;

	defaults$3._set('global', {
		responsive: true,
		responsiveAnimationDuration: 0,
		maintainAspectRatio: true,
		events: ['mousemove', 'mouseout', 'click', 'touchstart', 'touchmove'],
		hover: {
			onHover: null,
			mode: 'nearest',
			intersect: true,
			animationDuration: 400
		},
		onClick: null,
		defaultColor: 'rgba(0,0,0,0.1)',
		defaultFontColor: '#666',
		defaultFontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
		defaultFontSize: 12,
		defaultFontStyle: 'normal',
		showLines: true,

		// Element defaults defined in element extensions
		elements: {},

		// Layout options such as padding
		layout: {
			padding: {
				top: 0,
				right: 0,
				bottom: 0,
				left: 0
			}
		}
	});

	var core = function() {

		// Occupy the global variable of Chart, and create a simple base class
		var Chart = function(item, config) {
			this.construct(item, config);
			return this;
		};

		Chart.Chart = Chart;

		return Chart;
	};

	var core$1 = /*#__PURE__*/Object.freeze({
		default: core,
		__moduleExports: core
	});

	var colorName = {
		"aliceblue": [240, 248, 255],
		"antiquewhite": [250, 235, 215],
		"aqua": [0, 255, 255],
		"aquamarine": [127, 255, 212],
		"azure": [240, 255, 255],
		"beige": [245, 245, 220],
		"bisque": [255, 228, 196],
		"black": [0, 0, 0],
		"blanchedalmond": [255, 235, 205],
		"blue": [0, 0, 255],
		"blueviolet": [138, 43, 226],
		"brown": [165, 42, 42],
		"burlywood": [222, 184, 135],
		"cadetblue": [95, 158, 160],
		"chartreuse": [127, 255, 0],
		"chocolate": [210, 105, 30],
		"coral": [255, 127, 80],
		"cornflowerblue": [100, 149, 237],
		"cornsilk": [255, 248, 220],
		"crimson": [220, 20, 60],
		"cyan": [0, 255, 255],
		"darkblue": [0, 0, 139],
		"darkcyan": [0, 139, 139],
		"darkgoldenrod": [184, 134, 11],
		"darkgray": [169, 169, 169],
		"darkgreen": [0, 100, 0],
		"darkgrey": [169, 169, 169],
		"darkkhaki": [189, 183, 107],
		"darkmagenta": [139, 0, 139],
		"darkolivegreen": [85, 107, 47],
		"darkorange": [255, 140, 0],
		"darkorchid": [153, 50, 204],
		"darkred": [139, 0, 0],
		"darksalmon": [233, 150, 122],
		"darkseagreen": [143, 188, 143],
		"darkslateblue": [72, 61, 139],
		"darkslategray": [47, 79, 79],
		"darkslategrey": [47, 79, 79],
		"darkturquoise": [0, 206, 209],
		"darkviolet": [148, 0, 211],
		"deeppink": [255, 20, 147],
		"deepskyblue": [0, 191, 255],
		"dimgray": [105, 105, 105],
		"dimgrey": [105, 105, 105],
		"dodgerblue": [30, 144, 255],
		"firebrick": [178, 34, 34],
		"floralwhite": [255, 250, 240],
		"forestgreen": [34, 139, 34],
		"fuchsia": [255, 0, 255],
		"gainsboro": [220, 220, 220],
		"ghostwhite": [248, 248, 255],
		"gold": [255, 215, 0],
		"goldenrod": [218, 165, 32],
		"gray": [128, 128, 128],
		"green": [0, 128, 0],
		"greenyellow": [173, 255, 47],
		"grey": [128, 128, 128],
		"honeydew": [240, 255, 240],
		"hotpink": [255, 105, 180],
		"indianred": [205, 92, 92],
		"indigo": [75, 0, 130],
		"ivory": [255, 255, 240],
		"khaki": [240, 230, 140],
		"lavender": [230, 230, 250],
		"lavenderblush": [255, 240, 245],
		"lawngreen": [124, 252, 0],
		"lemonchiffon": [255, 250, 205],
		"lightblue": [173, 216, 230],
		"lightcoral": [240, 128, 128],
		"lightcyan": [224, 255, 255],
		"lightgoldenrodyellow": [250, 250, 210],
		"lightgray": [211, 211, 211],
		"lightgreen": [144, 238, 144],
		"lightgrey": [211, 211, 211],
		"lightpink": [255, 182, 193],
		"lightsalmon": [255, 160, 122],
		"lightseagreen": [32, 178, 170],
		"lightskyblue": [135, 206, 250],
		"lightslategray": [119, 136, 153],
		"lightslategrey": [119, 136, 153],
		"lightsteelblue": [176, 196, 222],
		"lightyellow": [255, 255, 224],
		"lime": [0, 255, 0],
		"limegreen": [50, 205, 50],
		"linen": [250, 240, 230],
		"magenta": [255, 0, 255],
		"maroon": [128, 0, 0],
		"mediumaquamarine": [102, 205, 170],
		"mediumblue": [0, 0, 205],
		"mediumorchid": [186, 85, 211],
		"mediumpurple": [147, 112, 219],
		"mediumseagreen": [60, 179, 113],
		"mediumslateblue": [123, 104, 238],
		"mediumspringgreen": [0, 250, 154],
		"mediumturquoise": [72, 209, 204],
		"mediumvioletred": [199, 21, 133],
		"midnightblue": [25, 25, 112],
		"mintcream": [245, 255, 250],
		"mistyrose": [255, 228, 225],
		"moccasin": [255, 228, 181],
		"navajowhite": [255, 222, 173],
		"navy": [0, 0, 128],
		"oldlace": [253, 245, 230],
		"olive": [128, 128, 0],
		"olivedrab": [107, 142, 35],
		"orange": [255, 165, 0],
		"orangered": [255, 69, 0],
		"orchid": [218, 112, 214],
		"palegoldenrod": [238, 232, 170],
		"palegreen": [152, 251, 152],
		"paleturquoise": [175, 238, 238],
		"palevioletred": [219, 112, 147],
		"papayawhip": [255, 239, 213],
		"peachpuff": [255, 218, 185],
		"peru": [205, 133, 63],
		"pink": [255, 192, 203],
		"plum": [221, 160, 221],
		"powderblue": [176, 224, 230],
		"purple": [128, 0, 128],
		"rebeccapurple": [102, 51, 153],
		"red": [255, 0, 0],
		"rosybrown": [188, 143, 143],
		"royalblue": [65, 105, 225],
		"saddlebrown": [139, 69, 19],
		"salmon": [250, 128, 114],
		"sandybrown": [244, 164, 96],
		"seagreen": [46, 139, 87],
		"seashell": [255, 245, 238],
		"sienna": [160, 82, 45],
		"silver": [192, 192, 192],
		"skyblue": [135, 206, 235],
		"slateblue": [106, 90, 205],
		"slategray": [112, 128, 144],
		"slategrey": [112, 128, 144],
		"snow": [255, 250, 250],
		"springgreen": [0, 255, 127],
		"steelblue": [70, 130, 180],
		"tan": [210, 180, 140],
		"teal": [0, 128, 128],
		"thistle": [216, 191, 216],
		"tomato": [255, 99, 71],
		"turquoise": [64, 224, 208],
		"violet": [238, 130, 238],
		"wheat": [245, 222, 179],
		"white": [255, 255, 255],
		"whitesmoke": [245, 245, 245],
		"yellow": [255, 255, 0],
		"yellowgreen": [154, 205, 50]
	};

	var colorName$1 = /*#__PURE__*/Object.freeze({
		default: colorName,
		__moduleExports: colorName
	});

	var cssKeywords = ( colorName$1 && colorName ) || colorName$1;

	var conversions = createCommonjsModule(function (module) {
	/* MIT license */


	// NOTE: conversions should only return primitive values (i.e. arrays, or
	//       values that give correct `typeof` results).
	//       do not use box values types (i.e. Number(), String(), etc.)

	var reverseKeywords = {};
	for (var key in cssKeywords) {
		if (cssKeywords.hasOwnProperty(key)) {
			reverseKeywords[cssKeywords[key]] = key;
		}
	}

	var convert = module.exports = {
		rgb: {channels: 3, labels: 'rgb'},
		hsl: {channels: 3, labels: 'hsl'},
		hsv: {channels: 3, labels: 'hsv'},
		hwb: {channels: 3, labels: 'hwb'},
		cmyk: {channels: 4, labels: 'cmyk'},
		xyz: {channels: 3, labels: 'xyz'},
		lab: {channels: 3, labels: 'lab'},
		lch: {channels: 3, labels: 'lch'},
		hex: {channels: 1, labels: ['hex']},
		keyword: {channels: 1, labels: ['keyword']},
		ansi16: {channels: 1, labels: ['ansi16']},
		ansi256: {channels: 1, labels: ['ansi256']},
		hcg: {channels: 3, labels: ['h', 'c', 'g']},
		apple: {channels: 3, labels: ['r16', 'g16', 'b16']},
		gray: {channels: 1, labels: ['gray']}
	};

	// hide .channels and .labels properties
	for (var model in convert) {
		if (convert.hasOwnProperty(model)) {
			if (!('channels' in convert[model])) {
				throw new Error('missing channels property: ' + model);
			}

			if (!('labels' in convert[model])) {
				throw new Error('missing channel labels property: ' + model);
			}

			if (convert[model].labels.length !== convert[model].channels) {
				throw new Error('channel and label counts mismatch: ' + model);
			}

			var channels = convert[model].channels;
			var labels = convert[model].labels;
			delete convert[model].channels;
			delete convert[model].labels;
			Object.defineProperty(convert[model], 'channels', {value: channels});
			Object.defineProperty(convert[model], 'labels', {value: labels});
		}
	}

	convert.rgb.hsl = function (rgb) {
		var r = rgb[0] / 255;
		var g = rgb[1] / 255;
		var b = rgb[2] / 255;
		var min = Math.min(r, g, b);
		var max = Math.max(r, g, b);
		var delta = max - min;
		var h;
		var s;
		var l;

		if (max === min) {
			h = 0;
		} else if (r === max) {
			h = (g - b) / delta;
		} else if (g === max) {
			h = 2 + (b - r) / delta;
		} else if (b === max) {
			h = 4 + (r - g) / delta;
		}

		h = Math.min(h * 60, 360);

		if (h < 0) {
			h += 360;
		}

		l = (min + max) / 2;

		if (max === min) {
			s = 0;
		} else if (l <= 0.5) {
			s = delta / (max + min);
		} else {
			s = delta / (2 - max - min);
		}

		return [h, s * 100, l * 100];
	};

	convert.rgb.hsv = function (rgb) {
		var rdif;
		var gdif;
		var bdif;
		var h;
		var s;

		var r = rgb[0] / 255;
		var g = rgb[1] / 255;
		var b = rgb[2] / 255;
		var v = Math.max(r, g, b);
		var diff = v - Math.min(r, g, b);
		var diffc = function (c) {
			return (v - c) / 6 / diff + 1 / 2;
		};

		if (diff === 0) {
			h = s = 0;
		} else {
			s = diff / v;
			rdif = diffc(r);
			gdif = diffc(g);
			bdif = diffc(b);

			if (r === v) {
				h = bdif - gdif;
			} else if (g === v) {
				h = (1 / 3) + rdif - bdif;
			} else if (b === v) {
				h = (2 / 3) + gdif - rdif;
			}
			if (h < 0) {
				h += 1;
			} else if (h > 1) {
				h -= 1;
			}
		}

		return [
			h * 360,
			s * 100,
			v * 100
		];
	};

	convert.rgb.hwb = function (rgb) {
		var r = rgb[0];
		var g = rgb[1];
		var b = rgb[2];
		var h = convert.rgb.hsl(rgb)[0];
		var w = 1 / 255 * Math.min(r, Math.min(g, b));

		b = 1 - 1 / 255 * Math.max(r, Math.max(g, b));

		return [h, w * 100, b * 100];
	};

	convert.rgb.cmyk = function (rgb) {
		var r = rgb[0] / 255;
		var g = rgb[1] / 255;
		var b = rgb[2] / 255;
		var c;
		var m;
		var y;
		var k;

		k = Math.min(1 - r, 1 - g, 1 - b);
		c = (1 - r - k) / (1 - k) || 0;
		m = (1 - g - k) / (1 - k) || 0;
		y = (1 - b - k) / (1 - k) || 0;

		return [c * 100, m * 100, y * 100, k * 100];
	};

	/**
	 * See https://en.m.wikipedia.org/wiki/Euclidean_distance#Squared_Euclidean_distance
	 * */
	function comparativeDistance(x, y) {
		return (
			Math.pow(x[0] - y[0], 2) +
			Math.pow(x[1] - y[1], 2) +
			Math.pow(x[2] - y[2], 2)
		);
	}

	convert.rgb.keyword = function (rgb) {
		var reversed = reverseKeywords[rgb];
		if (reversed) {
			return reversed;
		}

		var currentClosestDistance = Infinity;
		var currentClosestKeyword;

		for (var keyword in cssKeywords) {
			if (cssKeywords.hasOwnProperty(keyword)) {
				var value = cssKeywords[keyword];

				// Compute comparative distance
				var distance = comparativeDistance(rgb, value);

				// Check if its less, if so set as closest
				if (distance < currentClosestDistance) {
					currentClosestDistance = distance;
					currentClosestKeyword = keyword;
				}
			}
		}

		return currentClosestKeyword;
	};

	convert.keyword.rgb = function (keyword) {
		return cssKeywords[keyword];
	};

	convert.rgb.xyz = function (rgb) {
		var r = rgb[0] / 255;
		var g = rgb[1] / 255;
		var b = rgb[2] / 255;

		// assume sRGB
		r = r > 0.04045 ? Math.pow(((r + 0.055) / 1.055), 2.4) : (r / 12.92);
		g = g > 0.04045 ? Math.pow(((g + 0.055) / 1.055), 2.4) : (g / 12.92);
		b = b > 0.04045 ? Math.pow(((b + 0.055) / 1.055), 2.4) : (b / 12.92);

		var x = (r * 0.4124) + (g * 0.3576) + (b * 0.1805);
		var y = (r * 0.2126) + (g * 0.7152) + (b * 0.0722);
		var z = (r * 0.0193) + (g * 0.1192) + (b * 0.9505);

		return [x * 100, y * 100, z * 100];
	};

	convert.rgb.lab = function (rgb) {
		var xyz = convert.rgb.xyz(rgb);
		var x = xyz[0];
		var y = xyz[1];
		var z = xyz[2];
		var l;
		var a;
		var b;

		x /= 95.047;
		y /= 100;
		z /= 108.883;

		x = x > 0.008856 ? Math.pow(x, 1 / 3) : (7.787 * x) + (16 / 116);
		y = y > 0.008856 ? Math.pow(y, 1 / 3) : (7.787 * y) + (16 / 116);
		z = z > 0.008856 ? Math.pow(z, 1 / 3) : (7.787 * z) + (16 / 116);

		l = (116 * y) - 16;
		a = 500 * (x - y);
		b = 200 * (y - z);

		return [l, a, b];
	};

	convert.hsl.rgb = function (hsl) {
		var h = hsl[0] / 360;
		var s = hsl[1] / 100;
		var l = hsl[2] / 100;
		var t1;
		var t2;
		var t3;
		var rgb;
		var val;

		if (s === 0) {
			val = l * 255;
			return [val, val, val];
		}

		if (l < 0.5) {
			t2 = l * (1 + s);
		} else {
			t2 = l + s - l * s;
		}

		t1 = 2 * l - t2;

		rgb = [0, 0, 0];
		for (var i = 0; i < 3; i++) {
			t3 = h + 1 / 3 * -(i - 1);
			if (t3 < 0) {
				t3++;
			}
			if (t3 > 1) {
				t3--;
			}

			if (6 * t3 < 1) {
				val = t1 + (t2 - t1) * 6 * t3;
			} else if (2 * t3 < 1) {
				val = t2;
			} else if (3 * t3 < 2) {
				val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
			} else {
				val = t1;
			}

			rgb[i] = val * 255;
		}

		return rgb;
	};

	convert.hsl.hsv = function (hsl) {
		var h = hsl[0];
		var s = hsl[1] / 100;
		var l = hsl[2] / 100;
		var smin = s;
		var lmin = Math.max(l, 0.01);
		var sv;
		var v;

		l *= 2;
		s *= (l <= 1) ? l : 2 - l;
		smin *= lmin <= 1 ? lmin : 2 - lmin;
		v = (l + s) / 2;
		sv = l === 0 ? (2 * smin) / (lmin + smin) : (2 * s) / (l + s);

		return [h, sv * 100, v * 100];
	};

	convert.hsv.rgb = function (hsv) {
		var h = hsv[0] / 60;
		var s = hsv[1] / 100;
		var v = hsv[2] / 100;
		var hi = Math.floor(h) % 6;

		var f = h - Math.floor(h);
		var p = 255 * v * (1 - s);
		var q = 255 * v * (1 - (s * f));
		var t = 255 * v * (1 - (s * (1 - f)));
		v *= 255;

		switch (hi) {
			case 0:
				return [v, t, p];
			case 1:
				return [q, v, p];
			case 2:
				return [p, v, t];
			case 3:
				return [p, q, v];
			case 4:
				return [t, p, v];
			case 5:
				return [v, p, q];
		}
	};

	convert.hsv.hsl = function (hsv) {
		var h = hsv[0];
		var s = hsv[1] / 100;
		var v = hsv[2] / 100;
		var vmin = Math.max(v, 0.01);
		var lmin;
		var sl;
		var l;

		l = (2 - s) * v;
		lmin = (2 - s) * vmin;
		sl = s * vmin;
		sl /= (lmin <= 1) ? lmin : 2 - lmin;
		sl = sl || 0;
		l /= 2;

		return [h, sl * 100, l * 100];
	};

	// http://dev.w3.org/csswg/css-color/#hwb-to-rgb
	convert.hwb.rgb = function (hwb) {
		var h = hwb[0] / 360;
		var wh = hwb[1] / 100;
		var bl = hwb[2] / 100;
		var ratio = wh + bl;
		var i;
		var v;
		var f;
		var n;

		// wh + bl cant be > 1
		if (ratio > 1) {
			wh /= ratio;
			bl /= ratio;
		}

		i = Math.floor(6 * h);
		v = 1 - bl;
		f = 6 * h - i;

		if ((i & 0x01) !== 0) {
			f = 1 - f;
		}

		n = wh + f * (v - wh); // linear interpolation

		var r;
		var g;
		var b;
		switch (i) {
			default:
			case 6:
			case 0: r = v; g = n; b = wh; break;
			case 1: r = n; g = v; b = wh; break;
			case 2: r = wh; g = v; b = n; break;
			case 3: r = wh; g = n; b = v; break;
			case 4: r = n; g = wh; b = v; break;
			case 5: r = v; g = wh; b = n; break;
		}

		return [r * 255, g * 255, b * 255];
	};

	convert.cmyk.rgb = function (cmyk) {
		var c = cmyk[0] / 100;
		var m = cmyk[1] / 100;
		var y = cmyk[2] / 100;
		var k = cmyk[3] / 100;
		var r;
		var g;
		var b;

		r = 1 - Math.min(1, c * (1 - k) + k);
		g = 1 - Math.min(1, m * (1 - k) + k);
		b = 1 - Math.min(1, y * (1 - k) + k);

		return [r * 255, g * 255, b * 255];
	};

	convert.xyz.rgb = function (xyz) {
		var x = xyz[0] / 100;
		var y = xyz[1] / 100;
		var z = xyz[2] / 100;
		var r;
		var g;
		var b;

		r = (x * 3.2406) + (y * -1.5372) + (z * -0.4986);
		g = (x * -0.9689) + (y * 1.8758) + (z * 0.0415);
		b = (x * 0.0557) + (y * -0.2040) + (z * 1.0570);

		// assume sRGB
		r = r > 0.0031308
			? ((1.055 * Math.pow(r, 1.0 / 2.4)) - 0.055)
			: r * 12.92;

		g = g > 0.0031308
			? ((1.055 * Math.pow(g, 1.0 / 2.4)) - 0.055)
			: g * 12.92;

		b = b > 0.0031308
			? ((1.055 * Math.pow(b, 1.0 / 2.4)) - 0.055)
			: b * 12.92;

		r = Math.min(Math.max(0, r), 1);
		g = Math.min(Math.max(0, g), 1);
		b = Math.min(Math.max(0, b), 1);

		return [r * 255, g * 255, b * 255];
	};

	convert.xyz.lab = function (xyz) {
		var x = xyz[0];
		var y = xyz[1];
		var z = xyz[2];
		var l;
		var a;
		var b;

		x /= 95.047;
		y /= 100;
		z /= 108.883;

		x = x > 0.008856 ? Math.pow(x, 1 / 3) : (7.787 * x) + (16 / 116);
		y = y > 0.008856 ? Math.pow(y, 1 / 3) : (7.787 * y) + (16 / 116);
		z = z > 0.008856 ? Math.pow(z, 1 / 3) : (7.787 * z) + (16 / 116);

		l = (116 * y) - 16;
		a = 500 * (x - y);
		b = 200 * (y - z);

		return [l, a, b];
	};

	convert.lab.xyz = function (lab) {
		var l = lab[0];
		var a = lab[1];
		var b = lab[2];
		var x;
		var y;
		var z;

		y = (l + 16) / 116;
		x = a / 500 + y;
		z = y - b / 200;

		var y2 = Math.pow(y, 3);
		var x2 = Math.pow(x, 3);
		var z2 = Math.pow(z, 3);
		y = y2 > 0.008856 ? y2 : (y - 16 / 116) / 7.787;
		x = x2 > 0.008856 ? x2 : (x - 16 / 116) / 7.787;
		z = z2 > 0.008856 ? z2 : (z - 16 / 116) / 7.787;

		x *= 95.047;
		y *= 100;
		z *= 108.883;

		return [x, y, z];
	};

	convert.lab.lch = function (lab) {
		var l = lab[0];
		var a = lab[1];
		var b = lab[2];
		var hr;
		var h;
		var c;

		hr = Math.atan2(b, a);
		h = hr * 360 / 2 / Math.PI;

		if (h < 0) {
			h += 360;
		}

		c = Math.sqrt(a * a + b * b);

		return [l, c, h];
	};

	convert.lch.lab = function (lch) {
		var l = lch[0];
		var c = lch[1];
		var h = lch[2];
		var a;
		var b;
		var hr;

		hr = h / 360 * 2 * Math.PI;
		a = c * Math.cos(hr);
		b = c * Math.sin(hr);

		return [l, a, b];
	};

	convert.rgb.ansi16 = function (args) {
		var r = args[0];
		var g = args[1];
		var b = args[2];
		var value = 1 in arguments ? arguments[1] : convert.rgb.hsv(args)[2]; // hsv -> ansi16 optimization

		value = Math.round(value / 50);

		if (value === 0) {
			return 30;
		}

		var ansi = 30
			+ ((Math.round(b / 255) << 2)
			| (Math.round(g / 255) << 1)
			| Math.round(r / 255));

		if (value === 2) {
			ansi += 60;
		}

		return ansi;
	};

	convert.hsv.ansi16 = function (args) {
		// optimization here; we already know the value and don't need to get
		// it converted for us.
		return convert.rgb.ansi16(convert.hsv.rgb(args), args[2]);
	};

	convert.rgb.ansi256 = function (args) {
		var r = args[0];
		var g = args[1];
		var b = args[2];

		// we use the extended greyscale palette here, with the exception of
		// black and white. normal palette only has 4 greyscale shades.
		if (r === g && g === b) {
			if (r < 8) {
				return 16;
			}

			if (r > 248) {
				return 231;
			}

			return Math.round(((r - 8) / 247) * 24) + 232;
		}

		var ansi = 16
			+ (36 * Math.round(r / 255 * 5))
			+ (6 * Math.round(g / 255 * 5))
			+ Math.round(b / 255 * 5);

		return ansi;
	};

	convert.ansi16.rgb = function (args) {
		var color = args % 10;

		// handle greyscale
		if (color === 0 || color === 7) {
			if (args > 50) {
				color += 3.5;
			}

			color = color / 10.5 * 255;

			return [color, color, color];
		}

		var mult = (~~(args > 50) + 1) * 0.5;
		var r = ((color & 1) * mult) * 255;
		var g = (((color >> 1) & 1) * mult) * 255;
		var b = (((color >> 2) & 1) * mult) * 255;

		return [r, g, b];
	};

	convert.ansi256.rgb = function (args) {
		// handle greyscale
		if (args >= 232) {
			var c = (args - 232) * 10 + 8;
			return [c, c, c];
		}

		args -= 16;

		var rem;
		var r = Math.floor(args / 36) / 5 * 255;
		var g = Math.floor((rem = args % 36) / 6) / 5 * 255;
		var b = (rem % 6) / 5 * 255;

		return [r, g, b];
	};

	convert.rgb.hex = function (args) {
		var integer = ((Math.round(args[0]) & 0xFF) << 16)
			+ ((Math.round(args[1]) & 0xFF) << 8)
			+ (Math.round(args[2]) & 0xFF);

		var string = integer.toString(16).toUpperCase();
		return '000000'.substring(string.length) + string;
	};

	convert.hex.rgb = function (args) {
		var match = args.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
		if (!match) {
			return [0, 0, 0];
		}

		var colorString = match[0];

		if (match[0].length === 3) {
			colorString = colorString.split('').map(function (char) {
				return char + char;
			}).join('');
		}

		var integer = parseInt(colorString, 16);
		var r = (integer >> 16) & 0xFF;
		var g = (integer >> 8) & 0xFF;
		var b = integer & 0xFF;

		return [r, g, b];
	};

	convert.rgb.hcg = function (rgb) {
		var r = rgb[0] / 255;
		var g = rgb[1] / 255;
		var b = rgb[2] / 255;
		var max = Math.max(Math.max(r, g), b);
		var min = Math.min(Math.min(r, g), b);
		var chroma = (max - min);
		var grayscale;
		var hue;

		if (chroma < 1) {
			grayscale = min / (1 - chroma);
		} else {
			grayscale = 0;
		}

		if (chroma <= 0) {
			hue = 0;
		} else
		if (max === r) {
			hue = ((g - b) / chroma) % 6;
		} else
		if (max === g) {
			hue = 2 + (b - r) / chroma;
		} else {
			hue = 4 + (r - g) / chroma + 4;
		}

		hue /= 6;
		hue %= 1;

		return [hue * 360, chroma * 100, grayscale * 100];
	};

	convert.hsl.hcg = function (hsl) {
		var s = hsl[1] / 100;
		var l = hsl[2] / 100;
		var c = 1;
		var f = 0;

		if (l < 0.5) {
			c = 2.0 * s * l;
		} else {
			c = 2.0 * s * (1.0 - l);
		}

		if (c < 1.0) {
			f = (l - 0.5 * c) / (1.0 - c);
		}

		return [hsl[0], c * 100, f * 100];
	};

	convert.hsv.hcg = function (hsv) {
		var s = hsv[1] / 100;
		var v = hsv[2] / 100;

		var c = s * v;
		var f = 0;

		if (c < 1.0) {
			f = (v - c) / (1 - c);
		}

		return [hsv[0], c * 100, f * 100];
	};

	convert.hcg.rgb = function (hcg) {
		var h = hcg[0] / 360;
		var c = hcg[1] / 100;
		var g = hcg[2] / 100;

		if (c === 0.0) {
			return [g * 255, g * 255, g * 255];
		}

		var pure = [0, 0, 0];
		var hi = (h % 1) * 6;
		var v = hi % 1;
		var w = 1 - v;
		var mg = 0;

		switch (Math.floor(hi)) {
			case 0:
				pure[0] = 1; pure[1] = v; pure[2] = 0; break;
			case 1:
				pure[0] = w; pure[1] = 1; pure[2] = 0; break;
			case 2:
				pure[0] = 0; pure[1] = 1; pure[2] = v; break;
			case 3:
				pure[0] = 0; pure[1] = w; pure[2] = 1; break;
			case 4:
				pure[0] = v; pure[1] = 0; pure[2] = 1; break;
			default:
				pure[0] = 1; pure[1] = 0; pure[2] = w;
		}

		mg = (1.0 - c) * g;

		return [
			(c * pure[0] + mg) * 255,
			(c * pure[1] + mg) * 255,
			(c * pure[2] + mg) * 255
		];
	};

	convert.hcg.hsv = function (hcg) {
		var c = hcg[1] / 100;
		var g = hcg[2] / 100;

		var v = c + g * (1.0 - c);
		var f = 0;

		if (v > 0.0) {
			f = c / v;
		}

		return [hcg[0], f * 100, v * 100];
	};

	convert.hcg.hsl = function (hcg) {
		var c = hcg[1] / 100;
		var g = hcg[2] / 100;

		var l = g * (1.0 - c) + 0.5 * c;
		var s = 0;

		if (l > 0.0 && l < 0.5) {
			s = c / (2 * l);
		} else
		if (l >= 0.5 && l < 1.0) {
			s = c / (2 * (1 - l));
		}

		return [hcg[0], s * 100, l * 100];
	};

	convert.hcg.hwb = function (hcg) {
		var c = hcg[1] / 100;
		var g = hcg[2] / 100;
		var v = c + g * (1.0 - c);
		return [hcg[0], (v - c) * 100, (1 - v) * 100];
	};

	convert.hwb.hcg = function (hwb) {
		var w = hwb[1] / 100;
		var b = hwb[2] / 100;
		var v = 1 - b;
		var c = v - w;
		var g = 0;

		if (c < 1) {
			g = (v - c) / (1 - c);
		}

		return [hwb[0], c * 100, g * 100];
	};

	convert.apple.rgb = function (apple) {
		return [(apple[0] / 65535) * 255, (apple[1] / 65535) * 255, (apple[2] / 65535) * 255];
	};

	convert.rgb.apple = function (rgb) {
		return [(rgb[0] / 255) * 65535, (rgb[1] / 255) * 65535, (rgb[2] / 255) * 65535];
	};

	convert.gray.rgb = function (args) {
		return [args[0] / 100 * 255, args[0] / 100 * 255, args[0] / 100 * 255];
	};

	convert.gray.hsl = convert.gray.hsv = function (args) {
		return [0, 0, args[0]];
	};

	convert.gray.hwb = function (gray) {
		return [0, 100, gray[0]];
	};

	convert.gray.cmyk = function (gray) {
		return [0, 0, 0, gray[0]];
	};

	convert.gray.lab = function (gray) {
		return [gray[0], 0, 0];
	};

	convert.gray.hex = function (gray) {
		var val = Math.round(gray[0] / 100 * 255) & 0xFF;
		var integer = (val << 16) + (val << 8) + val;

		var string = integer.toString(16).toUpperCase();
		return '000000'.substring(string.length) + string;
	};

	convert.rgb.gray = function (rgb) {
		var val = (rgb[0] + rgb[1] + rgb[2]) / 3;
		return [val / 255 * 100];
	};
	});
	var conversions_1 = conversions.rgb;
	var conversions_2 = conversions.hsl;
	var conversions_3 = conversions.hsv;
	var conversions_4 = conversions.hwb;
	var conversions_5 = conversions.cmyk;
	var conversions_6 = conversions.xyz;
	var conversions_7 = conversions.lab;
	var conversions_8 = conversions.lch;
	var conversions_9 = conversions.hex;
	var conversions_10 = conversions.keyword;
	var conversions_11 = conversions.ansi16;
	var conversions_12 = conversions.ansi256;
	var conversions_13 = conversions.hcg;
	var conversions_14 = conversions.apple;
	var conversions_15 = conversions.gray;

	var conversions$1 = /*#__PURE__*/Object.freeze({
		default: conversions,
		__moduleExports: conversions,
		rgb: conversions_1,
		hsl: conversions_2,
		hsv: conversions_3,
		hwb: conversions_4,
		cmyk: conversions_5,
		xyz: conversions_6,
		lab: conversions_7,
		lch: conversions_8,
		hex: conversions_9,
		keyword: conversions_10,
		ansi16: conversions_11,
		ansi256: conversions_12,
		hcg: conversions_13,
		apple: conversions_14,
		gray: conversions_15
	});

	var conversions$2 = ( conversions$1 && conversions ) || conversions$1;

	/*
		this function routes a model to all other models.

		all functions that are routed have a property `.conversion` attached
		to the returned synthetic function. This property is an array
		of strings, each with the steps in between the 'from' and 'to'
		color models (inclusive).

		conversions that are not possible simply are not included.
	*/

	function buildGraph() {
		var graph = {};
		// https://jsperf.com/object-keys-vs-for-in-with-closure/3
		var models = Object.keys(conversions$2);

		for (var len = models.length, i = 0; i < len; i++) {
			graph[models[i]] = {
				// http://jsperf.com/1-vs-infinity
				// micro-opt, but this is simple.
				distance: -1,
				parent: null
			};
		}

		return graph;
	}

	// https://en.wikipedia.org/wiki/Breadth-first_search
	function deriveBFS(fromModel) {
		var graph = buildGraph();
		var queue = [fromModel]; // unshift -> queue -> pop

		graph[fromModel].distance = 0;

		while (queue.length) {
			var current = queue.pop();
			var adjacents = Object.keys(conversions$2[current]);

			for (var len = adjacents.length, i = 0; i < len; i++) {
				var adjacent = adjacents[i];
				var node = graph[adjacent];

				if (node.distance === -1) {
					node.distance = graph[current].distance + 1;
					node.parent = current;
					queue.unshift(adjacent);
				}
			}
		}

		return graph;
	}

	function link(from, to) {
		return function (args) {
			return to(from(args));
		};
	}

	function wrapConversion(toModel, graph) {
		var path = [graph[toModel].parent, toModel];
		var fn = conversions$2[graph[toModel].parent][toModel];

		var cur = graph[toModel].parent;
		while (graph[cur].parent) {
			path.unshift(graph[cur].parent);
			fn = link(conversions$2[graph[cur].parent][cur], fn);
			cur = graph[cur].parent;
		}

		fn.conversion = path;
		return fn;
	}

	var route = function (fromModel) {
		var graph = deriveBFS(fromModel);
		var conversion = {};

		var models = Object.keys(graph);
		for (var len = models.length, i = 0; i < len; i++) {
			var toModel = models[i];
			var node = graph[toModel];

			if (node.parent === null) {
				// no possible conversion, or this node is the source model.
				continue;
			}

			conversion[toModel] = wrapConversion(toModel, graph);
		}

		return conversion;
	};

	var route$1 = /*#__PURE__*/Object.freeze({
		default: route,
		__moduleExports: route
	});

	var route$2 = ( route$1 && route ) || route$1;

	var convert = {};

	var models = Object.keys(conversions$2);

	function wrapRaw(fn) {
		var wrappedFn = function (args) {
			if (args === undefined || args === null) {
				return args;
			}

			if (arguments.length > 1) {
				args = Array.prototype.slice.call(arguments);
			}

			return fn(args);
		};

		// preserve .conversion property if there is one
		if ('conversion' in fn) {
			wrappedFn.conversion = fn.conversion;
		}

		return wrappedFn;
	}

	function wrapRounded(fn) {
		var wrappedFn = function (args) {
			if (args === undefined || args === null) {
				return args;
			}

			if (arguments.length > 1) {
				args = Array.prototype.slice.call(arguments);
			}

			var result = fn(args);

			// we're assuming the result is an array here.
			// see notice in conversions.js; don't use box types
			// in conversion functions.
			if (typeof result === 'object') {
				for (var len = result.length, i = 0; i < len; i++) {
					result[i] = Math.round(result[i]);
				}
			}

			return result;
		};

		// preserve .conversion property if there is one
		if ('conversion' in fn) {
			wrappedFn.conversion = fn.conversion;
		}

		return wrappedFn;
	}

	models.forEach(function (fromModel) {
		convert[fromModel] = {};

		Object.defineProperty(convert[fromModel], 'channels', {value: conversions$2[fromModel].channels});
		Object.defineProperty(convert[fromModel], 'labels', {value: conversions$2[fromModel].labels});

		var routes = route$2(fromModel);
		var routeModels = Object.keys(routes);

		routeModels.forEach(function (toModel) {
			var fn = routes[toModel];

			convert[fromModel][toModel] = wrapRounded(fn);
			convert[fromModel][toModel].raw = wrapRaw(fn);
		});
	});

	var colorConvert = convert;

	var colorConvert$1 = /*#__PURE__*/Object.freeze({
		default: colorConvert,
		__moduleExports: colorConvert
	});

	var colorName$2 = {
		"aliceblue": [240, 248, 255],
		"antiquewhite": [250, 235, 215],
		"aqua": [0, 255, 255],
		"aquamarine": [127, 255, 212],
		"azure": [240, 255, 255],
		"beige": [245, 245, 220],
		"bisque": [255, 228, 196],
		"black": [0, 0, 0],
		"blanchedalmond": [255, 235, 205],
		"blue": [0, 0, 255],
		"blueviolet": [138, 43, 226],
		"brown": [165, 42, 42],
		"burlywood": [222, 184, 135],
		"cadetblue": [95, 158, 160],
		"chartreuse": [127, 255, 0],
		"chocolate": [210, 105, 30],
		"coral": [255, 127, 80],
		"cornflowerblue": [100, 149, 237],
		"cornsilk": [255, 248, 220],
		"crimson": [220, 20, 60],
		"cyan": [0, 255, 255],
		"darkblue": [0, 0, 139],
		"darkcyan": [0, 139, 139],
		"darkgoldenrod": [184, 134, 11],
		"darkgray": [169, 169, 169],
		"darkgreen": [0, 100, 0],
		"darkgrey": [169, 169, 169],
		"darkkhaki": [189, 183, 107],
		"darkmagenta": [139, 0, 139],
		"darkolivegreen": [85, 107, 47],
		"darkorange": [255, 140, 0],
		"darkorchid": [153, 50, 204],
		"darkred": [139, 0, 0],
		"darksalmon": [233, 150, 122],
		"darkseagreen": [143, 188, 143],
		"darkslateblue": [72, 61, 139],
		"darkslategray": [47, 79, 79],
		"darkslategrey": [47, 79, 79],
		"darkturquoise": [0, 206, 209],
		"darkviolet": [148, 0, 211],
		"deeppink": [255, 20, 147],
		"deepskyblue": [0, 191, 255],
		"dimgray": [105, 105, 105],
		"dimgrey": [105, 105, 105],
		"dodgerblue": [30, 144, 255],
		"firebrick": [178, 34, 34],
		"floralwhite": [255, 250, 240],
		"forestgreen": [34, 139, 34],
		"fuchsia": [255, 0, 255],
		"gainsboro": [220, 220, 220],
		"ghostwhite": [248, 248, 255],
		"gold": [255, 215, 0],
		"goldenrod": [218, 165, 32],
		"gray": [128, 128, 128],
		"green": [0, 128, 0],
		"greenyellow": [173, 255, 47],
		"grey": [128, 128, 128],
		"honeydew": [240, 255, 240],
		"hotpink": [255, 105, 180],
		"indianred": [205, 92, 92],
		"indigo": [75, 0, 130],
		"ivory": [255, 255, 240],
		"khaki": [240, 230, 140],
		"lavender": [230, 230, 250],
		"lavenderblush": [255, 240, 245],
		"lawngreen": [124, 252, 0],
		"lemonchiffon": [255, 250, 205],
		"lightblue": [173, 216, 230],
		"lightcoral": [240, 128, 128],
		"lightcyan": [224, 255, 255],
		"lightgoldenrodyellow": [250, 250, 210],
		"lightgray": [211, 211, 211],
		"lightgreen": [144, 238, 144],
		"lightgrey": [211, 211, 211],
		"lightpink": [255, 182, 193],
		"lightsalmon": [255, 160, 122],
		"lightseagreen": [32, 178, 170],
		"lightskyblue": [135, 206, 250],
		"lightslategray": [119, 136, 153],
		"lightslategrey": [119, 136, 153],
		"lightsteelblue": [176, 196, 222],
		"lightyellow": [255, 255, 224],
		"lime": [0, 255, 0],
		"limegreen": [50, 205, 50],
		"linen": [250, 240, 230],
		"magenta": [255, 0, 255],
		"maroon": [128, 0, 0],
		"mediumaquamarine": [102, 205, 170],
		"mediumblue": [0, 0, 205],
		"mediumorchid": [186, 85, 211],
		"mediumpurple": [147, 112, 219],
		"mediumseagreen": [60, 179, 113],
		"mediumslateblue": [123, 104, 238],
		"mediumspringgreen": [0, 250, 154],
		"mediumturquoise": [72, 209, 204],
		"mediumvioletred": [199, 21, 133],
		"midnightblue": [25, 25, 112],
		"mintcream": [245, 255, 250],
		"mistyrose": [255, 228, 225],
		"moccasin": [255, 228, 181],
		"navajowhite": [255, 222, 173],
		"navy": [0, 0, 128],
		"oldlace": [253, 245, 230],
		"olive": [128, 128, 0],
		"olivedrab": [107, 142, 35],
		"orange": [255, 165, 0],
		"orangered": [255, 69, 0],
		"orchid": [218, 112, 214],
		"palegoldenrod": [238, 232, 170],
		"palegreen": [152, 251, 152],
		"paleturquoise": [175, 238, 238],
		"palevioletred": [219, 112, 147],
		"papayawhip": [255, 239, 213],
		"peachpuff": [255, 218, 185],
		"peru": [205, 133, 63],
		"pink": [255, 192, 203],
		"plum": [221, 160, 221],
		"powderblue": [176, 224, 230],
		"purple": [128, 0, 128],
		"rebeccapurple": [102, 51, 153],
		"red": [255, 0, 0],
		"rosybrown": [188, 143, 143],
		"royalblue": [65, 105, 225],
		"saddlebrown": [139, 69, 19],
		"salmon": [250, 128, 114],
		"sandybrown": [244, 164, 96],
		"seagreen": [46, 139, 87],
		"seashell": [255, 245, 238],
		"sienna": [160, 82, 45],
		"silver": [192, 192, 192],
		"skyblue": [135, 206, 235],
		"slateblue": [106, 90, 205],
		"slategray": [112, 128, 144],
		"slategrey": [112, 128, 144],
		"snow": [255, 250, 250],
		"springgreen": [0, 255, 127],
		"steelblue": [70, 130, 180],
		"tan": [210, 180, 140],
		"teal": [0, 128, 128],
		"thistle": [216, 191, 216],
		"tomato": [255, 99, 71],
		"turquoise": [64, 224, 208],
		"violet": [238, 130, 238],
		"wheat": [245, 222, 179],
		"white": [255, 255, 255],
		"whitesmoke": [245, 245, 245],
		"yellow": [255, 255, 0],
		"yellowgreen": [154, 205, 50]
	};

	var colorName$3 = /*#__PURE__*/Object.freeze({
		default: colorName$2,
		__moduleExports: colorName$2
	});

	var colorNames = ( colorName$3 && colorName$2 ) || colorName$3;

	/* MIT license */


	var colorString = {
	   getRgba: getRgba,
	   getHsla: getHsla,
	   getRgb: getRgb,
	   getHsl: getHsl,
	   getHwb: getHwb,
	   getAlpha: getAlpha,

	   hexString: hexString,
	   rgbString: rgbString,
	   rgbaString: rgbaString,
	   percentString: percentString,
	   percentaString: percentaString,
	   hslString: hslString,
	   hslaString: hslaString,
	   hwbString: hwbString,
	   keyword: keyword
	};

	function getRgba(string) {
	   if (!string) {
	      return;
	   }
	   var abbr =  /^#([a-fA-F0-9]{3,4})$/i,
	       hex =  /^#([a-fA-F0-9]{6}([a-fA-F0-9]{2})?)$/i,
	       rgba = /^rgba?\(\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/i,
	       per = /^rgba?\(\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/i,
	       keyword = /(\w+)/;

	   var rgb = [0, 0, 0],
	       a = 1,
	       match = string.match(abbr),
	       hexAlpha = "";
	   if (match) {
	      match = match[1];
	      hexAlpha = match[3];
	      for (var i = 0; i < rgb.length; i++) {
	         rgb[i] = parseInt(match[i] + match[i], 16);
	      }
	      if (hexAlpha) {
	         a = Math.round((parseInt(hexAlpha + hexAlpha, 16) / 255) * 100) / 100;
	      }
	   }
	   else if (match = string.match(hex)) {
	      hexAlpha = match[2];
	      match = match[1];
	      for (var i = 0; i < rgb.length; i++) {
	         rgb[i] = parseInt(match.slice(i * 2, i * 2 + 2), 16);
	      }
	      if (hexAlpha) {
	         a = Math.round((parseInt(hexAlpha, 16) / 255) * 100) / 100;
	      }
	   }
	   else if (match = string.match(rgba)) {
	      for (var i = 0; i < rgb.length; i++) {
	         rgb[i] = parseInt(match[i + 1]);
	      }
	      a = parseFloat(match[4]);
	   }
	   else if (match = string.match(per)) {
	      for (var i = 0; i < rgb.length; i++) {
	         rgb[i] = Math.round(parseFloat(match[i + 1]) * 2.55);
	      }
	      a = parseFloat(match[4]);
	   }
	   else if (match = string.match(keyword)) {
	      if (match[1] == "transparent") {
	         return [0, 0, 0, 0];
	      }
	      rgb = colorNames[match[1]];
	      if (!rgb) {
	         return;
	      }
	   }

	   for (var i = 0; i < rgb.length; i++) {
	      rgb[i] = scale(rgb[i], 0, 255);
	   }
	   if (!a && a != 0) {
	      a = 1;
	   }
	   else {
	      a = scale(a, 0, 1);
	   }
	   rgb[3] = a;
	   return rgb;
	}

	function getHsla(string) {
	   if (!string) {
	      return;
	   }
	   var hsl = /^hsla?\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/;
	   var match = string.match(hsl);
	   if (match) {
	      var alpha = parseFloat(match[4]);
	      var h = scale(parseInt(match[1]), 0, 360),
	          s = scale(parseFloat(match[2]), 0, 100),
	          l = scale(parseFloat(match[3]), 0, 100),
	          a = scale(isNaN(alpha) ? 1 : alpha, 0, 1);
	      return [h, s, l, a];
	   }
	}

	function getHwb(string) {
	   if (!string) {
	      return;
	   }
	   var hwb = /^hwb\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/;
	   var match = string.match(hwb);
	   if (match) {
	    var alpha = parseFloat(match[4]);
	      var h = scale(parseInt(match[1]), 0, 360),
	          w = scale(parseFloat(match[2]), 0, 100),
	          b = scale(parseFloat(match[3]), 0, 100),
	          a = scale(isNaN(alpha) ? 1 : alpha, 0, 1);
	      return [h, w, b, a];
	   }
	}

	function getRgb(string) {
	   var rgba = getRgba(string);
	   return rgba && rgba.slice(0, 3);
	}

	function getHsl(string) {
	  var hsla = getHsla(string);
	  return hsla && hsla.slice(0, 3);
	}

	function getAlpha(string) {
	   var vals = getRgba(string);
	   if (vals) {
	      return vals[3];
	   }
	   else if (vals = getHsla(string)) {
	      return vals[3];
	   }
	   else if (vals = getHwb(string)) {
	      return vals[3];
	   }
	}

	// generators
	function hexString(rgba, a) {
	   var a = (a !== undefined && rgba.length === 3) ? a : rgba[3];
	   return "#" + hexDouble(rgba[0]) 
	              + hexDouble(rgba[1])
	              + hexDouble(rgba[2])
	              + (
	                 (a >= 0 && a < 1)
	                 ? hexDouble(Math.round(a * 255))
	                 : ""
	              );
	}

	function rgbString(rgba, alpha) {
	   if (alpha < 1 || (rgba[3] && rgba[3] < 1)) {
	      return rgbaString(rgba, alpha);
	   }
	   return "rgb(" + rgba[0] + ", " + rgba[1] + ", " + rgba[2] + ")";
	}

	function rgbaString(rgba, alpha) {
	   if (alpha === undefined) {
	      alpha = (rgba[3] !== undefined ? rgba[3] : 1);
	   }
	   return "rgba(" + rgba[0] + ", " + rgba[1] + ", " + rgba[2]
	           + ", " + alpha + ")";
	}

	function percentString(rgba, alpha) {
	   if (alpha < 1 || (rgba[3] && rgba[3] < 1)) {
	      return percentaString(rgba, alpha);
	   }
	   var r = Math.round(rgba[0]/255 * 100),
	       g = Math.round(rgba[1]/255 * 100),
	       b = Math.round(rgba[2]/255 * 100);

	   return "rgb(" + r + "%, " + g + "%, " + b + "%)";
	}

	function percentaString(rgba, alpha) {
	   var r = Math.round(rgba[0]/255 * 100),
	       g = Math.round(rgba[1]/255 * 100),
	       b = Math.round(rgba[2]/255 * 100);
	   return "rgba(" + r + "%, " + g + "%, " + b + "%, " + (alpha || rgba[3] || 1) + ")";
	}

	function hslString(hsla, alpha) {
	   if (alpha < 1 || (hsla[3] && hsla[3] < 1)) {
	      return hslaString(hsla, alpha);
	   }
	   return "hsl(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%)";
	}

	function hslaString(hsla, alpha) {
	   if (alpha === undefined) {
	      alpha = (hsla[3] !== undefined ? hsla[3] : 1);
	   }
	   return "hsla(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%, "
	           + alpha + ")";
	}

	// hwb is a bit different than rgb(a) & hsl(a) since there is no alpha specific syntax
	// (hwb have alpha optional & 1 is default value)
	function hwbString(hwb, alpha) {
	   if (alpha === undefined) {
	      alpha = (hwb[3] !== undefined ? hwb[3] : 1);
	   }
	   return "hwb(" + hwb[0] + ", " + hwb[1] + "%, " + hwb[2] + "%"
	           + (alpha !== undefined && alpha !== 1 ? ", " + alpha : "") + ")";
	}

	function keyword(rgb) {
	  return reverseNames[rgb.slice(0, 3)];
	}

	// helpers
	function scale(num, min, max) {
	   return Math.min(Math.max(min, num), max);
	}

	function hexDouble(num) {
	  var str = num.toString(16).toUpperCase();
	  return (str.length < 2) ? "0" + str : str;
	}


	//create a list of reverse color names
	var reverseNames = {};
	for (var name in colorNames) {
	   reverseNames[colorNames[name]] = name;
	}
	var colorString_1 = colorString.getRgba;
	var colorString_2 = colorString.getHsla;
	var colorString_3 = colorString.getRgb;
	var colorString_4 = colorString.getHsl;
	var colorString_5 = colorString.getHwb;
	var colorString_6 = colorString.getAlpha;
	var colorString_7 = colorString.hexString;
	var colorString_8 = colorString.rgbString;
	var colorString_9 = colorString.rgbaString;
	var colorString_10 = colorString.percentString;
	var colorString_11 = colorString.percentaString;
	var colorString_12 = colorString.hslString;
	var colorString_13 = colorString.hslaString;
	var colorString_14 = colorString.hwbString;
	var colorString_15 = colorString.keyword;

	var colorString$1 = /*#__PURE__*/Object.freeze({
		default: colorString,
		__moduleExports: colorString,
		getRgba: colorString_1,
		getHsla: colorString_2,
		getRgb: colorString_3,
		getHsl: colorString_4,
		getHwb: colorString_5,
		getAlpha: colorString_6,
		hexString: colorString_7,
		rgbString: colorString_8,
		rgbaString: colorString_9,
		percentString: colorString_10,
		percentaString: colorString_11,
		hslString: colorString_12,
		hslaString: colorString_13,
		hwbString: colorString_14,
		keyword: colorString_15
	});

	var convert$1 = ( colorConvert$1 && colorConvert ) || colorConvert$1;

	var string = ( colorString$1 && colorString ) || colorString$1;

	/* MIT license */



	var Color = function (obj) {
		if (obj instanceof Color) {
			return obj;
		}
		if (!(this instanceof Color)) {
			return new Color(obj);
		}

		this.valid = false;
		this.values = {
			rgb: [0, 0, 0],
			hsl: [0, 0, 0],
			hsv: [0, 0, 0],
			hwb: [0, 0, 0],
			cmyk: [0, 0, 0, 0],
			alpha: 1
		};

		// parse Color() argument
		var vals;
		if (typeof obj === 'string') {
			vals = string.getRgba(obj);
			if (vals) {
				this.setValues('rgb', vals);
			} else if (vals = string.getHsla(obj)) {
				this.setValues('hsl', vals);
			} else if (vals = string.getHwb(obj)) {
				this.setValues('hwb', vals);
			}
		} else if (typeof obj === 'object') {
			vals = obj;
			if (vals.r !== undefined || vals.red !== undefined) {
				this.setValues('rgb', vals);
			} else if (vals.l !== undefined || vals.lightness !== undefined) {
				this.setValues('hsl', vals);
			} else if (vals.v !== undefined || vals.value !== undefined) {
				this.setValues('hsv', vals);
			} else if (vals.w !== undefined || vals.whiteness !== undefined) {
				this.setValues('hwb', vals);
			} else if (vals.c !== undefined || vals.cyan !== undefined) {
				this.setValues('cmyk', vals);
			}
		}
	};

	Color.prototype = {
		isValid: function () {
			return this.valid;
		},
		rgb: function () {
			return this.setSpace('rgb', arguments);
		},
		hsl: function () {
			return this.setSpace('hsl', arguments);
		},
		hsv: function () {
			return this.setSpace('hsv', arguments);
		},
		hwb: function () {
			return this.setSpace('hwb', arguments);
		},
		cmyk: function () {
			return this.setSpace('cmyk', arguments);
		},

		rgbArray: function () {
			return this.values.rgb;
		},
		hslArray: function () {
			return this.values.hsl;
		},
		hsvArray: function () {
			return this.values.hsv;
		},
		hwbArray: function () {
			var values = this.values;
			if (values.alpha !== 1) {
				return values.hwb.concat([values.alpha]);
			}
			return values.hwb;
		},
		cmykArray: function () {
			return this.values.cmyk;
		},
		rgbaArray: function () {
			var values = this.values;
			return values.rgb.concat([values.alpha]);
		},
		hslaArray: function () {
			var values = this.values;
			return values.hsl.concat([values.alpha]);
		},
		alpha: function (val) {
			if (val === undefined) {
				return this.values.alpha;
			}
			this.setValues('alpha', val);
			return this;
		},

		red: function (val) {
			return this.setChannel('rgb', 0, val);
		},
		green: function (val) {
			return this.setChannel('rgb', 1, val);
		},
		blue: function (val) {
			return this.setChannel('rgb', 2, val);
		},
		hue: function (val) {
			if (val) {
				val %= 360;
				val = val < 0 ? 360 + val : val;
			}
			return this.setChannel('hsl', 0, val);
		},
		saturation: function (val) {
			return this.setChannel('hsl', 1, val);
		},
		lightness: function (val) {
			return this.setChannel('hsl', 2, val);
		},
		saturationv: function (val) {
			return this.setChannel('hsv', 1, val);
		},
		whiteness: function (val) {
			return this.setChannel('hwb', 1, val);
		},
		blackness: function (val) {
			return this.setChannel('hwb', 2, val);
		},
		value: function (val) {
			return this.setChannel('hsv', 2, val);
		},
		cyan: function (val) {
			return this.setChannel('cmyk', 0, val);
		},
		magenta: function (val) {
			return this.setChannel('cmyk', 1, val);
		},
		yellow: function (val) {
			return this.setChannel('cmyk', 2, val);
		},
		black: function (val) {
			return this.setChannel('cmyk', 3, val);
		},

		hexString: function () {
			return string.hexString(this.values.rgb);
		},
		rgbString: function () {
			return string.rgbString(this.values.rgb, this.values.alpha);
		},
		rgbaString: function () {
			return string.rgbaString(this.values.rgb, this.values.alpha);
		},
		percentString: function () {
			return string.percentString(this.values.rgb, this.values.alpha);
		},
		hslString: function () {
			return string.hslString(this.values.hsl, this.values.alpha);
		},
		hslaString: function () {
			return string.hslaString(this.values.hsl, this.values.alpha);
		},
		hwbString: function () {
			return string.hwbString(this.values.hwb, this.values.alpha);
		},
		keyword: function () {
			return string.keyword(this.values.rgb, this.values.alpha);
		},

		rgbNumber: function () {
			var rgb = this.values.rgb;
			return (rgb[0] << 16) | (rgb[1] << 8) | rgb[2];
		},

		luminosity: function () {
			// http://www.w3.org/TR/WCAG20/#relativeluminancedef
			var rgb = this.values.rgb;
			var lum = [];
			for (var i = 0; i < rgb.length; i++) {
				var chan = rgb[i] / 255;
				lum[i] = (chan <= 0.03928) ? chan / 12.92 : Math.pow(((chan + 0.055) / 1.055), 2.4);
			}
			return 0.2126 * lum[0] + 0.7152 * lum[1] + 0.0722 * lum[2];
		},

		contrast: function (color2) {
			// http://www.w3.org/TR/WCAG20/#contrast-ratiodef
			var lum1 = this.luminosity();
			var lum2 = color2.luminosity();
			if (lum1 > lum2) {
				return (lum1 + 0.05) / (lum2 + 0.05);
			}
			return (lum2 + 0.05) / (lum1 + 0.05);
		},

		level: function (color2) {
			var contrastRatio = this.contrast(color2);
			if (contrastRatio >= 7.1) {
				return 'AAA';
			}

			return (contrastRatio >= 4.5) ? 'AA' : '';
		},

		dark: function () {
			// YIQ equation from http://24ways.org/2010/calculating-color-contrast
			var rgb = this.values.rgb;
			var yiq = (rgb[0] * 299 + rgb[1] * 587 + rgb[2] * 114) / 1000;
			return yiq < 128;
		},

		light: function () {
			return !this.dark();
		},

		negate: function () {
			var this$1 = this;

			var rgb = [];
			for (var i = 0; i < 3; i++) {
				rgb[i] = 255 - this$1.values.rgb[i];
			}
			this.setValues('rgb', rgb);
			return this;
		},

		lighten: function (ratio) {
			var hsl = this.values.hsl;
			hsl[2] += hsl[2] * ratio;
			this.setValues('hsl', hsl);
			return this;
		},

		darken: function (ratio) {
			var hsl = this.values.hsl;
			hsl[2] -= hsl[2] * ratio;
			this.setValues('hsl', hsl);
			return this;
		},

		saturate: function (ratio) {
			var hsl = this.values.hsl;
			hsl[1] += hsl[1] * ratio;
			this.setValues('hsl', hsl);
			return this;
		},

		desaturate: function (ratio) {
			var hsl = this.values.hsl;
			hsl[1] -= hsl[1] * ratio;
			this.setValues('hsl', hsl);
			return this;
		},

		whiten: function (ratio) {
			var hwb = this.values.hwb;
			hwb[1] += hwb[1] * ratio;
			this.setValues('hwb', hwb);
			return this;
		},

		blacken: function (ratio) {
			var hwb = this.values.hwb;
			hwb[2] += hwb[2] * ratio;
			this.setValues('hwb', hwb);
			return this;
		},

		greyscale: function () {
			var rgb = this.values.rgb;
			// http://en.wikipedia.org/wiki/Grayscale#Converting_color_to_grayscale
			var val = rgb[0] * 0.3 + rgb[1] * 0.59 + rgb[2] * 0.11;
			this.setValues('rgb', [val, val, val]);
			return this;
		},

		clearer: function (ratio) {
			var alpha = this.values.alpha;
			this.setValues('alpha', alpha - (alpha * ratio));
			return this;
		},

		opaquer: function (ratio) {
			var alpha = this.values.alpha;
			this.setValues('alpha', alpha + (alpha * ratio));
			return this;
		},

		rotate: function (degrees) {
			var hsl = this.values.hsl;
			var hue = (hsl[0] + degrees) % 360;
			hsl[0] = hue < 0 ? 360 + hue : hue;
			this.setValues('hsl', hsl);
			return this;
		},

		/**
		 * Ported from sass implementation in C
		 * https://github.com/sass/libsass/blob/0e6b4a2850092356aa3ece07c6b249f0221caced/functions.cpp#L209
		 */
		mix: function (mixinColor, weight) {
			var color1 = this;
			var color2 = mixinColor;
			var p = weight === undefined ? 0.5 : weight;

			var w = 2 * p - 1;
			var a = color1.alpha() - color2.alpha();

			var w1 = (((w * a === -1) ? w : (w + a) / (1 + w * a)) + 1) / 2.0;
			var w2 = 1 - w1;

			return this
				.rgb(
					w1 * color1.red() + w2 * color2.red(),
					w1 * color1.green() + w2 * color2.green(),
					w1 * color1.blue() + w2 * color2.blue()
				)
				.alpha(color1.alpha() * p + color2.alpha() * (1 - p));
		},

		toJSON: function () {
			return this.rgb();
		},

		clone: function () {
			// NOTE(SB): using node-clone creates a dependency to Buffer when using browserify,
			// making the final build way to big to embed in Chart.js. So let's do it manually,
			// assuming that values to clone are 1 dimension arrays containing only numbers,
			// except 'alpha' which is a number.
			var result = new Color();
			var source = this.values;
			var target = result.values;
			var value, type;

			for (var prop in source) {
				if (source.hasOwnProperty(prop)) {
					value = source[prop];
					type = ({}).toString.call(value);
					if (type === '[object Array]') {
						target[prop] = value.slice(0);
					} else if (type === '[object Number]') {
						target[prop] = value;
					} else {
						console.error('unexpected color value:', value);
					}
				}
			}

			return result;
		}
	};

	Color.prototype.spaces = {
		rgb: ['red', 'green', 'blue'],
		hsl: ['hue', 'saturation', 'lightness'],
		hsv: ['hue', 'saturation', 'value'],
		hwb: ['hue', 'whiteness', 'blackness'],
		cmyk: ['cyan', 'magenta', 'yellow', 'black']
	};

	Color.prototype.maxes = {
		rgb: [255, 255, 255],
		hsl: [360, 100, 100],
		hsv: [360, 100, 100],
		hwb: [360, 100, 100],
		cmyk: [100, 100, 100, 100]
	};

	Color.prototype.getValues = function (space) {
		var values = this.values;
		var vals = {};

		for (var i = 0; i < space.length; i++) {
			vals[space.charAt(i)] = values[space][i];
		}

		if (values.alpha !== 1) {
			vals.a = values.alpha;
		}

		// {r: 255, g: 255, b: 255, a: 0.4}
		return vals;
	};

	Color.prototype.setValues = function (space, vals) {
		var values = this.values;
		var spaces = this.spaces;
		var maxes = this.maxes;
		var alpha = 1;
		var i;

		this.valid = true;

		if (space === 'alpha') {
			alpha = vals;
		} else if (vals.length) {
			// [10, 10, 10]
			values[space] = vals.slice(0, space.length);
			alpha = vals[space.length];
		} else if (vals[space.charAt(0)] !== undefined) {
			// {r: 10, g: 10, b: 10}
			for (i = 0; i < space.length; i++) {
				values[space][i] = vals[space.charAt(i)];
			}

			alpha = vals.a;
		} else if (vals[spaces[space][0]] !== undefined) {
			// {red: 10, green: 10, blue: 10}
			var chans = spaces[space];

			for (i = 0; i < space.length; i++) {
				values[space][i] = vals[chans[i]];
			}

			alpha = vals.alpha;
		}

		values.alpha = Math.max(0, Math.min(1, (alpha === undefined ? values.alpha : alpha)));

		if (space === 'alpha') {
			return false;
		}

		var capped;

		// cap values of the space prior converting all values
		for (i = 0; i < space.length; i++) {
			capped = Math.max(0, Math.min(maxes[space][i], values[space][i]));
			values[space][i] = Math.round(capped);
		}

		// convert to all the other color spaces
		for (var sname in spaces) {
			if (sname !== space) {
				values[sname] = convert$1[space][sname](values[space]);
			}
		}

		return true;
	};

	Color.prototype.setSpace = function (space, args) {
		var vals = args[0];

		if (vals === undefined) {
			// color.rgb()
			return this.getValues(space);
		}

		// color.rgb(10, 10, 10)
		if (typeof vals === 'number') {
			vals = Array.prototype.slice.call(args);
		}

		this.setValues(space, vals);
		return this;
	};

	Color.prototype.setChannel = function (space, index, val) {
		var svalues = this.values[space];
		if (val === undefined) {
			// color.red()
			return svalues[index];
		} else if (val === svalues[index]) {
			// color.red(color.red())
			return this;
		}

		// color.red(100)
		svalues[index] = val;
		this.setValues(space, svalues);

		return this;
	};

	if (typeof window !== 'undefined') {
		window.Color = Color;
	}

	var chartjsColor = Color;

	var chartjsColor$1 = /*#__PURE__*/Object.freeze({
		default: chartjsColor,
		__moduleExports: chartjsColor
	});

	function filterByPosition(array, position) {
		return helpers$4.where(array, function(v) {
			return v.position === position;
		});
	}

	function sortByWeight(array, reverse) {
		array.forEach(function(v, i) {
			v._tmpIndex_ = i;
			return v;
		});
		array.sort(function(a, b) {
			var v0 = reverse ? b : a;
			var v1 = reverse ? a : b;
			return v0.weight === v1.weight ?
				v0._tmpIndex_ - v1._tmpIndex_ :
				v0.weight - v1.weight;
		});
		array.forEach(function(v) {
			delete v._tmpIndex_;
		});
	}

	/**
	 * @interface ILayoutItem
	 * @prop {String} position - The position of the item in the chart layout. Possible values are
	 * 'left', 'top', 'right', 'bottom', and 'chartArea'
	 * @prop {Number} weight - The weight used to sort the item. Higher weights are further away from the chart area
	 * @prop {Boolean} fullWidth - if true, and the item is horizontal, then push vertical boxes down
	 * @prop {Function} isHorizontal - returns true if the layout item is horizontal (ie. top or bottom)
	 * @prop {Function} update - Takes two parameters: width and height. Returns size of item
	 * @prop {Function} getPadding -  Returns an object with padding on the edges
	 * @prop {Number} width - Width of item. Must be valid after update()
	 * @prop {Number} height - Height of item. Must be valid after update()
	 * @prop {Number} left - Left edge of the item. Set by layout system and cannot be used in update
	 * @prop {Number} top - Top edge of the item. Set by layout system and cannot be used in update
	 * @prop {Number} right - Right edge of the item. Set by layout system and cannot be used in update
	 * @prop {Number} bottom - Bottom edge of the item. Set by layout system and cannot be used in update
	 */

	// The layout service is very self explanatory.  It's responsible for the layout within a chart.
	// Scales, Legends and Plugins all rely on the layout service and can easily register to be placed anywhere they need
	// It is this service's responsibility of carrying out that layout.
	var core_layouts = {
		defaults: {},

		/**
		 * Register a box to a chart.
		 * A box is simply a reference to an object that requires layout. eg. Scales, Legend, Title.
		 * @param {Chart} chart - the chart to use
		 * @param {ILayoutItem} item - the item to add to be layed out
		 */
		addBox: function(chart, item) {
			if (!chart.boxes) {
				chart.boxes = [];
			}

			// initialize item with default values
			item.fullWidth = item.fullWidth || false;
			item.position = item.position || 'top';
			item.weight = item.weight || 0;

			chart.boxes.push(item);
		},

		/**
		 * Remove a layoutItem from a chart
		 * @param {Chart} chart - the chart to remove the box from
		 * @param {Object} layoutItem - the item to remove from the layout
		 */
		removeBox: function(chart, layoutItem) {
			var index = chart.boxes ? chart.boxes.indexOf(layoutItem) : -1;
			if (index !== -1) {
				chart.boxes.splice(index, 1);
			}
		},

		/**
		 * Sets (or updates) options on the given `item`.
		 * @param {Chart} chart - the chart in which the item lives (or will be added to)
		 * @param {Object} item - the item to configure with the given options
		 * @param {Object} options - the new item options.
		 */
		configure: function(chart, item, options) {
			var props = ['fullWidth', 'position', 'weight'];
			var ilen = props.length;
			var i = 0;
			var prop;

			for (; i < ilen; ++i) {
				prop = props[i];
				if (options.hasOwnProperty(prop)) {
					item[prop] = options[prop];
				}
			}
		},

		/**
		 * Fits boxes of the given chart into the given size by having each box measure itself
		 * then running a fitting algorithm
		 * @param {Chart} chart - the chart
		 * @param {Number} width - the width to fit into
		 * @param {Number} height - the height to fit into
		 */
		update: function(chart, width, height) {
			if (!chart) {
				return;
			}

			var layoutOptions = chart.options.layout || {};
			var padding = helpers$4.options.toPadding(layoutOptions.padding);
			var leftPadding = padding.left;
			var rightPadding = padding.right;
			var topPadding = padding.top;
			var bottomPadding = padding.bottom;

			var leftBoxes = filterByPosition(chart.boxes, 'left');
			var rightBoxes = filterByPosition(chart.boxes, 'right');
			var topBoxes = filterByPosition(chart.boxes, 'top');
			var bottomBoxes = filterByPosition(chart.boxes, 'bottom');
			var chartAreaBoxes = filterByPosition(chart.boxes, 'chartArea');

			// Sort boxes by weight. A higher weight is further away from the chart area
			sortByWeight(leftBoxes, true);
			sortByWeight(rightBoxes, false);
			sortByWeight(topBoxes, true);
			sortByWeight(bottomBoxes, false);

			// Essentially we now have any number of boxes on each of the 4 sides.
			// Our canvas looks like the following.
			// The areas L1 and L2 are the left axes. R1 is the right axis, T1 is the top axis and
			// B1 is the bottom axis
			// There are also 4 quadrant-like locations (left to right instead of clockwise) reserved for chart overlays
			// These locations are single-box locations only, when trying to register a chartArea location that is already taken,
			// an error will be thrown.
			//
			// |----------------------------------------------------|
			// |                  T1 (Full Width)                   |
			// |----------------------------------------------------|
			// |    |    |                 T2                  |    |
			// |    |----|-------------------------------------|----|
			// |    |    | C1 |                           | C2 |    |
			// |    |    |----|                           |----|    |
			// |    |    |                                     |    |
			// | L1 | L2 |           ChartArea (C0)            | R1 |
			// |    |    |                                     |    |
			// |    |    |----|                           |----|    |
			// |    |    | C3 |                           | C4 |    |
			// |    |----|-------------------------------------|----|
			// |    |    |                 B1                  |    |
			// |----------------------------------------------------|
			// |                  B2 (Full Width)                   |
			// |----------------------------------------------------|
			//
			// What we do to find the best sizing, we do the following
			// 1. Determine the minimum size of the chart area.
			// 2. Split the remaining width equally between each vertical axis
			// 3. Split the remaining height equally between each horizontal axis
			// 4. Give each layout the maximum size it can be. The layout will return it's minimum size
			// 5. Adjust the sizes of each axis based on it's minimum reported size.
			// 6. Refit each axis
			// 7. Position each axis in the final location
			// 8. Tell the chart the final location of the chart area
			// 9. Tell any axes that overlay the chart area the positions of the chart area

			// Step 1
			var chartWidth = width - leftPadding - rightPadding;
			var chartHeight = height - topPadding - bottomPadding;
			var chartAreaWidth = chartWidth / 2; // min 50%
			var chartAreaHeight = chartHeight / 2; // min 50%

			// Step 2
			var verticalBoxWidth = (width - chartAreaWidth) / (leftBoxes.length + rightBoxes.length);

			// Step 3
			var horizontalBoxHeight = (height - chartAreaHeight) / (topBoxes.length + bottomBoxes.length);

			// Step 4
			var maxChartAreaWidth = chartWidth;
			var maxChartAreaHeight = chartHeight;
			var minBoxSizes = [];

			function getMinimumBoxSize(box) {
				var minSize;
				var isHorizontal = box.isHorizontal();

				if (isHorizontal) {
					minSize = box.update(box.fullWidth ? chartWidth : maxChartAreaWidth, horizontalBoxHeight);
					maxChartAreaHeight -= minSize.height;
				} else {
					minSize = box.update(verticalBoxWidth, maxChartAreaHeight);
					maxChartAreaWidth -= minSize.width;
				}

				minBoxSizes.push({
					horizontal: isHorizontal,
					minSize: minSize,
					box: box,
				});
			}

			helpers$4.each(leftBoxes.concat(rightBoxes, topBoxes, bottomBoxes), getMinimumBoxSize);

			// If a horizontal box has padding, we move the left boxes over to avoid ugly charts (see issue #2478)
			var maxHorizontalLeftPadding = 0;
			var maxHorizontalRightPadding = 0;
			var maxVerticalTopPadding = 0;
			var maxVerticalBottomPadding = 0;

			helpers$4.each(topBoxes.concat(bottomBoxes), function(horizontalBox) {
				if (horizontalBox.getPadding) {
					var boxPadding = horizontalBox.getPadding();
					maxHorizontalLeftPadding = Math.max(maxHorizontalLeftPadding, boxPadding.left);
					maxHorizontalRightPadding = Math.max(maxHorizontalRightPadding, boxPadding.right);
				}
			});

			helpers$4.each(leftBoxes.concat(rightBoxes), function(verticalBox) {
				if (verticalBox.getPadding) {
					var boxPadding = verticalBox.getPadding();
					maxVerticalTopPadding = Math.max(maxVerticalTopPadding, boxPadding.top);
					maxVerticalBottomPadding = Math.max(maxVerticalBottomPadding, boxPadding.bottom);
				}
			});

			// At this point, maxChartAreaHeight and maxChartAreaWidth are the size the chart area could
			// be if the axes are drawn at their minimum sizes.
			// Steps 5 & 6
			var totalLeftBoxesWidth = leftPadding;
			var totalRightBoxesWidth = rightPadding;
			var totalTopBoxesHeight = topPadding;
			var totalBottomBoxesHeight = bottomPadding;

			// Function to fit a box
			function fitBox(box) {
				var minBoxSize = helpers$4.findNextWhere(minBoxSizes, function(minBox) {
					return minBox.box === box;
				});

				if (minBoxSize) {
					if (box.isHorizontal()) {
						var scaleMargin = {
							left: Math.max(totalLeftBoxesWidth, maxHorizontalLeftPadding),
							right: Math.max(totalRightBoxesWidth, maxHorizontalRightPadding),
							top: 0,
							bottom: 0
						};

						// Don't use min size here because of label rotation. When the labels are rotated, their rotation highly depends
						// on the margin. Sometimes they need to increase in size slightly
						box.update(box.fullWidth ? chartWidth : maxChartAreaWidth, chartHeight / 2, scaleMargin);
					} else {
						box.update(minBoxSize.minSize.width, maxChartAreaHeight);
					}
				}
			}

			// Update, and calculate the left and right margins for the horizontal boxes
			helpers$4.each(leftBoxes.concat(rightBoxes), fitBox);

			helpers$4.each(leftBoxes, function(box) {
				totalLeftBoxesWidth += box.width;
			});

			helpers$4.each(rightBoxes, function(box) {
				totalRightBoxesWidth += box.width;
			});

			// Set the Left and Right margins for the horizontal boxes
			helpers$4.each(topBoxes.concat(bottomBoxes), fitBox);

			// Figure out how much margin is on the top and bottom of the vertical boxes
			helpers$4.each(topBoxes, function(box) {
				totalTopBoxesHeight += box.height;
			});

			helpers$4.each(bottomBoxes, function(box) {
				totalBottomBoxesHeight += box.height;
			});

			function finalFitVerticalBox(box) {
				var minBoxSize = helpers$4.findNextWhere(minBoxSizes, function(minSize) {
					return minSize.box === box;
				});

				var scaleMargin = {
					left: 0,
					right: 0,
					top: totalTopBoxesHeight,
					bottom: totalBottomBoxesHeight
				};

				if (minBoxSize) {
					box.update(minBoxSize.minSize.width, maxChartAreaHeight, scaleMargin);
				}
			}

			// Let the left layout know the final margin
			helpers$4.each(leftBoxes.concat(rightBoxes), finalFitVerticalBox);

			// Recalculate because the size of each layout might have changed slightly due to the margins (label rotation for instance)
			totalLeftBoxesWidth = leftPadding;
			totalRightBoxesWidth = rightPadding;
			totalTopBoxesHeight = topPadding;
			totalBottomBoxesHeight = bottomPadding;

			helpers$4.each(leftBoxes, function(box) {
				totalLeftBoxesWidth += box.width;
			});

			helpers$4.each(rightBoxes, function(box) {
				totalRightBoxesWidth += box.width;
			});

			helpers$4.each(topBoxes, function(box) {
				totalTopBoxesHeight += box.height;
			});
			helpers$4.each(bottomBoxes, function(box) {
				totalBottomBoxesHeight += box.height;
			});

			// We may be adding some padding to account for rotated x axis labels
			var leftPaddingAddition = Math.max(maxHorizontalLeftPadding - totalLeftBoxesWidth, 0);
			totalLeftBoxesWidth += leftPaddingAddition;
			totalRightBoxesWidth += Math.max(maxHorizontalRightPadding - totalRightBoxesWidth, 0);

			var topPaddingAddition = Math.max(maxVerticalTopPadding - totalTopBoxesHeight, 0);
			totalTopBoxesHeight += topPaddingAddition;
			totalBottomBoxesHeight += Math.max(maxVerticalBottomPadding - totalBottomBoxesHeight, 0);

			// Figure out if our chart area changed. This would occur if the dataset layout label rotation
			// changed due to the application of the margins in step 6. Since we can only get bigger, this is safe to do
			// without calling `fit` again
			var newMaxChartAreaHeight = height - totalTopBoxesHeight - totalBottomBoxesHeight;
			var newMaxChartAreaWidth = width - totalLeftBoxesWidth - totalRightBoxesWidth;

			if (newMaxChartAreaWidth !== maxChartAreaWidth || newMaxChartAreaHeight !== maxChartAreaHeight) {
				helpers$4.each(leftBoxes, function(box) {
					box.height = newMaxChartAreaHeight;
				});

				helpers$4.each(rightBoxes, function(box) {
					box.height = newMaxChartAreaHeight;
				});

				helpers$4.each(topBoxes, function(box) {
					if (!box.fullWidth) {
						box.width = newMaxChartAreaWidth;
					}
				});

				helpers$4.each(bottomBoxes, function(box) {
					if (!box.fullWidth) {
						box.width = newMaxChartAreaWidth;
					}
				});

				maxChartAreaHeight = newMaxChartAreaHeight;
				maxChartAreaWidth = newMaxChartAreaWidth;
			}

			// Step 7 - Position the boxes
			var left = leftPadding + leftPaddingAddition;
			var top = topPadding + topPaddingAddition;

			function placeBox(box) {
				if (box.isHorizontal()) {
					box.left = box.fullWidth ? leftPadding : totalLeftBoxesWidth;
					box.right = box.fullWidth ? width - rightPadding : totalLeftBoxesWidth + maxChartAreaWidth;
					box.top = top;
					box.bottom = top + box.height;

					// Move to next point
					top = box.bottom;

				} else {

					box.left = left;
					box.right = left + box.width;
					box.top = totalTopBoxesHeight;
					box.bottom = totalTopBoxesHeight + maxChartAreaHeight;

					// Move to next point
					left = box.right;
				}
			}

			helpers$4.each(leftBoxes.concat(topBoxes), placeBox);

			// Account for chart width and height
			left += maxChartAreaWidth;
			top += maxChartAreaHeight;

			helpers$4.each(rightBoxes, placeBox);
			helpers$4.each(bottomBoxes, placeBox);

			// Step 8
			chart.chartArea = {
				left: totalLeftBoxesWidth,
				top: totalTopBoxesHeight,
				right: totalLeftBoxesWidth + maxChartAreaWidth,
				bottom: totalTopBoxesHeight + maxChartAreaHeight
			};

			// Step 9
			helpers$4.each(chartAreaBoxes, function(box) {
				box.left = chart.chartArea.left;
				box.top = chart.chartArea.top;
				box.right = chart.chartArea.right;
				box.bottom = chart.chartArea.bottom;

				box.update(maxChartAreaWidth, maxChartAreaHeight);
			});
		}
	};
	var core_layouts_1 = core_layouts.defaults;
	var core_layouts_2 = core_layouts.addBox;
	var core_layouts_3 = core_layouts.removeBox;
	var core_layouts_4 = core_layouts.configure;
	var core_layouts_5 = core_layouts.update;

	var core_layouts$1 = /*#__PURE__*/Object.freeze({
		default: core_layouts,
		__moduleExports: core_layouts,
		defaults: core_layouts_1,
		addBox: core_layouts_2,
		removeBox: core_layouts_3,
		configure: core_layouts_4,
		update: core_layouts_5
	});

	var layouts = ( core_layouts$1 && core_layouts ) || core_layouts$1;

	var core_scaleService = {
		// Scale registration object. Extensions can register new scale types (such as log or DB scales) and then
		// use the new chart options to grab the correct scale
		constructors: {},
		// Use a registration function so that we can move to an ES6 map when we no longer need to support
		// old browsers

		// Scale config defaults
		defaults: {},
		registerScaleType: function(type, scaleConstructor, scaleDefaults) {
			this.constructors[type] = scaleConstructor;
			this.defaults[type] = helpers$4.clone(scaleDefaults);
		},
		getScaleConstructor: function(type) {
			return this.constructors.hasOwnProperty(type) ? this.constructors[type] : undefined;
		},
		getScaleDefaults: function(type) {
			// Return the scale defaults merged with the global settings so that we always use the latest ones
			return this.defaults.hasOwnProperty(type) ? helpers$4.merge({}, [defaults$3.scale, this.defaults[type]]) : {};
		},
		updateScaleDefaults: function(type, additions) {
			var me = this;
			if (me.defaults.hasOwnProperty(type)) {
				me.defaults[type] = helpers$4.extend(me.defaults[type], additions);
			}
		},
		addScalesToLayout: function(chart) {
			// Adds each scale to the chart.boxes array to be sized accordingly
			helpers$4.each(chart.scales, function(scale) {
				// Set ILayoutItem parameters for backwards compatibility
				scale.fullWidth = scale.options.fullWidth;
				scale.position = scale.options.position;
				scale.weight = scale.options.weight;
				layouts.addBox(chart, scale);
			});
		}
	};
	var core_scaleService_1 = core_scaleService.constructors;
	var core_scaleService_2 = core_scaleService.defaults;
	var core_scaleService_3 = core_scaleService.registerScaleType;
	var core_scaleService_4 = core_scaleService.getScaleConstructor;
	var core_scaleService_5 = core_scaleService.getScaleDefaults;
	var core_scaleService_6 = core_scaleService.updateScaleDefaults;
	var core_scaleService_7 = core_scaleService.addScalesToLayout;

	var core_scaleService$1 = /*#__PURE__*/Object.freeze({
		default: core_scaleService,
		__moduleExports: core_scaleService,
		constructors: core_scaleService_1,
		defaults: core_scaleService_2,
		registerScaleType: core_scaleService_3,
		getScaleConstructor: core_scaleService_4,
		getScaleDefaults: core_scaleService_5,
		updateScaleDefaults: core_scaleService_6,
		addScalesToLayout: core_scaleService_7
	});

	var color = ( chartjsColor$1 && chartjsColor ) || chartjsColor$1;

	var scaleService = ( core_scaleService$1 && core_scaleService ) || core_scaleService$1;

	var core_helpers = function() {

		// -- Basic js utility methods

		helpers$4.configMerge = function(/* objects ... */) {
			return helpers$4.merge(helpers$4.clone(arguments[0]), [].slice.call(arguments, 1), {
				merger: function(key, target, source, options) {
					var tval = target[key] || {};
					var sval = source[key];

					if (key === 'scales') {
						// scale config merging is complex. Add our own function here for that
						target[key] = helpers$4.scaleMerge(tval, sval);
					} else if (key === 'scale') {
						// used in polar area & radar charts since there is only one scale
						target[key] = helpers$4.merge(tval, [scaleService.getScaleDefaults(sval.type), sval]);
					} else {
						helpers$4._merger(key, target, source, options);
					}
				}
			});
		};

		helpers$4.scaleMerge = function(/* objects ... */) {
			return helpers$4.merge(helpers$4.clone(arguments[0]), [].slice.call(arguments, 1), {
				merger: function(key, target, source, options) {
					if (key === 'xAxes' || key === 'yAxes') {
						var slen = source[key].length;
						var i, type, scale;

						if (!target[key]) {
							target[key] = [];
						}

						for (i = 0; i < slen; ++i) {
							scale = source[key][i];
							type = helpers$4.valueOrDefault(scale.type, key === 'xAxes' ? 'category' : 'linear');

							if (i >= target[key].length) {
								target[key].push({});
							}

							if (!target[key][i].type || (scale.type && scale.type !== target[key][i].type)) {
								// new/untyped scale or type changed: let's apply the new defaults
								// then merge source scale to correctly overwrite the defaults.
								helpers$4.merge(target[key][i], [scaleService.getScaleDefaults(type), scale]);
							} else {
								// scales type are the same
								helpers$4.merge(target[key][i], scale);
							}
						}
					} else {
						helpers$4._merger(key, target, source, options);
					}
				}
			});
		};

		helpers$4.where = function(collection, filterCallback) {
			if (helpers$4.isArray(collection) && Array.prototype.filter) {
				return collection.filter(filterCallback);
			}
			var filtered = [];

			helpers$4.each(collection, function(item) {
				if (filterCallback(item)) {
					filtered.push(item);
				}
			});

			return filtered;
		};
		helpers$4.findIndex = Array.prototype.findIndex ?
			function(array, callback, scope) {
				return array.findIndex(callback, scope);
			} :
			function(array, callback, scope) {
				scope = scope === undefined ? array : scope;
				for (var i = 0, ilen = array.length; i < ilen; ++i) {
					if (callback.call(scope, array[i], i, array)) {
						return i;
					}
				}
				return -1;
			};
		helpers$4.findNextWhere = function(arrayToSearch, filterCallback, startIndex) {
			// Default to start of the array
			if (helpers$4.isNullOrUndef(startIndex)) {
				startIndex = -1;
			}
			for (var i = startIndex + 1; i < arrayToSearch.length; i++) {
				var currentItem = arrayToSearch[i];
				if (filterCallback(currentItem)) {
					return currentItem;
				}
			}
		};
		helpers$4.findPreviousWhere = function(arrayToSearch, filterCallback, startIndex) {
			// Default to end of the array
			if (helpers$4.isNullOrUndef(startIndex)) {
				startIndex = arrayToSearch.length;
			}
			for (var i = startIndex - 1; i >= 0; i--) {
				var currentItem = arrayToSearch[i];
				if (filterCallback(currentItem)) {
					return currentItem;
				}
			}
		};

		// -- Math methods
		helpers$4.isNumber = function(n) {
			return !isNaN(parseFloat(n)) && isFinite(n);
		};
		helpers$4.almostEquals = function(x, y, epsilon) {
			return Math.abs(x - y) < epsilon;
		};
		helpers$4.almostWhole = function(x, epsilon) {
			var rounded = Math.round(x);
			return (((rounded - epsilon) < x) && ((rounded + epsilon) > x));
		};
		helpers$4.max = function(array) {
			return array.reduce(function(max, value) {
				if (!isNaN(value)) {
					return Math.max(max, value);
				}
				return max;
			}, Number.NEGATIVE_INFINITY);
		};
		helpers$4.min = function(array) {
			return array.reduce(function(min, value) {
				if (!isNaN(value)) {
					return Math.min(min, value);
				}
				return min;
			}, Number.POSITIVE_INFINITY);
		};
		helpers$4.sign = Math.sign ?
			function(x) {
				return Math.sign(x);
			} :
			function(x) {
				x = +x; // convert to a number
				if (x === 0 || isNaN(x)) {
					return x;
				}
				return x > 0 ? 1 : -1;
			};
		helpers$4.log10 = Math.log10 ?
			function(x) {
				return Math.log10(x);
			} :
			function(x) {
				var exponent = Math.log(x) * Math.LOG10E; // Math.LOG10E = 1 / Math.LN10.
				// Check for whole powers of 10,
				// which due to floating point rounding error should be corrected.
				var powerOf10 = Math.round(exponent);
				var isPowerOf10 = x === Math.pow(10, powerOf10);

				return isPowerOf10 ? powerOf10 : exponent;
			};
		helpers$4.toRadians = function(degrees) {
			return degrees * (Math.PI / 180);
		};
		helpers$4.toDegrees = function(radians) {
			return radians * (180 / Math.PI);
		};
		// Gets the angle from vertical upright to the point about a centre.
		helpers$4.getAngleFromPoint = function(centrePoint, anglePoint) {
			var distanceFromXCenter = anglePoint.x - centrePoint.x;
			var distanceFromYCenter = anglePoint.y - centrePoint.y;
			var radialDistanceFromCenter = Math.sqrt(distanceFromXCenter * distanceFromXCenter + distanceFromYCenter * distanceFromYCenter);

			var angle = Math.atan2(distanceFromYCenter, distanceFromXCenter);

			if (angle < (-0.5 * Math.PI)) {
				angle += 2.0 * Math.PI; // make sure the returned angle is in the range of (-PI/2, 3PI/2]
			}

			return {
				angle: angle,
				distance: radialDistanceFromCenter
			};
		};
		helpers$4.distanceBetweenPoints = function(pt1, pt2) {
			return Math.sqrt(Math.pow(pt2.x - pt1.x, 2) + Math.pow(pt2.y - pt1.y, 2));
		};
		helpers$4.aliasPixel = function(pixelWidth) {
			return (pixelWidth % 2 === 0) ? 0 : 0.5;
		};
		helpers$4.splineCurve = function(firstPoint, middlePoint, afterPoint, t) {
			// Props to Rob Spencer at scaled innovation for his post on splining between points
			// http://scaledinnovation.com/analytics/splines/aboutSplines.html

			// This function must also respect "skipped" points

			var previous = firstPoint.skip ? middlePoint : firstPoint;
			var current = middlePoint;
			var next = afterPoint.skip ? middlePoint : afterPoint;

			var d01 = Math.sqrt(Math.pow(current.x - previous.x, 2) + Math.pow(current.y - previous.y, 2));
			var d12 = Math.sqrt(Math.pow(next.x - current.x, 2) + Math.pow(next.y - current.y, 2));

			var s01 = d01 / (d01 + d12);
			var s12 = d12 / (d01 + d12);

			// If all points are the same, s01 & s02 will be inf
			s01 = isNaN(s01) ? 0 : s01;
			s12 = isNaN(s12) ? 0 : s12;

			var fa = t * s01; // scaling factor for triangle Ta
			var fb = t * s12;

			return {
				previous: {
					x: current.x - fa * (next.x - previous.x),
					y: current.y - fa * (next.y - previous.y)
				},
				next: {
					x: current.x + fb * (next.x - previous.x),
					y: current.y + fb * (next.y - previous.y)
				}
			};
		};
		helpers$4.EPSILON = Number.EPSILON || 1e-14;
		helpers$4.splineCurveMonotone = function(points) {
			var this$1 = this;

			// This function calculates Bézier control points in a similar way than |splineCurve|,
			// but preserves monotonicity of the provided data and ensures no local extremums are added
			// between the dataset discrete points due to the interpolation.
			// See : https://en.wikipedia.org/wiki/Monotone_cubic_interpolation

			var pointsWithTangents = (points || []).map(function(point) {
				return {
					model: point._model,
					deltaK: 0,
					mK: 0
				};
			});

			// Calculate slopes (deltaK) and initialize tangents (mK)
			var pointsLen = pointsWithTangents.length;
			var i, pointBefore, pointCurrent, pointAfter;
			for (i = 0; i < pointsLen; ++i) {
				pointCurrent = pointsWithTangents[i];
				if (pointCurrent.model.skip) {
					continue;
				}

				pointBefore = i > 0 ? pointsWithTangents[i - 1] : null;
				pointAfter = i < pointsLen - 1 ? pointsWithTangents[i + 1] : null;
				if (pointAfter && !pointAfter.model.skip) {
					var slopeDeltaX = (pointAfter.model.x - pointCurrent.model.x);

					// In the case of two points that appear at the same x pixel, slopeDeltaX is 0
					pointCurrent.deltaK = slopeDeltaX !== 0 ? (pointAfter.model.y - pointCurrent.model.y) / slopeDeltaX : 0;
				}

				if (!pointBefore || pointBefore.model.skip) {
					pointCurrent.mK = pointCurrent.deltaK;
				} else if (!pointAfter || pointAfter.model.skip) {
					pointCurrent.mK = pointBefore.deltaK;
				} else if (this$1.sign(pointBefore.deltaK) !== this$1.sign(pointCurrent.deltaK)) {
					pointCurrent.mK = 0;
				} else {
					pointCurrent.mK = (pointBefore.deltaK + pointCurrent.deltaK) / 2;
				}
			}

			// Adjust tangents to ensure monotonic properties
			var alphaK, betaK, tauK, squaredMagnitude;
			for (i = 0; i < pointsLen - 1; ++i) {
				pointCurrent = pointsWithTangents[i];
				pointAfter = pointsWithTangents[i + 1];
				if (pointCurrent.model.skip || pointAfter.model.skip) {
					continue;
				}

				if (helpers$4.almostEquals(pointCurrent.deltaK, 0, this$1.EPSILON)) {
					pointCurrent.mK = pointAfter.mK = 0;
					continue;
				}

				alphaK = pointCurrent.mK / pointCurrent.deltaK;
				betaK = pointAfter.mK / pointCurrent.deltaK;
				squaredMagnitude = Math.pow(alphaK, 2) + Math.pow(betaK, 2);
				if (squaredMagnitude <= 9) {
					continue;
				}

				tauK = 3 / Math.sqrt(squaredMagnitude);
				pointCurrent.mK = alphaK * tauK * pointCurrent.deltaK;
				pointAfter.mK = betaK * tauK * pointCurrent.deltaK;
			}

			// Compute control points
			var deltaX;
			for (i = 0; i < pointsLen; ++i) {
				pointCurrent = pointsWithTangents[i];
				if (pointCurrent.model.skip) {
					continue;
				}

				pointBefore = i > 0 ? pointsWithTangents[i - 1] : null;
				pointAfter = i < pointsLen - 1 ? pointsWithTangents[i + 1] : null;
				if (pointBefore && !pointBefore.model.skip) {
					deltaX = (pointCurrent.model.x - pointBefore.model.x) / 3;
					pointCurrent.model.controlPointPreviousX = pointCurrent.model.x - deltaX;
					pointCurrent.model.controlPointPreviousY = pointCurrent.model.y - deltaX * pointCurrent.mK;
				}
				if (pointAfter && !pointAfter.model.skip) {
					deltaX = (pointAfter.model.x - pointCurrent.model.x) / 3;
					pointCurrent.model.controlPointNextX = pointCurrent.model.x + deltaX;
					pointCurrent.model.controlPointNextY = pointCurrent.model.y + deltaX * pointCurrent.mK;
				}
			}
		};
		helpers$4.nextItem = function(collection, index, loop) {
			if (loop) {
				return index >= collection.length - 1 ? collection[0] : collection[index + 1];
			}
			return index >= collection.length - 1 ? collection[collection.length - 1] : collection[index + 1];
		};
		helpers$4.previousItem = function(collection, index, loop) {
			if (loop) {
				return index <= 0 ? collection[collection.length - 1] : collection[index - 1];
			}
			return index <= 0 ? collection[0] : collection[index - 1];
		};
		// Implementation of the nice number algorithm used in determining where axis labels will go
		helpers$4.niceNum = function(range, round) {
			var exponent = Math.floor(helpers$4.log10(range));
			var fraction = range / Math.pow(10, exponent);
			var niceFraction;

			if (round) {
				if (fraction < 1.5) {
					niceFraction = 1;
				} else if (fraction < 3) {
					niceFraction = 2;
				} else if (fraction < 7) {
					niceFraction = 5;
				} else {
					niceFraction = 10;
				}
			} else if (fraction <= 1.0) {
				niceFraction = 1;
			} else if (fraction <= 2) {
				niceFraction = 2;
			} else if (fraction <= 5) {
				niceFraction = 5;
			} else {
				niceFraction = 10;
			}

			return niceFraction * Math.pow(10, exponent);
		};
		// Request animation polyfill - http://www.paulirish.com/2011/requestanimationframe-for-smart-animating/
		helpers$4.requestAnimFrame = (function() {
			if (typeof window === 'undefined') {
				return function(callback) {
					callback();
				};
			}
			return window.requestAnimationFrame ||
				window.webkitRequestAnimationFrame ||
				window.mozRequestAnimationFrame ||
				window.oRequestAnimationFrame ||
				window.msRequestAnimationFrame ||
				function(callback) {
					return window.setTimeout(callback, 1000 / 60);
				};
		}());
		// -- DOM methods
		helpers$4.getRelativePosition = function(evt, chart) {
			var mouseX, mouseY;
			var e = evt.originalEvent || evt;
			var canvas = evt.target || evt.srcElement;
			var boundingRect = canvas.getBoundingClientRect();

			var touches = e.touches;
			if (touches && touches.length > 0) {
				mouseX = touches[0].clientX;
				mouseY = touches[0].clientY;

			} else {
				mouseX = e.clientX;
				mouseY = e.clientY;
			}

			// Scale mouse coordinates into canvas coordinates
			// by following the pattern laid out by 'jerryj' in the comments of
			// http://www.html5canvastutorials.com/advanced/html5-canvas-mouse-coordinates/
			var paddingLeft = parseFloat(helpers$4.getStyle(canvas, 'padding-left'));
			var paddingTop = parseFloat(helpers$4.getStyle(canvas, 'padding-top'));
			var paddingRight = parseFloat(helpers$4.getStyle(canvas, 'padding-right'));
			var paddingBottom = parseFloat(helpers$4.getStyle(canvas, 'padding-bottom'));
			var width = boundingRect.right - boundingRect.left - paddingLeft - paddingRight;
			var height = boundingRect.bottom - boundingRect.top - paddingTop - paddingBottom;

			// We divide by the current device pixel ratio, because the canvas is scaled up by that amount in each direction. However
			// the backend model is in unscaled coordinates. Since we are going to deal with our model coordinates, we go back here
			mouseX = Math.round((mouseX - boundingRect.left - paddingLeft) / (width) * canvas.width / chart.currentDevicePixelRatio);
			mouseY = Math.round((mouseY - boundingRect.top - paddingTop) / (height) * canvas.height / chart.currentDevicePixelRatio);

			return {
				x: mouseX,
				y: mouseY
			};

		};

		// Private helper function to convert max-width/max-height values that may be percentages into a number
		function parseMaxStyle(styleValue, node, parentProperty) {
			var valueInPixels;
			if (typeof styleValue === 'string') {
				valueInPixels = parseInt(styleValue, 10);

				if (styleValue.indexOf('%') !== -1) {
					// percentage * size in dimension
					valueInPixels = valueInPixels / 100 * node.parentNode[parentProperty];
				}
			} else {
				valueInPixels = styleValue;
			}

			return valueInPixels;
		}

		/**
		 * Returns if the given value contains an effective constraint.
		 * @private
		 */
		function isConstrainedValue(value) {
			return value !== undefined && value !== null && value !== 'none';
		}

		// Private helper to get a constraint dimension
		// @param domNode : the node to check the constraint on
		// @param maxStyle : the style that defines the maximum for the direction we are using (maxWidth / maxHeight)
		// @param percentageProperty : property of parent to use when calculating width as a percentage
		// @see http://www.nathanaeljones.com/blog/2013/reading-max-width-cross-browser
		function getConstraintDimension(domNode, maxStyle, percentageProperty) {
			var view = document.defaultView;
			var parentNode = helpers$4._getParentNode(domNode);
			var constrainedNode = view.getComputedStyle(domNode)[maxStyle];
			var constrainedContainer = view.getComputedStyle(parentNode)[maxStyle];
			var hasCNode = isConstrainedValue(constrainedNode);
			var hasCContainer = isConstrainedValue(constrainedContainer);
			var infinity = Number.POSITIVE_INFINITY;

			if (hasCNode || hasCContainer) {
				return Math.min(
					hasCNode ? parseMaxStyle(constrainedNode, domNode, percentageProperty) : infinity,
					hasCContainer ? parseMaxStyle(constrainedContainer, parentNode, percentageProperty) : infinity);
			}

			return 'none';
		}
		// returns Number or undefined if no constraint
		helpers$4.getConstraintWidth = function(domNode) {
			return getConstraintDimension(domNode, 'max-width', 'clientWidth');
		};
		// returns Number or undefined if no constraint
		helpers$4.getConstraintHeight = function(domNode) {
			return getConstraintDimension(domNode, 'max-height', 'clientHeight');
		};
		/**
		 * @private
	 	 */
		helpers$4._calculatePadding = function(container, padding, parentDimension) {
			padding = helpers$4.getStyle(container, padding);

			return padding.indexOf('%') > -1 ? parentDimension / parseInt(padding, 10) : parseInt(padding, 10);
		};
		/**
		 * @private
		 */
		helpers$4._getParentNode = function(domNode) {
			var parent = domNode.parentNode;
			if (parent && parent.host) {
				parent = parent.host;
			}
			return parent;
		};
		helpers$4.getMaximumWidth = function(domNode) {
			var container = helpers$4._getParentNode(domNode);
			if (!container) {
				return domNode.clientWidth;
			}

			var clientWidth = container.clientWidth;
			var paddingLeft = helpers$4._calculatePadding(container, 'padding-left', clientWidth);
			var paddingRight = helpers$4._calculatePadding(container, 'padding-right', clientWidth);

			var w = clientWidth - paddingLeft - paddingRight;
			var cw = helpers$4.getConstraintWidth(domNode);
			return isNaN(cw) ? w : Math.min(w, cw);
		};
		helpers$4.getMaximumHeight = function(domNode) {
			var container = helpers$4._getParentNode(domNode);
			if (!container) {
				return domNode.clientHeight;
			}

			var clientHeight = container.clientHeight;
			var paddingTop = helpers$4._calculatePadding(container, 'padding-top', clientHeight);
			var paddingBottom = helpers$4._calculatePadding(container, 'padding-bottom', clientHeight);

			var h = clientHeight - paddingTop - paddingBottom;
			var ch = helpers$4.getConstraintHeight(domNode);
			return isNaN(ch) ? h : Math.min(h, ch);
		};
		helpers$4.getStyle = function(el, property) {
			return el.currentStyle ?
				el.currentStyle[property] :
				document.defaultView.getComputedStyle(el, null).getPropertyValue(property);
		};
		helpers$4.retinaScale = function(chart, forceRatio) {
			var pixelRatio = chart.currentDevicePixelRatio = forceRatio || (typeof window !== 'undefined' && window.devicePixelRatio) || 1;
			if (pixelRatio === 1) {
				return;
			}

			var canvas = chart.canvas;
			var height = chart.height;
			var width = chart.width;

			canvas.height = height * pixelRatio;
			canvas.width = width * pixelRatio;
			chart.ctx.scale(pixelRatio, pixelRatio);

			// If no style has been set on the canvas, the render size is used as display size,
			// making the chart visually bigger, so let's enforce it to the "correct" values.
			// See https://github.com/chartjs/Chart.js/issues/3575
			if (!canvas.style.height && !canvas.style.width) {
				canvas.style.height = height + 'px';
				canvas.style.width = width + 'px';
			}
		};
		// -- Canvas methods
		helpers$4.fontString = function(pixelSize, fontStyle, fontFamily) {
			return fontStyle + ' ' + pixelSize + 'px ' + fontFamily;
		};
		helpers$4.longestText = function(ctx, font, arrayOfThings, cache) {
			cache = cache || {};
			var data = cache.data = cache.data || {};
			var gc = cache.garbageCollect = cache.garbageCollect || [];

			if (cache.font !== font) {
				data = cache.data = {};
				gc = cache.garbageCollect = [];
				cache.font = font;
			}

			ctx.font = font;
			var longest = 0;
			helpers$4.each(arrayOfThings, function(thing) {
				// Undefined strings and arrays should not be measured
				if (thing !== undefined && thing !== null && helpers$4.isArray(thing) !== true) {
					longest = helpers$4.measureText(ctx, data, gc, longest, thing);
				} else if (helpers$4.isArray(thing)) {
					// if it is an array lets measure each element
					// to do maybe simplify this function a bit so we can do this more recursively?
					helpers$4.each(thing, function(nestedThing) {
						// Undefined strings and arrays should not be measured
						if (nestedThing !== undefined && nestedThing !== null && !helpers$4.isArray(nestedThing)) {
							longest = helpers$4.measureText(ctx, data, gc, longest, nestedThing);
						}
					});
				}
			});

			var gcLen = gc.length / 2;
			if (gcLen > arrayOfThings.length) {
				for (var i = 0; i < gcLen; i++) {
					delete data[gc[i]];
				}
				gc.splice(0, gcLen);
			}
			return longest;
		};
		helpers$4.measureText = function(ctx, data, gc, longest, string) {
			var textWidth = data[string];
			if (!textWidth) {
				textWidth = data[string] = ctx.measureText(string).width;
				gc.push(string);
			}
			if (textWidth > longest) {
				longest = textWidth;
			}
			return longest;
		};
		helpers$4.numberOfLabelLines = function(arrayOfThings) {
			var numberOfLines = 1;
			helpers$4.each(arrayOfThings, function(thing) {
				if (helpers$4.isArray(thing)) {
					if (thing.length > numberOfLines) {
						numberOfLines = thing.length;
					}
				}
			});
			return numberOfLines;
		};

		helpers$4.color = !color ?
			function(value) {
				console.error('Color.js not found!');
				return value;
			} :
			function(value) {
				/* global CanvasGradient */
				if (value instanceof CanvasGradient) {
					value = defaults$3.global.defaultColor;
				}

				return color(value);
			};

		helpers$4.getHoverColor = function(colorValue) {
			/* global CanvasPattern */
			return (colorValue instanceof CanvasPattern) ?
				colorValue :
				helpers$4.color(colorValue).saturate(0.5).darken(0.1).rgbString();
		};
	};

	var core_helpers$1 = /*#__PURE__*/Object.freeze({
		default: core_helpers,
		__moduleExports: core_helpers
	});

	function interpolate(start, view, model, ease) {
		var keys = Object.keys(model);
		var i, ilen, key, actual, origin, target, type, c0, c1;

		for (i = 0, ilen = keys.length; i < ilen; ++i) {
			key = keys[i];

			target = model[key];

			// if a value is added to the model after pivot() has been called, the view
			// doesn't contain it, so let's initialize the view to the target value.
			if (!view.hasOwnProperty(key)) {
				view[key] = target;
			}

			actual = view[key];

			if (actual === target || key[0] === '_') {
				continue;
			}

			if (!start.hasOwnProperty(key)) {
				start[key] = actual;
			}

			origin = start[key];

			type = typeof target;

			if (type === typeof origin) {
				if (type === 'string') {
					c0 = color(origin);
					if (c0.valid) {
						c1 = color(target);
						if (c1.valid) {
							view[key] = c1.mix(c0, ease).rgbString();
							continue;
						}
					}
				} else if (type === 'number' && isFinite(origin) && isFinite(target)) {
					view[key] = origin + (target - origin) * ease;
					continue;
				}
			}

			view[key] = target;
		}
	}

	var Element = function(configuration) {
		helpers$4.extend(this, configuration);
		this.initialize.apply(this, arguments);
	};

	helpers$4.extend(Element.prototype, {

		initialize: function() {
			this.hidden = false;
		},

		pivot: function() {
			var me = this;
			if (!me._view) {
				me._view = helpers$4.clone(me._model);
			}
			me._start = {};
			return me;
		},

		transition: function(ease) {
			var me = this;
			var model = me._model;
			var start = me._start;
			var view = me._view;

			// No animation -> No Transition
			if (!model || ease === 1) {
				me._view = model;
				me._start = null;
				return me;
			}

			if (!view) {
				view = me._view = {};
			}

			if (!start) {
				start = me._start = {};
			}

			interpolate(start, view, model, ease);

			return me;
		},

		tooltipPosition: function() {
			return {
				x: this._model.x,
				y: this._model.y
			};
		},

		hasValue: function() {
			return helpers$4.isNumber(this._model.x) && helpers$4.isNumber(this._model.y);
		}
	});

	Element.extend = helpers$4.inherits;

	var core_element = Element;

	var core_element$1 = /*#__PURE__*/Object.freeze({
		default: core_element,
		__moduleExports: core_element
	});

	var Element$1 = ( core_element$1 && core_element ) || core_element$1;

	var core_animation = createCommonjsModule(function (module) {



	var exports = module.exports = Element$1.extend({
		chart: null, // the animation associated chart instance
		currentStep: 0, // the current animation step
		numSteps: 60, // default number of steps
		easing: '', // the easing to use for this animation
		render: null, // render function used by the animation service

		onAnimationProgress: null, // user specified callback to fire on each step of the animation
		onAnimationComplete: null, // user specified callback to fire when the animation finishes
	});

	// DEPRECATIONS

	/**
	 * Provided for backward compatibility, use Chart.Animation instead
	 * @prop Chart.Animation#animationObject
	 * @deprecated since version 2.6.0
	 * @todo remove at version 3
	 */
	Object.defineProperty(exports.prototype, 'animationObject', {
		get: function() {
			return this;
		}
	});

	/**
	 * Provided for backward compatibility, use Chart.Animation#chart instead
	 * @prop Chart.Animation#chartInstance
	 * @deprecated since version 2.6.0
	 * @todo remove at version 3
	 */
	Object.defineProperty(exports.prototype, 'chartInstance', {
		get: function() {
			return this.chart;
		},
		set: function(value) {
			this.chart = value;
		}
	});
	});

	var core_animation$1 = /*#__PURE__*/Object.freeze({
		default: core_animation,
		__moduleExports: core_animation
	});

	defaults$3._set('global', {
		animation: {
			duration: 1000,
			easing: 'easeOutQuart',
			onProgress: helpers$4.noop,
			onComplete: helpers$4.noop
		}
	});

	var core_animations = {
		frameDuration: 17,
		animations: [],
		dropFrames: 0,
		request: null,

		/**
		 * @param {Chart} chart - The chart to animate.
		 * @param {Chart.Animation} animation - The animation that we will animate.
		 * @param {Number} duration - The animation duration in ms.
		 * @param {Boolean} lazy - if true, the chart is not marked as animating to enable more responsive interactions
		 */
		addAnimation: function(chart, animation, duration, lazy) {
			var animations = this.animations;
			var i, ilen;

			animation.chart = chart;

			if (!lazy) {
				chart.animating = true;
			}

			for (i = 0, ilen = animations.length; i < ilen; ++i) {
				if (animations[i].chart === chart) {
					animations[i] = animation;
					return;
				}
			}

			animations.push(animation);

			// If there are no animations queued, manually kickstart a digest, for lack of a better word
			if (animations.length === 1) {
				this.requestAnimationFrame();
			}
		},

		cancelAnimation: function(chart) {
			var index = helpers$4.findIndex(this.animations, function(animation) {
				return animation.chart === chart;
			});

			if (index !== -1) {
				this.animations.splice(index, 1);
				chart.animating = false;
			}
		},

		requestAnimationFrame: function() {
			var me = this;
			if (me.request === null) {
				// Skip animation frame requests until the active one is executed.
				// This can happen when processing mouse events, e.g. 'mousemove'
				// and 'mouseout' events will trigger multiple renders.
				me.request = helpers$4.requestAnimFrame.call(window, function() {
					me.request = null;
					me.startDigest();
				});
			}
		},

		/**
		 * @private
		 */
		startDigest: function() {
			var me = this;
			var startTime = Date.now();
			var framesToDrop = 0;

			if (me.dropFrames > 1) {
				framesToDrop = Math.floor(me.dropFrames);
				me.dropFrames = me.dropFrames % 1;
			}

			me.advance(1 + framesToDrop);

			var endTime = Date.now();

			me.dropFrames += (endTime - startTime) / me.frameDuration;

			// Do we have more stuff to animate?
			if (me.animations.length > 0) {
				me.requestAnimationFrame();
			}
		},

		/**
		 * @private
		 */
		advance: function(count) {
			var animations = this.animations;
			var animation, chart;
			var i = 0;

			while (i < animations.length) {
				animation = animations[i];
				chart = animation.chart;

				animation.currentStep = (animation.currentStep || 0) + count;
				animation.currentStep = Math.min(animation.currentStep, animation.numSteps);

				helpers$4.callback(animation.render, [chart, animation], chart);
				helpers$4.callback(animation.onAnimationProgress, [animation], chart);

				if (animation.currentStep >= animation.numSteps) {
					helpers$4.callback(animation.onAnimationComplete, [animation], chart);
					chart.animating = false;
					animations.splice(i, 1);
				} else {
					++i;
				}
			}
		}
	};
	var core_animations_1 = core_animations.frameDuration;
	var core_animations_2 = core_animations.animations;
	var core_animations_3 = core_animations.dropFrames;
	var core_animations_4 = core_animations.request;
	var core_animations_5 = core_animations.addAnimation;
	var core_animations_6 = core_animations.cancelAnimation;
	var core_animations_7 = core_animations.requestAnimationFrame;
	var core_animations_8 = core_animations.startDigest;
	var core_animations_9 = core_animations.advance;

	var core_animations$1 = /*#__PURE__*/Object.freeze({
		default: core_animations,
		__moduleExports: core_animations,
		frameDuration: core_animations_1,
		animations: core_animations_2,
		dropFrames: core_animations_3,
		request: core_animations_4,
		addAnimation: core_animations_5,
		cancelAnimation: core_animations_6,
		requestAnimationFrame: core_animations_7,
		startDigest: core_animations_8,
		advance: core_animations_9
	});

	defaults$3._set('global', {
		elements: {
			arc: {
				backgroundColor: defaults$3.global.defaultColor,
				borderColor: '#fff',
				borderWidth: 2
			}
		}
	});

	var element_arc = Element$1.extend({
		inLabelRange: function(mouseX) {
			var vm = this._view;

			if (vm) {
				return (Math.pow(mouseX - vm.x, 2) < Math.pow(vm.radius + vm.hoverRadius, 2));
			}
			return false;
		},

		inRange: function(chartX, chartY) {
			var vm = this._view;

			if (vm) {
				var pointRelativePosition = helpers$4.getAngleFromPoint(vm, {x: chartX, y: chartY});
				var	angle = pointRelativePosition.angle;
				var distance = pointRelativePosition.distance;

				// Sanitise angle range
				var startAngle = vm.startAngle;
				var endAngle = vm.endAngle;
				while (endAngle < startAngle) {
					endAngle += 2.0 * Math.PI;
				}
				while (angle > endAngle) {
					angle -= 2.0 * Math.PI;
				}
				while (angle < startAngle) {
					angle += 2.0 * Math.PI;
				}

				// Check if within the range of the open/close angle
				var betweenAngles = (angle >= startAngle && angle <= endAngle);
				var withinRadius = (distance >= vm.innerRadius && distance <= vm.outerRadius);

				return (betweenAngles && withinRadius);
			}
			return false;
		},

		getCenterPoint: function() {
			var vm = this._view;
			var halfAngle = (vm.startAngle + vm.endAngle) / 2;
			var halfRadius = (vm.innerRadius + vm.outerRadius) / 2;
			return {
				x: vm.x + Math.cos(halfAngle) * halfRadius,
				y: vm.y + Math.sin(halfAngle) * halfRadius
			};
		},

		getArea: function() {
			var vm = this._view;
			return Math.PI * ((vm.endAngle - vm.startAngle) / (2 * Math.PI)) * (Math.pow(vm.outerRadius, 2) - Math.pow(vm.innerRadius, 2));
		},

		tooltipPosition: function() {
			var vm = this._view;
			var centreAngle = vm.startAngle + ((vm.endAngle - vm.startAngle) / 2);
			var rangeFromCentre = (vm.outerRadius - vm.innerRadius) / 2 + vm.innerRadius;

			return {
				x: vm.x + (Math.cos(centreAngle) * rangeFromCentre),
				y: vm.y + (Math.sin(centreAngle) * rangeFromCentre)
			};
		},

		draw: function() {
			var ctx = this._chart.ctx;
			var vm = this._view;
			var sA = vm.startAngle;
			var eA = vm.endAngle;

			ctx.beginPath();

			ctx.arc(vm.x, vm.y, vm.outerRadius, sA, eA);
			ctx.arc(vm.x, vm.y, vm.innerRadius, eA, sA, true);

			ctx.closePath();
			ctx.strokeStyle = vm.borderColor;
			ctx.lineWidth = vm.borderWidth;

			ctx.fillStyle = vm.backgroundColor;

			ctx.fill();
			ctx.lineJoin = 'bevel';

			if (vm.borderWidth) {
				ctx.stroke();
			}
		}
	});

	var element_arc$1 = /*#__PURE__*/Object.freeze({
		default: element_arc,
		__moduleExports: element_arc
	});

	var globalDefaults = defaults$3.global;

	defaults$3._set('global', {
		elements: {
			line: {
				tension: 0.4,
				backgroundColor: globalDefaults.defaultColor,
				borderWidth: 3,
				borderColor: globalDefaults.defaultColor,
				borderCapStyle: 'butt',
				borderDash: [],
				borderDashOffset: 0.0,
				borderJoinStyle: 'miter',
				capBezierPoints: true,
				fill: true, // do we fill in the area between the line and its base axis
			}
		}
	});

	var element_line = Element$1.extend({
		draw: function() {
			var me = this;
			var vm = me._view;
			var ctx = me._chart.ctx;
			var spanGaps = vm.spanGaps;
			var points = me._children.slice(); // clone array
			var globalOptionLineElements = globalDefaults.elements.line;
			var lastDrawnIndex = -1;
			var index, current, previous, currentVM;

			// If we are looping, adding the first point again
			if (me._loop && points.length) {
				points.push(points[0]);
			}

			ctx.save();

			// Stroke Line Options
			ctx.lineCap = vm.borderCapStyle || globalOptionLineElements.borderCapStyle;

			// IE 9 and 10 do not support line dash
			if (ctx.setLineDash) {
				ctx.setLineDash(vm.borderDash || globalOptionLineElements.borderDash);
			}

			ctx.lineDashOffset = vm.borderDashOffset || globalOptionLineElements.borderDashOffset;
			ctx.lineJoin = vm.borderJoinStyle || globalOptionLineElements.borderJoinStyle;
			ctx.lineWidth = vm.borderWidth || globalOptionLineElements.borderWidth;
			ctx.strokeStyle = vm.borderColor || globalDefaults.defaultColor;

			// Stroke Line
			ctx.beginPath();
			lastDrawnIndex = -1;

			for (index = 0; index < points.length; ++index) {
				current = points[index];
				previous = helpers$4.previousItem(points, index);
				currentVM = current._view;

				// First point moves to it's starting position no matter what
				if (index === 0) {
					if (!currentVM.skip) {
						ctx.moveTo(currentVM.x, currentVM.y);
						lastDrawnIndex = index;
					}
				} else {
					previous = lastDrawnIndex === -1 ? previous : points[lastDrawnIndex];

					if (!currentVM.skip) {
						if ((lastDrawnIndex !== (index - 1) && !spanGaps) || lastDrawnIndex === -1) {
							// There was a gap and this is the first point after the gap
							ctx.moveTo(currentVM.x, currentVM.y);
						} else {
							// Line to next point
							helpers$4.canvas.lineTo(ctx, previous._view, current._view);
						}
						lastDrawnIndex = index;
					}
				}
			}

			ctx.stroke();
			ctx.restore();
		}
	});

	var element_line$1 = /*#__PURE__*/Object.freeze({
		default: element_line,
		__moduleExports: element_line
	});

	var defaultColor = defaults$3.global.defaultColor;

	defaults$3._set('global', {
		elements: {
			point: {
				radius: 3,
				pointStyle: 'circle',
				backgroundColor: defaultColor,
				borderColor: defaultColor,
				borderWidth: 1,
				// Hover
				hitRadius: 1,
				hoverRadius: 4,
				hoverBorderWidth: 1
			}
		}
	});

	function xRange(mouseX) {
		var vm = this._view;
		return vm ? (Math.abs(mouseX - vm.x) < vm.radius + vm.hitRadius) : false;
	}

	function yRange(mouseY) {
		var vm = this._view;
		return vm ? (Math.abs(mouseY - vm.y) < vm.radius + vm.hitRadius) : false;
	}

	var element_point = Element$1.extend({
		inRange: function(mouseX, mouseY) {
			var vm = this._view;
			return vm ? ((Math.pow(mouseX - vm.x, 2) + Math.pow(mouseY - vm.y, 2)) < Math.pow(vm.hitRadius + vm.radius, 2)) : false;
		},

		inLabelRange: xRange,
		inXRange: xRange,
		inYRange: yRange,

		getCenterPoint: function() {
			var vm = this._view;
			return {
				x: vm.x,
				y: vm.y
			};
		},

		getArea: function() {
			return Math.PI * Math.pow(this._view.radius, 2);
		},

		tooltipPosition: function() {
			var vm = this._view;
			return {
				x: vm.x,
				y: vm.y,
				padding: vm.radius + vm.borderWidth
			};
		},

		draw: function(chartArea) {
			var vm = this._view;
			var model = this._model;
			var ctx = this._chart.ctx;
			var pointStyle = vm.pointStyle;
			var rotation = vm.rotation;
			var radius = vm.radius;
			var x = vm.x;
			var y = vm.y;
			var errMargin = 1.01; // 1.01 is margin for Accumulated error. (Especially Edge, IE.)

			if (vm.skip) {
				return;
			}

			// Clipping for Points.
			if (chartArea === undefined || (model.x >= chartArea.left && chartArea.right * errMargin >= model.x && model.y >= chartArea.top && chartArea.bottom * errMargin >= model.y)) {
				ctx.strokeStyle = vm.borderColor || defaultColor;
				ctx.lineWidth = helpers$4.valueOrDefault(vm.borderWidth, defaults$3.global.elements.point.borderWidth);
				ctx.fillStyle = vm.backgroundColor || defaultColor;
				helpers$4.canvas.drawPoint(ctx, pointStyle, radius, x, y, rotation);
			}
		}
	});

	var element_point$1 = /*#__PURE__*/Object.freeze({
		default: element_point,
		__moduleExports: element_point
	});

	defaults$3._set('global', {
		elements: {
			rectangle: {
				backgroundColor: defaults$3.global.defaultColor,
				borderColor: defaults$3.global.defaultColor,
				borderSkipped: 'bottom',
				borderWidth: 0
			}
		}
	});

	function isVertical(bar) {
		return bar._view.width !== undefined;
	}

	/**
	 * Helper function to get the bounds of the bar regardless of the orientation
	 * @param bar {Chart.Element.Rectangle} the bar
	 * @return {Bounds} bounds of the bar
	 * @private
	 */
	function getBarBounds(bar) {
		var vm = bar._view;
		var x1, x2, y1, y2;

		if (isVertical(bar)) {
			// vertical
			var halfWidth = vm.width / 2;
			x1 = vm.x - halfWidth;
			x2 = vm.x + halfWidth;
			y1 = Math.min(vm.y, vm.base);
			y2 = Math.max(vm.y, vm.base);
		} else {
			// horizontal bar
			var halfHeight = vm.height / 2;
			x1 = Math.min(vm.x, vm.base);
			x2 = Math.max(vm.x, vm.base);
			y1 = vm.y - halfHeight;
			y2 = vm.y + halfHeight;
		}

		return {
			left: x1,
			top: y1,
			right: x2,
			bottom: y2
		};
	}

	var element_rectangle = Element$1.extend({
		draw: function() {
			var ctx = this._chart.ctx;
			var vm = this._view;
			var left, right, top, bottom, signX, signY, borderSkipped;
			var borderWidth = vm.borderWidth;

			if (!vm.horizontal) {
				// bar
				left = vm.x - vm.width / 2;
				right = vm.x + vm.width / 2;
				top = vm.y;
				bottom = vm.base;
				signX = 1;
				signY = bottom > top ? 1 : -1;
				borderSkipped = vm.borderSkipped || 'bottom';
			} else {
				// horizontal bar
				left = vm.base;
				right = vm.x;
				top = vm.y - vm.height / 2;
				bottom = vm.y + vm.height / 2;
				signX = right > left ? 1 : -1;
				signY = 1;
				borderSkipped = vm.borderSkipped || 'left';
			}

			// Canvas doesn't allow us to stroke inside the width so we can
			// adjust the sizes to fit if we're setting a stroke on the line
			if (borderWidth) {
				// borderWidth shold be less than bar width and bar height.
				var barSize = Math.min(Math.abs(left - right), Math.abs(top - bottom));
				borderWidth = borderWidth > barSize ? barSize : borderWidth;
				var halfStroke = borderWidth / 2;
				// Adjust borderWidth when bar top position is near vm.base(zero).
				var borderLeft = left + (borderSkipped !== 'left' ? halfStroke * signX : 0);
				var borderRight = right + (borderSkipped !== 'right' ? -halfStroke * signX : 0);
				var borderTop = top + (borderSkipped !== 'top' ? halfStroke * signY : 0);
				var borderBottom = bottom + (borderSkipped !== 'bottom' ? -halfStroke * signY : 0);
				// not become a vertical line?
				if (borderLeft !== borderRight) {
					top = borderTop;
					bottom = borderBottom;
				}
				// not become a horizontal line?
				if (borderTop !== borderBottom) {
					left = borderLeft;
					right = borderRight;
				}
			}

			ctx.beginPath();
			ctx.fillStyle = vm.backgroundColor;
			ctx.strokeStyle = vm.borderColor;
			ctx.lineWidth = borderWidth;

			// Corner points, from bottom-left to bottom-right clockwise
			// | 1 2 |
			// | 0 3 |
			var corners = [
				[left, bottom],
				[left, top],
				[right, top],
				[right, bottom]
			];

			// Find first (starting) corner with fallback to 'bottom'
			var borders = ['bottom', 'left', 'top', 'right'];
			var startCorner = borders.indexOf(borderSkipped, 0);
			if (startCorner === -1) {
				startCorner = 0;
			}

			function cornerAt(index) {
				return corners[(startCorner + index) % 4];
			}

			// Draw rectangle from 'startCorner'
			var corner = cornerAt(0);
			ctx.moveTo(corner[0], corner[1]);

			for (var i = 1; i < 4; i++) {
				corner = cornerAt(i);
				ctx.lineTo(corner[0], corner[1]);
			}

			ctx.fill();
			if (borderWidth) {
				ctx.stroke();
			}
		},

		height: function() {
			var vm = this._view;
			return vm.base - vm.y;
		},

		inRange: function(mouseX, mouseY) {
			var inRange = false;

			if (this._view) {
				var bounds = getBarBounds(this);
				inRange = mouseX >= bounds.left && mouseX <= bounds.right && mouseY >= bounds.top && mouseY <= bounds.bottom;
			}

			return inRange;
		},

		inLabelRange: function(mouseX, mouseY) {
			var me = this;
			if (!me._view) {
				return false;
			}

			var inRange = false;
			var bounds = getBarBounds(me);

			if (isVertical(me)) {
				inRange = mouseX >= bounds.left && mouseX <= bounds.right;
			} else {
				inRange = mouseY >= bounds.top && mouseY <= bounds.bottom;
			}

			return inRange;
		},

		inXRange: function(mouseX) {
			var bounds = getBarBounds(this);
			return mouseX >= bounds.left && mouseX <= bounds.right;
		},

		inYRange: function(mouseY) {
			var bounds = getBarBounds(this);
			return mouseY >= bounds.top && mouseY <= bounds.bottom;
		},

		getCenterPoint: function() {
			var vm = this._view;
			var x, y;
			if (isVertical(this)) {
				x = vm.x;
				y = (vm.y + vm.base) / 2;
			} else {
				x = (vm.x + vm.base) / 2;
				y = vm.y;
			}

			return {x: x, y: y};
		},

		getArea: function() {
			var vm = this._view;
			return vm.width * Math.abs(vm.y - vm.base);
		},

		tooltipPosition: function() {
			var vm = this._view;
			return {
				x: vm.x,
				y: vm.y
			};
		}
	});

	var element_rectangle$1 = /*#__PURE__*/Object.freeze({
		default: element_rectangle,
		__moduleExports: element_rectangle
	});

	var require$$0$5 = ( element_arc$1 && element_arc ) || element_arc$1;

	var require$$1$3 = ( element_line$1 && element_line ) || element_line$1;

	var require$$2$1 = ( element_point$1 && element_point ) || element_point$1;

	var require$$3$1 = ( element_rectangle$1 && element_rectangle ) || element_rectangle$1;

	var elements = {};
	var Arc = require$$0$5;
	var Line = require$$1$3;
	var Point = require$$2$1;
	var Rectangle = require$$3$1;
	elements.Arc = Arc;
	elements.Line = Line;
	elements.Point = Point;
	elements.Rectangle = Rectangle;

	var elements$1 = /*#__PURE__*/Object.freeze({
		default: elements,
		__moduleExports: elements,
		Arc: Arc,
		Line: Line,
		Point: Point,
		Rectangle: Rectangle
	});

	/**
	 * Helper function to get relative position for an event
	 * @param {Event|IEvent} event - The event to get the position for
	 * @param {Chart} chart - The chart
	 * @returns {Point} the event position
	 */
	function getRelativePosition(e, chart) {
		if (e.native) {
			return {
				x: e.x,
				y: e.y
			};
		}

		return helpers$4.getRelativePosition(e, chart);
	}

	/**
	 * Helper function to traverse all of the visible elements in the chart
	 * @param chart {chart} the chart
	 * @param handler {Function} the callback to execute for each visible item
	 */
	function parseVisibleItems(chart, handler) {
		var datasets = chart.data.datasets;
		var meta, i, j, ilen, jlen;

		for (i = 0, ilen = datasets.length; i < ilen; ++i) {
			if (!chart.isDatasetVisible(i)) {
				continue;
			}

			meta = chart.getDatasetMeta(i);
			for (j = 0, jlen = meta.data.length; j < jlen; ++j) {
				var element = meta.data[j];
				if (!element._view.skip) {
					handler(element);
				}
			}
		}
	}

	/**
	 * Helper function to get the items that intersect the event position
	 * @param items {ChartElement[]} elements to filter
	 * @param position {Point} the point to be nearest to
	 * @return {ChartElement[]} the nearest items
	 */
	function getIntersectItems(chart, position) {
		var elements = [];

		parseVisibleItems(chart, function(element) {
			if (element.inRange(position.x, position.y)) {
				elements.push(element);
			}
		});

		return elements;
	}

	/**
	 * Helper function to get the items nearest to the event position considering all visible items in teh chart
	 * @param chart {Chart} the chart to look at elements from
	 * @param position {Point} the point to be nearest to
	 * @param intersect {Boolean} if true, only consider items that intersect the position
	 * @param distanceMetric {Function} function to provide the distance between points
	 * @return {ChartElement[]} the nearest items
	 */
	function getNearestItems(chart, position, intersect, distanceMetric) {
		var minDistance = Number.POSITIVE_INFINITY;
		var nearestItems = [];

		parseVisibleItems(chart, function(element) {
			if (intersect && !element.inRange(position.x, position.y)) {
				return;
			}

			var center = element.getCenterPoint();
			var distance = distanceMetric(position, center);

			if (distance < minDistance) {
				nearestItems = [element];
				minDistance = distance;
			} else if (distance === minDistance) {
				// Can have multiple items at the same distance in which case we sort by size
				nearestItems.push(element);
			}
		});

		return nearestItems;
	}

	/**
	 * Get a distance metric function for two points based on the
	 * axis mode setting
	 * @param {String} axis the axis mode. x|y|xy
	 */
	function getDistanceMetricForAxis(axis) {
		var useX = axis.indexOf('x') !== -1;
		var useY = axis.indexOf('y') !== -1;

		return function(pt1, pt2) {
			var deltaX = useX ? Math.abs(pt1.x - pt2.x) : 0;
			var deltaY = useY ? Math.abs(pt1.y - pt2.y) : 0;
			return Math.sqrt(Math.pow(deltaX, 2) + Math.pow(deltaY, 2));
		};
	}

	function indexMode(chart, e, options) {
		var position = getRelativePosition(e, chart);
		// Default axis for index mode is 'x' to match old behaviour
		options.axis = options.axis || 'x';
		var distanceMetric = getDistanceMetricForAxis(options.axis);
		var items = options.intersect ? getIntersectItems(chart, position) : getNearestItems(chart, position, false, distanceMetric);
		var elements = [];

		if (!items.length) {
			return [];
		}

		chart.data.datasets.forEach(function(dataset, datasetIndex) {
			if (chart.isDatasetVisible(datasetIndex)) {
				var meta = chart.getDatasetMeta(datasetIndex);
				var element = meta.data[items[0]._index];

				// don't count items that are skipped (null data)
				if (element && !element._view.skip) {
					elements.push(element);
				}
			}
		});

		return elements;
	}

	/**
	 * @interface IInteractionOptions
	 */
	/**
	 * If true, only consider items that intersect the point
	 * @name IInterfaceOptions#boolean
	 * @type Boolean
	 */

	/**
	 * Contains interaction related functions
	 * @namespace Chart.Interaction
	 */
	var core_interaction = {
		// Helper function for different modes
		modes: {
			single: function(chart, e) {
				var position = getRelativePosition(e, chart);
				var elements = [];

				parseVisibleItems(chart, function(element) {
					if (element.inRange(position.x, position.y)) {
						elements.push(element);
						return elements;
					}
				});

				return elements.slice(0, 1);
			},

			/**
			 * @function Chart.Interaction.modes.label
			 * @deprecated since version 2.4.0
			 * @todo remove at version 3
			 * @private
			 */
			label: indexMode,

			/**
			 * Returns items at the same index. If the options.intersect parameter is true, we only return items if we intersect something
			 * If the options.intersect mode is false, we find the nearest item and return the items at the same index as that item
			 * @function Chart.Interaction.modes.index
			 * @since v2.4.0
			 * @param chart {chart} the chart we are returning items from
			 * @param e {Event} the event we are find things at
			 * @param options {IInteractionOptions} options to use during interaction
			 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
			 */
			index: indexMode,

			/**
			 * Returns items in the same dataset. If the options.intersect parameter is true, we only return items if we intersect something
			 * If the options.intersect is false, we find the nearest item and return the items in that dataset
			 * @function Chart.Interaction.modes.dataset
			 * @param chart {chart} the chart we are returning items from
			 * @param e {Event} the event we are find things at
			 * @param options {IInteractionOptions} options to use during interaction
			 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
			 */
			dataset: function(chart, e, options) {
				var position = getRelativePosition(e, chart);
				options.axis = options.axis || 'xy';
				var distanceMetric = getDistanceMetricForAxis(options.axis);
				var items = options.intersect ? getIntersectItems(chart, position) : getNearestItems(chart, position, false, distanceMetric);

				if (items.length > 0) {
					items = chart.getDatasetMeta(items[0]._datasetIndex).data;
				}

				return items;
			},

			/**
			 * @function Chart.Interaction.modes.x-axis
			 * @deprecated since version 2.4.0. Use index mode and intersect == true
			 * @todo remove at version 3
			 * @private
			 */
			'x-axis': function(chart, e) {
				return indexMode(chart, e, {intersect: false});
			},

			/**
			 * Point mode returns all elements that hit test based on the event position
			 * of the event
			 * @function Chart.Interaction.modes.intersect
			 * @param chart {chart} the chart we are returning items from
			 * @param e {Event} the event we are find things at
			 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
			 */
			point: function(chart, e) {
				var position = getRelativePosition(e, chart);
				return getIntersectItems(chart, position);
			},

			/**
			 * nearest mode returns the element closest to the point
			 * @function Chart.Interaction.modes.intersect
			 * @param chart {chart} the chart we are returning items from
			 * @param e {Event} the event we are find things at
			 * @param options {IInteractionOptions} options to use
			 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
			 */
			nearest: function(chart, e, options) {
				var position = getRelativePosition(e, chart);
				options.axis = options.axis || 'xy';
				var distanceMetric = getDistanceMetricForAxis(options.axis);
				var nearestItems = getNearestItems(chart, position, options.intersect, distanceMetric);

				// We have multiple items at the same distance from the event. Now sort by smallest
				if (nearestItems.length > 1) {
					nearestItems.sort(function(a, b) {
						var sizeA = a.getArea();
						var sizeB = b.getArea();
						var ret = sizeA - sizeB;

						if (ret === 0) {
							// if equal sort by dataset index
							ret = a._datasetIndex - b._datasetIndex;
						}

						return ret;
					});
				}

				// Return only 1 item
				return nearestItems.slice(0, 1);
			},

			/**
			 * x mode returns the elements that hit-test at the current x coordinate
			 * @function Chart.Interaction.modes.x
			 * @param chart {chart} the chart we are returning items from
			 * @param e {Event} the event we are find things at
			 * @param options {IInteractionOptions} options to use
			 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
			 */
			x: function(chart, e, options) {
				var position = getRelativePosition(e, chart);
				var items = [];
				var intersectsItem = false;

				parseVisibleItems(chart, function(element) {
					if (element.inXRange(position.x)) {
						items.push(element);
					}

					if (element.inRange(position.x, position.y)) {
						intersectsItem = true;
					}
				});

				// If we want to trigger on an intersect and we don't have any items
				// that intersect the position, return nothing
				if (options.intersect && !intersectsItem) {
					items = [];
				}
				return items;
			},

			/**
			 * y mode returns the elements that hit-test at the current y coordinate
			 * @function Chart.Interaction.modes.y
			 * @param chart {chart} the chart we are returning items from
			 * @param e {Event} the event we are find things at
			 * @param options {IInteractionOptions} options to use
			 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
			 */
			y: function(chart, e, options) {
				var position = getRelativePosition(e, chart);
				var items = [];
				var intersectsItem = false;

				parseVisibleItems(chart, function(element) {
					if (element.inYRange(position.y)) {
						items.push(element);
					}

					if (element.inRange(position.x, position.y)) {
						intersectsItem = true;
					}
				});

				// If we want to trigger on an intersect and we don't have any items
				// that intersect the position, return nothing
				if (options.intersect && !intersectsItem) {
					items = [];
				}
				return items;
			}
		}
	};
	var core_interaction_1 = core_interaction.modes;

	var core_interaction$1 = /*#__PURE__*/Object.freeze({
		default: core_interaction,
		__moduleExports: core_interaction,
		modes: core_interaction_1
	});

	/**
	 * Platform fallback implementation (minimal).
	 * @see https://github.com/chartjs/Chart.js/pull/4591#issuecomment-319575939
	 */

	var platform_basic = {
		acquireContext: function(item) {
			if (item && item.canvas) {
				// Support for any object associated to a canvas (including a context2d)
				item = item.canvas;
			}

			return item && item.getContext('2d') || null;
		}
	};
	var platform_basic_1 = platform_basic.acquireContext;

	var platform_basic$1 = /*#__PURE__*/Object.freeze({
		default: platform_basic,
		__moduleExports: platform_basic,
		acquireContext: platform_basic_1
	});

	var EXPANDO_KEY = '$chartjs';
	var CSS_PREFIX = 'chartjs-';
	var CSS_RENDER_MONITOR = CSS_PREFIX + 'render-monitor';
	var CSS_RENDER_ANIMATION = CSS_PREFIX + 'render-animation';
	var ANIMATION_START_EVENTS = ['animationstart', 'webkitAnimationStart'];

	/**
	 * DOM event types -> Chart.js event types.
	 * Note: only events with different types are mapped.
	 * @see https://developer.mozilla.org/en-US/docs/Web/Events
	 */
	var EVENT_TYPES = {
		touchstart: 'mousedown',
		touchmove: 'mousemove',
		touchend: 'mouseup',
		pointerenter: 'mouseenter',
		pointerdown: 'mousedown',
		pointermove: 'mousemove',
		pointerup: 'mouseup',
		pointerleave: 'mouseout',
		pointerout: 'mouseout'
	};

	/**
	 * The "used" size is the final value of a dimension property after all calculations have
	 * been performed. This method uses the computed style of `element` but returns undefined
	 * if the computed style is not expressed in pixels. That can happen in some cases where
	 * `element` has a size relative to its parent and this last one is not yet displayed,
	 * for example because of `display: none` on a parent node.
	 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/used_value
	 * @returns {Number} Size in pixels or undefined if unknown.
	 */
	function readUsedSize(element, property) {
		var value = helpers$4.getStyle(element, property);
		var matches = value && value.match(/^(\d+)(\.\d+)?px$/);
		return matches ? Number(matches[1]) : undefined;
	}

	/**
	 * Initializes the canvas style and render size without modifying the canvas display size,
	 * since responsiveness is handled by the controller.resize() method. The config is used
	 * to determine the aspect ratio to apply in case no explicit height has been specified.
	 */
	function initCanvas(canvas, config) {
		var style = canvas.style;

		// NOTE(SB) canvas.getAttribute('width') !== canvas.width: in the first case it
		// returns null or '' if no explicit value has been set to the canvas attribute.
		var renderHeight = canvas.getAttribute('height');
		var renderWidth = canvas.getAttribute('width');

		// Chart.js modifies some canvas values that we want to restore on destroy
		canvas[EXPANDO_KEY] = {
			initial: {
				height: renderHeight,
				width: renderWidth,
				style: {
					display: style.display,
					height: style.height,
					width: style.width
				}
			}
		};

		// Force canvas to display as block to avoid extra space caused by inline
		// elements, which would interfere with the responsive resize process.
		// https://github.com/chartjs/Chart.js/issues/2538
		style.display = style.display || 'block';

		if (renderWidth === null || renderWidth === '') {
			var displayWidth = readUsedSize(canvas, 'width');
			if (displayWidth !== undefined) {
				canvas.width = displayWidth;
			}
		}

		if (renderHeight === null || renderHeight === '') {
			if (canvas.style.height === '') {
				// If no explicit render height and style height, let's apply the aspect ratio,
				// which one can be specified by the user but also by charts as default option
				// (i.e. options.aspectRatio). If not specified, use canvas aspect ratio of 2.
				canvas.height = canvas.width / (config.options.aspectRatio || 2);
			} else {
				var displayHeight = readUsedSize(canvas, 'height');
				if (displayWidth !== undefined) {
					canvas.height = displayHeight;
				}
			}
		}

		return canvas;
	}

	/**
	 * Detects support for options object argument in addEventListener.
	 * https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Safely_detecting_option_support
	 * @private
	 */
	var supportsEventListenerOptions = (function() {
		var supports = false;
		try {
			var options = Object.defineProperty({}, 'passive', {
				get: function() {
					supports = true;
				}
			});
			window.addEventListener('e', null, options);
		} catch (e) {
			// continue regardless of error
		}
		return supports;
	}());

	// Default passive to true as expected by Chrome for 'touchstart' and 'touchend' events.
	// https://github.com/chartjs/Chart.js/issues/4287
	var eventListenerOptions = supportsEventListenerOptions ? {passive: true} : false;

	function addEventListener$1(node, type, listener) {
		node.addEventListener(type, listener, eventListenerOptions);
	}

	function removeEventListener(node, type, listener) {
		node.removeEventListener(type, listener, eventListenerOptions);
	}

	function createEvent(type, chart, x, y, nativeEvent) {
		return {
			type: type,
			chart: chart,
			native: nativeEvent || null,
			x: x !== undefined ? x : null,
			y: y !== undefined ? y : null,
		};
	}

	function fromNativeEvent(event, chart) {
		var type = EVENT_TYPES[event.type] || event.type;
		var pos = helpers$4.getRelativePosition(event, chart);
		return createEvent(type, chart, pos.x, pos.y, event);
	}

	function throttled(fn, thisArg) {
		var ticking = false;
		var args = [];

		return function() {
			args = Array.prototype.slice.call(arguments);
			thisArg = thisArg || this;

			if (!ticking) {
				ticking = true;
				helpers$4.requestAnimFrame.call(window, function() {
					ticking = false;
					fn.apply(thisArg, args);
				});
			}
		};
	}

	// Implementation based on https://github.com/marcj/css-element-queries
	function createResizer(handler) {
		var resizer = document.createElement('div');
		var cls = CSS_PREFIX + 'size-monitor';
		var maxSize = 1000000;
		var style =
			'position:absolute;' +
			'left:0;' +
			'top:0;' +
			'right:0;' +
			'bottom:0;' +
			'overflow:hidden;' +
			'pointer-events:none;' +
			'visibility:hidden;' +
			'z-index:-1;';

		resizer.style.cssText = style;
		resizer.className = cls;
		resizer.innerHTML =
			'<div class="' + cls + '-expand" style="' + style + '">' +
				'<div style="' +
					'position:absolute;' +
					'width:' + maxSize + 'px;' +
					'height:' + maxSize + 'px;' +
					'left:0;' +
					'top:0">' +
				'</div>' +
			'</div>' +
			'<div class="' + cls + '-shrink" style="' + style + '">' +
				'<div style="' +
					'position:absolute;' +
					'width:200%;' +
					'height:200%;' +
					'left:0; ' +
					'top:0">' +
				'</div>' +
			'</div>';

		var expand = resizer.childNodes[0];
		var shrink = resizer.childNodes[1];

		resizer._reset = function() {
			expand.scrollLeft = maxSize;
			expand.scrollTop = maxSize;
			shrink.scrollLeft = maxSize;
			shrink.scrollTop = maxSize;
		};
		var onScroll = function() {
			resizer._reset();
			handler();
		};

		addEventListener$1(expand, 'scroll', onScroll.bind(expand, 'expand'));
		addEventListener$1(shrink, 'scroll', onScroll.bind(shrink, 'shrink'));

		return resizer;
	}

	// https://davidwalsh.name/detect-node-insertion
	function watchForRender(node, handler) {
		var expando = node[EXPANDO_KEY] || (node[EXPANDO_KEY] = {});
		var proxy = expando.renderProxy = function(e) {
			if (e.animationName === CSS_RENDER_ANIMATION) {
				handler();
			}
		};

		helpers$4.each(ANIMATION_START_EVENTS, function(type) {
			addEventListener$1(node, type, proxy);
		});

		// #4737: Chrome might skip the CSS animation when the CSS_RENDER_MONITOR class
		// is removed then added back immediately (same animation frame?). Accessing the
		// `offsetParent` property will force a reflow and re-evaluate the CSS animation.
		// https://gist.github.com/paulirish/5d52fb081b3570c81e3a#box-metrics
		// https://github.com/chartjs/Chart.js/issues/4737
		expando.reflow = !!node.offsetParent;

		node.classList.add(CSS_RENDER_MONITOR);
	}

	function unwatchForRender(node) {
		var expando = node[EXPANDO_KEY] || {};
		var proxy = expando.renderProxy;

		if (proxy) {
			helpers$4.each(ANIMATION_START_EVENTS, function(type) {
				removeEventListener(node, type, proxy);
			});

			delete expando.renderProxy;
		}

		node.classList.remove(CSS_RENDER_MONITOR);
	}

	function addResizeListener(node, listener, chart) {
		var expando = node[EXPANDO_KEY] || (node[EXPANDO_KEY] = {});

		// Let's keep track of this added resizer and thus avoid DOM query when removing it.
		var resizer = expando.resizer = createResizer(throttled(function() {
			if (expando.resizer) {
				return listener(createEvent('resize', chart));
			}
		}));

		// The resizer needs to be attached to the node parent, so we first need to be
		// sure that `node` is attached to the DOM before injecting the resizer element.
		watchForRender(node, function() {
			if (expando.resizer) {
				var container = node.parentNode;
				if (container && container !== resizer.parentNode) {
					container.insertBefore(resizer, container.firstChild);
				}

				// The container size might have changed, let's reset the resizer state.
				resizer._reset();
			}
		});
	}

	function removeResizeListener(node) {
		var expando = node[EXPANDO_KEY] || {};
		var resizer = expando.resizer;

		delete expando.resizer;
		unwatchForRender(node);

		if (resizer && resizer.parentNode) {
			resizer.parentNode.removeChild(resizer);
		}
	}

	function injectCSS(platform, css) {
		// http://stackoverflow.com/q/3922139
		var style = platform._style || document.createElement('style');
		if (!platform._style) {
			platform._style = style;
			css = '/* Chart.js */\n' + css;
			style.setAttribute('type', 'text/css');
			document.getElementsByTagName('head')[0].appendChild(style);
		}

		style.appendChild(document.createTextNode(css));
	}

	var platform_dom = {
		/**
		 * This property holds whether this platform is enabled for the current environment.
		 * Currently used by platform.js to select the proper implementation.
		 * @private
		 */
		_enabled: typeof window !== 'undefined' && typeof document !== 'undefined',

		initialize: function() {
			var keyframes = 'from{opacity:0.99}to{opacity:1}';

			injectCSS(this,
				// DOM rendering detection
				// https://davidwalsh.name/detect-node-insertion
				'@-webkit-keyframes ' + CSS_RENDER_ANIMATION + '{' + keyframes + '}' +
				'@keyframes ' + CSS_RENDER_ANIMATION + '{' + keyframes + '}' +
				'.' + CSS_RENDER_MONITOR + '{' +
					'-webkit-animation:' + CSS_RENDER_ANIMATION + ' 0.001s;' +
					'animation:' + CSS_RENDER_ANIMATION + ' 0.001s;' +
				'}'
			);
		},

		acquireContext: function(item, config) {
			if (typeof item === 'string') {
				item = document.getElementById(item);
			} else if (item.length) {
				// Support for array based queries (such as jQuery)
				item = item[0];
			}

			if (item && item.canvas) {
				// Support for any object associated to a canvas (including a context2d)
				item = item.canvas;
			}

			// To prevent canvas fingerprinting, some add-ons undefine the getContext
			// method, for example: https://github.com/kkapsner/CanvasBlocker
			// https://github.com/chartjs/Chart.js/issues/2807
			var context = item && item.getContext && item.getContext('2d');

			// `instanceof HTMLCanvasElement/CanvasRenderingContext2D` fails when the item is
			// inside an iframe or when running in a protected environment. We could guess the
			// types from their toString() value but let's keep things flexible and assume it's
			// a sufficient condition if the item has a context2D which has item as `canvas`.
			// https://github.com/chartjs/Chart.js/issues/3887
			// https://github.com/chartjs/Chart.js/issues/4102
			// https://github.com/chartjs/Chart.js/issues/4152
			if (context && context.canvas === item) {
				initCanvas(item, config);
				return context;
			}

			return null;
		},

		releaseContext: function(context) {
			var canvas = context.canvas;
			if (!canvas[EXPANDO_KEY]) {
				return;
			}

			var initial = canvas[EXPANDO_KEY].initial;
			['height', 'width'].forEach(function(prop) {
				var value = initial[prop];
				if (helpers$4.isNullOrUndef(value)) {
					canvas.removeAttribute(prop);
				} else {
					canvas.setAttribute(prop, value);
				}
			});

			helpers$4.each(initial.style || {}, function(value, key) {
				canvas.style[key] = value;
			});

			// The canvas render size might have been changed (and thus the state stack discarded),
			// we can't use save() and restore() to restore the initial state. So make sure that at
			// least the canvas context is reset to the default state by setting the canvas width.
			// https://www.w3.org/TR/2011/WD-html5-20110525/the-canvas-element.html
			canvas.width = canvas.width;

			delete canvas[EXPANDO_KEY];
		},

		addEventListener: function(chart, type, listener) {
			var canvas = chart.canvas;
			if (type === 'resize') {
				// Note: the resize event is not supported on all browsers.
				addResizeListener(canvas, listener, chart);
				return;
			}

			var expando = listener[EXPANDO_KEY] || (listener[EXPANDO_KEY] = {});
			var proxies = expando.proxies || (expando.proxies = {});
			var proxy = proxies[chart.id + '_' + type] = function(event) {
				listener(fromNativeEvent(event, chart));
			};

			addEventListener$1(canvas, type, proxy);
		},

		removeEventListener: function(chart, type, listener) {
			var canvas = chart.canvas;
			if (type === 'resize') {
				// Note: the resize event is not supported on all browsers.
				removeResizeListener(canvas, listener);
				return;
			}

			var expando = listener[EXPANDO_KEY] || {};
			var proxies = expando.proxies || {};
			var proxy = proxies[chart.id + '_' + type];
			if (!proxy) {
				return;
			}

			removeEventListener(canvas, type, proxy);
		}
	};

	// DEPRECATIONS

	/**
	 * Provided for backward compatibility, use EventTarget.addEventListener instead.
	 * EventTarget.addEventListener compatibility: Chrome, Opera 7, Safari, FF1.5+, IE9+
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener
	 * @function Chart.helpers.addEvent
	 * @deprecated since version 2.7.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers$4.addEvent = addEventListener$1;

	/**
	 * Provided for backward compatibility, use EventTarget.removeEventListener instead.
	 * EventTarget.removeEventListener compatibility: Chrome, Opera 7, Safari, FF1.5+, IE9+
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/removeEventListener
	 * @function Chart.helpers.removeEvent
	 * @deprecated since version 2.7.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers$4.removeEvent = removeEventListener;
	var platform_dom_1 = platform_dom._enabled;
	var platform_dom_2 = platform_dom.initialize;
	var platform_dom_3 = platform_dom.acquireContext;
	var platform_dom_4 = platform_dom.releaseContext;
	var platform_dom_5 = platform_dom.addEventListener;
	var platform_dom_6 = platform_dom.removeEventListener;

	var platform_dom$1 = /*#__PURE__*/Object.freeze({
		default: platform_dom,
		__moduleExports: platform_dom,
		_enabled: platform_dom_1,
		initialize: platform_dom_2,
		acquireContext: platform_dom_3,
		releaseContext: platform_dom_4,
		addEventListener: platform_dom_5,
		removeEventListener: platform_dom_6
	});

	var basic = ( platform_basic$1 && platform_basic ) || platform_basic$1;

	var dom = ( platform_dom$1 && platform_dom ) || platform_dom$1;

	// @TODO Make possible to select another platform at build time.
	var implementation = dom._enabled ? dom : basic;

	/**
	 * @namespace Chart.platform
	 * @see https://chartjs.gitbooks.io/proposals/content/Platform.html
	 * @since 2.4.0
	 */
	var platform = helpers$4.extend({
		/**
		 * @since 2.7.0
		 */
		initialize: function() {},

		/**
		 * Called at chart construction time, returns a context2d instance implementing
		 * the [W3C Canvas 2D Context API standard]{@link https://www.w3.org/TR/2dcontext/}.
		 * @param {*} item - The native item from which to acquire context (platform specific)
		 * @param {Object} options - The chart options
		 * @returns {CanvasRenderingContext2D} context2d instance
		 */
		acquireContext: function() {},

		/**
		 * Called at chart destruction time, releases any resources associated to the context
		 * previously returned by the acquireContext() method.
		 * @param {CanvasRenderingContext2D} context - The context2d instance
		 * @returns {Boolean} true if the method succeeded, else false
		 */
		releaseContext: function() {},

		/**
		 * Registers the specified listener on the given chart.
		 * @param {Chart} chart - Chart from which to listen for event
		 * @param {String} type - The ({@link IEvent}) type to listen for
		 * @param {Function} listener - Receives a notification (an object that implements
		 * the {@link IEvent} interface) when an event of the specified type occurs.
		 */
		addEventListener: function() {},

		/**
		 * Removes the specified listener previously registered with addEventListener.
		 * @param {Chart} chart -Chart from which to remove the listener
		 * @param {String} type - The ({@link IEvent}) type to remove
		 * @param {Function} listener - The listener function to remove from the event target.
		 */
		removeEventListener: function() {}

	}, implementation);

	var platform$1 = /*#__PURE__*/Object.freeze({
		default: platform,
		__moduleExports: platform
	});

	defaults$3._set('global', {
		plugins: {}
	});

	/**
	 * The plugin service singleton
	 * @namespace Chart.plugins
	 * @since 2.1.0
	 */
	var core_plugins = {
		/**
		 * Globally registered plugins.
		 * @private
		 */
		_plugins: [],

		/**
		 * This identifier is used to invalidate the descriptors cache attached to each chart
		 * when a global plugin is registered or unregistered. In this case, the cache ID is
		 * incremented and descriptors are regenerated during following API calls.
		 * @private
		 */
		_cacheId: 0,

		/**
		 * Registers the given plugin(s) if not already registered.
		 * @param {Array|Object} plugins plugin instance(s).
		 */
		register: function(plugins) {
			var p = this._plugins;
			([]).concat(plugins).forEach(function(plugin) {
				if (p.indexOf(plugin) === -1) {
					p.push(plugin);
				}
			});

			this._cacheId++;
		},

		/**
		 * Unregisters the given plugin(s) only if registered.
		 * @param {Array|Object} plugins plugin instance(s).
		 */
		unregister: function(plugins) {
			var p = this._plugins;
			([]).concat(plugins).forEach(function(plugin) {
				var idx = p.indexOf(plugin);
				if (idx !== -1) {
					p.splice(idx, 1);
				}
			});

			this._cacheId++;
		},

		/**
		 * Remove all registered plugins.
		 * @since 2.1.5
		 */
		clear: function() {
			this._plugins = [];
			this._cacheId++;
		},

		/**
		 * Returns the number of registered plugins?
		 * @returns {Number}
		 * @since 2.1.5
		 */
		count: function() {
			return this._plugins.length;
		},

		/**
		 * Returns all registered plugin instances.
		 * @returns {Array} array of plugin objects.
		 * @since 2.1.5
		 */
		getAll: function() {
			return this._plugins;
		},

		/**
		 * Calls enabled plugins for `chart` on the specified hook and with the given args.
		 * This method immediately returns as soon as a plugin explicitly returns false. The
		 * returned value can be used, for instance, to interrupt the current action.
		 * @param {Object} chart - The chart instance for which plugins should be called.
		 * @param {String} hook - The name of the plugin method to call (e.g. 'beforeUpdate').
		 * @param {Array} [args] - Extra arguments to apply to the hook call.
		 * @returns {Boolean} false if any of the plugins return false, else returns true.
		 */
		notify: function(chart, hook, args) {
			var descriptors = this.descriptors(chart);
			var ilen = descriptors.length;
			var i, descriptor, plugin, params, method;

			for (i = 0; i < ilen; ++i) {
				descriptor = descriptors[i];
				plugin = descriptor.plugin;
				method = plugin[hook];
				if (typeof method === 'function') {
					params = [chart].concat(args || []);
					params.push(descriptor.options);
					if (method.apply(plugin, params) === false) {
						return false;
					}
				}
			}

			return true;
		},

		/**
		 * Returns descriptors of enabled plugins for the given chart.
		 * @returns {Array} [{ plugin, options }]
		 * @private
		 */
		descriptors: function(chart) {
			var cache = chart.$plugins || (chart.$plugins = {});
			if (cache.id === this._cacheId) {
				return cache.descriptors;
			}

			var plugins = [];
			var descriptors = [];
			var config = (chart && chart.config) || {};
			var options = (config.options && config.options.plugins) || {};

			this._plugins.concat(config.plugins || []).forEach(function(plugin) {
				var idx = plugins.indexOf(plugin);
				if (idx !== -1) {
					return;
				}

				var id = plugin.id;
				var opts = options[id];
				if (opts === false) {
					return;
				}

				if (opts === true) {
					opts = helpers$4.clone(defaults$3.global.plugins[id]);
				}

				plugins.push(plugin);
				descriptors.push({
					plugin: plugin,
					options: opts || {}
				});
			});

			cache.descriptors = descriptors;
			cache.id = this._cacheId;
			return descriptors;
		},

		/**
		 * Invalidates cache for the given chart: descriptors hold a reference on plugin option,
		 * but in some cases, this reference can be changed by the user when updating options.
		 * https://github.com/chartjs/Chart.js/issues/5111#issuecomment-355934167
		 * @private
		 */
		_invalidate: function(chart) {
			delete chart.$plugins;
		}
	};
	var core_plugins_1 = core_plugins._plugins;
	var core_plugins_2 = core_plugins._cacheId;
	var core_plugins_3 = core_plugins.register;
	var core_plugins_4 = core_plugins.unregister;
	var core_plugins_5 = core_plugins.clear;
	var core_plugins_6 = core_plugins.count;
	var core_plugins_7 = core_plugins.getAll;
	var core_plugins_8 = core_plugins.notify;
	var core_plugins_9 = core_plugins.descriptors;
	var core_plugins_10 = core_plugins._invalidate;

	var core_plugins$1 = /*#__PURE__*/Object.freeze({
		default: core_plugins,
		__moduleExports: core_plugins,
		_plugins: core_plugins_1,
		_cacheId: core_plugins_2,
		register: core_plugins_3,
		unregister: core_plugins_4,
		clear: core_plugins_5,
		count: core_plugins_6,
		getAll: core_plugins_7,
		notify: core_plugins_8,
		descriptors: core_plugins_9,
		_invalidate: core_plugins_10
	});

	/**
	 * Namespace to hold static tick generation functions
	 * @namespace Chart.Ticks
	 */
	var core_ticks = {
		/**
		 * Namespace to hold formatters for different types of ticks
		 * @namespace Chart.Ticks.formatters
		 */
		formatters: {
			/**
			 * Formatter for value labels
			 * @method Chart.Ticks.formatters.values
			 * @param value the value to display
			 * @return {String|Array} the label to display
			 */
			values: function(value) {
				return helpers$4.isArray(value) ? value : '' + value;
			},

			/**
			 * Formatter for linear numeric ticks
			 * @method Chart.Ticks.formatters.linear
			 * @param tickValue {Number} the value to be formatted
			 * @param index {Number} the position of the tickValue parameter in the ticks array
			 * @param ticks {Array<Number>} the list of ticks being converted
			 * @return {String} string representation of the tickValue parameter
			 */
			linear: function(tickValue, index, ticks) {
				// If we have lots of ticks, don't use the ones
				var delta = ticks.length > 3 ? ticks[2] - ticks[1] : ticks[1] - ticks[0];

				// If we have a number like 2.5 as the delta, figure out how many decimal places we need
				if (Math.abs(delta) > 1) {
					if (tickValue !== Math.floor(tickValue)) {
						// not an integer
						delta = tickValue - Math.floor(tickValue);
					}
				}

				var logDelta = helpers$4.log10(Math.abs(delta));
				var tickString = '';

				if (tickValue !== 0) {
					var maxTick = Math.max(Math.abs(ticks[0]), Math.abs(ticks[ticks.length - 1]));
					if (maxTick < 1e-4) { // all ticks are small numbers; use scientific notation
						var logTick = helpers$4.log10(Math.abs(tickValue));
						tickString = tickValue.toExponential(Math.floor(logTick) - Math.floor(logDelta));
					} else {
						var numDecimal = -1 * Math.floor(logDelta);
						numDecimal = Math.max(Math.min(numDecimal, 20), 0); // toFixed has a max of 20 decimal places
						tickString = tickValue.toFixed(numDecimal);
					}
				} else {
					tickString = '0'; // never show decimal places for 0
				}

				return tickString;
			},

			logarithmic: function(tickValue, index, ticks) {
				var remain = tickValue / (Math.pow(10, Math.floor(helpers$4.log10(tickValue))));

				if (tickValue === 0) {
					return '0';
				} else if (remain === 1 || remain === 2 || remain === 5 || index === 0 || index === ticks.length - 1) {
					return tickValue.toExponential();
				}
				return '';
			}
		}
	};
	var core_ticks_1 = core_ticks.formatters;

	var core_ticks$1 = /*#__PURE__*/Object.freeze({
		default: core_ticks,
		__moduleExports: core_ticks,
		formatters: core_ticks_1
	});

	var Ticks = ( core_ticks$1 && core_ticks ) || core_ticks$1;

	defaults$3._set('scale', {
		display: true,
		position: 'left',
		offset: false,

		// grid line settings
		gridLines: {
			display: true,
			color: 'rgba(0, 0, 0, 0.1)',
			lineWidth: 1,
			drawBorder: true,
			drawOnChartArea: true,
			drawTicks: true,
			tickMarkLength: 10,
			zeroLineWidth: 1,
			zeroLineColor: 'rgba(0,0,0,0.25)',
			zeroLineBorderDash: [],
			zeroLineBorderDashOffset: 0.0,
			offsetGridLines: false,
			borderDash: [],
			borderDashOffset: 0.0
		},

		// scale label
		scaleLabel: {
			// display property
			display: false,

			// actual label
			labelString: '',

			// line height
			lineHeight: 1.2,

			// top/bottom padding
			padding: {
				top: 4,
				bottom: 4
			}
		},

		// label settings
		ticks: {
			beginAtZero: false,
			minRotation: 0,
			maxRotation: 50,
			mirror: false,
			padding: 0,
			reverse: false,
			display: true,
			autoSkip: true,
			autoSkipPadding: 0,
			labelOffset: 0,
			// We pass through arrays to be rendered as multiline labels, we convert Others to strings here.
			callback: Ticks.formatters.values,
			minor: {},
			major: {}
		}
	});

	function labelsFromTicks(ticks) {
		var labels = [];
		var i, ilen;

		for (i = 0, ilen = ticks.length; i < ilen; ++i) {
			labels.push(ticks[i].label);
		}

		return labels;
	}

	function getLineValue(scale, index, offsetGridLines) {
		var lineValue = scale.getPixelForTick(index);

		if (offsetGridLines) {
			if (index === 0) {
				lineValue -= (scale.getPixelForTick(1) - lineValue) / 2;
			} else {
				lineValue -= (lineValue - scale.getPixelForTick(index - 1)) / 2;
			}
		}
		return lineValue;
	}

	function computeTextSize(context, tick, font) {
		return helpers$4.isArray(tick) ?
			helpers$4.longestText(context, font, tick) :
			context.measureText(tick).width;
	}

	function parseFontOptions(options) {
		var valueOrDefault = helpers$4.valueOrDefault;
		var globalDefaults = defaults$3.global;
		var size = valueOrDefault(options.fontSize, globalDefaults.defaultFontSize);
		var style = valueOrDefault(options.fontStyle, globalDefaults.defaultFontStyle);
		var family = valueOrDefault(options.fontFamily, globalDefaults.defaultFontFamily);

		return {
			size: size,
			style: style,
			family: family,
			font: helpers$4.fontString(size, style, family)
		};
	}

	function parseLineHeight(options) {
		return helpers$4.options.toLineHeight(
			helpers$4.valueOrDefault(options.lineHeight, 1.2),
			helpers$4.valueOrDefault(options.fontSize, defaults$3.global.defaultFontSize));
	}

	var core_scale = Element$1.extend({
		/**
		 * Get the padding needed for the scale
		 * @method getPadding
		 * @private
		 * @returns {Padding} the necessary padding
		 */
		getPadding: function() {
			var me = this;
			return {
				left: me.paddingLeft || 0,
				top: me.paddingTop || 0,
				right: me.paddingRight || 0,
				bottom: me.paddingBottom || 0
			};
		},

		/**
		 * Returns the scale tick objects ({label, major})
		 * @since 2.7
		 */
		getTicks: function() {
			return this._ticks;
		},

		// These methods are ordered by lifecyle. Utilities then follow.
		// Any function defined here is inherited by all scale types.
		// Any function can be extended by the scale type

		mergeTicksOptions: function() {
			var ticks = this.options.ticks;
			if (ticks.minor === false) {
				ticks.minor = {
					display: false
				};
			}
			if (ticks.major === false) {
				ticks.major = {
					display: false
				};
			}
			for (var key in ticks) {
				if (key !== 'major' && key !== 'minor') {
					if (typeof ticks.minor[key] === 'undefined') {
						ticks.minor[key] = ticks[key];
					}
					if (typeof ticks.major[key] === 'undefined') {
						ticks.major[key] = ticks[key];
					}
				}
			}
		},
		beforeUpdate: function() {
			helpers$4.callback(this.options.beforeUpdate, [this]);
		},

		update: function(maxWidth, maxHeight, margins) {
			var me = this;
			var i, ilen, labels, label, ticks, tick;

			// Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
			me.beforeUpdate();

			// Absorb the master measurements
			me.maxWidth = maxWidth;
			me.maxHeight = maxHeight;
			me.margins = helpers$4.extend({
				left: 0,
				right: 0,
				top: 0,
				bottom: 0
			}, margins);
			me.longestTextCache = me.longestTextCache || {};

			// Dimensions
			me.beforeSetDimensions();
			me.setDimensions();
			me.afterSetDimensions();

			// Data min/max
			me.beforeDataLimits();
			me.determineDataLimits();
			me.afterDataLimits();

			// Ticks - `this.ticks` is now DEPRECATED!
			// Internal ticks are now stored as objects in the PRIVATE `this._ticks` member
			// and must not be accessed directly from outside this class. `this.ticks` being
			// around for long time and not marked as private, we can't change its structure
			// without unexpected breaking changes. If you need to access the scale ticks,
			// use scale.getTicks() instead.

			me.beforeBuildTicks();

			// New implementations should return an array of objects but for BACKWARD COMPAT,
			// we still support no return (`this.ticks` internally set by calling this method).
			ticks = me.buildTicks() || [];

			me.afterBuildTicks();

			me.beforeTickToLabelConversion();

			// New implementations should return the formatted tick labels but for BACKWARD
			// COMPAT, we still support no return (`this.ticks` internally changed by calling
			// this method and supposed to contain only string values).
			labels = me.convertTicksToLabels(ticks) || me.ticks;

			me.afterTickToLabelConversion();

			me.ticks = labels;   // BACKWARD COMPATIBILITY

			// IMPORTANT: from this point, we consider that `this.ticks` will NEVER change!

			// BACKWARD COMPAT: synchronize `_ticks` with labels (so potentially `this.ticks`)
			for (i = 0, ilen = labels.length; i < ilen; ++i) {
				label = labels[i];
				tick = ticks[i];
				if (!tick) {
					ticks.push(tick = {
						label: label,
						major: false
					});
				} else {
					tick.label = label;
				}
			}

			me._ticks = ticks;

			// Tick Rotation
			me.beforeCalculateTickRotation();
			me.calculateTickRotation();
			me.afterCalculateTickRotation();
			// Fit
			me.beforeFit();
			me.fit();
			me.afterFit();
			//
			me.afterUpdate();

			return me.minSize;

		},
		afterUpdate: function() {
			helpers$4.callback(this.options.afterUpdate, [this]);
		},

		//

		beforeSetDimensions: function() {
			helpers$4.callback(this.options.beforeSetDimensions, [this]);
		},
		setDimensions: function() {
			var me = this;
			// Set the unconstrained dimension before label rotation
			if (me.isHorizontal()) {
				// Reset position before calculating rotation
				me.width = me.maxWidth;
				me.left = 0;
				me.right = me.width;
			} else {
				me.height = me.maxHeight;

				// Reset position before calculating rotation
				me.top = 0;
				me.bottom = me.height;
			}

			// Reset padding
			me.paddingLeft = 0;
			me.paddingTop = 0;
			me.paddingRight = 0;
			me.paddingBottom = 0;
		},
		afterSetDimensions: function() {
			helpers$4.callback(this.options.afterSetDimensions, [this]);
		},

		// Data limits
		beforeDataLimits: function() {
			helpers$4.callback(this.options.beforeDataLimits, [this]);
		},
		determineDataLimits: helpers$4.noop,
		afterDataLimits: function() {
			helpers$4.callback(this.options.afterDataLimits, [this]);
		},

		//
		beforeBuildTicks: function() {
			helpers$4.callback(this.options.beforeBuildTicks, [this]);
		},
		buildTicks: helpers$4.noop,
		afterBuildTicks: function() {
			helpers$4.callback(this.options.afterBuildTicks, [this]);
		},

		beforeTickToLabelConversion: function() {
			helpers$4.callback(this.options.beforeTickToLabelConversion, [this]);
		},
		convertTicksToLabels: function() {
			var me = this;
			// Convert ticks to strings
			var tickOpts = me.options.ticks;
			me.ticks = me.ticks.map(tickOpts.userCallback || tickOpts.callback, this);
		},
		afterTickToLabelConversion: function() {
			helpers$4.callback(this.options.afterTickToLabelConversion, [this]);
		},

		//

		beforeCalculateTickRotation: function() {
			helpers$4.callback(this.options.beforeCalculateTickRotation, [this]);
		},
		calculateTickRotation: function() {
			var me = this;
			var context = me.ctx;
			var tickOpts = me.options.ticks;
			var labels = labelsFromTicks(me._ticks);

			// Get the width of each grid by calculating the difference
			// between x offsets between 0 and 1.
			var tickFont = parseFontOptions(tickOpts);
			context.font = tickFont.font;

			var labelRotation = tickOpts.minRotation || 0;

			if (labels.length && me.options.display && me.isHorizontal()) {
				var originalLabelWidth = helpers$4.longestText(context, tickFont.font, labels, me.longestTextCache);
				var labelWidth = originalLabelWidth;
				var cosRotation, sinRotation;

				// Allow 3 pixels x2 padding either side for label readability
				var tickWidth = me.getPixelForTick(1) - me.getPixelForTick(0) - 6;

				// Max label rotation can be set or default to 90 - also act as a loop counter
				while (labelWidth > tickWidth && labelRotation < tickOpts.maxRotation) {
					var angleRadians = helpers$4.toRadians(labelRotation);
					cosRotation = Math.cos(angleRadians);
					sinRotation = Math.sin(angleRadians);

					if (sinRotation * originalLabelWidth > me.maxHeight) {
						// go back one step
						labelRotation--;
						break;
					}

					labelRotation++;
					labelWidth = cosRotation * originalLabelWidth;
				}
			}

			me.labelRotation = labelRotation;
		},
		afterCalculateTickRotation: function() {
			helpers$4.callback(this.options.afterCalculateTickRotation, [this]);
		},

		//

		beforeFit: function() {
			helpers$4.callback(this.options.beforeFit, [this]);
		},
		fit: function() {
			var me = this;
			// Reset
			var minSize = me.minSize = {
				width: 0,
				height: 0
			};

			var labels = labelsFromTicks(me._ticks);

			var opts = me.options;
			var tickOpts = opts.ticks;
			var scaleLabelOpts = opts.scaleLabel;
			var gridLineOpts = opts.gridLines;
			var display = opts.display;
			var isHorizontal = me.isHorizontal();

			var tickFont = parseFontOptions(tickOpts);
			var tickMarkLength = opts.gridLines.tickMarkLength;

			// Width
			if (isHorizontal) {
				// subtract the margins to line up with the chartArea if we are a full width scale
				minSize.width = me.isFullWidth() ? me.maxWidth - me.margins.left - me.margins.right : me.maxWidth;
			} else {
				minSize.width = display && gridLineOpts.drawTicks ? tickMarkLength : 0;
			}

			// height
			if (isHorizontal) {
				minSize.height = display && gridLineOpts.drawTicks ? tickMarkLength : 0;
			} else {
				minSize.height = me.maxHeight; // fill all the height
			}

			// Are we showing a title for the scale?
			if (scaleLabelOpts.display && display) {
				var scaleLabelLineHeight = parseLineHeight(scaleLabelOpts);
				var scaleLabelPadding = helpers$4.options.toPadding(scaleLabelOpts.padding);
				var deltaHeight = scaleLabelLineHeight + scaleLabelPadding.height;

				if (isHorizontal) {
					minSize.height += deltaHeight;
				} else {
					minSize.width += deltaHeight;
				}
			}

			// Don't bother fitting the ticks if we are not showing them
			if (tickOpts.display && display) {
				var largestTextWidth = helpers$4.longestText(me.ctx, tickFont.font, labels, me.longestTextCache);
				var tallestLabelHeightInLines = helpers$4.numberOfLabelLines(labels);
				var lineSpace = tickFont.size * 0.5;
				var tickPadding = me.options.ticks.padding;

				if (isHorizontal) {
					// A horizontal axis is more constrained by the height.
					me.longestLabelWidth = largestTextWidth;

					var angleRadians = helpers$4.toRadians(me.labelRotation);
					var cosRotation = Math.cos(angleRadians);
					var sinRotation = Math.sin(angleRadians);

					// TODO - improve this calculation
					var labelHeight = (sinRotation * largestTextWidth)
						+ (tickFont.size * tallestLabelHeightInLines)
						+ (lineSpace * (tallestLabelHeightInLines - 1))
						+ lineSpace; // padding

					minSize.height = Math.min(me.maxHeight, minSize.height + labelHeight + tickPadding);

					me.ctx.font = tickFont.font;
					var firstLabelWidth = computeTextSize(me.ctx, labels[0], tickFont.font);
					var lastLabelWidth = computeTextSize(me.ctx, labels[labels.length - 1], tickFont.font);

					// Ensure that our ticks are always inside the canvas. When rotated, ticks are right aligned
					// which means that the right padding is dominated by the font height
					if (me.labelRotation !== 0) {
						me.paddingLeft = opts.position === 'bottom' ? (cosRotation * firstLabelWidth) + 3 : (cosRotation * lineSpace) + 3; // add 3 px to move away from canvas edges
						me.paddingRight = opts.position === 'bottom' ? (cosRotation * lineSpace) + 3 : (cosRotation * lastLabelWidth) + 3;
					} else {
						me.paddingLeft = firstLabelWidth / 2 + 3; // add 3 px to move away from canvas edges
						me.paddingRight = lastLabelWidth / 2 + 3;
					}
				} else {
					// A vertical axis is more constrained by the width. Labels are the
					// dominant factor here, so get that length first and account for padding
					if (tickOpts.mirror) {
						largestTextWidth = 0;
					} else {
						// use lineSpace for consistency with horizontal axis
						// tickPadding is not implemented for horizontal
						largestTextWidth += tickPadding + lineSpace;
					}

					minSize.width = Math.min(me.maxWidth, minSize.width + largestTextWidth);

					me.paddingTop = tickFont.size / 2;
					me.paddingBottom = tickFont.size / 2;
				}
			}

			me.handleMargins();

			me.width = minSize.width;
			me.height = minSize.height;
		},

		/**
		 * Handle margins and padding interactions
		 * @private
		 */
		handleMargins: function() {
			var me = this;
			if (me.margins) {
				me.paddingLeft = Math.max(me.paddingLeft - me.margins.left, 0);
				me.paddingTop = Math.max(me.paddingTop - me.margins.top, 0);
				me.paddingRight = Math.max(me.paddingRight - me.margins.right, 0);
				me.paddingBottom = Math.max(me.paddingBottom - me.margins.bottom, 0);
			}
		},

		afterFit: function() {
			helpers$4.callback(this.options.afterFit, [this]);
		},

		// Shared Methods
		isHorizontal: function() {
			return this.options.position === 'top' || this.options.position === 'bottom';
		},
		isFullWidth: function() {
			return (this.options.fullWidth);
		},

		// Get the correct value. NaN bad inputs, If the value type is object get the x or y based on whether we are horizontal or not
		getRightValue: function(rawValue) {
			// Null and undefined values first
			if (helpers$4.isNullOrUndef(rawValue)) {
				return NaN;
			}
			// isNaN(object) returns true, so make sure NaN is checking for a number; Discard Infinite values
			if (typeof rawValue === 'number' && !isFinite(rawValue)) {
				return NaN;
			}
			// If it is in fact an object, dive in one more level
			if (rawValue) {
				if (this.isHorizontal()) {
					if (rawValue.x !== undefined) {
						return this.getRightValue(rawValue.x);
					}
				} else if (rawValue.y !== undefined) {
					return this.getRightValue(rawValue.y);
				}
			}

			// Value is good, return it
			return rawValue;
		},

		/**
		 * Used to get the value to display in the tooltip for the data at the given index
		 * @param index
		 * @param datasetIndex
		 */
		getLabelForIndex: helpers$4.noop,

		/**
		 * Returns the location of the given data point. Value can either be an index or a numerical value
		 * The coordinate (0, 0) is at the upper-left corner of the canvas
		 * @param value
		 * @param index
		 * @param datasetIndex
		 */
		getPixelForValue: helpers$4.noop,

		/**
		 * Used to get the data value from a given pixel. This is the inverse of getPixelForValue
		 * The coordinate (0, 0) is at the upper-left corner of the canvas
		 * @param pixel
		 */
		getValueForPixel: helpers$4.noop,

		/**
		 * Returns the location of the tick at the given index
		 * The coordinate (0, 0) is at the upper-left corner of the canvas
		 */
		getPixelForTick: function(index) {
			var me = this;
			var offset = me.options.offset;
			if (me.isHorizontal()) {
				var innerWidth = me.width - (me.paddingLeft + me.paddingRight);
				var tickWidth = innerWidth / Math.max((me._ticks.length - (offset ? 0 : 1)), 1);
				var pixel = (tickWidth * index) + me.paddingLeft;

				if (offset) {
					pixel += tickWidth / 2;
				}

				var finalVal = me.left + Math.round(pixel);
				finalVal += me.isFullWidth() ? me.margins.left : 0;
				return finalVal;
			}
			var innerHeight = me.height - (me.paddingTop + me.paddingBottom);
			return me.top + (index * (innerHeight / (me._ticks.length - 1)));
		},

		/**
		 * Utility for getting the pixel location of a percentage of scale
		 * The coordinate (0, 0) is at the upper-left corner of the canvas
		 */
		getPixelForDecimal: function(decimal) {
			var me = this;
			if (me.isHorizontal()) {
				var innerWidth = me.width - (me.paddingLeft + me.paddingRight);
				var valueOffset = (innerWidth * decimal) + me.paddingLeft;

				var finalVal = me.left + Math.round(valueOffset);
				finalVal += me.isFullWidth() ? me.margins.left : 0;
				return finalVal;
			}
			return me.top + (decimal * me.height);
		},

		/**
		 * Returns the pixel for the minimum chart value
		 * The coordinate (0, 0) is at the upper-left corner of the canvas
		 */
		getBasePixel: function() {
			return this.getPixelForValue(this.getBaseValue());
		},

		getBaseValue: function() {
			var me = this;
			var min = me.min;
			var max = me.max;

			return me.beginAtZero ? 0 :
				min < 0 && max < 0 ? max :
				min > 0 && max > 0 ? min :
				0;
		},

		/**
		 * Returns a subset of ticks to be plotted to avoid overlapping labels.
		 * @private
		 */
		_autoSkip: function(ticks) {
			var skipRatio;
			var me = this;
			var isHorizontal = me.isHorizontal();
			var optionTicks = me.options.ticks.minor;
			var tickCount = ticks.length;
			var labelRotationRadians = helpers$4.toRadians(me.labelRotation);
			var cosRotation = Math.cos(labelRotationRadians);
			var longestRotatedLabel = me.longestLabelWidth * cosRotation;
			var result = [];
			var i, tick, shouldSkip;

			// figure out the maximum number of gridlines to show
			var maxTicks;
			if (optionTicks.maxTicksLimit) {
				maxTicks = optionTicks.maxTicksLimit;
			}

			if (isHorizontal) {
				skipRatio = false;

				if ((longestRotatedLabel + optionTicks.autoSkipPadding) * tickCount > (me.width - (me.paddingLeft + me.paddingRight))) {
					skipRatio = 1 + Math.floor(((longestRotatedLabel + optionTicks.autoSkipPadding) * tickCount) / (me.width - (me.paddingLeft + me.paddingRight)));
				}

				// if they defined a max number of optionTicks,
				// increase skipRatio until that number is met
				if (maxTicks && tickCount > maxTicks) {
					skipRatio = Math.max(skipRatio, Math.floor(tickCount / maxTicks));
				}
			}

			for (i = 0; i < tickCount; i++) {
				tick = ticks[i];

				// Since we always show the last tick,we need may need to hide the last shown one before
				shouldSkip = (skipRatio > 1 && i % skipRatio > 0) || (i % skipRatio === 0 && i + skipRatio >= tickCount);
				if (shouldSkip && i !== tickCount - 1) {
					// leave tick in place but make sure it's not displayed (#4635)
					delete tick.label;
				}
				result.push(tick);
			}
			return result;
		},

		// Actually draw the scale on the canvas
		// @param {rectangle} chartArea : the area of the chart to draw full grid lines on
		draw: function(chartArea) {
			var me = this;
			var options = me.options;
			if (!options.display) {
				return;
			}

			var context = me.ctx;
			var globalDefaults = defaults$3.global;
			var optionTicks = options.ticks.minor;
			var optionMajorTicks = options.ticks.major || optionTicks;
			var gridLines = options.gridLines;
			var scaleLabel = options.scaleLabel;

			var isRotated = me.labelRotation !== 0;
			var isHorizontal = me.isHorizontal();

			var ticks = optionTicks.autoSkip ? me._autoSkip(me.getTicks()) : me.getTicks();
			var tickFontColor = helpers$4.valueOrDefault(optionTicks.fontColor, globalDefaults.defaultFontColor);
			var tickFont = parseFontOptions(optionTicks);
			var majorTickFontColor = helpers$4.valueOrDefault(optionMajorTicks.fontColor, globalDefaults.defaultFontColor);
			var majorTickFont = parseFontOptions(optionMajorTicks);

			var tl = gridLines.drawTicks ? gridLines.tickMarkLength : 0;

			var scaleLabelFontColor = helpers$4.valueOrDefault(scaleLabel.fontColor, globalDefaults.defaultFontColor);
			var scaleLabelFont = parseFontOptions(scaleLabel);
			var scaleLabelPadding = helpers$4.options.toPadding(scaleLabel.padding);
			var labelRotationRadians = helpers$4.toRadians(me.labelRotation);

			var itemsToDraw = [];

			var axisWidth = me.options.gridLines.lineWidth;
			var xTickStart = options.position === 'right' ? me.left : me.right - axisWidth - tl;
			var xTickEnd = options.position === 'right' ? me.left + tl : me.right;
			var yTickStart = options.position === 'bottom' ? me.top + axisWidth : me.bottom - tl - axisWidth;
			var yTickEnd = options.position === 'bottom' ? me.top + axisWidth + tl : me.bottom + axisWidth;

			helpers$4.each(ticks, function(tick, index) {
				// autoskipper skipped this tick (#4635)
				if (helpers$4.isNullOrUndef(tick.label)) {
					return;
				}

				var label = tick.label;
				var lineWidth, lineColor, borderDash, borderDashOffset;
				if (index === me.zeroLineIndex && options.offset === gridLines.offsetGridLines) {
					// Draw the first index specially
					lineWidth = gridLines.zeroLineWidth;
					lineColor = gridLines.zeroLineColor;
					borderDash = gridLines.zeroLineBorderDash;
					borderDashOffset = gridLines.zeroLineBorderDashOffset;
				} else {
					lineWidth = helpers$4.valueAtIndexOrDefault(gridLines.lineWidth, index);
					lineColor = helpers$4.valueAtIndexOrDefault(gridLines.color, index);
					borderDash = helpers$4.valueOrDefault(gridLines.borderDash, globalDefaults.borderDash);
					borderDashOffset = helpers$4.valueOrDefault(gridLines.borderDashOffset, globalDefaults.borderDashOffset);
				}

				// Common properties
				var tx1, ty1, tx2, ty2, x1, y1, x2, y2, labelX, labelY;
				var textAlign = 'middle';
				var textBaseline = 'middle';
				var tickPadding = optionTicks.padding;

				if (isHorizontal) {
					var labelYOffset = tl + tickPadding;

					if (options.position === 'bottom') {
						// bottom
						textBaseline = !isRotated ? 'top' : 'middle';
						textAlign = !isRotated ? 'center' : 'right';
						labelY = me.top + labelYOffset;
					} else {
						// top
						textBaseline = !isRotated ? 'bottom' : 'middle';
						textAlign = !isRotated ? 'center' : 'left';
						labelY = me.bottom - labelYOffset;
					}

					var xLineValue = getLineValue(me, index, gridLines.offsetGridLines && ticks.length > 1);
					if (xLineValue < me.left) {
						lineColor = 'rgba(0,0,0,0)';
					}
					xLineValue += helpers$4.aliasPixel(lineWidth);

					labelX = me.getPixelForTick(index) + optionTicks.labelOffset; // x values for optionTicks (need to consider offsetLabel option)

					tx1 = tx2 = x1 = x2 = xLineValue;
					ty1 = yTickStart;
					ty2 = yTickEnd;
					y1 = chartArea.top;
					y2 = chartArea.bottom + axisWidth;
				} else {
					var isLeft = options.position === 'left';
					var labelXOffset;

					if (optionTicks.mirror) {
						textAlign = isLeft ? 'left' : 'right';
						labelXOffset = tickPadding;
					} else {
						textAlign = isLeft ? 'right' : 'left';
						labelXOffset = tl + tickPadding;
					}

					labelX = isLeft ? me.right - labelXOffset : me.left + labelXOffset;

					var yLineValue = getLineValue(me, index, gridLines.offsetGridLines && ticks.length > 1);
					if (yLineValue < me.top) {
						lineColor = 'rgba(0,0,0,0)';
					}
					yLineValue += helpers$4.aliasPixel(lineWidth);

					labelY = me.getPixelForTick(index) + optionTicks.labelOffset;

					tx1 = xTickStart;
					tx2 = xTickEnd;
					x1 = chartArea.left;
					x2 = chartArea.right + axisWidth;
					ty1 = ty2 = y1 = y2 = yLineValue;
				}

				itemsToDraw.push({
					tx1: tx1,
					ty1: ty1,
					tx2: tx2,
					ty2: ty2,
					x1: x1,
					y1: y1,
					x2: x2,
					y2: y2,
					labelX: labelX,
					labelY: labelY,
					glWidth: lineWidth,
					glColor: lineColor,
					glBorderDash: borderDash,
					glBorderDashOffset: borderDashOffset,
					rotation: -1 * labelRotationRadians,
					label: label,
					major: tick.major,
					textBaseline: textBaseline,
					textAlign: textAlign
				});
			});

			// Draw all of the tick labels, tick marks, and grid lines at the correct places
			helpers$4.each(itemsToDraw, function(itemToDraw) {
				if (gridLines.display) {
					context.save();
					context.lineWidth = itemToDraw.glWidth;
					context.strokeStyle = itemToDraw.glColor;
					if (context.setLineDash) {
						context.setLineDash(itemToDraw.glBorderDash);
						context.lineDashOffset = itemToDraw.glBorderDashOffset;
					}

					context.beginPath();

					if (gridLines.drawTicks) {
						context.moveTo(itemToDraw.tx1, itemToDraw.ty1);
						context.lineTo(itemToDraw.tx2, itemToDraw.ty2);
					}

					if (gridLines.drawOnChartArea) {
						context.moveTo(itemToDraw.x1, itemToDraw.y1);
						context.lineTo(itemToDraw.x2, itemToDraw.y2);
					}

					context.stroke();
					context.restore();
				}

				if (optionTicks.display) {
					// Make sure we draw text in the correct color and font
					context.save();
					context.translate(itemToDraw.labelX, itemToDraw.labelY);
					context.rotate(itemToDraw.rotation);
					context.font = itemToDraw.major ? majorTickFont.font : tickFont.font;
					context.fillStyle = itemToDraw.major ? majorTickFontColor : tickFontColor;
					context.textBaseline = itemToDraw.textBaseline;
					context.textAlign = itemToDraw.textAlign;

					var label = itemToDraw.label;
					if (helpers$4.isArray(label)) {
						var lineCount = label.length;
						var lineHeight = tickFont.size * 1.5;
						var y = me.isHorizontal() ? 0 : -lineHeight * (lineCount - 1) / 2;

						for (var i = 0; i < lineCount; ++i) {
							// We just make sure the multiline element is a string here..
							context.fillText('' + label[i], 0, y);
							// apply same lineSpacing as calculated @ L#320
							y += lineHeight;
						}
					} else {
						context.fillText(label, 0, 0);
					}
					context.restore();
				}
			});

			if (scaleLabel.display) {
				// Draw the scale label
				var scaleLabelX;
				var scaleLabelY;
				var rotation = 0;
				var halfLineHeight = parseLineHeight(scaleLabel) / 2;

				if (isHorizontal) {
					scaleLabelX = me.left + ((me.right - me.left) / 2); // midpoint of the width
					scaleLabelY = options.position === 'bottom'
						? me.bottom - halfLineHeight - scaleLabelPadding.bottom
						: me.top + halfLineHeight + scaleLabelPadding.top;
				} else {
					var isLeft = options.position === 'left';
					scaleLabelX = isLeft
						? me.left + halfLineHeight + scaleLabelPadding.top
						: me.right - halfLineHeight - scaleLabelPadding.top;
					scaleLabelY = me.top + ((me.bottom - me.top) / 2);
					rotation = isLeft ? -0.5 * Math.PI : 0.5 * Math.PI;
				}

				context.save();
				context.translate(scaleLabelX, scaleLabelY);
				context.rotate(rotation);
				context.textAlign = 'center';
				context.textBaseline = 'middle';
				context.fillStyle = scaleLabelFontColor; // render in correct colour
				context.font = scaleLabelFont.font;
				context.fillText(scaleLabel.labelString, 0, 0);
				context.restore();
			}

			if (gridLines.drawBorder) {
				// Draw the line at the edge of the axis
				context.lineWidth = helpers$4.valueAtIndexOrDefault(gridLines.lineWidth, 0);
				context.strokeStyle = helpers$4.valueAtIndexOrDefault(gridLines.color, 0);
				var x1 = me.left;
				var x2 = me.right + axisWidth;
				var y1 = me.top;
				var y2 = me.bottom + axisWidth;

				var aliasPixel = helpers$4.aliasPixel(context.lineWidth);
				if (isHorizontal) {
					y1 = y2 = options.position === 'top' ? me.bottom : me.top;
					y1 += aliasPixel;
					y2 += aliasPixel;
				} else {
					x1 = x2 = options.position === 'left' ? me.right : me.left;
					x1 += aliasPixel;
					x2 += aliasPixel;
				}

				context.beginPath();
				context.moveTo(x1, y1);
				context.lineTo(x2, y2);
				context.stroke();
			}
		}
	});

	var core_scale$1 = /*#__PURE__*/Object.freeze({
		default: core_scale,
		__moduleExports: core_scale
	});

	var core_tooltip = createCommonjsModule(function (module) {





	defaults$3._set('global', {
		tooltips: {
			enabled: true,
			custom: null,
			mode: 'nearest',
			position: 'average',
			intersect: true,
			backgroundColor: 'rgba(0,0,0,0.8)',
			titleFontStyle: 'bold',
			titleSpacing: 2,
			titleMarginBottom: 6,
			titleFontColor: '#fff',
			titleAlign: 'left',
			bodySpacing: 2,
			bodyFontColor: '#fff',
			bodyAlign: 'left',
			footerFontStyle: 'bold',
			footerSpacing: 2,
			footerMarginTop: 6,
			footerFontColor: '#fff',
			footerAlign: 'left',
			yPadding: 6,
			xPadding: 6,
			caretPadding: 2,
			caretSize: 5,
			cornerRadius: 6,
			multiKeyBackground: '#fff',
			displayColors: true,
			borderColor: 'rgba(0,0,0,0)',
			borderWidth: 0,
			callbacks: {
				// Args are: (tooltipItems, data)
				beforeTitle: helpers$4.noop,
				title: function(tooltipItems, data) {
					// Pick first xLabel for now
					var title = '';
					var labels = data.labels;
					var labelCount = labels ? labels.length : 0;

					if (tooltipItems.length > 0) {
						var item = tooltipItems[0];

						if (item.xLabel) {
							title = item.xLabel;
						} else if (labelCount > 0 && item.index < labelCount) {
							title = labels[item.index];
						}
					}

					return title;
				},
				afterTitle: helpers$4.noop,

				// Args are: (tooltipItems, data)
				beforeBody: helpers$4.noop,

				// Args are: (tooltipItem, data)
				beforeLabel: helpers$4.noop,
				label: function(tooltipItem, data) {
					var label = data.datasets[tooltipItem.datasetIndex].label || '';

					if (label) {
						label += ': ';
					}
					label += tooltipItem.yLabel;
					return label;
				},
				labelColor: function(tooltipItem, chart) {
					var meta = chart.getDatasetMeta(tooltipItem.datasetIndex);
					var activeElement = meta.data[tooltipItem.index];
					var view = activeElement._view;
					return {
						borderColor: view.borderColor,
						backgroundColor: view.backgroundColor
					};
				},
				labelTextColor: function() {
					return this._options.bodyFontColor;
				},
				afterLabel: helpers$4.noop,

				// Args are: (tooltipItems, data)
				afterBody: helpers$4.noop,

				// Args are: (tooltipItems, data)
				beforeFooter: helpers$4.noop,
				footer: helpers$4.noop,
				afterFooter: helpers$4.noop
			}
		}
	});

	var positioners = {
		/**
		 * Average mode places the tooltip at the average position of the elements shown
		 * @function Chart.Tooltip.positioners.average
		 * @param elements {ChartElement[]} the elements being displayed in the tooltip
		 * @returns {Point} tooltip position
		 */
		average: function(elements) {
			if (!elements.length) {
				return false;
			}

			var i, len;
			var x = 0;
			var y = 0;
			var count = 0;

			for (i = 0, len = elements.length; i < len; ++i) {
				var el = elements[i];
				if (el && el.hasValue()) {
					var pos = el.tooltipPosition();
					x += pos.x;
					y += pos.y;
					++count;
				}
			}

			return {
				x: Math.round(x / count),
				y: Math.round(y / count)
			};
		},

		/**
		 * Gets the tooltip position nearest of the item nearest to the event position
		 * @function Chart.Tooltip.positioners.nearest
		 * @param elements {Chart.Element[]} the tooltip elements
		 * @param eventPosition {Point} the position of the event in canvas coordinates
		 * @returns {Point} the tooltip position
		 */
		nearest: function(elements, eventPosition) {
			var x = eventPosition.x;
			var y = eventPosition.y;
			var minDistance = Number.POSITIVE_INFINITY;
			var i, len, nearestElement;

			for (i = 0, len = elements.length; i < len; ++i) {
				var el = elements[i];
				if (el && el.hasValue()) {
					var center = el.getCenterPoint();
					var d = helpers$4.distanceBetweenPoints(eventPosition, center);

					if (d < minDistance) {
						minDistance = d;
						nearestElement = el;
					}
				}
			}

			if (nearestElement) {
				var tp = nearestElement.tooltipPosition();
				x = tp.x;
				y = tp.y;
			}

			return {
				x: x,
				y: y
			};
		}
	};

	/**
	 * Helper method to merge the opacity into a color
	 */
	function mergeOpacity(colorString, opacity) {
		var color = helpers$4.color(colorString);
		return color.alpha(opacity * color.alpha()).rgbaString();
	}

	// Helper to push or concat based on if the 2nd parameter is an array or not
	function pushOrConcat(base, toPush) {
		if (toPush) {
			if (helpers$4.isArray(toPush)) {
				// base = base.concat(toPush);
				Array.prototype.push.apply(base, toPush);
			} else {
				base.push(toPush);
			}
		}

		return base;
	}

	/**
	 * Returns array of strings split by newline
	 * @param {String} value - The value to split by newline.
	 * @returns {Array} value if newline present - Returned from String split() method
	 * @function
	 */
	function splitNewlines(str) {
		if ((typeof str === 'string' || str instanceof String) && str.indexOf('\n') > -1) {
			return str.split('\n');
		}
		return str;
	}


	// Private helper to create a tooltip item model
	// @param element : the chart element (point, arc, bar) to create the tooltip item for
	// @return : new tooltip item
	function createTooltipItem(element) {
		var xScale = element._xScale;
		var yScale = element._yScale || element._scale; // handle radar || polarArea charts
		var index = element._index;
		var datasetIndex = element._datasetIndex;

		return {
			xLabel: xScale ? xScale.getLabelForIndex(index, datasetIndex) : '',
			yLabel: yScale ? yScale.getLabelForIndex(index, datasetIndex) : '',
			index: index,
			datasetIndex: datasetIndex,
			x: element._model.x,
			y: element._model.y
		};
	}

	/**
	 * Helper to get the reset model for the tooltip
	 * @param tooltipOpts {Object} the tooltip options
	 */
	function getBaseModel(tooltipOpts) {
		var globalDefaults = defaults$3.global;
		var valueOrDefault = helpers$4.valueOrDefault;

		return {
			// Positioning
			xPadding: tooltipOpts.xPadding,
			yPadding: tooltipOpts.yPadding,
			xAlign: tooltipOpts.xAlign,
			yAlign: tooltipOpts.yAlign,

			// Body
			bodyFontColor: tooltipOpts.bodyFontColor,
			_bodyFontFamily: valueOrDefault(tooltipOpts.bodyFontFamily, globalDefaults.defaultFontFamily),
			_bodyFontStyle: valueOrDefault(tooltipOpts.bodyFontStyle, globalDefaults.defaultFontStyle),
			_bodyAlign: tooltipOpts.bodyAlign,
			bodyFontSize: valueOrDefault(tooltipOpts.bodyFontSize, globalDefaults.defaultFontSize),
			bodySpacing: tooltipOpts.bodySpacing,

			// Title
			titleFontColor: tooltipOpts.titleFontColor,
			_titleFontFamily: valueOrDefault(tooltipOpts.titleFontFamily, globalDefaults.defaultFontFamily),
			_titleFontStyle: valueOrDefault(tooltipOpts.titleFontStyle, globalDefaults.defaultFontStyle),
			titleFontSize: valueOrDefault(tooltipOpts.titleFontSize, globalDefaults.defaultFontSize),
			_titleAlign: tooltipOpts.titleAlign,
			titleSpacing: tooltipOpts.titleSpacing,
			titleMarginBottom: tooltipOpts.titleMarginBottom,

			// Footer
			footerFontColor: tooltipOpts.footerFontColor,
			_footerFontFamily: valueOrDefault(tooltipOpts.footerFontFamily, globalDefaults.defaultFontFamily),
			_footerFontStyle: valueOrDefault(tooltipOpts.footerFontStyle, globalDefaults.defaultFontStyle),
			footerFontSize: valueOrDefault(tooltipOpts.footerFontSize, globalDefaults.defaultFontSize),
			_footerAlign: tooltipOpts.footerAlign,
			footerSpacing: tooltipOpts.footerSpacing,
			footerMarginTop: tooltipOpts.footerMarginTop,

			// Appearance
			caretSize: tooltipOpts.caretSize,
			cornerRadius: tooltipOpts.cornerRadius,
			backgroundColor: tooltipOpts.backgroundColor,
			opacity: 0,
			legendColorBackground: tooltipOpts.multiKeyBackground,
			displayColors: tooltipOpts.displayColors,
			borderColor: tooltipOpts.borderColor,
			borderWidth: tooltipOpts.borderWidth
		};
	}

	/**
	 * Get the size of the tooltip
	 */
	function getTooltipSize(tooltip, model) {
		var ctx = tooltip._chart.ctx;

		var height = model.yPadding * 2; // Tooltip Padding
		var width = 0;

		// Count of all lines in the body
		var body = model.body;
		var combinedBodyLength = body.reduce(function(count, bodyItem) {
			return count + bodyItem.before.length + bodyItem.lines.length + bodyItem.after.length;
		}, 0);
		combinedBodyLength += model.beforeBody.length + model.afterBody.length;

		var titleLineCount = model.title.length;
		var footerLineCount = model.footer.length;
		var titleFontSize = model.titleFontSize;
		var bodyFontSize = model.bodyFontSize;
		var footerFontSize = model.footerFontSize;

		height += titleLineCount * titleFontSize; // Title Lines
		height += titleLineCount ? (titleLineCount - 1) * model.titleSpacing : 0; // Title Line Spacing
		height += titleLineCount ? model.titleMarginBottom : 0; // Title's bottom Margin
		height += combinedBodyLength * bodyFontSize; // Body Lines
		height += combinedBodyLength ? (combinedBodyLength - 1) * model.bodySpacing : 0; // Body Line Spacing
		height += footerLineCount ? model.footerMarginTop : 0; // Footer Margin
		height += footerLineCount * (footerFontSize); // Footer Lines
		height += footerLineCount ? (footerLineCount - 1) * model.footerSpacing : 0; // Footer Line Spacing

		// Title width
		var widthPadding = 0;
		var maxLineWidth = function(line) {
			width = Math.max(width, ctx.measureText(line).width + widthPadding);
		};

		ctx.font = helpers$4.fontString(titleFontSize, model._titleFontStyle, model._titleFontFamily);
		helpers$4.each(model.title, maxLineWidth);

		// Body width
		ctx.font = helpers$4.fontString(bodyFontSize, model._bodyFontStyle, model._bodyFontFamily);
		helpers$4.each(model.beforeBody.concat(model.afterBody), maxLineWidth);

		// Body lines may include some extra width due to the color box
		widthPadding = model.displayColors ? (bodyFontSize + 2) : 0;
		helpers$4.each(body, function(bodyItem) {
			helpers$4.each(bodyItem.before, maxLineWidth);
			helpers$4.each(bodyItem.lines, maxLineWidth);
			helpers$4.each(bodyItem.after, maxLineWidth);
		});

		// Reset back to 0
		widthPadding = 0;

		// Footer width
		ctx.font = helpers$4.fontString(footerFontSize, model._footerFontStyle, model._footerFontFamily);
		helpers$4.each(model.footer, maxLineWidth);

		// Add padding
		width += 2 * model.xPadding;

		return {
			width: width,
			height: height
		};
	}

	/**
	 * Helper to get the alignment of a tooltip given the size
	 */
	function determineAlignment(tooltip, size) {
		var model = tooltip._model;
		var chart = tooltip._chart;
		var chartArea = tooltip._chart.chartArea;
		var xAlign = 'center';
		var yAlign = 'center';

		if (model.y < size.height) {
			yAlign = 'top';
		} else if (model.y > (chart.height - size.height)) {
			yAlign = 'bottom';
		}

		var lf, rf; // functions to determine left, right alignment
		var olf, orf; // functions to determine if left/right alignment causes tooltip to go outside chart
		var yf; // function to get the y alignment if the tooltip goes outside of the left or right edges
		var midX = (chartArea.left + chartArea.right) / 2;
		var midY = (chartArea.top + chartArea.bottom) / 2;

		if (yAlign === 'center') {
			lf = function(x) {
				return x <= midX;
			};
			rf = function(x) {
				return x > midX;
			};
		} else {
			lf = function(x) {
				return x <= (size.width / 2);
			};
			rf = function(x) {
				return x >= (chart.width - (size.width / 2));
			};
		}

		olf = function(x) {
			return x + size.width + model.caretSize + model.caretPadding > chart.width;
		};
		orf = function(x) {
			return x - size.width - model.caretSize - model.caretPadding < 0;
		};
		yf = function(y) {
			return y <= midY ? 'top' : 'bottom';
		};

		if (lf(model.x)) {
			xAlign = 'left';

			// Is tooltip too wide and goes over the right side of the chart.?
			if (olf(model.x)) {
				xAlign = 'center';
				yAlign = yf(model.y);
			}
		} else if (rf(model.x)) {
			xAlign = 'right';

			// Is tooltip too wide and goes outside left edge of canvas?
			if (orf(model.x)) {
				xAlign = 'center';
				yAlign = yf(model.y);
			}
		}

		var opts = tooltip._options;
		return {
			xAlign: opts.xAlign ? opts.xAlign : xAlign,
			yAlign: opts.yAlign ? opts.yAlign : yAlign
		};
	}

	/**
	 * Helper to get the location a tooltip needs to be placed at given the initial position (via the vm) and the size and alignment
	 */
	function getBackgroundPoint(vm, size, alignment, chart) {
		// Background Position
		var x = vm.x;
		var y = vm.y;

		var caretSize = vm.caretSize;
		var caretPadding = vm.caretPadding;
		var cornerRadius = vm.cornerRadius;
		var xAlign = alignment.xAlign;
		var yAlign = alignment.yAlign;
		var paddingAndSize = caretSize + caretPadding;
		var radiusAndPadding = cornerRadius + caretPadding;

		if (xAlign === 'right') {
			x -= size.width;
		} else if (xAlign === 'center') {
			x -= (size.width / 2);
			if (x + size.width > chart.width) {
				x = chart.width - size.width;
			}
			if (x < 0) {
				x = 0;
			}
		}

		if (yAlign === 'top') {
			y += paddingAndSize;
		} else if (yAlign === 'bottom') {
			y -= size.height + paddingAndSize;
		} else {
			y -= (size.height / 2);
		}

		if (yAlign === 'center') {
			if (xAlign === 'left') {
				x += paddingAndSize;
			} else if (xAlign === 'right') {
				x -= paddingAndSize;
			}
		} else if (xAlign === 'left') {
			x -= radiusAndPadding;
		} else if (xAlign === 'right') {
			x += radiusAndPadding;
		}

		return {
			x: x,
			y: y
		};
	}

	/**
	 * Helper to build before and after body lines
	 */
	function getBeforeAfterBodyLines(callback) {
		return pushOrConcat([], splitNewlines(callback));
	}

	var exports = module.exports = Element$1.extend({
		initialize: function() {
			this._model = getBaseModel(this._options);
			this._lastActive = [];
		},

		// Get the title
		// Args are: (tooltipItem, data)
		getTitle: function() {
			var me = this;
			var opts = me._options;
			var callbacks = opts.callbacks;

			var beforeTitle = callbacks.beforeTitle.apply(me, arguments);
			var title = callbacks.title.apply(me, arguments);
			var afterTitle = callbacks.afterTitle.apply(me, arguments);

			var lines = [];
			lines = pushOrConcat(lines, splitNewlines(beforeTitle));
			lines = pushOrConcat(lines, splitNewlines(title));
			lines = pushOrConcat(lines, splitNewlines(afterTitle));

			return lines;
		},

		// Args are: (tooltipItem, data)
		getBeforeBody: function() {
			return getBeforeAfterBodyLines(this._options.callbacks.beforeBody.apply(this, arguments));
		},

		// Args are: (tooltipItem, data)
		getBody: function(tooltipItems, data) {
			var me = this;
			var callbacks = me._options.callbacks;
			var bodyItems = [];

			helpers$4.each(tooltipItems, function(tooltipItem) {
				var bodyItem = {
					before: [],
					lines: [],
					after: []
				};
				pushOrConcat(bodyItem.before, splitNewlines(callbacks.beforeLabel.call(me, tooltipItem, data)));
				pushOrConcat(bodyItem.lines, callbacks.label.call(me, tooltipItem, data));
				pushOrConcat(bodyItem.after, splitNewlines(callbacks.afterLabel.call(me, tooltipItem, data)));

				bodyItems.push(bodyItem);
			});

			return bodyItems;
		},

		// Args are: (tooltipItem, data)
		getAfterBody: function() {
			return getBeforeAfterBodyLines(this._options.callbacks.afterBody.apply(this, arguments));
		},

		// Get the footer and beforeFooter and afterFooter lines
		// Args are: (tooltipItem, data)
		getFooter: function() {
			var me = this;
			var callbacks = me._options.callbacks;

			var beforeFooter = callbacks.beforeFooter.apply(me, arguments);
			var footer = callbacks.footer.apply(me, arguments);
			var afterFooter = callbacks.afterFooter.apply(me, arguments);

			var lines = [];
			lines = pushOrConcat(lines, splitNewlines(beforeFooter));
			lines = pushOrConcat(lines, splitNewlines(footer));
			lines = pushOrConcat(lines, splitNewlines(afterFooter));

			return lines;
		},

		update: function(changed) {
			var me = this;
			var opts = me._options;

			// Need to regenerate the model because its faster than using extend and it is necessary due to the optimization in Chart.Element.transition
			// that does _view = _model if ease === 1. This causes the 2nd tooltip update to set properties in both the view and model at the same time
			// which breaks any animations.
			var existingModel = me._model;
			var model = me._model = getBaseModel(opts);
			var active = me._active;

			var data = me._data;

			// In the case where active.length === 0 we need to keep these at existing values for good animations
			var alignment = {
				xAlign: existingModel.xAlign,
				yAlign: existingModel.yAlign
			};
			var backgroundPoint = {
				x: existingModel.x,
				y: existingModel.y
			};
			var tooltipSize = {
				width: existingModel.width,
				height: existingModel.height
			};
			var tooltipPosition = {
				x: existingModel.caretX,
				y: existingModel.caretY
			};

			var i, len;

			if (active.length) {
				model.opacity = 1;

				var labelColors = [];
				var labelTextColors = [];
				tooltipPosition = positioners[opts.position].call(me, active, me._eventPosition);

				var tooltipItems = [];
				for (i = 0, len = active.length; i < len; ++i) {
					tooltipItems.push(createTooltipItem(active[i]));
				}

				// If the user provided a filter function, use it to modify the tooltip items
				if (opts.filter) {
					tooltipItems = tooltipItems.filter(function(a) {
						return opts.filter(a, data);
					});
				}

				// If the user provided a sorting function, use it to modify the tooltip items
				if (opts.itemSort) {
					tooltipItems = tooltipItems.sort(function(a, b) {
						return opts.itemSort(a, b, data);
					});
				}

				// Determine colors for boxes
				helpers$4.each(tooltipItems, function(tooltipItem) {
					labelColors.push(opts.callbacks.labelColor.call(me, tooltipItem, me._chart));
					labelTextColors.push(opts.callbacks.labelTextColor.call(me, tooltipItem, me._chart));
				});


				// Build the Text Lines
				model.title = me.getTitle(tooltipItems, data);
				model.beforeBody = me.getBeforeBody(tooltipItems, data);
				model.body = me.getBody(tooltipItems, data);
				model.afterBody = me.getAfterBody(tooltipItems, data);
				model.footer = me.getFooter(tooltipItems, data);

				// Initial positioning and colors
				model.x = Math.round(tooltipPosition.x);
				model.y = Math.round(tooltipPosition.y);
				model.caretPadding = opts.caretPadding;
				model.labelColors = labelColors;
				model.labelTextColors = labelTextColors;

				// data points
				model.dataPoints = tooltipItems;

				// We need to determine alignment of the tooltip
				tooltipSize = getTooltipSize(this, model);
				alignment = determineAlignment(this, tooltipSize);
				// Final Size and Position
				backgroundPoint = getBackgroundPoint(model, tooltipSize, alignment, me._chart);
			} else {
				model.opacity = 0;
			}

			model.xAlign = alignment.xAlign;
			model.yAlign = alignment.yAlign;
			model.x = backgroundPoint.x;
			model.y = backgroundPoint.y;
			model.width = tooltipSize.width;
			model.height = tooltipSize.height;

			// Point where the caret on the tooltip points to
			model.caretX = tooltipPosition.x;
			model.caretY = tooltipPosition.y;

			me._model = model;

			if (changed && opts.custom) {
				opts.custom.call(me, model);
			}

			return me;
		},

		drawCaret: function(tooltipPoint, size) {
			var ctx = this._chart.ctx;
			var vm = this._view;
			var caretPosition = this.getCaretPosition(tooltipPoint, size, vm);

			ctx.lineTo(caretPosition.x1, caretPosition.y1);
			ctx.lineTo(caretPosition.x2, caretPosition.y2);
			ctx.lineTo(caretPosition.x3, caretPosition.y3);
		},
		getCaretPosition: function(tooltipPoint, size, vm) {
			var x1, x2, x3, y1, y2, y3;
			var caretSize = vm.caretSize;
			var cornerRadius = vm.cornerRadius;
			var xAlign = vm.xAlign;
			var yAlign = vm.yAlign;
			var ptX = tooltipPoint.x;
			var ptY = tooltipPoint.y;
			var width = size.width;
			var height = size.height;

			if (yAlign === 'center') {
				y2 = ptY + (height / 2);

				if (xAlign === 'left') {
					x1 = ptX;
					x2 = x1 - caretSize;
					x3 = x1;

					y1 = y2 + caretSize;
					y3 = y2 - caretSize;
				} else {
					x1 = ptX + width;
					x2 = x1 + caretSize;
					x3 = x1;

					y1 = y2 - caretSize;
					y3 = y2 + caretSize;
				}
			} else {
				if (xAlign === 'left') {
					x2 = ptX + cornerRadius + (caretSize);
					x1 = x2 - caretSize;
					x3 = x2 + caretSize;
				} else if (xAlign === 'right') {
					x2 = ptX + width - cornerRadius - caretSize;
					x1 = x2 - caretSize;
					x3 = x2 + caretSize;
				} else {
					x2 = vm.caretX;
					x1 = x2 - caretSize;
					x3 = x2 + caretSize;
				}
				if (yAlign === 'top') {
					y1 = ptY;
					y2 = y1 - caretSize;
					y3 = y1;
				} else {
					y1 = ptY + height;
					y2 = y1 + caretSize;
					y3 = y1;
					// invert drawing order
					var tmp = x3;
					x3 = x1;
					x1 = tmp;
				}
			}
			return {x1: x1, x2: x2, x3: x3, y1: y1, y2: y2, y3: y3};
		},

		drawTitle: function(pt, vm, ctx, opacity) {
			var title = vm.title;

			if (title.length) {
				ctx.textAlign = vm._titleAlign;
				ctx.textBaseline = 'top';

				var titleFontSize = vm.titleFontSize;
				var titleSpacing = vm.titleSpacing;

				ctx.fillStyle = mergeOpacity(vm.titleFontColor, opacity);
				ctx.font = helpers$4.fontString(titleFontSize, vm._titleFontStyle, vm._titleFontFamily);

				var i, len;
				for (i = 0, len = title.length; i < len; ++i) {
					ctx.fillText(title[i], pt.x, pt.y);
					pt.y += titleFontSize + titleSpacing; // Line Height and spacing

					if (i + 1 === title.length) {
						pt.y += vm.titleMarginBottom - titleSpacing; // If Last, add margin, remove spacing
					}
				}
			}
		},

		drawBody: function(pt, vm, ctx, opacity) {
			var bodyFontSize = vm.bodyFontSize;
			var bodySpacing = vm.bodySpacing;
			var body = vm.body;

			ctx.textAlign = vm._bodyAlign;
			ctx.textBaseline = 'top';
			ctx.font = helpers$4.fontString(bodyFontSize, vm._bodyFontStyle, vm._bodyFontFamily);

			// Before Body
			var xLinePadding = 0;
			var fillLineOfText = function(line) {
				ctx.fillText(line, pt.x + xLinePadding, pt.y);
				pt.y += bodyFontSize + bodySpacing;
			};

			// Before body lines
			ctx.fillStyle = mergeOpacity(vm.bodyFontColor, opacity);
			helpers$4.each(vm.beforeBody, fillLineOfText);

			var drawColorBoxes = vm.displayColors;
			xLinePadding = drawColorBoxes ? (bodyFontSize + 2) : 0;

			// Draw body lines now
			helpers$4.each(body, function(bodyItem, i) {
				var textColor = mergeOpacity(vm.labelTextColors[i], opacity);
				ctx.fillStyle = textColor;
				helpers$4.each(bodyItem.before, fillLineOfText);

				helpers$4.each(bodyItem.lines, function(line) {
					// Draw Legend-like boxes if needed
					if (drawColorBoxes) {
						// Fill a white rect so that colours merge nicely if the opacity is < 1
						ctx.fillStyle = mergeOpacity(vm.legendColorBackground, opacity);
						ctx.fillRect(pt.x, pt.y, bodyFontSize, bodyFontSize);

						// Border
						ctx.lineWidth = 1;
						ctx.strokeStyle = mergeOpacity(vm.labelColors[i].borderColor, opacity);
						ctx.strokeRect(pt.x, pt.y, bodyFontSize, bodyFontSize);

						// Inner square
						ctx.fillStyle = mergeOpacity(vm.labelColors[i].backgroundColor, opacity);
						ctx.fillRect(pt.x + 1, pt.y + 1, bodyFontSize - 2, bodyFontSize - 2);
						ctx.fillStyle = textColor;
					}

					fillLineOfText(line);
				});

				helpers$4.each(bodyItem.after, fillLineOfText);
			});

			// Reset back to 0 for after body
			xLinePadding = 0;

			// After body lines
			helpers$4.each(vm.afterBody, fillLineOfText);
			pt.y -= bodySpacing; // Remove last body spacing
		},

		drawFooter: function(pt, vm, ctx, opacity) {
			var footer = vm.footer;

			if (footer.length) {
				pt.y += vm.footerMarginTop;

				ctx.textAlign = vm._footerAlign;
				ctx.textBaseline = 'top';

				ctx.fillStyle = mergeOpacity(vm.footerFontColor, opacity);
				ctx.font = helpers$4.fontString(vm.footerFontSize, vm._footerFontStyle, vm._footerFontFamily);

				helpers$4.each(footer, function(line) {
					ctx.fillText(line, pt.x, pt.y);
					pt.y += vm.footerFontSize + vm.footerSpacing;
				});
			}
		},

		drawBackground: function(pt, vm, ctx, tooltipSize, opacity) {
			ctx.fillStyle = mergeOpacity(vm.backgroundColor, opacity);
			ctx.strokeStyle = mergeOpacity(vm.borderColor, opacity);
			ctx.lineWidth = vm.borderWidth;
			var xAlign = vm.xAlign;
			var yAlign = vm.yAlign;
			var x = pt.x;
			var y = pt.y;
			var width = tooltipSize.width;
			var height = tooltipSize.height;
			var radius = vm.cornerRadius;

			ctx.beginPath();
			ctx.moveTo(x + radius, y);
			if (yAlign === 'top') {
				this.drawCaret(pt, tooltipSize);
			}
			ctx.lineTo(x + width - radius, y);
			ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
			if (yAlign === 'center' && xAlign === 'right') {
				this.drawCaret(pt, tooltipSize);
			}
			ctx.lineTo(x + width, y + height - radius);
			ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
			if (yAlign === 'bottom') {
				this.drawCaret(pt, tooltipSize);
			}
			ctx.lineTo(x + radius, y + height);
			ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
			if (yAlign === 'center' && xAlign === 'left') {
				this.drawCaret(pt, tooltipSize);
			}
			ctx.lineTo(x, y + radius);
			ctx.quadraticCurveTo(x, y, x + radius, y);
			ctx.closePath();

			ctx.fill();

			if (vm.borderWidth > 0) {
				ctx.stroke();
			}
		},

		draw: function() {
			var ctx = this._chart.ctx;
			var vm = this._view;

			if (vm.opacity === 0) {
				return;
			}

			var tooltipSize = {
				width: vm.width,
				height: vm.height
			};
			var pt = {
				x: vm.x,
				y: vm.y
			};

			// IE11/Edge does not like very small opacities, so snap to 0
			var opacity = Math.abs(vm.opacity < 1e-3) ? 0 : vm.opacity;

			// Truthy/falsey value for empty tooltip
			var hasTooltipContent = vm.title.length || vm.beforeBody.length || vm.body.length || vm.afterBody.length || vm.footer.length;

			if (this._options.enabled && hasTooltipContent) {
				// Draw Background
				this.drawBackground(pt, vm, ctx, tooltipSize, opacity);

				// Draw Title, Body, and Footer
				pt.x += vm.xPadding;
				pt.y += vm.yPadding;

				// Titles
				this.drawTitle(pt, vm, ctx, opacity);

				// Body
				this.drawBody(pt, vm, ctx, opacity);

				// Footer
				this.drawFooter(pt, vm, ctx, opacity);
			}
		},

		/**
		 * Handle an event
		 * @private
		 * @param {IEvent} event - The event to handle
		 * @returns {Boolean} true if the tooltip changed
		 */
		handleEvent: function(e) {
			var me = this;
			var options = me._options;
			var changed = false;

			me._lastActive = me._lastActive || [];

			// Find Active Elements for tooltips
			if (e.type === 'mouseout') {
				me._active = [];
			} else {
				me._active = me._chart.getElementsAtEventForMode(e, options.mode, options);
			}

			// Remember Last Actives
			changed = !helpers$4.arrayEquals(me._active, me._lastActive);

			// Only handle target event on tooltip change
			if (changed) {
				me._lastActive = me._active;

				if (options.enabled || options.custom) {
					me._eventPosition = {
						x: e.x,
						y: e.y
					};

					me.update(true);
					me.pivot();
				}
			}

			return changed;
		}
	});

	/**
	 * @namespace Chart.Tooltip.positioners
	 */
	exports.positioners = positioners;
	});

	var core_tooltip$1 = /*#__PURE__*/Object.freeze({
		default: core_tooltip,
		__moduleExports: core_tooltip
	});

	var Animation = ( core_animation$1 && core_animation ) || core_animation$1;

	var animations = ( core_animations$1 && core_animations ) || core_animations$1;

	var Interaction = ( core_interaction$1 && core_interaction ) || core_interaction$1;

	var platform$2 = ( platform$1 && platform ) || platform$1;

	var plugins = ( core_plugins$1 && core_plugins ) || core_plugins$1;

	var Tooltip = ( core_tooltip$1 && core_tooltip ) || core_tooltip$1;

	var core_controller = function(Chart) {

		// Create a dictionary of chart types, to allow for extension of existing types
		Chart.types = {};

		// Store a reference to each instance - allowing us to globally resize chart instances on window resize.
		// Destroy method on the chart will remove the instance of the chart from this reference.
		Chart.instances = {};

		// Controllers available for dataset visualization eg. bar, line, slice, etc.
		Chart.controllers = {};

		/**
		 * Initializes the given config with global and chart default values.
		 */
		function initConfig(config) {
			config = config || {};

			// Do NOT use configMerge() for the data object because this method merges arrays
			// and so would change references to labels and datasets, preventing data updates.
			var data = config.data = config.data || {};
			data.datasets = data.datasets || [];
			data.labels = data.labels || [];

			config.options = helpers$4.configMerge(
				defaults$3.global,
				defaults$3[config.type],
				config.options || {});

			return config;
		}

		/**
		 * Updates the config of the chart
		 * @param chart {Chart} chart to update the options for
		 */
		function updateConfig(chart) {
			var newOptions = chart.options;

			helpers$4.each(chart.scales, function(scale) {
				layouts.removeBox(chart, scale);
			});

			newOptions = helpers$4.configMerge(
				Chart.defaults.global,
				Chart.defaults[chart.config.type],
				newOptions);

			chart.options = chart.config.options = newOptions;
			chart.ensureScalesHaveIDs();
			chart.buildOrUpdateScales();
			// Tooltip
			chart.tooltip._options = newOptions.tooltips;
			chart.tooltip.initialize();
		}

		function positionIsHorizontal(position) {
			return position === 'top' || position === 'bottom';
		}

		helpers$4.extend(Chart.prototype, /** @lends Chart */ {
			/**
			 * @private
			 */
			construct: function(item, config) {
				var me = this;

				config = initConfig(config);

				var context = platform$2.acquireContext(item, config);
				var canvas = context && context.canvas;
				var height = canvas && canvas.height;
				var width = canvas && canvas.width;

				me.id = helpers$4.uid();
				me.ctx = context;
				me.canvas = canvas;
				me.config = config;
				me.width = width;
				me.height = height;
				me.aspectRatio = height ? width / height : null;
				me.options = config.options;
				me._bufferedRender = false;

				/**
				 * Provided for backward compatibility, Chart and Chart.Controller have been merged,
				 * the "instance" still need to be defined since it might be called from plugins.
				 * @prop Chart#chart
				 * @deprecated since version 2.6.0
				 * @todo remove at version 3
				 * @private
				 */
				me.chart = me;
				me.controller = me; // chart.chart.controller #inception

				// Add the chart instance to the global namespace
				Chart.instances[me.id] = me;

				// Define alias to the config data: `chart.data === chart.config.data`
				Object.defineProperty(me, 'data', {
					get: function() {
						return me.config.data;
					},
					set: function(value) {
						me.config.data = value;
					}
				});

				if (!context || !canvas) {
					// The given item is not a compatible context2d element, let's return before finalizing
					// the chart initialization but after setting basic chart / controller properties that
					// can help to figure out that the chart is not valid (e.g chart.canvas !== null);
					// https://github.com/chartjs/Chart.js/issues/2807
					console.error("Failed to create chart: can't acquire context from the given item");
					return;
				}

				me.initialize();
				me.update();
			},

			/**
			 * @private
			 */
			initialize: function() {
				var me = this;

				// Before init plugin notification
				plugins.notify(me, 'beforeInit');

				helpers$4.retinaScale(me, me.options.devicePixelRatio);

				me.bindEvents();

				if (me.options.responsive) {
					// Initial resize before chart draws (must be silent to preserve initial animations).
					me.resize(true);
				}

				// Make sure scales have IDs and are built before we build any controllers.
				me.ensureScalesHaveIDs();
				me.buildOrUpdateScales();
				me.initToolTip();

				// After init plugin notification
				plugins.notify(me, 'afterInit');

				return me;
			},

			clear: function() {
				helpers$4.canvas.clear(this);
				return this;
			},

			stop: function() {
				// Stops any current animation loop occurring
				animations.cancelAnimation(this);
				return this;
			},

			resize: function(silent) {
				var me = this;
				var options = me.options;
				var canvas = me.canvas;
				var aspectRatio = (options.maintainAspectRatio && me.aspectRatio) || null;

				// the canvas render width and height will be casted to integers so make sure that
				// the canvas display style uses the same integer values to avoid blurring effect.

				// Set to 0 instead of canvas.size because the size defaults to 300x150 if the element is collapsed
				var newWidth = Math.max(0, Math.floor(helpers$4.getMaximumWidth(canvas)));
				var newHeight = Math.max(0, Math.floor(aspectRatio ? newWidth / aspectRatio : helpers$4.getMaximumHeight(canvas)));

				if (me.width === newWidth && me.height === newHeight) {
					return;
				}

				canvas.width = me.width = newWidth;
				canvas.height = me.height = newHeight;
				canvas.style.width = newWidth + 'px';
				canvas.style.height = newHeight + 'px';

				helpers$4.retinaScale(me, options.devicePixelRatio);

				if (!silent) {
					// Notify any plugins about the resize
					var newSize = {width: newWidth, height: newHeight};
					plugins.notify(me, 'resize', [newSize]);

					// Notify of resize
					if (me.options.onResize) {
						me.options.onResize(me, newSize);
					}

					me.stop();
					me.update({
						duration: me.options.responsiveAnimationDuration
					});
				}
			},

			ensureScalesHaveIDs: function() {
				var options = this.options;
				var scalesOptions = options.scales || {};
				var scaleOptions = options.scale;

				helpers$4.each(scalesOptions.xAxes, function(xAxisOptions, index) {
					xAxisOptions.id = xAxisOptions.id || ('x-axis-' + index);
				});

				helpers$4.each(scalesOptions.yAxes, function(yAxisOptions, index) {
					yAxisOptions.id = yAxisOptions.id || ('y-axis-' + index);
				});

				if (scaleOptions) {
					scaleOptions.id = scaleOptions.id || 'scale';
				}
			},

			/**
			 * Builds a map of scale ID to scale object for future lookup.
			 */
			buildOrUpdateScales: function() {
				var me = this;
				var options = me.options;
				var scales = me.scales || {};
				var items = [];
				var updated = Object.keys(scales).reduce(function(obj, id) {
					obj[id] = false;
					return obj;
				}, {});

				if (options.scales) {
					items = items.concat(
						(options.scales.xAxes || []).map(function(xAxisOptions) {
							return {options: xAxisOptions, dtype: 'category', dposition: 'bottom'};
						}),
						(options.scales.yAxes || []).map(function(yAxisOptions) {
							return {options: yAxisOptions, dtype: 'linear', dposition: 'left'};
						})
					);
				}

				if (options.scale) {
					items.push({
						options: options.scale,
						dtype: 'radialLinear',
						isDefault: true,
						dposition: 'chartArea'
					});
				}

				helpers$4.each(items, function(item) {
					var scaleOptions = item.options;
					var id = scaleOptions.id;
					var scaleType = helpers$4.valueOrDefault(scaleOptions.type, item.dtype);

					if (positionIsHorizontal(scaleOptions.position) !== positionIsHorizontal(item.dposition)) {
						scaleOptions.position = item.dposition;
					}

					updated[id] = true;
					var scale = null;
					if (id in scales && scales[id].type === scaleType) {
						scale = scales[id];
						scale.options = scaleOptions;
						scale.ctx = me.ctx;
						scale.chart = me;
					} else {
						var scaleClass = scaleService.getScaleConstructor(scaleType);
						if (!scaleClass) {
							return;
						}
						scale = new scaleClass({
							id: id,
							type: scaleType,
							options: scaleOptions,
							ctx: me.ctx,
							chart: me
						});
						scales[scale.id] = scale;
					}

					scale.mergeTicksOptions();

					// TODO(SB): I think we should be able to remove this custom case (options.scale)
					// and consider it as a regular scale part of the "scales"" map only! This would
					// make the logic easier and remove some useless? custom code.
					if (item.isDefault) {
						me.scale = scale;
					}
				});
				// clear up discarded scales
				helpers$4.each(updated, function(hasUpdated, id) {
					if (!hasUpdated) {
						delete scales[id];
					}
				});

				me.scales = scales;

				scaleService.addScalesToLayout(this);
			},

			buildOrUpdateControllers: function() {
				var me = this;
				var types = [];
				var newControllers = [];

				helpers$4.each(me.data.datasets, function(dataset, datasetIndex) {
					var meta = me.getDatasetMeta(datasetIndex);
					var type = dataset.type || me.config.type;

					if (meta.type && meta.type !== type) {
						me.destroyDatasetMeta(datasetIndex);
						meta = me.getDatasetMeta(datasetIndex);
					}
					meta.type = type;

					types.push(meta.type);

					if (meta.controller) {
						meta.controller.updateIndex(datasetIndex);
						meta.controller.linkScales();
					} else {
						var ControllerClass = Chart.controllers[meta.type];
						if (ControllerClass === undefined) {
							throw new Error('"' + meta.type + '" is not a chart type.');
						}

						meta.controller = new ControllerClass(me, datasetIndex);
						newControllers.push(meta.controller);
					}
				}, me);

				return newControllers;
			},

			/**
			 * Reset the elements of all datasets
			 * @private
			 */
			resetElements: function() {
				var me = this;
				helpers$4.each(me.data.datasets, function(dataset, datasetIndex) {
					me.getDatasetMeta(datasetIndex).controller.reset();
				}, me);
			},

			/**
			* Resets the chart back to it's state before the initial animation
			*/
			reset: function() {
				this.resetElements();
				this.tooltip.initialize();
			},

			update: function(config) {
				var me = this;

				if (!config || typeof config !== 'object') {
					// backwards compatibility
					config = {
						duration: config,
						lazy: arguments[1]
					};
				}

				updateConfig(me);

				// plugins options references might have change, let's invalidate the cache
				// https://github.com/chartjs/Chart.js/issues/5111#issuecomment-355934167
				plugins._invalidate(me);

				if (plugins.notify(me, 'beforeUpdate') === false) {
					return;
				}

				// In case the entire data object changed
				me.tooltip._data = me.data;

				// Make sure dataset controllers are updated and new controllers are reset
				var newControllers = me.buildOrUpdateControllers();

				// Make sure all dataset controllers have correct meta data counts
				helpers$4.each(me.data.datasets, function(dataset, datasetIndex) {
					me.getDatasetMeta(datasetIndex).controller.buildOrUpdateElements();
				}, me);

				me.updateLayout();

				// Can only reset the new controllers after the scales have been updated
				if (me.options.animation && me.options.animation.duration) {
					helpers$4.each(newControllers, function(controller) {
						controller.reset();
					});
				}

				me.updateDatasets();

				// Need to reset tooltip in case it is displayed with elements that are removed
				// after update.
				me.tooltip.initialize();

				// Last active contains items that were previously in the tooltip.
				// When we reset the tooltip, we need to clear it
				me.lastActive = [];

				// Do this before render so that any plugins that need final scale updates can use it
				plugins.notify(me, 'afterUpdate');

				if (me._bufferedRender) {
					me._bufferedRequest = {
						duration: config.duration,
						easing: config.easing,
						lazy: config.lazy
					};
				} else {
					me.render(config);
				}
			},

			/**
			 * Updates the chart layout unless a plugin returns `false` to the `beforeLayout`
			 * hook, in which case, plugins will not be called on `afterLayout`.
			 * @private
			 */
			updateLayout: function() {
				var me = this;

				if (plugins.notify(me, 'beforeLayout') === false) {
					return;
				}

				layouts.update(this, this.width, this.height);

				/**
				 * Provided for backward compatibility, use `afterLayout` instead.
				 * @method IPlugin#afterScaleUpdate
				 * @deprecated since version 2.5.0
				 * @todo remove at version 3
				 * @private
				 */
				plugins.notify(me, 'afterScaleUpdate');
				plugins.notify(me, 'afterLayout');
			},

			/**
			 * Updates all datasets unless a plugin returns `false` to the `beforeDatasetsUpdate`
			 * hook, in which case, plugins will not be called on `afterDatasetsUpdate`.
			 * @private
			 */
			updateDatasets: function() {
				var me = this;

				if (plugins.notify(me, 'beforeDatasetsUpdate') === false) {
					return;
				}

				for (var i = 0, ilen = me.data.datasets.length; i < ilen; ++i) {
					me.updateDataset(i);
				}

				plugins.notify(me, 'afterDatasetsUpdate');
			},

			/**
			 * Updates dataset at index unless a plugin returns `false` to the `beforeDatasetUpdate`
			 * hook, in which case, plugins will not be called on `afterDatasetUpdate`.
			 * @private
			 */
			updateDataset: function(index) {
				var me = this;
				var meta = me.getDatasetMeta(index);
				var args = {
					meta: meta,
					index: index
				};

				if (plugins.notify(me, 'beforeDatasetUpdate', [args]) === false) {
					return;
				}

				meta.controller.update();

				plugins.notify(me, 'afterDatasetUpdate', [args]);
			},

			render: function(config) {
				var me = this;

				if (!config || typeof config !== 'object') {
					// backwards compatibility
					config = {
						duration: config,
						lazy: arguments[1]
					};
				}

				var duration = config.duration;
				var lazy = config.lazy;

				if (plugins.notify(me, 'beforeRender') === false) {
					return;
				}

				var animationOptions = me.options.animation;
				var onComplete = function(animation) {
					plugins.notify(me, 'afterRender');
					helpers$4.callback(animationOptions && animationOptions.onComplete, [animation], me);
				};

				if (animationOptions && ((typeof duration !== 'undefined' && duration !== 0) || (typeof duration === 'undefined' && animationOptions.duration !== 0))) {
					var animation = new Animation({
						numSteps: (duration || animationOptions.duration) / 16.66, // 60 fps
						easing: config.easing || animationOptions.easing,

						render: function(chart, animationObject) {
							var easingFunction = helpers$4.easing.effects[animationObject.easing];
							var currentStep = animationObject.currentStep;
							var stepDecimal = currentStep / animationObject.numSteps;

							chart.draw(easingFunction(stepDecimal), stepDecimal, currentStep);
						},

						onAnimationProgress: animationOptions.onProgress,
						onAnimationComplete: onComplete
					});

					animations.addAnimation(me, animation, duration, lazy);
				} else {
					me.draw();

					// See https://github.com/chartjs/Chart.js/issues/3781
					onComplete(new Animation({numSteps: 0, chart: me}));
				}

				return me;
			},

			draw: function(easingValue) {
				var me = this;

				me.clear();

				if (helpers$4.isNullOrUndef(easingValue)) {
					easingValue = 1;
				}

				me.transition(easingValue);

				if (me.width <= 0 || me.height <= 0) {
					return;
				}

				if (plugins.notify(me, 'beforeDraw', [easingValue]) === false) {
					return;
				}

				// Draw all the scales
				helpers$4.each(me.boxes, function(box) {
					box.draw(me.chartArea);
				}, me);

				if (me.scale) {
					me.scale.draw();
				}

				me.drawDatasets(easingValue);
				me._drawTooltip(easingValue);

				plugins.notify(me, 'afterDraw', [easingValue]);
			},

			/**
			 * @private
			 */
			transition: function(easingValue) {
				var me = this;

				for (var i = 0, ilen = (me.data.datasets || []).length; i < ilen; ++i) {
					if (me.isDatasetVisible(i)) {
						me.getDatasetMeta(i).controller.transition(easingValue);
					}
				}

				me.tooltip.transition(easingValue);
			},

			/**
			 * Draws all datasets unless a plugin returns `false` to the `beforeDatasetsDraw`
			 * hook, in which case, plugins will not be called on `afterDatasetsDraw`.
			 * @private
			 */
			drawDatasets: function(easingValue) {
				var me = this;

				if (plugins.notify(me, 'beforeDatasetsDraw', [easingValue]) === false) {
					return;
				}

				// Draw datasets reversed to support proper line stacking
				for (var i = (me.data.datasets || []).length - 1; i >= 0; --i) {
					if (me.isDatasetVisible(i)) {
						me.drawDataset(i, easingValue);
					}
				}

				plugins.notify(me, 'afterDatasetsDraw', [easingValue]);
			},

			/**
			 * Draws dataset at index unless a plugin returns `false` to the `beforeDatasetDraw`
			 * hook, in which case, plugins will not be called on `afterDatasetDraw`.
			 * @private
			 */
			drawDataset: function(index, easingValue) {
				var me = this;
				var meta = me.getDatasetMeta(index);
				var args = {
					meta: meta,
					index: index,
					easingValue: easingValue
				};

				if (plugins.notify(me, 'beforeDatasetDraw', [args]) === false) {
					return;
				}

				meta.controller.draw(easingValue);

				plugins.notify(me, 'afterDatasetDraw', [args]);
			},

			/**
			 * Draws tooltip unless a plugin returns `false` to the `beforeTooltipDraw`
			 * hook, in which case, plugins will not be called on `afterTooltipDraw`.
			 * @private
			 */
			_drawTooltip: function(easingValue) {
				var me = this;
				var tooltip = me.tooltip;
				var args = {
					tooltip: tooltip,
					easingValue: easingValue
				};

				if (plugins.notify(me, 'beforeTooltipDraw', [args]) === false) {
					return;
				}

				tooltip.draw();

				plugins.notify(me, 'afterTooltipDraw', [args]);
			},

			// Get the single element that was clicked on
			// @return : An object containing the dataset index and element index of the matching element. Also contains the rectangle that was draw
			getElementAtEvent: function(e) {
				return Interaction.modes.single(this, e);
			},

			getElementsAtEvent: function(e) {
				return Interaction.modes.label(this, e, {intersect: true});
			},

			getElementsAtXAxis: function(e) {
				return Interaction.modes['x-axis'](this, e, {intersect: true});
			},

			getElementsAtEventForMode: function(e, mode, options) {
				var method = Interaction.modes[mode];
				if (typeof method === 'function') {
					return method(this, e, options);
				}

				return [];
			},

			getDatasetAtEvent: function(e) {
				return Interaction.modes.dataset(this, e, {intersect: true});
			},

			getDatasetMeta: function(datasetIndex) {
				var me = this;
				var dataset = me.data.datasets[datasetIndex];
				if (!dataset._meta) {
					dataset._meta = {};
				}

				var meta = dataset._meta[me.id];
				if (!meta) {
					meta = dataset._meta[me.id] = {
						type: null,
						data: [],
						dataset: null,
						controller: null,
						hidden: null,			// See isDatasetVisible() comment
						xAxisID: null,
						yAxisID: null
					};
				}

				return meta;
			},

			getVisibleDatasetCount: function() {
				var this$1 = this;

				var count = 0;
				for (var i = 0, ilen = this.data.datasets.length; i < ilen; ++i) {
					if (this$1.isDatasetVisible(i)) {
						count++;
					}
				}
				return count;
			},

			isDatasetVisible: function(datasetIndex) {
				var meta = this.getDatasetMeta(datasetIndex);

				// meta.hidden is a per chart dataset hidden flag override with 3 states: if true or false,
				// the dataset.hidden value is ignored, else if null, the dataset hidden state is returned.
				return typeof meta.hidden === 'boolean' ? !meta.hidden : !this.data.datasets[datasetIndex].hidden;
			},

			generateLegend: function() {
				return this.options.legendCallback(this);
			},

			/**
			 * @private
			 */
			destroyDatasetMeta: function(datasetIndex) {
				var id = this.id;
				var dataset = this.data.datasets[datasetIndex];
				var meta = dataset._meta && dataset._meta[id];

				if (meta) {
					meta.controller.destroy();
					delete dataset._meta[id];
				}
			},

			destroy: function() {
				var me = this;
				var canvas = me.canvas;
				var i, ilen;

				me.stop();

				// dataset controllers need to cleanup associated data
				for (i = 0, ilen = me.data.datasets.length; i < ilen; ++i) {
					me.destroyDatasetMeta(i);
				}

				if (canvas) {
					me.unbindEvents();
					helpers$4.canvas.clear(me);
					platform$2.releaseContext(me.ctx);
					me.canvas = null;
					me.ctx = null;
				}

				plugins.notify(me, 'destroy');

				delete Chart.instances[me.id];
			},

			toBase64Image: function() {
				return this.canvas.toDataURL.apply(this.canvas, arguments);
			},

			initToolTip: function() {
				var me = this;
				me.tooltip = new Tooltip({
					_chart: me,
					_chartInstance: me, // deprecated, backward compatibility
					_data: me.data,
					_options: me.options.tooltips
				}, me);
			},

			/**
			 * @private
			 */
			bindEvents: function() {
				var me = this;
				var listeners = me._listeners = {};
				var listener = function() {
					me.eventHandler.apply(me, arguments);
				};

				helpers$4.each(me.options.events, function(type) {
					platform$2.addEventListener(me, type, listener);
					listeners[type] = listener;
				});

				// Elements used to detect size change should not be injected for non responsive charts.
				// See https://github.com/chartjs/Chart.js/issues/2210
				if (me.options.responsive) {
					listener = function() {
						me.resize();
					};

					platform$2.addEventListener(me, 'resize', listener);
					listeners.resize = listener;
				}
			},

			/**
			 * @private
			 */
			unbindEvents: function() {
				var me = this;
				var listeners = me._listeners;
				if (!listeners) {
					return;
				}

				delete me._listeners;
				helpers$4.each(listeners, function(listener, type) {
					platform$2.removeEventListener(me, type, listener);
				});
			},

			updateHoverStyle: function(elements, mode, enabled) {
				var this$1 = this;

				var method = enabled ? 'setHoverStyle' : 'removeHoverStyle';
				var element, i, ilen;

				for (i = 0, ilen = elements.length; i < ilen; ++i) {
					element = elements[i];
					if (element) {
						this$1.getDatasetMeta(element._datasetIndex).controller[method](element);
					}
				}
			},

			/**
			 * @private
			 */
			eventHandler: function(e) {
				var me = this;
				var tooltip = me.tooltip;

				if (plugins.notify(me, 'beforeEvent', [e]) === false) {
					return;
				}

				// Buffer any update calls so that renders do not occur
				me._bufferedRender = true;
				me._bufferedRequest = null;

				var changed = me.handleEvent(e);
				// for smooth tooltip animations issue #4989
				// the tooltip should be the source of change
				// Animation check workaround:
				// tooltip._start will be null when tooltip isn't animating
				if (tooltip) {
					changed = tooltip._start
						? tooltip.handleEvent(e)
						: changed | tooltip.handleEvent(e);
				}

				plugins.notify(me, 'afterEvent', [e]);

				var bufferedRequest = me._bufferedRequest;
				if (bufferedRequest) {
					// If we have an update that was triggered, we need to do a normal render
					me.render(bufferedRequest);
				} else if (changed && !me.animating) {
					// If entering, leaving, or changing elements, animate the change via pivot
					me.stop();

					// We only need to render at this point. Updating will cause scales to be
					// recomputed generating flicker & using more memory than necessary.
					me.render({
						duration: me.options.hover.animationDuration,
						lazy: true
					});
				}

				me._bufferedRender = false;
				me._bufferedRequest = null;

				return me;
			},

			/**
			 * Handle an event
			 * @private
			 * @param {IEvent} event the event to handle
			 * @return {Boolean} true if the chart needs to re-render
			 */
			handleEvent: function(e) {
				var me = this;
				var options = me.options || {};
				var hoverOptions = options.hover;
				var changed = false;

				me.lastActive = me.lastActive || [];

				// Find Active Elements for hover and tooltips
				if (e.type === 'mouseout') {
					me.active = [];
				} else {
					me.active = me.getElementsAtEventForMode(e, hoverOptions.mode, hoverOptions);
				}

				// Invoke onHover hook
				// Need to call with native event here to not break backwards compatibility
				helpers$4.callback(options.onHover || options.hover.onHover, [e.native, me.active], me);

				if (e.type === 'mouseup' || e.type === 'click') {
					if (options.onClick) {
						// Use e.native here for backwards compatibility
						options.onClick.call(me, e.native, me.active);
					}
				}

				// Remove styling for last active (even if it may still be active)
				if (me.lastActive.length) {
					me.updateHoverStyle(me.lastActive, hoverOptions.mode, false);
				}

				// Built in hover styling
				if (me.active.length && hoverOptions.mode) {
					me.updateHoverStyle(me.active, hoverOptions.mode, true);
				}

				changed = !helpers$4.arrayEquals(me.active, me.lastActive);

				// Remember Last Actives
				me.lastActive = me.active;

				return changed;
			}
		});

		/**
		 * Provided for backward compatibility, use Chart instead.
		 * @class Chart.Controller
		 * @deprecated since version 2.6.0
		 * @todo remove at version 3
		 * @private
		 */
		Chart.Controller = Chart;
	};

	var core_controller$1 = /*#__PURE__*/Object.freeze({
		default: core_controller,
		__moduleExports: core_controller
	});

	var core_datasetController = function(Chart) {

		var arrayEvents = ['push', 'pop', 'shift', 'splice', 'unshift'];

		/**
		 * Hooks the array methods that add or remove values ('push', pop', 'shift', 'splice',
		 * 'unshift') and notify the listener AFTER the array has been altered. Listeners are
		 * called on the 'onData*' callbacks (e.g. onDataPush, etc.) with same arguments.
		 */
		function listenArrayEvents(array, listener) {
			if (array._chartjs) {
				array._chartjs.listeners.push(listener);
				return;
			}

			Object.defineProperty(array, '_chartjs', {
				configurable: true,
				enumerable: false,
				value: {
					listeners: [listener]
				}
			});

			arrayEvents.forEach(function(key) {
				var method = 'onData' + key.charAt(0).toUpperCase() + key.slice(1);
				var base = array[key];

				Object.defineProperty(array, key, {
					configurable: true,
					enumerable: false,
					value: function() {
						var args = Array.prototype.slice.call(arguments);
						var res = base.apply(this, args);

						helpers$4.each(array._chartjs.listeners, function(object) {
							if (typeof object[method] === 'function') {
								object[method].apply(object, args);
							}
						});

						return res;
					}
				});
			});
		}

		/**
		 * Removes the given array event listener and cleanup extra attached properties (such as
		 * the _chartjs stub and overridden methods) if array doesn't have any more listeners.
		 */
		function unlistenArrayEvents(array, listener) {
			var stub = array._chartjs;
			if (!stub) {
				return;
			}

			var listeners = stub.listeners;
			var index = listeners.indexOf(listener);
			if (index !== -1) {
				listeners.splice(index, 1);
			}

			if (listeners.length > 0) {
				return;
			}

			arrayEvents.forEach(function(key) {
				delete array[key];
			});

			delete array._chartjs;
		}

		// Base class for all dataset controllers (line, bar, etc)
		Chart.DatasetController = function(chart, datasetIndex) {
			this.initialize(chart, datasetIndex);
		};

		helpers$4.extend(Chart.DatasetController.prototype, {

			/**
			 * Element type used to generate a meta dataset (e.g. Chart.element.Line).
			 * @type {Chart.core.element}
			 */
			datasetElementType: null,

			/**
			 * Element type used to generate a meta data (e.g. Chart.element.Point).
			 * @type {Chart.core.element}
			 */
			dataElementType: null,

			initialize: function(chart, datasetIndex) {
				var me = this;
				me.chart = chart;
				me.index = datasetIndex;
				me.linkScales();
				me.addElements();
			},

			updateIndex: function(datasetIndex) {
				this.index = datasetIndex;
			},

			linkScales: function() {
				var me = this;
				var meta = me.getMeta();
				var dataset = me.getDataset();

				if (meta.xAxisID === null || !(meta.xAxisID in me.chart.scales)) {
					meta.xAxisID = dataset.xAxisID || me.chart.options.scales.xAxes[0].id;
				}
				if (meta.yAxisID === null || !(meta.yAxisID in me.chart.scales)) {
					meta.yAxisID = dataset.yAxisID || me.chart.options.scales.yAxes[0].id;
				}
			},

			getDataset: function() {
				return this.chart.data.datasets[this.index];
			},

			getMeta: function() {
				return this.chart.getDatasetMeta(this.index);
			},

			getScaleForId: function(scaleID) {
				return this.chart.scales[scaleID];
			},

			reset: function() {
				this.update(true);
			},

			/**
			 * @private
			 */
			destroy: function() {
				if (this._data) {
					unlistenArrayEvents(this._data, this);
				}
			},

			createMetaDataset: function() {
				var me = this;
				var type = me.datasetElementType;
				return type && new type({
					_chart: me.chart,
					_datasetIndex: me.index
				});
			},

			createMetaData: function(index) {
				var me = this;
				var type = me.dataElementType;
				return type && new type({
					_chart: me.chart,
					_datasetIndex: me.index,
					_index: index
				});
			},

			addElements: function() {
				var me = this;
				var meta = me.getMeta();
				var data = me.getDataset().data || [];
				var metaData = meta.data;
				var i, ilen;

				for (i = 0, ilen = data.length; i < ilen; ++i) {
					metaData[i] = metaData[i] || me.createMetaData(i);
				}

				meta.dataset = meta.dataset || me.createMetaDataset();
			},

			addElementAndReset: function(index) {
				var element = this.createMetaData(index);
				this.getMeta().data.splice(index, 0, element);
				this.updateElement(element, index, true);
			},

			buildOrUpdateElements: function() {
				var me = this;
				var dataset = me.getDataset();
				var data = dataset.data || (dataset.data = []);

				// In order to correctly handle data addition/deletion animation (an thus simulate
				// real-time charts), we need to monitor these data modifications and synchronize
				// the internal meta data accordingly.
				if (me._data !== data) {
					if (me._data) {
						// This case happens when the user replaced the data array instance.
						unlistenArrayEvents(me._data, me);
					}

					listenArrayEvents(data, me);
					me._data = data;
				}

				// Re-sync meta data in case the user replaced the data array or if we missed
				// any updates and so make sure that we handle number of datapoints changing.
				me.resyncElements();
			},

			update: helpers$4.noop,

			transition: function(easingValue) {
				var meta = this.getMeta();
				var elements = meta.data || [];
				var ilen = elements.length;
				var i = 0;

				for (; i < ilen; ++i) {
					elements[i].transition(easingValue);
				}

				if (meta.dataset) {
					meta.dataset.transition(easingValue);
				}
			},

			draw: function() {
				var meta = this.getMeta();
				var elements = meta.data || [];
				var ilen = elements.length;
				var i = 0;

				if (meta.dataset) {
					meta.dataset.draw();
				}

				for (; i < ilen; ++i) {
					elements[i].draw();
				}
			},

			removeHoverStyle: function(element) {
				helpers$4.merge(element._model, element.$previousStyle || {});
				delete element.$previousStyle;
			},

			setHoverStyle: function(element) {
				var dataset = this.chart.data.datasets[element._datasetIndex];
				var index = element._index;
				var custom = element.custom || {};
				var valueOrDefault = helpers$4.valueAtIndexOrDefault;
				var getHoverColor = helpers$4.getHoverColor;
				var model = element._model;

				element.$previousStyle = {
					backgroundColor: model.backgroundColor,
					borderColor: model.borderColor,
					borderWidth: model.borderWidth
				};

				model.backgroundColor = custom.hoverBackgroundColor ? custom.hoverBackgroundColor : valueOrDefault(dataset.hoverBackgroundColor, index, getHoverColor(model.backgroundColor));
				model.borderColor = custom.hoverBorderColor ? custom.hoverBorderColor : valueOrDefault(dataset.hoverBorderColor, index, getHoverColor(model.borderColor));
				model.borderWidth = custom.hoverBorderWidth ? custom.hoverBorderWidth : valueOrDefault(dataset.hoverBorderWidth, index, model.borderWidth);
			},

			/**
			 * @private
			 */
			resyncElements: function() {
				var me = this;
				var meta = me.getMeta();
				var data = me.getDataset().data;
				var numMeta = meta.data.length;
				var numData = data.length;

				if (numData < numMeta) {
					meta.data.splice(numData, numMeta - numData);
				} else if (numData > numMeta) {
					me.insertElements(numMeta, numData - numMeta);
				}
			},

			/**
			 * @private
			 */
			insertElements: function(start, count) {
				var this$1 = this;

				for (var i = 0; i < count; ++i) {
					this$1.addElementAndReset(start + i);
				}
			},

			/**
			 * @private
			 */
			onDataPush: function() {
				this.insertElements(this.getDataset().data.length - 1, arguments.length);
			},

			/**
			 * @private
			 */
			onDataPop: function() {
				this.getMeta().data.pop();
			},

			/**
			 * @private
			 */
			onDataShift: function() {
				this.getMeta().data.shift();
			},

			/**
			 * @private
			 */
			onDataSplice: function(start, count) {
				this.getMeta().data.splice(start, count);
				this.insertElements(start, arguments.length - 2);
			},

			/**
			 * @private
			 */
			onDataUnshift: function() {
				this.insertElements(0, arguments.length);
			}
		});

		Chart.DatasetController.extend = helpers$4.inherits;
	};

	var core_datasetController$1 = /*#__PURE__*/Object.freeze({
		default: core_datasetController,
		__moduleExports: core_datasetController
	});

	var Scale = ( core_scale$1 && core_scale ) || core_scale$1;

	/**
	 * Generate a set of linear ticks
	 * @param generationOptions the options used to generate the ticks
	 * @param dataRange the range of the data
	 * @returns {Array<Number>} array of tick values
	 */
	function generateTicks(generationOptions, dataRange) {
		var ticks = [];
		// To get a "nice" value for the tick spacing, we will use the appropriately named
		// "nice number" algorithm. See http://stackoverflow.com/questions/8506881/nice-label-algorithm-for-charts-with-minimum-ticks
		// for details.

		var factor;
		var precision;
		var spacing;

		if (generationOptions.stepSize && generationOptions.stepSize > 0) {
			spacing = generationOptions.stepSize;
		} else {
			var niceRange = helpers$4.niceNum(dataRange.max - dataRange.min, false);
			spacing = helpers$4.niceNum(niceRange / (generationOptions.maxTicks - 1), true);

			precision = generationOptions.precision;
			if (precision !== undefined) {
				// If the user specified a precision, round to that number of decimal places
				factor = Math.pow(10, precision);
				spacing = Math.ceil(spacing * factor) / factor;
			}
		}
		var niceMin = Math.floor(dataRange.min / spacing) * spacing;
		var niceMax = Math.ceil(dataRange.max / spacing) * spacing;

		// If min, max and stepSize is set and they make an evenly spaced scale use it.
		if (!helpers$4.isNullOrUndef(generationOptions.min) && !helpers$4.isNullOrUndef(generationOptions.max) && generationOptions.stepSize) {
			// If very close to our whole number, use it.
			if (helpers$4.almostWhole((generationOptions.max - generationOptions.min) / generationOptions.stepSize, spacing / 1000)) {
				niceMin = generationOptions.min;
				niceMax = generationOptions.max;
			}
		}

		var numSpaces = (niceMax - niceMin) / spacing;
		// If very close to our rounded value, use it.
		if (helpers$4.almostEquals(numSpaces, Math.round(numSpaces), spacing / 1000)) {
			numSpaces = Math.round(numSpaces);
		} else {
			numSpaces = Math.ceil(numSpaces);
		}

		precision = 1;
		if (spacing < 1) {
			precision = Math.pow(10, 1 - Math.floor(helpers$4.log10(spacing)));
			niceMin = Math.round(niceMin * precision) / precision;
			niceMax = Math.round(niceMax * precision) / precision;
		}
		ticks.push(generationOptions.min !== undefined ? generationOptions.min : niceMin);
		for (var j = 1; j < numSpaces; ++j) {
			ticks.push(Math.round((niceMin + j * spacing) * precision) / precision);
		}
		ticks.push(generationOptions.max !== undefined ? generationOptions.max : niceMax);

		return ticks;
	}

	var scale_linearbase = function(Chart) {

		var noop = helpers$4.noop;

		Chart.LinearScaleBase = Scale.extend({
			getRightValue: function(value) {
				if (typeof value === 'string') {
					return +value;
				}
				return Scale.prototype.getRightValue.call(this, value);
			},

			handleTickRangeOptions: function() {
				var me = this;
				var opts = me.options;
				var tickOpts = opts.ticks;

				// If we are forcing it to begin at 0, but 0 will already be rendered on the chart,
				// do nothing since that would make the chart weird. If the user really wants a weird chart
				// axis, they can manually override it
				if (tickOpts.beginAtZero) {
					var minSign = helpers$4.sign(me.min);
					var maxSign = helpers$4.sign(me.max);

					if (minSign < 0 && maxSign < 0) {
						// move the top up to 0
						me.max = 0;
					} else if (minSign > 0 && maxSign > 0) {
						// move the bottom down to 0
						me.min = 0;
					}
				}

				var setMin = tickOpts.min !== undefined || tickOpts.suggestedMin !== undefined;
				var setMax = tickOpts.max !== undefined || tickOpts.suggestedMax !== undefined;

				if (tickOpts.min !== undefined) {
					me.min = tickOpts.min;
				} else if (tickOpts.suggestedMin !== undefined) {
					if (me.min === null) {
						me.min = tickOpts.suggestedMin;
					} else {
						me.min = Math.min(me.min, tickOpts.suggestedMin);
					}
				}

				if (tickOpts.max !== undefined) {
					me.max = tickOpts.max;
				} else if (tickOpts.suggestedMax !== undefined) {
					if (me.max === null) {
						me.max = tickOpts.suggestedMax;
					} else {
						me.max = Math.max(me.max, tickOpts.suggestedMax);
					}
				}

				if (setMin !== setMax) {
					// We set the min or the max but not both.
					// So ensure that our range is good
					// Inverted or 0 length range can happen when
					// ticks.min is set, and no datasets are visible
					if (me.min >= me.max) {
						if (setMin) {
							me.max = me.min + 1;
						} else {
							me.min = me.max - 1;
						}
					}
				}

				if (me.min === me.max) {
					me.max++;

					if (!tickOpts.beginAtZero) {
						me.min--;
					}
				}
			},
			getTickLimit: noop,
			handleDirectionalChanges: noop,

			buildTicks: function() {
				var me = this;
				var opts = me.options;
				var tickOpts = opts.ticks;

				// Figure out what the max number of ticks we can support it is based on the size of
				// the axis area. For now, we say that the minimum tick spacing in pixels must be 50
				// We also limit the maximum number of ticks to 11 which gives a nice 10 squares on
				// the graph. Make sure we always have at least 2 ticks
				var maxTicks = me.getTickLimit();
				maxTicks = Math.max(2, maxTicks);

				var numericGeneratorOptions = {
					maxTicks: maxTicks,
					min: tickOpts.min,
					max: tickOpts.max,
					precision: tickOpts.precision,
					stepSize: helpers$4.valueOrDefault(tickOpts.fixedStepSize, tickOpts.stepSize)
				};
				var ticks = me.ticks = generateTicks(numericGeneratorOptions, me);

				me.handleDirectionalChanges();

				// At this point, we need to update our max and min given the tick values since we have expanded the
				// range of the scale
				me.max = helpers$4.max(ticks);
				me.min = helpers$4.min(ticks);

				if (tickOpts.reverse) {
					ticks.reverse();

					me.start = me.max;
					me.end = me.min;
				} else {
					me.start = me.min;
					me.end = me.max;
				}
			},
			convertTicksToLabels: function() {
				var me = this;
				me.ticksAsNumbers = me.ticks.slice();
				me.zeroLineIndex = me.ticks.indexOf(0);

				Scale.prototype.convertTicksToLabels.call(me);
			}
		});
	};

	var scale_linearbase$1 = /*#__PURE__*/Object.freeze({
		default: scale_linearbase,
		__moduleExports: scale_linearbase
	});

	var scale_category = function() {

		// Default config for a category scale
		var defaultConfig = {
			position: 'bottom'
		};

		var DatasetScale = Scale.extend({
			/**
			* Internal function to get the correct labels. If data.xLabels or data.yLabels are defined, use those
			* else fall back to data.labels
			* @private
			*/
			getLabels: function() {
				var data = this.chart.data;
				return this.options.labels || (this.isHorizontal() ? data.xLabels : data.yLabels) || data.labels;
			},

			determineDataLimits: function() {
				var me = this;
				var labels = me.getLabels();
				me.minIndex = 0;
				me.maxIndex = labels.length - 1;
				var findIndex;

				if (me.options.ticks.min !== undefined) {
					// user specified min value
					findIndex = labels.indexOf(me.options.ticks.min);
					me.minIndex = findIndex !== -1 ? findIndex : me.minIndex;
				}

				if (me.options.ticks.max !== undefined) {
					// user specified max value
					findIndex = labels.indexOf(me.options.ticks.max);
					me.maxIndex = findIndex !== -1 ? findIndex : me.maxIndex;
				}

				me.min = labels[me.minIndex];
				me.max = labels[me.maxIndex];
			},

			buildTicks: function() {
				var me = this;
				var labels = me.getLabels();
				// If we are viewing some subset of labels, slice the original array
				me.ticks = (me.minIndex === 0 && me.maxIndex === labels.length - 1) ? labels : labels.slice(me.minIndex, me.maxIndex + 1);
			},

			getLabelForIndex: function(index, datasetIndex) {
				var me = this;
				var data = me.chart.data;
				var isHorizontal = me.isHorizontal();

				if (data.yLabels && !isHorizontal) {
					return me.getRightValue(data.datasets[datasetIndex].data[index]);
				}
				return me.ticks[index - me.minIndex];
			},

			// Used to get data value locations.  Value can either be an index or a numerical value
			getPixelForValue: function(value, index) {
				var me = this;
				var offset = me.options.offset;
				// 1 is added because we need the length but we have the indexes
				var offsetAmt = Math.max((me.maxIndex + 1 - me.minIndex - (offset ? 0 : 1)), 1);

				// If value is a data object, then index is the index in the data array,
				// not the index of the scale. We need to change that.
				var valueCategory;
				if (value !== undefined && value !== null) {
					valueCategory = me.isHorizontal() ? value.x : value.y;
				}
				if (valueCategory !== undefined || (value !== undefined && isNaN(index))) {
					var labels = me.getLabels();
					value = valueCategory || value;
					var idx = labels.indexOf(value);
					index = idx !== -1 ? idx : index;
				}

				if (me.isHorizontal()) {
					var valueWidth = me.width / offsetAmt;
					var widthOffset = (valueWidth * (index - me.minIndex));

					if (offset) {
						widthOffset += (valueWidth / 2);
					}

					return me.left + Math.round(widthOffset);
				}
				var valueHeight = me.height / offsetAmt;
				var heightOffset = (valueHeight * (index - me.minIndex));

				if (offset) {
					heightOffset += (valueHeight / 2);
				}

				return me.top + Math.round(heightOffset);
			},
			getPixelForTick: function(index) {
				return this.getPixelForValue(this.ticks[index], index + this.minIndex, null);
			},
			getValueForPixel: function(pixel) {
				var me = this;
				var offset = me.options.offset;
				var value;
				var offsetAmt = Math.max((me._ticks.length - (offset ? 0 : 1)), 1);
				var horz = me.isHorizontal();
				var valueDimension = (horz ? me.width : me.height) / offsetAmt;

				pixel -= horz ? me.left : me.top;

				if (offset) {
					pixel -= (valueDimension / 2);
				}

				if (pixel <= 0) {
					value = 0;
				} else {
					value = Math.round(pixel / valueDimension);
				}

				return value + me.minIndex;
			},
			getBasePixel: function() {
				return this.bottom;
			}
		});

		scaleService.registerScaleType('category', DatasetScale, defaultConfig);
	};

	var scale_category$1 = /*#__PURE__*/Object.freeze({
		default: scale_category,
		__moduleExports: scale_category
	});

	var scale_linear = function(Chart) {

		var defaultConfig = {
			position: 'left',
			ticks: {
				callback: Ticks.formatters.linear
			}
		};

		var LinearScale = Chart.LinearScaleBase.extend({

			determineDataLimits: function() {
				var me = this;
				var opts = me.options;
				var chart = me.chart;
				var data = chart.data;
				var datasets = data.datasets;
				var isHorizontal = me.isHorizontal();
				var DEFAULT_MIN = 0;
				var DEFAULT_MAX = 1;

				function IDMatches(meta) {
					return isHorizontal ? meta.xAxisID === me.id : meta.yAxisID === me.id;
				}

				// First Calculate the range
				me.min = null;
				me.max = null;

				var hasStacks = opts.stacked;
				if (hasStacks === undefined) {
					helpers$4.each(datasets, function(dataset, datasetIndex) {
						if (hasStacks) {
							return;
						}

						var meta = chart.getDatasetMeta(datasetIndex);
						if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta) &&
							meta.stack !== undefined) {
							hasStacks = true;
						}
					});
				}

				if (opts.stacked || hasStacks) {
					var valuesPerStack = {};

					helpers$4.each(datasets, function(dataset, datasetIndex) {
						var meta = chart.getDatasetMeta(datasetIndex);
						var key = [
							meta.type,
							// we have a separate stack for stack=undefined datasets when the opts.stacked is undefined
							((opts.stacked === undefined && meta.stack === undefined) ? datasetIndex : ''),
							meta.stack
						].join('.');

						if (valuesPerStack[key] === undefined) {
							valuesPerStack[key] = {
								positiveValues: [],
								negativeValues: []
							};
						}

						// Store these per type
						var positiveValues = valuesPerStack[key].positiveValues;
						var negativeValues = valuesPerStack[key].negativeValues;

						if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
							helpers$4.each(dataset.data, function(rawValue, index) {
								var value = +me.getRightValue(rawValue);
								if (isNaN(value) || meta.data[index].hidden) {
									return;
								}

								positiveValues[index] = positiveValues[index] || 0;
								negativeValues[index] = negativeValues[index] || 0;

								if (opts.relativePoints) {
									positiveValues[index] = 100;
								} else if (value < 0) {
									negativeValues[index] += value;
								} else {
									positiveValues[index] += value;
								}
							});
						}
					});

					helpers$4.each(valuesPerStack, function(valuesForType) {
						var values = valuesForType.positiveValues.concat(valuesForType.negativeValues);
						var minVal = helpers$4.min(values);
						var maxVal = helpers$4.max(values);
						me.min = me.min === null ? minVal : Math.min(me.min, minVal);
						me.max = me.max === null ? maxVal : Math.max(me.max, maxVal);
					});

				} else {
					helpers$4.each(datasets, function(dataset, datasetIndex) {
						var meta = chart.getDatasetMeta(datasetIndex);
						if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
							helpers$4.each(dataset.data, function(rawValue, index) {
								var value = +me.getRightValue(rawValue);
								if (isNaN(value) || meta.data[index].hidden) {
									return;
								}

								if (me.min === null) {
									me.min = value;
								} else if (value < me.min) {
									me.min = value;
								}

								if (me.max === null) {
									me.max = value;
								} else if (value > me.max) {
									me.max = value;
								}
							});
						}
					});
				}

				me.min = isFinite(me.min) && !isNaN(me.min) ? me.min : DEFAULT_MIN;
				me.max = isFinite(me.max) && !isNaN(me.max) ? me.max : DEFAULT_MAX;

				// Common base implementation to handle ticks.min, ticks.max, ticks.beginAtZero
				this.handleTickRangeOptions();
			},
			getTickLimit: function() {
				var maxTicks;
				var me = this;
				var tickOpts = me.options.ticks;

				if (me.isHorizontal()) {
					maxTicks = Math.min(tickOpts.maxTicksLimit ? tickOpts.maxTicksLimit : 11, Math.ceil(me.width / 50));
				} else {
					// The factor of 2 used to scale the font size has been experimentally determined.
					var tickFontSize = helpers$4.valueOrDefault(tickOpts.fontSize, defaults$3.global.defaultFontSize);
					maxTicks = Math.min(tickOpts.maxTicksLimit ? tickOpts.maxTicksLimit : 11, Math.ceil(me.height / (2 * tickFontSize)));
				}

				return maxTicks;
			},
			// Called after the ticks are built. We need
			handleDirectionalChanges: function() {
				if (!this.isHorizontal()) {
					// We are in a vertical orientation. The top value is the highest. So reverse the array
					this.ticks.reverse();
				}
			},
			getLabelForIndex: function(index, datasetIndex) {
				return +this.getRightValue(this.chart.data.datasets[datasetIndex].data[index]);
			},
			// Utils
			getPixelForValue: function(value) {
				// This must be called after fit has been run so that
				// this.left, this.top, this.right, and this.bottom have been defined
				var me = this;
				var start = me.start;

				var rightValue = +me.getRightValue(value);
				var pixel;
				var range = me.end - start;

				if (me.isHorizontal()) {
					pixel = me.left + (me.width / range * (rightValue - start));
				} else {
					pixel = me.bottom - (me.height / range * (rightValue - start));
				}
				return pixel;
			},
			getValueForPixel: function(pixel) {
				var me = this;
				var isHorizontal = me.isHorizontal();
				var innerDimension = isHorizontal ? me.width : me.height;
				var offset = (isHorizontal ? pixel - me.left : me.bottom - pixel) / innerDimension;
				return me.start + ((me.end - me.start) * offset);
			},
			getPixelForTick: function(index) {
				return this.getPixelForValue(this.ticksAsNumbers[index]);
			}
		});

		scaleService.registerScaleType('linear', LinearScale, defaultConfig);
	};

	var scale_linear$1 = /*#__PURE__*/Object.freeze({
		default: scale_linear,
		__moduleExports: scale_linear
	});

	/**
	 * Generate a set of logarithmic ticks
	 * @param generationOptions the options used to generate the ticks
	 * @param dataRange the range of the data
	 * @returns {Array<Number>} array of tick values
	 */
	function generateTicks$1(generationOptions, dataRange) {
		var ticks = [];
		var valueOrDefault = helpers$4.valueOrDefault;

		// Figure out what the max number of ticks we can support it is based on the size of
		// the axis area. For now, we say that the minimum tick spacing in pixels must be 50
		// We also limit the maximum number of ticks to 11 which gives a nice 10 squares on
		// the graph
		var tickVal = valueOrDefault(generationOptions.min, Math.pow(10, Math.floor(helpers$4.log10(dataRange.min))));

		var endExp = Math.floor(helpers$4.log10(dataRange.max));
		var endSignificand = Math.ceil(dataRange.max / Math.pow(10, endExp));
		var exp, significand;

		if (tickVal === 0) {
			exp = Math.floor(helpers$4.log10(dataRange.minNotZero));
			significand = Math.floor(dataRange.minNotZero / Math.pow(10, exp));

			ticks.push(tickVal);
			tickVal = significand * Math.pow(10, exp);
		} else {
			exp = Math.floor(helpers$4.log10(tickVal));
			significand = Math.floor(tickVal / Math.pow(10, exp));
		}
		var precision = exp < 0 ? Math.pow(10, Math.abs(exp)) : 1;

		do {
			ticks.push(tickVal);

			++significand;
			if (significand === 10) {
				significand = 1;
				++exp;
				precision = exp >= 0 ? 1 : precision;
			}

			tickVal = Math.round(significand * Math.pow(10, exp) * precision) / precision;
		} while (exp < endExp || (exp === endExp && significand < endSignificand));

		var lastTick = valueOrDefault(generationOptions.max, tickVal);
		ticks.push(lastTick);

		return ticks;
	}


	var scale_logarithmic = function(Chart) {

		var defaultConfig = {
			position: 'left',

			// label settings
			ticks: {
				callback: Ticks.formatters.logarithmic
			}
		};

		var LogarithmicScale = Scale.extend({
			determineDataLimits: function() {
				var me = this;
				var opts = me.options;
				var chart = me.chart;
				var data = chart.data;
				var datasets = data.datasets;
				var isHorizontal = me.isHorizontal();
				function IDMatches(meta) {
					return isHorizontal ? meta.xAxisID === me.id : meta.yAxisID === me.id;
				}

				// Calculate Range
				me.min = null;
				me.max = null;
				me.minNotZero = null;

				var hasStacks = opts.stacked;
				if (hasStacks === undefined) {
					helpers$4.each(datasets, function(dataset, datasetIndex) {
						if (hasStacks) {
							return;
						}

						var meta = chart.getDatasetMeta(datasetIndex);
						if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta) &&
							meta.stack !== undefined) {
							hasStacks = true;
						}
					});
				}

				if (opts.stacked || hasStacks) {
					var valuesPerStack = {};

					helpers$4.each(datasets, function(dataset, datasetIndex) {
						var meta = chart.getDatasetMeta(datasetIndex);
						var key = [
							meta.type,
							// we have a separate stack for stack=undefined datasets when the opts.stacked is undefined
							((opts.stacked === undefined && meta.stack === undefined) ? datasetIndex : ''),
							meta.stack
						].join('.');

						if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
							if (valuesPerStack[key] === undefined) {
								valuesPerStack[key] = [];
							}

							helpers$4.each(dataset.data, function(rawValue, index) {
								var values = valuesPerStack[key];
								var value = +me.getRightValue(rawValue);
								// invalid, hidden and negative values are ignored
								if (isNaN(value) || meta.data[index].hidden || value < 0) {
									return;
								}
								values[index] = values[index] || 0;
								values[index] += value;
							});
						}
					});

					helpers$4.each(valuesPerStack, function(valuesForType) {
						if (valuesForType.length > 0) {
							var minVal = helpers$4.min(valuesForType);
							var maxVal = helpers$4.max(valuesForType);
							me.min = me.min === null ? minVal : Math.min(me.min, minVal);
							me.max = me.max === null ? maxVal : Math.max(me.max, maxVal);
						}
					});

				} else {
					helpers$4.each(datasets, function(dataset, datasetIndex) {
						var meta = chart.getDatasetMeta(datasetIndex);
						if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
							helpers$4.each(dataset.data, function(rawValue, index) {
								var value = +me.getRightValue(rawValue);
								// invalid, hidden and negative values are ignored
								if (isNaN(value) || meta.data[index].hidden || value < 0) {
									return;
								}

								if (me.min === null) {
									me.min = value;
								} else if (value < me.min) {
									me.min = value;
								}

								if (me.max === null) {
									me.max = value;
								} else if (value > me.max) {
									me.max = value;
								}

								if (value !== 0 && (me.minNotZero === null || value < me.minNotZero)) {
									me.minNotZero = value;
								}
							});
						}
					});
				}

				// Common base implementation to handle ticks.min, ticks.max
				this.handleTickRangeOptions();
			},
			handleTickRangeOptions: function() {
				var me = this;
				var opts = me.options;
				var tickOpts = opts.ticks;
				var valueOrDefault = helpers$4.valueOrDefault;
				var DEFAULT_MIN = 1;
				var DEFAULT_MAX = 10;

				me.min = valueOrDefault(tickOpts.min, me.min);
				me.max = valueOrDefault(tickOpts.max, me.max);

				if (me.min === me.max) {
					if (me.min !== 0 && me.min !== null) {
						me.min = Math.pow(10, Math.floor(helpers$4.log10(me.min)) - 1);
						me.max = Math.pow(10, Math.floor(helpers$4.log10(me.max)) + 1);
					} else {
						me.min = DEFAULT_MIN;
						me.max = DEFAULT_MAX;
					}
				}
				if (me.min === null) {
					me.min = Math.pow(10, Math.floor(helpers$4.log10(me.max)) - 1);
				}
				if (me.max === null) {
					me.max = me.min !== 0
						? Math.pow(10, Math.floor(helpers$4.log10(me.min)) + 1)
						: DEFAULT_MAX;
				}
				if (me.minNotZero === null) {
					if (me.min > 0) {
						me.minNotZero = me.min;
					} else if (me.max < 1) {
						me.minNotZero = Math.pow(10, Math.floor(helpers$4.log10(me.max)));
					} else {
						me.minNotZero = DEFAULT_MIN;
					}
				}
			},
			buildTicks: function() {
				var me = this;
				var opts = me.options;
				var tickOpts = opts.ticks;
				var reverse = !me.isHorizontal();

				var generationOptions = {
					min: tickOpts.min,
					max: tickOpts.max
				};
				var ticks = me.ticks = generateTicks$1(generationOptions, me);

				// At this point, we need to update our max and min given the tick values since we have expanded the
				// range of the scale
				me.max = helpers$4.max(ticks);
				me.min = helpers$4.min(ticks);

				if (tickOpts.reverse) {
					reverse = !reverse;
					me.start = me.max;
					me.end = me.min;
				} else {
					me.start = me.min;
					me.end = me.max;
				}
				if (reverse) {
					ticks.reverse();
				}
			},
			convertTicksToLabels: function() {
				this.tickValues = this.ticks.slice();

				Scale.prototype.convertTicksToLabels.call(this);
			},
			// Get the correct tooltip label
			getLabelForIndex: function(index, datasetIndex) {
				return +this.getRightValue(this.chart.data.datasets[datasetIndex].data[index]);
			},
			getPixelForTick: function(index) {
				return this.getPixelForValue(this.tickValues[index]);
			},
			/**
			 * Returns the value of the first tick.
			 * @param {Number} value - The minimum not zero value.
			 * @return {Number} The first tick value.
			 * @private
			 */
			_getFirstTickValue: function(value) {
				var exp = Math.floor(helpers$4.log10(value));
				var significand = Math.floor(value / Math.pow(10, exp));

				return significand * Math.pow(10, exp);
			},
			getPixelForValue: function(value) {
				var me = this;
				var reverse = me.options.ticks.reverse;
				var log10 = helpers$4.log10;
				var firstTickValue = me._getFirstTickValue(me.minNotZero);
				var offset = 0;
				var innerDimension, pixel, start, end, sign;

				value = +me.getRightValue(value);
				if (reverse) {
					start = me.end;
					end = me.start;
					sign = -1;
				} else {
					start = me.start;
					end = me.end;
					sign = 1;
				}
				if (me.isHorizontal()) {
					innerDimension = me.width;
					pixel = reverse ? me.right : me.left;
				} else {
					innerDimension = me.height;
					sign *= -1; // invert, since the upper-left corner of the canvas is at pixel (0, 0)
					pixel = reverse ? me.top : me.bottom;
				}
				if (value !== start) {
					if (start === 0) { // include zero tick
						offset = helpers$4.getValueOrDefault(
							me.options.ticks.fontSize,
							Chart.defaults.global.defaultFontSize
						);
						innerDimension -= offset;
						start = firstTickValue;
					}
					if (value !== 0) {
						offset += innerDimension / (log10(end) - log10(start)) * (log10(value) - log10(start));
					}
					pixel += sign * offset;
				}
				return pixel;
			},
			getValueForPixel: function(pixel) {
				var me = this;
				var reverse = me.options.ticks.reverse;
				var log10 = helpers$4.log10;
				var firstTickValue = me._getFirstTickValue(me.minNotZero);
				var innerDimension, start, end, value;

				if (reverse) {
					start = me.end;
					end = me.start;
				} else {
					start = me.start;
					end = me.end;
				}
				if (me.isHorizontal()) {
					innerDimension = me.width;
					value = reverse ? me.right - pixel : pixel - me.left;
				} else {
					innerDimension = me.height;
					value = reverse ? pixel - me.top : me.bottom - pixel;
				}
				if (value !== start) {
					if (start === 0) { // include zero tick
						var offset = helpers$4.getValueOrDefault(
							me.options.ticks.fontSize,
							Chart.defaults.global.defaultFontSize
						);
						value -= offset;
						innerDimension -= offset;
						start = firstTickValue;
					}
					value *= log10(end) - log10(start);
					value /= innerDimension;
					value = Math.pow(10, log10(start) + value);
				}
				return value;
			}
		});

		scaleService.registerScaleType('logarithmic', LogarithmicScale, defaultConfig);
	};

	var scale_logarithmic$1 = /*#__PURE__*/Object.freeze({
		default: scale_logarithmic,
		__moduleExports: scale_logarithmic
	});

	var scale_radialLinear = function(Chart) {

		var globalDefaults = defaults$3.global;

		var defaultConfig = {
			display: true,

			// Boolean - Whether to animate scaling the chart from the centre
			animate: true,
			position: 'chartArea',

			angleLines: {
				display: true,
				color: 'rgba(0, 0, 0, 0.1)',
				lineWidth: 1
			},

			gridLines: {
				circular: false
			},

			// label settings
			ticks: {
				// Boolean - Show a backdrop to the scale label
				showLabelBackdrop: true,

				// String - The colour of the label backdrop
				backdropColor: 'rgba(255,255,255,0.75)',

				// Number - The backdrop padding above & below the label in pixels
				backdropPaddingY: 2,

				// Number - The backdrop padding to the side of the label in pixels
				backdropPaddingX: 2,

				callback: Ticks.formatters.linear
			},

			pointLabels: {
				// Boolean - if true, show point labels
				display: true,

				// Number - Point label font size in pixels
				fontSize: 10,

				// Function - Used to convert point labels
				callback: function(label) {
					return label;
				}
			}
		};

		function getValueCount(scale) {
			var opts = scale.options;
			return opts.angleLines.display || opts.pointLabels.display ? scale.chart.data.labels.length : 0;
		}

		function getPointLabelFontOptions(scale) {
			var pointLabelOptions = scale.options.pointLabels;
			var fontSize = helpers$4.valueOrDefault(pointLabelOptions.fontSize, globalDefaults.defaultFontSize);
			var fontStyle = helpers$4.valueOrDefault(pointLabelOptions.fontStyle, globalDefaults.defaultFontStyle);
			var fontFamily = helpers$4.valueOrDefault(pointLabelOptions.fontFamily, globalDefaults.defaultFontFamily);
			var font = helpers$4.fontString(fontSize, fontStyle, fontFamily);

			return {
				size: fontSize,
				style: fontStyle,
				family: fontFamily,
				font: font
			};
		}

		function measureLabelSize(ctx, fontSize, label) {
			if (helpers$4.isArray(label)) {
				return {
					w: helpers$4.longestText(ctx, ctx.font, label),
					h: (label.length * fontSize) + ((label.length - 1) * 1.5 * fontSize)
				};
			}

			return {
				w: ctx.measureText(label).width,
				h: fontSize
			};
		}

		function determineLimits(angle, pos, size, min, max) {
			if (angle === min || angle === max) {
				return {
					start: pos - (size / 2),
					end: pos + (size / 2)
				};
			} else if (angle < min || angle > max) {
				return {
					start: pos - size - 5,
					end: pos
				};
			}

			return {
				start: pos,
				end: pos + size + 5
			};
		}

		/**
		 * Helper function to fit a radial linear scale with point labels
		 */
		function fitWithPointLabels(scale) {
			/*
			 * Right, this is really confusing and there is a lot of maths going on here
			 * The gist of the problem is here: https://gist.github.com/nnnick/696cc9c55f4b0beb8fe9
			 *
			 * Reaction: https://dl.dropboxusercontent.com/u/34601363/toomuchscience.gif
			 *
			 * Solution:
			 *
			 * We assume the radius of the polygon is half the size of the canvas at first
			 * at each index we check if the text overlaps.
			 *
			 * Where it does, we store that angle and that index.
			 *
			 * After finding the largest index and angle we calculate how much we need to remove
			 * from the shape radius to move the point inwards by that x.
			 *
			 * We average the left and right distances to get the maximum shape radius that can fit in the box
			 * along with labels.
			 *
			 * Once we have that, we can find the centre point for the chart, by taking the x text protrusion
			 * on each side, removing that from the size, halving it and adding the left x protrusion width.
			 *
			 * This will mean we have a shape fitted to the canvas, as large as it can be with the labels
			 * and position it in the most space efficient manner
			 *
			 * https://dl.dropboxusercontent.com/u/34601363/yeahscience.gif
			 */

			var plFont = getPointLabelFontOptions(scale);

			// Get maximum radius of the polygon. Either half the height (minus the text width) or half the width.
			// Use this to calculate the offset + change. - Make sure L/R protrusion is at least 0 to stop issues with centre points
			var largestPossibleRadius = Math.min(scale.height / 2, scale.width / 2);
			var furthestLimits = {
				r: scale.width,
				l: 0,
				t: scale.height,
				b: 0
			};
			var furthestAngles = {};
			var i, textSize, pointPosition;

			scale.ctx.font = plFont.font;
			scale._pointLabelSizes = [];

			var valueCount = getValueCount(scale);
			for (i = 0; i < valueCount; i++) {
				pointPosition = scale.getPointPosition(i, largestPossibleRadius);
				textSize = measureLabelSize(scale.ctx, plFont.size, scale.pointLabels[i] || '');
				scale._pointLabelSizes[i] = textSize;

				// Add quarter circle to make degree 0 mean top of circle
				var angleRadians = scale.getIndexAngle(i);
				var angle = helpers$4.toDegrees(angleRadians) % 360;
				var hLimits = determineLimits(angle, pointPosition.x, textSize.w, 0, 180);
				var vLimits = determineLimits(angle, pointPosition.y, textSize.h, 90, 270);

				if (hLimits.start < furthestLimits.l) {
					furthestLimits.l = hLimits.start;
					furthestAngles.l = angleRadians;
				}

				if (hLimits.end > furthestLimits.r) {
					furthestLimits.r = hLimits.end;
					furthestAngles.r = angleRadians;
				}

				if (vLimits.start < furthestLimits.t) {
					furthestLimits.t = vLimits.start;
					furthestAngles.t = angleRadians;
				}

				if (vLimits.end > furthestLimits.b) {
					furthestLimits.b = vLimits.end;
					furthestAngles.b = angleRadians;
				}
			}

			scale.setReductions(largestPossibleRadius, furthestLimits, furthestAngles);
		}

		/**
		 * Helper function to fit a radial linear scale with no point labels
		 */
		function fit(scale) {
			var largestPossibleRadius = Math.min(scale.height / 2, scale.width / 2);
			scale.drawingArea = Math.round(largestPossibleRadius);
			scale.setCenterPoint(0, 0, 0, 0);
		}

		function getTextAlignForAngle(angle) {
			if (angle === 0 || angle === 180) {
				return 'center';
			} else if (angle < 180) {
				return 'left';
			}

			return 'right';
		}

		function fillText(ctx, text, position, fontSize) {
			if (helpers$4.isArray(text)) {
				var y = position.y;
				var spacing = 1.5 * fontSize;

				for (var i = 0; i < text.length; ++i) {
					ctx.fillText(text[i], position.x, y);
					y += spacing;
				}
			} else {
				ctx.fillText(text, position.x, position.y);
			}
		}

		function adjustPointPositionForLabelHeight(angle, textSize, position) {
			if (angle === 90 || angle === 270) {
				position.y -= (textSize.h / 2);
			} else if (angle > 270 || angle < 90) {
				position.y -= textSize.h;
			}
		}

		function drawPointLabels(scale) {
			var ctx = scale.ctx;
			var opts = scale.options;
			var angleLineOpts = opts.angleLines;
			var pointLabelOpts = opts.pointLabels;

			ctx.lineWidth = angleLineOpts.lineWidth;
			ctx.strokeStyle = angleLineOpts.color;

			var outerDistance = scale.getDistanceFromCenterForValue(opts.ticks.reverse ? scale.min : scale.max);

			// Point Label Font
			var plFont = getPointLabelFontOptions(scale);

			ctx.textBaseline = 'top';

			for (var i = getValueCount(scale) - 1; i >= 0; i--) {
				if (angleLineOpts.display) {
					var outerPosition = scale.getPointPosition(i, outerDistance);
					ctx.beginPath();
					ctx.moveTo(scale.xCenter, scale.yCenter);
					ctx.lineTo(outerPosition.x, outerPosition.y);
					ctx.stroke();
					ctx.closePath();
				}

				if (pointLabelOpts.display) {
					// Extra 3px out for some label spacing
					var pointLabelPosition = scale.getPointPosition(i, outerDistance + 5);

					// Keep this in loop since we may support array properties here
					var pointLabelFontColor = helpers$4.valueAtIndexOrDefault(pointLabelOpts.fontColor, i, globalDefaults.defaultFontColor);
					ctx.font = plFont.font;
					ctx.fillStyle = pointLabelFontColor;

					var angleRadians = scale.getIndexAngle(i);
					var angle = helpers$4.toDegrees(angleRadians);
					ctx.textAlign = getTextAlignForAngle(angle);
					adjustPointPositionForLabelHeight(angle, scale._pointLabelSizes[i], pointLabelPosition);
					fillText(ctx, scale.pointLabels[i] || '', pointLabelPosition, plFont.size);
				}
			}
		}

		function drawRadiusLine(scale, gridLineOpts, radius, index) {
			var ctx = scale.ctx;
			ctx.strokeStyle = helpers$4.valueAtIndexOrDefault(gridLineOpts.color, index - 1);
			ctx.lineWidth = helpers$4.valueAtIndexOrDefault(gridLineOpts.lineWidth, index - 1);

			if (scale.options.gridLines.circular) {
				// Draw circular arcs between the points
				ctx.beginPath();
				ctx.arc(scale.xCenter, scale.yCenter, radius, 0, Math.PI * 2);
				ctx.closePath();
				ctx.stroke();
			} else {
				// Draw straight lines connecting each index
				var valueCount = getValueCount(scale);

				if (valueCount === 0) {
					return;
				}

				ctx.beginPath();
				var pointPosition = scale.getPointPosition(0, radius);
				ctx.moveTo(pointPosition.x, pointPosition.y);

				for (var i = 1; i < valueCount; i++) {
					pointPosition = scale.getPointPosition(i, radius);
					ctx.lineTo(pointPosition.x, pointPosition.y);
				}

				ctx.closePath();
				ctx.stroke();
			}
		}

		function numberOrZero(param) {
			return helpers$4.isNumber(param) ? param : 0;
		}

		var LinearRadialScale = Chart.LinearScaleBase.extend({
			setDimensions: function() {
				var me = this;
				var opts = me.options;
				var tickOpts = opts.ticks;
				// Set the unconstrained dimension before label rotation
				me.width = me.maxWidth;
				me.height = me.maxHeight;
				me.xCenter = Math.round(me.width / 2);
				me.yCenter = Math.round(me.height / 2);

				var minSize = helpers$4.min([me.height, me.width]);
				var tickFontSize = helpers$4.valueOrDefault(tickOpts.fontSize, globalDefaults.defaultFontSize);
				me.drawingArea = opts.display ? (minSize / 2) - (tickFontSize / 2 + tickOpts.backdropPaddingY) : (minSize / 2);
			},
			determineDataLimits: function() {
				var me = this;
				var chart = me.chart;
				var min = Number.POSITIVE_INFINITY;
				var max = Number.NEGATIVE_INFINITY;

				helpers$4.each(chart.data.datasets, function(dataset, datasetIndex) {
					if (chart.isDatasetVisible(datasetIndex)) {
						var meta = chart.getDatasetMeta(datasetIndex);

						helpers$4.each(dataset.data, function(rawValue, index) {
							var value = +me.getRightValue(rawValue);
							if (isNaN(value) || meta.data[index].hidden) {
								return;
							}

							min = Math.min(value, min);
							max = Math.max(value, max);
						});
					}
				});

				me.min = (min === Number.POSITIVE_INFINITY ? 0 : min);
				me.max = (max === Number.NEGATIVE_INFINITY ? 0 : max);

				// Common base implementation to handle ticks.min, ticks.max, ticks.beginAtZero
				me.handleTickRangeOptions();
			},
			getTickLimit: function() {
				var tickOpts = this.options.ticks;
				var tickFontSize = helpers$4.valueOrDefault(tickOpts.fontSize, globalDefaults.defaultFontSize);
				return Math.min(tickOpts.maxTicksLimit ? tickOpts.maxTicksLimit : 11, Math.ceil(this.drawingArea / (1.5 * tickFontSize)));
			},
			convertTicksToLabels: function() {
				var me = this;

				Chart.LinearScaleBase.prototype.convertTicksToLabels.call(me);

				// Point labels
				me.pointLabels = me.chart.data.labels.map(me.options.pointLabels.callback, me);
			},
			getLabelForIndex: function(index, datasetIndex) {
				return +this.getRightValue(this.chart.data.datasets[datasetIndex].data[index]);
			},
			fit: function() {
				if (this.options.pointLabels.display) {
					fitWithPointLabels(this);
				} else {
					fit(this);
				}
			},
			/**
			 * Set radius reductions and determine new radius and center point
			 * @private
			 */
			setReductions: function(largestPossibleRadius, furthestLimits, furthestAngles) {
				var me = this;
				var radiusReductionLeft = furthestLimits.l / Math.sin(furthestAngles.l);
				var radiusReductionRight = Math.max(furthestLimits.r - me.width, 0) / Math.sin(furthestAngles.r);
				var radiusReductionTop = -furthestLimits.t / Math.cos(furthestAngles.t);
				var radiusReductionBottom = -Math.max(furthestLimits.b - me.height, 0) / Math.cos(furthestAngles.b);

				radiusReductionLeft = numberOrZero(radiusReductionLeft);
				radiusReductionRight = numberOrZero(radiusReductionRight);
				radiusReductionTop = numberOrZero(radiusReductionTop);
				radiusReductionBottom = numberOrZero(radiusReductionBottom);

				me.drawingArea = Math.min(
					Math.round(largestPossibleRadius - (radiusReductionLeft + radiusReductionRight) / 2),
					Math.round(largestPossibleRadius - (radiusReductionTop + radiusReductionBottom) / 2));
				me.setCenterPoint(radiusReductionLeft, radiusReductionRight, radiusReductionTop, radiusReductionBottom);
			},
			setCenterPoint: function(leftMovement, rightMovement, topMovement, bottomMovement) {
				var me = this;
				var maxRight = me.width - rightMovement - me.drawingArea;
				var maxLeft = leftMovement + me.drawingArea;
				var maxTop = topMovement + me.drawingArea;
				var maxBottom = me.height - bottomMovement - me.drawingArea;

				me.xCenter = Math.round(((maxLeft + maxRight) / 2) + me.left);
				me.yCenter = Math.round(((maxTop + maxBottom) / 2) + me.top);
			},

			getIndexAngle: function(index) {
				var angleMultiplier = (Math.PI * 2) / getValueCount(this);
				var startAngle = this.chart.options && this.chart.options.startAngle ?
					this.chart.options.startAngle :
					0;

				var startAngleRadians = startAngle * Math.PI * 2 / 360;

				// Start from the top instead of right, so remove a quarter of the circle
				return index * angleMultiplier + startAngleRadians;
			},
			getDistanceFromCenterForValue: function(value) {
				var me = this;

				if (value === null) {
					return 0; // null always in center
				}

				// Take into account half font size + the yPadding of the top value
				var scalingFactor = me.drawingArea / (me.max - me.min);
				if (me.options.ticks.reverse) {
					return (me.max - value) * scalingFactor;
				}
				return (value - me.min) * scalingFactor;
			},
			getPointPosition: function(index, distanceFromCenter) {
				var me = this;
				var thisAngle = me.getIndexAngle(index) - (Math.PI / 2);
				return {
					x: Math.round(Math.cos(thisAngle) * distanceFromCenter) + me.xCenter,
					y: Math.round(Math.sin(thisAngle) * distanceFromCenter) + me.yCenter
				};
			},
			getPointPositionForValue: function(index, value) {
				return this.getPointPosition(index, this.getDistanceFromCenterForValue(value));
			},

			getBasePosition: function() {
				var me = this;
				var min = me.min;
				var max = me.max;

				return me.getPointPositionForValue(0,
					me.beginAtZero ? 0 :
					min < 0 && max < 0 ? max :
					min > 0 && max > 0 ? min :
					0);
			},

			draw: function() {
				var me = this;
				var opts = me.options;
				var gridLineOpts = opts.gridLines;
				var tickOpts = opts.ticks;
				var valueOrDefault = helpers$4.valueOrDefault;

				if (opts.display) {
					var ctx = me.ctx;
					var startAngle = this.getIndexAngle(0);

					// Tick Font
					var tickFontSize = valueOrDefault(tickOpts.fontSize, globalDefaults.defaultFontSize);
					var tickFontStyle = valueOrDefault(tickOpts.fontStyle, globalDefaults.defaultFontStyle);
					var tickFontFamily = valueOrDefault(tickOpts.fontFamily, globalDefaults.defaultFontFamily);
					var tickLabelFont = helpers$4.fontString(tickFontSize, tickFontStyle, tickFontFamily);

					helpers$4.each(me.ticks, function(label, index) {
						// Don't draw a centre value (if it is minimum)
						if (index > 0 || tickOpts.reverse) {
							var yCenterOffset = me.getDistanceFromCenterForValue(me.ticksAsNumbers[index]);

							// Draw circular lines around the scale
							if (gridLineOpts.display && index !== 0) {
								drawRadiusLine(me, gridLineOpts, yCenterOffset, index);
							}

							if (tickOpts.display) {
								var tickFontColor = valueOrDefault(tickOpts.fontColor, globalDefaults.defaultFontColor);
								ctx.font = tickLabelFont;

								ctx.save();
								ctx.translate(me.xCenter, me.yCenter);
								ctx.rotate(startAngle);

								if (tickOpts.showLabelBackdrop) {
									var labelWidth = ctx.measureText(label).width;
									ctx.fillStyle = tickOpts.backdropColor;
									ctx.fillRect(
										-labelWidth / 2 - tickOpts.backdropPaddingX,
										-yCenterOffset - tickFontSize / 2 - tickOpts.backdropPaddingY,
										labelWidth + tickOpts.backdropPaddingX * 2,
										tickFontSize + tickOpts.backdropPaddingY * 2
									);
								}

								ctx.textAlign = 'center';
								ctx.textBaseline = 'middle';
								ctx.fillStyle = tickFontColor;
								ctx.fillText(label, 0, -yCenterOffset);
								ctx.restore();
							}
						}
					});

					if (opts.angleLines.display || opts.pointLabels.display) {
						drawPointLabels(me);
					}
				}
			}
		});

		scaleService.registerScaleType('radialLinear', LinearRadialScale, defaultConfig);
	};

	var scale_radialLinear$1 = /*#__PURE__*/Object.freeze({
		default: scale_radialLinear,
		__moduleExports: scale_radialLinear
	});

	var require$$0$6 = ( moment && hooks$1 ) || moment;

	var moment$1 = require$$0$6;
	moment$1 = typeof moment$1 === 'function' ? moment$1 : window.moment;






	// Integer constants are from the ES6 spec.
	var MIN_INTEGER = Number.MIN_SAFE_INTEGER || -9007199254740991;
	var MAX_INTEGER = Number.MAX_SAFE_INTEGER || 9007199254740991;

	var INTERVALS = {
		millisecond: {
			common: true,
			size: 1,
			steps: [1, 2, 5, 10, 20, 50, 100, 250, 500]
		},
		second: {
			common: true,
			size: 1000,
			steps: [1, 2, 5, 10, 15, 30]
		},
		minute: {
			common: true,
			size: 60000,
			steps: [1, 2, 5, 10, 15, 30]
		},
		hour: {
			common: true,
			size: 3600000,
			steps: [1, 2, 3, 6, 12]
		},
		day: {
			common: true,
			size: 86400000,
			steps: [1, 2, 5]
		},
		week: {
			common: false,
			size: 604800000,
			steps: [1, 2, 3, 4]
		},
		month: {
			common: true,
			size: 2.628e9,
			steps: [1, 2, 3]
		},
		quarter: {
			common: false,
			size: 7.884e9,
			steps: [1, 2, 3, 4]
		},
		year: {
			common: true,
			size: 3.154e10
		}
	};

	var UNITS = Object.keys(INTERVALS);

	function sorter(a, b) {
		return a - b;
	}

	function arrayUnique(items) {
		var hash = {};
		var out = [];
		var i, ilen, item;

		for (i = 0, ilen = items.length; i < ilen; ++i) {
			item = items[i];
			if (!hash[item]) {
				hash[item] = true;
				out.push(item);
			}
		}

		return out;
	}

	/**
	 * Returns an array of {time, pos} objects used to interpolate a specific `time` or position
	 * (`pos`) on the scale, by searching entries before and after the requested value. `pos` is
	 * a decimal between 0 and 1: 0 being the start of the scale (left or top) and 1 the other
	 * extremity (left + width or top + height). Note that it would be more optimized to directly
	 * store pre-computed pixels, but the scale dimensions are not guaranteed at the time we need
	 * to create the lookup table. The table ALWAYS contains at least two items: min and max.
	 *
	 * @param {Number[]} timestamps - timestamps sorted from lowest to highest.
	 * @param {String} distribution - If 'linear', timestamps will be spread linearly along the min
	 * and max range, so basically, the table will contains only two items: {min, 0} and {max, 1}.
	 * If 'series', timestamps will be positioned at the same distance from each other. In this
	 * case, only timestamps that break the time linearity are registered, meaning that in the
	 * best case, all timestamps are linear, the table contains only min and max.
	 */
	function buildLookupTable(timestamps, min, max, distribution) {
		if (distribution === 'linear' || !timestamps.length) {
			return [
				{time: min, pos: 0},
				{time: max, pos: 1}
			];
		}

		var table = [];
		var items = [min];
		var i, ilen, prev, curr, next;

		for (i = 0, ilen = timestamps.length; i < ilen; ++i) {
			curr = timestamps[i];
			if (curr > min && curr < max) {
				items.push(curr);
			}
		}

		items.push(max);

		for (i = 0, ilen = items.length; i < ilen; ++i) {
			next = items[i + 1];
			prev = items[i - 1];
			curr = items[i];

			// only add points that breaks the scale linearity
			if (prev === undefined || next === undefined || Math.round((next + prev) / 2) !== curr) {
				table.push({time: curr, pos: i / (ilen - 1)});
			}
		}

		return table;
	}

	// @see adapted from http://www.anujgakhar.com/2014/03/01/binary-search-in-javascript/
	function lookup(table, key, value) {
		var lo = 0;
		var hi = table.length - 1;
		var mid, i0, i1;

		while (lo >= 0 && lo <= hi) {
			mid = (lo + hi) >> 1;
			i0 = table[mid - 1] || null;
			i1 = table[mid];

			if (!i0) {
				// given value is outside table (before first item)
				return {lo: null, hi: i1};
			} else if (i1[key] < value) {
				lo = mid + 1;
			} else if (i0[key] > value) {
				hi = mid - 1;
			} else {
				return {lo: i0, hi: i1};
			}
		}

		// given value is outside table (after last item)
		return {lo: i1, hi: null};
	}

	/**
	 * Linearly interpolates the given source `value` using the table items `skey` values and
	 * returns the associated `tkey` value. For example, interpolate(table, 'time', 42, 'pos')
	 * returns the position for a timestamp equal to 42. If value is out of bounds, values at
	 * index [0, 1] or [n - 1, n] are used for the interpolation.
	 */
	function interpolate$1(table, skey, sval, tkey) {
		var range = lookup(table, skey, sval);

		// Note: the lookup table ALWAYS contains at least 2 items (min and max)
		var prev = !range.lo ? table[0] : !range.hi ? table[table.length - 2] : range.lo;
		var next = !range.lo ? table[1] : !range.hi ? table[table.length - 1] : range.hi;

		var span = next[skey] - prev[skey];
		var ratio = span ? (sval - prev[skey]) / span : 0;
		var offset = (next[tkey] - prev[tkey]) * ratio;

		return prev[tkey] + offset;
	}

	/**
	 * Convert the given value to a moment object using the given time options.
	 * @see http://momentjs.com/docs/#/parsing/
	 */
	function momentify(value, options) {
		var parser = options.parser;
		var format = options.parser || options.format;

		if (typeof parser === 'function') {
			return parser(value);
		}

		if (typeof value === 'string' && typeof format === 'string') {
			return moment$1(value, format);
		}

		if (!(value instanceof moment$1)) {
			value = moment$1(value);
		}

		if (value.isValid()) {
			return value;
		}

		// Labels are in an incompatible moment format and no `parser` has been provided.
		// The user might still use the deprecated `format` option to convert his inputs.
		if (typeof format === 'function') {
			return format(value);
		}

		return value;
	}

	function parse$2(input, scale) {
		if (helpers$4.isNullOrUndef(input)) {
			return null;
		}

		var options = scale.options.time;
		var value = momentify(scale.getRightValue(input), options);
		if (!value.isValid()) {
			return null;
		}

		if (options.round) {
			value.startOf(options.round);
		}

		return value.valueOf();
	}

	/**
	 * Returns the number of unit to skip to be able to display up to `capacity` number of ticks
	 * in `unit` for the given `min` / `max` range and respecting the interval steps constraints.
	 */
	function determineStepSize(min, max, unit, capacity) {
		var range = max - min;
		var interval = INTERVALS[unit];
		var milliseconds = interval.size;
		var steps = interval.steps;
		var i, ilen, factor;

		if (!steps) {
			return Math.ceil(range / (capacity * milliseconds));
		}

		for (i = 0, ilen = steps.length; i < ilen; ++i) {
			factor = steps[i];
			if (Math.ceil(range / (milliseconds * factor)) <= capacity) {
				break;
			}
		}

		return factor;
	}

	/**
	 * Figures out what unit results in an appropriate number of auto-generated ticks
	 */
	function determineUnitForAutoTicks(minUnit, min, max, capacity) {
		var ilen = UNITS.length;
		var i, interval, factor;

		for (i = UNITS.indexOf(minUnit); i < ilen - 1; ++i) {
			interval = INTERVALS[UNITS[i]];
			factor = interval.steps ? interval.steps[interval.steps.length - 1] : MAX_INTEGER;

			if (interval.common && Math.ceil((max - min) / (factor * interval.size)) <= capacity) {
				return UNITS[i];
			}
		}

		return UNITS[ilen - 1];
	}

	/**
	 * Figures out what unit to format a set of ticks with
	 */
	function determineUnitForFormatting(ticks, minUnit, min, max) {
		var duration = moment$1.duration(moment$1(max).diff(moment$1(min)));
		var ilen = UNITS.length;
		var i, unit;

		for (i = ilen - 1; i >= UNITS.indexOf(minUnit); i--) {
			unit = UNITS[i];
			if (INTERVALS[unit].common && duration.as(unit) >= ticks.length) {
				return unit;
			}
		}

		return UNITS[minUnit ? UNITS.indexOf(minUnit) : 0];
	}

	function determineMajorUnit(unit) {
		for (var i = UNITS.indexOf(unit) + 1, ilen = UNITS.length; i < ilen; ++i) {
			if (INTERVALS[UNITS[i]].common) {
				return UNITS[i];
			}
		}
	}

	/**
	 * Generates a maximum of `capacity` timestamps between min and max, rounded to the
	 * `minor` unit, aligned on the `major` unit and using the given scale time `options`.
	 * Important: this method can return ticks outside the min and max range, it's the
	 * responsibility of the calling code to clamp values if needed.
	 */
	function generate(min, max, capacity, options) {
		var timeOpts = options.time;
		var minor = timeOpts.unit || determineUnitForAutoTicks(timeOpts.minUnit, min, max, capacity);
		var major = determineMajorUnit(minor);
		var stepSize = helpers$4.valueOrDefault(timeOpts.stepSize, timeOpts.unitStepSize);
		var weekday = minor === 'week' ? timeOpts.isoWeekday : false;
		var majorTicksEnabled = options.ticks.major.enabled;
		var interval = INTERVALS[minor];
		var first = moment$1(min);
		var last = moment$1(max);
		var ticks = [];
		var time;

		if (!stepSize) {
			stepSize = determineStepSize(min, max, minor, capacity);
		}

		// For 'week' unit, handle the first day of week option
		if (weekday) {
			first = first.isoWeekday(weekday);
			last = last.isoWeekday(weekday);
		}

		// Align first/last ticks on unit
		first = first.startOf(weekday ? 'day' : minor);
		last = last.startOf(weekday ? 'day' : minor);

		// Make sure that the last tick include max
		if (last < max) {
			last.add(1, minor);
		}

		time = moment$1(first);

		if (majorTicksEnabled && major && !weekday && !timeOpts.round) {
			// Align the first tick on the previous `minor` unit aligned on the `major` unit:
			// we first aligned time on the previous `major` unit then add the number of full
			// stepSize there is between first and the previous major time.
			time.startOf(major);
			time.add(~~((first - time) / (interval.size * stepSize)) * stepSize, minor);
		}

		for (; time < last; time.add(stepSize, minor)) {
			ticks.push(+time);
		}

		ticks.push(+time);

		return ticks;
	}

	/**
	 * Returns the right and left offsets from edges in the form of {left, right}.
	 * Offsets are added when the `offset` option is true.
	 */
	function computeOffsets(table, ticks, min, max, options) {
		var left = 0;
		var right = 0;
		var upper, lower;

		if (options.offset && ticks.length) {
			if (!options.time.min) {
				upper = ticks.length > 1 ? ticks[1] : max;
				lower = ticks[0];
				left = (
					interpolate$1(table, 'time', upper, 'pos') -
					interpolate$1(table, 'time', lower, 'pos')
				) / 2;
			}
			if (!options.time.max) {
				upper = ticks[ticks.length - 1];
				lower = ticks.length > 1 ? ticks[ticks.length - 2] : min;
				right = (
					interpolate$1(table, 'time', upper, 'pos') -
					interpolate$1(table, 'time', lower, 'pos')
				) / 2;
			}
		}

		return {left: left, right: right};
	}

	function ticksFromTimestamps(values, majorUnit) {
		var ticks = [];
		var i, ilen, value, major;

		for (i = 0, ilen = values.length; i < ilen; ++i) {
			value = values[i];
			major = majorUnit ? value === +moment$1(value).startOf(majorUnit) : false;

			ticks.push({
				value: value,
				major: major
			});
		}

		return ticks;
	}

	function determineLabelFormat(data, timeOpts) {
		var i, momentDate, hasTime;
		var ilen = data.length;

		// find the label with the most parts (milliseconds, minutes, etc.)
		// format all labels with the same level of detail as the most specific label
		for (i = 0; i < ilen; i++) {
			momentDate = momentify(data[i], timeOpts);
			if (momentDate.millisecond() !== 0) {
				return 'MMM D, YYYY h:mm:ss.SSS a';
			}
			if (momentDate.second() !== 0 || momentDate.minute() !== 0 || momentDate.hour() !== 0) {
				hasTime = true;
			}
		}
		if (hasTime) {
			return 'MMM D, YYYY h:mm:ss a';
		}
		return 'MMM D, YYYY';
	}

	var scale_time = function() {

		var defaultConfig = {
			position: 'bottom',

			/**
			 * Data distribution along the scale:
			 * - 'linear': data are spread according to their time (distances can vary),
			 * - 'series': data are spread at the same distance from each other.
			 * @see https://github.com/chartjs/Chart.js/pull/4507
			 * @since 2.7.0
			 */
			distribution: 'linear',

			/**
			 * Scale boundary strategy (bypassed by min/max time options)
			 * - `data`: make sure data are fully visible, ticks outside are removed
			 * - `ticks`: make sure ticks are fully visible, data outside are truncated
			 * @see https://github.com/chartjs/Chart.js/pull/4556
			 * @since 2.7.0
			 */
			bounds: 'data',

			time: {
				parser: false, // false == a pattern string from http://momentjs.com/docs/#/parsing/string-format/ or a custom callback that converts its argument to a moment
				format: false, // DEPRECATED false == date objects, moment object, callback or a pattern string from http://momentjs.com/docs/#/parsing/string-format/
				unit: false, // false == automatic or override with week, month, year, etc.
				round: false, // none, or override with week, month, year, etc.
				displayFormat: false, // DEPRECATED
				isoWeekday: false, // override week start day - see http://momentjs.com/docs/#/get-set/iso-weekday/
				minUnit: 'millisecond',

				// defaults to unit's corresponding unitFormat below or override using pattern string from http://momentjs.com/docs/#/displaying/format/
				displayFormats: {
					millisecond: 'h:mm:ss.SSS a', // 11:20:01.123 AM,
					second: 'h:mm:ss a', // 11:20:01 AM
					minute: 'h:mm a', // 11:20 AM
					hour: 'hA', // 5PM
					day: 'MMM D', // Sep 4
					week: 'll', // Week 46, or maybe "[W]WW - YYYY" ?
					month: 'MMM YYYY', // Sept 2015
					quarter: '[Q]Q - YYYY', // Q3
					year: 'YYYY' // 2015
				},
			},
			ticks: {
				autoSkip: false,

				/**
				 * Ticks generation input values:
				 * - 'auto': generates "optimal" ticks based on scale size and time options.
				 * - 'data': generates ticks from data (including labels from data {t|x|y} objects).
				 * - 'labels': generates ticks from user given `data.labels` values ONLY.
				 * @see https://github.com/chartjs/Chart.js/pull/4507
				 * @since 2.7.0
				 */
				source: 'auto',

				major: {
					enabled: false
				}
			}
		};

		var TimeScale = Scale.extend({
			initialize: function() {
				if (!moment$1) {
					throw new Error('Chart.js - Moment.js could not be found! You must include it before Chart.js to use the time scale. Download at https://momentjs.com');
				}

				this.mergeTicksOptions();

				Scale.prototype.initialize.call(this);
			},

			update: function() {
				var me = this;
				var options = me.options;

				// DEPRECATIONS: output a message only one time per update
				if (options.time && options.time.format) {
					console.warn('options.time.format is deprecated and replaced by options.time.parser.');
				}

				return Scale.prototype.update.apply(me, arguments);
			},

			/**
			 * Allows data to be referenced via 't' attribute
			 */
			getRightValue: function(rawValue) {
				if (rawValue && rawValue.t !== undefined) {
					rawValue = rawValue.t;
				}
				return Scale.prototype.getRightValue.call(this, rawValue);
			},

			determineDataLimits: function() {
				var me = this;
				var chart = me.chart;
				var timeOpts = me.options.time;
				var unit = timeOpts.unit || 'day';
				var min = MAX_INTEGER;
				var max = MIN_INTEGER;
				var timestamps = [];
				var datasets = [];
				var labels = [];
				var i, j, ilen, jlen, data, timestamp;

				// Convert labels to timestamps
				for (i = 0, ilen = chart.data.labels.length; i < ilen; ++i) {
					labels.push(parse$2(chart.data.labels[i], me));
				}

				// Convert data to timestamps
				for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
					if (chart.isDatasetVisible(i)) {
						data = chart.data.datasets[i].data;

						// Let's consider that all data have the same format.
						if (helpers$4.isObject(data[0])) {
							datasets[i] = [];

							for (j = 0, jlen = data.length; j < jlen; ++j) {
								timestamp = parse$2(data[j], me);
								timestamps.push(timestamp);
								datasets[i][j] = timestamp;
							}
						} else {
							timestamps.push.apply(timestamps, labels);
							datasets[i] = labels.slice(0);
						}
					} else {
						datasets[i] = [];
					}
				}

				if (labels.length) {
					// Sort labels **after** data have been converted
					labels = arrayUnique(labels).sort(sorter);
					min = Math.min(min, labels[0]);
					max = Math.max(max, labels[labels.length - 1]);
				}

				if (timestamps.length) {
					timestamps = arrayUnique(timestamps).sort(sorter);
					min = Math.min(min, timestamps[0]);
					max = Math.max(max, timestamps[timestamps.length - 1]);
				}

				min = parse$2(timeOpts.min, me) || min;
				max = parse$2(timeOpts.max, me) || max;

				// In case there is no valid min/max, set limits based on unit time option
				min = min === MAX_INTEGER ? +moment$1().startOf(unit) : min;
				max = max === MIN_INTEGER ? +moment$1().endOf(unit) + 1 : max;

				// Make sure that max is strictly higher than min (required by the lookup table)
				me.min = Math.min(min, max);
				me.max = Math.max(min + 1, max);

				// PRIVATE
				me._horizontal = me.isHorizontal();
				me._table = [];
				me._timestamps = {
					data: timestamps,
					datasets: datasets,
					labels: labels
				};
			},

			buildTicks: function() {
				var me = this;
				var min = me.min;
				var max = me.max;
				var options = me.options;
				var timeOpts = options.time;
				var timestamps = [];
				var ticks = [];
				var i, ilen, timestamp;

				switch (options.ticks.source) {
				case 'data':
					timestamps = me._timestamps.data;
					break;
				case 'labels':
					timestamps = me._timestamps.labels;
					break;
				case 'auto':
				default:
					timestamps = generate(min, max, me.getLabelCapacity(min), options);
				}

				if (options.bounds === 'ticks' && timestamps.length) {
					min = timestamps[0];
					max = timestamps[timestamps.length - 1];
				}

				// Enforce limits with user min/max options
				min = parse$2(timeOpts.min, me) || min;
				max = parse$2(timeOpts.max, me) || max;

				// Remove ticks outside the min/max range
				for (i = 0, ilen = timestamps.length; i < ilen; ++i) {
					timestamp = timestamps[i];
					if (timestamp >= min && timestamp <= max) {
						ticks.push(timestamp);
					}
				}

				me.min = min;
				me.max = max;

				// PRIVATE
				me._unit = timeOpts.unit || determineUnitForFormatting(ticks, timeOpts.minUnit, me.min, me.max);
				me._majorUnit = determineMajorUnit(me._unit);
				me._table = buildLookupTable(me._timestamps.data, min, max, options.distribution);
				me._offsets = computeOffsets(me._table, ticks, min, max, options);
				me._labelFormat = determineLabelFormat(me._timestamps.data, timeOpts);

				return ticksFromTimestamps(ticks, me._majorUnit);
			},

			getLabelForIndex: function(index, datasetIndex) {
				var me = this;
				var data = me.chart.data;
				var timeOpts = me.options.time;
				var label = data.labels && index < data.labels.length ? data.labels[index] : '';
				var value = data.datasets[datasetIndex].data[index];

				if (helpers$4.isObject(value)) {
					label = me.getRightValue(value);
				}
				if (timeOpts.tooltipFormat) {
					return momentify(label, timeOpts).format(timeOpts.tooltipFormat);
				}
				if (typeof label === 'string') {
					return label;
				}

				return momentify(label, timeOpts).format(me._labelFormat);
			},

			/**
			 * Function to format an individual tick mark
			 * @private
			 */
			tickFormatFunction: function(tick, index, ticks, formatOverride) {
				var me = this;
				var options = me.options;
				var time = tick.valueOf();
				var formats = options.time.displayFormats;
				var minorFormat = formats[me._unit];
				var majorUnit = me._majorUnit;
				var majorFormat = formats[majorUnit];
				var majorTime = tick.clone().startOf(majorUnit).valueOf();
				var majorTickOpts = options.ticks.major;
				var major = majorTickOpts.enabled && majorUnit && majorFormat && time === majorTime;
				var label = tick.format(formatOverride ? formatOverride : major ? majorFormat : minorFormat);
				var tickOpts = major ? majorTickOpts : options.ticks.minor;
				var formatter = helpers$4.valueOrDefault(tickOpts.callback, tickOpts.userCallback);

				return formatter ? formatter(label, index, ticks) : label;
			},

			convertTicksToLabels: function(ticks) {
				var this$1 = this;

				var labels = [];
				var i, ilen;

				for (i = 0, ilen = ticks.length; i < ilen; ++i) {
					labels.push(this$1.tickFormatFunction(moment$1(ticks[i].value), i, ticks));
				}

				return labels;
			},

			/**
			 * @private
			 */
			getPixelForOffset: function(time) {
				var me = this;
				var size = me._horizontal ? me.width : me.height;
				var start = me._horizontal ? me.left : me.top;
				var pos = interpolate$1(me._table, 'time', time, 'pos');

				return start + size * (me._offsets.left + pos) / (me._offsets.left + 1 + me._offsets.right);
			},

			getPixelForValue: function(value, index, datasetIndex) {
				var me = this;
				var time = null;

				if (index !== undefined && datasetIndex !== undefined) {
					time = me._timestamps.datasets[datasetIndex][index];
				}

				if (time === null) {
					time = parse$2(value, me);
				}

				if (time !== null) {
					return me.getPixelForOffset(time);
				}
			},

			getPixelForTick: function(index) {
				var ticks = this.getTicks();
				return index >= 0 && index < ticks.length ?
					this.getPixelForOffset(ticks[index].value) :
					null;
			},

			getValueForPixel: function(pixel) {
				var me = this;
				var size = me._horizontal ? me.width : me.height;
				var start = me._horizontal ? me.left : me.top;
				var pos = (size ? (pixel - start) / size : 0) * (me._offsets.left + 1 + me._offsets.left) - me._offsets.right;
				var time = interpolate$1(me._table, 'pos', pos, 'time');

				return moment$1(time);
			},

			/**
			 * Crude approximation of what the label width might be
			 * @private
			 */
			getLabelWidth: function(label) {
				var me = this;
				var ticksOpts = me.options.ticks;
				var tickLabelWidth = me.ctx.measureText(label).width;
				var angle = helpers$4.toRadians(ticksOpts.maxRotation);
				var cosRotation = Math.cos(angle);
				var sinRotation = Math.sin(angle);
				var tickFontSize = helpers$4.valueOrDefault(ticksOpts.fontSize, defaults$3.global.defaultFontSize);

				return (tickLabelWidth * cosRotation) + (tickFontSize * sinRotation);
			},

			/**
			 * @private
			 */
			getLabelCapacity: function(exampleTime) {
				var me = this;

				var formatOverride = me.options.time.displayFormats.millisecond;	// Pick the longest format for guestimation

				var exampleLabel = me.tickFormatFunction(moment$1(exampleTime), 0, [], formatOverride);
				var tickLabelWidth = me.getLabelWidth(exampleLabel);
				var innerWidth = me.isHorizontal() ? me.width : me.height;

				var capacity = Math.floor(innerWidth / tickLabelWidth);
				return capacity > 0 ? capacity : 1;
			}
		});

		scaleService.registerScaleType('time', TimeScale, defaultConfig);
	};

	var scale_time$1 = /*#__PURE__*/Object.freeze({
		default: scale_time,
		__moduleExports: scale_time
	});

	var elements$2 = ( elements$1 && elements ) || elements$1;

	defaults$3._set('bar', {
		hover: {
			mode: 'label'
		},

		scales: {
			xAxes: [{
				type: 'category',

				// Specific to Bar Controller
				categoryPercentage: 0.8,
				barPercentage: 0.9,

				// offset settings
				offset: true,

				// grid line settings
				gridLines: {
					offsetGridLines: true
				}
			}],

			yAxes: [{
				type: 'linear'
			}]
		}
	});

	defaults$3._set('horizontalBar', {
		hover: {
			mode: 'index',
			axis: 'y'
		},

		scales: {
			xAxes: [{
				type: 'linear',
				position: 'bottom'
			}],

			yAxes: [{
				position: 'left',
				type: 'category',

				// Specific to Horizontal Bar Controller
				categoryPercentage: 0.8,
				barPercentage: 0.9,

				// offset settings
				offset: true,

				// grid line settings
				gridLines: {
					offsetGridLines: true
				}
			}]
		},

		elements: {
			rectangle: {
				borderSkipped: 'left'
			}
		},

		tooltips: {
			callbacks: {
				title: function(item, data) {
					// Pick first xLabel for now
					var title = '';

					if (item.length > 0) {
						if (item[0].yLabel) {
							title = item[0].yLabel;
						} else if (data.labels.length > 0 && item[0].index < data.labels.length) {
							title = data.labels[item[0].index];
						}
					}

					return title;
				},

				label: function(item, data) {
					var datasetLabel = data.datasets[item.datasetIndex].label || '';
					return datasetLabel + ': ' + item.xLabel;
				}
			},
			mode: 'index',
			axis: 'y'
		}
	});

	/**
	 * Computes the "optimal" sample size to maintain bars equally sized while preventing overlap.
	 * @private
	 */
	function computeMinSampleSize(scale, pixels) {
		var min = scale.isHorizontal() ? scale.width : scale.height;
		var ticks = scale.getTicks();
		var prev, curr, i, ilen;

		for (i = 1, ilen = pixels.length; i < ilen; ++i) {
			min = Math.min(min, pixels[i] - pixels[i - 1]);
		}

		for (i = 0, ilen = ticks.length; i < ilen; ++i) {
			curr = scale.getPixelForTick(i);
			min = i > 0 ? Math.min(min, curr - prev) : min;
			prev = curr;
		}

		return min;
	}

	/**
	 * Computes an "ideal" category based on the absolute bar thickness or, if undefined or null,
	 * uses the smallest interval (see computeMinSampleSize) that prevents bar overlapping. This
	 * mode currently always generates bars equally sized (until we introduce scriptable options?).
	 * @private
	 */
	function computeFitCategoryTraits(index, ruler, options) {
		var thickness = options.barThickness;
		var count = ruler.stackCount;
		var curr = ruler.pixels[index];
		var size, ratio;

		if (helpers$4.isNullOrUndef(thickness)) {
			size = ruler.min * options.categoryPercentage;
			ratio = options.barPercentage;
		} else {
			// When bar thickness is enforced, category and bar percentages are ignored.
			// Note(SB): we could add support for relative bar thickness (e.g. barThickness: '50%')
			// and deprecate barPercentage since this value is ignored when thickness is absolute.
			size = thickness * count;
			ratio = 1;
		}

		return {
			chunk: size / count,
			ratio: ratio,
			start: curr - (size / 2)
		};
	}

	/**
	 * Computes an "optimal" category that globally arranges bars side by side (no gap when
	 * percentage options are 1), based on the previous and following categories. This mode
	 * generates bars with different widths when data are not evenly spaced.
	 * @private
	 */
	function computeFlexCategoryTraits(index, ruler, options) {
		var pixels = ruler.pixels;
		var curr = pixels[index];
		var prev = index > 0 ? pixels[index - 1] : null;
		var next = index < pixels.length - 1 ? pixels[index + 1] : null;
		var percent = options.categoryPercentage;
		var start, size;

		if (prev === null) {
			// first data: its size is double based on the next point or,
			// if it's also the last data, we use the scale end extremity.
			prev = curr - (next === null ? ruler.end - curr : next - curr);
		}

		if (next === null) {
			// last data: its size is also double based on the previous point.
			next = curr + curr - prev;
		}

		start = curr - ((curr - prev) / 2) * percent;
		size = ((next - prev) / 2) * percent;

		return {
			chunk: size / ruler.stackCount,
			ratio: options.barPercentage,
			start: start
		};
	}

	var controller_bar = function(Chart) {

		Chart.controllers.bar = Chart.DatasetController.extend({

			dataElementType: elements$2.Rectangle,

			initialize: function() {
				var me = this;
				var meta;

				Chart.DatasetController.prototype.initialize.apply(me, arguments);

				meta = me.getMeta();
				meta.stack = me.getDataset().stack;
				meta.bar = true;
			},

			update: function(reset) {
				var me = this;
				var rects = me.getMeta().data;
				var i, ilen;

				me._ruler = me.getRuler();

				for (i = 0, ilen = rects.length; i < ilen; ++i) {
					me.updateElement(rects[i], i, reset);
				}
			},

			updateElement: function(rectangle, index, reset) {
				var me = this;
				var chart = me.chart;
				var meta = me.getMeta();
				var dataset = me.getDataset();
				var custom = rectangle.custom || {};
				var rectangleOptions = chart.options.elements.rectangle;

				rectangle._xScale = me.getScaleForId(meta.xAxisID);
				rectangle._yScale = me.getScaleForId(meta.yAxisID);
				rectangle._datasetIndex = me.index;
				rectangle._index = index;

				rectangle._model = {
					datasetLabel: dataset.label,
					label: chart.data.labels[index],
					borderSkipped: custom.borderSkipped ? custom.borderSkipped : rectangleOptions.borderSkipped,
					backgroundColor: custom.backgroundColor ? custom.backgroundColor : helpers$4.valueAtIndexOrDefault(dataset.backgroundColor, index, rectangleOptions.backgroundColor),
					borderColor: custom.borderColor ? custom.borderColor : helpers$4.valueAtIndexOrDefault(dataset.borderColor, index, rectangleOptions.borderColor),
					borderWidth: custom.borderWidth ? custom.borderWidth : helpers$4.valueAtIndexOrDefault(dataset.borderWidth, index, rectangleOptions.borderWidth)
				};

				me.updateElementGeometry(rectangle, index, reset);

				rectangle.pivot();
			},

			/**
			 * @private
			 */
			updateElementGeometry: function(rectangle, index, reset) {
				var me = this;
				var model = rectangle._model;
				var vscale = me.getValueScale();
				var base = vscale.getBasePixel();
				var horizontal = vscale.isHorizontal();
				var ruler = me._ruler || me.getRuler();
				var vpixels = me.calculateBarValuePixels(me.index, index);
				var ipixels = me.calculateBarIndexPixels(me.index, index, ruler);

				model.horizontal = horizontal;
				model.base = reset ? base : vpixels.base;
				model.x = horizontal ? reset ? base : vpixels.head : ipixels.center;
				model.y = horizontal ? ipixels.center : reset ? base : vpixels.head;
				model.height = horizontal ? ipixels.size : undefined;
				model.width = horizontal ? undefined : ipixels.size;
			},

			/**
			 * @private
			 */
			getValueScaleId: function() {
				return this.getMeta().yAxisID;
			},

			/**
			 * @private
			 */
			getIndexScaleId: function() {
				return this.getMeta().xAxisID;
			},

			/**
			 * @private
			 */
			getValueScale: function() {
				return this.getScaleForId(this.getValueScaleId());
			},

			/**
			 * @private
			 */
			getIndexScale: function() {
				return this.getScaleForId(this.getIndexScaleId());
			},

			/**
			 * Returns the stacks based on groups and bar visibility.
			 * @param {Number} [last] - The dataset index
			 * @returns {Array} The stack list
			 * @private
			 */
			_getStacks: function(last) {
				var me = this;
				var chart = me.chart;
				var scale = me.getIndexScale();
				var stacked = scale.options.stacked;
				var ilen = last === undefined ? chart.data.datasets.length : last + 1;
				var stacks = [];
				var i, meta;

				for (i = 0; i < ilen; ++i) {
					meta = chart.getDatasetMeta(i);
					if (meta.bar && chart.isDatasetVisible(i) &&
						(stacked === false ||
						(stacked === true && stacks.indexOf(meta.stack) === -1) ||
						(stacked === undefined && (meta.stack === undefined || stacks.indexOf(meta.stack) === -1)))) {
						stacks.push(meta.stack);
					}
				}

				return stacks;
			},

			/**
			 * Returns the effective number of stacks based on groups and bar visibility.
			 * @private
			 */
			getStackCount: function() {
				return this._getStacks().length;
			},

			/**
			 * Returns the stack index for the given dataset based on groups and bar visibility.
			 * @param {Number} [datasetIndex] - The dataset index
			 * @param {String} [name] - The stack name to find
			 * @returns {Number} The stack index
			 * @private
			 */
			getStackIndex: function(datasetIndex, name) {
				var stacks = this._getStacks(datasetIndex);
				var index = (name !== undefined)
					? stacks.indexOf(name)
					: -1; // indexOf returns -1 if element is not present

				return (index === -1)
					? stacks.length - 1
					: index;
			},

			/**
			 * @private
			 */
			getRuler: function() {
				var me = this;
				var scale = me.getIndexScale();
				var stackCount = me.getStackCount();
				var datasetIndex = me.index;
				var isHorizontal = scale.isHorizontal();
				var start = isHorizontal ? scale.left : scale.top;
				var end = start + (isHorizontal ? scale.width : scale.height);
				var pixels = [];
				var i, ilen, min;

				for (i = 0, ilen = me.getMeta().data.length; i < ilen; ++i) {
					pixels.push(scale.getPixelForValue(null, i, datasetIndex));
				}

				min = helpers$4.isNullOrUndef(scale.options.barThickness)
					? computeMinSampleSize(scale, pixels)
					: -1;

				return {
					min: min,
					pixels: pixels,
					start: start,
					end: end,
					stackCount: stackCount,
					scale: scale
				};
			},

			/**
			 * Note: pixel values are not clamped to the scale area.
			 * @private
			 */
			calculateBarValuePixels: function(datasetIndex, index) {
				var me = this;
				var chart = me.chart;
				var meta = me.getMeta();
				var scale = me.getValueScale();
				var datasets = chart.data.datasets;
				var value = scale.getRightValue(datasets[datasetIndex].data[index]);
				var stacked = scale.options.stacked;
				var stack = meta.stack;
				var start = 0;
				var i, imeta, ivalue, base, head, size;

				if (stacked || (stacked === undefined && stack !== undefined)) {
					for (i = 0; i < datasetIndex; ++i) {
						imeta = chart.getDatasetMeta(i);

						if (imeta.bar &&
							imeta.stack === stack &&
							imeta.controller.getValueScaleId() === scale.id &&
							chart.isDatasetVisible(i)) {

							ivalue = scale.getRightValue(datasets[i].data[index]);
							if ((value < 0 && ivalue < 0) || (value >= 0 && ivalue > 0)) {
								start += ivalue;
							}
						}
					}
				}

				base = scale.getPixelForValue(start);
				head = scale.getPixelForValue(start + value);
				size = (head - base) / 2;

				return {
					size: size,
					base: base,
					head: head,
					center: head + size / 2
				};
			},

			/**
			 * @private
			 */
			calculateBarIndexPixels: function(datasetIndex, index, ruler) {
				var me = this;
				var options = ruler.scale.options;
				var range = options.barThickness === 'flex'
					? computeFlexCategoryTraits(index, ruler, options)
					: computeFitCategoryTraits(index, ruler, options);

				var stackIndex = me.getStackIndex(datasetIndex, me.getMeta().stack);
				var center = range.start + (range.chunk * stackIndex) + (range.chunk / 2);
				var size = Math.min(
					helpers$4.valueOrDefault(options.maxBarThickness, Infinity),
					range.chunk * range.ratio);

				return {
					base: center - size / 2,
					head: center + size / 2,
					center: center,
					size: size
				};
			},

			draw: function() {
				var me = this;
				var chart = me.chart;
				var scale = me.getValueScale();
				var rects = me.getMeta().data;
				var dataset = me.getDataset();
				var ilen = rects.length;
				var i = 0;

				helpers$4.canvas.clipArea(chart.ctx, chart.chartArea);

				for (; i < ilen; ++i) {
					if (!isNaN(scale.getRightValue(dataset.data[i]))) {
						rects[i].draw();
					}
				}

				helpers$4.canvas.unclipArea(chart.ctx);
			},
		});

		Chart.controllers.horizontalBar = Chart.controllers.bar.extend({
			/**
			 * @private
			 */
			getValueScaleId: function() {
				return this.getMeta().xAxisID;
			},

			/**
			 * @private
			 */
			getIndexScaleId: function() {
				return this.getMeta().yAxisID;
			}
		});
	};

	var controller_bar$1 = /*#__PURE__*/Object.freeze({
		default: controller_bar,
		__moduleExports: controller_bar
	});

	defaults$3._set('bubble', {
		hover: {
			mode: 'single'
		},

		scales: {
			xAxes: [{
				type: 'linear', // bubble should probably use a linear scale by default
				position: 'bottom',
				id: 'x-axis-0' // need an ID so datasets can reference the scale
			}],
			yAxes: [{
				type: 'linear',
				position: 'left',
				id: 'y-axis-0'
			}]
		},

		tooltips: {
			callbacks: {
				title: function() {
					// Title doesn't make sense for scatter since we format the data as a point
					return '';
				},
				label: function(item, data) {
					var datasetLabel = data.datasets[item.datasetIndex].label || '';
					var dataPoint = data.datasets[item.datasetIndex].data[item.index];
					return datasetLabel + ': (' + item.xLabel + ', ' + item.yLabel + ', ' + dataPoint.r + ')';
				}
			}
		}
	});


	var controller_bubble = function(Chart) {

		Chart.controllers.bubble = Chart.DatasetController.extend({
			/**
			 * @protected
			 */
			dataElementType: elements$2.Point,

			/**
			 * @protected
			 */
			update: function(reset) {
				var me = this;
				var meta = me.getMeta();
				var points = meta.data;

				// Update Points
				helpers$4.each(points, function(point, index) {
					me.updateElement(point, index, reset);
				});
			},

			/**
			 * @protected
			 */
			updateElement: function(point, index, reset) {
				var me = this;
				var meta = me.getMeta();
				var custom = point.custom || {};
				var xScale = me.getScaleForId(meta.xAxisID);
				var yScale = me.getScaleForId(meta.yAxisID);
				var options = me._resolveElementOptions(point, index);
				var data = me.getDataset().data[index];
				var dsIndex = me.index;

				var x = reset ? xScale.getPixelForDecimal(0.5) : xScale.getPixelForValue(typeof data === 'object' ? data : NaN, index, dsIndex);
				var y = reset ? yScale.getBasePixel() : yScale.getPixelForValue(data, index, dsIndex);

				point._xScale = xScale;
				point._yScale = yScale;
				point._options = options;
				point._datasetIndex = dsIndex;
				point._index = index;
				point._model = {
					backgroundColor: options.backgroundColor,
					borderColor: options.borderColor,
					borderWidth: options.borderWidth,
					hitRadius: options.hitRadius,
					pointStyle: options.pointStyle,
					rotation: options.rotation,
					radius: reset ? 0 : options.radius,
					skip: custom.skip || isNaN(x) || isNaN(y),
					x: x,
					y: y,
				};

				point.pivot();
			},

			/**
			 * @protected
			 */
			setHoverStyle: function(point) {
				var model = point._model;
				var options = point._options;
				point.$previousStyle = {
					backgroundColor: model.backgroundColor,
					borderColor: model.borderColor,
					borderWidth: model.borderWidth,
					radius: model.radius
				};
				model.backgroundColor = helpers$4.valueOrDefault(options.hoverBackgroundColor, helpers$4.getHoverColor(options.backgroundColor));
				model.borderColor = helpers$4.valueOrDefault(options.hoverBorderColor, helpers$4.getHoverColor(options.borderColor));
				model.borderWidth = helpers$4.valueOrDefault(options.hoverBorderWidth, options.borderWidth);
				model.radius = options.radius + options.hoverRadius;
			},

			/**
			 * @private
			 */
			_resolveElementOptions: function(point, index) {
				var me = this;
				var chart = me.chart;
				var datasets = chart.data.datasets;
				var dataset = datasets[me.index];
				var custom = point.custom || {};
				var options = chart.options.elements.point;
				var resolve = helpers$4.options.resolve;
				var data = dataset.data[index];
				var values = {};
				var i, ilen, key;

				// Scriptable options
				var context = {
					chart: chart,
					dataIndex: index,
					dataset: dataset,
					datasetIndex: me.index
				};

				var keys = [
					'backgroundColor',
					'borderColor',
					'borderWidth',
					'hoverBackgroundColor',
					'hoverBorderColor',
					'hoverBorderWidth',
					'hoverRadius',
					'hitRadius',
					'pointStyle',
					'rotation'
				];

				for (i = 0, ilen = keys.length; i < ilen; ++i) {
					key = keys[i];
					values[key] = resolve([
						custom[key],
						dataset[key],
						options[key]
					], context, index);
				}

				// Custom radius resolution
				values.radius = resolve([
					custom.radius,
					data ? data.r : undefined,
					dataset.radius,
					options.radius
				], context, index);
				return values;
			}
		});
	};

	var controller_bubble$1 = /*#__PURE__*/Object.freeze({
		default: controller_bubble,
		__moduleExports: controller_bubble
	});

	defaults$3._set('doughnut', {
		animation: {
			// Boolean - Whether we animate the rotation of the Doughnut
			animateRotate: true,
			// Boolean - Whether we animate scaling the Doughnut from the centre
			animateScale: false
		},
		hover: {
			mode: 'single'
		},
		legendCallback: function(chart) {
			var text = [];
			text.push('<ul class="' + chart.id + '-legend">');

			var data = chart.data;
			var datasets = data.datasets;
			var labels = data.labels;

			if (datasets.length) {
				for (var i = 0; i < datasets[0].data.length; ++i) {
					text.push('<li><span style="background-color:' + datasets[0].backgroundColor[i] + '"></span>');
					if (labels[i]) {
						text.push(labels[i]);
					}
					text.push('</li>');
				}
			}

			text.push('</ul>');
			return text.join('');
		},
		legend: {
			labels: {
				generateLabels: function(chart) {
					var data = chart.data;
					if (data.labels.length && data.datasets.length) {
						return data.labels.map(function(label, i) {
							var meta = chart.getDatasetMeta(0);
							var ds = data.datasets[0];
							var arc = meta.data[i];
							var custom = arc && arc.custom || {};
							var valueAtIndexOrDefault = helpers$4.valueAtIndexOrDefault;
							var arcOpts = chart.options.elements.arc;
							var fill = custom.backgroundColor ? custom.backgroundColor : valueAtIndexOrDefault(ds.backgroundColor, i, arcOpts.backgroundColor);
							var stroke = custom.borderColor ? custom.borderColor : valueAtIndexOrDefault(ds.borderColor, i, arcOpts.borderColor);
							var bw = custom.borderWidth ? custom.borderWidth : valueAtIndexOrDefault(ds.borderWidth, i, arcOpts.borderWidth);

							return {
								text: label,
								fillStyle: fill,
								strokeStyle: stroke,
								lineWidth: bw,
								hidden: isNaN(ds.data[i]) || meta.data[i].hidden,

								// Extra data used for toggling the correct item
								index: i
							};
						});
					}
					return [];
				}
			},

			onClick: function(e, legendItem) {
				var index = legendItem.index;
				var chart = this.chart;
				var i, ilen, meta;

				for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
					meta = chart.getDatasetMeta(i);
					// toggle visibility of index if exists
					if (meta.data[index]) {
						meta.data[index].hidden = !meta.data[index].hidden;
					}
				}

				chart.update();
			}
		},

		// The percentage of the chart that we cut out of the middle.
		cutoutPercentage: 50,

		// The rotation of the chart, where the first data arc begins.
		rotation: Math.PI * -0.5,

		// The total circumference of the chart.
		circumference: Math.PI * 2.0,

		// Need to override these to give a nice default
		tooltips: {
			callbacks: {
				title: function() {
					return '';
				},
				label: function(tooltipItem, data) {
					var dataLabel = data.labels[tooltipItem.index];
					var value = ': ' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];

					if (helpers$4.isArray(dataLabel)) {
						// show value on first line of multiline label
						// need to clone because we are changing the value
						dataLabel = dataLabel.slice();
						dataLabel[0] += value;
					} else {
						dataLabel += value;
					}

					return dataLabel;
				}
			}
		}
	});

	defaults$3._set('pie', helpers$4.clone(defaults$3.doughnut));
	defaults$3._set('pie', {
		cutoutPercentage: 0
	});

	var controller_doughnut = function(Chart) {

		Chart.controllers.doughnut = Chart.controllers.pie = Chart.DatasetController.extend({

			dataElementType: elements$2.Arc,

			linkScales: helpers$4.noop,

			// Get index of the dataset in relation to the visible datasets. This allows determining the inner and outer radius correctly
			getRingIndex: function(datasetIndex) {
				var this$1 = this;

				var ringIndex = 0;

				for (var j = 0; j < datasetIndex; ++j) {
					if (this$1.chart.isDatasetVisible(j)) {
						++ringIndex;
					}
				}

				return ringIndex;
			},

			update: function(reset) {
				var me = this;
				var chart = me.chart;
				var chartArea = chart.chartArea;
				var opts = chart.options;
				var arcOpts = opts.elements.arc;
				var availableWidth = chartArea.right - chartArea.left - arcOpts.borderWidth;
				var availableHeight = chartArea.bottom - chartArea.top - arcOpts.borderWidth;
				var minSize = Math.min(availableWidth, availableHeight);
				var offset = {x: 0, y: 0};
				var meta = me.getMeta();
				var cutoutPercentage = opts.cutoutPercentage;
				var circumference = opts.circumference;

				// If the chart's circumference isn't a full circle, calculate minSize as a ratio of the width/height of the arc
				if (circumference < Math.PI * 2.0) {
					var startAngle = opts.rotation % (Math.PI * 2.0);
					startAngle += Math.PI * 2.0 * (startAngle >= Math.PI ? -1 : startAngle < -Math.PI ? 1 : 0);
					var endAngle = startAngle + circumference;
					var start = {x: Math.cos(startAngle), y: Math.sin(startAngle)};
					var end = {x: Math.cos(endAngle), y: Math.sin(endAngle)};
					var contains0 = (startAngle <= 0 && endAngle >= 0) || (startAngle <= Math.PI * 2.0 && Math.PI * 2.0 <= endAngle);
					var contains90 = (startAngle <= Math.PI * 0.5 && Math.PI * 0.5 <= endAngle) || (startAngle <= Math.PI * 2.5 && Math.PI * 2.5 <= endAngle);
					var contains180 = (startAngle <= -Math.PI && -Math.PI <= endAngle) || (startAngle <= Math.PI && Math.PI <= endAngle);
					var contains270 = (startAngle <= -Math.PI * 0.5 && -Math.PI * 0.5 <= endAngle) || (startAngle <= Math.PI * 1.5 && Math.PI * 1.5 <= endAngle);
					var cutout = cutoutPercentage / 100.0;
					var min = {x: contains180 ? -1 : Math.min(start.x * (start.x < 0 ? 1 : cutout), end.x * (end.x < 0 ? 1 : cutout)), y: contains270 ? -1 : Math.min(start.y * (start.y < 0 ? 1 : cutout), end.y * (end.y < 0 ? 1 : cutout))};
					var max = {x: contains0 ? 1 : Math.max(start.x * (start.x > 0 ? 1 : cutout), end.x * (end.x > 0 ? 1 : cutout)), y: contains90 ? 1 : Math.max(start.y * (start.y > 0 ? 1 : cutout), end.y * (end.y > 0 ? 1 : cutout))};
					var size = {width: (max.x - min.x) * 0.5, height: (max.y - min.y) * 0.5};
					minSize = Math.min(availableWidth / size.width, availableHeight / size.height);
					offset = {x: (max.x + min.x) * -0.5, y: (max.y + min.y) * -0.5};
				}

				chart.borderWidth = me.getMaxBorderWidth(meta.data);
				chart.outerRadius = Math.max((minSize - chart.borderWidth) / 2, 0);
				chart.innerRadius = Math.max(cutoutPercentage ? (chart.outerRadius / 100) * (cutoutPercentage) : 0, 0);
				chart.radiusLength = (chart.outerRadius - chart.innerRadius) / chart.getVisibleDatasetCount();
				chart.offsetX = offset.x * chart.outerRadius;
				chart.offsetY = offset.y * chart.outerRadius;

				meta.total = me.calculateTotal();

				me.outerRadius = chart.outerRadius - (chart.radiusLength * me.getRingIndex(me.index));
				me.innerRadius = Math.max(me.outerRadius - chart.radiusLength, 0);

				helpers$4.each(meta.data, function(arc, index) {
					me.updateElement(arc, index, reset);
				});
			},

			updateElement: function(arc, index, reset) {
				var me = this;
				var chart = me.chart;
				var chartArea = chart.chartArea;
				var opts = chart.options;
				var animationOpts = opts.animation;
				var centerX = (chartArea.left + chartArea.right) / 2;
				var centerY = (chartArea.top + chartArea.bottom) / 2;
				var startAngle = opts.rotation; // non reset case handled later
				var endAngle = opts.rotation; // non reset case handled later
				var dataset = me.getDataset();
				var circumference = reset && animationOpts.animateRotate ? 0 : arc.hidden ? 0 : me.calculateCircumference(dataset.data[index]) * (opts.circumference / (2.0 * Math.PI));
				var innerRadius = reset && animationOpts.animateScale ? 0 : me.innerRadius;
				var outerRadius = reset && animationOpts.animateScale ? 0 : me.outerRadius;
				var valueAtIndexOrDefault = helpers$4.valueAtIndexOrDefault;

				helpers$4.extend(arc, {
					// Utility
					_datasetIndex: me.index,
					_index: index,

					// Desired view properties
					_model: {
						x: centerX + chart.offsetX,
						y: centerY + chart.offsetY,
						startAngle: startAngle,
						endAngle: endAngle,
						circumference: circumference,
						outerRadius: outerRadius,
						innerRadius: innerRadius,
						label: valueAtIndexOrDefault(dataset.label, index, chart.data.labels[index])
					}
				});

				var model = arc._model;

				// Resets the visual styles
				var custom = arc.custom || {};
				var valueOrDefault = helpers$4.valueAtIndexOrDefault;
				var elementOpts = this.chart.options.elements.arc;
				model.backgroundColor = custom.backgroundColor ? custom.backgroundColor : valueOrDefault(dataset.backgroundColor, index, elementOpts.backgroundColor);
				model.borderColor = custom.borderColor ? custom.borderColor : valueOrDefault(dataset.borderColor, index, elementOpts.borderColor);
				model.borderWidth = custom.borderWidth ? custom.borderWidth : valueOrDefault(dataset.borderWidth, index, elementOpts.borderWidth);

				// Set correct angles if not resetting
				if (!reset || !animationOpts.animateRotate) {
					if (index === 0) {
						model.startAngle = opts.rotation;
					} else {
						model.startAngle = me.getMeta().data[index - 1]._model.endAngle;
					}

					model.endAngle = model.startAngle + model.circumference;
				}

				arc.pivot();
			},

			calculateTotal: function() {
				var dataset = this.getDataset();
				var meta = this.getMeta();
				var total = 0;
				var value;

				helpers$4.each(meta.data, function(element, index) {
					value = dataset.data[index];
					if (!isNaN(value) && !element.hidden) {
						total += Math.abs(value);
					}
				});

				/* if (total === 0) {
					total = NaN;
				}*/

				return total;
			},

			calculateCircumference: function(value) {
				var total = this.getMeta().total;
				if (total > 0 && !isNaN(value)) {
					return (Math.PI * 2.0) * (Math.abs(value) / total);
				}
				return 0;
			},

			// gets the max border or hover width to properly scale pie charts
			getMaxBorderWidth: function(arcs) {
				var max = 0;
				var index = this.index;
				var length = arcs.length;
				var borderWidth;
				var hoverWidth;

				for (var i = 0; i < length; i++) {
					borderWidth = arcs[i]._model ? arcs[i]._model.borderWidth : 0;
					hoverWidth = arcs[i]._chart ? arcs[i]._chart.config.data.datasets[index].hoverBorderWidth : 0;

					max = borderWidth > max ? borderWidth : max;
					max = hoverWidth > max ? hoverWidth : max;
				}
				return max;
			}
		});
	};

	var controller_doughnut$1 = /*#__PURE__*/Object.freeze({
		default: controller_doughnut,
		__moduleExports: controller_doughnut
	});

	defaults$3._set('line', {
		showLines: true,
		spanGaps: false,

		hover: {
			mode: 'label'
		},

		scales: {
			xAxes: [{
				type: 'category',
				id: 'x-axis-0'
			}],
			yAxes: [{
				type: 'linear',
				id: 'y-axis-0'
			}]
		}
	});

	var controller_line = function(Chart) {

		function lineEnabled(dataset, options) {
			return helpers$4.valueOrDefault(dataset.showLine, options.showLines);
		}

		Chart.controllers.line = Chart.DatasetController.extend({

			datasetElementType: elements$2.Line,

			dataElementType: elements$2.Point,

			update: function(reset) {
				var me = this;
				var meta = me.getMeta();
				var line = meta.dataset;
				var points = meta.data || [];
				var options = me.chart.options;
				var lineElementOptions = options.elements.line;
				var scale = me.getScaleForId(meta.yAxisID);
				var i, ilen, custom;
				var dataset = me.getDataset();
				var showLine = lineEnabled(dataset, options);

				// Update Line
				if (showLine) {
					custom = line.custom || {};

					// Compatibility: If the properties are defined with only the old name, use those values
					if ((dataset.tension !== undefined) && (dataset.lineTension === undefined)) {
						dataset.lineTension = dataset.tension;
					}

					// Utility
					line._scale = scale;
					line._datasetIndex = me.index;
					// Data
					line._children = points;
					// Model
					line._model = {
						// Appearance
						// The default behavior of lines is to break at null values, according
						// to https://github.com/chartjs/Chart.js/issues/2435#issuecomment-216718158
						// This option gives lines the ability to span gaps
						spanGaps: dataset.spanGaps ? dataset.spanGaps : options.spanGaps,
						tension: custom.tension ? custom.tension : helpers$4.valueOrDefault(dataset.lineTension, lineElementOptions.tension),
						backgroundColor: custom.backgroundColor ? custom.backgroundColor : (dataset.backgroundColor || lineElementOptions.backgroundColor),
						borderWidth: custom.borderWidth ? custom.borderWidth : (dataset.borderWidth || lineElementOptions.borderWidth),
						borderColor: custom.borderColor ? custom.borderColor : (dataset.borderColor || lineElementOptions.borderColor),
						borderCapStyle: custom.borderCapStyle ? custom.borderCapStyle : (dataset.borderCapStyle || lineElementOptions.borderCapStyle),
						borderDash: custom.borderDash ? custom.borderDash : (dataset.borderDash || lineElementOptions.borderDash),
						borderDashOffset: custom.borderDashOffset ? custom.borderDashOffset : (dataset.borderDashOffset || lineElementOptions.borderDashOffset),
						borderJoinStyle: custom.borderJoinStyle ? custom.borderJoinStyle : (dataset.borderJoinStyle || lineElementOptions.borderJoinStyle),
						fill: custom.fill ? custom.fill : (dataset.fill !== undefined ? dataset.fill : lineElementOptions.fill),
						steppedLine: custom.steppedLine ? custom.steppedLine : helpers$4.valueOrDefault(dataset.steppedLine, lineElementOptions.stepped),
						cubicInterpolationMode: custom.cubicInterpolationMode ? custom.cubicInterpolationMode : helpers$4.valueOrDefault(dataset.cubicInterpolationMode, lineElementOptions.cubicInterpolationMode),
					};

					line.pivot();
				}

				// Update Points
				for (i = 0, ilen = points.length; i < ilen; ++i) {
					me.updateElement(points[i], i, reset);
				}

				if (showLine && line._model.tension !== 0) {
					me.updateBezierControlPoints();
				}

				// Now pivot the point for animation
				for (i = 0, ilen = points.length; i < ilen; ++i) {
					points[i].pivot();
				}
			},

			getPointBackgroundColor: function(point, index) {
				var backgroundColor = this.chart.options.elements.point.backgroundColor;
				var dataset = this.getDataset();
				var custom = point.custom || {};

				if (custom.backgroundColor) {
					backgroundColor = custom.backgroundColor;
				} else if (dataset.pointBackgroundColor) {
					backgroundColor = helpers$4.valueAtIndexOrDefault(dataset.pointBackgroundColor, index, backgroundColor);
				} else if (dataset.backgroundColor) {
					backgroundColor = dataset.backgroundColor;
				}

				return backgroundColor;
			},

			getPointBorderColor: function(point, index) {
				var borderColor = this.chart.options.elements.point.borderColor;
				var dataset = this.getDataset();
				var custom = point.custom || {};

				if (custom.borderColor) {
					borderColor = custom.borderColor;
				} else if (dataset.pointBorderColor) {
					borderColor = helpers$4.valueAtIndexOrDefault(dataset.pointBorderColor, index, borderColor);
				} else if (dataset.borderColor) {
					borderColor = dataset.borderColor;
				}

				return borderColor;
			},

			getPointBorderWidth: function(point, index) {
				var borderWidth = this.chart.options.elements.point.borderWidth;
				var dataset = this.getDataset();
				var custom = point.custom || {};

				if (!isNaN(custom.borderWidth)) {
					borderWidth = custom.borderWidth;
				} else if (!isNaN(dataset.pointBorderWidth) || helpers$4.isArray(dataset.pointBorderWidth)) {
					borderWidth = helpers$4.valueAtIndexOrDefault(dataset.pointBorderWidth, index, borderWidth);
				} else if (!isNaN(dataset.borderWidth)) {
					borderWidth = dataset.borderWidth;
				}

				return borderWidth;
			},

			getPointRotation: function(point, index) {
				var pointRotation = this.chart.options.elements.point.rotation;
				var dataset = this.getDataset();
				var custom = point.custom || {};

				if (!isNaN(custom.rotation)) {
					pointRotation = custom.rotation;
				} else if (!isNaN(dataset.pointRotation) || helpers$4.isArray(dataset.pointRotation)) {
					pointRotation = helpers$4.valueAtIndexOrDefault(dataset.pointRotation, index, pointRotation);
				}
				return pointRotation;
			},

			updateElement: function(point, index, reset) {
				var me = this;
				var meta = me.getMeta();
				var custom = point.custom || {};
				var dataset = me.getDataset();
				var datasetIndex = me.index;
				var value = dataset.data[index];
				var yScale = me.getScaleForId(meta.yAxisID);
				var xScale = me.getScaleForId(meta.xAxisID);
				var pointOptions = me.chart.options.elements.point;
				var x, y;

				// Compatibility: If the properties are defined with only the old name, use those values
				if ((dataset.radius !== undefined) && (dataset.pointRadius === undefined)) {
					dataset.pointRadius = dataset.radius;
				}
				if ((dataset.hitRadius !== undefined) && (dataset.pointHitRadius === undefined)) {
					dataset.pointHitRadius = dataset.hitRadius;
				}

				x = xScale.getPixelForValue(typeof value === 'object' ? value : NaN, index, datasetIndex);
				y = reset ? yScale.getBasePixel() : me.calculatePointY(value, index, datasetIndex);

				// Utility
				point._xScale = xScale;
				point._yScale = yScale;
				point._datasetIndex = datasetIndex;
				point._index = index;

				// Desired view properties
				point._model = {
					x: x,
					y: y,
					skip: custom.skip || isNaN(x) || isNaN(y),
					// Appearance
					radius: custom.radius || helpers$4.valueAtIndexOrDefault(dataset.pointRadius, index, pointOptions.radius),
					pointStyle: custom.pointStyle || helpers$4.valueAtIndexOrDefault(dataset.pointStyle, index, pointOptions.pointStyle),
					rotation: me.getPointRotation(point, index),
					backgroundColor: me.getPointBackgroundColor(point, index),
					borderColor: me.getPointBorderColor(point, index),
					borderWidth: me.getPointBorderWidth(point, index),
					tension: meta.dataset._model ? meta.dataset._model.tension : 0,
					steppedLine: meta.dataset._model ? meta.dataset._model.steppedLine : false,
					// Tooltip
					hitRadius: custom.hitRadius || helpers$4.valueAtIndexOrDefault(dataset.pointHitRadius, index, pointOptions.hitRadius)
				};
			},

			calculatePointY: function(value, index, datasetIndex) {
				var me = this;
				var chart = me.chart;
				var meta = me.getMeta();
				var yScale = me.getScaleForId(meta.yAxisID);
				var sumPos = 0;
				var sumNeg = 0;
				var i, ds, dsMeta;

				if (yScale.options.stacked) {
					for (i = 0; i < datasetIndex; i++) {
						ds = chart.data.datasets[i];
						dsMeta = chart.getDatasetMeta(i);
						if (dsMeta.type === 'line' && dsMeta.yAxisID === yScale.id && chart.isDatasetVisible(i)) {
							var stackedRightValue = Number(yScale.getRightValue(ds.data[index]));
							if (stackedRightValue < 0) {
								sumNeg += stackedRightValue || 0;
							} else {
								sumPos += stackedRightValue || 0;
							}
						}
					}

					var rightValue = Number(yScale.getRightValue(value));
					if (rightValue < 0) {
						return yScale.getPixelForValue(sumNeg + rightValue);
					}
					return yScale.getPixelForValue(sumPos + rightValue);
				}

				return yScale.getPixelForValue(value);
			},

			updateBezierControlPoints: function() {
				var me = this;
				var meta = me.getMeta();
				var area = me.chart.chartArea;
				var points = (meta.data || []);
				var i, ilen, point, model, controlPoints;

				// Only consider points that are drawn in case the spanGaps option is used
				if (meta.dataset._model.spanGaps) {
					points = points.filter(function(pt) {
						return !pt._model.skip;
					});
				}

				function capControlPoint(pt, min, max) {
					return Math.max(Math.min(pt, max), min);
				}

				if (meta.dataset._model.cubicInterpolationMode === 'monotone') {
					helpers$4.splineCurveMonotone(points);
				} else {
					for (i = 0, ilen = points.length; i < ilen; ++i) {
						point = points[i];
						model = point._model;
						controlPoints = helpers$4.splineCurve(
							helpers$4.previousItem(points, i)._model,
							model,
							helpers$4.nextItem(points, i)._model,
							meta.dataset._model.tension
						);
						model.controlPointPreviousX = controlPoints.previous.x;
						model.controlPointPreviousY = controlPoints.previous.y;
						model.controlPointNextX = controlPoints.next.x;
						model.controlPointNextY = controlPoints.next.y;
					}
				}

				if (me.chart.options.elements.line.capBezierPoints) {
					for (i = 0, ilen = points.length; i < ilen; ++i) {
						model = points[i]._model;
						model.controlPointPreviousX = capControlPoint(model.controlPointPreviousX, area.left, area.right);
						model.controlPointPreviousY = capControlPoint(model.controlPointPreviousY, area.top, area.bottom);
						model.controlPointNextX = capControlPoint(model.controlPointNextX, area.left, area.right);
						model.controlPointNextY = capControlPoint(model.controlPointNextY, area.top, area.bottom);
					}
				}
			},

			draw: function() {
				var me = this;
				var chart = me.chart;
				var meta = me.getMeta();
				var points = meta.data || [];
				var area = chart.chartArea;
				var ilen = points.length;
				var halfBorderWidth;
				var i = 0;

				if (lineEnabled(me.getDataset(), chart.options)) {
					halfBorderWidth = (meta.dataset._model.borderWidth || 0) / 2;

					helpers$4.canvas.clipArea(chart.ctx, {
						left: area.left,
						right: area.right,
						top: area.top - halfBorderWidth,
						bottom: area.bottom + halfBorderWidth
					});

					meta.dataset.draw();

					helpers$4.canvas.unclipArea(chart.ctx);
				}

				// Draw the points
				for (; i < ilen; ++i) {
					points[i].draw(area);
				}
			},

			setHoverStyle: function(element) {
				// Point
				var dataset = this.chart.data.datasets[element._datasetIndex];
				var index = element._index;
				var custom = element.custom || {};
				var model = element._model;

				element.$previousStyle = {
					backgroundColor: model.backgroundColor,
					borderColor: model.borderColor,
					borderWidth: model.borderWidth,
					radius: model.radius
				};

				model.backgroundColor = custom.hoverBackgroundColor || helpers$4.valueAtIndexOrDefault(dataset.pointHoverBackgroundColor, index, helpers$4.getHoverColor(model.backgroundColor));
				model.borderColor = custom.hoverBorderColor || helpers$4.valueAtIndexOrDefault(dataset.pointHoverBorderColor, index, helpers$4.getHoverColor(model.borderColor));
				model.borderWidth = custom.hoverBorderWidth || helpers$4.valueAtIndexOrDefault(dataset.pointHoverBorderWidth, index, model.borderWidth);
				model.radius = custom.hoverRadius || helpers$4.valueAtIndexOrDefault(dataset.pointHoverRadius, index, this.chart.options.elements.point.hoverRadius);
			},
		});
	};

	var controller_line$1 = /*#__PURE__*/Object.freeze({
		default: controller_line,
		__moduleExports: controller_line
	});

	defaults$3._set('polarArea', {
		scale: {
			type: 'radialLinear',
			angleLines: {
				display: false
			},
			gridLines: {
				circular: true
			},
			pointLabels: {
				display: false
			},
			ticks: {
				beginAtZero: true
			}
		},

		// Boolean - Whether to animate the rotation of the chart
		animation: {
			animateRotate: true,
			animateScale: true
		},

		startAngle: -0.5 * Math.PI,
		legendCallback: function(chart) {
			var text = [];
			text.push('<ul class="' + chart.id + '-legend">');

			var data = chart.data;
			var datasets = data.datasets;
			var labels = data.labels;

			if (datasets.length) {
				for (var i = 0; i < datasets[0].data.length; ++i) {
					text.push('<li><span style="background-color:' + datasets[0].backgroundColor[i] + '"></span>');
					if (labels[i]) {
						text.push(labels[i]);
					}
					text.push('</li>');
				}
			}

			text.push('</ul>');
			return text.join('');
		},
		legend: {
			labels: {
				generateLabels: function(chart) {
					var data = chart.data;
					if (data.labels.length && data.datasets.length) {
						return data.labels.map(function(label, i) {
							var meta = chart.getDatasetMeta(0);
							var ds = data.datasets[0];
							var arc = meta.data[i];
							var custom = arc.custom || {};
							var valueAtIndexOrDefault = helpers$4.valueAtIndexOrDefault;
							var arcOpts = chart.options.elements.arc;
							var fill = custom.backgroundColor ? custom.backgroundColor : valueAtIndexOrDefault(ds.backgroundColor, i, arcOpts.backgroundColor);
							var stroke = custom.borderColor ? custom.borderColor : valueAtIndexOrDefault(ds.borderColor, i, arcOpts.borderColor);
							var bw = custom.borderWidth ? custom.borderWidth : valueAtIndexOrDefault(ds.borderWidth, i, arcOpts.borderWidth);

							return {
								text: label,
								fillStyle: fill,
								strokeStyle: stroke,
								lineWidth: bw,
								hidden: isNaN(ds.data[i]) || meta.data[i].hidden,

								// Extra data used for toggling the correct item
								index: i
							};
						});
					}
					return [];
				}
			},

			onClick: function(e, legendItem) {
				var index = legendItem.index;
				var chart = this.chart;
				var i, ilen, meta;

				for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
					meta = chart.getDatasetMeta(i);
					meta.data[index].hidden = !meta.data[index].hidden;
				}

				chart.update();
			}
		},

		// Need to override these to give a nice default
		tooltips: {
			callbacks: {
				title: function() {
					return '';
				},
				label: function(item, data) {
					return data.labels[item.index] + ': ' + item.yLabel;
				}
			}
		}
	});

	var controller_polarArea = function(Chart) {

		Chart.controllers.polarArea = Chart.DatasetController.extend({

			dataElementType: elements$2.Arc,

			linkScales: helpers$4.noop,

			update: function(reset) {
				var me = this;
				var dataset = me.getDataset();
				var meta = me.getMeta();
				var start = me.chart.options.startAngle || 0;
				var starts = me._starts = [];
				var angles = me._angles = [];
				var i, ilen, angle;

				me._updateRadius();

				meta.count = me.countVisibleElements();

				for (i = 0, ilen = dataset.data.length; i < ilen; i++) {
					starts[i] = start;
					angle = me._computeAngle(i);
					angles[i] = angle;
					start += angle;
				}

				helpers$4.each(meta.data, function(arc, index) {
					me.updateElement(arc, index, reset);
				});
			},

			/**
			 * @private
			 */
			_updateRadius: function() {
				var me = this;
				var chart = me.chart;
				var chartArea = chart.chartArea;
				var opts = chart.options;
				var arcOpts = opts.elements.arc;
				var minSize = Math.min(chartArea.right - chartArea.left, chartArea.bottom - chartArea.top);

				chart.outerRadius = Math.max((minSize - arcOpts.borderWidth / 2) / 2, 0);
				chart.innerRadius = Math.max(opts.cutoutPercentage ? (chart.outerRadius / 100) * (opts.cutoutPercentage) : 1, 0);
				chart.radiusLength = (chart.outerRadius - chart.innerRadius) / chart.getVisibleDatasetCount();

				me.outerRadius = chart.outerRadius - (chart.radiusLength * me.index);
				me.innerRadius = me.outerRadius - chart.radiusLength;
			},

			updateElement: function(arc, index, reset) {
				var me = this;
				var chart = me.chart;
				var dataset = me.getDataset();
				var opts = chart.options;
				var animationOpts = opts.animation;
				var scale = chart.scale;
				var labels = chart.data.labels;

				var centerX = scale.xCenter;
				var centerY = scale.yCenter;

				// var negHalfPI = -0.5 * Math.PI;
				var datasetStartAngle = opts.startAngle;
				var distance = arc.hidden ? 0 : scale.getDistanceFromCenterForValue(dataset.data[index]);
				var startAngle = me._starts[index];
				var endAngle = startAngle + (arc.hidden ? 0 : me._angles[index]);

				var resetRadius = animationOpts.animateScale ? 0 : scale.getDistanceFromCenterForValue(dataset.data[index]);

				helpers$4.extend(arc, {
					// Utility
					_datasetIndex: me.index,
					_index: index,
					_scale: scale,

					// Desired view properties
					_model: {
						x: centerX,
						y: centerY,
						innerRadius: 0,
						outerRadius: reset ? resetRadius : distance,
						startAngle: reset && animationOpts.animateRotate ? datasetStartAngle : startAngle,
						endAngle: reset && animationOpts.animateRotate ? datasetStartAngle : endAngle,
						label: helpers$4.valueAtIndexOrDefault(labels, index, labels[index])
					}
				});

				// Apply border and fill style
				var elementOpts = this.chart.options.elements.arc;
				var custom = arc.custom || {};
				var valueOrDefault = helpers$4.valueAtIndexOrDefault;
				var model = arc._model;

				model.backgroundColor = custom.backgroundColor ? custom.backgroundColor : valueOrDefault(dataset.backgroundColor, index, elementOpts.backgroundColor);
				model.borderColor = custom.borderColor ? custom.borderColor : valueOrDefault(dataset.borderColor, index, elementOpts.borderColor);
				model.borderWidth = custom.borderWidth ? custom.borderWidth : valueOrDefault(dataset.borderWidth, index, elementOpts.borderWidth);

				arc.pivot();
			},

			countVisibleElements: function() {
				var dataset = this.getDataset();
				var meta = this.getMeta();
				var count = 0;

				helpers$4.each(meta.data, function(element, index) {
					if (!isNaN(dataset.data[index]) && !element.hidden) {
						count++;
					}
				});

				return count;
			},

			/**
			 * @private
			 */
			_computeAngle: function(index) {
				var me = this;
				var count = this.getMeta().count;
				var dataset = me.getDataset();
				var meta = me.getMeta();

				if (isNaN(dataset.data[index]) || meta.data[index].hidden) {
					return 0;
				}

				// Scriptable options
				var context = {
					chart: me.chart,
					dataIndex: index,
					dataset: dataset,
					datasetIndex: me.index
				};

				return helpers$4.options.resolve([
					me.chart.options.elements.arc.angle,
					(2 * Math.PI) / count
				], context, index);
			}
		});
	};

	var controller_polarArea$1 = /*#__PURE__*/Object.freeze({
		default: controller_polarArea,
		__moduleExports: controller_polarArea
	});

	defaults$3._set('radar', {
		scale: {
			type: 'radialLinear'
		},
		elements: {
			line: {
				tension: 0 // no bezier in radar
			}
		}
	});

	var controller_radar = function(Chart) {

		Chart.controllers.radar = Chart.DatasetController.extend({

			datasetElementType: elements$2.Line,

			dataElementType: elements$2.Point,

			linkScales: helpers$4.noop,

			update: function(reset) {
				var me = this;
				var meta = me.getMeta();
				var line = meta.dataset;
				var points = meta.data;
				var custom = line.custom || {};
				var dataset = me.getDataset();
				var lineElementOptions = me.chart.options.elements.line;
				var scale = me.chart.scale;

				// Compatibility: If the properties are defined with only the old name, use those values
				if ((dataset.tension !== undefined) && (dataset.lineTension === undefined)) {
					dataset.lineTension = dataset.tension;
				}

				helpers$4.extend(meta.dataset, {
					// Utility
					_datasetIndex: me.index,
					_scale: scale,
					// Data
					_children: points,
					_loop: true,
					// Model
					_model: {
						// Appearance
						tension: custom.tension ? custom.tension : helpers$4.valueOrDefault(dataset.lineTension, lineElementOptions.tension),
						backgroundColor: custom.backgroundColor ? custom.backgroundColor : (dataset.backgroundColor || lineElementOptions.backgroundColor),
						borderWidth: custom.borderWidth ? custom.borderWidth : (dataset.borderWidth || lineElementOptions.borderWidth),
						borderColor: custom.borderColor ? custom.borderColor : (dataset.borderColor || lineElementOptions.borderColor),
						fill: custom.fill ? custom.fill : (dataset.fill !== undefined ? dataset.fill : lineElementOptions.fill),
						borderCapStyle: custom.borderCapStyle ? custom.borderCapStyle : (dataset.borderCapStyle || lineElementOptions.borderCapStyle),
						borderDash: custom.borderDash ? custom.borderDash : (dataset.borderDash || lineElementOptions.borderDash),
						borderDashOffset: custom.borderDashOffset ? custom.borderDashOffset : (dataset.borderDashOffset || lineElementOptions.borderDashOffset),
						borderJoinStyle: custom.borderJoinStyle ? custom.borderJoinStyle : (dataset.borderJoinStyle || lineElementOptions.borderJoinStyle),
					}
				});

				meta.dataset.pivot();

				// Update Points
				helpers$4.each(points, function(point, index) {
					me.updateElement(point, index, reset);
				}, me);

				// Update bezier control points
				me.updateBezierControlPoints();
			},
			updateElement: function(point, index, reset) {
				var me = this;
				var custom = point.custom || {};
				var dataset = me.getDataset();
				var scale = me.chart.scale;
				var pointElementOptions = me.chart.options.elements.point;
				var pointPosition = scale.getPointPositionForValue(index, dataset.data[index]);

				// Compatibility: If the properties are defined with only the old name, use those values
				if ((dataset.radius !== undefined) && (dataset.pointRadius === undefined)) {
					dataset.pointRadius = dataset.radius;
				}
				if ((dataset.hitRadius !== undefined) && (dataset.pointHitRadius === undefined)) {
					dataset.pointHitRadius = dataset.hitRadius;
				}

				helpers$4.extend(point, {
					// Utility
					_datasetIndex: me.index,
					_index: index,
					_scale: scale,

					// Desired view properties
					_model: {
						x: reset ? scale.xCenter : pointPosition.x, // value not used in dataset scale, but we want a consistent API between scales
						y: reset ? scale.yCenter : pointPosition.y,

						// Appearance
						tension: custom.tension ? custom.tension : helpers$4.valueOrDefault(dataset.lineTension, me.chart.options.elements.line.tension),
						radius: custom.radius ? custom.radius : helpers$4.valueAtIndexOrDefault(dataset.pointRadius, index, pointElementOptions.radius),
						backgroundColor: custom.backgroundColor ? custom.backgroundColor : helpers$4.valueAtIndexOrDefault(dataset.pointBackgroundColor, index, pointElementOptions.backgroundColor),
						borderColor: custom.borderColor ? custom.borderColor : helpers$4.valueAtIndexOrDefault(dataset.pointBorderColor, index, pointElementOptions.borderColor),
						borderWidth: custom.borderWidth ? custom.borderWidth : helpers$4.valueAtIndexOrDefault(dataset.pointBorderWidth, index, pointElementOptions.borderWidth),
						pointStyle: custom.pointStyle ? custom.pointStyle : helpers$4.valueAtIndexOrDefault(dataset.pointStyle, index, pointElementOptions.pointStyle),
						rotation: custom.rotation ? custom.rotation : helpers$4.valueAtIndexOrDefault(dataset.pointRotation, index, pointElementOptions.rotation),

						// Tooltip
						hitRadius: custom.hitRadius ? custom.hitRadius : helpers$4.valueAtIndexOrDefault(dataset.pointHitRadius, index, pointElementOptions.hitRadius)
					}
				});

				point._model.skip = custom.skip ? custom.skip : (isNaN(point._model.x) || isNaN(point._model.y));
			},
			updateBezierControlPoints: function() {
				var chartArea = this.chart.chartArea;
				var meta = this.getMeta();

				helpers$4.each(meta.data, function(point, index) {
					var model = point._model;
					var controlPoints = helpers$4.splineCurve(
						helpers$4.previousItem(meta.data, index, true)._model,
						model,
						helpers$4.nextItem(meta.data, index, true)._model,
						model.tension
					);

					// Prevent the bezier going outside of the bounds of the graph
					model.controlPointPreviousX = Math.max(Math.min(controlPoints.previous.x, chartArea.right), chartArea.left);
					model.controlPointPreviousY = Math.max(Math.min(controlPoints.previous.y, chartArea.bottom), chartArea.top);

					model.controlPointNextX = Math.max(Math.min(controlPoints.next.x, chartArea.right), chartArea.left);
					model.controlPointNextY = Math.max(Math.min(controlPoints.next.y, chartArea.bottom), chartArea.top);

					// Now pivot the point for animation
					point.pivot();
				});
			},

			setHoverStyle: function(point) {
				// Point
				var dataset = this.chart.data.datasets[point._datasetIndex];
				var custom = point.custom || {};
				var index = point._index;
				var model = point._model;

				point.$previousStyle = {
					backgroundColor: model.backgroundColor,
					borderColor: model.borderColor,
					borderWidth: model.borderWidth,
					radius: model.radius
				};

				model.radius = custom.hoverRadius ? custom.hoverRadius : helpers$4.valueAtIndexOrDefault(dataset.pointHoverRadius, index, this.chart.options.elements.point.hoverRadius);
				model.backgroundColor = custom.hoverBackgroundColor ? custom.hoverBackgroundColor : helpers$4.valueAtIndexOrDefault(dataset.pointHoverBackgroundColor, index, helpers$4.getHoverColor(model.backgroundColor));
				model.borderColor = custom.hoverBorderColor ? custom.hoverBorderColor : helpers$4.valueAtIndexOrDefault(dataset.pointHoverBorderColor, index, helpers$4.getHoverColor(model.borderColor));
				model.borderWidth = custom.hoverBorderWidth ? custom.hoverBorderWidth : helpers$4.valueAtIndexOrDefault(dataset.pointHoverBorderWidth, index, model.borderWidth);
			},
		});
	};

	var controller_radar$1 = /*#__PURE__*/Object.freeze({
		default: controller_radar,
		__moduleExports: controller_radar
	});

	defaults$3._set('scatter', {
		hover: {
			mode: 'single'
		},

		scales: {
			xAxes: [{
				id: 'x-axis-1',    // need an ID so datasets can reference the scale
				type: 'linear',    // scatter should not use a category axis
				position: 'bottom'
			}],
			yAxes: [{
				id: 'y-axis-1',
				type: 'linear',
				position: 'left'
			}]
		},

		showLines: false,

		tooltips: {
			callbacks: {
				title: function() {
					return '';     // doesn't make sense for scatter since data are formatted as a point
				},
				label: function(item) {
					return '(' + item.xLabel + ', ' + item.yLabel + ')';
				}
			}
		}
	});

	var controller_scatter = function(Chart) {

		// Scatter charts use line controllers
		Chart.controllers.scatter = Chart.controllers.line;

	};

	var controller_scatter$1 = /*#__PURE__*/Object.freeze({
		default: controller_scatter,
		__moduleExports: controller_scatter
	});

	var Chart_Bar = function(Chart) {

		Chart.Bar = function(context, config) {
			config.type = 'bar';

			return new Chart(context, config);
		};

	};

	var Chart_Bar$1 = /*#__PURE__*/Object.freeze({
		default: Chart_Bar,
		__moduleExports: Chart_Bar
	});

	var Chart_Bubble = function(Chart) {

		Chart.Bubble = function(context, config) {
			config.type = 'bubble';
			return new Chart(context, config);
		};

	};

	var Chart_Bubble$1 = /*#__PURE__*/Object.freeze({
		default: Chart_Bubble,
		__moduleExports: Chart_Bubble
	});

	var Chart_Doughnut = function(Chart) {

		Chart.Doughnut = function(context, config) {
			config.type = 'doughnut';

			return new Chart(context, config);
		};

	};

	var Chart_Doughnut$1 = /*#__PURE__*/Object.freeze({
		default: Chart_Doughnut,
		__moduleExports: Chart_Doughnut
	});

	var Chart_Line = function(Chart) {

		Chart.Line = function(context, config) {
			config.type = 'line';

			return new Chart(context, config);
		};

	};

	var Chart_Line$1 = /*#__PURE__*/Object.freeze({
		default: Chart_Line,
		__moduleExports: Chart_Line
	});

	var Chart_PolarArea = function(Chart) {

		Chart.PolarArea = function(context, config) {
			config.type = 'polarArea';

			return new Chart(context, config);
		};

	};

	var Chart_PolarArea$1 = /*#__PURE__*/Object.freeze({
		default: Chart_PolarArea,
		__moduleExports: Chart_PolarArea
	});

	var Chart_Radar = function(Chart) {

		Chart.Radar = function(context, config) {
			config.type = 'radar';

			return new Chart(context, config);
		};

	};

	var Chart_Radar$1 = /*#__PURE__*/Object.freeze({
		default: Chart_Radar,
		__moduleExports: Chart_Radar
	});

	var Chart_Scatter = function(Chart) {
		Chart.Scatter = function(context, config) {
			config.type = 'scatter';
			return new Chart(context, config);
		};
	};

	var Chart_Scatter$1 = /*#__PURE__*/Object.freeze({
		default: Chart_Scatter,
		__moduleExports: Chart_Scatter
	});

	defaults$3._set('global', {
		plugins: {
			filler: {
				propagate: true
			}
		}
	});

	var mappers = {
		dataset: function(source) {
			var index = source.fill;
			var chart = source.chart;
			var meta = chart.getDatasetMeta(index);
			var visible = meta && chart.isDatasetVisible(index);
			var points = (visible && meta.dataset._children) || [];
			var length = points.length || 0;

			return !length ? null : function(point, i) {
				return (i < length && points[i]._view) || null;
			};
		},

		boundary: function(source) {
			var boundary = source.boundary;
			var x = boundary ? boundary.x : null;
			var y = boundary ? boundary.y : null;

			return function(point) {
				return {
					x: x === null ? point.x : x,
					y: y === null ? point.y : y,
				};
			};
		}
	};

	// @todo if (fill[0] === '#')
	function decodeFill(el, index, count) {
		var model = el._model || {};
		var fill = model.fill;
		var target;

		if (fill === undefined) {
			fill = !!model.backgroundColor;
		}

		if (fill === false || fill === null) {
			return false;
		}

		if (fill === true) {
			return 'origin';
		}

		target = parseFloat(fill, 10);
		if (isFinite(target) && Math.floor(target) === target) {
			if (fill[0] === '-' || fill[0] === '+') {
				target = index + target;
			}

			if (target === index || target < 0 || target >= count) {
				return false;
			}

			return target;
		}

		switch (fill) {
		// compatibility
		case 'bottom':
			return 'start';
		case 'top':
			return 'end';
		case 'zero':
			return 'origin';
		// supported boundaries
		case 'origin':
		case 'start':
		case 'end':
			return fill;
		// invalid fill values
		default:
			return false;
		}
	}

	function computeBoundary(source) {
		var model = source.el._model || {};
		var scale = source.el._scale || {};
		var fill = source.fill;
		var target = null;
		var horizontal;

		if (isFinite(fill)) {
			return null;
		}

		// Backward compatibility: until v3, we still need to support boundary values set on
		// the model (scaleTop, scaleBottom and scaleZero) because some external plugins and
		// controllers might still use it (e.g. the Smith chart).

		if (fill === 'start') {
			target = model.scaleBottom === undefined ? scale.bottom : model.scaleBottom;
		} else if (fill === 'end') {
			target = model.scaleTop === undefined ? scale.top : model.scaleTop;
		} else if (model.scaleZero !== undefined) {
			target = model.scaleZero;
		} else if (scale.getBasePosition) {
			target = scale.getBasePosition();
		} else if (scale.getBasePixel) {
			target = scale.getBasePixel();
		}

		if (target !== undefined && target !== null) {
			if (target.x !== undefined && target.y !== undefined) {
				return target;
			}

			if (typeof target === 'number' && isFinite(target)) {
				horizontal = scale.isHorizontal();
				return {
					x: horizontal ? target : null,
					y: horizontal ? null : target
				};
			}
		}

		return null;
	}

	function resolveTarget(sources, index, propagate) {
		var source = sources[index];
		var fill = source.fill;
		var visited = [index];
		var target;

		if (!propagate) {
			return fill;
		}

		while (fill !== false && visited.indexOf(fill) === -1) {
			if (!isFinite(fill)) {
				return fill;
			}

			target = sources[fill];
			if (!target) {
				return false;
			}

			if (target.visible) {
				return fill;
			}

			visited.push(fill);
			fill = target.fill;
		}

		return false;
	}

	function createMapper(source) {
		var fill = source.fill;
		var type = 'dataset';

		if (fill === false) {
			return null;
		}

		if (!isFinite(fill)) {
			type = 'boundary';
		}

		return mappers[type](source);
	}

	function isDrawable(point) {
		return point && !point.skip;
	}

	function drawArea(ctx, curve0, curve1, len0, len1) {
		var i;

		if (!len0 || !len1) {
			return;
		}

		// building first area curve (normal)
		ctx.moveTo(curve0[0].x, curve0[0].y);
		for (i = 1; i < len0; ++i) {
			helpers$4.canvas.lineTo(ctx, curve0[i - 1], curve0[i]);
		}

		// joining the two area curves
		ctx.lineTo(curve1[len1 - 1].x, curve1[len1 - 1].y);

		// building opposite area curve (reverse)
		for (i = len1 - 1; i > 0; --i) {
			helpers$4.canvas.lineTo(ctx, curve1[i], curve1[i - 1], true);
		}
	}

	function doFill(ctx, points, mapper, view, color, loop) {
		var count = points.length;
		var span = view.spanGaps;
		var curve0 = [];
		var curve1 = [];
		var len0 = 0;
		var len1 = 0;
		var i, ilen, index, p0, p1, d0, d1;

		ctx.beginPath();

		for (i = 0, ilen = (count + !!loop); i < ilen; ++i) {
			index = i % count;
			p0 = points[index]._view;
			p1 = mapper(p0, index, view);
			d0 = isDrawable(p0);
			d1 = isDrawable(p1);

			if (d0 && d1) {
				len0 = curve0.push(p0);
				len1 = curve1.push(p1);
			} else if (len0 && len1) {
				if (!span) {
					drawArea(ctx, curve0, curve1, len0, len1);
					len0 = len1 = 0;
					curve0 = [];
					curve1 = [];
				} else {
					if (d0) {
						curve0.push(p0);
					}
					if (d1) {
						curve1.push(p1);
					}
				}
			}
		}

		drawArea(ctx, curve0, curve1, len0, len1);

		ctx.closePath();
		ctx.fillStyle = color;
		ctx.fill();
	}

	var plugin_filler = {
		id: 'filler',

		afterDatasetsUpdate: function(chart, options) {
			var count = (chart.data.datasets || []).length;
			var propagate = options.propagate;
			var sources = [];
			var meta, i, el, source;

			for (i = 0; i < count; ++i) {
				meta = chart.getDatasetMeta(i);
				el = meta.dataset;
				source = null;

				if (el && el._model && el instanceof elements$2.Line) {
					source = {
						visible: chart.isDatasetVisible(i),
						fill: decodeFill(el, i, count),
						chart: chart,
						el: el
					};
				}

				meta.$filler = source;
				sources.push(source);
			}

			for (i = 0; i < count; ++i) {
				source = sources[i];
				if (!source) {
					continue;
				}

				source.fill = resolveTarget(sources, i, propagate);
				source.boundary = computeBoundary(source);
				source.mapper = createMapper(source);
			}
		},

		beforeDatasetDraw: function(chart, args) {
			var meta = args.meta.$filler;
			if (!meta) {
				return;
			}

			var ctx = chart.ctx;
			var el = meta.el;
			var view = el._view;
			var points = el._children || [];
			var mapper = meta.mapper;
			var color = view.backgroundColor || defaults$3.global.defaultColor;

			if (mapper && color && points.length) {
				helpers$4.canvas.clipArea(ctx, chart.chartArea);
				doFill(ctx, points, mapper, view, color, el._loop);
				helpers$4.canvas.unclipArea(ctx);
			}
		}
	};
	var plugin_filler_1 = plugin_filler.id;
	var plugin_filler_2 = plugin_filler.afterDatasetsUpdate;
	var plugin_filler_3 = plugin_filler.beforeDatasetDraw;

	var plugin_filler$1 = /*#__PURE__*/Object.freeze({
		default: plugin_filler,
		__moduleExports: plugin_filler,
		id: plugin_filler_1,
		afterDatasetsUpdate: plugin_filler_2,
		beforeDatasetDraw: plugin_filler_3
	});

	var noop$2 = helpers$4.noop;

	defaults$3._set('global', {
		legend: {
			display: true,
			position: 'top',
			fullWidth: true,
			reverse: false,
			weight: 1000,

			// a callback that will handle
			onClick: function(e, legendItem) {
				var index = legendItem.datasetIndex;
				var ci = this.chart;
				var meta = ci.getDatasetMeta(index);

				// See controller.isDatasetVisible comment
				meta.hidden = meta.hidden === null ? !ci.data.datasets[index].hidden : null;

				// We hid a dataset ... rerender the chart
				ci.update();
			},

			onHover: null,

			labels: {
				boxWidth: 40,
				padding: 10,
				// Generates labels shown in the legend
				// Valid properties to return:
				// text : text to display
				// fillStyle : fill of coloured box
				// strokeStyle: stroke of coloured box
				// hidden : if this legend item refers to a hidden item
				// lineCap : cap style for line
				// lineDash
				// lineDashOffset :
				// lineJoin :
				// lineWidth :
				generateLabels: function(chart) {
					var data = chart.data;
					return helpers$4.isArray(data.datasets) ? data.datasets.map(function(dataset, i) {
						return {
							text: dataset.label,
							fillStyle: (!helpers$4.isArray(dataset.backgroundColor) ? dataset.backgroundColor : dataset.backgroundColor[0]),
							hidden: !chart.isDatasetVisible(i),
							lineCap: dataset.borderCapStyle,
							lineDash: dataset.borderDash,
							lineDashOffset: dataset.borderDashOffset,
							lineJoin: dataset.borderJoinStyle,
							lineWidth: dataset.borderWidth,
							strokeStyle: dataset.borderColor,
							pointStyle: dataset.pointStyle,

							// Below is extra data used for toggling the datasets
							datasetIndex: i
						};
					}, this) : [];
				}
			}
		},

		legendCallback: function(chart) {
			var text = [];
			text.push('<ul class="' + chart.id + '-legend">');
			for (var i = 0; i < chart.data.datasets.length; i++) {
				text.push('<li><span style="background-color:' + chart.data.datasets[i].backgroundColor + '"></span>');
				if (chart.data.datasets[i].label) {
					text.push(chart.data.datasets[i].label);
				}
				text.push('</li>');
			}
			text.push('</ul>');
			return text.join('');
		}
	});

	/**
	 * Helper function to get the box width based on the usePointStyle option
	 * @param labelopts {Object} the label options on the legend
	 * @param fontSize {Number} the label font size
	 * @return {Number} width of the color box area
	 */
	function getBoxWidth(labelOpts, fontSize) {
		return labelOpts.usePointStyle ?
			fontSize * Math.SQRT2 :
			labelOpts.boxWidth;
	}

	/**
	 * IMPORTANT: this class is exposed publicly as Chart.Legend, backward compatibility required!
	 */
	var Legend = Element$1.extend({

		initialize: function(config) {
			helpers$4.extend(this, config);

			// Contains hit boxes for each dataset (in dataset order)
			this.legendHitBoxes = [];

			// Are we in doughnut mode which has a different data type
			this.doughnutMode = false;
		},

		// These methods are ordered by lifecycle. Utilities then follow.
		// Any function defined here is inherited by all legend types.
		// Any function can be extended by the legend type

		beforeUpdate: noop$2,
		update: function(maxWidth, maxHeight, margins) {
			var me = this;

			// Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
			me.beforeUpdate();

			// Absorb the master measurements
			me.maxWidth = maxWidth;
			me.maxHeight = maxHeight;
			me.margins = margins;

			// Dimensions
			me.beforeSetDimensions();
			me.setDimensions();
			me.afterSetDimensions();
			// Labels
			me.beforeBuildLabels();
			me.buildLabels();
			me.afterBuildLabels();

			// Fit
			me.beforeFit();
			me.fit();
			me.afterFit();
			//
			me.afterUpdate();

			return me.minSize;
		},
		afterUpdate: noop$2,

		//

		beforeSetDimensions: noop$2,
		setDimensions: function() {
			var me = this;
			// Set the unconstrained dimension before label rotation
			if (me.isHorizontal()) {
				// Reset position before calculating rotation
				me.width = me.maxWidth;
				me.left = 0;
				me.right = me.width;
			} else {
				me.height = me.maxHeight;

				// Reset position before calculating rotation
				me.top = 0;
				me.bottom = me.height;
			}

			// Reset padding
			me.paddingLeft = 0;
			me.paddingTop = 0;
			me.paddingRight = 0;
			me.paddingBottom = 0;

			// Reset minSize
			me.minSize = {
				width: 0,
				height: 0
			};
		},
		afterSetDimensions: noop$2,

		//

		beforeBuildLabels: noop$2,
		buildLabels: function() {
			var me = this;
			var labelOpts = me.options.labels || {};
			var legendItems = helpers$4.callback(labelOpts.generateLabels, [me.chart], me) || [];

			if (labelOpts.filter) {
				legendItems = legendItems.filter(function(item) {
					return labelOpts.filter(item, me.chart.data);
				});
			}

			if (me.options.reverse) {
				legendItems.reverse();
			}

			me.legendItems = legendItems;
		},
		afterBuildLabels: noop$2,

		//

		beforeFit: noop$2,
		fit: function() {
			var me = this;
			var opts = me.options;
			var labelOpts = opts.labels;
			var display = opts.display;

			var ctx = me.ctx;

			var globalDefault = defaults$3.global;
			var valueOrDefault = helpers$4.valueOrDefault;
			var fontSize = valueOrDefault(labelOpts.fontSize, globalDefault.defaultFontSize);
			var fontStyle = valueOrDefault(labelOpts.fontStyle, globalDefault.defaultFontStyle);
			var fontFamily = valueOrDefault(labelOpts.fontFamily, globalDefault.defaultFontFamily);
			var labelFont = helpers$4.fontString(fontSize, fontStyle, fontFamily);

			// Reset hit boxes
			var hitboxes = me.legendHitBoxes = [];

			var minSize = me.minSize;
			var isHorizontal = me.isHorizontal();

			if (isHorizontal) {
				minSize.width = me.maxWidth; // fill all the width
				minSize.height = display ? 10 : 0;
			} else {
				minSize.width = display ? 10 : 0;
				minSize.height = me.maxHeight; // fill all the height
			}

			// Increase sizes here
			if (display) {
				ctx.font = labelFont;

				if (isHorizontal) {
					// Labels

					// Width of each line of legend boxes. Labels wrap onto multiple lines when there are too many to fit on one
					var lineWidths = me.lineWidths = [0];
					var totalHeight = me.legendItems.length ? fontSize + (labelOpts.padding) : 0;

					ctx.textAlign = 'left';
					ctx.textBaseline = 'top';

					helpers$4.each(me.legendItems, function(legendItem, i) {
						var boxWidth = getBoxWidth(labelOpts, fontSize);
						var width = boxWidth + (fontSize / 2) + ctx.measureText(legendItem.text).width;

						if (lineWidths[lineWidths.length - 1] + width + labelOpts.padding >= me.width) {
							totalHeight += fontSize + (labelOpts.padding);
							lineWidths[lineWidths.length] = me.left;
						}

						// Store the hitbox width and height here. Final position will be updated in `draw`
						hitboxes[i] = {
							left: 0,
							top: 0,
							width: width,
							height: fontSize
						};

						lineWidths[lineWidths.length - 1] += width + labelOpts.padding;
					});

					minSize.height += totalHeight;

				} else {
					var vPadding = labelOpts.padding;
					var columnWidths = me.columnWidths = [];
					var totalWidth = labelOpts.padding;
					var currentColWidth = 0;
					var currentColHeight = 0;
					var itemHeight = fontSize + vPadding;

					helpers$4.each(me.legendItems, function(legendItem, i) {
						var boxWidth = getBoxWidth(labelOpts, fontSize);
						var itemWidth = boxWidth + (fontSize / 2) + ctx.measureText(legendItem.text).width;

						// If too tall, go to new column
						if (currentColHeight + itemHeight > minSize.height) {
							totalWidth += currentColWidth + labelOpts.padding;
							columnWidths.push(currentColWidth); // previous column width

							currentColWidth = 0;
							currentColHeight = 0;
						}

						// Get max width
						currentColWidth = Math.max(currentColWidth, itemWidth);
						currentColHeight += itemHeight;

						// Store the hitbox width and height here. Final position will be updated in `draw`
						hitboxes[i] = {
							left: 0,
							top: 0,
							width: itemWidth,
							height: fontSize
						};
					});

					totalWidth += currentColWidth;
					columnWidths.push(currentColWidth);
					minSize.width += totalWidth;
				}
			}

			me.width = minSize.width;
			me.height = minSize.height;
		},
		afterFit: noop$2,

		// Shared Methods
		isHorizontal: function() {
			return this.options.position === 'top' || this.options.position === 'bottom';
		},

		// Actually draw the legend on the canvas
		draw: function() {
			var me = this;
			var opts = me.options;
			var labelOpts = opts.labels;
			var globalDefault = defaults$3.global;
			var lineDefault = globalDefault.elements.line;
			var legendWidth = me.width;
			var lineWidths = me.lineWidths;

			if (opts.display) {
				var ctx = me.ctx;
				var valueOrDefault = helpers$4.valueOrDefault;
				var fontColor = valueOrDefault(labelOpts.fontColor, globalDefault.defaultFontColor);
				var fontSize = valueOrDefault(labelOpts.fontSize, globalDefault.defaultFontSize);
				var fontStyle = valueOrDefault(labelOpts.fontStyle, globalDefault.defaultFontStyle);
				var fontFamily = valueOrDefault(labelOpts.fontFamily, globalDefault.defaultFontFamily);
				var labelFont = helpers$4.fontString(fontSize, fontStyle, fontFamily);
				var cursor;

				// Canvas setup
				ctx.textAlign = 'left';
				ctx.textBaseline = 'middle';
				ctx.lineWidth = 0.5;
				ctx.strokeStyle = fontColor; // for strikethrough effect
				ctx.fillStyle = fontColor; // render in correct colour
				ctx.font = labelFont;

				var boxWidth = getBoxWidth(labelOpts, fontSize);
				var hitboxes = me.legendHitBoxes;

				// current position
				var drawLegendBox = function(x, y, legendItem) {
					if (isNaN(boxWidth) || boxWidth <= 0) {
						return;
					}

					// Set the ctx for the box
					ctx.save();

					ctx.fillStyle = valueOrDefault(legendItem.fillStyle, globalDefault.defaultColor);
					ctx.lineCap = valueOrDefault(legendItem.lineCap, lineDefault.borderCapStyle);
					ctx.lineDashOffset = valueOrDefault(legendItem.lineDashOffset, lineDefault.borderDashOffset);
					ctx.lineJoin = valueOrDefault(legendItem.lineJoin, lineDefault.borderJoinStyle);
					ctx.lineWidth = valueOrDefault(legendItem.lineWidth, lineDefault.borderWidth);
					ctx.strokeStyle = valueOrDefault(legendItem.strokeStyle, globalDefault.defaultColor);
					var isLineWidthZero = (valueOrDefault(legendItem.lineWidth, lineDefault.borderWidth) === 0);

					if (ctx.setLineDash) {
						// IE 9 and 10 do not support line dash
						ctx.setLineDash(valueOrDefault(legendItem.lineDash, lineDefault.borderDash));
					}

					if (opts.labels && opts.labels.usePointStyle) {
						// Recalculate x and y for drawPoint() because its expecting
						// x and y to be center of figure (instead of top left)
						var radius = fontSize * Math.SQRT2 / 2;
						var offSet = radius / Math.SQRT2;
						var centerX = x + offSet;
						var centerY = y + offSet;

						// Draw pointStyle as legend symbol
						helpers$4.canvas.drawPoint(ctx, legendItem.pointStyle, radius, centerX, centerY);
					} else {
						// Draw box as legend symbol
						if (!isLineWidthZero) {
							ctx.strokeRect(x, y, boxWidth, fontSize);
						}
						ctx.fillRect(x, y, boxWidth, fontSize);
					}

					ctx.restore();
				};
				var fillText = function(x, y, legendItem, textWidth) {
					var halfFontSize = fontSize / 2;
					var xLeft = boxWidth + halfFontSize + x;
					var yMiddle = y + halfFontSize;

					ctx.fillText(legendItem.text, xLeft, yMiddle);

					if (legendItem.hidden) {
						// Strikethrough the text if hidden
						ctx.beginPath();
						ctx.lineWidth = 2;
						ctx.moveTo(xLeft, yMiddle);
						ctx.lineTo(xLeft + textWidth, yMiddle);
						ctx.stroke();
					}
				};

				// Horizontal
				var isHorizontal = me.isHorizontal();
				if (isHorizontal) {
					cursor = {
						x: me.left + ((legendWidth - lineWidths[0]) / 2),
						y: me.top + labelOpts.padding,
						line: 0
					};
				} else {
					cursor = {
						x: me.left + labelOpts.padding,
						y: me.top + labelOpts.padding,
						line: 0
					};
				}

				var itemHeight = fontSize + labelOpts.padding;
				helpers$4.each(me.legendItems, function(legendItem, i) {
					var textWidth = ctx.measureText(legendItem.text).width;
					var width = boxWidth + (fontSize / 2) + textWidth;
					var x = cursor.x;
					var y = cursor.y;

					if (isHorizontal) {
						if (x + width >= legendWidth) {
							y = cursor.y += itemHeight;
							cursor.line++;
							x = cursor.x = me.left + ((legendWidth - lineWidths[cursor.line]) / 2);
						}
					} else if (y + itemHeight > me.bottom) {
						x = cursor.x = x + me.columnWidths[cursor.line] + labelOpts.padding;
						y = cursor.y = me.top + labelOpts.padding;
						cursor.line++;
					}

					drawLegendBox(x, y, legendItem);

					hitboxes[i].left = x;
					hitboxes[i].top = y;

					// Fill the actual label
					fillText(x, y, legendItem, textWidth);

					if (isHorizontal) {
						cursor.x += width + (labelOpts.padding);
					} else {
						cursor.y += itemHeight;
					}

				});
			}
		},

		/**
		 * Handle an event
		 * @private
		 * @param {IEvent} event - The event to handle
		 * @return {Boolean} true if a change occured
		 */
		handleEvent: function(e) {
			var me = this;
			var opts = me.options;
			var type = e.type === 'mouseup' ? 'click' : e.type;
			var changed = false;

			if (type === 'mousemove') {
				if (!opts.onHover) {
					return;
				}
			} else if (type === 'click') {
				if (!opts.onClick) {
					return;
				}
			} else {
				return;
			}

			// Chart event already has relative position in it
			var x = e.x;
			var y = e.y;

			if (x >= me.left && x <= me.right && y >= me.top && y <= me.bottom) {
				// See if we are touching one of the dataset boxes
				var lh = me.legendHitBoxes;
				for (var i = 0; i < lh.length; ++i) {
					var hitBox = lh[i];

					if (x >= hitBox.left && x <= hitBox.left + hitBox.width && y >= hitBox.top && y <= hitBox.top + hitBox.height) {
						// Touching an element
						if (type === 'click') {
							// use e.native for backwards compatibility
							opts.onClick.call(me, e.native, me.legendItems[i]);
							changed = true;
							break;
						} else if (type === 'mousemove') {
							// use e.native for backwards compatibility
							opts.onHover.call(me, e.native, me.legendItems[i]);
							changed = true;
							break;
						}
					}
				}
			}

			return changed;
		}
	});

	function createNewLegendAndAttach(chart, legendOpts) {
		var legend = new Legend({
			ctx: chart.ctx,
			options: legendOpts,
			chart: chart
		});

		layouts.configure(chart, legend, legendOpts);
		layouts.addBox(chart, legend);
		chart.legend = legend;
	}

	var plugin_legend = {
		id: 'legend',

		/**
		 * Backward compatibility: since 2.1.5, the legend is registered as a plugin, making
		 * Chart.Legend obsolete. To avoid a breaking change, we export the Legend as part of
		 * the plugin, which one will be re-exposed in the chart.js file.
		 * https://github.com/chartjs/Chart.js/pull/2640
		 * @private
		 */
		_element: Legend,

		beforeInit: function(chart) {
			var legendOpts = chart.options.legend;

			if (legendOpts) {
				createNewLegendAndAttach(chart, legendOpts);
			}
		},

		beforeUpdate: function(chart) {
			var legendOpts = chart.options.legend;
			var legend = chart.legend;

			if (legendOpts) {
				helpers$4.mergeIf(legendOpts, defaults$3.global.legend);

				if (legend) {
					layouts.configure(chart, legend, legendOpts);
					legend.options = legendOpts;
				} else {
					createNewLegendAndAttach(chart, legendOpts);
				}
			} else if (legend) {
				layouts.removeBox(chart, legend);
				delete chart.legend;
			}
		},

		afterEvent: function(chart, e) {
			var legend = chart.legend;
			if (legend) {
				legend.handleEvent(e);
			}
		}
	};
	var plugin_legend_1 = plugin_legend.id;
	var plugin_legend_2 = plugin_legend._element;
	var plugin_legend_3 = plugin_legend.beforeInit;
	var plugin_legend_4 = plugin_legend.beforeUpdate;
	var plugin_legend_5 = plugin_legend.afterEvent;

	var plugin_legend$1 = /*#__PURE__*/Object.freeze({
		default: plugin_legend,
		__moduleExports: plugin_legend,
		id: plugin_legend_1,
		_element: plugin_legend_2,
		beforeInit: plugin_legend_3,
		beforeUpdate: plugin_legend_4,
		afterEvent: plugin_legend_5
	});

	var noop$3 = helpers$4.noop;

	defaults$3._set('global', {
		title: {
			display: false,
			fontStyle: 'bold',
			fullWidth: true,
			lineHeight: 1.2,
			padding: 10,
			position: 'top',
			text: '',
			weight: 2000         // by default greater than legend (1000) to be above
		}
	});

	/**
	 * IMPORTANT: this class is exposed publicly as Chart.Legend, backward compatibility required!
	 */
	var Title = Element$1.extend({
		initialize: function(config) {
			var me = this;
			helpers$4.extend(me, config);

			// Contains hit boxes for each dataset (in dataset order)
			me.legendHitBoxes = [];
		},

		// These methods are ordered by lifecycle. Utilities then follow.

		beforeUpdate: noop$3,
		update: function(maxWidth, maxHeight, margins) {
			var me = this;

			// Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
			me.beforeUpdate();

			// Absorb the master measurements
			me.maxWidth = maxWidth;
			me.maxHeight = maxHeight;
			me.margins = margins;

			// Dimensions
			me.beforeSetDimensions();
			me.setDimensions();
			me.afterSetDimensions();
			// Labels
			me.beforeBuildLabels();
			me.buildLabels();
			me.afterBuildLabels();

			// Fit
			me.beforeFit();
			me.fit();
			me.afterFit();
			//
			me.afterUpdate();

			return me.minSize;

		},
		afterUpdate: noop$3,

		//

		beforeSetDimensions: noop$3,
		setDimensions: function() {
			var me = this;
			// Set the unconstrained dimension before label rotation
			if (me.isHorizontal()) {
				// Reset position before calculating rotation
				me.width = me.maxWidth;
				me.left = 0;
				me.right = me.width;
			} else {
				me.height = me.maxHeight;

				// Reset position before calculating rotation
				me.top = 0;
				me.bottom = me.height;
			}

			// Reset padding
			me.paddingLeft = 0;
			me.paddingTop = 0;
			me.paddingRight = 0;
			me.paddingBottom = 0;

			// Reset minSize
			me.minSize = {
				width: 0,
				height: 0
			};
		},
		afterSetDimensions: noop$3,

		//

		beforeBuildLabels: noop$3,
		buildLabels: noop$3,
		afterBuildLabels: noop$3,

		//

		beforeFit: noop$3,
		fit: function() {
			var me = this;
			var valueOrDefault = helpers$4.valueOrDefault;
			var opts = me.options;
			var display = opts.display;
			var fontSize = valueOrDefault(opts.fontSize, defaults$3.global.defaultFontSize);
			var minSize = me.minSize;
			var lineCount = helpers$4.isArray(opts.text) ? opts.text.length : 1;
			var lineHeight = helpers$4.options.toLineHeight(opts.lineHeight, fontSize);
			var textSize = display ? (lineCount * lineHeight) + (opts.padding * 2) : 0;

			if (me.isHorizontal()) {
				minSize.width = me.maxWidth; // fill all the width
				minSize.height = textSize;
			} else {
				minSize.width = textSize;
				minSize.height = me.maxHeight; // fill all the height
			}

			me.width = minSize.width;
			me.height = minSize.height;

		},
		afterFit: noop$3,

		// Shared Methods
		isHorizontal: function() {
			var pos = this.options.position;
			return pos === 'top' || pos === 'bottom';
		},

		// Actually draw the title block on the canvas
		draw: function() {
			var me = this;
			var ctx = me.ctx;
			var valueOrDefault = helpers$4.valueOrDefault;
			var opts = me.options;
			var globalDefaults = defaults$3.global;

			if (opts.display) {
				var fontSize = valueOrDefault(opts.fontSize, globalDefaults.defaultFontSize);
				var fontStyle = valueOrDefault(opts.fontStyle, globalDefaults.defaultFontStyle);
				var fontFamily = valueOrDefault(opts.fontFamily, globalDefaults.defaultFontFamily);
				var titleFont = helpers$4.fontString(fontSize, fontStyle, fontFamily);
				var lineHeight = helpers$4.options.toLineHeight(opts.lineHeight, fontSize);
				var offset = lineHeight / 2 + opts.padding;
				var rotation = 0;
				var top = me.top;
				var left = me.left;
				var bottom = me.bottom;
				var right = me.right;
				var maxWidth, titleX, titleY;

				ctx.fillStyle = valueOrDefault(opts.fontColor, globalDefaults.defaultFontColor); // render in correct colour
				ctx.font = titleFont;

				// Horizontal
				if (me.isHorizontal()) {
					titleX = left + ((right - left) / 2); // midpoint of the width
					titleY = top + offset;
					maxWidth = right - left;
				} else {
					titleX = opts.position === 'left' ? left + offset : right - offset;
					titleY = top + ((bottom - top) / 2);
					maxWidth = bottom - top;
					rotation = Math.PI * (opts.position === 'left' ? -0.5 : 0.5);
				}

				ctx.save();
				ctx.translate(titleX, titleY);
				ctx.rotate(rotation);
				ctx.textAlign = 'center';
				ctx.textBaseline = 'middle';

				var text = opts.text;
				if (helpers$4.isArray(text)) {
					var y = 0;
					for (var i = 0; i < text.length; ++i) {
						ctx.fillText(text[i], 0, y, maxWidth);
						y += lineHeight;
					}
				} else {
					ctx.fillText(text, 0, 0, maxWidth);
				}

				ctx.restore();
			}
		}
	});

	function createNewTitleBlockAndAttach(chart, titleOpts) {
		var title = new Title({
			ctx: chart.ctx,
			options: titleOpts,
			chart: chart
		});

		layouts.configure(chart, title, titleOpts);
		layouts.addBox(chart, title);
		chart.titleBlock = title;
	}

	var plugin_title = {
		id: 'title',

		/**
		 * Backward compatibility: since 2.1.5, the title is registered as a plugin, making
		 * Chart.Title obsolete. To avoid a breaking change, we export the Title as part of
		 * the plugin, which one will be re-exposed in the chart.js file.
		 * https://github.com/chartjs/Chart.js/pull/2640
		 * @private
		 */
		_element: Title,

		beforeInit: function(chart) {
			var titleOpts = chart.options.title;

			if (titleOpts) {
				createNewTitleBlockAndAttach(chart, titleOpts);
			}
		},

		beforeUpdate: function(chart) {
			var titleOpts = chart.options.title;
			var titleBlock = chart.titleBlock;

			if (titleOpts) {
				helpers$4.mergeIf(titleOpts, defaults$3.global.title);

				if (titleBlock) {
					layouts.configure(chart, titleBlock, titleOpts);
					titleBlock.options = titleOpts;
				} else {
					createNewTitleBlockAndAttach(chart, titleOpts);
				}
			} else if (titleBlock) {
				layouts.removeBox(chart, titleBlock);
				delete chart.titleBlock;
			}
		}
	};
	var plugin_title_1 = plugin_title.id;
	var plugin_title_2 = plugin_title._element;
	var plugin_title_3 = plugin_title.beforeInit;
	var plugin_title_4 = plugin_title.beforeUpdate;

	var plugin_title$1 = /*#__PURE__*/Object.freeze({
		default: plugin_title,
		__moduleExports: plugin_title,
		id: plugin_title_1,
		_element: plugin_title_2,
		beforeInit: plugin_title_3,
		beforeUpdate: plugin_title_4
	});

	var require$$0$7 = ( plugin_filler$1 && plugin_filler ) || plugin_filler$1;

	var require$$1$4 = ( plugin_legend$1 && plugin_legend ) || plugin_legend$1;

	var require$$2$2 = ( plugin_title$1 && plugin_title ) || plugin_title$1;

	var plugins$1 = {};
	var filler = require$$0$7;
	var legend = require$$1$4;
	var title = require$$2$2;
	plugins$1.filler = filler;
	plugins$1.legend = legend;
	plugins$1.title = title;

	var plugins$2 = /*#__PURE__*/Object.freeze({
		default: plugins$1,
		__moduleExports: plugins$1,
		filler: filler,
		legend: legend,
		title: title
	});

	var require$$0$8 = ( core$1 && core ) || core$1;

	var require$$2$3 = ( core_helpers$1 && core_helpers ) || core_helpers$1;

	var require$$16 = ( core_controller$1 && core_controller ) || core_controller$1;

	var require$$17 = ( core_datasetController$1 && core_datasetController ) || core_datasetController$1;

	var require$$18 = ( scale_linearbase$1 && scale_linearbase ) || scale_linearbase$1;

	var require$$19 = ( scale_category$1 && scale_category ) || scale_category$1;

	var require$$20 = ( scale_linear$1 && scale_linear ) || scale_linear$1;

	var require$$21 = ( scale_logarithmic$1 && scale_logarithmic ) || scale_logarithmic$1;

	var require$$22 = ( scale_radialLinear$1 && scale_radialLinear ) || scale_radialLinear$1;

	var require$$23 = ( scale_time$1 && scale_time ) || scale_time$1;

	var require$$24 = ( controller_bar$1 && controller_bar ) || controller_bar$1;

	var require$$25 = ( controller_bubble$1 && controller_bubble ) || controller_bubble$1;

	var require$$26 = ( controller_doughnut$1 && controller_doughnut ) || controller_doughnut$1;

	var require$$27 = ( controller_line$1 && controller_line ) || controller_line$1;

	var require$$28 = ( controller_polarArea$1 && controller_polarArea ) || controller_polarArea$1;

	var require$$29 = ( controller_radar$1 && controller_radar ) || controller_radar$1;

	var require$$30 = ( controller_scatter$1 && controller_scatter ) || controller_scatter$1;

	var require$$31 = ( Chart_Bar$1 && Chart_Bar ) || Chart_Bar$1;

	var require$$32 = ( Chart_Bubble$1 && Chart_Bubble ) || Chart_Bubble$1;

	var require$$33 = ( Chart_Doughnut$1 && Chart_Doughnut ) || Chart_Doughnut$1;

	var require$$34 = ( Chart_Line$1 && Chart_Line ) || Chart_Line$1;

	var require$$35 = ( Chart_PolarArea$1 && Chart_PolarArea ) || Chart_PolarArea$1;

	var require$$36 = ( Chart_Radar$1 && Chart_Radar ) || Chart_Radar$1;

	var require$$37 = ( Chart_Scatter$1 && Chart_Scatter ) || Chart_Scatter$1;

	var plugins$3 = ( plugins$2 && plugins$1 ) || plugins$2;

	/**
	 * @namespace Chart
	 */
	var Chart = require$$0$8();

	Chart.helpers = helpers$4;

	// @todo dispatch these helpers into appropriated helpers/helpers.* file and write unit tests!
	require$$2$3(Chart);

	Chart.Animation = Animation;
	Chart.animationService = animations;
	Chart.defaults = defaults$3;
	Chart.Element = Element$1;
	Chart.elements = elements$2;
	Chart.Interaction = Interaction;
	Chart.layouts = layouts;
	Chart.platform = platform$2;
	Chart.plugins = plugins;
	Chart.Scale = Scale;
	Chart.scaleService = scaleService;
	Chart.Ticks = Ticks;
	Chart.Tooltip = Tooltip;

	require$$16(Chart);
	require$$17(Chart);

	require$$18(Chart);
	require$$19(Chart);
	require$$20(Chart);
	require$$21(Chart);
	require$$22(Chart);
	require$$23(Chart);

	// Controllers must be loaded after elements
	// See Chart.core.datasetController.dataElementType
	require$$24(Chart);
	require$$25(Chart);
	require$$26(Chart);
	require$$27(Chart);
	require$$28(Chart);
	require$$29(Chart);
	require$$30(Chart);

	require$$31(Chart);
	require$$32(Chart);
	require$$33(Chart);
	require$$34(Chart);
	require$$35(Chart);
	require$$36(Chart);
	require$$37(Chart);

	// Loading built-in plugins

	for (var k in plugins$3) {
		if (plugins$3.hasOwnProperty(k)) {
			Chart.plugins.register(plugins$3[k]);
		}
	}

	Chart.platform.initialize();

	var chart = Chart;
	if (typeof window !== 'undefined') {
		window.Chart = Chart;
	}

	// DEPRECATIONS

	/**
	 * Provided for backward compatibility, not available anymore
	 * @namespace Chart.Legend
	 * @deprecated since version 2.1.5
	 * @todo remove at version 3
	 * @private
	 */
	Chart.Legend = plugins$3.legend._element;

	/**
	 * Provided for backward compatibility, not available anymore
	 * @namespace Chart.Title
	 * @deprecated since version 2.1.5
	 * @todo remove at version 3
	 * @private
	 */
	Chart.Title = plugins$3.title._element;

	/**
	 * Provided for backward compatibility, use Chart.plugins instead
	 * @namespace Chart.pluginService
	 * @deprecated since version 2.1.5
	 * @todo remove at version 3
	 * @private
	 */
	Chart.pluginService = Chart.plugins;

	/**
	 * Provided for backward compatibility, inheriting from Chart.PlugingBase has no
	 * effect, instead simply create/register plugins via plain JavaScript objects.
	 * @interface Chart.PluginBase
	 * @deprecated since version 2.5.0
	 * @todo remove at version 3
	 * @private
	 */
	Chart.PluginBase = Chart.Element.extend({});

	/**
	 * Provided for backward compatibility, use Chart.helpers.canvas instead.
	 * @namespace Chart.canvasHelpers
	 * @deprecated since version 2.6.0
	 * @todo remove at version 3
	 * @private
	 */
	Chart.canvasHelpers = Chart.helpers.canvas;

	/**
	 * Provided for backward compatibility, use Chart.layouts instead.
	 * @namespace Chart.layoutService
	 * @deprecated since version 2.8.0
	 * @todo remove at version 3
	 * @private
	 */
	Chart.layoutService = Chart.layouts;

	function dataHandler(newData, oldData) {
	  if (oldData) {
	    var chart = this.$data._chart;
	    var newDatasetLabels = newData.datasets.map(function (dataset) {
	      return dataset.label;
	    });
	    var oldDatasetLabels = oldData.datasets.map(function (dataset) {
	      return dataset.label;
	    });
	    var oldLabels = JSON.stringify(oldDatasetLabels);
	    var newLabels = JSON.stringify(newDatasetLabels);

	    if (newLabels === oldLabels && oldData.datasets.length === newData.datasets.length) {
	      newData.datasets.forEach(function (dataset, i) {
	        var oldDatasetKeys = Object.keys(oldData.datasets[i]);
	        var newDatasetKeys = Object.keys(dataset);
	        var deletionKeys = oldDatasetKeys.filter(function (key) {
	          return key !== '_meta' && newDatasetKeys.indexOf(key) === -1;
	        });
	        deletionKeys.forEach(function (deletionKey) {
	          delete chart.data.datasets[i][deletionKey];
	        });

	        for (var attribute in dataset) {
	          if (dataset.hasOwnProperty(attribute)) {
	            chart.data.datasets[i][attribute] = dataset[attribute];
	          }
	        }
	      });

	      if (newData.hasOwnProperty('labels')) {
	        chart.data.labels = newData.labels;
	        this.$emit('labels:update');
	      }

	      if (newData.hasOwnProperty('xLabels')) {
	        chart.data.xLabels = newData.xLabels;
	        this.$emit('xlabels:update');
	      }

	      if (newData.hasOwnProperty('yLabels')) {
	        chart.data.yLabels = newData.yLabels;
	        this.$emit('ylabels:update');
	      }

	      chart.update();
	      this.$emit('chart:update');
	    } else {
	      if (chart) {
	        chart.destroy();
	        this.$emit('chart:destroy');
	      }

	      this.renderChart(this.chartData, this.options);
	      this.$emit('chart:render');
	    }
	  } else {
	    if (this.$data._chart) {
	      this.$data._chart.destroy();

	      this.$emit('chart:destroy');
	    }

	    this.renderChart(this.chartData, this.options);
	    this.$emit('chart:render');
	  }
	}

	var reactiveData = {
	  data: function data() {
	    return {
	      chartData: null
	    };
	  },
	  watch: {
	    'chartData': dataHandler
	  }
	};
	var reactiveProp = {
	  props: {
	    chartData: {
	      required: true
	    }
	  },
	  watch: {
	    'chartData': dataHandler
	  }
	};
	var mixins = {
	  reactiveData: reactiveData,
	  reactiveProp: reactiveProp
	};

	function generateChart(chartId, chartType) {
	  return {
	    render: function render(createElement) {
	      return createElement('div', {
	        style: this.styles,
	        class: this.cssClasses
	      }, [createElement('canvas', {
	        attrs: {
	          id: this.chartId,
	          width: this.width,
	          height: this.height
	        },
	        ref: 'canvas'
	      })]);
	    },
	    props: {
	      chartId: {
	        default: chartId,
	        type: String
	      },
	      width: {
	        default: 400,
	        type: Number
	      },
	      height: {
	        default: 400,
	        type: Number
	      },
	      cssClasses: {
	        type: String,
	        default: ''
	      },
	      styles: {
	        type: Object
	      },
	      plugins: {
	        type: Array,
	        default: function _default() {
	          return [];
	        }
	      }
	    },
	    data: function data() {
	      return {
	        _chart: null,
	        _plugins: this.plugins
	      };
	    },
	    methods: {
	      addPlugin: function addPlugin(plugin) {
	        this.$data._plugins.push(plugin);
	      },
	      generateLegend: function generateLegend() {
	        if (this.$data._chart) {
	          return this.$data._chart.generateLegend();
	        }
	      },
	      renderChart: function renderChart(data, options) {
	        if (this.$data._chart) { this.$data._chart.destroy(); }
	        this.$data._chart = new chart(this.$refs.canvas.getContext('2d'), {
	          type: chartType,
	          data: data,
	          options: options,
	          plugins: this.$data._plugins
	        });
	      }
	    },
	    beforeDestroy: function beforeDestroy() {
	      if (this.$data._chart) {
	        this.$data._chart.destroy();
	      }
	    }
	  };
	}
	var Line$1 = generateChart('line-chart', 'line');

	var script$n = {
	  extends: Line$1,
	  mixins: [mixins.reactiveProp],
	  props: ['chartData', 'options'],
	  mounted: function mounted() {
	    this.renderChart(this.chartData || {}, this.options);
	  },
	};

	/* script */
	var __vue_script__$n = script$n;

	/* template */

	  /* style */
	  var __vue_inject_styles__$n = undefined;
	  /* scoped */
	  var __vue_scope_id__$n = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$n = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$n = undefined;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$n = /*#__PURE__*/normalizeComponent(
	    {},
	    __vue_inject_styles__$n,
	    __vue_script__$n,
	    __vue_scope_id__$n,
	    __vue_is_functional_template__$n,
	    __vue_module_identifier__$n,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//

	var script$o = {
	  props: {
	    title: String,
	    endpoint: String,
	    submitValue: String,
	    button: {
	      type: Boolean,
	      default: true,
	    },
	    canGoBack: {
	      type: Boolean,
	      default: false,
	    },
	    buttonDisabled: Boolean,
	    buttonText: String,
	    buttonTextSending: String,
	    buttonTextSent: String,
	    inputs: Array,
	    sendGuid: Boolean,
	    displayNavbar: Boolean,
	    canForget: Boolean,
	  },
	  data: function data() {
	    var self = this;
	    var hasEmalInput;
	    if (self.inputs) {
	      self.inputs.forEach(function (inputObj) {
	        if (inputObj.name === 'email') { hasEmalInput = true; }
	      });
	    }

	    var id = self.$f7route ? self.$f7route.query.id : null;
	    var storeForget = new Store(self, {
	      post: ['accounts', 'forget', { id: id }],
	    });
	    var debouncedAccountsRefresh = lodash.debounce(function () { return Brief$1.events.$emit('accounts-refresh'); }, 1000);
	    storeForget.on('postFinished', function () {
	      debouncedAccountsRefresh();
	      Brief$1.viewMain.router.navigate('/');
	    });
	    return {
	      storeForget: storeForget,
	      device_id: window.localStorage.getItem('device_id') || Utils$1.getDeviceId(),
	      email: window.localStorage.getItem('user_email') || '',
	      isLoading: false,
	      error: false,
	      state: 'init',
	      hasEmalInput: hasEmalInput,
	      allInputs: [],
	      teams: [],
	      teamId: null,
	      forgetInProgress: false,
	    };
	  },
	  computed: {
	    buttonTextComputed: function buttonTextComputed() {
	      var self = this;
	      var text = '';
	      if (self.state === 'init') {
	        text = self.buttonText;
	      } else if (self.state === 'sending') {
	        text = self.buttonTextSending;
	      } else if (self.state === 'sent') {
	        text = self.buttonTextSending;
	      } else if (self.state === 'error') {
	        text = 'Failed';
	      }
	      return text;
	    },
	  },
	  mounted: function mounted() {
	    var self = this;
	    if (self.hasEmalInput) {
	      $$1(self.$el).find('input[name="email"]').val(self.email);
	    }
	    $$1(self.$el).find('input, textarea').on('change input', function () {
	      Brief$1.closeNotification();
	    });
	    setTimeout(function () {
	      if (!self.allInputs || self.allInputs.length === 0) {
	        self.allInputs = self.inputs;
	      }

	      if (!Brief$1.isCordova && self.allInputs.length > 0) {
	        self.focusInput();
	      }
	    }, 400);
	    if (Brief$1.isCordova) {
	      Brief$1.events.$on('splashscreen:hidden', function () {
	        self.splashscreenHidden = true;
	        self.focusInput();
	      });
	    }
	    $$1('#app').addClass('no-widget');
	  },
	  beforeDestroy: function beforeDestroy() {
	    $$1('#app').removeClass('no-widget');
	  },
	  methods: {
	    focusInput: function focusInput() {
	      if (!self.allInputs || self.allInputs.length === 0) {
	        return;
	      }
	      var name = self.allInputs[0].name;
	      $$1(self.$el).find(("input[name=\"" + name + "\"]")).focus();
	    },
	    pageAfterIn: function pageAfterIn() {
	      var self = this;
	      if (self.allInputs && self.allInputs.length > 0) {
	        return;
	      }
	      setTimeout(function () {
	        self.allInputs = self.inputs;
	        if (self.splashscreenHidden) {
	          self.focusInput();
	        }
	        setTimeout(function () {
	          if (self.hasEmalInput) {
	            self.email = window.localStorage.getItem('user_email') || '';
	            $$1(self.$el).find('input[name="email"]').val(self.email);
	          }
	        }, 100);
	      }, 300);
	    },
	    onInput: function onInput(name, value) {
	      var self = this;
	      if (name === 'email') { self.email = value; }
	      self.$emit((name + "Change"), value);
	    },
	    submit: function submit() {
	      $$1(this.$el).find('form').trigger('submit');
	    },
	    goBack: function goBack() {
	      if (!Brief$1.isCordova) {
	        window.history.replaceState({}, '', '/');
	      }
	      this.$nextTick(function () {
	        Brief$1.cancelAddAccount();
	      });
	    },
	    onTeamSelect: function onTeamSelect(team) {
	      this.teamId = team.id;
	      $$1(this.$el).find('form').trigger('submit');
	    },
	    forgetTeam: function forgetTeam() {
	      var self = this;
	      self.forgetInProgress = true;
	      self.storeForget.post();
	    },
	    onSubmit: function onSubmit(e) {
	      var self = this;
	      e.preventDefault();

	      self.state = 'sending';
	      self.isLoading = true;

	      Brief$1.closeNotification();

	      var form = $$1(e.target);
	      var formData = Brief$1.f7.form.convertToData(form);
	      formData.teamId = self.teamId;

	      if (self.sendGuid)
	        { formData.guid = getGuidFromPath(); }
	      
	      var accounts = JSON.parse(window.localStorage.getItem('accounts') || '[]');
	      if (accounts.length > 0)
	        { formData.accountFromGroupId = accounts[0].userId; }

	      function getGuidFromPath() {
	        if (self.$f7route.params && self.$f7route.params.length)
	          { return self.$f7route.params[0]; }
	        return getLastFromPath(Brief$1.viewLogin.router.currentRoute.path);
	      }

	      function getLastFromPath(path) {
	        var urlParts = path.split('/').filter(function (c) { return c; });
	        return urlParts[urlParts.length - 1];
	      }

	      Brief$1.f7.request({
	        url: Brief$1.api + self.endpoint,
	        method: 'post',
	        data: formData,
	        dataType: 'json',
	        success: function success(result) {
	          var data = result.data;
	          if (result.success) {
	            if (data.teams) {
	              self.teams = data.teams;
	            } else {
	              self.teams = [];
	              self.teamId = null;
	              self.state = 'sent';
	              if (self.hasEmalInput) {
	                window.localStorage.setItem('user_email', formData.email || '');
	              }
	              if (data.Message) {
	                Brief$1.alert(data.Message, 'Success');
	              }
	              self.$emit('success', data);
	            }
	          } else {
	            self.state = 'error';
	            self.teams = [];
	            self.teamId = null;
	            self.error = true;
	            self.isLoading = false;
	            setTimeout(function () {
	              self.error = false;
	              self.state = 'init';
	            }, 2000);
	            if (data.Message) {
	              Brief$1.alert(data.Message, 'Error');
	            }
	            self.$emit('error', formData);
	          }
	        },
	        error: function error() {
	          self.state = 'error';
	          self.error = true;
	          self.isLoading = false;
	          self.teams = [];
	          self.teamId = null;
	          setTimeout(function () {
	            self.error = false;
	            self.state = 'init';
	          }, 2000);
	          Brief$1.alert('Error occured, try again later', 'Error');
	          self.$emit('error', formData);
	        },
	      });
	    },
	  },
	};

	/* script */
	var __vue_script__$o = script$o;

	/* template */
	var __vue_render__$l = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f7-page',{attrs:{"login-screen":""},on:{"page:afterin":_vm.pageAfterIn}},[(_vm.displayNavbar)?_c('common-navbar',{attrs:{"title":_vm.title,"root":true}}):_vm._e(),_vm._v(" "),_c('form',{attrs:{"method":"post"},on:{"submit":_vm.onSubmit}},[_c('input',{attrs:{"id":"device-id","type":"hidden","name":"device_id"},domProps:{"value":_vm.device_id}}),_vm._v(" "),_c('div',{staticClass:"login-screen-title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),(_vm.allInputs)?_c('div',{staticClass:"list inset"},[_c('ul',[_vm._l((_vm.allInputs),function(input,index){return _c('li',{staticClass:"item-content item-input"},[_c('div',{staticClass:"item-inner"},[_c('div',{staticClass:"item-input-wrap"},[_c('input',{attrs:{"type":input.type,"name":input.name,"placeholder":input.placeholder,"autocomplete":"new-password","required":""},on:{"input":function($event){return _vm.onInput(input.name, $event.target.value)}}})])])])}),_vm._v(" "),_vm._t("before-button"),_vm._v(" "),_vm._t("privacy-policy"),_vm._v(" "),(_vm.teams.length > 0)?_c('f7-block-title',[_vm._v("Select your Team")]):_vm._e(),_vm._v(" "),_vm._l((_vm.teams),function(team){return _c('f7-list-item',{attrs:{"title":team.name},on:{"click":function($event){return _vm.onTeamSelect(team)}}})})],2)]):_vm._e(),_vm._v(" "),(_vm.button && _vm.teams.length === 0)?_c('f7-block',[_c('f7-button',{class:{ disabled: _vm.isLoading || _vm.error || _vm.buttonDisabled, errored: _vm.error },attrs:{"big":"","fill":"","href":"#"},on:{"click":_vm.submit}},[(!_vm.isLoading)?_c('span',[_vm._v(_vm._s(_vm.buttonTextComputed))]):_vm._e(),_vm._v(" "),(_vm.isLoading)?_c('f7-preloader',{attrs:{"color":"white"}}):_vm._e()],1)],1):_vm._e(),_vm._v(" "),(_vm.canGoBack)?_c('f7-block',[_c('f7-button',{attrs:{"big":"","href":"#"},on:{"click":_vm.goBack}},[_vm._v(_vm._s(_vm.Back))])],1):_vm._e(),_vm._v(" "),(_vm.$slots.footer)?_c('div',{staticClass:"block-footer margin-top text-align-center"},[_vm._t("footer")],2):_vm._e(),_vm._v(" "),_c('input',{staticStyle:{"display":"none"},attrs:{"type":"submit"},domProps:{"value":_vm.buttonText}}),_vm._v(" "),(_vm.canForget)?_c('f7-list',[_c('f7-list-button',{on:{"click":_vm.forgetTeam}},[_vm._v(_vm._s(_vm.forgetInProgress ? 'Forget in progress...' : 'Forget this team')+" "),(_vm.forgetInProgress)?_c('span',{staticClass:"spinner"}):_vm._e()])],1):_vm._e()],1)],1)};
	var __vue_staticRenderFns__$l = [];

	  /* style */
	  var __vue_inject_styles__$o = undefined;
	  /* scoped */
	  var __vue_scope_id__$o = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$o = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$o = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$o = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$l, staticRenderFns: __vue_staticRenderFns__$l },
	    __vue_inject_styles__$o,
	    __vue_script__$o,
	    __vue_scope_id__$o,
	    __vue_is_functional_template__$o,
	    __vue_module_identifier__$o,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//

	function calculateImageSize() {
	  return Brief$1.f7.device.pixelRatio > 1 ? '400' : '200';
	}

	var script$p = {
	  props: {
	    id: String,
	    type: String,
	    contactType: String,
	  },
	  data: function data() {
	    var self = this;

	    var store;
	    var storeDelete;
	    var storeChat;
	    var storeDeleteUser;
	    var storeGetChannels;

	    if (self.type === 'user') {
	      store = new Store(self, {
	        get: ['user', 'get', { userId: self.id }],
	      });
	      storeChat = new Store(self, {
	        postNow: ['privatechannel', 'create', { peerUserId: self.id }],
	        postNowFinished: function postNowFinished(result) {
	          if (result.success) {
	            Brief$1.f7.panel.close('right');
	            Brief$1.viewMain.router.reloadFromStart(("/room/" + (result.data.id) + "/"));
	          }
	        },
	      });
	      storeDeleteUser = new Store(self, {
	        post: ['teamuser', 'delete', {
	          id: self.id,
	        }],
	        postFinished: function postFinished(result) {
	          self.deleteUserInProgress = false;
	          if (result.success) {
	            // Brief.events.$emit('contacts-removed', result.data);
	            Brief$1.viewRight.router.back();
	          }
	        },
	      });
	    } else {
	      store = new Store(self, {
	        get: ['contact', 'detail', {
	          contactId: self.id,
	          contactType: self.contactType,
	        }],
	        getFinished: function getFinished() {
	          self.selectedTags = (self.store.tags || []).map(function (tag) { return ({ name: tag }); });
	        },
	        postNow: ['contact', 'update', {
	          contactId: self.id,
	          contactType: self.contactType,
	        }, true],
	        postNowFinished: function postNowFinished(result) {
	          self.saveInProgress = false;
	          if (result.success) {
	            Brief$1.events.$emit('contacts-updated', result.data);
	            Brief$1.viewRight.router.back();
	          }
	        },
	      });
	      storeDelete = new Store(self, {
	        post: ['contact', 'delete', {
	          id: self.id,
	          contactType: self.contactType,
	        }],
	        postFinished: function postFinished(result) {
	          self.deleteInProgress = false;
	          if (result.success) {
	            Brief$1.events.$emit('contacts-removed', result.data);
	            Brief$1.viewRight.router.back();
	          }
	        },
	      });
	      storeGetChannels = new Store(self, {
	        get: ['user', 'channels', {
	          contactType: self.contactType,
	        }],
	      });
	    }

	    gtag('event', 'user_details', {
	      event_category: 'page',
	      event_label: 'Open user details',
	    });

	    return {
	      store: store,
	      storeDelete: storeDelete,
	      storeGetChannels: storeGetChannels,
	      storeDeleteUser: storeDeleteUser,
	      storeChat: storeChat,
	      selectedTags: [],
	      saveInProgress: false,
	      hashTagSearch: true,
	      query: '',
	      deleteInProgress: false,
	      deleteUserInProgress: false
	    };
	  },
	  computed: {
	    photoUrl: function photoUrl() {
	      var self = this;
	      var imageSize = calculateImageSize();
	      if (self.type === 'user') {
	        return self.path.imageUrl(
	          self.store.photoFile ? self.store.photoFile.filename : 'avatar.png',
	          ("h=" + imageSize + "&autorotate=true")
	        );
	      } else if ((self.contactType === 'facebook' || self.contactType === 'facebookContact') && self.store.email) {
	        return ((this.domain) + "/api/facebook/picture?id=" + (self.store.email.replace('@facebook.com', '')) + "&channelId=" + (self.store.channelId || '') + "&height=" + imageSize);
	      } else if (self.contactType === 'instagramContact' && self.store.avatarUrl) {
	        return self.store.avatarUrl;
	      } else if (self.contactType === 'websiteContact' && self.store.avatarUrl) {
	        return self.store.avatarUrl;
	      }
	      return self.path.imageUrl('avatar.png', ("h=" + imageSize + "&autorotate=true"));
	    },
	    isTeamOwner: function isTeamOwner() {
	      var self = this;
	      var loggedInUser = self.$root.loggedInUser;
	      if(self.type === 'user' && loggedInUser.isAdmin) {
	        return true
	      }
	      return false
	    },
	    lastActiveString: function lastActiveString() {
	      var self = this;
	      var s = '';
	      if (self.store.lastActive) {
	        var minsDiff = (new Date() - new Date(self.store.lastActive)) / 1000 / 60;
	        if (minsDiff < 2) {
	          s = 'Online';
	        } else {
	          s = 'Last seen ' + hooks$1(self.store.lastActive).locale('en').fromNow();
	        }
	      }
	      return s;
	    },
	  },
	  mounted: function mounted() {
	    var self = this;
	    if (self.id) {
	      self.store.get();
	    } else {
	      self.store = self.$root.loggedInUser;
	    }
	    if (self.type !== 'user') {
	      self.storeGetChannels.get();
	    }

	  },
	  methods: {
	    directMessage: function directMessage() {
	      var self = this;
	      self.storeChat.postNow();
	    },
	    openNotes: function openNotes() {
	      var self = this;
	      Brief$1.f7.panel.open('right');
	      Brief$1.viewRight.router.navigate(("/notes/" + (self.id) + "/"));
	    },
	    openConversations: function openConversations(channel) {
	      var self = this;
	      console.log(channel);
	      Brief$1.viewMain.router.reloadFromStart(("/" + (channel.type) + "/" + (channel.id) + "/?contactId=" + (self.id)));
	    },
	    save: function save() {
	      var self = this;
	      if (self.saveInProgress) { return; }
	      if (!Utils$1.isEmail(self.store.email)) {
	        Brief$1.notify('Error!', 'Invalid email address');
	        return;
	      }
	      self.saveInProgress = true;
	      self.store.tags = self.selectedTags.map(function (tag) { return tag.name; });
	      self.store.postNow();
	    },
	    deleteContact: function deleteContact() {
	      var self = this;
	      Brief$1.f7.dialog.confirm('Are you sure?', 'Deleting contact', function () {
	        self.deleteInProgress = true;
	        self.storeDelete.post();
	      });
	    },
	    deleteUser: function deleteUser() {
	      var self = this;
	      Brief$1.f7.dialog.confirm('Are you sure?', 'Deleting user', function () {
	        self.deleteUserInProgress = true;
	        self.storeDeleteUser.post();
	      });
	    },
	    onHashTagSearchChange: function onHashTagSearchChange(value) {
	      this.hashTagSearch = value;
	    },
	    onSelectedItemsAdd: function onSelectedItemsAdd(newItem) {
	      this.selectedTags.push(newItem);
	    },
	    onSelectedItemsRemove: function onSelectedItemsRemove(index) {
	      this.selectedTags.splice(index, 1);
	    },
	    onQueryChange: function onQueryChange(query) {
	      this.query = query;
	    },
	  },
	  beforeDestroy: function beforeDestroy() {
	    var self = this;
	    if (self.id) { self.store.dispose(); }
	    if (self.storeDelete) { self.storeDelete.dispose(); }
	    if (self.storeGetChannels) { self.storeGetChannels.dispose(); }
	    if(self.storeDeleteUser) { self.storeDeleteUser.dispose(); }
	  },
	};

	/* script */
	var __vue_script__$p = script$p;

	/* template */
	var __vue_render__$m = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f7-page',{staticClass:"page-user-view",attrs:{"name":"page-user-details"}},[_c('common-navbar',{attrs:{"title":"Details"}}),_vm._v(" "),(!_vm.store.isLoading)?[_c('f7-block',{staticClass:"user-photo-container"},[_c('span',{staticClass:"user-photo-image",style:('background-image: url(' + _vm.photoUrl + ')')})]),_vm._v(" "),(_vm.type === 'user')?[(_vm.type === 'user')?_c('f7-list',{staticClass:"user-details"},[_c('f7-list-item',{attrs:{"title":_vm.store.firstName}}),_vm._v(" "),_c('f7-list-item',{attrs:{"title":_vm.store.lastName}}),_vm._v(" "),_c('f7-list-item',{attrs:{"title":_vm.store.email}}),_vm._v(" "),(_vm.store.title)?_c('f7-list-item',{attrs:{"title":_vm.store.title}}):_vm._e(),_vm._v(" "),(_vm.store.isTeamOwner)?_c('f7-list-item',{staticStyle:{"color":"green"},attrs:{"title":"Team Admin"}}):_vm._e(),_vm._v(" "),(_vm.lastActiveString)?_c('f7-list-item',{attrs:{"title":_vm.lastActiveString}}):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.store.id && _vm.$root.loggedInUser.plan.name !== 'Base')?_c('f7-list',[_c('f7-list-button',{staticClass:"text-align-center",on:{"click":_vm.directMessage}},[_vm._v("Direct message")])],1):_vm._e(),_vm._v(" "),(_vm.isTeamOwner)?_c('f7-list',[_c('f7-list-button',{staticClass:"text-align-center",attrs:{"color":"red"},on:{"click":_vm.deleteUser}},[_vm._v(_vm._s(_vm.deleteUserInProgress ? 'Deleting...' : 'Delete user')+" "),(_vm.deleteUserInProgress)?_c('span',{staticClass:"spinner"}):_vm._e()])],1):_vm._e()]:[_c('f7-list',[_c('f7-list-item',{attrs:{"item-input":""}},[_c('f7-input',{attrs:{"type":"text","placeholder":"Firstname","value":_vm.store.firstName},on:{"input":function($event){_vm.store.firstName = $event.target.value;}}})],1),_vm._v(" "),_c('f7-list-item',{attrs:{"item-input":""}},[_c('f7-input',{attrs:{"type":"text","placeholder":"Lastname","value":_vm.store.lastName},on:{"input":function($event){_vm.store.lastName = $event.target.value;}}})],1),_vm._v(" "),_c('f7-list-item',{attrs:{"item-input":""}},[_c('f7-input',{attrs:{"type":"text","placeholder":"Email","value":_vm.store.email},on:{"input":function($event){_vm.store.email = $event.target.value;}}})],1)],1),_vm._v(" "),_c('f7-list',[_c('f7-list-button',{staticClass:"text-align-center",on:{"click":function($event){return _vm.openNotes()}}},[_vm._v("Open Notes")])],1),_vm._v(" "),_c('f7-list',_vm._l((_vm.storeGetChannels.channels),function(channel){return _c('f7-list-button',{key:channel.id,staticClass:"text-align-center",on:{"click":function($event){return _vm.openConversations(channel)}}},[_vm._v("Open "+_vm._s(channel.name)+" Conversations")])}),1),_vm._v(" "),_c('common-search',{staticClass:"contact-tags-search",attrs:{"title":"Add tag","name":"#","hash-tag-search":true,"selected-items":_vm.selectedTags,"query":_vm.query,"enable-tag-saving":true,"search-icon":false},on:{"hashtagsearchchange":_vm.onHashTagSearchChange,"selecteditems:add":_vm.onSelectedItemsAdd,"selecteditems:remove":_vm.onSelectedItemsRemove,"querychange":_vm.onQueryChange}}),_vm._v(" "),_c('f7-list',[_c('f7-list-button',{on:{"click":_vm.save}},[(!_vm.saveInProgress)?_c('span',[_vm._v("Save")]):_vm._e(),_vm._v(" "),(_vm.saveInProgress)?_c('span',{staticClass:"spinner"}):_vm._e()])],1),_vm._v(" "),_c('f7-list',[_c('f7-list-button',{attrs:{"color":"red"},on:{"click":_vm.deleteContact}},[(!_vm.deleteInProgress)?_c('span',[_vm._v("Delete contact")]):_vm._e(),_vm._v(" "),(_vm.deleteInProgress)?_c('span',{staticClass:"spinner"}):_vm._e()])],1)]]:_c('div',{staticClass:"infinite-scroll-preloader"},[_c('f7-preloader')],1)],2)};
	var __vue_staticRenderFns__$m = [];

	  /* style */
	  var __vue_inject_styles__$p = undefined;
	  /* scoped */
	  var __vue_scope_id__$p = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$p = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$p = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$p = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$m, staticRenderFns: __vue_staticRenderFns__$m },
	    __vue_inject_styles__$p,
	    __vue_script__$p,
	    __vue_scope_id__$p,
	    __vue_is_functional_template__$p,
	    __vue_module_identifier__$p,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	/**
	 * Checks if `value` is `undefined`.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	 * @example
	 *
	 * _.isUndefined(void 0);
	 * // => true
	 *
	 * _.isUndefined(null);
	 * // => false
	 */
	function isUndefined$2(value) {
	  return value === undefined;
	}

	var isUndefined_1 = isUndefined$2;

	/**
	 * The base implementation of methods like `_.findKey` and `_.findLastKey`,
	 * without support for iteratee shorthands, which iterates over `collection`
	 * using `eachFunc`.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to inspect.
	 * @param {Function} predicate The function invoked per iteration.
	 * @param {Function} eachFunc The function to iterate over `collection`.
	 * @returns {*} Returns the found element or its key, else `undefined`.
	 */
	function baseFindKey(collection, predicate, eachFunc) {
	  var result;
	  eachFunc(collection, function(value, key, collection) {
	    if (predicate(value, key, collection)) {
	      result = key;
	      return false;
	    }
	  });
	  return result;
	}

	var _baseFindKey = baseFindKey;

	var _baseFindKey$1 = /*#__PURE__*/Object.freeze({
		default: _baseFindKey,
		__moduleExports: _baseFindKey
	});

	/**
	 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var index = -1,
	        iterable = Object(object),
	        props = keysFunc(object),
	        length = props.length;

	    while (length--) {
	      var key = props[fromRight ? length : ++index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}

	var _createBaseFor = createBaseFor;

	var _createBaseFor$1 = /*#__PURE__*/Object.freeze({
		default: _createBaseFor,
		__moduleExports: _createBaseFor
	});

	var createBaseFor$1 = ( _createBaseFor$1 && _createBaseFor ) || _createBaseFor$1;

	/**
	 * The base implementation of `baseForOwn` which iterates over `object`
	 * properties returned by `keysFunc` and invokes `iteratee` for each property.
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor$1();

	var _baseFor = baseFor;

	var _baseFor$1 = /*#__PURE__*/Object.freeze({
		default: _baseFor,
		__moduleExports: _baseFor
	});

	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);

	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}

	var _baseTimes = baseTimes;

	var _baseTimes$1 = /*#__PURE__*/Object.freeze({
		default: _baseTimes,
		__moduleExports: _baseTimes
	});

	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]';

	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */
	function baseIsArguments(value) {
	  return isObjectLike$2(value) && baseGetTag$1(value) == argsTag;
	}

	var _baseIsArguments = baseIsArguments;

	var _baseIsArguments$1 = /*#__PURE__*/Object.freeze({
		default: _baseIsArguments,
		__moduleExports: _baseIsArguments
	});

	var baseIsArguments$1 = ( _baseIsArguments$1 && _baseIsArguments ) || _baseIsArguments$1;

	/** Used for built-in method references. */
	var objectProto$2 = Object.prototype;

	/** Used to check objects for own properties. */
	var hasOwnProperty$2 = objectProto$2.hasOwnProperty;

	/** Built-in value references. */
	var propertyIsEnumerable = objectProto$2.propertyIsEnumerable;

	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	var isArguments = baseIsArguments$1(function() { return arguments; }()) ? baseIsArguments$1 : function(value) {
	  return isObjectLike$2(value) && hasOwnProperty$2.call(value, 'callee') &&
	    !propertyIsEnumerable.call(value, 'callee');
	};

	var isArguments_1 = isArguments;

	var isArguments$1 = /*#__PURE__*/Object.freeze({
		default: isArguments_1,
		__moduleExports: isArguments_1
	});

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray$4 = Array.isArray;

	var isArray_1 = isArray$4;

	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}

	var stubFalse_1 = stubFalse;

	var stubFalse$1 = /*#__PURE__*/Object.freeze({
		default: stubFalse_1,
		__moduleExports: stubFalse_1
	});

	var stubFalse$2 = ( stubFalse$1 && stubFalse_1 ) || stubFalse$1;

	var isBuffer_1 = createCommonjsModule(function (module, exports) {
	/** Detect free variable `exports`. */
	var freeExports = exports && !exports.nodeType && exports;

	/** Detect free variable `module`. */
	var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;

	/** Built-in value references. */
	var Buffer = moduleExports ? root$1.Buffer : undefined;

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse$2;

	module.exports = isBuffer;
	});

	var isBuffer$2 = /*#__PURE__*/Object.freeze({
		default: isBuffer_1,
		__moduleExports: isBuffer_1
	});

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;

	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;

	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  var type = typeof value;
	  length = length == null ? MAX_SAFE_INTEGER : length;

	  return !!length &&
	    (type == 'number' ||
	      (type != 'symbol' && reIsUint.test(value))) &&
	        (value > -1 && value % 1 == 0 && value < length);
	}

	var _isIndex = isIndex;

	var _isIndex$1 = /*#__PURE__*/Object.freeze({
		default: _isIndex,
		__moduleExports: _isIndex
	});

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER$1 = 9007199254740991;

	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER$1;
	}

	var isLength_1 = isLength;

	var isLength$1 = /*#__PURE__*/Object.freeze({
		default: isLength_1,
		__moduleExports: isLength_1
	});

	var isLength$2 = ( isLength$1 && isLength_1 ) || isLength$1;

	/** `Object#toString` result references. */
	var argsTag$1 = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';

	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';

	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag$1] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;

	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike$2(value) &&
	    isLength$2(value.length) && !!typedArrayTags[baseGetTag$1(value)];
	}

	var _baseIsTypedArray = baseIsTypedArray;

	var _baseIsTypedArray$1 = /*#__PURE__*/Object.freeze({
		default: _baseIsTypedArray,
		__moduleExports: _baseIsTypedArray
	});

	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}

	var _baseUnary = baseUnary;

	var _baseUnary$1 = /*#__PURE__*/Object.freeze({
		default: _baseUnary,
		__moduleExports: _baseUnary
	});

	var _nodeUtil = createCommonjsModule(function (module, exports) {
	/** Detect free variable `exports`. */
	var freeExports = exports && !exports.nodeType && exports;

	/** Detect free variable `module`. */
	var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;

	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal$1.process;

	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    // Use `util.types` for Node.js 10+.
	    var types = freeModule && freeModule.require && freeModule.require('util').types;

	    if (types) {
	      return types;
	    }

	    // Legacy `process.binding('util')` for Node.js < 10.
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());

	module.exports = nodeUtil;
	});

	var _nodeUtil$1 = /*#__PURE__*/Object.freeze({
		default: _nodeUtil,
		__moduleExports: _nodeUtil
	});

	var baseIsTypedArray$1 = ( _baseIsTypedArray$1 && _baseIsTypedArray ) || _baseIsTypedArray$1;

	var baseUnary$1 = ( _baseUnary$1 && _baseUnary ) || _baseUnary$1;

	var nodeUtil = ( _nodeUtil$1 && _nodeUtil ) || _nodeUtil$1;

	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary$1(nodeIsTypedArray) : baseIsTypedArray$1;

	var isTypedArray_1 = isTypedArray;

	var isTypedArray$1 = /*#__PURE__*/Object.freeze({
		default: isTypedArray_1,
		__moduleExports: isTypedArray_1
	});

	var baseTimes$1 = ( _baseTimes$1 && _baseTimes ) || _baseTimes$1;

	var isArguments$2 = ( isArguments$1 && isArguments_1 ) || isArguments$1;

	var isBuffer$3 = ( isBuffer$2 && isBuffer_1 ) || isBuffer$2;

	var isIndex$1 = ( _isIndex$1 && _isIndex ) || _isIndex$1;

	var isTypedArray$2 = ( isTypedArray$1 && isTypedArray_1 ) || isTypedArray$1;

	/** Used for built-in method references. */
	var objectProto$3 = Object.prototype;

	/** Used to check objects for own properties. */
	var hasOwnProperty$3 = objectProto$3.hasOwnProperty;

	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  var isArr = isArray_1(value),
	      isArg = !isArr && isArguments$2(value),
	      isBuff = !isArr && !isArg && isBuffer$3(value),
	      isType = !isArr && !isArg && !isBuff && isTypedArray$2(value),
	      skipIndexes = isArr || isArg || isBuff || isType,
	      result = skipIndexes ? baseTimes$1(value.length, String) : [],
	      length = result.length;

	  for (var key in value) {
	    if ((inherited || hasOwnProperty$3.call(value, key)) &&
	        !(skipIndexes && (
	           // Safari 9 has enumerable `arguments.length` in strict mode.
	           key == 'length' ||
	           // Node.js 0.10 has enumerable non-index properties on buffers.
	           (isBuff && (key == 'offset' || key == 'parent')) ||
	           // PhantomJS 2 has enumerable non-index properties on typed arrays.
	           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	           // Skip index properties.
	           isIndex$1(key, length)
	        ))) {
	      result.push(key);
	    }
	  }
	  return result;
	}

	var _arrayLikeKeys = arrayLikeKeys;

	var _arrayLikeKeys$1 = /*#__PURE__*/Object.freeze({
		default: _arrayLikeKeys,
		__moduleExports: _arrayLikeKeys
	});

	/** Used for built-in method references. */
	var objectProto$4 = Object.prototype;

	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto$4;

	  return value === proto;
	}

	var _isPrototype = isPrototype;

	var _isPrototype$1 = /*#__PURE__*/Object.freeze({
		default: _isPrototype,
		__moduleExports: _isPrototype
	});

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}

	var _overArg = overArg;

	var _overArg$1 = /*#__PURE__*/Object.freeze({
		default: _overArg,
		__moduleExports: _overArg
	});

	var overArg$1 = ( _overArg$1 && _overArg ) || _overArg$1;

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = overArg$1(Object.keys, Object);

	var _nativeKeys = nativeKeys;

	var _nativeKeys$1 = /*#__PURE__*/Object.freeze({
		default: _nativeKeys,
		__moduleExports: _nativeKeys
	});

	var isPrototype$1 = ( _isPrototype$1 && _isPrototype ) || _isPrototype$1;

	var nativeKeys$1 = ( _nativeKeys$1 && _nativeKeys ) || _nativeKeys$1;

	/** Used for built-in method references. */
	var objectProto$5 = Object.prototype;

	/** Used to check objects for own properties. */
	var hasOwnProperty$4 = objectProto$5.hasOwnProperty;

	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype$1(object)) {
	    return nativeKeys$1(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty$4.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}

	var _baseKeys = baseKeys;

	var _baseKeys$1 = /*#__PURE__*/Object.freeze({
		default: _baseKeys,
		__moduleExports: _baseKeys
	});

	/** `Object#toString` result references. */
	var asyncTag = '[object AsyncFunction]',
	    funcTag$1 = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    proxyTag = '[object Proxy]';

	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction$3(value) {
	  if (!isObject$3(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag$1(value);
	  return tag == funcTag$1 || tag == genTag || tag == asyncTag || tag == proxyTag;
	}

	var isFunction_1 = isFunction$3;

	var isFunction$4 = /*#__PURE__*/Object.freeze({
		default: isFunction_1,
		__moduleExports: isFunction_1
	});

	var isFunction$5 = ( isFunction$4 && isFunction_1 ) || isFunction$4;

	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength$2(value.length) && !isFunction$5(value);
	}

	var isArrayLike_1 = isArrayLike;

	var isArrayLike$1 = /*#__PURE__*/Object.freeze({
		default: isArrayLike_1,
		__moduleExports: isArrayLike_1
	});

	var arrayLikeKeys$1 = ( _arrayLikeKeys$1 && _arrayLikeKeys ) || _arrayLikeKeys$1;

	var baseKeys$1 = ( _baseKeys$1 && _baseKeys ) || _baseKeys$1;

	var isArrayLike$2 = ( isArrayLike$1 && isArrayLike_1 ) || isArrayLike$1;

	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys$5(object) {
	  return isArrayLike$2(object) ? arrayLikeKeys$1(object) : baseKeys$1(object);
	}

	var keys_1 = keys$5;

	var keys$6 = /*#__PURE__*/Object.freeze({
		default: keys_1,
		__moduleExports: keys_1
	});

	var baseFor$1 = ( _baseFor$1 && _baseFor ) || _baseFor$1;

	var keys$7 = ( keys$6 && keys_1 ) || keys$6;

	/**
	 * The base implementation of `_.forOwn` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForOwn(object, iteratee) {
	  return object && baseFor$1(object, iteratee, keys$7);
	}

	var _baseForOwn = baseForOwn;

	var _baseForOwn$1 = /*#__PURE__*/Object.freeze({
		default: _baseForOwn,
		__moduleExports: _baseForOwn
	});

	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	  this.size = 0;
	}

	var _listCacheClear = listCacheClear;

	var _listCacheClear$1 = /*#__PURE__*/Object.freeze({
		default: _listCacheClear,
		__moduleExports: _listCacheClear
	});

	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq$1(value, other) {
	  return value === other || (value !== value && other !== other);
	}

	var eq_1 = eq$1;

	var eq$2 = /*#__PURE__*/Object.freeze({
		default: eq_1,
		__moduleExports: eq_1
	});

	var eq$3 = ( eq$2 && eq_1 ) || eq$2;

	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq$3(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}

	var _assocIndexOf = assocIndexOf;

	var _assocIndexOf$1 = /*#__PURE__*/Object.freeze({
		default: _assocIndexOf,
		__moduleExports: _assocIndexOf
	});

	var assocIndexOf$1 = ( _assocIndexOf$1 && _assocIndexOf ) || _assocIndexOf$1;

	/** Used for built-in method references. */
	var arrayProto$1 = Array.prototype;

	/** Built-in value references. */
	var splice = arrayProto$1.splice;

	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf$1(data, key);

	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  --this.size;
	  return true;
	}

	var _listCacheDelete = listCacheDelete;

	var _listCacheDelete$1 = /*#__PURE__*/Object.freeze({
		default: _listCacheDelete,
		__moduleExports: _listCacheDelete
	});

	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf$1(data, key);

	  return index < 0 ? undefined : data[index][1];
	}

	var _listCacheGet = listCacheGet;

	var _listCacheGet$1 = /*#__PURE__*/Object.freeze({
		default: _listCacheGet,
		__moduleExports: _listCacheGet
	});

	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf$1(this.__data__, key) > -1;
	}

	var _listCacheHas = listCacheHas;

	var _listCacheHas$1 = /*#__PURE__*/Object.freeze({
		default: _listCacheHas,
		__moduleExports: _listCacheHas
	});

	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf$1(data, key);

	  if (index < 0) {
	    ++this.size;
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}

	var _listCacheSet = listCacheSet;

	var _listCacheSet$1 = /*#__PURE__*/Object.freeze({
		default: _listCacheSet,
		__moduleExports: _listCacheSet
	});

	var listCacheClear$1 = ( _listCacheClear$1 && _listCacheClear ) || _listCacheClear$1;

	var listCacheDelete$1 = ( _listCacheDelete$1 && _listCacheDelete ) || _listCacheDelete$1;

	var listCacheGet$1 = ( _listCacheGet$1 && _listCacheGet ) || _listCacheGet$1;

	var listCacheHas$1 = ( _listCacheHas$1 && _listCacheHas ) || _listCacheHas$1;

	var listCacheSet$1 = ( _listCacheSet$1 && _listCacheSet ) || _listCacheSet$1;

	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var this$1 = this;

	  var index = -1,
	      length = entries == null ? 0 : entries.length;

	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this$1.set(entry[0], entry[1]);
	  }
	}

	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear$1;
	ListCache.prototype['delete'] = listCacheDelete$1;
	ListCache.prototype.get = listCacheGet$1;
	ListCache.prototype.has = listCacheHas$1;
	ListCache.prototype.set = listCacheSet$1;

	var _ListCache = ListCache;

	var _ListCache$1 = /*#__PURE__*/Object.freeze({
		default: _ListCache,
		__moduleExports: _ListCache
	});

	var ListCache$1 = ( _ListCache$1 && _ListCache ) || _ListCache$1;

	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache$1;
	  this.size = 0;
	}

	var _stackClear = stackClear;

	var _stackClear$1 = /*#__PURE__*/Object.freeze({
		default: _stackClear,
		__moduleExports: _stackClear
	});

	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  var data = this.__data__,
	      result = data['delete'](key);

	  this.size = data.size;
	  return result;
	}

	var _stackDelete = stackDelete;

	var _stackDelete$1 = /*#__PURE__*/Object.freeze({
		default: _stackDelete,
		__moduleExports: _stackDelete
	});

	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}

	var _stackGet = stackGet;

	var _stackGet$1 = /*#__PURE__*/Object.freeze({
		default: _stackGet,
		__moduleExports: _stackGet
	});

	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}

	var _stackHas = stackHas;

	var _stackHas$1 = /*#__PURE__*/Object.freeze({
		default: _stackHas,
		__moduleExports: _stackHas
	});

	/** Used to detect overreaching core-js shims. */
	var coreJsData = root$1['__core-js_shared__'];

	var _coreJsData = coreJsData;

	var _coreJsData$1 = /*#__PURE__*/Object.freeze({
		default: _coreJsData,
		__moduleExports: _coreJsData
	});

	var coreJsData$1 = ( _coreJsData$1 && _coreJsData ) || _coreJsData$1;

	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData$1 && coreJsData$1.keys && coreJsData$1.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());

	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}

	var _isMasked = isMasked;

	var _isMasked$1 = /*#__PURE__*/Object.freeze({
		default: _isMasked,
		__moduleExports: _isMasked
	});

	/** Used for built-in method references. */
	var funcProto = Function.prototype;

	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;

	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}

	var _toSource = toSource;

	var _toSource$1 = /*#__PURE__*/Object.freeze({
		default: _toSource,
		__moduleExports: _toSource
	});

	var isMasked$1 = ( _isMasked$1 && _isMasked ) || _isMasked$1;

	var toSource$1 = ( _toSource$1 && _toSource ) || _toSource$1;

	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;

	/** Used for built-in method references. */
	var funcProto$1 = Function.prototype,
	    objectProto$6 = Object.prototype;

	/** Used to resolve the decompiled source of functions. */
	var funcToString$1 = funcProto$1.toString;

	/** Used to check objects for own properties. */
	var hasOwnProperty$5 = objectProto$6.hasOwnProperty;

	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString$1.call(hasOwnProperty$5).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);

	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject$3(value) || isMasked$1(value)) {
	    return false;
	  }
	  var pattern = isFunction$5(value) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource$1(value));
	}

	var _baseIsNative = baseIsNative;

	var _baseIsNative$1 = /*#__PURE__*/Object.freeze({
		default: _baseIsNative,
		__moduleExports: _baseIsNative
	});

	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue$1(object, key) {
	  return object == null ? undefined : object[key];
	}

	var _getValue = getValue$1;

	var _getValue$1 = /*#__PURE__*/Object.freeze({
		default: _getValue,
		__moduleExports: _getValue
	});

	var baseIsNative$1 = ( _baseIsNative$1 && _baseIsNative ) || _baseIsNative$1;

	var getValue$2 = ( _getValue$1 && _getValue ) || _getValue$1;

	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue$2(object, key);
	  return baseIsNative$1(value) ? value : undefined;
	}

	var _getNative = getNative;

	var _getNative$1 = /*#__PURE__*/Object.freeze({
		default: _getNative,
		__moduleExports: _getNative
	});

	var getNative$1 = ( _getNative$1 && _getNative ) || _getNative$1;

	/* Built-in method references that are verified to be native. */
	var Map$1 = getNative$1(root$1, 'Map');

	var _Map = Map$1;

	var _Map$1 = /*#__PURE__*/Object.freeze({
		default: _Map,
		__moduleExports: _Map
	});

	/* Built-in method references that are verified to be native. */
	var nativeCreate = getNative$1(Object, 'create');

	var _nativeCreate = nativeCreate;

	var _nativeCreate$1 = /*#__PURE__*/Object.freeze({
		default: _nativeCreate,
		__moduleExports: _nativeCreate
	});

	var nativeCreate$1 = ( _nativeCreate$1 && _nativeCreate ) || _nativeCreate$1;

	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate$1 ? nativeCreate$1(null) : {};
	  this.size = 0;
	}

	var _hashClear = hashClear;

	var _hashClear$1 = /*#__PURE__*/Object.freeze({
		default: _hashClear,
		__moduleExports: _hashClear
	});

	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  var result = this.has(key) && delete this.__data__[key];
	  this.size -= result ? 1 : 0;
	  return result;
	}

	var _hashDelete = hashDelete;

	var _hashDelete$1 = /*#__PURE__*/Object.freeze({
		default: _hashDelete,
		__moduleExports: _hashDelete
	});

	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';

	/** Used for built-in method references. */
	var objectProto$7 = Object.prototype;

	/** Used to check objects for own properties. */
	var hasOwnProperty$6 = objectProto$7.hasOwnProperty;

	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate$1) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty$6.call(data, key) ? data[key] : undefined;
	}

	var _hashGet = hashGet;

	var _hashGet$1 = /*#__PURE__*/Object.freeze({
		default: _hashGet,
		__moduleExports: _hashGet
	});

	/** Used for built-in method references. */
	var objectProto$8 = Object.prototype;

	/** Used to check objects for own properties. */
	var hasOwnProperty$7 = objectProto$8.hasOwnProperty;

	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate$1 ? (data[key] !== undefined) : hasOwnProperty$7.call(data, key);
	}

	var _hashHas = hashHas;

	var _hashHas$1 = /*#__PURE__*/Object.freeze({
		default: _hashHas,
		__moduleExports: _hashHas
	});

	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED$1 = '__lodash_hash_undefined__';

	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  this.size += this.has(key) ? 0 : 1;
	  data[key] = (nativeCreate$1 && value === undefined) ? HASH_UNDEFINED$1 : value;
	  return this;
	}

	var _hashSet = hashSet;

	var _hashSet$1 = /*#__PURE__*/Object.freeze({
		default: _hashSet,
		__moduleExports: _hashSet
	});

	var hashClear$1 = ( _hashClear$1 && _hashClear ) || _hashClear$1;

	var hashDelete$1 = ( _hashDelete$1 && _hashDelete ) || _hashDelete$1;

	var hashGet$1 = ( _hashGet$1 && _hashGet ) || _hashGet$1;

	var hashHas$1 = ( _hashHas$1 && _hashHas ) || _hashHas$1;

	var hashSet$1 = ( _hashSet$1 && _hashSet ) || _hashSet$1;

	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var this$1 = this;

	  var index = -1,
	      length = entries == null ? 0 : entries.length;

	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this$1.set(entry[0], entry[1]);
	  }
	}

	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear$1;
	Hash.prototype['delete'] = hashDelete$1;
	Hash.prototype.get = hashGet$1;
	Hash.prototype.has = hashHas$1;
	Hash.prototype.set = hashSet$1;

	var _Hash = Hash;

	var _Hash$1 = /*#__PURE__*/Object.freeze({
		default: _Hash,
		__moduleExports: _Hash
	});

	var Hash$1 = ( _Hash$1 && _Hash ) || _Hash$1;

	var Map$2 = ( _Map$1 && _Map ) || _Map$1;

	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.size = 0;
	  this.__data__ = {
	    'hash': new Hash$1,
	    'map': new (Map$2 || ListCache$1),
	    'string': new Hash$1
	  };
	}

	var _mapCacheClear = mapCacheClear;

	var _mapCacheClear$1 = /*#__PURE__*/Object.freeze({
		default: _mapCacheClear,
		__moduleExports: _mapCacheClear
	});

	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}

	var _isKeyable = isKeyable;

	var _isKeyable$1 = /*#__PURE__*/Object.freeze({
		default: _isKeyable,
		__moduleExports: _isKeyable
	});

	var isKeyable$1 = ( _isKeyable$1 && _isKeyable ) || _isKeyable$1;

	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable$1(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}

	var _getMapData = getMapData;

	var _getMapData$1 = /*#__PURE__*/Object.freeze({
		default: _getMapData,
		__moduleExports: _getMapData
	});

	var getMapData$1 = ( _getMapData$1 && _getMapData ) || _getMapData$1;

	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  var result = getMapData$1(this, key)['delete'](key);
	  this.size -= result ? 1 : 0;
	  return result;
	}

	var _mapCacheDelete = mapCacheDelete;

	var _mapCacheDelete$1 = /*#__PURE__*/Object.freeze({
		default: _mapCacheDelete,
		__moduleExports: _mapCacheDelete
	});

	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData$1(this, key).get(key);
	}

	var _mapCacheGet = mapCacheGet;

	var _mapCacheGet$1 = /*#__PURE__*/Object.freeze({
		default: _mapCacheGet,
		__moduleExports: _mapCacheGet
	});

	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData$1(this, key).has(key);
	}

	var _mapCacheHas = mapCacheHas;

	var _mapCacheHas$1 = /*#__PURE__*/Object.freeze({
		default: _mapCacheHas,
		__moduleExports: _mapCacheHas
	});

	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  var data = getMapData$1(this, key),
	      size = data.size;

	  data.set(key, value);
	  this.size += data.size == size ? 0 : 1;
	  return this;
	}

	var _mapCacheSet = mapCacheSet;

	var _mapCacheSet$1 = /*#__PURE__*/Object.freeze({
		default: _mapCacheSet,
		__moduleExports: _mapCacheSet
	});

	var mapCacheClear$1 = ( _mapCacheClear$1 && _mapCacheClear ) || _mapCacheClear$1;

	var mapCacheDelete$1 = ( _mapCacheDelete$1 && _mapCacheDelete ) || _mapCacheDelete$1;

	var mapCacheGet$1 = ( _mapCacheGet$1 && _mapCacheGet ) || _mapCacheGet$1;

	var mapCacheHas$1 = ( _mapCacheHas$1 && _mapCacheHas ) || _mapCacheHas$1;

	var mapCacheSet$1 = ( _mapCacheSet$1 && _mapCacheSet ) || _mapCacheSet$1;

	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var this$1 = this;

	  var index = -1,
	      length = entries == null ? 0 : entries.length;

	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this$1.set(entry[0], entry[1]);
	  }
	}

	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear$1;
	MapCache.prototype['delete'] = mapCacheDelete$1;
	MapCache.prototype.get = mapCacheGet$1;
	MapCache.prototype.has = mapCacheHas$1;
	MapCache.prototype.set = mapCacheSet$1;

	var _MapCache = MapCache;

	var _MapCache$1 = /*#__PURE__*/Object.freeze({
		default: _MapCache,
		__moduleExports: _MapCache
	});

	var MapCache$1 = ( _MapCache$1 && _MapCache ) || _MapCache$1;

	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;

	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var data = this.__data__;
	  if (data instanceof ListCache$1) {
	    var pairs = data.__data__;
	    if (!Map$2 || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      this.size = ++data.size;
	      return this;
	    }
	    data = this.__data__ = new MapCache$1(pairs);
	  }
	  data.set(key, value);
	  this.size = data.size;
	  return this;
	}

	var _stackSet = stackSet;

	var _stackSet$1 = /*#__PURE__*/Object.freeze({
		default: _stackSet,
		__moduleExports: _stackSet
	});

	var stackClear$1 = ( _stackClear$1 && _stackClear ) || _stackClear$1;

	var stackDelete$1 = ( _stackDelete$1 && _stackDelete ) || _stackDelete$1;

	var stackGet$1 = ( _stackGet$1 && _stackGet ) || _stackGet$1;

	var stackHas$1 = ( _stackHas$1 && _stackHas ) || _stackHas$1;

	var stackSet$1 = ( _stackSet$1 && _stackSet ) || _stackSet$1;

	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  var data = this.__data__ = new ListCache$1(entries);
	  this.size = data.size;
	}

	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear$1;
	Stack.prototype['delete'] = stackDelete$1;
	Stack.prototype.get = stackGet$1;
	Stack.prototype.has = stackHas$1;
	Stack.prototype.set = stackSet$1;

	var _Stack = Stack;

	var _Stack$1 = /*#__PURE__*/Object.freeze({
		default: _Stack,
		__moduleExports: _Stack
	});

	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED$2 = '__lodash_hash_undefined__';

	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */
	function setCacheAdd(value) {
	  this.__data__.set(value, HASH_UNDEFINED$2);
	  return this;
	}

	var _setCacheAdd = setCacheAdd;

	var _setCacheAdd$1 = /*#__PURE__*/Object.freeze({
		default: _setCacheAdd,
		__moduleExports: _setCacheAdd
	});

	/**
	 * Checks if `value` is in the array cache.
	 *
	 * @private
	 * @name has
	 * @memberOf SetCache
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function setCacheHas(value) {
	  return this.__data__.has(value);
	}

	var _setCacheHas = setCacheHas;

	var _setCacheHas$1 = /*#__PURE__*/Object.freeze({
		default: _setCacheHas,
		__moduleExports: _setCacheHas
	});

	var setCacheAdd$1 = ( _setCacheAdd$1 && _setCacheAdd ) || _setCacheAdd$1;

	var setCacheHas$1 = ( _setCacheHas$1 && _setCacheHas ) || _setCacheHas$1;

	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var this$1 = this;

	  var index = -1,
	      length = values == null ? 0 : values.length;

	  this.__data__ = new MapCache$1;
	  while (++index < length) {
	    this$1.add(values[index]);
	  }
	}

	// Add methods to `SetCache`.
	SetCache.prototype.add = SetCache.prototype.push = setCacheAdd$1;
	SetCache.prototype.has = setCacheHas$1;

	var _SetCache = SetCache;

	var _SetCache$1 = /*#__PURE__*/Object.freeze({
		default: _SetCache,
		__moduleExports: _SetCache
	});

	/**
	 * A specialized version of `_.some` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length;

	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}

	var _arraySome = arraySome;

	var _arraySome$1 = /*#__PURE__*/Object.freeze({
		default: _arraySome,
		__moduleExports: _arraySome
	});

	/**
	 * Checks if a `cache` value for `key` exists.
	 *
	 * @private
	 * @param {Object} cache The cache to query.
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function cacheHas(cache, key) {
	  return cache.has(key);
	}

	var _cacheHas = cacheHas;

	var _cacheHas$1 = /*#__PURE__*/Object.freeze({
		default: _cacheHas,
		__moduleExports: _cacheHas
	});

	var SetCache$1 = ( _SetCache$1 && _SetCache ) || _SetCache$1;

	var arraySome$1 = ( _arraySome$1 && _arraySome ) || _arraySome$1;

	var cacheHas$1 = ( _cacheHas$1 && _cacheHas ) || _cacheHas$1;

	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;

	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `array` and `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      arrLength = array.length,
	      othLength = other.length;

	  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	    return false;
	  }
	  // Check that cyclic values are equal.
	  var arrStacked = stack.get(array);
	  var othStacked = stack.get(other);
	  if (arrStacked && othStacked) {
	    return arrStacked == other && othStacked == array;
	  }
	  var index = -1,
	      result = true,
	      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache$1 : undefined;

	  stack.set(array, other);
	  stack.set(other, array);

	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index];

	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, arrValue, index, other, array, stack)
	        : customizer(arrValue, othValue, index, array, other, stack);
	    }
	    if (compared !== undefined) {
	      if (compared) {
	        continue;
	      }
	      result = false;
	      break;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (seen) {
	      if (!arraySome$1(other, function(othValue, othIndex) {
	            if (!cacheHas$1(seen, othIndex) &&
	                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	              return seen.push(othIndex);
	            }
	          })) {
	        result = false;
	        break;
	      }
	    } else if (!(
	          arrValue === othValue ||
	            equalFunc(arrValue, othValue, bitmask, customizer, stack)
	        )) {
	      result = false;
	      break;
	    }
	  }
	  stack['delete'](array);
	  stack['delete'](other);
	  return result;
	}

	var _equalArrays = equalArrays;

	var _equalArrays$1 = /*#__PURE__*/Object.freeze({
		default: _equalArrays,
		__moduleExports: _equalArrays
	});

	/** Built-in value references. */
	var Uint8Array$1 = root$1.Uint8Array;

	var _Uint8Array = Uint8Array$1;

	var _Uint8Array$1 = /*#__PURE__*/Object.freeze({
		default: _Uint8Array,
		__moduleExports: _Uint8Array
	});

	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);

	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}

	var _mapToArray = mapToArray;

	var _mapToArray$1 = /*#__PURE__*/Object.freeze({
		default: _mapToArray,
		__moduleExports: _mapToArray
	});

	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);

	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}

	var _setToArray = setToArray;

	var _setToArray$1 = /*#__PURE__*/Object.freeze({
		default: _setToArray,
		__moduleExports: _setToArray
	});

	var Uint8Array$2 = ( _Uint8Array$1 && _Uint8Array ) || _Uint8Array$1;

	var equalArrays$1 = ( _equalArrays$1 && _equalArrays ) || _equalArrays$1;

	var mapToArray$1 = ( _mapToArray$1 && _mapToArray ) || _mapToArray$1;

	var setToArray$1 = ( _setToArray$1 && _setToArray ) || _setToArray$1;

	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG$1 = 1,
	    COMPARE_UNORDERED_FLAG$1 = 2;

	/** `Object#toString` result references. */
	var boolTag$1 = '[object Boolean]',
	    dateTag$1 = '[object Date]',
	    errorTag$1 = '[object Error]',
	    mapTag$1 = '[object Map]',
	    numberTag$1 = '[object Number]',
	    regexpTag$1 = '[object RegExp]',
	    setTag$1 = '[object Set]',
	    stringTag$1 = '[object String]',
	    symbolTag$1 = '[object Symbol]';

	var arrayBufferTag$1 = '[object ArrayBuffer]',
	    dataViewTag$1 = '[object DataView]';

	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol$2 ? Symbol$2.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	  switch (tag) {
	    case dataViewTag$1:
	      if ((object.byteLength != other.byteLength) ||
	          (object.byteOffset != other.byteOffset)) {
	        return false;
	      }
	      object = object.buffer;
	      other = other.buffer;

	    case arrayBufferTag$1:
	      if ((object.byteLength != other.byteLength) ||
	          !equalFunc(new Uint8Array$2(object), new Uint8Array$2(other))) {
	        return false;
	      }
	      return true;

	    case boolTag$1:
	    case dateTag$1:
	    case numberTag$1:
	      // Coerce booleans to `1` or `0` and dates to milliseconds.
	      // Invalid dates are coerced to `NaN`.
	      return eq$3(+object, +other);

	    case errorTag$1:
	      return object.name == other.name && object.message == other.message;

	    case regexpTag$1:
	    case stringTag$1:
	      // Coerce regexes to strings and treat strings, primitives and objects,
	      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	      // for more details.
	      return object == (other + '');

	    case mapTag$1:
	      var convert = mapToArray$1;

	    case setTag$1:
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG$1;
	      convert || (convert = setToArray$1);

	      if (object.size != other.size && !isPartial) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked) {
	        return stacked == other;
	      }
	      bitmask |= COMPARE_UNORDERED_FLAG$1;

	      // Recursively compare objects (susceptible to call stack limits).
	      stack.set(object, other);
	      var result = equalArrays$1(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	      stack['delete'](object);
	      return result;

	    case symbolTag$1:
	      if (symbolValueOf) {
	        return symbolValueOf.call(object) == symbolValueOf.call(other);
	      }
	  }
	  return false;
	}

	var _equalByTag = equalByTag;

	var _equalByTag$1 = /*#__PURE__*/Object.freeze({
		default: _equalByTag,
		__moduleExports: _equalByTag
	});

	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;

	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}

	var _arrayPush = arrayPush;

	var _arrayPush$1 = /*#__PURE__*/Object.freeze({
		default: _arrayPush,
		__moduleExports: _arrayPush
	});

	var arrayPush$1 = ( _arrayPush$1 && _arrayPush ) || _arrayPush$1;

	/**
	 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @param {Function} symbolsFunc The function to get the symbols of `object`.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	  var result = keysFunc(object);
	  return isArray_1(object) ? result : arrayPush$1(result, symbolsFunc(object));
	}

	var _baseGetAllKeys = baseGetAllKeys;

	var _baseGetAllKeys$1 = /*#__PURE__*/Object.freeze({
		default: _baseGetAllKeys,
		__moduleExports: _baseGetAllKeys
	});

	/**
	 * A specialized version of `_.filter` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function arrayFilter(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      resIndex = 0,
	      result = [];

	  while (++index < length) {
	    var value = array[index];
	    if (predicate(value, index, array)) {
	      result[resIndex++] = value;
	    }
	  }
	  return result;
	}

	var _arrayFilter = arrayFilter;

	var _arrayFilter$1 = /*#__PURE__*/Object.freeze({
		default: _arrayFilter,
		__moduleExports: _arrayFilter
	});

	/**
	 * This method returns a new empty array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {Array} Returns the new empty array.
	 * @example
	 *
	 * var arrays = _.times(2, _.stubArray);
	 *
	 * console.log(arrays);
	 * // => [[], []]
	 *
	 * console.log(arrays[0] === arrays[1]);
	 * // => false
	 */
	function stubArray() {
	  return [];
	}

	var stubArray_1 = stubArray;

	var stubArray$1 = /*#__PURE__*/Object.freeze({
		default: stubArray_1,
		__moduleExports: stubArray_1
	});

	var arrayFilter$1 = ( _arrayFilter$1 && _arrayFilter ) || _arrayFilter$1;

	var stubArray$2 = ( stubArray$1 && stubArray_1 ) || stubArray$1;

	/** Used for built-in method references. */
	var objectProto$9 = Object.prototype;

	/** Built-in value references. */
	var propertyIsEnumerable$1 = objectProto$9.propertyIsEnumerable;

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;

	/**
	 * Creates an array of the own enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbols = !nativeGetSymbols ? stubArray$2 : function(object) {
	  if (object == null) {
	    return [];
	  }
	  object = Object(object);
	  return arrayFilter$1(nativeGetSymbols(object), function(symbol) {
	    return propertyIsEnumerable$1.call(object, symbol);
	  });
	};

	var _getSymbols = getSymbols;

	var _getSymbols$1 = /*#__PURE__*/Object.freeze({
		default: _getSymbols,
		__moduleExports: _getSymbols
	});

	var baseGetAllKeys$1 = ( _baseGetAllKeys$1 && _baseGetAllKeys ) || _baseGetAllKeys$1;

	var getSymbols$1 = ( _getSymbols$1 && _getSymbols ) || _getSymbols$1;

	/**
	 * Creates an array of own enumerable property names and symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeys(object) {
	  return baseGetAllKeys$1(object, keys$7, getSymbols$1);
	}

	var _getAllKeys = getAllKeys;

	var _getAllKeys$1 = /*#__PURE__*/Object.freeze({
		default: _getAllKeys,
		__moduleExports: _getAllKeys
	});

	var getAllKeys$1 = ( _getAllKeys$1 && _getAllKeys ) || _getAllKeys$1;

	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG$2 = 1;

	/** Used for built-in method references. */
	var objectProto$a = Object.prototype;

	/** Used to check objects for own properties. */
	var hasOwnProperty$8 = objectProto$a.hasOwnProperty;

	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$2,
	      objProps = getAllKeys$1(object),
	      objLength = objProps.length,
	      othProps = getAllKeys$1(other),
	      othLength = othProps.length;

	  if (objLength != othLength && !isPartial) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isPartial ? key in other : hasOwnProperty$8.call(other, key))) {
	      return false;
	    }
	  }
	  // Check that cyclic values are equal.
	  var objStacked = stack.get(object);
	  var othStacked = stack.get(other);
	  if (objStacked && othStacked) {
	    return objStacked == other && othStacked == object;
	  }
	  var result = true;
	  stack.set(object, other);
	  stack.set(other, object);

	  var skipCtor = isPartial;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key];

	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, objValue, key, other, object, stack)
	        : customizer(objValue, othValue, key, object, other, stack);
	    }
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(compared === undefined
	          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	          : compared
	        )) {
	      result = false;
	      break;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (result && !skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;

	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      result = false;
	    }
	  }
	  stack['delete'](object);
	  stack['delete'](other);
	  return result;
	}

	var _equalObjects = equalObjects;

	var _equalObjects$1 = /*#__PURE__*/Object.freeze({
		default: _equalObjects,
		__moduleExports: _equalObjects
	});

	/* Built-in method references that are verified to be native. */
	var DataView = getNative$1(root$1, 'DataView');

	var _DataView = DataView;

	var _DataView$1 = /*#__PURE__*/Object.freeze({
		default: _DataView,
		__moduleExports: _DataView
	});

	/* Built-in method references that are verified to be native. */
	var Promise$1 = getNative$1(root$1, 'Promise');

	var _Promise = Promise$1;

	var _Promise$1 = /*#__PURE__*/Object.freeze({
		default: _Promise,
		__moduleExports: _Promise
	});

	/* Built-in method references that are verified to be native. */
	var Set$1 = getNative$1(root$1, 'Set');

	var _Set$1 = Set$1;

	var _Set$2 = /*#__PURE__*/Object.freeze({
		default: _Set$1,
		__moduleExports: _Set$1
	});

	/* Built-in method references that are verified to be native. */
	var WeakMap = getNative$1(root$1, 'WeakMap');

	var _WeakMap = WeakMap;

	var _WeakMap$1 = /*#__PURE__*/Object.freeze({
		default: _WeakMap,
		__moduleExports: _WeakMap
	});

	var DataView$1 = ( _DataView$1 && _DataView ) || _DataView$1;

	var Promise$2 = ( _Promise$1 && _Promise ) || _Promise$1;

	var Set$2 = ( _Set$2 && _Set$1 ) || _Set$2;

	var WeakMap$1 = ( _WeakMap$1 && _WeakMap ) || _WeakMap$1;

	/** `Object#toString` result references. */
	var mapTag$2 = '[object Map]',
	    objectTag$1 = '[object Object]',
	    promiseTag = '[object Promise]',
	    setTag$2 = '[object Set]',
	    weakMapTag$1 = '[object WeakMap]';

	var dataViewTag$2 = '[object DataView]';

	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource$1(DataView$1),
	    mapCtorString = toSource$1(Map$2),
	    promiseCtorString = toSource$1(Promise$2),
	    setCtorString = toSource$1(Set$2),
	    weakMapCtorString = toSource$1(WeakMap$1);

	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag$1;

	// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	if ((DataView$1 && getTag(new DataView$1(new ArrayBuffer(1))) != dataViewTag$2) ||
	    (Map$2 && getTag(new Map$2) != mapTag$2) ||
	    (Promise$2 && getTag(Promise$2.resolve()) != promiseTag) ||
	    (Set$2 && getTag(new Set$2) != setTag$2) ||
	    (WeakMap$1 && getTag(new WeakMap$1) != weakMapTag$1)) {
	  getTag = function(value) {
	    var result = baseGetTag$1(value),
	        Ctor = result == objectTag$1 ? value.constructor : undefined,
	        ctorString = Ctor ? toSource$1(Ctor) : '';

	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag$2;
	        case mapCtorString: return mapTag$2;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag$2;
	        case weakMapCtorString: return weakMapTag$1;
	      }
	    }
	    return result;
	  };
	}

	var _getTag = getTag;

	var _getTag$1 = /*#__PURE__*/Object.freeze({
		default: _getTag,
		__moduleExports: _getTag
	});

	var Stack$1 = ( _Stack$1 && _Stack ) || _Stack$1;

	var equalByTag$1 = ( _equalByTag$1 && _equalByTag ) || _equalByTag$1;

	var equalObjects$1 = ( _equalObjects$1 && _equalObjects ) || _equalObjects$1;

	var getTag$1 = ( _getTag$1 && _getTag ) || _getTag$1;

	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG$3 = 1;

	/** `Object#toString` result references. */
	var argsTag$2 = '[object Arguments]',
	    arrayTag$1 = '[object Array]',
	    objectTag$2 = '[object Object]';

	/** Used for built-in method references. */
	var objectProto$b = Object.prototype;

	/** Used to check objects for own properties. */
	var hasOwnProperty$9 = objectProto$b.hasOwnProperty;

	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	  var objIsArr = isArray_1(object),
	      othIsArr = isArray_1(other),
	      objTag = objIsArr ? arrayTag$1 : getTag$1(object),
	      othTag = othIsArr ? arrayTag$1 : getTag$1(other);

	  objTag = objTag == argsTag$2 ? objectTag$2 : objTag;
	  othTag = othTag == argsTag$2 ? objectTag$2 : othTag;

	  var objIsObj = objTag == objectTag$2,
	      othIsObj = othTag == objectTag$2,
	      isSameTag = objTag == othTag;

	  if (isSameTag && isBuffer$3(object)) {
	    if (!isBuffer$3(other)) {
	      return false;
	    }
	    objIsArr = true;
	    objIsObj = false;
	  }
	  if (isSameTag && !objIsObj) {
	    stack || (stack = new Stack$1);
	    return (objIsArr || isTypedArray$2(object))
	      ? equalArrays$1(object, other, bitmask, customizer, equalFunc, stack)
	      : equalByTag$1(object, other, objTag, bitmask, customizer, equalFunc, stack);
	  }
	  if (!(bitmask & COMPARE_PARTIAL_FLAG$3)) {
	    var objIsWrapped = objIsObj && hasOwnProperty$9.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty$9.call(other, '__wrapped__');

	    if (objIsWrapped || othIsWrapped) {
	      var objUnwrapped = objIsWrapped ? object.value() : object,
	          othUnwrapped = othIsWrapped ? other.value() : other;

	      stack || (stack = new Stack$1);
	      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  stack || (stack = new Stack$1);
	  return equalObjects$1(object, other, bitmask, customizer, equalFunc, stack);
	}

	var _baseIsEqualDeep = baseIsEqualDeep;

	var _baseIsEqualDeep$1 = /*#__PURE__*/Object.freeze({
		default: _baseIsEqualDeep,
		__moduleExports: _baseIsEqualDeep
	});

	var baseIsEqualDeep$1 = ( _baseIsEqualDeep$1 && _baseIsEqualDeep ) || _baseIsEqualDeep$1;

	/**
	 * The base implementation of `_.isEqual` which supports partial comparisons
	 * and tracks traversed objects.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Unordered comparison
	 *  2 - Partial comparison
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, bitmask, customizer, stack) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObjectLike$2(value) && !isObjectLike$2(other))) {
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep$1(value, other, bitmask, customizer, baseIsEqual, stack);
	}

	var _baseIsEqual = baseIsEqual;

	var _baseIsEqual$1 = /*#__PURE__*/Object.freeze({
		default: _baseIsEqual,
		__moduleExports: _baseIsEqual
	});

	var baseIsEqual$1 = ( _baseIsEqual$1 && _baseIsEqual ) || _baseIsEqual$1;

	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG$4 = 1,
	    COMPARE_UNORDERED_FLAG$2 = 2;

	/**
	 * The base implementation of `_.isMatch` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to inspect.
	 * @param {Object} source The object of property values to match.
	 * @param {Array} matchData The property names, values, and compare flags to match.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	 */
	function baseIsMatch(object, source, matchData, customizer) {
	  var index = matchData.length,
	      length = index,
	      noCustomizer = !customizer;

	  if (object == null) {
	    return !length;
	  }
	  object = Object(object);
	  while (index--) {
	    var data = matchData[index];
	    if ((noCustomizer && data[2])
	          ? data[1] !== object[data[0]]
	          : !(data[0] in object)
	        ) {
	      return false;
	    }
	  }
	  while (++index < length) {
	    data = matchData[index];
	    var key = data[0],
	        objValue = object[key],
	        srcValue = data[1];

	    if (noCustomizer && data[2]) {
	      if (objValue === undefined && !(key in object)) {
	        return false;
	      }
	    } else {
	      var stack = new Stack$1;
	      if (customizer) {
	        var result = customizer(objValue, srcValue, key, object, source, stack);
	      }
	      if (!(result === undefined
	            ? baseIsEqual$1(srcValue, objValue, COMPARE_PARTIAL_FLAG$4 | COMPARE_UNORDERED_FLAG$2, customizer, stack)
	            : result
	          )) {
	        return false;
	      }
	    }
	  }
	  return true;
	}

	var _baseIsMatch = baseIsMatch;

	var _baseIsMatch$1 = /*#__PURE__*/Object.freeze({
		default: _baseIsMatch,
		__moduleExports: _baseIsMatch
	});

	/**
	 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` if suitable for strict
	 *  equality comparisons, else `false`.
	 */
	function isStrictComparable(value) {
	  return value === value && !isObject$3(value);
	}

	var _isStrictComparable = isStrictComparable;

	var _isStrictComparable$1 = /*#__PURE__*/Object.freeze({
		default: _isStrictComparable,
		__moduleExports: _isStrictComparable
	});

	var isStrictComparable$1 = ( _isStrictComparable$1 && _isStrictComparable ) || _isStrictComparable$1;

	/**
	 * Gets the property names, values, and compare flags of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the match data of `object`.
	 */
	function getMatchData(object) {
	  var result = keys$7(object),
	      length = result.length;

	  while (length--) {
	    var key = result[length],
	        value = object[key];

	    result[length] = [key, value, isStrictComparable$1(value)];
	  }
	  return result;
	}

	var _getMatchData = getMatchData;

	var _getMatchData$1 = /*#__PURE__*/Object.freeze({
		default: _getMatchData,
		__moduleExports: _getMatchData
	});

	/**
	 * A specialized version of `matchesProperty` for source values suitable
	 * for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function matchesStrictComparable(key, srcValue) {
	  return function(object) {
	    if (object == null) {
	      return false;
	    }
	    return object[key] === srcValue &&
	      (srcValue !== undefined || (key in Object(object)));
	  };
	}

	var _matchesStrictComparable = matchesStrictComparable;

	var _matchesStrictComparable$1 = /*#__PURE__*/Object.freeze({
		default: _matchesStrictComparable,
		__moduleExports: _matchesStrictComparable
	});

	var baseIsMatch$1 = ( _baseIsMatch$1 && _baseIsMatch ) || _baseIsMatch$1;

	var getMatchData$1 = ( _getMatchData$1 && _getMatchData ) || _getMatchData$1;

	var matchesStrictComparable$1 = ( _matchesStrictComparable$1 && _matchesStrictComparable ) || _matchesStrictComparable$1;

	/**
	 * The base implementation of `_.matches` which doesn't clone `source`.
	 *
	 * @private
	 * @param {Object} source The object of property values to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatches(source) {
	  var matchData = getMatchData$1(source);
	  if (matchData.length == 1 && matchData[0][2]) {
	    return matchesStrictComparable$1(matchData[0][0], matchData[0][1]);
	  }
	  return function(object) {
	    return object === source || baseIsMatch$1(object, source, matchData);
	  };
	}

	var _baseMatches = baseMatches;

	var _baseMatches$1 = /*#__PURE__*/Object.freeze({
		default: _baseMatches,
		__moduleExports: _baseMatches
	});

	/** Used to match property names within property paths. */
	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	    reIsPlainProp = /^\w*$/;

	/**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */
	function isKey(value, object) {
	  if (isArray_1(value)) {
	    return false;
	  }
	  var type = typeof value;
	  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	      value == null || isSymbol$2(value)) {
	    return true;
	  }
	  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	    (object != null && value in Object(object));
	}

	var _isKey = isKey;

	var _isKey$1 = /*#__PURE__*/Object.freeze({
		default: _isKey,
		__moduleExports: _isKey
	});

	/** Error message constants. */
	var FUNC_ERROR_TEXT$1 = 'Expected a function';

	/**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided, it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is used as the map cache key. The `func`
	 * is invoked with the `this` binding of the memoized function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the
	 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoized function.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 * var other = { 'c': 3, 'd': 4 };
	 *
	 * var values = _.memoize(_.values);
	 * values(object);
	 * // => [1, 2]
	 *
	 * values(other);
	 * // => [3, 4]
	 *
	 * object.a = 2;
	 * values(object);
	 * // => [1, 2]
	 *
	 * // Modify the result cache.
	 * values.cache.set(object, ['a', 'b']);
	 * values(object);
	 * // => ['a', 'b']
	 *
	 * // Replace `_.memoize.Cache`.
	 * _.memoize.Cache = WeakMap;
	 */
	function memoize(func, resolver) {
	  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	    throw new TypeError(FUNC_ERROR_TEXT$1);
	  }
	  var memoized = function() {
	    var args = arguments,
	        key = resolver ? resolver.apply(this, args) : args[0],
	        cache = memoized.cache;

	    if (cache.has(key)) {
	      return cache.get(key);
	    }
	    var result = func.apply(this, args);
	    memoized.cache = cache.set(key, result) || cache;
	    return result;
	  };
	  memoized.cache = new (memoize.Cache || MapCache$1);
	  return memoized;
	}

	// Expose `MapCache`.
	memoize.Cache = MapCache$1;

	var memoize_1 = memoize;

	var memoize$1 = /*#__PURE__*/Object.freeze({
		default: memoize_1,
		__moduleExports: memoize_1
	});

	var memoize$2 = ( memoize$1 && memoize_1 ) || memoize$1;

	/** Used as the maximum memoize cache size. */
	var MAX_MEMOIZE_SIZE = 500;

	/**
	 * A specialized version of `_.memoize` which clears the memoized function's
	 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	 *
	 * @private
	 * @param {Function} func The function to have its output memoized.
	 * @returns {Function} Returns the new memoized function.
	 */
	function memoizeCapped(func) {
	  var result = memoize$2(func, function(key) {
	    if (cache.size === MAX_MEMOIZE_SIZE) {
	      cache.clear();
	    }
	    return key;
	  });

	  var cache = result.cache;
	  return result;
	}

	var _memoizeCapped = memoizeCapped;

	var _memoizeCapped$1 = /*#__PURE__*/Object.freeze({
		default: _memoizeCapped,
		__moduleExports: _memoizeCapped
	});

	var memoizeCapped$1 = ( _memoizeCapped$1 && _memoizeCapped ) || _memoizeCapped$1;

	/** Used to match property names within property paths. */
	var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;

	/**
	 * Converts `string` to a property path array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the property path array.
	 */
	var stringToPath = memoizeCapped$1(function(string) {
	  var result = [];
	  if (string.charCodeAt(0) === 46 /* . */) {
	    result.push('');
	  }
	  string.replace(rePropName, function(match, number, quote, subString) {
	    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	});

	var _stringToPath = stringToPath;

	var _stringToPath$1 = /*#__PURE__*/Object.freeze({
		default: _stringToPath,
		__moduleExports: _stringToPath
	});

	/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      result = Array(length);

	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}

	var _arrayMap = arrayMap;

	var _arrayMap$1 = /*#__PURE__*/Object.freeze({
		default: _arrayMap,
		__moduleExports: _arrayMap
	});

	var arrayMap$1 = ( _arrayMap$1 && _arrayMap ) || _arrayMap$1;

	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;

	/** Used to convert symbols to primitives and strings. */
	var symbolProto$1 = Symbol$2 ? Symbol$2.prototype : undefined,
	    symbolToString = symbolProto$1 ? symbolProto$1.toString : undefined;

	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isArray_1(value)) {
	    // Recursively convert values (susceptible to call stack limits).
	    return arrayMap$1(value, baseToString) + '';
	  }
	  if (isSymbol$2(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}

	var _baseToString = baseToString;

	var _baseToString$1 = /*#__PURE__*/Object.freeze({
		default: _baseToString,
		__moduleExports: _baseToString
	});

	var baseToString$1 = ( _baseToString$1 && _baseToString ) || _baseToString$1;

	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString$7(value) {
	  return value == null ? '' : baseToString$1(value);
	}

	var toString_1 = toString$7;

	var toString$8 = /*#__PURE__*/Object.freeze({
		default: toString_1,
		__moduleExports: toString_1
	});

	var isKey$1 = ( _isKey$1 && _isKey ) || _isKey$1;

	var stringToPath$1 = ( _stringToPath$1 && _stringToPath ) || _stringToPath$1;

	var toString$9 = ( toString$8 && toString_1 ) || toString$8;

	/**
	 * Casts `value` to a path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {Array} Returns the cast property path array.
	 */
	function castPath(value, object) {
	  if (isArray_1(value)) {
	    return value;
	  }
	  return isKey$1(value, object) ? [value] : stringToPath$1(toString$9(value));
	}

	var _castPath = castPath;

	var _castPath$1 = /*#__PURE__*/Object.freeze({
		default: _castPath,
		__moduleExports: _castPath
	});

	/** Used as references for various `Number` constants. */
	var INFINITY$1 = 1 / 0;

	/**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */
	function toKey(value) {
	  if (typeof value == 'string' || isSymbol$2(value)) {
	    return value;
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY$1) ? '-0' : result;
	}

	var _toKey = toKey;

	var _toKey$1 = /*#__PURE__*/Object.freeze({
		default: _toKey,
		__moduleExports: _toKey
	});

	var castPath$1 = ( _castPath$1 && _castPath ) || _castPath$1;

	var toKey$1 = ( _toKey$1 && _toKey ) || _toKey$1;

	/**
	 * The base implementation of `_.get` without support for default values.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @returns {*} Returns the resolved value.
	 */
	function baseGet(object, path) {
	  path = castPath$1(path, object);

	  var index = 0,
	      length = path.length;

	  while (object != null && index < length) {
	    object = object[toKey$1(path[index++])];
	  }
	  return (index && index == length) ? object : undefined;
	}

	var _baseGet = baseGet;

	var _baseGet$1 = /*#__PURE__*/Object.freeze({
		default: _baseGet,
		__moduleExports: _baseGet
	});

	var baseGet$1 = ( _baseGet$1 && _baseGet ) || _baseGet$1;

	/**
	 * Gets the value at `path` of `object`. If the resolved value is
	 * `undefined`, the `defaultValue` is returned in its place.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	 * @returns {*} Returns the resolved value.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.get(object, 'a[0].b.c');
	 * // => 3
	 *
	 * _.get(object, ['a', '0', 'b', 'c']);
	 * // => 3
	 *
	 * _.get(object, 'a.b.c', 'default');
	 * // => 'default'
	 */
	function get$6(object, path, defaultValue) {
	  var result = object == null ? undefined : baseGet$1(object, path);
	  return result === undefined ? defaultValue : result;
	}

	var get_1 = get$6;

	var get$7 = /*#__PURE__*/Object.freeze({
		default: get_1,
		__moduleExports: get_1
	});

	/**
	 * The base implementation of `_.hasIn` without support for deep paths.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {Array|string} key The key to check.
	 * @returns {boolean} Returns `true` if `key` exists, else `false`.
	 */
	function baseHasIn(object, key) {
	  return object != null && key in Object(object);
	}

	var _baseHasIn = baseHasIn;

	var _baseHasIn$1 = /*#__PURE__*/Object.freeze({
		default: _baseHasIn,
		__moduleExports: _baseHasIn
	});

	/**
	 * Checks if `path` exists on `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @param {Function} hasFunc The function to check properties.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 */
	function hasPath(object, path, hasFunc) {
	  path = castPath$1(path, object);

	  var index = -1,
	      length = path.length,
	      result = false;

	  while (++index < length) {
	    var key = toKey$1(path[index]);
	    if (!(result = object != null && hasFunc(object, key))) {
	      break;
	    }
	    object = object[key];
	  }
	  if (result || ++index != length) {
	    return result;
	  }
	  length = object == null ? 0 : object.length;
	  return !!length && isLength$2(length) && isIndex$1(key, length) &&
	    (isArray_1(object) || isArguments$2(object));
	}

	var _hasPath = hasPath;

	var _hasPath$1 = /*#__PURE__*/Object.freeze({
		default: _hasPath,
		__moduleExports: _hasPath
	});

	var baseHasIn$1 = ( _baseHasIn$1 && _baseHasIn ) || _baseHasIn$1;

	var hasPath$1 = ( _hasPath$1 && _hasPath ) || _hasPath$1;

	/**
	 * Checks if `path` is a direct or inherited property of `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 * @example
	 *
	 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	 *
	 * _.hasIn(object, 'a');
	 * // => true
	 *
	 * _.hasIn(object, 'a.b');
	 * // => true
	 *
	 * _.hasIn(object, ['a', 'b']);
	 * // => true
	 *
	 * _.hasIn(object, 'b');
	 * // => false
	 */
	function hasIn(object, path) {
	  return object != null && hasPath$1(object, path, baseHasIn$1);
	}

	var hasIn_1 = hasIn;

	var hasIn$1 = /*#__PURE__*/Object.freeze({
		default: hasIn_1,
		__moduleExports: hasIn_1
	});

	var get$8 = ( get$7 && get_1 ) || get$7;

	var hasIn$2 = ( hasIn$1 && hasIn_1 ) || hasIn$1;

	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG$5 = 1,
	    COMPARE_UNORDERED_FLAG$3 = 2;

	/**
	 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	 *
	 * @private
	 * @param {string} path The path of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatchesProperty(path, srcValue) {
	  if (isKey$1(path) && isStrictComparable$1(srcValue)) {
	    return matchesStrictComparable$1(toKey$1(path), srcValue);
	  }
	  return function(object) {
	    var objValue = get$8(object, path);
	    return (objValue === undefined && objValue === srcValue)
	      ? hasIn$2(object, path)
	      : baseIsEqual$1(srcValue, objValue, COMPARE_PARTIAL_FLAG$5 | COMPARE_UNORDERED_FLAG$3);
	  };
	}

	var _baseMatchesProperty = baseMatchesProperty;

	var _baseMatchesProperty$1 = /*#__PURE__*/Object.freeze({
		default: _baseMatchesProperty,
		__moduleExports: _baseMatchesProperty
	});

	/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity$1(value) {
	  return value;
	}

	var identity_1 = identity$1;

	var identity$2 = /*#__PURE__*/Object.freeze({
		default: identity_1,
		__moduleExports: identity_1
	});

	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}

	var _baseProperty = baseProperty;

	var _baseProperty$1 = /*#__PURE__*/Object.freeze({
		default: _baseProperty,
		__moduleExports: _baseProperty
	});

	/**
	 * A specialized version of `baseProperty` which supports deep paths.
	 *
	 * @private
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function basePropertyDeep(path) {
	  return function(object) {
	    return baseGet$1(object, path);
	  };
	}

	var _basePropertyDeep = basePropertyDeep;

	var _basePropertyDeep$1 = /*#__PURE__*/Object.freeze({
		default: _basePropertyDeep,
		__moduleExports: _basePropertyDeep
	});

	var baseProperty$1 = ( _baseProperty$1 && _baseProperty ) || _baseProperty$1;

	var basePropertyDeep$1 = ( _basePropertyDeep$1 && _basePropertyDeep ) || _basePropertyDeep$1;

	/**
	 * Creates a function that returns the value at `path` of a given object.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 * @example
	 *
	 * var objects = [
	 *   { 'a': { 'b': 2 } },
	 *   { 'a': { 'b': 1 } }
	 * ];
	 *
	 * _.map(objects, _.property('a.b'));
	 * // => [2, 1]
	 *
	 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	 * // => [1, 2]
	 */
	function property(path) {
	  return isKey$1(path) ? baseProperty$1(toKey$1(path)) : basePropertyDeep$1(path);
	}

	var property_1 = property;

	var property$1 = /*#__PURE__*/Object.freeze({
		default: property_1,
		__moduleExports: property_1
	});

	var baseMatches$1 = ( _baseMatches$1 && _baseMatches ) || _baseMatches$1;

	var baseMatchesProperty$1 = ( _baseMatchesProperty$1 && _baseMatchesProperty ) || _baseMatchesProperty$1;

	var identity$3 = ( identity$2 && identity_1 ) || identity$2;

	var property$2 = ( property$1 && property_1 ) || property$1;

	/**
	 * The base implementation of `_.iteratee`.
	 *
	 * @private
	 * @param {*} [value=_.identity] The value to convert to an iteratee.
	 * @returns {Function} Returns the iteratee.
	 */
	function baseIteratee(value) {
	  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	  if (typeof value == 'function') {
	    return value;
	  }
	  if (value == null) {
	    return identity$3;
	  }
	  if (typeof value == 'object') {
	    return isArray_1(value)
	      ? baseMatchesProperty$1(value[0], value[1])
	      : baseMatches$1(value);
	  }
	  return property$2(value);
	}

	var _baseIteratee = baseIteratee;

	var _baseIteratee$1 = /*#__PURE__*/Object.freeze({
		default: _baseIteratee,
		__moduleExports: _baseIteratee
	});

	var baseFindKey$1 = ( _baseFindKey$1 && _baseFindKey ) || _baseFindKey$1;

	var baseForOwn$1 = ( _baseForOwn$1 && _baseForOwn ) || _baseForOwn$1;

	var baseIteratee$1 = ( _baseIteratee$1 && _baseIteratee ) || _baseIteratee$1;

	/**
	 * This method is like `_.find` except that it returns the key of the first
	 * element `predicate` returns truthy for instead of the element itself.
	 *
	 * @static
	 * @memberOf _
	 * @since 1.1.0
	 * @category Object
	 * @param {Object} object The object to inspect.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @returns {string|undefined} Returns the key of the matched element,
	 *  else `undefined`.
	 * @example
	 *
	 * var users = {
	 *   'barney':  { 'age': 36, 'active': true },
	 *   'fred':    { 'age': 40, 'active': false },
	 *   'pebbles': { 'age': 1,  'active': true }
	 * };
	 *
	 * _.findKey(users, function(o) { return o.age < 40; });
	 * // => 'barney' (iteration order is not guaranteed)
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.findKey(users, { 'age': 1, 'active': true });
	 * // => 'pebbles'
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.findKey(users, ['active', false]);
	 * // => 'fred'
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.findKey(users, 'active');
	 * // => 'barney'
	 */
	function findKey(object, predicate) {
	  return baseFindKey$1(object, baseIteratee$1(predicate, 3), baseForOwn$1);
	}

	var findKey_1 = findKey;

	//

	function sortCallback(a, b) {
	  if (!a.firstNameLastNameEmail || !b.firstNameLastNameEmail)
	    { return 0; }
	  return a.firstNameLastNameEmail.localeCompare(b.firstNameLastNameEmail);
	}
	function sortCallbackEmail(a, b) {
	  if (!a.email || !b.email)
	    { return 0; }
	  return a.email.localeCompare(b.email);
	}

	function checkUpdateContact(contacts, updatedContact) {
	  for (var i = 0; i < contacts.length; i += 1) {
	    if (contacts[i].contactId === updatedContact.contactId) {
	      var firstNameLastNameEmail = updatedContact.firstName ? ((updatedContact.firstName.toLowerCase().trim()) + "_") : '';
	      firstNameLastNameEmail += updatedContact.lastName ? ((updatedContact.lastName.toLowerCase().trim()) + "_") : '';
	      firstNameLastNameEmail += updatedContact.email ? updatedContact.email.toLowerCase().trim() : '';
	      var contact = {
	        contactId: updatedContact.contactId,
	        firstName: updatedContact.firstName,
	        lastName: updatedContact.lastName,
	        email: updatedContact.email,
	        contactType: updatedContact.contactType,
	        firstNameLastNameEmail: firstNameLastNameEmail,
	        firstNameLastNameNull: Utils$1.isUndefined(updatedContact.firstName) && Utils$1.isUndefined(updatedContact.lastName),
	      };

	      Vue.set(contacts, i, contact);
	      return true;
	    }
	  }
	  return false;
	}

	function onUserInviteSubscribeFinished(response) {
	  if (!response) { return; }
	  var self = this;
	  var invite = response.data || response;
	  var q = self.query ? new RegExp(self.query, 'gim') : false;
	  var inviteIndex = findKey_1(self.storeInvite.invites, { email: invite.email }) || findKey_1(self.storeInvite.invites, { inviteId: invite.inviteId }); // find by email for new entries, find by id for invites with changed email just in case
	  if (response.deleteThis) {
	    if (!isUndefined_1(inviteIndex)) { self.storeInvite.invites.splice(inviteIndex, 1); } // remove from list
	  } else if (!q || q.test(invite.email)) {
	    if (!isUndefined_1(inviteIndex)) {
	      Vue.set(self.storeInvite.invites, inviteIndex, invite);
	    } else {
	      self.storeInvite.invites.unshift(invite);
	      self.storeInvite.invites.sort(sortCallbackEmail);
	    }
	  }
	}
	function onUserListSubscribeFinished(response) {
	  if (!response) { return; }
	  var self = this;
	  var user = response.data || response; // self.store.newUsers || [];
	  if (user.userId === self.store.userId) { return; } // current user shouldn't be updated in the list
	  var q = self.query ? new RegExp(self.query, 'gim') : false;
	  var userIndex = findKey_1(self.store.users, { userId: user.userId || user.id });
	  if (response.deleteThis) {
	    if (!isUndefined_1(userIndex)) { self.store.users.splice(userIndex, 1); } // remove from list
	  } else if (!q || q.test(user.firstName) || q.test(user.lastName) || q.test(user.email)) {
	    if (!isUndefined_1(userIndex)) {
	      user.lastActiveString = self.getLastActiveString(user.lastActive);
	      Vue.set(self.store.users, userIndex, Object.assign({}, self.store.users[userIndex] || {}, user));
	    } else {
	      self.store.users.unshift(user);
	      self.store.users.sort(sortCallback);
	    }
	  }
	}
	function onUserInvitePostFinished() {
	  var self = this;
	  self.query = '';
	  self.onQueryChange(self.query);

	  if (!self.storeInvite.invites) { return; }
	  var inviteIndexToDelete;
	  self.storeInvite.invites.forEach(function (invite, index) {
	    if (invite.email.indexOf('Inviting') === 0) { inviteIndexToDelete = index; }
	  });
	  if (typeof inviteIndexToDelete !== 'undefined') {
	    self.storeInvite.invites.splice(inviteIndexToDelete, 1);
	  }
	}

	function SetIfFirstNameLastNameNull(contact) {
	  if (Utils$1.isUndefined(contact.firstName) && Utils$1.isUndefined(contact.lastName)) { contact.firstNameLastNameNull = true; }
	}
	function onContactListGetFinished() {
	  var self = this;
	  self.searchbarPreloader = false;
	  if (self.store.contacts) {
	    if (self.store.contacts.length) { self.hasContacts = true; }
	    self.store.contacts.forEach(SetIfFirstNameLastNameNull);
	  }

	  if (self.store.recentContacts) {
	    if (self.store.recentContacts.length) { self.hasRecentContacts = true; }
	    self.store.recentContacts.forEach(SetIfFirstNameLastNameNull);
	  }
	}
	function onContactListGetMoreFinished() {
	  var self = this;

	  if (self.store.contacts) { self.store.contacts.forEach(SetIfFirstNameLastNameNull); }

	  if (self.store.recentContacts) { self.store.recentContacts.forEach(SetIfFirstNameLastNameNull); }
	}
	function onContactListSubscribeFinished(response) {
	  if (!response) { return; }
	  var self = this;
	  var contact = response.data || response;
	  var q = self.query ? new RegExp(self.query, 'gim') : false;
	  var contactIndex = findKey_1(self.store.contacts, { contactId: contact.contactId });
	  var recentContactIndex = findKey_1(self.store.recentContacts, { contactId: contact.contactId });
	  if (response.deleteThis) {
	    if (!isUndefined_1(contactIndex)) { self.store.contacts.splice(contactIndex, 1); } // remove from list
	    if (!isUndefined_1(recentContactIndex)) { self.store.recentContacts.splice(recentContactIndex, 1); } // remove from list
	  } else if (!q || q.test(contact.firstName) || q.test(contact.lastName) || q.test(contact.email)) {
	    if (!isUndefined_1(contactIndex)) { // changed contact
	      Vue.set(self.store.contacts, contactIndex, contact);
	    } else if (!isUndefined_1(recentContactIndex)) { // changed recent contact
	      Vue.set(self.store.recentContacts, recentContactIndex, contact);
	    } else { // added new contact - push to recent
	      // TODO: check contact created time and figure out if it's really recent or not
	      self.store.recentContacts.unshift(contact);
	    }
	  }
	  onContactListGetFinished.bind(this)();
	}

	var usersUpdateInterval;
	var script$q = {
	  name: 'ListUsers',
	  props: {
	    type: String,
	    disableHasTagSearch: Boolean,
	    forceFocusEvent: String,
	    searchPlaceholder: String,
	  },
	  data: function data() {
	    var self = this;
	    var store;
	    var storeInvite;
	    var storePostInvite;
	    var storePostInviteDelete;
	    if (self.type === 'team') {
	      store = new Store(self, {
	        get: ['user', 'list'],
	        getFinished: function getFinished() {
	          self.searchbarPreloader = false;
	          if (store.users.length > 0) { self.hasUsers = true; }
	        },
	        subscribe: ['user', 'list', 'users', {
	          processLocally: true,
	        }],
	        subscribeFinished: onUserListSubscribeFinished,
	      });
	      storeInvite = new Store(self, {
	        get: ['user', 'invitelist'],
	        getFinished: function getFinished() {
	          if (storeInvite.invites.length > 0) { self.hasInvites = true; }
	        },
	        subscribe: ['userinvite', 'list', 'invites', {
	          processLocally: true,
	          subscriptionKey: window.localStorage.getItem('team_id'),
	        }],
	        subscribeFinished: onUserInviteSubscribeFinished,
	      });

	      storePostInvite = new Store(self, {
	        post: ['people', 'invite'],
	        postFinished: onUserInvitePostFinished,
	      });
	      storePostInviteDelete = new Store(self, {
	        post: ['people', 'deleteinvite'],
	      });
	    } else {
	      store = new Store(self, {
	        get: ['contact', 'list'],
	        post: ['contact', 'create'],
	        targetArrayName: 'contacts',
	        getFinished: onContactListGetFinished,
	        getLocalFinished: function () {},
	        getMoreFinished: onContactListGetMoreFinished,
	        subscribe: ['contact', 'list', 'contacts', {
	          processLocally: true,
	          subscriptionKey: window.localStorage.getItem('team_id'),
	        }],
	        subscribeFinished: onContactListSubscribeFinished,
	        targetArrayName: 'contacts',
	      });
	    }

	    if (self.type === 'team') {
	      if (usersUpdateInterval) {
	        clearInterval(usersUpdateInterval);
	      }
	      usersUpdateInterval = setInterval(function () { return store.get(); }, 1 * 60 * 1000);
	    }

	    return {
	      hasUsers: false,
	      hasInvites: false,
	      hasContacts: false,
	      hasRecentContacts: false,
	      hashTagSearch: false,
	      store: store,
	      storeInvite: storeInvite,
	      storePostInvite: storePostInvite,
	      storePostInviteDelete: storePostInviteDelete,
	      query: null,
	      searchbarPreloader: false,
	    };
	  },
	  computed: {
	    orderedContacts: function orderedContacts() {
	      var ordered = this.store.contacts ? this.store.contacts.sort(sortCallback) : null;
	      return ordered;
	    },
	    orderedRecentContacts: function orderedRecentContacts() {
	      var ordered = this.store.recentContacts ? this.store.recentContacts.sort(sortCallback) : null;
	      return ordered;
	    },
	    firstList: function firstList() {
	      var self = this;
	      if (self.type === 'contacts') {
	        return self.orderedRecentContacts;
	      }
	      return self.storeInvite.invites;
	    },
	    mainList: function mainList() {
	      var self = this;
	      if (self.type === 'contacts') {
	        return self.orderedContacts;
	      }
	      return self.store.users;
	    },
	  },
	  watch: {
	    firstList: function watchFirstList(users) {
	      var self = this;
	      function updateUsers() {
	        self.$nextTick(function () {
	          if (!self.$refs.firstList) { return; }
	          self.$refs.firstList.f7VirtualList.replaceAllItems(users);
	        });
	      }
	      if (!self.$refs.firstList) {
	        window.setTimeout(function () {
	          updateUsers();
	        }, 0);
	        return;
	      }
	      updateUsers();
	    },
	    mainList: function watchStoreInvites(users) {
	      var self = this;
	      function updateUsers() {
	        self.$nextTick(function () {
	          if (!self.$refs.mainList) { return; }
	          self.$refs.mainList.f7VirtualList.replaceAllItems(users);
	        });
	      }
	      if (!self.$refs.mainList) {
	        window.setTimeout(function () {
	          updateUsers();
	        }, 0);
	        return;
	      }
	      updateUsers();
	    },
	  },
	  mounted: function mounted() {
	    // Compiled
	    var self = this;
	    if (self.type === 'team') {
	      Brief$1.events.$on('users-refresh', self.reload);
	    } else {
	      Brief$1.events.$on('contacts-refresh', self.reload);
	      Brief$1.events.$on('contacts-updated', self.updateContact);
	      Brief$1.events.$on('contacts-removed', self.removeContact);
	    }
	    self.store.get();
	    if (self.type === 'team') {
	      self.storeInvite.get();
	    }

	    // Attached
	    self.$nextTick(function () {
	      self.scrollRef = $$1(self.$el).closest('.infinite-scroll-content').on('infinite', self.getMore);
	    });
	  },
	  beforeDestroy: function beforeDestroy() {
	    var self = this;

	    self.scrollRef.off('infinite');

	    if (self.type === 'team') {
	      Brief$1.events.$off('users-refresh', self.reload);
	      self.store.dispose();
	      self.storeInvite.dispose();
	      self.storePostInvite.dispose();
	      self.storePostInviteDelete.dispose();
	    } else {
	      Brief$1.events.$off('contacts-refresh', self.reload);
	      Brief$1.events.$off('contacts-updated', self.updateContact);
	      Brief$1.events.$off('contacts-removed', self.removeContact);
	      self.store.dispose();
	    }
	  },
	  methods: {
	    getLiHeight: function getLiHeight() {
	      if (this.type === 'team') {
	        return this.$root.$theme.ios ? 57 : 70;
	      }
	      return this.$root.$theme.ios ? 50 : 56;
	    },
	    updateContact: function updateContact(updatedContact) {
	      var self = this;
	      if (!checkUpdateContact(self.store.recentContacts, updatedContact)) {
	        checkUpdateContact(self.store.contacts, updatedContact);
	      }
	    },
	    removeContact: function removeContact(removedContact) {
	      var self = this;
	      for (var i = 0; i < self.store.recentContacts.length; i += 1) {
	        var contact = self.store.recentContacts[i];
	        if (contact.contactId === removedContact.id) {
	          self.store.recentContacts.splice(i, 1);
	          return;
	        }
	      }
	      for (var i$1 = 0; i$1 < self.store.contacts.length; i$1 += 1) {
	        var contact$1 = self.store.contacts[i$1];
	        if (contact$1.contactId === removedContact.id) {
	          self.store.contacts.splice(i$1, 1);
	          return;
	        }
	      }
	    },
	    debounceSearch: debounce_1(function debounceSearch() {
	      var self = this;
	      self.store.get({ query: self.query });
	      if (self.type === 'team') {
	        self.storeInvite.get({ query: self.query });
	      }
	    }, 500),
	    reload: function reload() {
	      var self = this;
	      self.store.reload();
	      if (self.type === 'team') {
	        self.storeInvite.reload();
	      }
	    },
	    getMore: function getMore() {
	      var self = this;
	      self.store.getMore();
	    },
	    onQueryChange: function onQueryChange(query) {
	      var self = this;
	      if (query && self.query === query || query === null) { return; }
	      self.query = query;
	      self.searchbarPreloader = true;
	      self.debounceSearch();
	    },
	    addContact: function addContact(email) {
	      var self = this;
	      if (self.store.isLoading) { return; }

	      if (self.store.contacts.length > 0 || self.store.recentContacts.length > 0) { return; }

	      if (!Utils$1.isEmail(email)) { return; }
	      else if (email.contains(self.team)) { return; }
	      self.store.post({ email: email, contactType: 'Contact' });
	      this.onQueryChange('');
	    },
	    inviteUser: function inviteUser(email) {
	      var self = this;
	      if (self.store.isLoading) { return; }

	      if (self.storeInvite.invites.length > 0 || self.store.users.length > 0) { return; }

	      if (!Utils$1.isEmail(email)) { return; }

	      self.storePostInvite.post({ email: email });
	      self.storeInvite.invites.push({ email: 'Inviting...', inviteId: email });
	    },
	    onEnterPress: function onEnterPress(query) {
	      var self = this;
	      if (self.type === 'contacts') {
	        self.addContact(query);
	      } else {
	        self.inviteUser(query);
	      }
	    },
	    onInvite: function onInvite() {
	      var self = this;
	      self.inviteUser(self.query);
	    },
	    onAddContact: function onAddContact() {
	      var self = this;
	      self.addContact(self.query);
	    },
	    onHashTagSearchChange: function onHashTagSearchChange(value) {
	      var self = this;
	      self.hashTagSearch = value;
	    },
	    virtualItemRenderFirstList: function virtualItemRenderFirstList(user, index) {
	      var self = this;
	      if (self.type === 'contacts') {
	        return self.virtualItemRenderMainList(user, index);
	      }
	      var itemIndex = index;
	      if (typeof index !== 'number' && typeof index === 'object') {
	        itemIndex = index.index;
	      }
	      return ("<li data-index=\"" + itemIndex + "\">\n                <div class=\"item-content\">\n                  <div class=\"item-inner\">\n                    <div class=\"item-title\">" + (user.email) + "</div>\n                    <div class=\"button notification-icon-wrap refresh-button\" data-index=\"" + itemIndex + "\">\n                      <i class=\"icon f7-icons\">refresh_round</i>\n                    </div>\n                  </div>\n                </div>\n              </li>");
	    },
	    virtualItemRenderMainList: function virtualItemRenderMainList(user, index) {
	      var self = this;
	      var itemIndex = index;
	      if (typeof index !== 'number' && typeof index === 'object') {
	        itemIndex = index.index;
	      }
	      var title;
	      var link;
	      var avatar;
	      if (self.type === 'team') {
	        // team user
	        title = (user.firstName) + " " + (user.lastName);
	        link = "/user/" + (user.userId) + "/";
	        avatar = self.path.imageUrl(user.photoFile ? user.photoFile.filename : 'avatar.png');
	      } else {
	        // contact user
	        title = !user.firstNameLastNameNull ? (((user.firstName.replace('<', '').replace('>', '')) + " " + (user.lastName || ''))) : user.email;
	        link = "/contact/" + (user.contactType) + "/" + (user.contactId) + "/";
	        avatar = self.path.imageUrl('avatar.png');
	        if (user.contactType === 'facebookContact') {
	          avatar = (this.domain) + "/api/facebook/picture?id=" + (user.email.replace('@facebook.com', '')) + "&channelId=" + (user.channelId || '');
	        } else if (user.contactType === 'instagramContact') {
	          avatar = user.avatarUrl || self.path.imageUrl('avatar.png');
	        }
	      }
	      if (user.contactType !== 'instagramContact') {
	        avatar = self.path.imageUrl(avatar, ("h=" + (Math.ceil(34 * Brief$1.f7.device.pixelRatio)) + "&404=avatar&autorotate=true"));
	      }

	      return ("<li data-index=\"" + itemIndex + "\">\n                <a href=\"" + link + "\" class=\"item-link\">\n                  <div class=\"item-content\">\n                    <div class=\"item-media\">\n                      <span class=\"common-avatar\" style=\"background-image: url(" + avatar + "), url(" + (self.path.imageUrl('avatar.png', 'h=45&404=avatar&autorotate=true')) + ")\"></span>\n                    </div>\n                    <div class=\"item-inner\">\n                      <div class=\"item-title-row\">\n                        <div class=\"item-title\">" + (user.isAdmin ? '<span style="font-size: 9px">Admin</span>' : '') + " " + title + "</div>\n                      </div>\n                      <div class=\"item-subtitle\">" + (user.lastActiveString || '') + "</div>\n                    </div>\n                  </div>\n                </a>\n              </li>");
	    },
	    virtualAfterInsert: function virtualAfterInsert(vlist) {
	      var self = this;
	      var list = $$1(vlist.ul);

	      var listName = list.parents('.list').attr('data-name');
	      var title;
	      if (self.type === 'contacts') {
	        title = listName === 'main-list' ? 'Contacts' : 'Newly added';
	      } else {
	        title = listName === 'main-list' ? 'Users' : 'Pending invites';
	      }
	      list.prepend(("<li class=\"item-divider\">" + title + "</li>"));
	      vlist.setListSize();
	      list.css({ height: ((list.height() + (self.$theme.ios ? 31 : 48)) + "px") });

	      function refreshClick() {
	        var index = $$1(this).attr('data-index');
	        var id = self.storeInvite.invites[index].inviteId;
	        $$1(this).hide();
	        self.storePostInvite.post({ id: id });
	      }

	      if (listName === 'first-list') {
	        list.find('.refresh-button').off('click');
	        list.find('.refresh-button').on('click', refreshClick);
	      }
	    },
	    getLastActiveString: function getLastActiveString(lastActive) {
	      if (!lastActive) {
	        return '';
	      }
	      var s = null;
	      var minsDiff = (new Date() - new Date(lastActive)) / 1000 / 60;
	      if (minsDiff < 2) {
	        s = 'Online';
	      } else {
	        s = 'Last seen ' + hooks$1(lastActive).locale('en').fromNow();
	      }
	      return s || '';
	    },
	    openInvitePopover: function openInvitePopover(event, item) {
	      var self = this;
	      var dynamicPopover = Brief$1.f7.popover.create({
	        targetEl: event.target,
	        content: '<div class="popover">'+
	                    '<div class="popover-inner">'+
	                      '<div class="block">'+
	                        '<p><a href="#" data-action="resend" class="link popover-close">Resend</a></p>'+
	                        '<p><a href="#" data-action="delete" class="link popover-close" style="color: red">Delete</a></p>'+
	                      '</div>'+
	                    '</div>'+
	                  '</div>',
	        // Events
	        on: {
	          open: function (popover) {
	            $$1(popover.el).find('[data-action=resend]').on('click', function () {
	              self.storePostInvite.post({ id: item.inviteId });
	            });
	            $$1(popover.el).find('[data-action=delete]').on('click', function () {
	              self.storePostInviteDelete.post({ id: item.inviteId });
	            });
	          },
	        }
	      });
	      // Events also can be assigned on instance later
	      dynamicPopover.on('close', function (popover) {
	      });
	      dynamicPopover.on('closed', function (popover) {
	      });
	      dynamicPopover.open();
	    },
	  },
	};

	/* script */
	var __vue_script__$q = script$q;

	/* template */
	var __vue_render__$n = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('common-search',{attrs:{"title":_vm.searchPlaceholder,"hash-tag-search":_vm.hashTagSearch,"query":_vm.query,"force-focus-event":_vm.forceFocusEvent,"disable-hash-tag":_vm.disableHasTagSearch,"wrap":true,"preloader":_vm.searchbarPreloader},on:{"querychange":_vm.onQueryChange,"hashtagsearchchange":_vm.onHashTagSearchChange,"enterpress":_vm.onEnterPress}}),_vm._v(" "),_c('common-user-list-invite-info',{attrs:{"type":_vm.type,"hasUsers":_vm.type === 'contacts' ? (_vm.hasContacts || _vm.hasRecentContacts) : (_vm.hasUsers || _vm.hasInvites),"firstList":_vm.firstList,"mainList":_vm.mainList,"query":_vm.query,"hashTagSearch":_vm.hashTagSearch},on:{"invite":_vm.onInvite,"addContact":_vm.onAddContact}}),_vm._v(" "),(!_vm.hashTagSearch)?_c('div',[(_vm.type !== 'contacts' && _vm.firstList.length > 0)?_c('f7-list',{staticStyle:{"margin-top":"5px","margin-bottom":"5px"}},_vm._l((_vm.firstList),function(item){return _c('f7-list-item',{attrs:{"title":item.email,"link":"#"},on:{"click":function($event){return _vm.openInvitePopover($event, item)}}},[_c('f7-icon',{attrs:{"slot":"after","if-ios":"f7:more","if-md":"f7:more"},slot:"after"})],1)}),1):_vm._e(),_vm._v(" "),(_vm.type === 'contacts' && _vm.firstList && _vm.firstList.length > 0)?_c('f7-list',{ref:"firstList",staticClass:"users-list",attrs:{"virtual-list":"","virtual-list-params":{items: _vm.firstList, renderItem: _vm.virtualItemRenderFirstList, height: _vm.getLiHeight() },"data-name":"first-list"},on:{"virtual:itemsafterinsert":_vm.virtualAfterInsert}}):_vm._e(),_vm._v(" "),_c('f7-list',{ref:"mainList",staticClass:"users-list",attrs:{"virtual-list":"","media-list":"","virtual-list-params":{items: _vm.mainList, renderItem: _vm.virtualItemRenderMainList, height: _vm.getLiHeight() },"data-name":"main-list"},on:{"virtual:itemsafterinsert":_vm.virtualAfterInsert}})],1):_vm._e(),_vm._v(" "),(!_vm.store.noMoreToGet)?_c('div',{staticClass:"infinite-scroll-preloader",class:{invisible: !_vm.store.isLoading}},[_c('f7-preloader')],1):_vm._e(),_vm._v(" "),(!_vm.store.isLoading && (!_vm.firstList || _vm.firstList.length === 0) && (!_vm.mainList || _vm.mainList.length === 0) && !_vm.query)?_c('common-empty-message',{attrs:{"subtext":_vm.type !== 'contacts' ? 'Invite your team members' : 'Start adding your contacts'}}):_vm._e()],1)};
	var __vue_staticRenderFns__$n = [];

	  /* style */
	  var __vue_inject_styles__$q = undefined;
	  /* scoped */
	  var __vue_scope_id__$q = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$q = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$q = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$q = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$n, staticRenderFns: __vue_staticRenderFns__$n },
	    __vue_inject_styles__$q,
	    __vue_script__$q,
	    __vue_scope_id__$q,
	    __vue_is_functional_template__$q,
	    __vue_module_identifier__$q,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//

	var script$r = {
	  name: 'UserListInviteInfo',
	  props: {
	    query: String,
	    firstList: Array,
	    mainList: Array,
	    hasUsers: Boolean,
	    hashTagSearch: Boolean,
	    type: String,
	  },
	  data: function data() {
	    var self = this;
	    return {
	      forceInfo: false,
	      isVisible: false,
	      isPioneer: false,
	      visibleEvents: self.type === 'contacts'
	        ? ('info-invite-contact').split(' ')
	        : ('info-invite-team').split(' '),
	      invisibleEvents: self.type === 'contacts'
	        ? ('info-update-profile info-add-channels').split(' ')
	        : ('info-update-profile info-add-strechannels close-info-invite').split(' '),
	      actionText: self.type === 'contacts' ? 'add' : 'invite',
	      introText: self.type === 'contacts' ? 'Start adding your contacts' : 'Start inviting your team',
	    };
	  },
	  mounted: function mounted() {
	    var self = this;
	    self.visibleEvents.forEach(function (eventName) {
	      Brief$1.events.$on(eventName, function (forceInfo) {
	        if (forceInfo) { self.forceInfo = forceInfo; }
	        self.isVisible = true;
	      });
	    });
	    self.invisibleEvents.forEach(function (eventName) {
	      Brief$1.events.$on(eventName, function () {
	        self.forceInfo = null;
	        self.isVisible = false;
	      });
	    });
	  },
	  beforeDestroy: function beforeDestroy() {
	    var self = this;
	    self.visibleEvents.forEach(function (eventName) {
	      Brief$1.events.$off(eventName);
	    });
	    self.invisibleEvents.forEach(function (eventName) {
	      Brief$1.events.$off(eventName);
	    });
	  },
	  computed: {
	    info: function info() {
	      var self = this;

	      if (self.hashTagSearch) { return null; }

	      if (!self.mainList) { return null; }
	      
	      if (self.forceInfo) { return self.forceInfo; }

	      //const noUsers = self.type === 'team' ? self.mainList.length === 0 && self.firstList.length === 0 : self.mainList.length === 0;
	      var noUsers = self.mainList && self.mainList.length === 0 && self.firstList && self.firstList.length === 0;

	      var isSearching = self.query && self.query.length > 0;
	      var isEmail = Utils$1.isEmail(self.query);

	      if (self.isVisible && !isSearching && noUsers) {
	        if (noUsers) { self.isPioneer = true; }
	        return 'intro';
	      }

	      if (self.isPioneer && !isSearching && noUsers) {
	        return 'pioneer';
	      }

	      if (self.type === 'contacts') {
	        if (isEmail && isSearching && noUsers && self.query.contains(self.team)) {
	          return 'no-team';
	        }
	      }

	      if (isEmail && isSearching && noUsers) {
	        return 'action';
	      }

	      if (isSearching && !self.hasUsers) { return 'intro'; }

	      if (self.type === 'contacts' && noUsers && isSearching && self.query.contains('#')) {
	        return 'no-tag-results';
	      }
	      if (isSearching && noUsers) {
	        return 'no-results';
	      }

	      return null;
	    },
	  },
	  methods: {
	    onButtonClick: function onButtonClick() {
	      if (this.type === 'team') {
	        this.$emit('invite');
	      } else {
	        this.$emit('addContact');
	      }
	    },
	  },
	};

	/* script */
	var __vue_script__$r = script$r;

	/* template */
	var __vue_render__$o = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info-invite-team",class:{'fadeInUp': _vm.isVisible, 'animated': _vm.isVisible}},[(_vm.info === 'intro')?_c('div',{staticClass:"info-box"},[_vm._v(_vm._s(_vm.introText)+". Type their email address.")]):_vm._e(),_vm._v(" "),(_vm.info === 'pioneer')?_c('div',{staticClass:"info-box"},[_vm._v("Good, "+_vm._s(_vm.actionText)+" as many as you can to make this place crowded!")]):_vm._e(),_vm._v(" "),(_vm.info === 'no-team')?_c('div',{staticClass:"info-box"},[_vm._v("Please invite team members from Team tab only.")]):_vm._e(),_vm._v(" "),(_vm.info === 'action')?_c('div',{staticClass:"info-box info-box-button"},[_c('a',{staticClass:"button button-fill button-raised color-green",attrs:{"href":"#"},on:{"click":_vm.onButtonClick}},[_c('f7-icon',{attrs:{"if-ios":"f7:check","if-md":"material:check"}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.type === 'contacts' ? 'Add Contact' : 'Invite'))])],1)]):_vm._e(),_vm._v(" "),(_vm.info === 'no-tag-results')?_c('div',{staticClass:"info-box"},[_vm._v("Could not find any contacts for tag "),_c('b',[_vm._v(_vm._s(_vm.query))]),_vm._v(".")]):_vm._e(),_vm._v(" "),(_vm.info === 'no-results')?_c('div',{staticClass:"info-box"},[_vm._v("Could not find "),_c('b',[_vm._v(_vm._s(_vm.query))]),_vm._v(". Type email to "+_vm._s(_vm.actionText)+".")]):_vm._e()])};
	var __vue_staticRenderFns__$o = [];

	  /* style */
	  var __vue_inject_styles__$r = undefined;
	  /* scoped */
	  var __vue_scope_id__$r = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$r = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$r = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$r = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$o, staticRenderFns: __vue_staticRenderFns__$o },
	    __vue_inject_styles__$r,
	    __vue_script__$r,
	    __vue_scope_id__$r,
	    __vue_is_functional_template__$r,
	    __vue_module_identifier__$r,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//

	var script$s = {
	  props: {
	    name: String,
	    description: String,
	    errors: Object,
	  },
	  methods: {
	    channelNameInput: function channelNameInput(e) {
	      this.$emit('commonInfoChange', { name: e.target.value });
	    },
	    channelDescriptionInput: function channelDescriptionInput(e) {
	      this.$emit('commonInfoChange', { description: e.target.value });
	    },
	    save: function save() {
	      this.$emit('commonInfoSave');
	    },
	  },
	};

	/* script */
	var __vue_script__$s = script$s;

	/* template */
	var __vue_render__$p = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('f7-block-title',[_vm._v("Channel settings")]),_vm._v(" "),_c('f7-list',[_c('li',{staticClass:"item-content item-input",class:{'item-input-with-error-message': _vm.errors && _vm.errors.name, 'item-input-invalid': _vm.errors && _vm.errors.name}},[_c('div',{staticClass:"item-inner"},[_c('div',{staticClass:"item-input-wrap"},[_c('input',{attrs:{"type":"text","placeholder":"Channel name"},domProps:{"value":_vm.name},on:{"input":_vm.channelNameInput},nativeOn:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.save.apply(null, arguments)}}}),_vm._v(" "),(_vm.errors && _vm.errors.name)?_c('div',{staticClass:"item-input-error-message"},[_vm._v(_vm._s(_vm.errors && _vm.errors.name))]):_vm._e()])])]),_vm._v(" "),_c('f7-list-item',{attrs:{"item-input":""}},[_c('f7-input',{attrs:{"type":"textarea","placeholder":"Channel description (optional)","value":_vm.description},on:{"input":_vm.channelDescriptionInput},nativeOn:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.save.apply(null, arguments)}}})],1)],1)],1)};
	var __vue_staticRenderFns__$p = [];

	  /* style */
	  var __vue_inject_styles__$s = undefined;
	  /* scoped */
	  var __vue_scope_id__$s = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$s = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$s = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$s = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$p, staticRenderFns: __vue_staticRenderFns__$p },
	    __vue_inject_styles__$s,
	    __vue_script__$s,
	    __vue_scope_id__$s,
	    __vue_is_functional_template__$s,
	    __vue_module_identifier__$s,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//

	var script$t = {
	  props: {
	    isAutoReply: Boolean,
	    autoReplyText: String,
	  },
	  methods: {
	    autoReplyInput: function autoReplyInput(e) {
	      this.$emit('autoReplyTextChange', { autoReplyText: e.target.value });
	    },
	    checkAutoReply: function checkAutoReply() {
	      var ref = this.$refs;
	      var toggle = ref.toggle;
	      var toggleEl = toggle.$el.querySelector('input');
	      this.$emit('isAutoReplyChange', toggleEl.checked);
	    },
	  },
	};

	/* script */
	var __vue_script__$t = script$t;

	/* template */
	var __vue_render__$q = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('f7-list',{attrs:{"media-list":""}},[_c('f7-list-item',{attrs:{"title":"Auto reply"}},[_c('f7-toggle',{ref:"toggle",attrs:{"slot":"after","checked":_vm.isAutoReply},nativeOn:{"change":function($event){return _vm.checkAutoReply.apply(null, arguments)}},slot:"after"})],1),_vm._v(" "),_c('f7-list-item',{attrs:{"item-input":""}},[_c('f7-input',{attrs:{"type":"textarea","placeholder":"Auto reply text","value":_vm.autoReplyText},on:{"input":_vm.autoReplyInput}})],1)],1)],1)};
	var __vue_staticRenderFns__$q = [];

	  /* style */
	  var __vue_inject_styles__$t = undefined;
	  /* scoped */
	  var __vue_scope_id__$t = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$t = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$t = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$t = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$q, staticRenderFns: __vue_staticRenderFns__$q },
	    __vue_inject_styles__$t,
	    __vue_script__$t,
	    __vue_scope_id__$t,
	    __vue_is_functional_template__$t,
	    __vue_module_identifier__$t,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//

	var script$u = {
	  props: ['visibility'],
	  methods: {
	    checkVisibility: function checkVisibility() {
	      var self = this;
	      var visibility = self.visibility;
	      var newVisibility;
	      var ref = self.$refs;
	      var toggle = ref.toggle;
	      var checkbox = ref.checkbox;
	      var toggleEl = toggle.$el.querySelector('input');
	      var checkboxEl = checkbox && checkbox.$el.querySelector('input');
	      if (toggleEl.checked) {
	        if (checkboxEl && checkboxEl.checked) { newVisibility = 'forced'; }
	        else { newVisibility = 'public'; }
	      } else {
	        newVisibility = 'private';
	      }
	      if (newVisibility && visibility && newVisibility !== visibility) {
	        self.$emit('visibilityChange', newVisibility);
	      }
	    },
	  },
	};

	/* script */
	var __vue_script__$u = script$u;

	/* template */
	var __vue_render__$r = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('f7-block-title',[_vm._v("Channel visibility")]),_vm._v(" "),_c('f7-list',{attrs:{"media-list":""}},[_c('f7-list-item',{attrs:{"title":_vm.visibility === 'private' ? 'Private' : 'Public',"subtitle":_vm.visibility === 'private' ? 'Private channels are invite-only' : 'Anyone in your team can join'}},[_c('f7-toggle',{ref:"toggle",attrs:{"slot":"after","checked":_vm.visibility === 'public' || _vm.visibility === 'forced'},nativeOn:{"change":function($event){return _vm.checkVisibility.apply(null, arguments)}},slot:"after"})],1),_vm._v(" "),(_vm.visibility === 'public' || _vm.visibility === 'forced')?_c('f7-list-item',{ref:"checkbox",attrs:{"checkbox":"","checked":_vm.visibility === 'forced',"title":"Auto join everybody on the team"},on:{"change":_vm.checkVisibility}}):_vm._e()],1)],1)};
	var __vue_staticRenderFns__$r = [];

	  /* style */
	  var __vue_inject_styles__$u = undefined;
	  /* scoped */
	  var __vue_scope_id__$u = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$u = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$u = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$u = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$r, staticRenderFns: __vue_staticRenderFns__$r },
	    __vue_inject_styles__$u,
	    __vue_script__$u,
	    __vue_scope_id__$u,
	    __vue_is_functional_template__$u,
	    __vue_module_identifier__$u,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//

	var script$v = {
	  props: {
	    threshold: [Number, String],
	  },
	  methods: {
	    isSelected: function isSelected(n) {
	      var self = this;
	      var threshold = self.threshold;
	      if (!threshold || threshold === 'undefined') {
	        return n === 6;
	      }
	      return n === parseInt(threshold, 10);
	    },
	    onChange: function onChange(e) {
	      this.$emit('waitLimitChange', e.target.value);
	    },
	  },
	};

	/* script */
	var __vue_script__$v = script$v;

	/* template */
	var __vue_render__$s = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('f7-list',{attrs:{"item-input":""}},[_c('f7-list-item',[_c('f7-input',{attrs:{"type":"select","value":_vm.threshold || 6},on:{"change":_vm.onChange}},[_c('span',{attrs:{"slot":"info"},slot:"info"},[_vm._v("Minimum amount of time (in hours) for conversation to appear in \"Waited a long time for an answer\" list")]),_vm._v(" "),_vm._l((48),function(n){return _c('option',{attrs:{"checked":_vm.isSelected(n)},domProps:{"value":n,"selected":_vm.isSelected(n)}},[_vm._v(_vm._s(n)+" "+_vm._s(n === 1 ? 'hour' : 'hours'))])})],2)],1)],1)],1)};
	var __vue_staticRenderFns__$s = [];

	  /* style */
	  var __vue_inject_styles__$v = undefined;
	  /* scoped */
	  var __vue_scope_id__$v = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$v = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$v = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$v = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$s, staticRenderFns: __vue_staticRenderFns__$s },
	    __vue_inject_styles__$v,
	    __vue_script__$v,
	    __vue_scope_id__$v,
	    __vue_is_functional_template__$v,
	    __vue_module_identifier__$v,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//

	function assignFinished(result) {
	  var self = this;
	  self.assignInProgress = false;
	  if (result.success) {
	    Brief$1.f7.popup.close('.popup-main');
	  }
	}
	function getMoreUsers() {
	  var self = this;
	  self.storeUsers.getMore();
	}
	function handleGetFinished() {
	  var self = this;
	  self.searchbarPreloader = false;

	  for (var i = 0; i < self.storeUsers.users.length; i += 1) {
	    self.storeUsers.users[i].selected = false;
	  }
	}
	var script$w = {
	  props: ['id', 'conversationId', 'type'],
	  data: function data() {
	    var self = this;

	    var storeStream = new Store(self, {
	      post: ['conversation', 'assign'],
	      postFinished: assignFinished,
	    });

	    var storeUsers = new Store(self, {
	      get: ['conversation', 'assign', {
	        streamId: self.id,
	        streamType: Utils$1.capitalize(self.type),
	        conversationId: decodeURIComponent(self.conversationId),
	      }],
	      getFinished: handleGetFinished.bind(self),
	      getLocalFinished: function getLocalFinished() {},
	    });

	    return {
	      storeUsers: storeUsers,
	      storeStream: storeStream,
	      query: null,
	      showAssignButton: false,
	      assignInProgress: false,
	      selectedUserCount: 0,
	      searchbarPreloader: false
	    };
	  },
	  mounted: function mounted() {
	    var self = this;
	    self.storeUsers.get();
	    self.$nextTick(function () {
	      $$1(self.$el).find('.infinite-scroll').on('infinite', getMoreUsers.bind(self));
	    });
	  },
	  beforeDestroy: function beforeDestroy() {
	    var self = this;
	    $$1(self.$el).find('.infinite-scroll').off('infinite', getMoreUsers.bind(self));
	    self.storeUsers.dispose();
	    self.storeStream.dispose();
	  },
	  methods: {
	    selectedUserIds: function selectedUserIds() {
	      if (!this.storeUsers.users) { return []; }
	      var userIds = this.storeUsers.users.filter(function (user) { return user.selected; }).map(function (user) { return user.id; });
	      this.selectedUserCount = userIds.length;
	      return userIds;
	    },
	    debounceSearch: debounce_1(function debounceSearch() {
	      var self = this;
	      self.storeUsers.get({ query: self.query });
	    }, 500),
	    onQueryChange: function onQueryChange(query) {
	      var self = this;
	      self.searchbarPreloader = true;
	      self.query = query;
	      self.debounceSearch();
	    },
	    assign: function assign() {
	      var self = this;
	      self.assignInProgress = true;
	      self.storeStream.post({
	        id: self.id,
	        conversationId: decodeURIComponent(self.conversationId),
	        selectedUserIds: self.selectedUserIds(),
	        type: self.type,
	      });
	    },
	    selectUser: function selectUser(event, user) {
	      if (event.target.checked) { user.selected = true; }
	      else { user.selected = false; }
	      this.showAssignButton = this.selectedUserIds().length > 0;
	    },
	  },
	};

	/* script */
	var __vue_script__$w = script$w;

	/* template */
	var __vue_render__$t = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f7-page',{attrs:{"page-content":false}},[_c('f7-navbar',[_c('f7-nav-left',[_c('common-nav-placeholder')],1),_vm._v(" "),_c('f7-nav-title',[_vm._v("\n      Assign team members\n    ")]),_vm._v(" "),_c('f7-nav-right',[_c('f7-link',{attrs:{"popup-close":""}},[_c('f7-icon',{attrs:{"material":"close","size":"30"}})],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"page-content infinite-scroll"},[_c('f7-list',{staticClass:"invite-team-search-results",attrs:{"inset":""}},[_c('ul',[_vm._l((_vm.storeUsers.users),function(user){return _c('li',[_c('label',{staticClass:"item-checkbox item-content"},[_c('input',{attrs:{"type":"checkbox"},domProps:{"value":user.id,"checked":user.selected},on:{"change":function($event){return _vm.selectUser($event, user)}}}),_vm._v(" "),_c('i',{staticClass:"icon icon icon-checkbox"}),_vm._v(" "),_c('div',{staticClass:"item-media"},[_c('common-avatar',{attrs:{"avatar":user.photoFile}})],1),_vm._v(" "),_c('div',{staticClass:"item-inner"},[_c('div',{staticClass:"item-title"},[_vm._v(_vm._s(user.firstName)+" "+_vm._s(user.lastName))])])])])}),_vm._v(" "),(_vm.storeUsers.users && _vm.storeUsers.users.length === 0)?_c('li',{staticClass:"item-content"},[_c('div',{staticClass:"item-inner"},[_c('div',{staticClass:"item-title"},[_vm._v("No team members found")])])]):_vm._e()],2)]),_vm._v(" "),(_vm.storeUsers.isLoading)?_c('div',{staticClass:"infinite-scroll-preloader"},[_c('f7-preloader')],1):_vm._e(),_vm._v(" "),(_vm.showAssignButton)?_c('f7-block',{staticStyle:{"position":"fixed","width":"100%","bottom":"0"}},[_c('f7-button',{staticStyle:{"display":"flex","justify-content":"center","align-items":"center"},attrs:{"big":"","fill":""},on:{"click":_vm.assign}},[(!_vm.assignInProgress)?_c('span',{staticStyle:{"display":"flex","gap":"6px","align-items":"center"}},[_c('span',[_vm._v("Assign")]),_vm._v(" "),_c('span',{staticClass:"badge bg-color-green"},[_vm._v(_vm._s(_vm.selectedUserCount))])]):_vm._e(),_vm._v(" "),(_vm.assignInProgress)?_c('f7-preloader',{attrs:{"color":"white"}}):_vm._e()],1)],1):_vm._e()],1)],1)};
	var __vue_staticRenderFns__$t = [];

	  /* style */
	  var __vue_inject_styles__$w = undefined;
	  /* scoped */
	  var __vue_scope_id__$w = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$w = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$w = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$w = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$t, staticRenderFns: __vue_staticRenderFns__$t },
	    __vue_inject_styles__$w,
	    __vue_script__$w,
	    __vue_scope_id__$w,
	    __vue_is_functional_template__$w,
	    __vue_module_identifier__$w,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	var tlds = createCommonjsModule(function (module, exports) {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.TLDs = "(AAA|AARP|ABARTH|ABB|ABBOTT|ABBVIE|ABC|ABLE|ABOGADO|ABUDHABI|AC|ACADEMY|ACCENTURE|ACCOUNTANT|ACCOUNTANTS|ACO|ACTOR|AD|ADAC|ADS|ADULT|AE|AEG|AERO|AETNA|AF|AFAMILYCOMPANY|AFL|AFRICA|AG|AGAKHAN|AGENCY|AI|AIG|AIGO|AIRBUS|AIRFORCE|AIRTEL|AKDN|AL|ALFAROMEO|ALIBABA|ALIPAY|ALLFINANZ|ALLSTATE|ALLY|ALSACE|ALSTOM|AM|AMERICANEXPRESS|AMERICANFAMILY|AMEX|AMFAM|AMICA|AMSTERDAM|ANALYTICS|ANDROID|ANQUAN|ANZ|AO|AOL|APARTMENTS|APP|APPLE|AQ|AQUARELLE|AR|ARAB|ARAMCO|ARCHI|ARMY|ARPA|ART|ARTE|AS|ASDA|ASIA|ASSOCIATES|AT|ATHLETA|ATTORNEY|AU|AUCTION|AUDI|AUDIBLE|AUDIO|AUSPOST|AUTHOR|AUTO|AUTOS|AVIANCA|AW|AWS|AX|AXA|AZ|AZURE|BA|BABY|BAIDU|BANAMEX|BANANAREPUBLIC|BAND|BANK|BAR|BARCELONA|BARCLAYCARD|BARCLAYS|BAREFOOT|BARGAINS|BASEBALL|BASKETBALL|BAUHAUS|BAYERN|BB|BBC|BBT|BBVA|BCG|BCN|BD|BE|BEATS|BEAUTY|BEER|BENTLEY|BERLIN|BEST|BESTBUY|BET|BF|BG|BH|BHARTI|BI|BIBLE|BID|BIKE|BING|BINGO|BIO|BIZ|BJ|BLACK|BLACKFRIDAY|BLOCKBUSTER|BLOG|BLOOMBERG|BLUE|BM|BMS|BMW|BN|BNPPARIBAS|BO|BOATS|BOEHRINGER|BOFA|BOM|BOND|BOO|BOOK|BOOKING|BOSCH|BOSTIK|BOSTON|BOT|BOUTIQUE|BOX|BR|BRADESCO|BRIDGESTONE|BROADWAY|BROKER|BROTHER|BRUSSELS|BS|BT|BUDAPEST|BUGATTI|BUILD|BUILDERS|BUSINESS|BUY|BUZZ|BV|BW|BY|BZ|BZH|CA|CAB|CAFE|CAL|CALL|CALVINKLEIN|CAM|CAMERA|CAMP|CANCERRESEARCH|CANON|CAPETOWN|CAPITAL|CAPITALONE|CAR|CARAVAN|CARDS|CARE|CAREER|CAREERS|CARS|CASA|CASE|CASEIH|CASH|CASINO|CAT|CATERING|CATHOLIC|CBA|CBN|CBRE|CBS|CC|CD|CEB|CENTER|CEO|CERN|CF|CFA|CFD|CG|CH|CHANEL|CHANNEL|CHARITY|CHASE|CHAT|CHEAP|CHINTAI|CHRISTMAS|CHROME|CHURCH|CI|CIPRIANI|CIRCLE|CISCO|CITADEL|CITI|CITIC|CITY|CITYEATS|CK|CL|CLAIMS|CLEANING|CLICK|CLINIC|CLINIQUE|CLOTHING|CLOUD|CLUB|CLUBMED|CM|CN|CO|COACH|CODES|COFFEE|COLLEGE|COLOGNE|COM|COMCAST|COMMBANK|COMMUNITY|COMPANY|COMPARE|COMPUTER|COMSEC|CONDOS|CONSTRUCTION|CONSULTING|CONTACT|CONTRACTORS|COOKING|COOKINGCHANNEL|COOL|COOP|CORSICA|COUNTRY|COUPON|COUPONS|COURSES|CPA|CR|CREDIT|CREDITCARD|CREDITUNION|CRICKET|CROWN|CRS|CRUISE|CRUISES|CSC|CU|CUISINELLA|CV|CW|CX|CY|CYMRU|CYOU|CZ|DABUR|DAD|DANCE|DATA|DATE|DATING|DATSUN|DAY|DCLK|DDS|DE|DEAL|DEALER|DEALS|DEGREE|DELIVERY|DELL|DELOITTE|DELTA|DEMOCRAT|DENTAL|DENTIST|DESI|DESIGN|DEV|DHL|DIAMONDS|DIET|DIGITAL|DIRECT|DIRECTORY|DISCOUNT|DISCOVER|DISH|DIY|DJ|DK|DM|DNP|DO|DOCS|DOCTOR|DOG|DOMAINS|DOT|DOWNLOAD|DRIVE|DTV|DUBAI|DUCK|DUNLOP|DUPONT|DURBAN|DVAG|DVR|DZ|EARTH|EAT|EC|ECO|EDEKA|EDU|EDUCATION|EE|EG|EMAIL|EMERCK|ENERGY|ENGINEER|ENGINEERING|ENTERPRISES|EPSON|EQUIPMENT|ER|ERICSSON|ERNI|ES|ESQ|ESTATE|ESURANCE|ET|ETISALAT|EU|EUROVISION|EUS|EVENTS|EXCHANGE|EXPERT|EXPOSED|EXPRESS|EXTRASPACE|FAGE|FAIL|FAIRWINDS|FAITH|FAMILY|FAN|FANS|FARM|FARMERS|FASHION|FAST|FEDEX|FEEDBACK|FERRARI|FERRERO|FI|FIAT|FIDELITY|FIDO|FILM|FINAL|FINANCE|FINANCIAL|FIRE|FIRESTONE|FIRMDALE|FISH|FISHING|FIT|FITNESS|FJ|FK|FLICKR|FLIGHTS|FLIR|FLORIST|FLOWERS|FLY|FM|FO|FOO|FOOD|FOODNETWORK|FOOTBALL|FORD|FOREX|FORSALE|FORUM|FOUNDATION|FOX|FR|FREE|FRESENIUS|FRL|FROGANS|FRONTDOOR|FRONTIER|FTR|FUJITSU|FUJIXEROX|FUN|FUND|FURNITURE|FUTBOL|FYI|GA|GAL|GALLERY|GALLO|GALLUP|GAME|GAMES|GAP|GARDEN|GAY|GB|GBIZ|GD|GDN|GE|GEA|GENT|GENTING|GEORGE|GF|GG|GGEE|GH|GI|GIFT|GIFTS|GIVES|GIVING|GL|GLADE|GLASS|GLE|GLOBAL|GLOBO|GM|GMAIL|GMBH|GMO|GMX|GN|GODADDY|GOLD|GOLDPOINT|GOLF|GOO|GOODYEAR|GOOG|GOOGLE|GOP|GOT|GOV|GP|GQ|GR|GRAINGER|GRAPHICS|GRATIS|GREEN|GRIPE|GROCERY|GROUP|GS|GT|GU|GUARDIAN|GUCCI|GUGE|GUIDE|GUITARS|GURU|GW|GY|HAIR|HAMBURG|HANGOUT|HAUS|HBO|HDFC|HDFCBANK|HEALTH|HEALTHCARE|HELP|HELSINKI|HERE|HERMES|HGTV|HIPHOP|HISAMITSU|HITACHI|HIV|HK|HKT|HM|HN|HOCKEY|HOLDINGS|HOLIDAY|HOMEDEPOT|HOMEGOODS|HOMES|HOMESENSE|HONDA|HORSE|HOSPITAL|HOST|HOSTING|HOT|HOTELES|HOTELS|HOTMAIL|HOUSE|HOW|HR|HSBC|HT|HU|HUGHES|HYATT|HYUNDAI|IBM|ICBC|ICE|ICU|ID|IE|IEEE|IFM|IKANO|IL|IM|IMAMAT|IMDB|IMMO|IMMOBILIEN|IN|INC|INDUSTRIES|INFINITI|INFO|ING|INK|INSTITUTE|INSURANCE|INSURE|INT|INTEL|INTERNATIONAL|INTUIT|INVESTMENTS|IO|IPIRANGA|IQ|IR|IRISH|IS|ISMAILI|IST|ISTANBUL|IT|ITAU|ITV|IVECO|JAGUAR|JAVA|JCB|JCP|JE|JEEP|JETZT|JEWELRY|JIO|JLL|JM|JMP|JNJ|JO|JOBS|JOBURG|JOT|JOY|JP|JPMORGAN|JPRS|JUEGOS|JUNIPER|KAUFEN|KDDI|KE|KERRYHOTELS|KERRYLOGISTICS|KERRYPROPERTIES|KFH|KG|KH|KI|KIA|KIM|KINDER|KINDLE|KITCHEN|KIWI|KM|KN|KOELN|KOMATSU|KOSHER|KP|KPMG|KPN|KR|KRD|KRED|KUOKGROUP|KW|KY|KYOTO|KZ|LA|LACAIXA|LAMBORGHINI|LAMER|LANCASTER|LANCIA|LAND|LANDROVER|LANXESS|LASALLE|LAT|LATINO|LATROBE|LAW|LAWYER|LB|LC|LDS|LEASE|LECLERC|LEFRAK|LEGAL|LEGO|LEXUS|LGBT|LI|LIDL|LIFE|LIFEINSURANCE|LIFESTYLE|LIGHTING|LIKE|LILLY|LIMITED|LIMO|LINCOLN|LINDE|LINK|LIPSY|LIVE|LIVING|LIXIL|LK|LLC|LLP|LOAN|LOANS|LOCKER|LOCUS|LOFT|LOL|LONDON|LOTTE|LOTTO|LOVE|LPL|LPLFINANCIAL|LR|LS|LT|LTD|LTDA|LU|LUNDBECK|LUPIN|LUXE|LUXURY|LV|LY|MA|MACYS|MADRID|MAIF|MAISON|MAKEUP|MAN|MANAGEMENT|MANGO|MAP|MARKET|MARKETING|MARKETS|MARRIOTT|MARSHALLS|MASERATI|MATTEL|MBA|MC|MCKINSEY|MD|ME|MED|MEDIA|MEET|MELBOURNE|MEME|MEMORIAL|MEN|MENU|MERCKMSD|METLIFE|MG|MH|MIAMI|MICROSOFT|MIL|MINI|MINT|MIT|MITSUBISHI|MK|ML|MLB|MLS|MM|MMA|MN|MO|MOBI|MOBILE|MODA|MOE|MOI|MOM|MONASH|MONEY|MONSTER|MORMON|MORTGAGE|MOSCOW|MOTO|MOTORCYCLES|MOV|MOVIE|MP|MQ|MR|MS|MSD|MT|MTN|MTR|MU|MUSEUM|MUTUAL|MV|MW|MX|MY|MZ|NA|NAB|NAGOYA|NAME|NATIONWIDE|NATURA|NAVY|NBA|NC|NE|NEC|NET|NETBANK|NETFLIX|NETWORK|NEUSTAR|NEW|NEWHOLLAND|NEWS|NEXT|NEXTDIRECT|NEXUS|NF|NFL|NG|NGO|NHK|NI|NICO|NIKE|NIKON|NINJA|NISSAN|NISSAY|NL|NO|NOKIA|NORTHWESTERNMUTUAL|NORTON|NOW|NOWRUZ|NOWTV|NP|NR|NRA|NRW|NTT|NU|NYC|NZ|OBI|OBSERVER|OFF|OFFICE|OKINAWA|OLAYAN|OLAYANGROUP|OLDNAVY|OLLO|OM|OMEGA|ONE|ONG|ONL|ONLINE|ONYOURSIDE|OOO|OPEN|ORACLE|ORANGE|ORG|ORGANIC|ORIGINS|OSAKA|OTSUKA|OTT|OVH|PA|PAGE|PANASONIC|PARIS|PARS|PARTNERS|PARTS|PARTY|PASSAGENS|PAY|PCCW|PE|PET|PF|PFIZER|PG|PH|PHARMACY|PHD|PHILIPS|PHONE|PHOTO|PHOTOGRAPHY|PHOTOS|PHYSIO|PICS|PICTET|PICTURES|PID|PIN|PING|PINK|PIONEER|PIZZA|PK|PL|PLACE|PLAY|PLAYSTATION|PLUMBING|PLUS|PM|PN|PNC|POHL|POKER|POLITIE|PORN|POST|PR|PRAMERICA|PRAXI|PRESS|PRIME|PRO|PROD|PRODUCTIONS|PROF|PROGRESSIVE|PROMO|PROPERTIES|PROPERTY|PROTECTION|PRU|PRUDENTIAL|PS|PT|PUB|PW|PWC|PY|QA|QPON|QUEBEC|QUEST|QVC|RACING|RADIO|RAID|RE|READ|REALESTATE|REALTOR|REALTY|RECIPES|RED|REDSTONE|REDUMBRELLA|REHAB|REISE|REISEN|REIT|RELIANCE|REN|RENT|RENTALS|REPAIR|REPORT|REPUBLICAN|REST|RESTAURANT|REVIEW|REVIEWS|REXROTH|RICH|RICHARDLI|RICOH|RIGHTATHOME|RIL|RIO|RIP|RMIT|RO|ROCHER|ROCKS|RODEO|ROGERS|ROOM|RS|RSVP|RU|RUGBY|RUHR|RUN|RW|RWE|RYUKYU|SA|SAARLAND|SAFE|SAFETY|SAKURA|SALE|SALON|SAMSCLUB|SAMSUNG|SANDVIK|SANDVIKCOROMANT|SANOFI|SAP|SARL|SAS|SAVE|SAXO|SB|SBI|SBS|SC|SCA|SCB|SCHAEFFLER|SCHMIDT|SCHOLARSHIPS|SCHOOL|SCHULE|SCHWARZ|SCIENCE|SCJOHNSON|SCOR|SCOT|SD|SE|SEARCH|SEAT|SECURE|SECURITY|SEEK|SELECT|SENER|SERVICES|SES|SEVEN|SEW|SEX|SEXY|SFR|SG|SH|SHANGRILA|SHARP|SHAW|SHELL|SHIA|SHIKSHA|SHOES|SHOP|SHOPPING|SHOUJI|SHOW|SHOWTIME|SHRIRAM|SI|SILK|SINA|SINGLES|SITE|SJ|SK|SKI|SKIN|SKY|SKYPE|SL|SLING|SM|SMART|SMILE|SN|SNCF|SO|SOCCER|SOCIAL|SOFTBANK|SOFTWARE|SOHU|SOLAR|SOLUTIONS|SONG|SONY|SOY|SPACE|SPORT|SPOT|SPREADBETTING|SR|SRL|SS|ST|STADA|STAPLES|STAR|STATEBANK|STATEFARM|STC|STCGROUP|STOCKHOLM|STORAGE|STORE|STREAM|STUDIO|STUDY|STYLE|SU|SUCKS|SUPPLIES|SUPPLY|SUPPORT|SURF|SURGERY|SUZUKI|SV|SWATCH|SWIFTCOVER|SWISS|SX|SY|SYDNEY|SYMANTEC|SYSTEMS|SZ|TAB|TAIPEI|TALK|TAOBAO|TARGET|TATAMOTORS|TATAR|TATTOO|TAX|TAXI|TC|TCI|TD|TDK|TEAM|TECH|TECHNOLOGY|TEL|TEMASEK|TENNIS|TEVA|TF|TG|TH|THD|THEATER|THEATRE|TIAA|TICKETS|TIENDA|TIFFANY|TIPS|TIRES|TIROL|TJ|TJMAXX|TJX|TK|TKMAXX|TL|TM|TMALL|TN|TO|TODAY|TOKYO|TOOLS|TOP|TORAY|TOSHIBA|TOTAL|TOURS|TOWN|TOYOTA|TOYS|TR|TRADE|TRADING|TRAINING|TRAVEL|TRAVELCHANNEL|TRAVELERS|TRAVELERSINSURANCE|TRUST|TRV|TT|TUBE|TUI|TUNES|TUSHU|TV|TVS|TW|TZ|UA|UBANK|UBS|UG|UK|UNICOM|UNIVERSITY|UNO|UOL|UPS|US|UY|UZ|VA|VACATIONS|VANA|VANGUARD|VC|VE|VEGAS|VENTURES|VERISIGN|VERSICHERUNG|VET|VG|VI|VIAJES|VIDEO|VIG|VIKING|VILLAS|VIN|VIP|VIRGIN|VISA|VISION|VIVA|VIVO|VLAANDEREN|VN|VODKA|VOLKSWAGEN|VOLVO|VOTE|VOTING|VOTO|VOYAGE|VU|VUELOS|WALES|WALMART|WALTER|WANG|WANGGOU|WATCH|WATCHES|WEATHER|WEATHERCHANNEL|WEBCAM|WEBER|WEBSITE|WED|WEDDING|WEIBO|WEIR|WF|WHOSWHO|WIEN|WIKI|WILLIAMHILL|WIN|WINDOWS|WINE|WINNERS|WME|WOLTERSKLUWER|WOODSIDE|WORK|WORKS|WORLD|WOW|WS|WTC|WTF|XBOX|XEROX|XFINITY|XIHUAN|XIN|XN--11B4C3D|XN--1CK2E1B|XN--1QQW23A|XN--2SCRJ9C|XN--30RR7Y|XN--3BST00M|XN--3DS443G|XN--3E0B707E|XN--3HCRJ9C|XN--3OQ18VL8PN36A|XN--3PXU8K|XN--42C2D9A|XN--45BR5CYL|XN--45BRJ9C|XN--45Q11C|XN--4GBRIM|XN--54B7FTA0CC|XN--55QW42G|XN--55QX5D|XN--5SU34J936BGSG|XN--5TZM5G|XN--6FRZ82G|XN--6QQ986B3XL|XN--80ADXHKS|XN--80AO21A|XN--80AQECDR1A|XN--80ASEHDB|XN--80ASWG|XN--8Y0A063A|XN--90A3AC|XN--90AE|XN--90AIS|XN--9DBQ2A|XN--9ET52U|XN--9KRT00A|XN--B4W605FERD|XN--BCK1B9A5DRE4C|XN--C1AVG|XN--C2BR7G|XN--CCK2B3B|XN--CG4BKI|XN--CLCHC0EA0B2G2A9GCD|XN--CZR694B|XN--CZRS0T|XN--CZRU2D|XN--D1ACJ3B|XN--D1ALF|XN--E1A4C|XN--ECKVDTC9D|XN--EFVY88H|XN--FCT429K|XN--FHBEI|XN--FIQ228C5HS|XN--FIQ64B|XN--FIQS8S|XN--FIQZ9S|XN--FJQ720A|XN--FLW351E|XN--FPCRJ9C3D|XN--FZC2C9E2C|XN--FZYS8D69UVGM|XN--G2XX48C|XN--GCKR3F0F|XN--GECRJ9C|XN--GK3AT1E|XN--H2BREG3EVE|XN--H2BRJ9C|XN--H2BRJ9C8C|XN--HXT814E|XN--I1B6B1A6A2E|XN--IMR513N|XN--IO0A7I|XN--J1AEF|XN--J1AMH|XN--J6W193G|XN--JLQ61U9W7B|XN--JVR189M|XN--KCRX77D1X4A|XN--KPRW13D|XN--KPRY57D|XN--KPU716F|XN--KPUT3I|XN--L1ACC|XN--LGBBAT1AD8J|XN--MGB9AWBF|XN--MGBA3A3EJT|XN--MGBA3A4F16A|XN--MGBA7C0BBN0A|XN--MGBAAKC7DVF|XN--MGBAAM7A8H|XN--MGBAB2BD|XN--MGBAH1A3HJKRD|XN--MGBAI9AZGQP6J|XN--MGBAYH7GPA|XN--MGBBH1A|XN--MGBBH1A71E|XN--MGBC0A9AZCG|XN--MGBCA7DZDO|XN--MGBCPQ6GPA1A|XN--MGBERP4A5D4AR|XN--MGBGU82A|XN--MGBI4ECEXP|XN--MGBPL2FH|XN--MGBT3DHD|XN--MGBTX2B|XN--MGBX4CD0AB|XN--MIX891F|XN--MK1BU44C|XN--MXTQ1M|XN--NGBC5AZD|XN--NGBE9E0A|XN--NGBRX|XN--NODE|XN--NQV7F|XN--NQV7FS00EMA|XN--NYQY26A|XN--O3CW4H|XN--OGBPF8FL|XN--OTU796D|XN--P1ACF|XN--P1AI|XN--PBT977C|XN--PGBS0DH|XN--PSSY2U|XN--Q7CE6A|XN--Q9JYB4C|XN--QCKA1PMC|XN--QXA6A|XN--QXAM|XN--RHQV96G|XN--ROVU88B|XN--RVC1E0AM3E|XN--S9BRJ9C|XN--SES554G|XN--T60B56A|XN--TCKWE|XN--TIQ49XQYJ|XN--UNUP4Y|XN--VERMGENSBERATER-CTB|XN--VERMGENSBERATUNG-PWB|XN--VHQUV|XN--VUQ861B|XN--W4R85EL8FHU5DNRA|XN--W4RS40L|XN--WGBH1C|XN--WGBL6A|XN--XHQ521B|XN--XKC2AL3HYE2A|XN--XKC2DL3A5EE0H|XN--Y9A3AQ|XN--YFRO4I67O|XN--YGBI2AMMX|XN--ZFR164B|XXX|XYZ|YACHTS|YAHOO|YAMAXUN|YANDEX|YE|YODOBASHI|YOGA|YOKOHAMA|YOU|YOUTUBE|YT|YUN|ZA|ZAPPOS|ZARA|ZERO|ZIP|ZM|ZONE|ZUERICH|ZW|TEST)";
	});

	var tlds$1 = unwrapExports(tlds);
	var tlds_1 = tlds.TLDs;

	var tlds$2 = /*#__PURE__*/Object.freeze({
		default: tlds$1,
		__moduleExports: tlds,
		TLDs: tlds_1
	});

	var tlds_1$1 = ( tlds$2 && tlds$1 ) || tlds$2;

	var dictionary = createCommonjsModule(function (module, exports) {
	Object.defineProperty(exports, "__esModule", { value: true });

	exports.openingParenthesis = "([\"'{";
	exports.closingParenthesis = ")]\"'}";
	exports.parenthesis = exports.openingParenthesis
	    .split("")
	    .map(function (x, i) { return "" + x + exports.closingParenthesis.charAt(i); });
	exports.htmlAttributes = [
	    "src",
	    "data",
	    "href",
	    "cite",
	    "formaction",
	    "icon",
	    "manifest",
	    "poster",
	    "codebase",
	    "background",
	    "profile",
	    "usemap",
	    "itemtype",
	    "action",
	    "longdesc",
	    "classid",
	    "archive"
	];
	exports.nonLatinAlphabetRanges = "\\u0041-\\u005A\\u0061-\\u007A\\u00AA\\u00B5\\u00BA\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02C1\\u02C6-\\u02D1\\u02E0-\\u02E4\\u02EC\\u02EE\\u0370-\\u0374\\u0376\\u0377\\u037A-\\u037D\\u0386\\u0388-\\u038A\\u038C\\u038E-\\u03A1\\u03A3-\\u03F5\\u03F7-\\u0481\\u048A-\\u0527\\u0531-\\u0556\\u0559\\u0561-\\u0587\\u05D0-\\u05EA\\u05F0-\\u05F2\\u0620-\\u064A\\u066E\\u066F\\u0671-\\u06D3\\u06D5\\u06E5\\u06E6\\u06EE\\u06EF\\u06FA-\\u06FC\\u06FF\\u0710\\u0712-\\u072F\\u074D-\\u07A5\\u07B1\\u07CA-\\u07EA\\u07F4\\u07F5\\u07FA\\u0800-\\u0815\\u081A\\u0824\\u0828\\u0840-\\u0858\\u08A0\\u08A2-\\u08AC\\u0904-\\u0939\\u093D\\u0950\\u0958-\\u0961\\u0971-\\u0977\\u0979-\\u097F\\u0985-\\u098C\\u098F\\u0990\\u0993-\\u09A8\\u09AA-\\u09B0\\u09B2\\u09B6-\\u09B9\\u09BD\\u09CE\\u09DC\\u09DD\\u09DF-\\u09E1\\u09F0\\u09F1\\u0A05-\\u0A0A\\u0A0F\\u0A10\\u0A13-\\u0A28\\u0A2A-\\u0A30\\u0A32\\u0A33\\u0A35\\u0A36\\u0A38\\u0A39\\u0A59-\\u0A5C\\u0A5E\\u0A72-\\u0A74\\u0A85-\\u0A8D\\u0A8F-\\u0A91\\u0A93-\\u0AA8\\u0AAA-\\u0AB0\\u0AB2\\u0AB3\\u0AB5-\\u0AB9\\u0ABD\\u0AD0\\u0AE0\\u0AE1\\u0B05-\\u0B0C\\u0B0F\\u0B10\\u0B13-\\u0B28\\u0B2A-\\u0B30\\u0B32\\u0B33\\u0B35-\\u0B39\\u0B3D\\u0B5C\\u0B5D\\u0B5F-\\u0B61\\u0B71\\u0B83\\u0B85-\\u0B8A\\u0B8E-\\u0B90\\u0B92-\\u0B95\\u0B99\\u0B9A\\u0B9C\\u0B9E\\u0B9F\\u0BA3\\u0BA4\\u0BA8-\\u0BAA\\u0BAE-\\u0BB9\\u0BD0\\u0C05-\\u0C0C\\u0C0E-\\u0C10\\u0C12-\\u0C28\\u0C2A-\\u0C33\\u0C35-\\u0C39\\u0C3D\\u0C58\\u0C59\\u0C60\\u0C61\\u0C85-\\u0C8C\\u0C8E-\\u0C90\\u0C92-\\u0CA8\\u0CAA-\\u0CB3\\u0CB5-\\u0CB9\\u0CBD\\u0CDE\\u0CE0\\u0CE1\\u0CF1\\u0CF2\\u0D05-\\u0D0C\\u0D0E-\\u0D10\\u0D12-\\u0D3A\\u0D3D\\u0D4E\\u0D60\\u0D61\\u0D7A-\\u0D7F\\u0D85-\\u0D96\\u0D9A-\\u0DB1\\u0DB3-\\u0DBB\\u0DBD\\u0DC0-\\u0DC6\\u0E01-\\u0E30\\u0E32\\u0E33\\u0E40-\\u0E46\\u0E81\\u0E82\\u0E84\\u0E87\\u0E88\\u0E8A\\u0E8D\\u0E94-\\u0E97\\u0E99-\\u0E9F\\u0EA1-\\u0EA3\\u0EA5\\u0EA7\\u0EAA\\u0EAB\\u0EAD-\\u0EB0\\u0EB2\\u0EB3\\u0EBD\\u0EC0-\\u0EC4\\u0EC6\\u0EDC-\\u0EDF\\u0F00\\u0F40-\\u0F47\\u0F49-\\u0F6C\\u0F88-\\u0F8C\\u1000-\\u102A\\u103F\\u1050-\\u1055\\u105A-\\u105D\\u1061\\u1065\\u1066\\u106E-\\u1070\\u1075-\\u1081\\u108E\\u10A0-\\u10C5\\u10C7\\u10CD\\u10D0-\\u10FA\\u10FC-\\u1248\\u124A-\\u124D\\u1250-\\u1256\\u1258\\u125A-\\u125D\\u1260-\\u1288\\u128A-\\u128D\\u1290-\\u12B0\\u12B2-\\u12B5\\u12B8-\\u12BE\\u12C0\\u12C2-\\u12C5\\u12C8-\\u12D6\\u12D8-\\u1310\\u1312-\\u1315\\u1318-\\u135A\\u1380-\\u138F\\u13A0-\\u13F4\\u1401-\\u166C\\u166F-\\u167F\\u1681-\\u169A\\u16A0-\\u16EA\\u1700-\\u170C\\u170E-\\u1711\\u1720-\\u1731\\u1740-\\u1751\\u1760-\\u176C\\u176E-\\u1770\\u1780-\\u17B3\\u17D7\\u17DC\\u1820-\\u1877\\u1880-\\u18A8\\u18AA\\u18B0-\\u18F5\\u1900-\\u191C\\u1950-\\u196D\\u1970-\\u1974\\u1980-\\u19AB\\u19C1-\\u19C7\\u1A00-\\u1A16\\u1A20-\\u1A54\\u1AA7\\u1B05-\\u1B33\\u1B45-\\u1B4B\\u1B83-\\u1BA0\\u1BAE\\u1BAF\\u1BBA-\\u1BE5\\u1C00-\\u1C23\\u1C4D-\\u1C4F\\u1C5A-\\u1C7D\\u1CE9-\\u1CEC\\u1CEE-\\u1CF1\\u1CF5\\u1CF6\\u1D00-\\u1DBF\\u1E00-\\u1F15\\u1F18-\\u1F1D\\u1F20-\\u1F45\\u1F48-\\u1F4D\\u1F50-\\u1F57\\u1F59\\u1F5B\\u1F5D\\u1F5F-\\u1F7D\\u1F80-\\u1FB4\\u1FB6-\\u1FBC\\u1FBE\\u1FC2-\\u1FC4\\u1FC6-\\u1FCC\\u1FD0-\\u1FD3\\u1FD6-\\u1FDB\\u1FE0-\\u1FEC\\u1FF2-\\u1FF4\\u1FF6-\\u1FFC\\u2071\\u207F\\u2090-\\u209C\\u2102\\u2107\\u210A-\\u2113\\u2115\\u2119-\\u211D\\u2124\\u2126\\u2128\\u212A-\\u212D\\u212F-\\u2139\\u213C-\\u213F\\u2145-\\u2149\\u214E\\u2183\\u2184\\u2C00-\\u2C2E\\u2C30-\\u2C5E\\u2C60-\\u2CE4\\u2CEB-\\u2CEE\\u2CF2\\u2CF3\\u2D00-\\u2D25\\u2D27\\u2D2D\\u2D30-\\u2D67\\u2D6F\\u2D80-\\u2D96\\u2DA0-\\u2DA6\\u2DA8-\\u2DAE\\u2DB0-\\u2DB6\\u2DB8-\\u2DBE\\u2DC0-\\u2DC6\\u2DC8-\\u2DCE\\u2DD0-\\u2DD6\\u2DD8-\\u2DDE\\u2E2F\\u3005\\u3006\\u3031-\\u3035\\u303B\\u303C\\u3041-\\u3096\\u309D-\\u309F\\u30A1-\\u30FA\\u30FC-\\u30FF\\u3105-\\u312D\\u3131-\\u318E\\u31A0-\\u31BA\\u31F0-\\u31FF\\u3400-\\u4DB5\\u4E00-\\u9FCC\\uA000-\\uA48C\\uA4D0-\\uA4FD\\uA500-\\uA60C\\uA610-\\uA61F\\uA62A\\uA62B\\uA640-\\uA66E\\uA67F-\\uA697\\uA6A0-\\uA6E5\\uA717-\\uA71F\\uA722-\\uA788\\uA78B-\\uA78E\\uA790-\\uA793\\uA7A0-\\uA7AA\\uA7F8-\\uA801\\uA803-\\uA805\\uA807-\\uA80A\\uA80C-\\uA822\\uA840-\\uA873\\uA882-\\uA8B3\\uA8F2-\\uA8F7\\uA8FB\\uA90A-\\uA925\\uA930-\\uA946\\uA960-\\uA97C\\uA984-\\uA9B2\\uA9CF\\uAA00-\\uAA28\\uAA40-\\uAA42\\uAA44-\\uAA4B\\uAA60-\\uAA76\\uAA7A\\uAA80-\\uAAAF\\uAAB1\\uAAB5\\uAAB6\\uAAB9-\\uAABD\\uAAC0\\uAAC2\\uAADB-\\uAADD\\uAAE0-\\uAAEA\\uAAF2-\\uAAF4\\uAB01-\\uAB06\\uAB09-\\uAB0E\\uAB11-\\uAB16\\uAB20-\\uAB26\\uAB28-\\uAB2E\\uABC0-\\uABE2\\uAC00-\\uD7A3\\uD7B0-\\uD7C6\\uD7CB-\\uD7FB\\uF900-\\uFA6D\\uFA70-\\uFAD9\\uFB00-\\uFB06\\uFB13-\\uFB17\\uFB1D\\uFB1F-\\uFB28\\uFB2A-\\uFB36\\uFB38-\\uFB3C\\uFB3E\\uFB40\\uFB41\\uFB43\\uFB44\\uFB46-\\uFBB1\\uFBD3-\\uFD3D\\uFD50-\\uFD8F\\uFD92-\\uFDC7\\uFDF0-\\uFDFB\\uFE70-\\uFE74\\uFE76-\\uFEFC\\uFF21-\\uFF3A\\uFF41-\\uFF5A\\uFF66-\\uFFBE\\uFFC2-\\uFFC7\\uFFCA-\\uFFCF\\uFFD2-\\uFFD7\\uFFDA-\\uFFDC";
	exports.TLDs = tlds_1$1.TLDs;
	});

	var dictionary$1 = unwrapExports(dictionary);
	var dictionary_1 = dictionary.openingParenthesis;
	var dictionary_2 = dictionary.closingParenthesis;
	var dictionary_3 = dictionary.parenthesis;
	var dictionary_4 = dictionary.htmlAttributes;
	var dictionary_5 = dictionary.nonLatinAlphabetRanges;
	var dictionary_6 = dictionary.TLDs;

	var dictionary$2 = /*#__PURE__*/Object.freeze({
		default: dictionary$1,
		__moduleExports: dictionary,
		openingParenthesis: dictionary_1,
		closingParenthesis: dictionary_2,
		parenthesis: dictionary_3,
		htmlAttributes: dictionary_4,
		nonLatinAlphabetRanges: dictionary_5,
		TLDs: dictionary_6
	});

	var transform_1 = createCommonjsModule(function (module, exports) {
	Object.defineProperty(exports, "__esModule", { value: true });
	function applyOption(string, props, option) {
	    // conditional
	    if (typeof option === "function") {
	        return option(string, props);
	    }
	    // all
	    else {
	        return option;
	    }
	}
	function transform(input, options) {
	    var protocol = "";
	    var truncation = Infinity;
	    var attributes = {};
	    var truncateFromTheMiddle = false;
	    // special transformation
	    if (options && options.specialTransform) {
	        for (var index = 0; index < options.specialTransform.length; index++) {
	            var transformer = options.specialTransform[index];
	            if (transformer.test.test(input.string)) {
	                return transformer.transform(input.string, input);
	            }
	        }
	    }
	    // exclude
	    if (options && options.exclude) {
	        if (applyOption(input.string, input, options.exclude))
	            { return input.string; }
	    }
	    // protocol
	    if (options && options.protocol) {
	        protocol = applyOption(input.string, input, options.protocol);
	    }
	    if (input.protocol) {
	        protocol = "";
	    }
	    else if (!protocol) {
	        protocol = input.isEmail
	            ? "mailto:"
	            : input.isFile
	                ? "file:///"
	                : "http://";
	    }
	    // truncation
	    if (options && options.truncate) {
	        truncation = applyOption(input.string, input, options.truncate);
	    }
	    if (options && options.middleTruncation) {
	        truncateFromTheMiddle = applyOption(input.string, input, options.middleTruncation);
	    }
	    // attributes
	    if (options && options.attributes) {
	        attributes = applyOption(input.string, input, options.attributes);
	    }
	    return "<a " + Object.keys(attributes)
	        .map(function (key) {
	        return attributes[key] === true ? key : key + "=\"" + attributes[key] + "\" ";
	    })
	        .join(" ") + "href=\"" + protocol + input.string + "\">" + (input.string.length > truncation
	        ? truncateFromTheMiddle
	            ? input.string.substring(0, Math.floor(truncation / 2)) +
	                "…" +
	                input.string.substring(input.string.length - Math.ceil(truncation / 2), input.string.length)
	            : input.string.substring(0, truncation) + "…"
	        : input.string) + "</a>";
	}
	exports.transform = transform;
	});

	var transform$1 = unwrapExports(transform_1);
	var transform_2 = transform_1.transform;

	var transform$2 = /*#__PURE__*/Object.freeze({
		default: transform$1,
		__moduleExports: transform_1,
		transform: transform_2
	});

	var dictionary_1$1 = ( dictionary$2 && dictionary$1 ) || dictionary$2;

	var regex = createCommonjsModule(function (module, exports) {
	Object.defineProperty(exports, "__esModule", { value: true });

	var email_address = "([a-z0-9!#$%&'*+=?^_`{|}~-]+(\\.[a-z0-9!#$%&'*+=?^_`{|}~-]+)*)";
	var domainWithTLD = "([a-z0-9]+(-+[a-z0-9]+)*\\.)+(" + dictionary_1$1.TLDs + ")";
	var domainWithAnyTLD = "([a-z0-9]+(-+[a-z0-9]+)*\\.)+([a-z0-9][a-z0-9-]{0," + (Math.max.apply(commonjsGlobal, dictionary_1$1.TLDs.split("|").map(function (x) { return x.length; })) - 2) + "}[a-z0-9])";
	var allowedInPath = "a-zA-Z\\d\\-._~\\!$&*+,;=:@%'\"\\[\\]()";
	var path = "(((\\/(([" + allowedInPath + "]+(\\/[" + allowedInPath + "]*)*))?)?)((\\?([" + allowedInPath + "\\/?]*))?)((\\#([" + allowedInPath + "\\/?]*))?))?";
	var ipv4 = "((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)";
	var ipv6 = "\\[(([a-f0-9:]+:+)+[a-f0-9]+)\\]";
	var port = "(:(\\d{1,5}))?";
	var protocol = "(https?:|ftps?:)\\/\\/";
	var confirmedByProtocol = "(" + protocol + ")\\S+";
	var additionalSlashes = "(([\\/]?))+";
	var fqdn = "(((" + protocol + ")?(" + domainWithTLD + "|" + ipv4 + "|(" + protocol + ")(" + ipv6 + "|" + domainWithAnyTLD + "))(?!@\\w)" + port + ")|(" + confirmedByProtocol + "))";
	var nonLatinMatches = fqdn + "((((\\/(([" + allowedInPath + "]+(\\/[" + allowedInPath + dictionary_1$1.nonLatinAlphabetRanges + "]*)*))?)?)((\\?([" + allowedInPath + "\\/?]*))?)((\\#([" + allowedInPath + "\\/?]*))?))?\\b((([" + allowedInPath + "\\/" + dictionary_1$1.nonLatinAlphabetRanges + "][a-zA-Z\\d\\-_~+=\\/" + dictionary_1$1.nonLatinAlphabetRanges + "]+)?))+)";
	exports.email = "\\b(mailto:)?" + email_address + "@(" + domainWithTLD + "|" + ipv4 + ")\\b";
	exports.url = "(" + nonLatinMatches + ")|(\\b" + fqdn + path + "\\b" + additionalSlashes + ")";
	exports.file = "(file:\\/\\/\\/)([a-z]+:(\\/|\\\\)+)?([\\w.]+([\\/\\\\]?)+)+";
	exports.final = "(" + exports.url + ")|(" + exports.email + ")|(" + exports.file + ")";
	exports.finalRegex = new RegExp(exports.final, "gi");
	// for validation purposes
	exports.ipRegex = new RegExp("^(" + ipv4 + "|" + ipv6 + ")$", "i");
	exports.emailRegex = new RegExp("^(" + exports.email + ")$", "i");
	exports.fileRegex = new RegExp("^(" + exports.file + ")$", "i");
	exports.urlRegex = new RegExp("^(" + exports.url + ")$", "i");
	// identifying parts of the link
	var iidxes = {
	    isURL: 0,
	    isEmail: 0,
	    isFile: 0,
	    file: {
	        fileName: 0,
	        protocol: 0,
	    },
	    email: {
	        protocol: 0,
	        local: 0,
	        host: 0,
	    },
	    url: {
	        ipv4: 0,
	        ipv6: 0,
	        ipv4Confirmation: 0,
	        byProtocol: 0,
	        port: 0,
	        // three places where protocol can appear
	        protocol1: 0,
	        protocol2: 0,
	        protocol3: 0,
	        protocolWithDomain: 0,
	        path: 0,
	        // sometimes path might be split into two parts
	        secondPartOfPath: 0,
	        query: 0,
	        fragment: 0,
	    },
	};
	exports.iidxes = iidxes;
	var testers = [
	    "file:///some/file/path/filename.pdf",
	    "mailto:e+_mail.me@sub.domain.com",
	    "http://sub.domain.co.uk:3000/p/a/t/h_(asd)/h?q=abc123#dfdf",
	    "http://www.\u0639\u0631\u0628\u064A.com",
	    "http://127.0.0.1:3000/p/a/t_(asd)/h?q=abc123#dfdf",
	    "http://[2a00:1450:4025:401::67]/k/something",
	    "a.org/abc/\u10D8_\u10D2\u10D2" ].join(" ");
	var result = null;
	var i = 0;
	while ((result = exports.finalRegex.exec(testers)) !== null) {
	    if (i === 0) {
	        iidxes.isFile = result.lastIndexOf(result[0]);
	        iidxes.file.fileName = result.indexOf("filename.pdf");
	        iidxes.file.protocol = result.indexOf("file:///");
	    }
	    if (i === 1) {
	        iidxes.isEmail = result.lastIndexOf(result[0]);
	        iidxes.email.protocol = result.indexOf("mailto:");
	        iidxes.email.local = result.indexOf("e+_mail.me");
	        iidxes.email.host = result.indexOf("sub.domain.com");
	    }
	    if (i === 2) {
	        iidxes.isURL = result.lastIndexOf(result[0]);
	        iidxes.url.protocol1 = result.indexOf("http://");
	        iidxes.url.protocolWithDomain = result.indexOf("http://sub.domain.co.uk:3000");
	        iidxes.url.port = result.indexOf("3000");
	        iidxes.url.path = result.indexOf("/p/a/t/h_(asd)/h");
	        iidxes.url.query = result.indexOf("q=abc123");
	        iidxes.url.fragment = result.indexOf("dfdf");
	    }
	    if (i === 3) {
	        iidxes.url.byProtocol = result.lastIndexOf("http://www.عربي.com");
	        iidxes.url.protocol2 = result.lastIndexOf("http://");
	    }
	    if (i === 4) {
	        iidxes.url.ipv4 = result.indexOf("127.0.0.1");
	        iidxes.url.ipv4Confirmation = result.indexOf("0.");
	    }
	    if (i === 5) {
	        iidxes.url.ipv6 = result.indexOf("2a00:1450:4025:401::67");
	        iidxes.url.protocol3 = result.lastIndexOf("http://");
	    }
	    if (i === 6) {
	        iidxes.url.secondPartOfPath = result.indexOf("გგ");
	    }
	    i++;
	}
	});

	var regex$1 = unwrapExports(regex);
	var regex_1 = regex.email;
	var regex_2 = regex.url;
	var regex_3 = regex.file;
	var regex_4 = regex.finalRegex;
	var regex_5 = regex.ipRegex;
	var regex_6 = regex.emailRegex;
	var regex_7 = regex.fileRegex;
	var regex_8 = regex.urlRegex;
	var regex_9 = regex.iidxes;

	var regex$2 = /*#__PURE__*/Object.freeze({
		default: regex$1,
		__moduleExports: regex,
		email: regex_1,
		url: regex_2,
		file: regex_3,
		finalRegex: regex_4,
		ipRegex: regex_5,
		emailRegex: regex_6,
		fileRegex: regex_7,
		urlRegex: regex_8,
		iidxes: regex_9
	});

	var utils = createCommonjsModule(function (module, exports) {
	Object.defineProperty(exports, "__esModule", { value: true });

	function checkParenthesis(opening, closing, target, nextChar) {
	    if (nextChar !== closing) {
	        return false;
	    }
	    if (target.split(opening).length - target.split(closing).length === 1 ||
	        (opening === closing && target.split(opening).length % 2 === 0)) {
	        return true;
	    }
	}
	exports.checkParenthesis = checkParenthesis;
	exports.maximumAttrLength = dictionary_1$1.htmlAttributes.sort(function (a, b) { return b.length - a.length; })[0].length;
	function isInsideAttribute(prevFragment) {
	    return (/\s[a-z0-9-]+=('|")$/i.test(prevFragment) ||
	        /: ?url\(('|")?$/i.test(prevFragment));
	}
	exports.isInsideAttribute = isInsideAttribute;
	function isInsideAnchorTag(target, fullInput, targetEnd) {
	    var escapedTarget = target.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
	    var regex = new RegExp("(?=(<a))(?!([\\s\\S]*)(<\\/a>)(" + escapedTarget + "))[\\s\\S]*?(" + escapedTarget + ")(?!\"|')", "gi");
	    var result = null;
	    while ((result = regex.exec(fullInput)) !== null) {
	        var end = result.index + result[0].length;
	        if (end === targetEnd) {
	            return true;
	        }
	    }
	    return false;
	}
	exports.isInsideAnchorTag = isInsideAnchorTag;
	});

	var utils$1 = unwrapExports(utils);
	var utils_1 = utils.checkParenthesis;
	var utils_2 = utils.maximumAttrLength;
	var utils_3 = utils.isInsideAttribute;
	var utils_4 = utils.isInsideAnchorTag;

	var utils$2 = /*#__PURE__*/Object.freeze({
		default: utils$1,
		__moduleExports: utils,
		checkParenthesis: utils_1,
		maximumAttrLength: utils_2,
		isInsideAttribute: utils_3,
		isInsideAnchorTag: utils_4
	});

	var transform_1$1 = ( transform$2 && transform$1 ) || transform$2;

	var regex_1$1 = ( regex$2 && regex$1 ) || regex$2;

	var utils_1$1 = ( utils$2 && utils$1 ) || utils$2;

	var node = createCommonjsModule(function (module, exports) {
	Object.defineProperty(exports, "__esModule", { value: true });




	var list = function (input) {
	    var found = [];
	    var result = null;
	    var _loop_1 = function () {
	        var start = result.index;
	        var end = start + result[0].length;
	        var string = result[0];
	        // ### trailing slashes problem
	        /**
	         * This is a quick and dirty fix for a problem that could be probably fixed with
	         * slight modification in the regex.
	         * The problem is that the library doesn't count the trailing slashes as part
	         * of the URL, unless there were multiple trailing slashes.
	         */
	        if (input.charAt(end) === "/") {
	            string = string + input.charAt(end);
	            end++;
	        }
	        // ### Parenthesis problem
	        /**
	                As we're using the \b to tokenize the URL, sometimes the parenthesis are part of the URL
	                and sometimes they are actually the last part, this makes the tokenization stops just
	                before them.
	                To fix this, we calculate how many parenthesis are open and how many are closed inside
	                the URL and based on the number we should be able to know whether the aforementioned
	                parenthesis character is part of the URL or not
	            */
	        if (dictionary_1$1.closingParenthesis.indexOf(input.charAt(end)) > -1) {
	            dictionary_1$1.parenthesis.forEach(function (str) {
	                var opening = str.charAt(0);
	                var closing = str.charAt(1);
	                if (utils_1$1.checkParenthesis(opening, closing, string, input.charAt(end))) {
	                    string = string + input.charAt(end);
	                    end++;
	                }
	            });
	        }
	        // ### HTML problem 1
	        /**
	                checking whether the token is already inside an HTML element by seeing if it's
	                preceded by an HTML attribute that would hold a url (e.g. scr, cite ...etc)
	            */
	        if (['""', "''", "()"].indexOf(input.charAt(start - 1) + input.charAt(end)) !== -1) {
	            if (utils_1$1.isInsideAttribute(input.substring(start - utils_1$1.maximumAttrLength - 15, start))) {
	                return "continue";
	            }
	        }
	        // ### HTML problem 2
	        /**
	                Checking whether the token is the content of an actual anchor
	                e.g. <a href="https://something.com">click to go to something.com and have fun</a>
	            */
	        if (input.substring(end, input.length).indexOf("</a>") > -1 &&
	            input.substring(0, start).indexOf("<a") > -1 &&
	            utils_1$1.isInsideAnchorTag(string, input, end)) {
	            return "continue";
	        }
	        if (result[regex_1$1.iidxes.isURL]) {
	            var path = (result[regex_1$1.iidxes.url.path] || "") +
	                (result[regex_1$1.iidxes.url.secondPartOfPath] || "") || undefined;
	            var protocol = result[regex_1$1.iidxes.url.protocol1] ||
	                result[regex_1$1.iidxes.url.protocol2] ||
	                result[regex_1$1.iidxes.url.protocol3];
	            found.push({
	                start: start,
	                end: end,
	                string: string,
	                isURL: true,
	                protocol: protocol,
	                port: result[regex_1$1.iidxes.url.port],
	                ipv4: result[regex_1$1.iidxes.url.ipv4Confirmation]
	                    ? result[regex_1$1.iidxes.url.ipv4]
	                    : undefined,
	                ipv6: result[regex_1$1.iidxes.url.ipv6],
	                host: result[regex_1$1.iidxes.url.byProtocol]
	                    ? undefined
	                    : (result[regex_1$1.iidxes.url.protocolWithDomain] || "").substr((protocol || "").length),
	                confirmedByProtocol: !!result[regex_1$1.iidxes.url.byProtocol],
	                path: result[regex_1$1.iidxes.url.byProtocol] ? undefined : path,
	                query: result[regex_1$1.iidxes.url.query] || undefined,
	                fragment: result[regex_1$1.iidxes.url.fragment] || undefined,
	            });
	        }
	        else if (result[regex_1$1.iidxes.isFile]) {
	            var filePath = string.substr(8);
	            found.push({
	                start: start,
	                end: end,
	                string: string,
	                isFile: true,
	                protocol: result[regex_1$1.iidxes.file.protocol],
	                filename: result[regex_1$1.iidxes.file.fileName],
	                filePath: filePath,
	                fileDirectory: filePath.substr(0, filePath.length - result[regex_1$1.iidxes.file.fileName].length),
	            });
	        }
	        else if (result[regex_1$1.iidxes.isEmail]) {
	            found.push({
	                start: start,
	                end: end,
	                string: string,
	                isEmail: true,
	                local: result[regex_1$1.iidxes.email.local],
	                protocol: result[regex_1$1.iidxes.email.protocol],
	                host: result[regex_1$1.iidxes.email.host],
	            });
	        }
	        else {
	            found.push({
	                start: start,
	                end: end,
	                string: string,
	            });
	        }
	    };
	    while ((result = regex_1$1.finalRegex.exec(input)) !== null) {
	        _loop_1();
	    }
	    return found;
	};
	var anchorme = function (arg) {
	    var _a = typeof arg === "string"
	        ? { input: arg, options: undefined, extensions: undefined }
	        : arg, input = _a.input, options = _a.options, extensions = _a.extensions;
	    if (extensions) {
	        for (var index = 0; index < extensions.length; index++) {
	            var extension = extensions[index];
	            input = input.replace(extension.test, extension.transform);
	        }
	    }
	    var found = list(input);
	    var newStr = "";
	    // the following code isn't very intuitive nor human readable
	    // but faster than others
	    for (var index = 0; index < found.length; index++) {
	        newStr =
	            (newStr
	                ? newStr
	                : index === 0
	                    ? input.substring(0, found[index].start)
	                    : "") +
	                transform_1$1.transform(found[index], options) +
	                (found[index + 1]
	                    ? input.substring(found[index].end, found[index + 1].start)
	                    : input.substring(found[index].end));
	    }
	    return newStr ? newStr : input;
	};
	anchorme.list = function (input) {
	    return list(input);
	};
	anchorme.validate = {
	    ip: function (input) { return regex_1$1.ipRegex.test(input); },
	    email: function (input) { return regex_1$1.emailRegex.test(input); },
	    file: function (input) { return regex_1$1.fileRegex.test(input); },
	    url: function (input) { return regex_1$1.urlRegex.test(input) || regex_1$1.ipRegex.test(input); },
	};
	exports.default = anchorme;
	});

	var anchorme = unwrapExports(node);

	function linkify(text) {
	  var linkedText = text;
	  var linkTarget = Brief$1.isCordova ? '_system' : '_blank';
	  try {
	    linkedText = anchorme({
	      input: text,
	      options: {
	        attributes: function(string, info) {
	          var attributes = {
	            target: linkTarget
	          };

	          if (info.isURL) {
	            attributes["class"] = "message-link external";
	            try {
	              attributes["href"] = decodeURIComponent(string);
	            } catch (err) {
	              attributes["href"] = string;
	            }
	          }

	          if (info.isEmail) {
	            attributes["class"] = "message-email";
	            
	            // TODO When sending email is supportet
	            // attributes["href"] = `/email/create/?to=${string}`;
	            // attributes["mailto"] = undefined;
	          }

	          return attributes;
	        }
	      }
	    });
	  } catch (err) {}

	  // Parse Images
	  linkedText = linkedText.replace(/!\(([^)]*)\)\[([^]*)]/gi, '<img alt="$1" src="$2">');

	  // Tel
	  if (!/message-link external/.test(linkedText))
	    { linkedText = linkedText.replace(/([0-9][0-9-()+ ]{5,}[0-9])/gi, ("<a href=\"tel:$1\" target=\"" + linkTarget + "\" class=\"message-tel external\">$1</a>")); }

	  return linkedText;
	}

	function renderPopover(actions) {
	  return ("\n    <div class=\"popover popover-from-actions\">\n      <div class=\"popover-inner\">\n        <div class=\"list\">\n          <ul>\n            " + (actions.map(function (button) {
	    var itemClasses = [];
	    // eslint-disable-next-line
	              var color = button.color;
	    var bg = button.bg;
	    var bold = button.bold;
	    var disabled = button.disabled;
	    var label = button.label;
	    var text = button.text;
	    var icon = button.icon;
	    if (color) { itemClasses.push(("color-" + color)); }
	    if (bg) { itemClasses.push(("bg-" + bg)); }
	    if (bold) { itemClasses.push('popover-from-actions-bold'); }
	    if (disabled) { itemClasses.push('disabled'); }
	    if (label) {
	      itemClasses.push('popover-from-actions-label');
	      return ("<li class=\"" + (itemClasses.join(' ')) + "\">" + text + "</li>");
	    }
	    itemClasses.push('item-link');
	    if (icon) {
	      itemClasses.push('item-content');
	      return ("\n                  <li>\n                    <a class=\"" + (itemClasses.join(' ')) + "\">\n                      <div class=\"item-media\">\n                        " + icon + "\n                      </div>\n                      <div class=\"item-inner\">\n                        <div class=\"item-title\">\n                          " + text + "\n                        </div>\n                      </div>\n                    </a>\n                  </li>\n                ");
	    }
	    itemClasses.push('list-button');
	    return ("\n                <li>\n                  <a href=\"#\" class=\"list-button " + (itemClasses.join(' ')) + "\">" + text + "</a>\n                </li>\n              ");
	  }).join('')) + "\n          </ul>\n        </div>\n      </div>\n    </div>\n  ").trim();
	}
	function ActionsModal(actions, targetEl) {
	  var modal;
	  var isTouchDevice = Utils$1.mobileDevice();

	  function buttonOnClick(e) {
	    var buttonEl = this;
	    var buttonIndex;
	    if ($$1(buttonEl).hasClass('item-link')) {
	      buttonIndex = $$1(buttonEl).parents('li').index();
	    } else {
	      buttonIndex = $$1(buttonEl).index();
	    }
	    var button = actions[buttonIndex];
	    if (button.onClick) { button.onClick(actions, e); }
	    if (button.close !== false && modal) { modal.close(); }
	  }

	  if (isTouchDevice) {
	    // Return Actions
	    modal = Brief$1.f7.actions.create({
	      targetEl: targetEl,
	      buttons: [
	        actions,
	        [
	          {
	            text: 'Cancel',
	          } ] ],
	    });
	  } else {
	    // Return Popover
	    modal = Brief$1.f7.popover.create({
	      content: renderPopover(actions),
	      targetEl: targetEl,
	      backdrop: false,
	      closeByOutsideClick: true,
	    });
	    modal.once('opened', function () {
	      modal.$el.find('.item-link').each(function (groupIndex, buttonEl) {
	        $$1(buttonEl).on('click', buttonOnClick);
	      });
	    });
	    modal.once('closed', function () {
	      modal.$el.find('.item-link').each(function (groupIndex, buttonEl) {
	        $$1(buttonEl).off('click', buttonOnClick);
	      });
	    });
	  }

	  modal.once('closed', function () {
	    setTimeout(function () {
	      modal.destroy();
	      modal = null;
	    }, 0);
	  });

	  return modal;
	}

	function urlPreview (url, callback) {
	  var ls = window.localStorage;
	  if (ls[("urlPreview:" + url)]) {
	    callback(JSON.parse(ls[("urlPreview:" + url)]));
	    return;
	  }
	  var requestUrl = "https://api.linkpreview.net/?key=5a29309e322ebb72f9cbbf758eeb01390a575b779741d&q=" + url;
	  Brief$1.f7.request.json(requestUrl, function (data) {
	    ls[("urlPreview:" + url)] = JSON.stringify(data);
	    callback(data);
	  });
	}

	var Clipboard = {
	  el: undefined,
	  createEl: function createEl() {
	    var el = document.createElement('div');
	    el.style.display = 'none';
	    el.style.position = 'absolute';
	    el.style.visibility = 'hidden';
	    el.style.right = '100%';
	    el.style.bottom = '100%';
	    el.style.userSelect = 'text';
	    el.style.webkitUserSelect = 'text';
	    el.style['-webkit-user-select'] = 'text';
	    document.body.appendChild(el);
	    Clipboard.el = el;
	  },
	  showEl: function showEl() {
	    Clipboard.el.style.display = 'block';
	    Clipboard.el.style.visibility = 'visible';
	  },
	  hideEl: function hideEl() {
	    Clipboard.el.style.display = 'none';
	    Clipboard.el.style.visibility = 'hidden';
	  },
	  copy: function copy(text) {
	    if (!Clipboard.el) {
	      Clipboard.createEl();
	    }
	    Clipboard.el.innerHTML = text;

	    try {
	      window.getSelection().removeAllRanges();
	    } catch (err) {
	      // no support
	    }

	    Clipboard.showEl();

	    var range = document.createRange();
	    range.selectNode(Clipboard.el);

	    var success;
	    try {
	      window.getSelection().addRange(range);
	      // Now that we've selected the anchor text, execute the copy command
	      success = document.execCommand('copy');
	    } catch (err) {
	      success = false;
	    }

	    try {
	      window.getSelection().removeAllRanges();
	    } catch (err) {
	      // no support
	    }

	    Clipboard.hideEl();

	    return success;
	  },
	};

	// This file is a workaround for a bug in web browsers' "native"
	// ES6 importing system which is uncapable of importing "*.json" files.
	// https://github.com/catamphetamine/libphonenumber-js/issues/239
	var metadata = {"version":4,"country_calling_codes":{"1":["US","AG","AI","AS","BB","BM","BS","CA","DM","DO","GD","GU","JM","KN","KY","LC","MP","MS","PR","SX","TC","TT","VC","VG","VI"],"7":["RU","KZ"],"20":["EG"],"27":["ZA"],"30":["GR"],"31":["NL"],"32":["BE"],"33":["FR"],"34":["ES"],"36":["HU"],"39":["IT","VA"],"40":["RO"],"41":["CH"],"43":["AT"],"44":["GB","GG","IM","JE"],"45":["DK"],"46":["SE"],"47":["NO","SJ"],"48":["PL"],"49":["DE"],"51":["PE"],"52":["MX"],"53":["CU"],"54":["AR"],"55":["BR"],"56":["CL"],"57":["CO"],"58":["VE"],"60":["MY"],"61":["AU","CC","CX"],"62":["ID"],"63":["PH"],"64":["NZ"],"65":["SG"],"66":["TH"],"81":["JP"],"82":["KR"],"84":["VN"],"86":["CN"],"90":["TR"],"91":["IN"],"92":["PK"],"93":["AF"],"94":["LK"],"95":["MM"],"98":["IR"],"211":["SS"],"212":["MA","EH"],"213":["DZ"],"216":["TN"],"218":["LY"],"220":["GM"],"221":["SN"],"222":["MR"],"223":["ML"],"224":["GN"],"225":["CI"],"226":["BF"],"227":["NE"],"228":["TG"],"229":["BJ"],"230":["MU"],"231":["LR"],"232":["SL"],"233":["GH"],"234":["NG"],"235":["TD"],"236":["CF"],"237":["CM"],"238":["CV"],"239":["ST"],"240":["GQ"],"241":["GA"],"242":["CG"],"243":["CD"],"244":["AO"],"245":["GW"],"246":["IO"],"247":["AC"],"248":["SC"],"249":["SD"],"250":["RW"],"251":["ET"],"252":["SO"],"253":["DJ"],"254":["KE"],"255":["TZ"],"256":["UG"],"257":["BI"],"258":["MZ"],"260":["ZM"],"261":["MG"],"262":["RE","YT"],"263":["ZW"],"264":["NA"],"265":["MW"],"266":["LS"],"267":["BW"],"268":["SZ"],"269":["KM"],"290":["SH","TA"],"291":["ER"],"297":["AW"],"298":["FO"],"299":["GL"],"350":["GI"],"351":["PT"],"352":["LU"],"353":["IE"],"354":["IS"],"355":["AL"],"356":["MT"],"357":["CY"],"358":["FI","AX"],"359":["BG"],"370":["LT"],"371":["LV"],"372":["EE"],"373":["MD"],"374":["AM"],"375":["BY"],"376":["AD"],"377":["MC"],"378":["SM"],"380":["UA"],"381":["RS"],"382":["ME"],"383":["XK"],"385":["HR"],"386":["SI"],"387":["BA"],"389":["MK"],"420":["CZ"],"421":["SK"],"423":["LI"],"500":["FK"],"501":["BZ"],"502":["GT"],"503":["SV"],"504":["HN"],"505":["NI"],"506":["CR"],"507":["PA"],"508":["PM"],"509":["HT"],"590":["GP","BL","MF"],"591":["BO"],"592":["GY"],"593":["EC"],"594":["GF"],"595":["PY"],"596":["MQ"],"597":["SR"],"598":["UY"],"599":["CW","BQ"],"670":["TL"],"672":["NF"],"673":["BN"],"674":["NR"],"675":["PG"],"676":["TO"],"677":["SB"],"678":["VU"],"679":["FJ"],"680":["PW"],"681":["WF"],"682":["CK"],"683":["NU"],"685":["WS"],"686":["KI"],"687":["NC"],"688":["TV"],"689":["PF"],"690":["TK"],"691":["FM"],"692":["MH"],"850":["KP"],"852":["HK"],"853":["MO"],"855":["KH"],"856":["LA"],"880":["BD"],"886":["TW"],"960":["MV"],"961":["LB"],"962":["JO"],"963":["SY"],"964":["IQ"],"965":["KW"],"966":["SA"],"967":["YE"],"968":["OM"],"970":["PS"],"971":["AE"],"972":["IL"],"973":["BH"],"974":["QA"],"975":["BT"],"976":["MN"],"977":["NP"],"992":["TJ"],"993":["TM"],"994":["AZ"],"995":["GE"],"996":["KG"],"998":["UZ"]},"countries":{"AC":["247","00","(?:[01589]\\d|[46])\\d{4}",[5,6]],"AD":["376","00","(?:1|6\\d)\\d{7}|[135-9]\\d{5}",[6,8,9],[["(\\d{3})(\\d{3})","$1 $2",["[135-9]"]],["(\\d{4})(\\d{4})","$1 $2",["1"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["6"]]]],"AE":["971","00","(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}",[5,6,7,8,9,10,11,12],[["(\\d{3})(\\d{2,9})","$1 $2",["60|8"]],["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["[236]|[479][2-8]"],"0$1"],["(\\d{3})(\\d)(\\d{5})","$1 $2 $3",["[479]"]],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["5"],"0$1"]],"0"],"AF":["93","00","[2-7]\\d{8}",[9],[["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[2-7]"],"0$1"]],"0"],"AG":["1","011","(?:268|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"1|([457]\\d{6})$","268$1",0,"268"],"AI":["1","011","(?:264|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"1|([2457]\\d{6})$","264$1",0,"264"],"AL":["355","00","(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}",[6,7,8,9],[["(\\d{3})(\\d{3,4})","$1 $2",["80|9"],"0$1"],["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["4[2-6]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[2358][2-5]|4"],"0$1"],["(\\d{3})(\\d{5})","$1 $2",["[23578]"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["6"],"0$1"]],"0"],"AM":["374","00","(?:[1-489]\\d|55|60|77)\\d{6}",[8],[["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["[89]0"],"0 $1"],["(\\d{3})(\\d{5})","$1 $2",["2|3[12]"],"(0$1)"],["(\\d{2})(\\d{6})","$1 $2",["1|47"],"(0$1)"],["(\\d{2})(\\d{6})","$1 $2",["[3-9]"],"0$1"]],"0"],"AO":["244","00","[29]\\d{8}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[29]"]]]],"AR":["54","00","(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}",[10,11],[["(\\d{4})(\\d{2})(\\d{4})","$1 $2-$3",["2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])","2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)","2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]","2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"],"0$1",1],["(\\d{2})(\\d{4})(\\d{4})","$1 $2-$3",["1"],"0$1",1],["(\\d{3})(\\d{3})(\\d{4})","$1-$2-$3",["[68]"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2-$3",["[23]"],"0$1",1],["(\\d)(\\d{4})(\\d{2})(\\d{4})","$2 15-$3-$4",["9(?:2[2-469]|3[3-578])","9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))","9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)","9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]","9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"],"0$1",0,"$1 $2 $3-$4"],["(\\d)(\\d{2})(\\d{4})(\\d{4})","$2 15-$3-$4",["91"],"0$1",0,"$1 $2 $3-$4"],["(\\d{3})(\\d{3})(\\d{5})","$1-$2-$3",["8"],"0$1"],["(\\d)(\\d{3})(\\d{3})(\\d{4})","$2 15-$3-$4",["9"],"0$1",0,"$1 $2 $3-$4"]],"0",0,"0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?","9$1"],"AS":["1","011","(?:[58]\\d\\d|684|900)\\d{7}",[10],0,"1",0,"1|([267]\\d{6})$","684$1",0,"684"],"AT":["43","00","1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}",[4,5,6,7,8,9,10,11,12,13],[["(\\d)(\\d{3,12})","$1 $2",["1(?:11|[2-9])"],"0$1"],["(\\d{3})(\\d{2})","$1 $2",["517"],"0$1"],["(\\d{2})(\\d{3,5})","$1 $2",["5[079]"],"0$1"],["(\\d{3})(\\d{3,10})","$1 $2",["(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]"],"0$1"],["(\\d{4})(\\d{3,9})","$1 $2",["[2-467]|5[2-6]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["5"],"0$1"],["(\\d{2})(\\d{4})(\\d{4,7})","$1 $2 $3",["5"],"0$1"]],"0"],"AU":["61","001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011","1(?:[0-79]\\d{7}(?:\\d(?:\\d{2})?)?|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}",[5,6,7,8,9,10,12],[["(\\d{2})(\\d{3,4})","$1 $2",["16"],"0$1"],["(\\d{2})(\\d{3})(\\d{2,4})","$1 $2 $3",["16"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["14|4"],"0$1"],["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["[2378]"],"(0$1)"],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1(?:30|[89])"]]],"0",0,"0|(183[12])",0,0,0,[["(?:(?:2(?:[0-26-9]\\d|3[0-8]|4[02-9]|5[0135-9])|3(?:[0-3589]\\d|4[0-578]|6[1-9]|7[0-35-9])|7(?:[013-57-9]\\d|2[0-8]))\\d{3}|8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-79]|[18][13579]|2[14-9]|3[0-46-9]|[4-6]\\d|7[89]|9[0-4]))|(?:6[0-8]|[78]\\d)\\d{3}|9(?:[02-9]\\d{3}|1(?:(?:[0-58]\\d|6[0135-9])\\d|7(?:0[0-24-9]|[1-9]\\d)|9(?:[0-46-9]\\d|5[0-79])))))\\d{3}",[9]],["4(?:83[0-38]|93[0-6])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[06-9]|7[02-9]|8[0-24-9]|9[0-27-9])\\d{6}",[9]],["180(?:0\\d{3}|2)\\d{3}",[7,10]],["190[0-26]\\d{6}",[10]],0,0,0,["163\\d{2,6}",[5,6,7,8,9]],["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",[9]],["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",[6,8,10,12]]],"0011"],"AW":["297","00","(?:[25-79]\\d\\d|800)\\d{4}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[25-9]"]]]],"AX":["358","00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))","2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}",[5,6,7,8,9,10,11,12],0,"0",0,0,0,0,"18",0,"00"],"AZ":["994","00","365\\d{6}|(?:[124579]\\d|60|88)\\d{7}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["90"],"0$1"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["1[28]|2|365|46","1[28]|2|365[45]|46","1[28]|2|365(?:4|5[02])|46"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[13-9]"],"0$1"]],"0"],"BA":["387","00","6\\d{8}|(?:[35689]\\d|49|70)\\d{6}",[8,9],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["6[1-3]|[7-9]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2-$3",["[3-5]|6[56]"],"0$1"],["(\\d{2})(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3 $4",["6"],"0$1"]],"0"],"BB":["1","011","(?:246|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"1|([2-9]\\d{6})$","246$1",0,"246"],"BD":["880","00","[1-469]\\d{9}|8[0-79]\\d{7,8}|[2-79]\\d{8}|[2-9]\\d{7}|[3-9]\\d{6}|[57-9]\\d{5}",[6,7,8,9,10],[["(\\d{2})(\\d{4,6})","$1-$2",["31[5-8]|[459]1"],"0$1"],["(\\d{3})(\\d{3,7})","$1-$2",["3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:28|4[14]|5)|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"],"0$1"],["(\\d{4})(\\d{3,6})","$1-$2",["[13-9]|22"],"0$1"],["(\\d)(\\d{7,8})","$1-$2",["2"],"0$1"]],"0"],"BE":["32","00","4\\d{8}|[1-9]\\d{7}",[8,9],[["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["(?:80|9)0"],"0$1"],["(\\d)(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[239]|4[23]"],"0$1"],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[15-8]"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["4"],"0$1"]],"0"],"BF":["226","00","[025-7]\\d{7}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[025-7]"]]]],"BG":["359","00","[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}",[6,7,8,9],[["(\\d)(\\d)(\\d{2})(\\d{2})","$1 $2 $3 $4",["2"],"0$1"],["(\\d{3})(\\d{4})","$1 $2",["43[1-6]|70[1-9]"],"0$1"],["(\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["2"],"0$1"],["(\\d{2})(\\d{3})(\\d{2,3})","$1 $2 $3",["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"],"0$1"],["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["(?:70|8)0"],"0$1"],["(\\d{3})(\\d{3})(\\d{2})","$1 $2 $3",["43[1-7]|7"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[48]|9[08]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["9"],"0$1"]],"0"],"BH":["973","00","[136-9]\\d{7}",[8],[["(\\d{4})(\\d{4})","$1 $2",["[13679]|8[047]"]]]],"BI":["257","00","(?:[267]\\d|31)\\d{6}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2367]"]]]],"BJ":["229","00","(?:[25689]\\d|40)\\d{6}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[24-689]"]]]],"BL":["590","00","(?:590|(?:69|80)\\d|976)\\d{6}",[9],0,"0",0,0,0,0,0,[["590(?:2[7-9]|5[12]|87)\\d{4}"],["69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"],["80[0-5]\\d{6}"],0,0,0,0,0,["976[01]\\d{5}"]]],"BM":["1","011","(?:441|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"1|([2-8]\\d{6})$","441$1",0,"441"],"BN":["673","00","[2-578]\\d{6}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[2-578]"]]]],"BO":["591","00(?:1\\d)?","(?:[2-467]\\d\\d|8001)\\d{5}",[8,9],[["(\\d)(\\d{7})","$1 $2",["[23]|4[46]"]],["(\\d{8})","$1",["[67]"]],["(\\d{3})(\\d{2})(\\d{4})","$1 $2 $3",["8"]]],"0",0,"0(1\\d)?"],"BQ":["599","00","(?:[34]1|7\\d)\\d{5}",[7],0,0,0,0,0,0,"[347]"],"BR":["55","00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)","(?:[1-46-9]\\d\\d|5(?:[0-46-9]\\d|5[0-46-9]))\\d{8}|[1-9]\\d{9}|[3589]\\d{8}|[34]\\d{7}",[8,9,10,11],[["(\\d{4})(\\d{4})","$1-$2",["300|4(?:0[02]|37)","4(?:02|37)0|[34]00"]],["(\\d{3})(\\d{2,3})(\\d{4})","$1 $2 $3",["(?:[358]|90)0"],"0$1"],["(\\d{2})(\\d{4})(\\d{4})","$1 $2-$3",["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"],"($1)"],["(\\d{2})(\\d{5})(\\d{4})","$1 $2-$3",["[16][1-9]|[2-57-9]"],"($1)"]],"0",0,"(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?","$2"],"BS":["1","011","(?:242|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"1|([3-8]\\d{6})$","242$1",0,"242"],"BT":["975","00","[17]\\d{7}|[2-8]\\d{6}",[7,8],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[2-68]|7[246]"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["1[67]|7"]]]],"BW":["267","00","(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}",[7,8,10],[["(\\d{2})(\\d{5})","$1 $2",["90"]],["(\\d{3})(\\d{4})","$1 $2",["[24-6]|3[15-79]"]],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[37]"]],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["0"]],["(\\d{3})(\\d{4})(\\d{3})","$1 $2 $3",["8"]]]],"BY":["375","810","(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}",[6,7,8,9,10,11],[["(\\d{3})(\\d{3})","$1 $2",["800"],"8 $1"],["(\\d{3})(\\d{2})(\\d{2,4})","$1 $2 $3",["800"],"8 $1"],["(\\d{4})(\\d{2})(\\d{3})","$1 $2-$3",["1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])","1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"],"8 0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2-$3-$4",["1(?:[56]|7[467])|2[1-3]"],"8 0$1"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2-$3-$4",["[1-4]"],"8 0$1"],["(\\d{3})(\\d{3,4})(\\d{4})","$1 $2 $3",["[89]"],"8 $1"]],"8",0,"0|80?",0,0,0,0,"8~10"],"BZ":["501","00","(?:0800\\d|[2-8])\\d{6}",[7,11],[["(\\d{3})(\\d{4})","$1-$2",["[2-8]"]],["(\\d)(\\d{3})(\\d{4})(\\d{3})","$1-$2-$3-$4",["0"]]]],"CA":["1","011","(?:[2-8]\\d|90)\\d{8}|3\\d{6}",[7,10],0,"1",0,0,0,0,0,[["(?:2(?:04|[23]6|[48]9|50|63)|3(?:06|43|6[578])|4(?:03|1[68]|3[178]|50|68|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|13|39|47|72)|7(?:0[59]|78|8[02])|8(?:[06]7|19|25|73)|90[25])[2-9]\\d{6}",[10]],["",[10]],["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",[10]],["900[2-9]\\d{6}",[10]],["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:00|2[125-7]|33|44|66|77|88)|622)[2-9]\\d{6}",[10]],0,["310\\d{4}",[7]],0,["600[2-9]\\d{6}",[10]]]],"CC":["61","001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011","1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}",[6,7,8,9,10,12],0,"0",0,"0|([59]\\d{7})$","8$1",0,0,[["8(?:51(?:0(?:02|31|60|89)|1(?:18|76)|223)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}",[9]],["4(?:83[0-38]|93[0-6])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[06-9]|7[02-9]|8[0-24-9]|9[0-27-9])\\d{6}",[9]],["180(?:0\\d{3}|2)\\d{3}",[7,10]],["190[0-26]\\d{6}",[10]],0,0,0,0,["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",[9]],["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",[6,8,10,12]]],"0011"],"CD":["243","00","[189]\\d{8}|[1-68]\\d{6}",[7,9],[["(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["88"],"0$1"],["(\\d{2})(\\d{5})","$1 $2",["[1-6]"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["1"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[89]"],"0$1"]],"0"],"CF":["236","00","(?:[27]\\d{3}|8776)\\d{4}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[278]"]]]],"CG":["242","00","222\\d{6}|(?:0\\d|80)\\d{7}",[9],[["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["8"]],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[02]"]]]],"CH":["41","00","8\\d{11}|[2-9]\\d{8}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["8[047]|90"],"0$1"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2-79]|81"],"0$1"],["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["8"],"0$1"]],"0"],"CI":["225","00","[02]\\d{9}",[10],[["(\\d{2})(\\d{2})(\\d)(\\d{5})","$1 $2 $3 $4",["2"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{4})","$1 $2 $3 $4",["0"]]]],"CK":["682","00","[2-578]\\d{4}",[5],[["(\\d{2})(\\d{3})","$1 $2",["[2-578]"]]]],"CL":["56","(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0","12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}",[9,10,11],[["(\\d{5})(\\d{4})","$1 $2",["219","2196"],"($1)"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["44"]],["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["2[1-36]"],"($1)"],["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["9[2-9]"]],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"],"($1)"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["60|8"]],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["1"]],["(\\d{3})(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3 $4",["60"]]]],"CM":["237","00","[26]\\d{8}|88\\d{6,7}",[8,9],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["88"]],["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["[26]|88"]]]],"CN":["86","00|1(?:[12]\\d|79)\\d\\d00","1[127]\\d{8,9}|2\\d{9}(?:\\d{2})?|[12]\\d{6,7}|86\\d{6}|(?:1[03-689]\\d|6)\\d{7,9}|(?:[3-579]\\d|8[0-57-9])\\d{6,9}",[7,8,9,10,11,12],[["(\\d{2})(\\d{5,6})","$1 $2",["(?:10|2[0-57-9])[19]","(?:10|2[0-57-9])(?:10|9[56])","(?:10|2[0-57-9])(?:100|9[56])"],"0$1"],["(\\d{3})(\\d{5,6})","$1 $2",["3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]","(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]","85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])","85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["(?:4|80)0"]],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["10|2(?:[02-57-9]|1[1-9])","10|2(?:[02-57-9]|1[1-9])","10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"],"0$1",1],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"],"0$1",1],["(\\d{3})(\\d{7,8})","$1 $2",["9"]],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["80"],"0$1",1],["(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["[3-578]"],"0$1",1],["(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["1[3-9]"]],["(\\d{2})(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3 $4",["[12]"],"0$1",1]],"0",0,"0|(1(?:[12]\\d|79)\\d\\d)",0,0,0,0,"00"],"CO":["57","00(?:4(?:[14]4|56)|[579])","(?:60\\d\\d|9101)\\d{6}|(?:1\\d|3)\\d{9}",[10,11],[["(\\d{3})(\\d{7})","$1 $2",["6"],"($1)"],["(\\d{3})(\\d{7})","$1 $2",["[39]"]],["(\\d)(\\d{3})(\\d{7})","$1-$2-$3",["1"],"0$1",0,"$1 $2 $3"]],"0",0,"0(4(?:[14]4|56)|[579])?"],"CR":["506","00","(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}",[8,10],[["(\\d{4})(\\d{4})","$1 $2",["[2-7]|8[3-9]"]],["(\\d{3})(\\d{3})(\\d{4})","$1-$2-$3",["[89]"]]],0,0,"(19(?:0[0-2468]|1[09]|20|66|77|99))"],"CU":["53","119","[27]\\d{6,7}|[34]\\d{5,7}|(?:5|8\\d\\d)\\d{7}",[6,7,8,10],[["(\\d{2})(\\d{4,6})","$1 $2",["2[1-4]|[34]"],"(0$1)"],["(\\d)(\\d{6,7})","$1 $2",["7"],"(0$1)"],["(\\d)(\\d{7})","$1 $2",["5"],"0$1"],["(\\d{3})(\\d{7})","$1 $2",["8"],"0$1"]],"0"],"CV":["238","0","(?:[2-59]\\d\\d|800)\\d{4}",[7],[["(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3",["[2-589]"]]]],"CW":["599","00","(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}",[7,8],[["(\\d{3})(\\d{4})","$1 $2",["[3467]"]],["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["9[4-8]"]]],0,0,0,0,0,"[69]"],"CX":["61","001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011","1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}",[6,7,8,9,10,12],0,"0",0,"0|([59]\\d{7})$","8$1",0,0,[["8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|2(?:22|35))|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}",[9]],["4(?:83[0-38]|93[0-6])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[06-9]|7[02-9]|8[0-24-9]|9[0-27-9])\\d{6}",[9]],["180(?:0\\d{3}|2)\\d{3}",[7,10]],["190[0-26]\\d{6}",[10]],0,0,0,0,["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",[9]],["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",[6,8,10,12]]],"0011"],"CY":["357","00","(?:[279]\\d|[58]0)\\d{6}",[8],[["(\\d{2})(\\d{6})","$1 $2",["[257-9]"]]]],"CZ":["420","00","(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[2-8]|9[015-7]"]],["(\\d{2})(\\d{3})(\\d{3})(\\d{2})","$1 $2 $3 $4",["96"]],["(\\d{2})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["9"]],["(\\d{3})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["9"]]]],"DE":["49","00","[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:2[02-9]|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[015]\\d|[23]1|[46][1-8])\\d{1,9}",[4,5,6,7,8,9,10,11,12,13,14,15],[["(\\d{2})(\\d{3,13})","$1 $2",["3[02]|40|[68]9"],"0$1"],["(\\d{3})(\\d{3,12})","$1 $2",["2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1","2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"],"0$1"],["(\\d{4})(\\d{2,11})","$1 $2",["[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]","[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"],"0$1"],["(\\d{3})(\\d{4})","$1 $2",["138"],"0$1"],["(\\d{5})(\\d{2,10})","$1 $2",["3"],"0$1"],["(\\d{3})(\\d{5,11})","$1 $2",["181"],"0$1"],["(\\d{3})(\\d)(\\d{4,10})","$1 $2 $3",["1(?:3|80)|9"],"0$1"],["(\\d{3})(\\d{7,8})","$1 $2",["1[67]"],"0$1"],["(\\d{3})(\\d{7,12})","$1 $2",["8"],"0$1"],["(\\d{5})(\\d{6})","$1 $2",["185","1850","18500"],"0$1"],["(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["7"],"0$1"],["(\\d{4})(\\d{7})","$1 $2",["18[68]"],"0$1"],["(\\d{5})(\\d{6})","$1 $2",["15[0568]"],"0$1"],["(\\d{4})(\\d{7})","$1 $2",["15[1279]"],"0$1"],["(\\d{3})(\\d{8})","$1 $2",["18"],"0$1"],["(\\d{3})(\\d{2})(\\d{7,8})","$1 $2 $3",["1(?:6[023]|7)"],"0$1"],["(\\d{4})(\\d{2})(\\d{7})","$1 $2 $3",["15[279]"],"0$1"],["(\\d{3})(\\d{2})(\\d{8})","$1 $2 $3",["15"],"0$1"]],"0"],"DJ":["253","00","(?:2\\d|77)\\d{6}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[27]"]]]],"DK":["45","00","[2-9]\\d{7}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2-9]"]]]],"DM":["1","011","(?:[58]\\d\\d|767|900)\\d{7}",[10],0,"1",0,"1|([2-7]\\d{6})$","767$1",0,"767"],"DO":["1","011","(?:[58]\\d\\d|900)\\d{7}",[10],0,"1",0,0,0,0,"8001|8[024]9"],"DZ":["213","00","(?:[1-4]|[5-79]\\d|80)\\d{7}",[8,9],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[1-4]"],"0$1"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["9"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[5-8]"],"0$1"]],"0"],"EC":["593","00","1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}",[8,9,10,11],[["(\\d)(\\d{3})(\\d{4})","$1 $2-$3",["[2-7]"],"(0$1)",0,"$1-$2-$3"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["9"],"0$1"],["(\\d{4})(\\d{3})(\\d{3,4})","$1 $2 $3",["1"]]],"0"],"EE":["372","00","8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}",[7,8,10],[["(\\d{3})(\\d{4})","$1 $2",["[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88","[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"]],["(\\d{4})(\\d{3,4})","$1 $2",["[45]|8(?:00|[1-49])","[45]|8(?:00[1-9]|[1-49])"]],["(\\d{2})(\\d{2})(\\d{4})","$1 $2 $3",["7"]],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["8"]]]],"EG":["20","00","[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}",[8,9,10],[["(\\d)(\\d{7,8})","$1 $2",["[23]"],"0$1"],["(\\d{2})(\\d{6,7})","$1 $2",["1[35]|[4-6]|8[2468]|9[235-7]"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[189]"],"0$1"]],"0"],"EH":["212","00","[5-8]\\d{8}",[9],0,"0",0,0,0,0,"528[89]"],"ER":["291","00","[178]\\d{6}",[7],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[178]"],"0$1"]],"0"],"ES":["34","00","[5-9]\\d{8}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[89]00"]],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[5-9]"]]]],"ET":["251","00","(?:11|[2-579]\\d)\\d{7}",[9],[["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[1-579]"],"0$1"]],"0"],"FI":["358","00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))","[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}",[5,6,7,8,9,10,11,12],[["(\\d)(\\d{4,9})","$1 $2",["[2568][1-8]|3(?:0[1-9]|[1-9])|9"],"0$1"],["(\\d{3})(\\d{3,7})","$1 $2",["[12]00|[368]|70[07-9]"],"0$1"],["(\\d{2})(\\d{4,8})","$1 $2",["[1245]|7[135]"],"0$1"],["(\\d{2})(\\d{6,10})","$1 $2",["7"],"0$1"]],"0",0,0,0,0,"1[03-79]|[2-9]",0,"00"],"FJ":["679","0(?:0|52)","45\\d{5}|(?:0800\\d|[235-9])\\d{6}",[7,11],[["(\\d{3})(\\d{4})","$1 $2",["[235-9]|45"]],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["0"]]],0,0,0,0,0,0,0,"00"],"FK":["500","00","[2-7]\\d{4}",[5]],"FM":["691","00","(?:[39]\\d\\d|820)\\d{4}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[389]"]]]],"FO":["298","00","[2-9]\\d{5}",[6],[["(\\d{6})","$1",["[2-9]"]]],0,0,"(10(?:01|[12]0|88))"],"FR":["33","00","[1-9]\\d{8}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"],"0 $1"],["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["[1-79]"],"0$1"]],"0"],"GA":["241","00","(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}",[7,8],[["(\\d)(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2-7]"],"0$1"],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["0"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["11|[67]"],"0$1"]],0,0,"0(11\\d{6}|60\\d{6}|61\\d{6}|6[256]\\d{6}|7[467]\\d{6})","$1"],"GB":["44","00","[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}",[7,9,10],[["(\\d{3})(\\d{4})","$1 $2",["800","8001","80011","800111","8001111"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3",["845","8454","84546","845464"],"0$1"],["(\\d{3})(\\d{6})","$1 $2",["800"],"0$1"],["(\\d{5})(\\d{4,5})","$1 $2",["1(?:38|5[23]|69|76|94)","1(?:(?:38|69)7|5(?:24|39)|768|946)","1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"],"0$1"],["(\\d{4})(\\d{5,6})","$1 $2",["1(?:[2-69][02-9]|[78])"],"0$1"],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["[25]|7(?:0|6[02-9])","[25]|7(?:0|6(?:[03-9]|2[356]))"],"0$1"],["(\\d{4})(\\d{6})","$1 $2",["7"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[1389]"],"0$1"]],"0",0,0,0,0,0,[["(?:1(?:1(?:3(?:[0-58]\\d\\d|73[0235])|4(?:[0-5]\\d\\d|69[7-9]|70[01359])|(?:5[0-26-9]|[78][0-49])\\d\\d|6(?:[0-4]\\d\\d|50[0-79]))|2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d\\d|1(?:[0-7]\\d\\d|8(?:[02]\\d|1[0-26-9])))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}",[9,10]],["7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}",[10]],["80[08]\\d{7}|800\\d{6}|8001111"],["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d",[7,10]],["70\\d{8}",[10]],0,["(?:3[0347]|55)\\d{8}",[10]],["76(?:464|652)\\d{5}|76(?:0[0-2]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}",[10]],["56\\d{8}",[10]]],0," x"],"GD":["1","011","(?:473|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"1|([2-9]\\d{6})$","473$1",0,"473"],"GE":["995","00","(?:[3-57]\\d\\d|800)\\d{6}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["70"],"0$1"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["32"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[57]"]],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[348]"],"0$1"]],"0"],"GF":["594","00","(?:[56]94|80\\d|976)\\d{6}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[569]"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"],"0$1"]],"0"],"GG":["44","00","(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?",[7,9,10],0,"0",0,"0|([25-9]\\d{5})$","1481$1",0,0,[["1481[25-9]\\d{5}",[10]],["7(?:(?:781|839)\\d|911[17])\\d{5}",[10]],["80[08]\\d{7}|800\\d{6}|8001111"],["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d",[7,10]],["70\\d{8}",[10]],0,["(?:3[0347]|55)\\d{8}",[10]],["76(?:464|652)\\d{5}|76(?:0[0-2]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}",[10]],["56\\d{8}",[10]]]],"GH":["233","00","(?:[235]\\d{3}|800)\\d{5}",[8,9],[["(\\d{3})(\\d{5})","$1 $2",["8"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[235]"],"0$1"]],"0"],"GI":["350","00","(?:[25]\\d\\d|606)\\d{5}",[8],[["(\\d{3})(\\d{5})","$1 $2",["2"]]]],"GL":["299","00","(?:19|[2-689]\\d|70)\\d{4}",[6],[["(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["19|[2-9]"]]]],"GM":["220","00","[2-9]\\d{6}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[2-9]"]]]],"GN":["224","00","722\\d{6}|(?:3|6\\d)\\d{7}",[8,9],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["3"]],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[67]"]]]],"GP":["590","00","(?:590|(?:69|80)\\d|976)\\d{6}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[569]"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"],"0$1"]],"0",0,0,0,0,0,[["590(?:0[1-68]|[14][0-24-9]|2[0-68]|3[1289]|5[3-579]|6[0-289]|7[08]|8[0-689]|9\\d)\\d{4}"],["69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"],["80[0-5]\\d{6}"],0,0,0,0,0,["976[01]\\d{5}"]]],"GQ":["240","00","222\\d{6}|(?:3\\d|55|[89]0)\\d{7}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[235]"]],["(\\d{3})(\\d{6})","$1 $2",["[89]"]]]],"GR":["30","00","5005000\\d{3}|8\\d{9,11}|(?:[269]\\d|70)\\d{8}",[10,11,12],[["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["21|7"]],["(\\d{4})(\\d{6})","$1 $2",["2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[2689]"]],["(\\d{3})(\\d{3,4})(\\d{5})","$1 $2 $3",["8"]]]],"GT":["502","00","(?:1\\d{3}|[2-7])\\d{7}",[8,11],[["(\\d{4})(\\d{4})","$1 $2",["[2-7]"]],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["1"]]]],"GU":["1","011","(?:[58]\\d\\d|671|900)\\d{7}",[10],0,"1",0,"1|([3-9]\\d{6})$","671$1",0,"671"],"GW":["245","00","[49]\\d{8}|4\\d{6}",[7,9],[["(\\d{3})(\\d{4})","$1 $2",["40"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[49]"]]]],"GY":["592","001","9008\\d{3}|(?:[2-467]\\d\\d|862)\\d{4}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[2-46-9]"]]]],"HK":["852","00(?:30|5[09]|[126-9]?)","8[0-46-9]\\d{6,7}|9\\d{4,7}|(?:[2-7]|9\\d{3})\\d{7}",[5,6,7,8,9,11],[["(\\d{3})(\\d{2,5})","$1 $2",["900","9003"]],["(\\d{4})(\\d{4})","$1 $2",["[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["8"]],["(\\d{3})(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3 $4",["9"]]],0,0,0,0,0,0,0,"00"],"HN":["504","00","8\\d{10}|[237-9]\\d{7}",[8,11],[["(\\d{4})(\\d{4})","$1-$2",["[237-9]"]]]],"HR":["385","00","(?:[24-69]\\d|3[0-79])\\d{7}|80\\d{5,7}|[1-79]\\d{7}|6\\d{5,6}",[6,7,8,9],[["(\\d{2})(\\d{2})(\\d{2,3})","$1 $2 $3",["6[01]"],"0$1"],["(\\d{3})(\\d{2})(\\d{2,3})","$1 $2 $3",["8"],"0$1"],["(\\d)(\\d{4})(\\d{3})","$1 $2 $3",["1"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[67]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["9"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[2-5]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["8"],"0$1"]],"0"],"HT":["509","00","[2-489]\\d{7}",[8],[["(\\d{2})(\\d{2})(\\d{4})","$1 $2 $3",["[2-489]"]]]],"HU":["36","00","[235-7]\\d{8}|[1-9]\\d{7}",[8,9],[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["1"],"(06 $1)"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"],"(06 $1)"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[2-9]"],"06 $1"]],"06"],"ID":["62","00[89]","(?:(?:00[1-9]|8\\d)\\d{4}|[1-36])\\d{6}|00\\d{10}|[1-9]\\d{8,10}|[2-9]\\d{7}",[7,8,9,10,11,12,13],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["15"]],["(\\d{2})(\\d{5,9})","$1 $2",["2[124]|[36]1"],"(0$1)"],["(\\d{3})(\\d{5,7})","$1 $2",["800"],"0$1"],["(\\d{3})(\\d{5,8})","$1 $2",["[2-79]"],"(0$1)"],["(\\d{3})(\\d{3,4})(\\d{3})","$1-$2-$3",["8[1-35-9]"],"0$1"],["(\\d{3})(\\d{6,8})","$1 $2",["1"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["804"],"0$1"],["(\\d{3})(\\d)(\\d{3})(\\d{3})","$1 $2 $3 $4",["80"],"0$1"],["(\\d{3})(\\d{4})(\\d{4,5})","$1-$2-$3",["8"],"0$1"]],"0"],"IE":["353","00","(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}",[7,8,9,10],[["(\\d{2})(\\d{5})","$1 $2",["2[24-9]|47|58|6[237-9]|9[35-9]"],"(0$1)"],["(\\d{3})(\\d{5})","$1 $2",["[45]0"],"(0$1)"],["(\\d)(\\d{3,4})(\\d{4})","$1 $2 $3",["1"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[2569]|4[1-69]|7[14]"],"(0$1)"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["70"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["81"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[78]"],"0$1"],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1"]],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["4"],"(0$1)"],["(\\d{2})(\\d)(\\d{3})(\\d{4})","$1 $2 $3 $4",["8"],"0$1"]],"0"],"IL":["972","0(?:0|1[2-9])","1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}",[7,8,9,10,11,12],[["(\\d{4})(\\d{3})","$1-$2",["125"]],["(\\d{4})(\\d{2})(\\d{2})","$1-$2-$3",["121"]],["(\\d)(\\d{3})(\\d{4})","$1-$2-$3",["[2-489]"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["[57]"],"0$1"],["(\\d{4})(\\d{3})(\\d{3})","$1-$2-$3",["12"]],["(\\d{4})(\\d{6})","$1-$2",["159"]],["(\\d)(\\d{3})(\\d{3})(\\d{3})","$1-$2-$3-$4",["1[7-9]"]],["(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})","$1-$2 $3-$4",["15"]]],"0"],"IM":["44","00","1624\\d{6}|(?:[3578]\\d|90)\\d{8}",[10],0,"0",0,"0|([25-8]\\d{5})$","1624$1",0,"74576|(?:16|7[56])24"],"IN":["91","00","(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}",[8,9,10,11,12,13],[["(\\d{8})","$1",["5(?:0|2[23]|3[03]|[67]1|88)","5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)","5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"],0,1],["(\\d{4})(\\d{4,5})","$1 $2",["180","1800"],0,1],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["140"],0,1],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["11|2[02]|33|4[04]|79[1-7]|80[2-46]","11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])","11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"],"0$1",1],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]","1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]","1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"],"0$1",1],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807","1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]","1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"],"0$1",1],["(\\d{5})(\\d{5})","$1 $2",["[6-9]"],"0$1",1],["(\\d{4})(\\d{2,4})(\\d{4})","$1 $2 $3",["1(?:6|8[06])","1(?:6|8[06]0)"],0,1],["(\\d{4})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["18"],0,1]],"0"],"IO":["246","00","3\\d{6}",[7],[["(\\d{3})(\\d{4})","$1 $2",["3"]]]],"IQ":["964","00","(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}",[8,9,10],[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["1"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[2-6]"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["7"],"0$1"]],"0"],"IR":["98","00","[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}",[4,5,6,7,10],[["(\\d{4,5})","$1",["96"],"0$1"],["(\\d{2})(\\d{4,5})","$1 $2",["(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["9"],"0$1"],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["[1-8]"],"0$1"]],"0"],"IS":["354","00|1(?:0(?:01|[12]0)|100)","(?:38\\d|[4-9])\\d{6}",[7,9],[["(\\d{3})(\\d{4})","$1 $2",["[4-9]"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["3"]]],0,0,0,0,0,0,0,"00"],"IT":["39","00","0\\d{5,10}|1\\d{8,10}|3(?:[0-8]\\d{7,10}|9\\d{7,8})|(?:55|70)\\d{8}|8\\d{5}(?:\\d{2,4})?",[6,7,8,9,10,11],[["(\\d{2})(\\d{4,6})","$1 $2",["0[26]"]],["(\\d{3})(\\d{3,6})","$1 $2",["0[13-57-9][0159]|8(?:03|4[17]|9[2-5])","0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"]],["(\\d{4})(\\d{2,6})","$1 $2",["0(?:[13-579][2-46-8]|8[236-8])"]],["(\\d{4})(\\d{4})","$1 $2",["894"]],["(\\d{2})(\\d{3,4})(\\d{4})","$1 $2 $3",["0[26]|5"]],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["1(?:44|[679])|[378]"]],["(\\d{3})(\\d{3,4})(\\d{4})","$1 $2 $3",["0[13-57-9][0159]|14"]],["(\\d{2})(\\d{4})(\\d{5})","$1 $2 $3",["0[26]"]],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["0"]],["(\\d{3})(\\d{4})(\\d{4,5})","$1 $2 $3",["3"]]],0,0,0,0,0,0,[["0669[0-79]\\d{1,6}|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}"],["3[1-9]\\d{8}|3[2-9]\\d{7}",[9,10]],["80(?:0\\d{3}|3)\\d{3}",[6,9]],["(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}",[6,8,9,10]],["1(?:78\\d|99)\\d{6}",[9,10]],0,0,0,["55\\d{8}",[10]],["84(?:[08]\\d{3}|[17])\\d{3}",[6,9]]]],"JE":["44","00","1534\\d{6}|(?:[3578]\\d|90)\\d{8}",[10],0,"0",0,"0|([0-24-8]\\d{5})$","1534$1",0,0,[["1534[0-24-8]\\d{5}"],["7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97[7-9]))\\d{5}"],["80(?:07(?:35|81)|8901)\\d{4}"],["(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}"],["701511\\d{4}"],0,["(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}"],["76(?:464|652)\\d{5}|76(?:0[0-2]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}"],["56\\d{8}"]]],"JM":["1","011","(?:[58]\\d\\d|658|900)\\d{7}",[10],0,"1",0,0,0,0,"658|876"],"JO":["962","00","(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}",[8,9],[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["[2356]|87"],"(0$1)"],["(\\d{3})(\\d{5,6})","$1 $2",["[89]"],"0$1"],["(\\d{2})(\\d{7})","$1 $2",["70"],"0$1"],["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["7"],"0$1"]],"0"],"JP":["81","010","00[1-9]\\d{6,14}|[257-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}",[8,9,10,11,12,13,14,15,16,17],[["(\\d{3})(\\d{3})(\\d{3})","$1-$2-$3",["(?:12|57|99)0"],"0$1"],["(\\d{4})(\\d)(\\d{4})","$1-$2-$3",["1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51|63)|9(?:80|9[16])","1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9]|636)|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]","1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9]|636[457-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["60"],"0$1"],["(\\d)(\\d{4})(\\d{4})","$1-$2-$3",["[36]|4(?:2[09]|7[01])","[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[27-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])","1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9])|5(?:2|3[045]|4[0-369]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|49|51|6(?:[0-24]|36|5[0-3589]|72|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:49|55|83)[29]|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]","1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[23]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|72|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]","1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|7[015-9]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17|3[015-9]))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9(?:[019]|4[1-3]|6(?:[0-47-9]|5[01346-9])))|3(?:[29]|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[23]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|72|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|829(?:2|66)|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"],"0$1"],["(\\d{3})(\\d{2})(\\d{4})","$1-$2-$3",["[14]|[289][2-9]|5[3-9]|7[2-4679]"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1-$2-$3",["800"],"0$1"],["(\\d{2})(\\d{4})(\\d{4})","$1-$2-$3",["[257-9]"],"0$1"]],"0"],"KE":["254","000","(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}",[7,8,9,10],[["(\\d{2})(\\d{5,7})","$1 $2",["[24-6]"],"0$1"],["(\\d{3})(\\d{6})","$1 $2",["[17]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["[89]"],"0$1"]],"0"],"KG":["996","00","8\\d{9}|(?:[235-8]\\d|99)\\d{7}",[9,10],[["(\\d{4})(\\d{5})","$1 $2",["3(?:1[346]|[24-79])"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[235-79]|88"],"0$1"],["(\\d{3})(\\d{3})(\\d)(\\d{2,3})","$1 $2 $3 $4",["8"],"0$1"]],"0"],"KH":["855","00[14-9]","1\\d{9}|[1-9]\\d{7,8}",[8,9,10],[["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[1-9]"],"0$1"],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1"]]],"0"],"KI":["686","00","(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}",[5,8],0,"0"],"KM":["269","00","[3478]\\d{6}",[7],[["(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3",["[3478]"]]]],"KN":["1","011","(?:[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"1|([2-7]\\d{6})$","869$1",0,"869"],"KP":["850","00|99","85\\d{6}|(?:19\\d|[2-7])\\d{7}",[8,10],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["8"],"0$1"],["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["[2-7]"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["1"],"0$1"]],"0"],"KR":["82","00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))","00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}",[5,6,8,9,10,11,12,13,14],[["(\\d{2})(\\d{3,4})","$1-$2",["(?:3[1-3]|[46][1-4]|5[1-5])1"],"0$1"],["(\\d{4})(\\d{4})","$1-$2",["1"]],["(\\d)(\\d{3,4})(\\d{4})","$1-$2-$3",["2"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["60|8"],"0$1"],["(\\d{2})(\\d{3,4})(\\d{4})","$1-$2-$3",["[1346]|5[1-5]"],"0$1"],["(\\d{2})(\\d{4})(\\d{4})","$1-$2-$3",["[57]"],"0$1"],["(\\d{2})(\\d{5})(\\d{4})","$1-$2-$3",["5"],"0$1"]],"0",0,"0(8(?:[1-46-8]|5\\d\\d))?"],"KW":["965","00","18\\d{5}|(?:[2569]\\d|41)\\d{6}",[7,8],[["(\\d{4})(\\d{3,4})","$1 $2",["[169]|2(?:[235]|4[1-35-9])|52"]],["(\\d{3})(\\d{5})","$1 $2",["[245]"]]]],"KY":["1","011","(?:345|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"1|([2-9]\\d{6})$","345$1",0,"345"],"KZ":["7","810","(?:33622|8\\d{8})\\d{5}|[78]\\d{9}",[10,14],0,"8",0,0,0,0,"33|7",0,"8~10"],"LA":["856","00","[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}",[8,9,10],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["2[13]|3[14]|[4-8]"],"0$1"],["(\\d{2})(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3 $4",["30[013-9]"],"0$1"],["(\\d{2})(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3 $4",["[23]"],"0$1"]],"0"],"LB":["961","00","[27-9]\\d{7}|[13-9]\\d{6}",[7,8],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[27-9]"]]],"0"],"LC":["1","011","(?:[58]\\d\\d|758|900)\\d{7}",[10],0,"1",0,"1|([2-8]\\d{6})$","758$1",0,"758"],"LI":["423","00","[68]\\d{8}|(?:[2378]\\d|90)\\d{5}",[7,9],[["(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3",["[2379]|8(?:0[09]|7)","[2379]|8(?:0(?:02|9)|7)"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["8"]],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["69"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["6"]]],"0",0,"0|(1001)"],"LK":["94","00","[1-9]\\d{8}",[9],[["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["7"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[1-689]"],"0$1"]],"0"],"LR":["231","00","(?:2|33|5\\d|77|88)\\d{7}|[4-6]\\d{6}",[7,8,9],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[4-6]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["2"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[3578]"],"0$1"]],"0"],"LS":["266","00","(?:[256]\\d\\d|800)\\d{5}",[8],[["(\\d{4})(\\d{4})","$1 $2",["[2568]"]]]],"LT":["370","00","(?:[3469]\\d|52|[78]0)\\d{6}",[8],[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["52[0-7]"],"(8-$1)",1],["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["[7-9]"],"8 $1",1],["(\\d{2})(\\d{6})","$1 $2",["37|4(?:[15]|6[1-8])"],"(8-$1)",1],["(\\d{3})(\\d{5})","$1 $2",["[3-6]"],"(8-$1)",1]],"8",0,"[08]"],"LU":["352","00","35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}",[4,5,6,7,8,9,10,11],[["(\\d{2})(\\d{3})","$1 $2",["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]],["(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]],["(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["20[2-689]"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})","$1 $2 $3 $4",["2(?:[0367]|4[3-8])"]],["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["80[01]|90[015]"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3 $4",["20"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["6"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})","$1 $2 $3 $4 $5",["2(?:[0367]|4[3-8])"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})","$1 $2 $3 $4",["[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"]]],0,0,"(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)"],"LV":["371","00","(?:[268]\\d|90)\\d{6}",[8],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[269]|8[01]"]]]],"LY":["218","00","[2-9]\\d{8}",[9],[["(\\d{2})(\\d{7})","$1-$2",["[2-9]"],"0$1"]],"0"],"MA":["212","00","[5-8]\\d{8}",[9],[["(\\d{5})(\\d{4})","$1-$2",["5(?:29|38)","5(?:29[89]|389)","5(?:29[89]|389)0"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["5[45]"],"0$1"],["(\\d{4})(\\d{5})","$1-$2",["5(?:2[2-489]|3[5-9]|9)|892","5(?:2(?:[2-49]|8[235-9])|3[5-9]|9)|892"],"0$1"],["(\\d{2})(\\d{7})","$1-$2",["8"],"0$1"],["(\\d{3})(\\d{6})","$1-$2",["[5-7]"],"0$1"]],"0",0,0,0,0,0,[["5(?:29(?:[189][05]|2[29]|3[01])|389[05])\\d{4}|5(?:2(?:[0-25-7]\\d|3[1-578]|4[02-46-8]|8[0235-7]|90)|3(?:[0-47]\\d|5[02-9]|6[02-8]|8[08]|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}"],["(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[017]\\d|2[0-2]|6[0-8]))\\d{6}"],["80\\d{7}"],["89\\d{7}"],0,0,0,0,["592(?:4[0-2]|93)\\d{4}"]]],"MC":["377","00","(?:[3489]|6\\d)\\d{7}",[8,9],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["4"],"0$1"],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[389]"]],["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["6"],"0$1"]],"0"],"MD":["373","00","(?:[235-7]\\d|[89]0)\\d{6}",[8],[["(\\d{3})(\\d{5})","$1 $2",["[89]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["22|3"],"0$1"],["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["[25-7]"],"0$1"]],"0"],"ME":["382","00","(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}",[8,9],[["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[2-9]"],"0$1"]],"0"],"MF":["590","00","(?:590|(?:69|80)\\d|976)\\d{6}",[9],0,"0",0,0,0,0,0,[["590(?:0[079]|[14]3|[27][79]|30|5[0-268]|87)\\d{4}"],["69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"],["80[0-5]\\d{6}"],0,0,0,0,0,["976[01]\\d{5}"]]],"MG":["261","00","[23]\\d{8}",[9],[["(\\d{2})(\\d{2})(\\d{3})(\\d{2})","$1 $2 $3 $4",["[23]"],"0$1"]],"0",0,"0|([24-9]\\d{6})$","20$1"],"MH":["692","011","329\\d{4}|(?:[256]\\d|45)\\d{5}",[7],[["(\\d{3})(\\d{4})","$1-$2",["[2-6]"]]],"1"],"MK":["389","00","[2-578]\\d{7}",[8],[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["2|34[47]|4(?:[37]7|5[47]|64)"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[347]"],"0$1"],["(\\d{3})(\\d)(\\d{2})(\\d{2})","$1 $2 $3 $4",["[58]"],"0$1"]],"0"],"ML":["223","00","[24-9]\\d{7}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[24-9]"]]]],"MM":["95","00","1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}",[6,7,8,9,10],[["(\\d)(\\d{2})(\\d{3})","$1 $2 $3",["16|2"],"0$1"],["(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["[45]|6(?:0[23]|[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-6]"],"0$1"],["(\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["[12]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[4-7]|8[1-35]"],"0$1"],["(\\d)(\\d{3})(\\d{4,6})","$1 $2 $3",["9(?:2[0-4]|[35-9]|4[137-9])"],"0$1"],["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["2"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["8"],"0$1"],["(\\d)(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["92"],"0$1"],["(\\d)(\\d{5})(\\d{4})","$1 $2 $3",["9"],"0$1"]],"0"],"MN":["976","001","[12]\\d{7,9}|[5-9]\\d{7}",[8,9,10],[["(\\d{2})(\\d{2})(\\d{4})","$1 $2 $3",["[12]1"],"0$1"],["(\\d{4})(\\d{4})","$1 $2",["[5-9]"]],["(\\d{3})(\\d{5,6})","$1 $2",["[12]2[1-3]"],"0$1"],["(\\d{4})(\\d{5,6})","$1 $2",["[12](?:27|3[2-8]|4[2-68]|5[1-4689])","[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"],"0$1"],["(\\d{5})(\\d{4,5})","$1 $2",["[12]"],"0$1"]],"0"],"MO":["853","00","0800\\d{3}|(?:28|[68]\\d)\\d{6}",[7,8],[["(\\d{4})(\\d{3})","$1 $2",["0"]],["(\\d{4})(\\d{4})","$1 $2",["[268]"]]]],"MP":["1","011","[58]\\d{9}|(?:67|90)0\\d{7}",[10],0,"1",0,"1|([2-9]\\d{6})$","670$1",0,"670"],"MQ":["596","00","(?:69|80)\\d{7}|(?:59|97)6\\d{6}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[569]"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"],"0$1"]],"0"],"MR":["222","00","(?:[2-4]\\d\\d|800)\\d{5}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2-48]"]]]],"MS":["1","011","(?:[58]\\d\\d|664|900)\\d{7}",[10],0,"1",0,"1|([34]\\d{6})$","664$1",0,"664"],"MT":["356","00","3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}",[8],[["(\\d{4})(\\d{4})","$1 $2",["[2357-9]"]]]],"MU":["230","0(?:0|[24-7]0|3[03])","(?:5|8\\d\\d)\\d{7}|[2-468]\\d{6}",[7,8,10],[["(\\d{3})(\\d{4})","$1 $2",["[2-46]|8[013]"]],["(\\d{4})(\\d{4})","$1 $2",["5"]],["(\\d{5})(\\d{5})","$1 $2",["8"]]],0,0,0,0,0,0,0,"020"],"MV":["960","0(?:0|19)","(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}",[7,10],[["(\\d{3})(\\d{4})","$1-$2",["[3467]|9[13-9]"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[89]"]]],0,0,0,0,0,0,0,"00"],"MW":["265","00","(?:[129]\\d|31|77|88)\\d{7}|1\\d{6}",[7,9],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["1[2-9]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["2"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[137-9]"],"0$1"]],"0"],"MX":["52","0[09]","1(?:(?:44|99)[1-9]|65[0-689])\\d{7}|(?:1(?:[017]\\d|[235][1-9]|4[0-35-9]|6[0-46-9]|8[1-79]|9[1-8])|[2-9]\\d)\\d{8}",[10,11],[["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["33|5[56]|81"],0,1],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[2-9]"],0,1],["(\\d)(\\d{2})(\\d{4})(\\d{4})","$2 $3 $4",["1(?:33|5[56]|81)"],0,1],["(\\d)(\\d{3})(\\d{3})(\\d{4})","$2 $3 $4",["1"],0,1]],"01",0,"0(?:[12]|4[45])|1",0,0,0,0,"00"],"MY":["60","00","1\\d{8,9}|(?:3\\d|[4-9])\\d{7}",[8,9,10],[["(\\d)(\\d{3})(\\d{4})","$1-$2 $3",["[4-79]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1-$2 $3",["1(?:[02469]|[378][1-9]|53)|8","1(?:[02469]|[37][1-9]|53|8(?:[1-46-9]|5[7-9]))|8"],"0$1"],["(\\d)(\\d{4})(\\d{4})","$1-$2 $3",["3"],"0$1"],["(\\d)(\\d{3})(\\d{2})(\\d{4})","$1-$2-$3-$4",["1(?:[367]|80)"]],["(\\d{3})(\\d{3})(\\d{4})","$1-$2 $3",["15"],"0$1"],["(\\d{2})(\\d{4})(\\d{4})","$1-$2 $3",["1"],"0$1"]],"0"],"MZ":["258","00","(?:2|8\\d)\\d{7}",[8,9],[["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["2|8[2-79]"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["8"]]]],"NA":["264","00","[68]\\d{7,8}",[8,9],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["88"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["6"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["87"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["8"],"0$1"]],"0"],"NC":["687","00","(?:050|[2-57-9]\\d\\d)\\d{3}",[6],[["(\\d{2})(\\d{2})(\\d{2})","$1.$2.$3",["[02-57-9]"]]]],"NE":["227","00","[027-9]\\d{7}",[8],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["08"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[089]|2[013]|7[04]"]]]],"NF":["672","00","[13]\\d{5}",[6],[["(\\d{2})(\\d{4})","$1 $2",["1[0-3]"]],["(\\d)(\\d{5})","$1 $2",["[13]"]]],0,0,"([0-258]\\d{4})$","3$1"],"NG":["234","009","(?:[124-7]|9\\d{3})\\d{6}|[1-9]\\d{7}|[78]\\d{9,13}",[7,8,10,11,12,13,14],[["(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["78"],"0$1"],["(\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["[12]|9(?:0[3-9]|[1-9])"],"0$1"],["(\\d{2})(\\d{3})(\\d{2,3})","$1 $2 $3",["[3-7]|8[2-9]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["[7-9]"],"0$1"],["(\\d{3})(\\d{4})(\\d{4,5})","$1 $2 $3",["[78]"],"0$1"],["(\\d{3})(\\d{5})(\\d{5,6})","$1 $2 $3",["[78]"],"0$1"]],"0"],"NI":["505","00","(?:1800|[25-8]\\d{3})\\d{4}",[8],[["(\\d{4})(\\d{4})","$1 $2",["[125-8]"]]]],"NL":["31","00","(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|8\\d{6,9}|9\\d{6,10}|1\\d{4,5}",[5,6,7,8,9,10,11],[["(\\d{3})(\\d{4,7})","$1 $2",["[89]0"],"0$1"],["(\\d{2})(\\d{7})","$1 $2",["66"],"0$1"],["(\\d)(\\d{8})","$1 $2",["6"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[1-578]|91"],"0$1"],["(\\d{3})(\\d{3})(\\d{5})","$1 $2 $3",["9"],"0$1"]],"0"],"NO":["47","00","(?:0|[2-9]\\d{3})\\d{4}",[5,8],[["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["[489]|59"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[235-7]"]]],0,0,0,0,0,"[02-689]|7[0-8]"],"NP":["977","00","(?:1\\d|9)\\d{9}|[1-9]\\d{7}",[8,10,11],[["(\\d)(\\d{7})","$1-$2",["1[2-6]"],"0$1"],["(\\d{2})(\\d{6})","$1-$2",["1[01]|[2-8]|9(?:[1-59]|[67][2-6])"],"0$1"],["(\\d{3})(\\d{7})","$1-$2",["9"]]],"0"],"NR":["674","00","(?:444|(?:55|8\\d)\\d|666)\\d{4}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[4-68]"]]]],"NU":["683","00","(?:[47]|888\\d)\\d{3}",[4,7],[["(\\d{3})(\\d{4})","$1 $2",["8"]]]],"NZ":["64","0(?:0|161)","[29]\\d{7,9}|50\\d{5}(?:\\d{2,3})?|6[0-35-9]\\d{6}|7\\d{7,8}|8\\d{4,9}|(?:11\\d|[34])\\d{7}",[5,6,7,8,9,10],[["(\\d{2})(\\d{3,8})","$1 $2",["8[1-579]"],"0$1"],["(\\d{3})(\\d{2})(\\d{2,3})","$1 $2 $3",["50[036-8]|[89]0","50(?:[0367]|88)|[89]0"],"0$1"],["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["24|[346]|7[2-57-9]|9[2-9]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["2(?:10|74)|[59]|80"],"0$1"],["(\\d{2})(\\d{3,4})(\\d{4})","$1 $2 $3",["1|2[028]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,5})","$1 $2 $3",["2(?:[169]|7[0-35-9])|7|86"],"0$1"]],"0",0,0,0,0,0,0,"00"],"OM":["968","00","(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}",[7,8,9],[["(\\d{3})(\\d{4,6})","$1 $2",["[58]"]],["(\\d{2})(\\d{6})","$1 $2",["2"]],["(\\d{4})(\\d{4})","$1 $2",["[179]"]]]],"PA":["507","00","(?:00800|8\\d{3})\\d{6}|[68]\\d{7}|[1-57-9]\\d{6}",[7,8,10,11],[["(\\d{3})(\\d{4})","$1-$2",["[1-57-9]"]],["(\\d{4})(\\d{4})","$1-$2",["[68]"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["8"]]]],"PE":["51","00|19(?:1[124]|77|90)00","(?:[14-8]|9\\d)\\d{7}",[8,9],[["(\\d{3})(\\d{5})","$1 $2",["80"],"(0$1)"],["(\\d)(\\d{7})","$1 $2",["1"],"(0$1)"],["(\\d{2})(\\d{6})","$1 $2",["[4-8]"],"(0$1)"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["9"]]],"0",0,0,0,0,0,0,"00"," Anexo "],"PF":["689","00","4\\d{5}(?:\\d{2})?|8\\d{7,8}",[6,8,9],[["(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["44"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["4|8[7-9]"]],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"]]]],"PG":["675","00|140[1-3]","(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}",[7,8],[["(\\d{3})(\\d{4})","$1 $2",["18|[2-69]|85"]],["(\\d{4})(\\d{4})","$1 $2",["[78]"]]],0,0,0,0,0,0,0,"00"],"PH":["63","00","(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}",[6,8,9,10,11,12,13],[["(\\d)(\\d{5})","$1 $2",["2"],"(0$1)"],["(\\d{4})(\\d{4,6})","$1 $2",["3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2","3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"],"(0$1)"],["(\\d{5})(\\d{4})","$1 $2",["346|4(?:27|9[35])|883","3469|4(?:279|9(?:30|56))|8834"],"(0$1)"],["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["2"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[3-7]|8[2-8]"],"(0$1)"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[89]"],"0$1"],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["1"]],["(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})","$1 $2 $3 $4",["1"]]],"0"],"PK":["92","00","122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}",[8,9,10,11,12],[["(\\d{3})(\\d{3})(\\d{2,7})","$1 $2 $3",["[89]0"],"0$1"],["(\\d{4})(\\d{5})","$1 $2",["1"]],["(\\d{3})(\\d{6,7})","$1 $2",["2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])","9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"],"(0$1)"],["(\\d{2})(\\d{7,8})","$1 $2",["(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"],"(0$1)"],["(\\d{5})(\\d{5})","$1 $2",["58"],"(0$1)"],["(\\d{3})(\\d{7})","$1 $2",["3"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"],"(0$1)"],["(\\d{3})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["[24-9]"],"(0$1)"]],"0"],"PL":["48","00","6\\d{5}(?:\\d{2})?|8\\d{9}|[1-9]\\d{6}(?:\\d{2})?",[6,7,8,9,10],[["(\\d{5})","$1",["19"]],["(\\d{3})(\\d{3})","$1 $2",["11|64"]],["(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1","(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"]],["(\\d{3})(\\d{2})(\\d{2,3})","$1 $2 $3",["64"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"]],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["1[2-8]|[2-7]|8[1-79]|9[145]"]],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["8"]]]],"PM":["508","00","(?:[45]|80\\d\\d)\\d{5}",[6,9],[["(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["[45]"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"],"0$1"]],"0"],"PR":["1","011","(?:[589]\\d\\d|787)\\d{7}",[10],0,"1",0,0,0,0,"787|939"],"PS":["970","00","[2489]2\\d{6}|(?:1\\d|5)\\d{8}",[8,9,10],[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["[2489]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["5"],"0$1"],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1"]]],"0"],"PT":["351","00","1693\\d{5}|(?:[26-9]\\d|30)\\d{7}",[9],[["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["2[12]"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["16|[236-9]"]]]],"PW":["680","01[12]","(?:[24-8]\\d\\d|345|900)\\d{4}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[2-9]"]]]],"PY":["595","00","59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}",[6,7,8,9,10,11],[["(\\d{3})(\\d{3,6})","$1 $2",["[2-9]0"],"0$1"],["(\\d{2})(\\d{5})","$1 $2",["[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"],"(0$1)"],["(\\d{3})(\\d{4,5})","$1 $2",["2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["87"]],["(\\d{3})(\\d{6})","$1 $2",["9(?:[5-79]|8[1-6])"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[2-8]"],"0$1"],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["9"]]],"0"],"QA":["974","00","[2-7]\\d{7}|800\\d{4}(?:\\d{2})?|2\\d{6}",[7,8,9],[["(\\d{3})(\\d{4})","$1 $2",["2[126]|8"]],["(\\d{4})(\\d{4})","$1 $2",["[2-7]"]]]],"RE":["262","00","976\\d{6}|(?:26|[68]\\d)\\d{7}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2689]"],"0$1"]],"0",0,0,0,0,"26[23]|69|[89]"],"RO":["40","00","(?:[2378]\\d|90)\\d{7}|[23]\\d{5}",[6,9],[["(\\d{3})(\\d{3})","$1 $2",["2[3-6]","2[3-6]\\d9"],"0$1"],["(\\d{2})(\\d{4})","$1 $2",["219|31"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[23]1"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[237-9]"],"0$1"]],"0",0,0,0,0,0,0,0," int "],"RS":["381","00","38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}",[6,7,8,9,10,11,12],[["(\\d{3})(\\d{3,9})","$1 $2",["(?:2[389]|39)0|[7-9]"],"0$1"],["(\\d{2})(\\d{5,10})","$1 $2",["[1-36]"],"0$1"]],"0"],"RU":["7","810","8\\d{13}|[347-9]\\d{9}",[10,14],[["(\\d{4})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["7(?:1[0-8]|2[1-9])","7(?:1(?:[0-6]2|7|8[27])|2(?:1[23]|[2-9]2))","7(?:1(?:[0-6]2|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"],"8 ($1)",1],["(\\d{5})(\\d)(\\d{2})(\\d{2})","$1 $2 $3 $4",["7(?:1[0-68]|2[1-9])","7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))","7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"],"8 ($1)",1],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["7"],"8 ($1)",1],["(\\d{3})(\\d{3})(\\d{2})(\\d{2})","$1 $2-$3-$4",["[349]|8(?:[02-7]|1[1-8])"],"8 ($1)",1],["(\\d{4})(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3 $4",["8"],"8 ($1)"]],"8",0,0,0,0,"3[04-689]|[489]",0,"8~10"],"RW":["250","00","(?:06|[27]\\d\\d|[89]00)\\d{6}",[8,9],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["0"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[7-9]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["2"]]],"0"],"SA":["966","00","92\\d{7}|(?:[15]|8\\d)\\d{8}",[9,10],[["(\\d{4})(\\d{5})","$1 $2",["9"]],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["1"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["5"],"0$1"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["81"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["8"]]],"0"],"SB":["677","0[01]","(?:[1-6]|[7-9]\\d\\d)\\d{4}",[5,7],[["(\\d{2})(\\d{5})","$1 $2",["7|8[4-9]|9(?:[1-8]|9[0-8])"]]]],"SC":["248","010|0[0-2]","800\\d{4}|(?:[249]\\d|64)\\d{5}",[7],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[246]|9[57]"]]],0,0,0,0,0,0,0,"00"],"SD":["249","00","[19]\\d{8}",[9],[["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[19]"],"0$1"]],"0"],"SE":["46","00","(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}",[6,7,8,9,10],[["(\\d{2})(\\d{2,3})(\\d{2})","$1-$2 $3",["20"],"0$1",0,"$1 $2 $3"],["(\\d{3})(\\d{4})","$1-$2",["9(?:00|39|44|9)"],"0$1",0,"$1 $2"],["(\\d{2})(\\d{3})(\\d{2})","$1-$2 $3",["[12][136]|3[356]|4[0246]|6[03]|90[1-9]"],"0$1",0,"$1 $2 $3"],["(\\d)(\\d{2,3})(\\d{2})(\\d{2})","$1-$2 $3 $4",["8"],"0$1",0,"$1 $2 $3 $4"],["(\\d{3})(\\d{2,3})(\\d{2})","$1-$2 $3",["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"],"0$1",0,"$1 $2 $3"],["(\\d{3})(\\d{2,3})(\\d{3})","$1-$2 $3",["9(?:00|39|44)"],"0$1",0,"$1 $2 $3"],["(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})","$1-$2 $3 $4",["1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"],"0$1",0,"$1 $2 $3 $4"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1-$2 $3 $4",["10|7"],"0$1",0,"$1 $2 $3 $4"],["(\\d)(\\d{3})(\\d{3})(\\d{2})","$1-$2 $3 $4",["8"],"0$1",0,"$1 $2 $3 $4"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1-$2 $3 $4",["[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"],"0$1",0,"$1 $2 $3 $4"],["(\\d{3})(\\d{2})(\\d{2})(\\d{3})","$1-$2 $3 $4",["9"],"0$1",0,"$1 $2 $3 $4"],["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1-$2 $3 $4 $5",["[26]"],"0$1",0,"$1 $2 $3 $4 $5"]],"0"],"SG":["65","0[0-3]\\d","(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}",[8,10,11],[["(\\d{4})(\\d{4})","$1 $2",["[369]|8(?:0[1-5]|[1-9])"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["8"]],["(\\d{4})(\\d{4})(\\d{3})","$1 $2 $3",["7"]],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["1"]]]],"SH":["290","00","(?:[256]\\d|8)\\d{3}",[4,5],0,0,0,0,0,0,"[256]"],"SI":["386","00|10(?:22|66|88|99)","[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}",[5,6,7,8],[["(\\d{2})(\\d{3,6})","$1 $2",["8[09]|9"],"0$1"],["(\\d{3})(\\d{5})","$1 $2",["59|8"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[37][01]|4[0139]|51|6"],"0$1"],["(\\d)(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[1-57]"],"(0$1)"]],"0",0,0,0,0,0,0,"00"],"SJ":["47","00","0\\d{4}|(?:[489]\\d|[57]9)\\d{6}",[5,8],0,0,0,0,0,0,"79"],"SK":["421","00","[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}",[6,7,9],[["(\\d)(\\d{2})(\\d{3,4})","$1 $2 $3",["21"],"0$1"],["(\\d{2})(\\d{2})(\\d{2,3})","$1 $2 $3",["[3-5][1-8]1","[3-5][1-8]1[67]"],"0$1"],["(\\d)(\\d{3})(\\d{3})(\\d{2})","$1/$2 $3 $4",["2"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[689]"],"0$1"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1/$2 $3 $4",["[3-5]"],"0$1"]],"0"],"SL":["232","00","(?:[237-9]\\d|66)\\d{6}",[8],[["(\\d{2})(\\d{6})","$1 $2",["[236-9]"],"(0$1)"]],"0"],"SM":["378","00","(?:0549|[5-7]\\d)\\d{6}",[8,10],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[5-7]"]],["(\\d{4})(\\d{6})","$1 $2",["0"]]],0,0,"([89]\\d{5})$","0549$1"],"SN":["221","00","(?:[378]\\d|93)\\d{7}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"]],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[379]"]]]],"SO":["252","00","[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}",[6,7,8,9],[["(\\d{2})(\\d{4})","$1 $2",["8[125]"]],["(\\d{6})","$1",["[134]"]],["(\\d)(\\d{6})","$1 $2",["[15]|2[0-79]|3[0-46-8]|4[0-7]"]],["(\\d)(\\d{7})","$1 $2",["24|[67]"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[3478]|64|90"]],["(\\d{2})(\\d{5,7})","$1 $2",["1|28|6(?:0[5-7]|[1-35-9])|9[2-9]"]]],"0"],"SR":["597","00","(?:[2-5]|68|[78]\\d)\\d{5}",[6,7],[["(\\d{2})(\\d{2})(\\d{2})","$1-$2-$3",["56"]],["(\\d{3})(\\d{3})","$1-$2",["[2-5]"]],["(\\d{3})(\\d{4})","$1-$2",["[6-8]"]]]],"SS":["211","00","[19]\\d{8}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[19]"],"0$1"]],"0"],"ST":["239","00","(?:22|9\\d)\\d{5}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[29]"]]]],"SV":["503","00","[267]\\d{7}|[89]00\\d{4}(?:\\d{4})?",[7,8,11],[["(\\d{3})(\\d{4})","$1 $2",["[89]"]],["(\\d{4})(\\d{4})","$1 $2",["[267]"]],["(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["[89]"]]]],"SX":["1","011","7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"1|(5\\d{6})$","721$1",0,"721"],"SY":["963","00","[1-39]\\d{8}|[1-5]\\d{7}",[8,9],[["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[1-5]"],"0$1",1],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["9"],"0$1",1]],"0"],"SZ":["268","00","0800\\d{4}|(?:[237]\\d|900)\\d{6}",[8,9],[["(\\d{4})(\\d{4})","$1 $2",["[0237]"]],["(\\d{5})(\\d{4})","$1 $2",["9"]]]],"TA":["290","00","8\\d{3}",[4],0,0,0,0,0,0,"8"],"TC":["1","011","(?:[58]\\d\\d|649|900)\\d{7}",[10],0,"1",0,"1|([2-479]\\d{6})$","649$1",0,"649"],"TD":["235","00|16","(?:22|[69]\\d|77)\\d{6}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2679]"]]],0,0,0,0,0,0,0,"00"],"TG":["228","00","[279]\\d{7}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[279]"]]]],"TH":["66","00[1-9]","(?:001800|[2-57]|[689]\\d)\\d{7}|1\\d{7,9}",[8,9,10,13],[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["2"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[13-9]"],"0$1"],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1"]]],"0"],"TJ":["992","810","(?:00|[1-57-9]\\d)\\d{7}",[9],[["(\\d{6})(\\d)(\\d{2})","$1 $2 $3",["331","3317"]],["(\\d{3})(\\d{2})(\\d{4})","$1 $2 $3",["[34]7|91[78]"]],["(\\d{4})(\\d)(\\d{4})","$1 $2 $3",["3[1-5]"]],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[0-57-9]"]]],0,0,0,0,0,0,0,"8~10"],"TK":["690","00","[2-47]\\d{3,6}",[4,5,6,7]],"TL":["670","00","7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}",[7,8],[["(\\d{3})(\\d{4})","$1 $2",["[2-489]|70"]],["(\\d{4})(\\d{4})","$1 $2",["7"]]]],"TM":["993","810","[1-6]\\d{7}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2-$3-$4",["12"],"(8 $1)"],["(\\d{3})(\\d)(\\d{2})(\\d{2})","$1 $2-$3-$4",["[1-5]"],"(8 $1)"],["(\\d{2})(\\d{6})","$1 $2",["6"],"8 $1"]],"8",0,0,0,0,0,0,"8~10"],"TN":["216","00","[2-57-9]\\d{7}",[8],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[2-57-9]"]]]],"TO":["676","00","(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}",[5,7],[["(\\d{2})(\\d{3})","$1-$2",["[2-4]|50|6[09]|7[0-24-69]|8[05]"]],["(\\d{4})(\\d{3})","$1 $2",["0"]],["(\\d{3})(\\d{4})","$1 $2",["[5-9]"]]]],"TR":["90","00","4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}",[7,10,12,13],[["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["512|8[01589]|90"],"0$1",1],["(\\d{3})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["5(?:[0-59]|61)","5(?:[0-59]|616)","5(?:[0-59]|6161)"],"0$1",1],["(\\d{3})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[24][1-8]|3[1-9]"],"(0$1)",1],["(\\d{3})(\\d{3})(\\d{6,7})","$1 $2 $3",["80"],"0$1",1]],"0"],"TT":["1","011","(?:[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"1|([2-46-8]\\d{6})$","868$1",0,"868"],"TV":["688","00","(?:2|7\\d\\d|90)\\d{4}",[5,6,7],[["(\\d{2})(\\d{3})","$1 $2",["2"]],["(\\d{2})(\\d{4})","$1 $2",["90"]],["(\\d{2})(\\d{5})","$1 $2",["7"]]]],"TW":["886","0(?:0[25-79]|19)","[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}",[7,8,9,10,11],[["(\\d{2})(\\d)(\\d{4})","$1 $2 $3",["202"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[258]0"],"0$1"],["(\\d)(\\d{3,4})(\\d{4})","$1 $2 $3",["[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]","[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[49]"],"0$1"],["(\\d{2})(\\d{4})(\\d{4,5})","$1 $2 $3",["7"],"0$1"]],"0",0,0,0,0,0,0,0,"#"],"TZ":["255","00[056]","(?:[26-8]\\d|41|90)\\d{7}",[9],[["(\\d{3})(\\d{2})(\\d{4})","$1 $2 $3",["[89]"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[24]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[67]"],"0$1"]],"0"],"UA":["380","00","[89]\\d{9}|[3-9]\\d{8}",[9,10],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]","6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"],"0$1"],["(\\d{4})(\\d{5})","$1 $2",["3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6[0135689]|7[4-6])|6(?:[12][3-7]|[459])","3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6(?:[015689]|3[02389])|7[4-6])|6(?:[12][3-7]|[459])"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[3-7]|89|9[1-9]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["[89]"],"0$1"]],"0",0,0,0,0,0,0,"0~0"],"UG":["256","00[057]","800\\d{6}|(?:[29]0|[347]\\d)\\d{7}",[9],[["(\\d{4})(\\d{5})","$1 $2",["202","2024"],"0$1"],["(\\d{3})(\\d{6})","$1 $2",["[27-9]|4(?:6[45]|[7-9])"],"0$1"],["(\\d{2})(\\d{7})","$1 $2",["[34]"],"0$1"]],"0"],"US":["1","011","[2-9]\\d{9}|3\\d{6}",[10],[["(\\d{3})(\\d{4})","$1-$2",["310"],0,1],["(\\d{3})(\\d{3})(\\d{4})","($1) $2-$3",["[2-9]"],0,1,"$1-$2-$3"]],"1",0,0,0,0,0,[["5(?:05(?:[2-57-9]\\d\\d|6(?:[0-35-9]\\d|44))|82(?:2(?:0[0-3]|[268]2)|3(?:0[02]|22|33)|4(?:00|4[24]|65|82)|5(?:00|29|58|83)|6(?:00|66|82)|7(?:58|77)|8(?:00|42|5[25]|88)|9(?:00|9[89])))\\d{4}|(?:2(?:0[1-35-9]|1[02-9]|2[03-589]|3[149]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-57-9]|1[02-9]|2[01356]|3[0-24679]|4[167]|5[12]|6[014]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[19]|6[1-47]|7[0-5]|8[056])|6(?:0[1-35-9]|1[024-9]|2[03689]|[34][016]|5[01679]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-7]|3[1247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[068]|3[0-289]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}"],[""],["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"],["900[2-9]\\d{6}"],["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-7]|33|44|66|77|88)[2-9]\\d{6}"]]],"UY":["598","0(?:0|1[3-9]\\d)","4\\d{9}|[1249]\\d{7}|(?:[49]\\d|80)\\d{5}",[7,8,10],[["(\\d{3})(\\d{4})","$1 $2",["405|8|90"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["9"],"0$1"],["(\\d{4})(\\d{4})","$1 $2",["[124]"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["4"],"0$1"]],"0",0,0,0,0,0,0,"00"," int. "],"UZ":["998","810","(?:33|55|[679]\\d|88)\\d{7}",[9],[["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[35-9]"],"8 $1"]],"8",0,0,0,0,0,0,"8~10"],"VA":["39","00","0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}",[6,7,8,9,10,11],0,0,0,0,0,0,"06698"],"VC":["1","011","(?:[58]\\d\\d|784|900)\\d{7}",[10],0,"1",0,"1|([2-7]\\d{6})$","784$1",0,"784"],"VE":["58","00","[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}",[10],[["(\\d{3})(\\d{7})","$1-$2",["[24-689]"],"0$1"]],"0"],"VG":["1","011","(?:284|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"1|([2-578]\\d{6})$","284$1",0,"284"],"VI":["1","011","[58]\\d{9}|(?:34|90)0\\d{7}",[10],0,"1",0,"1|([2-9]\\d{6})$","340$1",0,"340"],"VN":["84","00","[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}",[7,8,9,10],[["(\\d{2})(\\d{5})","$1 $2",["80"],"0$1",1],["(\\d{4})(\\d{4,6})","$1 $2",["1"],0,1],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[69]"],"0$1",1],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[3578]"],"0$1",1],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["2[48]"],"0$1",1],["(\\d{3})(\\d{4})(\\d{3})","$1 $2 $3",["2"],"0$1",1]],"0"],"VU":["678","00","[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}",[5,7],[["(\\d{3})(\\d{4})","$1 $2",["[57-9]"]]]],"WF":["681","00","(?:40|72)\\d{4}|8\\d{5}(?:\\d{3})?",[6,9],[["(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["[478]"]],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"]]]],"WS":["685","0","(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}",[5,6,7,10],[["(\\d{5})","$1",["[2-5]|6[1-9]"]],["(\\d{3})(\\d{3,7})","$1 $2",["[68]"]],["(\\d{2})(\\d{5})","$1 $2",["7"]]]],"XK":["383","00","[23]\\d{7,8}|(?:4\\d\\d|[89]00)\\d{5}",[8,9],[["(\\d{3})(\\d{5})","$1 $2",["[89]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[2-4]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[23]"],"0$1"]],"0"],"YE":["967","00","(?:1|7\\d)\\d{7}|[1-7]\\d{6}",[7,8,9],[["(\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["[1-6]|7[24-68]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["7"],"0$1"]],"0"],"YT":["262","00","80\\d{7}|(?:26|63)9\\d{6}",[9],0,"0",0,0,0,0,"269|63"],"ZA":["27","00","[1-79]\\d{8}|8\\d{4,9}",[5,6,7,8,9,10],[["(\\d{2})(\\d{3,4})","$1 $2",["8[1-4]"],"0$1"],["(\\d{2})(\\d{3})(\\d{2,3})","$1 $2 $3",["8[1-4]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["860"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[1-9]"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["8"],"0$1"]],"0"],"ZM":["260","00","800\\d{6}|(?:21|63|[79]\\d)\\d{7}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[28]"],"0$1"],["(\\d{2})(\\d{7})","$1 $2",["[79]"],"0$1"]],"0"],"ZW":["263","00","2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}",[5,6,7,8,9,10],[["(\\d{3})(\\d{3,5})","$1 $2",["2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"],"0$1"],["(\\d)(\\d{3})(\\d{2,4})","$1 $2 $3",["[49]"],"0$1"],["(\\d{3})(\\d{4})","$1 $2",["80"],"0$1"],["(\\d{2})(\\d{7})","$1 $2",["24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2","2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["7"],"0$1"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)","2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"],"0$1"],["(\\d{4})(\\d{6})","$1 $2",["8"],"0$1"],["(\\d{2})(\\d{3,5})","$1 $2",["1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["29[013-9]|39|54"],"0$1"],["(\\d{4})(\\d{3,5})","$1 $2",["(?:25|54)8","258|5483"],"0$1"]],"0"]},"nonGeographic":{"800":["800",0,"(?:00|[1-9]\\d)\\d{6}",[8],[["(\\d{4})(\\d{4})","$1 $2",["\\d"]]],0,0,0,0,0,0,[0,0,["(?:00|[1-9]\\d)\\d{6}"]]],"808":["808",0,"[1-9]\\d{7}",[8],[["(\\d{4})(\\d{4})","$1 $2",["[1-9]"]]],0,0,0,0,0,0,[0,0,0,0,0,0,0,0,0,["[1-9]\\d{7}"]]],"870":["870",0,"7\\d{11}|[35-7]\\d{8}",[9,12],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[35-7]"]]],0,0,0,0,0,0,[0,["(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}"]]],"878":["878",0,"10\\d{10}",[12],[["(\\d{2})(\\d{5})(\\d{5})","$1 $2 $3",["1"]]],0,0,0,0,0,0,[0,0,0,0,0,0,0,0,["10\\d{10}"]]],"881":["881",0,"[0-36-9]\\d{8}",[9],[["(\\d)(\\d{3})(\\d{5})","$1 $2 $3",["[0-36-9]"]]],0,0,0,0,0,0,[0,["[0-36-9]\\d{8}"]]],"882":["882",0,"[13]\\d{6}(?:\\d{2,5})?|285\\d{9}|(?:[19]\\d|49)\\d{6}",[7,8,9,10,11,12],[["(\\d{2})(\\d{5})","$1 $2",["16|342"]],["(\\d{2})(\\d{6})","$1 $2",["4"]],["(\\d{2})(\\d{2})(\\d{4})","$1 $2 $3",["[19]"]],["(\\d{2})(\\d{4})(\\d{3})","$1 $2 $3",["3[23]"]],["(\\d{2})(\\d{3,4})(\\d{4})","$1 $2 $3",["1"]],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["34[57]"]],["(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["34"]],["(\\d{2})(\\d{4,5})(\\d{5})","$1 $2 $3",["[1-3]"]]],0,0,0,0,0,0,[0,["342\\d{4}|(?:337|49)\\d{6}|3(?:2|47|7\\d{3})\\d{7}",[7,8,9,10,12]],0,0,0,0,0,0,["1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:(?:285\\d\\d|3(?:45|[69]\\d{3}))\\d|9[89])\\d{6}"]]],"883":["883",0,"(?:210|370\\d\\d)\\d{7}|51\\d{7}(?:\\d{3})?",[9,10,12],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["510"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["2"]],["(\\d{4})(\\d{4})(\\d{4})","$1 $2 $3",["51[13]"]],["(\\d{3})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["[35]"]]],0,0,0,0,0,0,[0,0,0,0,0,0,0,0,["(?:210|(?:370[1-9]|51[013]0)\\d)\\d{7}|5100\\d{5}"]]],"888":["888",0,"\\d{11}",[11],[["(\\d{3})(\\d{3})(\\d{5})","$1 $2 $3"]],0,0,0,0,0,0,[0,0,0,0,0,0,["\\d{11}"]]],"979":["979",0,"[1359]\\d{8}",[9],[["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["[1359]"]]],0,0,0,0,0,0,[0,0,0,["[1359]\\d{8}"]]]}};

	// Importing from a ".js" file is a workaround for Node.js "ES Modules"

	function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) { descriptor.writable = true; } Object.defineProperty(target, descriptor.key, descriptor); } }

	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) { _defineProperties(Constructor.prototype, protoProps); } if (staticProps) { _defineProperties(Constructor, staticProps); } Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) { _setPrototypeOf(subClass, superClass); } }

	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

	function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) { return Class; } if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) { return _cache.get(Class); } _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

	function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) { _setPrototypeOf(instance, Class.prototype); } return instance; }; } return _construct.apply(null, arguments); }

	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) { return false; } if (Reflect.construct.sham) { return false; } if (typeof Proxy === "function") { return true; } try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

	function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

	// https://stackoverflow.com/a/46971044/970769
	// "Breaking changes in Typescript 2.1"
	// "Extending built-ins like Error, Array, and Map may no longer work."
	// "As a recommendation, you can manually adjust the prototype immediately after any super(...) calls."
	// https://github.com/Microsoft/TypeScript-wiki/blob/main/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
	var ParseError = /*#__PURE__*/function (_Error) {
	  _inherits(ParseError, _Error);

	  var _super = _createSuper(ParseError);

	  function ParseError(code) {
	    var _this;

	    _classCallCheck(this, ParseError);

	    _this = _super.call(this, code); // Set the prototype explicitly.
	    // Any subclass of FooError will have to manually set the prototype as well.

	    Object.setPrototypeOf(_assertThisInitialized(_this), ParseError.prototype);
	    _this.name = _this.constructor.name;
	    return _this;
	  }

	  return _createClass(ParseError);
	}( /*#__PURE__*/_wrapNativeSuper(Error));

	// The minimum length of the national significant number.
	var MIN_LENGTH_FOR_NSN = 2; // The ITU says the maximum length should be 15,
	// but one can find longer numbers in Germany.

	var MAX_LENGTH_FOR_NSN = 17; // The maximum length of the country calling code.

	var MAX_LENGTH_COUNTRY_CODE = 3; // Digits accepted in phone numbers
	// (ascii, fullwidth, arabic-indic, and eastern arabic digits).

	var VALID_DIGITS = "0-9\uFF10-\uFF19\u0660-\u0669\u06F0-\u06F9"; // `DASHES` will be right after the opening square bracket of the "character class"

	var DASHES = "-\u2010-\u2015\u2212\u30FC\uFF0D";
	var SLASHES = "\uFF0F/";
	var DOTS = "\uFF0E.";
	var WHITESPACE = " \xA0\xAD\u200B\u2060\u3000";
	var BRACKETS = "()\uFF08\uFF09\uFF3B\uFF3D\\[\\]"; // export const OPENING_BRACKETS = '(\uFF08\uFF3B\\\['

	var TILDES = "~\u2053\u223C\uFF5E"; // Regular expression of acceptable punctuation found in phone numbers. This
	// excludes punctuation found as a leading character only. This consists of dash
	// characters, white space characters, full stops, slashes, square brackets,
	// parentheses and tildes. Full-width variants are also present.

	var VALID_PUNCTUATION = "".concat(DASHES).concat(SLASHES).concat(DOTS).concat(WHITESPACE).concat(BRACKETS).concat(TILDES);
	var PLUS_CHARS = "+\uFF0B"; // const LEADING_PLUS_CHARS_PATTERN = new RegExp('^[' + PLUS_CHARS + ']+')

	// Copy-pasted from:
	// https://github.com/substack/semver-compare/blob/master/index.js
	//
	// Inlining this function because some users reported issues with
	// importing from `semver-compare` in a browser with ES6 "native" modules.
	//
	// Fixes `semver-compare` not being able to compare versions with alpha/beta/etc "tags".
	// https://github.com/catamphetamine/libphonenumber-js/issues/381
	function compare (a, b) {
	  a = a.split('-');
	  b = b.split('-');
	  var pa = a[0].split('.');
	  var pb = b[0].split('.');

	  for (var i = 0; i < 3; i++) {
	    var na = Number(pa[i]);
	    var nb = Number(pb[i]);
	    if (na > nb) { return 1; }
	    if (nb > na) { return -1; }
	    if (!isNaN(na) && isNaN(nb)) { return 1; }
	    if (isNaN(na) && !isNaN(nb)) { return -1; }
	  }

	  if (a[1] && b[1]) {
	    return a[1] > b[1] ? 1 : a[1] < b[1] ? -1 : 0;
	  }

	  return !a[1] && b[1] ? 1 : a[1] && !b[1] ? -1 : 0;
	}

	function _typeof$1(obj) { "@babel/helpers - typeof"; return _typeof$1 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof$1(obj); }

	function _classCallCheck$1(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _defineProperties$1(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) { descriptor.writable = true; } Object.defineProperty(target, descriptor.key, descriptor); } }

	function _createClass$1(Constructor, protoProps, staticProps) { if (protoProps) { _defineProperties$1(Constructor.prototype, protoProps); } if (staticProps) { _defineProperties$1(Constructor, staticProps); } Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

	var V3 = '1.2.0'; // Moved `001` country code to "nonGeographic" section of metadata.

	var V4 = '1.7.35';
	var DEFAULT_EXT_PREFIX = ' ext. ';
	var CALLING_CODE_REG_EXP = /^\d+$/;
	/**
	 * See: https://gitlab.com/catamphetamine/libphonenumber-js/blob/master/METADATA.md
	 */

	var Metadata = /*#__PURE__*/function () {
	  function Metadata(metadata) {
	    _classCallCheck$1(this, Metadata);

	    validateMetadata(metadata);
	    this.metadata = metadata;
	    setVersion.call(this, metadata);
	  }

	  _createClass$1(Metadata, [{
	    key: "getCountries",
	    value: function getCountries() {
	      return Object.keys(this.metadata.countries).filter(function (_) {
	        return _ !== '001';
	      });
	    }
	  }, {
	    key: "getCountryMetadata",
	    value: function getCountryMetadata(countryCode) {
	      return this.metadata.countries[countryCode];
	    }
	  }, {
	    key: "nonGeographic",
	    value: function nonGeographic() {
	      if (this.v1 || this.v2 || this.v3) { return; } // `nonGeographical` was a typo.
	      // It's present in metadata generated from `1.7.35` to `1.7.37`.
	      // The test case could be found by searching for "nonGeographical".

	      return this.metadata.nonGeographic || this.metadata.nonGeographical;
	    }
	  }, {
	    key: "hasCountry",
	    value: function hasCountry(country) {
	      return this.getCountryMetadata(country) !== undefined;
	    }
	  }, {
	    key: "hasCallingCode",
	    value: function hasCallingCode(callingCode) {
	      if (this.getCountryCodesForCallingCode(callingCode)) {
	        return true;
	      }

	      if (this.nonGeographic()) {
	        if (this.nonGeographic()[callingCode]) {
	          return true;
	        }
	      } else {
	        // A hacky workaround for old custom metadata (generated before V4).
	        var countryCodes = this.countryCallingCodes()[callingCode];

	        if (countryCodes && countryCodes.length === 1 && countryCodes[0] === '001') {
	          return true;
	        }
	      }
	    }
	  }, {
	    key: "isNonGeographicCallingCode",
	    value: function isNonGeographicCallingCode(callingCode) {
	      if (this.nonGeographic()) {
	        return this.nonGeographic()[callingCode] ? true : false;
	      } else {
	        return this.getCountryCodesForCallingCode(callingCode) ? false : true;
	      }
	    } // Deprecated.

	  }, {
	    key: "country",
	    value: function country(countryCode) {
	      return this.selectNumberingPlan(countryCode);
	    }
	  }, {
	    key: "selectNumberingPlan",
	    value: function selectNumberingPlan(countryCode, callingCode) {
	      // Supports just passing `callingCode` as the first argument.
	      if (countryCode && CALLING_CODE_REG_EXP.test(countryCode)) {
	        callingCode = countryCode;
	        countryCode = null;
	      }

	      if (countryCode && countryCode !== '001') {
	        if (!this.hasCountry(countryCode)) {
	          throw new Error("Unknown country: ".concat(countryCode));
	        }

	        this.numberingPlan = new NumberingPlan(this.getCountryMetadata(countryCode), this);
	      } else if (callingCode) {
	        if (!this.hasCallingCode(callingCode)) {
	          throw new Error("Unknown calling code: ".concat(callingCode));
	        }

	        this.numberingPlan = new NumberingPlan(this.getNumberingPlanMetadata(callingCode), this);
	      } else {
	        this.numberingPlan = undefined;
	      }

	      return this;
	    }
	  }, {
	    key: "getCountryCodesForCallingCode",
	    value: function getCountryCodesForCallingCode(callingCode) {
	      var countryCodes = this.countryCallingCodes()[callingCode];

	      if (countryCodes) {
	        // Metadata before V4 included "non-geographic entity" calling codes
	        // inside `country_calling_codes` (for example, `"881":["001"]`).
	        // Now the semantics of `country_calling_codes` has changed:
	        // it's specifically for "countries" now.
	        // Older versions of custom metadata will simply skip parsing
	        // "non-geographic entity" phone numbers with new versions
	        // of this library: it's not considered a bug,
	        // because such numbers are extremely rare,
	        // and developers extremely rarely use custom metadata.
	        if (countryCodes.length === 1 && countryCodes[0].length === 3) {
	          return;
	        }

	        return countryCodes;
	      }
	    }
	  }, {
	    key: "getCountryCodeForCallingCode",
	    value: function getCountryCodeForCallingCode(callingCode) {
	      var countryCodes = this.getCountryCodesForCallingCode(callingCode);

	      if (countryCodes) {
	        return countryCodes[0];
	      }
	    }
	  }, {
	    key: "getNumberingPlanMetadata",
	    value: function getNumberingPlanMetadata(callingCode) {
	      var countryCode = this.getCountryCodeForCallingCode(callingCode);

	      if (countryCode) {
	        return this.getCountryMetadata(countryCode);
	      }

	      if (this.nonGeographic()) {
	        var metadata = this.nonGeographic()[callingCode];

	        if (metadata) {
	          return metadata;
	        }
	      } else {
	        // A hacky workaround for old custom metadata (generated before V4).
	        // In that metadata, there was no concept of "non-geographic" metadata
	        // so metadata for `001` country code was stored along with other countries.
	        // The test case can be found by searching for:
	        // "should work around `nonGeographic` metadata not existing".
	        var countryCodes = this.countryCallingCodes()[callingCode];

	        if (countryCodes && countryCodes.length === 1 && countryCodes[0] === '001') {
	          return this.metadata.countries['001'];
	        }
	      }
	    } // Deprecated.

	  }, {
	    key: "countryCallingCode",
	    value: function countryCallingCode() {
	      return this.numberingPlan.callingCode();
	    } // Deprecated.

	  }, {
	    key: "IDDPrefix",
	    value: function IDDPrefix() {
	      return this.numberingPlan.IDDPrefix();
	    } // Deprecated.

	  }, {
	    key: "defaultIDDPrefix",
	    value: function defaultIDDPrefix() {
	      return this.numberingPlan.defaultIDDPrefix();
	    } // Deprecated.

	  }, {
	    key: "nationalNumberPattern",
	    value: function nationalNumberPattern() {
	      return this.numberingPlan.nationalNumberPattern();
	    } // Deprecated.

	  }, {
	    key: "possibleLengths",
	    value: function possibleLengths() {
	      return this.numberingPlan.possibleLengths();
	    } // Deprecated.

	  }, {
	    key: "formats",
	    value: function formats() {
	      return this.numberingPlan.formats();
	    } // Deprecated.

	  }, {
	    key: "nationalPrefixForParsing",
	    value: function nationalPrefixForParsing() {
	      return this.numberingPlan.nationalPrefixForParsing();
	    } // Deprecated.

	  }, {
	    key: "nationalPrefixTransformRule",
	    value: function nationalPrefixTransformRule() {
	      return this.numberingPlan.nationalPrefixTransformRule();
	    } // Deprecated.

	  }, {
	    key: "leadingDigits",
	    value: function leadingDigits() {
	      return this.numberingPlan.leadingDigits();
	    } // Deprecated.

	  }, {
	    key: "hasTypes",
	    value: function hasTypes() {
	      return this.numberingPlan.hasTypes();
	    } // Deprecated.

	  }, {
	    key: "type",
	    value: function type(_type) {
	      return this.numberingPlan.type(_type);
	    } // Deprecated.

	  }, {
	    key: "ext",
	    value: function ext() {
	      return this.numberingPlan.ext();
	    }
	  }, {
	    key: "countryCallingCodes",
	    value: function countryCallingCodes() {
	      if (this.v1) { return this.metadata.country_phone_code_to_countries; }
	      return this.metadata.country_calling_codes;
	    } // Deprecated.

	  }, {
	    key: "chooseCountryByCountryCallingCode",
	    value: function chooseCountryByCountryCallingCode(callingCode) {
	      return this.selectNumberingPlan(callingCode);
	    }
	  }, {
	    key: "hasSelectedNumberingPlan",
	    value: function hasSelectedNumberingPlan() {
	      return this.numberingPlan !== undefined;
	    }
	  }]);

	  return Metadata;
	}();

	var NumberingPlan = /*#__PURE__*/function () {
	  function NumberingPlan(metadata, globalMetadataObject) {
	    _classCallCheck$1(this, NumberingPlan);

	    this.globalMetadataObject = globalMetadataObject;
	    this.metadata = metadata;
	    setVersion.call(this, globalMetadataObject.metadata);
	  }

	  _createClass$1(NumberingPlan, [{
	    key: "callingCode",
	    value: function callingCode() {
	      return this.metadata[0];
	    } // Formatting information for regions which share
	    // a country calling code is contained by only one region
	    // for performance reasons. For example, for NANPA region
	    // ("North American Numbering Plan Administration",
	    //  which includes USA, Canada, Cayman Islands, Bahamas, etc)
	    // it will be contained in the metadata for `US`.

	  }, {
	    key: "getDefaultCountryMetadataForRegion",
	    value: function getDefaultCountryMetadataForRegion() {
	      return this.globalMetadataObject.getNumberingPlanMetadata(this.callingCode());
	    } // Is always present.

	  }, {
	    key: "IDDPrefix",
	    value: function IDDPrefix() {
	      if (this.v1 || this.v2) { return; }
	      return this.metadata[1];
	    } // Is only present when a country supports multiple IDD prefixes.

	  }, {
	    key: "defaultIDDPrefix",
	    value: function defaultIDDPrefix() {
	      if (this.v1 || this.v2) { return; }
	      return this.metadata[12];
	    }
	  }, {
	    key: "nationalNumberPattern",
	    value: function nationalNumberPattern() {
	      if (this.v1 || this.v2) { return this.metadata[1]; }
	      return this.metadata[2];
	    } // "possible length" data is always present in Google's metadata.

	  }, {
	    key: "possibleLengths",
	    value: function possibleLengths() {
	      if (this.v1) { return; }
	      return this.metadata[this.v2 ? 2 : 3];
	    }
	  }, {
	    key: "_getFormats",
	    value: function _getFormats(metadata) {
	      return metadata[this.v1 ? 2 : this.v2 ? 3 : 4];
	    } // For countries of the same region (e.g. NANPA)
	    // formats are all stored in the "main" country for that region.
	    // E.g. "RU" and "KZ", "US" and "CA".

	  }, {
	    key: "formats",
	    value: function formats() {
	      var _this = this;

	      var formats = this._getFormats(this.metadata) || this._getFormats(this.getDefaultCountryMetadataForRegion()) || [];
	      return formats.map(function (_) {
	        return new Format(_, _this);
	      });
	    }
	  }, {
	    key: "nationalPrefix",
	    value: function nationalPrefix() {
	      return this.metadata[this.v1 ? 3 : this.v2 ? 4 : 5];
	    }
	  }, {
	    key: "_getNationalPrefixFormattingRule",
	    value: function _getNationalPrefixFormattingRule(metadata) {
	      return metadata[this.v1 ? 4 : this.v2 ? 5 : 6];
	    } // For countries of the same region (e.g. NANPA)
	    // national prefix formatting rule is stored in the "main" country for that region.
	    // E.g. "RU" and "KZ", "US" and "CA".

	  }, {
	    key: "nationalPrefixFormattingRule",
	    value: function nationalPrefixFormattingRule() {
	      return this._getNationalPrefixFormattingRule(this.metadata) || this._getNationalPrefixFormattingRule(this.getDefaultCountryMetadataForRegion());
	    }
	  }, {
	    key: "_nationalPrefixForParsing",
	    value: function _nationalPrefixForParsing() {
	      return this.metadata[this.v1 ? 5 : this.v2 ? 6 : 7];
	    }
	  }, {
	    key: "nationalPrefixForParsing",
	    value: function nationalPrefixForParsing() {
	      // If `national_prefix_for_parsing` is not set explicitly,
	      // then infer it from `national_prefix` (if any)
	      return this._nationalPrefixForParsing() || this.nationalPrefix();
	    }
	  }, {
	    key: "nationalPrefixTransformRule",
	    value: function nationalPrefixTransformRule() {
	      return this.metadata[this.v1 ? 6 : this.v2 ? 7 : 8];
	    }
	  }, {
	    key: "_getNationalPrefixIsOptionalWhenFormatting",
	    value: function _getNationalPrefixIsOptionalWhenFormatting() {
	      return !!this.metadata[this.v1 ? 7 : this.v2 ? 8 : 9];
	    } // For countries of the same region (e.g. NANPA)
	    // "national prefix is optional when formatting" flag is
	    // stored in the "main" country for that region.
	    // E.g. "RU" and "KZ", "US" and "CA".

	  }, {
	    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
	    value: function nationalPrefixIsOptionalWhenFormattingInNationalFormat() {
	      return this._getNationalPrefixIsOptionalWhenFormatting(this.metadata) || this._getNationalPrefixIsOptionalWhenFormatting(this.getDefaultCountryMetadataForRegion());
	    }
	  }, {
	    key: "leadingDigits",
	    value: function leadingDigits() {
	      return this.metadata[this.v1 ? 8 : this.v2 ? 9 : 10];
	    }
	  }, {
	    key: "types",
	    value: function types() {
	      return this.metadata[this.v1 ? 9 : this.v2 ? 10 : 11];
	    }
	  }, {
	    key: "hasTypes",
	    value: function hasTypes() {
	      // Versions 1.2.0 - 1.2.4: can be `[]`.

	      /* istanbul ignore next */
	      if (this.types() && this.types().length === 0) {
	        return false;
	      } // Versions <= 1.2.4: can be `undefined`.
	      // Version >= 1.2.5: can be `0`.


	      return !!this.types();
	    }
	  }, {
	    key: "type",
	    value: function type(_type2) {
	      if (this.hasTypes() && getType$1(this.types(), _type2)) {
	        return new Type(getType$1(this.types(), _type2), this);
	      }
	    }
	  }, {
	    key: "ext",
	    value: function ext() {
	      if (this.v1 || this.v2) { return DEFAULT_EXT_PREFIX; }
	      return this.metadata[13] || DEFAULT_EXT_PREFIX;
	    }
	  }]);

	  return NumberingPlan;
	}();

	var Format = /*#__PURE__*/function () {
	  function Format(format, metadata) {
	    _classCallCheck$1(this, Format);

	    this._format = format;
	    this.metadata = metadata;
	  }

	  _createClass$1(Format, [{
	    key: "pattern",
	    value: function pattern() {
	      return this._format[0];
	    }
	  }, {
	    key: "format",
	    value: function format() {
	      return this._format[1];
	    }
	  }, {
	    key: "leadingDigitsPatterns",
	    value: function leadingDigitsPatterns() {
	      return this._format[2] || [];
	    }
	  }, {
	    key: "nationalPrefixFormattingRule",
	    value: function nationalPrefixFormattingRule() {
	      return this._format[3] || this.metadata.nationalPrefixFormattingRule();
	    }
	  }, {
	    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
	    value: function nationalPrefixIsOptionalWhenFormattingInNationalFormat() {
	      return !!this._format[4] || this.metadata.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
	    }
	  }, {
	    key: "nationalPrefixIsMandatoryWhenFormattingInNationalFormat",
	    value: function nationalPrefixIsMandatoryWhenFormattingInNationalFormat() {
	      // National prefix is omitted if there's no national prefix formatting rule
	      // set for this country, or when the national prefix formatting rule
	      // contains no national prefix itself, or when this rule is set but
	      // national prefix is optional for this phone number format
	      // (and it is not enforced explicitly)
	      return this.usesNationalPrefix() && !this.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
	    } // Checks whether national prefix formatting rule contains national prefix.

	  }, {
	    key: "usesNationalPrefix",
	    value: function usesNationalPrefix() {
	      return this.nationalPrefixFormattingRule() && // Check that national prefix formatting rule is not a "dummy" one.
	      !FIRST_GROUP_ONLY_PREFIX_PATTERN.test(this.nationalPrefixFormattingRule()) // In compressed metadata, `this.nationalPrefixFormattingRule()` is `0`
	      // when `national_prefix_formatting_rule` is not present.
	      // So, `true` or `false` are returned explicitly here, so that
	      // `0` number isn't returned.
	      ? true : false;
	    }
	  }, {
	    key: "internationalFormat",
	    value: function internationalFormat() {
	      return this._format[5] || this.format();
	    }
	  }]);

	  return Format;
	}();
	/**
	 * A pattern that is used to determine if the national prefix formatting rule
	 * has the first group only, i.e., does not start with the national prefix.
	 * Note that the pattern explicitly allows for unbalanced parentheses.
	 */


	var FIRST_GROUP_ONLY_PREFIX_PATTERN = /^\(?\$1\)?$/;

	var Type = /*#__PURE__*/function () {
	  function Type(type, metadata) {
	    _classCallCheck$1(this, Type);

	    this.type = type;
	    this.metadata = metadata;
	  }

	  _createClass$1(Type, [{
	    key: "pattern",
	    value: function pattern() {
	      if (this.metadata.v1) { return this.type; }
	      return this.type[0];
	    }
	  }, {
	    key: "possibleLengths",
	    value: function possibleLengths() {
	      if (this.metadata.v1) { return; }
	      return this.type[1] || this.metadata.possibleLengths();
	    }
	  }]);

	  return Type;
	}();

	function getType$1(types, type) {
	  switch (type) {
	    case 'FIXED_LINE':
	      return types[0];

	    case 'MOBILE':
	      return types[1];

	    case 'TOLL_FREE':
	      return types[2];

	    case 'PREMIUM_RATE':
	      return types[3];

	    case 'PERSONAL_NUMBER':
	      return types[4];

	    case 'VOICEMAIL':
	      return types[5];

	    case 'UAN':
	      return types[6];

	    case 'PAGER':
	      return types[7];

	    case 'VOIP':
	      return types[8];

	    case 'SHARED_COST':
	      return types[9];
	  }
	}

	function validateMetadata(metadata) {
	  if (!metadata) {
	    throw new Error('[libphonenumber-js] `metadata` argument not passed. Check your arguments.');
	  } // `country_phone_code_to_countries` was renamed to
	  // `country_calling_codes` in `1.0.18`.


	  if (!is_object(metadata) || !is_object(metadata.countries)) {
	    throw new Error("[libphonenumber-js] `metadata` argument was passed but it's not a valid metadata. Must be an object having `.countries` child object property. Got ".concat(is_object(metadata) ? 'an object of shape: { ' + Object.keys(metadata).join(', ') + ' }' : 'a ' + type_of(metadata) + ': ' + metadata, "."));
	  }
	} // Babel transforms `typeof` into some "branches"
	// so istanbul will show this as "branch not covered".

	/* istanbul ignore next */

	var is_object = function is_object(_) {
	  return _typeof$1(_) === 'object';
	}; // Babel transforms `typeof` into some "branches"
	// so istanbul will show this as "branch not covered".

	/* istanbul ignore next */


	var type_of = function type_of(_) {
	  return _typeof$1(_);
	};
	/**
	 * Returns "country calling code" for a country.
	 * Throws an error if the country doesn't exist or isn't supported by this library.
	 * @param  {string} country
	 * @param  {object} metadata
	 * @return {string}
	 * @example
	 * // Returns "44"
	 * getCountryCallingCode("GB")
	 */

	function getCountryCallingCode(country, metadata) {
	  metadata = new Metadata(metadata);

	  if (metadata.hasCountry(country)) {
	    return metadata.country(country).countryCallingCode();
	  }

	  throw new Error("Unknown country: ".concat(country));
	}
	function isSupportedCountry(country, metadata) {
	  // metadata = new Metadata(metadata)
	  // return metadata.hasCountry(country)
	  return metadata.countries[country] !== undefined;
	}

	function setVersion(metadata) {
	  var version = metadata.version;

	  if (typeof version === 'number') {
	    this.v1 = version === 1;
	    this.v2 = version === 2;
	    this.v3 = version === 3;
	    this.v4 = version === 4;
	  } else {
	    if (!version) {
	      this.v1 = true;
	    } else if (compare(version, V3) === -1) {
	      this.v2 = true;
	    } else if (compare(version, V4) === -1) {
	      this.v3 = true;
	    } else {
	      this.v4 = true;
	    }
	  }
	} // const ISO_COUNTRY_CODE = /^[A-Z]{2}$/
	// function isCountryCode(countryCode) {
	// 	return ISO_COUNTRY_CODE.test(countryCodeOrCountryCallingCode)
	// }

	var RFC3966_EXTN_PREFIX = ';ext=';
	/**
	 * Helper method for constructing regular expressions for parsing. Creates
	 * an expression that captures up to max_length digits.
	 * @return {string} RegEx pattern to capture extension digits.
	 */

	var getExtensionDigitsPattern = function getExtensionDigitsPattern(maxLength) {
	  return "([".concat(VALID_DIGITS, "]{1,").concat(maxLength, "})");
	};
	/**
	 * Helper initialiser method to create the regular-expression pattern to match
	 * extensions.
	 * Copy-pasted from Google's `libphonenumber`:
	 * https://github.com/google/libphonenumber/blob/55b2646ec9393f4d3d6661b9c82ef9e258e8b829/javascript/i18n/phonenumbers/phonenumberutil.js#L759-L766
	 * @return {string} RegEx pattern to capture extensions.
	 */


	function createExtensionPattern(purpose) {
	  // We cap the maximum length of an extension based on the ambiguity of the way
	  // the extension is prefixed. As per ITU, the officially allowed length for
	  // extensions is actually 40, but we don't support this since we haven't seen real
	  // examples and this introduces many false interpretations as the extension labels
	  // are not standardized.

	  /** @type {string} */
	  var extLimitAfterExplicitLabel = '20';
	  /** @type {string} */

	  var extLimitAfterLikelyLabel = '15';
	  /** @type {string} */

	  var extLimitAfterAmbiguousChar = '9';
	  /** @type {string} */

	  var extLimitWhenNotSure = '6';
	  /** @type {string} */

	  var possibleSeparatorsBetweenNumberAndExtLabel = "[ \xA0\\t,]*"; // Optional full stop (.) or colon, followed by zero or more spaces/tabs/commas.

	  /** @type {string} */

	  var possibleCharsAfterExtLabel = "[:\\.\uFF0E]?[ \xA0\\t,-]*";
	  /** @type {string} */

	  var optionalExtnSuffix = "#?"; // Here the extension is called out in more explicit way, i.e mentioning it obvious
	  // patterns like "ext.".

	  /** @type {string} */

	  var explicitExtLabels = "(?:e?xt(?:ensi(?:o\u0301?|\xF3))?n?|\uFF45?\uFF58\uFF54\uFF4E?|\u0434\u043E\u0431|anexo)"; // One-character symbols that can be used to indicate an extension, and less
	  // commonly used or more ambiguous extension labels.

	  /** @type {string} */

	  var ambiguousExtLabels = "(?:[x\uFF58#\uFF03~\uFF5E]|int|\uFF49\uFF4E\uFF54)"; // When extension is not separated clearly.

	  /** @type {string} */

	  var ambiguousSeparator = "[- ]+"; // This is the same as possibleSeparatorsBetweenNumberAndExtLabel, but not matching
	  // comma as extension label may have it.

	  /** @type {string} */

	  var possibleSeparatorsNumberExtLabelNoComma = "[ \xA0\\t]*"; // ",," is commonly used for auto dialling the extension when connected. First
	  // comma is matched through possibleSeparatorsBetweenNumberAndExtLabel, so we do
	  // not repeat it here. Semi-colon works in Iphone and Android also to pop up a
	  // button with the extension number following.

	  /** @type {string} */

	  var autoDiallingAndExtLabelsFound = "(?:,{2}|;)";
	  /** @type {string} */

	  var rfcExtn = RFC3966_EXTN_PREFIX + getExtensionDigitsPattern(extLimitAfterExplicitLabel);
	  /** @type {string} */

	  var explicitExtn = possibleSeparatorsBetweenNumberAndExtLabel + explicitExtLabels + possibleCharsAfterExtLabel + getExtensionDigitsPattern(extLimitAfterExplicitLabel) + optionalExtnSuffix;
	  /** @type {string} */

	  var ambiguousExtn = possibleSeparatorsBetweenNumberAndExtLabel + ambiguousExtLabels + possibleCharsAfterExtLabel + getExtensionDigitsPattern(extLimitAfterAmbiguousChar) + optionalExtnSuffix;
	  /** @type {string} */

	  var americanStyleExtnWithSuffix = ambiguousSeparator + getExtensionDigitsPattern(extLimitWhenNotSure) + "#";
	  /** @type {string} */

	  var autoDiallingExtn = possibleSeparatorsNumberExtLabelNoComma + autoDiallingAndExtLabelsFound + possibleCharsAfterExtLabel + getExtensionDigitsPattern(extLimitAfterLikelyLabel) + optionalExtnSuffix;
	  /** @type {string} */

	  var onlyCommasExtn = possibleSeparatorsNumberExtLabelNoComma + "(?:,)+" + possibleCharsAfterExtLabel + getExtensionDigitsPattern(extLimitAfterAmbiguousChar) + optionalExtnSuffix; // The first regular expression covers RFC 3966 format, where the extension is added
	  // using ";ext=". The second more generic where extension is mentioned with explicit
	  // labels like "ext:". In both the above cases we allow more numbers in extension than
	  // any other extension labels. The third one captures when single character extension
	  // labels or less commonly used labels are used. In such cases we capture fewer
	  // extension digits in order to reduce the chance of falsely interpreting two
	  // numbers beside each other as a number + extension. The fourth one covers the
	  // special case of American numbers where the extension is written with a hash
	  // at the end, such as "- 503#". The fifth one is exclusively for extension
	  // autodialling formats which are used when dialling and in this case we accept longer
	  // extensions. The last one is more liberal on the number of commas that acts as
	  // extension labels, so we have a strict cap on the number of digits in such extensions.

	  return rfcExtn + "|" + explicitExtn + "|" + ambiguousExtn + "|" + americanStyleExtnWithSuffix + "|" + autoDiallingExtn + "|" + onlyCommasExtn;
	}

	//  Checks we have at least three leading digits, and only valid punctuation,
	//  alpha characters and digits in the phone number. Does not include extension
	//  data. The symbol 'x' is allowed here as valid punctuation since it is often
	//  used as a placeholder for carrier codes, for example in Brazilian phone
	//  numbers. We also allow multiple '+' characters at the start.
	//
	//  Corresponds to the following:
	//  [digits]{minLengthNsn}|
	//  plus_sign*
	//  (([punctuation]|[star])*[digits]){3,}([punctuation]|[star]|[digits]|[alpha])*
	//
	//  The first reg-ex is to allow short numbers (two digits long) to be parsed if
	//  they are entered as "15" etc, but only if there is no punctuation in them.
	//  The second expression restricts the number of digits to three or more, but
	//  then allows them to be in international form, and to have alpha-characters
	//  and punctuation. We split up the two reg-exes here and combine them when
	//  creating the reg-ex VALID_PHONE_NUMBER_PATTERN itself so we can prefix it
	//  with ^ and append $ to each branch.
	//
	//  "Note VALID_PUNCTUATION starts with a -,
	//   so must be the first in the range" (c) Google devs.
	//  (wtf did they mean by saying that; probably nothing)
	//

	var MIN_LENGTH_PHONE_NUMBER_PATTERN = '[' + VALID_DIGITS + ']{' + MIN_LENGTH_FOR_NSN + '}'; //
	// And this is the second reg-exp:
	// (see MIN_LENGTH_PHONE_NUMBER_PATTERN for a full description of this reg-exp)
	//

	var VALID_PHONE_NUMBER = '[' + PLUS_CHARS + ']{0,1}' + '(?:' + '[' + VALID_PUNCTUATION + ']*' + '[' + VALID_DIGITS + ']' + '){3,}' + '[' + VALID_PUNCTUATION + VALID_DIGITS + ']*'; // This regular expression isn't present in Google's `libphonenumber`
	// and is only used to determine whether the phone number being input
	// is too short for it to even consider it a "valid" number.
	// This is just a way to differentiate between a really invalid phone
	// number like "abcde" and a valid phone number that a user has just
	// started inputting, like "+1" or "1": both these cases would be
	// considered `NOT_A_NUMBER` by Google's `libphonenumber`, but this
	// library can provide a more detailed error message — whether it's
	// really "not a number", or is it just a start of a valid phone number.

	var VALID_PHONE_NUMBER_START_REG_EXP = new RegExp('^' + '[' + PLUS_CHARS + ']{0,1}' + '(?:' + '[' + VALID_PUNCTUATION + ']*' + '[' + VALID_DIGITS + ']' + '){1,2}' + '$', 'i');
	var VALID_PHONE_NUMBER_WITH_EXTENSION = VALID_PHONE_NUMBER + // Phone number extensions
	'(?:' + createExtensionPattern() + ')?'; // The combined regular expression for valid phone numbers:
	//

	var VALID_PHONE_NUMBER_PATTERN = new RegExp( // Either a short two-digit-only phone number
	'^' + MIN_LENGTH_PHONE_NUMBER_PATTERN + '$' + '|' + // Or a longer fully parsed phone number (min 3 characters)
	'^' + VALID_PHONE_NUMBER_WITH_EXTENSION + '$', 'i'); // Checks to see if the string of characters could possibly be a phone number at
	// all. At the moment, checks to see that the string begins with at least 2
	// digits, ignoring any punctuation commonly found in phone numbers. This method
	// does not require the number to be normalized in advance - but does assume
	// that leading non-number symbols have been removed, such as by the method
	// `extract_possible_number`.
	//

	function isViablePhoneNumber(number) {
	  return number.length >= MIN_LENGTH_FOR_NSN && VALID_PHONE_NUMBER_PATTERN.test(number);
	} // This is just a way to differentiate between a really invalid phone
	// number like "abcde" and a valid phone number that a user has just
	// started inputting, like "+1" or "1": both these cases would be
	// considered `NOT_A_NUMBER` by Google's `libphonenumber`, but this
	// library can provide a more detailed error message — whether it's
	// really "not a number", or is it just a start of a valid phone number.

	function isViablePhoneNumberStart(number) {
	  return VALID_PHONE_NUMBER_START_REG_EXP.test(number);
	}

	// 1 or more valid digits, for use when parsing.

	var EXTN_PATTERN = new RegExp('(?:' + createExtensionPattern() + ')$', 'i'); // Strips any extension (as in, the part of the number dialled after the call is
	// connected, usually indicated with extn, ext, x or similar) from the end of
	// the number, and returns it.

	function extractExtension(number) {
	  var start = number.search(EXTN_PATTERN);

	  if (start < 0) {
	    return {};
	  } // If we find a potential extension, and the number preceding this is a viable
	  // number, we assume it is an extension.


	  var numberWithoutExtension = number.slice(0, start);
	  var matches = number.match(EXTN_PATTERN);
	  var i = 1;

	  while (i < matches.length) {
	    if (matches[i]) {
	      return {
	        number: numberWithoutExtension,
	        ext: matches[i]
	      };
	    }

	    i++;
	  }
	}

	function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) { return (it = it.call(o)).next.bind(it); } if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) { o = it; } var i = 0; return function () { if (i >= o.length) { return { done: true }; } return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

	function _unsupportedIterableToArray(o, minLen) { if (!o) { return; } if (typeof o === "string") { return _arrayLikeToArray(o, minLen); } var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) { n = o.constructor.name; } if (n === "Map" || n === "Set") { return Array.from(o); } if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) { return _arrayLikeToArray(o, minLen); } }

	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) { len = arr.length; } for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

	// These mappings map a character (key) to a specific digit that should
	// replace it for normalization purposes. Non-European digits that
	// may be used in phone numbers are mapped to a European equivalent.
	//
	// E.g. in Iraq they don't write `+442323234` but rather `+٤٤٢٣٢٣٢٣٤`.
	//
	var DIGITS = {
	  '0': '0',
	  '1': '1',
	  '2': '2',
	  '3': '3',
	  '4': '4',
	  '5': '5',
	  '6': '6',
	  '7': '7',
	  '8': '8',
	  '9': '9',
	  "\uFF10": '0',
	  // Fullwidth digit 0
	  "\uFF11": '1',
	  // Fullwidth digit 1
	  "\uFF12": '2',
	  // Fullwidth digit 2
	  "\uFF13": '3',
	  // Fullwidth digit 3
	  "\uFF14": '4',
	  // Fullwidth digit 4
	  "\uFF15": '5',
	  // Fullwidth digit 5
	  "\uFF16": '6',
	  // Fullwidth digit 6
	  "\uFF17": '7',
	  // Fullwidth digit 7
	  "\uFF18": '8',
	  // Fullwidth digit 8
	  "\uFF19": '9',
	  // Fullwidth digit 9
	  "\u0660": '0',
	  // Arabic-indic digit 0
	  "\u0661": '1',
	  // Arabic-indic digit 1
	  "\u0662": '2',
	  // Arabic-indic digit 2
	  "\u0663": '3',
	  // Arabic-indic digit 3
	  "\u0664": '4',
	  // Arabic-indic digit 4
	  "\u0665": '5',
	  // Arabic-indic digit 5
	  "\u0666": '6',
	  // Arabic-indic digit 6
	  "\u0667": '7',
	  // Arabic-indic digit 7
	  "\u0668": '8',
	  // Arabic-indic digit 8
	  "\u0669": '9',
	  // Arabic-indic digit 9
	  "\u06F0": '0',
	  // Eastern-Arabic digit 0
	  "\u06F1": '1',
	  // Eastern-Arabic digit 1
	  "\u06F2": '2',
	  // Eastern-Arabic digit 2
	  "\u06F3": '3',
	  // Eastern-Arabic digit 3
	  "\u06F4": '4',
	  // Eastern-Arabic digit 4
	  "\u06F5": '5',
	  // Eastern-Arabic digit 5
	  "\u06F6": '6',
	  // Eastern-Arabic digit 6
	  "\u06F7": '7',
	  // Eastern-Arabic digit 7
	  "\u06F8": '8',
	  // Eastern-Arabic digit 8
	  "\u06F9": '9' // Eastern-Arabic digit 9

	};
	function parseDigit(character) {
	  return DIGITS[character];
	}
	/**
	 * Parses phone number digits from a string.
	 * Drops all punctuation leaving only digits.
	 * Also converts wide-ascii and arabic-indic numerals to conventional numerals.
	 * E.g. in Iraq they don't write `+442323234` but rather `+٤٤٢٣٢٣٢٣٤`.
	 * @param  {string} string
	 * @return {string}
	 * @example
	 * ```js
	 * parseDigits('8 (800) 555')
	 * // Outputs '8800555'.
	 * ```
	 */

	function parseDigits(string) {
	  var result = ''; // Using `.split('')` here instead of normal `for ... of`
	  // because the importing application doesn't neccessarily include an ES6 polyfill.
	  // The `.split('')` approach discards "exotic" UTF-8 characters
	  // (the ones consisting of four bytes) but digits
	  // (including non-European ones) don't fall into that range
	  // so such "exotic" characters would be discarded anyway.

	  for (var _iterator = _createForOfIteratorHelperLoose(string.split('')), _step; !(_step = _iterator()).done;) {
	    var character = _step.value;
	    var digit = parseDigit(character);

	    if (digit) {
	      result += digit;
	    }
	  }

	  return result;
	}

	function _createForOfIteratorHelperLoose$1(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) { return (it = it.call(o)).next.bind(it); } if (Array.isArray(o) || (it = _unsupportedIterableToArray$1(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) { o = it; } var i = 0; return function () { if (i >= o.length) { return { done: true }; } return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

	function _unsupportedIterableToArray$1(o, minLen) { if (!o) { return; } if (typeof o === "string") { return _arrayLikeToArray$1(o, minLen); } var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) { n = o.constructor.name; } if (n === "Map" || n === "Set") { return Array.from(o); } if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) { return _arrayLikeToArray$1(o, minLen); } }

	function _arrayLikeToArray$1(arr, len) { if (len == null || len > arr.length) { len = arr.length; } for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	/**
	 * Parses phone number characters from a string.
	 * Drops all punctuation leaving only digits and the leading `+` sign (if any).
	 * Also converts wide-ascii and arabic-indic numerals to conventional numerals.
	 * E.g. in Iraq they don't write `+442323234` but rather `+٤٤٢٣٢٣٢٣٤`.
	 * @param  {string} string
	 * @return {string}
	 * @example
	 * ```js
	 * // Outputs '8800555'.
	 * parseIncompletePhoneNumber('8 (800) 555')
	 * // Outputs '+7800555'.
	 * parseIncompletePhoneNumber('+7 800 555')
	 * ```
	 */

	function parseIncompletePhoneNumber(string) {
	  var result = ''; // Using `.split('')` here instead of normal `for ... of`
	  // because the importing application doesn't neccessarily include an ES6 polyfill.
	  // The `.split('')` approach discards "exotic" UTF-8 characters
	  // (the ones consisting of four bytes) but digits
	  // (including non-European ones) don't fall into that range
	  // so such "exotic" characters would be discarded anyway.

	  for (var _iterator = _createForOfIteratorHelperLoose$1(string.split('')), _step; !(_step = _iterator()).done;) {
	    var character = _step.value;
	    result += parsePhoneNumberCharacter(character, result) || '';
	  }

	  return result;
	}
	/**
	 * Parses next character while parsing phone number digits (including a `+`)
	 * from text: discards everything except `+` and digits, and `+` is only allowed
	 * at the start of a phone number.
	 * For example, is used in `react-phone-number-input` where it uses
	 * [`input-format`](https://gitlab.com/catamphetamine/input-format).
	 * @param  {string} character - Yet another character from raw input string.
	 * @param  {string?} prevParsedCharacters - Previous parsed characters.
	 * @param  {object} meta - Optional custom use-case-specific metadata.
	 * @return {string?} The parsed character.
	 */

	function parsePhoneNumberCharacter(character, prevParsedCharacters) {
	  // Only allow a leading `+`.
	  if (character === '+') {
	    // If this `+` is not the first parsed character
	    // then discard it.
	    if (prevParsedCharacters) {
	      return;
	    }

	    return '+';
	  } // Allow digits.


	  return parseDigit(character);
	}

	// Deprecated. Import from 'metadata.js' directly instead.

	function _createForOfIteratorHelperLoose$2(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) { return (it = it.call(o)).next.bind(it); } if (Array.isArray(o) || (it = _unsupportedIterableToArray$2(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) { o = it; } var i = 0; return function () { if (i >= o.length) { return { done: true }; } return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

	function _unsupportedIterableToArray$2(o, minLen) { if (!o) { return; } if (typeof o === "string") { return _arrayLikeToArray$2(o, minLen); } var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) { n = o.constructor.name; } if (n === "Map" || n === "Set") { return Array.from(o); } if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) { return _arrayLikeToArray$2(o, minLen); } }

	function _arrayLikeToArray$2(arr, len) { if (len == null || len > arr.length) { len = arr.length; } for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

	/**
	 * Merges two arrays.
	 * @param  {*} a
	 * @param  {*} b
	 * @return {*}
	 */
	function mergeArrays(a, b) {
	  var merged = a.slice();

	  for (var _iterator = _createForOfIteratorHelperLoose$2(b), _step; !(_step = _iterator()).done;) {
	    var element = _step.value;

	    if (a.indexOf(element) < 0) {
	      merged.push(element);
	    }
	  }

	  return merged.sort(function (a, b) {
	    return a - b;
	  }); // ES6 version, requires Set polyfill.
	  // let merged = new Set(a)
	  // for (const element of b) {
	  // 	merged.add(i)
	  // }
	  // return Array.from(merged).sort((a, b) => a - b)
	}

	function checkNumberLength(nationalNumber, metadata) {
	  return checkNumberLengthForType(nationalNumber, undefined, metadata);
	} // Checks whether a number is possible for the country based on its length.
	// Should only be called for the "new" metadata which has "possible lengths".

	function checkNumberLengthForType(nationalNumber, type, metadata) {
	  var type_info = metadata.type(type); // There should always be "<possiblePengths/>" set for every type element.
	  // This is declared in the XML schema.
	  // For size efficiency, where a sub-description (e.g. fixed-line)
	  // has the same "<possiblePengths/>" as the "general description", this is missing,
	  // so we fall back to the "general description". Where no numbers of the type
	  // exist at all, there is one possible length (-1) which is guaranteed
	  // not to match the length of any real phone number.

	  var possible_lengths = type_info && type_info.possibleLengths() || metadata.possibleLengths(); // let local_lengths    = type_info && type.possibleLengthsLocal() || metadata.possibleLengthsLocal()
	  // Metadata before version `1.0.18` didn't contain `possible_lengths`.

	  if (!possible_lengths) {
	    return 'IS_POSSIBLE';
	  }

	  if (type === 'FIXED_LINE_OR_MOBILE') {
	    // No such country in metadata.

	    /* istanbul ignore next */
	    if (!metadata.type('FIXED_LINE')) {
	      // The rare case has been encountered where no fixedLine data is available
	      // (true for some non-geographic entities), so we just check mobile.
	      return checkNumberLengthForType(nationalNumber, 'MOBILE', metadata);
	    }

	    var mobile_type = metadata.type('MOBILE');

	    if (mobile_type) {
	      // Merge the mobile data in if there was any. "Concat" creates a new
	      // array, it doesn't edit possible_lengths in place, so we don't need a copy.
	      // Note that when adding the possible lengths from mobile, we have
	      // to again check they aren't empty since if they are this indicates
	      // they are the same as the general desc and should be obtained from there.
	      possible_lengths = mergeArrays(possible_lengths, mobile_type.possibleLengths()); // The current list is sorted; we need to merge in the new list and
	      // re-sort (duplicates are okay). Sorting isn't so expensive because
	      // the lists are very small.
	      // if (local_lengths) {
	      // 	local_lengths = mergeArrays(local_lengths, mobile_type.possibleLengthsLocal())
	      // } else {
	      // 	local_lengths = mobile_type.possibleLengthsLocal()
	      // }
	    }
	  } // If the type doesn't exist then return 'INVALID_LENGTH'.
	  else if (type && !type_info) {
	    return 'INVALID_LENGTH';
	  }

	  var actual_length = nationalNumber.length; // In `libphonenumber-js` all "local-only" formats are dropped for simplicity.
	  // // This is safe because there is never an overlap beween the possible lengths
	  // // and the local-only lengths; this is checked at build time.
	  // if (local_lengths && local_lengths.indexOf(nationalNumber.length) >= 0)
	  // {
	  // 	return 'IS_POSSIBLE_LOCAL_ONLY'
	  // }

	  var minimum_length = possible_lengths[0];

	  if (minimum_length === actual_length) {
	    return 'IS_POSSIBLE';
	  }

	  if (minimum_length > actual_length) {
	    return 'TOO_SHORT';
	  }

	  if (possible_lengths[possible_lengths.length - 1] < actual_length) {
	    return 'TOO_LONG';
	  } // We skip the first element since we've already checked it.


	  return possible_lengths.indexOf(actual_length, 1) >= 0 ? 'IS_POSSIBLE' : 'INVALID_LENGTH';
	}

	function isPossiblePhoneNumber(input, options, metadata) {
	  /* istanbul ignore if */
	  if (options === undefined) {
	    options = {};
	  }

	  metadata = new Metadata(metadata);

	  if (options.v2) {
	    if (!input.countryCallingCode) {
	      throw new Error('Invalid phone number object passed');
	    }

	    metadata.selectNumberingPlan(input.countryCallingCode);
	  } else {
	    if (!input.phone) {
	      return false;
	    }

	    if (input.country) {
	      if (!metadata.hasCountry(input.country)) {
	        throw new Error("Unknown country: ".concat(input.country));
	      }

	      metadata.country(input.country);
	    } else {
	      if (!input.countryCallingCode) {
	        throw new Error('Invalid phone number object passed');
	      }

	      metadata.selectNumberingPlan(input.countryCallingCode);
	    }
	  } // Old metadata (< 1.0.18) had no "possible length" data.


	  if (metadata.possibleLengths()) {
	    return isPossibleNumber(input.phone || input.nationalNumber, metadata);
	  } else {
	    // There was a bug between `1.7.35` and `1.7.37` where "possible_lengths"
	    // were missing for "non-geographical" numbering plans.
	    // Just assume the number is possible in such cases:
	    // it's unlikely that anyone generated their custom metadata
	    // in that short period of time (one day).
	    // This code can be removed in some future major version update.
	    if (input.countryCallingCode && metadata.isNonGeographicCallingCode(input.countryCallingCode)) {
	      // "Non-geographic entities" did't have `possibleLengths`
	      // due to a bug in metadata generation process.
	      return true;
	    } else {
	      throw new Error('Missing "possibleLengths" in metadata. Perhaps the metadata has been generated before v1.0.18.');
	    }
	  }
	}
	function isPossibleNumber(nationalNumber, metadata) {
	  //, isInternational) {
	  switch (checkNumberLength(nationalNumber, metadata)) {
	    case 'IS_POSSIBLE':
	      return true;
	    // This library ignores "local-only" phone numbers (for simplicity).
	    // See the readme for more info on what are "local-only" phone numbers.
	    // case 'IS_POSSIBLE_LOCAL_ONLY':
	    // 	return !isInternational

	    default:
	      return false;
	  }
	}

	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray$3(arr, i) || _nonIterableRest(); }

	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

	function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) { return; } var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) { break; } } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) { _i["return"](); } } finally { if (_d) { throw _e; } } } return _arr; }

	function _arrayWithHoles(arr) { if (Array.isArray(arr)) { return arr; } }

	function _createForOfIteratorHelperLoose$3(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) { return (it = it.call(o)).next.bind(it); } if (Array.isArray(o) || (it = _unsupportedIterableToArray$3(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) { o = it; } var i = 0; return function () { if (i >= o.length) { return { done: true }; } return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

	function _unsupportedIterableToArray$3(o, minLen) { if (!o) { return; } if (typeof o === "string") { return _arrayLikeToArray$3(o, minLen); } var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) { n = o.constructor.name; } if (n === "Map" || n === "Set") { return Array.from(o); } if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) { return _arrayLikeToArray$3(o, minLen); } }

	function _arrayLikeToArray$3(arr, len) { if (len == null || len > arr.length) { len = arr.length; } for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

	/**
	 * @param  {string} text - Phone URI (RFC 3966).
	 * @return {object} `{ ?number, ?ext }`.
	 */

	function parseRFC3966(text) {
	  var number;
	  var ext; // Replace "tel:" with "tel=" for parsing convenience.

	  text = text.replace(/^tel:/, 'tel=');

	  for (var _iterator = _createForOfIteratorHelperLoose$3(text.split(';')), _step; !(_step = _iterator()).done;) {
	    var part = _step.value;

	    var _part$split = part.split('='),
	        _part$split2 = _slicedToArray(_part$split, 2),
	        name = _part$split2[0],
	        value = _part$split2[1];

	    switch (name) {
	      case 'tel':
	        number = value;
	        break;

	      case 'ext':
	        ext = value;
	        break;

	      case 'phone-context':
	        // Only "country contexts" are supported.
	        // "Domain contexts" are ignored.
	        if (value[0] === '+') {
	          number = value + number;
	        }

	        break;
	    }
	  } // If the phone number is not viable, then abort.


	  if (!isViablePhoneNumber(number)) {
	    return {};
	  }

	  var result = {
	    number: number
	  };

	  if (ext) {
	    result.ext = ext;
	  }

	  return result;
	}
	/**
	 * @param  {object} - `{ ?number, ?extension }`.
	 * @return {string} Phone URI (RFC 3966).
	 */

	function formatRFC3966(_ref) {
	  var number = _ref.number,
	      ext = _ref.ext;

	  if (!number) {
	    return '';
	  }

	  if (number[0] !== '+') {
	    throw new Error("\"formatRFC3966()\" expects \"number\" to be in E.164 format.");
	  }

	  return "tel:".concat(number).concat(ext ? ';ext=' + ext : '');
	}

	/**
	 * Checks whether the entire input sequence can be matched
	 * against the regular expression.
	 * @return {boolean}
	 */
	function matchesEntirely(text, regular_expression) {
	  // If assigning the `''` default value is moved to the arguments above,
	  // code coverage would decrease for some weird reason.
	  text = text || '';
	  return new RegExp('^(?:' + regular_expression + ')$').test(text);
	}

	function _createForOfIteratorHelperLoose$4(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) { return (it = it.call(o)).next.bind(it); } if (Array.isArray(o) || (it = _unsupportedIterableToArray$4(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) { o = it; } var i = 0; return function () { if (i >= o.length) { return { done: true }; } return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

	function _unsupportedIterableToArray$4(o, minLen) { if (!o) { return; } if (typeof o === "string") { return _arrayLikeToArray$4(o, minLen); } var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) { n = o.constructor.name; } if (n === "Map" || n === "Set") { return Array.from(o); } if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) { return _arrayLikeToArray$4(o, minLen); } }

	function _arrayLikeToArray$4(arr, len) { if (len == null || len > arr.length) { len = arr.length; } for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	var NON_FIXED_LINE_PHONE_TYPES = ['MOBILE', 'PREMIUM_RATE', 'TOLL_FREE', 'SHARED_COST', 'VOIP', 'PERSONAL_NUMBER', 'PAGER', 'UAN', 'VOICEMAIL']; // Finds out national phone number type (fixed line, mobile, etc)

	function getNumberType(input, options, metadata) {
	  // If assigning the `{}` default value is moved to the arguments above,
	  // code coverage would decrease for some weird reason.
	  options = options || {}; // When `parse()` returned `{}`
	  // meaning that the phone number is not a valid one.

	  if (!input.country) {
	    return;
	  }

	  metadata = new Metadata(metadata);
	  metadata.selectNumberingPlan(input.country, input.countryCallingCode);
	  var nationalNumber = options.v2 ? input.nationalNumber : input.phone; // The following is copy-pasted from the original function:
	  // https://github.com/googlei18n/libphonenumber/blob/3ea547d4fbaa2d0b67588904dfa5d3f2557c27ff/javascript/i18n/phonenumbers/phonenumberutil.js#L2835
	  // Is this national number even valid for this country

	  if (!matchesEntirely(nationalNumber, metadata.nationalNumberPattern())) {
	    return;
	  } // Is it fixed line number


	  if (isNumberTypeEqualTo(nationalNumber, 'FIXED_LINE', metadata)) {
	    // Because duplicate regular expressions are removed
	    // to reduce metadata size, if "mobile" pattern is ""
	    // then it means it was removed due to being a duplicate of the fixed-line pattern.
	    //
	    if (metadata.type('MOBILE') && metadata.type('MOBILE').pattern() === '') {
	      return 'FIXED_LINE_OR_MOBILE';
	    } // `MOBILE` type pattern isn't included if it matched `FIXED_LINE` one.
	    // For example, for "US" country.
	    // Old metadata (< `1.0.18`) had a specific "types" data structure
	    // that happened to be `undefined` for `MOBILE` in that case.
	    // Newer metadata (>= `1.0.18`) has another data structure that is
	    // not `undefined` for `MOBILE` in that case (it's just an empty array).
	    // So this `if` is just for backwards compatibility with old metadata.


	    if (!metadata.type('MOBILE')) {
	      return 'FIXED_LINE_OR_MOBILE';
	    } // Check if the number happens to qualify as both fixed line and mobile.
	    // (no such country in the minimal metadata set)

	    /* istanbul ignore if */


	    if (isNumberTypeEqualTo(nationalNumber, 'MOBILE', metadata)) {
	      return 'FIXED_LINE_OR_MOBILE';
	    }

	    return 'FIXED_LINE';
	  }

	  for (var _iterator = _createForOfIteratorHelperLoose$4(NON_FIXED_LINE_PHONE_TYPES), _step; !(_step = _iterator()).done;) {
	    var type = _step.value;

	    if (isNumberTypeEqualTo(nationalNumber, type, metadata)) {
	      return type;
	    }
	  }
	}
	function isNumberTypeEqualTo(nationalNumber, type, metadata) {
	  type = metadata.type(type);

	  if (!type || !type.pattern()) {
	    return false;
	  } // Check if any possible number lengths are present;
	  // if so, we use them to avoid checking
	  // the validation pattern if they don't match.
	  // If they are absent, this means they match
	  // the general description, which we have
	  // already checked before a specific number type.


	  if (type.possibleLengths() && type.possibleLengths().indexOf(nationalNumber.length) < 0) {
	    return false;
	  }

	  return matchesEntirely(nationalNumber, type.pattern());
	}

	/**
	 * Checks if a given phone number is valid.
	 *
	 * If the `number` is a string, it will be parsed to an object,
	 * but only if it contains only valid phone number characters (including punctuation).
	 * If the `number` is an object, it is used as is.
	 *
	 * The optional `defaultCountry` argument is the default country.
	 * I.e. it does not restrict to just that country,
	 * e.g. in those cases where several countries share
	 * the same phone numbering rules (NANPA, Britain, etc).
	 * For example, even though the number `07624 369230`
	 * belongs to the Isle of Man ("IM" country code)
	 * calling `isValidNumber('07624369230', 'GB', metadata)`
	 * still returns `true` because the country is not restricted to `GB`,
	 * it's just that `GB` is the default one for the phone numbering rules.
	 * For restricting the country see `isValidNumberForRegion()`
	 * though restricting a country might not be a good idea.
	 * https://github.com/googlei18n/libphonenumber/blob/master/FAQ.md#when-should-i-use-isvalidnumberforregion
	 *
	 * Examples:
	 *
	 * ```js
	 * isValidNumber('+78005553535', metadata)
	 * isValidNumber('8005553535', 'RU', metadata)
	 * isValidNumber('88005553535', 'RU', metadata)
	 * isValidNumber({ phone: '8005553535', country: 'RU' }, metadata)
	 * ```
	 */

	function isValidNumber(input, options, metadata) {
	  // If assigning the `{}` default value is moved to the arguments above,
	  // code coverage would decrease for some weird reason.
	  options = options || {};
	  metadata = new Metadata(metadata); // This is just to support `isValidNumber({})`
	  // for cases when `parseNumber()` returns `{}`.

	  if (!input.country) {
	    return false;
	  }

	  metadata.selectNumberingPlan(input.country, input.countryCallingCode); // By default, countries only have type regexps when it's required for
	  // distinguishing different countries having the same `countryCallingCode`.

	  if (metadata.hasTypes()) {
	    return getNumberType(input, options, metadata.metadata) !== undefined;
	  } // If there are no type regexps for this country in metadata then use
	  // `nationalNumberPattern` as a "better than nothing" replacement.


	  var national_number = options.v2 ? input.nationalNumber : input.phone;
	  return matchesEntirely(national_number, metadata.nationalNumberPattern());
	}

	//
	// E.g. "(999) 111-22-33" -> "999 111 22 33"
	//
	// For some reason Google's metadata contains `<intlFormat/>`s with brackets and dashes.
	// Meanwhile, there's no single opinion about using punctuation in international phone numbers.
	//
	// For example, Google's `<intlFormat/>` for USA is `+1 213-373-4253`.
	// And here's a quote from WikiPedia's "North American Numbering Plan" page:
	// https://en.wikipedia.org/wiki/North_American_Numbering_Plan
	//
	// "The country calling code for all countries participating in the NANP is 1.
	// In international format, an NANP number should be listed as +1 301 555 01 00,
	// where 301 is an area code (Maryland)."
	//
	// I personally prefer the international format without any punctuation.
	// For example, brackets are remnants of the old age, meaning that the
	// phone number part in brackets (so called "area code") can be omitted
	// if dialing within the same "area".
	// And hyphens were clearly introduced for splitting local numbers into memorizable groups.
	// For example, remembering "5553535" is difficult but "555-35-35" is much simpler.
	// Imagine a man taking a bus from home to work and seeing an ad with a phone number.
	// He has a couple of seconds to memorize that number until it passes by.
	// If it were spaces instead of hyphens the man wouldn't necessarily get it,
	// but with hyphens instead of spaces the grouping is more explicit.
	// I personally think that hyphens introduce visual clutter,
	// so I prefer replacing them with spaces in international numbers.
	// In the modern age all output is done on displays where spaces are clearly distinguishable
	// so hyphens can be safely replaced with spaces without losing any legibility.
	//

	function applyInternationalSeparatorStyle(formattedNumber) {
	  return formattedNumber.replace(new RegExp("[".concat(VALID_PUNCTUATION, "]+"), 'g'), ' ').trim();
	}

	// first group is not used in the national pattern (e.g. Argentina) so the $1
	// group does not match correctly. Therefore, we use `\d`, so that the first
	// group actually used in the pattern will be matched.

	var FIRST_GROUP_PATTERN = /(\$\d)/;
	function formatNationalNumberUsingFormat(number, format, _ref) {
	  var useInternationalFormat = _ref.useInternationalFormat,
	      withNationalPrefix = _ref.withNationalPrefix,
	      carrierCode = _ref.carrierCode,
	      metadata = _ref.metadata;
	  var formattedNumber = number.replace(new RegExp(format.pattern()), useInternationalFormat ? format.internationalFormat() : // This library doesn't use `domestic_carrier_code_formatting_rule`,
	  // because that one is only used when formatting phone numbers
	  // for dialing from a mobile phone, and this is not a dialing library.
	  // carrierCode && format.domesticCarrierCodeFormattingRule()
	  // 	// First, replace the $CC in the formatting rule with the desired carrier code.
	  // 	// Then, replace the $FG in the formatting rule with the first group
	  // 	// and the carrier code combined in the appropriate way.
	  // 	? format.format().replace(FIRST_GROUP_PATTERN, format.domesticCarrierCodeFormattingRule().replace('$CC', carrierCode))
	  // 	: (
	  // 		withNationalPrefix && format.nationalPrefixFormattingRule()
	  // 			? format.format().replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule())
	  // 			: format.format()
	  // 	)
	  withNationalPrefix && format.nationalPrefixFormattingRule() ? format.format().replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule()) : format.format());

	  if (useInternationalFormat) {
	    return applyInternationalSeparatorStyle(formattedNumber);
	  }

	  return formattedNumber;
	}

	/**
	 * Pattern that makes it easy to distinguish whether a region has a single
	 * international dialing prefix or not. If a region has a single international
	 * prefix (e.g. 011 in USA), it will be represented as a string that contains
	 * a sequence of ASCII digits, and possibly a tilde, which signals waiting for
	 * the tone. If there are multiple available international prefixes in a
	 * region, they will be represented as a regex string that always contains one
	 * or more characters that are not ASCII digits or a tilde.
	 */

	var SINGLE_IDD_PREFIX_REG_EXP = /^[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?$/; // For regions that have multiple IDD prefixes
	// a preferred IDD prefix is returned.

	function getIddPrefix(country, callingCode, metadata) {
	  var countryMetadata = new Metadata(metadata);
	  countryMetadata.selectNumberingPlan(country, callingCode);

	  if (countryMetadata.defaultIDDPrefix()) {
	    return countryMetadata.defaultIDDPrefix();
	  }

	  if (SINGLE_IDD_PREFIX_REG_EXP.test(countryMetadata.IDDPrefix())) {
	    return countryMetadata.IDDPrefix();
	  }
	}

	function _createForOfIteratorHelperLoose$5(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) { return (it = it.call(o)).next.bind(it); } if (Array.isArray(o) || (it = _unsupportedIterableToArray$5(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) { o = it; } var i = 0; return function () { if (i >= o.length) { return { done: true }; } return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

	function _unsupportedIterableToArray$5(o, minLen) { if (!o) { return; } if (typeof o === "string") { return _arrayLikeToArray$5(o, minLen); } var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) { n = o.constructor.name; } if (n === "Map" || n === "Set") { return Array.from(o); } if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) { return _arrayLikeToArray$5(o, minLen); } }

	function _arrayLikeToArray$5(arr, len) { if (len == null || len > arr.length) { len = arr.length; } for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

	function _objectSpread(target) {
	var arguments$1 = arguments;
	 for (var i = 1; i < arguments.length; i++) { var source = null != arguments$1[i] ? arguments$1[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	var DEFAULT_OPTIONS = {
	  formatExtension: function formatExtension(formattedNumber, extension, metadata) {
	    return "".concat(formattedNumber).concat(metadata.ext()).concat(extension);
	  }
	}; // Formats a phone number
	//
	// Example use cases:
	//
	// ```js
	// formatNumber('8005553535', 'RU', 'INTERNATIONAL')
	// formatNumber('8005553535', 'RU', 'INTERNATIONAL', metadata)
	// formatNumber({ phone: '8005553535', country: 'RU' }, 'INTERNATIONAL')
	// formatNumber({ phone: '8005553535', country: 'RU' }, 'INTERNATIONAL', metadata)
	// formatNumber('+78005553535', 'NATIONAL')
	// formatNumber('+78005553535', 'NATIONAL', metadata)
	// ```
	//

	function formatNumber$1(input, format, options, metadata) {
	  // Apply default options.
	  if (options) {
	    options = _objectSpread(_objectSpread({}, DEFAULT_OPTIONS), options);
	  } else {
	    options = DEFAULT_OPTIONS;
	  }

	  metadata = new Metadata(metadata);

	  if (input.country && input.country !== '001') {
	    // Validate `input.country`.
	    if (!metadata.hasCountry(input.country)) {
	      throw new Error("Unknown country: ".concat(input.country));
	    }

	    metadata.country(input.country);
	  } else if (input.countryCallingCode) {
	    metadata.selectNumberingPlan(input.countryCallingCode);
	  } else { return input.phone || ''; }

	  var countryCallingCode = metadata.countryCallingCode();
	  var nationalNumber = options.v2 ? input.nationalNumber : input.phone; // This variable should have been declared inside `case`s
	  // but Babel has a bug and it says "duplicate variable declaration".

	  var number;

	  switch (format) {
	    case 'NATIONAL':
	      // Legacy argument support.
	      // (`{ country: ..., phone: '' }`)
	      if (!nationalNumber) {
	        return '';
	      }

	      number = formatNationalNumber(nationalNumber, input.carrierCode, 'NATIONAL', metadata, options);
	      return addExtension(number, input.ext, metadata, options.formatExtension);

	    case 'INTERNATIONAL':
	      // Legacy argument support.
	      // (`{ country: ..., phone: '' }`)
	      if (!nationalNumber) {
	        return "+".concat(countryCallingCode);
	      }

	      number = formatNationalNumber(nationalNumber, null, 'INTERNATIONAL', metadata, options);
	      number = "+".concat(countryCallingCode, " ").concat(number);
	      return addExtension(number, input.ext, metadata, options.formatExtension);

	    case 'E.164':
	      // `E.164` doesn't define "phone number extensions".
	      return "+".concat(countryCallingCode).concat(nationalNumber);

	    case 'RFC3966':
	      return formatRFC3966({
	        number: "+".concat(countryCallingCode).concat(nationalNumber),
	        ext: input.ext
	      });
	    // For reference, here's Google's IDD formatter:
	    // https://github.com/google/libphonenumber/blob/32719cf74e68796788d1ca45abc85dcdc63ba5b9/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L1546
	    // Not saying that this IDD formatter replicates it 1:1, but it seems to work.
	    // Who would even need to format phone numbers in IDD format anyway?

	    case 'IDD':
	      if (!options.fromCountry) {
	        return; // throw new Error('`fromCountry` option not passed for IDD-prefixed formatting.')
	      }

	      var formattedNumber = formatIDD(nationalNumber, input.carrierCode, countryCallingCode, options.fromCountry, metadata);
	      return addExtension(formattedNumber, input.ext, metadata, options.formatExtension);

	    default:
	      throw new Error("Unknown \"format\" argument passed to \"formatNumber()\": \"".concat(format, "\""));
	  }
	}

	function formatNationalNumber(number, carrierCode, formatAs, metadata, options) {
	  var format = chooseFormatForNumber(metadata.formats(), number);

	  if (!format) {
	    return number;
	  }

	  return formatNationalNumberUsingFormat(number, format, {
	    useInternationalFormat: formatAs === 'INTERNATIONAL',
	    withNationalPrefix: format.nationalPrefixIsOptionalWhenFormattingInNationalFormat() && options && options.nationalPrefix === false ? false : true,
	    carrierCode: carrierCode,
	    metadata: metadata
	  });
	}

	function chooseFormatForNumber(availableFormats, nationalNnumber) {
	  for (var _iterator = _createForOfIteratorHelperLoose$5(availableFormats), _step; !(_step = _iterator()).done;) {
	    var format = _step.value;

	    // Validate leading digits.
	    // The test case for "else path" could be found by searching for
	    // "format.leadingDigitsPatterns().length === 0".
	    if (format.leadingDigitsPatterns().length > 0) {
	      // The last leading_digits_pattern is used here, as it is the most detailed
	      var lastLeadingDigitsPattern = format.leadingDigitsPatterns()[format.leadingDigitsPatterns().length - 1]; // If leading digits don't match then move on to the next phone number format

	      if (nationalNnumber.search(lastLeadingDigitsPattern) !== 0) {
	        continue;
	      }
	    } // Check that the national number matches the phone number format regular expression


	    if (matchesEntirely(nationalNnumber, format.pattern())) {
	      return format;
	    }
	  }
	}

	function addExtension(formattedNumber, ext, metadata, formatExtension) {
	  return ext ? formatExtension(formattedNumber, ext, metadata) : formattedNumber;
	}

	function formatIDD(nationalNumber, carrierCode, countryCallingCode, fromCountry, metadata) {
	  var fromCountryCallingCode = getCountryCallingCode(fromCountry, metadata.metadata); // When calling within the same country calling code.

	  if (fromCountryCallingCode === countryCallingCode) {
	    var formattedNumber = formatNationalNumber(nationalNumber, carrierCode, 'NATIONAL', metadata); // For NANPA regions, return the national format for these regions
	    // but prefix it with the country calling code.

	    if (countryCallingCode === '1') {
	      return countryCallingCode + ' ' + formattedNumber;
	    } // If regions share a country calling code, the country calling code need
	    // not be dialled. This also applies when dialling within a region, so this
	    // if clause covers both these cases. Technically this is the case for
	    // dialling from La Reunion to other overseas departments of France (French
	    // Guiana, Martinique, Guadeloupe), but not vice versa - so we don't cover
	    // this edge case for now and for those cases return the version including
	    // country calling code. Details here:
	    // http://www.petitfute.com/voyage/225-info-pratiques-reunion
	    //


	    return formattedNumber;
	  }

	  var iddPrefix = getIddPrefix(fromCountry, undefined, metadata.metadata);

	  if (iddPrefix) {
	    return "".concat(iddPrefix, " ").concat(countryCallingCode, " ").concat(formatNationalNumber(nationalNumber, null, 'INTERNATIONAL', metadata));
	  }
	}

	function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

	function _objectSpread$1(target) {
	var arguments$1 = arguments;
	 for (var i = 1; i < arguments.length; i++) { var source = null != arguments$1[i] ? arguments$1[i] : {}; i % 2 ? ownKeys$1(Object(source), !0).forEach(function (key) { _defineProperty$1(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

	function _defineProperty$1(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

	function _classCallCheck$2(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _defineProperties$2(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) { descriptor.writable = true; } Object.defineProperty(target, descriptor.key, descriptor); } }

	function _createClass$2(Constructor, protoProps, staticProps) { if (protoProps) { _defineProperties$2(Constructor.prototype, protoProps); } if (staticProps) { _defineProperties$2(Constructor, staticProps); } Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

	var PhoneNumber = /*#__PURE__*/function () {
	  function PhoneNumber(countryCallingCode, nationalNumber, metadata) {
	    _classCallCheck$2(this, PhoneNumber);

	    if (!countryCallingCode) {
	      throw new TypeError('`country` or `countryCallingCode` not passed');
	    }

	    if (!nationalNumber) {
	      throw new TypeError('`nationalNumber` not passed');
	    }

	    if (!metadata) {
	      throw new TypeError('`metadata` not passed');
	    }

	    var _metadata = new Metadata(metadata); // If country code is passed then derive `countryCallingCode` from it.
	    // Also store the country code as `.country`.


	    if (isCountryCode(countryCallingCode)) {
	      this.country = countryCallingCode;

	      _metadata.country(countryCallingCode);

	      countryCallingCode = _metadata.countryCallingCode();
	    }

	    this.countryCallingCode = countryCallingCode;
	    this.nationalNumber = nationalNumber;
	    this.number = '+' + this.countryCallingCode + this.nationalNumber;
	    this.metadata = metadata;
	  }

	  _createClass$2(PhoneNumber, [{
	    key: "setExt",
	    value: function setExt(ext) {
	      this.ext = ext;
	    }
	  }, {
	    key: "isPossible",
	    value: function isPossible() {
	      return isPossiblePhoneNumber(this, {
	        v2: true
	      }, this.metadata);
	    }
	  }, {
	    key: "isValid",
	    value: function isValid() {
	      return isValidNumber(this, {
	        v2: true
	      }, this.metadata);
	    }
	  }, {
	    key: "isNonGeographic",
	    value: function isNonGeographic() {
	      var metadata = new Metadata(this.metadata);
	      return metadata.isNonGeographicCallingCode(this.countryCallingCode);
	    }
	  }, {
	    key: "isEqual",
	    value: function isEqual(phoneNumber) {
	      return this.number === phoneNumber.number && this.ext === phoneNumber.ext;
	    } // // Is just an alias for `this.isValid() && this.country === country`.
	    // // https://github.com/googlei18n/libphonenumber/blob/master/FAQ.md#when-should-i-use-isvalidnumberforregion
	    // isValidForRegion(country) {
	    // 	return isValidNumberForRegion(this, country, { v2: true }, this.metadata)
	    // }

	  }, {
	    key: "getType",
	    value: function getType() {
	      return getNumberType(this, {
	        v2: true
	      }, this.metadata);
	    }
	  }, {
	    key: "format",
	    value: function format(_format, options) {
	      return formatNumber$1(this, _format, options ? _objectSpread$1(_objectSpread$1({}, options), {}, {
	        v2: true
	      }) : {
	        v2: true
	      }, this.metadata);
	    }
	  }, {
	    key: "formatNational",
	    value: function formatNational(options) {
	      return this.format('NATIONAL', options);
	    }
	  }, {
	    key: "formatInternational",
	    value: function formatInternational(options) {
	      return this.format('INTERNATIONAL', options);
	    }
	  }, {
	    key: "getURI",
	    value: function getURI(options) {
	      return this.format('RFC3966', options);
	    }
	  }]);

	  return PhoneNumber;
	}();

	var isCountryCode = function isCountryCode(value) {
	  return /^[A-Z]{2}$/.test(value);
	};

	var CAPTURING_DIGIT_PATTERN = new RegExp('([' + VALID_DIGITS + '])');
	function stripIddPrefix(number, country, callingCode, metadata) {
	  if (!country) {
	    return;
	  } // Check if the number is IDD-prefixed.


	  var countryMetadata = new Metadata(metadata);
	  countryMetadata.selectNumberingPlan(country, callingCode);
	  var IDDPrefixPattern = new RegExp(countryMetadata.IDDPrefix());

	  if (number.search(IDDPrefixPattern) !== 0) {
	    return;
	  } // Strip IDD prefix.


	  number = number.slice(number.match(IDDPrefixPattern)[0].length); // If there're any digits after an IDD prefix,
	  // then those digits are a country calling code.
	  // Since no country code starts with a `0`,
	  // the code below validates that the next digit (if present) is not `0`.

	  var matchedGroups = number.match(CAPTURING_DIGIT_PATTERN);

	  if (matchedGroups && matchedGroups[1] != null && matchedGroups[1].length > 0) {
	    if (matchedGroups[1] === '0') {
	      return;
	    }
	  }

	  return number;
	}

	/**
	 * Strips any national prefix (such as 0, 1) present in a
	 * (possibly incomplete) number provided.
	 * "Carrier codes" are only used  in Colombia and Brazil,
	 * and only when dialing within those countries from a mobile phone to a fixed line number.
	 * Sometimes it won't actually strip national prefix
	 * and will instead prepend some digits to the `number`:
	 * for example, when number `2345678` is passed with `VI` country selected,
	 * it will return `{ number: "3402345678" }`, because `340` area code is prepended.
	 * @param {string} number — National number digits.
	 * @param {object} metadata — Metadata with country selected.
	 * @return {object} `{ nationalNumber: string, nationalPrefix: string? carrierCode: string? }`. Even if a national prefix was extracted, it's not necessarily present in the returned object, so don't rely on its presence in the returned object in order to find out whether a national prefix has been extracted or not.
	 */
	function extractNationalNumberFromPossiblyIncompleteNumber(number, metadata) {
	  if (number && metadata.numberingPlan.nationalPrefixForParsing()) {
	    // See METADATA.md for the description of
	    // `national_prefix_for_parsing` and `national_prefix_transform_rule`.
	    // Attempt to parse the first digits as a national prefix.
	    var prefixPattern = new RegExp('^(?:' + metadata.numberingPlan.nationalPrefixForParsing() + ')');
	    var prefixMatch = prefixPattern.exec(number);

	    if (prefixMatch) {
	      var nationalNumber;
	      var carrierCode; // https://gitlab.com/catamphetamine/libphonenumber-js/-/blob/master/METADATA.md#national_prefix_for_parsing--national_prefix_transform_rule
	      // If a `national_prefix_for_parsing` has any "capturing groups"
	      // then it means that the national (significant) number is equal to
	      // those "capturing groups" transformed via `national_prefix_transform_rule`,
	      // and nothing could be said about the actual national prefix:
	      // what is it and was it even there.
	      // If a `national_prefix_for_parsing` doesn't have any "capturing groups",
	      // then everything it matches is a national prefix.
	      // To determine whether `national_prefix_for_parsing` matched any
	      // "capturing groups", the value of the result of calling `.exec()`
	      // is looked at, and if it has non-undefined values where there're
	      // "capturing groups" in the regular expression, then it means
	      // that "capturing groups" have been matched.
	      // It's not possible to tell whether there'll be any "capturing gropus"
	      // before the matching process, because a `national_prefix_for_parsing`
	      // could exhibit both behaviors.

	      var capturedGroupsCount = prefixMatch.length - 1;
	      var hasCapturedGroups = capturedGroupsCount > 0 && prefixMatch[capturedGroupsCount];

	      if (metadata.nationalPrefixTransformRule() && hasCapturedGroups) {
	        nationalNumber = number.replace(prefixPattern, metadata.nationalPrefixTransformRule()); // If there's more than one captured group,
	        // then carrier code is the second one.

	        if (capturedGroupsCount > 1) {
	          carrierCode = prefixMatch[1];
	        }
	      } // If there're no "capturing groups",
	      // or if there're "capturing groups" but no
	      // `national_prefix_transform_rule`,
	      // then just strip the national prefix from the number,
	      // and possibly a carrier code.
	      // Seems like there could be more.
	      else {
	        // `prefixBeforeNationalNumber` is the whole substring matched by
	        // the `national_prefix_for_parsing` regular expression.
	        // There seem to be no guarantees that it's just a national prefix.
	        // For example, if there's a carrier code, it's gonna be a
	        // part of `prefixBeforeNationalNumber` too.
	        var prefixBeforeNationalNumber = prefixMatch[0];
	        nationalNumber = number.slice(prefixBeforeNationalNumber.length); // If there's at least one captured group,
	        // then carrier code is the first one.

	        if (hasCapturedGroups) {
	          carrierCode = prefixMatch[1];
	        }
	      } // Tries to guess whether a national prefix was present in the input.
	      // This is not something copy-pasted from Google's library:
	      // they don't seem to have an equivalent for that.
	      // So this isn't an "officially approved" way of doing something like that.
	      // But since there seems no other existing method, this library uses it.


	      var nationalPrefix;

	      if (hasCapturedGroups) {
	        var possiblePositionOfTheFirstCapturedGroup = number.indexOf(prefixMatch[1]);
	        var possibleNationalPrefix = number.slice(0, possiblePositionOfTheFirstCapturedGroup); // Example: an Argentinian (AR) phone number `0111523456789`.
	        // `prefixMatch[0]` is `01115`, and `$1` is `11`,
	        // and the rest of the phone number is `23456789`.
	        // The national number is transformed via `9$1` to `91123456789`.
	        // National prefix `0` is detected being present at the start.
	        // if (possibleNationalPrefix.indexOf(metadata.numberingPlan.nationalPrefix()) === 0) {

	        if (possibleNationalPrefix === metadata.numberingPlan.nationalPrefix()) {
	          nationalPrefix = metadata.numberingPlan.nationalPrefix();
	        }
	      } else {
	        nationalPrefix = prefixMatch[0];
	      }

	      return {
	        nationalNumber: nationalNumber,
	        nationalPrefix: nationalPrefix,
	        carrierCode: carrierCode
	      };
	    }
	  }

	  return {
	    nationalNumber: number
	  };
	}

	/**
	 * Strips national prefix and carrier code from a complete phone number.
	 * The difference from the non-"FromCompleteNumber" function is that
	 * it won't extract national prefix if the resultant number is too short
	 * to be a complete number for the selected phone numbering plan.
	 * @param  {string} number — Complete phone number digits.
	 * @param  {Metadata} metadata — Metadata with a phone numbering plan selected.
	 * @return {object} `{ nationalNumber: string, carrierCode: string? }`.
	 */

	function extractNationalNumber(number, metadata) {
	  // Parsing national prefixes and carrier codes
	  // is only required for local phone numbers
	  // but some people don't understand that
	  // and sometimes write international phone numbers
	  // with national prefixes (or maybe even carrier codes).
	  // http://ucken.blogspot.ru/2016/03/trunk-prefixes-in-skype4b.html
	  // Google's original library forgives such mistakes
	  // and so does this library, because it has been requested:
	  // https://github.com/catamphetamine/libphonenumber-js/issues/127
	  var _extractNationalNumbe = extractNationalNumberFromPossiblyIncompleteNumber(number, metadata),
	      carrierCode = _extractNationalNumbe.carrierCode,
	      nationalNumber = _extractNationalNumbe.nationalNumber;

	  if (nationalNumber !== number) {
	    if (!shouldHaveExtractedNationalPrefix(number, nationalNumber, metadata)) {
	      // Don't strip the national prefix.
	      return {
	        nationalNumber: number
	      };
	    } // Check the national (significant) number length after extracting national prefix and carrier code.
	    // Legacy generated metadata (before `1.0.18`) didn't support the "possible lengths" feature.


	    if (metadata.possibleLengths()) {
	      // The number remaining after stripping the national prefix and carrier code
	      // should be long enough to have a possible length for the country.
	      // Otherwise, don't strip the national prefix and carrier code,
	      // since the original number could be a valid number.
	      // This check has been copy-pasted "as is" from Google's original library:
	      // https://github.com/google/libphonenumber/blob/876268eb1ad6cdc1b7b5bef17fc5e43052702d57/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L3236-L3250
	      // It doesn't check for the "possibility" of the original `number`.
	      // I guess it's fine not checking that one. It works as is anyway.
	      if (!isPossibleIncompleteNationalNumber(nationalNumber, metadata)) {
	        // Don't strip the national prefix.
	        return {
	          nationalNumber: number
	        };
	      }
	    }
	  }

	  return {
	    nationalNumber: nationalNumber,
	    carrierCode: carrierCode
	  };
	} // In some countries, the same digit could be a national prefix
	// or a leading digit of a valid phone number.
	// For example, in Russia, national prefix is `8`,
	// and also `800 555 35 35` is a valid number
	// in which `8` is not a national prefix, but the first digit
	// of a national (significant) number.
	// Same's with Belarus:
	// `82004910060` is a valid national (significant) number,
	// but `2004910060` is not.
	// To support such cases (to prevent the code from always stripping
	// national prefix), a condition is imposed: a national prefix
	// is not extracted when the original number is "viable" and the
	// resultant number is not, a "viable" national number being the one
	// that matches `national_number_pattern`.

	function shouldHaveExtractedNationalPrefix(nationalNumberBefore, nationalNumberAfter, metadata) {
	  // The equivalent in Google's code is:
	  // https://github.com/google/libphonenumber/blob/e326fa1fc4283bb05eb35cb3c15c18f98a31af33/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L2969-L3004
	  if (matchesEntirely(nationalNumberBefore, metadata.nationalNumberPattern()) && !matchesEntirely(nationalNumberAfter, metadata.nationalNumberPattern())) {
	    return false;
	  } // This "is possible" national number (length) check has been commented out
	  // because it's superceded by the (effectively) same check done in the
	  // `extractNationalNumber()` function after it calls `shouldHaveExtractedNationalPrefix()`.
	  // In other words, why run the same check twice if it could only be run once.
	  // // Check the national (significant) number length after extracting national prefix and carrier code.
	  // // Fixes a minor "weird behavior" bug: https://gitlab.com/catamphetamine/libphonenumber-js/-/issues/57
	  // // (Legacy generated metadata (before `1.0.18`) didn't support the "possible lengths" feature).
	  // if (metadata.possibleLengths()) {
	  // 	if (isPossibleIncompleteNationalNumber(nationalNumberBefore, metadata) &&
	  // 		!isPossibleIncompleteNationalNumber(nationalNumberAfter, metadata)) {
	  // 		return false
	  // 	}
	  // }


	  return true;
	}

	function isPossibleIncompleteNationalNumber(nationalNumber, metadata) {
	  switch (checkNumberLength(nationalNumber, metadata)) {
	    case 'TOO_SHORT':
	    case 'INVALID_LENGTH':
	      // This library ignores "local-only" phone numbers (for simplicity).
	      // See the readme for more info on what are "local-only" phone numbers.
	      // case 'IS_POSSIBLE_LOCAL_ONLY':
	      return false;

	    default:
	      return true;
	  }
	}

	/**
	 * Sometimes some people incorrectly input international phone numbers
	 * without the leading `+`. This function corrects such input.
	 * @param  {string} number — Phone number digits.
	 * @param  {string?} country
	 * @param  {string?} callingCode
	 * @param  {object} metadata
	 * @return {object} `{ countryCallingCode: string?, number: string }`.
	 */

	function extractCountryCallingCodeFromInternationalNumberWithoutPlusSign(number, country, callingCode, metadata) {
	  var countryCallingCode = country ? getCountryCallingCode(country, metadata) : callingCode;

	  if (number.indexOf(countryCallingCode) === 0) {
	    metadata = new Metadata(metadata);
	    metadata.selectNumberingPlan(country, callingCode);
	    var possibleShorterNumber = number.slice(countryCallingCode.length);

	    var _extractNationalNumbe = extractNationalNumber(possibleShorterNumber, metadata),
	        possibleShorterNationalNumber = _extractNationalNumbe.nationalNumber;

	    var _extractNationalNumbe2 = extractNationalNumber(number, metadata),
	        nationalNumber = _extractNationalNumbe2.nationalNumber; // If the number was not valid before but is valid now,
	    // or if it was too long before, we consider the number
	    // with the country calling code stripped to be a better result
	    // and keep that instead.
	    // For example, in Germany (+49), `49` is a valid area code,
	    // so if a number starts with `49`, it could be both a valid
	    // national German number or an international number without
	    // a leading `+`.


	    if (!matchesEntirely(nationalNumber, metadata.nationalNumberPattern()) && matchesEntirely(possibleShorterNationalNumber, metadata.nationalNumberPattern()) || checkNumberLength(nationalNumber, metadata) === 'TOO_LONG') {
	      return {
	        countryCallingCode: countryCallingCode,
	        number: possibleShorterNumber
	      };
	    }
	  }

	  return {
	    number: number
	  };
	}

	/**
	 * Converts a phone number digits (possibly with a `+`)
	 * into a calling code and the rest phone number digits.
	 * The "rest phone number digits" could include
	 * a national prefix, carrier code, and national
	 * (significant) number.
	 * @param  {string} number — Phone number digits (possibly with a `+`).
	 * @param  {string} [country] — Default country.
	 * @param  {string} [callingCode] — Default calling code (some phone numbering plans are non-geographic).
	 * @param  {object} metadata
	 * @return {object} `{ countryCallingCode: string?, number: string }`
	 * @example
	 * // Returns `{ countryCallingCode: "1", number: "2133734253" }`.
	 * extractCountryCallingCode('2133734253', 'US', null, metadata)
	 * extractCountryCallingCode('2133734253', null, '1', metadata)
	 * extractCountryCallingCode('+12133734253', null, null, metadata)
	 * extractCountryCallingCode('+12133734253', 'RU', null, metadata)
	 */

	function extractCountryCallingCode(number, country, callingCode, metadata) {
	  if (!number) {
	    return {};
	  } // If this is not an international phone number,
	  // then either extract an "IDD" prefix, or extract a
	  // country calling code from a number by autocorrecting it
	  // by prepending a leading `+` in cases when it starts
	  // with the country calling code.
	  // https://wikitravel.org/en/International_dialling_prefix
	  // https://github.com/catamphetamine/libphonenumber-js/issues/376


	  if (number[0] !== '+') {
	    // Convert an "out-of-country" dialing phone number
	    // to a proper international phone number.
	    var numberWithoutIDD = stripIddPrefix(number, country, callingCode, metadata); // If an IDD prefix was stripped then
	    // convert the number to international one
	    // for subsequent parsing.

	    if (numberWithoutIDD && numberWithoutIDD !== number) {
	      number = '+' + numberWithoutIDD;
	    } else {
	      // Check to see if the number starts with the country calling code
	      // for the default country. If so, we remove the country calling code,
	      // and do some checks on the validity of the number before and after.
	      // https://github.com/catamphetamine/libphonenumber-js/issues/376
	      if (country || callingCode) {
	        var _extractCountryCallin = extractCountryCallingCodeFromInternationalNumberWithoutPlusSign(number, country, callingCode, metadata),
	            countryCallingCode = _extractCountryCallin.countryCallingCode,
	            shorterNumber = _extractCountryCallin.number;

	        if (countryCallingCode) {
	          return {
	            countryCallingCode: countryCallingCode,
	            number: shorterNumber
	          };
	        }
	      }

	      return {
	        number: number
	      };
	    }
	  } // Fast abortion: country codes do not begin with a '0'


	  if (number[1] === '0') {
	    return {};
	  }

	  metadata = new Metadata(metadata); // The thing with country phone codes
	  // is that they are orthogonal to each other
	  // i.e. there's no such country phone code A
	  // for which country phone code B exists
	  // where B starts with A.
	  // Therefore, while scanning digits,
	  // if a valid country code is found,
	  // that means that it is the country code.
	  //

	  var i = 2;

	  while (i - 1 <= MAX_LENGTH_COUNTRY_CODE && i <= number.length) {
	    var _countryCallingCode = number.slice(1, i);

	    if (metadata.hasCallingCode(_countryCallingCode)) {
	      metadata.selectNumberingPlan(_countryCallingCode);
	      return {
	        countryCallingCode: _countryCallingCode,
	        number: number.slice(i)
	      };
	    }

	    i++;
	  }

	  return {};
	}

	function _createForOfIteratorHelperLoose$6(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) { return (it = it.call(o)).next.bind(it); } if (Array.isArray(o) || (it = _unsupportedIterableToArray$6(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) { o = it; } var i = 0; return function () { if (i >= o.length) { return { done: true }; } return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

	function _unsupportedIterableToArray$6(o, minLen) { if (!o) { return; } if (typeof o === "string") { return _arrayLikeToArray$6(o, minLen); } var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) { n = o.constructor.name; } if (n === "Map" || n === "Set") { return Array.from(o); } if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) { return _arrayLikeToArray$6(o, minLen); } }

	function _arrayLikeToArray$6(arr, len) { if (len == null || len > arr.length) { len = arr.length; } for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	function getCountryByCallingCode(callingCode, nationalPhoneNumber, metadata) {


	  var possibleCountries = metadata.getCountryCodesForCallingCode(callingCode);

	  if (!possibleCountries) {
	    return;
	  } // If there's just one country corresponding to the country code,
	  // then just return it, without further phone number digits validation.


	  if (possibleCountries.length === 1) {
	    return possibleCountries[0];
	  }

	  return selectCountryFromList(possibleCountries, nationalPhoneNumber, metadata.metadata);
	}

	function selectCountryFromList(possibleCountries, nationalPhoneNumber, metadata) {
	  // Re-create `metadata` because it will be selecting a `country`.
	  metadata = new Metadata(metadata);

	  for (var _iterator = _createForOfIteratorHelperLoose$6(possibleCountries), _step; !(_step = _iterator()).done;) {
	    var country = _step.value;
	    metadata.country(country); // Leading digits check would be the simplest and fastest one.
	    // Leading digits patterns are only defined for about 20% of all countries.
	    // https://gitlab.com/catamphetamine/libphonenumber-js/blob/master/METADATA.md#leading_digits
	    // Matching "leading digits" is a sufficient but not necessary condition.

	    if (metadata.leadingDigits()) {
	      if (nationalPhoneNumber && nationalPhoneNumber.search(metadata.leadingDigits()) === 0) {
	        return country;
	      }
	    } // Else perform full validation with all of those
	    // fixed-line/mobile/etc regular expressions.
	    else if (getNumberType({
	      phone: nationalPhoneNumber,
	      country: country
	    }, undefined, metadata.metadata)) {
	      return country;
	    }
	  }
	}

	// This is a port of Google Android `libphonenumber`'s
	// This prevents malicious input from consuming CPU.

	var MAX_INPUT_STRING_LENGTH = 250; // This consists of the plus symbol, digits, and arabic-indic digits.

	var PHONE_NUMBER_START_PATTERN = new RegExp('[' + PLUS_CHARS + VALID_DIGITS + ']'); // Regular expression of trailing characters that we want to remove.
	// A trailing `#` is sometimes used when writing phone numbers with extensions in US.
	// Example: "+1 (645) 123 1234-910#" number has extension "910".

	var AFTER_PHONE_NUMBER_END_PATTERN = new RegExp('[^' + VALID_DIGITS + '#' + ']+$');
	//
	// ```js
	// parse('8 (800) 555-35-35', 'RU')
	// parse('8 (800) 555-35-35', 'RU', metadata)
	// parse('8 (800) 555-35-35', { country: { default: 'RU' } })
	// parse('8 (800) 555-35-35', { country: { default: 'RU' } }, metadata)
	// parse('+7 800 555 35 35')
	// parse('+7 800 555 35 35', metadata)
	// ```
	//

	function parse$3(text, options, metadata) {
	  // If assigning the `{}` default value is moved to the arguments above,
	  // code coverage would decrease for some weird reason.
	  options = options || {};
	  metadata = new Metadata(metadata); // Validate `defaultCountry`.

	  if (options.defaultCountry && !metadata.hasCountry(options.defaultCountry)) {
	    if (options.v2) {
	      throw new ParseError('INVALID_COUNTRY');
	    }

	    throw new Error("Unknown country: ".concat(options.defaultCountry));
	  } // Parse the phone number.


	  var _parseInput = parseInput(text, options.v2, options.extract),
	      formattedPhoneNumber = _parseInput.number,
	      ext = _parseInput.ext,
	      error = _parseInput.error; // If the phone number is not viable then return nothing.


	  if (!formattedPhoneNumber) {
	    if (options.v2) {
	      if (error === 'TOO_SHORT') {
	        throw new ParseError('TOO_SHORT');
	      }

	      throw new ParseError('NOT_A_NUMBER');
	    }

	    return {};
	  }

	  var _parsePhoneNumber = parsePhoneNumber(formattedPhoneNumber, options.defaultCountry, options.defaultCallingCode, metadata),
	      country = _parsePhoneNumber.country,
	      nationalNumber = _parsePhoneNumber.nationalNumber,
	      countryCallingCode = _parsePhoneNumber.countryCallingCode,
	      carrierCode = _parsePhoneNumber.carrierCode;

	  if (!metadata.hasSelectedNumberingPlan()) {
	    if (options.v2) {
	      throw new ParseError('INVALID_COUNTRY');
	    }

	    return {};
	  } // Validate national (significant) number length.


	  if (!nationalNumber || nationalNumber.length < MIN_LENGTH_FOR_NSN) {
	    // Won't throw here because the regexp already demands length > 1.

	    /* istanbul ignore if */
	    if (options.v2) {
	      throw new ParseError('TOO_SHORT');
	    } // Google's demo just throws an error in this case.


	    return {};
	  } // Validate national (significant) number length.
	  //
	  // A sidenote:
	  //
	  // They say that sometimes national (significant) numbers
	  // can be longer than `MAX_LENGTH_FOR_NSN` (e.g. in Germany).
	  // https://github.com/googlei18n/libphonenumber/blob/7e1748645552da39c4e1ba731e47969d97bdb539/resources/phonenumber.proto#L36
	  // Such numbers will just be discarded.
	  //


	  if (nationalNumber.length > MAX_LENGTH_FOR_NSN) {
	    if (options.v2) {
	      throw new ParseError('TOO_LONG');
	    } // Google's demo just throws an error in this case.


	    return {};
	  }

	  if (options.v2) {
	    var phoneNumber = new PhoneNumber(countryCallingCode, nationalNumber, metadata.metadata);

	    if (country) {
	      phoneNumber.country = country;
	    }

	    if (carrierCode) {
	      phoneNumber.carrierCode = carrierCode;
	    }

	    if (ext) {
	      phoneNumber.ext = ext;
	    }

	    return phoneNumber;
	  } // Check if national phone number pattern matches the number.
	  // National number pattern is different for each country,
	  // even for those ones which are part of the "NANPA" group.


	  var valid = (options.extended ? metadata.hasSelectedNumberingPlan() : country) ? matchesEntirely(nationalNumber, metadata.nationalNumberPattern()) : false;

	  if (!options.extended) {
	    return valid ? result(country, nationalNumber, ext) : {};
	  } // isInternational: countryCallingCode !== undefined


	  return {
	    country: country,
	    countryCallingCode: countryCallingCode,
	    carrierCode: carrierCode,
	    valid: valid,
	    possible: valid ? true : options.extended === true && metadata.possibleLengths() && isPossibleNumber(nationalNumber, metadata) ? true : false,
	    phone: nationalNumber,
	    ext: ext
	  };
	}
	/**
	 * Extracts a formatted phone number from text.
	 * Doesn't guarantee that the extracted phone number
	 * is a valid phone number (for example, doesn't validate its length).
	 * @param  {string} text
	 * @param  {boolean} [extract] — If `false`, then will parse the entire `text` as a phone number.
	 * @param  {boolean} [throwOnError] — By default, it won't throw if the text is too long.
	 * @return {string}
	 * @example
	 * // Returns "(213) 373-4253".
	 * extractFormattedPhoneNumber("Call (213) 373-4253 for assistance.")
	 */

	function extractFormattedPhoneNumber(text, extract, throwOnError) {
	  if (!text) {
	    return;
	  }

	  if (text.length > MAX_INPUT_STRING_LENGTH) {
	    if (throwOnError) {
	      throw new ParseError('TOO_LONG');
	    }

	    return;
	  }

	  if (extract === false) {
	    return text;
	  } // Attempt to extract a possible number from the string passed in


	  var startsAt = text.search(PHONE_NUMBER_START_PATTERN);

	  if (startsAt < 0) {
	    return;
	  }

	  return text // Trim everything to the left of the phone number
	  .slice(startsAt) // Remove trailing non-numerical characters
	  .replace(AFTER_PHONE_NUMBER_END_PATTERN, '');
	}
	/**
	 * @param  {string} text - Input.
	 * @param  {boolean} v2 - Legacy API functions don't pass `v2: true` flag.
	 * @param  {boolean} [extract] - Whether to extract a phone number from `text`, or attempt to parse the entire text as a phone number.
	 * @return {object} `{ ?number, ?ext }`.
	 */


	function parseInput(text, v2, extract) {
	  // Parse RFC 3966 phone number URI.
	  if (text && text.indexOf('tel:') === 0) {
	    return parseRFC3966(text);
	  }

	  var number = extractFormattedPhoneNumber(text, extract, v2); // If the phone number is not viable, then abort.

	  if (!number) {
	    return {};
	  }

	  if (!isViablePhoneNumber(number)) {
	    if (isViablePhoneNumberStart(number)) {
	      return {
	        error: 'TOO_SHORT'
	      };
	    }

	    return {};
	  } // Attempt to parse extension first, since it doesn't require region-specific
	  // data and we want to have the non-normalised number here.


	  var withExtensionStripped = extractExtension(number);

	  if (withExtensionStripped.ext) {
	    return withExtensionStripped;
	  }

	  return {
	    number: number
	  };
	}
	/**
	 * Creates `parse()` result object.
	 */


	function result(country, nationalNumber, ext) {
	  var result = {
	    country: country,
	    phone: nationalNumber
	  };

	  if (ext) {
	    result.ext = ext;
	  }

	  return result;
	}
	/**
	 * Parses a viable phone number.
	 * @param {string} formattedPhoneNumber — Example: "(213) 373-4253".
	 * @param {string} [defaultCountry]
	 * @param {string} [defaultCallingCode]
	 * @param {Metadata} metadata
	 * @return {object} Returns `{ country: string?, countryCallingCode: string?, nationalNumber: string? }`.
	 */


	function parsePhoneNumber(formattedPhoneNumber, defaultCountry, defaultCallingCode, metadata) {
	  // Extract calling code from phone number.
	  var _extractCountryCallin = extractCountryCallingCode(parseIncompletePhoneNumber(formattedPhoneNumber), defaultCountry, defaultCallingCode, metadata.metadata),
	      countryCallingCode = _extractCountryCallin.countryCallingCode,
	      number = _extractCountryCallin.number; // Choose a country by `countryCallingCode`.


	  var country;

	  if (countryCallingCode) {
	    metadata.selectNumberingPlan(countryCallingCode);
	  } // If `formattedPhoneNumber` is in "national" format
	  // then `number` is defined and `countryCallingCode` isn't.
	  else if (number && (defaultCountry || defaultCallingCode)) {
	    metadata.selectNumberingPlan(defaultCountry, defaultCallingCode);

	    if (defaultCountry) {
	      country = defaultCountry;
	    }

	    countryCallingCode = defaultCallingCode || getCountryCallingCode(defaultCountry, metadata.metadata);
	  } else { return {}; }

	  if (!number) {
	    return {
	      countryCallingCode: countryCallingCode
	    };
	  }

	  var _extractNationalNumbe = extractNationalNumber(parseIncompletePhoneNumber(number), metadata),
	      nationalNumber = _extractNationalNumbe.nationalNumber,
	      carrierCode = _extractNationalNumbe.carrierCode; // Sometimes there are several countries
	  // corresponding to the same country phone code
	  // (e.g. NANPA countries all having `1` country phone code).
	  // Therefore, to reliably determine the exact country,
	  // national (significant) number should have been parsed first.
	  //
	  // When `metadata.json` is generated, all "ambiguous" country phone codes
	  // get their countries populated with the full set of
	  // "phone number type" regular expressions.
	  //


	  var exactCountry = getCountryByCallingCode(countryCallingCode, nationalNumber, metadata);

	  if (exactCountry) {
	    country = exactCountry;
	    /* istanbul ignore if */

	    if (exactCountry === '001') ; else {
	      metadata.country(country);
	    }
	  }

	  return {
	    country: country,
	    countryCallingCode: countryCallingCode,
	    nationalNumber: nationalNumber,
	    carrierCode: carrierCode
	  };
	}

	function _defineProperties$3(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) { descriptor.writable = true; } Object.defineProperty(target, descriptor.key, descriptor); } }

	function _createClass$3(Constructor, protoProps, staticProps) { if (protoProps) { _defineProperties$3(Constructor.prototype, protoProps); } if (staticProps) { _defineProperties$3(Constructor, staticProps); } Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

	function _classCallCheck$3(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	// https://medium.com/dsinjs/implementing-lru-cache-in-javascript-94ba6755cda9
	var Node = /*#__PURE__*/_createClass$3(function Node(key, value) {
	  var next = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	  var prev = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

	  _classCallCheck$3(this, Node);

	  this.key = key;
	  this.value = value;
	  this.next = next;
	  this.prev = prev;
	});

	var LRUCache = /*#__PURE__*/function () {
	  //set default limit of 10 if limit is not passed.
	  function LRUCache() {
	    var limit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;

	    _classCallCheck$3(this, LRUCache);

	    this.size = 0;
	    this.limit = limit;
	    this.head = null;
	    this.tail = null;
	    this.cache = {};
	  } // Write Node to head of LinkedList
	  // update cache with Node key and Node reference


	  _createClass$3(LRUCache, [{
	    key: "put",
	    value: function put(key, value) {
	      this.ensureLimit();

	      if (!this.head) {
	        this.head = this.tail = new Node(key, value);
	      } else {
	        var node = new Node(key, value, this.head);
	        this.head.prev = node;
	        this.head = node;
	      } //Update the cache map


	      this.cache[key] = this.head;
	      this.size++;
	    } // Read from cache map and make that node as new Head of LinkedList

	  }, {
	    key: "get",
	    value: function get(key) {
	      if (this.cache[key]) {
	        var value = this.cache[key].value; // node removed from it's position and cache

	        this.remove(key); // write node again to the head of LinkedList to make it most recently used

	        this.put(key, value);
	        return value;
	      }

	      console.log("Item not available in cache for key ".concat(key));
	    }
	  }, {
	    key: "ensureLimit",
	    value: function ensureLimit() {
	      if (this.size === this.limit) {
	        this.remove(this.tail.key);
	      }
	    }
	  }, {
	    key: "remove",
	    value: function remove(key) {
	      var node = this.cache[key];

	      if (node.prev !== null) {
	        node.prev.next = node.next;
	      } else {
	        this.head = node.next;
	      }

	      if (node.next !== null) {
	        node.next.prev = node.prev;
	      } else {
	        this.tail = node.prev;
	      }

	      delete this.cache[key];
	      this.size--;
	    }
	  }, {
	    key: "clear",
	    value: function clear() {
	      this.head = null;
	      this.tail = null;
	      this.size = 0;
	      this.cache = {};
	    } // // Invokes the callback function with every node of the chain and the index of the node.
	    // forEach(fn) {
	    //   let node = this.head;
	    //   let counter = 0;
	    //   while (node) {
	    //     fn(node, counter);
	    //     node = node.next;
	    //     counter++;
	    //   }
	    // }
	    // // To iterate over LRU with a 'for...of' loop
	    // *[Symbol.iterator]() {
	    //   let node = this.head;
	    //   while (node) {
	    //     yield node;
	    //     node = node.next;
	    //   }
	    // }

	  }]);

	  return LRUCache;
	}();

	function _classCallCheck$4(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _defineProperties$4(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) { descriptor.writable = true; } Object.defineProperty(target, descriptor.key, descriptor); } }

	function _createClass$4(Constructor, protoProps, staticProps) { if (protoProps) { _defineProperties$4(Constructor.prototype, protoProps); } if (staticProps) { _defineProperties$4(Constructor, staticProps); } Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
	// countries being used for the same doc with ~10 patterns for each country. Some pages will have
	// a lot more countries in use, but typically fewer numbers for each so expanding the cache for
	// that use-case won't have a lot of benefit.

	var RegExpCache = /*#__PURE__*/function () {
	  function RegExpCache(size) {
	    _classCallCheck$4(this, RegExpCache);

	    this.cache = new LRUCache(size);
	  }

	  _createClass$4(RegExpCache, [{
	    key: "getPatternForRegExp",
	    value: function getPatternForRegExp(pattern) {
	      var regExp = this.cache.get(pattern);

	      if (!regExp) {
	        regExp = new RegExp('^' + pattern);
	        this.cache.put(pattern, regExp);
	      }

	      return regExp;
	    }
	  }]);

	  return RegExpCache;
	}();

	/** Returns a regular expression quantifier with an upper and lower limit. */
	function limit(lower, upper) {
	  if (lower < 0 || upper <= 0 || upper < lower) {
	    throw new TypeError();
	  }

	  return "{".concat(lower, ",").concat(upper, "}");
	}
	/**
	 * Trims away any characters after the first match of {@code pattern} in {@code candidate},
	 * returning the trimmed version.
	 */

	function trimAfterFirstMatch(regexp, string) {
	  var index = string.search(regexp);

	  if (index >= 0) {
	    return string.slice(0, index);
	  }

	  return string;
	}
	function startsWith(string, substring) {
	  return string.indexOf(substring) === 0;
	}
	function endsWith(string, substring) {
	  return string.indexOf(substring, string.length - substring.length) === string.length - substring.length;
	}

	// Javascript doesn't support UTF-8 regular expressions.
	// So mimicking them here.
	// Copy-pasted from `PhoneNumberMatcher.js`.

	/**
	 * "\p{Z}" is any kind of whitespace or invisible separator ("Separator").
	 * http://www.regular-expressions.info/unicode.html
	 * "\P{Z}" is the reverse of "\p{Z}".
	 * "\p{N}" is any kind of numeric character in any script ("Number").
	 * "\p{Nd}" is a digit zero through nine in any script except "ideographic scripts" ("Decimal_Digit_Number").
	 * "\p{Sc}" is a currency symbol ("Currency_Symbol").
	 * "\p{L}" is any kind of letter from any language ("Letter").
	 * "\p{Mn}" is "non-spacing mark".
	 *
	 * Javascript doesn't support Unicode Regular Expressions
	 * so substituting it with this explicit set of characters.
	 *
	 * https://stackoverflow.com/questions/13210194/javascript-regex-equivalent-of-a-za-z-using-pl
	 * https://github.com/danielberndt/babel-plugin-utf-8-regex/blob/master/src/transformer.js
	 */
	var _pZ = " \xA0\u1680\u180E\u2000-\u200A\u2028\u2029\u202F\u205F\u3000";
	var pZ = "[".concat(_pZ, "]");
	var PZ = "[^".concat(_pZ, "]");
	var _pN = "0-9\xB2\xB3\xB9\xBC-\xBE\u0660-\u0669\u06F0-\u06F9\u07C0-\u07C9\u0966-\u096F\u09E6-\u09EF\u09F4-\u09F9\u0A66-\u0A6F\u0AE6-\u0AEF\u0B66-\u0B6F\u0B72-\u0B77\u0BE6-\u0BF2\u0C66-\u0C6F\u0C78-\u0C7E\u0CE6-\u0CEF\u0D66-\u0D75\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F33\u1040-\u1049\u1090-\u1099\u1369-\u137C\u16EE-\u16F0\u17E0-\u17E9\u17F0-\u17F9\u1810-\u1819\u1946-\u194F\u19D0-\u19DA\u1A80-\u1A89\u1A90-\u1A99\u1B50-\u1B59\u1BB0-\u1BB9\u1C40-\u1C49\u1C50-\u1C59\u2070\u2074-\u2079\u2080-\u2089\u2150-\u2182\u2185-\u2189\u2460-\u249B\u24EA-\u24FF\u2776-\u2793\u2CFD\u3007\u3021-\u3029\u3038-\u303A\u3192-\u3195\u3220-\u3229\u3248-\u324F\u3251-\u325F\u3280-\u3289\u32B1-\u32BF\uA620-\uA629\uA6E6-\uA6EF\uA830-\uA835\uA8D0-\uA8D9\uA900-\uA909\uA9D0-\uA9D9\uAA50-\uAA59\uABF0-\uABF9\uFF10-\uFF19"; // const pN = `[${_pN}]`

	var _pNd = "0-9\u0660-\u0669\u06F0-\u06F9\u07C0-\u07C9\u0966-\u096F\u09E6-\u09EF\u0A66-\u0A6F\u0AE6-\u0AEF\u0B66-\u0B6F\u0BE6-\u0BEF\u0C66-\u0C6F\u0CE6-\u0CEF\u0D66-\u0D6F\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F29\u1040-\u1049\u1090-\u1099\u17E0-\u17E9\u1810-\u1819\u1946-\u194F\u19D0-\u19D9\u1A80-\u1A89\u1A90-\u1A99\u1B50-\u1B59\u1BB0-\u1BB9\u1C40-\u1C49\u1C50-\u1C59\uA620-\uA629\uA8D0-\uA8D9\uA900-\uA909\uA9D0-\uA9D9\uAA50-\uAA59\uABF0-\uABF9\uFF10-\uFF19";
	var pNd = "[".concat(_pNd, "]");
	var _pL = "A-Za-z\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u0527\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0\u08A2-\u08AC\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0977\u0979-\u097F\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C33\u0C35-\u0C39\u0C3D\u0C58\u0C59\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D60\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F4\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191C\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19C1-\u19C7\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FCC\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA697\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA78E\uA790-\uA793\uA7A0-\uA7AA\uA7F8-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA80-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uABC0-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC";
	var pL = "[".concat(_pL, "]");
	var pL_regexp = new RegExp(pL);
	var _pSc = "$\xA2-\xA5\u058F\u060B\u09F2\u09F3\u09FB\u0AF1\u0BF9\u0E3F\u17DB\u20A0-\u20B9\uA838\uFDFC\uFE69\uFF04\uFFE0\uFFE1\uFFE5\uFFE6";
	var pSc = "[".concat(_pSc, "]");
	var pSc_regexp = new RegExp(pSc);
	var _pMn = "\u0300-\u036F\u0483-\u0487\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u0711\u0730-\u074A\u07A6-\u07B0\u07EB-\u07F3\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u08E4-\u08FE\u0900-\u0902\u093A\u093C\u0941-\u0948\u094D\u0951-\u0957\u0962\u0963\u0981\u09BC\u09C1-\u09C4\u09CD\u09E2\u09E3\u0A01\u0A02\u0A3C\u0A41\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A70\u0A71\u0A75\u0A81\u0A82\u0ABC\u0AC1-\u0AC5\u0AC7\u0AC8\u0ACD\u0AE2\u0AE3\u0B01\u0B3C\u0B3F\u0B41-\u0B44\u0B4D\u0B56\u0B62\u0B63\u0B82\u0BC0\u0BCD\u0C3E-\u0C40\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0CBC\u0CBF\u0CC6\u0CCC\u0CCD\u0CE2\u0CE3\u0D41-\u0D44\u0D4D\u0D62\u0D63\u0DCA\u0DD2-\u0DD4\u0DD6\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0EB1\u0EB4-\u0EB9\u0EBB\u0EBC\u0EC8-\u0ECD\u0F18\u0F19\u0F35\u0F37\u0F39\u0F71-\u0F7E\u0F80-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102D-\u1030\u1032-\u1037\u1039\u103A\u103D\u103E\u1058\u1059\u105E-\u1060\u1071-\u1074\u1082\u1085\u1086\u108D\u109D\u135D-\u135F\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17B4\u17B5\u17B7-\u17BD\u17C6\u17C9-\u17D3\u17DD\u180B-\u180D\u18A9\u1920-\u1922\u1927\u1928\u1932\u1939-\u193B\u1A17\u1A18\u1A56\u1A58-\u1A5E\u1A60\u1A62\u1A65-\u1A6C\u1A73-\u1A7C\u1A7F\u1B00-\u1B03\u1B34\u1B36-\u1B3A\u1B3C\u1B42\u1B6B-\u1B73\u1B80\u1B81\u1BA2-\u1BA5\u1BA8\u1BA9\u1BAB\u1BE6\u1BE8\u1BE9\u1BED\u1BEF-\u1BF1\u1C2C-\u1C33\u1C36\u1C37\u1CD0-\u1CD2\u1CD4-\u1CE0\u1CE2-\u1CE8\u1CED\u1CF4\u1DC0-\u1DE6\u1DFC-\u1DFF\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302D\u3099\u309A\uA66F\uA674-\uA67D\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA825\uA826\uA8C4\uA8E0-\uA8F1\uA926-\uA92D\uA947-\uA951\uA980-\uA982\uA9B3\uA9B6-\uA9B9\uA9BC\uAA29-\uAA2E\uAA31\uAA32\uAA35\uAA36\uAA43\uAA4C\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEC\uAAED\uAAF6\uABE5\uABE8\uABED\uFB1E\uFE00-\uFE0F\uFE20-\uFE26";
	var pMn = "[".concat(_pMn, "]");
	var pMn_regexp = new RegExp(pMn);
	var _InBasic_Latin = "\0-\x7F";
	var _InLatin_1_Supplement = "\x80-\xFF";
	var _InLatin_Extended_A = "\u0100-\u017F";
	var _InLatin_Extended_Additional = "\u1E00-\u1EFF";
	var _InLatin_Extended_B = "\u0180-\u024F";
	var _InCombining_Diacritical_Marks = "\u0300-\u036F";
	var latinLetterRegexp = new RegExp('[' + _InBasic_Latin + _InLatin_1_Supplement + _InLatin_Extended_A + _InLatin_Extended_Additional + _InLatin_Extended_B + _InCombining_Diacritical_Marks + ']');
	/**
	 * Helper method to determine if a character is a Latin-script letter or not.
	 * For our purposes, combining marks should also return true since we assume
	 * they have been added to a preceding Latin character.
	 */

	function isLatinLetter(letter) {
	  // Combining marks are a subset of non-spacing-mark.
	  if (!pL_regexp.test(letter) && !pMn_regexp.test(letter)) {
	    return false;
	  }

	  return latinLetterRegexp.test(letter);
	}
	function isInvalidPunctuationSymbol(character) {
	  return character === '%' || pSc_regexp.test(character);
	}

	function _createForOfIteratorHelperLoose$7(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) { return (it = it.call(o)).next.bind(it); } if (Array.isArray(o) || (it = _unsupportedIterableToArray$8(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) { o = it; } var i = 0; return function () { if (i >= o.length) { return { done: true }; } return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

	function _unsupportedIterableToArray$8(o, minLen) { if (!o) { return; } if (typeof o === "string") { return _arrayLikeToArray$8(o, minLen); } var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) { n = o.constructor.name; } if (n === "Map" || n === "Set") { return Array.from(o); } if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) { return _arrayLikeToArray$8(o, minLen); } }

	function _arrayLikeToArray$8(arr, len) { if (len == null || len > arr.length) { len = arr.length; } for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	/**
	 * Leniency when finding potential phone numbers in text segments
	 * The levels here are ordered in increasing strictness.
	 */

	var Leniency = {
	  /**
	   * Phone numbers accepted are "possible", but not necessarily "valid".
	   */
	  POSSIBLE: function POSSIBLE(number, candidate, metadata) {
	    return true;
	  },

	  /**
	   * Phone numbers accepted are "possible" and "valid".
	   * Numbers written in national format must have their national-prefix
	   * present if it is usually written for a number of this type.
	   */
	  VALID: function VALID(number, candidate, metadata) {
	    if (!isValidNumber(number, undefined, metadata) || !containsOnlyValidXChars(number, candidate.toString(), metadata)) {
	      return false;
	    } // Skipped for simplicity.
	    // return isNationalPrefixPresentIfRequired(number, metadata)


	    return true;
	  },

	  /**
	   * Phone numbers accepted are "valid" and
	   * are grouped in a possible way for this locale. For example, a US number written as
	   * "65 02 53 00 00" and "650253 0000" are not accepted at this leniency level, whereas
	   * "650 253 0000", "650 2530000" or "6502530000" are.
	   * Numbers with more than one '/' symbol in the national significant number
	   * are also dropped at this level.
	   *
	   * Warning: This level might result in lower coverage especially for regions outside of
	   * country code "+1". If you are not sure about which level to use,
	   * email the discussion group libphonenumber-discuss@googlegroups.com.
	   */
	  STRICT_GROUPING: function STRICT_GROUPING(number, candidate, metadata, regExpCache) {
	    var candidateString = candidate.toString();

	    if (!isValidNumber(number, undefined, metadata) || !containsOnlyValidXChars(number, candidateString, metadata) || containsMoreThanOneSlashInNationalNumber(number, candidateString) || !isNationalPrefixPresentIfRequired(number, metadata)) {
	      return false;
	    }

	    return checkNumberGroupingIsValid(number, candidate, metadata, allNumberGroupsRemainGrouped, regExpCache);
	  },

	  /**
	   * Phone numbers accepted are {@linkplain PhoneNumberUtil#isValidNumber(PhoneNumber) valid} and
	   * are grouped in the same way that we would have formatted it, or as a single block. For
	   * example, a US number written as "650 2530000" is not accepted at this leniency level, whereas
	   * "650 253 0000" or "6502530000" are.
	   * Numbers with more than one '/' symbol are also dropped at this level.
	   * <p>
	   * Warning: This level might result in lower coverage especially for regions outside of country
	   * code "+1". If you are not sure about which level to use, email the discussion group
	   * libphonenumber-discuss@googlegroups.com.
	   */
	  EXACT_GROUPING: function EXACT_GROUPING(number, candidate, metadata, regExpCache) {
	    var candidateString = candidate.toString();

	    if (!isValidNumber(number, undefined, metadata) || !containsOnlyValidXChars(number, candidateString, metadata) || containsMoreThanOneSlashInNationalNumber(number, candidateString) || !isNationalPrefixPresentIfRequired(number, metadata)) {
	      return false;
	    }

	    return checkNumberGroupingIsValid(number, candidate, metadata, allNumberGroupsAreExactlyPresent, regExpCache);
	  }
	};

	function containsOnlyValidXChars(number, candidate, metadata) {
	  // The characters 'x' and 'X' can be (1) a carrier code, in which case they always precede the
	  // national significant number or (2) an extension sign, in which case they always precede the
	  // extension number. We assume a carrier code is more than 1 digit, so the first case has to
	  // have more than 1 consecutive 'x' or 'X', whereas the second case can only have exactly 1 'x'
	  // or 'X'. We ignore the character if it appears as the last character of the string.
	  for (var index = 0; index < candidate.length - 1; index++) {
	    var charAtIndex = candidate.charAt(index);

	    if (charAtIndex === 'x' || charAtIndex === 'X') {
	      var charAtNextIndex = candidate.charAt(index + 1);

	      if (charAtNextIndex === 'x' || charAtNextIndex === 'X') {
	        // This is the carrier code case, in which the 'X's always precede the national
	        // significant number.
	        index++;

	        if (util.isNumberMatch(number, candidate.substring(index)) != MatchType.NSN_MATCH) {
	          return false;
	        } // This is the extension sign case, in which the 'x' or 'X' should always precede the
	        // extension number.

	      } else if (parseDigits(candidate.substring(index)) !== number.ext) {
	        return false;
	      }
	    }
	  }

	  return true;
	}

	function isNationalPrefixPresentIfRequired(number, _metadata) {
	  // First, check how we deduced the country code. If it was written in international format, then
	  // the national prefix is not required.
	  if (number.getCountryCodeSource() != 'FROM_DEFAULT_COUNTRY') {
	    return true;
	  }

	  var phoneNumberRegion = util.getRegionCodeForCountryCode(number.getCountryCode());
	  var metadata = util.getMetadataForRegion(phoneNumberRegion);

	  if (metadata == null) {
	    return true;
	  } // Check if a national prefix should be present when formatting this number.


	  var nationalNumber = util.getNationalSignificantNumber(number);
	  var formatRule = util.chooseFormattingPatternForNumber(metadata.numberFormats(), nationalNumber); // To do this, we check that a national prefix formatting rule was present
	  // and that it wasn't just the first-group symbol ($1) with punctuation.

	  if (formatRule && formatRule.getNationalPrefixFormattingRule().length > 0) {
	    if (formatRule.getNationalPrefixOptionalWhenFormatting()) {
	      // The national-prefix is optional in these cases, so we don't need to check if it was
	      // present.
	      return true;
	    }

	    if (PhoneNumberUtil.formattingRuleHasFirstGroupOnly(formatRule.getNationalPrefixFormattingRule())) {
	      // National Prefix not needed for this number.
	      return true;
	    } // Normalize the remainder.


	    var rawInputCopy = PhoneNumberUtil.normalizeDigitsOnly(number.getRawInput()); // Check if we found a national prefix and/or carrier code at the start of the raw input, and
	    // return the result.

	    return util.maybeStripNationalPrefixAndCarrierCode(rawInputCopy, metadata, null);
	  }

	  return true;
	}

	function containsMoreThanOneSlashInNationalNumber(number, candidate) {
	  var firstSlashInBodyIndex = candidate.indexOf('/');

	  if (firstSlashInBodyIndex < 0) {
	    // No slashes, this is okay.
	    return false;
	  } // Now look for a second one.


	  var secondSlashInBodyIndex = candidate.indexOf('/', firstSlashInBodyIndex + 1);

	  if (secondSlashInBodyIndex < 0) {
	    // Only one slash, this is okay.
	    return false;
	  } // If the first slash is after the country calling code, this is permitted.


	  var candidateHasCountryCode = number.getCountryCodeSource() === CountryCodeSource.FROM_NUMBER_WITH_PLUS_SIGN || number.getCountryCodeSource() === CountryCodeSource.FROM_NUMBER_WITHOUT_PLUS_SIGN;

	  if (candidateHasCountryCode && PhoneNumberUtil.normalizeDigitsOnly(candidate.substring(0, firstSlashInBodyIndex)) === String(number.getCountryCode())) {
	    // Any more slashes and this is illegal.
	    return candidate.slice(secondSlashInBodyIndex + 1).indexOf('/') >= 0;
	  }

	  return true;
	}

	function checkNumberGroupingIsValid(number, candidate, metadata, checkGroups, regExpCache) {
	  var normalizedCandidate = normalizeDigits(candidate, true
	  /* keep non-digits */
	  );
	  var formattedNumberGroups = getNationalNumberGroups(metadata, number, null);

	  if (checkGroups(metadata, number, normalizedCandidate, formattedNumberGroups)) {
	    return true;
	  } // If this didn't pass, see if there are any alternate formats that match, and try them instead.


	  var alternateFormats = MetadataManager.getAlternateFormatsForCountry(number.getCountryCode());
	  var nationalSignificantNumber = util.getNationalSignificantNumber(number);

	  if (alternateFormats) {
	    for (var _iterator = _createForOfIteratorHelperLoose$7(alternateFormats.numberFormats()), _step; !(_step = _iterator()).done;) {
	      var alternateFormat = _step.value;

	      if (alternateFormat.leadingDigitsPatterns().length > 0) {
	        // There is only one leading digits pattern for alternate formats.
	        var leadingDigitsRegExp = regExpCache.getPatternForRegExp('^' + alternateFormat.leadingDigitsPatterns()[0]);

	        if (!leadingDigitsRegExp.test(nationalSignificantNumber)) {
	          // Leading digits don't match; try another one.
	          continue;
	        }
	      }

	      formattedNumberGroups = getNationalNumberGroups(metadata, number, alternateFormat);

	      if (checkGroups(metadata, number, normalizedCandidate, formattedNumberGroups)) {
	        return true;
	      }
	    }
	  }

	  return false;
	}
	/**
	 * Helper method to get the national-number part of a number, formatted without any national
	 * prefix, and return it as a set of digit blocks that would be formatted together following
	 * standard formatting rules.
	 */


	function getNationalNumberGroups(metadata, number, formattingPattern) {
	  if (formattingPattern) {
	    // We format the NSN only, and split that according to the separator.
	    var nationalSignificantNumber = util.getNationalSignificantNumber(number);
	    return util.formatNsnUsingPattern(nationalSignificantNumber, formattingPattern, 'RFC3966', metadata).split('-');
	  } // This will be in the format +CC-DG1-DG2-DGX;ext=EXT where DG1..DGX represents groups of digits.


	  var rfc3966Format = formatNumber(number, 'RFC3966', metadata); // We remove the extension part from the formatted string before splitting it into different
	  // groups.

	  var endIndex = rfc3966Format.indexOf(';');

	  if (endIndex < 0) {
	    endIndex = rfc3966Format.length;
	  } // The country-code will have a '-' following it.


	  var startIndex = rfc3966Format.indexOf('-') + 1;
	  return rfc3966Format.slice(startIndex, endIndex).split('-');
	}

	function allNumberGroupsAreExactlyPresent(metadata, number, normalizedCandidate, formattedNumberGroups) {
	  var candidateGroups = normalizedCandidate.split(NON_DIGITS_PATTERN); // Set this to the last group, skipping it if the number has an extension.

	  var candidateNumberGroupIndex = number.hasExtension() ? candidateGroups.length - 2 : candidateGroups.length - 1; // First we check if the national significant number is formatted as a block.
	  // We use contains and not equals, since the national significant number may be present with
	  // a prefix such as a national number prefix, or the country code itself.

	  if (candidateGroups.length == 1 || candidateGroups[candidateNumberGroupIndex].contains(util.getNationalSignificantNumber(number))) {
	    return true;
	  } // Starting from the end, go through in reverse, excluding the first group, and check the
	  // candidate and number groups are the same.


	  var formattedNumberGroupIndex = formattedNumberGroups.length - 1;

	  while (formattedNumberGroupIndex > 0 && candidateNumberGroupIndex >= 0) {
	    if (candidateGroups[candidateNumberGroupIndex] !== formattedNumberGroups[formattedNumberGroupIndex]) {
	      return false;
	    }

	    formattedNumberGroupIndex--;
	    candidateNumberGroupIndex--;
	  } // Now check the first group. There may be a national prefix at the start, so we only check
	  // that the candidate group ends with the formatted number group.


	  return candidateNumberGroupIndex >= 0 && endsWith(candidateGroups[candidateNumberGroupIndex], formattedNumberGroups[0]);
	}

	function allNumberGroupsRemainGrouped(metadata, number, normalizedCandidate, formattedNumberGroups) {
	  var fromIndex = 0;

	  if (number.getCountryCodeSource() !== CountryCodeSource.FROM_DEFAULT_COUNTRY) {
	    // First skip the country code if the normalized candidate contained it.
	    var countryCode = String(number.getCountryCode());
	    fromIndex = normalizedCandidate.indexOf(countryCode) + countryCode.length();
	  } // Check each group of consecutive digits are not broken into separate groupings in the
	  // {@code normalizedCandidate} string.


	  for (var i = 0; i < formattedNumberGroups.length; i++) {
	    // Fails if the substring of {@code normalizedCandidate} starting from {@code fromIndex}
	    // doesn't contain the consecutive digits in formattedNumberGroups[i].
	    fromIndex = normalizedCandidate.indexOf(formattedNumberGroups[i], fromIndex);

	    if (fromIndex < 0) {
	      return false;
	    } // Moves {@code fromIndex} forward.


	    fromIndex += formattedNumberGroups[i].length();

	    if (i == 0 && fromIndex < normalizedCandidate.length()) {
	      // We are at the position right after the NDC. We get the region used for formatting
	      // information based on the country code in the phone number, rather than the number itself,
	      // as we do not need to distinguish between different countries with the same country
	      // calling code and this is faster.
	      var region = util.getRegionCodeForCountryCode(number.getCountryCode());

	      if (util.getNddPrefixForRegion(region, true) != null && Character.isDigit(normalizedCandidate.charAt(fromIndex))) {
	        // This means there is no formatting symbol after the NDC. In this case, we only
	        // accept the number if there is no formatting symbol at all in the number, except
	        // for extensions. This is only important for countries with national prefixes.
	        var nationalSignificantNumber = util.getNationalSignificantNumber(number);
	        return startsWith(normalizedCandidate.slice(fromIndex - formattedNumberGroups[i].length), nationalSignificantNumber);
	      }
	    }
	  } // The check here makes sure that we haven't mistakenly already used the extension to
	  // match the last group of the subscriber number. Note the extension cannot have
	  // formatting in-between digits.


	  return normalizedCandidate.slice(fromIndex).contains(number.getExtension());
	}

	// of parsing. This allows us to strip off parts of the number that are actually the start of
	// another number, such as for: (530) 583-6985 x302/x2303 -> the second extension here makes this
	// actually two phone numbers, (530) 583-6985 x302 and (530) 583-6985 x2303. We remove the second
	// extension so that the first number is parsed correctly.
	//
	// Matches a slash (\ or /) followed by a space followed by an `x`.
	//

	var SECOND_NUMBER_START_PATTERN = /[\\/] *x/;
	function parsePreCandidate(candidate) {
	  // Check for extra numbers at the end.
	  // TODO: This is the place to start when trying to support extraction of multiple phone number
	  // from split notations (+41 79 123 45 67 / 68).
	  return trimAfterFirstMatch(SECOND_NUMBER_START_PATTERN, candidate);
	}

	// Matches strings that look like dates using "/" as a separator.
	// Examples: 3/10/2011, 31/10/96 or 08/31/95.
	var SLASH_SEPARATED_DATES = /(?:(?:[0-3]?\d\/[01]?\d)|(?:[01]?\d\/[0-3]?\d))\/(?:[12]\d)?\d{2}/; // Matches timestamps.
	// Examples: "2012-01-02 08:00".
	// Note that the reg-ex does not include the
	// trailing ":\d\d" -- that is covered by TIME_STAMPS_SUFFIX.

	var TIME_STAMPS = /[12]\d{3}[-/]?[01]\d[-/]?[0-3]\d +[0-2]\d$/;
	var TIME_STAMPS_SUFFIX_LEADING = /^:[0-5]\d/;
	function isValidPreCandidate(candidate, offset, text) {
	  // Skip a match that is more likely to be a date.
	  if (SLASH_SEPARATED_DATES.test(candidate)) {
	    return false;
	  } // Skip potential time-stamps.


	  if (TIME_STAMPS.test(candidate)) {
	    var followingText = text.slice(offset + candidate.length);

	    if (TIME_STAMPS_SUFFIX_LEADING.test(followingText)) {
	      return false;
	    }
	  }

	  return true;
	}

	// Copy-pasted from `PhoneNumberMatcher.js`.
	var OPENING_PARENS = "(\\[\uFF08\uFF3B";
	var CLOSING_PARENS = ")\\]\uFF09\uFF3D";
	var NON_PARENS = "[^".concat(OPENING_PARENS).concat(CLOSING_PARENS, "]");
	var LEAD_CLASS = "[".concat(OPENING_PARENS).concat(PLUS_CHARS, "]"); // Punctuation that may be at the start of a phone number - brackets and plus signs.

	var LEAD_CLASS_LEADING = new RegExp('^' + LEAD_CLASS); // Limit on the number of pairs of brackets in a phone number.

	var BRACKET_PAIR_LIMIT = limit(0, 3);
	/**
	 * Pattern to check that brackets match. Opening brackets should be closed within a phone number.
	 * This also checks that there is something inside the brackets. Having no brackets at all is also
	 * fine.
	 *
	 * An opening bracket at the beginning may not be closed, but subsequent ones should be.  It's
	 * also possible that the leading bracket was dropped, so we shouldn't be surprised if we see a
	 * closing bracket first. We limit the sets of brackets in a phone number to four.
	 */

	var MATCHING_BRACKETS_ENTIRE = new RegExp('^' + "(?:[" + OPENING_PARENS + "])?" + "(?:" + NON_PARENS + "+" + "[" + CLOSING_PARENS + "])?" + NON_PARENS + "+" + "(?:[" + OPENING_PARENS + "]" + NON_PARENS + "+[" + CLOSING_PARENS + "])" + BRACKET_PAIR_LIMIT + NON_PARENS + "*" + '$');
	/**
	 * Matches strings that look like publication pages. Example:
	 * <pre>Computing Complete Answers to Queries in the Presence of Limited Access Patterns.
	 * Chen Li. VLDB J. 12(3): 211-227 (2003).</pre>
	 *
	 * The string "211-227 (2003)" is not a telephone number.
	 */

	var PUB_PAGES = /\d{1,5}-+\d{1,5}\s{0,4}\(\d{1,4}/;
	function isValidCandidate(candidate, offset, text, leniency) {
	  // Check the candidate doesn't contain any formatting
	  // which would indicate that it really isn't a phone number.
	  if (!MATCHING_BRACKETS_ENTIRE.test(candidate) || PUB_PAGES.test(candidate)) {
	    return;
	  } // If leniency is set to VALID or stricter, we also want to skip numbers that are surrounded
	  // by Latin alphabetic characters, to skip cases like abc8005001234 or 8005001234def.


	  if (leniency !== 'POSSIBLE') {
	    // If the candidate is not at the start of the text,
	    // and does not start with phone-number punctuation,
	    // check the previous character.
	    if (offset > 0 && !LEAD_CLASS_LEADING.test(candidate)) {
	      var previousChar = text[offset - 1]; // We return null if it is a latin letter or an invalid punctuation symbol.

	      if (isInvalidPunctuationSymbol(previousChar) || isLatinLetter(previousChar)) {
	        return false;
	      }
	    }

	    var lastCharIndex = offset + candidate.length;

	    if (lastCharIndex < text.length) {
	      var nextChar = text[lastCharIndex];

	      if (isInvalidPunctuationSymbol(nextChar) || isLatinLetter(nextChar)) {
	        return false;
	      }
	    }
	  }

	  return true;
	}

	function _createForOfIteratorHelperLoose$8(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) { return (it = it.call(o)).next.bind(it); } if (Array.isArray(o) || (it = _unsupportedIterableToArray$9(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) { o = it; } var i = 0; return function () { if (i >= o.length) { return { done: true }; } return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

	function _unsupportedIterableToArray$9(o, minLen) { if (!o) { return; } if (typeof o === "string") { return _arrayLikeToArray$9(o, minLen); } var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) { n = o.constructor.name; } if (n === "Map" || n === "Set") { return Array.from(o); } if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) { return _arrayLikeToArray$9(o, minLen); } }

	function _arrayLikeToArray$9(arr, len) { if (len == null || len > arr.length) { len = arr.length; } for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

	function ownKeys$8(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

	function _objectSpread$8(target) {
	var arguments$1 = arguments;
	 for (var i = 1; i < arguments.length; i++) { var source = null != arguments$1[i] ? arguments$1[i] : {}; i % 2 ? ownKeys$8(Object(source), !0).forEach(function (key) { _defineProperty$8(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$8(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

	function _defineProperty$8(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

	function _classCallCheck$5(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _defineProperties$5(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) { descriptor.writable = true; } Object.defineProperty(target, descriptor.key, descriptor); } }

	function _createClass$5(Constructor, protoProps, staticProps) { if (protoProps) { _defineProperties$5(Constructor.prototype, protoProps); } if (staticProps) { _defineProperties$5(Constructor, staticProps); } Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
	var EXTN_PATTERNS_FOR_MATCHING = createExtensionPattern('matching');
	/**
	 * Patterns used to extract phone numbers from a larger phone-number-like pattern. These are
	 * ordered according to specificity. For example, white-space is last since that is frequently
	 * used in numbers, not just to separate two numbers. We have separate patterns since we don't
	 * want to break up the phone-number-like text on more than one different kind of symbol at one
	 * time, although symbols of the same type (e.g. space) can be safely grouped together.
	 *
	 * Note that if there is a match, we will always check any text found up to the first match as
	 * well.
	 */

	var INNER_MATCHES = [// Breaks on the slash - e.g. "651-234-2345/332-445-1234"
	'\\/+(.*)/', // Note that the bracket here is inside the capturing group, since we consider it part of the
	// phone number. Will match a pattern like "(650) 223 3345 (754) 223 3321".
	'(\\([^(]*)', // Breaks on a hyphen - e.g. "12345 - 332-445-1234 is my number."
	// We require a space on either side of the hyphen for it to be considered a separator.
	"(?:".concat(pZ, "-|-").concat(pZ, ")").concat(pZ, "*(.+)"), // Various types of wide hyphens. Note we have decided not to enforce a space here, since it's
	// possible that it's supposed to be used to break two numbers without spaces, and we haven't
	// seen many instances of it used within a number.
	"[\u2012-\u2015\uFF0D]".concat(pZ, "*(.+)"), // Breaks on a full stop - e.g. "12345. 332-445-1234 is my number."
	"\\.+".concat(pZ, "*([^.]+)"), // Breaks on space - e.g. "3324451234 8002341234"
	"".concat(pZ, "+(").concat(PZ, "+)")]; // Limit on the number of leading (plus) characters.

	var leadLimit = limit(0, 2); // Limit on the number of consecutive punctuation characters.

	var punctuationLimit = limit(0, 4);
	/* The maximum number of digits allowed in a digit-separated block. As we allow all digits in a
	 * single block, set high enough to accommodate the entire national number and the international
	 * country code. */

	var digitBlockLimit = MAX_LENGTH_FOR_NSN + MAX_LENGTH_COUNTRY_CODE; // Limit on the number of blocks separated by punctuation.
	// Uses digitBlockLimit since some formats use spaces to separate each digit.

	var blockLimit = limit(0, digitBlockLimit);
	/* A punctuation sequence allowing white space. */

	var punctuation = "[".concat(VALID_PUNCTUATION, "]") + punctuationLimit; // A digits block without punctuation.

	var digitSequence = pNd + limit(1, digitBlockLimit);
	/**
	 * Phone number pattern allowing optional punctuation.
	 * The phone number pattern used by `find()`, similar to
	 * VALID_PHONE_NUMBER, but with the following differences:
	 * <ul>
	 *   <li>All captures are limited in order to place an upper bound to the text matched by the
	 *       pattern.
	 * <ul>
	 *   <li>Leading punctuation / plus signs are limited.
	 *   <li>Consecutive occurrences of punctuation are limited.
	 *   <li>Number of digits is limited.
	 * </ul>
	 *   <li>No whitespace is allowed at the start or end.
	 *   <li>No alpha digits (vanity numbers such as 1-800-SIX-FLAGS) are currently supported.
	 * </ul>
	 */

	var PATTERN = '(?:' + LEAD_CLASS + punctuation + ')' + leadLimit + digitSequence + '(?:' + punctuation + digitSequence + ')' + blockLimit + '(?:' + EXTN_PATTERNS_FOR_MATCHING + ')?'; // Regular expression of trailing characters that we want to remove.
	// We remove all characters that are not alpha or numerical characters.
	// The hash character is retained here, as it may signify
	// the previous block was an extension.
	//
	// // Don't know what does '&&' mean here.
	// const UNWANTED_END_CHAR_PATTERN = new RegExp(`[[\\P{N}&&\\P{L}]&&[^#]]+$`)
	//

	var UNWANTED_END_CHAR_PATTERN = new RegExp("[^".concat(_pN).concat(_pL, "#]+$"));
	var MAX_SAFE_INTEGER$2 = Number.MAX_SAFE_INTEGER || Math.pow(2, 53) - 1;
	/**
	 * A stateful class that finds and extracts telephone numbers from {@linkplain CharSequence text}.
	 * Instances can be created using the {@linkplain PhoneNumberUtil#findNumbers factory methods} in
	 * {@link PhoneNumberUtil}.
	 *
	 * <p>Vanity numbers (phone numbers using alphabetic digits such as <tt>1-800-SIX-FLAGS</tt> are
	 * not found.
	 *
	 * <p>This class is not thread-safe.
	 */

	var PhoneNumberMatcher = /*#__PURE__*/function () {
	  /**
	   * Creates a new instance. See the factory methods in {@link PhoneNumberUtil} on how to obtain a
	   * new instance.
	   *
	   * @param util  the phone number util to use
	   * @param text  the character sequence that we will search, null for no text
	   * @param country  the country to assume for phone numbers not written in international format
	   *     (with a leading plus, or with the international dialing prefix of the specified region).
	   *     May be null or "ZZ" if only numbers with a leading plus should be
	   *     considered.
	   * @param leniency  the leniency to use when evaluating candidate phone numbers
	   * @param maxTries  the maximum number of invalid numbers to try before giving up on the text.
	   *     This is to cover degenerate cases where the text has a lot of false positives in it. Must
	   *     be {@code >= 0}.
	   */
	  function PhoneNumberMatcher() {
	    var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var metadata = arguments.length > 2 ? arguments[2] : undefined;

	    _classCallCheck$5(this, PhoneNumberMatcher);

	    options = _objectSpread$8(_objectSpread$8({}, options), {}, {
	      defaultCallingCode: options.defaultCallingCode,
	      defaultCountry: options.defaultCountry && isSupportedCountry(options.defaultCountry, metadata) ? options.defaultCountry : undefined,
	      leniency: options.leniency || options.extended ? 'POSSIBLE' : 'VALID',
	      maxTries: options.maxTries || MAX_SAFE_INTEGER$2
	    });

	    if (!options.leniency) {
	      throw new TypeError('`Leniency` not supplied');
	    }

	    if (options.maxTries < 0) {
	      throw new TypeError('`maxTries` not supplied');
	    }

	    this.text = text;
	    this.options = options;
	    this.metadata = metadata;
	    /** The degree of validation requested. */

	    this.leniency = Leniency[options.leniency];

	    if (!this.leniency) {
	      throw new TypeError("Unknown leniency: ".concat(options.leniency, "."));
	    }
	    /** The maximum number of retries after matching an invalid number. */


	    this.maxTries = options.maxTries;
	    this.PATTERN = new RegExp(PATTERN, 'ig');
	    /** The iteration tristate. */

	    this.state = 'NOT_READY';
	    /** The next index to start searching at. Undefined in {@link State#DONE}. */

	    this.searchIndex = 0; // A cache for frequently used country-specific regular expressions. Set to 32 to cover ~2-3
	    // countries being used for the same doc with ~10 patterns for each country. Some pages will have
	    // a lot more countries in use, but typically fewer numbers for each so expanding the cache for
	    // that use-case won't have a lot of benefit.

	    this.regExpCache = new RegExpCache(32);
	  }
	  /**
	   * Attempts to find the next subsequence in the searched sequence on or after {@code searchIndex}
	   * that represents a phone number. Returns the next match, null if none was found.
	   *
	   * @param index  the search index to start searching at
	   * @return  the phone number match found, null if none can be found
	   */


	  _createClass$5(PhoneNumberMatcher, [{
	    key: "find",
	    value: function find() {
	      var this$1 = this;

	      // // Reset the regular expression.
	      // this.PATTERN.lastIndex = index
	      var matches;

	      while (this.maxTries > 0 && (matches = this.PATTERN.exec(this.text)) !== null) {
	        var candidate = matches[0];
	        var offset = matches.index;
	        candidate = parsePreCandidate(candidate);

	        if (isValidPreCandidate(candidate, offset, this$1.text)) {
	          var match = // Try to come up with a valid match given the entire candidate.
	          this$1.parseAndVerify(candidate, offset, this$1.text) // If that failed, try to find an "inner match" -
	          // there might be a phone number within this candidate.
	          || this$1.extractInnerMatch(candidate, offset, this$1.text);

	          if (match) {
	            if (this$1.options.v2) {
	              var phoneNumber = new PhoneNumber(match.country || match.countryCallingCode, match.phone, this$1.metadata);

	              if (match.ext) {
	                phoneNumber.ext = match.ext;
	              }

	              return {
	                startsAt: match.startsAt,
	                endsAt: match.endsAt,
	                number: phoneNumber
	              };
	            }

	            return match;
	          }
	        }

	        this$1.maxTries--;
	      }
	    }
	    /**
	     * Attempts to extract a match from `substring`
	     * if the substring itself does not qualify as a match.
	     */

	  }, {
	    key: "extractInnerMatch",
	    value: function extractInnerMatch(substring, offset, text) {
	      var this$1 = this;

	      for (var _iterator = _createForOfIteratorHelperLoose$8(INNER_MATCHES), _step; !(_step = _iterator()).done;) {
	        var innerMatchPattern = _step.value;
	        var isFirstMatch = true;
	        var candidateMatch = void 0;
	        var innerMatchRegExp = new RegExp(innerMatchPattern, 'g');

	        while (this.maxTries > 0 && (candidateMatch = innerMatchRegExp.exec(substring)) !== null) {
	          if (isFirstMatch) {
	            // We should handle any group before this one too.
	            var _candidate = trimAfterFirstMatch(UNWANTED_END_CHAR_PATTERN, substring.slice(0, candidateMatch.index));

	            var _match = this$1.parseAndVerify(_candidate, offset, text);

	            if (_match) {
	              return _match;
	            }

	            this$1.maxTries--;
	            isFirstMatch = false;
	          }

	          var candidate = trimAfterFirstMatch(UNWANTED_END_CHAR_PATTERN, candidateMatch[1]); // Java code does `groupMatcher.start(1)` here,
	          // but there's no way in javascript to get a `candidate` start index,
	          // therefore resort to using this kind of an approximation.
	          // (`groupMatcher` is called `candidateInSubstringMatch` in this javascript port)
	          // https://stackoverflow.com/questions/15934353/get-index-of-each-capture-in-a-javascript-regex

	          var candidateIndexGuess = substring.indexOf(candidate, candidateMatch.index);
	          var match = this$1.parseAndVerify(candidate, offset + candidateIndexGuess, text);

	          if (match) {
	            return match;
	          }

	          this$1.maxTries--;
	        }
	      }
	    }
	    /**
	     * Parses a phone number from the `candidate` using `parseNumber` and
	     * verifies it matches the requested `leniency`. If parsing and verification succeed,
	     * a corresponding `PhoneNumberMatch` is returned, otherwise this method returns `null`.
	     *
	     * @param candidate  the candidate match
	     * @param offset  the offset of {@code candidate} within {@link #text}
	     * @return  the parsed and validated phone number match, or null
	     */

	  }, {
	    key: "parseAndVerify",
	    value: function parseAndVerify(candidate, offset, text) {
	      if (!isValidCandidate(candidate, offset, text, this.options.leniency)) {
	        return;
	      }

	      var number = parse$3(candidate, {
	        extended: true,
	        defaultCountry: this.options.defaultCountry,
	        defaultCallingCode: this.options.defaultCallingCode
	      }, this.metadata);

	      if (!number.possible) {
	        return;
	      }

	      if (this.leniency(number, candidate, this.metadata, this.regExpCache)) {
	        // // We used parseAndKeepRawInput to create this number,
	        // // but for now we don't return the extra values parsed.
	        // // TODO: stop clearing all values here and switch all users over
	        // // to using rawInput() rather than the rawString() of PhoneNumberMatch.
	        // number.clearCountryCodeSource()
	        // number.clearRawInput()
	        // number.clearPreferredDomesticCarrierCode()
	        var result = {
	          startsAt: offset,
	          endsAt: offset + candidate.length,
	          phone: number.phone
	        };

	        if (number.country && number.country !== '001') {
	          result.country = number.country;
	        } else {
	          result.countryCallingCode = number.countryCallingCode;
	        }

	        if (number.ext) {
	          result.ext = number.ext;
	        }

	        return result;
	      }
	    }
	  }, {
	    key: "hasNext",
	    value: function hasNext() {
	      if (this.state === 'NOT_READY') {
	        this.lastMatch = this.find(); // (this.searchIndex)

	        if (this.lastMatch) {
	          // this.searchIndex = this.lastMatch.endsAt
	          this.state = 'READY';
	        } else {
	          this.state = 'DONE';
	        }
	      }

	      return this.state === 'READY';
	    }
	  }, {
	    key: "next",
	    value: function next() {
	      // Check the state and find the next match as a side-effect if necessary.
	      if (!this.hasNext()) {
	        throw new Error('No next element');
	      } // Don't retain that memory any longer than necessary.


	      var result = this.lastMatch;
	      this.lastMatch = null;
	      this.state = 'NOT_READY';
	      return result;
	    }
	  }]);

	  return PhoneNumberMatcher;
	}();

	function _classCallCheck$6(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _defineProperties$6(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) { descriptor.writable = true; } Object.defineProperty(target, descriptor.key, descriptor); } }

	function _createClass$6(Constructor, protoProps, staticProps) { if (protoProps) { _defineProperties$6(Constructor.prototype, protoProps); } if (staticProps) { _defineProperties$6(Constructor, staticProps); } Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

	var AsYouTypeState = /*#__PURE__*/function () {
	  function AsYouTypeState(_ref) {
	    var onCountryChange = _ref.onCountryChange,
	        onCallingCodeChange = _ref.onCallingCodeChange;

	    _classCallCheck$6(this, AsYouTypeState);

	    this.onCountryChange = onCountryChange;
	    this.onCallingCodeChange = onCallingCodeChange;
	  }

	  _createClass$6(AsYouTypeState, [{
	    key: "reset",
	    value: function reset(defaultCountry, defaultCallingCode) {
	      this.international = false;
	      this.IDDPrefix = undefined;
	      this.missingPlus = undefined;
	      this.callingCode = undefined;
	      this.digits = '';
	      this.resetNationalSignificantNumber();
	      this.initCountryAndCallingCode(defaultCountry, defaultCallingCode);
	    }
	  }, {
	    key: "resetNationalSignificantNumber",
	    value: function resetNationalSignificantNumber() {
	      this.nationalSignificantNumber = this.getNationalDigits();
	      this.nationalSignificantNumberMatchesInput = true;
	      this.nationalPrefix = undefined;
	      this.carrierCode = undefined;
	      this.complexPrefixBeforeNationalSignificantNumber = undefined;
	    }
	  }, {
	    key: "update",
	    value: function update(properties) {
	      var this$1 = this;

	      for (var _i = 0, _Object$keys = Object.keys(properties); _i < _Object$keys.length; _i++) {
	        var key = _Object$keys[_i];
	        this$1[key] = properties[key];
	      }
	    }
	  }, {
	    key: "initCountryAndCallingCode",
	    value: function initCountryAndCallingCode(country, callingCode) {
	      this.setCountry(country);
	      this.setCallingCode(callingCode);
	    }
	  }, {
	    key: "setCountry",
	    value: function setCountry(country) {
	      this.country = country;
	      this.onCountryChange(country);
	    }
	  }, {
	    key: "setCallingCode",
	    value: function setCallingCode(callingCode) {
	      this.callingCode = callingCode;
	      this.onCallingCodeChange(callingCode, this.country);
	    }
	  }, {
	    key: "startInternationalNumber",
	    value: function startInternationalNumber(country, callingCode) {
	      // Prepend the `+` to parsed input.
	      this.international = true; // If a default country was set then reset it
	      // because an explicitly international phone
	      // number is being entered.

	      this.initCountryAndCallingCode(country, callingCode);
	    }
	  }, {
	    key: "appendDigits",
	    value: function appendDigits(nextDigits) {
	      this.digits += nextDigits;
	    }
	  }, {
	    key: "appendNationalSignificantNumberDigits",
	    value: function appendNationalSignificantNumberDigits(nextDigits) {
	      this.nationalSignificantNumber += nextDigits;
	    }
	    /**
	     * Returns the part of `this.digits` that corresponds to the national number.
	     * Basically, all digits that have been input by the user, except for the
	     * international prefix and the country calling code part
	     * (if the number is an international one).
	     * @return {string}
	     */

	  }, {
	    key: "getNationalDigits",
	    value: function getNationalDigits() {
	      if (this.international) {
	        return this.digits.slice((this.IDDPrefix ? this.IDDPrefix.length : 0) + (this.callingCode ? this.callingCode.length : 0));
	      }

	      return this.digits;
	    }
	  }, {
	    key: "getDigitsWithoutInternationalPrefix",
	    value: function getDigitsWithoutInternationalPrefix() {
	      if (this.international) {
	        if (this.IDDPrefix) {
	          return this.digits.slice(this.IDDPrefix.length);
	        }
	      }

	      return this.digits;
	    }
	  }]);

	  return AsYouTypeState;
	}();

	function _createForOfIteratorHelperLoose$9(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) { return (it = it.call(o)).next.bind(it); } if (Array.isArray(o) || (it = _unsupportedIterableToArray$a(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) { o = it; } var i = 0; return function () { if (i >= o.length) { return { done: true }; } return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

	function _unsupportedIterableToArray$a(o, minLen) { if (!o) { return; } if (typeof o === "string") { return _arrayLikeToArray$a(o, minLen); } var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) { n = o.constructor.name; } if (n === "Map" || n === "Set") { return Array.from(o); } if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) { return _arrayLikeToArray$a(o, minLen); } }

	function _arrayLikeToArray$a(arr, len) { if (len == null || len > arr.length) { len = arr.length; } for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

	// Should be the same as `DIGIT_PLACEHOLDER` in `libphonenumber-metadata-generator`.
	var DIGIT_PLACEHOLDER = 'x'; // '\u2008' (punctuation space)

	var DIGIT_PLACEHOLDER_MATCHER = new RegExp(DIGIT_PLACEHOLDER); // Counts all occurences of a symbol in a string.
	// http://stackoverflow.com/questions/202605/repeat-string-javascript

	function repeat$1(string, times) {
	  if (times < 1) {
	    return '';
	  }

	  var result = '';

	  while (times > 1) {
	    if (times & 1) {
	      result += string;
	    }

	    times >>= 1;
	    string += string;
	  }

	  return result + string;
	}
	function cutAndStripNonPairedParens(string, cutBeforeIndex) {
	  if (string[cutBeforeIndex] === ')') {
	    cutBeforeIndex++;
	  }

	  return stripNonPairedParens(string.slice(0, cutBeforeIndex));
	}
	function stripNonPairedParens(string) {
	  var dangling_braces = [];
	  var i = 0;

	  while (i < string.length) {
	    if (string[i] === '(') {
	      dangling_braces.push(i);
	    } else if (string[i] === ')') {
	      dangling_braces.pop();
	    }

	    i++;
	  }

	  var start = 0;
	  var cleared_string = '';
	  dangling_braces.push(string.length);

	  for (var _i = 0, _dangling_braces = dangling_braces; _i < _dangling_braces.length; _i++) {
	    var index = _dangling_braces[_i];
	    cleared_string += string.slice(start, index);
	    start = index + 1;
	  }

	  return cleared_string;
	}
	function populateTemplateWithDigits(template, position, digits) {
	  // Using `.split('')` to iterate through a string here
	  // to avoid requiring `Symbol.iterator` polyfill.
	  // `.split('')` is generally not safe for Unicode,
	  // but in this particular case for `digits` it is safe.
	  // for (const digit of digits)
	  for (var _iterator2 = _createForOfIteratorHelperLoose$9(digits.split('')), _step2; !(_step2 = _iterator2()).done;) {
	    var digit = _step2.value;

	    // If there is room for more digits in current `template`,
	    // then set the next digit in the `template`,
	    // and return the formatted digits so far.
	    // If more digits are entered than the current format could handle.
	    if (template.slice(position + 1).search(DIGIT_PLACEHOLDER_MATCHER) < 0) {
	      return;
	    }

	    position = template.search(DIGIT_PLACEHOLDER_MATCHER);
	    template = template.replace(DIGIT_PLACEHOLDER_MATCHER, digit);
	  }

	  return [template, position];
	}

	function formatCompleteNumber(state, format, _ref) {
	  var metadata = _ref.metadata,
	      shouldTryNationalPrefixFormattingRule = _ref.shouldTryNationalPrefixFormattingRule,
	      getSeparatorAfterNationalPrefix = _ref.getSeparatorAfterNationalPrefix;
	  var matcher = new RegExp("^(?:".concat(format.pattern(), ")$"));

	  if (matcher.test(state.nationalSignificantNumber)) {
	    return formatNationalNumberWithAndWithoutNationalPrefixFormattingRule(state, format, {
	      metadata: metadata,
	      shouldTryNationalPrefixFormattingRule: shouldTryNationalPrefixFormattingRule,
	      getSeparatorAfterNationalPrefix: getSeparatorAfterNationalPrefix
	    });
	  }
	}
	function canFormatCompleteNumber(nationalSignificantNumber, metadata) {
	  return checkNumberLength(nationalSignificantNumber, metadata) === 'IS_POSSIBLE';
	}

	function formatNationalNumberWithAndWithoutNationalPrefixFormattingRule(state, format, _ref2) {
	  var metadata = _ref2.metadata,
	      shouldTryNationalPrefixFormattingRule = _ref2.shouldTryNationalPrefixFormattingRule,
	      getSeparatorAfterNationalPrefix = _ref2.getSeparatorAfterNationalPrefix;
	  // `format` has already been checked for `nationalPrefix` requirement.
	  var nationalSignificantNumber = state.nationalSignificantNumber,
	      international = state.international,
	      nationalPrefix = state.nationalPrefix,
	      carrierCode = state.carrierCode; // Format the number with using `national_prefix_formatting_rule`.
	  // If the resulting formatted number is a valid formatted number, then return it.
	  //
	  // Google's AsYouType formatter is different in a way that it doesn't try
	  // to format using the "national prefix formatting rule", and instead it
	  // simply prepends a national prefix followed by a " " character.
	  // This code does that too, but as a fallback.
	  // The reason is that "national prefix formatting rule" may use parentheses,
	  // which wouldn't be included has it used the simpler Google's way.
	  //

	  if (shouldTryNationalPrefixFormattingRule(format)) {
	    var formattedNumber = formatNationalNumber$1(state, format, {
	      useNationalPrefixFormattingRule: true,
	      getSeparatorAfterNationalPrefix: getSeparatorAfterNationalPrefix,
	      metadata: metadata
	    });

	    if (formattedNumber) {
	      return formattedNumber;
	    }
	  } // Format the number without using `national_prefix_formatting_rule`.


	  return formatNationalNumber$1(state, format, {
	    useNationalPrefixFormattingRule: false,
	    getSeparatorAfterNationalPrefix: getSeparatorAfterNationalPrefix,
	    metadata: metadata
	  });
	}

	function formatNationalNumber$1(state, format, _ref3) {
	  var metadata = _ref3.metadata,
	      useNationalPrefixFormattingRule = _ref3.useNationalPrefixFormattingRule,
	      getSeparatorAfterNationalPrefix = _ref3.getSeparatorAfterNationalPrefix;
	  var formattedNationalNumber = formatNationalNumberUsingFormat(state.nationalSignificantNumber, format, {
	    carrierCode: state.carrierCode,
	    useInternationalFormat: state.international,
	    withNationalPrefix: useNationalPrefixFormattingRule,
	    metadata: metadata
	  });

	  if (!useNationalPrefixFormattingRule) {
	    if (state.nationalPrefix) {
	      // If a national prefix was extracted, then just prepend it,
	      // followed by a " " character.
	      formattedNationalNumber = state.nationalPrefix + getSeparatorAfterNationalPrefix(format) + formattedNationalNumber;
	    } else if (state.complexPrefixBeforeNationalSignificantNumber) {
	      formattedNationalNumber = state.complexPrefixBeforeNationalSignificantNumber + ' ' + formattedNationalNumber;
	    }
	  }

	  if (isValidFormattedNationalNumber(formattedNationalNumber, state)) {
	    return formattedNationalNumber;
	  }
	} // Check that the formatted phone number contains exactly
	// the same digits that have been input by the user.
	// For example, when "0111523456789" is input for `AR` country,
	// the extracted `this.nationalSignificantNumber` is "91123456789",
	// which means that the national part of `this.digits` isn't simply equal to
	// `this.nationalPrefix` + `this.nationalSignificantNumber`.
	//
	// Also, a `format` can add extra digits to the `this.nationalSignificantNumber`
	// being formatted via `metadata[country].national_prefix_transform_rule`.
	// For example, for `VI` country, it prepends `340` to the national number,
	// and if this check hasn't been implemented, then there would be a bug
	// when `340` "area coude" is "duplicated" during input for `VI` country:
	// https://github.com/catamphetamine/libphonenumber-js/issues/318
	//
	// So, all these "gotchas" are filtered out.
	//
	// In the original Google's code, the comments say:
	// "Check that we didn't remove nor add any extra digits when we matched
	// this formatting pattern. This usually happens after we entered the last
	// digit during AYTF. Eg: In case of MX, we swallow mobile token (1) when
	// formatted but AYTF should retain all the number entered and not change
	// in order to match a format (of same leading digits and length) display
	// in that way."
	// "If it's the same (i.e entered number and format is same), then it's
	// safe to return this in formatted number as nothing is lost / added."
	// Otherwise, don't use this format.
	// https://github.com/google/libphonenumber/commit/3e7c1f04f5e7200f87fb131e6f85c6e99d60f510#diff-9149457fa9f5d608a11bb975c6ef4bc5
	// https://github.com/google/libphonenumber/commit/3ac88c7106e7dcb553bcc794b15f19185928a1c6#diff-2dcb77e833422ee304da348b905cde0b
	//


	function isValidFormattedNationalNumber(formattedNationalNumber, state) {
	  return parseDigits(formattedNationalNumber) === state.getNationalDigits();
	}

	function _classCallCheck$7(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _defineProperties$7(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) { descriptor.writable = true; } Object.defineProperty(target, descriptor.key, descriptor); } }

	function _createClass$7(Constructor, protoProps, staticProps) { if (protoProps) { _defineProperties$7(Constructor.prototype, protoProps); } if (staticProps) { _defineProperties$7(Constructor, staticProps); } Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

	var PatternParser = /*#__PURE__*/function () {
	  function PatternParser() {
	    _classCallCheck$7(this, PatternParser);
	  }

	  _createClass$7(PatternParser, [{
	    key: "parse",
	    value: function parse(pattern) {
	      this.context = [{
	        or: true,
	        instructions: []
	      }];
	      this.parsePattern(pattern);

	      if (this.context.length !== 1) {
	        throw new Error('Non-finalized contexts left when pattern parse ended');
	      }

	      var _this$context$ = this.context[0],
	          branches = _this$context$.branches,
	          instructions = _this$context$.instructions;

	      if (branches) {
	        return {
	          op: '|',
	          args: branches.concat([expandSingleElementArray(instructions)])
	        };
	      }
	      /* istanbul ignore if */


	      if (instructions.length === 0) {
	        throw new Error('Pattern is required');
	      }

	      if (instructions.length === 1) {
	        return instructions[0];
	      }

	      return instructions;
	    }
	  }, {
	    key: "startContext",
	    value: function startContext(context) {
	      this.context.push(context);
	    }
	  }, {
	    key: "endContext",
	    value: function endContext() {
	      this.context.pop();
	    }
	  }, {
	    key: "getContext",
	    value: function getContext() {
	      return this.context[this.context.length - 1];
	    }
	  }, {
	    key: "parsePattern",
	    value: function parsePattern(pattern) {
	      if (!pattern) {
	        throw new Error('Pattern is required');
	      }

	      var match = pattern.match(OPERATOR);

	      if (!match) {
	        if (ILLEGAL_CHARACTER_REGEXP.test(pattern)) {
	          throw new Error("Illegal characters found in a pattern: ".concat(pattern));
	        }

	        this.getContext().instructions = this.getContext().instructions.concat(pattern.split(''));
	        return;
	      }

	      var operator = match[1];
	      var before = pattern.slice(0, match.index);
	      var rightPart = pattern.slice(match.index + operator.length);

	      switch (operator) {
	        case '(?:':
	          if (before) {
	            this.parsePattern(before);
	          }

	          this.startContext({
	            or: true,
	            instructions: [],
	            branches: []
	          });
	          break;

	        case ')':
	          if (!this.getContext().or) {
	            throw new Error('")" operator must be preceded by "(?:" operator');
	          }

	          if (before) {
	            this.parsePattern(before);
	          }

	          if (this.getContext().instructions.length === 0) {
	            throw new Error('No instructions found after "|" operator in an "or" group');
	          }

	          var _this$getContext = this.getContext(),
	              branches = _this$getContext.branches;

	          branches.push(expandSingleElementArray(this.getContext().instructions));
	          this.endContext();
	          this.getContext().instructions.push({
	            op: '|',
	            args: branches
	          });
	          break;

	        case '|':
	          if (!this.getContext().or) {
	            throw new Error('"|" operator can only be used inside "or" groups');
	          }

	          if (before) {
	            this.parsePattern(before);
	          } // The top-level is an implicit "or" group, if required.


	          if (!this.getContext().branches) {
	            // `branches` are not defined only for the root implicit "or" operator.

	            /* istanbul ignore else */
	            if (this.context.length === 1) {
	              this.getContext().branches = [];
	            } else {
	              throw new Error('"branches" not found in an "or" group context');
	            }
	          }

	          this.getContext().branches.push(expandSingleElementArray(this.getContext().instructions));
	          this.getContext().instructions = [];
	          break;

	        case '[':
	          if (before) {
	            this.parsePattern(before);
	          }

	          this.startContext({
	            oneOfSet: true
	          });
	          break;

	        case ']':
	          if (!this.getContext().oneOfSet) {
	            throw new Error('"]" operator must be preceded by "[" operator');
	          }

	          this.endContext();
	          this.getContext().instructions.push({
	            op: '[]',
	            args: parseOneOfSet(before)
	          });
	          break;

	        /* istanbul ignore next */

	        default:
	          throw new Error("Unknown operator: ".concat(operator));
	      }

	      if (rightPart) {
	        this.parsePattern(rightPart);
	      }
	    }
	  }]);

	  return PatternParser;
	}();

	function parseOneOfSet(pattern) {
	  var values = [];
	  var i = 0;

	  while (i < pattern.length) {
	    if (pattern[i] === '-') {
	      if (i === 0 || i === pattern.length - 1) {
	        throw new Error("Couldn't parse a one-of set pattern: ".concat(pattern));
	      }

	      var prevValue = pattern[i - 1].charCodeAt(0) + 1;
	      var nextValue = pattern[i + 1].charCodeAt(0) - 1;
	      var value = prevValue;

	      while (value <= nextValue) {
	        values.push(String.fromCharCode(value));
	        value++;
	      }
	    } else {
	      values.push(pattern[i]);
	    }

	    i++;
	  }

	  return values;
	}

	var ILLEGAL_CHARACTER_REGEXP = /[\(\)\[\]\?\:\|]/;
	var OPERATOR = new RegExp( // any of:
	'(' + // or operator
	'\\|' + // or
	'|' + // or group start
	'\\(\\?\\:' + // or
	'|' + // or group end
	'\\)' + // or
	'|' + // one-of set start
	'\\[' + // or
	'|' + // one-of set end
	'\\]' + ')');

	function expandSingleElementArray(array) {
	  if (array.length === 1) {
	    return array[0];
	  }

	  return array;
	}

	function _createForOfIteratorHelperLoose$a(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) { return (it = it.call(o)).next.bind(it); } if (Array.isArray(o) || (it = _unsupportedIterableToArray$b(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) { o = it; } var i = 0; return function () { if (i >= o.length) { return { done: true }; } return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

	function _unsupportedIterableToArray$b(o, minLen) { if (!o) { return; } if (typeof o === "string") { return _arrayLikeToArray$b(o, minLen); } var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) { n = o.constructor.name; } if (n === "Map" || n === "Set") { return Array.from(o); } if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) { return _arrayLikeToArray$b(o, minLen); } }

	function _arrayLikeToArray$b(arr, len) { if (len == null || len > arr.length) { len = arr.length; } for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

	function _classCallCheck$8(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _defineProperties$8(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) { descriptor.writable = true; } Object.defineProperty(target, descriptor.key, descriptor); } }

	function _createClass$8(Constructor, protoProps, staticProps) { if (protoProps) { _defineProperties$8(Constructor.prototype, protoProps); } if (staticProps) { _defineProperties$8(Constructor, staticProps); } Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

	var PatternMatcher = /*#__PURE__*/function () {
	  function PatternMatcher(pattern) {
	    _classCallCheck$8(this, PatternMatcher);

	    this.matchTree = new PatternParser().parse(pattern);
	  }

	  _createClass$8(PatternMatcher, [{
	    key: "match",
	    value: function match(string) {
	      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	          allowOverflow = _ref.allowOverflow;

	      if (!string) {
	        throw new Error('String is required');
	      }

	      var result = _match(string.split(''), this.matchTree, true);

	      if (result && result.match) {
	        delete result.matchedChars;
	      }

	      if (result && result.overflow) {
	        if (!allowOverflow) {
	          return;
	        }
	      }

	      return result;
	    }
	  }]);

	  return PatternMatcher;
	}();

	function _match(characters, tree, last) {
	  // If `tree` is a string, then `tree` is a single character.
	  // That's because when a pattern is parsed, multi-character-string parts
	  // of a pattern are compiled into arrays of single characters.
	  // I still wrote this piece of code for a "general" hypothetical case
	  // when `tree` could be a string of several characters, even though
	  // such case is not possible with the current implementation.
	  if (typeof tree === 'string') {
	    var characterString = characters.join('');

	    if (tree.indexOf(characterString) === 0) {
	      // `tree` is always a single character.
	      // If `tree.indexOf(characterString) === 0`
	      // then `characters.length === tree.length`.

	      /* istanbul ignore else */
	      if (characters.length === tree.length) {
	        return {
	          match: true,
	          matchedChars: characters
	        };
	      } // `tree` is always a single character.
	      // If `tree.indexOf(characterString) === 0`
	      // then `characters.length === tree.length`.

	      /* istanbul ignore next */


	      return {
	        partialMatch: true // matchedChars: characters

	      };
	    }

	    if (characterString.indexOf(tree) === 0) {
	      if (last) {
	        // The `else` path is not possible because `tree` is always a single character.
	        // The `else` case for `characters.length > tree.length` would be
	        // `characters.length <= tree.length` which means `characters.length <= 1`.
	        // `characters` array can't be empty, so that means `characters === [tree]`,
	        // which would also mean `tree.indexOf(characterString) === 0` and that'd mean
	        // that the `if (tree.indexOf(characterString) === 0)` condition before this
	        // `if` condition would be entered, and returned from there, not reaching this code.

	        /* istanbul ignore else */
	        if (characters.length > tree.length) {
	          return {
	            overflow: true
	          };
	        }
	      }

	      return {
	        match: true,
	        matchedChars: characters.slice(0, tree.length)
	      };
	    }

	    return;
	  }

	  if (Array.isArray(tree)) {
	    var restCharacters = characters.slice();
	    var i = 0;

	    while (i < tree.length) {
	      var subtree = tree[i];

	      var result = _match(restCharacters, subtree, last && i === tree.length - 1);

	      if (!result) {
	        return;
	      } else if (result.overflow) {
	        return result;
	      } else if (result.match) {
	        // Continue with the next subtree with the rest of the characters.
	        restCharacters = restCharacters.slice(result.matchedChars.length);

	        if (restCharacters.length === 0) {
	          if (i === tree.length - 1) {
	            return {
	              match: true,
	              matchedChars: characters
	            };
	          } else {
	            return {
	              partialMatch: true // matchedChars: characters

	            };
	          }
	        }
	      } else {
	        /* istanbul ignore else */
	        if (result.partialMatch) {
	          return {
	            partialMatch: true // matchedChars: characters

	          };
	        } else {
	          throw new Error("Unsupported match result:\n".concat(JSON.stringify(result, null, 2)));
	        }
	      }

	      i++;
	    } // If `last` then overflow has already been checked
	    // by the last element of the `tree` array.

	    /* istanbul ignore if */


	    if (last) {
	      return {
	        overflow: true
	      };
	    }

	    return {
	      match: true,
	      matchedChars: characters.slice(0, characters.length - restCharacters.length)
	    };
	  }

	  switch (tree.op) {
	    case '|':
	      var partialMatch;

	      for (var _iterator = _createForOfIteratorHelperLoose$a(tree.args), _step; !(_step = _iterator()).done;) {
	        var branch = _step.value;

	        var _result = _match(characters, branch, last);

	        if (_result) {
	          if (_result.overflow) {
	            return _result;
	          } else if (_result.match) {
	            return {
	              match: true,
	              matchedChars: _result.matchedChars
	            };
	          } else {
	            /* istanbul ignore else */
	            if (_result.partialMatch) {
	              partialMatch = true;
	            } else {
	              throw new Error("Unsupported match result:\n".concat(JSON.stringify(_result, null, 2)));
	            }
	          }
	        }
	      }

	      if (partialMatch) {
	        return {
	          partialMatch: true // matchedChars: ...

	        };
	      } // Not even a partial match.


	      return;

	    case '[]':
	      for (var _iterator2 = _createForOfIteratorHelperLoose$a(tree.args), _step2; !(_step2 = _iterator2()).done;) {
	        var _char = _step2.value;

	        if (characters[0] === _char) {
	          if (characters.length === 1) {
	            return {
	              match: true,
	              matchedChars: characters
	            };
	          }

	          if (last) {
	            return {
	              overflow: true
	            };
	          }

	          return {
	            match: true,
	            matchedChars: [_char]
	          };
	        }
	      } // No character matches.


	      return;

	    /* istanbul ignore next */

	    default:
	      throw new Error("Unsupported instruction tree: ".concat(tree));
	  }
	}

	function _createForOfIteratorHelperLoose$b(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) { return (it = it.call(o)).next.bind(it); } if (Array.isArray(o) || (it = _unsupportedIterableToArray$c(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) { o = it; } var i = 0; return function () { if (i >= o.length) { return { done: true }; } return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

	function _unsupportedIterableToArray$c(o, minLen) { if (!o) { return; } if (typeof o === "string") { return _arrayLikeToArray$c(o, minLen); } var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) { n = o.constructor.name; } if (n === "Map" || n === "Set") { return Array.from(o); } if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) { return _arrayLikeToArray$c(o, minLen); } }

	function _arrayLikeToArray$c(arr, len) { if (len == null || len > arr.length) { len = arr.length; } for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

	function _classCallCheck$9(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _defineProperties$9(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) { descriptor.writable = true; } Object.defineProperty(target, descriptor.key, descriptor); } }

	function _createClass$9(Constructor, protoProps, staticProps) { if (protoProps) { _defineProperties$9(Constructor.prototype, protoProps); } if (staticProps) { _defineProperties$9(Constructor, staticProps); } Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
	// Could be any digit, I guess.

	var DUMMY_DIGIT = '9'; // I don't know why is it exactly `15`

	var LONGEST_NATIONAL_PHONE_NUMBER_LENGTH = 15; // Create a phone number consisting only of the digit 9 that matches the
	// `number_pattern` by applying the pattern to the "longest phone number" string.

	var LONGEST_DUMMY_PHONE_NUMBER = repeat$1(DUMMY_DIGIT, LONGEST_NATIONAL_PHONE_NUMBER_LENGTH); // A set of characters that, if found in a national prefix formatting rules, are an indicator to
	// us that we should separate the national prefix from the number when formatting.

	var NATIONAL_PREFIX_SEPARATORS_PATTERN = /[- ]/; // Deprecated: Google has removed some formatting pattern related code from their repo.
	// An example of a character class is "[1-4]".

	var CREATE_CHARACTER_CLASS_PATTERN = function () {
	  return /\[([^\[\]])*\]/g;
	}; // Any digit in a regular expression that actually denotes a digit. For
	// example, in the regular expression "80[0-2]\d{6,10}", the first 2 digits
	// (8 and 0) are standalone digits, but the rest are not.
	// Two look-aheads are needed because the number following \\d could be a
	// two-digit number, since the phone number can be as long as 15 digits.


	var CREATE_STANDALONE_DIGIT_PATTERN = function () {
	  return /\d(?=[^,}][^,}])/g;
	}; // A regular expression that is used to determine if a `format` is
	// suitable to be used in the "as you type formatter".
	// A `format` is suitable when the resulting formatted number has
	// the same digits as the user has entered.
	//
	// In the simplest case, that would mean that the format
	// doesn't add any additional digits when formatting a number.
	// Google says that it also shouldn't add "star" (`*`) characters,
	// like it does in some Israeli formats.
	// Such basic format would only contain "valid punctuation"
	// and "captured group" identifiers ($1, $2, etc).
	//
	// An example of a format that adds additional digits:
	//
	// Country: `AR` (Argentina).
	// Format:
	// {
	//    "pattern": "(\\d)(\\d{2})(\\d{4})(\\d{4})",
	//    "leading_digits_patterns": ["91"],
	//    "national_prefix_formatting_rule": "0$1",
	//    "format": "$2 15-$3-$4",
	//    "international_format": "$1 $2 $3-$4"
	// }
	//
	// In the format above, the `format` adds `15` to the digits when formatting a number.
	// A sidenote: this format actually is suitable because `national_prefix_for_parsing`
	// has previously removed `15` from a national number, so re-adding `15` in `format`
	// doesn't actually result in any extra digits added to user's input.
	// But verifying that would be a complex procedure, so the code chooses a simpler path:
	// it simply filters out all `format`s that contain anything but "captured group" ids.
	//
	// This regular expression is called `ELIGIBLE_FORMAT_PATTERN` in Google's
	// `libphonenumber` code.
	//


	var NON_ALTERING_FORMAT_REG_EXP = new RegExp('[' + VALID_PUNCTUATION + ']*' + // Google developers say:
	// "We require that the first matching group is present in the
	//  output pattern to ensure no data is lost while formatting."
	'\\$1' + '[' + VALID_PUNCTUATION + ']*' + '(\\$\\d[' + VALID_PUNCTUATION + ']*)*' + '$'); // This is the minimum length of the leading digits of a phone number
	// to guarantee the first "leading digits pattern" for a phone number format
	// to be preemptive.

	var MIN_LEADING_DIGITS_LENGTH = 3;

	var AsYouTypeFormatter = /*#__PURE__*/function () {
	  function AsYouTypeFormatter(_ref) {
	    var state = _ref.state,
	        metadata = _ref.metadata;

	    _classCallCheck$9(this, AsYouTypeFormatter);

	    this.metadata = metadata;
	    this.resetFormat();
	  }

	  _createClass$9(AsYouTypeFormatter, [{
	    key: "resetFormat",
	    value: function resetFormat() {
	      this.chosenFormat = undefined;
	      this.template = undefined;
	      this.nationalNumberTemplate = undefined;
	      this.populatedNationalNumberTemplate = undefined;
	      this.populatedNationalNumberTemplatePosition = -1;
	    }
	  }, {
	    key: "reset",
	    value: function reset(numberingPlan, state) {
	      this.resetFormat();

	      if (numberingPlan) {
	        this.isNANP = numberingPlan.callingCode() === '1';
	        this.matchingFormats = numberingPlan.formats();

	        if (state.nationalSignificantNumber) {
	          this.narrowDownMatchingFormats(state);
	        }
	      } else {
	        this.isNANP = undefined;
	        this.matchingFormats = [];
	      }
	    }
	    /**
	     * Formats an updated phone number.
	     * @param  {string} nextDigits — Additional phone number digits.
	     * @param  {object} state — `AsYouType` state.
	     * @return {[string]} Returns undefined if the updated phone number can't be formatted using any of the available formats.
	     */

	  }, {
	    key: "format",
	    value: function format(nextDigits, state) {
	      var this$1 = this;

	      var _this = this;

	      // See if the phone number digits can be formatted as a complete phone number.
	      // If not, use the results from `formatNationalNumberWithNextDigits()`,
	      // which formats based on the chosen formatting pattern.
	      //
	      // Attempting to format complete phone number first is how it's done
	      // in Google's `libphonenumber`, so this library just follows it.
	      // Google's `libphonenumber` code doesn't explain in detail why does it
	      // attempt to format digits as a complete phone number
	      // instead of just going with a previoulsy (or newly) chosen `format`:
	      //
	      // "Checks to see if there is an exact pattern match for these digits.
	      //  If so, we should use this instead of any other formatting template
	      //  whose leadingDigitsPattern also matches the input."
	      //
	      if (canFormatCompleteNumber(state.nationalSignificantNumber, this.metadata)) {
	        for (var _iterator = _createForOfIteratorHelperLoose$b(this.matchingFormats), _step; !(_step = _iterator()).done;) {
	          var format = _step.value;
	          var formattedCompleteNumber = formatCompleteNumber(state, format, {
	            metadata: this$1.metadata,
	            shouldTryNationalPrefixFormattingRule: function shouldTryNationalPrefixFormattingRule(format) {
	              return _this.shouldTryNationalPrefixFormattingRule(format, {
	                international: state.international,
	                nationalPrefix: state.nationalPrefix
	              });
	            },
	            getSeparatorAfterNationalPrefix: function getSeparatorAfterNationalPrefix(format) {
	              return _this.getSeparatorAfterNationalPrefix(format);
	            }
	          });

	          if (formattedCompleteNumber) {
	            this$1.resetFormat();
	            this$1.chosenFormat = format;
	            this$1.setNationalNumberTemplate(formattedCompleteNumber.replace(/\d/g, DIGIT_PLACEHOLDER), state);
	            this$1.populatedNationalNumberTemplate = formattedCompleteNumber; // With a new formatting template, the matched position
	            // using the old template needs to be reset.

	            this$1.populatedNationalNumberTemplatePosition = this$1.template.lastIndexOf(DIGIT_PLACEHOLDER);
	            return formattedCompleteNumber;
	          }
	        }
	      } // Format the digits as a partial (incomplete) phone number
	      // using the previously chosen formatting pattern (or a newly chosen one).


	      return this.formatNationalNumberWithNextDigits(nextDigits, state);
	    } // Formats the next phone number digits.

	  }, {
	    key: "formatNationalNumberWithNextDigits",
	    value: function formatNationalNumberWithNextDigits(nextDigits, state) {
	      var previouslyChosenFormat = this.chosenFormat; // Choose a format from the list of matching ones.

	      var newlyChosenFormat = this.chooseFormat(state);

	      if (newlyChosenFormat) {
	        if (newlyChosenFormat === previouslyChosenFormat) {
	          // If it can format the next (current) digits
	          // using the previously chosen phone number format
	          // then return the updated formatted number.
	          return this.formatNextNationalNumberDigits(nextDigits);
	        } else {
	          // If a more appropriate phone number format
	          // has been chosen for these "leading digits",
	          // then re-format the national phone number part
	          // using the newly selected format.
	          return this.formatNextNationalNumberDigits(state.getNationalDigits());
	        }
	      }
	    }
	  }, {
	    key: "narrowDownMatchingFormats",
	    value: function narrowDownMatchingFormats(_ref2) {
	      var _this2 = this;

	      var nationalSignificantNumber = _ref2.nationalSignificantNumber,
	          nationalPrefix = _ref2.nationalPrefix,
	          international = _ref2.international;
	      var leadingDigits = nationalSignificantNumber; // "leading digits" pattern list starts with a
	      // "leading digits" pattern fitting a maximum of 3 leading digits.
	      // So, after a user inputs 3 digits of a national (significant) phone number
	      // this national (significant) number can already be formatted.
	      // The next "leading digits" pattern is for 4 leading digits max,
	      // and the "leading digits" pattern after it is for 5 leading digits max, etc.
	      // This implementation is different from Google's
	      // in that it searches for a fitting format
	      // even if the user has entered less than
	      // `MIN_LEADING_DIGITS_LENGTH` digits of a national number.
	      // Because some leading digit patterns already match for a single first digit.

	      var leadingDigitsPatternIndex = leadingDigits.length - MIN_LEADING_DIGITS_LENGTH;

	      if (leadingDigitsPatternIndex < 0) {
	        leadingDigitsPatternIndex = 0;
	      }

	      this.matchingFormats = this.matchingFormats.filter(function (format) {
	        return _this2.formatSuits(format, international, nationalPrefix) && _this2.formatMatches(format, leadingDigits, leadingDigitsPatternIndex);
	      }); // If there was a phone number format chosen
	      // and it no longer holds given the new leading digits then reset it.
	      // The test for this `if` condition is marked as:
	      // "Reset a chosen format when it no longer holds given the new leading digits".
	      // To construct a valid test case for this one can find a country
	      // in `PhoneNumberMetadata.xml` yielding one format for 3 `<leadingDigits>`
	      // and yielding another format for 4 `<leadingDigits>` (Australia in this case).

	      if (this.chosenFormat && this.matchingFormats.indexOf(this.chosenFormat) === -1) {
	        this.resetFormat();
	      }
	    }
	  }, {
	    key: "formatSuits",
	    value: function formatSuits(format, international, nationalPrefix) {
	      // When a prefix before a national (significant) number is
	      // simply a national prefix, then it's parsed as `this.nationalPrefix`.
	      // In more complex cases, a prefix before national (significant) number
	      // could include a national prefix as well as some "capturing groups",
	      // and in that case there's no info whether a national prefix has been parsed.
	      // If national prefix is not used when formatting a phone number
	      // using this format, but a national prefix has been entered by the user,
	      // and was extracted, then discard such phone number format.
	      // In Google's "AsYouType" formatter code, the equivalent would be this part:
	      // https://github.com/google/libphonenumber/blob/0a45cfd96e71cad8edb0e162a70fcc8bd9728933/java/libphonenumber/src/com/google/i18n/phonenumbers/AsYouTypeFormatter.java#L175-L184
	      if (nationalPrefix && !format.usesNationalPrefix() && // !format.domesticCarrierCodeFormattingRule() &&
	      !format.nationalPrefixIsOptionalWhenFormattingInNationalFormat()) {
	        return false;
	      } // If national prefix is mandatory for this phone number format
	      // and there're no guarantees that a national prefix is present in user input
	      // then discard this phone number format as not suitable.
	      // In Google's "AsYouType" formatter code, the equivalent would be this part:
	      // https://github.com/google/libphonenumber/blob/0a45cfd96e71cad8edb0e162a70fcc8bd9728933/java/libphonenumber/src/com/google/i18n/phonenumbers/AsYouTypeFormatter.java#L185-L193


	      if (!international && !nationalPrefix && format.nationalPrefixIsMandatoryWhenFormattingInNationalFormat()) {
	        return false;
	      }

	      return true;
	    }
	  }, {
	    key: "formatMatches",
	    value: function formatMatches(format, leadingDigits, leadingDigitsPatternIndex) {
	      var leadingDigitsPatternsCount = format.leadingDigitsPatterns().length; // If this format is not restricted to a certain
	      // leading digits pattern then it fits.
	      // The test case could be found by searching for "leadingDigitsPatternsCount === 0".

	      if (leadingDigitsPatternsCount === 0) {
	        return true;
	      } // Start narrowing down the list of possible formats based on the leading digits.
	      // (only previously matched formats take part in the narrowing down process)
	      // `leading_digits_patterns` start with 3 digits min
	      // and then go up from there one digit at a time.


	      leadingDigitsPatternIndex = Math.min(leadingDigitsPatternIndex, leadingDigitsPatternsCount - 1);
	      var leadingDigitsPattern = format.leadingDigitsPatterns()[leadingDigitsPatternIndex]; // Google imposes a requirement on the leading digits
	      // to be minimum 3 digits long in order to be eligible
	      // for checking those with a leading digits pattern.
	      //
	      // Since `leading_digits_patterns` start with 3 digits min,
	      // Google's original `libphonenumber` library only starts
	      // excluding any non-matching formats only when the
	      // national number entered so far is at least 3 digits long,
	      // otherwise format matching would give false negatives.
	      //
	      // For example, when the digits entered so far are `2`
	      // and the leading digits pattern is `21` –
	      // it's quite obvious in this case that the format could be the one
	      // but due to the absence of further digits it would give false negative.
	      //
	      // Also, `leading_digits_patterns` doesn't always correspond to a single
	      // digits count. For example, `60|8` pattern would already match `8`
	      // but the `60` part would require having at least two leading digits,
	      // so the whole pattern would require inputting two digits first in order to
	      // decide on whether it matches the input, even when the input is "80".
	      //
	      // This library — `libphonenumber-js` — allows filtering by `leading_digits_patterns`
	      // even when there's only 1 or 2 digits of the national (significant) number.
	      // To do that, it uses a non-strict pattern matcher written specifically for that.
	      //

	      if (leadingDigits.length < MIN_LEADING_DIGITS_LENGTH) {
	        // Before leading digits < 3 matching was implemented:
	        // return true
	        //
	        // After leading digits < 3 matching was implemented:
	        try {
	          return new PatternMatcher(leadingDigitsPattern).match(leadingDigits, {
	            allowOverflow: true
	          }) !== undefined;
	        } catch (error)
	        /* istanbul ignore next */
	        {
	          // There's a slight possibility that there could be some undiscovered bug
	          // in the pattern matcher code. Since the "leading digits < 3 matching"
	          // feature is not "essential" for operation, it can fall back to the old way
	          // in case of any issues rather than halting the application's execution.
	          console.error(error);
	          return true;
	        }
	      } // If at least `MIN_LEADING_DIGITS_LENGTH` digits of a national number are
	      // available then use the usual regular expression matching.
	      //
	      // The whole pattern is wrapped in round brackets (`()`) because
	      // the pattern can use "or" operator (`|`) at the top level of the pattern.
	      //


	      return new RegExp("^(".concat(leadingDigitsPattern, ")")).test(leadingDigits);
	    }
	  }, {
	    key: "getFormatFormat",
	    value: function getFormatFormat(format, international) {
	      return international ? format.internationalFormat() : format.format();
	    }
	  }, {
	    key: "chooseFormat",
	    value: function chooseFormat(state) {
	      var _this3 = this;

	      var _loop = function _loop() {
	        var format = _step2.value;

	        // If this format is currently being used
	        // and is still suitable, then stick to it.
	        if (_this3.chosenFormat === format) {
	          return "break";
	        } // Sometimes, a formatting rule inserts additional digits in a phone number,
	        // and "as you type" formatter can't do that: it should only use the digits
	        // that the user has input.
	        //
	        // For example, in Argentina, there's a format for mobile phone numbers:
	        //
	        // {
	        //    "pattern": "(\\d)(\\d{2})(\\d{4})(\\d{4})",
	        //    "leading_digits_patterns": ["91"],
	        //    "national_prefix_formatting_rule": "0$1",
	        //    "format": "$2 15-$3-$4",
	        //    "international_format": "$1 $2 $3-$4"
	        // }
	        //
	        // In that format, `international_format` is used instead of `format`
	        // because `format` inserts `15` in the formatted number,
	        // and `AsYouType` formatter should only use the digits
	        // the user has actually input, without adding any extra digits.
	        // In this case, it wouldn't make a difference, because the `15`
	        // is first stripped when applying `national_prefix_for_parsing`
	        // and then re-added when using `format`, so in reality it doesn't
	        // add any new digits to the number, but to detect that, the code
	        // would have to be more complex: it would have to try formatting
	        // the digits using the format and then see if any digits have
	        // actually been added or removed, and then, every time a new digit
	        // is input, it should re-check whether the chosen format doesn't
	        // alter the digits.
	        //
	        // Google's code doesn't go that far, and so does this library:
	        // it simply requires that a `format` doesn't add any additonal
	        // digits to user's input.
	        //
	        // Also, people in general should move from inputting phone numbers
	        // in national format (possibly with national prefixes)
	        // and use international phone number format instead:
	        // it's a logical thing in the modern age of mobile phones,
	        // globalization and the internet.
	        //

	        /* istanbul ignore if */


	        if (!NON_ALTERING_FORMAT_REG_EXP.test(_this3.getFormatFormat(format, state.international))) {
	          return "continue";
	        }

	        if (!_this3.createTemplateForFormat(format, state)) {
	          // Remove the format if it can't generate a template.
	          _this3.matchingFormats = _this3.matchingFormats.filter(function (_) {
	            return _ !== format;
	          });
	          return "continue";
	        }

	        _this3.chosenFormat = format;
	        return "break";
	      };

	      // When there are multiple available formats, the formatter uses the first
	      // format where a formatting template could be created.
	      //
	      // For some weird reason, `istanbul` says "else path not taken"
	      // for the `for of` line below. Supposedly that means that
	      // the loop doesn't ever go over the last element in the list.
	      // That's true because there always is `this.chosenFormat`
	      // when `this.matchingFormats` is non-empty.
	      // And, for some weird reason, it doesn't think that the case
	      // with empty `this.matchingFormats` qualifies for a valid "else" path.
	      // So simply muting this `istanbul` warning.
	      // It doesn't skip the contents of the `for of` loop,
	      // it just skips the `for of` line.
	      //

	      /* istanbul ignore next */
	      for (var _iterator2 = _createForOfIteratorHelperLoose$b(this.matchingFormats.slice()), _step2; !(_step2 = _iterator2()).done;) {
	        var _ret = _loop();

	        if (_ret === "break") { break; }
	        if (_ret === "continue") { continue; }
	      }

	      if (!this.chosenFormat) {
	        // No format matches the national (significant) phone number.
	        this.resetFormat();
	      }

	      return this.chosenFormat;
	    }
	  }, {
	    key: "createTemplateForFormat",
	    value: function createTemplateForFormat(format, state) {
	      // The formatter doesn't format numbers when numberPattern contains '|', e.g.
	      // (20|3)\d{4}. In those cases we quickly return.
	      // (Though there's no such format in current metadata)

	      /* istanbul ignore if */
	      if (format.pattern().indexOf('|') >= 0) {
	        return;
	      } // Get formatting template for this phone number format


	      var template = this.getTemplateForFormat(format, state); // If the national number entered is too long
	      // for any phone number format, then abort.

	      if (template) {
	        this.setNationalNumberTemplate(template, state);
	        return true;
	      }
	    }
	  }, {
	    key: "getSeparatorAfterNationalPrefix",
	    value: function getSeparatorAfterNationalPrefix(format) {
	      // `US` metadata doesn't have a `national_prefix_formatting_rule`,
	      // so the `if` condition below doesn't apply to `US`,
	      // but in reality there shoudl be a separator
	      // between a national prefix and a national (significant) number.
	      // So `US` national prefix separator is a "special" "hardcoded" case.
	      if (this.isNANP) {
	        return ' ';
	      } // If a `format` has a `national_prefix_formatting_rule`
	      // and that rule has a separator after a national prefix,
	      // then it means that there should be a separator
	      // between a national prefix and a national (significant) number.


	      if (format && format.nationalPrefixFormattingRule() && NATIONAL_PREFIX_SEPARATORS_PATTERN.test(format.nationalPrefixFormattingRule())) {
	        return ' ';
	      } // At this point, there seems to be no clear evidence that
	      // there should be a separator between a national prefix
	      // and a national (significant) number. So don't insert one.


	      return '';
	    }
	  }, {
	    key: "getInternationalPrefixBeforeCountryCallingCode",
	    value: function getInternationalPrefixBeforeCountryCallingCode(_ref3, options) {
	      var IDDPrefix = _ref3.IDDPrefix,
	          missingPlus = _ref3.missingPlus;

	      if (IDDPrefix) {
	        return options && options.spacing === false ? IDDPrefix : IDDPrefix + ' ';
	      }

	      if (missingPlus) {
	        return '';
	      }

	      return '+';
	    }
	  }, {
	    key: "getTemplate",
	    value: function getTemplate(state) {
	      var this$1 = this;

	      if (!this.template) {
	        return;
	      } // `this.template` holds the template for a "complete" phone number.
	      // The currently entered phone number is most likely not "complete",
	      // so trim all non-populated digits.


	      var index = -1;
	      var i = 0;
	      var internationalPrefix = state.international ? this.getInternationalPrefixBeforeCountryCallingCode(state, {
	        spacing: false
	      }) : '';

	      while (i < internationalPrefix.length + state.getDigitsWithoutInternationalPrefix().length) {
	        index = this$1.template.indexOf(DIGIT_PLACEHOLDER, index + 1);
	        i++;
	      }

	      return cutAndStripNonPairedParens(this.template, index + 1);
	    }
	  }, {
	    key: "setNationalNumberTemplate",
	    value: function setNationalNumberTemplate(template, state) {
	      this.nationalNumberTemplate = template;
	      this.populatedNationalNumberTemplate = template; // With a new formatting template, the matched position
	      // using the old template needs to be reset.

	      this.populatedNationalNumberTemplatePosition = -1; // For convenience, the public `.template` property
	      // contains the whole international number
	      // if the phone number being input is international:
	      // 'x' for the '+' sign, 'x'es for the country phone code,
	      // a spacebar and then the template for the formatted national number.

	      if (state.international) {
	        this.template = this.getInternationalPrefixBeforeCountryCallingCode(state).replace(/[\d\+]/g, DIGIT_PLACEHOLDER) + repeat$1(DIGIT_PLACEHOLDER, state.callingCode.length) + ' ' + template;
	      } else {
	        this.template = template;
	      }
	    }
	    /**
	     * Generates formatting template for a national phone number,
	     * optionally containing a national prefix, for a format.
	     * @param  {Format} format
	     * @param  {string} nationalPrefix
	     * @return {string}
	     */

	  }, {
	    key: "getTemplateForFormat",
	    value: function getTemplateForFormat(format, _ref4) {
	      var nationalSignificantNumber = _ref4.nationalSignificantNumber,
	          international = _ref4.international,
	          nationalPrefix = _ref4.nationalPrefix,
	          complexPrefixBeforeNationalSignificantNumber = _ref4.complexPrefixBeforeNationalSignificantNumber;
	      var pattern = format.pattern();
	      /* istanbul ignore else */

	      {
	        pattern = pattern // Replace anything in the form of [..] with \d
	        .replace(CREATE_CHARACTER_CLASS_PATTERN(), '\\d') // Replace any standalone digit (not the one in `{}`) with \d
	        .replace(CREATE_STANDALONE_DIGIT_PATTERN(), '\\d');
	      } // Generate a dummy national number (consisting of `9`s)
	      // that fits this format's `pattern`.
	      //
	      // This match will always succeed,
	      // because the "longest dummy phone number"
	      // has enough length to accomodate any possible
	      // national phone number format pattern.
	      //


	      var digits = LONGEST_DUMMY_PHONE_NUMBER.match(pattern)[0]; // If the national number entered is too long
	      // for any phone number format, then abort.

	      if (nationalSignificantNumber.length > digits.length) {
	        return;
	      } // Get a formatting template which can be used to efficiently format
	      // a partial number where digits are added one by one.
	      // Below `strictPattern` is used for the
	      // regular expression (with `^` and `$`).
	      // This wasn't originally in Google's `libphonenumber`
	      // and I guess they don't really need it
	      // because they're not using "templates" to format phone numbers
	      // but I added `strictPattern` after encountering
	      // South Korean phone number formatting bug.
	      //
	      // Non-strict regular expression bug demonstration:
	      //
	      // this.nationalSignificantNumber : `111111111` (9 digits)
	      //
	      // pattern : (\d{2})(\d{3,4})(\d{4})
	      // format : `$1 $2 $3`
	      // digits : `9999999999` (10 digits)
	      //
	      // '9999999999'.replace(new RegExp(/(\d{2})(\d{3,4})(\d{4})/g), '$1 $2 $3') = "99 9999 9999"
	      //
	      // template : xx xxxx xxxx
	      //
	      // But the correct template in this case is `xx xxx xxxx`.
	      // The template was generated incorrectly because of the
	      // `{3,4}` variability in the `pattern`.
	      //
	      // The fix is, if `this.nationalSignificantNumber` has already sufficient length
	      // to satisfy the `pattern` completely then `this.nationalSignificantNumber`
	      // is used instead of `digits`.


	      var strictPattern = new RegExp('^' + pattern + '$');
	      var nationalNumberDummyDigits = nationalSignificantNumber.replace(/\d/g, DUMMY_DIGIT); // If `this.nationalSignificantNumber` has already sufficient length
	      // to satisfy the `pattern` completely then use it
	      // instead of `digits`.

	      if (strictPattern.test(nationalNumberDummyDigits)) {
	        digits = nationalNumberDummyDigits;
	      }

	      var numberFormat = this.getFormatFormat(format, international);
	      var nationalPrefixIncludedInTemplate; // If a user did input a national prefix (and that's guaranteed),
	      // and if a `format` does have a national prefix formatting rule,
	      // then see if that national prefix formatting rule
	      // prepends exactly the same national prefix the user has input.
	      // If that's the case, then use the `format` with the national prefix formatting rule.
	      // Otherwise, use  the `format` without the national prefix formatting rule,
	      // and prepend a national prefix manually to it.

	      if (this.shouldTryNationalPrefixFormattingRule(format, {
	        international: international,
	        nationalPrefix: nationalPrefix
	      })) {
	        var numberFormatWithNationalPrefix = numberFormat.replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule()); // If `national_prefix_formatting_rule` of a `format` simply prepends
	        // national prefix at the start of a national (significant) number,
	        // then such formatting can be used with `AsYouType` formatter.
	        // There seems to be no `else` case: everywhere in metadata,
	        // national prefix formatting rule is national prefix + $1,
	        // or `($1)`, in which case such format isn't even considered
	        // when the user has input a national prefix.

	        /* istanbul ignore else */

	        if (parseDigits(format.nationalPrefixFormattingRule()) === (nationalPrefix || '') + parseDigits('$1')) {
	          numberFormat = numberFormatWithNationalPrefix;
	          nationalPrefixIncludedInTemplate = true; // Replace all digits of the national prefix in the formatting template
	          // with `DIGIT_PLACEHOLDER`s.

	          if (nationalPrefix) {
	            var i = nationalPrefix.length;

	            while (i > 0) {
	              numberFormat = numberFormat.replace(/\d/, DIGIT_PLACEHOLDER);
	              i--;
	            }
	          }
	        }
	      } // Generate formatting template for this phone number format.


	      var template = digits // Format the dummy phone number according to the format.
	      .replace(new RegExp(pattern), numberFormat) // Replace each dummy digit with a DIGIT_PLACEHOLDER.
	      .replace(new RegExp(DUMMY_DIGIT, 'g'), DIGIT_PLACEHOLDER); // If a prefix of a national (significant) number is not as simple
	      // as just a basic national prefix, then just prepend such prefix
	      // before the national (significant) number, optionally spacing
	      // the two with a whitespace.

	      if (!nationalPrefixIncludedInTemplate) {
	        if (complexPrefixBeforeNationalSignificantNumber) {
	          // Prepend the prefix to the template manually.
	          template = repeat$1(DIGIT_PLACEHOLDER, complexPrefixBeforeNationalSignificantNumber.length) + ' ' + template;
	        } else if (nationalPrefix) {
	          // Prepend national prefix to the template manually.
	          template = repeat$1(DIGIT_PLACEHOLDER, nationalPrefix.length) + this.getSeparatorAfterNationalPrefix(format) + template;
	        }
	      }

	      if (international) {
	        template = applyInternationalSeparatorStyle(template);
	      }

	      return template;
	    }
	  }, {
	    key: "formatNextNationalNumberDigits",
	    value: function formatNextNationalNumberDigits(digits) {
	      var result = populateTemplateWithDigits(this.populatedNationalNumberTemplate, this.populatedNationalNumberTemplatePosition, digits);

	      if (!result) {
	        // Reset the format.
	        this.resetFormat();
	        return;
	      }

	      this.populatedNationalNumberTemplate = result[0];
	      this.populatedNationalNumberTemplatePosition = result[1]; // Return the formatted phone number so far.

	      return cutAndStripNonPairedParens(this.populatedNationalNumberTemplate, this.populatedNationalNumberTemplatePosition + 1); // The old way which was good for `input-format` but is not so good
	      // for `react-phone-number-input`'s default input (`InputBasic`).
	      // return closeNonPairedParens(this.populatedNationalNumberTemplate, this.populatedNationalNumberTemplatePosition + 1)
	      // 	.replace(new RegExp(DIGIT_PLACEHOLDER, 'g'), ' ')
	    }
	  }, {
	    key: "shouldTryNationalPrefixFormattingRule",
	    value: function shouldTryNationalPrefixFormattingRule(format, _ref5) {
	      var international = _ref5.international,
	          nationalPrefix = _ref5.nationalPrefix;

	      if (format.nationalPrefixFormattingRule()) {
	        // In some countries, `national_prefix_formatting_rule` is `($1)`,
	        // so it applies even if the user hasn't input a national prefix.
	        // `format.usesNationalPrefix()` detects such cases.
	        var usesNationalPrefix = format.usesNationalPrefix();

	        if (usesNationalPrefix && nationalPrefix || !usesNationalPrefix && !international) {
	          return true;
	        }
	      }
	    }
	  }]);

	  return AsYouTypeFormatter;
	}();

	function _slicedToArray$2(arr, i) { return _arrayWithHoles$2(arr) || _iterableToArrayLimit$2(arr, i) || _unsupportedIterableToArray$d(arr, i) || _nonIterableRest$2(); }

	function _nonIterableRest$2() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

	function _unsupportedIterableToArray$d(o, minLen) { if (!o) { return; } if (typeof o === "string") { return _arrayLikeToArray$d(o, minLen); } var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) { n = o.constructor.name; } if (n === "Map" || n === "Set") { return Array.from(o); } if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) { return _arrayLikeToArray$d(o, minLen); } }

	function _arrayLikeToArray$d(arr, len) { if (len == null || len > arr.length) { len = arr.length; } for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

	function _iterableToArrayLimit$2(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) { return; } var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) { break; } } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) { _i["return"](); } } finally { if (_d) { throw _e; } } } return _arr; }

	function _arrayWithHoles$2(arr) { if (Array.isArray(arr)) { return arr; } }

	function _classCallCheck$a(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _defineProperties$a(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) { descriptor.writable = true; } Object.defineProperty(target, descriptor.key, descriptor); } }

	function _createClass$a(Constructor, protoProps, staticProps) { if (protoProps) { _defineProperties$a(Constructor.prototype, protoProps); } if (staticProps) { _defineProperties$a(Constructor, staticProps); } Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
	var VALID_FORMATTED_PHONE_NUMBER_DIGITS_PART = '[' + VALID_PUNCTUATION + VALID_DIGITS + ']+';
	var VALID_FORMATTED_PHONE_NUMBER_DIGITS_PART_PATTERN = new RegExp('^' + VALID_FORMATTED_PHONE_NUMBER_DIGITS_PART + '$', 'i');
	var VALID_FORMATTED_PHONE_NUMBER_PART = '(?:' + '[' + PLUS_CHARS + ']' + '[' + VALID_PUNCTUATION + VALID_DIGITS + ']*' + '|' + '[' + VALID_PUNCTUATION + VALID_DIGITS + ']+' + ')';
	var AFTER_PHONE_NUMBER_DIGITS_END_PATTERN = new RegExp('[^' + VALID_PUNCTUATION + VALID_DIGITS + ']+' + '.*' + '$'); // Tests whether `national_prefix_for_parsing` could match
	// different national prefixes.
	// Matches anything that's not a digit or a square bracket.

	var COMPLEX_NATIONAL_PREFIX = /[^\d\[\]]/;

	var AsYouTypeParser = /*#__PURE__*/function () {
	  function AsYouTypeParser(_ref) {
	    var defaultCountry = _ref.defaultCountry,
	        defaultCallingCode = _ref.defaultCallingCode,
	        metadata = _ref.metadata,
	        onNationalSignificantNumberChange = _ref.onNationalSignificantNumberChange;

	    _classCallCheck$a(this, AsYouTypeParser);

	    this.defaultCountry = defaultCountry;
	    this.defaultCallingCode = defaultCallingCode;
	    this.metadata = metadata;
	    this.onNationalSignificantNumberChange = onNationalSignificantNumberChange;
	  }

	  _createClass$a(AsYouTypeParser, [{
	    key: "input",
	    value: function input(text, state) {
	      var _extractFormattedDigi = extractFormattedDigitsAndPlus(text),
	          _extractFormattedDigi2 = _slicedToArray$2(_extractFormattedDigi, 2),
	          formattedDigits = _extractFormattedDigi2[0],
	          hasPlus = _extractFormattedDigi2[1];

	      var digits = parseDigits(formattedDigits); // Checks for a special case: just a leading `+` has been entered.

	      var justLeadingPlus;

	      if (hasPlus) {
	        if (!state.digits) {
	          state.startInternationalNumber();

	          if (!digits) {
	            justLeadingPlus = true;
	          }
	        }
	      }

	      if (digits) {
	        this.inputDigits(digits, state);
	      }

	      return {
	        digits: digits,
	        justLeadingPlus: justLeadingPlus
	      };
	    }
	    /**
	     * Inputs "next" phone number digits.
	     * @param  {string} digits
	     * @return {string} [formattedNumber] Formatted national phone number (if it can be formatted at this stage). Returning `undefined` means "don't format the national phone number at this stage".
	     */

	  }, {
	    key: "inputDigits",
	    value: function inputDigits(nextDigits, state) {
	      var digits = state.digits;
	      var hasReceivedThreeLeadingDigits = digits.length < 3 && digits.length + nextDigits.length >= 3; // Append phone number digits.

	      state.appendDigits(nextDigits); // Attempt to extract IDD prefix:
	      // Some users input their phone number in international format,
	      // but in an "out-of-country" dialing format instead of using the leading `+`.
	      // https://github.com/catamphetamine/libphonenumber-js/issues/185
	      // Detect such numbers as soon as there're at least 3 digits.
	      // Google's library attempts to extract IDD prefix at 3 digits,
	      // so this library just copies that behavior.
	      // I guess that's because the most commot IDD prefixes are
	      // `00` (Europe) and `011` (US).
	      // There exist really long IDD prefixes too:
	      // for example, in Australia the default IDD prefix is `0011`,
	      // and it could even be as long as `14880011`.
	      // An IDD prefix is extracted here, and then every time when
	      // there's a new digit and the number couldn't be formatted.

	      if (hasReceivedThreeLeadingDigits) {
	        this.extractIddPrefix(state);
	      }

	      if (this.isWaitingForCountryCallingCode(state)) {
	        if (!this.extractCountryCallingCode(state)) {
	          return;
	        }
	      } else {
	        state.appendNationalSignificantNumberDigits(nextDigits);
	      } // If a phone number is being input in international format,
	      // then it's not valid for it to have a national prefix.
	      // Still, some people incorrectly input such numbers with a national prefix.
	      // In such cases, only attempt to strip a national prefix if the number becomes too long.
	      // (but that is done later, not here)


	      if (!state.international) {
	        if (!this.hasExtractedNationalSignificantNumber) {
	          this.extractNationalSignificantNumber(state.getNationalDigits(), function (stateUpdate) {
	            return state.update(stateUpdate);
	          });
	        }
	      }
	    }
	  }, {
	    key: "isWaitingForCountryCallingCode",
	    value: function isWaitingForCountryCallingCode(_ref2) {
	      var international = _ref2.international,
	          callingCode = _ref2.callingCode;
	      return international && !callingCode;
	    } // Extracts a country calling code from a number
	    // being entered in internatonal format.

	  }, {
	    key: "extractCountryCallingCode",
	    value: function extractCountryCallingCode$$1(state) {
	      var _extractCountryCallin = extractCountryCallingCode('+' + state.getDigitsWithoutInternationalPrefix(), this.defaultCountry, this.defaultCallingCode, this.metadata.metadata),
	          countryCallingCode = _extractCountryCallin.countryCallingCode,
	          number = _extractCountryCallin.number;

	      if (countryCallingCode) {
	        state.setCallingCode(countryCallingCode);
	        state.update({
	          nationalSignificantNumber: number
	        });
	        return true;
	      }
	    }
	  }, {
	    key: "reset",
	    value: function reset(numberingPlan) {
	      if (numberingPlan) {
	        this.hasSelectedNumberingPlan = true;

	        var nationalPrefixForParsing = numberingPlan._nationalPrefixForParsing();

	        this.couldPossiblyExtractAnotherNationalSignificantNumber = nationalPrefixForParsing && COMPLEX_NATIONAL_PREFIX.test(nationalPrefixForParsing);
	      } else {
	        this.hasSelectedNumberingPlan = undefined;
	        this.couldPossiblyExtractAnotherNationalSignificantNumber = undefined;
	      }
	    }
	    /**
	     * Extracts a national (significant) number from user input.
	     * Google's library is different in that it only applies `national_prefix_for_parsing`
	     * and doesn't apply `national_prefix_transform_rule` after that.
	     * https://github.com/google/libphonenumber/blob/a3d70b0487875475e6ad659af404943211d26456/java/libphonenumber/src/com/google/i18n/phonenumbers/AsYouTypeFormatter.java#L539
	     * @return {boolean} [extracted]
	     */

	  }, {
	    key: "extractNationalSignificantNumber",
	    value: function extractNationalSignificantNumber(nationalDigits, setState) {
	      if (!this.hasSelectedNumberingPlan) {
	        return;
	      }

	      var _extractNationalNumbe = extractNationalNumberFromPossiblyIncompleteNumber(nationalDigits, this.metadata),
	          nationalPrefix = _extractNationalNumbe.nationalPrefix,
	          nationalNumber = _extractNationalNumbe.nationalNumber,
	          carrierCode = _extractNationalNumbe.carrierCode;

	      if (nationalNumber === nationalDigits) {
	        return;
	      }

	      this.onExtractedNationalNumber(nationalPrefix, carrierCode, nationalNumber, nationalDigits, setState);
	      return true;
	    }
	    /**
	     * In Google's code this function is called "attempt to extract longer NDD".
	     * "Some national prefixes are a substring of others", they say.
	     * @return {boolean} [result] — Returns `true` if extracting a national prefix produced different results from what they were.
	     */

	  }, {
	    key: "extractAnotherNationalSignificantNumber",
	    value: function extractAnotherNationalSignificantNumber(nationalDigits, prevNationalSignificantNumber, setState) {
	      if (!this.hasExtractedNationalSignificantNumber) {
	        return this.extractNationalSignificantNumber(nationalDigits, setState);
	      }

	      if (!this.couldPossiblyExtractAnotherNationalSignificantNumber) {
	        return;
	      }

	      var _extractNationalNumbe2 = extractNationalNumberFromPossiblyIncompleteNumber(nationalDigits, this.metadata),
	          nationalPrefix = _extractNationalNumbe2.nationalPrefix,
	          nationalNumber = _extractNationalNumbe2.nationalNumber,
	          carrierCode = _extractNationalNumbe2.carrierCode; // If a national prefix has been extracted previously,
	      // then it's always extracted as additional digits are added.
	      // That's assuming `extractNationalNumberFromPossiblyIncompleteNumber()`
	      // doesn't do anything different from what it currently does.
	      // So, just in case, here's this check, though it doesn't occur.

	      /* istanbul ignore if */


	      if (nationalNumber === prevNationalSignificantNumber) {
	        return;
	      }

	      this.onExtractedNationalNumber(nationalPrefix, carrierCode, nationalNumber, nationalDigits, setState);
	      return true;
	    }
	  }, {
	    key: "onExtractedNationalNumber",
	    value: function onExtractedNationalNumber(nationalPrefix, carrierCode, nationalSignificantNumber, nationalDigits, setState) {
	      var complexPrefixBeforeNationalSignificantNumber;
	      var nationalSignificantNumberMatchesInput; // This check also works with empty `this.nationalSignificantNumber`.

	      var nationalSignificantNumberIndex = nationalDigits.lastIndexOf(nationalSignificantNumber); // If the extracted national (significant) number is the
	      // last substring of the `digits`, then it means that it hasn't been altered:
	      // no digits have been removed from the national (significant) number
	      // while applying `national_prefix_transform_rule`.
	      // https://gitlab.com/catamphetamine/libphonenumber-js/-/blob/master/METADATA.md#national_prefix_for_parsing--national_prefix_transform_rule

	      if (nationalSignificantNumberIndex >= 0 && nationalSignificantNumberIndex === nationalDigits.length - nationalSignificantNumber.length) {
	        nationalSignificantNumberMatchesInput = true; // If a prefix of a national (significant) number is not as simple
	        // as just a basic national prefix, then such prefix is stored in
	        // `this.complexPrefixBeforeNationalSignificantNumber` property and will be
	        // prepended "as is" to the national (significant) number to produce
	        // a formatted result.

	        var prefixBeforeNationalNumber = nationalDigits.slice(0, nationalSignificantNumberIndex); // `prefixBeforeNationalNumber` is always non-empty,
	        // because `onExtractedNationalNumber()` isn't called
	        // when a national (significant) number hasn't been actually "extracted":
	        // when a national (significant) number is equal to the national part of `digits`,
	        // then `onExtractedNationalNumber()` doesn't get called.

	        if (prefixBeforeNationalNumber !== nationalPrefix) {
	          complexPrefixBeforeNationalSignificantNumber = prefixBeforeNationalNumber;
	        }
	      }

	      setState({
	        nationalPrefix: nationalPrefix,
	        carrierCode: carrierCode,
	        nationalSignificantNumber: nationalSignificantNumber,
	        nationalSignificantNumberMatchesInput: nationalSignificantNumberMatchesInput,
	        complexPrefixBeforeNationalSignificantNumber: complexPrefixBeforeNationalSignificantNumber
	      }); // `onExtractedNationalNumber()` is only called when
	      // the national (significant) number actually did change.

	      this.hasExtractedNationalSignificantNumber = true;
	      this.onNationalSignificantNumberChange();
	    }
	  }, {
	    key: "reExtractNationalSignificantNumber",
	    value: function reExtractNationalSignificantNumber(state) {
	      // Attempt to extract a national prefix.
	      //
	      // Some people incorrectly input national prefix
	      // in an international phone number.
	      // For example, some people write British phone numbers as `+44(0)...`.
	      //
	      // Also, in some rare cases, it is valid for a national prefix
	      // to be a part of an international phone number.
	      // For example, mobile phone numbers in Mexico are supposed to be
	      // dialled internationally using a `1` national prefix,
	      // so the national prefix will be part of an international number.
	      //
	      // Quote from:
	      // https://www.mexperience.com/dialing-cell-phones-in-mexico/
	      //
	      // "Dialing a Mexican cell phone from abroad
	      // When you are calling a cell phone number in Mexico from outside Mexico,
	      // it’s necessary to dial an additional “1” after Mexico’s country code
	      // (which is “52”) and before the area code.
	      // You also ignore the 045, and simply dial the area code and the
	      // cell phone’s number.
	      //
	      // If you don’t add the “1”, you’ll receive a recorded announcement
	      // asking you to redial using it.
	      //
	      // For example, if you are calling from the USA to a cell phone
	      // in Mexico City, you would dial +52 – 1 – 55 – 1234 5678.
	      // (Note that this is different to calling a land line in Mexico City
	      // from abroad, where the number dialed would be +52 – 55 – 1234 5678)".
	      //
	      // Google's demo output:
	      // https://libphonenumber.appspot.com/phonenumberparser?number=%2b5215512345678&country=MX
	      //
	      if (this.extractAnotherNationalSignificantNumber(state.getNationalDigits(), state.nationalSignificantNumber, function (stateUpdate) {
	        return state.update(stateUpdate);
	      })) {
	        return true;
	      } // If no format matches the phone number, then it could be
	      // "a really long IDD" (quote from a comment in Google's library).
	      // An IDD prefix is first extracted when the user has entered at least 3 digits,
	      // and then here — every time when there's a new digit and the number
	      // couldn't be formatted.
	      // For example, in Australia the default IDD prefix is `0011`,
	      // and it could even be as long as `14880011`.
	      //
	      // Could also check `!hasReceivedThreeLeadingDigits` here
	      // to filter out the case when this check duplicates the one
	      // already performed when there're 3 leading digits,
	      // but it's not a big deal, and in most cases there
	      // will be a suitable `format` when there're 3 leading digits.
	      //


	      if (this.extractIddPrefix(state)) {
	        this.extractCallingCodeAndNationalSignificantNumber(state);
	        return true;
	      } // Google's AsYouType formatter supports sort of an "autocorrection" feature
	      // when it "autocorrects" numbers that have been input for a country
	      // with that country's calling code.
	      // Such "autocorrection" feature looks weird, but different people have been requesting it:
	      // https://github.com/catamphetamine/libphonenumber-js/issues/376
	      // https://github.com/catamphetamine/libphonenumber-js/issues/375
	      // https://github.com/catamphetamine/libphonenumber-js/issues/316


	      if (this.fixMissingPlus(state)) {
	        this.extractCallingCodeAndNationalSignificantNumber(state);
	        return true;
	      }
	    }
	  }, {
	    key: "extractIddPrefix",
	    value: function extractIddPrefix(state) {
	      // An IDD prefix can't be present in a number written with a `+`.
	      // Also, don't re-extract an IDD prefix if has already been extracted.
	      var international = state.international,
	          IDDPrefix = state.IDDPrefix,
	          digits = state.digits,
	          nationalSignificantNumber = state.nationalSignificantNumber;

	      if (international || IDDPrefix) {
	        return;
	      } // Some users input their phone number in "out-of-country"
	      // dialing format instead of using the leading `+`.
	      // https://github.com/catamphetamine/libphonenumber-js/issues/185
	      // Detect such numbers.


	      var numberWithoutIDD = stripIddPrefix(digits, this.defaultCountry, this.defaultCallingCode, this.metadata.metadata);

	      if (numberWithoutIDD !== undefined && numberWithoutIDD !== digits) {
	        // If an IDD prefix was stripped then convert the IDD-prefixed number
	        // to international number for subsequent parsing.
	        state.update({
	          IDDPrefix: digits.slice(0, digits.length - numberWithoutIDD.length)
	        });
	        this.startInternationalNumber(state, {
	          country: undefined,
	          callingCode: undefined
	        });
	        return true;
	      }
	    }
	  }, {
	    key: "fixMissingPlus",
	    value: function fixMissingPlus(state) {
	      if (!state.international) {
	        var _extractCountryCallin2 = extractCountryCallingCodeFromInternationalNumberWithoutPlusSign(state.digits, this.defaultCountry, this.defaultCallingCode, this.metadata.metadata),
	            newCallingCode = _extractCountryCallin2.countryCallingCode,
	            number = _extractCountryCallin2.number;

	        if (newCallingCode) {
	          state.update({
	            missingPlus: true
	          });
	          this.startInternationalNumber(state, {
	            country: state.country,
	            callingCode: newCallingCode
	          });
	          return true;
	        }
	      }
	    }
	  }, {
	    key: "startInternationalNumber",
	    value: function startInternationalNumber(state, _ref3) {
	      var country = _ref3.country,
	          callingCode = _ref3.callingCode;
	      state.startInternationalNumber(country, callingCode); // If a national (significant) number has been extracted before, reset it.

	      if (state.nationalSignificantNumber) {
	        state.resetNationalSignificantNumber();
	        this.onNationalSignificantNumberChange();
	        this.hasExtractedNationalSignificantNumber = undefined;
	      }
	    }
	  }, {
	    key: "extractCallingCodeAndNationalSignificantNumber",
	    value: function extractCallingCodeAndNationalSignificantNumber(state) {
	      if (this.extractCountryCallingCode(state)) {
	        // `this.extractCallingCode()` is currently called when the number
	        // couldn't be formatted during the standard procedure.
	        // Normally, the national prefix would be re-extracted
	        // for an international number if such number couldn't be formatted,
	        // but since it's already not able to be formatted,
	        // there won't be yet another retry, so also extract national prefix here.
	        this.extractNationalSignificantNumber(state.getNationalDigits(), function (stateUpdate) {
	          return state.update(stateUpdate);
	        });
	      }
	    }
	  }]);

	  return AsYouTypeParser;
	}();

	function extractFormattedPhoneNumber$1(text) {
	  // Attempt to extract a possible number from the string passed in.
	  var startsAt = text.search(VALID_FORMATTED_PHONE_NUMBER_PART);

	  if (startsAt < 0) {
	    return;
	  } // Trim everything to the left of the phone number.


	  text = text.slice(startsAt); // Trim the `+`.

	  var hasPlus;

	  if (text[0] === '+') {
	    hasPlus = true;
	    text = text.slice('+'.length);
	  } // Trim everything to the right of the phone number.


	  text = text.replace(AFTER_PHONE_NUMBER_DIGITS_END_PATTERN, ''); // Re-add the previously trimmed `+`.

	  if (hasPlus) {
	    text = '+' + text;
	  }

	  return text;
	}
	/**
	 * Extracts formatted phone number digits (and a `+`) from text (if there're any).
	 * @param  {string} text
	 * @return {any[]}
	 */


	function _extractFormattedDigitsAndPlus(text) {
	  // Extract a formatted phone number part from text.
	  var extractedNumber = extractFormattedPhoneNumber$1(text) || ''; // Trim a `+`.

	  if (extractedNumber[0] === '+') {
	    return [extractedNumber.slice('+'.length), true];
	  }

	  return [extractedNumber];
	}
	/**
	 * Extracts formatted phone number digits (and a `+`) from text (if there're any).
	 * @param  {string} text
	 * @return {any[]}
	 */


	function extractFormattedDigitsAndPlus(text) {
	  var _extractFormattedDigi3 = _extractFormattedDigitsAndPlus(text),
	      _extractFormattedDigi4 = _slicedToArray$2(_extractFormattedDigi3, 2),
	      formattedDigits = _extractFormattedDigi4[0],
	      hasPlus = _extractFormattedDigi4[1]; // If the extracted phone number part
	  // can possibly be a part of some valid phone number
	  // then parse phone number characters from a formatted phone number.


	  if (!VALID_FORMATTED_PHONE_NUMBER_DIGITS_PART_PATTERN.test(formattedDigits)) {
	    formattedDigits = '';
	  }

	  return [formattedDigits, hasPlus];
	}

	function _typeof$4(obj) { "@babel/helpers - typeof"; return _typeof$4 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof$4(obj); }

	function _slicedToArray$3(arr, i) { return _arrayWithHoles$3(arr) || _iterableToArrayLimit$3(arr, i) || _unsupportedIterableToArray$e(arr, i) || _nonIterableRest$3(); }

	function _nonIterableRest$3() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

	function _unsupportedIterableToArray$e(o, minLen) { if (!o) { return; } if (typeof o === "string") { return _arrayLikeToArray$e(o, minLen); } var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) { n = o.constructor.name; } if (n === "Map" || n === "Set") { return Array.from(o); } if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) { return _arrayLikeToArray$e(o, minLen); } }

	function _arrayLikeToArray$e(arr, len) { if (len == null || len > arr.length) { len = arr.length; } for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

	function _iterableToArrayLimit$3(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) { return; } var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) { break; } } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) { _i["return"](); } } finally { if (_d) { throw _e; } } } return _arr; }

	function _arrayWithHoles$3(arr) { if (Array.isArray(arr)) { return arr; } }

	function _classCallCheck$b(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _defineProperties$b(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) { descriptor.writable = true; } Object.defineProperty(target, descriptor.key, descriptor); } }

	function _createClass$b(Constructor, protoProps, staticProps) { if (protoProps) { _defineProperties$b(Constructor.prototype, protoProps); } if (staticProps) { _defineProperties$b(Constructor, staticProps); } Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

	var AsYouType = /*#__PURE__*/function () {
	  /**
	   * @param {(string|object)?} [optionsOrDefaultCountry] - The default country used for parsing non-international phone numbers. Can also be an `options` object.
	   * @param {Object} metadata
	   */
	  function AsYouType(optionsOrDefaultCountry, metadata) {
	    _classCallCheck$b(this, AsYouType);

	    this.metadata = new Metadata(metadata);

	    var _this$getCountryAndCa = this.getCountryAndCallingCode(optionsOrDefaultCountry),
	        _this$getCountryAndCa2 = _slicedToArray$3(_this$getCountryAndCa, 2),
	        defaultCountry = _this$getCountryAndCa2[0],
	        defaultCallingCode = _this$getCountryAndCa2[1];

	    this.defaultCountry = defaultCountry;
	    this.defaultCallingCode = defaultCallingCode;
	    this.reset();
	  }

	  _createClass$b(AsYouType, [{
	    key: "getCountryAndCallingCode",
	    value: function getCountryAndCallingCode(optionsOrDefaultCountry) {
	      // Set `defaultCountry` and `defaultCallingCode` options.
	      var defaultCountry;
	      var defaultCallingCode; // Turns out `null` also has type "object". Weird.

	      if (optionsOrDefaultCountry) {
	        if (_typeof$4(optionsOrDefaultCountry) === 'object') {
	          defaultCountry = optionsOrDefaultCountry.defaultCountry;
	          defaultCallingCode = optionsOrDefaultCountry.defaultCallingCode;
	        } else {
	          defaultCountry = optionsOrDefaultCountry;
	        }
	      }

	      if (defaultCountry && !this.metadata.hasCountry(defaultCountry)) {
	        defaultCountry = undefined;
	      }

	      return [defaultCountry, defaultCallingCode];
	    }
	    /**
	     * Inputs "next" phone number characters.
	     * @param  {string} text
	     * @return {string} Formatted phone number characters that have been input so far.
	     */

	  }, {
	    key: "input",
	    value: function input(text) {
	      var _this$parser$input = this.parser.input(text, this.state),
	          digits = _this$parser$input.digits,
	          justLeadingPlus = _this$parser$input.justLeadingPlus;

	      if (justLeadingPlus) {
	        this.formattedOutput = '+';
	      } else if (digits) {
	        this.determineTheCountryIfNeeded(); // Match the available formats by the currently available leading digits.

	        if (this.state.nationalSignificantNumber) {
	          this.formatter.narrowDownMatchingFormats(this.state);
	        }

	        var formattedNationalNumber;

	        if (this.metadata.hasSelectedNumberingPlan()) {
	          formattedNationalNumber = this.formatter.format(digits, this.state);
	        }

	        if (formattedNationalNumber === undefined) {
	          // See if another national (significant) number could be re-extracted.
	          if (this.parser.reExtractNationalSignificantNumber(this.state)) {
	            this.determineTheCountryIfNeeded(); // If it could, then re-try formatting the new national (significant) number.

	            var nationalDigits = this.state.getNationalDigits();

	            if (nationalDigits) {
	              formattedNationalNumber = this.formatter.format(nationalDigits, this.state);
	            }
	          }
	        }

	        this.formattedOutput = formattedNationalNumber ? this.getFullNumber(formattedNationalNumber) : this.getNonFormattedNumber();
	      }

	      return this.formattedOutput;
	    }
	  }, {
	    key: "reset",
	    value: function reset() {
	      var _this = this;

	      this.state = new AsYouTypeState({
	        onCountryChange: function onCountryChange(country) {
	          // Before version `1.6.0`, the official `AsYouType` formatter API
	          // included the `.country` property of an `AsYouType` instance.
	          // Since that property (along with the others) have been moved to
	          // `this.state`, `this.country` property is emulated for compatibility
	          // with the old versions.
	          _this.country = country;
	        },
	        onCallingCodeChange: function onCallingCodeChange(callingCode, country) {
	          _this.metadata.selectNumberingPlan(country, callingCode);

	          _this.formatter.reset(_this.metadata.numberingPlan, _this.state);

	          _this.parser.reset(_this.metadata.numberingPlan);
	        }
	      });
	      this.formatter = new AsYouTypeFormatter({
	        state: this.state,
	        metadata: this.metadata
	      });
	      this.parser = new AsYouTypeParser({
	        defaultCountry: this.defaultCountry,
	        defaultCallingCode: this.defaultCallingCode,
	        metadata: this.metadata,
	        state: this.state,
	        onNationalSignificantNumberChange: function onNationalSignificantNumberChange() {
	          _this.determineTheCountryIfNeeded();

	          _this.formatter.reset(_this.metadata.numberingPlan, _this.state);
	        }
	      });
	      this.state.reset(this.defaultCountry, this.defaultCallingCode);
	      this.formattedOutput = '';
	      return this;
	    }
	    /**
	     * Returns `true` if the phone number is being input in international format.
	     * In other words, returns `true` if and only if the parsed phone number starts with a `"+"`.
	     * @return {boolean}
	     */

	  }, {
	    key: "isInternational",
	    value: function isInternational() {
	      return this.state.international;
	    }
	    /**
	     * Returns the "calling code" part of the phone number when it's being input
	     * in an international format.
	     * If no valid calling code has been entered so far, returns `undefined`.
	     * @return {string} [callingCode]
	     */

	  }, {
	    key: "getCallingCode",
	    value: function getCallingCode() {
	      // If the number is being input in national format and some "default calling code"
	      // has been passed to `AsYouType` constructor, then `this.state.callingCode`
	      // is equal to that "default calling code".
	      //
	      // If the number is being input in national format and no "default calling code"
	      // has been passed to `AsYouType` constructor, then returns `undefined`,
	      // even if a "default country" has been passed to `AsYouType` constructor.
	      //
	      if (this.isInternational()) {
	        return this.state.callingCode;
	      }
	    } // A legacy alias.

	  }, {
	    key: "getCountryCallingCode",
	    value: function getCountryCallingCode$$1() {
	      return this.getCallingCode();
	    }
	    /**
	     * Returns a two-letter country code of the phone number.
	     * Returns `undefined` for "non-geographic" phone numbering plans.
	     * Returns `undefined` if no phone number has been input yet.
	     * @return {string} [country]
	     */

	  }, {
	    key: "getCountry",
	    value: function getCountry() {
	      var digits = this.state.digits; // Return `undefined` if no digits have been input yet.

	      if (digits) {
	        return this._getCountry();
	      }
	    }
	    /**
	     * Returns a two-letter country code of the phone number.
	     * Returns `undefined` for "non-geographic" phone numbering plans.
	     * @return {string} [country]
	     */

	  }, {
	    key: "_getCountry",
	    value: function _getCountry() {
	      var country = this.state.country;

	      return country;
	    }
	  }, {
	    key: "determineTheCountryIfNeeded",
	    value: function determineTheCountryIfNeeded() {
	      // Suppose a user enters a phone number in international format,
	      // and there're several countries corresponding to that country calling code,
	      // and a country has been derived from the number, and then
	      // a user enters one more digit and the number is no longer
	      // valid for the derived country, so the country should be re-derived
	      // on every new digit in those cases.
	      //
	      // If the phone number is being input in national format,
	      // then it could be a case when `defaultCountry` wasn't specified
	      // when creating `AsYouType` instance, and just `defaultCallingCode` was specified,
	      // and that "calling code" could correspond to a "non-geographic entity",
	      // or there could be several countries corresponding to that country calling code.
	      // In those cases, `this.country` is `undefined` and should be derived
	      // from the number. Again, if country calling code is ambiguous, then
	      // `this.country` should be re-derived with each new digit.
	      //
	      if (!this.state.country || this.isCountryCallingCodeAmbiguous()) {
	        this.determineTheCountry();
	      }
	    } // Prepends `+CountryCode ` in case of an international phone number

	  }, {
	    key: "getFullNumber",
	    value: function getFullNumber(formattedNationalNumber) {
	      var _this2 = this;

	      if (this.isInternational()) {
	        var prefix = function prefix(text) {
	          return _this2.formatter.getInternationalPrefixBeforeCountryCallingCode(_this2.state, {
	            spacing: text ? true : false
	          }) + text;
	        };

	        var callingCode = this.state.callingCode;

	        if (!callingCode) {
	          return prefix("".concat(this.state.getDigitsWithoutInternationalPrefix()));
	        }

	        if (!formattedNationalNumber) {
	          return prefix(callingCode);
	        }

	        return prefix("".concat(callingCode, " ").concat(formattedNationalNumber));
	      }

	      return formattedNationalNumber;
	    }
	  }, {
	    key: "getNonFormattedNationalNumberWithPrefix",
	    value: function getNonFormattedNationalNumberWithPrefix() {
	      var _this$state = this.state,
	          nationalSignificantNumber = _this$state.nationalSignificantNumber,
	          complexPrefixBeforeNationalSignificantNumber = _this$state.complexPrefixBeforeNationalSignificantNumber,
	          nationalPrefix = _this$state.nationalPrefix;
	      var number = nationalSignificantNumber;
	      var prefix = complexPrefixBeforeNationalSignificantNumber || nationalPrefix;

	      if (prefix) {
	        number = prefix + number;
	      }

	      return number;
	    }
	  }, {
	    key: "getNonFormattedNumber",
	    value: function getNonFormattedNumber() {
	      var nationalSignificantNumberMatchesInput = this.state.nationalSignificantNumberMatchesInput;
	      return this.getFullNumber(nationalSignificantNumberMatchesInput ? this.getNonFormattedNationalNumberWithPrefix() : this.state.getNationalDigits());
	    }
	  }, {
	    key: "getNonFormattedTemplate",
	    value: function getNonFormattedTemplate() {
	      var number = this.getNonFormattedNumber();

	      if (number) {
	        return number.replace(/[\+\d]/g, DIGIT_PLACEHOLDER);
	      }
	    }
	  }, {
	    key: "isCountryCallingCodeAmbiguous",
	    value: function isCountryCallingCodeAmbiguous() {
	      var callingCode = this.state.callingCode;
	      var countryCodes = this.metadata.getCountryCodesForCallingCode(callingCode);
	      return countryCodes && countryCodes.length > 1;
	    } // Determines the country of the phone number
	    // entered so far based on the country phone code
	    // and the national phone number.

	  }, {
	    key: "determineTheCountry",
	    value: function determineTheCountry() {
	      this.state.setCountry(getCountryByCallingCode(this.isInternational() ? this.state.callingCode : this.defaultCallingCode, this.state.nationalSignificantNumber, this.metadata));
	    }
	    /**
	     * Returns a E.164 phone number value for the user's input.
	     *
	     * For example, for country `"US"` and input `"(222) 333-4444"`
	     * it will return `"+12223334444"`.
	     *
	     * For international phone number input, it will also auto-correct
	     * some minor errors such as using a national prefix when writing
	     * an international phone number. For example, if the user inputs
	     * `"+44 0 7400 000000"` then it will return an auto-corrected
	     * `"+447400000000"` phone number value.
	     *
	     * Will return `undefined` if no digits have been input,
	     * or when inputting a phone number in national format and no
	     * default country or default "country calling code" have been set.
	     *
	     * @return {string} [value]
	     */

	  }, {
	    key: "getNumberValue",
	    value: function getNumberValue() {
	      var _this$state2 = this.state,
	          digits = _this$state2.digits,
	          callingCode = _this$state2.callingCode,
	          country = _this$state2.country,
	          nationalSignificantNumber = _this$state2.nationalSignificantNumber; // Will return `undefined` if no digits have been input.

	      if (!digits) {
	        return;
	      }

	      if (this.isInternational()) {
	        if (callingCode) {
	          return '+' + callingCode + nationalSignificantNumber;
	        } else {
	          return '+' + digits;
	        }
	      } else {
	        if (country || callingCode) {
	          var callingCode_ = country ? this.metadata.countryCallingCode() : callingCode;
	          return '+' + callingCode_ + nationalSignificantNumber;
	        }
	      }
	    }
	    /**
	     * Returns an instance of `PhoneNumber` class.
	     * Will return `undefined` if no national (significant) number
	     * digits have been entered so far, or if no `defaultCountry` has been
	     * set and the user enters a phone number not in international format.
	     */

	  }, {
	    key: "getNumber",
	    value: function getNumber() {
	      var _this$state3 = this.state,
	          nationalSignificantNumber = _this$state3.nationalSignificantNumber,
	          carrierCode = _this$state3.carrierCode,
	          callingCode = _this$state3.callingCode; // `this._getCountry()` is basically same as `this.state.country`
	      // with the only change that it return `undefined` in case of a
	      // "non-geographic" numbering plan instead of `"001"` "internal use" value.

	      var country = this._getCountry();

	      if (!nationalSignificantNumber) {
	        return;
	      }

	      if (!country && !callingCode) {
	        return;
	      }

	      var phoneNumber = new PhoneNumber(country || callingCode, nationalSignificantNumber, this.metadata.metadata);

	      if (carrierCode) {
	        phoneNumber.carrierCode = carrierCode;
	      } // Phone number extensions are not supported by "As You Type" formatter.


	      return phoneNumber;
	    }
	    /**
	     * Returns `true` if the phone number is "possible".
	     * Is just a shortcut for `PhoneNumber.isPossible()`.
	     * @return {boolean}
	     */

	  }, {
	    key: "isPossible",
	    value: function isPossible() {
	      var phoneNumber = this.getNumber();

	      if (!phoneNumber) {
	        return false;
	      }

	      return phoneNumber.isPossible();
	    }
	    /**
	     * Returns `true` if the phone number is "valid".
	     * Is just a shortcut for `PhoneNumber.isValid()`.
	     * @return {boolean}
	     */

	  }, {
	    key: "isValid",
	    value: function isValid() {
	      var phoneNumber = this.getNumber();

	      if (!phoneNumber) {
	        return false;
	      }

	      return phoneNumber.isValid();
	    }
	    /**
	     * @deprecated
	     * This method is used in `react-phone-number-input/source/input-control.js`
	     * in versions before `3.0.16`.
	     */

	  }, {
	    key: "getNationalNumber",
	    value: function getNationalNumber() {
	      return this.state.nationalSignificantNumber;
	    }
	    /**
	     * Returns the phone number characters entered by the user.
	     * @return {string}
	     */

	  }, {
	    key: "getChars",
	    value: function getChars() {
	      return (this.state.international ? '+' : '') + this.state.digits;
	    }
	    /**
	     * Returns the template for the formatted phone number.
	     * @return {string}
	     */

	  }, {
	    key: "getTemplate",
	    value: function getTemplate() {
	      return this.formatter.getTemplate(this.state) || this.getNonFormattedTemplate() || '';
	    }
	  }]);

	  return AsYouType;
	}();

	// Importing from a ".js" file is a workaround for Node.js "ES Modules"

	function PhoneNumberMatcher$1(text, options) {
		return PhoneNumberMatcher.call(this, text, options, metadata)
	}
	PhoneNumberMatcher$1.prototype = Object.create(PhoneNumberMatcher.prototype, {});
	PhoneNumberMatcher$1.prototype.constructor = PhoneNumberMatcher$1;

	// Importing from a ".js" file is a workaround for Node.js "ES Modules"

	function AsYouType$1(country) {
		return AsYouType.call(this, country, metadata)
	}

	AsYouType$1.prototype = Object.create(AsYouType.prototype, {});
	AsYouType$1.prototype.constructor = AsYouType$1;

	// Importing from a ".js" file is a workaround for Node.js "ES Modules"

	function Metadata$1() {
		return Metadata.call(this, metadata)
	}

	Metadata$1.prototype = Object.create(Metadata.prototype, {});
	Metadata$1.prototype.constructor = Metadata$1;

	// Deprecated.

	// Deprecated.

	function _classCallCheck$c(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _defineProperties$c(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) { descriptor.writable = true; } Object.defineProperty(target, descriptor.key, descriptor); } }

	function _createClass$c(Constructor, protoProps, staticProps) { if (protoProps) { _defineProperties$c(Constructor.prototype, protoProps); } if (staticProps) { _defineProperties$c(Constructor, staticProps); } Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
	var WHITESPACE_IN_THE_BEGINNING_PATTERN = new RegExp('^[' + WHITESPACE + ']+');
	var PUNCTUATION_IN_THE_END_PATTERN = new RegExp('[' + VALID_PUNCTUATION + ']+$'); // // Regular expression for getting opening brackets for a valid number
	/**
	 * Extracts a parseable phone number including any opening brackets, etc.
	 * @param  {string} text - Input.
	 * @return {object} `{ ?number, ?startsAt, ?endsAt }`.
	 */

	var PhoneNumberSearch = /*#__PURE__*/function () {
	  function PhoneNumberSearch(text, options, metadata) {
	    _classCallCheck$c(this, PhoneNumberSearch);

	    this.text = text; // If assigning the `{}` default value is moved to the arguments above,
	    // code coverage would decrease for some weird reason.

	    this.options = options || {};
	    this.metadata = metadata; // Iteration tristate.

	    this.state = 'NOT_READY';
	    this.regexp = new RegExp(VALID_PHONE_NUMBER_WITH_EXTENSION, 'ig');
	  }

	  _createClass$c(PhoneNumberSearch, [{
	    key: "find",
	    value: function find() {
	      var matches = this.regexp.exec(this.text);

	      if (!matches) {
	        return;
	      }

	      var number = matches[0];
	      var startsAt = matches.index;
	      number = number.replace(WHITESPACE_IN_THE_BEGINNING_PATTERN, '');
	      startsAt += matches[0].length - number.length; // Fixes not parsing numbers with whitespace in the end.
	      // Also fixes not parsing numbers with opening parentheses in the end.
	      // https://github.com/catamphetamine/libphonenumber-js/issues/252

	      number = number.replace(PUNCTUATION_IN_THE_END_PATTERN, '');
	      number = parsePreCandidate(number);
	      var result = this.parseCandidate(number, startsAt);

	      if (result) {
	        return result;
	      } // Tail recursion.
	      // Try the next one if this one is not a valid phone number.


	      return this.find();
	    }
	  }, {
	    key: "parseCandidate",
	    value: function parseCandidate(number, startsAt) {
	      if (!isValidPreCandidate(number, startsAt, this.text)) {
	        return;
	      } // Don't parse phone numbers which are non-phone numbers
	      // due to being part of something else (e.g. a UUID).
	      // https://github.com/catamphetamine/libphonenumber-js/issues/213
	      // Copy-pasted from Google's `PhoneNumberMatcher.js` (`.parseAndValidate()`).


	      if (!isValidCandidate(number, startsAt, this.text, this.options.extended ? 'POSSIBLE' : 'VALID')) {
	        return;
	      } // // Prepend any opening brackets left behind by the
	      // // `PHONE_NUMBER_START_PATTERN` regexp.
	      // const text_before_number = text.slice(this.searching_from, startsAt)
	      // const full_number_starts_at = text_before_number.search(BEFORE_NUMBER_DIGITS_PUNCTUATION)
	      // if (full_number_starts_at >= 0)
	      // {
	      // 	number   = text_before_number.slice(full_number_starts_at) + number
	      // 	startsAt = full_number_starts_at
	      // }
	      //
	      // this.searching_from = matches.lastIndex


	      var result = parse$3(number, this.options, this.metadata);

	      if (!result.phone) {
	        return;
	      }

	      result.startsAt = startsAt;
	      result.endsAt = startsAt + number.length;
	      return result;
	    }
	  }, {
	    key: "hasNext",
	    value: function hasNext() {
	      if (this.state === 'NOT_READY') {
	        this.last_match = this.find();

	        if (this.last_match) {
	          this.state = 'READY';
	        } else {
	          this.state = 'DONE';
	        }
	      }

	      return this.state === 'READY';
	    }
	  }, {
	    key: "next",
	    value: function next() {
	      // Check the state and find the next match as a side-effect if necessary.
	      if (!this.hasNext()) {
	        throw new Error('No next element');
	      } // Don't retain that memory any longer than necessary.


	      var result = this.last_match;
	      this.last_match = null;
	      this.state = 'NOT_READY';
	      return result;
	    }
	  }]);

	  return PhoneNumberSearch;
	}();

	// This is a legacy function.

	// Importing from a ".js" file is a workaround for Node.js "ES Modules"

	function PhoneNumberSearch$1(text, options) {
		PhoneNumberSearch.call(this, text, options, metadata);
	}

	// Deprecated.
	PhoneNumberSearch$1.prototype = Object.create(PhoneNumberSearch.prototype, {});
	PhoneNumberSearch$1.prototype.constructor = PhoneNumberSearch$1;

	// `parsePhoneNumber()` named export has been renamed to `parsePhoneNumberWithError()`.

	//

	var typingMessageTimeout;

	var phoneParser = new AsYouType$1('SE');

	function getFullnameOrEmail(contact) {
	  if (contact.fullName) { return contact.fullName; }
	  if (!contact.firstName && !contact.lastName) { return contact.email; }

	  return ((contact.firstName) + " " + (contact.lastName));
	}

	function combineSubjectAndBody(subject, body, isMainMessage) {
	  if (!isMainMessage) { return body; }
	  return ("<b>" + subject + "</b><br />" + body);
	}

	function checkNeedToScroll(messagesContainer) {
	  var $pageContent = $$1(messagesContainer).parents('.page-content');
	  if ($pageContent.length === 0) { return false; }
	  var scrollHeightBefore = $pageContent[0].scrollHeight;
	  var heightBefore = $pageContent[0].offsetHeight;
	  var scrollBefore = $pageContent[0].scrollTop;
	  return scrollBefore - (scrollHeightBefore - heightBefore) >= -50;
	}

	var script$x = {
	  props: {
	    channelId: String,
	    conversationId: String,
	    type: String,
	    navbarSubtitle: String,
	    navbarTitleLink: [Boolean, String],
	    navbarRoot: Boolean,
	    store: Object,
	    storeIsTyping: Object,
	    storeEdit: Object,
	    storeDelete: Object,
	    storeEditPost: Object,
	    storeDeletePost: Object,
	    signature: Boolean,
	    focusOnLoad: Boolean,
	    placeholder: String,
	    useMentions: Boolean,
	    template: String,
	    isDirectMessagingChannel: Boolean,
	  },
	  data: function data() {
	    var self = this;
	    var storeNotesCount = new Store(self, {
	      get: ['note', 'count'],
	      loadFromLocalStorage: false,
	    });
	    var likeMessageStore = new Store(self, {
	      postNow: [self.type + 'message', 'like']
	    });

	    var storeContactSearch = new Store(self, {
	      postNow: ['contact', 'search'],
	      postNowFinished: function postNowFinished(result) {
	        self.contactSearchHits.length = 0;
	        self.enableNewContact = result.data.enableNewContact;
	        (ref = self.contactSearchHits).push.apply(ref, result.data.contacts);
	        var ref;
	      }
	    });
	    var storeIsHandled = new Store(self, {
	      postNow: ['conversation', 'ishandled', { 
	        type: self.type, 
	        channelId: self.channelId,
	        conversationId: decodeURIComponent(self.conversationId)
	      }],
	      postNowFinished: function postNowFinished() {
	        Brief$1.events.$emit('sync');
	      }
	    });

	    return {
	      storeIsHandled: storeIsHandled,
	      storeNotesCount: storeNotesCount,
	      likeMessageStore: likeMessageStore,
	      storeContactSearch: storeContactSearch,
	      contactSearchHits: [],
	      allowInfinite: true,
	      allowPreloader: self.type !== 'email',
	      initialScrolled: false,
	      messagesCount: self.store.messages ? self.store.messages.length : 0,
	      previousMessage: [],
	      typingMessageId: null,
	      typingUser: null,
	      editingMessage: null,
	      noTouch: !Utils$1.mobileDevice(),
	      editingPost: false,
	      getStarted: false,
	      getFinished: false,
	      getLocalFinished: false,
	      messagesGetFinished: false,
	      messagesGetLocalFinished: false,
	      messagesLoaded: false,
	      sendingMessages: [],
	      pageIsScrolling: false,
	      allowAnimatedMessages: false,
	      sendToQuery: null,
	      enableNewContact: false,
	      addNewContact: false,
	      showPhoneNumber: false,
	      showContactName: false,
	      phoneNumber: null,
	      contactName: null,
	      toggleIsHandledInProgress: false,
	      showBackLink: !Brief$1.isBigScreen,
	      isBigScreen: Brief$1.isBigScreen
	    };
	  },
	  watch: {
	    'store.messages': function watchMessages(a, b) {
	      var self = this;
	      // if (a.length > 0) {
	      //   self.getNotesCount();
	      // }
	      if (a.length > self.previousMessage.length && self.typingMessageId && self.typingUser) {
	        var lastMessage = a[a.length - 1];
	        if (!lastMessage.isTyping) {
	          if (lastMessage.userId === self.typingUser.id || lastMessage.id === self.typingMessageId) {
	            self.$nextTick(function () { return self.hideTyping(); });
	          }
	        }
	      }
	      self.previousMessage = a.slice(0);
	      if (self.store.isLoading) {
	        self.allowPreloader = false;
	      }
	      var initialMessagesLoad = false;
	      if (self.messagesContainer) {
	        initialMessagesLoad = true;
	      }
	      if (initialMessagesLoad) {
	        var needToScroll = checkNeedToScroll(self.messagesContainer) && (self.getFinished || self.getLocalFinished);
	        self.$nextTick(function () {
	          var needAnimatedMessage = false;
	          if (a && a.length > 0 && b && b.length > 0) {
	            var newCount = a.length - self.messagesCount;
	            self.messagesCount = newCount >= 0 ? a.length : 0;
	            //if (newCount === 1 && self.messagesGetFinished && self.messagesGetLocalFinished && self.allowAnimatedMessages) {
	              //needAnimatedMessage = true;
	            //}
	          }

	          if (needToScroll && self.store.messages.length !== 0) {
	            self.scrollPageToBottom(needAnimatedMessage);
	          }
	        });
	      }
	    },
	    allowPreloader: function allowPreloader() {
	      var self = this;
	      if (self.allowPreloader && !self.store.noMoreToGet) {
	        if (checkNeedToScroll(self.messagesContainer)) {
	          self.$nextTick(function () {
	            self.scrollPageToBottom();
	          });
	        }
	      }
	    },
	    sendToQuery: function sendToQuery() {
	      var self = this;
	      self.addNewContact = false;
	      self.enableNewContact = false;
	      self.contactSearchHits.length = 0;
	      self.searchContact();
	    },      
	    'store.noMoreToGet': function watchNoMoreToGet() {
	      var self = this;
	      if (self.allowPreloader && !self.store.noMoreToGet) {
	        if (checkNeedToScroll(self.messagesContainer)) {
	          self.$nextTick(function () {
	            self.scrollPageToBottom();
	          });
	        }
	      }
	    },
	    'store.isLoading': function watchIsLoading(isLoading) {
	      var self = this;
	      var $pageContent = $$1(self.$el).find('.page-content');
	      if (isLoading === true && self.getStarted && !self.getFinished) {
	        Brief$1.showProgress(self.$el);
	      }
	      if (isLoading === true) {
	        self.allowInfinite = false;
	        self.scrollHeightBeforeGet = $pageContent[0].scrollHeight;
	        self.allowPreloader = true;
	        self.messagesBeforeLoading = self.store.messages.length;
	      } else {
	        var messagesAfterLoading = self.store.messages.length;
	        if (messagesAfterLoading === self.messagesBeforeLoading || self.messagesBeforeLoading === 0) {
	          self.allowInfinite = true;
	          return;
	        }
	        $pageContent.css({ overflow: 'hidden', 'pointer-events': 'none' });
	        self.$nextTick(function () {
	          self.scrollHeightAfterGet = $pageContent[0].scrollHeight;
	          $pageContent.scrollTop((self.scrollHeightAfterGet - self.scrollHeightBeforeGet) + $pageContent.scrollTop());
	          $pageContent.css({ overflow: '', 'pointer-events': '' });
	          self.allowInfinite = true;
	        });
	      }
	    },
	    'store.signature': function watchSignature(v) {
	      ClientStorage.save(((this.conversationId || this.channelId) + "-signature"), v);
	    },
	  },
	  created: function created() {
	    var self = this;
	    self.store.on('getLocalFinished', function () {
	      self.getLocalFinished = true;
	      self.messagesGetLocalFinished = true;
	      self.store.messages.forEach(function (m) {
	        if (m.isNew || m.queueId) {
	          self.sendingMessages.push(m);
	        }
	      });
	      if (self.store.messages.length > 0 && self.store.messages.length < 30) {
	        self.allowPreloader = false;
	      }
	      self.$nextTick(function () {
	        if (self.store.messages.length > 0 && self.store.messages.length < 30) {
	          self.allowPreloader = false;
	        } else {
	          self.allowPreloader = true;
	        }
	      });
	    });
	    self.store.on('getStarted', function () {
	      self.getStarted = true;
	      self.getFinished = false;
	    });
	    self.store.on('getFinished', function () {
	      self.getStarted = false;
	      self.getFinished = true;
	      self.messagesLoaded = true;
	      self.messagesGetFinished = true;
	      self.messagesGetLocalFinished = true;
	      self.allowPreloader = true;
	      self.updateFiles();
	      Brief$1.hideProgress(self.$el);
	      self.checkQueue();
	      self.$nextTick(function () {
	        setTimeout(function () {
	          self.allowAnimatedMessages = true;
	        }, 300);
	      });
	    });
	    self.store.on('getMoreFinished subscribeFinished', function () {
	      self.updateFiles();
	      self.checkQueue();
	    });
	    self.store.on('getError reloadError', function (response) {
	      Brief$1.notify('Error!', response.Message || response);
	    });
	    self.store.on('postFormFinished', function (response) {
	      if (response.success) {
	        Brief$1.events.$emit(((self.type) + "-message-created"), response.data, self.isNewMessage);
	        Brief$1.events.$emit('message-created', response.data, self.isNewMessage);
	      }
	    });

	    if (!self.isNewMessage)
	      { self.store.get(); }
	  },
	  mounted: function mounted() {
	    var self = this;
	    Brief$1.events.$on('messages-refresh', self.reload);
	    if (self.signature) {
	      Brief$1.events.$on(((self.type) + "-stream-signature-changed"), function (data) {
	        if (self.channelId === data.id) {
	          self.store.signature = data.signature;
	        }
	      });
	    }

	    self.messagesContainer = $$1(self.$el).find('.brief-messages')[0];
	    if (!self.messagesContainer) {
	      self.$nextTick(function () {
	        self.messagesContainer = $$1(self.$el).find('.brief-messages')[0];
	      });
	    }

	    self.$nextTick(function () {
	      if (self.isNewMessage)
	        { self.focusSendToInput(); }
	    });
	  },
	  computed: {
	    lastRealMessage: function lastRealMessage() {
	      return lodash.findLast(this.orderedMessages, function (m) { return !m.isSystemMessage; });
	    },
	    isHandled: function isHandled() {
	      return this.lastRealMessage ? this.lastRealMessage.isHandled : false;
	    },
	    isHandledText: function isHandledText() {
	      return this.isHandled ? 'Handled' : 'Waiting';
	    },
	    isHandledStyle: function isHandledStyle() {
	      return {
	        color: this.isHandled ? '#25d242' : '#ff9500'
	      }
	    },
	    isNewMessage: function isNewMessage() {
	      return this.conversationId === 'new';
	    },
	    isReviewInvite: function isReviewInvite() {
	      return !!this.template;
	    },      
	    validSendToQuery: function validSendToQuery() {
	      return this.sendToQuery && this.sendToQuery.length > 1;
	    },
	    validPhoneNumber: function validPhoneNumber() {
	      return this.containsNumber(this.phoneNumber);
	    },
	    validContactName: function validContactName() {
	      return this.contactName && this.contactName.length > 1;
	    },
	    validContact: function validContact() {
	      return !this.isNewMessage || this.validPhoneNumber && this.validContactName;
	    },
	    orderedMessages: function orderedMessages() {
	      var ordered = Utils$1.orderByDate(this.store.messages, false, 'sendDate');
	      return ordered || [];
	    },
	    canAssign: function canAssign() {
	      var self = this;
	      if (self.isNewMessage)
	        { return false; }
	      // if (self.$root.loggedInUser.plan.name === 'Base')
	      //   return false;
	      return self.type !== 'note' && self.type !== 'room' && self.type !== 'comments' && self.type !== 'thread';
	    },
	    navbarTitle: function navbarTitle() {
	      return this.store.contactFullName || (this.isReviewInvite ? 'New Review Invite' : 'New Text Message');
	    },      
	    notePhotoUrl: function notePhotoUrl() {
	      var self = this;
	      var imageSize = 500;
	      var contact = self.store.contact;
	      if (!contact) {
	        return self.path.imageUrl('avatar.png', ("h=" + imageSize + "&autorotate=true"));
	      }
	      if ((contact.contactType === 'facebook' || contact.contactType === 'facebookContact') && contact.email) {
	        return ((this.domain) + "/api/facebook/picture?id=" + (contact.email.replace('@facebook.com', '')) + "&channelId=" + (contact.channelId || '') + "&height=" + imageSize);
	      } else if (contact.contactType === 'instagramContact' && contact.avatarUrl) {
	        return contact.avatarUrl;
	      } else if (contact.contactType === 'websiteContact' && contact.avatarUrl) {
	        return contact.avatarUrl;
	      }
	      return self.path.imageUrl('avatar.png', ("h=" + imageSize + "&autorotate=true"));
	    },
	    showPreviousLink: function showPreviousLink() {
	      return this.store.previousConversationId && this.store.noMoreToGet || this.store.previousConversationId && this.getLocalFinished;
	    },
	    showNextLink: function showNextLink() {
	      return !!this.store.subsequentConversationId;
	    },
	  },
	  methods: {
	    focusSendToInput: function focusSendToInput() {
	      var self = this;
	      if (self.$refs.sendToInput)
	        { self.$refs.sendToInput.$el.querySelector('input').focus(); }
	    },
	    scrollPageToBottom: function scrollPageToBottom(needAnimatedMessage) {
	      var self = this;
	      if (self.pageIsScrolling)
	        { return; }
	      
	      if (needAnimatedMessage) 
	        { self.pageIsScrolling = true; }

	      clearTimeout(self.pageScrollTimeout);

	      function scroll() {
	        var $pageContent = $$1(self.$el).find('.page-content');
	        var scrollHeight = $pageContent[0].scrollHeight;
	        var pageHeight = $pageContent[0].offsetHeight;
	        var pagePaddingTop = parseFloat(getComputedStyle($pageContent[0]).paddingTop);
	        var pagePaddingBottom = $$1($pageContent.parent()).find('.toolbar.messagebar').height();
	        var pageHeightWithoutPaddings = pageHeight - pagePaddingTop - pagePaddingBottom;
	        var scrollTop = scrollHeight - pageHeightWithoutPaddings;
	        var lastMessage = $pageContent.find('.brief-message:last-child');

	        if (!needAnimatedMessage) {
	          var lastMessageHeight = lastMessage.outerHeight(true);
	          if (lastMessageHeight > pageHeightWithoutPaddings)
	            { scrollTop = scrollTop - lastMessageHeight + $pageContent.find('.load-next').height(); }
	        }

	        if (scrollTop === 0 && needAnimatedMessage)
	          { self.pageIsScrolling = false; }
	        
	        $pageContent.scrollTop(scrollTop, needAnimatedMessage ? 300 : 0, function () {
	          self.pageIsScrolling = false;
	        });

	        self.pageScrollTimeout = setTimeout(function () {
	          self.pageIsScrolling = false;
	        }, 300);

	        if (needAnimatedMessage) {
	          lastMessage.addClass('brief-message-in').animationEnd(function () {
	            lastMessage.removeClass('brief-message-in');
	          });
	        }
	      }

	      if (needAnimatedMessage) {
	        self.$nextTick(function () {
	          scroll();
	        });
	      } else {
	        scroll();
	        self.$nextTick(function () {
	          scroll();
	        });
	      }
	    },
	    toggleIsHandled: function toggleIsHandled() {
	      var self = this;
	      if (self.toggleIsHandledInProgress)
	        { return; }
	      self.toggleIsHandledInProgress = true;
	      var newIsHandled = !self.lastRealMessage.isHandled;
	      self.storeIsHandled.postNow({ isHandled: newIsHandled }, false, function (res) {
	        self.toggleIsHandledInProgress = false;
	        if (!res.success)
	          { return; }
	        self.lastRealMessage.isHandled = newIsHandled;
	      });
	    },
	    parsePhoneNumber: function parsePhoneNumber(phoneNumber) {
	      if (!this.containsNumber(phoneNumber))
	        { return phoneNumber; }
	      phoneParser.reset();
	      return phoneParser.input(phoneNumber);
	    },
	    containsNumber: function containsNumber(text) {
	      if (!text)
	        { return false; }
	      return /\d/.test(text);
	    },
	    newContact: function newContact() {
	      if (this.containsNumber(this.sendToQuery)) {
	        this.phoneNumber = this.sendToQuery;
	        this.showContactName = true;
	      } else {
	        this.contactName = this.sendToQuery;
	        this.showPhoneNumber = true;
	      }

	      this.addNewContact = true;
	    },
	    likeMessage: function likeMessage(message, channelId) {
	      var self = this;
	      if (!message || !message.id) { return; }
	      self.likeMessageStore.postNow({id: message.id, messageId: message.messageId, channelId: channelId});
	    },
	    openThread: function openThread(messageId) {
	      Brief$1.f7.panel.open('right');
	      Brief$1.viewRight.router.navigate(("/thread/" + messageId + "/?channelId=" + (this.channelId)));
	    },
	    getNotesCount: function getNotesCount() {
	      var self = this;
	      if (self.getNotesCalled) {
	        return;
	      }
	      self.getNotesCalled = true;
	      var contact = self.store.messages.find(function (x) { return !x.isOurMessage && (x.userId || x.fromId); });
	      if (contact && self.conversationId) {
	        var id = contact.userId || contact.fromId;
	        self.storeNotesCount.get({ conversationId: self.conversationId, id: id });
	      }
	    },
	    isNewsletter: function isNewsletter(message) {
	      return !!message.isNewsletter;
	    },
	    checkQueue: function checkQueue() {
	      var self = this;
	      queue$1.checkStoreMessagesQueue(self.sendingMessages, self.store.messages);
	    },
	    updateFiles: function updateFiles() {
	      var self = this;
	      self.$nextTick(function () {
	        Brief$1.events.$emit('files-updated');
	      });
	    },
	    reload: function reload() {
	      var self = this;
	      self.store.reload();
	    },
	    messageClasses: function messageClasses(message) {
	      var self = this;
	      if (message.isSystemMessage) {
	        return {
	          'brief-message-system': true,
	        };
	      }
	      var messageIndex = self.orderedMessages.indexOf(message);
	      var prevMessage = self.orderedMessages[messageIndex - 1];
	      var nextMessage = self.orderedMessages[messageIndex + 1];
	      if (prevMessage && prevMessage.isSystemMessage) {
	        prevMessage = undefined;
	      }
	      if (nextMessage && nextMessage.isSystemMessage) {
	        nextMessage = undefined;
	      }

	      var name = message.fullName || (message.isMyMessage ? ((self.$root.loggedInUser.firstName) + " " + (self.$root.loggedInUser.lastName)) : '&nbsp;');
	      var date = self.messageDate(message.sendDate);
	      var type = message.isMyMessage || message.isOurMessage ? 'sent' : 'received';

	      var first;
	      var last;
	      var sameName;
	      var sameDate;

	      var prevName;
	      var prevDate;
	      var prevType;

	      var nextName;
	      var nextDate;
	      var nextType;

	      if (!prevMessage) { first = true; }
	      else {
	        prevName = prevMessage.fullName || (prevMessage.isMyMessage ? ((self.$root.loggedInUser.firstName) + " " + (self.$root.loggedInUser.lastName)) : '&nbsp;');
	        prevDate = self.messageDate(prevMessage.sendDate);
	        prevType = prevMessage.isMyMessage || prevMessage.isOurMessage ? 'sent' : 'received';

	        sameName = name === prevName;
	        sameDate = sameName && date === prevDate;

	        first = (name !== prevName) || (type !== prevType);
	      }

	      if (!nextMessage) { last = true; }
	      else {
	        nextName = nextMessage.fullName || (nextMessage.isMyMessage ? ((self.$root.loggedInUser.firstName) + " " + (self.$root.loggedInUser.lastName)) : '&nbsp;');
	        nextDate = self.messageDate(nextMessage.sendDate);
	        nextType = nextMessage.isMyMessage || nextMessage.isOurMessage ? 'sent' : 'received';
	        if (type === 'sent') {
	          last = (type !== nextType) || (date !== nextDate);
	        } else {
	          last = (name !== nextName) || (type !== nextType) || (date !== nextDate);
	        }
	      }

	      return {
	        'brief-message-same-name': sameName,
	        'brief-message-same-date': sameDate,
	        'brief-message-first': first,
	        'brief-message-last': last,
	        'brief-message-sent': type === 'sent',
	        'brief-message-received': type === 'received',
	        'brief-message-sending': message.isNew,
	        'brief-message-with-attachment': message.files && message.files.length > 0,
	        'brief-message-with-url-preview': message.urlPreview,
	        'brief-message-newsletter': self.isNewsletter(message),
	        'brief-message-typing': message.isTyping,
	        'brief-message-editing': self.editingMessage && self.editingMessage.id === message.id,
	      };
	    },
	    groupDate: function groupDate(date) {
	      return this.datefy(date, 'LL');
	    },
	    messageDate: function messageDate(date) {
	      return this.datefy(date);
	    },
	    getSystemMessage: function getSystemMessage(message) {
	      switch (message.systemMessageType) {
	        case 'join':
	          return ((message.fullName) + " joined room");
	        case 'leave':
	          return ((message.fullName) + " left room");
	        default:
	          return message.text;
	      }
	    },
	    isDifferentDate: function isDifferentDate(message) {
	      var self = this;
	      if (message.isTyping) { return false; }
	      var previousMessage = self.orderedMessages[self.orderedMessages.indexOf(message) - 1];
	      if (previousMessage) {
	        var previousDate = new Date(previousMessage.sendDate || new Date());
	        var currentDate = new Date(message.sendDate || new Date());
	        if (previousDate.getFullYear() !== currentDate.getFullYear() || previousDate.getMonth() !== currentDate.getMonth() || previousDate.getDate() !== currentDate.getDate()) {
	          return true;
	        }
	        return false;
	      }
	      return true;
	    },
	    dateKey: function dateKey(key) {
	      // eslint-disable-next-line
	      return key += '_date';
	    },
	    isInitialMessage: function isInitialMessage(message) {
	      return (this.conversationId || this.channelId) === message.id;
	    },
	    deleteMessage: function deleteMessage(message, isPost) {
	      var self = this;
	      if (!self.storeDelete) { return; }
	      if (self.type === 'room' || self.type === 'website' || self.type === 'note' || self.type === 'thread' || (self.type === 'comments' && !isPost)) {
	        self.storeDelete.post({
	          messageId: message.id,
	        });
	      } else if (self.type === 'comments' && isPost) {
	        self.storeDeletePost.post({
	          id: message.id,
	        });
	      }
	    },
	    editMessage: function editMessage(originalMessage, editedMessage, isPost) {
	      var self = this;
	      if (!self.storeEdit) { return; }

	      if (self.type === 'room' || self.type === 'website' || self.type === 'note' || self.type === 'thread' || (self.type === 'comments' && !isPost)) {
	        originalMessage.text = editedMessage.text; // eslint-disable-line
	        // push to store here
	        self.storeEdit.post({
	          messageId: originalMessage.id,
	          messageText: editedMessage.text,
	        });
	      } else if (self.type === 'comments' && isPost) {
	        self.storeEditPost.post({
	          id: originalMessage.id,
	          text: editedMessage.text,
	        });
	      }

	      self.editingMessage = null;
	    },
	    sendMessage: function sendMessage(message) {
	      var self = this;
	      if (self.editingMessage) {
	        self.editMessage(self.editingMessage, message, self.editingPost);
	        return;
	      }

	      if (self.$root.loggedInUser.isDemo) {
	        self.store.postForm(message);
	        return;
	      }

	      message.queueId = Utils$1.newGuid();
	      message.isHandled = true;

	      if (this.phoneNumber)
	        { message.phoneNumber = this.phoneNumber; }

	      if (this.contactName)
	        { message.contactName = this.contactName; }          

	      if (['facebook', 'email', 'website', 'instagram', 'note', 'thread'].indexOf(self.type) >= 0) {
	        if (!self.store.messages) { self.store.messages = []; }
	        message.id = message.queueId;          
	        if (self.type === 'facebook') {
	          message.fullName = self.store.userFullName;
	        } else {
	          message.fullName = getFullnameOrEmail({
	            email: self.store.email,
	            firstName: self.store.firstName,
	            lastName: self.store.lastName,
	          });
	          message.isMyMessage = true;
	          message.contactType = 'user';
	          message.userId = self.store.userId;
	          message.contacts = self.store.contacts;
	          message.replyType = self.store.replyType;
	          message.sendDate = new Date();
	          if (self.type === 'email') {
	            message.html = message.text;
	          }
	        }
	      }

	      self.store.messages.push(message);
	      self.store.postForm(message);
	      self.scrollPageToBottom(!message.files || message.files.length === 0);
	      self.updateFiles();
	    },
	    typing: function typing() {
	      var self = this;
	      if (self.timeoutTypingRef) { return; }
	      // self.$emit('typing', text);
	      if (self.storeIsTyping) {
	        self.storeIsTyping.postNow(null, true);
	      }
	      self.timeoutTypingRef = setTimeout(function () {
	        self.timeoutTypingRef = null;
	      }, 2500);
	    },
	    parseMessage: function parseMessage(message) {
	      var self = this;
	      var text = !message.isTyping ? self.$root.striptags(message.text) : message.text;
	      // Linkify
	      text = linkify(text);

	      // Add Mentions
	      if (message.mentions) {
	        if (message.mentions.users) {
	          Object.keys(message.mentions.users).forEach(function (userName) {
	            var re = new RegExp(("@" + userName), 'g');
	            text = text.replace(re, ("<a href=\"/user/" + (message.mentions.users[userName]) + "/\" data-view=\".view-right\" class=\"panel-open\" data-panel=\"right\">@" + userName + "</a>"));
	          });
	        }
	        if (message.mentions.channels) {
	          Object.keys(message.mentions.channels).forEach(function (channelName) {
	            var re = new RegExp(("#" + channelName), 'g');
	            var channel = message.mentions.channels[channelName];
	            text = text.replace(re, ("<a href=\"/" + (channel.type) + "/" + (channel.id) + "/\" data-reload-all=\"" + isBigScreen + "\" data-view=\".view-main\">#" + channelName + "</a>"));
	          });
	        }
	      }
	      // Find Links Previews
	      var fetchUrlPreview =
	        message.id &&
	        !message.urlPreview &&
	        !message.urlPreviewRequested &&
	        (self.type === 'room' || self.type === 'comments');

	      if (fetchUrlPreview) {
	        var link = text.match(/href="([^"]*)"/);
	        var url;
	        if (link) { url = link[1]; }
	        if (!url) {
	          url = text;
	        }
	        if (url && (url.indexOf('http://') === 0 || url.indexOf('https://') === 0)) {
	          message.urlPreviewRequested = true;
	          self.$set(self.store.messages[self.store.messages.indexOf(message)], 'urlPreview', true);

	          urlPreview(url, function (urlPreviewData) {
	            var messageIndex = self.store.messages.indexOf(message);
	            if (messageIndex < 0) { return; }
	            self.$set(self.store.messages[messageIndex], 'urlPreview', urlPreviewData);
	          });
	        }
	      }

	      if (!message.isSystemMessage && message.subject){
	        return combineSubjectAndBody(message.subject, text, message.isMainMessage);
	      }
	      return text;
	    },
	    datefy: function datefy(text, format) {
	      if ( format === void 0 ) format = null;

	      return Datefy(text, format);
	    },
	    urlify: function urlify(text) {
	      return Urlify(text);
	    },
	    photoUrl: function photoUrl(avatar, isLink) {
	      if (isLink) {
	        return avatar || this.path.imageUrl('avatar.png', ("h=" + (Math.ceil(34 * Brief$1.f7.device.pixelRatio)) + "&404=avatar&autorotate=true"));
	      }
	      return this.path.imageUrl(
	        avatar ? avatar.filename : 'avatar.png',
	        ("h=" + (Math.ceil(34 * Brief$1.f7.device.pixelRatio)) + "&404=avatar&autorotate=true")
	      );
	    },
	    showOriginal: function showOriginal(message, data) {
	      this.$emit('showOriginal', message, data);
	    },
	    loadUserDetails: function loadUserDetails(message) {
	      return;
	      var self = this;
	      var isUser = message.contactType === 'user' || this.type === 'room' || this.type === 'comments' || this.type === 'note';
	      var url;
	      if (isUser) {
	        url = "/user/" + (message.userId) + "/";
	      } else {
	        url = "/contact/" + (self.type) + "Contact/" + (message.userId || message.fromId) + "/";
	      }
	      Brief$1.f7.panel.open('right');
	      Brief$1.viewRight.router.navigate(url);
	    },
	    loadContactDetails: function loadContactDetails(contact) {
	      var url = "/contact/" + (contact.contactType) + "/" + (contact.id) + "/";
	      Brief$1.f7.panel.open('right');
	      Brief$1.viewRight.router.navigate(url);
	    },
	    onInfinite: function onInfinite() {
	      var self = this;
	      if (!self.allowInfinite) { return; }
	      self.store.getMore();
	    },
	    showTyping: function showTyping(data) {
	      var self = this;
	      if (data.deleteThis) { return; }

	      var lastTypingUser = lodash.orderBy(lodash.filter(data.users, function (x) { return x.id; }), function (x) { return new Date(x.timestamp); }, 'desc')[0];

	      if (self.$root.loggedInUser.id === lastTypingUser.id) { return; }

	      if (typingMessageTimeout) {
	        clearTimeout(typingMessageTimeout);
	      }
	      typingMessageTimeout = setTimeout(function () {
	        typingMessageTimeout = null;
	        self.hideTyping();
	      }, 5000);

	      if (self.typingMessageId) { return; }

	      self.typingMessageId = Date.now();
	      self.typingUser = lastTypingUser;

	      var message = {
	        text: '<span class="typing-dot"></span><span class="typing-dot"></span><span class="typing-dot"></span>',
	        isTyping: true,
	        isMyMessage: false,
	        id: self.typingMessageId,
	        sendDate: new Date(Date.now() + Date.now()),
	      };
	      self.store.messages.push(message);
	    },
	    hideTyping: function hideTyping() {
	      var self = this;
	      if (!self.typingMessageId) { return; }
	      var indexToDelete;
	      var typingMessageId = self.typingMessageId;
	      self.store.messages.forEach(function (message, index) {
	        if (message.id === typingMessageId) { indexToDelete = index; }
	      });

	      self.typingMessageId = null;
	      self.typingUser = null;

	      function deleteTypingMessage() {
	        self.store.messages.forEach(function (message, index) {
	          if (message.id === typingMessageId) {
	            self.store.messages.splice(index, 1);
	          }
	        });
	      }

	      if (typeof indexToDelete !== 'undefined') {
	        deleteTypingMessage();
	        return;
	        var $pageContent = $$1(self.messagesContainer).parents('.page-content');
	        // eslint-disable-next-line
	        if ($pageContent.length === 0) { return false; }
	        var $typingMessage = $pageContent.find('.brief-message-typing').eq(0);
	        var typingMessageHeight = $typingMessage[0].offsetHeight + parseInt($typingMessage.css('margin-bottom'), 10);
	        var scrollHeight = $pageContent[0].scrollHeight;
	        var offsetHeight = $pageContent[0].offsetHeight;
	        var scrollTop = $pageContent[0].scrollTop;
	        var requiredScrollTop = scrollHeight - offsetHeight - typingMessageHeight;
	        if (scrollHeight > offsetHeight && scrollTop > requiredScrollTop) {
	          $pageContent.scrollTop(requiredScrollTop, 200, function () {
	            deleteTypingMessage();
	          });
	        } else {
	          deleteTypingMessage();
	        }
	      }
	    },
	    messageIsEditable: function messageIsEditable(message) {
	      var self = this;
	      var allowedTypes = ['comments', 'room', 'website', 'note', 'thread'];
	      var isMyMessage = message.isMyMessage;
	      if (typeof isMyMessage === 'undefined' && message.userId) {
	        isMyMessage = message.userId === self.$root.loggedInUser.id;
	      }
	      if (allowedTypes.indexOf(self.type) >= 0 && isMyMessage) { return true; }
	      return false;
	    },
	    postIsCopyable: function postIsCopyable(message) {
	      var self = this;
	      if (!self.type === 'comments') { return false; }
	      return message.text && Utils$1.mobileDevice();
	    },
	    enableMessageEdit: function enableMessageEdit(message, isPost) {
	      var self = this;
	      self.editingPost = !!isPost;
	      self.editingMessage = message;
	    },
	    editLastMessage: function editLastMessage() {
	      var self = this;
	      var editingMessage = self.store.messages.reverse().find(function (x) { return x.isMyMessage && !x.isSystemMessage; });
	      if (!editingMessage) {
	        return;
	      }
	      self.editingPost = false;
	      self.editingMessage = editingMessage;
	    },
	    openBrowser: function openBrowser(url, e) {
	      e.preventDefault();
	      Brief$1.openInSystemBrowser(url);
	    },
	    openMessageActions: function openMessageActions(e, message, isPost) {
	      var self = this;
	      var isTouchDevice = Utils$1.mobileDevice();
	      if (e.type === 'contextmenu') {
	        if (isTouchDevice) {
	          e.preventDefault();
	        }
	        return;
	      }

	      if (!message) { return; }
	      var editable = self.messageIsEditable(message);
	      if (!editable && !message.text) {
	        return;
	      }
	      var $targetEl = $$1(e.target);
	      function preventClick(touchEvent) {
	        touchEvent.preventDefault();
	        touchEvent.stopPropagation();
	        touchEvent.stopImmediatePropagation();
	        $targetEl.off('touchend', preventClick, true);
	      }
	      if ($targetEl.closest('a').length && isTouchDevice) {
	        $targetEl.on('touchend', preventClick, true);
	      }

	      var buttons = [];
	      if (isTouchDevice) {
	        if ($targetEl.is('.message-tel, .message-email, .message-link')) {
	          var copyContent = $targetEl.text();
	          var copyText;
	          if ($targetEl.hasClass('message-tel')) { copyText = 'Number'; }
	          else if ($targetEl.hasClass('message-link')) { copyText = 'Link'; }
	          else if ($targetEl.hasClass('message-email')) { copyText = 'Email'; }
	          buttons.push({
	            text: ("Copy " + copyText),
	            onClick: function onClick() {
	              var copied = Clipboard.copy(copyContent);
	              if (copied) {
	                Brief$1.f7.toast.create({
	                  icon: self.$theme.ios ? '<i class="f7-icons">check</i>' : '<i class="material-icons">check</i>',
	                  text: (copyText + " copied"),
	                  position: 'center',
	                  closeTimeout: 2000,
	                }).open();
	              }
	            },
	          });
	        }
	      }
	      if (isTouchDevice) {
	        buttons.push({
	          text: 'Copy Text',
	          onClick: function onClick() {
	            var copied = Clipboard.copy(message.text);
	            if (copied) {
	              Brief$1.f7.toast.create({
	                icon: self.$theme.ios ? '<i class="f7-icons">check</i>' : '<i class="material-icons">check</i>',
	                text: 'Text copied',
	                position: 'center',
	                closeTimeout: 2000,
	              }).open();
	            }
	          },
	        });
	      }
	      // if (self.type === 'instagram') {
	      //   buttons.push({
	      //     text: 'Like',
	      //     onClick() {
	      //       self.likeMessage(message, self.channelId);
	      //     },
	      //   });
	      // }
	      if (self.type === 'email') {
	        buttons.push({
	          text: 'Forward',
	          onClick: function onClick() {
	            ClientStorage.save(self.channelId, message.textRaw || message.text);
	            ClientStorage.save(((self.channelId) + ":subject"), ("FWD: " + (message.subject || '')));
	            Brief$1.viewMain.router.navigate(("/email/" + (self.channelId) + "/create/"));
	          },
	        });
	      }
	      if (self.type === 'room') {
	        buttons.push({
	          text: 'Start Thread',
	          onClick: function onClick() {
	            Brief$1.f7.panel.open('right');
	            Brief$1.viewRight.router.navigate(("/thread/" + (message.id) + "/?channelId=" + (self.channelId)));
	          },
	        });
	      }
	      if (editable && message.text) {
	        buttons.push({
	          text: 'Edit Message',
	          onClick: function onClick() {
	            self.enableMessageEdit(message, isPost);
	          },
	        });
	      }
	      if (editable) {
	        buttons.push({
	          text: ("Delete " + (isPost ? 'Post' : 'Message')),
	          color: 'red',
	          onClick: function onClick() {
	            Brief$1.f7.dialog.confirm(("Are you sure want to delete this " + (isPost ? 'post' : 'message') + "? This cannot be undone."), function () {
	              self.deleteMessage(message, isPost);
	            });
	          },
	        });
	      }

	      var modal = ActionsModal(buttons, e.target);
	      modal.open();
	    },
	    searchContact: debounce_1(function searchContact() {
	      var self = this;
	      self.addNewContact = false;
	      self.enableNewContact = false;
	      self.contactSearchHits.length = 0;
	      if (self.sendToQuery)
	        { self.storeContactSearch.postNow({ query: self.sendToQuery }); }
	    }, 250),
	  },
	  beforeDestroy: function beforeDestroy() {
	    var self = this;
	    Brief$1.events.$off('messages-refresh', self.reload);
	    if (self.store) { self.store.dispose(); }
	    if (self.storeIsTyping) { self.storeIsTyping.dispose(); }
	    if (self.storeNotesCount) { self.storeNotesCount.dispose(); }
	    if (self.storeEdit) { self.storeEdit.dispose(); }
	    if (self.storeDelete) { self.storeDelete.dispose(); }
	  },
	};

	/* script */
	var __vue_script__$x = script$x;

	/* template */
	var __vue_render__$u = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f7-page',{attrs:{"page-content":false}},[_c('f7-navbar',{staticClass:"navbar-chat"},[(_vm.showBackLink)?_c('f7-nav-left',[_c('f7-link',{attrs:{"back":""}},[_c('f7-icon',{attrs:{"material":"arrow_back","size":"30"}})],1)],1):_vm._e(),_vm._v(" "),_c('f7-nav-title',[_c('div',{staticStyle:{"display":"flex","gap":"6px","align-items":"center"}},[(_vm.store.contact)?_c('common-avatar',{attrs:{"avatar":_vm.store.contact}}):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","flex-direction":"column","gap":"2px","align-items":"flex-start","font-weight":"bold","overflow":"hidden"}},[_c('div',{staticStyle:{"overflow":"hidden","text-overflow":"ellipsis"}},[_vm._v(_vm._s(_vm.navbarTitle))]),_vm._v(" "),(_vm.lastRealMessage)?_c('div',{staticStyle:{"font-size":"12px","font-weight":"bold","text-transform":"uppercase","display":"flex","gap":"3px"},style:(_vm.isHandledStyle)},[_c('span',[_vm._v(_vm._s(_vm.isHandledText))]),_vm._v(" "),_c('span',{staticStyle:{"width":"14px","height":"14px","margin-left":"0"}},[(_vm.toggleIsHandledInProgress)?_c('common-loader',{attrs:{"load":true}}):_vm._e(),_vm._v(" "),(_vm.isHandled && !_vm.toggleIsHandledInProgress)?_c('common-checkmark',{attrs:{"checked":true}}):_vm._e(),_vm._v(" "),(!_vm.isHandled && !_vm.toggleIsHandledInProgress)?_c('common-clock'):_vm._e()],1)]):_vm._e()])],1)]),_vm._v(" "),_c('f7-nav-right',[(_vm.canAssign)?_c('f7-link',{attrs:{"href":("/" + _vm.type + "/" + _vm.channelId + "/assign/" + (encodeURIComponent(_vm.conversationId)) + "/"),"view":".popup-main-view","popup-open":".popup-main","reload-current":""}},[_vm._v("Assign")]):_c('common-nav-placeholder')],1),_vm._v(" "),_vm._t("default")],2),_vm._v(" "),_c('common-offline-indicator',{attrs:{"store":_vm.store}}),_vm._v(" "),_c('div',{staticClass:"page-content messages-content infinite-scroll-content infinite-scroll-top",attrs:{"data-infinite-distance":"1"},on:{"infinite":_vm.onInfinite}},[(_vm.isNewMessage)?_c('f7-list',{attrs:{"no-hairlines":""}},[_c('f7-list-item',[_c('f7-label',[_vm._v("Send to:")]),_vm._v(" "),_c('f7-input',{ref:"sendToInput",attrs:{"type":"text","placeholder":"Name or Phone","value":_vm.sendToQuery,"clear-button":"","tabindex":"1"},on:{"input":function($event){_vm.sendToQuery = _vm.parsePhoneNumber($event.target.value);}}}),_vm._v(" "),((_vm.contactSearchHits.length || _vm.enableNewContact) && !_vm.addNewContact)?_c('f7-list',{staticStyle:{"border":"1px solid lightgray","border-radius":"8px","overflow":"hidden"},attrs:{"media-list":""}},[_vm._l((_vm.contactSearchHits),function(hit,index){return _c('f7-list-item',{key:index,attrs:{"title":hit.fullName,"text":_vm.parsePhoneNumber(hit.phoneNumber),"link":("/message/list/" + (hit.type) + "/" + (hit.channelId) + "/" + (hit.conversationId) + (_vm.template ? '?template=' + _vm.template : '')),"reload-current":true}})}),_vm._v(" "),(_vm.enableNewContact)?_c('f7-list-item',{attrs:{"title":"New Contact","link":"#"},on:{"click":_vm.newContact}}):_vm._e()],2):_vm._e()],1),_vm._v(" "),(_vm.addNewContact && _vm.showContactName)?_c('f7-list-item',[_c('f7-label',[_vm._v("Type name:")]),_vm._v(" "),_c('f7-input',{attrs:{"type":"text","placeholder":"Example: Anna Johansson","value":_vm.contactName,"clear-button":"","tabindex":"2"},on:{"input":function($event){_vm.contactName = $event.target.value;}}})],1):_vm._e(),_vm._v(" "),(_vm.addNewContact && _vm.showPhoneNumber)?_c('f7-list-item',[_c('f7-label',[_vm._v("Type phone number:")]),_vm._v(" "),_c('f7-input',{attrs:{"type":"text","placeholder":"Example: 0701234567","value":_vm.phoneNumber,"clear-button":"","tabindex":"2"},on:{"input":function($event){_vm.phoneNumber = _vm.parsePhoneNumber($event.target.value);}}})],1):_vm._e()],1):_vm._e(),_vm._v(" "),(!_vm.store.noMoreToGet && _vm.allowPreloader)?_c('div',{staticClass:"infinite-scroll-preloader",class:{invisible: !_vm.store.isLoading}},[_c('f7-preloader')],1):_vm._e(),_vm._v(" "),(_vm.showPreviousLink)?_c('f7-link',{staticClass:"load-prev",attrs:{"href":("/message/list/" + _vm.type + "/" + _vm.channelId + "/" + (_vm.urlify(_vm.store.previousConversationId)) + "/"),"data-reload-current":"true"}},[_vm._v("Older conversation")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"brief-messages"},[(!_vm.store.isLoading && (!_vm.orderedMessages || !_vm.orderedMessages.length) && !(!_vm.store.noMoreToGet && _vm.allowPreloader) && _vm.messagesGetFinished && _vm.messagesGetLocalFinished)?_c('common-empty-message',{attrs:{"text":_vm.type === 'note' ? 'It\’s empty here. Write a note below.' : undefined}}):_vm._e(),_vm._v(" "),(_vm.type === 'note' && _vm.store.contact)?_c('div',{staticClass:"brief-card comments notes"},[_c('a',{staticClass:"brief-card-header panel-open",attrs:{"href":"#","data-view":".view-right","data-panel":"right"},on:{"click":function($event){return _vm.loadContactDetails(_vm.store.contact)}}},[_c('common-avatar',{attrs:{"avatar":_vm.notePhotoUrl}}),_vm._v(" "),(_vm.store.contact.firstName && !_vm.store.contact.email)?_c('div',{staticClass:"brief-card-name"},[_vm._v(_vm._s(_vm.store.contact.firstName)+" "+_vm._s(_vm.store.contact.lastName))]):_c('div',{staticClass:"brief-card-name"},[_vm._v(_vm._s(_vm.store.contact.email))])],1)]):_vm._e(),_vm._v(" "),_vm._l((_vm.orderedMessages),function(message,mIndex){return [(_vm.isDifferentDate(message) && !((_vm.type === 'comments' || _vm.type === 'thread') && _vm.isInitialMessage(message)))?_c('div',{key:_vm.dateKey(message.id),staticClass:"brief-messages-date"},[_vm._v(_vm._s(_vm.groupDate(message.sendDate)))]):_vm._e(),_vm._v(" "),((_vm.type === 'comments' || _vm.type === 'thread') && _vm.isInitialMessage(message))?_c('div',{key:message.id,staticClass:"brief-card comments"},[(_vm.messageIsEditable(message) || _vm.postIsCopyable(message))?_c('f7-link',{staticClass:"brief-card-actions-link",attrs:{"icon-material":"more_vert"},on:{"click":function($event){return _vm.openMessageActions($event, message, true)}}}):_vm._e(),_vm._v(" "),_c('a',{staticClass:"brief-card-header panel-open",attrs:{"href":("/user/" + (message.userId) + "/"),"data-view":".view-right","data-panel":"right"}},[_c('common-avatar',{attrs:{"avatar":message.userPhoto}}),_vm._v(" "),_c('div',{staticClass:"brief-card-name"},[_vm._v(_vm._s(message.fullName))]),_vm._v(" "),_c('div',{staticClass:"brief-card-date"},[_vm._v(_vm._s(_vm.datefy(message.sendDate)))])],1),_vm._v(" "),_c('div',{staticClass:"brief-card-content"},[(message.text)?_c('span',{domProps:{"innerHTML":_vm._s(_vm.parseMessage(message))}}):_vm._e(),_vm._v(" "),(message.urlPreview)?_c('common-url-preview',{attrs:{"data":message.urlPreview}}):_vm._e(),_vm._v(" "),(message.files && message.files.length > 0)?_c('common-files',{attrs:{"message-id":message.id,"message-type":_vm.type,"files":message.files,"use-img":true}}):_vm._e()],1)],1):_c('div',{key:message.id,staticClass:"brief-message",class:_vm.messageClasses(message)},[(!message.isTyping)?[(!message.isSystemMessage)?_c('div',{staticClass:"brief-message-avatar",style:('background-image:url(' + ((_vm.type === 'room' || _vm.type === 'comments' || _vm.type === 'note') ? _vm.photoUrl(message.userPhoto) : _vm.photoUrl(message.photoUrl, true)) + ')'),on:{"click":function($event){return _vm.loadUserDetails(message)}}}):_vm._e(),_vm._v(" "),(!message.isSystemMessage)?_c('div',{staticClass:"brief-message-header"},[_c('div',{staticClass:"brief-message-name",on:{"click":function($event){return _vm.loadUserDetails(message)}}},[_vm._v(_vm._s(message.fullName || (message.isMyMessage ? _vm.$root.loggedInUser.firstName + ' ' + _vm.$root.loggedInUser.lastName : ' ')))]),_vm._v(" "),_c('div',{staticClass:"brief-message-date"},[_vm._v(_vm._s(_vm.messageDate(message.sendDate))+_vm._s(message.isEdited ? ' (edited)' : ''))])]):_vm._e(),_vm._v(" "),(message.isSystemMessage && !_vm.isDirectMessagingChannel)?_c('div',{staticClass:"brief-message-header"},[_vm._v("\n              "+_vm._s(_vm.getSystemMessage(message))+"\n            ")]):_vm._e(),_vm._v(" "),(message.url && (mIndex === 0 || _vm.orderedMessages[mIndex - 1].url !== message.url))?_c('div',{staticClass:"brief-message-header"},[_c('a',{staticStyle:{"height":"20px","white-space":"nowrap","overflow":"hidden","text-overflow":"ellipsis"},attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.openBrowser(message.url, $event)}}},[_vm._v(_vm._s(message.url))])]):_vm._e()]:_vm._e(),_vm._v(" "),(!message.isSystemMessage)?_c('div',{staticClass:"brief-message-content",class:{ 'note-files': _vm.type === 'note' },on:{"taphold":function($event){return _vm.openMessageActions($event, message)},"contextmenu":function($event){return _vm.openMessageActions($event, message)}}},[((_vm.messageIsEditable(message) || _vm.type === 'room') && _vm.noTouch)?[_c('f7-link',{staticClass:"brief-message-edit-link",attrs:{"icon-if-ios":"f7:chevron_down","icon-if-md":"material:more_vert"},on:{"click":function($event){return _vm.openMessageActions($event, message)}}}),_vm._v(" "),_c('span',{staticClass:"brief-message-edit-link-helper"})]:_vm._e(),_vm._v(" "),(message.isNew)?_c('f7-preloader'):_vm._e(),_vm._v(" "),(message.text && !_vm.isNewsletter(message))?_c('span',{class:{'message-image-text': (message.files && message.files.length > 0), 'brief-message-text': (!message.files || message.files.length === 0)},staticStyle:{"display":"block"},domProps:{"innerHTML":_vm._s(_vm.parseMessage(message))}}):_vm._e(),_vm._v(" "),(message.urlPreview)?_c('common-url-preview',{attrs:{"data":message.urlPreview}}):_vm._e(),_vm._v(" "),(_vm.isNewsletter(message))?_c('common-email-preview',{attrs:{"message":message},on:{"click":function($event){return _vm.showOriginal(message, $event)}}}):_vm._e(),_vm._v(" "),(_vm.type === 'email' && !message.isMyMessage && !message.isOurMessage && !message.isTyping)?_c('f7-link',{directives:[{name:"visible",rawName:"v-visible",value:(message.id),expression:"message.id"}],staticClass:"show-original-link",on:{"click":function($event){return _vm.showOriginal(message)}}},[_vm._v("Show original")]):_vm._e(),_vm._v(" "),(message.files && message.files.length > 0 && _vm.isNewsletter(message))?_c('common-files',{attrs:{"files":message.files,"message-id":message.id,"message-type":_vm.type},on:{"click":function () { return _vm.showOriginal(message, _vm.$event); }}}):_vm._e(),_vm._v(" "),(message.files && message.files.length > 0 && !_vm.isNewsletter(message))?_c('common-files',{attrs:{"files":message.files,"message-id":message.id,"message-type":_vm.type}}):_vm._e()],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"thread-info"},[(message.replies && message.replies > 0)?_c('a',{attrs:{"href":"#"},on:{"click":function($event){return _vm.openThread(message.id)}}},[_vm._v(_vm._s(message.replies)+" "+_vm._s(message.replies === 1 ? 'reply' : 'replies'))]):_vm._e()])],2)]})],2),_vm._v(" "),(_vm.showNextLink)?_c('f7-link',{staticClass:"load-next",attrs:{"href":("/message/list/" + _vm.type + "/" + _vm.channelId + "/" + (_vm.urlify(_vm.store.subsequentConversationId)) + "/"),"data-reload-current":"true"}},[_vm._v("Newer conversation")]):_vm._e()],1),_vm._v(" "),(!_vm.isNewMessage || _vm.validContact)?_c('common-write',{staticStyle:{"position":"absolute"},attrs:{"id":_vm.conversationId || _vm.channelId,"signature":_vm.store.signature,"file-upload":_vm.type !== 'sms',"messages-loaded":_vm.messagesLoaded,"focus-on-load":_vm.focusOnLoad,"type":_vm.type,"placeholder":_vm.placeholder,"use-mentions":_vm.useMentions,"show-contact-select":_vm.type === 'email',"editing-message":_vm.editingMessage,"desktop-send-on-enter":_vm.type !== 'email',"show-suggested-replies":_vm.type === 'sms' && _vm.validContact,"template":_vm.template},on:{"send":_vm.sendMessage,"resize":_vm.scrollPageToBottom,"typing":_vm.typing,"editLastMessage":_vm.editLastMessage,"cancelEditing":function($event){_vm.editingMessage = null;}}},[(_vm.lastRealMessage)?_c('div',{staticClass:"is-handled-button",on:{"click":_vm.toggleIsHandled}},[(_vm.toggleIsHandledInProgress)?_c('common-loader',{attrs:{"load":true}}):_vm._e(),_vm._v(" "),(_vm.isHandled && !_vm.toggleIsHandledInProgress)?_c('common-checkmark',{attrs:{"checked":true}}):_vm._e(),_vm._v(" "),(!_vm.isHandled && !_vm.toggleIsHandledInProgress)?_c('common-clock'):_vm._e()],1):_vm._e()]):_vm._e()],1)};
	var __vue_staticRenderFns__$u = [];

	  /* style */
	  var __vue_inject_styles__$x = undefined;
	  /* scoped */
	  var __vue_scope_id__$x = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$x = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$x = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$x = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$u, staticRenderFns: __vue_staticRenderFns__$u },
	    __vue_inject_styles__$x,
	    __vue_script__$x,
	    __vue_scope_id__$x,
	    __vue_is_functional_template__$x,
	    __vue_module_identifier__$x,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//

	function inviteFinished(result) {
	  var self = this;
	  self.inviteInProgress = false;
	  if (result.success) {
	    Brief$1.viewMain.router.back();
	  }
	}
	function getMoreUsers$1() {
	  var self = this;
	  self.storeUsers.getMore();
	}
	function handleGetFinished$1() {
	  var self = this;
	  self.searchbarPreloader = false;

	  for (var i = 0; i < self.storeUsers.users.length; i += 1) {
	    self.storeUsers.users[i].selected = false;
	  }
	}
	var script$y = {
	  props: ['id', 'type'],
	  data: function data() {
	    var self = this;

	    var storeStream = new Store(self, {
	      post: ['channel', 'invite', { channelType: self.type }],
	      postFinished: inviteFinished,
	    });

	    var storeUsers = new Store(self, {
	      get: ['stream', 'invite', {
	        streamId: self.id,
	        streamType: Utils$1.capitalize(self.type),
	      }],
	      getFinished: handleGetFinished$1.bind(self),
	      getLocalFinished: function getLocalFinished() {},
	    });

	    return {
	      storeUsers: storeUsers,
	      storeStream: storeStream,
	      query: null,
	      showInviteButton: false,
	      inviteInProgress: false,
	      searchbarPreloader: false,
	      selectedUserCount: 0,
	    };
	  },
	  mounted: function mounted() {
	    var self = this;
	    self.storeUsers.get();
	    self.$nextTick(function () {
	      $$1(self.$el).find('.infinite-scroll').on('infinite', getMoreUsers$1.bind(self));
	    });
	  },
	  beforeDestroy: function beforeDestroy() {
	    var self = this;
	    $$1(self.$el).find('.infinite-scroll').off('infinite', getMoreUsers$1.bind(self));
	    self.storeUsers.dispose();
	    self.storeStream.dispose();
	  },
	  methods: {
	    selectedUserIds: function selectedUserIds() {
	      if (!this.storeUsers.users) { return []; }
	      var userIds = this.storeUsers.users.filter(function (user) { return user.selected; }).map(function (user) { return user.id; });
	      this.selectedUserCount = userIds.length;
	      return userIds;
	    },
	    debounceSearch: debounce_1(function debounceSearch() {
	      var self = this;
	      self.storeUsers.get({ query: self.query });
	    }, 500),
	    onQueryChange: function onQueryChange(query) {
	      var self = this;
	      self.searchbarPreloader = true;
	      self.query = query;
	      self.debounceSearch();
	    },
	    invite: function invite() {
	      var self = this;
	      self.inviteInProgress = true;
	      self.storeStream.post({
	        id: self.id,
	        selectedUserIds: self.selectedUserIds(),
	      });
	    },
	    selectUser: function selectUser(event, user) {
	      if (event.target.checked) { user.selected = true; }
	      else { user.selected = false; }
	      this.showInviteButton = this.selectedUserIds().length > 0;
	    },
	  },
	};

	/* script */
	var __vue_script__$y = script$y;

	/* template */
	var __vue_render__$v = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f7-page',{attrs:{"page-content":false}},[_c('common-navbar',{attrs:{"title":"Invite team members"}},[_c('f7-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.showInviteButton),expression:"showInviteButton"}],attrs:{"slot":"nav-right"},on:{"click":_vm.invite},slot:"nav-right"},[_vm._v(_vm._s(_vm.inviteInProgress ? 'Inviting...' : 'Invite')+" "),(_vm.inviteInProgress)?_c('span',{staticClass:"spinner"}):_vm._e()]),_vm._v(" "),(_vm.selectedUserCount > 0)?_c('span',{staticClass:"badge invite-count-badge bg-color-green",attrs:{"slot":"nav-right"},slot:"nav-right"},[_vm._v(_vm._s(_vm.selectedUserCount))]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"page-content infinite-scroll"},[_c('common-search',{staticClass:"invite-team-searchbar",attrs:{"title":"Search team member","preloader":_vm.searchbarPreloader,"query":_vm.query,"disableHashTag":true},on:{"querychange":_vm.onQueryChange}}),_vm._v(" "),_c('f7-list',{staticClass:"invite-team-search-results"},[_c('ul',[_vm._l((_vm.storeUsers.users),function(user){return _c('li',[_c('label',{staticClass:"item-checkbox item-content"},[_c('input',{attrs:{"type":"checkbox"},domProps:{"value":user.id,"checked":user.selected},on:{"change":function($event){return _vm.selectUser($event, user)}}}),_vm._v(" "),_c('i',{staticClass:"icon icon icon-checkbox"}),_vm._v(" "),_c('div',{staticClass:"item-media"},[_c('common-avatar',{attrs:{"avatar":user.photoFile}})],1),_vm._v(" "),_c('div',{staticClass:"item-inner"},[_c('div',{staticClass:"item-title"},[_vm._v(_vm._s(user.firstName)+" "+_vm._s(user.lastName))])])])])}),_vm._v(" "),(_vm.storeUsers.users && _vm.storeUsers.users.length === 0)?_c('li',{staticClass:"item-content"},[_c('div',{staticClass:"item-inner"},[_c('div',{staticClass:"item-title"},[_vm._v("No team members found")])])]):_vm._e()],2)]),_vm._v(" "),(_vm.storeUsers.isLoading)?_c('div',{staticClass:"infinite-scroll-preloader"},[_c('f7-preloader')],1):_vm._e()],1)],1)};
	var __vue_staticRenderFns__$v = [];

	  /* style */
	  var __vue_inject_styles__$y = undefined;
	  /* scoped */
	  var __vue_scope_id__$y = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$y = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$y = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$y = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$v, staticRenderFns: __vue_staticRenderFns__$v },
	    __vue_inject_styles__$y,
	    __vue_script__$y,
	    __vue_scope_id__$y,
	    __vue_is_functional_template__$y,
	    __vue_module_identifier__$y,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//

	function joinStreamFinished(result) {
	  var self = this;
	  self.joinInProgress = false;
	  if (result.success) {
	    Utils$1.setTimeoutTrigger('streams-selected', self.id);
	    var url = "/" + (self.type) + "/" + (self.id) + "/";
	    Brief$1.viewMain.router.reloadFromStart(url);
	  }
	}

	function getFinished() {
	  var self = this;
	  var store = self.store;
	  if (!store) { return; }
	  self.name = store.name;
	  self.description = store.description;
	  self.joinedUserCount = store.joinedUserCount;
	}

	var script$z = {
	  props: ['id', 'type'],
	  data: function data() {
	    var self = this;

	    var store = new Store(self, {
	      get: [Utils$1.channelTypes(self.type), 'settings', { id: self.id }],
	      getFinished: getFinished,
	      post: ['channel', 'join', { channelType: self.type}],
	      postFinished: joinStreamFinished,
	    });
	    store.get();

	    return {
	      store: store,
	      streamName: store.name || '',
	      streamDescription: store.description || '',
	      streamJoinedUserCount: store.joinedUserCount || '',
	      joinInProgress: false,
	      name: '',
	      description: '',
	      joinedUserCount: '',
	    };
	  },
	  beforeDestroy: function beforeDestroy() {
	    var self = this;
	    self.store.dispose();
	  },
	  methods: {
	    joinStream: function joinStream() {
	      var self = this;
	      self.joinInProgress = true;
	      self.store.post({
	        id: self.id,
	        streamId: self.id,
	      });
	      return false;
	    },
	  },
	};

	/* script */
	var __vue_script__$z = script$z;

	/* template */
	var __vue_render__$w = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f7-page',{staticClass:"page-form"},[_c('common-navbar',{attrs:{"title":"Join channel"}}),_vm._v(" "),_c('f7-list',[_c('f7-list-item',{attrs:{"title":_vm.streamName || _vm.name}}),_vm._v(" "),(_vm.streamDescription || _vm.description)?_c('f7-list-item',{attrs:{"title":_vm.streamDescription || _vm.description}}):_vm._e()],1),_vm._v(" "),_c('f7-list',[_c('f7-list-item',{attrs:{"link":("/" + _vm.type + "/" + (_vm.$f7route.params.channelId) + "/members/"),"title":"Members"}},[_c('span',{attrs:{"slot":"after"},slot:"after"},[_vm._v(_vm._s(_vm.joinedUserCount))])])],1),_vm._v(" "),_c('f7-list',[_c('f7-list-button',{on:{"click":_vm.joinStream}},[_vm._v(_vm._s(_vm.joinInProgress ? 'Joining...' : 'Join')+" "),(_vm.joinInProgress)?_c('span',{staticClass:"spinner"}):_vm._e()])],1)],1)};
	var __vue_staticRenderFns__$w = [];

	  /* style */
	  var __vue_inject_styles__$z = undefined;
	  /* scoped */
	  var __vue_scope_id__$z = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$z = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$z = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$z = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$w, staticRenderFns: __vue_staticRenderFns__$w },
	    __vue_inject_styles__$z,
	    __vue_script__$z,
	    __vue_scope_id__$z,
	    __vue_is_functional_template__$z,
	    __vue_module_identifier__$z,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//

	function saveSignatureFinished(result) {
	  var self = this;
	  self.saveInProgress = false;
	  if (result.success) {
	    Brief$1.viewMain.router.back();
	  }
	}

	function getSignatureFinished() {
	  var self = this;
	  if (!self.store.signature) {
	    return;
	  }
	  var imageUrl = (self.store.signature || '').match(/\[([^]*)]/);
	  self.signatureImageUrl = imageUrl && imageUrl.length > 1 ? imageUrl[1] : '';
	  var imageText = (self.store.signature || '').match(/!\(([^)]*)\)/);
	  self.signatureImageText = imageText && imageText.length > 1 ? imageText[1] : '';
	  self.signature = (self.store.signature || '').replace(/!\(([^)]*)\)\[([^]*)]/gi, '').trim();
	}

	var script$A = {
	  props: ['type', 'id'],
	  data: function data() {
	    var self = this;
	    var channelType = Utils$1.channelTypes(self.type);
	    var store = new Store(self, {
	      get: ['channel', 'signature', { id: self.id, channelType: self.type }],
	      getFinished: getSignatureFinished,
	      post: ['channel', 'signature', { id: self.id, channelType: self.type }],
	      postFinished: saveSignatureFinished,
	    });
	    return {
	      store: store,
	      saveInProgress: false,
	      signature: '',
	      signatureImageUrl: '',
	      signatureImageText: '',
	    };
	  },
	  computed: {
	    typeTitle: function typeTitle() {
	      return Utils$1.capitalize(this.type);
	    },
	    signatureComputed: function signatureComputed() {
	      var self = this;
	      return self.signature;
	    },
	    signatureImageUrlComputed: function signatureImageUrlComputed() {
	      var self = this;
	      return self.signatureImageUrl;
	    },
	    signatureImageTextComputed: function signatureImageTextComputed() {
	      var self = this;
	      return self.signatureImageText;
	    },
	  },
	  mounted: function mounted() {
	    var self = this;
	    self.store.get();
	  },
	  beforeDestroy: function beforeDestroy() {
	    var self = this;
	    self.store.dispose();
	  },
	  methods: {
	    save: function save() {
	      var self = this;
	      if (self.saveInProgress) { return; }
	      self.saveInProgress = true;
	      var eventName = (self.type === 'facebook' ? 'facebook-stream' : 'email-stream') + "-signature-changed";
	      var signature = self.signatureComputed;
	      if (self.type === 'email' && self.signatureImageUrlComputed) {
	        signature += "\n!(" + (self.signatureImageTextComputed || '') + ")[" + (self.signatureImageUrlComputed) + "]";
	      }
	      self.store.signature = signature;

	      Utils$1.setTimeoutTrigger(eventName, {
	        id: self.id,
	        signature: signature,
	      });
	      self.store.post({
	        signature: signature,
	      });
	    },
	  },
	};

	/* script */
	var __vue_script__$A = script$A;

	/* template */
	var __vue_render__$x = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f7-page',{staticClass:"page-form"},[_c('common-navbar',{attrs:{"title":"Edit signature"}}),_vm._v(" "),_c('f7-list',[_c('f7-list-item',{attrs:{"item-input":""}},[_c('f7-input',{attrs:{"type":"textarea","placeholder":_vm.typeTitle + ' signature',"value":_vm.signatureComputed},on:{"input":function($event){_vm.signature = $event.target.value;}}})],1)],1),_vm._v(" "),(_vm.type === 'email')?[_c('f7-block-title',[_vm._v("Signature Image")]),_vm._v(" "),_c('f7-list',[_c('f7-list-item',{attrs:{"item-input":""}},[_c('f7-input',{attrs:{"type":"text","placeholder":"Image URL","value":_vm.signatureImageUrlComputed},on:{"input":function($event){_vm.signatureImageUrl = $event.target.value;}}})],1),_vm._v(" "),_c('f7-list-item',{attrs:{"item-input":""}},[_c('f7-input',{attrs:{"type":"text","placeholder":"Image text","value":_vm.signatureImageTextComputed},on:{"input":function($event){_vm.signatureImageText = $event.target.value;}}})],1)],1)]:_vm._e(),_vm._v(" "),_c('f7-list',[_c('f7-list-button',{on:{"click":_vm.save}},[(!_vm.saveInProgress)?_c('span',[_vm._v("Save")]):_vm._e(),_vm._v(" "),(_vm.saveInProgress)?_c('span',{staticClass:"spinner"}):_vm._e()])],1)],2)};
	var __vue_staticRenderFns__$x = [];

	  /* style */
	  var __vue_inject_styles__$A = undefined;
	  /* scoped */
	  var __vue_scope_id__$A = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$A = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$A = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$A = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$x, staticRenderFns: __vue_staticRenderFns__$x },
	    __vue_inject_styles__$A,
	    __vue_script__$A,
	    __vue_scope_id__$A,
	    __vue_is_functional_template__$A,
	    __vue_module_identifier__$A,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//

	var script$B = {
	  props: {
	    type: String,
	    id: String,
	  },
	  data: function data() {
	    var self = this;
	    var type = self.type;
	    var id = self.id;
	    var channelType = Utils$1.channelTypes(type);

	    var storeUsers = new Store(self, {
	      get: ['channel', 'userlist', { id: id, type: channelType }],
	    });
	    var storeKick = new Store(self, {
	      post: ['channel', 'kickuser', { id: id, type: channelType }],
	      postFinished: function () { return storeUsers.get(); },
	    });

	    var storeSettings = new Store(self, {
	      get: [channelType, 'settings', { id: id }],
	    });

	    storeUsers.get();
	    storeSettings.get();

	    return {
	      storeUsers: storeUsers,
	      storeKick: storeKick,
	      storeSettings: storeSettings,
	      noTouch: !Utils$1.mobileDevice(),
	      currentUserId: window.localStorage.getItem('user_id'),
	    };
	  },
	  computed: {
	    allowInvite: function allowInvite() {
	      var self = this;
	      var allow = false;
	      if (self.storeUsers.users) {
	        self.storeUsers.users.forEach(function (user) {
	          if (user.id === self.$root.loggedInUser.id) {
	            allow = true;
	          }
	        });
	      }
	      return allow;
	    },
	  },
	  methods: {
	    onPageBeforeIn: function onPageBeforeIn(e, page) {
	      var self = this;
	      if (page && page.direction === 'backward') {
	        self.storeUsers.reload();
	      }
	    },
	    kick: function kick(user) {
	      var self = this;
	      Brief.f7.dialog.confirm(("Do you want to remove " + (user.firstName) + " " + (user.lastName || '') + " from this channel?"), ("Remove user from " + (self.storeSettings.name)), function () {
	        self.storeKick.post({ userId: user.id });
	      });
	    },
	  },
	};

	/* script */
	var __vue_script__$B = script$B;

	/* template */
	var __vue_render__$y = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f7-page',{staticClass:"page-form",on:{"page:beforein":_vm.onPageBeforeIn}},[_c('common-navbar',{attrs:{"title":"Members"}},[(_vm.allowInvite)?_c('f7-link',{attrs:{"slot":"nav-right","href":("/" + _vm.type + "/" + _vm.id + "/invite/")},slot:"nav-right"},[_vm._v("Invite")]):_vm._e()],1),_vm._v(" "),_c('f7-list',{attrs:{"media-list":""}},[_c('ul',{staticClass:"content-round"},_vm._l((_vm.storeUsers.users),function(item){return _c('li',{key:item.id,staticClass:"swipeout",class:{'swipeout-desktop': _vm.noTouch}},[_c('div',{staticClass:"swipeout-content"},[_c('a',{staticClass:"item-link panel-open",attrs:{"href":("/user/" + (item.id) + "/"),"data-view":".view-right","data-panel":"right"}},[_c('div',{staticClass:"item-content"},[_c('div',{staticClass:"item-media"},[_c('common-avatar',{attrs:{"slot":"media","avatar":item.photoFile},slot:"media"})],1),_vm._v(" "),_c('div',{staticClass:"item-inner"},[_c('div',{staticClass:"item-title-row",staticStyle:{"background":"inherit"}},[_c('div',{staticClass:"item-title"},[_vm._v(_vm._s(item.firstName)+" "+_vm._s(item.lastName || ''))])])])])])]),_vm._v(" "),(item.id !== _vm.currentUserId && _vm.storeSettings.isOwner)?_c('div',{staticClass:"swipeout-actions-right"},[_c('a',{staticClass:"swipeout-close kick-user",attrs:{"href":"#"},on:{"click":function($event){return _vm.kick(item)}}},[_c('f7-icon',{attrs:{"if-ios":"f7:clear","if-md":"material:clear"}}),_vm._v(" "),_c('span',[_vm._v("Remove")])],1)]):_vm._e()])}),0)])],1)};
	var __vue_staticRenderFns__$y = [];

	  /* style */
	  var __vue_inject_styles__$B = undefined;
	  /* scoped */
	  var __vue_scope_id__$B = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$B = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$B = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$B = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$y, staticRenderFns: __vue_staticRenderFns__$y },
	    __vue_inject_styles__$B,
	    __vue_script__$B,
	    __vue_scope_id__$B,
	    __vue_is_functional_template__$B,
	    __vue_module_identifier__$B,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//

	var script$C = {
	  props: {
	    type: String, // roomstream, facebookstream, ...
	    id: String, // channel id
	  },
	  data: function data() {
	    var self = this;
	    var type = self.type;
	    var id = self.id;

	    var channelType = Utils$1.channelTypes(type);

	    var store = new Store(self, {
	      get: [channelType, 'settings', { id: id }],
	      post: ['channelnotification', 'settings', { id: id, type: channelType }],
	      getFinished: function getFinished() {
	        if (!self.mode) { self.mode = store.userNotificationMode; }
	      },
	      postFinished: function postFinished(result) {
	        self.saveInProgress = false;
	        if (result.success) {
	          Brief$1.viewMain.router.back();
	        }
	      },
	    });
	    store.get();

	    return {
	      store: store,
	      saveInProgress: false,
	      mode: store.userNotificationMode,
	    };
	  },
	  methods: {
	    onChange: function onChange(e) {
	      var self = this;
	      if (e.target.checked) {
	        self.mode = e.target.value;
	      }
	    },
	    save: function save() {
	      var self = this;
	      self.saveInProgress = true;
	      self.store.post({
	        userNotificationMode: self.mode,
	      });
	    },
	  },
	};

	/* script */
	var __vue_script__$C = script$C;

	/* template */
	var __vue_render__$z = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f7-page',{staticClass:"page-form"},[_c('common-navbar',{attrs:{"title":"Notifications"}}),_vm._v(" "),_c('f7-block-header',[_vm._v("Notify me about")]),_vm._v(" "),_c('f7-list',[_c('f7-list-item',{attrs:{"radio":"","title":"All new messages","name":"radio-notifications","value":"ALL_MESSAGES","checked":_vm.store.userNotificationMode === 'ALL_MESSAGES'},on:{"change":_vm.onChange}}),_vm._v(" "),_c('f7-list-item',{attrs:{"radio":"","title":"Mentions","name":"radio-notifications","value":"MENTIONS_ONLY","checked":_vm.store.userNotificationMode === 'MENTIONS_ONLY'},on:{"change":_vm.onChange}}),_vm._v(" "),_c('f7-list-item',{attrs:{"radio":"","title":"Nothing","name":"radio-notifications","value":"NONE","checked":_vm.store.userNotificationMode === 'NONE'},on:{"change":_vm.onChange}})],1),_vm._v(" "),_c('f7-list',[_c('f7-list-button',{on:{"click":_vm.save}},[(!_vm.saveInProgress)?_c('span',[_vm._v("Save")]):_vm._e(),_vm._v(" "),(_vm.saveInProgress)?_c('span',{staticClass:"spinner"}):_vm._e()])],1)],1)};
	var __vue_staticRenderFns__$z = [];

	  /* style */
	  var __vue_inject_styles__$C = undefined;
	  /* scoped */
	  var __vue_scope_id__$C = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$C = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$C = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$C = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$z, staticRenderFns: __vue_staticRenderFns__$z },
	    __vue_inject_styles__$C,
	    __vue_script__$C,
	    __vue_scope_id__$C,
	    __vue_is_functional_template__$C,
	    __vue_module_identifier__$C,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//

	var script$D = {
	  props: {
	    type: String, // roomstream, facebookstream, ...
	    id: String, // channel id
	    editTeamName: Boolean,
	  },
	  data: function data() {
	    var self = this;
	    var type = self.type;
	    var id = self.id;

	    var channelType = Utils$1.channelTypes(type);

	    var store = new Store(self, {
	      get: [channelType, 'settings', { id: id }],
	      post: ['channelinfo', 'settings', { id: id, type: channelType }],
	      getFinished: function getFinished() {
	      },
	      postFinished: function postFinished(result) {
	        self.saveInProgress = false;
	        if (result.success) {
	          Brief$1.events.$emit('refresh-settings');
	          Brief$1.viewMain.router.back();
	        }
	      },
	    });
	    store.get();

	    return {
	      store: store,
	      saveInProgress: false,
	    };
	  },
	  methods: {
	    visibilityChange: function visibilityChange(visibility) {
	      var self = this;
	      self.updateStore({ visibility: visibility });
	      self.$emit('change', { visibility: visibility });
	    },
	    commonInfoChange: function commonInfoChange(infoProps) {
	      var self = this;
	      self.updateStore(infoProps);
	      self.$emit('change', infoProps);
	    },
	    updateStore: function updateStore(props) {
	      var self = this;
	      Object.keys(props).forEach(function (prop) {
	        self.store[prop] = props[prop];
	      });
	    },
	    save: function save() {
	      var self = this;
	      self.saveInProgress = true;
	      self.store.post();
	    },
	  },
	};

	/* script */
	var __vue_script__$D = script$D;

	/* template */
	var __vue_render__$A = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f7-page',{staticClass:"page-form"},[_c('common-navbar',{attrs:{"title":"Channel settings"}}),_vm._v(" "),_c('common-channel-visibility',{attrs:{"visibility":_vm.store.visibility},on:{"visibilityChange":_vm.visibilityChange}}),_vm._v(" "),_c('common-channel-info',{attrs:{"name":_vm.store.name,"description":_vm.store.description},on:{"commonInfoChange":_vm.commonInfoChange}}),_vm._v(" "),(_vm.editTeamName)?_c('f7-block-title',[_vm._v("Team/Company name")]):_vm._e(),_vm._v(" "),(_vm.editTeamName)?_c('f7-list',{attrs:{"item-input":""}},[_c('f7-list-item',[_c('f7-input',{attrs:{"type":"text","value":_vm.store.teamName,"placeholder":"Team/Company name"},on:{"input":function($event){_vm.store.teamName = $event.target.value;}}})],1)],1):_vm._e(),_vm._v(" "),_c('f7-list',[_c('f7-list-button',{on:{"click":_vm.save}},[(!_vm.saveInProgress)?_c('span',[_vm._v("Save")]):_vm._e(),_vm._v(" "),(_vm.saveInProgress)?_c('span',{staticClass:"spinner"}):_vm._e()])],1)],1)};
	var __vue_staticRenderFns__$A = [];

	  /* style */
	  var __vue_inject_styles__$D = undefined;
	  /* scoped */
	  var __vue_scope_id__$D = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$D = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$D = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$D = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$A, staticRenderFns: __vue_staticRenderFns__$A },
	    __vue_inject_styles__$D,
	    __vue_script__$D,
	    __vue_scope_id__$D,
	    __vue_is_functional_template__$D,
	    __vue_module_identifier__$D,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//

	var script$E = {
	  props: {
	    type: String, // roomstream, facebookstream, ...
	    id: String, // channel id
	  },
	  data: function data() {
	    var self = this;
	    var type = self.type;
	    var id = self.id;

	    var channelType = Utils$1.channelTypes(type);

	    var store = new Store(self, {
	      get: [channelType, 'settings', { id: id }],
	      post: ['channelautoreply', 'settings', { id: id, type: channelType }],
	      getFinished: function getFinished() {
	      },
	      postFinished: function postFinished(result) {
	        self.saveInProgress = false;
	        if (result.success) {
	          Brief$1.events.$emit('refresh-settings');
	          Brief$1.viewMain.router.back();
	        }
	      },
	    });
	    store.get();

	    return {
	      store: store,
	      saveInProgress: false,
	    };
	  },
	  methods: {
	    isAutoReplyChange: function isAutoReplyChange(isAutoReply) {
	      var self = this;
	      self.updateStore({ isAutoReply: isAutoReply });
	    },
	    autoReplyTextChange: function autoReplyTextChange(props) {
	      var self = this;
	      self.updateStore(props);
	    },
	    updateStore: function updateStore(props) {
	      var self = this;
	      Object.keys(props).forEach(function (prop) {
	        self.store[prop] = props[prop];
	      });
	    },
	    save: function save() {
	      var self = this;
	      self.saveInProgress = true;
	      self.store.post();
	    },
	  },
	};

	/* script */
	var __vue_script__$E = script$E;

	/* template */
	var __vue_render__$B = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f7-page',{staticClass:"page-form"},[_c('common-navbar',{attrs:{"title":"Auto reply"}}),_vm._v(" "),_c('common-channel-autoreply',{attrs:{"isAutoReply":_vm.store.isAutoReply,"autoReplyText":_vm.store.autoReplyText},on:{"isAutoReplyChange":_vm.isAutoReplyChange,"autoReplyTextChange":_vm.autoReplyTextChange}}),_vm._v(" "),_c('f7-list',[_c('f7-list-button',{on:{"click":_vm.save}},[(!_vm.saveInProgress)?_c('span',[_vm._v("Save")]):_vm._e(),_vm._v(" "),(_vm.saveInProgress)?_c('span',{staticClass:"spinner"}):_vm._e()])],1)],1)};
	var __vue_staticRenderFns__$B = [];

	  /* style */
	  var __vue_inject_styles__$E = undefined;
	  /* scoped */
	  var __vue_scope_id__$E = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$E = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$E = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$E = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$B, staticRenderFns: __vue_staticRenderFns__$B },
	    __vue_inject_styles__$E,
	    __vue_script__$E,
	    __vue_scope_id__$E,
	    __vue_is_functional_template__$E,
	    __vue_module_identifier__$E,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//

	var script$F = {
	  props: {
	    type: String, // roomstream, facebookstream, ...
	    id: String, // channel id
	  },
	  data: function data() {
	    var self = this;
	    var type = self.type;
	    var id = self.id;

	    var channelType = Utils$1.channelTypes(type);

	    var store = new Store(self, {
	      get: [channelType, 'settings', { id: id }],
	      post: ['channelwaitlimit', 'settings', { id: id, type: channelType }],
	      getFinished: function getFinished() {
	      },
	      postFinished: function postFinished(result) {
	        self.saveInProgress = false;
	        if (result.success) {
	          Brief$1.events.$emit('refresh-settings');
	          Brief$1.viewMain.router.back();
	        }
	      },
	    });
	    store.get();

	    return {
	      store: store,
	      saveInProgress: false,
	    };
	  },
	  methods: {
	    waitLimitChange: function waitLimitChange(waitLimit) {
	      var self = this;
	      self.updateStore({ longWaitingThreshold: waitLimit });
	      self.$emit('change', { longWaitingThreshold: waitLimit });
	    },
	    updateStore: function updateStore(props) {
	      var self = this;
	      Object.keys(props).forEach(function (prop) {
	        self.store[prop] = props[prop];
	      });
	    },
	    save: function save() {
	      var self = this;
	      self.saveInProgress = true;
	      self.store.post();
	    },
	  },
	};

	/* script */
	var __vue_script__$F = script$F;

	/* template */
	var __vue_render__$C = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f7-page',{staticClass:"page-form"},[_c('common-navbar',{attrs:{"title":"Waited a long time limit"}}),_vm._v(" "),_c('common-channel-wait-limit',{attrs:{"threshold":_vm.store.longWaitingThreshold},on:{"waitLimitChange":_vm.waitLimitChange}}),_vm._v(" "),_c('f7-list',[_c('f7-list-button',{on:{"click":_vm.save}},[(!_vm.saveInProgress)?_c('span',[_vm._v("Save")]):_vm._e(),_vm._v(" "),(_vm.saveInProgress)?_c('span',{staticClass:"spinner"}):_vm._e()])],1)],1)};
	var __vue_staticRenderFns__$C = [];

	  /* style */
	  var __vue_inject_styles__$F = undefined;
	  /* scoped */
	  var __vue_scope_id__$F = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$F = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$F = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$F = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$C, staticRenderFns: __vue_staticRenderFns__$C },
	    __vue_inject_styles__$F,
	    __vue_script__$F,
	    __vue_scope_id__$F,
	    __vue_is_functional_template__$F,
	    __vue_module_identifier__$F,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	var momentTimezone = createCommonjsModule(function (module) {
	//! moment-timezone.js
	//! version : 0.5.34
	//! Copyright (c) JS Foundation and other contributors
	//! license : MIT
	//! github.com/moment/moment-timezone

	(function (root, factory) {

		/*global define*/
		if (module.exports) {
			module.exports = factory(require$$0$6); // Node
		} else {
			factory(root.moment);                        // Browser
		}
	}(commonjsGlobal, function (moment) {

		// Resolves es6 module loading issue
		if (moment.version === undefined && moment.default) {
			moment = moment.default;
		}

		// Do not load moment-timezone a second time.
		// if (moment.tz !== undefined) {
		// 	logError('Moment Timezone ' + moment.tz.version + ' was already loaded ' + (moment.tz.dataVersion ? 'with data from ' : 'without any data') + moment.tz.dataVersion);
		// 	return moment;
		// }

		var VERSION = "0.5.34",
			zones = {},
			links = {},
			countries = {},
			names = {},
			guesses = {},
			cachedGuess;

		if (!moment || typeof moment.version !== 'string') {
			logError('Moment Timezone requires Moment.js. See https://momentjs.com/timezone/docs/#/use-it/browser/');
		}

		var momentVersion = moment.version.split('.'),
			major = +momentVersion[0],
			minor = +momentVersion[1];

		// Moment.js version check
		if (major < 2 || (major === 2 && minor < 6)) {
			logError('Moment Timezone requires Moment.js >= 2.6.0. You are using Moment.js ' + moment.version + '. See momentjs.com');
		}

		/************************************
			Unpacking
		************************************/

		function charCodeToInt(charCode) {
			if (charCode > 96) {
				return charCode - 87;
			} else if (charCode > 64) {
				return charCode - 29;
			}
			return charCode - 48;
		}

		function unpackBase60(string) {
			var i = 0,
				parts = string.split('.'),
				whole = parts[0],
				fractional = parts[1] || '',
				multiplier = 1,
				num,
				out = 0,
				sign = 1;

			// handle negative numbers
			if (string.charCodeAt(0) === 45) {
				i = 1;
				sign = -1;
			}

			// handle digits before the decimal
			for (i; i < whole.length; i++) {
				num = charCodeToInt(whole.charCodeAt(i));
				out = 60 * out + num;
			}

			// handle digits after the decimal
			for (i = 0; i < fractional.length; i++) {
				multiplier = multiplier / 60;
				num = charCodeToInt(fractional.charCodeAt(i));
				out += num * multiplier;
			}

			return out * sign;
		}

		function arrayToInt (array) {
			for (var i = 0; i < array.length; i++) {
				array[i] = unpackBase60(array[i]);
			}
		}

		function intToUntil (array, length) {
			for (var i = 0; i < length; i++) {
				array[i] = Math.round((array[i - 1] || 0) + (array[i] * 60000)); // minutes to milliseconds
			}

			array[length - 1] = Infinity;
		}

		function mapIndices (source, indices) {
			var out = [], i;

			for (i = 0; i < indices.length; i++) {
				out[i] = source[indices[i]];
			}

			return out;
		}

		function unpack (string) {
			var data = string.split('|'),
				offsets = data[2].split(' '),
				indices = data[3].split(''),
				untils  = data[4].split(' ');

			arrayToInt(offsets);
			arrayToInt(indices);
			arrayToInt(untils);

			intToUntil(untils, indices.length);

			return {
				name       : data[0],
				abbrs      : mapIndices(data[1].split(' '), indices),
				offsets    : mapIndices(offsets, indices),
				untils     : untils,
				population : data[5] | 0
			};
		}

		/************************************
			Zone object
		************************************/

		function Zone (packedString) {
			if (packedString) {
				this._set(unpack(packedString));
			}
		}

		Zone.prototype = {
			_set : function (unpacked) {
				this.name       = unpacked.name;
				this.abbrs      = unpacked.abbrs;
				this.untils     = unpacked.untils;
				this.offsets    = unpacked.offsets;
				this.population = unpacked.population;
			},

			_index : function (timestamp) {
				var target = +timestamp,
					untils = this.untils,
					i;

				for (i = 0; i < untils.length; i++) {
					if (target < untils[i]) {
						return i;
					}
				}
			},

			countries : function () {
				var zone_name = this.name;
				return Object.keys(countries).filter(function (country_code) {
					return countries[country_code].zones.indexOf(zone_name) !== -1;
				});
			},

			parse : function (timestamp) {
				var target  = +timestamp,
					offsets = this.offsets,
					untils  = this.untils,
					max     = untils.length - 1,
					offset, offsetNext, offsetPrev, i;

				for (i = 0; i < max; i++) {
					offset     = offsets[i];
					offsetNext = offsets[i + 1];
					offsetPrev = offsets[i ? i - 1 : i];

					if (offset < offsetNext && tz.moveAmbiguousForward) {
						offset = offsetNext;
					} else if (offset > offsetPrev && tz.moveInvalidForward) {
						offset = offsetPrev;
					}

					if (target < untils[i] - (offset * 60000)) {
						return offsets[i];
					}
				}

				return offsets[max];
			},

			abbr : function (mom) {
				return this.abbrs[this._index(mom)];
			},

			offset : function (mom) {
				logError("zone.offset has been deprecated in favor of zone.utcOffset");
				return this.offsets[this._index(mom)];
			},

			utcOffset : function (mom) {
				return this.offsets[this._index(mom)];
			}
		};

		/************************************
			Country object
		************************************/

		function Country (country_name, zone_names) {
			this.name = country_name;
			this.zones = zone_names;
		}

		/************************************
			Current Timezone
		************************************/

		function OffsetAt(at) {
			var timeString = at.toTimeString();
			var abbr = timeString.match(/\([a-z ]+\)/i);
			if (abbr && abbr[0]) {
				// 17:56:31 GMT-0600 (CST)
				// 17:56:31 GMT-0600 (Central Standard Time)
				abbr = abbr[0].match(/[A-Z]/g);
				abbr = abbr ? abbr.join('') : undefined;
			} else {
				// 17:56:31 CST
				// 17:56:31 GMT+0800 (台北標準時間)
				abbr = timeString.match(/[A-Z]{3,5}/g);
				abbr = abbr ? abbr[0] : undefined;
			}

			if (abbr === 'GMT') {
				abbr = undefined;
			}

			this.at = +at;
			this.abbr = abbr;
			this.offset = at.getTimezoneOffset();
		}

		function ZoneScore(zone) {
			this.zone = zone;
			this.offsetScore = 0;
			this.abbrScore = 0;
		}

		ZoneScore.prototype.scoreOffsetAt = function (offsetAt) {
			this.offsetScore += Math.abs(this.zone.utcOffset(offsetAt.at) - offsetAt.offset);
			if (this.zone.abbr(offsetAt.at).replace(/[^A-Z]/g, '') !== offsetAt.abbr) {
				this.abbrScore++;
			}
		};

		function findChange(low, high) {
			var mid, diff;

			while ((diff = ((high.at - low.at) / 12e4 | 0) * 6e4)) {
				mid = new OffsetAt(new Date(low.at + diff));
				if (mid.offset === low.offset) {
					low = mid;
				} else {
					high = mid;
				}
			}

			return low;
		}

		function userOffsets() {
			var startYear = new Date().getFullYear() - 2,
				last = new OffsetAt(new Date(startYear, 0, 1)),
				offsets = [last],
				change, next, i;

			for (i = 1; i < 48; i++) {
				next = new OffsetAt(new Date(startYear, i, 1));
				if (next.offset !== last.offset) {
					change = findChange(last, next);
					offsets.push(change);
					offsets.push(new OffsetAt(new Date(change.at + 6e4)));
				}
				last = next;
			}

			for (i = 0; i < 4; i++) {
				offsets.push(new OffsetAt(new Date(startYear + i, 0, 1)));
				offsets.push(new OffsetAt(new Date(startYear + i, 6, 1)));
			}

			return offsets;
		}

		function sortZoneScores (a, b) {
			if (a.offsetScore !== b.offsetScore) {
				return a.offsetScore - b.offsetScore;
			}
			if (a.abbrScore !== b.abbrScore) {
				return a.abbrScore - b.abbrScore;
			}
			if (a.zone.population !== b.zone.population) {
				return b.zone.population - a.zone.population;
			}
			return b.zone.name.localeCompare(a.zone.name);
		}

		function addToGuesses (name, offsets) {
			var i, offset;
			arrayToInt(offsets);
			for (i = 0; i < offsets.length; i++) {
				offset = offsets[i];
				guesses[offset] = guesses[offset] || {};
				guesses[offset][name] = true;
			}
		}

		function guessesForUserOffsets (offsets) {
			var offsetsLength = offsets.length,
				filteredGuesses = {},
				out = [],
				i, j, guessesOffset;

			for (i = 0; i < offsetsLength; i++) {
				guessesOffset = guesses[offsets[i].offset] || {};
				for (j in guessesOffset) {
					if (guessesOffset.hasOwnProperty(j)) {
						filteredGuesses[j] = true;
					}
				}
			}

			for (i in filteredGuesses) {
				if (filteredGuesses.hasOwnProperty(i)) {
					out.push(names[i]);
				}
			}

			return out;
		}

		function rebuildGuess () {

			// use Intl API when available and returning valid time zone
			try {
				var intlName = Intl.DateTimeFormat().resolvedOptions().timeZone;
				if (intlName && intlName.length > 3) {
					var name = names[normalizeName(intlName)];
					if (name) {
						return name;
					}
					logError("Moment Timezone found " + intlName + " from the Intl api, but did not have that data loaded.");
				}
			} catch (e) {
				// Intl unavailable, fall back to manual guessing.
			}

			var offsets = userOffsets(),
				offsetsLength = offsets.length,
				guesses = guessesForUserOffsets(offsets),
				zoneScores = [],
				zoneScore, i, j;

			for (i = 0; i < guesses.length; i++) {
				zoneScore = new ZoneScore(getZone(guesses[i]), offsetsLength);
				for (j = 0; j < offsetsLength; j++) {
					zoneScore.scoreOffsetAt(offsets[j]);
				}
				zoneScores.push(zoneScore);
			}

			zoneScores.sort(sortZoneScores);

			return zoneScores.length > 0 ? zoneScores[0].zone.name : undefined;
		}

		function guess (ignoreCache) {
			if (!cachedGuess || ignoreCache) {
				cachedGuess = rebuildGuess();
			}
			return cachedGuess;
		}

		/************************************
			Global Methods
		************************************/

		function normalizeName (name) {
			return (name || '').toLowerCase().replace(/\//g, '_');
		}

		function addZone (packed) {
			var i, name, split, normalized;

			if (typeof packed === "string") {
				packed = [packed];
			}

			for (i = 0; i < packed.length; i++) {
				split = packed[i].split('|');
				name = split[0];
				normalized = normalizeName(name);
				zones[normalized] = packed[i];
				names[normalized] = name;
				addToGuesses(normalized, split[2].split(' '));
			}
		}

		function getZone (name, caller) {

			name = normalizeName(name);

			var zone = zones[name];
			var link;

			if (zone instanceof Zone) {
				return zone;
			}

			if (typeof zone === 'string') {
				zone = new Zone(zone);
				zones[name] = zone;
				return zone;
			}

			// Pass getZone to prevent recursion more than 1 level deep
			if (links[name] && caller !== getZone && (link = getZone(links[name], getZone))) {
				zone = zones[name] = new Zone();
				zone._set(link);
				zone.name = names[name];
				return zone;
			}

			return null;
		}

		function getNames () {
			var i, out = [];

			for (i in names) {
				if (names.hasOwnProperty(i) && (zones[i] || zones[links[i]]) && names[i]) {
					out.push(names[i]);
				}
			}

			return out.sort();
		}

		function getCountryNames () {
			return Object.keys(countries);
		}

		function addLink (aliases) {
			var i, alias, normal0, normal1;

			if (typeof aliases === "string") {
				aliases = [aliases];
			}

			for (i = 0; i < aliases.length; i++) {
				alias = aliases[i].split('|');

				normal0 = normalizeName(alias[0]);
				normal1 = normalizeName(alias[1]);

				links[normal0] = normal1;
				names[normal0] = alias[0];

				links[normal1] = normal0;
				names[normal1] = alias[1];
			}
		}

		function addCountries (data) {
			var i, country_code, country_zones, split;
			if (!data || !data.length) { return; }
			for (i = 0; i < data.length; i++) {
				split = data[i].split('|');
				country_code = split[0].toUpperCase();
				country_zones = split[1].split(' ');
				countries[country_code] = new Country(
					country_code,
					country_zones
				);
			}
		}

		function getCountry (name) {
			name = name.toUpperCase();
			return countries[name] || null;
		}

		function zonesForCountry(country, with_offset) {
			country = getCountry(country);

			if (!country) { return null; }

			var zones = country.zones.sort();

			if (with_offset) {
				return zones.map(function (zone_name) {
					var zone = getZone(zone_name);
					return {
						name: zone_name,
						offset: zone.utcOffset(new Date())
					};
				});
			}

			return zones;
		}

		function loadData (data) {
			addZone(data.zones);
			addLink(data.links);
			addCountries(data.countries);
			tz.dataVersion = data.version;
		}

		function zoneExists (name) {
			if (!zoneExists.didShowError) {
				zoneExists.didShowError = true;
					logError("moment.tz.zoneExists('" + name + "') has been deprecated in favor of !moment.tz.zone('" + name + "')");
			}
			return !!getZone(name);
		}

		function needsOffset (m) {
			var isUnixTimestamp = (m._f === 'X' || m._f === 'x');
			return !!(m._a && (m._tzm === undefined) && !isUnixTimestamp);
		}

		function logError (message) {
			if (typeof console !== 'undefined' && typeof console.error === 'function') {
				console.error(message);
			}
		}

		/************************************
			moment.tz namespace
		************************************/

		function tz (input) {
			var args = Array.prototype.slice.call(arguments, 0, -1),
				name = arguments[arguments.length - 1],
				zone = getZone(name),
				out  = moment.utc.apply(null, args);

			if (zone && !moment.isMoment(input) && needsOffset(out)) {
				out.add(zone.parse(out), 'minutes');
			}

			out.tz(name);

			return out;
		}

		tz.version      = VERSION;
		tz.dataVersion  = '';
		tz._zones       = zones;
		tz._links       = links;
		tz._names       = names;
		tz._countries	= countries;
		tz.add          = addZone;
		tz.link         = addLink;
		tz.load         = loadData;
		tz.zone         = getZone;
		tz.zoneExists   = zoneExists; // deprecated in 0.1.0
		tz.guess        = guess;
		tz.names        = getNames;
		tz.Zone         = Zone;
		tz.unpack       = unpack;
		tz.unpackBase60 = unpackBase60;
		tz.needsOffset  = needsOffset;
		tz.moveInvalidForward   = true;
		tz.moveAmbiguousForward = false;
		tz.countries    = getCountryNames;
		tz.zonesForCountry = zonesForCountry;

		/************************************
			Interface with Moment.js
		************************************/

		var fn = moment.fn;

		moment.tz = tz;

		moment.defaultZone = null;

		moment.updateOffset = function (mom, keepTime) {
			var zone = moment.defaultZone,
				offset;

			if (mom._z === undefined) {
				if (zone && needsOffset(mom) && !mom._isUTC) {
					mom._d = moment.utc(mom._a)._d;
					mom.utc().add(zone.parse(mom), 'minutes');
				}
				mom._z = zone;
			}
			if (mom._z) {
				offset = mom._z.utcOffset(mom);
				if (Math.abs(offset) < 16) {
					offset = offset / 60;
				}
				if (mom.utcOffset !== undefined) {
					var z = mom._z;
					mom.utcOffset(-offset, keepTime);
					mom._z = z;
				} else {
					mom.zone(offset, keepTime);
				}
			}
		};

		fn.tz = function (name, keepTime) {
			if (name) {
				if (typeof name !== 'string') {
					throw new Error('Time zone name must be a string, got ' + name + ' [' + typeof name + ']');
				}
				this._z = getZone(name);
				if (this._z) {
					moment.updateOffset(this, keepTime);
				} else {
					logError("Moment Timezone has no data for " + name + ". See http://momentjs.com/timezone/docs/#/data-loading/.");
				}
				return this;
			}
			if (this._z) { return this._z.name; }
		};

		function abbrWrap (old) {
			return function () {
				if (this._z) { return this._z.abbr(this); }
				return old.call(this);
			};
		}

		function resetZoneWrap (old) {
			return function () {
				this._z = null;
				return old.apply(this, arguments);
			};
		}

		function resetZoneWrap2 (old) {
			return function () {
				if (arguments.length > 0) { this._z = null; }
				return old.apply(this, arguments);
			};
		}

		fn.zoneName  = abbrWrap(fn.zoneName);
		fn.zoneAbbr  = abbrWrap(fn.zoneAbbr);
		fn.utc       = resetZoneWrap(fn.utc);
		fn.local     = resetZoneWrap(fn.local);
		fn.utcOffset = resetZoneWrap2(fn.utcOffset);

		moment.tz.setDefault = function(name) {
			if (major < 2 || (major === 2 && minor < 9)) {
				logError('Moment Timezone setDefault() requires Moment.js >= 2.9.0. You are using Moment.js ' + moment.version + '.');
			}
			moment.defaultZone = name ? getZone(name) : null;
			return moment;
		};

		// Cloning a moment should include the _z property.
		var momentProperties = moment.momentProperties;
		if (Object.prototype.toString.call(momentProperties) === '[object Array]') {
			// moment 2.8.1+
			momentProperties.push('_z');
			momentProperties.push('_a');
		} else if (momentProperties) {
			// moment 2.7.0
			momentProperties._z = null;
		}

		// INJECT DATA

		return moment;
	}));
	});

	var momentTimezone$1 = /*#__PURE__*/Object.freeze({
		default: momentTimezone,
		__moduleExports: momentTimezone
	});

	var version = "2021e";
	var zones = ["Africa/Abidjan|LMT GMT|g.8 0|01|-2ldXH.Q|48e5","Africa/Nairobi|LMT +0230 EAT +0245|-2r.g -2u -30 -2J|012132|-2ua2r.g N6nV.g 3Fbu h1cu dzbJ|47e5","Africa/Algiers|PMT WET WEST CET CEST|-9.l 0 -10 -10 -20|0121212121212121343431312123431213|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 DA0 Imo0 rd0 De0 9Xz0 1fb0 1ap0 16K0 2yo0 mEp0 hwL0 jxA0 11A0 dDd0 17b0 11B0 1cN0 2Dy0 1cN0 1fB0 1cL0|26e5","Africa/Lagos|LMT GMT +0030 WAT|-d.z 0 -u -10|01023|-2B40d.z 7iod.z dnXK.p dLzH.z|17e6","Africa/Bissau|LMT -01 GMT|12.k 10 0|012|-2ldX0 2xoo0|39e4","Africa/Maputo|LMT CAT|-2a.k -20|01|-2GJea.k|26e5","Africa/Cairo|EET EEST|-20 -30|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1bIO0 vb0 1ip0 11z0 1iN0 1nz0 12p0 1pz0 10N0 1pz0 16p0 1jz0 s3d0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1WL0 rd0 1Rz0 wp0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1qL0 Xd0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1ny0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 WL0 1qN0 Rb0 1wp0 On0 1zd0 Lz0 1EN0 Fb0 c10 8n0 8Nd0 gL0 e10 mn0|15e6","Africa/Casablanca|LMT +00 +01|u.k 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2gMnt.E 130Lt.E rb0 Dd0 dVb0 b6p0 TX0 EoB0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4mn0 SyN0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0|32e5","Africa/Ceuta|WET WEST CET CEST|0 -10 -10 -20|010101010101010101010232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-25KN0 11z0 drd0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1y7o0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4VB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|85e3","Africa/El_Aaiun|LMT -01 +00 +01|Q.M 10 0 -10|012323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1rDz7.c 1GVA7.c 6L0 AL0 1Nd0 XX0 1Cp0 pz0 1cBB0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0|20e4","Africa/Johannesburg|SAST SAST SAST|-1u -20 -30|012121|-2GJdu 1Ajdu 1cL0 1cN0 1cL0|84e5","Africa/Juba|LMT CAT CAST EAT|-26.s -20 -30 -30|012121212121212121212121212121212131|-1yW26.s 1zK06.s 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0 PeX0|","Africa/Khartoum|LMT CAT CAST EAT|-2a.8 -20 -30 -30|012121212121212121212121212121212131|-1yW2a.8 1zK0a.8 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0 HjL0|51e5","Africa/Monrovia|MMT MMT GMT|H.8 I.u 0|012|-23Lzg.Q 28G01.m|11e5","Africa/Ndjamena|LMT WAT WAST|-10.c -10 -20|0121|-2le10.c 2J3c0.c Wn0|13e5","Africa/Sao_Tome|LMT GMT WAT|A.J 0 -10|0121|-2le00 4i6N0 2q00|","Africa/Tripoli|LMT CET CEST EET|-Q.I -10 -20 -20|012121213121212121212121213123123|-21JcQ.I 1hnBQ.I vx0 4iP0 xx0 4eN0 Bb0 7ip0 U0n0 A10 1db0 1cN0 1db0 1dd0 1db0 1eN0 1bb0 1e10 1cL0 1c10 1db0 1dd0 1db0 1cN0 1db0 1q10 fAn0 1ep0 1db0 AKq0 TA0 1o00|11e5","Africa/Tunis|PMT CET CEST|-9.l -10 -20|0121212121212121212121212121212121|-2nco9.l 18pa9.l 1qM0 DA0 3Tc0 11B0 1ze0 WM0 7z0 3d0 14L0 1cN0 1f90 1ar0 16J0 1gXB0 WM0 1rA0 11c0 nwo0 Ko0 1cM0 1cM0 1rA0 10M0 zuM0 10N0 1aN0 1qM0 WM0 1qM0 11A0 1o00|20e5","Africa/Windhoek|+0130 SAST SAST CAT WAT|-1u -20 -30 -20 -10|01213434343434343434343434343434343434343434343434343|-2GJdu 1Ajdu 1cL0 1SqL0 9Io0 16P0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0|32e4","America/Adak|NST NWT NPT BST BDT AHST HST HDT|b0 a0 a0 b0 a0 a0 a0 90|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|326","America/Anchorage|AST AWT APT AHST AHDT YST AKST AKDT|a0 90 90 a0 90 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T00 8wX0 iA0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|30e4","America/Puerto_Rico|AST AWT APT|40 30 30|0120|-17lU0 7XT0 iu0|24e5","America/Araguaina|LMT -03 -02|3c.M 30 20|0121212121212121212121212121212121212121212121212121|-2glwL.c HdKL.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 ny10 Lz0|14e4","America/Argentina/Buenos_Aires|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 A4p0 uL0 1qN0 WL0|","America/Argentina/Catamarca|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323132321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 7B0 8zb0 uL0|","America/Argentina/Cordoba|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323132323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0 1qN0 WL0|","America/Argentina/Jujuy|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323121323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1ze0 TX0 1ld0 WK0 1wp0 TX0 A4p0 uL0|","America/Argentina/La_Rioja|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0|","America/Argentina/Mendoza|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232312121321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1u20 SL0 1vd0 Tb0 1wp0 TW0 ri10 Op0 7TX0 uL0|","America/Argentina/Rio_Gallegos|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0|","America/Argentina/Salta|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0|","America/Argentina/San_Juan|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rld0 m10 8lb0 uL0|","America/Argentina/San_Luis|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323121212321212|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 XX0 1q20 SL0 AN0 vDb0 m10 8lb0 8L0 jd0 1qN0 WL0 1qN0|","America/Argentina/Tucuman|CMT -04 -03 -02|4g.M 40 30 20|0121212121212121212121212121212121212121212323232313232123232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 4N0 8BX0 uL0 1qN0 WL0|","America/Argentina/Ushuaia|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rkN0 8p0 8zb0 uL0|","America/Asuncion|AMT -04 -03|3O.E 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-1x589.k 1DKM9.k 3CL0 3Dd0 10L0 1pB0 10n0 1pB0 10n0 1pB0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1lB0 14n0 1dd0 1cL0 1fd0 WL0 1rd0 1aL0 1dB0 Xz0 1qp0 Xb0 1qN0 10L0 1rB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 WN0 1qL0 11B0 1nX0 1ip0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 TX0 1tB0 19X0 1a10 1fz0 1a10 1fz0 1cN0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0|28e5","America/Panama|CMT EST|5j.A 50|01|-2uduE.o|15e5","America/Bahia_Banderas|LMT MST CST PST MDT CDT|71 70 60 80 60 50|0121212131414141414141414141414141414152525252525252525252525252525252525252525252525252525252|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nW0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|84e3","America/Bahia|LMT -03 -02|2y.4 30 20|01212121212121212121212121212121212121212121212121212121212121|-2glxp.U HdLp.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 l5B0 Rb0|27e5","America/Barbados|LMT AST ADT -0330|3W.t 40 30 3u|0121213121212121|-2m4k1.v 1eAN1.v RB0 1Bz0 Op0 1rb0 11d0 1jJc0 IL0 1ip0 17b0 1ip0 17b0 1ld0 13b0|28e4","America/Belem|LMT -03 -02|3d.U 30 20|012121212121212121212121212121|-2glwK.4 HdKK.4 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|20e5","America/Belize|LMT CST -0530 CWT CPT CDT|5Q.M 60 5u 50 50 50|012121212121212121212121212121212121212121212121213412121212121212121212121212121212121212121215151|-2kBu7.c fPA7.c Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu Rcu 7Bt0 Ni0 4nd0 Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu e9Au qn0 lxB0 mn0|57e3","America/Boa_Vista|LMT -04 -03|42.E 40 30|0121212121212121212121212121212121|-2glvV.k HdKV.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 smp0 WL0 1tB0 2L0|62e2","America/Bogota|BMT -05 -04|4U.g 50 40|0121|-2eb73.I 38yo3.I 2en0|90e5","America/Boise|PST PDT MST MWT MPT MDT|80 70 70 60 60 60|0101023425252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-261q0 1nX0 11B0 1nX0 8C10 JCL0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 Dd0 1Kn0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e4","America/Cambridge_Bay|-00 MST MWT MPT MDDT MDT CST CDT EST|0 70 60 60 50 60 60 50 50|0123141515151515151515151515151515151515151515678651515151515151515151515151515151515151515151515151515151515151515151515151|-21Jc0 RO90 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11A0 1nX0 2K0 WQ0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e2","America/Campo_Grande|LMT -04 -03|3C.s 40 30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwl.w HdLl.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|77e4","America/Cancun|LMT CST EST EDT CDT|5L.4 60 50 40 50|0123232341414141414141414141414141414141412|-1UQG0 2q2o0 yLB0 1lb0 14p0 1lb0 14p0 Lz0 xB0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 Dd0|63e4","America/Caracas|CMT -0430 -04|4r.E 4u 40|01212|-2kV7w.k 28KM2.k 1IwOu kqo0|29e5","America/Cayenne|LMT -04 -03|3t.k 40 30|012|-2mrwu.E 2gWou.E|58e3","America/Chicago|CST CDT EST CWT CPT|60 50 50 50 50|01010101010101010101010101010101010102010101010103401010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 1wp0 TX0 WN0 1qL0 1cN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 11B0 1Hz0 14p0 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|92e5","America/Chihuahua|LMT MST CST CDT MDT|74.k 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|81e4","America/Costa_Rica|SJMT CST CDT|5A.d 60 50|0121212121|-1Xd6n.L 2lu0n.L Db0 1Kp0 Db0 pRB0 15b0 1kp0 mL0|12e5","America/Phoenix|MST MDT MWT|70 60 60|01010202010|-261r0 1nX0 11B0 1nX0 SgN0 4Al1 Ap0 1db0 SWqX 1cL0|42e5","America/Cuiaba|LMT -04 -03|3I.k 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwf.E HdLf.E 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 4a10 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|54e4","America/Danmarkshavn|LMT -03 -02 GMT|1e.E 30 20 0|01212121212121212121212121212121213|-2a5WJ.k 2z5fJ.k 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 DC0|8","America/Dawson_Creek|PST PDT PWT PPT MST|80 70 70 70 70|0102301010101010101010101010101010101010101010101010101014|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 ML0|12e3","America/Dawson|YST YDT YWT YPT YDDT PST PDT MST|90 80 80 80 70 80 70 70|010102304056565656565656565656565656565656565656565656565656565656565656565656565656565656567|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 jrA0 fNd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1z90|13e2","America/Denver|MST MDT MWT MPT|70 60 60 60|01010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 11B0 1qL0 WN0 mn0 Ord0 8x20 ix0 LCN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e5","America/Detroit|LMT CST EST EWT EPT EDT|5w.b 60 50 40 40 40|0123425252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2Cgir.N peqr.N 156L0 8x40 iv0 6fd0 11z0 JxX1 SMX 1cN0 1cL0 aW10 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e5","America/Edmonton|LMT MST MDT MWT MPT|7x.Q 70 60 60 60|0121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2yd4q.8 shdq.8 1in0 17d0 hz0 2dB0 1fz0 1a10 11z0 1qN0 WL0 1qN0 11z0 IGN0 8x20 ix0 3NB0 11z0 XQp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|10e5","America/Eirunepe|LMT -05 -04|4D.s 50 40|0121212121212121212121212121212121|-2glvk.w HdLk.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0 yTd0 d5X0|31e3","America/El_Salvador|LMT CST CDT|5U.M 60 50|012121|-1XiG3.c 2Fvc3.c WL0 1qN0 WL0|11e5","America/Tijuana|LMT MST PST PDT PWT PPT|7M.4 70 80 70 70 70|012123245232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQE0 4PX0 8mM0 8lc0 SN0 1cL0 pHB0 83r0 zI0 5O10 1Rz0 cOO0 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 BUp0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|20e5","America/Fort_Nelson|PST PDT PWT PPT MST|80 70 70 70 70|01023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010104|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0|39e2","America/Fort_Wayne|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010101023010101010101010101040454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 QI10 Db0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 5Tz0 1o10 qLb0 1cL0 1cN0 1cL0 1qhd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Fortaleza|LMT -03 -02|2y 30 20|0121212121212121212121212121212121212121|-2glxq HdLq 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 5z0 2mN0 On0|34e5","America/Glace_Bay|LMT AST ADT AWT APT|3X.M 40 30 30 30|012134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsI0.c CwO0.c 1in0 UGp0 8x50 iu0 iq10 11z0 Jg10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3","America/Godthab|LMT -03 -02|3q.U 30 20|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5Ux.4 2z5dx.4 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e3","America/Goose_Bay|NST NDT NST NDT NWT NPT AST ADT ADDT|3u.Q 2u.Q 3u 2u 2u 2u 40 30 20|010232323232323245232323232323232323232323232323232323232326767676767676767676767676767676767676767676768676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-25TSt.8 1in0 DXb0 2HbX.8 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 S10 g0u 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|76e2","America/Grand_Turk|KMT EST EDT AST|57.a 50 40 40|0121212121212121212121212121212121212121212121212121212121212121212121212132121212121212121212121212121212121212121|-2l1uQ.O 2HHBQ.O 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 7jA0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e2","America/Guatemala|LMT CST CDT|62.4 60 50|0121212121|-24KhV.U 2efXV.U An0 mtd0 Nz0 ifB0 17b0 zDB0 11z0|13e5","America/Guayaquil|QMT -05 -04|5e 50 40|0121|-1yVSK 2uILK rz0|27e5","America/Guyana|LMT -04 -0345 -03|3Q.D 40 3J 30|01231|-2mf87.l 8Hc7.l 2r7bJ Ey0f|80e4","America/Halifax|LMT AST ADT AWT APT|4e.o 40 30 30 30|0121212121212121212121212121212121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsHJ.A xzzJ.A 1db0 3I30 1in0 3HX0 IL0 1E10 ML0 1yN0 Pb0 1Bd0 Mn0 1Bd0 Rz0 1w10 Xb0 1w10 LX0 1w10 Xb0 1w10 Lz0 1C10 Jz0 1E10 OL0 1yN0 Un0 1qp0 Xb0 1qp0 11X0 1w10 Lz0 1HB0 LX0 1C10 FX0 1w10 Xb0 1qp0 Xb0 1BB0 LX0 1td0 Xb0 1qp0 Xb0 Rf0 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 6i10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|39e4","America/Havana|HMT CST CDT|5t.A 50 40|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Meuu.o 72zu.o ML0 sld0 An0 1Nd0 Db0 1Nd0 An0 6Ep0 An0 1Nd0 An0 JDd0 Mn0 1Ap0 On0 1fd0 11X0 1qN0 WL0 1wp0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 14n0 1ld0 14L0 1kN0 15b0 1kp0 1cL0 1cN0 1fz0 1a10 1fz0 1fB0 11z0 14p0 1nX0 11B0 1nX0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 1a10 1in0 1a10 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 17c0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 11A0 6i00 Rc0 1wo0 U00 1tA0 Rc0 1wo0 U00 1wo0 U00 1zc0 U00 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0|21e5","America/Hermosillo|LMT MST CST PST MDT|7n.Q 70 60 80 60|0121212131414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0|64e4","America/Indiana/Knox|CST CDT CWT CPT EST|60 50 50 50 50|0101023010101010101010101010101010101040101010101010101010101010101010101010101010101010141010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 3Cn0 8wp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 z8o0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Marengo|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010104545454545414545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 dyN0 11z0 6fd0 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1e6p0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Petersburg|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010104010101010101010101010141014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 3Fb0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 19co0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Tell_City|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010401054541010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 8wn0 1cN0 1cL0 1cN0 1cK0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Vevay|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010102304545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 kPB0 Awn0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1lnd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Vincennes|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010454541014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Winamac|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010101010454541054545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1za0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Inuvik|-00 PST PDDT MST MDT|0 80 60 70 60|0121343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-FnA0 tWU0 1fA0 wPe0 2pz0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|35e2","America/Iqaluit|-00 EWT EPT EST EDDT EDT CST CDT|0 40 40 50 30 40 60 50|01234353535353535353535353535353535353535353567353535353535353535353535353535353535353535353535353535353535353535353535353|-16K00 7nX0 iv0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|67e2","America/Jamaica|KMT EST EDT|57.a 50 40|0121212121212121212121|-2l1uQ.O 2uM1Q.O 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0|94e4","America/Juneau|PST PWT PPT PDT YDT YST AKST AKDT|80 70 70 70 80 90 90 80|01203030303030303030303030403030356767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cM0 1cM0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|33e3","America/Kentucky/Louisville|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101010102301010101010101010101010101454545454545414545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 3Fd0 Nb0 LPd0 11z0 RB0 8x30 iw0 1nX1 e0X 9vd0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 xz0 gso0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Kentucky/Monticello|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 SWp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/La_Paz|CMT BST -04|4w.A 3w.A 40|012|-1x37r.o 13b0|19e5","America/Lima|LMT -05 -04|58.A 50 40|0121212121212121|-2tyGP.o 1bDzP.o zX0 1aN0 1cL0 1cN0 1cL0 1PrB0 zX0 1O10 zX0 6Gp0 zX0 98p0 zX0|11e6","America/Los_Angeles|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 5Wp1 1VaX 3dA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e6","America/Maceio|LMT -03 -02|2m.Q 30 20|012121212121212121212121212121212121212121|-2glxB.8 HdLB.8 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 8Q10 WL0 1tB0 5z0 2mN0 On0|93e4","America/Managua|MMT CST EST CDT|5J.c 60 50 50|0121313121213131|-1quie.M 1yAMe.M 4mn0 9Up0 Dz0 1K10 Dz0 s3F0 1KH0 DB0 9In0 k8p0 19X0 1o30 11y0|22e5","America/Manaus|LMT -04 -03|40.4 40 30|01212121212121212121212121212121|-2glvX.U HdKX.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0|19e5","America/Martinique|FFMT AST ADT|44.k 40 30|0121|-2mPTT.E 2LPbT.E 19X0|39e4","America/Matamoros|LMT CST CDT|6E 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|45e4","America/Mazatlan|LMT MST CST PST MDT|75.E 70 60 80 60|0121212131414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|44e4","America/Menominee|CST CDT CWT CPT EST|60 50 50 50 50|01010230101041010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 LCN0 1fz0 6410 9Jb0 1cM0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|85e2","America/Merida|LMT CST EST CDT|5W.s 60 50 50|0121313131313131313131313131313131313131313131313131313131313131313131313131313131313131|-1UQG0 2q2o0 2hz0 wu30 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|11e5","America/Metlakatla|PST PWT PPT PDT AKST AKDT|80 70 70 70 90 80|01203030303030303030303030303030304545450454545454545454545454545454545454545454|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1hU10 Rd0 1zb0 Op0 1zb0 Op0 1zb0 uM0 jB0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2","America/Mexico_City|LMT MST CST CDT CWT|6A.A 70 60 50 50|012121232324232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 gEn0 TX0 3xd0 Jb0 6zB0 SL0 e5d0 17b0 1Pff0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|20e6","America/Miquelon|LMT AST -03 -02|3I.E 40 30 20|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2mKkf.k 2LTAf.k gQ10 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|61e2","America/Moncton|EST AST ADT AWT APT|50 40 30 30 30|012121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsH0 CwN0 1in0 zAo0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1K10 Lz0 1zB0 NX0 1u10 Wn0 S20 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14n1 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 ReX 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|64e3","America/Monterrey|LMT CST CDT|6F.g 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|41e5","America/Montevideo|LMT MMT -04 -03 -0330 -0230 -02 -0130|3I.P 3I.P 40 30 3u 2u 20 1u|012343434343434343434343435353636353636375363636363636363636363636363636363636363636363|-2tRUf.9 sVc0 8jcf.9 1db0 1dcu 1cLu 1dcu 1cLu ircu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu WLu 1fAu 1cLu 1o0u 11zu NAu 3jXu zXu Dq0u 19Xu pcu jz0 cm10 19X0 6tB0 1fbu 3o0u jX0 4vB0 xz0 3Cp0 mmu 1a10 IMu Db0 4c10 uL0 1Nd0 An0 1SN0 uL0 mp0 28L0 iPB0 un0 1SN0 xz0 1zd0 Lz0 1zd0 Rb0 1zd0 On0 1wp0 Rb0 s8p0 1fB0 1ip0 11z0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 11z0|17e5","America/Toronto|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101012301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 11Wu 1nzu 1fD0 WJ0 1wr0 Nb0 1Ap0 On0 1zd0 On0 1wp0 TX0 1tB0 TX0 1tB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 4kM0 8x40 iv0 1o10 11z0 1nX0 11z0 1o10 11z0 1o10 1qL0 11D0 1nX0 11B0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e5","America/New_York|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 11B0 1qL0 1a10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x40 iv0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e6","America/Nipigon|EST EDT EWT EPT|50 40 40 40|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 Rnb0 3je0 8x40 iv0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|16e2","America/Nome|NST NWT NPT BST BDT YST AKST AKDT|b0 a0 a0 b0 a0 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cl0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|38e2","America/Noronha|LMT -02 -01|29.E 20 10|0121212121212121212121212121212121212121|-2glxO.k HdKO.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|30e2","America/North_Dakota/Beulah|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/North_Dakota/Center|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/North_Dakota/New_Salem|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Ojinaga|LMT MST CST CDT MDT|6V.E 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3","America/Pangnirtung|-00 AST AWT APT ADDT ADT EDT EST CST CDT|0 40 30 30 20 30 40 50 60 50|012314151515151515151515151515151515167676767689767676767676767676767676767676767676767676767676767676767676767676767676767|-1XiM0 PnG0 8x50 iu0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1o00 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2","America/Paramaribo|LMT PMT PMT -0330 -03|3E.E 3E.Q 3E.A 3u 30|01234|-2nDUj.k Wqo0.c qanX.I 1yVXN.o|24e4","America/Port-au-Prince|PPMT EST EDT|4N 50 40|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-28RHb 2FnMb 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14q0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 i6n0 1nX0 11B0 1nX0 d430 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 3iN0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5","America/Rio_Branco|LMT -05 -04|4v.c 50 40|01212121212121212121212121212121|-2glvs.M HdLs.M 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0 d5X0|31e4","America/Porto_Velho|LMT -04 -03|4f.A 40 30|012121212121212121212121212121|-2glvI.o HdKI.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|37e4","America/Punta_Arenas|SMT -05 -04 -03|4G.K 50 40 30|0102021212121212121232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-2q2jh.e fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 blz0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|","America/Rainy_River|CST CDT CWT CPT|60 50 50 50|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TQ0 1in0 Rnb0 3je0 8x30 iw0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|842","America/Rankin_Inlet|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313131313131313131313131313131313131313131313131313131313131313131|-vDc0 keu0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e2","America/Recife|LMT -03 -02|2j.A 30 20|0121212121212121212121212121212121212121|-2glxE.o HdLE.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|33e5","America/Regina|LMT MST MDT MWT MPT CST|6W.A 70 60 60 60 60|012121212121212121212121341212121212121212121212121215|-2AD51.o uHe1.o 1in0 s2L0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 66N0 1cL0 1cN0 19X0 1fB0 1cL0 1fB0 1cL0 1cN0 1cL0 M30 8x20 ix0 1ip0 1cL0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 3NB0 1cL0 1cN0|19e4","America/Resolute|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313431313131313131313131313131313131313131313131313131313131313131|-SnA0 GWS0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|229","America/Santarem|LMT -04 -03|3C.M 40 30|0121212121212121212121212121212|-2glwl.c HdLl.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0|21e4","America/Santiago|SMT -05 -04 -03|4G.K 50 40 30|010202121212121212321232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-2q2jh.e fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 9Bz0 jb0 1oN0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0|62e5","America/Santo_Domingo|SDMT EST EDT -0430 AST|4E 50 40 4u 40|01213131313131414|-1ttjk 1lJMk Mn0 6sp0 Lbu 1Cou yLu 1RAu wLu 1QMu xzu 1Q0u xXu 1PAu 13jB0 e00|29e5","America/Sao_Paulo|LMT -03 -02|36.s 30 20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwR.w HdKR.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 pTd0 PX0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|20e6","America/Scoresbysund|LMT -02 -01 +00|1r.Q 20 10 0|0121323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2a5Ww.8 2z5ew.8 1a00 1cK0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|452","America/Sitka|PST PWT PPT PDT YST AKST AKDT|80 70 70 70 90 90 80|01203030303030303030303030303030345656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|90e2","America/St_Johns|NST NDT NST NDT NWT NPT NDDT|3u.Q 2u.Q 3u 2u 2u 2u 1u|01010101010101010101010101010101010102323232323232324523232323232323232323232323232323232323232323232323232323232323232323232323232323232326232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-28oit.8 14L0 1nB0 1in0 1gm0 Dz0 1JB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1fB0 19X0 1fB0 19X0 10O0 eKX.8 19X0 1iq0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4","America/Swift_Current|LMT MST MDT MWT MPT CST|7b.k 70 60 60 60 60|012134121212121212121215|-2AD4M.E uHdM.E 1in0 UGp0 8x20 ix0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 isN0 1cL0 3Cp0 1cL0 1cN0 11z0 1qN0 WL0 pMp0|16e3","America/Tegucigalpa|LMT CST CDT|5M.Q 60 50|01212121|-1WGGb.8 2ETcb.8 WL0 1qN0 WL0 GRd0 AL0|11e5","America/Thule|LMT AST ADT|4z.8 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5To.Q 31NBo.Q 1cL0 1cN0 1cL0 1fB0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|656","America/Thunder_Bay|CST EST EWT EPT EDT|60 50 40 40 40|0123141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-2q5S0 1iaN0 8x40 iv0 XNB0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4","America/Vancouver|PST PDT PWT PPT|80 70 70 70|0102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TO0 1in0 UGp0 8x10 iy0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5","America/Whitehorse|YST YDT YWT YPT YDDT PST PDT MST|90 80 80 80 70 80 70 70|010102304056565656565656565656565656565656565656565656565656565656565656565656565656565656567|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 3NA0 vrd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1z90|23e3","America/Winnipeg|CST CDT CWT CPT|60 50 50 50|010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aIi0 WL0 3ND0 1in0 Jap0 Rb0 aCN0 8x30 iw0 1tB0 11z0 1ip0 11z0 1o10 11z0 1o10 11z0 1rd0 10L0 1op0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 1cL0 1cN0 11z0 6i10 WL0 6i10 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|66e4","America/Yakutat|YST YWT YPT YDT AKST AKDT|90 80 80 80 90 80|01203030303030303030303030303030304545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-17T10 8x00 iz0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cn0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|642","America/Yellowknife|-00 MST MWT MPT MDDT MDT|0 70 60 60 50 60|012314151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151|-1pdA0 hix0 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3","Antarctica/Casey|-00 +08 +11|0 -80 -b0|0121212121212|-2q00 1DjS0 T90 40P0 KL0 blz0 3m10 1o30 14k0 1kr0 12l0 1o01|10","Antarctica/Davis|-00 +07 +05|0 -70 -50|01012121|-vyo0 iXt0 alj0 1D7v0 VB0 3Wn0 KN0|70","Pacific/Port_Moresby|+10|-a0|0||25e4","Antarctica/Macquarie|AEST AEDT -00|-a0 -b0 0|010201010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 1a00 4SK0 1ayy0 Lvs0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 3Co0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|1","Antarctica/Mawson|-00 +06 +05|0 -60 -50|012|-CEo0 2fyk0|60","Pacific/Auckland|NZMT NZST NZST NZDT|-bu -cu -c0 -d0|01020202020202020202020202023232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1GCVu Lz0 1tB0 11zu 1o0u 11zu 1o0u 11zu 1o0u 14nu 1lcu 14nu 1lcu 1lbu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1qLu WMu 1qLu 11Au 1n1bu IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|14e5","Antarctica/Palmer|-00 -03 -04 -02|0 30 40 20|0121212121213121212121212121212121212121212121212121212121212121212121212121212121|-cao0 nD0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 jsN0 14N0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|40","Antarctica/Rothera|-00 -03|0 30|01|gOo0|130","Asia/Riyadh|LMT +03|-36.Q -30|01|-TvD6.Q|57e5","Antarctica/Troll|-00 +00 +02|0 0 -20|01212121212121212121212121212121212121212121212121212121212121212121|1puo0 hd0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|40","Antarctica/Vostok|-00 +06|0 -60|01|-tjA0|25","Europe/Oslo|CET CEST|-10 -20|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2awM0 Qm0 W6o0 5pf0 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 wJc0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1qM0 WM0 zpc0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e4","Asia/Almaty|LMT +05 +06 +07|-57.M -50 -60 -70|012323232323232323232321232323232323232323232323232|-1Pc57.M eUo7.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|15e5","Asia/Amman|LMT EET EEST|-2n.I -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1yW2n.I 1HiMn.I KL0 1oN0 11b0 1oN0 11b0 1pd0 1dz0 1cp0 11b0 1op0 11b0 fO10 1db0 1e10 1cL0 1cN0 1cL0 1cN0 1fz0 1pd0 10n0 1ld0 14n0 1hB0 15b0 1ip0 19X0 1cN0 1cL0 1cN0 17b0 1ld0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1So0 y00 1fc0 1dc0 1co0 1dc0 1cM0 1cM0 1cM0 1o00 11A0 1lc0 17c0 1cM0 1cM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 4bX0 Dd0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 LA0 1C00 LA0 1C00 Oo0 1zc0 Oo0 1C00 LA0 1C00 LA0 1C00 LA0 1C00 LA0 1C00 Oo0 1zc0 Oo0 1C00 LA0 1C00 LA0 1C00 LA0 1C00 LA0 1C00 Oo0 1C00 LA0 1C00|25e5","Asia/Anadyr|LMT +12 +13 +14 +11|-bN.U -c0 -d0 -e0 -b0|01232121212121212121214121212121212121212121212121212121212141|-1PcbN.U eUnN.U 23CL0 1db0 2q10 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|13e3","Asia/Aqtau|LMT +04 +05 +06|-3l.4 -40 -50 -60|012323232323232323232123232312121212121212121212|-1Pc3l.4 eUnl.4 24PX0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|15e4","Asia/Aqtobe|LMT +04 +05 +06|-3M.E -40 -50 -60|0123232323232323232321232323232323232323232323232|-1Pc3M.E eUnM.E 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|27e4","Asia/Ashgabat|LMT +04 +05 +06|-3R.w -40 -50 -60|0123232323232323232323212|-1Pc3R.w eUnR.w 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0|41e4","Asia/Atyrau|LMT +03 +05 +06 +04|-3r.I -30 -50 -60 -40|01232323232323232323242323232323232324242424242|-1Pc3r.I eUor.I 24PW0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 2sp0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|","Asia/Baghdad|BMT +03 +04|-2V.A -30 -40|012121212121212121212121212121212121212121212121212121|-26BeV.A 2ACnV.A 11b0 1cp0 1dz0 1dd0 1db0 1cN0 1cp0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1de0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0|66e5","Asia/Qatar|LMT +04 +03|-3q.8 -40 -30|012|-21Jfq.8 27BXq.8|96e4","Asia/Baku|LMT +03 +04 +05|-3j.o -30 -40 -50|01232323232323232323232123232323232323232323232323232323232323232|-1Pc3j.o 1jUoj.o WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 9Je0 1o00 11z0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e5","Asia/Bangkok|BMT +07|-6G.4 -70|01|-218SG.4|15e6","Asia/Barnaul|LMT +06 +07 +08|-5z -60 -70 -80|0123232323232323232323212323232321212121212121212121212121212121212|-21S5z pCnz 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 p90 LE0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|","Asia/Beirut|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-21aq0 1on0 1410 1db0 19B0 1in0 1ip0 WL0 1lQp0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 q6N0 En0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1op0 11b0 dA10 17b0 1iN0 17b0 1iN0 17b0 1iN0 17b0 1vB0 SL0 1mp0 13z0 1iN0 17b0 1iN0 17b0 1jd0 12n0 1a10 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0|22e5","Asia/Bishkek|LMT +05 +06 +07|-4W.o -50 -60 -70|012323232323232323232321212121212121212121212121212|-1Pc4W.o eUnW.o 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2e00 1tX0 17b0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1cPu 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0|87e4","Asia/Brunei|LMT +0730 +08|-7D.E -7u -80|012|-1KITD.E gDc9.E|42e4","Asia/Kolkata|MMT IST +0630|-5l.a -5u -6u|012121|-2zOtl.a 1r2LP.a 1un0 HB0 7zX0|15e6","Asia/Chita|LMT +08 +09 +10|-7x.Q -80 -90 -a0|012323232323232323232321232323232323232323232323232323232323232312|-21Q7x.Q pAnx.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3re0|33e4","Asia/Choibalsan|LMT +07 +08 +10 +09|-7C -70 -80 -a0 -90|0123434343434343434343434343434343434343434343424242|-2APHC 2UkoC cKn0 1da0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 3Db0 h1f0 1cJ0 1cP0 1cJ0|38e3","Asia/Shanghai|CST CDT|-80 -90|01010101010101010101010101010|-23uw0 18n0 OjB0 Rz0 11d0 1wL0 A10 8HX0 1G10 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 aL0 1tU30 Rb0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0|23e6","Asia/Colombo|MMT +0530 +06 +0630|-5j.w -5u -60 -6u|01231321|-2zOtj.w 1rFbN.w 1zzu 7Apu 23dz0 11zu n3cu|22e5","Asia/Dhaka|HMT +0630 +0530 +06 +07|-5R.k -6u -5u -60 -70|0121343|-18LFR.k 1unn.k HB0 m6n0 2kxbu 1i00|16e6","Asia/Damascus|LMT EET EEST|-2p.c -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-21Jep.c Hep.c 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1xRB0 11X0 1oN0 10L0 1pB0 11b0 1oN0 10L0 1mp0 13X0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 Nb0 1AN0 Nb0 bcp0 19X0 1gp0 19X0 3ld0 1xX0 Vd0 1Bz0 Sp0 1vX0 10p0 1dz0 1cN0 1cL0 1db0 1db0 1g10 1an0 1ap0 1db0 1fd0 1db0 1cN0 1db0 1dd0 1db0 1cp0 1dz0 1c10 1dX0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 19z0 1fB0 1qL0 11B0 1on0 Wp0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0|26e5","Asia/Dili|LMT +08 +09|-8m.k -80 -90|01212|-2le8m.k 1dnXm.k 1nfA0 Xld0|19e4","Asia/Dubai|LMT +04|-3F.c -40|01|-21JfF.c|39e5","Asia/Dushanbe|LMT +05 +06 +07|-4z.c -50 -60 -70|012323232323232323232321|-1Pc4z.c eUnz.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2hB0|76e4","Asia/Famagusta|LMT EET EEST +03|-2f.M -20 -30 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212312121212121212121212121212121212121212121|-1Vc2f.M 2a3cf.M 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 15U0 2Ks0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|","Asia/Gaza|EET EEST IST IDT|-20 -30 -20 -30|010101010101010101010101010101010123232323232323232323232323232320101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1c2o0 MM0 iM0 4JA0 10o0 1pA0 10M0 1pA0 16o0 1jA0 16o0 1jA0 pBa0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 bXB0 gM0 8Q00 IM0 1wo0 TX0 1HB0 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 11z0 1o10 14o0 1lA1 SKX 1xd1 MKX 1AN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nA0 1210 1qL0 WN0 1qL0 WN0 1qL0 11c0 1on0 11B0 1o00 11A0 1qo0 Xc0 1qo0 Xc0 1qo0 1200 1nA0 1200 1qo0 Xc0 1qo0 Xc0 1qo0 Xc0 1qo0 Xc0 1qo0 1200 1nA0 1200 1qo0 Xc0 1qo0 Xc0 1qo0 Xc0 1qo0 Xc0 1qo0 1200 1qo0 Xc0 1qo0|18e5","Asia/Hebron|EET EEST IST IDT|-20 -30 -20 -30|01010101010101010101010101010101012323232323232323232323232323232010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1c2o0 MM0 iM0 4JA0 10o0 1pA0 10M0 1pA0 16o0 1jA0 16o0 1jA0 pBa0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 bXB0 gM0 8Q00 IM0 1wo0 TX0 1HB0 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 12L0 1mN0 14o0 1lc0 Tb0 1xd1 MKX bB0 cn0 1cN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nA0 1210 1qL0 WN0 1qL0 WN0 1qL0 11c0 1on0 11B0 1o00 11A0 1qo0 Xc0 1qo0 Xc0 1qo0 1200 1nA0 1200 1qo0 Xc0 1qo0 Xc0 1qo0 Xc0 1qo0 Xc0 1qo0 1200 1nA0 1200 1qo0 Xc0 1qo0 Xc0 1qo0 Xc0 1qo0 Xc0 1qo0 1200 1qo0 Xc0 1qo0|25e4","Asia/Ho_Chi_Minh|LMT PLMT +07 +08 +09|-76.E -76.u -70 -80 -90|0123423232|-2yC76.E bK00.a 1h7b6.u 5lz0 18o0 3Oq0 k5b0 aW00 BAM0|90e5","Asia/Hong_Kong|LMT HKT HKST HKWT JST|-7A.G -80 -90 -8u -90|0123412121212121212121212121212121212121212121212121212121212121212121|-2CFH0 1taO0 Hc0 xUu 9tBu 11z0 1tDu Rc0 1wo0 11A0 1cM0 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1nX0 U10 1tz0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|73e5","Asia/Hovd|LMT +06 +07 +08|-66.A -60 -70 -80|012323232323232323232323232323232323232323232323232|-2APG6.A 2Uko6.A cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|81e3","Asia/Irkutsk|IMT +07 +08 +09|-6V.5 -70 -80 -90|01232323232323232323232123232323232323232323232323232323232323232|-21zGV.5 pjXV.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4","Europe/Istanbul|IMT EET EEST +03 +04|-1U.U -20 -30 -30 -40|0121212121212121212121212121212121212121212121234312121212121212121212121212121212121212121212121212121212121212123|-2ogNU.U dzzU.U 11b0 8tB0 1on0 1410 1db0 19B0 1in0 3Rd0 Un0 1oN0 11b0 zSN0 CL0 mp0 1Vz0 1gN0 8yn0 1yp0 ML0 1kp0 17b0 1ip0 17b0 1fB0 19X0 1ip0 19X0 1ip0 17b0 qdB0 38L0 1jd0 Tz0 l6O0 11A0 WN0 1qL0 TB0 1tX0 U10 1tz0 11B0 1in0 17d0 z90 cne0 pb0 2Cp0 1800 14o0 1dc0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1a00 1fA0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WO0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 Xc0 1qo0 WM0 1qM0 11A0 1o00 1200 1nA0 11A0 1tA0 U00 15w0|13e6","Asia/Jakarta|BMT +0720 +0730 +09 +08 WIB|-77.c -7k -7u -90 -80 -70|01232425|-1Q0Tk luM0 mPzO 8vWu 6kpu 4PXu xhcu|31e6","Asia/Jayapura|LMT +09 +0930 WIT|-9m.M -90 -9u -90|0123|-1uu9m.M sMMm.M L4nu|26e4","Asia/Jerusalem|JMT IST IDT IDDT|-2k.E -20 -30 -40|01212121212121321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-26Bek.E SyOk.E MM0 iM0 4JA0 10o0 1pA0 10M0 1pA0 16o0 1jA0 16o0 1jA0 3LA0 Eo0 oo0 1co0 1dA0 16o0 10M0 1jc0 1tA0 14o0 1cM0 1a00 11A0 1Nc0 Ao0 1Nc0 Ao0 1Ko0 LA0 1o00 WM0 EQK0 Db0 1fB0 Rb0 bXB0 gM0 8Q00 IM0 1wo0 TX0 1HB0 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 1hB0 1dX0 1ep0 1aL0 1eN0 17X0 1nf0 11z0 1tB0 19W0 1e10 17b0 1ep0 1gL0 18N0 1fz0 1eN0 17b0 1gq0 1gn0 19d0 1dz0 1c10 17X0 1hB0 1gn0 19d0 1dz0 1c10 17X0 1kp0 1dz0 1c10 1aL0 1eN0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0|81e4","Asia/Kabul|+04 +0430|-40 -4u|01|-10Qs0|46e5","Asia/Kamchatka|LMT +11 +12 +13|-ay.A -b0 -c0 -d0|012323232323232323232321232323232323232323232323232323232323212|-1SLKy.A ivXy.A 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|18e4","Asia/Karachi|LMT +0530 +0630 +05 PKT PKST|-4s.c -5u -6u -50 -50 -60|012134545454|-2xoss.c 1qOKW.c 7zX0 eup0 LqMu 1fy00 1cL0 dK10 11b0 1610 1jX0|24e6","Asia/Urumqi|LMT +06|-5O.k -60|01|-1GgtO.k|32e5","Asia/Kathmandu|LMT +0530 +0545|-5F.g -5u -5J|012|-21JhF.g 2EGMb.g|12e5","Asia/Khandyga|LMT +08 +09 +10 +11|-92.d -80 -90 -a0 -b0|0123232323232323232323212323232323232323232323232343434343434343432|-21Q92.d pAp2.d 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 qK0 yN0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|66e2","Asia/Krasnoyarsk|LMT +06 +07 +08|-6b.q -60 -70 -80|01232323232323232323232123232323232323232323232323232323232323232|-21Hib.q prAb.q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|10e5","Asia/Kuala_Lumpur|SMT +07 +0720 +0730 +09 +08|-6T.p -70 -7k -7u -90 -80|0123435|-2Bg6T.p 17anT.p l5XE 17bO 8Fyu 1so1u|71e5","Asia/Kuching|LMT +0730 +08 +0820 +09|-7l.k -7u -80 -8k -90|0123232323232323242|-1KITl.k gDbP.k 6ynu AnE 1O0k AnE 1NAk AnE 1NAk AnE 1NAk AnE 1O0k AnE 1NAk AnE pAk 8Fz0|13e4","Asia/Macau|LMT CST +09 +10 CDT|-7y.a -80 -90 -a0 -90|012323214141414141414141414141414141414141414141414141414141414141414141|-2CFHy.a 1uqKy.a PX0 1kn0 15B0 11b0 4Qq0 1oM0 11c0 1ko0 1u00 11A0 1cM0 11c0 1o00 11A0 1o00 11A0 1oo0 1400 1o00 11A0 1o00 U00 1tA0 U00 1wo0 Rc0 1wru U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cK0 1cO0 1cK0 1cO0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|57e4","Asia/Magadan|LMT +10 +11 +12|-a3.c -a0 -b0 -c0|012323232323232323232321232323232323232323232323232323232323232312|-1Pca3.c eUo3.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Cq0|95e3","Asia/Makassar|LMT MMT +08 +09 WITA|-7V.A -7V.A -80 -90 -80|01234|-21JjV.A vfc0 myLV.A 8ML0|15e5","Asia/Manila|PST PDT JST|-80 -90 -90|010201010|-1kJI0 AL0 cK10 65X0 mXB0 vX0 VK10 1db0|24e6","Asia/Nicosia|LMT EET EEST|-2d.s -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Vc2d.s 2a3cd.s 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|32e4","Asia/Novokuznetsk|LMT +06 +07 +08|-5M.M -60 -70 -80|012323232323232323232321232323232323232323232323232323232323212|-1PctM.M eULM.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|55e4","Asia/Novosibirsk|LMT +06 +07 +08|-5v.E -60 -70 -80|0123232323232323232323212323212121212121212121212121212121212121212|-21Qnv.E pAFv.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 ml0 Os0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 4eN0|15e5","Asia/Omsk|LMT +05 +06 +07|-4R.u -50 -60 -70|01232323232323232323232123232323232323232323232323232323232323232|-224sR.u pMLR.u 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|12e5","Asia/Oral|LMT +03 +05 +06 +04|-3p.o -30 -50 -60 -40|01232323232323232424242424242424242424242424242|-1Pc3p.o eUop.o 23CK0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 1cM0 IM0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|27e4","Asia/Pontianak|LMT PMT +0730 +09 +08 WITA WIB|-7h.k -7h.k -7u -90 -80 -80 -70|012324256|-2ua7h.k XE00 munL.k 8Rau 6kpu 4PXu xhcu Wqnu|23e4","Asia/Pyongyang|LMT KST JST KST|-8n -8u -90 -90|012313|-2um8n 97XR 1lTzu 2Onc0 6BA0|29e5","Asia/Qostanay|LMT +04 +05 +06|-4e.s -40 -50 -60|012323232323232323232123232323232323232323232323|-1Pc4e.s eUoe.s 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|","Asia/Qyzylorda|LMT +04 +05 +06|-4l.Q -40 -50 -60|01232323232323232323232323232323232323232323232|-1Pc4l.Q eUol.Q 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 3ao0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 zQl0|73e4","Asia/Rangoon|RMT +0630 +09|-6o.L -6u -90|0121|-21Jio.L SmnS.L 7j9u|48e5","Asia/Sakhalin|LMT +09 +11 +12 +10|-9u.M -90 -b0 -c0 -a0|01232323232323232323232423232323232424242424242424242424242424242|-2AGVu.M 1BoMu.M 1qFa0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 2pB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|58e4","Asia/Samarkand|LMT +04 +05 +06|-4r.R -40 -50 -60|01232323232323232323232|-1Pc4r.R eUor.R 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0|36e4","Asia/Seoul|LMT KST JST KST KDT KDT|-8r.Q -8u -90 -90 -a0 -9u|012343434343151515151515134343|-2um8r.Q 97XV.Q 1m1zu 6CM0 Fz0 1kN0 14n0 1kN0 14L0 1zd0 On0 69B0 2I0u OL0 1FB0 Rb0 1qN0 TX0 1tB0 TX0 1tB0 TX0 1tB0 TX0 2ap0 12FBu 11A0 1o00 11A0|23e6","Asia/Srednekolymsk|LMT +10 +11 +12|-ae.Q -a0 -b0 -c0|01232323232323232323232123232323232323232323232323232323232323232|-1Pcae.Q eUoe.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|35e2","Asia/Taipei|CST JST CDT|-80 -90 -90|01020202020202020202020202020202020202020|-1iw80 joM0 1yo0 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 10N0 1BX0 10p0 1pz0 10p0 1pz0 10p0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1BB0 ML0 1Bd0 ML0 uq10 1db0 1cN0 1db0 97B0 AL0|74e5","Asia/Tashkent|LMT +05 +06 +07|-4B.b -50 -60 -70|012323232323232323232321|-1Pc4B.b eUnB.b 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0|23e5","Asia/Tbilisi|TBMT +03 +04 +05|-2X.b -30 -40 -50|0123232323232323232323212121232323232323232323212|-1Pc2X.b 1jUnX.b WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cK0 1cL0 1cN0 1cL0 1cN0 2pz0 1cL0 1fB0 3Nz0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 An0 Os0 WM0|11e5","Asia/Tehran|LMT TMT +0330 +04 +05 +0430|-3p.I -3p.I -3u -40 -50 -4u|01234325252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2btDp.I 1d3c0 1huLT.I TXu 1pz0 sN0 vAu 1cL0 1dB0 1en0 pNB0 UL0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 64p0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0|14e6","Asia/Thimphu|LMT +0530 +06|-5W.A -5u -60|012|-Su5W.A 1BGMs.A|79e3","Asia/Tokyo|JST JDT|-90 -a0|010101010|-QJJ0 Rc0 1lc0 14o0 1zc0 Oo0 1zc0 Oo0|38e6","Asia/Tomsk|LMT +06 +07 +08|-5D.P -60 -70 -80|0123232323232323232323212323232323232323232323212121212121212121212|-21NhD.P pxzD.P 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 co0 1bB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Qp0|10e5","Asia/Ulaanbaatar|LMT +07 +08 +09|-77.w -70 -80 -90|012323232323232323232323232323232323232323232323232|-2APH7.w 2Uko7.w cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|12e5","Asia/Ust-Nera|LMT +08 +09 +12 +11 +10|-9w.S -80 -90 -c0 -b0 -a0|012343434343434343434345434343434343434343434343434343434343434345|-21Q9w.S pApw.S 23CL0 1d90 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|65e2","Asia/Vladivostok|LMT +09 +10 +11|-8L.v -90 -a0 -b0|01232323232323232323232123232323232323232323232323232323232323232|-1SJIL.v itXL.v 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4","Asia/Yakutsk|LMT +08 +09 +10|-8C.W -80 -90 -a0|01232323232323232323232123232323232323232323232323232323232323232|-21Q8C.W pAoC.W 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|28e4","Asia/Yekaterinburg|LMT PMT +04 +05 +06|-42.x -3J.5 -40 -50 -60|012343434343434343434343234343434343434343434343434343434343434343|-2ag42.x 7mQh.s qBvJ.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|14e5","Asia/Yerevan|LMT +03 +04 +05|-2W -30 -40 -50|0123232323232323232323212121212323232323232323232323232323232|-1Pc2W 1jUnW WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 4RX0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|13e5","Atlantic/Azores|HMT -02 -01 +00 WET|1S.w 20 10 0 0|0121212121212121212121212121212121212121212123212321232123212121212121212121212121212121212121212121232323232323232323232323232323234323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2ldW0 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|25e4","Atlantic/Bermuda|BMT BST AST ADT|4j.i 3j.i 40 30|010102323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-28p7E.G 1bb0 1i10 11X0 ru30 thbE.G 1PX0 11B0 1tz0 Rd0 1zb0 Op0 1zb0 3I10 Lz0 1EN0 FX0 1HB0 FX0 1Kp0 Db0 1Kp0 Db0 1Kp0 FX0 93d0 11z0 GAp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e3","Atlantic/Canary|LMT -01 WET WEST|11.A 10 0 -10|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UtaW.o XPAW.o 1lAK0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Atlantic/Cape_Verde|LMT -02 -01|1y.4 20 10|01212|-2ldW0 1eEo0 7zX0 1djf0|50e4","Atlantic/Faroe|LMT WET WEST|r.4 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2uSnw.U 2Wgow.U 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|49e3","Atlantic/Madeira|FMT -01 +00 +01 WET WEST|17.A 10 0 -10 0 -10|0121212121212121212121212121212121212121212123212321232123212121212121212121212121212121212121212121454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2ldX0 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e4","Atlantic/Reykjavik|LMT -01 +00 GMT|1s 10 0 0|012121212121212121212121212121212121212121212121212121212121212121213|-2uWmw mfaw 1Bd0 ML0 1LB0 Cn0 1LB0 3fX0 C10 HrX0 1cO0 LB0 1EL0 LA0 1C00 Oo0 1wo0 Rc0 1wo0 Rc0 1wo0 Rc0 1zc0 Oo0 1zc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0|12e4","Atlantic/South_Georgia|-02|20|0||30","Atlantic/Stanley|SMT -04 -03 -02|3P.o 40 30 20|012121212121212323212121212121212121212121212121212121212121212121212|-2kJw8.A 12bA8.A 19X0 1fB0 19X0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 Cn0 1Cc10 WL0 1qL0 U10 1tz0 2mN0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 U10 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qN0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 U10 1tz0 U10 1tz0 U10|21e2","Australia/Sydney|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293k0 xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|40e5","Australia/Adelaide|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293ju xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 WM0 1qM0 Rc0 1zc0 U00 1tA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|11e5","Australia/Brisbane|AEST AEDT|-a0 -b0|01010101010101010|-293k0 xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0|20e5","Australia/Broken_Hill|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293ju xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|18e3","Australia/Hobart|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 1a00 1qM0 Oo0 1zc0 Oo0 TAo0 yM0 1cM0 1cM0 1fA0 1a00 VfA0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|21e4","Australia/Darwin|ACST ACDT|-9u -au|010101010|-293ju xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00|12e4","Australia/Eucla|+0845 +0945|-8J -9J|0101010101010101010|-293iJ xc0 10jc0 yM0 1cM0 1cM0 1gSo0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|368","Australia/Lord_Howe|AEST +1030 +1130 +11|-a0 -au -bu -b0|0121212121313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313|raC0 1zdu Rb0 1zd0 On0 1zd0 On0 1zd0 On0 1zd0 TXu 1qMu WLu 1tAu WLu 1tAu TXu 1tAu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 11Au 1nXu 1qMu 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu 11zu 1o0u WLu 1qMu 14nu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu|347","Australia/Lindeman|AEST AEDT|-a0 -b0|010101010101010101010|-293k0 xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0|10","Australia/Melbourne|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293k0 xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1qM0 11A0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|39e5","Australia/Perth|AWST AWDT|-80 -90|0101010101010101010|-293i0 xc0 10jc0 yM0 1cM0 1cM0 1gSo0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|18e5","CET|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|","Pacific/Easter|EMT -07 -06 -05|7h.s 70 60 50|012121212121212121212121212123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1uSgG.w 1s4IG.w WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 2pA0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0|30e2","CST6CDT|CST CDT CWT CPT|60 50 50 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","EET|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|","Europe/Dublin|DMT IST GMT BST IST|p.l -y.D 0 -10 -10|01232323232324242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242|-2ax9y.D Rc0 1fzy.D 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 g600 14o0 1wo0 17c0 1io0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","EST|EST|50|0||","EST5EDT|EST EDT EWT EPT|50 40 40 40|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 SgN0 8x40 iv0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","Etc/GMT-0|GMT|0|0||","Etc/GMT-1|+01|-10|0||","Etc/GMT-11|+11|-b0|0||","Pacific/Tarawa|+12|-c0|0||29e3","Etc/GMT-13|+13|-d0|0||","Etc/GMT-14|+14|-e0|0||","Etc/GMT-2|+02|-20|0||","Etc/GMT-3|+03|-30|0||","Etc/GMT-4|+04|-40|0||","Etc/GMT-5|+05|-50|0||","Etc/GMT-6|+06|-60|0||","Indian/Christmas|+07|-70|0||21e2","Etc/GMT-8|+08|-80|0||","Pacific/Palau|+09|-90|0||21e3","Etc/GMT+1|-01|10|0||","Etc/GMT+10|-10|a0|0||","Etc/GMT+11|-11|b0|0||","Etc/GMT+12|-12|c0|0||","Etc/GMT+3|-03|30|0||","Etc/GMT+4|-04|40|0||","Etc/GMT+5|-05|50|0||","Etc/GMT+6|-06|60|0||","Etc/GMT+7|-07|70|0||","Etc/GMT+8|-08|80|0||","Etc/GMT+9|-09|90|0||","Etc/UTC|UTC|0|0||","Europe/Amsterdam|AMT NST +0120 +0020 CEST CET|-j.w -1j.w -1k -k -20 -10|010101010101010101010101010101010101010101012323234545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-2aFcj.w 11b0 1iP0 11A0 1io0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1co0 1io0 1yo0 Pc0 1a00 1fA0 1Bc0 Mo0 1tc0 Uo0 1tA0 U00 1uo0 W00 1s00 VA0 1so0 Vc0 1sM0 UM0 1wo0 Rc0 1u00 Wo0 1rA0 W00 1s00 VA0 1sM0 UM0 1w00 fV0 BCX.w 1tA0 U00 1u00 Wo0 1sm0 601k WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|16e5","Europe/Andorra|WET CET CEST|0 -10 -20|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-UBA0 1xIN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|79e3","Europe/Astrakhan|LMT +03 +04 +05|-3c.c -30 -40 -50|012323232323232323212121212121212121212121212121212121212121212|-1Pcrc.c eUMc.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|10e5","Europe/Athens|AMT EET EEST CEST CET|-1y.Q -20 -30 -20 -10|012123434121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a61x.Q CNbx.Q mn0 kU10 9b0 3Es0 Xa0 1fb0 1dd0 k3X0 Nz0 SCp0 1vc0 SO0 1cM0 1a00 1ao0 1fc0 1a10 1fG0 1cg0 1dX0 1bX0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|35e5","Europe/London|GMT BST BDST|0 -10 -20|0101010101010101010101010101010101010101010101010121212121210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|10e6","Europe/Belgrade|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19RC0 3IP0 WM0 1fA0 1cM0 1cM0 1rc0 Qo0 1vmo0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Berlin|CET CEST CEMT|-10 -20 -30|01010101010101210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 kL0 Nc0 m10 WM0 1ao0 1cp0 dX0 jz0 Dd0 1io0 17c0 1fA0 1a00 1ehA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e5","Europe/Prague|CET CEST GMT|-10 -20 0|01010101010101010201010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 1qM0 11c0 mp0 xA0 mn0 17c0 1io0 17c0 1fc0 1ao0 1bNc0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|13e5","Europe/Brussels|WET CET CEST WEST|0 -10 -20 -10|0121212103030303030303030303030303030303030303030303212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ehc0 3zX0 11c0 1iO0 11A0 1o00 11A0 my0 Ic0 1qM0 Rc0 1EM0 UM0 1u00 10o0 1io0 1io0 17c0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a30 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 y00 5Wn0 WM0 1fA0 1cM0 16M0 1iM0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|21e5","Europe/Bucharest|BMT EET EEST|-1I.o -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1xApI.o 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Axc0 On0 1fA0 1a10 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|19e5","Europe/Budapest|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 1oo0 11c0 1lc0 17c0 O1V0 3Nf0 WM0 1fA0 1cM0 1cM0 1oJ0 1dd0 1020 1fX0 1cp0 1cM0 1cM0 1cM0 1fA0 1a00 bhy0 Rb0 1wr0 Rc0 1C00 LA0 1C00 LA0 SNW0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cO0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e5","Europe/Zurich|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19Lc0 11A0 1o00 11A0 1xG10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|38e4","Europe/Chisinau|CMT BMT EET EEST CEST CET MSK MSD|-1T -1I.o -20 -30 -20 -10 -30 -40|012323232323232323234545467676767676767676767323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-26jdT wGMa.A 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 27A0 2en0 39g0 WM0 1fA0 1cM0 V90 1t7z0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 gL0 WO0 1cM0 1cM0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11D0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|67e4","Europe/Copenhagen|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 Tz0 VuO0 60q0 WM0 1fA0 1cM0 1cM0 1cM0 S00 1HA0 Nc0 1C00 Dc0 1Nc0 Ao0 1h5A0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Gibraltar|GMT BST BDST CET CEST|0 -10 -20 -10 -20|010101010101010101010101010101010101010101010101012121212121010121010101010101010101034343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 10Jz0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|30e3","Europe/Helsinki|HMT EET EEST|-1D.N -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1WuND.N OULD.N 1dA0 1xGq0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Kaliningrad|CET CEST EET EEST MSK MSD +03|-10 -20 -20 -30 -30 -40 -30|01010101010101232454545454545454543232323232323232323232323232323232323232323262|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 390 7A0 1en0 12N0 1pbb0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|44e4","Europe/Kiev|KMT EET MSK CEST CET MSD EEST|-22.4 -20 -30 -20 -10 -40 -30|0123434252525252525252525256161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc22.4 eUo2.4 rnz0 2Hg0 WM0 1fA0 da0 1v4m0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 Db0 3220 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|34e5","Europe/Kirov|LMT +03 +04 +05|-3i.M -30 -40 -50|01232323232323232321212121212121212121212121212121212121212121|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|48e4","Europe/Lisbon|LMT WET WEST WEMT CET CEST|A.J 0 -10 -20 -10 -20|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121214121212121212121212121212121212124545454212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2le00 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 pvy0 1cM0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e5","Europe/Luxembourg|LMT CET CEST WET WEST WEST WET|-o.A -10 -20 0 -10 -20 -10|0121212134343434343434343434343434343434343434343434565651212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2DG0o.A t6mo.A TB0 1nX0 Up0 1o20 11A0 rW0 CM0 1qP0 R90 1EO0 UK0 1u20 10m0 1ip0 1in0 17e0 19W0 1fB0 1db0 1cp0 1in0 17d0 1fz0 1a10 1in0 1a10 1in0 17f0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 vA0 60L0 WM0 1fA0 1cM0 17c0 1io0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Europe/Madrid|WET WEST WEMT CET CEST|0 -10 -20 -10 -20|010101010101010101210343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-25Td0 19B0 1cL0 1dd0 b1z0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1in0 17d0 iIn0 Hd0 1cL0 bb0 1200 2s20 14n0 5aL0 Mp0 1vz0 17d0 1in0 17d0 1in0 17d0 1in0 17d0 6hX0 11B0 XHX0 1a10 1fz0 1a10 19X0 1cN0 1fz0 1a10 1fC0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e5","Europe/Malta|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2arB0 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1co0 17c0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1co0 1cM0 1lA0 Xc0 1qq0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1iN0 19z0 1fB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|42e4","Europe/Minsk|MMT EET MSK CEST CET MSD EEST +03|-1O -20 -30 -20 -10 -40 -30 -30|01234343252525252525252525261616161616161616161616161616161616161617|-1Pc1O eUnO qNX0 3gQ0 WM0 1fA0 1cM0 Al0 1tsn0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 3Fc0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0|19e5","Europe/Monaco|PMT WET WEST WEMT CET CEST|-9.l 0 -10 -20 -10 -20|01212121212121212121212121212121212121212121212121232323232345454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2n5c9.l cFX9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 2RV0 11z0 11B0 1ze0 WM0 1fA0 1cM0 1fa0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|38e3","Europe/Moscow|MMT MMT MST MDST MSD MSK +05 EET EEST MSK|-2u.h -2v.j -3v.j -4v.j -40 -30 -50 -20 -30 -40|012132345464575454545454545454545458754545454545454545454545454545454545454595|-2ag2u.h 2pyW.W 1bA0 11X0 GN0 1Hb0 c4v.j ik0 3DA0 dz0 15A0 c10 2q10 iM10 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|16e6","Europe/Paris|PMT WET WEST CEST CET WEMT|-9.l 0 -10 -20 -10 -20|0121212121212121212121212121212121212121212121212123434352543434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 Ik0 5M30 WM0 1fA0 1cM0 Vx0 hB0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e6","Europe/Riga|RMT LST EET MSK CEST CET MSD EEST|-1A.y -2A.y -20 -30 -20 -10 -40 -30|010102345454536363636363636363727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272|-25TzA.y 11A0 1iM0 ko0 gWm0 yDXA.y 2bX0 3fE0 WM0 1fA0 1cM0 1cM0 4m0 1sLy0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 1o00 11A0 1o00 11A0 1qM0 3oo0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|64e4","Europe/Rome|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2arB0 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1cM0 16M0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1C00 LA0 1zc0 Oo0 1C00 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1zc0 Oo0 1fC0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|39e5","Europe/Samara|LMT +03 +04 +05|-3k.k -30 -40 -50|0123232323232323232121232323232323232323232323232323232323212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2y10 14m0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|12e5","Europe/Saratov|LMT +03 +04 +05|-34.i -30 -40 -50|012323232323232321212121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 5810|","Europe/Simferopol|SMT EET MSK CEST CET MSD EEST MSK|-2g -20 -30 -20 -10 -40 -30 -40|012343432525252525252525252161616525252616161616161616161616161616161616172|-1Pc2g eUog rEn0 2qs0 WM0 1fA0 1cM0 3V0 1u0L0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 4eL0 1cL0 1cN0 1cL0 1cN0 dX0 WL0 1cN0 1cL0 1fB0 1o30 11B0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11z0 1nW0|33e4","Europe/Sofia|EET CET CEST EEST|-20 -10 -20 -30|01212103030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030|-168L0 WM0 1fA0 1cM0 1cM0 1cN0 1mKH0 1dd0 1fb0 1ap0 1fb0 1a20 1fy0 1a30 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Stockholm|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 TB0 2yDe0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|15e5","Europe/Tallinn|TMT CET CEST EET MSK MSD EEST|-1D -10 -20 -20 -30 -40 -30|012103421212454545454545454546363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363|-26oND teD 11A0 1Ta0 4rXl KSLD 2FX0 2Jg0 WM0 1fA0 1cM0 18J0 1sTX0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o10 11A0 1qM0 5QM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e4","Europe/Tirane|LMT CET CEST|-1j.k -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glBj.k 14pcj.k 5LC0 WM0 4M0 1fCK0 10n0 1op0 11z0 1pd0 11z0 1qN0 WL0 1qp0 Xb0 1qp0 Xb0 1qp0 11z0 1lB0 11z0 1qN0 11z0 1iN0 16n0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|42e4","Europe/Ulyanovsk|LMT +03 +04 +05 +02|-3d.A -30 -40 -50 -20|01232323232323232321214121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|13e5","Europe/Uzhgorod|CET CEST MSK MSD EET EEST|-10 -20 -30 -40 -20 -30|010101023232323232323232320454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-1cqL0 6i00 WM0 1fA0 1cM0 1ml0 1Cp0 1r3W0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 1Nf0 2pw0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e4","Europe/Vienna|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 3KM0 14o0 LA00 6i00 WM0 1fA0 1cM0 1cM0 1cM0 400 2qM0 1ao0 1co0 1cM0 1io0 17c0 1gHa0 19X0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|18e5","Europe/Vilnius|WMT KMT CET EET MSK CEST MSD EEST|-1o -1z.A -10 -20 -30 -20 -40 -30|012324525254646464646464646473737373737373737352537373737373737373737373737373737373737373737373737373737373737373737373|-293do 6ILM.o 1Ooz.A zz0 Mfd0 29W0 3is0 WM0 1fA0 1cM0 LV0 1tgL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11B0 1o00 11A0 1qM0 8io0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Europe/Volgograd|LMT +03 +04 +05|-2V.E -30 -40 -50|0123232323232323212121212121212121212121212121212121212121212121|-21IqV.E psLV.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 9Jd0 5gn0|10e5","Europe/Warsaw|WMT CET CEST EET EEST|-1o -10 -20 -20 -30|012121234312121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ctdo 1LXo 11d0 1iO0 11A0 1o00 11A0 1on0 11A0 6zy0 HWP0 5IM0 WM0 1fA0 1cM0 1dz0 1mL0 1en0 15B0 1aq0 1nA0 11A0 1io0 17c0 1fA0 1a00 iDX0 LA0 1cM0 1cM0 1C00 Oo0 1cM0 1cM0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1C00 LA0 uso0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e5","Europe/Zaporozhye|+0220 EET MSK CEST CET MSD EEST|-2k -20 -30 -20 -10 -40 -30|01234342525252525252525252526161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc2k eUok rdb0 2RE0 WM0 1fA0 8m0 1v9a0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cK0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|77e4","HST|HST|a0|0||","Indian/Chagos|LMT +05 +06|-4N.E -50 -60|012|-2xosN.E 3AGLN.E|30e2","Indian/Cocos|+0630|-6u|0||596","Indian/Kerguelen|-00 +05|0 -50|01|-MG00|130","Indian/Mahe|LMT +04|-3F.M -40|01|-2xorF.M|79e3","Indian/Maldives|MMT +05|-4S -50|01|-olgS|35e4","Indian/Mauritius|LMT +04 +05|-3O -40 -50|012121|-2xorO 34unO 14L0 12kr0 11z0|15e4","Indian/Reunion|LMT +04|-3F.Q -40|01|-2mDDF.Q|84e4","Pacific/Kwajalein|+11 +10 +09 -12 +12|-b0 -a0 -90 c0 -c0|012034|-1kln0 akp0 6Up0 12ry0 Wan0|14e3","MET|MET MEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|","MST|MST|70|0||","MST7MDT|MST MDT MWT MPT|70 60 60 60|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","Pacific/Chatham|+1215 +1245 +1345|-cf -cJ -dJ|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-WqAf 1adef IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|600","Pacific/Apia|LMT -1130 -11 -10 +14 +13|bq.U bu b0 a0 -e0 -d0|01232345454545454545454545|-2nDMx.4 1yW03.4 2rRbu 1ff0 1a00 CI0 AQ0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0|37e3","Pacific/Bougainville|+10 +09 +11|-a0 -90 -b0|0102|-16Wy0 7CN0 2MQp0|18e4","Pacific/Chuuk|+10 +09|-a0 -90|01010|-2ewy0 axB0 RVX0 axd0|49e3","Pacific/Efate|LMT +11 +12|-bd.g -b0 -c0|012121212121212121212121|-2l9nd.g 2uNXd.g Dc0 n610 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 Lz0 1Nd0 An0|66e3","Pacific/Enderbury|-00 -12 -11 +13|0 c0 b0 -d0|0123|-1iIo0 1GsA0 B7X0|1","Pacific/Fakaofo|-11 +13|b0 -d0|01|1Gfn0|483","Pacific/Fiji|LMT +12 +13|-bT.I -c0 -d0|01212121212121212121212121212121212121212121212121212121212121|-2bUzT.I 3m8NT.I LA0 1EM0 IM0 nJc0 LA0 1o00 Rc0 1wo0 Ao0 1Nc0 Ao0 1Q00 xz0 1SN0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 20o0 pc0 2hc0 bc0 4q00 pc0 20o0 pc0 20o0 pc0 20o0 s00 1VA0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 1VA0 s00|88e4","Pacific/Galapagos|LMT -05 -06|5W.o 50 60|01212|-1yVS1.A 2dTz1.A gNd0 rz0|25e3","Pacific/Gambier|LMT -09|8X.M 90|01|-2jof0.c|125","Pacific/Guadalcanal|LMT +11|-aD.M -b0|01|-2joyD.M|11e4","Pacific/Guam|GST +09 GDT ChST|-a0 -90 -b0 -a0|01020202020202020203|-18jK0 6pB0 AhB0 3QL0 g2p0 3p91 WOX rX0 1zd0 Rb0 1wp0 Rb0 5xd0 rX0 5sN0 zb1 1C0X On0 ULb0|17e4","Pacific/Honolulu|HST HDT HWT HPT HST|au 9u 9u 9u a0|0102304|-1thLu 8x0 lef0 8wWu iAu 46p0|37e4","Pacific/Kiritimati|-1040 -10 +14|aE a0 -e0|012|nIaE B7Xk|51e2","Pacific/Kosrae|+11 +09 +10 +12|-b0 -90 -a0 -c0|01021030|-2ewz0 axC0 HBy0 akp0 axd0 WOK0 1bdz0|66e2","Pacific/Majuro|+11 +09 +10 +12|-b0 -90 -a0 -c0|0102103|-2ewz0 axC0 HBy0 akp0 6RB0 12um0|28e3","Pacific/Marquesas|LMT -0930|9i 9u|01|-2joeG|86e2","Pacific/Pago_Pago|LMT SST|bm.M b0|01|-2nDMB.c|37e2","Pacific/Nauru|LMT +1130 +09 +12|-b7.E -bu -90 -c0|01213|-1Xdn7.E QCnB.E 7mqu 1lnbu|10e3","Pacific/Niue|LMT -1120 -11|bj.E bk b0|012|-FScE.k suo0.k|12e2","Pacific/Norfolk|+1112 +1130 +1230 +11 +12|-bc -bu -cu -b0 -c0|012134343434343434343434343434343434343434|-Kgbc W01G Oo0 1COo0 9Jcu 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|25e4","Pacific/Noumea|LMT +11 +12|-b5.M -b0 -c0|01212121|-2l9n5.M 2EqM5.M xX0 1PB0 yn0 HeP0 Ao0|98e3","Pacific/Pitcairn|-0830 -08|8u 80|01|18Vku|56","Pacific/Pohnpei|+11 +09 +10|-b0 -90 -a0|010210|-2ewz0 axC0 HBy0 akp0 axd0|34e3","Pacific/Rarotonga|LMT -1030 -0930 -10|aD.4 au 9u a0|0123232323232323232323232323|-FSdk.U 13tbO.U IL0 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu|13e3","Pacific/Tahiti|LMT -10|9W.g a0|01|-2joe1.I|18e4","Pacific/Tongatapu|LMT +1220 +13 +14|-cj.c -ck -d0 -e0|01232323232|-XbMj.c BgLX.c 1yndk 15A0 1wo0 xz0 1Q10 xz0 zWN0 s00|75e3","PST8PDT|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","WET|WET WEST|0 -10|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|"];
	var links = ["Africa/Abidjan|Africa/Accra","Africa/Abidjan|Africa/Bamako","Africa/Abidjan|Africa/Banjul","Africa/Abidjan|Africa/Conakry","Africa/Abidjan|Africa/Dakar","Africa/Abidjan|Africa/Freetown","Africa/Abidjan|Africa/Lome","Africa/Abidjan|Africa/Nouakchott","Africa/Abidjan|Africa/Ouagadougou","Africa/Abidjan|Africa/Timbuktu","Africa/Abidjan|Atlantic/St_Helena","Africa/Cairo|Egypt","Africa/Johannesburg|Africa/Maseru","Africa/Johannesburg|Africa/Mbabane","Africa/Lagos|Africa/Bangui","Africa/Lagos|Africa/Brazzaville","Africa/Lagos|Africa/Douala","Africa/Lagos|Africa/Kinshasa","Africa/Lagos|Africa/Libreville","Africa/Lagos|Africa/Luanda","Africa/Lagos|Africa/Malabo","Africa/Lagos|Africa/Niamey","Africa/Lagos|Africa/Porto-Novo","Africa/Maputo|Africa/Blantyre","Africa/Maputo|Africa/Bujumbura","Africa/Maputo|Africa/Gaborone","Africa/Maputo|Africa/Harare","Africa/Maputo|Africa/Kigali","Africa/Maputo|Africa/Lubumbashi","Africa/Maputo|Africa/Lusaka","Africa/Nairobi|Africa/Addis_Ababa","Africa/Nairobi|Africa/Asmara","Africa/Nairobi|Africa/Asmera","Africa/Nairobi|Africa/Dar_es_Salaam","Africa/Nairobi|Africa/Djibouti","Africa/Nairobi|Africa/Kampala","Africa/Nairobi|Africa/Mogadishu","Africa/Nairobi|Indian/Antananarivo","Africa/Nairobi|Indian/Comoro","Africa/Nairobi|Indian/Mayotte","Africa/Tripoli|Libya","America/Adak|America/Atka","America/Adak|US/Aleutian","America/Anchorage|US/Alaska","America/Argentina/Buenos_Aires|America/Buenos_Aires","America/Argentina/Catamarca|America/Argentina/ComodRivadavia","America/Argentina/Catamarca|America/Catamarca","America/Argentina/Cordoba|America/Cordoba","America/Argentina/Cordoba|America/Rosario","America/Argentina/Jujuy|America/Jujuy","America/Argentina/Mendoza|America/Mendoza","America/Chicago|US/Central","America/Denver|America/Shiprock","America/Denver|Navajo","America/Denver|US/Mountain","America/Detroit|US/Michigan","America/Edmonton|Canada/Mountain","America/Fort_Wayne|America/Indiana/Indianapolis","America/Fort_Wayne|America/Indianapolis","America/Fort_Wayne|US/East-Indiana","America/Godthab|America/Nuuk","America/Halifax|Canada/Atlantic","America/Havana|Cuba","America/Indiana/Knox|America/Knox_IN","America/Indiana/Knox|US/Indiana-Starke","America/Jamaica|Jamaica","America/Kentucky/Louisville|America/Louisville","America/Los_Angeles|US/Pacific","America/Manaus|Brazil/West","America/Mazatlan|Mexico/BajaSur","America/Mexico_City|Mexico/General","America/New_York|US/Eastern","America/Noronha|Brazil/DeNoronha","America/Panama|America/Atikokan","America/Panama|America/Cayman","America/Panama|America/Coral_Harbour","America/Phoenix|America/Creston","America/Phoenix|US/Arizona","America/Puerto_Rico|America/Anguilla","America/Puerto_Rico|America/Antigua","America/Puerto_Rico|America/Aruba","America/Puerto_Rico|America/Blanc-Sablon","America/Puerto_Rico|America/Curacao","America/Puerto_Rico|America/Dominica","America/Puerto_Rico|America/Grenada","America/Puerto_Rico|America/Guadeloupe","America/Puerto_Rico|America/Kralendijk","America/Puerto_Rico|America/Lower_Princes","America/Puerto_Rico|America/Marigot","America/Puerto_Rico|America/Montserrat","America/Puerto_Rico|America/Port_of_Spain","America/Puerto_Rico|America/St_Barthelemy","America/Puerto_Rico|America/St_Kitts","America/Puerto_Rico|America/St_Lucia","America/Puerto_Rico|America/St_Thomas","America/Puerto_Rico|America/St_Vincent","America/Puerto_Rico|America/Tortola","America/Puerto_Rico|America/Virgin","America/Regina|Canada/Saskatchewan","America/Rio_Branco|America/Porto_Acre","America/Rio_Branco|Brazil/Acre","America/Santiago|Chile/Continental","America/Sao_Paulo|Brazil/East","America/St_Johns|Canada/Newfoundland","America/Tijuana|America/Ensenada","America/Tijuana|America/Santa_Isabel","America/Tijuana|Mexico/BajaNorte","America/Toronto|America/Montreal","America/Toronto|America/Nassau","America/Toronto|Canada/Eastern","America/Vancouver|Canada/Pacific","America/Whitehorse|Canada/Yukon","America/Winnipeg|Canada/Central","Asia/Ashgabat|Asia/Ashkhabad","Asia/Bangkok|Asia/Phnom_Penh","Asia/Bangkok|Asia/Vientiane","Asia/Dhaka|Asia/Dacca","Asia/Dubai|Asia/Muscat","Asia/Ho_Chi_Minh|Asia/Saigon","Asia/Hong_Kong|Hongkong","Asia/Jerusalem|Asia/Tel_Aviv","Asia/Jerusalem|Israel","Asia/Kathmandu|Asia/Katmandu","Asia/Kolkata|Asia/Calcutta","Asia/Kuala_Lumpur|Asia/Singapore","Asia/Kuala_Lumpur|Singapore","Asia/Macau|Asia/Macao","Asia/Makassar|Asia/Ujung_Pandang","Asia/Nicosia|Europe/Nicosia","Asia/Qatar|Asia/Bahrain","Asia/Rangoon|Asia/Yangon","Asia/Riyadh|Antarctica/Syowa","Asia/Riyadh|Asia/Aden","Asia/Riyadh|Asia/Kuwait","Asia/Seoul|ROK","Asia/Shanghai|Asia/Chongqing","Asia/Shanghai|Asia/Chungking","Asia/Shanghai|Asia/Harbin","Asia/Shanghai|PRC","Asia/Taipei|ROC","Asia/Tehran|Iran","Asia/Thimphu|Asia/Thimbu","Asia/Tokyo|Japan","Asia/Ulaanbaatar|Asia/Ulan_Bator","Asia/Urumqi|Asia/Kashgar","Atlantic/Faroe|Atlantic/Faeroe","Atlantic/Reykjavik|Iceland","Atlantic/South_Georgia|Etc/GMT+2","Australia/Adelaide|Australia/South","Australia/Brisbane|Australia/Queensland","Australia/Broken_Hill|Australia/Yancowinna","Australia/Darwin|Australia/North","Australia/Hobart|Australia/Currie","Australia/Hobart|Australia/Tasmania","Australia/Lord_Howe|Australia/LHI","Australia/Melbourne|Australia/Victoria","Australia/Perth|Australia/West","Australia/Sydney|Australia/ACT","Australia/Sydney|Australia/Canberra","Australia/Sydney|Australia/NSW","Etc/GMT-0|Etc/GMT","Etc/GMT-0|Etc/GMT+0","Etc/GMT-0|Etc/GMT0","Etc/GMT-0|Etc/Greenwich","Etc/GMT-0|GMT","Etc/GMT-0|GMT+0","Etc/GMT-0|GMT-0","Etc/GMT-0|GMT0","Etc/GMT-0|Greenwich","Etc/UTC|Etc/UCT","Etc/UTC|Etc/Universal","Etc/UTC|Etc/Zulu","Etc/UTC|UCT","Etc/UTC|UTC","Etc/UTC|Universal","Etc/UTC|Zulu","Europe/Belgrade|Europe/Ljubljana","Europe/Belgrade|Europe/Podgorica","Europe/Belgrade|Europe/Sarajevo","Europe/Belgrade|Europe/Skopje","Europe/Belgrade|Europe/Zagreb","Europe/Chisinau|Europe/Tiraspol","Europe/Dublin|Eire","Europe/Helsinki|Europe/Mariehamn","Europe/Istanbul|Asia/Istanbul","Europe/Istanbul|Turkey","Europe/Lisbon|Portugal","Europe/London|Europe/Belfast","Europe/London|Europe/Guernsey","Europe/London|Europe/Isle_of_Man","Europe/London|Europe/Jersey","Europe/London|GB","Europe/London|GB-Eire","Europe/Moscow|W-SU","Europe/Oslo|Arctic/Longyearbyen","Europe/Oslo|Atlantic/Jan_Mayen","Europe/Prague|Europe/Bratislava","Europe/Rome|Europe/San_Marino","Europe/Rome|Europe/Vatican","Europe/Warsaw|Poland","Europe/Zurich|Europe/Busingen","Europe/Zurich|Europe/Vaduz","Indian/Christmas|Etc/GMT-7","Pacific/Auckland|Antarctica/McMurdo","Pacific/Auckland|Antarctica/South_Pole","Pacific/Auckland|NZ","Pacific/Chatham|NZ-CHAT","Pacific/Chuuk|Pacific/Truk","Pacific/Chuuk|Pacific/Yap","Pacific/Easter|Chile/EasterIsland","Pacific/Enderbury|Pacific/Kanton","Pacific/Guam|Pacific/Saipan","Pacific/Honolulu|Pacific/Johnston","Pacific/Honolulu|US/Hawaii","Pacific/Kwajalein|Kwajalein","Pacific/Pago_Pago|Pacific/Midway","Pacific/Pago_Pago|Pacific/Samoa","Pacific/Pago_Pago|US/Samoa","Pacific/Palau|Etc/GMT-9","Pacific/Pohnpei|Pacific/Ponape","Pacific/Port_Moresby|Antarctica/DumontDUrville","Pacific/Port_Moresby|Etc/GMT-10","Pacific/Tarawa|Etc/GMT-12","Pacific/Tarawa|Pacific/Funafuti","Pacific/Tarawa|Pacific/Wake","Pacific/Tarawa|Pacific/Wallis"];
	var countries = ["AD|Europe/Andorra","AE|Asia/Dubai","AF|Asia/Kabul","AG|America/Port_of_Spain America/Antigua","AI|America/Port_of_Spain America/Anguilla","AL|Europe/Tirane","AM|Asia/Yerevan","AO|Africa/Lagos Africa/Luanda","AQ|Antarctica/Casey Antarctica/Davis Antarctica/DumontDUrville Antarctica/Mawson Antarctica/Palmer Antarctica/Rothera Antarctica/Syowa Antarctica/Troll Antarctica/Vostok Pacific/Auckland Antarctica/McMurdo","AR|America/Argentina/Buenos_Aires America/Argentina/Cordoba America/Argentina/Salta America/Argentina/Jujuy America/Argentina/Tucuman America/Argentina/Catamarca America/Argentina/La_Rioja America/Argentina/San_Juan America/Argentina/Mendoza America/Argentina/San_Luis America/Argentina/Rio_Gallegos America/Argentina/Ushuaia","AS|Pacific/Pago_Pago","AT|Europe/Vienna","AU|Australia/Lord_Howe Antarctica/Macquarie Australia/Hobart Australia/Melbourne Australia/Sydney Australia/Broken_Hill Australia/Brisbane Australia/Lindeman Australia/Adelaide Australia/Darwin Australia/Perth Australia/Eucla","AW|America/Curacao America/Aruba","AX|Europe/Helsinki Europe/Mariehamn","AZ|Asia/Baku","BA|Europe/Belgrade Europe/Sarajevo","BB|America/Barbados","BD|Asia/Dhaka","BE|Europe/Brussels","BF|Africa/Abidjan Africa/Ouagadougou","BG|Europe/Sofia","BH|Asia/Qatar Asia/Bahrain","BI|Africa/Maputo Africa/Bujumbura","BJ|Africa/Lagos Africa/Porto-Novo","BL|America/Port_of_Spain America/St_Barthelemy","BM|Atlantic/Bermuda","BN|Asia/Brunei","BO|America/La_Paz","BQ|America/Curacao America/Kralendijk","BR|America/Noronha America/Belem America/Fortaleza America/Recife America/Araguaina America/Maceio America/Bahia America/Sao_Paulo America/Campo_Grande America/Cuiaba America/Santarem America/Porto_Velho America/Boa_Vista America/Manaus America/Eirunepe America/Rio_Branco","BS|America/Nassau","BT|Asia/Thimphu","BW|Africa/Maputo Africa/Gaborone","BY|Europe/Minsk","BZ|America/Belize","CA|America/St_Johns America/Halifax America/Glace_Bay America/Moncton America/Goose_Bay America/Blanc-Sablon America/Toronto America/Nipigon America/Thunder_Bay America/Iqaluit America/Pangnirtung America/Atikokan America/Winnipeg America/Rainy_River America/Resolute America/Rankin_Inlet America/Regina America/Swift_Current America/Edmonton America/Cambridge_Bay America/Yellowknife America/Inuvik America/Creston America/Dawson_Creek America/Fort_Nelson America/Whitehorse America/Dawson America/Vancouver","CC|Indian/Cocos","CD|Africa/Maputo Africa/Lagos Africa/Kinshasa Africa/Lubumbashi","CF|Africa/Lagos Africa/Bangui","CG|Africa/Lagos Africa/Brazzaville","CH|Europe/Zurich","CI|Africa/Abidjan","CK|Pacific/Rarotonga","CL|America/Santiago America/Punta_Arenas Pacific/Easter","CM|Africa/Lagos Africa/Douala","CN|Asia/Shanghai Asia/Urumqi","CO|America/Bogota","CR|America/Costa_Rica","CU|America/Havana","CV|Atlantic/Cape_Verde","CW|America/Curacao","CX|Indian/Christmas","CY|Asia/Nicosia Asia/Famagusta","CZ|Europe/Prague","DE|Europe/Zurich Europe/Berlin Europe/Busingen","DJ|Africa/Nairobi Africa/Djibouti","DK|Europe/Copenhagen","DM|America/Port_of_Spain America/Dominica","DO|America/Santo_Domingo","DZ|Africa/Algiers","EC|America/Guayaquil Pacific/Galapagos","EE|Europe/Tallinn","EG|Africa/Cairo","EH|Africa/El_Aaiun","ER|Africa/Nairobi Africa/Asmara","ES|Europe/Madrid Africa/Ceuta Atlantic/Canary","ET|Africa/Nairobi Africa/Addis_Ababa","FI|Europe/Helsinki","FJ|Pacific/Fiji","FK|Atlantic/Stanley","FM|Pacific/Chuuk Pacific/Pohnpei Pacific/Kosrae","FO|Atlantic/Faroe","FR|Europe/Paris","GA|Africa/Lagos Africa/Libreville","GB|Europe/London","GD|America/Port_of_Spain America/Grenada","GE|Asia/Tbilisi","GF|America/Cayenne","GG|Europe/London Europe/Guernsey","GH|Africa/Accra","GI|Europe/Gibraltar","GL|America/Nuuk America/Danmarkshavn America/Scoresbysund America/Thule","GM|Africa/Abidjan Africa/Banjul","GN|Africa/Abidjan Africa/Conakry","GP|America/Port_of_Spain America/Guadeloupe","GQ|Africa/Lagos Africa/Malabo","GR|Europe/Athens","GS|Atlantic/South_Georgia","GT|America/Guatemala","GU|Pacific/Guam","GW|Africa/Bissau","GY|America/Guyana","HK|Asia/Hong_Kong","HN|America/Tegucigalpa","HR|Europe/Belgrade Europe/Zagreb","HT|America/Port-au-Prince","HU|Europe/Budapest","ID|Asia/Jakarta Asia/Pontianak Asia/Makassar Asia/Jayapura","IE|Europe/Dublin","IL|Asia/Jerusalem","IM|Europe/London Europe/Isle_of_Man","IN|Asia/Kolkata","IO|Indian/Chagos","IQ|Asia/Baghdad","IR|Asia/Tehran","IS|Atlantic/Reykjavik","IT|Europe/Rome","JE|Europe/London Europe/Jersey","JM|America/Jamaica","JO|Asia/Amman","JP|Asia/Tokyo","KE|Africa/Nairobi","KG|Asia/Bishkek","KH|Asia/Bangkok Asia/Phnom_Penh","KI|Pacific/Tarawa Pacific/Enderbury Pacific/Kiritimati","KM|Africa/Nairobi Indian/Comoro","KN|America/Port_of_Spain America/St_Kitts","KP|Asia/Pyongyang","KR|Asia/Seoul","KW|Asia/Riyadh Asia/Kuwait","KY|America/Panama America/Cayman","KZ|Asia/Almaty Asia/Qyzylorda Asia/Qostanay Asia/Aqtobe Asia/Aqtau Asia/Atyrau Asia/Oral","LA|Asia/Bangkok Asia/Vientiane","LB|Asia/Beirut","LC|America/Port_of_Spain America/St_Lucia","LI|Europe/Zurich Europe/Vaduz","LK|Asia/Colombo","LR|Africa/Monrovia","LS|Africa/Johannesburg Africa/Maseru","LT|Europe/Vilnius","LU|Europe/Luxembourg","LV|Europe/Riga","LY|Africa/Tripoli","MA|Africa/Casablanca","MC|Europe/Monaco","MD|Europe/Chisinau","ME|Europe/Belgrade Europe/Podgorica","MF|America/Port_of_Spain America/Marigot","MG|Africa/Nairobi Indian/Antananarivo","MH|Pacific/Majuro Pacific/Kwajalein","MK|Europe/Belgrade Europe/Skopje","ML|Africa/Abidjan Africa/Bamako","MM|Asia/Yangon","MN|Asia/Ulaanbaatar Asia/Hovd Asia/Choibalsan","MO|Asia/Macau","MP|Pacific/Guam Pacific/Saipan","MQ|America/Martinique","MR|Africa/Abidjan Africa/Nouakchott","MS|America/Port_of_Spain America/Montserrat","MT|Europe/Malta","MU|Indian/Mauritius","MV|Indian/Maldives","MW|Africa/Maputo Africa/Blantyre","MX|America/Mexico_City America/Cancun America/Merida America/Monterrey America/Matamoros America/Mazatlan America/Chihuahua America/Ojinaga America/Hermosillo America/Tijuana America/Bahia_Banderas","MY|Asia/Kuala_Lumpur Asia/Kuching","MZ|Africa/Maputo","NA|Africa/Windhoek","NC|Pacific/Noumea","NE|Africa/Lagos Africa/Niamey","NF|Pacific/Norfolk","NG|Africa/Lagos","NI|America/Managua","NL|Europe/Amsterdam","NO|Europe/Oslo","NP|Asia/Kathmandu","NR|Pacific/Nauru","NU|Pacific/Niue","NZ|Pacific/Auckland Pacific/Chatham","OM|Asia/Dubai Asia/Muscat","PA|America/Panama","PE|America/Lima","PF|Pacific/Tahiti Pacific/Marquesas Pacific/Gambier","PG|Pacific/Port_Moresby Pacific/Bougainville","PH|Asia/Manila","PK|Asia/Karachi","PL|Europe/Warsaw","PM|America/Miquelon","PN|Pacific/Pitcairn","PR|America/Puerto_Rico","PS|Asia/Gaza Asia/Hebron","PT|Europe/Lisbon Atlantic/Madeira Atlantic/Azores","PW|Pacific/Palau","PY|America/Asuncion","QA|Asia/Qatar","RE|Indian/Reunion","RO|Europe/Bucharest","RS|Europe/Belgrade","RU|Europe/Kaliningrad Europe/Moscow Europe/Simferopol Europe/Kirov Europe/Volgograd Europe/Astrakhan Europe/Saratov Europe/Ulyanovsk Europe/Samara Asia/Yekaterinburg Asia/Omsk Asia/Novosibirsk Asia/Barnaul Asia/Tomsk Asia/Novokuznetsk Asia/Krasnoyarsk Asia/Irkutsk Asia/Chita Asia/Yakutsk Asia/Khandyga Asia/Vladivostok Asia/Ust-Nera Asia/Magadan Asia/Sakhalin Asia/Srednekolymsk Asia/Kamchatka Asia/Anadyr","RW|Africa/Maputo Africa/Kigali","SA|Asia/Riyadh","SB|Pacific/Guadalcanal","SC|Indian/Mahe","SD|Africa/Khartoum","SE|Europe/Stockholm","SG|Asia/Singapore","SH|Africa/Abidjan Atlantic/St_Helena","SI|Europe/Belgrade Europe/Ljubljana","SJ|Europe/Oslo Arctic/Longyearbyen","SK|Europe/Prague Europe/Bratislava","SL|Africa/Abidjan Africa/Freetown","SM|Europe/Rome Europe/San_Marino","SN|Africa/Abidjan Africa/Dakar","SO|Africa/Nairobi Africa/Mogadishu","SR|America/Paramaribo","SS|Africa/Juba","ST|Africa/Sao_Tome","SV|America/El_Salvador","SX|America/Curacao America/Lower_Princes","SY|Asia/Damascus","SZ|Africa/Johannesburg Africa/Mbabane","TC|America/Grand_Turk","TD|Africa/Ndjamena","TF|Indian/Reunion Indian/Kerguelen","TG|Africa/Abidjan Africa/Lome","TH|Asia/Bangkok","TJ|Asia/Dushanbe","TK|Pacific/Fakaofo","TL|Asia/Dili","TM|Asia/Ashgabat","TN|Africa/Tunis","TO|Pacific/Tongatapu","TR|Europe/Istanbul","TT|America/Port_of_Spain","TV|Pacific/Funafuti","TW|Asia/Taipei","TZ|Africa/Nairobi Africa/Dar_es_Salaam","UA|Europe/Simferopol Europe/Kiev Europe/Uzhgorod Europe/Zaporozhye","UG|Africa/Nairobi Africa/Kampala","UM|Pacific/Pago_Pago Pacific/Wake Pacific/Honolulu Pacific/Midway","US|America/New_York America/Detroit America/Kentucky/Louisville America/Kentucky/Monticello America/Indiana/Indianapolis America/Indiana/Vincennes America/Indiana/Winamac America/Indiana/Marengo America/Indiana/Petersburg America/Indiana/Vevay America/Chicago America/Indiana/Tell_City America/Indiana/Knox America/Menominee America/North_Dakota/Center America/North_Dakota/New_Salem America/North_Dakota/Beulah America/Denver America/Boise America/Phoenix America/Los_Angeles America/Anchorage America/Juneau America/Sitka America/Metlakatla America/Yakutat America/Nome America/Adak Pacific/Honolulu","UY|America/Montevideo","UZ|Asia/Samarkand Asia/Tashkent","VA|Europe/Rome Europe/Vatican","VC|America/Port_of_Spain America/St_Vincent","VE|America/Caracas","VG|America/Port_of_Spain America/Tortola","VI|America/Port_of_Spain America/St_Thomas","VN|Asia/Bangkok Asia/Ho_Chi_Minh","VU|Pacific/Efate","WF|Pacific/Wallis","WS|Pacific/Apia","YE|Asia/Riyadh Asia/Aden","YT|Africa/Nairobi Indian/Mayotte","ZA|Africa/Johannesburg","ZM|Africa/Maputo Africa/Lusaka","ZW|Africa/Maputo Africa/Harare"];
	var latest = {
		version: version,
		zones: zones,
		links: links,
		countries: countries
	};

	var latest$1 = /*#__PURE__*/Object.freeze({
		version: version,
		zones: zones,
		links: links,
		countries: countries,
		default: latest
	});

	var require$$0$9 = ( momentTimezone$1 && momentTimezone ) || momentTimezone$1;

	var require$$1$5 = ( latest$1 && latest ) || latest$1;

	var momentTimezone$2 = createCommonjsModule(function (module) {
	var moment = module.exports = require$$0$9;
	moment.tz.load(require$$1$5);
	});

	//

	var script$G = {
	  props: {
	    type: String, // roomstream, facebookstream, ...
	    id: String, // channel id
	  },
	  data: function data() {
	    var self = this;
	    var type = self.type;
	    var id = self.id;

	    var channelType = Utils$1.channelTypes(type);

	    var store = new Store(self, {
	      get: [channelType, 'settings', { id: id }],
	      post: ['channelofficehours', 'settings', { id: id, type: channelType }],
	      getFinished: function getFinished() {
	      },
	      postFinished: function postFinished(result) {
	        self.saveInProgress = false;
	        if (result.success) {
	          Brief$1.events.$emit('refresh-settings');
	          Brief$1.viewMain.router.back();
	        }
	      },
	    });
	    store.get();

	    return {
	      store: store,
	      saveInProgress: false,
	      timezones: lodash.orderBy(lodash.filter(momentTimezone$2.tz.names().map(function (z) { return ({
	        offset: momentTimezone$2().tz(z).utcOffset(),
	        name: z,
	        offsetString: momentTimezone$2().tz(z).format('Z'),
	      }); }), function (x) { return !/GMT/.test(x.name); }), ['offset', 'name']),
	    };
	  },
	  computed: {
	    officeHoursZoneComputed: {
	      get: function get() {
	        var self = this;
	        if (self.store.officeHoursZone === null || self.store.officeHoursZone === undefined) {
	          var tz = self.timezones.find(function (x) { return x.offset === -new Date().getTimezoneOffset(); });
	          if (!tz) {
	            return undefined;
	          }
	          return tz.name;
	        }
	        return self.store.officeHoursZone;
	      },
	      set: function set(value) {
	        var self = this;
	        self.store.officeHoursZone = value;
	      },
	    },
	    embedCode: function embedCode() {
	      return widgetEmbedCode(this.store.widgetId);
	    },
	    weekDaysValues: function weekDaysValues() {
	      return ('Monday Tuesday Wednesday Thursday Friday Saturday Sunday').split(' ').map(function (day) { return day.substr(0, 3).toLowerCase(); });
	    },
	    weekDaysTitles: function weekDaysTitles() {
	      return ('Monday Tuesday Wednesday Thursday Friday Saturday Sunday').split(' ').map(function (day) { return day.substr(0, 3); });
	    },
	  },
	  methods: {
	    updateStore: function updateStore(props) {
	      var self = this;
	      Object.keys(props).forEach(function (prop) {
	        self.store[prop] = props[prop];
	      });
	    },
	    save: function save() {
	      var self = this;
	      self.saveInProgress = true;
	      if (!self.store.officeHours || Object.keys(self.store.officeHours).length === 0) {
	        self.store.officeHours = null;
	      }
	      self.store.officeHoursZone = self.officeHoursZoneComputed;
	      self.store.post();
	    },
	    getFullHours: function getFullHours(h) {
	      return h < 10 ? ("0" + h) : h;
	    },
	    getZoneHours: function getZoneHours(h) {
	      var abs = Math.abs(h);
	      if (h < 0) {
	        return abs < 10 ? ("-0" + abs) : ("-" + abs);
	      }
	      return abs < 10 ? ("+0" + abs) : ("+" + abs);
	    },
	    handle24Switch: function handle24Switch(event) {
	      var self = this;
	      var checked;
	      if (event.target) { checked = event.target.checked; }
	      else { checked = event; }
	      if (!checked) {
	        if (typeof self.store.officeHours === 'object' && self.store.officeHours !== null) { return; }
	        self.store.officeHours = {};
	      } else {
	        self.store.officeHours = undefined;
	      }
	    },
	    handleDayChange: function handleDayChange(event) {
	      var self = this;
	      var checked = event.target.checked;
	      var value = event.target.value;
	      if (checked) {
	        self.$set(self.store.officeHours, value, [{ from: 9, to: 17 }]);
	      } else {
	        self.$delete(self.store.officeHours, value);
	      }
	    },
	    addHoursRow: function addHoursRow(day) {
	      var self = this;
	      self.store.officeHours[day.toLowerCase()].push({ from: 9, to: 17 });
	    },
	    removeHoursRow: function removeHoursRow(day, index) {
	      var self = this;
	      self.store.officeHours[day.toLowerCase()].splice(index, 1);
	    },
	  },
	};

	/* script */
	var __vue_script__$G = script$G;

	/* template */
	var __vue_render__$D = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f7-page',{staticClass:"page-form"},[_c('common-navbar',{attrs:{"title":"Office hours"}}),_vm._v(" "),_c('f7-block-title',[_vm._v("Office hours")]),_vm._v(" "),_c('f7-list',[_c('f7-list-item',{attrs:{"title":"Open 24/7"}},[_c('f7-toggle',{attrs:{"slot":"after","checked":!_vm.store.officeHours},nativeOn:{"change":function($event){return _vm.handle24Switch.apply(null, arguments)}},slot:"after"})],1)],1),_vm._v(" "),(_vm.store.officeHours)?_c('f7-list',{staticClass:"timezone-picker"},[_c('f7-list-item',{attrs:{"item-input":""}},[_c('f7-label',[_vm._v("Timezone")]),_vm._v(" "),_c('f7-input',{staticClass:"item-input-field"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.officeHoursZoneComputed),expression:"officeHoursZoneComputed"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.officeHoursZoneComputed=$event.target.multiple ? $$selectedVal : $$selectedVal[0];}}},_vm._l((_vm.timezones),function(tz){return _c('option',{domProps:{"value":tz.name}},[_vm._v("(GMT "+_vm._s((tz.offsetString))+") "+_vm._s(tz.name))])}),0)])],1)],1):_vm._e(),_vm._v(" "),(_vm.store.officeHours)?_c('f7-list',{staticClass:"office-hours-picker"},_vm._l((_vm.weekDaysValues),function(day,index){return _c('f7-list-item',[_c('label',{staticClass:"checkbox",attrs:{"slot":"media"},slot:"media"},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":day in _vm.store.officeHours,"value":day},on:{"change":_vm.handleDayChange}}),_vm._v(" "),_c('i',{staticClass:"icon-checkbox"})]),_vm._v(" "),_c('div',{staticClass:"item-title",attrs:{"slot":"inner"},slot:"inner"},[_vm._v(_vm._s(_vm.weekDaysTitles[index]))]),_vm._v(" "),(_vm.store.officeHours[day])?_c('div',{staticClass:"office-hours-rows",attrs:{"slot":"inner"},slot:"inner"},_vm._l((_vm.store.officeHours[day]),function(hours,index){return _c('div',{staticClass:"office-hours-row"},[_c('div',{staticClass:"office-hours-select-wrap"},[_c('div',{staticClass:"office-hours-select-title"},[_vm._v("From")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(hours.from),expression:"hours.from"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(hours, "from", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);}}},_vm._l((24 * 2),function(n){return _c('option',{domProps:{"value":(n - 1) / 2}},[_vm._v(_vm._s(_vm.getFullHours(Math.trunc((n - 1) / 2)))+":"+_vm._s((n - 1) % 2 === 0 ? '00' : '30'))])}),0)]),_vm._v(" "),_c('span',[_vm._v("-")]),_vm._v(" "),_c('div',{staticClass:"office-hours-select-wrap"},[_c('div',{staticClass:"office-hours-select-title"},[_vm._v("To")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(hours.to),expression:"hours.to"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(hours, "to", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);}}},_vm._l((24),function(n){return _c('option',{domProps:{"value":n-1}},[_vm._v(_vm._s(_vm.getFullHours(n-1))+":00")])}),0)]),_vm._v(" "),_c('f7-link',{staticClass:"office-hours-add-link",attrs:{"icon-only":"","icon-if-ios":"f7:add_round_fill","icon-if-md":"material:add"},on:{"click":function($event){return _vm.addHoursRow(day)}}}),_vm._v(" "),_c('f7-link',{staticClass:"office-hours-delete-link",class:{'office-hours-row-inactive-link': _vm.store.officeHours[day].length < 2},attrs:{"icon-only":"","icon-if-ios":"f7:delete_round_fill","icon-if-md":"material:delete"},on:{"click":function($event){return _vm.removeHoursRow(day, index)}}})],1)}),0):_vm._e()])}),1):_vm._e(),_vm._v(" "),_c('f7-list',[_c('f7-list-button',{on:{"click":_vm.save}},[(!_vm.saveInProgress)?_c('span',[_vm._v("Save")]):_vm._e(),_vm._v(" "),(_vm.saveInProgress)?_c('span',{staticClass:"spinner"}):_vm._e()])],1)],1)};
	var __vue_staticRenderFns__$D = [];

	  /* style */
	  var __vue_inject_styles__$G = undefined;
	  /* scoped */
	  var __vue_scope_id__$G = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$G = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$G = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$G = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$D, staticRenderFns: __vue_staticRenderFns__$D },
	    __vue_inject_styles__$G,
	    __vue_script__$G,
	    __vue_scope_id__$G,
	    __vue_is_functional_template__$G,
	    __vue_module_identifier__$G,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	/* eslint no-regex-spaces: ["off"] */
	function widgetEmbedCode$1(id, customChatButton, widgetElementId, widgetUnreadCountId) {
	  if ( id === void 0 ) id = '';
	  if ( customChatButton === void 0 ) customChatButton = false;
	  if ( widgetElementId === void 0 ) widgetElementId = 'brief-chat-button';
	  if ( widgetUnreadCountId === void 0 ) widgetUnreadCountId = 'brief-unread-count';

	  return ("\n<script>\nwindow.BriefWidgetId = '" + id + "';\n" + (customChatButton
	    ? ("\nwindow.BriefElementId = '" + widgetElementId + "';\nwindow.BriefUnreadId = '" + widgetUnreadCountId + "';\n")
	    : '') + "\nwindow.BriefUser = {\n  firstName: '',\n  lastName: '',\n  email: '',\n  avatarUrl: '',\n};\n(function() {\n  var w = window;\n  var d = document;\n  function l() {\n    var s = d.createElement('script');\n    s.type = 'text/javascript';\n    s.async = true;\n    s.src = 'https://widget.letsbrief.com/widget/widget.min.js';\n    d.head.appendChild(s);\n  }\n  if (w.attachEvent) {\n    w.attachEvent('onload', l);\n  } else {\n    w.addEventListener('load', l, false);\n  }\n})();\n</script>")
	    .trim()
	    .replace(/\n      /g, '')
	    .replace(/\n    /g, '')
	    .replace(/\n  /g, '')
	    .replace(/\n/g, '');
	}

	//

	var script$H = {
	  props: {
	    type: String, // roomstream, facebookstream, ...
	    id: String, // channel id
	  },
	  data: function data() {
	    var self = this;
	    var type = self.type;
	    var id = self.id;

	    var channelType = Utils$1.channelTypes(type);

	    var store = new Store(self, {
	      get: [channelType, 'settings', { id: id }],
	      post: ['channelwidget', 'settings', { id: id, type: channelType }],
	      getFinished: function getFinished() {
	      },
	      postFinished: function postFinished(result) {
	        self.saveInProgress = false;
	        if (result.success) {
	          Brief$1.events.$emit('refresh-settings');
	          Brief$1.viewMain.router.back();
	        }
	      },
	    });

	    var storeOnline = new Store(self, {
	      postNow: ['websitechannel', 'online'],
	    });

	    store.get();

	    return {
	      store: store,
	      storeOnline: storeOnline,
	      saveInProgress: false,
	      introSelectedLanguage: '',
	      welcomeSelectedLanguage: '',
	      languages: Utils$1.getLanguages(),
	      welcomeMessageTimeoutSettings: [1, 2, 3, 5, 10, 20, 30, 60],
	    };
	  },
	  watch: {
	    introSelectedLanguage: function(newValue) {
	      var self = this;
	      if (!newValue) {
	        return;
	      }
	      self.store.teamIntroTextLanguages.push({
	        lang: self.introSelectedLanguage,
	        name: self.languages.find(function (x) { return x.lang === self.introSelectedLanguage; }).name,
	        text: '',
	      });
	      self.introSelectedLanguage = '';
	    },
	    welcomeSelectedLanguage: function(newValue) {
	      var self = this;
	      if (!newValue) {
	        return;
	      }
	      self.store.welcomeMessageLanguages.push({
	        lang: self.welcomeSelectedLanguage,
	        name: self.languages.find(function (x) { return x.lang === self.welcomeSelectedLanguage; }).name,
	        text: '',
	      });
	      self.welcomeSelectedLanguage = '';
	    },
	  },
	  computed: {
	    expectedResponseTimeComputed: {
	      get: function get() {
	        var self = this;
	        return self.store.expectedResponseTime || '1';
	      },
	      set: function set(value) {
	        var self = this;
	        self.store.expectedResponseTime = value;
	      },
	    },
	    embedCode: function embedCode() {
	      return widgetEmbedCode$1(
	        this.store.widgetId,
	        this.store.customChatButton,
	        this.store.widgetElementId,
	        this.store.widgetUnreadCountId
	      );
	    },
	  },
	  methods: {
	    save: function save() {
	      var self = this;
	      self.saveInProgress = true;
	      self.store.expectedResponseTime = self.expectedResponseTimeComputed;
	      self.store.post();
	    },
	    handleColorInput: function handleColorInput(event) {
	      var self = this;
	      var value;
	      if (event.target) { value = event.target.value; }
	      else { value = event; }
	      var newValue;
	      if (value[0] !== '#') { newValue = "#" + value; }
	      if (!value) { newValue = '#'; }
	      if (newValue !== value) {
	        self.store.themeColor = value;
	        self.$refs.colorInput.$el.querySelector('input').value = value;
	      }
	    },
	    handleCustomButtonSwitch: function handleCustomButtonSwitch(event) {
	      var self = this;
	      var checked;
	      if (event.target) { checked = event.target.checked; }
	      else { checked = event; }
	      self.store.customChatButton = !!checked;
	    },
	    handlePositionChange: function handlePositionChange(event) {
	      var self = this;
	      if (event.target.checked) {
	        self.store.position = event.target.value;
	      }
	    },
	    handleReplyTimeChange: function handleReplyTimeChange(event) {
	      var self = this;
	      self.expectedResponseTimeComputed = event.target.value;
	    },
	    addDomainRow: function addDomainRow() {
	      if (this.store.domains.length > 9) {
	        return;
	      }
	      this.store.domains.push({ domain: '' });
	    },
	    removeDomainRow: function removeDomainRow(index) {
	      this.store.domains.splice(index, 1);
	    },
	    removeIntroLanguage: function removeIntroLanguage(language) {
	      this.store.teamIntroTextLanguages = lodash.filter(this.store.teamIntroTextLanguages, function (x) { return x.lang !== language.lang; });
	    },
	    removeWelcomeLanguage: function removeWelcomeLanguage(language) {
	      this.store.welcomeMessageLanguages = lodash.filter(this.store.welcomeMessageLanguages, function (x) { return x.lang !== language.lang; });
	    },
	    handleOnlineChange: function handleOnlineChange(e) {
	      var self = this;
	      self.store.online = e.target.checked;
	      self.storeOnline.postNow({
	        id: self.$f7route.params.channelId,
	        online: e.target.checked,
	      });
	    },
	  },
	};

	/* script */
	var __vue_script__$H = script$H;

	/* template */
	var __vue_render__$E = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f7-page',{staticClass:"page-form"},[_c('common-navbar',{attrs:{"title":"Widget settings"}}),_vm._v(" "),_c('f7-list',{staticClass:"content-round content-white"},[_c('li',[_c('div',{staticClass:"item-content"},[_c('div',{staticClass:"item-inner"},[_c('div',{staticClass:"item-media"},[_c('common-avatar',{attrs:{"slot":"media","avatar":_vm.$root.loggedInUser.photoFile},slot:"media"})],1),_vm._v(" "),_c('div',{staticClass:"item-title",staticStyle:{"margin-left":"10px"}},[_vm._v("Show me in widget")]),_vm._v(" "),_c('div',{staticClass:"item-after"},[_c('f7-toggle',{attrs:{"slot":"after","checked":_vm.store.online,"value":"online"},nativeOn:{"change":function($event){return _vm.handleOnlineChange.apply(null, arguments)}},slot:"after"})],1)])])])]),_vm._v(" "),_c('f7-block-title',[_vm._v("Reply time")]),_vm._v(" "),_c('f7-list',[_c('f7-list-item',{attrs:{"name":"response-time","radio":"","value":"1","checked":_vm.expectedResponseTimeComputed === '1',"title":"Typically replies in few minutes"},nativeOn:{"change":function($event){return _vm.handleReplyTimeChange.apply(null, arguments)}}}),_vm._v(" "),_c('f7-list-item',{attrs:{"name":"response-time","radio":"","value":"2","checked":_vm.expectedResponseTimeComputed === '2',"title":"Typically replies in few hours"},nativeOn:{"change":function($event){return _vm.handleReplyTimeChange.apply(null, arguments)}}}),_vm._v(" "),_c('f7-list-item',{attrs:{"name":"response-time","radio":"","value":"3","checked":_vm.expectedResponseTimeComputed === '3',"title":"Typically replies in few days"},nativeOn:{"change":function($event){return _vm.handleReplyTimeChange.apply(null, arguments)}}})],1),_vm._v(" "),_c('f7-block-title',[_vm._v("Welcome message")]),_vm._v(" "),_c('f7-list',[_c('f7-list-item',{attrs:{"item-input":""}},[_c('div',{staticClass:"sub-block-title"},[_vm._v("Default language")]),_vm._v(" "),_c('f7-input',{staticClass:"item-input-field",attrs:{"type":"textarea","placeholder":"E.g. Hi there! How can we help you?","value":_vm.store.welcomeMessage},on:{"input":function($event){_vm.store.welcomeMessage = $event.target.value;}}})],1),_vm._v(" "),_vm._l((_vm.store.welcomeMessageLanguages),function(l){return _c('f7-list-item',{attrs:{"item-input":""}},[_c('div',{staticClass:"sub-block-title"},[_vm._v(_vm._s(l.name))]),_vm._v(" "),_c('f7-link',{staticClass:"delete-language-button",attrs:{"icon-only":"","icon-if-ios":"f7:delete_round_fill","icon-if-md":"material:delete"},on:{"click":function($event){return _vm.removeWelcomeLanguage(l)}}}),_vm._v(" "),_c('f7-input',{staticClass:"item-input-field",attrs:{"type":"textarea","placeholder":"E.g. Hi there! How can we help you?","value":l.text},on:{"input":function($event){l.text = $event.target.value;}}})],1)}),_vm._v(" "),_c('f7-list-item',[_c('f7-input',{staticClass:"item-input-field"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.welcomeSelectedLanguage),expression:"welcomeSelectedLanguage"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.welcomeSelectedLanguage=$event.target.multiple ? $$selectedVal : $$selectedVal[0];}}},[_c('option',{attrs:{"value":""}},[_vm._v("Add Language")]),_vm._v(" "),_vm._l((_vm.languages),function(l){return _c('option',{domProps:{"value":l.lang}},[_vm._v(_vm._s(l.name))])})],2)])],1)],2),_vm._v(" "),_c('f7-block-title',[_vm._v("Team introduction text")]),_vm._v(" "),_c('f7-list',[_c('f7-list-item',{attrs:{"item-input":""}},[_c('div',{staticClass:"sub-block-title"},[_vm._v("Default language")]),_vm._v(" "),_c('f7-input',{staticClass:"item-input-field",attrs:{"type":"textarea","placeholder":"E.g. We are here to help!","value":_vm.store.teamIntroText},on:{"input":function($event){_vm.store.teamIntroText = $event.target.value;}}})],1),_vm._v(" "),_vm._l((_vm.store.teamIntroTextLanguages),function(l){return _c('f7-list-item',{attrs:{"item-input":""}},[_c('div',{staticClass:"sub-block-title"},[_vm._v(_vm._s(l.name))]),_vm._v(" "),_c('f7-link',{staticClass:"delete-language-button",attrs:{"icon-only":"","icon-if-ios":"f7:delete_round_fill","icon-if-md":"material:delete"},on:{"click":function($event){return _vm.removeIntroLanguage(l)}}}),_vm._v(" "),_c('f7-input',{staticClass:"item-input-field",attrs:{"type":"textarea","placeholder":"E.g. We are here to help!","value":l.text},on:{"input":function($event){l.text = $event.target.value;}}})],1)}),_vm._v(" "),_c('f7-list-item',[_c('f7-input',{staticClass:"item-input-field"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.introSelectedLanguage),expression:"introSelectedLanguage"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.introSelectedLanguage=$event.target.multiple ? $$selectedVal : $$selectedVal[0];}}},[_c('option',{attrs:{"value":""}},[_vm._v("Add Language")]),_vm._v(" "),_vm._l((_vm.languages),function(l){return _c('option',{domProps:{"value":l.lang}},[_vm._v(_vm._s(l.name))])})],2)])],1)],2),_vm._v(" "),_c('f7-block-title',[_vm._v("Widget Theme Color")]),_vm._v(" "),_c('f7-list',[_c('f7-list-item',{staticClass:"input-color-display-item",attrs:{"item-input":""}},[_c('div',{staticClass:"input-color-display",style:(("background-color:" + (_vm.store.themeColor)))}),_vm._v(" "),_c('f7-input',{ref:"colorInput",staticClass:"item-input-field",attrs:{"type":"text","placeholder":"#rrggbb","maxlength":"7","value":_vm.store.themeColor},on:{"input":_vm.handleColorInput,"change":_vm.handleColorInput}})],1)],1),_vm._v(" "),_c('f7-block-title',[_vm._v("Widget Position")]),_vm._v(" "),_c('f7-list',[_c('f7-list-item',{attrs:{"radio":"","name":"widget-position","checked":_vm.store.position === 'bottom-right',"title":"Bottom Right","value":"bottom-right"},on:{"change":_vm.handlePositionChange}}),_vm._v(" "),_c('f7-list-item',{attrs:{"radio":"","name":"widget-position","checked":_vm.store.position === 'bottom-left',"title":"Bottom Left","value":"bottom-left"},on:{"change":_vm.handlePositionChange}})],1),_vm._v(" "),_c('f7-block-title',[_vm._v("Widget Button")]),_vm._v(" "),_c('f7-list',[_c('f7-list-item',{attrs:{"title":"Use custom chat button"}},[_c('f7-toggle',{attrs:{"slot":"after","checked":_vm.store.customChatButton},nativeOn:{"change":function($event){return _vm.handleCustomButtonSwitch.apply(null, arguments)}},slot:"after"})],1)],1),_vm._v(" "),(_vm.store.customChatButton)?_c('f7-block-title',[_vm._v("Widget Button Element ID")]):_vm._e(),_vm._v(" "),(_vm.store.customChatButton)?_c('f7-list',[_c('f7-list-item',{attrs:{"item-input":""}},[_c('f7-input',{attrs:{"type":"text","value":_vm.store.widgetElementId,"placeholder":"brief-chat-button"},on:{"input":function($event){_vm.store.widgetElementId = $event.target.value;}}})],1)],1):_vm._e(),_vm._v(" "),(_vm.store.customChatButton)?_c('f7-block-title',[_vm._v("Widget Unread Count Element ID")]):_vm._e(),_vm._v(" "),(_vm.store.customChatButton)?_c('f7-list',[_c('f7-list-item',{attrs:{"item-input":""}},[_c('f7-input',{attrs:{"type":"text","value":_vm.store.widgetUnreadCountId,"placeholder":"brief-unread-count"},on:{"input":function($event){_vm.store.widgetUnreadCountId = $event.target.value;}}})],1)],1):_vm._e(),_vm._v(" "),_c('f7-list',{staticClass:"timezone-picker"},[_c('f7-list-item',{attrs:{"item-input":""}},[_c('f7-label',[_vm._v("Welcome message shown in")]),_vm._v(" "),_c('f7-input',{staticClass:"item-input-field"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.store.welcomeMessageTimeoutSeconds),expression:"store.welcomeMessageTimeoutSeconds"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.store, "welcomeMessageTimeoutSeconds", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);}}},_vm._l((_vm.welcomeMessageTimeoutSettings),function(s){return _c('option',{domProps:{"value":s}},[_vm._v(_vm._s(s)+" second"+_vm._s(s === 1 ? '' : 's'))])}),0)])],1)],1),_vm._v(" "),_c('f7-block-title',[_vm._v("Widget Code")]),_vm._v(" "),_c('f7-block',{attrs:{"strong":""}},[_c('pre',{staticClass:"widget-embed-code"},[_vm._v(_vm._s(_vm.embedCode))])]),_vm._v(" "),_c('f7-block-title',[_vm._v("Allowed domains")]),_vm._v(" "),_c('f7-list',{staticClass:"domains-picker"},[_vm._l((_vm.store.domains),function(d,index){return _c('f7-list-item',[_c('f7-input',{attrs:{"type":"text","value":d.domain,"placeholder":"Domain"},on:{"input":function($event){d.domain = $event.target.value;}}}),_vm._v(" "),_c('div',{staticClass:"domain-buttons"},[_c('f7-link',{attrs:{"icon-only":"","icon-if-ios":"f7:delete_round_fill","icon-if-md":"material:delete"},on:{"click":function($event){return _vm.removeDomainRow(index)}}})],1)],1)}),_vm._v(" "),_c('f7-list-item',[_c('f7-link',{attrs:{"icon-only":"","icon-if-ios":"f7:add_round_fill","icon-if-md":"material:add"},on:{"click":function($event){return _vm.addDomainRow()}}})],1)],2),_vm._v(" "),_c('f7-list',[_c('f7-list-button',{on:{"click":_vm.save}},[(!_vm.saveInProgress)?_c('span',[_vm._v("Save")]):_vm._e(),_vm._v(" "),(_vm.saveInProgress)?_c('span',{staticClass:"spinner"}):_vm._e()])],1)],1)};
	var __vue_staticRenderFns__$E = [];

	  /* style */
	  var __vue_inject_styles__$H = undefined;
	  /* scoped */
	  var __vue_scope_id__$H = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$H = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$H = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$H = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$E, staticRenderFns: __vue_staticRenderFns__$E },
	    __vue_inject_styles__$H,
	    __vue_script__$H,
	    __vue_scope_id__$H,
	    __vue_is_functional_template__$H,
	    __vue_module_identifier__$H,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//

	var script$I = {
	  props: {
	    type: String, // roomstream, facebookstream, ...
	    id: String, // channel id
	  },
	  data: function data() {
	    var self = this;
	    var type = self.type;
	    var id = self.id;

	    var channelType = Utils$1.channelTypes(type);

	    var store = new Store(self, {
	      get: [channelType, 'settings', { id: id }],
	      post: ['channelemail', 'settings', { id: id, type: channelType }],
	      getFinished: function getFinished() {
	      },
	      postFinished: function postFinished(result) {
	        self.saveInProgress = false;
	        if (result.success) {
	          Brief$1.events.$emit('refresh-settings');
	          Brief$1.events.$emit('refresh-worker-error-status');
	          Brief$1.viewMain.router.back();
	        }
	      },
	    });
	    store.get();

	    return {
	      store: store,
	      saveInProgress: false,
	    };
	  },
	  methods: {
	    updateStore: function updateStore(props) {
	      var self = this;
	      Object.keys(props).forEach(function (prop) {
	        self.store[prop] = props[prop];
	      });
	    },
	    save: function save() {
	      var self = this;
	      self.store.post();
	    },
	  },
	};

	/* script */
	var __vue_script__$I = script$I;

	/* template */
	var __vue_render__$F = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f7-page',{staticClass:"page-form"},[_c('common-navbar',{attrs:{"title":"Email settings"}}),_vm._v(" "),_c('f7-block-title',[_vm._v("Email address")]),_vm._v(" "),_c('f7-list',[_c('f7-list-item',{attrs:{"item-input":""}},[_c('f7-input',{attrs:{"type":"email","placeholder":"E-mail","value":_vm.store.email,"disabled":""},on:{"input":function($event){_vm.store.email = $event.target.value;}}})],1),_vm._v(" "),_c('f7-list-item',{attrs:{"item-input":""}},[_c('f7-input',{attrs:{"type":"text","placeholder":"Sender name","value":_vm.store.senderName},on:{"input":function($event){_vm.store.senderName = $event.target.value;}}})],1)],1),_vm._v(" "),_c('f7-block-title',[_vm._v("Email server type")]),_vm._v(" "),_c('f7-list',[_c('f7-list-item',{attrs:{"radio":"","name":"emailType","value":"POP3","checked":_vm.store.emailType === 'POP3',"title":"POP3"},on:{"change":function($event){_vm.store.emailType = $event.target.value;}}}),_vm._v(" "),_c('f7-list-item',{attrs:{"radio":"","name":"emailType","value":"IMAP","checked":_vm.store.emailType === 'IMAP',"title":"IMAP"},on:{"change":function($event){_vm.store.emailType = $event.target.value;}}})],1),_vm._v(" "),_c('f7-block-title',[_vm._v("Incoming email account")]),_vm._v(" "),_c('f7-list',[_c('f7-list-item',{attrs:{"item-input":""}},[_c('f7-input',{attrs:{"type":"password","placeholder":"Password","value":_vm.store.password},on:{"input":function($event){_vm.store.password = $event.target.value;}}})],1),_vm._v(" "),_c('f7-list-item',{attrs:{"item-input":""}},[_c('f7-input',{attrs:{"type":"text","placeholder":"Ex. pop3.host.com or imap.host.com","value":_vm.store.host},on:{"input":function($event){_vm.store.host = $event.target.value;}}})],1),_vm._v(" "),_c('f7-list-item',{attrs:{"item-input":""}},[_c('f7-input',{attrs:{"type":"text","placeholder":"Ex. 110 or 993","value":_vm.store.port},on:{"input":function($event){_vm.store.port = $event.target.value;}}})],1)],1),_vm._v(" "),_c('f7-block-title',[_vm._v("Outgoing email account")]),_vm._v(" "),_c('f7-list',[_c('f7-list-item',{attrs:{"item-input":""}},[_c('f7-input',{attrs:{"type":"password","placeholder":"SMTP Password","value":_vm.store.smtpPassword},on:{"input":function($event){_vm.store.smtpPassword = $event.target.value;}}})],1),_vm._v(" "),_c('f7-list-item',{attrs:{"item-input":""}},[_c('f7-input',{attrs:{"type":"text","placeholder":"Ex. smtp.host.com","value":_vm.store.smtpHost},on:{"input":function($event){_vm.store.smtpHost = $event.target.value;}}})],1),_vm._v(" "),_c('f7-list-item',{attrs:{"item-input":""}},[_c('f7-input',{attrs:{"type":"text","placeholder":"Ex. 587","value":_vm.store.smtpPort},on:{"input":function($event){_vm.store.smtpPort = $event.target.value;}}})],1)],1),_vm._v(" "),_c('f7-list',[_c('f7-list-button',{on:{"click":_vm.save}},[(!_vm.saveInProgress)?_c('span',[_vm._v("Save")]):_vm._e(),_vm._v(" "),(_vm.saveInProgress)?_c('span',{staticClass:"spinner"}):_vm._e()])],1)],1)};
	var __vue_staticRenderFns__$F = [];

	  /* style */
	  var __vue_inject_styles__$I = undefined;
	  /* scoped */
	  var __vue_scope_id__$I = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$I = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$I = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$I = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$F, staticRenderFns: __vue_staticRenderFns__$F },
	    __vue_inject_styles__$I,
	    __vue_script__$I,
	    __vue_scope_id__$I,
	    __vue_is_functional_template__$I,
	    __vue_module_identifier__$I,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//

	var script$J = {
	  props: {
	    type: String, // roomstream, facebookstream, ...
	    id: String, // channel id
	  },
	  data: function data() {
	    var self = this;
	    var type = self.type;
	    var id = self.id;

	    var channelType = Utils$1.channelTypes(type);

	    var store = new Store(self, {
	      get: [channelType, 'settings', { id: id }],
	      post: ['channelinstagram', 'settings', { id: id, type: channelType }],
	      getFinished: function getFinished() {
	      },
	      postFinished: function postFinished(result) {
	        self.saveInProgress = false;
	        if (result.success) {
	          Brief$1.events.$emit('refresh-settings');
	          Brief$1.viewMain.router.back();
	        }
	        if (result.additionalData && result.additionalData.needToVerify) {
	          self.needToVerify = true;
	        }
	      },
	    });
	    store.get();

	    return {
	      store: store,
	      saveInProgress: false,
	      needToVerify: false,
	    };
	  },
	  methods: {
	    updateStore: function updateStore(props) {
	      var self = this;
	      Object.keys(props).forEach(function (prop) {
	        self.store[prop] = props[prop];
	      });
	    },
	    save: function save() {
	      var self = this;
	      self.saveInProgress = true;
	      self.store.post();
	    },
	  },
	};

	/* script */
	var __vue_script__$J = script$J;

	/* template */
	var __vue_render__$G = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f7-page',{staticClass:"page-form"},[_c('common-navbar',{attrs:{"title":"Instagram Account"}}),_vm._v(" "),_c('f7-list',[_c('f7-list-item',{attrs:{"item-input":""}},[_c('f7-input',{attrs:{"type":"text","placeholder":"Username","value":_vm.store.username},on:{"input":function($event){_vm.store.username = $event.target.value;}}})],1),_vm._v(" "),_c('f7-list-item',{attrs:{"item-input":""}},[_c('f7-input',{attrs:{"type":"password","placeholder":"Password","value":_vm.store.password},on:{"input":function($event){_vm.store.password = $event.target.value;}}})],1),_vm._v(" "),(_vm.needToVerify)?_c('f7-list-item',{attrs:{"item-input":""}},[_c('f7-input',{attrs:{"type":"text","placeholder":"Verification code","value":_vm.store.code},on:{"input":function($event){_vm.store.code = $event.target.value;}}})],1):_vm._e()],1),_vm._v(" "),_c('f7-list',[_c('f7-list-button',{on:{"click":_vm.save}},[(!_vm.saveInProgress)?_c('span',[_vm._v("Save")]):_vm._e(),_vm._v(" "),(_vm.saveInProgress)?_c('span',{staticClass:"spinner"}):_vm._e()])],1)],1)};
	var __vue_staticRenderFns__$G = [];

	  /* style */
	  var __vue_inject_styles__$J = undefined;
	  /* scoped */
	  var __vue_scope_id__$J = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$J = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$J = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$J = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$G, staticRenderFns: __vue_staticRenderFns__$G },
	    __vue_inject_styles__$J,
	    __vue_script__$J,
	    __vue_scope_id__$J,
	    __vue_is_functional_template__$J,
	    __vue_module_identifier__$J,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//

	var script$K = {
	  props: {
	    type: String,
	    id: String,
	    longWaitingThreshold: [String, Number],
	    isDirectMessagingChannel: Boolean,
	    editSignature: Boolean,
	    editWaitLimit: Boolean,
	    editAutoReply: Boolean,
	    store: Object,
	    storeLeave: Object,
	    storeDelete: Object,
	    handleStores: {
	      type: Boolean,
	      default: true,
	    },
	  },
	  data: function data() {
	    gtag('event', 'channel_settings', {
	      event_category: 'page',
	      event_label: 'Open channel settings',
	    });
	    return {
	      deleteInProgress: false,
	      saveInProgress: false,
	      leaveInProgress: false,
	    };
	  },
	  created: function created() {
	    var self = this;
	    if (!self.handleStores) { return; }
	    if (self.store) {
	      self.store.on('postFinished', function (result) {
	        if (result.success) {
	          Brief$1.viewMain.router.back();
	          Utils$1.setTimeoutTrigger('streams-selected', self.id);
	        }
	      });
	    }
	    if (self.storeLeave) {
	      self.storeLeave.on('postFinished', function (result) {
	        Brief$1.events.$emit('message-clear', self.id);
	        if (result.success) {
	          var url = '/';
	          Brief$1.viewMain.router.reloadFromStart(url);
	          Utils$1.setTimeoutTrigger('streams-selected', 'list');
	        }
	      });
	    }
	    if (self.storeDelete) {
	      self.storeDelete.on('postFinished', function (result) {
	        Brief$1.events.$emit('message-clear', self.id);
	        if (result.success) {
	          var url = '/';
	          Brief$1.viewMain.router.reloadFromStart(url);
	          Utils$1.setTimeoutTrigger('streams-selected', 'list');

	          Brief$1.notify('Success!', 'Channel has been successfully deleted');
	        }
	      });
	    }
	  },
	  mounted: function mounted() {
	    var self = this;
	    if (!self.handleStores) { return; }
	    Brief$1.events.$on('page-back', function () { return self.store.get(); });
	    Brief$1.events.$on('refresh-settings', function () { return self.store.get(); });
	    $$1(self.$el).on('change input', 'input, textarea', function () {
	      Brief$1.closeNotification();
	    });
	  },
	  beforeDestroy: function beforeDestroy() {
	    var self = this;
	    if (!self.handleStores) { return; }
	    if (self.store) { self.store.dispose(); }
	    if (self.storeLeave) { self.storeLeave.dispose(); }
	    if (self.storeDelete) { self.storeDelete.dispose(); }
	    Brief$1.events.$off('page-back');
	    Brief$1.events.$off('refresh-settings');
	  },
	  methods: {
	    updateStore: function updateStore(props) {
	      var self = this;
	      if (!self.handleStores) { return; }
	      Object.keys(props).forEach(function (prop) {
	        self.store[prop] = props[prop];
	      });
	    },
	    saveChannel: function saveChannel() {
	      var self = this;
	      self.$emit('channelBeforeSave');
	      self.saveInProgress = true;
	      if (self.handleStores && self.store) {
	        self.store.post();
	      }
	      self.$emit('channelSave');
	    },
	    leaveChannel: function leaveChannel() {
	      var self = this;
	      self.$emit('channelBeforeLeave');
	      self.leaveInProgress = true;
	      if (self.handleStores && self.storeLeave) {
	        self.storeLeave.post();
	      }
	      self.$emit('channelLeave');
	    },
	    deleteChannel: function deleteChannel() {
	      var self = this;
	      Brief$1.f7.dialog.confirm('Are you sure?', ("Deleting channel \"" + (self.store.name) + "\""), function () {
	        self.$emit('channelBeforeDelete');
	        self.deleteInProgress = true;
	        if (self.handleStores && self.storeDelete) {
	          self.storeDelete.post();
	        }
	        self.$emit('channelDelete');
	      });
	    },
	  },
	};

	/* script */
	var __vue_script__$K = script$K;

	/* template */
	var __vue_render__$H = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f7-page',{staticClass:"page-form"},[_c('common-navbar',{attrs:{"title":"Settings"}}),_vm._v(" "),(!_vm.store.isLoading)?[(!_vm.isDirectMessagingChannel && _vm.$root.loggedInUser.plan.name !== 'Base')?_c('f7-list',[_c('f7-list-item',{attrs:{"link":("/" + _vm.type + "/" + (_vm.$f7route.params.channelId) + "/members/")}},[_c('div',{staticClass:"members-info"},[_c('span',{staticClass:"members-info-count"},[_vm._v(_vm._s(_vm.store.joinedUserCount))]),_vm._v(" "),_c('span',{staticClass:"members-info-text"},[_vm._v(_vm._s(_vm.store.joinedUserCount > 1 ? 'members' : 'member'))])])])],1):_vm._e(),_vm._v(" "),_c('f7-list',{attrs:{"media-list":""}},[(!_vm.isDirectMessagingChannel)?_c('f7-list-item',{attrs:{"link":("/" + _vm.type + "/" + (_vm.$f7route.params.channelId) + "/info/"),"title":_vm.store.name,"subtitle":_vm.store.visibility === 'private' ? 'Private - Invite only' : _vm.store.visibility === 'forced' ? 'Public - auto join' : 'Public'}}):_vm._e(),_vm._v(" "),(_vm.isDirectMessagingChannel)?_c('f7-list-item',{attrs:{"title":_vm.store.name,"subtitle":"Direct Messages"}}):_vm._e()],1),_vm._v(" "),(_vm.editWaitLimit)?_c('f7-list',{attrs:{"media-list":""}},[_c('f7-list-item',{attrs:{"link":("/" + _vm.type + "/" + (_vm.$f7route.params.channelId) + "/waitlimit/"),"title":"Waited a long time limit","subtitle":((_vm.store.longWaitingThreshold || 6) + " hours")}})],1):_vm._e(),_vm._v(" "),(_vm.editAutoReply)?_c('f7-list',{attrs:{"media-list":""}},[_c('f7-list-item',{attrs:{"link":("/" + _vm.type + "/" + (_vm.$f7route.params.channelId) + "/autoreply/"),"title":("Auto reply: " + (_vm.store.isAutoReply ? 'on' : 'off')),"subtitle":_vm.store.autoReplyText}})],1):_vm._e(),_vm._v(" "),_vm._t("default"),_vm._v(" "),(_vm.editSignature)?_c('f7-list',[(_vm.$f7route.params.channelId)?_c('f7-list-item',{attrs:{"link":("/" + _vm.type + "/" + (_vm.$f7route.params.channelId) + "/signature/"),"title":"Signature"}}):_vm._e()],1):_vm._e(),_vm._v(" "),_c('f7-list',[_c('f7-list-item',{attrs:{"link":("/" + _vm.type + "/" + (_vm.$f7route.params.channelId) + "/notifications/"),"title":"Notifications"}})],1),_vm._v(" "),_vm._t("before-button"),_vm._v(" "),_c('f7-list',[_c('f7-list-button',{on:{"click":_vm.leaveChannel}},[_vm._v(_vm._s(_vm.leaveInProgress ? 'Leaving channel...' : 'Leave channel')+" "),(_vm.leaveInProgress)?_c('span',{staticClass:"spinner"}):_vm._e()]),_vm._v(" "),_c('f7-block-footer',{staticClass:"text-align-center"},[_vm._v("You can leave and rejoin later")])],1),_vm._v(" "),(_vm.store.isOwner && !_vm.isDirectMessagingChannel || _vm.$root.loggedInUser.isTeamOwner)?_c('f7-list',[_c('f7-list-button',{attrs:{"color":"red"},on:{"click":_vm.deleteChannel}},[_vm._v(_vm._s(_vm.deleteInProgress ? 'Deleting...' : 'Delete channel')+" "),(_vm.deleteInProgress)?_c('span',{staticClass:"spinner"}):_vm._e()])],1):_vm._e()]:_c('div',{staticClass:"infinite-scroll-preloader"},[_c('f7-preloader')],1)],2)};
	var __vue_staticRenderFns__$H = [];

	  /* style */
	  var __vue_inject_styles__$K = undefined;
	  /* scoped */
	  var __vue_scope_id__$K = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$K = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$K = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$K = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$H, staticRenderFns: __vue_staticRenderFns__$H },
	    __vue_inject_styles__$K,
	    __vue_script__$K,
	    __vue_scope_id__$K,
	    __vue_is_functional_template__$K,
	    __vue_module_identifier__$K,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//

	var script$L = {
	  props: {
	    type: String,
	    store: Object,
	    handleStores: {
	      type: Boolean,
	      default: true,
	    },
	  },
	  data: function data() {
	    return {
	      createInProgress: false,
	      commonErrors: {},
	    };
	  },
	  created: function created() {
	    var self = this;
	    if (!self.handleStores) { return; }
	    if (!self.store) { return; }
	    self.store.on('postNowFinished', function (result) {
	      self.createInProgress = false;
	      if (result.success) {
	        var channelId = result.data.id;
	        Utils$1.setTimeoutTrigger('streams-selected', channelId);

	        var url = "/" + (self.type) + "/" + channelId + "/";
	        Brief$1.viewMain.router.reloadFromStart(url);
	      }
	    });
	  },
	  mounted: function mounted() {
	    var self = this;
	    if (!self.handleStores) { return; }
	    $$1(self.$el).on('change input', 'input, textarea', function () {
	      Brief$1.closeNotification();
	    });
	  },
	  beforeDestroy: function beforeDestroy() {
	    var self = this;
	    if (!self.handleStores) { return; }
	    if (self.store) { self.store.dispose(); }
	    
	  },
	  methods: {
	    updateStore: function updateStore(props) {
	      var self = this;
	      if (!self.handleStores) { return; }
	      Object.keys(props).forEach(function (prop) {
	        self.$set(self.store, prop, props[prop]);
	      });
	    },
	    visibilityChange: function visibilityChange(visibility) {
	      var self = this;
	      self.updateStore({ visibility: visibility });
	      self.$emit('change', { visibility: visibility });
	    },
	    commonInfoChange: function commonInfoChange(infoProps) {
	      var self = this;
	      self.updateStore(infoProps);
	      self.$emit('change', infoProps);
	    },
	    createChannel: function createChannel() {
	      var self = this;
	      self.commonErrors = {};

	      if (!self.store.name) {
	        switch (self.type) {
	          case 'email':
	            self.store.name = "Email: " + (self.store.email);
	            break;
	          case 'facebook':
	            self.store.name = "Facebook: " + (self.store.pageName);
	            break;
	          case 'instagram':
	            self.store.name = "Instagram: " + (self.store.pageName);
	            break;
	          case 'website':
	            self.store.name = "Website: " + (self.store.teamName);
	            break;
	        }
	      }
	      if (self.type === 'email' && !self.store.senderName) {
	        self.store.senderName = self.store.email;
	      }
	      self.$emit('channelBeforeCreate');
	      self.createInProgress = true;
	      if (self.handleStores && self.store) {
	        self.store.postNow({
	          visibility: self.store.visibility || 'public',
	        });
	      }
	      self.$emit('channelCreate');
	    },
	  },
	};

	/* script */
	var __vue_script__$L = script$L;

	/* template */
	var __vue_render__$I = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f7-page',{staticClass:"page-form"},[_c('common-navbar',{attrs:{"title":("Create " + (_vm.type[0].toUpperCase() + _vm.type.slice(1)) + " channel")}}),_vm._v(" "),_vm._t("start"),_vm._v(" "),_c('common-channel-visibility',{attrs:{"visibility":_vm.store.visibility || 'public'},on:{"visibilityChange":_vm.visibilityChange}}),_vm._v(" "),_c('common-channel-info',{attrs:{"name":_vm.store.name,"description":_vm.store.description,"errors":_vm.commonErrors},on:{"commonInfoChange":_vm.commonInfoChange,"commonInfoSave":_vm.createChannel}}),_vm._v(" "),_vm._t("default"),_vm._v(" "),_c('f7-list',[_c('f7-list-button',{on:{"click":_vm.createChannel}},[_vm._v(_vm._s(_vm.createInProgress ? 'Creating...' : 'Create')+" "),(_vm.createInProgress)?_c('span',{staticClass:"spinner"}):_vm._e()])],1),_vm._v(" "),_vm._t("end")],2)};
	var __vue_staticRenderFns__$I = [];

	  /* style */
	  var __vue_inject_styles__$L = undefined;
	  /* scoped */
	  var __vue_scope_id__$L = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$L = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$L = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$L = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$I, staticRenderFns: __vue_staticRenderFns__$I },
	    __vue_inject_styles__$L,
	    __vue_script__$L,
	    __vue_scope_id__$L,
	    __vue_is_functional_template__$L,
	    __vue_module_identifier__$L,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//

	var script$M = {
	  props: {
	    type: String,
	    introduction: {
	      type: Boolean,
	      default: true,
	    },
	    store: Object,
	    storeMarkAsDone: Object,
	    storeMarkAsNotDone: Object,
	    batchStoreMarkAsDone: Object,
	    batchStoreMarkAsRead: Object,
	    latestItemsText: String,
	    photoAvatar: Boolean,
	    sortConversationsByDate: Boolean,
	    itemHeight: Number,
	    search: {
	      type: Boolean,
	      default: true,
	    },
	    handleStores: {
	      type: Boolean,
	      default: true,
	    },
	  },
	  created: function created() {
	    var self = this;
	    if (!self.handleStores) { return; }
	    self.store.on('getStarted', function () {
	      self.getFinished = false;
	      self.getStarted = true;
	    });
	    self.store.on('getFinished', function () {
	      self.searchbarPreloader = false;
	      self.firstTimeLoad = false;
	      self.messagesLoaded = true;
	      self.getStarted = false;
	      self.getFinished = true;
	    });
	    self.store.on('getError reloadError', function (response) {
	      Brief$1.notify('Error!', response.Message || response);
	    });
	  },
	  data: function data() {
	    var loggedInUser = this.$root.loggedInUser;      

	    return {
	      firstTimeLoad: true,
	      messagesLoaded: false,
	      query: null,
	      hashTagSearch: false,
	      getStarted: false,
	      getFinished: false,
	      searchbarPreloader: false,
	      wasSearch: false,
	      loggedInUser: loggedInUser
	    };
	  },
	  computed: {
	    assignedConversations: function assignedConversations() {
	      var self = this;
	      var userId = window.localStorage.getItem('user_id');
	      if (!self.store.conversations) { return []; }
	      var c = self.store.conversations.filter(function (conversation) { return conversation.isAssigned; });
	      c = c.filter(function (conversation){ 
	          return !conversation.assignedUsers || conversation.assignedUsers.some(
	              function (a){ 
	                  return a === userId; 
	              }
	      )});
	      if (self.sortConversationsByDate) {
	        c = c.sort(function (a, b) {
	          return new Date(a.sendDate).getTime() - new Date(b.sendDate).getTime();
	        });
	      }
	      return c;
	    },
	    waitedConversations: function waitedConversations() {
	      var self = this;
	      if (!self.store.conversations) { return []; }
	      var c = self.store.conversations.filter(function (conversation) { return !conversation.isHandled; });
	      if (self.sortConversationsByDate) {
	        c = c.sort(function (a, b) {
	          return new Date(a.sendDate).getTime() - new Date(b.sendDate).getTime();
	        });
	      }
	      return c;
	    },
	    latestConversations: function latestConversations() {
	      var self = this;
	      if (!self.store.conversations) { return []; }
	      var c = self.store.conversations.filter(function (conversation) { return conversation.isHandled; });
	      if (self.sortConversationsByDate) {
	        c = c.sort(function (a, b) {
	          return new Date(b.sendDate).getTime() - new Date(a.sendDate).getTime();
	        });
	      }
	      return c;
	    },
	    showIntroduction: function showIntroduction() {
	      var self = this;
	      if (!self.introduction) { return false; }
	      if (self.store.isLoading) { return false; }
	      if (!self.messagesLoaded) { return false; }
	      if (self.query && self.query.trim()) { return false; }
	      if (Utils$1.isUndefined(self.store.conversations)) { return false; }
	      if (self.store.conversations.length > 0 && (self.store.conversations.some(function (c) { return !c.isHandled; }) || self.store.conversations.some(function (c) { return c.isAssigned; }))) { return false; }
	      if (self.store.conversations.length === 0 && self.wasSearch) { return false; }
	      return true;
	    },
	    noResultFound: function noResultFound() {
	      var self = this;
	      return self.query &&
	        self.query.length &&
	        !self.showIntroduction &&
	        self.store.conversations &&
	        self.store.conversations.length <= 0;
	    },
	    onboardingFinished: function onboardingFinished() {
	      return this.loggedInUser && 
	        this.loggedInUser.onboarding && 
	        this.loggedInUser.onboarding.setupBusiness &&
	        this.loggedInUser.onboarding.setupSms;
	    },
	  },
	  mounted: function mounted() {
	    var self = this;

	    Brief$1.events.$on('messages-clear', self.handleMessagesClear);
	    Brief$1.events.$on('messages-refresh', self.handleMessagesRefresh);
	    Brief$1.events.$on('email-message-created', self.reload);
	    Brief$1.events.$on('sms-message-created', self.handleSmsCreated);
	    var contactId = self.$f7route.query.contactId;
	    if (contactId) {
	      self.query = "contact:" + contactId;
	      self.store.get({ query: self.query });
	    } else {
	      self.store.get();
	    }
	  },
	  methods: {
	    markAsDone: function markAsDone(conversation) {
	      var self = this;
	      conversation.markedAsDone = true;
	      conversation.markedAsNotDone = false;
	      self.storeMarkAsDone.postNow({
	        id: conversation.id,
	        markedAsDone: true,
	      });
	      self.store.saveClient();
	    },
	    markAsNotDone: function markAsNotDone(conversation) {
	      var self = this;
	      conversation.markedAsDone = false;
	      conversation.markedAsNotDone = true;
	      self.storeMarkAsNotDone.postNow({
	        id: conversation.id,
	        markedAsNotDone: true,
	      });
	      self.store.saveClient();
	    },
	    handleSelected: function handleSelected(item) {
	      var self = this;
	      item.isReadByMe = true;
	      self.store.saveClient();
	    },
	    debounceSearch: debounce_1(function debounceSearch() {
	      var self = this;
	      self.wasSearch = true;
	      if (!self.query) {
	        delete self.store.contactId;
	      }
	      self.store.get({ query: self.query });
	    }, 500),
	    onQueryChange: function onQueryChange(query) {
	      var self = this;
	      self.query = query;
	      self.searchbarPreloader = true;
	      self.debounceSearch();
	    },
	    reload: function reload() {
	      var self = this;
	      self.store.reload();
	    },
	    handleMessagesClear: function handleMessagesClear(id) {
	      var self = this;
	      if (id !== self.$f7route.params.channelId) { return; }
	      self.store.conversations = [];
	      self.store.clear();
	    },
	    handleMessagesRefresh: function handleMessagesRefresh(id) {
	      var self = this;
	      if (id !== self.$f7route.params.channelId) { return; }
	      self.store.reload();
	    },
	    handleSmsCreated: function handleSmsCreated(data, isNewMessage) {
	      if (isNewMessage) {
	        Brief$1.viewMain.router.navigate(("/message/list/sms/" + (data.channelId) + "/" + (data.conversationId)), { reloadAll: true });
	        Brief$1.f7.tab.show('#tab-handled');
	      }
	    },      
	    onInfinite: function onInfinite() {
	      var self = this;
	      self.store.getMore();
	    },
	    onHashTagSearchChange: function onHashTagSearchChange(value) {
	      var self = this;
	      self.hashTagSearch = value;
	    },
	    markAllAsDone: function markAllAsDone(type) {
	      var self = this;
	      self.batchStoreMarkAsDone.post({
	        id: self.$f7route.params.channelId,
	        type: type,
	      });

	      var items = type === 'waited' ? self.waitedConversations : self.latestConversations;
	      items.forEach(function (item) {
	        item.markedAsDone = true;
	        item.markedAsNotDone = false;
	        if (type === 'waited') {
	          item.waitedLongTimeForAnswer = false;
	        }
	      });
	    },
	    markAllAsRead: function markAllAsRead(type) {
	      var self = this;
	      // Send request here with mark all as read
	      self.batchStoreMarkAsRead.post({
	        id: self.$f7route.params.channelId,
	        type: type,
	      });

	      var items = type === 'waited' ? self.waitedConversations : self.latestConversations;
	      items.forEach(function (item) {
	        item.isReadByMe = true;
	      });
	    },
	    batchActions: function batchActions(type, targetEl) {
	      var self = this;

	      var buttons = [
	        {
	          text: 'Mark all as Read',
	          onClick: function onClick() {
	            self.markAllAsRead(type);
	          },
	        },
	        {
	          text: 'Mark all as Done',
	          onClick: function onClick() {
	            self.markAllAsDone(type);
	          },
	        } ];

	      var modal = ActionsModal(buttons, targetEl);
	      modal.open();
	    },
	    logout: function logout() {
	      this.isLoggingOut = true;
	      var access_token = window.localStorage.getItem('access_token'); // eslint-disable-line
	      var device_id = window.localStorage.getItem('device_id'); // eslint-disable-line
	      if (!Brief$1.isCordova) {
	        Brief$1.f7.request.postJSON(
	          '/api/firebase/unsubscribe', {
	            device_id: device_id,
	            access_token: access_token,
	        }, function (res) {
	            console.log(res);
	        });
	      }
	      Brief$1.f7.request({
	        url: ((Brief$1.api) + "/account/logout"),
	        method: 'POST',
	        dataType: 'json',
	        contentType: 'application/json',
	        data: JSON.stringify({
	          access_token: access_token,
	          device_id: device_id,
	          isCordova: !!Brief$1.isCordova,
	        }),
	      });
	      Brief$1.logout();
	    },      
	  },
	  beforeDestroy: function beforeDestroy() {
	    var self = this;
	    Brief$1.events.$off('messages-clear', self.handleMessagesClear);
	    Brief$1.events.$off('messages-refresh', self.handleMessagesRefresh);
	    Brief$1.events.$off('email-message-created', self.reload);
	    self.store.dispose();
	    self.storeMarkAsDone.dispose();
	    self.storeMarkAsNotDone.dispose();
	    self.batchStoreMarkAsDone.dispose();
	    self.batchStoreMarkAsRead.dispose();
	  },
	};

	/* script */
	var __vue_script__$M = script$M;

	/* template */
	var __vue_render__$J = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f7-page',{attrs:{"infinite":"","infinite-preloader":false,"infinite-distance":400},on:{"infinite":_vm.onInfinite}},[_c('f7-navbar',[_c('f7-nav-left',[_c('f7-link',{attrs:{"popover-open":".popover-user"}},[_c('common-avatar',{attrs:{"avatar":_vm.loggedInUser.photoFile}})],1)],1),_vm._v(" "),_c('f7-nav-title',[_vm._v("\n      Inbox\n    ")]),_vm._v(" "),_c('f7-nav-right',[(_vm.onboardingFinished)?_c('f7-link',{attrs:{"popover-open":".popover-new"}},[_c('f7-icon',{attrs:{"material":"edit","size":"30","color":"app"}})],1):_c('common-nav-placeholder')],1)],1),_vm._v(" "),_c('f7-popover',{staticClass:"popover-user"},[_c('f7-list',[_c('f7-list-item',{attrs:{"title":"Edit Profile","link":"/user/settings/","view":".popup-main-view","popup-open":".popup-main","reload-current":"","popover-close":""}}),_vm._v(" "),_c('f7-list-item',{attrs:{"title":"Change Password","link":"/password/settings/","view":".popup-main-view","popup-open":".popup-main","reload-current":"","popover-close":""}}),_vm._v(" "),_c('f7-list-item',{attrs:{"title":"Notifications","link":"/notification/settings/","view":".popup-main-view","popup-open":".popup-main","reload-current":"","popover-close":""}}),_vm._v(" "),_c('f7-list-item',{attrs:{"title":"Subscription","link":"/subscription/settings/","view":".popup-main-view","popup-open":".popup-main","reload-current":"","popover-close":""}}),_vm._v(" "),_c('f7-list-item',{attrs:{"title":"Log Out","link":"#","popover-close":"","color":"red"},on:{"click":_vm.logout}})],1)],1),_vm._v(" "),_c('f7-popover',{staticClass:"popover-new"},[_c('f7-list',[_c('f7-list-item',{attrs:{"title":"New Review Invite","link":("/message/list/sms/" + (_vm.loggedInUser.smsChannelId) + "/new-review-invite"),"view":".view-main","reload-all":"","popover-close":""}}),_vm._v(" "),_c('f7-list-item',{attrs:{"title":"New Text Message","link":("/message/list/sms/" + (_vm.loggedInUser.smsChannelId) + "/new"),"view":".view-main","reload-all":"","popover-close":""}})],1)],1),_vm._v(" "),_vm._t("start"),_vm._v(" "),_vm._t("before-search"),_vm._v(" "),_vm._t("after-search"),_vm._v(" "),_c('f7-toolbar',{attrs:{"tabbar":""}},[_c('f7-link',{attrs:{"tab-link":"#tab-waiting","tab-link-active":""}},[_vm._v("Waiting")]),_vm._v(" "),_c('f7-link',{attrs:{"tab-link":"#tab-handled"}},[_vm._v("Handled")])],1),_vm._v(" "),_c('f7-tabs',[_c('f7-tab',{attrs:{"id":"tab-waiting","tab-active":""}},[(_vm.showIntroduction)?_c('div',[_c('f7-block',[_c('div',{staticStyle:{"text-align":"center"}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","version":"1.0","viewBox":"0 0 800.000000 590","preserveAspectRatio":"xMidYMid meet"}},[_c('g',{attrs:{"transform":"translate(-100.000000,750.000000) scale(0.125000,-0.125000)","fill":"rgba(0, 0, 0, 0.4)","stroke":"none"}},[_c('path',{attrs:{"d":"M4867 4882 c-35 -38 -8 -92 45 -92 31 0 51 21 51 57 0 48 -64 71 -96 35z m72 -6 c7 -8 11 -27 9 -43 -3 -25 -7 -28 -37 -28 -43 0 -60 23 -43 59 13 29 52 35 71 12z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M4147 4863 c-14 -14 -18 -14 -34 -2 -16 13 -17 12 -4 -3 11 -15 11 -21 1 -33 -7 -9 -11 -18 -8 -20 3 -3 11 1 18 10 12 14 15 14 34 -2 20 -17 21 -17 4 2 -16 17 -16 20 -1 37 21 23 12 33 -10 11z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M4885 4690 c-4 -12 -5 -24 -2 -27 3 -2 8 5 12 17 4 12 5 24 2 27 -3 2 -8 -5 -12 -17z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M4857 4543 c-9 -51 -2 -53 11 -3 5 22 6 40 2 40 -4 0 -10 -17 -13 -37z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M3945 4555 c23 -8 85 -10 85 -3 0 4 -21 8 -47 7 -27 0 -43 -2 -38 -4z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M3793 4524 c-17 -7 -35 -18 -38 -24 -4 -7 10 -3 31 8 22 11 46 22 54 25 13 5 13 5 0 5 -8 0 -29 -6 -47 -14z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M4110 4536 c0 -7 69 -36 84 -36 13 1 -30 25 -61 34 -13 4 -23 5 -23 2z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M3185 4467 c-13 -10 -16 -21 -11 -41 5 -22 12 -27 33 -24 38 4 52 32 29 57 -22 25 -26 25 -51 8z m55 -22 c0 -32 -45 -49 -56 -20 -10 24 14 47 37 34 10 -5 19 -11 19 -14z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M4290 4425 c19 -19 36 -35 39 -35 3 0 -10 16 -29 35 -19 19 -36 35 -39 35 -3 0 10 -16 29 -35z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M3653 4418 c-22 -26 -37 -48 -30 -48 3 0 17 16 31 35 30 39 30 46 -1 13z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M4808 4388 c-10 -23 -16 -44 -13 -46 6 -6 37 67 33 78 -2 5 -11 -9 -20 -32z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M3781 4295 c-112 -52 -208 -95 -213 -95 -5 0 -7 8 -4 18 3 9 8 31 11 47 5 23 4 26 -4 14 -6 -10 -12 -33 -13 -53 l-3 -36 -545 -251 c-300 -138 -556 -261 -570 -275 l-25 -24 -3 -998 c-2 -697 0 -1008 8 -1034 21 -73 -102 -68 1585 -68 1656 0 1559 -4 1584 57 8 21 11 290 9 1035 l-3 1008 -25 24 c-28 28 -1536 726 -1566 726 -10 -1 -111 -43 -223 -95z m449 -40 c124 -57 207 -101 212 -112 3 -10 8 -34 9 -53 2 -33 3 -32 8 11 l6 45 64 -28 63 -29 -23 -27 -24 -27 26 23 c14 12 28 22 32 22 15 0 923 -423 940 -438 14 -13 17 -28 15 -81 l-3 -66 -760 -352 c-634 -294 -766 -352 -795 -349 -19 2 -375 161 -790 353 l-755 348 -3 66 c-2 52 1 68 15 81 26 23 1514 708 1539 708 11 0 112 -43 224 -95z m-1016 -1152 c590 -273 760 -347 791 -347 31 0 200 74 792 347 414 191 754 347 757 347 4 0 6 -410 6 -910 l0 -911 -25 -24 -24 -25 -1506 0 -1506 0 -24 25 -25 24 0 911 c0 500 3 910 7 910 3 0 344 -156 757 -347z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M3930 4195 c-26 -32 13 -81 48 -59 34 22 22 74 -18 74 -10 0 -23 -7 -30 -15z m58 -23 c4 -28 -24 -41 -44 -20 -20 20 -7 50 20 46 13 -2 22 -12 24 -26z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M3552 4090 c0 -19 4 -46 8 -60 6 -20 8 -21 8 -5 1 11 -3 38 -7 60 l-9 40 0 -35z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M4425 3932 l-30 -36 27 18 27 17 4 -33 c4 -31 4 -30 5 8 1 22 7 45 14 52 9 9 9 12 -2 11 -8 0 -28 -17 -45 -37z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M3626 3892 c20 -35 61 -78 68 -71 2 2 -16 27 -41 54 -37 41 -42 44 -27 17z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M4258 3822 c-64 -36 -62 -51 2 -16 28 15 50 31 50 36 0 10 3 11 -52 -20z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M4449 3755 c-5 -50 -4 -63 7 -53 3 3 4 28 2 54 l-3 49 -6 -50z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M3780 3756 c0 -11 80 -46 102 -45 16 0 11 4 -17 13 -22 7 -50 18 -62 25 -13 6 -23 9 -23 7z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M4050 3730 c-62 -20 -52 -26 16 -9 24 6 44 15 44 20 0 5 -1 9 -2 8 -2 -1 -28 -9 -58 -19z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M5022 3731 c9 -16 9 -23 -3 -38 -13 -17 -13 -17 4 -4 15 12 22 12 38 3 18 -11 18 -11 7 7 -9 16 -9 23 3 38 13 17 13 17 -4 4 -15 -12 -22 -12 -38 -3 -18 11 -18 11 -7 -7z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M3147 3643 c-14 -14 -18 -14 -34 -2 -16 13 -17 12 -4 -4 12 -15 11 -20 -4 -37 -19 -21 -7 -28 13 -8 10 10 17 10 35 -1 20 -13 21 -13 8 3 -12 14 -13 21 -2 38 16 26 10 32 -12 11z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M4436 3587 c-4 -27 -5 -51 -2 -54 7 -7 19 61 14 84 -2 10 -8 -4 -12 -30z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M4020 3575 c-26 -32 13 -81 48 -59 34 22 22 74 -18 74 -10 0 -23 -7 -30 -15z m57 -11 c8 -21 -19 -46 -40 -38 -17 6 -23 35 -10 47 12 13 44 7 50 -9z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M4373 3400 c-28 -65 -21 -64 12 0 14 28 22 50 18 50 -5 0 -18 -23 -30 -50z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M4299 3258 c-7 -12 -19 -33 -27 -45 -8 -13 -10 -23 -6 -23 10 0 56 81 50 87 -2 3 -10 -6 -17 -19z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M4201 3097 c-8 -12 -21 -32 -29 -44 -8 -13 -12 -23 -8 -23 8 0 60 80 55 85 -3 2 -11 -6 -18 -18z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M4092 2939 c-19 -30 -11 -32 11 -3 10 13 14 24 10 24 -5 0 -14 -9 -21 -21z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M3410 2340 c-20 -20 -26 -66 -12 -85 4 -6 34 -9 70 -7 l62 4 0 38 c0 29 -6 43 -22 54 -31 22 -74 20 -98 -4z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M4470 2338 c-23 -25 -26 -66 -6 -94 12 -15 17 -17 27 -6 7 6 32 12 56 12 45 0 49 5 44 54 -5 55 -82 76 -121 34z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M3900 2149 c0 -18 21 -53 44 -71 45 -37 127 -16 155 39 21 41 15 43 -94 43 -68 0 -105 -4 -105 -11z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M4370 4329 c0 -4 11 -27 25 -50 14 -24 25 -39 25 -34 0 11 -49 94 -50 84z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M4706 4224 c-15 -20 -26 -37 -24 -39 2 -2 16 12 32 31 15 20 26 37 24 39 -2 2 -16 -12 -32 -31z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M5266 4067 c-36 -26 4 -84 42 -61 23 15 26 38 7 58 -20 19 -26 20 -49 3z m43 -11 c17 -20 2 -48 -23 -44 -24 3 -34 37 -14 49 18 12 24 11 37 -5z"}})])]),_vm._v(" "),_c('span',{staticStyle:{"color":"rgba(0, 0, 0, 0.4)","display":"block","font-size":"16px","font-weight":"bold"}},[_vm._v("Your inbox is empty")])])]),_vm._v(" "),(_vm.onboardingFinished)?_c('div',{staticStyle:{"margin-top":"100px"}},[_c('f7-block-title',{staticStyle:{"text-align":"center"}},[_vm._v("What do you like to do next?")]),_vm._v(" "),_c('f7-list',{attrs:{"inset":""}},[_c('f7-list-item',{attrs:{"title":"New Review Invite","link":("/message/list/sms/" + (_vm.loggedInUser.smsChannelId) + "/new-review-invite"),"view":".view-main","reload-all":true}}),_vm._v(" "),_c('f7-list-item',{attrs:{"title":"New Text Message","link":("/message/list/sms/" + (_vm.loggedInUser.smsChannelId) + "/new"),"view":".view-main","reload-all":true}})],1)],1):_vm._e()],1):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.assignedConversations.length > 0),expression:"assignedConversations.length > 0"}],staticClass:"content-center"},[_c('f7-block-title',{staticClass:"block-title-sticky"},[_c('span',[_vm._v("Assigned to you")])]),_vm._v(" "),_c('common-conversation-list',{attrs:{"items":_vm.assignedConversations,"item-height":_vm.itemHeight,"channelTitle":_vm.store.channelTitle,"photo-avatar":_vm.photoAvatar},on:{"markAsDone":_vm.markAsDone,"markAsNotDone":_vm.markAsNotDone,"click":_vm.handleSelected}})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.waitedConversations.length > 0),expression:"waitedConversations.length > 0"}],staticClass:"content-center"},[_c('common-conversation-list',{attrs:{"items":_vm.waitedConversations,"item-height":_vm.itemHeight,"channelTitle":_vm.store.channelTitle,"photo-avatar":_vm.photoAvatar},on:{"markAsDone":_vm.markAsDone,"markAsNotDone":_vm.markAsNotDone,"click":_vm.handleSelected}})],1)]),_vm._v(" "),_c('f7-tab',{attrs:{"id":"tab-handled"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.latestConversations.length > 0),expression:"latestConversations.length > 0"}],staticClass:"content-center"},[_c('common-conversation-list',{attrs:{"items":_vm.latestConversations,"item-height":_vm.itemHeight,"channelTitle":_vm.store.channelTitle,"photo-avatar":_vm.photoAvatar},on:{"markAsDone":_vm.markAsDone,"markAsNotDone":_vm.markAsNotDone,"click":_vm.handleSelected}})],1)])],1),_vm._v(" "),(_vm.query && _vm.query.length && !_vm.store.isLoading && !_vm.firstTimeLoad && _vm.noResultFound)?_c('div',{staticClass:"brief-card content-center content-round"},[_c('div',{staticClass:"brief-card-content"},[_vm._v("No results found for "),_c('b',[_vm._v(_vm._s(_vm.query))])])]):_vm._e(),_vm._v(" "),_vm._t("after-introduction"),_vm._v(" "),(!_vm.store.noMoreToGet)?_c('div',{staticClass:"infinite-scroll-preloader",class:{invisible: !_vm.store.isLoading}},[_c('f7-preloader')],1):_vm._e(),_vm._v(" "),_vm._t("end")],2)};
	var __vue_staticRenderFns__$J = [];

	  /* style */
	  var __vue_inject_styles__$M = undefined;
	  /* scoped */
	  var __vue_scope_id__$M = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$M = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$M = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$M = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$J, staticRenderFns: __vue_staticRenderFns__$J },
	    __vue_inject_styles__$M,
	    __vue_script__$M,
	    __vue_scope_id__$M,
	    __vue_is_functional_template__$M,
	    __vue_module_identifier__$M,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//

	function clearPrevousStreams(e) {
	  $$1(e.target).prevAll('.page').trigger('page:beforeremove', { page: {} });
	}

	var handlePreProcess = lodash.debounce(function () { return Brief$1.events.$emit('accounts-refresh'); }, 1000);

	var script$N = {
	  name: 'AccountsList',
	  props: ['userId', 'userFullname'],
	  data: function data() {
	    var self = this;
	    var accounts = JSON.parse(window.localStorage.getItem('accounts') || '[]');
	    var store = new Store(self, {
	      get: ['accounts', 'list', { tokens: accounts.map(function (x) { return x.token; }) }],
	    });

	    var storeNotifications = new Store(self, {
	      preProcess: handlePreProcess,
	      subscribe: ['notificationmessage', 'list', 'notifications'],
	      skipTeamCheck: true,
	    });

	    var storeObject = {
	      store: store,
	      storeNotifications: storeNotifications,
	    };

	    return storeObject;
	  },
	  mounted: function mounted() {
	    var self = this;

	    self.store.get();

	    Brief$1.events.$on('sync', self.sync);
	    Brief$1.events.$on('accounts-refresh', self.sync);
	  },
	  computed: {
	    accounts: function accounts() {
	      return this.store.accounts || [];
	    },
	    selectedAccount: function selectedAccount() {
	      var userId = window.localStorage.getItem('user_id');
	      var accounts = JSON.parse(window.localStorage.getItem('accounts') || '[]');
	      var selectedAccount = accounts.find(function (x) { return x.userId === userId; });
	      return selectedAccount || {};
	    },
	  },
	  beforeDestroy: function beforeDestroy() {
	    var self = this;

	    Brief$1.events.$off('sync', self.sync);
	    Brief$1.events.$off('accounts-refresh', self.sync);
	    self.store.dispose();
	  },
	  methods: {
	    getNotificationsCount: function getNotificationsCount(account) {
	      return account.messagesCount > 0 ? account.messagesCount : undefined;
	    },
	    handleAccountClick: function handleAccountClick(account) {
	      var self = this;
	      if (!account.active) {
	        window.localStorage.setItem('user_email', account.email);
	        return;
	      }
	      var accounts = JSON.parse(window.localStorage.getItem('accounts') || '[]');
	      var acc = accounts.find(function (x) { return x.userId === account.userId; });
	      if (!acc || window.localStorage.getItem('user_id') === acc.userId) {
	        return;
	      }
	      window.localStorage.setItem('user_id', acc.userId);
	      window.localStorage.setItem('team_id', acc.teamId);
	      window.localStorage.setItem('access_token', acc.token);
	      localforage.clear();
	      if (Brief$1.isCordova) {
	        Brief$1.f7.preloader.show();
	        setTimeout(function () {
	          Brief$1.f7.preloader.hide();
	          window.location.reload();
	        }, 200);
	      } else {
	        self.$nextTick(function () {
	          window.location = '/';
	        });
	      }
	    },
	    handleAddClick: function handleAddClick() {
	      window.localStorage.setItem('user_email', '');
	      Brief$1.viewMain.$el.once('page:init', clearPrevousStreams);
	    },
	    sync: function sync() {
	      this.store.get();
	    },
	  },
	};

	/* script */
	var __vue_script__$N = script$N;

	/* template */
	var __vue_render__$K = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.accounts && _vm.accounts.length > 1)?_c('f7-block-title',[_vm._v("Teams")]):_vm._e(),_vm._v(" "),_c('f7-list',[_vm._l((_vm.accounts),function(account){return (_vm.accounts && _vm.accounts.length > 1)?_c('f7-list-item',{class:{'pointer': _vm.selectedAccount.userId !== account.userId, 'highlighted-account': _vm.selectedAccount.userId === account.userId, 'customer-channel-title': true},staticStyle:{"font-size":"13px"},attrs:{"title":(account.teamName || account.email) + ' ' + (!account.active ? ' (Logged out)' : ''),"link":!account.active ? ("/team/add/?email=" + (account.email) + "&id=" + (account.userId)) : '',"badge":_vm.getNotificationsCount(account),"reload-all":true,"view":".view-main","panel-close":""},on:{"click":function($event){return _vm.handleAccountClick(account)}}},[_c('div',{staticClass:"notification-icon-wrap",attrs:{"slot":"inner-start"},slot:"inner-start"},[_c('common-avatar',{attrs:{"avatar":account.photoFile,"type":"team"}})],1)]):_vm._e()}),_vm._v(" "),_c('f7-list-item',{class:{'customer-channel-title': true},attrs:{"link":"/team/add/","reload-all":true,"view":".view-main","panel-close":"","title":_vm.accounts.length < 2 ? 'Switch team' : 'Add team'},on:{"click":function($event){return _vm.handleAddClick()}}},[_c('div',{staticClass:"notification-icon-wrap",attrs:{"slot":"inner-start"},slot:"inner-start"},[_c('f7-icon',{attrs:{"if-ios":"f7:add_round_fill","if-md":"material:add"}})],1)])],2)],1)};
	var __vue_staticRenderFns__$K = [];

	  /* style */
	  var __vue_inject_styles__$N = undefined;
	  /* scoped */
	  var __vue_scope_id__$N = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$N = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$N = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$N = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$K, staticRenderFns: __vue_staticRenderFns__$K },
	    __vue_inject_styles__$N,
	    __vue_script__$N,
	    __vue_scope_id__$N,
	    __vue_is_functional_template__$N,
	    __vue_module_identifier__$N,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	/* script */

	/* template */
	var __vue_render__$L = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"48px","height":"48px"}})};
	var __vue_staticRenderFns__$L = [];

	  /* style */
	  var __vue_inject_styles__$O = undefined;
	  /* scoped */
	  var __vue_scope_id__$O = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$O = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$O = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$O = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$L, staticRenderFns: __vue_staticRenderFns__$L },
	    __vue_inject_styles__$O,
	    {},
	    __vue_scope_id__$O,
	    __vue_is_functional_template__$O,
	    __vue_module_identifier__$O,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	// F7 Components

	var registeredComponents = {
	  f7Views: views,
	  f7View: view,
	  f7Page: page,
	  f7Navbar: navbar,
	  f7NavLeft: f7NavLeft,
	  f7NavRight: navRight,
	  f7NavTitle: f7NavTitle,
	  f7Block: block,
	  f7BlockTitle: blockTitle,
	  f7BlockHeader: blockHeader,
	  f7BlockFooter: blockFooter,
	  f7Card: card,
	  f7CardHeader: f7CardHeader,
	  f7CardFooter: f7CardFooter,
	  f7CardContent: f7CardContent,
	  f7Chip: chip,
	  f7Icon: f7Icon,
	  f7Col: col,
	  f7Row: row,
	  f7Badge: f7Badge,
	  f7Preloader: preloader,
	  f7Statusbar: statusbar,
	  f7Subnavbar: subnavbar,
	  f7Tabs: tabs,
	  f7Tab: tab,
	  f7PageContent: f7PageContent,
	  f7Fab: fab,
	  f7FabButton: fabButton,
	  f7FabButtons: fabButtons,
	  f7Toolbar: toolbar,
	  f7Progressbar: progressbar,
	  f7LoginScreenTitle: loginScreenTitle,
	  f7Swiper: swiper,
	  f7SwiperSlide: swiperSlide,
	  f7List: list,
	  f7ListItem: listItem,
	  f7ListItemCell: listItemCell,
	  f7ListItemRow: listItemRow,
	  f7ListItemContent: f7ListItemContent,
	  f7ListButton: listButton,
	  f7SwipeoutActions: swipeoutActions,
	  f7SwipeoutButton: swipeoutButton,
	  f7Link: f7Link,
	  f7Button: button,
	  f7Segmented: segmented,
	  f7Searchbar: searchbar,
	  f7Popover: popover,
	  f7Popup: popup,
	  f7Accordion: accordion,
	  f7AccordionItem: accordionItem,
	  f7AccordionToggle: accordionToggle,
	  f7AccordionContent: accordionContent,
	  f7Checkbox: checkbox,
	  f7Radio: radio,
	  f7Range: f7Range,
	  f7Toggle: f7Toggle,
	  f7Label: label,
	  f7Input: f7Input,
	  f7Panel: panel,
	  f7Sheet: sheet,
	  // Custom components
	  teamStatistics: __vue_component__$m,
	  dashboardChart: __vue_component__$n,
	  commonWrite: __vue_component__$1,
	  commonBadge: __vue_component__$2,
	  commonFiles: __vue_component__$3,
	  commonFile: __vue_component__$4,
	  commonImage: __vue_component__$5,
	  commonVideo: __vue_component__$6,
	  commonDocument: __vue_component__$7,
	  commonAvatar: __vue_component__$8,
	  commonSearch: __vue_component__$9,
	  commonAuthPage: __vue_component__$o,
	  commonNavbar: __vue_component__$a,
	  commonTopbanner: __vue_component__$b,
	  commonToolbarButton: __vue_component__$c,
	  commonEmptyMessage: __vue_component__$e,
	  commonConversationList: __vue_component__$d,
	  commonOfflineIndicator: __vue_component__$f,
	  commonUrlPreview: __vue_component__$g,
	  commonEmailPreview: __vue_component__$h,
	  commonPlan: __vue_component__$i,
	  commonCheckmark: __vue_component__$j,
	  commonClock: __vue_component__$k,
	  commonLoader: __vue_component__$l,
	  commonUserPage: __vue_component__$p,
	  commonUserList: __vue_component__$q,
	  commonUserListInviteInfo: __vue_component__$r,
	  commonChannelInfo: __vue_component__$s,
	  commonChannelAutoreply: __vue_component__$t,
	  commonChannelVisibility: __vue_component__$u,
	  commonChannelWaitLimit: __vue_component__$v,
	  conversationAssignPage: __vue_component__$w,
	  channelChatPage: __vue_component__$x,
	  channelInvitePage: __vue_component__$y,
	  channelJoinPage: __vue_component__$z,
	  channelSignaturePage: __vue_component__$A,
	  channelMembersPage: __vue_component__$B,
	  channelNotificationsPage: __vue_component__$C,
	  channelInfoPage: __vue_component__$D,
	  channelAutoreplyPage: __vue_component__$E,
	  channelWaitlimitPage: __vue_component__$F,
	  channelOfficehoursPage: __vue_component__$G,
	  channelWidgetPage: __vue_component__$H,
	  channelEmailPage: __vue_component__$I,
	  channelInstagramPage: __vue_component__$J,
	  channelSettingsPage: __vue_component__$K,
	  channelCreatePage: __vue_component__$L,
	  channelConversationPage: __vue_component__$M,
	  accountsList: __vue_component__$N,
	  commonNavPlaceholder: __vue_component__$O,
	};

	function VueDirectives () {
	  Vue.directive('visible', {
	    inserted: function inserted(el, binding) {
	      // eslint-disable-next-line
	      el.style.visibility = binding.value ? 'visible' : 'hidden';
	    },
	  });
	}

	//

	var checkInterval = null;
	var isLoggedInUsingGoogle = false;

	var script$O = {
	  name: 'AccountLogin',
	  data: function data() {
	    var self = this;
	    var state = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
	      var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
	      return v.toString(16);
	    });
	    if (Brief$1.isCordova) {
	      state = "mobile_" + state;
	    }
	    var storeGoogleAuth = new Store(self, {
	      get: ['google', 'auth', { state: state }],
	    });
	    storeGoogleAuth.on('getFinished', function () {
	      if (!storeGoogleAuth.token) {
	        return;
	      }
	      if (checkInterval) {
	        clearInterval(checkInterval);
	      }
	      window.localStorage.setItem('user_id', storeGoogleAuth.userId);
	      window.localStorage.setItem('team_id', storeGoogleAuth.teamId);
	      window.localStorage.setItem('access_token', storeGoogleAuth.token);
	      window.localStorage.setItem('accounts', JSON.stringify([{
	        userId: storeGoogleAuth.userId,
	        teamId: storeGoogleAuth.teamId,
	        token: storeGoogleAuth.token,
	        firstName: storeGoogleAuth.firstName,
	        lastName: storeGoogleAuth.lastName,
	        photoFile: storeGoogleAuth.photoFile,
	      }]));

	      isLoggedInUsingGoogle = true;
	      if (!Brief$1.isCordova) {
	        Brief$1.login();
	      }
	    });
	    return {
	      storeGoogleAuth: storeGoogleAuth,
	      state: state,
	      inputs: [
	        {
	          type: 'email',
	          name: 'email',
	          placeholder: 'Enter your email',
	        },
	        {
	          type: 'password',
	          name: 'password',
	          placeholder: 'Password',
	        } ],
	    };
	  },
	  methods: {
	    submit: function submit() {
	      $$1(this.$el).find('form').trigger('submit');
	    },
	    googleSignin: function googleSignin() {
	      var this$1 = this;

	      var url = (this.domain) + "/api/google/login?state=" + (this.state);
	      if (!Brief$1.isCordova) {
	        var win = window.open(url);
	        var timer = setInterval(function () {
	          if (win.closed) {
	            clearInterval(timer);
	            this$1.storeGoogleAuth.get();
	          }
	        }, 500);
	      } else {
	        Brief$1.events.$on('sync', function () {
	          if (!isLoggedInUsingGoogle) {
	            return;
	          }
	          isLoggedInUsingGoogle = false;
	          setTimeout(function () {
	            Brief$1.login();
	          }, 500);
	        });
	        Brief$1.openInSystemBrowser(url);
	        checkInterval = setInterval(function () {
	          this$1.storeGoogleAuth.get();
	        }, 1000);
	      }
	    },
	    onSuccess: function onSuccess(data) {
	      var self = this;

	      if (!Brief$1.isCordova) {
	        PushNotifications.requestPermission();
	        window.history.replaceState({}, '', '/');
	      }

	      self.$root.loggedInUser.id = data.userId;
	      self.$root.loggedInUser.ownerTeamId = data.ownerTeamId;

	      window.localStorage.setItem('user_id', data.userId);
	      window.localStorage.setItem('team_id', data.ownerTeamId);
	      window.localStorage.setItem('access_token', data.token);
	      window.localStorage.setItem('accounts', JSON.stringify([{
	        userId: data.userId,
	        teamId: data.ownerTeamId,
	        token: data.token,
	        firstName: data.firstName,
	        lastName: data.lastName,
	        photoFile: data.photoFile,
	      }]));

	      Brief$1.login();
	    },
	  },
	};

	/* script */
	var __vue_script__$O = script$O;

	/* template */
	var __vue_render__$M = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('common-auth-page',{attrs:{"title":"Hello and welcome","endpoint":"/account/login","buttonText":"Login","buttonTextSending":"Logging in...","buttonTextSent":"Logged in...","inputs":_vm.inputs,"sendGuid":false},on:{"success":_vm.onSuccess}},[_c('template',{slot:"footer"},[_c('a',{attrs:{"data-reload-current":"true","href":"/account/signup/"}},[_vm._v("Sign up?")]),_vm._v(" "),_c('span',[_vm._v(" | ")]),_vm._v(" "),_c('a',{attrs:{"data-reload-current":"true","href":"/account/forgot/"}},[_vm._v("Forgot password?")])])],2)};
	var __vue_staticRenderFns__$M = [];

	  /* style */
	  var __vue_inject_styles__$P = undefined;
	  /* scoped */
	  var __vue_scope_id__$P = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$P = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$P = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$P = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$M, staticRenderFns: __vue_staticRenderFns__$M },
	    __vue_inject_styles__$P,
	    __vue_script__$O,
	    __vue_scope_id__$P,
	    __vue_is_functional_template__$P,
	    __vue_module_identifier__$P,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//

	var script$P = {
	  name: 'AccountSignup',
	  data: function data() {
	    return {
	      inputs: [
	        {
	          type: 'email',
	          name: 'email',
	          placeholder: 'Enter your email',
	        } ],
	    };
	  },
	  methods: {
	    onSuccess: function onSuccess() {
	      setTimeout(function () {
	        Brief$1.viewLogin.router.navigate('/account/login/', { reloadCurrent: true });
	      }, 5000);
	    },
	  },
	};

	/* script */
	var __vue_script__$P = script$P;

	/* template */
	var __vue_render__$N = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('common-auth-page',{attrs:{"title":"Nice to have you onboard","endpoint":"/account/signup","buttonText":"Sign up","buttonTextSending":"Signing up...","buttonTextSent":"Check your email...","inputs":_vm.inputs,"sendGuid":false},on:{"success":_vm.onSuccess}},[_c('template',{slot:"footer"},[_c('a',{attrs:{"data-reload-current":"true","href":"/account/login/"}},[_vm._v("Already have an account?")])])],2)};
	var __vue_staticRenderFns__$N = [];

	  /* style */
	  var __vue_inject_styles__$Q = undefined;
	  /* scoped */
	  var __vue_scope_id__$Q = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$Q = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$Q = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$Q = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$N, staticRenderFns: __vue_staticRenderFns__$N },
	    __vue_inject_styles__$Q,
	    __vue_script__$P,
	    __vue_scope_id__$Q,
	    __vue_is_functional_template__$Q,
	    __vue_module_identifier__$Q,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//

	var script$Q = {
	  name: 'AccountForgot',
	  data: function data() {
	    return {
	      inputs: [
	        {
	          type: 'email',
	          name: 'email',
	          placeholder: 'Enter your email',
	        } ],
	    };
	  },
	  methods: {
	    onSuccess: function onSuccess() {
	      setTimeout(function () {
	        Brief$1.viewLogin.router.navigate('/account/login/', { reloadCurrent: true });
	      }, 5000);
	    },
	  },
	};

	/* script */
	var __vue_script__$Q = script$Q;

	/* template */
	var __vue_render__$O = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('common-auth-page',{attrs:{"title":"No problem, we will help you","endpoint":"/account/forgot","buttonText":"Reset my password","buttonTextSending":"Please wait...","buttonTextSent":"Reset email sent","inputs":_vm.inputs,"sendGuid":false},on:{"success":_vm.onSuccess}},[_c('template',{slot:"footer"},[_c('a',{attrs:{"data-reload-current":"true","href":"/account/login/"}},[_vm._v("I have remembered my password")])])],2)};
	var __vue_staticRenderFns__$O = [];

	  /* style */
	  var __vue_inject_styles__$R = undefined;
	  /* scoped */
	  var __vue_scope_id__$R = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$R = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$R = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$R = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$O, staticRenderFns: __vue_staticRenderFns__$O },
	    __vue_inject_styles__$R,
	    __vue_script__$Q,
	    __vue_scope_id__$R,
	    __vue_is_functional_template__$R,
	    __vue_module_identifier__$R,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//

	var script$R = {
	  name: 'AccountReset',
	  data: function data() {
	    return {
	      inputs: [
	        {
	          type: 'password',
	          name: 'password',
	          placeholder: 'Password',
	        },
	        {
	          type: 'password',
	          name: 'confirm',
	          placeholder: 'Confirm password',
	        } ],
	    };
	  },
	  methods: {
	    onSuccess: function onSuccess() {
	      setTimeout(function () {
	        Brief$1.viewLogin.router.navigate('/account/login/', { reloadCurrent: true });
	      }, 2000);
	    },
	  },
	};

	/* script */
	var __vue_script__$R = script$R;

	/* template */
	var __vue_render__$P = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('common-auth-page',{attrs:{"title":"Almost there..","endpoint":"/account/reset","buttonText":"Reset","buttonTextSending":"Resetting...","buttonTextSent":"Resetted","inputs":_vm.inputs,"sendGuid":true},on:{"success":_vm.onSuccess}})};
	var __vue_staticRenderFns__$P = [];

	  /* style */
	  var __vue_inject_styles__$S = undefined;
	  /* scoped */
	  var __vue_scope_id__$S = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$S = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$S = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$S = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$P, staticRenderFns: __vue_staticRenderFns__$P },
	    __vue_inject_styles__$S,
	    __vue_script__$R,
	    __vue_scope_id__$S,
	    __vue_is_functional_template__$S,
	    __vue_module_identifier__$S,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//
	//
	//
	//
	//
	//
	//
	//
	//
	//

	var script$S = {
	  name: 'AccountNotfound',
	};

	/* script */
	var __vue_script__$S = script$S;

	/* template */
	var __vue_render__$Q = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('common-auth-page',{attrs:{"title":"User already verified!","button":false}},[_c('template',{slot:"footer"},[_c('a',{attrs:{"href":"/account/login/","data-reload-current":"true"}},[_vm._v("Login here")])])],2)};
	var __vue_staticRenderFns__$Q = [];

	  /* style */
	  var __vue_inject_styles__$T = undefined;
	  /* scoped */
	  var __vue_scope_id__$T = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$T = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$T = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$T = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$Q, staticRenderFns: __vue_staticRenderFns__$Q },
	    __vue_inject_styles__$T,
	    __vue_script__$S,
	    __vue_scope_id__$T,
	    __vue_is_functional_template__$T,
	    __vue_module_identifier__$T,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//

	var script$T = {
	  name: 'AccountVerify',
	  data: function data() {
	    return {
	      inputs: [
	        {
	          type: 'text',
	          name: 'firstname',
	          placeholder: 'First name',
	        },
	        {
	          type: 'text',
	          name: 'lastname',
	          placeholder: 'Last name',
	        },
	        {
	          type: 'password',
	          name: 'password',
	          placeholder: 'Password',
	        },
	        {
	          type: 'password',
	          name: 'confirm',
	          placeholder: 'Confirm password',
	        } ],
	      password: '',
	      confirm: '',
	      buttonDisabled: true,
	      resultText: '',
	    };
	  },
	  methods: {
	    checkPassword: function checkPassword(prop, value) {
	      var self = this;
	      self[prop] = value;
	      if (self.password.length < 6) {
	        self.resultText = 'Your password must be at least 6 characters long. Please add more.';
	        self.buttonDisabled = true;
	      } else if (self.password.search(/[0-9]/) < 0) {
	        self.resultText = 'Your password must contain at least one digit.';
	        self.buttonDisabled = true;
	      } else if (self.confirm === '') {
	        self.resultText = '';
	        self.buttonDisabled = true;
	      } else if (self.confirm !== self.password) {
	        self.resultText = 'Your password and confirmation do not match.';
	        self.buttonDisabled = true;
	      } else {
	        self.resultText = '';
	        self.buttonDisabled = false;
	      }
	    },
	    onSuccess: function onSuccess(data) {
	      var self = this;

	      if (!Brief$1.isCordova) {
	        window.history.replaceState({}, '', '/');
	      }

	      self.$root.loggedInUser.id = data.userId;
	      self.$root.loggedInUser.ownerTeamId = data.ownerTeamId;

	      window.localStorage.setItem('user_id', data.userId);
	      window.localStorage.setItem('team_id', data.ownerTeamId);
	      window.localStorage.setItem('access_token', data.token);
	      window.localStorage.setItem('accounts', JSON.stringify([{
	        userId: data.userId,
	        teamId: data.ownerTeamId,
	        token: data.token,
	        firstName: data.firstName,
	        lastName: data.lastName,
	        photoFile: data.photoFile,
	      }]));

	      Brief$1.login();
	    },
	  },
	};

	/* script */
	var __vue_script__$T = script$T;

	/* template */
	var __vue_render__$R = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('common-auth-page',{attrs:{"title":"Almost there..","endpoint":"/account/verify","buttonDisabled":_vm.buttonDisabled,"buttonText":"Let me in","buttonTextSending":"Signing up...","buttonTextSent":"Welcome!","inputs":_vm.inputs,"sendGuid":true},on:{"success":_vm.onSuccess,"passwordChange":function($event){return _vm.checkPassword('password', $event)},"confirmChange":function($event){return _vm.checkPassword('confirm', $event)}}},[_c('li',{attrs:{"slot":"before-button"},slot:"before-button"},[_c('div',{staticClass:"block-footer verify-password-message",attrs:{"id":"result"}},[_vm._v(_vm._s(_vm.resultText))])]),_vm._v(" "),_c('li',{staticClass:"margin-bottom",attrs:{"slot":"privacy-policy"},slot:"privacy-policy"},[_c('div',{staticClass:"block-footer"},[_vm._v("\n      Read our Privacy policy "),_c('a',{staticClass:"link external",attrs:{"href":"https://letsbrief.com/privacypolicy.pdf","target":"_blank"}},[_vm._v("here")])])])])};
	var __vue_staticRenderFns__$R = [];

	  /* style */
	  var __vue_inject_styles__$U = undefined;
	  /* scoped */
	  var __vue_scope_id__$U = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$U = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$U = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$U = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$R, staticRenderFns: __vue_staticRenderFns__$R },
	    __vue_inject_styles__$U,
	    __vue_script__$T,
	    __vue_scope_id__$U,
	    __vue_is_functional_template__$U,
	    __vue_module_identifier__$U,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//

	var script$U = {
	  data: function data() {
	    var self = this;
	    var shortId = self.$f7route.params.shortId;

	    var store = new Store(self, {
	      get: ['reviewlink', 'get'],
	      getFinished: function () {
	      }
	    });

	    store.get({ shortId: shortId });

	    return {
	      store: store,
	    }
	  },
	};

	/* script */
	var __vue_script__$U = script$U;

	/* template */
	var __vue_render__$S = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f7-page',[_c('f7-block',{staticStyle:{"display":"flex","flex-direction":"column","height":"100%","justify-content":"center","align-content":"center","align-items":"center","margin":"0"}},[_c('h1',{staticStyle:{"text-align":"center","font-weight":"normal","margin-bottom":"44px"}},[_vm._v("\n      Use "),_c('svg',{staticStyle:{"height":"33px","position":"relative","top":"8px"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 270 90"}},[_c('path',{attrs:{"d":"M115.39 46.71c0 12.77-9.99 22.18-22.25 22.18s-22.25-9.41-22.25-22.18c0-12.86 9.99-22.18 22.25-22.18s22.25 9.32 22.25 22.18zm-9.74 0c0-7.98-5.79-13.44-12.51-13.44s-12.51 5.46-12.51 13.44c0 7.9 5.79 13.44 12.51 13.44s12.51-5.55 12.51-13.44z","fill":"#EA4335"}}),_c('path',{attrs:{"d":"M163.39 46.71c0 12.77-9.99 22.18-22.25 22.18s-22.25-9.41-22.25-22.18c0-12.85 9.99-22.18 22.25-22.18s22.25 9.32 22.25 22.18zm-9.74 0c0-7.98-5.79-13.44-12.51-13.44s-12.51 5.46-12.51 13.44c0 7.9 5.79 13.44 12.51 13.44s12.51-5.55 12.51-13.44z","fill":"#FBBC05"}}),_c('path',{attrs:{"d":"M209.39 25.87v39.82c0 16.38-9.66 23.07-21.08 23.07-10.75 0-17.22-7.19-19.66-13.07l8.48-3.53c1.51 3.61 5.21 7.87 11.17 7.87 7.31 0 11.84-4.51 11.84-13v-3.19h-.34c-2.18 2.69-6.38 5.04-11.68 5.04-11.09 0-21.25-9.66-21.25-22.09 0-12.52 10.16-22.26 21.25-22.26 5.29 0 9.49 2.35 11.68 4.96h.34v-3.61h9.25zm-8.56 20.92c0-7.81-5.21-13.52-11.84-13.52-6.72 0-12.35 5.71-12.35 13.52 0 7.73 5.63 13.36 12.35 13.36 6.63 0 11.84-5.63 11.84-13.36z","fill":"#4285F4"}}),_c('path',{attrs:{"d":"M224.64 2.53v65h-9.5v-65z","fill":"#34A853"}}),_c('path',{attrs:{"d":"M261.66 54.01l7.56 5.04c-2.44 3.61-8.32 9.83-18.48 9.83-12.6 0-22.01-9.74-22.01-22.18 0-13.19 9.49-22.18 20.92-22.18 11.51 0 17.14 9.16 18.98 14.11l1.01 2.52-29.65 12.28c2.27 4.45 5.8 6.72 10.75 6.72 4.96 0 8.4-2.44 10.92-6.14zm-23.27-7.98l19.82-8.23c-1.09-2.77-4.37-4.7-8.23-4.7-4.95 0-11.84 4.37-11.59 12.93z","fill":"#EA4335"}}),_c('path',{attrs:{"d":"M34.93 40.94v-9.41h31.71c.31 1.64.47 3.58.47 5.68 0 7.06-1.93 15.79-8.15 22.01-6.05 6.3-13.78 9.66-24.02 9.66C15.96 68.88 0 53.42 0 34.44 0 15.46 15.96 0 34.94 0c10.5 0 17.98 4.12 23.6 9.49l-6.64 6.64c-4.03-3.78-9.49-6.72-16.97-6.72-13.86 0-24.7 11.17-24.7 25.03 0 13.86 10.84 25.03 24.7 25.03 8.99 0 14.11-3.61 17.39-6.89 2.66-2.66 4.41-6.46 5.1-11.65z","fill":"#4285F4"}})]),_vm._v(" to leave your review?\n    ")]),_vm._v(" "),_c('f7-button',{staticStyle:{"width":"100%","max-width":"300px","font-weight":"bold"},attrs:{"big":"","fill":"","href":_vm.store.reviewLink,"external":""}},[_vm._v("Yes")])],1)],1)};
	var __vue_staticRenderFns__$S = [];

	  /* style */
	  var __vue_inject_styles__$V = undefined;
	  /* scoped */
	  var __vue_scope_id__$V = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$V = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$V = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$V = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$S, staticRenderFns: __vue_staticRenderFns__$S },
	    __vue_inject_styles__$V,
	    __vue_script__$U,
	    __vue_scope_id__$V,
	    __vue_is_functional_template__$V,
	    __vue_module_identifier__$V,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//

	var script$V = {
	  data: function data() {
	    return {
	      isCordova: Brief$1.isCordova,
	    };
	  },
	};

	/* script */
	var __vue_script__$V = script$V;

	/* template */
	var __vue_render__$T = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f7-page',{staticClass:"page-form"},[_c('common-navbar',{attrs:{"title":"Settings","root":true}}),_vm._v(" "),_c('f7-list',{attrs:{"inset":""}},[_c('f7-list-item',{attrs:{"title":"Profile","link":"/user/settings/"}}),_vm._v(" "),_c('f7-list-item',{attrs:{"title":"Company information","link":"/company/settings/"}}),_vm._v(" "),(!_vm.isCordova)?_c('f7-list-item',{attrs:{"title":"Subscription","link":"/subscription/settings/"}}):_vm._e()],1)],1)};
	var __vue_staticRenderFns__$T = [];

	  /* style */
	  var __vue_inject_styles__$W = undefined;
	  /* scoped */
	  var __vue_scope_id__$W = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$W = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$W = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$W = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$T, staticRenderFns: __vue_staticRenderFns__$T },
	    __vue_inject_styles__$W,
	    __vue_script__$V,
	    __vue_scope_id__$W,
	    __vue_is_functional_template__$W,
	    __vue_module_identifier__$W,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//

	var script$W = {
	  name: 'AccountLogin',
	  data: function data() {
	    return {
	      inputs: [
	        {
	          type: 'email',
	          name: 'email',
	          placeholder: 'Enter your email',
	        },
	        {
	          type: 'password',
	          name: 'password',
	          placeholder: 'Password',
	        } ],
	    };
	  },
	  methods: {
	    submit: function submit() {
	      $$1(this.$el).find('form').trigger('submit');
	    },
	    onSuccess: function onSuccess(data) {
	      var self = this;

	      var accounts = JSON.parse(window.localStorage.getItem('accounts') || '[]');
	      var selectedAccount = accounts.find(function (x) { return x.userId === data.userId; });
	      if (!selectedAccount) {
	        accounts.push({
	          userId: data.userId,
	          teamId: data.ownerTeamId,
	          token: data.token,
	          firstName: data.firstName,
	          lastName: data.lastName,
	          photoFile: data.photoFile,
	        });
	      } else {
	        selectedAccount.token = data.token;
	      }
	      window.localStorage.setItem('user_id', data.userId);
	      window.localStorage.setItem('team_id', data.ownerTeamId);
	      window.localStorage.setItem('access_token', data.token);
	      window.localStorage.setItem('accounts', JSON.stringify(accounts));
	      localforage.clear();
	      if (Brief$1.isCordova) {
	        Brief$1.f7.preloader.show();
	        setTimeout(function () {
	          Brief$1.f7.preloader.hide();
	          window.location.reload();
	        }, 200);
	      } else {
	        self.$nextTick(function () {
	          window.location = '/';
	        });
	      }

	      if (!Brief$1.isCordova) {
	        PushNotifications.requestPermission();
	        window.history.replaceState({}, '', '/');
	      }

	      Brief$1.login();
	    },
	  },
	};

	/* script */
	var __vue_script__$W = script$W;

	/* template */
	var __vue_render__$U = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('common-auth-page',{attrs:{"title":"Add Team","endpoint":"/account/login","buttonText":"Add","buttonTextSending":"Logging in...","buttonTextSent":"Logged in...","inputs":_vm.inputs,"can-forget":true,"sendGuid":false,"displayNavbar":true},on:{"success":_vm.onSuccess}},[_c('template',{slot:"footer"},[_c('a',{attrs:{"data-reload-current":"true","href":"/team/signup/"}},[_vm._v("Sign up?")]),_vm._v(" "),_c('span',[_vm._v(" | ")]),_vm._v(" "),_c('a',{attrs:{"data-reload-current":"true","href":"/team/forgot/"}},[_vm._v("Forgot password?")])])],2)};
	var __vue_staticRenderFns__$U = [];

	  /* style */
	  var __vue_inject_styles__$X = undefined;
	  /* scoped */
	  var __vue_scope_id__$X = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$X = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$X = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$X = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$U, staticRenderFns: __vue_staticRenderFns__$U },
	    __vue_inject_styles__$X,
	    __vue_script__$W,
	    __vue_scope_id__$X,
	    __vue_is_functional_template__$X,
	    __vue_module_identifier__$X,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//

	var script$X = {
	  name: 'AccountSignup',
	  data: function data() {
	    return {
	      inputs: [
	        {
	          type: 'email',
	          name: 'email',
	          placeholder: 'Enter your email',
	        } ],
	    };
	  },
	  methods: {
	    onSuccess: function onSuccess() {
	      setTimeout(function () {
	        Brief$1.viewMain.router.navigate('/team/add/', { reloadCurrent: true });
	      }, 5000);
	    },
	  },
	};

	/* script */
	var __vue_script__$X = script$X;

	/* template */
	var __vue_render__$V = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('common-auth-page',{attrs:{"title":"Nice to have you onboard","endpoint":"/account/signup","buttonText":"Sign up","buttonTextSending":"Signing up...","buttonTextSent":"Check your email...","inputs":_vm.inputs,"sendGuid":false,"displayNavbar":true},on:{"success":_vm.onSuccess}},[_c('template',{slot:"footer"},[_c('a',{attrs:{"data-reload-current":"true","href":"/team/add/"}},[_vm._v("Already have an account?")])])],2)};
	var __vue_staticRenderFns__$V = [];

	  /* style */
	  var __vue_inject_styles__$Y = undefined;
	  /* scoped */
	  var __vue_scope_id__$Y = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$Y = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$Y = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$Y = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$V, staticRenderFns: __vue_staticRenderFns__$V },
	    __vue_inject_styles__$Y,
	    __vue_script__$X,
	    __vue_scope_id__$Y,
	    __vue_is_functional_template__$Y,
	    __vue_module_identifier__$Y,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//

	var script$Y = {
	  name: 'AccountForgot',
	  data: function data() {
	    return {
	      inputs: [
	        {
	          type: 'email',
	          name: 'email',
	          placeholder: 'Enter your email',
	        } ],
	    };
	  },
	  methods: {
	    onSuccess: function onSuccess() {
	      setTimeout(function () {
	        Brief$1.viewMain.router.navigate('/team/add/', { reloadCurrent: true });
	      }, 5000);
	    },
	  },
	};

	/* script */
	var __vue_script__$Y = script$Y;

	/* template */
	var __vue_render__$W = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('common-auth-page',{attrs:{"title":"No problem, we will help you","endpoint":"/account/forgot","buttonText":"Reset my password","buttonTextSending":"Please wait...","buttonTextSent":"Reset email sent","inputs":_vm.inputs,"sendGuid":false,"displayNavbar":true},on:{"success":_vm.onSuccess}},[_c('template',{slot:"footer"},[_c('a',{attrs:{"data-reload-current":"true","href":"/team/add/"}},[_vm._v("I have remembered my password")])])],2)};
	var __vue_staticRenderFns__$W = [];

	  /* style */
	  var __vue_inject_styles__$Z = undefined;
	  /* scoped */
	  var __vue_scope_id__$Z = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$Z = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$Z = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$Z = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$W, staticRenderFns: __vue_staticRenderFns__$W },
	    __vue_inject_styles__$Z,
	    __vue_script__$Y,
	    __vue_scope_id__$Z,
	    __vue_is_functional_template__$Z,
	    __vue_module_identifier__$Z,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//

	var script$Z = {
	  name: 'AccountReset',
	  data: function data() {
	    return {
	      inputs: [
	        {
	          type: 'password',
	          name: 'password',
	          placeholder: 'Password',
	        },
	        {
	          type: 'password',
	          name: 'confirm',
	          placeholder: 'Confirm password',
	        } ],
	    };
	  },
	  methods: {
	    onSuccess: function onSuccess() {
	      setTimeout(function () {
	        Brief$1.viewMain.router.navigate('/team/add/', { reloadCurrent: true });
	      }, 2000);
	    },
	  },
	};

	/* script */
	var __vue_script__$Z = script$Z;

	/* template */
	var __vue_render__$X = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('common-auth-page',{attrs:{"title":"Almost there..","endpoint":"/account/reset","buttonText":"Let me in","buttonTextSending":"Resetting...","buttonTextSent":"Resetted","inputs":_vm.inputs,"sendGuid":true,"displayNavbar":true},on:{"success":_vm.onSuccess}})};
	var __vue_staticRenderFns__$X = [];

	  /* style */
	  var __vue_inject_styles__$_ = undefined;
	  /* scoped */
	  var __vue_scope_id__$_ = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$_ = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$_ = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$_ = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$X, staticRenderFns: __vue_staticRenderFns__$X },
	    __vue_inject_styles__$_,
	    __vue_script__$Z,
	    __vue_scope_id__$_,
	    __vue_is_functional_template__$_,
	    __vue_module_identifier__$_,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//

	var script$_ = {
	  name: 'AccountVerify',
	  data: function data() {
	    var id = this.$f7route ? this.$f7route.query.id : null;
	    if (id) {
	      window.location = "brief:///account/verify/" + id;
	    }
	    return {
	      inputs: [
	        {
	          type: 'text',
	          name: 'firstname',
	          placeholder: 'First name',
	        },
	        {
	          type: 'text',
	          name: 'lastname',
	          placeholder: 'Last name',
	        },
	        {
	          type: 'password',
	          name: 'password',
	          placeholder: 'Password',
	        },
	        {
	          type: 'password',
	          name: 'confirm',
	          placeholder: 'Confirm password',
	        } ],
	      password: '',
	      confirm: '',
	      buttonDisabled: true,
	      resultText: '',
	    };
	  },
	  methods: {
	    checkPassword: function checkPassword(prop, value) {
	      var self = this;
	      self[prop] = value;
	      if (self.password.length < 6) {
	        self.resultText = 'Your password must be at least 6 characters long. Please add more.';
	        self.buttonDisabled = true;
	      } else if (self.password.search(/[0-9]/) < 0) {
	        self.resultText = 'Your password must contain at least one digit.';
	        self.buttonDisabled = true;
	      } else if (self.confirm === '') {
	        self.resultText = '';
	        self.buttonDisabled = true;
	      } else if (self.confirm !== self.password) {
	        self.resultText = 'Your password and confirmation do not match.';
	        self.buttonDisabled = true;
	      } else {
	        self.resultText = '';
	        self.buttonDisabled = false;
	      }
	    },
	    onSuccess: function onSuccess(data) {
	      var self = this;

	      self.$root.loggedInUser.id = data.userId;
	      self.$root.loggedInUser.ownerTeamId = data.ownerTeamId;

	      var accounts = JSON.parse(window.localStorage.getItem('accounts') || '[]');
	      if (!accounts.find(function (x) { return x.userId === data.userId; })) {
	        accounts.push({
	          userId: data.userId,
	          teamId: data.ownerTeamId,
	          token: data.token,
	          firstName: data.firstName,
	          lastName: data.lastName,
	          photoFile: data.photoFile,
	        });
	      }

	      window.localStorage.setItem('user_id', data.userId);
	      window.localStorage.setItem('team_id', data.ownerTeamId);
	      window.localStorage.setItem('access_token', data.token);
	      window.localStorage.setItem('accounts', JSON.stringify(accounts));

	      localforage.clear();
	      if (Brief$1.isCordova) {
	        Brief$1.f7.preloader.show();
	        setTimeout(function () {
	          Brief$1.f7.preloader.hide();
	          window.location.reload();
	        }, 200);
	      } else {
	        self.$nextTick(function () {
	          window.location = '/';
	        });
	      }

	      if (!Brief$1.isCordova) {
	        PushNotifications.requestPermission();
	        window.history.replaceState({}, '', '/');
	      }

	      Brief$1.login();
	    },
	  },
	};

	/* script */
	var __vue_script__$_ = script$_;

	/* template */
	var __vue_render__$Y = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('common-auth-page',{attrs:{"title":"Almost there..","endpoint":"/account/verify","buttonDisabled":_vm.buttonDisabled,"buttonText":"Let me in","buttonTextSending":"Signing up...","buttonTextSent":"Welcome!","inputs":_vm.inputs,"sendGuid":true,"displayNavbar":true},on:{"success":_vm.onSuccess,"passwordChange":function($event){return _vm.checkPassword('password', $event)},"confirmChange":function($event){return _vm.checkPassword('confirm', $event)}}},[_c('li',{staticClass:"margin-bottom",attrs:{"slot":"before-button"},slot:"before-button"},[_c('div',{staticClass:"block-footer verify-password-message",attrs:{"id":"result"}},[_vm._v(_vm._s(_vm.resultText))])]),_vm._v(" "),_c('li',{staticClass:"margin-bottom",attrs:{"slot":"privacy-policy"},slot:"privacy-policy"},[_c('div',{staticClass:"block-footer"},[_vm._v("\n      Read our Privacy policy "),_c('a',{staticClass:"link external",attrs:{"href":"https://letsbrief.com/privacypolicy.pdf","target":"_blank"}},[_vm._v("here")])])])])};
	var __vue_staticRenderFns__$Y = [];

	  /* style */
	  var __vue_inject_styles__$10 = undefined;
	  /* scoped */
	  var __vue_scope_id__$10 = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$10 = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$10 = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$10 = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$Y, staticRenderFns: __vue_staticRenderFns__$Y },
	    __vue_inject_styles__$10,
	    __vue_script__$_,
	    __vue_scope_id__$10,
	    __vue_is_functional_template__$10,
	    __vue_module_identifier__$10,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	var croppie = createCommonjsModule(function (module, exports) {
	/*************************
	 * Croppie
	 * Copyright 2019
	 * Foliotek
	 * Version: 2.6.5
	 *************************/
	(function (root, factory) {
	    if (typeof exports.nodeName !== 'string') {
	        // CommonJS
	        module.exports = factory();
	    } else {
	        // Browser globals
	        root.Croppie = factory();
	    }
	}(typeof self !== 'undefined' ? self : commonjsGlobal, function () {

	    /* Polyfills */
	    if (typeof Promise !== 'function') {
	        /*! promise-polyfill 3.1.0 */
	        !function(a){function b(a,b){return function(){a.apply(b,arguments);}}function c(a){if("object"!==typeof this){ throw new TypeError("Promises must be constructed via new"); }if("function"!==typeof a){ throw new TypeError("not a function"); }this._state=null,this._value=null,this._deferreds=[],i(a,b(e,this),b(f,this));}function d(a){var b=this;return null===this._state?void this._deferreds.push(a):void k(function(){var c=b._state?a.onFulfilled:a.onRejected;if(null===c){ return void(b._state?a.resolve:a.reject)(b._value); }var d;try{d=c(b._value);}catch(e){return void a.reject(e)}a.resolve(d);})}function e(a){try{if(a===this){ throw new TypeError("A promise cannot be resolved with itself."); }if(a&&("object"===typeof a||"function"===typeof a)){var c=a.then;if("function"===typeof c){ return void i(b(c,a),b(e,this),b(f,this)) }}this._state=!0,this._value=a,g.call(this);}catch(d){f.call(this,d);}}function f(a){this._state=!1,this._value=a,g.call(this);}function g(){
	        var this$1 = this;
	for(var a=0,b=this._deferreds.length;b>a;a++){ d.call(this$1,this$1._deferreds[a]); }this._deferreds=null;}function h(a,b,c,d){this.onFulfilled="function"===typeof a?a:null,this.onRejected="function"===typeof b?b:null,this.resolve=c,this.reject=d;}function i(a,b,c){var d=!1;try{a(function(a){d||(d=!0,b(a));},function(a){d||(d=!0,c(a));});}catch(e){if(d){ return; }d=!0,c(e);}}var j=setTimeout,k="function"===typeof setImmediate&&setImmediate||function(a){j(a,1);},l=Array.isArray||function(a){return "[object Array]"===Object.prototype.toString.call(a)};c.prototype["catch"]=function(a){return this.then(null,a)},c.prototype.then=function(a,b){var e=this;return new c(function(c,f){d.call(e,new h(a,b,c,f));})},c.all=function(){var a=Array.prototype.slice.call(1===arguments.length&&l(arguments[0])?arguments[0]:arguments);return new c(function(b,c){function d(f,g){try{if(g&&("object"===typeof g||"function"===typeof g)){var h=g.then;if("function"===typeof h){ return void h.call(g,function(a){d(f,a);},c) }}a[f]=g,0===--e&&b(a);}catch(i){c(i);}}if(0===a.length){ return b([]); }for(var e=a.length,f=0;f<a.length;f++){ d(f,a[f]); }})},c.resolve=function(a){return a&&"object"===typeof a&&a.constructor===c?a:new c(function(b){b(a);})},c.reject=function(a){return new c(function(b,c){c(a);})},c.race=function(a){return new c(function(b,c){for(var d=0,e=a.length;e>d;d++){ a[d].then(b,c); }})},c._setImmediateFn=function(a){k=a;},module.exports?module.exports=c:a.Promise||(a.Promise=c);}(this);
	    }

	    if (typeof window !== 'undefined' && typeof window.CustomEvent !== "function") {
	        (function(){
	            function CustomEvent ( event, params ) {
	                params = params || { bubbles: false, cancelable: false, detail: undefined };
	                var evt = document.createEvent( 'CustomEvent' );
	                evt.initCustomEvent( event, params.bubbles, params.cancelable, params.detail );
	                return evt;
	            }
	            CustomEvent.prototype = window.Event.prototype;
	            window.CustomEvent = CustomEvent;
	        }());
	    }

	    if (typeof HTMLCanvasElement !== 'undefined' && !HTMLCanvasElement.prototype.toBlob) {
	        Object.defineProperty(HTMLCanvasElement.prototype, 'toBlob', {
	            value: function (callback, type, quality) {
	                var binStr = atob( this.toDataURL(type, quality).split(',')[1] ),
	                len = binStr.length,
	                arr = new Uint8Array(len);

	                for (var i=0; i<len; i++ ) {
	                    arr[i] = binStr.charCodeAt(i);
	                }

	                callback( new Blob( [arr], {type: type || 'image/png'} ) );
	            }
	        });
	    }
	    /* End Polyfills */

	    var cssPrefixes = ['Webkit', 'Moz', 'ms'],
	        emptyStyles = typeof document !== 'undefined' ? document.createElement('div').style : {},
	        EXIF_NORM = [1,8,3,6],
	        EXIF_FLIP = [2,7,4,5],
	        CSS_TRANS_ORG,
	        CSS_TRANSFORM,
	        CSS_USERSELECT;

	    function vendorPrefix(prop) {
	        if (prop in emptyStyles) {
	            return prop;
	        }

	        var capProp = prop[0].toUpperCase() + prop.slice(1),
	            i = cssPrefixes.length;

	        while (i--) {
	            prop = cssPrefixes[i] + capProp;
	            if (prop in emptyStyles) {
	                return prop;
	            }
	        }
	    }

	    CSS_TRANSFORM = vendorPrefix('transform');
	    CSS_TRANS_ORG = vendorPrefix('transformOrigin');
	    CSS_USERSELECT = vendorPrefix('userSelect');

	    function getExifOffset(ornt, rotate) {
	        var arr = EXIF_NORM.indexOf(ornt) > -1 ? EXIF_NORM : EXIF_FLIP,
	            index = arr.indexOf(ornt),
	            offset = (rotate / 90) % arr.length;// 180 = 2%4 = 2 shift exif by 2 indexes

	        return arr[(arr.length + index + (offset % arr.length)) % arr.length];
	    }

	    // Credits to : Andrew Dupont - http://andrewdupont.net/2009/08/28/deep-extending-objects-in-javascript/
	    function deepExtend(destination, source) {
	        destination = destination || {};
	        for (var property in source) {
	            if (source[property] && source[property].constructor && source[property].constructor === Object) {
	                destination[property] = destination[property] || {};
	                deepExtend(destination[property], source[property]);
	            } else {
	                destination[property] = source[property];
	            }
	        }
	        return destination;
	    }

	    function clone(object) {
	        return deepExtend({}, object);
	    }

	    function debounce(func, wait, immediate) {
	        var timeout;
	        return function () {
	            var context = this, args = arguments;
	            var later = function () {
	                timeout = null;
	                if (!immediate) { func.apply(context, args); }
	            };
	            var callNow = immediate && !timeout;
	            clearTimeout(timeout);
	            timeout = setTimeout(later, wait);
	            if (callNow) { func.apply(context, args); }
	        };
	    }

	    function dispatchChange(element) {
	        if ("createEvent" in document) {
	            var evt = document.createEvent("HTMLEvents");
	            evt.initEvent("change", false, true);
	            element.dispatchEvent(evt);
	        }
	        else {
	            element.fireEvent("onchange");
	        }
	    }

	    //http://jsperf.com/vanilla-css
	    function css(el, styles, val) {
	        if (typeof (styles) === 'string') {
	            var tmp = styles;
	            styles = {};
	            styles[tmp] = val;
	        }

	        for (var prop in styles) {
	            el.style[prop] = styles[prop];
	        }
	    }

	    function addClass(el, c) {
	        if (el.classList) {
	            el.classList.add(c);
	        }
	        else {
	            el.className += ' ' + c;
	        }
	    }

	    function removeClass(el, c) {
	        if (el.classList) {
	            el.classList.remove(c);
	        }
	        else {
	            el.className = el.className.replace(c, '');
	        }
	    }

	    function setAttributes(el, attrs) {
	        for (var key in attrs) {
	            el.setAttribute(key, attrs[key]);
	        }
	    }

	    function num(v) {
	        return parseInt(v, 10);
	    }

	    /* Utilities */
	    function loadImage(src, doExif) {
	        if (!src) { throw 'Source image missing'; }
	        
	        var img = new Image();
	        img.style.opacity = '0';
	        return new Promise(function (resolve, reject) {
	            function _resolve() {
	                img.style.opacity = '1';
	                setTimeout(function () {
	                    resolve(img);
	                }, 1);
	            }

	            img.removeAttribute('crossOrigin');
	            if (src.match(/^https?:\/\/|^\/\//)) {
	                img.setAttribute('crossOrigin', 'anonymous');
	            }

	            img.onload = function () {
	                if (doExif) {
	                    EXIF.getData(img, function () {
	                        _resolve();
	                    });
	                }
	                else {
	                    _resolve();
	                }
	            };
	            img.onerror = function (ev) {
	                img.style.opacity = 1;
	                setTimeout(function () {
	                    reject(ev);
	                }, 1);
	            };
	            img.src = src;
	        });
	    }

	    function naturalImageDimensions(img, ornt) {
	        var w = img.naturalWidth;
	        var h = img.naturalHeight;
	        var orient = ornt || getExifOrientation(img);
	        if (orient && orient >= 5) {
	            var x= w;
	            w = h;
	            h = x;
	        }
	        return { width: w, height: h };
	    }

	    /* CSS Transform Prototype */
	    var TRANSLATE_OPTS = {
	        'translate3d': {
	            suffix: ', 0px'
	        },
	        'translate': {
	            suffix: ''
	        }
	    };
	    var Transform = function (x, y, scale) {
	        this.x = parseFloat(x);
	        this.y = parseFloat(y);
	        this.scale = parseFloat(scale);
	    };

	    Transform.parse = function (v) {
	        if (v.style) {
	            return Transform.parse(v.style[CSS_TRANSFORM]);
	        }
	        else if (v.indexOf('matrix') > -1 || v.indexOf('none') > -1) {
	            return Transform.fromMatrix(v);
	        }
	        else {
	            return Transform.fromString(v);
	        }
	    };

	    Transform.fromMatrix = function (v) {
	        var vals = v.substring(7).split(',');
	        if (!vals.length || v === 'none') {
	            vals = [1, 0, 0, 1, 0, 0];
	        }

	        return new Transform(num(vals[4]), num(vals[5]), parseFloat(vals[0]));
	    };

	    Transform.fromString = function (v) {
	        var values = v.split(') '),
	            translate = values[0].substring(Croppie.globals.translate.length + 1).split(','),
	            scale = values.length > 1 ? values[1].substring(6) : 1,
	            x = translate.length > 1 ? translate[0] : 0,
	            y = translate.length > 1 ? translate[1] : 0;

	        return new Transform(x, y, scale);
	    };

	    Transform.prototype.toString = function () {
	        var suffix = TRANSLATE_OPTS[Croppie.globals.translate].suffix || '';
	        return Croppie.globals.translate + '(' + this.x + 'px, ' + this.y + 'px' + suffix + ') scale(' + this.scale + ')';
	    };

	    var TransformOrigin = function (el) {
	        if (!el || !el.style[CSS_TRANS_ORG]) {
	            this.x = 0;
	            this.y = 0;
	            return;
	        }
	        var css = el.style[CSS_TRANS_ORG].split(' ');
	        this.x = parseFloat(css[0]);
	        this.y = parseFloat(css[1]);
	    };

	    TransformOrigin.prototype.toString = function () {
	        return this.x + 'px ' + this.y + 'px';
	    };

	    function getExifOrientation (img) {
	        return img.exifdata && img.exifdata.Orientation ? num(img.exifdata.Orientation) : 1;
	    }

	    function drawCanvas(canvas, img, orientation) {
	        var width = img.width,
	            height = img.height,
	            ctx = canvas.getContext('2d');

	        canvas.width = img.width;
	        canvas.height = img.height;

	        ctx.save();
	        switch (orientation) {
	          case 2:
	             ctx.translate(width, 0);
	             ctx.scale(-1, 1);
	             break;

	          case 3:
	              ctx.translate(width, height);
	              ctx.rotate(180*Math.PI/180);
	              break;

	          case 4:
	              ctx.translate(0, height);
	              ctx.scale(1, -1);
	              break;

	          case 5:
	              canvas.width = height;
	              canvas.height = width;
	              ctx.rotate(90*Math.PI/180);
	              ctx.scale(1, -1);
	              break;

	          case 6:
	              canvas.width = height;
	              canvas.height = width;
	              ctx.rotate(90*Math.PI/180);
	              ctx.translate(0, -height);
	              break;

	          case 7:
	              canvas.width = height;
	              canvas.height = width;
	              ctx.rotate(-90*Math.PI/180);
	              ctx.translate(-width, height);
	              ctx.scale(1, -1);
	              break;

	          case 8:
	              canvas.width = height;
	              canvas.height = width;
	              ctx.translate(0, width);
	              ctx.rotate(-90*Math.PI/180);
	              break;
	        }
	        ctx.drawImage(img, 0,0, width, height);
	        ctx.restore();
	    }

	    /* Private Methods */
	    function _create() {
	        var self = this,
	            contClass = 'croppie-container',
	            customViewportClass = self.options.viewport.type ? 'cr-vp-' + self.options.viewport.type : null,
	            boundary, img, viewport, overlay, bw, bh;

	        self.options.useCanvas = self.options.enableOrientation || _hasExif.call(self);
	        // Properties on class
	        self.data = {};
	        self.elements = {};

	        boundary = self.elements.boundary = document.createElement('div');
	        viewport = self.elements.viewport = document.createElement('div');
	        img = self.elements.img = document.createElement('img');
	        overlay = self.elements.overlay = document.createElement('div');

	        if (self.options.useCanvas) {
	            self.elements.canvas = document.createElement('canvas');
	            self.elements.preview = self.elements.canvas;
	        }
	        else {
	            self.elements.preview = img;
	        }

	        addClass(boundary, 'cr-boundary');
	        boundary.setAttribute('aria-dropeffect', 'none');
	        bw = self.options.boundary.width;
	        bh = self.options.boundary.height;
	        css(boundary, {
	            width: (bw + (isNaN(bw) ? '' : 'px')),
	            height: (bh + (isNaN(bh) ? '' : 'px'))
	        });

	        addClass(viewport, 'cr-viewport');
	        if (customViewportClass) {
	            addClass(viewport, customViewportClass);
	        }
	        css(viewport, {
	            width: self.options.viewport.width + 'px',
	            height: self.options.viewport.height + 'px'
	        });
	        viewport.setAttribute('tabindex', 0);

	        addClass(self.elements.preview, 'cr-image');
	        setAttributes(self.elements.preview, { 'alt': 'preview', 'aria-grabbed': 'false' });
	        addClass(overlay, 'cr-overlay');

	        self.element.appendChild(boundary);
	        boundary.appendChild(self.elements.preview);
	        boundary.appendChild(viewport);
	        boundary.appendChild(overlay);

	        addClass(self.element, contClass);
	        if (self.options.customClass) {
	            addClass(self.element, self.options.customClass);
	        }

	        _initDraggable.call(this);

	        if (self.options.enableZoom) {
	            _initializeZoom.call(self);
	        }

	        // if (self.options.enableOrientation) {
	        //     _initRotationControls.call(self);
	        // }

	        if (self.options.enableResize) {
	            _initializeResize.call(self);
	        }
	    }

	    // function _initRotationControls () {
	    //     var self = this,
	    //         wrap, btnLeft, btnRight, iLeft, iRight;

	    //     wrap = document.createElement('div');
	    //     self.elements.orientationBtnLeft = btnLeft = document.createElement('button');
	    //     self.elements.orientationBtnRight = btnRight = document.createElement('button');

	    //     wrap.appendChild(btnLeft);
	    //     wrap.appendChild(btnRight);

	    //     iLeft = document.createElement('i');
	    //     iRight = document.createElement('i');
	    //     btnLeft.appendChild(iLeft);
	    //     btnRight.appendChild(iRight);

	    //     addClass(wrap, 'cr-rotate-controls');
	    //     addClass(btnLeft, 'cr-rotate-l');
	    //     addClass(btnRight, 'cr-rotate-r');

	    //     self.elements.boundary.appendChild(wrap);

	    //     btnLeft.addEventListener('click', function () {
	    //         self.rotate(-90);
	    //     });
	    //     btnRight.addEventListener('click', function () {
	    //         self.rotate(90);
	    //     });
	    // }

	    function _hasExif() {
	        return this.options.enableExif && window.EXIF;
	    }

	    function _initializeResize () {
	        var self = this;
	        var wrap = document.createElement('div');
	        var isDragging = false;
	        var direction;
	        var originalX;
	        var originalY;
	        var minSize = 50;
	        var maxWidth;
	        var maxHeight;
	        var vr;
	        var hr;

	        addClass(wrap, 'cr-resizer');
	        css(wrap, {
	            width: this.options.viewport.width + 'px',
	            height: this.options.viewport.height + 'px'
	        });

	        if (this.options.resizeControls.height) {
	            vr = document.createElement('div');
	            addClass(vr, 'cr-resizer-vertical');
	            wrap.appendChild(vr);
	        }

	        if (this.options.resizeControls.width) {
	            hr = document.createElement('div');
	            addClass(hr, 'cr-resizer-horisontal');
	            wrap.appendChild(hr);
	        }

	        function mouseDown(ev) {
	            if (ev.button !== undefined && ev.button !== 0) { return; }

	            ev.preventDefault();
	            if (isDragging) {
	                return;
	            }

	            var overlayRect = self.elements.overlay.getBoundingClientRect();

	            isDragging = true;
	            originalX = ev.pageX;
	            originalY = ev.pageY;
	            direction = ev.currentTarget.className.indexOf('vertical') !== -1 ? 'v' : 'h';
	            maxWidth = overlayRect.width;
	            maxHeight = overlayRect.height;

	            if (ev.touches) {
	                var touches = ev.touches[0];
	                originalX = touches.pageX;
	                originalY = touches.pageY;
	            }

	            window.addEventListener('mousemove', mouseMove);
	            window.addEventListener('touchmove', mouseMove);
	            window.addEventListener('mouseup', mouseUp);
	            window.addEventListener('touchend', mouseUp);
	            document.body.style[CSS_USERSELECT] = 'none';
	        }

	        function mouseMove(ev) {
	            var pageX = ev.pageX;
	            var pageY = ev.pageY;

	            ev.preventDefault();

	            if (ev.touches) {
	                var touches = ev.touches[0];
	                pageX = touches.pageX;
	                pageY = touches.pageY;
	            }

	            var deltaX = pageX - originalX;
	            var deltaY = pageY - originalY;
	            var newHeight = self.options.viewport.height + deltaY;
	            var newWidth = self.options.viewport.width + deltaX;

	            if (direction === 'v' && newHeight >= minSize && newHeight <= maxHeight) {
	                css(wrap, {
	                    height: newHeight + 'px'
	                });

	                self.options.boundary.height += deltaY;
	                css(self.elements.boundary, {
	                    height: self.options.boundary.height + 'px'
	                });

	                self.options.viewport.height += deltaY;
	                css(self.elements.viewport, {
	                    height: self.options.viewport.height + 'px'
	                });
	            }
	            else if (direction === 'h' && newWidth >= minSize && newWidth <= maxWidth) {
	                css(wrap, {
	                    width: newWidth + 'px'
	                });

	                self.options.boundary.width += deltaX;
	                css(self.elements.boundary, {
	                    width: self.options.boundary.width + 'px'
	                });

	                self.options.viewport.width += deltaX;
	                css(self.elements.viewport, {
	                    width: self.options.viewport.width + 'px'
	                });
	            }

	            _updateOverlay.call(self);
	            _updateZoomLimits.call(self);
	            _updateCenterPoint.call(self);
	            _triggerUpdate.call(self);
	            originalY = pageY;
	            originalX = pageX;
	        }

	        function mouseUp() {
	            isDragging = false;
	            window.removeEventListener('mousemove', mouseMove);
	            window.removeEventListener('touchmove', mouseMove);
	            window.removeEventListener('mouseup', mouseUp);
	            window.removeEventListener('touchend', mouseUp);
	            document.body.style[CSS_USERSELECT] = '';
	        }

	        if (vr) {
	            vr.addEventListener('mousedown', mouseDown);
	            vr.addEventListener('touchstart', mouseDown);
	        }

	        if (hr) {
	            hr.addEventListener('mousedown', mouseDown);
	            hr.addEventListener('touchstart', mouseDown);
	        }

	        this.elements.boundary.appendChild(wrap);
	    }

	    function _setZoomerVal(v) {
	        if (this.options.enableZoom) {
	            var z = this.elements.zoomer,
	                val = fix(v, 4);

	            z.value = Math.max(parseFloat(z.min), Math.min(parseFloat(z.max), val)).toString();
	        }
	    }

	    function _initializeZoom() {
	        var self = this,
	            wrap = self.elements.zoomerWrap = document.createElement('div'),
	            zoomer = self.elements.zoomer = document.createElement('input');

	        addClass(wrap, 'cr-slider-wrap');
	        addClass(zoomer, 'cr-slider');
	        zoomer.type = 'range';
	        zoomer.step = '0.0001';
	        zoomer.value = '1';
	        zoomer.style.display = self.options.showZoomer ? '' : 'none';
	        zoomer.setAttribute('aria-label', 'zoom');

	        self.element.appendChild(wrap);
	        wrap.appendChild(zoomer);

	        self._currentZoom = 1;

	        function change() {
	            _onZoom.call(self, {
	                value: parseFloat(zoomer.value),
	                origin: new TransformOrigin(self.elements.preview),
	                viewportRect: self.elements.viewport.getBoundingClientRect(),
	                transform: Transform.parse(self.elements.preview)
	            });
	        }

	        function scroll(ev) {
	            var delta, targetZoom;

	            if(self.options.mouseWheelZoom === 'ctrl' && ev.ctrlKey !== true){
	              return 0;
	            } else if (ev.wheelDelta) {
	                delta = ev.wheelDelta / 1200; //wheelDelta min: -120 max: 120 // max x 10 x 2
	            } else if (ev.deltaY) {
	                delta = ev.deltaY / 1060; //deltaY min: -53 max: 53 // max x 10 x 2
	            } else if (ev.detail) {
	                delta = ev.detail / -60; //delta min: -3 max: 3 // max x 10 x 2
	            } else {
	                delta = 0;
	            }

	            targetZoom = self._currentZoom + (delta * self._currentZoom);

	            ev.preventDefault();
	            _setZoomerVal.call(self, targetZoom);
	            change.call(self);
	        }

	        self.elements.zoomer.addEventListener('input', change);// this is being fired twice on keypress
	        self.elements.zoomer.addEventListener('change', change);

	        if (self.options.mouseWheelZoom) {
	            self.elements.boundary.addEventListener('mousewheel', scroll);
	            self.elements.boundary.addEventListener('DOMMouseScroll', scroll);
	        }
	    }

	    function _onZoom(ui) {
	        var self = this,
	            transform = ui ? ui.transform : Transform.parse(self.elements.preview),
	            vpRect = ui ? ui.viewportRect : self.elements.viewport.getBoundingClientRect(),
	            origin = ui ? ui.origin : new TransformOrigin(self.elements.preview);

	        function applyCss() {
	            var transCss = {};
	            transCss[CSS_TRANSFORM] = transform.toString();
	            transCss[CSS_TRANS_ORG] = origin.toString();
	            css(self.elements.preview, transCss);
	        }

	        self._currentZoom = ui ? ui.value : self._currentZoom;
	        transform.scale = self._currentZoom;
	        self.elements.zoomer.setAttribute('aria-valuenow', self._currentZoom);
	        applyCss();

	        if (self.options.enforceBoundary) {
	            var boundaries = _getVirtualBoundaries.call(self, vpRect),
	                transBoundaries = boundaries.translate,
	                oBoundaries = boundaries.origin;

	            if (transform.x >= transBoundaries.maxX) {
	                origin.x = oBoundaries.minX;
	                transform.x = transBoundaries.maxX;
	            }

	            if (transform.x <= transBoundaries.minX) {
	                origin.x = oBoundaries.maxX;
	                transform.x = transBoundaries.minX;
	            }

	            if (transform.y >= transBoundaries.maxY) {
	                origin.y = oBoundaries.minY;
	                transform.y = transBoundaries.maxY;
	            }

	            if (transform.y <= transBoundaries.minY) {
	                origin.y = oBoundaries.maxY;
	                transform.y = transBoundaries.minY;
	            }
	        }
	        applyCss();
	        _debouncedOverlay.call(self);
	        _triggerUpdate.call(self);
	    }

	    function _getVirtualBoundaries(viewport) {
	        var self = this,
	            scale = self._currentZoom,
	            vpWidth = viewport.width,
	            vpHeight = viewport.height,
	            centerFromBoundaryX = self.elements.boundary.clientWidth / 2,
	            centerFromBoundaryY = self.elements.boundary.clientHeight / 2,
	            imgRect = self.elements.preview.getBoundingClientRect(),
	            curImgWidth = imgRect.width,
	            curImgHeight = imgRect.height,
	            halfWidth = vpWidth / 2,
	            halfHeight = vpHeight / 2;

	        var maxX = ((halfWidth / scale) - centerFromBoundaryX) * -1;
	        var minX = maxX - ((curImgWidth * (1 / scale)) - (vpWidth * (1 / scale)));

	        var maxY = ((halfHeight / scale) - centerFromBoundaryY) * -1;
	        var minY = maxY - ((curImgHeight * (1 / scale)) - (vpHeight * (1 / scale)));

	        var originMinX = (1 / scale) * halfWidth;
	        var originMaxX = (curImgWidth * (1 / scale)) - originMinX;

	        var originMinY = (1 / scale) * halfHeight;
	        var originMaxY = (curImgHeight * (1 / scale)) - originMinY;

	        return {
	            translate: {
	                maxX: maxX,
	                minX: minX,
	                maxY: maxY,
	                minY: minY
	            },
	            origin: {
	                maxX: originMaxX,
	                minX: originMinX,
	                maxY: originMaxY,
	                minY: originMinY
	            }
	        };
	    }

	    function _updateCenterPoint(rotate) {
	        var self = this,
	            scale = self._currentZoom,
	            data = self.elements.preview.getBoundingClientRect(),
	            vpData = self.elements.viewport.getBoundingClientRect(),
	            transform = Transform.parse(self.elements.preview.style[CSS_TRANSFORM]),
	            pc = new TransformOrigin(self.elements.preview),
	            top = (vpData.top - data.top) + (vpData.height / 2),
	            left = (vpData.left - data.left) + (vpData.width / 2),
	            center = {},
	            adj = {};

	        if (rotate) {
	            var cx = pc.x;
	            var cy = pc.y;
	            var tx = transform.x;
	            var ty = transform.y;

	            center.y = cx;
	            center.x = cy;
	            transform.y = tx;
	            transform.x = ty;
	        }
	        else {
	            center.y = top / scale;
	            center.x = left / scale;

	            adj.y = (center.y - pc.y) * (1 - scale);
	            adj.x = (center.x - pc.x) * (1 - scale);

	            transform.x -= adj.x;
	            transform.y -= adj.y;
	        }

	        var newCss = {};
	        newCss[CSS_TRANS_ORG] = center.x + 'px ' + center.y + 'px';
	        newCss[CSS_TRANSFORM] = transform.toString();
	        css(self.elements.preview, newCss);
	    }

	    function _initDraggable() {
	        var self = this,
	            isDragging = false,
	            originalX,
	            originalY,
	            originalDistance,
	            vpRect,
	            transform;

	        function assignTransformCoordinates(deltaX, deltaY) {
	            var imgRect = self.elements.preview.getBoundingClientRect(),
	                top = transform.y + deltaY,
	                left = transform.x + deltaX;

	            if (self.options.enforceBoundary) {
	                if (vpRect.top > imgRect.top + deltaY && vpRect.bottom < imgRect.bottom + deltaY) {
	                    transform.y = top;
	                }

	                if (vpRect.left > imgRect.left + deltaX && vpRect.right < imgRect.right + deltaX) {
	                    transform.x = left;
	                }
	            }
	            else {
	                transform.y = top;
	                transform.x = left;
	            }
	        }

	        function toggleGrabState(isDragging) {
	          self.elements.preview.setAttribute('aria-grabbed', isDragging);
	          self.elements.boundary.setAttribute('aria-dropeffect', isDragging? 'move': 'none');
	        }

	        function keyDown(ev) {
	            var LEFT_ARROW  = 37,
	                UP_ARROW    = 38,
	                RIGHT_ARROW = 39,
	                DOWN_ARROW  = 40;

	            if (ev.shiftKey && (ev.keyCode === UP_ARROW || ev.keyCode === DOWN_ARROW)) {
	                var zoom;
	                if (ev.keyCode === UP_ARROW) {
	                    zoom = parseFloat(self.elements.zoomer.value) + parseFloat(self.elements.zoomer.step);
	                }
	                else {
	                    zoom = parseFloat(self.elements.zoomer.value) - parseFloat(self.elements.zoomer.step);
	                }
	                self.setZoom(zoom);
	            }
	            else if (self.options.enableKeyMovement && (ev.keyCode >= 37 && ev.keyCode <= 40)) {
	                ev.preventDefault();
	                var movement = parseKeyDown(ev.keyCode);

	                transform = Transform.parse(self.elements.preview);
	                document.body.style[CSS_USERSELECT] = 'none';
	                vpRect = self.elements.viewport.getBoundingClientRect();
	                keyMove(movement);
	            }

	            function parseKeyDown(key) {
	                switch (key) {
	                    case LEFT_ARROW:
	                        return [1, 0];
	                    case UP_ARROW:
	                        return [0, 1];
	                    case RIGHT_ARROW:
	                        return [-1, 0];
	                    case DOWN_ARROW:
	                        return [0, -1];
	                }
	            }
	        }

	        function keyMove(movement) {
	            var deltaX = movement[0],
	                deltaY = movement[1],
	                newCss = {};

	            assignTransformCoordinates(deltaX, deltaY);

	            newCss[CSS_TRANSFORM] = transform.toString();
	            css(self.elements.preview, newCss);
	            _updateOverlay.call(self);
	            document.body.style[CSS_USERSELECT] = '';
	            _updateCenterPoint.call(self);
	            _triggerUpdate.call(self);
	            originalDistance = 0;
	        }

	        function mouseDown(ev) {
	            if (ev.button !== undefined && ev.button !== 0) { return; }

	            ev.preventDefault();
	            if (isDragging) { return; }
	            isDragging = true;
	            originalX = ev.pageX;
	            originalY = ev.pageY;

	            if (ev.touches) {
	                var touches = ev.touches[0];
	                originalX = touches.pageX;
	                originalY = touches.pageY;
	            }
	            toggleGrabState(isDragging);
	            transform = Transform.parse(self.elements.preview);
	            window.addEventListener('mousemove', mouseMove);
	            window.addEventListener('touchmove', mouseMove);
	            window.addEventListener('mouseup', mouseUp);
	            window.addEventListener('touchend', mouseUp);
	            document.body.style[CSS_USERSELECT] = 'none';
	            vpRect = self.elements.viewport.getBoundingClientRect();
	        }

	        function mouseMove(ev) {
	            ev.preventDefault();
	            var pageX = ev.pageX,
	                pageY = ev.pageY;

	            if (ev.touches) {
	                var touches = ev.touches[0];
	                pageX = touches.pageX;
	                pageY = touches.pageY;
	            }

	            var deltaX = pageX - originalX,
	                deltaY = pageY - originalY,
	                newCss = {};

	            if (ev.type === 'touchmove') {
	                if (ev.touches.length > 1) {
	                    var touch1 = ev.touches[0];
	                    var touch2 = ev.touches[1];
	                    var dist = Math.sqrt((touch1.pageX - touch2.pageX) * (touch1.pageX - touch2.pageX) + (touch1.pageY - touch2.pageY) * (touch1.pageY - touch2.pageY));

	                    if (!originalDistance) {
	                        originalDistance = dist / self._currentZoom;
	                    }

	                    var scale = dist / originalDistance;

	                    _setZoomerVal.call(self, scale);
	                    dispatchChange(self.elements.zoomer);
	                    return;
	                }
	            }

	            assignTransformCoordinates(deltaX, deltaY);

	            newCss[CSS_TRANSFORM] = transform.toString();
	            css(self.elements.preview, newCss);
	            _updateOverlay.call(self);
	            originalY = pageY;
	            originalX = pageX;
	        }

	        function mouseUp() {
	            isDragging = false;
	            toggleGrabState(isDragging);
	            window.removeEventListener('mousemove', mouseMove);
	            window.removeEventListener('touchmove', mouseMove);
	            window.removeEventListener('mouseup', mouseUp);
	            window.removeEventListener('touchend', mouseUp);
	            document.body.style[CSS_USERSELECT] = '';
	            _updateCenterPoint.call(self);
	            _triggerUpdate.call(self);
	            originalDistance = 0;
	        }

	        self.elements.overlay.addEventListener('mousedown', mouseDown);
	        self.elements.viewport.addEventListener('keydown', keyDown);
	        self.elements.overlay.addEventListener('touchstart', mouseDown);
	    }

	    function _updateOverlay() {
	        if (!this.elements) { return; } // since this is debounced, it can be fired after destroy
	        var self = this,
	            boundRect = self.elements.boundary.getBoundingClientRect(),
	            imgData = self.elements.preview.getBoundingClientRect();

	        css(self.elements.overlay, {
	            width: imgData.width + 'px',
	            height: imgData.height + 'px',
	            top: (imgData.top - boundRect.top) + 'px',
	            left: (imgData.left - boundRect.left) + 'px'
	        });
	    }
	    var _debouncedOverlay = debounce(_updateOverlay, 500);

	    function _triggerUpdate() {
	        var self = this,
	            data = self.get();

	        if (!_isVisible.call(self)) {
	            return;
	        }

	        self.options.update.call(self, data);
	        if (self.$ && typeof Prototype === 'undefined') {
	            self.$(self.element).trigger('update.croppie', data);
	        }
	        else {
	            var ev;
	            if (window.CustomEvent) {
	                ev = new CustomEvent('update', { detail: data });
	            } else {
	                ev = document.createEvent('CustomEvent');
	                ev.initCustomEvent('update', true, true, data);
	            }

	            self.element.dispatchEvent(ev);
	        }
	    }

	    function _isVisible() {
	        return this.elements.preview.offsetHeight > 0 && this.elements.preview.offsetWidth > 0;
	    }

	    function _updatePropertiesFromImage() {
	        var self = this,
	            initialZoom = 1,
	            cssReset = {},
	            img = self.elements.preview,
	            imgData,
	            transformReset = new Transform(0, 0, initialZoom),
	            originReset = new TransformOrigin(),
	            isVisible = _isVisible.call(self);

	        if (!isVisible || self.data.bound) {// if the croppie isn't visible or it doesn't need binding
	            return;
	        }

	        self.data.bound = true;
	        cssReset[CSS_TRANSFORM] = transformReset.toString();
	        cssReset[CSS_TRANS_ORG] = originReset.toString();
	        cssReset['opacity'] = 1;
	        css(img, cssReset);

	        imgData = self.elements.preview.getBoundingClientRect();

	        self._originalImageWidth = imgData.width;
	        self._originalImageHeight = imgData.height;
	        self.data.orientation = _hasExif.call(self) ? getExifOrientation(self.elements.img) : self.data.orientation;

	        if (self.options.enableZoom) {
	            _updateZoomLimits.call(self, true);
	        }
	        else {
	            self._currentZoom = initialZoom;
	        }

	        transformReset.scale = self._currentZoom;
	        cssReset[CSS_TRANSFORM] = transformReset.toString();
	        css(img, cssReset);

	        if (self.data.points.length) {
	            _bindPoints.call(self, self.data.points);
	        }
	        else {
	            _centerImage.call(self);
	        }

	        _updateCenterPoint.call(self);
	        _updateOverlay.call(self);
	    }

	    function _updateZoomLimits (initial) {
	        var self = this,
	            minZoom = Math.max(self.options.minZoom, 0) || 0,
	            maxZoom = self.options.maxZoom || 1.5,
	            initialZoom,
	            defaultInitialZoom,
	            zoomer = self.elements.zoomer,
	            scale = parseFloat(zoomer.value),
	            boundaryData = self.elements.boundary.getBoundingClientRect(),
	            imgData = naturalImageDimensions(self.elements.img, self.data.orientation),
	            vpData = self.elements.viewport.getBoundingClientRect(),
	            minW,
	            minH;
	        if (self.options.enforceBoundary) {
	            minW = vpData.width / imgData.width;
	            minH = vpData.height / imgData.height;
	            minZoom = Math.max(minW, minH);
	        }

	        if (minZoom >= maxZoom) {
	            maxZoom = minZoom + 1;
	        }

	        zoomer.min = fix(minZoom, 4);
	        zoomer.max = fix(maxZoom, 4);

	        if (!initial && (scale < zoomer.min || scale > zoomer.max)) {
	            _setZoomerVal.call(self, scale < zoomer.min ? zoomer.min : zoomer.max);
	        }
	        else if (initial) {
	            defaultInitialZoom = Math.max((boundaryData.width / imgData.width), (boundaryData.height / imgData.height));
	            initialZoom = self.data.boundZoom !== null ? self.data.boundZoom : defaultInitialZoom;
	            _setZoomerVal.call(self, initialZoom);
	        }

	        dispatchChange(zoomer);
	    }

	    function _bindPoints(points) {
	        if (points.length !== 4) {
	            throw "Croppie - Invalid number of points supplied: " + points;
	        }
	        var self = this,
	            pointsWidth = points[2] - points[0],
	            // pointsHeight = points[3] - points[1],
	            vpData = self.elements.viewport.getBoundingClientRect(),
	            boundRect = self.elements.boundary.getBoundingClientRect(),
	            vpOffset = {
	                left: vpData.left - boundRect.left,
	                top: vpData.top - boundRect.top
	            },
	            scale = vpData.width / pointsWidth,
	            originTop = points[1],
	            originLeft = points[0],
	            transformTop = (-1 * points[1]) + vpOffset.top,
	            transformLeft = (-1 * points[0]) + vpOffset.left,
	            newCss = {};

	        newCss[CSS_TRANS_ORG] = originLeft + 'px ' + originTop + 'px';
	        newCss[CSS_TRANSFORM] = new Transform(transformLeft, transformTop, scale).toString();
	        css(self.elements.preview, newCss);

	        _setZoomerVal.call(self, scale);
	        self._currentZoom = scale;
	    }

	    function _centerImage() {
	        var self = this,
	            imgDim = self.elements.preview.getBoundingClientRect(),
	            vpDim = self.elements.viewport.getBoundingClientRect(),
	            boundDim = self.elements.boundary.getBoundingClientRect(),
	            vpLeft = vpDim.left - boundDim.left,
	            vpTop = vpDim.top - boundDim.top,
	            w = vpLeft - ((imgDim.width - vpDim.width) / 2),
	            h = vpTop - ((imgDim.height - vpDim.height) / 2),
	            transform = new Transform(w, h, self._currentZoom);

	        css(self.elements.preview, CSS_TRANSFORM, transform.toString());
	    }

	    function _transferImageToCanvas(customOrientation) {
	        var self = this,
	            canvas = self.elements.canvas,
	            img = self.elements.img,
	            ctx = canvas.getContext('2d');

	        ctx.clearRect(0, 0, canvas.width, canvas.height);
	        canvas.width = img.width;
	        canvas.height = img.height;

	        var orientation = self.options.enableOrientation && customOrientation || getExifOrientation(img);
	        drawCanvas(canvas, img, orientation);
	    }

	    function _getCanvas(data) {
	        var self = this,
	            points = data.points,
	            left = num(points[0]),
	            top = num(points[1]),
	            right = num(points[2]),
	            bottom = num(points[3]),
	            width = right-left,
	            height = bottom-top,
	            circle = data.circle,
	            canvas = document.createElement('canvas'),
	            ctx = canvas.getContext('2d'),
	            canvasWidth = data.outputWidth || width,
	            canvasHeight = data.outputHeight || height;

	        canvas.width = canvasWidth;
	        canvas.height = canvasHeight;

	        if (data.backgroundColor) {
	            ctx.fillStyle = data.backgroundColor;
	            ctx.fillRect(0, 0, canvasWidth, canvasHeight);
	        }

	        // By default assume we're going to draw the entire
	        // source image onto the destination canvas.
	        var sx = left,
	            sy = top,
	            sWidth = width,
	            sHeight = height,
	            dx = 0,
	            dy = 0,
	            dWidth = canvasWidth,
	            dHeight = canvasHeight;

	        //
	        // Do not go outside of the original image's bounds along the x-axis.
	        // Handle translations when projecting onto the destination canvas.
	        //

	        // The smallest possible source x-position is 0.
	        if (left < 0) {
	            sx = 0;
	            dx = (Math.abs(left) / width) * canvasWidth;
	        }

	        // The largest possible source width is the original image's width.
	        if (sWidth + sx > self._originalImageWidth) {
	            sWidth = self._originalImageWidth - sx;
	            dWidth =  (sWidth / width) * canvasWidth;
	        }

	        //
	        // Do not go outside of the original image's bounds along the y-axis.
	        //

	        // The smallest possible source y-position is 0.
	        if (top < 0) {
	            sy = 0;
	            dy = (Math.abs(top) / height) * canvasHeight;
	        }

	        // The largest possible source height is the original image's height.
	        if (sHeight + sy > self._originalImageHeight) {
	            sHeight = self._originalImageHeight - sy;
	            dHeight = (sHeight / height) * canvasHeight;
	        }

	        // console.table({ left, right, top, bottom, canvasWidth, canvasHeight, width, height, startX, startY, circle, sx, sy, dx, dy, sWidth, sHeight, dWidth, dHeight });

	        ctx.drawImage(this.elements.preview, sx, sy, sWidth, sHeight, dx, dy, dWidth, dHeight);
	        if (circle) {
	            ctx.fillStyle = '#fff';
	            ctx.globalCompositeOperation = 'destination-in';
	            ctx.beginPath();
	            ctx.arc(canvas.width / 2, canvas.height / 2, canvas.width / 2, 0, Math.PI * 2, true);
	            ctx.closePath();
	            ctx.fill();
	        }
	        return canvas;
	    }

	    function _getHtmlResult(data) {
	        var points = data.points,
	            div = document.createElement('div'),
	            img = document.createElement('img'),
	            width = points[2] - points[0],
	            height = points[3] - points[1];

	        addClass(div, 'croppie-result');
	        div.appendChild(img);
	        css(img, {
	            left: (-1 * points[0]) + 'px',
	            top: (-1 * points[1]) + 'px'
	        });
	        img.src = data.url;
	        css(div, {
	            width: width + 'px',
	            height: height + 'px'
	        });

	        return div;
	    }

	    function _getBase64Result(data) {
	        return _getCanvas.call(this, data).toDataURL(data.format, data.quality);
	    }

	    function _getBlobResult(data) {
	        var self = this;
	        return new Promise(function (resolve) {
	            _getCanvas.call(self, data).toBlob(function (blob) {
	                resolve(blob);
	            }, data.format, data.quality);
	        });
	    }

	    function _replaceImage(img) {
	        if (this.elements.img.parentNode) {
	            Array.prototype.forEach.call(this.elements.img.classList, function(c) { img.classList.add(c); });
	            this.elements.img.parentNode.replaceChild(img, this.elements.img);
	            this.elements.preview = img; // if the img is attached to the DOM, they're not using the canvas
	        }
	        this.elements.img = img;
	    }

	    function _bind(options, cb) {
	        var self = this,
	            url,
	            points = [],
	            zoom = null,
	            hasExif = _hasExif.call(self);

	        if (typeof (options) === 'string') {
	            url = options;
	            options = {};
	        }
	        else if (Array.isArray(options)) {
	            points = options.slice();
	        }
	        else if (typeof (options) === 'undefined' && self.data.url) { //refreshing
	            _updatePropertiesFromImage.call(self);
	            _triggerUpdate.call(self);
	            return null;
	        }
	        else {
	            url = options.url;
	            points = options.points || [];
	            zoom = typeof(options.zoom) === 'undefined' ? null : options.zoom;
	        }

	        self.data.bound = false;
	        self.data.url = url || self.data.url;
	        self.data.boundZoom = zoom;

	        return loadImage(url, hasExif).then(function (img) {
	            _replaceImage.call(self, img);
	            if (!points.length) {
	                var natDim = naturalImageDimensions(img);
	                var rect = self.elements.viewport.getBoundingClientRect();
	                var aspectRatio = rect.width / rect.height;
	                var imgAspectRatio = natDim.width / natDim.height;
	                var width, height;

	                if (imgAspectRatio > aspectRatio) {
	                    height = natDim.height;
	                    width = height * aspectRatio;
	                }
	                else {
	                    width = natDim.width;
	                    height = natDim.height / aspectRatio;
	                }

	                var x0 = (natDim.width - width) / 2;
	                var y0 = (natDim.height - height) / 2;
	                var x1 = x0 + width;
	                var y1 = y0 + height;
	                self.data.points = [x0, y0, x1, y1];
	            }
	            else if (self.options.relative) {
	                points = [
	                    points[0] * img.naturalWidth / 100,
	                    points[1] * img.naturalHeight / 100,
	                    points[2] * img.naturalWidth / 100,
	                    points[3] * img.naturalHeight / 100
	                ];
	            }

	            self.data.orientation = options.orientation || 1;
	            self.data.points = points.map(function (p) {
	                return parseFloat(p);
	            });
	            if (self.options.useCanvas) {
	                _transferImageToCanvas.call(self, self.data.orientation);
	            }
	            _updatePropertiesFromImage.call(self);
	            _triggerUpdate.call(self);
	            cb && cb();
	        });
	    }

	    function fix(v, decimalPoints) {
	        return parseFloat(v).toFixed(decimalPoints || 0);
	    }

	    function _get() {
	        var self = this,
	            imgData = self.elements.preview.getBoundingClientRect(),
	            vpData = self.elements.viewport.getBoundingClientRect(),
	            x1 = vpData.left - imgData.left,
	            y1 = vpData.top - imgData.top,
	            widthDiff = (vpData.width - self.elements.viewport.offsetWidth) / 2, //border
	            heightDiff = (vpData.height - self.elements.viewport.offsetHeight) / 2,
	            x2 = x1 + self.elements.viewport.offsetWidth + widthDiff,
	            y2 = y1 + self.elements.viewport.offsetHeight + heightDiff,
	            scale = self._currentZoom;

	        if (scale === Infinity || isNaN(scale)) {
	            scale = 1;
	        }

	        var max = self.options.enforceBoundary ? 0 : Number.NEGATIVE_INFINITY;
	        x1 = Math.max(max, x1 / scale);
	        y1 = Math.max(max, y1 / scale);
	        x2 = Math.max(max, x2 / scale);
	        y2 = Math.max(max, y2 / scale);

	        return {
	            points: [fix(x1), fix(y1), fix(x2), fix(y2)],
	            zoom: scale,
	            orientation: self.data.orientation
	        };
	    }

	    var RESULT_DEFAULTS = {
	            type: 'canvas',
	            format: 'png',
	            quality: 1
	        },
	        RESULT_FORMATS = ['jpeg', 'webp', 'png'];

	    function _result(options) {
	        var self = this,
	            data = _get.call(self),
	            opts = deepExtend(clone(RESULT_DEFAULTS), clone(options)),
	            resultType = (typeof (options) === 'string' ? options : (opts.type || 'base64')),
	            size = opts.size || 'viewport',
	            format = opts.format,
	            quality = opts.quality,
	            backgroundColor = opts.backgroundColor,
	            circle = typeof opts.circle === 'boolean' ? opts.circle : (self.options.viewport.type === 'circle'),
	            vpRect = self.elements.viewport.getBoundingClientRect(),
	            ratio = vpRect.width / vpRect.height,
	            prom;

	        if (size === 'viewport') {
	            data.outputWidth = vpRect.width;
	            data.outputHeight = vpRect.height;
	        } else if (typeof size === 'object') {
	            if (size.width && size.height) {
	                data.outputWidth = size.width;
	                data.outputHeight = size.height;
	            } else if (size.width) {
	                data.outputWidth = size.width;
	                data.outputHeight = size.width / ratio;
	            } else if (size.height) {
	                data.outputWidth = size.height * ratio;
	                data.outputHeight = size.height;
	            }
	        }

	        if (RESULT_FORMATS.indexOf(format) > -1) {
	            data.format = 'image/' + format;
	            data.quality = quality;
	        }

	        data.circle = circle;
	        data.url = self.data.url;
	        data.backgroundColor = backgroundColor;

	        prom = new Promise(function (resolve) {
	            switch(resultType.toLowerCase())
	            {
	                case 'rawcanvas':
	                    resolve(_getCanvas.call(self, data));
	                    break;
	                case 'canvas':
	                case 'base64':
	                    resolve(_getBase64Result.call(self, data));
	                    break;
	                case 'blob':
	                    _getBlobResult.call(self, data).then(resolve);
	                    break;
	                default:
	                    resolve(_getHtmlResult.call(self, data));
	                    break;
	            }
	        });
	        return prom;
	    }

	    function _refresh() {
	        _updatePropertiesFromImage.call(this);
	    }

	    function _rotate(deg) {
	        if (!this.options.useCanvas || !this.options.enableOrientation) {
	            throw 'Croppie: Cannot rotate without enableOrientation && EXIF.js included';
	        }

	        var self = this,
	            canvas = self.elements.canvas;

	        self.data.orientation = getExifOffset(self.data.orientation, deg);
	        drawCanvas(canvas, self.elements.img, self.data.orientation);
	        _updateCenterPoint.call(self, true);
	        _updateZoomLimits.call(self);

	        // Reverses image dimensions if the degrees of rotation is not divisible by 180.
	        if ((Math.abs(deg) / 90) % 2 === 1) {
	            var oldHeight = self._originalImageHeight;
	            var oldWidth = self._originalImageWidth;
	            self._originalImageWidth = oldHeight;
	            self._originalImageHeight = oldWidth;
	        }
	    }

	    function _destroy() {
	        var self = this;
	        self.element.removeChild(self.elements.boundary);
	        removeClass(self.element, 'croppie-container');
	        if (self.options.enableZoom) {
	            self.element.removeChild(self.elements.zoomerWrap);
	        }
	        delete self.elements;
	    }

	    if (typeof window !== 'undefined' && window.jQuery) {
	        var $ = window.jQuery;
	        $.fn.croppie = function (opts) {
	            var ot = typeof opts;

	            if (ot === 'string') {
	                var args = Array.prototype.slice.call(arguments, 1);
	                var singleInst = $(this).data('croppie');

	                if (opts === 'get') {
	                    return singleInst.get();
	                }
	                else if (opts === 'result') {
	                    return singleInst.result.apply(singleInst, args);
	                }
	                else if (opts === 'bind') {
	                    return singleInst.bind.apply(singleInst, args);
	                }

	                return this.each(function () {
	                    var i = $(this).data('croppie');
	                    if (!i) { return; }

	                    var method = i[opts];
	                    if ($.isFunction(method)) {
	                        method.apply(i, args);
	                        if (opts === 'destroy') {
	                            $(this).removeData('croppie');
	                        }
	                    }
	                    else {
	                        throw 'Croppie ' + opts + ' method not found';
	                    }
	                });
	            }
	            else {
	                return this.each(function () {
	                    var i = new Croppie(this, opts);
	                    i.$ = $;
	                    $(this).data('croppie', i);
	                });
	            }
	        };
	    }

	    function Croppie(element, opts) {
	        if (element.className.indexOf('croppie-container') > -1) {
	            throw new Error("Croppie: Can't initialize croppie more than once");
	        }
	        this.element = element;
	        this.options = deepExtend(clone(Croppie.defaults), opts);

	        if (this.element.tagName.toLowerCase() === 'img') {
	            var origImage = this.element;
	            addClass(origImage, 'cr-original-image');
	            setAttributes(origImage, {'aria-hidden' : 'true', 'alt' : '' });
	            var replacementDiv = document.createElement('div');
	            this.element.parentNode.appendChild(replacementDiv);
	            replacementDiv.appendChild(origImage);
	            this.element = replacementDiv;
	            this.options.url = this.options.url || origImage.src;
	        }

	        _create.call(this);
	        if (this.options.url) {
	            var bindOpts = {
	                url: this.options.url,
	                points: this.options.points
	            };
	            delete this.options['url'];
	            delete this.options['points'];
	            _bind.call(this, bindOpts);
	        }
	    }

	    Croppie.defaults = {
	        viewport: {
	            width: 100,
	            height: 100,
	            type: 'square'
	        },
	        boundary: { },
	        orientationControls: {
	            enabled: true,
	            leftClass: '',
	            rightClass: ''
	        },
	        resizeControls: {
	            width: true,
	            height: true
	        },
	        customClass: '',
	        showZoomer: true,
	        enableZoom: true,
	        enableResize: false,
	        mouseWheelZoom: true,
	        enableExif: false,
	        enforceBoundary: true,
	        enableOrientation: false,
	        enableKeyMovement: true,
	        update: function () { }
	    };

	    Croppie.globals = {
	        translate: 'translate3d'
	    };

	    deepExtend(Croppie.prototype, {
	        bind: function (options, cb) {
	            return _bind.call(this, options, cb);
	        },
	        get: function () {
	            var data = _get.call(this);
	            var points = data.points;
	            if (this.options.relative) {
	                points[0] /= this.elements.img.naturalWidth / 100;
	                points[1] /= this.elements.img.naturalHeight / 100;
	                points[2] /= this.elements.img.naturalWidth / 100;
	                points[3] /= this.elements.img.naturalHeight / 100;
	            }
	            return data;
	        },
	        result: function (type) {
	            return _result.call(this, type);
	        },
	        refresh: function () {
	            return _refresh.call(this);
	        },
	        setZoom: function (v) {
	            _setZoomerVal.call(this, v);
	            dispatchChange(this.elements.zoomer);
	        },
	        rotate: function (deg) {
	            _rotate.call(this, deg);
	        },
	        destroy: function () {
	            return _destroy.call(this);
	        }
	    });
	    return Croppie;
	}));
	});

	//

	var script$10 = {
	  name: 'UserPhotoDetail',
	  props: ['photoFile', 'type'],
	  data: function data() {
	    var self = this;

	    var type = self.type || 'user';
	    var store = new Store(self, {
	      postForm: [type, 'photoupload'],
	      postFormFinished: function postFormFinished(result) {
	        self.uploading = false;
	        if (result.success) {
	          self.$emit('photoUpdate', result.data);
	        }
	      },
	    });
	    return {
	      store: store,
	      downloading: false,
	      uploading: false,
	    };
	  },
	  watch: {
	    photoFile: function photoFile() {
	      var self = this;
	      self.downloading = true;
	      var img = new window.Image();
	      img.onload = function onload() {
	        self.downloading = false;
	      };
	      img.src = self.photoUrl;
	    },
	  },
	  computed: {
	    photoUrl: function photoUrl() {
	      var defaultAvatar = this.type === 'team' ? 'team_avatar.png' : 'avatar.png';
	      var imageSize = Brief$1.f7.device.pixelRatio > 1 ? '400' : '200';
	      return this.path.imageUrl(
	        this.photoFile ? this.photoFile.filename : defaultAvatar,
	        ("h=" + imageSize + "&autorotate=true")
	      );
	    },
	  },
	  methods: {
	    saveImage: function saveImage(src) {
	      var self = this;
	      self.uploading = true;
	      self.store.postForm({
	        src: src,
	      });
	    },
	    openCropper: function openCropper(src) {
	      var self = this;
	      var croppie$$1;

	      function onResize() {
	        croppie$$1.setZoom(croppie$$1._currentZoom); // eslint-disable-line
	      }

	      var popup = Brief$1.f7.popup.create({
	        content: "\n          <div class=\"popup popup-image-crop popup-tablet-fullscreen\">\n            <div class=\"view view-init\" data-dynamic-navbar=\"false\">\n              <div class=\"page\">\n                <div class=\"image-crop\"></div>\n                <div class=\"toolbar toolbar-bottom-md no-hairline no-shadow\">\n                  <div class=\"toolbar-inner\">\n                    <a href=\"#\" class=\"link popup-close\">Cancel</a>\n                    <a href=\"#\" class=\"link crop-image\">Done</a>\n                  </div>\n                </div>\n              </div>\n            </div>\n          </div>\n        ".trim(),
	        on: {
	          open: function open() {
	            croppie$$1 = new croppie(popup.$el.find('.image-crop')[0], {
	              enableZoom: true,
	              enforceBoundary: true,
	              showZoomer: true,
	              viewport: {
	                width: 300,
	                height: 300,
	                type: 'square',
	              },
	            });
	            croppie$$1.bind({ url: src, zoom: 0 });
	            popup.$el.find('a.crop-image').on('click', function () {
	              croppie$$1.result({
	                type: 'base64',
	                size: {
	                  width: 800,
	                  height: 800,
	                },
	                format: 'jpeg',
	              }).then(function (result) {
	                self.saveImage(result);
	              });
	              popup.close();
	            });
	            Brief$1.f7.on('resize', onResize);
	          },
	          closed: function closed() {
	            Brief$1.f7.off('resize', onResize);
	            setTimeout(function () {
	              popup.destroy();
	              croppie$$1.destroy();
	            }, 100);
	          },
	        },
	      });
	      popup.open();
	    },
	    onFilesChange: function onFilesChange(event) {
	      var self = this;
	      var input = event.target;
	      if (!input.files || !input.files.length) { return; }
	      var file = input.files[0];
	      if (file.type.indexOf('image') === 0) {
	        var reader = new window.FileReader();
	        self.uploading = true;
	        reader.onload = (function (e) {
	          self.openCropper(e.target.result);
	          self.uploading = false;
	          input.value = null;
	        });
	        reader.readAsDataURL(file);
	      }
	    },
	  },
	  beforeDestroy: function beforeDestroy() {},
	};

	/* script */
	var __vue_script__$10 = script$10;

	/* template */
	var __vue_render__$Z = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f7-block',{staticClass:"user-photo-container",class:{'uploading': _vm.uploading}},[_c('label',[_c('span',{staticClass:"user-photo-image",style:('background-image: url(' + _vm.photoUrl + ')')}),_vm._v(" "),_c('f7-icon',{attrs:{"if-ios":"f7:camera_fill","if-md":"material:camera_alt"}}),_vm._v(" "),_c('input',{ref:"input",attrs:{"type":"file"},on:{"change":_vm.onFilesChange}})],1),_vm._v(" "),(_vm.uploading || _vm.downloading)?_c('f7-preloader'):_vm._e()],1)};
	var __vue_staticRenderFns__$Z = [];

	  /* style */
	  var __vue_inject_styles__$11 = undefined;
	  /* scoped */
	  var __vue_scope_id__$11 = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$11 = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$11 = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$11 = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$Z, staticRenderFns: __vue_staticRenderFns__$Z },
	    __vue_inject_styles__$11,
	    __vue_script__$10,
	    __vue_scope_id__$11,
	    __vue_is_functional_template__$11,
	    __vue_module_identifier__$11,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//

	var script$11 = {
	  components: {
	    userPhotoDetail: __vue_component__$11,
	  },
	  data: function data() {
	    var self = this;
	    var debouncedAccountsRefresh = lodash.debounce(function () { return Brief$1.events.$emit('accounts-refresh'); }, 1000);
	    var store = new Store(self, {
	      get: ['team', 'settings'],
	      post: ['team', 'settings'],
	      postFinished: function postFinished(result) {
	        self.saveInProgress = false;
	        if (result.success) {
	          debouncedAccountsRefresh();
	          Brief$1.f7.popup.close();
	        }
	      },
	    });
	    store.get();

	    gtag('event', 'team_settings', {
	      event_category: 'page',
	      event_label: 'Open company settings',
	    });

	    return {
	      store: store,
	      saveInProgress: false,
	    };
	  },
	  methods: {
	    handleJoinLeaveMessagesSwitch: function handleJoinLeaveMessagesSwitch(event) {
	      var self = this;
	      var checked;
	      if (event.target) { checked = event.target.checked; }
	      else { checked = event; }
	      self.store.showJoinLeaveMessages = !!checked;
	    },
	    save: function save() {
	      var self = this;
	      self.saveInProgress = true;
	      self.store.post();
	    },
	    onPhotoUpdate: function onPhotoUpdate(photoFile) {
	      Brief$1.events.$emit('accounts-refresh');
	      this.store.photoFile = photoFile;
	    },
	  },
	};

	/* script */
	var __vue_script__$11 = script$11;

	/* template */
	var __vue_render__$_ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f7-page',{staticClass:"page-form"},[_c('f7-navbar',[_c('f7-link',{attrs:{"back":""}},[_c('f7-icon',{attrs:{"material":"arrow_back","size":"30"}})],1),_vm._v(" "),_c('f7-nav-title',[_vm._v("\n      Company Profile\n    ")]),_vm._v(" "),_c('f7-nav-right',[_c('f7-link',{attrs:{"popup-close":""}},[_c('f7-icon',{attrs:{"material":"close","size":"30"}})],1)],1)],1),_vm._v(" "),_c('f7-block',{staticStyle:{"padding":"0"},attrs:{"inset":""}},[_c('user-photo-detail',{attrs:{"photo-file":_vm.store.photoFile,"type":"team"},on:{"photoUpdate":_vm.onPhotoUpdate}})],1),_vm._v(" "),_c('f7-list',{attrs:{"inset":""}},[_c('f7-list-item',{attrs:{"item-input":""}},[_c('f7-input',{attrs:{"type":"text","value":_vm.store.teamName,"placeholder":"Team/Company name"},on:{"input":function($event){_vm.store.teamName = $event.target.value;}}})],1)],1),_vm._v(" "),_c('f7-list',{attrs:{"inset":""}},[_c('f7-list-button',{on:{"click":_vm.save}},[(!_vm.saveInProgress)?_c('span',[_vm._v("Save")]):_vm._e(),_vm._v(" "),(_vm.saveInProgress)?_c('f7-preloader'):_vm._e()],1)],1)],1)};
	var __vue_staticRenderFns__$_ = [];

	  /* style */
	  var __vue_inject_styles__$12 = undefined;
	  /* scoped */
	  var __vue_scope_id__$12 = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$12 = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$12 = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$12 = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$_, staticRenderFns: __vue_staticRenderFns__$_ },
	    __vue_inject_styles__$12,
	    __vue_script__$11,
	    __vue_scope_id__$12,
	    __vue_is_functional_template__$12,
	    __vue_module_identifier__$12,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//

	var script$12 = {
	  data: function data() {
	    var self = this;
	    var store = new Store(self, {
	      get: ['plan', 'settings'],
	    });
	    store.get();

	    var storePlanChange = new Store(self, {
	      postNow: ['plan', 'change'],
	      postNowFinished: function () {
	        store.clear();
	        window.location.reload();
	      }
	    });

	    return {
	      store: store,
	      storePlanChange: storePlanChange
	    };
	  },
	  mounted: function mounted() {
	    Brief$1.events.$on('change-plan', this.changePlan);
	  },
	  beforeDestroy: function beforeDestroy() {
	    Brief$1.events.$off('change-plan', this.changePlan);
	  },
	  methods: {
	    changePlan: function changePlan(priceId) {
	      Brief$1.showPreloader('Changing plan');
	      this.storePlanChange.postNow({ priceId: priceId });
	    },
	  }
	};

	/* script */
	var __vue_script__$12 = script$12;

	/* template */
	var __vue_render__$10 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f7-page',{staticClass:"page-form"},[_c('f7-navbar',[_c('f7-nav-left',[_c('f7-link',{attrs:{"back":""}},[_c('f7-icon',{attrs:{"material":"arrow_back","size":"30"}})],1)],1),_vm._v(" "),_c('f7-nav-title',[_vm._v("\n      Change Plan\n    ")]),_vm._v(" "),_c('f7-nav-right',[_c('f7-link',{attrs:{"popup-close":""}},[_c('f7-icon',{attrs:{"material":"close","size":"30"}})],1)],1)],1),_vm._v(" "),(!_vm.store.billingPeriod)?_c('div',{staticClass:"infinite-scroll-preloader"},[_c('f7-preloader')],1):_vm._e(),_vm._v(" "),(_vm.store.billingPeriod)?_c('f7-block-title',[_vm._v("Billed")]):_vm._e(),_vm._v(" "),(_vm.store.billingPeriod)?_c('f7-segmented',{staticStyle:{"background-color":"#fff","margin":"0 16px 16px 16px"}},[_c('f7-button',{attrs:{"small":"","active":_vm.store.billingPeriod === 'Yearly'},on:{"click":function($event){_vm.store.billingPeriod = 'Yearly';}}},[_vm._v("Yearly")]),_vm._v(" "),_c('f7-button',{attrs:{"small":"","active":_vm.store.billingPeriod === 'Monthly'},on:{"click":function($event){_vm.store.billingPeriod = 'Monthly';}}},[_vm._v("Monthly")])],1):_vm._e(),_vm._v(" "),_c('f7-block',{staticStyle:{"margin-top":"0","display":"flex","flex-wrap":"wrap","gap":"16px","background":"transparent"}},_vm._l((_vm.store.plans),function(plan){return _c('common-plan',{key:plan.name,attrs:{"plan":plan,"hasSubscription":_vm.store.hasSubscription,"billingPeriod":_vm.store.billingPeriod,"currentPriceId":_vm.store.currentPriceId}})}),1)],1)};
	var __vue_staticRenderFns__$10 = [];

	  /* style */
	  var __vue_inject_styles__$13 = undefined;
	  /* scoped */
	  var __vue_scope_id__$13 = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$13 = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$13 = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$13 = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$10, staticRenderFns: __vue_staticRenderFns__$10 },
	    __vue_inject_styles__$13,
	    __vue_script__$12,
	    __vue_scope_id__$13,
	    __vue_is_functional_template__$13,
	    __vue_module_identifier__$13,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//

	function handlePreProcess$1(data) {
	  var self = this;

	  var userId = self.$root.loggedInUser.id;
	  data.isMyMessage = userId === data.userId;

	  return true;
	}

	var script$13 = {
	  name: 'NoteList',
	  props: ['params'],
	  data: function data() {
	    var self = this;
	    var id = self.$f7route.params.id;
	    var conversationId = self.$f7route.query.conversationId;
	    var store = new Store(self, {
	      preProcess: handlePreProcess$1,
	      get: ['note', 'list', { id: id, conversationId: conversationId }],
	      postForm: ['note', 'create', { conversationId: conversationId, contactId: id }],
	      subscribe: ['note', 'list', 'messages', { subscriptionKey: conversationId }],
	    });
	    var storeEdit = new Store(self, {
	      post: ['note', 'edit', {}],
	    });

	    var storeDelete = new Store(self, {
	      post: ['note', 'delete', {}],
	    });

	    var storeEditPost = new Store(self, {
	      post: ['post', 'edit', {}],
	    });

	    var storeDeletePost = new Store(self, {
	      post: ['post', 'delete', {}],
	      postFinished: function postFinished(result) {
	        if (result.success) {
	          Brief$1.viewMain.router.back();
	        }
	      },
	    });

	    return {
	      conversationId: conversationId,
	      store: store,
	      storeEdit: storeEdit,
	      storeDelete: storeDelete,
	      storeEditPost: storeEditPost,
	      storeDeletePost: storeDeletePost,
	    };
	  },
	};

	/* script */
	var __vue_script__$13 = script$13;

	/* template */
	var __vue_render__$11 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('channel-chat-page',{ref:"chat",attrs:{"navbarTitle":"Notes","navbarRoot":false,"type":"note","placeholder":"Write a note","conversation-id":_vm.conversationId,"store":_vm.store,"storeEdit":_vm.storeEdit,"storeDelete":_vm.storeDelete,"storeEditPost":_vm.storeEditPost,"storeDeletePost":_vm.storeDeletePost,"focus-on-load":true,"use-mentions":true,"use-saved-replies":true}})};
	var __vue_staticRenderFns__$11 = [];

	  /* style */
	  var __vue_inject_styles__$14 = undefined;
	  /* scoped */
	  var __vue_scope_id__$14 = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$14 = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$14 = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$14 = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$11, staticRenderFns: __vue_staticRenderFns__$11 },
	    __vue_inject_styles__$14,
	    __vue_script__$13,
	    __vue_scope_id__$14,
	    __vue_is_functional_template__$14,
	    __vue_module_identifier__$14,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//

	function handlePreProcess$2(data) {
	  var self = this;

	  var userId = self.$root.loggedInUser.id;
	  data.isMyMessage = userId === data.userId;

	  return true;
	}

	var script$14 = {
	  name: 'Thread',
	  props: ['params'],
	  data: function data() {
	    var self = this;
	    var id = self.$f7route.params.id;
	    var channelId = self.$f7route.query.channelId;
	    var store = new Store(self, {
	      preProcess: handlePreProcess$2,
	      get: ['thread', 'list', { id: id }],
	      postForm: ['roommessage', 'create', { streamId: channelId, threadId: id }],
	      subscribe: ['thread', 'list', 'messages', { subscriptionKey: id }],
	    });
	    var storeEdit = new Store(self, {
	      post: ['roommessage', 'edit', { threadId: id }],
	    });

	    var storeDelete = new Store(self, {
	      post: ['roommessage', 'delete', { threadId: id }],
	    });

	    var storeEditPost = new Store(self, {
	      post: ['post', 'edit', {}],
	    });

	    var storeDeletePost = new Store(self, {
	      post: ['post', 'delete', {}],
	      postFinished: function postFinished(result) {
	        if (result.success) {
	          Brief$1.viewMain.router.back();
	        }
	      },
	    });

	    return {
	      conversationId: id,
	      store: store,
	      storeEdit: storeEdit,
	      storeDelete: storeDelete,
	      storeEditPost: storeEditPost,
	      storeDeletePost: storeDeletePost,
	    };
	  },
	};

	/* script */
	var __vue_script__$14 = script$14;

	/* template */
	var __vue_render__$12 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('channel-chat-page',{ref:"chat",attrs:{"navbarTitle":"Thread","navbarRoot":false,"type":"thread","placeholder":"Message","conversation-id":_vm.conversationId,"store":_vm.store,"storeEdit":_vm.storeEdit,"storeDelete":_vm.storeDelete,"storeEditPost":_vm.storeEditPost,"storeDeletePost":_vm.storeDeletePost,"focus-on-load":true,"use-mentions":true,"use-saved-replies":true}})};
	var __vue_staticRenderFns__$12 = [];

	  /* style */
	  var __vue_inject_styles__$15 = undefined;
	  /* scoped */
	  var __vue_scope_id__$15 = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$15 = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$15 = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$15 = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$12, staticRenderFns: __vue_staticRenderFns__$12 },
	    __vue_inject_styles__$15,
	    __vue_script__$14,
	    __vue_scope_id__$15,
	    __vue_is_functional_template__$15,
	    __vue_module_identifier__$15,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//

	var median = function (a) {
	  var array = a.sort();
	  if (array.length % 2 === 0) { // array with even number elements
	    return (array[array.length / 2] + array[(array.length / 2) - 1]) / 2;
	  } else {
	    return array[(array.length - 1) / 2]; // array with odd number elements
	  }
	};

	var script$15 = {
	  components: {
	  },
	  data: function data() {
	    var self = this;
	    var store = new Store(self, {
	      get: ['dashboard', 'chart'],
	      getLocalFinished: function getLocalFinished() {
	      },
	      getFinished: function getFinished() {
	        Brief$1.f7.preloader.hide();
	      },
	    });

	    gtag('event', 'dashboard', {
	      event_category: 'page',
	      event_label: 'Open dashboard',
	    });

	    return {
	      store: store,
	      chartOptions: {
	        responsive: true,
	        maintainAspectRatio: false,
	        scales: {
	          yAxes: [{
	            ticks: {
	              beginAtZero: true,
	              //stepSize: 1,
	              min: 0,
	            },
	          }],
	        },
	      },
	    };
	  },
	  mounted: function mounted() {
	    var self = this;
	    var weekAgo = new Date();
	    weekAgo.setDate(weekAgo.getDate() - 7);
	    var calendarRange = Brief$1.f7.calendar.create({
	      inputEl: '#demo-calendar-range',
	      dateFormat: 'M dd yyyy',
	      rangePicker: true,
	      value: [weekAgo, new Date()],
	      on: {
	        change: function (cal, dates) {
	          var from = hooks$1(dates[0]).format('MM/DD/YYYY');
	          var to = dates.length === 2 ? hooks$1(dates[1]).format('MM/DD/YYYY') : null;
	          Brief$1.f7.preloader.show();
	          self.store.get({ from: from, to: to });
	        },
	      },
	    });
	  },
	  beforeDestroy: function beforeDestroy() {
	    var self = this;
	    if (self.store) { self.store.dispose(); }
	  },
	  methods: {
	    getTotalAverage: function getTotalAverage(chartData) {
	      if (!chartData) {
	        return 0;
	      }
	      var items = [];
	      chartData.datasets.forEach(function (d) {
	        items.push.apply(items, d.data);
	      });
	      return median(items);
	    },
	    getTotal: function getTotal(chartData) {
	      if (!chartData) {
	        return 0;
	      }
	      var items = [];
	      chartData.datasets.forEach(function (d) {
	        items.push.apply(items, d.data);
	      });
	      return lodash.sum(items);
	    },
	    save: function save() {
	      var self = this;
	      self.saveInProgress = true;
	      self.store.post();
	    },
	  },
	};

	/* script */
	var __vue_script__$15 = script$15;

	/* template */
	var __vue_render__$13 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f7-page',{staticClass:"page-form"},[_c('common-navbar',{attrs:{"title":"Statistics","root":true}}),_vm._v(" "),_c('div',{staticClass:"list no-hairlines-md"},[_c('ul',[_c('li',[_c('div',{staticClass:"item-content item-input"},[_c('div',{staticClass:"item-inner"},[_c('div',{staticClass:"item-input-wrap"},[_c('input',{attrs:{"type":"text","placeholder":"Select date range","readonly":"readonly","id":"demo-calendar-range"}})])])])])])]),_vm._v(" "),_c('div',{staticClass:"list no-hairlines-md"},[_c('div',{staticClass:"block-title padding-top no-margin-bottom"},[_vm._v("Average Response Time, minutes")]),_vm._v(" "),_c('div',{staticClass:"chart-totals"},[_vm._v(_vm._s(_vm.getTotalAverage(_vm.store.responseChartData)))]),_vm._v(" "),_c('dashboard-chart',{attrs:{"chart-data":_vm.store.responseChartData,"options":_vm.chartOptions}})],1),_vm._v(" "),_c('div',{staticClass:"list no-hairlines-md"},[_c('div',{staticClass:"block-title padding-top no-margin-bottom"},[_vm._v("Unique Customers")]),_vm._v(" "),_c('div',{staticClass:"chart-totals"},[_vm._v(_vm._s(_vm.getTotal(_vm.store.chartData)))]),_vm._v(" "),_c('dashboard-chart',{attrs:{"chart-data":_vm.store.chartData,"options":_vm.chartOptions}})],1),_vm._v(" "),_c('div',{staticClass:"list no-hairlines-md"},[_c('div',{staticClass:"block-title padding-top no-margin-bottom"},[_vm._v("Conversations")]),_vm._v(" "),_c('div',{staticClass:"chart-totals"},[_vm._v(_vm._s(_vm.getTotal(_vm.store.conversationsChartData)))]),_vm._v(" "),_c('dashboard-chart',{attrs:{"chart-data":_vm.store.conversationsChartData,"options":_vm.chartOptions}})],1),_vm._v(" "),_c('div',{staticClass:"list no-hairlines-md"},[_c('div',{staticClass:"block-title padding-top no-margin-bottom"},[_vm._v("Received Messages")]),_vm._v(" "),_c('div',{staticClass:"chart-totals"},[_vm._v(_vm._s(_vm.getTotal(_vm.store.messagesChartData)))]),_vm._v(" "),_c('dashboard-chart',{attrs:{"chart-data":_vm.store.messagesChartData,"options":_vm.chartOptions}})],1)],1)};
	var __vue_staticRenderFns__$13 = [];

	  /* style */
	  var __vue_inject_styles__$16 = undefined;
	  /* scoped */
	  var __vue_scope_id__$16 = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$16 = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$16 = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$16 = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$13, staticRenderFns: __vue_staticRenderFns__$13 },
	    __vue_inject_styles__$16,
	    __vue_script__$15,
	    __vue_scope_id__$16,
	    __vue_is_functional_template__$16,
	    __vue_module_identifier__$16,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//

	var script$16 = {
	  name: 'InfoAddChannels',
	  data: function data() {
	    return {
	      isVisible: false,
	    };
	  },
	  mounted: function mounted() {
	    var self = this;
	    Brief$1.events.$on('info-invite-team', function () {
	      self.isVisible = false;
	    });
	    Brief$1.events.$on('info-update-profile', function () {
	      self.isVisible = false;
	    });
	    Brief$1.events.$on('info-add-channels', function () {
	      self.isVisible = true;
	    });
	    Brief$1.events.$on('add-stream-clicked', function () {
	      self.isVisible = false;
	    });
	    Brief$1.events.$on('close-info-stream', function () {
	      self.isVisible = false;
	    });
	  },
	  beforeDestroy: function beforeDestroy() {
	    Brief$1.events.$off('info-invite-team');
	    Brief$1.events.$off('info-update-profile');
	    Brief$1.events.$off('info-add-channels');
	    Brief$1.events.$off('add-stream-clicked');
	    Brief$1.events.$off('close-info-stream');
	  },
	};

	/* script */
	var __vue_script__$16 = script$16;

	/* template */
	var __vue_render__$14 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isVisible),expression:"isVisible"}],staticClass:"info-add-streams",class:{'fadeInUp': _vm.isVisible, 'animated': _vm.isVisible}},[_c('div',{staticClass:"info-box"},[_vm._v("Click here to add new channel")])])};
	var __vue_staticRenderFns__$14 = [];

	  /* style */
	  var __vue_inject_styles__$17 = undefined;
	  /* scoped */
	  var __vue_scope_id__$17 = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$17 = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$17 = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$17 = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$14, staticRenderFns: __vue_staticRenderFns__$14 },
	    __vue_inject_styles__$17,
	    __vue_script__$16,
	    __vue_scope_id__$17,
	    __vue_is_functional_template__$17,
	    __vue_module_identifier__$17,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//

	function recalculateBadges(streams) {
	  var self = this;
	  var totalNewCount = 0;
	  streams.forEach(function (stream) {
	    if (self.selectedStreamId !== stream.id) {
	      if (stream.id !== 'notifications') {
	        totalNewCount += stream.newNotificationsCount;
	      }
	    } else {
	      stream.newNotificationsCount = 0;
	    }
	  });
	  if (isNaN(totalNewCount) || !totalNewCount) { totalNewCount = 0; }
	  Brief$1.events.$emit('streams-badge-refresh', totalNewCount);

	  if (!self.originalFavicon) {
	    self.originalFavicon = $$1('head link[rel="icon"]').attr('href');
	  }

	  if (totalNewCount > 0) {
	    document.title = "(" + totalNewCount + ") Brief";
	    $$1('head link[rel="icon"]').attr('href', 'data:image/png;base64,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');
	  } else {
	    document.title = 'Brief';
	    $$1('head link[rel="icon"]').attr('href', self.originalFavicon);
	  }
	}

	function clearPrevousStreams$1(e) {
	  $$1(e.target).prevAll('.page').trigger('page:beforeremove', { page: {} });
	}

	function handleGetFinished$2() {
	  recalculateBadges.call(this, this.store.streams);
	}

	var debouncedAccountsRefresh = lodash.debounce(function () { return Brief$1.events.$emit('accounts-refresh'); }, 3000);

	function handlePreProcess$3(data) {
	  var self = this;
	  debouncedAccountsRefresh();
	  if (data.participants) {
	    data.participants.forEach(function (user) {
	      if (user.id !== self.$root.loggedInUser.id) { data.name = user.name; }
	    });
	  }

	  if (data.deleteThis) {
	    return true;
	  }

	  var userId = self.$root.loggedInUser.id;

	  data.newNotificationsCount = data.badgeCount[userId] || 0;

	  // eslint-disable-next-line
	  if (self.currentUrl && getUrl$1(data) === self.currentUrl) {
	    self.storeBadgeReset.post({ channelId: data.id, channelType: data.streamType });
	    data.newNotificationsCount = 0;
	  }

	  if (data.streamType === 'list' || data.streamType === 'notifications') { return true; }

	  var justLeaved = data.justLeavedUserIds && data.justLeavedUserIds.indexOf(userId) > -1;
	  if (justLeaved) {
	    data.deleteThis = true;
	    return true;
	  }

	  var needToAddStream = data.ownerUserId === userId || (data.joinedUserIds.indexOf(userId) > -1);

	  if (!needToAddStream) {
	    return false;
	  }

	  return true;
	}
	function sort(streams) {
	  var sortingOrder = ['notifications', 'list', 'website', 'email', 'facebook', 'instagram', 'room'];
	  streams.sort(function (a, b) {
	    if (a.streamType !== b.streamType) {
	      return sortingOrder.indexOf(a.streamType) - sortingOrder.indexOf(b.streamType);
	    }
	    return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
	  });
	}

	// eslint-disable-next-line
	function getUrl$1(stream) {
	  if (stream.streamType === 'website') {
	    return ("/website/" + (stream.id) + "/");
	  } else if (stream.streamType === 'email') {
	    return ("/email/" + (stream.id) + "/");
	  } else if (stream.streamType === 'facebook') {
	    return ("/facebook/" + (stream.id) + "/");
	  } else if (stream.streamType === 'instagram') {
	    return ("/instagram/" + (stream.id) + "/");
	  } else if (stream.streamType === 'room') {
	    return ("/room/" + (stream.id) + "/");
	  } else if (stream.id === 'list') {
	    return '/posts/';
	  } else if (stream.id === 'notifications') {
	    return '/all-messages/';
	  }
	}

	function setUrls(streams) {
	  streams.forEach(function (stream) {
	    stream.url = getUrl$1(stream);
	  });
	}

	function getPageLink(notification) {
	  if (notification.pageType === 'email' && notification.group) {
	    return ("/email/" + (notification.streamId) + "/");
	  } else if (notification.pageType === 'email') {
	    return ("/email/" + (notification.streamId) + "/" + (encodeURIComponent(notification.extraParam1)) + "/");
	  } else if (notification.pageType === 'website' && notification.group) {
	    return ("/website/" + (notification.streamId) + "/");
	  } else if (notification.pageType === 'website') {
	    return ("/website/" + (notification.streamId) + "/" + (encodeURIComponent(notification.extraParam1)) + "/");
	  } else if (notification.pageType === 'facebook' && notification.group) {
	    return ("/facebook/" + (notification.streamId) + "/");
	  } else if (notification.pageType === 'facebook') {
	    return ("/facebook/" + (notification.streamId) + "/" + (encodeURIComponent(notification.extraParam1)) + "/");
	  } else if (notification.pageType === 'room') {
	    return ("/room/" + (notification.pageId) + "/");
	  } else if (notification.pageType === 'comment') {
	    return ("/post/" + (notification.pageId) + "/");
	  }
	  return ("/post/" + (notification.pageId) + "/");
	}

	function getTitle(notification) {
	  var title = notification.userFullname;
	  var streamName = '';

	  if (notification.streamName) { streamName = notification.streamName; } else if (notification.pageType === 'comment') { streamName = 'Comment'; } else if (notification.pageType === 'post') { streamName = 'Posts'; }

	  if (!title) { title = streamName; } else if (streamName) { title += " to " + streamName; }

	  return title;
	}

	function getText(notification) {
	  var text = notification.text || '';

	  return text;
	}

	function showNotification(title, body, icon, url) {
	  var options = {
	    body: body,
	    icon: icon,
	  };
	  var notification = new window.Notification(title, options);
	  notification.onclick = function onClick() {
	    window.open(url);
	    notification.close();
	  };
	}
	function notify(title, body, icon, url) {
	  if (!('Notification' in window)) { return; }

	  if (window.Notification.permission === 'granted') {
	    showNotification(title, body, icon, url);
	  } else if (window.Notification.permission !== 'denied') {
	    window.Notification.requestPermission(function (permission) {
	      if (permission === 'granted') {
	        showNotification(title, body, icon, url);
	      }
	    });
	  }
	}

	function getUserPhoto(notification) {
	  if (!notification.userPhoto && !!notification.group) {
	    return { filename: ((notification.pageType) + "_notification.png") };
	  }
	  if (!notification.userPhoto && notification.pageType === 'facebook') {
	    return { filename: ((this.domain) + "/api/facebook/picture?id=" + (notification.facebookUserId) + "&channelId=" + (notification.pageId)) };
	  }
	  return notification.userPhoto;
	}

	function processSubscriptionWebNotification(response) {
	  var url = getPageLink(response);
	  if (window.location.href.indexOf(url.substring(0, url.indexOf('?'))) === -1) {
	    var icon = getUserPhoto(response);
	    var iconUrl = config$1.path.imageUrl(
	      icon ? icon.filename : 'avatar.png',
	      ("h=" + (Math.ceil(34 * Brief$1.f7.device.pixelRatio)) + "&404=avatar&autorotate=true")
	    );

	    notify(getTitle(response), getText(response), iconUrl, url);
	  }
	}

	var script$17 = {
	  name: 'ChannelList',
	  components: {
	    infoAddChannels: __vue_component__$17,
	  },
	  props: ['userId', 'userFullname'],
	  data: function data() {
	    var self = this;
	    var store = new Store(self, {
	      preProcess: handlePreProcess$3,
	      get: ['stream', 'list', { filter: 'all' }],
	      subscribe: ['stream', 'list', 'streams'],
	      getFinished: handleGetFinished$2,
	    });

	    var storeBadgeReset = new Store(self, {
	      post: ['badge', 'reset'],
	    });

	    var storeObject = {
	      store: store,
	      storeBadgeReset: storeBadgeReset,
	      selectedStreamId: null,
	      currentUrl: null,
	      latestUrl: null,
	      notificationCount: 0,
	      screenWidth: screen ? screen.width : 1600,
	    };

	    if (Brief$1.isDesktop) {
	      var storeWebNotification = new Store(self, {
	        subscribe: ['notificationmessage', 'list', 'notifications', { processLocally: true, subscriptionKey: window.localStorage.getItem('user_id') }],
	        subscribeFinished: processSubscriptionWebNotification,
	      });
	      storeObject.storeWebNotification = storeWebNotification;
	    }

	    return storeObject;
	  },
	  mounted: function mounted() {
	    var self = this;

	    self.store.get();

	    Brief$1.events.$on('streams-selected', function (stream) {
	      self.selectedStreamId = stream;
	    });

	    Brief$1.events.$on('sync', self.sync);

	    Brief$1.viewMain.on('pageInit', function (page) {
	      self.currentUrl = page.route.url;
	    });

	    Brief$1.viewMain.on('pageAfterIn', function (page) {
	      self.currentUrl = page.route.url;
	    });
	  },
	  watch: {
	    'store.streams': function watchStoreStreams() {
	      var notificationStream = this.store.streams.find(function (stream) { return stream.id === 'notifications'; });
	      if (notificationStream && notificationStream.newNotificationsCount !== this.notificationCount) {
	        this.notificationCount = notificationStream ? notificationStream.newNotificationsCount : 0;
	      }
	    },
	  },
	  computed: {
	    selectedUrl: function selectedUrl() {
	      var self = this;
	      var streams = self.store.streams || [];

	      if (['/channel/add/', '/team/add/', '/all-messages/', '/account/settings/', '/statistics/'].indexOf(self.currentUrl) >= 0) {
	        self.latestUrl = self.currentUrl;
	        return self.latestUrl;
	      }

	      var currentStream = streams.filter(function (stream) { return self.currentUrl === stream.url; });

	      if (currentStream.length === 1) {
	        self.latestUrl = currentStream[0].url;
	        return self.latestUrl;
	      }
	      recalculateBadges.call(self, self.store.streams || []);
	      return self.latestUrl;
	    },
	    channels: function channels() {
	      var self = this;
	      var channels = (self.store.streams || []).filter(function (channel) { return !channel.peerUserId; });

	      sort(channels);
	      setUrls(channels);

	      return channels;
	    },
	    directMessages: function directMessages() {
	      var self = this;
	      var channels = (self.store.streams || []).filter(function (channel) { return channel.peerUserId; });
	      channels.forEach(function (channel) {
	        (channel.participants || []).forEach(function (user) {
	          if (user.id !== self.$root.loggedInUser.id) { channel.name = user.name; }
	        });
	      });

	      sort(channels);
	      setUrls(channels);

	      return channels;
	    },
	    accounts: function accounts() {
	      var accounts = JSON.parse(window.localStorage.getItem('accounts') || '[]');
	      if (accounts.length === 1) ;
	      return accounts;
	    },
	    selectedAccount: function selectedAccount() {
	      var userId = window.localStorage.getItem('user_id');
	      var accounts = JSON.parse(window.localStorage.getItem('accounts') || '[]');
	      var selectedAccount = accounts.find(function (x) { return x.userId === userId; });
	      return selectedAccount || {};
	    }
	  },
	  beforeDestroy: function beforeDestroy() {
	    var self = this;

	    Brief$1.events.$off('streams-selected');
	    Brief$1.events.$off('sync', self.sync);
	    self.store.dispose();
	  },
	  methods: {
	    hasNewMessages: function hasNewMessages(stream) {
	      var self = this;
	      return self.getNotificationsCount(stream) > 0;
	    },
	    getNotificationsCount: function getNotificationsCount(stream) {
	      return stream.newNotificationsCount > 0 && stream.id !== 'notifications' ? stream.newNotificationsCount : undefined;
	    },
	    selectStream: function selectStream(stream) {
	      var self = this;
	      self.selectedStreamId = stream.id;
	      stream.newNotificationsCount = 0;
	      recalculateBadges.call(self, self.store.streams || []);
	      Brief$1.viewMain.$el.once('page:init', clearPrevousStreams$1);
	    },
	    handleClick: function handleClick(stream) {
	      var self = this;
	      gtag('event', 'channel_click', {
	        event_category: 'channel',
	        event_label: 'Select channel',
	      });
	      self.selectStream(stream);
	    },
	    addStream: function addStream(type) {
	      var self = this;
	      gtag('event', 'channel_add_click', {
	        event_category: 'channel',
	        event_label: 'Add channel',
	      });
	      self.selectedStreamId = 'addorselect';
	      Brief$1.events.$emit('add-stream-clicked');
	      Brief$1.viewMain.$el.once('page:init', clearPrevousStreams$1);
	    },
	    sync: function sync() {
	      this.store.get();
	    },
	  },
	};

	/* script */
	var __vue_script__$17 = script$17;

	/* template */
	var __vue_render__$15 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f7-page',[_c('f7-list',_vm._l((_vm.channels),function(channel){return (channel.id === 'notifications' || channel.id === 'list')?_c('f7-list-item',{key:channel.id,class:{'stream-selected':_vm.selectedUrl == channel.url, 'stream-highlight': _vm.hasNewMessages(channel), 'customer-channel-title': true},attrs:{"link":channel.url,"reload-all":true,"view":".view-main","panel-close":"","title":channel.name,"badge":_vm.getNotificationsCount(channel)},on:{"click":function($event){return _vm.handleClick(channel)}}},[(channel.id === 'notifications')?_c('div',{staticClass:"notification-icon-wrap",attrs:{"slot":"inner-start"},slot:"inner-start"},[_c('f7-icon',{attrs:{"if-ios":"f7:bell_fill","if-md":"material:notifications"}})],1):_vm._e(),_vm._v(" "),(channel.id === 'list')?_c('div',{staticClass:"notification-icon-wrap",attrs:{"slot":"inner-start"},slot:"inner-start"},[_c('f7-icon',{attrs:{"if-ios":"material:forum","if-md":"material:forum"}})],1):_vm._e()]):_vm._e()}),1),_vm._v(" "),_c('div',{staticClass:"channels"},[_c('f7-block-title',[_vm._v("Channels\n      "),_c('f7-button',{attrs:{"view":".view-main","reload-all":true,"href":"/channel/add/?type=customer","panel-close":""},on:{"click":function($event){return _vm.addStream('customer')}}},[_vm._v("Add")])],1),_vm._v(" "),_c('info-add-channels'),_vm._v(" "),_c('f7-list',_vm._l((_vm.channels.filter(function (c) { return c.streamType !== 'room'; })),function(channel){return (channel.id !== 'notifications' && channel.id !== 'list')?_c('f7-list-item',{key:channel.id,class:{'stream-selected':_vm.selectedUrl == channel.url, 'stream-highlight': _vm.hasNewMessages(channel), 'customer-channel-title': true },attrs:{"link":channel.url,"reload-all":true,"view":".view-main","panel-close":"","title":channel.name,"badge":_vm.getNotificationsCount(channel),"data-id":channel.id},on:{"click":function($event){return _vm.handleClick(channel)}}},[_c('div',{staticClass:"notification-icon-wrap",attrs:{"slot":"inner-start"},slot:"inner-start"},[(channel.streamType === 'instagram')?_c('f7-icon',{attrs:{"if-ios":"f7:social_instagram","if-md":"f7:social_instagram"}}):_vm._e(),_vm._v(" "),(channel.streamType === 'email')?_c('f7-icon',{attrs:{"if-ios":"f7:email","if-md":"f7:email"}}):_vm._e(),_vm._v(" "),(channel.streamType === 'facebook')?_c('f7-icon',{attrs:{"if-ios":"f7:social_facebook","if-md":"f7:social_facebook"}}):_vm._e(),_vm._v(" "),(channel.streamType === 'website')?_c('f7-icon',{attrs:{"if-ios":"f7:world","if-md":"f7:world"}}):_vm._e()],1)]):_vm._e()}),1)],1),_vm._v(" "),(_vm.directMessages && _vm.directMessages.length && _vm.$root.loggedInUser.plan && _vm.$root.loggedInUser.plan.name !== 'Base')?_c('div',{staticClass:"channels"},[_c('f7-block-title',[_vm._v("Direct Messages")]),_vm._v(" "),_c('f7-list',_vm._l((_vm.directMessages),function(channel){return _c('f7-list-item',{key:channel.id,class:{'stream-selected':_vm.selectedUrl == channel.url, 'stream-highlight': _vm.hasNewMessages(channel), 'customer-channel-title': true },attrs:{"link":channel.url,"reload-all":true,"view":".view-main","panel-close":"","title":channel.name,"badge":_vm.getNotificationsCount(channel),"data-id":channel.id},on:{"click":function($event){return _vm.handleClick(channel)}}},[_c('div',{staticClass:"notification-icon-wrap",attrs:{"slot":"inner-start"},slot:"inner-start"},[_c('common-avatar',{attrs:{"slot":"media","avatar":channel.avatar,"small":true,"type":"user"},slot:"media"})],1)])}),1)],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"channel-spacer"}),_vm._v(" "),_c('div',[_c('f7-list',[(_vm.$root.loggedInUser.plan && _vm.$root.loggedInUser.plan.name !== 'Base')?_c('f7-list-item',{class:{'stream-selected':_vm.selectedUrl == '/statistics/', 'customer-channel-title': true},attrs:{"link":"/statistics/","reload-all":true,"view":".view-main","panel-close":"","title":"Statistics"}},[_c('div',{staticClass:"notification-icon-wrap",attrs:{"slot":"inner-start"},slot:"inner-start"},[_c('f7-icon',{attrs:{"if-ios":"f7:graph_round","if-md":"f7:graph_round"}})],1)]):_vm._e(),_vm._v(" "),_c('f7-list-item',{class:{'stream-selected':_vm.selectedUrl == '/account/settings/', 'customer-channel-title': true},attrs:{"link":"/account/settings/","reload-all":true,"view":".view-main","panel-close":"","title":"Settings"}},[_c('div',{staticClass:"notification-icon-wrap",attrs:{"slot":"inner-start"},slot:"inner-start"},[_c('f7-icon',{attrs:{"if-ios":"f7:settings","if-md":"material:settings"}})],1)])],1)],1),_vm._v(" "),(_vm.$root.loggedInUser.plan && _vm.$root.loggedInUser.plan.name !== 'Base')?_c('accounts-list'):_vm._e(),_vm._v(" "),(_vm.screenWidth < 768)?_c('div',{staticClass:"list"},[_c('ul',[_c('li',[_c('a',{attrs:{"href":"#","id":"brief-chat-button"}},[_c('div',{staticClass:"item-content"},[_c('div',{staticClass:"item-inner"},[_c('div',{staticClass:"item-title"},[_vm._v("Chat with us")]),_vm._v(" "),_c('div',{staticClass:"item-after"},[_c('span',{staticClass:"badge",attrs:{"id":"brief-unread-count"}},[_vm._v("0")])])])])])])])]):_vm._e()],1)};
	var __vue_staticRenderFns__$15 = [];

	  /* style */
	  var __vue_inject_styles__$18 = undefined;
	  /* scoped */
	  var __vue_scope_id__$18 = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$18 = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$18 = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$18 = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$15, staticRenderFns: __vue_staticRenderFns__$15 },
	    __vue_inject_styles__$18,
	    __vue_script__$17,
	    __vue_scope_id__$18,
	    __vue_is_functional_template__$18,
	    __vue_module_identifier__$18,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//

	function handleGetFinished$3() {
	  var self = this;
	  self.isAddExisting = self.store.streams.length > 0;
	}

	var icons = {
	  room: 'data:image/png;base64,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',
	  website: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAQAAADZc7J/AAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QA/4ePzL8AAAAJcEhZcwAADnYAAA52ARTacF8AAAAHdElNRQfiBg4CFxzqwZ4NAAADfklEQVRIx63VX0jVZxzH8df5059TkWVOOnpM1LwZ5M1KSVhZXfRnbBG7GV5EMdgYdNOg3UZEDWO7qBGyaMGCyW4M2hiBNMkYZqxC6soUFWy1TppZeRSPx2cXc9bSWhv7Pjc/vvD5/J7n+/s970/E7IqrtEWdNZIWY9Q9t1zys26T/qFiqjXqkxVeWFl9GlWLvUpepEF6RtBp1KRJozpnDNMaFL1Mvs5lwZDrJuScclDQokVw0Ck5E64bEly2bi75Jl2CDru1CZqUaBHUqxe0KNEkaLNbh6DLphfl1boEzcocEnRIWeuR21JSbntkrZQOwSFlmgVdqv9+9jZBswI10oZtxQHBaRERpwUHsNWwtBoFmgVtz2YR1SC4olTUGcEJUfOdF9SDesF580WdEJwRVeqKoEGUONbZg4yP5dlpStIRi62XtU0VimSt94VRSVN2GjMigz3OuUpU46xv/rqrUTTiTT/J12jQIh9Z6Rvd2Gy7y34UxZR3bXBBKyp96HenZBT4xEPvsE9wQQKV7hpQAY4L9s8Meb/gOKgw4K5KJFwQ7IuqQ5sxVCjU4x7iVqF/xqAfq8RxT49C5RjThrqoNbJughIxvTJYqNC49IxB2rhCC5HRK2YVuClrTVyRMUFKsBrjUqKWyzdhiZQYcpaYkK/CsCnjWK1YRDCmKCKHtCzyLDXiMWIKRae7ME+hKWk5LJXnsZHpruhLb2YQ5nyeVU+M2C6l2DHBSSkl3tJrUJ0SpUqVqDOo11olUk4KjimWst2IJ3F3lYm4gx4sdAcZTy330MD0S5aLearPEBagx2+oktAXdcs8VWBATplFGDciYdnMLpdJGDGOhDK5aeMq89yKuoSNEuj1QKUkxt23QHLGIGmB+8axUqUHepGwEZfiWvWrddCgxaYkfaZbRDHqlUz/ym+j2KeC1ZLSPjCqQK1+rf/DZaLGDwq1umqZD+Q5p9sb6k1qMoI89eKaPFDhfY9975Eam6W95+ozoLQrFXN2Gij5bsjYADbIuC5fxJeCs2JKtf8FlBeRVmvQsG34SnAYHBacwBZDBtXORtrzUC13VNCh2A4TrllhhWsm7LDSL4KjyueC6vNY36td8J3VOmTtsktWh3LfCtrtfRnWeRYsnSblfO1zwUUXBUecNGlS56uC5c9ZPB9tNzyVk/PEryZeJ9r4D+EamcPkX8X7H+HUwiwILiEyAAAAJXRFWHRkYXRlOmNyZWF0ZQAyMDE4LTA2LTE0VDAyOjIzOjI4LTA0OjAw9od/wQAAACV0RVh0ZGF0ZTptb2RpZnkAMjAxOC0wNi0xNFQwMjoyMzoyOC0wNDowMIfax30AAAAZdEVYdFNvZnR3YXJlAHd3dy5pbmtzY2FwZS5vcmeb7jwaAAAAAElFTkSuQmCC',
	  email: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAABmJLR0QA/wD/AP+gvaeTAAAAB3RJTUUH4gYOAhUs/i7MIwAABFlJREFUWMO9l1tsVEUcxn8zc267ZaFCu0WghdLSWkokxkSRaL3xgAnyVsUYjUhUfDExMQrYGI0kKEGJMQEkITEYA2Ki8UXjDUFiCPGWqLQIpUCr5VKgltI9u3su48MWusu2sKVLv2TOwzn/M9838/1n/jMCgNe+gDeWwpbWapxoM8p8ECFnI5gEwiQDweigM017aHrRwRF8/yuS/Z8zc95JvtsOG59CsPEA9HRJam5bih15HWXMQwg1er5CJIUegX+A5EALK2r3sn4vgqMa9h5rxinZhFRlxWcdBoF/HLd/OTdN3aNoXHYrkdhmlFE1LuQAUpYiVR3nu7+R2NEVKKN+3MgvQRl3EIk9IlHmYsQN8PtaENJAmQ9JpJw5/uyDkLLOQEg774PWmUVU1BFD/kyLUiP7pQBKFCwss4g7gqBIIpSAjoshv/b6pMIcUdaQAA0xU7Cy1iYdwrM1Dg0TFaEeiwqBELCvx+PTzjTzSxVbO1LZAxMyJ1xAc6VNc6XF+4dddp/2EEIgr7MFWrPzRIrPutK8UOfQFDe5cjzGcLoXlpnEbcmm9iSdiYDHZtrYcnQrpc/TbG1Pkgg0rzZGKLclv5z38+LkSB3UxhQtjRG6Xc2GQy7nc8y7Oo4NBKw9mKDUErzSkCEfCVlf8r2ebEleusWhMqJY2+pypD+4Jvn+sx4b2lwWVZismO3gqKvPXJYFwwdaUvBEtU3lacnGv10erbJpipt50X6o+fyfNPvO+jw/x2HeJINCkBWlRxQhgPsrTKZHJZvbkxwfyOSFNZgXFzzNlvYkA76mZW6EuCOvzVzoDGSjMioptwW7utKcSWqeqXHo90M2HUnyZ1/AkmkWpdbokrVgqf+6IW8edJlkSj5aMIFyR7DmjwHWtbrcU26yfcEE+jzN+jaXc6NI2IIs+L3XZ1tHkkUVFg9Pt1ACnpzlUB/ziJnist8v1jvs6kyz9qDLylqH+olqbBYEGr7sTvP1KY/l1Q63Tx4KlwLuKjNz4i0peHyWTWVU8t5hl+Yqm/uGSdgRBOQi4Ws+PJaiKxGwqiHCjGhhbgng3rjJzZFMwnYlQpZVWZcT9krk7QNCQE8yZF2bSzrUrGmMFkyejbqYomVuhK6BgHcOJen39LDHjpwZEMBf//nsPBFwd7nJkmkZv68XU2zJyw0RPulM81abS4kxWJGz9jzBzh59yX9DwFRHsqjC5M4pBmGRyrEQsOeMx+7THufSeog/8JKCHWd0TlHUmR8yVat4pxIhRH5vvnfRIAx9lByyQgzSisuPomD4oegLEh2eLBrLqFWFxyWB/yNjOvVcL7nWBP4PknRyG2FwatwFhP5hUu4OxYy6TqbWgGE0IURhNXTM5EEfqcQqFs/5XvH025pE32+YVgIh5yNFyQ25mEJmaYXBCVLuak51fMzRXp1henc/uP0GFdVNmM5zKNWEVHGElGNbDYP3Cx0GhEE3gf8tKfcDWn/6mYpZmtUP8D+10I7746HV+wAAACV0RVh0ZGF0ZTpjcmVhdGUAMjAxOC0wNi0xNFQwMjoyMTo0NC0wNDowMPO9zA8AAAAldEVYdGRhdGU6bW9kaWZ5ADIwMTgtMDYtMTRUMDI6MjE6NDQtMDQ6MDCC4HSzAAAAAElFTkSuQmCC',
	  facebook: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAfElEQVRYR2NkGGDACLLfMnLW/4Fwx/HlaYyjDhieIXBsWSrWJGUVNRtFnOppAJfFMFtp6gBCloMcMXwdQIzvaRoC2ByAHtzYUiXVEuGoA0ZeCBCb6pETHrZESXYiHHXAgIcAeqEy8nLBaAiMhsBoCIyGwPALgYHoGcPsBAAHQMYh3QbB2QAAAABJRU5ErkJggg==',
	  instagram: 'data:image/png;base64,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',
	};

	var script$18 = {
	  name: 'ChannelAdd',
	  watch: {
	    isAddExisting: function isAddExisting() {
	      var self = this;
	      if (!self.isAddExisting) { return; }
	      if (self.$theme.ios && self.pageData && self.pageData.from === 'previous') {
	        self.$nextTick(function () {
	          self.pageData.$el.addClass('page-previous');
	        });
	      }
	    },
	  },
	  data: function data() {
	    var route = this.route;
	    if (!route) { route = this.$f7route; }
	    var type = route.query.type;
	    var self = this;
	    var store = new Store(self, {
	      get: ['stream', 'list', { filter: 'NotJoined', type: type }],
	      getFinished: handleGetFinished$3,
	    });
	    return {
	      store: store,
	      pageData: null,
	      isAddExisting: false,
	      icons: icons,
	      type: type,
	    };
	  },
	  mounted: function mounted() {
	    var self = this;
	    self.store.get();
	  },
	  beforeDestroy: function beforeDestroy() {
	    var self = this;
	    self.store.dispose();
	  },
	  on: {
	    pageInit: function pageInit(e, page) {
	      var self = this;
	      self.pageData = page;
	    },
	  },
	};

	/* script */
	var __vue_script__$18 = script$18;

	/* template */
	var __vue_render__$16 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f7-page',{attrs:{"with-subnavbar":_vm.isAddExisting && _vm.$theme.ios}},[_c('common-navbar',{attrs:{"title":"Add channel","root":true}}),_vm._v(" "),(_vm.isAddExisting && _vm.$theme.ios)?_c('f7-subnavbar',[_c('f7-segmented',[_c('f7-button',{attrs:{"tab-link":"#channel-add-1","tab-link-active":""}},[_vm._v("Existing channels")]),_vm._v(" "),_c('f7-button',{attrs:{"tab-link":"#channel-add-2"}},[_vm._v("Create channel")])],1)],1):_vm._e(),_vm._v(" "),(_vm.isAddExisting && _vm.$theme.md)?_c('f7-toolbar',{attrs:{"tabbar":""}},[_c('f7-link',{attrs:{"tab-link":"#channel-add-1","tab-link-active":""}},[_vm._v("Existing channels")]),_vm._v(" "),_c('f7-link',{attrs:{"tab-link":"#channel-add-2"}},[_vm._v("Create channel")])],1):_vm._e(),_vm._v(" "),_c('f7-tabs',[(_vm.isAddExisting)?_c('f7-tab',{attrs:{"id":"channel-add-1","tab-active":""}},[_c('f7-list',{attrs:{"media-list":""}},_vm._l((_vm.store.streams),function(stream){return _c('f7-list-item',{key:stream.id,attrs:{"title":stream.name,"subtitle":stream.description,"text":stream.type + ' by ' + stream.ownerName,"after":stream.joinedUserCount + ' joined',"link":("/" + (stream.streamType.toLowerCase()) + "/" + (stream.id) + "/join/"),"media":_vm.icons[stream.streamType]}})}),1)],1):_vm._e(),_vm._v(" "),_c('f7-tab',{attrs:{"id":"channel-add-2","tab-active":!_vm.isAddExisting}},[_c('f7-list',{attrs:{"media-list":""}},[(_vm.type === 'team')?_c('f7-list-item',{attrs:{"link":"/room/add/","title":"Room channel","text":"Chat with your team around a certain topic","media":_vm.icons.room}}):_vm._e(),_vm._v(" "),(_vm.type === 'customer')?_c('f7-list-item',{attrs:{"link":"/website/add/","title":"Website channel","text":"Chat with your customers on your website","media":_vm.icons.website}}):_vm._e(),_vm._v(" "),(_vm.type === 'customer')?_c('f7-list-item',{attrs:{"link":"/email/select/","title":"Email channel","text":"Chat with your customers through your Email inbox","media":_vm.icons.email}}):_vm._e(),_vm._v(" "),(_vm.type === 'customer')?_c('f7-list-item',{attrs:{"link":"/facebook/select/","title":"Facebook channel","text":"Chat with your customers on your Facebook page","media":_vm.icons.facebook}}):_vm._e(),_vm._v(" "),(_vm.type === 'customer')?_c('f7-list-item',{attrs:{"link":"/instagram/select/","title":"Instagram channel","text":"Chat with your customers on your Instagram page","media":_vm.icons.instagram}}):_vm._e()],1)],1)],1)],1)};
	var __vue_staticRenderFns__$16 = [];

	  /* style */
	  var __vue_inject_styles__$19 = undefined;
	  /* scoped */
	  var __vue_scope_id__$19 = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$19 = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$19 = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$19 = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$16, staticRenderFns: __vue_staticRenderFns__$16 },
	    __vue_inject_styles__$19,
	    __vue_script__$18,
	    __vue_scope_id__$19,
	    __vue_is_functional_template__$19,
	    __vue_module_identifier__$19,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//

	var script$19 = {
	  name: 'Notifications',
	  data: function data() {
	    var self = this;
	    var store = new Store(self, {
	      get: ['notificationmessage', 'list'],
	      subscribe: ['notificationmessage', 'list', 'notifications', { processLocally: true }],
	      subscribeFinished: function () {
	        store.get();
	      },
	      itemsGroupKey: 'textArray',
	      getStarted: function getStarted() {
	        self.getFinished = false;
	        self.getStarted = true;
	      },
	      getFinished: function getFinished() {
	        self.notificationsLoaded = true;
	        self.getStarted = false;
	        self.getFinished = true;
	      },
	      getLocalFinished: function getLocalFinished() {}, // Do nothing function to avoid calling handleGetFinished (which messes up the badge count)
	    });
	    return {
	      store: store,
	      notificationsLoaded: false,
	      getStarted: false,
	      getFinished: false,
	    };
	  },
	  watch: {
	    'store.isLoading': function watchIsLoading(isLoading) {
	      var self = this;
	      if (isLoading === true && self.getStarted && !self.getFinished) {
	        Brief$1.showProgress(this.$el);
	      }
	    },
	    getFinished: function getFinished(getFinished$1) {
	      if (getFinished$1) {
	        Brief$1.hideProgress(this.$el);
	      }
	    },
	  },
	  computed: {
	    orderedNotifications: function orderedNotifications() {
	      var ordered = Utils$1.orderByDate(this.store.notifications, true, 'createdDate');
	      return ordered;
	    },
	    isEmpty: function isEmpty() {
	      return !this.store.notifications || (this.store.notifications.length === 0 && this.notificationsLoaded);
	    },
	  },
	  mounted: function mounted() {
	    var self = this;
	    self.store.get();
	  },
	  beforeDestroy: function beforeDestroy() {
	    var self = this;
	    self.store.dispose();
	  },
	  methods: {
	    linkifyMessage: function linkifyMessage(text) {
	      return linkify(text);
	    },
	    datefy: function datefy(date) {
	      return Datefy(date);
	    },
	    onInfinite: function onInfinite() {
	      this.store.getMore();
	    },
	    getTitle: function getTitle(notification) {
	      var title = notification.userFullname;
	      var streamName = '';

	      if (notification.streamName) {
	        streamName = notification.streamName;
	      } else if (notification.pageType === 'comment') {
	        streamName = 'Comment';
	      } else if (notification.pageType === 'post') {
	        streamName = 'Wall';
	      }

	      if (notification.textArray.length > 1) {
	        return streamName;
	      }

	      if (!title) {
	        title = streamName;
	      } else if (streamName) {
	        title += " to " + streamName;
	      }

	      return title;
	    },
	    getLink: function getLink(notification) {
	      if (notification.pageType === 'email' && notification.group) {
	        return ("/email/" + (notification.streamId) + "/");
	      } else if (notification.pageType === 'email') {
	        return ("/email/" + (notification.streamId) + "/" + (notification.extraParam1) + "/");
	      } else if (notification.pageType === 'website' && notification.group) {
	        return ("/website/" + (notification.streamId) + "/");
	      } else if (notification.pageType === 'website') {
	        return ("/website/" + (notification.streamId) + "/" + (encodeURIComponent(notification.extraParam1)) + "/");
	      } else if (notification.pageType === 'facebook' && notification.group) {
	        return ("/facebook/" + (notification.streamId) + "/");
	      } else if (notification.pageType === 'facebook') {
	        return ("/facebook/" + (notification.streamId) + "/" + (notification.extraParam1) + "/");
	      } else if (notification.pageType === 'room') {
	        return ("/room/" + (notification.pageId) + "/");
	      } else if (notification.pageType === 'comment') {
	        return ("/post/" + (notification.pageId) + "/");
	      } else if (notification.pageType === 'instagram' && notification.group) {
	        return ("/instagram/" + (notification.pageId) + "/");
	      } else if (notification.pageType === 'instagram') {
	        return ("/instagram/" + (notification.pageId) + "/" + (notification.extraParam1) + "/");
	      }
	      return ("/post/" + (notification.pageId) + "/");
	    },
	    getUserPhoto: function getUserPhoto(notification) {
	      if (notification.textArray.length > 1 && !notification.useAvatar) { return { filename: ((notification.pageType) + "_notification.png") }; }
	      if (!notification.userPhoto && notification.pageType === 'facebook' && notification.facebookUserId) {
	        return { filename: ((this.domain) + "/api/facebook/picture?id=" + (notification.facebookUserId) + "&channelId=" + (notification.pageId)) }
	      }
	      if (!notification.userPhoto && notification.pageType === 'instagram' && notification.avatarUrl) { return { filename: notification.avatarUrl }; }
	      //if (!notification.userPhoto && !!notification.group) { return { filename: `${notification.pageType}_notification.png` }; }
	      return notification.userPhoto;
	    },
	  },
	};

	/* script */
	var __vue_script__$19 = script$19;

	/* template */
	var __vue_render__$17 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f7-page',{staticClass:"page-conversations",attrs:{"infinite":"","infinite-distance":400,"infinite-preloader":false},on:{"infinite":_vm.onInfinite}},[_c('common-navbar',{attrs:{"title":"All messages","root":true}}),_vm._v(" "),_c('common-offline-indicator',{attrs:{"store":_vm.store}}),_vm._v(" "),_c('div',{staticClass:"content-center content-spacing"},[_c('div',{staticClass:"list notifications-list conversation-list media-list"},[_c('ul',_vm._l((_vm.orderedNotifications),function(notification){return _c('li',[_c('a',{staticClass:"item-link",attrs:{"href":_vm.getLink(notification) + '?back_link=1'}},[_c('div',{staticClass:"item-content"},[_c('div',{staticClass:"item-media"},[(!_vm.getUserPhoto(notification) && !!notification.group && notification.pageType === 'facebook')?_c('span',{staticClass:"common-avatar common-avatar-icon",attrs:{"slot":"media"},slot:"media"},[_c('f7-icon',{attrs:{"if-ios":"f7:social_facebook","if-md":"f7:social_facebook"}})],1):(!_vm.getUserPhoto(notification) && !!notification.group && notification.pageType === 'instagram')?_c('span',{staticClass:"common-avatar common-avatar-icon",attrs:{"slot":"media"},slot:"media"},[_c('f7-icon',{attrs:{"if-ios":"f7:social_instagram","if-md":"f7:social_instagram"}})],1):(!_vm.getUserPhoto(notification) && !!notification.group && notification.pageType === 'email')?_c('span',{staticClass:"common-avatar common-avatar-icon",attrs:{"slot":"media"},slot:"media"},[_c('f7-icon',{attrs:{"if-ios":"f7:email","if-md":"f7:email"}})],1):(!_vm.getUserPhoto(notification) && !!notification.group && notification.pageType === 'room')?_c('span',{staticClass:"common-avatar common-avatar-icon",attrs:{"slot":"media"},slot:"media"},[_c('f7-icon',{attrs:{"if-ios":"f7:chats","if-md":"f7:chats"}})],1):(!_vm.getUserPhoto(notification) && _vm.getTitle(notification))?_c('span',{staticClass:"common-avatar common-avatar-text",attrs:{"slot":"media"},slot:"media"},[_vm._v(_vm._s(_vm.getTitle(notification)[0].toUpperCase()))]):_c('common-avatar',{attrs:{"slot":"media","avatar":_vm.getUserPhoto(notification)},slot:"media"})],1),_vm._v(" "),_c('div',{staticClass:"item-inner"},[_c('div',{staticClass:"item-title-row"},[_c('div',{staticClass:"item-title"},[_vm._v(_vm._s(_vm.getTitle(notification)))]),_vm._v(" "),_c('div',{staticClass:"item-after"},[_c('span',[_vm._v(_vm._s(_vm.datefy(notification.createdDate)))])])]),_vm._v(" "),_vm._l((notification.textArray),function(t){return _c('div',{staticClass:"item-text"},[_vm._v(_vm._s(t))])})],2)])])])}),0)])]),_vm._v(" "),(!_vm.store.noMoreToGet)?_c('div',{staticClass:"infinite-scroll-preloader",class:{invisible: !_vm.store.isLoading}},[_c('f7-preloader')],1):_vm._e(),_vm._v(" "),(_vm.isEmpty && !_vm.store.isLoading)?_c('common-empty-message'):_vm._e()],1)};
	var __vue_staticRenderFns__$17 = [];

	  /* style */
	  var __vue_inject_styles__$1a = undefined;
	  /* scoped */
	  var __vue_scope_id__$1a = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$1a = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$1a = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$1a = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$17, staticRenderFns: __vue_staticRenderFns__$17 },
	    __vue_inject_styles__$1a,
	    __vue_script__$19,
	    __vue_scope_id__$1a,
	    __vue_is_functional_template__$1a,
	    __vue_module_identifier__$1a,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	var _$1 = ( lodash$1 && lodash ) || lodash$1;

	var utils$3 = createCommonjsModule(function (module) {
	var MAX_TEXT_LENGTH = 40;

	var getLikeMessage = function (userId, p, count) {
	  if ( count === void 0 ) count = 3;

	  if (!p.likes || p.likes.length === 0) {
	    return '';
	  }
	  var isLikedByMe = p.likes.find(function (x) { return x.id === userId; });
	  var likeMessage = '';
	  var userCountToDisplayNames = count;
	  var otherUsersCount = p.likes.length - userCountToDisplayNames;
	  if (isLikedByMe) {
	    userCountToDisplayNames -= 1;
	    if (p.likes.length < count) {
	      likeMessage += 'You ';
	    } else if (userCountToDisplayNames === 1 && p.likes.length > count) {
	      likeMessage += 'You';
	    } else {
	      likeMessage += 'You, ';
	    }
	  }
	  var likedUsers = _$1.filter(p.likes, function (x) { return x.id !== userId; });
	  if (likedUsers.length === 0) {
	    return 'You like this';
	  }
	  if (likedUsers.length === 1) {
	    if (isLikedByMe) {
	      return ("You and " + (likedUsers[0].firstName) + " like this");
	    }
	    return ((likedUsers[0].firstName) + " like this");
	  }
	  var users = _$1.take(likedUsers, userCountToDisplayNames);
	  for (var i = 0; i < users.length - 1; i++) {
	    likeMessage += users[i].firstName;
	    if (i + 1 < users.length - 1) {
	      likeMessage += ', ';
	    }
	  }
	  if (otherUsersCount < 1) {
	    likeMessage += " and " + (users[users.length - 1].firstName);
	  } else {
	    likeMessage += ", " + (users[users.length - 1].firstName) + " and " + otherUsersCount + " others";
	  }
	  var text = likeMessage + " like this";
	  if (text.length > MAX_TEXT_LENGTH && count > 1) {
	    return getLikeMessage(userId, p, count - 1);
	  }
	  return text;
	};
	module.exports.getLikeMessage = getLikeMessage;

	var getCurrentPeriodForSubscription = function (subscriptionStartDate) {
	  var now = require$$0$6().startOf('day');
	  var currentDate = require$$0$6(subscriptionStartDate).startOf('day');
	  while (currentDate <= now) {
	    currentDate = currentDate.add(1, 'month');
	  }
	  return {
	    startDate: require$$0$6(currentDate).subtract(1, 'month').toDate(),
	    endDate: currentDate.toDate(),
	  };
	};
	module.exports.getCurrentPeriodForSubscription = getCurrentPeriodForSubscription;

	module.exports.getContactName = function (contact) {
	  if (contact.firstName === 'Website' && contact.lastName === 'User' && contact.email) {
	    return contact.email;
	  }
	  if (contact.firstName === 'Anonymous' && contact.email) {
	    return contact.email;
	  }
	  if (contact.firstName && contact.firstName.length > 0) {
	    var name = contact.firstName;
	    if (contact.lastName && contact.lastName.length > 0) {
	      name += " " + (contact.lastName);
	    }
	    return name;
	  }
	  if (contact.fullName || contact.username) {
	    return contact.fullName || contact.username;
	  }

	  return contact.email && contact.email.length > 0
	    ? contact.email
	    : 'Anonymous';
	};
	});
	var utils_1$2 = utils$3.getLikeMessage;
	var utils_2$1 = utils$3.getCurrentPeriodForSubscription;
	var utils_3$1 = utils$3.getContactName;

	//

	function handleGetStarted() {
	  var self = this;
	  self.getFinished = false;
	  self.getStarted = true;
	}
	function handleGetFinished$4() {
	  var self = this;
	  self.messagesLoaded = true;
	  self.getStarted = false;
	  self.getFinished = true;
	  self.checkQueue();
	  self.$nextTick(function () {
	    Brief$1.events.$emit('files-updated');
	  });
	}
	function handleGetError() {
	  var self = this;
	  self.getStarted = false;
	  self.getFinished = true;
	}
	function send(message) {
	  var self = this;
	  message.queueId = Utils$1.newGuid();
	  message.isLikedByMe = false;
	  message.likeCount = 0;
	  message.commentCount = 0;
	  message.fullName = message.fullName || (((self.$root.loggedInUser.firstName) + " " + (self.$root.loggedInUser.lastName)));

	  self.store.messages.push(message);
	  handleGetFinished$4.call(self);
	  self.store.postForm(message);
	}
	function like(message) {
	  var self = this;
	  var userId = window.localStorage.getItem('user_id');
	  message.isLikedByMe = !message.isLikedByMe;
	  message.likeCount = message.isLikedByMe ? message.likeCount + 1 : message.likeCount - 1;
	  self.storeLike.postNow({ messageId: message.id });
	}
	function inviteTeam() {
	  gtag('event', 'tip_1_click', {
	    event_category: 'tips',
	    event_label: 'Click on Tip 1',
	  });
	  Brief$1.f7.panel.close();
	  Brief$1.f7.panel.open('right');
	  Brief$1.events.$emit('info-invite-team', 'intro');
	  setTimeout(function () { Brief$1.events.$emit('close-info-invite'); }, this.autoInfoDismissTimeout);
	}
	function addStreams() {
	  gtag('event', 'tip_2_click', {
	    event_category: 'tips',
	    event_label: 'Click on Tip 2',
	  });
	  Brief$1.f7.panel.close();
	  Brief$1.f7.panel.open('left');
	  Brief$1.events.$emit('info-add-channels');
	  setTimeout(function () { Brief$1.events.$emit('close-info-stream'); }, this.autoInfoDismissTimeout);
	}
	function updateProfile() {
	  gtag('event', 'tip_3_click', {
	    event_category: 'tips',
	    event_label: 'Click on Tip 3',
	  });
	  Brief$1.f7.panel.close();
	  Brief$1.f7.panel.open('right');
	  Brief$1.events.$emit('info-update-profile');
	  setTimeout(function () { Brief$1.events.$emit('close-info-profile'); }, this.autoInfoDismissTimeout);
	}

	function handlePreProcess$4(data) {
	  var self = this;

	  var userId = self.$root.loggedInUser.id;
	  data.isMyMessage = userId === data.userId;
	  data.isLikedByMe = data.likes.find(function (x) { return x.id === userId; }) !== undefined;

	  return true;
	}
	var messageDates = {};
	var script$1a = {
	  name: 'PostList',
	  watch: {
	    'store.isLoading': function watchIsLoading(isLoading) {
	      var self = this;
	      if (isLoading === true && self.getStarted && !self.getFinished) {
	        Brief$1.showProgress(this.$el);
	      }
	    },
	    getFinished: function getFinished(getFinished$1) {
	      if (getFinished$1) {
	        Brief$1.hideProgress(this.$el);
	      }
	    },
	    orderedMessages: function orderedMessages() {
	      var self = this;
	      if (self.lazyImagesInitialized) {
	        self.$nextTick(function () {
	          $$1(self.$el).trigger('lazy');
	        });
	      } else {
	        self.$nextTick(function () {
	          if ($$1(self.$el).find('img.lazy').length > 0) {
	            self.lazyImagesInitialized = true;
	            Brief$1.f7.lazy.create(self.$el);
	          }
	        });
	      }
	    },
	  },
	  data: function data() {
	    var self = this;
	    var store = new Store(self, {
	      preProcess: handlePreProcess$4,
	      get: ['post', 'list'],
	      postForm: ['post', 'create'],
	      subscribe: ['post', 'list', 'messages'],
	      getLocalFinished: function getLocalFinished() {
	        self.store.messages.forEach(function (m) {
	          if (m.isNew || m.queueId) {
	            self.sendingMessages.push(m);
	          }
	        });
	      },
	      getFinished: handleGetFinished$4,
	      getMoreFinished: function getMoreFinished() {
	        self.checkQueue();
	      },
	      subscribeFinished: function subscribeFinished(response) {
	        var post = self.store.messages.find(function (x) { return x.id === response.id; });
	        var postIndex = self.store.messages.findIndex(function (x) { return x.id === response.id; });
	        if (post) {
	          var userId = window.localStorage.getItem('user_id');
	          post.likeMessage = utils_1$2(userId, response);
	          Vue.set(self.store.messages, postIndex, post);
	        }
	        self.checkQueue();
	      },
	      getError: handleGetError,
	      getStarted: handleGetStarted,
	    });
	    var storeLike = new Store(self, {
	      postNow: ['post', 'like'],
	    });
	    var deletePostStore = new Store(self, {
	      post: ['post', 'delete', {}],
	    });
	    return {
	      store: store,
	      storeLike: storeLike,
	      deletePostStore: deletePostStore,
	      messagesLoaded: false,
	      lazyImagesInitialized: false,
	      allowIntroduction: true,
	      getStarted: false,
	      getFinished: false,
	      sendingMessages: [],
	    };
	  },
	  created: function created() {
	    var self = this;
	    ClientStorage.get('wall-introduction')
	      .then(function (allowIntroduction) {
	        if (allowIntroduction === false || allowIntroduction === 'false') {
	          self.allowIntroduction = false;
	        }
	      });
	  },
	  computed: {
	    orderedMessages: function orderedMessages() {
	      var ordered = Utils$1.orderByDate(this.store.messages, true, 'sendDate');
	      return ordered;
	    },
	    showIntroduction: function showIntroduction() {
	      if (!this.allowIntroduction) { return false; }
	      if (!this.messagesLoaded) { return false; }
	      if (!this.store.messages || this.store.messages.length === 0 || this.store.isNewUser) {
	        return true;
	      }
	      return false;
	    },
	  },
	  mounted: function mounted() {
	    var self = this;
	    // Compiled
	    self.autoInfoDismissTimeout = 15000;
	    Brief$1.events.$on('messages-refresh', self.reload);
	    Brief$1.events.$on('comments-message-created', self.reload);
	    self.store.get();
	  },
	  beforeDestroy: function beforeDestroy() {
	    var self = this;

	    Brief$1.events.$off('messages-refresh', self.reload);
	    Brief$1.events.$off('comments-message-created', self.reload);
	    self.store.dispose();
	    self.storeLike.dispose();
	    if (self.lazyImagesInitialized) { Brief$1.f7.lazy.destroy(self.$el); }
	    $$1(self.$el).find('img').attr('src', '');
	  },
	  methods: {
	    checkQueue: function checkQueue() {
	      var self = this;
	      queue$1.checkStoreMessagesQueue(self.sendingMessages, self.store.messages);
	    },
	    like: like,
	    inviteTeam: inviteTeam,
	    addStreams: addStreams,
	    updateProfile: updateProfile,
	    send: send,
	    hideIntroduction: function hideIntroduction() {
	      var self = this;
	      self.allowIntroduction = false;
	      ClientStorage.save('wall-introduction', false);
	    },
	    reload: function reload() {
	      var self = this;
	      self.store.reload();
	    },
	    datefyMessage: function datefyMessage(message) {
	      if (!messageDates[message.id]) {
	        messageDates[message.id] = Datefy(message.sendDate);
	      }
	      return messageDates[message.id];
	    },
	    goToDetails: function goToDetails(message) {
	      Brief$1.viewMain.router.navigate(("/post/" + (message.id) + "/"));
	    },
	    parseMessage: function parseMessage(message) {
	      var text = this.$root.striptags(message.text);
	      text = linkify(text);

	      if (message.mentions) {
	        if (message.mentions.users) {
	          Object.keys(message.mentions.users).forEach(function (userName) {
	            var re = new RegExp(("@" + userName), 'g');
	            text = text.replace(re, ("<a href=\"/user/" + (message.mentions.users[userName]) + "/\" data-view=\".view-right\" class=\"panel-open\" data-panel=\"right\">@" + userName + "</a>"));
	          });
	        }
	        if (message.mentions.channels) {
	          Object.keys(message.mentions.channels).forEach(function (channelName) {
	            var re = new RegExp(("#" + channelName), 'g');
	            var channel = message.mentions.channels[channelName];
	            text = text.replace(re, ("<a href=\"/" + (channel.type) + "/" + (channel.id) + "/\" data-reload-all=\"true\" data-view=\".view-main\">#" + channelName + "</a>"));
	          });
	        }
	      }

	      return text;
	    },
	    onInfinite: function onInfinite() {
	      var self = this;
	      self.store.getMore();
	    },
	    deletePost: function deletePost(message) {
	      var self = this;
	      if (!message || !message.id) { return; }
	      self.deletePostStore.post({
	        id: message.id,
	      });
	    },
	    messageIsEditable: function messageIsEditable(message) {
	      var self = this;
	      var isMyMessage = message.isMyMessage;
	      if (typeof isMyMessage === 'undefined' && message.userId) {
	        isMyMessage = message.userId === self.$root.loggedInUser.id;
	      }
	      if (isMyMessage) { return true; }
	      return false;
	    },
	    postIsCopyable: function postIsCopyable(message) {
	      return message.text && Utils$1.mobileDevice();
	    },
	    openMessageActions: function openMessageActions(e, message) {
	      var self = this;
	      if (!message) { return; }
	      var isTouchDevice = Utils$1.mobileDevice();
	      var editable = self.messageIsEditable(message);

	      if (!editable && !message.text) {
	        return;
	      }

	      var buttons = [];
	      if (isTouchDevice && message.text) {
	        buttons.push({
	          text: 'Copy Text',
	          onClick: function onClick() {
	            var copied = Clipboard.copy(message.text);
	            if (copied) {
	              Brief$1.f7.toast.create({
	                icon: self.$theme.ios ? '<i class="f7-icons">check</i>' : '<i class="material-icons">check</i>',
	                text: 'Text copied',
	                position: 'center',
	                closeTimeout: 2000,
	              }).open();
	            }
	          },
	        });
	      }
	      if (editable) {
	        buttons.push({
	          text: 'Delete Post',
	          color: 'red',
	          onClick: function onClick() {
	            Brief$1.f7.dialog.confirm('Are you sure want to delete this post? This cannot be undone.', function () {
	              self.deletePost(message);
	            });
	          },
	        });
	      }

	      var modal = ActionsModal(buttons, e.target);
	      modal.open();
	    },
	  },
	};

	/* script */
	var __vue_script__$1a = script$1a;

	/* template */
	var __vue_render__$18 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f7-page',{staticClass:"page-posts",attrs:{"infinite":"","infinite-distance":400,"infinite-preloader":false},on:{"infinite":_vm.onInfinite}},[_c('common-navbar',{attrs:{"title":"Wall","root":true}}),_vm._v(" "),_c('common-offline-indicator',{attrs:{"slot":"fixed","store":_vm.store},slot:"fixed"}),_vm._v(" "),_c('common-write',{staticClass:"messagebar-top content-center content-spacing content-round",attrs:{"file-upload":true,"disable-focus-after-send":true,"top":true,"use-mentions":true,"id":"wall","type":"wall","placeholder":"Write post on team wall"},on:{"send":_vm.send}}),_vm._v(" "),(_vm.showIntroduction)?_c('div',{staticClass:"brief-cards-list"},[_c('ul',[_c('li',{staticClass:"brief-card content-round"},[(_vm.orderedMessages && _vm.orderedMessages.length > 0)?_c('f7-link',{staticClass:"hide-introduction-link",attrs:{"icon-if-ios":"f7:close","icon-if-md":"material:close"},on:{"click":_vm.hideIntroduction}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"brief-card-header"},[_c('common-avatar',{attrs:{"avatar":{ filename: '384a5f73-1e6a-489d-a7ef-f802e1335bdd.jpeg' }}}),_vm._v(" "),_c('div',{staticClass:"brief-card-name",staticStyle:{"margin-top":"10px"}},[_vm._v("The Salon Business")])],1),_vm._v(" "),(_vm.$root.loggedInUser.isAdmin)?_c('div',{staticClass:"brief-card-content"},[_vm._v("\n          Hi and welcome to Brief!"),_c('br'),_c('br'),_vm._v("\n          As you can see Brief is quite empty right now, that is intentional to keep it simple and clean."),_c('br'),_c('br'),_vm._v("\n          Now let's customize it for you. I will help you setup the basics when you click on the links below:"),_c('br'),_c('br'),_vm._v(" "),_c('span',{staticClass:"text-badge color-blue"},[_vm._v("1")]),_vm._v(" "),_c('a',{attrs:{"href":"#"},on:{"click":_vm.inviteTeam}},[_vm._v("Start off by inviting people that you might be missing on your team")]),_c('br'),_c('br'),_vm._v(" "),_c('span',{staticClass:"text-badge color-blue"},[_vm._v("2")]),_vm._v(" "),_c('a',{attrs:{"href":"#"},on:{"click":_vm.addStreams}},[_vm._v("Next, check if there is any more channels that you like to add")]),_c('br'),_c('br'),_vm._v(" "),_c('span',{staticClass:"text-badge color-blue"},[_vm._v("3")]),_vm._v(" "),_c('a',{attrs:{"href":"#"},on:{"click":_vm.updateProfile}},[_vm._v("And last, make sure your profile has a photo and work title")]),_c('br'),_c('br'),_vm._v("\n          Good luck!"),_c('br'),_c('br')]):_c('div',{staticClass:"brief-card-content"},[_vm._v("\n          Hi and welcome to Brief!"),_c('br'),_c('br'),_vm._v("\n          Let's customize Brief for you. I will help you setup the basics when you click on the links below:"),_c('br'),_c('br'),_vm._v(" "),_c('span',{staticClass:"text-badge color-blue"},[_vm._v("1")]),_vm._v(" "),_c('a',{attrs:{"href":"#"},on:{"click":_vm.inviteTeam}},[_vm._v("Start off by inviting people that you might be missing on your team")]),_c('br'),_c('br'),_vm._v(" "),_c('span',{staticClass:"text-badge color-blue"},[_vm._v("2")]),_vm._v(" "),_c('a',{attrs:{"href":"#"},on:{"click":_vm.addStreams}},[_vm._v("Next, check if there is any more channels that you like to add")]),_c('br'),_c('br'),_vm._v(" "),_c('span',{staticClass:"text-badge color-blue"},[_vm._v("3")]),_vm._v(" "),_c('a',{attrs:{"href":"#"},on:{"click":_vm.updateProfile}},[_vm._v("And last, make sure your profile has a photo and work title")]),_c('br'),_c('br'),_vm._v("\n          Good luck!"),_c('br'),_c('br')])],1)])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"brief-cards-list"},[_c('ul',_vm._l((_vm.orderedMessages),function(message){return _c('li',{key:message.id,staticClass:"brief-card content-round"},[(_vm.messageIsEditable(message) || _vm.postIsCopyable(message))?_c('f7-link',{staticClass:"brief-card-actions-link",attrs:{"icon-material":"more_vert"},on:{"click":function($event){return _vm.openMessageActions($event, message, true)}}}):_vm._e(),_vm._v(" "),_c('a',{staticClass:"brief-card-header panel-open",attrs:{"href":("/user/" + (message.userId) + "/"),"data-view":".view-right","data-panel":"right"}},[_c('common-avatar',{attrs:{"avatar":message.userPhoto}}),_vm._v(" "),_c('div',{staticClass:"brief-card-name"},[_vm._v(_vm._s(message.fullName))]),_vm._v(" "),_c('div',{staticClass:"brief-card-date"},[_vm._v(_vm._s(_vm.datefyMessage(message, message.sendDate)))])],1),_vm._v(" "),_c('div',{staticClass:"brief-card-content"},[(message.text)?_c('span',{staticClass:"card-text",domProps:{"innerHTML":_vm._s(_vm.parseMessage(message))},on:{"click":function($event){return _vm.goToDetails(message)}}}):_vm._e(),_vm._v(" "),(message.files && message.files.length > 0)?_c('common-files',{attrs:{"files":message.files,"use-img":true,"lazy":true}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"brief-card-footer",class:{'inactive': !message.id}},[_c('f7-link',{staticClass:"like-button",class:{'liked': message.isLikedByMe},attrs:{"icon-material":"thumb_up"},on:{"click":function($event){return _vm.like(message)}}},[_vm._v(_vm._s(message.likeCount))]),_vm._v(" "),(!!message.likeMessage)?_c('f7-link',{staticClass:"like-list",class:{'liked': message.isLikedByMe},attrs:{"href":'/post/' + message.id + '/likes/'}},[_vm._v(_vm._s(message.likeMessage))]):_vm._e(),_vm._v(" "),_c('f7-link',{staticClass:"comment-button",attrs:{"href":'/post/' + message.id + '/',"icon-if-ios":"f7:chat","icon-if-md":"material:chat_bubble_outline"}},[_vm._v(_vm._s(message.commentCount))])],1)],1)}),0)]),_vm._v(" "),(!_vm.store.noMoreToGet)?_c('div',{staticClass:"infinite-scroll-preloader",class:{invisible: !_vm.store.isLoading}},[_c('f7-preloader')],1):_vm._e()],1)};
	var __vue_staticRenderFns__$18 = [];

	  /* style */
	  var __vue_inject_styles__$1b = undefined;
	  /* scoped */
	  var __vue_scope_id__$1b = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$1b = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$1b = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$1b = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$18, staticRenderFns: __vue_staticRenderFns__$18 },
	    __vue_inject_styles__$1b,
	    __vue_script__$1a,
	    __vue_scope_id__$1b,
	    __vue_is_functional_template__$1b,
	    __vue_module_identifier__$1b,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//

	function handlePreProcess$5(data) {
	  var self = this;

	  data.isMyMessage = self.$root.loggedInUser.id === data.userId;

	  return true;
	}

	var script$1b = {
	  name: 'CommentList',
	  props: ['params'],
	  data: function data() {
	    var self = this;
	    var conversationId = self.$f7route.params.id;
	    var store = new Store(self, {
	      preProcess: handlePreProcess$5,
	      get: ['comment', 'list', { conversationId: conversationId }],
	      postForm: ['comment', 'create', { conversationId: conversationId }],
	      subscribe: ['comment', 'list', 'messages', { subscriptionKey: conversationId }],
	    });
	    var storeIsTyping = new Store(self, {
	      postNow: ['message', 'istyping', { channelId: conversationId, contextId: conversationId, type: 'comment' }],
	      subscribe: ['comment', 'istyping', null, { processLocally: true, subscriptionKey: conversationId }],
	      subscribeFinished: function (data) {
	        self.$refs.chat.showTyping(data);
	      },
	    });

	    var storeEdit = new Store(self, {
	      post: ['comment', 'edit', {}],
	    });

	    var storeDelete = new Store(self, {
	      post: ['comment', 'delete', {}],
	    });

	    var storeEditPost = new Store(self, {
	      post: ['post', 'edit', {}],
	    });

	    var storeDeletePost = new Store(self, {
	      post: ['post', 'delete', {}],
	      postFinished: function postFinished(result) {
	        if (result.success) {
	          Brief$1.viewMain.router.back();
	        }
	      },
	    });

	    return {
	      conversationId: conversationId,
	      store: store,
	      storeIsTyping: storeIsTyping,
	      storeEdit: storeEdit,
	      storeDelete: storeDelete,
	      storeEditPost: storeEditPost,
	      storeDeletePost: storeDeletePost,
	    };
	  },
	};

	/* script */
	var __vue_script__$1b = script$1b;

	/* template */
	var __vue_render__$19 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('channel-chat-page',{ref:"chat",attrs:{"navbarTitle":"Reply","navbarRoot":false,"type":"comments","conversation-id":_vm.conversationId,"store":_vm.store,"storeIsTyping":_vm.storeIsTyping,"storeEdit":_vm.storeEdit,"storeDelete":_vm.storeDelete,"storeEditPost":_vm.storeEditPost,"storeDeletePost":_vm.storeDeletePost,"focus-on-load":true,"use-mentions":true,"use-saved-replies":true}})};
	var __vue_staticRenderFns__$19 = [];

	  /* style */
	  var __vue_inject_styles__$1c = undefined;
	  /* scoped */
	  var __vue_scope_id__$1c = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$1c = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$1c = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$1c = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$19, staticRenderFns: __vue_staticRenderFns__$19 },
	    __vue_inject_styles__$1c,
	    __vue_script__$1b,
	    __vue_scope_id__$1c,
	    __vue_is_functional_template__$1c,
	    __vue_module_identifier__$1c,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//

	var script$1c = {
	  props: {
	    type: String,
	    id: String,
	  },
	  data: function data() {
	    var self = this;
	    var ref = self.$f7route.params;
	    var id = ref.id;

	    var storeUsers = new Store(self, {
	      get: ['post', 'likes', { id: id }],
	    });
	    storeUsers.get();

	    return {
	      storeUsers: storeUsers,
	      noTouch: !Utils$1.mobileDevice(),
	      currentUserId: window.localStorage.getItem('user_id'),
	    };
	  },
	  computed: {
	  },
	  methods: {
	    onPageBeforeIn: function onPageBeforeIn(e, page) {
	      var self = this;
	      if (page && page.direction === 'backward') {
	        self.storeUsers.reload();
	      }
	    },
	  },
	};

	/* script */
	var __vue_script__$1c = script$1c;

	/* template */
	var __vue_render__$1a = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f7-page',{staticClass:"page-form",on:{"page:beforein":_vm.onPageBeforeIn}},[_c('common-navbar',{attrs:{"title":"Likes"}}),_vm._v(" "),_c('f7-list',{attrs:{"media-list":""}},[_c('ul',{staticClass:"content-round"},_vm._l((_vm.storeUsers.users),function(item){return _c('li',{key:item.id,staticClass:"swipeout",class:{'swipeout-desktop': _vm.noTouch}},[_c('div',{staticClass:"swipeout-content"},[_c('a',{staticClass:"item-link panel-open",attrs:{"href":("/user/" + (item.id) + "/"),"data-view":".view-right","data-panel":"right"}},[_c('div',{staticClass:"item-content"},[_c('div',{staticClass:"item-media"},[_c('common-avatar',{attrs:{"slot":"media","avatar":item.photoFile},slot:"media"})],1),_vm._v(" "),_c('div',{staticClass:"item-inner"},[_c('div',{staticClass:"item-title-row",staticStyle:{"background":"inherit"}},[_c('div',{staticClass:"item-title"},[_vm._v(_vm._s(item.firstName)+" "+_vm._s(item.lastName || ''))])])])])])])])}),0)])],1)};
	var __vue_staticRenderFns__$1a = [];

	  /* style */
	  var __vue_inject_styles__$1d = undefined;
	  /* scoped */
	  var __vue_scope_id__$1d = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$1d = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$1d = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$1d = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$1a, staticRenderFns: __vue_staticRenderFns__$1a },
	    __vue_inject_styles__$1d,
	    __vue_script__$1c,
	    __vue_scope_id__$1d,
	    __vue_is_functional_template__$1d,
	    __vue_module_identifier__$1d,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//

	var script$1d = {
	  name: 'InfoProfileUpdate',
	  data: function data() {
	    return {
	      isVisible: false,
	    };
	  },
	  mounted: function mounted() {
	    var self = this;
	    Brief$1.events.$on('info-invite-team', function () {
	      self.isVisible = false;
	    });
	    Brief$1.events.$on('info-update-profile', function () {
	      self.isVisible = true;
	    });
	    Brief$1.events.$on('info-add-channels', function () {
	      self.isVisible = false;
	    });
	    Brief$1.events.$on('user-link-clicked', function () {
	      self.isVisible = false;
	    });
	    Brief$1.events.$on('close-info-profile', function () {
	      self.isVisible = false;
	    });
	  },
	  beforeDestroy: function beforeDestroy() {
	    Brief$1.events.$off('info-invite-team');
	    Brief$1.events.$off('info-update-profile');
	    Brief$1.events.$off('info-add-channels');
	    Brief$1.events.$off('user-link-clicked');
	    Brief$1.events.$off('close-info-profile');
	  },
	};

	/* script */
	var __vue_script__$1d = script$1d;

	/* template */
	var __vue_render__$1b = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isVisible),expression:"isVisible"}],staticClass:"info-update-profile",class:{'fadeInUp': _vm.isVisible, 'animated': _vm.isVisible},on:{"click":function($event){_vm.isVisible = false;}}},[_c('div',{staticClass:"info-box"},[_vm._v("Click here to edit your profile")])])};
	var __vue_staticRenderFns__$1b = [];

	  /* style */
	  var __vue_inject_styles__$1e = undefined;
	  /* scoped */
	  var __vue_scope_id__$1e = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$1e = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$1e = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$1e = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$1b, staticRenderFns: __vue_staticRenderFns__$1b },
	    __vue_inject_styles__$1e,
	    __vue_script__$1d,
	    __vue_scope_id__$1e,
	    __vue_is_functional_template__$1e,
	    __vue_module_identifier__$1e,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//

	var script$1e = {
	  name: 'PeopleList',
	  components: {
	    infoProfileUpdate: __vue_component__$1e,
	  },
	  data: function data() {
	    return {};
	  },
	  methods: {
	    userLinkClick: function userLinkClick() {
	      Brief$1.events.$emit('user-link-clicked');
	    },
	  },
	};

	/* script */
	var __vue_script__$1e = script$1e;

	/* template */
	var __vue_render__$1c = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f7-page',{attrs:{"infinite":"","infinite-preloader":false,"toolbar-fixed":_vm.$theme.md}},[(_vm.$root.loggedInUser.plan && _vm.$root.loggedInUser.plan.name !== 'Base')?_c('div',[_c('f7-toolbar',{attrs:{"tabbar":""}},[_c('f7-link',{attrs:{"tab-link":"#tab1","tab-link-active":""}},[_vm._v("Team")]),_vm._v(" "),_c('f7-link',{attrs:{"tab-link":"#tab2"}},[_vm._v("Contacts")])],1)],1):_c('f7-navbar',[_c('f7-nav-title',{attrs:{"sliding":"","title":"Contacts"}})],1),_vm._v(" "),(_vm.$root.loggedInUser.plan && _vm.$root.loggedInUser.plan.name !== 'Base')?_c('f7-tabs',{staticClass:"no-horizontal-scroll"},[_c('common-user-list',{staticClass:"tab tab-active",attrs:{"id":"tab1","type":"team","disableHasTagSearch":true,"forceFocusEvent":"info-invite-team","searchPlaceholder":"Search or Invite"}}),_vm._v(" "),_c('common-user-list',{staticClass:"tab",attrs:{"id":"tab2","type":"contacts","forceFocusEvent":"info-invite-contact","searchPlaceholder":"Search or Add"}})],1):_c('common-user-list',{staticClass:"tab",attrs:{"type":"contacts","forceFocusEvent":"info-invite-contact","searchPlaceholder":"Search or Add"}})],1)};
	var __vue_staticRenderFns__$1c = [];

	  /* style */
	  var __vue_inject_styles__$1f = undefined;
	  /* scoped */
	  var __vue_scope_id__$1f = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$1f = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$1f = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$1f = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$1c, staticRenderFns: __vue_staticRenderFns__$1c },
	    __vue_inject_styles__$1f,
	    __vue_script__$1e,
	    __vue_scope_id__$1f,
	    __vue_is_functional_template__$1f,
	    __vue_module_identifier__$1f,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//
	//
	//
	//
	//
	//
	//

	var script$1f = {
	  name: 'ContactDetails',
	};

	/* script */
	var __vue_script__$1f = script$1f;

	/* template */
	var __vue_render__$1d = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('common-user-page',{attrs:{"id":_vm.$f7route.params.id,"contactType":_vm.$f7route.params.contactType,"type":"contact"}})};
	var __vue_staticRenderFns__$1d = [];

	  /* style */
	  var __vue_inject_styles__$1g = undefined;
	  /* scoped */
	  var __vue_scope_id__$1g = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$1g = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$1g = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$1g = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$1d, staticRenderFns: __vue_staticRenderFns__$1d },
	    __vue_inject_styles__$1g,
	    __vue_script__$1f,
	    __vue_scope_id__$1g,
	    __vue_is_functional_template__$1g,
	    __vue_module_identifier__$1g,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//

	function userPostFinished(result) {
	  this.saveInProgress = false;
	  if (result.success) {
	    Brief$1.events.$emit('profile-changed', result.data);
	    this.$root.loggedInUser.get();
	    Brief$1.f7.popup.close();
	  }
	}

	var script$1g = {
	  name: 'UserSettings',
	  components: {
	    userPhotoDetail: __vue_component__$11,
	  },
	  data: function data() {
	    var self = this;
	    var store = new Store(self, {
	      post: ['user', 'update'],
	      postFinished: userPostFinished,
	      sync: false,
	    });
	    var storeNotifications = new Store(self, {
	      post: ['user', 'updatenotifications'],
	      postFinished: userPostFinished,
	      sync: false,
	    });
	    var storeDeleteAccount = new Store(self, {
	      postNow: ['teamuser', 'delete', { id: self.$root.loggedInUser.id }],
	      postNowFinished: function postNowFinished(result) {
	        self.deleteInProgress = false;
	        if (result.success) {
	          Brief$1.logout();
	        }
	      },
	    });
	    return {
	      store: store,
	      storeNotifications: storeNotifications,
	      storeDeleteAccount: storeDeleteAccount,
	      photoFile: self.$root.loggedInUser.photoFile,
	      firstName: self.$root.loggedInUser.firstName,
	      lastName: self.$root.loggedInUser.lastName,
	      title: self.$root.loggedInUser.title,
	      email: self.$root.loggedInUser.email,
	      version: self.$root.loggedInUser.version,
	      saveInProgress: false,
	      deleteInProgress: false,
	    };
	  },
	  beforeDestroy: function beforeDestroy() {
	    var self = this;
	    self.store.dispose();
	  },
	  computed: {
	    isNotificationsDisabled: function isNotificationsDisabled() {
	      return this.$root.loggedInUser.disableNotificatonsUntil &&
	        hooks$1(this.$root.loggedInUser.disableNotificatonsUntil) > hooks$1();
	    },
	    notificationsResumedIn: function notificationsResumedIn() {
	      var disableNotificatonsUntil = this.$root.loggedInUser.disableNotificatonsUntil;
	      if (!disableNotificatonsUntil) {
	        return '';
	      }
	      var startTime = hooks$1();
	      var endTime = hooks$1(disableNotificatonsUntil);
	      var duration = hooks$1.duration(endTime.diff(startTime));
	      var hours = parseInt(duration.asHours());
	      var minutes = parseInt(duration.asMinutes()) - hours * 60;
	      if (hours > 1000) {
	        return null;
	      }
	      if (minutes === 0) {
	        return (hours + "h");
	      }
	      return (hours + "h " + minutes + "m");
	    }
	  },
	  methods: {
	    save: function save() {
	      var self = this;
	      self.saveInProgress = true;

	      self.store.post({
	        firstName: self.firstName,
	        lastName: self.lastName,
	        title: self.title,
	        photoFile: false,
	      });
	    },
	    deleteAccount: function deleteAccount() {
	      var self = this;

	      Brief$1.f7.dialog.confirm('Are you sure you want to delete your account?', function () {
	        self.deleteInProgress = true;
	        self.storeDeleteAccount.postNow();
	      });
	    },
	    onPhotoUpdate: function onPhotoUpdate(photoFile) {
	      this.$set(this.$root.loggedInUser, 'photoFile', photoFile);
	      this.photoFile = this.$root.loggedInUser.photoFile;
	    },
	  },
	};

	/* script */
	var __vue_script__$1g = script$1g;

	/* template */
	var __vue_render__$1e = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f7-page',{staticClass:"page-form"},[_c('f7-navbar',[_c('f7-nav-left',[_c('common-nav-placeholder')],1),_vm._v(" "),_c('f7-nav-title',[_vm._v("\n      Edit Profile\n    ")]),_vm._v(" "),_c('f7-nav-right',[_c('f7-link',{attrs:{"popup-close":""}},[_c('f7-icon',{attrs:{"material":"close","size":"30"}})],1)],1)],1),_vm._v(" "),_c('f7-block',{staticStyle:{"margin-top":"0"}},[_c('user-photo-detail',{attrs:{"photo-file":_vm.photoFile},on:{"photoUpdate":_vm.onPhotoUpdate}})],1),_vm._v(" "),_c('f7-list',{attrs:{"inset":""}},[_c('f7-list-item',{attrs:{"item-input":""}},[_c('f7-input',{attrs:{"type":"text","placeholder":"Firstname","value":_vm.firstName},on:{"input":function($event){_vm.firstName = $event.target.value;}}})],1),_vm._v(" "),_c('f7-list-item',{attrs:{"item-input":""}},[_c('f7-input',{attrs:{"type":"text","placeholder":"Lastname","value":_vm.lastName},on:{"input":function($event){_vm.lastName = $event.target.value;}}})],1),_vm._v(" "),_c('f7-list-item',{staticStyle:{"color":"gray"},attrs:{"title":_vm.email}})],1),_vm._v(" "),_c('f7-list',{attrs:{"inset":""}},[_c('f7-list-button',{on:{"click":_vm.save}},[(!_vm.saveInProgress)?_c('span',[_vm._v("Save")]):_vm._e(),_vm._v(" "),(_vm.saveInProgress)?_c('f7-preloader'):_vm._e()],1)],1),_vm._v(" "),_c('f7-list',{attrs:{"inset":""}},[_c('f7-list-button',{attrs:{"color":"red"},on:{"click":_vm.deleteAccount}},[(!_vm.deleteInProgress)?_c('span',[_vm._v("Delete Account")]):_vm._e(),_vm._v(" "),(_vm.deleteInProgress)?_c('f7-preloader'):_vm._e()],1)],1)],1)};
	var __vue_staticRenderFns__$1e = [];

	  /* style */
	  var __vue_inject_styles__$1h = undefined;
	  /* scoped */
	  var __vue_scope_id__$1h = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$1h = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$1h = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$1h = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$1e, staticRenderFns: __vue_staticRenderFns__$1e },
	    __vue_inject_styles__$1h,
	    __vue_script__$1g,
	    __vue_scope_id__$1h,
	    __vue_is_functional_template__$1h,
	    __vue_module_identifier__$1h,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//

	var script$1h = {
	  name: 'EmailChannelSelect',
	  data: function data() {
	    return {
	      providers: [
	        {
	          name: 'Gmail',
	          link: '/email/permission-gmail/',
	          size: 44,
	          img: "data:image/png;base64,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"
	        },
	        {
	          name: 'iCloud',
	          link: ("/email/add/?provider=" + (this.name)),
	          size: 28,
	          img: 'data:image/png;base64,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',
	        },
	        {
	          name: 'Yahoo',
	          link: ("/email/add/?provider=" + (this.name)),
	          size: 38,
	          img: ("data:image/svg+xml;charset=utf-8," + (encodeURIComponent('<svg width="512" height="119" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid"><defs><linearGradient x1="14.975%" y1="98.428%" x2="81.496%" y2="10.025%" id="a"><stop stop-color="#210045" offset="0%"/><stop stop-color="#430085" offset="59.416%"/><stop stop-color="#5000B2" offset="100%"/></linearGradient><linearGradient x1="6.474%" y1="3.413%" x2="96.87%" y2="98.466%" id="b"><stop stop-color="#5500BD" offset="0%"/><stop stop-color="#5000AC" offset="100%"/></linearGradient><linearGradient x1="67.722%" y1="78.401%" x2="81.981%" y2="75.997%" id="c"><stop stop-color="#2A005A" offset="0%"/><stop stop-color="#210046" offset="100%"/></linearGradient><linearGradient x1="25.266%" y1="99.927%" x2="99.46%" y2="14.029%" id="d"><stop stop-color="#21004E" offset="0%"/><stop stop-color="#39007F" offset="100%"/></linearGradient><linearGradient x1="31.526%" y1="62.532%" x2="43.213%" y2="67.498%" id="e"><stop stop-color="#1B0041" offset="0%"/><stop stop-color="#21004F" offset="100%"/></linearGradient><linearGradient x1="86.973%" y1="-.098%" x2="12.076%" y2="97.304%" id="f"><stop stop-color="#5500BD" offset="0%"/><stop stop-color="#47008D" offset="100%"/></linearGradient><linearGradient x1="20.051%" y1=".784%" x2="99.734%" y2="96.158%" id="g"><stop stop-color="#5100B2" offset="0%"/><stop stop-color="#5500BD" offset="100%"/></linearGradient><linearGradient x1="72.605%" y1="81.925%" x2="84.608%" y2="76.552%" id="h"><stop stop-color="#27005D" stop-opacity=".98" offset="0%"/><stop stop-color="#2B005D" offset="31.767%"/><stop stop-color="#280055" offset="59.756%"/><stop stop-color="#24004D" offset="80.878%"/><stop stop-color="#230049" offset="100%"/></linearGradient><linearGradient x1="32.888%" y1="-.446%" x2="96.379%" y2="100.172%" id="i"><stop stop-color="#5500BD" offset="0%"/><stop stop-color="#5300B5" offset="100%"/></linearGradient><linearGradient x1="84.994%" y1=".48%" x2="84.994%" y2="100.04%" id="j"><stop stop-color="#210045" offset="0%"/><stop stop-color="#25004D" offset="25%"/><stop stop-color="#2B005C" offset="50%"/><stop stop-color="#340071" offset="74.854%"/><stop stop-color="#3E0088" offset="100%"/></linearGradient><linearGradient x1="1.858%" y1="99.053%" x2="99.91%" y2="3.563%" id="k"><stop stop-color="#4D00A1" offset="0%"/><stop stop-color="#5200B4" offset="100%"/></linearGradient><linearGradient x1=".226%" y1="66.146%" x2="99.644%" y2="66.146%" id="l"><stop stop-color="#6700E8" offset="0%"/><stop stop-color="#6700E8" offset="50.604%"/><stop stop-color="#6700E8" offset="100%"/></linearGradient><linearGradient x1="27.599%" y1="43.413%" x2="99.563%" y2="43.413%" id="m"><stop stop-color="#5A00C9" offset="0%"/><stop stop-color="#4F00A8" offset="100%"/></linearGradient><linearGradient x1=".929%" y1="1.754%" x2="100.982%" y2="1.754%" id="n"><stop stop-color="#390080" offset="0%"/><stop stop-color="#31006E" offset="50%"/><stop stop-color="#250056" offset="100%"/></linearGradient><linearGradient x1="-1.291%" y1="97.061%" x2="72.687%" y2="97.061%" id="o"><stop stop-color="#3F008B" offset="0%"/><stop stop-color="#220050" offset="100%"/></linearGradient><linearGradient x1=".061%" y1="56.314%" x2="99.97%" y2="56.314%" id="p"><stop stop-color="#6700E8" offset="0%"/><stop stop-color="#6700E8" offset="50%"/><stop stop-color="#6700E8" offset="100%"/></linearGradient><linearGradient x1="70.134%" y1="5.816%" x2="15.084%" y2="84.489%" id="q"><stop stop-color="#1C0044" offset="0%"/><stop stop-color="#2F0065" offset="10.005%"/><stop stop-color="#34006D" offset="20.479%"/><stop stop-color="#3B007A" offset="30%"/><stop stop-color="#3C007A" offset="40%"/><stop stop-color="#490096" offset="50%"/><stop stop-color="#5000AB" offset="60%"/><stop stop-color="#5400BA" offset="70.026%"/><stop stop-color="#5500BC" offset="80.312%"/><stop stop-color="#5700C2" offset="90%"/><stop stop-color="#5C00CE" offset="100%"/></linearGradient><linearGradient x1="15.582%" y1="88.954%" x2="77.808%" y2="7.079%" id="r"><stop stop-color="#1B0041" offset="0%"/><stop stop-color="#1B0041" offset="10.005%"/><stop stop-color="#1B0041" offset="20.479%"/><stop stop-color="#240052" offset="30%"/><stop stop-color="#32006A" offset="40%"/><stop stop-color="#3D007D" offset="50%"/><stop stop-color="#490098" offset="60%"/><stop stop-color="#4F00A8" offset="70.026%"/><stop stop-color="#5500BC" offset="80.312%"/><stop stop-color="#5700C2" offset="90%"/><stop stop-color="#6000DA" offset="100%"/></linearGradient><linearGradient x1="61.828%" y1="2.028%" x2="16.828%" y2="87.189%" id="s"><stop stop-color="#1E0046" offset="0%"/><stop stop-color="#2D0061" offset="10.005%"/><stop stop-color="#33006B" offset="20.479%"/><stop stop-color="#400082" offset="30%"/><stop stop-color="#490096" offset="40%"/><stop stop-color="#5000AC" offset="50%"/><stop stop-color="#5500BD" offset="60%"/><stop stop-color="#4F00A8" offset="70.026%"/><stop stop-color="#5500BC" offset="80.312%"/><stop stop-color="#5700C2" offset="90%"/><stop stop-color="#6000DA" offset="100%"/></linearGradient><linearGradient x1="20.312%" y1="92.318%" x2="71.385%" y2="3.948%" id="t"><stop stop-color="#1B0041" offset="0%"/><stop stop-color="#1B0041" offset="10.005%"/><stop stop-color="#1B0041" offset="20.479%"/><stop stop-color="#240052" offset="30%"/><stop stop-color="#32006A" offset="40%"/><stop stop-color="#3D007D" offset="50%"/><stop stop-color="#490098" offset="60%"/><stop stop-color="#4F00A8" offset="70.026%"/><stop stop-color="#5500BC" offset="80.312%"/><stop stop-color="#5700C2" offset="90%"/><stop stop-color="#6000DA" offset="100%"/></linearGradient><radialGradient cx="55.029%" cy="19.904%" fx="55.029%" fy="19.904%" r="81.986%" id="u"><stop stop-color="#6000D8" offset="0%"/><stop stop-color="#5C00CD" offset="20.886%"/><stop stop-color="#5500BE" offset="37.415%"/><stop stop-color="#2D0062" offset="72.1%"/><stop stop-color="#210045" offset="100%"/></radialGradient><linearGradient x1="-.21%" y1="99.61%" x2="66.935%" y2="11.047%" id="v"><stop stop-color="#47008D" offset="0%"/><stop stop-color="#5100B3" offset="100%"/></linearGradient><linearGradient x1="-.581%" y1="69.345%" x2="99.58%" y2="69.345%" id="w"><stop stop-color="#5500BD" offset="0%"/><stop stop-color="#5200B2" offset="100%"/></linearGradient><radialGradient cx="53.297%" cy="32.389%" fx="53.297%" fy="32.389%" id="x"><stop stop-color="#6700E8" offset="0%"/><stop stop-color="#5C00CE" offset="39.936%"/><stop stop-color="#5600BF" stop-opacity=".045" offset="70.124%"/><stop stop-color="#220047" stop-opacity="0" offset="100%"/></radialGradient></defs><path d="M505.2 1.622c3.924.656 6.544 3.057 6.544 7.191 0 1.368-.564 3.295-.94 4.923-2.63 11.587-12.894 52.525-17.216 79.85l-3.976-3.976 12.656-84.052 2.933-3.936z" fill="url(#a)"/><path d="M249.404 12.746c-5.298 1.268-10.5 1.234-15.613 0l8.119 8.43 7.494-8.43zM168.246 12.746c5.297 1.268 10.499 1.234 15.612 0l-8.118 8.43-7.494-8.43z" fill="#6700E8"/><path d="M122.422 12.713c11.972 30.299 30.813 76.16 40.2 93.688l-13.897-4.247-34.388-85.999 8.085-3.442z" fill="url(#b)"/><path d="M111.536 12.71c3.823 1.281 6.995 1.36 10.887 0l-7.738 4.754-3.149-4.753z" fill="#6700E8"/><path d="M117.034 16.017l35.041 85.94c-2.073 2.245-2.998 3.423-5.013 4.473-10.157-26.159-21.064-52.324-30.304-78.145l-4.56-7.733 4.836-4.535z" fill="url(#c)"/><path d="M86.898 106.398l-10.345-3.664 36.425-85.46 4.059-1.255V28.67C111.373 45.013 97 80.87 86.897 106.398z" fill="url(#d)"/><path d="M78.318.256l3.435 7.806 8.743-4.059L94.05.256c-5.624 1.276-10.697 1.318-15.733 0z" fill="#6700E8"/><path d="M53.65 68.326l-5.932 2.186-3.747-6.557L81.128 4.627l2.657-.91C87.452 2.89 91.45 2 94.056.257c-5.901 7.972-27.388 45.232-40.406 68.07z" fill="url(#e)"/><path d="M45.532 67.39l1.561-1.562 36.76-62.124L78.317.256C73.88 8.523 57.511 35.273 47.093 52.401l-4.996 9.368 3.435 5.62z" fill="url(#f)"/><path d="M15.868.256c8.15 14.442 20.66 34.645 31.225 52.145v13.427l-2.498 2.498L8.062 3.378 15.868.256z" fill="url(#g)"/><path d="M9.847 4.184L15.868.256C9.407 1.634 6.704 1.722.256.256l2.498 2.81 7.093 1.118z" fill="#6700E8"/><path d="M47.093 65.828l-2.81 4.06-3.747-1.562C33.56 56.27 13.053 19.54.256.256c2.594 1.88 6.099 2.911 10.146 3.569l36.691 62.003z" fill="url(#h)"/><path d="M54.587 118.598l-10.616-4.996.937-44.34 2.185-3.434 6.557 2.498.937 50.272z" fill="url(#i)"/><path d="M47.093 115.163l-7.494 3.435.937-50.272 6.557-2.498v49.335z" fill="url(#j)"/><path d="M71.449 106.42c13.027-26.554 27.513-62.164 40.086-93.715l5.502 3.315-35.565 87-7.213 2.464-2.81.936z" fill="url(#k)"/><path d="M151.703 101.8l10.932 4.604c-4.194-1.057-9.87-1.462-15.575.027l2.134-5.257 2.509.626z" fill="#200045"/><path d="M92.685 75.7l7.686-3.298c11.072.39 22.144.384 33.216 0l7.797 3.395-7.259 1.587H98.191L92.685 75.7z" fill="url(#l)"/><path d="M97.805 78.943L92.644 75.7c16.216-.248 32.457-.227 48.726.097l-5.161 3.146c-12.802-.415-25.603-.365-38.404 0z" fill="#200045"/><path d="M183.858 106.42l-10.929-3.747V18.68l3.123-1.562 7.806-4.371c-1.62 31.17-1.655 62.394 0 93.674z" fill="url(#m)"/><path d="M176.052 102.049v2.186l-7.806 2.185c1.24-31.175 1.36-62.395 0-93.674l7.806 4.371v84.932z" fill="url(#n)"/><path d="M233.791 106.42l10.929-3.747V18.68l-3.123-1.562-7.806-4.371c1.62 31.17 1.656 62.394 0 93.674z" fill="url(#o)"/><path d="M176.083 59.39l6.561-2.926c17.438.44 34.896.406 52.37 0l6.582 2.925-8.142 1.946H182.59l-6.506-1.946z" fill="url(#p)"/><path d="M304.513 12.71c-30.667 0-45.97 19.174-45.97 47.053 0 34.917 23.162 47.013 45.57 47.013 26.615 0 45.695-14.976 45.695-46.925 0-30.75-18.06-47.14-45.295-47.14zm-.917 4.45c.288-.006.579 0 .868 0 20.254 0 35.128 13.796 35.128 42.622 0 28.79-14.855 42.583-35.089 42.583-22.077 0-35.05-15.82-35.05-42.505 0-30.179 15.984-42.328 34.143-42.7z" fill="url(#q)"/><path d="M304.405 11.481c-33.12 0-50.496 21-50.496 48.223 0 29.797 18.97 47.97 50.448 47.97 34.031 0 50.652-20.481 50.652-47.657 0-30.3-19.85-48.536-50.604-48.536zm.098 3.103c26.15 0 43.49 15.732 43.49 45.257 0 30.677-18.325 45.061-43.88 45.061-21.515 0-43.754-11.612-43.754-45.14 0-26.768 14.699-45.178 44.144-45.178z" fill="url(#r)"/><path d="M418.952 7.92c-31.124 0-52.448 17.596-52.448 51.892 0 33.643 19.838 52.438 52.575 52.438 24.794 0 51.96-12.735 51.96-51.96 0-42.335-29.673-52.37-52.087-52.37zm-.166 3.747c24.768 0 43.012 15.047 43.012 48.232 0 36.075-22.069 47.774-42.973 47.774-22.335 0-42.68-13.107-42.68-48.486 0-36.67 22.551-47.52 42.64-47.52z" fill="url(#s)"/><path d="M418.747 5.841c-32.983 0-58.195 18.73-58.195 53.551 0 28.69 16.77 53.94 58.468 53.94 35.302 0 58.351-19.408 58.351-53.433 0-32.085-21.501-54.058-58.624-54.058zm.205 3.494c21.804 0 50.672 9.771 50.672 50.955 0 38.159-26.435 50.545-50.555 50.545-31.847 0-51.14-18.285-51.14-51.014 0-33.363 20.745-50.486 51.023-50.486z" fill="url(#t)"/><path d="M479.918 111.78c0-4.03 2.45-7.776 7.361-7.776 4.701 0 8.22 2.812 8.22 7.302 0 5.595-3.704 7.657-7.096 7.657-4.691 0-8.485-2.434-8.485-7.184z" fill="url(#u)"/><path d="M487.761 92.693c3.807-26.91 6.123-55.19 8.346-83.389 0-5.62 3.715-7.818 7.463-7.818.657 0 1.626.137 1.626.137l-1.02 6.74-13.352 83.583-3.063.747z" fill="url(#v)"/><path d="M39.6 118.598l7.507-5.5 7.48 5.5s-4.146-.754-7.48-.754c-3.008 0-7.508.754-7.508.754zM71.447 106.432l10.474-4.528c1.598 1.916 3.02 3.54 4.982 4.5-3.77-1.02-9.478-1.478-15.454.016l-.002.012zM168.246 106.42c5.07-1.221 10.262-1.275 15.593 0l-7.787-4.371-7.806 4.371zM182.644 62.853l-6.575-3.464c21.842.228 43.684.266 65.526 0l-6.567 3.444a1911.677 1911.677 0 0 0-52.384.02z" fill="#200045"/><path d="M241.597 102.049v2.186l7.807 2.185c-1.242-31.175-1.36-62.395 0-93.674l-7.807 4.371v84.932z" fill="url(#w)"/><path d="M249.404 106.42c-5.07-1.221-10.263-1.275-15.593 0l7.786-4.371 7.807 4.371zM491.205 89.536l-3.46 3.157c2.319-.408 4.111.197 5.854.899l-2.394-4.056z" fill="#200045"/><path d="M511.556 8.301c0 3.671-3.407 6.648-7.61 6.648-4.202 0-7.609-2.977-7.609-6.648s3.407-6.648 7.61-6.648c4.202 0 7.609 2.977 7.609 6.648z" fill="url(#x)"/></svg>'))),
	        },
	        {
	          name: 'Aol',
	          link: ("/email/add/?provider=" + (this.name)),
	          size: 30,
	          img: ("data:image/svg+xml;charset=utf-8," + (encodeURIComponent('<svg width="126" height="51" xmlns="http://www.w3.org/2000/svg"><path d="M105.178 1.073v48.03H94.255V.827h10.841l.082.246zM35.437 49.104l-2.349-6.98h-16.77l-2.543 6.98H.887L19.91.827h9.719l18.826 48.276H35.437v.001zm33.308 1.012c-13.113 0-19.41-10.371-19.41-19.24 0-8.872 6.298-19.248 19.41-19.248 13.12 0 19.416 10.375 19.416 19.248 0 8.87-6.296 19.24-19.416 19.24zm49.489-.671c-4.006 0-7.258-3.256-7.258-7.26a7.263 7.263 0 0 1 7.258-7.26c4.008 0 7.264 3.254 7.264 7.26 0 4.004-3.256 7.26-7.264 7.26zM19.712 32.34h10.117l-5.061-16.831-5.056 16.831zm49.033-10.597c-4.673 0-8.628 3.852-8.628 9.133 0 5.282 3.955 9.126 8.628 9.126 4.678 0 8.637-3.844 8.637-9.126 0-5.281-3.96-9.133-8.637-9.133z" fill="#2D3140" fill-rule="nonzero"/></svg>'))),
	        },
	        {
	          name: 'Outlook',
	          link: ("/email/add/?provider=" + (this.name)),
	          size: 38,
	          img: ("data:image/svg+xml;charset=utf-8," + (encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" width="2500" height="361" viewBox="0 0 722.381 104.313"><path d="M64.567 22.116V42.52l7.13 4.49c.188.055.596.059.784 0l30.688-20.69c0-2.449-2.284-4.204-3.573-4.204H64.567z" fill="#0072c6"/><path d="M64.567 50.133l6.508 4.471c.916.674 2.021 0 2.021 0-1.102.674 30.077-20.037 30.077-20.037v37.501c0 4.082-2.613 5.795-5.552 5.795H64.563v-27.73h.004zM173.428 91.886c-10.891 0-19.612-3.589-26.167-10.766-6.555-7.178-9.83-16.514-9.83-28.013 0-12.353 3.338-22.21 10.018-29.568 6.676-7.354 15.766-11.033 27.265-11.033 10.605 0 19.15 3.573 25.63 10.711 6.48 7.143 9.72 16.483 9.72 28.013 0 12.533-3.322 22.442-9.963 29.725-6.64 7.283-15.534 10.93-26.673 10.93zm.643-71.239c-8.07 0-14.621 2.911-19.66 8.733-5.034 5.822-7.554 13.466-7.554 22.927 0 9.466 2.453 17.078 7.366 22.85 4.91 5.767 11.311 8.646 19.202 8.646 8.427 0 15.068-2.746 19.926-8.247 4.854-5.493 7.283-13.191 7.283-23.084 0-10.14-2.358-17.98-7.072-23.515-4.709-5.544-11.209-8.31-19.491-8.31zM265.6 90.6h-8.784v-8.677h-.215c-3.644 6.64-9.285 9.963-16.925 9.963-13.07 0-19.605-7.781-19.605-23.355v-32.78h8.733v31.386c0 11.57 4.427 17.356 13.285 17.356 4.286 0 7.812-1.575 10.578-4.737s4.153-7.291 4.153-12.404V35.751h8.784V90.6h-.004zm40.433-.536c-2.073 1.148-4.804 1.716-8.196 1.716-9.607 0-14.41-5.356-14.41-16.071v-32.46H274v-7.498h9.427V22.359l8.784-2.84V35.75h13.818v7.498H292.21v30.905c0 3.678.622 6.303 1.876 7.874 1.25 1.575 3.323 2.359 6.214 2.359 2.214 0 4.125-.603 5.732-1.822v7.499zM572.424 88.082c-4.215 2.534-9.214 3.804-14.997 3.804-7.82 0-14.132-2.539-18.94-7.628-4.802-5.09-7.2-11.683-7.2-19.797 0-9.031 2.586-16.29 7.765-21.772 5.172-5.481 12.083-8.223 20.73-8.223 4.819 0 9.065.893 12.748 2.68v8.999c-4.07-2.856-8.431-4.286-13.07-4.286-5.61 0-10.206 2.01-13.795 6.025-3.588 4.016-5.379 9.293-5.379 15.828 0 6.43 1.685 11.503 5.058 15.214 3.373 3.718 7.906 5.57 13.583 5.57 4.784 0 9.282-1.582 13.497-4.767v8.353zm33.463 3.804c-8.102 0-14.578-2.559-19.413-7.683-4.843-5.129-7.264-11.922-7.264-20.385 0-9.21 2.52-16.408 7.554-21.583 5.034-5.176 11.836-7.766 20.408-7.766 8.18 0 14.563 2.52 19.155 7.554 4.583 5.035 6.88 12.016 6.88 20.941 0 8.753-2.473 15.758-7.417 21.027-4.952 5.262-11.581 7.895-19.903 7.895zm.643-50.027c-5.638 0-10.105 1.92-13.392 5.759-3.283 3.84-4.928 9.132-4.928 15.879 0 6.504 1.66 11.624 4.98 15.374 3.318 3.75 7.764 5.626 13.336 5.626 5.677 0 10.045-1.838 13.101-5.517 3.052-3.675 4.576-8.905 4.576-15.695 0-6.856-1.524-12.137-4.576-15.851-3.052-3.718-7.42-5.575-13.097-5.575zM722.381 90.6h-8.784V59.106c0-6.069-.936-10.46-2.813-13.176-1.877-2.711-5.027-4.07-9.454-4.07-3.75 0-6.938 1.716-9.56 5.144-2.62 3.428-3.937 7.534-3.937 12.321v31.28h-8.784V58.04c0-10.782-4.164-16.177-12.482-16.177-3.855 0-7.036 1.619-9.536 4.847-2.504 3.232-3.75 7.436-3.75 12.615v31.28h-8.783v-54.85h8.784v8.679h.215c3.89-6.641 9.567-9.964 17.035-9.964 3.75 0 7.017 1.047 9.802 3.135 2.786 2.088 4.694 4.83 5.732 8.223 4.07-7.569 10.14-11.354 18.21-11.354 12.068 0 18.105 7.444 18.105 22.336v33.792z" fill="#0072c6"/><g fill="#0072c6"><path d="M30.873 40.726c-2.218 0-3.985 1.042-5.29 3.123-1.304 2.08-1.958 4.834-1.958 8.263 0 3.479.654 6.229 1.959 8.25 1.304 2.026 3.016 3.033 5.132 3.033 2.182 0 3.914-.983 5.191-2.95 1.278-1.967 1.92-4.698 1.92-8.188 0-3.64-.619-6.473-1.86-8.498-1.243-2.022-2.94-3.033-5.094-3.033z"/><path d="M0 11.754V91.58l60.727 12.733V0L0 11.754zm40.636 53.408c-2.566 3.377-5.912 5.07-10.041 5.07-4.024 0-7.3-1.638-9.834-4.91-2.531-3.275-3.8-7.537-3.8-12.795 0-5.552 1.285-10.042 3.859-13.47 2.574-3.428 5.982-5.144 10.225-5.144 4.008 0 7.252 1.638 9.724 4.92 2.476 3.284 3.715 7.61 3.715 12.98.003 5.521-1.282 9.972-3.848 13.349z"/></g><path d="M326.378 90.6h-8.784V9.396h8.784v81.206zm37.964 1.286c-8.106 0-14.578-2.562-19.417-7.687-4.838-5.125-7.26-11.918-7.26-20.38 0-9.216 2.52-16.409 7.554-21.588 5.035-5.176 11.836-7.765 20.405-7.765 8.18 0 14.562 2.519 19.154 7.553 4.584 5.035 6.88 12.016 6.88 20.945 0 8.749-2.472 15.754-7.417 21.023-4.948 5.266-11.577 7.899-19.899 7.899zm.643-50.031c-5.642 0-10.104 1.92-13.387 5.759-3.287 3.84-4.93 9.132-4.93 15.883 0 6.5 1.662 11.624 4.98 15.374 3.319 3.75 7.766 5.626 13.337 5.626 5.677 0 10.045-1.838 13.101-5.517 3.052-3.675 4.576-8.905 4.576-15.695 0-6.856-1.524-12.141-4.576-15.855-3.056-3.718-7.424-5.575-13.101-5.575zm60.895 50.031c-8.106 0-14.578-2.562-19.417-7.687-4.838-5.125-7.26-11.918-7.26-20.38 0-9.216 2.52-16.409 7.554-21.588 5.035-5.176 11.836-7.765 20.408-7.765 8.177 0 14.563 2.519 19.151 7.553s6.884 12.016 6.884 20.945c0 8.749-2.472 15.754-7.42 21.023-4.949 5.27-11.582 7.899-19.9 7.899zm.643-50.031c-5.642 0-10.108 1.92-13.391 5.759-3.287 3.84-4.929 9.132-4.929 15.883 0 6.5 1.661 11.624 4.98 15.374 3.318 3.75 7.765 5.626 13.336 5.626 5.677 0 10.042-1.838 13.097-5.517 3.053-3.675 4.58-8.905 4.58-15.695 0-6.856-1.527-12.141-4.58-15.855-3.052-3.718-7.416-5.575-13.093-5.575zM510.017 90.6h-12.322l-24.212-26.355h-.216v26.356h-8.784V9.395h8.784v51.477h.216l23.033-25.121h11.514l-25.442 26.46 27.429 28.39zm13.701 1.176c-1.642 0-3.045-.588-4.2-1.767-1.164-1.18-1.744-2.586-1.744-4.231 0-1.642.58-3.06 1.744-4.259 1.155-1.199 2.558-1.794 4.2-1.794 1.68 0 3.106.595 4.286 1.794 1.179 1.199 1.767 2.617 1.767 4.259 0 1.645-.588 3.052-1.767 4.231-1.18 1.18-2.606 1.767-4.286 1.767z" fill="#0072c6"/></svg>'))),
	        } ],
	    };
	  },
	};

	/* script */
	var __vue_script__$1h = script$1h;

	/* template */
	var __vue_render__$1f = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f7-page',[_c('common-navbar',{attrs:{"title":"Create Email channel"}}),_vm._v(" "),_c('f7-list',{staticClass:"email-providers-list"},[_vm._l((_vm.providers),function(provider){return _c('f7-list-item',{key:provider.name,attrs:{"link":provider.link}},[_c('img',{attrs:{"src":provider.img,"height":provider.size}})])}),_vm._v(" "),_c('f7-list-button',{attrs:{"link":"/email/add/"}},[_vm._v("Other")])],2)],1)};
	var __vue_staticRenderFns__$1f = [];

	  /* style */
	  var __vue_inject_styles__$1i = undefined;
	  /* scoped */
	  var __vue_scope_id__$1i = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$1i = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$1i = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$1i = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$1f, staticRenderFns: __vue_staticRenderFns__$1f },
	    __vue_inject_styles__$1i,
	    __vue_script__$1h,
	    __vue_scope_id__$1i,
	    __vue_is_functional_template__$1i,
	    __vue_module_identifier__$1i,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//

	var providers = {
	  Google: {
	    POP3:{
	      host: 'pop.gmail.com',
	      port: '995'
	    },
	    SMTP:{
	      smtpHost: 'smtp.gmail.com',
	      smtpPort: '587'
	    },
	    IMAP:{
	      host: 'imap.gmail.com',
	      port: '993',
	    }
	  },
	  Outlook: {
	    POP3:{
	      host: 'outlook.office365.com',
	      port: '995'
	    },
	    SMTP:{
	      smtpHost: 'smtp.office365.com',
	      smtpPort: '587'
	    },
	    IMAP:{
	      host: 'outlook.office365.com',
	      port: '993',
	    }
	  },
	  Aol: {
	    POP3:{
	      host: 'pop.aol.com',
	      port: '995'
	    },
	    SMTP:{
	      smtpHost: 'smtp.aol.com',
	      smtpPort: '465'
	    },
	    IMAP:{
	      host: 'imap.aol.com',
	      port: '993'
	    }
	  },
	  Yahoo: {
	    POP3:{
	      host: 'pop.mail.yahoo.com',
	      port: '995'
	    },
	    SMTP:{
	      smtpHost: 'smtp.mail.yahoo.com',
	      smtpPort: '465'
	    },
	    IMAP:{
	      host: 'imap.mail.yahoo.com',
	      port: '993'
	    }
	  },
	  iCloud: {
	    pop:{
	    },
	    SMTP:{
	      host: 'smtp.mail.me.com',
	      port: '587'
	    },
	    IMAP:{
	      host: 'imap.mail.me.com',
	      port: '993'
	    }
	  }
	};

	var script$1i = {
	  name: 'EmailChannelCreate',
	  data: function data() {
	    var self = this;

	    var store = new Store(self, {
	      postNow: ['emailstream', 'create'],
	    });

	    store.on('postNowFinished', function (response) {
	      if (response.data && /web browser/.test(response.data.Message)) {
	        self.permissionError = response.data;
	      }
	    });

	    Utils$1.extend(store, {
	      email: '',
	      userName: '',
	      password: '',
	      smtpUserName: '',
	      smtpPassword: '',
	      port: '110',
	      smtpPort: '',
	      emailType:'IMAP',
	      host: '',
	    });

	    var provider = self.$f7route.query.provider;
	    if (!(provider in providers)) { provider = false; }
	    if (provider) {
	      Utils$1.extend(store, providers[provider]['IMAP']);
	      Utils$1.extend(store, providers[provider]['SMTP']);
	    }

	    gtag('event', 'email_add', {
	      event_category: 'page',
	      event_label: 'Add email channel',
	    });

	    return {
	      store: store,
	      passwords: '',
	      provider: provider,
	      showProviderDetails: false,
	      permissionError: false,
	      providers: providers,
	    };
	  },
	  watch: {
	    showProviderDetails: function showProviderDetails(value) {
	      var self = this;
	      if (!self.provider) { return; }
	      Utils$1.extend(self.store, self.providers[self.provider][self.store.emailType]);
	      Utils$1.extend(self.store, providers[self.provider]["SMTP"]);
	      self.setPasswords(self.passwords);
	    },
	    passwords: function passwords(value) {
	      var self = this;
	      self.setPasswords(value);
	    },
	    'store.email': function watchStoreEmail(value) {
	      var self = this;
	      if (!self.provider) { return; }
	      self.store.userName = value;
	      self.store.smtpUserName = value;
	    },
	    'store.userName': {
	      handler: function handler(newVal, oldVal) {
	        if (
	          typeof newVal !== 'undefined' &&
	          (this.store.smtpUserName.trim() === '' || this.store.smtpUserName.trim() === oldVal)
	        ) {
	          this.store.smtpUserName = newVal;
	        }
	      },
	      deep: true,
	    },
	    'store.password': {
	      handler: function handler(newVal, oldVal) {
	        if (
	          (typeof newVal !== 'undefined') &&
	          (this.store.smtpPassword.trim() === '' || this.store.smtpPassword.trim() === oldVal)
	        ) {
	          this.store.smtpPassword = newVal;
	        }
	      },
	      deep: true,
	    },
	    'store.emailType': {
	      handler: function handler(newVal) {
	        var self = this;

	        if(self.provider)
	        {
	          Utils$1.extend(self.store, providers[self.provider][newVal]);
	        }

	        if (
	          newVal === 'POP3' &&
	          (typeof this.store.port === 'undefined' || this.store.port.trim() === '' || this.store.port === '143')
	        ) {
	          this.store.port = '110';
	        } else if (
	          newVal === 'IMAP' &&
	          (typeof this.store.port === 'undefined' || this.store.port.trim() === '' || this.store.port === '110')
	        ) {
	          this.store.port = '143';
	        }
	      },
	      deep: true,
	    },
	  },
	  methods: {
	    setPasswords: function setPasswords(password) {
	      var self = this;
	      self.store.password = password;
	      self.store.smtpPassword = password;
	    },
	    allowGmailAccess: function allowGmailAccess() {
	      Brief.openInSystemBrowser('https://myaccount.google.com/lesssecureapps');
	    },
	  },
	};

	/* script */
	var __vue_script__$1i = script$1i;

	/* template */
	var __vue_render__$1g = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('channel-create-page',{ref:"channelCreate",attrs:{"type":"email","store":_vm.store,"handleStores":true}},[(!_vm.provider)?_c('f7-block-title',[_vm._v("Email address")]):_c('f7-block-title',[_vm._v(_vm._s(_vm.provider)+" account details")]),_vm._v(" "),_c('f7-list',[_c('f7-list-item',{attrs:{"item-input":""}},[_c('f7-input',{attrs:{"type":"email","placeholder":"E-mail","value":_vm.store.email},on:{"input":function($event){_vm.store.email = $event.target.value;}}})],1),_vm._v(" "),(_vm.provider && !_vm.showProviderDetails)?_c('f7-list-item',{attrs:{"item-input":""}},[_c('f7-input',{attrs:{"type":"password","placeholder":"Password","value":_vm.passwords},on:{"input":function($event){_vm.passwords = $event.target.value;}}})],1):_vm._e(),_vm._v(" "),_c('f7-list-item',{attrs:{"item-input":""}},[_c('f7-input',{attrs:{"type":"text","placeholder":"Sender name","value":_vm.store.senderName},on:{"input":function($event){_vm.store.senderName = $event.target.value;}}})],1)],1),_vm._v(" "),(!_vm.provider || (_vm.provider && _vm.showProviderDetails))?[_c('f7-block-title',[_vm._v("Email server type")]),_vm._v(" "),_c('f7-list',[_c('f7-list-item',{attrs:{"radio":"","name":"emailType","value":"POP3","checked":_vm.store.emailType === 'POP3',"title":"POP3"},on:{"change":function($event){_vm.store.emailType = $event.target.value;}}}),_vm._v(" "),_c('f7-list-item',{attrs:{"radio":"","name":"emailType","value":"IMAP","checked":_vm.store.emailType === 'IMAP',"title":"IMAP"},on:{"change":function($event){_vm.store.emailType = $event.target.value;}}})],1),_vm._v(" "),_c('f7-block-title',[_vm._v("Incoming email account")]),_vm._v(" "),_c('f7-list',[_c('f7-list-item',{attrs:{"item-input":""}},[_c('f7-input',{attrs:{"type":"email","placeholder":"Username","value":_vm.store.userName},on:{"input":function($event){_vm.store.userName = $event.target.value;}}})],1),_vm._v(" "),_c('f7-list-item',{attrs:{"item-input":""}},[_c('f7-input',{attrs:{"type":"password","placeholder":"Password","value":_vm.store.password},on:{"input":function($event){_vm.store.password = $event.target.value;}}})],1),_vm._v(" "),_c('f7-list-item',{attrs:{"item-input":""}},[_c('f7-input',{attrs:{"type":"text","placeholder":"Ex. pop3.host.com or imap.host.com","value":_vm.store.host},on:{"input":function($event){_vm.store.host = $event.target.value;}}})],1),_vm._v(" "),_c('f7-list-item',{attrs:{"item-input":""}},[_c('f7-input',{attrs:{"type":"text","placeholder":"Ex. 110 or 993","value":_vm.store.port},on:{"input":function($event){_vm.store.port = $event.target.value;}}})],1)],1),_vm._v(" "),_c('f7-block-title',[_vm._v("Outgoing email account")]),_vm._v(" "),_c('f7-list',[_c('f7-list-item',{attrs:{"item-input":""}},[_c('f7-input',{attrs:{"type":"email","placeholder":"SMTP Username","value":_vm.store.smtpUserName},on:{"input":function($event){_vm.store.smtpUserName = $event.target.value;}}})],1),_vm._v(" "),_c('f7-list-item',{attrs:{"item-input":""}},[_c('f7-input',{attrs:{"type":"password","placeholder":"SMTP Password","value":_vm.store.smtpPassword},on:{"input":function($event){_vm.store.smtpPassword = $event.target.value;}}})],1),_vm._v(" "),_c('f7-list-item',{attrs:{"item-input":""}},[_c('f7-input',{attrs:{"type":"text","placeholder":"Ex. smtp.host.com","value":_vm.store.smtpHost},on:{"input":function($event){_vm.store.smtpHost = $event.target.value;}}})],1),_vm._v(" "),_c('f7-list-item',{attrs:{"item-input":""}},[_c('f7-input',{attrs:{"type":"text","placeholder":"Ex. 587","value":_vm.store.smtpPort},on:{"input":function($event){_vm.store.smtpPort = $event.target.value;}}})],1)],1)]:_vm._e(),_vm._v(" "),_c('f7-list',[(_vm.provider)?_c('f7-list-button',{on:{"click":function($event){_vm.showProviderDetails = !_vm.showProviderDetails;}}},[_vm._v(_vm._s(_vm.showProviderDetails ? 'Less' : 'More')+" settings")]):_vm._e()],1),_vm._v(" "),_c('f7-list',[(_vm.permissionError)?_c('f7-list-button',{on:{"click":_vm.allowGmailAccess}},[_vm._v("Click here to allow access for Brief and than try again in a minute")]):_vm._e()],1)],2)};
	var __vue_staticRenderFns__$1g = [];

	  /* style */
	  var __vue_inject_styles__$1j = undefined;
	  /* scoped */
	  var __vue_scope_id__$1j = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$1j = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$1j = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$1j = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$1g, staticRenderFns: __vue_staticRenderFns__$1g },
	    __vue_inject_styles__$1j,
	    __vue_script__$1i,
	    __vue_scope_id__$1j,
	    __vue_is_functional_template__$1j,
	    __vue_module_identifier__$1j,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//

	var script$1j = {
	  name: 'EmailCreateGmail',
	  data: function data() {
	    var self = this;

	    var store = new Store(self, {
	      get: ['emailchannel', 'creategmail'],
	      postNow: ['emailchannel', 'creategmail'],
	    });

	    gtag('event', 'email_add', {
	      event_category: 'page',
	      event_label: 'Add email channel',
	    });

	    store.get();

	    return {
	      store: store
	    };
	  },
	};

	/* script */
	var __vue_script__$1j = script$1j;

	/* template */
	var __vue_render__$1h = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('channel-create-page',{ref:"channelCreate",attrs:{"type":"email","store":_vm.store,"handleStores":true}},[_c('f7-block-title',[_vm._v("Sender information")]),_vm._v(" "),_c('f7-list',[_c('f7-list-item',{attrs:{"item-input":""}},[_c('f7-input',{attrs:{"type":"text","placeholder":"Sender name","value":_vm.store.senderName},on:{"input":function($event){_vm.store.senderName = $event.target.value;}}})],1)],1)],1)};
	var __vue_staticRenderFns__$1h = [];

	  /* style */
	  var __vue_inject_styles__$1k = undefined;
	  /* scoped */
	  var __vue_scope_id__$1k = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$1k = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$1k = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$1k = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$1h, staticRenderFns: __vue_staticRenderFns__$1h },
	    __vue_inject_styles__$1k,
	    __vue_script__$1j,
	    __vue_scope_id__$1k,
	    __vue_is_functional_template__$1k,
	    __vue_module_identifier__$1k,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	var GmailService = function GmailService () {};

	GmailService.prototype.givePermission = function givePermission (callback, channelId) {
	  var state = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
	    var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
	    return v.toString(16);
	  });

	  if (Brief$1.isCordova)
	    { state = "mobile_" + state; }
	    
	  if (channelId)
	    { state = state + "_" + channelId; }
	    
	  var storeGmailState = new Store(self, {
	    postNow: ['gmail', 'state', { state: state }],
	  });

	  storeGmailState.on('postNowFinished', function () {
	    var url = (config$1.domain) + "api/gmail/auth?state=" + state;
	    if (!Brief$1.isCordova) {
	      var win = window.open(url);
	      var timer = setInterval(function () {
	        if (win.closed) {
	          clearInterval(timer);
	          callback();
	        }
	      }, 500);
	    }
	  });

	  storeGmailState.postNow();
	};

	var gmailService = new GmailService();

	//

	var script$1k = {
	  name: 'EmailPermissionGmail',
	  data: function data() {
	    return {
	      isLoading: false
	    };
	  },
	  methods: {
	    givePermission: function () {
	      var self = this;
	      self.isLoading = true;
	      gmailService.givePermission(function () {
	        self.isLoading = false;
	        Brief$1.viewMain.router.navigate("/email/create-gmail/");
	      });
	    },
	  },
	};

	/* script */
	var __vue_script__$1k = script$1k;

	/* template */
	var __vue_render__$1i = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f7-page',{staticClass:"page-form"},[_c('common-navbar',{attrs:{"title":"Permission to Gmail"}}),_vm._v(" "),(!_vm.isLoading)?_c('div',{staticClass:"content-center"},[_c('f7-block-title',[_vm._v("Give permission to Gmail")]),_vm._v(" "),_c('f7-block',{staticClass:"content-round content-white",attrs:{"strong":""}},[_vm._v("\n      Brief needs your permission to be able to download and handle your Gmail emails.\n      "),_c('f7-button',{staticClass:"margin-top",attrs:{"big":"","fill":""},on:{"click":_vm.givePermission}},[_vm._v("Give permission")])],1)],1):_vm._e(),_vm._v(" "),(_vm.isLoading)?_c('div',{staticClass:"infinite-scroll-preloader"},[_c('f7-preloader')],1):_vm._e()],1)};
	var __vue_staticRenderFns__$1i = [];

	  /* style */
	  var __vue_inject_styles__$1l = undefined;
	  /* scoped */
	  var __vue_scope_id__$1l = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$1l = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$1l = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$1l = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$1i, staticRenderFns: __vue_staticRenderFns__$1i },
	    __vue_inject_styles__$1l,
	    __vue_script__$1k,
	    __vue_scope_id__$1l,
	    __vue_is_functional_template__$1l,
	    __vue_module_identifier__$1l,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//

	var script$1l = {
	  name: 'EmailChannelSettings',
	  data: function data() {
	    var self = this;
	    var channelId = self.$f7route.params.channelId;
	    var store = new Store(self, {
	      get: ['emailstream', 'settings', { id: channelId }],
	      post: ['emailstream', 'rename'],
	      sync: false,
	    });

	    var storeLeave = new Store(self, {
	      post: ['channel', 'leave', { id: channelId, channelType: 'email' }],
	    });

	    var storeDelete = new Store(self, {
	      post: ['channel', 'delete', { id: channelId, channelType: 'email' }],
	    });

	    store.get();

	    return {
	      store: store,
	      storeLeave: storeLeave,
	      storeDelete: storeDelete,
	      channelId: channelId,
	      tokenUpdated: false,
	      tokenUpdateInProgress: false,
	    };
	  },
	  methods: {
	    updateToken: function updateToken() {
	      var self = this;

	      self.tokenUpdateInProgress = true;

	      gmailService.givePermission(function () {
	        self.tokenUpdateInProgress = false;
	        self.tokenUpdated = true;
	      }, this.channelId);
	    },
	  },
	};

	/* script */
	var __vue_script__$1l = script$1l;

	/* template */
	var __vue_render__$1j = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('channel-settings-page',{attrs:{"type":"email","id":_vm.channelId,"name":_vm.store.name,"description":_vm.store.description,"isLoading":_vm.store.isLoading,"joinedUserCount":_vm.store.joinedUserCount,"isOwner":_vm.store.isOwner,"visibility":_vm.store.visibility,"longWaitingThreshold":_vm.store.longWaitingThreshold,"editWaitLimit":true,"editAutoReply":true,"editSignature":true,"editVisibility":true,"editInfo":true,"store":_vm.store,"storeLeave":_vm.storeLeave,"storeDelete":_vm.storeDelete,"handleStores":true}},[(!_vm.store.isGmail)?_c('f7-list',{attrs:{"media-list":""}},[_c('f7-list-item',{attrs:{"link":("/email/" + _vm.channelId + "/account/"),"title":"Email Settings","subtitle":_vm.store.email}})],1):_c('template',{slot:"before-button"},[_c('f7-list',[_c('ul',[(!_vm.tokenUpdated)?_c('f7-list-button',{on:{"click":_vm.updateToken}},[_vm._v(_vm._s(_vm.tokenUpdateInProgress? 'Updating Gmail access...' : 'Update Gmail access')+" "),(_vm.tokenUpdateInProgress)?_c('span',{staticClass:"spinner"}):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.tokenUpdated)?_c('f7-block-footer',{staticClass:"padding"},[_vm._v("Gmail access updated")]):_vm._e()],1)])],1)],2)};
	var __vue_staticRenderFns__$1j = [];

	  /* style */
	  var __vue_inject_styles__$1m = undefined;
	  /* scoped */
	  var __vue_scope_id__$1m = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$1m = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$1m = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$1m = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$1j, staticRenderFns: __vue_staticRenderFns__$1j },
	    __vue_inject_styles__$1m,
	    __vue_script__$1l,
	    __vue_scope_id__$1m,
	    __vue_is_functional_template__$1m,
	    __vue_module_identifier__$1m,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//
	//
	//
	//
	//
	//

	var script$1m = { name: 'EmailChannelInvite' };

	/* script */
	var __vue_script__$1m = script$1m;

	/* template */
	var __vue_render__$1k = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('channel-invite-page',{attrs:{"id":_vm.$f7route.params.channelId,"type":"email"}})};
	var __vue_staticRenderFns__$1k = [];

	  /* style */
	  var __vue_inject_styles__$1n = undefined;
	  /* scoped */
	  var __vue_scope_id__$1n = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$1n = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$1n = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$1n = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$1k, staticRenderFns: __vue_staticRenderFns__$1k },
	    __vue_inject_styles__$1n,
	    __vue_script__$1m,
	    __vue_scope_id__$1n,
	    __vue_is_functional_template__$1n,
	    __vue_module_identifier__$1n,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//
	//
	//
	//
	//
	//
	//

	var script$1n = { name: 'EmailConversationAssign' };

	/* script */
	var __vue_script__$1n = script$1n;

	/* template */
	var __vue_render__$1l = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('conversation-assign-page',{attrs:{"id":_vm.$f7route.params.channelId,"conversationId":_vm.$f7route.params.conversationId,"type":"email"}})};
	var __vue_staticRenderFns__$1l = [];

	  /* style */
	  var __vue_inject_styles__$1o = undefined;
	  /* scoped */
	  var __vue_scope_id__$1o = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$1o = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$1o = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$1o = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$1l, staticRenderFns: __vue_staticRenderFns__$1l },
	    __vue_inject_styles__$1o,
	    __vue_script__$1n,
	    __vue_scope_id__$1o,
	    __vue_is_functional_template__$1o,
	    __vue_module_identifier__$1o,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//
	//
	//
	//
	//
	//

	var script$1o = { name: 'EmailChannelJoin' };

	/* script */
	var __vue_script__$1o = script$1o;

	/* template */
	var __vue_render__$1m = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('channel-join-page',{attrs:{"id":_vm.$f7route.params.channelId,"type":"email"}})};
	var __vue_staticRenderFns__$1m = [];

	  /* style */
	  var __vue_inject_styles__$1p = undefined;
	  /* scoped */
	  var __vue_scope_id__$1p = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$1p = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$1p = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$1p = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$1m, staticRenderFns: __vue_staticRenderFns__$1m },
	    __vue_inject_styles__$1p,
	    __vue_script__$1o,
	    __vue_scope_id__$1p,
	    __vue_is_functional_template__$1p,
	    __vue_module_identifier__$1p,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//
	//
	//
	//
	//
	//

	var script$1p = { name: 'EmailChannelSignature' };

	/* script */
	var __vue_script__$1p = script$1p;

	/* template */
	var __vue_render__$1n = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('channel-signature-page',{attrs:{"id":_vm.$f7route.params.channelId,"type":"email"}})};
	var __vue_staticRenderFns__$1n = [];

	  /* style */
	  var __vue_inject_styles__$1q = undefined;
	  /* scoped */
	  var __vue_scope_id__$1q = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$1q = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$1q = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$1q = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$1n, staticRenderFns: __vue_staticRenderFns__$1n },
	    __vue_inject_styles__$1q,
	    __vue_script__$1p,
	    __vue_scope_id__$1q,
	    __vue_is_functional_template__$1q,
	    __vue_module_identifier__$1q,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//
	//
	//
	//
	//
	//

	var script$1q = {
	  name: 'EmailChannelMembers',
	};

	/* script */
	var __vue_script__$1q = script$1q;

	/* template */
	var __vue_render__$1o = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('channel-members-page',{attrs:{"id":_vm.$f7route.params.channelId,"type":"email"}})};
	var __vue_staticRenderFns__$1o = [];

	  /* style */
	  var __vue_inject_styles__$1r = undefined;
	  /* scoped */
	  var __vue_scope_id__$1r = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$1r = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$1r = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$1r = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$1o, staticRenderFns: __vue_staticRenderFns__$1o },
	    __vue_inject_styles__$1r,
	    __vue_script__$1q,
	    __vue_scope_id__$1r,
	    __vue_is_functional_template__$1r,
	    __vue_module_identifier__$1r,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//
	//
	//
	//
	//
	//

	var script$1r = {
	  name: 'EmailChannelNotifications',
	};

	/* script */
	var __vue_script__$1r = script$1r;

	/* template */
	var __vue_render__$1p = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('channel-notifications-page',{attrs:{"id":_vm.$f7route.params.channelId,"type":"email"}})};
	var __vue_staticRenderFns__$1p = [];

	  /* style */
	  var __vue_inject_styles__$1s = undefined;
	  /* scoped */
	  var __vue_scope_id__$1s = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$1s = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$1s = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$1s = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$1p, staticRenderFns: __vue_staticRenderFns__$1p },
	    __vue_inject_styles__$1s,
	    __vue_script__$1r,
	    __vue_scope_id__$1s,
	    __vue_is_functional_template__$1s,
	    __vue_module_identifier__$1s,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//

	function highlight$1(searchString, text) {
	  var r = new RegExp(("(" + searchString + ")"), 'gi');
	  return text.replace(r, '<span class="highlight">$1</span>');
	}
	function queryContains$1(data, query) {
	  return !Utils$1.isUndefined(data) && data.toLowerCase().contains(query.toLowerCase());
	}
	function prepareContacts$1(tempContacts, contacts) {
	  var this$1 = this;

	  if (!contacts || contacts.length === 0) { return; }
	  Object.keys(contacts).forEach(function (c) {
	    var contact = contacts[c];
	    if (queryContains$1(contact.firstName, this$1.query)) {
	      contact.displayField = highlight$1(this$1.query, contact.firstName);
	    } else {
	      contact.displayField = contact.firstName;
	    }

	    if (queryContains$1(contact.lastName, this$1.query)) {
	      contact.displayField = (contact.displayField) + " " + (highlight$1(this$1.query, contact.lastName));
	    } else {
	      contact.displayField = (contact.displayField) + " " + (contact.lastName);
	    }

	    if (!Utils$1.isUndefined(contact.displayField)) {
	      if (!contact.displayField.contains('<span')) {
	        contact.displayField = highlight$1(this$1.query, contact.email);
	      }
	    } else {
	      contact.displayField = highlight$1(this$1.query, contact.email);
	    }

	    if (!contact.displayField) {
	      return;
	    }
	    contact.itemSelected = false;
	    tempContacts.push(contact);
	  });
	}

	function getContactFinished$1() {
	  this.isLoading = false;
	  var tempContacts = [];
	  prepareContacts$1.bind(this)(tempContacts, this.store.contacts);
	  prepareContacts$1.bind(this)(tempContacts, this.store.recentContacts);
	  if (tempContacts.length > 0) { tempContacts[0].itemSelected = true; }

	  this.contacts = tempContacts;
	}
	function postEmailFinished(response) {
	  var self = this;
	  self.sending = false;
	  Brief$1.hideProgress(self.$el);
	  if (response.success) {
	    self.text = '';
	    self.files = [];
	    self.contacts = [];
	    ClientStorage.remove(((self.channelId) + ":contacts"));
	    ClientStorage.remove(((self.channelId) + ":subject"));
	    ClientStorage.remove(((self.channelId) + ":message"));
	    ClientStorage.remove(("" + (self.channelId)));
	    var url = "/email/" + (self.channelId) + "/" + (encodeURIComponent(response.data.conversationId)) + "/";
	    Brief$1.viewMain.router.navigate(url, { reloadCurrent: true });
	    Brief$1.events.$emit('message-posted', response);
	    setTimeout(function () {
	      Brief$1.events.$emit('messages-refresh');
	    }, 500);
	  }
	}

	var script$1s = {
	  name: 'EmailMessageCreate',
	  components: {
	    contactAutocomplete: __vue_component__,
	  },
	  props: ['params'],
	  data: function data() {
	    var self = this;

	    var store = new Store(self, {
	      get: ['contact', 'list', { take: 6 }],
	      postForm: ['emailmessage', 'create'],
	      getFinished: getContactFinished$1,
	      getLocalFinished: function () {},
	      postFormFinished: postEmailFinished,
	    });

	    var storeSignature = new Store(self, {
	      get: ['emailstream', 'signature'],
	    });

	    var streamStore = new Store(self, {
	      get: ['stream', 'list', { filter: 'All' }],
	      getFinished: function getFinished() {
	        if (self.streams) { self.channelId = self.streams[0].id; }
	      },
	    });
	    return {
	      store: store,
	      streamStore: streamStore,
	      storeSignature: storeSignature,
	      channelId: null,
	      text: null,
	      sending: false,
	      senderName: null,
	      subject: null,
	      selectedContacts: [],
	      contacts: [],
	      itemIndex: 0,
	      isLoading: false,
	      query: '',
	      enterCallback: undefined,
	    };
	  },
	  mounted: function mounted() {
	    var self = this;
	    if (!self.$f7route.params.channelId) {
	      self.streamStore.get();
	    } else {
	      self.channelId = self.$f7route.params.channelId;
	      self.storeSignature.get({ emailStreamId: self.channelId });
	    }

	    ClientStorage.get(((self.channelId) + ":contacts")).then(function (contacts) {
	      if (contacts !== null) { self.selectedContacts = contacts || []; }
	    });

	    ClientStorage.get(((self.channelId) + ":subject")).then(function (subject) {
	      self.subject = subject;
	    });
	  },
	  computed: {
	    streams: function streams() {
	      var streams = [];

	      if (this.streamStore.streams) {
	        streams = this.streamStore.streams.filter(function (stream) { return stream.streamType === 'email'; });
	      }

	      if (this.$f7route.params.channelId) {
	        streams.push({ id: this.$f7route.params.channelId });
	      }

	      if (streams.length === 1 && !this.channelId) {
	        this.channelId = streams[0].id;
	      }

	      return streams;
	    },
	    showForm: function showForm() {
	      return !this.streamStore.isLoading && this.streams.length > 0;
	    },
	    showStreamSelect: function showStreamSelect() {
	      return !this.streamStore.isLoading && !this.$f7route.params.channelId && this.streams.length > 1;
	    },
	    showNoStreams: function showNoStreams() {
	      return !this.streamStore.isLoading && this.streams.length === 0;
	    },
	  },
	  watch: {
	    subject: function subject() {
	      ClientStorage.save(((this.channelId) + ":subject"), this.subject);
	    },
	    channelId: function channelId() {
	      var self = this;
	      self.storeSignature.get({ emailStreamId: self.channelId });
	    },
	  },
	  beforeDestroy: function beforeDestroy() {
	    var self = this;
	    self.store.dispose();
	  },
	  methods: {
	    debounceSearch: debounce_1(function debounceSearch() {
	      var self = this;
	      self.isLoading = true;
	      self.store.get({ query: self.query });
	    }, 500),
	    onContactSearch: function onContactSearch() {
	      var self = this;
	      self.itemIndex = 0;
	      if (Utils$1.isUndefined(self.query)) {
	        self.contacts = [];
	        return;
	      }
	      if (self.isLoading) { return; }
	      self.debounceSearch();
	    },
	    hideDropdown: function hideDropdown() {
	      this.contacts = [];
	    },
	    send: function send() {
	      var self = this;
	      self.$refs.commonWrite.send();
	    },
	    onSend: function onSend(message) {
	      var self = this;
	      if (self.sending) { return; }

	      if (!self.channelId) {
	        Brief$1.notify('Error!', 'Select a channel to create message in');
	        return;
	      }

	      if (Utils$1.isUndefined(self.query)) {
	        if (self.selectedContacts.length === 0) {
	          Brief$1.notify('Error!', 'Please add at least one contact');
	          Brief$1.events.$emit('force-input-focus');
	          return;
	        }
	      } else if (Utils$1.isEmail(self.query)) {
	        Brief$1.events.$emit('force-input-lose-focus');
	      } else {
	        Brief$1.notify('Error!', 'Invalid email address');
	        Brief$1.events.$emit('force-input-focus');
	        return;
	      }

	      if (Utils$1.isUndefined(message.text) && message.files.length === 0) {
	        Brief$1.notify('Error!', 'Message or attachment is required');
	        return;
	      }

	      self.sending = true;
	      Brief$1.showProgress(self.$el);

	      self.store.postForm({
	        subject: self.subject,
	        contacts: self.selectedContacts,
	        text: message.text,
	        files: message.files,
	        emailStreamId: self.channelId,
	      });
	    },
	    onTextChange: function onTextChange(newText) {
	      this.text = newText;
	    },
	    onQueryChange: function onQueryChange(newQuery) {
	      this.query = newQuery;
	    },
	    onItemIndexChange: function onItemIndexChange(newIndex) {
	      this.itemIndex = newIndex;
	    },
	    onSelectedContactsAdd: function onSelectedContactsAdd(newContact) {
	      var self = this;
	      self.selectedContacts.push(newContact);
	      ClientStorage.save(((self.channelId) + ":contacts"), self.selectedContacts);
	    },
	    onSelectedContactsReplace: function onSelectedContactsReplace(newContact) {
	      var self = this;
	      self.selectedContacts = [newContact];
	      ClientStorage.save(((self.channelId) + ":contacts"), self.selectedContacts);
	    },
	    onSelectedContactsRemove: function onSelectedContactsRemove(index) {
	      var self = this;
	      self.selectedContacts.splice(index, 1);
	      ClientStorage.save(((self.channelId) + ":contacts"), self.selectedContacts);
	    },
	    onSearchedContactsReplace: function onSearchedContactsReplace(newArr) {
	      var self = this;
	      self.contacts = newArr;
	      ClientStorage.save(((self.channelId) + ":contacts"), self.selectedContacts);
	    },
	  },
	};

	/* script */
	var __vue_script__$1s = script$1s;

	/* template */
	var __vue_render__$1q = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f7-page',{staticClass:"email-create-page",attrs:{"page-content":false}},[_c('common-navbar',{attrs:{"title":"New email"}}),_vm._v(" "),_c('div',{staticClass:"page-content",on:{"click":_vm.hideDropdown}},[(_vm.showNoStreams)?_c('div',{staticClass:"brief-card"},[_c('div',{staticClass:"brief-card-header"},[_vm._v("No email channels has been added yet!")]),_vm._v(" "),_c('div',{staticClass:"brief-card-content"},[_vm._v("\n        In order to send emails through the app, you need to create a new email channel\n      ")])]):_vm._e(),_vm._v(" "),(_vm.showForm)?_c('f7-list',[_c('ul',[(_vm.showStreamSelect)?_c('f7-list-item',{attrs:{"smart-select":"","smart-select-params":{ closeOnSelect: true },"title":"Channel"}},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.channelId),expression:"channelId"}],attrs:{"name":"channelId"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.channelId=$event.target.multiple ? $$selectedVal : $$selectedVal[0];}}},_vm._l((_vm.streams),function(stream,index){return _c('option',{domProps:{"value":stream.id,"selected":index === 0}},[_vm._v(_vm._s(stream.name))])}),0)]):_vm._e(),_vm._v(" "),_c('contact-autocomplete',{attrs:{"query":_vm.query,"searched-contacts":_vm.contacts,"selected-contacts":_vm.selectedContacts,"item-index":_vm.itemIndex,"to":_vm.$f7route.query.to,"is-loading":_vm.isLoading},on:{"contactsearch":_vm.onContactSearch,"querychange":_vm.onQueryChange,"itemindexchange":_vm.onItemIndexChange,"selectedcontacts:add":_vm.onSelectedContactsAdd,"selectedcontacts:replace":_vm.onSelectedContactsReplace,"selectedcontacts:remove":_vm.onSelectedContactsRemove,"searchedcontacts:replace":_vm.onSearchedContactsReplace}}),_vm._v(" "),_c('f7-list-item',[_c('f7-input',{attrs:{"type":"text","placeholder":"Subject","value":_vm.subject},on:{"input":function($event){_vm.subject = $event.target.value;}}})],1)],1)]):_vm._e(),_vm._v(" "),(_vm.showForm)?_c('common-write',{ref:"commonWrite",staticClass:"email-create-messagebar",attrs:{"top":true,"id":_vm.channelId,"fileUpload":true,"signature":_vm.storeSignature.signature,"clearDataOnSend":false,"textToHtml":false,"type":"email-compose"},on:{"send":_vm.onSend}}):_vm._e()],1)],1)};
	var __vue_staticRenderFns__$1q = [];

	  /* style */
	  var __vue_inject_styles__$1t = undefined;
	  /* scoped */
	  var __vue_scope_id__$1t = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$1t = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$1t = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$1t = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$1q, staticRenderFns: __vue_staticRenderFns__$1q },
	    __vue_inject_styles__$1t,
	    __vue_script__$1s,
	    __vue_scope_id__$1t,
	    __vue_is_functional_template__$1t,
	    __vue_module_identifier__$1t,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//

	function getFullnameOrEmail$1(contact) {
	  if (contact.fullName) { return contact.fullName; }
	  if (!contact.firstName && !contact.lastName) { return contact.email; }

	  return ((contact.firstName) + " " + (contact.lastName));
	}
	function processSubscriptionResponse(response) {
	  var self = this;
	  var index = self.store.messages.findIndex(function (email) { return email.id === response.id; });
	  if (response.conversationId === decodeURIComponent(self.$f7route.params.conversationId)) {
	    var email = {
	      id: response.id,
	      isOurMessage: response.from ? response.from.email.toLowerCase() === self.store.email.toLowerCase() : false,
	      fullName: response.from ? getFullnameOrEmail$1(response.from) : null,
	      text: response.text,
	      files: response.files,
	      sendDate: response.sendDate,
	      userId: response.from ? response.from.id : null,
	      contactType: response.contactType,
	      isSystemMessage: response.isSystemMessage,
	    };

	    if (index <= -1) {
	      self.store.messages.push(email);
	    } else {
	      self.$set(self.store.messages, index, email);
	    }
	    self.$nextTick(function () {
	      Brief$1.events.$emit('files-updated');
	    });
	  }
	}

	function isReadByMe(message, userId) {
	  if (message.readByEveryone || message.ownerUserId === userId) {
	    return true;
	  }
	  return message.hasRead.find(function (x) { return x === userId; }) !== undefined;
	}
	function handlePreProcess$6(data) {
	  var self = this;

	  var userId = self.$root.loggedInUser.id;
	  data.isReadByMe = isReadByMe(data, userId);

	  return true;
	}

	function getFinished$1() {
	  Brief$1.events.$emit('common-write-contacts', this.store.contacts);
	}

	var script$1t = {
	  name: 'EmailMessageList',
	  props: ['params'],
	  mounted: function mounted() {
	    var this$1 = this;

	    Brief$1.events.$on('common-write-contacts:updated', function (contacts) {
	      this$1.store.contacts = contacts;
	    });
	    Brief$1.events.$on('common-write-reply-type:updated', function (replyType) {
	      this$1.store.replyType = replyType;
	    });
	  },
	  data: function data() {
	    var self = this;
	    var channelId = self.$f7route.params.channelId;
	    var conversationId = self.$f7route.params.conversationId;

	    var store = new Store(self, {
	      preProcess: handlePreProcess$6,
	      get: ['emailmessage', 'list', { conversationId: conversationId, channelId: channelId }],
	      getFinished: getFinished$1,
	      postForm: ['emailmessage', 'reply', { conversationId: conversationId, channelId: channelId }],
	      subscribe: ['emailmessage', 'list', 'messages', { processLocally: true, subscriptionKey: conversationId }],
	      subscribeFinished: processSubscriptionResponse,
	    });
	    var storeIsTyping = new Store(self, {
	      postNow: ['message', 'istyping', { channelId: channelId, contextId: conversationId, type: 'email' }],
	      subscribe: ['emailmessage', 'istyping', null, { processLocally: true, subscriptionKey: conversationId }],
	      subscribeFinished: function (data) {
	        self.$refs.chat.showTyping(data);
	      },
	    });
	    return {
	      store: store,
	      storeIsTyping: storeIsTyping,
	      channelId: channelId,
	      conversationId: conversationId,
	      getLocalFinished: false,
	    };
	  },
	  computed: {
	    showPreviousLink: function showPreviousLink() {
	      return (!Utils$1.isUndefined(this.store.previousConversationId) && this.store.noMoreToGet) ||
	             (!Utils$1.isUndefined(this.store.previousConversationId) && this.getLocalFinished);
	    },
	    showNextLink: function showNextLink() {
	      return !Utils$1.isUndefined(this.store.subsequentConversationId);
	    },
	  },
	  methods: {
	    showOriginal: function showOriginal(message, data) {
	      var self = this;
	      function proceedData(emailMessage) {
	        var from = {
	          name: emailMessage.from.firstName,
	          email: emailMessage.from.email,
	        };
	        var to = {
	          name: emailMessage.to[0].firstName,
	          email: emailMessage.to[0].email,
	        };
	        var fromString = "<b>" + (from.name) + "</b> <span>&lt;" + (from.email) + "&gt;</span>";
	        var subjectString = emailMessage.subject;
	        var toString = "To: <span>" + (to.name) + (to.name !== to.email ? (" &lt;" + (to.email) + "&gt;") : '') + "</span>";
	        var popupInstance = Brief$1.f7.popup.create({
	          content: ("\n            <div class=\"popup email-original-popup\">\n              <div class=\"view\">\n                <div class=\"page\">\n                  <div class=\"navbar\">\n                    <div class=\"navbar-inner\">\n                      <div class=\"title\">Original email</div>\n                      <div class=\"right\">\n                        <a href=\"#\" class=\"link icon-only popup-close\">\n                          <i class=\"icon " + (self.$theme.md ? ' material-icons' : 'f7-icons') + "\">close</i>\n                        </a>\n                      </div>\n                    </div>\n                  </div>\n                  <div class=\"page-content\">\n                    <div class=\"list simple-list no-margin\">\n                      <ul>\n                        <li>" + fromString + "</li>\n                        <li>" + subjectString + "</li>\n                        <li>" + toString + "</li>\n                      </ul>\n                    </div>\n                    " + (Brief$1.f7.device.ios ? '<div class="email-original-iframe-wrap">' : '') + "\n                    " + (emailMessage.html && emailMessage.html.length ?
	                      '<iframe frameborder="0"></iframe>' :
	                      ("<div class=\"block\">" + (emailMessage.text) + "</div>")) + "\n                    " + (Brief$1.f7.device.ios ? '</div>' : '') + "\n                  </div>\n                </div>\n              </div>\n            </div>").trim(),
	          on: {
	            open: function open(popup) {
	              if (!emailMessage.html || !emailMessage.html.length) { return; }
	              var iframe = popup.$el.find('iframe')[0];
	              var body = iframe.contentDocument.body;
	              body.innerHTML = emailMessage.html;
	              if (Brief$1.isCordova) {
	                $$1(body).find('a').on('click', function onClick(e) {
	                  e.preventDefault();
	                  var $link = $$1(this);
	                  var url = $link.attr('href');
	                  if (!url || url === '#' || url.indexOf('javascript') >= 0) { return; }
	                  Brief$1.openInSystemBrowser(url);
	                });
	              } else {
	                $$1(body).find('a').attr('target', '_blank');
	              }
	            },
	          },
	        }).open();
	        if (!Brief$1.isCordova) {
	          document.addEventListener('keydown', function(e) {
	            if (e.code === 'Escape' && popupInstance) {
	              popupInstance.close();
	              popupInstance = null;
	            }
	          }, false);
	        }
	      }
	      if (data) {
	        proceedData(data);
	        return;
	      }

	      Brief$1.f7.preloader.show();
	      Brief$1.f7.request({
	        url: ((Brief$1.api) + "/emailmessage/original"),
	        method: 'GET',
	        dataType: 'json',
	        data: {
	          id: message.id,
	          access_token: window.localStorage.getItem('access_token'),
	          device_id: window.localStorage.getItem('device_id'),
	        },
	        success: function success(response) {
	          Brief$1.f7.preloader.hide();
	          proceedData(response.data);
	        },
	      });
	    },
	  },
	};

	/* script */
	var __vue_script__$1t = script$1t;

	/* template */
	var __vue_render__$1r = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('channel-chat-page',{ref:"chat",attrs:{"navbarTitle":"Reply","navbarRoot":false,"type":"email","channel-id":_vm.channelId,"conversation-id":_vm.conversationId,"store":_vm.store,"storeIsTyping":_vm.storeIsTyping,"show-previous-link":_vm.showPreviousLink,"show-next-link":_vm.showNextLink,"show-original-button":true,"focus-on-load":false,"use-mentions":true,"use-saved-replies":true,"signature":true},on:{"showOriginal":_vm.showOriginal}})};
	var __vue_staticRenderFns__$1r = [];

	  /* style */
	  var __vue_inject_styles__$1u = undefined;
	  /* scoped */
	  var __vue_scope_id__$1u = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$1u = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$1u = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$1u = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$1r, staticRenderFns: __vue_staticRenderFns__$1r },
	    __vue_inject_styles__$1u,
	    __vue_script__$1t,
	    __vue_scope_id__$1u,
	    __vue_is_functional_template__$1u,
	    __vue_module_identifier__$1u,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//

	function isReadByMe$1(message, userId) {
	  if (message.readByEveryone || message.ownerUserId === userId) {
	    return true;
	  }
	  return message.hasRead.find(function (x) { return x === userId; }) !== undefined;
	}

	function processSubscriptionResponse$1(response) {
	  var self = this;
	  var userId = self.$root.loggedInUser.id;
	  self.store.workerError = null;

	  var index = self.store.conversations
	    .findIndex(function (email) { return email.id === response.id; });

	  if (index === -1) {
	    var email = {
	      id: response.id,
	      conversationId: response.conversationId,
	      from: response.from ? utils_3$1(response.from) : null,
	      to: response.from ? utils_3$1(response.to[0]) : null,
	      subject: response.subject,
	      text: response.text,
	      sendDate: response.sendDate,
	      isReadByMe: isReadByMe$1(response, userId),
	      isAnsweredByUs: response.isAnsweredByUs,
	      markedAsDone: response.markedAsDone,
	      markedAsNotDone: response.markedAsNotDone,
	      waitedLongTimeForAnswer: !response.isAssigned && response.waitedLongTimeForAnswer,
	      isAssigned: response.isAssigned,
	      assignedUsers: response.assignedUsers
	    };
	    var conversationIndex = self.store.conversations
	      .findIndex(function (foundConversation) { return foundConversation.conversationId === response.conversationId; });

	    var q = self.query ? new RegExp(self.query, 'gim') : false;
	    var ms = response;
	    var canAdd = !q || (
	      q.test(ms.from.firstName) ||
	      q.test(ms.from.lastName) ||
	      q.test(ms.to.firstName) ||
	      q.test(ms.to.lastName) ||
	      q.test(ms.text) ||
	      q.test(ms.subject)
	    );
	    if (canAdd) {
	      if (conversationIndex >= 0) {
	        self.$set(self.store.conversations, conversationIndex, email);
	      } else {
	        var found = false;
	        for (var i = 0; i < self.store.conversations.length; i++) {
	          if (!self.store.conversations[i] || !self.store.conversations[i].sendDate) {
	            continue;
	          }
	          if (new Date(self.store.conversations[i].sendDate) < new Date(email.sendDate)) {
	            self.store.conversations.splice(i, 0, email);
	            found = true;
	            break;
	          }
	        }
	        if (!found && Utils$1.canAddConversation(self.store.conversations, email)) {
	          self.store.conversations.push(email);
	        }
	      }
	    }
	  } else {
	    var email$1 = Utils$1.extend(self.store.conversations[index], {
	      markedAsDone: response.markedAsDone,
	      markedAsNotDone: response.markedAsNotDone,
	      isReadByMe: isReadByMe$1(response, userId),
	      isAnsweredByUs: response.isAnsweredByUs,
	      waitedLongTimeForAnswer: response.waitedLongTimeForAnswer,
	      isAssigned: response.isAssigned,
	      assignedUsers: response.assignedUsers,
	    });
	    self.$set(self.store.conversations, index, email$1);
	  }
	}

	var script$1u = {
	  name: 'EmailConversationList',
	  data: function data() {
	    var self = this;
	    var channelId = self.$f7route.params.channelId;
	    var store = new Store(self, {
	      get: ['emailconversation', 'list', { id: channelId }],
	      subscribe: ['emailconversation', 'list', 'conversations', { processLocally: true, subscriptionKey: channelId }],
	      getLocalFinished: function getLocalFinished() { self.store.workerError = null; },
	      subscribeFinished: processSubscriptionResponse$1,
	      targetArrayName: 'conversations',
	    });
	    var storeMarkAsDone = new Store(self, {
	      postNow: ['emailconversation', 'done'],
	    });
	    var storeMarkAsNotDone = new Store(self, {
	      postNow: ['emailconversation', 'notdone'],
	    });
	    var batchStoreMarkAsDone = new Store(self, {
	      post: ['emailconversations', 'alldone'],
	    });
	    var batchStoreMarkAsRead = new Store(self, {
	      post: ['emailconversations', 'allread'],
	    });
	    var storeProgress = new Store(self, {
	      subscribe: ['emailchannel', 'list', null, { processLocally: true, subscriptionKey: channelId }],
	      subscribeFinished: function (data) {
	        if (!data.downloadInProgress) {
	          store.progress = null;
	        } else {
	          store.progress = {
	            current: data.progressCurrent,
	            total: data.progressTotal,
	          };
	        }
	      },
	    });
	    return {
	      store: store,
	      channelId: channelId,
	      storeMarkAsDone: storeMarkAsDone,
	      storeMarkAsNotDone: storeMarkAsNotDone,
	      batchStoreMarkAsDone: batchStoreMarkAsDone,
	      batchStoreMarkAsRead: batchStoreMarkAsRead,
	      storeProgress: storeProgress,
	      tokenUpdated: false,
	      tokenUpdateInProgress: false
	    };
	  },
	  methods: {
	    updateToken: function updateToken() {
	      var self = this;

	      self.tokenUpdateInProgress = true;

	      gmailService.givePermission(function () {
	        self.tokenUpdateInProgress = false;
	        self.tokenUpdated = true;
	      }, this.channelId);
	    },
	  },
	  mounted: function mounted() {
	    var self = this;
	    Brief.events.$on('refresh-worker-error-status', function () { return self.$set(self.store, 'workerError', null); });
	  },
	  beforeDestroy: function beforeDestroy() {
	    Brief.events.$off('refresh-worker-error-status');
	  },
	};

	/* script */
	var __vue_script__$1u = script$1u;

	/* template */
	var __vue_render__$1s = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('channel-conversation-page',{attrs:{"type":"email","introduction":true,"store":_vm.store,"storeMarkAsDone":_vm.storeMarkAsDone,"storeMarkAsNotDone":_vm.storeMarkAsNotDone,"batchStoreMarkAsDone":_vm.batchStoreMarkAsDone,"batchStoreMarkAsRead":_vm.batchStoreMarkAsRead,"photoAvatar":false,"sortConversationsByDate":true,"handleStores":true,"itemHeight":_vm.$theme.ios ? 92 : 91}},[(_vm.store && _vm.store.progress)?_c('div',{staticClass:"content-center",attrs:{"slot":"after-search"},slot:"after-search"},[_c('f7-block',{staticClass:"content-round content-white",attrs:{"strong":""}},[_vm._v("\n      Download in progress ("+_vm._s(_vm.store.progress.current)+" of "+_vm._s(_vm.store.progress.total)+")\n      "),_c('f7-progressbar',{attrs:{"progress":Math.round(_vm.store.progress.current / _vm.store.progress.total * 100)}})],1)],1):_vm._e(),_vm._v(" "),(_vm.store && _vm.store.workerError && _vm.store.isGmail && !_vm.tokenUpdated)?_c('div',{staticClass:"content-center",attrs:{"slot":"after-search"},slot:"after-search"},[_c('f7-block',{staticClass:"content-round content-white",attrs:{"strong":""}},[_vm._v("\n      Ops! We are not able to download your Gmail messages. Try give Brief permission to Gmail again.\n      "),_c('f7-button',{staticClass:"margin-top",attrs:{"big":"","fill":""},on:{"click":_vm.updateToken}},[_vm._v(_vm._s(_vm.tokenUpdateInProgress ? 'Giving permission...' : 'Give permission')+" "),(_vm.tokenUpdateInProgress)?_c('span',{staticClass:"spinner"}):_vm._e()])],1)],1):_vm._e(),_vm._v(" "),(_vm.store && _vm.store.workerError && !_vm.store.isGmail)?_c('div',{staticClass:"content-center",attrs:{"slot":"after-search"},slot:"after-search"},[_c('f7-block',{staticClass:"content-round content-white",attrs:{"strong":""}},[_vm._v("\n      Ops! We are not able to download your Email messages."),_c('br'),_vm._v("\n      Please verify email "),_c('f7-link',{attrs:{"href":("/email/" + _vm.channelId + "/account/")}},[_vm._v("host and credentials")]),_vm._v(" or contact Brief support.\n    ")],1)],1):_vm._e(),_vm._v(" "),_c('template',{slot:"introduction"},[_c('p',[_vm._v("Hi!")]),_vm._v(" "),_c('p',[_vm._v("We are downloading the latest emails for you and will let you know when its ready.")]),_vm._v(" "),_c('p',[_vm._v("/Brief")])]),_vm._v(" "),_c('common-toolbar-button',{attrs:{"slot":"end","white":"","href":("/email/" + _vm.channelId + "/create/"),"text":"Create new email"},slot:"end"})],2)};
	var __vue_staticRenderFns__$1s = [];

	  /* style */
	  var __vue_inject_styles__$1v = undefined;
	  /* scoped */
	  var __vue_scope_id__$1v = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$1v = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$1v = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$1v = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$1s, staticRenderFns: __vue_staticRenderFns__$1s },
	    __vue_inject_styles__$1v,
	    __vue_script__$1u,
	    __vue_scope_id__$1v,
	    __vue_is_functional_template__$1v,
	    __vue_module_identifier__$1v,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//
	//
	//
	//
	//
	//

	var script$1v = {
	  name: 'EmailChannelInfo',
	};

	/* script */
	var __vue_script__$1v = script$1v;

	/* template */
	var __vue_render__$1t = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('channel-info-page',{attrs:{"id":_vm.$f7route.params.channelId,"type":"email"}})};
	var __vue_staticRenderFns__$1t = [];

	  /* style */
	  var __vue_inject_styles__$1w = undefined;
	  /* scoped */
	  var __vue_scope_id__$1w = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$1w = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$1w = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$1w = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$1t, staticRenderFns: __vue_staticRenderFns__$1t },
	    __vue_inject_styles__$1w,
	    __vue_script__$1v,
	    __vue_scope_id__$1w,
	    __vue_is_functional_template__$1w,
	    __vue_module_identifier__$1w,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//
	//
	//
	//
	//
	//

	var script$1w = {
	  name: 'EmailChannelAutoReply',
	};

	/* script */
	var __vue_script__$1w = script$1w;

	/* template */
	var __vue_render__$1u = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('channel-autoreply-page',{attrs:{"id":_vm.$f7route.params.channelId,"type":"email"}})};
	var __vue_staticRenderFns__$1u = [];

	  /* style */
	  var __vue_inject_styles__$1x = undefined;
	  /* scoped */
	  var __vue_scope_id__$1x = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$1x = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$1x = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$1x = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$1u, staticRenderFns: __vue_staticRenderFns__$1u },
	    __vue_inject_styles__$1x,
	    __vue_script__$1w,
	    __vue_scope_id__$1x,
	    __vue_is_functional_template__$1x,
	    __vue_module_identifier__$1x,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//
	//
	//
	//
	//
	//

	var script$1x = {
	  name: 'EmailChannelWaitLimit',
	};

	/* script */
	var __vue_script__$1x = script$1x;

	/* template */
	var __vue_render__$1v = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('channel-waitlimit-page',{attrs:{"id":_vm.$f7route.params.channelId,"type":"email"}})};
	var __vue_staticRenderFns__$1v = [];

	  /* style */
	  var __vue_inject_styles__$1y = undefined;
	  /* scoped */
	  var __vue_scope_id__$1y = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$1y = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$1y = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$1y = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$1v, staticRenderFns: __vue_staticRenderFns__$1v },
	    __vue_inject_styles__$1y,
	    __vue_script__$1x,
	    __vue_scope_id__$1y,
	    __vue_is_functional_template__$1y,
	    __vue_module_identifier__$1y,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//
	//
	//
	//
	//
	//

	var script$1y = {
	  name: 'EmailChannelEmail',
	};

	/* script */
	var __vue_script__$1y = script$1y;

	/* template */
	var __vue_render__$1w = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('channel-email-page',{attrs:{"id":_vm.$f7route.params.channelId,"type":"email"}})};
	var __vue_staticRenderFns__$1w = [];

	  /* style */
	  var __vue_inject_styles__$1z = undefined;
	  /* scoped */
	  var __vue_scope_id__$1z = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$1z = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$1z = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$1z = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$1w, staticRenderFns: __vue_staticRenderFns__$1w },
	    __vue_inject_styles__$1z,
	    __vue_script__$1y,
	    __vue_scope_id__$1z,
	    __vue_is_functional_template__$1z,
	    __vue_module_identifier__$1z,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	var FacebookApiClient = function FacebookApiClient () {};

	FacebookApiClient.prototype.login = function login (permissions, callback, errorCallback) {
	    var this$1 = this;

	  window.facebookConnectPlugin.login(
	    permissions, 
	    function (response) {
	      if (response && response.status === 'connected') {
	        callback(response.authResponse.accessToken);
	      } else {
	        if (errorCallback) { errorCallback(response ? response.status : 'unknown'); }
	      }
	    }, 
	    function (error) {
	      this$1.logError(error);
	      if (errorCallback) { errorCallback(error); }
	    }
	  );
	};

	FacebookApiClient.prototype.getToken = function getToken (callback, errorCallback) {
	    var this$1 = this;

	  window.facebookConnectPlugin.getLoginStatus(
	    function (response) {
	      if (response && response.status === 'connected') {
	        callback(response.authResponse.accessToken);
	      } else {
	        if (errorCallback) { errorCallback(response ? response.status : 'unknown'); }
	      }
	    }, 
	    function (error) {
	      this$1.logError(error);
	      if (errorCallback) { errorCallback(error); }
	    }
	  );
	};

	FacebookApiClient.prototype.api = function api (url, permissions, callback, errorCallback) {
	    var this$1 = this;

	  window.facebookConnectPlugin.api(
	    url,
	    permissions,
	    function (response) {
	      callback(response.data || response);
	    },
	    function (error) {
	      this$1.logError(error);
	      if (errorCallback) { errorCallback(error); }
	    }
	  );
	};

	FacebookApiClient.prototype.logError = function logError (error) {
	  Brief$1.sendError(JSON.stringify(error));
	};

	var facebookApiClient = new FacebookApiClient();

	var permissions = ['pages_read_engagement', 'pages_show_list', 'pages_messaging', 'pages_manage_metadata'];

	var FacebookService = function FacebookService () {};

	FacebookService.prototype.givePermission = function givePermission (callback, errorCallback) {
	  facebookApiClient.login(permissions, callback, errorCallback);
	};

	FacebookService.prototype.getToken = function getToken (callback, errorCallback) {
	  facebookApiClient.getToken(callback, errorCallback);
	};

	FacebookService.prototype.getPages = function getPages (token, callback, errorCallback) {
	  facebookApiClient.api(("me/accounts?access_token=" + token), permissions, callback, errorCallback);
	};

	FacebookService.prototype.getPage = function getPage (token, pageId, callback, errorCallback) {
	  facebookApiClient.api((pageId + "?access_token=" + token + "&fields=access_token,name,username"), permissions, callback, errorCallback);
	};

	var facebookService = new FacebookService();

	//

	var script$1z = {
	  name: 'FacebookChannelSelect',
	  data: function data() {
	    return {
	      status: null,
	      isLoading: false,
	      needsLogin: true,
	      pages: [],
	    };
	  },
	  methods: {
	    givePermission: function login() {
	      var self = this;
	      self.isLoading = true;
	      facebookService.givePermission(function (token) {
	        facebookService.getPages(token, function (pages) {
	          self.isLoading = false;

	          if (pages.length === 0) {
	            self.status = 'Could not find any Facebook page connected to your account';
	            return;
	          }

	          self.pages = pages;
	          self.needsLogin = false;
	        }, function (error) {
	          Brief$1.notify('Failed to get Facebook pages details', error);
	        });
	      }, function (error) {
	        self.isLoading = false;
	        Brief$1.notify('Failed to login to Facebook', error);
	      });
	    },
	  },
	};

	/* script */
	var __vue_script__$1z = script$1z;

	/* template */
	var __vue_render__$1x = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f7-page',{staticClass:"page-form"},[_c('common-navbar',{attrs:{"title":"Create Facebook channel"}}),_vm._v(" "),(_vm.isLoading)?_c('div',{staticClass:"infinite-scroll-preloader"},[_c('f7-preloader')],1):_vm._e(),_vm._v(" "),_c('f7-block-footer',{domProps:{"textContent":_vm._s(_vm.status)}}),_vm._v(" "),(!_vm.isLoading)?_c('div',{staticClass:"content-center"},[(_vm.needsLogin)?_c('div',[_c('f7-block-title',[_vm._v("Give permission to Facebook")]),_vm._v(" "),_c('f7-block',{staticClass:"content-round content-white",attrs:{"strong":""}},[_vm._v("\n        Brief needs your permission to be able to download and handle your Facebook messages.\n        "),_c('f7-button',{staticClass:"margin-top",attrs:{"big":"","fill":""},on:{"click":_vm.givePermission}},[_vm._v("Give permission")])],1)],1):_vm._e(),_vm._v(" "),(!_vm.needsLogin)?_c('div',[_c('f7-block-title',[_vm._v("Select Facebook page")]),_vm._v(" "),_c('f7-list',_vm._l((_vm.pages),function(page){return _c('f7-list-item',{attrs:{"link":'/facebook/add/' + page.id + '/',"title":page.name}})}),1)],1):_vm._e()]):_vm._e()],1)};
	var __vue_staticRenderFns__$1x = [];

	  /* style */
	  var __vue_inject_styles__$1A = undefined;
	  /* scoped */
	  var __vue_scope_id__$1A = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$1A = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$1A = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$1A = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$1x, staticRenderFns: __vue_staticRenderFns__$1x },
	    __vue_inject_styles__$1A,
	    __vue_script__$1z,
	    __vue_scope_id__$1A,
	    __vue_is_functional_template__$1A,
	    __vue_module_identifier__$1A,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//

	var script$1A = {
	  name: 'FacebookChannelCreate',
	  data: function data() {
	    var self = this;

	    var store = new Store(self, {
	      postNow: ['facebookstream', 'create', { pageId: self.$f7route.params.pageId }],
	    });

	    return {
	      store: store,
	    };
	  },
	  created: function created() {
	    var self = this;

	    facebookService.getToken(function (token) {
	      facebookService.getPage(token, self.$f7route.params.pageId, function (page) {
	        self.store.pageId = self.$f7route.params.pageId;
	        self.store.pageName = page.name;
	        self.store.pageToken = page.access_token;
	      }, function (error) {
	        Brief$1.notify('Failed to get Facebook page details', error);
	      });
	    }, function (error) {
	      Brief$1.notify('Failed to login to Facebook', error);
	    });
	  },
	};

	/* script */
	var __vue_script__$1A = script$1A;

	/* template */
	var __vue_render__$1y = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('channel-create-page',{ref:"channelCreate",attrs:{"type":"facebook","store":_vm.store,"handleStores":true}})};
	var __vue_staticRenderFns__$1y = [];

	  /* style */
	  var __vue_inject_styles__$1B = undefined;
	  /* scoped */
	  var __vue_scope_id__$1B = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$1B = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$1B = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$1B = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$1y, staticRenderFns: __vue_staticRenderFns__$1y },
	    __vue_inject_styles__$1B,
	    __vue_script__$1A,
	    __vue_scope_id__$1B,
	    __vue_is_functional_template__$1B,
	    __vue_module_identifier__$1B,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//
	//
	//
	//
	//
	//

	var script$1B = { name: 'FacebookChannelInvite' };

	/* script */
	var __vue_script__$1B = script$1B;

	/* template */
	var __vue_render__$1z = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('channel-invite-page',{attrs:{"id":_vm.$f7route.params.channelId,"type":"facebook"}})};
	var __vue_staticRenderFns__$1z = [];

	  /* style */
	  var __vue_inject_styles__$1C = undefined;
	  /* scoped */
	  var __vue_scope_id__$1C = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$1C = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$1C = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$1C = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$1z, staticRenderFns: __vue_staticRenderFns__$1z },
	    __vue_inject_styles__$1C,
	    __vue_script__$1B,
	    __vue_scope_id__$1C,
	    __vue_is_functional_template__$1C,
	    __vue_module_identifier__$1C,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//
	//
	//
	//
	//
	//
	//

	var script$1C = { name: 'FacebookConversationAssign' };

	/* script */
	var __vue_script__$1C = script$1C;

	/* template */
	var __vue_render__$1A = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('conversation-assign-page',{attrs:{"id":_vm.$f7route.params.channelId,"conversationId":_vm.$f7route.params.conversationId,"type":"facebook"}})};
	var __vue_staticRenderFns__$1A = [];

	  /* style */
	  var __vue_inject_styles__$1D = undefined;
	  /* scoped */
	  var __vue_scope_id__$1D = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$1D = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$1D = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$1D = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$1A, staticRenderFns: __vue_staticRenderFns__$1A },
	    __vue_inject_styles__$1D,
	    __vue_script__$1C,
	    __vue_scope_id__$1D,
	    __vue_is_functional_template__$1D,
	    __vue_module_identifier__$1D,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//
	//
	//
	//
	//
	//

	var script$1D = { name: 'FacebookChannelJoin' };

	/* script */
	var __vue_script__$1D = script$1D;

	/* template */
	var __vue_render__$1B = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('channel-join-page',{attrs:{"id":_vm.$f7route.params.channelId,"type":"facebook"}})};
	var __vue_staticRenderFns__$1B = [];

	  /* style */
	  var __vue_inject_styles__$1E = undefined;
	  /* scoped */
	  var __vue_scope_id__$1E = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$1E = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$1E = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$1E = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$1B, staticRenderFns: __vue_staticRenderFns__$1B },
	    __vue_inject_styles__$1E,
	    __vue_script__$1D,
	    __vue_scope_id__$1E,
	    __vue_is_functional_template__$1E,
	    __vue_module_identifier__$1E,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//

	var script$1E = {
	  name: 'FacebookChannelSettings',
	  data: function data() {
	    var self = this;
	    var channelId = self.$f7route.params.channelId;

	    var store = new Store(self, {
	      get: ['facebookstream', 'settings', { id: channelId }],
	      post: ['facebookstream', 'rename'],
	      sync: false,
	    });
	    var storeLeave = new Store(self, {
	      post: ['channel', 'leave', { id: channelId, channelType: 'facebook' }],
	    });
	    var storeDelete = new Store(self, {
	      post: ['channel', 'delete', { id: channelId, channelType: 'facebook' }],
	    });
	    var storeUpdateToken = new Store(self, {
	      post: ['facebooktoken', 'update', { id: channelId }],
	    });

	    store.get();

	    return {
	      store: store,
	      storeLeave: storeLeave,
	      storeDelete: storeDelete,
	      storeUpdateToken: storeUpdateToken,
	      tokenUpdateInProgress: false,
	      tokenUpdated: false,
	    };
	  },
	  methods: {
	    updateToken: function updateToken() {
	      var self = this;

	      self.tokenUpdateInProgress = true;

	      facebookService.givePermission(function (token) {
	        facebookService.getPage(token, self.store.pageId, function (page) {
	          self.storeUpdateToken.post({ pageToken: page.access_token });
	          self.tokenUpdateInProgress = false;
	          self.tokenUpdated = true;
	        }, function (error) {
	          self.tokenUpdateInProgress = false;
	          Brief$1.notify('Failed to get Facebook page details', error);
	        });
	      }, function (error) {
	        self.tokenUpdateInProgress = false;
	        Brief$1.notify('Failed to login to Facebook', error);
	      });
	    },
	  },
	};

	/* script */
	var __vue_script__$1E = script$1E;

	/* template */
	var __vue_render__$1C = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('channel-settings-page',{attrs:{"type":"facebook","id":_vm.channelId,"name":_vm.store.name,"description":_vm.store.description,"isLoading":_vm.store.isLoading,"joinedUserCount":_vm.store.joinedUserCount,"isOwner":_vm.store.isOwner,"visibility":_vm.store.visibility,"longWaitingThreshold":_vm.store.longWaitingThreshold,"editWaitLimit":true,"editAutoReply":true,"editSignature":true,"editVisibility":true,"editInfo":true,"store":_vm.store,"storeLeave":_vm.storeLeave,"storeDelete":_vm.storeDelete,"handleStores":true}},[_c('template',{slot:"before-button"},[_c('f7-list',[_c('ul',[(!_vm.tokenUpdated)?_c('f7-list-button',{on:{"click":_vm.updateToken}},[_vm._v(_vm._s(_vm.tokenUpdateInProgress? 'Updating Facebook access...' : 'Update Facebook access')+" "),(_vm.tokenUpdateInProgress)?_c('span',{staticClass:"spinner"}):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.tokenUpdated)?_c('f7-block-footer',{staticClass:"padding"},[_vm._v("Facebook access updated")]):_vm._e()],1)])],1)],2)};
	var __vue_staticRenderFns__$1C = [];

	  /* style */
	  var __vue_inject_styles__$1F = undefined;
	  /* scoped */
	  var __vue_scope_id__$1F = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$1F = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$1F = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$1F = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$1C, staticRenderFns: __vue_staticRenderFns__$1C },
	    __vue_inject_styles__$1F,
	    __vue_script__$1E,
	    __vue_scope_id__$1F,
	    __vue_is_functional_template__$1F,
	    __vue_module_identifier__$1F,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//
	//
	//
	//
	//
	//

	var script$1F = { name: 'FacebookChannelSignature' };

	/* script */
	var __vue_script__$1F = script$1F;

	/* template */
	var __vue_render__$1D = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('channel-signature-page',{attrs:{"id":_vm.$f7route.params.channelId,"type":"facebook"}})};
	var __vue_staticRenderFns__$1D = [];

	  /* style */
	  var __vue_inject_styles__$1G = undefined;
	  /* scoped */
	  var __vue_scope_id__$1G = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$1G = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$1G = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$1G = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$1D, staticRenderFns: __vue_staticRenderFns__$1D },
	    __vue_inject_styles__$1G,
	    __vue_script__$1F,
	    __vue_scope_id__$1G,
	    __vue_is_functional_template__$1G,
	    __vue_module_identifier__$1G,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//
	//
	//
	//
	//
	//

	var script$1G = {
	  name: 'FacebookChannelMembers',
	};

	/* script */
	var __vue_script__$1G = script$1G;

	/* template */
	var __vue_render__$1E = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('channel-members-page',{attrs:{"id":_vm.$f7route.params.channelId,"type":"facebook"}})};
	var __vue_staticRenderFns__$1E = [];

	  /* style */
	  var __vue_inject_styles__$1H = undefined;
	  /* scoped */
	  var __vue_scope_id__$1H = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$1H = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$1H = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$1H = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$1E, staticRenderFns: __vue_staticRenderFns__$1E },
	    __vue_inject_styles__$1H,
	    __vue_script__$1G,
	    __vue_scope_id__$1H,
	    __vue_is_functional_template__$1H,
	    __vue_module_identifier__$1H,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//
	//
	//
	//
	//
	//

	var script$1H = {
	  name: 'FacebookChannelNotifications',
	};

	/* script */
	var __vue_script__$1H = script$1H;

	/* template */
	var __vue_render__$1F = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('channel-notifications-page',{attrs:{"id":_vm.$f7route.params.channelId,"type":"facebook"}})};
	var __vue_staticRenderFns__$1F = [];

	  /* style */
	  var __vue_inject_styles__$1I = undefined;
	  /* scoped */
	  var __vue_scope_id__$1I = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$1I = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$1I = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$1I = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$1F, staticRenderFns: __vue_staticRenderFns__$1F },
	    __vue_inject_styles__$1I,
	    __vue_script__$1H,
	    __vue_scope_id__$1I,
	    __vue_is_functional_template__$1I,
	    __vue_module_identifier__$1I,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	/**
	 * A specialized version of `_.forEach` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns `array`.
	 */
	function arrayEach(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length;

	  while (++index < length) {
	    if (iteratee(array[index], index, array) === false) {
	      break;
	    }
	  }
	  return array;
	}

	var _arrayEach = arrayEach;

	var _arrayEach$1 = /*#__PURE__*/Object.freeze({
		default: _arrayEach,
		__moduleExports: _arrayEach
	});

	/**
	 * Creates a `baseEach` or `baseEachRight` function.
	 *
	 * @private
	 * @param {Function} eachFunc The function to iterate over a collection.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseEach(eachFunc, fromRight) {
	  return function(collection, iteratee) {
	    if (collection == null) {
	      return collection;
	    }
	    if (!isArrayLike$2(collection)) {
	      return eachFunc(collection, iteratee);
	    }
	    var length = collection.length,
	        index = fromRight ? length : -1,
	        iterable = Object(collection);

	    while ((fromRight ? index-- : ++index < length)) {
	      if (iteratee(iterable[index], index, iterable) === false) {
	        break;
	      }
	    }
	    return collection;
	  };
	}

	var _createBaseEach = createBaseEach;

	var _createBaseEach$1 = /*#__PURE__*/Object.freeze({
		default: _createBaseEach,
		__moduleExports: _createBaseEach
	});

	var createBaseEach$1 = ( _createBaseEach$1 && _createBaseEach ) || _createBaseEach$1;

	/**
	 * The base implementation of `_.forEach` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 */
	var baseEach = createBaseEach$1(baseForOwn$1);

	var _baseEach = baseEach;

	var _baseEach$1 = /*#__PURE__*/Object.freeze({
		default: _baseEach,
		__moduleExports: _baseEach
	});

	/**
	 * Casts `value` to `identity` if it's not a function.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {Function} Returns cast function.
	 */
	function castFunction(value) {
	  return typeof value == 'function' ? value : identity$3;
	}

	var _castFunction = castFunction;

	var _castFunction$1 = /*#__PURE__*/Object.freeze({
		default: _castFunction,
		__moduleExports: _castFunction
	});

	var arrayEach$1 = ( _arrayEach$1 && _arrayEach ) || _arrayEach$1;

	var baseEach$1 = ( _baseEach$1 && _baseEach ) || _baseEach$1;

	var castFunction$1 = ( _castFunction$1 && _castFunction ) || _castFunction$1;

	/**
	 * Iterates over elements of `collection` and invokes `iteratee` for each element.
	 * The iteratee is invoked with three arguments: (value, index|key, collection).
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * **Note:** As with other "Collections" methods, objects with a "length"
	 * property are iterated like arrays. To avoid this behavior use `_.forIn`
	 * or `_.forOwn` for object iteration.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @alias each
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 * @see _.forEachRight
	 * @example
	 *
	 * _.forEach([1, 2], function(value) {
	 *   console.log(value);
	 * });
	 * // => Logs `1` then `2`.
	 *
	 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
	 *   console.log(key);
	 * });
	 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	 */
	function forEach$1(collection, iteratee) {
	  var func = isArray_1(collection) ? arrayEach$1 : baseEach$1;
	  return func(collection, castFunction$1(iteratee));
	}

	var forEach_1 = forEach$1;

	var forEach$2 = /*#__PURE__*/Object.freeze({
		default: forEach_1,
		__moduleExports: forEach_1
	});

	var require$$0$a = ( forEach$2 && forEach_1 ) || forEach$2;

	var each$1 = require$$0$a;

	var defineProperty = (function() {
	  try {
	    var func = getNative$1(Object, 'defineProperty');
	    func({}, '', {});
	    return func;
	  } catch (e) {}
	}());

	var _defineProperty$c = defineProperty;

	var _defineProperty$d = /*#__PURE__*/Object.freeze({
		default: _defineProperty$c,
		__moduleExports: _defineProperty$c
	});

	var defineProperty$1 = ( _defineProperty$d && _defineProperty$c ) || _defineProperty$d;

	/**
	 * The base implementation of `assignValue` and `assignMergeValue` without
	 * value checks.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function baseAssignValue(object, key, value) {
	  if (key == '__proto__' && defineProperty$1) {
	    defineProperty$1(object, key, {
	      'configurable': true,
	      'enumerable': true,
	      'value': value,
	      'writable': true
	    });
	  } else {
	    object[key] = value;
	  }
	}

	var _baseAssignValue = baseAssignValue;

	var _baseAssignValue$1 = /*#__PURE__*/Object.freeze({
		default: _baseAssignValue,
		__moduleExports: _baseAssignValue
	});

	/**
	 * A specialized version of `baseAggregator` for arrays.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} setter The function to set `accumulator` values.
	 * @param {Function} iteratee The iteratee to transform keys.
	 * @param {Object} accumulator The initial aggregated object.
	 * @returns {Function} Returns `accumulator`.
	 */
	function arrayAggregator(array, setter, iteratee, accumulator) {
	  var index = -1,
	      length = array == null ? 0 : array.length;

	  while (++index < length) {
	    var value = array[index];
	    setter(accumulator, value, iteratee(value), array);
	  }
	  return accumulator;
	}

	var _arrayAggregator = arrayAggregator;

	var _arrayAggregator$1 = /*#__PURE__*/Object.freeze({
		default: _arrayAggregator,
		__moduleExports: _arrayAggregator
	});

	/**
	 * Aggregates elements of `collection` on `accumulator` with keys transformed
	 * by `iteratee` and values set by `setter`.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} setter The function to set `accumulator` values.
	 * @param {Function} iteratee The iteratee to transform keys.
	 * @param {Object} accumulator The initial aggregated object.
	 * @returns {Function} Returns `accumulator`.
	 */
	function baseAggregator(collection, setter, iteratee, accumulator) {
	  baseEach$1(collection, function(value, key, collection) {
	    setter(accumulator, value, iteratee(value), collection);
	  });
	  return accumulator;
	}

	var _baseAggregator = baseAggregator;

	var _baseAggregator$1 = /*#__PURE__*/Object.freeze({
		default: _baseAggregator,
		__moduleExports: _baseAggregator
	});

	var arrayAggregator$1 = ( _arrayAggregator$1 && _arrayAggregator ) || _arrayAggregator$1;

	var baseAggregator$1 = ( _baseAggregator$1 && _baseAggregator ) || _baseAggregator$1;

	/**
	 * Creates a function like `_.groupBy`.
	 *
	 * @private
	 * @param {Function} setter The function to set accumulator values.
	 * @param {Function} [initializer] The accumulator object initializer.
	 * @returns {Function} Returns the new aggregator function.
	 */
	function createAggregator(setter, initializer) {
	  return function(collection, iteratee) {
	    var func = isArray_1(collection) ? arrayAggregator$1 : baseAggregator$1,
	        accumulator = initializer ? initializer() : {};

	    return func(collection, setter, baseIteratee$1(iteratee, 2), accumulator);
	  };
	}

	var _createAggregator = createAggregator;

	var _createAggregator$1 = /*#__PURE__*/Object.freeze({
		default: _createAggregator,
		__moduleExports: _createAggregator
	});

	var baseAssignValue$1 = ( _baseAssignValue$1 && _baseAssignValue ) || _baseAssignValue$1;

	var createAggregator$1 = ( _createAggregator$1 && _createAggregator ) || _createAggregator$1;

	/** Used for built-in method references. */
	var objectProto$c = Object.prototype;

	/** Used to check objects for own properties. */
	var hasOwnProperty$a = objectProto$c.hasOwnProperty;

	/**
	 * Creates an object composed of keys generated from the results of running
	 * each element of `collection` thru `iteratee`. The order of grouped values
	 * is determined by the order they occur in `collection`. The corresponding
	 * value of each key is an array of elements responsible for generating the
	 * key. The iteratee is invoked with one argument: (value).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	 * @returns {Object} Returns the composed aggregate object.
	 * @example
	 *
	 * _.groupBy([6.1, 4.2, 6.3], Math.floor);
	 * // => { '4': [4.2], '6': [6.1, 6.3] }
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.groupBy(['one', 'two', 'three'], 'length');
	 * // => { '3': ['one', 'two'], '5': ['three'] }
	 */
	var groupBy = createAggregator$1(function(result, value, key) {
	  if (hasOwnProperty$a.call(result, key)) {
	    result[key].push(value);
	  } else {
	    baseAssignValue$1(result, key, [value]);
	  }
	});

	var groupBy_1 = groupBy;

	//

	function isOurMessage(message) {
	  return message.from.facebookUserId === this.store.pageId;
	}

	function isFromPage(message) {
	  return message.from.facebookUserId === this.store.pageId;
	}

	function getPhotoUrl(message) {
	  var to = isArray_1(message.to) ? message.to[0] : message.to;
	  var photoId = isFromPage.bind(this)(message) ? to.facebookUserId : message.from.facebookUserId;
	  var channelId = isFromPage.bind(this)(message) ? to.channelId : message.from.channelId;

	  if (photoId) {
	    return ((this.domain) + "/api/facebook/picture?id=" + photoId + "&channelId=" + (channelId || ''));
	  }
	  return null;
	}
	function isReadByMe$2(message) {
	  var userId = this.$root.loggedInUser.id;

	  return !(!message.readByEveryone
	      && !message.hasRead.filter(function (item) { return (item === userId); }).length
	      && message.ownerUserId !== userId);
	}

	function processSubscriptionResponse$2(resp) {
	  var self = this;
	  var newConversations = groupBy_1(self.store.messages, 'conversationId');
	  self.store.workerError = null;
	  self.store.isExpired = false;
	  self.store.messages = [];

	  var q = self.query ? new RegExp(self.query, 'gim') : false;
	  each$1(newConversations, function (messages, conversationId) {
	    var conversationIndex = findKey_1(self.store.conversations, { conversationId: conversationId });
	    var message = messages[messages.length - 1];
	    Utils$1.extend(message, {
	      isOurMessage: isOurMessage.bind(self)(message),
	      photoUrl: getPhotoUrl.bind(self)(message),
	      isReadByMe: isReadByMe$2.bind(self)(message),
	      from: utils_3$1(message.from),
	      to: utils_3$1(message.to[0]),
	      assignedUsers: resp.assignedUsers
	    });
	    if (!q || (
	      q.test(message.from.firstName) ||
	      q.test(message.from.lastName) ||
	      q.test(message.to.firstName) ||
	      q.test(message.to.lastName) ||
	      q.test(message.text)
	    )) {
	      if (!isUndefined_1(conversationIndex)) {
	        self.$set(self.store.conversations, conversationIndex, message);
	      } else {
	        var found = false;
	        for (var i = 0; i < self.store.conversations.length; i++) {
	          if (!self.store.conversations[i] || !self.store.conversations[i].sendDate) {
	            continue;
	          }
	          if (new Date(self.store.conversations[i].sendDate) < new Date(message.sendDate)) {
	            self.store.conversations.splice(i, 0, message);
	            found = true;
	            break;
	          }
	        }
	        if (!found && Utils$1.canAddConversation(self.store.conversations, message)) {
	          self.store.conversations.push(message);
	        }
	      }
	    }
	  });
	}
	var script$1I = {
	  name: 'FacebookConversationList',
	  data: function data() {
	    var self = this;
	    var channelId = self.$f7route.params.channelId;

	    var store = new Store(self, {
	      get: ['facebookconversation', 'list', { id: channelId }],
	      subscribe: ['facebookconversation', 'list', 'messages', { subscriptionKey: channelId }],
	      getLocalFinished: function getLocalFinished() {},
	      subscribeFinished: processSubscriptionResponse$2,
	      targetArrayName: 'conversations',
	    });
	    var storeMarkAsDone = new Store(self, {
	      postNow: ['facebookconversation', 'done'],
	    });
	    var storeMarkAsNotDone = new Store(self, {
	      postNow: ['facebookconversation', 'notdone'],
	    });
	    var batchStoreMarkAsDone = new Store(self, {
	      post: ['facebookconversations', 'alldone'],
	    });
	    var batchStoreMarkAsRead = new Store(self, {
	      post: ['facebookconversations', 'allread'],
	    });
	    var storeUpdateToken = new Store(self, {
	      post: ['facebooktoken', 'update', { id: channelId }],
	    });
	    var storeProgress = new Store(self, {
	      subscribe: ['facebookchannel', 'list', null, { processLocally: true, subscriptionKey: channelId }],
	      subscribeFinished: function (data) {
	        if (!data.downloadInProgress) {
	          store.progress = null;
	        } else {
	          store.progress = {
	            current: data.progressCurrent,
	            total: data.progressTotal,
	          };
	        }
	      },
	    });
	    return {
	      store: store,
	      storeMarkAsDone: storeMarkAsDone,
	      storeMarkAsNotDone: storeMarkAsNotDone,
	      batchStoreMarkAsDone: batchStoreMarkAsDone,
	      batchStoreMarkAsRead: batchStoreMarkAsRead,
	      storeUpdateToken: storeUpdateToken,
	      storeProgress: storeProgress,
	      tokenUpdated: false,
	      tokenUpdateInProgress: false
	    };
	  },
	  methods: {
	    updateToken: function updateToken() {
	      var self = this;

	      self.tokenUpdateInProgress = true;

	      facebookService.givePermission(function (token) {
	        facebookService.getPage(token, self.store.pageId, function (page) {
	          self.storeUpdateToken.post({ pageToken: page.access_token });
	          self.tokenUpdateInProgress = false;
	          self.tokenUpdated = true;
	        }, function (error) {
	          self.tokenUpdateInProgress = false;
	          Brief$1.notify('Failed to get Facebook page details', error);
	        });
	      }, function (error) {
	        self.tokenUpdateInProgress = false;
	        Brief$1.notify('Failed to login to Facebook', error);
	      });
	    }
	  },
	};

	/* script */
	var __vue_script__$1I = script$1I;

	/* template */
	var __vue_render__$1G = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('channel-conversation-page',{attrs:{"type":"facebook","introduction":true,"store":_vm.store,"storeMarkAsDone":_vm.storeMarkAsDone,"storeMarkAsNotDone":_vm.storeMarkAsNotDone,"batchStoreMarkAsDone":_vm.batchStoreMarkAsDone,"batchStoreMarkAsRead":_vm.batchStoreMarkAsRead,"photoAvatar":true,"sortConversationsByDate":false,"handleStores":true,"itemHeight":_vm.$theme.ios ? 76 : 70}},[(_vm.store && _vm.store.progress)?_c('div',{staticClass:"content-center",attrs:{"slot":"after-search"},slot:"after-search"},[_c('f7-block',{staticClass:"content-round content-white",attrs:{"strong":""}},[_vm._v("\n      Download in progress ("+_vm._s(_vm.store.progress.current)+" of "+_vm._s(_vm.store.progress.total)+")\n      "),_c('f7-progressbar',{attrs:{"progress":Math.round(_vm.store.progress.current / _vm.store.progress.total * 100)}})],1)],1):_vm._e(),_vm._v(" "),(_vm.store && _vm.store.workerError && !_vm.tokenUpdated)?_c('div',{staticClass:"content-center",attrs:{"slot":"after-search"},slot:"after-search"},[_c('f7-block',{staticClass:"content-round content-white",attrs:{"strong":""}},[_vm._v("\n      Ops! We are not able to download your Facebook messages. Try give Brief permission to Facebook again.\n      "),_c('f7-button',{staticClass:"margin-top",attrs:{"big":"","fill":""},on:{"click":_vm.updateToken}},[_vm._v(_vm._s(_vm.tokenUpdateInProgress ? 'Giving permission...' : 'Give permission')+" "),(_vm.tokenUpdateInProgress)?_c('span',{staticClass:"spinner"}):_vm._e()])],1)],1):_vm._e(),_vm._v(" "),_c('template',{slot:"introduction"},[_c('p',[_vm._v("Hi!")]),_vm._v(" "),_c('p',[_vm._v("We are downloading the latest messages for your Facebook page and will let you know when its ready.")]),_vm._v(" "),_c('p',[_vm._v("/Brief")])])],2)};
	var __vue_staticRenderFns__$1G = [];

	  /* style */
	  var __vue_inject_styles__$1J = undefined;
	  /* scoped */
	  var __vue_scope_id__$1J = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$1J = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$1J = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$1J = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$1G, staticRenderFns: __vue_staticRenderFns__$1G },
	    __vue_inject_styles__$1J,
	    __vue_script__$1I,
	    __vue_scope_id__$1J,
	    __vue_is_functional_template__$1J,
	    __vue_module_identifier__$1J,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//

	function getNameOrEmail(contact) {
	  return contact.firstName ? (((contact.firstName) + " " + (contact.lastName))).trim() : contact.email;
	}
	function isOurMessage$1(message) {
	  return message.from.facebookUserId === this.store.pageId;
	}
	function getPhotoUrl$1(message) {
	  var to = message.to && message.to.length > 0 ? message.to[0] : message.to;
	  var photoId = isOurMessage$1.bind(this)(message) ? to.facebookUserId : message.from.facebookUserId;
	  var channelId = isOurMessage$1.bind(this)(message) ? to.channelId : message.from.channelId;

	  if (photoId) {
	    return ((this.domain) + "/api/facebook/picture?id=" + photoId + "&channelId=" + (channelId || ''));
	  }
	  return null;
	}
	function handleSubscribeFinished(response) {
	  var self = this;

	  var index = self.store.messages.findIndex(function (msg) { return msg.id === response.id; });
	  if (response.conversationId === self.$f7route.params.conversationId && response.subscriptionKey === self.$f7route.params.channelId) {
	    response.fullName = response.from ? getNameOrEmail.bind(self)(response.from) : null;
	    response.isOurMessage = response.from ? isOurMessage$1.bind(self)(response) : null;
	    response.photoUrl = response.from ? getPhotoUrl$1.bind(self)(response) : null;

	    if (index <= -1) {
	      self.store.messages.push(response);
	    } else {
	      self.$set(self.store.messages, index, response);
	    }
	  }

	  self.$nextTick(function () {
	    Brief$1.events.$emit('files-updated');
	  });
	}
	function isReadByMe$3(message, userId) {
	  if (message.readByEveryone || message.ownerUserId === userId) {
	    return true;
	  }
	  return message.hasRead.find(function (x) { return x === userId; }) !== undefined;
	}
	function handlePreProcess$7(data) {
	  var self = this;

	  var userId = self.$root.loggedInUser.id;
	  data.isReadByMe = isReadByMe$3(data, userId);

	  return true;
	}

	var script$1J = {
	  name: 'FacebookMessageList',
	  data: function data() {
	    var self = this;
	    var channelId = self.$f7route.params.channelId;
	    var conversationId = self.$f7route.params.conversationId;

	    var store = new Store(self, {
	      get: ['facebookmessage', 'list', { streamId: channelId, conversationId: conversationId }],
	      postForm: ['facebookmessage', 'reply', { conversationId: conversationId, streamId: channelId }],
	      subscribe: ['facebookmessage', 'list', 'messages', { processLocally: true, subscriptionKey: conversationId }],
	      preProcess: handlePreProcess$7,
	      subscribeFinished: handleSubscribeFinished,
	    });
	    var storeIsTyping = new Store(self, {
	      postNow: ['message', 'istyping', { channelId: channelId, contextId: conversationId, type: 'facebook' }],
	      subscribe: ['facebookmessage', 'istyping', null, { processLocally: true, subscriptionKey: conversationId }],
	      subscribeFinished: function (subscribeData) {
	        self.$refs.chat.showTyping(subscribeData);
	      },
	    });
	    return {
	      store: store,
	      storeIsTyping: storeIsTyping,
	      channelId: channelId,
	      conversationId: conversationId,
	    };
	  },
	};

	/* script */
	var __vue_script__$1J = script$1J;

	/* template */
	var __vue_render__$1H = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('channel-chat-page',{ref:"chat",attrs:{"navbarTitle":"Reply","navbarRoot":false,"type":"facebook","channel-id":_vm.channelId,"conversation-id":_vm.conversationId,"store":_vm.store,"storeIsTyping":_vm.storeIsTyping,"focus-on-load":false,"use-mentions":true,"use-saved-replies":true,"signature":true}})};
	var __vue_staticRenderFns__$1H = [];

	  /* style */
	  var __vue_inject_styles__$1K = undefined;
	  /* scoped */
	  var __vue_scope_id__$1K = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$1K = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$1K = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$1K = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$1H, staticRenderFns: __vue_staticRenderFns__$1H },
	    __vue_inject_styles__$1K,
	    __vue_script__$1J,
	    __vue_scope_id__$1K,
	    __vue_is_functional_template__$1K,
	    __vue_module_identifier__$1K,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//
	//
	//
	//
	//
	//

	var script$1K = {
	  name: 'FacebookChannelInfo',
	};

	/* script */
	var __vue_script__$1K = script$1K;

	/* template */
	var __vue_render__$1I = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('channel-info-page',{attrs:{"id":_vm.$f7route.params.channelId,"type":"facebook"}})};
	var __vue_staticRenderFns__$1I = [];

	  /* style */
	  var __vue_inject_styles__$1L = undefined;
	  /* scoped */
	  var __vue_scope_id__$1L = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$1L = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$1L = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$1L = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$1I, staticRenderFns: __vue_staticRenderFns__$1I },
	    __vue_inject_styles__$1L,
	    __vue_script__$1K,
	    __vue_scope_id__$1L,
	    __vue_is_functional_template__$1L,
	    __vue_module_identifier__$1L,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//
	//
	//
	//
	//
	//

	var script$1L = {
	  name: 'FacebookChannelAutoReply',
	};

	/* script */
	var __vue_script__$1L = script$1L;

	/* template */
	var __vue_render__$1J = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('channel-autoreply-page',{attrs:{"id":_vm.$f7route.params.channelId,"type":"facebook"}})};
	var __vue_staticRenderFns__$1J = [];

	  /* style */
	  var __vue_inject_styles__$1M = undefined;
	  /* scoped */
	  var __vue_scope_id__$1M = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$1M = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$1M = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$1M = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$1J, staticRenderFns: __vue_staticRenderFns__$1J },
	    __vue_inject_styles__$1M,
	    __vue_script__$1L,
	    __vue_scope_id__$1M,
	    __vue_is_functional_template__$1M,
	    __vue_module_identifier__$1M,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//
	//
	//
	//
	//
	//

	var script$1M = {
	  name: 'FacebookChannelWaitLimit',
	};

	/* script */
	var __vue_script__$1M = script$1M;

	/* template */
	var __vue_render__$1K = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('channel-waitlimit-page',{attrs:{"id":_vm.$f7route.params.channelId,"type":"facebook"}})};
	var __vue_staticRenderFns__$1K = [];

	  /* style */
	  var __vue_inject_styles__$1N = undefined;
	  /* scoped */
	  var __vue_scope_id__$1N = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$1N = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$1N = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$1N = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$1K, staticRenderFns: __vue_staticRenderFns__$1K },
	    __vue_inject_styles__$1N,
	    __vue_script__$1M,
	    __vue_scope_id__$1N,
	    __vue_is_functional_template__$1N,
	    __vue_module_identifier__$1N,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	var permissions$1 = ['pages_read_engagement', 'instagram_basic', 'instagram_manage_messages', 'pages_manage_metadata'];

	var InstagramService = function InstagramService () {};

	InstagramService.prototype.givePermission = function givePermission (callback, errorCallback) {
	  facebookApiClient.login(permissions$1, callback, errorCallback);
	};
	  
	InstagramService.prototype.getToken = function getToken (callback, errorCallback) {
	  facebookApiClient.getToken(callback, errorCallback);
	};

	InstagramService.prototype.getPages = function getPages (token, callback, errorCallback) {
	  facebookApiClient.api(("me/accounts?access_token=" + token), permissions$1, callback, errorCallback);
	};

	InstagramService.prototype.getPage = function getPage (token, pageId, callback, errorCallback) {
	  facebookApiClient.api((pageId + "?access_token=" + token + "&fields=access_token,name,username,connected_instagram_account"), permissions$1, callback, errorCallback);
	};

	var instagramService = new InstagramService();

	//

	var script$1N = {
	  name: 'InstagramChannelSelect',
	  data: function data() {
	    return {
	      status: null,
	      isLoading: false,
	      needsLogin: true,
	      pages: [],
	    };
	  },
	  methods: {
	    givePermission: function login() {
	      var self = this;
	      self.isLoading = true;
	      instagramService.givePermission(function (token) {
	        instagramService.getPages(token, function (pages) {
	          self.isLoading = false;

	          if (pages.length === 0) {
	            self.status = 'Could not find any Facebook page connected to your account';
	            return;
	          }

	          self.pages = pages;
	          self.needsLogin = false;
	        }, function (error) {
	          Brief$1.notify('Failed to get Facebook pages details', error);
	        });
	      }, function (error) {
	        self.isLoading = false;
	        Brief$1.notify('Failed to login to Facebook', error);
	      });
	    },
	  },
	};

	/* script */
	var __vue_script__$1N = script$1N;

	/* template */
	var __vue_render__$1L = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f7-page',{staticClass:"page-form"},[_c('common-navbar',{attrs:{"title":"Create Instagram channel"}}),_vm._v(" "),(_vm.isLoading)?_c('div',{staticClass:"infinite-scroll-preloader"},[_c('f7-preloader')],1):_vm._e(),_vm._v(" "),_c('f7-block-footer',{domProps:{"textContent":_vm._s(_vm.status)}}),_vm._v(" "),(!_vm.isLoading)?_c('div',{staticClass:"content-center"},[(_vm.needsLogin)?_c('div',[_c('f7-block-title',[_vm._v("Give permission to Instagram")]),_vm._v(" "),_c('f7-block',{staticClass:"content-round content-white",attrs:{"strong":""}},[_vm._v("\n        Brief needs your permission to be able to download and handle your Instagram messages.\n        "),_c('f7-button',{staticClass:"margin-top",attrs:{"big":"","fill":""},on:{"click":_vm.givePermission}},[_vm._v("Give permission")])],1)],1):_vm._e(),_vm._v(" "),(!_vm.needsLogin)?_c('div',[_c('f7-block-title',[_vm._v("Select Facebook page connected to Instagram")]),_vm._v(" "),_c('f7-list',_vm._l((_vm.pages),function(page){return _c('f7-list-item',{attrs:{"link":'/instagram/add/' + page.id + '/',"title":page.name}})}),1)],1):_vm._e()]):_vm._e()],1)};
	var __vue_staticRenderFns__$1L = [];

	  /* style */
	  var __vue_inject_styles__$1O = undefined;
	  /* scoped */
	  var __vue_scope_id__$1O = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$1O = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$1O = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$1O = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$1L, staticRenderFns: __vue_staticRenderFns__$1L },
	    __vue_inject_styles__$1O,
	    __vue_script__$1N,
	    __vue_scope_id__$1O,
	    __vue_is_functional_template__$1O,
	    __vue_module_identifier__$1O,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//

	var script$1O = {
	  name: 'InstagramChannelCreate',
	  data: function data() {
	    var self = this;

	    var store = new Store(self, {
	      postNow: ['instagramstream', 'create', { pageId: self.$f7route.params.pageId }],
	    });

	    return {
	      store: store,
	    };
	  },
	  created: function created() {
	    var self = this;

	    instagramService.getToken(function (token) {
	      instagramService.getPage(token, self.$f7route.params.pageId, function (page) {
	        self.store.pageId = self.$f7route.params.pageId;
	        self.store.pageName = page.name;
	        self.store.pageToken = page.access_token;
	        self.store.username = page.username;
	        self.store.accountId = page.connected_instagram_account.id;
	      }, function (error) {
	        Brief$1.notify('Failed to get Facebook page details', error);
	      });
	    }, function (error) {
	      Brief$1.notify('Failed to login to Facebook', error);
	    });
	  },
	};

	/* script */
	var __vue_script__$1O = script$1O;

	/* template */
	var __vue_render__$1M = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('channel-create-page',{ref:"channelCreate",attrs:{"type":"instagram","store":_vm.store,"handleStores":true}})};
	var __vue_staticRenderFns__$1M = [];

	  /* style */
	  var __vue_inject_styles__$1P = undefined;
	  /* scoped */
	  var __vue_scope_id__$1P = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$1P = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$1P = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$1P = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$1M, staticRenderFns: __vue_staticRenderFns__$1M },
	    __vue_inject_styles__$1P,
	    __vue_script__$1O,
	    __vue_scope_id__$1P,
	    __vue_is_functional_template__$1P,
	    __vue_module_identifier__$1P,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//

	function isReadByMe$4(message) {
	  var userId = this.$root.loggedInUser.id;

	  return !(!message.readByEveryone
	      && !message.hasRead.filter(function (item) { return (item === userId); }).length
	      && message.ownerUserId !== userId);
	}

	function processSubscriptionResponse$3(resp) {
	  var self = this;
	  var newConversations = groupBy_1(self.store.messages, 'conversationId');
	  self.store.messages = [];
	  self.store.workerError = false;

	  var q = self.query ? new RegExp(self.query, 'gim') : false;
	  each$1(newConversations, function (messages, conversationId) {
	    var conversationIndex = findKey_1(self.store.conversations, { conversationId: conversationId });
	    var message = messages[messages.length - 1];
	    Utils$1.extend(message, {
	      isReadByMe: isReadByMe$4.bind(self)(message),
	      from: utils_3$1(message.from),
	      to: utils_3$1(message.to[0]),
	      assignedUsers: resp.assignedUsers
	    });
	    if (!q || (
	      q.test(message.from.fullName) ||
	      q.test(message.from.username) ||
	      q.test(message.to.fullName) ||
	      q.test(message.to.username) ||
	      q.test(message.text)
	    )) {
	      if (!isUndefined_1(conversationIndex)) {
	        self.$set(self.store.conversations, conversationIndex, message);
	      } else {
	        var found = false;
	        for (var i = 0; i < self.store.conversations.length; i++) {
	          if (!self.store.conversations[i] || !self.store.conversations[i].sendDate) {
	            continue;
	          }
	          if (new Date(self.store.conversations[i].sendDate) < new Date(message.sendDate)) {
	            self.store.conversations.splice(i, 0, message);
	            found = true;
	            break;
	          }
	        }
	        if (!found && Utils$1.canAddConversation(self.store.conversations, message)) {
	          self.store.conversations.push(message);
	        }
	      }
	    }
	  });
	}
	var script$1P = {
	  name: 'InstagramConversationList',
	  data: function data() {
	    var self = this;
	    var channelId = self.$f7route.params.channelId;

	    var store = new Store(self, {
	      get: ['instagramconversation', 'list', { id: channelId }],
	      subscribe: ['instagramconversation', 'list', 'messages', { subscriptionKey: channelId }],
	      getLocalFinished: function getLocalFinished() {},
	      subscribeFinished: processSubscriptionResponse$3,
	      targetArrayName: 'conversations',
	    });
	    var storeMarkAsDone = new Store(self, {
	      postNow: ['instagramconversation', 'done'],
	    });
	    var storeMarkAsNotDone = new Store(self, {
	      postNow: ['instagramconversation', 'notdone'],
	    });
	    var batchStoreMarkAsDone = new Store(self, {
	      post: ['instagramconversations', 'alldone'],
	    });
	    var batchStoreMarkAsRead = new Store(self, {
	      post: ['instagramconversations', 'allread'],
	    });
	    var storeUpdateToken = new Store(self, {
	      post: ['instagramtoken', 'update', { id: channelId }],
	    });
	    var storeProgress = new Store(self, {
	      subscribe: ['instagramchannel', 'list', null, { processLocally: true, subscriptionKey: channelId }],
	      subscribeFinished: function (data) {
	        if (data.errorCode) {
	          store.workerError = data.continousWorkerFailureCount > 10;
	          store.latestError = data.latestError;
	          store.errorCode = data.errorCode;
	        }
	        else if (!data.downloadInProgress) {
	          store.progress = null;
	        } else {
	          store.progress = {
	            current: data.progressCurrent,
	            total: data.progressTotal,
	          };
	        }
	      },
	    });
	    return {
	      store: store,
	      storeMarkAsDone: storeMarkAsDone,
	      storeMarkAsNotDone: storeMarkAsNotDone,
	      batchStoreMarkAsDone: batchStoreMarkAsDone,
	      batchStoreMarkAsRead: batchStoreMarkAsRead,
	      storeUpdateToken: storeUpdateToken,
	      storeProgress: storeProgress,
	      tokenUpdated: false,
	      tokenUpdateInProgress: false
	    };
	  },
	  methods: {
	    updateToken: function updateToken() {
	      var self = this;

	      self.tokenUpdateInProgress = true;

	      instagramService.givePermission(function (token) {
	        instagramService.getPage(token, self.store.pageId, function (page) {
	          self.storeUpdateToken.post({ pageToken: page.access_token });
	          self.tokenUpdateInProgress = false;
	          self.tokenUpdated = true;
	          self.store.workerError = false;
	          self.store.latestError = null;
	          self.store.errorCode = null;
	        }, function (error) {
	          self.tokenUpdateInProgress = false;
	          Brief$1.notify('Failed to get Facebook page details', error);
	        });
	      }, function (error) {
	        self.tokenUpdateInProgress = false;
	        Brief$1.notify('Failed to login to Facebook', error);
	      });
	    },
	  },
	};

	/* script */
	var __vue_script__$1P = script$1P;

	/* template */
	var __vue_render__$1N = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('channel-conversation-page',{attrs:{"type":"instagram","introduction":true,"store":_vm.store,"storeMarkAsDone":_vm.storeMarkAsDone,"storeMarkAsNotDone":_vm.storeMarkAsNotDone,"batchStoreMarkAsDone":_vm.batchStoreMarkAsDone,"batchStoreMarkAsRead":_vm.batchStoreMarkAsRead,"photoAvatar":true,"sortConversationsByDate":false,"handleStores":true,"itemHeight":_vm.$theme.ios ? 76 : 70}},[(_vm.store && _vm.store.progress)?_c('div',{staticClass:"content-center",attrs:{"slot":"after-search"},slot:"after-search"},[_c('f7-block',{staticClass:"content-round content-white",attrs:{"strong":""}},[_vm._v("\n      Download in progress\n      "),_c('f7-progressbar',{attrs:{"progress":Math.round(_vm.store.progress.current / _vm.store.progress.total * 100)}})],1)],1):_vm._e(),_vm._v(" "),(_vm.store && _vm.store.workerError && !_vm.tokenUpdated)?_c('div',{staticClass:"content-center",attrs:{"slot":"after-search"},slot:"after-search"},[_c('f7-block',{staticClass:"content-round content-white",attrs:{"strong":""}},[(_vm.store.errorCode === 1001)?_c('div',[_vm._v("\n        Ops! We are not able to download your Instagram messages. Make sure you have enabled access to Instagram Direct messages in the "),_c('b',[_vm._v("Instagram mobile app")]),_vm._v(" by following these steps. After the steps are completed, press the button below.\n        "),_c('common-files',{attrs:{"files":[{ contentType: 'image/png', url: _vm.path.imageUrl('9052f071-3671-4b4a-90e1-96aeb1362716.png', 'autorotate=true&h=500') }],"use-img":true}})],1):_c('div',[_vm._v("\n        Ops! We are not able to download your Instagram messages. Try give Brief permission to Instagram again.\n      ")]),_vm._v(" "),_c('f7-button',{staticClass:"margin-top",attrs:{"big":"","fill":""},on:{"click":_vm.updateToken}},[_vm._v(_vm._s(_vm.tokenUpdateInProgress ? 'In progress...' : _vm.store.errorCode === 1001 ? 'I have enabled access' : 'Give permission')+" "),(_vm.tokenUpdateInProgress)?_c('span',{staticClass:"spinner"}):_vm._e()])],1)],1):_vm._e(),_vm._v(" "),_c('template',{slot:"introduction"},[_c('p',[_vm._v("Hi!")]),_vm._v(" "),_c('p',[_vm._v("We are downloading the latest messages for your Instagram account and will let you know when its ready.")]),_vm._v(" "),_c('p',[_vm._v("/Brief")])])],2)};
	var __vue_staticRenderFns__$1N = [];

	  /* style */
	  var __vue_inject_styles__$1Q = undefined;
	  /* scoped */
	  var __vue_scope_id__$1Q = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$1Q = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$1Q = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$1Q = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$1N, staticRenderFns: __vue_staticRenderFns__$1N },
	    __vue_inject_styles__$1Q,
	    __vue_script__$1P,
	    __vue_scope_id__$1Q,
	    __vue_is_functional_template__$1Q,
	    __vue_module_identifier__$1Q,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//

	function isReadByMe$5(message, userId) {
	  if (message.readByEveryone || message.ownerUserId === userId) {
	    return true;
	  }
	  return message.hasRead.find(function (x) { return x === userId; }) !== undefined;
	}

	function handlePreProcess$8(data) {
	  var self = this;

	  var userId = self.$root.loggedInUser.id;
	  data.isReadByMe = isReadByMe$5(data, userId);

	  return true;
	}

	var script$1Q = {
	  name: 'InstagramMessageList',
	  data: function data() {
	    var self = this;
	    var channelId = 'b4912358-0607-4436-9df6-9579655577ee';//self.$f7route.params.channelId;
	    var conversationId = self.$f7route.params.conversationId;

	    var store = new Store(self, {
	      get: ['instagrammessage', 'list', { streamId: channelId, conversationId: conversationId }],
	      postForm: ['instagrammessage', 'reply', { conversationId: conversationId, streamId: channelId }],
	      subscribe: ['instagrammessage', 'list', 'messages', { processLocally: false, subscriptionKey: conversationId }],
	      targetArrayName: 'messages',
	      preProcess: handlePreProcess$8,
	    });
	    var storeIsTyping = new Store(self, {
	      postNow: ['message', 'istyping', { channelId: channelId, contextId: conversationId, type: 'instagram' }],
	      subscribe: ['instagrammessage', 'istyping', null, { processLocally: true, subscriptionKey: conversationId }],
	      subscribeFinished: function (subscribeData) {
	        self.$refs.chat.showTyping(subscribeData);
	      },
	    });
	    return {
	      store: store,
	      storeIsTyping: storeIsTyping,
	      channelId: channelId,
	      conversationId: conversationId,
	    };
	  },
	};

	/* script */
	var __vue_script__$1Q = script$1Q;

	/* template */
	var __vue_render__$1O = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('channel-chat-page',{ref:"chat",attrs:{"navbarTitle":"Reply","navbarRoot":false,"type":"instagram","channel-id":_vm.channelId,"conversation-id":_vm.conversationId,"store":_vm.store,"storeIsTyping":_vm.storeIsTyping,"focus-on-load":false,"use-mentions":true,"use-saved-replies":true,"signature":true}})};
	var __vue_staticRenderFns__$1O = [];

	  /* style */
	  var __vue_inject_styles__$1R = undefined;
	  /* scoped */
	  var __vue_scope_id__$1R = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$1R = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$1R = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$1R = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$1O, staticRenderFns: __vue_staticRenderFns__$1O },
	    __vue_inject_styles__$1R,
	    __vue_script__$1Q,
	    __vue_scope_id__$1R,
	    __vue_is_functional_template__$1R,
	    __vue_module_identifier__$1R,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//

	var script$1R = {
	  name: 'InstagramChannelSettings',
	  data: function data() {
	    var self = this;
	    var channelId = self.$f7route.params.channelId;

	    var store = new Store(self, {
	      get: ['instagramchannel', 'settings', { id: channelId }],
	      post: ['instagramchannel', 'rename'],
	      sync: false,
	    });
	    var storeLeave = new Store(self, {
	      post: ['channel', 'leave', { id: channelId, channelType: 'instagram' }],
	    });
	    var storeDelete = new Store(self, {
	      post: ['channel', 'delete', { id: channelId, channelType: 'instagram' }],
	    });
	    var storeUpdateToken = new Store(self, {
	      post: ['instagramtoken', 'update', { id: channelId }],
	    });

	    store.get();

	    return {
	      store: store,
	      storeLeave: storeLeave,
	      storeDelete: storeDelete,
	      channelId: channelId,
	      storeUpdateToken: storeUpdateToken,
	      tokenUpdated: false,
	      tokenUpdateInProgress: false,
	    };
	  },
	  methods: {
	    updateToken: function updateToken() {
	      var self = this;

	      self.tokenUpdateInProgress = true;

	      instagramService.givePermission(function (token) {
	        instagramService.getPage(token, self.store.pageId, function (page) {
	          self.storeUpdateToken.post({ pageToken: page.access_token });
	          self.tokenUpdateInProgress = false;
	          self.tokenUpdated = true;
	        }, function (error) {
	          self.tokenUpdateInProgress = false;
	          Brief$1.notify('Failed to get Facebook page details', error);
	        });
	      }, function (error) {
	        self.tokenUpdateInProgress = false;
	        Brief$1.notify('Failed to login to Facebook', error);
	      });
	    },
	  },
	};

	/* script */
	var __vue_script__$1R = script$1R;

	/* template */
	var __vue_render__$1P = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('channel-settings-page',{attrs:{"type":"instagram","id":_vm.channelId,"name":_vm.store.name,"description":_vm.store.description,"isLoading":_vm.store.isLoading,"joinedUserCount":_vm.store.joinedUserCount,"isOwner":_vm.store.isOwner,"visibility":_vm.store.visibility,"longWaitingThreshold":_vm.store.longWaitingThreshold,"editWaitLimit":true,"editAutoReply":true,"editSignature":false,"editVisibility":true,"editInfo":true,"store":_vm.store,"storeLeave":_vm.storeLeave,"storeDelete":_vm.storeDelete,"handleStores":true}},[_c('template',{slot:"before-button"},[_c('f7-list',[_c('ul',[(!_vm.tokenUpdated)?_c('f7-list-button',{on:{"click":_vm.updateToken}},[_vm._v(_vm._s(_vm.tokenUpdateInProgress? 'Updating Instagram access...' : 'Update Instagram access')+" "),(_vm.tokenUpdateInProgress)?_c('span',{staticClass:"spinner"}):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.tokenUpdated)?_c('f7-block-footer',{staticClass:"padding"},[_vm._v("Instagram access updated")]):_vm._e()],1)])],1)],2)};
	var __vue_staticRenderFns__$1P = [];

	  /* style */
	  var __vue_inject_styles__$1S = undefined;
	  /* scoped */
	  var __vue_scope_id__$1S = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$1S = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$1S = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$1S = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$1P, staticRenderFns: __vue_staticRenderFns__$1P },
	    __vue_inject_styles__$1S,
	    __vue_script__$1R,
	    __vue_scope_id__$1S,
	    __vue_is_functional_template__$1S,
	    __vue_module_identifier__$1S,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//
	//
	//
	//
	//
	//

	var script$1S = {
	  name: 'InstagramChannelMembers',
	};

	/* script */
	var __vue_script__$1S = script$1S;

	/* template */
	var __vue_render__$1Q = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('channel-members-page',{attrs:{"id":_vm.$f7route.params.channelId,"type":"instagram"}})};
	var __vue_staticRenderFns__$1Q = [];

	  /* style */
	  var __vue_inject_styles__$1T = undefined;
	  /* scoped */
	  var __vue_scope_id__$1T = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$1T = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$1T = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$1T = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$1Q, staticRenderFns: __vue_staticRenderFns__$1Q },
	    __vue_inject_styles__$1T,
	    __vue_script__$1S,
	    __vue_scope_id__$1T,
	    __vue_is_functional_template__$1T,
	    __vue_module_identifier__$1T,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//
	//
	//
	//
	//
	//

	var script$1T = {
	  name: 'InstagramChannelNotifications',
	};

	/* script */
	var __vue_script__$1T = script$1T;

	/* template */
	var __vue_render__$1R = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('channel-notifications-page',{attrs:{"id":_vm.$f7route.params.channelId,"type":"instagram"}})};
	var __vue_staticRenderFns__$1R = [];

	  /* style */
	  var __vue_inject_styles__$1U = undefined;
	  /* scoped */
	  var __vue_scope_id__$1U = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$1U = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$1U = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$1U = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$1R, staticRenderFns: __vue_staticRenderFns__$1R },
	    __vue_inject_styles__$1U,
	    __vue_script__$1T,
	    __vue_scope_id__$1U,
	    __vue_is_functional_template__$1U,
	    __vue_module_identifier__$1U,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//
	//
	//
	//
	//
	//

	var script$1U = { name: 'InstagramChannelJoin' };

	/* script */
	var __vue_script__$1U = script$1U;

	/* template */
	var __vue_render__$1S = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('channel-join-page',{attrs:{"id":_vm.$f7route.params.channelId,"type":"instagram"}})};
	var __vue_staticRenderFns__$1S = [];

	  /* style */
	  var __vue_inject_styles__$1V = undefined;
	  /* scoped */
	  var __vue_scope_id__$1V = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$1V = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$1V = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$1V = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$1S, staticRenderFns: __vue_staticRenderFns__$1S },
	    __vue_inject_styles__$1V,
	    __vue_script__$1U,
	    __vue_scope_id__$1V,
	    __vue_is_functional_template__$1V,
	    __vue_module_identifier__$1V,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//
	//
	//
	//
	//
	//

	var script$1V = { name: 'InstagramChannelInvite' };

	/* script */
	var __vue_script__$1V = script$1V;

	/* template */
	var __vue_render__$1T = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('channel-invite-page',{attrs:{"id":_vm.$f7route.params.channelId,"type":"instagram"}})};
	var __vue_staticRenderFns__$1T = [];

	  /* style */
	  var __vue_inject_styles__$1W = undefined;
	  /* scoped */
	  var __vue_scope_id__$1W = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$1W = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$1W = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$1W = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$1T, staticRenderFns: __vue_staticRenderFns__$1T },
	    __vue_inject_styles__$1W,
	    __vue_script__$1V,
	    __vue_scope_id__$1W,
	    __vue_is_functional_template__$1W,
	    __vue_module_identifier__$1W,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//
	//
	//
	//
	//
	//
	//

	var script$1W = { name: 'InstagramConversationAssign' };

	/* script */
	var __vue_script__$1W = script$1W;

	/* template */
	var __vue_render__$1U = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('conversation-assign-page',{attrs:{"id":_vm.$f7route.params.channelId,"conversationId":_vm.$f7route.params.conversationId,"type":"instagram"}})};
	var __vue_staticRenderFns__$1U = [];

	  /* style */
	  var __vue_inject_styles__$1X = undefined;
	  /* scoped */
	  var __vue_scope_id__$1X = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$1X = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$1X = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$1X = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$1U, staticRenderFns: __vue_staticRenderFns__$1U },
	    __vue_inject_styles__$1X,
	    __vue_script__$1W,
	    __vue_scope_id__$1X,
	    __vue_is_functional_template__$1X,
	    __vue_module_identifier__$1X,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//
	//
	//
	//
	//
	//

	var script$1X = {
	  name: 'InstagramChannelInfo',
	};

	/* script */
	var __vue_script__$1X = script$1X;

	/* template */
	var __vue_render__$1V = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('channel-info-page',{attrs:{"id":_vm.$f7route.params.channelId,"type":"instagram"}})};
	var __vue_staticRenderFns__$1V = [];

	  /* style */
	  var __vue_inject_styles__$1Y = undefined;
	  /* scoped */
	  var __vue_scope_id__$1Y = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$1Y = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$1Y = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$1Y = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$1V, staticRenderFns: __vue_staticRenderFns__$1V },
	    __vue_inject_styles__$1Y,
	    __vue_script__$1X,
	    __vue_scope_id__$1Y,
	    __vue_is_functional_template__$1Y,
	    __vue_module_identifier__$1Y,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//
	//
	//
	//
	//
	//

	var script$1Y = {
	  name: 'InstagramChannelAutoReply',
	};

	/* script */
	var __vue_script__$1Y = script$1Y;

	/* template */
	var __vue_render__$1W = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('channel-autoreply-page',{attrs:{"id":_vm.$f7route.params.channelId,"type":"instagram"}})};
	var __vue_staticRenderFns__$1W = [];

	  /* style */
	  var __vue_inject_styles__$1Z = undefined;
	  /* scoped */
	  var __vue_scope_id__$1Z = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$1Z = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$1Z = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$1Z = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$1W, staticRenderFns: __vue_staticRenderFns__$1W },
	    __vue_inject_styles__$1Z,
	    __vue_script__$1Y,
	    __vue_scope_id__$1Z,
	    __vue_is_functional_template__$1Z,
	    __vue_module_identifier__$1Z,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//
	//
	//
	//
	//
	//

	var script$1Z = {
	  name: 'InstagramChannelWaitLimit',
	};

	/* script */
	var __vue_script__$1Z = script$1Z;

	/* template */
	var __vue_render__$1X = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('channel-waitlimit-page',{attrs:{"id":_vm.$f7route.params.channelId,"type":"instagram"}})};
	var __vue_staticRenderFns__$1X = [];

	  /* style */
	  var __vue_inject_styles__$1_ = undefined;
	  /* scoped */
	  var __vue_scope_id__$1_ = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$1_ = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$1_ = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$1_ = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$1X, staticRenderFns: __vue_staticRenderFns__$1X },
	    __vue_inject_styles__$1_,
	    __vue_script__$1Z,
	    __vue_scope_id__$1_,
	    __vue_is_functional_template__$1_,
	    __vue_module_identifier__$1_,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//
	//
	//
	//
	//
	//

	var script$1_ = {
	  name: 'InstagramChannelInstagram',
	};

	/* script */
	var __vue_script__$1_ = script$1_;

	/* template */
	var __vue_render__$1Y = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('channel-instagram-page',{attrs:{"id":_vm.$f7route.params.channelId,"type":"instagram"}})};
	var __vue_staticRenderFns__$1Y = [];

	  /* style */
	  var __vue_inject_styles__$20 = undefined;
	  /* scoped */
	  var __vue_scope_id__$20 = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$20 = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$20 = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$20 = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$1Y, staticRenderFns: __vue_staticRenderFns__$1Y },
	    __vue_inject_styles__$20,
	    __vue_script__$1_,
	    __vue_scope_id__$20,
	    __vue_is_functional_template__$20,
	    __vue_module_identifier__$20,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//

	var script$20 = {
	  name: 'RoomChannelCreate',
	  data: function data() {
	    var self = this;

	    var store = new Store(self, {
	      postNow: ['roomstream', 'create'],
	    });

	    gtag('event', 'room_add', {
	      event_category: 'page',
	      event_label: 'Add room channel',
	    });
	    return {
	      store: store,
	    };
	  },
	};

	/* script */
	var __vue_script__$20 = script$20;

	/* template */
	var __vue_render__$1Z = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('channel-create-page',{ref:"channelCreate",attrs:{"type":"room","store":_vm.store,"handleStores":true}})};
	var __vue_staticRenderFns__$1Z = [];

	  /* style */
	  var __vue_inject_styles__$21 = undefined;
	  /* scoped */
	  var __vue_scope_id__$21 = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$21 = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$21 = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$21 = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$1Z, staticRenderFns: __vue_staticRenderFns__$1Z },
	    __vue_inject_styles__$21,
	    __vue_script__$20,
	    __vue_scope_id__$21,
	    __vue_is_functional_template__$21,
	    __vue_module_identifier__$21,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//

	var script$21 = {
	  name: 'RoomChannelSettings',
	  data: function data() {
	    var self = this;
	    var id = self.$f7route.params.channelId;
	    var store = new Store(self, {
	      get: ['roomstream', 'settings', { id: id }],
	      post: ['roomstream', 'rename', { id: id }],
	      sync: false,
	    });

	    var storeLeave = new Store(self, {
	      post: ['channel', 'leave', { id: id, channelType: 'room' }],
	    });

	    var storeDelete = new Store(self, {
	      post: ['channel', 'delete', { id: id, channelType: 'room' }],
	    });

	    store.get();

	    return {
	      id: id,
	      store: store,
	      storeLeave: storeLeave,
	      storeDelete: storeDelete,
	    };
	  },
	};

	/* script */
	var __vue_script__$21 = script$21;

	/* template */
	var __vue_render__$1_ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('channel-settings-page',{attrs:{"type":"room","id":_vm.id,"isDirectMessagingChannel":!!_vm.store.peerUserId,"editWaitLimit":false,"editSignature":false,"store":_vm.store,"storeLeave":_vm.storeLeave,"storeDelete":_vm.storeDelete,"handleStores":true}})};
	var __vue_staticRenderFns__$1_ = [];

	  /* style */
	  var __vue_inject_styles__$22 = undefined;
	  /* scoped */
	  var __vue_scope_id__$22 = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$22 = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$22 = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$22 = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$1_, staticRenderFns: __vue_staticRenderFns__$1_ },
	    __vue_inject_styles__$22,
	    __vue_script__$21,
	    __vue_scope_id__$22,
	    __vue_is_functional_template__$22,
	    __vue_module_identifier__$22,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//
	//
	//
	//
	//
	//

	var script$22 = { name: 'RoomChannelInvite' };

	/* script */
	var __vue_script__$22 = script$22;

	/* template */
	var __vue_render__$20 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('channel-invite-page',{attrs:{"id":_vm.$f7route.params.channelId,"type":"room"}})};
	var __vue_staticRenderFns__$20 = [];

	  /* style */
	  var __vue_inject_styles__$23 = undefined;
	  /* scoped */
	  var __vue_scope_id__$23 = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$23 = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$23 = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$23 = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$20, staticRenderFns: __vue_staticRenderFns__$20 },
	    __vue_inject_styles__$23,
	    __vue_script__$22,
	    __vue_scope_id__$23,
	    __vue_is_functional_template__$23,
	    __vue_module_identifier__$23,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//
	//
	//
	//
	//
	//

	var script$23 = { name: 'RoomChannelJoin' };

	/* script */
	var __vue_script__$23 = script$23;

	/* template */
	var __vue_render__$21 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('channel-join-page',{attrs:{"id":_vm.$f7route.params.channelId,"type":"room"}})};
	var __vue_staticRenderFns__$21 = [];

	  /* style */
	  var __vue_inject_styles__$24 = undefined;
	  /* scoped */
	  var __vue_scope_id__$24 = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$24 = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$24 = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$24 = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$21, staticRenderFns: __vue_staticRenderFns__$21 },
	    __vue_inject_styles__$24,
	    __vue_script__$23,
	    __vue_scope_id__$24,
	    __vue_is_functional_template__$24,
	    __vue_module_identifier__$24,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//
	//
	//
	//
	//
	//

	var script$24 = {
	  name: 'RoomChannelMembers',
	};

	/* script */
	var __vue_script__$24 = script$24;

	/* template */
	var __vue_render__$22 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('channel-members-page',{attrs:{"id":_vm.$f7route.params.channelId,"type":"room"}})};
	var __vue_staticRenderFns__$22 = [];

	  /* style */
	  var __vue_inject_styles__$25 = undefined;
	  /* scoped */
	  var __vue_scope_id__$25 = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$25 = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$25 = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$25 = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$22, staticRenderFns: __vue_staticRenderFns__$22 },
	    __vue_inject_styles__$25,
	    __vue_script__$24,
	    __vue_scope_id__$25,
	    __vue_is_functional_template__$25,
	    __vue_module_identifier__$25,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//
	//
	//
	//
	//
	//

	var script$25 = {
	  name: 'RoomChannelNotifications',
	};

	/* script */
	var __vue_script__$25 = script$25;

	/* template */
	var __vue_render__$23 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('channel-notifications-page',{attrs:{"id":_vm.$f7route.params.channelId,"type":"room"}})};
	var __vue_staticRenderFns__$23 = [];

	  /* style */
	  var __vue_inject_styles__$26 = undefined;
	  /* scoped */
	  var __vue_scope_id__$26 = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$26 = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$26 = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$26 = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$23, staticRenderFns: __vue_staticRenderFns__$23 },
	    __vue_inject_styles__$26,
	    __vue_script__$25,
	    __vue_scope_id__$26,
	    __vue_is_functional_template__$26,
	    __vue_module_identifier__$26,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//
	//
	//
	//
	//
	//

	var script$26 = {
	  name: 'RoomChannelInfo',
	};

	/* script */
	var __vue_script__$26 = script$26;

	/* template */
	var __vue_render__$24 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('channel-info-page',{attrs:{"id":_vm.$f7route.params.channelId,"type":"room"}})};
	var __vue_staticRenderFns__$24 = [];

	  /* style */
	  var __vue_inject_styles__$27 = undefined;
	  /* scoped */
	  var __vue_scope_id__$27 = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$27 = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$27 = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$27 = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$24, staticRenderFns: __vue_staticRenderFns__$24 },
	    __vue_inject_styles__$27,
	    __vue_script__$26,
	    __vue_scope_id__$27,
	    __vue_is_functional_template__$27,
	    __vue_module_identifier__$27,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//

	function handlePreProcess$9(data) {
	  var self = this;

	  var userId = self.$root.loggedInUser.id;
	  data.isMyMessage = userId === data.userId;

	  return true;
	}

	function onUserListSubscribeFinished$1(response) {
	  if (!response) { return; }
	  var self = this;
	  var user = response.data || response;
	  if (user.userId !== self.store.chatUserId) { return; }
	  self.store.lastActive = user.lastActive;
	}

	var script$27 = {
	  name: 'RoomMessageList',
	  props: ['params'],
	  data: function data() {
	    var self = this;
	    var channelId = self.$f7route.params.channelId;
	    var store = new Store(self, {
	      get: ['roommessage', 'list', { streamId: channelId }],
	      postForm: ['roommessage', 'create', { streamId: channelId }],
	      subscribe: ['roommessage', 'list', 'messages', { subscriptionKey: channelId }],
	      preProcess: handlePreProcess$9,
	      targetArrayName: 'messages',
	      getFinished: function getFinished() {
	        self.isDirectMessagingChannel = store.peerUserId || store.participants;
	      },
	    });
	    var storeIsTyping = new Store(self, {
	      postNow: ['message', 'istyping', { channelId: channelId, contextId: channelId, type:'room' }],
	      subscribe: ['roommessage', 'istyping', null, { processLocally: true, subscriptionKey: channelId }],
	      subscribeFinished: function (data) {
	        self.$refs.chat.showTyping(data);
	      },
	    });
	    var storeDelete = new Store(self, {
	      post: ['roommessage', 'delete', {}],
	    });
	    var storeEdit = new Store(self, {
	      post: ['roommessage', 'edit', {}],
	    });

	    var storeUserLastActive = new Store(self, {
	      subscribe: ['user', 'list', 'users', {
	        processLocally: true,
	      }],
	      subscribeFinished: onUserListSubscribeFinished$1,
	    });

	    setInterval(function () {
	      if (!store.lastActive) {
	        return;
	      }
	      store.lastActive = new Date(new Date(store.lastActive).getTime() + 1000);
	    }, 60 * 1000);

	    return {
	      store: store,
	      storeIsTyping: storeIsTyping,
	      storeEdit: storeEdit,
	      storeDelete: storeDelete,
	      storeUserLastActive: storeUserLastActive,
	      channelId: channelId,
	      isDirectMessagingChannel: false,
	    };
	  },
	  mounted: function mounted() {
	    Brief$1.events.$on('topsearch', this.search);
	  },
	  beforeDestroy: function beforeDestroy() {
	    Brief$1.events.$off('topsearch', this.search);
	  },
	  methods: {
	    search: function search(query) {
	      this.store.get({ query: query });
	    },
	  },
	  computed: {
	    lastActiveString: function lastActiveString() {
	      var self = this;
	      if (!self.store.peerUserId || !self.store.chatUserId) {
	        return '';
	      }
	      if (!self.store.lastActive) {
	        return '';
	      }
	      var s = null;
	      var minsDiff = (new Date() - new Date(self.store.lastActive)) / 1000 / 60;
	      if (minsDiff < 2) {
	        s = 'Online';
	      } else {
	        s = 'Last seen ' + hooks$1(self.store.lastActive).locale('en').fromNow();
	      }
	      return s || '';
	    },
	  },
	};

	/* script */
	var __vue_script__$27 = script$27;

	/* template */
	var __vue_render__$25 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('channel-chat-page',{ref:"chat",attrs:{"navbarTitle":_vm.store.name,"navbarSubtitle":_vm.lastActiveString,"navbarTitleLink":("/room/" + _vm.channelId + "/settings/"),"navbarRoot":true,"type":"room","channel-id":_vm.channelId,"store":_vm.store,"storeIsTyping":_vm.storeIsTyping,"storeEdit":_vm.storeEdit,"storeDelete":_vm.storeDelete,"focus-on-load":true,"use-mentions":true,"use-saved-replies":true,"is-direct-messaging-channel":!!_vm.store.peerUserId}})};
	var __vue_staticRenderFns__$25 = [];

	  /* style */
	  var __vue_inject_styles__$28 = undefined;
	  /* scoped */
	  var __vue_scope_id__$28 = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$28 = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$28 = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$28 = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$25, staticRenderFns: __vue_staticRenderFns__$25 },
	    __vue_inject_styles__$28,
	    __vue_script__$27,
	    __vue_scope_id__$28,
	    __vue_is_functional_template__$28,
	    __vue_module_identifier__$28,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//

	var script$28 = {
	  name: 'WebsiteChannelCreate',
	  data: function data() {
	    var self = this;

	    var store = new Store(self, {
	      postNow: ['websitechannel', 'create'],
	    });
	    if (self.$root.loggedInUser) {
	      store.teamName = self.$root.loggedInUser.teamName || '';
	    }

	    gtag('event', 'website_add', {
	      event_category: 'page',
	      event_label: 'Add website channel',
	    });
	    return {
	      store: store,
	    };
	  },
	  computed: {
	    userTeamName: function userTeamName() {
	      var self = this;
	      if (!self.$root.loggedInUser || !self.$root.loggedInUser.teamName) {
	        return '';
	      }
	      if (!self.store.teamName) {
	        self.store.teamName = self.$root.loggedInUser.teamName || '';
	      }
	      return self.$root.loggedInUser.teamName;
	    },
	  },
	};

	/* script */
	var __vue_script__$28 = script$28;

	/* template */
	var __vue_render__$26 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('channel-create-page',{ref:"channelCreate",attrs:{"type":"website","store":_vm.store,"handleStores":true}},[_c('f7-block-title',[_vm._v("Team/Company name")]),_vm._v(" "),_c('f7-list',[_c('f7-list-item',{attrs:{"item-input":""}},[_c('input',{attrs:{"type":"hidden"},domProps:{"value":_vm.userTeamName}}),_vm._v(" "),_c('f7-input',{attrs:{"type":"text","placeholder":"Team/Company name","value":_vm.store.teamName},on:{"input":function($event){_vm.store.teamName = $event.target.value;}},nativeOn:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.$refs.channelCreate.createChannel()}}})],1)],1)],1)};
	var __vue_staticRenderFns__$26 = [];

	  /* style */
	  var __vue_inject_styles__$29 = undefined;
	  /* scoped */
	  var __vue_scope_id__$29 = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$29 = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$29 = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$29 = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$26, staticRenderFns: __vue_staticRenderFns__$26 },
	    __vue_inject_styles__$29,
	    __vue_script__$28,
	    __vue_scope_id__$29,
	    __vue_is_functional_template__$29,
	    __vue_module_identifier__$29,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//

	var script$29 = {
	  name: 'WebsiteChannelSettings',
	  data: function data() {
	    var self = this;
	    var id = self.$f7route.params.channelId;
	    var store = new Store(self, {
	      get: ['websitechannel', 'settings', { id: id }],
	      post: ['websitechannel', 'rename'],
	      sync: false,
	    });
	    store.get();

	    var storeLeave = new Store(self, {
	      post: ['channel', 'leave', { id: id, channelType: 'website' }],
	    });

	    var storeDelete = new Store(self, {
	      post: ['channel', 'delete', { id: id, channelType: 'website' }],
	    });
	    return {
	      id: id,
	      store: store,
	      storeLeave: storeLeave,
	      storeDelete: storeDelete,
	    };
	  },
	};

	/* script */
	var __vue_script__$29 = script$29;

	/* template */
	var __vue_render__$27 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('channel-settings-page',{attrs:{"type":"website","id":_vm.id,"name":_vm.store.name,"description":_vm.store.description,"isLoading":_vm.store.isLoading,"joinedUserCount":_vm.store.joinedUserCount,"isOwner":_vm.store.isOwner,"visibility":_vm.store.visibility,"longWaitingThreshold":_vm.store.longWaitingThreshold,"editWaitLimit":true,"editAutoReply":true,"editSignature":false,"editVisibility":true,"editInfo":true,"store":_vm.store,"storeLeave":_vm.storeLeave,"storeDelete":_vm.storeDelete,"handleStores":true}},[_c('f7-list',{attrs:{"media-list":""}},[_c('f7-list-item',{attrs:{"link":("/website/" + (_vm.$f7route.params.channelId) + "/officehours/"),"title":"Office hours","subtitle":!_vm.store.officeHours ? 'Open 24/7' : ''}})],1),_vm._v(" "),_c('f7-list',[_c('f7-list-item',{attrs:{"link":("/website/" + (_vm.$f7route.params.channelId) + "/widget/"),"title":"Widget settings"}})],1)],1)};
	var __vue_staticRenderFns__$27 = [];

	  /* style */
	  var __vue_inject_styles__$2a = undefined;
	  /* scoped */
	  var __vue_scope_id__$2a = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$2a = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$2a = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$2a = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$27, staticRenderFns: __vue_staticRenderFns__$27 },
	    __vue_inject_styles__$2a,
	    __vue_script__$29,
	    __vue_scope_id__$2a,
	    __vue_is_functional_template__$2a,
	    __vue_module_identifier__$2a,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//
	//
	//
	//
	//
	//

	var script$2a = { name: 'WebsiteChannelInvite' };

	/* script */
	var __vue_script__$2a = script$2a;

	/* template */
	var __vue_render__$28 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('channel-invite-page',{attrs:{"id":_vm.$f7route.params.channelId,"type":"website"}})};
	var __vue_staticRenderFns__$28 = [];

	  /* style */
	  var __vue_inject_styles__$2b = undefined;
	  /* scoped */
	  var __vue_scope_id__$2b = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$2b = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$2b = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$2b = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$28, staticRenderFns: __vue_staticRenderFns__$28 },
	    __vue_inject_styles__$2b,
	    __vue_script__$2a,
	    __vue_scope_id__$2b,
	    __vue_is_functional_template__$2b,
	    __vue_module_identifier__$2b,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//
	//
	//
	//
	//
	//
	//

	var script$2b = { name: 'WebsiteConversationAssign' };

	/* script */
	var __vue_script__$2b = script$2b;

	/* template */
	var __vue_render__$29 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('conversation-assign-page',{attrs:{"id":_vm.$f7route.params.channelId,"conversationId":_vm.$f7route.params.conversationId,"type":"website"}})};
	var __vue_staticRenderFns__$29 = [];

	  /* style */
	  var __vue_inject_styles__$2c = undefined;
	  /* scoped */
	  var __vue_scope_id__$2c = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$2c = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$2c = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$2c = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$29, staticRenderFns: __vue_staticRenderFns__$29 },
	    __vue_inject_styles__$2c,
	    __vue_script__$2b,
	    __vue_scope_id__$2c,
	    __vue_is_functional_template__$2c,
	    __vue_module_identifier__$2c,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//
	//
	//
	//
	//
	//

	var script$2c = { name: 'WebsiteChannelJoin' };

	/* script */
	var __vue_script__$2c = script$2c;

	/* template */
	var __vue_render__$2a = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('channel-join-page',{attrs:{"id":_vm.$f7route.params.channelId,"type":"website"}})};
	var __vue_staticRenderFns__$2a = [];

	  /* style */
	  var __vue_inject_styles__$2d = undefined;
	  /* scoped */
	  var __vue_scope_id__$2d = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$2d = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$2d = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$2d = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$2a, staticRenderFns: __vue_staticRenderFns__$2a },
	    __vue_inject_styles__$2d,
	    __vue_script__$2c,
	    __vue_scope_id__$2d,
	    __vue_is_functional_template__$2d,
	    __vue_module_identifier__$2d,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//
	//
	//
	//
	//
	//

	var script$2d = {
	  name: 'WebsiteChannelMembers',
	};

	/* script */
	var __vue_script__$2d = script$2d;

	/* template */
	var __vue_render__$2b = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('channel-members-page',{attrs:{"id":_vm.$f7route.params.channelId,"type":"website"}})};
	var __vue_staticRenderFns__$2b = [];

	  /* style */
	  var __vue_inject_styles__$2e = undefined;
	  /* scoped */
	  var __vue_scope_id__$2e = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$2e = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$2e = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$2e = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$2b, staticRenderFns: __vue_staticRenderFns__$2b },
	    __vue_inject_styles__$2e,
	    __vue_script__$2d,
	    __vue_scope_id__$2e,
	    __vue_is_functional_template__$2e,
	    __vue_module_identifier__$2e,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//
	//
	//
	//
	//
	//

	var script$2e = {
	  name: 'WebsiteChannelNotifications',
	};

	/* script */
	var __vue_script__$2e = script$2e;

	/* template */
	var __vue_render__$2c = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('channel-notifications-page',{attrs:{"id":_vm.$f7route.params.channelId,"type":"website"}})};
	var __vue_staticRenderFns__$2c = [];

	  /* style */
	  var __vue_inject_styles__$2f = undefined;
	  /* scoped */
	  var __vue_scope_id__$2f = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$2f = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$2f = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$2f = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$2c, staticRenderFns: __vue_staticRenderFns__$2c },
	    __vue_inject_styles__$2f,
	    __vue_script__$2e,
	    __vue_scope_id__$2f,
	    __vue_is_functional_template__$2f,
	    __vue_module_identifier__$2f,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//

	function isReadByMe$6(message, userId) {
	  return message.hasRead.find(function (x) { return x === userId; }) !== undefined;
	}
	function getPhotoUrl$2(message) {
	  if (!message.isAnsweredByUs) {
	    return message.fromOriginal.photoUrl;
	  }
	  var to = lodash.isArray(message.toOriginal) ? message.toOriginal[0] : message.toOriginal;
	  return to.photoUrl;
	}

	function processSubscriptionResponse$4(response) {
	  var self = this;
	  var userId = self.$root.loggedInUser.id;

	  var index = self.store.conversations
	    .findIndex(function (foundConversation) { return foundConversation.id === response.id; });

	  if (index <= -1) {
	    var conversation = {
	      id: response.id,
	      conversationId: response.conversationId,
	      from: response.from,
	      to: response.to,
	      text: response.text,
	      sendDate: response.sendDate,
	      isReadByMe: isReadByMe$6(response, userId),
	      isAnsweredByUs: response.isAnsweredByUs,
	      markedAsDone: response.markedAsDone,
	      markedAsNotDone: response.markedAsNotDone,
	      waitedLongTimeForAnswer: response.waitedLongTimeForAnswer,
	      isAssigned: response.isAssigned,
	      photoUrl: getPhotoUrl$2(response),
	      assignedUsers: response.assignedUsers
	    };

	    index = self.store.conversations
	      .findIndex(function (foundConversation) { return foundConversation.conversationId === response.conversationId; });

	    var q = self.query ? new RegExp(self.query, 'gim') : false;
	    var ms = response;
	    var canAdd = !q || (
	      q.test(ms.from.firstName) ||
	      q.test(ms.from.lastName) ||
	      q.test(ms.to.firstName) ||
	      q.test(ms.to.lastName) ||
	      q.test(ms.text) ||
	      q.test(ms.subject)
	    );
	    if (canAdd) {
	      if (index >= 0) {
	        self.$set(self.store.conversations, index, conversation);
	      } else {
	        var found = false;
	        for (var i = 0; i < self.store.conversations.length; i++) {
	          if (!self.store.conversations[i] || !self.store.conversations[i].sendDate) {
	            continue;
	          }
	          if (new Date(self.store.conversations[i].sendDate) < new Date(conversation.sendDate)) {
	            self.store.conversations.splice(i, 0, conversation);
	            found = true;
	            break;
	          }
	        }
	        if (!found && Utils$1.canAddConversation(self.store.conversations, conversation)) {
	          self.store.conversations.push(conversation);
	        }
	      }
	    }
	  } else {
	    var conversation$1 = Utils$1.extend(self.store.conversations[index], {
	      markedAsDone: response.markedAsDone,
	      markedAsNotDone: response.markedAsNotDone,
	      isReadByMe: isReadByMe$6(response, userId),
	      isAnsweredByUs: response.isAnsweredByUs,
	      waitedLongTimeForAnswer: response.waitedLongTimeForAnswer,
	      isAssigned: response.isAssigned,
	      assignedUsers: response.assignedUsers
	    });
	    self.$set(self.store.conversations, index, conversation$1);
	  }
	}

	var script$2f = {
	  name: 'WebsiteConversationList',
	  data: function data() {
	    var self = this;
	    var store = new Store(self, {
	      get: ['websiteconversation', 'list', { id: self.$f7route.params.channelId }],
	      subscribe: ['websiteconversation', 'list', 'conversations', { processLocally: true, subscriptionKey: self.$f7route.params.channelId }],
	      getLocalFinished: function getLocalFinished() {},
	      subscribeFinished: processSubscriptionResponse$4,
	      targetArrayName: 'conversations',
	    });
	    var storeMarkAsDone = new Store(self, {
	      postNow: ['websiteconversation', 'done'],
	    });
	    var storeMarkAsNotDone = new Store(self, {
	      postNow: ['websiteconversation', 'notdone'],
	    });
	    var batchStoreMarkAsDone = new Store(self, {
	      post: ['websiteconversations', 'alldone'],
	    });
	    var batchStoreMarkAsRead = new Store(self, {
	      post: ['websiteconversations', 'allread'],
	    });
	    return {
	      store: store,
	      storeMarkAsDone: storeMarkAsDone,
	      storeMarkAsNotDone: storeMarkAsNotDone,
	      batchStoreMarkAsRead: batchStoreMarkAsRead,
	      batchStoreMarkAsDone: batchStoreMarkAsDone,
	      firstTimeLoad: true,
	      messagesLoaded: false,
	      query: null,
	      hashTagSearch: false,
	      online: store.online,
	      getStarted: false,
	      getFinished: false,
	      searchbarPreloader: false,
	    };
	  },
	  computed: {
	    showSearch: function showSearch() {
	      var self = this;
	      return !!(self.store.installed && (self.store.conversations.length || self.$refs.commonConversation.query));
	    },
	    showInstalled: function showInstalled() {
	      var self = this;
	      var query = self.$refs.commonConversation && self.$refs.commonConversation.query;
	      if (self.store.isLoading) { return false; }
	      if (query && query.trim()) { return false; }
	      if (!Utils$1.isUndefined(self.store.conversations) && self.store.conversations.length > 0) { return false; }
	      if (self.store.installed) { return true; }
	      return false;
	    },
	    embedCode: function embedCode() {
	      return widgetEmbedCode$1(this.store.widgetId);
	    },
	  },
	};

	/* script */
	var __vue_script__$2f = script$2f;

	/* template */
	var __vue_render__$2d = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('channel-conversation-page',{ref:"commonConversation",attrs:{"type":"website","introduction":!_vm.store.installed,"store":_vm.store,"storeMarkAsDone":_vm.storeMarkAsDone,"storeMarkAsNotDone":_vm.storeMarkAsNotDone,"batchStoreMarkAsDone":_vm.batchStoreMarkAsDone,"batchStoreMarkAsRead":_vm.batchStoreMarkAsRead,"photoAvatar":false,"sortConversationsByDate":true,"handleStores":true,"itemHeight":_vm.$theme.ios ? 76 : 70,"search":_vm.showSearch}},[_c('template',{slot:"introduction"},[_c('p',[_vm._v("Hi! We have prepared a chat widget for you. Just paste following widget embed code on your website and soon visitors will be able to chat with your team:")]),_vm._v(" "),_c('p',[_c('pre',{staticClass:"widget-embed-code"},[_vm._v(_vm._s(_vm.embedCode))])])]),_vm._v(" "),(_vm.showInstalled)?_c('div',{staticClass:"brief-card content-center content-round",attrs:{"slot":"after-introduction"},slot:"after-introduction"},[_c('div',{staticClass:"brief-card-header"},[_c('common-avatar',{attrs:{"avatar":{ filename: 'avatar.png' }}}),_vm._v(" "),_c('div',{staticClass:"brief-card-name"},[_vm._v("Brief Bot")]),_vm._v(" "),_c('div',{staticClass:"brief-card-date"},[_vm._v(" ")])],1),_vm._v(" "),_c('div',{staticClass:"brief-card-content"},[_c('p',[_vm._v("Great! Widget is now installed on your website.")]),_vm._v(" "),_c('p',[_vm._v("While waiting for questions from visitors to arrive, lets give them a friendly welcome message and also let them know your office hours")]),_vm._v(" "),_c('p',[_vm._v("Go to "),_c('f7-link',{attrs:{"href":("/website/" + (_vm.$f7route.params.channelId) + "/settings/")}},[_vm._v("channel settings")]),_vm._v(" page where you can find all the options for your widget.")],1)])]):_vm._e()],2)};
	var __vue_staticRenderFns__$2d = [];

	  /* style */
	  var __vue_inject_styles__$2g = undefined;
	  /* scoped */
	  var __vue_scope_id__$2g = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$2g = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$2g = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$2g = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$2d, staticRenderFns: __vue_staticRenderFns__$2d },
	    __vue_inject_styles__$2g,
	    __vue_script__$2f,
	    __vue_scope_id__$2g,
	    __vue_is_functional_template__$2g,
	    __vue_module_identifier__$2g,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//

	function getPhotoUrl$3(message) {
	  if (!message.isAnsweredByUs) {
	    return message.from.photoUrl;
	  }
	  var to = _.isArray(message.to) ? message.to[0] : message.to;
	  return to.photoUrl;
	}
	function processSubscriptionResponse$5(response) {
	  var self = this;
	  var index = self.store.messages.findIndex(function (message) { return message.id === response.id; });
	  if (response.deleteThis && index >= 0) {
	    self.store.messages.splice(index, 1);
	    return;
	  }
	  if (response.conversationId === self.$f7route.params.conversationId) {
	    var message = {
	      id: response.id,
	      isOurMessage: response.isOurMessage,
	      fullName: response.fullName,
	      text: response.text,
	      files: response.files,
	      sendDate: response.sendDate,
	      userId: response.from ? response.from.id : null,
	      url: response.url,
	      photoUrl: response.from ? getPhotoUrl$3(response) : null,
	      contactType: 'website',
	      isSystemMessage: response.isSystemMessage,
	    };

	    if (index <= -1) {
	      self.store.messages.push(message);
	    } else {
	      self.$set(self.store.messages, index, message);
	    }
	    self.$nextTick(function () {
	      Brief$1.events.$emit('files-updated');
	    });
	  }
	}

	var script$2g = {
	  name: 'WebsiteMessageList',
	  props: ['params'],
	  data: function data() {
	    var self = this;
	    var channelId = self.$f7route.params.channelId;
	    var conversationId = self.$f7route.params.conversationId;

	    var store = new Store(self, {
	      get: ['websitemessage', 'list', { channelId: channelId, conversationId: conversationId }],
	      postForm: ['websitemessage', 'reply', { channelId: channelId, conversationId: conversationId }],
	      // subscribe: ['websitemessage', 'list', 'messages', { processLocally: true, subscriptionKey: conversationId }],
	      subscribeFinished: processSubscriptionResponse$5,
	    });
	    var storeIsTyping = new Store(self, {
	      postNow: ['websitemessage', 'istyping', { channelId: channelId, conversationId: conversationId }],
	      // subscribe: ['websitemessage', 'istyping', null, { processLocally: true, subscriptionKey: conversationId }],
	      subscribeFinished: function (data) {
	        self.$refs.chat.showTyping(data);
	      },
	    });
	    var storeEdit = new Store(self, {
	      post: ['websitemessage', 'edit', {}],
	    });
	    var storeDelete = new Store(self, {
	      post: ['websitemessage', 'delete', {}],
	    });
	    return {
	      store: store,
	      storeIsTyping: storeIsTyping,
	      storeEdit: storeEdit,
	      storeDelete: storeDelete,
	      channelId: channelId,
	      conversationId: conversationId,
	      getLocalFinished: false,
	    };
	  },
	  computed: {
	    showPreviousLink: function showPreviousLink() {
	      return this.store.previousConversationId && this.store.noMoreToGet || this.store.previousConversationId && this.getLocalFinished;
	    },
	    showNextLink: function showNextLink() {
	      return !!this.store.subsequentConversationId;
	    },
	  },
	};

	/* script */
	var __vue_script__$2g = script$2g;

	/* template */
	var __vue_render__$2e = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('channel-chat-page',{ref:"chat",attrs:{"navbarTitle":"Reply","navbarRoot":false,"type":"website","channel-id":_vm.channelId,"conversation-id":_vm.conversationId,"store":_vm.store,"storeIsTyping":_vm.storeIsTyping,"storeEdit":_vm.storeEdit,"storeDelete":_vm.storeDelete,"show-previous-link":_vm.showPreviousLink,"show-next-link":_vm.showNextLink,"focus-on-load":false,"use-mentions":true,"use-saved-replies":true}})};
	var __vue_staticRenderFns__$2e = [];

	  /* style */
	  var __vue_inject_styles__$2h = undefined;
	  /* scoped */
	  var __vue_scope_id__$2h = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$2h = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$2h = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$2h = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$2e, staticRenderFns: __vue_staticRenderFns__$2e },
	    __vue_inject_styles__$2h,
	    __vue_script__$2g,
	    __vue_scope_id__$2h,
	    __vue_is_functional_template__$2h,
	    __vue_module_identifier__$2h,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//
	//
	//
	//
	//
	//
	//

	var script$2h = {
	  name: 'WebsiteChannelInfo',
	};

	/* script */
	var __vue_script__$2h = script$2h;

	/* template */
	var __vue_render__$2f = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('channel-info-page',{attrs:{"id":_vm.$f7route.params.channelId,"type":"website","editTeamName":true}})};
	var __vue_staticRenderFns__$2f = [];

	  /* style */
	  var __vue_inject_styles__$2i = undefined;
	  /* scoped */
	  var __vue_scope_id__$2i = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$2i = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$2i = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$2i = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$2f, staticRenderFns: __vue_staticRenderFns__$2f },
	    __vue_inject_styles__$2i,
	    __vue_script__$2h,
	    __vue_scope_id__$2i,
	    __vue_is_functional_template__$2i,
	    __vue_module_identifier__$2i,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//
	//
	//
	//
	//
	//

	var script$2i = {
	  name: 'WebsiteChannelAutoReply',
	};

	/* script */
	var __vue_script__$2i = script$2i;

	/* template */
	var __vue_render__$2g = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('channel-autoreply-page',{attrs:{"id":_vm.$f7route.params.channelId,"type":"website"}})};
	var __vue_staticRenderFns__$2g = [];

	  /* style */
	  var __vue_inject_styles__$2j = undefined;
	  /* scoped */
	  var __vue_scope_id__$2j = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$2j = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$2j = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$2j = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$2g, staticRenderFns: __vue_staticRenderFns__$2g },
	    __vue_inject_styles__$2j,
	    __vue_script__$2i,
	    __vue_scope_id__$2j,
	    __vue_is_functional_template__$2j,
	    __vue_module_identifier__$2j,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//
	//
	//
	//
	//
	//

	var script$2j = {
	  name: 'WebsiteChannelWaitLimit',
	};

	/* script */
	var __vue_script__$2j = script$2j;

	/* template */
	var __vue_render__$2h = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('channel-waitlimit-page',{attrs:{"id":_vm.$f7route.params.channelId,"type":"website"}})};
	var __vue_staticRenderFns__$2h = [];

	  /* style */
	  var __vue_inject_styles__$2k = undefined;
	  /* scoped */
	  var __vue_scope_id__$2k = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$2k = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$2k = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$2k = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$2h, staticRenderFns: __vue_staticRenderFns__$2h },
	    __vue_inject_styles__$2k,
	    __vue_script__$2j,
	    __vue_scope_id__$2k,
	    __vue_is_functional_template__$2k,
	    __vue_module_identifier__$2k,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//
	//
	//
	//
	//
	//

	var script$2k = {
	  name: 'WebsiteChannelOfficeHours',
	};

	/* script */
	var __vue_script__$2k = script$2k;

	/* template */
	var __vue_render__$2i = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('channel-officehours-page',{attrs:{"id":_vm.$f7route.params.channelId,"type":"website"}})};
	var __vue_staticRenderFns__$2i = [];

	  /* style */
	  var __vue_inject_styles__$2l = undefined;
	  /* scoped */
	  var __vue_scope_id__$2l = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$2l = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$2l = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$2l = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$2i, staticRenderFns: __vue_staticRenderFns__$2i },
	    __vue_inject_styles__$2l,
	    __vue_script__$2k,
	    __vue_scope_id__$2l,
	    __vue_is_functional_template__$2l,
	    __vue_module_identifier__$2l,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//
	//
	//
	//
	//
	//

	var script$2l = {
	  name: 'WebsiteChannelWidget',
	};

	/* script */
	var __vue_script__$2l = script$2l;

	/* template */
	var __vue_render__$2j = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('channel-widget-page',{attrs:{"id":_vm.$f7route.params.channelId,"type":"website"}})};
	var __vue_staticRenderFns__$2j = [];

	  /* style */
	  var __vue_inject_styles__$2m = undefined;
	  /* scoped */
	  var __vue_scope_id__$2m = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$2m = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$2m = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$2m = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$2j, staticRenderFns: __vue_staticRenderFns__$2j },
	    __vue_inject_styles__$2m,
	    __vue_script__$2l,
	    __vue_scope_id__$2m,
	    __vue_is_functional_template__$2m,
	    __vue_module_identifier__$2m,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//

	var script$2m = {
	  data: function data() {
	    var self = this;
	    var channelId = self.$f7route.params.channelId;

	    var storeSavedReplies = new Store(self, {
	      get: ['savedreply', 'list', { channelId: channelId }],
	    });

	    storeSavedReplies.get({ take: 500 });

	    return {
	      channelId: channelId,
	      storeSavedReplies: storeSavedReplies,
	    };
	  },
	  computed: {
	    channelReplies: function channelReplies() {
	      var self = this;
	      if (!self.storeSavedReplies.replies) { return []; }
	      return self.storeSavedReplies.replies.filter(function (reply) { return reply.scope === 'CHANNEL' && reply.channelId === self.channelId; });
	    },
	    teamReplies: function teamReplies() {
	      var self = this;
	      if (!self.storeSavedReplies.replies) { return []; }
	      return self.storeSavedReplies.replies.filter(function (reply) { return reply.scope === 'TEAM'; });
	    },
	  },
	  methods: {
	    onPageBeforeIn: function onPageBeforeIn(e, page) {
	      var self = this;
	      if (page && page.direction === 'backward') {
	        self.storeSavedReplies.get({ take: 500 });
	      }
	    },
	  },
	};

	/* script */
	var __vue_script__$2m = script$2m;

	/* template */
	var __vue_render__$2k = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f7-page',{staticClass:"page-form",on:{"page:beforein":_vm.onPageBeforeIn}},[_c('common-navbar',{attrs:{"title":"Saved Replies"}},[_c('f7-link',{attrs:{"slot":"nav-right","href":("/replies/add/" + _vm.channelId + "/")},slot:"nav-right"},[_vm._v("New reply")])],1),_vm._v(" "),(_vm.channelReplies.length)?_c('f7-block-title',[_vm._v("Channel Replies")]):_vm._e(),_vm._v(" "),(_vm.channelReplies.length)?_c('f7-list',_vm._l((_vm.channelReplies),function(reply){return _c('f7-list-item',{attrs:{"title":reply.title,"link":("/replies/edit/" + (reply.id) + "/" + (reply.channelId) + "/")}})}),1):_vm._e(),_vm._v(" "),(_vm.teamReplies.length)?_c('f7-block-title',[_vm._v("Common Replies")]):_vm._e(),_vm._v(" "),(_vm.teamReplies.length)?_c('f7-list',_vm._l((_vm.teamReplies),function(reply){return _c('f7-list-item',{attrs:{"title":reply.title,"link":("/replies/edit/" + (reply.id) + "/" + (reply.channelId ? ((reply.channelId) + "/") : ''))}})}),1):_vm._e()],1)};
	var __vue_staticRenderFns__$2k = [];

	  /* style */
	  var __vue_inject_styles__$2n = undefined;
	  /* scoped */
	  var __vue_scope_id__$2n = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$2n = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$2n = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$2n = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$2k, staticRenderFns: __vue_staticRenderFns__$2k },
	    __vue_inject_styles__$2n,
	    __vue_script__$2m,
	    __vue_scope_id__$2n,
	    __vue_is_functional_template__$2n,
	    __vue_module_identifier__$2n,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//

	var script$2n = {
	  data: function data() {
	    var self = this;
	    var channelId = self.$f7route.params.channelId;

	    var storeSavedReplies = new Store(self, {
	      post: ['savedreply', 'create'],
	      postFinished: function postFinished(response) {
	        self.saveInProgress = false;
	        
	        if (!response.success && response.data.Message) {
	          Brief$1.notify('Error!', response.data.Message);
	          return;
	        }

	        Brief$1.events.$emit('template-created');
	        Brief$1.f7.popup.close();
	      },
	    });

	    return {
	      channelId: channelId,
	      store: storeSavedReplies,
	      title: '',
	      text: '',
	      scope: 'TEAM',
	      saveInProgress: false,
	    };
	  },
	  methods: {
	    save: function save() {
	      var self = this;
	      self.saveInProgress = true;
	      self.store.title = self.title;
	      self.store.text = self.text;
	      var postData = {
	        title: self.title,
	        text: self.text,
	        scope: self.scope,
	      };
	      if (postData.scope === 'CHANNEL') {
	        postData.channelId = self.channelId;
	      }
	      self.store.post(postData);
	      return false;
	    },
	  },
	};

	/* script */
	var __vue_script__$2n = script$2n;

	/* template */
	var __vue_render__$2l = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f7-page',{staticClass:"page-form"},[_c('f7-navbar',[_c('f7-nav-left',[_c('common-nav-placeholder')],1),_vm._v(" "),_c('f7-nav-title',[_vm._v("\n      New Template\n    ")]),_vm._v(" "),_c('f7-nav-right',[_c('f7-link',{attrs:{"popup-close":""}},[_c('f7-icon',{attrs:{"material":"close","size":"30"}})],1)],1)],1),_vm._v(" "),_c('f7-list',{attrs:{"inset":""}},[_c('f7-list-item',{attrs:{"item-input":""}},[_c('f7-input',{attrs:{"type":"text","placeholder":"Template Name","value":_vm.title},on:{"input":function($event){_vm.title = $event.target.value;}},nativeOn:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.save.apply(null, arguments)}}})],1),_vm._v(" "),_c('f7-list-item',{attrs:{"item-input":""}},[_c('f7-input',{staticClass:"large-area",attrs:{"type":"textarea","placeholder":"Message Text","value":_vm.text},on:{"input":function($event){_vm.text = $event.target.value;}}})],1)],1),_vm._v(" "),(_vm.channelId)?_c('f7-list',{attrs:{"inset":""}},[_c('f7-list-item',{attrs:{"radio":"","value":"TEAM","checked":_vm.scope === 'TEAM',"title":"For every channel"},on:{"change":function($event){_vm.scope = 'TEAM';}}}),_vm._v(" "),_c('f7-list-item',{attrs:{"radio":"","value":"CHANNEL","checked":_vm.scope === 'CHANNEL',"title":"Only for this channel"},on:{"change":function($event){_vm.scope = 'CHANNEL';}}})],1):_vm._e(),_vm._v(" "),_c('f7-list',{attrs:{"inset":""}},[_c('f7-list-button',{on:{"click":_vm.save}},[(!_vm.saveInProgress)?_c('span',[_vm._v("Create")]):_vm._e(),_vm._v(" "),(_vm.saveInProgress)?_c('f7-preloader'):_vm._e()],1)],1)],1)};
	var __vue_staticRenderFns__$2l = [];

	  /* style */
	  var __vue_inject_styles__$2o = undefined;
	  /* scoped */
	  var __vue_scope_id__$2o = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$2o = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$2o = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$2o = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$2l, staticRenderFns: __vue_staticRenderFns__$2l },
	    __vue_inject_styles__$2o,
	    __vue_script__$2n,
	    __vue_scope_id__$2o,
	    __vue_is_functional_template__$2o,
	    __vue_module_identifier__$2o,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//

	var script$2o = {
	  data: function data() {
	    var self = this;
	    var channelId = self.$f7route.params.channelId;
	    var replyId = self.$f7route.params.id;

	    var storeSavedReplies = new Store(self, {
	      get: ['savedreply', 'list', { id: replyId }],
	      getFinished: function getFinished() {
	        if (!storeSavedReplies.replies.length) { return; }
	        var reply = storeSavedReplies.replies[0];
	        self.title = reply.title;
	        self.text = reply.text;
	        self.scope = reply.scope;
	        self.type = reply.type;
	      },
	    });

	    var storeSavedReplyEdit = new Store(self, {
	      post: ['savedreply', 'edit'],
	      postFinished: function postFinished(response) {
	        self.saveInProgress = false;

	        if (!response.success && response.data.Message) {
	          Brief$1.notify('Error!', response.data.Message);
	          return;
	        }

	        Brief$1.events.$emit('template-edited');
	        Brief$1.f7.popup.close();
	      },
	    });

	    var storeSavedReplyCreate = new Store(self, {
	      post: ['savedreply', 'create'],
	      postFinished: function postFinished(response) {
	        self.saveInProgress = false;

	        if (!response.success && response.data.Message) {
	          Brief$1.notify('Error!', response.data.Message);
	          return;
	        }

	        Brief$1.events.$emit('template-created');
	        Brief$1.f7.popup.close();
	      },
	    });

	    var storeSavedReplyDelete = new Store(self, {
	      post: ['savedreply', 'delete'],
	      postFinished: function postFinished(response) {
	        self.deleteInProgress = false;

	        if (!response.success && response.data.Message) {
	          Brief$1.notify('Error!', response.data.Message);
	          return;
	        }

	        Brief$1.events.$emit('template-deleted');
	        Brief$1.f7.popup.close();
	      },
	    });

	    storeSavedReplies.get();

	    return {
	      replyId: replyId,
	      channelId: channelId,
	      storeSavedReplyEdit: storeSavedReplyEdit,
	      storeSavedReplyCreate: storeSavedReplyCreate,
	      storeSavedReplyDelete: storeSavedReplyDelete,
	      title: '',
	      text: '',
	      scope: 'TEAM',
	      type: null,
	      saveInProgress: false,
	      deleteInProgress: false,
	    };
	  },
	  methods: {
	    save: function save() {
	      var self = this;

	      self.saveInProgress = true;

	      var postData = {
	        title: self.title,
	        text: self.text,
	        scope: self.scope,
	      };

	      if (postData.scope === 'CHANNEL')
	        { postData.channelId = self.channelId; }
	      
	      if (self.type === 'DEFAULT') {
	        self.storeSavedReplyCreate.post(postData);
	      } else {
	        postData.id = self.replyId;
	        self.storeSavedReplyEdit.post(postData);
	      }

	      return false;
	    },
	    deleteReply: function deleteReply() {
	      var self = this;
	      self.deleteInProgress = true;
	      self.storeSavedReplyDelete.post({
	        id: self.replyId,
	      });
	    },
	  },
	};

	/* script */
	var __vue_script__$2o = script$2o;

	/* template */
	var __vue_render__$2m = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f7-page',{staticClass:"page-form"},[_c('f7-navbar',[_c('f7-nav-left',[_c('common-nav-placeholder')],1),_vm._v(" "),_c('f7-nav-title',[_vm._v("\n      Edit Template\n    ")]),_vm._v(" "),_c('f7-nav-right',[_c('f7-link',{attrs:{"popup-close":""}},[_c('f7-icon',{attrs:{"material":"close","size":"30"}})],1)],1)],1),_vm._v(" "),[_c('f7-list',{attrs:{"inset":""}},[_c('f7-list-item',{attrs:{"item-input":""}},[_c('f7-input',{attrs:{"type":"text","placeholder":"Template Name","value":_vm.title},on:{"input":function($event){_vm.title = $event.target.value;}},nativeOn:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.save.apply(null, arguments)}}})],1),_vm._v(" "),_c('f7-list-item',{attrs:{"item-input":""}},[_c('f7-input',{staticClass:"large-area",attrs:{"type":"textarea","placeholder":"Message text","value":_vm.text},on:{"input":function($event){_vm.text = $event.target.value;}}})],1)],1),_vm._v(" "),(_vm.channelId)?_c('f7-list',{attrs:{"inset":""}},[_c('f7-list-item',{attrs:{"radio":"","value":"TEAM","checked":_vm.scope === 'TEAM',"title":"For every channel"},on:{"change":function($event){_vm.scope = 'TEAM';}}}),_vm._v(" "),_c('f7-list-item',{attrs:{"radio":"","value":"CHANNEL","checked":_vm.scope === 'CHANNEL',"title":"Only for this channel"},on:{"change":function($event){_vm.scope = 'CHANNEL';}}})],1):_vm._e(),_vm._v(" "),_c('f7-list',{attrs:{"inset":""}},[_c('f7-list-button',{on:{"click":_vm.save}},[(!_vm.saveInProgress)?_c('span',[_vm._v("Save")]):_vm._e(),_vm._v(" "),(_vm.saveInProgress)?_c('f7-preloader'):_vm._e()],1)],1),_vm._v(" "),(!_vm.type)?_c('f7-list',{attrs:{"inset":""}},[_c('f7-list-button',{attrs:{"color":"red"},on:{"click":_vm.deleteReply}},[(!_vm.deleteInProgress)?_c('span',[_vm._v("Delete")]):_vm._e(),_vm._v(" "),(_vm.deleteInProgress)?_c('f7-preloader'):_vm._e()],1)],1):_vm._e()]],2)};
	var __vue_staticRenderFns__$2m = [];

	  /* style */
	  var __vue_inject_styles__$2p = undefined;
	  /* scoped */
	  var __vue_scope_id__$2p = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$2p = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$2p = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$2p = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$2m, staticRenderFns: __vue_staticRenderFns__$2m },
	    __vue_inject_styles__$2p,
	    __vue_script__$2o,
	    __vue_scope_id__$2p,
	    __vue_is_functional_template__$2p,
	    __vue_module_identifier__$2p,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//
	//
	//
	//
	//
	//
	//

	var script$2p = {
	  name: 'ContentNotFound',
	};

	/* script */
	var __vue_script__$2p = script$2p;

	/* template */
	var __vue_render__$2n = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f7-page',{staticClass:"content-not-found-page"},[_c('f7-block',[_c('h1',[_vm._v("Content not found")])])],1)};
	var __vue_staticRenderFns__$2n = [];

	  /* style */
	  var __vue_inject_styles__$2q = undefined;
	  /* scoped */
	  var __vue_scope_id__$2q = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$2q = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$2q = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$2q = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$2n, staticRenderFns: __vue_staticRenderFns__$2n },
	    __vue_inject_styles__$2q,
	    __vue_script__$2p,
	    __vue_scope_id__$2q,
	    __vue_is_functional_template__$2q,
	    __vue_module_identifier__$2q,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//

	var script$2q = {
	  name: 'ConversationList',
	  data: function data() {
	    var self = this;
	    var loggedInUser = this.$root.loggedInUser;      

	    var storeAssigned = new Store(self, {
	      get: ['conversation', 'list', { isHandled: false, isAssigned: true }],
	      subscribe: [
	        ['conversation', 'listassigned', 'conversations'],
	        ['conversation', 'listassignedemail', 'conversations'], // TEMPORARY - Remove when one table
	        ['conversation', 'listassignedwebsite', 'conversations'], // TEMPORARY - Remove when one table
	        ['conversation', 'listassignedfacebook', 'conversations'], // TEMPORARY - Remove when one table
	        ['conversation', 'listassignedinstagram', 'conversations'] ],
	      preProcess: handlePreProcess$a
	    });

	    var storeWaiting = new Store(self, {
	      get: ['conversation', 'list', { isHandled: false }],
	      subscribe: [
	        ['conversation', 'listwaiting', 'conversations'],
	        ['conversation', 'listwaitingemail', 'conversations'], // TEMPORARY - Remove when one table
	        ['conversation', 'listwaitingwebsite', 'conversations'], // TEMPORARY - Remove when one table
	        ['conversation', 'listwaitingfacebook', 'conversations'], // TEMPORARY - Remove when one table
	        ['conversation', 'listwaitinginstagram', 'conversations'] ],
	    });

	    var storeHandled = new Store(self, {
	      get: ['conversation', 'list', { isHandled: true }],
	      subscribe: [
	        ['conversation', 'listhandled', 'conversations'],
	        ['conversation', 'listhandledemail', 'conversations'], // TEMPORARY - Remove when one table
	        ['conversation', 'listhandledwebsite', 'conversations'], // TEMPORARY - Remove when one table
	        ['conversation', 'listhandledfacebook', 'conversations'], // TEMPORARY - Remove when one table
	        ['conversation', 'listhandledinstagram', 'conversations'] ],
	    });

	    var storeIsHandled = new Store(self, {
	      postNow: ['conversation', 'ishandled'],
	      postNowFinished: function postNowFinished() {
	        Brief$1.events.$emit('sync');
	      }
	    });

	    var storeSearch = new Store(self, {
	      get: ['conversation', 'search'],
	      getFinished: function () {
	        self.showSearchbarNotFound = self.storeSearch.conversations.length === 0;
	      }
	    });

	    return {
	      loggedInUser: loggedInUser,
	      storeAssigned: storeAssigned,
	      storeWaiting: storeWaiting,
	      storeHandled: storeHandled,
	      storeIsHandled: storeIsHandled,
	      storeSearch: storeSearch,
	      isBigScreen: Brief$1.isBigScreen,
	      isCordova: Brief$1.isCordova,
	      searchbarEnabled: false,
	      showSearchbarNotFound: false,
	      searchQuery: '',
	      oldConversationHourOffset: 6
	    };
	  },
	  mounted: function mounted() {
	    var self = this;

	    Brief$1.events.$on('message-created', self.handleCreated);

	    self.storeAssigned.get();
	    self.storeWaiting.get();
	    self.storeHandled.get();
	  },
	  computed: {
	    onboardingFinished: function onboardingFinished() {
	      var self = this;
	      return self.loggedInUser && 
	        self.loggedInUser.onboarding && 
	        self.loggedInUser.onboarding.setupBusiness &&
	        self.loggedInUser.onboarding.setupSms;
	    },
	    showIntroductionWaiting: function showIntroductionWaiting() {
	      var self = this;
	      if (self.storeAssigned.isLoading) { return false; }
	      if (self.storeWaiting.isLoading) { return false; }
	      if (Utils$1.isUndefined(self.storeAssigned.conversations)) { return false; }
	      if (Utils$1.isUndefined(self.storeWaiting.conversations)) { return false; }
	      if (self.storeAssigned.conversations.length > 0) { return false; }
	      if (self.storeWaiting.conversations.length > 0) { return false; }
	      return true;
	    },
	    showIntroductionHandled: function showIntroductionHandled() {
	      var self = this;
	      if (self.storeHandled.isLoading) { return false; }
	      if (Utils$1.isUndefined(self.storeHandled.conversations)) { return false; }
	      if (self.storeHandled.conversations.length > 0) { return false; }
	      return true;
	    },
	    assignedConversations: function assignedConversations() {
	      var self = this;
	      if (!self.storeAssigned.conversations) 
	        { return []; }
	      return self.storeAssigned.conversations.sort(self.sortDesc);
	    },
	    oldConversations: function oldConversations() {
	      var self = this;
	      if (!self.storeWaiting.conversations) 
	        { return []; }

	      var oldOffset = hooks$1().subtract({ hours: self.oldConversationHourOffset });
	      var old = self.storeWaiting.conversations.filter(function (c) { return hooks$1(new Date(c.sendDate)).isBefore(oldOffset); });

	      var sorted = old.sort(self.sortAsc);

	      if (self.assignedConversations.length)
	        { return sorted.filter(function (c) { return !self.assignedConversations.some(function (c2) { return c.id === c2.id; }); }); }

	      return sorted;
	    },
	    waitingConversations: function waitingConversations() {
	      var self = this;
	      if (!self.storeWaiting.conversations) 
	        { return []; }

	      var sorted = self.storeWaiting.conversations.sort(self.sortDesc);

	      if (self.assignedConversations.length)
	        { sorted = sorted.filter(function (c) { return !self.assignedConversations.some(function (c2) { return c.id === c2.id; }); }); }

	      if (self.oldConversations.length)
	        { sorted = sorted.filter(function (c) { return !self.oldConversations.some(function (c2) { return c.id === c2.id; }); }); }

	      return sorted;
	    },
	    handledConversations: function handledConversations() {
	      var self = this;
	      if (!self.storeHandled.conversations) 
	        { return []; }
	      return self.storeHandled.conversations.sort(self.sortDesc);
	    },
	    searchedMessages: function searchedMessages() {
	      var self = this;
	      if (!self.storeSearch.conversations) 
	        { return []; }
	      return self.storeSearch.conversations.sort(self.sortDesc);
	    },
	    unreadCount: function unreadCount() {
	      var self = this;
	      var unreadCountAssigned = self.assignedConversations.filter(function (c) { return c.isReadByMe === false || (c.hasRead && !c.hasRead.includes(self.loggedInUser.id)); }).length;
	      var unreadCountOld = self.oldConversations.filter(function (c) { return c.isReadByMe === false || (c.hasRead && !c.hasRead.includes(self.loggedInUser.id)); }).length;
	      var unreadCountWaiting = self.waitingConversations.filter(function (c) { return c.isReadByMe === false || (c.hasRead && !c.hasRead.includes(self.loggedInUser.id)); }).length;
	      var totalUnreadCount = unreadCountAssigned + unreadCountOld + unreadCountWaiting;
	      
	      Brief$1.events.$emit('streams-badge-refresh', totalUnreadCount);

	      return totalUnreadCount;
	    }
	  },
	  watch: {
	    'storeWaiting.isLoading': handleIsLoading,
	  },
	  methods: {
	    handleSelectedAssigned: function handleSelectedAssigned(item) {
	      var self = this;
	      item.isReadByMe = true;
	      item.hasRead = [self.loggedInUser.id];
	      self.storeAssigned.saveClient();
	    },
	    handleSelectedWaiting: function handleSelectedWaiting(item) {
	      var self = this;
	      item.isReadByMe = true;
	      item.hasRead = [self.loggedInUser.id];
	      self.storeWaiting.saveClient();
	    },
	    handleSelectedHandled: function handleSelectedHandled(item) {
	      var self = this;
	      item.isReadByMe = true;
	      item.hasRead = [self.loggedInUser.id];
	      self.storeHandled.saveClient();
	    },
	    handleSelectedSearch: function handleSelectedSearch(item) {
	      var self = this;
	      item.isReadByMe = true;
	      item.hasRead = [self.loggedInUser.id];
	      self.storeSearch.saveClient();
	    },
	    handleMarkAsHandled: function handleMarkAsHandled(item) {
	      var self = this;
	      self.setIsHandled(item, true);
	    },
	    handleMarkAsWaiting: function handleMarkAsWaiting(item) {
	      var self = this;
	      self.setIsHandled(item, false);
	    },
	    setIsHandled: function setIsHandled(item, isHandled) {
	      var self = this;
	      item.isHandled = isHandled;
	      self.storeIsHandled.postNow({ 
	        isHandled: item.isHandled,
	        type: item.type, 
	        channelId: item.channelId,
	        conversationId: item.conversationId
	      });
	    },
	    handleCreated: function handleCreated(data, isNewMessage) {
	      if (!isNewMessage)
	        { return; }
	      var navigateOptions = Brief$1.isBigScreen ? { reloadAll: true } : { reloadCurrent: true };
	      Brief$1.viewMain.router.navigate(("/message/list/" + (data.type) + "/" + (data.channelId) + "/" + (data.conversationId)), navigateOptions);
	      Brief$1.f7.tab.show('#tab-handled');
	    },
	    openSheet: function openSheet() {
	      Brief$1.f7.sheet.open((".templates-sheet-" + (this._uid)), true);
	    },
	    closeSheet: function closeSheet() {
	      Brief$1.f7.sheet.close((".templates-sheet-" + (this._uid)), true);
	    },
	    onInfinite: function onInfinite() {
	      var self = this;
	      var tabActive = $$1('.tab-link-active');
	      if (!tabActive.length)
	        { return; }
	      if (tabActive.dataset().tab === '#tab-handled')
	        { self.storeHandled.getMore(); }
	      else
	        { self.storeWaiting.getMore(); }
	    },
	    onSearchbarEnable: function onSearchbarEnable(searchbar) {
	      this.searchbarEnabled = true;
	      searchbar.inputEl.value = this.searchQuery;
	    },
	    onSearchbarDisable: function onSearchbarDisable() {
	      this.searchbarEnabled = false;
	      this.showSearchbarNotFound = false;
	    },
	    onSearchbarSearch: function onSearchbarSearch(e) {
	      var self = this;
	      self.searchQuery = e.target.value;
	      if (self.searchQuery.length <= 1) {
	        if (self.storeSearch.conversations)
	          { self.storeSearch.conversations = []; }
	        self.showSearchbarNotFound = false;
	        return;
	      }
	      self.debounceSearch();
	    },
	    debounceSearch: lodash.debounce(function debounceSearch() {
	      var self = this;
	      self.storeSearch.get({ query: self.searchQuery });
	    }, 500),
	    sortAsc: function sortAsc(a, b) { 
	      return new Date(a.sendDate).getTime() - new Date(b.sendDate).getTime();
	    },
	    sortDesc: function sortDesc(a, b) { 
	      return new Date(b.sendDate).getTime() - new Date(a.sendDate).getTime();
	    },   
	    logout: function logout() {
	      Brief$1.logout();
	    }, 
	  }
	};

	function handleIsLoading(isLoading) {
	  var self = this;
	  if (isLoading)
	    { Brief$1.showProgress(self.$el); }
	  else
	    { Brief$1.hideProgress(self.$el); }
	}

	function handlePreProcess$a(data) {
	  var self = this;

	  if (data.deleteThis)
	    { return true; }

	  return data.assignedUsers && data.assignedUsers.includes(self.$root.loggedInUser.id);
	}

	/* script */
	var __vue_script__$2q = script$2q;

	/* template */
	var __vue_render__$2o = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f7-page',{attrs:{"page-content":false}},[(_vm.onboardingFinished)?_c('f7-fab',{attrs:{"color":"app"},on:{"click":_vm.openSheet}},[_c('f7-icon',{attrs:{"material":"edit"}})],1):_vm._e(),_vm._v(" "),_c('f7-sheet',{class:("templates-sheet small templates-sheet-" + _vm._uid)},[_c('f7-block',[_c('h2',[_vm._v("Create New")])]),_vm._v(" "),_c('f7-list',[_c('f7-list-item',{attrs:{"title":"Review Invite","link":("/message/list/sms/" + (_vm.loggedInUser.smsChannelId) + "/new?template=recension-inbjudan"),"view":".view-main","reload-all":_vm.isBigScreen},on:{"click":_vm.closeSheet}}),_vm._v(" "),_c('f7-list-item',{attrs:{"title":"Text Message","link":("/message/list/sms/" + (_vm.loggedInUser.smsChannelId) + "/new"),"view":".view-main","reload-all":_vm.isBigScreen},on:{"click":_vm.closeSheet}})],1)],1),_vm._v(" "),_c('f7-navbar',[_c('f7-nav-left',[_c('span',{staticStyle:{"padding":"0 16px","color":"#000","font-size":"30px","font-weight":"bold"}},[_vm._v("Inbox")])]),_vm._v(" "),_c('f7-nav-right',[_c('f7-link',{staticClass:"searchbar-enable",staticStyle:{"padding-right":"8px"},attrs:{"data-searchbar":".searchbar"}},[_c('f7-icon',{attrs:{"material":"search","size":"30","color":"app"}})],1),_vm._v(" "),_c('f7-link',{staticStyle:{"padding-left":"8px"},attrs:{"popover-open":".popover-user"}},[_c('common-avatar',{attrs:{"avatar":_vm.loggedInUser.photoFile}})],1)],1),_vm._v(" "),_c('f7-searchbar',{staticClass:"searchbar-expandable shadow-content",attrs:{"placeholder":"Search messages","custom-search":true,"backdrop":false,"clear-button":false,"disable-link-text":"Cancel"},on:{"searchbar:enable":_vm.onSearchbarEnable,"searchbar:disable":_vm.onSearchbarDisable,"input":_vm.onSearchbarSearch}})],1),_vm._v(" "),(!_vm.searchbarEnabled)?_c('f7-toolbar',{attrs:{"tabbar":"","no-hairline":""}},[_c('f7-link',{staticStyle:{"color":"#ff9500"},attrs:{"tab-link":"#tab-waiting","tab-link-active":""}},[_c('div',{staticStyle:{"display":"flex","align-items":"center"}},[_c('span',[_vm._v("Waiting")]),_vm._v(" "),(_vm.unreadCount)?_c('f7-badge',{attrs:{"color":"red"}},[_vm._v(_vm._s(_vm.unreadCount))]):_vm._e()],1)]),_vm._v(" "),_c('f7-link',{staticStyle:{"color":"#25d242"},attrs:{"tab-link":"#tab-handled"}},[_vm._v("Handled")])],1):_vm._e(),_vm._v(" "),_c('common-offline-indicator',{attrs:{"store":_vm.storeWaiting}}),_vm._v(" "),_c('common-topbanner'),_vm._v(" "),_c('div',{staticClass:"page-content infinite-scroll-content",on:{"infinite":_vm.onInfinite}},[_c('f7-popover',{staticClass:"popover-user"},[_c('f7-list',[_c('f7-list-item',{attrs:{"title":"Edit Profile","link":"/user/settings/","view":".popup-main-view","popup-open":".popup-main","reload-current":"","popover-close":""}}),_vm._v(" "),_c('f7-list-item',{attrs:{"title":"Change Password","link":"/password/settings/","view":".popup-main-view","popup-open":".popup-main","reload-current":"","popover-close":""}}),_vm._v(" "),_c('f7-list-item',{attrs:{"title":"Notifications","link":"/notification/settings/","view":".popup-main-view","popup-open":".popup-main","reload-current":"","popover-close":""}})],1),_vm._v(" "),_c('f7-list',[_c('f7-list-item',{attrs:{"title":"Manage Users","link":"/users/settings/","view":".popup-main-view","popup-open":".popup-main","reload-current":"","popover-close":""}}),_vm._v(" "),(!_vm.isCordova)?_c('f7-list-item',{attrs:{"title":"Subscription","link":"/subscription/settings/","view":".popup-main-view","popup-open":".popup-main","reload-current":"","popover-close":""}}):_vm._e()],1),_vm._v(" "),_c('f7-list',[_c('f7-list-item',{attrs:{"title":"Log Out","link":"#","popover-close":"","color":"red"},on:{"click":_vm.logout}})],1)],1),_vm._v(" "),(!_vm.searchbarEnabled)?_c('f7-tabs',[_c('f7-tab',{attrs:{"id":"tab-waiting","tab-active":""}},[(_vm.showIntroductionWaiting)?_c('div',[_c('f7-block',[_c('div',{staticStyle:{"text-align":"center"}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","version":"1.0","viewBox":"0 0 800.000000 590","preserveAspectRatio":"xMidYMid meet"}},[_c('g',{attrs:{"transform":"translate(-100.000000,750.000000) scale(0.125000,-0.125000)","fill":"rgba(0, 0, 0, 0.4)","stroke":"none"}},[_c('path',{attrs:{"d":"M4867 4882 c-35 -38 -8 -92 45 -92 31 0 51 21 51 57 0 48 -64 71 -96 35z m72 -6 c7 -8 11 -27 9 -43 -3 -25 -7 -28 -37 -28 -43 0 -60 23 -43 59 13 29 52 35 71 12z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M4147 4863 c-14 -14 -18 -14 -34 -2 -16 13 -17 12 -4 -3 11 -15 11 -21 1 -33 -7 -9 -11 -18 -8 -20 3 -3 11 1 18 10 12 14 15 14 34 -2 20 -17 21 -17 4 2 -16 17 -16 20 -1 37 21 23 12 33 -10 11z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M4885 4690 c-4 -12 -5 -24 -2 -27 3 -2 8 5 12 17 4 12 5 24 2 27 -3 2 -8 -5 -12 -17z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M4857 4543 c-9 -51 -2 -53 11 -3 5 22 6 40 2 40 -4 0 -10 -17 -13 -37z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M3945 4555 c23 -8 85 -10 85 -3 0 4 -21 8 -47 7 -27 0 -43 -2 -38 -4z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M3793 4524 c-17 -7 -35 -18 -38 -24 -4 -7 10 -3 31 8 22 11 46 22 54 25 13 5 13 5 0 5 -8 0 -29 -6 -47 -14z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M4110 4536 c0 -7 69 -36 84 -36 13 1 -30 25 -61 34 -13 4 -23 5 -23 2z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M3185 4467 c-13 -10 -16 -21 -11 -41 5 -22 12 -27 33 -24 38 4 52 32 29 57 -22 25 -26 25 -51 8z m55 -22 c0 -32 -45 -49 -56 -20 -10 24 14 47 37 34 10 -5 19 -11 19 -14z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M4290 4425 c19 -19 36 -35 39 -35 3 0 -10 16 -29 35 -19 19 -36 35 -39 35 -3 0 10 -16 29 -35z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M3653 4418 c-22 -26 -37 -48 -30 -48 3 0 17 16 31 35 30 39 30 46 -1 13z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M4808 4388 c-10 -23 -16 -44 -13 -46 6 -6 37 67 33 78 -2 5 -11 -9 -20 -32z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M3781 4295 c-112 -52 -208 -95 -213 -95 -5 0 -7 8 -4 18 3 9 8 31 11 47 5 23 4 26 -4 14 -6 -10 -12 -33 -13 -53 l-3 -36 -545 -251 c-300 -138 -556 -261 -570 -275 l-25 -24 -3 -998 c-2 -697 0 -1008 8 -1034 21 -73 -102 -68 1585 -68 1656 0 1559 -4 1584 57 8 21 11 290 9 1035 l-3 1008 -25 24 c-28 28 -1536 726 -1566 726 -10 -1 -111 -43 -223 -95z m449 -40 c124 -57 207 -101 212 -112 3 -10 8 -34 9 -53 2 -33 3 -32 8 11 l6 45 64 -28 63 -29 -23 -27 -24 -27 26 23 c14 12 28 22 32 22 15 0 923 -423 940 -438 14 -13 17 -28 15 -81 l-3 -66 -760 -352 c-634 -294 -766 -352 -795 -349 -19 2 -375 161 -790 353 l-755 348 -3 66 c-2 52 1 68 15 81 26 23 1514 708 1539 708 11 0 112 -43 224 -95z m-1016 -1152 c590 -273 760 -347 791 -347 31 0 200 74 792 347 414 191 754 347 757 347 4 0 6 -410 6 -910 l0 -911 -25 -24 -24 -25 -1506 0 -1506 0 -24 25 -25 24 0 911 c0 500 3 910 7 910 3 0 344 -156 757 -347z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M3930 4195 c-26 -32 13 -81 48 -59 34 22 22 74 -18 74 -10 0 -23 -7 -30 -15z m58 -23 c4 -28 -24 -41 -44 -20 -20 20 -7 50 20 46 13 -2 22 -12 24 -26z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M3552 4090 c0 -19 4 -46 8 -60 6 -20 8 -21 8 -5 1 11 -3 38 -7 60 l-9 40 0 -35z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M4425 3932 l-30 -36 27 18 27 17 4 -33 c4 -31 4 -30 5 8 1 22 7 45 14 52 9 9 9 12 -2 11 -8 0 -28 -17 -45 -37z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M3626 3892 c20 -35 61 -78 68 -71 2 2 -16 27 -41 54 -37 41 -42 44 -27 17z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M4258 3822 c-64 -36 -62 -51 2 -16 28 15 50 31 50 36 0 10 3 11 -52 -20z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M4449 3755 c-5 -50 -4 -63 7 -53 3 3 4 28 2 54 l-3 49 -6 -50z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M3780 3756 c0 -11 80 -46 102 -45 16 0 11 4 -17 13 -22 7 -50 18 -62 25 -13 6 -23 9 -23 7z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M4050 3730 c-62 -20 -52 -26 16 -9 24 6 44 15 44 20 0 5 -1 9 -2 8 -2 -1 -28 -9 -58 -19z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M5022 3731 c9 -16 9 -23 -3 -38 -13 -17 -13 -17 4 -4 15 12 22 12 38 3 18 -11 18 -11 7 7 -9 16 -9 23 3 38 13 17 13 17 -4 4 -15 -12 -22 -12 -38 -3 -18 11 -18 11 -7 -7z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M3147 3643 c-14 -14 -18 -14 -34 -2 -16 13 -17 12 -4 -4 12 -15 11 -20 -4 -37 -19 -21 -7 -28 13 -8 10 10 17 10 35 -1 20 -13 21 -13 8 3 -12 14 -13 21 -2 38 16 26 10 32 -12 11z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M4436 3587 c-4 -27 -5 -51 -2 -54 7 -7 19 61 14 84 -2 10 -8 -4 -12 -30z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M4020 3575 c-26 -32 13 -81 48 -59 34 22 22 74 -18 74 -10 0 -23 -7 -30 -15z m57 -11 c8 -21 -19 -46 -40 -38 -17 6 -23 35 -10 47 12 13 44 7 50 -9z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M4373 3400 c-28 -65 -21 -64 12 0 14 28 22 50 18 50 -5 0 -18 -23 -30 -50z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M4299 3258 c-7 -12 -19 -33 -27 -45 -8 -13 -10 -23 -6 -23 10 0 56 81 50 87 -2 3 -10 -6 -17 -19z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M4201 3097 c-8 -12 -21 -32 -29 -44 -8 -13 -12 -23 -8 -23 8 0 60 80 55 85 -3 2 -11 -6 -18 -18z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M4092 2939 c-19 -30 -11 -32 11 -3 10 13 14 24 10 24 -5 0 -14 -9 -21 -21z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M3410 2340 c-20 -20 -26 -66 -12 -85 4 -6 34 -9 70 -7 l62 4 0 38 c0 29 -6 43 -22 54 -31 22 -74 20 -98 -4z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M4470 2338 c-23 -25 -26 -66 -6 -94 12 -15 17 -17 27 -6 7 6 32 12 56 12 45 0 49 5 44 54 -5 55 -82 76 -121 34z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M3900 2149 c0 -18 21 -53 44 -71 45 -37 127 -16 155 39 21 41 15 43 -94 43 -68 0 -105 -4 -105 -11z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M4370 4329 c0 -4 11 -27 25 -50 14 -24 25 -39 25 -34 0 11 -49 94 -50 84z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M4706 4224 c-15 -20 -26 -37 -24 -39 2 -2 16 12 32 31 15 20 26 37 24 39 -2 2 -16 -12 -32 -31z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M5266 4067 c-36 -26 4 -84 42 -61 23 15 26 38 7 58 -20 19 -26 20 -49 3z m43 -11 c17 -20 2 -48 -23 -44 -24 3 -34 37 -14 49 18 12 24 11 37 -5z"}})])]),_vm._v(" "),_c('span',{staticStyle:{"color":"rgba(0, 0, 0, 0.4)","display":"block","font-size":"16px","font-weight":"bold"}},[_vm._v("Great! You've got no waiting messages.")])])]),_vm._v(" "),(_vm.onboardingFinished)?_c('div',{staticStyle:{"margin-top":"100px"}},[_c('f7-block-title',{staticStyle:{"text-align":"center"}},[_vm._v("What do you like to do next?")]),_vm._v(" "),_c('div',{staticClass:"shadow-content",staticStyle:{"margin":"0 16px 16px 16px"}},[_c('f7-list',[_c('f7-list-item',{attrs:{"title":"New Review Invite","link":("/message/list/sms/" + (_vm.loggedInUser.smsChannelId) + "/new?template=recension-inbjudan"),"view":".view-main","reload-all":_vm.isBigScreen}}),_vm._v(" "),_c('f7-list-item',{attrs:{"title":"New Text Message","link":("/message/list/sms/" + (_vm.loggedInUser.smsChannelId) + "/new"),"view":".view-main","reload-all":_vm.isBigScreen}})],1)],1)],1):_vm._e()],1):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.assignedConversations.length > 0),expression:"assignedConversations.length > 0"}],staticClass:"shadow-content",staticStyle:{"margin":"0 16px 16px 16px"}},[_c('f7-block-title',{staticClass:"block-title-sticky"},[_c('span',[_vm._v("Assigned to you")])]),_vm._v(" "),_c('common-conversation-list',{staticClass:"assigned-list",attrs:{"items":_vm.assignedConversations},on:{"click":_vm.handleSelectedAssigned,"markAsHandled":_vm.handleMarkAsHandled,"markAsWaiting":_vm.handleMarkAsWaiting}})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.oldConversations.length > 0),expression:"oldConversations.length > 0"}],staticClass:"shadow-content",staticStyle:{"margin":"0 16px 16px 16px"}},[_c('f7-block-title',{staticClass:"block-title-sticky"},[_c('span',[_vm._v("Waiting more than "+_vm._s(_vm.oldConversationHourOffset)+" hours")])]),_vm._v(" "),_c('common-conversation-list',{staticClass:"old-list",attrs:{"items":_vm.oldConversations},on:{"click":_vm.handleSelectedWaiting,"markAsHandled":_vm.handleMarkAsHandled,"markAsWaiting":_vm.handleMarkAsWaiting}})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.waitingConversations.length > 0),expression:"waitingConversations.length > 0"}],staticClass:"shadow-content",staticStyle:{"margin":"0 16px 16px 16px"}},[_c('f7-block-title',{staticClass:"block-title-sticky"},[_c('span',[_vm._v("Latest")])]),_vm._v(" "),_c('common-conversation-list',{attrs:{"items":_vm.waitingConversations},on:{"click":_vm.handleSelectedWaiting,"markAsHandled":_vm.handleMarkAsHandled,"markAsWaiting":_vm.handleMarkAsWaiting}})],1),_vm._v(" "),(!_vm.showIntroductionWaiting && _vm.assignedConversations.length === 0 && _vm.oldConversations.length === 0 && _vm.waitingConversations.length === 0)?_c('div',{staticClass:"center-content",staticStyle:{"height":"150px"}},[_c('f7-preloader',{attrs:{"size":"68px"}})],1):_vm._e()]),_vm._v(" "),_c('f7-tab',{attrs:{"id":"tab-handled"}},[(_vm.showIntroductionHandled)?_c('div',[_c('f7-block',[_c('div',{staticStyle:{"text-align":"center"}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","version":"1.0","viewBox":"0 0 800.000000 590","preserveAspectRatio":"xMidYMid meet"}},[_c('g',{attrs:{"transform":"translate(-100.000000,750.000000) scale(0.125000,-0.125000)","fill":"rgba(0, 0, 0, 0.4)","stroke":"none"}},[_c('path',{attrs:{"d":"M4867 4882 c-35 -38 -8 -92 45 -92 31 0 51 21 51 57 0 48 -64 71 -96 35z m72 -6 c7 -8 11 -27 9 -43 -3 -25 -7 -28 -37 -28 -43 0 -60 23 -43 59 13 29 52 35 71 12z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M4147 4863 c-14 -14 -18 -14 -34 -2 -16 13 -17 12 -4 -3 11 -15 11 -21 1 -33 -7 -9 -11 -18 -8 -20 3 -3 11 1 18 10 12 14 15 14 34 -2 20 -17 21 -17 4 2 -16 17 -16 20 -1 37 21 23 12 33 -10 11z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M4885 4690 c-4 -12 -5 -24 -2 -27 3 -2 8 5 12 17 4 12 5 24 2 27 -3 2 -8 -5 -12 -17z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M4857 4543 c-9 -51 -2 -53 11 -3 5 22 6 40 2 40 -4 0 -10 -17 -13 -37z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M3945 4555 c23 -8 85 -10 85 -3 0 4 -21 8 -47 7 -27 0 -43 -2 -38 -4z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M3793 4524 c-17 -7 -35 -18 -38 -24 -4 -7 10 -3 31 8 22 11 46 22 54 25 13 5 13 5 0 5 -8 0 -29 -6 -47 -14z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M4110 4536 c0 -7 69 -36 84 -36 13 1 -30 25 -61 34 -13 4 -23 5 -23 2z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M3185 4467 c-13 -10 -16 -21 -11 -41 5 -22 12 -27 33 -24 38 4 52 32 29 57 -22 25 -26 25 -51 8z m55 -22 c0 -32 -45 -49 -56 -20 -10 24 14 47 37 34 10 -5 19 -11 19 -14z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M4290 4425 c19 -19 36 -35 39 -35 3 0 -10 16 -29 35 -19 19 -36 35 -39 35 -3 0 10 -16 29 -35z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M3653 4418 c-22 -26 -37 -48 -30 -48 3 0 17 16 31 35 30 39 30 46 -1 13z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M4808 4388 c-10 -23 -16 -44 -13 -46 6 -6 37 67 33 78 -2 5 -11 -9 -20 -32z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M3781 4295 c-112 -52 -208 -95 -213 -95 -5 0 -7 8 -4 18 3 9 8 31 11 47 5 23 4 26 -4 14 -6 -10 -12 -33 -13 -53 l-3 -36 -545 -251 c-300 -138 -556 -261 -570 -275 l-25 -24 -3 -998 c-2 -697 0 -1008 8 -1034 21 -73 -102 -68 1585 -68 1656 0 1559 -4 1584 57 8 21 11 290 9 1035 l-3 1008 -25 24 c-28 28 -1536 726 -1566 726 -10 -1 -111 -43 -223 -95z m449 -40 c124 -57 207 -101 212 -112 3 -10 8 -34 9 -53 2 -33 3 -32 8 11 l6 45 64 -28 63 -29 -23 -27 -24 -27 26 23 c14 12 28 22 32 22 15 0 923 -423 940 -438 14 -13 17 -28 15 -81 l-3 -66 -760 -352 c-634 -294 -766 -352 -795 -349 -19 2 -375 161 -790 353 l-755 348 -3 66 c-2 52 1 68 15 81 26 23 1514 708 1539 708 11 0 112 -43 224 -95z m-1016 -1152 c590 -273 760 -347 791 -347 31 0 200 74 792 347 414 191 754 347 757 347 4 0 6 -410 6 -910 l0 -911 -25 -24 -24 -25 -1506 0 -1506 0 -24 25 -25 24 0 911 c0 500 3 910 7 910 3 0 344 -156 757 -347z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M3930 4195 c-26 -32 13 -81 48 -59 34 22 22 74 -18 74 -10 0 -23 -7 -30 -15z m58 -23 c4 -28 -24 -41 -44 -20 -20 20 -7 50 20 46 13 -2 22 -12 24 -26z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M3552 4090 c0 -19 4 -46 8 -60 6 -20 8 -21 8 -5 1 11 -3 38 -7 60 l-9 40 0 -35z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M4425 3932 l-30 -36 27 18 27 17 4 -33 c4 -31 4 -30 5 8 1 22 7 45 14 52 9 9 9 12 -2 11 -8 0 -28 -17 -45 -37z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M3626 3892 c20 -35 61 -78 68 -71 2 2 -16 27 -41 54 -37 41 -42 44 -27 17z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M4258 3822 c-64 -36 -62 -51 2 -16 28 15 50 31 50 36 0 10 3 11 -52 -20z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M4449 3755 c-5 -50 -4 -63 7 -53 3 3 4 28 2 54 l-3 49 -6 -50z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M3780 3756 c0 -11 80 -46 102 -45 16 0 11 4 -17 13 -22 7 -50 18 -62 25 -13 6 -23 9 -23 7z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M4050 3730 c-62 -20 -52 -26 16 -9 24 6 44 15 44 20 0 5 -1 9 -2 8 -2 -1 -28 -9 -58 -19z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M5022 3731 c9 -16 9 -23 -3 -38 -13 -17 -13 -17 4 -4 15 12 22 12 38 3 18 -11 18 -11 7 7 -9 16 -9 23 3 38 13 17 13 17 -4 4 -15 -12 -22 -12 -38 -3 -18 11 -18 11 -7 -7z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M3147 3643 c-14 -14 -18 -14 -34 -2 -16 13 -17 12 -4 -4 12 -15 11 -20 -4 -37 -19 -21 -7 -28 13 -8 10 10 17 10 35 -1 20 -13 21 -13 8 3 -12 14 -13 21 -2 38 16 26 10 32 -12 11z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M4436 3587 c-4 -27 -5 -51 -2 -54 7 -7 19 61 14 84 -2 10 -8 -4 -12 -30z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M4020 3575 c-26 -32 13 -81 48 -59 34 22 22 74 -18 74 -10 0 -23 -7 -30 -15z m57 -11 c8 -21 -19 -46 -40 -38 -17 6 -23 35 -10 47 12 13 44 7 50 -9z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M4373 3400 c-28 -65 -21 -64 12 0 14 28 22 50 18 50 -5 0 -18 -23 -30 -50z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M4299 3258 c-7 -12 -19 -33 -27 -45 -8 -13 -10 -23 -6 -23 10 0 56 81 50 87 -2 3 -10 -6 -17 -19z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M4201 3097 c-8 -12 -21 -32 -29 -44 -8 -13 -12 -23 -8 -23 8 0 60 80 55 85 -3 2 -11 -6 -18 -18z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M4092 2939 c-19 -30 -11 -32 11 -3 10 13 14 24 10 24 -5 0 -14 -9 -21 -21z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M3410 2340 c-20 -20 -26 -66 -12 -85 4 -6 34 -9 70 -7 l62 4 0 38 c0 29 -6 43 -22 54 -31 22 -74 20 -98 -4z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M4470 2338 c-23 -25 -26 -66 -6 -94 12 -15 17 -17 27 -6 7 6 32 12 56 12 45 0 49 5 44 54 -5 55 -82 76 -121 34z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M3900 2149 c0 -18 21 -53 44 -71 45 -37 127 -16 155 39 21 41 15 43 -94 43 -68 0 -105 -4 -105 -11z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M4370 4329 c0 -4 11 -27 25 -50 14 -24 25 -39 25 -34 0 11 -49 94 -50 84z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M4706 4224 c-15 -20 -26 -37 -24 -39 2 -2 16 12 32 31 15 20 26 37 24 39 -2 2 -16 -12 -32 -31z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M5266 4067 c-36 -26 4 -84 42 -61 23 15 26 38 7 58 -20 19 -26 20 -49 3z m43 -11 c17 -20 2 -48 -23 -44 -24 3 -34 37 -14 49 18 12 24 11 37 -5z"}})])]),_vm._v(" "),_c('span',{staticStyle:{"color":"rgba(0, 0, 0, 0.4)","display":"block","font-size":"16px","font-weight":"bold"}},[_vm._v("Nothing yet. All handled messages will show up here.")])])])],1):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.handledConversations.length > 0),expression:"handledConversations.length > 0"}],staticClass:"shadow-content",staticStyle:{"margin":"0 16px 16px 16px"}},[_c('f7-block-title',{staticClass:"block-title-sticky"},[_c('span',[_vm._v("Latest")])]),_vm._v(" "),_c('common-conversation-list',{attrs:{"items":_vm.handledConversations},on:{"click":_vm.handleSelectedHandled,"markAsHandled":_vm.handleMarkAsHandled,"markAsWaiting":_vm.handleMarkAsWaiting}})],1)])],1):_vm._e(),_vm._v(" "),(_vm.searchbarEnabled)?_c('div',{staticClass:"searchbar-conversations"},[(_vm.searchQuery.length > 1 && !_vm.storeSearch.isLoading)?_c('div',{staticClass:"shadow-content",staticStyle:{"margin":"16px"}},[(!_vm.showSearchbarNotFound && _vm.searchedMessages.length > 0)?_c('f7-block-title',{staticClass:"block-title-sticky"},[_c('span',[_vm._v("Latest")])]):_vm._e(),_vm._v(" "),(!_vm.showSearchbarNotFound && _vm.searchedMessages.length > 0)?_c('common-conversation-list',{attrs:{"items":_vm.searchedMessages},on:{"click":_vm.handleSelectedSearch,"markAsHandled":_vm.handleMarkAsHandled,"markAsWaiting":_vm.handleMarkAsWaiting}}):_vm._e(),_vm._v(" "),(_vm.showSearchbarNotFound)?_c('f7-list',[_c('f7-list-item',{attrs:{"title":"Nothing found"}})],1):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.storeSearch.isLoading)?_c('div',{staticClass:"center-content",staticStyle:{"height":"70%"}},[_c('f7-preloader',{attrs:{"size":"68px"}})],1):_vm._e()]):_vm._e()],1)],1)};
	var __vue_staticRenderFns__$2o = [];

	  /* style */
	  var __vue_inject_styles__$2r = undefined;
	  /* scoped */
	  var __vue_scope_id__$2r = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$2r = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$2r = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$2r = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$2o, staticRenderFns: __vue_staticRenderFns__$2o },
	    __vue_inject_styles__$2r,
	    __vue_script__$2q,
	    __vue_scope_id__$2r,
	    __vue_is_functional_template__$2r,
	    __vue_module_identifier__$2r,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//

	function isReadByMe$7(message, userId) {
	  if (message.readByEveryone || message.ownerUserId === userId) {
	    return true;
	  }
	  return message.hasRead.find(function (x) { return x === userId; }) !== undefined;
	}

	function handlePreProcess$b(data) {
	  var self = this;

	  var userId = self.$root.loggedInUser.id;
	  data.isReadByMe = isReadByMe$7(data, userId);

	  return true;
	}

	var script$2r = {
	  name: 'MessageList',
	  data: function data() {
	    var self = this;
	    var type = self.$f7route.params.type;
	    var channelId = self.$f7route.params.channelId;
	    var conversationId = decodeURIComponent(self.$f7route.params.conversationId);
	    var template = self.$f7route.query.template;

	    var store = new Store(self, {
	      get: ['message', 'list', { type: type, channelId: channelId, conversationId: conversationId }],
	      postForm: [(type + "message"), 'reply', { channelId: channelId, conversationId: conversationId }],
	      postFormFinished: function () { Brief$1.events.$emit('sync'); },
	      subscribe: [
	        ['message', 'list', 'messages', { processLocally: false, subscriptionKey: conversationId }],
	        ['message', 'listemail', 'messages', { processLocally: false, subscriptionKey: conversationId }], // TEMPORARY - Remove when one table
	        ['message', 'listwebsite', 'messages', { processLocally: false, subscriptionKey: conversationId }], // TEMPORARY - Remove when one table
	        ['message', 'listfacebook', 'messages', { processLocally: false, subscriptionKey: conversationId }], // TEMPORARY - Remove when one table
	        ['message', 'listinstagram', 'messages', { processLocally: false, subscriptionKey: conversationId }] ],
	      targetArrayName: 'messages',
	      preProcess: handlePreProcess$b,
	    });
	    var storeIsTyping = new Store(self, {
	      postNow: ['message', 'istyping', { channelId: channelId, contextId: conversationId }],
	      subscribe: ['message', 'istyping', null, { processLocally: true, subscriptionKey: conversationId }],
	      subscribeFinished: function (subscribeData) {
	        self.$refs.chat.showTyping(subscribeData);
	      },
	    });
	    return {
	      store: store,
	      storeIsTyping: storeIsTyping,
	      channelId: channelId,
	      conversationId: conversationId,
	      type: type,
	      template: template
	    };
	  },
	  methods: {
	    showOriginal: function showOriginal(message, data) {
	      function proceedData(emailMessage) {
	        var from = {
	          name: emailMessage.from.firstName,
	          email: emailMessage.from.email,
	        };
	        var to = {
	          name: emailMessage.to[0].firstName,
	          email: emailMessage.to[0].email,
	        };
	        var fromString = "<b>" + (from.name) + "</b> <span>&lt;" + (from.email) + "&gt;</span>";
	        var subjectString = emailMessage.subject;
	        var toString = "To: <span>" + (to.name) + (to.name !== to.email ? (" &lt;" + (to.email) + "&gt;") : '') + "</span>";
	        var popupInstance = Brief$1.f7.popup.create({
	          content: ("\n            <div class=\"popup email-original-popup\">\n              <div class=\"view\">\n                <div class=\"page\">\n                  <div class=\"navbar\">\n                    <div class=\"navbar-inner\">\n                      <div class=\"title\">Original Email</div>\n                      <div class=\"right\">\n                        <a href=\"#\" class=\"popup-close link\">\n                          <i class=\"icon material-icons\" style=\"font-size: 30px;\">close</i>\n                        </a>\n                      </div>\n                    </div>\n                  </div>\n                  <div class=\"page-content\">\n                    <div class=\"list simple-list no-margin\">\n                      <ul>\n                        <li>" + fromString + "</li>\n                        <li>" + subjectString + "</li>\n                        <li>" + toString + "</li>\n                      </ul>\n                    </div>\n                    " + (Brief$1.f7.device.ios ? '<div class="email-original-iframe-wrap">' : '') + "\n                    " + (emailMessage.html && emailMessage.html.length ?
	                      '<iframe frameborder="0"></iframe>' :
	                      ("<div class=\"block\">" + (emailMessage.text) + "</div>")) + "\n                    " + (Brief$1.f7.device.ios ? '</div>' : '') + "\n                  </div>\n                </div>\n              </div>\n            </div>").trim(),
	          on: {
	            open: function open(popup) {
	              if (!emailMessage.html || !emailMessage.html.length) { return; }
	              var iframe = popup.$el.find('iframe')[0];
	              var body = iframe.contentDocument.body;
	              body.innerHTML = emailMessage.html;
	              if (Brief$1.isCordova) {
	                $$1(body).find('a').on('click', function onClick(e) {
	                  e.preventDefault();
	                  var $link = $$1(this);
	                  var url = $link.attr('href');
	                  if (!url || url === '#' || url.indexOf('javascript') >= 0) { return; }
	                  Brief$1.openInSystemBrowser(url);
	                });
	              } else {
	                $$1(body).find('a').attr('target', '_blank');
	              }
	            },
	          },
	        }).open();
	        if (!Brief$1.isCordova) {
	          document.addEventListener('keydown', function(e) {
	            if (e.code === 'Escape' && popupInstance) {
	              popupInstance.close();
	              popupInstance = null;
	            }
	          }, false);
	        }
	      }
	      if (data) {
	        proceedData(data);
	        return;
	      }

	      Brief$1.f7.preloader.show();
	      Brief$1.f7.request({
	        url: ((Brief$1.api) + "/emailmessage/original"),
	        method: 'GET',
	        dataType: 'json',
	        data: {
	          id: message.id,
	          access_token: window.localStorage.getItem('access_token'),
	          device_id: window.localStorage.getItem('device_id'),
	        },
	        success: function success(response) {
	          Brief$1.f7.preloader.hide();
	          proceedData(response.data);
	        },
	      });
	    },
	  },
	};

	/* script */
	var __vue_script__$2r = script$2r;

	/* template */
	var __vue_render__$2p = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('channel-chat-page',{ref:"chat",attrs:{"navbarRoot":false,"type":_vm.type,"channel-id":_vm.channelId,"conversation-id":_vm.conversationId,"store":_vm.store,"storeIsTyping":_vm.storeIsTyping,"focus-on-load":false,"use-mentions":true,"signature":true,"template":_vm.template},on:{"showOriginal":_vm.showOriginal}})};
	var __vue_staticRenderFns__$2p = [];

	  /* style */
	  var __vue_inject_styles__$2s = undefined;
	  /* scoped */
	  var __vue_scope_id__$2s = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$2s = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$2s = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$2s = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$2p, staticRenderFns: __vue_staticRenderFns__$2p },
	    __vue_inject_styles__$2s,
	    __vue_script__$2r,
	    __vue_scope_id__$2s,
	    __vue_is_functional_template__$2s,
	    __vue_module_identifier__$2s,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//
	//
	//
	//
	//
	//
	//

	var script$2s = { name: 'MessageAssign' };

	/* script */
	var __vue_script__$2s = script$2s;

	/* template */
	var __vue_render__$2q = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('conversation-assign-page',{attrs:{"id":_vm.$f7route.params.channelId,"conversationId":_vm.$f7route.params.conversationId,"type":"sms"}})};
	var __vue_staticRenderFns__$2q = [];

	  /* style */
	  var __vue_inject_styles__$2t = undefined;
	  /* scoped */
	  var __vue_scope_id__$2t = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$2t = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$2t = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$2t = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$2q, staticRenderFns: __vue_staticRenderFns__$2q },
	    __vue_inject_styles__$2t,
	    __vue_script__$2s,
	    __vue_scope_id__$2t,
	    __vue_is_functional_template__$2t,
	    __vue_module_identifier__$2t,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	/* script */

	/* template */
	var __vue_render__$2r = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f7-page',{staticClass:"page-form"},[_c('f7-navbar',[_c('f7-nav-left',[_c('common-nav-placeholder')],1),_vm._v(" "),_c('f7-nav-title',[_vm._v("\n      Settings\n    ")]),_vm._v(" "),_c('f7-nav-right',[_c('f7-link',{attrs:{"popup-close":""}},[_c('f7-icon',{attrs:{"material":"close","size":"30"}})],1)],1)],1),_vm._v(" "),_c('f7-list',{attrs:{"inset":""}},[_c('f7-list-item',{attrs:{"title":"Channels","link":"/company/settings/"}}),_vm._v(" "),_c('f7-list-item',{attrs:{"title":"Company Profile","link":"/company/settings/"}}),_vm._v(" "),_c('f7-list-item',{attrs:{"title":"Subscription","link":"/subscription/settings/"}})],1)],1)};
	var __vue_staticRenderFns__$2r = [];

	  /* style */
	  var __vue_inject_styles__$2u = undefined;
	  /* scoped */
	  var __vue_scope_id__$2u = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$2u = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$2u = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$2u = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$2r, staticRenderFns: __vue_staticRenderFns__$2r },
	    __vue_inject_styles__$2u,
	    {},
	    __vue_scope_id__$2u,
	    __vue_is_functional_template__$2u,
	    __vue_module_identifier__$2u,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//

	var script$2t = {
	  name: 'NotificationSettings',
	  data: function data() {
	    var self = this;
	    var storeNotifications = new Store(self, {
	      post: ['user', 'updatenotifications'],
	      postFinished: notificationPostFinished,
	      sync: false,
	    });
	    self.$nextTick(function () {
	      self.checkNotifications();
	    });
	    return {
	      storeNotifications: storeNotifications,
	      isCordova: Brief$1.isCordova,
	      saveInProgress: false,
	      showEnableNotifications: false,
	      showTurnOnNotifications: false,
	    };
	  },    
	  computed: {
	    isNotificationsDisabled: function isNotificationsDisabled() {
	      return this.$root.loggedInUser.disableNotificatonsUntil &&
	        hooks$1(this.$root.loggedInUser.disableNotificatonsUntil) > hooks$1();
	    },
	    notificationsResumedIn: function notificationsResumedIn() {
	      var disableNotificatonsUntil = this.$root.loggedInUser.disableNotificatonsUntil;
	      if (!disableNotificatonsUntil) {
	        return '';
	      }
	      var startTime = hooks$1();
	      var endTime = hooks$1(disableNotificatonsUntil);
	      var duration = hooks$1.duration(endTime.diff(startTime));
	      var hours = parseInt(duration.asHours());
	      var minutes = parseInt(duration.asMinutes()) - hours * 60;
	      if (hours > 1000) {
	        return null;
	      }
	      if (minutes === 0) {
	        return (hours + "h");
	      }
	      return (hours + "h " + minutes + "m");
	    }
	  },
	  methods: {
	    checkNotifications: function checkNotifications() {
	      var self = this;

	      PushNotifications.hasGrantedPermission(function (hasGrantedPermission) {
	        PushNotifications.hasDeniedPermission(function (hasDeniedPermission) {
	          self.showEnableNotifications = !hasGrantedPermission && !hasDeniedPermission;
	          self.showTurnOnNotifications = hasDeniedPermission;
	        });
	      });
	    },
	    openDeviceSettings: function openDeviceSettings() {
	      var self = this;
	      PushNotifications.openDeviceSettings(function () {
	        self.showTurnOnNotifications = false;
	      });
	    },
	    enableNotificationPermission: function enableNotificationPermission() {
	      var self = this;
	      PushNotifications.requestPermission(function () {
	        self.showEnableNotifications = false;
	      });
	    },
	    snooze: function snooze(type) {
	      var durationMs = type;
	      if (type === 'tomorrow') {
	        durationMs = hooks$1.duration(hooks$1().set('hour', 8).set('minute', 0).add(1, 'day').diff(hooks$1())).asMilliseconds();
	      }
	      if (type === 'monday') {
	        durationMs = hooks$1.duration(hooks$1().set('hour', 8).set('minute', 0).add(7, 'days').isoWeekday(1).diff(hooks$1())).asMilliseconds();
	      }
	      if (type === 'forever') {
	        durationMs = 5 * 365 * 24 * 60 * 60 * 1000;
	      }
	      this.storeNotifications.post({ durationMs: durationMs });
	    },
	    save: function save() {
	      var self = this;
	      self.saveInProgress = true;

	    },      
	  },
	};

	function notificationPostFinished(result) {
	  this.saveInProgress = false;
	  if (result.success) {
	    this.$root.loggedInUser.get();
	    Brief$1.f7.popup.close();
	  }
	}

	/* script */
	var __vue_script__$2t = script$2t;

	/* template */
	var __vue_render__$2s = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f7-page',{staticClass:"page-form"},[_c('f7-navbar',[_c('f7-nav-left',[_c('f7-nav-left',[_c('common-nav-placeholder')],1)],1),_vm._v(" "),_c('f7-nav-title',[_vm._v("\n      Notifications\n    ")]),_vm._v(" "),_c('f7-nav-right',[_c('f7-link',{attrs:{"popup-close":""}},[_c('f7-icon',{attrs:{"material":"close","size":"30"}})],1)],1)],1),_vm._v(" "),(_vm.showEnableNotifications)?_c('f7-block',{staticStyle:{"display":"flex","flex-direction":"column","justify-content":"space-between","gap":"16px"},attrs:{"strong":"","inset":""}},[_c('span',[_vm._v("Enable notifications to get notified when receiving text messages from customers")]),_vm._v(" "),_c('f7-button',{staticStyle:{"align-self":"flex-end"},attrs:{"fill":""},on:{"click":_vm.enableNotificationPermission}},[_vm._v("Enable Notifications")])],1):_vm._e(),_vm._v(" "),(_vm.showTurnOnNotifications)?_c('f7-block',{staticStyle:{"display":"flex","flex-direction":"column","justify-content":"space-between","gap":"16px"},attrs:{"strong":"","inset":""}},[(_vm.isCordova)?_c('span',[_vm._v("Turn on notifications for Brief in your device settings")]):_vm._e(),_vm._v(" "),(!_vm.isCordova)?_c('span',[_vm._v("Turn on notifications for Brief in your browser settings")]):_vm._e(),_vm._v(" "),(_vm.isCordova)?_c('f7-button',{staticStyle:{"align-self":"flex-end"},attrs:{"fill":""},on:{"click":_vm.openDeviceSettings}},[_vm._v("Device Settings")]):_vm._e()],1):_vm._e(),_vm._v(" "),_c('f7-block-title',[_vm._v("Snooze Notifications")]),_vm._v(" "),(_vm.isNotificationsDisabled)?_c('f7-list',{attrs:{"inset":""}},[(_vm.notificationsResumedIn)?_c('f7-list-item',{attrs:{"title":'Resumes in ' + _vm.notificationsResumedIn}},[_c('f7-button',{attrs:{"slot":"after"},on:{"click":function($event){return _vm.snooze(0)}},slot:"after"},[_vm._v("\n        Resume now\n      ")])],1):_vm._e()],1):_vm._e(),_vm._v(" "),_c('f7-list',{attrs:{"inset":""}},[_c('f7-list-item',{attrs:{"link":"true","title":"For 20 Minutes"},on:{"click":function($event){return _vm.snooze(20 * 60 * 1000)}}}),_vm._v(" "),_c('f7-list-item',{attrs:{"link":"true","title":"For 1 Hour"},on:{"click":function($event){return _vm.snooze(1 * 60 * 60 * 1000)}}}),_vm._v(" "),_c('f7-list-item',{attrs:{"link":"true","title":"For 2 Hours"},on:{"click":function($event){return _vm.snooze(2 * 60 * 60 * 1000)}}}),_vm._v(" "),_c('f7-list-item',{attrs:{"link":"true","title":"For 4 Hours"},on:{"click":function($event){return _vm.snooze(4 * 60 * 60 * 1000)}}}),_vm._v(" "),_c('f7-list-item',{attrs:{"link":"true","title":"For 8 Hours"},on:{"click":function($event){return _vm.snooze(8 * 60 * 60 * 1000)}}}),_vm._v(" "),_c('f7-list-item',{attrs:{"link":"true","title":"For 24 Hours"},on:{"click":function($event){return _vm.snooze(24 * 60 * 60 * 1000)}}}),_vm._v(" "),_c('f7-list-item',{attrs:{"link":"true","title":"For 48 Hours"},on:{"click":function($event){return _vm.snooze(48 * 60 * 60 * 1000)}}}),_vm._v(" "),_c('f7-list-item',{attrs:{"link":"true","title":"Until Tomorrow"},on:{"click":function($event){return _vm.snooze('tomorrow')}}}),_vm._v(" "),_c('f7-list-item',{attrs:{"link":"true","title":"Until Monday"},on:{"click":function($event){return _vm.snooze('monday')}}}),_vm._v(" "),_c('f7-list-item',{attrs:{"link":"true","title":"Forever"},on:{"click":function($event){return _vm.snooze('forever')}}})],1)],1)};
	var __vue_staticRenderFns__$2s = [];

	  /* style */
	  var __vue_inject_styles__$2v = undefined;
	  /* scoped */
	  var __vue_scope_id__$2v = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$2v = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$2v = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$2v = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$2s, staticRenderFns: __vue_staticRenderFns__$2s },
	    __vue_inject_styles__$2v,
	    __vue_script__$2t,
	    __vue_scope_id__$2v,
	    __vue_is_functional_template__$2v,
	    __vue_module_identifier__$2v,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//

	  var script$2u = {
	    data: function data() {
	      var self = this;
	      var store = new Store(self, {
	        get: ['subscription', 'settings'],
	        getFinished: function () {
	          Brief$1.hidePreloader();
	        }
	      });
	      store.clear();
	      store.get();

	      var storeSubscriptionCancel = new Store(self, {
	        postNow: ['subscription', 'cancel'],
	        postNowFinished: function () {
	          store.get();
	        }
	      });

	      var storeSubscriptionActivate = new Store(self, {
	        postNow: ['subscription', 'activate'],
	        postNowFinished: function () {
	          store.get();
	        }
	      });

	      var accessToken = window.localStorage.getItem('access_token');
	      var deviceId = window.localStorage.getItem('device_id');

	      return {
	        store: store,
	        storeSubscriptionCancel: storeSubscriptionCancel,
	        storeSubscriptionActivate: storeSubscriptionActivate,
	        accessToken: accessToken,
	        deviceId: deviceId
	      };
	    },
	    methods: {
	      showRedirectProgress: function showRedirectProgress() {
	        Brief$1.showPreloader('Redirecting to payment provider');
	      },
	      cancelSubscription: function cancelSubscription() {
	        Brief$1.showPreloader('Canceling subscription');
	        this.storeSubscriptionCancel.postNow();
	      },
	      activateSubscription: function activateSubscription() {
	        Brief$1.showPreloader('Activating subscription');
	        this.storeSubscriptionActivate.postNow();
	      }
	    },
	    computed: {
	      subscriptionExpiryDate: function subscriptionExpiryDate() {
	        return this.store.subscriptionExpiryDate ? ("" + (hooks$1(this.store.subscriptionExpiryDate).locale('en').format('LL'))) : undefined;
	      },
	      subscriptionHasExpired: function subscriptionHasExpired() {
	        return this.store.subscriptionExpiryDate ? hooks$1(this.store.subscriptionExpiryDate).isSameOrBefore() : false;
	      },
	      cardExpiryDate: function cardExpiryDate() {
	        return this.store.card ? ("" + (hooks$1(this.store.card.expiryDate).locale('en').format('MM/YYYY'))) : undefined;
	      },
	      latestInvoiceDate: function latestInvoiceDate() {
	        return this.store.latestInvoice ? ("" + (hooks$1(this.store.latestInvoice.date).locale('en').format('LL'))) : undefined;
	      },
	      latestInvoicePaid: function latestInvoicePaid() {
	        return this.store.latestInvoice ? ("$" + (this.store.latestInvoice.paid)) : undefined;
	      },
	    },
	  };

	/* script */
	var __vue_script__$2u = script$2u;

	/* template */
	var __vue_render__$2t = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f7-page',{staticClass:"page-form"},[_c('f7-navbar',[_c('f7-nav-left',[_c('common-nav-placeholder')],1),_vm._v(" "),_c('f7-nav-title',[_vm._v("\n      Subscription\n    ")]),_vm._v(" "),_c('f7-nav-right',[_c('f7-link',{attrs:{"popup-close":""}},[_c('f7-icon',{attrs:{"material":"close","size":"30"}})],1)],1)],1),_vm._v(" "),(!_vm.store.currentPlan)?_c('div',{staticClass:"center-content",staticStyle:{"height":"70%"}},[_c('f7-preloader',{attrs:{"size":"68px"}})],1):_vm._e(),_vm._v(" "),(_vm.store.currentPlan && !_vm.subscriptionHasExpired)?_c('f7-block-title',[_vm._v("Plan")]):_vm._e(),_vm._v(" "),(_vm.store.currentPlan)?_c('f7-block',{staticStyle:{"display":"flex","flex-direction":"column","justify-content":"space-between","gap":"16px"},attrs:{"strong":"","inset":""}},[_c('span',[_vm._v("\n      You are currently on a "),_c('b',[_vm._v(_vm._s(_vm.store.currentPlan.name))]),_vm._v(" plan that includes "),_c('b',[_vm._v(_vm._s(_vm.store.currentPlan.price.sentMessagesIncluded))]),_vm._v(" sent messages/month.\n      "),(_vm.subscriptionExpiryDate && !_vm.store.subscriptionIsCanceled)?_c('span',[_c('br'),_vm._v("Your plan will automatically renew on "),_c('b',[_vm._v(_vm._s(_vm.subscriptionExpiryDate))]),_vm._v(".")]):_vm._e(),_vm._v(" "),(_vm.subscriptionExpiryDate && _vm.store.subscriptionIsCanceled)?_c('span',[_c('br'),_vm._v("Your plan will be canceled on "),_c('b',[_vm._v(_vm._s(_vm.subscriptionExpiryDate))]),_vm._v(".")]):_vm._e()]),_vm._v(" "),_c('f7-button',{staticStyle:{"align-self":"flex-end"},attrs:{"fill":"","href":"/plan/settings/"}},[_vm._v("Change plan")])],1):_vm._e(),_vm._v(" "),(_vm.store.currentPlan && _vm.store.currentPlan.price.id !== 'free')?_c('div',[_c('f7-block-title',[_vm._v("Payment Information")]),_vm._v(" "),_c('f7-block',{staticStyle:{"display":"flex","flex-direction":"column","justify-content":"space-between","gap":"16px"},attrs:{"strong":"","inset":""}},[(_vm.store.card)?_c('span',[_vm._v("Your default payment method is a credit card ending in "),_c('b',[_vm._v(_vm._s(_vm.store.card.ending))]),_vm._v(" that expires on "),_c('b',[_vm._v(_vm._s(_vm.cardExpiryDate))])]):_c('span',[_vm._v("Missing payment method")]),_vm._v(" "),_c('f7-button',{staticStyle:{"align-self":"flex-end"},attrs:{"fill":"","href":("/api/stripe/portal?access_token=" + _vm.accessToken + "&device_id&" + _vm.deviceId),"external":""},on:{"click":_vm.showRedirectProgress}},[_vm._v("Update payment")])],1),_vm._v(" "),(_vm.store.latestInvoice)?_c('f7-block-title',[_vm._v("Invoices")]):_vm._e(),_vm._v(" "),(_vm.store.latestInvoice)?_c('f7-block',{staticStyle:{"display":"flex","flex-direction":"column","justify-content":"space-between","gap":"16px"},attrs:{"strong":"","inset":""}},[_c('span',[_vm._v("Your latest invoice was created "),_c('b',[_vm._v(_vm._s(_vm.latestInvoiceDate))]),_vm._v(" at total "),_c('b',[_vm._v(_vm._s(_vm.latestInvoicePaid))])]),_vm._v(" "),_c('f7-button',{staticStyle:{"align-self":"flex-end"},attrs:{"fill":"","href":("/api/stripe/portal?access_token=" + _vm.accessToken + "&device_id&" + _vm.deviceId),"external":""},on:{"click":_vm.showRedirectProgress}},[_vm._v("Download invoices")])],1):_vm._e(),_vm._v(" "),(_vm.subscriptionExpiryDate && !_vm.store.subscriptionIsCanceled)?_c('f7-block-title',[_vm._v("Cancel Subscription")]):_vm._e(),_vm._v(" "),(_vm.subscriptionExpiryDate && !_vm.store.subscriptionIsCanceled)?_c('f7-block',{staticStyle:{"display":"flex","flex-direction":"column","justify-content":"space-between","gap":"16px"},attrs:{"strong":"","inset":""}},[_c('span',[_vm._v("You may cancel your subscription at any time. Once your subscription has been cancelled, you will not be charged after the end of your current billing cycle. You will still be able to use current plan until "),_c('b',[_vm._v(_vm._s(_vm.subscriptionExpiryDate))]),_vm._v(".")]),_vm._v(" "),_c('f7-button',{staticStyle:{"align-self":"flex-end"},attrs:{"fill":""},on:{"click":_vm.cancelSubscription}},[_vm._v("Cancel subscription")])],1):_vm._e(),_vm._v(" "),(_vm.subscriptionExpiryDate && _vm.store.subscriptionIsCanceled)?_c('f7-block-title',[_vm._v("Activate Subscription")]):_vm._e(),_vm._v(" "),(_vm.subscriptionExpiryDate && _vm.store.subscriptionIsCanceled)?_c('f7-block',{staticStyle:{"display":"flex","flex-direction":"column","justify-content":"space-between","gap":"16px"},attrs:{"strong":"","inset":""}},[_c('span',[_vm._v("You may activate your subscription at any time")]),_vm._v(" "),(_vm.subscriptionHasExpired)?_c('f7-button',{staticStyle:{"align-self":"flex-end"},attrs:{"fill":"","href":("/api/stripe/checkout?access_token=" + _vm.accessToken + "&device_id&" + _vm.deviceId + "&selectedPriceId=" + (_vm.store.currentPlan.price.id)),"external":""},on:{"click":_vm.showRedirectProgress}},[_vm._v("Activate subscription")]):_c('f7-button',{staticStyle:{"align-self":"flex-end"},attrs:{"fill":""},on:{"click":_vm.activateSubscription}},[_vm._v("Activate subscription")])],1):_vm._e()],1):_vm._e()],1)};
	var __vue_staticRenderFns__$2t = [];

	  /* style */
	  var __vue_inject_styles__$2w = undefined;
	  /* scoped */
	  var __vue_scope_id__$2w = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$2w = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$2w = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$2w = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$2t, staticRenderFns: __vue_staticRenderFns__$2t },
	    __vue_inject_styles__$2w,
	    __vue_script__$2u,
	    __vue_scope_id__$2w,
	    __vue_is_functional_template__$2w,
	    __vue_module_identifier__$2w,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//

	var script$2v = {
	  name: 'PasswordSettings',
	  props: ['isLoading'],
	  data: function data() {
	    var this$1 = this;

	    var self = this;
	    var store = new Store(self, {
	      post: ['user', 'password'],
	      postFinished: function (result) {
	        this$1.saveInProgress = false;
	        if (result.success) {
	          Brief$1.f7.popup.close();
	        }
	      },
	    });
	    return {
	      store: store,
	      currentPassword: '',
	      newPassword: '',
	      confirmPassword: '',
	      errorMessageCurrent: '',
	      errorMessageNew: '',
	      errorMessageConfirm: '',
	      saveInProgress: false,
	      controlId: parseInt((Math.random() * 100000), 10).toString(),
	    };
	  },
	  watch: {
	    currentPassword: function currentPassword() {
	      var self = this;
	      self.errorMessageOld = '';
	    },
	    newPassword: function newPassword() {
	      var self = this;
	      self.errorMessageNew = '';
	    },
	    confirmPassword: function confirmPassword() {
	      var self = this;
	      self.errorMessageConfirm = '';
	    },
	  },
	  beforeDestroy: function beforeDestroy() {
	    var self = this;
	    self.store.dispose();
	  },
	  methods: {
	    save: function save() {
	      var self = this;
	      self.errorMessageCurrent = self.currentPassword.trim() === '' ? 'Please specify your current password' : '';
	      self.errorMessageNew = self.newPassword.trim() === '' ? 'Password can not be empty' : '';
	      self.errorMessageConfirm = self.newPassword.trim() && self.newPassword !== self.confirmPassword ? 'Password and confirm password don\'t match' : '';
	      if (self.errorMessageCurrent || self.errorMessageNew || self.errorMessageConfirm) {
	        return;
	      }
	      self.saveInProgress = true;
	      self.store.post({
	        password: self.currentPassword.trim(),
	        newPassword: self.newPassword.trim(),
	      });
	    },
	  },
	};

	/* script */
	var __vue_script__$2v = script$2v;

	/* template */
	var __vue_render__$2u = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f7-page',{staticClass:"page-form"},[_c('f7-navbar',[_c('f7-nav-left',[_c('f7-nav-left',[_c('common-nav-placeholder')],1)],1),_vm._v(" "),_c('f7-nav-title',[_vm._v("\n      Change Password\n    ")]),_vm._v(" "),_c('f7-nav-right',[_c('f7-link',{attrs:{"popup-close":""}},[_c('f7-icon',{attrs:{"material":"close","size":"30"}})],1)],1)],1),_vm._v(" "),_c('f7-list',{attrs:{"inset":""}},[_c('f7-list-item',{attrs:{"item-input":""}},[_c('f7-input',{attrs:{"type":"password","placeholder":"Current Password","value":_vm.currentPassword,"autocomplete":"new-password"},on:{"input":function($event){_vm.currentPassword = $event.target.value;}}}),_vm._v(" "),(_vm.errorMessageCurrent)?_c('div',{staticStyle:{"color":"red","font-size":"14px","margin-top":"4px"}},[_vm._v(_vm._s(_vm.errorMessageCurrent))]):_vm._e()],1)],1),_vm._v(" "),_c('f7-list',{attrs:{"inset":""}},[_c('f7-list-item',{attrs:{"item-input":""}},[_c('f7-input',{attrs:{"type":"password","placeholder":"New Password","value":_vm.newPassword,"errorMessage":"Testar2","autocomplete":"new-password"},on:{"input":function($event){_vm.newPassword = $event.target.value;}}}),_vm._v(" "),(_vm.errorMessageNew)?_c('div',{staticStyle:{"color":"red","font-size":"14px","margin-top":"4px"}},[_vm._v(_vm._s(_vm.errorMessageNew))]):_vm._e()],1),_vm._v(" "),_c('f7-list-item',{attrs:{"item-input":""}},[_c('f7-input',{attrs:{"type":"password","placeholder":"Confirm New Password","value":_vm.confirmPassword,"errorMessage":_vm.errorMessageConfirm,"autocomplete":"new-password"},on:{"input":function($event){_vm.confirmPassword = $event.target.value;}}}),_vm._v(" "),(_vm.errorMessageConfirm)?_c('div',{staticStyle:{"color":"red","font-size":"14px","margin-top":"4px"}},[_vm._v(_vm._s(_vm.errorMessageConfirm))]):_vm._e()],1)],1),_vm._v(" "),_c('f7-list',{attrs:{"inset":""}},[_c('f7-list-button',{on:{"click":_vm.save}},[(!_vm.saveInProgress)?_c('span',[_vm._v("Change")]):_vm._e(),_vm._v(" "),(_vm.saveInProgress)?_c('f7-preloader'):_vm._e()],1)],1)],1)};
	var __vue_staticRenderFns__$2u = [];

	  /* style */
	  var __vue_inject_styles__$2x = undefined;
	  /* scoped */
	  var __vue_scope_id__$2x = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$2x = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$2x = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$2x = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$2u, staticRenderFns: __vue_staticRenderFns__$2u },
	    __vue_inject_styles__$2x,
	    __vue_script__$2v,
	    __vue_scope_id__$2x,
	    __vue_is_functional_template__$2x,
	    __vue_module_identifier__$2x,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//

	var script$2w = {
	  data: function data() {
	    var self = this;

	    document.addEventListener('DOMNodeInserted', function () {
	      var items = document.querySelectorAll('.pac-item');
	      items.forEach(function (i) {
	        i.classList.add("no-fastclick");
	      });
	    });

	    var store = new Store(self, {
	      postNow: ['reviewchannel', 'create'],
	      postNowFinished: function () {
	        self.$root.loggedInUser.get();
	        Brief$1.viewPopup.router.navigate('/onboarding/number/');
	      }
	    });

	    return {
	      foundPlaceId: null,
	      store: store
	    }
	  },
	  mounted: function mounted() {
	    var self = this;

	    this.$nextTick(function () {
	      self.findBusinessInput = document.querySelectorAll('.find-business-input > input')[0];
	      var findBusinessMap = document.querySelectorAll('.find-business-map')[0];

	      var autocomplete = new google.maps.places.Autocomplete(self.findBusinessInput, { 
	        fields: ['place_id', 'geometry', 'name'],
	        types: ['establishment'],
	        componentRestrictions: { country: "se" },
	      });          

	      autocomplete.addListener("place_changed", function () {
	        var place = autocomplete.getPlace();          
	        if (!place.place_id)
	          { return; }

	        var mapUrl = "https://www.google.com/maps/embed/v1/place?key=AIzaSyB1C2-KRFqmdsp4qdOlnn6B1IhCKh0J-LU&q=place_id:" + (place.place_id);

	        findBusinessMap.src = mapUrl;  

	        self.foundPlaceId = place.place_id;
	        self.foundPlaceName = place.name;
	      });               
	    });      
	  },
	  computed: {
	    foundBusiness: function foundBusiness() {
	      return this.foundPlaceId && this.foundPlaceId !== '';
	    }
	  },
	  methods: {
	    next: function next() {
	      this.store.postNow({ 
	        placeId: this.foundPlaceId, 
	        name: this.foundPlaceName 
	      });
	    },
	    inputChanged: function inputChanged(value) {
	      if (value === '')
	        { this.reset(); }
	    },
	    reset: function reset() {
	      var self = this;

	      self.foundPlaceId = null;
	      self.foundPlaceName = null;

	      if (self.findBusinessInput) {
	        self.findBusinessInput.value = '';
	        self.findBusinessInput.focus();
	      }
	    }
	  }
	};

	/* script */
	var __vue_script__$2w = script$2w;

	/* template */
	var __vue_render__$2v = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f7-page',{staticClass:"onboarding"},[_c('f7-block',{directives:[{name:"show",rawName:"v-show",value:(!_vm.foundBusiness),expression:"!foundBusiness"}]},[_c('h1',[_vm._v("Welcome")])]),_vm._v(" "),_c('f7-block',{directives:[{name:"show",rawName:"v-show",value:(!_vm.foundBusiness),expression:"!foundBusiness"}]},[_c('h4',[_vm._v("Before you can start sending review invitations, we need to find your Google Business Profile")])]),_vm._v(" "),_c('f7-list',{directives:[{name:"show",rawName:"v-show",value:(!_vm.foundBusiness),expression:"!foundBusiness"}],attrs:{"inset":"","no-hairlines":""}},[_c('f7-list-item',[_c('f7-label',[_vm._v("Search for your business name:")]),_vm._v(" "),_c('f7-input',{staticClass:"find-business-input",attrs:{"type":"text","placeholder":"Example: Peters Auto","clear-button":""},on:{"input":function($event){return _vm.inputChanged($event.target.value)}}})],1)],1),_vm._v(" "),_c('f7-block',{directives:[{name:"show",rawName:"v-show",value:(_vm.foundBusiness),expression:"foundBusiness"}]},[_c('h1',[_vm._v("Is this your business?")]),_vm._v(" "),_c('div',{staticStyle:{"position":"relative","height":"300px","background-color":"#f7f7f8","display":"flex","justify-content":"center","align-items":"center"}},[_c('f7-preloader'),_vm._v(" "),_c('iframe',{staticClass:"find-business-map",staticStyle:{"width":"100%","height":"300px","position":"absolute","top":"0","left":"0"},attrs:{"frameborder":"0"}})],1)]),_vm._v(" "),_c('f7-block',{directives:[{name:"show",rawName:"v-show",value:(_vm.foundBusiness),expression:"foundBusiness"}],staticClass:"bottom"},[_c('f7-button',{attrs:{"big":"","fill":""},on:{"click":_vm.next}},[_vm._v("Yes, this is my business")]),_vm._v(" "),_c('f7-button',{attrs:{"big":""},on:{"click":_vm.reset}},[_vm._v("No, try again")])],1)],1)};
	var __vue_staticRenderFns__$2v = [];

	  /* style */
	  var __vue_inject_styles__$2y = undefined;
	  /* scoped */
	  var __vue_scope_id__$2y = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$2y = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$2y = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$2y = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$2v, staticRenderFns: __vue_staticRenderFns__$2v },
	    __vue_inject_styles__$2y,
	    __vue_script__$2w,
	    __vue_scope_id__$2y,
	    __vue_is_functional_template__$2y,
	    __vue_module_identifier__$2y,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//

	var phoneParser$1 = new AsYouType$1('SE');

	var script$2x = {
	  data: function data() {
	    var this$1 = this;

	    var self = this;
	    
	    var store = new Store(self, {
	      postNow: ['smschannel', 'create'],
	      postNowFinished: function () {
	        self.$root.loggedInUser.get();
	        this$1.isLoading = false;
	      }
	    });

	    store.postNow();

	    return {
	      store: store,
	      isLoading: true
	    }
	  },
	  methods: {
	    copyToClipboard: function copyToClipboard() {
	      navigator.clipboard.writeText(this.phoneNumber);
	      Brief$1.showPreloader('Copy To Clipboard');
	      setTimeout(function () {
	        Brief$1.hidePreloader();
	      }, 1000);
	    }
	  },
	  computed: {
	    phoneNumber: function phoneNumber() {
	      phoneParser$1.reset();
	      return phoneParser$1.input(this.store.phoneNumber) || '';
	    }
	  }
	};

	/* script */
	var __vue_script__$2x = script$2x;

	/* template */
	var __vue_render__$2w = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f7-page',{staticClass:"onboarding"},[_c('f7-block',[_c('h1',[_vm._v("\n      New Phone Number\n    ")]),_vm._v(" "),_c('h4',[_vm._v("Here is your business phone number that will be used to send and receive text messages from your customers")]),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","flex-direction":"column","justify-content":"center","align-items":"center","background-color":"#fff","border-radius":"8px","padding":"16px 0","width":"100%","gap":"16px"}},[(_vm.isLoading)?_c('f7-preloader'):_vm._e(),_vm._v(" "),(!_vm.isLoading)?_c('label',{staticStyle:{"width":"100%","font-size":"34px","text-align":"center"}},[_vm._v(_vm._s(_vm.phoneNumber))]):_vm._e(),_vm._v(" "),(!_vm.isLoading)?_c('f7-button',{staticStyle:{"border":"none"},attrs:{"href":"#"},on:{"click":_vm.copyToClipboard}},[_vm._v("Copy To Clipboard")]):_vm._e()],1)]),_vm._v(" "),(!_vm.isLoading)?_c('f7-block',{staticClass:"bottom"},[_c('f7-button',{attrs:{"big":"","fill":"","href":"/onboarding/notifications/","view":".popup-main-view"}},[_vm._v("Next")])],1):_vm._e()],1)};
	var __vue_staticRenderFns__$2w = [];

	  /* style */
	  var __vue_inject_styles__$2z = undefined;
	  /* scoped */
	  var __vue_scope_id__$2z = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$2z = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$2z = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$2z = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$2w, staticRenderFns: __vue_staticRenderFns__$2w },
	    __vue_inject_styles__$2z,
	    __vue_script__$2x,
	    __vue_scope_id__$2z,
	    __vue_is_functional_template__$2z,
	    __vue_module_identifier__$2z,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//

	var script$2y = {
	  data: function data() {
	    return {
	      inProgress: false
	    }
	  },
	  methods: {
	    enableNotifications: function enableNotifications() {
	      var self = this;
	      self.inProgress = true;
	      PushNotifications.requestPermission(function () {
	        self.inProgress = false;
	        self.next();
	      });
	    },
	    notNow: function notNow() {
	      var self = this;
	      PushNotifications.setNotNow();
	      self.next();
	    },
	    next: function next() {
	      Brief$1.viewPopup.router.navigate('/onboarding/done/');
	    }
	  },
	};

	/* script */
	var __vue_script__$2y = script$2y;

	/* template */
	var __vue_render__$2x = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f7-page',{staticClass:"onboarding"},[_c('f7-block',[_c('h1',[_vm._v("\n      Notifications\n    ")]),_vm._v(" "),_c('h4',[_vm._v("Enable notifications to get notified when receiving text messages from customers")]),_vm._v(" "),_c('div',{staticClass:"center-content"},[_c('f7-icon',{staticStyle:{"color":"#7113ff"},attrs:{"material":"notifications","size":"180"}})],1)]),_vm._v(" "),_c('f7-block',{staticClass:"bottom"},[_c('f7-button',{attrs:{"big":"","fill":""},on:{"click":_vm.enableNotifications}},[(!_vm.inProgress)?_c('span',[_vm._v("Enable Notifications")]):_vm._e(),_vm._v(" "),(_vm.inProgress)?_c('f7-preloader',{attrs:{"color":"white"}}):_vm._e()],1),_vm._v(" "),_c('f7-button',{attrs:{"big":""},on:{"click":_vm.notNow}},[_vm._v("Not Now")])],1)],1)};
	var __vue_staticRenderFns__$2x = [];

	  /* style */
	  var __vue_inject_styles__$2A = undefined;
	  /* scoped */
	  var __vue_scope_id__$2A = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$2A = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$2A = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$2A = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$2x, staticRenderFns: __vue_staticRenderFns__$2x },
	    __vue_inject_styles__$2A,
	    __vue_script__$2y,
	    __vue_scope_id__$2A,
	    __vue_is_functional_template__$2A,
	    __vue_module_identifier__$2A,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	/* script */

	/* template */
	var __vue_render__$2y = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f7-page',{staticClass:"onboarding"},[_c('f7-block',[_c('h1',[_vm._v("\n      Success\n    ")]),_vm._v(" "),_c('h4',[_vm._v("You are ready to send your first review invite")]),_vm._v(" "),_c('div',{staticClass:"center-content",staticStyle:{"padding-top":"24px"}},[_c('common-checkmark',{staticStyle:{"width":"180px","height":"180px"},attrs:{"checked":true}})],1)]),_vm._v(" "),_c('f7-block',{staticClass:"bottom"},[_c('f7-button',{attrs:{"big":"","fill":"","popup-close":""}},[_vm._v("Get Started")])],1)],1)};
	var __vue_staticRenderFns__$2y = [];

	  /* style */
	  var __vue_inject_styles__$2B = undefined;
	  /* scoped */
	  var __vue_scope_id__$2B = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$2B = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$2B = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$2B = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$2y, staticRenderFns: __vue_staticRenderFns__$2y },
	    __vue_inject_styles__$2B,
	    {},
	    __vue_scope_id__$2B,
	    __vue_is_functional_template__$2B,
	    __vue_module_identifier__$2B,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	/* script */

	/* template */
	var __vue_render__$2z = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f7-page')};
	var __vue_staticRenderFns__$2z = [];

	  /* style */
	  var __vue_inject_styles__$2C = undefined;
	  /* scoped */
	  var __vue_scope_id__$2C = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$2C = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$2C = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$2C = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$2z, staticRenderFns: __vue_staticRenderFns__$2z },
	    __vue_inject_styles__$2C,
	    {},
	    __vue_scope_id__$2C,
	    __vue_is_functional_template__$2C,
	    __vue_module_identifier__$2C,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//

	var script$2z = {
	  data: function data() {
	    var self = this;

	    var storeUsers = new Store(self, {
	      get: ['user', 'list'],
	    });

	    return {
	      storeUsers: storeUsers,
	    };
	  },
	  mounted: function mounted() {
	    var self = this;
	    Brief$1.events.$on(['user-deleted', 'user-invited'], self.storeUsers.reload);
	    self.storeUsers.get();
	  },
	  beforeDestroy: function beforeDestroy() {
	    var self = this;
	    Brief$1.events.$off(['user-deleted', 'user-invited'], self.storeUsers.reload);
	    self.storeUsers.dispose();
	  },
	  methods: {

	  },
	};

	/* script */
	var __vue_script__$2z = script$2z;

	/* template */
	var __vue_render__$2A = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f7-page',[_c('f7-navbar',[_c('f7-nav-left',[_c('common-nav-placeholder')],1),_vm._v(" "),_c('f7-nav-title',[_vm._v("\n      Manage Users\n    ")]),_vm._v(" "),_c('f7-nav-right',[_c('f7-link',{attrs:{"popup-close":""}},[_c('f7-icon',{attrs:{"material":"close","size":"30"}})],1)],1)],1),_vm._v(" "),((_vm.storeUsers.users && _vm.storeUsers.users.length && !_vm.storeUsers.isLoading))?_c('f7-list',{staticStyle:{"margin-bottom":"80px"},attrs:{"inset":""}},_vm._l((_vm.storeUsers.users),function(user){return _c('f7-list-item',{key:user.id,attrs:{"header":user.isAdmin ? 'Admin' : null,"title":user.isVerified ? user.fullName : user.email,"footer":user.isVerified ? user.lastActiveString : 'Waiting for person to accept invite',"link":user.isVerified ? ("/user/" + (user.id) + "/") : ("/user/invite/" + (user.id) + "/")}},[_c('common-avatar',{attrs:{"slot":"media","avatar":user.photoFile},slot:"media"})],1)}),1):_vm._e(),_vm._v(" "),((_vm.storeUsers.users && !_vm.storeUsers.users.length && !_vm.storeUsers.isLoading))?_c('f7-block',[_c('div',{staticStyle:{"text-align":"center","padding-top":"34px"}},[_c('f7-icon',{staticStyle:{"color":"rgba(0, 0, 0, 0.25)"},attrs:{"material":"person_add","size":"230"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"rgba(0, 0, 0, 0.4)","display":"block","font-size":"16px","font-weight":"bold"}},[_vm._v("No users yet. Start inviting your team below.")])],1)]):_vm._e(),_vm._v(" "),(!_vm.storeUsers.users && _vm.storeUsers.isLoading)?_c('div',{staticClass:"center-content",staticStyle:{"height":"70%"}},[_c('f7-preloader',{attrs:{"size":"68px"}})],1):_vm._e(),_vm._v(" "),_c('f7-block',{staticStyle:{"position":"fixed","width":"100%","bottom":"0"}},[_c('f7-button',{staticStyle:{"display":"flex","justify-content":"center","align-items":"center"},attrs:{"href":"/user/invite/","big":"","fill":""}},[_vm._v("\n      Invite User\n    ")])],1)],1)};
	var __vue_staticRenderFns__$2A = [];

	  /* style */
	  var __vue_inject_styles__$2D = undefined;
	  /* scoped */
	  var __vue_scope_id__$2D = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$2D = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$2D = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$2D = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$2A, staticRenderFns: __vue_staticRenderFns__$2A },
	    __vue_inject_styles__$2D,
	    __vue_script__$2z,
	    __vue_scope_id__$2D,
	    __vue_is_functional_template__$2D,
	    __vue_module_identifier__$2D,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//

	var script$2A = {
	  data: function data() {
	    var self = this;
	    var userId = self.$f7route.params.id;

	    var storeGet = new Store(self, {
	      get: ['user', 'get', { userId: userId }],
	    });

	    var storeDelete = new Store(self, {
	      postNow: ['teamuser', 'delete', { id: userId }],
	      postNowFinished: function postNowFinished(result) {
	        self.deleteInProgress = false;
	        if (result.success) {
	          Brief$1.events.$emit('user-deleted');
	          Brief$1.viewPopup.router.back();
	        }
	      },
	    });

	    return {
	      storeGet: storeGet,
	      storeDelete: storeDelete,
	      deleteInProgress: false,
	      isLoggedInUserAdmin: self.$root.loggedInUser.isAdmin,
	    };
	  },
	  mounted: function mounted() {
	    var self = this;
	    self.storeGet.get();
	  },
	  beforeDestroy: function beforeDestroy() {
	    var self = this;
	    self.storeGet.dispose();
	    self.storeDelete.dispose();
	  },
	  computed: {
	    fullName: function fullName() {
	      var self = this;

	      if (!self.storeGet.fullName)
	        { return ''; }

	      return self.storeGet.fullName;
	    },
	    photoUrl: function photoUrl() {
	      var self = this;

	      var imageSize = Brief$1.f7.device.pixelRatio > 1 ? '400' : '200';
	      return self.path.imageUrl(
	        self.storeGet.photoFile ? self.storeGet.photoFile.filename : 'avatar.png',
	        ("h=" + imageSize + "&autorotate=true")
	      );
	    },
	  },
	  methods: {
	    deleteUser: function deleteUser() {
	      var self = this;

	      Brief$1.f7.dialog.confirm(("Are you sure you want to delete user " + (self.fullName) + "?"), function () {
	        self.deleteInProgress = true;
	        self.storeDelete.postNow();
	      });
	    },
	  },
	};

	/* script */
	var __vue_script__$2A = script$2A;

	/* template */
	var __vue_render__$2B = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f7-page',[_c('f7-navbar',[_c('f7-nav-left',[_c('f7-link',{attrs:{"back":""}},[_c('f7-icon',{attrs:{"material":"arrow_back","size":"30"}})],1)],1),_vm._v(" "),_c('f7-nav-title',[_vm._v("\n      "+_vm._s(_vm.fullName)+"\n    ")]),_vm._v(" "),_c('f7-nav-right',[_c('f7-link',{attrs:{"popup-close":""}},[_c('f7-icon',{attrs:{"material":"close","size":"30"}})],1)],1)],1),_vm._v(" "),_c('f7-block',{staticStyle:{"margin-top":"0"}},[_c('span',{staticClass:"user-photo-image",style:('background-image: url(' + _vm.photoUrl + ')')})]),_vm._v(" "),_c('div',{staticClass:"shadow-content",staticStyle:{"margin":"0 16px"}},[(_vm.storeGet.isAdmin)?_c('f7-block-title',{staticClass:"block-title-sticky",staticStyle:{"color":"#7113ff"}},[_c('span',[_vm._v("Admin")])]):_vm._e(),_vm._v(" "),_c('f7-list',[_c('f7-list-item',{attrs:{"title":_vm.storeGet.firstName}}),_vm._v(" "),_c('f7-list-item',{attrs:{"title":_vm.storeGet.lastName}}),_vm._v(" "),_c('f7-list-item',{attrs:{"title":_vm.storeGet.email}}),_vm._v(" "),(_vm.storeGet.lastActiveString)?_c('f7-list-item',{style:(("color: " + (_vm.storeGet.lastActiveString === 'Online' ? 'green' : 'orange'))),attrs:{"title":_vm.storeGet.lastActiveString}}):_vm._e()],1)],1),_vm._v(" "),(_vm.isLoggedInUserAdmin)?_c('f7-list',{attrs:{"inset":""}},[_c('f7-list-button',{attrs:{"color":"red"},on:{"click":_vm.deleteUser}},[(!_vm.deleteInProgress)?_c('span',[_vm._v("Delete User")]):_vm._e(),_vm._v(" "),(_vm.deleteInProgress)?_c('f7-preloader'):_vm._e()],1)],1):_vm._e()],1)};
	var __vue_staticRenderFns__$2B = [];

	  /* style */
	  var __vue_inject_styles__$2E = undefined;
	  /* scoped */
	  var __vue_scope_id__$2E = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$2E = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$2E = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$2E = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$2B, staticRenderFns: __vue_staticRenderFns__$2B },
	    __vue_inject_styles__$2E,
	    __vue_script__$2A,
	    __vue_scope_id__$2E,
	    __vue_is_functional_template__$2E,
	    __vue_module_identifier__$2E,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//

	var script$2B = {
	  data: function data() {
	    var self = this;

	    var storeInvite = new Store(self, {
	      postNow: ['people', 'invite'],
	      postNowFinished: function postNowFinished(result) {
	        self.inviteInProgress = false;
	        if (result.success) {
	          Brief$1.events.$emit('user-invited');
	          Brief$1.viewPopup.router.back();
	        }
	      },
	    });

	    return {
	      storeInvite: storeInvite,
	      inviteInProgress: false,
	      email: ''
	    };
	  },
	  beforeDestroy: function beforeDestroy() {
	    var self = this;
	    self.storeInvite.dispose();
	  },
	  methods: {
	    inviteUser: function inviteUser() {
	      var self = this;

	      if (!isValidEmail(self.email)) {
	        Brief$1.notify('Error', 'Invalid email');
	        return;
	      }

	      self.inviteInProgress = true;
	      self.storeInvite.postNow({ email: self.email });
	    },
	  },
	};

	function isValidEmail(email) {
	  var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	  return re.test(email);
	}

	/* script */
	var __vue_script__$2B = script$2B;

	/* template */
	var __vue_render__$2C = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f7-page',[_c('f7-navbar',[_c('f7-nav-left',[_c('f7-link',{attrs:{"back":""}},[_c('f7-icon',{attrs:{"material":"arrow_back","size":"30"}})],1)],1),_vm._v(" "),_c('f7-nav-title',[_vm._v("\n      Invite User\n    ")]),_vm._v(" "),_c('f7-nav-right',[_c('f7-link',{attrs:{"popup-close":""}},[_c('f7-icon',{attrs:{"material":"close","size":"30"}})],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"shadow-content",staticStyle:{"margin":"0 16px"}},[_c('f7-list',[_c('f7-list-item',{attrs:{"item-input":""}},[_c('f7-input',{attrs:{"type":"email","placeholder":"Email","value":_vm.email},on:{"input":function($event){_vm.email = $event.target.value;}}})],1)],1)],1),_vm._v(" "),_c('f7-list',{attrs:{"inset":""}},[_c('f7-list-button',{on:{"click":_vm.inviteUser}},[(!_vm.inviteInProgress)?_c('span',[_vm._v("Invite")]):_vm._e(),_vm._v(" "),(_vm.inviteInProgress)?_c('f7-preloader'):_vm._e()],1)],1)],1)};
	var __vue_staticRenderFns__$2C = [];

	  /* style */
	  var __vue_inject_styles__$2F = undefined;
	  /* scoped */
	  var __vue_scope_id__$2F = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$2F = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$2F = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$2F = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$2C, staticRenderFns: __vue_staticRenderFns__$2C },
	    __vue_inject_styles__$2F,
	    __vue_script__$2B,
	    __vue_scope_id__$2F,
	    __vue_is_functional_template__$2F,
	    __vue_module_identifier__$2F,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//

	var script$2C = {
	  data: function data() {
	    var self = this;
	    var inviteId = self.$f7route.params.id;

	    var storeGet = new Store(self, {
	      get: ['user', 'invite', { id: inviteId }],
	    });

	    var storeInvite = new Store(self, {
	      postNow: ['people', 'invite'],
	      postNowFinished: function postNowFinished(result) {
	        self.resendInProgress = false;
	        if (result.success) {
	          Brief$1.events.$emit('user-invited');
	          Brief$1.viewPopup.router.back();
	        }
	      },
	    });

	    var storeDelete = new Store(self, {
	      postNow: ['user', 'invitedelete', { id: inviteId }],
	      postNowFinished: function postNowFinished(result) {
	        self.deleteInProgress = false;
	        if (result.success) {
	          Brief$1.events.$emit('user-deleted');
	          Brief$1.viewPopup.router.back();
	        }
	      },
	    });

	    return {
	      storeGet: storeGet,
	      storeInvite: storeInvite,
	      storeDelete: storeDelete,
	      resendInProgress: false,
	      deleteInProgress: false,
	      isLoggedInUserAdmin: self.$root.loggedInUser.isAdmin,
	    };
	  },
	  mounted: function mounted() {
	    var self = this;
	    self.storeGet.get();
	  },
	  beforeDestroy: function beforeDestroy() {
	    var self = this;
	    self.storeGet.dispose();
	    self.storeDelete.dispose();
	  },
	  methods: {
	    resendInvite: function resendInvite() {
	      var self = this;

	      self.resendInProgress = true;
	      self.storeInvite.postNow({ email: self.storeGet.email });
	    },
	    deleteInvite: function deleteInvite() {
	      var self = this;

	      Brief$1.f7.dialog.confirm(("Are you sure you want to delete invite for email " + (self.storeGet.email) + "?"), function () {
	        self.deleteInProgress = true;
	        self.storeDelete.postNow();
	      });
	    },
	  },
	};

	/* script */
	var __vue_script__$2C = script$2C;

	/* template */
	var __vue_render__$2D = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f7-page',[_c('f7-navbar',[_c('f7-nav-left',[_c('f7-link',{attrs:{"back":""}},[_c('f7-icon',{attrs:{"material":"arrow_back","size":"30"}})],1)],1),_vm._v(" "),_c('f7-nav-title',[_vm._v("\n      User Invite\n    ")]),_vm._v(" "),_c('f7-nav-right',[_c('f7-link',{attrs:{"popup-close":""}},[_c('f7-icon',{attrs:{"material":"close","size":"30"}})],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"shadow-content",staticStyle:{"margin":"0 16px"}},[_c('f7-list',[_c('f7-list-item',{attrs:{"title":_vm.storeGet.email}}),_vm._v(" "),(_vm.storeGet.invitedBy)?_c('f7-list-item',{attrs:{"title":("Invited by: " + (_vm.storeGet.invitedBy))}}):_vm._e(),_vm._v(" "),_c('f7-list-item',{staticStyle:{"color":"#7113ff"},attrs:{"title":"Waiting for person to accept invite"}})],1)],1),_vm._v(" "),_c('f7-list',{attrs:{"inset":""}},[_c('f7-list-button',{on:{"click":_vm.resendInvite}},[(!_vm.resendInProgress)?_c('span',[_vm._v("Resend Invite")]):_vm._e(),_vm._v(" "),(_vm.resendInProgress)?_c('f7-preloader'):_vm._e()],1)],1),_vm._v(" "),(_vm.isLoggedInUserAdmin)?_c('f7-list',{attrs:{"inset":""}},[_c('f7-list-button',{attrs:{"color":"red"},on:{"click":_vm.deleteInvite}},[(!_vm.deleteInProgress)?_c('span',[_vm._v("Delete Invite")]):_vm._e(),_vm._v(" "),(_vm.deleteInProgress)?_c('f7-preloader'):_vm._e()],1)],1):_vm._e()],1)};
	var __vue_staticRenderFns__$2D = [];

	  /* style */
	  var __vue_inject_styles__$2G = undefined;
	  /* scoped */
	  var __vue_scope_id__$2G = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$2G = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$2G = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$2G = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$2D, staticRenderFns: __vue_staticRenderFns__$2D },
	    __vue_inject_styles__$2G,
	    __vue_script__$2C,
	    __vue_scope_id__$2G,
	    __vue_is_functional_template__$2G,
	    __vue_module_identifier__$2G,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	var leftViewRoutes = [
	  // Channel List
	  {
	    path: '/channel/list/',
	    component: __vue_component__$18,
	  },
	  {
	    path: '/conversation/list/',
	    component: __vue_component__$2r,
	  } ];

	var popupViewRoutes = [
	  {
	    path: '/user/settings/',
	    component: __vue_component__$1h,
	  },
	  {
	    path: '/users/settings/',
	    component: __vue_component__$2D,
	  },
	  {
	    path: '/user/invite/',
	    component: __vue_component__$2F,
	  },
	  {
	    path: '/user/invite/:id/',
	    component: __vue_component__$2G,
	  },
	  {
	    path: '/user/:id/',
	    component: __vue_component__$2E,
	  },
	  {
	    path: '/company/settings/',
	    component: __vue_component__$12,
	  },
	  {
	    path: '/setting/list/',
	    component: __vue_component__$2u,
	  },
	  {
	    path: '/notification/settings/',
	    component: __vue_component__$2v,
	  },
	  {
	    path: '/subscription/settings/',
	    component: __vue_component__$2w,
	  },   
	  {
	    path: '/password/settings/',
	    component: __vue_component__$2x,
	  },
	  {
	    path: '/plan/settings',
	    component: __vue_component__$13,
	  },
	  {
	    path: '/onboarding/find-business/',
	    component: __vue_component__$2y,
	  },      
	  {
	    path: '/onboarding/number/',
	    component: __vue_component__$2z,
	  },
	  {
	    path: '/onboarding/notifications/',
	    component: __vue_component__$2A,
	  },
	  {
	    path: '/onboarding/done/',
	    component: __vue_component__$2B,
	  },
	  {
	    path: '/sms/:channelId/assign/:conversationId/',
	    component: __vue_component__$2t,
	  },
	  {
	    path: '/email/:channelId/assign/:conversationId/',
	    component: __vue_component__$1o,
	  },
	  {
	    path: '/website/:channelId/assign/:conversationId/',
	    component: __vue_component__$2c,
	  },
	  {
	    path: '/facebook/:channelId/assign/:conversationId/',
	    component: __vue_component__$1D,
	  },
	  {
	    path: '/instagram/:channelId/assign/:conversationId/',
	    component: __vue_component__$1X,
	  },
	  // Replies
	  {
	    path: '/replies/add/',
	    component: __vue_component__$2o,
	  },
	  {
	    path: '/replies/add/:channelId?/',
	    component: __vue_component__$2o,
	  },
	  {
	    path: '/replies/list/:channelId/',
	    component: __vue_component__$2n,
	  },
	  {
	    path: '/replies/edit/:id/:channelId?/',
	    component: __vue_component__$2p,
	  } ];

	var mainViewRoutes = [
	  {
	    path: '/',
	    component: __vue_component__$2C,
	  },
	  {
	    path: '/conversation/list/',
	    component: __vue_component__$2r,
	  },
	  {
	    path: '/message/list/:type/:channelId/:conversationId',
	    component: __vue_component__$2s,
	  },
	  {
	    path: '/posts/',
	    component: __vue_component__$1b,
	  },
	  {
	    path: '/statistics/',
	    component: __vue_component__$16,
	  },
	  {
	    path: '/thread/:id/',
	    component: __vue_component__$15,
	  },
	  {
	    path: '/team/add/',
	    component: __vue_component__$X,
	  },
	  {
	    path: '/team/signup/',
	    component: __vue_component__$Y,
	  },
	  {
	    path: '/team/forgot/',
	    component: __vue_component__$Z,
	  },
	  {
	    path: '/account/settings/',
	    component: __vue_component__$W,
	  },
	  // {
	  //   path: '/team/billing/',
	  //   component: teamBilling,
	  // },
	  // {
	  //   path: '/team/statistics/',
	  //   component: teamStatistics,
	  // },
	  // {
	  //   path: '/team/invoices/',
	  //   component: invoices,
	  // },
	  // {
	  //   path: '/team/payment-method/',
	  //   component: paymentMethod,
	  // },
	  // {
	  //   path: '/team/select-plan/',
	  //   component: selectPlan,
	  // },
	  {
	    path: '/account/reset/(.*)',
	    component: __vue_component__$_,
	  },
	  {
	    path: '/account/verify/(.*)',
	    component: __vue_component__$10,
	  },
	  {
	    path: '/channel/add/',
	    component: __vue_component__$19,
	  },
	  // Notifications
	  {
	    path: '/all-messages/',
	    component: __vue_component__$1a,
	  },
	  // Email channel
	  {
	    path: '/email/select/',
	    component: __vue_component__$1i,
	  },
	  {
	    path: '/email/add/',
	    component: __vue_component__$1j,
	  },
	  {
	    path: '/email/create/',
	    component: __vue_component__$1t,
	  },
	  {
	    path: '/email/create-gmail/',
	    component: __vue_component__$1k,
	  },
	  {
	    path: '/email/permission-gmail/',
	    component: __vue_component__$1l,
	  },
	  {
	    path: '/email/:channelId/create/',
	    component: __vue_component__$1t,
	  },
	  {
	    path: '/email/:channelId/settings/',
	    component: __vue_component__$1m,
	  },
	  {
	    path: '/email/:channelId/join/',
	    component: __vue_component__$1p,
	  },
	  {
	    path: '/email/:channelId/invite/',
	    component: __vue_component__$1n,
	  },
	  {
	    path: '/email/:channelId/signature/',
	    component: __vue_component__$1q,
	  },
	  {
	    path: '/email/:channelId/members/',
	    component: __vue_component__$1r,
	  },
	  {
	    path: '/email/:channelId/notifications/',
	    component: __vue_component__$1s,
	  },
	  {
	    path: '/email/:channelId/info/',
	    component: __vue_component__$1w,
	  },
	  {
	    path: '/email/:channelId/autoreply/',
	    component: __vue_component__$1x,
	  },
	  {
	    path: '/email/:channelId/waitlimit/',
	    component: __vue_component__$1y,
	  },
	  {
	    path: '/email/:channelId/account/',
	    component: __vue_component__$1z,
	  },
	  {
	    path: '/email/:channelId/',
	    component: __vue_component__$1v,
	  },
	  {
	    path: '/email/:channelId/:conversationId/',
	    component: __vue_component__$1u,
	  },

	  // Facebook channel
	  {
	    path: '/facebook/select/',
	    component: __vue_component__$1A,
	  },
	  {
	    path: '/facebook/add/:pageId/',
	    component: __vue_component__$1B,
	  },
	  {
	    path: '/facebook/:channelId/settings/',
	    component: __vue_component__$1F,
	  },
	  {
	    path: '/facebook/:channelId/join/',
	    component: __vue_component__$1E,
	  },
	  {
	    path: '/facebook/:channelId/invite/',
	    component: __vue_component__$1C,
	  },
	  {
	    path: '/facebook/:channelId/signature/',
	    component: __vue_component__$1G,
	  },
	  {
	    path: '/facebook/:channelId/members/',
	    component: __vue_component__$1H,
	  },
	  {
	    path: '/facebook/:channelId/notifications/',
	    component: __vue_component__$1I,
	  },
	  {
	    path: '/facebook/:channelId/info/',
	    component: __vue_component__$1L,
	  },
	  {
	    path: '/facebook/:channelId/autoreply/',
	    component: __vue_component__$1M,
	  },
	  {
	    path: '/facebook/:channelId/waitlimit/',
	    component: __vue_component__$1N,
	  },
	  {
	    path: '/facebook/:channelId/',
	    component: __vue_component__$1J,
	  },
	  {
	    path: '/facebook/:channelId/:conversationId/',
	    component: __vue_component__$1K,
	  },

	  // Instagram channel
	  {
	    path: '/instagram/select/',
	    component: __vue_component__$1O,
	  },
	  {
	    path: '/instagram/add/:pageId/',
	    component: __vue_component__$1P,
	  },
	  {
	    path: '/instagram/:channelId/',
	    component: __vue_component__$1Q,
	  },
	  {
	    path: '/instagram/:channelId/settings/',
	    component: __vue_component__$1S,
	  },
	  {
	    path: '/instagram/:channelId/notifications/',
	    component: __vue_component__$1U,
	  },
	  {
	    path: '/instagram/:channelId/members/',
	    component: __vue_component__$1T,
	  },
	  {
	    path: '/instagram/:channelId/join/',
	    component: __vue_component__$1V,
	  },
	  {
	    path: '/instagram/:channelId/invite/',
	    component: __vue_component__$1W,
	  },
	  {
	    path: '/instagram/:channelId/info/',
	    component: __vue_component__$1Y,
	  },
	  {
	    path: '/instagram/:channelId/autoreply/',
	    component: __vue_component__$1Z,
	  },
	  {
	    path: '/instagram/:channelId/waitlimit/',
	    component: __vue_component__$1_,
	  },
	  {
	    path: '/instagram/:channelId/account/',
	    component: __vue_component__$20,
	  },
	  {
	    path: '/instagram/:channelId/:conversationId/',
	    component: __vue_component__$1R,
	  },

	  // Room channel
	  {
	    path: '/room/add/',
	    component: __vue_component__$21,
	  },
	  {
	    path: '/room/:channelId/',
	    component: __vue_component__$28,
	  },
	  {
	    path: '/room/:channelId/settings/',
	    component: __vue_component__$22,
	  },
	  {
	    path: '/room/:channelId/invite/',
	    component: __vue_component__$23,
	  },
	  {
	    path: '/room/:channelId/join/',
	    component: __vue_component__$24,
	  },
	  {
	    path: '/room/:channelId/members/',
	    component: __vue_component__$25,
	  },
	  {
	    path: '/room/:channelId/notifications/',
	    component: __vue_component__$26,
	  },
	  {
	    path: '/room/:channelId/info/',
	    component: __vue_component__$27,
	  },

	  // Website channel
	  {
	    path: '/website/add/',
	    component: __vue_component__$29,
	  },
	  {
	    path: '/website/:channelId/settings/',
	    component: __vue_component__$2a,
	  },
	  {
	    path: '/website/:channelId/invite/',
	    component: __vue_component__$2b,
	  },
	  {
	    path: '/website/:channelId/join/',
	    component: __vue_component__$2d,
	  },
	  {
	    path: '/website/:channelId/',
	    component: __vue_component__$2g,
	  },
	  {
	    path: '/website/:channelId/members/',
	    component: __vue_component__$2e,
	  },
	  {
	    path: '/website/:channelId/notifications/',
	    component: __vue_component__$2f,
	  },
	  {
	    path: '/website/:channelId/info/',
	    component: __vue_component__$2i,
	  },
	  {
	    path: '/website/:channelId/autoreply/',
	    component: __vue_component__$2j,
	  },
	  {
	    path: '/website/:channelId/waitlimit/',
	    component: __vue_component__$2k,
	  },
	  {
	    path: '/website/:channelId/officehours/',
	    component: __vue_component__$2l,
	  },
	  {
	    path: '/website/:channelId/widget/',
	    component: __vue_component__$2m,
	  },
	  // {
	  //   path: '/website/:channelId/:conversationId/',
	  //   component: websiteChat,
	  // },

	  // Posts
	  // {
	  //   path: '/',
	  //   component: postList,
	  // },
	  {
	    path: '/post/:id/',
	    component: __vue_component__$1c,
	  },
	  {
	    path: '/post/:id/likes/',
	    component: __vue_component__$1d,
	  },
	  // Photos
	  {
	    path: '(.*)/photos/',
	    async: function async(to, from, resolve, reject) {
	      var router = this;
	      reject();
	      setTimeout(function () {
	        router.navigate(to.url.split('photos/')[0], { reloadCurrent: true });
	      }, 0);
	    },
	  },
	  {
	    path: '/r/:shortId',
	    component: __vue_component__$V,
	  },

	  // 404
	  {
	    path: '(.*)',
	    component: __vue_component__$2q,
	  } ];

	var loginViewRoutes = [
	  {
	    path: '/account/login/',
	    component: __vue_component__$P,
	  },
	  {
	    path: '/account/signup/',
	    component: __vue_component__$Q,
	  },
	  {
	    path: '/account/forgot/',
	    component: __vue_component__$R,
	  },
	  {
	    path: '/account/reset/(.*)',
	    component: __vue_component__$S,
	  },
	  {
	    path: '/account/verify/(.*)',
	    component: __vue_component__$U,
	  },
	  {
	    path: '/account/notfound/',
	    component: __vue_component__$T,
	  },
	  {
	    path: '/r/:shortId',
	    component: __vue_component__$V,
	  } ];

	function loggedInUserStore (self) {
	  var isOnboardingInitiated = false;
	  var store = new Store(window, {
	    get: ['user', 'get'],
	    getFinished: function () {
	      if (store.onboarding !== undefined && !isOnboardingInitiated) {
	        getStartUrl(store.onboarding, function (startUrl) {
	          if (!startUrl)
	            { return; }
	          Brief$1.f7.popup.open('.popup-main');
	          Brief$1.viewPopup.router.navigate(startUrl, { reloadAll: true });
	          isOnboardingInitiated = true;
	        });
	      }
	    },
	  });
	  return store;
	}

	function getStartUrl(onboarding, callback) {
	  if (onboarding.setupBusiness === false)
	    { return callback('/onboarding/find-business/'); }
	  if (onboarding.setupSms === false)
	    { return callback('/onboarding/number/'); }
	  if (PushNotifications.canAskForPermission(function (canAsk) {
	    return canAsk 
	      ? callback('/onboarding/notifications/') 
	      : callback();
	  }));
	}

	//

	var script$2D = {
	  name: 'AccountSignup',
	  data: function data() {
	    return {
	      inputs: [
	        {
	          type: 'email',
	          name: 'email',
	          placeholder: 'Enter your email',
	        } ],
	    };
	  },
	  methods: {
	    onSuccess: function onSuccess() {
	      var this$1 = this;

	      setTimeout(function () {
	        this$1.goToLogin();
	      }, 200);
	    },
	    goToLogin: function goToLogin() {
	      window.localStorage.setItem('user_id', '');
	      window.localStorage.setItem('team_id', '');
	      window.localStorage.setItem('access_token', '');
	      window.localStorage.setItem('accounts', '[]');
	      window.location = '/account/login';
	    },
	  },
	};

	/* script */
	var __vue_script__$2D = script$2D;

	/* template */
	var __vue_render__$2E = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('common-auth-page',{attrs:{"title":"This is Demo account. Sign up now to create your own team","endpoint":"/account/signup","buttonText":"Sign up","buttonTextSending":"Signing up...","buttonTextSent":"Check your email...","inputs":_vm.inputs,"sendGuid":false},on:{"success":_vm.onSuccess}},[_c('template',{slot:"footer"},[_c('a',{attrs:{"target":"_blank"},on:{"click":function($event){return _vm.goToLogin()}}},[_vm._v("Already have an account?")])])],2)};
	var __vue_staticRenderFns__$2E = [];

	  /* style */
	  var __vue_inject_styles__$2H = undefined;
	  /* scoped */
	  var __vue_scope_id__$2H = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$2H = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$2H = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$2H = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$2E, staticRenderFns: __vue_staticRenderFns__$2E },
	    __vue_inject_styles__$2H,
	    __vue_script__$2D,
	    __vue_scope_id__$2H,
	    __vue_is_functional_template__$2H,
	    __vue_module_identifier__$2H,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	//

	var script$2E = {
	  name: 'App',
	  components: {
	    signup: __vue_component__$2H,
	  },
	  data: function data() {
	    return {
	      isBigScreen: Brief$1.isBigScreen
	    }
	  }
	};

	/* script */
	var __vue_script__$2E = script$2E;

	/* template */
	var __vue_render__$2F = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('f7-statusbar'),_vm._v(" "),(_vm.$root.isLoggedIn)?[_c('f7-view',{attrs:{"main":"","init":false}}),_vm._v(" "),(_vm.isBigScreen)?_c('f7-panel',{attrs:{"left":"","reveal":""}},[_c('f7-view',{staticClass:"view-left",attrs:{"init":false}})],1):_vm._e(),_vm._v(" "),_c('f7-popup',{staticClass:"popup-main"},[_c('f7-view',{staticClass:"popup-main-view"})],1)]:_c('div',{staticClass:"login-screen modal-in"},[_c('f7-view',{staticClass:"view-login",attrs:{"init":false}})],1)],2)};
	var __vue_staticRenderFns__$2F = [];

	  /* style */
	  var __vue_inject_styles__$2I = undefined;
	  /* scoped */
	  var __vue_scope_id__$2I = undefined;
	  /* module identifier */
	  var __vue_module_identifier__$2I = undefined;
	  /* functional template */
	  var __vue_is_functional_template__$2I = false;
	  /* style inject */
	  
	  /* style inject SSR */
	  
	  /* style inject shadow dom */
	  

	  
	  var __vue_component__$2I = /*#__PURE__*/normalizeComponent(
	    { render: __vue_render__$2F, staticRenderFns: __vue_staticRenderFns__$2F },
	    __vue_inject_styles__$2I,
	    __vue_script__$2E,
	    __vue_scope_id__$2I,
	    __vue_is_functional_template__$2I,
	    __vue_module_identifier__$2I,
	    false,
	    undefined,
	    undefined,
	    undefined
	  );

	function Framework7App () {
	  Object.assign(Vue.prototype, config$1);

	  // Install Vue Filters and Directives
	  VueDirectives();

	  // Install Plugin
	  Vue.use(VuePlugin, Framework7);

	  // Touch
	  var isTouchScreen = Utils$1.mobileDevice();

	  // Detect IE
	  if (Utils$1.detectIE() !== false) {
	    $$1('html').addClass('ie');
	  }

	  // Register components
	  Vue.mixin({
	    components: registeredComponents,
	  });

	  // Init App
	  var app = new Vue({
	    el: '#app',
	    components: {
	      App: __vue_component__$2I,
	    },
	    render: function (c) { return c('app'); },
	    framework7: {
	      view: {
	        iosAnimateNavbarBackIcon: true,
	        pushStateSeparator: '',
	        xhrCacheDuration: 86400000,
	        iosSwipeBack: isTouchScreen,
	        iosSwipeBackActiveArea: window.screen.width,
	        iosSwipeBackThreshold: 0,
	        mdSwipeBack: isTouchScreen,
	        mdSwipeBackActiveArea: window.screen.width,
	        mdSwipeBackThreshold: 0,
	        animateWithJS: false,
	      },
	      dialog: {
	        title: 'Brief',
	      },
	      navbar: {
	        scrollTopOnTitleClick: false,
	      },
	      lazy: {
	        placeholder: '',
	        threshold: 200,
	      },
	      panel: {
	        swipe: isTouchScreen ? 'left' : false,
	        swipeActiveArea: window.screen.width - 10,
	        swipeCloseOpposite: false,
	        swipeThreshold: 15,
	        leftBreakpoint: 768,
	        rightBreakpoint: 1367,
	      },
	      sortable: false,
	      swipeout: isTouchScreen ? {} : false,
	      touch: {
	        tapHold: isTouchScreen,
	        tapHoldDelay: 750,
	        tapHoldPreventClicks: true,
	      },
	      statusbar: {
	        scrollTopClick: true,
	        overlay: Framework7.device.ios && Brief$1.isCordova ? true : 'auto',
	      },
	      theme : 'md'
	    },
	    watch: {
	      isLoggedIn: function isLoggedIn(isLoggedIn$1) {
	        var self = this;
	        var f7 = Brief$1.f7;
	        // Login
	        if (isLoggedIn$1) {
	          if (!window.localStorage.getItem('access_token') || !window.localStorage.getItem('accounts')) {
	            self.isLoggedIn = false;
	            return;
	          }
	          if (Brief$1.viewLogin) {
	            Brief$1.viewLogin.destroy();
	            Brief$1.viewLogin = null;
	          }

	          self.loggedInUser.get({ appVersion: 1789668689113 });

	          self.$nextTick(function () {
	            var indexUrlMain = Brief$1.isBigScreen ? '/' : '/conversation/list/';
	            // if (window.location.href.indexOf('/account/verify') >= 0) indexUrl = '/account/verify/';
	            // if (window.location.href.indexOf('/account/reset') >= 0) indexUrl = '/account/reset/';
	            // Main View
	            Brief$1.viewMain = f7.views.create('.view-main', {
	              pushState: !Brief$1.isCordova,
	              pushStateOnLoad: Brief$1.isBigScreen,
	              url: indexUrlMain,
	              routes: mainViewRoutes,
	            });

	            // Reload Method
	            Brief$1.viewMain.router.reloadFromStart = function (url) {
	              Brief$1.viewMain.router.navigate(url, { reloadAll: true });
	            };

	            // Left View
	            if (Brief$1.isBigScreen) {
	              Brief$1.viewLeft = f7.views.create('.view-left', {
	                name: 'left',
	                url: '/conversation/list/',
	                iosDynamicNavbar: false,
	                routes: leftViewRoutes,
	              });
	            }

	            // Right View
	            // Brief.viewRight = f7.views.create('.view-right', {
	            //   name: 'right',
	            //   url: $('.view-right').attr('data-url'),
	            //   iosSwipeBack: false,
	            //   routes: rightViewRoutes,
	            // });

	            // Popup View
	            Brief$1.viewPopup = f7.views.create('.popup-main-view', {
	              name: 'popup',
	              routes: popupViewRoutes,
	            });            
	          });

	          // Set Statusbar
	          $$1('.statusbar').addClass('statusbar-logged-in');

	          Brief$1.events.$emit('login');
	        } else {
	          // Logout
	          // Destroy Views
	          if (Brief$1.viewMain) {
	            Brief$1.viewMain.destroy();
	            Brief$1.viewMain = null;
	          }
	          if (Brief$1.viewLeft) {
	            Brief$1.viewLeft.destroy();
	            Brief$1.viewLeft = null;
	          }
	          if (Brief$1.viewRight) {
	            Brief$1.viewRight.destroy();
	            Brief$1.viewRight = null;
	          }
	          if (Brief$1.viewPopup) {
	            Brief$1.viewPopup.destroy();
	            Brief$1.viewPopup = null;
	          }          
	          Brief$1.f7.panel.close('right', false);
	          Brief$1.f7.panel.close('left', false);

	          // Login View
	          self.$nextTick(function () {
	            var loginUrl = '/account/login/';
	            if (window.location.href.indexOf('/account/verify') >= 0) { loginUrl = window.location.pathname; }
	            if (window.location.href.indexOf('/account/reset') >= 0) { loginUrl = window.location.pathname; }
	            if (window.location.href.indexOf('/r/') >= 0) { loginUrl = window.location.pathname; }
	            Brief$1.viewLogin = f7.views.create('.view-login', {
	              name: 'login',
	              iosDynamicNavbar: false,
	              url: loginUrl,
	              routes: loginViewRoutes,
	            });
	          });
	          // Set Statusbar
	          $$1('.statusbar').removeClass('statusbar-logged-in');
	          Brief$1.events.$emit('logout');
	        }
	      },
	    },
	    data: function data() {
	      return {
	        isCordova: Brief$1.isCordova,
	        isLoggedIn: undefined,
	        onLine: Brief$1.onLine(),
	        loggedInUser: loggedInUserStore(this),
	      };
	    },
	    methods: {
	      striptags: function striptags(text) {
	        if(Utils$1.isUndefined(text))
	          { return text; }
	        
	        var encoded = text
	          .replace(/</g, '&lt;')
	          .replace(/>/g, '&gt;')
	          .replace(/"/g, '&quot;')
	          .replace(/'/g, '&#039;');
	        return encoded.replace(new RegExp('\r?\n', 'g'), '<br />'); // eslint-disable-line
	      },
	      onF7Ready: function onF7Ready(f7) {
	        var self = this;
	        // F7
	        Brief$1.f7 = f7;
	        self.isLoggedIn = Brief$1.isLoggedIn();

	        Brief$1.f7.device.iphoneX = Brief$1.f7.device.iphone && ((window.screen.width === 375 && window.screen.height === 812) || (window.screen.width === 414 && window.screen.height === 896));
	        Brief$1.f7.device.statusbar = Brief$1.f7.device.needsStatusbarOverlay();

	        Brief$1.f7.on('pageInit', function () {
	          Brief$1.closeNotification();
	          if (!self.isLoggedIn) { return; }
	          setTimeout(function () {
	            if (!Brief$1.viewMain) { return; }
	            Brief$1.viewMain.$el.find('.navbar-hidden').removeClass('navbar-hidden');
	            Brief$1.viewMain.$el.find('.no-navbar-by-scroll').removeClass('no-navbar-by-scroll');
	          }, 1200);
	        });
	        Brief$1.f7.on('pageBeforeIn', function () {
	          Brief$1.closeNotification();
	          if (!self.isLoggedIn) { return; }
	          if (Brief$1.isCordova && document.activeElement && document.activeElement.tagName !== 'BODY') {
	            document.activeElement.blur();
	          }
	        });
	        if (self.isLoggedIn)
	          { setInterval(function () { return self.loggedInUser.get(); }, 5 * 60 * 1000); }
	      },
	    },
	  });
	  app.$on('login', function () {
	    if (!window.localStorage.getItem('access_token')) { return; }
	    app.isLoggedIn = true;
	  });
	  app.$on('logout', function () {
	    var access_token = window.localStorage.getItem('access_token'); // eslint-disable-line
	    var device_id = window.localStorage.getItem('device_id'); // eslint-disable-line
	    if (!Brief$1.isCordova) {
	      Brief$1.f7.request.postJSON(
	        '/api/firebase/unsubscribe', {
	          device_id: device_id,
	          access_token: access_token,
	      }, function (res) {
	          console.log(res);
	      });
	    }
	    Brief$1.f7.request({
	      url: ((Brief$1.api) + "/account/logout"),
	      method: 'POST',
	      dataType: 'json',
	      contentType: 'application/json',
	      data: JSON.stringify({
	        access_token: access_token,
	        device_id: device_id,
	        isCordova: !!Brief$1.isCordova,
	      }),
	    });
	    localforage.clear();
	    var accounts = JSON.parse(window.localStorage.getItem('accounts') || '[]');
	    if (accounts.length === 0 || accounts.length === 1) {
	      app.isLoggedIn = false;
	      var deviceId = window.localStorage.getItem('device_id');
	      var email = window.localStorage.getItem('user_email');
	      window.localStorage.clear();
	      window.localStorage.setItem('device_id', deviceId);
	      window.localStorage.setItem('user_email', email || '');
	    } else {
	      var userId = window.localStorage.getItem('user_id');
	      accounts = lodash.filter(accounts, function (x) { return x.userId !== userId; });
	      if (accounts.length > 0) {
	        window.localStorage.setItem('user_id', accounts[0].userId);
	        window.localStorage.setItem('team_id', accounts[0].teamId);
	        window.localStorage.setItem('access_token', accounts[0].token);
	      }
	      window.localStorage.setItem('accounts', JSON.stringify(accounts));
	    }
	    window.location.reload();
	  });

	  Brief$1.events.$on('online', function () {
	    app.onLine = true;
	  });
	  Brief$1.events.$on('offline', function () {
	    app.onLine = false;
	  });
	  Brief$1.login = function () {
	    app.$emit('login');
	  };
	  Brief$1.logout = function () {
	    app.$emit('logout');
	  };
	  Brief$1.app = app;

	  // Logout when logged in user verifies new account
	  // if (window.location.href.indexOf('/account/verify/') !== -1) { Brief.logout(); }

	  return app;
	}

	if (!Brief$1.isCordova && !window.facebookConnectPlugin)
	  { window.facebookConnectPlugin = facebookConnectPlugin; }

	function initCordovaApp() {
	  document.addEventListener('deviceready', function () {
	    Shims();
	    Utils$1.getDeviceId();
	    Prototypes();
	    Framework7App();
	    PushNotifications.init();

	    window.handleOpenURL = function handleOpenURL(url) {
	      if (url.indexOf('brief') < 0) {
	        return;
	      }

	      var briefUrl = url.replace('brief://', '');
	      if (briefUrl.indexOf('/account/') === 0) {
	        Brief$1.viewLogin.router.navigate(briefUrl);
	      } else {
	        Brief$1.viewMain.router.navigate(briefUrl);
	      }
	    };

	    try {
	      UniversalLinks$1();
	      PhoneGap();
	      checkAccount();
	    } catch (err) {
	      Brief$1.sendError('Run updater error: ' + err);
	    }
	  }, false);

	  handleAndroidBackButton();
	}

	function handleAndroidBackButton() {
	  if (window.device.platform.toLowerCase() !== 'android')
	    { return; }
	  document.addEventListener('backbutton', function (e) {
	    var isRootPage = Brief$1.f7.views.current.selector === '.view-main' && Brief$1.f7.views.current.history.length <= 1;
	    if (isRootPage && window.navigator.app && window.navigator.app.exitApp) {
	      window.navigator.app.exitApp();
	      return true;
	    }
	    Brief$1.f7.views.current.router.back();
	    e.preventDefault();
	    return false;
	  }, false);
	}

	function initWebApp() {
	  Shims();
	  Utils$1.getDeviceId();
	  Prototypes();
	  checkAccount();
	  Framework7App();
	  PushNotifications.init();
	}

	function checkAccount() {
	  var nuid = !Brief$1.isCordova
	    ? Utils$1.getParameterByName('nuid', window.location.href)
	    : window.localStorage.getItem('nuid');
	  var url = window.localStorage.getItem('nuid_url');
	  if (!nuid && url) {
	    window.localStorage.setItem('nuid', '');
	    window.localStorage.setItem('nuid_url', '');
	    setTimeout(function () {
	      Brief$1.viewMain.router.navigate(url);
	    }, 700);
	    return;
	  }
	  if (!nuid) {
	    return;
	  }
	  if (nuid === window.localStorage.getItem('user_id')) {
	    window.localStorage.setItem('nuid', '');
	    var href = window.location.href.split('?')[0];
	    window.location = href;
	    return;
	  }
	  var accounts = JSON.parse(window.localStorage.getItem('accounts') || '[]');
	  var acc = accounts.find(function (x) { return x.userId === nuid; });
	  if (!acc) {
	    return;
	  }
	  window.localStorage.setItem('user_id', acc.userId);
	  window.localStorage.setItem('team_id', acc.teamId);
	  window.localStorage.setItem('access_token', acc.token);
	  window.localStorage.setItem('nuid', '');
	  window.location = window.location.href.split('?')[0];
	}

	trackErrors();

	if (Brief$1.isCordova)
	  { initCordovaApp(); }
	else 
	  { initWebApp(); }

	return Brief$1;

}());
